import qh from "zustand";
import * as jo from "react";
import b0, { createContext as Pp, forwardRef as eA, useContext as KA, createElement as yE, useState as Tl, useCallback as Gc, useEffect as Pd, useMemo as Oh, useLayoutEffect as _F, lazy as or, Suspense as QE, Fragment as CE, useRef as z0, Children as UE, cloneElement as IE } from "react";
import a1 from "axios";
import { toast as eb, ToastContainer as BE, css as Xl, makeStyles as zA, Loader as ZE, Text as j0, Dropdown as cv, Stack as YC, Modal as LC, Tooltip as u0, getTheme as SE, Center as EE, Input as VE, Button as WE } from "@conexasaude/conexa-hero";
import { QueryClient as NE, QueryCache as JE, MutationCache as GE, QueryClientProvider as TE, useQuery as XE, useMutation as kE } from "@tanstack/react-query";
import "@emotion/react";
const m0 = qh((s, a) => ({
  listenerEvent: null,
  clearListenerEvent: () => s({
    listenerEvent: null
  }),
  dispatch(i) {
    const r = a().listenerEvent;
    r && r(i);
  }
})), JO = () => m0.getState().clearListenerEvent;
var wE = !1;
function DE(s) {
  if (s.sheet)
    return s.sheet;
  for (var a = 0; a < document.styleSheets.length; a++)
    if (document.styleSheets[a].ownerNode === s)
      return document.styleSheets[a];
}
function ME(s) {
  var a = document.createElement("style");
  return a.setAttribute("data-emotion", s.key), s.nonce !== void 0 && a.setAttribute("nonce", s.nonce), a.appendChild(document.createTextNode("")), a.setAttribute("data-s", ""), a;
}
var YE = /* @__PURE__ */ function() {
  function s(i) {
    var r = this;
    this._insertTag = function(e) {
      var n;
      r.tags.length === 0 ? r.insertionPoint ? n = r.insertionPoint.nextSibling : r.prepend ? n = r.container.firstChild : n = r.before : n = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(e, n), r.tags.push(e);
    }, this.isSpeedy = i.speedy === void 0 ? !wE : i.speedy, this.tags = [], this.ctr = 0, this.nonce = i.nonce, this.key = i.key, this.container = i.container, this.prepend = i.prepend, this.insertionPoint = i.insertionPoint, this.before = null;
  }
  var a = s.prototype;
  return a.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, a.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(ME(this));
    var e = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var n = DE(e);
      try {
        n.insertRule(r, n.cssRules.length);
      } catch {
      }
    } else
      e.appendChild(document.createTextNode(r));
    this.ctr++;
  }, a.flush = function() {
    this.tags.forEach(function(r) {
      var e;
      return (e = r.parentNode) == null ? void 0 : e.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, s;
}(), fd = "-ms-", wm = "-moz-", Fs = "-webkit-", xC = "comm", kb = "rule", wb = "decl", LE = "@import", HC = "@keyframes", xE = "@layer", HE = Math.abs, s1 = String.fromCharCode, PE = Object.assign;
function OE(s, a) {
  return zc(s, 0) ^ 45 ? (((a << 2 ^ zc(s, 0)) << 2 ^ zc(s, 1)) << 2 ^ zc(s, 2)) << 2 ^ zc(s, 3) : 0;
}
function PC(s) {
  return s.trim();
}
function KE(s, a) {
  return (s = a.exec(s)) ? s[0] : s;
}
function Rs(s, a, i) {
  return s.replace(a, i);
}
function tb(s, a) {
  return s.indexOf(a);
}
function zc(s, a) {
  return s.charCodeAt(a) | 0;
}
function Np(s, a, i) {
  return s.slice(a, i);
}
function Mu(s) {
  return s.length;
}
function Db(s) {
  return s.length;
}
function Fm(s, a) {
  return a.push(s), s;
}
function zE(s, a) {
  return s.map(a).join("");
}
var l1 = 1, YA = 1, OC = 0, Od = 0, mc = 0, jA = "";
function c1(s, a, i, r, e, n, t) {
  return { value: s, root: a, parent: i, type: r, props: e, children: n, line: l1, column: YA, length: t, return: "" };
}
function Gg(s, a) {
  return PE(c1("", null, null, "", null, null, 0), s, { length: -s.length }, a);
}
function jE() {
  return mc;
}
function _E() {
  return mc = Od > 0 ? zc(jA, --Od) : 0, YA--, mc === 10 && (YA = 1, l1--), mc;
}
function ru() {
  return mc = Od < OC ? zc(jA, Od++) : 0, YA++, mc === 10 && (YA = 1, l1++), mc;
}
function Pu() {
  return zc(jA, Od);
}
function Sm() {
  return Od;
}
function Op(s, a) {
  return Np(jA, s, a);
}
function Jp(s) {
  switch (s) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function KC(s) {
  return l1 = YA = 1, OC = Mu(jA = s), Od = 0, [];
}
function zC(s) {
  return jA = "", s;
}
function Em(s) {
  return PC(Op(Od - 1, nb(s === 91 ? s + 2 : s === 40 ? s + 1 : s)));
}
function $E(s) {
  for (; (mc = Pu()) && mc < 33; )
    ru();
  return Jp(s) > 2 || Jp(mc) > 3 ? "" : " ";
}
function qE(s, a) {
  for (; --a && ru() && !(mc < 48 || mc > 102 || mc > 57 && mc < 65 || mc > 70 && mc < 97); )
    ;
  return Op(s, Sm() + (a < 6 && Pu() == 32 && ru() == 32));
}
function nb(s) {
  for (; ru(); )
    switch (mc) {
      case s:
        return Od;
      case 34:
      case 39:
        s !== 34 && s !== 39 && nb(mc);
        break;
      case 40:
        s === 41 && nb(s);
        break;
      case 92:
        ru();
        break;
    }
  return Od;
}
function eV(s, a) {
  for (; ru() && s + mc !== 57; )
    if (s + mc === 84 && Pu() === 47)
      break;
  return "/*" + Op(a, Od - 1) + "*" + s1(s === 47 ? s : ru());
}
function tV(s) {
  for (; !Jp(Pu()); )
    ru();
  return Op(s, Od);
}
function nV(s) {
  return zC(Vm("", null, null, null, [""], s = KC(s), 0, [0], s));
}
function Vm(s, a, i, r, e, n, t, o, l) {
  for (var c = 0, d = 0, u = t, h = 0, A = 0, g = 0, f = 1, p = 1, v = 1, b = 0, m = "", y = e, U = n, B = r, Q = m; p; )
    switch (g = b, b = ru()) {
      case 40:
        if (g != 108 && zc(Q, u - 1) == 58) {
          tb(Q += Rs(Em(b), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        Q += Em(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        Q += $E(g);
        break;
      case 92:
        Q += qE(Sm() - 1, 7);
        continue;
      case 47:
        switch (Pu()) {
          case 42:
          case 47:
            Fm(rV(eV(ru(), Sm()), a, i), l);
            break;
          default:
            Q += "/";
        }
        break;
      case 123 * f:
        o[c++] = Mu(Q) * v;
      case 125 * f:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            p = 0;
          case 59 + d:
            v == -1 && (Q = Rs(Q, /\f/g, "")), A > 0 && Mu(Q) - u && Fm(A > 32 ? qF(Q + ";", r, i, u - 1) : qF(Rs(Q, " ", "") + ";", r, i, u - 2), l);
            break;
          case 59:
            Q += ";";
          default:
            if (Fm(B = $F(Q, a, i, c, d, e, o, m, y = [], U = [], u), n), b === 123)
              if (d === 0)
                Vm(Q, a, B, B, y, n, u, o, U);
              else
                switch (h === 99 && zc(Q, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Vm(s, B, B, r && Fm($F(s, B, B, 0, 0, e, o, m, e, y = [], u), U), e, U, u, o, r ? y : U);
                    break;
                  default:
                    Vm(Q, B, B, B, [""], U, 0, o, U);
                }
        }
        c = d = A = 0, f = v = 1, m = Q = "", u = t;
        break;
      case 58:
        u = 1 + Mu(Q), A = g;
      default:
        if (f < 1) {
          if (b == 123)
            --f;
          else if (b == 125 && f++ == 0 && _E() == 125)
            continue;
        }
        switch (Q += s1(b), b * f) {
          case 38:
            v = d > 0 ? 1 : (Q += "\f", -1);
            break;
          case 44:
            o[c++] = (Mu(Q) - 1) * v, v = 1;
            break;
          case 64:
            Pu() === 45 && (Q += Em(ru())), h = Pu(), d = u = Mu(m = Q += tV(Sm())), b++;
            break;
          case 45:
            g === 45 && Mu(Q) == 2 && (f = 0);
        }
    }
  return n;
}
function $F(s, a, i, r, e, n, t, o, l, c, d) {
  for (var u = e - 1, h = e === 0 ? n : [""], A = Db(h), g = 0, f = 0, p = 0; g < r; ++g)
    for (var v = 0, b = Np(s, u + 1, u = HE(f = t[g])), m = s; v < A; ++v)
      (m = PC(f > 0 ? h[v] + " " + b : Rs(b, /&\f/g, h[v]))) && (l[p++] = m);
  return c1(s, a, i, e === 0 ? kb : o, l, c, d);
}
function rV(s, a, i) {
  return c1(s, a, i, xC, s1(jE()), Np(s, 2, -2), 0);
}
function qF(s, a, i, r) {
  return c1(s, a, i, wb, Np(s, 0, r), Np(s, r + 1, -1), r);
}
function wA(s, a) {
  for (var i = "", r = Db(s), e = 0; e < r; e++)
    i += a(s[e], e, s, a) || "";
  return i;
}
function iV(s, a, i, r) {
  switch (s.type) {
    case xE:
      if (s.children.length) break;
    case LE:
    case wb:
      return s.return = s.return || s.value;
    case xC:
      return "";
    case HC:
      return s.return = s.value + "{" + wA(s.children, r) + "}";
    case kb:
      s.value = s.props.join(",");
  }
  return Mu(i = wA(s.children, r)) ? s.return = s.value + "{" + i + "}" : "";
}
function oV(s) {
  var a = Db(s);
  return function(i, r, e, n) {
    for (var t = "", o = 0; o < a; o++)
      t += s[o](i, r, e, n) || "";
    return t;
  };
}
function aV(s) {
  return function(a) {
    a.root || (a = a.return) && s(a);
  };
}
function sV(s) {
  var a = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return a[i] === void 0 && (a[i] = s(i)), a[i];
  };
}
var lV = function(a, i, r) {
  for (var e = 0, n = 0; e = n, n = Pu(), e === 38 && n === 12 && (i[r] = 1), !Jp(n); )
    ru();
  return Op(a, Od);
}, cV = function(a, i) {
  var r = -1, e = 44;
  do
    switch (Jp(e)) {
      case 0:
        e === 38 && Pu() === 12 && (i[r] = 1), a[r] += lV(Od - 1, i, r);
        break;
      case 2:
        a[r] += Em(e);
        break;
      case 4:
        if (e === 44) {
          a[++r] = Pu() === 58 ? "&\f" : "", i[r] = a[r].length;
          break;
        }
      default:
        a[r] += s1(e);
    }
  while (e = ru());
  return a;
}, dV = function(a, i) {
  return zC(cV(KC(a), i));
}, eR = /* @__PURE__ */ new WeakMap(), uV = function(a) {
  if (!(a.type !== "rule" || !a.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  a.length < 1)) {
    for (var i = a.value, r = a.parent, e = a.column === r.column && a.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(a.props.length === 1 && i.charCodeAt(0) !== 58 && !eR.get(r)) && !e) {
      eR.set(a, !0);
      for (var n = [], t = dV(i, n), o = r.props, l = 0, c = 0; l < t.length; l++)
        for (var d = 0; d < o.length; d++, c++)
          a.props[c] = n[l] ? t[l].replace(/&\f/g, o[d]) : o[d] + " " + t[l];
    }
  }
}, hV = function(a) {
  if (a.type === "decl") {
    var i = a.value;
    // charcode for l
    i.charCodeAt(0) === 108 && // charcode for b
    i.charCodeAt(2) === 98 && (a.return = "", a.value = "");
  }
};
function jC(s, a) {
  switch (OE(s, a)) {
    case 5103:
      return Fs + "print-" + s + s;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Fs + s + s;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Fs + s + wm + s + fd + s + s;
    case 6828:
    case 4268:
      return Fs + s + fd + s + s;
    case 6165:
      return Fs + s + fd + "flex-" + s + s;
    case 5187:
      return Fs + s + Rs(s, /(\w+).+(:[^]+)/, Fs + "box-$1$2" + fd + "flex-$1$2") + s;
    case 5443:
      return Fs + s + fd + "flex-item-" + Rs(s, /flex-|-self/, "") + s;
    case 4675:
      return Fs + s + fd + "flex-line-pack" + Rs(s, /align-content|flex-|-self/, "") + s;
    case 5548:
      return Fs + s + fd + Rs(s, "shrink", "negative") + s;
    case 5292:
      return Fs + s + fd + Rs(s, "basis", "preferred-size") + s;
    case 6060:
      return Fs + "box-" + Rs(s, "-grow", "") + Fs + s + fd + Rs(s, "grow", "positive") + s;
    case 4554:
      return Fs + Rs(s, /([^-])(transform)/g, "$1" + Fs + "$2") + s;
    case 6187:
      return Rs(Rs(Rs(s, /(zoom-|grab)/, Fs + "$1"), /(image-set)/, Fs + "$1"), s, "") + s;
    case 5495:
    case 3959:
      return Rs(s, /(image-set\([^]*)/, Fs + "$1$`$1");
    case 4968:
      return Rs(Rs(s, /(.+:)(flex-)?(.*)/, Fs + "box-pack:$3" + fd + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Fs + s + s;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Rs(s, /(.+)-inline(.+)/, Fs + "$1$2") + s;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Mu(s) - 1 - a > 6) switch (zc(s, a + 1)) {
        case 109:
          if (zc(s, a + 4) !== 45) break;
        case 102:
          return Rs(s, /(.+:)(.+)-([^]+)/, "$1" + Fs + "$2-$3$1" + wm + (zc(s, a + 3) == 108 ? "$3" : "$2-$3")) + s;
        case 115:
          return ~tb(s, "stretch") ? jC(Rs(s, "stretch", "fill-available"), a) + s : s;
      }
      break;
    case 4949:
      if (zc(s, a + 1) !== 115) break;
    case 6444:
      switch (zc(s, Mu(s) - 3 - (~tb(s, "!important") && 10))) {
        case 107:
          return Rs(s, ":", ":" + Fs) + s;
        case 101:
          return Rs(s, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Fs + (zc(s, 14) === 45 ? "inline-" : "") + "box$3$1" + Fs + "$2$3$1" + fd + "$2box$3") + s;
      }
      break;
    case 5936:
      switch (zc(s, a + 11)) {
        case 114:
          return Fs + s + fd + Rs(s, /[svh]\w+-[tblr]{2}/, "tb") + s;
        case 108:
          return Fs + s + fd + Rs(s, /[svh]\w+-[tblr]{2}/, "tb-rl") + s;
        case 45:
          return Fs + s + fd + Rs(s, /[svh]\w+-[tblr]{2}/, "lr") + s;
      }
      return Fs + s + fd + s + s;
  }
  return s;
}
var AV = function(a, i, r, e) {
  if (a.length > -1 && !a.return) switch (a.type) {
    case wb:
      a.return = jC(a.value, a.length);
      break;
    case HC:
      return wA([Gg(a, {
        value: Rs(a.value, "@", "@" + Fs)
      })], e);
    case kb:
      if (a.length) return zE(a.props, function(n) {
        switch (KE(n, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return wA([Gg(a, {
              props: [Rs(n, /:(read-\w+)/, ":" + wm + "$1")]
            })], e);
          case "::placeholder":
            return wA([Gg(a, {
              props: [Rs(n, /:(plac\w+)/, ":" + Fs + "input-$1")]
            }), Gg(a, {
              props: [Rs(n, /:(plac\w+)/, ":" + wm + "$1")]
            }), Gg(a, {
              props: [Rs(n, /:(plac\w+)/, fd + "input-$1")]
            })], e);
        }
        return "";
      });
  }
}, gV = [AV], _C = function(a) {
  var i = a.key;
  if (i === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(f) {
      var p = f.getAttribute("data-emotion");
      p.indexOf(" ") !== -1 && (document.head.appendChild(f), f.setAttribute("data-s", ""));
    });
  }
  var e = a.stylisPlugins || gV, n = {}, t, o = [];
  t = a.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + i + ' "]'),
    function(f) {
      for (var p = f.getAttribute("data-emotion").split(" "), v = 1; v < p.length; v++)
        n[p[v]] = !0;
      o.push(f);
    }
  );
  var l, c = [uV, hV];
  {
    var d, u = [iV, aV(function(f) {
      d.insert(f);
    })], h = oV(c.concat(e, u)), A = function(p) {
      return wA(nV(p), h);
    };
    l = function(p, v, b, m) {
      d = b, A(p ? p + "{" + v.styles + "}" : v.styles), m && (g.inserted[v.name] = !0);
    };
  }
  var g = {
    key: i,
    sheet: new YE({
      key: i,
      container: t,
      nonce: a.nonce,
      speedy: a.speedy,
      prepend: a.prepend,
      insertionPoint: a.insertionPoint
    }),
    nonce: a.nonce,
    inserted: n,
    registered: {},
    insert: l
  };
  return g.sheet.hydrate(o), g;
};
function zl() {
  return zl = Object.assign ? Object.assign.bind() : function(s) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a];
      for (var r in i) ({}).hasOwnProperty.call(i, r) && (s[r] = i[r]);
    }
    return s;
  }, zl.apply(null, arguments);
}
var Dn = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function d1(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
function fV(s) {
  if (s.__esModule) return s;
  var a = s.default;
  if (typeof a == "function") {
    var i = function r() {
      return this instanceof r ? Reflect.construct(a, arguments, this.constructor) : a.apply(this, arguments);
    };
    i.prototype = a.prototype;
  } else i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(s).forEach(function(r) {
    var e = Object.getOwnPropertyDescriptor(s, r);
    Object.defineProperty(i, r, e.get ? e : {
      enumerable: !0,
      get: function() {
        return s[r];
      }
    });
  }), i;
}
var rb = { exports: {} }, Zs = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tR;
function pV() {
  if (tR) return Zs;
  tR = 1;
  var s = typeof Symbol == "function" && Symbol.for, a = s ? Symbol.for("react.element") : 60103, i = s ? Symbol.for("react.portal") : 60106, r = s ? Symbol.for("react.fragment") : 60107, e = s ? Symbol.for("react.strict_mode") : 60108, n = s ? Symbol.for("react.profiler") : 60114, t = s ? Symbol.for("react.provider") : 60109, o = s ? Symbol.for("react.context") : 60110, l = s ? Symbol.for("react.async_mode") : 60111, c = s ? Symbol.for("react.concurrent_mode") : 60111, d = s ? Symbol.for("react.forward_ref") : 60112, u = s ? Symbol.for("react.suspense") : 60113, h = s ? Symbol.for("react.suspense_list") : 60120, A = s ? Symbol.for("react.memo") : 60115, g = s ? Symbol.for("react.lazy") : 60116, f = s ? Symbol.for("react.block") : 60121, p = s ? Symbol.for("react.fundamental") : 60117, v = s ? Symbol.for("react.responder") : 60118, b = s ? Symbol.for("react.scope") : 60119;
  function m(U) {
    if (typeof U == "object" && U !== null) {
      var B = U.$$typeof;
      switch (B) {
        case a:
          switch (U = U.type, U) {
            case l:
            case c:
            case r:
            case n:
            case e:
            case u:
              return U;
            default:
              switch (U = U && U.$$typeof, U) {
                case o:
                case d:
                case g:
                case A:
                case t:
                  return U;
                default:
                  return B;
              }
          }
        case i:
          return B;
      }
    }
  }
  function y(U) {
    return m(U) === c;
  }
  return Zs.AsyncMode = l, Zs.ConcurrentMode = c, Zs.ContextConsumer = o, Zs.ContextProvider = t, Zs.Element = a, Zs.ForwardRef = d, Zs.Fragment = r, Zs.Lazy = g, Zs.Memo = A, Zs.Portal = i, Zs.Profiler = n, Zs.StrictMode = e, Zs.Suspense = u, Zs.isAsyncMode = function(U) {
    return y(U) || m(U) === l;
  }, Zs.isConcurrentMode = y, Zs.isContextConsumer = function(U) {
    return m(U) === o;
  }, Zs.isContextProvider = function(U) {
    return m(U) === t;
  }, Zs.isElement = function(U) {
    return typeof U == "object" && U !== null && U.$$typeof === a;
  }, Zs.isForwardRef = function(U) {
    return m(U) === d;
  }, Zs.isFragment = function(U) {
    return m(U) === r;
  }, Zs.isLazy = function(U) {
    return m(U) === g;
  }, Zs.isMemo = function(U) {
    return m(U) === A;
  }, Zs.isPortal = function(U) {
    return m(U) === i;
  }, Zs.isProfiler = function(U) {
    return m(U) === n;
  }, Zs.isStrictMode = function(U) {
    return m(U) === e;
  }, Zs.isSuspense = function(U) {
    return m(U) === u;
  }, Zs.isValidElementType = function(U) {
    return typeof U == "string" || typeof U == "function" || U === r || U === c || U === n || U === e || U === u || U === h || typeof U == "object" && U !== null && (U.$$typeof === g || U.$$typeof === A || U.$$typeof === t || U.$$typeof === o || U.$$typeof === d || U.$$typeof === p || U.$$typeof === v || U.$$typeof === b || U.$$typeof === f);
  }, Zs.typeOf = m, Zs;
}
var Ss = {}, nR;
function mV() {
  if (nR) return Ss;
  nR = 1;
  var s = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return s.NODE_ENV !== "production" && function() {
    var a = typeof Symbol == "function" && Symbol.for, i = a ? Symbol.for("react.element") : 60103, r = a ? Symbol.for("react.portal") : 60106, e = a ? Symbol.for("react.fragment") : 60107, n = a ? Symbol.for("react.strict_mode") : 60108, t = a ? Symbol.for("react.profiler") : 60114, o = a ? Symbol.for("react.provider") : 60109, l = a ? Symbol.for("react.context") : 60110, c = a ? Symbol.for("react.async_mode") : 60111, d = a ? Symbol.for("react.concurrent_mode") : 60111, u = a ? Symbol.for("react.forward_ref") : 60112, h = a ? Symbol.for("react.suspense") : 60113, A = a ? Symbol.for("react.suspense_list") : 60120, g = a ? Symbol.for("react.memo") : 60115, f = a ? Symbol.for("react.lazy") : 60116, p = a ? Symbol.for("react.block") : 60121, v = a ? Symbol.for("react.fundamental") : 60117, b = a ? Symbol.for("react.responder") : 60118, m = a ? Symbol.for("react.scope") : 60119;
    function y(Ft) {
      return typeof Ft == "string" || typeof Ft == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Ft === e || Ft === d || Ft === t || Ft === n || Ft === h || Ft === A || typeof Ft == "object" && Ft !== null && (Ft.$$typeof === f || Ft.$$typeof === g || Ft.$$typeof === o || Ft.$$typeof === l || Ft.$$typeof === u || Ft.$$typeof === v || Ft.$$typeof === b || Ft.$$typeof === m || Ft.$$typeof === p);
    }
    function U(Ft) {
      if (typeof Ft == "object" && Ft !== null) {
        var Zt = Ft.$$typeof;
        switch (Zt) {
          case i:
            var ft = Ft.type;
            switch (ft) {
              case c:
              case d:
              case e:
              case t:
              case n:
              case h:
                return ft;
              default:
                var It = ft && ft.$$typeof;
                switch (It) {
                  case l:
                  case u:
                  case f:
                  case g:
                  case o:
                    return It;
                  default:
                    return Zt;
                }
            }
          case r:
            return Zt;
        }
      }
    }
    var B = c, Q = d, N = l, J = o, w = i, W = u, G = e, Z = f, K = g, L = r, O = t, de = n, oe = h, fe = !1;
    function ge(Ft) {
      return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), we(Ft) || U(Ft) === c;
    }
    function we(Ft) {
      return U(Ft) === d;
    }
    function _e(Ft) {
      return U(Ft) === l;
    }
    function Te(Ft) {
      return U(Ft) === o;
    }
    function Pe(Ft) {
      return typeof Ft == "object" && Ft !== null && Ft.$$typeof === i;
    }
    function $e(Ft) {
      return U(Ft) === u;
    }
    function Bt(Ft) {
      return U(Ft) === e;
    }
    function Le(Ft) {
      return U(Ft) === f;
    }
    function at(Ft) {
      return U(Ft) === g;
    }
    function pt(Ft) {
      return U(Ft) === r;
    }
    function kt(Ft) {
      return U(Ft) === t;
    }
    function _t(Ft) {
      return U(Ft) === n;
    }
    function Lt(Ft) {
      return U(Ft) === h;
    }
    Ss.AsyncMode = B, Ss.ConcurrentMode = Q, Ss.ContextConsumer = N, Ss.ContextProvider = J, Ss.Element = w, Ss.ForwardRef = W, Ss.Fragment = G, Ss.Lazy = Z, Ss.Memo = K, Ss.Portal = L, Ss.Profiler = O, Ss.StrictMode = de, Ss.Suspense = oe, Ss.isAsyncMode = ge, Ss.isConcurrentMode = we, Ss.isContextConsumer = _e, Ss.isContextProvider = Te, Ss.isElement = Pe, Ss.isForwardRef = $e, Ss.isFragment = Bt, Ss.isLazy = Le, Ss.isMemo = at, Ss.isPortal = pt, Ss.isProfiler = kt, Ss.isStrictMode = _t, Ss.isSuspense = Lt, Ss.isValidElementType = y, Ss.typeOf = U;
  }(), Ss;
}
var vV = {};
vV.NODE_ENV === "production" ? rb.exports = pV() : rb.exports = mV();
var bV = rb.exports, $C = bV, FV = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, RV = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, qC = {};
qC[$C.ForwardRef] = FV;
qC[$C.Memo] = RV;
var yV = !0;
function eU(s, a, i) {
  var r = "";
  return i.split(" ").forEach(function(e) {
    s[e] !== void 0 ? a.push(s[e] + ";") : r += e + " ";
  }), r;
}
var QV = function(a, i, r) {
  var e = a.key + "-" + i.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  yV === !1) && a.registered[e] === void 0 && (a.registered[e] = i.styles);
}, tU = function(a, i, r) {
  QV(a, i, r);
  var e = a.key + "-" + i.name;
  if (a.inserted[i.name] === void 0) {
    var n = i;
    do
      a.insert(i === n ? "." + e : "", n, a.sheet, !0), n = n.next;
    while (n !== void 0);
  }
};
function CV(s) {
  for (var a = 0, i, r = 0, e = s.length; e >= 4; ++r, e -= 4)
    i = s.charCodeAt(r) & 255 | (s.charCodeAt(++r) & 255) << 8 | (s.charCodeAt(++r) & 255) << 16 | (s.charCodeAt(++r) & 255) << 24, i = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16), i ^= /* k >>> r: */
    i >>> 24, a = /* Math.imul(k, m): */
    (i & 65535) * 1540483477 + ((i >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16);
  switch (e) {
    case 3:
      a ^= (s.charCodeAt(r + 2) & 255) << 16;
    case 2:
      a ^= (s.charCodeAt(r + 1) & 255) << 8;
    case 1:
      a ^= s.charCodeAt(r) & 255, a = /* Math.imul(h, m): */
      (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16);
  }
  return a ^= a >>> 13, a = /* Math.imul(h, m): */
  (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16), ((a ^ a >>> 15) >>> 0).toString(36);
}
var UV = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, IV = !1, BV = /[A-Z]|^ms/g, ZV = /_EMO_([^_]+?)_([^]*?)_EMO_/g, nU = function(a) {
  return a.charCodeAt(1) === 45;
}, rR = function(a) {
  return a != null && typeof a != "boolean";
}, dv = /* @__PURE__ */ sV(function(s) {
  return nU(s) ? s : s.replace(BV, "-$&").toLowerCase();
}), iR = function(a, i) {
  switch (a) {
    case "animation":
    case "animationName":
      if (typeof i == "string")
        return i.replace(ZV, function(r, e, n) {
          return Yu = {
            name: e,
            styles: n,
            next: Yu
          }, e;
        });
  }
  return UV[a] !== 1 && !nU(a) && typeof i == "number" && i !== 0 ? i + "px" : i;
}, SV = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Gp(s, a, i) {
  if (i == null)
    return "";
  var r = i;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof i) {
    case "boolean":
      return "";
    case "object": {
      var e = i;
      if (e.anim === 1)
        return Yu = {
          name: e.name,
          styles: e.styles,
          next: Yu
        }, e.name;
      var n = i;
      if (n.styles !== void 0) {
        var t = n.next;
        if (t !== void 0)
          for (; t !== void 0; )
            Yu = {
              name: t.name,
              styles: t.styles,
              next: Yu
            }, t = t.next;
        var o = n.styles + ";";
        return o;
      }
      return EV(s, a, i);
    }
    case "function": {
      if (s !== void 0) {
        var l = Yu, c = i(s);
        return Yu = l, Gp(s, a, c);
      }
      break;
    }
  }
  var d = i;
  if (a == null)
    return d;
  var u = a[d];
  return u !== void 0 ? u : d;
}
function EV(s, a, i) {
  var r = "";
  if (Array.isArray(i))
    for (var e = 0; e < i.length; e++)
      r += Gp(s, a, i[e]) + ";";
  else
    for (var n in i) {
      var t = i[n];
      if (typeof t != "object") {
        var o = t;
        a != null && a[o] !== void 0 ? r += n + "{" + a[o] + "}" : rR(o) && (r += dv(n) + ":" + iR(n, o) + ";");
      } else {
        if (n === "NO_COMPONENT_SELECTOR" && IV)
          throw new Error(SV);
        if (Array.isArray(t) && typeof t[0] == "string" && (a == null || a[t[0]] === void 0))
          for (var l = 0; l < t.length; l++)
            rR(t[l]) && (r += dv(n) + ":" + iR(n, t[l]) + ";");
        else {
          var c = Gp(s, a, t);
          switch (n) {
            case "animation":
            case "animationName": {
              r += dv(n) + ":" + c + ";";
              break;
            }
            default:
              r += n + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var oR = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Yu;
function ib(s, a, i) {
  if (s.length === 1 && typeof s[0] == "object" && s[0] !== null && s[0].styles !== void 0)
    return s[0];
  var r = !0, e = "";
  Yu = void 0;
  var n = s[0];
  if (n == null || n.raw === void 0)
    r = !1, e += Gp(i, a, n);
  else {
    var t = n;
    e += t[0];
  }
  for (var o = 1; o < s.length; o++)
    if (e += Gp(i, a, s[o]), r) {
      var l = n;
      e += l[o];
    }
  oR.lastIndex = 0;
  for (var c = "", d; (d = oR.exec(e)) !== null; )
    c += "-" + d[1];
  var u = CV(e) + c;
  return {
    name: u,
    styles: e,
    next: Yu
  };
}
var Tp = {}, u1 = Object.prototype.hasOwnProperty, rU = /* @__PURE__ */ Pp(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ _C({
    key: "css"
  }) : null
);
rU.Provider;
var VV = function(a) {
  return /* @__PURE__ */ eA(function(i, r) {
    var e = KA(rU);
    return a(i, e, r);
  });
}, WV = /* @__PURE__ */ Pp({}), NV = function(a) {
  return a.replace(/\$/g, "-");
}, ob = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", ab = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", iU = function(a, i) {
  if (Tp.NODE_ENV !== "production" && typeof i.css == "string" && // check if there is a css declaration
  i.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + i.css + "`");
  var r = {};
  for (var e in i)
    u1.call(i, e) && (r[e] = i[e]);
  if (r[ob] = a, Tp.NODE_ENV !== "production") {
    var n = new Error();
    if (n.stack) {
      var t = n.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);
      t || (t = n.stack.match(/.*\n([A-Z][A-Za-z$]+)@/)), t && (r[ab] = NV(t[1]));
    }
  }
  return r;
}, Mb = /* @__PURE__ */ VV(function(s, a, i) {
  var r = s.css;
  typeof r == "string" && a.registered[r] !== void 0 && (r = a.registered[r]);
  var e = s[ob], n = [r], t = "";
  typeof s.className == "string" ? t = eU(a.registered, n, s.className) : s.className != null && (t = s.className + " ");
  var o = ib(n, void 0, typeof r == "function" || Array.isArray(r) ? KA(WV) : void 0);
  if (Tp.NODE_ENV !== "production" && o.name.indexOf("-") === -1) {
    var l = s[ab];
    l && (o = ib([o, "label:" + l + ";"]));
  }
  tU(a, o, typeof e == "string"), t += a.key + "-" + o.name;
  var c = {};
  for (var d in s)
    u1.call(s, d) && d !== "css" && d !== ob && (Tp.NODE_ENV === "production" || d !== ab) && (c[d] = s[d]);
  c.ref = i, c.className = t;
  var u = /* @__PURE__ */ yE(e, c);
  return u;
});
Tp.NODE_ENV !== "production" && (Mb.displayName = "EmotionCssPropInternal");
var sb = { exports: {} }, Tg = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aR;
function JV() {
  if (aR) return Tg;
  aR = 1;
  var s = b0, a = Symbol.for("react.element"), i = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, e = s.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = { key: !0, ref: !0, __self: !0, __source: !0 };
  function t(o, l, c) {
    var d, u = {}, h = null, A = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (A = l.ref);
    for (d in l) r.call(l, d) && !n.hasOwnProperty(d) && (u[d] = l[d]);
    if (o && o.defaultProps) for (d in l = o.defaultProps, l) u[d] === void 0 && (u[d] = l[d]);
    return { $$typeof: a, type: o, key: h, ref: A, props: u, _owner: e.current };
  }
  return Tg.Fragment = i, Tg.jsx = t, Tg.jsxs = t, Tg;
}
var Xg = {}, sR;
function GV() {
  if (sR) return Xg;
  sR = 1;
  var s = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return s.NODE_ENV !== "production" && function() {
    var a = b0, i = Symbol.for("react.element"), r = Symbol.for("react.portal"), e = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), t = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), A = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), f = Symbol.iterator, p = "@@iterator";
    function v(wt) {
      if (wt === null || typeof wt != "object")
        return null;
      var Yn = f && wt[f] || wt[p];
      return typeof Yn == "function" ? Yn : null;
    }
    var b = a.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function m(wt) {
      {
        for (var Yn = arguments.length, kr = new Array(Yn > 1 ? Yn - 1 : 0), mr = 1; mr < Yn; mr++)
          kr[mr - 1] = arguments[mr];
        y("error", wt, kr);
      }
    }
    function y(wt, Yn, kr) {
      {
        var mr = b.ReactDebugCurrentFrame, yi = mr.getStackAddendum();
        yi !== "" && (Yn += "%s", kr = kr.concat([yi]));
        var Or = kr.map(function(Ei) {
          return String(Ei);
        });
        Or.unshift("Warning: " + Yn), Function.prototype.apply.call(console[wt], console, Or);
      }
    }
    var U = !1, B = !1, Q = !1, N = !1, J = !1, w;
    w = Symbol.for("react.module.reference");
    function W(wt) {
      return !!(typeof wt == "string" || typeof wt == "function" || wt === e || wt === t || J || wt === n || wt === d || wt === u || N || wt === g || U || B || Q || typeof wt == "object" && wt !== null && (wt.$$typeof === A || wt.$$typeof === h || wt.$$typeof === o || wt.$$typeof === l || wt.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      wt.$$typeof === w || wt.getModuleId !== void 0));
    }
    function G(wt, Yn, kr) {
      var mr = wt.displayName;
      if (mr)
        return mr;
      var yi = Yn.displayName || Yn.name || "";
      return yi !== "" ? kr + "(" + yi + ")" : kr;
    }
    function Z(wt) {
      return wt.displayName || "Context";
    }
    function K(wt) {
      if (wt == null)
        return null;
      if (typeof wt.tag == "number" && m("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof wt == "function")
        return wt.displayName || wt.name || null;
      if (typeof wt == "string")
        return wt;
      switch (wt) {
        case e:
          return "Fragment";
        case r:
          return "Portal";
        case t:
          return "Profiler";
        case n:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof wt == "object")
        switch (wt.$$typeof) {
          case l:
            var Yn = wt;
            return Z(Yn) + ".Consumer";
          case o:
            var kr = wt;
            return Z(kr._context) + ".Provider";
          case c:
            return G(wt, wt.render, "ForwardRef");
          case h:
            var mr = wt.displayName || null;
            return mr !== null ? mr : K(wt.type) || "Memo";
          case A: {
            var yi = wt, Or = yi._payload, Ei = yi._init;
            try {
              return K(Ei(Or));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, O = 0, de, oe, fe, ge, we, _e, Te;
    function Pe() {
    }
    Pe.__reactDisabledLog = !0;
    function $e() {
      {
        if (O === 0) {
          de = console.log, oe = console.info, fe = console.warn, ge = console.error, we = console.group, _e = console.groupCollapsed, Te = console.groupEnd;
          var wt = {
            configurable: !0,
            enumerable: !0,
            value: Pe,
            writable: !0
          };
          Object.defineProperties(console, {
            info: wt,
            log: wt,
            warn: wt,
            error: wt,
            group: wt,
            groupCollapsed: wt,
            groupEnd: wt
          });
        }
        O++;
      }
    }
    function Bt() {
      {
        if (O--, O === 0) {
          var wt = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, wt, {
              value: de
            }),
            info: L({}, wt, {
              value: oe
            }),
            warn: L({}, wt, {
              value: fe
            }),
            error: L({}, wt, {
              value: ge
            }),
            group: L({}, wt, {
              value: we
            }),
            groupCollapsed: L({}, wt, {
              value: _e
            }),
            groupEnd: L({}, wt, {
              value: Te
            })
          });
        }
        O < 0 && m("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Le = b.ReactCurrentDispatcher, at;
    function pt(wt, Yn, kr) {
      {
        if (at === void 0)
          try {
            throw Error();
          } catch (yi) {
            var mr = yi.stack.trim().match(/\n( *(at )?)/);
            at = mr && mr[1] || "";
          }
        return `
` + at + wt;
      }
    }
    var kt = !1, _t;
    {
      var Lt = typeof WeakMap == "function" ? WeakMap : Map;
      _t = new Lt();
    }
    function Ft(wt, Yn) {
      if (!wt || kt)
        return "";
      {
        var kr = _t.get(wt);
        if (kr !== void 0)
          return kr;
      }
      var mr;
      kt = !0;
      var yi = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Or;
      Or = Le.current, Le.current = null, $e();
      try {
        if (Yn) {
          var Ei = function() {
            throw Error();
          };
          if (Object.defineProperty(Ei.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ei, []);
            } catch (Et) {
              mr = Et;
            }
            Reflect.construct(wt, [], Ei);
          } else {
            try {
              Ei.call();
            } catch (Et) {
              mr = Et;
            }
            wt.call(Ei.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Et) {
            mr = Et;
          }
          wt();
        }
      } catch (Et) {
        if (Et && mr && typeof Et.stack == "string") {
          for (var Rt = Et.stack.split(`
`), ln = mr.stack.split(`
`), tt = Rt.length - 1, Oe = ln.length - 1; tt >= 1 && Oe >= 0 && Rt[tt] !== ln[Oe]; )
            Oe--;
          for (; tt >= 1 && Oe >= 0; tt--, Oe--)
            if (Rt[tt] !== ln[Oe]) {
              if (tt !== 1 || Oe !== 1)
                do
                  if (tt--, Oe--, Oe < 0 || Rt[tt] !== ln[Oe]) {
                    var Jt = `
` + Rt[tt].replace(" at new ", " at ");
                    return wt.displayName && Jt.includes("<anonymous>") && (Jt = Jt.replace("<anonymous>", wt.displayName)), typeof wt == "function" && _t.set(wt, Jt), Jt;
                  }
                while (tt >= 1 && Oe >= 0);
              break;
            }
        }
      } finally {
        kt = !1, Le.current = Or, Bt(), Error.prepareStackTrace = yi;
      }
      var St = wt ? wt.displayName || wt.name : "", Vt = St ? pt(St) : "";
      return typeof wt == "function" && _t.set(wt, Vt), Vt;
    }
    function Zt(wt, Yn, kr) {
      return Ft(wt, !1);
    }
    function ft(wt) {
      var Yn = wt.prototype;
      return !!(Yn && Yn.isReactComponent);
    }
    function It(wt, Yn, kr) {
      if (wt == null)
        return "";
      if (typeof wt == "function")
        return Ft(wt, ft(wt));
      if (typeof wt == "string")
        return pt(wt);
      switch (wt) {
        case d:
          return pt("Suspense");
        case u:
          return pt("SuspenseList");
      }
      if (typeof wt == "object")
        switch (wt.$$typeof) {
          case c:
            return Zt(wt.render);
          case h:
            return It(wt.type, Yn, kr);
          case A: {
            var mr = wt, yi = mr._payload, Or = mr._init;
            try {
              return It(Or(yi), Yn, kr);
            } catch {
            }
          }
        }
      return "";
    }
    var Kt = Object.prototype.hasOwnProperty, Sn = {}, Cn = b.ReactDebugCurrentFrame;
    function on(wt) {
      if (wt) {
        var Yn = wt._owner, kr = It(wt.type, wt._source, Yn ? Yn.type : null);
        Cn.setExtraStackFrame(kr);
      } else
        Cn.setExtraStackFrame(null);
    }
    function An(wt, Yn, kr, mr, yi) {
      {
        var Or = Function.call.bind(Kt);
        for (var Ei in wt)
          if (Or(wt, Ei)) {
            var Rt = void 0;
            try {
              if (typeof wt[Ei] != "function") {
                var ln = Error((mr || "React class") + ": " + kr + " type `" + Ei + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof wt[Ei] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ln.name = "Invariant Violation", ln;
              }
              Rt = wt[Ei](Yn, Ei, mr, kr, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (tt) {
              Rt = tt;
            }
            Rt && !(Rt instanceof Error) && (on(yi), m("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", mr || "React class", kr, Ei, typeof Rt), on(null)), Rt instanceof Error && !(Rt.message in Sn) && (Sn[Rt.message] = !0, on(yi), m("Failed %s type: %s", kr, Rt.message), on(null));
          }
      }
    }
    var Ue = Array.isArray;
    function ne(wt) {
      return Ue(wt);
    }
    function se(wt) {
      {
        var Yn = typeof Symbol == "function" && Symbol.toStringTag, kr = Yn && wt[Symbol.toStringTag] || wt.constructor.name || "Object";
        return kr;
      }
    }
    function Ce(wt) {
      try {
        return At(wt), !1;
      } catch {
        return !0;
      }
    }
    function At(wt) {
      return "" + wt;
    }
    function Ge(wt) {
      if (Ce(wt))
        return m("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", se(wt)), At(wt);
    }
    var Ye = b.ReactCurrentOwner, Qt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tn, vn, Yt;
    Yt = {};
    function Tn(wt) {
      if (Kt.call(wt, "ref")) {
        var Yn = Object.getOwnPropertyDescriptor(wt, "ref").get;
        if (Yn && Yn.isReactWarning)
          return !1;
      }
      return wt.ref !== void 0;
    }
    function er(wt) {
      if (Kt.call(wt, "key")) {
        var Yn = Object.getOwnPropertyDescriptor(wt, "key").get;
        if (Yn && Yn.isReactWarning)
          return !1;
      }
      return wt.key !== void 0;
    }
    function lr(wt, Yn) {
      if (typeof wt.ref == "string" && Ye.current && Yn && Ye.current.stateNode !== Yn) {
        var kr = K(Ye.current.type);
        Yt[kr] || (m('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(Ye.current.type), wt.ref), Yt[kr] = !0);
      }
    }
    function Br(wt, Yn) {
      {
        var kr = function() {
          tn || (tn = !0, m("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Yn));
        };
        kr.isReactWarning = !0, Object.defineProperty(wt, "key", {
          get: kr,
          configurable: !0
        });
      }
    }
    function pi(wt, Yn) {
      {
        var kr = function() {
          vn || (vn = !0, m("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Yn));
        };
        kr.isReactWarning = !0, Object.defineProperty(wt, "ref", {
          get: kr,
          configurable: !0
        });
      }
    }
    var $n = function(wt, Yn, kr, mr, yi, Or, Ei) {
      var Rt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: i,
        // Built-in properties that belong on the element
        type: wt,
        key: Yn,
        ref: kr,
        props: Ei,
        // Record the component responsible for creating this element.
        _owner: Or
      };
      return Rt._store = {}, Object.defineProperty(Rt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Rt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: mr
      }), Object.defineProperty(Rt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: yi
      }), Object.freeze && (Object.freeze(Rt.props), Object.freeze(Rt)), Rt;
    };
    function rr(wt, Yn, kr, mr, yi) {
      {
        var Or, Ei = {}, Rt = null, ln = null;
        kr !== void 0 && (Ge(kr), Rt = "" + kr), er(Yn) && (Ge(Yn.key), Rt = "" + Yn.key), Tn(Yn) && (ln = Yn.ref, lr(Yn, yi));
        for (Or in Yn)
          Kt.call(Yn, Or) && !Qt.hasOwnProperty(Or) && (Ei[Or] = Yn[Or]);
        if (wt && wt.defaultProps) {
          var tt = wt.defaultProps;
          for (Or in tt)
            Ei[Or] === void 0 && (Ei[Or] = tt[Or]);
        }
        if (Rt || ln) {
          var Oe = typeof wt == "function" ? wt.displayName || wt.name || "Unknown" : wt;
          Rt && Br(Ei, Oe), ln && pi(Ei, Oe);
        }
        return $n(wt, Rt, ln, yi, mr, Ye.current, Ei);
      }
    }
    var Kr = b.ReactCurrentOwner, Bi = b.ReactDebugCurrentFrame;
    function Li(wt) {
      if (wt) {
        var Yn = wt._owner, kr = It(wt.type, wt._source, Yn ? Yn.type : null);
        Bi.setExtraStackFrame(kr);
      } else
        Bi.setExtraStackFrame(null);
    }
    var xo;
    xo = !1;
    function Yr(wt) {
      return typeof wt == "object" && wt !== null && wt.$$typeof === i;
    }
    function Qo() {
      {
        if (Kr.current) {
          var wt = K(Kr.current.type);
          if (wt)
            return `

Check the render method of \`` + wt + "`.";
        }
        return "";
      }
    }
    function Wo(wt) {
      return "";
    }
    var xi = {};
    function Fa(wt) {
      {
        var Yn = Qo();
        if (!Yn) {
          var kr = typeof wt == "string" ? wt : wt.displayName || wt.name;
          kr && (Yn = `

Check the top-level render call using <` + kr + ">.");
        }
        return Yn;
      }
    }
    function sn(wt, Yn) {
      {
        if (!wt._store || wt._store.validated || wt.key != null)
          return;
        wt._store.validated = !0;
        var kr = Fa(Yn);
        if (xi[kr])
          return;
        xi[kr] = !0;
        var mr = "";
        wt && wt._owner && wt._owner !== Kr.current && (mr = " It was passed a child from " + K(wt._owner.type) + "."), Li(wt), m('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', kr, mr), Li(null);
      }
    }
    function Ct(wt, Yn) {
      {
        if (typeof wt != "object")
          return;
        if (ne(wt))
          for (var kr = 0; kr < wt.length; kr++) {
            var mr = wt[kr];
            Yr(mr) && sn(mr, Yn);
          }
        else if (Yr(wt))
          wt._store && (wt._store.validated = !0);
        else if (wt) {
          var yi = v(wt);
          if (typeof yi == "function" && yi !== wt.entries)
            for (var Or = yi.call(wt), Ei; !(Ei = Or.next()).done; )
              Yr(Ei.value) && sn(Ei.value, Yn);
        }
      }
    }
    function cn(wt) {
      {
        var Yn = wt.type;
        if (Yn == null || typeof Yn == "string")
          return;
        var kr;
        if (typeof Yn == "function")
          kr = Yn.propTypes;
        else if (typeof Yn == "object" && (Yn.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Yn.$$typeof === h))
          kr = Yn.propTypes;
        else
          return;
        if (kr) {
          var mr = K(Yn);
          An(kr, wt.props, "prop", mr, wt);
        } else if (Yn.PropTypes !== void 0 && !xo) {
          xo = !0;
          var yi = K(Yn);
          m("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", yi || "Unknown");
        }
        typeof Yn.getDefaultProps == "function" && !Yn.getDefaultProps.isReactClassApproved && m("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Hn(wt) {
      {
        for (var Yn = Object.keys(wt.props), kr = 0; kr < Yn.length; kr++) {
          var mr = Yn[kr];
          if (mr !== "children" && mr !== "key") {
            Li(wt), m("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", mr), Li(null);
            break;
          }
        }
        wt.ref !== null && (Li(wt), m("Invalid attribute `ref` supplied to `React.Fragment`."), Li(null));
      }
    }
    var Sr = {};
    function ao(wt, Yn, kr, mr, yi, Or) {
      {
        var Ei = W(wt);
        if (!Ei) {
          var Rt = "";
          (wt === void 0 || typeof wt == "object" && wt !== null && Object.keys(wt).length === 0) && (Rt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ln = Wo();
          ln ? Rt += ln : Rt += Qo();
          var tt;
          wt === null ? tt = "null" : ne(wt) ? tt = "array" : wt !== void 0 && wt.$$typeof === i ? (tt = "<" + (K(wt.type) || "Unknown") + " />", Rt = " Did you accidentally export a JSX literal instead of a component?") : tt = typeof wt, m("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", tt, Rt);
        }
        var Oe = rr(wt, Yn, kr, yi, Or);
        if (Oe == null)
          return Oe;
        if (Ei) {
          var Jt = Yn.children;
          if (Jt !== void 0)
            if (mr)
              if (ne(Jt)) {
                for (var St = 0; St < Jt.length; St++)
                  Ct(Jt[St], wt);
                Object.freeze && Object.freeze(Jt);
              } else
                m("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ct(Jt, wt);
        }
        if (Kt.call(Yn, "key")) {
          var Vt = K(wt), Et = Object.keys(Yn).filter(function(jt) {
            return jt !== "key";
          }), Qn = Et.length > 0 ? "{key: someKey, " + Et.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sr[Vt + Qn]) {
            var gn = Et.length > 0 ? "{" + Et.join(": ..., ") + ": ...}" : "{}";
            m(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Qn, Vt, gn, Vt), Sr[Vt + Qn] = !0;
          }
        }
        return wt === e ? Hn(Oe) : cn(Oe), Oe;
      }
    }
    function wr(wt, Yn, kr) {
      return ao(wt, Yn, kr, !0);
    }
    function Jr(wt, Yn, kr) {
      return ao(wt, Yn, kr, !1);
    }
    var Fn = Jr, Ia = wr;
    Xg.Fragment = e, Xg.jsx = Fn, Xg.jsxs = Ia;
  }(), Xg;
}
var TV = {};
TV.NODE_ENV === "production" ? sb.exports = JV() : sb.exports = GV();
var Dm = sb.exports;
function We(s, a, i) {
  return u1.call(a, "css") ? Dm.jsx(Mb, iU(s, a), i) : Dm.jsx(s, a, i);
}
function Ir(s, a, i) {
  return u1.call(a, "css") ? Dm.jsxs(Mb, iU(s, a), i) : Dm.jsxs(s, a, i);
}
const Rm = a1.create({
  baseURL: "https://hml-meet.conexasaude.com.br/api/v2"
}), lR = a1.create({
  baseURL: "https://hml-mstwilio.conexasaude.com.br/api/integration/vonage"
}), XV = a1.create({
  baseURL: "https://hml-api.conexasaude.com.br"
}), kV = {
  APP_URL: "vonage-express.conexasaude.com.br",
  APP_URL_ENDPOINT: "https://mstwilio.conexasaude.com.br/api/integration/vonage",
  APP_STORAGE_HOST: "https://storage.conexasaude.com.br",
  APP_MEET_URL: "https://meet.conexasaude.com.br/api/v2",
  APP_API_CORE: "https://api.conexasaude.com.br",
  APP_ENV_NAME: "PROD"
}, wV = {
  APP_URL: "hml-vonage-express.conexasaude.com.br",
  APP_URL_ENDPOINT: "https://hml-mstwilio.conexasaude.com.br/api/integration/vonage",
  APP_STORAGE_HOST: "https://hml-storage.conexasaude.com.br",
  APP_MEET_URL: "https://hml-meet.conexasaude.com.br/api/v2",
  APP_API_CORE: "https://hml-api.conexasaude.com.br",
  APP_ENV_NAME: "HML"
}, h0 = {
  PROD: kV,
  HML: wV
};
var Yb = /* @__PURE__ */ ((s) => (s.END = "END", s.ACTIVE = "ACTIVE", s))(Yb || {});
class Xp {
  static async solveShortnedLink(a, i) {
    const {
      data: r
    } = await Rm.get(`integration/vonage/solve-shortened-link/${a}`, {
      baseURL: h0[i].APP_MEET_URL
    });
    return r;
  }
  static async sessionEvents(a, i, r) {
    if (i) {
      fetch(`${h0[r].APP_MEET_URL}/integration/vonage/sessions/${a == null ? void 0 : a.sessionId}/events`, {
        keepalive: !0,
        method: "post",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(a)
      });
      return;
    }
    return await Rm.post(`integration/vonage/sessions/${a == null ? void 0 : a.sessionId}/events`, a, {
      baseURL: h0[r].APP_MEET_URL
    });
  }
  static async getCallStatus(a, i) {
    const {
      data: r
    } = await lR.get(`status/${a}`, {
      baseURL: h0[i].APP_URL_ENDPOINT
    });
    return r ? "END" : "ACTIVE";
  }
  static async userMeetStatus(a, i, r) {
    const {
      data: e
    } = await Rm.get(`integration/vonage/sessions/${a}/users/${i}/status`, {
      baseURL: h0[r].APP_MEET_URL
    });
    return e;
  }
  static async callReleased(a, i) {
    const {
      data: r
    } = await lR.get(`chamada/liberada/${a}`, {
      baseURL: h0[i].APP_URL_ENDPOINT
    });
    return r;
  }
  static async sendTerms(a, i, r) {
    await XV.post(`integration/ativacao/paciente/${a}/aceitar-termo-na-chamada`, {
      idClinica: i
    }, {
      baseURL: h0[r].APP_API_CORE
    });
  }
  static async removeParticipants(a, i, r, e) {
    if (r) {
      fetch(`${h0[e].APP_MEET_URL}/integration/vonage/sessions/${i}/ended`, {
        keepalive: !0,
        method: "put",
        headers: {
          "content-type": "application/json"
        },
        body: JSON.stringify(a)
      });
      return;
    }
    return await Rm.put(`integration/vonage/sessions/${i}/ended`, a, {
      baseURL: h0[e].APP_MEET_URL
    });
  }
}
const DV = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_APP_API_CORE: "https://hml-api.conexasaude.com.br", VITE_APP_API_URL: "http://localhost:3333", VITE_APP_ENV_NAME: "HML", VITE_APP_MEET_URL: "https://hml-meet.conexasaude.com.br/api/v2", VITE_APP_STORAGE_HOST: "https://hml-storage.conexasaude.com.br", VITE_APP_URL: "hml-vonage-express.conexasaude.com.br", VITE_APP_URL_ENDPOINT: "https://hml-mstwilio.conexasaude.com.br/api/integration/vonage" };
function MV(s, a) {
  let i;
  try {
    i = s();
  } catch {
    return;
  }
  return {
    getItem: (e) => {
      var n;
      const t = (l) => l === null ? null : JSON.parse(l, void 0), o = (n = i.getItem(e)) != null ? n : null;
      return o instanceof Promise ? o.then(t) : t(o);
    },
    setItem: (e, n) => i.setItem(
      e,
      JSON.stringify(n, void 0)
    ),
    removeItem: (e) => i.removeItem(e)
  };
}
const kp = (s) => (a) => {
  try {
    const i = s(a);
    return i instanceof Promise ? i : {
      then(r) {
        return kp(r)(i);
      },
      catch(r) {
        return this;
      }
    };
  } catch (i) {
    return {
      then(r) {
        return this;
      },
      catch(r) {
        return kp(r)(i);
      }
    };
  }
}, YV = (s, a) => (i, r, e) => {
  let n = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: (p) => p,
    version: 0,
    merge: (p, v) => ({
      ...v,
      ...p
    }),
    ...a
  }, t = !1;
  const o = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let c;
  try {
    c = n.getStorage();
  } catch {
  }
  if (!c)
    return s(
      (...p) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${n.name}', the given storage is currently unavailable.`
        ), i(...p);
      },
      r,
      e
    );
  const d = kp(n.serialize), u = () => {
    const p = n.partialize({ ...r() });
    let v;
    const b = d({ state: p, version: n.version }).then(
      (m) => c.setItem(n.name, m)
    ).catch((m) => {
      v = m;
    });
    if (v)
      throw v;
    return b;
  }, h = e.setState;
  e.setState = (p, v) => {
    h(p, v), u();
  };
  const A = s(
    (...p) => {
      i(...p), u();
    },
    r,
    e
  );
  let g;
  const f = () => {
    var p;
    if (!c) return;
    t = !1, o.forEach((b) => b(r()));
    const v = ((p = n.onRehydrateStorage) == null ? void 0 : p.call(n, r())) || void 0;
    return kp(c.getItem.bind(c))(n.name).then((b) => {
      if (b)
        return n.deserialize(b);
    }).then((b) => {
      if (b)
        if (typeof b.version == "number" && b.version !== n.version) {
          if (n.migrate)
            return n.migrate(
              b.state,
              b.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return b.state;
    }).then((b) => {
      var m;
      return g = n.merge(
        b,
        (m = r()) != null ? m : A
      ), i(g, !0), u();
    }).then(() => {
      v == null || v(g, void 0), t = !0, l.forEach((b) => b(g));
    }).catch((b) => {
      v == null || v(void 0, b);
    });
  };
  return e.persist = {
    setOptions: (p) => {
      n = {
        ...n,
        ...p
      }, p.getStorage && (c = p.getStorage());
    },
    clearStorage: () => {
      c == null || c.removeItem(n.name);
    },
    getOptions: () => n,
    rehydrate: () => f(),
    hasHydrated: () => t,
    onHydrate: (p) => (o.add(p), () => {
      o.delete(p);
    }),
    onFinishHydration: (p) => (l.add(p), () => {
      l.delete(p);
    })
  }, f(), g || A;
}, LV = (s, a) => (i, r, e) => {
  let n = {
    storage: MV(() => localStorage),
    partialize: (f) => f,
    version: 0,
    merge: (f, p) => ({
      ...p,
      ...f
    }),
    ...a
  }, t = !1;
  const o = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let c = n.storage;
  if (!c)
    return s(
      (...f) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${n.name}', the given storage is currently unavailable.`
        ), i(...f);
      },
      r,
      e
    );
  const d = () => {
    const f = n.partialize({ ...r() });
    return c.setItem(n.name, {
      state: f,
      version: n.version
    });
  }, u = e.setState;
  e.setState = (f, p) => {
    u(f, p), d();
  };
  const h = s(
    (...f) => {
      i(...f), d();
    },
    r,
    e
  );
  e.getInitialState = () => h;
  let A;
  const g = () => {
    var f, p;
    if (!c) return;
    t = !1, o.forEach((b) => {
      var m;
      return b((m = r()) != null ? m : h);
    });
    const v = ((p = n.onRehydrateStorage) == null ? void 0 : p.call(n, (f = r()) != null ? f : h)) || void 0;
    return kp(c.getItem.bind(c))(n.name).then((b) => {
      if (b)
        if (typeof b.version == "number" && b.version !== n.version) {
          if (n.migrate)
            return [
              !0,
              n.migrate(
                b.state,
                b.version
              )
            ];
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, b.state];
      return [!1, void 0];
    }).then((b) => {
      var m;
      const [y, U] = b;
      if (A = n.merge(
        U,
        (m = r()) != null ? m : h
      ), i(A, !0), y)
        return d();
    }).then(() => {
      v == null || v(A, void 0), A = r(), t = !0, l.forEach((b) => b(A));
    }).catch((b) => {
      v == null || v(void 0, b);
    });
  };
  return e.persist = {
    setOptions: (f) => {
      n = {
        ...n,
        ...f
      }, f.storage && (c = f.storage);
    },
    clearStorage: () => {
      c == null || c.removeItem(n.name);
    },
    getOptions: () => n,
    rehydrate: () => g(),
    hasHydrated: () => t,
    onHydrate: (f) => (o.add(f), () => {
      o.delete(f);
    }),
    onFinishHydration: (f) => (l.add(f), () => {
      l.delete(f);
    })
  }, n.skipHydration || g(), A || h;
}, xV = (s, a) => "getStorage" in a || "serialize" in a || "deserialize" in a ? ((DV ? "production" : void 0) !== "production" && console.warn(
  "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
), YV(s, a)) : LV(s, a), HV = xV, PV = HV((s) => ({
  meetSettings: null,
  shortnedLinkSolved: null,
  updateMeetSettings: (a) => {
    s(() => ({
      meetSettings: a
    }));
  },
  updateShortnedLinkSolved: (a) => {
    s(() => ({
      shortnedLinkSolved: a
    }));
  }
}), {
  name: "meet-store",
  // unique name
  getStorage: () => sessionStorage
  // (optional) by default, 'localStorage' is used
}), OV = qh(PV);
function lb(s) {
  this.message = s;
}
lb.prototype = new Error(), lb.prototype.name = "InvalidCharacterError";
var cR = typeof window != "undefined" && window.atob && window.atob.bind(window) || function(s) {
  var a = String(s).replace(/=+$/, "");
  if (a.length % 4 == 1) throw new lb("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var i, r, e = 0, n = 0, t = ""; r = a.charAt(n++); ~r && (i = e % 4 ? 64 * i + r : r, e++ % 4) ? t += String.fromCharCode(255 & i >> (-2 * e & 6)) : 0) r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(r);
  return t;
};
function KV(s) {
  var a = s.replace(/-/g, "+").replace(/_/g, "/");
  switch (a.length % 4) {
    case 0:
      break;
    case 2:
      a += "==";
      break;
    case 3:
      a += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(i) {
      return decodeURIComponent(cR(i).replace(/(.)/g, function(r, e) {
        var n = e.charCodeAt(0).toString(16).toUpperCase();
        return n.length < 2 && (n = "0" + n), "%" + n;
      }));
    }(a);
  } catch {
    return cR(a);
  }
}
function Mm(s) {
  this.message = s;
}
function zV(s, a) {
  if (typeof s != "string") throw new Mm("Invalid token specified");
  var i = (a = a || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(KV(s.split(".")[i]));
  } catch (r) {
    throw new Mm("Invalid token specified: " + r.message);
  }
}
Mm.prototype = new Error(), Mm.prototype.name = "InvalidTokenError";
function jV(s) {
  return zV(s);
}
const dR = (s) => {
  var a, i;
  return eb({
    message: ((i = (a = s == null ? void 0 : s.response) == null ? void 0 : a.data) == null ? void 0 : i.msg) || "Aconteceu um problema inesperado, sentimos muito.",
    variant: "error"
  });
}, oU = new NE({
  queryCache: new JE({
    onError(s) {
      dR(s);
    }
  }),
  mutationCache: new GE({
    onError(s) {
      dR(s);
    }
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: !1,
      retry: 1,
      networkMode: "offlineFirst"
    },
    mutations: {
      retry: 1
    }
  }
}), aU = Pp(null), GO = ({
  children: s,
  meetingUrl: a,
  enableTranscription: i,
  userType: r,
  env: e,
  listenerEvent: n,
  onFinishMeet: t,
  disableInlineNotifications: o = !0
}) => {
  const [l, c] = Tl(!1), [d, u] = Tl(null), h = OV((f) => f.updateShortnedLinkSolved), A = Gc(async (f) => {
    var p;
    try {
      const v = await Xp.solveShortnedLink(f, e);
      if (v != null && v.longUrl) {
        h(v);
        const b = (p = v == null ? void 0 : v.longUrl) == null ? void 0 : p.split("/")[4], m = jV(b);
        u(m);
      }
    } catch (v) {
      console.warn("Error getting meet settings", v);
    } finally {
      c(!1);
    }
  }, [h, e]);
  Pd(() => {
    if (a) {
      const f = new URL(a), p = new URLSearchParams(f.search), v = {};
      for (const [b, m] of p)
        v[b] = m;
      A(v == null ? void 0 : v.shortened);
    }
  }, [A, a]), Pd(() => {
    n && m0.setState({
      listenerEvent: n
    });
  }, [n]);
  const g = Oh(() => ({
    isLoading: l,
    meetSettings: d,
    enableTranscription: i,
    userType: r,
    env: e,
    onFinishMeet: t
  }), [i, e, l, d, t, r]);
  return /* @__PURE__ */ Ir(TE, { client: oU, children: [
    !o && /* @__PURE__ */ We(BE, {}),
    /* @__PURE__ */ We(aU.Provider, { value: g, children: a ? s : null })
  ] });
};
var ki = {}, cb = { exports: {} };
(function(s, a) {
  (function(i, r) {
    var e = "1.0.38", n = "", t = "?", o = "function", l = "undefined", c = "object", d = "string", u = "major", h = "model", A = "name", g = "type", f = "vendor", p = "version", v = "architecture", b = "console", m = "mobile", y = "tablet", U = "smarttv", B = "wearable", Q = "embedded", N = 500, J = "Amazon", w = "Apple", W = "ASUS", G = "BlackBerry", Z = "Browser", K = "Chrome", L = "Edge", O = "Firefox", de = "Google", oe = "Huawei", fe = "LG", ge = "Microsoft", we = "Motorola", _e = "Opera", Te = "Samsung", Pe = "Sharp", $e = "Sony", Bt = "Xiaomi", Le = "Zebra", at = "Facebook", pt = "Chromium OS", kt = "Mac OS", _t = function(Ce, At) {
      var Ge = {};
      for (var Ye in Ce)
        At[Ye] && At[Ye].length % 2 === 0 ? Ge[Ye] = At[Ye].concat(Ce[Ye]) : Ge[Ye] = Ce[Ye];
      return Ge;
    }, Lt = function(Ce) {
      for (var At = {}, Ge = 0; Ge < Ce.length; Ge++)
        At[Ce[Ge].toUpperCase()] = Ce[Ge];
      return At;
    }, Ft = function(Ce, At) {
      return typeof Ce === d ? Zt(At).indexOf(Zt(Ce)) !== -1 : !1;
    }, Zt = function(Ce) {
      return Ce.toLowerCase();
    }, ft = function(Ce) {
      return typeof Ce === d ? Ce.replace(/[^\d\.]/g, n).split(".")[0] : r;
    }, It = function(Ce, At) {
      if (typeof Ce === d)
        return Ce = Ce.replace(/^\s\s*/, n), typeof At === l ? Ce : Ce.substring(0, N);
    }, Kt = function(Ce, At) {
      for (var Ge = 0, Ye, Qt, tn, vn, Yt, Tn; Ge < At.length && !Yt; ) {
        var er = At[Ge], lr = At[Ge + 1];
        for (Ye = Qt = 0; Ye < er.length && !Yt && er[Ye]; )
          if (Yt = er[Ye++].exec(Ce), Yt)
            for (tn = 0; tn < lr.length; tn++)
              Tn = Yt[++Qt], vn = lr[tn], typeof vn === c && vn.length > 0 ? vn.length === 2 ? typeof vn[1] == o ? this[vn[0]] = vn[1].call(this, Tn) : this[vn[0]] = vn[1] : vn.length === 3 ? typeof vn[1] === o && !(vn[1].exec && vn[1].test) ? this[vn[0]] = Tn ? vn[1].call(this, Tn, vn[2]) : r : this[vn[0]] = Tn ? Tn.replace(vn[1], vn[2]) : r : vn.length === 4 && (this[vn[0]] = Tn ? vn[3].call(this, Tn.replace(vn[1], vn[2])) : r) : this[vn] = Tn || r;
        Ge += 2;
      }
    }, Sn = function(Ce, At) {
      for (var Ge in At)
        if (typeof At[Ge] === c && At[Ge].length > 0) {
          for (var Ye = 0; Ye < At[Ge].length; Ye++)
            if (Ft(At[Ge][Ye], Ce))
              return Ge === t ? r : Ge;
        } else if (Ft(At[Ge], Ce))
          return Ge === t ? r : Ge;
      return Ce;
    }, Cn = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, on = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, An = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [p, [A, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [p, [A, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [A, p], [/opios[\/ ]+([\w\.]+)/i], [p, [A, _e + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [p, [A, _e + " GX"]], [/\bopr\/([\w\.]+)/i], [p, [A, _e]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [p, [A, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [A, p], [/\bddg\/([\w\.]+)/i], [p, [A, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [p, [A, "UC" + Z]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [p, [A, "WeChat"]], [/konqueror\/([\w\.]+)/i], [p, [A, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [p, [A, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [p, [A, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [p, [A, "Smart Lenovo " + Z]], [/(avast|avg)\/([\w\.]+)/i], [[A, /(.+)/, "$1 Secure " + Z], p], [/\bfocus\/([\w\.]+)/i], [p, [A, O + " Focus"]], [/\bopt\/([\w\.]+)/i], [p, [A, _e + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [p, [A, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [p, [A, "Dolphin"]], [/coast\/([\w\.]+)/i], [p, [A, _e + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [p, [A, "MIUI " + Z]], [/fxios\/([-\w\.]+)/i], [p, [A, O]], [/\bqihu|(qi?ho?o?|360)browser/i], [[A, "360 " + Z]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[A, /(.+)/, "$1 " + Z], p], [/samsungbrowser\/([\w\.]+)/i], [p, [A, Te + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[A, /_/g, " "], p], [/metasr[\/ ]?([\d\.]+)/i], [p, [A, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[A, "Sogou Mobile"], p], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [A, p], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [A], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[A, at], p], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [A, p], [/\bgsa\/([\w\.]+) .*safari\//i], [p, [A, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [p, [A, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [p, [A, K + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[A, K + " WebView"], p], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [p, [A, "Android " + Z]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [A, p], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [p, [A, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [p, A], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [A, [p, Sn, Cn]], [/(webkit|khtml)\/([\w\.]+)/i], [A, p], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[A, "Netscape"], p], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [p, [A, O + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [A, p], [/(cobalt)\/([\w\.]+)/i], [A, [p, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[v, "amd64"]], [/(ia32(?=;))/i], [[v, Zt]], [/((?:i[346]|x)86)[;\)]/i], [[v, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[v, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[v, "armhf"]], [/windows (ce|mobile); ppc;/i], [[v, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[v, /ower/, n, Zt]], [/(sun4\w)[;\)]/i], [[v, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[v, Zt]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [h, [f, Te], [g, y]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [h, [f, Te], [g, m]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [h, [f, w], [g, m]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [h, [f, w], [g, y]], [/(macintosh);/i], [h, [f, w]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [h, [f, Pe], [g, m]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [h, [f, oe], [g, y]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [h, [f, oe], [g, m]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[h, /_/g, " "], [f, Bt], [g, m]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[h, /_/g, " "], [f, Bt], [g, y]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [h, [f, "OPPO"], [g, m]], [/\b(opd2\d{3}a?) bui/i], [h, [f, "OPPO"], [g, y]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [h, [f, "Vivo"], [g, m]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [h, [f, "Realme"], [g, m]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [h, [f, we], [g, m]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [h, [f, we], [g, y]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [h, [f, fe], [g, y]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [h, [f, fe], [g, m]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [h, [f, "Lenovo"], [g, y]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[h, /_/g, " "], [f, "Nokia"], [g, m]], [/(pixel c)\b/i], [h, [f, de], [g, y]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [h, [f, de], [g, m]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [h, [f, $e], [g, m]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[h, "Xperia Tablet"], [f, $e], [g, y]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [h, [f, "OnePlus"], [g, m]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [h, [f, J], [g, y]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[h, /(.+)/g, "Fire Phone $1"], [f, J], [g, m]], [/(playbook);[-\w\),; ]+(rim)/i], [h, f, [g, y]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [h, [f, G], [g, m]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [h, [f, W], [g, y]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [h, [f, W], [g, m]], [/(nexus 9)/i], [h, [f, "HTC"], [g, y]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [f, [h, /_/g, " "], [g, m]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [h, [f, "Acer"], [g, y]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [h, [f, "Meizu"], [g, m]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [h, [f, "Ulefone"], [g, m]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [f, h, [g, m]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [f, h, [g, y]], [/(surface duo)/i], [h, [f, ge], [g, y]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [h, [f, "Fairphone"], [g, m]], [/(u304aa)/i], [h, [f, "AT&T"], [g, m]], [/\bsie-(\w*)/i], [h, [f, "Siemens"], [g, m]], [/\b(rct\w+) b/i], [h, [f, "RCA"], [g, y]], [/\b(venue[\d ]{2,7}) b/i], [h, [f, "Dell"], [g, y]], [/\b(q(?:mv|ta)\w+) b/i], [h, [f, "Verizon"], [g, y]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [h, [f, "Barnes & Noble"], [g, y]], [/\b(tm\d{3}\w+) b/i], [h, [f, "NuVision"], [g, y]], [/\b(k88) b/i], [h, [f, "ZTE"], [g, y]], [/\b(nx\d{3}j) b/i], [h, [f, "ZTE"], [g, m]], [/\b(gen\d{3}) b.+49h/i], [h, [f, "Swiss"], [g, m]], [/\b(zur\d{3}) b/i], [h, [f, "Swiss"], [g, y]], [/\b((zeki)?tb.*\b) b/i], [h, [f, "Zeki"], [g, y]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[f, "Dragon Touch"], h, [g, y]], [/\b(ns-?\w{0,9}) b/i], [h, [f, "Insignia"], [g, y]], [/\b((nxa|next)-?\w{0,9}) b/i], [h, [f, "NextBook"], [g, y]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[f, "Voice"], h, [g, m]], [/\b(lvtel\-)?(v1[12]) b/i], [[f, "LvTel"], h, [g, m]], [/\b(ph-1) /i], [h, [f, "Essential"], [g, m]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [h, [f, "Envizen"], [g, y]], [/\b(trio[-\w\. ]+) b/i], [h, [f, "MachSpeed"], [g, y]], [/\btu_(1491) b/i], [h, [f, "Rotor"], [g, y]], [/(shield[\w ]+) b/i], [h, [f, "Nvidia"], [g, y]], [/(sprint) (\w+)/i], [f, h, [g, m]], [/(kin\.[onetw]{3})/i], [[h, /\./g, " "], [f, ge], [g, m]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [h, [f, Le], [g, y]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [h, [f, Le], [g, m]], [/smart-tv.+(samsung)/i], [f, [g, U]], [/hbbtv.+maple;(\d+)/i], [[h, /^/, "SmartTV"], [f, Te], [g, U]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[f, fe], [g, U]], [/(apple) ?tv/i], [f, [h, w + " TV"], [g, U]], [/crkey/i], [[h, K + "cast"], [f, de], [g, U]], [/droid.+aft(\w+)( bui|\))/i], [h, [f, J], [g, U]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [h, [f, Pe], [g, U]], [/(bravia[\w ]+)( bui|\))/i], [h, [f, $e], [g, U]], [/(mitv-\w{5}) bui/i], [h, [f, Bt], [g, U]], [/Hbbtv.*(technisat) (.*);/i], [f, h, [g, U]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[f, It], [h, It], [g, U]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[g, U]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [f, h, [g, b]], [/droid.+; (shield) bui/i], [h, [f, "Nvidia"], [g, b]], [/(playstation [345portablevi]+)/i], [h, [f, $e], [g, b]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [h, [f, ge], [g, b]], [/((pebble))app/i], [f, h, [g, B]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [h, [f, w], [g, B]], [/droid.+; (glass) \d/i], [h, [f, de], [g, B]], [/droid.+; (wt63?0{2,3})\)/i], [h, [f, Le], [g, B]], [/(quest( \d| pro)?)/i], [h, [f, at], [g, B]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [f, [g, Q]], [/(aeobc)\b/i], [h, [f, J], [g, Q]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [h, [g, m]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [h, [g, y]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[g, y]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[g, m]], [/(android[-\w\. ]{0,9});.+buil/i], [h, [f, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [p, [A, L + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [p, [A, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [A, p], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [p, A]], os: [[/microsoft (windows) (vista|xp)/i], [A, p], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [A, [p, Sn, on]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[p, Sn, on], [A, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[p, /_/g, "."], [A, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[A, kt], [p, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [p, A], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [A, p], [/\(bb(10);/i], [p, [A, G]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [p, [A, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [p, [A, O + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [p, [A, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [p, [A, "watchOS"]], [/crkey\/([\d\.]+)/i], [p, [A, K + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[A, pt], p], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [A, p], [/(sunos) ?([\w\.\d]*)/i], [[A, "Solaris"], p], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [A, p]] }, Ue = function(Ce, At) {
      if (typeof Ce === c && (At = Ce, Ce = r), !(this instanceof Ue))
        return new Ue(Ce, At).getResult();
      var Ge = typeof i !== l && i.navigator ? i.navigator : r, Ye = Ce || (Ge && Ge.userAgent ? Ge.userAgent : n), Qt = Ge && Ge.userAgentData ? Ge.userAgentData : r, tn = At ? _t(An, At) : An, vn = Ge && Ge.userAgent == Ye;
      return this.getBrowser = function() {
        var Yt = {};
        return Yt[A] = r, Yt[p] = r, Kt.call(Yt, Ye, tn.browser), Yt[u] = ft(Yt[p]), vn && Ge && Ge.brave && typeof Ge.brave.isBrave == o && (Yt[A] = "Brave"), Yt;
      }, this.getCPU = function() {
        var Yt = {};
        return Yt[v] = r, Kt.call(Yt, Ye, tn.cpu), Yt;
      }, this.getDevice = function() {
        var Yt = {};
        return Yt[f] = r, Yt[h] = r, Yt[g] = r, Kt.call(Yt, Ye, tn.device), vn && !Yt[g] && Qt && Qt.mobile && (Yt[g] = m), vn && Yt[h] == "Macintosh" && Ge && typeof Ge.standalone !== l && Ge.maxTouchPoints && Ge.maxTouchPoints > 2 && (Yt[h] = "iPad", Yt[g] = y), Yt;
      }, this.getEngine = function() {
        var Yt = {};
        return Yt[A] = r, Yt[p] = r, Kt.call(Yt, Ye, tn.engine), Yt;
      }, this.getOS = function() {
        var Yt = {};
        return Yt[A] = r, Yt[p] = r, Kt.call(Yt, Ye, tn.os), vn && !Yt[A] && Qt && Qt.platform && Qt.platform != "Unknown" && (Yt[A] = Qt.platform.replace(/chrome os/i, pt).replace(/macos/i, kt)), Yt;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return Ye;
      }, this.setUA = function(Yt) {
        return Ye = typeof Yt === d && Yt.length > N ? It(Yt, N) : Yt, this;
      }, this.setUA(Ye), this;
    };
    Ue.VERSION = e, Ue.BROWSER = Lt([A, p, u]), Ue.CPU = Lt([v]), Ue.DEVICE = Lt([h, f, g, b, m, U, y, B, Q]), Ue.ENGINE = Ue.OS = Lt([A, p]), s.exports && (a = s.exports = Ue), a.UAParser = Ue;
    var ne = typeof i !== l && (i.jQuery || i.Zepto);
    if (ne && !ne.ua) {
      var se = new Ue();
      ne.ua = se.getResult(), ne.ua.get = function() {
        return se.getUA();
      }, ne.ua.set = function(Ce) {
        se.setUA(Ce);
        var At = se.getResult();
        for (var Ge in At)
          ne.ua[Ge] = At[Ge];
      };
    }
  })(typeof window == "object" ? window : Dn);
})(cb, cb.exports);
var _V = cb.exports;
Object.defineProperty(ki, "__esModule", { value: !0 });
function $V(s) {
  return s && typeof s == "object" && "default" in s ? s.default : s;
}
var Fd = b0, Al = $V(Fd), sU = _V, nh = new sU(), yd = nh.getBrowser(), qV = nh.getCPU(), iu = nh.getDevice(), Lb = nh.getEngine(), rh = nh.getOS(), Kp = nh.getUA(), lU = function(a) {
  return nh.setUA(a);
}, zp = function(a) {
  if (!a) {
    console.error("No userAgent string was provided");
    return;
  }
  var i = new sU(a);
  return {
    UA: i,
    browser: i.getBrowser(),
    cpu: i.getCPU(),
    device: i.getDevice(),
    engine: i.getEngine(),
    os: i.getOS(),
    ua: i.getUA(),
    setUserAgent: function(e) {
      return i.setUA(e);
    }
  };
}, cU = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: nh,
  browser: yd,
  cpu: qV,
  device: iu,
  engine: Lb,
  os: rh,
  ua: Kp,
  setUa: lU,
  parseUserAgent: zp
});
function uR(s, a) {
  var i = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(s);
    a && (r = r.filter(function(e) {
      return Object.getOwnPropertyDescriptor(s, e).enumerable;
    })), i.push.apply(i, r);
  }
  return i;
}
function e3(s) {
  for (var a = 1; a < arguments.length; a++) {
    var i = arguments[a] != null ? arguments[a] : {};
    a % 2 ? uR(Object(i), !0).forEach(function(r) {
      i3(s, r, i[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : uR(Object(i)).forEach(function(r) {
      Object.defineProperty(s, r, Object.getOwnPropertyDescriptor(i, r));
    });
  }
  return s;
}
function Zp(s) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Zp = function(a) {
    return typeof a;
  } : Zp = function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, Zp(s);
}
function t3(s, a) {
  if (!(s instanceof a))
    throw new TypeError("Cannot call a class as a function");
}
function n3(s, a) {
  for (var i = 0; i < a.length; i++) {
    var r = a[i];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(s, r.key, r);
  }
}
function r3(s, a, i) {
  return a && n3(s.prototype, a), s;
}
function i3(s, a, i) {
  return a in s ? Object.defineProperty(s, a, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[a] = i, s;
}
function db() {
  return db = Object.assign || function(s) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a];
      for (var r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (s[r] = i[r]);
    }
    return s;
  }, db.apply(this, arguments);
}
function o3(s, a) {
  if (typeof a != "function" && a !== null)
    throw new TypeError("Super expression must either be null or a function");
  s.prototype = Object.create(a && a.prototype, {
    constructor: {
      value: s,
      writable: !0,
      configurable: !0
    }
  }), a && hb(s, a);
}
function ub(s) {
  return ub = Object.setPrototypeOf ? Object.getPrototypeOf : function(i) {
    return i.__proto__ || Object.getPrototypeOf(i);
  }, ub(s);
}
function hb(s, a) {
  return hb = Object.setPrototypeOf || function(r, e) {
    return r.__proto__ = e, r;
  }, hb(s, a);
}
function a3(s, a) {
  if (s == null) return {};
  var i = {}, r = Object.keys(s), e, n;
  for (n = 0; n < r.length; n++)
    e = r[n], !(a.indexOf(e) >= 0) && (i[e] = s[e]);
  return i;
}
function Au(s, a) {
  if (s == null) return {};
  var i = a3(s, a), r, e;
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(s);
    for (e = 0; e < n.length; e++)
      r = n[e], !(a.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(s, r) && (i[r] = s[r]);
  }
  return i;
}
function Wm(s) {
  if (s === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function s3(s, a) {
  if (a && (typeof a == "object" || typeof a == "function"))
    return a;
  if (a !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Wm(s);
}
function l3(s, a) {
  return c3(s) || d3(s, a) || u3(s, a) || h3();
}
function c3(s) {
  if (Array.isArray(s)) return s;
}
function d3(s, a) {
  var i = s == null ? null : typeof Symbol != "undefined" && s[Symbol.iterator] || s["@@iterator"];
  if (i != null) {
    var r = [], e = !0, n = !1, t, o;
    try {
      for (i = i.call(s); !(e = (t = i.next()).done) && (r.push(t.value), !(a && r.length === a)); e = !0)
        ;
    } catch (l) {
      n = !0, o = l;
    } finally {
      try {
        !e && i.return != null && i.return();
      } finally {
        if (n) throw o;
      }
    }
    return r;
  }
}
function u3(s, a) {
  if (s) {
    if (typeof s == "string") return hR(s, a);
    var i = Object.prototype.toString.call(s).slice(8, -1);
    if (i === "Object" && s.constructor && (i = s.constructor.name), i === "Map" || i === "Set") return Array.from(s);
    if (i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return hR(s, a);
  }
}
function hR(s, a) {
  (a == null || a > s.length) && (a = s.length);
  for (var i = 0, r = new Array(a); i < a; i++) r[i] = s[i];
  return r;
}
function h3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var pd = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, Kd = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, _A = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, A3 = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, g3 = function(a) {
  switch (a) {
    case pd.Mobile:
      return {
        isMobile: !0
      };
    case pd.Tablet:
      return {
        isTablet: !0
      };
    case pd.SmartTv:
      return {
        isSmartTV: !0
      };
    case pd.Console:
      return {
        isConsole: !0
      };
    case pd.Wearable:
      return {
        isWearable: !0
      };
    case pd.Browser:
      return {
        isBrowser: !0
      };
    case pd.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return A3;
  }
}, f3 = function(a) {
  return lU(a);
}, qo = function(a) {
  var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return a || i;
}, xb = function() {
  return typeof window != "undefined" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, Hb = function(a) {
  var i = xb();
  return i && i.platform && (i.platform.indexOf(a) !== -1 || i.platform === "MacIntel" && i.maxTouchPoints > 1 && !window.MSStream);
}, p3 = function(a, i, r, e, n) {
  return {
    isBrowser: a,
    browserMajorVersion: qo(i.major),
    browserFullVersion: qo(i.version),
    browserName: qo(i.name),
    engineName: qo(r.name),
    engineVersion: qo(r.version),
    osName: qo(e.name),
    osVersion: qo(e.version),
    userAgent: qo(n)
  };
}, AR = function(a, i, r, e) {
  return e3({}, a, {
    vendor: qo(i.vendor),
    model: qo(i.model),
    os: qo(r.name),
    osVersion: qo(r.version),
    ua: qo(e)
  });
}, m3 = function(a, i, r, e) {
  return {
    isSmartTV: a,
    engineName: qo(i.name),
    engineVersion: qo(i.version),
    osName: qo(r.name),
    osVersion: qo(r.version),
    userAgent: qo(e)
  };
}, v3 = function(a, i, r, e) {
  return {
    isConsole: a,
    engineName: qo(i.name),
    engineVersion: qo(i.version),
    osName: qo(r.name),
    osVersion: qo(r.version),
    userAgent: qo(e)
  };
}, b3 = function(a, i, r, e) {
  return {
    isWearable: a,
    engineName: qo(i.name),
    engineVersion: qo(i.version),
    osName: qo(r.name),
    osVersion: qo(r.version),
    userAgent: qo(e)
  };
}, F3 = function(a, i, r, e, n) {
  return {
    isEmbedded: a,
    vendor: qo(i.vendor),
    model: qo(i.model),
    engineName: qo(r.name),
    engineVersion: qo(r.version),
    osName: qo(e.name),
    osVersion: qo(e.version),
    userAgent: qo(n)
  };
};
function R3(s) {
  var a = s ? zp(s) : cU, i = a.device, r = a.browser, e = a.engine, n = a.os, t = a.ua, o = g3(i.type), l = o.isBrowser, c = o.isMobile, d = o.isTablet, u = o.isSmartTV, h = o.isConsole, A = o.isWearable, g = o.isEmbedded;
  if (l)
    return p3(l, r, e, n, t);
  if (u)
    return m3(u, e, n, t);
  if (h)
    return v3(h, e, n, t);
  if (c || d)
    return AR(o, i, n, t);
  if (A)
    return b3(A, e, n, t);
  if (g)
    return F3(g, i, e, n, t);
}
var dU = function(a) {
  var i = a.type;
  return i === pd.Mobile;
}, uU = function(a) {
  var i = a.type;
  return i === pd.Tablet;
}, hU = function(a) {
  var i = a.type;
  return i === pd.Mobile || i === pd.Tablet;
}, AU = function(a) {
  var i = a.type;
  return i === pd.SmartTv;
}, Ym = function(a) {
  var i = a.type;
  return i === pd.Browser;
}, gU = function(a) {
  var i = a.type;
  return i === pd.Wearable;
}, fU = function(a) {
  var i = a.type;
  return i === pd.Console;
}, pU = function(a) {
  var i = a.type;
  return i === pd.Embedded;
}, mU = function(a) {
  var i = a.vendor;
  return qo(i);
}, vU = function(a) {
  var i = a.model;
  return qo(i);
}, bU = function(a) {
  var i = a.type;
  return qo(i, "browser");
}, FU = function(a) {
  var i = a.name;
  return i === _A.Android;
}, RU = function(a) {
  var i = a.name;
  return i === _A.Windows;
}, yU = function(a) {
  var i = a.name;
  return i === _A.MAC_OS;
}, QU = function(a) {
  var i = a.name;
  return i === _A.WindowsPhone;
}, CU = function(a) {
  var i = a.name;
  return i === _A.IOS;
}, UU = function(a) {
  var i = a.version;
  return qo(i);
}, IU = function(a) {
  var i = a.name;
  return qo(i);
}, BU = function(a) {
  var i = a.name;
  return i === Kd.Chrome;
}, ZU = function(a) {
  var i = a.name;
  return i === Kd.Firefox;
}, SU = function(a) {
  var i = a.name;
  return i === Kd.Chromium;
}, Lm = function(a) {
  var i = a.name;
  return i === Kd.Edge;
}, EU = function(a) {
  var i = a.name;
  return i === Kd.Yandex;
}, VU = function(a) {
  var i = a.name;
  return i === Kd.Safari || i === Kd.MobileSafari;
}, WU = function(a) {
  var i = a.name;
  return i === Kd.MobileSafari;
}, NU = function(a) {
  var i = a.name;
  return i === Kd.Opera;
}, JU = function(a) {
  var i = a.name;
  return i === Kd.InternetExplorer || i === Kd.Ie;
}, GU = function(a) {
  var i = a.name;
  return i === Kd.MIUI;
}, TU = function(a) {
  var i = a.name;
  return i === Kd.SamsungBrowser;
}, XU = function(a) {
  var i = a.version;
  return qo(i);
}, kU = function(a) {
  var i = a.major;
  return qo(i);
}, wU = function(a) {
  var i = a.name;
  return qo(i);
}, DU = function(a) {
  var i = a.name;
  return qo(i);
}, MU = function(a) {
  var i = a.version;
  return qo(i);
}, YU = function() {
  var a = xb(), i = a && a.userAgent && a.userAgent.toLowerCase();
  return typeof i == "string" ? /electron/.test(i) : !1;
}, DA = function(a) {
  return typeof a == "string" && a.indexOf("Edg/") !== -1;
}, LU = function() {
  var a = xb();
  return a && (/iPad|iPhone|iPod/.test(a.platform) || a.platform === "MacIntel" && a.maxTouchPoints > 1) && !window.MSStream;
}, Lu = function() {
  return Hb("iPad");
}, xU = function() {
  return Hb("iPhone");
}, HU = function() {
  return Hb("iPod");
}, PU = function(a) {
  return qo(a);
};
function OU(s) {
  var a = s || cU, i = a.device, r = a.browser, e = a.os, n = a.engine, t = a.ua;
  return {
    isSmartTV: AU(i),
    isConsole: fU(i),
    isWearable: gU(i),
    isEmbedded: pU(i),
    isMobileSafari: WU(r) || Lu(),
    isChromium: SU(r),
    isMobile: hU(i) || Lu(),
    isMobileOnly: dU(i),
    isTablet: uU(i) || Lu(),
    isBrowser: Ym(i),
    isDesktop: Ym(i),
    isAndroid: FU(e),
    isWinPhone: QU(e),
    isIOS: CU(e) || Lu(),
    isChrome: BU(r),
    isFirefox: ZU(r),
    isSafari: VU(r),
    isOpera: NU(r),
    isIE: JU(r),
    osVersion: UU(e),
    osName: IU(e),
    fullBrowserVersion: XU(r),
    browserVersion: kU(r),
    browserName: wU(r),
    mobileVendor: mU(i),
    mobileModel: vU(i),
    engineName: DU(n),
    engineVersion: MU(n),
    getUA: PU(t),
    isEdge: Lm(r) || DA(t),
    isYandex: EU(r),
    deviceType: bU(i),
    isIOS13: LU(),
    isIPad13: Lu(),
    isIPhone13: xU(),
    isIPod13: HU(),
    isElectron: YU(),
    isEdgeChromium: DA(t),
    isLegacyEdge: Lm(r) && !DA(t),
    isWindows: RU(e),
    isMacOs: yU(e),
    isMIUI: GU(r),
    isSamsungBrowser: TU(r)
  };
}
var KU = AU(iu), zU = fU(iu), jU = gU(iu), y3 = pU(iu), Q3 = WU(yd) || Lu(), C3 = SU(yd), h1 = hU(iu) || Lu(), _U = dU(iu), $U = uU(iu) || Lu(), qU = Ym(iu), U3 = Ym(iu), eI = FU(rh), tI = QU(rh), nI = CU(rh) || Lu(), I3 = BU(yd), B3 = ZU(yd), Z3 = VU(yd), S3 = NU(yd), rI = JU(yd), E3 = UU(rh), V3 = IU(rh), W3 = XU(yd), N3 = kU(yd), J3 = wU(yd), G3 = mU(iu), T3 = vU(iu), X3 = DU(Lb), k3 = MU(Lb), w3 = PU(Kp), D3 = Lm(yd) || DA(Kp), M3 = EU(yd), Y3 = bU(iu), L3 = LU(), x3 = Lu(), H3 = xU(), P3 = HU(), O3 = YU(), K3 = DA(Kp), z3 = Lm(yd) && !DA(Kp), j3 = RU(rh), _3 = yU(rh), $3 = GU(yd), q3 = TU(yd), eW = function(a) {
  if (!a || typeof a != "string") {
    console.error("No valid user agent string was provided");
    return;
  }
  var i = zp(a), r = i.device, e = i.browser, n = i.os, t = i.engine, o = i.ua;
  return OU({
    device: r,
    browser: e,
    os: n,
    engine: t,
    ua: o
  });
}, tW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return eI ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, nW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return qU ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, rW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return rI ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, iW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return nI ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, oW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return h1 ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, aW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return $U ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, sW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return tI ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, lW = function(a) {
  var i = a.renderWithFragment, r = a.children;
  a.viewClassName, a.style;
  var e = Au(a, ["renderWithFragment", "children", "viewClassName", "style"]);
  return _U ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, cW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return KU ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, dW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return zU ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, uW = function(a) {
  var i = a.renderWithFragment, r = a.children, e = Au(a, ["renderWithFragment", "children"]);
  return jU ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", e, r) : null;
}, hW = function(a) {
  var i = a.renderWithFragment, r = a.children;
  a.viewClassName, a.style;
  var e = a.condition, n = Au(a, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return e ? i ? Al.createElement(Fd.Fragment, null, r) : Al.createElement("div", n, r) : null;
};
function AW(s) {
  return /* @__PURE__ */ function(a) {
    o3(i, a);
    function i(r) {
      var e;
      return t3(this, i), e = s3(this, ub(i).call(this, r)), e.isEventListenerAdded = !1, e.handleOrientationChange = e.handleOrientationChange.bind(Wm(e)), e.onOrientationChange = e.onOrientationChange.bind(Wm(e)), e.onPageLoad = e.onPageLoad.bind(Wm(e)), e.state = {
        isLandscape: !1,
        isPortrait: !1
      }, e;
    }
    return r3(i, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var e = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: e === 0,
          isLandscape: e === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window == "undefined" ? "undefined" : Zp(window)) !== void 0 && h1 && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return Al.createElement(s, db({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), i;
  }(Al.Component);
}
function gW() {
  var s = Fd.useState(function() {
    var n = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: n === 0,
      isLandscape: n === 90,
      orientation: n === 0 ? "portrait" : "landscape"
    };
  }), a = l3(s, 2), i = a[0], r = a[1], e = Fd.useCallback(function() {
    var n = window.innerWidth > window.innerHeight ? 90 : 0, t = {
      isPortrait: n === 0,
      isLandscape: n === 90,
      orientation: n === 0 ? "portrait" : "landscape"
    };
    i.orientation !== t.orientation && r(t);
  }, [i.orientation]);
  return Fd.useEffect(function() {
    return (typeof window == "undefined" ? "undefined" : Zp(window)) !== void 0 && h1 && (e(), window.addEventListener("load", e, !1), window.addEventListener("resize", e, !1)), function() {
      window.removeEventListener("resize", e, !1), window.removeEventListener("load", e, !1);
    };
  }, [e]), i;
}
function iI(s) {
  var a = s || window.navigator.userAgent;
  return zp(a);
}
function fW(s) {
  var a = s || window.navigator.userAgent, i = iI(a), r = OU(i);
  return [r, i];
}
ki.AndroidView = tW;
ki.BrowserTypes = Kd;
ki.BrowserView = nW;
ki.ConsoleView = dW;
ki.CustomView = hW;
ki.IEView = rW;
ki.IOSView = iW;
ki.MobileOnlyView = lW;
ki.MobileView = oW;
ki.OsTypes = _A;
ki.SmartTVView = cW;
ki.TabletView = aW;
ki.WearableView = uW;
ki.WinPhoneView = sW;
ki.browserName = J3;
ki.browserVersion = N3;
ki.deviceDetect = R3;
ki.deviceType = Y3;
ki.engineName = X3;
ki.engineVersion = k3;
ki.fullBrowserVersion = W3;
ki.getSelectorsByUserAgent = eW;
ki.getUA = w3;
var pW = ki.isAndroid = eI;
ki.isBrowser = qU;
ki.isChrome = I3;
ki.isChromium = C3;
ki.isConsole = zU;
ki.isDesktop = U3;
ki.isEdge = D3;
ki.isEdgeChromium = K3;
ki.isElectron = O3;
ki.isEmbedded = y3;
ki.isFirefox = B3;
ki.isIE = rI;
ki.isIOS = nI;
ki.isIOS13 = L3;
ki.isIPad13 = x3;
ki.isIPhone13 = H3;
ki.isIPod13 = P3;
ki.isLegacyEdge = z3;
ki.isMIUI = $3;
ki.isMacOs = _3;
var Sp = ki.isMobile = h1;
ki.isMobileOnly = _U;
ki.isMobileSafari = Q3;
ki.isOpera = S3;
ki.isSafari = Z3;
ki.isSamsungBrowser = q3;
ki.isSmartTV = KU;
ki.isTablet = $U;
ki.isWearable = jU;
ki.isWinPhone = tI;
ki.isWindows = j3;
ki.isYandex = M3;
ki.mobileModel = T3;
ki.mobileVendor = G3;
ki.osName = V3;
ki.osVersion = E3;
ki.parseUserAgent = zp;
ki.setUserAgent = f3;
ki.useDeviceData = iI;
ki.useDeviceSelectors = fW;
ki.useMobileOrientation = gW;
ki.withOrientationChange = AW;
const mW = {
  tooltip: Xl`
    .hero-tooltip_baloon {
      padding: 8px;
      height: fit-content;
      font-size: 12px;
    }

    .hero-tooltip_root {
      margin: 0 !important;
      z-index: auto;
    }
  `
}, vW = zA({
  root: (s, {
    isMiniMode: a,
    isMobile: i
  }) => Xl`
    width: 100%;
    padding: ${a ? "0" : "6px"};

    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${a ? "12px" : "24px"};

    position: ${a ? "absolute" : "relative"};
    z-index: 10;
    bottom: ${a || i ? "10px" : "0"};
    /* left: 50%; */
    /* transform: translate(-50%, 0%); */

    .hero-tooltip_root {
      margin: 0 !important;
    }

    ${a && mW.tooltip}
  `,
  actionButton: ({
    colors: s
  }, {
    isMiniMode: a
  }) => Xl`
    background: ${s.neutral[300]};
    border: none;
    color: ${s.background.white};
    cursor: pointer;

    width: ${a ? "38px" : "48px"};
    height: ${a ? "38px" : "48px"};

    ${a && Xl`
      svg {
        width: 22px;
      }
    `}

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    svg {
      fill: ${s.background.white};
    }

    &:hover {
      background: ${s.neutral[300]};
    }

    &:disabled {
      background: ${s.neutral[400]};

      color: ${s.neutral[200]};

      svg {
        fill: ${s.neutral[200]};
      }
    }
  `,
  endCall: ({
    colors: s
  }) => Xl`
    background: ${s.feedback.error[300]};

    &:hover {
      background: ${s.feedback.error[300]};
    }

    &:disabled {
      background: ${s.feedback.error[500]};

      color: ${s.neutral[200]};

      svg {
        fill: ${s.neutral[200]};
      }
    }
  `,
  actionOff: ({
    colors: s
  }) => Xl`
    background: ${s.background.white};
    color: ${s.neutral[300]};
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.1));

    svg {
      fill: ${s.neutral[300]};
    }

    &:hover {
      background: ${s.neutral[100]};
    }
  `,
  leftAction: Xl``
}), Cu = qh((s) => ({
  defaultSettings: {
    publishAudio: !0,
    publishVideo: !0,
    videoEffects: !1,
    audioSource: "",
    videoSource: "",
    audioOutputSource: ""
  },
  room: null,
  updateUser: (a) => s((i) => ({
    defaultSettings: {
      ...i.defaultSettings,
      ...a
    }
  })),
  setRoom: (a) => {
    s(() => ({
      room: a
    }));
  }
}));
function uv() {
  if (typeof document.fullscreenElement != "undefined")
    return "fullscreenElement";
  if (typeof document.mozFullScreenElement != "undefined")
    return "mozFullScreenElement";
  if (typeof document.msFullscreenElement != "undefined")
    return "msFullscreenElement";
  if (typeof document.webkitFullscreenElement != "undefined")
    return "webkitFullscreenElement";
  console.warn("fullscreenElement is not supported by this browser");
}
function bW() {
  const s = m0((t) => t.dispatch), [a, i] = Tl(
    // @ts-ignore
    document[uv()] != null
  ), r = document.body, e = () => {
    r != null && r.requestFullscreen().then(() => {
      i(document[uv()] != null), s({
        type: "changeFullscreen",
        message: "fullscreen-on"
      });
    }).catch(() => {
      i(!1);
    });
  }, n = () => {
    i(!1), document.exitFullscreen(), s({
      type: "changeFullscreen",
      message: "fullscreen-off"
    });
  };
  return _F(() => (document.onfullscreenchange = () => (
    // @ts-ignore
    i(document[uv()] != null)
  ), () => document.onfullscreenchange = void 0), []), _F(() => () => {
    a && n();
  }, [a]), {
    isFullscreen: a,
    handleOpenFullscren: e,
    handleExitFullscreen: n
  };
}
function FW() {
  const s = Cu((o) => o.room), [a, i] = Tl(null), [r, e] = Tl(null), n = Gc(async () => {
    if (s)
      try {
        const {
          screen: o
        } = s;
        o.on("started", () => {
          i(o), e(!0);
        }), o.on("stopped", () => {
          i(null), e(!1);
        }), await s.startScreensharing();
      } catch (o) {
        console.error("[useScreensharing] - startScreenSharing error:", o);
      }
  }, [s]), t = Gc(() => {
    s && (s.stopScreensharing(), e(!1));
  }, [s]);
  return {
    screen: a,
    isScreenSharing: r,
    startScreenSharing: n,
    stopScreenSharing: t
  };
}
const oI = () => {
  const s = Cu((i) => i.room);
  return Gc(async ({
    data: i,
    type: r
  }) => {
    if (s)
      try {
        await s.signal({
          data: i,
          type: r
        });
      } catch (e) {
        console.warn(e);
      }
  }, [s]);
}, RW = (s, a) => {
  const {
    data: i
  } = XE({
    queryKey: ["call-status", s],
    queryFn: async () => await Xp.getCallStatus(s, a),
    enabled: !!s
  });
  return {
    data: i
  };
}, yW = () => kE({
  mutationFn: async ({
    participants: a,
    sessionId: i,
    onunload: r,
    env: e
  }) => {
    await Xp.removeParticipants(a, i, r, e);
  },
  retry: 0
}), Pb = () => {
  const s = KA(aU);
  if (!s)
    throw new Error("useMeetContext must be used within a MeetProvider");
  return s;
}, wp = qh((s) => ({
  open: !1,
  toggle: () => {
    s((a) => ({
      open: !a.open
    }));
  },
  close: () => {
    s(() => ({
      open: !1
    }));
  },
  handleOpen: () => {
    s(() => ({
      open: !0
    }));
  }
})), QW = (s) => {
  const a = Cu((W) => W.room), i = Cu((W) => W.defaultSettings), r = oI(), e = yW(), n = wp((W) => W.open), t = wp((W) => W.toggle), {
    meetSettings: o,
    env: l,
    onFinishMeet: c
  } = Pb(), {
    isFullscreen: d,
    handleExitFullscreen: u,
    handleOpenFullscren: h
  } = bW(), {
    isScreenSharing: A,
    startScreenSharing: g,
    stopScreenSharing: f
  } = FW(), [p, v] = Tl(i == null ? void 0 : i.publishAudio), [b, m] = Tl(i == null ? void 0 : i.publishVideo), [y, U] = Tl(!1), B = Gc(async () => {
    await e.mutateAsync({
      participants: s == null ? void 0 : s.participants,
      sessionId: o == null ? void 0 : o.sessionId,
      env: l
    });
  }, [l, o == null ? void 0 : o.sessionId, s == null ? void 0 : s.participants, e]);
  return {
    hasAudio: p,
    hasVideo: b,
    toggleAudio: () => {
      if (a && a.camera) {
        const W = a.camera;
        W.isAudioEnabled() ? (W.disableAudio(), v(!1), s != null && s.stopRecognition && (s == null || s.stopRecognition())) : (W.enableAudio(), v(!0), s != null && s.startRecognition && (s == null || s.startRecognition()));
      }
    },
    toggleVideo: () => {
      if (a && a.camera) {
        const {
          camera: W
        } = a;
        W.isVideoEnabled() ? (W.disableVideo(), m(!1)) : (W.enableVideo(), m(!0));
      }
    },
    dispatchAttachment: () => {
      const W = window.ReactNativeWebView;
      W && W.postMessage(JSON.stringify({
        key: "attachment"
      }));
    },
    isFullscreen: d,
    isLoadingFinishMeet: y,
    handleExitFullscreen: u,
    handleOpenFullscren: h,
    isScreenSharing: A,
    startScreenSharing: g,
    stopScreenSharing: f,
    exitRoom: async () => {
      var W;
      a && a.camera && (U(!0), c && await c(), await B(), U(!1), r({
        data: "END_CALL",
        type: "meet"
      }), (W = s == null ? void 0 : s.stopRecognition) == null || W.call(s), a == null || a.leave(), a == null || a.removeAllListeners());
    },
    isOpenChat: n,
    toggleChat: t
  };
};
var qn = function() {
  return qn = Object.assign || function(a) {
    for (var i, r = 1, e = arguments.length; r < e; r++) {
      i = arguments[r];
      for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (a[n] = i[n]);
    }
    return a;
  }, qn.apply(this, arguments);
};
function CW(s, a) {
  var i = {};
  for (var r in s) Object.prototype.hasOwnProperty.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && typeof Object.getOwnPropertySymbols == "function")
    for (var e = 0, r = Object.getOwnPropertySymbols(s); e < r.length; e++)
      a.indexOf(r[e]) < 0 && Object.prototype.propertyIsEnumerable.call(s, r[e]) && (i[r[e]] = s[r[e]]);
  return i;
}
var UW = or(function() {
  return Promise.resolve().then(function() {
    return O9;
  });
}), IW = or(function() {
  return Promise.resolve().then(function() {
    return z9;
  });
}), BW = or(function() {
  return Promise.resolve().then(function() {
    return _9;
  });
}), ZW = or(function() {
  return Promise.resolve().then(function() {
    return q9;
  });
}), SW = or(function() {
  return Promise.resolve().then(function() {
    return tN;
  });
}), EW = or(function() {
  return Promise.resolve().then(function() {
    return rN;
  });
}), VW = or(function() {
  return Promise.resolve().then(function() {
    return oN;
  });
}), WW = or(function() {
  return Promise.resolve().then(function() {
    return sN;
  });
}), NW = or(function() {
  return Promise.resolve().then(function() {
    return cN;
  });
}), JW = or(function() {
  return Promise.resolve().then(function() {
    return uN;
  });
}), GW = or(function() {
  return Promise.resolve().then(function() {
    return AN;
  });
}), TW = or(function() {
  return Promise.resolve().then(function() {
    return fN;
  });
}), XW = or(function() {
  return Promise.resolve().then(function() {
    return mN;
  });
}), kW = or(function() {
  return Promise.resolve().then(function() {
    return bN;
  });
}), wW = or(function() {
  return Promise.resolve().then(function() {
    return RN;
  });
}), DW = or(function() {
  return Promise.resolve().then(function() {
    return QN;
  });
}), MW = or(function() {
  return Promise.resolve().then(function() {
    return UN;
  });
}), YW = or(function() {
  return Promise.resolve().then(function() {
    return BN;
  });
}), LW = or(function() {
  return Promise.resolve().then(function() {
    return SN;
  });
}), xW = or(function() {
  return Promise.resolve().then(function() {
    return VN;
  });
}), HW = or(function() {
  return Promise.resolve().then(function() {
    return NN;
  });
}), PW = or(function() {
  return Promise.resolve().then(function() {
    return GN;
  });
}), OW = or(function() {
  return Promise.resolve().then(function() {
    return XN;
  });
}), KW = or(function() {
  return Promise.resolve().then(function() {
    return wN;
  });
}), zW = or(function() {
  return Promise.resolve().then(function() {
    return MN;
  });
}), jW = or(function() {
  return Promise.resolve().then(function() {
    return LN;
  });
}), _W = or(function() {
  return Promise.resolve().then(function() {
    return _J;
  });
}), $W = or(function() {
  return Promise.resolve().then(function() {
    return HN;
  });
}), qW = or(function() {
  return Promise.resolve().then(function() {
    return ON;
  });
}), e5 = or(function() {
  return Promise.resolve().then(function() {
    return zN;
  });
}), t5 = or(function() {
  return Promise.resolve().then(function() {
    return _N;
  });
}), n5 = or(function() {
  return Promise.resolve().then(function() {
    return qN;
  });
}), r5 = or(function() {
  return Promise.resolve().then(function() {
    return tJ;
  });
}), i5 = or(function() {
  return Promise.resolve().then(function() {
    return rJ;
  });
}), o5 = or(function() {
  return Promise.resolve().then(function() {
    return oJ;
  });
}), a5 = or(function() {
  return Promise.resolve().then(function() {
    return sJ;
  });
}), s5 = or(function() {
  return Promise.resolve().then(function() {
    return cJ;
  });
}), l5 = or(function() {
  return Promise.resolve().then(function() {
    return uJ;
  });
}), c5 = or(function() {
  return Promise.resolve().then(function() {
    return AJ;
  });
}), d5 = or(function() {
  return Promise.resolve().then(function() {
    return fJ;
  });
}), u5 = or(function() {
  return Promise.resolve().then(function() {
    return mJ;
  });
}), h5 = or(function() {
  return Promise.resolve().then(function() {
    return bJ;
  });
}), A5 = or(function() {
  return Promise.resolve().then(function() {
    return RJ;
  });
}), g5 = or(function() {
  return Promise.resolve().then(function() {
    return QJ;
  });
}), f5 = or(function() {
  return Promise.resolve().then(function() {
    return UJ;
  });
}), p5 = or(function() {
  return Promise.resolve().then(function() {
    return BJ;
  });
}), m5 = or(function() {
  return Promise.resolve().then(function() {
    return SJ;
  });
}), v5 = or(function() {
  return Promise.resolve().then(function() {
    return VJ;
  });
}), b5 = or(function() {
  return Promise.resolve().then(function() {
    return NJ;
  });
}), F5 = or(function() {
  return Promise.resolve().then(function() {
    return GJ;
  });
}), R5 = or(function() {
  return Promise.resolve().then(function() {
    return XJ;
  });
}), y5 = or(function() {
  return Promise.resolve().then(function() {
    return wJ;
  });
}), Q5 = or(function() {
  return Promise.resolve().then(function() {
    return MJ;
  });
}), C5 = or(function() {
  return Promise.resolve().then(function() {
    return LJ;
  });
}), U5 = or(function() {
  return Promise.resolve().then(function() {
    return HJ;
  });
}), I5 = or(function() {
  return Promise.resolve().then(function() {
    return OJ;
  });
}), B5 = or(function() {
  return Promise.resolve().then(function() {
    return zJ;
  });
}), Z5 = or(function() {
  return Promise.resolve().then(function() {
    return tX;
  });
}), S5 = or(function() {
  return Promise.resolve().then(function() {
    return rX;
  });
}), E5 = or(function() {
  return Promise.resolve().then(function() {
    return oX;
  });
}), V5 = or(function() {
  return Promise.resolve().then(function() {
    return sX;
  });
}), W5 = or(function() {
  return Promise.resolve().then(function() {
    return cX;
  });
}), N5 = or(function() {
  return Promise.resolve().then(function() {
    return uX;
  });
}), J5 = or(function() {
  return Promise.resolve().then(function() {
    return AX;
  });
}), G5 = or(function() {
  return Promise.resolve().then(function() {
    return fX;
  });
}), T5 = or(function() {
  return Promise.resolve().then(function() {
    return mX;
  });
}), X5 = or(function() {
  return Promise.resolve().then(function() {
    return bX;
  });
}), k5 = or(function() {
  return Promise.resolve().then(function() {
    return RX;
  });
}), w5 = or(function() {
  return Promise.resolve().then(function() {
    return QX;
  });
}), D5 = or(function() {
  return Promise.resolve().then(function() {
    return UX;
  });
}), M5 = or(function() {
  return Promise.resolve().then(function() {
    return BX;
  });
}), Y5 = or(function() {
  return Promise.resolve().then(function() {
    return SX;
  });
}), L5 = or(function() {
  return Promise.resolve().then(function() {
    return qJ;
  });
}), x5 = or(function() {
  return Promise.resolve().then(function() {
    return tG;
  });
}), H5 = or(function() {
  return Promise.resolve().then(function() {
    return rG;
  });
}), P5 = or(function() {
  return Promise.resolve().then(function() {
    return oG;
  });
}), O5 = or(function() {
  return Promise.resolve().then(function() {
    return sG;
  });
}), K5 = or(function() {
  return Promise.resolve().then(function() {
    return cG;
  });
}), z5 = or(function() {
  return Promise.resolve().then(function() {
    return uG;
  });
}), j5 = or(function() {
  return Promise.resolve().then(function() {
    return AG;
  });
}), _5 = or(function() {
  return Promise.resolve().then(function() {
    return fG;
  });
}), $5 = or(function() {
  return Promise.resolve().then(function() {
    return mG;
  });
}), q5 = or(function() {
  return Promise.resolve().then(function() {
    return bG;
  });
}), e9 = or(function() {
  return Promise.resolve().then(function() {
    return RG;
  });
}), t9 = or(function() {
  return Promise.resolve().then(function() {
    return QG;
  });
}), n9 = or(function() {
  return Promise.resolve().then(function() {
    return UG;
  });
}), r9 = or(function() {
  return Promise.resolve().then(function() {
    return BG;
  });
}), i9 = or(function() {
  return Promise.resolve().then(function() {
    return SG;
  });
}), o9 = or(function() {
  return Promise.resolve().then(function() {
    return VG;
  });
}), a9 = or(function() {
  return Promise.resolve().then(function() {
    return NG;
  });
}), s9 = or(function() {
  return Promise.resolve().then(function() {
    return GG;
  });
}), l9 = or(function() {
  return Promise.resolve().then(function() {
    return XG;
  });
}), c9 = or(function() {
  return Promise.resolve().then(function() {
    return wG;
  });
}), d9 = or(function() {
  return Promise.resolve().then(function() {
    return MG;
  });
}), u9 = or(function() {
  return Promise.resolve().then(function() {
    return LG;
  });
}), h9 = or(function() {
  return Promise.resolve().then(function() {
    return HG;
  });
}), A9 = or(function() {
  return Promise.resolve().then(function() {
    return OG;
  });
}), g9 = or(function() {
  return Promise.resolve().then(function() {
    return zG;
  });
}), f9 = or(function() {
  return Promise.resolve().then(function() {
    return _G;
  });
}), p9 = or(function() {
  return Promise.resolve().then(function() {
    return qG;
  });
}), m9 = or(function() {
  return Promise.resolve().then(function() {
    return tT;
  });
}), v9 = or(function() {
  return Promise.resolve().then(function() {
    return rT;
  });
}), b9 = or(function() {
  return Promise.resolve().then(function() {
    return oT;
  });
}), F9 = or(function() {
  return Promise.resolve().then(function() {
    return sT;
  });
}), R9 = or(function() {
  return Promise.resolve().then(function() {
    return cT;
  });
}), y9 = or(function() {
  return Promise.resolve().then(function() {
    return uT;
  });
}), Q9 = or(function() {
  return Promise.resolve().then(function() {
    return AT;
  });
}), C9 = or(function() {
  return Promise.resolve().then(function() {
    return fT;
  });
}), U9 = or(function() {
  return Promise.resolve().then(function() {
    return mT;
  });
}), I9 = or(function() {
  return Promise.resolve().then(function() {
    return bT;
  });
}), B9 = or(function() {
  return Promise.resolve().then(function() {
    return RT;
  });
}), Z9 = or(function() {
  return Promise.resolve().then(function() {
    return QT;
  });
}), S9 = or(function() {
  return Promise.resolve().then(function() {
    return UT;
  });
}), E9 = or(function() {
  return Promise.resolve().then(function() {
    return BT;
  });
}), V9 = or(function() {
  return Promise.resolve().then(function() {
    return ST;
  });
}), W9 = or(function() {
  return Promise.resolve().then(function() {
    return VT;
  });
}), N9 = or(function() {
  return Promise.resolve().then(function() {
    return NT;
  });
}), J9 = or(function() {
  return Promise.resolve().then(function() {
    return GT;
  });
}), G9 = or(function() {
  return Promise.resolve().then(function() {
    return XT;
  });
}), T9 = or(function() {
  return Promise.resolve().then(function() {
    return wT;
  });
}), X9 = or(function() {
  return Promise.resolve().then(function() {
    return MT;
  });
}), k9 = or(function() {
  return Promise.resolve().then(function() {
    return LT;
  });
}), w9 = or(function() {
  return Promise.resolve().then(function() {
    return HT;
  });
}), D9 = or(function() {
  return Promise.resolve().then(function() {
    return OT;
  });
}), M9 = or(function() {
  return Promise.resolve().then(function() {
    return zT;
  });
}), Y9 = or(function() {
  return Promise.resolve().then(function() {
    return _T;
  });
}), L9 = or(function() {
  return Promise.resolve().then(function() {
    return qT;
  });
}), x9 = {
  "arrow-down": UW,
  "arrow-left": IW,
  "arrow-right": BW,
  "arrow-up": ZW,
  back: SW,
  "left-arrow-circle": EW,
  up: VW,
  add: WW,
  bullet: NW,
  calendar: JW,
  check: GW,
  clip: TW,
  clock: XW,
  "close-circle": kW,
  close: wW,
  copy: DW,
  download: MW,
  edit: YW,
  email: LW,
  exit: xW,
  "eye-off": HW,
  "eye-on": PW,
  fail: OW,
  "filter-close": KW,
  filter: zW,
  flag: jW,
  group: _W,
  home: $W,
  image: qW,
  information: e5,
  "item-documents-files": t5,
  key: n5,
  lock: r5,
  menu: i5,
  minus: o5,
  more: a5,
  notification: s5,
  plus: l5,
  print: c5,
  "question-checkmark-circle": d5,
  question: u5,
  refresh: h5,
  search: A5,
  "send-share": g5,
  settings: f5,
  star: p5,
  success: m5,
  support: v5,
  "time-zone": b5,
  trash: F5,
  unlock: R5,
  upload: y5,
  user: Q5,
  warning: C5,
  wifi: U5,
  overflow: I5,
  "plus-circle": B5,
  brain: Z5,
  "card-edit": S5,
  "doctor-talk": E5,
  folder: V5,
  heartbeat: W5,
  hospital: N5,
  mask: J5,
  "medical-certificate": G5,
  "medical-cross": T5,
  notes: X5,
  pill: k5,
  "scale-weight": w5,
  "shield-heart": D5,
  stethoscope: M5,
  syringe: Y5,
  audio: L5,
  "camera-off": x5,
  "camera-on": H5,
  fullscreen: P5,
  "microphone-off": O5,
  "microphone-on": K5,
  minimize: z5,
  miniplayer: j5,
  "phone-on": _5,
  rotate: $5,
  "share-screen": q5,
  book: e9,
  "browser-video-player": t9,
  chart: n9,
  chat: r9,
  "clipboard-saved": i9,
  clipboard: o9,
  "credit-card": a9,
  dashboard: s9,
  "document-atestado": l9,
  "face-id": c9,
  "file-check": d9,
  "file-error": u9,
  "file-exams": h9,
  file: A9,
  "file-image": g9,
  "file-pdf": f9,
  "file-text": p9,
  "file-warning-error": m9,
  "file-crossed": v9,
  "filter-cross-delete": b9,
  "file-warning": F9,
  "user-error": R9,
  "font-bold": y9,
  "font-italic": Q9,
  "font-underline": C9,
  frame: U9,
  "icon-share": I9,
  identity: B9,
  "justify-center": Z9,
  "justify-left": S9,
  "medical-cross-fast-help-circle": E9,
  mobile: V9,
  "paragraph-list": W9,
  "paragraph-number": N9,
  receipt: J9,
  "select-all": G9,
  send: T9,
  "settings-handles": X9,
  "signin-send-share": k9,
  "receipt-bullet": w9,
  analytics: D9,
  "document-calculator": M9,
  "profile-checkmark": Y9,
  "hand-key": L9
}, Nm = function(s) {
  var a = s.name, i = s.size, r = s.color, e = s.onClick, n = CW(s, ["name", "size", "color", "onClick"]), t = Oh(function() {
    if (!a)
      throw new Error("Icon name was not provided");
    return a;
  }, [a]), o = x9[t];
  return We(QE, qn({ fallback: We("span", { className: "icon-on-suspense" }) }, { children: We(o, qn({ color: r, onClick: e, size: i }, n)) }));
}, H9 = {
  "x-small": 14,
  small: 16,
  medium: 24,
  large: 32
}, ar = function(s) {
  return H9[s || "medium"];
}, P9 = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.231 9.24a.77.77 0 0 1 1.117 0L12 13.025l3.652-3.785a.77.77 0 0 1 1.117 0 .84.84 0 0 1 0 1.157l-4.21 4.363a.77.77 0 0 1-1.117 0l-4.21-4.363a.84.84 0 0 1 0-1.157Z", fill: "currentColor" }) }));
}, O9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: P9
}), K9 = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.76 7.231a.77.77 0 0 1 0 1.117L10.975 12l3.785 3.652a.77.77 0 0 1 0 1.117.84.84 0 0 1-1.157 0l-4.363-4.21a.77.77 0 0 1 0-1.117l4.363-4.21a.84.84 0 0 1 1.157 0Z", fill: "currentColor" }) }));
}, z9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: K9
}), j9 = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.24 7.231a.84.84 0 0 1 1.157 0l4.363 4.21a.77.77 0 0 1 0 1.117l-4.363 4.21a.84.84 0 0 1-1.157 0 .77.77 0 0 1 0-1.116L13.025 12 9.24 8.348a.77.77 0 0 1 0-1.117Z", fill: "currentColor" }) }));
}, _9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: j9
}), $9 = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.442 9.24a.77.77 0 0 1 1.116 0l4.21 4.363a.84.84 0 0 1 0 1.157.77.77 0 0 1-1.116 0L12 10.975 8.348 14.76a.77.77 0 0 1-1.117 0 .84.84 0 0 1 0-1.157l4.21-4.363Z", fill: "currentColor" }) }));
}, q9 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $9
}), eN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.53 6.47a.75.75 0 0 1 0 1.06l-3.72 3.72H19a.75.75 0 0 1 0 1.5H6.81l3.72 3.72a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }) }));
}, tN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: eN
}), nN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.949A7.05 7.05 0 0 0 2.95 10 7.05 7.05 0 0 0 10 17.051 7.05 7.05 0 0 0 17.052 10 7.05 7.05 0 0 0 10 2.949Zm0 15.384A8.333 8.333 0 0 1 1.667 10 8.333 8.333 0 0 1 10 1.667 8.333 8.333 0 0 1 18.334 10 8.333 8.333 0 0 1 10 18.333Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.94 10c0-.354.287-.641.641-.641h6.838a.641.641 0 0 1 0 1.282H6.581a.641.641 0 0 1-.64-.641Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.599 6.983c.25.25.25.656 0 .906L7.488 10l2.11 2.112a.641.641 0 1 1-.906.906l-2.564-2.564a.641.641 0 0 1 0-.906l2.564-2.564c.25-.25.656-.25.907 0Z", fill: s.color })] }));
}, rN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nN
}), iN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.48 10.48a.75.75 0 0 1-1.06 0L12.7 6.76v12.19a.75.75 0 0 1-1.5 0V6.76l-3.72 3.72a.75.75 0 1 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06Z", fill: "currentColor" }) }));
}, oN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iN
}), aN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 15.25a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5V.75a.75.75 0 0 0-1.5 0v6.5H.75a.75.75 0 0 0 0 1.5h6.5v6.5Z", fill: "currentColor" }) }));
}, sN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aN
}), lN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.243 7.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486Z", fill: "currentColor" }) }));
}, cN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lN
}), dN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.999A3.749 3.749 0 0 1 5.999 2.25H18a3.749 3.749 0 0 1 3.749 3.749V18a3.749 3.749 0 0 1-3.749 3.749H6a3.749 3.749 0 0 1-3.749-3.749V6Zm3.749-2.25A2.25 2.25 0 0 0 3.749 6V18A2.25 2.25 0 0 0 6 20.251H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.749H6Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8A.75.75 0 0 1 3 7.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8ZM17.805 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 10.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 11.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 14.45ZM10.803 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM14.304 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM17.805 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM17.805 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 17.45Z", fill: "currentColor" })] }));
}, uN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dN
}), hN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.774 5.728a.786.786 0 0 1 0 1.104L9.46 18.272a.765.765 0 0 1-1.091 0l-5.143-5.2a.786.786 0 0 1 0-1.103.765.765 0 0 1 1.09 0l4.598 4.648 10.77-10.889a.765.765 0 0 1 1.09 0Z", fill: "currentColor" }) }));
}, AN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hN
}), gN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6 3.605a4.629 4.629 0 1 1 6.547 6.546l-7.232 7.232a2.866 2.866 0 0 1-4.052-4.052l5.486-5.486a.75.75 0 1 1 1.06 1.06l-5.486 5.486a1.366 1.366 0 0 0 1.932 1.932l7.232-7.232a3.13 3.13 0 1 0-4.426-4.426L6.43 11.897a4.892 4.892 0 1 0 6.92 6.92l4.389-4.39a.75.75 0 1 1 1.06 1.061l-4.389 4.39a6.392 6.392 0 0 1-9.04 0 6.392 6.392 0 0 1 0-9.041L12.6 3.605Z", fill: "currentColor" }) }));
}, fN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gN
}), pN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.613 12.618c0-.425.345-.77.77-.77h4.769a.769.769 0 0 1 0 1.539h-4.77a.769.769 0 0 1-.769-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.382 6.103c.425 0 .77.344.77.769v5.746a.769.769 0 1 1-1.539 0V6.872c0-.425.345-.77.77-.77Z", fill: "currentColor" })] }));
}, mN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pN
}), vN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.298 5.702c.2.2.2.525 0 .726l-3.87 3.87a.513.513 0 0 1-.726-.725l3.87-3.87c.2-.2.526-.2.726 0Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.702 5.702c.2-.2.525-.2.726 0l3.87 3.87a.513.513 0 0 1-.725.726l-3.87-3.87c-.2-.2-.2-.525 0-.726Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.36a5.64 5.64 0 1 0 0 11.28A5.64 5.64 0 0 0 8 2.36ZM1.333 8a6.666 6.666 0 1 1 13.334 0A6.666 6.666 0 1 1 1.334 8Z", fill: s.color })] }));
}, bN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vN
}), FN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.277 6.277c.37-.37.97-.37 1.34 0l10.105 10.106a.947.947 0 1 1-1.34 1.34L6.278 7.617a.947.947 0 0 1 0-1.34Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.723 6.277c.37.37.37.97 0 1.34L7.617 17.722a.947.947 0 1 1-1.34-1.34L16.383 6.278c.37-.37.97-.37 1.34 0Z", fill: "currentColor" })] }));
}, RN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FN
}), yN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.103 8.922a2.82 2.82 0 0 1 2.82-2.82H19.18A2.82 2.82 0 0 1 22 8.923v10.259A2.82 2.82 0 0 1 19.18 22H8.923a2.82 2.82 0 0 1-2.82-2.82V8.923Zm2.82-1.281c-.709 0-1.282.573-1.282 1.281v10.259c0 .707.573 1.281 1.281 1.281h10.259c.707 0 1.281-.574 1.281-1.281V8.922c0-.708-.574-1.281-1.281-1.281H8.922Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.82 3.538c-.708 0-1.282.574-1.282 1.282v10.257c0 .708.574 1.282 1.282 1.282h2.052a.769.769 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 15.077V4.82A2.82 2.82 0 0 1 4.82 2h10.257a2.82 2.82 0 0 1 2.82 2.82v2.052a.769.769 0 0 1-1.538 0V4.82c0-.708-.574-1.282-1.282-1.282H4.82Z", fill: "currentColor" })] }));
}, QN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yN
}), CN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061L8.25 13.19V1A.75.75 0 0 1 9 .25ZM.25 19a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 19Z", fill: "currentColor" }) }));
}, UN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CN
}), IN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.834 3.622c-.71 0-1.296.612-1.296 1.381v13.994c0 .768.586 1.381 1.296 1.381h14.332c.71 0 1.296-.613 1.296-1.381v-6.384c0-.448.344-.81.769-.81.425 0 .769.362.769.81v6.384C22 20.65 20.737 22 19.166 22H4.834C3.264 22 2 20.65 2 18.997V5.003C2 3.35 3.263 2 4.834 2H12c.425 0 .77.363.77.81 0 .449-.345.812-.77.812H4.834Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.009 2.871a2.719 2.719 0 0 1 3.988 0l.177.186c1.101 1.16 1.101 3.043 0 4.204l-8.605 9.07-.003.002a1.78 1.78 0 0 1-.832.496l-3.812 1.005a.751.751 0 0 1-.745-.21.835.835 0 0 1-.199-.785l.954-4.018c.079-.333.242-.637.472-.88l8.605-9.07Zm-8.23 13.065 2.582-.68a.26.26 0 0 0 .121-.073l8.604-9.069c.5-.527.5-1.383 0-1.91l-.176-.186a1.236 1.236 0 0 0-1.813 0l-8.605 9.07a.276.276 0 0 0-.068.126l-.646 2.722Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.384 4.583a.742.742 0 0 1 1.088 0l3.077 3.244c.3.316.3.83 0 1.146a.742.742 0 0 1-1.088 0L15.385 5.73a.842.842 0 0 1 0-1.147ZM8.616 12.22c.08-.011.24-.035.387-.035 1.841 0 3.333 1.573 3.333 3.513 0 .161-.022.325-.034.415a2.576 2.576 0 0 0-.005.039c-.056.444-.442.756-.863.697-.421-.058-.718-.466-.662-.91l.012-.094c.01-.08.014-.11.014-.147 0-1.045-.803-1.892-1.795-1.892a.633.633 0 0 0-.103.01l-.133.02c-.421.054-.805-.263-.857-.707-.051-.444.249-.849.67-.903l.036-.006Z", fill: "currentColor" })] }));
}, BN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: IN
}), ZN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 6.8A2.543 2.543 0 0 1 4.8 4.25h14.4a2.543 2.543 0 0 1 2.547 2.68.75.75 0 0 1 .003.07v10A2.756 2.756 0 0 1 19 19.75H5A2.756 2.756 0 0 1 2.25 17V7c0-.024.001-.047.003-.07a2.55 2.55 0 0 1-.003-.13Zm1.5 2.374V17c0 .06.004.119.013.177l4.748-4.75L3.75 9.175Zm6.39 2.55a.77.77 0 0 0-.072-.05l-5.82-3.976c-.357-.293-.498-.589-.498-.898 0-.586.464-1.05 1.05-1.05h14.4c.586 0 1.05.464 1.05 1.05 0 .312-.14.62-.466 1.042l-5.827 3.885a.65.65 0 0 0-.025.017l-.043.028c-1.149.736-2.525.737-3.675.003l-.074-.051Zm-.344 1.54-4.973 4.973c.058.009.117.013.177.013h14c.06 0 .119-.004.177-.013l-4.94-4.939a4.81 4.81 0 0 1-4.44-.034Zm5.741-.787 4.7 4.7c.009-.058.013-.117.013-.177V9.335l-4.713 3.142Z", fill: "currentColor" }) }));
}, SN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ZN
}), EN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.825 12a.77.77 0 0 1 .77-.77h5.135a.77.77 0 1 1 0 1.538h-5.135a.77.77 0 0 1-.77-.768Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.131 9.405c.301-.3.789-.3 1.09 0l2.053 2.051c.301.3.301.787 0 1.087l-2.054 2.052c-.3.3-.788.3-1.089 0-.3-.3-.3-.788 0-1.088L19.641 12l-1.51-1.508c-.3-.3-.3-.787 0-1.087Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.324 3.538c-.71 0-1.284.574-1.284 1.282v14.36c0 .708.574 1.282 1.284 1.282H17.65c.71 0 1.284-.574 1.284-1.283v-2.051a.77.77 0 0 1 1.54 0v2.051A2.822 2.822 0 0 1 17.649 22H5.324A2.822 2.822 0 0 1 2.5 19.18V4.82A2.822 2.822 0 0 1 5.324 2H17.65a2.822 2.822 0 0 1 2.824 2.82v2.051a.77.77 0 0 1-1.54 0v-2.05c0-.71-.575-1.283-1.284-1.283H5.324Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.405 10.205a.77.77 0 0 1 .77.769v2.051a.77.77 0 0 1-1.54 0v-2.051a.77.77 0 0 1 .77-.769Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.486 2a.77.77 0 0 1 .77.769v14.355c0 1.069-.604 2.044-1.56 2.523l-4.11 2.052c-1.876.937-4.086-.427-4.086-2.523a.77.77 0 0 1 1.54 0 1.284 1.284 0 0 0 1.858 1.147l4.107-2.05c.437-.22.711-.663.711-1.15V2.77a.77.77 0 0 1 .77-.769Z", fill: "currentColor" })] }));
}, VN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: EN
}), WN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.714 18.435a.768.768 0 0 1 .995-.442c.766.298 1.536.459 2.291.459.425 0 .77.346.77.774A.772.772 0 0 1 12 20c-.972 0-1.931-.207-2.846-.563a.776.776 0 0 1-.44-1.002Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.476 11.802a.777.777 0 0 1 .31 1.05c-1.016 1.892-2.465 3.664-4.144 4.97C15.967 19.123 14.014 20 12 20a.772.772 0 0 1-.77-.774c0-.428.345-.774.77-.774 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.767.767 0 0 1 1.043-.313Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.761 8.233a.766.766 0 0 1 1.085.086 16.398 16.398 0 0 1 1.94 2.83c.285.53.285 1.173 0 1.702a.766.766 0 0 1-1.041.313.777.777 0 0 1-.312-1.05.245.245 0 0 0 0-.228 14.858 14.858 0 0 0-1.757-2.562.778.778 0 0 1 .085-1.091ZM19.724 4.227c.3.302.3.792 0 1.095L5.364 19.773a.766.766 0 0 1-1.088 0 .778.778 0 0 1 0-1.095l14.36-14.451a.766.766 0 0 1 1.088 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.741 10.248a2.45 2.45 0 0 0-3.481 0 2.49 2.49 0 0 0 0 3.503c.3.303.3.793 0 1.095a.766.766 0 0 1-1.088 0 4.045 4.045 0 0 1 0-5.693 3.983 3.983 0 0 1 5.657 0c.3.302.3.792 0 1.095a.766.766 0 0 1-1.088 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.358 6.179C8.033 4.876 9.986 4 12 4c2.014 0 3.97.877 5.644 2.181a.778.778 0 0 1 .138 1.086.766.766 0 0 1-1.08.139C15.205 6.238 13.573 5.548 12 5.548c-1.57 0-3.202.69-4.701 1.856-1.495 1.163-2.809 2.763-3.732 4.482a.245.245 0 0 0 0 .23c.923 1.718 2.236 3.316 3.73 4.48a.778.778 0 0 1 .138 1.085.766.766 0 0 1-1.08.14c-1.676-1.307-3.125-3.077-4.142-4.97a1.805 1.805 0 0 1 0-1.7C3.23 9.256 4.679 7.483 6.358 6.178Z", fill: "currentColor" })] }));
}, NN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: WN
}), JN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.299 7.404c-1.495 1.162-2.809 2.762-3.732 4.481a.245.245 0 0 0 0 .23c.923 1.719 2.237 3.318 3.732 4.481 1.499 1.166 3.13 1.856 4.701 1.856 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.246.246 0 0 0 0-.23c-.923-1.719-2.237-3.318-3.732-4.481-1.5-1.166-3.13-1.856-4.701-1.856-1.571 0-3.202.69-4.701 1.856Zm-.941-1.225C8.033 4.876 9.986 4 12 4c2.014 0 3.967.876 5.642 2.179 1.679 1.305 3.128 3.077 4.145 4.97.284.53.284 1.172 0 1.702-1.017 1.893-2.466 3.665-4.145 4.97C15.967 19.125 14.014 20 12 20c-2.014 0-3.967-.876-5.642-2.179-1.679-1.306-3.128-3.077-4.145-4.97a1.804 1.804 0 0 1 0-1.702C3.23 9.256 4.679 7.484 6.358 6.18Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.658 10.332a2.334 2.334 0 0 0-3.316 0 2.37 2.37 0 0 0 0 3.336c.916.922 2.4.922 3.316 0a2.37 2.37 0 0 0 0-3.336Zm1.036-1.043a3.793 3.793 0 0 0-5.388 0 3.852 3.852 0 0 0 0 5.422 3.793 3.793 0 0 0 5.388 0 3.852 3.852 0 0 0 0-5.422Z", fill: "currentColor" })] }));
}, GN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: JN
}), TN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.447 8.553c.3.3.3.788 0 1.088L9.64 15.447a.77.77 0 1 1-1.088-1.088l5.806-5.806c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.553 8.553c.3-.3.788-.3 1.088 0l5.806 5.806a.77.77 0 0 1-1.088 1.088L8.553 9.64a.77.77 0 0 1 0-1.088Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" })] }));
}, XN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TN
}), kN = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.234 3.473h9.896c.681 0 1.239.553 1.243 1.234v1.034c0 .147-.11.246-.234.258a.253.253 0 0 1-.205-.07l-.541-.517a.26.26 0 0 1-.041-.053.139.139 0 0 1-.025-.05.214.214 0 0 1-.016-.085v-.517a.175.175 0 0 0-.177-.176H4.24a.175.175 0 0 0-.177.176v1.83c0 .044.017.09.05.122l3.682 3.675a.6.6 0 0 1 .086.115l.002.004.002.004.005.008a.144.144 0 0 1 .014.03l.002.007a.29.29 0 0 0 .02.05c.002.003.003.008.004.013l.005.015.001.007c.001.004.003.008.003.013 0 .004 0 .01.002.015a.08.08 0 0 1 .002.014c0 .004 0 .008.002.012a.051.051 0 0 1 .002.013v4.466c0 .23.217.402.439.344l1.767-.443a.356.356 0 0 0 .267-.344v-2.334c0-.147.11-.246.234-.258a.253.253 0 0 1 .205.07l.541.516a.261.261 0 0 1 .041.054l.025.049a.214.214 0 0 1 .016.086V14.673c0 .648-.443 1.214-1.07 1.37l-1.768.442a1.414 1.414 0 0 1-1.755-1.37v-4.19l-3.523-3.52A1.225 1.225 0 0 1 3 6.533V4.707c0-.68.554-1.234 1.234-1.234Zm9.33 3.367a.57.57 0 0 1 .804.804L13.15 8.862l1.218 1.218a.57.57 0 0 1-.804.803l-1.218-1.218-1.218 1.219a.57.57 0 0 1-.803-.804l1.218-1.218-1.218-1.218a.57.57 0 0 1 .803-.804l1.218 1.218 1.218-1.218Z", fill: "currentColor" }) }));
}, wN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: kN
}), DN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.797C3 3.805 3.806 3 4.8 3h14.4c.994 0 1.8.805 1.8 1.797v2.656c0 .477-.19.933-.527 1.27l-5.356 5.349c-.301.3-.79.3-1.091 0a.77.77 0 0 1 0-1.09l5.356-5.347a.255.255 0 0 0 .075-.182V4.797a.257.257 0 0 0-.257-.256H4.8a.257.257 0 0 0-.257.256v2.656c0 .07.027.134.074.18l.001.002 5.356 5.347a.77.77 0 0 1 0 1.09c-.301.3-.79.3-1.09 0L3.528 8.725h-.001A1.793 1.793 0 0 1 3 7.453V4.797Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.429 12.757a.77.77 0 0 1 .771.77v6.418c0 .334.315.58.64.498l2.57-.642a.514.514 0 0 0 .39-.498v-5.776a.77.77 0 0 1 1.543 0v5.776c0 .943-.643 1.764-1.559 1.993l-2.571.642a2.057 2.057 0 0 1-2.556-1.993v-6.418a.77.77 0 0 1 .772-.77Z", fill: "currentColor" })] }));
}, MN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: DN
}), YN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.774 2.954c.428 0 .774.344.774.77V21.23c0 .425-.346.769-.774.769A.772.772 0 0 1 4 21.23V3.724c0-.425.347-.77.774-.77ZM19.226 3.026c.427 0 .774.344.774.769v10.277c0 .425-.347.769-.774.769a.772.772 0 0 1-.774-.77V3.796c0-.425.346-.77.774-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m4.774 14.051-.495-.591a.766.766 0 0 0-.1 1.083.778.778 0 0 0 1.074.113l.002-.002a.97.97 0 0 1 .078-.046c.084-.047.238-.121.476-.2.475-.157 1.295-.333 2.578-.333 1.187 0 2.186.384 3.329.832l.043.017c1.105.433 2.351.922 3.854.922 1.453 0 2.465-.27 3.138-.568.336-.149.582-.303.754-.43a2.532 2.532 0 0 0 .283-.244l.008-.008.003-.004.002-.002v-.001s.002 0-.575-.514l.576.513a.766.766 0 0 0-.06-1.086.778.778 0 0 0-1.08.045l-.004.005a.988.988 0 0 1-.078.062 2.434 2.434 0 0 1-.46.26c-.456.202-1.25.434-2.507.434-1.187 0-2.186-.384-3.329-.832l-.043-.017c-1.105-.434-2.351-.923-3.854-.923-1.426 0-2.413.197-3.067.412-.326.108-.568.22-.737.314a2.536 2.536 0 0 0-.287.184l-.009.008-.004.003-.002.001s-.002.002.493.593ZM5.325 4.266a.778.778 0 0 1-1.08.02.766.766 0 0 1-.035-1.087l.564.526c-.564-.526-.563-.527-.563-.527v-.001l.002-.002.004-.004.008-.008a1.23 1.23 0 0 1 .083-.077 2.51 2.51 0 0 1 .201-.157c.172-.121.418-.268.752-.41C5.931 2.256 6.94 2 8.387 2c1.503 0 2.75.489 3.854.922l.043.017c1.143.449 2.142.832 3.329.832 1.283 0 2.103-.176 2.578-.333.238-.079.392-.153.476-.2a.987.987 0 0 0 .077-.046l.003-.002a.778.778 0 0 1 1.074.113.766.766 0 0 1-.1 1.084l-.495-.592.494.592-.001.001-.002.001-.004.004-.009.007a1.536 1.536 0 0 1-.085.062 2.52 2.52 0 0 1-.202.122 4.38 4.38 0 0 1-.737.314c-.654.215-1.64.412-3.067.412-1.503 0-2.75-.49-3.854-.923-.014-.005-.029-.01-.043-.017-1.143-.448-2.142-.832-3.329-.832-1.261 0-2.06.223-2.519.417-.23.097-.38.19-.462.248a.975.975 0 0 0-.081.063Z", fill: "currentColor" })] }));
}, LN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: YN
}), xN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.757 3.27a3.653 3.653 0 0 1 4.487 0l5.845 4.547a3.653 3.653 0 0 1 1.411 2.884v7.145a3.654 3.654 0 0 1-3.654 3.654H6.154A3.654 3.654 0 0 1 2.5 17.846v-7.145c0-1.127.52-2.192 1.41-2.884L9.757 3.27Zm.897 1.154L4.808 8.97a2.191 2.191 0 0 0-.846 1.73v7.145c0 1.211.98 2.192 2.192 2.192h11.692c1.211 0 2.192-.98 2.192-2.192v-7.145a2.19 2.19 0 0 0-.846-1.73l-5.846-4.547a2.192 2.192 0 0 0-2.692 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.55 11.912a2.192 2.192 0 1 0-3.1 3.1 2.192 2.192 0 0 0 3.1-3.1Zm1.033-1.034a3.654 3.654 0 1 0-5.167 5.167 3.654 3.654 0 0 0 5.167-5.167Z", fill: "currentColor" })] }));
}, HN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xN
}), PN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.558 4.385c-.642 0-1.162.516-1.162 1.153v12.924c0 .637.52 1.153 1.162 1.153h14.88c.643 0 1.164-.516 1.164-1.153V5.538c0-.637-.52-1.153-1.163-1.153H4.559ZM2 5.538A2.548 2.548 0 0 1 4.558 3h14.88a2.548 2.548 0 0 1 2.56 2.538v12.924A2.549 2.549 0 0 1 19.437 21H4.559A2.548 2.548 0 0 1 2 18.462V5.538Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.1 8.415a1.17 1.17 0 0 0-1.645 0 1.147 1.147 0 0 0 0 1.632c.454.45 1.19.45 1.645 0a1.147 1.147 0 0 0 0-1.632Zm.986-.98c-1-.99-2.62-.99-3.618 0-1 .992-1 2.6 0 3.59 1 .992 2.62.992 3.618 0 1-.99 1-2.598 0-3.59ZM15.524 12.288a1.638 1.638 0 0 1 2.29-.252l3.924 3.116c.301.239.35.674.11.973a.702.702 0 0 1-.982.108l-3.925-3.116a.235.235 0 0 0-.327.036m0 0-3.104 3.85a1.638 1.638 0 0 1-2.288.252l-1.739-1.38a.234.234 0 0 0-.324.032l-4.067 4.844a.701.701 0 0 1-.983.088.689.689 0 0 1-.09-.974l4.068-4.844a1.637 1.637 0 0 1 2.268-.228l1.738 1.38c.1.08.248.064.328-.035l3.103-3.85", fill: "currentColor" })] }));
}, ON = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: PN
}), KN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8.253a1 1 0 1 1 2-.005 1 1 0 0 1-2 .005Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75ZM2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 11.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, zN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KN
}), jN = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M7.748 4.663h-1.75a2 2 0 0 0-2.001 2.001V19.67a2 2 0 0 0 2 2h2.001M20.003 7.665v-1a2 2 0 0 0-2-2.002h-1.751", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("rect", { x: 10.999, y: 10.541, width: 9.004, height: 11.13, rx: 1.125, stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("rect", { x: 7.749, y: 2.663, width: 8.504, height: 4.002, rx: 2, stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, _N = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: jN
}), $N = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.673 8.406c.186-.187.476-.357.83-.357s.644.17.83.357c.185.186.355.477.355.833s-.17.647-.355.833a1.183 1.183 0 0 1-.83.357c-.354 0-.644-.17-.83-.357a1.192 1.192 0 0 1-.355-.833c0-.356.17-.647.355-.833Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.01 4.166c-.59-.218-1.073-.12-1.433.241L9.589 7.408a1.48 1.48 0 0 0-.346 1.538l.916 2.044a.778.778 0 0 1-.163.872l-5.95 5.876v2.21H6.25l5.955-5.98a.77.77 0 0 1 .85-.165l2.147.923c.59.218 1.073.12 1.433-.242l2.961-2.973c.341-.426.456-.948.268-1.467l-1.538-3.603-.007-.018a1.27 1.27 0 0 0-.703-.706l-.017-.007-3.589-1.544Zm-2.526-.856c.872-.876 2.034-.987 3.084-.592a.832.832 0 0 1 .033.014L18.2 4.28a2.82 2.82 0 0 1 1.55 1.557l1.543 3.614.013.033c.419 1.121.128 2.238-.542 3.046a.8.8 0 0 1-.047.051l-2.988 3.001c-.873.876-2.034.987-3.084.592a.784.784 0 0 1-.033-.014l-1.683-.724-5.812 5.837a.771.771 0 0 1-.546.227H3.273a.774.774 0 0 1-.773-.776v-3.311c0-.208.083-.407.23-.553l5.799-5.726-.706-1.577a3.037 3.037 0 0 1 .673-3.247l2.988-3Z", fill: "currentColor" })] }));
}, qN = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $N
}), eJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538c-1.853 0-3.355 1.493-3.355 3.334v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873C7.097 4.182 9.292 2 12 2c2.708 0 4.903 2.181 4.903 4.872v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-1.841-1.502-3.334-3.355-3.334Z", fill: "currentColor" })] }));
}, tJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: eJ
}), nJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.251 6a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001A.75.75 0 0 1 2.25 6ZM2.251 12a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75ZM2.251 18a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, rJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nJ
}), iJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 16 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1c0-.552.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89C.398 2 0 1.552 0 1Z", fill: "currentColor" }) }));
}, oJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iJ
}), aJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 18.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 12.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 6.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246ZM11.438 6h-.688v.004", fill: "currentColor" }) }));
}, sJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aJ
}), lJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.292 17.593a.75.75 0 0 1 .75.75v.365a3.042 3.042 0 0 1-6.084.001v-.365a.75.75 0 0 1 1.5 0v.365a1.542 1.542 0 0 0 3.084-.001v-.365a.75.75 0 0 1 .75-.75ZM9.417 4.833a2.583 2.583 0 1 1 5.166 0v.918a.75.75 0 0 1-1.5 0v-.918a1.083 1.083 0 1 0-2.166 0v.918a.75.75 0 0 1-1.5 0v-.918Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.094 6.407a3.78 3.78 0 0 0-3.781 3.781v2.797c0 .73-.29 1.429-.806 1.944l-.64.641a1.25 1.25 0 0 0-.367.884c0 .63.51 1.14 1.14 1.14h10.721c.63 0 1.14-.51 1.14-1.14 0-.33-.132-.65-.366-.884l-.641-.64a2.75 2.75 0 0 1-.806-1.945v-2.797a3.78 3.78 0 0 0-3.781-3.781h-1.813Zm-5.281 3.781a5.28 5.28 0 0 1 5.281-5.281h1.813a5.28 5.28 0 0 1 5.281 5.281v2.797c0 .33.132.65.366.884l.641.64a2.75 2.75 0 0 1 .806 1.945 2.64 2.64 0 0 1-2.64 2.64H6.64A2.64 2.64 0 0 1 4 16.454c0-.73.29-1.429.806-1.944l.64-.641a1.25 1.25 0 0 0 .367-.884v-2.797Z", fill: "currentColor" })] }));
}, cJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lJ
}), dJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .907c.523 0 .947.424.947.948v14.29a.947.947 0 0 1-1.894 0V1.855c0-.524.424-.948.947-.948Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.093 9a.947.947 0 0 1-.948.947H1.855a.947.947 0 1 1 0-1.894h14.29c.524 0 .948.424.948.947Z", fill: "currentColor" })] }));
}, uJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dJ
}), hJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3.75a.25.25 0 0 0-.25.25v3.25h8.5V4a.25.25 0 0 0-.25-.25H8Zm9.75 3.5V4A1.75 1.75 0 0 0 16 2.25H8A1.75 1.75 0 0 0 6.25 4v3.25H5A2.75 2.75 0 0 0 2.25 10v5A2.75 2.75 0 0 0 5 17.75h1.25V20c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 17.75 20v-2.25H19A2.75 2.75 0 0 0 21.75 15v-5A2.75 2.75 0 0 0 19 7.25h-1.25ZM5 8.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h1.25V13.8a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75v2.45H19c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25H5Zm11.25 5.8h-8.5V20c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-5.45ZM6.25 11a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, AJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hJ
}), gJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M13 21.608a8.119 8.119 0 0 1-1 .063 9.004 9.004 0 1 1 9.004-9.004c0 .334-.02.668-.062 1M20.004 17.669l-2.501 2.5-1.501-1.5", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "m12 13.378 1.328-.737a2.087 2.087 0 0 0 1.073-1.825 2.298 2.298 0 0 0-2.42-2.15 2.345 2.345 0 0 0-2.382 1.812M12.1 16.569a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, fJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gJ
}), pJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.436 9.971a1.422 1.422 0 0 0-1.496-1.306.771.771 0 0 1-.074 0 1.467 1.467 0 0 0-1.49 1.135.769.769 0 0 1-1.499-.348 3.005 3.005 0 0 1 3.015-2.324 2.96 2.96 0 0 1 3.082 2.82c0 1.175-.856 1.899-1.386 2.33l-.196.157c-.209.168-.365.294-.492.426a.597.597 0 0 0-.131.173.769.769 0 0 1-1.538-.008c0-.552.301-.96.558-1.229.204-.213.466-.422.686-.598l.143-.115c.56-.455.808-.755.818-1.113ZM12.604 15.242A.767.767 0 0 0 12 14.95a.897.897 0 1 0 .897.897.768.768 0 0 0-.293-.604Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.231 15.718c0-.425.344-.769.769-.769.495 0 .897.402.897.897a.769.769 0 0 1-1.373.476.767.767 0 0 1-.293-.604Z", fill: "currentColor" })] }));
}, mJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pJ
}), vJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 3.538a.77.77 0 0 1 .768.77v3.077h3.077a.77.77 0 1 1 0 1.538H2.77A.77.77 0 0 1 2 8.153V4.309a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.917 7.833C4.497 4.396 7.964 2 12 2c5.523 0 10 4.477 10 10a.77.77 0 0 1-1.538 0A8.46 8.46 0 0 0 12 3.538c-3.41 0-6.345 2.023-7.685 4.937a.77.77 0 0 1-1.398-.642ZM16.615 15.846a.77.77 0 0 1 .77-.77h3.846a.77.77 0 0 1 .769.77v3.846a.77.77 0 0 1-1.538 0v-3.077h-3.077a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 11.23a.77.77 0 0 1 .768.77A8.46 8.46 0 0 0 12 20.462c3.41 0 6.345-2.023 7.685-4.937a.77.77 0 1 1 1.398.642C19.502 19.604 16.035 22 12 22 6.477 22 2 17.523 2 12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" })] }));
}, bJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vJ
}), FJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.286 7.22a5.704 5.704 0 1 0-8.067 8.066 5.704 5.704 0 0 0 8.067-8.067Zm1.095-1.096A7.253 7.253 0 1 0 6.124 16.381 7.253 7.253 0 0 0 16.381 6.124Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.282 15.282a.774.774 0 0 1 1.095 0l3.396 3.396a.774.774 0 1 1-1.095 1.095l-3.396-3.396a.774.774 0 0 1 0-1.095Z", fill: "currentColor" })] }));
}, RJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FJ
}), yJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "m12 12 9-9v7-7h-7", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, QJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yJ
}), CJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { clipRule: "evenodd", d: "M14.121 9.879A3 3 0 1 1 9.88 14.12 3 3 0 0 1 14.12 9.88Z", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { clipRule: "evenodd", d: "M16.18 18.725a1.29 1.29 0 0 0 1.823 0l.722-.722a1.29 1.29 0 0 0 0-1.823 1.324 1.324 0 0 1-.284-1.453 7.63 7.63 0 0 0 .065-.16 1.217 1.217 0 0 1 1.137-.766h.067c.712 0 1.289-.577 1.289-1.289v-1.021c0-.712-.577-1.289-1.289-1.289h-.067c-.5 0-.954-.301-1.137-.766a7.63 7.63 0 0 0-.065-.16 1.324 1.324 0 0 1 .284-1.453 1.29 1.29 0 0 0 0-1.823l-.722-.722a1.29 1.29 0 0 0-1.823 0 1.324 1.324 0 0 1-1.453.284l-.16-.065a1.227 1.227 0 0 1-.767-1.141v-.067C13.8 3.577 13.223 3 12.511 3H11.49a1.29 1.29 0 0 0-1.29 1.289v.067c0 .5-.301.954-.766 1.137-.054.022-.107.043-.16.066a1.324 1.324 0 0 1-1.453-.284 1.29 1.29 0 0 0-1.823 0l-.723.722a1.29 1.29 0 0 0 0 1.823c.382.382.494.955.284 1.453a5.419 5.419 0 0 0-.065.161 1.22 1.22 0 0 1-1.138.766h-.067C3.577 10.2 3 10.777 3 11.489v1.021c0 .713.577 1.29 1.289 1.29h.067c.5 0 .954.301 1.137.766l.065.16c.21.498.098 1.071-.284 1.453a1.29 1.29 0 0 0 0 1.823l.722.722a1.29 1.29 0 0 0 1.823 0 1.324 1.324 0 0 1 1.453-.284l.16.065c.466.183.766.637.766 1.137v.067c0 .712.577 1.289 1.289 1.289h1.021c.712 0 1.289-.577 1.289-1.289v-.067c0-.5.301-.954.766-1.137l.16-.065a1.332 1.332 0 0 1 1.457.285Z", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, UJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CJ
}), IJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2a.73.73 0 0 1 .657.426l2.694 5.722 6.024.923a.74.74 0 0 1 .589.518.783.783 0 0 1-.183.778L17.42 14.82l1.03 6.291a.775.775 0 0 1-.293.745.708.708 0 0 1-.772.055L12 18.943l-5.385 2.968a.708.708 0 0 1-.772-.055.775.775 0 0 1-.292-.745l1.03-6.291-4.362-4.453a.783.783 0 0 1-.183-.778.74.74 0 0 1 .59-.518l6.022-.923 2.695-5.722A.73.73 0 0 1 12 2Zm0 2.491L9.793 9.178a.735.735 0 0 1-.55.418l-4.948.758 3.583 3.658a.78.78 0 0 1 .21.671l-.845 5.16 4.414-2.434a.707.707 0 0 1 .686 0l4.414 2.434-.844-5.16a.78.78 0 0 1 .209-.67l3.583-3.659-4.948-.758a.734.734 0 0 1-.55-.418L12 4.49Z", fill: "currentColor" }) }));
}, BJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: IJ
}), ZJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.12 8.998c.3.3.3.787 0 1.087l-4.89 4.89a.77.77 0 0 1-1.198.14L7.809 12.89a.769.769 0 1 1 1.087-1.087l1.665 1.665 4.47-4.471c.301-.3.788-.3 1.088 0Z", fill: "currentColor" })] }));
}, SJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ZJ
}), EJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10.62a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h1c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-1Zm-1.75.25c0-.966.784-1.75 1.75-1.75h1a2.75 2.75 0 0 1 2.75 2.75v3A2.75 2.75 0 0 1 19 17.62h-1a1.75 1.75 0 0 1-1.75-1.75v-5ZM5 10.62c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h1a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25H5Zm-2.75 1.25A2.75 2.75 0 0 1 5 9.12h1c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 6 17.62H5a2.75 2.75 0 0 1-2.75-2.75v-3Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 9.37a7.25 7.25 0 1 1 14.5 0v.5a.75.75 0 0 1-1.5 0v-.5a5.75 5.75 0 1 0-11.5 0v.5a.75.75 0 0 1-1.5 0v-.5ZM11.375 19.37a.5.5 0 0 0 0 1h1.25a.5.5 0 0 0 0-1h-1.25Zm-2 .5a2 2 0 0 1 2-2h1.25a2 2 0 0 1 0 4h-1.25a2 2 0 0 1-2-2Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 16.12a.75.75 0 0 1 .75.75v1A2.75 2.75 0 0 1 16 20.62h-2.125a.75.75 0 0 1 0-1.5H16c.69 0 1.25-.56 1.25-1.25v-1a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, VJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: EJ
}), WJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.754 3.5a8.254 8.254 0 0 0 0 16.508.75.75 0 1 1 0 1.5C6.367 21.508 2 17.14 2 11.754S6.367 2 11.754 2s9.754 4.367 9.754 9.754a.75.75 0 1 1-1.5 0A8.254 8.254 0 0 0 11.754 3.5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.513 8.752a.75.75 0 0 1 .75-.75h16.981a.75.75 0 0 1 0 1.5H3.264a.75.75 0 0 1-.75-.75ZM2.514 14.755a.75.75 0 0 1 .75-.75h8.49a.75.75 0 1 1 0 1.5h-8.49a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.273 3.433a2.865 2.865 0 0 1 4.962-.001 16.234 16.234 0 0 1 2.27 8.324.75.75 0 1 1-1.5-.004 14.733 14.733 0 0 0-2.063-7.559l-.005-.008a1.366 1.366 0 0 0-2.366 0l-.004.007a14.885 14.885 0 0 0 0 15.125l.003.005c.245.424.697.685 1.187.687a.75.75 0 0 1-.004 1.5 2.876 2.876 0 0 1-2.48-1.432 16.385 16.385 0 0 1 0-16.644Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.756 14.505a3.252 3.252 0 1 0 0 6.503 3.252 3.252 0 0 0 0-6.503Zm0-1.5a4.752 4.752 0 1 0 0 9.503 4.752 4.752 0 0 0 0-9.503Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.294 15.799c.345 0 .624.279.624.623v1.488h1.129a.624.624 0 1 1 0 1.247h-1.753a.624.624 0 0 1-.623-.623v-2.111c0-.345.279-.624.623-.624Z", fill: "currentColor" })] }));
}, NJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: WJ
}), JJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.818 5.077c.427 0 .773.344.773.77v13.076c0 .859.68 1.539 1.526 1.539h7.727c.862 0 1.565-.697 1.565-1.539V5.846c0-.425.346-.77.773-.77a.77.77 0 0 1 .773.77v13.077c0 1.708-1.413 3.077-3.11 3.077H8.116a3.067 3.067 0 0 1-3.072-3.077V5.846c0-.425.346-.77.773-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 5.846c0-.425.346-.77.773-.77h15.454c.427 0 .773.345.773.77 0 .425-.346.77-.773.77H4.273a.771.771 0 0 1-.773-.77ZM9.167 2.77c0-.426.346-.77.772-.77h4.122a.77.77 0 0 1 .772.77.77.77 0 0 1-.772.768H9.939a.771.771 0 0 1-.772-.769ZM14.06 9.18a.77.77 0 0 1 .773.769v7.18a.77.77 0 0 1-.772.768.77.77 0 0 1-.773-.769v-7.18a.77.77 0 0 1 .773-.769ZM9.94 9.18a.77.77 0 0 1 .772.769v7.18a.77.77 0 0 1-.773.768.771.771 0 0 1-.772-.769v-7.18c0-.424.346-.769.772-.769Z", fill: "currentColor" })] }));
}, GJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: JJ
}), TJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12ZM7.259 5.681A4.89 4.89 0 0 1 12 2c2.708 0 4.903 2.181 4.903 4.872 0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77c0-1.84-1.502-3.333-3.355-3.333a3.343 3.343 0 0 0-3.24 2.52.775.775 0 0 1-1.501-.377Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.129 6.103c.428 0 .774.344.774.769v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-.425.346-.77.774-.77Z", fill: "currentColor" })] }));
}, XJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TJ
}), kJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061l3.721 3.721V3a.75.75 0 0 1 .75-.75ZM3.25 21a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, wJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: kJ
}), DJ = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.348 16.472c-2.082 0-3.806 1.625-3.806 3.765A.767.767 0 0 1 4.77 21 .767.767 0 0 1 4 20.237c0-3.005 2.437-5.29 5.348-5.29h5.304c3.038 0 5.348 2.41 5.348 5.29a.767.767 0 0 1-.771.763.767.767 0 0 1-.77-.763c0-2.06-1.643-3.765-3.807-3.765H9.348ZM14.63 5.56a3.774 3.774 0 0 0-5.164.009c-1.41 1.313-1.378 3.599.034 5.083 1.327 1.396 3.638 1.364 5.138-.033 1.429-1.33 1.456-3.6-.009-5.058Zm1.074-1.118a5.346 5.346 0 0 0-7.307.003c-2.126 1.98-1.95 5.25-.034 7.265 2.001 2.103 5.308 1.93 7.344.033 2.104-1.959 2.08-5.238.02-7.28a.778.778 0 0 0-.011-.01l-.012-.011Z", fill: "currentColor" }) }));
}, MJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: DJ
}), YJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6.615a.77.77 0 0 1 .77.77v5.128a.77.77 0 1 1-1.54 0V7.385a.77.77 0 0 1 .77-.77ZM10.974 16.362a1.026 1.026 0 1 1 2.05-.005 1.026 1.026 0 0 1-2.05.005Z", fill: "currentColor" })] }));
}, LJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: YJ
}), xJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.876 19.627a1.125 1.125 0 1 1 2.247-.003 1.125 1.125 0 0 1-2.247.003Zm.473-.003-.473-.003v.006M18.901 12.553c-3.805-3.49-9.998-3.49-13.803 0a.75.75 0 1 1-1.014-1.106c4.38-4.016 11.452-4.016 15.831 0a.75.75 0 1 1-1.014 1.106Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.91 8.366c-5.463-4.821-14.356-4.821-19.82 0a.75.75 0 0 1-.992-1.124c6.03-5.323 15.774-5.323 21.805 0a.75.75 0 1 1-.993 1.124ZM15.891 16.353a5.526 5.526 0 0 0-7.783 0 .75.75 0 1 1-1.058-1.064 7.026 7.026 0 0 1 9.9 0 .75.75 0 0 1-1.059 1.064Z", fill: "currentColor" })] }));
}, HJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xJ
}), PJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M18.5027 12C18.5027 12.2763 18.2788 12.5002 18.0025 12.5002C17.7263 12.5002 17.5023 12.2763 17.5023 12C17.5023 11.7237 17.7263 11.4998 18.0025 11.4998C18.2788 11.4998 18.5027 11.7237 18.5027 12", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M12.5002 12C12.5002 12.2763 12.2762 12.5002 12 12.5002C11.7237 12.5002 11.4998 12.2763 11.4998 12C11.4998 11.7237 11.7237 11.4998 12 11.4998C12.2762 11.4998 12.5002 11.7237 12.5002 12", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M6.49773 12C6.49773 12.2763 6.27378 12.5002 5.99752 12.5002C5.72127 12.5002 5.49731 12.2763 5.49731 12C5.49731 11.7237 5.72127 11.4998 5.99752 11.4998C6.27378 11.4998 6.49773 11.7237 6.49773 12", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, OJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: PJ
}), KJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M12 8V16", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M16 12H8", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, zJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KJ
}), jJ = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2621 10.0539C19.765 9.55675 18.959 9.55675 18.4618 10.0539C17.9647 10.551 17.9647 11.357 18.4618 11.8542C18.959 12.3513 19.765 12.3513 20.2621 11.8542C20.7593 11.357 20.7593 10.551 20.2621 10.0539ZM21.3219 8.99237C20.2389 7.9103 18.4838 7.91059 17.4012 8.99322C16.3183 10.0761 16.3183 11.8319 17.4012 12.9148C18.4841 13.9978 20.2399 13.9978 21.3228 12.9148C22.4057 11.8319 22.4057 10.0761 21.3228 8.99322L21.3219 8.99237Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.949 15.4041C18.949 14.9898 19.2848 14.6541 19.699 14.6541H20.5C22.2952 14.6541 23.75 16.1088 23.75 17.9041V19.0001C23.75 19.4143 23.4142 19.7501 23 19.7501C22.5858 19.7501 22.25 19.4143 22.25 19.0001V17.9041C22.25 16.9373 21.4668 16.1541 20.5 16.1541H19.699C19.2848 16.1541 18.949 15.8183 18.949 15.4041Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.53813 10.0539C5.041 9.55675 4.23498 9.55675 3.73784 10.0539C3.24071 10.551 3.24071 11.357 3.73784 11.8542C4.23498 12.3513 5.041 12.3513 5.53813 11.8542C6.03527 11.357 6.03527 10.551 5.53813 10.0539ZM6.59794 8.99237C5.51494 7.9103 3.75982 7.91059 2.67718 8.99322C1.59426 10.0761 1.59426 11.8319 2.67718 12.9148C3.76011 13.9978 5.51587 13.9978 6.59879 12.9148C7.68172 11.8319 7.68172 10.0761 6.59879 8.99322L6.59794 8.99237Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 16.1541C2.53321 16.1541 1.75 16.9373 1.75 17.9041V19.0001C1.75 19.4143 1.41421 19.7501 1 19.7501C0.585786 19.7501 0.25 19.4143 0.25 19.0001V17.9041C0.25 16.1088 1.70479 14.6541 3.5 14.6541H4.301C4.71521 14.6541 5.051 14.9898 5.051 15.4041C5.051 15.8183 4.71521 16.1541 4.301 16.1541H3.5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6723 6.44269C12.7487 5.5191 11.2513 5.5191 10.3277 6.44269C9.40411 7.36629 9.40411 8.86372 10.3277 9.78731C11.2513 10.7109 12.7487 10.7109 13.6723 9.78731C14.5959 8.86371 14.5959 7.36628 13.6723 6.44269ZM14.7326 5.38165C13.2232 3.87266 10.7763 3.87278 9.26704 5.38203C7.75767 6.89141 7.75766 9.3386 9.26704 10.848C10.7764 12.3573 13.2236 12.3573 14.733 10.848C16.2423 9.33859 16.242 6.89103 14.7326 5.38165Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.91003 17.399C5.91003 15.0518 7.81282 13.149 10.16 13.149H13.839C16.1862 13.149 18.089 15.0518 18.089 17.399V19C18.089 19.4143 17.7532 19.75 17.339 19.75C16.9248 19.75 16.589 19.4143 16.589 19V17.399C16.589 15.8803 15.3578 14.649 13.839 14.649H10.16C8.64125 14.649 7.41003 15.8803 7.41003 17.399V19C7.41003 19.4143 7.07425 19.75 6.66003 19.75C6.24582 19.75 5.91003 19.4143 5.91003 19V17.399Z", fill: "currentColor" })] }));
}, _J = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: jJ
}), $J = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: "currentColor" })] }));
}, qJ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $J
}), eG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.81 2.886a.75.75 0 0 1 1.044.184l11.9 17a.75.75 0 1 1-1.228.86l-11.9-17a.75.75 0 0 1 .184-1.044Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.75a.75.75 0 0 1 .75.75v7a1.5 1.5 0 0 0 1.5 1.5h7.962a.75.75 0 0 1 0 1.5H5.25a3 3 0 0 1-3-3v-7A.75.75 0 0 1 3 7.75ZM4.412 6.25a.75.75 0 0 1 .75-.75h7.963a3 3 0 0 1 3 3v7a.75.75 0 0 1-1.5 0v-7a1.5 1.5 0 0 0-1.5-1.5H5.162a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.7 7.265c1.227-.988 3.05-.114 3.05 1.46v6.55c0 1.575-1.823 2.449-3.05 1.46l-3.795-3.054a.75.75 0 1 1 .94-1.168l3.795 3.054c.245.197.61.024.61-.292v-6.55a.374.374 0 0 0-.61-.292l-3.795 3.054a.75.75 0 0 1-.94-1.168L18.7 7.265Z", fill: "currentColor" })] }));
}, tG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: eG
}), nG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 22 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.633 1.625c-.898 0-1.625.727-1.625 1.625v7.583c0 .898.727 1.625 1.625 1.625h8.532c.897 0 1.625-.727 1.625-1.625V3.25c0-.898-.728-1.625-1.625-1.625H3.633ZM.383 3.25A3.25 3.25 0 0 1 3.633 0h8.532a3.25 3.25 0 0 1 3.25 3.25v7.583a3.25 3.25 0 0 1-3.25 3.25H3.633a3.25 3.25 0 0 1-3.25-3.25V3.25Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.204 1.912c1.33-1.07 3.304-.124 3.304 1.582v7.096c0 1.705-1.975 2.652-3.305 1.581l-4.11-3.308a.812.812 0 1 1 1.018-1.266l4.112 3.309c.265.213.66.025.66-.316V3.494a.406.406 0 0 0-.66-.317l-4.112 3.31a.812.812 0 1 1-1.018-1.267l4.11-3.308Z", fill: "currentColor" })] }));
}, rG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nG
}), iG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.073 1.375c0-.397.322-.719.719-.719h3.833c.397 0 .719.322.719.72v3.832a.719.719 0 0 1-1.438 0V2.094h-3.114a.719.719 0 0 1-.72-.719Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.133.867c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM1.375 14.073c.397 0 .719.322.719.719v3.114h3.114a.719.719 0 1 1 0 1.438H1.375a.719.719 0 0 1-.719-.719v-3.833c0-.397.322-.719.719-.719Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.633 12.367c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM4.25 3.052c-.662 0-1.198.536-1.198 1.198v4.792a.719.719 0 1 1-1.437 0V4.25A2.635 2.635 0 0 1 4.25 1.615h4.792a.719.719 0 1 1 0 1.437H4.25ZM17.667 10.24c.397 0 .718.321.718.718v4.792a2.635 2.635 0 0 1-2.635 2.636H10a.719.719 0 0 1 0-1.438h5.75c.662 0 1.198-.536 1.198-1.198v-4.792c0-.397.322-.718.719-.718Z", fill: "currentColor" })] }));
}, oG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iG
}), aG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 11.25a.75.75 0 0 1 .75.75A2.751 2.751 0 0 0 12 14.752a.75.75 0 0 1 0 1.5A4.251 4.251 0 0 1 7.75 12a.75.75 0 0 1 .75-.75ZM8.5 8.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 7.75a.75.75 0 0 1 .75.75V12a.75.75 0 1 1-1.5 0V8.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.498 10.75a.75.75 0 0 1 .749.75 6.744 6.744 0 0 0 11.29 4.99.75.75 0 0 1 1.012 1.107A8.244 8.244 0 0 1 3.747 11.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.253a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM3.466 3.466a.75.75 0 0 1 1.061 0l16.007 16.007a.75.75 0 0 1-1.061 1.06L3.466 4.528a.75.75 0 0 1 0-1.06ZM8.238 4.566A4.236 4.236 0 0 1 16.252 6.5V11a.75.75 0 0 1-1.5 0V6.495a2.736 2.736 0 0 0-5.176-1.25.75.75 0 1 1-1.338-.678ZM19.505 10.75a.75.75 0 0 1 .748.752 8.159 8.159 0 0 1-.835 3.572.75.75 0 1 1-1.346-.661 6.658 6.658 0 0 0 .681-2.915.75.75 0 0 1 .752-.748Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 13.945a.75.75 0 0 1 .001 1.061 4.238 4.238 0 0 1-3.006 1.245.75.75 0 0 1 0-1.5c.729.001 1.43-.288 1.944-.804a.75.75 0 0 1 1.061-.002Z", fill: "currentColor" })] }));
}, sG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aG
}), lG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: s.color })] }));
}, cG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lG
}), dG = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 2.996a.75.75 0 0 1 .75-.75h4.002a.75.75 0 1 1 0 1.5H3.746v3.252a.75.75 0 0 1-1.5 0V2.996Zm8.004 2A2.75 2.75 0 0 1 13 2.246h6.004a2.75 2.75 0 0 1 2.75 2.75V11a2.75 2.75 0 0 1-2.75 2.75H13A2.75 2.75 0 0 1 10.25 11V4.996ZM13 3.746c-.69 0-1.25.56-1.25 1.25V11c0 .69.56 1.25 1.25 1.25h6.004c.69 0 1.25-.56 1.25-1.25V4.996c0-.69-.56-1.25-1.25-1.25H13ZM8.529 15.471a.75.75 0 0 1 0 1.06l-3.722 3.723h2.191a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75v-4.002a.75.75 0 0 1 1.5 0v2.19l3.722-3.72a.75.75 0 0 1 1.06 0Zm12.475.78a.75.75 0 0 1 .75.75v4.003a.75.75 0 0 1-.75.75h-4.002a.75.75 0 0 1 0-1.5h3.252v-3.252a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }) }));
}, uG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dG
}), hG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.283 14c0-.966.783-1.75 1.75-1.75H20c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 0 1 20 21.75h-8.969A1.75 1.75 0 0 1 9.283 20v-6Zm1.75-.25a.25.25 0 0 0-.25.25v6c0 .139.111.25.25.25H20a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25h-8.969ZM5.47 6.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 6.538a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-.75.75H6.29a.75.75 0 1 1 0-1.5H8.25V7.288a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h2a.75.75 0 1 1 0 1.5H5A2.75 2.75 0 0 1 2.252 13V6a2.75 2.75 0 0 1 2.75-2.75h11A2.75 2.75 0 0 1 18.75 6v4a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H5Z", fill: "currentColor" })] }));
}, AG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hG
}), gG = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { clipRule: "evenodd", d: "M11.19 11.192a13.162 13.162 0 0 0 2.749-3.968.78.78 0 0 0-.173-.862l-.853-.852c-.7-.699-.7-1.687-.089-2.298l1.223-1.222a2.083 2.083 0 0 1 2.946 0l.68.679c.771.772 1.093 1.885.885 2.99-.515 2.721-2.096 5.701-4.647 8.253-2.551 2.55-5.532 4.132-8.253 4.646-1.105.209-2.218-.113-2.99-.885l-.678-.678a2.083 2.083 0 0 1 0-2.946l1.222-1.222c.61-.61 1.6-.61 2.209 0l.94.942a.78.78 0 0 0 .862.173c1.385-.612 2.75-1.532 3.968-2.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}, fG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gG
}), pG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.424 4.053a.75.75 0 0 1 .75.75v2.893a.75.75 0 0 1-.75.75h-2.893a.75.75 0 0 1 0-1.5h2.143V4.803a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12c0-5.384 4.365-9.75 9.75-9.75a9.747 9.747 0 0 1 8.563 5.087.75.75 0 0 1-1.316.718A8.25 8.25 0 1 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.384-4.365 9.75-9.75 9.75S2.25 17.384 2.25 12Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.945 10.055a2.75 2.75 0 1 0-3.89 3.89 2.75 2.75 0 0 0 3.89-3.89Zm1.06-1.06a4.25 4.25 0 1 0-6.01 6.01 4.25 4.25 0 0 0 6.01-6.01Z", fill: "currentColor" })] }));
}, mG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pG
}), vG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.12A2.75 2.75 0 0 1 5 2.37h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 1 1 1.5 0v6.125A2.75 2.75 0 0 1 19 21.87H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.372a3.751 3.751 0 0 1 3.752-3.75h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.25v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.34a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.502a.75.75 0 1 1-1.06-1.061l1.97-1.97-1.97-1.972a.75.75 0 0 1 0-1.06Z", fill: "currentColor" })] }));
}, bG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vG
}), FG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M17 5.317a20.42 20.42 0 0 1 2.956-.3A1.005 1.005 0 0 1 21 6.016v11.837c0 .542-.433.99-.974.998-3.092.047-5.42.617-8.026 2.149-2.606-1.532-4.934-2.102-8.026-2.148A.996.996 0 0 1 3 17.853V6.016a.995.995 0 0 1 1.017-1c3.071.099 5.389.677 7.983 2.13", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { clipRule: "evenodd", d: "M17 15.238V3.012c0-.729-.766-1.238-1.417-.911-1.756.88-3.236 2.669-3.583 4.511V21c.396-2.099 2.261-4.129 4.331-4.824a.987.987 0 0 0 .669-.938Z", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, RG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FG
}), yG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M3 8h18M11 5.495l-.005.005.005.005.005-.005L11 5.495M8.5 5.495l-.005.005.005.005.005-.005-.005-.005M6 5.495l-.005.005.005.005.005-.005L6 5.495", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M9 20H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { clipRule: "evenodd", d: "M22 17v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v0Z", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { clipRule: "evenodd", d: "M15.586 18.498v-2.995a.496.496 0 0 1 .749-.432l2.507 1.498a.504.504 0 0 1 0 .863l-2.507 1.498a.496.496 0 0 1-.749-.431v0Z", stroke: s.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, QG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yG
}), CG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.194 15.334a.194.194 0 0 0-.194.194v3.778c0 .107.087.194.194.194h4.723a.75.75 0 0 1 0 1.5H4.194c-.937 0-1.694-.76-1.694-1.694v-3.778c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H4.194ZM13.833 4.194c0-.935.759-1.694 1.694-1.694h3.778c.935 0 1.694.757 1.694 1.694v15.112c0 .935-.757 1.694-1.694 1.694h-4.722a.75.75 0 0 1-.75-.75V4.194Zm1.5 0V19.5h3.972a.194.194 0 0 0 .194-.194V4.194A.194.194 0 0 0 19.305 4h-3.778a.194.194 0 0 0-.194.194Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.86 9.667a.194.194 0 0 0-.194.194V19.5h4.917a.75.75 0 0 1 0 1.5H8.917a.75.75 0 0 1-.751-.75V9.861c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H9.86Z", fill: "currentColor" })] }));
}, UG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CG
}), IG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h3c.219 0 .416.094.553.243l3.446 3.446 3.47-3.47A.75.75 0 0 1 16 16.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5Zm7.553 17.757a.75.75 0 0 1-1.083.024L7.688 17.75H5A2.75 2.75 0 0 1 2.25 15V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75h-2.69l-3.757 3.757Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Z", fill: "currentColor" })] }));
}, BG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: IG
}), ZG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.167 12.321c.29.293.29.768 0 1.06l-2.768 2.792a.74.74 0 0 1-1.051.001l-1.665-1.673a.755.755 0 0 1-.002-1.06.74.74 0 0 1 1.052-.002l1.139 1.144 2.243-2.262a.74.74 0 0 1 1.052 0ZM9.946 3.555 8.843 4.939v.72c0 .134.109.243.243.243h5.828c.134 0 .243-.11.243-.244V4.94l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.586A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.235-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.731a.728.728 0 0 1-.73-.728v.972c0 .943.762 1.708 1.7 1.708h5.83c.938 0 1.7-.765 1.7-1.708v-.975h-.73Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634A2.677 2.677 0 0 1 6.171 3.95h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.731H6.171c-.67 0-1.214.546-1.214 1.22v12.683c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.2 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" })] }));
}, SG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ZG
}), EG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.946 3.555 8.843 4.94v.719c0 .134.109.243.243.243h5.828c.134 0 .243-.109.243-.243v-.72l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.585V2.64A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.236-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.732a.728.728 0 0 1-.73-.729v.973c0 .942.762 1.707 1.7 1.707h5.83c.938 0 1.7-.765 1.7-1.707v-.976h-.73Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634a2.677 2.677 0 0 1 2.671-2.683h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.732H6.171c-.67 0-1.214.545-1.214 1.22v12.682c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.201 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.386 11.512a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732ZM7.386 16.39a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732Z", fill: "currentColor" })] }));
}, VG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: EG
}), WG = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { d: "M3 9h18M9.57 13H7m11 6H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}, NG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: WG
}), JG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.128 3.962a3.167 3.167 0 0 0-3.166 3.166v9.744a3.167 3.167 0 0 0 3.166 3.166h9.744a3.167 3.167 0 0 0 3.166-3.166V7.128a3.167 3.167 0 0 0-3.166-3.166H7.128ZM2.5 7.128A4.628 4.628 0 0 1 7.128 2.5h9.744A4.628 4.628 0 0 1 21.5 7.128v9.744a4.628 4.628 0 0 1-4.628 4.628H7.128A4.628 4.628 0 0 1 2.5 16.872V7.128Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.124 8.615 2.825 5.648 1.16-2.32a1.219 1.219 0 0 1 1.09-.674h4.57a.73.73 0 0 1 0 1.462h-4.42l-1.31 2.62c-.45.9-1.731.9-2.18.001l-2.833-5.664L8.73 12.09v.002a1.22 1.22 0 0 1-1.072.638H3.231a.73.73 0 0 1 0-1.462h4.282l1.45-2.688a1.218 1.218 0 0 1 2.16.034Zm-.875.66Zm-.432-.007ZM13.73 14.7Z", fill: "currentColor" })] }));
}, GG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: JG
}), TG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.783 7.398a3.751 3.751 0 0 1 1.677-.396h1.293a.75.75 0 1 1 0 1.5H6.46c-.35 0-.694.081-1.006.238l-.586.292a2.25 2.25 0 0 0-.924.856l-1.55 2.585a.75.75 0 1 1-1.287-.772l1.551-2.585c.367-.612.901-1.106 1.54-1.425m0 0 .585-.293M17.257 5.001a.75.75 0 0 1 .75.75v3.001a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 7.252a.75.75 0 0 1 .75-.75h3.001a.75.75 0 0 1 0 1.5h-3.001a.75.75 0 0 1-.75-.75ZM16.006 12.754a.75.75 0 0 1 .75-.75h2.001a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.005 15.755a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5h-4.002a.75.75 0 0 1-.75-.75ZM10.414 10.033a2.396 2.396 0 0 1 3.688 3.025l-2.994 4.49A4.751 4.751 0 0 1 8.77 19.38l-5.765 2.083a.75.75 0 0 1-.51-1.41l5.765-2.084a3.252 3.252 0 0 0 1.6-1.254l2.994-4.49a.896.896 0 0 0-1.38-1.131l-2.19 2.19a.75.75 0 0 1-.531.22h-2a.75.75 0 0 1 0-1.5h1.69l1.971-1.97Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.003 4.25A2.25 2.25 0 0 1 9.253 2h11.005a2.25 2.25 0 0 1 2.25 2.25v15.007a2.25 2.25 0 0 1-2.25 2.25H9.253a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .414.336.75.75.75h11.005a.75.75 0 0 0 .75-.75V4.25a.75.75 0 0 0-.75-.751H9.253a.75.75 0 0 0-.75.75v8.504a.75.75 0 0 1-1.5 0V4.251Z", fill: "currentColor" })] }));
}, XG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TG
}), kG = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.385 8.236a.77.77 0 0 1 .769.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM16.615 8.236a.77.77 0 0 1 .77.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM12.513 8.253a.77.77 0 0 1 .77.77v3.59c0 .99-.805 1.794-1.796 1.794h-.513a.77.77 0 1 1 0-1.538h.513a.257.257 0 0 0 .257-.257v-3.59a.77.77 0 0 1 .769-.769ZM8.132 15.72c.3-.3.787-.3 1.088 0a3.933 3.933 0 0 0 5.561 0 .77.77 0 0 1 1.088 1.088 5.471 5.471 0 0 1-7.737 0 .77.77 0 0 1 0-1.088ZM2 4.82A2.82 2.82 0 0 1 4.82 2h2.655a.77.77 0 1 1 0 1.538H4.82c-.709 0-1.283.574-1.283 1.283v2.654a.77.77 0 1 1-1.538 0V4.82ZM21.23 15.756a.77.77 0 0 1 .77.77v2.654A2.82 2.82 0 0 1 19.18 22h-2.655a.77.77 0 0 1 0-1.538h2.655c.708 0 1.282-.574 1.282-1.282v-2.655a.77.77 0 0 1 .769-.77ZM2.77 15.756a.77.77 0 0 1 .768.77v2.654c0 .708.574 1.282 1.283 1.282h2.654a.77.77 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18v-2.655a.77.77 0 0 1 .77-.77ZM15.756 2.77a.77.77 0 0 1 .77-.77h2.654A2.82 2.82 0 0 1 22 4.82v2.655a.77.77 0 1 1-1.538 0V4.82c0-.709-.574-1.283-1.282-1.283h-2.655a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }) }));
}, wG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: kG
}), DG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.246 2.25a.75.75 0 0 1 .749.75v3.998c0 .139.112.25.25.25h3.999a.75.75 0 1 1 0 1.5h-3.999a1.75 1.75 0 0 1-1.749-1.75V3a.75.75 0 0 1 .75-.749ZM10.64 11.429a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 0 1 1.06-1.06l.97.97 1.97-1.97a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 10.996a3.747 3.747 0 0 1 3.747-3.748h4.001a3.747 3.747 0 0 1 3.748 3.748v4.001a3.747 3.747 0 0 1-3.748 3.747h-4A3.747 3.747 0 0 1 2.5 14.997v-4.001Zm3.747-2.249A2.248 2.248 0 0 0 4 10.996v4.001a2.248 2.248 0 0 0 2.248 2.248h4.001a2.248 2.248 0 0 0 2.249-2.248v-4.001a2.248 2.248 0 0 0-2.249-2.249h-4Z", fill: "currentColor" }), We("path", { d: "M7 5.002c0-.69.56-1.25 1.25-1.25h7.171c.331 0 .649.132.883.366l2.83 2.827c.235.234.367.552.367.884v11.173c0 .69-.56 1.25-1.249 1.25H8.249c-.69 0-1.249-.56-1.249-1.25v-.763H5.501v.763A2.748 2.748 0 0 0 8.25 21.75h10.003A2.748 2.748 0 0 0 21 19.002V7.829c0-.73-.29-1.429-.806-1.944l-2.83-2.828a2.748 2.748 0 0 0-1.943-.803H8.25a2.748 2.748 0 0 0-2.748 2.748v3.244h1.5V5.002Z", fill: "currentColor" })] }));
}, MG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: DG
}), YG = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.748 2.003h6.922a.758.758 0 0 1 .15 0h.1c.729 0 1.427.289 1.942.804l2.83 2.827c.517.515.807 1.215.807 1.944v11.173A2.748 2.748 0 0 1 17.75 21.5H7.748A2.748 2.748 0 0 1 5 18.751v-.332A3.749 3.749 0 0 1 2 14.746v-4.001A3.749 3.749 0 0 1 5 7.072V4.75a2.748 2.748 0 0 1 2.748-2.748ZM6.5 18.75v-.257h3.248a3.747 3.747 0 0 0 3.748-3.748v-4.001a3.747 3.747 0 0 0-3.748-3.747H6.5V4.75c0-.69.56-1.25 1.25-1.25h6.246v3.247c0 .966.783 1.749 1.75 1.749H19V18.75c0 .69-.56 1.25-1.249 1.25H7.748c-.69 0-1.249-.56-1.249-1.25Zm9.245-11.753h3.113a1.248 1.248 0 0 0-.223-.304l-2.83-2.827a1.25 1.25 0 0 0-.31-.226v3.107c0 .138.112.25.25.25ZM3.498 10.745a2.248 2.248 0 0 1 2.248-2.248h4.001a2.248 2.248 0 0 1 2.249 2.248v4.001a2.248 2.248 0 0 1-2.249 2.249h-4a2.248 2.248 0 0 1-2.25-2.249v-4.001Zm3.574.268a.75.75 0 1 0-1.152.96l.85 1.019-.85 1.019a.75.75 0 0 0 1.152.96l.673-.809.673.808a.75.75 0 0 0 1.152-.96l-.85-1.018.85-1.02a.75.75 0 0 0-1.152-.96l-.673.809-.673-.808Z", fill: "currentColor" }) }));
}, LG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: YG
}), xG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75ZM7.961 16.432A.755.755 0 1 1 9.029 17.5a.755.755 0 0 1-1.068-1.068ZM7.25 10.995a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 13.995a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM14.961 16.466a.755.755 0 1 1 1.068 1.069.755.755 0 0 1-1.068-1.069ZM11.466 16.456a.755.755 0 1 1 1.068 1.069.755.755 0 0 1-1.068-1.069Z", fill: "currentColor" })] }));
}, HG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xG
}), PG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, OG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: PG
}), KG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M20.0033 7.99867H16.0016C15.4491 7.99867 15.0012 7.55076 15.0012 6.99825V2.99658", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M6.38866 10.9994C6.46883 11.0787 6.49318 11.1986 6.45031 11.3029C6.40745 11.4072 6.30584 11.4753 6.19308 11.4753C6.08032 11.4753 5.97871 11.4072 5.93584 11.3029C5.89298 11.1986 5.91733 11.0787 5.9975 10.9994C6.10632 10.8915 6.28184 10.8915 6.39066 10.9994", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M13.0004 11.9502C11.4628 11.7149 9.89938 12.1655 8.72294 13.1831C7.54651 14.2007 6.8754 15.683 6.88686 17.2384C6.88843 17.4943 6.90883 17.7498 6.94789 18.0027", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("rect", { x: "2.99622", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, zG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KG
}), jG = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.414 6.414L15.586 3.586C15.211 3.211 14.702 3 14.172 3H7C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H17C18.105 21 19 20.105 19 19V7.828C19 7.298 18.789 6.789 18.414 6.414V6.414Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19 8H15C14.448 8 14 7.552 14 7V3", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M10.34 16.5498H13.66", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.833 12.751V11.583C10.833 11.261 11.094 11 11.416 11H12.584C12.906 11 13.167 11.261 13.167 11.583V12.751C13.167 13.073 12.906 13.334 12.584 13.334H11.416C11.094 13.333 10.833 13.072 10.833 12.751Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 17.417V16.249C8 15.927 8.261 15.666 8.583 15.666H9.751C10.073 15.666 10.334 15.927 10.334 16.249V17.417C10.334 17.739 10.073 18 9.751 18H8.583C8.261 18 8 17.739 8 17.417Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.667 17.417V16.249C13.667 15.927 13.928 15.666 14.25 15.666H15.418C15.74 15.666 16.001 15.927 16.001 16.249V17.417C16 17.739 15.739 18 15.417 18H14.249C13.928 18 13.667 17.739 13.667 17.417H13.667Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M14.24 15.6701L12.73 13.3101", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M9.76001 15.6701L11.27 13.3101", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, _G = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: jG
}), $G = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M20.0033 7.99867H16.0016C15.4491 7.99867 15.0012 7.55076 15.0012 6.99825V2.99658", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("rect", { x: "2.99622", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M5.74731 11.2499L6.24752 14.7513H6.57666L7.99825 11.7501L9.41984 14.7513H9.74898L10.2492 11.2499", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, qG = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $G
}), eT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M20.0034 7.99867H16.0018C15.4492 7.99867 15.0013 7.55076 15.0013 6.99825V2.99658", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M7.99826 12.8151V10.9794", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M7.99811 14.8403C7.97406 14.8403 7.951 14.8499 7.93409 14.8671C7.91717 14.8842 7.90781 14.9073 7.90807 14.9314C7.90808 14.9683 7.93037 15.0015 7.96451 15.0156C7.99865 15.0296 8.03788 15.0216 8.06384 14.9954C8.0898 14.9691 8.09734 14.9298 8.08293 14.8958C8.06852 14.8618 8.03502 14.8399 7.99811 14.8403", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("rect", { x: "2.99658", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, tT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: eT
}), nT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M5.00012 8V19C5.00012 20.105 5.89512 21 7.00012 21H15.0001", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19.0001 20.75L5.00012 3.25", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19 16V7.828C19 7.298 18.789 6.789 18.414 6.414L15.586 3.586C15.211 3.211 14.702 3 14.172 3H9", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19.0001 8H15.0001C14.4481 8 14.0001 7.552 14.0001 7V3", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, rT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nT
}), iT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M14 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V14", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M21 18L18 21", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M18 18L21 21", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.625 12.4996V14.3737C13.625 14.7524 13.411 15.0987 13.0722 15.2681L11.8222 15.8931C11.5123 16.0481 11.1441 16.0315 10.8493 15.8493C10.5545 15.6671 10.375 15.3452 10.375 14.9987V12.4996L8.38921 10.9677C8.14376 10.7784 8 10.4859 8 10.1759V9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9V10.1759C16 10.4859 15.8562 10.7784 15.6108 10.9677L13.625 12.4996Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, oT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iT
}), aT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("path", { d: "M12.0003 12.6588V10.709", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4167 6.41152L15.5875 3.58234C15.2124 3.20708 14.7036 2.99609 14.173 2.99609H6.99796C5.89293 2.99609 4.99713 3.8919 4.99713 4.99693V19.0028C4.99713 20.1078 5.89293 21.0036 6.99796 21.0036H17.0021C18.1072 21.0036 19.003 20.1078 19.003 19.0028V7.82611C19.003 7.29549 18.792 6.78666 18.4167 6.41152Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M11.9997 14.8084C11.9445 14.8084 11.8997 14.8532 11.8997 14.9084C11.8997 14.9637 11.9445 15.0085 11.9997 15.0085C12.0433 14.9966 12.0735 14.9571 12.0735 14.9119C12.0735 14.8668 12.0433 14.8272 11.9997 14.8154", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, sT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aT
}), lT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [We("circle", { cx: "12.001", cy: "8.24884", r: "4.25177", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M3.99731 20.0038C3.99731 17.5178 6.01315 15.502 8.49919 15.502H11.0833", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M15.7346 19.7718L19.2721 16.2344", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M15.7346 16.2344L19.2721 19.7718", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, cT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lT
}), dT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 6A.75.75 0 0 1 7 5.25h5.875a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75V6Zm1.5.75v4.5h5.125a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h7a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75v-6Zm1.5.75v4.5H14a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" })] }));
}, uT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dT
}), hT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.682 5.273a.75.75 0 0 1 .546.91l-3 12a.75.75 0 0 1-1.456-.365l3-12a.75.75 0 0 1 .91-.545Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 18a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM9.25 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 9.25 6Z", fill: "currentColor" })] }));
}, AT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hT
}), gT = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 5a.75.75 0 0 1 .75.75v6a3.25 3.25 0 0 0 6.5 0v-6a.75.75 0 0 1 1.5 0v6a4.75 4.75 0 1 1-9.5 0v-6A.75.75 0 0 1 8 5ZM6.25 18.75A.75.75 0 0 1 7 18h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, fT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gT
}), pT = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 14A2.75 2.75 0 0 1 16 11.25h3A2.75 2.75 0 0 1 21.75 14v5A2.75 2.75 0 0 1 19 21.75h-3A2.75 2.75 0 0 1 13.25 19v-5ZM16 3.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 5A2.75 2.75 0 0 1 16 2.25h3A2.75 2.75 0 0 1 21.75 5v2A2.75 2.75 0 0 1 19 9.75h-3A2.75 2.75 0 0 1 13.25 7V5ZM5 3.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5ZM2.25 5A2.75 2.75 0 0 1 5 2.25h3A2.75 2.75 0 0 1 10.75 5v5A2.75 2.75 0 0 1 8 12.75H5A2.75 2.75 0 0 1 2.25 10V5ZM5 15.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H5ZM2.25 17A2.75 2.75 0 0 1 5 14.25h3A2.75 2.75 0 0 1 10.75 17v2A2.75 2.75 0 0 1 8 21.75H5A2.75 2.75 0 0 1 2.25 19v-2Z", fill: "currentColor" }) }));
}, mT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pT
}), vT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.5A2.75 2.75 0 0 1 5 2.75h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 0 1 1.5 0V19.5A2.75 2.75 0 0 1 19 22.25H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.752a3.751 3.751 0 0 1 3.752-3.751h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.251v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.72a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.501a.75.75 0 1 1-1.06-1.06l1.97-1.971-1.97-1.97a.75.75 0 0 1 0-1.061Z", fill: "currentColor" })] }));
}, bT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vT
}), FT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.998a.75.75 0 0 1 .75-.75h18.008a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75ZM6.248 11a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75ZM6.25 14.5a.75.75 0 0 1 .75-.75h5a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.997 4.747a2.251 2.251 0 0 0-2.25 2.251V15a2.251 2.251 0 0 0 2.25 2.252H10a.75.75 0 0 1 0 1.5H5.997A3.751 3.751 0 0 1 2.247 15V6.998a3.752 3.752 0 0 1 3.75-3.751h12.005a3.752 3.752 0 0 1 3.752 3.751V11a.75.75 0 0 1-1.5 0V6.998a2.251 2.251 0 0 0-2.252-2.251H5.997Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.093 16.253H18.41a2.85 2.85 0 0 1 2.843 2.843V19.504c0 .69-.56 1.25-1.25 1.25H13.5c-.69 0-1.25-.56-1.25-1.25v-.409a2.85 2.85 0 0 1 2.843-2.842Zm.003 1.5a1.35 1.35 0 0 0-1.346 1.346v.155h6.003v-.155a1.35 1.35 0 0 0-1.346-1.346h-3.311ZM14 12.49a2.75 2.75 0 1 1 5.502.022 2.75 2.75 0 0 1-5.501-.022Zm2.751 1.262a1.25 1.25 0 1 0-1.25-1.256m1.25 1.256a1.25 1.25 0 0 1-1.25-1.256", fill: s.color })] }));
}, RT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FT
}), yT = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM7.253 20.008a.75.75 0 0 1 .75-.75h8.003a.75.75 0 0 1 0 1.5H8.003a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, QT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yT
}), CT = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 20.008a.75.75 0 0 1 .75-.75h8.004a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, UT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CT
}), IT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { clipRule: "evenodd", d: "M15.752 11.25a.75.75 0 0 0-.75-.75H13.5V8.998a.75.75 0 0 0-.75-.75H11.25a.75.75 0 0 0-.75.75v1.5H8.998a.75.75 0 0 0-.75.75v1.501c0 .415.335.75.75.75h1.5v1.501c0 .415.336.75.75.75h1.501a.75.75 0 0 0 .75-.75v-1.5h1.501a.75.75 0 0 0 .75-.75V11.25Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M5.633 5.633a9.004 9.004 0 1 1 0 12.734M4.497 12H1.996M5.997 8.999h-2.5M5.997 15.001h-2.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, BT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: IT
}), ZT = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.998 3.746c-.69 0-1.25.56-1.25 1.251v14.006c0 .69.56 1.25 1.25 1.25h8.004c.69 0 1.25-.56 1.25-1.25V4.997c0-.69-.56-1.25-1.25-1.25h-.75v1.026A1.307 1.307 0 0 1 14 6.147H9.999a1.307 1.307 0 0 1-1.25-1.375V3.747h-.75Zm0-1.5a2.75 2.75 0 0 0-2.75 2.751v14.006a2.75 2.75 0 0 0 2.75 2.75h8.004a2.75 2.75 0 0 0 2.75-2.75V4.997a2.75 2.75 0 0 0-2.75-2.75H7.998Zm2.251 1.5v.901h3.502v-.9H10.25Zm-1 14.257a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5H9.999a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, ST = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ZT
}), ET = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.25 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM11.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM11.25 19a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM6 17.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 19a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z", fill: "currentColor" }) }));
}, VT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ET
}), WT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.25 4a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 9a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85A.75.75 0 0 1 10.4 9ZM5.537 3.307A.75.75 0 0 1 6 4v5a.75.75 0 1 1-1.5 0V5.81a.75.75 0 0 1-1.03-1.09l1.25-1.25a.75.75 0 0 1 .817-.163ZM10.25 14a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 19a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85a.75.75 0 0 1-.75-.75ZM5 14.75a.25.25 0 0 0-.25.25.75.75 0 0 1-1.5 0c0-.966.784-1.75 1.75-1.75h.614a1.979 1.979 0 0 1 1.503 3.266L5.63 18.25H7a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.57-1.238l2.548-2.972a.479.479 0 0 0-.364-.79H5Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 9A.75.75 0 0 1 4 8.25h2.5a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 9Z", fill: "currentColor" })] }));
}, NT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: WT
}), JT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 7.394c0-.427.346-.773.772-.773h8.228a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773ZM7.114 11.515c0-.427.346-.773.772-.773h8.362a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.8 4.045a.258.258 0 0 0-.257.258v15.235l1.626-.815a.77.77 0 0 1 .69 0l2.398 1.201 2.398-1.2a.77.77 0 0 1 .69-.001l2.398 1.2 2.397-1.2a.77.77 0 0 1 .69 0l1.627.814V4.303a.258.258 0 0 0-.257-.258H4.8ZM3 4.303C3 3.308 3.806 2.5 4.8 2.5h14.4c.994 0 1.8.808 1.8 1.803v15.651c0 .96-1.007 1.578-1.86 1.152h-.001l-1.654-.829-2.167 1.086-.002.001c-.362.18-.785.18-1.146 0h-.002L12 20.277l-2.168 1.086-.002.001c-.36.18-.784.18-1.146 0h-.002l-2.167-1.087-1.654.829-.002.001A1.287 1.287 0 0 1 3 19.954V4.303Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 15.636c0-.427.346-.773.772-.773h5.142a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" })] }));
}, GT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: JT
}), TT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5A2.75 2.75 0 0 1 5 2.25a.75.75 0 0 1 0 1.5c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0ZM3 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 3 7.58ZM7.58 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 7.58 3ZM21 18.25a.75.75 0 0 1 .75.75A2.75 2.75 0 0 1 19 21.75a.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25a.75.75 0 0 1 .75-.75ZM18.25 3a.75.75 0 0 1 .75-.75A2.75 2.75 0 0 1 21.75 5a.75.75 0 0 1-1.5 0c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1-.75-.75ZM21 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM21 12.92a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM12.92 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM12.92 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM9.308 15.58a.75.75 0 0 1 0 1.061l-2.222 2.222a.75.75 0 0 1-1.06 0l-1.334-1.332a.75.75 0 1 1 1.06-1.061l.804.803 1.692-1.692a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13.75c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25H5ZM2.25 15A2.75 2.75 0 0 1 5 12.25h4A2.75 2.75 0 0 1 11.75 15v4A2.75 2.75 0 0 1 9 21.75H5A2.75 2.75 0 0 1 2.25 19v-4Z", fill: "currentColor" })] }));
}, XT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TT
}), kT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.874 5.995C2.27 4.308 3.979 2.672 5.639 3.442l14.429 6.697c1.577.731 1.577 2.989 0 3.72l-14.43 6.7c-1.659.769-3.367-.867-2.764-2.554l2.143-6.008-2.143-6.002Zm2.133-1.193a.54.54 0 0 0-.72.689l2.232 6.254a.75.75 0 0 1 0 .504l-2.232 6.26c-.171.478.31.879.72.689l14.43-6.7a.555.555 0 0 0 0-.999L5.006 4.802Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.06 12a.75.75 0 0 1 .75-.75H20.5a.75.75 0 0 1 0 1.5H5.81a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] }));
}, wT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: kT
}), DT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.385 4.82a.77.77 0 0 1 .769-.769h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 4.82a.77.77 0 0 1 .77-.769H14.05a.77.77 0 0 1 0 1.539H2.77A.77.77 0 0 1 2 4.82ZM9.18 12a.77.77 0 0 1 .769-.77H21.23a.77.77 0 0 1 0 1.54H9.949a.77.77 0 0 1-.77-.77ZM2 12a.77.77 0 0 1 .77-.77h3.076a.77.77 0 1 1 0 1.54H2.77A.77.77 0 0 1 2 12ZM17.385 19.18a.77.77 0 0 1 .769-.77h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 19.18a.77.77 0 0 1 .77-.77H14.05a.77.77 0 0 1 0 1.539H2.77a.77.77 0 0 1-.769-.77Z", fill: s.color }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.01 3.914a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002ZM8.804 11.093a1.282 1.282 0 1 0-1.813 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.087-1.088a2.82 2.82 0 1 0-3.989 3.989 2.82 2.82 0 0 0 3.99-3.988v-.001ZM17.01 18.273a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002Z", fill: s.color })] }));
}, MT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: DT
}), YT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 8.5A.5.5 0 0 1 2 8h8.253a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Z", fill: "#4E535C" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.646 5.896a.5.5 0 0 1 .708 0l2.25 2.25a.5.5 0 0 1 0 .708l-2.25 2.249a.5.5 0 1 1-.707-.707L9.543 8.5 7.646 6.604a.5.5 0 0 1 0-.708Z", fill: "#4E535C" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-1.5a.5.5 0 0 1 1 0V13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v1.5a.5.5 0 0 1-1 0V4Z", fill: "#4E535C" })] }));
}, LT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: YT
}), xT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M16 7H12", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M16 11H12", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M16 15H12", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 20.191V4C4 3.448 4.448 3 5 3H19C19.552 3 20 3.448 20 4V20.191C20 20.563 19.609 20.804 19.276 20.638L17.333 19.666L14.667 21L12 19.667L9.333 21L6.666 19.667L4.723 20.639C4.391 20.804 4 20.563 4 20.191Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M8 6.99C7.997 6.99 7.995 6.992 7.995 6.995C7.995 6.998 7.997 7 8 7C8.003 7 8.005 6.998 8.005 6.995C8.005 6.992 8.003 6.99 8 6.99", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M8 11C7.997 11 7.995 11.002 7.995 11.005C7.995 11.008 7.997 11.01 8 11.01C8.003 11.01 8.005 11.008 8.005 11.005C8.005 11.002 8.003 11 8 11", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M8 14.99C7.997 14.99 7.995 14.992 7.995 14.995C7.995 14.998 7.997 15 8 15C8.003 15 8.005 14.998 8.005 14.995C8.005 14.992 8.003 14.99 8 14.99", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, HT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: xT
}), PT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M9 17V8C9 7.448 9.448 7 10 7H15V17", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M15 7V4C15 3.448 15.448 3 16 3H20C20.552 3 21 3.448 21 4V16C21 16.552 20.552 17 20 17H4C3.448 17 3 16.552 3 16V12C3 11.448 3.448 11 4 11H9", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M3 21H21", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, OT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: PT
}), KT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.0037 12.4998V21.0033C22.0037 21.5559 21.5558 22.0038 21.0033 22.0038H15.0008C14.4483 22.0038 14.0004 21.5559 14.0004 21.0033V12.4998C14.0004 11.9473 14.4483 11.4994 15.0008 11.4994H21.0033C21.5558 11.4994 22.0037 11.9473 22.0037 12.4998Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M22.0037 15.0008H14.0004", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M7.49771 7.99789H16.0013", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M7.49771 11.4994H9.99875", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M7.49771 15.0008H9.99875", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M10.9992 19.0025H5.99708C4.89205 19.0025 3.99625 18.1067 3.99625 17.0016V5.99705C3.99625 4.89202 4.89205 3.99622 5.99708 3.99622H18.0021C19.1071 3.99622 20.0029 4.89202 20.0029 5.99705V8.9983", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M16.7516 17.2018C16.7239 17.2018 16.7015 17.2242 16.7015 17.2518C16.7015 17.2794 16.7239 17.3018 16.7516 17.3018C16.7792 17.3018 16.8016 17.2794 16.8016 17.2518C16.8016 17.2242 16.7792 17.2018 16.7516 17.2018", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19.2526 17.2018C19.225 17.2018 19.2026 17.2242 19.2026 17.2518C19.2026 17.2794 19.225 17.3018 19.2526 17.3018C19.2802 17.3018 19.3026 17.2794 19.3026 17.2518C19.3026 17.2242 19.2802 17.2018 19.2526 17.2018", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M16.7516 19.7028C16.7239 19.7028 16.7015 19.7251 16.7015 19.7528C16.7015 19.7804 16.7239 19.8028 16.7516 19.8028C16.7792 19.8028 16.8016 19.7804 16.8016 19.7528C16.8016 19.7251 16.7792 19.7028 16.7516 19.7028", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19.2526 19.7028C19.225 19.7028 19.2026 19.7251 19.2026 19.7528C19.2026 19.7804 19.225 19.8028 19.2526 19.8028C19.2802 19.8028 19.3026 19.7804 19.3026 19.7528C19.3026 19.7251 19.2802 19.7028 19.2526 19.7028", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, zT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KT
}), jT = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { d: "M19.0029 21.0038C20.108 21.0038 21.0038 20.108 21.0038 19.0029", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M21.0037 19.0029V15.0012", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M19.0029 21.0037H14.0008", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M9.99917 2.99622H4.99709C3.89206 2.99622 2.99625 3.89202 2.99625 4.99705V7.9983", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0029 10.9995H15.0013C13.8962 10.9995 13.0004 10.1037 13.0004 8.99872V4.99705C13.0004 3.89202 13.8962 2.99622 15.0013 2.99622H19.0029C20.1079 2.99622 21.0038 3.89202 21.0038 4.99705V8.99872C21.0038 10.1037 20.1079 10.9995 19.0029 10.9995Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M18.3637 6.14661L16.6629 7.84731L15.6405 6.82789", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99917 21.0037H3.49646C3.2202 21.0037 2.99625 20.7797 2.99625 20.5035V20.0973C2.99955 18.9417 3.93553 18.0057 5.09113 18.0024H8.40451C9.5601 18.0057 10.4961 18.9417 10.4994 20.0973V20.5035C10.4994 20.7797 10.2754 21.0037 9.99917 21.0037Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.74781 15.5014C5.64383 15.5014 4.74846 14.6072 4.747 13.5033C4.74553 12.3993 5.63852 11.5027 6.7425 11.4998C7.84648 11.4968 8.74423 12.3886 8.74866 13.4926C8.75077 14.0246 8.54091 14.5356 8.16545 14.9126C7.78999 15.2895 7.27986 15.5014 6.74781 15.5014Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, _T = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: jT
}), $T = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({ width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.9975 21.0038H3.99667C3.44444 21.0038 2.99625 20.5556 2.99625 20.0034V14.0009C2.99625 13.4487 3.44444 13.0005 3.99667 13.0005H5.9975C6.54973 13.0005 6.99792 13.4487 6.99792 14.0009V20.0034C6.99792 20.5556 6.54973 21.0038 5.9975 21.0038Z", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M13.0004 17.0021H15.3344C15.7676 17.0021 16.1887 16.862 16.5349 16.6019L18.9519 14.7892C19.5551 14.337 20.3995 14.397 20.9327 14.9302V14.9302C21.525 15.5225 21.525 16.4819 20.9327 17.0731L18.8589 19.147C18.3006 19.7052 17.5883 20.0864 16.814 20.2414L13.8828 20.8277C13.3015 20.9437 12.7023 20.9297 12.1271 20.7857L9.47595 20.1234C9.15882 20.0434 8.83368 20.0033 8.50655 20.0033H6.99792", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M13.0004 17.0022H14.486C15.3234 17.0022 16.0017 16.3239 16.0017 15.4865V15.1834C16.0017 14.4881 15.5285 13.8819 14.8542 13.7138L12.5612 13.1405C12.1881 13.0475 11.8059 13.0005 11.4218 13.0005V13.0005C10.4944 13.0005 9.587 13.2746 8.81567 13.7898L6.99792 15.0013", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M13.4496 4.17076L8.82268 4.17376C8.55757 4.17376 8.30346 4.2798 8.11638 4.46688L7.29104 5.29223C6.89987 5.68339 6.89987 6.31665 7.29104 6.70682L8.11938 7.53516C8.30646 7.72224 8.56157 7.82828 8.82668 7.82728L13.4526 7.82428L13.4636 7.82528C14.1269 9.11282 15.4544 10.0012 17.0041 9.99918C19.213 9.99318 21.0037 8.19744 21.0037 5.98952C21.0047 3.7806 19.216 1.99385 17.0071 1.99585C15.4634 1.99985 14.1389 2.88923 13.4726 4.17176", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), We("path", { d: "M17.0041 6.26168C17.1481 6.26168 17.2642 6.14463 17.2642 6.00057C17.2642 5.85651 17.1461 5.73947 17.0031 5.73947C16.859 5.73947 16.742 5.85651 16.742 6.00057C16.742 6.14463 16.859 6.26168 17.0041 6.26168", stroke: s.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, qT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $T
}), eX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.165 2.84a3.849 3.849 0 0 1 6.14 2.1l.004.016a.27.27 0 0 0 .204.206 4.355 4.355 0 0 1 2.757 6.681l-.004.007a.256.256 0 0 0 0 .29l.005.006a4.355 4.355 0 0 1-2.758 6.682.27.27 0 0 0-.204.205l-.003.015a3.845 3.845 0 0 1-6.14 2.112l-.004-.004a.257.257 0 0 0-.323 0l-.004.003a3.849 3.849 0 0 1-6.14-2.099l-.004-.016a.27.27 0 0 0-.204-.206 4.355 4.355 0 0 1-2.758-6.68l.005-.008a.256.256 0 0 0 0-.29l-.006-.008a4.355 4.355 0 0 1 2.759-6.68.27.27 0 0 0 .204-.205l.004-.016a3.845 3.845 0 0 1 6.14-2.105l.004.003c.084.068.2.075.291.022a.715.715 0 0 1 .035-.03Zm1.012 1.162a1.796 1.796 0 0 1-2.304.044 2.31 2.31 0 0 0-3.68 1.258 1.808 1.808 0 0 1-1.386 1.372l-.008.002a2.821 2.821 0 0 0-1.791 4.32 1.793 1.793 0 0 1 0 2.014 2.818 2.818 0 0 0 1.79 4.32l.01.002c.689.148 1.23.684 1.384 1.371a2.308 2.308 0 0 0 3.681 1.255 1.796 1.796 0 0 1 2.254 0 2.31 2.31 0 0 0 3.681-1.264 1.808 1.808 0 0 1 1.385-1.372l.009-.002a2.821 2.821 0 0 0 1.79-4.321 1.793 1.793 0 0 1 0-2.012 2.818 2.818 0 0 0-1.79-4.322l-.009-.001a1.808 1.808 0 0 1-1.385-1.371 2.308 2.308 0 0 0-3.63-1.293Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.904c.425 0 .77.344.77.769v16.653a.769.769 0 0 1-1.539 0V3.673c0-.425.344-.769.77-.769ZM17.13 14.82c-.709 0-1.283.573-1.283 1.281a.769.769 0 0 1-1.538 0 2.82 2.82 0 0 1 2.82-2.82.769.769 0 1 1 0 1.538ZM8.922 7.13c.425 0 .77.345.77.769a2.82 2.82 0 0 1-2.821 2.82.769.769 0 1 1 0-1.538c.708 0 1.282-.574 1.282-1.282 0-.424.345-.769.77-.769ZM6.101 14.05c0-.424.345-.768.77-.768A2.82 2.82 0 0 1 9.69 16.1a.769.769 0 0 1-1.538 0c0-.708-.574-1.282-1.282-1.282a.769.769 0 0 1-.77-.769ZM15.078 7.13c.425 0 .769.345.769.769 0 .708.574 1.282 1.283 1.282a.769.769 0 1 1 0 1.537A2.82 2.82 0 0 1 14.309 7.9c0-.424.344-.769.769-.769Z", fill: "currentColor" })] }));
}, tX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: eX
}), nX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.82A2.82 2.82 0 0 1 4.82 2h12.308a2.82 2.82 0 0 1 2.82 2.82V9.95a.77.77 0 0 1-1.538 0V4.82c0-.709-.573-1.283-1.282-1.283H4.821c-.709 0-1.283.574-1.283 1.283V19.18c0 .707.574 1.282 1.283 1.282h5.128a.77.77 0 1 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18V4.82Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.31 13.658c.7-.7 1.837-.7 2.538 0l1.626 1.627c.701.7.701 1.837 0 2.538l-3.65 3.651a1.795 1.795 0 0 1-1.27.526h-2.652a.77.77 0 0 1-.77-.77v-2.652c0-.476.19-.932.526-1.269l3.652-3.65Zm1.087 1.088-3.65 3.651a.257.257 0 0 0-.076.181v1.884h1.883a.256.256 0 0 0 .181-.076l3.652-3.65c.1-.101.1-.263 0-.363m-1.627-1.627Zm-.363 0c.1-.1.263-.1.363 0h-.363ZM10.975 11.23a.77.77 0 0 1 .769.77v3.077a.77.77 0 0 1-1.539 0V12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.667 13.539a.77.77 0 0 1 .769-.77h3.077a.77.77 0 0 1 0 1.539H9.436a.77.77 0 0 1-.77-.77ZM7.128 6.872a.77.77 0 0 1 .77-.77h6.153a.77.77 0 1 1 0 1.54H7.898a.77.77 0 0 1-.77-.77Z", fill: "currentColor" })] }));
}, rX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nX
}), iX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.262 2.75a1.04 1.04 0 0 0-1.04 1.04v1.039h5.659v-1.04a1.04 1.04 0 0 0-1.04-1.039H8.262Zm6.119 1.04a2.54 2.54 0 0 0-2.54-2.54H8.262a2.54 2.54 0 0 0-2.54 2.54v3.578a4.32 4.32 0 0 0 1.6 3.36l-.335 1.342a1.56 1.56 0 0 0-.43.025l-.216.043a.82.82 0 0 0-.032.007l-2.299.46a3.434 3.434 0 0 0-2.761 3.367v.344a.75.75 0 0 0 1.5 0v-.344c0-.922.65-1.716 1.555-1.897l1.419-.283v1.902a2.252 2.252 0 1 0 1.5 0v-1.912c1.133.67 2.386.908 3.724.643a.75.75 0 0 0-.291-1.472 3.628 3.628 0 0 1-2.28-.257l.305-1.22c.431.144.892.221 1.37.221.482 0 .946-.078 1.379-.224l.092.359a.75.75 0 1 0 1.453-.375l-.19-.732a4.32 4.32 0 0 0 1.596-3.357V3.79Zm-1.5 2.539H7.223v1.04a2.827 2.827 0 0 0 2.829 2.828 2.829 2.829 0 0 0 2.829-2.829v-1.04ZM6.473 17.066a.75.75 0 1 0 0 1.501.75.75 0 0 0 0-1.501ZM11.443 16.904a5.654 5.654 0 1 1 5.654 5.654.75.75 0 0 1 0-1.5 4.155 4.155 0 1 0-4.154-4.154.75.75 0 0 1-1.5 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.193 16.154a.75.75 0 0 1 .75.75c0 .628.139 1.222.387 1.756a.75.75 0 0 1 .054.47l-.396 1.898 1.893-.403a.75.75 0 0 1 .471.054 4.148 4.148 0 0 0 1.75.384.75.75 0 1 1 0 1.5c-.758 0-1.482-.15-2.144-.42l-2.783.59a.75.75 0 0 1-.89-.886l.582-2.79a5.651 5.651 0 0 1-.424-2.153.75.75 0 0 1 .75-.75ZM14.814 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.213 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM17.064 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.463 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM19.314 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.713 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132Z", fill: "currentColor" })] }));
}, oX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iX
}), aX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.846 5.509a3.004 3.004 0 0 1 3-3.009h5.657c.918 0 1.799.366 2.448 1.017l2.189 2.195a3.477 3.477 0 0 1 1.014 2.455v3.381a.693.693 0 1 1-1.385 0v-3.38c0-.553-.219-1.083-.608-1.474L14.97 4.5c-.389-.39-.917-.61-1.468-.61H7.846c-.892 0-1.615.725-1.615 1.62V8.77a.693.693 0 1 1-1.385 0V5.509Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.846 2.522c.383 0 .693.31.693.694v3.218c0 .384.31.695.692.695h3.209a.693.693 0 0 1 0 1.388h-3.21a2.08 2.08 0 0 1-2.076-2.083V3.216c0-.383.31-.694.692-.694ZM3 10.622a2.542 2.542 0 0 1 2.538-2.546h3.875a2.075 2.075 0 0 1 1.728.928l1.024 1.54c.128.194.344.31.576.31h5.72A2.542 2.542 0 0 1 21 13.4v5.554a2.542 2.542 0 0 1-2.538 2.546H5.538A2.542 2.542 0 0 1 3 18.954v-8.332Zm2.538-1.157c-.637 0-1.153.518-1.153 1.157v8.332c0 .64.516 1.157 1.153 1.157h12.924c.637 0 1.153-.518 1.153-1.157V13.4c0-.64-.516-1.158-1.153-1.158H12.74a2.075 2.075 0 0 1-1.728-.927l-1.024-1.54a.692.692 0 0 0-.576-.31H5.538Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.462 15.02c0-.384.31-.695.692-.695h2.77a.693.693 0 0 1 0 1.389h-2.77a.693.693 0 0 1-.692-.694Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.538 12.937c.383 0 .693.31.693.694v2.777a.693.693 0 1 1-1.385 0v-2.777c0-.383.31-.694.692-.694Z", fill: "currentColor" })] }));
}, sX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aX
}), lX = function(s) {
  var a = ar(s.size);
  return We("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.086 21.23a.77.77 0 0 1 .771-.768h10.286a.77.77 0 1 1 0 1.538H6.857a.77.77 0 0 1-.771-.77ZM5.829 3.538c-.71 0-1.286.574-1.286 1.283v1.025a.77.77 0 0 1-1.543 0V4.821A2.824 2.824 0 0 1 5.829 2H18.17A2.824 2.824 0 0 1 21 4.82V9.95a.77.77 0 0 1-.771.769h-4.115a.772.772 0 0 1-.622-.315l-1.714-2.335-2.73 5.582a.771.771 0 0 1-1.316.117l-2.238-3.05H4.543v4.36c0 .709.575 1.282 1.285 1.282h12.345c.709 0 1.284-.573 1.284-1.282V14.05a.77.77 0 0 1 .772-.769.77.77 0 0 1 .771.77v1.025a2.824 2.824 0 0 1-2.828 2.82H5.829A2.824 2.824 0 0 1 3 15.077V9.949a.77.77 0 0 1 .771-.77h4.115c.246 0 .477.117.622.315l1.714 2.335 2.73-5.582a.771.771 0 0 1 1.316-.117l2.238 3.05h2.951V4.82c0-.708-.575-1.282-1.286-1.282H5.83Z", fill: "currentColor" }) }));
}, cX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: lX
}), dX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.326 9.432c0-.425.343-.77.767-.77h4.093c.99 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.766.77a.769.769 0 0 1-.768-.77V10.46a.257.257 0 0 0-.256-.258h-4.093a.769.769 0 0 1-.767-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.814 4.04a.257.257 0 0 0-.256.257V20.73a.769.769 0 1 1-1.534 0V4.297c0-.992.8-1.797 1.79-1.797H15.07c.989 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.767.77a.769.769 0 0 1-.767-.77V4.297a.257.257 0 0 0-.256-.257H3.814Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.023 20.73c0 .425-.343.77-.767.77H6.628a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77h5.628c.424 0 .767.345.767.77v4.108Zm-1.534-.77v-2.568H7.395v2.568h4.094Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.442 15.852c.423 0 .767.345.767.77v4.108c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 20.73c0-.425.343-.77.767-.77h20.466c.424 0 .767.345.767.77 0 .425-.343.77-.767.77H1.767A.769.769 0 0 1 1 20.73ZM9.442 7.635c.423 0 .767.345.767.77v3.082c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77V8.404c0-.425.343-.77.767-.77Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.14 9.946c0-.425.343-.77.767-.77h3.07c.423 0 .767.345.767.77 0 .425-.344.77-.767.77h-3.07a.769.769 0 0 1-.767-.77Z", fill: "currentColor" })] }));
}, uX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: dX
}), hX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.998 5.2 6.5 6.641a1.287 1.287 0 0 0-.896 1.227v8.264c0 .562.363 1.058.896 1.227h.002l4.492 1.438a3.29 3.29 0 0 0 2.011 0l4.498-1.437c.532-.17.893-.667.893-1.228V7.87a1.287 1.287 0 0 0-.893-1.224l-4.499-1.442a3.29 3.29 0 0 0-2.006-.005Zm2.474-1.468a4.812 4.812 0 0 0-2.936-.006l-.002.001L6.04 5.168h-.001a2.83 2.83 0 0 0-1.968 2.7v8.265a2.832 2.832 0 0 0 1.968 2.7h.001l4.49 1.437a4.816 4.816 0 0 0 2.942 0l4.497-1.437a2.83 2.83 0 0 0 1.962-2.7V7.867a2.83 2.83 0 0 0-1.962-2.693l-4.496-1.442Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.396 9.139a.77.77 0 0 1 .767-.772h.227C21.384 8.367 23 9.994 23 12c0 2.007-1.616 3.634-3.61 3.634h-.227a.77.77 0 0 1-.767-.772.77.77 0 0 1 .767-.772h.227A2.083 2.083 0 0 0 21.466 12c0-1.154-.93-2.09-2.076-2.09h-.227a.77.77 0 0 1-.767-.772ZM4.61 9.911a2.083 2.083 0 0 0-2.076 2.09c0 1.154.93 2.09 2.076 2.09h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61c-1.994 0-3.61-1.627-3.61-3.634 0-2.007 1.616-3.634 3.61-3.634h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61ZM8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" })] }));
}, AX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hX
}), gX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.031 7.646a3.75 3.75 0 0 1 1.677-.396H8a.75.75 0 1 1 0 1.5H6.708c-.35 0-.694.08-1.006.237l-.585.293a2.25 2.25 0 0 0-.924.855l-1.55 2.584a.75.75 0 1 1-1.286-.771l1.55-2.585A3.75 3.75 0 0 1 4.447 7.94m0 0 .585-.293M17.5 5.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.25 7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM16.25 13a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.25 16a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM10.66 10.28a2.396 2.396 0 0 1 3.687 3.023l-2.993 4.488a4.75 4.75 0 0 1-2.337 1.832l-5.762 2.082a.75.75 0 1 1-.51-1.41l5.762-2.082a3.25 3.25 0 0 0 1.6-1.254l2.993-4.488a.896.896 0 0 0-1.38-1.13l-2.19 2.19a.75.75 0 0 1-.53.219H7a.75.75 0 1 1 0-1.5h1.69l1.97-1.97Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 4.5A2.25 2.25 0 0 1 9.5 2.25h11a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .415.336.75.75.75h11a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75V13a.75.75 0 1 1-1.5 0V4.5Z", fill: "currentColor" })] }));
}, fX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gX
}), pX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.539a8.461 8.461 0 0 0-8.461 8.46v.002A8.462 8.462 0 1 0 12 3.539h-.002Zm10 8.46C22 6.477 17.523 2 12 2S2 6.477 2 12s4.478 10 10 10c5.523 0 10.001-4.478 10-10Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.367 7.911c0-.991.803-1.795 1.794-1.795h1.678c.992 0 1.795.804 1.795 1.795V9.38h1.47c.99 0 1.794.804 1.794 1.795v1.678c0 .99-.804 1.795-1.795 1.795h-1.469v1.469c0 .99-.803 1.794-1.795 1.794h-1.678a1.795 1.795 0 0 1-1.794-1.794v-1.47h-1.47a1.795 1.795 0 0 1-1.794-1.794v-1.678c0-.991.804-1.795 1.795-1.795h1.469V7.91Zm1.794-.256a.257.257 0 0 0-.256.256v2.238a.77.77 0 0 1-.77.77H7.899a.257.257 0 0 0-.257.256v1.678c0 .141.115.256.257.256h2.238a.77.77 0 0 1 .77.77v2.238c0 .14.114.256.255.256h1.678a.257.257 0 0 0 .257-.256v-2.239a.77.77 0 0 1 .77-.769h2.237a.257.257 0 0 0 .257-.256v-1.678a.257.257 0 0 0-.257-.257h-2.238a.77.77 0 0 1-.769-.769V7.911a.257.257 0 0 0-.257-.256h-1.678Z", fill: "currentColor" })] }));
}, mX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: pX
}), vX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 16.502a.75.75 0 0 1 .75-.75h4.001a.75.75 0 0 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM18.032 15.033a.75.75 0 0 1 0 1.061l-1.876 1.876a.75.75 0 0 1-1.06 0l-1.126-1.126a.75.75 0 1 1 1.061-1.06l.595.595 1.346-1.346a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.996a4.75 4.75 0 0 1 4.75-4.75h10.008a4.75 4.75 0 0 1 4.75 4.75v10.008a4.75 4.75 0 0 1-4.75 4.75H6.996a4.75 4.75 0 0 1-4.75-4.75V6.996Zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v10.008a3.25 3.25 0 0 0 3.25 3.25h10.008a3.25 3.25 0 0 0 3.25-3.25V6.996a3.25 3.25 0 0 0-3.25-3.25H6.996Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 13a.75.75 0 0 1 .75-.75H15a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM8.498 5.748a.75.75 0 0 1 .75.75v3.001a.75.75 0 1 1-1.5 0V6.498a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 7.998a.75.75 0 0 1 .75-.75h3.001a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] }));
}, bX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vX
}), FX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.824 3.562c-.699-.7-1.833-.7-2.532 0-.7.7-.7 1.835 0 2.535.7.7 1.833.7 2.532 0 .7-.7.7-1.835 0-2.535Zm1.085-1.087a3.323 3.323 0 0 0-4.702 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.708ZM8.212 8.11a3.323 3.323 0 0 0-4.703 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.709Zm1.085-1.088a4.857 4.857 0 0 0-6.873 0 4.87 4.87 0 0 0 0 6.882 4.857 4.857 0 0 0 6.873 0 4.87 4.87 0 0 0 0-6.882Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 10.463c0-.424.344-.768.767-.768h8.186a.768.768 0 0 1 0 1.537H1.767A.768.768 0 0 1 1 10.463ZM20.784 11.911a2.321 2.321 0 0 0-3.286 0l-5.075 5.081a2.327 2.327 0 0 0 0 3.29 2.321 2.321 0 0 0 3.286 0l5.075-5.081a2.328 2.328 0 0 0 0-3.29Zm-4.371-1.086a3.855 3.855 0 0 1 5.457 0 3.865 3.865 0 0 1 0 5.463l-5.076 5.08a3.855 3.855 0 0 1-5.456 0 3.865 3.865 0 0 1 0-5.462l5.075-5.081Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.893 13.383c.3-.3.785-.3 1.085 0l4.339 4.343a.769.769 0 0 1-1.086 1.087l-4.338-4.344c-.3-.3-.3-.786 0-1.086Z", fill: "currentColor" })] }));
}, RX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FX
}), yX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.897A5.898 5.898 0 0 1 7.897 2h8.206A5.898 5.898 0 0 1 22 7.897v8.206A5.898 5.898 0 0 1 16.103 22H7.897A5.898 5.898 0 0 1 2 16.103V7.897Zm5.897-4.359a4.36 4.36 0 0 0-4.359 4.36v8.205a4.36 4.36 0 0 0 4.36 4.358h8.205a4.36 4.36 0 0 0 4.358-4.358V7.897a4.36 4.36 0 0 0-4.358-4.359H7.897Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7.06a3.334 3.334 0 0 0-3.333 3.334c0 .141.115.256.256.256h6.154a.256.256 0 0 0 .256-.256A3.333 3.333 0 0 0 12 7.06Zm-4.872 3.334a4.872 4.872 0 0 1 9.744 0c0 .992-.805 1.795-1.795 1.795H8.923a1.795 1.795 0 0 1-1.795-1.795Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.37 8.676a.77.77 0 0 1 .344 1.032l-1.026 2.051a.77.77 0 1 1-1.376-.688l1.026-2.05a.77.77 0 0 1 1.032-.345Z", fill: "currentColor" })] }));
}, QX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: yX
}), CX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.515 3.836a4.009 4.009 0 0 0-3.03 0L5.342 5.934c-.483.197-.8.666-.8 1.187v4.04c0 4.233 3.169 8.234 7.458 9.28 4.29-1.046 7.457-5.047 7.457-9.28V7.12c0-.52-.315-.989-.8-1.187l-5.142-2.098Zm.584-1.424a5.556 5.556 0 0 0-4.198 0L4.758 4.51A2.82 2.82 0 0 0 3 7.12v4.04c0 5.027 3.77 9.687 8.83 10.821a.776.776 0 0 0 .34 0c5.06-1.134 8.83-5.794 8.83-10.82V7.12a2.82 2.82 0 0 0-1.758-2.61L14.1 2.41Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.522 9.692c-.757 0-1.35.708-1.35 1.444 0 .786.522 1.577 1.268 2.228.36.313.738.563 1.057.73.16.084.295.143.398.179.052.018.086.027.105.031.019-.004.053-.013.105-.031.103-.036.238-.095.398-.178a5.703 5.703 0 0 0 1.056-.731c.747-.65 1.27-1.442 1.27-2.228 0-.735-.595-1.444-1.35-1.444-.449 0-.73.206-.902.4a.772.772 0 0 1-1.154 0 1.158 1.158 0 0 0-.901-.4Zm-2.893 1.444c0-1.4 1.109-2.982 2.893-2.982.614 0 1.104.183 1.478.423.374-.24.864-.423 1.478-.423 1.783 0 2.893 1.582 2.893 2.982 0 1.445-.921 2.624-1.797 3.387-.45.393-.928.71-1.351.932a4.525 4.525 0 0 1-.61.27c-.177.062-.396.121-.613.121-.217 0-.436-.06-.613-.12a4.525 4.525 0 0 1-.61-.27c-.423-.223-.9-.54-1.351-.933-.876-.763-1.797-1.942-1.797-3.387Z", fill: "currentColor" })] }));
}, UX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CX
}), IX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.94 12.269a1.79 1.79 0 1 0-2.532 2.532 1.79 1.79 0 0 0 2.533-2.532Zm1.085-1.086a3.326 3.326 0 1 0-4.702 4.704 3.326 3.326 0 0 0 4.703-4.704ZM1 4.837a2.813 2.813 0 0 1 2.814-2.814H5.86a.767.767 0 0 1 0 1.535H3.814c-.707 0-1.28.572-1.28 1.28V8.93a5.372 5.372 0 1 0 10.745 0V4.837c0-.707-.572-1.279-1.279-1.279H9.953a.767.767 0 0 1 0-1.535H12a2.813 2.813 0 0 1 2.814 2.814V8.93A6.907 6.907 0 1 1 1 8.93V4.837Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.907 14.302c.424 0 .767.344.767.768v1.279a5.116 5.116 0 1 0 10.233 0v-.256a.767.767 0 1 1 1.535 0v.256a6.65 6.65 0 1 1-13.302 0v-1.28c0-.423.343-.767.767-.767ZM5.86 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767ZM9.953 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767Z", fill: "currentColor" })] }));
}, BX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: IX
}), ZX = function(s) {
  var a = ar(s.size);
  return Ir("svg", qn({}, s, { width: a, height: a, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.175 3.288c.3.3.3.785 0 1.085l-4.267 4.253c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l4.267-4.254c.3-.3.787-.3 1.088 0ZM20.759 5.864c.3.3.301.785.001 1.085l-4.256 4.253c-.3.3-.788.3-1.088.002a.765.765 0 0 1-.002-1.085l4.257-4.254c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.379 5.108c.3-.3.787-.3 1.088 0l7.487 7.454c.3.299.3.784 0 1.084-.3.3-.787.3-1.087 0l-7.488-7.453c-.3-.3-.3-.785 0-1.085ZM7.057 16.959c.3.3.3.785 0 1.084l-3.744 3.732c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l3.744-3.732c.3-.3.787-.3 1.088 0ZM6.718 11.744c.3-.3.787-.3 1.087 0l1.498 1.493c.3.3.3.785 0 1.085-.3.299-.788.299-1.088 0l-1.497-1.493c-.3-.3-.3-.785 0-1.085ZM8.964 9.505c.3-.3.787-.3 1.088 0l1.497 1.493c.3.3.3.785 0 1.084-.3.3-.787.3-1.088 0L8.964 10.59c-.3-.3-.3-.785 0-1.084ZM16.02 2.225c.3-.3.788-.3 1.088 0l4.667 4.652c.3.3.3.785 0 1.084-.3.3-.788.3-1.088 0L16.02 3.31c-.3-.3-.3-.785 0-1.084Z", fill: "currentColor" }), We("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.964 6.596c.3.3.3.785 0 1.084L6.26 14.364a1.275 1.275 0 0 0 0 1.807l1.648 1.641c.5.5 1.312.5 1.813 0l6.704-6.684c.3-.299.788-.299 1.088 0 .3.3.3.786 0 1.085l-6.705 6.684a2.826 2.826 0 0 1-3.987 0l-1.649-1.64a2.806 2.806 0 0 1 0-3.977l6.705-6.684c.3-.3.787-.3 1.087 0Z", fill: "currentColor" })] }));
}, SX = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ZX
});
const xm = (s) => {
  const {
    condition: a,
    children: i
  } = s;
  return a ? /* @__PURE__ */ We(CE, { children: i }) : null;
}, EX = zA({
  actionButton: ({
    colors: s
  }, {
    isMiniMode: a
  }) => Xl`
    background: ${s.neutral[300]};
    border: none;
    color: ${s.background.white};
    cursor: pointer;

    width: ${a ? "38px" : "48px"};
    height: ${a ? "38px" : "48px"};

    ${a && Xl`
      svg {
        width: 22px;
      }

      font-size: 0.7rem;
    `}

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${a ? "4px" : "8px"};

    svg {
      fill: ${s.background.white};
    }

    &:hover {
      background: ${s.neutral[300]};
    }

    &:disabled {
      background: ${s.neutral[400]};

      color: ${s.neutral[200]};

      svg {
        fill: ${s.neutral[200]};
      }
    }
  `,
  actionOff: ({
    colors: s
  }) => Xl`
    background: ${s.background.white};
    color: ${s.neutral[300]};
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.1));

    svg {
      fill: ${s.neutral[300]};
    }

    &:hover {
      background: ${s.neutral[100]};
    }
  `,
  endCall: ({
    colors: s
  }) => Xl`
    background: ${s.feedback.error[300]};

    &:hover {
      background: ${s.feedback.error[300]};
    }

    &:disabled {
      background: ${s.feedback.error[500]};

      color: ${s.neutral[200]};

      svg {
        fill: ${s.neutral[200]};
      }
    }
  `
});
var gR = {};
const Du = eA(({
  active: s,
  disabled: a,
  icon: i,
  endCall: r,
  onClick: e,
  externalIcon: n,
  isMiniMode: t,
  busy: o,
  ...l
}, c) => {
  const d = EX({
    isMiniMode: t
  });
  return /* @__PURE__ */ Ir("button", { ref: c, css: [d.actionButton, s && d.actionOff, r && d.endCall, gR.NODE_ENV === "production" ? "" : ";label:IconButton;", gR.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9lZG5pbHNvbmFsYnVxdWVycXVlL0RvY3VtZW50cy9Qcm9qZWN0cy9jb25leGEvdm9uYWdlLWV4cHJlc3Mtc2RrL3NyYy9jb21wb25lbnRzL0ljb25CdXR0b24vaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXFDUSIsImZpbGUiOiIvVXNlcnMvZWRuaWxzb25hbGJ1cXVlcnF1ZS9Eb2N1bWVudHMvUHJvamVjdHMvY29uZXhhL3ZvbmFnZS1leHByZXNzLXNkay9zcmMvY29tcG9uZW50cy9JY29uQnV0dG9uL2luZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcywgTG9hZGVyIH0gZnJvbSBcIkBjb25leGFzYXVkZS9jb25leGEtaGVyb1wiO1xuaW1wb3J0IHsgSWNvbiwgSWNvblByb3BzIH0gZnJvbSBcIkBjb25leGFzYXVkZS9pY29uc1wiO1xuaW1wb3J0IHsgUmVhY3RFbGVtZW50LCBmb3J3YXJkUmVmIH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgeyBSZW5kZXJJZiB9IGZyb20gXCIuLi9SZW5kZXJJZlwiO1xuaW1wb3J0IHVzZVN0eWxlcyBmcm9tIFwiLi9zdHlsZXNcIjtcblxudHlwZSBJY29uQnV0dG9uUHJvcHMgPSB7XG4gIGFjdGl2ZT86IGJvb2xlYW47XG4gIGRpc2FibGVkPzogYm9vbGVhbjtcbiAgaWNvbj86IEljb25Qcm9wc1tcIm5hbWVcIl07XG4gIGVuZENhbGw/OiBib29sZWFuO1xuICBvbkNsaWNrOiAoKSA9PiB2b2lkO1xuICBleHRlcm5hbEljb24/OiBSZWFjdEVsZW1lbnQ7XG4gIGJ1c3k/OiBib29sZWFuO1xuICBpc01pbmlNb2RlPzogYm9vbGVhbjtcbn07XG5cbmV4cG9ydCBjb25zdCBJY29uQnV0dG9uID0gZm9yd2FyZFJlZjxIVE1MQnV0dG9uRWxlbWVudCwgSWNvbkJ1dHRvblByb3BzPihcbiAgKFxuICAgIHtcbiAgICAgIGFjdGl2ZSxcbiAgICAgIGRpc2FibGVkLFxuICAgICAgaWNvbixcbiAgICAgIGVuZENhbGwsXG4gICAgICBvbkNsaWNrLFxuICAgICAgZXh0ZXJuYWxJY29uLFxuICAgICAgaXNNaW5pTW9kZSxcbiAgICAgIGJ1c3ksXG4gICAgICAuLi5yZXN0XG4gICAgfSxcbiAgICByZWZcbiAgKSA9PiB7XG4gICAgY29uc3Qgc3R5bGVzID0gdXNlU3R5bGVzKHsgaXNNaW5pTW9kZSB9KTtcblxuICAgIHJldHVybiAoXG4gICAgICA8YnV0dG9uXG4gICAgICAgIHJlZj17cmVmfVxuICAgICAgICBjc3M9e1tcbiAgICAgICAgICBzdHlsZXMuYWN0aW9uQnV0dG9uLFxuICAgICAgICAgIGFjdGl2ZSAmJiBzdHlsZXMuYWN0aW9uT2ZmLFxuICAgICAgICAgIGVuZENhbGwgJiYgc3R5bGVzLmVuZENhbGwsXG4gICAgICAgIF19XG4gICAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICAgIGRpc2FibGVkPXtkaXNhYmxlZH1cbiAgICAgICAgey4uLnJlc3R9XG4gICAgICA+XG4gICAgICAgIDxSZW5kZXJJZiBjb25kaXRpb249e2J1c3l9PlxuICAgICAgICAgIDxMb2FkZXJcbiAgICAgICAgICAgIHNwaW5Db2xvcj1cIiNmZmZmXCJcbiAgICAgICAgICAgIHJpbmdDb2xvcj1cIiNmZmZmXCJcbiAgICAgICAgICAgIHN0eWxlcz17e1xuICAgICAgICAgICAgICByb290OiBjc3NgXG4gICAgICAgICAgICAgICAgcGFkZGluZzogMDtcbiAgICAgICAgICAgICAgYCxcbiAgICAgICAgICAgIH19XG4gICAgICAgICAgLz5cbiAgICAgICAgPC9SZW5kZXJJZj5cblxuICAgICAgICA8UmVuZGVySWYgY29uZGl0aW9uPXshYnVzeX0+XG4gICAgICAgICAge2V4dGVybmFsSWNvbiB8fCAoaWNvbiAmJiA8SWNvbiBuYW1lPXtpY29ufSAvPil9XG4gICAgICAgIDwvUmVuZGVySWY+XG4gICAgICA8L2J1dHRvbj5cbiAgICApO1xuICB9XG4pO1xuXG5JY29uQnV0dG9uLmRpc3BsYXlOYW1lID0gXCJJY29uQnV0dG9uXCI7XG4iXX0= */"], onClick: e, disabled: a, ...l, children: [
    /* @__PURE__ */ We(xm, { condition: o, children: /* @__PURE__ */ We(ZE, { spinColor: "#ffff", ringColor: "#ffff", styles: {
      root: Xl`
                padding: 0;
              `
    } }) }),
    /* @__PURE__ */ We(xm, { condition: !o, children: n || i && /* @__PURE__ */ We(Nm, { name: i }) })
  ] });
});
Du.displayName = "IconButton";
var Ob = { exports: {} }, MA = typeof Reflect == "object" ? Reflect : null, fR = MA && typeof MA.apply == "function" ? MA.apply : function(a, i, r) {
  return Function.prototype.apply.call(a, i, r);
}, Jm;
MA && typeof MA.ownKeys == "function" ? Jm = MA.ownKeys : Object.getOwnPropertySymbols ? Jm = function(a) {
  return Object.getOwnPropertyNames(a).concat(Object.getOwnPropertySymbols(a));
} : Jm = function(a) {
  return Object.getOwnPropertyNames(a);
};
function VX(s) {
  console && console.warn && console.warn(s);
}
var aI = Number.isNaN || function(a) {
  return a !== a;
};
function zs() {
  zs.init.call(this);
}
Ob.exports = zs;
Ob.exports.once = GX;
zs.EventEmitter = zs;
zs.prototype._events = void 0;
zs.prototype._eventsCount = 0;
zs.prototype._maxListeners = void 0;
var pR = 10;
function A1(s) {
  if (typeof s != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof s);
}
Object.defineProperty(zs, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return pR;
  },
  set: function(s) {
    if (typeof s != "number" || s < 0 || aI(s))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + s + ".");
    pR = s;
  }
});
zs.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
zs.prototype.setMaxListeners = function(a) {
  if (typeof a != "number" || a < 0 || aI(a))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + a + ".");
  return this._maxListeners = a, this;
};
function sI(s) {
  return s._maxListeners === void 0 ? zs.defaultMaxListeners : s._maxListeners;
}
zs.prototype.getMaxListeners = function() {
  return sI(this);
};
zs.prototype.emit = function(a) {
  for (var i = [], r = 1; r < arguments.length; r++) i.push(arguments[r]);
  var e = a === "error", n = this._events;
  if (n !== void 0)
    e = e && n.error === void 0;
  else if (!e)
    return !1;
  if (e) {
    var t;
    if (i.length > 0 && (t = i[0]), t instanceof Error)
      throw t;
    var o = new Error("Unhandled error." + (t ? " (" + t.message + ")" : ""));
    throw o.context = t, o;
  }
  var l = n[a];
  if (l === void 0)
    return !1;
  if (typeof l == "function")
    fR(l, this, i);
  else
    for (var c = l.length, d = hI(l, c), r = 0; r < c; ++r)
      fR(d[r], this, i);
  return !0;
};
function lI(s, a, i, r) {
  var e, n, t;
  if (A1(i), n = s._events, n === void 0 ? (n = s._events = /* @__PURE__ */ Object.create(null), s._eventsCount = 0) : (n.newListener !== void 0 && (s.emit(
    "newListener",
    a,
    i.listener ? i.listener : i
  ), n = s._events), t = n[a]), t === void 0)
    t = n[a] = i, ++s._eventsCount;
  else if (typeof t == "function" ? t = n[a] = r ? [i, t] : [t, i] : r ? t.unshift(i) : t.push(i), e = sI(s), e > 0 && t.length > e && !t.warned) {
    t.warned = !0;
    var o = new Error("Possible EventEmitter memory leak detected. " + t.length + " " + String(a) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    o.name = "MaxListenersExceededWarning", o.emitter = s, o.type = a, o.count = t.length, VX(o);
  }
  return s;
}
zs.prototype.addListener = function(a, i) {
  return lI(this, a, i, !1);
};
zs.prototype.on = zs.prototype.addListener;
zs.prototype.prependListener = function(a, i) {
  return lI(this, a, i, !0);
};
function WX() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function cI(s, a, i) {
  var r = { fired: !1, wrapFn: void 0, target: s, type: a, listener: i }, e = WX.bind(r);
  return e.listener = i, r.wrapFn = e, e;
}
zs.prototype.once = function(a, i) {
  return A1(i), this.on(a, cI(this, a, i)), this;
};
zs.prototype.prependOnceListener = function(a, i) {
  return A1(i), this.prependListener(a, cI(this, a, i)), this;
};
zs.prototype.removeListener = function(a, i) {
  var r, e, n, t, o;
  if (A1(i), e = this._events, e === void 0)
    return this;
  if (r = e[a], r === void 0)
    return this;
  if (r === i || r.listener === i)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete e[a], e.removeListener && this.emit("removeListener", a, r.listener || i));
  else if (typeof r != "function") {
    for (n = -1, t = r.length - 1; t >= 0; t--)
      if (r[t] === i || r[t].listener === i) {
        o = r[t].listener, n = t;
        break;
      }
    if (n < 0)
      return this;
    n === 0 ? r.shift() : NX(r, n), r.length === 1 && (e[a] = r[0]), e.removeListener !== void 0 && this.emit("removeListener", a, o || i);
  }
  return this;
};
zs.prototype.off = zs.prototype.removeListener;
zs.prototype.removeAllListeners = function(a) {
  var i, r, e;
  if (r = this._events, r === void 0)
    return this;
  if (r.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[a] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[a]), this;
  if (arguments.length === 0) {
    var n = Object.keys(r), t;
    for (e = 0; e < n.length; ++e)
      t = n[e], t !== "removeListener" && this.removeAllListeners(t);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (i = r[a], typeof i == "function")
    this.removeListener(a, i);
  else if (i !== void 0)
    for (e = i.length - 1; e >= 0; e--)
      this.removeListener(a, i[e]);
  return this;
};
function dI(s, a, i) {
  var r = s._events;
  if (r === void 0)
    return [];
  var e = r[a];
  return e === void 0 ? [] : typeof e == "function" ? i ? [e.listener || e] : [e] : i ? JX(e) : hI(e, e.length);
}
zs.prototype.listeners = function(a) {
  return dI(this, a, !0);
};
zs.prototype.rawListeners = function(a) {
  return dI(this, a, !1);
};
zs.listenerCount = function(s, a) {
  return typeof s.listenerCount == "function" ? s.listenerCount(a) : uI.call(s, a);
};
zs.prototype.listenerCount = uI;
function uI(s) {
  var a = this._events;
  if (a !== void 0) {
    var i = a[s];
    if (typeof i == "function")
      return 1;
    if (i !== void 0)
      return i.length;
  }
  return 0;
}
zs.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Jm(this._events) : [];
};
function hI(s, a) {
  for (var i = new Array(a), r = 0; r < a; ++r)
    i[r] = s[r];
  return i;
}
function NX(s, a) {
  for (; a + 1 < s.length; a++)
    s[a] = s[a + 1];
  s.pop();
}
function JX(s) {
  for (var a = new Array(s.length), i = 0; i < a.length; ++i)
    a[i] = s[i].listener || s[i];
  return a;
}
function GX(s, a) {
  return new Promise(function(i, r) {
    function e(t) {
      s.removeListener(a, n), r(t);
    }
    function n() {
      typeof s.removeListener == "function" && s.removeListener("error", e), i([].slice.call(arguments));
    }
    AI(s, a, n, { once: !0 }), a !== "error" && TX(s, e, { once: !0 });
  });
}
function TX(s, a, i) {
  typeof s.on == "function" && AI(s, "error", a, i);
}
function AI(s, a, i, r) {
  if (typeof s.on == "function")
    r.once ? s.once(a, i) : s.on(a, i);
  else if (typeof s.addEventListener == "function")
    s.addEventListener(a, function e(n) {
      r.once && s.removeEventListener(a, e), i(n);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof s);
}
var Qd = Ob.exports, gI = { exports: {} };
/**
 * @license OpenTok.js 2.27.6 cf306f8
 *
 * Copyright (c) 2010-2024 TokBox, Inc.
 * Subject to the applicable Software Development Kit (SDK) License Agreement:
 * https://www.vonage.com/legal/communications-apis/terms-of-use/
 *
 * Date: Wed, 05 Jun 2024 14:03:04 GMT
 */
(function(s, a) {
  (function(r, e) {
    s.exports = e();
  })(window, function() {
    return (
      /******/
      function(i) {
        var r = {};
        function e(n) {
          if (r[n])
            return r[n].exports;
          var t = r[n] = {
            /******/
            i: n,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return i[n].call(t.exports, t, t.exports, e), t.l = !0, t.exports;
        }
        return e.m = i, e.c = r, e.d = function(n, t, o) {
          e.o(n, t) || Object.defineProperty(n, t, { enumerable: !0, get: o });
        }, e.r = function(n) {
          typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(n, "__esModule", { value: !0 });
        }, e.t = function(n, t) {
          if (t & 1 && (n = e(n)), t & 8 || t & 4 && typeof n == "object" && n && n.__esModule) return n;
          var o = /* @__PURE__ */ Object.create(null);
          if (e.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: n }), t & 2 && typeof n != "string") for (var l in n) e.d(o, l, function(c) {
            return n[c];
          }.bind(null, l));
          return o;
        }, e.n = function(n) {
          var t = n && n.__esModule ? (
            /******/
            function() {
              return n.default;
            }
          ) : (
            /******/
            function() {
              return n;
            }
          );
          return e.d(t, "a", t), t;
        }, e.o = function(n, t) {
          return Object.prototype.hasOwnProperty.call(n, t);
        }, e.p = "", e(e.s = 353);
      }([
        /* 0 */
        /***/
        function(i, r) {
          function e(n) {
            return n && n.__esModule ? n : {
              default: n
            };
          }
          i.exports = e;
        },
        /* 1 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(408)), o = n(e(126)), l = n(e(127));
          const c = (0, o.default)((u) => {
            const h = {};
            return (() => {
              Object.keys(l.default).forEach((g) => {
                const f = l.default[g].method, p = (0, t.default)(`OpenTok:${u}:${g.toLowerCase()}`);
                p.log = console[f].bind(console), h[g.toLowerCase()] = p;
              });
            })(), h;
          });
          c.setLogLevel = (u) => {
            let h;
            try {
              h = (typeof window !== void 0 ? window : Dn).localStorage.debug;
            } catch {
              h = "";
            }
            const g = [...Object.keys(l.default).map((f) => `${u >= l.default[f].priority ? "" : "-"}(autogen)?OpenTok:*:${f.toLowerCase()}`), ...(h || "").split(/[\s,]/).filter((f) => f.indexOf("(autogen)?") === -1)].filter((f) => f).join(",");
            t.default.enable(g);
          };
          var d = c;
          r.default = d;
        },
        /* 2 */
        /***/
        function(i, r, e) {
          (function(n) {
            /*!
            * @overview es6-promise - a tiny implementation of Promises/A+.
            * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
            * @license   Licensed under MIT license
            *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
            * @version   v4.2.8+1e68dce6
            */
            (function(t, o) {
              i.exports = o();
            })(this, function() {
              function t(Ge) {
                var Ye = typeof Ge;
                return Ge !== null && (Ye === "object" || Ye === "function");
              }
              function o(Ge) {
                return typeof Ge == "function";
              }
              var l = void 0;
              Array.isArray ? l = Array.isArray : l = function(Ge) {
                return Object.prototype.toString.call(Ge) === "[object Array]";
              };
              var c = l, d = 0, u = void 0, h = void 0, A = function(Ye, Qt) {
                w[d] = Ye, w[d + 1] = Qt, d += 2, d === 2 && (h ? h(W) : Z());
              };
              function g(Ge) {
                h = Ge;
              }
              function f(Ge) {
                A = Ge;
              }
              var p = typeof window != "undefined" ? window : void 0, v = p || {}, b = v.MutationObserver || v.WebKitMutationObserver, m = typeof self == "undefined" && typeof n != "undefined" && {}.toString.call(n) === "[object process]", y = typeof Uint8ClampedArray != "undefined" && typeof importScripts != "undefined" && typeof MessageChannel != "undefined";
              function U() {
                return function() {
                  return n.nextTick(W);
                };
              }
              function B() {
                return typeof u != "undefined" ? function() {
                  u(W);
                } : J();
              }
              function Q() {
                var Ge = 0, Ye = new b(W), Qt = document.createTextNode("");
                return Ye.observe(Qt, { characterData: !0 }), function() {
                  Qt.data = Ge = ++Ge % 2;
                };
              }
              function N() {
                var Ge = new MessageChannel();
                return Ge.port1.onmessage = W, function() {
                  return Ge.port2.postMessage(0);
                };
              }
              function J() {
                var Ge = setTimeout;
                return function() {
                  return Ge(W, 1);
                };
              }
              var w = new Array(1e3);
              function W() {
                for (var Ge = 0; Ge < d; Ge += 2) {
                  var Ye = w[Ge], Qt = w[Ge + 1];
                  Ye(Qt), w[Ge] = void 0, w[Ge + 1] = void 0;
                }
                d = 0;
              }
              function G() {
                try {
                  var Ge = Function("return this")().require("vertx");
                  return u = Ge.runOnLoop || Ge.runOnContext, B();
                } catch {
                  return J();
                }
              }
              var Z = void 0;
              m ? Z = U() : b ? Z = Q() : y ? Z = N() : p === void 0 ? Z = G() : Z = J();
              function K(Ge, Ye) {
                var Qt = this, tn = new this.constructor(de);
                tn[O] === void 0 && Kt(tn);
                var vn = Qt._state;
                if (vn) {
                  var Yt = arguments[vn - 1];
                  A(function() {
                    return Ft(vn, tn, Yt, Qt._result);
                  });
                } else
                  _t(Qt, tn, Ge, Ye);
                return tn;
              }
              function L(Ge) {
                var Ye = this;
                if (Ge && typeof Ge == "object" && Ge.constructor === Ye)
                  return Ge;
                var Qt = new Ye(de);
                return Le(Qt, Ge), Qt;
              }
              var O = Math.random().toString(36).substring(2);
              function de() {
              }
              var oe = void 0, fe = 1, ge = 2;
              function we() {
                return new TypeError("You cannot resolve a promise with itself");
              }
              function _e() {
                return new TypeError("A promises callback cannot return that same promise.");
              }
              function Te(Ge, Ye, Qt, tn) {
                try {
                  Ge.call(Ye, Qt, tn);
                } catch (vn) {
                  return vn;
                }
              }
              function Pe(Ge, Ye, Qt) {
                A(function(tn) {
                  var vn = !1, Yt = Te(Qt, Ye, function(Tn) {
                    vn || (vn = !0, Ye !== Tn ? Le(tn, Tn) : pt(tn, Tn));
                  }, function(Tn) {
                    vn || (vn = !0, kt(tn, Tn));
                  }, "Settle: " + (tn._label || " unknown promise"));
                  !vn && Yt && (vn = !0, kt(tn, Yt));
                }, Ge);
              }
              function $e(Ge, Ye) {
                Ye._state === fe ? pt(Ge, Ye._result) : Ye._state === ge ? kt(Ge, Ye._result) : _t(Ye, void 0, function(Qt) {
                  return Le(Ge, Qt);
                }, function(Qt) {
                  return kt(Ge, Qt);
                });
              }
              function Bt(Ge, Ye, Qt) {
                Ye.constructor === Ge.constructor && Qt === K && Ye.constructor.resolve === L ? $e(Ge, Ye) : Qt === void 0 ? pt(Ge, Ye) : o(Qt) ? Pe(Ge, Ye, Qt) : pt(Ge, Ye);
              }
              function Le(Ge, Ye) {
                if (Ge === Ye)
                  kt(Ge, we());
                else if (t(Ye)) {
                  var Qt = void 0;
                  try {
                    Qt = Ye.then;
                  } catch (tn) {
                    kt(Ge, tn);
                    return;
                  }
                  Bt(Ge, Ye, Qt);
                } else
                  pt(Ge, Ye);
              }
              function at(Ge) {
                Ge._onerror && Ge._onerror(Ge._result), Lt(Ge);
              }
              function pt(Ge, Ye) {
                Ge._state === oe && (Ge._result = Ye, Ge._state = fe, Ge._subscribers.length !== 0 && A(Lt, Ge));
              }
              function kt(Ge, Ye) {
                Ge._state === oe && (Ge._state = ge, Ge._result = Ye, A(at, Ge));
              }
              function _t(Ge, Ye, Qt, tn) {
                var vn = Ge._subscribers, Yt = vn.length;
                Ge._onerror = null, vn[Yt] = Ye, vn[Yt + fe] = Qt, vn[Yt + ge] = tn, Yt === 0 && Ge._state && A(Lt, Ge);
              }
              function Lt(Ge) {
                var Ye = Ge._subscribers, Qt = Ge._state;
                if (Ye.length !== 0) {
                  for (var tn = void 0, vn = void 0, Yt = Ge._result, Tn = 0; Tn < Ye.length; Tn += 3)
                    tn = Ye[Tn], vn = Ye[Tn + Qt], tn ? Ft(Qt, tn, vn, Yt) : vn(Yt);
                  Ge._subscribers.length = 0;
                }
              }
              function Ft(Ge, Ye, Qt, tn) {
                var vn = o(Qt), Yt = void 0, Tn = void 0, er = !0;
                if (vn) {
                  try {
                    Yt = Qt(tn);
                  } catch (lr) {
                    er = !1, Tn = lr;
                  }
                  if (Ye === Yt) {
                    kt(Ye, _e());
                    return;
                  }
                } else
                  Yt = tn;
                Ye._state !== oe || (vn && er ? Le(Ye, Yt) : er === !1 ? kt(Ye, Tn) : Ge === fe ? pt(Ye, Yt) : Ge === ge && kt(Ye, Yt));
              }
              function Zt(Ge, Ye) {
                try {
                  Ye(function(tn) {
                    Le(Ge, tn);
                  }, function(tn) {
                    kt(Ge, tn);
                  });
                } catch (Qt) {
                  kt(Ge, Qt);
                }
              }
              var ft = 0;
              function It() {
                return ft++;
              }
              function Kt(Ge) {
                Ge[O] = ft++, Ge._state = void 0, Ge._result = void 0, Ge._subscribers = [];
              }
              function Sn() {
                return new Error("Array Methods must be provided an Array");
              }
              var Cn = function() {
                function Ge(Ye, Qt) {
                  this._instanceConstructor = Ye, this.promise = new Ye(de), this.promise[O] || Kt(this.promise), c(Qt) ? (this.length = Qt.length, this._remaining = Qt.length, this._result = new Array(this.length), this.length === 0 ? pt(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(Qt), this._remaining === 0 && pt(this.promise, this._result))) : kt(this.promise, Sn());
                }
                return Ge.prototype._enumerate = function(Qt) {
                  for (var tn = 0; this._state === oe && tn < Qt.length; tn++)
                    this._eachEntry(Qt[tn], tn);
                }, Ge.prototype._eachEntry = function(Qt, tn) {
                  var vn = this._instanceConstructor, Yt = vn.resolve;
                  if (Yt === L) {
                    var Tn = void 0, er = void 0, lr = !1;
                    try {
                      Tn = Qt.then;
                    } catch (pi) {
                      lr = !0, er = pi;
                    }
                    if (Tn === K && Qt._state !== oe)
                      this._settledAt(Qt._state, tn, Qt._result);
                    else if (typeof Tn != "function")
                      this._remaining--, this._result[tn] = Qt;
                    else if (vn === Ce) {
                      var Br = new vn(de);
                      lr ? kt(Br, er) : Bt(Br, Qt, Tn), this._willSettleAt(Br, tn);
                    } else
                      this._willSettleAt(new vn(function(pi) {
                        return pi(Qt);
                      }), tn);
                  } else
                    this._willSettleAt(Yt(Qt), tn);
                }, Ge.prototype._settledAt = function(Qt, tn, vn) {
                  var Yt = this.promise;
                  Yt._state === oe && (this._remaining--, Qt === ge ? kt(Yt, vn) : this._result[tn] = vn), this._remaining === 0 && pt(Yt, this._result);
                }, Ge.prototype._willSettleAt = function(Qt, tn) {
                  var vn = this;
                  _t(Qt, void 0, function(Yt) {
                    return vn._settledAt(fe, tn, Yt);
                  }, function(Yt) {
                    return vn._settledAt(ge, tn, Yt);
                  });
                }, Ge;
              }();
              function on(Ge) {
                return new Cn(this, Ge).promise;
              }
              function An(Ge) {
                var Ye = this;
                return c(Ge) ? new Ye(function(Qt, tn) {
                  for (var vn = Ge.length, Yt = 0; Yt < vn; Yt++)
                    Ye.resolve(Ge[Yt]).then(Qt, tn);
                }) : new Ye(function(Qt, tn) {
                  return tn(new TypeError("You must pass an array to race."));
                });
              }
              function Ue(Ge) {
                var Ye = this, Qt = new Ye(de);
                return kt(Qt, Ge), Qt;
              }
              function ne() {
                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
              }
              function se() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
              }
              var Ce = function() {
                function Ge(Ye) {
                  this[O] = It(), this._result = this._state = void 0, this._subscribers = [], de !== Ye && (typeof Ye != "function" && ne(), this instanceof Ge ? Zt(this, Ye) : se());
                }
                return Ge.prototype.catch = function(Qt) {
                  return this.then(null, Qt);
                }, Ge.prototype.finally = function(Qt) {
                  var tn = this, vn = tn.constructor;
                  return o(Qt) ? tn.then(function(Yt) {
                    return vn.resolve(Qt()).then(function() {
                      return Yt;
                    });
                  }, function(Yt) {
                    return vn.resolve(Qt()).then(function() {
                      throw Yt;
                    });
                  }) : tn.then(Qt, Qt);
                }, Ge;
              }();
              Ce.prototype.then = K, Ce.all = on, Ce.race = An, Ce.resolve = L, Ce.reject = Ue, Ce._setScheduler = g, Ce._setAsap = f, Ce._asap = A;
              function At() {
                var Ge = void 0;
                if (typeof (typeof window !== void 0 ? window : Dn) != "undefined")
                  Ge = typeof window !== void 0 ? window : Dn;
                else if (typeof self != "undefined")
                  Ge = self;
                else
                  try {
                    Ge = Function("return this")();
                  } catch {
                    throw new Error("polyfill failed because global object is unavailable in this environment");
                  }
                var Ye = Ge.Promise;
                if (Ye) {
                  var Qt = null;
                  try {
                    Qt = Object.prototype.toString.call(Ye.resolve());
                  } catch {
                  }
                  if (Qt === "[object Promise]" && !Ye.cast)
                    return;
                }
                Ge.Promise = Ce;
              }
              return Ce.polyfill = At, Ce.Promise = Ce, Ce;
            });
          }).call(this, e(27));
        },
        /* 3 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(464)), l = t.default.parse();
          r.default = l;
        },
        /* 4 */
        /***/
        function(i, r, e) {
          i.exports = e(404);
        },
        /* 5 */
        /***/
        function(i, r, e) {
          (function(n) {
            function t(l, c, d, u, h, A, g) {
              try {
                var f = l[A](g), p = f.value;
              } catch (v) {
                d(v);
                return;
              }
              f.done ? c(p) : n.resolve(p).then(u, h);
            }
            function o(l) {
              return function() {
                var c = this, d = arguments;
                return new n(function(u, h) {
                  var A = l.apply(c, d);
                  function g(p) {
                    t(A, u, h, g, f, "next", p);
                  }
                  function f(p) {
                    t(A, u, h, g, f, "throw", p);
                  }
                  g(void 0);
                });
              };
            }
            i.exports = o;
          }).call(this, e(2));
        },
        /* 6 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = h;
          var t = n(e(9)), o = n(e(17)), l = n(e(14)), c = n(e(1)), d = n(e(411));
          const u = (0, c.default)("Events");
          function h(A) {
            const g = new l.default();
            g.on("newListener", (p) => {
              g.emit(`${p}:added`);
            }), g.on("removeListener", (p) => {
              g.emit(`${p}:removed`);
            });
            const f = {
              /**
               * A map of events already dispatched.
               */
              eventsDispatched: {},
              /**
               * Adds an event handler function for one or more events.
               *
               * <p>
               * The following code adds an event handler for one event:
               * </p>
               *
               * <pre>
               * obj.on("eventName", function (event) {
               *     // This is the event handler.
               * });
               * </pre>
               *
               * <p>If you pass in multiple event names and a handler method, the handler is
               * registered for each of those events:</p>
               *
               * <pre>
               * obj.on("eventName1 eventName2",
               *        function (event) {
               *            // This is the event handler.
               *        });
               * </pre>
               *
               * <p>You can also pass in a third <code>context</code> parameter (which is optional) to
               * define the value of <code>this</code> in the handler method:</p>
               *
               * <pre>obj.on("eventName",
               *        function (event) {
               *            // This is the event handler.
               *        },
               *        obj);
               * </pre>
               *
               * <p>
               * The method also supports an alternate syntax, in which the first parameter is an object
               * that is a hash map of event names and handler functions and the second parameter (optional)
               * is the context for this in each handler:
               * </p>
               * <pre>
               * obj.on(
               *    {
               *       eventName1: function (event) {
               *               // This is the handler for eventName1.
               *           },
               *       eventName2:  function (event) {
               *               // This is the handler for eventName2.
               *           }
               *    },
               *    obj);
               * </pre>
               *
               * <p>
               * If you do not add a handler for an event, the event is ignored locally.
               * </p>
               *
               * @param {String} type The string identifying the type of event. You can specify multiple event
               * names in this string, separating them with a space. The event handler will process each of
               * the events.
               * @param {Function} handler The handler function to process the event. This function takes
               * the event object as a parameter.
               * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
               * handler function.
               *
               * @returns {EventDispatcher} The EventDispatcher object.
               *
               * @memberOf EventDispatcher
               * @method #on
               * @see <a href="#off">off()</a>
               * @see <a href="#once">once()</a>
               * @see <a href="#events">Events</a>
               */
              on(p, v, b) {
                return typeof p == "string" && v ? p.split(" ").forEach((m) => {
                  g.on(m, (0, d.default)(v, b));
                }) : Object.keys(p).forEach((m) => {
                  g.on(m, (0, d.default)(p[m], v));
                }), this;
              },
              /**
               * Removes an event handler or handlers.
               *
               * <p>If you pass in one event name and a handler method, the handler is removed for that
               * event:</p>
               *
               * <pre>obj.off("eventName", eventHandler);</pre>
               *
               * <p>If you pass in multiple event names and a handler method, the handler is removed for
               * those events:</p>
               *
               * <pre>obj.off("eventName1 eventName2", eventHandler);</pre>
               *
               * <p>If you pass in an event name (or names) and <i>no</i> handler method, all handlers are
               * removed for those events:</p>
               *
               * <pre>obj.off("event1Name event2Name");</pre>
               *
               * <p>If you pass in no arguments, <i>all</i> event handlers are removed for all events
               * dispatched by the object:</p>
               *
               * <pre>obj.off();</pre>
               *
               * <p>
               * The method also supports an alternate syntax, in which the first parameter is an object that
               * is a hash map of event names and handler functions and the second parameter (optional) is
               * the context for this in each handler:
               * </p>
               * <pre>
               * obj.off(
               *    {
               *       eventName1: event1Handler,
               *       eventName2: event2Handler
               *    });
               * </pre>
               *
               * @param {String} type (Optional) The string identifying the type of event. You can
               * use a space to specify multiple events, as in "accessAllowed accessDenied
               * accessDialogClosed". If you pass in no <code>type</code> value (or other arguments),
               * all event handlers are removed for the object.
               * @param {Function} handler (Optional) The event handler function to remove. The handler
               * must be the same function object as was passed into <code>on()</code>. Be careful with
               * helpers like <code>bind()</code> that return a new function when called. If you pass in
               * no <code>handler</code>, all event handlers are removed for the specified event
               * <code>type</code>.
               * @param {Object} context (Optional) If you specify a <code>context</code>, the event handler
               * is removed for all specified events and handlers that use the specified context. (The
               * context must match the context passed into <code>on()</code>.)
               *
               * @returns {Object} The object that dispatched the event.
               *
               * @memberOf EventDispatcher
               * @method #off
               * @see <a href="#on">on()</a>
               * @see <a href="#once">once()</a>
               * @see <a href="#events">Events</a>
               */
              off(p, v, b) {
                return typeof p == "string" ? this.off(p.split(" "), v, b) : Array.isArray(p) ? p.forEach((m) => {
                  v && (0, o.default)(v) ? g.removeListener(m, (0, d.default)(v, b)) : g.removeAllListeners(m);
                }) : p ? Object.keys(p).forEach((m) => {
                  g.removeListener(m, (0, d.default)(p[m], v));
                }) : g.removeAllListeners(), this;
              },
              /**
               * Adds an event handler function for one or more events. Once the handler is called,
               * the specified handler method is removed as a handler for this event. (When you use
               * the <code>on()</code> method to add an event handler, the handler is <i>not</i>
               * removed when it is called.) The <code>once()</code> method is the equivilent of
               * calling the <code>on()</code>
               * method and calling <code>off()</code> the first time the handler is invoked.
               *
               * <p>
               * The following code adds a one-time event handler for one event:
               * </p>
               *
               * <pre>
               * obj.once("eventName", function (event) {
               *    // This is the event handler.
               * });
               * </pre>
               *
               * <p>If you pass in multiple event names and a handler method, the handler is registered
               * for each of those events:</p>
               *
               * <pre>obj.once("eventName1 eventName2"
               *          function (event) {
               *              // This is the event handler.
               *          });
               * </pre>
               *
               * <p>You can also pass in a third <code>context</code> parameter (which is optional) to define
               * the value of
               * <code>this</code> in the handler method:</p>
               *
               * <pre>obj.once("eventName",
               *          function (event) {
               *              // This is the event handler.
               *          },
               *          obj);
               * </pre>
               *
               * <p>
               * The method also supports an alternate syntax, in which the first parameter is an object that
               * is a hash map of event names and handler functions and the second parameter (optional) is the
               * context for this in each handler:
               * </p>
               * <pre>
               * obj.once(
               *    {
               *       eventName1: function (event) {
               *                  // This is the event handler for eventName1.
               *           },
               *       eventName2:  function (event) {
               *                  // This is the event handler for eventName1.
               *           }
               *    },
               *    obj);
               * </pre>
               *
               * @param {String} type The string identifying the type of event. You can specify multiple
               * event names in this string, separating them with a space. The event handler will process
               * the first occurence of the events. After the first event, the handler is removed (for
               * all specified events).
               * @param {Function} handler The handler function to process the event. This function takes
               * the event object as a parameter.
               * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
               * handler function.
               *
               * @returns {Object} The object that dispatched the event.
               *
               * @memberOf EventDispatcher
               * @method #once
               * @see <a href="#on">on()</a>
               * @see <a href="#off">off()</a>
               * @see <a href="#events">Events</a>
               */
              once(p, v, b) {
                return typeof p == "string" && v ? p.split(" ").forEach((m) => {
                  g.once(m, (0, d.default)(v, b));
                }) : Object.keys(p).forEach((m) => {
                  g.once(m, (0, d.default)(p[m], v));
                }), this;
              },
              /**
               * Execute any listeners bound to the +event+ Event.
               *
               * Each handler will be executed.
               *
               * @param [Event] event An Event object.
               * @return this
              */
              dispatchEvent(p) {
                if (!p.type)
                  throw new Error("dispatchEvent: Event has no type");
                return p.target || (p.target = this), this.trigger(p.type, p), this;
              },
              dispatchEventOnce(p, v) {
                this.isEventDispatched(p.type, v) || (this.dispatchEvent(p), this.eventsDispatched[p.type] ? this.eventsDispatched[p.type].push(v) : this.eventsDispatched[p.type] = [v]);
              },
              isEventDispatched(p, v) {
                var b;
                return (b = this.eventsDispatched[p]) == null ? void 0 : b.includes(v);
              },
              /**
               * Execute each handler for the event called +name+.
               *
               * Each handler will be executed, and any exceptions that they throw will
               * be caught and logged
               *
               * @example
               * foo.on('bar', function(name, message) {
               *   alert("Hello " + name + ": " + message);
               * });
               *
               * foo.trigger('OpenTok', 'asdf'); // -> Hello OpenTok: asdf
               *
               * @param {String} eventName The name of this event.
               * @param {Array} arguments The arguments handlers will be called with
               *
               * @return this
               */
              trigger(p) {
                try {
                  for (var v = arguments.length, b = new Array(v > 1 ? v - 1 : 0), m = 1; m < v; m++)
                    b[m - 1] = arguments[m];
                  g.emit(p, ...b);
                } catch (y) {
                  u.error("An error occurred in an event handler", y);
                }
                return this;
              },
              // Alias of trigger for easier node compatibility
              emit() {
                return A.trigger(...arguments);
              },
              /**
               * @deprecated use <a href="#on">on()</a> or <a href="#once">once()</a> instead.
               * <p>
               * This method registers a method as an event listener for a specific event.
               * <p>
               *
               * <p>
               *   If a handler is not registered for an event, the event is ignored locally. If the
               *   event listener function does not exist, the event is ignored locally.
               * </p>
               * <p>
               *   Throws an exception if the <code>listener</code> name is invalid.
               * </p>
               *
               * @param {String} type The string identifying the type of event.
               *
               * @param {Function} listener The function to be invoked when the object dispatches the event.
               *
               * @param {Object} context (Optional) Defines the value of <code>this</code> in the event
               * handler function.
               *
               * @memberOf EventDispatcher
               * @method #addEventListener
               * @see <a href="#on">on()</a>
               * @see <a href="#once">once()</a>
               * @see <a href="#events">Events</a>
              */
              addEventListener(p, v, b) {
                return u.warn("The addEventListener() method is deprecated. Use on() or once() instead."), A.on(p, v, b);
              },
              /**
               * @deprecated use <a href="#off">off()</a> instead.
               * <p>
               * Removes an event listener for a specific event.
               * <p>
               *
               * <p>
               *   Throws an exception if the <code>listener</code> name is invalid.
               * </p>
               *
               * @param {String} type The string identifying the type of event.
               *
               * @param {Function} listener The event listener function to remove.
               *
               * @param {Object} context (Optional) If you specify a <code>context</code>, the event
               * handler is removed for all specified events and event listeners that use the specified
               context. (The context must match the context passed into
               * <code>addEventListener()</code>.)
               *
               * @memberOf EventDispatcher
               * @method #removeEventListener
               * @see <a href="#off">off()</a>
               * @see <a href="#events">Events</a>
               */
              // See 'off' for usage.
              // @depreciated will become a private helper function in the future.
              removeEventListener(p, v, b) {
                return u.warn("The removeEventListener() method is deprecated. Use off() instead."), A.off(p, v, b);
              },
              listenerCount(p) {
                return g.listenerCount(p);
              }
            };
            return (0, t.default)(A, f);
          }
        },
        /* 7 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(143)), o = n(e(255)), l = n(e(6)), c = n(e(1)), d = n(e(3)), u = n(e(257)), h = n(e(256)), A = n(e(258)), g = n(e(555)), f = n(e(260)), p = n(e(263)), v = n(e(568)), b = n(e(265));
          o.default.logging = (0, c.default)("OT.$"), o.default.env = d.default, o.default.ElementCollection = h.default, o.default.ajax = A.default, o.default.statable = g.default, o.default.Analytics = f.default, o.default.Collection = p.default, o.default.domExtras = v.default, o.default.Error = b.default, (0, u.default)(o.default, "useLogHelpers", {
            value(y) {
              const U = (0, c.default)("useLogHelpersDeprecatedMixin");
              return Object.keys(U).forEach((B) => {
                y[B] = U[B];
              }), y;
            },
            name: "OT.useLogHelpers",
            getWarning: "Please use an external library for your debugging needs"
          }), o.default.defaults = t.default, (0, u.default)(o.default, "eventing", {
            value: l.default,
            name: "OT.$.eventing",
            getWarning: "Please use an external library to create an event emitter."
          }), Object.keys(o.default).forEach((y) => {
            const B = o.default[y]._attachToOTHelpers || {};
            Object.keys(B).forEach((Q) => {
              Object.hasOwnProperty.call(o.default, Q) && !(y === "util" && Q === "bind") && console.warn(`More than one module is trying to define ${Q} on OTHelpers.`), o.default[Q] = B[Q];
            });
          });
          var m = o.default;
          r.default = m;
        },
        /* 8 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {
            // The API key does not match the token or session.
            AUTHENTICATION_ERROR: "OT_AUTHENTICATION_ERROR",
            // JSON response was badly formed.
            BADLY_FORMED_RESPONSE: "OT_BADLY_FORMED_RESPONSE",
            // Unable to publish because your browser failed to get access to your microphone. You may need to
            // fully quit and restart your browser to get it to work.
            // See https://bugs.chromium.org/p/webrtc/issues/detail?id=4799 for more details.
            CHROME_MICROPHONE_ACQUISITION_ERROR: "OT_CHROME_MICROPHONE_ACQUISITION_ERROR",
            // Failed to connect to session.
            CONNECT_FAILED: "OT_CONNECT_FAILED",
            // The session has exceded the maximum number of simultaneous connections.
            CONNECTION_LIMIT_EXCEEDED: "OT_CONNECTION_LIMIT_EXCEEDED",
            // The constraints for getting user media could not be satisfied.
            CONSTRAINTS_NOT_SATISFIED: "OT_CONSTRAINTS_NOT_SATISFIED",
            // Failed to create peer connection.
            CREATE_PEER_CONNECTION_FAILED: "OT_CREATE_PEER_CONNECTION_FAILED",
            // Action failed due to session disconnection.
            DISCONNECTED: "OT_DISCONNECTED",
            // Received an unexpected empty response from the server.
            EMPTY_RESPONSE_BODY: "OT_EMPTY_RESPONSE_BODY",
            // Attempted to call getRtcStatsReport in a browser that doesn't support standard getStats API.
            GET_RTC_STATS_REPORT_NOT_SUPPORTED: "OT_GET_RTC_STATS_REPORT_NOT_SUPPORTED",
            // The hardware to fulfil the user media request appears to exist but could not be acquired. It
            // might be in use by another application.
            HARDWARE_UNAVAILABLE: "OT_HARDWARE_UNAVAILABLE",
            // Something went wrong while establishing WebRTC connectivity.
            ICE_WORKFLOW_FAILED: "OT_ICE_WORKFLOW_FAILED",
            // Received an invalid HTTP status. This may be considered invalid for the endpoint only and not
            // HTTP in general.
            INVALID_HTTP_STATUS: "OT_INVALID_HTTP_STATUS",
            // One or more parameters was not valid or not provided.
            INVALID_PARAMETER: "OT_INVALID_PARAMETER",
            // The session id was invalid.
            INVALID_SESSION_ID: "OT_INVALID_SESSION_ID",
            // The fetching of the stream for the video element has been aborted.
            MEDIA_ERR_ABORTED: "OT_MEDIA_ERR_ABORTED",
            // A decoding error occurred while trying to play the stream in the video element.
            MEDIA_ERR_DECODE: "OT_MEDIA_ERR_DECODE",
            // A network error caused the stream to stop being fetched.
            MEDIA_ERR_NETWORK: "OT_MEDIA_ERR_NETWORK",
            // The stream has been detected to be not suitable for playback.
            MEDIA_ERR_SRC_NOT_SUPPORTED: "OT_MEDIA_ERR_SRC_NOT_SUPPORTED",
            // The ended event on the video element fired
            MEDIA_ENDED: "OT_MEDIA_ENDED",
            // No devices were found to provide the media stream.
            NO_DEVICES_FOUND: "OT_NO_DEVICES_FOUND",
            // Video and audio was disabled. You need to enable at least one.
            NO_VALID_CONSTRAINTS: "OT_NO_VALID_CONSTRAINTS",
            // Couldn't perform action due to not being connected.
            NOT_CONNECTED: "OT_NOT_CONNECTED",
            // A resource was not found.
            NOT_FOUND: "OT_NOT_FOUND",
            // Something in the user media request is not supported.
            NOT_SUPPORTED: "OT_NOT_SUPPORTED",
            // Couldn't perform an action because the Peer Connection is not connected.
            PEER_CONNECTION_NOT_CONNECTED: "OT_PEER_CONNECTION_NOT_CONNECTED",
            // An action was not permitted.
            PERMISSION_DENIED: "OT_PERMISSION_DENIED",
            // The signal could not be sent due to the rate limit.
            RATE_LIMIT_EXCEEDED: "OT_RATE_LIMIT_EXCEEDED",
            // Error calling OT.reportIssue(). Check the client\'s network connection.
            REPORT_ISSUE_FAILED: "OT_REPORT_ISSUE_FAILED",
            // Screen-sharing support in this browser requires an extension, but the extension is not
            // installed.
            SCREEN_SHARING_EXTENSION_NOT_INSTALLED: "OT_SCREEN_SHARING_EXTENSION_NOT_INSTALLED",
            // Screen-sharing support in this browser requires an extension, but one has not been registered.
            SCREEN_SHARING_EXTENSION_NOT_REGISTERED: "OT_SCREEN_SHARING_EXTENSION_NOT_REGISTERED",
            // Screen sharing is not supported in the browser.
            SCREEN_SHARING_NOT_SUPPORTED: "OT_SCREEN_SHARING_NOT_SUPPORTED",
            // The WebRTC connection failed during setDescription.
            SET_REMOTE_DESCRIPTION_FAILED: "OT_SET_REMOTE_DESCRIPTION_FAILED",
            // Setting the ICE configuration failed.
            FAILED_SET_CONFIGURATION: "OT_FAILED_SET_CONFIGURATION",
            // Rumor.Socket cannot connect when it is already connecting or connected.
            SOCKET_ALREADY_CONNECTED_CONNECTING: "OT_SOCKET_ALREADY_CONNECTED_CONNECTING",
            // A connection was closed abnormally (that is, with no close frame being sent) when a status code
            // is expected.
            SOCKET_CLOSE_ABNORMAL: "OT_SOCKET_CLOSE_ABNORMAL",
            // Exception was thrown during Rumor connection, possibly because of a blocked port.
            SOCKET_CLOSE_CONNECT_EXCEPTION: "OT_SOCKET_CLOSE_CONNECT_EXCEPTION",
            // Connectivity loss was detected as it was too long since the socket received the last PONG
            // message.
            SOCKET_CLOSE_CONNECTIVITY_LOSS: "OT_SOCKET_CLOSE_CONNECTIVITY_LOSS",
            // Falling back on this error for socket close because a more suitable one was not found.
            SOCKET_CLOSE_FALLBACK_CODE: "OT_SOCKET_CLOSE_FALLBACK_CODE",
            // An endpoint received data within a message that was not consistent with the type of the message
            // (e.g., non-UTF-8 [RFC3629] data within a text message)
            SOCKET_CLOSE_INCONSISTENT_DATA: "OT_SOCKET_CLOSE_INCONSISTENT_DATA",
            // No status code was provided even though one was expected.
            SOCKET_CLOSE_NO_STATUS: "OT_SOCKET_CLOSE_NO_STATUS",
            // An endpoint received a message that violates its policy.  This is a generic status code that
            // can be returned when there is no other more suitable status code (e.g., 1003 or 1009) or if
            // there is a need to hide specific details about the policy.
            SOCKET_CLOSE_POLICY_VIOLATION: "OT_SOCKET_CLOSE_POLICY_VIOLATION",
            // The endpoint is going away, either because of a server failure or because the browser is
            // navigating away from the page that opened the connection.
            SOCKET_CLOSE_GOING_AWAY: "OT_SOCKET_CLOSE_GOING_AWAY",
            // A protocol error occurred.
            SOCKET_CLOSE_PROTOCOL_ERROR: "OT_SOCKET_CLOSE_PROTOCOL_ERROR",
            // Timed out while waiting for the Rumor socket to connect.
            SOCKET_CLOSE_TIMEOUT: "OT_SOCKET_CLOSE_TIMEOUT",
            // An endpoint received a message that is too big for it to process
            SOCKET_CLOSE_TOO_LARGE: "OT_SOCKET_CLOSE_TOO_LARGE",
            // An endpoint encountered an unexpected condition that prevented it from fulfilling the request.
            SOCKET_CLOSE_UNEXPECTED_CONDITION: "OT_SOCKET_CLOSE_UNEXPECTED_CONDITION",
            // An endpoint has indicated that reconnections are not available.
            SOCKET_CLOSE_UNSUPPORTED: "OT_SOCKET_CLOSE_UNSUPPORTED",
            // Failed to create the stream in the server model.
            STREAM_CREATE_FAILED: "OT_STREAM_CREATE_FAILED",
            // The stream was destroyed before it could be subscribed to.
            STREAM_DESTROYED: "OT_STREAM_DESTROYED",
            // The session has exceded the maximum number of simultaneous streams.
            STREAM_LIMIT_EXCEEDED: "OT_STREAM_LIMIT_EXCEEDED",
            // Couldn't subscribe to the stream because it was not found.
            STREAM_NOT_FOUND: "OT_STREAM_NOT_FOUND",
            // Couldn't subscribe to stream due to unexpected error from rumor
            UNABLE_TO_SUBSCRIBE: "OT_UNABLE_TO_SUBSCRIBE",
            // Couldn't connect due to a terms of service violation.
            TERMS_OF_SERVICE_FAILURE: "OT_TERMS_OF_SERVICE_FAILURE",
            // A timer expired while waiting for an action to occur.
            TIMEOUT: "OT_TIMEOUT",
            // The operation was cancelled
            CANCEL: "OT_CANCEL",
            // Generic media abort error
            UNABLE_TO_CAPTURE_MEDIA: "OT_UNABLE_TO_CAPTURE_MEDIA",
            // Generic/ Unknown screen share error
            UNABLE_TO_CAPTURE_SCREEN: "OT_UNABLE_TO_CAPTURE_SCREEN",
            // The error code received was unexpected.
            UNEXPECTED_ERROR_CODE: "OT_UNEXPECTED_ERROR_CODE",
            // Received an unexpected HTTP status.
            UNEXPECTED_HTTP_STATUS: "OT_UNEXPECTED_HTTP_STATUS",
            // An unexpected server response was received which could not be handled.
            UNEXPECTED_SERVER_RESPONSE: "OT_UNEXPECTED_SERVER_RESPONSE",
            // An unknown anvil error occurred.
            UNKNOWN_HTTP_ERROR: "OT_UNKNOWN_HTTP_ERROR",
            UNSUPPORTED_BROWSER: "OT_UNSUPPORTED_BROWSER",
            // Access to user media was denied.
            USER_MEDIA_ACCESS_DENIED: "OT_USER_MEDIA_ACCESS_DENIED",
            // There was a cross domain error or the server responded with invalid JSON.
            XDOMAIN_OR_PARSING_ERROR: "OT_XDOMAIN_OR_PARSING_ERROR",
            API_KEY_DISABLED: "OT_API_KEY_DISABLED",
            // There was an error when trying to get the list of supported codecs.
            UNABLE_TO_ACCESS_MEDIA_ENGINE: "OT_UNABLE_TO_ACCESS_MEDIA_ENGINE",
            // The proxyUrl was set after a session or publisher were created.
            SET_PROXY_URL_TIMING_ERROR: "OT_SET_PROXY_URL_TIMING_ERROR",
            // The proxyUrl has already been set. Setting it again will not have any effect
            PROXY_URL_ALREADY_SET_ERROR: "OT_PROXY_URL_ALREADY_SET_ERROR",
            // You cannot reset the video source on a publisher that does not currently include a video track.
            SET_VIDEO_SOURCE_FAILURE: "OT_SET_VIDEO_SOURCE_FAILURE",
            // Invalid video source. Video source must be a valid video input deviceId
            INVALID_VIDEO_SOURCE: "OT_INVALID_VIDEO_SOURCE",
            // The requested audio device does not have permissions to be used.
            REQUESTED_DEVICE_PERMISSION_DENIED: "OT_REQUESTED_DEVICE_PERMISSION_DENIED",
            // Invalid output audio device ID. It must be a valid video output deviceId.
            INVALID_AUDIO_OUTPUT_SOURCE: "OT_INVALID_AUDIO_OUTPUT_SOURCE",
            // Invalid encryption secret. Must be a string and match length requirements.
            INVALID_ENCRYPTION_SECRET: "OT_INVALID_ENCRYPTION_SECRET"
          };
          r.default = n;
        },
        /* 9 */
        /***/
        function(i, r, e) {
          var n = e(85), t = e(45), o = e(204), l = e(26), c = e(68), d = e(34), u = Object.prototype, h = u.hasOwnProperty, A = o(function(g, f) {
            if (c(f) || l(f)) {
              t(f, d(f), g);
              return;
            }
            for (var p in f)
              h.call(f, p) && n(g, p, f[p]);
          });
          i.exports = A;
        },
        /* 10 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = {
            JS_EXCEPTION: 2e3,
            AUTHENTICATION_ERROR: 1004,
            INVALID_SESSION_ID: 1005,
            CONNECT_FAILED: 1006,
            CONNECT_REJECTED: 1007,
            CONNECTION_TIMEOUT: 1008,
            NOT_CONNECTED: 1010,
            INVALID_PARAMETER: 1011,
            P2P_CONNECTION_FAILED: 1013,
            API_RESPONSE_FAILURE: 1014,
            PEER_CONNECTION_NOT_CONNECTED: 1015,
            TERMS_OF_SERVICE_FAILURE: 1026,
            CONNECTION_LIMIT_EXCEEDED: 1027,
            UNABLE_TO_PUBLISH: 1500,
            UNABLE_TO_SUBSCRIBE: 1501,
            UNSUPPORTED_VIDEO_CODEC: 1502,
            UNABLE_TO_FORCE_DISCONNECT: 1520,
            UNABLE_TO_FORCE_UNPUBLISH: 1530,
            UNABLE_TO_FORCE_MUTE: 1540,
            PUBLISHER_ICE_WORKFLOW_FAILED: 1553,
            SUBSCRIBER_ICE_WORKFLOW_FAILED: 1554,
            STREAM_LIMIT_EXCEEDED: 1605,
            UNEXPECTED_SERVER_RESPONSE: 2001,
            REPORT_ISSUE_ERROR: 2011,
            SET_PROXY_URL_TIMING_ERROR: 2021,
            PROXY_URL_ALREADY_SET_ERROR: 2022,
            GET_RTC_STATS_REPORT_NOT_SUPPORTED: 2031,
            ANVIL_BADLY_FORMED_RESPONSE: 3001,
            ANVIL_INVALID_HTTP_STATUS: 3002,
            ANVIL_XDOMAIN_OR_PARSING_ERROR: 3003,
            ANVIL_UNKNOWN_HTTP_ERROR: 3004,
            ANVIL_UNEXPECTED_ERROR_CODE: 3005,
            ANVIL_EMPTY_RESPONSE_BODY: 3006,
            ANVIL_CONNECT_FAILED: 3007,
            UNABLE_TO_ACCESS_MEDIA_ENGINE: 5001
          };
          r.default = t;
        },
        /* 11 */
        /***/
        function(i, r) {
          function e(n) {
            var t = typeof n;
            return n != null && (t == "object" || t == "function");
          }
          i.exports = e;
        },
        /* 12 */
        /***/
        function(i, r) {
          var e = Array.isArray;
          i.exports = e;
        },
        /* 13 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(22)), o = n(e(8));
          function l(c) {
            c === void 0 && (c = {});
            const d = c.Errors || o.default, u = c.OTErrorClass || t.default, h = Object.keys(d).map((A) => d[A]);
            return function(g, f, p) {
              if (h.indexOf(g) === -1)
                return new Error(`Attempt to use invalid error name (${g}). Original message: ${f.message}`);
              if (!(f instanceof Error || /^\[object .*Error\]$/.test(Object.prototype.toString.call(f))))
                return new Error(`Did not pass Error as second argument: ${f}`);
              const v = new u(void 0, f.message);
              if (v.name = g, !f.stack)
                try {
                  throw f;
                } catch {
                }
              return v.stack = f.stack, p && (v.code = p), v;
            };
          }
        },
        /* 14 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = typeof Reflect == "object" ? Reflect : null, o = t && typeof t.apply == "function" ? t.apply : function(W, G, Z) {
              return Function.prototype.apply.call(W, G, Z);
            }, l;
            t && typeof t.ownKeys == "function" ? l = t.ownKeys : Object.getOwnPropertySymbols ? l = function(W) {
              return Object.getOwnPropertyNames(W).concat(Object.getOwnPropertySymbols(W));
            } : l = function(W) {
              return Object.getOwnPropertyNames(W);
            };
            function c(w) {
              console && console.warn && console.warn(w);
            }
            var d = Number.isNaN || function(W) {
              return W !== W;
            };
            function u() {
              u.init.call(this);
            }
            i.exports = u, i.exports.once = Q, u.EventEmitter = u, u.prototype._events = void 0, u.prototype._eventsCount = 0, u.prototype._maxListeners = void 0;
            var h = 10;
            function A(w) {
              if (typeof w != "function")
                throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof w);
            }
            Object.defineProperty(u, "defaultMaxListeners", {
              enumerable: !0,
              get: function() {
                return h;
              },
              set: function(w) {
                if (typeof w != "number" || w < 0 || d(w))
                  throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + w + ".");
                h = w;
              }
            }), u.init = function() {
              (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, u.prototype.setMaxListeners = function(W) {
              if (typeof W != "number" || W < 0 || d(W))
                throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + W + ".");
              return this._maxListeners = W, this;
            };
            function g(w) {
              return w._maxListeners === void 0 ? u.defaultMaxListeners : w._maxListeners;
            }
            u.prototype.getMaxListeners = function() {
              return g(this);
            }, u.prototype.emit = function(W) {
              for (var G = [], Z = 1; Z < arguments.length; Z++) G.push(arguments[Z]);
              var K = W === "error", L = this._events;
              if (L !== void 0)
                K = K && L.error === void 0;
              else if (!K)
                return !1;
              if (K) {
                var O;
                if (G.length > 0 && (O = G[0]), O instanceof Error)
                  throw O;
                var de = new Error("Unhandled error." + (O ? " (" + O.message + ")" : ""));
                throw de.context = O, de;
              }
              var oe = L[W];
              if (oe === void 0)
                return !1;
              if (typeof oe == "function")
                o(oe, this, G);
              else
                for (var fe = oe.length, ge = y(oe, fe), Z = 0; Z < fe; ++Z)
                  o(ge[Z], this, G);
              return !0;
            };
            function f(w, W, G, Z) {
              var K, L, O;
              if (A(G), L = w._events, L === void 0 ? (L = w._events = /* @__PURE__ */ Object.create(null), w._eventsCount = 0) : (L.newListener !== void 0 && (w.emit(
                "newListener",
                W,
                G.listener ? G.listener : G
              ), L = w._events), O = L[W]), O === void 0)
                O = L[W] = G, ++w._eventsCount;
              else if (typeof O == "function" ? O = L[W] = Z ? [G, O] : [O, G] : Z ? O.unshift(G) : O.push(G), K = g(w), K > 0 && O.length > K && !O.warned) {
                O.warned = !0;
                var de = new Error("Possible EventEmitter memory leak detected. " + O.length + " " + String(W) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                de.name = "MaxListenersExceededWarning", de.emitter = w, de.type = W, de.count = O.length, c(de);
              }
              return w;
            }
            u.prototype.addListener = function(W, G) {
              return f(this, W, G, !1);
            }, u.prototype.on = u.prototype.addListener, u.prototype.prependListener = function(W, G) {
              return f(this, W, G, !0);
            };
            function p() {
              if (!this.fired)
                return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
            }
            function v(w, W, G) {
              var Z = { fired: !1, wrapFn: void 0, target: w, type: W, listener: G }, K = p.bind(Z);
              return K.listener = G, Z.wrapFn = K, K;
            }
            u.prototype.once = function(W, G) {
              return A(G), this.on(W, v(this, W, G)), this;
            }, u.prototype.prependOnceListener = function(W, G) {
              return A(G), this.prependListener(W, v(this, W, G)), this;
            }, u.prototype.removeListener = function(W, G) {
              var Z, K, L, O, de;
              if (A(G), K = this._events, K === void 0)
                return this;
              if (Z = K[W], Z === void 0)
                return this;
              if (Z === G || Z.listener === G)
                --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete K[W], K.removeListener && this.emit("removeListener", W, Z.listener || G));
              else if (typeof Z != "function") {
                for (L = -1, O = Z.length - 1; O >= 0; O--)
                  if (Z[O] === G || Z[O].listener === G) {
                    de = Z[O].listener, L = O;
                    break;
                  }
                if (L < 0)
                  return this;
                L === 0 ? Z.shift() : U(Z, L), Z.length === 1 && (K[W] = Z[0]), K.removeListener !== void 0 && this.emit("removeListener", W, de || G);
              }
              return this;
            }, u.prototype.off = u.prototype.removeListener, u.prototype.removeAllListeners = function(W) {
              var G, Z, K;
              if (Z = this._events, Z === void 0)
                return this;
              if (Z.removeListener === void 0)
                return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Z[W] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Z[W]), this;
              if (arguments.length === 0) {
                var L = Object.keys(Z), O;
                for (K = 0; K < L.length; ++K)
                  O = L[K], O !== "removeListener" && this.removeAllListeners(O);
                return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
              }
              if (G = Z[W], typeof G == "function")
                this.removeListener(W, G);
              else if (G !== void 0)
                for (K = G.length - 1; K >= 0; K--)
                  this.removeListener(W, G[K]);
              return this;
            };
            function b(w, W, G) {
              var Z = w._events;
              if (Z === void 0)
                return [];
              var K = Z[W];
              return K === void 0 ? [] : typeof K == "function" ? G ? [K.listener || K] : [K] : G ? B(K) : y(K, K.length);
            }
            u.prototype.listeners = function(W) {
              return b(this, W, !0);
            }, u.prototype.rawListeners = function(W) {
              return b(this, W, !1);
            }, u.listenerCount = function(w, W) {
              return typeof w.listenerCount == "function" ? w.listenerCount(W) : m.call(w, W);
            }, u.prototype.listenerCount = m;
            function m(w) {
              var W = this._events;
              if (W !== void 0) {
                var G = W[w];
                if (typeof G == "function")
                  return 1;
                if (G !== void 0)
                  return G.length;
              }
              return 0;
            }
            u.prototype.eventNames = function() {
              return this._eventsCount > 0 ? l(this._events) : [];
            };
            function y(w, W) {
              for (var G = new Array(W), Z = 0; Z < W; ++Z)
                G[Z] = w[Z];
              return G;
            }
            function U(w, W) {
              for (; W + 1 < w.length; W++)
                w[W] = w[W + 1];
              w.pop();
            }
            function B(w) {
              for (var W = new Array(w.length), G = 0; G < W.length; ++G)
                W[G] = w[G].listener || w[G];
              return W;
            }
            function Q(w, W) {
              return new n(function(G, Z) {
                function K(O) {
                  w.removeListener(W, L), Z(O);
                }
                function L() {
                  typeof w.removeListener == "function" && w.removeListener("error", K), G([].slice.call(arguments));
                }
                J(w, W, L, { once: !0 }), W !== "error" && N(w, K, { once: !0 });
              });
            }
            function N(w, W, G) {
              typeof w.on == "function" && J(w, "error", W, G);
            }
            function J(w, W, G, Z) {
              if (typeof w.on == "function")
                Z.once ? w.once(W, G) : w.on(W, G);
              else if (typeof w.addEventListener == "function")
                w.addEventListener(W, function K(L) {
                  Z.once && w.removeEventListener(W, K), G(L);
                });
              else
                throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof w);
            }
          }).call(this, e(2));
        },
        /* 15 */
        /***/
        function(i, r, e) {
          var n = e(186), t = typeof self == "object" && self && self.Object === Object && self, o = n || t || Function("return this")();
          i.exports = o;
        },
        /* 16 */
        /***/
        function(i, r, e) {
          var n = e(556), t = e(557), o = t;
          o.v1 = n, o.v4 = t, i.exports = o;
        },
        /* 17 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(11), o = "[object AsyncFunction]", l = "[object Function]", c = "[object GeneratorFunction]", d = "[object Proxy]";
          function u(h) {
            if (!t(h))
              return !1;
            var A = n(h);
            return A == l || A == c || A == o || A == d;
          }
          i.exports = u;
        },
        /* 18 */
        /***/
        function(i, r) {
          function e(n) {
            return n != null && typeof n == "object";
          }
          i.exports = e;
        },
        /* 19 */
        /***/
        function(i, r, e) {
          var n = e(219), t = Object.prototype.toString;
          function o(Z) {
            return t.call(Z) === "[object Array]";
          }
          function l(Z) {
            return typeof Z == "undefined";
          }
          function c(Z) {
            return Z !== null && !l(Z) && Z.constructor !== null && !l(Z.constructor) && typeof Z.constructor.isBuffer == "function" && Z.constructor.isBuffer(Z);
          }
          function d(Z) {
            return t.call(Z) === "[object ArrayBuffer]";
          }
          function u(Z) {
            return typeof FormData != "undefined" && Z instanceof FormData;
          }
          function h(Z) {
            var K;
            return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? K = ArrayBuffer.isView(Z) : K = Z && Z.buffer && Z.buffer instanceof ArrayBuffer, K;
          }
          function A(Z) {
            return typeof Z == "string";
          }
          function g(Z) {
            return typeof Z == "number";
          }
          function f(Z) {
            return Z !== null && typeof Z == "object";
          }
          function p(Z) {
            if (t.call(Z) !== "[object Object]")
              return !1;
            var K = Object.getPrototypeOf(Z);
            return K === null || K === Object.prototype;
          }
          function v(Z) {
            return t.call(Z) === "[object Date]";
          }
          function b(Z) {
            return t.call(Z) === "[object File]";
          }
          function m(Z) {
            return t.call(Z) === "[object Blob]";
          }
          function y(Z) {
            return t.call(Z) === "[object Function]";
          }
          function U(Z) {
            return f(Z) && y(Z.pipe);
          }
          function B(Z) {
            return typeof URLSearchParams != "undefined" && Z instanceof URLSearchParams;
          }
          function Q(Z) {
            return Z.trim ? Z.trim() : Z.replace(/^\s+|\s+$/g, "");
          }
          function N() {
            return typeof navigator != "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
          }
          function J(Z, K) {
            if (!(Z === null || typeof Z == "undefined"))
              if (typeof Z != "object" && (Z = [Z]), o(Z))
                for (var L = 0, O = Z.length; L < O; L++)
                  K.call(null, Z[L], L, Z);
              else
                for (var de in Z)
                  Object.prototype.hasOwnProperty.call(Z, de) && K.call(null, Z[de], de, Z);
          }
          function w() {
            var Z = {};
            function K(de, oe) {
              p(Z[oe]) && p(de) ? Z[oe] = w(Z[oe], de) : p(de) ? Z[oe] = w({}, de) : o(de) ? Z[oe] = de.slice() : Z[oe] = de;
            }
            for (var L = 0, O = arguments.length; L < O; L++)
              J(arguments[L], K);
            return Z;
          }
          function W(Z, K, L) {
            return J(K, function(de, oe) {
              L && typeof de == "function" ? Z[oe] = n(de, L) : Z[oe] = de;
            }), Z;
          }
          function G(Z) {
            return Z.charCodeAt(0) === 65279 && (Z = Z.slice(1)), Z;
          }
          i.exports = {
            isArray: o,
            isArrayBuffer: d,
            isBuffer: c,
            isFormData: u,
            isArrayBufferView: h,
            isString: A,
            isNumber: g,
            isObject: f,
            isPlainObject: p,
            isUndefined: l,
            isDate: v,
            isFile: b,
            isBlob: m,
            isFunction: y,
            isStream: U,
            isURLSearchParams: B,
            isStandardBrowserEnv: N,
            forEach: J,
            merge: w,
            extend: W,
            trim: Q,
            stripBOM: G
          };
        },
        /* 20 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(9)), o = n(e(62)), l = n(e(291)), c = n(e(145)), d = n(e(163)), u = n(e(1)), h = n(e(292));
          function A(Q, N) {
            var J = typeof Symbol != "undefined" && Q[Symbol.iterator] || Q["@@iterator"];
            if (J) return (J = J.call(Q)).next.bind(J);
            if (Array.isArray(Q) || (J = g(Q)) || N) {
              J && (Q = J);
              var w = 0;
              return function() {
                return w >= Q.length ? { done: !0 } : { done: !1, value: Q[w++] };
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          function g(Q, N) {
            if (Q) {
              if (typeof Q == "string") return f(Q, N);
              var J = Object.prototype.toString.call(Q).slice(8, -1);
              if (J === "Object" && Q.constructor && (J = Q.constructor.name), J === "Map" || J === "Set") return Array.from(Q);
              if (J === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(J)) return f(Q, N);
            }
          }
          function f(Q, N) {
            (N == null || N > Q.length) && (N = Q.length);
            for (var J = 0, w = new Array(N); J < N; J++) w[J] = Q[J];
            return w;
          }
          const p = (0, u.default)("SDPHelpers"), v = 1e4, b = 2e4, m = {
            getSections(Q) {
              return Q.split(/\r\n|\r|\n/).reduce((N, J) => {
                const w = J.match(/^m=(\w+) \d+/);
                return w && (N.sections[N.section = w[1]] = []), N.sections[N.section].push(J), N;
              }, {
                sections: {
                  header: []
                },
                section: "header"
              }).sections;
            },
            getCodecsFromSection(Q) {
              const N = Q[0].match(/m=\w+ \d+ [A-Z/]+ ([\d ]+)$/)[1].split(" "), J = (0, t.default)(...Q.filter((w) => w.match(/^a=rtpmap:\d+/)).map((w) => w.match(/^a=rtpmap:(\d+) ([\w-]+)/).splice(1)).map((w) => {
                let W = w[0], G = w[1];
                return {
                  [W]: G
                };
              }));
              return {
                codecs: N,
                codecMap: J
              };
            },
            getCodecsAndCodecMap(Q, N) {
              const J = m.getSections(Q)[N];
              if (!J)
                throw new Error(`no mediaType ${N}`);
              return m.getCodecsFromSection(J);
            },
            getCodecs(Q, N) {
              const J = m.getCodecsAndCodecMap(Q, N);
              return J.codecs.map((w) => J.codecMap[w] || "Unknown codec");
            },
            MediaDirection: h.default,
            iceCredentials: {
              ufrag: "a=ice-ufrag:",
              pwd: "a=ice-pwd:"
            }
          };
          m.getMLineIndex = function(N, J) {
            const w = `m=${J}`;
            return (0, l.default)(N, (W) => W.indexOf(w) !== -1);
          }, m.getMLine = function(N, J) {
            const w = m.getMLineIndex(N, J);
            return w > -1 ? N[w] : void 0;
          }, m.hasMediaType = (Q, N) => {
            const J = new RegExp(`^m=${N}`), w = Q.split(`\r
`);
            return (0, l.default)(w, (W) => J.test(W)) >= 0;
          }, m.hasMLinePayloadType = function(N, J, w) {
            const W = m.getMLine(N, J);
            return m.getMLinePayloadTypes(W, J).indexOf(w) > -1;
          }, m.getMLinePayloadTypes = function(N, J) {
            const w = new RegExp(`^m=${J} \\d+(/\\d+)? [a-zA-Z0-9/]+(( [a-zA-Z0-9/]+)+)$`, "i"), W = N.match(w);
            return !W || W.length < 2 ? [] : W[2].trim().split(" ");
          }, m.splitSections = function(N) {
            return N.split(`
m=`).map((w, W) => (W > 0 ? "m=" + w : w).trim() + `\r
`);
          }, m.getLinesPerSection = (Q) => m.splitSections(Q).map((J) => m.getSDPLines(J)), m.replaceDirectionInSdpLines = (Q, N, J) => {
            const w = Q.join(`\r
`);
            return m.replaceDirection(w, N, J).split(`\r
`);
          }, m.replaceDirection = (Q, N, J) => {
            const w = new RegExp(`a=${N}`, "g");
            return Q.replace(w, `a=${J}`);
          }, m.setSubscriberMediaSectionToInactive = (Q) => {
            const N = h.default.SENDONLY, J = h.default.INACTIVE;
            return m.replaceDirectionInSdpLines(Q, N, J);
          }, m.changeMediaDirection = function(N, J) {
            const w = m.splitSections(N);
            let G = w.shift();
            const Z = h.default.RECVONLY, K = h.default.INACTIVE, L = J === Z ? K : Z;
            return w.forEach((O) => {
              const de = O.includes("m=video") ? m.replaceDirection(O, L, J) : O;
              G += de;
            }), G;
          }, m.removeTypesFromMLine = function(N, J) {
            const w = /[0-9 ]*$/.exec(N)[0], W = w.split(" ").filter((G) => G !== "" && J.indexOf(G) === -1);
            return N.replace(w, ` ${W.join(" ")}`);
          }, m.removeMediaEncoding = function(N, J, w) {
            let W, G, Z, K, L = N.split(`\r
`);
            const O = m.getMLineIndex(L, J), de = O > -1 ? L[O] : void 0, oe = [];
            if (O === -1 || (W = m.getMLinePayloadTypes(de, J), W.length === 0))
              return L.join(`\r
`);
            for (G = O; G < L.length; G++) {
              const fe = new RegExp(w, "i");
              L[G].indexOf("a=rtpmap:") === 0 && (K = L[G].split(" "), K.length === 2 && fe.test(K[1]) && oe.push(K[0].substr(9)));
            }
            if (!oe.length)
              return L.join(`\r
`);
            for (G = O; G < L.length; G++)
              if (L[G].indexOf("a=fmtp:") === 0)
                for (K = L[G].split(" "), Z = 0; Z < oe.length; Z++)
                  K.length === 2 && K[1] === `apt=${oe[Z]}` && oe.push(K[0].substr(7));
            return L = L.filter((fe) => {
              for (let ge = 0; ge < oe.length; ge++)
                if (fe.indexOf(`a=rtpmap:${oe[ge]} `) === 0 || fe.indexOf(`a=fmtp:${oe[ge]} `) === 0 || fe.indexOf(`a=rtcp-fb:${oe[ge]} `) === 0)
                  return !1;
              return !0;
            }), oe.length > 0 && O > -1 && (L[O] = m.removeTypesFromMLine(de, oe)), L.join(`\r
`);
          }, m.disableMediaType = function(N, J) {
            const w = N.split(`\r
`), W = [];
            let G;
            w.forEach((L) => {
              let O = L;
              /^m=/.test(O) && (G = void 0), G || (G = [], W.push(G)), G.push(O);
            });
            const Z = new RegExp(`^m=${J} \\d+ ([^ ]+) [0-9 ]+$`), K = W.map((L) => {
              const O = L[0].match(Z);
              return O ? [`m=${J} 0 ${O[1]} 0`, "a=inactive", ...L.filter(
                (de) => /^c=/.test(de) || /^a=mid:/.test(de) || de === ""
                // This preserves the trailing newline
              )] : L;
            });
            return [].concat(...K).join(`\r
`);
          }, m.removeVideoCodec = function(N, J) {
            return m.removeMediaEncoding(N, "video", J);
          };
          const y = function(N, J) {
            let w = J.filterByName("ssrc-group:FID");
            switch (w.length === 0 ? w = [] : w = w[0].value.split(" "), w.length) {
              case 0:
              case 1:
                var G = J.find((K) => K.name.indexOf("rtpmap:") === 0 && K.value.indexOf("rtx/90000") > -1);
                if (!G)
                  return !1;
                var Z = G.name.split(":")[1];
                return Z.indexOf("/") > -1 && (Z = Z.split("/")[0]), m.hasMLinePayloadType(N, "video", Z);
              default:
                return p.debug("SDP Helpers: There are more than two FIDs, RTX is definitely enabled"), !0;
            }
          };
          m.getAttributesForMediaType = function(N, J) {
            let w, W, G, Z, K, L, O, de, oe, fe;
            const ge = m.getMLineIndex(N, J), we = new RegExp(`m=(?!${J}).+ `, "i"), _e = new RegExp("a=ssrc:\\d+ .*", "i"), Te = new RegExp("a=ssrc-group:(SIM|FID) (\\d+).*?", "i"), Pe = new RegExp("a=([a-z0-9:/-]+) (.*)", "i"), $e = [];
            for (let Bt = ge + 1; Bt < N.length; Bt++) {
              if (we.test(N[Bt])) {
                w !== void 0 && (W = Bt - 1);
                break;
              }
              K = N[Bt].match(Te), L = N[Bt].match(_e), w === void 0 && (K || L) && (w = Bt, K && (Z = /^(FID|SIM)$/.test(K[1]) ? K[2] : K[1])), O = N[Bt].match(`a=ssrc:${Z} msid:(.+)`), O && (de = O[1]);
              const Le = _e.test(N[Bt]), at = Te.test(N[Bt]);
              w !== void 0 && (W === void 0 && !Le && !at ? W = Bt - 1 : Bt === N.length - 1 && (W = Bt));
              const pt = N[Bt].match(/a=mid:(.+)/);
              pt && (oe = pt[1], fe = Bt), G = Pe.exec(N[Bt]), G && G.length === 3 && $e.push({
                lineIndex: Bt,
                name: G[1],
                value: G[2]
              });
            }
            return $e.ssrcStartIndex = w, $e.ssrcEndIndex = W, $e.msid = de, $e.mid = oe, $e.midIndex = fe, $e.isUsingRTX = y.bind(null, N, $e), $e.filterByName = function(Le) {
              return this.filter((at) => at.name === Le);
            }, $e.getRtpNumber = (Bt) => {
              const Le = new RegExp("rtpmap:(.+)");
              return (0, o.default)($e.map((at) => {
                const pt = at.name.match(Le);
                return pt && at.value.indexOf(Bt) >= 0 ? pt[1] : null;
              }), (at) => at !== null);
            }, $e;
          }, m.modifyDtx = (Q, N) => {
            const J = Q.split(`\r
`);
            if (!m.getMLine(J, "audio"))
              return p.debug("No audio m-line, not enabling dtx."), Q;
            const w = m.getAttributesForMediaType(J, "audio"), W = w.getRtpNumber("opus");
            if (!W)
              return p.debug("Could not find rtp number for opus, not enabling dtx."), Q;
            const G = w.find((L) => L.name === `fmtp:${W}`);
            if (!G)
              return p.debug("Could not find a=fmtp line for opus, not enabling dtx."), Q;
            let Z = J[G.lineIndex];
            const K = /usedtx=\d+([\s;]*)/;
            return K.test(G.value) ? Z = Z.replace(K, N ? "usedtx=1$1" : "") : N && (Z += "; usedtx=1"), Z = Z.replace(/[;\s]*$/, ""), J[G.lineIndex] = Z, J.join(`\r
`);
          };
          const U = (Q, N, J) => {
            const w = N.split(`\r
`);
            if (!m.getMLine(w, "audio"))
              return p.debug("No audio m-line, not enabling stereo."), N;
            const W = m.getAttributesForMediaType(w, "audio"), G = W.getRtpNumber("opus");
            if (!G)
              return p.debug("Could not find rtp number for opus, not enabling stereo."), N;
            const Z = W.find((O) => O.name === `fmtp:${G}`);
            if (!Z)
              return p.debug("Could not find a=fmtp line for opus, not enabling stereo."), N;
            let K = w[Z.lineIndex], L;
            switch (Q) {
              case "send":
                L = /sprop-stereo=\d+([\s;]*)/, L.test(Z.value) ? K = K.replace(L, J ? "sprop-stereo=1$1" : "") : J && (K += "; sprop-stereo=1");
                break;
              case "receive":
                L = /([^-])stereo=\d+([\s;]*)/, L.test(Z.value) ? K = K.replace(L, J ? "$1stereo=1$2" : "$1") : J && (K += "; stereo=1");
                break;
              default:
                throw new Error(`Invalid type ${Q} passed into enableStereo`);
            }
            return K = K.replace(/[;\s]*$/, ""), w[Z.lineIndex] = K, w.join(`\r
`);
          };
          m.modifySendStereo = U.bind(null, "send"), m.modifyReceiveStereo = U.bind(null, "receive"), m.setAudioBitrate = (Q, N) => {
            const J = m.getAudioBitrate(Q);
            if (J !== void 0)
              return p.debug(`Audio bitrate already set to ${J}, not setting audio bitrate`), Q;
            const w = Q.split(`\r
`);
            if (!m.getMLine(w, "audio"))
              return p.debug("No audio m-line, not setting audio bitrate"), Q;
            const W = m.getAttributesForMediaType(w, "audio"), G = W.getRtpNumber("opus");
            if (!G)
              return p.debug("Could not find rtp number for opus, not setting audio bitrate."), Q;
            const Z = W.find((L) => L.name === `fmtp:${G}`);
            if (!Z)
              return p.debug("Could not find a=fmtp line for opus, not setting audio bitrate."), Q;
            let K = w[Z.lineIndex];
            return K += `; maxaveragebitrate=${N}`, K = K.replace(/[;\s]*$/, ""), w[Z.lineIndex] = K, w.join(`\r
`);
          }, m.removeVideoOrientation = (Q) => {
            let N = Q.split(`\r
`);
            return N = N.filter((J) => !J.includes("urn:3gpp:video-orientation")), N.join(`\r
`);
          }, m.hasSendStereo = (Q) => /[\s;]sprop-stereo=1/.test(Q), m.hasSendDtx = (Q) => /[\s;]usedtx=1/.test(Q), m.getAudioBitrate = (Q) => {
            const N = Q.match(/[\s;]maxaveragebitrate=(\d+)/);
            if (N)
              return Number(N[1]);
          }, m.MAX_SSRCS = 10, m.getSSRCGroupType = (Q) => ["SIM", "FID"].find((J) => Q.filterByName(`ssrc-group:${J}`)[0]), m.getSSRCGroup = (Q) => {
            const N = m.getSSRCGroupType(Q);
            return Q.filterByName(`ssrc-group:${N}`)[0];
          }, m.getSSRCGroupSSRCs = (Q) => {
            const N = m.getSSRCGroup(Q);
            return N ? N.value.split(" ").slice(0, m.MAX_SSRCS) : [];
          }, m.getAllowedSSRCs = (Q, N) => {
            const J = N.slice();
            return Q.filterByName("ssrc-group:FID").forEach((w) => {
              const W = w.value.split(" ");
              (0, c.default)(J, W).length && Array.prototype.push.apply(J, W);
            }), (0, d.default)(J);
          }, m.filterExcessSSRCs = (Q) => {
            const N = Q.split(`\r
`), J = m.getAttributesForMediaType(N, "video"), w = m.getSSRCGroupType(J), W = J.ssrcStartIndex;
            if (W === void 0)
              return Q;
            let G;
            const Z = (L) => {
              let O = null;
              return L.match(/^a=ssrc:(\d+)/) && (O = RegExp.$1), O;
            };
            if (w) {
              const L = m.getSSRCGroupSSRCs(J), O = [`a=ssrc-group:${w}`, ...L].join(" "), de = J.find((oe) => oe.name.startsWith("ssrc-group:")).lineIndex;
              N[de] = O, G = m.getAllowedSSRCs(J, L);
            } else
              G = [], J.ssrcStartIndex && G.push(Z(N[J.ssrcStartIndex]));
            return N.filter((L, O) => {
              if (O < W || O > J.ssrcEndIndex)
                return !0;
              if (O === W) {
                if (!w) {
                  const oe = Z(L);
                  return oe ? G.includes(oe) : !/^a=ssrc:(\d+)/.test(L);
                }
                return !0;
              }
              const de = Z(L);
              if (de)
                return G.includes(de);
              if (L.match(/^a=ssrc-group:FID (\d+)/)) {
                const oe = RegExp.$1;
                return G.includes(oe);
              }
              return !L.match(/^a=ssrc-group:SIM /);
            }).join(`\r
`);
          }, m.enableSimulcast = function(N, J) {
            let w, W;
            const G = N.split(`\r
`);
            if (!m.getMLine(G, "video"))
              return p.debug("No video m-line, not enabling simulcast."), N;
            const Z = m.getAttributesForMediaType(G, "video");
            if (Z.filterByName("ssrc-group:SIM").length > 0)
              return p.debug("Simulcast is already enabled in this SDP, not attempting to enable again."), m.filterExcessSSRCs(N);
            if (!Z.msid)
              return p.debug("No local stream attached, not enabling simulcast."), N;
            const K = Z.isUsingRTX(), L = [], O = [];
            for (W = 0; W < J; ++W)
              L.push(v + W), K && O.push(b + W);
            if (w = [`a=ssrc-group:SIM ${L.join(" ")}`], K)
              for (W = 0; W < J; ++W)
                w.push(`a=ssrc-group:FID ${L[W]} ${O[W]}`);
            for (W = 0; W < J; ++W)
              w.push(`a=ssrc:${L[W]} cname:localCname`, `a=ssrc:${L[W]} msid:${Z.msid}`);
            if (K)
              for (W = 0; W < J; ++W)
                w.push(`a=ssrc:${O[W]} cname:localCname`, `a=ssrc:${O[W]} msid:${Z.msid}`);
            return w.unshift(Z.ssrcStartIndex, Z.ssrcEndIndex - Z.ssrcStartIndex + 1), G.splice(...w), G.join(`\r
`);
          }, m.reprioritizeVideoCodec = function(N, J, w) {
            const W = N.split(`\r
`), G = m.getMLineIndex(W, "video");
            if (G === -1)
              return N;
            const Z = m.getMLinePayloadTypes(W[G], "video"), K = new RegExp(`^a=rtpmap:(\\d+).* ${J}`, "i"), L = W.map((fe) => fe.match(K)).filter((fe) => fe !== null);
            if (L.length === 0)
              return N;
            const O = L.map((fe) => fe[1]);
            let de = Z.filter((fe) => O.indexOf(fe) === -1);
            w === "top" ? de.unshift(...O) : w === "bottom" ? de.push(...O) : (p.error(`Unexpected location param: ${w}; not changing ${J} priority`), de = Z);
            const oe = W[G].replace(Z.join(" "), de.join(" "));
            return W[G] = oe, W.join(`\r
`);
          }, m.getSetupRole = (Q) => {
            for (var N = A(Q.split(/\r\n|\r|\n/)), J; !(J = N()).done; ) {
              const W = J.value.match(/^a=setup:(\w+)/);
              if (W)
                return W[1];
            }
            return "";
          }, m.setSetupRole = (Q, N) => Q.split(/\r\n|\r|\n/).map((J) => J.match(/^a=setup:(\w+)/) ? `a=setup:${N}` : J).join(`\r
`), m.changeSetupRole = (Q, N, J) => Q.split(/\r\n|\r|\n/).map((w) => w.includes(`a=setup:${N}`) ? `a=setup:${J}` : w).join(`\r
`), m.patterns = {
            // group sample: a=group:BUNDLE 0a 1v 2a 3v
            bundle: "a=group:BUNDLE",
            // address sample: c=IN IP4 54.201.197.86
            address: "c=IN IP4",
            // rtcp sample: a=rtcp:41511
            rtcp: "a=rtcp:",
            // direction sample: a=sendonly
            direction: ["a=inactive", "a=sendonly", "a=recvonly", "a=sendrecv"],
            // a=rtcp-rsize
            rsize: "a=rtcp-rsize",
            // ssrc sample: a=ssrc:3 cname:1E7BE30B-C693-4570-B552-34244D6F04C1
            ssrc: "a=ssrc:",
            // msid sample: a=msid:McwRQfjkv8dWA33jaqKHwuBh6ovY0TxNpBZB 3c18dd96-8af5-4e07-856d-0cd21e0203b8
            msid: "a=msid:"
          }, m.getIndexStartingWith = (Q, N, J) => {
            const w = Q.slice(J), W = N.map((G) => w.findIndex((Z) => Z.includes(G))).filter((G) => G > -1);
            return W.length ? J + Math.min(...W) : Q.length;
          }, m.getLastIndexPriorTo = (Q, N, J) => Q.slice(0, J).map((G) => G.includes(N)).lastIndexOf(!0), m.includesAny = (Q, N) => {
            for (let J = 0; J < N.length; J++)
              if (Q.includes(N[J]))
                return !0;
            return !1;
          }, m.isVersionLine = (Q) => /^o=/.test(Q), m.getVersionLine = (Q) => Q.find(m.isVersionLine), m.getVersion = (Q) => {
            const N = m.getVersionLine(Q);
            if (N === void 0)
              return;
            const J = Number(N.match(/ (\d+) IN /)[1]);
            return Number.isInteger(J) ? J : void 0;
          }, m.updateVersion = (Q, N, J) => {
            const w = [...Q], W = w.findIndex((G) => m.isVersionLine(G));
            return W >= 0 && (w[W] = w[W].replace(` ${N} `, ` ${J} `)), w;
          }, m.isBundleLine = (Q) => Q.includes(m.patterns.bundle), m.getBundleLine = (Q) => Q.find(m.isBundleLine), m.createBundleLine = (Q) => `${m.patterns.bundle} ${Q.join(" ")}`, m.updateBundleLine = (Q, N) => {
            const J = [...Q], w = m.createBundleLine(N), W = J.findIndex((G) => m.isBundleLine(G));
            return W >= 0 && (J[W] = w), J;
          }, m.parseMLine = (Q) => {
            const N = Q.match(/^(m=(?:audio|video)) (\d+) (.+)/), J = N[1], w = N[2], W = N[3];
            return {
              port: w,
              transport: W,
              mediaType: J
            };
          }, m.disableTrack = (Q) => {
            const N = m.parseMLine(Q), J = N.mediaType, w = N.transport;
            return `${J} 0 ${w}`;
          }, m.setMediaDirection = (Q, N) => {
            if (!Object.values(h.default).includes(N))
              return Q;
            const w = Q.slice(), W = w.findIndex((G) => m.includesAny(G, m.patterns.direction));
            return W === -1 || (w[W] = `a=${N}`), w;
          }, m.disableTrackSection = (Q) => {
            const N = Q.mid, J = Q.sdp;
            let w = J.filter((W) => {
              const G = m.patterns, Z = G.address, K = G.rtcp, L = G.rsize, O = G.ssrc, de = G.msid;
              return !m.includesAny(W, [Z, K, L, O, de]);
            });
            return w[0] = m.disableTrack(J[0]), w = m.setMediaDirection(w, h.default.INACTIVE), {
              mid: N,
              sdp: w
            };
          }, m.isDisabledMediaSection = (Q) => {
            let N = Q[0];
            return /^m=(?:video|audio) 0 RTP\/SAVPF 0/.test(N);
          }, m.getDisabledSectionForMid = (Q) => [`m=${Q.includes("a") ? "audio" : "video"} 0 RTP/SAVPF 0`], m.disableTrackSections = (Q, N) => N.map((J) => {
            const w = m.getTrackMids(J), W = w[0];
            return !W || Q.includes(W) ? J : m.getDisabledSectionForMid(W);
          }), m.getEnabledTracks = (Q) => m.getBundleLine(Q).match(new RegExp(`^${m.patterns.bundle} (.+)$`))[1].split(" "), m.getDisabledTracks = (Q, N) => (
            // Get tracks that were present in previous SDP but not in the new SDP
            Q.filter((J) => !N.includes(J))
          ), m.getTrackSection = (Q, N) => {
            const J = Q.findIndex((K) => K.includes(`a=mid:${N}`)), w = N.includes("a") ? "audio" : "video", W = m.getLastIndexPriorTo(Q, `m=${w}`, J), G = m.getIndexStartingWith(Q, ["m=audio", "m=video"], J), Z = Q.slice(W, G);
            return {
              mid: N,
              sdp: Z
            };
          }, m.getHeaders = (Q) => {
            const N = Q.findIndex((J) => J.includes("m=audio") || J.includes("m=video"));
            return Q.slice(0, N);
          }, m.getSDPLines = (Q) => Q.split(`\r
`).filter((N) => N), m.getTrackMids = (Q) => {
            const N = "a=mid:";
            return Q.filter((w) => w.match(new RegExp(`^${N}\\d+`))).map((w) => w.substring(N.length));
          }, m.getTrackSections = (Q) => m.getTrackMids(Q).map((J) => m.getTrackSection(Q, J)), m.parseMantisSDP = (Q) => {
            const N = m.changeSetupRole(Q, "actpass", "passive");
            return m.parseSDP(N);
          }, m.isMediaSectionDisabled = (Q) => {
            const N = m.parseMLine(Q[0]), J = N.port;
            return parseInt(J, 10) === 0;
          }, m.getSectionMid = (Q) => m.isMediaSectionDisabled(Q) ? null : m.getTrackMids(Q)[0], m.parseSDP = (Q) => {
            const N = m.getLinesPerSection(Q), J = N[0], w = N.slice(1);
            return {
              bundle: m.getBundleLine(J),
              version: m.getVersion(J),
              tracks: m.getEnabledTracks(J),
              mediaSections: w,
              mids: w.map(m.getSectionMid),
              headers: J
            };
          }, m.createSDP = (Q, N) => {
            const J = [...Q];
            return N.forEach((w) => J.push(...w)), J.push(""), J.join(`\r
`);
          }, m.removePayloadTypeFromSection = (Q, N) => Q.filter((J) => !J.includes(`a=rtpmap:${N} `) && !J.includes(`a=fmtp:${N} `) && !J.includes(`a=rtcp-fb:${N} `)), m.getRtxPayloadType = (Q, N) => {
            const J = Q.filter((W) => W.includes(`apt=${N}`))[0];
            return J == null ? void 0 : J.match(/^a=fmtp:(\d+) /)[1];
          }, m.removeRtxPayloadTypeFromSection = (Q, N) => {
            let J = [...Q];
            const w = m.getRtxPayloadType(J, N);
            return w && (J = m.removePayloadTypeFromSection(J, w)), J;
          }, m.trimUnusedCodecs = (Q, N) => {
            const J = Q[0].split(" "), w = J.slice(3), W = J.slice(0, 3), G = m.getCodecsFromSection(Q);
            let Z = [...Q], K = [];
            w.forEach((O) => {
              const de = G.codecMap[O];
              if (!N.includes(de))
                Z = m.removePayloadTypeFromSection(Z, O), Z = m.removeRtxPayloadTypeFromSection(Z, O);
              else {
                K.push(O);
                const oe = m.getRtxPayloadType(Z, O);
                oe && K.push(oe);
              }
            });
            const L = K.length ? K : [0];
            return Z[0] = [...W, ...L].join(" "), Z;
          }, m.removeUnusedCodecs = (Q, N) => {
            if (!N)
              return Q;
            const J = m.parseSDP(Q), w = J.headers, W = J.mediaSections, G = m.parseSDP(N), Z = G.mids, K = G.mediaSections, L = W.map((de) => {
              const oe = Z.findIndex((ge) => ge === m.getTrackMids(de)[0]);
              if (oe < 0)
                return de;
              const fe = Object.values(m.getCodecsFromSection(K[oe]).codecMap);
              return m.trimUnusedCodecs(de, fe);
            }), O = [...w];
            return L.forEach((de) => O.push(...de)), O.push(""), O.join(`\r
`);
          }, m.updateSDPWithNewOffer = (Q, N) => {
            const J = Q.headers, w = Q.version, W = Q.mediaSections, G = m.getSDPLines(N), Z = m.getVersion(G), K = m.getEnabledTracks(G), L = {
              version: Z,
              tracks: K,
              headers: m.updateBundleLine(m.updateVersion(J, w, Z), K),
              mediaSections: m.disableTrackSections(K, W)
            };
            return L.mids = L.mediaSections.map(m.getSectionMid), L;
          }, m.isUfragLine = (Q) => Q.includes(m.iceCredentials.ufrag), m.isPwdLine = (Q) => Q.includes(m.iceCredentials.pwd), m.getIceCredentials = (Q) => {
            const N = {};
            return Q.forEach((J) => {
              m.isUfragLine(J) ? N.ufrag = J : m.isPwdLine(J) && (N.pwd = J);
            }), N;
          }, m.updateIceCredentials = (Q, N) => {
            const J = m.getIceCredentials(N);
            return Q.map((w) => m.isUfragLine(w) ? J.ufrag : m.isPwdLine(w) ? J.pwd : w);
          }, m.updateFirstEnabledMediaSection = (Q, N) => {
            const J = [...Q.mediaSections], w = N.mids.findIndex((G) => G !== null), W = Q.mids.findIndex((G) => G !== null);
            return w >= 0 && W >= 0 && (J[W] = N.mediaSections[w]), J;
          };
          var B = m;
          r.default = B;
        },
        /* 21 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(3)), d = t(e(104)), u = t(e(253)), h = t(e(547)), A = t(e(254)), f = function(v) {
              v === void 0 && (v = {});
              const b = v.getNativeEnumerateDevices || (0, u.default)(), m = v.getNativeMediaDevices || (0, h.default)(), y = v.currentAudioOutputDevice || d.default, U = y.getCurrentAudioOutputDeviceId, B = v.currentAudioInputDevice || A.default, Q = B.getCurrentAudioInputDevice, N = v.env || c.default, J = v.global || (typeof window !== void 0 ? window : Dn), w = {}, W = {
                audio: "audioInput",
                video: "videoInput",
                audioinput: "audioInput",
                videoinput: "videoInput",
                audiooutput: "audioOutput",
                audioInput: "audioInput",
                videoInput: "videoInput",
                audioOutput: "audioOutput"
              }, G = () => b()();
              return w.getNativeMediaDevices = () => m(), w.hasEnumerateDevicesCapability = () => typeof b() == "function", w.hasDeviceChangeCapability = () => {
                const Z = m();
                return !!(Z && "ondevicechange" in Z);
              }, w.hasSetSinkIdCapability = () => "setSinkId" in (J == null ? void 0 : J.HTMLMediaElement.prototype), w.hasAudioOutputApiSupport = () => {
                const Z = v, K = Z.hasSetSinkIdCapability, L = K === void 0 ? w.hasSetSinkIdCapability : K, O = v, de = O.hasDeviceChangeCapability, oe = de === void 0 ? w.hasDeviceChangeCapability : de;
                return !(N != null && N.isFirefox) && L() && oe();
              }, w.hasEnumerateDevicesBug = () => N.isSafari && N.version === 13.1, w.getMediaDevices = () => w.hasEnumerateDevicesCapability() ? G().then((Z) => (
                // Normalise the device kinds
                Z.map((K) => ({
                  deviceId: K.deviceId || K.id,
                  label: K.label,
                  kind: W[K.kind]
                }))
              )) : n.reject(new Error("This browser does not support enumerateDevices APIs")), w.getInputMediaDevices = () => w.getMediaDevices().then((Z) => Z.filter((K) => /^(audio|video)Input$/.test(K.kind))), w.getAudioOutputMediaDevices = () => w.getMediaDevices().then((Z) => Z.filter((K) => K.kind === "audioOutput").map((K) => {
                let L = K.deviceId, O = K.label;
                return {
                  deviceId: L,
                  label: O
                };
              })), w.getAudioInputMediaDevices = () => w.getMediaDevices().then((Z) => Z.filter((K) => K.kind === "audioInput").map((K) => {
                let L = K.deviceId, O = K.label;
                return {
                  deviceId: L,
                  label: O
                };
              })), w.shouldAskForDevices = () => w.hasEnumerateDevicesCapability() ? w.getInputMediaDevices().then((Z) => {
                if (Z.length === 0)
                  return {
                    video: !0,
                    audio: !0
                  };
                const K = Z.filter((O) => O.kind === "audioInput"), L = Z.filter((O) => O.kind === "videoInput");
                return w.hasEnumerateDevicesBug() && L.length === 0 ? {
                  audio: !0,
                  video: !0
                } : {
                  video: L.length > 0,
                  audio: K.length > 0,
                  videoDevices: L,
                  audioDevices: K
                };
              }).catch(() => (
                // There was an error. It may be temporally. Just assume
                // all devices exist for now.
                {
                  video: !0,
                  audio: !0
                }
              )) : n.resolve({
                video: !0,
                audio: !0
              }), w.getDefaultAudioOutputDeviceId = (Z) => !Array.isArray(Z) || Z.length === 0 ? "" : (Z.find((O) => O.deviceId === "default") || Z[0]).deviceId, w.getDefaultAudioInputDevice = (Z) => !Array.isArray(Z) || Z.length === 0 ? "" : Z.find((K) => K.deviceId === "default") || Z[0], w.hasDevice = (Z, K) => {
                let L = Z;
                return Array.isArray(L) || (L = []), L.some((O) => O.deviceId === K);
              }, w.getActiveAudioInputDevice = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function Z() {
                var K, L, O;
                return o.default.wrap(function(oe) {
                  for (; ; ) switch (oe.prev = oe.next) {
                    case 0:
                      return oe.next = 2, w.getAudioInputMediaDevices();
                    case 2:
                      if (K = oe.sent, K.length !== 0) {
                        oe.next = 5;
                        break;
                      }
                      return oe.abrupt("return", {
                        deviceId: null,
                        label: null
                      });
                    case 5:
                      return L = Q(), L || (O = w.getDefaultAudioInputDevice(K), L = K.find((fe) => fe === O)), oe.abrupt("return", L);
                    case 8:
                    case "end":
                      return oe.stop();
                  }
                }, Z);
              })), w.getActiveAudioOutputDevice = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function Z() {
                var K, L, O;
                return o.default.wrap(function(oe) {
                  for (; ; ) switch (oe.prev = oe.next) {
                    case 0:
                      return oe.prev = 0, oe.next = 3, w.getAudioOutputMediaDevices();
                    case 3:
                      K = oe.sent, oe.next = 9;
                      break;
                    case 6:
                      throw oe.prev = 6, oe.t0 = oe.catch(0), oe.t0;
                    case 9:
                      if (K.length !== 0) {
                        oe.next = 11;
                        break;
                      }
                      return oe.abrupt("return", {
                        deviceId: null,
                        label: null
                      });
                    case 11:
                      return L = K.find((fe) => fe.deviceId === U()), L || (O = w.getDefaultAudioOutputDeviceId(K), L = K.find((fe) => fe.deviceId === O)), oe.abrupt("return", L);
                    case 14:
                    case "end":
                      return oe.stop();
                  }
                }, Z, null, [[0, 6]]);
              })), w;
            };
            r.default = f;
          }).call(this, e(2));
        },
        /* 22 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(6)), o = n(e(1)), l = n(e(23)), c = n(e(31)), d = n(e(561));
          const u = (0, o.default)("GlobalExceptionHandler"), h = (0, l.default)(), A = function(p, v) {
            Error.call(this), this.code = p, this.message = v;
          };
          A.prototype = Object.create(Error.prototype), A.prototype.constructor = A, (0, t.default)(A), A.getTitleByCode = function(f) {
            return d.default[+f];
          }, A.handleJsException = (f) => {
            let p = f.error, v = f.errorMsg, b = f.code, m = f.target, y = f.analytics;
            if (!m)
              throw new Error("handleJsException requires target");
            const U = () => b !== void 0 ? b : p && p.code, B = () => v !== void 0 ? v : p && p.message, Q = A.getTitleByCode(U());
            u.error(`OT.exception :: title: ${Q} (${U()}) msg: ${B()}`);
            try {
              const N = {
                partnerId: m.session ? m.session.apiKey : m.apiKey,
                sessionId: m.session ? m.session.sessionId : m.sessionId
              };
              y.logError(U(), "tb.exception", Q, {
                details: B()
              }, N);
              const J = new h.ExceptionEvent(c.default.EXCEPTION, B(), Q, U(), m, m, p);
              if (p)
                J.stack = p.stack;
              else
                try {
                  throw new Error();
                } catch (w) {
                  J.stack = w.stack;
                }
              A.dispatchEvent(J);
            } catch (N) {
              u.error(`OT.exception :: Failed to dispatch exception - ${N.toString()}`);
            }
          };
          var g = A;
          r.default = g;
        },
        /* 23 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = u;
          var t = n(e(29)), o = n(e(30)), l = n(e(1)), c = n(e(144)), d = n(e(31));
          function u(h) {
            h === void 0 && (h = {});
            const A = h.logging || (0, l.default)("Events"), g = {};
            g.ExceptionEvent = function(U, B, Q, N, J, w, W) {
              return new c.default(U, !1, {
                error: W,
                message: B,
                title: Q,
                code: N,
                component: J,
                target: w
              });
            }, g.IssueReportedEvent = function(U, B) {
              return new c.default(U, !1, {
                issueId: B
              });
            }, g.EnvLoadedEvent = function(U) {
              return new c.default(U, !1);
            };
            let f = !1;
            g.ConnectionEvent = /* @__PURE__ */ function(y) {
              (0, o.default)(U, y);
              function U(B, Q, N) {
                return y.call(this, B, !1, {
                  connection: Q,
                  reason: N
                }) || this;
              }
              return (0, t.default)(U, [{
                key: "connections",
                get: function() {
                  return f || (A.warn("OT.ConnectionEvent connections property is deprecated, use connection instead."), f = !0), [this.connection];
                }
              }]), U;
            }(c.default);
            let p = !1;
            g.StreamEvent = /* @__PURE__ */ function(y) {
              (0, o.default)(U, y);
              function U(B, Q, N, J) {
                return y.call(this, B, J, {
                  stream: Q,
                  reason: N
                }) || this;
              }
              return (0, t.default)(U, [{
                key: "streams",
                get: function() {
                  return p || (A.warn("OT.StreamEvent streams property is deprecated, use stream instead."), p = !0), [this.stream];
                }
              }]), U;
            }(c.default);
            let v = !1, b = !1, m = !1;
            return g.SessionConnectEvent = /* @__PURE__ */ function(y) {
              (0, o.default)(U, y);
              function U(B) {
                return y.call(this, B, !1) || this;
              }
              return (0, t.default)(U, [{
                key: "connections",
                get: function() {
                  return v || (A.warn("OT.SessionConnectedEvent no longer includes connections. Listen for connectionCreated events instead."), v = !0), [];
                }
                // eslint-disable-next-line class-methods-use-this
              }, {
                key: "streams",
                get: function() {
                  return b || (A.warn("OT.SessionConnectedEvent no longer includes streams. Listen for streamCreated events instead."), b = !0), [];
                }
                // eslint-disable-next-line class-methods-use-this
              }, {
                key: "archives",
                get: function() {
                  return m || (A.warn("OT.SessionConnectedEvent no longer includes archives. Listen for archiveStarted events instead."), m = !0), [];
                }
              }]), U;
            }(c.default), g.SessionReconnectingEvent = function() {
              return new c.default(d.default.SESSION_RECONNECTING, !1);
            }, g.SessionReconnectedEvent = function() {
              return new c.default(d.default.SESSION_RECONNECTED);
            }, g.SessionDisconnectEvent = function(U, B, Q) {
              return new c.default(U, Q, {
                reason: B
              });
            }, g.StreamPropertyChangedEvent = function(U, B, Q, N, J) {
              return new c.default(U, !1, {
                stream: B,
                changedProperty: Q,
                oldValue: N,
                newValue: J
              });
            }, g.VideoDimensionsChangedEvent = function(U, B, Q) {
              return new c.default("videoDimensionsChanged", !1, {
                target: U,
                oldValue: B,
                newValue: Q
              });
            }, g.ArchiveEvent = function(U, B) {
              return new c.default(U, !1, {
                id: B.id,
                name: B.name,
                status: B.status,
                archive: B
              });
            }, g.ArchiveUpdatedEvent = function(U, B, Q, N) {
              return new c.default("updated", !1, {
                target: U,
                changedProperty: B,
                oldValue: Q,
                newValue: N
              });
            }, g.SignalEvent = function(U, B, Q) {
              return new c.default(U ? `signal:${U}` : d.default.SIGNAL, !1, {
                data: B,
                from: Q
              });
            }, g.CaptionReceivedEvent = function(U, B, Q) {
              return new c.default("caption", !1, {
                caption: U,
                streamId: B,
                isFinal: Q
              });
            }, g.PublisherCaptionsEnabled = function(U) {
              return new c.default("publisherCaptionsEnabled", !1, {
                captionsEnabled: U
              });
            }, g.StreamUpdatedEvent = function(U, B, Q, N) {
              return new c.default("updated", !1, {
                target: U,
                changedProperty: B,
                oldValue: Q,
                newValue: N
              });
            }, g.DestroyedEvent = function(U, B, Q) {
              return new c.default(U, !1, {
                target: B,
                reason: Q
              });
            }, g.ConnectionStateChangedEvent = function(U, B, Q) {
              return new c.default(U, !1, {
                target: B,
                mediaMode: Q
              });
            }, g.VideoEnabledChangedEvent = function(U, B) {
              return new c.default(U, !1, {
                reason: B.reason
              });
            }, g.VideoDisableWarningEvent = function(U) {
              return new c.default(U, !1);
            }, g.AudioLevelUpdatedEvent = function(U) {
              return new c.default(d.default.AUDIO_LEVEL_UPDATED, !1, {
                audioLevel: U
              });
            }, g.MediaStoppedEvent = function(U, B) {
              return new c.default(d.default.MEDIA_STOPPED, !0, {
                target: U,
                track: B
              });
            }, g.MuteForcedEvent = function(U) {
              return new c.default(d.default.MUTE_FORCED, !1, U);
            }, g.VideoElementCreatedEvent = function(U) {
              return new c.default(d.default.VIDEO_ELEMENT_CREATED, !1, {
                element: U
              });
            }, g;
          }
        },
        /* 24 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(263)), l = {
            // Publishers are id'd by their guid
            publishers: new t.default("guid"),
            // Subscribers are id'd by their widgetId
            subscribers: new t.default("widgetId"),
            sessions: new t.default()
          };
          r.default = l;
        },
        /* 25 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.MEDIUM = r.LOW = r.CongestionLevels = r.CRITICAL = void 0;
          const n = 2;
          r.CRITICAL = n;
          const t = 1;
          r.MEDIUM = t;
          const o = 0;
          r.LOW = o;
          const l = {
            CRITICAL: n,
            MEDIUM: t,
            LOW: o
          };
          r.CongestionLevels = l;
        },
        /* 26 */
        /***/
        function(i, r, e) {
          var n = e(17), t = e(116);
          function o(l) {
            return l != null && t(l.length) && !n(l);
          }
          i.exports = o;
        },
        /* 27 */
        /***/
        function(i, r) {
          var e = i.exports = {}, n, t;
          function o() {
            throw new Error("setTimeout has not been defined");
          }
          function l() {
            throw new Error("clearTimeout has not been defined");
          }
          (function() {
            try {
              typeof setTimeout == "function" ? n = setTimeout : n = o;
            } catch {
              n = o;
            }
            try {
              typeof clearTimeout == "function" ? t = clearTimeout : t = l;
            } catch {
              t = l;
            }
          })();
          function c(m) {
            if (n === setTimeout)
              return setTimeout(m, 0);
            if ((n === o || !n) && setTimeout)
              return n = setTimeout, setTimeout(m, 0);
            try {
              return n(m, 0);
            } catch {
              try {
                return n.call(null, m, 0);
              } catch {
                return n.call(this, m, 0);
              }
            }
          }
          function d(m) {
            if (t === clearTimeout)
              return clearTimeout(m);
            if ((t === l || !t) && clearTimeout)
              return t = clearTimeout, clearTimeout(m);
            try {
              return t(m);
            } catch {
              try {
                return t.call(null, m);
              } catch {
                return t.call(this, m);
              }
            }
          }
          var u = [], h = !1, A, g = -1;
          function f() {
            !h || !A || (h = !1, A.length ? u = A.concat(u) : g = -1, u.length && p());
          }
          function p() {
            if (!h) {
              var m = c(f);
              h = !0;
              for (var y = u.length; y; ) {
                for (A = u, u = []; ++g < y; )
                  A && A[g].run();
                g = -1, y = u.length;
              }
              A = null, h = !1, d(m);
            }
          }
          e.nextTick = function(m) {
            var y = new Array(arguments.length - 1);
            if (arguments.length > 1)
              for (var U = 1; U < arguments.length; U++)
                y[U - 1] = arguments[U];
            u.push(new v(m, y)), u.length === 1 && !h && c(p);
          };
          function v(m, y) {
            this.fun = m, this.array = y;
          }
          v.prototype.run = function() {
            this.fun.apply(null, this.array);
          }, e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.version = "", e.versions = {};
          function b() {
          }
          e.on = b, e.addListener = b, e.once = b, e.off = b, e.removeListener = b, e.removeAllListeners = b, e.emit = b, e.prependListener = b, e.prependOnceListener = b, e.listeners = function(m) {
            return [];
          }, e.binding = function(m) {
            throw new Error("process.binding is not supported");
          }, e.cwd = function() {
            return "/";
          }, e.chdir = function(m) {
            throw new Error("process.chdir is not supported");
          }, e.umask = function() {
            return 0;
          };
        },
        /* 28 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(29)), c = n(e(6)), d = n(e(264)), u = n(e(260)), h = n(e(148)), A = n(e(37)), g = n(e(562)), f = n(e(564)), p = n(e(567));
          const v = (0, A.default)(), b = "2";
          let m = /* @__PURE__ */ function() {
            function y(B) {
              let Q = B === void 0 ? {} : B, N = Q.staticConfig, J = N === void 0 ? v.onlyLocal() : N, w = Q.sessionInfo, W = w === void 0 ? new h.default() : w, G = Q.ajax, Z = Q.queue, K = Q.getUserAgentClientHintData, L = K === void 0 ? p.default : K, O = Q.userAgentData, de = O === void 0 ? typeof navigator != "undefined" && navigator.userAgentData : O;
              this.getTurnServerName = (oe) => {
                let fe, ge;
                return !oe || typeof oe != "object" ? fe : ((Array.isArray(oe) ? oe : [oe]).forEach((_e) => {
                  const Te = _e.urls || _e.url;
                  (Array.isArray(Te) ? Te : [Te]).forEach(($e) => {
                    const Bt = $e.indexOf(":") + 1, Le = $e.lastIndexOf(":");
                    $e.includes("turns") ? ge = $e.substring(Bt, Le) : fe = $e.substring(Bt, Le);
                  });
                }), ge || fe);
              }, this.ajax = G, this.queue = Z, this.sessionInfo = W, this.getUserAgentClientHintData = L, this.userAgentData = de, this.staticConfig = J;
            }
            var U = y.prototype;
            return U._getCachedUserAgentData = /* @__PURE__ */ function() {
              var B = (0, o.default)(/* @__PURE__ */ t.default.mark(function N() {
                return t.default.wrap(function(w) {
                  for (; ; ) switch (w.prev = w.next) {
                    case 0:
                      if (this.cachedUserAgentData) {
                        w.next = 4;
                        break;
                      }
                      return w.next = 3, this.getUserAgentClientHintData(this.userAgentData);
                    case 3:
                      this.cachedUserAgentData = w.sent;
                    case 4:
                      return w.abrupt("return", this.cachedUserAgentData);
                    case 5:
                    case "end":
                      return w.stop();
                  }
                }, N, this);
              }));
              function Q() {
                return B.apply(this, arguments);
              }
              return Q;
            }(), U.commonQoSFields = function() {
              const Q = this._analytics.proxyUrl, N = this.sessionInfo.messagingURL;
              return {
                clientVersion: this.staticConfig.clientVersion,
                buildHash: this.staticConfig.buildHash,
                source: (typeof window !== void 0 ? window : Dn).location && (typeof window !== void 0 ? window : Dn).location.href,
                logVersion: b,
                apiServer: this.staticConfig.apiUrl,
                clientSystemTime: (/* @__PURE__ */ new Date()).getTime(),
                sessionId: this.sessionInfo.sessionId,
                mediaServerName: this.sessionInfo.mediaServerName,
                relayServer: this.getTurnServerName(this.sessionInfo.iceServers),
                p2p: this.sessionInfo.p2pEnabled,
                messagingServer: this.sessionInfo.messagingServer,
                messagingUrl: (0, g.default)(Q, N),
                version: this.staticConfig.version,
                partnerId: this.sessionInfo.partnerId
              };
            }, U._getCommonDataFields = /* @__PURE__ */ function() {
              var B = (0, o.default)(/* @__PURE__ */ t.default.mark(function N() {
                var J, w;
                return t.default.wrap(function(G) {
                  for (; ; ) switch (G.prev = G.next) {
                    case 0:
                      return G.next = 2, d.default.getAsync();
                    case 2:
                      return J = G.sent, G.next = 5, this._getCachedUserAgentData();
                    case 5:
                      return w = G.sent, G.abrupt("return", Object.assign({
                        guid: J
                      }, this.commonQoSFields(), w));
                    case 7:
                    case "end":
                      return G.stop();
                  }
                }, N, this);
              }));
              function Q() {
                return B.apply(this, arguments);
              }
              return Q;
            }(), U.logError = function(Q, N, J, w, W) {
              W === void 0 && (W = {}), this._getCommonDataFields().then((G) => {
                const Z = [Q, N, J, w, Object.assign({}, G, W)];
                y.emit("logError", ...Z), this._analytics.logError(...Z);
              });
            }, U.logEvent = function(Q, N, J) {
              Q === void 0 && (Q = {}), this._getCommonDataFields().then((w) => {
                const W = Object.assign({}, w, Q);
                y.emit("logEvent", W), this._analytics.logEvent(W, !1, N, J);
              });
            }, U.logQOS = function(Q) {
              Q === void 0 && (Q = {}), this._getCommonDataFields().then((N) => {
                const J = Object.assign({
                  duration: 0
                }, N, Q);
                (0, f.default)(J), y.emit("logQOS", J), this._analytics.logQOS(J);
              });
            }, (0, l.default)(y, [{
              key: "staticConfig",
              get: function() {
                return this._staticConfig;
              },
              set: function(Q) {
                this._staticConfig = Q, this._analytics = new u.default({
                  loggingUrl: this.staticConfig.loggingUrl,
                  ajax: this.ajax,
                  queue: this.queue
                });
              }
            }]), y;
          }();
          r.default = m, (0, c.default)(m), i.exports = m;
        },
        /* 29 */
        /***/
        function(i, r) {
          function e(t, o) {
            for (var l = 0; l < o.length; l++) {
              var c = o[l];
              c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(t, c.key, c);
            }
          }
          function n(t, o, l) {
            return o && e(t.prototype, o), l && e(t, l), t;
          }
          i.exports = n;
        },
        /* 30 */
        /***/
        function(i, r) {
          function e(n, t) {
            n.prototype = Object.create(t.prototype), n.prototype.constructor = n, n.__proto__ = t;
          }
          i.exports = e;
        },
        /* 31 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {
            // Activity Status for cams/mics
            ACTIVE: "active",
            INACTIVE: "inactive",
            UNKNOWN: "unknown",
            // Archive types
            PER_SESSION: "perSession",
            PER_STREAM: "perStream",
            // Events
            EXCEPTION: "exception",
            ISSUE_REPORTED: "issueReported",
            // Session Events
            SESSION_CONNECTED: "sessionConnected",
            SESSION_RECONNECTING: "sessionReconnecting",
            SESSION_RECONNECTED: "sessionReconnected",
            SESSION_DISCONNECTED: "sessionDisconnected",
            STREAM_CREATED: "streamCreated",
            STREAM_DESTROYED: "streamDestroyed",
            CONNECTION_CREATED: "connectionCreated",
            CONNECTION_DESTROYED: "connectionDestroyed",
            SIGNAL: "signal",
            STREAM_PROPERTY_CHANGED: "streamPropertyChanged",
            MICROPHONE_LEVEL_CHANGED: "microphoneLevelChanged",
            // Publisher Events
            RESIZE: "resize",
            SETTINGS_BUTTON_CLICK: "settingsButtonClick",
            DEVICE_INACTIVE: "deviceInactive",
            INVALID_DEVICE_NAME: "invalidDeviceName",
            ACCESS_ALLOWED: "accessAllowed",
            ACCESS_DENIED: "accessDenied",
            ACCESS_DIALOG_OPENED: "accessDialogOpened",
            ACCESS_DIALOG_CLOSED: "accessDialogClosed",
            ECHO_CANCELLATION_MODE_CHANGED: "echoCancellationModeChanged",
            MEDIA_STOPPED: "mediaStopped",
            PUBLISHER_DESTROYED: "destroyed",
            MUTE_FORCED: "muteForced",
            // Subscriber Events
            SUBSCRIBER_DESTROYED: "destroyed",
            SUBSCRIBER_CONNECTED: "connected",
            SUBSCRIBER_DISCONNECTED: "disconnected",
            SUBSCRIBER_CAPTION_RECEIVED: "captionReceived",
            // DeviceManager Events
            DEVICES_DETECTED: "devicesDetected",
            // DevicePanel Events
            DEVICES_SELECTED: "devicesSelected",
            CLOSE_BUTTON_CLICK: "closeButtonClick",
            MICLEVEL: "microphoneActivityLevel",
            MICGAINCHANGED: "microphoneGainChanged",
            // Environment Loader
            ENV_LOADED: "envLoaded",
            ENV_UNLOADED: "envUnloaded",
            // Audio activity Events
            AUDIO_LEVEL_UPDATED: "audioLevelUpdated",
            VIDEO_ELEMENT_CREATED: "videoElementCreated"
          };
          r.default = n;
        },
        /* 32 */
        /***/
        function(i, r, e) {
          var n = !0, t = !0;
          function o(c, d, u) {
            var h = c.match(d);
            return h && h.length >= u && parseInt(h[u], 10);
          }
          function l(c, d, u) {
            if (c.RTCPeerConnection) {
              var h = c.RTCPeerConnection.prototype, A = h.addEventListener;
              h.addEventListener = function(f, p) {
                if (f !== d)
                  return A.apply(this, arguments);
                var v = function(b) {
                  var m = u(b);
                  m && p(m);
                };
                return this._eventMap = this._eventMap || {}, this._eventMap[p] = v, A.apply(this, [
                  f,
                  v
                ]);
              };
              var g = h.removeEventListener;
              h.removeEventListener = function(f, p) {
                if (f !== d || !this._eventMap || !this._eventMap[p])
                  return g.apply(this, arguments);
                var v = this._eventMap[p];
                return delete this._eventMap[p], g.apply(this, [
                  f,
                  v
                ]);
              }, Object.defineProperty(h, "on" + d, {
                get: function() {
                  return this["_on" + d];
                },
                set: function(f) {
                  this["_on" + d] && (this.removeEventListener(
                    d,
                    this["_on" + d]
                  ), delete this["_on" + d]), f && this.addEventListener(
                    d,
                    this["_on" + d] = f
                  );
                },
                enumerable: !0,
                configurable: !0
              });
            }
          }
          i.exports = {
            extractVersion: o,
            wrapPeerConnectionEvent: l,
            disableLog: function(c) {
              return typeof c != "boolean" ? new Error("Argument type: " + typeof c + ". Please use a boolean.") : (n = c, c ? "adapter.js logging disabled" : "adapter.js logging enabled");
            },
            /**
             * Disable or enable deprecation warnings
             * @param {!boolean} bool set to true to disable warnings.
             */
            disableWarnings: function(c) {
              return typeof c != "boolean" ? new Error("Argument type: " + typeof c + ". Please use a boolean.") : (t = !c, "adapter.js deprecation warnings " + (c ? "disabled" : "enabled"));
            },
            log: function() {
              if (typeof window == "object") {
                if (n)
                  return;
                typeof console != "undefined" && typeof console.log == "function" && console.log.apply(console, arguments);
              }
            },
            /**
             * Shows a deprecation warning suggesting the modern and spec-compatible API.
             */
            deprecated: function(c, d) {
              t && console.warn(c + " is deprecated, please use " + d + " instead.");
            },
            /**
             * Browser detector.
             *
             * @return {object} result containing browser and version
             *     properties.
             */
            detectBrowser: function(c) {
              var d = c && c.navigator, u = {};
              if (u.browser = null, u.version = null, typeof c == "undefined" || !c.navigator)
                return u.browser = "Not a browser.", u;
              if (d.mozGetUserMedia)
                u.browser = "firefox", u.version = o(
                  d.userAgent,
                  /Firefox\/(\d+)\./,
                  1
                );
              else if (d.webkitGetUserMedia)
                u.browser = "chrome", u.version = o(
                  d.userAgent,
                  /Chrom(e|ium)\/(\d+)\./,
                  2
                );
              else if (d.mediaDevices && d.userAgent.match(/Edge\/(\d+).(\d+)$/))
                u.browser = "edge", u.version = o(
                  d.userAgent,
                  /Edge\/(\d+).(\d+)$/,
                  2
                );
              else if (c.RTCPeerConnection && d.userAgent.match(/AppleWebKit\/(\d+)\./))
                u.browser = "safari", u.version = o(
                  d.userAgent,
                  /AppleWebKit\/(\d+)\./,
                  1
                );
              else
                return u.browser = "Not a supported browser.", u;
              return u;
            }
          };
        },
        /* 33 */
        /***/
        function(i, r, e) {
          var n = e(44), t = e(365), o = e(366), l = "[object Null]", c = "[object Undefined]", d = n ? n.toStringTag : void 0;
          function u(h) {
            return h == null ? h === void 0 ? c : l : d && d in Object(h) ? t(h) : o(h);
          }
          i.exports = u;
        },
        /* 34 */
        /***/
        function(i, r, e) {
          var n = e(190), t = e(118), o = e(26);
          function l(c) {
            return o(c) ? n(c) : t(c);
          }
          i.exports = l;
        },
        /* 35 */
        /***/
        function(i, r, e) {
          var n = e(47);
          i.exports = function(t) {
            if (!n(t)) throw new TypeError("Cannot use null or undefined");
            return t;
          };
        },
        /* 36 */
        /***/
        function(i, r, e) {
          var n = e(56), t = e(211), o = e(130), l = e(212), c = e(213), d = i.exports = function(u, h) {
            var A, g, f, p, v;
            return arguments.length < 2 || typeof u != "string" ? (p = h, h = u, u = null) : p = arguments[2], n(u) ? (A = c.call(u, "c"), g = c.call(u, "e"), f = c.call(u, "w")) : (A = f = !0, g = !1), v = { value: h, configurable: A, enumerable: g, writable: f }, p ? o(l(p), v) : v;
          };
          d.gs = function(u, h, A) {
            var g, f, p, v;
            return typeof u != "string" ? (p = A, A = h, h = u, u = null) : p = arguments[3], n(h) ? t(h) ? n(A) ? t(A) || (p = A, A = void 0) : A = void 0 : (p = h, h = A = void 0) : h = void 0, n(u) ? (g = c.call(u, "c"), f = c.call(u, "e")) : (g = !0, f = !1), v = { get: h, set: A, configurable: g, enumerable: f }, p ? o(l(p), v) : v;
          };
        },
        /* 37 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(29)), l = t(e(218)), c = t(e(485)), d = t(e(536)), u = t(e(61)), h = t(e(1)), A = t(e(103));
            const g = (0, h.default)("StaticConfig"), f = (0, u.default)({ version: "v2.27.6", buildHash: "cf306f8", minimumVersion: { firefox: 52, chrome: 49 }, debug: !1, websiteURL: "http://www.tokbox.com", configURL: "https://config.opentok.com", ipWhitelistConfigURL: "", cdnURL: "", loggingURL: "https://hlg.tokbox.com/prod", apiURL: "https://anvil.opentok.com" }), p = (0, d.default)(["apiURL", "assetURL", "cdnURL", "sessionInfoOverrides", "loggingURL"]), v = {
              apiUrl: "apiURL",
              loggingUrl: "loggingURL"
            }, b = (0, c.default)((U) => v[U]);
            function m(U) {
              let B = U === void 0 ? {} : U, Q = B.axios, N = Q === void 0 ? l.default : Q;
              return /* @__PURE__ */ function() {
                w.onlyLocal = function() {
                  const G = (0, u.default)((typeof window !== void 0 ? window : Dn).OTProperties);
                  return new w(Object.assign({}, f, p(G)));
                }, w.get = function(G) {
                  let Z = G.partnerId, K = G.token, L = G.useIpWhitelistConfigUrl, O = G.proxyUrl;
                  return (() => {
                    const oe = this.onlyLocal();
                    if (!oe.configUrl)
                      return n.resolve({});
                    if (L === !0 && !oe.ipWhitelistConfigUrl)
                      return n.resolve({});
                    let fe = L === !0 ? oe.ipWhitelistConfigUrl : oe.configUrl;
                    return fe = (0, A.default)(fe, O), N.get(`${fe}/project/${Z}/config.json`, {
                      headers: {
                        "X-TB-TOKEN-AUTH": K
                      }
                    }).then((ge) => ge.data);
                  })().catch((oe) => (g.error("could not reach live config service", oe), {})).then((oe) => {
                    const fe = (0, u.default)((typeof window !== void 0 ? window : Dn).OTProperties), ge = Object.assign({}, f, p(fe), b(oe));
                    return new w(ge);
                  });
                };
                function w(W) {
                  Object.defineProperty(this, "config", {
                    value: Object.freeze((0, u.default)(W))
                  });
                }
                return (0, o.default)(w, [{
                  key: "configUrl",
                  get: function() {
                    return this.config.configURL;
                  }
                }, {
                  key: "ipWhitelistConfigUrl",
                  get: function() {
                    return this.config.ipWhitelistConfigURL;
                  }
                }, {
                  key: "apiUrl",
                  get: function() {
                    return this.config.apiURL;
                  }
                }, {
                  key: "loggingUrl",
                  get: function() {
                    return this.config.loggingURL;
                  }
                }, {
                  key: "apiEnabled",
                  get: function() {
                    return typeof this.config.apiEnabled != "undefined" ? this.config.apiEnabled : !0;
                  }
                }, {
                  key: "version",
                  get: function() {
                    return this.config.version;
                  }
                }, {
                  key: "clientVersion",
                  get: function() {
                    return `js-${(this.version || "unknown").replace("v", "")}`;
                  }
                }, {
                  key: "buildHash",
                  get: function() {
                    return this.config.buildHash;
                  }
                }, {
                  key: "minimumVersion",
                  get: function() {
                    return this.config.minimumVersion;
                  }
                }, {
                  key: "websiteUrl",
                  get: function() {
                    return this.config.websiteURL;
                  }
                }, {
                  key: "debug",
                  get: function() {
                    return this.config.debug === "true" || this.config.debug === !0;
                  }
                }, {
                  key: "sessionInfoOverrides",
                  get: function() {
                    return this.config.sessionInfoOverrides;
                  }
                }, {
                  key: "cdnUrl",
                  get: function() {
                    return this.config.cdnURL || `${(typeof window !== void 0 ? window : Dn).location.protocol}//${(typeof window !== void 0 ? window : Dn).location.host}`;
                  }
                }, {
                  key: "assetUrl",
                  get: function() {
                    return this.config.assetURL || `${this.cdnUrl}/webrtc/${this.version}`;
                  }
                }]), w;
              }();
            }
            var y = m;
            r.default = y;
          }).call(this, e(2));
        },
        /* 38 */
        /***/
        function(i, r, e) {
          var n = e(514), t = e(522), o = e(90), l = e(12), c = e(527);
          function d(u) {
            return typeof u == "function" ? u : u == null ? o : typeof u == "object" ? l(u) ? t(u[0], u[1]) : n(u) : c(u);
          }
          i.exports = d;
        },
        /* 39 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = -1, l = n == null ? 0 : n.length, c = Array(l); ++o < l; )
              c[o] = t(n[o], o, n);
            return c;
          }
          i.exports = e;
        },
        /* 40 */
        /***/
        function(i, r, e) {
          var n = e(537), t = e(140), o = t(function(l, c) {
            return l == null ? {} : n(l, c);
          });
          i.exports = o;
        },
        /* 41 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(7));
          function o(l, c) {
            let d;
            const u = c || {};
            l.setDisplayMode = function(h) {
              const A = h || "auto";
              d !== A && (t.default.removeClass(this.domElement, `OT_mode-${d}`), t.default.addClass(this.domElement, `OT_mode-${A}`), d = A);
            }, l.getDisplayMode = function() {
              return d;
            }, l.showAfterLoading = function() {
              t.default.removeClass(this.domElement, "OT_hide-forced");
            }, l.hideWhileLoading = function() {
              t.default.addClass(this.domElement, "OT_hide-forced");
            }, l.destroy = function() {
              return u.onDestroy && u.onDestroy(this.domElement), this.domElement && t.default.removeElement(this.domElement), l;
            }, l.appendTo = function(h) {
              return this.domElement = t.default.createElement(u.nodeName || "div", u.htmlAttributes, u.htmlContent), u.onCreate && u.onCreate(this.domElement), l.setDisplayMode(u.mode), u.mode === "auto" && (t.default.addClass(l.domElement, "OT_mode-on-hold"), setTimeout(() => {
                t.default.removeClass(l.domElement, "OT_mode-on-hold");
              }, 2e3)), h.appendChild(this.domElement), l;
            };
          }
        },
        /* 42 */
        /***/
        function(i, r, e) {
          var n = e(79), t = 4;
          function o(l) {
            return n(l, t);
          }
          i.exports = o;
        },
        /* 43 */
        /***/
        function(i, r, e) {
          var n = e(364), t = e(369);
          function o(l, c) {
            var d = t(l, c);
            return n(d) ? d : void 0;
          }
          i.exports = o;
        },
        /* 44 */
        /***/
        function(i, r, e) {
          var n = e(15), t = n.Symbol;
          i.exports = t;
        },
        /* 45 */
        /***/
        function(i, r, e) {
          var n = e(85), t = e(63);
          function o(l, c, d, u) {
            var h = !d;
            d || (d = {});
            for (var A = -1, g = c.length; ++A < g; ) {
              var f = c[A], p = u ? u(d[f], l[f], f, d, l) : void 0;
              p === void 0 && (p = l[f]), h ? t(d, f, p) : n(d, f, p);
            }
            return d;
          }
          i.exports = o;
        },
        /* 46 */
        /***/
        function(i, r, e) {
          var n = e(393), t = e(113), o = e(394), l = e(198), c = e(199), d = e(33), u = e(187), h = "[object Map]", A = "[object Object]", g = "[object Promise]", f = "[object Set]", p = "[object WeakMap]", v = "[object DataView]", b = u(n), m = u(t), y = u(o), U = u(l), B = u(c), Q = d;
          (n && Q(new n(new ArrayBuffer(1))) != v || t && Q(new t()) != h || o && Q(o.resolve()) != g || l && Q(new l()) != f || c && Q(new c()) != p) && (Q = function(N) {
            var J = d(N), w = J == A ? N.constructor : void 0, W = w ? u(w) : "";
            if (W)
              switch (W) {
                case b:
                  return v;
                case m:
                  return h;
                case y:
                  return g;
                case U:
                  return f;
                case B:
                  return p;
              }
            return J;
          }), i.exports = Q;
        },
        /* 47 */
        /***/
        function(i, r, e) {
          var n = e(414)();
          i.exports = function(t) {
            return t !== n && t !== null;
          };
        },
        /* 48 */
        /***/
        function(i, r, e) {
          i.exports = e(428)() ? e(93).Symbol : e(431);
        },
        /* 49 */
        /***/
        function(i, r, e) {
          var n = e(70), t = 1 / 0;
          function o(l) {
            if (typeof l == "string" || n(l))
              return l;
            var c = l + "";
            return c == "0" && 1 / l == -t ? "-0" : c;
          }
          i.exports = o;
        },
        /* 50 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = t;
          const n = (typeof window !== void 0 ? window : Dn).performance || {};
          function t() {
            return n.now ? n.timing.navigationStart + n.now() : Date.now();
          }
        },
        /* 51 */
        /***/
        function(i, r, e) {
          var n = e(602);
          function t(o) {
            return n(2, o);
          }
          i.exports = t;
        },
        /* 52 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(51)), o = n(e(1)), l = n(e(610)), c = n(e(37)), d = n(e(3)), u = n(e(611));
          const h = (0, c.default)(), A = function(v) {
            v === void 0 && (v = {});
            const b = v.env || d.default, m = v.hasGetUserMediaCapability || l.default, y = v.hasPeerConnectionCapability || u.default, U = v.logging || (0, o.default)("hasOpenTokSupport"), N = ((v.staticConfig || h.onlyLocal()).minimumVersion || {})[b.name.toLowerCase()];
            return N && N > b.version ? (U.debug("Support for", b.name, "is disabled because we require", N, "but this is", b.version), !1) : b.name === "Node" ? !0 : m() && y();
          }, g = (0, t.default)(() => A());
          var f = {
            check: A,
            once: g
          };
          r.default = f;
        },
        /* 53 */
        /***/
        function(i, r) {
          function e(n, t) {
            return n === t || n !== n && t !== t;
          }
          i.exports = e;
        },
        /* 54 */
        /***/
        function(i, r, e) {
          var n = e(190), t = e(388), o = e(26);
          function l(c) {
            return o(c) ? n(c, !0) : t(c);
          }
          i.exports = l;
        },
        /* 55 */
        /***/
        function(i, r) {
          function e(n, t) {
            var o = -1, l = n.length;
            for (t || (t = Array(l)); ++o < l; )
              t[o] = n[o];
            return t;
          }
          i.exports = e;
        },
        /* 56 */
        /***/
        function(i, r, e) {
          var n = void 0;
          i.exports = function(t) {
            return t !== n && t !== null;
          };
        },
        /* 57 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            const o = [];
            return {
              on(l, c) {
                for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
                  u[h - 2] = arguments[h];
                if (o.push({
                  eventName: l,
                  handler: c,
                  args: u
                }), t.on)
                  t.on(l, c);
                else if (t.addEventListener)
                  t.addEventListener(l, c, ...u);
                else
                  throw new Error("Object does not support events", t);
              },
              off(l, c) {
                if (t.off)
                  t.off(l, c);
                else if (t.removeEventListener) {
                  for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
                    u[h - 2] = arguments[h];
                  t.removeEventListener(l, c, ...u);
                } else
                  throw new Error("Object does not support events", t);
              },
              once(l, c) {
                for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
                  u[h - 2] = arguments[h];
                o.push({
                  eventName: l,
                  handler: c,
                  args: u
                }), t.once(l, c);
              },
              removeAll() {
                o.forEach((l) => {
                  let c = l.eventName, d = l.handler, u = l.args;
                  this.off(c, d, ...u);
                }), o.splice(0, o.length);
              }
            };
          }
        },
        /* 58 */
        /***/
        function(i, r, e) {
          var n = e(101);
          function t(o, l, c) {
            var d = o == null ? void 0 : n(o, l);
            return d === void 0 ? c : d;
          }
          i.exports = t;
        },
        /* 59 */
        /***/
        function(i, r, e) {
          var n = e(12), t = e(139), o = e(247), l = e(60);
          function c(d, u) {
            return n(d) ? d : t(d, u) ? [d] : o(l(d));
          }
          i.exports = c;
        },
        /* 60 */
        /***/
        function(i, r, e) {
          var n = e(524);
          function t(o) {
            return o == null ? "" : n(o);
          }
          i.exports = t;
        },
        /* 61 */
        /***/
        function(i, r, e) {
          var n = e(79), t = 1, o = 4;
          function l(c) {
            return n(c, t | o);
          }
          i.exports = l;
        },
        /* 62 */
        /***/
        function(i, r, e) {
          var n = e(625), t = e(291), o = n(t);
          i.exports = o;
        },
        /* 63 */
        /***/
        function(i, r, e) {
          var n = e(188);
          function t(o, l, c) {
            l == "__proto__" && n ? n(o, l, {
              configurable: !0,
              enumerable: !0,
              value: c,
              writable: !0
            }) : o[l] = c;
          }
          i.exports = t;
        },
        /* 64 */
        /***/
        function(i, r, e) {
          var n = e(383), t = e(18), o = Object.prototype, l = o.hasOwnProperty, c = o.propertyIsEnumerable, d = n(/* @__PURE__ */ function() {
            return arguments;
          }()) ? n : function(u) {
            return t(u) && l.call(u, "callee") && !c.call(u, "callee");
          };
          i.exports = d;
        },
        /* 65 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(15), o = e(384), l = r && !r.nodeType && r, c = l && typeof n == "object" && n && !n.nodeType && n, d = c && c.exports === l, u = d ? t.Buffer : void 0, h = u ? u.isBuffer : void 0, A = h || o;
            n.exports = A;
          }).call(this, e(86)(i));
        },
        /* 66 */
        /***/
        function(i, r) {
          var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
          function t(o, l) {
            var c = typeof o;
            return l = l == null ? e : l, !!l && (c == "number" || c != "symbol" && n.test(o)) && o > -1 && o % 1 == 0 && o < l;
          }
          i.exports = t;
        },
        /* 67 */
        /***/
        function(i, r) {
          function e(n) {
            return function(t) {
              return n(t);
            };
          }
          i.exports = e;
        },
        /* 68 */
        /***/
        function(i, r) {
          var e = Object.prototype;
          function n(t) {
            var o = t && t.constructor, l = typeof o == "function" && o.prototype || e;
            return t === l;
          }
          i.exports = n;
        },
        /* 69 */
        /***/
        function(i, r, e) {
          i.exports = function(n) {
            if (typeof n != "function") throw new TypeError(n + " is not a function");
            return n;
          };
        },
        /* 70 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(18), o = "[object Symbol]";
          function l(c) {
            return typeof c == "symbol" || t(c) && n(c) == o;
          }
          i.exports = l;
        },
        /* 71 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.getProxyUrl = r.errorMessages = r.clearProxyUrl = void 0, r.setProxyUrl = g;
          var t = n(e(10)), o = n(e(22)), l = n(e(24)), c = n(e(13)), d = n(e(8)), u = n(e(72));
          let h;
          const A = {
            SET_PROXY_URL_TIMING_ERROR: "The proxyUrl was set after a session or publisher was created.",
            PROXY_URL_ALREADY_SET_ERROR: "The proxyUrl has already been set. Setting it again will not have any effect."
          };
          r.errorMessages = A;
          function g(v) {
            const b = e(28), m = u.default, y = new b(), U = l.default.sessions.length() > 0, B = l.default.publishers.length() > 0;
            let Q;
            if (U) {
              const J = l.default.sessions.find((w) => w.currentState === "connected");
              Q = J ? J.sessionId : l.default.sessions.find().sessionId;
            } else
              Q = "";
            const N = {
              sessionId: Q,
              apiKey: m.value
            };
            if (B || U) {
              const J = (0, c.default)()(d.default.SET_PROXY_URL_TIMING_ERROR, new Error(A.SET_PROXY_URL_TIMING_ERROR), t.default.SET_PROXY_URL_TIMING_ERROR);
              o.default.handleJsException({
                error: J,
                target: N,
                analytics: y
              });
            } else if (h) {
              const J = (0, c.default)()(d.default.PROXY_URL_ALREADY_SET_ERROR, new Error(A.PROXY_URL_ALREADY_SET_ERROR), t.default.PROXY_URL_ALREADY_SET_ERROR);
              o.default.handleJsException({
                error: J,
                target: N,
                analytics: y
              });
            } else
              h = v;
          }
          const f = () => h;
          r.getProxyUrl = f;
          const p = () => {
            h = null;
          };
          r.clearProxyUrl = p;
        },
        /* 72 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(7)), o;
          let l;
          if ((t.default == null || (o = t.default.env) == null ? void 0 : o.name) === "Node")
            l = "";
          else {
            var c, d;
            const h = (c = Array.prototype.slice.call(document.getElementsByTagName("script"))) == null || (d = c.pop()) == null ? void 0 : d.getAttribute("src");
            l = (h && h.match(/[?&]apikey=([^&]+)/i) || [])[1] || "";
          }
          var u = {
            value: l
          };
          r.default = u;
        },
        /* 73 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t, o, l) {
            l === void 0 && (l = 1 / 0);
            let c = null, d = !1, u = 1;
            const h = 1e3 / o, A = () => {
              !d || u > l || (u += 1, t(), c = setTimeout(A, h));
            };
            this.start = () => {
              d || (d = !0, setTimeout(A, h));
            }, this.stop = () => {
              (typeof window !== void 0 ? window : Dn).clearTimeout(c), d = !1;
            };
          }
        },
        /* 74 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = pt;
            var o = t(e(4)), l = t(e(5)), c = t(e(160)), d = t(e(9)), u = t(e(61)), h = t(e(145)), A = t(e(289)), g = t(e(290)), f = t(e(16)), p = t(e(6)), v = t(e(1)), b = t(e(3)), m = t(e(10)), y = t(e(22)), U = t(e(265)), B = t(e(162)), Q = t(e(20)), N = t(e(75)), J = t(e(628)), w = t(e(630)), W = t(e(164)), G = t(e(631)), Z = t(e(633)), K = t(e(294)), L = t(e(297)), O = t(e(637)), de = t(e(638)), oe = t(e(640)), fe = t(e(642)), ge = t(e(644)), we = t(e(645)), _e = t(e(647)), Te = t(e(298)), Pe = t(e(651)), $e = t(e(8)), Bt = t(e(652)), Le = t(e(50)), at = t(e(292));
            function pt(kt) {
              kt === void 0 && (kt = {});
              const _t = kt.hasValidPeerConnection || w.default, Lt = kt.applySdpTransform || W.default, Ft = kt.createPeerConnection || G.default, Zt = kt.env || b.default, ft = kt.sdpTransformDefaults || Z.default, It = kt.getStatsAdapter || K.default, Kt = kt.getRtcStatsReportAdapter || L.default, Sn = kt.getSynchronizationSources || O.default, Cn = kt.IceCandidateProcessor || de.default, on = kt.logging || v.default, An = kt.offerProcessor || oe.default, Ue = kt.PeerConnectionChannels || fe.default, ne = kt.subscribeProcessor || ge.default, se = we.default, Ce = kt.changeMediaDirection || _e.default, At = Ce.changeMediaDirectionToInactive, Ge = Ce.changeMediaDirectionToRecvOnly, Ye = kt.Qos || Te.default, Qt = kt.global || (typeof window !== void 0 ? window : Dn), tn = kt.debounce || A.default, vn = kt.needsToSwapH264Profiles || Pe.default.once, Yt = (0, J.default)(), Tn = () => _t(Qt.RTCPeerConnection), er = kt.NativeRTCIceCandidate || Qt.RTCIceCandidate, lr = kt.NativeRTCSessionDescription || Qt.RTCSessionDescription, Br = kt.Errors || $e.default, pi = kt.OTErrorClass || y.default, $n = kt.ExceptionCodes || m.default, rr = kt.hasPictureInPictureBug || Bt.default, Kr = 1e4, Bi = (xo) => {
                let Yr = xo.sendMessage, Qo = xo.logging;
                const Wo = {};
                return (xi) => {
                  xi.candidate ? (Wo[xi.candidate.sdpMid] = xi.candidate.sdpMLineIndex, Yr("candidate", {
                    candidate: xi.candidate.candidate,
                    sdpMid: xi.candidate.sdpMid || "",
                    sdpMLineIndex: xi.candidate.sdpMLineIndex || 0
                  })) : Qo.debug("IceCandidateForwarder: No more ICE candidates.");
                };
              }, Li = () => {
              };
              return function(Yr) {
                Yr === void 0 && (Yr = {});
                let Qo = !1;
                const Wo = Yr, xi = Wo.iceConfig, Fa = xi === void 0 ? {
                  servers: []
                } : xi, sn = Wo.sendMessage, Ct = Wo.isPublisher, cn = Wo.offerOverrides, Hn = Wo.answerOverrides, Sr = Wo.p2p, ao = Wo.codecFlags, wr = Wo.sourceStreamId, Jr = Wo.keyStore, Fn = Wo.sFrameClientStore, Ia = Wo.isE2ee, wt = Wo.removeUnusedCodecs, Yn = Wo.sessionId;
                let kr = Yr, mr = kr.logAnalyticsEvent, yi = mr === void 0 ? Li : mr, Or = !1, Ei;
                const Rt = vn();
                let ln = 0, tt = !1, Oe = {}, Jt, St;
                const Vt = new se(yi), Et = (0, B.default)();
                function Qn(Xn, Kn) {
                  Qo || ["candidate", "offer", "answer", "pranswer"].indexOf(Xn) > -1 && (Qo = (Xn === "candidate" ? Kn.candidate : Kn.sdp).indexOf("typ relay") !== -1), sn(Xn, Kn);
                }
                const gn = (0, Le.default)();
                yi("createPeerConnection", "Attempt");
                const jt = {};
                jt.id = (0, f.default)();
                const On = on(`PeerConnection:${jt.id}`);
                On.debug("construct", {
                  id: jt.id,
                  options: Yr
                });
                const Ar = ft, ui = (Xn) => Fa.transportPolicy === "relay" && Xn != null && Xn.candidate.indexOf("typ relay") === -1, fr = (0, g.default)(Yr, ["isPublisher", "logAnalyticsEvent", "offerOverrides", "answerOverrides", "sendMessage"]);
                let Jn, Qr, ti, Wn, Hi, Ho = [];
                const Ea = (() => {
                  let Xn = fr.overrideSimulcastEnabled || !1;
                  return {
                    get() {
                      return Xn;
                    },
                    set(Kn) {
                      const pr = !!Kn && fr.capableSimulcastStreams > 1;
                      pr !== Xn && fr.overrideSimulcastEnabled === void 0 && (Xn = pr, jt.generateOfferAndSend());
                    }
                  };
                })(), Ga = () => {
                  jt.iceConnectionStateIsConnected() ? On.debug("iceRestart is going to wait until we disconnect or negotiationNeeded and then restart ice") : jt.generateOfferAndSend();
                }, No = /* @__PURE__ */ (() => {
                  let Xn = !1;
                  return {
                    get() {
                      return Xn;
                    },
                    set(Kn) {
                      const pr = !!Kn;
                      pr !== Xn && (Xn = pr, Xn && Ga());
                    }
                  };
                })(), Ba = {
                  clean() {
                    delete this.promise, delete this.resolve, delete this.reject;
                  }
                };
                Ba.promise = new n((Xn, Kn) => {
                  Ba.resolve = Xn, Ba.reject = Kn;
                });
                let Ra = new Cn(), us = "new";
                Object.defineProperty(jt, "signalingState", {
                  get() {
                    return Jn.signalingState;
                  },
                  set(Xn) {
                    return Jn.signalingState = Xn, Xn;
                  }
                }), (0, p.default)(jt), jt.addOptions = (Xn) => {
                  yi = Xn.logAnalyticsEvent;
                }, jt.startEncryption = /* @__PURE__ */ function() {
                  var Xn = (0, l.default)(/* @__PURE__ */ o.default.mark(function Kn(pr) {
                    var hi, Qi;
                    return o.default.wrap(function(bn) {
                      for (; ; ) switch (bn.prev = bn.next) {
                        case 0:
                          if (Ia) {
                            bn.next = 2;
                            break;
                          }
                          return bn.abrupt("return");
                        case 2:
                          return bn.next = 4, Yt({
                            sessionId: Yn,
                            connectionId: pr
                          });
                        case 4:
                          return hi = bn.sent, bn.next = 7, Fn.createSender(hi);
                        case 7:
                          return Jt = bn.sent, bn.next = 10, Jr.get();
                        case 10:
                          return Qi = bn.sent, bn.next = 13, Jt.setSenderEncryptionKey(Qi);
                        case 13:
                          St = (hn) => {
                            Jt.setSenderEncryptionKey(hn);
                          }, Jr.on("keyChanged", St), Jn.getTransceivers().forEach(/* @__PURE__ */ function() {
                            var hn = (0, l.default)(/* @__PURE__ */ o.default.mark(function xn(vr) {
                              return o.default.wrap(function(zi) {
                                for (; ; ) switch (zi.prev = zi.next) {
                                  case 0:
                                    return zi.next = 2, Jt.encrypt(hi, vr.sender);
                                  case 2:
                                  case "end":
                                    return zi.stop();
                                }
                              }, xn);
                            }));
                            return function(xn) {
                              return hn.apply(this, arguments);
                            };
                          }());
                        case 16:
                        case "end":
                          return bn.stop();
                      }
                    }, Kn);
                  }));
                  return function(Kn) {
                    return Xn.apply(this, arguments);
                  };
                }(), jt.once("iceConnected", /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function Xn() {
                  var Kn, pr;
                  return o.default.wrap(function(Qi) {
                    for (; ; ) switch (Qi.prev = Qi.next) {
                      case 0:
                        Kn = "", pr = {
                          pcc: parseInt((0, Le.default)() - gn, 10),
                          hasRelayCandidates: Qo,
                          proxyInfo: Kn
                        }, Jn && Jn.proxyInfo && (pr.proxyInfo = Jn.proxyInfo), yi("createPeerConnection", "Success", pr);
                      case 4:
                      case "end":
                        return Qi.stop();
                    }
                  }, Xn);
                }))), jt.startDecryption = /* @__PURE__ */ function() {
                  var Xn = (0, l.default)(/* @__PURE__ */ o.default.mark(function Kn(pr, hi) {
                    var Qi, qt, bn;
                    return o.default.wrap(function(xn) {
                      for (; ; ) switch (xn.prev = xn.next) {
                        case 0:
                          if (jt.iceConnectionStateIsConnected()) {
                            xn.next = 3;
                            break;
                          }
                          return jt.once("iceConnected", () => jt.startDecryption(pr, hi)), xn.abrupt("return");
                        case 3:
                          return xn.next = 5, Yt({
                            sessionId: Yn,
                            connectionId: pr
                          });
                        case 5:
                          return Qi = xn.sent, qt = hi.receiver, xn.next = 9, so(Qi);
                        case 9:
                          return bn = xn.sent, xn.prev = 10, xn.next = 13, bn == null ? void 0 : bn.decrypt(Qi, qt);
                        case 13:
                          xn.next = 18;
                          break;
                        case 15:
                          xn.prev = 15, xn.t0 = xn.catch(10), On.error(xn.t0);
                        case 18:
                        case "end":
                          return xn.stop();
                      }
                    }, Kn, null, [[10, 15]]);
                  }));
                  return function(Kn, pr) {
                    return Xn.apply(this, arguments);
                  };
                }(), Ba.resolve();
                const so = /* @__PURE__ */ function() {
                  var Xn = (0, l.default)(/* @__PURE__ */ o.default.mark(function Kn(pr) {
                    return o.default.wrap(function(Qi) {
                      for (; ; ) switch (Qi.prev = Qi.next) {
                        case 0:
                          if (!Oe[pr]) {
                            Qi.next = 2;
                            break;
                          }
                          return Qi.abrupt("return", Oe[pr]);
                        case 2:
                          return Oe[pr] = new n(/* @__PURE__ */ function() {
                            var qt = (0, l.default)(/* @__PURE__ */ o.default.mark(function bn(hn) {
                              var xn, vr;
                              return o.default.wrap(function(zi) {
                                for (; ; ) switch (zi.prev = zi.next) {
                                  case 0:
                                    return zi.next = 2, Jr.get();
                                  case 2:
                                    if (xn = zi.sent, vr = Fn.getReceiver(pr), vr) {
                                      zi.next = 9;
                                      break;
                                    }
                                    return zi.next = 7, Fn.createReceiver(pr);
                                  case 7:
                                    vr = zi.sent, vr.addReceiver(pr);
                                  case 9:
                                    vr.setReceiverEncryptionKey(pr, xn), Jr.on("keyChanged", (_i) => {
                                      vr.setReceiverEncryptionKey(pr, _i);
                                    }), vr.addEventListener("decryptFailed", () => {
                                      jt.trigger("decryptFailed");
                                    }), vr.addEventListener("decryptionRestored", () => {
                                      jt.trigger("decryptRestored");
                                    }), hn(vr);
                                  case 14:
                                  case "end":
                                    return zi.stop();
                                }
                              }, bn);
                            }));
                            return function(bn) {
                              return qt.apply(this, arguments);
                            };
                          }()), Qi.abrupt("return", Oe[pr]);
                        case 4:
                        case "end":
                          return Qi.stop();
                      }
                    }, Kn);
                  }));
                  return function(pr) {
                    return Xn.apply(this, arguments);
                  };
                }(), Va = (Xn) => {
                  if (On.debug("internalCreatePeerConnection: called"), Jn) {
                    On.debug("internalCreatePeerConnection: resolving synchronously"), Xn.call(null, null, Jn);
                    return;
                  }
                  if (Ho.push(Xn), !(Ho.length > 1)) {
                    if (On.debug(`Creating peer connection config "${JSON.stringify(fr)}".`), Fa.servers.length === 0 && (On.error("No ice servers present"), yi("Error", "noIceServers")), Fa.transportPolicy === "relay") {
                      const Kn = (pr) => pr && pr.indexOf("turn") === 0;
                      Fa.servers = Fa.servers.map((pr) => {
                        const hi = (0, u.default)(pr);
                        return Array.isArray(hi.urls) || (hi.urls = [hi.urls]), hi.urls = hi.urls.filter(Kn), hi.urls.length === 0 ? void 0 : hi;
                      }).filter((pr) => pr !== void 0);
                    }
                    fr.iceTransportPolicy = Fa.transportPolicy, fr.iceServers = Fa.servers, Ia && (fr.forceEncodedVideoInsertableStreams = !0, fr.forceEncodedAudioInsertableStreams = !0, fr.encodedInsertableStreams = !0), Tn().then((Kn) => {
                      if (!Kn)
                        throw On.error("createPeerConnection: Invalid RTCPeerConnection object"), new Error("Failed to create valid RTCPeerConnection object");
                      return Ft({
                        window: Qt,
                        config: fr
                      });
                    }).then(/* @__PURE__ */ function() {
                      var Kn = (0, l.default)(/* @__PURE__ */ o.default.mark(function pr(hi) {
                        return o.default.wrap(function(qt) {
                          for (; ; ) switch (qt.prev = qt.next) {
                            case 0:
                              qa(null, hi);
                            case 1:
                            case "end":
                              return qt.stop();
                          }
                        }, pr);
                      }));
                      return function(pr) {
                        return Kn.apply(this, arguments);
                      };
                    }(), (Kn) => qa(Kn));
                  }
                }, qa = (Xn, Kn) => {
                  if (Xn) {
                    za({
                      reason: `Failed to create PeerConnection, exception: ${Xn}`,
                      prefix: "NewPeerConnection"
                    }), Ho = [];
                    return;
                  }
                  On.debug("OT attachEventsToPeerConnection"), Jn = Kn, Ra && Ra.setPeerConnection(Kn), Qr = new Ue(Jn), fr.channels && Qr.addMany(fr.channels);
                  const pr = Bi({
                    sendMessage: Qn,
                    logging: On
                  }), hi = (xn) => {
                    if (Ba.resolve(), ui(xn.candidate)) {
                      On.debug("Ignore candidate", xn.candidate.candidate);
                      return;
                    }
                    pr(xn);
                  }, Qi = /* @__PURE__ */ function() {
                    var xn = (0, l.default)(/* @__PURE__ */ o.default.mark(function vr(Rr) {
                      return o.default.wrap(function(_i) {
                        for (; ; ) switch (_i.prev = _i.next) {
                          case 0:
                            ya(Rr);
                          case 1:
                          case "end":
                            return _i.stop();
                        }
                      }, vr);
                    }));
                    return function(Rr) {
                      return xn.apply(this, arguments);
                    };
                  }();
                  let qt = Jn.iceConnectionState;
                  const bn = (xn) => {
                    Jn ? (On.debug("iceconnectionstatechange", Jn.iceConnectionState), Jn.iceConnectionState === "connected" ? (qt === "disconnected" && jt.clearFailedTimeout(), jt.emit("iceConnected"), No.set(!1)) : Jn.iceConnectionState === "completed" && Zt.isLegacyEdge && setTimeout(() => ys.startCollecting(Jn), 1e3)) : On.debug("iceconnectionstatechange on peerConnection that no longer exists", jt);
                    const vr = xn.target.iceConnectionState;
                    jt.trigger("iceConnectionStateChange", vr), yi("attachEventsToPeerConnection", "iceconnectionstatechange", vr), vr === "disconnected" && (No.get() ? (On.debug("Restarting ice!"), jt.generateOfferAndSend()) : (0, N.default)() || (Hi = setTimeout(() => {
                      const Rr = "failed";
                      yi("attachEventsToPeerConnection", "iceconnectionstatechange", Rr), qt = Rr, jt.trigger("iceConnectionStateChange", Rr);
                    }, Kr))), qt !== "disconnected" && vr === "failed" && za({
                      reason: "The stream was unable to connect due to a network error. Make sure your connection isn't blocked by a firewall.",
                      prefix: "ICEWorkflow"
                    }), qt = vr;
                  }, hn = () => {
                    yi("peerConnection:negotiationNeeded", "Event"), Ct && jt.generateOfferAndSend(), jt.trigger("negotiationNeeded");
                  };
                  Jn.addEventListener("track", Qi), Jn.addEventListener("icecandidate", hi), Jn.addEventListener("signalingstatechange", oa), Jn.addEventListener("negotiationneeded", hn), Jn.addEventListener("iceconnectionstatechange", bn), Et.add(() => {
                    Jn && (Jn.removeEventListener("track", Qi), Jn.removeEventListener("icecandidate", hi), Jn.removeEventListener("signalingstatechange", oa), Jn.removeEventListener("negotiationneeded", hn), Jn.removeEventListener("iceconnectionstatechange", bn));
                  }), hs();
                }, hs = () => {
                  for (; Ho.length; )
                    Ho.shift().call(null);
                }, oi = () => {
                  Ra && (Ra.destroy(), Ra = null), Ho = [], ys.stopCollecting(), Et.releaseAll(), Ba.clean(), Jn !== null && (Jn.destroy && Jn.destroy(), Jn = null, jt.trigger("close")), jt.off();
                }, oa = (Xn) => {
                  const Kn = Xn.target.signalingState;
                  if (jt.emit("signalingStateChange", Kn), Kn === "stable" && jt.emit("signalingStateStable"), Kn && Kn !== us)
                    switch (us = Kn, On.debug(`stateChange: ${us}`), us) {
                      case "closed":
                        oi();
                        break;
                    }
                }, Wa = (Xn) => {
                  Xn.dataChannels = Qr.sampleQos(), jt.trigger("qos", {
                    parsedStats: Xn,
                    simulcastEnabled: Ea.get()
                  });
                }, Xa = () => {
                  let Xn;
                  if (Jn.getRemoteStreams)
                    Xn = Jn.getRemoteStreams();
                  else if (Jn.remoteStreams)
                    Xn = Jn.remoteStreams;
                  else
                    throw new Error("Invalid Peer Connection object implements no method for retrieving remote streams");
                  return Array.prototype.slice.call(Xn);
                }, ya = (Xn) => {
                  var Kn;
                  const pr = Xn.track, hi = Xn.transceiver, Qi = Xn.stream || ((Kn = Xn.streams) == null ? void 0 : Kn[0]);
                  yi("createPeerConnection", "TrackAdded"), jt.trigger("trackAdded", {
                    stream: Qi,
                    track: pr,
                    transceiver: hi
                  });
                }, Fl = (Xn, Kn, pr) => {
                  Or = !1, za({
                    reason: `PeerConnection.offerProcessor ${Xn}: ${Kn}`,
                    prefix: pr
                  });
                }, As = (Xn) => {
                  if (Or) {
                    Ei = Xn;
                    return;
                  }
                  Or = !0, yi("peerConnection:processOffer", "Event");
                  const Kn = new lr({
                    type: "offer",
                    sdp: Xn.content.sdp
                  }), pr = (Qi) => {
                    Or = !1, Ra && Ra.process(), Qn("answer", Qi), Zt.isLegacyEdge || ys.startCollecting(Jn, Ct), Ei && (As(Ei), Ei = null);
                  }, hi = (Qi) => jt.trigger("remoteVideoSupported", Qi);
                  Va(() => {
                    An(Jn, Qt.RTCPeerConnection, Qt.RTCSessionDescription, lr, Ar, Kn, ao, Sr, pr, Fl, hi, Rt, wr);
                  });
                }, gl = (Xn) => {
                  yi("peerConnection:processAnswer", "Event");
                  const Kn = "Failed to parse SessionDescription. a=extmap-allow-mixed Expects at least 2 fields.", pr = (hi) => {
                    typeof hi.includes == "function" && hi.includes(Kn) && (hi = "SessionDescription issue has been fixed in Chrome 71 and above. Please update your browser."), za({
                      reason: `Error while setting RemoteDescription ${hi}`,
                      prefix: "SetRemoteDescription"
                    });
                  };
                  if (!Xn.content.sdp) {
                    pr("Weird answer message, no SDP.");
                    return;
                  }
                  Wn = new lr({
                    type: "answer",
                    sdp: Lt(Ar, "remote", "answer", (0, d.default)({
                      replaceBaselineProfile: Rt
                    }, Hn), Xn.content.sdp).local
                  }), (() => {
                    const hi = () => {
                      On.debug("processAnswer: setRemoteDescription Success"), Ra && Ra.process();
                    };
                    Jn.setRemoteDescription(Wn).then(hi).catch(pr), Vt.setResolved();
                  })(), Zt.isLegacyEdge || ys.startCollecting(Jn, Ct);
                }, Vi = (Xn) => {
                  var Kn, pr;
                  if (((Kn = Jn) == null || (pr = Kn.signalingState) == null ? void 0 : pr.toLowerCase()) === "closed")
                    return;
                  yi("peerConnection:processSubscribe", "Event"), On.debug("processSubscribe: Sending offer to subscriber.");
                  let hi = Ea.get() ? fr.capableSimulcastStreams : 1;
                  wr === "P2P" && !Sr && (hi = 1), Va(() => {
                    ne({
                      peerConnection: Jn,
                      NativeRTCSessionDescription: lr,
                      sdpTransforms: Ar,
                      numSimulcastStreams: hi,
                      removeVideoOrientation: rr(),
                      offerOverrides: cn,
                      offerConstraints: {
                        iceRestart: No.get()
                      },
                      replaceBaselineProfile: Rt,
                      removeUnusedCodecs: wt
                    }).then((qt) => {
                      On.debug("processSubscribe: got offer, waiting for _readyToCompleteOffer"), ti = qt, Ba.promise.then(() => Xn(ti));
                    }, (qt) => {
                      za({
                        reason: `subscribeProcessor ${qt.message}: ${qt.reason}`,
                        prefix: qt.prefix
                      });
                    }), No.set(!1);
                  });
                }, zr = () => {
                  typeof St == "function" && Jr.off("keyChanged", St), Jt = null, Oe = null;
                };
                jt.generateOfferAndSend = () => {
                  const Xn = (Kn) => {
                    On.debug("processSubscribe: sending offer"), Qn("offer", Kn);
                  };
                  jt.generateOffer(Xn);
                }, jt.generateOffer = tn(function(Xn) {
                  Xn === void 0 && (Xn = () => {
                  }), Vt.enqueueOfferAnswer(() => Vi(Xn));
                }, 100);
                const za = (Xn) => {
                  let Kn = Xn.reason, pr = Xn.prefix;
                  On.error(Kn, "in state", Jn ? {
                    connectionState: Jn.connectionState,
                    iceConnectionState: Jn.iceConnectionState,
                    iceGatheringState: Jn.iceGatheringState,
                    signalingState: Jn.signalingState
                  } : "(none)"), jt.trigger("error", {
                    reason: Kn,
                    prefix: pr
                  });
                };
                jt.addTrack = (Xn, Kn) => {
                  const pr = new n((hi, Qi) => {
                    Va((qt) => {
                      if (qt)
                        return Qi(qt);
                      hi();
                    });
                  }).then(() => {
                    if (Jn.addTrack)
                      return Jn.addTrack(Xn, Kn);
                    const hi = Jn.getLocalStreams()[0];
                    if (hi === void 0)
                      throw new Error("PeerConnection has no existing streams, cannot addTrack");
                    hi.addTrack(Xn), jt.generateOfferAndSend();
                  }).then(() => new n((hi) => {
                    jt.once("signalingStateStable", () => {
                      hi();
                    });
                  }));
                  return (0, c.default)(pr, 15e3, "Renegotiation timed out");
                };
                function ws(Xn) {
                  this.track = Xn;
                }
                jt.setIceConfig = (Xn) => {
                  try {
                    Zt.isFirefox && (Xn.certificates = Jn.getConfiguration().certificates), Jn.setConfiguration(Xn);
                  } catch (Kn) {
                    throw new U.default(`A peer connection failed to set configuration with ${Kn.message}`, Br.FAILED_SET_CONFIGURATION);
                  }
                  return No.set(!0), Jn;
                }, jt.removeTrack = (Xn) => {
                  const Kn = n.resolve().then(() => {
                    if (Xn instanceof ws) {
                      Jn.getLocalStreams()[0].removeTrack(Xn.track), jt.generateOfferAndSend();
                      return;
                    }
                    return Jn.removeTrack(Xn);
                  }).then(() => new n((pr) => {
                    jt.once("signalingStateStable", () => {
                      pr();
                    });
                  }));
                  return (0, c.default)(Kn, 15e3, "Renegotiation timed out");
                }, jt.addLocalStream = (Xn) => new n((Kn, pr) => {
                  Va((hi) => {
                    if (hi) {
                      pr(hi);
                      return;
                    }
                    try {
                      Xn.getTracks && Xn.getTracks().forEach((Qi) => Jn.addTrack(Qi, Xn));
                    } catch (Qi) {
                      pr(Qi);
                      return;
                    }
                    Kn();
                  });
                }), jt.getLocalStreams = () => Jn.getLocalStreams(), jt.getSenders = () => Jn.getSenders ? Jn.getSenders() : Jn.getLocalStreams()[0].getTracks().map((Xn) => new ws(Xn)), jt.disconnect = () => {
                  var Xn;
                  Ra && (Ra.destroy(), Ra = null), (Xn = Jn) != null && Xn.signalingState && Jn.signalingState.toLowerCase() !== "closed" && (Jn.close(), zr(), setTimeout(oi));
                }, jt.iceRestart = () => No.set(!0), jt.clearFailedTimeout = () => clearTimeout(Hi);
                const Zi = (Xn) => {
                  const Kn = Xn ? At : Ge;
                  return new n((hi) => {
                    Vt.enqueueOfferAnswer(/* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function Qi() {
                      return o.default.wrap(function(bn) {
                        for (; ; ) switch (bn.prev = bn.next) {
                          case 0:
                            return bn.next = 2, Kn(Jn);
                          case 2:
                            Vt.setResolved(), hi();
                          case 4:
                          case "end":
                            return bn.stop();
                        }
                      }, Qi);
                    })));
                  });
                };
                jt.changeMediaDirectionToRecvOnly = () => Zi(!1), jt.changeMediaDirectionToInactive = () => Zi(!0), jt.processMessage = (Xn, Kn) => {
                  switch (On.debug(`processMessage: Received ${Xn} from ${Kn.fromAddress}`, Kn), On.debug(Kn), Xn) {
                    case "generateoffer":
                      Kn.content && Kn.content.simulcastEnabled !== void 0 && Ea.set(Kn.content.simulcastEnabled), jt.generateOfferAndSend(), hi();
                      break;
                    case "offer":
                      As(Kn), hi();
                      break;
                    case "answer":
                    case "pranswer":
                      gl(Kn);
                      break;
                    case "candidate":
                      var pr = new er(Kn.content);
                      Ra && Ra.addIceCandidate(pr).catch((Qi) => {
                        On.warn(`Error while adding ICE candidate: ${JSON.stringify(pr)}: ${Qi.toString()}`);
                      });
                      break;
                    default:
                      On.debug(`processMessage: Received an unexpected message of type ${Xn} from ${Kn.fromAddress}: ${JSON.stringify(Kn)}`);
                  }
                  function hi() {
                    ln += 1, ys.handleOfferMessageReceived(), ln > 1 && (yi("Renegotiation", "Attempt"), tt = !0);
                  }
                  return jt;
                };
                const kl = (Xn) => {
                  const Kn = (pr, hi) => pr.mid < hi.mid ? 1 : pr.mid > hi.mid ? -1 : 0;
                  return Xn.sort(Kn);
                }, vc = (Xn) => Jn.getTransceivers().filter((Kn) => Xn.includes(Kn.mid));
                jt.stopTransceivers = (Xn) => {
                  const Kn = vc(Xn);
                  kl(Kn).forEach((pr) => pr.stop());
                }, jt.setTransceiversToInactive = (Xn) => {
                  vc(Xn).forEach((pr) => {
                    pr.direction = at.default.INACTIVE;
                  });
                }, jt.remoteStreams = () => Jn ? Xa() : [], jt.remoteTracks = () => Jn ? Jn.getReceivers ? Array.prototype.slice.apply(Jn.getReceivers()).map((Xn) => Xn.track) : Array.prototype.concat.apply([], Xa().map((Xn) => Xn.getTracks())) : [], jt.remoteDescription = () => Jn.remoteDescription, jt.getStats = (Xn, Kn) => {
                  if (!Jn) {
                    const pr = $n.PEER_CONNECTION_NOT_CONNECTED;
                    Kn(new U.default(pi.getTitleByCode(pr), Br.PEER_CONNECTION_NOT_CONNECTED, {
                      code: pr
                    }));
                    return;
                  }
                  It(Jn, Xn, Kn);
                }, jt.getRtcStatsReport = (Xn, Kn) => {
                  if (!Jn) {
                    const pr = $n.PEER_CONNECTION_NOT_CONNECTED;
                    Kn(new U.default(pi.getTitleByCode(pr), Br.PEER_CONNECTION_NOT_CONNECTED, {
                      code: pr
                    }));
                    return;
                  }
                  Kt(Jn, Xn, Kn);
                }, jt.getSynchronizationSources = (Xn) => {
                  if (!Ct) {
                    if (!Jn) {
                      const Kn = $n.PEER_CONNECTION_NOT_CONNECTED;
                      Xn(new U.default(pi.getTitleByCode(Kn), Br.PEER_CONNECTION_NOT_CONNECTED, {
                        code: Kn
                      }));
                      return;
                    }
                    Sn(Jn, Xn);
                  }
                };
                const wl = function Xn(Kn, pr, hi, Qi) {
                  let qt;
                  const bn = Qr.get(pr, hi);
                  if (!bn) {
                    if (Kn > 0) {
                      setTimeout(Xn.bind(null, Kn - 1, pr, hi, Qi), 200);
                      return;
                    }
                    qt = new U.default(`A channel with that label and options could not be found. Label:${pr}. Options: ${JSON.stringify(hi)}`);
                  }
                  Qi(qt, bn);
                };
                jt.getDataChannel = (Xn, Kn, pr) => {
                  if (!Jn) {
                    pr(new U.default("Cannot create a DataChannel before there is a connection."));
                    return;
                  }
                  wl(100, Xn, Kn, pr);
                }, jt.getSourceStreamId = () => wr, jt.iceConnectionStateIsConnected = () => Jn && ["connected", "completed"].indexOf(Jn.iceConnectionState) > -1, jt.hasTrack = (Xn) => Jn.getSenders().some((Kn) => Kn.track === Xn), jt.findAndReplaceTrack = (Xn, Kn) => n.resolve().then(() => {
                  const pr = Jn.getSenders().filter((hi) => hi.track === Xn)[0];
                  if (!pr)
                    return n.resolve();
                  if (typeof pr.replaceTrack != "function")
                    throw new Error("Sender does not support replaceTrack");
                  return pr.replaceTrack(Kn);
                }), jt.hasRelayCandidates = () => Qo, jt.getNegotiatedCodecs = () => {
                  if (!Jn.localDescription || !Jn.remoteDescription)
                    return null;
                  const Xn = (Kn) => (0, h.default)(Q.default.getCodecs(Jn.localDescription.sdp, Kn), Q.default.getCodecs(Jn.remoteDescription.sdp, Kn));
                  return {
                    audio: Xn("audio"),
                    video: Xn("video")
                  };
                }, jt.on("signalingStateStable", () => {
                  tt && (tt = !1, yi("Renegotiation", "Success", jt.getNegotiatedCodecs()));
                }), jt.on("error", (Xn) => {
                  let Kn = Xn.prefix;
                  tt && ["CreateOffer", "SetRemoteDescription"].indexOf(Kn) !== -1 && (tt = !1, yi("Renegotiation", "Failure"));
                }), jt.on("close", () => {
                  tt && (tt = !1, yi("Renegotiation", "Cancel"));
                });
                const ys = new Ye();
                return ys.on("stats", Wa), jt;
              };
            }
          }).call(this, e(2));
        },
        /* 75 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3));
          const o = () => (
            // Chromium-based browsers version M90 logs a warning that Plan B is being removed
            (t.default.isChrome || t.default.isElectron) && t.default.version >= 90 || t.default.isOpera && t.default.version >= 76
          );
          var l = () => !o() && // For legacy browsers, we still enforce Plan B
          (t.default.isChrome && t.default.version > 71 || t.default.isChromiumEdge && t.default.version < 90 || t.default.isOpera && t.default.version > 58);
          r.default = l;
        },
        /* 76 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = {
            ACTIVE_VIDEO: 0,
            ACTIVE_VIDEO_WITH_WARNING: 1,
            SUSPENDED_VIDEO: 2
          };
          r.default = t;
        },
        /* 77 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(40)), o = n(e(677)), l = n(e(11)), c = n(e(165));
          const d = {};
          function u(b) {
            return Number(b.framerateMean || b.googFrameRateSent || b.googFrameRateReceived || b.googFrameRateInput || b.googFrameRateOutput || 0);
          }
          function h(b) {
            return Number(b.framesEncoded || b.framesDecoded);
          }
          function A(b, m) {
            if (u(b))
              return u(b);
            if (!h(b))
              return;
            let y = 0;
            const U = d[b.id] ? d[b.id].frames : 0, B = d[b.id] ? d[b.id].timestamp : m;
            return y = (0, c.default)({
              currentStatFrames: h(b),
              currentTimestamp: b.timestamp,
              prevStatFrames: U,
              prevTimestamp: B
            }), d[b.id] = {
              frames: h(b),
              timestamp: b.timestamp
            }, y;
          }
          function g(b, m) {
            if (!m)
              return {};
            const y = m.filter((U) => U.id === b.mediaTrackId);
            return y.length ? y[0] : {};
          }
          function f(b, m) {
            return "packetsLost" in m ? b + m.packetsLost : b;
          }
          const p = {
            isVideoStat(b, m) {
              const y = g(b, m);
              return b.kind === "video" && ["outbound-rtp", "inbound-rtp"].includes(b.type) || b.mediaType === "video" || "googFrameWidthReceived" in b || // Old Chrome
              "googFrameWidthInput" in b || // Old Chrome
              b.type === "inbound-rtp" && b.id.indexOf("Video") !== -1 || // Safari
              b.type === "inboundrtp" && y.frameWidth !== 0;
            },
            isAudioStat(b, m) {
              const y = g(b, m);
              return b.kind === "audio" && ["outbound-rtp", "inbound-rtp"].includes(b.type) || b.mediaType === "audio" || "audioInputLevel" in b || // Old Chrome
              "audioOutputLevel" in b || // Old Chrome
              b.type === "inbound-rtp" && b.id.indexOf("Audio") !== -1 || // Safari
              b.type === "inboundrtp" && y.frameWidth === 0;
            },
            isInboundStat(b) {
              return "bytesReceived" in b || "packetsReceived" in b;
            },
            isOutboundStat(b) {
              return "bytesSent" in b || "packetsSent" in b;
            },
            isVideoTrackStat(b) {
              return b.type === "track" && (b.frameHeight > 0 || b.frameWidth > 0 || b.framesCorrupted > 0 || b.framesDecoded > 0 || b.framesPerSecond > 0 || b.framesSent > 0 || b.framesReceived > 0);
            },
            isVideoRemoteInboundRtpStat(b) {
              return b.type === "remote-inbound-rtp" && b.kind === "video";
            },
            isAudioRemoteInboundRtpStat(b) {
              return b.type === "remote-inbound-rtp" && b.kind === "audio";
            },
            isVideoInboundRtpStat(b) {
              return b.type === "inbound-rtp" && b.kind === "video";
            },
            parseStatCategory(b) {
              const m = {
                packetsLost: 0,
                packetsReceived: 0,
                bytesReceived: 0
                // frameRate is only set for video stat
              };
              return "packetsReceived" in b && (m.packetsReceived = parseInt(b.packetsReceived, 10)), "packetsLost" in b && (m.packetsLost = parseInt(b.packetsLost, 10)), "bytesReceived" in b && (m.bytesReceived = parseInt(b.bytesReceived, 10)), this.isVideoStat(b) && ("framerateMean" in b ? m.frameRate = Number(b.framerateMean) : "googFrameRateOutput" in b ? m.frameRate = Number(b.googFrameRateOutput) : "googFrameRateInput" in b && (m.frameRate = Number(b.googFrameRateInput))), m;
            },
            getVideoPacketsLost(b) {
              return b.filter((m) => this.isVideoRemoteInboundRtpStat(m, b)).reduce(f, 0);
            },
            getAudioPacketsLost(b) {
              return b.filter((m) => this.isAudioRemoteInboundRtpStat(m, b)).reduce(f, 0);
            },
            normalizeTimestamp(b, m) {
              return m === void 0 && (m = Date.now()), (0, l.default)(b) && "getTime" in b ? b.getTime() : Math.abs(b / (1e3 * m) - 1) < 0.05 ? b / 1e3 : b;
            },
            normalizeStats(b, m, y) {
              m === void 0 && (m = !0);
              const U = b.filter((L) => p.isVideoStat(L, b)).filter((L) => p.isInboundStat(L) === m), B = b.filter((L) => this.isAudioStat(L, b)).filter((L) => this.isInboundStat(L) === m)[0], Q = U[0];
              if (!B && !Q)
                throw new Error("could not find stats for either audio or video");
              const N = p.normalizeTimestamp(Q ? Q.timestamp : B.timestamp), J = {
                timestamp: N
              };
              Q && !m && Q.packetsLost === void 0 && (Q.packetsLost = this.getVideoPacketsLost(b)), B && !m && B.packetsLost === void 0 && (B.packetsLost = this.getAudioPacketsLost(b));
              const w = ["packetsSent", "packetsLost", "bytesSent"], Z = m ? (L) => (0, t.default)(L, ["packetsReceived", "packetsLost", "bytesReceived"]) : (L) => (0, t.default)(L, w), K = (L) => {
                const O = ["framerateMean", "googFrameRateSent", "googFrameRateReceived", "googFrameRateInput", "googFrameRateOutput", "framesEncoded", "framesDecoded"], de = w.concat(O), oe = {
                  timestamp: N,
                  id: Q.id
                };
                return de.forEach((fe) => {
                  oe[fe] = L.map((ge) => Number(ge[fe] || 0)).reduce((ge, we) => ge + we, 0);
                }), oe;
              };
              if (U && U.length > 0) {
                const L = K(U);
                J.video = Object.assign({
                  frameRate: A(L, y)
                }, (0, o.default)(Z(L), Number));
              }
              return B && (J.audio = (0, o.default)(Z(B), Number)), J;
            }
          };
          var v = p;
          r.default = v;
        },
        /* 78 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.messages = r.default = r.codes = void 0;
          const n = {
            1e3: "The connection successfully completed the purpose for which it was created.",
            1001: "The endpoint is going away, either because of a server failure or because the browser is navigating away from the page that opened the connection.",
            1002: "The endpoint is terminating the connection due to a protocol error. (CLOSE_PROTOCOL_ERROR)",
            1003: "The connection is being terminated because the endpoint has indicated that reconnections are not available. (CLOSE_UNSUPPORTED)",
            1005: "Indicates that no status code was provided even though one was expected. (CLOSE_NO_STATUS)",
            1006: "Used to indicate that a connection was closed abnormally (that is, with no close frame being sent) when a status code is expected. (CLOSE_ABNORMAL)",
            1007: "Indicates that an endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [RFC3629] data within a text message)",
            1008: "Indicates that an endpoint is terminating the connection because it has received a message that violates its policy.  This is a generic status code that can be returned when there is no other more suitable status code (e.g., 1003 or 1009) or if there is a need to hide specific details about the policy",
            1009: "Indicates that an endpoint is terminating the connection because it has received a message that is too big for it to process (CLOSE_TOO_LARGE)",
            1011: "Indicates that a server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request",
            // ... codes in the 4000-4999 range are available for use by applications.
            4001: "Connectivity loss was detected as it was too long since the socket received the last PONG message",
            4010: "Timed out while waiting for the Rumor socket to connect.",
            4020: "Error code unavailable.",
            4030: "Exception was thrown during Rumor connection, possibly because of a blocked port."
          };
          r.messages = n;
          const t = {
            CLOSE_NORMAL: 1e3,
            CLOSE_GOING_AWAY: 1001,
            CLOSE_PROTOCOL_ERROR: 1002,
            CLOSE_UNSUPPORTED: 1003,
            CLOSE_NO_STATUS: 1005,
            CLOSE_ABNORMAL: 1006,
            CLOSE_INCONSISTENT_DATA: 1007,
            CLOSE_POLICY_VIOLATION: 1008,
            CLOSE_TOO_LARGE: 1009,
            CLOSE_UNEXPECTED_CONDITION: 1011,
            CLOSE_CONNECTIVITY_LOSS: 4001,
            CLOSE_TIMEOUT: 4010,
            CLOSE_FALLBACK_CODE: 4020,
            CLOSE_CONNECT_EXCEPTION: 4030,
            ALREADY_CONNECTED_CONNECTING: null
          };
          r.codes = t;
          var o = {
            messages: n,
            codes: t
          };
          r.default = o;
        },
        /* 79 */
        /***/
        function(i, r, e) {
          var n = e(80), t = e(115), o = e(85), l = e(189), c = e(387), d = e(192), u = e(55), h = e(390), A = e(392), g = e(195), f = e(197), p = e(46), v = e(395), b = e(396), m = e(202), y = e(12), U = e(65), B = e(400), Q = e(11), N = e(402), J = e(34), w = e(54), W = 1, G = 2, Z = 4, K = "[object Arguments]", L = "[object Array]", O = "[object Boolean]", de = "[object Date]", oe = "[object Error]", fe = "[object Function]", ge = "[object GeneratorFunction]", we = "[object Map]", _e = "[object Number]", Te = "[object Object]", Pe = "[object RegExp]", $e = "[object Set]", Bt = "[object String]", Le = "[object Symbol]", at = "[object WeakMap]", pt = "[object ArrayBuffer]", kt = "[object DataView]", _t = "[object Float32Array]", Lt = "[object Float64Array]", Ft = "[object Int8Array]", Zt = "[object Int16Array]", ft = "[object Int32Array]", It = "[object Uint8Array]", Kt = "[object Uint8ClampedArray]", Sn = "[object Uint16Array]", Cn = "[object Uint32Array]", on = {};
          on[K] = on[L] = on[pt] = on[kt] = on[O] = on[de] = on[_t] = on[Lt] = on[Ft] = on[Zt] = on[ft] = on[we] = on[_e] = on[Te] = on[Pe] = on[$e] = on[Bt] = on[Le] = on[It] = on[Kt] = on[Sn] = on[Cn] = !0, on[oe] = on[fe] = on[at] = !1;
          function An(Ue, ne, se, Ce, At, Ge) {
            var Ye, Qt = ne & W, tn = ne & G, vn = ne & Z;
            if (se && (Ye = At ? se(Ue, Ce, At, Ge) : se(Ue)), Ye !== void 0)
              return Ye;
            if (!Q(Ue))
              return Ue;
            var Yt = y(Ue);
            if (Yt) {
              if (Ye = v(Ue), !Qt)
                return u(Ue, Ye);
            } else {
              var Tn = p(Ue), er = Tn == fe || Tn == ge;
              if (U(Ue))
                return d(Ue, Qt);
              if (Tn == Te || Tn == K || er && !At) {
                if (Ye = tn || er ? {} : m(Ue), !Qt)
                  return tn ? A(Ue, c(Ye, Ue)) : h(Ue, l(Ye, Ue));
              } else {
                if (!on[Tn])
                  return At ? Ue : {};
                Ye = b(Ue, Tn, Qt);
              }
            }
            Ge || (Ge = new n());
            var lr = Ge.get(Ue);
            if (lr)
              return lr;
            Ge.set(Ue, Ye), N(Ue) ? Ue.forEach(function($n) {
              Ye.add(An($n, ne, se, $n, Ue, Ge));
            }) : B(Ue) && Ue.forEach(function($n, rr) {
              Ye.set(rr, An($n, ne, se, rr, Ue, Ge));
            });
            var Br = vn ? tn ? f : g : tn ? w : J, pi = Yt ? void 0 : Br(Ue);
            return t(pi || Ue, function($n, rr) {
              pi && (rr = $n, $n = Ue[rr]), o(Ye, rr, An($n, ne, se, rr, Ue, Ge));
            }), Ye;
          }
          i.exports = An;
        },
        /* 80 */
        /***/
        function(i, r, e) {
          var n = e(81), t = e(359), o = e(360), l = e(361), c = e(362), d = e(363);
          function u(h) {
            var A = this.__data__ = new n(h);
            this.size = A.size;
          }
          u.prototype.clear = t, u.prototype.delete = o, u.prototype.get = l, u.prototype.has = c, u.prototype.set = d, i.exports = u;
        },
        /* 81 */
        /***/
        function(i, r, e) {
          var n = e(354), t = e(355), o = e(356), l = e(357), c = e(358);
          function d(u) {
            var h = -1, A = u == null ? 0 : u.length;
            for (this.clear(); ++h < A; ) {
              var g = u[h];
              this.set(g[0], g[1]);
            }
          }
          d.prototype.clear = n, d.prototype.delete = t, d.prototype.get = o, d.prototype.has = l, d.prototype.set = c, i.exports = d;
        },
        /* 82 */
        /***/
        function(i, r, e) {
          var n = e(53);
          function t(o, l) {
            for (var c = o.length; c--; )
              if (n(o[c][0], l))
                return c;
            return -1;
          }
          i.exports = t;
        },
        /* 83 */
        /***/
        function(i, r, e) {
          var n = e(43), t = n(Object, "create");
          i.exports = t;
        },
        /* 84 */
        /***/
        function(i, r, e) {
          var n = e(378);
          function t(o, l) {
            var c = o.__data__;
            return n(l) ? c[typeof l == "string" ? "string" : "hash"] : c.map;
          }
          i.exports = t;
        },
        /* 85 */
        /***/
        function(i, r, e) {
          var n = e(63), t = e(53), o = Object.prototype, l = o.hasOwnProperty;
          function c(d, u, h) {
            var A = d[u];
            (!(l.call(d, u) && t(A, h)) || h === void 0 && !(u in d)) && n(d, u, h);
          }
          i.exports = c;
        },
        /* 86 */
        /***/
        function(i, r) {
          i.exports = function(e) {
            return e.webpackPolyfill || (e.deprecate = function() {
            }, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
              enumerable: !0,
              get: function() {
                return e.l;
              }
            }), Object.defineProperty(e, "id", {
              enumerable: !0,
              get: function() {
                return e.i;
              }
            }), e.webpackPolyfill = 1), e;
          };
        },
        /* 87 */
        /***/
        function(i, r, e) {
          var n = e(385), t = e(67), o = e(117), l = o && o.isTypedArray, c = l ? t(l) : n;
          i.exports = c;
        },
        /* 88 */
        /***/
        function(i, r, e) {
          var n = e(11), t = Object.create, o = /* @__PURE__ */ function() {
            function l() {
            }
            return function(c) {
              if (!n(c))
                return {};
              if (t)
                return t(c);
              l.prototype = c;
              var d = new l();
              return l.prototype = void 0, d;
            };
          }();
          i.exports = o;
        },
        /* 89 */
        /***/
        function(i, r, e) {
          var n = e(90), t = e(205), o = e(124);
          function l(c, d) {
            return o(t(c, d, n), c + "");
          }
          i.exports = l;
        },
        /* 90 */
        /***/
        function(i, r) {
          function e(n) {
            return n;
          }
          i.exports = e;
        },
        /* 91 */
        /***/
        function(i, r, e) {
          var n = Object.prototype.toString, t = n.call(/* @__PURE__ */ function() {
            return arguments;
          }());
          i.exports = function(o) {
            return n.call(o) === t;
          };
        },
        /* 92 */
        /***/
        function(i, r, e) {
          var n = Object.prototype.toString, t = n.call("");
          i.exports = function(o) {
            return typeof o == "string" || o && typeof o == "object" && (o instanceof String || n.call(o) === t) || !1;
          };
        },
        /* 93 */
        /***/
        function(i, r, e) {
          i.exports = e(429)() ? globalThis : e(430);
        },
        /* 94 */
        /***/
        function(i, r, e) {
          (function(n) {
            r.__esModule = !0, r.default = t;
            function t(o) {
              return new n((l) => setTimeout(l, o));
            }
          }).call(this, e(2));
        },
        /* 95 */
        /***/
        function(i, r, e) {
          var n = e(88), t = e(11);
          function o(l) {
            return function() {
              var c = arguments;
              switch (c.length) {
                case 0:
                  return new l();
                case 1:
                  return new l(c[0]);
                case 2:
                  return new l(c[0], c[1]);
                case 3:
                  return new l(c[0], c[1], c[2]);
                case 4:
                  return new l(c[0], c[1], c[2], c[3]);
                case 5:
                  return new l(c[0], c[1], c[2], c[3], c[4]);
                case 6:
                  return new l(c[0], c[1], c[2], c[3], c[4], c[5]);
                case 7:
                  return new l(c[0], c[1], c[2], c[3], c[4], c[5], c[6]);
              }
              var d = n(l.prototype), u = l.apply(d, c);
              return t(u) ? u : d;
            };
          }
          i.exports = o;
        },
        /* 96 */
        /***/
        function(i, r, e) {
          var n = e(501);
          function t(o, l) {
            var c = o == null ? 0 : o.length;
            return !!c && n(o, l, 0) > -1;
          }
          i.exports = t;
        },
        /* 97 */
        /***/
        function(i, r, e) {
          var n = e(507);
          function t(o) {
            var l = n(o), c = l % 1;
            return l === l ? c ? l - c : l : 0;
          }
          i.exports = t;
        },
        /* 98 */
        /***/
        function(i, r, e) {
          var n = e(114), t = e(517), o = e(518);
          function l(c) {
            var d = -1, u = c == null ? 0 : c.length;
            for (this.__data__ = new n(); ++d < u; )
              this.add(c[d]);
          }
          l.prototype.add = l.prototype.push = t, l.prototype.has = o, i.exports = l;
        },
        /* 99 */
        /***/
        function(i, r) {
          function e(n, t) {
            return n.has(t);
          }
          i.exports = e;
        },
        /* 100 */
        /***/
        function(i, r) {
          function e(n) {
            var t = -1, o = Array(n.size);
            return n.forEach(function(l) {
              o[++t] = l;
            }), o;
          }
          i.exports = e;
        },
        /* 101 */
        /***/
        function(i, r, e) {
          var n = e(59), t = e(49);
          function o(l, c) {
            c = n(c, l);
            for (var d = 0, u = c.length; l != null && d < u; )
              l = l[t(c[d++])];
            return d && d == u ? l : void 0;
          }
          i.exports = o;
        },
        /* 102 */
        /***/
        function(i, r, e) {
          var n = e(250), t = e(34);
          function o(l, c) {
            return l && n(l, c, t);
          }
          i.exports = o;
        },
        /* 103 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(251));
          const o = (d) => d.replace(/\/$/, "");
          var c = (d, u) => {
            if (!u) return d;
            const h = t.default.parse(u), A = t.default.parse(d);
            if (!h.protocol || !A.protocol) return d;
            const g = h.protocol.match(/^https/), p = (A.protocol.match(/^ws/i) ? "ws" : "http") + (g ? "s" : ""), v = o(`${p}://${h.host}${h.pathname}`), b = o(`${A.host}${A.pathname}${A.search || ""}`);
            return `${v}/${b}`;
          };
          r.default = c;
        },
        /* 104 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          let n = "";
          var c = {
            getCurrentAudioOutputDeviceId: () => n,
            setCurrentAudioOutputDeviceId: (d) => {
              n = d;
            }
          };
          r.default = c;
        },
        /* 105 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(9));
          const o = (c, d, u) => d && !u ? () => d.call(c) : d && u ? (h) => (h !== void 0 && u.call(c, h), d.call(c)) : (h) => {
            h !== void 0 && u.call(c, h);
          };
          function l(c, d) {
            const u = {};
            Object.keys(d).forEach((h) => {
              u[h] = o(c, d[h].get, d[h].set);
            }), (0, t.default)(c, u);
          }
        },
        /* 106 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(203));
          function o(c) {
            let d = c === void 0 ? {} : c, u = d.NativeVideoElementWrapper;
            const A = u === void 0 ? (0, t.default)() : u, g = 50;
            function f(p) {
              let v = p === void 0 ? {} : p, b = v.fallbackText, m = b === void 0 ? "Sorry, Web RTC is not available in your browser" : b, y = v.fitMode, U = v.muted, B = v._inject, Q = v.widgetType;
              return new A({
                fallbackText: m,
                fitMode: y,
                muted: U,
                defaultAudioVolume: g,
                _inject: B,
                widgetType: Q
              });
            }
            return f;
          }
          var l = o;
          r.default = l;
        },
        /* 107 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.adaptIceServers = n, r.parseIceServers = t;
          function n(o) {
            return o.map((l) => ({
              url: l.url,
              // deprecated
              urls: l.urls || [l.url],
              username: l.username,
              credential: l.credential
            }));
          }
          function t(o) {
            let l;
            try {
              l = JSON.parse(o.data).content.iceServers;
            } catch {
              return [];
            }
            return n(l);
          }
        },
        /* 108 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = () => t.default.name === "Chrome" && t.default.version >= 58 || ["Firefox", "Edge", "Safari", "Opera"].indexOf(t.default.name) !== -1;
          r.default = o;
        },
        /* 109 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            let o = null, l = !1;
            const c = () => {
              l && (t(), o = window.requestAnimationFrame(c));
            };
            this.start = () => {
              l || (l = !0, window.requestAnimationFrame(c));
            }, this.stop = () => {
              window.cancelAnimationFrame(o), l = !1;
            };
          }
        },
        /* 110 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.ONE_SECOND_IN_MS = r.ONE_MINUTE_IN_MS = void 0;
          const n = 1e3;
          r.ONE_SECOND_IN_MS = n;
          const t = 60 * n;
          r.ONE_MINUTE_IN_MS = t;
        },
        /* 111 */
        /***/
        function(i, r, e) {
          Object.defineProperty(r, "__esModule", {
            value: !0
          }), r.CancellationError = r.default = void 0;
          var n = e(684), t = c(n), o = e(320), l = c(o);
          function c(d) {
            return d && d.__esModule ? d : { default: d };
          }
          r.default = t.default, r.CancellationError = l.default;
        },
        /* 112 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(52)), o, l;
          const c = !!window.crypto, d = !!((o = window.RTCRtpSender) != null && o.prototype.createEncodedStreams) || !!((l = window.RTCRtpSender) != null && l.prototype.createdEncodedVideoStreams), u = !!window.Worker, h = () => c && d && u;
          var A = function(f) {
            f === void 0 && (f = {});
            const p = f.hasOpenTokSupport || t.default.once, v = f.isE2eeSupported || h;
            return p() && v();
          };
          r.default = A;
        },
        /* 113 */
        /***/
        function(i, r, e) {
          var n = e(43), t = e(15), o = n(t, "Map");
          i.exports = o;
        },
        /* 114 */
        /***/
        function(i, r, e) {
          var n = e(370), t = e(377), o = e(379), l = e(380), c = e(381);
          function d(u) {
            var h = -1, A = u == null ? 0 : u.length;
            for (this.clear(); ++h < A; ) {
              var g = u[h];
              this.set(g[0], g[1]);
            }
          }
          d.prototype.clear = n, d.prototype.delete = t, d.prototype.get = o, d.prototype.has = l, d.prototype.set = c, i.exports = d;
        },
        /* 115 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = -1, l = n == null ? 0 : n.length; ++o < l && t(n[o], o, n) !== !1; )
              ;
            return n;
          }
          i.exports = e;
        },
        /* 116 */
        /***/
        function(i, r) {
          var e = 9007199254740991;
          function n(t) {
            return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
          }
          i.exports = n;
        },
        /* 117 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(186), o = r && !r.nodeType && r, l = o && typeof n == "object" && n && !n.nodeType && n, c = l && l.exports === o, d = c && t.process, u = function() {
              try {
                var h = l && l.require && l.require("util").types;
                return h || d && d.binding && d.binding("util");
              } catch {
              }
            }();
            n.exports = u;
          }).call(this, e(86)(i));
        },
        /* 118 */
        /***/
        function(i, r, e) {
          var n = e(68), t = e(386), o = Object.prototype, l = o.hasOwnProperty;
          function c(d) {
            if (!n(d))
              return t(d);
            var u = [];
            for (var h in Object(d))
              l.call(d, h) && h != "constructor" && u.push(h);
            return u;
          }
          i.exports = c;
        },
        /* 119 */
        /***/
        function(i, r, e) {
          var n = e(391), t = e(193), o = Object.prototype, l = o.propertyIsEnumerable, c = Object.getOwnPropertySymbols, d = c ? function(u) {
            return u == null ? [] : (u = Object(u), n(c(u), function(h) {
              return l.call(u, h);
            }));
          } : t;
          i.exports = d;
        },
        /* 120 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = -1, l = t.length, c = n.length; ++o < l; )
              n[c + o] = t[o];
            return n;
          }
          i.exports = e;
        },
        /* 121 */
        /***/
        function(i, r, e) {
          var n = e(191), t = n(Object.getPrototypeOf, Object);
          i.exports = t;
        },
        /* 122 */
        /***/
        function(i, r, e) {
          var n = e(200);
          function t(o) {
            var l = new o.constructor(o.byteLength);
            return new n(l).set(new n(o)), l;
          }
          i.exports = t;
        },
        /* 123 */
        /***/
        function(i, r) {
          function e(n, t, o) {
            switch (o.length) {
              case 0:
                return n.call(t);
              case 1:
                return n.call(t, o[0]);
              case 2:
                return n.call(t, o[0], o[1]);
              case 3:
                return n.call(t, o[0], o[1], o[2]);
            }
            return n.apply(t, o);
          }
          i.exports = e;
        },
        /* 124 */
        /***/
        function(i, r, e) {
          var n = e(406), t = e(206), o = t(n);
          i.exports = o;
        },
        /* 125 */
        /***/
        function(i, r, e) {
          var n = e(53), t = e(26), o = e(66), l = e(11);
          function c(d, u, h) {
            if (!l(h))
              return !1;
            var A = typeof u;
            return (A == "number" ? t(h) && o(u, h.length) : A == "string" && u in h) ? n(h[u], d) : !1;
          }
          i.exports = c;
        },
        /* 126 */
        /***/
        function(i, r, e) {
          var n = e(114), t = "Expected a function";
          function o(l, c) {
            if (typeof l != "function" || c != null && typeof c != "function")
              throw new TypeError(t);
            var d = function() {
              var u = arguments, h = c ? c.apply(this, u) : u[0], A = d.cache;
              if (A.has(h))
                return A.get(h);
              var g = l.apply(this, u);
              return d.cache = A.set(h, g) || A, g;
            };
            return d.cache = new (o.Cache || n)(), d;
          }
          o.Cache = n, i.exports = o;
        },
        /* 127 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = {
            error: {
              priority: 1,
              method: "error"
            },
            warn: {
              priority: 2,
              method: "warn"
            },
            info: {
              priority: 3,
              method: "info"
            },
            log: {
              priority: 4,
              method: "log"
            },
            debug: {
              priority: 5,
              method: "debug"
            },
            spam: {
              priority: 6,
              method: "log"
            }
          };
          r.default = t;
        },
        /* 128 */
        /***/
        function(i, r, e) {
          i.exports = e(208)() ? Object.setPrototypeOf : e(209);
        },
        /* 129 */
        /***/
        function(i, r, e) {
          var n = e(56), t = {
            object: !0,
            function: !0,
            undefined: !0
            /* document.all */
          };
          i.exports = function(o) {
            return n(o) ? hasOwnProperty.call(t, typeof o) : !1;
          };
        },
        /* 130 */
        /***/
        function(i, r, e) {
          i.exports = e(420)() ? Object.assign : e(421);
        },
        /* 131 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(19), o = e(472), l = e(221), c = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            function d(g, f) {
              !t.isUndefined(g) && t.isUndefined(g["Content-Type"]) && (g["Content-Type"] = f);
            }
            function u() {
              var g;
              return (typeof XMLHttpRequest != "undefined" || typeof n != "undefined" && Object.prototype.toString.call(n) === "[object process]") && (g = e(222)), g;
            }
            function h(g, f, p) {
              if (t.isString(g))
                try {
                  return (f || JSON.parse)(g), t.trim(g);
                } catch (v) {
                  if (v.name !== "SyntaxError")
                    throw v;
                }
              return (0, JSON.stringify)(g);
            }
            var A = {
              transitional: {
                silentJSONParsing: !0,
                forcedJSONParsing: !0,
                clarifyTimeoutError: !1
              },
              adapter: u(),
              transformRequest: [function(f, p) {
                return o(p, "Accept"), o(p, "Content-Type"), t.isFormData(f) || t.isArrayBuffer(f) || t.isBuffer(f) || t.isStream(f) || t.isFile(f) || t.isBlob(f) ? f : t.isArrayBufferView(f) ? f.buffer : t.isURLSearchParams(f) ? (d(p, "application/x-www-form-urlencoded;charset=utf-8"), f.toString()) : t.isObject(f) || p && p["Content-Type"] === "application/json" ? (d(p, "application/json"), h(f)) : f;
              }],
              transformResponse: [function(f) {
                var p = this.transitional, v = p && p.silentJSONParsing, b = p && p.forcedJSONParsing, m = !v && this.responseType === "json";
                if (m || b && t.isString(f) && f.length)
                  try {
                    return JSON.parse(f);
                  } catch (y) {
                    if (m)
                      throw y.name === "SyntaxError" ? l(y, this, "E_JSON_PARSE") : y;
                  }
                return f;
              }],
              /**
               * A timeout in milliseconds to abort a request. If set to 0 (default) a
               * timeout is not created.
               */
              timeout: 0,
              xsrfCookieName: "XSRF-TOKEN",
              xsrfHeaderName: "X-XSRF-TOKEN",
              maxContentLength: -1,
              maxBodyLength: -1,
              validateStatus: function(f) {
                return f >= 200 && f < 300;
              }
            };
            A.headers = {
              common: {
                Accept: "application/json, text/plain, */*"
              }
            }, t.forEach(["delete", "get", "head"], function(f) {
              A.headers[f] = {};
            }), t.forEach(["post", "put", "patch"], function(f) {
              A.headers[f] = t.merge(c);
            }), i.exports = A;
          }).call(this, e(27));
        },
        /* 132 */
        /***/
        function(i, r) {
          i.exports = {};
        },
        /* 133 */
        /***/
        function(i, r, e) {
          var n = e(228), t = e(490), o = e(491), l = e(230), c = e(505), d = e(234), u = e(506), h = e(237), A = e(238), g = e(97), f = "Expected a function", p = 1, v = 2, b = 8, m = 16, y = 32, U = 64, B = Math.max;
          function Q(N, J, w, W, G, Z, K, L) {
            var O = J & v;
            if (!O && typeof N != "function")
              throw new TypeError(f);
            var de = W ? W.length : 0;
            if (de || (J &= ~(y | U), W = G = void 0), K = K === void 0 ? K : B(g(K), 0), L = L === void 0 ? L : g(L), de -= G ? G.length : 0, J & U) {
              var oe = W, fe = G;
              W = G = void 0;
            }
            var ge = O ? void 0 : d(N), we = [
              N,
              J,
              w,
              W,
              G,
              oe,
              fe,
              Z,
              K,
              L
            ];
            if (ge && u(we, ge), N = we[0], J = we[1], w = we[2], W = we[3], G = we[4], L = we[9] = we[9] === void 0 ? O ? 0 : N.length : B(we[9] - de, 0), !L && J & (b | m) && (J &= ~(b | m)), !J || J == p)
              var _e = t(N, J, w);
            else J == b || J == m ? _e = o(N, J, L) : (J == y || J == (p | y)) && !G.length ? _e = c(N, J, w, W) : _e = l.apply(void 0, we);
            var Te = ge ? n : h;
            return A(Te(_e, we), N, J);
          }
          i.exports = Q;
        },
        /* 134 */
        /***/
        function(i, r, e) {
          var n = e(88), t = e(135), o = 4294967295;
          function l(c) {
            this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = o, this.__views__ = [];
          }
          l.prototype = n(t.prototype), l.prototype.constructor = l, i.exports = l;
        },
        /* 135 */
        /***/
        function(i, r) {
          function e() {
          }
          i.exports = e;
        },
        /* 136 */
        /***/
        function(i, r) {
          var e = "__lodash_placeholder__";
          function n(t, o) {
            for (var l = -1, c = t.length, d = 0, u = []; ++l < c; ) {
              var h = t[l];
              (h === o || h === e) && (t[l] = e, u[d++] = l);
            }
            return u;
          }
          i.exports = n;
        },
        /* 137 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(121), o = e(18), l = "[object Object]", c = Function.prototype, d = Object.prototype, u = c.toString, h = d.hasOwnProperty, A = u.call(Object);
          function g(f) {
            if (!o(f) || n(f) != l)
              return !1;
            var p = t(f);
            if (p === null)
              return !0;
            var v = h.call(p, "constructor") && p.constructor;
            return typeof v == "function" && v instanceof v && u.call(v) == A;
          }
          i.exports = g;
        },
        /* 138 */
        /***/
        function(i, r, e) {
          var n = e(516), t = e(18);
          function o(l, c, d, u, h) {
            return l === c ? !0 : l == null || c == null || !t(l) && !t(c) ? l !== l && c !== c : n(l, c, d, u, o, h);
          }
          i.exports = o;
        },
        /* 139 */
        /***/
        function(i, r, e) {
          var n = e(12), t = e(70), o = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/;
          function c(d, u) {
            if (n(d))
              return !1;
            var h = typeof d;
            return h == "number" || h == "symbol" || h == "boolean" || d == null || t(d) ? !0 : l.test(d) || !o.test(d) || u != null && d in Object(u);
          }
          i.exports = c;
        },
        /* 140 */
        /***/
        function(i, r, e) {
          var n = e(531), t = e(205), o = e(124);
          function l(c) {
            return o(t(c, void 0, n), c + "");
          }
          i.exports = l;
        },
        /* 141 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = t;
          let n;
          function t(o) {
            o === void 0 && (o = {});
            const l = o.AudioContext || (typeof window !== void 0 ? window : Dn).AudioContext || (typeof window !== void 0 ? window : Dn).webkitAudioContext;
            return function() {
              if (n = n || l && new l(), n == null)
                throw new Error("AudioContext could not be created, hardware limit reached.");
              return n;
            };
          }
        },
        /* 142 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          let n = /* @__PURE__ */ function() {
            function t(l) {
              this._analyser = null, this._timeDomainData = null, this._sourceNode = null, this._audioContext = l;
            }
            var o = t.prototype;
            return o._initAudioAnalyser = function(c) {
              this._analyser = this._audioContext.createAnalyser(), this._sourceNode = this._audioContext.createMediaStreamSource(c), this._sourceNode.connect(this._analyser), this._timeDomainData = new Uint8Array(this._analyser.frequencyBinCount);
            }, o.webRTCStream = function(c) {
              this._sourceNode && this._sourceNode.disconnect(this._analyser), this._audioContext.state === "suspended" && this._audioContext.resume(), this._initAudioAnalyser(c);
            }, o.destroy = function() {
              this._sourceNode && this._sourceNode.disconnect(this._analyser), this._timeDomainData = null;
            }, o.sample = function(c) {
              if (typeof c == "function")
                throw new Error("sample no longer takes a callback");
              if (this._analyser && this._timeDomainData) {
                this._analyser.getByteTimeDomainData(this._timeDomainData);
                let d = 0;
                for (let u = this._timeDomainData.length - 1; u >= 0; u -= 1)
                  d = Math.max(d, Math.abs(this._timeDomainData[u] - 128));
                return d / 128;
              }
              return null;
            }, t;
          }();
          r.default = n;
        },
        /* 143 */
        /***/
        function(i, r, e) {
          var n = e(89), t = e(53), o = e(125), l = e(54), c = Object.prototype, d = c.hasOwnProperty, u = n(function(h, A) {
            h = Object(h);
            var g = -1, f = A.length, p = f > 2 ? A[2] : void 0;
            for (p && o(A[0], A[1], p) && (f = 1); ++g < f; )
              for (var v = A[g], b = l(v), m = -1, y = b.length; ++m < y; ) {
                var U = b[m], B = h[U];
                (B === void 0 || t(B, c[U]) && !d.call(h, U)) && (h[U] = v[U]);
              }
            return h;
          });
          i.exports = u;
        },
        /* 144 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(9)), o = n(e(145)), l = n(e(1));
          const c = (0, l.default)("Event");
          let d = /* @__PURE__ */ function() {
            function u(A, g, f) {
              g === void 0 && (g = !0), f === void 0 && (f = {}), this.type = A, this.cancelable = g, this._defaultPrevented = !1;
              const p = (0, o.default)(Object.keys(this), Object.keys(f));
              if (p.length > 0)
                throw new Error(`Cannot used reserved property names: ${p.join(",")}`);
              (0, t.default)(this, f);
            }
            var h = u.prototype;
            return h.preventDefault = function() {
              this.cancelable ? this._defaultPrevented = !0 : c.warn("Event.preventDefault :: Trying to preventDefault on an event that isn't cancelable");
            }, h.isDefaultPrevented = function() {
              return this._defaultPrevented;
            }, u;
          }();
          r.default = d;
        },
        /* 145 */
        /***/
        function(i, r, e) {
          var n = e(39), t = e(559), o = e(89), l = e(560), c = o(function(d) {
            var u = n(d, l);
            return u.length && u[0] === d[0] ? t(u) : [];
          });
          i.exports = c;
        },
        /* 146 */
        /***/
        function(i, r) {
          function e(n, t, o) {
            for (var l = -1, c = n == null ? 0 : n.length; ++l < c; )
              if (o(t, n[l]))
                return !0;
            return !1;
          }
          i.exports = e;
        },
        /* 147 */
        /***/
        function(i, r, e) {
          var n = e(26), t = e(18);
          function o(l) {
            return t(l) && n(l);
          }
          i.exports = o;
        },
        /* 148 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(29)), o = n(e(61)), l = n(e(58)), d = /* @__PURE__ */ function() {
            function u(h) {
              h === void 0 && (h = {}), Object.defineProperty(this, "_rawSessionInfo", {
                value: (0, o.default)(h)
              });
            }
            return (0, t.default)(u, [{
              key: "sessionId",
              get: function() {
                return this._rawSessionInfo.session_id;
              }
              /**
               * @type {String}
               * @readonly
               */
            }, {
              key: "partnerId",
              get: function() {
                return this._rawSessionInfo.partner_id;
              }
              /**
               * @type {String}
               * @readonly
               */
            }, {
              key: "messagingServer",
              get: function() {
                return this._rawSessionInfo.messaging_server_url;
              }
              /**
               * @type {String}
               * @readonly
               */
            }, {
              key: "mediaServerName",
              get: function() {
                return this._rawSessionInfo.media_server_hostname;
              }
              /**
               * @type {String}
               * @readonly
               */
            }, {
              key: "messagingURL",
              get: function() {
                return this._rawSessionInfo.messaging_url;
              }
              /**
               * @type {String}
               * @readonly
               */
            }, {
              key: "symphonyAddress",
              get: function() {
                return this._rawSessionInfo.symphony_address;
              }
              /**
               * @type {Array}
               * @readonly
               */
            }, {
              key: "iceServers",
              get: function() {
                return this._rawSessionInfo.ice_servers;
              }
              /**
               * Simulcast is tri-state:
               * * true - simulcast is on for this session
               * * false - simulcast is off for this session
               * * undefined - the developer can choose
               * @type {Boolean|Undefined}
               * @readonly
               */
            }, {
              key: "simulcast",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.simulcast");
              }
              /**
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "e2ee",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.e2ee", !1);
              }
              /**
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "reconnection",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.reconnection", !1);
              }
              /**
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "renegotiation",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.renegotiation", !1);
              }
              /**
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "p2pEnabled",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.p2p.preference.value") === "enabled";
              }
              /**
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "hybridSession",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.hybridSession", !1);
              }
              /**
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "isAdaptiveEnabled",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.p2p.preference.value") === "adaptive";
              }
              /**
               * If this contains a valid codec, it will be prioritized
               *
               * @type {String}
               * @readonly
               */
            }, {
              key: "priorityVideoCodec",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.priorityVideoCodec", "");
              }
              /**
               * Is true if H264 codec is enabled
               *
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "h264",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.h264", !0);
              }
              /**
               * Is true if VP8 codec is enabled
               *
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "vp8",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.vp8", !0);
              }
              /**
               * Is true if VP9 codec is enabled
               *
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "vp9",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.vp9", !0);
              }
              /**
               * Is true if SinglePeerConnection is enabled
               *
               * @type {Boolean}
               * @readonly
               */
            }, {
              key: "singlePeerConnection",
              get: function() {
                return (0, l.default)(this._rawSessionInfo, "properties.singlePeerConnection", !1);
              }
              /**
               * clientCandidates can be "relay". Other values are unknown.
               *
               * @type {String|Undefined}
               * @readonly
               */
            }, {
              key: "clientCandidates",
              get: function() {
                const A = (0, l.default)(this._rawSessionInfo, "properties.clientCandidates");
                return A === "relayed" ? "relay" : A;
              }
            }]), u;
          }();
          r.default = d;
        },
        /* 149 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = () => document.createElement("video");
          r.default = n;
        },
        /* 150 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n() {
            return {
              ROTATED_NORMAL: 0,
              ROTATED_LEFT: 270,
              ROTATED_RIGHT: 90,
              ROTATED_UPSIDE_DOWN: 180
            };
          }
        },
        /* 151 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = b;
          var t = n(e(575)), o = n(e(1)), l = n(e(586)), c = n(e(3));
          const d = (0, o.default)("createWindowMock"), u = [{
            key: "location",
            type: "object"
          }, {
            key: "setTimeout",
            type: "function"
          }, {
            key: "requestAnimationFrame",
            type: "function"
          }, {
            key: "URL",
            type: "function"
          }, {
            key: "MediaStream",
            type: "class"
          }, {
            key: "webkitMediaStream",
            type: "class"
          }, {
            key: "RTCIceCandidate",
            type: "class"
          }, {
            key: "mozRTCIceCandidate",
            type: "class"
          }, {
            key: "RTCSessionDescription",
            type: "class"
          }, {
            key: "mozRTCSessionDescription",
            type: "class"
          }, {
            key: "RTCIceGatherer",
            type: "class"
          }, {
            key: "RTCIceTransport",
            type: "class"
          }, {
            key: "RTCDtlsTransport",
            type: "class"
          }, {
            key: "RTCSctpTransport",
            type: "class"
          }, {
            key: "RTCRtpReceiver",
            type: "class"
          }, {
            key: "HTMLMediaElement",
            type: "class"
          }, {
            key: "RTCPeerConnection",
            type: "class"
          }, {
            key: "webkitRTCPeerConnection",
            type: "class"
          }, {
            key: "mozRTCPeerConnection",
            type: "class"
          }, {
            key: "MediaStreamTrack",
            type: "class"
          }, {
            key: "RTCRtpSender",
            type: "class"
          }, {
            key: "RTCTrackEvent",
            type: "class"
          }, {
            key: "RTCTransceiver",
            type: "class"
          }, {
            key: "RTCDtmfSender",
            type: "class"
          }, {
            key: "RTCDTMFSender",
            type: "class"
          }, {
            key: "MediaStreamTrackEvent",
            type: "class"
          }], h = [{
            key: "userAgent",
            type: "string"
          }, {
            key: "getUserMedia",
            type: "function"
          }, {
            key: "getDisplayMedia",
            type: "function"
          }, {
            key: "webkitGetUserMedia",
            type: "function"
          }, {
            key: "mozGetUserMedia",
            type: "function"
          }], A = [{
            key: "getUserMedia",
            type: "function"
          }, {
            key: "getDisplayMedia",
            type: "function"
          }, {
            key: "enumerateDevices",
            type: "function"
          }, {
            key: "getSupportedConstraints",
            type: "function"
          }, {
            key: "addEventListener",
            type: "function"
          }, {
            key: "removeEventListener",
            type: "function"
          }], g = (m, y) => {
            if (typeof y != "function")
              return d.warn("Non-function passed into bindWithStaticProperties()"), y;
            const U = y.bind(m);
            return Object.keys(y).forEach((B) => {
              U[B] = y[B];
            }), U;
          }, f = (m) => typeof m != "function" ? (d.warn("Non-function passed into extendClass()"), m) : (0, l.default)(m), p = () => (m, y, U) => {
            U.forEach((B) => {
              let Q = B.key, N = B.type, J = y[Q];
              if (J !== void 0) {
                switch (N) {
                  case "function":
                    J = g(y, J);
                    break;
                  case "class":
                    J = f(J);
                    break;
                  case "string":
                  case "object":
                    break;
                  default:
                    throw new Error(`Invalid type of window key: ${N}`);
                }
                m[Q] = J;
              }
            });
          }, v = (m) => {
            const y = {}, U = p();
            return U(y, m, u), m.navigator !== void 0 && (y.navigator = {}, U(y.navigator, m.navigator, h), m.navigator.mediaDevices !== void 0 && (y.navigator.mediaDevices = {}, U(y.navigator.mediaDevices, m.navigator.mediaDevices, A))), y;
          };
          function b(m) {
            if (m.adapter !== void 0 || c.default.isLegacyEdge)
              return m;
            const y = v(m);
            return (0, t.default)({
              window: y
            }), y;
          }
        },
        /* 152 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n() {
            let t = null;
            this.transform = (o) => {
              t === null || o >= t ? t = o : t = o * 0.3 + t * 0.7;
              const l = Math.log(t) / Math.LN10 / 1.5 + 1;
              return Math.min(Math.max(l, 0), 1);
            };
          }
        },
        /* 153 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(9)), o = n(e(6));
          const l = (d) => Object.keys(d).map((u) => d[u]);
          function c(d) {
            const u = {}, h = (A, g) => {
              (0, t.default)(g, {
                parent: this
              }), g.appendTo(d.parent), u[A] = g, this[A] = g;
            };
            d.parent && ((0, o.default)(this), this.destroy = () => {
              this.off(), this.hideWhileLoading(), l(u).forEach((A) => A.destroy());
            }, this.showAfterLoading = () => {
              l(u).forEach((A) => A.showAfterLoading());
            }, this.hideWhileLoading = () => {
              l(u).forEach((A) => A.hideWhileLoading());
            }, this.set = (A, g) => (typeof A == "string" && g ? h(A, g) : Object.keys(A).forEach((f) => {
              h(f, A[f]);
            }), this));
          }
        },
        /* 154 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(6)), o = n(e(31)), l = n(e(587)), c = n(e(23));
          const d = (0, c.default)();
          function u() {
            const A = this;
            (0, t.default)(A);
            function g() {
              return l.default.isDomLoaded() && !l.default.isDomUnloaded();
            }
            function f() {
              g() && A.dispatchEvent(new d.EnvLoadedEvent(o.default.ENV_LOADED));
            }
            function p() {
              l.default.whenUnloaded.then(v), f();
            }
            function v() {
              A.dispatchEvent(new d.EnvLoadedEvent(o.default.ENV_UNLOADED));
            }
            l.default.whenLoaded.then(p), this.onLoad = function(b, m) {
              if (g()) {
                b.call(m);
                return;
              }
              A.on(o.default.ENV_LOADED, b, m);
            }, this.onUnload = function(b, m) {
              if (this.isUnloaded()) {
                b.call(m);
                return;
              }
              A.on(o.default.ENV_UNLOADED, b, m);
            }, this.isUnloaded = function() {
              return l.default.isDomUnloaded();
            };
          }
          var h = new u();
          r.default = h;
        },
        /* 155 */
        /***/
        function(i, r, e) {
          var n = e(592);
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */
          function t(L, O) {
            if (L === O)
              return 0;
            for (var de = L.length, oe = O.length, fe = 0, ge = Math.min(de, oe); fe < ge; ++fe)
              if (L[fe] !== O[fe]) {
                de = L[fe], oe = O[fe];
                break;
              }
            return de < oe ? -1 : oe < de ? 1 : 0;
          }
          function o(L) {
            return (typeof window !== void 0 ? window : Dn).Buffer && typeof (typeof window !== void 0 ? window : Dn).Buffer.isBuffer == "function" ? (typeof window !== void 0 ? window : Dn).Buffer.isBuffer(L) : !!(L != null && L._isBuffer);
          }
          var l = e(593), c = Object.prototype.hasOwnProperty, d = Array.prototype.slice, u = function() {
            return function() {
            }.name === "foo";
          }();
          function h(L) {
            return Object.prototype.toString.call(L);
          }
          function A(L) {
            return o(L) || typeof (typeof window !== void 0 ? window : Dn).ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(L) : L ? !!(L instanceof DataView || L.buffer && L.buffer instanceof ArrayBuffer) : !1;
          }
          var g = i.exports = U, f = /\s*function\s+([^\(\s]*)\s*/;
          function p(L) {
            if (l.isFunction(L)) {
              if (u)
                return L.name;
              var O = L.toString(), de = O.match(f);
              return de && de[1];
            }
          }
          g.AssertionError = function(O) {
            this.name = "AssertionError", this.actual = O.actual, this.expected = O.expected, this.operator = O.operator, O.message ? (this.message = O.message, this.generatedMessage = !1) : (this.message = m(this), this.generatedMessage = !0);
            var de = O.stackStartFunction || y;
            if (Error.captureStackTrace)
              Error.captureStackTrace(this, de);
            else {
              var oe = new Error();
              if (oe.stack) {
                var fe = oe.stack, ge = p(de), we = fe.indexOf(`
` + ge);
                if (we >= 0) {
                  var _e = fe.indexOf(`
`, we + 1);
                  fe = fe.substring(_e + 1);
                }
                this.stack = fe;
              }
            }
          }, l.inherits(g.AssertionError, Error);
          function v(L, O) {
            return typeof L == "string" ? L.length < O ? L : L.slice(0, O) : L;
          }
          function b(L) {
            if (u || !l.isFunction(L))
              return l.inspect(L);
            var O = p(L), de = O ? ": " + O : "";
            return "[Function" + de + "]";
          }
          function m(L) {
            return v(b(L.actual), 128) + " " + L.operator + " " + v(b(L.expected), 128);
          }
          function y(L, O, de, oe, fe) {
            throw new g.AssertionError({
              message: de,
              actual: L,
              expected: O,
              operator: oe,
              stackStartFunction: fe
            });
          }
          g.fail = y;
          function U(L, O) {
            L || y(L, !0, O, "==", g.ok);
          }
          g.ok = U, g.equal = function(O, de, oe) {
            O != de && y(O, de, oe, "==", g.equal);
          }, g.notEqual = function(O, de, oe) {
            O == de && y(O, de, oe, "!=", g.notEqual);
          }, g.deepEqual = function(O, de, oe) {
            B(O, de, !1) || y(O, de, oe, "deepEqual", g.deepEqual);
          }, g.deepStrictEqual = function(O, de, oe) {
            B(O, de, !0) || y(O, de, oe, "deepStrictEqual", g.deepStrictEqual);
          };
          function B(L, O, de, oe) {
            if (L === O)
              return !0;
            if (o(L) && o(O))
              return t(L, O) === 0;
            if (l.isDate(L) && l.isDate(O))
              return L.getTime() === O.getTime();
            if (l.isRegExp(L) && l.isRegExp(O))
              return L.source === O.source && L.global === O.global && L.multiline === O.multiline && L.lastIndex === O.lastIndex && L.ignoreCase === O.ignoreCase;
            if ((L === null || typeof L != "object") && (O === null || typeof O != "object"))
              return de ? L === O : L == O;
            if (A(L) && A(O) && h(L) === h(O) && !(L instanceof Float32Array || L instanceof Float64Array))
              return t(
                new Uint8Array(L.buffer),
                new Uint8Array(O.buffer)
              ) === 0;
            if (o(L) !== o(O))
              return !1;
            oe = oe || { actual: [], expected: [] };
            var fe = oe.actual.indexOf(L);
            return fe !== -1 && fe === oe.expected.indexOf(O) ? !0 : (oe.actual.push(L), oe.expected.push(O), N(L, O, de, oe));
          }
          function Q(L) {
            return Object.prototype.toString.call(L) == "[object Arguments]";
          }
          function N(L, O, de, oe) {
            if (L == null || O === null || O === void 0)
              return !1;
            if (l.isPrimitive(L) || l.isPrimitive(O))
              return L === O;
            if (de && Object.getPrototypeOf(L) !== Object.getPrototypeOf(O))
              return !1;
            var fe = Q(L), ge = Q(O);
            if (fe && !ge || !fe && ge)
              return !1;
            if (fe)
              return L = d.call(L), O = d.call(O), B(L, O, de);
            var we = K(L), _e = K(O), Te, Pe;
            if (we.length !== _e.length)
              return !1;
            for (we.sort(), _e.sort(), Pe = we.length - 1; Pe >= 0; Pe--)
              if (we[Pe] !== _e[Pe])
                return !1;
            for (Pe = we.length - 1; Pe >= 0; Pe--)
              if (Te = we[Pe], !B(L[Te], O[Te], de, oe))
                return !1;
            return !0;
          }
          g.notDeepEqual = function(O, de, oe) {
            B(O, de, !1) && y(O, de, oe, "notDeepEqual", g.notDeepEqual);
          }, g.notDeepStrictEqual = J;
          function J(L, O, de) {
            B(L, O, !0) && y(L, O, de, "notDeepStrictEqual", J);
          }
          g.strictEqual = function(O, de, oe) {
            O !== de && y(O, de, oe, "===", g.strictEqual);
          }, g.notStrictEqual = function(O, de, oe) {
            O === de && y(O, de, oe, "!==", g.notStrictEqual);
          };
          function w(L, O) {
            if (!L || !O)
              return !1;
            if (Object.prototype.toString.call(O) == "[object RegExp]")
              return O.test(L);
            try {
              if (L instanceof O)
                return !0;
            } catch {
            }
            return Error.isPrototypeOf(O) ? !1 : O.call({}, L) === !0;
          }
          function W(L) {
            var O;
            try {
              L();
            } catch (de) {
              O = de;
            }
            return O;
          }
          function G(L, O, de, oe) {
            var fe;
            if (typeof O != "function")
              throw new TypeError('"block" argument must be a function');
            typeof de == "string" && (oe = de, de = null), fe = W(O), oe = (de && de.name ? " (" + de.name + ")." : ".") + (oe ? " " + oe : "."), L && !fe && y(fe, de, "Missing expected exception" + oe);
            var ge = typeof oe == "string", we = !L && l.isError(fe), _e = !L && fe && !de;
            if ((we && ge && w(fe, de) || _e) && y(fe, de, "Got unwanted exception" + oe), L && fe && de && !w(fe, de) || !L && fe)
              throw fe;
          }
          g.throws = function(L, O, de) {
            G(!0, L, O, de);
          }, g.doesNotThrow = function(L, O, de) {
            G(!1, L, O, de);
          }, g.ifError = function(L) {
            if (L) throw L;
          };
          function Z(L, O) {
            L || y(L, !0, O, "==", Z);
          }
          g.strict = n(Z, g, {
            equal: g.strictEqual,
            deepEqual: g.deepStrictEqual,
            notEqual: g.notStrictEqual,
            notDeepEqual: g.notDeepStrictEqual
          }), g.strict.strict = g.strict;
          var K = Object.keys || function(L) {
            var O = [];
            for (var de in L)
              c.call(L, de) && O.push(de);
            return O;
          };
        },
        /* 156 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(600)), l = n(e(282)), c = (d) => t.default.isElectron ? d === "screen" ? !0 : (0, l.default)(d) : o.default.indexOf(d) > -1;
          r.default = c;
        },
        /* 157 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = h;
          var t = n(e(6)), o = n(e(1)), l = n(e(285)), c = n(e(150));
          const d = (0, c.default)(), u = (0, o.default)("StreamChannel");
          function h(A) {
            this.id = A.id, this.type = A.type, this.active = (0, l.default)(A.active), this.orientation = A.orientation || d.ROTATED_NORMAL, A.frameRate && (this.frameRate = parseFloat(A.frameRate)), A.preferredFrameRate && (this.preferredFrameRate = parseFloat(A.preferredFrameRate)), A.preferredWidth && (this.preferredWidth = parseInt(A.preferredWidth, 10)), A.preferredHeight && (this.preferredHeight = parseInt(A.preferredHeight, 10)), this.width = parseInt(A.width, 10), this.height = parseInt(A.height, 10), this.source = A.source || "camera", this.fitMode = A.fitMode || "cover", (0, t.default)(this), this.update = function(g) {
              const f = {}, p = {};
              for (const v in g) {
                if (!g.hasOwnProperty(v))
                  continue;
                const b = this[v];
                switch (v) {
                  case "active":
                    this.active = (0, l.default)(g[v]);
                    break;
                  case "disableWarning":
                    this.disableWarning = (0, l.default)(g[v]);
                    break;
                  case "frameRate":
                    this.frameRate = parseFloat(g[v], 10);
                    break;
                  case "width":
                  case "height":
                    this[v] = parseInt(g[v], 10), f[v] = this[v], p[v] = b;
                    break;
                  case "orientation":
                    this[v] = g[v], f[v] = this[v], p[v] = b;
                    break;
                  case "fitMode":
                    this[v] = g[v];
                    break;
                  case "source":
                    this[v] = g[v];
                    break;
                  case "sourceStreamId":
                    break;
                  default:
                    return u.debug(`Tried to update unknown key ${v} on ${this.type} channel ${this.id}`), !1;
                }
                this.trigger("update", this, v, b, this[v]);
              }
              return Object.keys(f).length && this.trigger("update", this, "videoDimensions", p, f), !0;
            };
          }
        },
        /* 158 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = u;
          var t = n(e(1)), o = n(e(608)), l = n(e(609)), c = n(e(286));
          const d = (0, t.default)("StylableComponent");
          function u(h, A, g, f) {
            if (!h.trigger)
              throw new Error("OT.StylableComponent is dependent on the eventing mixin. Ensure that this is included in the object before StylableComponent.");
            f = f || function() {
            };
            let p = !1;
            const v = function(y, U, B) {
              B ? h.trigger("styleValueChanged", y, U, B) : h.trigger("styleValueChanged", y, U);
            };
            g === !1 && (A = {
              buttonDisplayMode: "off",
              nameDisplayMode: "off",
              audioLevelDisplayMode: "off",
              videoDisabledDisplayMode: "off",
              audioBlockedDisplayMode: "off"
            }, p = !0, f({
              showControls: !1
            }));
            const b = new l.default(A, v);
            h.getStyle = function(m) {
              return b.get(m);
            }, h.setStyle = function(m, y, U) {
              if (p)
                return d.warn("Calling setStyle() has no effect because theshowControls option was set to false"), this;
              let B;
              return typeof m != "string" ? B = m : (B = {}, B[m] = y), B.backgroundImageURI && (B.backgroundImageURI = (0, o.default)(B.backgroundImageURI)), b.setAll(B, U), f((0, c.default)(B)), this;
            };
          }
        },
        /* 159 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(51)), o = n(e(1)), l = n(e(28)), c = n(e(52)), d = n(e(612)), u = n(e(613)), h = n(e(37)), A = n(e(72)), g = n(e(154)), f = n(e(7)), p = n(e(614)), v = n(e(615));
          const b = (0, h.default)(), m = (0, o.default)("systemRequirements"), y = b.onlyLocal(), U = c.default.once, B = new l.default(), Q = (0, t.default)(() => {
            B.logEvent({
              action: "checkSystemRequirements",
              variation: "notHasRequirements",
              partnerId: A.default.value,
              payload: {
                userAgent: f.default.env.userAgent
              }
            });
          }), N = (0, t.default)(() => {
            (0, p.default)();
          });
          let J = !1;
          var w = {
            /**
             * Checks if the system supports OpenTok for WebRTC. Note that this method is called
             * automatically when you call <code>OT.initPublisher()</code> or <code>OT.initSession()</code>,
             * and if the system doesn't support OpenTok, the OpenTok.js library displays a message to
             * the user. Call the <code>OT.checkSystemRequirements()</code> method before calling
             * <code>OT.initPublisher()</code> or <code>OT.initSession()</code> if you do not want the
             * library to display that message.
             *
             * @return {Number} Whether the system supports OpenTok for WebRTC (1) or not (0).
             * @see <a href="#upgradeSystemRequirements">OT.upgradeSystemRequirements()</a>
             * @method OT.checkSystemRequirements
             * @memberof OT
             */
            check() {
              m.debug("OT.checkSystemRequirements()");
              const W = Number(d.default && U());
              return N(), W || Q(), W;
            },
            /**
             * Displays information about system requirements for OpenTok for WebRTC. This
             * information is displayed in an iframe element that fills the browser window.
             * <p>
             * <i>Note:</i> this information is displayed automatically when you call the
             * <code>OT.initSession()</code> or the <code>OT.initPublisher()</code> method
             * if the client does not support OpenTok for WebRTC.
             * </p>
             * @see <a href="#checkSystemRequirements">OT.checkSystemRequirements()</a>
             * @method OT.upgradeSystemRequirements
             * @memberof OT
             */
            upgrade(W) {
              let G = W === void 0 ? {} : W, Z = G.isSupportedButOld, K = Z === void 0 ? f.default.env.name.toLowerCase() in y.minimumVersion : Z, L = G.userAgent, O = L === void 0 ? navigator.userAgent : L;
              g.default.onLoad(() => {
                if (J)
                  return;
                const de = new u.default(v.default);
                J = !0, de.on("close", () => {
                  J = !1;
                }), de.open();
                let oe;
                O.match(/(iPad|iPhone|iPod|android|webOS)/i) ? oe = `${K ? "supported-" : ""}mobile-browser` : oe = `${K ? "upgrade" : "normal"}-install`, de.el(`#section-${oe}`).style.display = "block";
              });
            }
          };
          r.default = w;
        },
        /* 160 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0), o = t(e(30)), l = t(e(161));
            const c = e(619);
            let d = /* @__PURE__ */ function(u) {
              (0, o.default)(h, u);
              function h(A) {
                var g;
                return g = u.call(this, A) || this, g.name = "TimeoutError", g;
              }
              return h;
            }(/* @__PURE__ */ (0, l.default)(Error));
            i.exports = (u, h, A) => new n((g, f) => {
              if (typeof h != "number" || h < 0)
                throw new TypeError("Expected `ms` to be a positive number");
              const p = setTimeout(() => {
                if (typeof A == "function") {
                  try {
                    g(A());
                  } catch (m) {
                    f(m);
                  }
                  return;
                }
                const v = typeof A == "string" ? A : `Promise timed out after ${h} milliseconds`, b = A instanceof Error ? A : new d(v);
                typeof u.cancel == "function" && u.cancel(), f(b);
              }, h);
              c(u.then(g, f), () => {
                clearTimeout(p);
              });
            }), i.exports.TimeoutError = d;
          }).call(this, e(2));
        },
        /* 161 */
        /***/
        function(i, r, e) {
          var n = e(616), t = e(288), o = e(617), l = e(618);
          function c(d) {
            var u = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
            return i.exports = c = function(A) {
              if (A === null || !o(A)) return A;
              if (typeof A != "function")
                throw new TypeError("Super expression must either be null or a function");
              if (typeof u != "undefined") {
                if (u.has(A)) return u.get(A);
                u.set(A, g);
              }
              function g() {
                return l(A, arguments, n(this).constructor);
              }
              return g.prototype = Object.create(A.prototype, {
                constructor: {
                  value: g,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t(g, A);
            }, c(d);
          }
          i.exports = c;
        },
        /* 162 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          function n() {
            const o = [];
            return {
              add(l) {
                o.push(l);
              },
              remove(l) {
                const c = o.indexOf(l);
                c >= 0 && o.splice(c, 1);
              },
              releaseAll() {
                const l = [];
                for (; o.length > 0; ) {
                  const d = o.pop();
                  try {
                    d();
                  } catch (u) {
                    l.push(u);
                  }
                }
                const c = l.length;
                if (c > 0)
                  throw new Error(`Failed to complete ${c} cleanup job${c === 1 ? "" : "s"}: ${l.map((d) => `<${d}>`).join(", ")}`);
              }
            };
          }
          var t = n;
          r.default = t;
        },
        /* 163 */
        /***/
        function(i, r, e) {
          var n = e(626);
          function t(o) {
            return o && o.length ? n(o) : [];
          }
          i.exports = t;
        },
        /* 164 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(1));
          const o = (0, t.default)("applySdpTransform");
          var l = (c, d, u, h, A) => {
            const g = c[d][u], f = `${d} ${u}`, v = `sdpTransforms (${f === "local offer" || f === "remote answer" ? "publisher" : "subscriber"}): ${d} ${u}`, b = d === "local" ? "created" : "received";
            o.debug(`${v}: ${b}:
${A}`);
            const m = g(h, A);
            return m.local === A ? o.debug(`${v}: not modified`) : o.debug(`${v}: modified to:
${m.local}`), m;
          };
          r.default = l;
        },
        /* 165 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = function(l) {
            if (l === void 0 && (l = {}), !l)
              return 0;
            const c = l, d = c.currentStatFrames, u = d === void 0 ? 0 : d, h = c.prevStatFrames, A = h === void 0 ? 0 : h, g = c.currentTimestamp, f = g === void 0 ? 0 : g, p = c.prevTimestamp, v = p === void 0 ? 0 : p;
            if (u >= A && f > v) {
              const b = (u - A) / ((f - v) / 1e3);
              return Math.round(b * 100) / 100;
            }
            return 0;
          };
          r.default = t;
        },
        /* 166 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(58)), l = typeof (0, t.default)(typeof window !== void 0 ? window : Dn, "navigator.getDisplayMedia", (0, t.default)(typeof window !== void 0 ? window : Dn, "navigator.mediaDevices.getDisplayMedia")) == "function";
          r.default = l;
        },
        /* 167 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(42));
          function o() {
            return function(c, d, u) {
              const h = d.slice(), A = (0, t.default)(u), g = function(v) {
                return h.indexOf(v) !== -1;
              }, f = function(v, b) {
                return A[v] && A[v].indexOf(b) !== -1;
              };
              return function(p) {
                let v = c, b = null;
                this.current = v;
                function m(U, B) {
                  p({
                    message: U,
                    newState: B,
                    currentState: v,
                    previousState: b
                  });
                }
                function y(U) {
                  return g(U) ? f(v, U) ? !0 : (m(`'${v}' cannot transition to '${U}'`, U), !1) : (m(`'${U}' is not a valid state`, U), !1);
                }
                this.set = function(U) {
                  y(U) && (b = v, this.current = U, v = U);
                };
              };
            };
          }
        },
        /* 168 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = f;
            var o = t(e(62)), l = t(e(13)), c = t(e(8)), d = t(e(300)), u = t(e(656)), h = t(e(658)), A = t(e(307)), g = t(e(7));
            function f(p) {
              p === void 0 && (p = {});
              const v = p.chromeExtensionHelper || (0, d.default)(), b = p.electronExtensionHelper || (0, u.default)(), m = p.Errors || c.default, y = p.firefoxExtensionHelper || h.default, U = p.getDisplayMediaExtensionHelper || A.default, B = p.otError || (0, l.default)(), Q = p.OTHelpers || g.default, N = {};
              N.extensionByKind = {}, N.extensionClasses = {}, N.registerExtensionHelper = (W, G) => {
                N.extensionClasses[W] = G, G.autoRegisters && G.isSupportedInThisBrowser && N.registerExtension(W);
              }, N.registerExtension = function(W) {
                if (N.extensionClasses[W] == null)
                  throw new Error("Unsupported kind passed to OT.registerScreenSharingExtension");
                for (var G = arguments.length, Z = new Array(G > 1 ? G - 1 : 0), K = 1; K < G; K++)
                  Z[K - 1] = arguments[K];
                const L = N.extensionClasses[W].register(...Z);
                N.extensionByKind[W] = L;
              };
              const J = () => {
                const W = (0, o.default)(Object.keys(N.extensionClasses).sort(
                  // Try "electron" first.  Reason being, even though `getDisplayMedia`
                  // is exposed in electron, developers must use the electron's
                  // `desktopCapturer` instead.
                  (G) => G === "electron" ? -1 : 1
                ), (G) => N.extensionClasses[G].isSupportedInThisBrowser);
                return W === void 0 ? {} : {
                  name: W,
                  proto: N.extensionClasses[W],
                  instance: N.extensionByKind[W]
                };
              };
              N.pickHelper = () => J(), N.checkCapability = (W) => {
                const G = {
                  supported: !1,
                  extensionRequired: void 0,
                  extensionRegistered: void 0,
                  extensionInstalled: void 0,
                  supportedSources: {}
                }, Z = J();
                if (Z.name === void 0) {
                  setTimeout(W.bind(null, G));
                  return;
                }
                if (G.supported = !0, G.extensionRequired = Z.proto.extensionRequired ? Z.name : void 0, G.supportedSources = {
                  screen: Z.proto.sources.screen,
                  application: Z.proto.sources.application,
                  window: Z.proto.sources.window,
                  browser: Z.proto.sources.browser
                }, !Z.instance) {
                  G.extensionRegistered = !1, G.extensionRequired && (G.extensionInstalled = !1), setTimeout(W.bind(null, G));
                  return;
                }
                G.extensionRegistered = G.extensionRequired ? !0 : void 0, Z.instance.isInstalled((K) => {
                  G.extensionInstalled = G.extensionRequired || Q.env.name === "Firefox" ? K : void 0, W(G);
                });
              }, N.registerExtensionHelper("electron", b), N.registerExtensionHelper("getDisplayMedia", U), N.registerExtensionHelper("chrome", v), N.registerExtensionHelper("firefox", y);
              const w = () => {
              };
              return N.getConstraints = (W) => {
                const G = W.onAccessDialogOpened, Z = G === void 0 ? w : G, K = W.onAccessDialogClosed, L = K === void 0 ? w : K, O = W.videoSource, de = W.constraints;
                return new n((oe, fe) => {
                  N.checkCapability((ge) => {
                    if (ge.supported)
                      if (ge.extensionRegistered === !1)
                        fe(B(m.SCREEN_SHARING_EXTENSION_NOT_REGISTERED, new Error("Screen Sharing support in this browser requires an extension, but one has not been registered.")));
                      else if (ge.extensionRequired && ge.extensionInstalled === !1)
                        fe(B(m.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error("Screen Sharing support in this browser requires an extension, but the extension is not installed.")));
                      else {
                        const we = N.pickHelper();
                        we.proto.getConstraintsShowsPermissionUI && Z(), we.instance.getConstraints(O, de, (_e, Te) => {
                          we.proto.getConstraintsShowsPermissionUI && L(), _e ? fe(_e) : oe(Te);
                        });
                      }
                    else {
                      let we = "Screen Sharing is not supported in this browser";
                      Q.env.isElectron ? we = "Set the webPreferences.contextIsolation option of the Electron BrowserWindow to false or use a preload script to access the desktop capturer. For more information, see https://tokbox.com/developer/guides/screen-sharing/js/." : Q.env.name === "Chrome" && Q.env.version > 73 && (typeof window !== void 0 ? window : Dn).location.protocol !== "https:" && (we = "https:// is required for screen sharing"), fe(B(m.SCREEN_SHARING_NOT_SUPPORTED, new Error(we)));
                    }
                  });
                });
              }, N;
            }
          }).call(this, e(2));
        },
        /* 169 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(10)), o = n(e(13)), l = n(e(8));
          function c(d) {
            d === void 0 && (d = {});
            const u = d.Errors || l.default, h = d.ExceptionCodes || t.default, A = d.otError || (0, o.default)(), g = {
              ICEWorkflow: u.ICE_WORKFLOW_FAILED,
              NewPeerConnection: u.CREATE_PEER_CONNECTION_FAILED,
              SetRemoteDescription: u.SET_REMOTE_DESCRIPTION_FAILED,
              Subscribe: {
                404: u.STREAM_NOT_FOUND,
                [h.STREAM_LIMIT_EXCEEDED]: u.STREAM_LIMIT_EXCEEDED
              }
            };
            return function(p, v, b, m, y) {
              const U = `${(b ? `${b}: ` : "") + y} PeerConnection with connection ${m} failed: ${v}`, B = g[b] || {}, Q = typeof B == "string" ? B : B[p], N = y === "Publisher" ? h.UNABLE_TO_PUBLISH : h.UNABLE_TO_SUBSCRIBE;
              if (!Q) {
                const w = new Error(U);
                return w.code = N, w;
              }
              const J = b === "ICEWorkflow" ? y === "Publisher" ? h.PUBLISHER_ICE_WORKFLOW_FAILED : h.SUBSCRIBER_ICE_WORKFLOW_FAILED : Q === u.STREAM_LIMIT_EXCEEDED ? h.STREAM_LIMIT_EXCEEDED : N;
              return A(Q, new Error(U), J);
            };
          }
        },
        /* 170 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(7));
          function o(l) {
            l === void 0 && (l = {});
            const c = l.OTHelpers || t.default, u = (l.global || (typeof window !== void 0 ? window : Dn)).RTCPeerConnection;
            return function(A, g) {
              c.env.name === "Firefox" && u && u.generateCertificate ? u.generateCertificate({
                name: "RSASSA-PKCS1-v1_5",
                hash: "SHA-256",
                modulusLength: 2048,
                publicExponent: new Uint8Array([1, 0, 1])
              }).catch((f) => {
                g(f);
              }).then((f) => {
                A.certificates = [f], g(void 0, A);
              }) : setTimeout(() => {
                g(void 0, A);
              });
            };
          }
        },
        /* 171 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = {
            bandwidthCriticalThreshold: 7e4,
            bandwidthFairThreshold: 0,
            packetLossCriticalThreshold: 0.15,
            packetLossCriticalThresholdMediumBw: 0.2,
            criticalCongestionPeriod: 16e3
          };
          r.default = t;
        },
        /* 172 */
        /***/
        function(i, r, e) {
          (function(n) {
            r.__esModule = !0, r.default = t;
            function t(o) {
              return function() {
                for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
                  d[u] = arguments[u];
                return new n((h, A) => {
                  o(...d, function(g) {
                    if (g) {
                      A(g);
                      return;
                    }
                    for (var f = arguments.length, p = new Array(f > 1 ? f - 1 : 0), v = 1; v < f; v++)
                      p[v - 1] = arguments[v];
                    if (p.length === 1) {
                      h(p[0]);
                      return;
                    }
                    h(p);
                  });
                });
              };
            }
          }).call(this, e(2));
        },
        /* 173 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(29)), c = G(e(111)), d = n(e(6)), u = n(e(1)), h = n(e(57)), A = n(e(3)), g = n(e(685)), f = n(e(686)), p = n(e(7)), v = n(e(106)), b = n(e(687)), m = n(e(688)), y = n(e(689)), U = n(e(690)), B = n(e(691)), Q = n(e(174)), N = e(322), J = n(e(175)), w = n(e(267));
          function W(oe) {
            if (typeof WeakMap != "function") return null;
            var fe = /* @__PURE__ */ new WeakMap(), ge = /* @__PURE__ */ new WeakMap();
            return (W = function(_e) {
              return _e ? ge : fe;
            })(oe);
          }
          function G(oe, fe) {
            if (oe && oe.__esModule)
              return oe;
            if (oe === null || typeof oe != "object" && typeof oe != "function")
              return { default: oe };
            var ge = W(fe);
            if (ge && ge.has(oe))
              return ge.get(oe);
            var we = {}, _e = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var Te in oe)
              if (Te !== "default" && Object.prototype.hasOwnProperty.call(oe, Te)) {
                var Pe = _e ? Object.getOwnPropertyDescriptor(oe, Te) : null;
                Pe && (Pe.get || Pe.set) ? Object.defineProperty(we, Te, Pe) : we[Te] = oe[Te];
              }
            return we.default = oe, ge && ge.set(oe, we), we;
          }
          const Z = J.default.VIDEO_BUFFER_TIMEOUT, K = J.default.VIDEO_LOADING_TIMEOUT, L = (0, u.default)("WidgetView");
          (0, v.default)();
          function O(oe) {
            let fe = oe === void 0 ? {} : oe, ge = fe.logging, we = ge === void 0 ? L : ge, _e = fe.OTHelpers, Te = _e === void 0 ? p.default : _e, Pe = fe.waitForVideoToBePlaying, $e = Pe === void 0 ? U.default : Pe, Bt = fe.VideoElementFacade, Le = Bt === void 0 ? (0, v.default)() : Bt, at = fe.env, pt = at === void 0 ? A.default : at;
            const kt = (0, f.default)({
              window: typeof window !== void 0 ? window : Dn
            }), _t = (Ft) => {
              if (Ft.isCanceled())
                throw we.debug("bindVideo bailing due to cancellation"), new c.CancellationError("CANCEL");
            };
            return /* @__PURE__ */ function() {
              function Ft(ft, It) {
                let Kt = It === void 0 ? {} : It, Sn = Kt.insertDefaultUI, Cn = Sn === void 0 ? !0 : Sn, on = Kt.width, An = on === void 0 ? 264 : on, Ue = Kt.height, ne = Ue === void 0 ? 198 : Ue, se = Kt.fitMode, Ce = se === void 0 ? "cover" : se, At = Kt.mirror, Ge = At === void 0 ? !1 : At, Ye = Kt.insertMode, Qt = Kt.classNames, tn = Kt.style, vn = Kt.widgetType, Yt = Kt.initials;
                this._videoElementFacade = void 0, this._container = void 0, this._posterContainer = document.createElement("div"), this._widgetContainer = document.createElement("div"), this._loading = !0, this._audioOnly = !1, this._showPoster = void 0, this._poster = void 0, this._cancelBind = void 0, (0, d.default)(this), /^(contain|cover)$/.test(Ce) === !1 && we.warn(`Invalid fit value "${Ce}" passed. Only "contain" and "cover" can be used.`), this._widgetType = vn, this._fitMode = Ce, this._insertDefaultUI = Cn;
                const Tn = (0, h.default)(this._widgetContainer);
                if (Tn.on("click", this.userGesture.bind(this)), Tn.on("touchstart", this.userGesture.bind(this), kt ? {
                  passive: !0
                } : !1), this.once("destroy", () => Tn.removeAll()), this._widgetContainer.classList.add("OT_widget-container"), this._widgetContainer.style.width = "100%", this._widgetContainer.style.height = "100%", Cn !== !1) {
                  this._container = (0, m.default)(ft, Ye), pt.isSafari && pt.isiOS && pt.iOSVersion && pt.iOSVersion < 11.2 && this._container.classList.add("OT_ForceContain"), this._container.style.width = (0, g.default)(An), this._container.style.height = (0, g.default)(ne), this._container.style.overflow = "hidden", (0, y.default)(this._container), Ge && Te.addClass(this._container, "OT_mirrored"), Qt && Qt.trim().split(/\s+/).forEach((Kr) => this._container.classList.add(Kr)), this._container.classList.add("OT_loading"), this._container.classList.add(`OT_fit-mode-${Ce}`), this._container.appendChild(this._widgetContainer);
                  const pi = Te(this._container).observeSize(() => (0, y.default)(this._container)), $n = pi[0], rr = Te.observeNodeOrChildNodeRemoval(this._container, (Kr) => {
                    if (!this._videoElementFacade)
                      return;
                    Kr.some((Li) => Li === this._widgetContainer || Li === this._videoElementFacade.domElement()) && this.destroyVideo();
                  });
                  this.once("destroy", () => {
                    we.debug("disconnecting observers"), $n.disconnect(), rr.disconnect();
                  });
                }
                this._posterContainer.classList.add("OT_video-poster"), this._widgetContainer.appendChild(this._posterContainer);
                const er = document.createElement("div");
                er.classList.add("OT_video-loading");
                const lr = document.createElement("div");
                lr.classList.add("OT_video-loading-spinner"), er.appendChild(lr), this._widgetContainer.appendChild(er), tn && tn.backgroundImageURI ? this.setBackgroundImageURI(tn.backgroundImageURI) : Yt && this.setInitials(Yt);
              }
              var Zt = Ft.prototype;
              return Zt.addError = function(It, Kt, Sn) {
                this._container && (this._container.innerHTML = `<p>${It}${Kt ? ` <span class="ot-help-message">${Kt}</span>` : ""}</p>`, Te.addClass(this._container, Sn || "OT_subscriber_error"), this._container.querySelector("p").offsetHeight > this._container.offsetHeight && (this._container.querySelector("span").style.display = "none"));
              }, Zt.destroy = function() {
                this.emit("destroy"), this.destroyVideo(), this._container && (Te.removeElement(this._container), this._container = null);
              }, Zt.setBackgroundImageURI = function(It) {
                Te.css(this._posterContainer, "backgroundImage", `url(${It})`), Te.css(this._posterContainer, "backgroundSize", "contain"), Te.css(this._posterContainer, "opacity", "1.0");
              }, Zt.setInitials = function(It) {
                const Kt = (0, b.default)(It), Sn = new XMLSerializer().serializeToString(Kt);
                Te.css(this._posterContainer, "backgroundImage", `url('data:image/svg+xml,${Sn}')`), Te.css(this._posterContainer, "backgroundSize", "auto 55%"), Te.css(this._posterContainer, "opacity", "1.0");
              }, Zt.isAudioBlocked = function() {
                return !!(this._videoElementFacade && this._videoElementFacade.isAudioBlocked());
              }, Zt.unblockAudio = function() {
                return this._videoElementFacade.unblockAudio();
              }, Zt.userGesture = function() {
                this.isAudioBlocked() && (0, Q.default)().then(() => we.debug("Successfully unblocked audio"), (It) => we.error("Error retrying audio on user interaction:", It));
              }, Zt.setAudioBlockedUi = function(It) {
                this._container && (It ? this._container.classList.add("OT_container-audio-blocked") : this._container.classList.remove("OT_container-audio-blocked"));
              }, Zt.rebindSrcObject = function() {
                this._videoElementFacade && this._videoElementFacade._rebindSrcObject();
              }, Zt.pauseAndPlayVideoElement = function() {
                this._videoElementFacade && this._videoElementFacade._pauseAndPlay();
              }, Zt._loadVideoBuffer = /* @__PURE__ */ function() {
                var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function Kt(Sn, Cn, on) {
                  var An, Ue, ne, se, Ce;
                  return t.default.wrap(function(Ge) {
                    for (; ; ) switch (Ge.prev = Ge.next) {
                      case 0:
                        return on === void 0 && (on = {}), Ue = (An = on.createElement) != null ? An : w.default, ne = !1, se = Ue(), se.srcObject = Sn, Ge.prev = 5, Ce = se.play(), Ge.next = 9, $e(se, Cn);
                      case 9:
                        return ne = Ge.sent, Ge.next = 12, Ce;
                      case 12:
                        Ge.next = 16;
                        break;
                      case 14:
                        Ge.prev = 14, Ge.t0 = Ge.catch(5);
                      case 16:
                        return se.srcObject = null, se.remove(), Ge.abrupt("return", ne);
                      case 19:
                      case "end":
                        return Ge.stop();
                    }
                  }, Kt, null, [[5, 14]]);
                }));
                function It(Kt, Sn, Cn) {
                  return ft.apply(this, arguments);
                }
                return It;
              }(), Zt._emitAMREvent = function(It, Kt, Sn) {
                this.emit("amrLogEvent", It, Kt, Sn);
              }, Zt._createVideoElementFacade = function(It) {
                let Kt = It._inject, Sn = It.audioVolume, Cn = It.fallbackText, on = It.muted;
                this._videoElementFacade = new Le({
                  defaultAudioVolume: parseFloat(Sn),
                  fallbackText: Cn,
                  fitMode: this._fitMode,
                  _inject: Kt,
                  muted: on,
                  widgetType: this._widgetType
                });
                const An = (0, h.default)(this._videoElementFacade);
                if (this._videoFacadeEvents = An, An.on("error", () => {
                  this.trigger("error");
                }), An.on("videoDimensionsChanged", (Ue, ne) => {
                  this.trigger("videoDimensionsChanged", Ue, ne);
                }), An.on("mediaStopped", (Ue) => {
                  this.trigger("mediaStopped", Ue);
                }), An.on("audioBlocked", () => this.trigger("audioBlocked")), An.on("audioUnblocked", () => this.trigger("audioUnblocked")), this._videoElementFacade.audioChannelType("telephony"), we.debug("Appending the video facade"), this._videoElementFacade.appendTo(this._widgetContainer), typeof Sn != "undefined")
                  try {
                    this._videoElementFacade.setAudioVolume(Sn);
                  } catch (Ue) {
                    we.warn(`bindVideo ${Ue}`);
                  }
              }, Zt._bindToStream = /* @__PURE__ */ function() {
                var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function Kt(Sn, Cn) {
                  return t.default.wrap(function(An) {
                    for (; ; ) switch (An.prev = An.next) {
                      case 0:
                        return An.prev = 0, An.next = 3, this._videoElementFacade.bindToStream(Sn);
                      case 3:
                        An.next = 14;
                        break;
                      case 5:
                        if (An.prev = 5, An.t0 = An.catch(0), !Cn.isCanceled()) {
                          An.next = 12;
                          break;
                        }
                        throw we.debug("Refusing to destroyVideo as bindVideo was cancelled"), new c.CancellationError("CANCEL");
                      case 12:
                        throw this.destroyVideo(), An.t0;
                      case 14:
                      case "end":
                        return An.stop();
                    }
                  }, Kt, this, [[0, 5]]);
                }));
                function It(Kt, Sn) {
                  return ft.apply(this, arguments);
                }
                return It;
              }(), Zt._getNewBindCancellation = function() {
                this._cancelBind && (we.debug("Cancelling last bindVideo request"), this._cancelBind.cancel());
                const It = new c.default();
                return this._cancelBind = It, this.once("destroy", () => It.cancel()), It;
              }, Zt._triggerVideoElementCreated = function() {
                const It = (Kt) => {
                  this.trigger("videoElementCreated", Kt), this._insertDefaultUI && Te.addClass(Kt, "OT_video-element");
                };
                this._videoElementFacade.domElement() ? It(this._videoElementFacade.domElement()) : this._videoFacadeEvents.on("videoElementCreated", (Kt) => {
                  It(Kt);
                });
              }, Zt._waitForVideoResolution = /* @__PURE__ */ function() {
                var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function Kt(Sn) {
                  return t.default.wrap(function(on) {
                    for (; ; ) switch (on.prev = on.next) {
                      case 0:
                        if (!(!this.audioOnly() && Sn.getVideoTracks().length > 0)) {
                          on.next = 5;
                          break;
                        }
                        return we.debug("Waiting for correct resolution"), on.next = 4, (0, B.default)(this._videoElementFacade, 5e3);
                      case 4:
                        we.debug(`Resolution: ${this._videoElementFacade.videoWidth()}x${this._videoElementFacade.videoHeight()}`);
                      case 5:
                      case "end":
                        return on.stop();
                    }
                  }, Kt, this);
                }));
                function It(Kt) {
                  return ft.apply(this, arguments);
                }
                return It;
              }(), Zt._tryToLoadVideoBuffer = /* @__PURE__ */ function() {
                var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function Kt(Sn, Cn) {
                  var on, An, Ue;
                  return t.default.wrap(function(se) {
                    for (; ; ) switch (se.prev = se.next) {
                      case 0:
                        this._emitAMREvent("AMRLoadVideoBuffer", "Attempt"), on = Math.ceil(K / Z), An = !1;
                      case 3:
                        if (!(!An && on)) {
                          se.next = 10;
                          break;
                        }
                        return se.next = 6, this._loadVideoBuffer(Sn, Z);
                      case 6:
                        An = se.sent, on--, se.next = 3;
                        break;
                      case 10:
                        if (An) {
                          se.next = 16;
                          break;
                        }
                        if (this._emitAMREvent("AMRLoadVideoBuffer", "Failure"), !Cn) {
                          se.next = 15;
                          break;
                        }
                        throw Ue = (0, N.createAmrVideoBufferError)(), Ue;
                      case 15:
                        return se.abrupt("return");
                      case 16:
                        this._emitAMREvent("AMRLoadVideoBuffer", "Success"), this._videoFacadeEvents.on("amrLogEvent", (Ce, At, Ge) => {
                          this._emitAMREvent(Ce, At, Ge);
                        });
                      case 18:
                      case "end":
                        return se.stop();
                    }
                  }, Kt, this);
                }));
                function It(Kt, Sn) {
                  return ft.apply(this, arguments);
                }
                return It;
              }(), Zt.bindVideo = /* @__PURE__ */ function() {
                var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function Kt(Sn, Cn, on) {
                  var An, Ue, ne, se, Ce, At, Ge, Ye;
                  return t.default.wrap(function(tn) {
                    for (; ; ) switch (tn.prev = tn.next) {
                      case 0:
                        if (An = Cn.audioVolume, Ue = Cn.muted, ne = Cn.fallbackText, se = Cn.hasVideo, Ce = Cn._inject, on === void 0 && (on = !1), we.debug("bindVideo ", {
                          webRTCStream: Sn
                        }), At = !!this._videoElementFacade, Ge = this._getNewBindCancellation(), At) {
                          tn.next = 9;
                          break;
                        }
                        this._createVideoElementFacade({
                          _inject: Ce,
                          audioVolume: An,
                          fallbackText: ne,
                          muted: Ue
                        }), tn.next = 13;
                        break;
                      case 9:
                        if (!(Sn instanceof MediaStream)) {
                          tn.next = 13;
                          break;
                        }
                        if (!se) {
                          tn.next = 13;
                          break;
                        }
                        return tn.next = 13, this._tryToLoadVideoBuffer(Sn, on);
                      case 13:
                        return tn.next = 15, this._bindToStream(Sn, Ge);
                      case 15:
                        return At || this._triggerVideoElementCreated(), _t(Ge), Ye = $e(this._videoElementFacade, 5e3), tn.next = 20, this._waitForVideoResolution(Sn);
                      case 20:
                        return we.debug("Waiting for video to be playing"), tn.next = 23, Ye;
                      case 23:
                        we.debug("Video is playing"), _t(Ge);
                      case 25:
                      case "end":
                        return tn.stop();
                    }
                  }, Kt, this);
                }));
                function It(Kt, Sn, Cn) {
                  return ft.apply(this, arguments);
                }
                return It;
              }(), Zt.bindAudioTrackOnly = function() {
                this._videoElementFacade && this._videoElementFacade.bindAudioTrackOnly();
              }, Zt.destroyVideo = function() {
                this._videoElementFacade && (this._videoElementFacade.destroy(), this._videoElementFacade = null);
              }, Zt.video = function() {
                return this._videoElementFacade;
              }, Zt.showPoster = function(It) {
                return It === void 0 ? !Te.isDisplayNone(this._posterContainer) : (this._showPoster = It, Te[It ? "show" : "hide"](this._posterContainer), this.showPoster());
              }, Zt.poster = function(It) {
                return It === void 0 ? Te.css(this._posterContainer, "backgroundImage") : (this._poster = It, Te.css(this._posterContainer, "backgroundImage", `url(${It})`), this.poster());
              }, Zt.loading = function(It) {
                return It === void 0 ? this._loading : (this._loading = !!It, this._container && this._container.classList[It ? "add" : "remove"]("OT_loading"), this.loading());
              }, Zt.audioOnly = function(It) {
                return It === void 0 ? this._audioOnly : (this._audioOnly = It, this._container && this._container.classList[It ? "add" : "remove"]("OT_audio-only"), this.audioOnly());
              }, Zt.domId = function() {
                return this._container && this._container.getAttribute("id");
              }, Zt.setSinkId = function(It) {
                if (this._videoElementFacade)
                  return this._videoElementFacade.setSinkId(It);
              }, (0, l.default)(Ft, [{
                key: "domElement",
                get: function() {
                  return this._container;
                }
              }, {
                key: "videoElement",
                get: function() {
                  return this._videoElementFacade && this._videoElementFacade.domElement() || void 0;
                }
                /**
                 * The width of the video element in pixels
                 * @return {Number}
                 */
              }, {
                key: "width",
                get: function() {
                  return this.videoElement && this.videoElement.offsetWidth;
                }
                /**
                 * The height of the video element in pixels
                 * @return {Number}
                 */
              }, {
                key: "height",
                get: function() {
                  return this.videoElement && this.videoElement.offsetHeight;
                }
              }]), Ft;
            }();
          }
          var de = O;
          r.default = de;
        },
        /* 174 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(24)), l = () => n.all(o.default.subscribers.where().map((c) => {
              if (c.isAudioBlocked())
                return c._.unblockAudio();
            }));
            r.default = l;
          }).call(this, e(2));
        },
        /* 175 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = {
            // Publisher keeps sending media for 5 secs
            KEEP_SENDING_MEDIA_AFTER_TRANSITIONED: 5 * 1e3,
            // Subscriber has 5 secs to load the video before Publisher stops sending
            VIDEO_LOADING_TIMEOUT: 5 * 1e3,
            // 5 secs to load the video + 1 sec tolerance to establish the PeerConnection
            TRANSITION_TIMEOUT: 6 * 1e3,
            // Send media for 3 secs to keep alive
            KEEP_SENDING_MEDIA_TO_KEEP_ALIVE: 3 * 1e3,
            // Send media every 30 secs to keep alive
            KEEP_SENDING_RTCP_DELAY: 30 * 1e3,
            // Worst cases observed buffer took a max of 1.x secs to load
            VIDEO_BUFFER_TIMEOUT: 2 * 1e3
          };
          r.default = t;
        },
        /* 176 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => t === "P2P" ? "RELAYED" : "ROUTED";
          r.default = n;
        },
        /* 177 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(1));
          const c = (0, l.default)("MediaProcessorConnector");
          let d = function(A) {
            var g = this;
            this.setTrack = /* @__PURE__ */ function() {
              var f = (0, o.default)(/* @__PURE__ */ t.default.mark(function p(v) {
                var b;
                return t.default.wrap(function(y) {
                  for (; ; ) switch (y.prev = y.next) {
                    case 0:
                      return b = null, y.prev = 1, y.next = 4, g.connector.setTrack(v);
                    case 4:
                      b = y.sent, g.originalTrack = v, y.next = 11;
                      break;
                    case 8:
                      y.prev = 8, y.t0 = y.catch(1), c.error(`Error setting track: ${y.t0}`);
                    case 11:
                      return y.abrupt("return", b);
                    case 12:
                    case "end":
                      return y.stop();
                  }
                }, p, null, [[1, 8]]);
              }));
              return function(p) {
                return f.apply(this, arguments);
              };
            }(), this.destroy = /* @__PURE__ */ (0, o.default)(/* @__PURE__ */ t.default.mark(function f() {
              return t.default.wrap(function(v) {
                for (; ; ) switch (v.prev = v.next) {
                  case 0:
                    return v.prev = 0, v.next = 3, g.connector.destroy();
                  case 3:
                    v.next = 8;
                    break;
                  case 5:
                    v.prev = 5, v.t0 = v.catch(0), c.warn(`Error destroying connector: ${v.t0}`);
                  case 8:
                  case "end":
                    return v.stop();
                }
              }, f, null, [[0, 5]]);
            })), this.stopOriginalTrack = () => {
              this.originalTrack && (this.originalTrack.stop(), this.originalTrack = null);
            }, this.connector = A;
          };
          d.isValidConnector = (h) => typeof (h == null ? void 0 : h.setTrack) == "function" && typeof (h == null ? void 0 : h.destroy) == "function";
          var u = d;
          r.default = u;
        },
        /* 178 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = ao;
            var o = t(e(4)), l = t(e(5)), c = t(e(332)), d = t(e(333)), u = t(e(58)), h = t(e(9)), A = t(e(61)), g = t(e(62)), f = t(e(295)), p = t(e(40)), v = t(e(51)), b = t(e(709)), m = t(e(275)), y = t(e(155)), U = t(e(16)), B = t(e(207)), Q = Ct(e(111)), N = e(719), J = t(e(76)), w = e(25), W = t(e(720)), G = t(e(6)), Z = t(e(1)), K = t(e(94)), L = t(e(3)), O = t(e(21)), de = t(e(722)), oe = t(e(73)), fe = t(e(10)), ge = t(e(22)), we = e(309), _e = t(e(150)), Te = t(e(31)), Pe = t(e(28)), $e = t(e(172)), Bt = t(e(327)), Le = t(e(287)), at = t(e(13)), pt = t(e(334)), kt = t(e(8)), _t = t(e(77)), Lt = t(e(144)), Ft = t(e(162)), Zt = t(e(723)), ft = t(e(173)), It = t(e(724)), Kt = t(e(174)), Sn = t(e(725)), Cn = t(e(726)), on = t(e(727)), An = t(e(176)), Ue = t(e(270)), ne = t(e(301)), se = t(e(154)), Ce = t(e(23)), At = t(e(169)), Ge = t(e(311)), Ye = t(e(7)), Qt = e(107), tn = t(e(284)), vn = t(e(312)), Yt = t(e(319)), Tn = t(e(157)), er = t(e(159)), lr = t(e(330)), Br = t(e(728)), pi = t(e(177)), $n = t(e(733)), rr = t(e(734)), Kr = t(e(736)), Bi = e(737), Li = t(e(324)), xo = t(e(175)), Yr = t(e(738)), Qo = t(e(180)), Wo = t(e(739)), xi = t(e(740)), Fa = e(71);
            function sn(wr) {
              if (typeof WeakMap != "function") return null;
              var Jr = /* @__PURE__ */ new WeakMap(), Fn = /* @__PURE__ */ new WeakMap();
              return (sn = function(wt) {
                return wt ? Fn : Jr;
              })(wr);
            }
            function Ct(wr, Jr) {
              if (wr && wr.__esModule)
                return wr;
              if (wr === null || typeof wr != "object" && typeof wr != "function")
                return { default: wr };
              var Fn = sn(Jr);
              if (Fn && Fn.has(wr))
                return Fn.get(wr);
              var Ia = {}, wt = Object.defineProperty && Object.getOwnPropertyDescriptor;
              for (var Yn in wr)
                if (Yn !== "default" && Object.prototype.hasOwnProperty.call(wr, Yn)) {
                  var kr = wt ? Object.getOwnPropertyDescriptor(wr, Yn) : null;
                  kr && (kr.get || kr.set) ? Object.defineProperty(Ia, Yn, kr) : Ia[Yn] = wr[Yn];
                }
              return Ia.default = wr, Fn && Fn.set(wr, Ia), Ia;
            }
            const cn = (0, ft.default)(), Hn = (0, O.default)(), Sr = Hn.getInputMediaDevices;
            function ao(wr) {
              wr === void 0 && (wr = {});
              let Jr = wr, Fn = (0, d.default)({}, ((0, c.default)(Jr), Jr));
              ["processPubOptions"].forEach((qa) => {
                (0, y.default)(Fn[qa], `${qa} dependency must be injected into Publisher`);
              });
              const Ia = Fn.AnalyticsHelper || Pe.default, wt = Fn.createAudioFallbackCoordinator || W.default, Yn = Fn.calculateCapableSimulcastStreams || Ue.default, kr = Fn.createChromeMixin || (0, ne.default)(), mr = Fn.deviceHelpers || (0, O.default)(), yi = Fn.EnvironmentLoader || se.default, Or = Fn.Errors || kt.default, Ei = Fn.Events || (0, Ce.default)(), Rt = Fn.ExceptionCodes || fe.default, ln = Fn.interpretPeerConnectionError || (0, At.default)(), tt = Fn.IntervalRunner || oe.default, Oe = Fn.logging || (0, Z.default)("Publisher"), Jt = Fn.Microphone || (0, Ge.default)(), St = Fn.otError || (0, at.default)(), Vt = Fn.OTErrorClass || ge.default, Et = Fn.OTHelpers || Ye.default, Qn = Fn.parseIceServers || Qt.parseIceServers, gn = Fn.PUBLISH_MAX_DELAY || tn.default, jt = Fn.PublisherPeerConnection || (0, vn.default)(), On = Fn.PublishingState || (0, Yt.default)(), Ar = Fn.StreamChannel || Tn.default, ui = Fn.systemRequirements || er.default, fr = Fn.VideoOrientation || (0, _e.default)(), Jn = Fn.WidgetView || cn, Qr = Fn.global || (typeof window !== void 0 ? window : Dn), ti = Fn.createSendMethod || lr.default, Wn = Fn.MediaProcessor || Br.default, Hi = pi.default, Ho = Fn.createVonageNoiseSuppression || N.createVonageNoiseSuppression, Ea = Fn.setScalabilityMode || xi.default, Ga = Fn.shouldLogMediaProcessorEvents || $n.default, No = Fn.processPubOptions, Ba = Object.assign({}, xo.default, Fn.AMRStateDurations), Ra = Ba.KEEP_SENDING_MEDIA_AFTER_TRANSITIONED, us = Ba.KEEP_SENDING_MEDIA_TO_KEEP_ALIVE, so = Ba.KEEP_SENDING_RTCP_DELAY;
              return function(hs) {
                var oi = this;
                hs === void 0 && (hs = {});
                let oa = (0, G.default)({});
                const Wa = new B.default(), Xa = (0, Li.default)(), ya = (nt) => Wa.get(nt), Fl = (nt, Ke) => Wa.set(nt, Ke);
                (0, G.default)(this);
                const As = (0, Ft.default)();
                let gl = new Ia();
                ui.check() || ui.upgrade();
                let Vi, zr, za, ws, Zi, kl, vc, wl, ys, Xn, Kn, pr, hi = !1, Qi, qt, bn, hn, xn;
                const vr = {}, Rr = {};
                let zi;
                const _i = 5e3;
                let Ko = !1, ps, ho, Ya;
                const La = hs, Jd = La._enableSenderStats, zo = () => this.session || Ya || {
                  isConnected() {
                    return !1;
                  }
                }, Rl = () => this.streamId || "", ms = [], $o = new Wn(), bc = new Kr.default();
                this.once("publishComplete", (nt) => {
                  if (!nt) {
                    var Ke;
                    hi = !0, Qi = (Ke = this.session) != null && Ke.sessionInfo.p2pEnabled ? "P2P" : "MANTIS";
                  }
                }), this.on("sourceStreamIdChanged", (nt) => {
                  Qi = nt, Xa.completeTransitionTo(Qi);
                }), this.on("audioAcquisitionProblem", (nt) => {
                  let Ke = nt.method;
                  fn("publisher:audioAcquisitionProblem", "Event", {
                    didPublishComplete: hi,
                    method: Ke
                  });
                });
                function Zc() {
                  return {
                    connectionId: zo().isConnected() ? zo().connection.connectionId : null,
                    streamId: Rl(),
                    widgetType: "Publisher"
                  };
                }
                const oc = (nt) => {
                  const Ke = Object.keys(Or).map(($t) => Or[$t]), et = St(Ke.indexOf(nt.name) > -1 ? nt.name : Or.MEDIA_ERR_ABORTED, nt, Rt.UNABLE_TO_PUBLISH);
                  Oe.error(`onStreamAvailableError ${et.name}: ${et.message}`), Zi.set("Failed"), Vi && (Vi.destroy(), Vi = null);
                  const dt = {
                    failureReason: "GetUserMedia",
                    failureCode: Rt.UNABLE_TO_PUBLISH,
                    failureMessage: `OT.Publisher failed to access camera/mic: ${et.message}`
                  };
                  Ro("Failure", {}, dt), Vt.handleJsException({
                    error: et,
                    errorMsg: dt.failureReason,
                    code: dt.failureCode,
                    target: this,
                    analytics: gl
                  }), this.trigger("publishComplete", et);
                }, gu = (nt) => {
                  const Ke = (0, A.default)(nt);
                  Ke.code = Rt.UNABLE_TO_PUBLISH, Oe.error(`OT.Publisher.onScreenSharingError ${Ke.message}`), Zi.set("Failed"), Ke.message = `Screensharing: ${Ke.message}`, this.trigger("publishComplete", Ke), Ro("Failure", {}, {
                    failureReason: "ScreenSharing",
                    failureMessage: Ke.message
                  }), Vi && (Vi.destroy(), Vi = null);
                }, zd = (nt) => {
                  const Ke = (0, A.default)(nt);
                  let et;
                  try {
                    et = window.self !== window.top;
                  } catch {
                  }
                  (typeof window !== void 0 ? window : Dn).location.protocol !== "https:" && (ct ? Ke.message += " Note: https:// is required for screen sharing." : (0, Le.default)() && Et.env.hostName !== "localhost" && (Ke.message += ` Note: ${Et.env.name} requires HTTPS for camera and microphone access.`)), et && !ct && (Ke.message += " Note: Check that the iframe has the allow attribute for camera and microphone"), Oe.error(Ke.message), Zi.set("Failed"), Ke.message = `OT.Publisher Access Denied: Permission Denied: ${Ke.message}`, Ke.code = Rt.UNABLE_TO_PUBLISH, Vi && (Vi.destroy(), Vi = null), Ro("Cancel", {
                    reason: "AccessDenied"
                  }), this.trigger("publishComplete", Ke), this.dispatchEvent(new Lt.default(Te.default.ACCESS_DENIED));
                }, ka = (nt) => {
                  throw nt instanceof Error || /^\[object .*Error\]$/.test(Object.prototype.toString.call(nt)) || (nt = new Error("Unknown error has occurred. Stream is not available.")), nt.name === Or.USER_MEDIA_ACCESS_DENIED || nt.name === Or.NOT_SUPPORTED && nt.originalMessage.match(/Only secure origins/) ? zd(nt) : No.isScreenSharing ? gu(nt) : oc(nt), nt;
                }, jr = () => {
                  fn("accessDialog", "Opened"), this.dispatchEvent(new Lt.default(Te.default.ACCESS_DIALOG_OPENED, !0));
                }, xe = () => {
                  fn("accessDialog", "Closed"), this.dispatchEvent(new Lt.default(Te.default.ACCESS_DIALOG_CLOSED, !1));
                }, ot = (0, U.default)(), ye = {};
                let re = !1, Be = {}, He = !1, Xe = No(hs, "OT.Publisher", () => Zi && Zi.isDestroyed());
                Xe.on({
                  accessDialogOpened: jr,
                  accessDialogClosed: xe
                });
                const ut = Xe, ct = ut.isScreenSharing, Xt = ut.isCustomAudioTrack, pn = ut.isCustomVideoTrack, un = ut.shouldAllowAudio, vt = ut.properties, gr = ut.getUserMedia;
                Object.defineProperty(this, "loudness", {
                  writable: !1,
                  value: void 0,
                  configurable: !0
                });
                function sr(nt) {
                  nt.forEach((Ke) => Ke());
                }
                const an = (nt, Ke, et) => nt.addEventListener ? (nt.addEventListener(Ke, et), () => nt.removeEventListener(Ke, et)) : () => {
                };
                (function() {
                  const Ke = [];
                  oa.on("streamDestroy", () => sr(Ke)), oa.on("streamChange", () => {
                    sr(Ke);
                    const et = zr.getAudioTracks().map((dt) => an(dt, "ended", () => {
                      He = !0, this.trigger("audioAcquisitionProblem", {
                        method: "trackEndedEvent"
                      });
                    }));
                    Ke.splice(0, Ke.length, ...et);
                  });
                }).call(this), function() {
                  const Ke = [];
                  oa.on("streamDestroy", () => sr(Ke)), oa.on("streamChange", () => {
                    sr(Ke), En() || zr.getTracks().forEach((et) => {
                      et.addEventListener && (Ke.push(an(et, "mute", () => {
                        sa();
                      })), Ke.push(an(et, "unmute", () => {
                        sa();
                      })));
                    });
                  });
                }();
                const En = () => {
                  if (ct)
                    return !0;
                  const Ke = ["text", "detail"].includes(vt.videoContentHint);
                  return pn && Ke;
                }, fn = hs.logAnalyticsEvent || ((nt, Ke, et, dt, $t) => {
                  let be = (0, h.default)({
                    action: nt,
                    variation: Ke,
                    payload: et
                  }, Zc(), dt);
                  Ke === "Failure" && (be = (0, h.default)(Be, be)), Be = (0, p.default)(be, "sessionId", "connectionId", "partnerId"), gl.logEvent(be, $t);
                }), Fr = () => {
                  if (!Ga(this.session)) {
                    $o.disableLogging();
                    return;
                  }
                  const Ke = this.session.apiKey;
                  $o.enableLogging(Ke);
                }, Ro = function(Ke, et, dt) {
                  et === void 0 && (et = {}), dt === void 0 && (dt = {}), dt.failureReason !== "Non-fatal" && (Ke === "Attempt" && (vc = (/* @__PURE__ */ new Date()).getTime(), ho && (ho.stop(), Oe.error("_connectivityAttemptPinger should have been cleaned up")), ho = new tt(() => {
                    fn("Publish", "Attempting", et, Object.assign({}, Zc(), dt));
                  }, 1 / 5, 6)), Ke === "Failure" || Ke === "Success" || Ke === "Cancel" ? (ho ? (ho.stop(), ho = void 0) : Oe.warn(`Received connectivity event: "${Ke}" without "Attempt"`), fn("Publish", Ke, Object.assign({
                    videoInputDevices: ys,
                    audioInputDevices: wl,
                    videoInputDeviceCount: ys ? ys.length : void 0,
                    audioInputDeviceCount: wl ? wl.length : void 0,
                    selectedVideoInputDeviceId: Xn,
                    selectedAudioInputDeviceId: Kn
                  }, et), Object.assign({
                    attemptDuration: (/* @__PURE__ */ new Date()).getTime() - vc
                  }, dt))) : fn("Publish", Ke, et, dt));
                }, ca = (nt, Ke) => {
                  fn("ICERestart", nt, Ke);
                }, Co = (nt, Ke, et) => {
                  Ke === "Attempt" ? (vr[nt] = (/* @__PURE__ */ new Date()).getTime(), fn(nt, Ke, et)) : (Ke === "Failure" || Ke === "Success") && fn(nt, Ke, et, {
                    attemptDuration: (/* @__PURE__ */ new Date()).getTime() - vr[nt]
                  });
                }, ga = function(Ke, et) {
                  et === void 0 && (et = {}), Co("RoutedToRelayedTransition", Ke, et);
                }, aa = function(Ke, et) {
                  et === void 0 && (et = {}), Co("RelayedToRoutedTransition", Ke, et);
                }, Dl = (0, v.default)(() => {
                  fn("GetStats", "Called");
                }), Jo = (0, v.default)(() => {
                  fn("GetRtcStatsReport", "Called");
                }), Pi = (nt) => {
                  var Ke;
                  let et = nt.parsedStats, dt = nt.simulcastEnabled, $t = nt.remoteConnectionId, be = nt.peerId, ze = nt.sourceStreamId;
                  const P = {
                    peerId: be,
                    widgetType: "Publisher",
                    connectionId: this.session && this.session.isConnected() ? this.session.connection.connectionId : null,
                    streamId: this.streamId,
                    width: Vi.width,
                    height: Vi.height,
                    audioTrack: zr && zr.getAudioTracks().length > 0,
                    hasAudio: Za(),
                    publishAudio: vt.publishAudio,
                    videoTrack: zr && zr.getVideoTracks().length > 0,
                    hasVideo: to(),
                    publishVideo: vt.publishVideo,
                    audioSource: Xt ? "Custom" : void 0,
                    duration: za ? Math.round(((/* @__PURE__ */ new Date()).getTime() - za.getTime()) / 1e3) : 0,
                    remoteConnectionId: $t,
                    scalableVideo: dt,
                    sourceStreamId: (0, An.default)(ze),
                    publisherAudioFallbackEnabled: ((Ke = vt.audioFallback) == null ? void 0 : Ke.publisher) || !1
                  };
                  let te = ct && pn && "Screen" || ct && hs.videoSource || pn && "Custom" || vt.constraints.video && "Camera" || null;
                  (0, f.default)(te) && (te = (0, b.default)(te)), P.videoSource = te;
                  const Re = {
                    videoWidth: this.videoWidth(),
                    videoHeight: this.videoHeight()
                  }, Qe = (0, h.default)({}, P, et, Re);
                  gl.logQOS(Qe), this.trigger("qos", Qe);
                }, wa = () => {
                  var nt, Ke;
                  let et = ((nt = vt.videoDimensions) == null ? void 0 : nt.width) || 640, dt = ((Ke = vt.videoDimensions) == null ? void 0 : Ke.height) || 480;
                  if (vt.publishVideo) {
                    var $t;
                    const be = ($t = Vi) == null ? void 0 : $t.video();
                    et = (be == null ? void 0 : be.videoWidth()) || et, dt = (be == null ? void 0 : be.videoHeight()) || dt;
                  }
                  return {
                    width: et,
                    height: dt
                  };
                }, yl = (nt) => {
                  Oe.error("OT.Publisher State Change Failed: ", nt.message), Oe.debug(nt);
                }, Ci = () => {
                  if (Zi.isDestroyed()) {
                    Vi && Vi.destroyVideo();
                    return;
                  }
                  Oe.debug("OT.Publisher.onLoaded; resolution:", `${this.videoWidth()}x${this.videoHeight()}`), Zi.set("MediaBound"), (0, Kt.default)().catch(Oe.error), Vi.loading(this.session ? !this.stream : !1), re = !0;
                }, Ti = (nt) => {
                  const Ke = St(Or.CONNECT_FAILED, nt, Rt.P2P_CONNECTION_FAILED);
                  Ke.message = `OT.Publisher PeerConnection Error: ${Ke.message}`, Ro("Failure", {}, {
                    failureReason: "PeerConnectionError",
                    failureCode: Ke.code,
                    failureMessage: Ke.message
                  }), Zi.set("Failed"), this.trigger("publishComplete", Ke), Vt.handleJsException({
                    error: Ke,
                    target: this,
                    analytics: gl
                  });
                }, Di = () => {
                  zr && (oa.emit("streamDestroy"), Qr.MediaStreamTrack && Qr.MediaStreamTrack.prototype.stop ? zr.getTracks().forEach((nt) => nt.stop()) : zr.stop());
                }, Gd = () => {
                  const nt = L.default.isiOS && L.default.iOSVersion >= 15 && L.default.iOSVersion < 15.2, Ke = zr.getVideoTracks()[0];
                  if (!nt || !Ke)
                    return;
                  const et = () => {
                    !document.hidden && Vi && Vi.rebindSrcObject();
                  };
                  document.addEventListener("visibilitychange", et);
                }, _l = () => {
                  const nt = L.default.isiOS && L.default.iOSVersion >= 13.3, Ke = zr.getAudioTracks()[0];
                  nt && Ke && (Ke.onmute = () => dc(Ke), Ke.onunmute = () => sl(Ke));
                }, Zl = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et;
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          if (et = {
                            muted: !0
                          }, Vi) {
                            $t.next = 3;
                            break;
                          }
                          throw new Error("Cannot bind video after widget view has been destroyed");
                        case 3:
                          return $t.abrupt("return", Vi.bindVideo(zr, et));
                        case 4:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }(), Ml = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          if (Oe.debug("OT.Publisher.onStreamAvailable"), Zi.set("BindingMedia"), vt.videoContentHint !== void 0 && (0, we.setVideoContentHint)(et, vt.videoContentHint), Di(), zr = et, !vt.videoFilter) {
                            be.next = 14;
                            break;
                          }
                          return be.prev = 6, be.next = 9, oi.applyVideoFilter(vt.videoFilter);
                        case 9:
                          be.next = 14;
                          break;
                        case 11:
                          be.prev = 11, be.t0 = be.catch(6), Oe.error(`Error applying video filter: ${be.t0}`);
                        case 14:
                          if (!vt.audioFilter) {
                            be.next = 23;
                            break;
                          }
                          return be.prev = 15, be.next = 18, oi.applyAudioFilter(vt.audioFilter);
                        case 18:
                          be.next = 23;
                          break;
                        case 20:
                          be.prev = 20, be.t1 = be.catch(15), Oe.error(`Error applying audio filter: ${be.t1}`);
                        case 23:
                          oa.emit("streamChange"), _l(), Gd(), dt = (ze, P) => {
                            let te;
                            return ze.forEach((Re) => {
                              if (Re.deviceId)
                                te = Re.deviceId.toString();
                              else if (Re.label && P) {
                                const Qe = (0, g.default)(P, (yt) => yt.label === Re.label);
                                Qe && (te = Qe.deviceId);
                              }
                            }), te;
                          }, Xn = dt(zr.getVideoTracks(), ys), Kn = dt(zr.getAudioTracks(), wl), ws = new Jt(zr, !vt.publishAudio), da(), lc(), oi.accessAllowed = !0, oi.dispatchEvent(new Lt.default(Te.default.ACCESS_ALLOWED, !1));
                        case 34:
                        case "end":
                          return be.stop();
                      }
                    }, Ke, null, [[6, 11], [15, 20]]);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }(), kc = (nt) => {
                  Oe.error("OT.Publisher.onPublishingTimeout");
                  let Ke, et;
                  He ? (Ke = Or.CHROME_MICROPHONE_ACQUISITION_ERROR, et = "Unable to publish because your browser failed to get access to your microphone. You may need to fully quit and restart your browser to get it to work. See https://bugs.chromium.org/p/webrtc/issues/detail?id=4799 for more details.") : (Ke = Or.TIMEOUT, et = "Could not publish in a reasonable amount of time");
                  const dt = {
                    failureReason: "ICEWorkflow",
                    failureCode: Rt.UNABLE_TO_PUBLISH,
                    failureMessage: "OT.Publisher failed to publish in a reasonable amount of time (timeout)"
                  };
                  Ro("Failure", {}, dt), Vt.handleJsException({
                    errorMsg: dt.failureReason,
                    code: dt.failureCode,
                    target: this,
                    analytics: gl
                  }), nt.isConnected() && this.streamId && nt._.streamDestroy(this.streamId), this.disconnect(), Zi.isDestroyed() || Zi.set("MediaBound"), this.trigger("publishComplete", St(Ke, new Error(et), Rt.UNABLE_TO_PUBLISH));
                }, Td = (nt) => {
                  const Ke = St(Or.MEDIA_ERR_DECODE, nt, Rt.UNABLE_TO_PUBLISH);
                  Ke.message = `OT.Publisher while playing stream: ${Ke.message}`, Oe.error("OT.Publisher.onVideoError:", Ke), fn("stream", null, {
                    reason: Ke.message
                  });
                  const et = Zi.isAttemptingToPublish();
                  Zi.set("Failed"), et ? this.trigger("publishComplete", Ke) : this.trigger("error", Ke.message), Vt.handleJsException({
                    error: Ke,
                    target: this,
                    analytics: gl
                  });
                };
                this._setWebRTCStream = (nt) => {
                  zr = nt;
                }, this._setCurrentVideoFilter = (nt) => {
                  ea = nt;
                }, this._getCurrentVideoFilter = () => ea, this._setCurrentAudioFilter = (nt) => {
                  ec = nt;
                }, this._getMediaProcessor = () => $o, this._removePeerConnection = (nt) => {
                  var Ke;
                  if (!nt)
                    return;
                  const et = ya(nt), dt = et.peerConnectionId;
                  delete ye[dt], nt.destroy(), (Ke = xc) == null || Ke.onPeerConnectionDisconnected();
                }, this._removeSubscriber = (nt) => {
                  this.session.sessionInfo.isAdaptiveEnabled && Qi === "P2P" && this._.startRelayedToRoutedTransition(), ql(nt).then((et) => {
                    et.forEach((dt) => this._removePeerConnection(dt));
                  });
                };
                const wc = (nt) => {
                  const Ke = ya(nt), et = Ke.remoteSubscriberId, dt = Ke.peerConnectionId;
                  Oe.debug("Subscriber has been disconnected from the Publisher's PeerConnection"), fn("disconnect", "PeerConnection", {
                    subscriberConnection: dt
                  }), this._removeSubscriber(et);
                }, $l = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be, ze, P, te, Re, Qe, yt, Ht, zt, rn;
                    return o.default.wrap(function(Vn) {
                      for (; ; ) switch (Vn.prev = Vn.next) {
                        case 0:
                          if ($t = dt.reason, be = dt.prefix, ze = oi.session && oi.session.sessionInfo, !(be === "ICEWorkflow" && ze && ze.reconnection && re)) {
                            Vn.next = 5;
                            break;
                          }
                          return Oe.debug("Ignoring peer connection failure due to possibility of reconnection."), Vn.abrupt("return");
                        case 5:
                          return P = ya(et) || {}, te = P.remoteConnectionId, Re = te === void 0 ? "(not found)" : te, Qe = P.peerConnectionId, yt = ln(void 0, $t, be, Re, "Publisher"), Ht = {
                            hasRelayCandidates: et && et.hasRelayCandidates()
                          }, zt = {
                            failureReason: be || "PeerConnectionError",
                            failureCode: yt.code,
                            failureMessage: yt.message
                          }, Zi.isPublishing() ? zt.reason = "Non-fatal" : oi.trigger("publishComplete", yt), Ro("Failure", Ht, zt), Vt.handleJsException({
                            errorMsg: `OT.Publisher PeerConnection Error: ${$t}`,
                            code: yt.code,
                            target: oi,
                            analytics: gl
                          }), Vn.next = 14, ye[Qe];
                        case 14:
                          rn = Vn.sent, rn.destroy(), delete ye[Qe];
                        case 17:
                        case "end":
                          return Vn.stop();
                      }
                    }, Ke);
                  }));
                  return function(et, dt) {
                    return nt.apply(this, arguments);
                  };
                }(), Yl = (nt) => this.session.sessionInfo.isAdaptiveEnabled && nt.getSourceStreamId() === "P2P", js = (nt) => {
                  const Ke = ya(nt), et = Ke.remoteConnectionId;
                  ca("Success", {
                    remoteConnectionId: et
                  });
                }, ac = (nt) => {
                  const Ke = ya(nt), et = Ke.remoteConnectionId;
                  ca("Failure", {
                    reason: "ICEWorkflow",
                    message: "OT.Publisher PeerConnection Error: The stream was unable to connect due to a network error. Make sure your connection isn't blocked by a firewall.",
                    remoteConnectionId: et
                  });
                }, Dc = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be, ze, P, te, Re, Qe, yt, Ht;
                    return o.default.wrap(function(rn) {
                      for (; ; ) switch (rn.prev = rn.next) {
                        case 0:
                          if ($t = oi.session.sessionInfo.isAdaptiveEnabled, be = dt.getSourceStreamId(), Rr[be] = et, et === "disconnected" && setTimeout(() => {
                            const tr = oi.session._.isSocketReconnecting, si = oi.session._.getSocket().is("connected") && !tr();
                            if (Rr[be] === "disconnected" && si) {
                              const ai = ya(dt), Ui = ai.remoteConnectionId;
                              ca("Attempt", {
                                remoteConnectionId: Ui
                              }), dt.iceRestart();
                            }
                          }, 2e3), et !== "connected") {
                            rn.next = 26;
                            break;
                          }
                          if (clearTimeout(zi), !$t) {
                            rn.next = 26;
                            break;
                          }
                          return rn.next = 9, Sc();
                        case 9:
                          if (rn.t0 = ze = rn.sent, rn.t0 != null) {
                            rn.next = 14;
                            break;
                          }
                          rn.t1 = void 0, rn.next = 15;
                          break;
                        case 14:
                          rn.t1 = ze.iceConnectionStateIsConnected();
                        case 15:
                          return te = rn.t1, rn.next = 18, Cl();
                        case 18:
                          if (rn.t2 = P = rn.sent, rn.t2 != null) {
                            rn.next = 23;
                            break;
                          }
                          rn.t3 = void 0, rn.next = 24;
                          break;
                        case 23:
                          rn.t3 = P.iceConnectionStateIsConnected();
                        case 24:
                          Re = rn.t3, te && Re && Uo();
                        case 26:
                          if (et !== "failed") {
                            rn.next = 33;
                            break;
                          }
                          if (Qe = oi.session._.isSocketReconnecting, yt = oi.session._.getSocket(), Ht = yt.is("connected") && !Qe(), Ht) {
                            rn.next = 32;
                            break;
                          }
                          return rn.abrupt("return");
                        case 32:
                          $t && be === Qi && be === "P2P" ? oi._.startRelayedToRoutedTransition() : zi = setTimeout(() => {
                            oi.session._.streamDestroy(oi.streamId, be);
                          }, _i);
                        case 33:
                        case "end":
                          return rn.stop();
                      }
                    }, Ke);
                  }));
                  return function(et, dt) {
                    return nt.apply(this, arguments);
                  };
                }(), Ll = (nt) => {
                  nt.setP2PMaxBitrate(), nt.startEncryption(this.session.connection.id), Yl(nt) && ga("Success");
                }, ed = (nt) => {
                  if (Zi.current !== "PublishingToSession")
                    throw new Error("assignStream called when publisher is not successfully publishing");
                  As.releaseAll(), this.stream = nt, this.stream.on("destroyed", this.disconnect, this), As.add(() => {
                    this.stream && this.stream.off("destroyed", this.disconnect, this);
                  }), Zi.set("Publishing"), Vi.loading(!re), za = /* @__PURE__ */ new Date(), this.dispatchEvent(new Ei.StreamEvent("streamCreated", nt, null, !1)), Ro("Success"), this.trigger("publishComplete", null, this);
                }, sc = (nt) => {
                  let Ke = nt.peerConnectionId, et = nt.send, dt = nt.log, $t = nt.logQoS, be = nt.sourceStreamId;
                  if (Ds(Ke))
                    return n.reject(new Error("PeerConnection already exists"));
                  const ze = Yn({
                    isChromiumEdge: Et.env.isChromiumEdge,
                    browserName: Et.env.name,
                    isScreenSharing: ct,
                    isCustomVideoTrack: pn,
                    sessionInfo: this.session.sessionInfo,
                    constraints: vt.constraints,
                    videoDimensions: wa(),
                    capableSimulcastScreenshare: vt.capableSimulcastScreenshare,
                    scalableVideo: vt.scalableVideo
                  });
                  return ye[Ke] = n.all([this.session._.getIceConfig(), this.session._.getVideoCodecsCompatible(zr)]).then((P) => {
                    let te = P[0], Re = P[1], Qe = zr;
                    if (!Re) {
                      Qe = zr.clone();
                      const Ht = Qe.getVideoTracks(), zt = Ht[0];
                      zt && (zt.stop(), Qe.removeTrack(zt));
                    }
                    const yt = new jt({
                      iceConfig: te,
                      sendMessage: (Ht, zt) => {
                        Ht === "offer" && this.trigger("connected"), et({
                          type: Ht,
                          content: zt
                        });
                      },
                      webRTCStream: Qe,
                      channels: vt.channels,
                      capableSimulcastStreams: ze,
                      overrideSimulcastEnabled: hs._enableSimulcast,
                      logAnalyticsEvent: dt,
                      offerOverrides: {
                        enableDtx: vt.enableDtx,
                        enableStereo: vt.enableStereo,
                        audioBitrate: vt.audioBitrate,
                        priorityVideoCodec: vt._priorityVideoCodec || this.session.sessionInfo.priorityVideoCodec,
                        codecFlags: vt._codecFlags || this.session._.getCodecFlags()
                      },
                      // FIXME - Remove answerOverrides once maxaveragebitrate is supported by Mantis
                      answerOverrides: this.session.sessionInfo.p2pEnabled ? void 0 : {
                        audioBitrate: vt.audioBitrate
                      },
                      sourceStreamId: be,
                      isP2pEnabled: this.session.sessionInfo.p2pEnabled,
                      sessionId: this.session.id,
                      keyStore: this.session.keyStore,
                      sFrameClientStore: this.session.sFrameClientStore,
                      isE2ee: this.session._.isE2ee(),
                      audioFallbackEnabled: vt.publisherAudioFallbackEnabled,
                      resolution: {
                        width: this.videoWidth(),
                        height: this.videoHeight()
                      }
                    });
                    return yt.on({
                      disconnected: () => wc(yt),
                      error: (Ht) => {
                        let zt = Ht.reason, rn = Ht.prefix;
                        return $l(yt, {
                          reason: zt,
                          prefix: rn
                        });
                      },
                      qos: $t,
                      iceRestartSuccess: () => js(yt),
                      iceRestartFailure: () => ac(yt),
                      iceConnectionStateChange: (Ht) => Dc(Ht, yt),
                      audioAcquisitionProblem: () => {
                        He = !0, this.trigger("audioAcquisitionProblem", {
                          method: "getStats"
                        });
                      },
                      audioFallbackStateChange: (Ht) => xc.onPeerConnectionStateChange(Object.assign({}, Ht, {
                        peerConnection: yt,
                        publishVideo: vt.publishVideo,
                        stream: this.stream,
                        peerId: ya(yt).peerId
                      }))
                    }), yt.once("connected", () => Ll(yt)), new n((Ht, zt) => {
                      const rn = (tr) => {
                        zt(tr);
                      };
                      yt.once("error", rn), yt.init(kl, (tr) => {
                        if (tr)
                          return zt(tr);
                        yt.off("error", rn), Ht(yt);
                      });
                    });
                  }), Ds(Ke);
                }, Ql = () => n.all(Object.keys(ye).map(Ds)), ql = (nt) => Ql().then((Ke) => Ke.filter((et) => ya(et).remoteSubscriberId === nt)), Ds = (nt) => ye[nt], jd = (nt) => {
                  const Ke = Object.keys(ye).find((et) => et.endsWith(`~${nt}`));
                  return ye[Ke];
                }, Sc = () => jd("MANTIS"), Cl = () => jd("P2P");
                let _r = kr(this, {
                  name: vt.name,
                  publishAudio: vt.publishAudio,
                  publishVideo: vt.publishVideo,
                  audioSource: vt.audioSource,
                  showControls: vt.showControls,
                  shouldAllowAudio: un,
                  logAnalyticsEvent: fn
                });
                const Xd = () => {
                  this.off("publishComplete", sa), _r && _r.reset(), As.releaseAll(), this.disconnect(), ws = null, Di(), zr = null, Vi && (Vi.destroy(), Vi = null), this.session && this._.unpublishFromSession(this.session, "reset"), $o.getVideoFilter() && kd(), bc.destroy(), this.id = null, this.stream = null, re = !1, this.session = null, this.streamId = null, Zi.isDestroyed() || Zi.set("NotPublishing");
                }, to = () => {
                  if (!zr || zr.getVideoTracks().length === 0)
                    return !1;
                  const Ke = ["text", "detail"].includes(vt.videoContentHint), et = pn && Ke, dt = Et.env.isChromium && (ct || et);
                  return zr.getVideoTracks().reduce(($t, be) => $t && (!be.muted || !!dt) && be.enabled && be.readyState !== "ended", vt.publishVideo);
                }, Za = () => !zr || zr.getAudioTracks().length === 0 ? !1 : zr.getAudioTracks().length > 0 && zr.getAudioTracks().reduce((nt, Ke) => nt && !Ke.muted && Ke.enabled && Ke.readyState !== "ended", vt.publishAudio), sa = (nt) => {
                  if (Vi && (Vi.audioOnly(!to()), Vi.showPoster(!to())), _r && _r.setAudioOnly(!to() && Za()), this.stream) {
                    let Ke;
                    Ko && to() && (Ke = w.CongestionLevels.LOW, Ko = !1), this.stream.setChannelActiveState({
                      channelType: "audio",
                      activeState: Za(),
                      activeReason: nt
                    }), this.stream.setChannelActiveState({
                      channelType: "video",
                      activeState: to(),
                      activeReason: nt,
                      congestionLevel: Ke
                    });
                  } else
                    this.off("publishComplete", sa), this.once("publishComplete", sa);
                }, Ec = (nt, Ke) => {
                  let et = !1;
                  if (typeof nt == "function" ? Ke = nt : et = nt === "rtcStatsReport", et ? Jo() : Dl(), et && !Bt.default) {
                    const dt = Rt.GET_RTC_STATS_REPORT_NOT_SUPPORTED;
                    Ke(St(Or.GET_RTC_STATS_REPORT_NOT_SUPPORTED, new Error(Vt.getTitleByCode(dt)), dt));
                    return;
                  }
                  Ql().then((dt) => {
                    if (dt.length === 0) {
                      const $t = Rt.PEER_CONNECTION_NOT_CONNECTED;
                      throw St(Or.PEER_CONNECTION_NOT_CONNECTED, new Error(Vt.getTitleByCode($t)), $t);
                    }
                    return dt;
                  }).then((dt) => this.session.sessionInfo.isAdaptiveEnabled ? dt.filter((be) => be.getSourceStreamId() === Qi) : dt).then((dt) => n.all(dt.map(($t) => (et ? (0, $e.default)($t.getRtcStatsReport.bind($t)) : (0, $e.default)($t.getStats.bind($t)))().then((be) => ({
                    pc: $t,
                    stats: be
                  }))))).then((dt) => {
                    const $t = za ? za.getTime() : Date.now(), be = dt.map((ze) => {
                      let P = ze.pc, te = ze.stats;
                      const Re = ya(P), Qe = Re.remoteConnectionId, yt = Re.remoteSubscriberId;
                      return (0, h.default)(Qe.match(/^symphony\./) ? {} : {
                        subscriberId: yt,
                        connectionId: Qe
                      }, et ? {
                        rtcStatsReport: te
                      } : {
                        stats: _t.default.normalizeStats(te, !1, $t)
                      });
                    });
                    Ke(null, be);
                  }).catch(Ke);
                }, Fc = (nt) => Ec(nt), Cd = (nt) => Ec("rtcStatsReport", nt), Sl = (nt, Ke) => {
                  const et = {
                    name: vt.name || "",
                    streamId: this.streamId,
                    subscriberAudioFallbackEnabled: vt.subscriberAudioFallbackEnabled,
                    channels: ms,
                    minBitrate: vt.minVideoBitrate,
                    sourceStreamId: nt,
                    e2ee: this.session._.isE2ee(),
                    publisherAudioFallbackEnabled: vt.publisherAudioFallbackEnabled,
                    customProperties: {
                      initials: vt.initials
                    }
                  };
                  this.session._.streamCreate(et, Ke);
                }, Uo = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et;
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          return bn = !1, $t.next = 3, Sc();
                        case 3:
                          if (et = $t.sent, !et) {
                            $t.next = 18;
                            break;
                          }
                          return oi.trigger("sourceStreamIdChanged", "P2P"), vt.publisherAudioFallbackEnabled && et.disableCongestionLevelEstimation(), $t.next = 9, (0, K.default)(Ra);
                        case 9:
                          if (!bn) {
                            $t.next = 12;
                            break;
                          }
                          return Oe.debug("Cancelling stop sending RTP to MANTIS."), $t.abrupt("return");
                        case 12:
                          return bc.muteAudioInPeerConnection(zr, et), $t.next = 15, et.changeMediaDirectionToInactive();
                        case 15:
                          if (!(Et.env.isFirefox && Et.env.version < 96)) {
                            $t.next = 18;
                            break;
                          }
                          return $t.next = 18, Mc();
                        case 18:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }(), ja = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et, dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          return bn = !0, be.next = 3, Sc();
                        case 3:
                          if (et = be.sent, !et) {
                            be.next = 22;
                            break;
                          }
                          return bc.unmuteAudioInPeerConnection(zr, et), be.next = 8, et.changeMediaDirectionToRecvOnly();
                        case 8:
                          if (qt && clearTimeout(qt), oi.trigger("sourceStreamIdChanged", "MANTIS"), !vt.publisherAudioFallbackEnabled) {
                            be.next = 22;
                            break;
                          }
                          return be.t0 = et, be.next = 14, Cl();
                        case 14:
                          if (be.t1 = dt = be.sent, be.t1 != null) {
                            be.next = 19;
                            break;
                          }
                          be.t2 = void 0, be.next = 20;
                          break;
                        case 19:
                          be.t2 = dt.getAudioFallbackState();
                        case 20:
                          be.t3 = be.t2, be.t0.enableCongestionLevelEstimation.call(be.t0, be.t3);
                        case 22:
                        case "end":
                          return be.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }(), Mc = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et;
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          return $t.next = 2, Sc();
                        case 2:
                          et = $t.sent, et && (qt = setTimeout(/* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function be() {
                            return o.default.wrap(function(P) {
                              for (; ; ) switch (P.prev = P.next) {
                                case 0:
                                  if (Qi !== "P2P") {
                                    P.next = 9;
                                    break;
                                  }
                                  return P.next = 3, et.changeMediaDirectionToRecvOnly();
                                case 3:
                                  return P.next = 5, (0, K.default)(us);
                                case 5:
                                  return P.next = 7, et.changeMediaDirectionToInactive();
                                case 7:
                                  return P.next = 9, Mc();
                                case 9:
                                case "end":
                                  return P.stop();
                              }
                            }, be);
                          })), so));
                        case 4:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }(), td = () => {
                  ga("Attempt");
                  const nt = (et) => {
                    const dt = (0, on.default)(et);
                    this.trigger("streamCreateForP2PComplete", dt), ga("Failure", {
                      reason: dt.message
                    });
                  };
                  if (!this.session) {
                    ga("Failure", {
                      reason: "Not connected to the session."
                    });
                    return;
                  }
                  const Ke = setTimeout(() => {
                    ga("Failure", {
                      reason: "Timeout"
                    });
                  }, gn);
                  this.once("streamCreateForP2PComplete", () => {
                    clearTimeout(Ke);
                  }), Oe.debug(`streamCreateWithSource: send a message to RUMOR for creating the stream with the sourceStreaId P2P and stream ${this.streamId}`), Sl("P2P", (et) => {
                    et ? nt(et) : this.trigger("streamCreateForP2PComplete");
                  });
                }, Ud = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    return o.default.wrap(function(dt) {
                      for (; ; ) switch (dt.prev = dt.next) {
                        case 0:
                          if (Qi === "P2P") {
                            dt.next = 2;
                            break;
                          }
                          return dt.abrupt("return");
                        case 2:
                          if (aa("Attempt"), oi.session) {
                            dt.next = 6;
                            break;
                          }
                          return aa("Failure", {
                            reason: "Not connected to the session."
                          }), dt.abrupt("return");
                        case 6:
                          if (oi.streamId) {
                            dt.next = 9;
                            break;
                          }
                          return aa("Failure", {
                            reason: "No streamId available"
                          }), dt.abrupt("return");
                        case 9:
                          return dt.next = 11, ja();
                        case 11:
                          return oi.session._.streamDestroy(oi.streamId, "P2P"), dt.t0 = oi, dt.next = 15, Cl();
                        case 15:
                          dt.t1 = dt.sent, dt.t0._removePeerConnection.call(dt.t0, dt.t1), aa("Success"), oi.trigger("streamDestroyForP2PComplete");
                        case 19:
                        case "end":
                          return dt.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }();
                this.publish = (nt) => (Oe.debug("OT.Publisher: publish"), (Zi.isAttemptingToPublish() || Zi.isPublishing()) && Xd(), Zi.set("GetUserMedia"), vt.style && this.setStyle(vt.style, null, !0), vt.classNames = "OT_root OT_publisher", yi.onLoad(() => {
                  Oe.debug("OT.Publisher: publish: environment loaded"), Vi = new Jn(nt, Object.assign({}, vt, {
                    widgetType: "publisher"
                  })), un && (0, It.default)({
                    publisher: this,
                    widgetView: Vi
                  }), Vi.on("error", Td), this.id = Vi.domId(), this.element = Vi.domElement, this.element && _r && _r.init(Vi), Vi.on("videoDimensionsChanged", (Ke, et) => {
                    vt.publishVideo && (this.stream && this.stream.setVideoDimensions(et.width, et.height), this.dispatchEvent(new Ei.VideoDimensionsChangedEvent(this, Ke, et)));
                  }), Vi.on("mediaStopped", (Ke) => {
                    const et = new Ei.MediaStoppedEvent(this, Ke);
                    if (this.dispatchEvent(et), !et.isDefaultPrevented()) {
                      if (Ke) {
                        const dt = String(Ke.kind).toLowerCase();
                        dt === "audio" ? lc() : dt === "video" ? da() : Oe.warn(`Track with invalid kind has ended: ${Ke.kind}`);
                        return;
                      }
                      this.session ? this._.unpublishFromSession(this.session, "mediaStopped") : this.destroy("mediaStopped");
                    }
                  }), Vi.on("videoElementCreated", (Ke) => {
                    const et = new Ei.VideoElementCreatedEvent(Ke);
                    this.dispatchEvent(et);
                  }), gr().catch(ka).then(/* @__PURE__ */ function() {
                    var Ke = (0, l.default)(/* @__PURE__ */ o.default.mark(function et(dt) {
                      var $t;
                      return o.default.wrap(function(ze) {
                        for (; ; ) switch (ze.prev = ze.next) {
                          case 0:
                            return wl = Xe.audioDevices, ys = Xe.videoDevices, $t = !!vt.videoFilter, ps = (0, rr.default)(oi), $t && (Da = (0, Cn.default)(dt, ys)), ze.next = 7, Ml(dt);
                          case 7:
                            return vt.publishVideo || oi._toggleVideo(vt.publishVideo, wa()), !ct && !pn && !$t && (Da = (0, Cn.default)(dt, ys), vt.publishVideo && Md(Da)), ze.abrupt("return", Zl().catch((P) => {
                              if (!(P instanceof Q.CancellationError))
                                throw P;
                            }).then(() => {
                              Ci(), Zi.isDestroyed() || (oi.trigger("initSuccess"), oi.trigger("loaded", oi));
                            }, (P) => {
                              Oe.error(`OT.Publisher.publish failed to bind video: ${P}`), Ti(P);
                            }));
                          case 10:
                          case "end":
                            return ze.stop();
                        }
                      }, et);
                    }));
                    return function(et) {
                      return Ke.apply(this, arguments);
                    };
                  }());
                }), this), this._getVideoSenders = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function nt() {
                  return o.default.wrap(function(et) {
                    for (; ; ) switch (et.prev = et.next) {
                      case 0:
                        return et.abrupt("return", Ql().then((dt) => dt[0].getSenders().filter(($t) => $t.track.kind === "video")));
                      case 1:
                      case "end":
                        return et.stop();
                    }
                  }, nt);
                })), this._setScalableValues = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be, ze;
                    return o.default.wrap(function(te) {
                      for (; ; ) switch (te.prev = te.next) {
                        case 0:
                          return te.next = 2, oi._getVideoSenders();
                        case 2:
                          return $t = te.sent, be = $t[0], ze = be.getParameters(), ze.encodings.forEach((Re, Qe) => {
                            Re[et] = dt[Qe];
                          }), te.next = 8, be.setParameters(ze);
                        case 8:
                        case "end":
                          return te.stop();
                      }
                    }, Ke);
                  }));
                  return function(Ke, et) {
                    return nt.apply(this, arguments);
                  };
                }(), this._setScalabilityMode = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          return $t.abrupt("return", Ea(et, oi));
                        case 1:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }(), this._setScalableFramerates = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          if (dt = nd(et), !(dt && fl(dt))) {
                            be.next = 4;
                            break;
                          }
                          return be.next = 4, oi._setScalableValues("maxFramerate", dt);
                        case 4:
                        case "end":
                          return be.stop();
                      }
                    }, Ke);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }(), this._setScalableVideoLayers = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          if (dt = nd(et), !(dt && ou(dt))) {
                            be.next = 4;
                            break;
                          }
                          return be.next = 4, oi._setScalableValues("scaleResolutionDownBy", dt);
                        case 4:
                        case "end":
                          return be.stop();
                      }
                    }, Ke);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }();
                const fl = (nt) => {
                  let Ke = 0;
                  return nt.every((et) => et !== 15 && et !== 30 || et < Ke ? !1 : (Ke = et, !0));
                }, ou = (nt) => {
                  let Ke = 17;
                  return nt.every((et) => et < 1 || et >= Ke ? !1 : (Ke = et, !0));
                }, nd = (nt) => {
                  let Ke;
                  if (typeof nt != "string")
                    return Ke;
                  const et = nt.split(":");
                  return et.length === 0 || et.length > 3 || !et.every((dt) => !isNaN(dt)) || (Ke = et.map((dt) => parseInt(dt, 10)).reverse()), Ke;
                }, au = (nt) => zr && zr[`get${(0, m.default)(nt)}Tracks`]().length > 0 && zr[`get${(0, m.default)(nt)}Tracks`]().every((Ke) => Ke.readyState !== "ended"), lc = (nt) => {
                  const Ke = au("audio") && vt.publishAudio;
                  _r && _r.setMuted(!Ke), ws && ws.muted(!Ke), xn && xn.originalTrack && (xn.originalTrack.enabled = Ke), sa(nt);
                };
                this.publishAudio = (nt) => {
                  fn("publishAudio", "Attempt", {
                    publishAudio: nt
                  }), vt.publishAudio = nt;
                  try {
                    lc(), fn("publishAudio", "Success", {
                      publishAudio: nt
                    });
                  } catch (Ke) {
                    fn("publishAudio", "Failure", {
                      message: Ke.message
                    });
                  }
                  return this;
                }, this.publishCaptions = (nt) => {
                  fn("publishCaptions", "Attempt", {
                    publishCaptions: nt
                  });
                  try {
                    oa.dispatchEvent(new Ei.PublisherCaptionsEnabled(nt)), this.stream.setChannelActiveState({
                      channelType: "data",
                      activeState: nt
                    }), fn("publishCaptions", "Success", {
                      publishCaptions: nt
                    });
                  } catch (Ke) {
                    fn("publishCaptions", "Failure", {
                      message: Ke.message,
                      publishCaptions: nt
                    });
                  }
                };
                let Vc, _s = !1;
                const da = () => {
                  const nt = au("video") && vt.publishVideo;
                  if (L.default.name === "Chrome" && L.default.version >= 69 && (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et, dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          return Vc && Vc.cancel(), Vc = new Q.default(), et = Vc, be.next = 5, Ql();
                        case 5:
                          dt = be.sent, et.isCanceled() || dt.forEach((ze) => {
                            ze.setVideoActiveState(nt);
                          });
                        case 7:
                        case "end":
                          return be.stop();
                      }
                    }, Ke);
                  }))(), pn && $o) {
                    const Ke = $o.getOriginalVideoTrack();
                    Ke && (Ke.enabled = nt);
                  }
                  if (pn && hn) {
                    const Ke = hn.originalTrack;
                    Ke && (Ke.enabled = nt);
                  }
                  zr && zr.getVideoTracks().forEach((Ke) => {
                    Ke.enabled = nt, Ke.isCreatedCanvas && (Ke.enabled = !1);
                  }), sa();
                }, kd = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et;
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          return et = $o.getOriginalVideoTrack(), $t.prev = 1, $t.next = 4, $o.destroy();
                        case 4:
                          $t.next = 9;
                          break;
                        case 6:
                          $t.prev = 6, $t.t0 = $t.catch(1), Oe.warn(`Error cleaning up mediaProcessor: ${$t.t0}`);
                        case 9:
                          et.stop();
                        case 10:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke, null, [[1, 6]]);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }(), la = (nt) => (
                  // Track has been already updated by another call. This means cycleVideo, setVideoSource
                  // or clearVideoFilter has already got the track from the currentDeviceId, thus we don't
                  // need to duplicate the track from the same device.
                  // This does not apply when a videoFilter or mediaProcessorConnector is set, since we could need to get a track from
                  // the same device.
                  !ea && !hn && nt === su()
                ), cc = (nt, Ke) => ea || hn ? !0 : nt ? Da !== Ke : Ke !== void 0;
                let Da, ea, ec;
                this._toggleVideo = (0, de.default)(/* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be, ze, P, te, Re, Qe, yt;
                    return o.default.wrap(function(zt) {
                      for (; ; ) switch (zt.prev = zt.next) {
                        case 0:
                          if (!(ct || pn || _s)) {
                            zt.next = 2;
                            break;
                          }
                          return zt.abrupt("return");
                        case 2:
                          return zt.next = 4, od();
                        case 4:
                          if (be = zt.sent, ze = Dd(), ze) {
                            zt.next = 8;
                            break;
                          }
                          throw St(Or.NOT_SUPPORTED, new Error("Publisher._toggleVideo cannot toggleVideo when you have no video source."));
                        case 8:
                          if (P = ($t = be.find((rn) => rn.label === ze.label)) == null ? void 0 : $t.deviceId, cc(et, P)) {
                            zt.next = 11;
                            break;
                          }
                          return zt.abrupt("return");
                        case 11:
                          if (ze.readyState !== "ended") {
                            zt.next = 14;
                            break;
                          }
                          return _s = !0, zt.abrupt("return");
                        case 14:
                          if (et && Et.env.isAndroid && Et.env.isChrome && ze && ze.stop && ze.stop(), et) {
                            zt.next = 31;
                            break;
                          }
                          zt.prev = 16, te = (0, Sn.default)(dt), zt.next = 23;
                          break;
                        case 20:
                          return zt.prev = 20, zt.t0 = zt.catch(16), zt.abrupt("return");
                        case 23:
                          if (P && (Da = P), Md(te.label), Re = $o.getVideoFilter(), !Re) {
                            zt.next = 30;
                            break;
                          }
                          return ea = Re, zt.next = 30, kd();
                        case 30:
                          hn && (hn.destroy(), hn.stopOriginalTrack());
                        case 31:
                          if (!(Da && be.findIndex((rn) => rn.deviceId === Da) === -1)) {
                            zt.next = 33;
                            break;
                          }
                          throw St(Or.NO_DEVICES_FOUND, new Error("Previous device no longer available - deviceId not found"));
                        case 33:
                          if (oa.emit("streamDestroy"), !et) {
                            zt.next = 64;
                            break;
                          }
                          if (!la(Da)) {
                            zt.next = 37;
                            break;
                          }
                          return zt.abrupt("return");
                        case 37:
                          return zt.prev = 37, zt.next = 40, wd(Da);
                        case 40:
                          te = zt.sent, zt.next = 47;
                          break;
                        case 43:
                          throw zt.prev = 43, zt.t1 = zt.catch(37), Oe.error(`Error getting new track for current device(${Da}): ${zt.t1}`), zt.t1;
                        case 47:
                          if (te) {
                            zt.next = 50;
                            break;
                          }
                          return Oe.error("Failed to enable video. It was not possible to get a new track from the camera"), zt.abrupt("return");
                        case 50:
                          if (!ea) {
                            zt.next = 59;
                            break;
                          }
                          return Qe = $o.getOriginalVideoTrack(), zt.next = 54, $o.setVideoFilter(ea);
                        case 54:
                          return zt.next = 56, $o.setMediaStream(zr);
                        case 56:
                          return zt.next = 58, $o.setVideoTrack(te);
                        case 58:
                          te = zt.sent;
                        case 59:
                          if (!hn) {
                            zt.next = 64;
                            break;
                          }
                          return Qe = hn.originalTrack, zt.next = 63, hn.setTrack(te);
                        case 63:
                          te = zt.sent;
                        case 64:
                          return zt.prev = 64, zt.next = 67, id(ze, te);
                        case 67:
                          (yt = Qe) == null || yt.stop(), zt.next = 73;
                          break;
                        case 70:
                          throw zt.prev = 70, zt.t2 = zt.catch(64), zt.t2;
                        case 73:
                        case "end":
                          return zt.stop();
                      }
                    }, Ke, null, [[16, 20], [37, 43], [64, 70]]);
                  }));
                  return function(Ke, et) {
                    return nt.apply(this, arguments);
                  };
                }());
                const Yc = (0, Bi.callWithCancellation)(/* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t;
                    return o.default.wrap(function(ze) {
                      for (; ; ) switch (ze.prev = ze.next) {
                        case 0:
                          return ze.next = 2, Ql();
                        case 2:
                          $t = ze.sent, dt.isCanceled() || $t.forEach((P) => {
                            et ? P.enableCongestionLevelEstimation() : P.disableCongestionLevelEstimation();
                          });
                        case 4:
                        case "end":
                          return ze.stop();
                      }
                    }, Ke);
                  }));
                  return function(Ke, et) {
                    return nt.apply(this, arguments);
                  };
                }()), rd = () => {
                  var nt, Ke;
                  xc.reset(), (nt = _r) == null || nt.videoDisabledIndicator.disableVideo(!1), (Ke = _r) == null || Ke.videoDisabledIndicator.setWarning(!1);
                }, Lc = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t;
                    return o.default.wrap(function(ze) {
                      for (; ; ) switch (ze.prev = ze.next) {
                        case 0:
                          (dt = _r) == null || dt.videoDisabledIndicator.disableVideo(!1), ($t = _r) == null || $t.videoDisabledIndicator.setWarning(!1), et === J.default.SUSPENDED_VIDEO ? oi.trigger("videoEnabled", {
                            reason: "quality"
                          }) : oi.trigger("videoDisableWarningLifted");
                        case 3:
                        case "end":
                          return ze.stop();
                      }
                    }, Ke);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }(), fu = () => {
                  if (vt.publishVideo) {
                    var nt;
                    (nt = _r) == null || nt.videoDisabledIndicator.setWarning(!0);
                  }
                  this.trigger("videoDisableWarning");
                }, El = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et;
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          vt.publishVideo && ((et = _r) == null || et.videoDisabledIndicator.disableVideo(!0)), oi.trigger("videoDisabled", {
                            reason: "quality"
                          });
                        case 2:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }();
                let xc;
                if (vt.publisherAudioFallbackEnabled) {
                  xc = wt({
                    getAllPeerConnections: Ql
                  });
                  const nt = {
                    [J.default.ACTIVE_VIDEO]: Lc,
                    [J.default.ACTIVE_VIDEO_WITH_WARNING]: fu,
                    [J.default.SUSPENDED_VIDEO]: El
                  };
                  xc.on("stateChange", (Ke) => {
                    let et = Ke.previousState, dt = Ke.state;
                    try {
                      nt[dt](et);
                    } catch ($t) {
                      throw Oe.error(`Audio fallback error: ${$t}`), $t;
                    }
                  });
                }
                this.publishVideo = (nt) => {
                  if (vt.publishVideo === nt)
                    return this;
                  fn("publishVideo", "Attempt", {
                    publishVideo: nt
                  });
                  const Ke = wa();
                  vt.publishVideo = nt, vt.publisherAudioFallbackEnabled && (Yc(nt), nt === !1 && xc.getState() !== J.default.ACTIVE_VIDEO && (Ko = !0, rd()));
                  try {
                    this._toggleVideo(vt.publishVideo, Ke), da(), fn("publishVideo", "Success", {
                      publishVideo: nt
                    });
                  } catch (et) {
                    fn("publishVideo", "Failure", {
                      message: et.message
                    });
                  }
                  return this;
                }, this.setVideoContentHint = (nt) => {
                  ct && vt._setDefaultScalabilityMode && this._setScalabilityMode((0, Wo.default)(nt), this), (0, we.setVideoContentHint)(zr, nt);
                }, this.getVideoContentHint = () => (0, we.getVideoContentHint)(zr), this.destroy = function(nt, Ke) {
                  return Zi.isAttemptingToPublish() && this.session && Ro("Cancel", {
                    reason: "destroy"
                  }), Zi.isDestroyed() ? this : (Zi.set("Destroyed"), Xd(), Xe && (Xe.off(), Xe = null), _r && (_r.destroy(), _r = null), oa && (oa.off(), oa = null), Ke !== !0 && this.dispatchEvent(new Ei.DestroyedEvent(Te.default.PUBLISHER_DESTROYED, this, nt)), this.off(), hn && (hn.destroy(), hn.stopOriginalTrack()), xn && (xn.destroy(), xn.stopOriginalTrack()), ps !== void 0 && ps(), this);
                }, this.disconnect = () => {
                  Object.keys(ye).forEach((nt) => {
                    const Ke = Ds(nt);
                    delete ye[nt], Ke.then((et) => this._removePeerConnection(et));
                  }), ms.length = 0;
                }, this.processMessage = (nt, Ke, et) => {
                  const dt = (0, u.default)(et, "params.subscriber", Ke).replace(/^INVALID-STREAM$/, Ke), $t = (0, u.default)(et, "content.peerId"), be = (0, u.default)(et, "content.sourceStreamId", "MANTIS"), ze = `${dt}~${$t}~${be}`;
                  Oe.debug(`OT.Publisher.processMessage: Received ${nt} from ${Ke} for ${ze}`), Oe.debug(et);
                  const P = Ds(ze), te = () => {
                    const Qe = ti({
                      socket: this.session._.getSocket(),
                      uri: et.uri,
                      content: {
                        peerId: $t,
                        sourceStreamId: be
                      }
                    });
                    sc({
                      peerConnectionId: ze,
                      send: Qe,
                      log: function(rn, tr, Vn, si, ai) {
                        si === void 0 && (si = {});
                        const Ui = Object.assign({
                          peerId: $t,
                          sourceStreamId: (0, An.default)(be)
                        }, si);
                        return fn(rn, tr, Vn, Ui, ai);
                      },
                      logQoS: (zt) => {
                        be === Qi && Pi(Object.assign({}, zt, {
                          peerId: $t,
                          remoteConnectionId: Ke,
                          sourceStreamId: be
                        }));
                      },
                      sourceStreamId: be
                    }).then((zt) => (Fl(zt, {
                      remoteConnectionId: Ke,
                      remoteSubscriberId: dt,
                      peerId: $t,
                      sourceStreamId: be,
                      peerConnectionId: ze
                    }), zt.processMessage(nt, et), null)).catch((zt) => {
                      Oe.error("OT.Publisher failed to create a peerConnection", zt);
                    });
                  }, Re = this.session.sessionInfo.isAdaptiveEnabled;
                  switch (nt) {
                    case "unsubscribe":
                      this._removeSubscriber(dt);
                      break;
                    default:
                      if (P)
                        P.then((Qe) => Qe.processMessage(nt, et));
                      else {
                        if (Re && Cl())
                          return;
                        te();
                      }
                      break;
                  }
                }, this.getImgData = function() {
                  if (!re)
                    return Oe.error("OT.Publisher.getImgData: Cannot getImgData before the Publisher is publishing."), null;
                  const nt = Vi && Vi.video();
                  return nt ? nt.imgData() : null;
                };
                const _d = (nt) => {
                  Di(), zr = nt, oa.emit("streamChange"), ws = new Jt(zr, !vt.publishAudio);
                }, vo = (nt) => {
                  nt.getSenders().forEach((Ke) => {
                    if (Ke.track.kind === "audio" && zr.getAudioTracks().length)
                      return Ke.replaceTrack(zr.getAudioTracks()[0]);
                    if (Ke.track.kind === "video" && zr.getVideoTracks().length)
                      return Ke.replaceTrack(zr.getVideoTracks()[0]);
                  });
                }, co = function(Ke) {
                  return Ke === void 0 && (Ke = vo), Ql().then((et) => {
                    const dt = [];
                    return et.map(Ke), n.all(dt);
                  });
                };
                {
                  let nt = 0;
                  const Ke = /* @__PURE__ */ function() {
                    var et = (0, l.default)(/* @__PURE__ */ o.default.mark(function dt() {
                      var $t, be, ze, P, te;
                      return o.default.wrap(function(Qe) {
                        for (; ; ) switch (Qe.prev = Qe.next) {
                          case 0:
                            if (!(Et.env.isLegacyEdge || !Qr.RTCRtpSender || typeof Qr.RTCRtpSender.prototype.replaceTrack != "function")) {
                              Qe.next = 2;
                              break;
                            }
                            throw St(Or.UNSUPPORTED_BROWSER, new Error("Publisher#cycleVideo is not supported in your browser."), Rt.UNABLE_TO_PUBLISH);
                          case 2:
                            if (!(pn || ct)) {
                              Qe.next = 4;
                              break;
                            }
                            throw St(Or.NOT_SUPPORTED, new Error("Publisher#cycleVideo: The publisher is not using a camera video source"));
                          case 4:
                            if ($t = Dd(), $t) {
                              Qe.next = 7;
                              break;
                            }
                            throw St(Or.NOT_SUPPORTED, new Error("Publisher#cycleVideo cannot cycleVideo when you have no video source."));
                          case 7:
                            return nt += 1, Qe.next = 10, od();
                          case 10:
                            if (be = Qe.sent, ze = be.filter((yt) => yt.deviceId !== Da).length > 0, ze) {
                              Qe.next = 14;
                              break;
                            }
                            return Qe.abrupt("return", Da);
                          case 14:
                            for (; be[nt % be.length].deviceId === Da; )
                              nt += 1;
                            return oa.emit("streamDestroy"), P = be[nt % be.length], te = P.deviceId, Qe.next = 20, xl(te);
                          case 20:
                            return Qe.abrupt("return", Da);
                          case 21:
                          case "end":
                            return Qe.stop();
                        }
                      }, dt);
                    }));
                    return function() {
                      return et.apply(this, arguments);
                    };
                  }();
                  this.cycleVideo = (0, de.default)(/* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function et() {
                    var dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          return be.prev = 0, be.next = 3, Ke();
                        case 3:
                          dt = be.sent, be.next = 10;
                          break;
                        case 6:
                          throw be.prev = 6, be.t0 = be.catch(0), Oe.error(`Publisher#cycleVideo: could not cycle video: ${be.t0}`), be.t0;
                        case 10:
                          return be.abrupt("return", {
                            deviceId: dt
                          });
                        case 11:
                        case "end":
                          return be.stop();
                      }
                    }, et, null, [[0, 6]]);
                  })));
                }
                const id = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be, ze;
                    return o.default.wrap(function(te) {
                      for (; ; ) switch (te.prev = te.next) {
                        case 0:
                          return te.next = 2, Ql();
                        case 2:
                          return $t = te.sent, te.next = 5, n.all($t.map(/* @__PURE__ */ function() {
                            var Re = (0, l.default)(/* @__PURE__ */ o.default.mark(function Qe(yt) {
                              return o.default.wrap(function(zt) {
                                for (; ; ) switch (zt.prev = zt.next) {
                                  case 0:
                                    return zt.next = 2, yt.findAndReplaceTrack(et, dt);
                                  case 2:
                                    yt.setP2PMaxBitrate();
                                  case 3:
                                  case "end":
                                    return zt.stop();
                                }
                              }, Qe);
                            }));
                            return function(Qe) {
                              return Re.apply(this, arguments);
                            };
                          }()));
                        case 5:
                          if (zr.removeTrack(et), zr.addTrack(dt), et && et.stop) {
                            try {
                              be = dt instanceof MediaStreamTrackGenerator || Object.getPrototypeOf(dt).toString().includes("MediaStreamTrackGenerator");
                            } catch {
                              be = !1;
                            }
                            be || et.stop();
                          }
                          (Et.env.name === "Firefox" || Et.env.name === "Safari") && (oi.videoElement().srcObject = null, oi.videoElement().srcObject = zr), ze = Vi && Vi.video(), ze && ze.refreshTracks(), oa.emit("streamChange"), da();
                        case 13:
                        case "end":
                          return te.stop();
                      }
                    }, Ke);
                  }));
                  return function(et, dt) {
                    return nt.apply(this, arguments);
                  };
                }(), wd = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P, te, Re, Qe;
                    return o.default.wrap(function(Ht) {
                      for (; ; ) switch (Ht.prev = Ht.next) {
                        case 0:
                          return $t = su(), Md(et), be = (0, A.default)(hs), be.audioSource = null, be.videoSource = et, Xe = No(be, "OT.Publisher.getTrackFromDeviceId", () => Zi && Zi.isDestroyed()), Xe.on({
                            accessDialogOpened: jr,
                            accessDialogClosed: xe
                          }), ze = Xe, P = ze.getUserMedia, Ht.prev = 8, Ht.next = 11, P();
                        case 11:
                          te = Ht.sent, Ht.next = 18;
                          break;
                        case 14:
                          throw Ht.prev = 14, Ht.t0 = Ht.catch(8), Oe.error(Ht.t0), Ht.t0;
                        case 18:
                          return Re = (dt = te) == null ? void 0 : dt.getVideoTracks(), Qe = Re[0], Qe || Md($t), Ht.abrupt("return", Qe);
                        case 21:
                        case "end":
                          return Ht.stop();
                      }
                    }, Ke, null, [[8, 14]]);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }(), Dd = () => zr.getVideoTracks()[0], su = () => pr, Md = (nt) => {
                  pr = nt;
                }, od = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                    var et, dt;
                    return o.default.wrap(function(be) {
                      for (; ; ) switch (be.prev = be.next) {
                        case 0:
                          return be.next = 2, mr.shouldAskForDevices();
                        case 2:
                          if (et = be.sent, dt = et.videoDevices, !(!et.video || !dt || !dt.length)) {
                            be.next = 6;
                            break;
                          }
                          throw St(Or.NO_DEVICES_FOUND, new Error("No video devices available"), Rt.UNABLE_TO_PUBLISH);
                        case 6:
                          return be.abrupt("return", dt);
                        case 7:
                        case "end":
                          return be.stop();
                      }
                    }, Ke);
                  }));
                  return function() {
                    return nt.apply(this, arguments);
                  };
                }(), Je = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be, ze, P;
                    return o.default.wrap(function(Re) {
                      for (; ; ) switch (Re.prev = Re.next) {
                        case 0:
                          if (oi.session) {
                            Re.next = 2;
                            break;
                          }
                          return Re.abrupt("return");
                        case 2:
                          if ($t = oi.session.sessionInfo.isAdaptiveEnabled, !(Qi && $t)) {
                            Re.next = 17;
                            break;
                          }
                          return Re.next = 6, jd(Qi);
                        case 6:
                          return be = Re.sent, Re.next = 9, be == null ? void 0 : be.findAndReplaceTrack(et, dt);
                        case 9:
                          if (Qi !== "P2P") {
                            Re.next = 15;
                            break;
                          }
                          return Re.next = 12, Sc();
                        case 12:
                          return ze = Re.sent, Re.next = 15, bc.replaceTrackInMutedAudioTracks(ze, et, dt);
                        case 15:
                          Re.next = 22;
                          break;
                        case 17:
                          return Re.next = 19, Ql();
                        case 19:
                          return P = Re.sent, Re.next = 22, n.all(P.map((Qe) => Qe.findAndReplaceTrack(et, dt)));
                        case 22:
                        case "end":
                          return Re.stop();
                      }
                    }, Ke);
                  }));
                  return function(et, dt) {
                    return nt.apply(this, arguments);
                  };
                }(), Ne = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et, dt) {
                    var $t, be;
                    return o.default.wrap(function(P) {
                      for (; ; ) switch (P.prev = P.next) {
                        case 0:
                          if (et !== dt) {
                            P.next = 2;
                            break;
                          }
                          return P.abrupt("return");
                        case 2:
                          return P.next = 4, Je(et, dt);
                        case 4:
                          dt && zr.addTrack(dt), et && zr.removeTrack(et), $t = Vi && Vi.video(), $t && $t.refreshTracks(), _r && (dt && !et && _r.addAudioTrack(), et && !dt && _r.removeAudioTrack());
                          try {
                            be = dt instanceof MediaStreamTrackGenerator || Object.getPrototypeOf(dt).toString().includes("MediaStreamTrackGenerator");
                          } catch {
                            be = !1;
                          }
                          et && et.stop && !be && et.stop(), dt && (lc(), ws = new Jt(zr, !vt.publishAudio)), oa.emit("streamChange"), sa();
                        case 14:
                        case "end":
                          return P.stop();
                      }
                    }, Ke);
                  }));
                  return function(et, dt) {
                    return nt.apply(this, arguments);
                  };
                }(), qr = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t;
                    return o.default.wrap(function(ze) {
                      for (; ; ) switch (ze.prev = ze.next) {
                        case 0:
                          return dt = et.getSettings().deviceId, ze.prev = 1, ze.next = 4, oi.setAudioSource(dt);
                        case 4:
                          $t = zr.getAudioTracks()[0], $t && ($t.onmute = () => dc($t), $t.onunmute = () => sl($t)), ze.next = 11;
                          break;
                        case 8:
                          ze.prev = 8, ze.t0 = ze.catch(1), Oe.error(ze.t0);
                        case 11:
                        case "end":
                          return ze.stop();
                      }
                    }, Ke, null, [[1, 8]]);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }(), dc = (nt) => {
                  let Ke = !1;
                  vt.publishVideo && document.hidden && (Ke = !0, this.publishVideo(!1));
                  const et = /* @__PURE__ */ function() {
                    var dt = (0, l.default)(/* @__PURE__ */ o.default.mark(function $t() {
                      return o.default.wrap(function(ze) {
                        for (; ; ) switch (ze.prev = ze.next) {
                          case 0:
                            if (document.hidden) {
                              ze.next = 5;
                              break;
                            }
                            return ze.next = 3, qr(nt);
                          case 3:
                            Ke && oi.publishVideo(!0), document.removeEventListener("visibilitychange", et);
                          case 5:
                          case "end":
                            return ze.stop();
                        }
                      }, $t);
                    }));
                    return function() {
                      return dt.apply(this, arguments);
                    };
                  }();
                  document.addEventListener("visibilitychange", et);
                }, sl = (nt) => {
                  var Ke;
                  Za() && (to() ? this.videoElement().pause() : qr(nt)), this == null || (Ke = this.session) == null || Ke.trigger("gsmCallEnded");
                }, Ta = !(Et.env.isLegacyEdge || !Qr.RTCRtpSender || typeof Qr.RTCRtpSender.prototype.replaceTrack != "function"), $d = () => St(Or.UNSUPPORTED_BROWSER, new Error("Publisher#setAudioSource is not supported in your browser.")), Id = () => St(Or.CANCEL, new Error("Operation did not succeed due to a new request."));
                let $s;
                const _a = () => ($s && $s.cancel(), $s = new Q.default(), $s), no = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P, te, Re, Qe, yt, Ht, zt, rn;
                    return o.default.wrap(function(Vn) {
                      for (; ; ) switch (Vn.prev = Vn.next) {
                        case 0:
                          if (Ta) {
                            Vn.next = 2;
                            break;
                          }
                          throw $d();
                        case 2:
                          if (dt = _a(), $t = /* @__PURE__ */ function() {
                            var si = (0, l.default)(/* @__PURE__ */ o.default.mark(function ai(Ui) {
                              return o.default.wrap(function(xa) {
                                for (; ; ) switch (xa.prev = xa.next) {
                                  case 0:
                                    if (!dt.isCanceled()) {
                                      xa.next = 3;
                                      break;
                                    }
                                    throw Ui.getTracks((ll) => ll.stop()), Id();
                                  case 3:
                                    return xa.abrupt("return", no(Ui.getAudioTracks()[0]));
                                  case 4:
                                  case "end":
                                    return xa.stop();
                                }
                              }, ai);
                            }));
                            return function(Ui) {
                              return si.apply(this, arguments);
                            };
                          }(), be = oi.getAudioSource(), be) {
                            Vn.next = 7;
                            break;
                          }
                          throw St(Or.NOT_SUPPORTED, new Error("Publisher#setAudioSource cannot add an audio source when you started without one."));
                        case 7:
                          if (!(et instanceof MediaStreamTrack)) {
                            Vn.next = 26;
                            break;
                          }
                          if (!dt.isCanceled()) {
                            Vn.next = 10;
                            break;
                          }
                          throw Id();
                        case 10:
                          if (!xn) {
                            Vn.next = 23;
                            break;
                          }
                          return Vn.prev = 11, Vn.next = 14, xn.setTrack(et);
                        case 14:
                          return ze = Vn.sent, Vn.next = 17, Ne(be, ze);
                        case 17:
                          return Vn.abrupt("return", Vn.sent);
                        case 20:
                          Vn.prev = 20, Vn.t0 = Vn.catch(11), Oe.error(`Error setting track on audioMediaProcessorConnector: ${Vn.t0}`);
                        case 23:
                          return Vn.abrupt("return", Ne(be, et));
                        case 26:
                          if (typeof et != "string") {
                            Vn.next = 73;
                            break;
                          }
                          return P = (0, A.default)(hs), P.audioSource = et, P.videoSource = null, Xe = No(P, "OT.Publisher.setAudioSource", () => dt.isCanceled() || Zi && Zi.isDestroyed()), Xe.on({
                            accessDialogOpened: jr,
                            accessDialogClosed: xe
                          }), te = be.label, Re = be.getConstraints && be.getSettings().deviceId || void 0, be && be.stop(), Qe = Xe, yt = Qe.getUserMedia, Vn.prev = 36, Vn.t1 = $t, Vn.next = 40, yt();
                        case 40:
                          return Vn.t2 = Vn.sent, Vn.next = 43, (0, Vn.t1)(Vn.t2);
                        case 43:
                          return Vn.abrupt("return", Vn.sent);
                        case 46:
                          if (Vn.prev = 46, Vn.t3 = Vn.catch(36), !dt.isCanceled()) {
                            Vn.next = 50;
                            break;
                          }
                          throw Id();
                        case 50:
                          if (Ht = (0, A.default)(hs), Ht.videoSource = null, Ht.audioSource = Re, !(!Ht.audioSource && te)) {
                            Vn.next = 60;
                            break;
                          }
                          return Vn.next = 56, Sr();
                        case 56:
                          if (zt = Vn.sent.find((si) => si.label === te), !dt.isCanceled()) {
                            Vn.next = 59;
                            break;
                          }
                          throw Id();
                        case 59:
                          zt && (Ht.audioSource = zt.deviceId);
                        case 60:
                          if (Ht.audioSource) {
                            Vn.next = 63;
                            break;
                          }
                          throw Vn.t3.message += " (could not determine previous audio device)", St(Or.NOT_FOUND, Vn.t3);
                        case 63:
                          return Xe = No(Ht, "OT.Publisher.setAudioSource", () => dt.isCanceled() || Zi && Zi.isDestroyed()), Vn.next = 66, Xe.getUserMedia().catch((si) => {
                            throw si.message += " (could not obtain previous audio device)", si;
                          });
                        case 66:
                          return rn = Vn.sent, Vn.next = 69, $t(rn);
                        case 69:
                          throw Vn.t3.message += " (reverted to previous audio device)", Vn.t3;
                        case 71:
                          Vn.next = 74;
                          break;
                        case 73:
                          throw St(Or.INVALID_PARAMETER, new Error("Invalid parameter passed to OT.Publisher.setAudioSource(). Expected string or MediaStreamTrack."));
                        case 74:
                        case "end":
                          return Vn.stop();
                      }
                    }, Ke, null, [[11, 20], [36, 46]]);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }();
                this.setAudioSource = no, this.getAudioSource = () => zr && zr.getAudioTracks().length > 0 ? zr.getAudioTracks()[0] : null;
                const Bd = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function et(dt) {
                    var $t, be, ze, P, te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if ($t = St(Or.INVALID_VIDEO_SOURCE, new Error("Invalid video source. Video source must be a valid video input deviceId"), 1041), be = St(Or.SET_VIDEO_SOURCE_FAILURE, new Error("You cannot reset the video source on a publisher that does not currently use a camera source."), 1040), !(Et.env.isLegacyEdge || !Qr.RTCRtpSender || typeof Qr.RTCRtpSender.prototype.replaceTrack != "function")) {
                            Qe.next = 4;
                            break;
                          }
                          throw St(Or.UNSUPPORTED_BROWSER, new Error("setVideoSource is not supported in your browser."), Rt.UNABLE_TO_PUBLISH);
                        case 4:
                          if (typeof dt == "string") {
                            Qe.next = 6;
                            break;
                          }
                          throw $t;
                        case 6:
                          if (ze = !zr || zr.getVideoTracks().length === 0, !(pn || ct || ze)) {
                            Qe.next = 9;
                            break;
                          }
                          throw be;
                        case 9:
                          return Qe.next = 11, Sr();
                        case 11:
                          if (P = Qe.sent, te = P.find((yt) => yt.kind === "videoInput" && yt.deviceId === dt), te) {
                            Qe.next = 15;
                            break;
                          }
                          throw $t;
                        case 15:
                          return Qe.next = 17, xl(dt);
                        case 17:
                        case "end":
                          return Qe.stop();
                      }
                    }, et);
                  }));
                  function Ke(et) {
                    return nt.apply(this, arguments);
                  }
                  return Ke;
                }();
                this.setVideoSource = Bd;
                const xl = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P, te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if ($t = Da, Da = et, vt.publishVideo) {
                            Qe.next = 4;
                            break;
                          }
                          return Qe.abrupt("return");
                        case 4:
                          if (!la(et)) {
                            Qe.next = 6;
                            break;
                          }
                          return Qe.abrupt("return");
                        case 6:
                          if (be = Dd(), !(vt.publishVideo && Et.env.isAndroid && (Et.env.isChrome || Et.env.isFirefox))) {
                            Qe.next = 14;
                            break;
                          }
                          if (!ea) {
                            Qe.next = 13;
                            break;
                          }
                          return ze = ea, Qe.next = 12, kd();
                        case 12:
                          ea = null;
                        case 13:
                          be && be.stop && be.stop();
                        case 14:
                          return Qe.prev = 14, Qe.next = 17, wd(et);
                        case 17:
                          P = Qe.sent, Qe.next = 25;
                          break;
                        case 20:
                          throw Qe.prev = 20, Qe.t0 = Qe.catch(14), Da = $t, Oe.error(Qe.t0), Qe.t0;
                        case 25:
                          if (P) {
                            Qe.next = 28;
                            break;
                          }
                          return Oe.warn("Unable to aquire video track. Moving to next device."), Qe.abrupt("return");
                        case 28:
                          if (!ea) {
                            Qe.next = 33;
                            break;
                          }
                          return te = $o.getOriginalVideoTrack(), Qe.next = 32, $o.setVideoTrack(P);
                        case 32:
                          P = Qe.sent;
                        case 33:
                          if (!hn) {
                            Qe.next = 38;
                            break;
                          }
                          return te = hn.originalTrack, Qe.next = 37, hn.setTrack(P);
                        case 37:
                          P = Qe.sent;
                        case 38:
                          return Qe.next = 40, id(be, P);
                        case 40:
                          if (!ze) {
                            Qe.next = 43;
                            break;
                          }
                          return Qe.next = 43, oi.applyVideoFilter(ze);
                        case 43:
                          (dt = te) == null || dt.stop(), vt.publishVideo && (_s = !1);
                        case 45:
                        case "end":
                          return Qe.stop();
                      }
                    }, Ke, null, [[14, 20]]);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }();
                this.getVideoSource = () => {
                  const nt = {}, Ke = !zr || zr.getVideoTracks().length === 0;
                  return nt.track = zr && vt.publishVideo && zr.getVideoTracks()[0] || null, nt.deviceId = !ct && !pn && Da ? Da : null, pn ? nt.type = "custom" : ct ? nt.type = "screen" : Ke ? nt.type = null : nt.type = "camera", nt;
                }, this._ = {
                  privateEvents: oa,
                  setIceConfig(nt) {
                    return (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke() {
                      var et;
                      return o.default.wrap(function($t) {
                        for (; ; ) switch ($t.prev = $t.next) {
                          case 0:
                            return $t.next = 2, Ql();
                          case 2:
                            et = $t.sent, et.forEach((be) => be.setIceConfig(nt));
                          case 4:
                          case "end":
                            return $t.stop();
                        }
                      }, Ke);
                    }))();
                  },
                  publishToSession: (nt, Ke) => {
                    if (Zi.current === "PublishingToSession" || Zi.isPublishing())
                      return Oe.warn(`This publisher is already publishing to the session. If you want to
             republish, please unpublish first.`), n.resolve();
                    Ke && (gl = Ke), this.session = nt, Ya = nt, this.streamId = (0, U.default)(), Ro("Attempt", {
                      dataChannels: vt.channels,
                      properties: (0, Zt.default)(vt)
                    });
                    const dt = new n((te, Re) => {
                      if (re) {
                        te();
                        return;
                      }
                      this.once("initSuccess", te), this.once("destroyed", (Qe) => {
                        let yt = Qe.reason, Ht = "";
                        yt && (Ht = ` Reason: ${yt}`), Re(new Error(`Publisher destroyed before it finished loading.${Ht}`));
                      });
                    });
                    Oe.debug("publishToSession: waiting for publishComplete, which is triggered by stream#created from rumor");
                    const $t = () => {
                      if (vt._setDefaultScalabilityMode && vt.constraints.video) {
                        const te = this.getVideoContentHint();
                        let Re;
                        ct ? Re = (0, Wo.default)(te) : pn || (Re = "L3T2_KEY"), Re && this._setScalabilityMode(Re, this);
                      }
                    }, be = new n((te, Re) => {
                      this.once("publishComplete", (Qe) => {
                        if (Qe) {
                          Re(Qe);
                          return;
                        }
                        this._setScalableFramerates(vt.scalableFramerates), this._setScalableVideoLayers(vt.scalableVideoLayers), $t(), this.stream && (this.stream.setChannelActiveState({
                          channelType: "audio",
                          activeState: Za()
                        }), this.stream.setChannelActiveState({
                          channelType: "video",
                          activeState: to()
                        })), Oe.debug("publishToSession: got publishComplete"), te();
                      });
                    }), ze = (te) => {
                      const Re = (0, on.default)(te);
                      throw Ro("Failure", {}, {
                        failureReason: "Publish",
                        failureCode: Re.code,
                        failureMessage: Re.message
                      }), Zi.isAttemptingToPublish() && this.trigger("publishComplete", Re), Vt.handleJsException({
                        errorMsg: te.message,
                        code: Re.code,
                        target: this,
                        error: te,
                        analytics: gl
                      }), Re;
                    };
                    Oe.debug("publishToSession: waiting for loaded");
                    const P = dt.then(() => nt._.getVideoCodecsCompatible(zr)).then((te) => {
                      if (Oe.debug("publishToSession: loaded"), !this.session)
                        return;
                      const Re = setTimeout(() => {
                        kc(nt);
                      }, gn);
                      this.once("publishComplete", () => {
                        clearTimeout(Re);
                      }), Zi.set("PublishingToSession");
                      const Qe = te && Vi && Vi.video(), yt = zr.getVideoTracks().length > 0, Ht = vt.videoSource !== null && vt.videoSource !== !1;
                      Qe && yt && Ht && ms.push(new Ar({
                        id: "video1",
                        type: "video",
                        active: vt.publishVideo,
                        orientation: fr.ROTATED_NORMAL,
                        frameRate: vt.frameRate,
                        width: this.videoWidth(),
                        height: this.videoHeight(),
                        e2ee: nt._.isE2ee(),
                        source: ct ? "screen" : pn ? "custom" : "camera",
                        fitMode: vt.fitMode
                      }));
                      const zt = zr.getAudioTracks().length > 0;
                      return vt.audioSource !== null && vt.audioSource !== !1 && zt && (ms.push(new Ar({
                        id: "audio1",
                        type: "audio",
                        active: vt.publishAudio
                      })), ms.push(new Ar({
                        id: "caption1",
                        type: "data",
                        active: vt.publishCaptions
                      }))), Jd && ms.push(new Ar({
                        id: "downlinkStats1",
                        type: "data",
                        active: !0
                      })), this._.streamChannels = ms, Oe.debug("publishToSession: creating rumor stream id"), new n((tr, Vn) => {
                        Sl(null, (si, ai, Ui) => {
                          if (si) {
                            Vn(ze(si));
                            return;
                          }
                          tr({
                            streamId: ai,
                            message: Ui
                          });
                        });
                      });
                    }).then((te) => {
                      if (te === void 0)
                        return;
                      const Re = te.streamId, Qe = te.message;
                      if (Oe.debug("publishToSession: rumor stream id created:", Re, "(this is different from stream#created, which requires media to actually be flowing for mantis sessions)"), Re !== this.streamId)
                        throw new Error("streamId response does not match request");
                      this.streamId = Re, kl = Qn(Qe);
                    }).catch((te) => {
                      throw this.trigger("publishComplete", te), te;
                    });
                    return n.all([P, be]);
                  },
                  unpublishFromSession: (nt, Ke) => {
                    if (!this.session || nt.id !== this.session.id) {
                      if (Ke === "unpublished") {
                        const et = this.session && this.session.id || "no session";
                        Oe.warn(`The publisher ${ot} is trying to unpublish from a session ${nt.id} it is not attached to (it is attached to ${et})`);
                      }
                      return this;
                    }
                    if (nt.isConnected() && (this.stream || Zi.isAttemptingToPublish()) && nt._.streamDestroy(this.streamId), As.releaseAll(), this.disconnect(), Zi.isAttemptingToPublish()) {
                      Ro("Cancel", {
                        reason: "unpublish"
                      });
                      const et = () => {
                        switch (Ke) {
                          case "mediaStopped":
                            return "The video element fired the ended event, indicating there is an issue with the media";
                          case "unpublished":
                            return "The publisher was unpublished before it could be published";
                          case "reset":
                            return "The publisher was reset";
                          default:
                            return `The publisher was destroyed due to ${Ke}`;
                        }
                      }, dt = new Error(et());
                      this.trigger("publishComplete", St(Ke === "mediaStopped" ? Or.MEDIA_ENDED : Or.CANCEL, dt));
                    }
                    return fn("unpublish", "Success"), this._.streamDestroyed(Ke), this;
                  },
                  unpublishStreamFromSession: (nt, Ke, et) => nt.id !== this.streamId ? (Oe.warn(`The publisher ${ot} is trying to destroy a stream ${nt.id} that is not attached to it`), this) : this._.unpublishFromSession(Ke, et),
                  streamDestroyed: (nt) => {
                    ["reset"].indexOf(nt) < 0 && (Zi.isDestroyed() || Zi.set("MediaBound"));
                    const Ke = new Ei.StreamEvent("streamDestroyed", this.stream, nt, !0);
                    this.dispatchEventOnce(Ke, this.streamId), Ke.isDefaultPrevented() || this.destroy();
                  },
                  archivingStatus(nt) {
                    return _r && _r.setArchivingStatus(nt), nt;
                  },
                  webRtcStream() {
                    return zr;
                  },
                  switchTracks() {
                    return (0, l.default)(/* @__PURE__ */ o.default.mark(function nt() {
                      var Ke;
                      return o.default.wrap(function(dt) {
                        for (; ; ) switch (dt.prev = dt.next) {
                          case 0:
                            return dt.prev = 0, dt.next = 3, gr().catch(ka);
                          case 3:
                            Ke = dt.sent, dt.next = 10;
                            break;
                          case 6:
                            throw dt.prev = 6, dt.t0 = dt.catch(0), Oe.error(`OT.Publisher.switchTracks failed to getUserMedia: ${dt.t0}`), dt.t0;
                          case 10:
                            _d(Ke), dt.prev = 11, Zl(), dt.next = 21;
                            break;
                          case 15:
                            if (dt.prev = 15, dt.t1 = dt.catch(11), !(dt.t1 instanceof Q.CancellationError)) {
                              dt.next = 19;
                              break;
                            }
                            return dt.abrupt("return");
                          case 19:
                            throw Oe.error("Error while binding video", dt.t1), dt.t1;
                          case 21:
                            dt.prev = 21, co(), dt.next = 29;
                            break;
                          case 25:
                            throw dt.prev = 25, dt.t2 = dt.catch(21), Oe.error("Error replacing tracks", dt.t2), dt.t2;
                          case 29:
                          case "end":
                            return dt.stop();
                        }
                      }, nt, null, [[0, 6], [11, 15], [21, 25]]);
                    }))();
                  },
                  getDataChannel(nt, Ke, et) {
                    const dt = Ds(Object.keys(ye)[0]);
                    if (!dt) {
                      et(new Et.Error("Cannot create a DataChannel before there is a subscriber."));
                      return;
                    }
                    dt.then(($t) => {
                      $t.getDataChannel(nt, Ke, et);
                    });
                  },
                  iceRestart(nt) {
                    nt === void 0 && (nt = !1), Ql().then((Ke) => {
                      Ke.forEach((et) => {
                        const dt = ya(et), $t = dt.remoteConnectionId;
                        ca("Attempt", {
                          remoteConnectionId: $t
                        }), Oe.debug("Publisher: ice restart attempt"), et.iceRestart(), nt && et.generateOffer();
                      });
                    });
                  },
                  getState() {
                    return Zi;
                  },
                  demoOnlyCycleVideo: this.cycleVideo,
                  testOnlyGetFramesEncoded() {
                    return (0, l.default)(/* @__PURE__ */ o.default.mark(function nt() {
                      var Ke;
                      return o.default.wrap(function(dt) {
                        for (; ; ) switch (dt.prev = dt.next) {
                          case 0:
                            return dt.next = 2, Ql();
                          case 2:
                            if (Ke = dt.sent, Ke.length) {
                              dt.next = 5;
                              break;
                            }
                            throw new Error("No established PeerConnections yet");
                          case 5:
                            return dt.abrupt("return", Ke[0]._testOnlyGetFramesEncoded());
                          case 6:
                          case "end":
                            return dt.stop();
                        }
                      }, nt);
                    }))();
                  },
                  onStreamAvailable: Ml,
                  startRoutedToRelayedTransition: () => {
                    Xa.startTransitionToRelayed(), td();
                  },
                  startRelayedToRoutedTransition: () => {
                    Xa.startTransitionToRouted(Ud);
                  },
                  forceMuteAudio: function() {
                    fn("publishAudio", "Attempt", {
                      publishAudio: !1
                    }), vt.publishAudio = !1;
                    try {
                      lc("auto"), this.dispatchEvent(new Ei.MuteForcedEvent()), fn("publishAudio", "Success", {
                        publishAudio: !1
                      });
                    } catch (nt) {
                      fn("publishAudio", "Failure", {
                        message: nt.message
                      });
                    }
                  }.bind(this),
                  setCongestionLevel: function() {
                    var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function et(dt, $t) {
                      var be;
                      return o.default.wrap(function(P) {
                        for (; ; ) switch (P.prev = P.next) {
                          case 0:
                            if (!xc) {
                              P.next = 15;
                              break;
                            }
                            if (!$t) {
                              P.next = 8;
                              break;
                            }
                            return P.next = 4, Ds($t);
                          case 4:
                            P.t1 = P.sent, P.t0 = [P.t1], P.next = 11;
                            break;
                          case 8:
                            return P.next = 10, Ql();
                          case 10:
                            P.t0 = P.sent;
                          case 11:
                            be = P.t0, be.forEach((te) => {
                              te.setCongestionLevel(dt);
                            }), P.next = 16;
                            break;
                          case 15:
                            Oe.warn("Audio Fallback is not enabled");
                          case 16:
                          case "end":
                            return P.stop();
                        }
                      }, et);
                    }));
                    function Ke(et, dt) {
                      return nt.apply(this, arguments);
                    }
                    return Ke;
                  }()
                }, this.detectDevices = function() {
                  Oe.warn("Publisher.detectDevices() is not implemented.");
                }, this.detectMicActivity = function() {
                  Oe.warn("Publisher.detectMicActivity() is not implemented.");
                }, this.getEchoCancellationMode = function() {
                  return Oe.warn("Publisher.getEchoCancellationMode() is not implemented."), "fullDuplex";
                }, this.setMicrophoneGain = function() {
                  Oe.warn("Publisher.setMicrophoneGain() is not implemented.");
                }, this.getMicrophoneGain = function() {
                  return Oe.warn("Publisher.getMicrophoneGain() is not implemented."), 0.5;
                }, this.setCamera = function() {
                  Oe.warn("Publisher.setCamera() is not implemented.");
                }, this.setMicrophone = function() {
                  Oe.warn("Publisher.setMicrophone() is not implemented.");
                }, this.guid = function() {
                  return ot;
                }, this.videoElement = function() {
                  const nt = Vi && Vi.video();
                  return nt ? nt.domElement() : null;
                }, this.setStream = ed, this.isWebRTC = !0, this.isLoading = function() {
                  return Vi && Vi.loading();
                }, this.videoWidth = () => wa().width, this.videoHeight = () => wa().height, this.getStats = function(Ke) {
                  Fc((et, dt) => {
                    et ? Ke(et) : Ke(null, dt);
                  });
                }, this.getRtcStatsReport = () => new n((nt, Ke) => {
                  Cd((et, dt) => {
                    et ? Ke(et) : nt(dt);
                  });
                }), Zi = new On(yl), this.accessAllowed = !1, this.applyVideoFilter = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P, te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if (dt = (0, pt.default)(et), fn("applyVideoFilter", "Attempt", {
                            videoFilter: dt
                          }), Qe.prev = 2, !hn) {
                            Qe.next = 5;
                            break;
                          }
                          throw St(Or.NOT_SUPPORTED, new Error("Cannot apply video filter when videoMediaProcessorConnector is set."));
                        case 5:
                          if ($t = Wn.isSupported(), $t) {
                            Qe.next = 8;
                            break;
                          }
                          throw St(Or.NOT_SUPPORTED, new Error("Browser does not support video filters (Insertable Streams and Worker APIs are required)"));
                        case 8:
                          if ($o.isValidVideoFilter(et)) {
                            Qe.next = 10;
                            break;
                          }
                          throw St(Or.INVALID_PARAMETER, new Error("Video filter has invalid configuration"));
                        case 10:
                          if (zr) {
                            Qe.next = 15;
                            break;
                          }
                          return be = "Ignoring. No mediaStream", fn("applyVideoFilter", "Failure", {
                            message: be
                          }), Oe.warn(be), Qe.abrupt("return");
                        case 15:
                          if (!ct) {
                            Qe.next = 17;
                            break;
                          }
                          throw St(Or.INVALID_PARAMETER, new Error("Video filters can not be applied to screen share"));
                        case 17:
                          if (Fr(), vt.publishVideo) {
                            Qe.next = 22;
                            break;
                          }
                          return ea = et, fn("applyVideoFilter", "Success", {
                            videoFilter: dt
                          }), Qe.abrupt("return");
                        case 22:
                          if (!$o.getVideoFilter()) {
                            Qe.next = 37;
                            break;
                          }
                          if (!$o.canUpdateVideoFilter(et.type)) {
                            Qe.next = 35;
                            break;
                          }
                          return Qe.prev = 24, Qe.next = 27, $o.updateVideoFilter(et);
                        case 27:
                          return ea = et, fn("applyVideoFilter", "Success", {
                            videoFilter: dt
                          }), Qe.abrupt("return");
                        case 32:
                          Qe.prev = 32, Qe.t0 = Qe.catch(24), Oe.warn(`Error updating video filter: ${Qe.t0}`);
                        case 35:
                          return Qe.next = 37, oi.clearVideoFilter();
                        case 37:
                          if (ze = zr.getVideoTracks(), P = ze[0], P) {
                            Qe.next = 43;
                            break;
                          }
                          return be = "Ignoring. No video", fn("applyVideoFilter", "Failure", {
                            message: be
                          }), Oe.warn(be), Qe.abrupt("return");
                        case 43:
                          return Qe.next = 45, $o.setVideoFilter(et);
                        case 45:
                          return Qe.next = 47, $o.setMediaStream(zr);
                        case 47:
                          if (te = Qe.sent, !te) {
                            Qe.next = 51;
                            break;
                          }
                          return Qe.next = 51, id(P, te);
                        case 51:
                          Qe.next = 58;
                          break;
                        case 53:
                          throw Qe.prev = 53, Qe.t1 = Qe.catch(2), Oe.error(`Error applying video filter: ${Qe.t1}`), fn("applyVideoFilter", "Failure", {
                            message: Qe.t1.message
                          }), Qe.t1;
                        case 58:
                          ea = et, fn("applyVideoFilter", "Success", {
                            videoFilter: dt
                          });
                        case 60:
                        case "end":
                          return Qe.stop();
                      }
                    }, Ke, null, [[2, 53], [24, 32]]);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }(), this.getVideoFilter = () => (fn("getVideoFilter", "Attempt"), fn("getVideoFilter", "Success"), ea || null), this.applyAudioFilter = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P, te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if (fn("applyAudioFilter", "Attempt", {
                            audioFilter: et
                          }), dt = Wn.isSupported(), dt) {
                            Qe.next = 4;
                            break;
                          }
                          throw St(Or.NOT_SUPPORTED, new Error("Browser does not support audio filters (Insertable Streams and Worker APIs are required)"));
                        case 4:
                          if ((0, Yr.default)(et)) {
                            Qe.next = 6;
                            break;
                          }
                          throw St(Or.INVALID_PARAMETER, new Error("Audio filter has invalid configuration"));
                        case 6:
                          if (!xn) {
                            Qe.next = 8;
                            break;
                          }
                          throw St(Or.NOT_SUPPORTED, new Error("Cannot apply audio filter when audioMediaProcessorConnector is set."));
                        case 8:
                          if (zr) {
                            Qe.next = 13;
                            break;
                          }
                          return $t = "Ignoring. No mediaStream", fn("applyAudioFilter", "Failure", {
                            message: $t
                          }), Oe.warn($t), Qe.abrupt("return");
                        case 13:
                          if (vt.publishAudio) {
                            Qe.next = 17;
                            break;
                          }
                          return ec = et, fn("applyAudioFilter", "Success", {
                            audioFilter: et
                          }), Qe.abrupt("return");
                        case 17:
                          if (!oi.getAudioFilter()) {
                            Qe.next = 20;
                            break;
                          }
                          return Qe.next = 20, oi.clearAudioFilter();
                        case 20:
                          if (Qe.prev = 20, et.type !== "advancedNoiseSuppression") {
                            Qe.next = 32;
                            break;
                          }
                          return be = Qo.default.getConfig({
                            library: "noise-suppression",
                            proxyUrl: (0, Fa.getProxyUrl)()
                          }), ze = be.assetsDirBaseUrl, P = Ho(), Qe.next = 26, P.init({
                            assetsDirBaseUrl: ze
                          });
                        case 26:
                          return Qe.next = 28, P.getConnector();
                        case 28:
                          return te = Qe.sent, Qe.next = 31, Yd(te);
                        case 31:
                          ec = et;
                        case 32:
                          Qe.next = 39;
                          break;
                        case 34:
                          throw Qe.prev = 34, Qe.t0 = Qe.catch(20), Oe.error(`Error applying audio filter: ${Qe.t0}`), fn("applyAudioFilter", "Failure", {
                            message: Qe.t0.message
                          }), Qe.t0;
                        case 39:
                          fn("applyAudioFilter", "Success");
                        case 40:
                        case "end":
                          return Qe.stop();
                      }
                    }, Ke, null, [[20, 34]]);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }(), this.clearAudioFilter = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function nt() {
                  var Ke;
                  return o.default.wrap(function(dt) {
                    for (; ; ) switch (dt.prev = dt.next) {
                      case 0:
                        if (fn("clearAudioFilter", "Attempt"), !(!vt.publishAudio && oi.getAudioFilter())) {
                          dt.next = 5;
                          break;
                        }
                        return ec = null, fn("clearAudioFilter", "Success"), dt.abrupt("return");
                      case 5:
                        if (Wn.isSupported()) {
                          dt.next = 10;
                          break;
                        }
                        return Ke = 'Ignoring. "clearAudioFilter" not supported.', fn("clearAudioFilter", "Success", {
                          message: Ke
                        }), Oe.warn(Ke), dt.abrupt("return");
                      case 10:
                        if (oi.getAudioFilter()) {
                          dt.next = 15;
                          break;
                        }
                        return Ke = "Ignoring. No audio filter applied", fn("clearAudioFilter", "Success", {
                          message: Ke
                        }), Oe.debug(Ke), dt.abrupt("return");
                      case 15:
                        if (zr) {
                          dt.next = 20;
                          break;
                        }
                        return Ke = "Ignoring. No mediaStream", fn("clearAudioFilter", "Success", {
                          message: Ke
                        }), Oe.warn(Ke), dt.abrupt("return");
                      case 20:
                        return dt.prev = 20, dt.next = 23, Yd(null);
                      case 23:
                        ec = null, dt.next = 30;
                        break;
                      case 26:
                        return dt.prev = 26, dt.t0 = dt.catch(20), fn("clearAudioFilter", "Failure", {
                          error: dt.t0
                        }), dt.abrupt("return");
                      case 30:
                        fn("clearAudioFilter", "Success");
                      case 31:
                      case "end":
                        return dt.stop();
                    }
                  }, nt, null, [[20, 26]]);
                })), this.getAudioFilter = () => (fn("getAudioFilter", "Attempt"), fn("getAudioFilter", "Success"), ec || null), this.setVideoMediaProcessorConnector = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P, te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if (fn("setVideoMediaProcessorConnector", "Attempt", {
                            message: et ? "setting the connector" : "clearing the connector"
                          }), !oi.getVideoFilter()) {
                            Qe.next = 4;
                            break;
                          }
                          throw fn("setVideoMediaProcessorConnector", "Failure", {
                            message: "Tried to set video MediaProcessorConnector when video filter applied."
                          }), St(Or.NOT_SUPPORTED, new Error("setVideoMediaProcessorConnector: Cannot use this method when videoFilter is set."));
                        case 4:
                          if (!hn) {
                            Qe.next = 14;
                            break;
                          }
                          return dt = zr.getVideoTracks(), $t = dt[0], Qe.next = 8, wd(Da);
                        case 8:
                          return be = Qe.sent, Qe.next = 11, id($t, be);
                        case 11:
                          hn.destroy(), hn.stopOriginalTrack(), hn = null;
                        case 14:
                          if (et) {
                            Qe.next = 17;
                            break;
                          }
                          return fn("setVideoMediaProcessorConnector", "Success", {
                            message: "clearing the connector"
                          }), Qe.abrupt("return");
                        case 17:
                          if (Hi.isValidConnector(et)) {
                            Qe.next = 20;
                            break;
                          }
                          throw fn("setVideoMediaProcessorConnector", "Failure", {
                            message: "Invalid MediaProcessorConnector"
                          }), St(Or.INVALID_PARAMETER, new Error("setVideoMediaProcessorConnector:  Tried to set invalid MediaProcessorConnector"));
                        case 20:
                          if (hn = new Hi(et), ze = zr.getVideoTracks(), P = ze[0], P) {
                            Qe.next = 28;
                            break;
                          }
                          return te = "Connector not set as no video track is present.", fn("setVideoMediaProcessorConnector", "Failure", {
                            message: te
                          }), Oe.warn(`setVideoMediaProcessorConnector: ${te}`), hn = null, Qe.abrupt("return");
                        case 28:
                          return Qe.prev = 28, Qe.next = 31, hn.setTrack(P);
                        case 31:
                          return $t = Qe.sent, Qe.next = 34, id(P, $t);
                        case 34:
                          Qe.next = 42;
                          break;
                        case 36:
                          throw Qe.prev = 36, Qe.t0 = Qe.catch(28), hn = null, Oe.error(`setVideoMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${Qe.t0}`), fn("setVideoMediaProcessorConnector", "Failure", {
                            message: Qe.t0.message
                          }), Qe.t0;
                        case 42:
                          fn("setVideoMediaProcessorConnector", "Success");
                        case 43:
                        case "end":
                          return Qe.stop();
                      }
                    }, Ke, null, [[28, 36]]);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }(), this.setAudioMediaProcessorConnector = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    return o.default.wrap(function($t) {
                      for (; ; ) switch ($t.prev = $t.next) {
                        case 0:
                          return fn("setAudioMediaProcessorConnector", "Attempt", {
                            message: et ? "setting the connector" : "clearing the connector"
                          }), $t.prev = 1, $t.next = 4, Yd(et);
                        case 4:
                          fn("setAudioMediaProcessorConnector", "Success", {
                            message: et ? void 0 : "clearing the connector"
                          }), $t.next = 11;
                          break;
                        case 7:
                          throw $t.prev = 7, $t.t0 = $t.catch(1), fn("setAudioMediaProcessorConnector", "Failure", {
                            message: $t.t0.message
                          }), $t.t0;
                        case 11:
                        case "end":
                          return $t.stop();
                      }
                    }, Ke, null, [[1, 7]]);
                  }));
                  return function(Ke) {
                    return nt.apply(this, arguments);
                  };
                }();
                const Yd = /* @__PURE__ */ function() {
                  var nt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ke(et) {
                    var dt, $t, be, ze, P;
                    return o.default.wrap(function(Re) {
                      for (; ; ) switch (Re.prev = Re.next) {
                        case 0:
                          if (!(oi.getAudioFilter() && et)) {
                            Re.next = 3;
                            break;
                          }
                          throw dt = "Tried to set audio MediaProcessorConnector when audio filter applied.", St(Or.NOT_SUPPORTED, new Error(dt));
                        case 3:
                          if (!xn) {
                            Re.next = 9;
                            break;
                          }
                          return $t = zr.getAudioTracks(), be = $t[0], Re.next = 7, Ne(be, xn.originalTrack);
                        case 7:
                          xn.destroy(), xn = null;
                        case 9:
                          if (et) {
                            Re.next = 11;
                            break;
                          }
                          return Re.abrupt("return");
                        case 11:
                          if (Hi.isValidConnector(et)) {
                            Re.next = 14;
                            break;
                          }
                          throw dt = "Invalid MediaProcessorConnector", St(Or.INVALID_PARAMETER, new Error(dt));
                        case 14:
                          if (ze = zr.getAudioTracks(), P = ze[0], P) {
                            Re.next = 20;
                            break;
                          }
                          throw dt = "Connector not set as no audio track is present.", Oe.warn(`setAudioMediaProcessorConnector: ${dt}`), xn = null, new Error(dt);
                        case 20:
                          return xn = new Hi(et), Re.prev = 21, Re.next = 24, xn.setTrack(P);
                        case 24:
                          return be = Re.sent, Re.next = 27, Ne(oi.getAudioSource(), be);
                        case 27:
                          Re.next = 34;
                          break;
                        case 29:
                          throw Re.prev = 29, Re.t0 = Re.catch(21), xn = null, Oe.error(`setAudioMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${Re.t0}`), Re.t0;
                        case 34:
                        case "end":
                          return Re.stop();
                      }
                    }, Ke, null, [[21, 29]]);
                  }));
                  return function(et) {
                    return nt.apply(this, arguments);
                  };
                }();
                this.clearVideoFilter = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function nt() {
                  var Ke, et, dt, $t, be;
                  return o.default.wrap(function(P) {
                    for (; ; ) switch (P.prev = P.next) {
                      case 0:
                        if (fn("clearVideoFilter", "Attempt"), !(!vt.publishVideo && !$o.getVideoFilter())) {
                          P.next = 5;
                          break;
                        }
                        return ea = null, fn("clearVideoFilter", "Success"), P.abrupt("return");
                      case 5:
                        if (!(!$o.getVideoFilter() && !ea)) {
                          P.next = 10;
                          break;
                        }
                        return Ke = "Ignoring. No video filter applied", fn("clearVideoFilter", "Success", {
                          message: Ke
                        }), Oe.debug(Ke), P.abrupt("return");
                      case 10:
                        if (Wn.isSupported()) {
                          P.next = 15;
                          break;
                        }
                        return Ke = 'Ignoring. "clearVideoFilter" not supported.', fn("clearVideoFilter", "Success", {
                          message: Ke
                        }), Oe.warn(Ke), P.abrupt("return");
                      case 15:
                        if (zr) {
                          P.next = 20;
                          break;
                        }
                        return Ke = "Ignoring. No mediaStream", fn("clearVideoFilter", "Success", {
                          message: Ke
                        }), Oe.warn(Ke), P.abrupt("return");
                      case 20:
                        return et = ea, ea = null, dt = zr.getVideoTracks(), $t = dt[0], P.prev = 23, P.next = 26, wd(Da);
                      case 26:
                        be = P.sent, P.next = 33;
                        break;
                      case 29:
                        return P.prev = 29, P.t0 = P.catch(23), Oe.error(P.t0), P.abrupt("return");
                      case 33:
                        if (be) {
                          P.next = 36;
                          break;
                        }
                        return Oe.warn("Failed to clear filter because there is no video track."), P.abrupt("return");
                      case 36:
                        return P.prev = 36, P.next = 39, id($t, be);
                      case 39:
                        return P.next = 41, kd();
                      case 41:
                        P.next = 46;
                        break;
                      case 43:
                        P.prev = 43, P.t1 = P.catch(36), ea = et;
                      case 46:
                        fn("clearVideoFilter", "Success");
                      case 47:
                      case "end":
                        return P.stop();
                    }
                  }, nt, null, [[23, 29], [36, 43]]);
                }));
              };
            }
          }).call(this, e(2));
        },
        /* 179 */
        /***/
        function(i, r) {
          function e(n) {
            if (n === void 0)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return n;
          }
          i.exports = e;
        },
        /* 180 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(103)), o = n(e(3));
          const l = (u, h, A) => {
            let g;
            const v = h === "noise-suppression" ? "noise-suppression/v1.0.0" : "ml-transformers/v4.0.0";
            return A.isProd ? g = "https://static.opentok.com" : A.isRel ? g = "https://static.rel.tokbox.com" : g = "https://www.dev.tokbox.com", u && (u.includes("euproxy.opentok.com") ? g = "https://static-eu.opentok.com" : g = (0, t.default)(g, u)), `${g}/${v}`;
          };
          var d = {
            getConfig: function(h) {
              h === void 0 && (h = {});
              const A = h, g = A.proxyUrl, f = A.library, p = A.env, v = p === void 0 ? o.default : p, b = l(g, f, v);
              return {
                mediapipeBaseAssetsUri: `${b}`,
                wasmAssetUriPath: `${b}/`,
                tfliteAssetUriPath: `${b}/`,
                assetsDirBaseUrl: `${b}`
              };
            }
          };
          r.default = d;
        },
        /* 181 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(112)), o = n(e(52));
          const l = o.default.once;
          function c(d, u) {
            u === void 0 && (u = {});
            const h = u.hasE2eeCapability || t.default, A = u.hasOpenTokSupport || l;
            this.publish = d.indexOf("publish") !== -1 ? 1 : 0, this.subscribe = d.indexOf("subscribe") !== -1 ? 1 : 0, this.forceUnpublish = d.indexOf("forceunpublish") !== -1 ? 1 : 0, this.forceDisconnect = d.indexOf("forcedisconnect") !== -1 ? 1 : 0, this.forceMute = d.indexOf("forcemute") !== -1 ? 1 : 0, this.supportsE2ee = h() ? 1 : 0, this.supportsWebRTC = A() ? 1 : 0, this.permittedTo = (g) => Object.prototype.hasOwnProperty.call(this, g) && this[g] === 1;
          }
        },
        /* 182 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = g;
          var t = n(e(6)), o = n(e(1)), l = n(e(24)), c = n(e(7)), d = n(e(23));
          const u = (0, o.default)("Stream"), h = (0, d.default)(), A = ["name", "archiving"];
          function g(f, p, v, b, m, y, U) {
            const B = this;
            let Q;
            this.id = f, this.streamId = f, this.name = p, this.creationTime = Number(v), this.initials = U || "", this.connection = b, this.channel = y, this.publisher = l.default.publishers.find({
              streamId: this.id
            }), (0, t.default)(this);
            const N = function(L, O, de, oe) {
              let fe = O;
              switch (fe) {
                case "active":
                  fe = L.type === "audio" ? "hasAudio" : "hasVideo", B[fe] = oe;
                  break;
                case "disableWarning":
                  if (fe = L.type === "audio" ? "audioDisableWarning" : "videoDisableWarning", B[fe] = oe, !B[L.type === "audio" ? "hasAudio" : "hasVideo"])
                    return;
                  break;
                case "fitMode":
                  fe = "defaultFitMode", B[fe] = oe;
                  break;
                case "source":
                  fe = L.type === "audio" ? "audioType" : "videoType", B[fe] = oe;
                  break;
                case "videoDimensions":
                  B.videoDimensions = oe;
                  break;
                case "orientation":
                case "width":
                case "height":
                  return;
              }
              B.dispatchEvent(new h.StreamUpdatedEvent(B, fe, de, oe));
            }, J = function() {
              return B.publisher ? B.publisher : l.default.subscribers.find((L) => L.stream && L.stream.id === B.id && L.session.id === m.id);
            }, w = function() {
              return !B.publisher;
            };
            this.getChannelsOfType = function(L) {
              return B.channel.filter((O) => O.type === L);
            }, this.getChannel = function(L) {
              for (let O = 0; O < B.channel.length; ++O)
                if (B.channel[O].id === L)
                  return B.channel[O];
              return null;
            };
            const W = this.getChannelsOfType("audio")[0], G = this.getChannelsOfType("video")[0];
            this.hasAudio = W != null && W.active, this.hasVideo = G != null && G.active, this.videoType = G && G.source, this.defaultFitMode = G && G.fitMode, this.videoDimensions = {}, G && (this.videoDimensions.width = G.width, this.videoDimensions.height = G.height, this.videoDimensions.orientation = G.orientation, G.on("update", N), this.frameRate = G.frameRate), W && W.on("update", N), this.setChannelActiveState = function(L) {
              let O = L.channelType, de = L.activeState, oe = L.activeReason, fe = L.congestionLevel, ge = L.subscriberId, we = L.isSubscriber;
              const _e = {
                active: de
              };
              oe && (_e.activeReason = oe), fe !== void 0 && (_e.congestionLevel = fe), ge && (_e.subscriberId = ge), Z(O, _e, we);
            }, this.setVideoDimensions = function(L, O) {
              Z("video", {
                width: L,
                height: O,
                orientation: 0
              });
            }, this.setRestrictFrameRate = function(L) {
              Z("video", {
                restrictFrameRate: L
              }, !0);
            }, this.setPreferredResolution = function(L) {
              if (!w()) {
                u.warn("setPreferredResolution has no affect when called by a publisher");
                return;
              }
              if (m.sessionInfo.p2pEnabled) {
                u.warn("Stream.setPreferredResolution will not work in a P2P Session");
                return;
              }
              if (L && L.width === void 0 && L.height === void 0)
                return;
              const O = B.getChannelsOfType("video")[0];
              if (O) {
                if (L && L.width) {
                  if (isNaN(parseInt(L.width, 10)))
                    throw new c.default.Error("stream preferred width must be an integer", "Subscriber");
                  O.preferredWidth = parseInt(L.width, 10);
                } else
                  O.preferredWidth = void 0;
                if (L && L.height) {
                  if (isNaN(parseInt(L.height, 10)))
                    throw new c.default.Error("stream preferred height must be an integer", "Subscriber");
                  O.preferredHeight = parseInt(L.height, 10);
                } else
                  O.preferredHeight = void 0;
                m._.subscriberChannelUpdate(B, J(), O, {
                  preferredWidth: O.preferredWidth || 0,
                  preferredHeight: O.preferredHeight || 0
                });
              }
            }, this.getPreferredResolution = function() {
              const L = B.getChannelsOfType("video")[0];
              if (!(!L || !L.preferredWidth && !L.preferredHeight))
                return {
                  width: L.preferredWidth,
                  height: L.preferredHeight
                };
            }, this.setPreferredFrameRate = function(L) {
              if (!w()) {
                u.warn("setPreferredFrameRate has no affect when called by a publisher");
                return;
              }
              if (m.sessionInfo.p2pEnabled) {
                u.warn("Stream.setPreferredFrameRate will not work in a P2P Session");
                return;
              }
              if (L && isNaN(parseFloat(L)))
                throw new c.default.Error("stream preferred frameRate must be a number", "Subscriber");
              const O = B.getChannelsOfType("video")[0];
              O && (O.preferredFrameRate = L ? parseFloat(L) : null, m._.subscriberChannelUpdate(B, J(), O, {
                preferredFrameRate: O.preferredFrameRate || 0
              }));
            }, this.getPreferredFrameRate = function() {
              const L = B.getChannelsOfType("video")[0];
              return L ? L.preferredFrameRate : null;
            };
            const Z = function(L, O, de) {
              de === void 0 && (de = !1);
              let oe;
              if (de) {
                const fe = J();
                oe = (ge) => m._.subscriberChannelUpdate(B, fe, ge, O);
              } else
                oe = (fe) => m._.streamChannelUpdate(B, fe, O);
              B.getChannelsOfType(L).forEach(oe);
            };
            this.destroyed = !1, this.destroyedReason = void 0, this.destroy = function(L, O) {
              L === void 0 && (L = "clientDisconnected"), Q = L, B.destroyed = !0, B.destroyedReason = Q, O !== !0 && B.dispatchEvent(new h.DestroyedEvent(
                "destroyed",
                // This should be eventNames.STREAM_DESTROYED, but
                // the value of that is currently shared with Session
                B,
                Q
              ));
            }, this._ = {}, this._.updateProperty = function(L, O) {
              if (A.indexOf(L) === -1) {
                u.warn(`Unknown stream property "${L}" was modified to "${O}".`);
                return;
              }
              const de = B[L], oe = O;
              switch (L) {
                case "name":
                  B[L] = oe;
                  break;
                case "archiving":
                  var fe = J();
                  B.publisher && fe && fe._.archivingStatus(oe), B[L] = oe;
                  break;
              }
              const ge = new h.StreamUpdatedEvent(B, L, de, oe);
              B.dispatchEvent(ge);
            }, this._.update = function(L) {
              for (const O in L)
                L.hasOwnProperty(O) && B._.updateProperty(O, L[O]);
            }, this._.forceMute = function(L) {
              L.hasOwnProperty("channels") && L.channels.includes("audio") && B.publisher && B.publisher._.forceMuteAudio();
            }, this._.updateChannel = function(L, O) {
              const de = B.getChannel(L);
              de && de.update(O);
            };
          }
        },
        /* 183 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = r.UNSUBSCRIBE = r.SUBSCRIBE = r.STATUS = r.PONG = r.PING = r.MESSAGE = r.DISCONNECT = r.CONNECT = void 0;
          const n = 0;
          r.SUBSCRIBE = n;
          const t = 1;
          r.UNSUBSCRIBE = t;
          const o = 2;
          r.MESSAGE = o;
          const l = 3;
          r.CONNECT = l;
          const c = 4;
          r.DISCONNECT = c;
          const d = 7;
          r.PING = d;
          const u = 8;
          r.PONG = u;
          const h = 9;
          r.STATUS = h;
          var A = {
            SUBSCRIBE: n,
            UNSUBSCRIBE: t,
            MESSAGE: o,
            CONNECT: l,
            DISCONNECT: c,
            PING: d,
            PONG: u,
            STATUS: h
          };
          r.default = A;
        },
        /* 184 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(9)), o = n(e(6)), l = n(e(181)), c = n(e(23)), d = n(e(775));
          const u = (0, c.default)();
          function h(g, f, p, v, b) {
            let m;
            this.id = g, this.connectionId = g, this.creationTime = f ? Number(f) : null, this.data = p, this.capabilities = (0, d.default)(v), this.permissions = new l.default(b), this.quality = null, (0, o.default)(this), this.destroy = (y, U) => {
              m = y || "clientDisconnected", U !== !0 && this.dispatchEvent(new u.DestroyedEvent(
                // This should be eventNames.CONNECTION_DESTROYED, but
                // the value of that is currently shared with Session
                "destroyed",
                this,
                m
              ));
            }, this.destroyed = () => m !== void 0, this.destroyedReason = () => m;
          }
          h.fromHash = (g) => {
            let f = g.id, p = g.creationTime, v = g.data, b = g.capablities, m = g.permissions;
            return new h(f, p, v, (0, t.default)(b || {}, {
              supportsWebRTC: !0
            }), m || []);
          };
          var A = h;
          r.default = A;
        },
        /* 185 */
        /***/
        function(i, r, e) {
          var n = e(792), t = e(249), o = e(89), l = e(147), c = o(function(d, u) {
            return l(d) ? n(d, t(u, 1, l, !0)) : [];
          });
          i.exports = c;
        },
        /* 186 */
        /***/
        function(i, r) {
          var e = typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn) && (typeof window !== void 0 ? window : Dn).Object === Object && (typeof window !== void 0 ? window : Dn);
          i.exports = e;
        },
        /* 187 */
        /***/
        function(i, r) {
          var e = Function.prototype, n = e.toString;
          function t(o) {
            if (o != null) {
              try {
                return n.call(o);
              } catch {
              }
              try {
                return o + "";
              } catch {
              }
            }
            return "";
          }
          i.exports = t;
        },
        /* 188 */
        /***/
        function(i, r, e) {
          var n = e(43), t = function() {
            try {
              var o = n(Object, "defineProperty");
              return o({}, "", {}), o;
            } catch {
            }
          }();
          i.exports = t;
        },
        /* 189 */
        /***/
        function(i, r, e) {
          var n = e(45), t = e(34);
          function o(l, c) {
            return l && n(c, t(c), l);
          }
          i.exports = o;
        },
        /* 190 */
        /***/
        function(i, r, e) {
          var n = e(382), t = e(64), o = e(12), l = e(65), c = e(66), d = e(87), u = Object.prototype, h = u.hasOwnProperty;
          function A(g, f) {
            var p = o(g), v = !p && t(g), b = !p && !v && l(g), m = !p && !v && !b && d(g), y = p || v || b || m, U = y ? n(g.length, String) : [], B = U.length;
            for (var Q in g)
              (f || h.call(g, Q)) && !(y && // Safari 9 has enumerable `arguments.length` in strict mode.
              (Q == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
              b && (Q == "offset" || Q == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
              m && (Q == "buffer" || Q == "byteLength" || Q == "byteOffset") || // Skip index properties.
              c(Q, B))) && U.push(Q);
            return U;
          }
          i.exports = A;
        },
        /* 191 */
        /***/
        function(i, r) {
          function e(n, t) {
            return function(o) {
              return n(t(o));
            };
          }
          i.exports = e;
        },
        /* 192 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(15), o = r && !r.nodeType && r, l = o && typeof n == "object" && n && !n.nodeType && n, c = l && l.exports === o, d = c ? t.Buffer : void 0, u = d ? d.allocUnsafe : void 0;
            function h(A, g) {
              if (g)
                return A.slice();
              var f = A.length, p = u ? u(f) : new A.constructor(f);
              return A.copy(p), p;
            }
            n.exports = h;
          }).call(this, e(86)(i));
        },
        /* 193 */
        /***/
        function(i, r) {
          function e() {
            return [];
          }
          i.exports = e;
        },
        /* 194 */
        /***/
        function(i, r, e) {
          var n = e(120), t = e(121), o = e(119), l = e(193), c = Object.getOwnPropertySymbols, d = c ? function(u) {
            for (var h = []; u; )
              n(h, o(u)), u = t(u);
            return h;
          } : l;
          i.exports = d;
        },
        /* 195 */
        /***/
        function(i, r, e) {
          var n = e(196), t = e(119), o = e(34);
          function l(c) {
            return n(c, o, t);
          }
          i.exports = l;
        },
        /* 196 */
        /***/
        function(i, r, e) {
          var n = e(120), t = e(12);
          function o(l, c, d) {
            var u = c(l);
            return t(l) ? u : n(u, d(l));
          }
          i.exports = o;
        },
        /* 197 */
        /***/
        function(i, r, e) {
          var n = e(196), t = e(194), o = e(54);
          function l(c) {
            return n(c, o, t);
          }
          i.exports = l;
        },
        /* 198 */
        /***/
        function(i, r, e) {
          var n = e(43), t = e(15), o = n(t, "Set");
          i.exports = o;
        },
        /* 199 */
        /***/
        function(i, r, e) {
          var n = e(43), t = e(15), o = n(t, "WeakMap");
          i.exports = o;
        },
        /* 200 */
        /***/
        function(i, r, e) {
          var n = e(15), t = n.Uint8Array;
          i.exports = t;
        },
        /* 201 */
        /***/
        function(i, r, e) {
          var n = e(122);
          function t(o, l) {
            var c = l ? n(o.buffer) : o.buffer;
            return new o.constructor(c, o.byteOffset, o.length);
          }
          i.exports = t;
        },
        /* 202 */
        /***/
        function(i, r, e) {
          var n = e(88), t = e(121), o = e(68);
          function l(c) {
            return typeof c.constructor == "function" && !o(c) ? n(t(c)) : {};
          }
          i.exports = l;
        },
        /* 203 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(6)), d = t(e(1)), u = t(e(57)), h = t(e(461)), A = t(e(462)), g = t(e(463)), f = t(e(94)), p = t(e(3)), v = t(e(252)), b = t(e(21)), m = t(e(104)), y = t(e(141)), U = t(e(142)), B = t(e(548)), Q = t(e(569)), N = t(e(7)), J = t(e(266)), w = t(e(267));
            const W = (0, b.default)(), G = W.hasAudioOutputApiSupport, Z = m.default.getCurrentAudioOutputDeviceId;
            function K(oe, fe) {
              const ge = (0, w.default)();
              return (0, A.default)(ge), ge.innerHTML = oe, fe === !0 && (ge.muted = "true"), ge;
            }
            function L() {
              const oe = K("");
              return oe.setAttribute("style", "display:none"), oe;
            }
            function O(oe) {
              oe === void 0 && (oe = {});
              const fe = oe.audioContext || (0, y.default)(), ge = oe.canBeOrientatedMixin || B.default, we = oe.document || (typeof window !== void 0 ? window : Dn).document, _e = oe.listenForTracksEnded || (0, Q.default)(), Te = oe.logging || d.default, Pe = oe.OTHelpers || N.default, $e = oe.videoElementErrorMap || (0, J.default)(), Bt = oe.WebaudioAudioLevelSampler || U.default, Le = oe.global || (typeof window !== void 0 ? window : Dn);
              let at = 1;
              return /* @__PURE__ */ function() {
                function kt(Lt, Ft) {
                  var Zt = this;
                  let ft = Lt._inject, It = ft === void 0 ? {} : ft, Kt = It.createVideoElement, Sn = Kt === void 0 ? K : Kt, Cn = It.createAudioOnlyVideoElement, on = Cn === void 0 ? L : Cn, An = Lt.muted, Ue = Lt.fallbackText, ne = Lt.widgetType;
                  this._domElement = void 0, this._domAudioOnlyVideoElement = void 0, this._blockedVolume = void 0, this._mediaStoppedListener = void 0, this._audioLevelSampler = void 0, this._playInterrupts = 0, this._isVideoLoadedMetaData = !1, this._audioOnlyVideoElementWatcher = void 0, this._blinkStartTime = null, this.logging = Te(`NativeVideoElementWrapper:${at}`), at += 1, (0, c.default)(this), this._defaultAudioVolume = Ft, this._widgetType = ne, this._emitVideoPlayAttempt = () => {
                    this._blinkStartTime = (/* @__PURE__ */ new Date()).getTime(), this.trigger("amrLogEvent", "AMRTransitionVideo", "Attempt");
                  }, this._emitVideoPlaySuccess = () => {
                    const Ge = (/* @__PURE__ */ new Date()).getTime() - this._blinkStartTime;
                    this.trigger("amrLogEvent", "AMRTransitionVideo", "Success", {
                      attemptDuration: Ge
                    }), this._blinkStartTime = null;
                  }, this._emitVideoPlayFailure = () => {
                    this.trigger("amrLogEvent", "AMRTransitionVideo", "Failure");
                  };
                  let se = !1;
                  const Ce = () => {
                    se || (this.logging.warn("Video element paused, auto-resuming. If you intended to do this, use publishVideo(false) or subscribeToVideo(false) instead."), se = !0), this.play();
                  };
                  this._domElement = Sn(Ue, An), this.trigger("videoElementCreated", this._domElement), this._domElementEvents = (0, u.default)(this._domElement), this._domElementEvents.on("loadstart", () => this._onDomElementLoadStart()), this._domElementEvents.on("timeupdate", function() {
                    for (var Ge = arguments.length, Ye = new Array(Ge), Qt = 0; Qt < Ge; Qt++)
                      Ye[Qt] = arguments[Qt];
                    return Zt.trigger("timeupdate", ...Ye);
                  }), this._domElementEvents.on("loadedmetadata", /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function Ge() {
                    var Ye, Qt, tn, vn, Yt = arguments;
                    return o.default.wrap(function(er) {
                      for (; ; ) switch (er.prev = er.next) {
                        case 0:
                          for (Zt._isVideoLoadedMetaData = !0, Ye = Yt.length, Qt = new Array(Ye), tn = 0; tn < Ye; tn++)
                            Qt[tn] = Yt[tn];
                          if (Zt.trigger("loadedmetadata", ...Qt), !Zt._domAudioOnlyVideoElement) {
                            er.next = 10;
                            break;
                          }
                          if (vn = Zt._domAudioOnlyVideoElement.srcObject, Zt._removeAudioOnlyVideoElement(), !vn) {
                            er.next = 10;
                            break;
                          }
                          return er.next = 9, (0, v.default)();
                        case 9:
                          Zt.play();
                        case 10:
                        case "end":
                          return er.stop();
                      }
                    }, Ge);
                  })));
                  const At = (Ge) => {
                    this.trigger("error", $e(Ge.target.error));
                  };
                  this._domElementEvents.on("error", At, !1), this._domElementEvents.on("pause", Ce), this.on("destroyed", () => {
                    this._domElementEvents.removeAll(), this._domAudioOnlyVideoElementEvents && this._domAudioOnlyVideoElementEvents.removeAll();
                  }), ge(this, () => this._domElement), p.default.isSafari && this._widgetType === "subscriber" && (this._domAudioOnlyVideoElement = on(), this._bindAudioOnlyVideoElementEvents());
                }
                var _t = kt.prototype;
                return _t._onDomElementLoadStart = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    return o.default.wrap(function(It) {
                      for (; ; ) switch (It.prev = It.next) {
                        case 0:
                          if (!(this._widgetType === "subscriber" && G())) {
                            It.next = 3;
                            break;
                          }
                          return It.next = 3, this._setActiveAudioOutputDevice();
                        case 3:
                        case "end":
                          return It.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._setActiveAudioOutputDevice = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    var ft;
                    return o.default.wrap(function(Kt) {
                      for (; ; ) switch (Kt.prev = Kt.next) {
                        case 0:
                          if (ft = Z(), !(ft === "" || ft === "default")) {
                            Kt.next = 3;
                            break;
                          }
                          return Kt.abrupt("return");
                        case 3:
                          return Kt.next = 5, this.setSinkId(ft);
                        case 5:
                        case "end":
                          return Kt.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._rebindSrcObject = function() {
                  this._domElement && (this._domElement.srcObject = this._domElement.srcObject);
                }, _t._pauseAndPlay = function() {
                  this._domElement && (this._domElement.pause(), this._domElement.play());
                }, _t._startAudioOnlyVideoElementWatcher = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    var ft, It;
                    return o.default.wrap(function(Sn) {
                      for (; ; ) switch (Sn.prev = Sn.next) {
                        case 0:
                          return ft = 1e3, It = p.default.isiOS, this._audioOnlyVideoElementWatcher = setInterval(() => {
                            this._domAudioOnlyVideoElement && this._domAudioOnlyVideoElement.paused && (this._domAudioOnlyVideoElement.srcObject = this._domAudioOnlyVideoElement.srcObject, It && this._domAudioOnlyVideoElement.play());
                          }, 100), Sn.next = 5, (0, f.default)(ft);
                        case 5:
                          clearInterval(this._audioOnlyVideoElementWatcher), this._audioOnlyVideoElementWatcher = null;
                        case 7:
                        case "end":
                          return Sn.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._removeAudioOnlyVideoElement = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    return o.default.wrap(function(It) {
                      for (; ; ) switch (It.prev = It.next) {
                        case 0:
                          this._domAudioOnlyVideoElement.srcObject = null, this._domAudioOnlyVideoElement.parentNode.removeChild(this._domAudioOnlyVideoElement), this._domAudioOnlyVideoElementEvents && this._domAudioOnlyVideoElementEvents.removeAll(), this._domAudioOnlyVideoElement = null;
                        case 4:
                        case "end":
                          return It.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t.bindAudioTrackOnly = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    var ft, It, Kt, Sn, Cn, on, An;
                    return o.default.wrap(function(ne) {
                      for (; ; ) switch (ne.prev = ne.next) {
                        case 0:
                          return ft = this._stream.getVideoTracks(), It = this._stream.getAudioTracks(), Kt = ft[0], Sn = Kt === void 0 ? {} : Kt, Cn = It[0], on = Cn === void 0 ? {} : Cn, ne.next = 6, (0, v.default)();
                        case 6:
                          An = !Sn.enabled && on.enabled, !this._isVideoLoadedMetaData && An && this._domAudioOnlyVideoElement && (this._domAudioOnlyVideoElement.srcObject = new Le.MediaStream(It), this._startAudioOnlyVideoElementWatcher());
                        case 8:
                        case "end":
                          return ne.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._bindAudioOnlyVideoElementEvents = function() {
                  var Ft = this;
                  this._domAudioOnlyVideoElementEvents = (0, u.default)(this._domAudioOnlyVideoElement), this._domAudioOnlyVideoElementEvents.on("pause", () => this.play()), this._domAudioOnlyVideoElementEvents.on("timeupdate", function() {
                    for (var Zt = arguments.length, ft = new Array(Zt), It = 0; It < Zt; It++)
                      ft[It] = arguments[It];
                    return Ft.trigger("timeupdate", ...ft);
                  }), this._domAudioOnlyVideoElementEvents.on("loadedmetadata", function() {
                    for (var Zt = arguments.length, ft = new Array(Zt), It = 0; It < Zt; It++)
                      ft[It] = arguments[It];
                    return Ft.trigger("loadedmetadata", ...ft);
                  });
                }, _t.whenTimeIncrements = function(Ft, Zt) {
                  this.once("timeupdate", () => {
                    Ft.call(Zt, this);
                  });
                }, _t.domElement = function() {
                  return this._domElement;
                }, _t.videoWidth = function() {
                  return this._domElement ? Number(this._domElement[`video${this.isRotated() ? "Height" : "Width"}`]) : 0;
                }, _t.videoHeight = function() {
                  return this._domElement ? Number(this._domElement[`video${this.isRotated() ? "Width" : "Height"}`]) : 0;
                }, _t.aspectRatio = function() {
                  return this.videoWidth() / this.videoHeight();
                }, _t.imgData = function() {
                  const Ft = Pe.createElement("canvas", {
                    width: this.videoWidth(),
                    height: this.videoHeight(),
                    style: {
                      display: "none"
                    }
                  });
                  we.body.appendChild(Ft);
                  let Zt = null;
                  try {
                    Ft.getContext("2d").drawImage(this._domElement, 0, 0, Ft.width, Ft.height), Zt = Ft.toDataURL("image/png");
                  } catch {
                  }
                  return Pe.removeElement(Ft), Zt === null || Zt === "data:," ? (this.logging.warn("Cannot get image data yet"), null) : Zt.replace("data:image/png;base64,", "").trim();
                }, _t.appendTo = function(Ft) {
                  return Ft.appendChild(this._domElement), this._domAudioOnlyVideoElement && Ft.appendChild(this._domAudioOnlyVideoElement), this;
                }, _t.isAudioBlocked = function() {
                  return this._blockedVolume !== void 0;
                }, _t.unblockAudio = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    var ft;
                    return o.default.wrap(function(Kt) {
                      for (; ; ) switch (Kt.prev = Kt.next) {
                        case 0:
                          if (this.isAudioBlocked()) {
                            Kt.next = 3;
                            break;
                          }
                          return this.logging.warn("Unexpected call to unblockAudio() without blocked audio"), Kt.abrupt("return");
                        case 3:
                          return ft = this._blockedVolume, this._blockedVolume = void 0, this.setAudioVolume(ft), Kt.prev = 6, Kt.next = 9, this.play();
                        case 9:
                          Kt.next = 16;
                          break;
                        case 11:
                          throw Kt.prev = 11, Kt.t0 = Kt.catch(6), this._blockedVolume = ft, this._domElement.muted = !0, Kt.t0;
                        case 16:
                          this.trigger("audioUnblocked");
                        case 17:
                        case "end":
                          return Kt.stop();
                      }
                    }, Zt, this, [[6, 11]]);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t.rebind = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    return o.default.wrap(function(It) {
                      for (; ; ) switch (It.prev = It.next) {
                        case 0:
                          if (this._domElement) {
                            It.next = 2;
                            break;
                          }
                          throw new Error("Can't rebind because _domElement no longer exists");
                        case 2:
                          this._playInterrupts++, this._domElement.srcObject = this._domElement.srcObject, this._hasAudioOnlyVideoElement() && (this._domAudioOnlyVideoElement.srcObject = this._domAudioOnlyVideoElement.srcObject);
                        case 5:
                        case "end":
                          return It.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._createAudioLevelSampler = function() {
                  if (this._removeAudioLevelSampler(), this._stream.getAudioTracks().length > 0) {
                    try {
                      this._audioContext = fe();
                    } catch (Ft) {
                      this.logging.warn("Failed to get AudioContext(), audio level visualisation will not work", Ft);
                    }
                    this._audioContext && (this._audioLevelSampler = new Bt(this._audioContext), this._audioLevelSampler.webRTCStream(this._stream));
                  }
                }, _t._removeAudioLevelSampler = function() {
                  this._audioContext && (delete this._audioContext, delete this._audioLevelSampler);
                }, _t._toggleVideoTracks = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    var ft, It, Kt;
                    return o.default.wrap(function(Cn) {
                      for (; ; ) switch (Cn.prev = Cn.next) {
                        case 0:
                          if (ft = this._domElement.srcObject.getTracks().filter((on) => on.enabled), It = ft.length > 1, !It) {
                            Cn.next = 8;
                            break;
                          }
                          return Kt = ft.filter((on) => on.kind === "video"), Kt.forEach((on) => {
                            on.enabled = !1;
                          }), Cn.next = 7, (0, v.default)();
                        case 7:
                          Kt.forEach((on) => {
                            on.enabled = !0;
                          });
                        case 8:
                        case "end":
                          return Cn.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._hasAudioOnlyVideoElement = function() {
                  return this._domAudioOnlyVideoElement && this._domAudioOnlyVideoElement.srcObject;
                }, _t.play = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt() {
                    var ft, It, Kt, Sn, Cn, on, An, Ue, ne, se, Ce, At;
                    return o.default.wrap(function(Ye) {
                      for (; ; ) switch (Ye.prev = Ye.next) {
                        case 0:
                          if (ft = this._playInterrupts, It = this._hasAudioOnlyVideoElement() ? this._domAudioOnlyVideoElement : this._domElement, !p.default.isSafari) {
                            Ye.next = 5;
                            break;
                          }
                          return Ye.next = 5, (0, v.default)();
                        case 5:
                          if (!(p.default.isiOS && p.default.isSafari)) {
                            Ye.next = 15;
                            break;
                          }
                          if (this._widgetType !== "publisher") {
                            Ye.next = 14;
                            break;
                          }
                          if (Kt = p.default.iOSVersion >= 14 && p.default.iOSVersion <= 14.2, Sn = this._stream.getVideoTracks(), Cn = Sn[0], on = Cn === void 0 ? {} : Cn, An = this._stream.getAudioTracks(), Ue = An[0], ne = Ue === void 0 ? {} : Ue, !(Kt && !(0, g.default)(It) && on.enabled)) {
                            Ye.next = 12;
                            break;
                          }
                          return Ye.abrupt("return");
                        case 12:
                          if (!ne.muted) {
                            Ye.next = 14;
                            break;
                          }
                          return Ye.abrupt("return");
                        case 14:
                          this._toggleVideoTracks();
                        case 15:
                          return Ye.prev = 15, this._emitVideoPlayAttempt(), Ye.next = 19, It.play();
                        case 19:
                          return this._emitVideoPlaySuccess(), Ye.abrupt("return");
                        case 23:
                          if (Ye.prev = 23, Ye.t0 = Ye.catch(15), this._emitVideoPlayFailure(), se = Ye.t0 || {}, Ce = se.name, At = Ce === "AbortError", At && this._playInterrupts++, !(this._playInterrupts > ft)) {
                            Ye.next = 33;
                            break;
                          }
                          return Ye.next = 32, this.play();
                        case 32:
                          return Ye.abrupt("return");
                        case 33:
                          throw Ye.t0;
                        case 34:
                        case "end":
                          return Ye.stop();
                      }
                    }, Zt, this, [[15, 23]]);
                  }));
                  function Ft() {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t._bindToStream = function(Ft) {
                  this._stream = Ft, this._domElement.srcObject = Ft, this._domAudioOnlyVideoElement && this.bindAudioTrackOnly();
                }, _t.bindToStream = /* @__PURE__ */ function() {
                  var Lt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Zt(ft) {
                    var It = this, Kt, Sn, Cn;
                    return o.default.wrap(function(An) {
                      for (; ; ) switch (An.prev = An.next) {
                        case 0:
                          if (this._domElement) {
                            An.next = 2;
                            break;
                          }
                          throw new Error("Can't bind because _domElement no longer exists");
                        case 2:
                          return this._bindToStream(ft), (0, l.default)(/* @__PURE__ */ o.default.mark(function Ue() {
                            var ne;
                            return o.default.wrap(function(Ce) {
                              for (; ; ) switch (Ce.prev = Ce.next) {
                                case 0:
                                  return Ce.prev = 0, Ce.next = 3, It.play();
                                case 3:
                                  Ce.next = 26;
                                  break;
                                case 5:
                                  if (Ce.prev = 5, Ce.t0 = Ce.catch(0), ne = !!ft.getAudioTracks().length, !(It._hasAudioOnlyVideoElement() && Ce.t0.name === "NotAllowedError")) {
                                    Ce.next = 15;
                                    break;
                                  }
                                  return It._domAudioOnlyVideoElement.muted = !0, Ce.next = 12, It.play();
                                case 12:
                                  It._domAudioOnlyVideoElement.muted = !1, Ce.next = 26;
                                  break;
                                case 15:
                                  if (!ne) {
                                    Ce.next = 23;
                                    break;
                                  }
                                  return It._blockedVolume = It.getAudioVolume(), It._domElement.muted = !0, Ce.next = 20, It.play();
                                case 20:
                                  It.trigger("audioBlocked"), Ce.next = 26;
                                  break;
                                case 23:
                                  return It._domElement.muted = !0, Ce.next = 26, It.play();
                                case 26:
                                case "end":
                                  return Ce.stop();
                              }
                            }, Ue, null, [[0, 5]]);
                          }))().catch((Ue) => {
                            this.logging.debug(".play() failed: ", Ue);
                          }), Kt = {
                            width: this._domElement.videoWidth,
                            height: this._domElement.videoHeight
                          }, this.trigger("videoDimensionsChanged", Object.assign({}, Kt), Object.assign({}, Kt)), this._domElementEvents.on("resize", () => {
                            const Ue = this._domElement, ne = Ue.videoWidth, se = Ue.videoHeight, Ce = ne !== Kt.width, At = se !== Kt.height;
                            (Ce || At) && (this.trigger("videoDimensionsChanged", Object.assign({}, Kt), {
                              width: ne,
                              height: se
                            }), Kt.width = ne, Kt.height = se);
                          }), Sn = () => {
                            try {
                              this._mediaStoppedListener.stop();
                            } catch {
                              return;
                            }
                            this._domElement && (this._domElement.onended = null), this.trigger("mediaStopped");
                          }, Cn = (Ue) => {
                            this.trigger("mediaStopped", Ue);
                          }, this._domElement.onended = () => Sn(), this._mediaStoppedListener = _e(ft, Sn, Cn), this._createAudioLevelSampler(), An.abrupt("return", void 0);
                        case 13:
                        case "end":
                          return An.stop();
                      }
                    }, Zt, this);
                  }));
                  function Ft(Zt) {
                    return Lt.apply(this, arguments);
                  }
                  return Ft;
                }(), _t.unbindStream = function() {
                  return this._domElement && (this._domElement.srcObject = null), this._domAudioOnlyVideoElement && (this._domAudioOnlyVideoElement.srcObject = null), this._removeAudioLevelSampler(), this;
                }, _t.setAudioVolume = function(Ft) {
                  if (this.isAudioBlocked()) {
                    this._blockedVolume = Ft;
                    return;
                  }
                  const Zt = parseFloat(Ft) / 100, ft = [this.domElement()];
                  this._domAudioOnlyVideoElement && ft.push(this._domAudioOnlyVideoElement), ft.forEach((It) => {
                    It && (It.volume = Zt, It.muted = Zt === 0);
                  });
                }, _t.getAudioVolume = function() {
                  if (this.isAudioBlocked())
                    return this._blockedVolume;
                  const Ft = this.domElement();
                  return Ft ? Ft.muted ? 0 : Ft.volume * 100 : this._defaultAudioVolume;
                }, _t.audioChannelType = function(Ft) {
                  const Zt = this.domElement();
                  return Ft !== void 0 && (Zt.mozAudioChannelType = Ft), "mozAudioChannelType" in this._domElement ? Zt.mozAudioChannelType : "unknown";
                }, _t.getAudioInputLevel = function() {
                  return this._audioLevelSampler.sample();
                }, _t.refreshTracks = function() {
                  this._mediaStoppedListener && this._mediaStoppedListener.refresh(), this._createAudioLevelSampler();
                }, _t.destroy = function() {
                  this._mediaStoppedListener && this._mediaStoppedListener.stop(), this.logging.debug("removing domElementEvents"), this._domElementEvents.removeAll(), this._domAudioOnlyVideoElementEvents && this._domAudioOnlyVideoElementEvents.removeAll(), this._audioOnlyVideoElementWatcher && clearInterval(this._audioOnlyVideoElementWatcher), this.unbindStream(), this._domElement && (Pe.removeElement(this._domElement), this._domElement = null), this._domAudioOnlyVideoElement && (Pe.removeElement(this._domAudioOnlyVideoElement), this._domAudioOnlyVideoElement = null), this.trigger("destroyed"), (0, h.default)("NativeVideoElementWrapper", this);
                }, _t.setSinkId = function(Ft) {
                  const ft = [this._domElement, this._domAudioOnlyVideoElement].map((It) => {
                    if (It)
                      return It.setSinkId(Ft);
                  });
                  return n.all(ft);
                }, kt;
              }();
            }
            var de = O;
            r.default = de;
          }).call(this, e(2));
        },
        /* 204 */
        /***/
        function(i, r, e) {
          var n = e(89), t = e(125);
          function o(l) {
            return n(function(c, d) {
              var u = -1, h = d.length, A = h > 1 ? d[h - 1] : void 0, g = h > 2 ? d[2] : void 0;
              for (A = l.length > 3 && typeof A == "function" ? (h--, A) : void 0, g && t(d[0], d[1], g) && (A = h < 3 ? void 0 : A, h = 1), c = Object(c); ++u < h; ) {
                var f = d[u];
                f && l(c, f, u, A);
              }
              return c;
            });
          }
          i.exports = o;
        },
        /* 205 */
        /***/
        function(i, r, e) {
          var n = e(123), t = Math.max;
          function o(l, c, d) {
            return c = t(c === void 0 ? l.length - 1 : c, 0), function() {
              for (var u = arguments, h = -1, A = t(u.length - c, 0), g = Array(A); ++h < A; )
                g[h] = u[c + h];
              h = -1;
              for (var f = Array(c + 1); ++h < c; )
                f[h] = u[h];
              return f[c] = d(g), n(l, this, f);
            };
          }
          i.exports = o;
        },
        /* 206 */
        /***/
        function(i, r) {
          var e = 800, n = 16, t = Date.now;
          function o(l) {
            var c = 0, d = 0;
            return function() {
              var u = t(), h = n - (u - d);
              if (d = u, h > 0) {
                if (++c >= e)
                  return arguments[0];
              } else
                c = 0;
              return l.apply(void 0, arguments);
            };
          }
          i.exports = o;
        },
        /* 207 */
        /***/
        function(i, r, e) {
          i.exports = e(412)() ? WeakMap : e(413);
        },
        /* 208 */
        /***/
        function(i, r, e) {
          var n = Object.create, t = Object.getPrototypeOf, o = {};
          i.exports = function() {
            var l = Object.setPrototypeOf, c = arguments[0] || n;
            return typeof l != "function" ? !1 : t(l(c(null), o)) === o;
          };
        },
        /* 209 */
        /***/
        function(i, r, e) {
          var n = e(210), t = e(35), o = Object.prototype.isPrototypeOf, l = Object.defineProperty, c = { configurable: !0, enumerable: !1, writable: !0, value: void 0 }, d;
          d = function(u, h) {
            if (t(u), h === null || n(h)) return u;
            throw new TypeError("Prototype must be null or an object");
          }, i.exports = function(u) {
            var h, A;
            return u ? (u.level === 2 ? u.set ? (A = u.set, h = function(g, f) {
              return A.call(d(g, f), f), g;
            }) : h = function(g, f) {
              return d(g, f).__proto__ = f, g;
            } : h = function g(f, p) {
              var v;
              return d(f, p), v = o.call(g.nullPolyfill, f), v && delete g.nullPolyfill.__proto__, p === null && (p = g.nullPolyfill), f.__proto__ = p, v && l(g.nullPolyfill, "__proto__", c), f;
            }, Object.defineProperty(h, "level", {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: u.level
            })) : null;
          }(
            function() {
              var u = /* @__PURE__ */ Object.create(null), h = {}, A, g = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
              if (g) {
                try {
                  A = g.set, A.call(u, h);
                } catch {
                }
                if (Object.getPrototypeOf(u) === h) return { set: A, level: 2 };
              }
              return u.__proto__ = h, Object.getPrototypeOf(u) === h ? { level: 2 } : (u = {}, u.__proto__ = h, Object.getPrototypeOf(u) === h ? { level: 1 } : !1);
            }()
          ), e(415);
        },
        /* 210 */
        /***/
        function(i, r, e) {
          var n = e(47), t = { function: !0, object: !0 };
          i.exports = function(o) {
            return n(o) && t[typeof o] || !1;
          };
        },
        /* 211 */
        /***/
        function(i, r, e) {
          var n = e(418), t = /^\s*class[\s{/}]/, o = Function.prototype.toString;
          i.exports = function(l) {
            return !(!n(l) || t.test(o.call(l)));
          };
        },
        /* 212 */
        /***/
        function(i, r, e) {
          var n = e(47), t = Array.prototype.forEach, o = Object.create, l = function(c, d) {
            var u;
            for (u in c) d[u] = c[u];
          };
          i.exports = function(c) {
            var d = o(null);
            return t.call(arguments, function(u) {
              n(u) && l(Object(u), d);
            }), d;
          };
        },
        /* 213 */
        /***/
        function(i, r, e) {
          i.exports = e(425)() ? String.prototype.contains : e(426);
        },
        /* 214 */
        /***/
        function(i, r, e) {
          var n = e(91), t = e(92), o = e(427), l = e(456), c = e(457), d = e(48).iterator;
          i.exports = function(u) {
            return typeof c(u)[d] == "function" ? u[d]() : n(u) ? new o(u) : t(u) ? new l(u) : new o(u);
          };
        },
        /* 215 */
        /***/
        function(i, r, e) {
          var n = e(432);
          i.exports = function(t) {
            if (!n(t)) throw new TypeError(t + " is not a symbol");
            return t;
          };
        },
        /* 216 */
        /***/
        function(i, r, e) {
          var n = e(436), t = e(130), o = e(69), l = e(35), c = e(36), d = e(437), u = e(48), h = Object.defineProperty, A = Object.defineProperties, g;
          i.exports = g = function(f, p) {
            if (!(this instanceof g)) throw new TypeError("Constructor requires 'new'");
            A(this, {
              __list__: c("w", l(f)),
              __context__: c("w", p),
              __nextIndex__: c("w", 0)
            }), p && (o(p.on), p.on("_add", this._onAdd), p.on("_delete", this._onDelete), p.on("_clear", this._onClear));
          }, delete g.prototype.constructor, A(
            g.prototype,
            t(
              {
                _next: c(function() {
                  var f;
                  if (this.__list__) {
                    if (this.__redo__ && (f = this.__redo__.shift(), f !== void 0))
                      return f;
                    if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
                    this._unBind();
                  }
                }),
                next: c(function() {
                  return this._createResult(this._next());
                }),
                _createResult: c(function(f) {
                  return f === void 0 ? { done: !0, value: void 0 } : { done: !1, value: this._resolve(f) };
                }),
                _resolve: c(function(f) {
                  return this.__list__[f];
                }),
                _unBind: c(function() {
                  this.__list__ = null, delete this.__redo__, this.__context__ && (this.__context__.off("_add", this._onAdd), this.__context__.off("_delete", this._onDelete), this.__context__.off("_clear", this._onClear), this.__context__ = null);
                }),
                toString: c(function() {
                  return "[object " + (this[u.toStringTag] || "Object") + "]";
                })
              },
              d({
                _onAdd: c(function(f) {
                  if (!(f >= this.__nextIndex__)) {
                    if (++this.__nextIndex__, !this.__redo__) {
                      h(this, "__redo__", c("c", [f]));
                      return;
                    }
                    this.__redo__.forEach(function(p, v) {
                      p >= f && (this.__redo__[v] = ++p);
                    }, this), this.__redo__.push(f);
                  }
                }),
                _onDelete: c(function(f) {
                  var p;
                  f >= this.__nextIndex__ || (--this.__nextIndex__, this.__redo__ && (p = this.__redo__.indexOf(f), p !== -1 && this.__redo__.splice(p, 1), this.__redo__.forEach(function(v, b) {
                    v > f && (this.__redo__[b] = --v);
                  }, this)));
                }),
                _onClear: c(function() {
                  this.__redo__ && n.call(this.__redo__), this.__nextIndex__ = 0;
                })
              })
            )
          ), h(
            g.prototype,
            u.iterator,
            c(function() {
              return this;
            })
          );
        },
        /* 217 */
        /***/
        function(i, r, e) {
          var n = e(56), t = e(129), o = e(439), l = e(440), c = function(d, u) {
            return d.replace("%v", l(u));
          };
          i.exports = function(d, u, h) {
            if (!t(h)) throw new TypeError(c(u, d));
            if (!n(d)) {
              if ("default" in h) return h.default;
              if (h.isOptional) return null;
            }
            var A = o(h.errorMessage);
            throw n(A) || (A = u), new TypeError(c(A, d));
          };
        },
        /* 218 */
        /***/
        function(i, r, e) {
          i.exports = e(467);
        },
        /* 219 */
        /***/
        function(i, r, e) {
          i.exports = function(t, o) {
            return function() {
              for (var c = new Array(arguments.length), d = 0; d < c.length; d++)
                c[d] = arguments[d];
              return t.apply(o, c);
            };
          };
        },
        /* 220 */
        /***/
        function(i, r, e) {
          var n = e(19);
          function t(o) {
            return encodeURIComponent(o).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
          }
          i.exports = function(l, c, d) {
            if (!c)
              return l;
            var u;
            if (d)
              u = d(c);
            else if (n.isURLSearchParams(c))
              u = c.toString();
            else {
              var h = [];
              n.forEach(c, function(f, p) {
                f === null || typeof f == "undefined" || (n.isArray(f) ? p = p + "[]" : f = [f], n.forEach(f, function(b) {
                  n.isDate(b) ? b = b.toISOString() : n.isObject(b) && (b = JSON.stringify(b)), h.push(t(p) + "=" + t(b));
                }));
              }), u = h.join("&");
            }
            if (u) {
              var A = l.indexOf("#");
              A !== -1 && (l = l.slice(0, A)), l += (l.indexOf("?") === -1 ? "?" : "&") + u;
            }
            return l;
          };
        },
        /* 221 */
        /***/
        function(i, r, e) {
          i.exports = function(t, o, l, c, d) {
            return t.config = o, l && (t.code = l), t.request = c, t.response = d, t.isAxiosError = !0, t.toJSON = function() {
              return {
                // Standard
                message: this.message,
                name: this.name,
                // Microsoft
                description: this.description,
                number: this.number,
                // Mozilla
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                // Axios
                config: this.config,
                code: this.code
              };
            }, t;
          };
        },
        /* 222 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(19), o = e(473), l = e(474), c = e(220), d = e(475), u = e(478), h = e(479), A = e(223);
            i.exports = function(f) {
              return new n(function(v, b) {
                var m = f.data, y = f.headers, U = f.responseType;
                t.isFormData(m) && delete y["Content-Type"];
                var B = new XMLHttpRequest();
                if (f.auth) {
                  var Q = f.auth.username || "", N = f.auth.password ? unescape(encodeURIComponent(f.auth.password)) : "";
                  y.Authorization = "Basic " + btoa(Q + ":" + N);
                }
                var J = d(f.baseURL, f.url);
                B.open(f.method.toUpperCase(), c(J, f.params, f.paramsSerializer), !0), B.timeout = f.timeout;
                function w() {
                  if (B) {
                    var G = "getAllResponseHeaders" in B ? u(B.getAllResponseHeaders()) : null, Z = !U || U === "text" || U === "json" ? B.responseText : B.response, K = {
                      data: Z,
                      status: B.status,
                      statusText: B.statusText,
                      headers: G,
                      config: f,
                      request: B
                    };
                    o(v, b, K), B = null;
                  }
                }
                if ("onloadend" in B ? B.onloadend = w : B.onreadystatechange = function() {
                  !B || B.readyState !== 4 || B.status === 0 && !(B.responseURL && B.responseURL.indexOf("file:") === 0) || setTimeout(w);
                }, B.onabort = function() {
                  B && (b(A("Request aborted", f, "ECONNABORTED", B)), B = null);
                }, B.onerror = function() {
                  b(A("Network Error", f, null, B)), B = null;
                }, B.ontimeout = function() {
                  var Z = "timeout of " + f.timeout + "ms exceeded";
                  f.timeoutErrorMessage && (Z = f.timeoutErrorMessage), b(A(
                    Z,
                    f,
                    f.transitional && f.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
                    B
                  )), B = null;
                }, t.isStandardBrowserEnv()) {
                  var W = (f.withCredentials || h(J)) && f.xsrfCookieName ? l.read(f.xsrfCookieName) : void 0;
                  W && (y[f.xsrfHeaderName] = W);
                }
                "setRequestHeader" in B && t.forEach(y, function(Z, K) {
                  typeof m == "undefined" && K.toLowerCase() === "content-type" ? delete y[K] : B.setRequestHeader(K, Z);
                }), t.isUndefined(f.withCredentials) || (B.withCredentials = !!f.withCredentials), U && U !== "json" && (B.responseType = f.responseType), typeof f.onDownloadProgress == "function" && B.addEventListener("progress", f.onDownloadProgress), typeof f.onUploadProgress == "function" && B.upload && B.upload.addEventListener("progress", f.onUploadProgress), f.cancelToken && f.cancelToken.promise.then(function(Z) {
                  B && (B.abort(), b(Z), B = null);
                }), m || (m = null), B.send(m);
              });
            };
          }).call(this, e(2));
        },
        /* 223 */
        /***/
        function(i, r, e) {
          var n = e(221);
          i.exports = function(o, l, c, d, u) {
            var h = new Error(o);
            return n(h, l, c, d, u);
          };
        },
        /* 224 */
        /***/
        function(i, r, e) {
          i.exports = function(t) {
            return !!(t && t.__CANCEL__);
          };
        },
        /* 225 */
        /***/
        function(i, r, e) {
          var n = e(19);
          i.exports = function(o, l) {
            l = l || {};
            var c = {}, d = ["url", "method", "data"], u = ["headers", "auth", "proxy", "params"], h = [
              "baseURL",
              "transformRequest",
              "transformResponse",
              "paramsSerializer",
              "timeout",
              "timeoutMessage",
              "withCredentials",
              "adapter",
              "responseType",
              "xsrfCookieName",
              "xsrfHeaderName",
              "onUploadProgress",
              "onDownloadProgress",
              "decompress",
              "maxContentLength",
              "maxBodyLength",
              "maxRedirects",
              "transport",
              "httpAgent",
              "httpsAgent",
              "cancelToken",
              "socketPath",
              "responseEncoding"
            ], A = ["validateStatus"];
            function g(b, m) {
              return n.isPlainObject(b) && n.isPlainObject(m) ? n.merge(b, m) : n.isPlainObject(m) ? n.merge({}, m) : n.isArray(m) ? m.slice() : m;
            }
            function f(b) {
              n.isUndefined(l[b]) ? n.isUndefined(o[b]) || (c[b] = g(void 0, o[b])) : c[b] = g(o[b], l[b]);
            }
            n.forEach(d, function(m) {
              n.isUndefined(l[m]) || (c[m] = g(void 0, l[m]));
            }), n.forEach(u, f), n.forEach(h, function(m) {
              n.isUndefined(l[m]) ? n.isUndefined(o[m]) || (c[m] = g(void 0, o[m])) : c[m] = g(void 0, l[m]);
            }), n.forEach(A, function(m) {
              m in l ? c[m] = g(o[m], l[m]) : m in o && (c[m] = g(void 0, o[m]));
            });
            var p = d.concat(u).concat(h).concat(A), v = Object.keys(o).concat(Object.keys(l)).filter(function(m) {
              return p.indexOf(m) === -1;
            });
            return n.forEach(v, f), c;
          };
        },
        /* 226 */
        /***/
        function(i, r, e) {
          function n(t) {
            this.message = t;
          }
          n.prototype.toString = function() {
            return "Cancel" + (this.message ? ": " + this.message : "");
          }, n.prototype.__CANCEL__ = !0, i.exports = n;
        },
        /* 227 */
        /***/
        function(i, r, e) {
          var n = e(486), t = e(488);
          function o(l, c, d) {
            return n(t, l, c, d);
          }
          i.exports = o;
        },
        /* 228 */
        /***/
        function(i, r, e) {
          var n = e(90), t = e(229), o = t ? function(l, c) {
            return t.set(l, c), l;
          } : n;
          i.exports = o;
        },
        /* 229 */
        /***/
        function(i, r, e) {
          var n = e(199), t = n && new n();
          i.exports = t;
        },
        /* 230 */
        /***/
        function(i, r, e) {
          var n = e(231), t = e(232), o = e(492), l = e(95), c = e(233), d = e(240), u = e(504), h = e(136), A = e(15), g = 1, f = 2, p = 8, v = 16, b = 128, m = 512;
          function y(U, B, Q, N, J, w, W, G, Z, K) {
            var L = B & b, O = B & g, de = B & f, oe = B & (p | v), fe = B & m, ge = de ? void 0 : l(U);
            function we() {
              for (var _e = arguments.length, Te = Array(_e), Pe = _e; Pe--; )
                Te[Pe] = arguments[Pe];
              if (oe)
                var $e = d(we), Bt = o(Te, $e);
              if (N && (Te = n(Te, N, J, oe)), w && (Te = t(Te, w, W, oe)), _e -= Bt, oe && _e < K) {
                var Le = h(Te, $e);
                return c(
                  U,
                  B,
                  y,
                  we.placeholder,
                  Q,
                  Te,
                  Le,
                  G,
                  Z,
                  K - _e
                );
              }
              var at = O ? Q : this, pt = de ? at[U] : U;
              return _e = Te.length, G ? Te = u(Te, G) : fe && _e > 1 && Te.reverse(), L && Z < _e && (Te.length = Z), this && this !== A && this instanceof we && (pt = ge || l(pt)), pt.apply(at, Te);
            }
            return we;
          }
          i.exports = y;
        },
        /* 231 */
        /***/
        function(i, r) {
          var e = Math.max;
          function n(t, o, l, c) {
            for (var d = -1, u = t.length, h = l.length, A = -1, g = o.length, f = e(u - h, 0), p = Array(g + f), v = !c; ++A < g; )
              p[A] = o[A];
            for (; ++d < h; )
              (v || d < u) && (p[l[d]] = t[d]);
            for (; f--; )
              p[A++] = t[d++];
            return p;
          }
          i.exports = n;
        },
        /* 232 */
        /***/
        function(i, r) {
          var e = Math.max;
          function n(t, o, l, c) {
            for (var d = -1, u = t.length, h = -1, A = l.length, g = -1, f = o.length, p = e(u - A, 0), v = Array(p + f), b = !c; ++d < p; )
              v[d] = t[d];
            for (var m = d; ++g < f; )
              v[m + g] = o[g];
            for (; ++h < A; )
              (b || d < u) && (v[m + l[h]] = t[d++]);
            return v;
          }
          i.exports = n;
        },
        /* 233 */
        /***/
        function(i, r, e) {
          var n = e(493), t = e(237), o = e(238), l = 1, c = 2, d = 4, u = 8, h = 32, A = 64;
          function g(f, p, v, b, m, y, U, B, Q, N) {
            var J = p & u, w = J ? U : void 0, W = J ? void 0 : U, G = J ? y : void 0, Z = J ? void 0 : y;
            p |= J ? h : A, p &= ~(J ? A : h), p & d || (p &= ~(l | c));
            var K = [
              f,
              p,
              m,
              G,
              w,
              Z,
              W,
              B,
              Q,
              N
            ], L = v.apply(void 0, K);
            return n(f) && t(L, K), L.placeholder = b, o(L, f, p);
          }
          i.exports = g;
        },
        /* 234 */
        /***/
        function(i, r, e) {
          var n = e(229), t = e(235), o = n ? function(l) {
            return n.get(l);
          } : t;
          i.exports = o;
        },
        /* 235 */
        /***/
        function(i, r) {
          function e() {
          }
          i.exports = e;
        },
        /* 236 */
        /***/
        function(i, r, e) {
          var n = e(88), t = e(135);
          function o(l, c) {
            this.__wrapped__ = l, this.__actions__ = [], this.__chain__ = !!c, this.__index__ = 0, this.__values__ = void 0;
          }
          o.prototype = n(t.prototype), o.prototype.constructor = o, i.exports = o;
        },
        /* 237 */
        /***/
        function(i, r, e) {
          var n = e(228), t = e(206), o = t(n);
          i.exports = o;
        },
        /* 238 */
        /***/
        function(i, r, e) {
          var n = e(498), t = e(499), o = e(124), l = e(500);
          function c(d, u, h) {
            var A = u + "";
            return o(d, t(A, l(n(A), h)));
          }
          i.exports = c;
        },
        /* 239 */
        /***/
        function(i, r) {
          function e(n, t, o, l) {
            for (var c = n.length, d = o + (l ? 1 : -1); l ? d-- : ++d < c; )
              if (t(n[d], d, n))
                return d;
            return -1;
          }
          i.exports = e;
        },
        /* 240 */
        /***/
        function(i, r) {
          function e(n) {
            var t = n;
            return t.placeholder;
          }
          i.exports = e;
        },
        /* 241 */
        /***/
        function(i, r, e) {
          var n = e(508), t = e(11), o = e(70), l = NaN, c = /^[-+]0x[0-9a-f]+$/i, d = /^0b[01]+$/i, u = /^0o[0-7]+$/i, h = parseInt;
          function A(g) {
            if (typeof g == "number")
              return g;
            if (o(g))
              return l;
            if (t(g)) {
              var f = typeof g.valueOf == "function" ? g.valueOf() : g;
              g = t(f) ? f + "" : f;
            }
            if (typeof g != "string")
              return g === 0 ? g : +g;
            g = n(g);
            var p = d.test(g);
            return p || u.test(g) ? h(g.slice(2), p ? 2 : 8) : c.test(g) ? l : +g;
          }
          i.exports = A;
        },
        /* 242 */
        /***/
        function(i, r, e) {
          var n = e(98), t = e(243), o = e(99), l = 1, c = 2;
          function d(u, h, A, g, f, p) {
            var v = A & l, b = u.length, m = h.length;
            if (b != m && !(v && m > b))
              return !1;
            var y = p.get(u), U = p.get(h);
            if (y && U)
              return y == h && U == u;
            var B = -1, Q = !0, N = A & c ? new n() : void 0;
            for (p.set(u, h), p.set(h, u); ++B < b; ) {
              var J = u[B], w = h[B];
              if (g)
                var W = v ? g(w, J, B, h, u, p) : g(J, w, B, u, h, p);
              if (W !== void 0) {
                if (W)
                  continue;
                Q = !1;
                break;
              }
              if (N) {
                if (!t(h, function(G, Z) {
                  if (!o(N, Z) && (J === G || f(J, G, A, g, p)))
                    return N.push(Z);
                })) {
                  Q = !1;
                  break;
                }
              } else if (!(J === w || f(J, w, A, g, p))) {
                Q = !1;
                break;
              }
            }
            return p.delete(u), p.delete(h), Q;
          }
          i.exports = d;
        },
        /* 243 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = -1, l = n == null ? 0 : n.length; ++o < l; )
              if (t(n[o], o, n))
                return !0;
            return !1;
          }
          i.exports = e;
        },
        /* 244 */
        /***/
        function(i, r) {
          function e(n) {
            var t = -1, o = Array(n.size);
            return n.forEach(function(l, c) {
              o[++t] = [c, l];
            }), o;
          }
          i.exports = e;
        },
        /* 245 */
        /***/
        function(i, r, e) {
          var n = e(11);
          function t(o) {
            return o === o && !n(o);
          }
          i.exports = t;
        },
        /* 246 */
        /***/
        function(i, r) {
          function e(n, t) {
            return function(o) {
              return o == null ? !1 : o[n] === t && (t !== void 0 || n in Object(o));
            };
          }
          i.exports = e;
        },
        /* 247 */
        /***/
        function(i, r, e) {
          var n = e(523), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, o = /\\(\\)?/g, l = n(function(c) {
            var d = [];
            return c.charCodeAt(0) === 46 && d.push(""), c.replace(t, function(u, h, A, g) {
              d.push(A ? g.replace(o, "$1") : h || u);
            }), d;
          });
          i.exports = l;
        },
        /* 248 */
        /***/
        function(i, r, e) {
          var n = e(525), t = e(526);
          function o(l, c) {
            return l != null && t(l, c, n);
          }
          i.exports = o;
        },
        /* 249 */
        /***/
        function(i, r, e) {
          var n = e(120), t = e(532);
          function o(l, c, d, u, h) {
            var A = -1, g = l.length;
            for (d || (d = t), h || (h = []); ++A < g; ) {
              var f = l[A];
              c > 0 && d(f) ? c > 1 ? o(f, c - 1, d, u, h) : n(h, f) : u || (h[h.length] = f);
            }
            return h;
          }
          i.exports = o;
        },
        /* 250 */
        /***/
        function(i, r, e) {
          var n = e(535), t = n();
          i.exports = t;
        },
        /* 251 */
        /***/
        function(i, r, e) {
          var n = e(540), t = e(541);
          r.parse = Q, r.resolve = J, r.resolveObject = w, r.format = N, r.Url = o;
          function o() {
            this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
          }
          var l = /^([a-z0-9.+-]+:)/i, c = /:[0-9]*$/, d = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, u = ["<", ">", '"', "`", " ", "\r", `
`, "	"], h = ["{", "}", "|", "\\", "^", "`"].concat(u), A = ["'"].concat(h), g = ["%", "/", "?", ";", "#"].concat(A), f = ["/", "?", "#"], p = 255, v = /^[+a-z0-9A-Z_-]{0,63}$/, b = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, m = {
            javascript: !0,
            "javascript:": !0
          }, y = {
            javascript: !0,
            "javascript:": !0
          }, U = {
            http: !0,
            https: !0,
            ftp: !0,
            gopher: !0,
            file: !0,
            "http:": !0,
            "https:": !0,
            "ftp:": !0,
            "gopher:": !0,
            "file:": !0
          }, B = e(542);
          function Q(W, G, Z) {
            if (W && t.isObject(W) && W instanceof o) return W;
            var K = new o();
            return K.parse(W, G, Z), K;
          }
          o.prototype.parse = function(W, G, Z) {
            if (!t.isString(W))
              throw new TypeError("Parameter 'url' must be a string, not " + typeof W);
            var K = W.indexOf("?"), L = K !== -1 && K < W.indexOf("#") ? "?" : "#", O = W.split(L), de = /\\/g;
            O[0] = O[0].replace(de, "/"), W = O.join(L);
            var oe = W;
            if (oe = oe.trim(), !Z && W.split("#").length === 1) {
              var fe = d.exec(oe);
              if (fe)
                return this.path = oe, this.href = oe, this.pathname = fe[1], fe[2] ? (this.search = fe[2], G ? this.query = B.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : G && (this.search = "", this.query = {}), this;
            }
            var ge = l.exec(oe);
            if (ge) {
              ge = ge[0];
              var we = ge.toLowerCase();
              this.protocol = we, oe = oe.substr(ge.length);
            }
            if (Z || ge || oe.match(/^\/\/[^@\/]+@[^@\/]+/)) {
              var _e = oe.substr(0, 2) === "//";
              _e && !(ge && y[ge]) && (oe = oe.substr(2), this.slashes = !0);
            }
            if (!y[ge] && (_e || ge && !U[ge])) {
              for (var Te = -1, Pe = 0; Pe < f.length; Pe++) {
                var $e = oe.indexOf(f[Pe]);
                $e !== -1 && (Te === -1 || $e < Te) && (Te = $e);
              }
              var Bt, Le;
              Te === -1 ? Le = oe.lastIndexOf("@") : Le = oe.lastIndexOf("@", Te), Le !== -1 && (Bt = oe.slice(0, Le), oe = oe.slice(Le + 1), this.auth = decodeURIComponent(Bt)), Te = -1;
              for (var Pe = 0; Pe < g.length; Pe++) {
                var $e = oe.indexOf(g[Pe]);
                $e !== -1 && (Te === -1 || $e < Te) && (Te = $e);
              }
              Te === -1 && (Te = oe.length), this.host = oe.slice(0, Te), oe = oe.slice(Te), this.parseHost(), this.hostname = this.hostname || "";
              var at = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
              if (!at)
                for (var pt = this.hostname.split(/\./), Pe = 0, kt = pt.length; Pe < kt; Pe++) {
                  var _t = pt[Pe];
                  if (_t && !_t.match(v)) {
                    for (var Lt = "", Ft = 0, Zt = _t.length; Ft < Zt; Ft++)
                      _t.charCodeAt(Ft) > 127 ? Lt += "x" : Lt += _t[Ft];
                    if (!Lt.match(v)) {
                      var ft = pt.slice(0, Pe), It = pt.slice(Pe + 1), Kt = _t.match(b);
                      Kt && (ft.push(Kt[1]), It.unshift(Kt[2])), It.length && (oe = "/" + It.join(".") + oe), this.hostname = ft.join(".");
                      break;
                    }
                  }
                }
              this.hostname.length > p ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), at || (this.hostname = n.toASCII(this.hostname));
              var Sn = this.port ? ":" + this.port : "", Cn = this.hostname || "";
              this.host = Cn + Sn, this.href += this.host, at && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), oe[0] !== "/" && (oe = "/" + oe));
            }
            if (!m[we])
              for (var Pe = 0, kt = A.length; Pe < kt; Pe++) {
                var on = A[Pe];
                if (oe.indexOf(on) !== -1) {
                  var An = encodeURIComponent(on);
                  An === on && (An = escape(on)), oe = oe.split(on).join(An);
                }
              }
            var Ue = oe.indexOf("#");
            Ue !== -1 && (this.hash = oe.substr(Ue), oe = oe.slice(0, Ue));
            var ne = oe.indexOf("?");
            if (ne !== -1 ? (this.search = oe.substr(ne), this.query = oe.substr(ne + 1), G && (this.query = B.parse(this.query)), oe = oe.slice(0, ne)) : G && (this.search = "", this.query = {}), oe && (this.pathname = oe), U[we] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
              var Sn = this.pathname || "", se = this.search || "";
              this.path = Sn + se;
            }
            return this.href = this.format(), this;
          };
          function N(W) {
            return t.isString(W) && (W = Q(W)), W instanceof o ? W.format() : o.prototype.format.call(W);
          }
          o.prototype.format = function() {
            var W = this.auth || "";
            W && (W = encodeURIComponent(W), W = W.replace(/%3A/i, ":"), W += "@");
            var G = this.protocol || "", Z = this.pathname || "", K = this.hash || "", L = !1, O = "";
            this.host ? L = W + this.host : this.hostname && (L = W + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (L += ":" + this.port)), this.query && t.isObject(this.query) && Object.keys(this.query).length && (O = B.stringify(this.query));
            var de = this.search || O && "?" + O || "";
            return G && G.substr(-1) !== ":" && (G += ":"), this.slashes || (!G || U[G]) && L !== !1 ? (L = "//" + (L || ""), Z && Z.charAt(0) !== "/" && (Z = "/" + Z)) : L || (L = ""), K && K.charAt(0) !== "#" && (K = "#" + K), de && de.charAt(0) !== "?" && (de = "?" + de), Z = Z.replace(/[?#]/g, function(oe) {
              return encodeURIComponent(oe);
            }), de = de.replace("#", "%23"), G + L + Z + de + K;
          };
          function J(W, G) {
            return Q(W, !1, !0).resolve(G);
          }
          o.prototype.resolve = function(W) {
            return this.resolveObject(Q(W, !1, !0)).format();
          };
          function w(W, G) {
            return W ? Q(W, !1, !0).resolveObject(G) : G;
          }
          o.prototype.resolveObject = function(W) {
            if (t.isString(W)) {
              var G = new o();
              G.parse(W, !1, !0), W = G;
            }
            for (var Z = new o(), K = Object.keys(this), L = 0; L < K.length; L++) {
              var O = K[L];
              Z[O] = this[O];
            }
            if (Z.hash = W.hash, W.href === "")
              return Z.href = Z.format(), Z;
            if (W.slashes && !W.protocol) {
              for (var de = Object.keys(W), oe = 0; oe < de.length; oe++) {
                var fe = de[oe];
                fe !== "protocol" && (Z[fe] = W[fe]);
              }
              return U[Z.protocol] && Z.hostname && !Z.pathname && (Z.path = Z.pathname = "/"), Z.href = Z.format(), Z;
            }
            if (W.protocol && W.protocol !== Z.protocol) {
              if (!U[W.protocol]) {
                for (var ge = Object.keys(W), we = 0; we < ge.length; we++) {
                  var _e = ge[we];
                  Z[_e] = W[_e];
                }
                return Z.href = Z.format(), Z;
              }
              if (Z.protocol = W.protocol, !W.host && !y[W.protocol]) {
                for (var kt = (W.pathname || "").split("/"); kt.length && !(W.host = kt.shift()); ) ;
                W.host || (W.host = ""), W.hostname || (W.hostname = ""), kt[0] !== "" && kt.unshift(""), kt.length < 2 && kt.unshift(""), Z.pathname = kt.join("/");
              } else
                Z.pathname = W.pathname;
              if (Z.search = W.search, Z.query = W.query, Z.host = W.host || "", Z.auth = W.auth, Z.hostname = W.hostname || W.host, Z.port = W.port, Z.pathname || Z.search) {
                var Te = Z.pathname || "", Pe = Z.search || "";
                Z.path = Te + Pe;
              }
              return Z.slashes = Z.slashes || W.slashes, Z.href = Z.format(), Z;
            }
            var $e = Z.pathname && Z.pathname.charAt(0) === "/", Bt = W.host || W.pathname && W.pathname.charAt(0) === "/", Le = Bt || $e || Z.host && W.pathname, at = Le, pt = Z.pathname && Z.pathname.split("/") || [], kt = W.pathname && W.pathname.split("/") || [], _t = Z.protocol && !U[Z.protocol];
            if (_t && (Z.hostname = "", Z.port = null, Z.host && (pt[0] === "" ? pt[0] = Z.host : pt.unshift(Z.host)), Z.host = "", W.protocol && (W.hostname = null, W.port = null, W.host && (kt[0] === "" ? kt[0] = W.host : kt.unshift(W.host)), W.host = null), Le = Le && (kt[0] === "" || pt[0] === "")), Bt)
              Z.host = W.host || W.host === "" ? W.host : Z.host, Z.hostname = W.hostname || W.hostname === "" ? W.hostname : Z.hostname, Z.search = W.search, Z.query = W.query, pt = kt;
            else if (kt.length)
              pt || (pt = []), pt.pop(), pt = pt.concat(kt), Z.search = W.search, Z.query = W.query;
            else if (!t.isNullOrUndefined(W.search)) {
              if (_t) {
                Z.hostname = Z.host = pt.shift();
                var Lt = Z.host && Z.host.indexOf("@") > 0 ? Z.host.split("@") : !1;
                Lt && (Z.auth = Lt.shift(), Z.host = Z.hostname = Lt.shift());
              }
              return Z.search = W.search, Z.query = W.query, (!t.isNull(Z.pathname) || !t.isNull(Z.search)) && (Z.path = (Z.pathname ? Z.pathname : "") + (Z.search ? Z.search : "")), Z.href = Z.format(), Z;
            }
            if (!pt.length)
              return Z.pathname = null, Z.search ? Z.path = "/" + Z.search : Z.path = null, Z.href = Z.format(), Z;
            for (var Ft = pt.slice(-1)[0], Zt = (Z.host || W.host || pt.length > 1) && (Ft === "." || Ft === "..") || Ft === "", ft = 0, It = pt.length; It >= 0; It--)
              Ft = pt[It], Ft === "." ? pt.splice(It, 1) : Ft === ".." ? (pt.splice(It, 1), ft++) : ft && (pt.splice(It, 1), ft--);
            if (!Le && !at)
              for (; ft--; ft)
                pt.unshift("..");
            Le && pt[0] !== "" && (!pt[0] || pt[0].charAt(0) !== "/") && pt.unshift(""), Zt && pt.join("/").substr(-1) !== "/" && pt.push("");
            var Kt = pt[0] === "" || pt[0] && pt[0].charAt(0) === "/";
            if (_t) {
              Z.hostname = Z.host = Kt ? "" : pt.length ? pt.shift() : "";
              var Lt = Z.host && Z.host.indexOf("@") > 0 ? Z.host.split("@") : !1;
              Lt && (Z.auth = Lt.shift(), Z.host = Z.hostname = Lt.shift());
            }
            return Le = Le || Z.host && pt.length, Le && !Kt && pt.unshift(""), pt.length ? Z.pathname = pt.join("/") : (Z.pathname = null, Z.path = null), (!t.isNull(Z.pathname) || !t.isNull(Z.search)) && (Z.path = (Z.pathname ? Z.pathname : "") + (Z.search ? Z.search : "")), Z.auth = W.auth || Z.auth, Z.slashes = Z.slashes || W.slashes, Z.href = Z.format(), Z;
          }, o.prototype.parseHost = function() {
            var W = this.host, G = c.exec(W);
            G && (G = G[0], G !== ":" && (this.port = G.substr(1)), W = W.substr(0, W.length - G.length)), W && (this.hostname = W);
          };
        },
        /* 252 */
        /***/
        function(i, r, e) {
          (function(n) {
            r.__esModule = !0, r.default = t;
            function t() {
              return new n((o) => setTimeout(o));
            }
          }).call(this, e(2));
        },
        /* 253 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            t === void 0 && (t = {});
            const o = t.global || (typeof window !== void 0 ? window : Dn);
            return function() {
              if (o.navigator.mediaDevices) {
                const c = o.navigator.mediaDevices;
                return c.enumerateDevices && c.enumerateDevices.bind(c);
              }
            };
          }
        },
        /* 254 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          let n = "";
          var l = {
            getCurrentAudioInputDevice: () => n,
            setCurrentAudioInputDevice: (c) => {
              n = c;
            }
          };
          r.default = l;
        },
        /* 255 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(256)), l = (c, d) => new t.default(c, d);
          r.default = l;
        },
        /* 256 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(17)), o = n(e(549)), l = n(e(550)), c = n(e(551)), d = n(e(553));
          const u = {
            attributes: o.default,
            css: l.default,
            classNames: c.default,
            observers: d.default
          }, h = /^#([\w-]*)$/, A = function(m) {
            return Array.prototype.slice.call(m);
          }, g = function(m, y) {
            let U;
            if (typeof m == "undefined")
              return [];
            if (typeof m == "string") {
              U = [];
              const B = h.exec(m);
              if (y = y || document, B && B[1]) {
                const Q = y.getElementById(B[1]);
                Q && U.push(Q);
              } else
                U = y.querySelectorAll(m);
            } else m && (m.nodeType || (typeof window !== void 0 ? window : Dn).XMLHttpRequest && m instanceof (typeof window !== void 0 ? window : Dn).XMLHttpRequest || m === (typeof window !== void 0 ? window : Dn)) ? (U = [m], y = m) : Array.isArray(m) ? (U = m.slice(), y = null) : U = A(U);
            return U;
          }, f = function(m, y) {
            const U = g(m, y);
            this.context = y, this.toArray = function() {
              return U;
            }, this.length = U.length, this.first = U[0], this.last = U[U.length - 1], this.get = function(B) {
              return B === void 0 ? U : U[B];
            };
          };
          f._attachToOTHelpers = {}, f._attachToOTHelpers.removeElement = function(b) {
            return new f(b).remove();
          }, f.prototype.getAsArray = function() {
            let b = this.get();
            return (0, t.default)(b.forEach) || (b = A(b)), b;
          }, f.prototype.some = function(b, m) {
            return this.getAsArray().some(b, m);
          }, f.prototype.forEach = function(b, m) {
            return this.getAsArray().forEach(b, m), this;
          }, f.prototype.map = function(b, m) {
            return new f(this.getAsArray().map(b, m), this.context);
          }, f.prototype.filter = function(b, m) {
            return new f(this.getAsArray().filter(b, m), this.context);
          }, f.prototype.find = function(b) {
            return new f(b, this.first);
          }, f.prototype.on = function(b, m) {
            return this.forEach((y) => {
              y.addEventListener(b, m, !1);
            });
          }, f.prototype.off = function(b, m) {
            return this.forEach((y) => {
              y.removeEventListener(b, m, !1);
            });
          }, f.prototype.once = function(b, m) {
            const y = function() {
              this.off(b, y), m(...arguments);
            }.bind(this);
            return this.on(b, y);
          }, f.prototype.appendTo = function(b) {
            if (!b)
              throw new Error("appendTo requires a DOMElement to append to.");
            return this.forEach((m) => {
              b.appendChild(m);
            });
          }, f.prototype.append = function() {
            const b = this.first;
            return b ? (Array.prototype.forEach.call(arguments, (m) => {
              b.appendChild(m);
            }), this) : this;
          }, f.prototype.prepend = function() {
            if (arguments.length === 0)
              return this;
            const b = this.first;
            let m;
            return b ? (m = Array.prototype.slice.call(arguments), b.firstElementChild || b.appendChild(m.shift()), m.forEach((y) => {
              b.insertBefore(y, b.firstElementChild);
            }), this) : this;
          }, f.prototype.after = function(b) {
            if (!b)
              throw new Error("after requires a DOMElement to insert after");
            return this.forEach((m) => {
              m.parentElement && (b !== m.parentNode.lastChild ? m.parentElement.insertBefore(m, b) : m.parentElement.appendChild(m));
            });
          }, f.prototype.before = function(b) {
            if (!b)
              throw new Error("before requires a DOMElement to insert before");
            return this.forEach((m) => {
              m.parentElement && m.parentElement.insertBefore(m, b);
            });
          }, f.prototype.remove = function() {
            return this.forEach((b) => {
              b.parentNode && b.parentNode.removeChild(b);
            });
          }, f.prototype.empty = function() {
            return this.forEach((b) => {
              for (; b.firstChild; )
                b.removeChild(b.firstChild);
            });
          }, f.prototype.isDisplayNone = function() {
            return this.some((b) => ((b == null ? void 0 : b.offsetWidth) === 0 || (b == null ? void 0 : b.offsetHeight) === 0) && new f(b).css("display") === "none" ? !0 : b != null && b.parentNode && b != null && b.parentNode.style ? new f(b.parentNode).isDisplayNone() : !1);
          };
          const p = function b(m) {
            return (m.offsetWidth === 0 || m.offsetHeight === 0) && new f(m).css("display") === "none" ? m : m.parentNode && m.parentNode.style ? b(m.parentNode) : null;
          };
          f._attachToOTHelpers.emptyElement = function(b) {
            return new f(b).empty();
          }, f._attachToOTHelpers._findElementWithDisplayNone = p, u.css(f, p), u.attributes(f), u.classNames(f), u.observers(f), ["on", "off", "isDisplayNone", "show", "hide", "css", "makeVisibleAndYield", "addClass", "removeClass"].forEach((b) => {
            f._attachToOTHelpers[b] = function() {
              const m = Array.prototype.slice.apply(arguments), y = m.shift(), U = new f(y);
              return f.prototype[b].apply(U, m);
            };
          });
          var v = f;
          r.default = v;
        },
        /* 257 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(1));
          const o = (0, t.default)("deprecation");
          function l(c, d, u) {
            let h = u === void 0 ? {} : u, A = h.value, g = h.name, f = g === void 0 ? `${d}` : g, p = h.getWarning, v = p === void 0 ? "" : p, b = h.setWarning, m = b === void 0 ? "" : b, y = h.canSet, U = y === void 0 ? !1 : y, B = h.warnOnSet, Q = B === void 0 ? !1 : B, N = A, J = !1, w = !Q;
            Object.defineProperty(c, d, {
              get() {
                return J || (J = !0, o.warn(`${f} is deprecated, and will be removed in the future. ${v}`.trim())), N;
              },
              set(G) {
                U && (N = G), w || (w = !0, U ? o.warn(`${f} is deprecated. ${m}`.trim()) : o.warn(`${f} is deprecated, and will be removed in the future. ${m}`.trim()));
              }
            });
          }
        },
        /* 258 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(9)), o = n(e(3)), l = n(e(255)), c = n(e(259));
          const d = {};
          function u(A) {
            if (typeof A == "string")
              return A;
            const g = [];
            return Object.keys(A).forEach((f) => {
              g.push(`${encodeURIComponent(f)}=${encodeURIComponent(A[f])}`);
            }), g.join("&").replace(/\+/g, "%20");
          }
          o.default.name !== "Node" && (d.request = function(A, g, f) {
            const p = new (typeof window !== void 0 ? window : Dn).XMLHttpRequest(), v = g || {};
            if (!v.method) {
              f(new Error("No HTTP method specified in options"));
              return;
            }
            g.overrideMimeType && (p.overrideMimeType && p.overrideMimeType(g.overrideMimeType), delete g.overrideMimeType), f && ((0, l.default)(p).on("load", (m) => {
              const y = m.target.status;
              y >= 200 && (y < 300 || y === 304) ? f(null, m) : f(m);
            }), (0, l.default)(p).on("error", f)), p.open(g.method, A, !0), v.headers || (v.headers = {});
            for (const m in v.headers)
              Object.prototype.hasOwnProperty.call(v.headers, m) && p.setRequestHeader(m, v.headers[m]);
            p.send(g.body && u(g.body));
          }, d.get = function(A, g, f) {
            const p = (0, t.default)(g || {}, {
              method: "GET"
            });
            d.request(A, p, f);
          }, d.post = function(A, g, f) {
            const p = (0, t.default)(g || {}, {
              method: "POST"
            });
            d.request(A, p, f);
          }, d.getJSON = function(A, g, f) {
            g = g || {};
            const p = function(m, y) {
              if (m)
                f(m, y && y.target && y.target.responseText);
              else {
                let U;
                try {
                  U = JSON.parse(y.target.responseText);
                } catch (B) {
                  f(B, y && y.target && y.target.responseText);
                  return;
                }
                f(null, U, y);
              }
            }, v = (0, t.default)({
              Accept: "application/json"
            }, g.headers || {});
            d.get(A, (0, t.default)(g || {}, {
              headers: v
            }), p);
          }, (0, c.default)(d));
          var h = d;
          r.default = h;
        },
        /* 259 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = (o) => {
            const l = {};
            Object.keys(o).forEach((c) => {
              l[c] = o[c];
            }), o._attachToOTHelpers = l;
          };
          r.default = t;
        },
        /* 260 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = p;
          var t = n(e(9)), o = n(e(16)), l = n(e(1)), c = n(e(558)), d = n(e(258)), u = n(e(103)), h = e(71);
          const A = (0, l.default)("analytics"), g = (0, o.default)(), f = new c.default();
          function p(v) {
            var b = this;
            let m = v.loggingUrl, y = v.queue, U = y === void 0 ? f : y, B = v.ajax, Q = B === void 0 ? d.default : B;
            this.loggingUrl = m, this.updateEndPoints = () => {
              if (!this.proxyUrl) {
                this.proxyUrl = (0, h.getProxyUrl)();
                const W = (0, u.default)(this.loggingUrl, this.proxyUrl);
                this.loggingUrl = W;
              }
              this.endPoint = `${this.loggingUrl}/logging/ClientEvent`, this.endPointQos = `${this.loggingUrl}/logging/ClientQos`;
            }, this.updateEndPoints();
            const N = {}, J = function(G, Z, K) {
              Z === void 0 && (Z = () => {
              }), U.add((L) => {
                A.debug("sending analytics:", b.loggingUrl, G), Q.post(K ? b.endPointQos : b.endPoint, {
                  body: G,
                  overrideMimeType: "text/plain",
                  headers: {
                    Accept: "text/plain",
                    "Content-Type": "application/json"
                  }
                }, (O) => {
                  O && A.debug("Failed to send ClientEvent, moving on to the next item."), Z(O || void 0), L();
                });
              });
            }, w = (W, G, Z) => {
              if (!Z)
                return !1;
              const K = [Z, G, W].join("_");
              return (N[K] || 0) >= 100;
            };
            this.logError = function(W, G, Z, K, L) {
              K === void 0 && (K = null), L === void 0 && (L = {});
              const O = L, de = O.partnerId;
              if (w(W, G, de))
                return;
              const oe = [de, G, W].join("_"), fe = K;
              N[oe] = typeof N[oe] != "undefined" ? N[oe] + 1 : 1, b.logEvent((0, t.default)(L, {
                action: `${G}.${W}`,
                payload: fe
              }), !1);
            }, this.logEvent = function(W, G, Z, K) {
              G === void 0 && (G = !1), K === void 0 && (K = () => {
              }), b.updateEndPoints();
              const L = Object.assign({}, W, {
                clientInstanceId: g
              });
              if (Z && !isNaN(Z) && Math.random() > Z) {
                A.debug("skipping sending analytics due to throttle:", L);
                return;
              }
              A.debug("queueing analytics:", b.loggingUrl, L);
              let O;
              try {
                O = JSON.stringify(L);
              } catch (de) {
                K(de);
                return;
              }
              J(O, K, G);
            }, this.logQOS = (W) => this.logEvent(W, !0);
          }
        },
        /* 261 */
        /***/
        function(i, r) {
          var e = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
          if (e) {
            var n = new Uint8Array(16);
            i.exports = function() {
              return e(n), n;
            };
          } else {
            var t = new Array(16);
            i.exports = function() {
              for (var l = 0, c; l < 16; l++)
                l & 3 || (c = Math.random() * 4294967296), t[l] = c >>> ((l & 3) << 3) & 255;
              return t;
            };
          }
        },
        /* 262 */
        /***/
        function(i, r) {
          for (var e = [], n = 0; n < 256; ++n)
            e[n] = (n + 256).toString(16).substr(1);
          function t(o, l) {
            var c = l || 0, d = e;
            return [
              d[o[c++]],
              d[o[c++]],
              d[o[c++]],
              d[o[c++]],
              "-",
              d[o[c++]],
              d[o[c++]],
              "-",
              d[o[c++]],
              d[o[c++]],
              "-",
              d[o[c++]],
              d[o[c++]],
              "-",
              d[o[c++]],
              d[o[c++]],
              d[o[c++]],
              d[o[c++]],
              d[o[c++]],
              d[o[c++]]
            ].join("");
          }
          i.exports = t;
        },
        /* 263 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = d;
          var t = n(e(17)), o = n(e(6)), l = n(e(1));
          const c = (0, l.default)("Collection");
          function d(u) {
            let h = [], A = {};
            const g = u || "id";
            (0, o.default)(this);
            const f = function(m, y) {
              return (0, t.default)(m[y]) ? m[y]() : m[y];
            }, p = function(m) {
              this.trigger("update", m), this.trigger(`update:${m.target.id}`, m);
            }.bind(this), v = function(m) {
              this.remove(m.target, m.reason);
            }.bind(this);
            this.reset = function() {
              h.forEach(function(b) {
                b.off("updated", p, this), b.off("destroyed", v, this);
              }, this), h = [], A = {};
            }, this.destroy = function(b) {
              h.forEach((m) => {
                m && typeof m.destroy == "function" && m.destroy(b, !0);
              }), this.reset(), this.off();
            }, this.get = function(b) {
              return b && A[b] !== void 0 ? h[A[b]] : void 0;
            }, this.has = function(b) {
              return b && A[b] !== void 0;
            }, this.toString = function() {
              return h.toString();
            }, this.where = function(b, m) {
              return (0, t.default)(b) ? h.filter(b, m) : h.filter((y) => {
                for (const U in b)
                  if (b.hasOwnProperty(U) && f(y, U) !== b[U])
                    return !1;
                return !0;
              });
            }, this.find = function(b, m) {
              let y;
              (0, t.default)(b) ? y = b : y = function(B) {
                for (const Q in b)
                  if (b.hasOwnProperty(Q) && f(B, Q) !== b[Q])
                    return !1;
                return !0;
              }, y = y.bind(m);
              for (let U = 0; U < h.length; ++U)
                if (y(h[U]) === !0)
                  return h[U];
              return null;
            }, this.forEach = function(b, m) {
              return h.forEach(b, m), this;
            }, this.map = function(b) {
              return h.map(b);
            }, this.add = function(b) {
              const m = f(b, g);
              return this.has(m) ? (c.warn(`Model ${m} is already in the collection`, h), this) : (A[m] = h.push(b) - 1, b.on("updated", p, this), b.on("destroyed", v, this), this.trigger("add", b), this.trigger(`add:${m}`, b), this);
            }, this.remove = function(b, m) {
              const y = f(b, g);
              h.splice(A[y], 1);
              for (let U = A[y]; U < h.length; ++U)
                A[f(h[U], g)] = U;
              return delete A[y], b.off("updated", p, this), b.off("destroyed", v, this), this.trigger("remove", b, m), this.trigger(`remove:${y}`, b, m), this;
            }, this._triggerAddEvents = function() {
              this.where.apply(this, arguments).forEach(function(b) {
                this.trigger("add", b), this.trigger(`add:${f(b, g)}`, b);
              }, this);
            }, this.length = function() {
              return h.length;
            };
          }
        },
        /* 264 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(17)), l = t(e(16)), c = t(e(1));
            const d = (0, c.default)("guidStorage"), u = {};
            let h, A;
            const g = function(b) {
              return !((0, o.default)(b.get) && (0, o.default)(b.set));
            }, f = function(b) {
              if (A) {
                b(null, A);
                return;
              }
              h.get(b);
            };
            u.override = (v) => {
              if (g(v))
                throw new Error("The storageInterface argument does not seem to be valid, it must implement get and set methods");
              h !== v && (h = v, A && h.set(A, (b) => {
                b && d.error(`Failed to send initial Guid value (${A}) to the newly assigned Guid Storage. The error was: ${b}`);
              }));
            }, u.get = (v) => {
              f((b, m) => {
                if (b) {
                  v(b);
                  return;
                }
                m ? A || (A = m) : (m = (0, l.default)(), h.set(m, (y) => {
                  if (y) {
                    v(y);
                    return;
                  }
                  A = m;
                })), v(null, A);
              });
            }, u.getAsync = () => new n((v, b) => {
              u.get((m, y) => m ? b(m) : v(y));
            }), u.override({
              get(v) {
                let b;
                try {
                  b = (typeof window !== void 0 ? window : Dn).localStorage.getItem("opentok_client_id");
                } catch {
                  b || (b = (0, l.default)());
                }
                v(null, b);
              },
              set(v, b) {
                try {
                  (typeof window !== void 0 ? window : Dn).localStorage.setItem("opentok_client_id", v);
                } catch {
                }
                b(null);
              }
            }), u.set = (v) => {
              A = v;
            };
            var p = u;
            r.default = p;
          }).call(this, e(2));
        },
        /* 265 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(11)), o = n(e(3));
          let l;
          const c = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"], d = function(g, f, p) {
            switch (arguments.length) {
              case 1:
                (0, t.default)(g) && (p = g, f = void 0, g = void 0);
                break;
              case 2:
                (0, t.default)(f) && (p = f, f = void 0);
                break;
            }
            if (p instanceof Error)
              for (let v = 0, b = c.length; v < b; ++v)
                this[c[v]] = p[c[v]];
            else if ((0, t.default)(p))
              for (const v in p)
                p.hasOwnProperty(v) && (this[v] = p[v]);
            if (!(this.fileName && this.lineNumber && this.columnNumber && this.stack)) {
              const v = l();
              !this.fileName && v.fileName && (this.fileName = v.fileName), !this.lineNumber && v.lineNumber && (this.lineNumber = v.lineNumber), !this.columnNumber && v.columnNumber && (this.columnNumber = v.columnNumber), !this.stack && v.stack && (this.stack = v.stack);
            }
            !this.message && g && (this.message = g), (!this.name || this.name === "Error") && f && (this.name = f);
          };
          d.prototype = Object.create(Error.prototype), d.prototype.toString = function() {
            let A = "";
            return this.fileName && (A += ` ${this.fileName}`), this.lineNumber && (A += ` ${this.lineNumber}`, this.columnNumber && (A += `:${this.columnNumber}`)), `<${this.name ? `${this.name} ` : ""}${this.message}${A}>`;
          }, d.prototype.valueOf = d.prototype.toString;
          const u = function(g, f) {
            return f.slice(2).map((p) => {
              const v = {
                fileName: p.getFileName(),
                linenumber: p.getLineNumber(),
                columnNumber: p.getColumnNumber()
              };
              return p.getFunctionName() && (v.functionName = p.getFunctionName()), p.getMethodName() && (v.methodName = p.getMethodName()), p.getThis() && (v.self = p.getThis()), v;
            });
          };
          l = function() {
            const g = {};
            let f, p, v;
            switch (o.default.name) {
              case "Firefox":
              case "Safari":
                try {
                  (typeof window !== void 0 ? window : Dn).call.js.is.explody();
                } catch (y) {
                  v = y;
                }
                f = (v.stack || "").split(`
`), f.shift(), f.shift(), g.stack = f, p = /@(.+?):([0-9]+)(:([0-9]+))?$/.exec(f[0]), p && (g.fileName = p[1], g.lineNumber = parseInt(p[2], 10), p.length > 3 && (g.columnNumber = parseInt(p[4], 10)));
                break;
              case "Chrome":
              case "Node":
              case "Opera":
                var b = Error.prepareStackTrace;
                Error.prepareStackTrace = u, v = new Error(), g.stack = v.stack, Error.prepareStackTrace = b;
                var m = g.stack[0];
                g.lineNumber = m.lineNumber, g.columnNumber = m.columnNumber, g.fileName = m.fileName, m.functionName && (g.functionName = m.functionName), m.methodName && (g.methodName = m.methodName), m.self && (g.self = m.self);
                break;
              default:
                v = new Error(), v.stack && (g.stack = v.stack.split(`
`));
                break;
            }
            return v.message && (g.message = v.message), g;
          };
          var h = d;
          r.default = h;
        },
        /* 266 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(13)), o = n(e(8));
          function l(c) {
            c === void 0 && (c = {});
            const d = c.Errors || o.default, u = c.otError || (0, t.default)(), h = {};
            return (typeof window !== void 0 ? window : Dn).MediaError && (h[(typeof window !== void 0 ? window : Dn).MediaError.MEDIA_ERR_ABORTED] = {
              name: d.MEDIA_ERR_ABORTED,
              message: "The fetching process for the media resource was aborted by the user agent at the user's request."
            }, h[(typeof window !== void 0 ? window : Dn).MediaError.MEDIA_ERR_NETWORK] = {
              name: d.MEDIA_ERR_NETWORK,
              message: "A network error of some description caused the user agent to stop fetching the media resource, after the resource was established to be usable."
            }, h[(typeof window !== void 0 ? window : Dn).MediaError.MEDIA_ERR_DECODE] = {
              name: d.MEDIA_ERR_DECODE,
              message: "An error of some description occurred while decoding the media resource, after the resource was established to be usable."
            }, h[(typeof window !== void 0 ? window : Dn).MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED] = {
              name: d.MEDIA_ERR_SRC_NOT_SUPPORTED,
              message: "The media resource indicated by the src attribute was not suitable."
            }), function(g) {
              const f = h[g.code];
              return f ? u(f.name, new Error(`There was an unexpected problem with the Video Stream: ${f.message}`)) : new Error(`An unknown error occurred${g.message ? `: ${g.message}` : "."}`);
            };
          }
        },
        /* 267 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(149)), l = n(e(570)), d = function(h) {
            h === void 0 && (h = {});
            const A = h.hasOwnProperty("env") ? h.env : t.default, g = h.createVideoElementUsingNativeAPI || o.default, f = h.createVideoElementForSafari || l.default;
            let p;
            return A != null && A.isSafari ? p = f() : p = g(), p.autoplay = !0, p.playsinline = !0, p.setAttribute("autoplay", ""), p.setAttribute("playsinline", ""), p;
          };
          r.default = d;
        },
        /* 268 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(50));
          let o = /* @__PURE__ */ function() {
            function l(d, u) {
              var h;
              let A = u === void 0 ? {} : u, g = A.requestAnimationFrame, f = g === void 0 ? (h = window).requestAnimationFrame.bind(h) : g;
              this._lastCalled = (0, t.default)(), this._audioLevel = void 0, this._running = !1, this._requestAnimationFrame = f, this._getAudioLevel = d, this._startLoop();
            }
            var c = l.prototype;
            return c._startLoop = function() {
              this._running || (this._running = !0, this._requestAnimationFrame(this._loop.bind(this)));
            }, c._loop = function() {
              this._getAudioLevel((u, h) => {
                let A = null;
                if (!u) {
                  for (let g = 0; g < h.length; g += 1) {
                    const f = h[g];
                    let p = null;
                    if (f.audioOutputLevel !== void 0) {
                      const v = parseFloat(f.audioOutputLevel) / 32768;
                      isNaN(v) || (p = v);
                    } else f.audioLevel !== void 0 && (p = f.audioLevel);
                    p !== null && (A === null || p > A) && (A = p);
                  }
                  this._audioLevel = A, this._running && (0, t.default)() - this._lastCalled < 1e4 ? this._requestAnimationFrame(this._loop.bind(this)) : this._running = !1;
                }
              });
            }, c.destroy = function() {
              this._running = !1;
            }, c.sample = function(u) {
              if (typeof u == "function")
                throw new Error("sample no longer takes a callback");
              return this._startLoop(), this._lastCalled = (0, t.default)(), this._audioLevel;
            }, l;
          }();
          r.default = o;
        },
        /* 269 */
        /***/
        function(i, r, e) {
          var n = {};
          n.generateIdentifier = function() {
            return Math.random().toString(36).substr(2, 10);
          }, n.localCName = n.generateIdentifier(), n.splitLines = function(t) {
            return t.trim().split(`
`).map(function(o) {
              return o.trim();
            });
          }, n.splitSections = function(t) {
            var o = t.split(`
m=`);
            return o.map(function(l, c) {
              return (c > 0 ? "m=" + l : l).trim() + `\r
`;
            });
          }, n.getDescription = function(t) {
            var o = n.splitSections(t);
            return o && o[0];
          }, n.getMediaSections = function(t) {
            var o = n.splitSections(t);
            return o.shift(), o;
          }, n.matchPrefix = function(t, o) {
            return n.splitLines(t).filter(function(l) {
              return l.indexOf(o) === 0;
            });
          }, n.parseCandidate = function(t) {
            var o;
            t.indexOf("a=candidate:") === 0 ? o = t.substring(12).split(" ") : o = t.substring(10).split(" ");
            for (var l = {
              foundation: o[0],
              component: parseInt(o[1], 10),
              protocol: o[2].toLowerCase(),
              priority: parseInt(o[3], 10),
              ip: o[4],
              address: o[4],
              // address is an alias for ip.
              port: parseInt(o[5], 10),
              // skip parts[6] == 'typ'
              type: o[7]
            }, c = 8; c < o.length; c += 2)
              switch (o[c]) {
                case "raddr":
                  l.relatedAddress = o[c + 1];
                  break;
                case "rport":
                  l.relatedPort = parseInt(o[c + 1], 10);
                  break;
                case "tcptype":
                  l.tcpType = o[c + 1];
                  break;
                case "ufrag":
                  l.ufrag = o[c + 1], l.usernameFragment = o[c + 1];
                  break;
                default:
                  l[o[c]] = o[c + 1];
                  break;
              }
            return l;
          }, n.writeCandidate = function(t) {
            var o = [];
            o.push(t.foundation), o.push(t.component), o.push(t.protocol.toUpperCase()), o.push(t.priority), o.push(t.address || t.ip), o.push(t.port);
            var l = t.type;
            return o.push("typ"), o.push(l), l !== "host" && t.relatedAddress && t.relatedPort && (o.push("raddr"), o.push(t.relatedAddress), o.push("rport"), o.push(t.relatedPort)), t.tcpType && t.protocol.toLowerCase() === "tcp" && (o.push("tcptype"), o.push(t.tcpType)), (t.usernameFragment || t.ufrag) && (o.push("ufrag"), o.push(t.usernameFragment || t.ufrag)), "candidate:" + o.join(" ");
          }, n.parseIceOptions = function(t) {
            return t.substr(14).split(" ");
          }, n.parseRtpMap = function(t) {
            var o = t.substr(9).split(" "), l = {
              payloadType: parseInt(o.shift(), 10)
              // was: id
            };
            return o = o[0].split("/"), l.name = o[0], l.clockRate = parseInt(o[1], 10), l.channels = o.length === 3 ? parseInt(o[2], 10) : 1, l.numChannels = l.channels, l;
          }, n.writeRtpMap = function(t) {
            var o = t.payloadType;
            t.preferredPayloadType !== void 0 && (o = t.preferredPayloadType);
            var l = t.channels || t.numChannels || 1;
            return "a=rtpmap:" + o + " " + t.name + "/" + t.clockRate + (l !== 1 ? "/" + l : "") + `\r
`;
          }, n.parseExtmap = function(t) {
            var o = t.substr(9).split(" ");
            return {
              id: parseInt(o[0], 10),
              direction: o[0].indexOf("/") > 0 ? o[0].split("/")[1] : "sendrecv",
              uri: o[1]
            };
          }, n.writeExtmap = function(t) {
            return "a=extmap:" + (t.id || t.preferredId) + (t.direction && t.direction !== "sendrecv" ? "/" + t.direction : "") + " " + t.uri + `\r
`;
          }, n.parseFmtp = function(t) {
            for (var o = {}, l, c = t.substr(t.indexOf(" ") + 1).split(";"), d = 0; d < c.length; d++)
              l = c[d].trim().split("="), o[l[0].trim()] = l[1];
            return o;
          }, n.writeFmtp = function(t) {
            var o = "", l = t.payloadType;
            if (t.preferredPayloadType !== void 0 && (l = t.preferredPayloadType), t.parameters && Object.keys(t.parameters).length) {
              var c = [];
              Object.keys(t.parameters).forEach(function(d) {
                t.parameters[d] ? c.push(d + "=" + t.parameters[d]) : c.push(d);
              }), o += "a=fmtp:" + l + " " + c.join(";") + `\r
`;
            }
            return o;
          }, n.parseRtcpFb = function(t) {
            var o = t.substr(t.indexOf(" ") + 1).split(" ");
            return {
              type: o.shift(),
              parameter: o.join(" ")
            };
          }, n.writeRtcpFb = function(t) {
            var o = "", l = t.payloadType;
            return t.preferredPayloadType !== void 0 && (l = t.preferredPayloadType), t.rtcpFeedback && t.rtcpFeedback.length && t.rtcpFeedback.forEach(function(c) {
              o += "a=rtcp-fb:" + l + " " + c.type + (c.parameter && c.parameter.length ? " " + c.parameter : "") + `\r
`;
            }), o;
          }, n.parseSsrcMedia = function(t) {
            var o = t.indexOf(" "), l = {
              ssrc: parseInt(t.substr(7, o - 7), 10)
            }, c = t.indexOf(":", o);
            return c > -1 ? (l.attribute = t.substr(o + 1, c - o - 1), l.value = t.substr(c + 1)) : l.attribute = t.substr(o + 1), l;
          }, n.parseSsrcGroup = function(t) {
            var o = t.substr(13).split(" ");
            return {
              semantics: o.shift(),
              ssrcs: o.map(function(l) {
                return parseInt(l, 10);
              })
            };
          }, n.getMid = function(t) {
            var o = n.matchPrefix(t, "a=mid:")[0];
            if (o)
              return o.substr(6);
          }, n.parseFingerprint = function(t) {
            var o = t.substr(14).split(" ");
            return {
              algorithm: o[0].toLowerCase(),
              // algorithm is case-sensitive in Edge.
              value: o[1]
            };
          }, n.getDtlsParameters = function(t, o) {
            var l = n.matchPrefix(
              t + o,
              "a=fingerprint:"
            );
            return {
              role: "auto",
              fingerprints: l.map(n.parseFingerprint)
            };
          }, n.writeDtlsParameters = function(t, o) {
            var l = "a=setup:" + o + `\r
`;
            return t.fingerprints.forEach(function(c) {
              l += "a=fingerprint:" + c.algorithm + " " + c.value + `\r
`;
            }), l;
          }, n.parseCryptoLine = function(t) {
            var o = t.substr(9).split(" ");
            return {
              tag: parseInt(o[0], 10),
              cryptoSuite: o[1],
              keyParams: o[2],
              sessionParams: o.slice(3)
            };
          }, n.writeCryptoLine = function(t) {
            return "a=crypto:" + t.tag + " " + t.cryptoSuite + " " + (typeof t.keyParams == "object" ? n.writeCryptoKeyParams(t.keyParams) : t.keyParams) + (t.sessionParams ? " " + t.sessionParams.join(" ") : "") + `\r
`;
          }, n.parseCryptoKeyParams = function(t) {
            if (t.indexOf("inline:") !== 0)
              return null;
            var o = t.substr(7).split("|");
            return {
              keyMethod: "inline",
              keySalt: o[0],
              lifeTime: o[1],
              mkiValue: o[2] ? o[2].split(":")[0] : void 0,
              mkiLength: o[2] ? o[2].split(":")[1] : void 0
            };
          }, n.writeCryptoKeyParams = function(t) {
            return t.keyMethod + ":" + t.keySalt + (t.lifeTime ? "|" + t.lifeTime : "") + (t.mkiValue && t.mkiLength ? "|" + t.mkiValue + ":" + t.mkiLength : "");
          }, n.getCryptoParameters = function(t, o) {
            var l = n.matchPrefix(
              t + o,
              "a=crypto:"
            );
            return l.map(n.parseCryptoLine);
          }, n.getIceParameters = function(t, o) {
            var l = n.matchPrefix(
              t + o,
              "a=ice-ufrag:"
            )[0], c = n.matchPrefix(
              t + o,
              "a=ice-pwd:"
            )[0];
            return l && c ? {
              usernameFragment: l.substr(12),
              password: c.substr(10)
            } : null;
          }, n.writeIceParameters = function(t) {
            return "a=ice-ufrag:" + t.usernameFragment + `\r
a=ice-pwd:` + t.password + `\r
`;
          }, n.parseRtpParameters = function(t) {
            for (var o = {
              codecs: [],
              headerExtensions: [],
              fecMechanisms: [],
              rtcp: []
            }, l = n.splitLines(t), c = l[0].split(" "), d = 3; d < c.length; d++) {
              var u = c[d], h = n.matchPrefix(
                t,
                "a=rtpmap:" + u + " "
              )[0];
              if (h) {
                var A = n.parseRtpMap(h), g = n.matchPrefix(
                  t,
                  "a=fmtp:" + u + " "
                );
                switch (A.parameters = g.length ? n.parseFmtp(g[0]) : {}, A.rtcpFeedback = n.matchPrefix(
                  t,
                  "a=rtcp-fb:" + u + " "
                ).map(n.parseRtcpFb), o.codecs.push(A), A.name.toUpperCase()) {
                  case "RED":
                  case "ULPFEC":
                    o.fecMechanisms.push(A.name.toUpperCase());
                    break;
                }
              }
            }
            return n.matchPrefix(t, "a=extmap:").forEach(function(f) {
              o.headerExtensions.push(n.parseExtmap(f));
            }), o;
          }, n.writeRtpDescription = function(t, o) {
            var l = "";
            l += "m=" + t + " ", l += o.codecs.length > 0 ? "9" : "0", l += " UDP/TLS/RTP/SAVPF ", l += o.codecs.map(function(d) {
              return d.preferredPayloadType !== void 0 ? d.preferredPayloadType : d.payloadType;
            }).join(" ") + `\r
`, l += `c=IN IP4 0.0.0.0\r
`, l += `a=rtcp:9 IN IP4 0.0.0.0\r
`, o.codecs.forEach(function(d) {
              l += n.writeRtpMap(d), l += n.writeFmtp(d), l += n.writeRtcpFb(d);
            });
            var c = 0;
            return o.codecs.forEach(function(d) {
              d.maxptime > c && (c = d.maxptime);
            }), c > 0 && (l += "a=maxptime:" + c + `\r
`), l += `a=rtcp-mux\r
`, o.headerExtensions && o.headerExtensions.forEach(function(d) {
              l += n.writeExtmap(d);
            }), l;
          }, n.parseRtpEncodingParameters = function(t) {
            var o = [], l = n.parseRtpParameters(t), c = l.fecMechanisms.indexOf("RED") !== -1, d = l.fecMechanisms.indexOf("ULPFEC") !== -1, u = n.matchPrefix(t, "a=ssrc:").map(function(p) {
              return n.parseSsrcMedia(p);
            }).filter(function(p) {
              return p.attribute === "cname";
            }), h = u.length > 0 && u[0].ssrc, A, g = n.matchPrefix(t, "a=ssrc-group:FID").map(function(p) {
              var v = p.substr(17).split(" ");
              return v.map(function(b) {
                return parseInt(b, 10);
              });
            });
            g.length > 0 && g[0].length > 1 && g[0][0] === h && (A = g[0][1]), l.codecs.forEach(function(p) {
              if (p.name.toUpperCase() === "RTX" && p.parameters.apt) {
                var v = {
                  ssrc: h,
                  codecPayloadType: parseInt(p.parameters.apt, 10)
                };
                h && A && (v.rtx = { ssrc: A }), o.push(v), c && (v = JSON.parse(JSON.stringify(v)), v.fec = {
                  ssrc: h,
                  mechanism: d ? "red+ulpfec" : "red"
                }, o.push(v));
              }
            }), o.length === 0 && h && o.push({
              ssrc: h
            });
            var f = n.matchPrefix(t, "b=");
            return f.length && (f[0].indexOf("b=TIAS:") === 0 ? f = parseInt(f[0].substr(7), 10) : f[0].indexOf("b=AS:") === 0 ? f = parseInt(f[0].substr(5), 10) * 1e3 * 0.95 - 50 * 40 * 8 : f = void 0, o.forEach(function(p) {
              p.maxBitrate = f;
            })), o;
          }, n.parseRtcpParameters = function(t) {
            var o = {}, l = n.matchPrefix(t, "a=ssrc:").map(function(u) {
              return n.parseSsrcMedia(u);
            }).filter(function(u) {
              return u.attribute === "cname";
            })[0];
            l && (o.cname = l.value, o.ssrc = l.ssrc);
            var c = n.matchPrefix(t, "a=rtcp-rsize");
            o.reducedSize = c.length > 0, o.compound = c.length === 0;
            var d = n.matchPrefix(t, "a=rtcp-mux");
            return o.mux = d.length > 0, o;
          }, n.parseMsid = function(t) {
            var o, l = n.matchPrefix(t, "a=msid:");
            if (l.length === 1)
              return o = l[0].substr(7).split(" "), { stream: o[0], track: o[1] };
            var c = n.matchPrefix(t, "a=ssrc:").map(function(d) {
              return n.parseSsrcMedia(d);
            }).filter(function(d) {
              return d.attribute === "msid";
            });
            if (c.length > 0)
              return o = c[0].value.split(" "), { stream: o[0], track: o[1] };
          }, n.parseSctpDescription = function(t) {
            var o = n.parseMLine(t), l = n.matchPrefix(t, "a=max-message-size:"), c;
            l.length > 0 && (c = parseInt(l[0].substr(19), 10)), isNaN(c) && (c = 65536);
            var d = n.matchPrefix(t, "a=sctp-port:");
            if (d.length > 0)
              return {
                port: parseInt(d[0].substr(12), 10),
                protocol: o.fmt,
                maxMessageSize: c
              };
            var u = n.matchPrefix(t, "a=sctpmap:");
            if (u.length > 0) {
              var h = n.matchPrefix(t, "a=sctpmap:")[0].substr(10).split(" ");
              return {
                port: parseInt(h[0], 10),
                protocol: h[1],
                maxMessageSize: c
              };
            }
          }, n.writeSctpDescription = function(t, o) {
            var l = [];
            return t.protocol !== "DTLS/SCTP" ? l = [
              "m=" + t.kind + " 9 " + t.protocol + " " + o.protocol + `\r
`,
              `c=IN IP4 0.0.0.0\r
`,
              "a=sctp-port:" + o.port + `\r
`
            ] : l = [
              "m=" + t.kind + " 9 " + t.protocol + " " + o.port + `\r
`,
              `c=IN IP4 0.0.0.0\r
`,
              "a=sctpmap:" + o.port + " " + o.protocol + ` 65535\r
`
            ], o.maxMessageSize !== void 0 && l.push("a=max-message-size:" + o.maxMessageSize + `\r
`), l.join("");
          }, n.generateSessionId = function() {
            return Math.random().toString().substr(2, 21);
          }, n.writeSessionBoilerplate = function(t, o, l) {
            var c, d = o !== void 0 ? o : 2;
            t ? c = t : c = n.generateSessionId();
            var u = l || "thisisadapterortc";
            return `v=0\r
o=` + u + " " + c + " " + d + ` IN IP4 127.0.0.1\r
s=-\r
t=0 0\r
`;
          }, n.writeMediaSection = function(t, o, l, c) {
            var d = n.writeRtpDescription(t.kind, o);
            if (d += n.writeIceParameters(
              t.iceGatherer.getLocalParameters()
            ), d += n.writeDtlsParameters(
              t.dtlsTransport.getLocalParameters(),
              l === "offer" ? "actpass" : "active"
            ), d += "a=mid:" + t.mid + `\r
`, t.direction ? d += "a=" + t.direction + `\r
` : t.rtpSender && t.rtpReceiver ? d += `a=sendrecv\r
` : t.rtpSender ? d += `a=sendonly\r
` : t.rtpReceiver ? d += `a=recvonly\r
` : d += `a=inactive\r
`, t.rtpSender) {
              var u = "msid:" + c.id + " " + t.rtpSender.track.id + `\r
`;
              d += "a=" + u, d += "a=ssrc:" + t.sendEncodingParameters[0].ssrc + " " + u, t.sendEncodingParameters[0].rtx && (d += "a=ssrc:" + t.sendEncodingParameters[0].rtx.ssrc + " " + u, d += "a=ssrc-group:FID " + t.sendEncodingParameters[0].ssrc + " " + t.sendEncodingParameters[0].rtx.ssrc + `\r
`);
            }
            return d += "a=ssrc:" + t.sendEncodingParameters[0].ssrc + " cname:" + n.localCName + `\r
`, t.rtpSender && t.sendEncodingParameters[0].rtx && (d += "a=ssrc:" + t.sendEncodingParameters[0].rtx.ssrc + " cname:" + n.localCName + `\r
`), d;
          }, n.getDirection = function(t, o) {
            for (var l = n.splitLines(t), c = 0; c < l.length; c++)
              switch (l[c]) {
                case "a=sendrecv":
                case "a=sendonly":
                case "a=recvonly":
                case "a=inactive":
                  return l[c].substr(2);
              }
            return o ? n.getDirection(o) : "sendrecv";
          }, n.getKind = function(t) {
            var o = n.splitLines(t), l = o[0].split(" ");
            return l[0].substr(2);
          }, n.isRejected = function(t) {
            return t.split(" ", 2)[1] === "0";
          }, n.parseMLine = function(t) {
            var o = n.splitLines(t), l = o[0].substr(2).split(" ");
            return {
              kind: l[0],
              port: parseInt(l[1], 10),
              protocol: l[2],
              fmt: l.slice(3).join(" ")
            };
          }, n.parseOLine = function(t) {
            var o = n.matchPrefix(t, "o=")[0], l = o.substr(2).split(" ");
            return {
              username: l[0],
              sessionId: l[1],
              sessionVersion: parseInt(l[2], 10),
              netType: l[3],
              addressType: l[4],
              address: l[5]
            };
          }, n.isValidSDP = function(t) {
            if (typeof t != "string" || t.length === 0)
              return !1;
            for (var o = n.splitLines(t), l = 0; l < o.length; l++)
              if (o[l].length < 2 || o[l].charAt(1) !== "=")
                return !1;
            return !0;
          }, i.exports = n;
        },
        /* 270 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            return ["Chrome", "Safari", "Edge", "Opera"].indexOf(t.browserName) === -1 || t.browserName === "Edge" && !t.isChromiumEdge || t.isScreenSharing && !t.capableSimulcastScreenshare || t.sessionInfo.p2pEnabled || !t.constraints.video && !t.isCustomVideoTrack || t.scalableVideo === !1 ? 1 : t.videoDimensions.width > 640 && t.videoDimensions.height > 480 ? 3 : 2;
          }
        },
        /* 271 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = A;
          var t = n(e(272)), o = n(e(591)), l = n(e(156));
          function c(g, f, p) {
            return !g.publish && f ? !1 : typeof g.source == "boolean" ? g.source : p ? {
              mandatory: {
                sourceId: g.source
              }
            } : (0, l.default)(g.source) ? {} : {
              deviceId: {
                exact: g.source
              }
            };
          }
          function d(g) {
            let f = c(g.audio, g.enableRenegotiation, g.usingOptionalMandatoryStyle);
            if (f === !1)
              return !1;
            const p = g.usingOptionalMandatoryStyle, v = g.enableStereo, b = g.echoCancellation, m = g.noiseSuppression, y = g.autoGainControl, U = g.disableAudioProcessing, B = (Q) => {
              typeof f == "object" && (p ? ((0, t.default)(f, {
                optional: []
              }), f.optional.push(Q)) : (0, t.default)(f, Q));
            };
            return (v || U || !b || !m || !y) && f === !0 && (f = {}), v && B({
              channelCount: 2
            }), ["echoCancellation", "autoGainControl", "noiseSuppression"].forEach((Q) => {
              const N = !U && g[Q];
              B({
                [Q]: N
              });
            }), f;
          }
          function u(g) {
            let f = c(g.video, g.enableRenegotiation, g.usingOptionalMandatoryStyle);
            if (f === !1)
              return !1;
            const p = g.videoDimensions, v = g.frameRate, b = g.maxResolution, m = g.facingMode, y = g.usingOptionalMandatoryStyle;
            if ((p || v || b || m) && f === !0 && (f = {}), p) {
              const U = p.width, B = p.height;
              y ? ((0, t.default)(f, {
                optional: []
              }), f.optional.push({
                minWidth: U
              }, {
                maxWidth: U
              }, {
                minHeight: B
              }, {
                maxHeight: B
              })) : (0, t.default)(f, {
                width: {
                  ideal: U
                },
                height: {
                  ideal: B
                }
              });
            }
            return v && (y ? ((0, t.default)(f, {
              optional: []
            }), f.optional.push({
              minFrameRate: v
            }, {
              maxFrameRate: v
            })) : (0, t.default)(f, {
              frameRate: {
                ideal: v
              }
            })), b && (y ? (0, t.default)(f, {
              mandatory: {
                maxWidth: b.width,
                maxHeight: b.height
              }
            }) : (0, t.default)(f, {
              width: {
                max: b.width
              },
              height: {
                max: b.height
              }
            })), m && (y ? ((0, t.default)(f, {
              optional: []
            }), f.optional.push({
              facingMode: m
            })) : (0, t.default)(f, {
              facingMode: {
                ideal: m
              }
            })), f;
          }
          function h(g) {
            return {
              audio: d(g),
              video: u(g)
            };
          }
          function A(g) {
            const f = (0, o.default)(g);
            return {
              constraints: h(f),
              publishAudio: f.audio.publish,
              publishVideo: f.video.publish,
              frameRate: f.frameRate,
              videoDimensions: f.videoDimensions,
              audioDeviceId: typeof f.audio.source == "string" ? f.audio.source : void 0,
              videoDeviceId: typeof f.video.source == "string" ? f.video.source : void 0
            };
          }
        },
        /* 272 */
        /***/
        function(i, r, e) {
          var n = e(588), t = e(204), o = t(function(l, c, d) {
            n(l, c, d);
          });
          i.exports = o;
        },
        /* 273 */
        /***/
        function(i, r, e) {
          var n = e(63), t = e(53);
          function o(l, c, d) {
            (d !== void 0 && !t(l[c], d) || d === void 0 && !(c in l)) && n(l, c, d);
          }
          i.exports = o;
        },
        /* 274 */
        /***/
        function(i, r) {
          function e(n, t) {
            if (!(t === "constructor" && typeof n[t] == "function") && t != "__proto__")
              return n[t];
          }
          i.exports = e;
        },
        /* 275 */
        /***/
        function(i, r, e) {
          var n = e(60), t = e(276);
          function o(l) {
            return t(n(l).toLowerCase());
          }
          i.exports = o;
        },
        /* 276 */
        /***/
        function(i, r, e) {
          var n = e(596), t = n("toUpperCase");
          i.exports = t;
        },
        /* 277 */
        /***/
        function(i, r) {
          function e(n, t, o) {
            var l = -1, c = n.length;
            t < 0 && (t = -t > c ? 0 : c + t), o = o > c ? c : o, o < 0 && (o += c), c = t > o ? 0 : o - t >>> 0, t >>>= 0;
            for (var d = Array(c); ++l < c; )
              d[l] = n[l + t];
            return d;
          }
          i.exports = e;
        },
        /* 278 */
        /***/
        function(i, r) {
          var e = "\\ud800-\\udfff", n = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", o = "\\u20d0-\\u20ff", l = n + t + o, c = "\\ufe0e\\ufe0f", d = "\\u200d", u = RegExp("[" + d + e + l + c + "]");
          function h(A) {
            return u.test(A);
          }
          i.exports = h;
        },
        /* 279 */
        /***/
        function(i, r, e) {
          var n = e(598), t = e(278), o = e(599);
          function l(c) {
            return t(c) ? o(c) : n(c);
          }
          i.exports = l;
        },
        /* 280 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3));
          const o = t.default.name, l = t.default.version;
          var d = t.default.isChromiumEdge || o === "Chrome" && l >= 72 || o === "Firefox" && l >= 66 || o === "Opera" && l >= 60 || o === "Safari";
          r.default = d;
        },
        /* 281 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = !!(t.default.isChrome && t.default.version >= 74 || t.default.isEdge && t.default.version >= 79);
          r.default = o;
        },
        /* 282 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = (l) => t.default.isElectron ? l instanceof MediaStreamTrack && l.label === "Screen" : !1;
          r.default = o;
        },
        /* 283 */
        /***/
        function(i, r, e) {
          var n = e(102), t = e(605), o = t(n);
          i.exports = o;
        },
        /* 284 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = 15e3;
          r.default = n;
        },
        /* 285 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = function(l, c) {
            return c === void 0 && (c = !1), l === void 0 ? c : l === "true" || l === !0;
          };
          r.default = t;
        },
        /* 286 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(61));
          function o(l) {
            const c = (0, t.default)(l);
            if (c.backgroundImageURI) {
              const d = c.backgroundImageURI.split(":")[0];
              c.backgroundImageURI = ["http", "https", "data"].indexOf(d) !== -1 ? d : "other";
            }
            return c;
          }
        },
        /* 287 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = () => !t.default.isNode && !t.default.isElectron ? (
            // See https://www.chromestatus.com/feature/4924861776396288
            (t.default.isChrome || t.default.isOpera || t.default.isChromiumEdge) && t.default.version >= 74 || t.default.isFirefox && t.default.version >= 68 || // See https://webkit.org/blog/7763/a-closer-look-into-webrtc/
            t.default.isSafari && t.default.version >= 11
          ) : !1;
          r.default = o;
        },
        /* 288 */
        /***/
        function(i, r) {
          function e(n, t) {
            return i.exports = e = Object.setPrototypeOf || function(l, c) {
              return l.__proto__ = c, l;
            }, e(n, t);
          }
          i.exports = e;
        },
        /* 289 */
        /***/
        function(i, r, e) {
          var n = e(11), t = e(620), o = e(241), l = "Expected a function", c = Math.max, d = Math.min;
          function u(h, A, g) {
            var f, p, v, b, m, y, U = 0, B = !1, Q = !1, N = !0;
            if (typeof h != "function")
              throw new TypeError(l);
            A = o(A) || 0, n(g) && (B = !!g.leading, Q = "maxWait" in g, v = Q ? c(o(g.maxWait) || 0, A) : v, N = "trailing" in g ? !!g.trailing : N);
            function J(oe) {
              var fe = f, ge = p;
              return f = p = void 0, U = oe, b = h.apply(ge, fe), b;
            }
            function w(oe) {
              return U = oe, m = setTimeout(Z, A), B ? J(oe) : b;
            }
            function W(oe) {
              var fe = oe - y, ge = oe - U, we = A - fe;
              return Q ? d(we, v - ge) : we;
            }
            function G(oe) {
              var fe = oe - y, ge = oe - U;
              return y === void 0 || fe >= A || fe < 0 || Q && ge >= v;
            }
            function Z() {
              var oe = t();
              if (G(oe))
                return K(oe);
              m = setTimeout(Z, W(oe));
            }
            function K(oe) {
              return m = void 0, N && f ? J(oe) : (f = p = void 0, b);
            }
            function L() {
              m !== void 0 && clearTimeout(m), U = 0, f = y = p = m = void 0;
            }
            function O() {
              return m === void 0 ? b : K(t());
            }
            function de() {
              var oe = t(), fe = G(oe);
              if (f = arguments, p = this, y = oe, fe) {
                if (m === void 0)
                  return w(y);
                if (Q)
                  return clearTimeout(m), m = setTimeout(Z, A), J(y);
              }
              return m === void 0 && (m = setTimeout(Z, A)), b;
            }
            return de.cancel = L, de.flush = O, de;
          }
          i.exports = u;
        },
        /* 290 */
        /***/
        function(i, r, e) {
          var n = e(39), t = e(79), o = e(621), l = e(59), c = e(45), d = e(624), u = e(140), h = e(197), A = 1, g = 2, f = 4, p = u(function(v, b) {
            var m = {};
            if (v == null)
              return m;
            var y = !1;
            b = n(b, function(B) {
              return B = l(B, v), y || (y = B.length > 1), B;
            }), c(v, h(v), m), y && (m = t(m, A | g | f, d));
            for (var U = b.length; U--; )
              o(m, b[U]);
            return m;
          });
          i.exports = p;
        },
        /* 291 */
        /***/
        function(i, r, e) {
          var n = e(239), t = e(38), o = e(97), l = Math.max;
          function c(d, u, h) {
            var A = d == null ? 0 : d.length;
            if (!A)
              return -1;
            var g = h == null ? 0 : o(h);
            return g < 0 && (g = l(A + g, 0)), n(d, t(u, 3), g);
          }
          i.exports = c;
        },
        /* 292 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = {
            INACTIVE: "inactive",
            RECVONLY: "recvonly",
            SENDONLY: "sendonly",
            SENDRECV: "sendrecv"
          };
          r.default = t;
        },
        /* 293 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), c = /* @__PURE__ */ function() {
            var d = (0, o.default)(/* @__PURE__ */ t.default.mark(function u(h, A) {
              var g, f, p, v;
              return t.default.wrap(function(m) {
                for (; ; ) switch (m.prev = m.next) {
                  case 0:
                    return g = !1, f = !0, p = new TextEncoder(), m.next = 5, window.crypto.subtle.importKey("raw", p.encode(A), {
                      name: "PBKDF2"
                    }, g, ["deriveBits", "deriveKey"]);
                  case 5:
                    return v = m.sent, m.abrupt("return", window.crypto.subtle.deriveKey({
                      name: "PBKDF2",
                      salt: p.encode(h),
                      iterations: 1e5,
                      hash: "SHA-256"
                    }, v, {
                      name: "AES-CTR",
                      length: 256
                    }, f, ["encrypt", "decrypt"]));
                  case 7:
                  case "end":
                    return m.stop();
                }
              }, u);
            }));
            return function(h, A) {
              return d.apply(this, arguments);
            };
          }();
          r.default = c;
        },
        /* 294 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(634)), o = n(e(297)), l = n(e(108));
          const c = (0, l.default)();
          var d = (u, h, A) => {
            (0, o.default)(u, h, (g, f) => {
              if (g) {
                A(g);
                return;
              }
              let p = [];
              c ? typeof f.values == "function" ? p = (0, t.default)(f.values()) : typeof f.forEach != "function" ? p = Object.keys(f).map((v) => f[v]) : f.forEach((v) => {
                p.push(v);
              }) : f.result().forEach((v) => {
                const b = {};
                v.names().forEach((m) => {
                  b[m] = v.stat(m);
                }), b.id = v.id, b.type = v.type, b.timestamp = v.timestamp, p.push(b);
              }), A(null, p);
            });
          };
          r.default = d;
        },
        /* 295 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(12), o = e(18), l = "[object String]";
          function c(d) {
            return typeof d == "string" || !t(d) && o(d) && n(d) == l;
          }
          i.exports = c;
        },
        /* 296 */
        /***/
        function(i, r, e) {
          var n = e(636), t = e(34);
          function o(l) {
            return l == null ? [] : n(l, t(l));
          }
          i.exports = o;
        },
        /* 297 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(108));
          const o = (0, t.default)(), l = (h, A, g) => {
            h.getStats(A).then((f) => g(null, f)).catch(g);
          }, c = (h, A) => {
            h.getStats((g) => {
              A(null, g);
            }, A);
          };
          var u = (h, A, g) => {
            o ? l(h, A, g) : c(h, g);
          };
          r.default = u;
        },
        /* 298 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(30)), o = e(14), l = n(e(42)), c = n(e(648)), d = n(e(650)), u = n(e(50)), h = n(e(1));
          const A = (0, h.default)("QoS");
          let g = /* @__PURE__ */ function(p) {
            (0, t.default)(v, p);
            function v() {
              for (var m, y = arguments.length, U = new Array(y), B = 0; B < y; B++)
                U[B] = arguments[B];
              return m = p.call(this, ...U) || this, m._peerConnection = void 0, m._isPublisher = void 0, m.timeoutId = void 0, m._creationTime = (0, u.default)(), m.offerMessagesReceived = 0, m.prevStats = {
                timeStamp: (0, u.default)()
              }, m.changeCounters = {
                videoCodec: new d.default(),
                audioCodec: new d.default()
              }, m;
            }
            var b = v.prototype;
            return b.startCollecting = function(y, U) {
              if (!y || !y.getStats)
                return;
              this._isPublisher = U;
              const B = !!this._peerConnection;
              if (this._peerConnection = y, B)
                return;
              const Q = (N) => {
                const J = (0, u.default)(), w = {
                  timeStamp: J,
                  duration: Math.round((J - this._creationTime) / 1e3),
                  period: Math.round((J - this.prevStats.timeStamp) / 1e3)
                };
                (0, c.default)(this._peerConnection, this.prevStats, w, this._isPublisher, (W, G) => {
                  if (W) {
                    A.error("Failed to Parse QOS Stats:", W);
                    return;
                  }
                  this.handleParsedStats(G), clearTimeout(this.timeoutId), this.timeoutId = setTimeout(() => Q(v.INTERVAL), N);
                });
              };
              this.timeoutId = setTimeout(() => Q(v.INTERVAL - v.INITIAL_INTERVAL), v.INITIAL_INTERVAL);
            }, b.stopCollecting = function() {
              this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this._peerConnection = null;
            }, b.handleOfferMessageReceived = function() {
              this.offerMessagesReceived += 1;
            }, b.handleParsedStats = function(y) {
              Object.keys(this.changeCounters).forEach((Q) => {
                this.changeCounters[Q].onValue(y[Q]), y[`${Q}ChangeCount`] = this.changeCounters[Q].changeCount;
              }), y.offerMessagesReceived = this.offerMessagesReceived;
              const U = (0, l.default)(y);
              if (["audioSentBytes", "audioSentPackets", "audioSentPacketsLost", "videoSentBytes", "videoSentPackets", "videoSentPacketsLost", "audioRecvBytes", "audioRecvPackets", "audioRecvPacketsLost", "videoRecvBytes", "videoRecvPackets", "videoRecvPacketsLost"].forEach((Q) => {
                U[Q] = this.prevStats && this.prevStats[Q] ? y[Q] - this.prevStats[Q] : y[Q];
              }), this.prevStats && this.prevStats.videoFramesReceived) {
                const Q = y.videoFramesReceived - this.prevStats.videoFramesReceived, N = y.period;
                U.videoFrameRateReceived = Math.round(Q / N);
              }
              this.prevStats = y, delete U.framesDecoded, delete U.framesEncoded, this.emit("stats", U);
            }, v;
          }(o.EventEmitter);
          g.INITIAL_INTERVAL = 1e3, g.INTERVAL = 3e4;
          var f = g;
          r.default = f;
        },
        /* 299 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            switch (t >> 24) {
              case 0:
                return "TURN/TLS";
              case 1:
                return "TURN/TCP";
              case 2:
                return "TURN/UDP";
              default:
                return "";
            }
          };
          r.default = n;
        },
        /* 300 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = d;
          var t = n(e(16)), o = n(e(13)), l = n(e(8)), c = n(e(166));
          function d(u) {
            let h = u === void 0 ? {} : u, A = h.haveGetDisplayMedia, g = A === void 0 ? c.default : A, f = h.global, p = f === void 0 ? typeof window !== void 0 ? window : Dn : f, v = h.Errors, b = v === void 0 ? l.default : v, m = h.otError, y = m === void 0 ? (0, o.default)() : m;
            const U = (
              // don't bother supporting extension when we have display media
              !g && !!p.navigator.webkitGetUserMedia && !p.navigator.userAgent.match(/android/i) && typeof p.chrome != "undefined"
            );
            return {
              isSupportedInThisBrowser: U,
              autoRegisters: !1,
              extensionRequired: !0,
              getConstraintsShowsPermissionUI: !0,
              sources: {
                screen: !0,
                application: !1,
                window: !0,
                browser: !0
              },
              register(B, Q) {
                return Q === 2 ? this.registerVersion2(B) : this.registerVersion1(B);
              },
              registerVersion1(B) {
                if (!B)
                  throw new Error("initChromeScreenSharingExtensionHelper: extensionID is required.");
                const Q = U, N = {};
                let J;
                const w = `com.tokbox.screenSharing.${B}`, W = function(O, de) {
                  const oe = {
                    payload: de,
                    from: "jsapi"
                  };
                  return oe[w] = O, oe;
                }, G = function(O, de) {
                  let oe;
                  const fe = (0, t.default)();
                  return N[fe] = function() {
                    clearTimeout(oe), oe = null, O(...arguments);
                  }, de && (oe = setTimeout(() => {
                    delete N[fe], O(y(b.TIMEOUT, new Error("Timeout waiting for response to screensharing request.")));
                  }, de)), fe;
                }, Z = function(O) {
                  if (!O)
                    throw new Error("isAvailable: callback is required.");
                  if (!Q) {
                    setTimeout(O.bind(null, !1));
                    return;
                  }
                  if (J !== void 0)
                    setTimeout(O.bind(null, J));
                  else {
                    const de = G((fe) => {
                      J !== !0 && (J = fe === "extensionLoaded"), O(J);
                    }, 2e3), oe = W("isExtensionInstalled", {
                      requestId: de
                    });
                    p.postMessage(oe, "*");
                  }
                }, K = function(O, de, oe) {
                  if (!oe)
                    throw new Error("getSourceId: callback is required");
                  Z((fe) => {
                    if (!fe)
                      return oe(y(b.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error("Extension is not installed")));
                    const ge = G((we, _e) => {
                      typeof we == "object" && we.name && we.stack ? oe(we) : we === "permissionDenied" ? oe(y(b.USER_MEDIA_ACCESS_DENIED, new Error("User denied access to screensharing"))) : (de.video || (de.video = {}), de.video.mandatory || (de.video.mandatory = {}), de.video.mandatory.chromeMediaSource = "desktop", de.video.mandatory.chromeMediaSourceId = _e.sourceId, oe(void 0, de));
                    });
                    p.postMessage(W("getSourceId", {
                      requestId: ge,
                      source: O
                    }), "*");
                  });
                };
                return p.addEventListener("message", (L) => {
                  if (L.origin !== p.location.origin || !(L.data != null && typeof L.data == "object") || L.data.from !== "extension")
                    return;
                  const O = L.data[w], de = L.data.payload;
                  if (de && de.requestId) {
                    const oe = N[de.requestId];
                    delete N[de.requestId], oe && oe(O, de);
                  }
                  O === "extensionLoaded" && (J = !0);
                }), {
                  extensionAPIVersion: 1,
                  extensionID: B,
                  isInstalled: Z,
                  getConstraints: K
                };
              },
              registerVersion2(B) {
                const Q = U && typeof p.chrome.runtime != "undefined", N = function(W) {
                  if (!W)
                    throw new Error("isAvailable: callback is required.");
                  if (!Q) {
                    setTimeout(W.bind(null, !1));
                    return;
                  }
                  p.chrome.runtime.sendMessage(B, {
                    type: "isInstalled"
                  }, null, (G) => {
                    setTimeout(W.bind(null, !!G));
                  });
                };
                return {
                  extensionAPIVersion: 2,
                  extensionID: B,
                  isInstalled: N,
                  getConstraints: function(W, G, Z) {
                    if (!Z)
                      throw new Error("getSourceId: callback is required");
                    N((K) => {
                      if (!K)
                        return Z(y(b.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, new Error("Extension is not installed")));
                      p.chrome.runtime.sendMessage(B, {
                        type: "getSourceId",
                        source: W
                      }, null, (L) => {
                        L.error === "permissionDenied" ? Z(y(b.USER_MEDIA_ACCESS_DENIED, new Error("User denied access to screensharing"))) : L.error ? Z(new Error(`UnexpectError: ${L.error}`)) : (G.video || (G.video = {}), G.video.mandatory || (G.video.mandatory = {}), G.video.mandatory.chromeMediaSource = "desktop", G.video.mandatory.chromeMediaSourceId = L.sourceId, Z(void 0, G));
                      });
                    });
                  }
                };
              }
            };
          }
        },
        /* 301 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = m;
            var o = t(e(1)), l = t(e(109)), c = t(e(162)), d = t(e(653)), u = t(e(302)), h = t(e(152)), A = t(e(303)), g = t(e(153)), f = t(e(304)), p = t(e(305)), v = t(e(306)), b = t(e(158));
            function m(y) {
              y === void 0 && (y = {});
              const U = y.Archiving || d.default, B = y.AudioLevelMeter || u.default, Q = y.AudioLevelTransformer || h.default, N = y.BackingBar || A.default, J = y.Chrome || g.default, w = y.MuteButton || (0, f.default)(), W = y.NamePanel || p.default, G = y.VideoDisabledIndicator || v.default, Z = y.StylableComponent || b.default, K = y.logging || (0, o.default)("createChromeMixin");
              return function(O, de) {
                let oe = de === void 0 ? {} : de, fe = oe.name, ge = oe.publishAudio, we = oe.publishVideo, _e = oe.audioSource, Te = oe.showControls, Pe = oe.shouldAllowAudio, $e = oe.logAnalyticsEvent, Bt, Le, at;
                const pt = {}, kt = (0, c.default)(), _t = (Zt) => {
                  if (Zt === !1)
                    return "off";
                  const ft = O.getStyle("buttonDisplayMode");
                  return ft === !1 ? "on" : ft;
                };
                let Lt = new n((Zt, ft) => {
                  pt.init = (It) => {
                    O.getStyle("showArchiveStatus") || $e("showArchiveStatus", "createChrome", {
                      mode: "off"
                    });
                    const Kt = {
                      backingBar: new N({
                        nameMode: fe ? O.getStyle("nameDisplayMode") : "off",
                        muteMode: _t(O.getStyle("buttonDisplayMode"))
                      }),
                      name: new W({
                        name: fe,
                        mode: O.getStyle("nameDisplayMode")
                      }),
                      archive: new U({
                        show: !!O.getStyle("showArchiveStatus") && O.getStyle("archiveStatusDisplayMode") !== "off",
                        archiving: !1
                      }),
                      muteButton: new w({
                        muted: ge === !1,
                        mode: _t.call(null, O.getStyle("buttonDisplayMode"))
                      })
                    };
                    Bt = new B({
                      mode: O.getStyle("audioLevelDisplayMode")
                    });
                    const Sn = new Q(), Cn = new l.default(() => {
                      const on = ge ? Sn.transform(O.loudness) : 0;
                      Bt.setValue(on);
                    });
                    Bt.watchVisibilityChanged((on) => {
                      on ? Cn.start() : Cn.stop();
                    }), Bt.audioOnly(!we && ge), Kt.audioLevel = Bt, Kt.videoDisabledIndicator = new G({
                      mode: O.getStyle("videoDisabledDisplayMode")
                    }), It && It.domElement && (at = It, Le = new J({
                      parent: at.domElement
                    }).set(Kt).on({
                      muted: () => O.publishAudio(!1),
                      unmuted: () => O.publishAudio(!0)
                    }), (_e === null || _e === !1) && pt.removeAudioTrack(), Zt());
                  }, pt.reset = () => {
                    ft(new Error("Chrome still being created")), Le && (Le.destroy(), Le = null);
                  }, pt.destroy = () => {
                    pt.reset(), kt.releaseAll(), Lt = null;
                  };
                });
                Lt.catch((Zt) => {
                  (!Zt || Zt.message !== "Chrome still being created") && K.error("createChromeMixin failed to setup UI", Zt);
                }), pt.setAudioOnly = (Zt) => {
                  Bt && Bt.audioOnly(Zt);
                }, pt.setArchivingStatus = (Zt) => {
                  Le && Le.archive.setArchiving(Zt);
                }, pt.setMuted = (Zt) => {
                  Le && Le.muteButton && Le.muteButton.muted(Zt);
                }, pt.removeAudioTrack = () => {
                  Le && Le.muteButton && Le.muteButton.remove();
                }, pt.addAudioTrack = () => {
                  Le && Le.muteButton && Le.muteButton.add();
                }, pt.videoDisabledIndicator = {
                  disableVideo: function() {
                    for (var ft, It = arguments.length, Kt = new Array(It), Sn = 0; Sn < It; Sn++)
                      Kt[Sn] = arguments[Sn];
                    return (ft = Le) == null ? void 0 : ft.videoDisabledIndicator.disableVideo(...Kt);
                  },
                  setWarning: function() {
                    for (var ft, It = arguments.length, Kt = new Array(It), Sn = 0; Sn < It; Sn++)
                      Kt[Sn] = arguments[Sn];
                    return (ft = Le) == null ? void 0 : ft.videoDisabledIndicator.setWarning(...Kt);
                  }
                }, Z(O, {
                  showArchiveStatus: !0,
                  nameDisplayMode: "auto",
                  buttonDisplayMode: "auto",
                  videoDisabledDisplayMode: "auto",
                  audioLevelDisplayMode: Pe ? "auto" : "off",
                  archiveStatusDisplayMode: "auto",
                  backgroundImageURI: null
                }, Te, (Zt) => {
                  $e("SetStyle", "Publisher", Zt, null, 0.1);
                });
                const Ft = (Zt, ft) => {
                  Lt.then(() => {
                    switch (Zt) {
                      case "nameDisplayMode":
                        Le.name.setDisplayMode(ft), Le.backingBar.setNameMode(ft);
                        break;
                      case "showArchiveStatus":
                        $e("showArchiveStatus", "styleChange", {
                          mode: ft ? "on" : "off"
                        }), Le.archive.setShowArchiveStatus(!!ft);
                        break;
                      case "archiveStatusDisplayMode":
                        Le.archive.setShowArchiveStatus(ft !== "off");
                        break;
                      case "buttonDisplayMode":
                        Le.muteButton.setDisplayMode(ft), Le.backingBar.setMuteMode(ft);
                        break;
                      case "audioLevelDisplayMode":
                        Le.audioLevel.setDisplayMode(ft);
                        break;
                      case "backgroundImageURI":
                        at.setBackgroundImageURI(ft);
                        break;
                    }
                  });
                };
                return O.on("styleValueChanged", Ft), kt.add(() => O.off("styleValueChanged", Ft)), pt;
              };
            }
          }).call(this, e(2));
        },
        /* 302 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = u;
            var o = t(e(14)), l = t(e(105)), c = t(e(41)), d = t(e(7));
            function u(h) {
              const A = this, g = new o.default();
              let f, p, v, b, m = !0, y = !1, U = "auto";
              const B = h.maxValue || 1, Q = h.minValue || 0;
              function N() {
                p = d.default.createElement("div", {
                  className: "OT_audio-level-meter__value"
                }, ""), f = d.default.createElement("div", {
                  className: "OT_audio-level-meter__audio-only-img"
                }, "");
                const Z = A.domElement;
                Z.appendChild(f), Z.appendChild(p), A.watchVisibilityChanged((K) => {
                  K ? d.default.removeClass(A.domElement, "OT_hide-forced") : d.default.addClass(A.domElement, "OT_hide-forced");
                });
              }
              function J() {
                g.removeAllListeners("visibilityChanged");
              }
              function w() {
                const Z = (v - Q) / (B - Q);
                p.style.transform = `scale(${Math.sqrt(Z)})`;
              }
              function W() {
                const Z = (y && U === "auto" || U === "on") && m;
                b !== Z && (b = Z, g.emit("visibilityChanged", Z));
              }
              (0, l.default)(A, {
                audioOnly: {
                  get() {
                    return y;
                  },
                  set(Z) {
                    y = Z, W();
                  }
                }
              }), A.setValue = function(Z) {
                v = Z, w();
              }, A.watchVisibilityChanged = function(Z) {
                return g.on("visibilityChanged", Z), n.resolve().then(() => {
                  Z(b);
                }), function() {
                  g.removeListener("visibilityChanged", Z);
                };
              };
              const G = {
                mode: h ? h.mode : "auto",
                nodeName: "div",
                htmlAttributes: {
                  className: "OT_audio-level-meter"
                },
                onCreate: N,
                onDestroy: J
              };
              (0, c.default)(this, G), A.setDisplayMode = function(Z) {
                U = Z, W();
              }, A.getDisplayMode = function() {
                return U;
              }, A.showAfterLoading = function() {
                m = !0, W();
              }, A.hideWhileLoading = function() {
                m = !1, W();
              }, W();
            }
          }).call(this, e(2));
        },
        /* 303 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(41));
          function o(l) {
            let c = l.nameMode, d = l.muteMode;
            function u() {
              return c === "on" || d === "on" ? "on" : c === "mini" || d === "mini" ? "mini" : c === "mini-auto" || d === "mini-auto" ? "mini-auto" : c === "auto" || d === "auto" ? "auto" : "off";
            }
            (0, t.default)(this, {
              mode: u(),
              nodeName: "div",
              htmlContent: "",
              htmlAttributes: {
                className: "OT_bar OT_edge-bar-item"
              }
            }), this.setNameMode = function(h) {
              c = h, this.setDisplayMode(u());
            }, this.setMuteMode = function(h) {
              d = h, this.setDisplayMode(u());
            };
          }
        },
        /* 304 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(7)), o = n(e(41)), l = n(e(105));
          function c(d) {
            d === void 0 && (d = {});
            const u = d.OTHelpers || t.default, h = d.Widget || o.default;
            return function(g) {
              let f = g.muted || !1;
              const p = () => {
                f ? u.addClass(this.domElement, "OT_active") : u.removeClass(this.domElement, "OT_active ");
              }, v = () => (f = !f, p(), f ? this.parent.trigger("muted", this) : this.parent.trigger("unmuted", this), !1), b = (B) => {
                u.on(B, "click", v);
              }, m = (B) => {
                u.off(B, "click", v);
              };
              (0, l.default)(this, {
                muted: {
                  get() {
                    return f;
                  },
                  set(B) {
                    f = B, p();
                  }
                }
              });
              const y = f ? "OT_edge-bar-item OT_mute OT_active" : "OT_edge-bar-item OT_mute";
              h(this, {
                mode: g.mode,
                nodeName: "button",
                htmlContent: "Mute",
                htmlAttributes: {
                  className: y,
                  type: "button"
                },
                onCreate: b,
                onDestroy: m
              });
              let U;
              this.remove = () => {
                this.domElement && this.domElement.parentNode && (U = this.domElement.parentNode, this.domElement.parentNode.removeChild(this.domElement));
              }, this.add = () => {
                U && this.domElement && !this.domElement.parentNode && U.appendChild(this.domElement);
              };
            };
          }
        },
        /* 305 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(41));
          const o = (c) => {
            const d = document.createElement("div");
            return d.textContent = c, d.innerHTML;
          };
          function l(c) {
            let d = c.name;
            (!d || d.trim().length === "") && (d = null, c.mode = "off"), this.setName = function(u) {
              d || this.setDisplayMode("auto"), d = o(u), this.domElement.innerHTML = d;
            }.bind(this), d = o(d), (0, t.default)(this, {
              mode: c.mode,
              nodeName: "h1",
              htmlContent: d,
              htmlAttributes: {
                className: "OT_name OT_edge-bar-item"
              }
            });
          }
        },
        /* 306 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(41)), o = n(e(7));
          function l(c) {
            let d = !1, u = !1;
            const h = function(g) {
              const f = ["auto", "on"].indexOf(this.getDisplayMode()) > -1;
              o.default.removeClass(g, "OT_video-disabled OT_video-disabled-warning OT_active"), f && (d ? o.default.addClass(g, "OT_video-disabled") : u && o.default.addClass(g, "OT_video-disabled-warning"), o.default.addClass(g, "OT_active"));
            }.bind(this);
            this.disableVideo = function(g) {
              d = g, g === !0 && (u = !1), h(this.domElement);
            }, this.setWarning = function(g) {
              u = g, h(this.domElement);
            }, (0, t.default)(this, {
              mode: c.mode || "auto",
              nodeName: "div",
              htmlAttributes: {
                className: "OT_video-disabled-indicator"
              }
            });
            const A = this.setDisplayMode.bind(this);
            this.setDisplayMode = function(g) {
              A(g), h(this.domElement);
            };
          }
        },
        /* 307 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(166)), c = {
            isSupportedInThisBrowser: /* Even though getDisplayMedia is supported in Edge, we haven't gotten it */ /* to work with our SDK */ !t.default.isLegacyEdge && // Even though getDisplayMedia is exposed in Electron, devs need to use
            // desktopCapturer instead
            !t.default.isElectron && o.default && // getDisplayMedia is not supported in Android
            !t.default.isAndroid,
            autoRegisters: !0,
            extensionRequired: !1,
            getConstraintsShowsPermissionUI: !1,
            sources: {
              screen: !0,
              application: !1,
              window: t.default.name !== "Safari",
              browser: t.default.name !== "Safari"
            },
            register() {
              return {
                isInstalled(d) {
                  d(void 0);
                },
                getConstraints(d, u, h) {
                  h(void 0, {
                    video: u.video,
                    audio: u.audio
                  });
                }
              };
            }
          };
          r.default = c;
        },
        /* 308 */
        /***/
        function(i, r, e) {
          e.r(r), function(n) {
            var t = function(u, h, A, g) {
              return new (A || (A = n))(function(f, p) {
                function v(y) {
                  try {
                    m(g.next(y));
                  } catch (U) {
                    p(U);
                  }
                }
                function b(y) {
                  try {
                    m(g.throw(y));
                  } catch (U) {
                    p(U);
                  }
                }
                function m(y) {
                  y.done ? f(y.value) : new A(function(U) {
                    U(y.value);
                  }).then(v, b);
                }
                m((g = g.apply(u, [])).next());
              });
            }, o = function(u, h) {
              var A = { label: 0, sent: function() {
                if (p[0] & 1) throw p[1];
                return p[1];
              }, trys: [], ops: [] }, g, f, p, v;
              return v = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
                return this;
              }), v;
              function b(y) {
                return function(U) {
                  return m([y, U]);
                };
              }
              function m(y) {
                if (g) throw new TypeError("Generator is already executing.");
                for (; A; ) try {
                  if (g = 1, f && (p = f[y[0] & 2 ? "return" : y[0] ? "throw" : "next"]) && !(p = p.call(f, y[1])).done) return p;
                  switch (f = 0, p && (y = [0, p.value]), y[0]) {
                    case 0:
                    case 1:
                      p = y;
                      break;
                    case 4:
                      return A.label++, { value: y[1], done: !1 };
                    case 5:
                      A.label++, f = y[1], y = [0];
                      continue;
                    case 7:
                      y = A.ops.pop(), A.trys.pop();
                      continue;
                    default:
                      if (p = A.trys, !(p = p.length > 0 && p[p.length - 1]) && (y[0] === 6 || y[0] === 2)) {
                        A = 0;
                        continue;
                      }
                      if (y[0] === 3 && (!p || y[1] > p[0] && y[1] < p[3])) {
                        A.label = y[1];
                        break;
                      }
                      if (y[0] === 6 && A.label < p[1]) {
                        A.label = p[1], p = y;
                        break;
                      }
                      if (p && A.label < p[2]) {
                        A.label = p[2], A.ops.push(y);
                        break;
                      }
                      p[2] && A.ops.pop(), A.trys.pop();
                      continue;
                  }
                  y = h.call(u, A);
                } catch (U) {
                  y = [6, U], f = 0;
                } finally {
                  g = p = 0;
                }
                if (y[0] & 5) throw y[1];
                return { value: y[0] ? y[1] : void 0, done: !0 };
              }
            };
            function l() {
              return typeof window != "undefined" || /* istanbul ignore next */
              typeof window !== void 0 ? window : Dn;
            }
            var c = "onFailure must return boolean, or delay in ms";
            function d(u, h, A) {
              return A === void 0 && (A = 10), function() {
                for (var g = [], f = 0; f < arguments.length; f++)
                  g[f] = arguments[f];
                return t(this, void 0, void 0, function() {
                  var p, v, b;
                  return o(this, function(m) {
                    switch (m.label) {
                      case 0:
                        p = 0, v = function() {
                          var y, U, B;
                          return o(this, function(Q) {
                            switch (Q.label) {
                              case 0:
                                return Q.trys.push([0, 2, , 6]), y = {}, [4, u.apply(void 0, g)];
                              case 1:
                                return [2, (y.value = Q.sent(), y)];
                              case 2:
                                if (U = Q.sent(), B = h(U, p), B === !1 || B == null || p >= A)
                                  throw U;
                                return typeof B != "number" ? [3, 4] : [4, new n(function(N) {
                                  return l().setTimeout(N, B);
                                })];
                              case 3:
                                return Q.sent(), [3, 5];
                              case 4:
                                if (B !== !0)
                                  throw new Error(c);
                                Q.label = 5;
                              case 5:
                                return [3, 6];
                              case 6:
                                return [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        }, m.label = 1;
                      case 1:
                        return (p += 1) ? [5, v()] : [3, 3];
                      case 2:
                        return b = m.sent(), typeof b == "object" ? [2, b.value] : [3, 1];
                      case 3:
                        return [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              };
            }
            r.default = d;
          }.call(this, e(2));
        },
        /* 309 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.setVideoContentHint = r.isValidVideoContentHint = r.getVideoContentHint = void 0;
          var t = n(e(1));
          const o = (0, t.default)("videoContentHint"), l = ["", "text", "motion", "detail"], c = (A) => l.includes(A);
          r.isValidVideoContentHint = c;
          const d = (A) => {
            var g;
            return A == null || (g = A.getVideoTracks()) == null ? void 0 : g[0];
          }, u = (A, g) => {
            if (!c(g)) {
              o.warn('Invalid content hint. Valid content hints are "text", "detail", "motion", or ""');
              return;
            }
            const f = d(A);
            if (!f) {
              o.warn("Tried to set contentHint but no video track is present");
              return;
            }
            if (f.contentHint === void 0) {
              o.warn("contentHint not supported by this browser");
              return;
            }
            f.contentHint = g;
          };
          r.setVideoContentHint = u;
          const h = (A) => {
            const g = d(A);
            return (g == null ? void 0 : g.contentHint) || "";
          };
          r.getVideoContentHint = h;
        },
        /* 310 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = (o) => o && typeof o == "object" && typeof o.kind == "string" && typeof o.stop == "function" && typeof o.enabled == "boolean";
          r.default = t;
        },
        /* 311 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(105));
          function o() {
            return function(c, d) {
              let u;
              (0, t.default)(this, {
                muted: {
                  get() {
                    return u;
                  },
                  set(h) {
                    if (u === h)
                      return;
                    u = h;
                    const A = c.getAudioTracks();
                    for (let g = 0, f = A.length; g < f; ++g)
                      A[g].enabled = !u;
                  }
                }
              }), d !== void 0 ? this.muted(d === !0) : c.getAudioTracks().length ? this.muted(!c.getAudioTracks()[0].enabled) : this.muted(!1);
            };
          }
        },
        /* 312 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = L;
            var o = t(e(4)), l = t(e(5)), c = t(e(9)), d = t(e(40)), u = t(e(62)), h = t(e(663)), A = t(e(664)), g = t(e(671)), f = t(e(1)), p = t(e(6)), v = t(e(316)), b = t(e(317)), m = t(e(676)), y = t(e(77)), U = t(e(7)), B = t(e(74)), Q = t(e(170)), N = t(e(678)), J = e(25), w = t(e(76)), W = t(e(679));
            const G = w.default.ACTIVE_VIDEO, Z = w.default.SUSPENDED_VIDEO, K = (0, f.default)("PublisherPeerConnection");
            function L(O) {
              O === void 0 && (O = {});
              const de = O.getStatsHelpers || y.default, oe = O.OTHelpers || U.default, fe = O.PeerConnection || (0, B.default)(), ge = O.setCertificates || (0, Q.default)(), we = O.watchAudioAcquisition || N.default, _e = O.createAudioFallbackStateMachine || h.default, Te = O.createCongestionLevelEstimator || A.default, Pe = O.createNetworkQualityMonitor || g.default, $e = O.getDelayForAmrProbe || W.default;
              return function(Le) {
                var at = this;
                let pt = Le.iceConfig, kt = Le.webRTCStream, _t = Le.channels, Lt = Le.sendMessage, Ft = Le.capableSimulcastStreams, Zt = Le.overrideSimulcastEnabled, ft = Le.logAnalyticsEvent, It = Le.offerOverrides, Kt = Le.answerOverrides, Sn = Le.sourceStreamId, Cn = Le.isP2pEnabled, on = Le.sessionId, An = Le.keyStore, Ue = Le.sFrameClientStore, ne = Le.isE2ee, se = Le.audioFallbackEnabled, Ce, At = !1, Ge, Ye, Qt, tn;
                const vn = function() {
                  this.destroy(), At && (At = !1, this.trigger("iceRestartFailure")), this.trigger("disconnected");
                }, Yt = function(rr) {
                  let Kr = rr.reason, Bi = rr.prefix;
                  this.trigger("error", {
                    reason: Kr,
                    prefix: Bi
                  });
                }, Tn = function(rr) {
                  At && Ce.iceConnectionStateIsConnected() && (At = !1, this.trigger("iceRestartSuccess")), rr === "connected" && (oe.env.name === "Chrome" && (Ge && Ge(), Ge = we((Kr) => Ce.getStats(null, Kr), () => this.trigger("audioAcquisitionProblem"))), this.trigger("connected")), this.trigger("iceConnectionStateChange", rr);
                };
                this._setVideoTrackEncodingActiveState = /* @__PURE__ */ function() {
                  var $n = (0, l.default)(/* @__PURE__ */ o.default.mark(function rr(Kr) {
                    var Bi, Li;
                    return o.default.wrap(function(Yr) {
                      for (; ; ) switch (Yr.prev = Yr.next) {
                        case 0:
                          return Bi = at.getSenders().find((Qo) => Qo.track.kind === "video"), Li = Bi.getParameters(), Li.encodings.forEach((Qo) => {
                            Qo.active = Kr;
                          }), Yr.prev = 3, Yr.next = 6, Bi.setParameters(Li);
                        case 6:
                          Yr.next = 11;
                          break;
                        case 8:
                          Yr.prev = 8, Yr.t0 = Yr.catch(3), K.error(Yr.t0);
                        case 11:
                        case "end":
                          return Yr.stop();
                      }
                    }, rr, null, [[3, 8]]);
                  }));
                  return function(rr) {
                    return $n.apply(this, arguments);
                  };
                }(), (0, p.default)(this), this.setCongestionLevel = ($n) => {
                  var rr;
                  (rr = Ye) == null || rr.setCongestionLevel($n, {
                    algorithm: "manual"
                  });
                }, this.getAudioFallbackState = () => {
                  var $n;
                  return ($n = Ye) == null ? void 0 : $n.getState();
                }, this.startEncryption = ($n) => {
                  Ce && Ce.startEncryption($n);
                }, this.changeMediaDirectionToInactive = () => {
                  Ce && Ce.changeMediaDirectionToInactive();
                }, this.changeMediaDirectionToRecvOnly = () => {
                  Ce && Ce.changeMediaDirectionToRecvOnly();
                }, this.getDataChannel = function($n, rr, Kr) {
                  Ce.getDataChannel($n, rr, Kr);
                }, this.getSourceStreamId = () => Ce.getSourceStreamId(), this.destroy = function() {
                  var $n, rr;
                  ($n = Qt) == null || $n.stop(), (rr = tn) == null || rr.stop(), Ge && (Ge(), Ge = null), Ce && (Ce.disconnect(), Ce = null), this.off();
                }, this.processMessage = function($n, rr) {
                  Ce.processMessage($n, rr);
                }, this.addTrack = function($n, rr, Kr) {
                  return Ce.addTrack($n, rr, Kr);
                }, this.removeTrack = function($n) {
                  return Ce.removeTrack($n);
                }, this.getLocalStreams = function() {
                  return Ce.getLocalStreams();
                }, this.init = function($n, rr) {
                  (0, v.default)(Sn) && (0, b.default)(pt);
                  const Kr = {
                    iceConfig: pt.needRumorIceServersFallback ? (0, c.default)(pt, {
                      servers: [...$n, ...pt.servers]
                    }) : pt,
                    channels: _t,
                    capableSimulcastStreams: Ft,
                    overrideSimulcastEnabled: Zt
                  };
                  ge(Kr, (Bi, Li) => {
                    if (Bi) {
                      rr(Bi);
                      return;
                    }
                    const xo = (0, c.default)({
                      logAnalyticsEvent: ft,
                      isPublisher: !0,
                      offerOverrides: It,
                      answerOverrides: Kt,
                      sourceStreamId: Sn,
                      p2p: Cn,
                      sessionId: on,
                      keyStore: An,
                      sFrameClientStore: Ue,
                      isE2ee: ne
                    }, Li);
                    Ce = new fe((0, c.default)({
                      sendMessage: Lt
                    }, xo)), Ce.on({
                      close: vn,
                      error: Yt,
                      qos: (Yr) => this.trigger("qos", Yr),
                      iceConnectionStateChange: Tn
                    }, this), Ce.addLocalStream(kt).then(() => {
                      rr(void 0);
                    }).catch(rr);
                  });
                }, this.setIceConfig = ($n) => {
                  Ce.setIceConfig($n);
                }, this.generateOffer = () => {
                  Ce.generateOfferAndSend();
                }, this.getSenders = function() {
                  return Ce.getSenders();
                }, this.iceRestart = function() {
                  Ce && (At = !0, Ce.iceRestart());
                }, this.hasRelayCandidates = () => Ce.hasRelayCandidates(), this.iceConnectionStateIsConnected = function() {
                  return Ce.iceConnectionStateIsConnected();
                }, this.findAndReplaceTrack = ($n, rr) => Ce.findAndReplaceTrack($n, rr), this._testOnlyGetFramesEncoded = () => new n(($n, rr) => {
                  Ce.getStats(null, (Kr, Bi) => {
                    if (Kr) {
                      rr(Kr);
                      return;
                    }
                    const Li = (0, u.default)(Bi, (xo) => de.isVideoStat(xo, Bi) && de.isOutboundStat(xo));
                    if (!Li) {
                      rr(new Error("Could not find framesEncoded in getStats report"));
                      return;
                    }
                    $n((0, d.default)(Li, ["timestamp", "framesEncoded"]));
                  });
                }), this.getStats = ($n) => Ce.getStats(null, $n), this.getRtcStatsReport = ($n) => Ce.getRtcStatsReport(null, $n), this.setVideoActiveState = ($n) => {
                  this._setVideoTrackEncodingActiveState($n);
                }, this.setP2PMaxBitrate = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function $n() {
                  var rr, Kr, Bi, Li, xo, Yr, Qo;
                  return o.default.wrap(function(xi) {
                    for (; ; ) switch (xi.prev = xi.next) {
                      case 0:
                        if (at.getSourceStreamId() === "P2P") {
                          xi.next = 2;
                          break;
                        }
                        return xi.abrupt("return");
                      case 2:
                        if (Kr = at.getSenders().find((Fa) => Fa.track.kind === "video"), Kr) {
                          xi.next = 5;
                          break;
                        }
                        return xi.abrupt("return");
                      case 5:
                        return Bi = (Kr == null || (rr = Kr.track) == null || rr.getSettings == null ? void 0 : rr.getSettings()) || {}, Li = Bi.width, xo = Bi.height, Yr = (0, m.default)(Li, xo), Qo = Kr.getParameters(), Qo.encodings.forEach((Fa) => {
                          Fa.maxBitrate = Yr;
                        }), xi.prev = 9, xi.next = 12, Kr.setParameters(Qo);
                      case 12:
                        xi.next = 16;
                        break;
                      case 14:
                        xi.prev = 14, xi.t0 = xi.catch(9);
                      case 16:
                      case "end":
                        return xi.stop();
                    }
                  }, $n, null, [[9, 14]]);
                }));
                const er = function(rr) {
                  var Kr, Bi;
                  let Li = rr === void 0 ? {} : rr, xo = Li.isAmrTransition, Yr = xo === void 0 ? !1 : xo;
                  at._setVideoTrackEncodingActiveState(!1), (Kr = Qt) == null || Kr.stop(), (Bi = tn) == null || Bi.start(Yr ? {
                    getDelayForProbeNumber: $e
                  } : {});
                };
                this.disableCongestionLevelEstimation = () => {
                  if (se) {
                    var $n, rr, Kr;
                    ($n = Qt) == null || $n.stop(), (rr = tn) == null || rr.stop(), (Kr = Ye) == null || Kr.reset();
                  }
                }, this.enableCongestionLevelEstimation = ($n) => {
                  if (se) {
                    var rr, Kr;
                    if ((rr = tn) == null || rr.stop(), $n) {
                      if (Ye.setInternalState($n), $n.videoState === Z) {
                        er({
                          isAmrTransition: !0
                        });
                        return;
                      }
                    } else
                      Ye.setCongestionLevel(J.CongestionLevels.LOW);
                    (Kr = Qt) == null || Kr.start();
                  }
                };
                const lr = () => {
                  Ye = _e({
                    logAnalyticsEvent: ft
                  }), Ye.on("stateChange", ($n) => {
                    let rr = $n.state;
                    switch (rr) {
                      case G:
                        this._setVideoTrackEncodingActiveState(!0);
                        break;
                      case Z:
                        er();
                        break;
                    }
                    this.trigger("audioFallbackStateChange", {
                      state: rr
                    });
                  }), Qt.on("congestionLevel", ($n, rr) => {
                    var Kr;
                    (Kr = Ye) == null || Kr.setCongestionLevel($n, rr);
                  }), tn.on("networkRecovered", () => {
                    var $n, rr;
                    ($n = Ye) == null || $n.setCongestionLevel(J.CongestionLevels.LOW), (rr = Qt) == null || rr.start();
                  });
                }, Br = () => {
                  Qt = Te({
                    getStats: this.getStats,
                    logAnalyticsEvent: ft
                  }), this.on("connected", () => {
                    Qt.start();
                  });
                };
                se && ((() => {
                  tn = Pe({
                    getStats: this.getStats,
                    setVideoActive: this._setVideoTrackEncodingActiveState
                  });
                })(), Br(), lr());
              };
            }
          }).call(this, e(2));
        },
        /* 313 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = c(e(668));
          function l(g) {
            if (typeof WeakMap != "function") return null;
            var f = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap();
            return (l = function(b) {
              return b ? p : f;
            })(g);
          }
          function c(g, f) {
            if (g && g.__esModule)
              return g;
            if (g === null || typeof g != "object" && typeof g != "function")
              return { default: g };
            var p = l(f);
            if (p && p.has(g))
              return p.get(g);
            var v = {}, b = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var m in g)
              if (m !== "default" && Object.prototype.hasOwnProperty.call(g, m)) {
                var y = b ? Object.getOwnPropertyDescriptor(g, m) : null;
                y && (y.get || y.set) ? Object.defineProperty(v, m, y) : v[m] = g[m];
              }
            return v.default = g, p && p.set(g, v), v;
          }
          const d = 1e3, u = 500;
          var A = function(f, p) {
            p === void 0 && (p = {});
            const v = p.StatsUtils || o, b = new t.default();
            let m, y;
            const U = () => {
              m = void 0, y = void 0;
            }, B = (W) => {
              m === void 0 && (m = W);
              let G;
              return W.audioReportTimestamp !== m.audioReportTimestamp && (W.audioFractionLost !== void 0 ? G = W.audioFractionLost : G = v.getAudioPacketLoss(W, m), m = W), G;
            }, Q = (W) => {
              y === void 0 && (y = W);
              let G;
              return W.videoReportTimestamp !== y.videoReportTimestamp && (G = v.getVideoPacketLoss(W, y), y = W), G;
            }, N = (W) => {
              const G = v.parseStats(W), Z = B(G), K = Q(G), L = G.bandwidth, O = G.videoResolution;
              b.emit("statsAvailable", {
                audioPacketLoss: Z,
                videoPacketLoss: K,
                bandwidth: L,
                videoResolution: O
              });
            }, J = () => {
              f((W, G) => {
                W || N(G);
              });
            };
            let w;
            return Object.assign(b, {
              start() {
                w || (w = setTimeout(() => {
                  J(), w = setInterval(() => {
                    J();
                  }, u);
                }, d));
              },
              stop() {
                clearInterval(w), w = void 0, U();
              }
            });
          };
          r.default = A;
        },
        /* 314 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = function(l) {
            l === void 0 && (l = 0);
            let c = l, d = 1e4, u, h = 0;
            const A = () => {
              const g = Date.now();
              if (!u)
                return u = g, 1;
              const f = g - u, p = 1 - Math.exp(-f / d);
              return u = g, p;
            };
            return {
              setPeriod(g) {
                d = g;
              },
              getMovingAverageValue() {
                return c;
              },
              addValue(g) {
                if (g === void 0 || isNaN(g)) return;
                const f = A();
                c = g * f + c * (1 - f), h += 1;
              },
              reset() {
                c = l, u = void 0, h = 0;
              },
              getDataPointCount() {
                return h;
              }
            };
          };
          r.default = t;
        },
        /* 315 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = e(110);
          const t = 30 * n.ONE_SECOND_IN_MS, o = 2 * n.ONE_MINUTE_IN_MS, l = [t, n.ONE_MINUTE_IN_MS, o];
          var d = (u) => {
            var h;
            return (h = l[u]) != null ? h : l[l.length - 1];
          };
          r.default = d;
        },
        /* 316 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(675)), o = (l) => l !== "P2P" ? !1 : (0, t.default)();
          r.default = o;
        },
        /* 317 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            t.transportPolicy = "relay", t.customServers = t.customServers || [];
          };
          r.default = n;
        },
        /* 318 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = b;
          var t = n(e(9)), o = n(e(6)), l = n(e(10)), c = n(e(22)), d = n(e(316)), u = n(e(317)), h = n(e(7)), A = n(e(74)), g = n(e(680)), f = n(e(170)), p = n(e(8)), v = n(e(682));
          function b(m) {
            m === void 0 && (m = {});
            const y = m.OTHelpers || h.default, U = m.PeerConnection || (0, A.default)(), B = m.SinglePeerConnectionAdapter || (0, g.default)(), Q = m.setCertificates || (0, f.default)(), N = m.Errors || p.default, J = m.ExceptionCodes || l.default, w = m.OTErrorClass || c.default, W = m.watchSubscriberAudio || v.default;
            return function(Z) {
              let K = Z.clientCandidates, L = Z.iceConfig, O = Z.send, de = Z.logAnalyticsEvent, oe = Z.p2p, fe = Z.codecFlags, ge = Z.sourceStreamId, we = Z.remoteConnectionId, _e = Z._singlePeerConnectionController, Te = Z.keyStore, Pe = Z.sFrameClientStore, $e = Z.isE2ee, Bt = Z.sessionId;
              const Le = this;
              let at, pt = !1, kt = !1, _t = null;
              const Lt = !!_e, Ft = [], Zt = [], ft = function() {
                this.destroy(), kt && this.trigger("iceRestartFailure", this), this.trigger("disconnected", this);
              }, It = (Ye) => {
                const Qt = Ye.kind === "video" ? Ft : Zt;
                Qt.includes(Ye) || Qt.push(Ye);
              }, Kt = (Ye) => {
                let Qt = Ye.track, tn = Ye.transceiver, vn = Ye.stream;
                It(Qt), this.trigger("remoteTrackAdded", vn, this), $e && at.startDecryption(we, tn);
              }, Sn = (Ye) => {
                this.trigger("remoteVideoSupported", Ye);
              }, Cn = () => {
                this.trigger("decryptFailed");
              }, on = () => {
                this.trigger("decryptRestored");
              }, An = function(Qt) {
                let tn = Qt.reason, vn = Qt.prefix;
                this.trigger("error", null, tn, this, vn);
              }, Ue = function(Qt) {
                kt && (Qt === "connected" || Qt === "completed") && (kt = !1, this.trigger("iceRestartSuccess")), Qt === "connected" && this.trigger("connected"), this.trigger("iceConnectionStateChange", Qt);
              }, ne = function(Qt) {
                this.trigger("signalingStateChange", Qt);
              }, se = function(Qt) {
                this.trigger("signalingStateStable", Qt);
              }, Ce = (Ye, Qt, tn) => {
                (Ye === "answer" || Ye === "pranswer") && this.trigger("connected"), O({
                  type: Ye,
                  content: Qt
                }, tn);
              }, At = (Ye) => {
                var Qt;
                const tn = Zt[0];
                (Qt = at) == null || Qt.getStats(tn, Ye);
              };
              (0, o.default)(this), this._hasAudioTracks = () => Zt.length > 0, this._hasVideoTracks = () => Ft.length > 0, this._getVideoTracks = () => Ft, this._getAudioTracks = () => Zt, this._getTracks = () => [...Zt, ...Ft], this.close = function() {
                pt || (pt = !0, at && (at.disconnect(), at = null), this.off());
              }, this.destroy = function() {
                this.stopAudioStatsWatcher(), !pt && this.close();
              }, this.getDataChannel = function(Ye, Qt, tn) {
                at.getDataChannel(Ye, Qt, tn);
              }, this.getSourceStreamId = () => at.getSourceStreamId(), this.processMessage = function(Ye, Qt) {
                at.processMessage(Ye, Qt);
              }, this.remoteDescription = function() {
                return at.remoteDescription();
              }, this.getStats = function(Ye) {
                if (at)
                  at.getStats(null, Ye);
                else {
                  const Qt = J.PEER_CONNECTION_NOT_CONNECTED;
                  Ye(new y.Error(w.getTitleByCode(Qt), N.PEER_CONNECTION_NOT_CONNECTED, {
                    code: Qt
                  }));
                }
              }, this.getAudioStats = function(Ye) {
                At(Ye);
              }, this.getSynchronizationSources = function(Ye) {
                if (!at) {
                  const Qt = J.PEER_CONNECTION_NOT_CONNECTED;
                  Ye(new y.Error(w.getTitleByCode(Qt), N.PEER_CONNECTION_NOT_CONNECTED, {
                    code: Qt
                  }));
                  return;
                }
                at.getSynchronizationSources(Ye);
              }, this.getRtcStatsReport = function(Ye) {
                if (at)
                  at.getRtcStatsReport(null, Ye);
                else {
                  const Qt = J.PEER_CONNECTION_NOT_CONNECTED;
                  Ye(new y.Error(w.getTitleByCode(Qt), N.PEER_CONNECTION_NOT_CONNECTED, {
                    code: Qt
                  }));
                }
              }, this.setIceConfig = (Ye) => {
                at.setIceConfig(Ye);
              }, this.generateOffer = () => {
                at.generateOfferAndSend();
              }, this.startAudioStatsWatcher = function(Ye) {
                _t || (_t = W(At, (Qt) => {
                  this.stopAudioStatsWatcher(), this.trigger("audioLevelStuckWarning", Qt);
                }, Ye));
              }, this.stopAudioStatsWatcher = function() {
                _t && _t.stop(), _t = null;
              };
              const Ge = function(Qt) {
                return function(tn) {
                  const vn = Qt === "video" ? Ft : Zt;
                  at && at.remoteTracks().forEach((Yt) => {
                    Yt.kind === Qt && Yt.enabled !== tn && vn.includes(Yt) && (Yt.enabled = tn);
                  });
                };
              };
              this.subscribeToAudio = Ge("audio"), this.subscribeToVideo = Ge("video"), this.hasRelayCandidates = function() {
                return at.hasRelayCandidates();
              }, this.iceRestart = function() {
                return kt = !0, at.iceRestart();
              }, this.iceConnectionStateIsConnected = function() {
                return at.iceConnectionStateIsConnected();
              }, this.init = function(Ye) {
                (0, d.default)(ge) && (0, u.default)(L), Q({
                  iceConfig: L
                }, (tn, vn) => {
                  if (tn) {
                    Ye(tn);
                    return;
                  }
                  const Yt = (0, t.default)({
                    logAnalyticsEvent: de,
                    clientCandidates: K,
                    codecFlags: fe,
                    sourceStreamId: ge,
                    keyStore: Te,
                    sFrameClientStore: Pe,
                    isE2ee: $e,
                    sessionId: Bt
                  }, vn), Tn = (0, t.default)({
                    sendMessage: Ce,
                    p2p: oe
                  }, Yt, {
                    remoteConnectionId: we
                  });
                  Lt ? at = new B(Tn, _e) : at = new U(Tn), at.on({
                    iceConnected: () => Le.emit("iceConnected"),
                    close: ft,
                    trackAdded: Kt,
                    signalingStateChange: ne,
                    signalingStateStable: se,
                    error: An,
                    qos: (er) => this.trigger("qos", er),
                    iceConnectionStateChange: Ue,
                    remoteVideoSupported: Sn,
                    decryptFailed: Cn,
                    decryptRestored: on
                  }, Le), !Lt && at.remoteTracks().length > 0 ? at.remoteStreams().forEach((er) => {
                    er.getTracks().forEach((lr) => Kt({
                      stream: er,
                      track: lr
                    }));
                  }) : Ye(void 0, Le);
                });
              };
            };
          }
        },
        /* 319 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(167));
          function o(l) {
            l === void 0 && (l = {});
            const A = (l.generateSimpleStateMachine || (0, t.default)())("NotPublishing", ["NotPublishing", "GetUserMedia", "BindingMedia", "MediaBound", "PublishingToSession", "Publishing", "Failed", "Destroyed"], {
              NotPublishing: ["NotPublishing", "GetUserMedia", "Destroyed"],
              GetUserMedia: ["BindingMedia", "Failed", "NotPublishing", "Destroyed"],
              BindingMedia: ["MediaBound", "Failed", "NotPublishing", "Destroyed"],
              MediaBound: ["NotPublishing", "PublishingToSession", "Failed", "Destroyed"],
              PublishingToSession: ["NotPublishing", "Publishing", "Failed", "Destroyed", "MediaBound"],
              Publishing: ["NotPublishing", "MediaBound", "Failed", "Destroyed"],
              Failed: ["Destroyed"],
              Destroyed: []
            });
            return A.prototype.isDestroyed = function() {
              return this.current === "Destroyed";
            }, A.prototype.isAttemptingToPublish = function() {
              return ["GetUserMedia", "BindingMedia", "MediaBound", "PublishingToSession"].indexOf(this.current) !== -1;
            }, A.prototype.isPublishing = function() {
              return this.current === "Publishing";
            }, A;
          }
        },
        /* 320 */
        /***/
        function(i, r, e) {
          Object.defineProperty(r, "__esModule", {
            value: !0
          }), r.default = n;
          function n(t) {
            this.message = t || "Operation has been canceled.", this.name = "CancellationError", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
          }
          n.prototype = Object.create(Error.prototype), n.prototype.constructor = n;
        },
        /* 321 */
        /***/
        function(i, r, e) {
          var n = e(2);
          Object.defineProperty(r, "__esModule", { value: !0 });
          function t(o, l) {
            return n.resolve(o).then((c) => n.resolve(l()).then(() => c), (c) => n.resolve(l()).then(() => n.reject(c)));
          }
          r.default = t;
        },
        /* 322 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.isAmrVideoBufferError = r.createAmrVideoBufferError = void 0;
          const n = "bufferFailed: videoBuffer failed to load or timeout", t = (l) => l.message === n;
          r.isAmrVideoBufferError = t;
          const o = () => new Error(n);
          r.createAmrVideoBufferError = o;
        },
        /* 323 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = ao;
            var o = t(e(4)), l = t(e(5)), c = t(e(692)), d = e(111), u = t(e(16)), h = t(e(14)), A = t(e(9)), g = t(e(143)), f = t(e(58)), p = t(e(272)), v = t(e(51)), b = t(e(296)), m = t(e(289)), y = t(e(693)), U = t(e(6)), B = t(e(1)), Q = t(e(57)), N = t(e(3)), J = t(e(324)), w = t(e(285)), W = t(e(694)), G = t(e(695)), Z = t(e(10)), K = t(e(22)), L = t(e(696)), O = t(e(31)), de = t(e(327)), oe = t(e(13)), fe = t(e(697)), ge = t(e(8)), we = t(e(50)), _e = t(e(109)), Te = t(e(698)), Pe = t(e(173)), $e = t(e(699)), Bt = t(e(302)), Le = t(e(152)), at = t(e(303)), pt = t(e(153)), kt = t(e(23)), _t = t(e(77)), Lt = t(e(700)), Ft = t(e(328)), Zt = t(e(701)), ft = t(e(169)), It = t(e(304)), Kt = t(e(305)), Sn = t(e(7)), Cn = t(e(158)), on = t(e(151)), An = t(e(74)), Ue = t(e(318)), ne = t(e(329)), se = t(e(306)), Ce = t(e(704)), At = t(e(705)), Ge = t(e(706)), Ye = t(e(330)), Qt = e(107), tn = t(e(176)), vn = t(e(707)), Yt = t(e(177)), Tn = e(322), er = t(e(331)), lr = t(e(110)), Br = t(e(325));
            const pi = ["AudioLevelMeter", "AudioLevelTransformer", "BackingBar", "Chrome", "env", "Errors", "Events", "ExceptionCodes", "audioLevelSamplerFactory", "getStatsHelpers", "hasAudioOutputLevelStatCapability", "hasRemoteStreamsWithWebAudio", "interpretPeerConnectionError", "logging", "MuteButton", "NamePanel", "otError", "OTErrorClass", "OTHelpers", "StylableComponent", "SubscriberPeerConnection", "SubscribingState", "VideoDisabledIndicator", "AudioBlockedIndicator", "VideoUnsupportedIndicator", "watchFrameRate", "createSendMethod", "parseIceServers", "document", "WidgetView", "createAudioConnector", "ResizeObserverPolyfill", "AMRStateDurations"], $n = (0, Pe.default)(), rr = (0, kt.default)(), Kr = ge.default, Bi = (0, ft.default)(), Li = (0, It.default)(), xo = (0, on.default)(typeof window !== void 0 ? window : Dn), Yr = (0, An.default)({
              global: xo
            }), Qo = (0, Ue.default)({
              PeerConnection: Yr
            }), Wo = (0, B.default)("Subscriber"), xi = (0, oe.default)(), Fa = 100, sn = (wr, Jr) => wr.connection.id === Jr.connection.id, Ct = (wr) => {
              let Jr = wr.apiKey, Fn = wr.sessionId, Ia = wr.streamId, wt = wr.subscriberId;
              return ["/v2/partner", Jr, "session", Fn, "stream", Ia, "subscriber", wt].join("/");
            }, cn = (0, L.default)();
            function Hn(wr) {
              return Math.max(0, Math.min(100, parseInt(wr, 10)));
            }
            function Sr(wr) {
              return wr.audioVolume !== void 0 ? wr.audioVolume : wr.subscribeToAudio === !1 ? 0 : Fa;
            }
            function ao(wr) {
              wr === void 0 && (wr = {});
              let Jr = wr, Fn = Jr.AudioLevelMeter, Ia = Fn === void 0 ? Bt.default : Fn, wt = Jr.AudioLevelTransformer, Yn = wt === void 0 ? Le.default : wt, kr = Jr.BackingBar, mr = kr === void 0 ? at.default : kr, yi = Jr.Chrome, Or = yi === void 0 ? pt.default : yi, Ei = Jr.env, Rt = Ei === void 0 ? N.default : Ei, ln = Jr.Errors, tt = ln === void 0 ? Kr : ln, Oe = Jr.Events, Jt = Oe === void 0 ? rr : Oe, St = Jr.ExceptionCodes, Vt = St === void 0 ? Z.default : St, Et = Jr.audioLevelSamplerFactory, Qn = Et === void 0 ? Zt.default : Et, gn = Jr.getStatsHelpers, jt = gn === void 0 ? _t.default : gn, On = Jr.hasAudioOutputLevelStatCapability, Ar = On === void 0 ? Lt.default : On, ui = Jr.hasRemoteStreamsWithWebAudio, fr = ui === void 0 ? Ft.default : ui, Jn = Jr.interpretPeerConnectionError, Qr = Jn === void 0 ? Bi : Jn, ti = Jr.logging, Wn = ti === void 0 ? Wo : ti, Hi = Jr.MuteButton, Ho = Hi === void 0 ? Li : Hi, Ea = Jr.NamePanel, Ga = Ea === void 0 ? Kt.default : Ea, No = Jr.otError, Ba = No === void 0 ? xi : No, Ra = Jr.OTErrorClass, us = Ra === void 0 ? K.default : Ra, so = Jr.OTHelpers, Va = so === void 0 ? Sn.default : so, qa = Jr.StylableComponent, hs = qa === void 0 ? Cn.default : qa, oi = Jr.SubscriberPeerConnection, oa = oi === void 0 ? Qo : oi, Wa = Jr.SubscribingState, Xa = Wa === void 0 ? ne.default : Wa, ya = Jr.VideoDisabledIndicator, Fl = ya === void 0 ? se.default : ya, As = Jr.AudioBlockedIndicator, gl = As === void 0 ? Ce.default : As, Vi = Jr.VideoUnsupportedIndicator, zr = Vi === void 0 ? At.default : Vi, za = Jr.watchFrameRate, ws = za === void 0 ? Ge.default : za, Zi = Jr.createSendMethod, kl = Zi === void 0 ? Ye.default : Zi, vc = Jr.parseIceServers, wl = vc === void 0 ? Qt.parseIceServers : vc, ys = Jr.document, Xn = ys === void 0 ? (typeof window !== void 0 ? window : Dn).document : ys, Kn = Jr.WidgetView, pr = Kn === void 0 ? $n : Kn, hi = Jr.createAudioConnector, Qi = hi === void 0 ? vn.default : hi, qt = Jr.ResizeObserverPolyfill, bn = qt === void 0 ? y.default : qt, hn = Jr.AMRStateDurations, xn = (0, c.default)(Jr, pi);
              const vr = 3e4, Rr = 15e3, zi = xn.RESIZE_DEBOUNCE_WAIT || lr.default, _i = function Ko(ps, ho, Ya) {
                var La = this, Jd;
                if (ho === void 0 && (ho = {}), Ya === void 0 && (Ya = () => {
                }), ho.analytics === void 0)
                  throw new Error("Subscriber requires an instance of analytics");
                const zo = ho.analytics, Rl = (0, u.default)(), ms = Ko.hasAudioOutputLevelStatCapability() || fr(), $o = this, bc = {}, Zc = {}, oc = {}, gu = {}, zd = {}, ka = Qi(oc);
                let jr, xe, ot, ye, re, Be, He, Xe, ut, ct, Xt, pn, un, vt, gr = !1, sr = ps || Rl, an = ho.session, En = ho.stream;
                const fn = ho, Fr = fn._singlePeerConnectionController, Ro = Fr !== void 0;
                let ca, Co, ga = !1, aa, Dl = {}, Jo = null, Pi = !1, wa = !0, yl = [], Ci = (0, g.default)({}, ho, {
                  showControls: !0,
                  testNetwork: !1,
                  fitMode: En.defaultFitMode || "cover",
                  insertDefaultUI: !0,
                  initials: En.initials
                }), Ti, Di;
                const Gd = an.sessionInfo.isAdaptiveEnabled, _l = {
                  P2P: O.default.SUBSCRIBER_DISCONNECTED,
                  MANTIS: O.default.SUBSCRIBER_DISCONNECTED
                };
                let Zl, Ml, kc, Td;
                const wc = Rt.name === "Chrome" && Rt.version >= 58 || Rt.isChromiumEdge || Rt.isOpera, $l = an._.getSocket(), Yl = (0, J.default)(hn);
                Yl.on("transitionToP2PTimeout", () => {
                  $l.subscriberDestroy(En.id, this.widgetId, Br.default.P2P), Di = Br.default.P2P, Yl.completeTransitionTo(Di);
                });
                const js = () => (0, b.default)(Zc), ac = (be) => Zc[be], Dc = () => Zc[Di], Ll = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          return Qe.next = 2, Zc[P];
                        case 2:
                          te = Qe.sent, te == null || te.close(), delete Zc[P];
                        case 5:
                        case "end":
                          return Qe.stop();
                      }
                    }, ze);
                  }));
                  return function(P) {
                    return be.apply(this, arguments);
                  };
                }(), ed = (be) => {
                  delete oc[be];
                }, sc = () => {
                  js().forEach(/* @__PURE__ */ function() {
                    var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                      return o.default.wrap(function(Re) {
                        for (; ; ) switch (Re.prev = Re.next) {
                          case 0:
                            return Re.next = 2, P;
                          case 2:
                            Re.sent.destroy();
                          case 3:
                          case "end":
                            return Re.stop();
                        }
                      }, ze);
                    }));
                    return function(ze) {
                      return be.apply(this, arguments);
                    };
                  }()), Object.keys(Zc).forEach((be) => {
                    delete Zc[be];
                  });
                }, Ql = (be) => {
                  En.setChannelActiveState(Object.assign({}, be, {
                    isSubscriber: !0
                  }));
                }, ql = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te, Re, Qe;
                    return o.default.wrap(function(Ht) {
                      for (; ; ) switch (Ht.prev = Ht.next) {
                        case 0:
                          if (P) {
                            Ht.next = 2;
                            break;
                          }
                          return Ht.abrupt("return");
                        case 2:
                          return Re = {
                            error: lc,
                            audioVolume: ca,
                            hasVideo: (te = En) == null ? void 0 : te.hasVideo
                          }, Qe = Gd && Di === "P2P", Ht.prev = 4, Ht.next = 7, jr.bindVideo(P, Re, Qe);
                        case 7:
                          Ht.next = 15;
                          break;
                        case 9:
                          if (Ht.prev = 9, Ht.t0 = Ht.catch(4), !(Ht.t0 instanceof d.CancellationError || Be.isDestroyed())) {
                            Ht.next = 13;
                            break;
                          }
                          return Ht.abrupt("return");
                        case 13:
                          throw lc(Ht.t0), Ht.t0;
                        case 15:
                        case "end":
                          return Ht.stop();
                      }
                    }, ze, null, [[4, 9]]);
                  }));
                  return function(P) {
                    return be.apply(this, arguments);
                  };
                }(), Ds = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P, te) {
                    var Re, Qe, yt, Ht;
                    return o.default.wrap(function(rn) {
                      for (; ; ) switch (rn.prev = rn.next) {
                        case 0:
                          if (Re = !1, typeof P == "function" ? te = P : Re = P === "rtcStatsReport", Re ? wd() : id(), !(Re && !de.default)) {
                            rn.next = 7;
                            break;
                          }
                          return Qe = Vt.GET_RTC_STATS_REPORT_NOT_SUPPORTED, te(Ba(ge.default.GET_RTC_STATS_REPORT_NOT_SUPPORTED, new Error(us.getTitleByCode(Qe)), Qe)), rn.abrupt("return");
                        case 7:
                          if (Dc()) {
                            rn.next = 11;
                            break;
                          }
                          return Qe = Vt.PEER_CONNECTION_NOT_CONNECTED, te(Ba(tt.PEER_CONNECTION_NOT_CONNECTED, new Error(us.getTitleByCode(Qe)), Qe)), rn.abrupt("return");
                        case 11:
                          return rn.next = 13, Dc();
                        case 13:
                          yt = rn.sent, Ht = Re ? yt.getRtcStatsReport : yt.getStats, Ht((tr, Vn) => {
                            tr ? (tr.code === Vt.PEER_CONNECTION_NOT_CONNECTED && (tr = Ba(tt.PEER_CONNECTION_NOT_CONNECTED, tr, Vt.PEER_CONNECTION_NOT_CONNECTED)), te(tr)) : te(null, Vn);
                          });
                        case 16:
                        case "end":
                          return rn.stop();
                      }
                    }, ze);
                  }));
                  return function(P, te) {
                    return be.apply(this, arguments);
                  };
                }(), jd = (be) => Ds(be), Sc = (be) => Ds("rtcStatsReport", be), Cl = (be) => ut ? be === "video" ? ut.getVideoTracks().length > 0 : ut.getAudioTracks().length > 0 : !1, _r = (be, ze, P, te, Re) => {
                  let Qe = (0, A.default)({
                    action: be,
                    variation: ze,
                    payload: P,
                    streamId: En ? En.id : null,
                    sessionId: an ? an.sessionId : null,
                    connectionId: an && an.isConnected() ? an.connection.connectionId : null,
                    partnerId: an && an.sessionInfo ? an.sessionInfo.partnerId : null,
                    subscriberId: Rl,
                    widgetType: "Subscriber",
                    singlePeerConnection: !!Fr
                  }, te);
                  (ze === "Failure" || ze === "iceconnectionstatechange" && P === "closed") && (Qe = (0, A.default)(Qe, Dl));
                  const yt = [Qe];
                  Re && yt.push(Re), zo.logEvent(...yt);
                }, Xd = (be, ze, P) => {
                  ze === "Attempt" ? (gu[be] = (/* @__PURE__ */ new Date()).getTime(), _r(be, ze, P)) : (ze === "Failure" || ze === "Success") && _r(be, ze, P, {
                    attemptDuration: (/* @__PURE__ */ new Date()).getTime() - gu[be]
                  });
                }, to = function(ze, P) {
                  P === void 0 && (P = {}), Xd("RoutedToRelayedTransition", ze, P);
                }, Za = function(ze, P) {
                  P === void 0 && (P = {}), Xd("RelayedToRoutedTransition", ze, P);
                }, sa = (0, G.default)({
                  onInvalidTransition(be, ze) {
                    const P = `Invalid state transition: Event '${be}' not possible in state '${ze}'`;
                    Wn.error(P), _r("Subscriber:InvalidStateTransition", "Event", {
                      details: P
                    });
                  }
                });
                {
                  const be = "Unable to subscribe to stream in a reasonable amount of time";
                  (0, fe.default)({
                    connectivityState: sa,
                    onWarning() {
                      Cd("Warning", {});
                    },
                    onTimeout: () => {
                      if (jr && jr.addError(be), Be.isAttemptingToSubscribe()) {
                        Be.set("Failed"), this._disconnect({
                          noStateTransition: !0
                        });
                        const ze = Ba(ge.default.TIMEOUT, new Error(be), Vt.UNABLE_TO_SUBSCRIBE);
                        sa.fail({
                          options: {
                            failureReason: "Subscribe",
                            failureMessage: be,
                            failureCode: Vt.UNABLE_TO_SUBSCRIBE
                          },
                          error: ze
                        });
                      }
                    },
                    warningMs: Rr,
                    timeoutMs: vr
                  });
                }
                bc.promise = new n((be, ze) => {
                  bc.resolve = be, bc.reject = ze;
                }), Ci.testNetwork && an.sessionInfo.p2pEnabled && Wn.warn("You cannot test your network with a relayed session. Use a routed session.");
                const Ec = Ci.preferredResolution === "auto" && !an.sessionInfo.p2pEnabled;
                if (this.id = sr, this.widgetId = Rl, this.session = an, this.stream = Ci.stream, En = Ci.stream, this.streamId = En.id, !an)
                  return us.handleJsException({
                    errorMsg: "OT.Subscriber must be passed a session option",
                    code: 2e3,
                    target: this,
                    analytics: zo
                  }), null;
                (0, U.default)(this), $o.once("subscribeComplete", function() {
                  try {
                    Ya(...arguments);
                  } catch (be) {
                    Wn.error("Completion handler threw an exception", be);
                  }
                }), an.on("captionReceived", (be) => {
                  be.streamId === $o.streamId && (this.dispatchEvent(be), this.trigger(O.default.SUBSCRIBER_CAPTION_RECEIVED, be));
                });
                const Fc = (be) => {
                  let ze = be.transition, P = be.from;
                  return ze === "fail" ? P === "connected" ? "Disconnect" : "Failure" : ze === "disconnect" && P === "connected" ? "Disconnect" : "Cancel";
                };
                sa.observe({
                  onEnterConnecting() {
                    Cd("Attempt", null, {});
                  },
                  onEnterConnected() {
                    Cd("Success", null, {});
                  },
                  onEnterDisconnected(be, ze) {
                    let P = ze === void 0 ? {} : ze, te = P.options, Re = te === void 0 ? {} : te, Qe = P.payload, yt = Qe === void 0 ? null : Qe;
                    Cd(Fc(be), yt, Re);
                  }
                }), sa.observe({
                  onEnterConnected: () => {
                    this.trigger("subscribeComplete", void 0, this);
                  },
                  onEnterDisconnected: function(ze, P) {
                    let te = ze.from, Re = P === void 0 ? {} : P, Qe = Re.error;
                    te === "connecting" && La.trigger("subscribeComplete", Qe || new Error("An unknown error occurred"), La);
                  }
                }), (0, W.default)({
                  connectivityState: sa,
                  logAttempt() {
                    _r("Subscribe", "Attempting", null, {
                      connectionId: an && an.isConnected() ? an.connection.connectionId : null
                    });
                  }
                });
                const Cd = function(ze, P, te) {
                  P === void 0 && (P = {}), ze === "Failure" || ze === "Success" || ze === "Cancel" ? _r("Subscribe", ze, P, Object.assign({}, te, {
                    attemptDuration: (/* @__PURE__ */ new Date()).getTime() - pn
                  })) : ze === "Attempt" ? (pn = (/* @__PURE__ */ new Date()).getTime(), _r("Subscribe", ze, Object.assign({}, P, {
                    testNetwork: Ci.testNetwork
                  }), te)) : _r("Subscribe", ze, P, te);
                }, Sl = (be, ze) => {
                  _r("ICERestart", be, ze);
                }, Uo = (be) => {
                  var ze, P;
                  let te = be.parsedStats, Re = be.remoteConnectionId, Qe = be.peerId, yt = be.sourceStreamId;
                  const Ht = {
                    widgetType: "Subscriber",
                    width: jr.width,
                    height: jr.height,
                    audioTrack: Cl("audio"),
                    hasAudio: En && En.hasAudio,
                    subscribeToAudio: vt,
                    audioVolume: this.getAudioVolume(),
                    videoTrack: Cl("video"),
                    connectionId: an ? an.connection.connectionId : null,
                    hasVideo: En && En.hasVideo,
                    subscribeToVideo: Ci.subscribeToVideo,
                    congestionLevel: Jo,
                    streamId: En.id,
                    subscriberId: Rl,
                    duration: Math.round(((0, we.default)() - re) / 1e3),
                    remoteConnectionId: Re,
                    peerId: Qe,
                    sourceStreamId: (0, tn.default)(yt),
                    preferredResolutionHeight: (ze = Ci.preferredResolution) == null ? void 0 : ze.height,
                    preferredResolutionWidth: (P = Ci.preferredResolution) == null ? void 0 : P.width,
                    preferredFrameRate: Ci.preferredFrameRate,
                    audioFallback: !ct && Xt === "auto",
                    initials: En.initials
                  }, zt = (0, A.default)(Ht, te);
                  zo.logQOS(zt), this.trigger("qos", Object.assign({}, zo.commonQoSFields(), zt));
                }, ja = (be) => {
                  Wn.error("OT.Subscriber State Change Failed: ", be.message), Wn.debug(be);
                }, Mc = () => {
                  Be.isSubscribing() || !jr || !jr.video() || (gr = !0, Pi || (sa.connect(), Pi = !0), Wn.debug("OT.Subscriber.onLoaded"), Be.set("Subscribing"), re = (0, we.default)(), jr.loading(!1), xe && xe.showAfterLoading(), ga && En.setRestrictFrameRate(!0), ye && ye.audioOnly(jr.audioOnly()), this.setAudioVolume(ca), this.trigger("loaded", this));
                }, td = () => En && En.hasAudio && vt && this.getAudioVolume() > 0 && !this.isAudioBlocked(), Ud = () => En && En.hasVideo, fl = (be) => {
                  const ze = be === "audioLevelStuckAt0" && (!td() || Ud());
                  let P = !1;
                  if (!ze && (_r("subscriber:onAudioWarning", "Event", {
                    reason: be
                  }), jr)) {
                    if (jr.rebindSrcObject(), _r("subscriber:rebindSrcObject", "Called"), be === "audioLevelStuck")
                      return;
                    P = !0;
                  }
                  ou(P);
                }, ou = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if (P === void 0 && (P = !1), !wc) {
                            Qe.next = 6;
                            break;
                          }
                          return Qe.next = 4, Dc();
                        case 4:
                          te = Qe.sent, te.startAudioStatsWatcher(P);
                        case 6:
                        case "end":
                          return Qe.stop();
                      }
                    }, ze);
                  }));
                  return function(P) {
                    return be.apply(this, arguments);
                  };
                }(), nd = (be) => {
                  Gd && be.getSourceStreamId() === "P2P" && to("Success");
                }, au = () => {
                  Wn.debug("OT.Subscriber has been disconnected from the Publisher's PeerConnection"), sa.fail({
                    options: {
                      failureReason: "PeerConnectionError",
                      failureCode: Vt.UNABLE_TO_PUBLISH,
                      failureMessage: "PeerConnection disconnected"
                    },
                    error: Ba(tt.DISCONNECTED, new Error("ClientDisconnected"))
                  }), this._disconnect({
                    noStateTransition: !0
                  }), (Be.isAttemptingToSubscribe() || Be.isSubscribing()) && Be.set("Failed");
                }, lc = (be) => {
                  const ze = Ba(tt.MEDIA_ERR_DECODE, be, be.code || Vt.P2P_CONNECTION_FAILED);
                  ze.message = `OT.Subscriber while playing stream: ${ze.message}`, Wn.error("OT.Subscriber.onVideoError"), sa.fail({
                    options: {
                      failureReason: "VideoElement",
                      failureMessage: ze.message,
                      failureCode: ze.code || Vt.P2P_CONNECTION_FAILED
                    },
                    error: ze
                  });
                  const P = Be.isAttemptingToSubscribe();
                  Be.set("Failed"), P || $o.trigger("error", ze.message), us.handleJsException({
                    error: ze,
                    code: Vt.UNABLE_TO_SUBSCRIBE,
                    // @todo why do we override the code?
                    target: $o,
                    analytics: zo
                  });
                }, Vc = (be) => {
                  const ze = (0, Te.default)(be);
                  us.handleJsException({
                    error: ze,
                    code: ze.code,
                    target: $o,
                    analytics: zo
                  }), this._disconnect({
                    noStateTransition: !0
                  });
                  const P = {
                    failureReason: "Subscribe",
                    failureMessage: `OT.Subscriber PeerConnection Error: ${ze.message}`,
                    failureCode: Vt.P2P_CONNECTION_FAILED
                  };
                  vo(ze.code, ze.message), sa.fail({
                    options: P,
                    error: Ba(ze.name, new Error(`Subscribe: Subscriber PeerConnection with connection (not found) failed: ${ze.message}`), ze.code)
                  }), ze.name === ge.default.STREAM_NOT_FOUND && this._destroy({
                    reason: "streamNotFound",
                    noStateTransition: !0
                  });
                }, _s = (be, ze, P, te) => {
                  if (te === "SetRemoteDescription" && !wa && ze.match(/Unsupported video without audio for fallback/)) {
                    jr && jr.addError("The stream is unable to be played.", "Your browser does not support the video format.");
                    let Ht;
                    Va.env.name === "Safari" ? Ht = new Error("VP8 is not supported in this version of Safari. You might want to consider switching to an H264 project. See https://tokbox.com/safari for more information.") : Ht = new Error("Video format not supported in this browser."), Ht.code = Vt.UNSUPPORTED_VIDEO_CODEC, lc(Ht);
                    return;
                  }
                  if (te === "ICEWorkflow" && an.sessionInfo.reconnection && gr) {
                    Wn.debug("Ignoring peer connection failure due to possibility of reconnection.");
                    return;
                  }
                  let Re;
                  te === "ICEWorkflow" ? Re = Vt.SUBSCRIBER_ICE_WORKFLOW_FAILED : be === Vt.STREAM_LIMIT_EXCEEDED ? Re = be : Re = Vt.P2P_CONNECTION_FAILED;
                  const Qe = {
                    failureReason: te || "PeerConnectionError",
                    failureMessage: `OT.Subscriber PeerConnection Error: ${ze}`,
                    failureCode: Re
                  }, yt = Qr(be, ze, te, "(not found)", "Subscriber");
                  if (sa.fail({
                    options: Qe,
                    error: yt
                  }), Be.isAttemptingToSubscribe()) {
                    const Ht = {
                      hasRelayCandidates: P && P.hasRelayCandidates()
                    };
                    _r("createPeerConnection", "Failure", Ht, Qe), Be.set("Failed");
                  } else Be.isSubscribing() && (Be.set("Failed"), this.trigger("error", ze));
                  this._disconnect({
                    noStateTransition: !0
                  }), Number(be) === 404 && this._destroy({
                    noStateTransition: !0
                  }), us.handleJsException({
                    error: yt,
                    errorMsg: `OT.Subscriber PeerConnection Error: ${ze}`,
                    code: Re,
                    target: this,
                    analytics: zo
                  }), vo(be);
                }, da = (be) => {
                  const ze = be._hasVideoTracks(), P = be._hasAudioTracks(), te = En && En.hasVideo && !ze, Re = En && En.hasAudio && !P;
                  return !(te || Re);
                }, kd = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P, te) {
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          return Qe.prev = 0, Qe.next = 3, cn(() => da(te));
                        case 3:
                          Qe.next = 12;
                          break;
                        case 5:
                          if (Qe.prev = 5, Qe.t0 = Qe.catch(0), Qe.t0.message !== "TIMEOUT") {
                            Qe.next = 11;
                            break;
                          }
                          Wn.error("The expected tracks never arrived"), Qe.next = 12;
                          break;
                        case 11:
                          throw Qe.t0;
                        case 12:
                          return Qe.next = 14, la(P, te);
                        case 14:
                        case "end":
                          return Qe.stop();
                      }
                    }, ze, null, [[0, 5]]);
                  }));
                  return function(P, te) {
                    return be.apply(this, arguments);
                  };
                }(), la = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P, te) {
                    var Re, Qe, yt, Ht, zt, rn, tr, Vn;
                    return o.default.wrap(function(ai) {
                      for (; ; ) switch (ai.prev = ai.next) {
                        case 0:
                          if (Re = Object.keys(oc).length === 1, Qe = te == null ? void 0 : te.getSourceStreamId(), yt = an, Ht = yt.sessionInfo, ut = P, Qe && (oc[Qe] = P), Wn.debug("OT.Subscriber.onRemoteStreamAdded with sourceStreamId", Qe), Be.set("BindingRemoteStream"), !Zl) {
                            ai.next = 14;
                            break;
                          }
                          if (!ct) {
                            ai.next = 13;
                            break;
                          }
                          return ai.next = 11, cc(Qe);
                        case 11:
                          ai.next = 14;
                          break;
                        case 13:
                          Zl.destroy();
                        case 14:
                          return La.subscribeToAudio(vt), Xt === "auto" && !Ci.subscribeToVideo || (Xt = "loading", La.subscribeToVideo(Ci.subscribeToVideo, "loading")), !Ht.p2pEnabled && Qe !== "P2P" && (Ec || La.setPreferredResolution(Ci.preferredResolution), La.setPreferredFrameRate(Ci.preferredFrameRate)), te && te._getVideoTracks().forEach((Ui) => {
                            (typeof window !== void 0 ? window : Dn).webkitMediaStream ? Ui.enabled = !1 : Ui.enabled = En.hasVideo && Ci.subscribeToVideo;
                          }), ai.prev = 18, ai.next = 21, ql(ut);
                        case 21:
                          ai.next = 32;
                          break;
                        case 23:
                          if (ai.prev = 23, ai.t0 = ai.catch(18), !(0, Tn.isAmrVideoBufferError)(ai.t0)) {
                            ai.next = 31;
                            break;
                          }
                          return Wn.error(`OT.Subscriber: ${ai.t0.message}`), Mc(), Yl.completeTransitionTo(Di), Di === "P2P" && $l.subscriberDestroy(En.id, La.widgetId, Di), ai.abrupt("return");
                        case 31:
                          throw ai.t0;
                        case 32:
                          if (ou(), !Be.isDestroyed()) {
                            ai.next = 36;
                            break;
                          }
                          return Wn.error("Subscriber destroyed"), ai.abrupt("return");
                        case 36:
                          return te && (typeof window !== void 0 ? window : Dn).webkitMediaStream && te._getVideoTracks().forEach((Ui) => {
                            Ui.enabled = En.hasVideo && Ci.subscribeToVideo;
                          }), zt = jr && jr.video(), zt && zt.orientation({
                            width: En.videoDimensions.width,
                            height: En.videoDimensions.height,
                            videoOrientation: En.videoDimensions.orientation
                          }), rn = xe && xe.videoUnsupportedIndicator, rn && rn.setVideoUnsupported(!wa), tr = new n((Ui, Sa) => {
                            const xa = jr && jr.video();
                            if (xa && xa.domElement()) {
                              Ui();
                              return;
                            }
                            jr.once("videoElementCreated", Ui), $o.once("destroyed", Sa);
                          }), ai.next = 44, tr;
                        case 44:
                          return ai.next = 46, bc.promise;
                        case 46:
                          if (Re ? Be.set("Subscribing") : Mc(), He && "webRTCStream" in He && te._hasAudioTracks() && He.webRTCStream(P), Vn = Va.env, (Vn.isSafari || Vn.isChromiumEdge || Vn.isOpera || Vn.name === "Chrome" && Vn.version >= 58 || Vn.isFirefox && Vn.version >= 96) && (aa && (aa.destroy(), aa = null), te && (aa = ws(te.getStats.bind(te)))), !Gd) {
                            ai.next = 62;
                            break;
                          }
                          if (Yl.completeTransitionTo(Di), !(vt && ka.audioMediaProcessorConnector)) {
                            ai.next = 62;
                            break;
                          }
                          return ai.prev = 53, ai.next = 56, ka.applyAudioConnectorOnRoutedToRelayedTransition();
                        case 56:
                          _r("setAudioMediaProcessorConnector", "Success", {
                            message: "Audio connector applied on routed to relayed transition."
                          }), ai.next = 62;
                          break;
                        case 59:
                          ai.prev = 59, ai.t1 = ai.catch(53), _r("setAudioMediaProcessorConnector", "Failure", {
                            message: ai.t1.message
                          });
                        case 62:
                        case "end":
                          return ai.stop();
                      }
                    }, ze, null, [[18, 23], [53, 59]]);
                  }));
                  return function(P, te) {
                    return be.apply(this, arguments);
                  };
                }(), cc = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te, Re;
                    return o.default.wrap(function(yt) {
                      for (; ; ) switch (yt.prev = yt.next) {
                        case 0:
                          return P === "P2P" && Ml && (te = oc.MANTIS.getVideoTracks(), Re = te[0], (0, er.default)(oc.MANTIS, Re, Ml)), yt.next = 3, Ke();
                        case 3:
                        case "end":
                          return yt.stop();
                      }
                    }, ze);
                  }));
                  return function(P) {
                    return be.apply(this, arguments);
                  };
                }(), Da = (be) => {
                  wa !== be && this.dispatchEvent(new Jt.VideoEnabledChangedEvent(be ? "videoEnabled" : "videoDisabled", {
                    reason: be ? "codecChanged" : "codecNotSupported"
                  })), wa = be;
                }, ea = (be) => {
                  jr.setAudioBlockedUi(be);
                  const ze = xe && xe.audioBlockedIndicator;
                  ze && ze.setAudioBlocked(be);
                  const P = xe && xe.videoUnsupportedIndicator;
                  P && P.setVideoUnsupported(!be && !wa);
                };
                this.on("audioBlocked", () => {
                  ea(!0);
                }), this.on("audioUnblocked", () => {
                  ea(!1);
                });
                const ec = {
                  new: O.default.SUBSCRIBER_DISCONNECTED,
                  checking: O.default.SUBSCRIBER_DISCONNECTED,
                  connected: O.default.SUBSCRIBER_CONNECTED,
                  completed: O.default.SUBSCRIBER_CONNECTED,
                  disconnected: O.default.SUBSCRIBER_DISCONNECTED
                }, Yc = (be, ze) => {
                  const P = ec[be], te = ze.getSourceStreamId(), Re = _l[te];
                  P && P !== Re && (_l[te] = P, be === "disconnected" && te !== "P2P" && setTimeout(/* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function yt() {
                    var Ht;
                    return o.default.wrap(function(rn) {
                      for (; ; ) switch (rn.prev = rn.next) {
                        case 0:
                          if (Ht = an._.isSocketReconnecting, !(_l[te] === "disconnected" && $l.is("connected") && !Ht())) {
                            rn.next = 4;
                            break;
                          }
                          return rn.next = 4, La._.iceRestart("peer connection disconnected");
                        case 4:
                        case "end":
                          return rn.stop();
                      }
                    }, yt);
                  })), 2e3), jr && jr.loading(P !== O.default.SUBSCRIBER_CONNECTED), Wn.debug(`OT.Subscriber.connectionStateChanged to ${be}`), this.dispatchEvent(new Jt.ConnectionStateChangedEvent(P, this, (0, tn.default)(te))));
                }, rd = () => {
                  Sl("Success");
                }, Lc = () => {
                  Sl("Failure", {
                    reason: "ICEWorkflow",
                    message: "OT.Subscriber PeerConnection Error: The stream was unable to connect due to a network error. Make sure your connection isn't blocked by a firewall."
                  });
                }, fu = (be) => {
                  const ze = jr && jr.video();
                  switch (be.changedProperty) {
                    case "videoDimensions":
                      if (!ze)
                        break;
                      ze.orientation({
                        width: be.newValue.width,
                        height: be.newValue.height,
                        videoOrientation: be.newValue.orientation
                      }), this.dispatchEvent(new Jt.VideoDimensionsChangedEvent(this, be.oldValue, be.newValue));
                      break;
                    case "videoDisableWarning":
                      xe && xe.videoDisabledIndicator.setWarning(be.newValue), this.dispatchEvent(new Jt.VideoDisableWarningEvent(be.newValue ? "videoDisableWarning" : "videoDisableWarningLifted")), Jo = be.newValue ? 1 : null;
                      break;
                    case "hasVideo":
                      co(!En.hasVideo || !Ci.subscribeToVideo), Rt.isSafari && !En.hasVideo && jr && jr.bindAudioTrackOnly(), this.dispatchEvent(new Jt.VideoEnabledChangedEvent(En.hasVideo ? "videoEnabled" : "videoDisabled", {
                        reason: "publishVideo"
                      }));
                      break;
                    case "hasAudio":
                      ot.update();
                      break;
                  }
                }, El = () => En.getChannelsOfType("audio").length > 0;
                ot = {
                  get() {
                    return El() ? $o.getStyle("buttonDisplayMode") : "off";
                  },
                  update() {
                    const be = ot.get();
                    xe && (xe.muteButton.setDisplayMode(be), xe.backingBar.setMuteMode(be));
                  }
                };
                const xc = (be, ze) => {
                  if (xe)
                    switch (be) {
                      case "nameDisplayMode":
                        xe.name.setDisplayMode(ze), xe.backingBar.setNameMode(ze);
                        break;
                      case "videoUnsupportedDisplayMode":
                        xe.videoUnsupportedIndicator.setDisplayMode(ze);
                        break;
                      case "videoDisabledDisplayMode":
                        xe.videoDisabledIndicator.setDisplayMode(ze);
                        break;
                      case "audioBlockedDisplayMode":
                        xe.audioBlockedIndicator.setDisplayMode(ze);
                        break;
                      case "showArchiveStatus":
                        xe.archive.setShowArchiveStatus(ze);
                        break;
                      case "buttonDisplayMode":
                        ot.update();
                        break;
                      case "audioLevelDisplayMode":
                        xe.audioLevel.setDisplayMode(ze);
                        break;
                      case "bugDisplayMode":
                        break;
                      case "backgroundImageURI":
                        jr.setBackgroundImageURI(ze);
                        break;
                    }
                }, _d = () => {
                  const be = {
                    backingBar: new mr({
                      nameMode: Ci.name ? this.getStyle("nameDisplayMode") : "off",
                      muteMode: ot.get()
                    }),
                    name: new Ga({
                      name: Ci.name,
                      mode: this.getStyle("nameDisplayMode")
                    }),
                    muteButton: new Ho({
                      muted: ca === 0,
                      mode: ot.get()
                    })
                  };
                  if (ms) {
                    const ze = new Yn();
                    ye = new Ia({
                      mode: $o.getStyle("audioLevelDisplayMode")
                    });
                    const P = new _e.default(() => {
                      ye.setValue(ze.transform(this.loudness));
                    });
                    ye.watchVisibilityChanged((te) => {
                      te ? P.start() : P.stop();
                    }), ye.setDisplayMode(this.getStyle("audioLevelDisplayMode")), ye.audioOnly(!1), be.audioLevel = ye;
                  }
                  be.videoDisabledIndicator = new Fl({
                    mode: this.getStyle("videoDisabledDisplayMode")
                  }), be.audioBlockedIndicator = new gl({
                    mode: this.getStyle("audioBlockedDisplayMode")
                  }), be.videoUnsupportedIndicator = new zr({
                    mode: this.getStyle("videoUnsupportedDisplayMode")
                  }), jr && jr.domElement && (xe = new Or({
                    parent: jr.domElement
                  }).set(be).on({
                    muted() {
                      $o.setAudioVolume(0);
                    },
                    unmuted() {
                      $o.setAudioVolume(Co);
                    }
                  }, this), xe.hideWhileLoading());
                }, vo = (be, ze) => {
                  let P, te;
                  jr && (be === Vt.STREAM_LIMIT_EXCEEDED ? (P = "The stream was unable to connect.", te = "The limit for the number of media streams has been reached.") : ze === "Tried to subscribe to an encrypted stream without enabling encryption" ? (P = "Unable to subscribe to an encrypted stream without enabling encryption.", te = "") : (P = "The stream was unable to connect due to a network error.", Pi ? te = "Ensure you have a stable connection and try again." : te = "Make sure you have a stable network connection and that it isn't blocked by a firewall."), jr.addError(P, te));
                };
                hs(this, {
                  nameDisplayMode: "auto",
                  buttonDisplayMode: "auto",
                  audioLevelDisplayMode: "auto",
                  videoDisabledDisplayMode: "auto",
                  audioBlockedDisplayMode: "auto",
                  backgroundImageURI: null,
                  showArchiveStatus: !0,
                  showMicButton: !0
                }, Ci.showControls, (be) => {
                  _r("SetStyle", "Subscriber", be, null, 0.1);
                });
                function co(be) {
                  js().forEach(/* @__PURE__ */ function() {
                    var P = (0, l.default)(/* @__PURE__ */ o.default.mark(function te(Re) {
                      return o.default.wrap(function(yt) {
                        for (; ; ) switch (yt.prev = yt.next) {
                          case 0:
                            return yt.next = 2, Re;
                          case 2:
                            yt.sent.subscribeToVideo(!be);
                          case 3:
                          case "end":
                            return yt.stop();
                        }
                      }, te);
                    }));
                    return function(te) {
                      return P.apply(this, arguments);
                    };
                  }());
                  const ze = be || !ut || !ut.getVideoTracks().length;
                  jr && (jr.audioOnly(ze), jr.showPoster(ze)), ye && ye.audioOnly(ze);
                }
                const id = (0, v.default)(() => {
                  _r("GetStats", "Called");
                }), wd = (0, v.default)(() => {
                  _r("GetRtcStatsReport", "Called");
                }), Dd = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    return o.default.wrap(function(Re) {
                      for (; ; ) switch (Re.prev = Re.next) {
                        case 0:
                          return Xe && (Xe.destroy(), Xe = void 0), Re.prev = 1, Re.next = 4, cn(() => P._hasAudioTracks());
                        case 4:
                          Re.next = 9;
                          break;
                        case 6:
                          return Re.prev = 6, Re.t0 = Re.catch(1), Re.abrupt("return");
                        case 9:
                          He = Qn(P), He ? Xe = (0, $e.default)({
                            subscriber: La,
                            audioLevelSampler: He
                          }) : Object.prototype.hasOwnProperty.call(La, "loudness") || (Object.defineProperty(La, "loudness", {
                            value: void 0,
                            configurable: !0,
                            writable: !1
                          }), Wn.error("No suitable audio level samplers found, audio level visualisation will not work"));
                        case 11:
                        case "end":
                          return Re.stop();
                      }
                    }, ze, null, [[1, 6]]);
                  }));
                  return function(P) {
                    return be.apply(this, arguments);
                  };
                }(), su = (be, ze) => {
                  if (zd[ze]) {
                    zd[ze].removeAll();
                    const te = () => {
                      be.off("error", te), be.off("disconnected", te);
                    };
                    be.on("error", te), be.on("disconnected", te);
                  }
                  const P = (0, Q.default)(be);
                  P.once("connected", () => nd(be)), P.on("disconnected", au), P.on("error", _s), P.once("remoteTrackAdded", /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function te() {
                    var Re = arguments;
                    return o.default.wrap(function(yt) {
                      for (; ; ) switch (yt.prev = yt.next) {
                        case 0:
                          return yt.next = 2, Dd(be);
                        case 2:
                          return yt.prev = 2, yt.next = 5, kd(...Re);
                        case 5:
                          yt.next = 10;
                          break;
                        case 7:
                          yt.prev = 7, yt.t0 = yt.catch(2), Wn.error(yt.t0);
                        case 10:
                        case "end":
                          return yt.stop();
                      }
                    }, te, null, [[2, 7]]);
                  }))), P.on("audioLevelStuckWarning", fl), P.on("signalingStateStable", /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function te() {
                    var Re;
                    return o.default.wrap(function(yt) {
                      for (; ; ) switch (yt.prev = yt.next) {
                        case 0:
                          $o.trigger("signalingStateStable"), Re = jr && jr.video(), Re && ut && He && "webRTCStream" in He && be._hasAudioTracks() && He.webRTCStream(ut);
                        case 3:
                        case "end":
                          return yt.stop();
                      }
                    }, te);
                  }))), P.on("iceConnectionStateChange", (te) => Yc(te, be)), P.on("iceRestartSuccess", rd), P.on("iceRestartFailure", Lc), P.on("remoteVideoSupported", Da), P.on("decryptFailed", () => {
                    this.trigger("encryptionSecretMismatch"), _r("encryptionSecretMismatch", "Event"), Wn.warn("Media cannot be decrypted due to an encryption secret mismatch.");
                  }), P.on("decryptRestored", () => {
                    this.trigger("encryptionSecretMatch"), _r("encryptionSecretMatch", "Event");
                  }), zd[ze] = zd;
                }, Md = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze() {
                    var P;
                    return o.default.wrap(function(Re) {
                      for (; ; ) switch (Re.prev = Re.next) {
                        case 0:
                          return to("Attempt"), Re.next = 3, ac("MANTIS");
                        case 3:
                          if (P = Re.sent, P != null && P.iceConnectionStateIsConnected()) {
                            Re.next = 7;
                            break;
                          }
                          return to("Failure", {
                            reason: "Attempted to transition to Relayed without being connected in Routed mode."
                          }), Re.abrupt("return");
                        case 7:
                          $l.subscriberCreate(
                            En.id,
                            Rl,
                            // subscriberId
                            no,
                            "P2P",
                            an._.isE2ee(),
                            (Qe, yt) => {
                              Qe && !sa.is("disconnected") && to("Failure", Qe), Wn.debug("message received when created a subscriber with source", yt);
                            }
                          );
                        case 8:
                        case "end":
                          return Re.stop();
                      }
                    }, ze);
                  }));
                  return function() {
                    return be.apply(this, arguments);
                  };
                }(), od = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze() {
                    var P;
                    return o.default.wrap(function(Re) {
                      for (; ; ) switch (Re.prev = Re.next) {
                        case 0:
                          if (!(Ci.testNetwork || sn(En, an) || Di !== "P2P")) {
                            Re.next = 2;
                            break;
                          }
                          return Re.abrupt("return");
                        case 2:
                          if (Za("Attempt"), ut = oc.MANTIS, !(ct && Zl)) {
                            Re.next = 7;
                            break;
                          }
                          return Re.next = 7, Ke();
                        case 7:
                          if (!(ka.audioMediaProcessorConnector && vt)) {
                            Re.next = 17;
                            break;
                          }
                          return Re.prev = 8, Re.next = 11, ka.applyAudioConnectorOnRelayedToRoutedTransition();
                        case 11:
                          _r("setAudioMediaProcessorConnector", "Success", {
                            message: "Audio connector applied on relayed to routed transition."
                          }), Re.next = 17;
                          break;
                        case 14:
                          Re.prev = 14, Re.t0 = Re.catch(8), _r("setAudioMediaProcessorConnector", "Failure", {
                            message: Re.t0.message
                          });
                        case 17:
                          return Re.next = 19, ql(ut);
                        case 19:
                          return Re.next = 21, Ll("P2P");
                        case 21:
                          return jr.loading(!1), Di = "MANTIS", ed("P2P"), Re.next = 26, Dc();
                        case 26:
                          return P = Re.sent, Re.next = 29, Dd(P);
                        case 29:
                          Za("Success");
                        case 30:
                        case "end":
                          return Re.stop();
                      }
                    }, ze, null, [[8, 14]]);
                  }));
                  return function() {
                    return be.apply(this, arguments);
                  };
                }();
                this._destroy = (be) => {
                  let ze = be.reason, P = ze === void 0 ? "Unknown" : ze, te = be.quiet, Re = be.noStateTransition, Qe = Re === void 0 ? !1 : Re;
                  return Be.isDestroyed() ? this : (Be.set("Destroyed"), aa && (aa.destroy(), aa = null), Dl = {
                    sessionId: an.sessionId,
                    connectionId: an && an.isConnected() ? an.connection.connectionId : null,
                    partnerId: an && an.sessionInfo ? an.sessionInfo.partnerId : null,
                    streamId: En && !En.destroyed ? En.id : null
                  }, this._disconnect({
                    reason: P,
                    noStateTransition: Qe
                  }), xe && (xe.destroy(), xe = null), jr && (jr.destroy(), jr.off(), jr = null, this.element = null), En && !En.destroyed && _r("unsubscribe", null, {
                    streamId: En.id
                  }), En.off(un, this), this.id = null, sr = null, this.stream = null, En = null, this.streamId = null, this.session = null, an = null, Ci = null, te !== !0 && (this.dispatchEvent(new Jt.DestroyedEvent(O.default.SUBSCRIBER_DESTROYED, this, P)), this.off()), this);
                }, this.destroy = function(be, ze) {
                  be === void 0 && (be = "Unsubscribe"), Wn.warn("Subscriber#destroy is deprecated and will be removed. Please use Session#unsubscribe instead"), La._destroy({
                    reason: be,
                    quiet: ze
                  });
                }, this._disconnect = function(be) {
                  let ze = be === void 0 ? {} : be, P = ze.reason, te = P === void 0 ? "Unknown" : P;
                  if (!ze.noStateTransition && !sa.is("disconnected")) {
                    const Qe = te === "Unsubscribe" ? void 0 : Ba(tt.STREAM_DESTROYED, new Error("Stream was destroyed before it could be subscribed to"));
                    sa.disconnect({
                      payload: {
                        reason: te
                      },
                      error: Qe
                    });
                  }
                  !Be.isDestroyed() && !Be.isFailed() && Be.set("NotSubscribing"), jr && jr.destroyVideo(), $l.is("connected") && En && !En.destroyed && $l.subscriberDestroy(En.id, La.widgetId), sc();
                }, this.disconnect = () => {
                  Wn.warn("Subscriber#disconnect is deprecated and will be removed. Please use Session#unsubscribe instead"), this._disconnect({
                    reason: "Unsubscribe"
                  });
                };
                const Je = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te, Re, Qe, yt, Ht, zt, rn;
                    return o.default.wrap(function(Vn) {
                      for (; ; ) switch (Vn.prev = Vn.next) {
                        case 0:
                          return te = P.peerId, Re = P.fromConnectionId, Qe = P.sourceStreamId, yt = Ct({
                            apiKey: an.apiKey,
                            sessionId: an.sessionId,
                            streamId: En.id,
                            subscriberId: La.widgetId
                          }), Ht = kl({
                            socket: La.session._.getSocket(),
                            uri: yt,
                            content: {
                              peerId: te,
                              sourceStreamId: Qe
                            }
                          }), zt = function(ai, Ui, Sa, xa, ll) {
                            xa === void 0 && (xa = {});
                            const Hc = Object.assign({
                              peerId: te,
                              sourceStreamId: (0, tn.default)(Qe)
                            }, xa);
                            return _r(ai, Ui, Sa, Hc, ll);
                          }, rn = (si) => {
                            Di === Qe && Uo(Object.assign({}, si, {
                              peerId: te,
                              remoteConnectionId: Re,
                              sourceStreamId: Qe
                            }));
                          }, Vn.abrupt("return", La._setupPeerConnection({
                            send: Ht,
                            log: zt,
                            logQoS: rn,
                            sourceStreamId: Qe
                          }));
                        case 6:
                        case "end":
                          return Vn.stop();
                      }
                    }, ze);
                  }));
                  return function(P) {
                    return be.apply(this, arguments);
                  };
                }();
                this.processMessage = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P, te, Re) {
                    var Qe, yt, Ht;
                    return o.default.wrap(function(rn) {
                      for (; ; ) switch (rn.prev = rn.next) {
                        case 0:
                          return Wn.debug(`OT.Subscriber.processMessage: Received ${P} message from ${te}`), Wn.debug(Re), Qe = (0, f.default)(Re, "content.peerId"), yt = (0, f.default)(Re, "content.sourceStreamId"), rn.next = 6, ac(yt);
                        case 6:
                          if (Ht = rn.sent, !Ht) {
                            rn.next = 11;
                            break;
                          }
                          Ht.processMessage(P, Re), rn.next = 16;
                          break;
                        case 11:
                          if (P !== "offer") {
                            rn.next = 16;
                            break;
                          }
                          return rn.next = 14, Je({
                            peerId: Qe,
                            fromConnectionId: te,
                            sourceStreamId: yt
                          });
                        case 14:
                          Ht = rn.sent, Ro ? Ht.processMessage("offer", Re) : La.session._.addSubscriberToPeerConnectionsQueue(Ht, Re);
                        case 16:
                        case "end":
                          return rn.stop();
                      }
                    }, ze);
                  }));
                  return function(ze, P, te) {
                    return be.apply(this, arguments);
                  };
                }(), this.disableVideo = (be) => {
                  if (!be)
                    Wn.warn("Due to high packet loss and low bandwidth, video has been disabled");
                  else if (Xt === "auto" && Ti === !1)
                    Wn.info("Video has been re-enabled");
                  else {
                    Wn.info("Video was not re-enabled because it was manually disabled"), xe && xe.videoDisabledIndicator && xe.videoDisabledIndicator.disableVideo(!1);
                    return;
                  }
                  this.subscribeToVideo(be, "auto"), _r("updateQuality", "video", be ? {
                    videoEnabled: !0
                  } : {
                    videoDisabled: !0
                  });
                }, this.getImgData = () => {
                  if (!this.isSubscribing())
                    return Wn.error("OT.Subscriber.getImgData: Cannot getImgData before the Subscriber is subscribing."), null;
                  const be = jr && jr.video();
                  return be ? be.imgData() : null;
                }, this.getStats = (be) => {
                  jd((ze, P) => {
                    if (ze) {
                      be(ze);
                      return;
                    }
                    const te = {
                      timestamp: 0
                    };
                    if (P.forEach((Re) => {
                      if (jt.isInboundStat(Re)) {
                        const Qe = jt.isVideoStat(Re, P), yt = jt.isAudioStat(Re, P);
                        (yt || Qe) && (te.timestamp = jt.normalizeTimestamp(Re.timestamp)), Qe ? ((0, p.default)(te, {
                          video: jt.parseStatCategory(Re)
                        }), aa && (0, p.default)(te, {
                          video: {
                            frameRate: aa.getFrameRateFromStat(Re)
                          }
                        })) : yt && (0, p.default)(te, {
                          audio: jt.parseStatCategory(Re)
                        });
                      }
                    }), kc) {
                      const Re = kc, Qe = Re.maxBitrateBitsPerSecond, yt = Re.sentEstimatedBandwidthBitsPerSecond;
                      te.senderStats = {
                        senderMaxBitrate: Qe,
                        senderCurrentBitrate: yt
                      };
                    }
                    be(null, te);
                  });
                }, this.getRtcStatsReport = () => new n((be, ze) => {
                  Sc((P, te) => {
                    P ? ze(P) : be(te);
                  });
                });
                function Ne(be) {
                  const ze = jr && jr.video();
                  if (ze)
                    try {
                      ze.setAudioVolume(be);
                    } catch (P) {
                      Wn.warn(`setAudioVolume: ${P}`), ca === 0 && (Wn.info("Using subscribeToAudio to mute Audio because setAudioVolume(0) failed"), $o.subscribeToAudio(!1));
                    }
                  xe && xe.muteButton.muted(be === 0);
                }
                this.setAudioVolume = (be) => {
                  const ze = Hn(be);
                  return _r("setAudioVolume", "Attempt", {
                    audioVolume: ze
                  }), isNaN(ze) ? (Wn.error("OT.Subscriber.setAudioVolume: value should be an integer between 0 and 100"), _r("setAudioVolume", "Failure", {
                    message: "value should be an integer between 0 and 100"
                  }), this) : (ze !== be && Wn.warn("OT.Subscriber.setAudioVolume: value should be an integer between 0 and 100"), ze === ca ? (Ne(ca), _r("setAudioVolume", "Success", {
                    audioVolume: ca,
                    message: "Requested volume is same as already set audioVolume"
                  }), this) : (ca > 0 && (Co = ca), ca = ze, Ne(ca), ca > 0 && !vt && (Co = ca, this.subscribeToAudio(!0)), _r("setAudioVolume", "Success", {
                    audioVolume: ca
                  }), this));
                }, this.getAudioVolume = () => {
                  const be = jr && jr.video();
                  if (be)
                    try {
                      return be.getAudioVolume();
                    } catch (ze) {
                      Wn.warn(`getAudioVolume ${ze}`);
                    }
                  return ca;
                }, this.subscribeToAudio = (be) => {
                  const ze = (0, w.default)(be, !0);
                  js().forEach(/* @__PURE__ */ function() {
                    var te = (0, l.default)(/* @__PURE__ */ o.default.mark(function Re(Qe) {
                      return o.default.wrap(function(Ht) {
                        for (; ; ) switch (Ht.prev = Ht.next) {
                          case 0:
                            return Ht.next = 2, Qe;
                          case 2:
                            Ht.sent.subscribeToAudio(ze);
                          case 3:
                          case "end":
                            return Ht.stop();
                        }
                      }, Re);
                    }));
                    return function(Re) {
                      return te.apply(this, arguments);
                    };
                  }()), En && js().length !== 0 && Ql({
                    channelType: "audio",
                    activeState: ze
                  });
                  const P = vt !== ze;
                  if (vt = ze, P && this.setAudioVolume(ze ? Co : 0), ka.audioMediaProcessorConnector)
                    if (vt)
                      $t();
                    else
                      try {
                        ka.resetAudioStreamAndTrack(Di), _r("setAudioMediaProcessorConnector", "Success", {
                          message: "reset the audio track"
                        });
                      } catch (te) {
                        _r("setAudioMediaProcessorConnector", "Failure", {
                          message: `Error resetting track: ${te.message}`
                        });
                      }
                  return _r("subscribeToAudio", "Event", {
                    subscribeToAudio: ze
                  }), this;
                };
                const qr = {
                  auto: "quality",
                  publishVideo: "publishVideo",
                  subscribeToVideo: "subscribeToVideo"
                };
                if (Rt.name === "Safari") {
                  const be = () => {
                    !Xn.hidden && Ci.subscribeToVideo && (Wn.debug("document visibility restored in Safari - resubscribing to video"), this.subscribeToVideo(!1), this.subscribeToVideo(!0));
                  };
                  Xn.addEventListener("visibilitychange", be), this.once("destroyed", () => {
                    Xn.removeEventListener("visibilitychange", be);
                  });
                }
                this.subscribeToVideo = (be, ze) => {
                  const P = (0, w.default)(be, !0), te = !P && ze === "auto";
                  return ze || (Ti = !P), te && (Jo = 2), _r("subscribeToVideo", "Attempt", {
                    subscribeToVideo: P,
                    reason: ze
                  }), co(!P || !En.hasVideo || !ut), En.hasVideo && !Cl("video") ? (P && Wn.info("Subscriber is audio-only due to incompatibility, can't subscribeToVideo."), Ci.subscribeToVideo = !1, _r("subscribeToVideo", "Failure", {
                    message: "No video tracks available"
                  }), this) : (xe && xe.videoDisabledIndicator && xe.videoDisabledIndicator.disableVideo(te), js().length > 0 && an && En && (P !== Ci.subscribeToVideo || ze !== Xt) && !(Ti && ze) && Ql({
                    channelType: "video",
                    activeState: P,
                    activeReason: ze
                  }), Ci.subscribeToVideo = P, Xt = ze, ct = P, Zl && (ct ? Ke() : et()), _r("subscribeToVideo", "Success", {
                    subscribeToVideo: P,
                    reason: ze
                  }), ze !== "loading" && this.dispatchEvent(new Jt.VideoEnabledChangedEvent(P ? "videoEnabled" : "videoDisabled", {
                    reason: qr[ze] || "subscribeToVideo"
                  })), this);
                }, this.setPreferredResolution = (be) => {
                  if (dc("Attempt", {
                    preferredResolution: be
                  }), Ec) {
                    const ze = "Cannot call this method directly if in auto mode.";
                    dc("Failure", {
                      preferredResolution: be,
                      message: ze
                    }), Wn.warn(ze);
                    return;
                  }
                  if (be === "auto") {
                    const ze = "preferredResolution 'auto' cannot be set using setPreferredResolution(), it must be set in subscriberOptions property preferredResolution.";
                    dc("Failure", {
                      preferredResolution: be,
                      message: ze
                    }), Wn.warn(ze);
                    return;
                  }
                  sl(be);
                };
                const dc = (be, ze) => {
                  Ec || _r("setPreferredResolution", be, ze);
                }, sl = (be) => {
                  if (Be.isDestroyed() || js().length === 0 && !Be.current === "Connecting") {
                    const te = "Cannot set the max Resolution when not subscribing to a publisher";
                    dc("Failure", {
                      preferredResolution: be,
                      message: te
                    }), Wn.warn(te);
                    return;
                  }
                  if (Ci.preferredResolution = be, an.sessionInfo.p2pEnabled) {
                    const te = "OT.Subscriber.setPreferredResolution will not work in a P2P Session";
                    dc("Failure", {
                      preferredResolution: be,
                      message: te
                    }), Wn.warn(te);
                    return;
                  }
                  if (!Be.isStreamAdded()) {
                    dc("Pending");
                    return;
                  }
                  const ze = En.getPreferredResolution();
                  if (ze && be && ze.width === be.width && ze.height === be.height || !ze && !be) {
                    dc("Cancel");
                    return;
                  }
                  En.setPreferredResolution(be), dc("Success");
                }, Ta = (0, m.default)((be) => {
                  if (!be)
                    return;
                  const ze = be.offsetWidth, P = be.offsetHeight, te = window.devicePixelRatio, Re = {
                    width: ze * te,
                    height: P * te
                  };
                  sl(Re);
                }, zi);
                if (this.setPreferredFrameRate = (be) => {
                  if (Be.isDestroyed() || js().length === 0 && !Be.current === "Connecting") {
                    Wn.warn("Cannot set the max frameRate when not subscribing to a publisher");
                    return;
                  }
                  if (Ci.preferredFrameRate = be, an.sessionInfo.p2pEnabled) {
                    Wn.warn("OT.Subscriber.setPreferredFrameRate will not work in a P2P Session");
                    return;
                  }
                  const ze = En.getPreferredFrameRate();
                  be && ze && ze === be || !ze && !be || En.setPreferredFrameRate(be);
                }, this.isSubscribing = () => Be.isSubscribing(), this.isWebRTC = !0, this.isLoading = () => jr && jr.loading(), this.isAudioBlocked = () => !!(jr && jr.isAudioBlocked()), this.videoElement = () => {
                  const be = jr && jr.video();
                  return be ? be.domElement() : null;
                }, this.videoWidth = () => {
                  const be = jr && jr.video();
                  return be ? be.videoWidth() : void 0;
                }, this.videoHeight = () => {
                  const be = jr && jr.video();
                  return be ? be.videoHeight() : void 0;
                }, this._subscribeToSelf = /* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function be() {
                  var ze;
                  return o.default.wrap(function(te) {
                    for (; ; ) switch (te.prev = te.next) {
                      case 0:
                        if (ze = an.getPublisherForStream(En), ze && ze._.webRtcStream()) {
                          te.next = 5;
                          break;
                        }
                        sa.fail({
                          payload: {
                            reason: "streamNotFound"
                          },
                          error: Ba(tt.STREAM_DESTROYED, new Error("Tried to subscribe to a local publisher, but its stream no longer exists"))
                        }), te.next = 14;
                        break;
                      case 5:
                        return bc.resolve(), te.prev = 6, te.next = 9, la(ze._.webRtcStream());
                      case 9:
                        te.next = 14;
                        break;
                      case 11:
                        te.prev = 11, te.t0 = te.catch(6), Wn.error(te.t0);
                      case 14:
                      case "end":
                        return te.stop();
                    }
                  }, be, null, [[6, 11]]);
                })), this._setupPeerConnection = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te, Re, Qe, yt;
                    return o.default.wrap(function(zt) {
                      for (; ; ) switch (zt.prev = zt.next) {
                        case 0:
                          return te = P.send, Re = P.log, Qe = P.logQoS, yt = P.sourceStreamId, Ci.testNetwork && La.setAudioVolume(0), js().length === 0 && Be.set("Connecting"), Di = yt, Zc[yt] = new n((rn, tr) => {
                            an._.getIceConfig().then((Vn) => {
                              var si;
                              Vn.needRumorIceServersFallback && (Vn.servers = [...yl || [], ...Vn.servers || []]);
                              const ai = {
                                iceConfig: Vn,
                                subscriberId: La.widgetId,
                                send: te,
                                logAnalyticsEvent: Re,
                                p2p: an.sessionInfo.p2pEnabled,
                                sourceStreamId: yt,
                                remoteConnectionId: En.connection.id,
                                // We force to use the SPC only for Mantis leg.
                                _singlePeerConnectionController: yt === "MANTIS" && Fr,
                                keyStore: an.keyStore,
                                sFrameClientStore: an.sFrameClientStore,
                                isE2ee: an._.isE2ee(),
                                sessionId: (si = an) == null ? void 0 : si.sessionId
                              };
                              Object.prototype.hasOwnProperty.call(Ci, "codecFlags") && (ai.codecFlags = Ci.codecFlags);
                              const Ui = new Ko.SubscriberPeerConnection(ai);
                              Ui.once("iceConnected", bc.resolve), Ui.once("error", bc.reject), Ui.on("qos", Qe), su(Ui, yt), Ui.init((Sa) => {
                                Sa ? tr(Sa) : rn(Ui);
                              });
                            });
                          }), zt.abrupt("return", Zc[yt]);
                        case 6:
                        case "end":
                          return zt.stop();
                      }
                    }, ze);
                  }));
                  return function(ze) {
                    return be.apply(this, arguments);
                  };
                }(), this.restrictFrameRate = (be) => (Wn.debug(`OT.Subscriber.restrictFrameRate(${be})`), _r("restrictFrameRate", be.toString(), {
                  streamId: En.id
                }), an.sessionInfo.p2pEnabled && Wn.warn("OT.Subscriber.restrictFrameRate: Cannot restrictFrameRate on a P2P session"), typeof be != "boolean" ? Wn.error(`OT.Subscriber.restrictFrameRate: expected a boolean value got a ${typeof be}`) : (ga = be, En.setRestrictFrameRate(be)), this), this.on("styleValueChanged", xc, this), this._ = {
                  getDataChannel(be, ze, P) {
                    return (0, l.default)(/* @__PURE__ */ o.default.mark(function te() {
                      return o.default.wrap(function(Qe) {
                        for (; ; ) switch (Qe.prev = Qe.next) {
                          case 0:
                            if (Dc()) {
                              Qe.next = 3;
                              break;
                            }
                            return P(new Va.Error("Cannot create a DataChannel before there is a publisher connection.")), Qe.abrupt("return");
                          case 3:
                            return Qe.next = 5, Dc();
                          case 5:
                            Qe.sent.getDataChannel(be, ze, P);
                          case 6:
                          case "end":
                            return Qe.stop();
                        }
                      }, te);
                    }))();
                  },
                  iceRestart(be, ze) {
                    return (0, l.default)(/* @__PURE__ */ o.default.mark(function P() {
                      var te;
                      return o.default.wrap(function(Qe) {
                        for (; ; ) switch (Qe.prev = Qe.next) {
                          case 0:
                            return ze === void 0 && (ze = !1), Qe.next = 3, ac("MANTIS");
                          case 3:
                            te = Qe.sent, te ? (Sl("Attempt", {
                              reason: be
                            }), Wn.debug("Subscriber: iceRestart attempt"), te.iceRestart(), ze && te.generateOffer()) : Wn.debug("Subscriber: Skipping ice restart, we have no peer connection");
                          case 5:
                          case "end":
                            return Qe.stop();
                        }
                      }, P);
                    }))();
                  },
                  unblockAudio: () => jr && jr.unblockAudio(),
                  webRtcStream: () => ut,
                  setIceConfig: function() {
                    var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function P(te) {
                      return o.default.wrap(function(Qe) {
                        for (; ; ) switch (Qe.prev = Qe.next) {
                          case 0:
                            js().forEach(/* @__PURE__ */ function() {
                              var yt = (0, l.default)(/* @__PURE__ */ o.default.mark(function Ht(zt) {
                                return o.default.wrap(function(tr) {
                                  for (; ; ) switch (tr.prev = tr.next) {
                                    case 0:
                                      return tr.next = 2, zt;
                                    case 2:
                                      return tr.abrupt("return", tr.sent.setIceConfig(te));
                                    case 3:
                                    case "end":
                                      return tr.stop();
                                  }
                                }, Ht);
                              }));
                              return function(Ht) {
                                return yt.apply(this, arguments);
                              };
                            }());
                          case 1:
                          case "end":
                            return Qe.stop();
                        }
                      }, P);
                    }));
                    function ze(P) {
                      return be.apply(this, arguments);
                    }
                    return ze;
                  }(),
                  privateEvents: new h.default(),
                  startRoutedToRelayedTransition() {
                    Ci.testNetwork || sn(En, an) || (Yl.startTransitionToRelayed(), Md());
                  },
                  startRelayedToRoutedTransition() {
                    Yl.startTransitionToRouted(od);
                  },
                  setSinkId(be) {
                    if (jr && jr.video())
                      return jr.setSinkId(be);
                    Wn.debug("Called setAudioOutputDevice on a subscriber without a video element");
                  },
                  pauseAndPlayVideoElement() {
                    jr && jr.pauseAndPlayVideoElement();
                  },
                  get isSubscribingToVideo() {
                    return Ci.subscribeToVideo;
                  }
                }, this._onSenderStatsReceived = (be) => {
                  let ze;
                  try {
                    ze = JSON.parse(be.data);
                  } catch (P) {
                    Wn.error(`Sender-Stats parsing failed: ${P.message}`);
                    return;
                  }
                  kc = ze;
                }, Be = new Xa(ja), Wn.debug(`OT.Subscriber: subscribe to ${En.id}`), Be.set("Init"), !En)
                  return Wn.error("OT.Subscriber: No stream parameter."), !1;
                un = {
                  updated: fu
                }, En.on(un, this), Ci.name = Ci.name || En.name, Ci.classNames = "OT_root OT_subscriber", Ci.style && this.setStyle(Ci.style, null, !0), Co = Fa, Ci.subscribeToVideo = (0, w.default)(Ci.subscribeToVideo, !0), Ti = !Ci.subscribeToVideo, Ci.subscribeToAudio = (0, w.default)(Ci.subscribeToAudio, !0), this.subscribeToAudio(Ci.subscribeToAudio), this.setAudioVolume(Sr(Ci)), jr = new Ko.WidgetView(ps, Object.assign({}, Ci, {
                  widgetType: "subscriber"
                })), jr.on("error", lc), jr.on("audioBlocked", () => this.trigger("audioBlocked")), jr.on("audioUnblocked", () => this.trigger("audioUnblocked")), jr.on("amrLogEvent", (be, ze, P) => {
                  _r(be, ze, {}, P);
                }), this.id = jr.domId(), sr = jr.domId(), this.element = jr.domElement, jr.on("videoElementCreated", (be) => {
                  const ze = new Jt.VideoElementCreatedEvent(be), P = this;
                  gr ? this.dispatchEvent(ze) : this.once("loaded", () => {
                    P.dispatchEvent(ze);
                  }), Ec && be && (be.height !== 0 && be.width !== 0 && Ta(be), Td = new bn(() => {
                    Ta(be);
                  }), Td.observe(be));
                }), jr.on("destroy", () => {
                  var be;
                  (be = Td) == null || be.disconnect();
                }), this.element && _d.call(this);
                const $d = En.getChannelsOfType("audio"), Id = En.getChannelsOfType("video"), $s = En.getChannelsOfType("data");
                let _a = $s.some((be) => be.id === "caption1" && be.active);
                this.subscribeToCaptions = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te, Re;
                    return o.default.wrap(function(yt) {
                      for (; ; ) switch (yt.prev = yt.next) {
                        case 0:
                          te = (0, w.default)(P, !0), Re = {
                            active: te
                          }, _a = te, _r("subscribeToCaptions", "Attempt", {
                            subscribeToCaptions: te
                          }), $l.subscriberChannelUpdate(En.id, La.widgetId, "caption1", Re), _r("subscribeToCaptions", "Success", {
                            subscribeToCaptions: te
                          });
                        case 6:
                        case "end":
                          return yt.stop();
                      }
                    }, ze);
                  }));
                  return function(ze) {
                    return be.apply(this, arguments);
                  };
                }(), this.isSubscribedToCaptions = () => _a;
                const no = $d.map((be) => ({
                  id: be.id,
                  type: be.type,
                  active: Ci.subscribeToAudio
                })).concat(Id.map((be) => {
                  const ze = {
                    id: be.id,
                    type: be.type,
                    active: Ci.subscribeToVideo,
                    restrictFrameRate: Ci.restrictFrameRate !== void 0 ? Ci.restrictFrameRate : !1
                  };
                  return Ci.preferredFrameRate !== void 0 && (ze.preferredFrameRate = parseFloat(Ci.preferredFrameRate)), Ci.preferredHeight !== void 0 && (ze.preferredHeight = parseInt(Ci.preferredHeight, 10)), Ci.preferredWidth !== void 0 && (ze.preferredWidth = parseInt(Ci.preferredWidth, 10)), ze;
                })).concat($s.map((be) => ({
                  id: be.id,
                  type: be.type,
                  active: be.active
                }))), Bd = (Jd = En.getChannelsOfType("data")[0]) == null ? void 0 : Jd.active, xl = !Ci.testNetwork && sn(En, an) && !Bd;
                (() => {
                  var be;
                  const ze = an.getPublisherForStream(En);
                  if (ze != null && (be = ze._) != null && be.privateEvents && xl) {
                    let P = !1;
                    ze._.privateEvents.on("publisherCaptionsEnabled", (te) => {
                      !P && te.captionsEnabled && (no.find((Re) => Re.id === "caption1").active = !0, nt(), P = !0);
                    });
                  }
                })();
                const nt = () => {
                  sa.beginConnect(), $l.subscriberCreate(
                    En.id,
                    Rl,
                    // subscriberId
                    no,
                    null,
                    an._.isE2ee(),
                    (be, ze) => {
                      const P = Object.assign({
                        status: ze == null ? void 0 : ze.status
                      }, (be == null ? void 0 : be.message) && {
                        error: be == null ? void 0 : be.message
                      });
                      _r("subscriberCreate", "Event", P), be && !sa.is("disconnected") && Vc(be), yl = wl(ze);
                    }
                  );
                };
                if (xl)
                  return sa.beginConnect(), this._subscribeToSelf(), this;
                Ro ? Fr.addSubscriber(nt) : nt(), this.setVideoMediaProcessorConnector = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te;
                    return o.default.wrap(function(Qe) {
                      for (; ; ) switch (Qe.prev = Qe.next) {
                        case 0:
                          if (_r("setVideoMediaProcessorConnector", "Attempt", {
                            message: P ? "setting the connector" : "clearing the connector"
                          }), dt(), P) {
                            Qe.next = 6;
                            break;
                          }
                          return et(), _r("setVideoMediaProcessorConnector", "Success", {
                            message: "clearing the connector"
                          }), Qe.abrupt("return");
                        case 6:
                          if (Yt.default.isValidConnector(P)) {
                            Qe.next = 9;
                            break;
                          }
                          throw _r("setVideoMediaProcessorConnector", "Failure", {
                            message: "Invalid MediaProcessorConnector"
                          }), Ba(ge.default.INVALID_PARAMETER, new Error("setVideoMediaProcessorConnector:  Tried to set invalid MediaProcessorConnector"));
                        case 9:
                          if (Zl = new Yt.default(P), te = Yl.isTransitioning(), !(te || !ct)) {
                            Qe.next = 14;
                            break;
                          }
                          return _r("setVideoMediaProcessorConnector", "Pending", {
                            isTransitioning: te,
                            isVideoEnabled: ct
                          }), Qe.abrupt("return");
                        case 14:
                          return et(), Qe.prev = 15, Qe.next = 18, Ke();
                        case 18:
                          Qe.next = 24;
                          break;
                        case 20:
                          throw Qe.prev = 20, Qe.t0 = Qe.catch(15), _r("setVideoMediaProcessorConnector", "Failure", {
                            message: Qe.t0.message
                          }), Qe.t0;
                        case 24:
                        case "end":
                          return Qe.stop();
                      }
                    }, ze, null, [[15, 20]]);
                  }));
                  return function(ze) {
                    return be.apply(this, arguments);
                  };
                }();
                const Ke = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze() {
                    var P, te, Re;
                    return o.default.wrap(function(yt) {
                      for (; ; ) switch (yt.prev = yt.next) {
                        case 0:
                          if (P = ut.getVideoTracks(), Ml = P[0], Ml) {
                            yt.next = 7;
                            break;
                          }
                          throw te = "Connector not set as no video is present.", Wn.warn(`setVideoMediaProcessorConnector: ${te}`), Zl = null, Error("setVideoMediaProcessorConnector", "Failure", {
                            message: te
                          });
                        case 7:
                          return yt.prev = 7, yt.next = 10, Zl.setTrack(Ml);
                        case 10:
                          Re = yt.sent, (0, er.default)(ut, Ml, Re), _r("setVideoMediaProcessorConnector", "Success"), yt.next = 20;
                          break;
                        case 15:
                          throw yt.prev = 15, yt.t0 = yt.catch(7), Zl = null, Wn.error(`setVideoMediaProcessorConnector: Error getting track from MediaProcessorConnector: ${yt.t0}`), Error("setVideoMediaProcessorConnector", "Failure", {
                            message: yt.t0.message
                          });
                        case 20:
                        case "end":
                          return yt.stop();
                      }
                    }, ze, null, [[7, 15]]);
                  }));
                  return function() {
                    return be.apply(this, arguments);
                  };
                }(), et = () => {
                  if (Ml) {
                    try {
                      const be = ut.getVideoTracks(), ze = be[0];
                      (0, er.default)(ut, ze, Ml), _r("setVideoMediaProcessorConnector", "Success", {
                        message: "reset the video track"
                      });
                    } catch (be) {
                      throw Wn.error(`setVideoMediaProcessorConnector: Error resetting track: ${be}`), Error("setVideoMediaProcessorConnector", "Failure", {
                        message: be.message
                      });
                    }
                    Ml = null;
                  }
                }, dt = () => {
                  var be;
                  (be = Zl) == null || be.destroy(), Zl = null;
                };
                this.setAudioMediaProcessorConnector = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze(P) {
                    var te, Re;
                    return o.default.wrap(function(yt) {
                      for (; ; ) switch (yt.prev = yt.next) {
                        case 0:
                          if (_r("setAudioMediaProcessorConnector", "Attempt", {
                            message: P ? "setting the connector" : "clearing the connector"
                          }), ka == null || ka.clearAudioMediaProcessorConnector(Di), P) {
                            yt.next = 6;
                            break;
                          }
                          return ka == null || ka.resetAudioStreamAndTrack(), _r("setAudioMediaProcessorConnector", "Success", {
                            message: "clearing the connector"
                          }), yt.abrupt("return");
                        case 6:
                          if (Yt.default.isValidConnector(P)) {
                            yt.next = 11;
                            break;
                          }
                          throw te = "Tried to set invalid MediaProcessorConnector", Wn.error(`setAudioMediaProcessorConnector: ${te}`), _r("setAudioMediaProcessorConnector", "Failure", {
                            message: te
                          }), Ba(ge.default.INVALID_PARAMETER, new Error(`setAudioVideoMediaProcessorConnector: ${te}`));
                        case 11:
                          if (ka.initializeConnector(P), Re = Yl.isTransitioning(), !(Re || !vt)) {
                            yt.next = 16;
                            break;
                          }
                          return _r("setAudioMediaProcessorConnector", "Pending", {
                            isTransitioning: Re,
                            subscribingToAudio: vt
                          }), yt.abrupt("return");
                        case 16:
                          ka.resetAudioStreamAndTrack(), $t();
                        case 18:
                        case "end":
                          return yt.stop();
                      }
                    }, ze);
                  }));
                  return function(ze) {
                    return be.apply(this, arguments);
                  };
                }();
                const $t = /* @__PURE__ */ function() {
                  var be = (0, l.default)(/* @__PURE__ */ o.default.mark(function ze() {
                    return o.default.wrap(function(te) {
                      for (; ; ) switch (te.prev = te.next) {
                        case 0:
                          return te.prev = 0, te.next = 3, ka == null ? void 0 : ka.setAudioMediaProcessorConnector(Di);
                        case 3:
                          te.next = 10;
                          break;
                        case 5:
                          throw te.prev = 5, te.t0 = te.catch(0), Wn.error(`setAudioMediaProcessorConnector: ${te.t0.message}`), _r("setAudioMediaProcessorConnector", "Failure", {
                            message: te.t0.message
                          }), te.t0;
                        case 10:
                          _r("setAudioMediaProcessorConnector", "Success");
                        case 11:
                        case "end":
                          return te.stop();
                      }
                    }, ze, null, [[0, 5]]);
                  }));
                  return function() {
                    return be.apply(this, arguments);
                  };
                }();
                return this;
              };
              return _i.hasAudioOutputLevelStatCapability = Ar, _i.WidgetView = pr, _i.SubscriberPeerConnection = oa, _i;
            }
          }).call(this, e(2));
        },
        /* 324 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = n(e(325)), l = n(e(175)), d = function(h) {
            h === void 0 && (h = {});
            const A = Object.assign({}, l.default, h), g = A.TRANSITION_TIMEOUT, f = new t.default(), p = {
              state: o.default.MANTIS,
              pendingTransitions: [],
              timeout: void 0,
              isTransitioning() {
                return this.state === o.default.TRANSITIONING;
              },
              clearTransitionTimeout() {
                this.timeout && (clearTimeout(this.timeout), this.timeout = void 0);
              },
              startTransitionToRelayed() {
                this.state = o.default.TRANSITIONING, this.clearTransitionTimeout(), this.timeout = setTimeout(() => {
                  f.emit("transitionToP2PTimeout");
                }, g);
              },
              completeTransitionTo(v) {
                v === o.default.P2P && (this.clearTransitionTimeout(), this._transitionTo(v));
              },
              startTransitionToRouted(v) {
                this.state === o.default.TRANSITIONING ? this.pendingTransitions.push({
                  to: o.default.MANTIS,
                  process: v
                }) : this._transitionTo(o.default.MANTIS, v);
              },
              _transitionTo(v, b) {
                b && (this.state = o.default.TRANSITIONING, b()), this.state = v, this._onTransitionCompleted();
              },
              _onTransitionCompleted() {
                if (this.pendingTransitions.length) {
                  const v = this.pendingTransitions.shift(), b = v.to, m = v.process;
                  this._transitionTo(b, m);
                }
              }
            };
            return Object.assign(f, p);
          };
          r.default = d;
        },
        /* 325 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {
            MANTIS: "MANTIS",
            P2P: "P2P",
            TRANSITIONING: "TRANSITIONING"
          };
          r.default = n;
        },
        /* 326 */
        /***/
        function(i, r, e) {
          (function(t, o) {
            i.exports = o();
          })(this, function() {
            return (
              /******/
              function(n) {
                var t = {};
                function o(l) {
                  if (t[l])
                    return t[l].exports;
                  var c = t[l] = {
                    /******/
                    i: l,
                    /******/
                    l: !1,
                    /******/
                    exports: {}
                    /******/
                  };
                  return n[l].call(c.exports, c, c.exports, o), c.l = !0, c.exports;
                }
                return o.m = n, o.c = t, o.i = function(l) {
                  return l;
                }, o.d = function(l, c, d) {
                  o.o(l, c) || Object.defineProperty(l, c, {
                    /******/
                    configurable: !1,
                    /******/
                    enumerable: !0,
                    /******/
                    get: d
                    /******/
                  });
                }, o.n = function(l) {
                  var c = l && l.__esModule ? (
                    /******/
                    function() {
                      return l.default;
                    }
                  ) : (
                    /******/
                    function() {
                      return l;
                    }
                  );
                  return o.d(c, "a", c), c;
                }, o.o = function(l, c) {
                  return Object.prototype.hasOwnProperty.call(l, c);
                }, o.p = "", o(o.s = 5);
              }([
                /* 0 */
                /***/
                function(n, t, o) {
                  n.exports = function(l, c) {
                    var d, u, h;
                    for (d = 1; d < arguments.length; d++) {
                      u = arguments[d];
                      for (h in u)
                        u.hasOwnProperty(h) && (l[h] = u[h]);
                    }
                    return l;
                  };
                },
                /* 1 */
                /***/
                function(n, t, o) {
                  var l = o(0);
                  n.exports = {
                    build: function(c, d) {
                      var u, h, A, g = d.plugins;
                      for (u = 0, h = g.length; u < h; u++)
                        A = g[u], A.methods && l(c, A.methods), A.properties && Object.defineProperties(c, A.properties);
                    },
                    hook: function(c, d, u) {
                      var h, A, g, f, p = c.config.plugins, v = [c.context];
                      for (u && (v = v.concat(u)), h = 0, A = p.length; h < A; h++)
                        f = p[h], g = p[h][d], g && g.apply(f, v);
                    }
                  };
                },
                /* 2 */
                /***/
                function(n, t, o) {
                  function l(c) {
                    if (c.length === 0)
                      return c;
                    var d, u, h = c.split(/[_-]/);
                    if (h.length === 1 && h[0][0].toLowerCase() === h[0][0])
                      return c;
                    for (u = h[0].toLowerCase(), d = 1; d < h.length; d++)
                      u = u + h[d].charAt(0).toUpperCase() + h[d].substring(1).toLowerCase();
                    return u;
                  }
                  l.prepended = function(c, d) {
                    return d = l(d), c + d[0].toUpperCase() + d.substring(1);
                  }, n.exports = l;
                },
                /* 3 */
                /***/
                function(n, t, o) {
                  var l = o(0), c = o(2);
                  function d(u, h) {
                    u = u || {}, this.options = u, this.defaults = h.defaults, this.states = [], this.transitions = [], this.map = {}, this.lifecycle = this.configureLifecycle(), this.init = this.configureInitTransition(u.init), this.data = this.configureData(u.data), this.methods = this.configureMethods(u.methods), this.map[this.defaults.wildcard] = {}, this.configureTransitions(u.transitions || []), this.plugins = this.configurePlugins(u.plugins, h.plugin);
                  }
                  l(d.prototype, {
                    addState: function(u) {
                      this.map[u] || (this.states.push(u), this.addStateLifecycleNames(u), this.map[u] = {});
                    },
                    addStateLifecycleNames: function(u) {
                      this.lifecycle.onEnter[u] = c.prepended("onEnter", u), this.lifecycle.onLeave[u] = c.prepended("onLeave", u), this.lifecycle.on[u] = c.prepended("on", u);
                    },
                    addTransition: function(u) {
                      this.transitions.indexOf(u) < 0 && (this.transitions.push(u), this.addTransitionLifecycleNames(u));
                    },
                    addTransitionLifecycleNames: function(u) {
                      this.lifecycle.onBefore[u] = c.prepended("onBefore", u), this.lifecycle.onAfter[u] = c.prepended("onAfter", u), this.lifecycle.on[u] = c.prepended("on", u);
                    },
                    mapTransition: function(u) {
                      var h = u.name, A = u.from, g = u.to;
                      return this.addState(A), typeof g != "function" && this.addState(g), this.addTransition(h), this.map[A][h] = u, u;
                    },
                    configureLifecycle: function() {
                      return {
                        onBefore: { transition: "onBeforeTransition" },
                        onAfter: { transition: "onAfterTransition" },
                        onEnter: { state: "onEnterState" },
                        onLeave: { state: "onLeaveState" },
                        on: { transition: "onTransition" }
                      };
                    },
                    configureInitTransition: function(u) {
                      return typeof u == "string" ? this.mapTransition(l({}, this.defaults.init, { to: u, active: !0 })) : typeof u == "object" ? this.mapTransition(l({}, this.defaults.init, u, { active: !0 })) : (this.addState(this.defaults.init.from), this.defaults.init);
                    },
                    configureData: function(u) {
                      return typeof u == "function" ? u : typeof u == "object" ? function() {
                        return u;
                      } : function() {
                        return {};
                      };
                    },
                    configureMethods: function(u) {
                      return u || {};
                    },
                    configurePlugins: function(u, h) {
                      u = u || [];
                      var A, g, f;
                      for (A = 0, g = u.length; A < g; A++)
                        f = u[A], typeof f == "function" && (u[A] = f = f()), f.configure && f.configure(this);
                      return u;
                    },
                    configureTransitions: function(u) {
                      var h, A, g, f, p, v = this.defaults.wildcard;
                      for (A = 0; A < u.length; A++)
                        for (g = u[A], f = Array.isArray(g.from) ? g.from : [g.from || v], p = g.to || v, h = 0; h < f.length; h++)
                          this.mapTransition({ name: g.name, from: f[h], to: p });
                    },
                    transitionFor: function(u, h) {
                      var A = this.defaults.wildcard;
                      return this.map[u][h] || this.map[A][h];
                    },
                    transitionsFor: function(u) {
                      var h = this.defaults.wildcard;
                      return Object.keys(this.map[u]).concat(Object.keys(this.map[h]));
                    },
                    allStates: function() {
                      return this.states;
                    },
                    allTransitions: function() {
                      return this.transitions;
                    }
                  }), n.exports = d;
                },
                /* 4 */
                /***/
                function(n, t, o) {
                  var l = o(0), c = o(6), d = o(1), u = [null, []];
                  function h(A, g) {
                    this.context = A, this.config = g, this.state = g.init.from, this.observers = [A];
                  }
                  l(h.prototype, {
                    init: function(A) {
                      if (l(this.context, this.config.data.apply(this.context, A)), d.hook(this, "init"), this.config.init.active)
                        return this.fire(this.config.init.name, []);
                    },
                    is: function(A) {
                      return Array.isArray(A) ? A.indexOf(this.state) >= 0 : this.state === A;
                    },
                    isPending: function() {
                      return this.pending;
                    },
                    can: function(A) {
                      return !this.isPending() && !!this.seek(A);
                    },
                    cannot: function(A) {
                      return !this.can(A);
                    },
                    allStates: function() {
                      return this.config.allStates();
                    },
                    allTransitions: function() {
                      return this.config.allTransitions();
                    },
                    transitions: function() {
                      return this.config.transitionsFor(this.state);
                    },
                    seek: function(A, g) {
                      var f = this.config.defaults.wildcard, p = this.config.transitionFor(this.state, A), v = p && p.to;
                      return typeof v == "function" ? v.apply(this.context, g) : v === f ? this.state : v;
                    },
                    fire: function(A, g) {
                      return this.transit(A, this.state, this.seek(A, g), g);
                    },
                    transit: function(A, g, f, p) {
                      var v = this.config.lifecycle, b = this.config.options.observeUnchangedState || g !== f;
                      return f ? this.isPending() ? this.context.onPendingTransition(A, g, f) : (this.config.addState(f), this.beginTransit(), p.unshift({
                        // this context will be passed to each lifecycle event observer
                        transition: A,
                        from: g,
                        to: f,
                        fsm: this.context
                      }), this.observeEvents([
                        this.observersForEvent(v.onBefore.transition),
                        this.observersForEvent(v.onBefore[A]),
                        b ? this.observersForEvent(v.onLeave.state) : u,
                        b ? this.observersForEvent(v.onLeave[g]) : u,
                        this.observersForEvent(v.on.transition),
                        b ? ["doTransit", [this]] : u,
                        b ? this.observersForEvent(v.onEnter.state) : u,
                        b ? this.observersForEvent(v.onEnter[f]) : u,
                        b ? this.observersForEvent(v.on[f]) : u,
                        this.observersForEvent(v.onAfter.transition),
                        this.observersForEvent(v.onAfter[A]),
                        this.observersForEvent(v.on[A])
                      ], p)) : this.context.onInvalidTransition(A, g, f);
                    },
                    beginTransit: function() {
                      this.pending = !0;
                    },
                    endTransit: function(A) {
                      return this.pending = !1, A;
                    },
                    failTransit: function(A) {
                      throw this.pending = !1, A;
                    },
                    doTransit: function(A) {
                      this.state = A.to;
                    },
                    observe: function(A) {
                      if (A.length === 2) {
                        var g = {};
                        g[A[0]] = A[1], this.observers.push(g);
                      } else
                        this.observers.push(A[0]);
                    },
                    observersForEvent: function(A) {
                      for (var g = 0, f = this.observers.length, p, v = []; g < f; g++)
                        p = this.observers[g], p[A] && v.push(p);
                      return [A, v, !0];
                    },
                    observeEvents: function(A, g, f, p) {
                      if (A.length === 0)
                        return this.endTransit(p === void 0 ? !0 : p);
                      var v = A[0][0], b = A[0][1], m = A[0][2];
                      if (g[0].event = v, v && m && v !== f && d.hook(this, "lifecycle", g), b.length === 0)
                        return A.shift(), this.observeEvents(A, g, v, p);
                      var y = b.shift(), U = y[v].apply(y, g);
                      return U && typeof U.then == "function" ? U.then(this.observeEvents.bind(this, A, g, v)).catch(this.failTransit.bind(this)) : U === !1 ? this.endTransit(!1) : this.observeEvents(A, g, v, U);
                    },
                    onInvalidTransition: function(A, g, f) {
                      throw new c("transition is invalid in current state", A, g, f, this.state);
                    },
                    onPendingTransition: function(A, g, f) {
                      throw new c("transition is invalid while previous transition is still in progress", A, g, f, this.state);
                    }
                  }), n.exports = h;
                },
                /* 5 */
                /***/
                function(n, t, o) {
                  var l = o(0), c = o(2), d = o(1), u = o(3), h = o(4), A = {
                    is: function(m) {
                      return this._fsm.is(m);
                    },
                    can: function(m) {
                      return this._fsm.can(m);
                    },
                    cannot: function(m) {
                      return this._fsm.cannot(m);
                    },
                    observe: function() {
                      return this._fsm.observe(arguments);
                    },
                    transitions: function() {
                      return this._fsm.transitions();
                    },
                    allTransitions: function() {
                      return this._fsm.allTransitions();
                    },
                    allStates: function() {
                      return this._fsm.allStates();
                    },
                    onInvalidTransition: function(m, y, U) {
                      return this._fsm.onInvalidTransition(m, y, U);
                    },
                    onPendingTransition: function(m, y, U) {
                      return this._fsm.onPendingTransition(m, y, U);
                    }
                  }, g = {
                    state: {
                      configurable: !1,
                      enumerable: !0,
                      get: function() {
                        return this._fsm.state;
                      },
                      set: function(m) {
                        throw Error("use transitions to change state");
                      }
                    }
                  };
                  function f(m) {
                    return v(this || {}, m);
                  }
                  function p() {
                    var m, y;
                    typeof arguments[0] == "function" ? (m = arguments[0], y = arguments[1] || {}) : (m = function() {
                      this._fsm.apply(this, arguments);
                    }, y = arguments[0] || {});
                    var U = new u(y, f);
                    return b(m.prototype, U), m.prototype._fsm.config = U, m;
                  }
                  function v(m, y) {
                    var U = new u(y, f);
                    return b(m, U), m._fsm(), m;
                  }
                  function b(m, y) {
                    if (typeof m != "object" || Array.isArray(m))
                      throw Error("StateMachine can only be applied to objects");
                    d.build(m, y), Object.defineProperties(m, g), l(m, A), l(m, y.methods), y.allTransitions().forEach(function(U) {
                      m[c(U)] = function() {
                        return this._fsm.fire(U, [].slice.call(arguments));
                      };
                    }), m._fsm = function() {
                      this._fsm = new h(this, y), this._fsm.init(arguments);
                    };
                  }
                  f.version = "3.0.1", f.factory = p, f.apply = v, f.defaults = {
                    wildcard: "*",
                    init: {
                      name: "init",
                      from: "none"
                    }
                  }, n.exports = f;
                },
                /* 6 */
                /***/
                function(n, t, o) {
                  n.exports = function(l, c, d, u, h) {
                    this.message = l, this.transition = c, this.from = d, this.to = u, this.current = h;
                  };
                }
                /******/
              ])
            );
          });
        },
        /* 327 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(108)), l = (0, t.default)();
          r.default = l;
        },
        /* 328 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = () => ["Firefox", "Safari", "Edge", "Chrome", "Opera"].indexOf(t.default.name) > -1;
          r.default = o;
        },
        /* 329 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(167));
          const u = (0, t.default)()("NotSubscribing", ["NotSubscribing", "Init", "Connecting", "BindingRemoteStream", "Subscribing", "Failed", "Destroyed"], {
            NotSubscribing: ["NotSubscribing", "Init", "Destroyed"],
            Init: ["NotSubscribing", "Connecting", "BindingRemoteStream", "Destroyed"],
            Connecting: ["NotSubscribing", "BindingRemoteStream", "Failed", "Destroyed"],
            BindingRemoteStream: ["NotSubscribing", "Subscribing", "Failed", "Destroyed", "BindingRemoteStream"],
            Subscribing: ["NotSubscribing", "Failed", "Destroyed", "BindingRemoteStream"],
            Failed: ["Destroyed"],
            Destroyed: []
          });
          u.prototype.isDestroyed = function() {
            return this.current === "Destroyed";
          }, u.prototype.isFailed = function() {
            return this.current === "Failed";
          }, u.prototype.isSubscribing = function() {
            return this.current === "Subscribing";
          }, u.prototype.isAttemptingToSubscribe = function() {
            return ["Init", "Connecting", "BindingRemoteStream"].indexOf(this.current) !== -1;
          }, u.prototype.isStreamAdded = function() {
            return this.current === "BindingRemoteStream" || this.isSubscribing();
          };
          var h = u;
          r.default = h;
        },
        /* 330 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            let o = t.socket, l = t.uri, c = t.content;
            return (d, u) => {
              let h = d.type, A = d.content;
              return o.send({
                message: {
                  uri: l,
                  method: h,
                  content: Object.assign({}, c, A)
                }
              }, u);
            };
          };
          r.default = n;
        },
        /* 331 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t, o, l) => {
            o !== l && (t.removeTrack(o), t.addTrack(l));
          };
          r.default = n;
        },
        /* 332 */
        /***/
        function(i, r) {
          function e(n) {
            if (n == null) throw new TypeError("Cannot destructure undefined");
          }
          i.exports = e;
        },
        /* 333 */
        /***/
        function(i, r) {
          function e() {
            return i.exports = e = Object.assign || function(n) {
              for (var t = 1; t < arguments.length; t++) {
                var o = arguments[t];
                for (var l in o)
                  Object.prototype.hasOwnProperty.call(o, l) && (n[l] = o[l]);
              }
              return n;
            }, e.apply(this, arguments);
          }
          i.exports = e;
        },
        /* 334 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            var o;
            const l = Object.assign({}, t);
            return (t == null || (o = t.backgroundImgUrl) == null ? void 0 : o.includes("base64")) && delete l.backgroundImgUrl, l;
          };
          r.default = n;
        },
        /* 335 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = e(729), t = e(336), c = {
            isSupported: () => typeof MediaStreamTrackProcessor != "undefined" && typeof MediaStreamTrackGenerator != "undefined",
            setMetadata: n.setVonageMetadata,
            createProcessor: t.createVonageMediaProcessor
          };
          r.default = c;
        },
        /* 336 */
        /***/
        function(i, r, e) {
          e.r(r), function(n, t) {
            e.d(r, "BackgroundTransformer", function() {
              return HF;
            }), e.d(r, "BackgroundTransformerType", function() {
              return Hn;
            }), e.d(r, "BlurRadius", function() {
              return cn;
            }), e.d(r, "ErrorFunction", function() {
              return Li;
            }), e.d(r, "MediapipeHelper", function() {
              return Qn;
            }), e.d(r, "PipelineInfoData", function() {
              return xo;
            }), e.d(r, "RenderingType", function() {
              return ao;
            }), e.d(r, "VonageMediaProcessor", function() {
              return lv;
            }), e.d(r, "WarningType", function() {
              return Bi;
            }), e.d(r, "WebglSelfieSegmentationType", function() {
              return Sr;
            }), e.d(r, "createVonageMediaProcessor", function() {
              return RE;
            }), e.d(r, "getSupportedBrowserFeatures", function() {
              return yi;
            }), e.d(r, "getVonageFaceDetection", function() {
              return mE;
            }), e.d(r, "getVonageFaceMash", function() {
              return vE;
            }), e.d(r, "getVonageHands", function() {
              return fE;
            }), e.d(r, "getVonageHolistic", function() {
              return pE;
            }), e.d(r, "getVonageObjectron", function() {
              return bE;
            }), e.d(r, "getVonagePose", function() {
              return FE;
            }), e.d(r, "getVonageSelfieSegmentation", function() {
              return gE;
            }), e.d(r, "isSupported", function() {
              return mr;
            });
            var o = Object.defineProperty, l = (E, R, S) => R in E ? o(E, R, { enumerable: !0, configurable: !0, writable: !0, value: S }) : E[R] = S, c = (E, R, S) => (l(E, typeof R != "symbol" ? R + "" : R, S), S), d = Object.defineProperty, u = (E, R, S) => R in E ? d(E, R, { enumerable: !0, configurable: !0, writable: !0, value: S }) : E[R] = S, h = (E, R, S) => (u(E, typeof R != "symbol" ? R + "" : R, S), S);
            function A() {
              return new n((E, R) => {
                typeof MediaStreamTrackProcessor > "u" || typeof MediaStreamTrackGenerator > "u" ? R("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.") : E();
              });
            }
            class g {
            }
            h(g, "updates", {
              transformer_new: "New transformer",
              transformer_null: "Null transformer"
            }), h(g, "errors", {
              transformer_none: "No transformers provided",
              transformer_start: "Cannot start transformer",
              transformer_transform: "Cannot transform frame",
              transformer_flush: "Cannot flush transformer",
              readable_null: "Readable is null",
              writable_null: "Writable is null"
            });
            const f = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), b = Symbol("anyProducer"), m = n.resolve(), y = Symbol("listenerAdded"), U = Symbol("listenerRemoved");
            let B = !1;
            function Q(E) {
              if (typeof E != "string" && typeof E != "symbol")
                throw new TypeError("eventName must be a string or a symbol");
            }
            function N(E) {
              if (typeof E != "function")
                throw new TypeError("listener must be a function");
            }
            function J(E, R) {
              const S = p.get(E);
              return S.has(R) || S.set(R, /* @__PURE__ */ new Set()), S.get(R);
            }
            function w(E, R) {
              const S = typeof R == "string" || typeof R == "symbol" ? R : b, ie = v.get(E);
              return ie.has(S) || ie.set(S, /* @__PURE__ */ new Set()), ie.get(S);
            }
            function W(E, R, S) {
              const ie = v.get(E);
              if (ie.has(R))
                for (const pe of ie.get(R))
                  pe.enqueue(S);
              if (ie.has(b)) {
                const pe = n.all([R, S]);
                for (const De of ie.get(b))
                  De.enqueue(pe);
              }
            }
            function G(E, R) {
              R = Array.isArray(R) ? R : [R];
              let S = !1, ie = () => {
              }, pe = [];
              const De = {
                enqueue(ht) {
                  pe.push(ht), ie();
                },
                finish() {
                  S = !0, ie();
                }
              };
              for (const ht of R)
                w(E, ht).add(De);
              return {
                async next() {
                  return pe ? pe.length === 0 ? S ? (pe = void 0, this.next()) : (await new n((ht) => {
                    ie = ht;
                  }), this.next()) : {
                    done: !1,
                    value: await pe.shift()
                  } : { done: !0 };
                },
                async return(ht) {
                  pe = void 0;
                  for (const rt of R)
                    w(E, rt).delete(De);
                  return ie(), arguments.length > 0 ? { done: !0, value: await ht } : { done: !0 };
                },
                [Symbol.asyncIterator]() {
                  return this;
                }
              };
            }
            function Z(E) {
              if (E === void 0)
                return O;
              if (!Array.isArray(E))
                throw new TypeError("`methodNames` must be an array of strings");
              for (const R of E)
                if (!O.includes(R))
                  throw typeof R != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${R} is not Emittery method`);
              return E;
            }
            const K = (E) => E === y || E === U;
            class L {
              static mixin(R, S) {
                return S = Z(S), (ie) => {
                  if (typeof ie != "function")
                    throw new TypeError("`target` must be function");
                  for (const ht of S)
                    if (ie.prototype[ht] !== void 0)
                      throw new Error(`The property \`${ht}\` already exists on \`target\``);
                  function pe() {
                    return Object.defineProperty(this, R, {
                      enumerable: !1,
                      value: new L()
                    }), this[R];
                  }
                  Object.defineProperty(ie.prototype, R, {
                    enumerable: !1,
                    get: pe
                  });
                  const De = (ht) => function(...rt) {
                    return this[R][ht](...rt);
                  };
                  for (const ht of S)
                    Object.defineProperty(ie.prototype, ht, {
                      enumerable: !1,
                      value: De(ht)
                    });
                  return ie;
                };
              }
              static get isDebugEnabled() {
                if (typeof t != "object")
                  return B;
                const { env: R } = t || { env: {} };
                return R.DEBUG === "emittery" || R.DEBUG === "*" || B;
              }
              static set isDebugEnabled(R) {
                B = R;
              }
              constructor(R = {}) {
                f.set(this, /* @__PURE__ */ new Set()), p.set(this, /* @__PURE__ */ new Map()), v.set(this, /* @__PURE__ */ new Map()), this.debug = R.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (S, ie, pe, De) => {
                  try {
                    De = JSON.stringify(De);
                  } catch {
                    De = `Object with the following keys failed to stringify: ${Object.keys(De).join(",")}`;
                  }
                  typeof pe == "symbol" && (pe = pe.toString());
                  const ht = /* @__PURE__ */ new Date(), rt = `${ht.getHours()}:${ht.getMinutes()}:${ht.getSeconds()}.${ht.getMilliseconds()}`;
                  console.log(`[${rt}][emittery:${S}][${ie}] Event Name: ${pe}
	data: ${De}`);
                });
              }
              logIfDebugEnabled(R, S, ie) {
                (L.isDebugEnabled || this.debug.enabled) && this.debug.logger(R, this.debug.name, S, ie);
              }
              on(R, S) {
                N(S), R = Array.isArray(R) ? R : [R];
                for (const ie of R)
                  Q(ie), J(this, ie).add(S), this.logIfDebugEnabled("subscribe", ie, void 0), K(ie) || this.emit(y, { eventName: ie, listener: S });
                return this.off.bind(this, R, S);
              }
              off(R, S) {
                N(S), R = Array.isArray(R) ? R : [R];
                for (const ie of R)
                  Q(ie), J(this, ie).delete(S), this.logIfDebugEnabled("unsubscribe", ie, void 0), K(ie) || this.emit(U, { eventName: ie, listener: S });
              }
              once(R) {
                return new n((S) => {
                  const ie = this.on(R, (pe) => {
                    ie(), S(pe);
                  });
                });
              }
              events(R) {
                R = Array.isArray(R) ? R : [R];
                for (const S of R)
                  Q(S);
                return G(this, R);
              }
              async emit(R, S) {
                Q(R), this.logIfDebugEnabled("emit", R, S), W(this, R, S);
                const ie = J(this, R), pe = f.get(this), De = [...ie], ht = K(R) ? [] : [...pe];
                await m, await n.all([
                  ...De.map(async (rt) => {
                    if (ie.has(rt))
                      return rt(S);
                  }),
                  ...ht.map(async (rt) => {
                    if (pe.has(rt))
                      return rt(R, S);
                  })
                ]);
              }
              async emitSerial(R, S) {
                Q(R), this.logIfDebugEnabled("emitSerial", R, S);
                const ie = J(this, R), pe = f.get(this), De = [...ie], ht = [...pe];
                await m;
                for (const rt of De)
                  ie.has(rt) && await rt(S);
                for (const rt of ht)
                  pe.has(rt) && await rt(R, S);
              }
              onAny(R) {
                return N(R), this.logIfDebugEnabled("subscribeAny", void 0, void 0), f.get(this).add(R), this.emit(y, { listener: R }), this.offAny.bind(this, R);
              }
              anyEvent() {
                return G(this);
              }
              offAny(R) {
                N(R), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(U, { listener: R }), f.get(this).delete(R);
              }
              clearListeners(R) {
                R = Array.isArray(R) ? R : [R];
                for (const S of R)
                  if (this.logIfDebugEnabled("clear", S, void 0), typeof S == "string" || typeof S == "symbol") {
                    J(this, S).clear();
                    const ie = w(this, S);
                    for (const pe of ie)
                      pe.finish();
                    ie.clear();
                  } else {
                    f.get(this).clear();
                    for (const ie of p.get(this).values())
                      ie.clear();
                    for (const ie of v.get(this).values()) {
                      for (const pe of ie)
                        pe.finish();
                      ie.clear();
                    }
                  }
              }
              listenerCount(R) {
                R = Array.isArray(R) ? R : [R];
                let S = 0;
                for (const ie of R) {
                  if (typeof ie == "string") {
                    S += f.get(this).size + J(this, ie).size + w(this, ie).size + w(this).size;
                    continue;
                  }
                  typeof ie < "u" && Q(ie), S += f.get(this).size;
                  for (const pe of p.get(this).values())
                    S += pe.size;
                  for (const pe of v.get(this).values())
                    S += pe.size;
                }
                return S;
              }
              bindMethods(R, S) {
                if (typeof R != "object" || R === null)
                  throw new TypeError("`target` must be an object");
                S = Z(S);
                for (const ie of S) {
                  if (R[ie] !== void 0)
                    throw new Error(`The property \`${ie}\` already exists on \`target\``);
                  Object.defineProperty(R, ie, {
                    enumerable: !1,
                    value: this[ie].bind(this)
                  });
                }
              }
            }
            const O = Object.getOwnPropertyNames(L.prototype).filter((E) => E !== "constructor");
            Object.defineProperty(L, "listenerAdded", {
              value: y,
              writable: !1,
              enumerable: !0,
              configurable: !1
            }), Object.defineProperty(L, "listenerRemoved", {
              value: U,
              writable: !1,
              enumerable: !0,
              configurable: !1
            });
            var de = L;
            function oe(E) {
              return typeof E == "object" && E !== null && "message" in E && typeof E.message == "string";
            }
            function fe(E) {
              if (oe(E))
                return E;
              try {
                return new Error(JSON.stringify(E));
              } catch {
                return new Error(String(E));
              }
            }
            function ge(E) {
              return fe(E).message;
            }
            var we = Object.defineProperty, _e = (E, R, S) => R in E ? we(E, R, { enumerable: !0, configurable: !0, writable: !0, value: S }) : E[R] = S, Te = (E, R, S) => (_e(E, R + "", S), S);
            const Pe = "hlg.tokbox.com/prod/logging/vcp_webrtc", $e = "https://", Bt = 1e4;
            let Le;
            const at = new Uint8Array(16);
            function pt() {
              if (!Le && (Le = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Le))
                throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
              return Le(at);
            }
            const kt = [];
            for (let E = 0; E < 256; ++E)
              kt.push((E + 256).toString(16).slice(1));
            function _t(E, R = 0) {
              return (kt[E[R + 0]] + kt[E[R + 1]] + kt[E[R + 2]] + kt[E[R + 3]] + "-" + kt[E[R + 4]] + kt[E[R + 5]] + "-" + kt[E[R + 6]] + kt[E[R + 7]] + "-" + kt[E[R + 8]] + kt[E[R + 9]] + "-" + kt[E[R + 10]] + kt[E[R + 11]] + kt[E[R + 12]] + kt[E[R + 13]] + kt[E[R + 14]] + kt[E[R + 15]]).toLowerCase();
            }
            const Lt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Ft = {
              randomUUID: Lt
            };
            function Zt(E, R, S) {
              if (Ft.randomUUID && !R && !E)
                return Ft.randomUUID();
              E = E || {};
              const ie = E.random || (E.rng || pt)();
              return ie[6] = ie[6] & 15 | 64, ie[8] = ie[8] & 63 | 128, _t(ie);
            }
            function ft(E, R) {
              globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
              let S = globalThis.vonage.workerizer;
              return S[E] || (S[E] = R), S[E];
            }
            const It = ft(
              "globals",
              {}
            );
            var Kt = /* @__PURE__ */ ((E) => (E.INIT = "INIT", E.FORWARD = "FORWARD", E.TERMINATE = "TERMINATE", E.GLOBALS_SYNC = "GLOBALS_SYNC", E))(Kt || {});
            function Sn(E) {
              return [ImageBitmap, ReadableStream, WritableStream].some((R) => E instanceof R);
            }
            let Cn = 0;
            function on(E, R, S, ie, pe) {
              const De = Cn++;
              return E.postMessage(
                {
                  id: De,
                  type: R,
                  functionName: S,
                  args: ie
                },
                ie.filter((ht) => Sn(ht))
              ), new n((ht) => {
                pe == null || pe.set(De, ht);
              });
            }
            function An(E, R) {
              const { id: S, type: ie } = E, pe = Array.isArray(R) ? R : [R];
              postMessage(
                {
                  id: S,
                  type: ie,
                  result: R
                },
                pe.filter((De) => Sn(De))
              );
            }
            const Ue = ft("workerized", {});
            function ne() {
              return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
            }
            async function se() {
              if (ne())
                An({ type: Kt.GLOBALS_SYNC }, It);
              else {
                const E = [];
                for (const R in Ue) {
                  const { worker: S, resolvers: ie } = Ue[R].workerContext;
                  S && E.push(
                    on(
                      S,
                      Kt.GLOBALS_SYNC,
                      "",
                      [It],
                      ie
                    )
                  );
                }
                await n.all(E);
              }
            }
            function Ce(E, R) {
              if (Array.isArray(R))
                R.splice(0, R.length);
              else if (typeof R == "object")
                for (const S in R)
                  delete R[S];
              for (const S in E)
                Array.isArray(E[S]) ? (R[S] = [], Ce(E[S], R[S])) : typeof E[S] == "object" ? (R[S] = {}, Ce(E[S], R[S])) : R[S] = E[S];
            }
            async function At(E, R) {
              const { functionName: S, args: ie } = E;
              if (!R.instance)
                throw "instance not initialized";
              if (!S)
                throw "missing function name to call";
              if (!R.instance[S])
                throw `undefined function [${S}] in class ${R.instance.constructor.workerId}`;
              An(E, await R.instance[S](...ie != null ? ie : []));
            }
            const Ge = ft("registeredWorkers", {});
            function Ye(E, R) {
              if (!E.args)
                throw "Missing className while initializing worker";
              const [S, ie] = E.args, pe = Ge[S];
              if (pe)
                R.instance = new pe(E.args.slice(1));
              else
                throw `unknown worker class ${S}`;
              Ce(ie, It), An(E, typeof R.instance !== void 0);
            }
            async function Qt(E, R) {
              const { args: S } = E;
              if (!R.instance)
                throw "instance not initialized";
              let ie;
              R.instance.terminate && (ie = await R.instance.terminate(...S != null ? S : [])), An(E, ie);
            }
            function tn(E) {
              if (!E.args)
                throw "Missing globals while syncing";
              Ce(E.args[0], It), An(E, {});
            }
            function vn() {
              const E = {};
              onmessage = async (R) => {
                const S = R.data;
                switch (S.type) {
                  case Kt.INIT:
                    Ye(S, E);
                    break;
                  case Kt.FORWARD:
                    At(S, E);
                    break;
                  case Kt.TERMINATE:
                    Qt(S, E);
                    break;
                  case Kt.GLOBALS_SYNC:
                    tn(S);
                    break;
                }
              };
            }
            ne() && vn();
            function Yt(E, R) {
              return It[E] || (It[E] = R), [
                () => It[E],
                async (S) => {
                  It[E] = S, await se();
                }
              ];
            }
            function Tn(E, R) {
              return Yt(E, R);
            }
            const [er, lr] = Tn("metadata");
            function Br(E) {
              lr(E);
            }
            function pi() {
              return er();
            }
            class $n {
              constructor(R) {
                Te(this, "uuid", Zt()), this.config = R;
              }
              async send(R) {
                var S, ie, pe;
                const { appId: De, sourceType: ht } = (S = pi()) != null ? S : {};
                if (!De || !ht)
                  return "metadata missing";
                const rt = new AbortController(), Nt = setTimeout(() => rt.abort(), Bt);
                return await ((pe = (ie = this.config) == null ? void 0 : ie.fetch) != null ? pe : fetch)(this.getUrl(), {
                  method: "POST",
                  headers: this.getHeaders(),
                  body: JSON.stringify(this.buildReport(R)),
                  signal: rt.signal
                }), clearTimeout(Nt), "success";
              }
              getUrl() {
                var R;
                let S = (R = pi().proxyUrl) != null ? R : $e;
                return S += (S.at(-1) === "/" ? "" : "/") + Pe, S;
              }
              getHeaders() {
                return {
                  "Content-Type": "application/json"
                };
              }
              buildReport(R) {
                const S = pi();
                return {
                  guid: this.uuid,
                  ...R,
                  applicationId: S.appId,
                  timestamp: Date.now(),
                  proxyUrl: S.proxyUrl,
                  source: S.sourceType
                };
              }
            }
            const rr = "2.0.3";
            class Kr {
              constructor(R) {
                h(this, "frameTransformedCount", 0), h(this, "frameFromSourceCount", 0), h(this, "startAt", 0), h(this, "reporter"), this.config = R, this.reporter = new $n(R);
              }
              async onFrameFromSource() {
                this.frameFromSourceCount++;
              }
              get fps() {
                const { startAt: R, frameFromSourceCount: S } = this, ie = (Date.now() - R) / 1e3;
                return S / ie;
              }
              async onFrameTransformed(R = {}, S = !1) {
                this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
                const { startAt: ie, frameTransformedCount: pe, frameFromSourceCount: De } = this, ht = Date.now(), rt = (ht - ie) / 1e3, Nt = pe / rt, Pn = De / rt;
                return S || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = ht, this.reporter.config = this.config, this.reporter.send({
                  ...this.config.report,
                  variation: "QoS",
                  fps: Pn,
                  transformedFps: Nt,
                  framesTransformed: pe,
                  ...R
                })) : "success";
              }
            }
            var Bi = /* @__PURE__ */ ((E) => (E.FPS_DROP = "fps_drop", E))(Bi || {}), Li = /* @__PURE__ */ ((E) => (E.start = "start", E.transform = "transform", E.flush = "flush", E))(Li || {}), xo = /* @__PURE__ */ ((E) => (E.pipeline_ended = "pipeline_ended", E.pipeline_ended_with_error = "pipeline_ended_with_error", E.pipeline_started = "pipeline_started", E.pipeline_started_with_error = "pipeline_started_with_error", E.pipeline_restarted = "pipeline_restarted", E.pipeline_restarted_with_error = "pipeline_restarted_with_error", E))(xo || {});
            const Yr = 500, Qo = 0.8;
            class Wo extends de {
              constructor(R, S) {
                super(), h(this, "reporter_", new $n()), h(this, "reporterQos_", new Kr({
                  loggingIntervalFrameCount: Yr,
                  report: {
                    version: rr
                  }
                })), h(this, "transformerType_"), h(this, "transformer_"), h(this, "shouldStop_"), h(this, "isFlashed_"), h(this, "mediaTransformerQosReportStartTimestamp_"), h(this, "videoHeight_"), h(this, "videoWidth_"), h(this, "trackExpectedRate_"), h(this, "index_"), h(this, "controller_"), this.index_ = S, this.transformer_ = R, this.shouldStop_ = !1, this.isFlashed_ = !1, this.mediaTransformerQosReportStartTimestamp_ = 0, this.videoHeight_ = 0, this.videoWidth_ = 0, this.trackExpectedRate_ = -1, this.transformerType_ = "Custom", "getTransformerType" in R && (this.transformerType_ = R.getTransformerType()), this.report({
                  variation: "Create"
                });
              }
              setTrackExpectedRate(R) {
                this.trackExpectedRate_ = R;
              }
              async start(R) {
                if (this.controller_ = R, this.transformer_ && typeof this.transformer_.start == "function")
                  try {
                    await this.transformer_.start(R);
                  } catch (S) {
                    this.report({
                      message: g.errors.transformer_start,
                      variation: "Error",
                      error: ge(S)
                    });
                    const ie = { eventMetaData: { transformerIndex: this.index_ }, error: S, function: "start" };
                    this.emit("error", ie);
                  }
              }
              async transform(R, S) {
                var ie, pe, De, ht;
                if (this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), R instanceof VideoFrame && (this.videoHeight_ = (ie = R == null ? void 0 : R.displayHeight) != null ? ie : 0, this.videoWidth_ = (pe = R == null ? void 0 : R.displayWidth) != null ? pe : 0), this.reporterQos_.onFrameFromSource(), this.transformer_)
                  if (this.shouldStop_)
                    console.warn("[Pipeline] flush from transform"), R.close(), this.flush(S), S.terminate();
                  else {
                    try {
                      await ((ht = (De = this.transformer_).transform) == null ? void 0 : ht.call(De, R, S)), this.reportQos();
                    } catch (rt) {
                      this.report({
                        message: g.errors.transformer_transform,
                        variation: "Error",
                        error: ge(rt)
                      });
                      const Nt = { eventMetaData: { transformerIndex: this.index_ }, error: rt, function: "transform" };
                      this.emit("error", Nt);
                    }
                    if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * Qo > this.reporterQos_.fps) {
                      const rt = {
                        eventMetaData: {
                          transformerIndex: this.index_
                        },
                        warningType: "fps_drop",
                        dropInfo: {
                          requested: this.trackExpectedRate_,
                          current: this.reporterQos_.fps
                        }
                      };
                      this.emit("warn", rt);
                    }
                  }
              }
              async flush(R) {
                if (this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_) {
                  this.isFlashed_ = !0;
                  try {
                    await this.transformer_.flush(R);
                  } catch (S) {
                    this.report({
                      message: g.errors.transformer_flush,
                      variation: "Error",
                      error: ge(S)
                    });
                    const ie = { eventMetaData: { transformerIndex: this.index_ }, error: S, function: "flush" };
                    this.emit("error", ie);
                  }
                }
                this.reportQos(!0), this.report({
                  variation: "Delete"
                });
              }
              stop() {
                console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
              }
              report(R) {
                this.reporter_.send({
                  version: rr,
                  action: "MediaTransformer",
                  transformerType: this.transformerType_,
                  ...R
                });
              }
              reportQos(R = !1) {
                this.reporterQos_.config = {
                  ...this.reporterQos_.config
                }, this.reporterQos_.onFrameTransformed({
                  version: rr,
                  action: "MediaTransformer",
                  transformerType: this.transformerType_,
                  videoWidth: this.videoWidth_,
                  videoHeight: this.videoHeight_
                }, R);
              }
            }
            class xi extends de {
              constructor(R) {
                super(), h(this, "transformers_"), h(this, "trackExpectedRate_"), this.transformers_ = [], this.trackExpectedRate_ = -1;
                for (let S = 0; S < R.length; S++) {
                  let ie = new Wo(R[S], S);
                  ie.on("error", (pe) => {
                    this.emit("error", pe);
                  }), ie.on("warn", (pe) => {
                    this.emit("warn", pe);
                  }), this.transformers_.push(ie);
                }
              }
              setTrackExpectedRate(R) {
                this.trackExpectedRate_ = R;
                for (let S of this.transformers_)
                  S.setTrackExpectedRate(this.trackExpectedRate_);
              }
              async start(R, S) {
                if (!this.transformers_ || this.transformers_.length === 0) {
                  console.log("[Pipeline] No transformers.");
                  return;
                }
                try {
                  let ie = R;
                  for (let pe of this.transformers_)
                    R = R.pipeThrough(new TransformStream(pe));
                  R.pipeTo(S).then(async () => {
                    console.log("[Pipeline] Setup."), await S.abort(), await ie.cancel(), this.emit("pipelineInfo", "pipeline_ended");
                  }).catch(async (pe) => {
                    R.cancel().then(() => {
                      console.log("[Pipeline] Shutting down streams after abort.");
                    }).catch((De) => {
                      console.error("[Pipeline] Error from stream transform:", De);
                    }), await S.abort(pe), await ie.cancel(pe), this.emit("pipelineInfo", "pipeline_ended_with_error");
                  });
                } catch {
                  this.emit("pipelineInfo", "pipeline_started_with_error"), this.destroy();
                  return;
                }
                this.emit("pipelineInfo", "pipeline_started"), console.log("[Pipeline] Pipeline started.");
              }
              async destroy() {
                console.log("[Pipeline] Destroying Pipeline.");
                for (let R of this.transformers_)
                  R.stop();
              }
            }
            class Fa extends de {
              constructor() {
                super(), h(this, "reporter_"), h(this, "pipeline_"), h(this, "transformers_"), h(this, "readable_"), h(this, "writable_"), h(this, "trackExpectedRate_"), this.reporter_ = new $n(), this.trackExpectedRate_ = -1, this.report({
                  variation: "Create"
                });
              }
              setTrackExpectedRate(R) {
                this.trackExpectedRate_ = R, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
              }
              transform(R, S) {
                return this.readable_ = R, this.writable_ = S, this.transformInternal();
              }
              transformInternal() {
                return new n(async (R, S) => {
                  if (!this.transformers_ || this.transformers_.length === 0) {
                    this.report({
                      message: g.errors.transformer_none,
                      variation: "Error"
                    }), S("[MediaProcessor] Need to set transformers.");
                    return;
                  }
                  if (!this.readable_) {
                    this.report({
                      variation: "Error",
                      message: g.errors.readable_null
                    }), S("[MediaProcessor] Readable is null.");
                    return;
                  }
                  if (!this.writable_) {
                    this.report({
                      variation: "Error",
                      message: g.errors.writable_null
                    }), S("[MediaProcessor] Writable is null.");
                    return;
                  }
                  let ie = !1;
                  this.pipeline_ && (ie = !0, this.pipeline_.clearListeners(), this.pipeline_.destroy()), this.pipeline_ = new xi(this.transformers_), this.pipeline_.on("warn", (pe) => {
                    this.emit("warn", pe);
                  }), this.pipeline_.on("error", (pe) => {
                    this.emit("error", pe);
                  }), this.pipeline_.on("pipelineInfo", (pe) => {
                    ie && (pe === "pipeline_started" ? pe = xo.pipeline_restarted : pe === "pipeline_started_with_error" && (pe = xo.pipeline_restarted_with_error)), this.emit("pipelineInfo", pe);
                  }), this.trackExpectedRate_ != -1 && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_), this.pipeline_.start(this.readable_, this.writable_).then(() => {
                    R();
                  }).catch((pe) => {
                    S(pe);
                  });
                });
              }
              setTransformers(R) {
                return this.report({
                  variation: "Update",
                  message: g.updates.transformer_new
                }), this.transformers_ = R, this.readable_ && this.writable_ ? this.transformInternal() : n.resolve();
              }
              destroy() {
                return new n(async (R) => {
                  this.pipeline_ && this.pipeline_.destroy(), this.report({ variation: "Delete" }), R();
                });
              }
              report(R) {
                this.reporter_.send({
                  version: rr,
                  action: "MediaProcessor",
                  ...R
                });
              }
            }
            class sn {
              constructor() {
                h(this, "processor_"), h(this, "generator_"), this.processor_ = null, this.generator_ = null;
              }
              init(R) {
                return new n((S, ie) => {
                  try {
                    this.processor_ = new MediaStreamTrackProcessor(R);
                  } catch (pe) {
                    console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${pe}`), ie(pe);
                  }
                  try {
                    R.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "audio" }) : R.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "video" }) : ie("kind not supported");
                  } catch (pe) {
                    console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${pe}`), ie(pe);
                  }
                  S();
                });
              }
              getReadable() {
                return this.processor_.readable;
              }
              getWriteable() {
                return this.generator_.writable;
              }
              getProccesorTrack() {
                return this.generator_;
              }
            }
            class Ct {
              constructor(R) {
                h(this, "insertableStreamHelper_"), h(this, "mediaProcessor_"), this.insertableStreamHelper_ = new sn(), this.mediaProcessor_ = R;
              }
              setTrack(R) {
                return new n((S, ie) => {
                  this.insertableStreamHelper_.init(R).then(() => {
                    this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
                      S(this.insertableStreamHelper_.getProccesorTrack());
                    }).catch((pe) => {
                      ie(pe);
                    });
                  }).catch((pe) => {
                    ie(pe);
                  });
                });
              }
              destroy() {
                return new n((R, S) => {
                  this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
                    R();
                  }).catch((ie) => {
                    S(ie);
                  }) : S("no processor");
                });
              }
            }
            var cn = /* @__PURE__ */ ((E) => (E.Low = "Low", E.High = "High", E))(cn || {}), Hn = /* @__PURE__ */ ((E) => (E.BackgroundBlur = "BackgroundBlur", E.VirtualBackground = "VirtualBackground", E.VideoBackground = "VideoBackground", E.SilhouetteBlur = "SilhouetteBlur", E))(Hn || {}), Sr = /* @__PURE__ */ ((E) => (E.FAST = "FAST", E.PRECISE = "PRECISE", E))(Sr || {}), ao = /* @__PURE__ */ ((E) => (E.CANVAS = "CANVAS", E.WEBGL = "WEBGL", E))(ao || {});
            const wr = async () => WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));
            var Jr = function() {
              var E = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
              return function(R) {
                R = R || {};
                var S = typeof R < "u" ? R : {}, ie, pe;
                S.ready = new n(function(wn, jn) {
                  ie = wn, pe = jn;
                });
                var De = {}, ht;
                for (ht in S)
                  S.hasOwnProperty(ht) && (De[ht] = S[ht]);
                var rt = "./this.program", Nt = function(wn, jn) {
                  throw jn;
                }, Pn = !0, cr = "";
                function Vr(wn) {
                  return S.locateFile ? S.locateFile(wn, cr) : cr + wn;
                }
                var mi;
                typeof document < "u" && document.currentScript && (cr = document.currentScript.src), E && (cr = E), cr.indexOf("blob:") !== 0 ? cr = cr.substr(0, cr.replace(/[?#].*/, "").lastIndexOf("/") + 1) : cr = "";
                var Fi = S.print || console.log.bind(console), br = S.printErr || console.warn.bind(console);
                for (ht in De)
                  De.hasOwnProperty(ht) && (S[ht] = De[ht]);
                De = null, S.arguments && S.arguments, S.thisProgram && (rt = S.thisProgram), S.quit && (Nt = S.quit);
                var Nr;
                S.wasmBinary && (Nr = S.wasmBinary);
                var $i = S.noExitRuntime || !0;
                typeof WebAssembly != "object" && ta("no native wasm support detected");
                var qi, Vo = !1, Un = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
                function el(wn, jn, hr) {
                  for (var po = jn + hr, Po = jn; wn[Po] && !(Po >= po); )
                    ++Po;
                  if (Po - jn > 16 && wn.subarray && Un)
                    return Un.decode(wn.subarray(jn, Po));
                  for (var Yo = ""; jn < Po; ) {
                    var fi = wn[jn++];
                    if (!(fi & 128)) {
                      Yo += String.fromCharCode(fi);
                      continue;
                    }
                    var ra = wn[jn++] & 63;
                    if ((fi & 224) == 192) {
                      Yo += String.fromCharCode((fi & 31) << 6 | ra);
                      continue;
                    }
                    var ls = wn[jn++] & 63;
                    if ((fi & 240) == 224 ? fi = (fi & 15) << 12 | ra << 6 | ls : fi = (fi & 7) << 18 | ra << 12 | ls << 6 | wn[jn++] & 63, fi < 65536)
                      Yo += String.fromCharCode(fi);
                    else {
                      var xs = fi - 65536;
                      Yo += String.fromCharCode(55296 | xs >> 10, 56320 | xs & 1023);
                    }
                  }
                  return Yo;
                }
                function Ys(wn, jn) {
                  return wn ? el(Mr, wn, jn) : "";
                }
                function Ca(wn, jn, hr) {
                  for (var po = 0; po < wn.length; ++po)
                    Go[jn++ >> 0] = wn.charCodeAt(po);
                  Go[jn >> 0] = 0;
                }
                function lo(wn, jn) {
                  return wn % jn > 0 && (wn += jn - wn % jn), wn;
                }
                var Cc, Go, Mr, ml;
                function cd(wn) {
                  Cc = wn, S.HEAP8 = Go = new Int8Array(wn), S.HEAP16 = new Int16Array(wn), S.HEAP32 = ml = new Int32Array(wn), S.HEAPU8 = Mr = new Uint8Array(wn), S.HEAPU16 = new Uint16Array(wn), S.HEAPU32 = new Uint32Array(wn), S.HEAPF32 = new Float32Array(wn), S.HEAPF64 = new Float64Array(wn);
                }
                S.INITIAL_MEMORY;
                var Ma, Ji = [], ts = [], tl = [], Wl = 0;
                function Ac() {
                  return $i || Wl > 0;
                }
                function Hl() {
                  if (S.preRun)
                    for (typeof S.preRun == "function" && (S.preRun = [S.preRun]); S.preRun.length; )
                      vl(S.preRun.shift());
                  bo(Ji);
                }
                function Uc() {
                  bo(ts);
                }
                function dl() {
                  if (S.postRun)
                    for (typeof S.postRun == "function" && (S.postRun = [S.postRun]); S.postRun.length; )
                      gc(S.postRun.shift());
                  bo(tl);
                }
                function vl(wn) {
                  Ji.unshift(wn);
                }
                function Nc(wn) {
                  ts.unshift(wn);
                }
                function gc(wn) {
                  tl.unshift(wn);
                }
                var Js = 0, Is = null;
                function Pl(wn) {
                  Js++, S.monitorRunDependencies && S.monitorRunDependencies(Js);
                }
                function Nl(wn) {
                  if (Js--, S.monitorRunDependencies && S.monitorRunDependencies(Js), Js == 0 && Is) {
                    var jn = Is;
                    Is = null, jn();
                  }
                }
                S.preloadedImages = {}, S.preloadedAudios = {};
                function ta(wn) {
                  S.onAbort && S.onAbort(wn), wn = "Aborted(" + wn + ")", br(wn), Vo = !0, wn += ". Build with -s ASSERTIONS=1 for more info.";
                  var jn = new WebAssembly.RuntimeError(wn);
                  throw pe(jn), jn;
                }
                var $a = "data:application/octet-stream;base64,";
                function Gs(wn) {
                  return wn.startsWith($a);
                }
                var To;
                To = "tflite-simd.wasm", Gs(To) || (To = Vr(To));
                function Na(wn) {
                  try {
                    if (wn == To && Nr)
                      return new Uint8Array(Nr);
                    if (!mi)
                      throw "both async and sync fetching of the wasm failed";
                  } catch (jn) {
                    ta(jn);
                  }
                }
                function nl() {
                  return !Nr && Pn && typeof fetch == "function" ? fetch(To, { credentials: "same-origin" }).then(function(wn) {
                    if (!wn.ok)
                      throw "failed to load wasm binary file at '" + To + "'";
                    return wn.arrayBuffer();
                  }).catch(function() {
                    return Na(To);
                  }) : n.resolve().then(function() {
                    return Na(To);
                  });
                }
                function vs() {
                  var wn = { a: na };
                  function jn(fi, ra) {
                    var ls = fi.exports;
                    S.asm = ls, qi = S.asm.q, cd(qi.buffer), Ma = S.asm.E, Nc(S.asm.r), Nl();
                  }
                  Pl();
                  function hr(fi) {
                    jn(fi.instance);
                  }
                  function po(fi) {
                    return nl().then(function(ra) {
                      return WebAssembly.instantiate(ra, wn);
                    }).then(function(ra) {
                      return ra;
                    }).then(fi, function(ra) {
                      br("failed to asynchronously prepare wasm: " + ra), ta(ra);
                    });
                  }
                  function Po() {
                    return !Nr && typeof WebAssembly.instantiateStreaming == "function" && !Gs(To) && typeof fetch == "function" ? fetch(To, { credentials: "same-origin" }).then(function(fi) {
                      var ra = WebAssembly.instantiateStreaming(fi, wn);
                      return ra.then(hr, function(ls) {
                        return br("wasm streaming compile failed: " + ls), br("falling back to ArrayBuffer instantiation"), po(hr);
                      });
                    }) : po(hr);
                  }
                  if (S.instantiateWasm)
                    try {
                      var Yo = S.instantiateWasm(wn, jn);
                      return Yo;
                    } catch (fi) {
                      return br("Module.instantiateWasm callback failed with error: " + fi), !1;
                    }
                  return Po().catch(pe), {};
                }
                function bo(wn) {
                  for (; wn.length > 0; ) {
                    var jn = wn.shift();
                    if (typeof jn == "function") {
                      jn(S);
                      continue;
                    }
                    var hr = jn.func;
                    typeof hr == "number" ? jn.arg === void 0 ? Ma.get(hr)() : Ma.get(hr)(jn.arg) : hr(jn.arg === void 0 ? null : jn.arg);
                  }
                }
                function fa(wn, jn, hr, po) {
                  ta("Assertion failed: " + Ys(wn) + ", at: " + [jn ? Ys(jn) : "unknown filename", hr, po ? Ys(po) : "unknown function"]);
                }
                function ss(wn, jn) {
                  ta("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
                }
                function eo(wn, jn) {
                  ta("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
                }
                function Pa() {
                  ta("");
                }
                var Ao;
                Ao = function() {
                  return performance.now();
                };
                var ua = !0;
                function ns(wn) {
                  return ml[Wi() >> 2] = wn, wn;
                }
                function Ls(wn, jn) {
                  var hr;
                  if (wn === 0)
                    hr = Date.now();
                  else if ((wn === 1 || wn === 4) && ua)
                    hr = Ao();
                  else
                    return ns(28), -1;
                  return ml[jn >> 2] = hr / 1e3 | 0, ml[jn + 4 >> 2] = hr % 1e3 * 1e3 * 1e3 | 0, 0;
                }
                function Ua() {
                  return 2147483648;
                }
                function go(wn, jn, hr) {
                  Mr.copyWithin(wn, jn, jn + hr);
                }
                function Bs(wn) {
                  try {
                    return qi.grow(wn - Cc.byteLength + 65535 >>> 16), cd(qi.buffer), 1;
                  } catch {
                  }
                }
                function Ts(wn) {
                  var jn = Mr.length;
                  wn = wn >>> 0;
                  var hr = 2147483648;
                  if (wn > hr)
                    return !1;
                  for (var po = 1; po <= 4; po *= 2) {
                    var Po = jn * (1 + 0.2 / po);
                    Po = Math.min(Po, wn + 100663296);
                    var Yo = Math.min(hr, lo(Math.max(wn, Po), 65536)), fi = Bs(Yo);
                    if (fi)
                      return !0;
                  }
                  return !1;
                }
                function Oa(wn) {
                  for (var jn = Ao(); Ao() - jn < wn; )
                    ;
                }
                var Jl = {};
                function rl() {
                  return rt || "./this.program";
                }
                function Xs() {
                  if (!Xs.strings) {
                    var wn = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", jn = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: wn, _: rl() };
                    for (var hr in Jl)
                      Jl[hr] === void 0 ? delete jn[hr] : jn[hr] = Jl[hr];
                    var po = [];
                    for (var hr in jn)
                      po.push(hr + "=" + jn[hr]);
                    Xs.strings = po;
                  }
                  return Xs.strings;
                }
                var il = { mappings: {}, buffers: [null, [], []], printChar: function(wn, jn) {
                  var hr = il.buffers[wn];
                  jn === 0 || jn === 10 ? ((wn === 1 ? Fi : br)(el(hr, 0)), hr.length = 0) : hr.push(jn);
                }, varargs: void 0, get: function() {
                  il.varargs += 4;
                  var wn = ml[il.varargs - 4 >> 2];
                  return wn;
                }, getStr: function(wn) {
                  var jn = Ys(wn);
                  return jn;
                }, get64: function(wn, jn) {
                  return wn;
                } };
                function pa(wn, jn) {
                  var hr = 0;
                  return Xs().forEach(function(po, Po) {
                    var Yo = jn + hr;
                    ml[wn + Po * 4 >> 2] = Yo, Ca(po, Yo), hr += po.length + 1;
                  }), 0;
                }
                function rs(wn, jn) {
                  var hr = Xs();
                  ml[wn >> 2] = hr.length;
                  var po = 0;
                  return hr.forEach(function(Po) {
                    po += Po.length + 1;
                  }), ml[jn >> 2] = po, 0;
                }
                function ma(wn) {
                  So(wn);
                }
                function Xo(wn) {
                  return 0;
                }
                function ks(wn, jn, hr, po, Po) {
                }
                function Zo(wn, jn, hr, po) {
                  for (var Po = 0, Yo = 0; Yo < hr; Yo++) {
                    for (var fi = ml[jn + Yo * 8 >> 2], ra = ml[jn + (Yo * 8 + 4) >> 2], ls = 0; ls < ra; ls++)
                      il.printChar(wn, Mr[fi + ls]);
                    Po += ra;
                  }
                  return ml[po >> 2] = Po, 0;
                }
                function fo() {
                  if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") {
                    var wn = new Uint8Array(1);
                    return function() {
                      return crypto.getRandomValues(wn), wn[0];
                    };
                  } else
                    return function() {
                      ta("randomDevice");
                    };
                }
                function ul(wn, jn) {
                  ul.randomDevice || (ul.randomDevice = fo());
                  for (var hr = 0; hr < jn; hr++)
                    Go[wn + hr >> 0] = ul.randomDevice();
                  return 0;
                }
                var na = { a: fa, e: ss, d: eo, b: Pa, n: Ls, h: Ua, l: go, m: Ts, p: Oa, f: pa, g: rs, j: ma, i: Xo, k: ks, c: Zo, o: ul };
                vs(), S.___wasm_call_ctors = function() {
                  return (S.___wasm_call_ctors = S.asm.r).apply(null, arguments);
                }, S._getModelBufferMemoryOffset = function() {
                  return (S._getModelBufferMemoryOffset = S.asm.s).apply(null, arguments);
                }, S._getInputMemoryOffset = function() {
                  return (S._getInputMemoryOffset = S.asm.t).apply(null, arguments);
                }, S._getInputHeight = function() {
                  return (S._getInputHeight = S.asm.u).apply(null, arguments);
                }, S._getInputWidth = function() {
                  return (S._getInputWidth = S.asm.v).apply(null, arguments);
                }, S._getInputChannelCount = function() {
                  return (S._getInputChannelCount = S.asm.w).apply(null, arguments);
                }, S._getOutputMemoryOffset = function() {
                  return (S._getOutputMemoryOffset = S.asm.x).apply(null, arguments);
                }, S._getOutputHeight = function() {
                  return (S._getOutputHeight = S.asm.y).apply(null, arguments);
                }, S._getOutputWidth = function() {
                  return (S._getOutputWidth = S.asm.z).apply(null, arguments);
                }, S._getOutputChannelCount = function() {
                  return (S._getOutputChannelCount = S.asm.A).apply(null, arguments);
                }, S._loadModel = function() {
                  return (S._loadModel = S.asm.B).apply(null, arguments);
                }, S._runInference = function() {
                  return (S._runInference = S.asm.C).apply(null, arguments);
                }, S._isGPUEnabled = function() {
                  return (S._isGPUEnabled = S.asm.D).apply(null, arguments);
                };
                var Wi = S.___errno_location = function() {
                  return (Wi = S.___errno_location = S.asm.F).apply(null, arguments);
                }, li;
                function ko(wn) {
                  this.name = "ExitStatus", this.message = "Program terminated with exit(" + wn + ")", this.status = wn;
                }
                Is = function wn() {
                  li || is(), li || (Is = wn);
                };
                function is(wn) {
                  if (Js > 0 || (Hl(), Js > 0))
                    return;
                  function jn() {
                    li || (li = !0, S.calledRun = !0, !Vo && (Uc(), ie(S), S.onRuntimeInitialized && S.onRuntimeInitialized(), dl()));
                  }
                  S.setStatus ? (S.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                      S.setStatus("");
                    }, 1), jn();
                  }, 1)) : jn();
                }
                S.run = is;
                function So(wn, jn) {
                  wo(wn);
                }
                function wo(wn) {
                  Ac() || (S.onExit && S.onExit(wn), Vo = !0), Nt(wn, new ko(wn));
                }
                if (S.preInit)
                  for (typeof S.preInit == "function" && (S.preInit = [S.preInit]); S.preInit.length > 0; )
                    S.preInit.pop()();
                return is(), R.ready;
              };
            }();
            class Fn {
              constructor() {
                c(this, "selectedTFLite"), c(this, "isSIMDSupported", !1), c(this, "isThreadsSupported", !1), c(this, "inputWidth", 0), c(this, "inputHeight", 0), c(this, "inputChannelCount", 0), c(this, "inputMemoryOffset", 0), c(this, "outputWidth", 0), c(this, "outputHeight", 0), c(this, "outputChannelCount", 0), c(this, "outputMemoryOffset", 0);
              }
            }
            const Ia = "https://d3opqjmqzxf057.cloudfront.net/vonage-tensorflow-wasm/tflite-simd-wasm/1.1.3/", wt = "https://d3opqjmqzxf057.cloudfront.net/ml/selfie_segmentation/4.0.0/";
            async function Yn(E = Ia, R = wt) {
              let S = new Fn();
              var ie = new n(function(pe, De) {
                async function ht() {
                  return Jr({
                    locateFile: function(Nt) {
                      return E + Nt;
                    }
                  });
                }
                async function rt(Nt) {
                  return new n(async (Pn, cr) => {
                    const Vr = Nt;
                    if (typeof Vr > "u")
                      return cr("TFLite backend unavailable: wasmSimd");
                    const mi = "selfie_segmentation_landscape";
                    console.log("Loading tflite model:", mi);
                    let Fi = R + `${mi}.tflite`;
                    console.log("TFLite modelUrl: " + Fi);
                    try {
                      const br = await (await fetch(Fi)).arrayBuffer();
                      console.log("Model buffer size:", br.byteLength);
                      const Nr = Vr._getModelBufferMemoryOffset();
                      console.log(
                        "Model buffer memory offset:",
                        Nr
                      ), console.log("Loading model buffer..."), Vr.HEAPU8.set(
                        new Uint8Array(br),
                        Nr
                      );
                      const $i = Vr._loadModel(
                        br.byteLength
                      );
                      if (console.log("Load model result:", $i), $i !== 0) {
                        cr("Cannot load model");
                        return;
                      }
                      S.inputWidth = Vr._getInputWidth(), S.inputHeight = Vr._getInputHeight(), S.inputChannelCount = Vr._getInputChannelCount(), S.inputMemoryOffset = Vr._getInputMemoryOffset(), console.log(
                        "Input memory offset:",
                        S.inputMemoryOffset
                      ), console.log("Input height:", S.inputHeight), console.log("Input width:", S.inputWidth), console.log(
                        "Input channels:",
                        S.inputChannelCount
                      ), S.outputMemoryOffset = Vr._getOutputMemoryOffset(), S.outputWidth = Vr._getOutputWidth(), S.outputHeight = Vr._getOutputHeight(), S.outputChannelCount = Vr._getOutputChannelCount(), console.log(
                        "Output memory offset:",
                        S.outputMemoryOffset
                      ), console.log("Output height:", S.outputHeight), console.log("Output width:", S.outputWidth), console.log(
                        "Output channels:",
                        S.outputChannelCount
                      ), S.selectedTFLite = Vr;
                    } catch (br) {
                      cr(br);
                      return;
                    }
                    Pn();
                  });
                }
                ht().then((Nt) => {
                  if (Nt === null)
                    throw console.error("loadTFLite null"), "loadTFLite null";
                  rt(Nt).then((Pn) => {
                    pe(S);
                  }).catch((Pn) => {
                    console.error("loadTFLiteModel error"), De("loadTFLiteModel error");
                  });
                }).catch((Nt) => {
                  console.error("loadTFLite error:", Nt), De("loadTFLite error:" + Nt);
                });
              });
              return ie;
            }
            class kr {
              constructor() {
                c(this, "canvas", new OffscreenCanvas(0, 0)), c(this, "context", this.canvas.getContext(
                  "2d",
                  {
                    willReadFrequently: !0
                  }
                )), c(this, "pixelCount", 0), c(this, "inputOffset", 0), c(this, "outputOffset", 0), c(this, "infos"), c(this, "mask");
              }
              async init(R, S) {
                await this.initWasm(R, S), this.infos && (this.canvas.width = this.infos.inputWidth, this.canvas.height = this.infos.inputHeight, this.pixelCount = this.infos.inputWidth * this.infos.inputHeight, this.mask = new ImageData(
                  this.infos.inputWidth,
                  this.infos.inputHeight
                ), this.inputOffset = this.infos.inputMemoryOffset / 4, this.outputOffset = this.infos.outputMemoryOffset / 4);
              }
              async initWasm(R, S) {
                this.infos = await Yn(
                  R,
                  S
                );
              }
              getOutputDimensions() {
                var R, S, ie, pe;
                return {
                  width: (S = (R = this.infos) == null ? void 0 : R.outputWidth) != null ? S : 0,
                  height: (pe = (ie = this.infos) == null ? void 0 : ie.outputHeight) != null ? pe : 0
                };
              }
              async process(R) {
                if (!this.mask || !this.infos)
                  return;
                const S = this.infos.inputWidth, ie = this.infos.inputHeight;
                this.context.drawImage(
                  R,
                  0,
                  0,
                  R.width,
                  R.height,
                  0,
                  0,
                  S,
                  ie
                );
                const pe = this.context.getImageData(0, 0, S, ie), De = this.infos.selectedTFLite.HEAPF32;
                for (let ht = 0; ht < this.pixelCount; ht++) {
                  const rt = this.inputOffset + ht * 3;
                  De[rt] = pe.data[ht * 4] / 255, De[rt + 1] = pe.data[ht * 4 + 1] / 255, De[rt + 2] = pe.data[ht * 4 + 2] / 255;
                }
                this.infos.selectedTFLite._runInference();
                for (let ht = 0; ht < this.pixelCount; ht++) {
                  const rt = this.infos.selectedTFLite.HEAPF32[this.outputOffset + ht];
                  this.mask.data[ht * 4] = this.mask.data[ht * 4 + 3] = 255 * rt;
                }
                return createImageBitmap(this.mask);
              }
              isGpuSupported() {
                var R, S, ie;
                return (ie = (S = (R = this.infos) == null ? void 0 : R.selectedTFLite) == null ? void 0 : S._isGPUEnabled()) != null ? ie : !1;
              }
            }
            async function mr(E, R) {
              const { wasm: S, insertableStreams: ie, simd: pe, webgl: De } = await yi(E, R);
              if (!S.supported)
                throw S.message;
              if (!ie.supported)
                throw ie.message;
              if (!pe.supported)
                throw pe.message;
              if (!De.supported)
                throw De.message;
            }
            async function yi(E, R) {
              const S = new kr();
              await S.initWasm(E, R);
              const ie = {
                wasm: {
                  supported: typeof WebAssembly == "object" && typeof WebAssembly.instantiate == "function",
                  message: "Your browser does not support WebAssembly features."
                },
                simd: {
                  supported: await wr(),
                  message: "Your browser does not support simd features."
                },
                insertableStreams: { supported: !0 },
                gpu: {
                  supported: S.isGpuSupported(),
                  message: "Your browser does not support gpu features."
                },
                webgl: Or(),
                performance: Ei()
              };
              try {
                await A();
              } catch (pe) {
                ie.insertableStreams.supported = !1, ie.insertableStreams.message = pe;
              }
              return ie;
            }
            function Or() {
              return OffscreenCanvas ? new OffscreenCanvas(0, 0).getContext("webgl2") ? { supported: !0 } : {
                supported: !1,
                message: "Your browser does not support webgl 2"
              } : {
                supported: !1,
                message: "Your browser does not support offscreen canvas"
              };
            }
            function Ei() {
              return new OffscreenCanvas(0, 0).getContext("webgl2", {
                failIfMajorPerformanceCaveat: !0
              }) ? { supported: !0 } : {
                supported: !1,
                message: "Your hardware does not perform good enough to run the library efficiently"
              };
            }
            const Rt = {};
            (function() {
              var E;
              function R(le) {
                var Ie = 0;
                return function() {
                  return Ie < le.length ? { done: !1, value: le[Ie++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(le, Ie, Ze) {
                return le == Array.prototype || le == Object.prototype || (le[Ie] = Ze.value), le;
              };
              function ie(le) {
                le = [typeof globalThis == "object" && globalThis, le, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var Ie = 0; Ie < le.length; ++Ie) {
                  var Ze = le[Ie];
                  if (Ze && Ze.Math == Math)
                    return Ze;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(le, Ie) {
                if (Ie)
                  e: {
                    var Ze = pe;
                    le = le.split(".");
                    for (var Mt = 0; Mt < le.length - 1; Mt++) {
                      var yn = le[Mt];
                      if (!(yn in Ze))
                        break e;
                      Ze = Ze[yn];
                    }
                    le = le[le.length - 1], Mt = Ze[le], Ie = Ie(Mt), Ie != Mt && Ie != null && S(Ze, le, { configurable: !0, writable: !0, value: Ie });
                  }
              }
              De("Symbol", function(le) {
                function Ie(nr) {
                  if (this instanceof Ie)
                    throw new TypeError("Symbol is not a constructor");
                  return new Ze(Mt + (nr || "") + "_" + yn++, nr);
                }
                function Ze(nr, mn) {
                  this.g = nr, S(this, "description", { configurable: !0, writable: !0, value: mn });
                }
                if (le)
                  return le;
                Ze.prototype.toString = function() {
                  return this.g;
                };
                var Mt = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", yn = 0;
                return Ie;
              }), De("Symbol.iterator", function(le) {
                if (le)
                  return le;
                le = Symbol("Symbol.iterator");
                for (var Ie = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), Ze = 0; Ze < Ie.length; Ze++) {
                  var Mt = pe[Ie[Ze]];
                  typeof Mt == "function" && typeof Mt.prototype[le] != "function" && S(Mt.prototype, le, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return le;
              });
              function ht(le) {
                return le = { next: le }, le[Symbol.iterator] = function() {
                  return this;
                }, le;
              }
              function rt(le) {
                var Ie = typeof Symbol < "u" && Symbol.iterator && le[Symbol.iterator];
                return Ie ? Ie.call(le) : { next: R(le) };
              }
              function Nt(le) {
                if (!(le instanceof Array)) {
                  le = rt(le);
                  for (var Ie, Ze = []; !(Ie = le.next()).done; )
                    Ze.push(Ie.value);
                  le = Ze;
                }
                return le;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(le) {
                function Ie() {
                }
                return Ie.prototype = le, new Ie();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(le, Ie) {
                  if (le.__proto__ = Ie, le.__proto__ !== Ie)
                    throw new TypeError(le + " is not extensible");
                  return le;
                } : null;
              }
              var br = cr;
              function Nr(le, Ie) {
                if (le.prototype = Pn(Ie.prototype), le.prototype.constructor = le, br)
                  br(le, Ie);
                else
                  for (var Ze in Ie)
                    if (Ze != "prototype")
                      if (Object.defineProperties) {
                        var Mt = Object.getOwnPropertyDescriptor(Ie, Ze);
                        Mt && Object.defineProperty(le, Ze, Mt);
                      } else
                        le[Ze] = Ie[Ze];
                le.ea = Ie.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
              }
              function qi(le) {
                if (le.l)
                  throw new TypeError("Generator is already running");
                le.l = !0;
              }
              $i.prototype.o = function(le) {
                this.h = le;
              };
              function Vo(le, Ie) {
                le.j = { U: Ie, V: !0 }, le.g = le.m || le.s;
              }
              $i.prototype.return = function(le) {
                this.j = { return: le }, this.g = this.s;
              };
              function Un(le, Ie, Ze) {
                return le.g = Ze, { value: Ie };
              }
              function el(le) {
                this.g = new $i(), this.h = le;
              }
              function Ys(le, Ie) {
                qi(le.g);
                var Ze = le.g.i;
                return Ze ? Ca(le, "return" in Ze ? Ze.return : function(Mt) {
                  return { value: Mt, done: !0 };
                }, Ie, le.g.return) : (le.g.return(Ie), lo(le));
              }
              function Ca(le, Ie, Ze, Mt) {
                try {
                  var yn = Ie.call(le.g.i, Ze);
                  if (!(yn instanceof Object))
                    throw new TypeError("Iterator result " + yn + " is not an object");
                  if (!yn.done)
                    return le.g.l = !1, yn;
                  var nr = yn.value;
                } catch (mn) {
                  return le.g.i = null, Vo(le.g, mn), lo(le);
                }
                return le.g.i = null, Mt.call(le.g, nr), lo(le);
              }
              function lo(le) {
                for (; le.g.g; )
                  try {
                    var Ie = le.h(le.g);
                    if (Ie)
                      return le.g.l = !1, { value: Ie.value, done: !1 };
                  } catch (Ze) {
                    le.g.h = void 0, Vo(le.g, Ze);
                  }
                if (le.g.l = !1, le.g.j) {
                  if (Ie = le.g.j, le.g.j = null, Ie.V)
                    throw Ie.U;
                  return { value: Ie.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(le) {
                this.next = function(Ie) {
                  return qi(le.g), le.g.i ? Ie = Ca(le, le.g.i.next, Ie, le.g.o) : (le.g.o(Ie), Ie = lo(le)), Ie;
                }, this.throw = function(Ie) {
                  return qi(le.g), le.g.i ? Ie = Ca(le, le.g.i.throw, Ie, le.g.o) : (Vo(le.g, Ie), Ie = lo(le)), Ie;
                }, this.return = function(Ie) {
                  return Ys(le, Ie);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(le, Ie) {
                return Ie = new Cc(new el(Ie)), br && le.prototype && br(Ie, le.prototype), Ie;
              }
              function Mr(le, Ie) {
                le instanceof String && (le += "");
                var Ze = 0, Mt = !1, yn = { next: function() {
                  if (!Mt && Ze < le.length) {
                    var nr = Ze++;
                    return { value: Ie(nr, le[nr]), done: !1 };
                  }
                  return Mt = !0, { done: !0, value: void 0 };
                } };
                return yn[Symbol.iterator] = function() {
                  return yn;
                }, yn;
              }
              var ml = typeof Object.assign == "function" ? Object.assign : function(le, Ie) {
                for (var Ze = 1; Ze < arguments.length; Ze++) {
                  var Mt = arguments[Ze];
                  if (Mt)
                    for (var yn in Mt)
                      Object.prototype.hasOwnProperty.call(Mt, yn) && (le[yn] = Mt[yn]);
                }
                return le;
              };
              De("Object.assign", function(le) {
                return le || ml;
              }), De("Promise", function(le) {
                function Ie(mn) {
                  this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                  var zn = this.j();
                  try {
                    mn(zn.resolve, zn.reject);
                  } catch (Wr) {
                    zn.reject(Wr);
                  }
                }
                function Ze() {
                  this.g = null;
                }
                function Mt(mn) {
                  return mn instanceof Ie ? mn : new Ie(function(zn) {
                    zn(mn);
                  });
                }
                if (le)
                  return le;
                Ze.prototype.h = function(mn) {
                  if (this.g == null) {
                    this.g = [];
                    var zn = this;
                    this.i(function() {
                      zn.l();
                    });
                  }
                  this.g.push(mn);
                };
                var yn = pe.setTimeout;
                Ze.prototype.i = function(mn) {
                  yn(mn, 0);
                }, Ze.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var mn = this.g;
                    this.g = [];
                    for (var zn = 0; zn < mn.length; ++zn) {
                      var Wr = mn[zn];
                      mn[zn] = null;
                      try {
                        Wr();
                      } catch (ci) {
                        this.j(ci);
                      }
                    }
                  }
                  this.g = null;
                }, Ze.prototype.j = function(mn) {
                  this.i(function() {
                    throw mn;
                  });
                }, Ie.prototype.j = function() {
                  function mn(ci) {
                    return function(Ki) {
                      Wr || (Wr = !0, ci.call(zn, Ki));
                    };
                  }
                  var zn = this, Wr = !1;
                  return { resolve: mn(this.C), reject: mn(this.l) };
                }, Ie.prototype.C = function(mn) {
                  if (mn === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (mn instanceof Ie)
                    this.F(mn);
                  else {
                    e:
                      switch (typeof mn) {
                        case "object":
                          var zn = mn != null;
                          break e;
                        case "function":
                          zn = !0;
                          break e;
                        default:
                          zn = !1;
                      }
                    zn ? this.u(mn) : this.m(mn);
                  }
                }, Ie.prototype.u = function(mn) {
                  var zn = void 0;
                  try {
                    zn = mn.then;
                  } catch (Wr) {
                    this.l(Wr);
                    return;
                  }
                  typeof zn == "function" ? this.G(zn, mn) : this.m(mn);
                }, Ie.prototype.l = function(mn) {
                  this.s(2, mn);
                }, Ie.prototype.m = function(mn) {
                  this.s(1, mn);
                }, Ie.prototype.s = function(mn, zn) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + mn + ", " + zn + "): Promise already settled in state" + this.h);
                  this.h = mn, this.i = zn, this.h === 2 && this.D(), this.A();
                }, Ie.prototype.D = function() {
                  var mn = this;
                  yn(function() {
                    if (mn.B()) {
                      var zn = pe.console;
                      typeof zn < "u" && zn.error(mn.i);
                    }
                  }, 1);
                }, Ie.prototype.B = function() {
                  if (this.o)
                    return !1;
                  var mn = pe.CustomEvent, zn = pe.Event, Wr = pe.dispatchEvent;
                  return typeof Wr > "u" ? !0 : (typeof mn == "function" ? mn = new mn("unhandledrejection", { cancelable: !0 }) : typeof zn == "function" ? mn = new zn("unhandledrejection", { cancelable: !0 }) : (mn = pe.document.createEvent("CustomEvent"), mn.initCustomEvent("unhandledrejection", !1, !0, mn)), mn.promise = this, mn.reason = this.i, Wr(mn));
                }, Ie.prototype.A = function() {
                  if (this.g != null) {
                    for (var mn = 0; mn < this.g.length; ++mn)
                      nr.h(this.g[mn]);
                    this.g = null;
                  }
                };
                var nr = new Ze();
                return Ie.prototype.F = function(mn) {
                  var zn = this.j();
                  mn.J(zn.resolve, zn.reject);
                }, Ie.prototype.G = function(mn, zn) {
                  var Wr = this.j();
                  try {
                    mn.call(zn, Wr.resolve, Wr.reject);
                  } catch (ci) {
                    Wr.reject(ci);
                  }
                }, Ie.prototype.then = function(mn, zn) {
                  function Wr(yo, Xi) {
                    return typeof yo == "function" ? function(vi) {
                      try {
                        ci(yo(vi));
                      } catch (Yi) {
                        Ki(Yi);
                      }
                    } : Xi;
                  }
                  var ci, Ki, Gi = new Ie(function(yo, Xi) {
                    ci = yo, Ki = Xi;
                  });
                  return this.J(Wr(mn, ci), Wr(zn, Ki)), Gi;
                }, Ie.prototype.catch = function(mn) {
                  return this.then(void 0, mn);
                }, Ie.prototype.J = function(mn, zn) {
                  function Wr() {
                    switch (ci.h) {
                      case 1:
                        mn(ci.i);
                        break;
                      case 2:
                        zn(ci.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + ci.h);
                    }
                  }
                  var ci = this;
                  this.g == null ? nr.h(Wr) : this.g.push(Wr), this.o = !0;
                }, Ie.resolve = Mt, Ie.reject = function(mn) {
                  return new Ie(function(zn, Wr) {
                    Wr(mn);
                  });
                }, Ie.race = function(mn) {
                  return new Ie(function(zn, Wr) {
                    for (var ci = rt(mn), Ki = ci.next(); !Ki.done; Ki = ci.next())
                      Mt(Ki.value).J(zn, Wr);
                  });
                }, Ie.all = function(mn) {
                  var zn = rt(mn), Wr = zn.next();
                  return Wr.done ? Mt([]) : new Ie(function(ci, Ki) {
                    function Gi(vi) {
                      return function(Yi) {
                        yo[vi] = Yi, Xi--, Xi == 0 && ci(yo);
                      };
                    }
                    var yo = [], Xi = 0;
                    do
                      yo.push(void 0), Xi++, Mt(Wr.value).J(Gi(yo.length - 1), Ki), Wr = zn.next();
                    while (!Wr.done);
                  });
                }, Ie;
              }), De("Object.is", function(le) {
                return le || function(Ie, Ze) {
                  return Ie === Ze ? Ie !== 0 || 1 / Ie === 1 / Ze : Ie !== Ie && Ze !== Ze;
                };
              }), De("Array.prototype.includes", function(le) {
                return le || function(Ie, Ze) {
                  var Mt = this;
                  Mt instanceof String && (Mt = String(Mt));
                  var yn = Mt.length;
                  for (Ze = Ze || 0, 0 > Ze && (Ze = Math.max(Ze + yn, 0)); Ze < yn; Ze++) {
                    var nr = Mt[Ze];
                    if (nr === Ie || Object.is(nr, Ie))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(le) {
                return le || function(Ie, Ze) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (Ie instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(Ie, Ze || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(le) {
                return le || function() {
                  return Mr(this, function(Ie) {
                    return Ie;
                  });
                };
              });
              var cd = this || self;
              function Ma(le, Ie) {
                le = le.split(".");
                var Ze = cd;
                le[0] in Ze || typeof Ze.execScript > "u" || Ze.execScript("var " + le[0]);
                for (var Mt; le.length && (Mt = le.shift()); )
                  le.length || Ie === void 0 ? Ze[Mt] && Ze[Mt] !== Object.prototype[Mt] ? Ze = Ze[Mt] : Ze = Ze[Mt] = {} : Ze[Mt] = Ie;
              }
              function Ji(le, Ie) {
                return Ie = String.fromCharCode.apply(null, Ie), le == null ? Ie : le + Ie;
              }
              var ts, tl = typeof TextDecoder < "u", Wl, Ac = typeof TextEncoder < "u";
              function Hl(le) {
                if (Ac)
                  le = (Wl || (Wl = new TextEncoder())).encode(le);
                else {
                  var Ie = void 0;
                  Ie = Ie === void 0 ? !1 : Ie;
                  for (var Ze = 0, Mt = new Uint8Array(3 * le.length), yn = 0; yn < le.length; yn++) {
                    var nr = le.charCodeAt(yn);
                    if (128 > nr)
                      Mt[Ze++] = nr;
                    else {
                      if (2048 > nr)
                        Mt[Ze++] = nr >> 6 | 192;
                      else {
                        if (55296 <= nr && 57343 >= nr) {
                          if (56319 >= nr && yn < le.length) {
                            var mn = le.charCodeAt(++yn);
                            if (56320 <= mn && 57343 >= mn) {
                              nr = 1024 * (nr - 55296) + mn - 56320 + 65536, Mt[Ze++] = nr >> 18 | 240, Mt[Ze++] = nr >> 12 & 63 | 128, Mt[Ze++] = nr >> 6 & 63 | 128, Mt[Ze++] = nr & 63 | 128;
                              continue;
                            } else
                              yn--;
                          }
                          if (Ie)
                            throw Error("Found an unpaired surrogate");
                          nr = 65533;
                        }
                        Mt[Ze++] = nr >> 12 | 224, Mt[Ze++] = nr >> 6 & 63 | 128;
                      }
                      Mt[Ze++] = nr & 63 | 128;
                    }
                  }
                  le = Mt.subarray(0, Ze);
                }
                return le;
              }
              var Uc = {}, dl = null;
              function vl(le, Ie) {
                Ie === void 0 && (Ie = 0), Js(), Ie = Uc[Ie];
                for (var Ze = Array(Math.floor(le.length / 3)), Mt = Ie[64] || "", yn = 0, nr = 0; yn < le.length - 2; yn += 3) {
                  var mn = le[yn], zn = le[yn + 1], Wr = le[yn + 2], ci = Ie[mn >> 2];
                  mn = Ie[(mn & 3) << 4 | zn >> 4], zn = Ie[(zn & 15) << 2 | Wr >> 6], Wr = Ie[Wr & 63], Ze[nr++] = ci + mn + zn + Wr;
                }
                switch (ci = 0, Wr = Mt, le.length - yn) {
                  case 2:
                    ci = le[yn + 1], Wr = Ie[(ci & 15) << 2] || Mt;
                  case 1:
                    le = le[yn], Ze[nr] = Ie[le >> 2] + Ie[(le & 3) << 4 | ci >> 4] + Wr + Mt;
                }
                return Ze.join("");
              }
              function Nc(le) {
                var Ie = le.length, Ze = 3 * Ie / 4;
                Ze % 3 ? Ze = Math.floor(Ze) : "=.".indexOf(le[Ie - 1]) != -1 && (Ze = "=.".indexOf(le[Ie - 2]) != -1 ? Ze - 2 : Ze - 1);
                var Mt = new Uint8Array(Ze), yn = 0;
                return gc(le, function(nr) {
                  Mt[yn++] = nr;
                }), Mt.subarray(0, yn);
              }
              function gc(le, Ie) {
                function Ze(Wr) {
                  for (; Mt < le.length; ) {
                    var ci = le.charAt(Mt++), Ki = dl[ci];
                    if (Ki != null)
                      return Ki;
                    if (!/^[\s\xa0]*$/.test(ci))
                      throw Error("Unknown base64 encoding at char: " + ci);
                  }
                  return Wr;
                }
                Js();
                for (var Mt = 0; ; ) {
                  var yn = Ze(-1), nr = Ze(0), mn = Ze(64), zn = Ze(64);
                  if (zn === 64 && yn === -1)
                    break;
                  Ie(yn << 2 | nr >> 4), mn != 64 && (Ie(nr << 4 & 240 | mn >> 2), zn != 64 && Ie(mn << 6 & 192 | zn));
                }
              }
              function Js() {
                if (!dl) {
                  dl = {};
                  for (var le = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), Ie = ["+/=", "+/", "-_=", "-_.", "-_"], Ze = 0; 5 > Ze; Ze++) {
                    var Mt = le.concat(Ie[Ze].split(""));
                    Uc[Ze] = Mt;
                    for (var yn = 0; yn < Mt.length; yn++) {
                      var nr = Mt[yn];
                      dl[nr] === void 0 && (dl[nr] = yn);
                    }
                  }
                }
              }
              var Is = typeof Uint8Array.prototype.slice == "function", Pl;
              function Nl(le, Ie, Ze) {
                return Ie === Ze ? Pl || (Pl = new Uint8Array(0)) : Is ? le.slice(Ie, Ze) : new Uint8Array(le.subarray(Ie, Ze));
              }
              var ta = 0, $a = 0;
              function Gs(le, Ie) {
                Ie = Ie === void 0 ? {} : Ie, Ie = Ie.v === void 0 ? !1 : Ie.v, this.h = null, this.g = this.i = this.j = 0, this.l = !1, this.v = Ie, le && To(this, le);
              }
              function To(le, Ie) {
                Ie = Ie.constructor === Uint8Array ? Ie : Ie.constructor === ArrayBuffer ? new Uint8Array(Ie) : Ie.constructor === Array ? new Uint8Array(Ie) : Ie.constructor === String ? Nc(Ie) : Ie instanceof Uint8Array ? new Uint8Array(Ie.buffer, Ie.byteOffset, Ie.byteLength) : new Uint8Array(0), le.h = Ie, le.j = 0, le.i = le.h.length, le.g = le.j;
              }
              Gs.prototype.reset = function() {
                this.g = this.j;
              };
              function Na(le) {
                var Ie = le.h, Ze = Ie[le.g], Mt = Ze & 127;
                return 128 > Ze ? (le.g += 1, Mt) : (Ze = Ie[le.g + 1], Mt |= (Ze & 127) << 7, 128 > Ze ? (le.g += 2, Mt) : (Ze = Ie[le.g + 2], Mt |= (Ze & 127) << 14, 128 > Ze ? (le.g += 3, Mt) : (Ze = Ie[le.g + 3], Mt |= (Ze & 127) << 21, 128 > Ze ? (le.g += 4, Mt) : (Ze = Ie[le.g + 4], Mt |= (Ze & 15) << 28, 128 > Ze ? (le.g += 5, Mt >>> 0) : (le.g += 5, 128 <= Ie[le.g++] && 128 <= Ie[le.g++] && 128 <= Ie[le.g++] && 128 <= Ie[le.g++] && le.g++, Mt)))));
              }
              function nl(le) {
                var Ie = le.h[le.g], Ze = le.h[le.g + 1], Mt = le.h[le.g + 2], yn = le.h[le.g + 3];
                return le.g += 4, Ze = (Ie << 0 | Ze << 8 | Mt << 16 | yn << 24) >>> 0, le = 2 * (Ze >> 31) + 1, Ie = Ze >>> 23 & 255, Ze &= 8388607, Ie == 255 ? Ze ? NaN : 1 / 0 * le : Ie == 0 ? le * Math.pow(2, -149) * Ze : le * Math.pow(2, Ie - 150) * (Ze + Math.pow(2, 23));
              }
              var vs = [];
              function bo() {
                this.g = new Uint8Array(64), this.h = 0;
              }
              bo.prototype.push = function(le) {
                if (!(this.h + 1 < this.g.length)) {
                  var Ie = this.g;
                  this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length)), this.g.set(Ie);
                }
                this.g[this.h++] = le;
              }, bo.prototype.length = function() {
                return this.h;
              }, bo.prototype.end = function() {
                var le = this.g, Ie = this.h;
                return this.h = 0, Nl(le, 0, Ie);
              };
              function fa(le, Ie) {
                for (; 127 < Ie; )
                  le.push(Ie & 127 | 128), Ie >>>= 7;
                le.push(Ie);
              }
              function ss(le) {
                var Ie = {}, Ze = Ie.N === void 0 ? !1 : Ie.N;
                this.o = { v: Ie.v === void 0 ? !1 : Ie.v }, this.N = Ze, Ie = this.o, vs.length ? (Ze = vs.pop(), Ie && (Ze.v = Ie.v), le && To(Ze, le), le = Ze) : le = new Gs(le, Ie), this.g = le, this.m = this.g.g, this.h = this.i = this.l = -1, this.j = !1;
              }
              ss.prototype.reset = function() {
                this.g.reset(), this.h = this.l = -1;
              };
              function eo(le) {
                var Ie = le.g;
                if ((Ie = Ie.g == Ie.i) || (Ie = le.j) || (Ie = le.g, Ie = Ie.l || 0 > Ie.g || Ie.g > Ie.i), Ie)
                  return !1;
                le.m = le.g.g, Ie = Na(le.g);
                var Ze = Ie & 7;
                return Ze != 0 && Ze != 5 && Ze != 1 && Ze != 2 && Ze != 3 && Ze != 4 ? (le.j = !0, !1) : (le.i = Ie, le.l = Ie >>> 3, le.h = Ze, !0);
              }
              function Pa(le) {
                switch (le.h) {
                  case 0:
                    if (le.h != 0)
                      Pa(le);
                    else {
                      for (le = le.g; le.h[le.g] & 128; )
                        le.g++;
                      le.g++;
                    }
                    break;
                  case 1:
                    le.h != 1 ? Pa(le) : (le = le.g, le.g += 8);
                    break;
                  case 2:
                    if (le.h != 2)
                      Pa(le);
                    else {
                      var Ie = Na(le.g);
                      le = le.g, le.g += Ie;
                    }
                    break;
                  case 5:
                    le.h != 5 ? Pa(le) : (le = le.g, le.g += 4);
                    break;
                  case 3:
                    Ie = le.l;
                    do {
                      if (!eo(le)) {
                        le.j = !0;
                        break;
                      }
                      if (le.h == 4) {
                        le.l != Ie && (le.j = !0);
                        break;
                      }
                      Pa(le);
                    } while (!0);
                    break;
                  default:
                    le.j = !0;
                }
              }
              function Ao(le, Ie, Ze) {
                var Mt = le.g.i, yn = Na(le.g);
                return yn = le.g.g + yn, le.g.i = yn, Ze(Ie, le), le.g.g = yn, le.g.i = Mt, Ie;
              }
              function ua(le) {
                var Ie = Na(le.g);
                le = le.g;
                var Ze = le.g;
                le.g += Ie, le = le.h;
                var Mt;
                if (tl)
                  (Mt = ts) || (Mt = ts = new TextDecoder("utf-8", { fatal: !1 })), Mt = Mt.decode(le.subarray(Ze, Ze + Ie));
                else {
                  Ie = Ze + Ie;
                  for (var yn = [], nr = null, mn, zn, Wr; Ze < Ie; )
                    mn = le[Ze++], 128 > mn ? yn.push(mn) : 224 > mn ? Ze >= Ie ? yn.push(65533) : (zn = le[Ze++], 194 > mn || (zn & 192) !== 128 ? (Ze--, yn.push(65533)) : yn.push((mn & 31) << 6 | zn & 63)) : 240 > mn ? Ze >= Ie - 1 ? yn.push(65533) : (zn = le[Ze++], (zn & 192) !== 128 || mn === 224 && 160 > zn || mn === 237 && 160 <= zn || ((Mt = le[Ze++]) & 192) !== 128 ? (Ze--, yn.push(65533)) : yn.push((mn & 15) << 12 | (zn & 63) << 6 | Mt & 63)) : 244 >= mn ? Ze >= Ie - 2 ? yn.push(65533) : (zn = le[Ze++], (zn & 192) !== 128 || (mn << 28) + (zn - 144) >> 30 || ((Mt = le[Ze++]) & 192) !== 128 || ((Wr = le[Ze++]) & 192) !== 128 ? (Ze--, yn.push(65533)) : (mn = (mn & 7) << 18 | (zn & 63) << 12 | (Mt & 63) << 6 | Wr & 63, mn -= 65536, yn.push((mn >> 10 & 1023) + 55296, (mn & 1023) + 56320))) : yn.push(65533), 8192 <= yn.length && (nr = Ji(nr, yn), yn.length = 0);
                  Mt = Ji(nr, yn);
                }
                return Mt;
              }
              function ns() {
                this.h = [], this.i = 0, this.g = new bo();
              }
              function Ls(le, Ie) {
                Ie.length !== 0 && (le.h.push(Ie), le.i += Ie.length);
              }
              function Ua(le) {
                var Ie = le.i + le.g.length();
                if (Ie === 0)
                  return new Uint8Array(0);
                Ie = new Uint8Array(Ie);
                for (var Ze = le.h, Mt = Ze.length, yn = 0, nr = 0; nr < Mt; nr++) {
                  var mn = Ze[nr];
                  mn.length !== 0 && (Ie.set(mn, yn), yn += mn.length);
                }
                return Ze = le.g, Mt = Ze.h, Mt !== 0 && (Ie.set(Ze.g.subarray(0, Mt), yn), Ze.h = 0), le.h = [Ie], Ie;
              }
              function go(le, Ie, Ze) {
                if (Ze != null) {
                  fa(le.g, 8 * Ie + 5), le = le.g;
                  var Mt = Ze;
                  Mt = (Ze = 0 > Mt ? 1 : 0) ? -Mt : Mt, Mt === 0 ? 0 < 1 / Mt ? ta = $a = 0 : ($a = 0, ta = 2147483648) : isNaN(Mt) ? ($a = 0, ta = 2147483647) : 34028234663852886e22 < Mt ? ($a = 0, ta = (Ze << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > Mt ? (Mt = Math.round(Mt / Math.pow(2, -149)), $a = 0, ta = (Ze << 31 | Mt) >>> 0) : (Ie = Math.floor(Math.log(Mt) / Math.LN2), Mt *= Math.pow(2, -Ie), Mt = Math.round(8388608 * Mt) & 8388607, $a = 0, ta = (Ze << 31 | Ie + 127 << 23 | Mt) >>> 0), Ze = ta, le.push(Ze >>> 0 & 255), le.push(Ze >>> 8 & 255), le.push(Ze >>> 16 & 255), le.push(Ze >>> 24 & 255);
                }
              }
              var Bs = typeof Uint8Array == "function";
              function Ts(le, Ie, Ze) {
                if (le != null)
                  return typeof le == "object" ? Bs && le instanceof Uint8Array ? Ze(le) : Oa(le, Ie, Ze) : Ie(le);
              }
              function Oa(le, Ie, Ze) {
                if (Array.isArray(le)) {
                  for (var Mt = Array(le.length), yn = 0; yn < le.length; yn++)
                    Mt[yn] = Ts(le[yn], Ie, Ze);
                  return Array.isArray(le) && le.W && Xs(Mt), Mt;
                }
                Mt = {};
                for (yn in le)
                  Mt[yn] = Ts(le[yn], Ie, Ze);
                return Mt;
              }
              function Jl(le) {
                return typeof le == "number" ? isFinite(le) ? le : String(le) : le;
              }
              var rl = { W: { value: !0, configurable: !0 } };
              function Xs(le) {
                return Array.isArray(le) && !Object.isFrozen(le) && Object.defineProperties(le, rl), le;
              }
              var il;
              function pa(le, Ie, Ze) {
                var Mt = il;
                il = null, le || (le = Mt), Mt = this.constructor.ca, le || (le = Mt ? [Mt] : []), this.j = Mt ? 0 : -1, this.i = null, this.g = le;
                e: {
                  if (Mt = this.g.length, le = Mt - 1, Mt && (Mt = this.g[le], Mt !== null && typeof Mt == "object" && Mt.constructor === Object)) {
                    this.l = le - this.j, this.h = Mt;
                    break e;
                  }
                  Ie !== void 0 && -1 < Ie ? (this.l = Math.max(Ie, le + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
                }
                if (Ze)
                  for (Ie = 0; Ie < Ze.length; Ie++)
                    le = Ze[Ie], le < this.l ? (le += this.j, (Mt = this.g[le]) ? Xs(Mt) : this.g[le] = rs) : (ma(this), (Mt = this.h[le]) ? Xs(Mt) : this.h[le] = rs);
              }
              var rs = Object.freeze(Xs([]));
              function ma(le) {
                var Ie = le.l + le.j;
                le.g[Ie] || (le.h = le.g[Ie] = {});
              }
              function Xo(le, Ie, Ze) {
                return Ie === -1 ? null : Ze !== void 0 && Ze || Ie >= le.l ? le.h ? le.h[Ie] : void 0 : le.g[Ie + le.j];
              }
              function ks(le) {
                var Ie = Ie === void 0 ? !1 : Ie, Ze = Xo(le, 1, Ie);
                return Ze == null && (Ze = rs), Ze === rs && (Ze = Xs([]), fo(le, 1, Ze, Ie)), Ze;
              }
              function Zo(le, Ie, Ze) {
                return le = Xo(le, Ie), le = le == null ? le : +le, le == null ? Ze === void 0 ? 0 : Ze : le;
              }
              function fo(le, Ie, Ze, Mt) {
                Mt !== void 0 && Mt || Ie >= le.l ? (ma(le), le.h[Ie] = Ze) : le.g[Ie + le.j] = Ze;
              }
              function ul(le, Ie) {
                le.i || (le.i = {});
                var Ze = le.i[1];
                if (!Ze) {
                  var Mt = ks(le);
                  Ze = [];
                  for (var yn = 0; yn < Mt.length; yn++)
                    Ze[yn] = new Ie(Mt[yn]);
                  le.i[1] = Ze;
                }
                return Ze;
              }
              function na(le, Ie, Ze, Mt) {
                var yn = ul(le, Ze);
                Ie = Ie || new Ze(), le = ks(le), Mt != null ? (yn.splice(Mt, 0, Ie), le.splice(Mt, 0, Wi(Ie))) : (yn.push(Ie), le.push(Wi(Ie)));
              }
              pa.prototype.toJSON = function() {
                var le = Wi(this);
                return Oa(le, Jl, vl);
              };
              function Wi(le, Ie) {
                if (le.i)
                  for (var Ze in le.i) {
                    var Mt = le.i[Ze];
                    if (Array.isArray(Mt))
                      for (var yn = 0; yn < Mt.length; yn++)
                        Mt[yn] && Wi(Mt[yn]);
                    else
                      Mt && Wi(Mt);
                  }
                return le.g;
              }
              pa.prototype.toString = function() {
                return Wi(this).toString();
              };
              function li(le, Ie) {
                return le = Xo(le, Ie), le == null ? 0 : le;
              }
              function ko(le, Ie) {
                return le = Xo(le, Ie), le == null ? "" : le;
              }
              function is(le, Ie) {
                if (le = le.m) {
                  Ls(Ie, Ie.g.end());
                  for (var Ze = 0; Ze < le.length; Ze++)
                    Ls(Ie, le[Ze]);
                }
              }
              function So(le, Ie) {
                if (Ie.h == 4)
                  return !1;
                var Ze = Ie.m;
                return Pa(Ie), Ie.N || (Ie = Nl(Ie.g.h, Ze, Ie.g.g), (Ze = le.m) ? Ze.push(Ie) : le.m = [Ie]), !0;
              }
              function wo(le, Ie) {
                var Ze = void 0;
                return new (Ze || (Ze = n))(function(Mt, yn) {
                  function nr(Wr) {
                    try {
                      zn(Ie.next(Wr));
                    } catch (ci) {
                      yn(ci);
                    }
                  }
                  function mn(Wr) {
                    try {
                      zn(Ie.throw(Wr));
                    } catch (ci) {
                      yn(ci);
                    }
                  }
                  function zn(Wr) {
                    Wr.done ? Mt(Wr.value) : new Ze(function(ci) {
                      ci(Wr.value);
                    }).then(nr, mn);
                  }
                  zn((Ie = Ie.apply(le, void 0)).next());
                });
              }
              function wn(le) {
                pa.call(this, le);
              }
              Nr(wn, pa);
              function jn(le, Ie) {
                for (; eo(Ie); )
                  switch (Ie.i) {
                    case 8:
                      var Ze = Na(Ie.g);
                      fo(le, 1, Ze);
                      break;
                    case 21:
                      Ze = nl(Ie.g), fo(le, 2, Ze);
                      break;
                    case 26:
                      Ze = ua(Ie), fo(le, 3, Ze);
                      break;
                    case 34:
                      Ze = ua(Ie), fo(le, 4, Ze);
                      break;
                    default:
                      if (!So(le, Ie))
                        return le;
                  }
                return le;
              }
              function hr(le) {
                pa.call(this, le, -1, po);
              }
              Nr(hr, pa), hr.prototype.addClassification = function(le, Ie) {
                na(this, le, wn, Ie);
              };
              var po = [1];
              function Po(le) {
                pa.call(this, le);
              }
              Nr(Po, pa);
              function Yo(le, Ie) {
                for (; eo(Ie); )
                  switch (Ie.i) {
                    case 13:
                      var Ze = nl(Ie.g);
                      fo(le, 1, Ze);
                      break;
                    case 21:
                      Ze = nl(Ie.g), fo(le, 2, Ze);
                      break;
                    case 29:
                      Ze = nl(Ie.g), fo(le, 3, Ze);
                      break;
                    case 37:
                      Ze = nl(Ie.g), fo(le, 4, Ze);
                      break;
                    case 45:
                      Ze = nl(Ie.g), fo(le, 5, Ze);
                      break;
                    default:
                      if (!So(le, Ie))
                        return le;
                  }
                return le;
              }
              function fi(le) {
                pa.call(this, le, -1, ra);
              }
              Nr(fi, pa);
              var ra = [1];
              function ls(le) {
                pa.call(this, le);
              }
              Nr(ls, pa);
              function xs(le, Ie, Ze) {
                if (Ze = le.createShader(Ze === 0 ? le.VERTEX_SHADER : le.FRAGMENT_SHADER), le.shaderSource(Ze, Ie), le.compileShader(Ze), !le.getShaderParameter(Ze, le.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + le.getShaderInfoLog(Ze));
                return Ze;
              }
              function Hs(le) {
                return ul(le, wn).map(function(Ie) {
                  return { index: li(Ie, 1), Y: Zo(Ie, 2), label: Xo(Ie, 3) != null ? ko(Ie, 3) : void 0, displayName: Xo(Ie, 4) != null ? ko(Ie, 4) : void 0 };
                });
              }
              function hl(le) {
                return { x: Zo(le, 1), y: Zo(le, 2), z: Zo(le, 3), visibility: Xo(le, 4) != null ? Zo(le, 4) : void 0 };
              }
              function bl(le, Ie) {
                this.h = le, this.g = Ie, this.l = 0;
              }
              function os(le, Ie, Ze) {
                return Ps(le, Ie), typeof le.g.canvas.transferToImageBitmap == "function" ? n.resolve(le.g.canvas.transferToImageBitmap()) : Ze ? n.resolve(le.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(le.g.canvas) : (le.i === void 0 && (le.i = document.createElement("canvas")), new n(function(Mt) {
                  le.i.height = le.g.canvas.height, le.i.width = le.g.canvas.width, le.i.getContext("2d", {}).drawImage(le.g.canvas, 0, 0, le.g.canvas.width, le.g.canvas.height), Mt(le.i);
                }));
              }
              function Ps(le, Ie) {
                var Ze = le.g;
                if (le.m === void 0) {
                  var Mt = xs(Ze, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), yn = xs(Ze, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), nr = Ze.createProgram();
                  if (Ze.attachShader(nr, Mt), Ze.attachShader(nr, yn), Ze.linkProgram(nr), !Ze.getProgramParameter(nr, Ze.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + Ze.getProgramInfoLog(nr));
                  Mt = le.m = nr, Ze.useProgram(Mt), yn = Ze.getUniformLocation(Mt, "sampler0"), le.j = { I: Ze.getAttribLocation(Mt, "aVertex"), H: Ze.getAttribLocation(Mt, "aTex"), da: yn }, le.s = Ze.createBuffer(), Ze.bindBuffer(Ze.ARRAY_BUFFER, le.s), Ze.enableVertexAttribArray(le.j.I), Ze.vertexAttribPointer(le.j.I, 2, Ze.FLOAT, !1, 0, 0), Ze.bufferData(Ze.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), Ze.STATIC_DRAW), Ze.bindBuffer(Ze.ARRAY_BUFFER, null), le.o = Ze.createBuffer(), Ze.bindBuffer(Ze.ARRAY_BUFFER, le.o), Ze.enableVertexAttribArray(le.j.H), Ze.vertexAttribPointer(
                    le.j.H,
                    2,
                    Ze.FLOAT,
                    !1,
                    0,
                    0
                  ), Ze.bufferData(Ze.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), Ze.STATIC_DRAW), Ze.bindBuffer(Ze.ARRAY_BUFFER, null), Ze.uniform1i(yn, 0);
                }
                Mt = le.j, Ze.useProgram(le.m), Ze.canvas.width = Ie.width, Ze.canvas.height = Ie.height, Ze.viewport(0, 0, Ie.width, Ie.height), Ze.activeTexture(Ze.TEXTURE0), le.h.bindTexture2d(Ie.glName), Ze.enableVertexAttribArray(Mt.I), Ze.bindBuffer(Ze.ARRAY_BUFFER, le.s), Ze.vertexAttribPointer(Mt.I, 2, Ze.FLOAT, !1, 0, 0), Ze.enableVertexAttribArray(Mt.H), Ze.bindBuffer(Ze.ARRAY_BUFFER, le.o), Ze.vertexAttribPointer(
                  Mt.H,
                  2,
                  Ze.FLOAT,
                  !1,
                  0,
                  0
                ), Ze.bindFramebuffer(Ze.DRAW_FRAMEBUFFER ? Ze.DRAW_FRAMEBUFFER : Ze.FRAMEBUFFER, null), Ze.clearColor(0, 0, 0, 0), Ze.clear(Ze.COLOR_BUFFER_BIT), Ze.colorMask(!0, !0, !0, !0), Ze.drawArrays(Ze.TRIANGLE_FAN, 0, 4), Ze.disableVertexAttribArray(Mt.I), Ze.disableVertexAttribArray(Mt.H), Ze.bindBuffer(Ze.ARRAY_BUFFER, null), le.h.bindTexture2d(0);
              }
              function dd(le) {
                this.g = le;
              }
              var Os = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function cs(le, Ie) {
                return Ie + le;
              }
              function Il(le, Ie) {
                window[le] = Ie;
              }
              function Ol(le) {
                var Ie = document.createElement("script");
                return Ie.setAttribute("src", le), Ie.setAttribute("crossorigin", "anonymous"), new n(function(Ze) {
                  Ie.addEventListener("load", function() {
                    Ze();
                  }, !1), Ie.addEventListener("error", function() {
                    Ze();
                  }, !1), document.body.appendChild(Ie);
                });
              }
              function bs() {
                return wo(this, function le() {
                  return Go(le, function(Ie) {
                    switch (Ie.g) {
                      case 1:
                        return Ie.m = 2, Un(Ie, WebAssembly.instantiate(Os), 4);
                      case 4:
                        Ie.g = 3, Ie.m = 0;
                        break;
                      case 2:
                        return Ie.m = 0, Ie.j = null, Ie.return(!1);
                      case 3:
                        return Ie.return(!0);
                    }
                  });
                });
              }
              function Jc(le) {
                if (this.g = le, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = n.resolve(), this.P = "", this.B = {}, this.locateFile = le && le.locateFile || cs, typeof window == "object")
                  var Ie = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  Ie = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.S = Ie, le.options) {
                  Ie = rt(Object.keys(le.options));
                  for (var Ze = Ie.next(); !Ze.done; Ze = Ie.next()) {
                    Ze = Ze.value;
                    var Mt = le.options[Ze].default;
                    Mt !== void 0 && (this.j[Ze] = typeof Mt == "function" ? Mt() : Mt);
                  }
                }
              }
              E = Jc.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function Ks(le, Ie) {
                return le.g.files === void 0 ? [] : typeof le.g.files == "function" ? le.g.files(Ie) : le.g.files;
              }
              function Bl(le) {
                return wo(le, function Ie() {
                  var Ze = this, Mt, yn, nr, mn, zn, Wr, ci, Ki, Gi, yo, Xi;
                  return Go(Ie, function(vi) {
                    switch (vi.g) {
                      case 1:
                        return Mt = Ze, Ze.R ? (yn = Ks(Ze, Ze.j), Un(vi, bs(), 2)) : vi.return();
                      case 2:
                        if (nr = vi.h, typeof window == "object")
                          return Il("createMediapipeSolutionsWasm", { locateFile: Ze.locateFile }), Il("createMediapipeSolutionsPackedAssets", { locateFile: Ze.locateFile }), Wr = yn.filter(function(Yi) {
                            return Yi.data !== void 0;
                          }), ci = yn.filter(function(Yi) {
                            return Yi.data === void 0;
                          }), Ki = n.all(Wr.map(function(Yi) {
                            var Fo = ol(Mt, Yi.url);
                            if (Yi.path !== void 0) {
                              var Lo = Yi.path;
                              Fo = Fo.then(function(ia) {
                                return Mt.overrideFile(Lo, ia), n.resolve(ia);
                              });
                            }
                            return Fo;
                          })), Gi = n.all(ci.map(function(Yi) {
                            return Yi.simd === void 0 || Yi.simd && nr || !Yi.simd && !nr ? Ol(Mt.locateFile(Yi.url, Mt.S)) : n.resolve();
                          })).then(function() {
                            return wo(Mt, function Yi() {
                              var Fo, Lo, ia = this;
                              return Go(Yi, function(ha) {
                                if (ha.g == 1)
                                  return Fo = window.createMediapipeSolutionsWasm, Lo = window.createMediapipeSolutionsPackedAssets, Un(ha, Fo(Lo), 2);
                                ia.h = ha.h, ha.g = 0;
                              });
                            });
                          }), yo = function() {
                            return wo(Mt, function Yi() {
                              var Fo = this;
                              return Go(Yi, function(Lo) {
                                return Fo.g.graph && Fo.g.graph.url ? Lo = Un(Lo, ol(Fo, Fo.g.graph.url), 0) : (Lo.g = 0, Lo = void 0), Lo;
                              });
                            });
                          }(), Un(vi, n.all([Gi, Ki, yo]), 7);
                        if (typeof importScripts != "function")
                          throw Error("solutions can only be loaded on a web page or in a web worker");
                        return mn = yn.filter(function(Yi) {
                          return Yi.simd === void 0 || Yi.simd && nr || !Yi.simd && !nr;
                        }).map(function(Yi) {
                          return Mt.locateFile(Yi.url, Mt.S);
                        }), importScripts.apply(null, Nt(mn)), Un(vi, createMediapipeSolutionsWasm(Module), 6);
                      case 6:
                        Ze.h = vi.h, Ze.l = new OffscreenCanvas(1, 1), Ze.h.canvas = Ze.l, zn = Ze.h.GL.createContext(
                          Ze.l,
                          { antialias: !1, alpha: !1, ba: typeof WebGL2RenderingContext < "u" ? 2 : 1 }
                        ), Ze.h.GL.makeContextCurrent(zn), vi.g = 4;
                        break;
                      case 7:
                        if (Ze.l = document.createElement("canvas"), Xi = Ze.l.getContext("webgl2", {}), !Xi && (Xi = Ze.l.getContext("webgl", {}), !Xi))
                          return alert("Failed to create WebGL canvas context when passing video frame."), vi.return();
                        Ze.D = Xi, Ze.h.canvas = Ze.l, Ze.h.createContext(Ze.l, !0, !0, {});
                      case 4:
                        Ze.i = new Ze.h.SolutionWasm(), Ze.R = !1, vi.g = 0;
                    }
                  });
                });
              }
              function nc(le) {
                return wo(le, function Ie() {
                  var Ze = this, Mt, yn, nr, mn, zn, Wr, ci, Ki;
                  return Go(Ie, function(Gi) {
                    if (Gi.g == 1) {
                      if (Ze.g.graph && Ze.g.graph.url && Ze.P === Ze.g.graph.url)
                        return Gi.return();
                      if (Ze.o = !0, !Ze.g.graph || !Ze.g.graph.url) {
                        Gi.g = 2;
                        return;
                      }
                      return Ze.P = Ze.g.graph.url, Un(Gi, ol(Ze, Ze.g.graph.url), 3);
                    }
                    for (Gi.g != 2 && (Mt = Gi.h, Ze.i.loadGraph(Mt)), yn = rt(Object.keys(Ze.B)), nr = yn.next(); !nr.done; nr = yn.next())
                      mn = nr.value, Ze.i.overrideFile(mn, Ze.B[mn]);
                    if (Ze.B = {}, Ze.g.listeners)
                      for (zn = rt(Ze.g.listeners), Wr = zn.next(); !Wr.done; Wr = zn.next())
                        ci = Wr.value, xd(Ze, ci);
                    Ki = Ze.j, Ze.j = {}, Ze.setOptions(Ki), Gi.g = 0;
                  });
                });
              }
              E.reset = function() {
                return wo(this, function le() {
                  var Ie = this;
                  return Go(le, function(Ze) {
                    Ie.i && (Ie.i.reset(), Ie.m = {}, Ie.s = {}), Ze.g = 0;
                  });
                });
              }, E.setOptions = function(le, Ie) {
                var Ze = this;
                if (Ie = Ie || this.g.options) {
                  for (var Mt = [], yn = [], nr = {}, mn = rt(Object.keys(le)), zn = mn.next(); !zn.done; nr = { K: nr.K, L: nr.L }, zn = mn.next()) {
                    var Wr = zn.value;
                    Wr in this.j && this.j[Wr] === le[Wr] || (this.j[Wr] = le[Wr], zn = Ie[Wr], zn !== void 0 && (zn.onChange && (nr.K = zn.onChange, nr.L = le[Wr], Mt.push(/* @__PURE__ */ function(ci) {
                      return function() {
                        return wo(Ze, function Ki() {
                          var Gi, yo = this;
                          return Go(Ki, function(Xi) {
                            if (Xi.g == 1)
                              return Un(Xi, ci.K(ci.L), 2);
                            Gi = Xi.h, Gi === !0 && (yo.o = !0), Xi.g = 0;
                          });
                        });
                      };
                    }(nr))), zn.graphOptionXref && (Wr = { valueNumber: zn.type === 1 ? le[Wr] : 0, valueBoolean: zn.type === 0 ? le[Wr] : !1, valueString: zn.type === 2 ? le[Wr] : "" }, zn = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), zn.graphOptionXref), Wr), yn.push(zn))));
                  }
                  (Mt.length !== 0 || yn.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(yn), this.u = (this.u === void 0 ? [] : this.u).concat(Mt));
                }
              };
              function Oc(le) {
                return wo(le, function Ie() {
                  var Ze = this, Mt, yn, nr, mn, zn, Wr, ci;
                  return Go(Ie, function(Ki) {
                    switch (Ki.g) {
                      case 1:
                        if (!Ze.o)
                          return Ki.return();
                        if (!Ze.u) {
                          Ki.g = 2;
                          break;
                        }
                        Mt = rt(Ze.u), yn = Mt.next();
                      case 3:
                        if (yn.done) {
                          Ki.g = 5;
                          break;
                        }
                        return nr = yn.value, Un(Ki, nr(), 4);
                      case 4:
                        yn = Mt.next(), Ki.g = 3;
                        break;
                      case 5:
                        Ze.u = void 0;
                      case 2:
                        if (Ze.A) {
                          for (mn = new Ze.h.GraphOptionChangeRequestList(), zn = rt(Ze.A), Wr = zn.next(); !Wr.done; Wr = zn.next())
                            ci = Wr.value, mn.push_back(ci);
                          Ze.i.changeOptions(mn), mn.delete(), Ze.A = void 0;
                        }
                        Ze.o = !1, Ki.g = 0;
                    }
                  });
                });
              }
              E.initialize = function() {
                return wo(this, function le() {
                  var Ie = this;
                  return Go(le, function(Ze) {
                    return Ze.g == 1 ? Un(Ze, Bl(Ie), 2) : Ze.g != 3 ? Un(Ze, nc(Ie), 3) : Un(Ze, Oc(Ie), 0);
                  });
                });
              };
              function ol(le, Ie) {
                return wo(le, function Ze() {
                  var Mt = this, yn, nr;
                  return Go(Ze, function(mn) {
                    return Ie in Mt.F ? mn.return(Mt.F[Ie]) : (yn = Mt.locateFile(Ie, ""), nr = fetch(yn).then(function(zn) {
                      return zn.arrayBuffer();
                    }), Mt.F[Ie] = nr, mn.return(nr));
                  });
                });
              }
              E.overrideFile = function(le, Ie) {
                this.i ? this.i.overrideFile(le, Ie) : this.B[le] = Ie;
              }, E.clearOverriddenFiles = function() {
                this.B = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(le, Ie) {
                return wo(this, function Ze() {
                  var Mt = this, yn, nr, mn, zn, Wr, ci, Ki, Gi, yo;
                  return Go(Ze, function(Xi) {
                    switch (Xi.g) {
                      case 1:
                        return Mt.g.inputs ? (yn = 1e3 * (Ie == null ? performance.now() : Ie), Un(Xi, Mt.C, 2)) : Xi.return();
                      case 2:
                        return Un(Xi, Mt.initialize(), 3);
                      case 3:
                        for (nr = new Mt.h.PacketDataList(), mn = rt(Object.keys(le)), zn = mn.next(); !zn.done; zn = mn.next())
                          if (Wr = zn.value, ci = Mt.g.inputs[Wr]) {
                            e: {
                              var vi = Mt, Yi = le[Wr];
                              switch (ci.type) {
                                case "video":
                                  var Fo = vi.m[ci.stream];
                                  if (Fo || (Fo = new bl(vi.h, vi.D), vi.m[ci.stream] = Fo), vi = Fo, vi.l === 0 && (vi.l = vi.h.createTexture()), typeof HTMLVideoElement < "u" && Yi instanceof HTMLVideoElement) {
                                    var Lo = Yi.videoWidth;
                                    Fo = Yi.videoHeight;
                                  } else
                                    typeof HTMLImageElement < "u" && Yi instanceof HTMLImageElement ? (Lo = Yi.naturalWidth, Fo = Yi.naturalHeight) : (Lo = Yi.width, Fo = Yi.height);
                                  Fo = { glName: vi.l, width: Lo, height: Fo }, Lo = vi.g, Lo.canvas.width = Fo.width, Lo.canvas.height = Fo.height, Lo.activeTexture(Lo.TEXTURE0), vi.h.bindTexture2d(vi.l), Lo.texImage2D(Lo.TEXTURE_2D, 0, Lo.RGBA, Lo.RGBA, Lo.UNSIGNED_BYTE, Yi), vi.h.bindTexture2d(0), vi = Fo;
                                  break e;
                                case "detections":
                                  for (Fo = vi.m[ci.stream], Fo || (Fo = new dd(vi.h), vi.m[ci.stream] = Fo), vi = Fo, vi.data || (vi.data = new vi.g.DetectionListData()), vi.data.reset(Yi.length), Fo = 0; Fo < Yi.length; ++Fo) {
                                    Lo = Yi[Fo];
                                    var ia = vi.data, ha = ia.setBoundingBox, ds = Fo, q = Lo.T, he = new ls();
                                    fo(he, 1, q.Z), fo(he, 2, q.$), fo(he, 3, q.height), fo(he, 4, q.width), fo(he, 5, q.rotation), fo(he, 6, q.X);
                                    var ve = q = new ns();
                                    go(ve, 1, Xo(he, 1)), go(ve, 2, Xo(he, 2)), go(ve, 3, Xo(he, 3)), go(ve, 4, Xo(he, 4)), go(ve, 5, Xo(he, 5));
                                    var bt = Xo(he, 6);
                                    if (bt != null && bt != null) {
                                      fa(ve.g, 48);
                                      var Ot = ve.g, In = bt;
                                      bt = 0 > In, In = Math.abs(In);
                                      var en = In >>> 0;
                                      for (In = Math.floor((In - en) / 4294967296), In >>>= 0, bt && (In = ~In >>> 0, en = (~en >>> 0) + 1, 4294967295 < en && (en = 0, In++, 4294967295 < In && (In = 0))), ta = en, $a = In, bt = ta, en = $a; 0 < en || 127 < bt; )
                                        Ot.push(bt & 127 | 128), bt = (bt >>> 7 | en << 25) >>> 0, en >>>= 7;
                                      Ot.push(bt);
                                    }
                                    if (is(he, ve), q = Ua(q), ha.call(ia, ds, q), Lo.O)
                                      for (ia = 0; ia < Lo.O.length; ++ia)
                                        he = Lo.O[ia], ve = !!he.visibility, ha = vi.data, ds = ha.addNormalizedLandmark, q = Fo, he = Object.assign(Object.assign({}, he), { visibility: ve ? he.visibility : 0 }), ve = new Po(), fo(ve, 1, he.x), fo(ve, 2, he.y), fo(ve, 3, he.z), he.visibility && fo(ve, 4, he.visibility), Ot = he = new ns(), go(Ot, 1, Xo(ve, 1)), go(Ot, 2, Xo(ve, 2)), go(Ot, 3, Xo(ve, 3)), go(Ot, 4, Xo(ve, 4)), go(Ot, 5, Xo(ve, 5)), is(ve, Ot), he = Ua(he), ds.call(ha, q, he);
                                    if (Lo.M)
                                      for (ia = 0; ia < Lo.M.length; ++ia) {
                                        if (ha = vi.data, ds = ha.addClassification, q = Fo, he = Lo.M[ia], ve = new wn(), fo(ve, 2, he.Y), he.index && fo(ve, 1, he.index), he.label && fo(ve, 3, he.label), he.displayName && fo(ve, 4, he.displayName), Ot = he = new ns(), en = Xo(ve, 1), en != null && en != null)
                                          if (fa(Ot.g, 8), bt = Ot.g, 0 <= en)
                                            fa(bt, en);
                                          else {
                                            for (In = 0; 9 > In; In++)
                                              bt.push(en & 127 | 128), en >>= 7;
                                            bt.push(1);
                                          }
                                        go(Ot, 2, Xo(ve, 2)), bt = Xo(ve, 3), bt != null && (bt = Hl(bt), fa(Ot.g, 26), fa(Ot.g, bt.length), Ls(Ot, Ot.g.end()), Ls(Ot, bt)), bt = Xo(ve, 4), bt != null && (bt = Hl(bt), fa(Ot.g, 34), fa(Ot.g, bt.length), Ls(Ot, Ot.g.end()), Ls(
                                          Ot,
                                          bt
                                        )), is(ve, Ot), he = Ua(he), ds.call(ha, q, he);
                                      }
                                  }
                                  vi = vi.data;
                                  break e;
                                default:
                                  vi = {};
                              }
                            }
                            switch (Ki = vi, Gi = ci.stream, ci.type) {
                              case "video":
                                nr.pushTexture2d(Object.assign(Object.assign({}, Ki), { stream: Gi, timestamp: yn }));
                                break;
                              case "detections":
                                yo = Ki, yo.stream = Gi, yo.timestamp = yn, nr.pushDetectionList(yo);
                                break;
                              default:
                                throw Error("Unknown input config type: '" + ci.type + "'");
                            }
                          }
                        return Mt.i.send(nr), Un(Xi, Mt.C, 4);
                      case 4:
                        nr.delete(), Xi.g = 0;
                    }
                  });
                });
              };
              function rc(le, Ie, Ze) {
                return wo(le, function Mt() {
                  var yn, nr, mn, zn, Wr, ci, Ki = this, Gi, yo, Xi, vi, Yi, Fo, Lo, ia;
                  return Go(Mt, function(ha) {
                    switch (ha.g) {
                      case 1:
                        if (!Ze)
                          return ha.return(Ie);
                        for (yn = {}, nr = 0, mn = rt(Object.keys(Ze)), zn = mn.next(); !zn.done; zn = mn.next())
                          Wr = zn.value, ci = Ze[Wr], typeof ci != "string" && ci.type === "texture" && Ie[ci.stream] !== void 0 && ++nr;
                        1 < nr && (Ki.G = !1), Gi = rt(Object.keys(Ze)), zn = Gi.next();
                      case 2:
                        if (zn.done) {
                          ha.g = 4;
                          break;
                        }
                        if (yo = zn.value, Xi = Ze[yo], typeof Xi == "string")
                          return Lo = yn, ia = yo, Un(ha, Ld(Ki, yo, Ie[Xi]), 14);
                        if (vi = Ie[Xi.stream], Xi.type === "detection_list") {
                          if (vi) {
                            for (var ds = vi.getRectList(), q = vi.getLandmarksList(), he = vi.getClassificationsList(), ve = [], bt = 0; bt < ds.size(); ++bt) {
                              var Ot = ds.get(bt);
                              e: {
                                var In = new ls();
                                for (Ot = new ss(Ot); eo(Ot); )
                                  switch (Ot.i) {
                                    case 13:
                                      var en = nl(Ot.g);
                                      fo(In, 1, en);
                                      break;
                                    case 21:
                                      en = nl(Ot.g), fo(In, 2, en);
                                      break;
                                    case 29:
                                      en = nl(Ot.g), fo(In, 3, en);
                                      break;
                                    case 37:
                                      en = nl(Ot.g), fo(In, 4, en);
                                      break;
                                    case 45:
                                      en = nl(Ot.g), fo(In, 5, en);
                                      break;
                                    case 48:
                                      for (var Gn = Ot.g, dr = 128, D = 0, Fe = en = 0; 4 > Fe && 128 <= dr; Fe++)
                                        dr = Gn.h[Gn.g++], D |= (dr & 127) << 7 * Fe;
                                      if (128 <= dr && (dr = Gn.h[Gn.g++], D |= (dr & 127) << 28, en |= (dr & 127) >> 4), 128 <= dr)
                                        for (Fe = 0; 5 > Fe && 128 <= dr; Fe++)
                                          dr = Gn.h[Gn.g++], en |= (dr & 127) << 7 * Fe + 3;
                                      128 > dr ? (Gn = D >>> 0, dr = en >>> 0, (en = dr & 2147483648) && (Gn = ~Gn + 1 >>> 0, dr = ~dr >>> 0, Gn == 0 && (dr = dr + 1 >>> 0)), Gn = 4294967296 * dr + (Gn >>> 0), en = en ? -Gn : Gn) : (Gn.l = !0, en = void 0), fo(In, 6, en);
                                      break;
                                    default:
                                      if (!So(In, Ot))
                                        break e;
                                  }
                              }
                              In = { Z: Zo(In, 1), $: Zo(In, 2), height: Zo(In, 3), width: Zo(In, 4), rotation: Zo(In, 5, 0), X: li(In, 6) }, en = q.get(bt);
                              e:
                                for (Ot = new fi(), en = new ss(en); eo(en); )
                                  switch (en.i) {
                                    case 10:
                                      Gn = Ao(en, new Po(), Yo), na(Ot, Gn, Po, void 0);
                                      break;
                                    default:
                                      if (!So(Ot, en))
                                        break e;
                                  }
                              Ot = ul(Ot, Po).map(hl), Gn = he.get(bt);
                              e:
                                for (en = new hr(), Gn = new ss(Gn); eo(Gn); )
                                  switch (Gn.i) {
                                    case 10:
                                      en.addClassification(Ao(
                                        Gn,
                                        new wn(),
                                        jn
                                      ));
                                      break;
                                    default:
                                      if (!So(en, Gn))
                                        break e;
                                  }
                              In = { T: In, O: Ot, M: Hs(en) }, ve.push(In);
                            }
                            ds = ve;
                          } else
                            ds = [];
                          yn[yo] = ds, ha.g = 7;
                          break;
                        }
                        if (Xi.type === "proto_list") {
                          if (vi) {
                            for (ds = Array(vi.size()), q = 0; q < vi.size(); q++)
                              ds[q] = vi.get(q);
                            vi.delete();
                          } else
                            ds = [];
                          yn[yo] = ds, ha.g = 7;
                          break;
                        }
                        if (vi === void 0) {
                          ha.g = 3;
                          break;
                        }
                        if (Xi.type === "float_list") {
                          yn[yo] = vi, ha.g = 7;
                          break;
                        }
                        if (Xi.type === "proto") {
                          yn[yo] = vi, ha.g = 7;
                          break;
                        }
                        if (Xi.type !== "texture")
                          throw Error("Unknown output config type: '" + Xi.type + "'");
                        return Yi = Ki.s[yo], Yi || (Yi = new bl(Ki.h, Ki.D), Ki.s[yo] = Yi), Un(ha, os(Yi, vi, Ki.G), 13);
                      case 13:
                        Fo = ha.h, yn[yo] = Fo;
                      case 7:
                        Xi.transform && yn[yo] && (yn[yo] = Xi.transform(yn[yo])), ha.g = 3;
                        break;
                      case 14:
                        Lo[ia] = ha.h;
                      case 3:
                        zn = Gi.next(), ha.g = 2;
                        break;
                      case 4:
                        return ha.return(yn);
                    }
                  });
                });
              }
              function Ld(le, Ie, Ze) {
                return wo(le, function Mt() {
                  var yn = this, nr;
                  return Go(Mt, function(mn) {
                    return typeof Ze == "number" || Ze instanceof Uint8Array || Ze instanceof yn.h.Uint8BlobList ? mn.return(Ze) : Ze instanceof yn.h.Texture2dDataOut ? (nr = yn.s[Ie], nr || (nr = new bl(yn.h, yn.D), yn.s[Ie] = nr), mn.return(os(nr, Ze, yn.G))) : mn.return(void 0);
                  });
                });
              }
              function xd(le, Ie) {
                for (var Ze = Ie.name || "$", Mt = [].concat(Nt(Ie.wants)), yn = new le.h.StringList(), nr = rt(Ie.wants), mn = nr.next(); !mn.done; mn = nr.next())
                  yn.push_back(mn.value);
                nr = le.h.PacketListener.implement({ onResults: function(zn) {
                  for (var Wr = {}, ci = 0; ci < Ie.wants.length; ++ci)
                    Wr[Mt[ci]] = zn.get(ci);
                  var Ki = le.listeners[Ze];
                  Ki && (le.C = rc(le, Wr, Ie.outs).then(function(Gi) {
                    Gi = Ki(Gi);
                    for (var yo = 0; yo < Ie.wants.length; ++yo) {
                      var Xi = Wr[Mt[yo]];
                      typeof Xi == "object" && Xi.hasOwnProperty && Xi.hasOwnProperty("delete") && Xi.delete();
                    }
                    Gi && (le.C = Gi);
                  }));
                } }), le.i.attachMultiListener(yn, nr), yn.delete();
              }
              E.onResults = function(le, Ie) {
                this.listeners[Ie || "$"] = le;
              }, Ma("Solution", Jc), Ma("OptionType", { BOOL: 0, NUMBER: 1, aa: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function ic(le) {
                switch (le === void 0 && (le = 0), le) {
                  case 1:
                    return "selfie_segmentation_landscape.tflite";
                  default:
                    return "selfie_segmentation.tflite";
                }
              }
              function fc(le) {
                var Ie = this;
                le = le || {}, this.g = new Jc({ locateFile: le.locateFile, files: function(Ze) {
                  return [{ simd: !0, url: "selfie_segmentation_solution_simd_wasm_bin.js" }, { simd: !1, url: "selfie_segmentation_solution_wasm_bin.js" }, { data: !0, url: ic(Ze.modelSelection) }];
                }, graph: { url: "selfie_segmentation.binarypb" }, listeners: [{ wants: ["segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: {
                  type: "video",
                  stream: "input_frames_gpu"
                } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, modelSelection: { type: 1, graphOptionXref: {
                  calculatorType: "ConstantSidePacketCalculator",
                  calculatorName: "ConstantSidePacketCalculatorModelSelection",
                  fieldName: "int_value"
                }, onChange: function(Ze) {
                  return wo(Ie, function Mt() {
                    var yn, nr, mn = this, zn;
                    return Go(Mt, function(Wr) {
                      return Wr.g == 1 ? (yn = ic(Ze), nr = "third_party/mediapipe/modules/selfie_segmentation/" + yn, Un(Wr, ol(mn.g, yn), 2)) : (zn = Wr.h, mn.g.overrideFile(nr, zn), Wr.return(!0));
                    });
                  });
                } } } });
              }
              E = fc.prototype, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(le) {
                this.g.onResults(le);
              }, E.initialize = function() {
                return wo(this, function le() {
                  var Ie = this;
                  return Go(le, function(Ze) {
                    return Un(Ze, Ie.g.initialize(), 0);
                  });
                });
              }, E.reset = function() {
                this.g.reset();
              }, E.send = function(le) {
                return wo(this, function Ie() {
                  var Ze = this;
                  return Go(Ie, function(Mt) {
                    return Un(Mt, Ze.g.send(le), 0);
                  });
                });
              }, E.setOptions = function(le) {
                this.g.setOptions(le);
              }, Ma("SelfieSegmentation", fc), Ma("VERSION", "0.1.1632777926");
            }).call(Rt);
            const ln = {};
            (function() {
              var E;
              function R(Y) {
                var me = 0;
                return function() {
                  return me < Y.length ? { done: !1, value: Y[me++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(Y, me, Ee) {
                return Y == Array.prototype || Y == Object.prototype || (Y[me] = Ee.value), Y;
              };
              function ie(Y) {
                Y = [typeof globalThis == "object" && globalThis, Y, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var me = 0; me < Y.length; ++me) {
                  var Ee = Y[me];
                  if (Ee && Ee.Math == Math)
                    return Ee;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(Y, me) {
                if (me)
                  e: {
                    var Ee = pe;
                    Y = Y.split(".");
                    for (var je = 0; je < Y.length - 1; je++) {
                      var Tt = Y[je];
                      if (!(Tt in Ee))
                        break e;
                      Ee = Ee[Tt];
                    }
                    Y = Y[Y.length - 1], je = Ee[Y], me = me(je), me != je && me != null && S(Ee, Y, { configurable: !0, writable: !0, value: me });
                  }
              }
              De("Symbol", function(Y) {
                function me(X) {
                  if (this instanceof me)
                    throw new TypeError("Symbol is not a constructor");
                  return new Ee(je + (X || "") + "_" + Tt++, X);
                }
                function Ee(X, j) {
                  this.g = X, S(this, "description", { configurable: !0, writable: !0, value: j });
                }
                if (Y)
                  return Y;
                Ee.prototype.toString = function() {
                  return this.g;
                };
                var je = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", Tt = 0;
                return me;
              }), De("Symbol.iterator", function(Y) {
                if (Y)
                  return Y;
                Y = Symbol("Symbol.iterator");
                for (var me = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), Ee = 0; Ee < me.length; Ee++) {
                  var je = pe[me[Ee]];
                  typeof je == "function" && typeof je.prototype[Y] != "function" && S(je.prototype, Y, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return Y;
              });
              function ht(Y) {
                return Y = { next: Y }, Y[Symbol.iterator] = function() {
                  return this;
                }, Y;
              }
              function rt(Y) {
                var me = typeof Symbol < "u" && Symbol.iterator && Y[Symbol.iterator];
                return me ? me.call(Y) : { next: R(Y) };
              }
              function Nt(Y) {
                if (!(Y instanceof Array)) {
                  Y = rt(Y);
                  for (var me, Ee = []; !(me = Y.next()).done; )
                    Ee.push(me.value);
                  Y = Ee;
                }
                return Y;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(Y) {
                function me() {
                }
                return me.prototype = Y, new me();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(Y, me) {
                  if (Y.__proto__ = me, Y.__proto__ !== me)
                    throw new TypeError(Y + " is not extensible");
                  return Y;
                } : null;
              }
              var br = cr;
              function Nr(Y, me) {
                if (Y.prototype = Pn(me.prototype), Y.prototype.constructor = Y, br)
                  br(Y, me);
                else
                  for (var Ee in me)
                    if (Ee != "prototype")
                      if (Object.defineProperties) {
                        var je = Object.getOwnPropertyDescriptor(me, Ee);
                        je && Object.defineProperty(Y, Ee, je);
                      } else
                        Y[Ee] = me[Ee];
                Y.ra = me.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.u = this.o = 0, this.j = null;
              }
              function qi(Y) {
                if (Y.l)
                  throw new TypeError("Generator is already running");
                Y.l = !0;
              }
              $i.prototype.s = function(Y) {
                this.h = Y;
              };
              function Vo(Y, me) {
                Y.j = { fa: me, ga: !0 }, Y.g = Y.o || Y.u;
              }
              $i.prototype.return = function(Y) {
                this.j = { return: Y }, this.g = this.u;
              };
              function Un(Y, me, Ee) {
                return Y.g = Ee, { value: me };
              }
              function el(Y) {
                this.g = new $i(), this.h = Y;
              }
              function Ys(Y, me) {
                qi(Y.g);
                var Ee = Y.g.i;
                return Ee ? Ca(Y, "return" in Ee ? Ee.return : function(je) {
                  return { value: je, done: !0 };
                }, me, Y.g.return) : (Y.g.return(me), lo(Y));
              }
              function Ca(Y, me, Ee, je) {
                try {
                  var Tt = me.call(Y.g.i, Ee);
                  if (!(Tt instanceof Object))
                    throw new TypeError("Iterator result " + Tt + " is not an object");
                  if (!Tt.done)
                    return Y.g.l = !1, Tt;
                  var X = Tt.value;
                } catch (j) {
                  return Y.g.i = null, Vo(Y.g, j), lo(Y);
                }
                return Y.g.i = null, je.call(Y.g, X), lo(Y);
              }
              function lo(Y) {
                for (; Y.g.g; )
                  try {
                    var me = Y.h(Y.g);
                    if (me)
                      return Y.g.l = !1, { value: me.value, done: !1 };
                  } catch (Ee) {
                    Y.g.h = void 0, Vo(Y.g, Ee);
                  }
                if (Y.g.l = !1, Y.g.j) {
                  if (me = Y.g.j, Y.g.j = null, me.ga)
                    throw me.fa;
                  return { value: me.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(Y) {
                this.next = function(me) {
                  return qi(Y.g), Y.g.i ? me = Ca(Y, Y.g.i.next, me, Y.g.s) : (Y.g.s(me), me = lo(Y)), me;
                }, this.throw = function(me) {
                  return qi(Y.g), Y.g.i ? me = Ca(Y, Y.g.i.throw, me, Y.g.s) : (Vo(Y.g, me), me = lo(Y)), me;
                }, this.return = function(me) {
                  return Ys(Y, me);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(Y) {
                function me(je) {
                  return Y.next(je);
                }
                function Ee(je) {
                  return Y.throw(je);
                }
                return new n(function(je, Tt) {
                  function X(j) {
                    j.done ? je(j.value) : n.resolve(j.value).then(me, Ee).then(X, Tt);
                  }
                  X(Y.next());
                });
              }
              function Mr(Y) {
                return Go(new Cc(new el(Y)));
              }
              De("Promise", function(Y) {
                function me(j) {
                  this.h = 0, this.i = void 0, this.g = [], this.s = !1;
                  var Ae = this.j();
                  try {
                    j(Ae.resolve, Ae.reject);
                  } catch (C) {
                    Ae.reject(C);
                  }
                }
                function Ee() {
                  this.g = null;
                }
                function je(j) {
                  return j instanceof me ? j : new me(function(Ae) {
                    Ae(j);
                  });
                }
                if (Y)
                  return Y;
                Ee.prototype.h = function(j) {
                  if (this.g == null) {
                    this.g = [];
                    var Ae = this;
                    this.i(function() {
                      Ae.l();
                    });
                  }
                  this.g.push(j);
                };
                var Tt = pe.setTimeout;
                Ee.prototype.i = function(j) {
                  Tt(j, 0);
                }, Ee.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var j = this.g;
                    this.g = [];
                    for (var Ae = 0; Ae < j.length; ++Ae) {
                      var C = j[Ae];
                      j[Ae] = null;
                      try {
                        C();
                      } catch (x) {
                        this.j(x);
                      }
                    }
                  }
                  this.g = null;
                }, Ee.prototype.j = function(j) {
                  this.i(function() {
                    throw j;
                  });
                }, me.prototype.j = function() {
                  function j(x) {
                    return function(ee) {
                      C || (C = !0, x.call(Ae, ee));
                    };
                  }
                  var Ae = this, C = !1;
                  return { resolve: j(this.D), reject: j(this.l) };
                }, me.prototype.D = function(j) {
                  if (j === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (j instanceof me)
                    this.H(j);
                  else {
                    e:
                      switch (typeof j) {
                        case "object":
                          var Ae = j != null;
                          break e;
                        case "function":
                          Ae = !0;
                          break e;
                        default:
                          Ae = !1;
                      }
                    Ae ? this.A(j) : this.o(j);
                  }
                }, me.prototype.A = function(j) {
                  var Ae = void 0;
                  try {
                    Ae = j.then;
                  } catch (C) {
                    this.l(C);
                    return;
                  }
                  typeof Ae == "function" ? this.I(Ae, j) : this.o(j);
                }, me.prototype.l = function(j) {
                  this.u(2, j);
                }, me.prototype.o = function(j) {
                  this.u(1, j);
                }, me.prototype.u = function(j, Ae) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + j + ", " + Ae + "): Promise already settled in state" + this.h);
                  this.h = j, this.i = Ae, this.h === 2 && this.G(), this.B();
                }, me.prototype.G = function() {
                  var j = this;
                  Tt(function() {
                    if (j.C()) {
                      var Ae = pe.console;
                      typeof Ae < "u" && Ae.error(j.i);
                    }
                  }, 1);
                }, me.prototype.C = function() {
                  if (this.s)
                    return !1;
                  var j = pe.CustomEvent, Ae = pe.Event, C = pe.dispatchEvent;
                  return typeof C > "u" ? !0 : (typeof j == "function" ? j = new j("unhandledrejection", { cancelable: !0 }) : typeof Ae == "function" ? j = new Ae("unhandledrejection", { cancelable: !0 }) : (j = pe.document.createEvent("CustomEvent"), j.initCustomEvent("unhandledrejection", !1, !0, j)), j.promise = this, j.reason = this.i, C(j));
                }, me.prototype.B = function() {
                  if (this.g != null) {
                    for (var j = 0; j < this.g.length; ++j)
                      X.h(this.g[j]);
                    this.g = null;
                  }
                };
                var X = new Ee();
                return me.prototype.H = function(j) {
                  var Ae = this.j();
                  j.M(Ae.resolve, Ae.reject);
                }, me.prototype.I = function(j, Ae) {
                  var C = this.j();
                  try {
                    j.call(Ae, C.resolve, C.reject);
                  } catch (x) {
                    C.reject(x);
                  }
                }, me.prototype.then = function(j, Ae) {
                  function C(M, H) {
                    return typeof M == "function" ? function(ce) {
                      try {
                        x(M(ce));
                      } catch (ke) {
                        ee(ke);
                      }
                    } : H;
                  }
                  var x, ee, F = new me(function(M, H) {
                    x = M, ee = H;
                  });
                  return this.M(C(j, x), C(Ae, ee)), F;
                }, me.prototype.catch = function(j) {
                  return this.then(void 0, j);
                }, me.prototype.M = function(j, Ae) {
                  function C() {
                    switch (x.h) {
                      case 1:
                        j(x.i);
                        break;
                      case 2:
                        Ae(x.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + x.h);
                    }
                  }
                  var x = this;
                  this.g == null ? X.h(C) : this.g.push(C), this.s = !0;
                }, me.resolve = je, me.reject = function(j) {
                  return new me(function(Ae, C) {
                    C(j);
                  });
                }, me.race = function(j) {
                  return new me(function(Ae, C) {
                    for (var x = rt(j), ee = x.next(); !ee.done; ee = x.next())
                      je(ee.value).M(Ae, C);
                  });
                }, me.all = function(j) {
                  var Ae = rt(j), C = Ae.next();
                  return C.done ? je([]) : new me(function(x, ee) {
                    function F(ce) {
                      return function(ke) {
                        M[ce] = ke, H--, H == 0 && x(M);
                      };
                    }
                    var M = [], H = 0;
                    do
                      M.push(void 0), H++, je(C.value).M(F(M.length - 1), ee), C = Ae.next();
                    while (!C.done);
                  });
                }, me;
              });
              function ml(Y, me) {
                Y instanceof String && (Y += "");
                var Ee = 0, je = !1, Tt = { next: function() {
                  if (!je && Ee < Y.length) {
                    var X = Ee++;
                    return { value: me(X, Y[X]), done: !1 };
                  }
                  return je = !0, { done: !0, value: void 0 };
                } };
                return Tt[Symbol.iterator] = function() {
                  return Tt;
                }, Tt;
              }
              var cd = typeof Object.assign == "function" ? Object.assign : function(Y, me) {
                for (var Ee = 1; Ee < arguments.length; Ee++) {
                  var je = arguments[Ee];
                  if (je)
                    for (var Tt in je)
                      Object.prototype.hasOwnProperty.call(je, Tt) && (Y[Tt] = je[Tt]);
                }
                return Y;
              };
              De("Object.assign", function(Y) {
                return Y || cd;
              }), De("Object.is", function(Y) {
                return Y || function(me, Ee) {
                  return me === Ee ? me !== 0 || 1 / me === 1 / Ee : me !== me && Ee !== Ee;
                };
              }), De("Array.prototype.includes", function(Y) {
                return Y || function(me, Ee) {
                  var je = this;
                  je instanceof String && (je = String(je));
                  var Tt = je.length;
                  for (Ee = Ee || 0, 0 > Ee && (Ee = Math.max(Ee + Tt, 0)); Ee < Tt; Ee++) {
                    var X = je[Ee];
                    if (X === me || Object.is(X, me))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(Y) {
                return Y || function(me, Ee) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (me instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(me, Ee || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(Y) {
                return Y || function() {
                  return ml(this, function(me) {
                    return me;
                  });
                };
              });
              var Ma = this || self;
              function Ji(Y, me) {
                Y = Y.split(".");
                var Ee = Ma;
                Y[0] in Ee || typeof Ee.execScript > "u" || Ee.execScript("var " + Y[0]);
                for (var je; Y.length && (je = Y.shift()); )
                  Y.length || me === void 0 ? Ee[je] && Ee[je] !== Object.prototype[je] ? Ee = Ee[je] : Ee = Ee[je] = {} : Ee[je] = me;
              }
              function ts() {
                throw Error("Invalid UTF8");
              }
              function tl(Y, me) {
                return me = String.fromCharCode.apply(null, me), Y == null ? me : Y + me;
              }
              var Wl, Ac = typeof TextDecoder < "u", Hl, Uc = typeof TextEncoder < "u", dl = {}, vl = null;
              function Nc(Y) {
                var me;
                me === void 0 && (me = 0), Is(), me = dl[me];
                for (var Ee = Array(Math.floor(Y.length / 3)), je = me[64] || "", Tt = 0, X = 0; Tt < Y.length - 2; Tt += 3) {
                  var j = Y[Tt], Ae = Y[Tt + 1], C = Y[Tt + 2], x = me[j >> 2];
                  j = me[(j & 3) << 4 | Ae >> 4], Ae = me[(Ae & 15) << 2 | C >> 6], C = me[C & 63], Ee[X++] = x + j + Ae + C;
                }
                switch (x = 0, C = je, Y.length - Tt) {
                  case 2:
                    x = Y[Tt + 1], C = me[(x & 15) << 2] || je;
                  case 1:
                    Y = Y[Tt], Ee[X] = me[Y >> 2] + me[(Y & 3) << 4 | x >> 4] + C + je;
                }
                return Ee.join("");
              }
              function gc(Y) {
                var me = Y.length, Ee = 3 * me / 4;
                Ee % 3 ? Ee = Math.floor(Ee) : "=.".indexOf(Y[me - 1]) != -1 && (Ee = "=.".indexOf(Y[me - 2]) != -1 ? Ee - 2 : Ee - 1);
                var je = new Uint8Array(Ee), Tt = 0;
                return Js(Y, function(X) {
                  je[Tt++] = X;
                }), Tt !== Ee ? je.subarray(0, Tt) : je;
              }
              function Js(Y, me) {
                function Ee(C) {
                  for (; je < Y.length; ) {
                    var x = Y.charAt(je++), ee = vl[x];
                    if (ee != null)
                      return ee;
                    if (!/^[\s\xa0]*$/.test(x))
                      throw Error("Unknown base64 encoding at char: " + x);
                  }
                  return C;
                }
                Is();
                for (var je = 0; ; ) {
                  var Tt = Ee(-1), X = Ee(0), j = Ee(64), Ae = Ee(64);
                  if (Ae === 64 && Tt === -1)
                    break;
                  me(Tt << 2 | X >> 4), j != 64 && (me(X << 4 & 240 | j >> 2), Ae != 64 && me(j << 6 & 192 | Ae));
                }
              }
              function Is() {
                if (!vl) {
                  vl = {};
                  for (var Y = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), me = ["+/=", "+/", "-_=", "-_.", "-_"], Ee = 0; 5 > Ee; Ee++) {
                    var je = Y.concat(me[Ee].split(""));
                    dl[Ee] = je;
                    for (var Tt = 0; Tt < je.length; Tt++) {
                      var X = je[Tt];
                      vl[X] === void 0 && (vl[X] = Tt);
                    }
                  }
                }
              }
              var Pl = typeof Uint8Array == "function";
              function Nl(Y) {
                return Pl && Y != null && Y instanceof Uint8Array;
              }
              var ta;
              function $a(Y) {
                if (this.L = Y, Y !== null && Y.length === 0)
                  throw Error("ByteString should be constructed with non-empty values");
              }
              var Gs = typeof Uint8Array.prototype.slice == "function", To = 0, Na = 0;
              function nl(Y, me) {
                if (Y.constructor === Uint8Array)
                  return Y;
                if (Y.constructor === ArrayBuffer)
                  return new Uint8Array(Y);
                if (Y.constructor === Array)
                  return new Uint8Array(Y);
                if (Y.constructor === String)
                  return gc(Y);
                if (Y.constructor === $a)
                  return !me && (me = Y.L) && me.constructor === Uint8Array ? me : (me = Y.L, me = me == null || Nl(me) ? me : typeof me == "string" ? gc(me) : null, (Y = Y.L = me) ? new Uint8Array(Y) : ta || (ta = new Uint8Array(0)));
                if (Y instanceof Uint8Array)
                  return new Uint8Array(Y.buffer, Y.byteOffset, Y.byteLength);
                throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
              }
              function vs(Y, me) {
                return Error("Invalid wire type: " + Y + " (at position " + me + ")");
              }
              function bo() {
                return Error("Failed to read varint, encoding is invalid.");
              }
              function fa(Y, me) {
                me = me === void 0 ? {} : me, me = me.v === void 0 ? !1 : me.v, this.h = null, this.g = this.i = this.j = 0, this.v = me, Y && ss(this, Y);
              }
              function ss(Y, me) {
                Y.h = nl(me, Y.v), Y.j = 0, Y.i = Y.h.length, Y.g = Y.j;
              }
              fa.prototype.reset = function() {
                this.g = this.j;
              };
              function eo(Y) {
                if (Y.g > Y.i)
                  throw Error("Tried to read past the end of the data " + Y.g + " > " + Y.i);
              }
              function Pa(Y) {
                var me = Y.h, Ee = me[Y.g], je = Ee & 127;
                if (128 > Ee)
                  return Y.g += 1, eo(Y), je;
                if (Ee = me[Y.g + 1], je |= (Ee & 127) << 7, 128 > Ee)
                  return Y.g += 2, eo(Y), je;
                if (Ee = me[Y.g + 2], je |= (Ee & 127) << 14, 128 > Ee)
                  return Y.g += 3, eo(Y), je;
                if (Ee = me[Y.g + 3], je |= (Ee & 127) << 21, 128 > Ee)
                  return Y.g += 4, eo(Y), je;
                if (Ee = me[Y.g + 4], Y.g += 5, je |= (Ee & 15) << 28, 128 > Ee)
                  return eo(Y), je;
                if (128 <= me[Y.g++] && 128 <= me[Y.g++] && 128 <= me[Y.g++] && 128 <= me[Y.g++] && 128 <= me[Y.g++])
                  throw bo();
                return eo(Y), je;
              }
              var Ao = [];
              function ua() {
                this.g = [];
              }
              ua.prototype.length = function() {
                return this.g.length;
              }, ua.prototype.end = function() {
                var Y = this.g;
                return this.g = [], Y;
              };
              function ns(Y, me) {
                for (; 127 < me; )
                  Y.g.push(me & 127 | 128), me >>>= 7;
                Y.g.push(me);
              }
              function Ls(Y) {
                var me = {}, Ee = me.W === void 0 ? !1 : me.W;
                this.l = { v: me.v === void 0 ? !1 : me.v }, this.W = Ee, me = this.l, Ao.length ? (Ee = Ao.pop(), me && (Ee.v = me.v), Y && ss(Ee, Y), Y = Ee) : Y = new fa(Y, me), this.g = Y, this.j = this.g.g, this.h = this.i = -1;
              }
              Ls.prototype.reset = function() {
                this.g.reset(), this.j = this.g.g, this.h = this.i = -1;
              };
              function Ua(Y) {
                var me = Y.g;
                if (me.g == me.i)
                  return !1;
                Y.j = Y.g.g;
                var Ee = Pa(Y.g) >>> 0;
                if (me = Ee >>> 3, Ee &= 7, !(0 <= Ee && 5 >= Ee))
                  throw vs(Ee, Y.j);
                if (1 > me)
                  throw Error("Invalid field number: " + me + " (at position " + Y.j + ")");
                return Y.i = me, Y.h = Ee, !0;
              }
              function go(Y) {
                switch (Y.h) {
                  case 0:
                    if (Y.h != 0)
                      go(Y);
                    else
                      e: {
                        Y = Y.g;
                        for (var me = Y.g, Ee = me + 10; me < Ee; )
                          if (!(Y.h[me++] & 128)) {
                            Y.g = me, eo(Y);
                            break e;
                          }
                        throw bo();
                      }
                    break;
                  case 1:
                    Y = Y.g, Y.g += 8, eo(Y);
                    break;
                  case 2:
                    Y.h != 2 ? go(Y) : (me = Pa(Y.g) >>> 0, Y = Y.g, Y.g += me, eo(Y));
                    break;
                  case 5:
                    Y = Y.g, Y.g += 4, eo(Y);
                    break;
                  case 3:
                    me = Y.i;
                    do {
                      if (!Ua(Y))
                        throw Error("Unmatched start-group tag: stream EOF");
                      if (Y.h == 4) {
                        if (Y.i != me)
                          throw Error("Unmatched end-group tag");
                        break;
                      }
                      go(Y);
                    } while (!0);
                    break;
                  default:
                    throw vs(Y.h, Y.j);
                }
              }
              var Bs = [];
              function Ts() {
                this.i = [], this.h = 0, this.g = new ua();
              }
              function Oa(Y, me) {
                me.length !== 0 && (Y.i.push(me), Y.h += me.length);
              }
              function Jl(Y, me) {
                if (me = me.ca) {
                  Oa(Y, Y.g.end());
                  for (var Ee = 0; Ee < me.length; Ee++)
                    Oa(Y, me[Ee]);
                }
              }
              var rl = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
              function Xs(Y, me) {
                Object.isFrozen(Y) || (rl ? Y[rl] |= me : Y.N !== void 0 ? Y.N |= me : Object.defineProperties(Y, { N: { value: me, configurable: !0, writable: !0, enumerable: !1 } }));
              }
              function il(Y) {
                var me;
                return rl ? me = Y[rl] : me = Y.N, me == null ? 0 : me;
              }
              function pa(Y) {
                return Xs(Y, 1), Y;
              }
              function rs(Y) {
                return Array.isArray(Y) ? !!(il(Y) & 2) : !1;
              }
              function ma(Y) {
                if (!Array.isArray(Y))
                  throw Error("cannot mark non-array as immutable");
                Xs(Y, 2);
              }
              function Xo(Y) {
                return Y !== null && typeof Y == "object" && !Array.isArray(Y) && Y.constructor === Object;
              }
              var ks = Object.freeze(pa([]));
              function Zo(Y) {
                if (rs(Y.m))
                  throw Error("Cannot mutate an immutable Message");
              }
              var fo = typeof Symbol < "u" && typeof Symbol.hasInstance < "u";
              function ul(Y) {
                return { value: Y, configurable: !1, writable: !1, enumerable: !1 };
              }
              function na(Y, me, Ee) {
                return me === -1 ? null : me >= Y.i ? Y.g ? Y.g[me] : void 0 : Ee !== void 0 && Ee && Y.g && (Ee = Y.g[me], Ee != null) ? Ee : Y.m[me + Y.h];
              }
              function Wi(Y, me, Ee, je) {
                je = je === void 0 ? !1 : je, Zo(Y), me < Y.i && !je ? Y.m[me + Y.h] = Ee : (Y.g || (Y.g = Y.m[Y.i + Y.h] = {}))[me] = Ee;
              }
              function li(Y, me, Ee, je) {
                Ee = Ee === void 0 ? !0 : Ee, je = je === void 0 ? !1 : je;
                var Tt = na(Y, me, je);
                return Tt == null && (Tt = ks), rs(Y.m) ? Ee && (ma(Tt), Object.freeze(Tt)) : (Tt === ks || rs(Tt)) && (Tt = pa(Tt.slice()), Wi(Y, me, Tt, je)), Tt;
              }
              function ko(Y, me, Ee) {
                return Y = na(Y, me), Y = Y == null ? Y : +Y, Y == null ? Ee === void 0 ? 0 : Ee : Y;
              }
              function is(Y, me, Ee, je) {
                Y.j || (Y.j = {});
                var Tt = rs(Y.m), X = Y.j[Ee];
                if (!X) {
                  je = li(Y, Ee, !0, je === void 0 ? !1 : je), X = [], Tt = Tt || rs(je);
                  for (var j = 0; j < je.length; j++)
                    X[j] = new me(je[j]), Tt && ma(X[j].m);
                  Tt && (ma(X), Object.freeze(X)), Y.j[Ee] = X;
                }
                return X;
              }
              function So(Y, me, Ee, je, Tt) {
                var X = X === void 0 ? !1 : X;
                return Zo(Y), X = is(Y, Ee, me, X), Ee = je || new Ee(), Y = li(Y, me), Tt != null ? (X.splice(Tt, 0, Ee), Y.splice(Tt, 0, Ee.m)) : (X.push(Ee), Y.push(Ee.m)), Ee;
              }
              function wo(Y, me) {
                return Y = na(Y, me), Y == null ? 0 : Y;
              }
              function wn(Y, me) {
                return Y = na(Y, me), Y == null ? "" : Y;
              }
              function jn(Y) {
                switch (typeof Y) {
                  case "number":
                    return isFinite(Y) ? Y : String(Y);
                  case "object":
                    if (Y && !Array.isArray(Y)) {
                      if (Nl(Y))
                        return Nc(Y);
                      if (Y instanceof $a) {
                        var me = Y.L;
                        return me = me == null || typeof me == "string" ? me : Pl && me instanceof Uint8Array ? Nc(me) : null, (Y.L = me) || "";
                      }
                    }
                }
                return Y;
              }
              function hr(Y) {
                var me = Yo;
                return me = me === void 0 ? fi : me, Po(Y, me);
              }
              function po(Y, me) {
                if (Y != null) {
                  if (Array.isArray(Y))
                    Y = Po(Y, me);
                  else if (Xo(Y)) {
                    var Ee = {}, je;
                    for (je in Y)
                      Ee[je] = po(Y[je], me);
                    Y = Ee;
                  } else
                    Y = me(Y);
                  return Y;
                }
              }
              function Po(Y, me) {
                for (var Ee = Y.slice(), je = 0; je < Ee.length; je++)
                  Ee[je] = po(Ee[je], me);
                return Array.isArray(Y) && il(Y) & 1 && pa(Ee), Ee;
              }
              function Yo(Y) {
                return Y && typeof Y == "object" && Y.toJSON ? Y.toJSON() : (Y = jn(Y), Array.isArray(Y) ? hr(Y) : Y);
              }
              function fi(Y) {
                return Nl(Y) ? new Uint8Array(Y) : Y;
              }
              function ra(Y, me, Ee) {
                Y || (Y = ls), ls = null;
                var je = this.constructor.h;
                Y || (Y = je ? [je] : []), this.h = (je ? 0 : -1) - (this.constructor.g || 0), this.j = void 0, this.m = Y;
                e: {
                  if (je = this.m.length, Y = je - 1, je && (je = this.m[Y], Xo(je))) {
                    this.i = Y - this.h, this.g = je;
                    break e;
                  }
                  me !== void 0 && -1 < me ? (this.i = Math.max(me, Y + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
                }
                if (Ee)
                  for (me = 0; me < Ee.length; me++)
                    if (Y = Ee[me], Y < this.i)
                      Y += this.h, (je = this.m[Y]) ? Array.isArray(je) && pa(je) : this.m[Y] = ks;
                    else {
                      je = this.g || (this.g = this.m[this.i + this.h] = {});
                      var Tt = je[Y];
                      Tt ? Array.isArray(Tt) && pa(Tt) : je[Y] = ks;
                    }
              }
              ra.prototype.toJSON = function() {
                return hr(this.m);
              }, ra.prototype.toString = function() {
                return this.m.toString();
              };
              var ls;
              function xs() {
                ra.apply(this, arguments);
              }
              if (Nr(xs, ra), fo) {
                var Hs = {};
                Object.defineProperties(xs, (Hs[Symbol.hasInstance] = ul(function() {
                  throw Error("Cannot perform instanceof checks for MutableMessage");
                }), Hs));
              }
              function hl(Y, me, Ee) {
                if (Ee) {
                  var je = {}, Tt;
                  for (Tt in Ee) {
                    var X = Ee[Tt], j = X.ja;
                    j || (je.F = X.pa || X.ha.P, X.ba ? (je.U = Ol(X.ba), j = /* @__PURE__ */ function(Ae) {
                      return function(C, x, ee) {
                        return Ae.F(C, x, ee, Ae.U);
                      };
                    }(je)) : X.da ? (je.T = bs(X.X.g, X.da), j = /* @__PURE__ */ function(Ae) {
                      return function(C, x, ee) {
                        return Ae.F(C, x, ee, Ae.T);
                      };
                    }(je)) : j = je.F, X.ja = j), j(me, Y, X.X), je = { F: je.F, U: je.U, T: je.T };
                  }
                }
                Jl(me, Y);
              }
              var bl = Symbol();
              function os(Y, me, Ee) {
                return Y[bl] || (Y[bl] = function(je, Tt) {
                  return me(je, Tt, Ee);
                });
              }
              function Ps(Y) {
                var me = Y[bl];
                if (!me) {
                  var Ee = le(Y);
                  me = function(je, Tt) {
                    return Ie(je, Tt, Ee);
                  }, Y[bl] = me;
                }
                return me;
              }
              function dd(Y) {
                var me = Y.ba;
                if (me)
                  return Ps(me);
                if (me = Y.oa)
                  return os(Y.X.g, me, Y.da);
              }
              function Os(Y) {
                var me = dd(Y), Ee = Y.X, je = Y.ha.O;
                return me ? function(Tt, X) {
                  return je(Tt, X, Ee, me);
                } : function(Tt, X) {
                  return je(Tt, X, Ee);
                };
              }
              function cs(Y, me, Ee, je, Tt, X) {
                Y = Y();
                var j = 0;
                for (Y.length && typeof Y[0] != "number" && (Ee(me, Y[0]), j++); j < Y.length; ) {
                  Ee = Y[j++];
                  for (var Ae = j + 1; Ae < Y.length && typeof Y[Ae] != "number"; )
                    Ae++;
                  var C = Y[j++];
                  switch (Ae -= j, Ae) {
                    case 0:
                      je(me, Ee, C);
                      break;
                    case 1:
                      je(me, Ee, C, Y[j++]);
                      break;
                    case 2:
                      Tt(me, Ee, C, Y[j++], Y[j++]);
                      break;
                    case 3:
                      Ae = Y[j++];
                      var x = Y[j++], ee = Y[j++];
                      Array.isArray(ee) ? Tt(me, Ee, C, Ae, x, ee) : X(me, Ee, C, Ae, x, ee);
                      break;
                    case 4:
                      X(me, Ee, C, Y[j++], Y[j++], Y[j++], Y[j++]);
                      break;
                    default:
                      throw Error("unexpected number of binary field arguments: " + Ae);
                  }
                }
                return me;
              }
              var Il = Symbol();
              function Ol(Y) {
                var me = Y[Il];
                if (!me) {
                  var Ee = ol(Y);
                  me = function(je, Tt) {
                    return Mt(je, Tt, Ee);
                  }, Y[Il] = me;
                }
                return me;
              }
              function bs(Y, me) {
                var Ee = Y[Il];
                return Ee || (Ee = function(je, Tt) {
                  return hl(je, Tt, me);
                }, Y[Il] = Ee), Ee;
              }
              var Jc = Symbol();
              function Ks(Y, me) {
                Y.push(me);
              }
              function Bl(Y, me, Ee) {
                Y.push(me, Ee.P);
              }
              function nc(Y, me, Ee, je, Tt) {
                var X = Ol(Tt), j = Ee.P;
                Y.push(me, function(Ae, C, x) {
                  return j(Ae, C, x, je, X);
                });
              }
              function Oc(Y, me, Ee, je, Tt, X) {
                var j = bs(je, X), Ae = Ee.P;
                Y.push(me, function(C, x, ee) {
                  return Ae(C, x, ee, je, j);
                });
              }
              function ol(Y) {
                var me = Y[Jc];
                return me || cs(Y, Y[Jc] = [], Ks, Bl, nc, Oc);
              }
              var rc = Symbol();
              function Ld(Y, me) {
                Y[0] = me;
              }
              function xd(Y, me, Ee, je) {
                var Tt = Ee.O;
                Y[me] = je ? function(X, j, Ae) {
                  return Tt(X, j, Ae, je);
                } : Tt;
              }
              function ic(Y, me, Ee, je, Tt, X) {
                var j = Ee.O, Ae = Ps(Tt);
                Y[me] = function(C, x, ee) {
                  return j(C, x, ee, je, Ae, X);
                };
              }
              function fc(Y, me, Ee, je, Tt, X, j) {
                var Ae = Ee.O, C = os(je, Tt, X);
                Y[me] = function(x, ee, F) {
                  return Ae(x, ee, F, je, C, j);
                };
              }
              function le(Y) {
                var me = Y[rc];
                return me || cs(Y, Y[rc] = {}, Ld, xd, ic, fc);
              }
              function Ie(Y, me, Ee) {
                for (; Ua(me) && me.h != 4; ) {
                  var je = me.i, Tt = Ee[je];
                  if (!Tt) {
                    var X = Ee[0];
                    X && (X = X[je]) && (Tt = Ee[je] = Os(X));
                  }
                  if ((!Tt || !Tt(me, Y, je)) && (Tt = me, je = Y, X = Tt.j, go(Tt), !Tt.W)) {
                    var j = Tt.g.h;
                    Tt = Tt.g.g, Tt = X === Tt ? ta || (ta = new Uint8Array(0)) : Gs ? j.slice(X, Tt) : new Uint8Array(j.subarray(X, Tt)), (X = je.ca) ? X.push(Tt) : je.ca = [Tt];
                  }
                }
                return Y;
              }
              function Ze(Y, me, Ee) {
                if (Bs.length) {
                  var je = Bs.pop();
                  Y && (ss(je.g, Y), je.i = -1, je.h = -1), Y = je;
                } else
                  Y = new Ls(Y);
                try {
                  return Ie(new me(), Y, le(Ee));
                } finally {
                  me = Y.g, me.h = null, me.j = 0, me.i = 0, me.g = 0, me.v = !1, Y.i = -1, Y.h = -1, 100 > Bs.length && Bs.push(Y);
                }
              }
              function Mt(Y, me, Ee) {
                for (var je = Ee.length, Tt = je % 2 == 1, X = Tt ? 1 : 0; X < je; X += 2)
                  (0, Ee[X + 1])(me, Y, Ee[X]);
                hl(Y, me, Tt ? Ee[0] : void 0);
              }
              function yn(Y, me) {
                var Ee = new Ts();
                Mt(Y, Ee, ol(me)), Oa(Ee, Ee.g.end()), Y = new Uint8Array(Ee.h), me = Ee.i;
                for (var je = me.length, Tt = 0, X = 0; X < je; X++) {
                  var j = me[X];
                  Y.set(j, Tt), Tt += j.length;
                }
                return Ee.i = [Y], Y;
              }
              function nr(Y, me) {
                return { O: Y, P: me };
              }
              var mn = nr(function(Y, me, Ee) {
                if (Y.h !== 5)
                  return !1;
                Y = Y.g;
                var je = Y.h[Y.g], Tt = Y.h[Y.g + 1], X = Y.h[Y.g + 2], j = Y.h[Y.g + 3];
                return Y.g += 4, eo(Y), Tt = (je << 0 | Tt << 8 | X << 16 | j << 24) >>> 0, Y = 2 * (Tt >> 31) + 1, je = Tt >>> 23 & 255, Tt &= 8388607, Wi(me, Ee, je == 255 ? Tt ? NaN : 1 / 0 * Y : je == 0 ? Y * Math.pow(2, -149) * Tt : Y * Math.pow(2, je - 150) * (Tt + Math.pow(2, 23))), !0;
              }, function(Y, me, Ee) {
                if (me = na(me, Ee), me != null) {
                  ns(Y.g, 8 * Ee + 5), Y = Y.g;
                  var je = me;
                  je = (Ee = 0 > je ? 1 : 0) ? -je : je, je === 0 ? 0 < 1 / je ? To = Na = 0 : (Na = 0, To = 2147483648) : isNaN(je) ? (Na = 0, To = 2147483647) : 34028234663852886e22 < je ? (Na = 0, To = (Ee << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > je ? (je = Math.round(je / Math.pow(2, -149)), Na = 0, To = (Ee << 31 | je) >>> 0) : (me = Math.floor(Math.log(je) / Math.LN2), je *= Math.pow(2, -me), je = Math.round(8388608 * je), 16777216 <= je && ++me, Na = 0, To = (Ee << 31 | me + 127 << 23 | je & 8388607) >>> 0), Ee = To, Y.g.push(Ee >>> 0 & 255), Y.g.push(Ee >>> 8 & 255), Y.g.push(Ee >>> 16 & 255), Y.g.push(Ee >>> 24 & 255);
                }
              }), zn = nr(function(Y, me, Ee) {
                if (Y.h !== 0)
                  return !1;
                for (var je = Y.g, Tt = 128, X = 0, j = Y = 0; 4 > j && 128 <= Tt; j++)
                  Tt = je.h[je.g++], eo(je), X |= (Tt & 127) << 7 * j;
                if (128 <= Tt && (Tt = je.h[je.g++], eo(je), X |= (Tt & 127) << 28, Y |= (Tt & 127) >> 4), 128 <= Tt)
                  for (j = 0; 5 > j && 128 <= Tt; j++)
                    Tt = je.h[je.g++], eo(je), Y |= (Tt & 127) << 7 * j + 3;
                if (128 > Tt)
                  je = X >>> 0, Tt = Y >>> 0, (Y = Tt & 2147483648) && (je = ~je + 1 >>> 0, Tt = ~Tt >>> 0, je == 0 && (Tt = Tt + 1 >>> 0)), je = 4294967296 * Tt + (je >>> 0);
                else
                  throw bo();
                return Wi(me, Ee, Y ? -je : je), !0;
              }, function(Y, me, Ee) {
                if (me = na(me, Ee), me != null && me != null) {
                  ns(Y.g, 8 * Ee), Y = Y.g;
                  var je = me;
                  for (Ee = 0 > je, je = Math.abs(je), me = je >>> 0, je = Math.floor((je - me) / 4294967296), je >>>= 0, Ee && (je = ~je >>> 0, me = (~me >>> 0) + 1, 4294967295 < me && (me = 0, je++, 4294967295 < je && (je = 0))), To = me, Na = je, Ee = To, me = Na; 0 < me || 127 < Ee; )
                    Y.g.push(Ee & 127 | 128), Ee = (Ee >>> 7 | me << 25) >>> 0, me >>>= 7;
                  Y.g.push(Ee);
                }
              }), Wr = nr(function(Y, me, Ee) {
                return Y.h !== 0 ? !1 : (Wi(me, Ee, Pa(Y.g)), !0);
              }, function(Y, me, Ee) {
                if (me = na(me, Ee), me != null && me != null)
                  if (ns(Y.g, 8 * Ee), Y = Y.g, Ee = me, 0 <= Ee)
                    ns(Y, Ee);
                  else {
                    for (me = 0; 9 > me; me++)
                      Y.g.push(Ee & 127 | 128), Ee >>= 7;
                    Y.g.push(1);
                  }
              }), ci = nr(function(Y, me, Ee) {
                if (Y.h !== 2)
                  return !1;
                var je = Pa(Y.g) >>> 0;
                Y = Y.g;
                var Tt = Y.g;
                Y.g += je, eo(Y), Y = Y.h;
                var X;
                if (Ac)
                  (X = Wl) || (X = Wl = new TextDecoder("utf-8", { fatal: !0 })), X = X.decode(Y.subarray(Tt, Tt + je));
                else {
                  je = Tt + je;
                  for (var j = [], Ae = null, C, x, ee; Tt < je; )
                    C = Y[Tt++], 128 > C ? j.push(C) : 224 > C ? Tt >= je ? ts() : (x = Y[Tt++], 194 > C || (x & 192) !== 128 ? (Tt--, ts()) : j.push((C & 31) << 6 | x & 63)) : 240 > C ? Tt >= je - 1 ? ts() : (x = Y[Tt++], (x & 192) !== 128 || C === 224 && 160 > x || C === 237 && 160 <= x || ((X = Y[Tt++]) & 192) !== 128 ? (Tt--, ts()) : j.push((C & 15) << 12 | (x & 63) << 6 | X & 63)) : 244 >= C ? Tt >= je - 2 ? ts() : (x = Y[Tt++], (x & 192) !== 128 || (C << 28) + (x - 144) >> 30 || ((X = Y[Tt++]) & 192) !== 128 || ((ee = Y[Tt++]) & 192) !== 128 ? (Tt--, ts()) : (C = (C & 7) << 18 | (x & 63) << 12 | (X & 63) << 6 | ee & 63, C -= 65536, j.push((C >> 10 & 1023) + 55296, (C & 1023) + 56320))) : ts(), 8192 <= j.length && (Ae = tl(Ae, j), j.length = 0);
                  X = tl(Ae, j);
                }
                return Wi(me, Ee, X), !0;
              }, function(Y, me, Ee) {
                if (me = na(me, Ee), me != null) {
                  var je = !1;
                  if (je = je === void 0 ? !1 : je, Uc) {
                    if (je && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(me))
                      throw Error("Found an unpaired surrogate");
                    me = (Hl || (Hl = new TextEncoder())).encode(me);
                  } else {
                    for (var Tt = 0, X = new Uint8Array(3 * me.length), j = 0; j < me.length; j++) {
                      var Ae = me.charCodeAt(j);
                      if (128 > Ae)
                        X[Tt++] = Ae;
                      else {
                        if (2048 > Ae)
                          X[Tt++] = Ae >> 6 | 192;
                        else {
                          if (55296 <= Ae && 57343 >= Ae) {
                            if (56319 >= Ae && j < me.length) {
                              var C = me.charCodeAt(++j);
                              if (56320 <= C && 57343 >= C) {
                                Ae = 1024 * (Ae - 55296) + C - 56320 + 65536, X[Tt++] = Ae >> 18 | 240, X[Tt++] = Ae >> 12 & 63 | 128, X[Tt++] = Ae >> 6 & 63 | 128, X[Tt++] = Ae & 63 | 128;
                                continue;
                              } else
                                j--;
                            }
                            if (je)
                              throw Error("Found an unpaired surrogate");
                            Ae = 65533;
                          }
                          X[Tt++] = Ae >> 12 | 224, X[Tt++] = Ae >> 6 & 63 | 128;
                        }
                        X[Tt++] = Ae & 63 | 128;
                      }
                    }
                    me = X.subarray(0, Tt);
                  }
                  ns(Y.g, 8 * Ee + 2), ns(Y.g, me.length), Oa(Y, Y.g.end()), Oa(Y, me);
                }
              }), Ki = nr(function(Y, me, Ee, je, Tt) {
                if (Y.h !== 2)
                  return !1;
                me = So(me, Ee, je), Ee = Y.g.i, je = Pa(Y.g) >>> 0;
                var X = Y.g.g + je, j = X - Ee;
                if (0 >= j && (Y.g.i = X, Tt(me, Y), j = X - Y.g.g), j)
                  throw Error("Message parsing ended unexpectedly. Expected to read " + (je + " bytes, instead read " + (je - j) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                return Y.g.g = X, Y.g.i = Ee, !0;
              }, function(Y, me, Ee, je, Tt) {
                if (me = is(me, je, Ee), me != null)
                  for (je = 0; je < me.length; je++) {
                    var X = Y;
                    ns(X.g, 8 * Ee + 2);
                    var j = X.g.end();
                    Oa(X, j), j.push(X.h), X = j, Tt(me[je], Y), j = Y;
                    var Ae = X.pop();
                    for (Ae = j.h + j.g.length() - Ae; 127 < Ae; )
                      X.push(Ae & 127 | 128), Ae >>>= 7, j.h++;
                    X.push(Ae), j.h++;
                  }
              });
              function Gi() {
                xs.apply(this, arguments);
              }
              if (Nr(Gi, xs), fo) {
                var yo = {};
                Object.defineProperties(Gi, (yo[Symbol.hasInstance] = ul(Object[Symbol.hasInstance]), yo));
              }
              function Xi(Y) {
                Gi.call(this, Y);
              }
              Nr(Xi, Gi);
              function vi() {
                return [1, Wr, 2, mn, 3, ci, 4, ci];
              }
              function Yi(Y) {
                Gi.call(this, Y, -1, Lo);
              }
              Nr(Yi, Gi), Yi.prototype.addClassification = function(Y, me) {
                return So(this, 1, Xi, Y, me), this;
              };
              function Fo() {
                return [1, Ki, Xi, vi];
              }
              var Lo = [1];
              function ia(Y) {
                Gi.call(this, Y);
              }
              Nr(ia, Gi);
              function ha() {
                return [1, mn, 2, mn, 3, mn, 4, mn, 5, mn];
              }
              function ds(Y) {
                Gi.call(this, Y, -1, he);
              }
              Nr(ds, Gi);
              function q() {
                return [1, Ki, ia, ha];
              }
              var he = [1];
              function ve(Y) {
                Gi.call(this, Y);
              }
              Nr(ve, Gi);
              function bt() {
                return [1, mn, 2, mn, 3, mn, 4, mn, 5, mn, 6, zn];
              }
              function Ot(Y, me, Ee) {
                if (Ee = Y.createShader(Ee === 0 ? Y.VERTEX_SHADER : Y.FRAGMENT_SHADER), Y.shaderSource(Ee, me), Y.compileShader(Ee), !Y.getShaderParameter(Ee, Y.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + Y.getShaderInfoLog(Ee));
                return Ee;
              }
              function In(Y) {
                return is(Y, Xi, 1).map(function(me) {
                  return { index: wo(me, 1), score: ko(me, 2), label: na(me, 3) != null ? wn(me, 3) : void 0, displayName: na(me, 4) != null ? wn(me, 4) : void 0 };
                });
              }
              function en(Y) {
                return { x: ko(Y, 1), y: ko(Y, 2), z: ko(Y, 3), visibility: na(Y, 4) != null ? ko(Y, 4) : void 0 };
              }
              function Gn(Y) {
                return Y.map(function(me) {
                  return is(Ze(me, ds, q), ia, 1).map(en);
                });
              }
              function dr(Y, me) {
                this.h = Y, this.g = me, this.l = 0;
              }
              function D(Y, me, Ee) {
                return Fe(Y, me), typeof Y.g.canvas.transferToImageBitmap == "function" ? n.resolve(Y.g.canvas.transferToImageBitmap()) : Ee ? n.resolve(Y.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(Y.g.canvas) : (Y.i === void 0 && (Y.i = document.createElement("canvas")), new n(function(je) {
                  Y.i.height = Y.g.canvas.height, Y.i.width = Y.g.canvas.width, Y.i.getContext("2d", {}).drawImage(Y.g.canvas, 0, 0, Y.g.canvas.width, Y.g.canvas.height), je(Y.i);
                }));
              }
              function Fe(Y, me) {
                var Ee = Y.g;
                if (Y.o === void 0) {
                  var je = Ot(Ee, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), Tt = Ot(Ee, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), X = Ee.createProgram();
                  if (Ee.attachShader(X, je), Ee.attachShader(X, Tt), Ee.linkProgram(X), !Ee.getProgramParameter(X, Ee.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + Ee.getProgramInfoLog(X));
                  je = Y.o = X, Ee.useProgram(je), Tt = Ee.getUniformLocation(je, "sampler0"), Y.j = { K: Ee.getAttribLocation(je, "aVertex"), J: Ee.getAttribLocation(je, "aTex"), qa: Tt }, Y.u = Ee.createBuffer(), Ee.bindBuffer(Ee.ARRAY_BUFFER, Y.u), Ee.enableVertexAttribArray(Y.j.K), Ee.vertexAttribPointer(Y.j.K, 2, Ee.FLOAT, !1, 0, 0), Ee.bufferData(Ee.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), Ee.STATIC_DRAW), Ee.bindBuffer(Ee.ARRAY_BUFFER, null), Y.s = Ee.createBuffer(), Ee.bindBuffer(Ee.ARRAY_BUFFER, Y.s), Ee.enableVertexAttribArray(Y.j.J), Ee.vertexAttribPointer(
                    Y.j.J,
                    2,
                    Ee.FLOAT,
                    !1,
                    0,
                    0
                  ), Ee.bufferData(Ee.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), Ee.STATIC_DRAW), Ee.bindBuffer(Ee.ARRAY_BUFFER, null), Ee.uniform1i(Tt, 0);
                }
                je = Y.j, Ee.useProgram(Y.o), Ee.canvas.width = me.width, Ee.canvas.height = me.height, Ee.viewport(0, 0, me.width, me.height), Ee.activeTexture(Ee.TEXTURE0), Y.h.bindTexture2d(me.glName), Ee.enableVertexAttribArray(je.K), Ee.bindBuffer(Ee.ARRAY_BUFFER, Y.u), Ee.vertexAttribPointer(je.K, 2, Ee.FLOAT, !1, 0, 0), Ee.enableVertexAttribArray(je.J), Ee.bindBuffer(Ee.ARRAY_BUFFER, Y.s), Ee.vertexAttribPointer(
                  je.J,
                  2,
                  Ee.FLOAT,
                  !1,
                  0,
                  0
                ), Ee.bindFramebuffer(Ee.DRAW_FRAMEBUFFER ? Ee.DRAW_FRAMEBUFFER : Ee.FRAMEBUFFER, null), Ee.clearColor(0, 0, 0, 0), Ee.clear(Ee.COLOR_BUFFER_BIT), Ee.colorMask(!0, !0, !0, !0), Ee.drawArrays(Ee.TRIANGLE_FAN, 0, 4), Ee.disableVertexAttribArray(je.K), Ee.disableVertexAttribArray(je.J), Ee.bindBuffer(Ee.ARRAY_BUFFER, null), Y.h.bindTexture2d(0);
              }
              function Se(Y) {
                this.g = Y;
              }
              var it = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function Gt(Y, me) {
                return me + Y;
              }
              function nn(Y, me) {
                window[Y] = me;
              }
              function Pt(Y) {
                var me = document.createElement("script");
                return me.setAttribute("src", Y), me.setAttribute("crossorigin", "anonymous"), new n(function(Ee) {
                  me.addEventListener("load", function() {
                    Ee();
                  }, !1), me.addEventListener("error", function() {
                    Ee();
                  }, !1), document.body.appendChild(me);
                });
              }
              function Mn() {
                return Mr(function(Y) {
                  switch (Y.g) {
                    case 1:
                      return Y.o = 2, Un(Y, WebAssembly.instantiate(it), 4);
                    case 4:
                      Y.g = 3, Y.o = 0;
                      break;
                    case 2:
                      return Y.o = 0, Y.j = null, Y.return(!1);
                    case 3:
                      return Y.return(!0);
                  }
                });
              }
              function Nn(Y) {
                if (this.g = Y, this.listeners = {}, this.j = {}, this.H = {}, this.o = {}, this.u = {}, this.I = this.s = this.$ = !0, this.D = n.resolve(), this.Z = "", this.C = {}, this.locateFile = Y && Y.locateFile || Gt, typeof window == "object")
                  var me = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  me = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.aa = me, Y.options) {
                  me = rt(Object.keys(Y.options));
                  for (var Ee = me.next(); !Ee.done; Ee = me.next()) {
                    Ee = Ee.value;
                    var je = Y.options[Ee].default;
                    je !== void 0 && (this.j[Ee] = typeof je == "function" ? je() : je);
                  }
                }
              }
              E = Nn.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function Xr(Y) {
                var me, Ee, je, Tt, X, j, Ae, C, x, ee, F;
                return Mr(function(M) {
                  switch (M.g) {
                    case 1:
                      return Y.$ ? (me = Y.g.files === void 0 ? [] : typeof Y.g.files == "function" ? Y.g.files(Y.j) : Y.g.files, Un(M, Mn(), 2)) : M.return();
                    case 2:
                      if (Ee = M.h, typeof window == "object")
                        return nn("createMediapipeSolutionsWasm", { locateFile: Y.locateFile }), nn("createMediapipeSolutionsPackedAssets", { locateFile: Y.locateFile }), j = me.filter(function(H) {
                          return H.data !== void 0;
                        }), Ae = me.filter(function(H) {
                          return H.data === void 0;
                        }), C = n.all(j.map(function(H) {
                          var ce = di(Y, H.url);
                          if (H.path !== void 0) {
                            var ke = H.path;
                            ce = ce.then(function(st) {
                              return Y.overrideFile(ke, st), n.resolve(st);
                            });
                          }
                          return ce;
                        })), x = n.all(Ae.map(function(H) {
                          return H.simd === void 0 || H.simd && Ee || !H.simd && !Ee ? Pt(Y.locateFile(H.url, Y.aa)) : n.resolve();
                        })).then(function() {
                          var H, ce, ke;
                          return Mr(function(st) {
                            if (st.g == 1)
                              return H = window.createMediapipeSolutionsWasm, ce = window.createMediapipeSolutionsPackedAssets, ke = Y, Un(st, H(ce), 2);
                            ke.h = st.h, st.g = 0;
                          });
                        }), ee = function() {
                          return Mr(function(H) {
                            return Y.g.graph && Y.g.graph.url ? H = Un(
                              H,
                              di(Y, Y.g.graph.url),
                              0
                            ) : (H.g = 0, H = void 0), H;
                          });
                        }(), Un(M, n.all([x, C, ee]), 7);
                      if (typeof importScripts != "function")
                        throw Error("solutions can only be loaded on a web page or in a web worker");
                      return je = me.filter(function(H) {
                        return H.simd === void 0 || H.simd && Ee || !H.simd && !Ee;
                      }).map(function(H) {
                        return Y.locateFile(H.url, Y.aa);
                      }), importScripts.apply(null, Nt(je)), Tt = Y, Un(M, createMediapipeSolutionsWasm(Module), 6);
                    case 6:
                      Tt.h = M.h, Y.l = new OffscreenCanvas(1, 1), Y.h.canvas = Y.l, X = Y.h.GL.createContext(Y.l, {
                        antialias: !1,
                        alpha: !1,
                        na: typeof WebGL2RenderingContext < "u" ? 2 : 1
                      }), Y.h.GL.makeContextCurrent(X), M.g = 4;
                      break;
                    case 7:
                      if (Y.l = document.createElement("canvas"), F = Y.l.getContext("webgl2", {}), !F && (F = Y.l.getContext("webgl", {}), !F))
                        return alert("Failed to create WebGL canvas context when passing video frame."), M.return();
                      Y.G = F, Y.h.canvas = Y.l, Y.h.createContext(Y.l, !0, !0, {});
                    case 4:
                      Y.i = new Y.h.SolutionWasm(), Y.$ = !1, M.g = 0;
                  }
                });
              }
              function ei(Y) {
                var me, Ee, je, Tt, X, j, Ae, C;
                return Mr(function(x) {
                  if (x.g == 1) {
                    if (Y.g.graph && Y.g.graph.url && Y.Z === Y.g.graph.url)
                      return x.return();
                    if (Y.s = !0, !Y.g.graph || !Y.g.graph.url) {
                      x.g = 2;
                      return;
                    }
                    return Y.Z = Y.g.graph.url, Un(x, di(Y, Y.g.graph.url), 3);
                  }
                  for (x.g != 2 && (me = x.h, Y.i.loadGraph(me)), Ee = rt(Object.keys(Y.C)), je = Ee.next(); !je.done; je = Ee.next())
                    Tt = je.value, Y.i.overrideFile(Tt, Y.C[Tt]);
                  if (Y.C = {}, Y.g.listeners)
                    for (X = rt(Y.g.listeners), j = X.next(); !j.done; j = X.next())
                      Ae = j.value, Ai(Y, Ae);
                  C = Y.j, Y.j = {}, Y.setOptions(C), x.g = 0;
                });
              }
              E.reset = function() {
                var Y = this;
                return Mr(function(me) {
                  Y.i && (Y.i.reset(), Y.o = {}, Y.u = {}), me.g = 0;
                });
              }, E.setOptions = function(Y, me) {
                var Ee = this;
                if (me = me || this.g.options) {
                  for (var je = [], Tt = [], X = {}, j = rt(Object.keys(Y)), Ae = j.next(); !Ae.done; X = { R: X.R, S: X.S }, Ae = j.next()) {
                    var C = Ae.value;
                    C in this.j && this.j[C] === Y[C] || (this.j[C] = Y[C], Ae = me[C], Ae !== void 0 && (Ae.onChange && (X.R = Ae.onChange, X.S = Y[C], je.push(/* @__PURE__ */ function(x) {
                      return function() {
                        var ee;
                        return Mr(function(F) {
                          if (F.g == 1)
                            return Un(F, x.R(x.S), 2);
                          ee = F.h, ee === !0 && (Ee.s = !0), F.g = 0;
                        });
                      };
                    }(X))), Ae.graphOptionXref && (C = { valueNumber: Ae.type === 1 ? Y[C] : 0, valueBoolean: Ae.type === 0 ? Y[C] : !1, valueString: Ae.type === 2 ? Y[C] : "" }, Ae = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), Ae.graphOptionXref), C), Tt.push(Ae))));
                  }
                  (je.length !== 0 || Tt.length !== 0) && (this.s = !0, this.B = (this.B === void 0 ? [] : this.B).concat(Tt), this.A = (this.A === void 0 ? [] : this.A).concat(je));
                }
              };
              function ji(Y) {
                var me, Ee, je, Tt, X, j, Ae;
                return Mr(function(C) {
                  switch (C.g) {
                    case 1:
                      if (!Y.s)
                        return C.return();
                      if (!Y.A) {
                        C.g = 2;
                        break;
                      }
                      me = rt(Y.A), Ee = me.next();
                    case 3:
                      if (Ee.done) {
                        C.g = 5;
                        break;
                      }
                      return je = Ee.value, Un(C, je(), 4);
                    case 4:
                      Ee = me.next(), C.g = 3;
                      break;
                    case 5:
                      Y.A = void 0;
                    case 2:
                      if (Y.B) {
                        for (Tt = new Y.h.GraphOptionChangeRequestList(), X = rt(Y.B), j = X.next(); !j.done; j = X.next())
                          Ae = j.value, Tt.push_back(Ae);
                        Y.i.changeOptions(Tt), Tt.delete(), Y.B = void 0;
                      }
                      Y.s = !1, C.g = 0;
                  }
                });
              }
              E.initialize = function() {
                var Y = this;
                return Mr(function(me) {
                  return me.g == 1 ? Un(me, Xr(Y), 2) : me.g != 3 ? Un(me, ei(Y), 3) : Un(me, ji(Y), 0);
                });
              };
              function di(Y, me) {
                var Ee, je;
                return Mr(function(Tt) {
                  return me in Y.H ? Tt.return(Y.H[me]) : (Ee = Y.locateFile(me, ""), je = fetch(Ee).then(function(X) {
                    return X.arrayBuffer();
                  }), Y.H[me] = je, Tt.return(je));
                });
              }
              E.overrideFile = function(Y, me) {
                this.i ? this.i.overrideFile(Y, me) : this.C[Y] = me;
              }, E.clearOverriddenFiles = function() {
                this.C = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(Y, me) {
                var Ee = this, je, Tt, X, j, Ae, C, x, ee, F;
                return Mr(function(M) {
                  switch (M.g) {
                    case 1:
                      return Ee.g.inputs ? (je = 1e3 * (me == null ? performance.now() : me), Un(M, Ee.D, 2)) : M.return();
                    case 2:
                      return Un(M, Ee.initialize(), 3);
                    case 3:
                      for (Tt = new Ee.h.PacketDataList(), X = rt(Object.keys(Y)), j = X.next(); !j.done; j = X.next())
                        if (Ae = j.value, C = Ee.g.inputs[Ae]) {
                          e: {
                            var H = Y[Ae];
                            switch (C.type) {
                              case "video":
                                var ce = Ee.o[C.stream];
                                if (ce || (ce = new dr(Ee.h, Ee.G), Ee.o[C.stream] = ce), ce.l === 0 && (ce.l = ce.h.createTexture()), typeof HTMLVideoElement < "u" && H instanceof HTMLVideoElement)
                                  var ke = H.videoWidth, st = H.videoHeight;
                                else
                                  typeof HTMLImageElement < "u" && H instanceof HTMLImageElement ? (ke = H.naturalWidth, st = H.naturalHeight) : (ke = H.width, st = H.height);
                                st = { glName: ce.l, width: ke, height: st }, ke = ce.g, ke.canvas.width = st.width, ke.canvas.height = st.height, ke.activeTexture(ke.TEXTURE0), ce.h.bindTexture2d(ce.l), ke.texImage2D(ke.TEXTURE_2D, 0, ke.RGBA, ke.RGBA, ke.UNSIGNED_BYTE, H), ce.h.bindTexture2d(0), ce = st;
                                break e;
                              case "detections":
                                for (ce = Ee.o[C.stream], ce || (ce = new Se(Ee.h), Ee.o[C.stream] = ce), ce.data || (ce.data = new ce.g.DetectionListData()), ce.data.reset(H.length), st = 0; st < H.length; ++st) {
                                  ke = H[st];
                                  var mt = ce.data, xt = mt.setBoundingBox, dn = st, Bn = ke.ea, Zn = new ve();
                                  if (Wi(Zn, 1, Bn.ka), Wi(Zn, 2, Bn.la), Wi(Zn, 3, Bn.height), Wi(Zn, 4, Bn.width), Wi(Zn, 5, Bn.rotation), Wi(Zn, 6, Bn.ia), Bn = yn(Zn, bt), xt.call(mt, dn, Bn), ke.Y)
                                    for (mt = 0; mt < ke.Y.length; ++mt) {
                                      Zn = ke.Y[mt];
                                      var ir = !!Zn.visibility;
                                      xt = ce.data, dn = xt.addNormalizedLandmark, Bn = st, Zn = Object.assign(Object.assign({}, Zn), { visibility: ir ? Zn.visibility : 0 }), ir = new ia(), Wi(ir, 1, Zn.x), Wi(ir, 2, Zn.y), Wi(ir, 3, Zn.z), Zn.visibility && Wi(
                                        ir,
                                        4,
                                        Zn.visibility
                                      ), Zn = yn(ir, ha), dn.call(xt, Bn, Zn);
                                    }
                                  if (ke.V)
                                    for (mt = 0; mt < ke.V.length; ++mt)
                                      xt = ce.data, dn = xt.addClassification, Bn = st, Zn = ke.V[mt], ir = new Xi(), Wi(ir, 2, Zn.score), Zn.index && Wi(ir, 1, Zn.index), Zn.label && Wi(ir, 3, Zn.label), Zn.displayName && Wi(ir, 4, Zn.displayName), Zn = yn(ir, vi), dn.call(xt, Bn, Zn);
                                }
                                ce = ce.data;
                                break e;
                              default:
                                ce = {};
                            }
                          }
                          switch (x = ce, ee = C.stream, C.type) {
                            case "video":
                              Tt.pushTexture2d(Object.assign(Object.assign({}, x), { stream: ee, timestamp: je }));
                              break;
                            case "detections":
                              F = x, F.stream = ee, F.timestamp = je, Tt.pushDetectionList(F);
                              break;
                            default:
                              throw Error("Unknown input config type: '" + C.type + "'");
                          }
                        }
                      return Ee.i.send(Tt), Un(M, Ee.D, 4);
                    case 4:
                      Tt.delete(), M.g = 0;
                  }
                });
              };
              function Cr(Y, me, Ee) {
                var je, Tt, X, j, Ae, C, x, ee, F, M, H, ce, ke, st;
                return Mr(function(mt) {
                  switch (mt.g) {
                    case 1:
                      if (!Ee)
                        return mt.return(me);
                      for (je = {}, Tt = 0, X = rt(Object.keys(Ee)), j = X.next(); !j.done; j = X.next())
                        Ae = j.value, C = Ee[Ae], typeof C != "string" && C.type === "texture" && me[C.stream] !== void 0 && ++Tt;
                      1 < Tt && (Y.I = !1), x = rt(Object.keys(Ee)), j = x.next();
                    case 2:
                      if (j.done) {
                        mt.g = 4;
                        break;
                      }
                      if (ee = j.value, F = Ee[ee], typeof F == "string")
                        return ke = je, st = ee, Un(mt, ni(Y, ee, me[F]), 14);
                      if (M = me[F.stream], F.type === "detection_list") {
                        if (M) {
                          for (var xt = M.getRectList(), dn = M.getLandmarksList(), Bn = M.getClassificationsList(), Zn = [], ir = 0; ir < xt.size(); ++ir) {
                            var Ur = Ze(xt.get(ir), ve, bt);
                            Ur = { ea: { ka: ko(Ur, 1), la: ko(Ur, 2), height: ko(Ur, 3), width: ko(Ur, 4), rotation: ko(Ur, 5, 0), ia: wo(Ur, 6) }, Y: is(Ze(dn.get(ir), ds, q), ia, 1).map(en), V: In(Ze(Bn.get(ir), Yi, Fo)) }, Zn.push(Ur);
                          }
                          xt = Zn;
                        } else
                          xt = [];
                        je[ee] = xt, mt.g = 7;
                        break;
                      }
                      if (F.type === "proto_list") {
                        if (M) {
                          for (xt = Array(M.size()), dn = 0; dn < M.size(); dn++)
                            xt[dn] = M.get(dn);
                          M.delete();
                        } else
                          xt = [];
                        je[ee] = xt, mt.g = 7;
                        break;
                      }
                      if (M === void 0) {
                        mt.g = 3;
                        break;
                      }
                      if (F.type === "float_list") {
                        je[ee] = M, mt.g = 7;
                        break;
                      }
                      if (F.type === "proto") {
                        je[ee] = M, mt.g = 7;
                        break;
                      }
                      if (F.type !== "texture")
                        throw Error("Unknown output config type: '" + F.type + "'");
                      return H = Y.u[ee], H || (H = new dr(Y.h, Y.G), Y.u[ee] = H), Un(mt, D(H, M, Y.I), 13);
                    case 13:
                      ce = mt.h, je[ee] = ce;
                    case 7:
                      F.transform && je[ee] && (je[ee] = F.transform(je[ee])), mt.g = 3;
                      break;
                    case 14:
                      ke[st] = mt.h;
                    case 3:
                      j = x.next(), mt.g = 2;
                      break;
                    case 4:
                      return mt.return(je);
                  }
                });
              }
              function ni(Y, me, Ee) {
                var je;
                return Mr(function(Tt) {
                  return typeof Ee == "number" || Ee instanceof Uint8Array || Ee instanceof Y.h.Uint8BlobList ? Tt.return(Ee) : Ee instanceof Y.h.Texture2dDataOut ? (je = Y.u[me], je || (je = new dr(Y.h, Y.G), Y.u[me] = je), Tt.return(D(je, Ee, Y.I))) : Tt.return(void 0);
                });
              }
              function Ai(Y, me) {
                for (var Ee = me.name || "$", je = [].concat(Nt(me.wants)), Tt = new Y.h.StringList(), X = rt(me.wants), j = X.next(); !j.done; j = X.next())
                  Tt.push_back(j.value);
                X = Y.h.PacketListener.implement({ onResults: function(Ae) {
                  for (var C = {}, x = 0; x < me.wants.length; ++x)
                    C[je[x]] = Ae.get(x);
                  var ee = Y.listeners[Ee];
                  ee && (Y.D = Cr(Y, C, me.outs).then(function(F) {
                    F = ee(F);
                    for (var M = 0; M < me.wants.length; ++M) {
                      var H = C[je[M]];
                      typeof H == "object" && H.hasOwnProperty && H.hasOwnProperty("delete") && H.delete();
                    }
                    F && (Y.D = F);
                  }));
                } }), Y.i.attachMultiListener(Tt, X), Tt.delete();
              }
              E.onResults = function(Y, me) {
                this.listeners[me || "$"] = Y;
              }, Ji("Solution", Nn), Ji("OptionType", { BOOL: 0, NUMBER: 1, ma: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function Ri(Y) {
                return Y === void 0 && (Y = 0), Y === 1 ? "hand_landmark_full.tflite" : "hand_landmark_lite.tflite";
              }
              function Ii(Y) {
                var me = this;
                Y = Y || {}, this.g = new Nn({ locateFile: Y.locateFile, files: function(Ee) {
                  return [{ url: "hands_solution_packed_assets_loader.js" }, { simd: !1, url: "hands_solution_wasm_bin.js" }, { simd: !0, url: "hands_solution_simd_wasm_bin.js" }, { data: !0, url: Ri(Ee.modelComplexity) }];
                }, graph: { url: "hands.binarypb" }, inputs: { image: { type: "video", stream: "input_frames_gpu" } }, listeners: [{ wants: ["multi_hand_landmarks", "multi_hand_world_landmarks", "image_transformed", "multi_handedness"], outs: {
                  image: "image_transformed",
                  multiHandLandmarks: { type: "proto_list", stream: "multi_hand_landmarks", transform: Gn },
                  multiHandWorldLandmarks: { type: "proto_list", stream: "multi_hand_world_landmarks", transform: Gn },
                  multiHandedness: { type: "proto_list", stream: "multi_handedness", transform: function(Ee) {
                    return Ee.map(function(je) {
                      return In(Ze(je, Yi, Fo))[0];
                    });
                  } }
                } }], options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: typeof window != "object" || window.navigator === void 0 ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, maxNumHands: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculator", fieldName: "int_value" } }, modelComplexity: {
                  type: 1,
                  graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" },
                  onChange: function(Ee) {
                    var je, Tt, X;
                    return Mr(function(j) {
                      return j.g == 1 ? (je = Ri(Ee), Tt = "third_party/mediapipe/modules/hand_landmark/" + je, Un(j, di(me.g, je), 2)) : (X = j.h, me.g.overrideFile(Tt, X), j.return(!0));
                    });
                  }
                }, minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "handlandmarktrackinggpu__palmdetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } }, minTrackingConfidence: { type: 1, graphOptionXref: {
                  calculatorType: "ThresholdingCalculator",
                  calculatorName: "handlandmarktrackinggpu__handlandmarkgpu__ThresholdingCalculator",
                  fieldName: "threshold"
                } } } });
              }
              E = Ii.prototype, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(Y) {
                this.g.onResults(Y);
              }, E.initialize = function() {
                var Y = this;
                return Mr(function(me) {
                  return Un(me, Y.g.initialize(), 0);
                });
              }, E.reset = function() {
                this.g.reset();
              }, E.send = function(Y) {
                var me = this;
                return Mr(function(Ee) {
                  return Un(Ee, me.g.send(Y), 0);
                });
              }, E.setOptions = function(Y) {
                this.g.setOptions(Y);
              }, Ji("Hands", Ii), Ji("HAND_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8], [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16], [13, 17], [0, 17], [17, 18], [18, 19], [19, 20]]), Ji("VERSION", "0.4.1646424915");
            }).call(ln);
            var tt = {};
            (function() {
              var E;
              function R(C) {
                var x = 0;
                return function() {
                  return x < C.length ? { done: !1, value: C[x++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(C, x, ee) {
                return C == Array.prototype || C == Object.prototype || (C[x] = ee.value), C;
              };
              function ie(C) {
                C = [typeof globalThis == "object" && globalThis, C, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var x = 0; x < C.length; ++x) {
                  var ee = C[x];
                  if (ee && ee.Math == Math)
                    return ee;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(C, x) {
                if (x)
                  e: {
                    var ee = pe;
                    C = C.split(".");
                    for (var F = 0; F < C.length - 1; F++) {
                      var M = C[F];
                      if (!(M in ee))
                        break e;
                      ee = ee[M];
                    }
                    C = C[C.length - 1], F = ee[C], x = x(F), x != F && x != null && S(ee, C, { configurable: !0, writable: !0, value: x });
                  }
              }
              De("Symbol", function(C) {
                function x(H) {
                  if (this instanceof x)
                    throw new TypeError("Symbol is not a constructor");
                  return new ee(F + (H || "") + "_" + M++, H);
                }
                function ee(H, ce) {
                  this.g = H, S(this, "description", { configurable: !0, writable: !0, value: ce });
                }
                if (C)
                  return C;
                ee.prototype.toString = function() {
                  return this.g;
                };
                var F = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", M = 0;
                return x;
              }), De("Symbol.iterator", function(C) {
                if (C)
                  return C;
                C = Symbol("Symbol.iterator");
                for (var x = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), ee = 0; ee < x.length; ee++) {
                  var F = pe[x[ee]];
                  typeof F == "function" && typeof F.prototype[C] != "function" && S(F.prototype, C, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return C;
              });
              function ht(C) {
                return C = { next: C }, C[Symbol.iterator] = function() {
                  return this;
                }, C;
              }
              function rt(C) {
                var x = typeof Symbol < "u" && Symbol.iterator && C[Symbol.iterator];
                return x ? x.call(C) : { next: R(C) };
              }
              function Nt(C) {
                if (!(C instanceof Array)) {
                  C = rt(C);
                  for (var x, ee = []; !(x = C.next()).done; )
                    ee.push(x.value);
                  C = ee;
                }
                return C;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(C) {
                function x() {
                }
                return x.prototype = C, new x();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(C, x) {
                  if (C.__proto__ = x, C.__proto__ !== x)
                    throw new TypeError(C + " is not extensible");
                  return C;
                } : null;
              }
              var br = cr;
              function Nr(C, x) {
                if (C.prototype = Pn(x.prototype), C.prototype.constructor = C, br)
                  br(C, x);
                else
                  for (var ee in x)
                    if (ee != "prototype")
                      if (Object.defineProperties) {
                        var F = Object.getOwnPropertyDescriptor(x, ee);
                        F && Object.defineProperty(C, ee, F);
                      } else
                        C[ee] = x[ee];
                C.da = x.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
              }
              function qi(C) {
                if (C.l)
                  throw new TypeError("Generator is already running");
                C.l = !0;
              }
              $i.prototype.o = function(C) {
                this.h = C;
              };
              function Vo(C, x) {
                C.j = { U: x, V: !0 }, C.g = C.m || C.s;
              }
              $i.prototype.return = function(C) {
                this.j = { return: C }, this.g = this.s;
              };
              function Un(C, x, ee) {
                return C.g = ee, { value: x };
              }
              function el(C) {
                this.g = new $i(), this.h = C;
              }
              function Ys(C, x) {
                qi(C.g);
                var ee = C.g.i;
                return ee ? Ca(C, "return" in ee ? ee.return : function(F) {
                  return { value: F, done: !0 };
                }, x, C.g.return) : (C.g.return(x), lo(C));
              }
              function Ca(C, x, ee, F) {
                try {
                  var M = x.call(C.g.i, ee);
                  if (!(M instanceof Object))
                    throw new TypeError("Iterator result " + M + " is not an object");
                  if (!M.done)
                    return C.g.l = !1, M;
                  var H = M.value;
                } catch (ce) {
                  return C.g.i = null, Vo(C.g, ce), lo(C);
                }
                return C.g.i = null, F.call(C.g, H), lo(C);
              }
              function lo(C) {
                for (; C.g.g; )
                  try {
                    var x = C.h(C.g);
                    if (x)
                      return C.g.l = !1, { value: x.value, done: !1 };
                  } catch (ee) {
                    C.g.h = void 0, Vo(C.g, ee);
                  }
                if (C.g.l = !1, C.g.j) {
                  if (x = C.g.j, C.g.j = null, x.V)
                    throw x.U;
                  return { value: x.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(C) {
                this.next = function(x) {
                  return qi(C.g), C.g.i ? x = Ca(C, C.g.i.next, x, C.g.o) : (C.g.o(x), x = lo(C)), x;
                }, this.throw = function(x) {
                  return qi(C.g), C.g.i ? x = Ca(C, C.g.i.throw, x, C.g.o) : (Vo(C.g, x), x = lo(C)), x;
                }, this.return = function(x) {
                  return Ys(C, x);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(C) {
                function x(F) {
                  return C.next(F);
                }
                function ee(F) {
                  return C.throw(F);
                }
                return new n(function(F, M) {
                  function H(ce) {
                    ce.done ? F(ce.value) : n.resolve(ce.value).then(x, ee).then(H, M);
                  }
                  H(C.next());
                });
              }
              function Mr(C) {
                return Go(new Cc(new el(C)));
              }
              De("Promise", function(C) {
                function x(ce) {
                  this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                  var ke = this.j();
                  try {
                    ce(ke.resolve, ke.reject);
                  } catch (st) {
                    ke.reject(st);
                  }
                }
                function ee() {
                  this.g = null;
                }
                function F(ce) {
                  return ce instanceof x ? ce : new x(function(ke) {
                    ke(ce);
                  });
                }
                if (C)
                  return C;
                ee.prototype.h = function(ce) {
                  if (this.g == null) {
                    this.g = [];
                    var ke = this;
                    this.i(function() {
                      ke.l();
                    });
                  }
                  this.g.push(ce);
                };
                var M = pe.setTimeout;
                ee.prototype.i = function(ce) {
                  M(ce, 0);
                }, ee.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var ce = this.g;
                    this.g = [];
                    for (var ke = 0; ke < ce.length; ++ke) {
                      var st = ce[ke];
                      ce[ke] = null;
                      try {
                        st();
                      } catch (mt) {
                        this.j(mt);
                      }
                    }
                  }
                  this.g = null;
                }, ee.prototype.j = function(ce) {
                  this.i(function() {
                    throw ce;
                  });
                }, x.prototype.j = function() {
                  function ce(mt) {
                    return function(xt) {
                      st || (st = !0, mt.call(ke, xt));
                    };
                  }
                  var ke = this, st = !1;
                  return { resolve: ce(this.C), reject: ce(this.l) };
                }, x.prototype.C = function(ce) {
                  if (ce === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (ce instanceof x)
                    this.F(ce);
                  else {
                    e:
                      switch (typeof ce) {
                        case "object":
                          var ke = ce != null;
                          break e;
                        case "function":
                          ke = !0;
                          break e;
                        default:
                          ke = !1;
                      }
                    ke ? this.v(ce) : this.m(ce);
                  }
                }, x.prototype.v = function(ce) {
                  var ke = void 0;
                  try {
                    ke = ce.then;
                  } catch (st) {
                    this.l(st);
                    return;
                  }
                  typeof ke == "function" ? this.G(ke, ce) : this.m(ce);
                }, x.prototype.l = function(ce) {
                  this.s(2, ce);
                }, x.prototype.m = function(ce) {
                  this.s(1, ce);
                }, x.prototype.s = function(ce, ke) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + ce + ", " + ke + "): Promise already settled in state" + this.h);
                  this.h = ce, this.i = ke, this.h === 2 && this.D(), this.A();
                }, x.prototype.D = function() {
                  var ce = this;
                  M(function() {
                    if (ce.B()) {
                      var ke = pe.console;
                      typeof ke < "u" && ke.error(ce.i);
                    }
                  }, 1);
                }, x.prototype.B = function() {
                  if (this.o)
                    return !1;
                  var ce = pe.CustomEvent, ke = pe.Event, st = pe.dispatchEvent;
                  return typeof st > "u" ? !0 : (typeof ce == "function" ? ce = new ce("unhandledrejection", { cancelable: !0 }) : typeof ke == "function" ? ce = new ke("unhandledrejection", { cancelable: !0 }) : (ce = pe.document.createEvent("CustomEvent"), ce.initCustomEvent("unhandledrejection", !1, !0, ce)), ce.promise = this, ce.reason = this.i, st(ce));
                }, x.prototype.A = function() {
                  if (this.g != null) {
                    for (var ce = 0; ce < this.g.length; ++ce)
                      H.h(this.g[ce]);
                    this.g = null;
                  }
                };
                var H = new ee();
                return x.prototype.F = function(ce) {
                  var ke = this.j();
                  ce.J(ke.resolve, ke.reject);
                }, x.prototype.G = function(ce, ke) {
                  var st = this.j();
                  try {
                    ce.call(ke, st.resolve, st.reject);
                  } catch (mt) {
                    st.reject(mt);
                  }
                }, x.prototype.then = function(ce, ke) {
                  function st(Bn, Zn) {
                    return typeof Bn == "function" ? function(ir) {
                      try {
                        mt(Bn(ir));
                      } catch (Ur) {
                        xt(Ur);
                      }
                    } : Zn;
                  }
                  var mt, xt, dn = new x(function(Bn, Zn) {
                    mt = Bn, xt = Zn;
                  });
                  return this.J(st(ce, mt), st(ke, xt)), dn;
                }, x.prototype.catch = function(ce) {
                  return this.then(void 0, ce);
                }, x.prototype.J = function(ce, ke) {
                  function st() {
                    switch (mt.h) {
                      case 1:
                        ce(mt.i);
                        break;
                      case 2:
                        ke(mt.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + mt.h);
                    }
                  }
                  var mt = this;
                  this.g == null ? H.h(st) : this.g.push(st), this.o = !0;
                }, x.resolve = F, x.reject = function(ce) {
                  return new x(function(ke, st) {
                    st(ce);
                  });
                }, x.race = function(ce) {
                  return new x(function(ke, st) {
                    for (var mt = rt(ce), xt = mt.next(); !xt.done; xt = mt.next())
                      F(xt.value).J(ke, st);
                  });
                }, x.all = function(ce) {
                  var ke = rt(ce), st = ke.next();
                  return st.done ? F([]) : new x(function(mt, xt) {
                    function dn(ir) {
                      return function(Ur) {
                        Bn[ir] = Ur, Zn--, Zn == 0 && mt(Bn);
                      };
                    }
                    var Bn = [], Zn = 0;
                    do
                      Bn.push(void 0), Zn++, F(st.value).J(dn(Bn.length - 1), xt), st = ke.next();
                    while (!st.done);
                  });
                }, x;
              });
              function ml(C, x) {
                C instanceof String && (C += "");
                var ee = 0, F = !1, M = { next: function() {
                  if (!F && ee < C.length) {
                    var H = ee++;
                    return { value: x(H, C[H]), done: !1 };
                  }
                  return F = !0, { done: !0, value: void 0 };
                } };
                return M[Symbol.iterator] = function() {
                  return M;
                }, M;
              }
              var cd = typeof Object.assign == "function" ? Object.assign : function(C, x) {
                for (var ee = 1; ee < arguments.length; ee++) {
                  var F = arguments[ee];
                  if (F)
                    for (var M in F)
                      Object.prototype.hasOwnProperty.call(F, M) && (C[M] = F[M]);
                }
                return C;
              };
              De("Object.assign", function(C) {
                return C || cd;
              }), De("Object.is", function(C) {
                return C || function(x, ee) {
                  return x === ee ? x !== 0 || 1 / x === 1 / ee : x !== x && ee !== ee;
                };
              }), De("Array.prototype.includes", function(C) {
                return C || function(x, ee) {
                  var F = this;
                  F instanceof String && (F = String(F));
                  var M = F.length;
                  for (ee = ee || 0, 0 > ee && (ee = Math.max(ee + M, 0)); ee < M; ee++) {
                    var H = F[ee];
                    if (H === x || Object.is(H, x))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(C) {
                return C || function(x, ee) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (x instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(x, ee || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(C) {
                return C || function() {
                  return ml(this, function(x) {
                    return x;
                  });
                };
              });
              var Ma = this || self;
              function Ji(C, x) {
                C = C.split(".");
                var ee = Ma;
                C[0] in ee || typeof ee.execScript > "u" || ee.execScript("var " + C[0]);
                for (var F; C.length && (F = C.shift()); )
                  C.length || x === void 0 ? ee[F] && ee[F] !== Object.prototype[F] ? ee = ee[F] : ee = ee[F] = {} : ee[F] = x;
              }
              function ts(C) {
                Ma.setTimeout(function() {
                  throw C;
                }, 0);
              }
              function tl(C) {
                ts(C);
              }
              function Wl(C, x) {
                tl(Error("Invalid wire type: " + C + " (at position " + x + ")"));
              }
              function Ac() {
                tl(Error("Failed to read varint, encoding is invalid."));
              }
              function Hl(C, x) {
                return x = String.fromCharCode.apply(null, x), C == null ? x : C + x;
              }
              var Uc, dl = typeof TextDecoder < "u", vl, Nc = typeof TextEncoder < "u";
              function gc(C) {
                if (Nc)
                  C = (vl || (vl = new TextEncoder())).encode(C);
                else {
                  var x = void 0;
                  x = x === void 0 ? !1 : x;
                  for (var ee = 0, F = new Uint8Array(3 * C.length), M = 0; M < C.length; M++) {
                    var H = C.charCodeAt(M);
                    if (128 > H)
                      F[ee++] = H;
                    else {
                      if (2048 > H)
                        F[ee++] = H >> 6 | 192;
                      else {
                        if (55296 <= H && 57343 >= H) {
                          if (56319 >= H && M < C.length) {
                            var ce = C.charCodeAt(++M);
                            if (56320 <= ce && 57343 >= ce) {
                              H = 1024 * (H - 55296) + ce - 56320 + 65536, F[ee++] = H >> 18 | 240, F[ee++] = H >> 12 & 63 | 128, F[ee++] = H >> 6 & 63 | 128, F[ee++] = H & 63 | 128;
                              continue;
                            } else
                              M--;
                          }
                          if (x)
                            throw Error("Found an unpaired surrogate");
                          H = 65533;
                        }
                        F[ee++] = H >> 12 | 224, F[ee++] = H >> 6 & 63 | 128;
                      }
                      F[ee++] = H & 63 | 128;
                    }
                  }
                  C = F.subarray(0, ee);
                }
                return C;
              }
              var Js = {}, Is = null;
              function Pl(C) {
                var x;
                x === void 0 && (x = 0), $a(), x = Js[x];
                for (var ee = Array(Math.floor(C.length / 3)), F = x[64] || "", M = 0, H = 0; M < C.length - 2; M += 3) {
                  var ce = C[M], ke = C[M + 1], st = C[M + 2], mt = x[ce >> 2];
                  ce = x[(ce & 3) << 4 | ke >> 4], ke = x[(ke & 15) << 2 | st >> 6], st = x[st & 63], ee[H++] = mt + ce + ke + st;
                }
                switch (mt = 0, st = F, C.length - M) {
                  case 2:
                    mt = C[M + 1], st = x[(mt & 15) << 2] || F;
                  case 1:
                    C = C[M], ee[H] = x[C >> 2] + x[(C & 3) << 4 | mt >> 4] + st + F;
                }
                return ee.join("");
              }
              function Nl(C) {
                var x = C.length, ee = 3 * x / 4;
                ee % 3 ? ee = Math.floor(ee) : "=.".indexOf(C[x - 1]) != -1 && (ee = "=.".indexOf(C[x - 2]) != -1 ? ee - 2 : ee - 1);
                var F = new Uint8Array(ee), M = 0;
                return ta(C, function(H) {
                  F[M++] = H;
                }), F.subarray(0, M);
              }
              function ta(C, x) {
                function ee(st) {
                  for (; F < C.length; ) {
                    var mt = C.charAt(F++), xt = Is[mt];
                    if (xt != null)
                      return xt;
                    if (!/^[\s\xa0]*$/.test(mt))
                      throw Error("Unknown base64 encoding at char: " + mt);
                  }
                  return st;
                }
                $a();
                for (var F = 0; ; ) {
                  var M = ee(-1), H = ee(0), ce = ee(64), ke = ee(64);
                  if (ke === 64 && M === -1)
                    break;
                  x(M << 2 | H >> 4), ce != 64 && (x(H << 4 & 240 | ce >> 2), ke != 64 && x(ce << 6 & 192 | ke));
                }
              }
              function $a() {
                if (!Is) {
                  Is = {};
                  for (var C = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), x = ["+/=", "+/", "-_=", "-_.", "-_"], ee = 0; 5 > ee; ee++) {
                    var F = C.concat(x[ee].split(""));
                    Js[ee] = F;
                    for (var M = 0; M < F.length; M++) {
                      var H = F[M];
                      Is[H] === void 0 && (Is[H] = M);
                    }
                  }
                }
              }
              var Gs = typeof Uint8Array == "function", To;
              function Na(C) {
                if (this.g = C, C !== null && C.length === 0)
                  throw Error("ByteString should be constructed with non-empty values");
              }
              Na.prototype.toJSON = function() {
                if (this.g == null)
                  var C = "";
                else
                  C = this.g, C = this.g = C == null || typeof C == "string" ? C : Gs && C instanceof Uint8Array ? Pl(C) : null;
                return C;
              };
              var nl = typeof Uint8Array.prototype.slice == "function";
              function vs(C, x, ee) {
                return x === ee ? To || (To = new Uint8Array(0)) : nl ? C.slice(x, ee) : new Uint8Array(C.subarray(x, ee));
              }
              var bo = 0, fa = 0;
              function ss(C) {
                if (C.constructor === Uint8Array)
                  return C;
                if (C.constructor === ArrayBuffer)
                  return new Uint8Array(C);
                if (C.constructor === Array)
                  return new Uint8Array(C);
                if (C.constructor === String)
                  return Nl(C);
                if (C.constructor === Na) {
                  if (C.g == null)
                    var x = To || (To = new Uint8Array(0));
                  else {
                    x = Uint8Array;
                    var ee = C.g;
                    ee = ee == null || Gs && ee != null && ee instanceof Uint8Array ? ee : typeof ee == "string" ? Nl(ee) : null, C = C.g = ee, x = new x(C);
                  }
                  return x;
                }
                if (C instanceof Uint8Array)
                  return new Uint8Array(C.buffer, C.byteOffset, C.byteLength);
                throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
              }
              function eo(C, x) {
                x = x === void 0 ? {} : x, x = x.u === void 0 ? !1 : x.u, this.h = null, this.g = this.i = this.m = 0, this.l = !1, this.u = x, C && Pa(this, C);
              }
              function Pa(C, x) {
                C.h = ss(x), C.m = 0, C.i = C.h.length, C.g = C.m;
              }
              eo.prototype.reset = function() {
                this.g = this.m;
              };
              function Ao(C) {
                for (var x = 128, ee = 0, F = 0, M = 0; 4 > M && 128 <= x; M++)
                  x = C.h[C.g++], ee |= (x & 127) << 7 * M;
                if (128 <= x && (x = C.h[C.g++], ee |= (x & 127) << 28, F |= (x & 127) >> 4), 128 <= x)
                  for (M = 0; 5 > M && 128 <= x; M++)
                    x = C.h[C.g++], F |= (x & 127) << 7 * M + 3;
                if (128 > x)
                  return C = ee >>> 0, x = F >>> 0, (F = x & 2147483648) && (C = ~C + 1 >>> 0, x = ~x >>> 0, C == 0 && (x = x + 1 >>> 0)), C = 4294967296 * x + (C >>> 0), F ? -C : C;
                C.l = !0, Ac();
              }
              function ua(C) {
                C.g > C.i && (C.l = !0, tl(Error("Tried to read past the end of the data " + C.g + " > " + C.i)));
              }
              eo.prototype.j = function() {
                var C = this.h, x = C[this.g], ee = x & 127;
                return 128 > x ? (this.g += 1, ua(this), ee) : (x = C[this.g + 1], ee |= (x & 127) << 7, 128 > x ? (this.g += 2, ua(this), ee) : (x = C[this.g + 2], ee |= (x & 127) << 14, 128 > x ? (this.g += 3, ua(this), ee) : (x = C[this.g + 3], ee |= (x & 127) << 21, 128 > x ? (this.g += 4, ua(this), ee) : (x = C[this.g + 4], ee |= (x & 15) << 28, 128 > x ? (this.g += 5, ua(this), ee >>> 0) : (this.g += 5, 128 <= C[this.g++] && 128 <= C[this.g++] && 128 <= C[this.g++] && 128 <= C[this.g++] && 128 <= C[this.g++] ? (this.l = !0, Ac(), ee) : (ua(this), ee))))));
              }, eo.prototype.o = function() {
                var C = this.h[this.g], x = this.h[this.g + 1], ee = this.h[this.g + 2], F = this.h[this.g + 3];
                return this.g += 4, ua(this), ee = (C << 0 | x << 8 | ee << 16 | F << 24) >>> 0, C = 2 * (ee >> 31) + 1, x = ee >>> 23 & 255, ee &= 8388607, x == 255 ? ee ? NaN : 1 / 0 * C : x == 0 ? C * Math.pow(2, -149) * ee : C * Math.pow(2, x - 150) * (ee + Math.pow(2, 23));
              };
              var ns = [];
              function Ls() {
                this.g = new Uint8Array(64), this.h = 0;
              }
              function Ua(C, x) {
                if (!(C.h + 1 < C.g.length)) {
                  var ee = C.g;
                  C.g = new Uint8Array(Math.ceil(1 + 2 * C.g.length)), C.g.set(ee);
                }
                C.g[C.h++] = x;
              }
              Ls.prototype.length = function() {
                return this.h;
              }, Ls.prototype.end = function() {
                var C = this.g, x = this.h;
                return this.h = 0, vs(C, 0, x);
              };
              function go(C, x) {
                for (; 127 < x; )
                  Ua(C, x & 127 | 128), x >>>= 7;
                Ua(C, x);
              }
              function Bs(C) {
                var x = {}, ee = x.N === void 0 ? !1 : x.N;
                this.m = { u: x.u === void 0 ? !1 : x.u }, this.N = ee, x = this.m, ns.length ? (ee = ns.pop(), x && (ee.u = x.u), C && Pa(ee, C), C = ee) : C = new eo(C, x), this.g = C, this.l = this.g.g, this.h = this.i = -1, this.j = !1;
              }
              Bs.prototype.reset = function() {
                this.g.reset(), this.h = this.i = -1;
              };
              function Ts(C) {
                var x = C.g;
                if ((x = x.g == x.i) || (x = C.j) || (x = C.g, x = x.l || 0 > x.g || x.g > x.i), x)
                  return !1;
                C.l = C.g.g;
                var ee = C.g.j();
                return x = ee >>> 3, ee &= 7, 0 <= ee && 5 >= ee ? (C.i = x, C.h = ee, !0) : (C.j = !0, Wl(ee, C.l), !1);
              }
              function Oa(C) {
                switch (C.h) {
                  case 0:
                    if (C.h != 0)
                      Oa(C);
                    else
                      e: {
                        C = C.g;
                        for (var x = C.g, ee = 0; 10 > ee; ee++) {
                          if (!(C.h[x] & 128)) {
                            C.g = x + 1, ua(C);
                            break e;
                          }
                          x++;
                        }
                        C.l = !0, Ac();
                      }
                    break;
                  case 1:
                    C = C.g, C.g += 8, ua(C);
                    break;
                  case 2:
                    C.h != 2 ? Oa(C) : (x = C.g.j(), C = C.g, C.g += x, ua(C));
                    break;
                  case 5:
                    C = C.g, C.g += 4, ua(C);
                    break;
                  case 3:
                    x = C.i;
                    do {
                      if (!Ts(C)) {
                        C.j = !0, tl(Error("Unmatched start-group tag: stream EOF"));
                        break;
                      }
                      if (C.h == 4) {
                        C.i != x && (C.j = !0, tl(Error("Unmatched end-group tag")));
                        break;
                      }
                      Oa(C);
                    } while (!0);
                    break;
                  default:
                    C.j = !0, Wl(C.h, C.l);
                }
              }
              function Jl(C, x, ee) {
                C.N || (C = vs(C.g.h, ee, C.g.g), (ee = x.o) ? ee.push(C) : x.o = [C]);
              }
              function rl(C, x, ee) {
                var F = C.g.i, M = C.g.j(), H = C.g.g + M;
                if (C.g.i = H, ee(x, C), ee = H - C.g.g, ee !== 0)
                  throw Error("Message parsing ended unexpectedly. Expected to read " + (M + " bytes, instead read " + (M - ee) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                return C.g.g = H, C.g.i = F, x;
              }
              function Xs(C, x, ee) {
                var F = C.g.j();
                for (F = C.g.g + F; C.g.g < F; )
                  ee.push(x.call(C.g));
              }
              var il = [];
              function pa() {
                this.h = [], this.i = 0, this.g = new Ls();
              }
              function rs(C, x) {
                x.length !== 0 && (C.h.push(x), C.i += x.length);
              }
              function ma(C, x, ee) {
                go(C.g, 8 * x + 2), go(C.g, ee.length), rs(C, C.g.end()), rs(C, ee);
              }
              var Xo = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
              function ks(C, x) {
                Object.isFrozen(C) || (Xo ? C[Xo] |= x : C.g !== void 0 ? C.g |= x : Object.defineProperties(C, { g: { value: x, configurable: !0, writable: !0, enumerable: !1 } }));
              }
              function Zo(C) {
                if (!C)
                  return 0;
                var x;
                return Xo ? x = C[Xo] : x = C.g, x == null ? 0 : x;
              }
              function fo(C) {
                return Array.isArray(C) && ks(C, 1), C;
              }
              function ul(C) {
                if (!Array.isArray(C))
                  throw Error("cannot mark non-array as immutable");
                ks(C, 2);
              }
              function na(C) {
                return C !== null && typeof C == "object" && C.constructor === Object;
              }
              function Wi(C) {
                switch (typeof C) {
                  case "number":
                    return isFinite(C) ? C : String(C);
                  case "object":
                    return Gs && C != null && C instanceof Uint8Array ? Pl(C) : C;
                  default:
                    return C;
                }
              }
              function li(C, x) {
                if (C != null)
                  return Array.isArray(C) || na(C) ? ko(C, x) : x(C);
              }
              function ko(C, x) {
                if (Array.isArray(C)) {
                  for (var ee = Array(C.length), F = 0; F < C.length; F++)
                    ee[F] = li(C[F], x);
                  return Zo(C) & 1 && fo(ee), ee;
                }
                ee = {};
                for (F in C)
                  ee[F] = li(C[F], x);
                return ee;
              }
              var is;
              function So(C, x, ee) {
                var F = is;
                is = null, C || (C = F), F = this.constructor.ba, C || (C = F ? [F] : []), this.j = (F ? 0 : -1) - (this.constructor.$ || 0), this.m = this.g = null, this.h = C;
                e: {
                  if (F = this.h.length, C = F - 1, F && (F = this.h[C], na(F))) {
                    this.l = C - this.j, this.i = F;
                    break e;
                  }
                  x !== void 0 && -1 < x ? (this.l = Math.max(x, C + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
                }
                if (ee)
                  for (x = 0; x < ee.length; x++)
                    C = ee[x], C < this.l ? (C += this.j, (F = this.h[C]) ? fo(F) : this.h[C] = wo) : (wn(this), (F = this.i[C]) ? fo(F) : this.i[C] = wo);
              }
              var wo = Object.freeze(fo([]));
              function wn(C) {
                var x = C.l + C.j;
                C.h[x] || (C.i = C.h[x] = {});
              }
              function jn(C, x, ee) {
                return x === -1 ? null : ee !== void 0 && ee || x >= C.l ? C.i ? C.i[x] : void 0 : C.h[x + C.j];
              }
              function hr(C, x, ee) {
                ee = ee === void 0 ? !0 : ee;
                var F = F === void 0 ? !1 : F, M = jn(C, x, F);
                return M == null && (M = wo), M === wo ? (M = fo([]), fi(C, x, M, F)) : ee && Array.isArray(M) && Zo(M) & 2 && (M = M.slice(), fi(C, x, M, F)), M;
              }
              function po(C) {
                var x = hr(C, 3, !1);
                if (C.m || (C.m = {}), !C.m[3]) {
                  for (var ee = 0; ee < x.length; ee++)
                    x[ee] = +x[ee];
                  C.m[3] = !0;
                }
                return x;
              }
              function Po(C, x, ee) {
                return C = jn(C, x), C == null ? ee : C;
              }
              function Yo(C, x, ee) {
                return C = jn(C, x), C = C == null ? C : +C, C == null ? ee === void 0 ? 0 : ee : C;
              }
              function fi(C, x, ee, F) {
                F !== void 0 && F || x >= C.l ? (wn(C), C.i[x] = ee) : C.h[x + C.j] = ee;
              }
              function ra(C, x, ee) {
                if (ee === -1)
                  return null;
                C.g || (C.g = {});
                var F = C.g[ee];
                if (F)
                  return F;
                var M = jn(C, ee, !1);
                return M == null ? F : (x = new x(M), C.g[ee] = x);
              }
              function ls(C, x, ee) {
                C.g || (C.g = {});
                var F = C.g[ee];
                if (!F) {
                  var M = hr(C, ee, !1);
                  F = [];
                  for (var H = Array.isArray(M) ? !!(Zo(M) & 2) : !1, ce = 0; ce < M.length; ce++)
                    F[ce] = new x(M[ce]), H && ul(F[ce].h);
                  H && (ul(F), Object.freeze(F)), C.g[ee] = F;
                }
                return F;
              }
              function xs(C, x, ee, F, M) {
                var H = ls(C, F, x);
                ee = ee || new F(), C = hr(C, x), M != null ? (H.splice(M, 0, ee), C.splice(M, 0, Hs(ee))) : (H.push(ee), C.push(Hs(ee)));
              }
              So.prototype.toJSON = function() {
                var C = Hs(this);
                return ko(C, Wi);
              };
              function Hs(C) {
                if (C.g)
                  for (var x in C.g) {
                    var ee = C.g[x];
                    if (Array.isArray(ee))
                      for (var F = 0; F < ee.length; F++)
                        ee[F] && Hs(ee[F]);
                    else
                      ee && Hs(ee);
                  }
                return C.h;
              }
              So.prototype.toString = function() {
                return Hs(this).toString();
              };
              function hl(C, x) {
                if (C = C.o) {
                  rs(x, x.g.end());
                  for (var ee = 0; ee < C.length; ee++)
                    rs(x, C[ee]);
                }
              }
              function bl(C) {
                var x = C[0];
                switch (C.length) {
                  case 2:
                    var ee = C[1];
                    return function(st, mt, xt) {
                      return x(st, mt, xt, ee);
                    };
                  case 3:
                    var F = C[1], M = C[2];
                    return function(st, mt, xt) {
                      return x(st, mt, xt, F, M);
                    };
                  case 4:
                    var H = C[1], ce = C[2], ke = C[3];
                    return function(st, mt, xt) {
                      return x(st, mt, xt, H, ce, ke);
                    };
                  default:
                    throw Error("unsupported number of parameters, expected [2-4], got " + C.length);
                }
              }
              function os(C, x, ee) {
                for (; Ts(x) && x.h != 4; ) {
                  var F = x.i, M = ee[F];
                  if (M) {
                    if (Array.isArray(M) && (M = ee[F] = bl(M)), !M(x, C, F)) {
                      F = x, M = C;
                      var H = F.l;
                      Oa(F), Jl(F, M, H);
                    }
                  } else
                    F = x, M = C, H = F.l, Oa(F), Jl(F, M, H);
                }
                return C;
              }
              function Ps(C, x) {
                var ee = new pa();
                if (x(C, ee), C = ee.i + ee.g.length(), C === 0)
                  ee = new Uint8Array(0);
                else {
                  C = new Uint8Array(C);
                  for (var F = ee.h, M = F.length, H = x = 0; H < M; H++) {
                    var ce = F[H];
                    ce.length !== 0 && (C.set(ce, x), x += ce.length);
                  }
                  F = ee.g, M = F.h, M !== 0 && (C.set(F.g.subarray(0, M), x), F.h = 0), ee.h = [C], ee = C;
                }
                return ee;
              }
              function dd(C, x, ee) {
                if (il.length) {
                  var F = il.pop();
                  C && (Pa(F.g, C), F.i = -1, F.h = -1), C = F;
                } else
                  C = new Bs(C);
                try {
                  return ee(new x(), C);
                } finally {
                  x = C.g, x.h = null, x.m = 0, x.i = 0, x.g = 0, x.l = !1, x.u = !1, C.i = -1, C.h = -1, C.j = !1, 100 > il.length && il.push(C);
                }
              }
              function Os(C, x, ee) {
                if (x = jn(x, ee), x != null) {
                  go(C.g, 8 * ee + 5), C = C.g;
                  var F = x;
                  F = (ee = 0 > F ? 1 : 0) ? -F : F, F === 0 ? 0 < 1 / F ? bo = fa = 0 : (fa = 0, bo = 2147483648) : isNaN(F) ? (fa = 0, bo = 2147483647) : 34028234663852886e22 < F ? (fa = 0, bo = (ee << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > F ? (F = Math.round(F / Math.pow(2, -149)), fa = 0, bo = (ee << 31 | F) >>> 0) : (x = Math.floor(Math.log(F) / Math.LN2), F *= Math.pow(2, -x), F = Math.round(8388608 * F), 16777216 <= F && ++x, fa = 0, bo = (ee << 31 | x + 127 << 23 | F & 8388607) >>> 0), ee = bo, Ua(C, ee >>> 0 & 255), Ua(C, ee >>> 8 & 255), Ua(C, ee >>> 16 & 255), Ua(C, ee >>> 24 & 255);
                }
              }
              function cs(C, x, ee) {
                return C.h !== 5 ? !1 : (fi(x, ee, C.g.o()), !0);
              }
              function Il(C, x, ee) {
                return C.h !== 5 && C.h !== 2 ? !1 : (x = hr(x, ee), C.h == 2 ? Xs(C, eo.prototype.o, x) : x.push(C.g.o()), !0);
              }
              function Ol(C, x, ee) {
                return C.h !== 0 ? !1 : (fi(x, ee, Ao(C.g)), !0);
              }
              function bs(C, x, ee) {
                return C.h !== 0 ? !1 : (fi(x, ee, C.g.j()), !0);
              }
              function Jc(C, x, ee) {
                if (C.h !== 2)
                  return !1;
                var F = C.g.j();
                C = C.g;
                var M = C.g;
                C.g += F, ua(C), C = C.h;
                var H;
                if (dl)
                  (H = Uc) || (H = Uc = new TextDecoder("utf-8", { fatal: !1 })), H = H.decode(C.subarray(M, M + F));
                else {
                  F = M + F;
                  for (var ce = [], ke = null, st, mt, xt; M < F; )
                    st = C[M++], 128 > st ? ce.push(st) : 224 > st ? M >= F ? ce.push(65533) : (mt = C[M++], 194 > st || (mt & 192) !== 128 ? (M--, ce.push(65533)) : ce.push((st & 31) << 6 | mt & 63)) : 240 > st ? M >= F - 1 ? ce.push(65533) : (mt = C[M++], (mt & 192) !== 128 || st === 224 && 160 > mt || st === 237 && 160 <= mt || ((H = C[M++]) & 192) !== 128 ? (M--, ce.push(65533)) : ce.push((st & 15) << 12 | (mt & 63) << 6 | H & 63)) : 244 >= st ? M >= F - 2 ? ce.push(65533) : (mt = C[M++], (mt & 192) !== 128 || (st << 28) + (mt - 144) >> 30 || ((H = C[M++]) & 192) !== 128 || ((xt = C[M++]) & 192) !== 128 ? (M--, ce.push(65533)) : (st = (st & 7) << 18 | (mt & 63) << 12 | (H & 63) << 6 | xt & 63, st -= 65536, ce.push((st >> 10 & 1023) + 55296, (st & 1023) + 56320))) : ce.push(65533), 8192 <= ce.length && (ke = Hl(ke, ce), ce.length = 0);
                  H = Hl(ke, ce);
                }
                return fi(x, ee, H), !0;
              }
              function Ks(C, x, ee, F, M) {
                if (C.h !== 2)
                  return !1;
                C = rl(C, new F(), M);
                var H = H === void 0 ? !1 : H;
                return x.g || (x.g = {}), F = C && Hs(C), x.g[ee] = C, fi(x, ee, F, H), !0;
              }
              function Bl(C, x, ee, F, M) {
                return C.h !== 2 ? !1 : (C = rl(C, new F(), M), xs(x, ee, C, F, void 0), !0);
              }
              function nc(C, x, ee) {
                return C.h !== 0 && C.h !== 2 ? !1 : (x = hr(x, ee), C.h == 2 ? Xs(C, eo.prototype.j, x) : x.push(C.g.j()), !0);
              }
              function Oc(C, x, ee) {
                return C.h !== 0 ? !1 : (fi(x, ee, Ao(C.g)), !0);
              }
              function ol(C) {
                So.call(this, C, -1, xd);
              }
              var rc;
              Nr(ol, So), ol.prototype.getRows = function() {
                return jn(this, 1);
              }, ol.prototype.getCols = function() {
                return jn(this, 2);
              }, ol.prototype.getPackedDataList = function() {
                return po(this);
              }, ol.prototype.getLayout = function() {
                return Po(this, 4, 0);
              };
              function Ld(C, x) {
                return os(C, x, rc || (rc = { 1: bs, 2: bs, 3: Il, 4: Oc }));
              }
              var xd = [3];
              function ic(C) {
                So.call(this, C);
              }
              var fc;
              Nr(ic, So);
              function le(C, x) {
                var ee = jn(C, 1);
                if (ee != null && ee != null) {
                  go(x.g, 8);
                  var F = x.g;
                  if (0 <= ee)
                    go(F, ee);
                  else {
                    for (var M = 0; 9 > M; M++)
                      Ua(F, ee & 127 | 128), ee >>= 7;
                    Ua(F, 1);
                  }
                }
                Os(x, C, 2), F = jn(C, 3), F != null && ma(x, 3, gc(F)), F = jn(C, 4), F != null && ma(x, 4, gc(F)), hl(C, x);
              }
              function Ie(C, x) {
                return os(C, x, fc || (fc = { 1: bs, 2: cs, 3: Jc, 4: Jc }));
              }
              function Ze(C) {
                So.call(this, C, -1, nr);
              }
              var Mt;
              Nr(Ze, So), Ze.prototype.addClassification = function(C, x) {
                return xs(this, 1, C, ic, x), this;
              };
              function yn(C, x) {
                return os(C, x, Mt || (Mt = { 1: [Bl, ic, Ie] }));
              }
              var nr = [1];
              function mn(C) {
                So.call(this, C);
              }
              var zn;
              Nr(mn, So);
              function Wr(C, x) {
                Os(x, C, 1), Os(x, C, 2), Os(x, C, 3), Os(x, C, 4), Os(x, C, 5), hl(C, x);
              }
              function ci(C, x) {
                return os(C, x, zn || (zn = { 1: cs, 2: cs, 3: cs, 4: cs, 5: cs }));
              }
              function Ki(C) {
                So.call(this, C, -1, Xi);
              }
              var Gi;
              Nr(Ki, So);
              function yo(C, x) {
                return os(C, x, Gi || (Gi = { 1: [Bl, mn, ci] }));
              }
              var Xi = [1];
              function vi(C) {
                So.call(this, C);
              }
              var Yi;
              Nr(vi, So);
              function Fo(C, x) {
                Os(x, C, 1), Os(x, C, 2), Os(x, C, 3), Os(x, C, 4), Os(x, C, 5);
                var ee = jn(C, 6);
                if (ee != null && ee != null) {
                  go(x.g, 48);
                  var F = x.g, M = ee;
                  ee = 0 > M, M = Math.abs(M);
                  var H = M >>> 0;
                  for (M = Math.floor((M - H) / 4294967296), M >>>= 0, ee && (M = ~M >>> 0, H = (~H >>> 0) + 1, 4294967295 < H && (H = 0, M++, 4294967295 < M && (M = 0))), bo = H, fa = M, ee = bo, H = fa; 0 < H || 127 < ee; )
                    Ua(F, ee & 127 | 128), ee = (ee >>> 7 | H << 25) >>> 0, H >>>= 7;
                  Ua(F, ee);
                }
                hl(C, x);
              }
              function Lo(C, x) {
                return os(C, x, Yi || (Yi = { 1: cs, 2: cs, 3: cs, 4: cs, 5: cs, 6: Ol }));
              }
              function ia(C) {
                So.call(this, C, -1, q);
              }
              var ha;
              Nr(ia, So), ia.prototype.getVertexType = function() {
                return Po(this, 1, 0);
              }, ia.prototype.getPrimitiveType = function() {
                return Po(this, 2, 0);
              }, ia.prototype.getVertexBufferList = function() {
                return po(this);
              }, ia.prototype.getIndexBufferList = function() {
                return hr(this, 4);
              };
              function ds(C, x) {
                return os(C, x, ha || (ha = { 1: Oc, 2: Oc, 3: Il, 4: nc }));
              }
              var q = [3, 4];
              function he(C) {
                So.call(this, C);
              }
              var ve;
              Nr(he, So), he.prototype.getMesh = function() {
                return ra(this, ia, 1);
              }, he.prototype.getPoseTransformMatrix = function() {
                return ra(this, ol, 2);
              };
              function bt(C, x) {
                return os(C, x, ve || (ve = { 1: [Ks, ia, ds], 2: [Ks, ol, Ld] }));
              }
              var Ot = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], In = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
                386,
                385
              ], [385, 384], [384, 398], [398, 362]], en = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], Gn = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], dr = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], D = [
                [10, 338],
                [338, 297],
                [297, 332],
                [332, 284],
                [284, 251],
                [251, 389],
                [389, 356],
                [356, 454],
                [454, 323],
                [323, 361],
                [361, 288],
                [288, 397],
                [397, 365],
                [365, 379],
                [379, 378],
                [378, 400],
                [400, 377],
                [377, 152],
                [152, 148],
                [148, 176],
                [176, 149],
                [149, 150],
                [150, 136],
                [136, 172],
                [172, 58],
                [58, 132],
                [132, 93],
                [93, 234],
                [234, 127],
                [127, 162],
                [162, 21],
                [21, 54],
                [54, 103],
                [103, 67],
                [67, 109],
                [109, 10]
              ], Fe = [].concat(Nt(Ot), Nt(In), Nt(en), Nt(Gn), Nt(dr), Nt(D));
              function Se(C, x, ee) {
                if (ee = C.createShader(ee === 0 ? C.VERTEX_SHADER : C.FRAGMENT_SHADER), C.shaderSource(ee, x), C.compileShader(ee), !C.getShaderParameter(ee, C.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + C.getShaderInfoLog(ee));
                return ee;
              }
              function it(C) {
                return ls(C, ic, 1).map(function(x) {
                  return { index: Po(x, 1, 0), score: Yo(x, 2), label: jn(x, 3) != null ? Po(x, 3, "") : void 0, displayName: jn(x, 4) != null ? Po(x, 4, "") : void 0 };
                });
              }
              function Gt(C) {
                return { x: Yo(C, 1), y: Yo(C, 2), z: Yo(C, 3), visibility: jn(C, 4) != null ? Yo(C, 4) : void 0 };
              }
              function nn(C) {
                return ls(dd(C, Ki, yo), mn, 1).map(Gt);
              }
              function Pt(C, x) {
                this.h = C, this.g = x, this.l = 0;
              }
              function Mn(C, x, ee) {
                return Nn(C, x), typeof C.g.canvas.transferToImageBitmap == "function" ? n.resolve(C.g.canvas.transferToImageBitmap()) : ee ? n.resolve(C.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(C.g.canvas) : (C.i === void 0 && (C.i = document.createElement("canvas")), new n(function(F) {
                  C.i.height = C.g.canvas.height, C.i.width = C.g.canvas.width, C.i.getContext("2d", {}).drawImage(C.g.canvas, 0, 0, C.g.canvas.width, C.g.canvas.height), F(C.i);
                }));
              }
              function Nn(C, x) {
                var ee = C.g;
                if (C.m === void 0) {
                  var F = Se(ee, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), M = Se(ee, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), H = ee.createProgram();
                  if (ee.attachShader(H, F), ee.attachShader(H, M), ee.linkProgram(H), !ee.getProgramParameter(H, ee.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + ee.getProgramInfoLog(H));
                  F = C.m = H, ee.useProgram(F), M = ee.getUniformLocation(F, "sampler0"), C.j = { I: ee.getAttribLocation(F, "aVertex"), H: ee.getAttribLocation(F, "aTex"), ca: M }, C.s = ee.createBuffer(), ee.bindBuffer(ee.ARRAY_BUFFER, C.s), ee.enableVertexAttribArray(C.j.I), ee.vertexAttribPointer(C.j.I, 2, ee.FLOAT, !1, 0, 0), ee.bufferData(ee.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), ee.STATIC_DRAW), ee.bindBuffer(ee.ARRAY_BUFFER, null), C.o = ee.createBuffer(), ee.bindBuffer(ee.ARRAY_BUFFER, C.o), ee.enableVertexAttribArray(C.j.H), ee.vertexAttribPointer(
                    C.j.H,
                    2,
                    ee.FLOAT,
                    !1,
                    0,
                    0
                  ), ee.bufferData(ee.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), ee.STATIC_DRAW), ee.bindBuffer(ee.ARRAY_BUFFER, null), ee.uniform1i(M, 0);
                }
                F = C.j, ee.useProgram(C.m), ee.canvas.width = x.width, ee.canvas.height = x.height, ee.viewport(0, 0, x.width, x.height), ee.activeTexture(ee.TEXTURE0), C.h.bindTexture2d(x.glName), ee.enableVertexAttribArray(F.I), ee.bindBuffer(ee.ARRAY_BUFFER, C.s), ee.vertexAttribPointer(F.I, 2, ee.FLOAT, !1, 0, 0), ee.enableVertexAttribArray(F.H), ee.bindBuffer(ee.ARRAY_BUFFER, C.o), ee.vertexAttribPointer(
                  F.H,
                  2,
                  ee.FLOAT,
                  !1,
                  0,
                  0
                ), ee.bindFramebuffer(ee.DRAW_FRAMEBUFFER ? ee.DRAW_FRAMEBUFFER : ee.FRAMEBUFFER, null), ee.clearColor(0, 0, 0, 0), ee.clear(ee.COLOR_BUFFER_BIT), ee.colorMask(!0, !0, !0, !0), ee.drawArrays(ee.TRIANGLE_FAN, 0, 4), ee.disableVertexAttribArray(F.I), ee.disableVertexAttribArray(F.H), ee.bindBuffer(ee.ARRAY_BUFFER, null), C.h.bindTexture2d(0);
              }
              function Xr(C) {
                this.g = C;
              }
              var ei = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function ji(C, x) {
                return x + C;
              }
              function di(C, x) {
                window[C] = x;
              }
              function Cr(C) {
                var x = document.createElement("script");
                return x.setAttribute("src", C), x.setAttribute("crossorigin", "anonymous"), new n(function(ee) {
                  x.addEventListener("load", function() {
                    ee();
                  }, !1), x.addEventListener("error", function() {
                    ee();
                  }, !1), document.body.appendChild(x);
                });
              }
              function ni() {
                return Mr(function(C) {
                  switch (C.g) {
                    case 1:
                      return C.m = 2, Un(C, WebAssembly.instantiate(ei), 4);
                    case 4:
                      C.g = 3, C.m = 0;
                      break;
                    case 2:
                      return C.m = 0, C.j = null, C.return(!1);
                    case 3:
                      return C.return(!0);
                  }
                });
              }
              function Ai(C) {
                if (this.g = C, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = n.resolve(), this.P = "", this.B = {}, this.locateFile = C && C.locateFile || ji, typeof window == "object")
                  var x = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  x = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.S = x, C.options) {
                  x = rt(Object.keys(C.options));
                  for (var ee = x.next(); !ee.done; ee = x.next()) {
                    ee = ee.value;
                    var F = C.options[ee].default;
                    F !== void 0 && (this.j[ee] = typeof F == "function" ? F() : F);
                  }
                }
              }
              E = Ai.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function Ri(C) {
                var x, ee, F, M, H, ce, ke, st, mt, xt, dn;
                return Mr(function(Bn) {
                  switch (Bn.g) {
                    case 1:
                      return C.R ? (x = C.g.files === void 0 ? [] : typeof C.g.files == "function" ? C.g.files(C.j) : C.g.files, Un(Bn, ni(), 2)) : Bn.return();
                    case 2:
                      if (ee = Bn.h, typeof window == "object")
                        return di("createMediapipeSolutionsWasm", { locateFile: C.locateFile }), di("createMediapipeSolutionsPackedAssets", { locateFile: C.locateFile }), ce = x.filter(function(Zn) {
                          return Zn.data !== void 0;
                        }), ke = x.filter(function(Zn) {
                          return Zn.data === void 0;
                        }), st = n.all(ce.map(function(Zn) {
                          var ir = me(C, Zn.url);
                          if (Zn.path !== void 0) {
                            var Ur = Zn.path;
                            ir = ir.then(function(Zr) {
                              return C.overrideFile(Ur, Zr), n.resolve(Zr);
                            });
                          }
                          return ir;
                        })), mt = n.all(ke.map(function(Zn) {
                          return Zn.simd === void 0 || Zn.simd && ee || !Zn.simd && !ee ? Cr(C.locateFile(Zn.url, C.S)) : n.resolve();
                        })).then(function() {
                          var Zn, ir, Ur;
                          return Mr(function(Zr) {
                            if (Zr.g == 1)
                              return Zn = window.createMediapipeSolutionsWasm, ir = window.createMediapipeSolutionsPackedAssets, Ur = C, Un(Zr, Zn(ir), 2);
                            Ur.h = Zr.h, Zr.g = 0;
                          });
                        }), xt = function() {
                          return Mr(function(Zn) {
                            return C.g.graph && C.g.graph.url ? Zn = Un(
                              Zn,
                              me(C, C.g.graph.url),
                              0
                            ) : (Zn.g = 0, Zn = void 0), Zn;
                          });
                        }(), Un(Bn, n.all([mt, st, xt]), 7);
                      if (typeof importScripts != "function")
                        throw Error("solutions can only be loaded on a web page or in a web worker");
                      return F = x.filter(function(Zn) {
                        return Zn.simd === void 0 || Zn.simd && ee || !Zn.simd && !ee;
                      }).map(function(Zn) {
                        return C.locateFile(Zn.url, C.S);
                      }), importScripts.apply(null, Nt(F)), M = C, Un(Bn, createMediapipeSolutionsWasm(Module), 6);
                    case 6:
                      M.h = Bn.h, C.l = new OffscreenCanvas(1, 1), C.h.canvas = C.l, H = C.h.GL.createContext(C.l, {
                        antialias: !1,
                        alpha: !1,
                        aa: typeof WebGL2RenderingContext < "u" ? 2 : 1
                      }), C.h.GL.makeContextCurrent(H), Bn.g = 4;
                      break;
                    case 7:
                      if (C.l = document.createElement("canvas"), dn = C.l.getContext("webgl2", {}), !dn && (dn = C.l.getContext("webgl", {}), !dn))
                        return alert("Failed to create WebGL canvas context when passing video frame."), Bn.return();
                      C.D = dn, C.h.canvas = C.l, C.h.createContext(C.l, !0, !0, {});
                    case 4:
                      C.i = new C.h.SolutionWasm(), C.R = !1, Bn.g = 0;
                  }
                });
              }
              function Ii(C) {
                var x, ee, F, M, H, ce, ke, st;
                return Mr(function(mt) {
                  if (mt.g == 1) {
                    if (C.g.graph && C.g.graph.url && C.P === C.g.graph.url)
                      return mt.return();
                    if (C.o = !0, !C.g.graph || !C.g.graph.url) {
                      mt.g = 2;
                      return;
                    }
                    return C.P = C.g.graph.url, Un(mt, me(C, C.g.graph.url), 3);
                  }
                  for (mt.g != 2 && (x = mt.h, C.i.loadGraph(x)), ee = rt(Object.keys(C.B)), F = ee.next(); !F.done; F = ee.next())
                    M = F.value, C.i.overrideFile(M, C.B[M]);
                  if (C.B = {}, C.g.listeners)
                    for (H = rt(C.g.listeners), ce = H.next(); !ce.done; ce = H.next())
                      ke = ce.value, Tt(C, ke);
                  st = C.j, C.j = {}, C.setOptions(st), mt.g = 0;
                });
              }
              E.reset = function() {
                var C = this;
                return Mr(function(x) {
                  C.i && (C.i.reset(), C.m = {}, C.s = {}), x.g = 0;
                });
              }, E.setOptions = function(C, x) {
                var ee = this;
                if (x = x || this.g.options) {
                  for (var F = [], M = [], H = {}, ce = rt(Object.keys(C)), ke = ce.next(); !ke.done; H = { K: H.K, L: H.L }, ke = ce.next()) {
                    var st = ke.value;
                    st in this.j && this.j[st] === C[st] || (this.j[st] = C[st], ke = x[st], ke !== void 0 && (ke.onChange && (H.K = ke.onChange, H.L = C[st], F.push(/* @__PURE__ */ function(mt) {
                      return function() {
                        var xt;
                        return Mr(function(dn) {
                          if (dn.g == 1)
                            return Un(dn, mt.K(mt.L), 2);
                          xt = dn.h, xt === !0 && (ee.o = !0), dn.g = 0;
                        });
                      };
                    }(H))), ke.graphOptionXref && (st = { valueNumber: ke.type === 1 ? C[st] : 0, valueBoolean: ke.type === 0 ? C[st] : !1, valueString: ke.type === 2 ? C[st] : "" }, ke = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), ke.graphOptionXref), st), M.push(ke))));
                  }
                  (F.length !== 0 || M.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(M), this.v = (this.v === void 0 ? [] : this.v).concat(F));
                }
              };
              function Y(C) {
                var x, ee, F, M, H, ce, ke;
                return Mr(function(st) {
                  switch (st.g) {
                    case 1:
                      if (!C.o)
                        return st.return();
                      if (!C.v) {
                        st.g = 2;
                        break;
                      }
                      x = rt(C.v), ee = x.next();
                    case 3:
                      if (ee.done) {
                        st.g = 5;
                        break;
                      }
                      return F = ee.value, Un(st, F(), 4);
                    case 4:
                      ee = x.next(), st.g = 3;
                      break;
                    case 5:
                      C.v = void 0;
                    case 2:
                      if (C.A) {
                        for (M = new C.h.GraphOptionChangeRequestList(), H = rt(C.A), ce = H.next(); !ce.done; ce = H.next())
                          ke = ce.value, M.push_back(ke);
                        C.i.changeOptions(M), M.delete(), C.A = void 0;
                      }
                      C.o = !1, st.g = 0;
                  }
                });
              }
              E.initialize = function() {
                var C = this;
                return Mr(function(x) {
                  return x.g == 1 ? Un(x, Ri(C), 2) : x.g != 3 ? Un(x, Ii(C), 3) : Un(x, Y(C), 0);
                });
              };
              function me(C, x) {
                var ee, F;
                return Mr(function(M) {
                  return x in C.F ? M.return(C.F[x]) : (ee = C.locateFile(x, ""), F = fetch(ee).then(function(H) {
                    return H.arrayBuffer();
                  }), C.F[x] = F, M.return(F));
                });
              }
              E.overrideFile = function(C, x) {
                this.i ? this.i.overrideFile(C, x) : this.B[C] = x;
              }, E.clearOverriddenFiles = function() {
                this.B = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(C, x) {
                var ee = this, F, M, H, ce, ke, st, mt, xt, dn;
                return Mr(function(Bn) {
                  switch (Bn.g) {
                    case 1:
                      return ee.g.inputs ? (F = 1e3 * (x == null ? performance.now() : x), Un(Bn, ee.C, 2)) : Bn.return();
                    case 2:
                      return Un(Bn, ee.initialize(), 3);
                    case 3:
                      for (M = new ee.h.PacketDataList(), H = rt(Object.keys(C)), ce = H.next(); !ce.done; ce = H.next())
                        if (ke = ce.value, st = ee.g.inputs[ke]) {
                          e: {
                            var Zn = C[ke];
                            switch (st.type) {
                              case "video":
                                var ir = ee.m[st.stream];
                                if (ir || (ir = new Pt(ee.h, ee.D), ee.m[st.stream] = ir), ir.l === 0 && (ir.l = ir.h.createTexture()), typeof HTMLVideoElement < "u" && Zn instanceof HTMLVideoElement)
                                  var Ur = Zn.videoWidth, Zr = Zn.videoHeight;
                                else
                                  typeof HTMLImageElement < "u" && Zn instanceof HTMLImageElement ? (Ur = Zn.naturalWidth, Zr = Zn.naturalHeight) : (Ur = Zn.width, Zr = Zn.height);
                                Zr = { glName: ir.l, width: Ur, height: Zr }, Ur = ir.g, Ur.canvas.width = Zr.width, Ur.canvas.height = Zr.height, Ur.activeTexture(Ur.TEXTURE0), ir.h.bindTexture2d(ir.l), Ur.texImage2D(Ur.TEXTURE_2D, 0, Ur.RGBA, Ur.RGBA, Ur.UNSIGNED_BYTE, Zn), ir.h.bindTexture2d(0), ir = Zr;
                                break e;
                              case "detections":
                                for (ir = ee.m[st.stream], ir || (ir = new Xr(ee.h), ee.m[st.stream] = ir), ir.data || (ir.data = new ir.g.DetectionListData()), ir.data.reset(Zn.length), Zr = 0; Zr < Zn.length; ++Zr) {
                                  Ur = Zn[Zr];
                                  var Pr = ir.data, xr = Pr.setBoundingBox, oo = Zr, Do = Ur.T, Mo = new vi();
                                  if (fi(Mo, 1, Do.X), fi(Mo, 2, Do.Y), fi(Mo, 3, Do.height), fi(Mo, 4, Do.width), fi(Mo, 5, Do.rotation), fi(Mo, 6, Do.W), Do = Ps(Mo, Fo), xr.call(Pr, oo, Do), Ur.O)
                                    for (Pr = 0; Pr < Ur.O.length; ++Pr) {
                                      Mo = Ur.O[Pr];
                                      var gs = !!Mo.visibility;
                                      xr = ir.data, oo = xr.addNormalizedLandmark, Do = Zr, Mo = Object.assign(Object.assign({}, Mo), { visibility: gs ? Mo.visibility : 0 }), gs = new mn(), fi(gs, 1, Mo.x), fi(gs, 2, Mo.y), fi(gs, 3, Mo.z), Mo.visibility && fi(gs, 4, Mo.visibility), Mo = Ps(gs, Wr), oo.call(xr, Do, Mo);
                                    }
                                  if (Ur.M)
                                    for (Pr = 0; Pr < Ur.M.length; ++Pr)
                                      xr = ir.data, oo = xr.addClassification, Do = Zr, Mo = Ur.M[Pr], gs = new ic(), fi(gs, 2, Mo.score), Mo.index && fi(gs, 1, Mo.index), Mo.label && fi(gs, 3, Mo.label), Mo.displayName && fi(gs, 4, Mo.displayName), Mo = Ps(gs, le), oo.call(xr, Do, Mo);
                                }
                                ir = ir.data;
                                break e;
                              default:
                                ir = {};
                            }
                          }
                          switch (mt = ir, xt = st.stream, st.type) {
                            case "video":
                              M.pushTexture2d(Object.assign(Object.assign({}, mt), { stream: xt, timestamp: F }));
                              break;
                            case "detections":
                              dn = mt, dn.stream = xt, dn.timestamp = F, M.pushDetectionList(dn);
                              break;
                            default:
                              throw Error("Unknown input config type: '" + st.type + "'");
                          }
                        }
                      return ee.i.send(M), Un(Bn, ee.C, 4);
                    case 4:
                      M.delete(), Bn.g = 0;
                  }
                });
              };
              function Ee(C, x, ee) {
                var F, M, H, ce, ke, st, mt, xt, dn, Bn, Zn, ir, Ur, Zr;
                return Mr(function(Pr) {
                  switch (Pr.g) {
                    case 1:
                      if (!ee)
                        return Pr.return(x);
                      for (F = {}, M = 0, H = rt(Object.keys(ee)), ce = H.next(); !ce.done; ce = H.next())
                        ke = ce.value, st = ee[ke], typeof st != "string" && st.type === "texture" && x[st.stream] !== void 0 && ++M;
                      1 < M && (C.G = !1), mt = rt(Object.keys(ee)), ce = mt.next();
                    case 2:
                      if (ce.done) {
                        Pr.g = 4;
                        break;
                      }
                      if (xt = ce.value, dn = ee[xt], typeof dn == "string")
                        return Ur = F, Zr = xt, Un(Pr, je(C, xt, x[dn]), 14);
                      if (Bn = x[dn.stream], dn.type === "detection_list") {
                        if (Bn) {
                          for (var xr = Bn.getRectList(), oo = Bn.getLandmarksList(), Do = Bn.getClassificationsList(), Mo = [], gs = 0; gs < xr.size(); ++gs) {
                            var Gl = dd(xr.get(gs), vi, Lo);
                            Gl = { T: { X: Yo(Gl, 1), Y: Yo(Gl, 2), height: Yo(Gl, 3), width: Yo(Gl, 4), rotation: Yo(Gl, 5, 0), W: Po(Gl, 6, 0) }, O: nn(oo.get(gs)), M: it(dd(Do.get(gs), Ze, yn)) }, Mo.push(Gl);
                          }
                          xr = Mo;
                        } else
                          xr = [];
                        F[xt] = xr, Pr.g = 7;
                        break;
                      }
                      if (dn.type === "proto_list") {
                        if (Bn) {
                          for (xr = Array(Bn.size()), oo = 0; oo < Bn.size(); oo++)
                            xr[oo] = Bn.get(oo);
                          Bn.delete();
                        } else
                          xr = [];
                        F[xt] = xr, Pr.g = 7;
                        break;
                      }
                      if (Bn === void 0) {
                        Pr.g = 3;
                        break;
                      }
                      if (dn.type === "float_list") {
                        F[xt] = Bn, Pr.g = 7;
                        break;
                      }
                      if (dn.type === "proto") {
                        F[xt] = Bn, Pr.g = 7;
                        break;
                      }
                      if (dn.type !== "texture")
                        throw Error("Unknown output config type: '" + dn.type + "'");
                      return Zn = C.s[xt], Zn || (Zn = new Pt(C.h, C.D), C.s[xt] = Zn), Un(Pr, Mn(Zn, Bn, C.G), 13);
                    case 13:
                      ir = Pr.h, F[xt] = ir;
                    case 7:
                      dn.transform && F[xt] && (F[xt] = dn.transform(F[xt])), Pr.g = 3;
                      break;
                    case 14:
                      Ur[Zr] = Pr.h;
                    case 3:
                      ce = mt.next(), Pr.g = 2;
                      break;
                    case 4:
                      return Pr.return(F);
                  }
                });
              }
              function je(C, x, ee) {
                var F;
                return Mr(function(M) {
                  return typeof ee == "number" || ee instanceof Uint8Array || ee instanceof C.h.Uint8BlobList ? M.return(ee) : ee instanceof C.h.Texture2dDataOut ? (F = C.s[x], F || (F = new Pt(C.h, C.D), C.s[x] = F), M.return(Mn(F, ee, C.G))) : M.return(void 0);
                });
              }
              function Tt(C, x) {
                for (var ee = x.name || "$", F = [].concat(Nt(x.wants)), M = new C.h.StringList(), H = rt(x.wants), ce = H.next(); !ce.done; ce = H.next())
                  M.push_back(ce.value);
                H = C.h.PacketListener.implement({ onResults: function(ke) {
                  for (var st = {}, mt = 0; mt < x.wants.length; ++mt)
                    st[F[mt]] = ke.get(mt);
                  var xt = C.listeners[ee];
                  xt && (C.C = Ee(C, st, x.outs).then(function(dn) {
                    dn = xt(dn);
                    for (var Bn = 0; Bn < x.wants.length; ++Bn) {
                      var Zn = st[F[Bn]];
                      typeof Zn == "object" && Zn.hasOwnProperty && Zn.hasOwnProperty("delete") && Zn.delete();
                    }
                    dn && (C.C = dn);
                  }));
                } }), C.i.attachMultiListener(M, H), M.delete();
              }
              E.onResults = function(C, x) {
                this.listeners[x || "$"] = C;
              }, Ji("Solution", Ai), Ji("OptionType", { BOOL: 0, NUMBER: 1, Z: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function X(C) {
                return C.map(j);
              }
              function j(C) {
                C = dd(C, he, bt);
                var x = C.getMesh();
                if (!x)
                  return C;
                var ee = new Float32Array(x.getVertexBufferList());
                x.getVertexBufferList = function() {
                  return ee;
                };
                var F = new Uint32Array(x.getIndexBufferList());
                return x.getIndexBufferList = function() {
                  return F;
                }, C;
              }
              function Ae(C) {
                var x = this;
                C = C || {}, this.g = new Ai({
                  locateFile: C.locateFile,
                  files: [{ url: "holistic_solution_packed_assets_loader.js" }, { simd: !1, url: "holistic_solution_wasm_bin.js" }, { simd: !0, url: "holistic_solution_simd_wasm_bin.js" }],
                  graph: { url: "holistic.binarypb" },
                  inputs: { image: { type: "video", stream: "input_frames_gpu" } },
                  listeners: [{ wants: "left_hand_landmarks right_hand_landmarks face_landmarks pose_landmarks world_landmarks segmentation_mask image_transformed multi_face_geometry".split(" "), outs: { image: {
                    type: "texture",
                    stream: "image_transformed"
                  }, leftHandLandmarks: { type: "proto", stream: "left_hand_landmarks", transform: nn }, rightHandLandmarks: { type: "proto", stream: "right_hand_landmarks", transform: nn }, faceLandmarks: { type: "proto", stream: "face_landmarks", transform: nn }, poseLandmarks: { type: "proto", stream: "pose_landmarks", transform: nn }, ea: { type: "proto", stream: "world_landmarks", transform: nn }, segmentationMask: { type: "texture", stream: "segmentation_mask" }, multiFaceGeometry: { type: "proto_list", stream: "multi_face_geometry", transform: X } } }],
                  options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, enableFaceGeometry: { type: 0, graphOptionXref: { calculatorName: "EnableFaceGeometryConstant", calculatorType: "ConstantSidePacketCalculator", fieldName: "bool_value" } }, selfieMode: { type: 0, graphOptionXref: {
                    calculatorType: "GlScalerCalculator",
                    calculatorIndex: 1,
                    fieldName: "flip_horizontal"
                  } }, modelComplexity: { type: 1, default: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(ee) {
                    var F, M, H, ce;
                    return Mr(function(ke) {
                      if (ke.g == 1) {
                        switch (F = "", ee) {
                          case 1:
                            F = "pose_landmark_full.tflite";
                            break;
                          case 2:
                            F = "pose_landmark_heavy.tflite";
                            break;
                          default:
                            F = "pose_landmark_lite.tflite";
                        }
                        return M = "third_party/mediapipe/modules/pose_landmark/" + F, H = x.g.locateFile(
                          F,
                          ""
                        ), Un(ke, fetch(H), 3);
                      }
                      return ke.g != 2 ? Un(ke, ke.h.arrayBuffer(), 2) : (ce = ke.h, x.g.overrideFile(M, ce), Un(ke, x.g.reset(), 0));
                    });
                  } }, smoothLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" } }, enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } }, smoothSegmentation: {
                    type: 0,
                    graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" }
                  }, refineFaceLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorRefineFaceLandmarks", fieldName: "bool_value" } }, minDetectionConfidence: { type: 1, graphOptionXref: {
                    calculatorType: "TensorsToDetectionsCalculator",
                    calculatorName: "holisticlandmarkgpu__poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator",
                    fieldName: "min_score_thresh"
                  } }, minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "holisticlandmarkgpu__poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }, cameraNear: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "near" } }, cameraFar: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "far" } }, cameraVerticalFovDegrees: {
                    type: 1,
                    graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "vertical_fov_degrees" }
                  } }
                });
              }
              E = Ae.prototype, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(C) {
                this.g.onResults(C);
              }, E.initialize = function() {
                var C = this;
                return Mr(function(x) {
                  return Un(x, C.g.initialize(), 0);
                });
              }, E.reset = function() {
                this.g.reset();
              }, E.send = function(C) {
                var x = this;
                return Mr(function(ee) {
                  return Un(ee, x.g.send(C), 0);
                });
              }, E.setOptions = function(C) {
                this.g.setOptions(C);
              }, Ji("Holistic", Ae), Ji("FACE_GEOMETRY", { Layout: { COLUMN_MAJOR: 0, ROW_MAJOR: 1, 0: "COLUMN_MAJOR", 1: "ROW_MAJOR" }, PrimitiveType: { TRIANGLE: 0, 0: "TRIANGLE" }, VertexType: { VERTEX_PT: 0, 0: "VERTEX_PT" }, DEFAULT_CAMERA_PARAMS: { verticalFovDegrees: 63, near: 1, far: 1e4 } }), Ji("FACEMESH_LIPS", Ot), Ji("FACEMESH_LEFT_EYE", In), Ji("FACEMESH_LEFT_EYEBROW", en), Ji("FACEMESH_LEFT_IRIS", [[474, 475], [475, 476], [476, 477], [477, 474]]), Ji("FACEMESH_RIGHT_EYE", Gn), Ji("FACEMESH_RIGHT_EYEBROW", dr), Ji("FACEMESH_RIGHT_IRIS", [[469, 470], [470, 471], [471, 472], [472, 469]]), Ji("FACEMESH_FACE_OVAL", D), Ji("FACEMESH_CONTOURS", Fe), Ji("FACEMESH_TESSELATION", [
                [127, 34],
                [34, 139],
                [139, 127],
                [11, 0],
                [0, 37],
                [37, 11],
                [232, 231],
                [231, 120],
                [120, 232],
                [72, 37],
                [37, 39],
                [39, 72],
                [128, 121],
                [121, 47],
                [47, 128],
                [232, 121],
                [121, 128],
                [128, 232],
                [104, 69],
                [69, 67],
                [67, 104],
                [175, 171],
                [171, 148],
                [148, 175],
                [118, 50],
                [50, 101],
                [101, 118],
                [73, 39],
                [39, 40],
                [40, 73],
                [9, 151],
                [151, 108],
                [108, 9],
                [48, 115],
                [115, 131],
                [131, 48],
                [194, 204],
                [204, 211],
                [211, 194],
                [74, 40],
                [40, 185],
                [185, 74],
                [80, 42],
                [42, 183],
                [183, 80],
                [40, 92],
                [92, 186],
                [186, 40],
                [230, 229],
                [229, 118],
                [118, 230],
                [202, 212],
                [
                  212,
                  214
                ],
                [214, 202],
                [83, 18],
                [18, 17],
                [17, 83],
                [76, 61],
                [61, 146],
                [146, 76],
                [160, 29],
                [29, 30],
                [30, 160],
                [56, 157],
                [157, 173],
                [173, 56],
                [106, 204],
                [204, 194],
                [194, 106],
                [135, 214],
                [214, 192],
                [192, 135],
                [203, 165],
                [165, 98],
                [98, 203],
                [21, 71],
                [71, 68],
                [68, 21],
                [51, 45],
                [45, 4],
                [4, 51],
                [144, 24],
                [24, 23],
                [23, 144],
                [77, 146],
                [146, 91],
                [91, 77],
                [205, 50],
                [50, 187],
                [187, 205],
                [201, 200],
                [200, 18],
                [18, 201],
                [91, 106],
                [106, 182],
                [182, 91],
                [90, 91],
                [91, 181],
                [181, 90],
                [85, 84],
                [84, 17],
                [17, 85],
                [206, 203],
                [203, 36],
                [36, 206],
                [148, 171],
                [171, 140],
                [140, 148],
                [
                  92,
                  40
                ],
                [40, 39],
                [39, 92],
                [193, 189],
                [189, 244],
                [244, 193],
                [159, 158],
                [158, 28],
                [28, 159],
                [247, 246],
                [246, 161],
                [161, 247],
                [236, 3],
                [3, 196],
                [196, 236],
                [54, 68],
                [68, 104],
                [104, 54],
                [193, 168],
                [168, 8],
                [8, 193],
                [117, 228],
                [228, 31],
                [31, 117],
                [189, 193],
                [193, 55],
                [55, 189],
                [98, 97],
                [97, 99],
                [99, 98],
                [126, 47],
                [47, 100],
                [100, 126],
                [166, 79],
                [79, 218],
                [218, 166],
                [155, 154],
                [154, 26],
                [26, 155],
                [209, 49],
                [49, 131],
                [131, 209],
                [135, 136],
                [136, 150],
                [150, 135],
                [47, 126],
                [126, 217],
                [217, 47],
                [223, 52],
                [52, 53],
                [53, 223],
                [45, 51],
                [51, 134],
                [134, 45],
                [211, 170],
                [
                  170,
                  140
                ],
                [140, 211],
                [67, 69],
                [69, 108],
                [108, 67],
                [43, 106],
                [106, 91],
                [91, 43],
                [230, 119],
                [119, 120],
                [120, 230],
                [226, 130],
                [130, 247],
                [247, 226],
                [63, 53],
                [53, 52],
                [52, 63],
                [238, 20],
                [20, 242],
                [242, 238],
                [46, 70],
                [70, 156],
                [156, 46],
                [78, 62],
                [62, 96],
                [96, 78],
                [46, 53],
                [53, 63],
                [63, 46],
                [143, 34],
                [34, 227],
                [227, 143],
                [123, 117],
                [117, 111],
                [111, 123],
                [44, 125],
                [125, 19],
                [19, 44],
                [236, 134],
                [134, 51],
                [51, 236],
                [216, 206],
                [206, 205],
                [205, 216],
                [154, 153],
                [153, 22],
                [22, 154],
                [39, 37],
                [37, 167],
                [167, 39],
                [200, 201],
                [201, 208],
                [208, 200],
                [36, 142],
                [142, 100],
                [
                  100,
                  36
                ],
                [57, 212],
                [212, 202],
                [202, 57],
                [20, 60],
                [60, 99],
                [99, 20],
                [28, 158],
                [158, 157],
                [157, 28],
                [35, 226],
                [226, 113],
                [113, 35],
                [160, 159],
                [159, 27],
                [27, 160],
                [204, 202],
                [202, 210],
                [210, 204],
                [113, 225],
                [225, 46],
                [46, 113],
                [43, 202],
                [202, 204],
                [204, 43],
                [62, 76],
                [76, 77],
                [77, 62],
                [137, 123],
                [123, 116],
                [116, 137],
                [41, 38],
                [38, 72],
                [72, 41],
                [203, 129],
                [129, 142],
                [142, 203],
                [64, 98],
                [98, 240],
                [240, 64],
                [49, 102],
                [102, 64],
                [64, 49],
                [41, 73],
                [73, 74],
                [74, 41],
                [212, 216],
                [216, 207],
                [207, 212],
                [42, 74],
                [74, 184],
                [184, 42],
                [169, 170],
                [170, 211],
                [211, 169],
                [
                  170,
                  149
                ],
                [149, 176],
                [176, 170],
                [105, 66],
                [66, 69],
                [69, 105],
                [122, 6],
                [6, 168],
                [168, 122],
                [123, 147],
                [147, 187],
                [187, 123],
                [96, 77],
                [77, 90],
                [90, 96],
                [65, 55],
                [55, 107],
                [107, 65],
                [89, 90],
                [90, 180],
                [180, 89],
                [101, 100],
                [100, 120],
                [120, 101],
                [63, 105],
                [105, 104],
                [104, 63],
                [93, 137],
                [137, 227],
                [227, 93],
                [15, 86],
                [86, 85],
                [85, 15],
                [129, 102],
                [102, 49],
                [49, 129],
                [14, 87],
                [87, 86],
                [86, 14],
                [55, 8],
                [8, 9],
                [9, 55],
                [100, 47],
                [47, 121],
                [121, 100],
                [145, 23],
                [23, 22],
                [22, 145],
                [88, 89],
                [89, 179],
                [179, 88],
                [6, 122],
                [122, 196],
                [196, 6],
                [88, 95],
                [95, 96],
                [96, 88],
                [138, 172],
                [172, 136],
                [136, 138],
                [215, 58],
                [58, 172],
                [172, 215],
                [115, 48],
                [48, 219],
                [219, 115],
                [42, 80],
                [80, 81],
                [81, 42],
                [195, 3],
                [3, 51],
                [51, 195],
                [43, 146],
                [146, 61],
                [61, 43],
                [171, 175],
                [175, 199],
                [199, 171],
                [81, 82],
                [82, 38],
                [38, 81],
                [53, 46],
                [46, 225],
                [225, 53],
                [144, 163],
                [163, 110],
                [110, 144],
                [52, 65],
                [65, 66],
                [66, 52],
                [229, 228],
                [228, 117],
                [117, 229],
                [34, 127],
                [127, 234],
                [234, 34],
                [107, 108],
                [108, 69],
                [69, 107],
                [109, 108],
                [108, 151],
                [151, 109],
                [48, 64],
                [64, 235],
                [235, 48],
                [62, 78],
                [78, 191],
                [191, 62],
                [129, 209],
                [209, 126],
                [126, 129],
                [111, 35],
                [35, 143],
                [
                  143,
                  111
                ],
                [117, 123],
                [123, 50],
                [50, 117],
                [222, 65],
                [65, 52],
                [52, 222],
                [19, 125],
                [125, 141],
                [141, 19],
                [221, 55],
                [55, 65],
                [65, 221],
                [3, 195],
                [195, 197],
                [197, 3],
                [25, 7],
                [7, 33],
                [33, 25],
                [220, 237],
                [237, 44],
                [44, 220],
                [70, 71],
                [71, 139],
                [139, 70],
                [122, 193],
                [193, 245],
                [245, 122],
                [247, 130],
                [130, 33],
                [33, 247],
                [71, 21],
                [21, 162],
                [162, 71],
                [170, 169],
                [169, 150],
                [150, 170],
                [188, 174],
                [174, 196],
                [196, 188],
                [216, 186],
                [186, 92],
                [92, 216],
                [2, 97],
                [97, 167],
                [167, 2],
                [141, 125],
                [125, 241],
                [241, 141],
                [164, 167],
                [167, 37],
                [37, 164],
                [72, 38],
                [38, 12],
                [12, 72],
                [38, 82],
                [82, 13],
                [13, 38],
                [63, 68],
                [68, 71],
                [71, 63],
                [226, 35],
                [35, 111],
                [111, 226],
                [101, 50],
                [50, 205],
                [205, 101],
                [206, 92],
                [92, 165],
                [165, 206],
                [209, 198],
                [198, 217],
                [217, 209],
                [165, 167],
                [167, 97],
                [97, 165],
                [220, 115],
                [115, 218],
                [218, 220],
                [133, 112],
                [112, 243],
                [243, 133],
                [239, 238],
                [238, 241],
                [241, 239],
                [214, 135],
                [135, 169],
                [169, 214],
                [190, 173],
                [173, 133],
                [133, 190],
                [171, 208],
                [208, 32],
                [32, 171],
                [125, 44],
                [44, 237],
                [237, 125],
                [86, 87],
                [87, 178],
                [178, 86],
                [85, 86],
                [86, 179],
                [179, 85],
                [84, 85],
                [85, 180],
                [180, 84],
                [83, 84],
                [84, 181],
                [181, 83],
                [201, 83],
                [83, 182],
                [182, 201],
                [137, 93],
                [93, 132],
                [132, 137],
                [76, 62],
                [62, 183],
                [183, 76],
                [61, 76],
                [76, 184],
                [184, 61],
                [57, 61],
                [61, 185],
                [185, 57],
                [212, 57],
                [57, 186],
                [186, 212],
                [214, 207],
                [207, 187],
                [187, 214],
                [34, 143],
                [143, 156],
                [156, 34],
                [79, 239],
                [239, 237],
                [237, 79],
                [123, 137],
                [137, 177],
                [177, 123],
                [44, 1],
                [1, 4],
                [4, 44],
                [201, 194],
                [194, 32],
                [32, 201],
                [64, 102],
                [102, 129],
                [129, 64],
                [213, 215],
                [215, 138],
                [138, 213],
                [59, 166],
                [166, 219],
                [219, 59],
                [242, 99],
                [99, 97],
                [97, 242],
                [2, 94],
                [94, 141],
                [141, 2],
                [75, 59],
                [59, 235],
                [235, 75],
                [24, 110],
                [110, 228],
                [
                  228,
                  24
                ],
                [25, 130],
                [130, 226],
                [226, 25],
                [23, 24],
                [24, 229],
                [229, 23],
                [22, 23],
                [23, 230],
                [230, 22],
                [26, 22],
                [22, 231],
                [231, 26],
                [112, 26],
                [26, 232],
                [232, 112],
                [189, 190],
                [190, 243],
                [243, 189],
                [221, 56],
                [56, 190],
                [190, 221],
                [28, 56],
                [56, 221],
                [221, 28],
                [27, 28],
                [28, 222],
                [222, 27],
                [29, 27],
                [27, 223],
                [223, 29],
                [30, 29],
                [29, 224],
                [224, 30],
                [247, 30],
                [30, 225],
                [225, 247],
                [238, 79],
                [79, 20],
                [20, 238],
                [166, 59],
                [59, 75],
                [75, 166],
                [60, 75],
                [75, 240],
                [240, 60],
                [147, 177],
                [177, 215],
                [215, 147],
                [20, 79],
                [79, 166],
                [166, 20],
                [187, 147],
                [147, 213],
                [213, 187],
                [112, 233],
                [233, 244],
                [244, 112],
                [233, 128],
                [128, 245],
                [245, 233],
                [128, 114],
                [114, 188],
                [188, 128],
                [114, 217],
                [217, 174],
                [174, 114],
                [131, 115],
                [115, 220],
                [220, 131],
                [217, 198],
                [198, 236],
                [236, 217],
                [198, 131],
                [131, 134],
                [134, 198],
                [177, 132],
                [132, 58],
                [58, 177],
                [143, 35],
                [35, 124],
                [124, 143],
                [110, 163],
                [163, 7],
                [7, 110],
                [228, 110],
                [110, 25],
                [25, 228],
                [356, 389],
                [389, 368],
                [368, 356],
                [11, 302],
                [302, 267],
                [267, 11],
                [452, 350],
                [350, 349],
                [349, 452],
                [302, 303],
                [303, 269],
                [269, 302],
                [357, 343],
                [343, 277],
                [277, 357],
                [452, 453],
                [453, 357],
                [357, 452],
                [333, 332],
                [
                  332,
                  297
                ],
                [297, 333],
                [175, 152],
                [152, 377],
                [377, 175],
                [347, 348],
                [348, 330],
                [330, 347],
                [303, 304],
                [304, 270],
                [270, 303],
                [9, 336],
                [336, 337],
                [337, 9],
                [278, 279],
                [279, 360],
                [360, 278],
                [418, 262],
                [262, 431],
                [431, 418],
                [304, 408],
                [408, 409],
                [409, 304],
                [310, 415],
                [415, 407],
                [407, 310],
                [270, 409],
                [409, 410],
                [410, 270],
                [450, 348],
                [348, 347],
                [347, 450],
                [422, 430],
                [430, 434],
                [434, 422],
                [313, 314],
                [314, 17],
                [17, 313],
                [306, 307],
                [307, 375],
                [375, 306],
                [387, 388],
                [388, 260],
                [260, 387],
                [286, 414],
                [414, 398],
                [398, 286],
                [335, 406],
                [406, 418],
                [418, 335],
                [364, 367],
                [
                  367,
                  416
                ],
                [416, 364],
                [423, 358],
                [358, 327],
                [327, 423],
                [251, 284],
                [284, 298],
                [298, 251],
                [281, 5],
                [5, 4],
                [4, 281],
                [373, 374],
                [374, 253],
                [253, 373],
                [307, 320],
                [320, 321],
                [321, 307],
                [425, 427],
                [427, 411],
                [411, 425],
                [421, 313],
                [313, 18],
                [18, 421],
                [321, 405],
                [405, 406],
                [406, 321],
                [320, 404],
                [404, 405],
                [405, 320],
                [315, 16],
                [16, 17],
                [17, 315],
                [426, 425],
                [425, 266],
                [266, 426],
                [377, 400],
                [400, 369],
                [369, 377],
                [322, 391],
                [391, 269],
                [269, 322],
                [417, 465],
                [465, 464],
                [464, 417],
                [386, 257],
                [257, 258],
                [258, 386],
                [466, 260],
                [260, 388],
                [388, 466],
                [456, 399],
                [399, 419],
                [419, 456],
                [284, 332],
                [332, 333],
                [333, 284],
                [417, 285],
                [285, 8],
                [8, 417],
                [346, 340],
                [340, 261],
                [261, 346],
                [413, 441],
                [441, 285],
                [285, 413],
                [327, 460],
                [460, 328],
                [328, 327],
                [355, 371],
                [371, 329],
                [329, 355],
                [392, 439],
                [439, 438],
                [438, 392],
                [382, 341],
                [341, 256],
                [256, 382],
                [429, 420],
                [420, 360],
                [360, 429],
                [364, 394],
                [394, 379],
                [379, 364],
                [277, 343],
                [343, 437],
                [437, 277],
                [443, 444],
                [444, 283],
                [283, 443],
                [275, 440],
                [440, 363],
                [363, 275],
                [431, 262],
                [262, 369],
                [369, 431],
                [297, 338],
                [338, 337],
                [337, 297],
                [273, 375],
                [375, 321],
                [321, 273],
                [450, 451],
                [
                  451,
                  349
                ],
                [349, 450],
                [446, 342],
                [342, 467],
                [467, 446],
                [293, 334],
                [334, 282],
                [282, 293],
                [458, 461],
                [461, 462],
                [462, 458],
                [276, 353],
                [353, 383],
                [383, 276],
                [308, 324],
                [324, 325],
                [325, 308],
                [276, 300],
                [300, 293],
                [293, 276],
                [372, 345],
                [345, 447],
                [447, 372],
                [352, 345],
                [345, 340],
                [340, 352],
                [274, 1],
                [1, 19],
                [19, 274],
                [456, 248],
                [248, 281],
                [281, 456],
                [436, 427],
                [427, 425],
                [425, 436],
                [381, 256],
                [256, 252],
                [252, 381],
                [269, 391],
                [391, 393],
                [393, 269],
                [200, 199],
                [199, 428],
                [428, 200],
                [266, 330],
                [330, 329],
                [329, 266],
                [287, 273],
                [273, 422],
                [422, 287],
                [250, 462],
                [
                  462,
                  328
                ],
                [328, 250],
                [258, 286],
                [286, 384],
                [384, 258],
                [265, 353],
                [353, 342],
                [342, 265],
                [387, 259],
                [259, 257],
                [257, 387],
                [424, 431],
                [431, 430],
                [430, 424],
                [342, 353],
                [353, 276],
                [276, 342],
                [273, 335],
                [335, 424],
                [424, 273],
                [292, 325],
                [325, 307],
                [307, 292],
                [366, 447],
                [447, 345],
                [345, 366],
                [271, 303],
                [303, 302],
                [302, 271],
                [423, 266],
                [266, 371],
                [371, 423],
                [294, 455],
                [455, 460],
                [460, 294],
                [279, 278],
                [278, 294],
                [294, 279],
                [271, 272],
                [272, 304],
                [304, 271],
                [432, 434],
                [434, 427],
                [427, 432],
                [272, 407],
                [407, 408],
                [408, 272],
                [394, 430],
                [430, 431],
                [431, 394],
                [395, 369],
                [369, 400],
                [400, 395],
                [334, 333],
                [333, 299],
                [299, 334],
                [351, 417],
                [417, 168],
                [168, 351],
                [352, 280],
                [280, 411],
                [411, 352],
                [325, 319],
                [319, 320],
                [320, 325],
                [295, 296],
                [296, 336],
                [336, 295],
                [319, 403],
                [403, 404],
                [404, 319],
                [330, 348],
                [348, 349],
                [349, 330],
                [293, 298],
                [298, 333],
                [333, 293],
                [323, 454],
                [454, 447],
                [447, 323],
                [15, 16],
                [16, 315],
                [315, 15],
                [358, 429],
                [429, 279],
                [279, 358],
                [14, 15],
                [15, 316],
                [316, 14],
                [285, 336],
                [336, 9],
                [9, 285],
                [329, 349],
                [349, 350],
                [350, 329],
                [374, 380],
                [380, 252],
                [252, 374],
                [318, 402],
                [402, 403],
                [403, 318],
                [6, 197],
                [
                  197,
                  419
                ],
                [419, 6],
                [318, 319],
                [319, 325],
                [325, 318],
                [367, 364],
                [364, 365],
                [365, 367],
                [435, 367],
                [367, 397],
                [397, 435],
                [344, 438],
                [438, 439],
                [439, 344],
                [272, 271],
                [271, 311],
                [311, 272],
                [195, 5],
                [5, 281],
                [281, 195],
                [273, 287],
                [287, 291],
                [291, 273],
                [396, 428],
                [428, 199],
                [199, 396],
                [311, 271],
                [271, 268],
                [268, 311],
                [283, 444],
                [444, 445],
                [445, 283],
                [373, 254],
                [254, 339],
                [339, 373],
                [282, 334],
                [334, 296],
                [296, 282],
                [449, 347],
                [347, 346],
                [346, 449],
                [264, 447],
                [447, 454],
                [454, 264],
                [336, 296],
                [296, 299],
                [299, 336],
                [338, 10],
                [10, 151],
                [151, 338],
                [278, 439],
                [
                  439,
                  455
                ],
                [455, 278],
                [292, 407],
                [407, 415],
                [415, 292],
                [358, 371],
                [371, 355],
                [355, 358],
                [340, 345],
                [345, 372],
                [372, 340],
                [346, 347],
                [347, 280],
                [280, 346],
                [442, 443],
                [443, 282],
                [282, 442],
                [19, 94],
                [94, 370],
                [370, 19],
                [441, 442],
                [442, 295],
                [295, 441],
                [248, 419],
                [419, 197],
                [197, 248],
                [263, 255],
                [255, 359],
                [359, 263],
                [440, 275],
                [275, 274],
                [274, 440],
                [300, 383],
                [383, 368],
                [368, 300],
                [351, 412],
                [412, 465],
                [465, 351],
                [263, 467],
                [467, 466],
                [466, 263],
                [301, 368],
                [368, 389],
                [389, 301],
                [395, 378],
                [378, 379],
                [379, 395],
                [412, 351],
                [351, 419],
                [419, 412],
                [436, 426],
                [426, 322],
                [322, 436],
                [2, 164],
                [164, 393],
                [393, 2],
                [370, 462],
                [462, 461],
                [461, 370],
                [164, 0],
                [0, 267],
                [267, 164],
                [302, 11],
                [11, 12],
                [12, 302],
                [268, 12],
                [12, 13],
                [13, 268],
                [293, 300],
                [300, 301],
                [301, 293],
                [446, 261],
                [261, 340],
                [340, 446],
                [330, 266],
                [266, 425],
                [425, 330],
                [426, 423],
                [423, 391],
                [391, 426],
                [429, 355],
                [355, 437],
                [437, 429],
                [391, 327],
                [327, 326],
                [326, 391],
                [440, 457],
                [457, 438],
                [438, 440],
                [341, 382],
                [382, 362],
                [362, 341],
                [459, 457],
                [457, 461],
                [461, 459],
                [434, 430],
                [430, 394],
                [394, 434],
                [414, 463],
                [463, 362],
                [362, 414],
                [396, 369],
                [369, 262],
                [262, 396],
                [354, 461],
                [461, 457],
                [457, 354],
                [316, 403],
                [403, 402],
                [402, 316],
                [315, 404],
                [404, 403],
                [403, 315],
                [314, 405],
                [405, 404],
                [404, 314],
                [313, 406],
                [406, 405],
                [405, 313],
                [421, 418],
                [418, 406],
                [406, 421],
                [366, 401],
                [401, 361],
                [361, 366],
                [306, 408],
                [408, 407],
                [407, 306],
                [291, 409],
                [409, 408],
                [408, 291],
                [287, 410],
                [410, 409],
                [409, 287],
                [432, 436],
                [436, 410],
                [410, 432],
                [434, 416],
                [416, 411],
                [411, 434],
                [264, 368],
                [368, 383],
                [383, 264],
                [309, 438],
                [438, 457],
                [457, 309],
                [352, 376],
                [376, 401],
                [401, 352],
                [274, 275],
                [275, 4],
                [4, 274],
                [421, 428],
                [
                  428,
                  262
                ],
                [262, 421],
                [294, 327],
                [327, 358],
                [358, 294],
                [433, 416],
                [416, 367],
                [367, 433],
                [289, 455],
                [455, 439],
                [439, 289],
                [462, 370],
                [370, 326],
                [326, 462],
                [2, 326],
                [326, 370],
                [370, 2],
                [305, 460],
                [460, 455],
                [455, 305],
                [254, 449],
                [449, 448],
                [448, 254],
                [255, 261],
                [261, 446],
                [446, 255],
                [253, 450],
                [450, 449],
                [449, 253],
                [252, 451],
                [451, 450],
                [450, 252],
                [256, 452],
                [452, 451],
                [451, 256],
                [341, 453],
                [453, 452],
                [452, 341],
                [413, 464],
                [464, 463],
                [463, 413],
                [441, 413],
                [413, 414],
                [414, 441],
                [258, 442],
                [442, 441],
                [441, 258],
                [257, 443],
                [443, 442],
                [442, 257],
                [259, 444],
                [444, 443],
                [443, 259],
                [260, 445],
                [445, 444],
                [444, 260],
                [467, 342],
                [342, 445],
                [445, 467],
                [459, 458],
                [458, 250],
                [250, 459],
                [289, 392],
                [392, 290],
                [290, 289],
                [290, 328],
                [328, 460],
                [460, 290],
                [376, 433],
                [433, 435],
                [435, 376],
                [250, 290],
                [290, 392],
                [392, 250],
                [411, 416],
                [416, 433],
                [433, 411],
                [341, 463],
                [463, 464],
                [464, 341],
                [453, 464],
                [464, 465],
                [465, 453],
                [357, 465],
                [465, 412],
                [412, 357],
                [343, 412],
                [412, 399],
                [399, 343],
                [360, 363],
                [363, 440],
                [440, 360],
                [437, 399],
                [399, 456],
                [456, 437],
                [420, 456],
                [456, 363],
                [363, 420],
                [401, 435],
                [435, 288],
                [288, 401],
                [
                  372,
                  383
                ],
                [383, 353],
                [353, 372],
                [339, 255],
                [255, 249],
                [249, 339],
                [448, 261],
                [261, 255],
                [255, 448],
                [133, 243],
                [243, 190],
                [190, 133],
                [133, 155],
                [155, 112],
                [112, 133],
                [33, 246],
                [246, 247],
                [247, 33],
                [33, 130],
                [130, 25],
                [25, 33],
                [398, 384],
                [384, 286],
                [286, 398],
                [362, 398],
                [398, 414],
                [414, 362],
                [362, 463],
                [463, 341],
                [341, 362],
                [263, 359],
                [359, 467],
                [467, 263],
                [263, 249],
                [249, 255],
                [255, 263],
                [466, 467],
                [467, 260],
                [260, 466],
                [75, 60],
                [60, 166],
                [166, 75],
                [238, 239],
                [239, 79],
                [79, 238],
                [162, 127],
                [127, 139],
                [139, 162],
                [72, 11],
                [11, 37],
                [37, 72],
                [121, 232],
                [
                  232,
                  120
                ],
                [120, 121],
                [73, 72],
                [72, 39],
                [39, 73],
                [114, 128],
                [128, 47],
                [47, 114],
                [233, 232],
                [232, 128],
                [128, 233],
                [103, 104],
                [104, 67],
                [67, 103],
                [152, 175],
                [175, 148],
                [148, 152],
                [119, 118],
                [118, 101],
                [101, 119],
                [74, 73],
                [73, 40],
                [40, 74],
                [107, 9],
                [9, 108],
                [108, 107],
                [49, 48],
                [48, 131],
                [131, 49],
                [32, 194],
                [194, 211],
                [211, 32],
                [184, 74],
                [74, 185],
                [185, 184],
                [191, 80],
                [80, 183],
                [183, 191],
                [185, 40],
                [40, 186],
                [186, 185],
                [119, 230],
                [230, 118],
                [118, 119],
                [210, 202],
                [202, 214],
                [214, 210],
                [84, 83],
                [83, 17],
                [17, 84],
                [77, 76],
                [76, 146],
                [146, 77],
                [161, 160],
                [160, 30],
                [30, 161],
                [190, 56],
                [56, 173],
                [173, 190],
                [182, 106],
                [106, 194],
                [194, 182],
                [138, 135],
                [135, 192],
                [192, 138],
                [129, 203],
                [203, 98],
                [98, 129],
                [54, 21],
                [21, 68],
                [68, 54],
                [5, 51],
                [51, 4],
                [4, 5],
                [145, 144],
                [144, 23],
                [23, 145],
                [90, 77],
                [77, 91],
                [91, 90],
                [207, 205],
                [205, 187],
                [187, 207],
                [83, 201],
                [201, 18],
                [18, 83],
                [181, 91],
                [91, 182],
                [182, 181],
                [180, 90],
                [90, 181],
                [181, 180],
                [16, 85],
                [85, 17],
                [17, 16],
                [205, 206],
                [206, 36],
                [36, 205],
                [176, 148],
                [148, 140],
                [140, 176],
                [165, 92],
                [92, 39],
                [39, 165],
                [245, 193],
                [193, 244],
                [244, 245],
                [27, 159],
                [159, 28],
                [28, 27],
                [
                  30,
                  247
                ],
                [247, 161],
                [161, 30],
                [174, 236],
                [236, 196],
                [196, 174],
                [103, 54],
                [54, 104],
                [104, 103],
                [55, 193],
                [193, 8],
                [8, 55],
                [111, 117],
                [117, 31],
                [31, 111],
                [221, 189],
                [189, 55],
                [55, 221],
                [240, 98],
                [98, 99],
                [99, 240],
                [142, 126],
                [126, 100],
                [100, 142],
                [219, 166],
                [166, 218],
                [218, 219],
                [112, 155],
                [155, 26],
                [26, 112],
                [198, 209],
                [209, 131],
                [131, 198],
                [169, 135],
                [135, 150],
                [150, 169],
                [114, 47],
                [47, 217],
                [217, 114],
                [224, 223],
                [223, 53],
                [53, 224],
                [220, 45],
                [45, 134],
                [134, 220],
                [32, 211],
                [211, 140],
                [140, 32],
                [109, 67],
                [67, 108],
                [108, 109],
                [146, 43],
                [43, 91],
                [91, 146],
                [231, 230],
                [230, 120],
                [120, 231],
                [113, 226],
                [226, 247],
                [247, 113],
                [105, 63],
                [63, 52],
                [52, 105],
                [241, 238],
                [238, 242],
                [242, 241],
                [124, 46],
                [46, 156],
                [156, 124],
                [95, 78],
                [78, 96],
                [96, 95],
                [70, 46],
                [46, 63],
                [63, 70],
                [116, 143],
                [143, 227],
                [227, 116],
                [116, 123],
                [123, 111],
                [111, 116],
                [1, 44],
                [44, 19],
                [19, 1],
                [3, 236],
                [236, 51],
                [51, 3],
                [207, 216],
                [216, 205],
                [205, 207],
                [26, 154],
                [154, 22],
                [22, 26],
                [165, 39],
                [39, 167],
                [167, 165],
                [199, 200],
                [200, 208],
                [208, 199],
                [101, 36],
                [36, 100],
                [100, 101],
                [43, 57],
                [57, 202],
                [202, 43],
                [242, 20],
                [20, 99],
                [99, 242],
                [56, 28],
                [
                  28,
                  157
                ],
                [157, 56],
                [124, 35],
                [35, 113],
                [113, 124],
                [29, 160],
                [160, 27],
                [27, 29],
                [211, 204],
                [204, 210],
                [210, 211],
                [124, 113],
                [113, 46],
                [46, 124],
                [106, 43],
                [43, 204],
                [204, 106],
                [96, 62],
                [62, 77],
                [77, 96],
                [227, 137],
                [137, 116],
                [116, 227],
                [73, 41],
                [41, 72],
                [72, 73],
                [36, 203],
                [203, 142],
                [142, 36],
                [235, 64],
                [64, 240],
                [240, 235],
                [48, 49],
                [49, 64],
                [64, 48],
                [42, 41],
                [41, 74],
                [74, 42],
                [214, 212],
                [212, 207],
                [207, 214],
                [183, 42],
                [42, 184],
                [184, 183],
                [210, 169],
                [169, 211],
                [211, 210],
                [140, 170],
                [170, 176],
                [176, 140],
                [104, 105],
                [105, 69],
                [69, 104],
                [193, 122],
                [122, 168],
                [168, 193],
                [50, 123],
                [123, 187],
                [187, 50],
                [89, 96],
                [96, 90],
                [90, 89],
                [66, 65],
                [65, 107],
                [107, 66],
                [179, 89],
                [89, 180],
                [180, 179],
                [119, 101],
                [101, 120],
                [120, 119],
                [68, 63],
                [63, 104],
                [104, 68],
                [234, 93],
                [93, 227],
                [227, 234],
                [16, 15],
                [15, 85],
                [85, 16],
                [209, 129],
                [129, 49],
                [49, 209],
                [15, 14],
                [14, 86],
                [86, 15],
                [107, 55],
                [55, 9],
                [9, 107],
                [120, 100],
                [100, 121],
                [121, 120],
                [153, 145],
                [145, 22],
                [22, 153],
                [178, 88],
                [88, 179],
                [179, 178],
                [197, 6],
                [6, 196],
                [196, 197],
                [89, 88],
                [88, 96],
                [96, 89],
                [135, 138],
                [138, 136],
                [136, 135],
                [138, 215],
                [215, 172],
                [172, 138],
                [
                  218,
                  115
                ],
                [115, 219],
                [219, 218],
                [41, 42],
                [42, 81],
                [81, 41],
                [5, 195],
                [195, 51],
                [51, 5],
                [57, 43],
                [43, 61],
                [61, 57],
                [208, 171],
                [171, 199],
                [199, 208],
                [41, 81],
                [81, 38],
                [38, 41],
                [224, 53],
                [53, 225],
                [225, 224],
                [24, 144],
                [144, 110],
                [110, 24],
                [105, 52],
                [52, 66],
                [66, 105],
                [118, 229],
                [229, 117],
                [117, 118],
                [227, 34],
                [34, 234],
                [234, 227],
                [66, 107],
                [107, 69],
                [69, 66],
                [10, 109],
                [109, 151],
                [151, 10],
                [219, 48],
                [48, 235],
                [235, 219],
                [183, 62],
                [62, 191],
                [191, 183],
                [142, 129],
                [129, 126],
                [126, 142],
                [116, 111],
                [111, 143],
                [143, 116],
                [118, 117],
                [117, 50],
                [50, 118],
                [223, 222],
                [
                  222,
                  52
                ],
                [52, 223],
                [94, 19],
                [19, 141],
                [141, 94],
                [222, 221],
                [221, 65],
                [65, 222],
                [196, 3],
                [3, 197],
                [197, 196],
                [45, 220],
                [220, 44],
                [44, 45],
                [156, 70],
                [70, 139],
                [139, 156],
                [188, 122],
                [122, 245],
                [245, 188],
                [139, 71],
                [71, 162],
                [162, 139],
                [149, 170],
                [170, 150],
                [150, 149],
                [122, 188],
                [188, 196],
                [196, 122],
                [206, 216],
                [216, 92],
                [92, 206],
                [164, 2],
                [2, 167],
                [167, 164],
                [242, 141],
                [141, 241],
                [241, 242],
                [0, 164],
                [164, 37],
                [37, 0],
                [11, 72],
                [72, 12],
                [12, 11],
                [12, 38],
                [38, 13],
                [13, 12],
                [70, 63],
                [63, 71],
                [71, 70],
                [31, 226],
                [226, 111],
                [111, 31],
                [36, 101],
                [101, 205],
                [205, 36],
                [203, 206],
                [206, 165],
                [165, 203],
                [126, 209],
                [209, 217],
                [217, 126],
                [98, 165],
                [165, 97],
                [97, 98],
                [237, 220],
                [220, 218],
                [218, 237],
                [237, 239],
                [239, 241],
                [241, 237],
                [210, 214],
                [214, 169],
                [169, 210],
                [140, 171],
                [171, 32],
                [32, 140],
                [241, 125],
                [125, 237],
                [237, 241],
                [179, 86],
                [86, 178],
                [178, 179],
                [180, 85],
                [85, 179],
                [179, 180],
                [181, 84],
                [84, 180],
                [180, 181],
                [182, 83],
                [83, 181],
                [181, 182],
                [194, 201],
                [201, 182],
                [182, 194],
                [177, 137],
                [137, 132],
                [132, 177],
                [184, 76],
                [76, 183],
                [183, 184],
                [185, 61],
                [61, 184],
                [184, 185],
                [186, 57],
                [57, 185],
                [185, 186],
                [216, 212],
                [
                  212,
                  186
                ],
                [186, 216],
                [192, 214],
                [214, 187],
                [187, 192],
                [139, 34],
                [34, 156],
                [156, 139],
                [218, 79],
                [79, 237],
                [237, 218],
                [147, 123],
                [123, 177],
                [177, 147],
                [45, 44],
                [44, 4],
                [4, 45],
                [208, 201],
                [201, 32],
                [32, 208],
                [98, 64],
                [64, 129],
                [129, 98],
                [192, 213],
                [213, 138],
                [138, 192],
                [235, 59],
                [59, 219],
                [219, 235],
                [141, 242],
                [242, 97],
                [97, 141],
                [97, 2],
                [2, 141],
                [141, 97],
                [240, 75],
                [75, 235],
                [235, 240],
                [229, 24],
                [24, 228],
                [228, 229],
                [31, 25],
                [25, 226],
                [226, 31],
                [230, 23],
                [23, 229],
                [229, 230],
                [231, 22],
                [22, 230],
                [230, 231],
                [232, 26],
                [26, 231],
                [231, 232],
                [233, 112],
                [112, 232],
                [232, 233],
                [244, 189],
                [189, 243],
                [243, 244],
                [189, 221],
                [221, 190],
                [190, 189],
                [222, 28],
                [28, 221],
                [221, 222],
                [223, 27],
                [27, 222],
                [222, 223],
                [224, 29],
                [29, 223],
                [223, 224],
                [225, 30],
                [30, 224],
                [224, 225],
                [113, 247],
                [247, 225],
                [225, 113],
                [99, 60],
                [60, 240],
                [240, 99],
                [213, 147],
                [147, 215],
                [215, 213],
                [60, 20],
                [20, 166],
                [166, 60],
                [192, 187],
                [187, 213],
                [213, 192],
                [243, 112],
                [112, 244],
                [244, 243],
                [244, 233],
                [233, 245],
                [245, 244],
                [245, 128],
                [128, 188],
                [188, 245],
                [188, 114],
                [114, 174],
                [174, 188],
                [134, 131],
                [131, 220],
                [220, 134],
                [174, 217],
                [217, 236],
                [236, 174],
                [236, 198],
                [198, 134],
                [134, 236],
                [215, 177],
                [177, 58],
                [58, 215],
                [156, 143],
                [143, 124],
                [124, 156],
                [25, 110],
                [110, 7],
                [7, 25],
                [31, 228],
                [228, 25],
                [25, 31],
                [264, 356],
                [356, 368],
                [368, 264],
                [0, 11],
                [11, 267],
                [267, 0],
                [451, 452],
                [452, 349],
                [349, 451],
                [267, 302],
                [302, 269],
                [269, 267],
                [350, 357],
                [357, 277],
                [277, 350],
                [350, 452],
                [452, 357],
                [357, 350],
                [299, 333],
                [333, 297],
                [297, 299],
                [396, 175],
                [175, 377],
                [377, 396],
                [280, 347],
                [347, 330],
                [330, 280],
                [269, 303],
                [303, 270],
                [270, 269],
                [151, 9],
                [9, 337],
                [337, 151],
                [344, 278],
                [278, 360],
                [360, 344],
                [424, 418],
                [
                  418,
                  431
                ],
                [431, 424],
                [270, 304],
                [304, 409],
                [409, 270],
                [272, 310],
                [310, 407],
                [407, 272],
                [322, 270],
                [270, 410],
                [410, 322],
                [449, 450],
                [450, 347],
                [347, 449],
                [432, 422],
                [422, 434],
                [434, 432],
                [18, 313],
                [313, 17],
                [17, 18],
                [291, 306],
                [306, 375],
                [375, 291],
                [259, 387],
                [387, 260],
                [260, 259],
                [424, 335],
                [335, 418],
                [418, 424],
                [434, 364],
                [364, 416],
                [416, 434],
                [391, 423],
                [423, 327],
                [327, 391],
                [301, 251],
                [251, 298],
                [298, 301],
                [275, 281],
                [281, 4],
                [4, 275],
                [254, 373],
                [373, 253],
                [253, 254],
                [375, 307],
                [307, 321],
                [321, 375],
                [280, 425],
                [425, 411],
                [411, 280],
                [200, 421],
                [
                  421,
                  18
                ],
                [18, 200],
                [335, 321],
                [321, 406],
                [406, 335],
                [321, 320],
                [320, 405],
                [405, 321],
                [314, 315],
                [315, 17],
                [17, 314],
                [423, 426],
                [426, 266],
                [266, 423],
                [396, 377],
                [377, 369],
                [369, 396],
                [270, 322],
                [322, 269],
                [269, 270],
                [413, 417],
                [417, 464],
                [464, 413],
                [385, 386],
                [386, 258],
                [258, 385],
                [248, 456],
                [456, 419],
                [419, 248],
                [298, 284],
                [284, 333],
                [333, 298],
                [168, 417],
                [417, 8],
                [8, 168],
                [448, 346],
                [346, 261],
                [261, 448],
                [417, 413],
                [413, 285],
                [285, 417],
                [326, 327],
                [327, 328],
                [328, 326],
                [277, 355],
                [355, 329],
                [329, 277],
                [309, 392],
                [392, 438],
                [438, 309],
                [381, 382],
                [
                  382,
                  256
                ],
                [256, 381],
                [279, 429],
                [429, 360],
                [360, 279],
                [365, 364],
                [364, 379],
                [379, 365],
                [355, 277],
                [277, 437],
                [437, 355],
                [282, 443],
                [443, 283],
                [283, 282],
                [281, 275],
                [275, 363],
                [363, 281],
                [395, 431],
                [431, 369],
                [369, 395],
                [299, 297],
                [297, 337],
                [337, 299],
                [335, 273],
                [273, 321],
                [321, 335],
                [348, 450],
                [450, 349],
                [349, 348],
                [359, 446],
                [446, 467],
                [467, 359],
                [283, 293],
                [293, 282],
                [282, 283],
                [250, 458],
                [458, 462],
                [462, 250],
                [300, 276],
                [276, 383],
                [383, 300],
                [292, 308],
                [308, 325],
                [325, 292],
                [283, 276],
                [276, 293],
                [293, 283],
                [264, 372],
                [372, 447],
                [447, 264],
                [346, 352],
                [352, 340],
                [340, 346],
                [354, 274],
                [274, 19],
                [19, 354],
                [363, 456],
                [456, 281],
                [281, 363],
                [426, 436],
                [436, 425],
                [425, 426],
                [380, 381],
                [381, 252],
                [252, 380],
                [267, 269],
                [269, 393],
                [393, 267],
                [421, 200],
                [200, 428],
                [428, 421],
                [371, 266],
                [266, 329],
                [329, 371],
                [432, 287],
                [287, 422],
                [422, 432],
                [290, 250],
                [250, 328],
                [328, 290],
                [385, 258],
                [258, 384],
                [384, 385],
                [446, 265],
                [265, 342],
                [342, 446],
                [386, 387],
                [387, 257],
                [257, 386],
                [422, 424],
                [424, 430],
                [430, 422],
                [445, 342],
                [342, 276],
                [276, 445],
                [422, 273],
                [273, 424],
                [424, 422],
                [306, 292],
                [292, 307],
                [307, 306],
                [
                  352,
                  366
                ],
                [366, 345],
                [345, 352],
                [268, 271],
                [271, 302],
                [302, 268],
                [358, 423],
                [423, 371],
                [371, 358],
                [327, 294],
                [294, 460],
                [460, 327],
                [331, 279],
                [279, 294],
                [294, 331],
                [303, 271],
                [271, 304],
                [304, 303],
                [436, 432],
                [432, 427],
                [427, 436],
                [304, 272],
                [272, 408],
                [408, 304],
                [395, 394],
                [394, 431],
                [431, 395],
                [378, 395],
                [395, 400],
                [400, 378],
                [296, 334],
                [334, 299],
                [299, 296],
                [6, 351],
                [351, 168],
                [168, 6],
                [376, 352],
                [352, 411],
                [411, 376],
                [307, 325],
                [325, 320],
                [320, 307],
                [285, 295],
                [295, 336],
                [336, 285],
                [320, 319],
                [319, 404],
                [404, 320],
                [329, 330],
                [330, 349],
                [349, 329],
                [334, 293],
                [293, 333],
                [333, 334],
                [366, 323],
                [323, 447],
                [447, 366],
                [316, 15],
                [15, 315],
                [315, 316],
                [331, 358],
                [358, 279],
                [279, 331],
                [317, 14],
                [14, 316],
                [316, 317],
                [8, 285],
                [285, 9],
                [9, 8],
                [277, 329],
                [329, 350],
                [350, 277],
                [253, 374],
                [374, 252],
                [252, 253],
                [319, 318],
                [318, 403],
                [403, 319],
                [351, 6],
                [6, 419],
                [419, 351],
                [324, 318],
                [318, 325],
                [325, 324],
                [397, 367],
                [367, 365],
                [365, 397],
                [288, 435],
                [435, 397],
                [397, 288],
                [278, 344],
                [344, 439],
                [439, 278],
                [310, 272],
                [272, 311],
                [311, 310],
                [248, 195],
                [195, 281],
                [281, 248],
                [375, 273],
                [273, 291],
                [291, 375],
                [175, 396],
                [396, 199],
                [199, 175],
                [312, 311],
                [311, 268],
                [268, 312],
                [276, 283],
                [283, 445],
                [445, 276],
                [390, 373],
                [373, 339],
                [339, 390],
                [295, 282],
                [282, 296],
                [296, 295],
                [448, 449],
                [449, 346],
                [346, 448],
                [356, 264],
                [264, 454],
                [454, 356],
                [337, 336],
                [336, 299],
                [299, 337],
                [337, 338],
                [338, 151],
                [151, 337],
                [294, 278],
                [278, 455],
                [455, 294],
                [308, 292],
                [292, 415],
                [415, 308],
                [429, 358],
                [358, 355],
                [355, 429],
                [265, 340],
                [340, 372],
                [372, 265],
                [352, 346],
                [346, 280],
                [280, 352],
                [295, 442],
                [442, 282],
                [282, 295],
                [354, 19],
                [19, 370],
                [370, 354],
                [285, 441],
                [441, 295],
                [295, 285],
                [
                  195,
                  248
                ],
                [248, 197],
                [197, 195],
                [457, 440],
                [440, 274],
                [274, 457],
                [301, 300],
                [300, 368],
                [368, 301],
                [417, 351],
                [351, 465],
                [465, 417],
                [251, 301],
                [301, 389],
                [389, 251],
                [394, 395],
                [395, 379],
                [379, 394],
                [399, 412],
                [412, 419],
                [419, 399],
                [410, 436],
                [436, 322],
                [322, 410],
                [326, 2],
                [2, 393],
                [393, 326],
                [354, 370],
                [370, 461],
                [461, 354],
                [393, 164],
                [164, 267],
                [267, 393],
                [268, 302],
                [302, 12],
                [12, 268],
                [312, 268],
                [268, 13],
                [13, 312],
                [298, 293],
                [293, 301],
                [301, 298],
                [265, 446],
                [446, 340],
                [340, 265],
                [280, 330],
                [330, 425],
                [425, 280],
                [322, 426],
                [426, 391],
                [391, 322],
                [
                  420,
                  429
                ],
                [429, 437],
                [437, 420],
                [393, 391],
                [391, 326],
                [326, 393],
                [344, 440],
                [440, 438],
                [438, 344],
                [458, 459],
                [459, 461],
                [461, 458],
                [364, 434],
                [434, 394],
                [394, 364],
                [428, 396],
                [396, 262],
                [262, 428],
                [274, 354],
                [354, 457],
                [457, 274],
                [317, 316],
                [316, 402],
                [402, 317],
                [316, 315],
                [315, 403],
                [403, 316],
                [315, 314],
                [314, 404],
                [404, 315],
                [314, 313],
                [313, 405],
                [405, 314],
                [313, 421],
                [421, 406],
                [406, 313],
                [323, 366],
                [366, 361],
                [361, 323],
                [292, 306],
                [306, 407],
                [407, 292],
                [306, 291],
                [291, 408],
                [408, 306],
                [291, 287],
                [287, 409],
                [409, 291],
                [287, 432],
                [432, 410],
                [410, 287],
                [427, 434],
                [434, 411],
                [411, 427],
                [372, 264],
                [264, 383],
                [383, 372],
                [459, 309],
                [309, 457],
                [457, 459],
                [366, 352],
                [352, 401],
                [401, 366],
                [1, 274],
                [274, 4],
                [4, 1],
                [418, 421],
                [421, 262],
                [262, 418],
                [331, 294],
                [294, 358],
                [358, 331],
                [435, 433],
                [433, 367],
                [367, 435],
                [392, 289],
                [289, 439],
                [439, 392],
                [328, 462],
                [462, 326],
                [326, 328],
                [94, 2],
                [2, 370],
                [370, 94],
                [289, 305],
                [305, 455],
                [455, 289],
                [339, 254],
                [254, 448],
                [448, 339],
                [359, 255],
                [255, 446],
                [446, 359],
                [254, 253],
                [253, 449],
                [449, 254],
                [253, 252],
                [252, 450],
                [450, 253],
                [252, 256],
                [256, 451],
                [451, 252],
                [
                  256,
                  341
                ],
                [341, 452],
                [452, 256],
                [414, 413],
                [413, 463],
                [463, 414],
                [286, 441],
                [441, 414],
                [414, 286],
                [286, 258],
                [258, 441],
                [441, 286],
                [258, 257],
                [257, 442],
                [442, 258],
                [257, 259],
                [259, 443],
                [443, 257],
                [259, 260],
                [260, 444],
                [444, 259],
                [260, 467],
                [467, 445],
                [445, 260],
                [309, 459],
                [459, 250],
                [250, 309],
                [305, 289],
                [289, 290],
                [290, 305],
                [305, 290],
                [290, 460],
                [460, 305],
                [401, 376],
                [376, 435],
                [435, 401],
                [309, 250],
                [250, 392],
                [392, 309],
                [376, 411],
                [411, 433],
                [433, 376],
                [453, 341],
                [341, 464],
                [464, 453],
                [357, 453],
                [453, 465],
                [465, 357],
                [343, 357],
                [357, 412],
                [412, 343],
                [437, 343],
                [343, 399],
                [399, 437],
                [344, 360],
                [360, 440],
                [440, 344],
                [420, 437],
                [437, 456],
                [456, 420],
                [360, 420],
                [420, 363],
                [363, 360],
                [361, 401],
                [401, 288],
                [288, 361],
                [265, 372],
                [372, 353],
                [353, 265],
                [390, 339],
                [339, 249],
                [249, 390],
                [339, 448],
                [448, 255],
                [255, 339]
              ]), Ji("HAND_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 4], [0, 5], [5, 6], [6, 7], [7, 8], [5, 9], [9, 10], [10, 11], [11, 12], [9, 13], [13, 14], [14, 15], [15, 16], [13, 17], [0, 17], [17, 18], [18, 19], [19, 20]]), Ji("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]), Ji("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 }), Ji("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 }), Ji("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 }), Ji("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 }), Ji("matrixDataToMatrix", function(C) {
                for (var x = C.getCols(), ee = C.getRows(), F = C.getPackedDataList(), M = [], H = 0; H < ee; H++)
                  M.push(Array(x));
                for (H = 0; H < ee; H++)
                  for (var ce = 0; ce < x; ce++) {
                    var ke = C.getLayout() === 1 ? H * x + ce : ce * ee + H;
                    M[H][ce] = F[ke];
                  }
                return M;
              }), Ji("VERSION", "0.5.1635989137");
            }).call(tt);
            const Oe = {};
            (function() {
              var E;
              function R(X) {
                var j = 0;
                return function() {
                  return j < X.length ? { done: !1, value: X[j++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(X, j, Ae) {
                return X == Array.prototype || X == Object.prototype || (X[j] = Ae.value), X;
              };
              function ie(X) {
                X = [typeof globalThis == "object" && globalThis, X, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var j = 0; j < X.length; ++j) {
                  var Ae = X[j];
                  if (Ae && Ae.Math == Math)
                    return Ae;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(X, j) {
                if (j)
                  e: {
                    var Ae = pe;
                    X = X.split(".");
                    for (var C = 0; C < X.length - 1; C++) {
                      var x = X[C];
                      if (!(x in Ae))
                        break e;
                      Ae = Ae[x];
                    }
                    X = X[X.length - 1], C = Ae[X], j = j(C), j != C && j != null && S(Ae, X, { configurable: !0, writable: !0, value: j });
                  }
              }
              De("Symbol", function(X) {
                function j(ee) {
                  if (this instanceof j)
                    throw new TypeError("Symbol is not a constructor");
                  return new Ae(C + (ee || "") + "_" + x++, ee);
                }
                function Ae(ee, F) {
                  this.g = ee, S(this, "description", { configurable: !0, writable: !0, value: F });
                }
                if (X)
                  return X;
                Ae.prototype.toString = function() {
                  return this.g;
                };
                var C = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", x = 0;
                return j;
              }), De("Symbol.iterator", function(X) {
                if (X)
                  return X;
                X = Symbol("Symbol.iterator");
                for (var j = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), Ae = 0; Ae < j.length; Ae++) {
                  var C = pe[j[Ae]];
                  typeof C == "function" && typeof C.prototype[X] != "function" && S(C.prototype, X, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return X;
              });
              function ht(X) {
                return X = { next: X }, X[Symbol.iterator] = function() {
                  return this;
                }, X;
              }
              function rt(X) {
                var j = typeof Symbol < "u" && Symbol.iterator && X[Symbol.iterator];
                return j ? j.call(X) : { next: R(X) };
              }
              function Nt(X) {
                if (!(X instanceof Array)) {
                  X = rt(X);
                  for (var j, Ae = []; !(j = X.next()).done; )
                    Ae.push(j.value);
                  X = Ae;
                }
                return X;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(X) {
                function j() {
                }
                return j.prototype = X, new j();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(X, j) {
                  if (X.__proto__ = j, X.__proto__ !== j)
                    throw new TypeError(X + " is not extensible");
                  return X;
                } : null;
              }
              var br = cr;
              function Nr(X, j) {
                if (X.prototype = Pn(j.prototype), X.prototype.constructor = X, br)
                  br(X, j);
                else
                  for (var Ae in j)
                    if (Ae != "prototype")
                      if (Object.defineProperties) {
                        var C = Object.getOwnPropertyDescriptor(j, Ae);
                        C && Object.defineProperty(X, Ae, C);
                      } else
                        X[Ae] = j[Ae];
                X.na = j.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.u = this.o = 0, this.j = null;
              }
              function qi(X) {
                if (X.l)
                  throw new TypeError("Generator is already running");
                X.l = !0;
              }
              $i.prototype.s = function(X) {
                this.h = X;
              };
              function Vo(X, j) {
                X.j = { da: j, ea: !0 }, X.g = X.o || X.u;
              }
              $i.prototype.return = function(X) {
                this.j = { return: X }, this.g = this.u;
              };
              function Un(X, j, Ae) {
                return X.g = Ae, { value: j };
              }
              function el(X) {
                this.g = new $i(), this.h = X;
              }
              function Ys(X, j) {
                qi(X.g);
                var Ae = X.g.i;
                return Ae ? Ca(X, "return" in Ae ? Ae.return : function(C) {
                  return { value: C, done: !0 };
                }, j, X.g.return) : (X.g.return(j), lo(X));
              }
              function Ca(X, j, Ae, C) {
                try {
                  var x = j.call(X.g.i, Ae);
                  if (!(x instanceof Object))
                    throw new TypeError("Iterator result " + x + " is not an object");
                  if (!x.done)
                    return X.g.l = !1, x;
                  var ee = x.value;
                } catch (F) {
                  return X.g.i = null, Vo(X.g, F), lo(X);
                }
                return X.g.i = null, C.call(X.g, ee), lo(X);
              }
              function lo(X) {
                for (; X.g.g; )
                  try {
                    var j = X.h(X.g);
                    if (j)
                      return X.g.l = !1, { value: j.value, done: !1 };
                  } catch (Ae) {
                    X.g.h = void 0, Vo(X.g, Ae);
                  }
                if (X.g.l = !1, X.g.j) {
                  if (j = X.g.j, X.g.j = null, j.ea)
                    throw j.da;
                  return { value: j.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(X) {
                this.next = function(j) {
                  return qi(X.g), X.g.i ? j = Ca(X, X.g.i.next, j, X.g.s) : (X.g.s(j), j = lo(X)), j;
                }, this.throw = function(j) {
                  return qi(X.g), X.g.i ? j = Ca(X, X.g.i.throw, j, X.g.s) : (Vo(X.g, j), j = lo(X)), j;
                }, this.return = function(j) {
                  return Ys(X, j);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(X) {
                function j(C) {
                  return X.next(C);
                }
                function Ae(C) {
                  return X.throw(C);
                }
                return new n(function(C, x) {
                  function ee(F) {
                    F.done ? C(F.value) : n.resolve(F.value).then(j, Ae).then(ee, x);
                  }
                  ee(X.next());
                });
              }
              function Mr(X) {
                return Go(new Cc(new el(X)));
              }
              De("Promise", function(X) {
                function j(F) {
                  this.h = 0, this.i = void 0, this.g = [], this.s = !1;
                  var M = this.j();
                  try {
                    F(M.resolve, M.reject);
                  } catch (H) {
                    M.reject(H);
                  }
                }
                function Ae() {
                  this.g = null;
                }
                function C(F) {
                  return F instanceof j ? F : new j(function(M) {
                    M(F);
                  });
                }
                if (X)
                  return X;
                Ae.prototype.h = function(F) {
                  if (this.g == null) {
                    this.g = [];
                    var M = this;
                    this.i(function() {
                      M.l();
                    });
                  }
                  this.g.push(F);
                };
                var x = pe.setTimeout;
                Ae.prototype.i = function(F) {
                  x(F, 0);
                }, Ae.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var F = this.g;
                    this.g = [];
                    for (var M = 0; M < F.length; ++M) {
                      var H = F[M];
                      F[M] = null;
                      try {
                        H();
                      } catch (ce) {
                        this.j(ce);
                      }
                    }
                  }
                  this.g = null;
                }, Ae.prototype.j = function(F) {
                  this.i(function() {
                    throw F;
                  });
                }, j.prototype.j = function() {
                  function F(ce) {
                    return function(ke) {
                      H || (H = !0, ce.call(M, ke));
                    };
                  }
                  var M = this, H = !1;
                  return { resolve: F(this.D), reject: F(this.l) };
                }, j.prototype.D = function(F) {
                  if (F === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (F instanceof j)
                    this.H(F);
                  else {
                    e:
                      switch (typeof F) {
                        case "object":
                          var M = F != null;
                          break e;
                        case "function":
                          M = !0;
                          break e;
                        default:
                          M = !1;
                      }
                    M ? this.A(F) : this.o(F);
                  }
                }, j.prototype.A = function(F) {
                  var M = void 0;
                  try {
                    M = F.then;
                  } catch (H) {
                    this.l(H);
                    return;
                  }
                  typeof M == "function" ? this.I(M, F) : this.o(F);
                }, j.prototype.l = function(F) {
                  this.u(2, F);
                }, j.prototype.o = function(F) {
                  this.u(1, F);
                }, j.prototype.u = function(F, M) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + F + ", " + M + "): Promise already settled in state" + this.h);
                  this.h = F, this.i = M, this.h === 2 && this.G(), this.B();
                }, j.prototype.G = function() {
                  var F = this;
                  x(function() {
                    if (F.C()) {
                      var M = pe.console;
                      typeof M < "u" && M.error(F.i);
                    }
                  }, 1);
                }, j.prototype.C = function() {
                  if (this.s)
                    return !1;
                  var F = pe.CustomEvent, M = pe.Event, H = pe.dispatchEvent;
                  return typeof H > "u" ? !0 : (typeof F == "function" ? F = new F("unhandledrejection", { cancelable: !0 }) : typeof M == "function" ? F = new M("unhandledrejection", { cancelable: !0 }) : (F = pe.document.createEvent("CustomEvent"), F.initCustomEvent("unhandledrejection", !1, !0, F)), F.promise = this, F.reason = this.i, H(F));
                }, j.prototype.B = function() {
                  if (this.g != null) {
                    for (var F = 0; F < this.g.length; ++F)
                      ee.h(this.g[F]);
                    this.g = null;
                  }
                };
                var ee = new Ae();
                return j.prototype.H = function(F) {
                  var M = this.j();
                  F.M(M.resolve, M.reject);
                }, j.prototype.I = function(F, M) {
                  var H = this.j();
                  try {
                    F.call(M, H.resolve, H.reject);
                  } catch (ce) {
                    H.reject(ce);
                  }
                }, j.prototype.then = function(F, M) {
                  function H(mt, xt) {
                    return typeof mt == "function" ? function(dn) {
                      try {
                        ce(mt(dn));
                      } catch (Bn) {
                        ke(Bn);
                      }
                    } : xt;
                  }
                  var ce, ke, st = new j(function(mt, xt) {
                    ce = mt, ke = xt;
                  });
                  return this.M(H(F, ce), H(M, ke)), st;
                }, j.prototype.catch = function(F) {
                  return this.then(void 0, F);
                }, j.prototype.M = function(F, M) {
                  function H() {
                    switch (ce.h) {
                      case 1:
                        F(ce.i);
                        break;
                      case 2:
                        M(ce.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + ce.h);
                    }
                  }
                  var ce = this;
                  this.g == null ? ee.h(H) : this.g.push(H), this.s = !0;
                }, j.resolve = C, j.reject = function(F) {
                  return new j(function(M, H) {
                    H(F);
                  });
                }, j.race = function(F) {
                  return new j(function(M, H) {
                    for (var ce = rt(F), ke = ce.next(); !ke.done; ke = ce.next())
                      C(ke.value).M(M, H);
                  });
                }, j.all = function(F) {
                  var M = rt(F), H = M.next();
                  return H.done ? C([]) : new j(function(ce, ke) {
                    function st(dn) {
                      return function(Bn) {
                        mt[dn] = Bn, xt--, xt == 0 && ce(mt);
                      };
                    }
                    var mt = [], xt = 0;
                    do
                      mt.push(void 0), xt++, C(H.value).M(st(mt.length - 1), ke), H = M.next();
                    while (!H.done);
                  });
                }, j;
              });
              function ml(X, j) {
                X instanceof String && (X += "");
                var Ae = 0, C = !1, x = { next: function() {
                  if (!C && Ae < X.length) {
                    var ee = Ae++;
                    return { value: j(ee, X[ee]), done: !1 };
                  }
                  return C = !0, { done: !0, value: void 0 };
                } };
                return x[Symbol.iterator] = function() {
                  return x;
                }, x;
              }
              var cd = typeof Object.assign == "function" ? Object.assign : function(X, j) {
                for (var Ae = 1; Ae < arguments.length; Ae++) {
                  var C = arguments[Ae];
                  if (C)
                    for (var x in C)
                      Object.prototype.hasOwnProperty.call(C, x) && (X[x] = C[x]);
                }
                return X;
              };
              De("Object.assign", function(X) {
                return X || cd;
              }), De("Object.is", function(X) {
                return X || function(j, Ae) {
                  return j === Ae ? j !== 0 || 1 / j === 1 / Ae : j !== j && Ae !== Ae;
                };
              }), De("Array.prototype.includes", function(X) {
                return X || function(j, Ae) {
                  var C = this;
                  C instanceof String && (C = String(C));
                  var x = C.length;
                  for (Ae = Ae || 0, 0 > Ae && (Ae = Math.max(Ae + x, 0)); Ae < x; Ae++) {
                    var ee = C[Ae];
                    if (ee === j || Object.is(ee, j))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(X) {
                return X || function(j, Ae) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (j instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(j, Ae || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(X) {
                return X || function() {
                  return ml(this, function(j) {
                    return j;
                  });
                };
              });
              var Ma = this || self;
              function Ji(X, j) {
                X = X.split(".");
                var Ae = Ma;
                X[0] in Ae || typeof Ae.execScript > "u" || Ae.execScript("var " + X[0]);
                for (var C; X.length && (C = X.shift()); )
                  X.length || j === void 0 ? Ae[C] && Ae[C] !== Object.prototype[C] ? Ae = Ae[C] : Ae = Ae[C] = {} : Ae[C] = j;
              }
              function ts() {
                throw Error("Invalid UTF8");
              }
              function tl(X, j) {
                return j = String.fromCharCode.apply(null, j), X == null ? j : X + j;
              }
              var Wl, Ac = typeof TextDecoder < "u", Hl, Uc = typeof TextEncoder < "u", dl = {}, vl = null;
              function Nc(X) {
                var j;
                j === void 0 && (j = 0), Is(), j = dl[j];
                for (var Ae = Array(Math.floor(X.length / 3)), C = j[64] || "", x = 0, ee = 0; x < X.length - 2; x += 3) {
                  var F = X[x], M = X[x + 1], H = X[x + 2], ce = j[F >> 2];
                  F = j[(F & 3) << 4 | M >> 4], M = j[(M & 15) << 2 | H >> 6], H = j[H & 63], Ae[ee++] = ce + F + M + H;
                }
                switch (ce = 0, H = C, X.length - x) {
                  case 2:
                    ce = X[x + 1], H = j[(ce & 15) << 2] || C;
                  case 1:
                    X = X[x], Ae[ee] = j[X >> 2] + j[(X & 3) << 4 | ce >> 4] + H + C;
                }
                return Ae.join("");
              }
              function gc(X) {
                var j = X.length, Ae = 3 * j / 4;
                Ae % 3 ? Ae = Math.floor(Ae) : "=.".indexOf(X[j - 1]) != -1 && (Ae = "=.".indexOf(X[j - 2]) != -1 ? Ae - 2 : Ae - 1);
                var C = new Uint8Array(Ae), x = 0;
                return Js(X, function(ee) {
                  C[x++] = ee;
                }), x !== Ae ? C.subarray(0, x) : C;
              }
              function Js(X, j) {
                function Ae(H) {
                  for (; C < X.length; ) {
                    var ce = X.charAt(C++), ke = vl[ce];
                    if (ke != null)
                      return ke;
                    if (!/^[\s\xa0]*$/.test(ce))
                      throw Error("Unknown base64 encoding at char: " + ce);
                  }
                  return H;
                }
                Is();
                for (var C = 0; ; ) {
                  var x = Ae(-1), ee = Ae(0), F = Ae(64), M = Ae(64);
                  if (M === 64 && x === -1)
                    break;
                  j(x << 2 | ee >> 4), F != 64 && (j(ee << 4 & 240 | F >> 2), M != 64 && j(F << 6 & 192 | M));
                }
              }
              function Is() {
                if (!vl) {
                  vl = {};
                  for (var X = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), j = ["+/=", "+/", "-_=", "-_.", "-_"], Ae = 0; 5 > Ae; Ae++) {
                    var C = X.concat(j[Ae].split(""));
                    dl[Ae] = C;
                    for (var x = 0; x < C.length; x++) {
                      var ee = C[x];
                      vl[ee] === void 0 && (vl[ee] = x);
                    }
                  }
                }
              }
              var Pl = typeof Uint8Array == "function";
              function Nl(X) {
                return Pl && X != null && X instanceof Uint8Array;
              }
              var ta;
              function $a(X) {
                if (this.L = X, X !== null && X.length === 0)
                  throw Error("ByteString should be constructed with non-empty values");
              }
              var Gs = typeof Uint8Array.prototype.slice == "function", To = 0, Na = 0;
              function nl(X, j) {
                if (X.constructor === Uint8Array)
                  return X;
                if (X.constructor === ArrayBuffer)
                  return new Uint8Array(X);
                if (X.constructor === Array)
                  return new Uint8Array(X);
                if (X.constructor === String)
                  return gc(X);
                if (X.constructor === $a)
                  return !j && (j = X.L) && j.constructor === Uint8Array ? j : (j = X.L, j = j == null || Nl(j) ? j : typeof j == "string" ? gc(j) : null, (X = X.L = j) ? new Uint8Array(X) : ta || (ta = new Uint8Array(0)));
                if (X instanceof Uint8Array)
                  return new Uint8Array(X.buffer, X.byteOffset, X.byteLength);
                throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
              }
              function vs(X, j) {
                return Error("Invalid wire type: " + X + " (at position " + j + ")");
              }
              function bo() {
                return Error("Failed to read varint, encoding is invalid.");
              }
              function fa(X, j) {
                j = j === void 0 ? {} : j, j = j.v === void 0 ? !1 : j.v, this.h = null, this.g = this.i = this.j = 0, this.v = j, X && ss(this, X);
              }
              function ss(X, j) {
                X.h = nl(j, X.v), X.j = 0, X.i = X.h.length, X.g = X.j;
              }
              fa.prototype.reset = function() {
                this.g = this.j;
              };
              function eo(X) {
                if (X.g > X.i)
                  throw Error("Tried to read past the end of the data " + X.g + " > " + X.i);
              }
              function Pa(X) {
                var j = X.h, Ae = j[X.g], C = Ae & 127;
                if (128 > Ae)
                  return X.g += 1, eo(X), C;
                if (Ae = j[X.g + 1], C |= (Ae & 127) << 7, 128 > Ae)
                  return X.g += 2, eo(X), C;
                if (Ae = j[X.g + 2], C |= (Ae & 127) << 14, 128 > Ae)
                  return X.g += 3, eo(X), C;
                if (Ae = j[X.g + 3], C |= (Ae & 127) << 21, 128 > Ae)
                  return X.g += 4, eo(X), C;
                if (Ae = j[X.g + 4], X.g += 5, C |= (Ae & 15) << 28, 128 > Ae)
                  return eo(X), C;
                if (128 <= j[X.g++] && 128 <= j[X.g++] && 128 <= j[X.g++] && 128 <= j[X.g++] && 128 <= j[X.g++])
                  throw bo();
                return eo(X), C;
              }
              var Ao = [];
              function ua() {
                this.g = [];
              }
              ua.prototype.length = function() {
                return this.g.length;
              }, ua.prototype.end = function() {
                var X = this.g;
                return this.g = [], X;
              };
              function ns(X, j) {
                for (; 127 < j; )
                  X.g.push(j & 127 | 128), j >>>= 7;
                X.g.push(j);
              }
              function Ls(X) {
                var j = {}, Ae = j.W === void 0 ? !1 : j.W;
                this.l = { v: j.v === void 0 ? !1 : j.v }, this.W = Ae, j = this.l, Ao.length ? (Ae = Ao.pop(), j && (Ae.v = j.v), X && ss(Ae, X), X = Ae) : X = new fa(X, j), this.g = X, this.j = this.g.g, this.h = this.i = -1;
              }
              Ls.prototype.reset = function() {
                this.g.reset(), this.j = this.g.g, this.h = this.i = -1;
              };
              function Ua(X) {
                var j = X.g;
                if (j.g == j.i)
                  return !1;
                X.j = X.g.g;
                var Ae = Pa(X.g) >>> 0;
                if (j = Ae >>> 3, Ae &= 7, !(0 <= Ae && 5 >= Ae))
                  throw vs(Ae, X.j);
                if (1 > j)
                  throw Error("Invalid field number: " + j + " (at position " + X.j + ")");
                return X.i = j, X.h = Ae, !0;
              }
              function go(X) {
                switch (X.h) {
                  case 0:
                    if (X.h != 0)
                      go(X);
                    else
                      e: {
                        X = X.g;
                        for (var j = X.g, Ae = j + 10; j < Ae; )
                          if (!(X.h[j++] & 128)) {
                            X.g = j, eo(X);
                            break e;
                          }
                        throw bo();
                      }
                    break;
                  case 1:
                    X = X.g, X.g += 8, eo(X);
                    break;
                  case 2:
                    X.h != 2 ? go(X) : (j = Pa(X.g) >>> 0, X = X.g, X.g += j, eo(X));
                    break;
                  case 5:
                    X = X.g, X.g += 4, eo(X);
                    break;
                  case 3:
                    j = X.i;
                    do {
                      if (!Ua(X))
                        throw Error("Unmatched start-group tag: stream EOF");
                      if (X.h == 4) {
                        if (X.i != j)
                          throw Error("Unmatched end-group tag");
                        break;
                      }
                      go(X);
                    } while (!0);
                    break;
                  default:
                    throw vs(X.h, X.j);
                }
              }
              var Bs = [];
              function Ts() {
                this.i = [], this.h = 0, this.g = new ua();
              }
              function Oa(X, j) {
                j.length !== 0 && (X.i.push(j), X.h += j.length);
              }
              function Jl(X, j) {
                if (j = j.ba) {
                  Oa(X, X.g.end());
                  for (var Ae = 0; Ae < j.length; Ae++)
                    Oa(X, j[Ae]);
                }
              }
              var rl = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
              function Xs(X, j) {
                Object.isFrozen(X) || (rl ? X[rl] |= j : X.N !== void 0 ? X.N |= j : Object.defineProperties(X, { N: { value: j, configurable: !0, writable: !0, enumerable: !1 } }));
              }
              function il(X) {
                var j;
                return rl ? j = X[rl] : j = X.N, j == null ? 0 : j;
              }
              function pa(X) {
                return Xs(X, 1), X;
              }
              function rs(X) {
                return Array.isArray(X) ? !!(il(X) & 2) : !1;
              }
              function ma(X) {
                if (!Array.isArray(X))
                  throw Error("cannot mark non-array as immutable");
                Xs(X, 2);
              }
              function Xo(X) {
                return X !== null && typeof X == "object" && !Array.isArray(X) && X.constructor === Object;
              }
              var ks = Object.freeze(pa([]));
              function Zo(X) {
                if (rs(X.m))
                  throw Error("Cannot mutate an immutable Message");
              }
              var fo = typeof Symbol < "u" && typeof Symbol.hasInstance < "u";
              function ul(X) {
                return { value: X, configurable: !1, writable: !1, enumerable: !1 };
              }
              function na(X, j, Ae) {
                return j === -1 ? null : j >= X.i ? X.g ? X.g[j] : void 0 : Ae !== void 0 && Ae && X.g && (Ae = X.g[j], Ae != null) ? Ae : X.m[j + X.h];
              }
              function Wi(X, j, Ae, C) {
                C = C === void 0 ? !1 : C, Zo(X), j < X.i && !C ? X.m[j + X.h] = Ae : (X.g || (X.g = X.m[X.i + X.h] = {}))[j] = Ae;
              }
              function li(X, j, Ae, C) {
                Ae = Ae === void 0 ? !0 : Ae, C = C === void 0 ? !1 : C;
                var x = na(X, j, C);
                return x == null && (x = ks), rs(X.m) ? Ae && (ma(x), Object.freeze(x)) : (x === ks || rs(x)) && (x = pa(x.slice()), Wi(X, j, x, C)), x;
              }
              function ko(X, j, Ae) {
                return X = na(X, j), X = X == null ? X : +X, X == null ? Ae === void 0 ? 0 : Ae : X;
              }
              function is(X, j, Ae, C) {
                X.j || (X.j = {});
                var x = rs(X.m), ee = X.j[Ae];
                if (!ee) {
                  C = li(X, Ae, !0, C === void 0 ? !1 : C), ee = [], x = x || rs(C);
                  for (var F = 0; F < C.length; F++)
                    ee[F] = new j(C[F]), x && ma(ee[F].m);
                  x && (ma(ee), Object.freeze(ee)), X.j[Ae] = ee;
                }
                return ee;
              }
              function So(X, j, Ae, C, x) {
                var ee = ee === void 0 ? !1 : ee;
                return Zo(X), ee = is(X, Ae, j, ee), Ae = C || new Ae(), X = li(X, j), x != null ? (ee.splice(x, 0, Ae), X.splice(x, 0, Ae.m)) : (ee.push(Ae), X.push(Ae.m)), Ae;
              }
              function wo(X, j) {
                return X = na(X, j), X == null ? 0 : X;
              }
              function wn(X, j) {
                return X = na(X, j), X == null ? "" : X;
              }
              function jn(X) {
                switch (typeof X) {
                  case "number":
                    return isFinite(X) ? X : String(X);
                  case "object":
                    if (X && !Array.isArray(X)) {
                      if (Nl(X))
                        return Nc(X);
                      if (X instanceof $a) {
                        var j = X.L;
                        return j = j == null || typeof j == "string" ? j : Pl && j instanceof Uint8Array ? Nc(j) : null, (X.L = j) || "";
                      }
                    }
                }
                return X;
              }
              function hr(X) {
                var j = Yo;
                return j = j === void 0 ? fi : j, Po(X, j);
              }
              function po(X, j) {
                if (X != null) {
                  if (Array.isArray(X))
                    X = Po(X, j);
                  else if (Xo(X)) {
                    var Ae = {}, C;
                    for (C in X)
                      Ae[C] = po(X[C], j);
                    X = Ae;
                  } else
                    X = j(X);
                  return X;
                }
              }
              function Po(X, j) {
                for (var Ae = X.slice(), C = 0; C < Ae.length; C++)
                  Ae[C] = po(Ae[C], j);
                return Array.isArray(X) && il(X) & 1 && pa(Ae), Ae;
              }
              function Yo(X) {
                return X && typeof X == "object" && X.toJSON ? X.toJSON() : (X = jn(X), Array.isArray(X) ? hr(X) : X);
              }
              function fi(X) {
                return Nl(X) ? new Uint8Array(X) : X;
              }
              function ra(X, j, Ae) {
                X || (X = ls), ls = null;
                var C = this.constructor.h;
                X || (X = C ? [C] : []), this.h = (C ? 0 : -1) - (this.constructor.g || 0), this.j = void 0, this.m = X;
                e: {
                  if (C = this.m.length, X = C - 1, C && (C = this.m[X], Xo(C))) {
                    this.i = X - this.h, this.g = C;
                    break e;
                  }
                  j !== void 0 && -1 < j ? (this.i = Math.max(j, X + 1 - this.h), this.g = void 0) : this.i = Number.MAX_VALUE;
                }
                if (Ae)
                  for (j = 0; j < Ae.length; j++)
                    if (X = Ae[j], X < this.i)
                      X += this.h, (C = this.m[X]) ? Array.isArray(C) && pa(C) : this.m[X] = ks;
                    else {
                      C = this.g || (this.g = this.m[this.i + this.h] = {});
                      var x = C[X];
                      x ? Array.isArray(x) && pa(x) : C[X] = ks;
                    }
              }
              ra.prototype.toJSON = function() {
                return hr(this.m);
              }, ra.prototype.toString = function() {
                return this.m.toString();
              };
              var ls;
              function xs() {
                ra.apply(this, arguments);
              }
              if (Nr(xs, ra), fo) {
                var Hs = {};
                Object.defineProperties(xs, (Hs[Symbol.hasInstance] = ul(function() {
                  throw Error("Cannot perform instanceof checks for MutableMessage");
                }), Hs));
              }
              function hl(X, j, Ae) {
                if (Ae) {
                  var C = {}, x;
                  for (x in Ae) {
                    var ee = Ae[x], F = ee.ha;
                    F || (C.F = ee.la || ee.fa.P, ee.aa ? (C.U = Ol(ee.aa), F = /* @__PURE__ */ function(M) {
                      return function(H, ce, ke) {
                        return M.F(H, ce, ke, M.U);
                      };
                    }(C)) : ee.ca ? (C.T = bs(ee.X.g, ee.ca), F = /* @__PURE__ */ function(M) {
                      return function(H, ce, ke) {
                        return M.F(H, ce, ke, M.T);
                      };
                    }(C)) : F = C.F, ee.ha = F), F(j, X, ee.X), C = { F: C.F, U: C.U, T: C.T };
                  }
                }
                Jl(j, X);
              }
              var bl = Symbol();
              function os(X, j, Ae) {
                return X[bl] || (X[bl] = function(C, x) {
                  return j(C, x, Ae);
                });
              }
              function Ps(X) {
                var j = X[bl];
                if (!j) {
                  var Ae = le(X);
                  j = function(C, x) {
                    return Ie(C, x, Ae);
                  }, X[bl] = j;
                }
                return j;
              }
              function dd(X) {
                var j = X.aa;
                if (j)
                  return Ps(j);
                if (j = X.ka)
                  return os(X.X.g, j, X.ca);
              }
              function Os(X) {
                var j = dd(X), Ae = X.X, C = X.fa.O;
                return j ? function(x, ee) {
                  return C(x, ee, Ae, j);
                } : function(x, ee) {
                  return C(x, ee, Ae);
                };
              }
              function cs(X, j, Ae, C, x, ee) {
                X = X();
                var F = 0;
                for (X.length && typeof X[0] != "number" && (Ae(j, X[0]), F++); F < X.length; ) {
                  Ae = X[F++];
                  for (var M = F + 1; M < X.length && typeof X[M] != "number"; )
                    M++;
                  var H = X[F++];
                  switch (M -= F, M) {
                    case 0:
                      C(j, Ae, H);
                      break;
                    case 1:
                      C(j, Ae, H, X[F++]);
                      break;
                    case 2:
                      x(j, Ae, H, X[F++], X[F++]);
                      break;
                    case 3:
                      M = X[F++];
                      var ce = X[F++], ke = X[F++];
                      Array.isArray(ke) ? x(j, Ae, H, M, ce, ke) : ee(j, Ae, H, M, ce, ke);
                      break;
                    case 4:
                      ee(j, Ae, H, X[F++], X[F++], X[F++], X[F++]);
                      break;
                    default:
                      throw Error("unexpected number of binary field arguments: " + M);
                  }
                }
                return j;
              }
              var Il = Symbol();
              function Ol(X) {
                var j = X[Il];
                if (!j) {
                  var Ae = ol(X);
                  j = function(C, x) {
                    return Mt(C, x, Ae);
                  }, X[Il] = j;
                }
                return j;
              }
              function bs(X, j) {
                var Ae = X[Il];
                return Ae || (Ae = function(C, x) {
                  return hl(C, x, j);
                }, X[Il] = Ae), Ae;
              }
              var Jc = Symbol();
              function Ks(X, j) {
                X.push(j);
              }
              function Bl(X, j, Ae) {
                X.push(j, Ae.P);
              }
              function nc(X, j, Ae, C, x) {
                var ee = Ol(x), F = Ae.P;
                X.push(j, function(M, H, ce) {
                  return F(M, H, ce, C, ee);
                });
              }
              function Oc(X, j, Ae, C, x, ee) {
                var F = bs(C, ee), M = Ae.P;
                X.push(j, function(H, ce, ke) {
                  return M(H, ce, ke, C, F);
                });
              }
              function ol(X) {
                var j = X[Jc];
                return j || cs(X, X[Jc] = [], Ks, Bl, nc, Oc);
              }
              var rc = Symbol();
              function Ld(X, j) {
                X[0] = j;
              }
              function xd(X, j, Ae, C) {
                var x = Ae.O;
                X[j] = C ? function(ee, F, M) {
                  return x(ee, F, M, C);
                } : x;
              }
              function ic(X, j, Ae, C, x, ee) {
                var F = Ae.O, M = Ps(x);
                X[j] = function(H, ce, ke) {
                  return F(H, ce, ke, C, M, ee);
                };
              }
              function fc(X, j, Ae, C, x, ee, F) {
                var M = Ae.O, H = os(C, x, ee);
                X[j] = function(ce, ke, st) {
                  return M(ce, ke, st, C, H, F);
                };
              }
              function le(X) {
                var j = X[rc];
                return j || cs(X, X[rc] = {}, Ld, xd, ic, fc);
              }
              function Ie(X, j, Ae) {
                for (; Ua(j) && j.h != 4; ) {
                  var C = j.i, x = Ae[C];
                  if (!x) {
                    var ee = Ae[0];
                    ee && (ee = ee[C]) && (x = Ae[C] = Os(ee));
                  }
                  if ((!x || !x(j, X, C)) && (x = j, C = X, ee = x.j, go(x), !x.W)) {
                    var F = x.g.h;
                    x = x.g.g, x = ee === x ? ta || (ta = new Uint8Array(0)) : Gs ? F.slice(ee, x) : new Uint8Array(F.subarray(ee, x)), (ee = C.ba) ? ee.push(x) : C.ba = [x];
                  }
                }
                return X;
              }
              function Ze(X, j, Ae) {
                if (Bs.length) {
                  var C = Bs.pop();
                  X && (ss(C.g, X), C.i = -1, C.h = -1), X = C;
                } else
                  X = new Ls(X);
                try {
                  return Ie(new j(), X, le(Ae));
                } finally {
                  j = X.g, j.h = null, j.j = 0, j.i = 0, j.g = 0, j.v = !1, X.i = -1, X.h = -1, 100 > Bs.length && Bs.push(X);
                }
              }
              function Mt(X, j, Ae) {
                for (var C = Ae.length, x = C % 2 == 1, ee = x ? 1 : 0; ee < C; ee += 2)
                  (0, Ae[ee + 1])(j, X, Ae[ee]);
                hl(X, j, x ? Ae[0] : void 0);
              }
              function yn(X, j) {
                var Ae = new Ts();
                Mt(X, Ae, ol(j)), Oa(Ae, Ae.g.end()), X = new Uint8Array(Ae.h), j = Ae.i;
                for (var C = j.length, x = 0, ee = 0; ee < C; ee++) {
                  var F = j[ee];
                  X.set(F, x), x += F.length;
                }
                return Ae.i = [X], X;
              }
              function nr(X, j) {
                return { O: X, P: j };
              }
              var mn = nr(function(X, j, Ae) {
                if (X.h !== 5)
                  return !1;
                X = X.g;
                var C = X.h[X.g], x = X.h[X.g + 1], ee = X.h[X.g + 2], F = X.h[X.g + 3];
                return X.g += 4, eo(X), x = (C << 0 | x << 8 | ee << 16 | F << 24) >>> 0, X = 2 * (x >> 31) + 1, C = x >>> 23 & 255, x &= 8388607, Wi(j, Ae, C == 255 ? x ? NaN : 1 / 0 * X : C == 0 ? X * Math.pow(2, -149) * x : X * Math.pow(2, C - 150) * (x + Math.pow(2, 23))), !0;
              }, function(X, j, Ae) {
                if (j = na(j, Ae), j != null) {
                  ns(X.g, 8 * Ae + 5), X = X.g;
                  var C = j;
                  C = (Ae = 0 > C ? 1 : 0) ? -C : C, C === 0 ? 0 < 1 / C ? To = Na = 0 : (Na = 0, To = 2147483648) : isNaN(C) ? (Na = 0, To = 2147483647) : 34028234663852886e22 < C ? (Na = 0, To = (Ae << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > C ? (C = Math.round(C / Math.pow(2, -149)), Na = 0, To = (Ae << 31 | C) >>> 0) : (j = Math.floor(Math.log(C) / Math.LN2), C *= Math.pow(2, -j), C = Math.round(8388608 * C), 16777216 <= C && ++j, Na = 0, To = (Ae << 31 | j + 127 << 23 | C & 8388607) >>> 0), Ae = To, X.g.push(Ae >>> 0 & 255), X.g.push(Ae >>> 8 & 255), X.g.push(Ae >>> 16 & 255), X.g.push(Ae >>> 24 & 255);
                }
              }), zn = nr(function(X, j, Ae) {
                if (X.h !== 0)
                  return !1;
                for (var C = X.g, x = 128, ee = 0, F = X = 0; 4 > F && 128 <= x; F++)
                  x = C.h[C.g++], eo(C), ee |= (x & 127) << 7 * F;
                if (128 <= x && (x = C.h[C.g++], eo(C), ee |= (x & 127) << 28, X |= (x & 127) >> 4), 128 <= x)
                  for (F = 0; 5 > F && 128 <= x; F++)
                    x = C.h[C.g++], eo(C), X |= (x & 127) << 7 * F + 3;
                if (128 > x)
                  C = ee >>> 0, x = X >>> 0, (X = x & 2147483648) && (C = ~C + 1 >>> 0, x = ~x >>> 0, C == 0 && (x = x + 1 >>> 0)), C = 4294967296 * x + (C >>> 0);
                else
                  throw bo();
                return Wi(j, Ae, X ? -C : C), !0;
              }, function(X, j, Ae) {
                if (j = na(j, Ae), j != null && j != null) {
                  ns(X.g, 8 * Ae), X = X.g;
                  var C = j;
                  for (Ae = 0 > C, C = Math.abs(C), j = C >>> 0, C = Math.floor((C - j) / 4294967296), C >>>= 0, Ae && (C = ~C >>> 0, j = (~j >>> 0) + 1, 4294967295 < j && (j = 0, C++, 4294967295 < C && (C = 0))), To = j, Na = C, Ae = To, j = Na; 0 < j || 127 < Ae; )
                    X.g.push(Ae & 127 | 128), Ae = (Ae >>> 7 | j << 25) >>> 0, j >>>= 7;
                  X.g.push(Ae);
                }
              }), Wr = nr(function(X, j, Ae) {
                return X.h !== 0 ? !1 : (Wi(j, Ae, Pa(X.g)), !0);
              }, function(X, j, Ae) {
                if (j = na(j, Ae), j != null && j != null)
                  if (ns(X.g, 8 * Ae), X = X.g, Ae = j, 0 <= Ae)
                    ns(X, Ae);
                  else {
                    for (j = 0; 9 > j; j++)
                      X.g.push(Ae & 127 | 128), Ae >>= 7;
                    X.g.push(1);
                  }
              }), ci = nr(function(X, j, Ae) {
                if (X.h !== 2)
                  return !1;
                var C = Pa(X.g) >>> 0;
                X = X.g;
                var x = X.g;
                X.g += C, eo(X), X = X.h;
                var ee;
                if (Ac)
                  (ee = Wl) || (ee = Wl = new TextDecoder("utf-8", { fatal: !0 })), ee = ee.decode(X.subarray(x, x + C));
                else {
                  C = x + C;
                  for (var F = [], M = null, H, ce, ke; x < C; )
                    H = X[x++], 128 > H ? F.push(H) : 224 > H ? x >= C ? ts() : (ce = X[x++], 194 > H || (ce & 192) !== 128 ? (x--, ts()) : F.push((H & 31) << 6 | ce & 63)) : 240 > H ? x >= C - 1 ? ts() : (ce = X[x++], (ce & 192) !== 128 || H === 224 && 160 > ce || H === 237 && 160 <= ce || ((ee = X[x++]) & 192) !== 128 ? (x--, ts()) : F.push((H & 15) << 12 | (ce & 63) << 6 | ee & 63)) : 244 >= H ? x >= C - 2 ? ts() : (ce = X[x++], (ce & 192) !== 128 || (H << 28) + (ce - 144) >> 30 || ((ee = X[x++]) & 192) !== 128 || ((ke = X[x++]) & 192) !== 128 ? (x--, ts()) : (H = (H & 7) << 18 | (ce & 63) << 12 | (ee & 63) << 6 | ke & 63, H -= 65536, F.push((H >> 10 & 1023) + 55296, (H & 1023) + 56320))) : ts(), 8192 <= F.length && (M = tl(M, F), F.length = 0);
                  ee = tl(M, F);
                }
                return Wi(j, Ae, ee), !0;
              }, function(X, j, Ae) {
                if (j = na(j, Ae), j != null) {
                  var C = !1;
                  if (C = C === void 0 ? !1 : C, Uc) {
                    if (C && /(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])/.test(j))
                      throw Error("Found an unpaired surrogate");
                    j = (Hl || (Hl = new TextEncoder())).encode(j);
                  } else {
                    for (var x = 0, ee = new Uint8Array(3 * j.length), F = 0; F < j.length; F++) {
                      var M = j.charCodeAt(F);
                      if (128 > M)
                        ee[x++] = M;
                      else {
                        if (2048 > M)
                          ee[x++] = M >> 6 | 192;
                        else {
                          if (55296 <= M && 57343 >= M) {
                            if (56319 >= M && F < j.length) {
                              var H = j.charCodeAt(++F);
                              if (56320 <= H && 57343 >= H) {
                                M = 1024 * (M - 55296) + H - 56320 + 65536, ee[x++] = M >> 18 | 240, ee[x++] = M >> 12 & 63 | 128, ee[x++] = M >> 6 & 63 | 128, ee[x++] = M & 63 | 128;
                                continue;
                              } else
                                F--;
                            }
                            if (C)
                              throw Error("Found an unpaired surrogate");
                            M = 65533;
                          }
                          ee[x++] = M >> 12 | 224, ee[x++] = M >> 6 & 63 | 128;
                        }
                        ee[x++] = M & 63 | 128;
                      }
                    }
                    j = ee.subarray(0, x);
                  }
                  ns(X.g, 8 * Ae + 2), ns(X.g, j.length), Oa(X, X.g.end()), Oa(X, j);
                }
              }), Ki = nr(function(X, j, Ae, C, x) {
                if (X.h !== 2)
                  return !1;
                j = So(j, Ae, C), Ae = X.g.i, C = Pa(X.g) >>> 0;
                var ee = X.g.g + C, F = ee - Ae;
                if (0 >= F && (X.g.i = ee, x(j, X), F = ee - X.g.g), F)
                  throw Error("Message parsing ended unexpectedly. Expected to read " + (C + " bytes, instead read " + (C - F) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                return X.g.g = ee, X.g.i = Ae, !0;
              }, function(X, j, Ae, C, x) {
                if (j = is(j, C, Ae), j != null)
                  for (C = 0; C < j.length; C++) {
                    var ee = X;
                    ns(ee.g, 8 * Ae + 2);
                    var F = ee.g.end();
                    Oa(ee, F), F.push(ee.h), ee = F, x(j[C], X), F = X;
                    var M = ee.pop();
                    for (M = F.h + F.g.length() - M; 127 < M; )
                      ee.push(M & 127 | 128), M >>>= 7, F.h++;
                    ee.push(M), F.h++;
                  }
              });
              function Gi() {
                xs.apply(this, arguments);
              }
              if (Nr(Gi, xs), fo) {
                var yo = {};
                Object.defineProperties(Gi, (yo[Symbol.hasInstance] = ul(Object[Symbol.hasInstance]), yo));
              }
              function Xi(X) {
                Gi.call(this, X);
              }
              Nr(Xi, Gi);
              function vi() {
                return [1, Wr, 2, mn, 3, ci, 4, ci];
              }
              function Yi(X) {
                Gi.call(this, X, -1, Lo);
              }
              Nr(Yi, Gi), Yi.prototype.addClassification = function(X, j) {
                return So(this, 1, Xi, X, j), this;
              };
              function Fo() {
                return [1, Ki, Xi, vi];
              }
              var Lo = [1];
              function ia(X) {
                Gi.call(this, X);
              }
              Nr(ia, Gi);
              function ha() {
                return [1, mn, 2, mn, 3, mn, 4, mn, 5, mn];
              }
              function ds(X) {
                Gi.call(this, X, -1, he);
              }
              Nr(ds, Gi);
              function q() {
                return [1, Ki, ia, ha];
              }
              var he = [1];
              function ve(X) {
                Gi.call(this, X);
              }
              Nr(ve, Gi);
              function bt() {
                return [1, mn, 2, mn, 3, mn, 4, mn, 5, mn, 6, zn];
              }
              var Ot = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], In = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
                386,
                385
              ], [385, 384], [384, 398], [398, 362]], en = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], Gn = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], dr = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], D = [
                [10, 338],
                [338, 297],
                [297, 332],
                [332, 284],
                [284, 251],
                [251, 389],
                [389, 356],
                [356, 454],
                [454, 323],
                [323, 361],
                [361, 288],
                [288, 397],
                [397, 365],
                [365, 379],
                [379, 378],
                [378, 400],
                [400, 377],
                [377, 152],
                [152, 148],
                [148, 176],
                [176, 149],
                [149, 150],
                [150, 136],
                [136, 172],
                [172, 58],
                [58, 132],
                [132, 93],
                [93, 234],
                [234, 127],
                [127, 162],
                [162, 21],
                [21, 54],
                [54, 103],
                [103, 67],
                [67, 109],
                [109, 10]
              ], Fe = [].concat(Nt(Ot), Nt(In), Nt(en), Nt(Gn), Nt(dr), Nt(D));
              function Se(X, j, Ae) {
                if (Ae = X.createShader(Ae === 0 ? X.VERTEX_SHADER : X.FRAGMENT_SHADER), X.shaderSource(Ae, j), X.compileShader(Ae), !X.getShaderParameter(Ae, X.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + X.getShaderInfoLog(Ae));
                return Ae;
              }
              function it(X) {
                return is(X, Xi, 1).map(function(j) {
                  return { index: wo(j, 1), ga: ko(j, 2), label: na(j, 3) != null ? wn(j, 3) : void 0, displayName: na(j, 4) != null ? wn(j, 4) : void 0 };
                });
              }
              function Gt(X) {
                return { x: ko(X, 1), y: ko(X, 2), z: ko(X, 3), visibility: na(X, 4) != null ? ko(X, 4) : void 0 };
              }
              function nn(X, j) {
                this.h = X, this.g = j, this.l = 0;
              }
              function Pt(X, j, Ae) {
                return Mn(X, j), typeof X.g.canvas.transferToImageBitmap == "function" ? n.resolve(X.g.canvas.transferToImageBitmap()) : Ae ? n.resolve(X.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(X.g.canvas) : (X.i === void 0 && (X.i = document.createElement("canvas")), new n(function(C) {
                  X.i.height = X.g.canvas.height, X.i.width = X.g.canvas.width, X.i.getContext("2d", {}).drawImage(X.g.canvas, 0, 0, X.g.canvas.width, X.g.canvas.height), C(X.i);
                }));
              }
              function Mn(X, j) {
                var Ae = X.g;
                if (X.o === void 0) {
                  var C = Se(Ae, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), x = Se(Ae, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), ee = Ae.createProgram();
                  if (Ae.attachShader(ee, C), Ae.attachShader(ee, x), Ae.linkProgram(ee), !Ae.getProgramParameter(ee, Ae.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + Ae.getProgramInfoLog(ee));
                  C = X.o = ee, Ae.useProgram(C), x = Ae.getUniformLocation(C, "sampler0"), X.j = { K: Ae.getAttribLocation(C, "aVertex"), J: Ae.getAttribLocation(C, "aTex"), ma: x }, X.u = Ae.createBuffer(), Ae.bindBuffer(Ae.ARRAY_BUFFER, X.u), Ae.enableVertexAttribArray(X.j.K), Ae.vertexAttribPointer(X.j.K, 2, Ae.FLOAT, !1, 0, 0), Ae.bufferData(Ae.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), Ae.STATIC_DRAW), Ae.bindBuffer(Ae.ARRAY_BUFFER, null), X.s = Ae.createBuffer(), Ae.bindBuffer(Ae.ARRAY_BUFFER, X.s), Ae.enableVertexAttribArray(X.j.J), Ae.vertexAttribPointer(
                    X.j.J,
                    2,
                    Ae.FLOAT,
                    !1,
                    0,
                    0
                  ), Ae.bufferData(Ae.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), Ae.STATIC_DRAW), Ae.bindBuffer(Ae.ARRAY_BUFFER, null), Ae.uniform1i(x, 0);
                }
                C = X.j, Ae.useProgram(X.o), Ae.canvas.width = j.width, Ae.canvas.height = j.height, Ae.viewport(0, 0, j.width, j.height), Ae.activeTexture(Ae.TEXTURE0), X.h.bindTexture2d(j.glName), Ae.enableVertexAttribArray(C.K), Ae.bindBuffer(Ae.ARRAY_BUFFER, X.u), Ae.vertexAttribPointer(C.K, 2, Ae.FLOAT, !1, 0, 0), Ae.enableVertexAttribArray(C.J), Ae.bindBuffer(Ae.ARRAY_BUFFER, X.s), Ae.vertexAttribPointer(
                  C.J,
                  2,
                  Ae.FLOAT,
                  !1,
                  0,
                  0
                ), Ae.bindFramebuffer(Ae.DRAW_FRAMEBUFFER ? Ae.DRAW_FRAMEBUFFER : Ae.FRAMEBUFFER, null), Ae.clearColor(0, 0, 0, 0), Ae.clear(Ae.COLOR_BUFFER_BIT), Ae.colorMask(!0, !0, !0, !0), Ae.drawArrays(Ae.TRIANGLE_FAN, 0, 4), Ae.disableVertexAttribArray(C.K), Ae.disableVertexAttribArray(C.J), Ae.bindBuffer(Ae.ARRAY_BUFFER, null), X.h.bindTexture2d(0);
              }
              function Nn(X) {
                this.g = X;
              }
              var Xr = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function ei(X, j) {
                return j + X;
              }
              function ji(X, j) {
                window[X] = j;
              }
              function di(X) {
                var j = document.createElement("script");
                return j.setAttribute("src", X), j.setAttribute("crossorigin", "anonymous"), new n(function(Ae) {
                  j.addEventListener("load", function() {
                    Ae();
                  }, !1), j.addEventListener("error", function() {
                    Ae();
                  }, !1), document.body.appendChild(j);
                });
              }
              function Cr() {
                return Mr(function(X) {
                  switch (X.g) {
                    case 1:
                      return X.o = 2, Un(X, WebAssembly.instantiate(Xr), 4);
                    case 4:
                      X.g = 3, X.o = 0;
                      break;
                    case 2:
                      return X.o = 0, X.j = null, X.return(!1);
                    case 3:
                      return X.return(!0);
                  }
                });
              }
              function ni(X) {
                if (this.g = X, this.listeners = {}, this.j = {}, this.H = {}, this.o = {}, this.u = {}, this.I = this.s = this.Z = !0, this.D = n.resolve(), this.Y = "", this.C = {}, this.locateFile = X && X.locateFile || ei, typeof window == "object")
                  var j = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  j = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.$ = j, X.options) {
                  j = rt(Object.keys(X.options));
                  for (var Ae = j.next(); !Ae.done; Ae = j.next()) {
                    Ae = Ae.value;
                    var C = X.options[Ae].default;
                    C !== void 0 && (this.j[Ae] = typeof C == "function" ? C() : C);
                  }
                }
              }
              E = ni.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function Ai(X) {
                var j, Ae, C, x, ee, F, M, H, ce, ke, st;
                return Mr(function(mt) {
                  switch (mt.g) {
                    case 1:
                      return X.Z ? (j = X.g.files === void 0 ? [] : typeof X.g.files == "function" ? X.g.files(X.j) : X.g.files, Un(mt, Cr(), 2)) : mt.return();
                    case 2:
                      if (Ae = mt.h, typeof window == "object")
                        return ji("createMediapipeSolutionsWasm", { locateFile: X.locateFile }), ji("createMediapipeSolutionsPackedAssets", { locateFile: X.locateFile }), F = j.filter(function(xt) {
                          return xt.data !== void 0;
                        }), M = j.filter(function(xt) {
                          return xt.data === void 0;
                        }), H = n.all(F.map(function(xt) {
                          var dn = Y(X, xt.url);
                          if (xt.path !== void 0) {
                            var Bn = xt.path;
                            dn = dn.then(function(Zn) {
                              return X.overrideFile(Bn, Zn), n.resolve(Zn);
                            });
                          }
                          return dn;
                        })), ce = n.all(M.map(function(xt) {
                          return xt.simd === void 0 || xt.simd && Ae || !xt.simd && !Ae ? di(X.locateFile(xt.url, X.$)) : n.resolve();
                        })).then(function() {
                          var xt, dn, Bn;
                          return Mr(function(Zn) {
                            if (Zn.g == 1)
                              return xt = window.createMediapipeSolutionsWasm, dn = window.createMediapipeSolutionsPackedAssets, Bn = X, Un(Zn, xt(dn), 2);
                            Bn.h = Zn.h, Zn.g = 0;
                          });
                        }), ke = function() {
                          return Mr(function(xt) {
                            return X.g.graph && X.g.graph.url ? xt = Un(
                              xt,
                              Y(X, X.g.graph.url),
                              0
                            ) : (xt.g = 0, xt = void 0), xt;
                          });
                        }(), Un(mt, n.all([ce, H, ke]), 7);
                      if (typeof importScripts != "function")
                        throw Error("solutions can only be loaded on a web page or in a web worker");
                      return C = j.filter(function(xt) {
                        return xt.simd === void 0 || xt.simd && Ae || !xt.simd && !Ae;
                      }).map(function(xt) {
                        return X.locateFile(xt.url, X.$);
                      }), importScripts.apply(null, Nt(C)), x = X, Un(mt, createMediapipeSolutionsWasm(Module), 6);
                    case 6:
                      x.h = mt.h, X.l = new OffscreenCanvas(1, 1), X.h.canvas = X.l, ee = X.h.GL.createContext(X.l, {
                        antialias: !1,
                        alpha: !1,
                        ja: typeof WebGL2RenderingContext < "u" ? 2 : 1
                      }), X.h.GL.makeContextCurrent(ee), mt.g = 4;
                      break;
                    case 7:
                      if (X.l = document.createElement("canvas"), st = X.l.getContext("webgl2", {}), !st && (st = X.l.getContext("webgl", {}), !st))
                        return alert("Failed to create WebGL canvas context when passing video frame."), mt.return();
                      X.G = st, X.h.canvas = X.l, X.h.createContext(X.l, !0, !0, {});
                    case 4:
                      X.i = new X.h.SolutionWasm(), X.Z = !1, mt.g = 0;
                  }
                });
              }
              function Ri(X) {
                var j, Ae, C, x, ee, F, M, H;
                return Mr(function(ce) {
                  if (ce.g == 1) {
                    if (X.g.graph && X.g.graph.url && X.Y === X.g.graph.url)
                      return ce.return();
                    if (X.s = !0, !X.g.graph || !X.g.graph.url) {
                      ce.g = 2;
                      return;
                    }
                    return X.Y = X.g.graph.url, Un(ce, Y(X, X.g.graph.url), 3);
                  }
                  for (ce.g != 2 && (j = ce.h, X.i.loadGraph(j)), Ae = rt(Object.keys(X.C)), C = Ae.next(); !C.done; C = Ae.next())
                    x = C.value, X.i.overrideFile(x, X.C[x]);
                  if (X.C = {}, X.g.listeners)
                    for (ee = rt(X.g.listeners), F = ee.next(); !F.done; F = ee.next())
                      M = F.value, je(X, M);
                  H = X.j, X.j = {}, X.setOptions(H), ce.g = 0;
                });
              }
              E.reset = function() {
                var X = this;
                return Mr(function(j) {
                  X.i && (X.i.reset(), X.o = {}, X.u = {}), j.g = 0;
                });
              }, E.setOptions = function(X, j) {
                var Ae = this;
                if (j = j || this.g.options) {
                  for (var C = [], x = [], ee = {}, F = rt(Object.keys(X)), M = F.next(); !M.done; ee = { R: ee.R, S: ee.S }, M = F.next()) {
                    var H = M.value;
                    H in this.j && this.j[H] === X[H] || (this.j[H] = X[H], M = j[H], M !== void 0 && (M.onChange && (ee.R = M.onChange, ee.S = X[H], C.push(/* @__PURE__ */ function(ce) {
                      return function() {
                        var ke;
                        return Mr(function(st) {
                          if (st.g == 1)
                            return Un(st, ce.R(ce.S), 2);
                          ke = st.h, ke === !0 && (Ae.s = !0), st.g = 0;
                        });
                      };
                    }(ee))), M.graphOptionXref && (H = { valueNumber: M.type === 1 ? X[H] : 0, valueBoolean: M.type === 0 ? X[H] : !1, valueString: M.type === 2 ? X[H] : "" }, M = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), M.graphOptionXref), H), x.push(M))));
                  }
                  (C.length !== 0 || x.length !== 0) && (this.s = !0, this.B = (this.B === void 0 ? [] : this.B).concat(x), this.A = (this.A === void 0 ? [] : this.A).concat(C));
                }
              };
              function Ii(X) {
                var j, Ae, C, x, ee, F, M;
                return Mr(function(H) {
                  switch (H.g) {
                    case 1:
                      if (!X.s)
                        return H.return();
                      if (!X.A) {
                        H.g = 2;
                        break;
                      }
                      j = rt(X.A), Ae = j.next();
                    case 3:
                      if (Ae.done) {
                        H.g = 5;
                        break;
                      }
                      return C = Ae.value, Un(H, C(), 4);
                    case 4:
                      Ae = j.next(), H.g = 3;
                      break;
                    case 5:
                      X.A = void 0;
                    case 2:
                      if (X.B) {
                        for (x = new X.h.GraphOptionChangeRequestList(), ee = rt(X.B), F = ee.next(); !F.done; F = ee.next())
                          M = F.value, x.push_back(M);
                        X.i.changeOptions(x), x.delete(), X.B = void 0;
                      }
                      X.s = !1, H.g = 0;
                  }
                });
              }
              E.initialize = function() {
                var X = this;
                return Mr(function(j) {
                  return j.g == 1 ? Un(j, Ai(X), 2) : j.g != 3 ? Un(j, Ri(X), 3) : Un(j, Ii(X), 0);
                });
              };
              function Y(X, j) {
                var Ae, C;
                return Mr(function(x) {
                  return j in X.H ? x.return(X.H[j]) : (Ae = X.locateFile(j, ""), C = fetch(Ae).then(function(ee) {
                    return ee.arrayBuffer();
                  }), X.H[j] = C, x.return(C));
                });
              }
              E.overrideFile = function(X, j) {
                this.i ? this.i.overrideFile(X, j) : this.C[X] = j;
              }, E.clearOverriddenFiles = function() {
                this.C = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(X, j) {
                var Ae = this, C, x, ee, F, M, H, ce, ke, st;
                return Mr(function(mt) {
                  switch (mt.g) {
                    case 1:
                      return Ae.g.inputs ? (C = 1e3 * (j == null ? performance.now() : j), Un(mt, Ae.D, 2)) : mt.return();
                    case 2:
                      return Un(mt, Ae.initialize(), 3);
                    case 3:
                      for (x = new Ae.h.PacketDataList(), ee = rt(Object.keys(X)), F = ee.next(); !F.done; F = ee.next())
                        if (M = F.value, H = Ae.g.inputs[M]) {
                          e: {
                            var xt = X[M];
                            switch (H.type) {
                              case "video":
                                var dn = Ae.o[H.stream];
                                if (dn || (dn = new nn(Ae.h, Ae.G), Ae.o[H.stream] = dn), dn.l === 0 && (dn.l = dn.h.createTexture()), typeof HTMLVideoElement < "u" && xt instanceof HTMLVideoElement)
                                  var Bn = xt.videoWidth, Zn = xt.videoHeight;
                                else
                                  typeof HTMLImageElement < "u" && xt instanceof HTMLImageElement ? (Bn = xt.naturalWidth, Zn = xt.naturalHeight) : (Bn = xt.width, Zn = xt.height);
                                Zn = { glName: dn.l, width: Bn, height: Zn }, Bn = dn.g, Bn.canvas.width = Zn.width, Bn.canvas.height = Zn.height, Bn.activeTexture(Bn.TEXTURE0), dn.h.bindTexture2d(dn.l), Bn.texImage2D(Bn.TEXTURE_2D, 0, Bn.RGBA, Bn.RGBA, Bn.UNSIGNED_BYTE, xt), dn.h.bindTexture2d(0), dn = Zn;
                                break e;
                              case "detections":
                                for (dn = Ae.o[H.stream], dn || (dn = new Nn(Ae.h), Ae.o[H.stream] = dn), dn.data || (dn.data = new dn.g.DetectionListData()), dn.data.reset(xt.length), Zn = 0; Zn < xt.length; ++Zn) {
                                  Bn = xt[Zn];
                                  var ir = dn.data, Ur = ir.setBoundingBox, Zr = Zn, Pr = Bn.boundingBox, xr = new ve();
                                  if (Wi(xr, 1, Pr.xCenter), Wi(xr, 2, Pr.yCenter), Wi(xr, 3, Pr.height), Wi(xr, 4, Pr.width), Wi(xr, 5, Pr.rotation), Wi(xr, 6, Pr.rectId), Pr = yn(xr, bt), Ur.call(ir, Zr, Pr), Bn.landmarks)
                                    for (ir = 0; ir < Bn.landmarks.length; ++ir) {
                                      xr = Bn.landmarks[ir];
                                      var oo = !!xr.visibility;
                                      Ur = dn.data, Zr = Ur.addNormalizedLandmark, Pr = Zn, xr = Object.assign(Object.assign({}, xr), { visibility: oo ? xr.visibility : 0 }), oo = new ia(), Wi(
                                        oo,
                                        1,
                                        xr.x
                                      ), Wi(oo, 2, xr.y), Wi(oo, 3, xr.z), xr.visibility && Wi(oo, 4, xr.visibility), xr = yn(oo, ha), Zr.call(Ur, Pr, xr);
                                    }
                                  if (Bn.V)
                                    for (ir = 0; ir < Bn.V.length; ++ir)
                                      Ur = dn.data, Zr = Ur.addClassification, Pr = Zn, xr = Bn.V[ir], oo = new Xi(), Wi(oo, 2, xr.ga), xr.index && Wi(oo, 1, xr.index), xr.label && Wi(oo, 3, xr.label), xr.displayName && Wi(oo, 4, xr.displayName), xr = yn(oo, vi), Zr.call(Ur, Pr, xr);
                                }
                                dn = dn.data;
                                break e;
                              default:
                                dn = {};
                            }
                          }
                          switch (ce = dn, ke = H.stream, H.type) {
                            case "video":
                              x.pushTexture2d(Object.assign(Object.assign({}, ce), { stream: ke, timestamp: C }));
                              break;
                            case "detections":
                              st = ce, st.stream = ke, st.timestamp = C, x.pushDetectionList(st);
                              break;
                            default:
                              throw Error("Unknown input config type: '" + H.type + "'");
                          }
                        }
                      return Ae.i.send(x), Un(mt, Ae.D, 4);
                    case 4:
                      x.delete(), mt.g = 0;
                  }
                });
              };
              function me(X, j, Ae) {
                var C, x, ee, F, M, H, ce, ke, st, mt, xt, dn, Bn, Zn;
                return Mr(function(ir) {
                  switch (ir.g) {
                    case 1:
                      if (!Ae)
                        return ir.return(j);
                      for (C = {}, x = 0, ee = rt(Object.keys(Ae)), F = ee.next(); !F.done; F = ee.next())
                        M = F.value, H = Ae[M], typeof H != "string" && H.type === "texture" && j[H.stream] !== void 0 && ++x;
                      1 < x && (X.I = !1), ce = rt(Object.keys(Ae)), F = ce.next();
                    case 2:
                      if (F.done) {
                        ir.g = 4;
                        break;
                      }
                      if (ke = F.value, st = Ae[ke], typeof st == "string")
                        return Bn = C, Zn = ke, Un(ir, Ee(X, ke, j[st]), 14);
                      if (mt = j[st.stream], st.type === "detection_list") {
                        if (mt) {
                          for (var Ur = mt.getRectList(), Zr = mt.getLandmarksList(), Pr = mt.getClassificationsList(), xr = [], oo = 0; oo < Ur.size(); ++oo) {
                            var Do = Ze(Ur.get(oo), ve, bt);
                            Do = { boundingBox: { xCenter: ko(Do, 1), yCenter: ko(Do, 2), height: ko(Do, 3), width: ko(Do, 4), rotation: ko(Do, 5, 0), rectId: wo(Do, 6) }, landmarks: is(Ze(Zr.get(oo), ds, q), ia, 1).map(Gt), V: it(Ze(Pr.get(oo), Yi, Fo)) }, xr.push(Do);
                          }
                          Ur = xr;
                        } else
                          Ur = [];
                        C[ke] = Ur, ir.g = 7;
                        break;
                      }
                      if (st.type === "proto_list") {
                        if (mt) {
                          for (Ur = Array(mt.size()), Zr = 0; Zr < mt.size(); Zr++)
                            Ur[Zr] = mt.get(Zr);
                          mt.delete();
                        } else
                          Ur = [];
                        C[ke] = Ur, ir.g = 7;
                        break;
                      }
                      if (mt === void 0) {
                        ir.g = 3;
                        break;
                      }
                      if (st.type === "float_list") {
                        C[ke] = mt, ir.g = 7;
                        break;
                      }
                      if (st.type === "proto") {
                        C[ke] = mt, ir.g = 7;
                        break;
                      }
                      if (st.type !== "texture")
                        throw Error("Unknown output config type: '" + st.type + "'");
                      return xt = X.u[ke], xt || (xt = new nn(X.h, X.G), X.u[ke] = xt), Un(ir, Pt(xt, mt, X.I), 13);
                    case 13:
                      dn = ir.h, C[ke] = dn;
                    case 7:
                      st.transform && C[ke] && (C[ke] = st.transform(C[ke])), ir.g = 3;
                      break;
                    case 14:
                      Bn[Zn] = ir.h;
                    case 3:
                      F = ce.next(), ir.g = 2;
                      break;
                    case 4:
                      return ir.return(C);
                  }
                });
              }
              function Ee(X, j, Ae) {
                var C;
                return Mr(function(x) {
                  return typeof Ae == "number" || Ae instanceof Uint8Array || Ae instanceof X.h.Uint8BlobList ? x.return(Ae) : Ae instanceof X.h.Texture2dDataOut ? (C = X.u[j], C || (C = new nn(X.h, X.G), X.u[j] = C), x.return(Pt(C, Ae, X.I))) : x.return(void 0);
                });
              }
              function je(X, j) {
                for (var Ae = j.name || "$", C = [].concat(Nt(j.wants)), x = new X.h.StringList(), ee = rt(j.wants), F = ee.next(); !F.done; F = ee.next())
                  x.push_back(F.value);
                ee = X.h.PacketListener.implement({ onResults: function(M) {
                  for (var H = {}, ce = 0; ce < j.wants.length; ++ce)
                    H[C[ce]] = M.get(ce);
                  var ke = X.listeners[Ae];
                  ke && (X.D = me(X, H, j.outs).then(function(st) {
                    st = ke(st);
                    for (var mt = 0; mt < j.wants.length; ++mt) {
                      var xt = H[C[mt]];
                      typeof xt == "object" && xt.hasOwnProperty && xt.hasOwnProperty("delete") && xt.delete();
                    }
                    st && (X.D = st);
                  }));
                } }), X.i.attachMultiListener(x, ee), x.delete();
              }
              E.onResults = function(X, j) {
                this.listeners[j || "$"] = X;
              }, Ji("Solution", ni), Ji("OptionType", { BOOL: 0, NUMBER: 1, ia: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function Tt(X) {
                var j = this;
                X = X || {};
                var Ae = { url: "face_detection_short.binarypb" }, C = { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } };
                this.g = new ni({
                  locateFile: X.locateFile,
                  files: [{ data: !0, url: "face_detection_short.binarypb" }, { data: !0, url: "face_detection_short_range.tflite" }, { simd: !0, url: "face_detection_solution_simd_wasm_bin.js" }, { simd: !1, url: "face_detection_solution_wasm_bin.js" }],
                  graph: Ae,
                  listeners: [{ wants: ["detections", "image_transformed"], outs: { image: "image_transformed", detections: { type: "detection_list", stream: "detections" } } }],
                  inputs: { image: { type: "video", stream: "input_frames_gpu" } },
                  options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: typeof window != "object" || window.navigator === void 0 ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, model: { type: 0, onChange: function(x) {
                    var ee, F, M, H, ce, ke;
                    return Mr(function(st) {
                      switch (st.g) {
                        case 1:
                          ee = x === "short" ? ["face_detection_short_range.tflite"] : ["face_detection_full_range_sparse.tflite"], F = rt(ee), M = F.next();
                        case 2:
                          if (M.done) {
                            st.g = 4;
                            break;
                          }
                          return H = M.value, ce = "third_party/mediapipe/modules/face_detection/" + H, Un(st, Y(j.g, H), 5);
                        case 5:
                          ke = st.h, j.g.overrideFile(ce, ke), M = F.next(), st.g = 2;
                          break;
                        case 4:
                          return Ae.url = x === "short" ? "face_detection_short.binarypb" : "face_detection_full.binarypb", C.graphOptionXref.calculatorName = x === "short" ? "facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator" : "facedetectionfullrangegpu__facedetectionfullrangecommon__TensorsToDetectionsCalculator", st.return(!0);
                      }
                    });
                  } }, minDetectionConfidence: C }
                });
              }
              E = Tt.prototype, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(X) {
                this.g.onResults(X);
              }, E.initialize = function() {
                var X = this;
                return Mr(function(j) {
                  return Un(j, X.g.initialize(), 0);
                });
              }, E.reset = function() {
                this.g.reset();
              }, E.send = function(X) {
                var j = this;
                return Mr(function(Ae) {
                  return Un(Ae, j.g.send(X), 0);
                });
              }, E.setOptions = function(X) {
                this.g.setOptions(X);
              }, Ji("FaceDetection", Tt), Ji("FACEDETECTION_LIPS", Ot), Ji("FACEDETECTION_LEFT_EYE", In), Ji("FACEDETECTION_LEFT_EYEBROW", en), Ji("FACEDETECTION_RIGHT_EYE", Gn), Ji("FACEDETECTION_RIGHT_EYEBROW", dr), Ji("FACEDETECTION_FACE_OVAL", D), Ji("FACEDETECTION_CONTOURS", Fe), Ji("FACEDETECTION_TESSELATION", [
                [127, 34],
                [34, 139],
                [139, 127],
                [11, 0],
                [0, 37],
                [37, 11],
                [232, 231],
                [231, 120],
                [120, 232],
                [72, 37],
                [37, 39],
                [39, 72],
                [128, 121],
                [121, 47],
                [47, 128],
                [232, 121],
                [121, 128],
                [128, 232],
                [104, 69],
                [69, 67],
                [67, 104],
                [175, 171],
                [171, 148],
                [148, 175],
                [118, 50],
                [50, 101],
                [101, 118],
                [73, 39],
                [39, 40],
                [40, 73],
                [9, 151],
                [151, 108],
                [108, 9],
                [48, 115],
                [115, 131],
                [131, 48],
                [194, 204],
                [204, 211],
                [211, 194],
                [74, 40],
                [40, 185],
                [185, 74],
                [80, 42],
                [42, 183],
                [183, 80],
                [40, 92],
                [92, 186],
                [186, 40],
                [230, 229],
                [229, 118],
                [118, 230],
                [202, 212],
                [212, 214],
                [214, 202],
                [83, 18],
                [18, 17],
                [17, 83],
                [76, 61],
                [61, 146],
                [146, 76],
                [160, 29],
                [29, 30],
                [30, 160],
                [56, 157],
                [157, 173],
                [173, 56],
                [106, 204],
                [204, 194],
                [194, 106],
                [135, 214],
                [214, 192],
                [192, 135],
                [203, 165],
                [165, 98],
                [98, 203],
                [21, 71],
                [71, 68],
                [68, 21],
                [51, 45],
                [45, 4],
                [4, 51],
                [144, 24],
                [24, 23],
                [23, 144],
                [77, 146],
                [146, 91],
                [91, 77],
                [205, 50],
                [50, 187],
                [187, 205],
                [201, 200],
                [200, 18],
                [18, 201],
                [91, 106],
                [106, 182],
                [182, 91],
                [90, 91],
                [91, 181],
                [181, 90],
                [85, 84],
                [84, 17],
                [17, 85],
                [206, 203],
                [203, 36],
                [36, 206],
                [148, 171],
                [171, 140],
                [140, 148],
                [92, 40],
                [40, 39],
                [39, 92],
                [193, 189],
                [189, 244],
                [244, 193],
                [159, 158],
                [158, 28],
                [28, 159],
                [247, 246],
                [246, 161],
                [161, 247],
                [236, 3],
                [3, 196],
                [196, 236],
                [54, 68],
                [68, 104],
                [104, 54],
                [193, 168],
                [168, 8],
                [8, 193],
                [117, 228],
                [228, 31],
                [31, 117],
                [189, 193],
                [193, 55],
                [55, 189],
                [98, 97],
                [97, 99],
                [99, 98],
                [126, 47],
                [47, 100],
                [100, 126],
                [166, 79],
                [79, 218],
                [218, 166],
                [155, 154],
                [154, 26],
                [26, 155],
                [209, 49],
                [49, 131],
                [131, 209],
                [135, 136],
                [136, 150],
                [150, 135],
                [47, 126],
                [126, 217],
                [217, 47],
                [223, 52],
                [52, 53],
                [53, 223],
                [45, 51],
                [51, 134],
                [134, 45],
                [211, 170],
                [170, 140],
                [140, 211],
                [67, 69],
                [69, 108],
                [108, 67],
                [43, 106],
                [106, 91],
                [91, 43],
                [230, 119],
                [119, 120],
                [120, 230],
                [226, 130],
                [130, 247],
                [247, 226],
                [63, 53],
                [53, 52],
                [52, 63],
                [238, 20],
                [20, 242],
                [242, 238],
                [46, 70],
                [70, 156],
                [156, 46],
                [78, 62],
                [62, 96],
                [96, 78],
                [46, 53],
                [53, 63],
                [63, 46],
                [143, 34],
                [34, 227],
                [227, 143],
                [123, 117],
                [117, 111],
                [111, 123],
                [44, 125],
                [125, 19],
                [19, 44],
                [236, 134],
                [134, 51],
                [51, 236],
                [216, 206],
                [206, 205],
                [205, 216],
                [154, 153],
                [153, 22],
                [22, 154],
                [39, 37],
                [37, 167],
                [167, 39],
                [200, 201],
                [201, 208],
                [208, 200],
                [36, 142],
                [142, 100],
                [100, 36],
                [57, 212],
                [212, 202],
                [202, 57],
                [20, 60],
                [60, 99],
                [99, 20],
                [28, 158],
                [158, 157],
                [157, 28],
                [35, 226],
                [226, 113],
                [113, 35],
                [160, 159],
                [159, 27],
                [27, 160],
                [204, 202],
                [202, 210],
                [210, 204],
                [113, 225],
                [225, 46],
                [46, 113],
                [43, 202],
                [202, 204],
                [204, 43],
                [62, 76],
                [76, 77],
                [77, 62],
                [137, 123],
                [123, 116],
                [116, 137],
                [41, 38],
                [38, 72],
                [72, 41],
                [203, 129],
                [129, 142],
                [142, 203],
                [64, 98],
                [98, 240],
                [240, 64],
                [49, 102],
                [102, 64],
                [64, 49],
                [41, 73],
                [73, 74],
                [74, 41],
                [212, 216],
                [216, 207],
                [207, 212],
                [42, 74],
                [74, 184],
                [184, 42],
                [169, 170],
                [170, 211],
                [211, 169],
                [170, 149],
                [149, 176],
                [176, 170],
                [105, 66],
                [66, 69],
                [69, 105],
                [122, 6],
                [6, 168],
                [168, 122],
                [123, 147],
                [147, 187],
                [187, 123],
                [96, 77],
                [77, 90],
                [90, 96],
                [65, 55],
                [55, 107],
                [107, 65],
                [89, 90],
                [90, 180],
                [180, 89],
                [101, 100],
                [100, 120],
                [120, 101],
                [63, 105],
                [105, 104],
                [104, 63],
                [93, 137],
                [137, 227],
                [227, 93],
                [15, 86],
                [86, 85],
                [85, 15],
                [129, 102],
                [102, 49],
                [49, 129],
                [14, 87],
                [87, 86],
                [86, 14],
                [55, 8],
                [8, 9],
                [9, 55],
                [100, 47],
                [47, 121],
                [121, 100],
                [145, 23],
                [23, 22],
                [22, 145],
                [88, 89],
                [89, 179],
                [179, 88],
                [6, 122],
                [122, 196],
                [196, 6],
                [88, 95],
                [95, 96],
                [96, 88],
                [
                  138,
                  172
                ],
                [172, 136],
                [136, 138],
                [215, 58],
                [58, 172],
                [172, 215],
                [115, 48],
                [48, 219],
                [219, 115],
                [42, 80],
                [80, 81],
                [81, 42],
                [195, 3],
                [3, 51],
                [51, 195],
                [43, 146],
                [146, 61],
                [61, 43],
                [171, 175],
                [175, 199],
                [199, 171],
                [81, 82],
                [82, 38],
                [38, 81],
                [53, 46],
                [46, 225],
                [225, 53],
                [144, 163],
                [163, 110],
                [110, 144],
                [52, 65],
                [65, 66],
                [66, 52],
                [229, 228],
                [228, 117],
                [117, 229],
                [34, 127],
                [127, 234],
                [234, 34],
                [107, 108],
                [108, 69],
                [69, 107],
                [109, 108],
                [108, 151],
                [151, 109],
                [48, 64],
                [64, 235],
                [235, 48],
                [62, 78],
                [78, 191],
                [191, 62],
                [129, 209],
                [209, 126],
                [126, 129],
                [111, 35],
                [35, 143],
                [143, 111],
                [117, 123],
                [123, 50],
                [50, 117],
                [222, 65],
                [65, 52],
                [52, 222],
                [19, 125],
                [125, 141],
                [141, 19],
                [221, 55],
                [55, 65],
                [65, 221],
                [3, 195],
                [195, 197],
                [197, 3],
                [25, 7],
                [7, 33],
                [33, 25],
                [220, 237],
                [237, 44],
                [44, 220],
                [70, 71],
                [71, 139],
                [139, 70],
                [122, 193],
                [193, 245],
                [245, 122],
                [247, 130],
                [130, 33],
                [33, 247],
                [71, 21],
                [21, 162],
                [162, 71],
                [170, 169],
                [169, 150],
                [150, 170],
                [188, 174],
                [174, 196],
                [196, 188],
                [216, 186],
                [186, 92],
                [92, 216],
                [2, 97],
                [97, 167],
                [167, 2],
                [141, 125],
                [125, 241],
                [241, 141],
                [164, 167],
                [167, 37],
                [37, 164],
                [72, 38],
                [38, 12],
                [12, 72],
                [
                  38,
                  82
                ],
                [82, 13],
                [13, 38],
                [63, 68],
                [68, 71],
                [71, 63],
                [226, 35],
                [35, 111],
                [111, 226],
                [101, 50],
                [50, 205],
                [205, 101],
                [206, 92],
                [92, 165],
                [165, 206],
                [209, 198],
                [198, 217],
                [217, 209],
                [165, 167],
                [167, 97],
                [97, 165],
                [220, 115],
                [115, 218],
                [218, 220],
                [133, 112],
                [112, 243],
                [243, 133],
                [239, 238],
                [238, 241],
                [241, 239],
                [214, 135],
                [135, 169],
                [169, 214],
                [190, 173],
                [173, 133],
                [133, 190],
                [171, 208],
                [208, 32],
                [32, 171],
                [125, 44],
                [44, 237],
                [237, 125],
                [86, 87],
                [87, 178],
                [178, 86],
                [85, 86],
                [86, 179],
                [179, 85],
                [84, 85],
                [85, 180],
                [180, 84],
                [83, 84],
                [84, 181],
                [181, 83],
                [
                  201,
                  83
                ],
                [83, 182],
                [182, 201],
                [137, 93],
                [93, 132],
                [132, 137],
                [76, 62],
                [62, 183],
                [183, 76],
                [61, 76],
                [76, 184],
                [184, 61],
                [57, 61],
                [61, 185],
                [185, 57],
                [212, 57],
                [57, 186],
                [186, 212],
                [214, 207],
                [207, 187],
                [187, 214],
                [34, 143],
                [143, 156],
                [156, 34],
                [79, 239],
                [239, 237],
                [237, 79],
                [123, 137],
                [137, 177],
                [177, 123],
                [44, 1],
                [1, 4],
                [4, 44],
                [201, 194],
                [194, 32],
                [32, 201],
                [64, 102],
                [102, 129],
                [129, 64],
                [213, 215],
                [215, 138],
                [138, 213],
                [59, 166],
                [166, 219],
                [219, 59],
                [242, 99],
                [99, 97],
                [97, 242],
                [2, 94],
                [94, 141],
                [141, 2],
                [75, 59],
                [59, 235],
                [235, 75],
                [24, 110],
                [110, 228],
                [228, 24],
                [25, 130],
                [130, 226],
                [226, 25],
                [23, 24],
                [24, 229],
                [229, 23],
                [22, 23],
                [23, 230],
                [230, 22],
                [26, 22],
                [22, 231],
                [231, 26],
                [112, 26],
                [26, 232],
                [232, 112],
                [189, 190],
                [190, 243],
                [243, 189],
                [221, 56],
                [56, 190],
                [190, 221],
                [28, 56],
                [56, 221],
                [221, 28],
                [27, 28],
                [28, 222],
                [222, 27],
                [29, 27],
                [27, 223],
                [223, 29],
                [30, 29],
                [29, 224],
                [224, 30],
                [247, 30],
                [30, 225],
                [225, 247],
                [238, 79],
                [79, 20],
                [20, 238],
                [166, 59],
                [59, 75],
                [75, 166],
                [60, 75],
                [75, 240],
                [240, 60],
                [147, 177],
                [177, 215],
                [215, 147],
                [20, 79],
                [79, 166],
                [166, 20],
                [187, 147],
                [147, 213],
                [213, 187],
                [
                  112,
                  233
                ],
                [233, 244],
                [244, 112],
                [233, 128],
                [128, 245],
                [245, 233],
                [128, 114],
                [114, 188],
                [188, 128],
                [114, 217],
                [217, 174],
                [174, 114],
                [131, 115],
                [115, 220],
                [220, 131],
                [217, 198],
                [198, 236],
                [236, 217],
                [198, 131],
                [131, 134],
                [134, 198],
                [177, 132],
                [132, 58],
                [58, 177],
                [143, 35],
                [35, 124],
                [124, 143],
                [110, 163],
                [163, 7],
                [7, 110],
                [228, 110],
                [110, 25],
                [25, 228],
                [356, 389],
                [389, 368],
                [368, 356],
                [11, 302],
                [302, 267],
                [267, 11],
                [452, 350],
                [350, 349],
                [349, 452],
                [302, 303],
                [303, 269],
                [269, 302],
                [357, 343],
                [343, 277],
                [277, 357],
                [452, 453],
                [453, 357],
                [357, 452],
                [333, 332],
                [332, 297],
                [297, 333],
                [175, 152],
                [152, 377],
                [377, 175],
                [347, 348],
                [348, 330],
                [330, 347],
                [303, 304],
                [304, 270],
                [270, 303],
                [9, 336],
                [336, 337],
                [337, 9],
                [278, 279],
                [279, 360],
                [360, 278],
                [418, 262],
                [262, 431],
                [431, 418],
                [304, 408],
                [408, 409],
                [409, 304],
                [310, 415],
                [415, 407],
                [407, 310],
                [270, 409],
                [409, 410],
                [410, 270],
                [450, 348],
                [348, 347],
                [347, 450],
                [422, 430],
                [430, 434],
                [434, 422],
                [313, 314],
                [314, 17],
                [17, 313],
                [306, 307],
                [307, 375],
                [375, 306],
                [387, 388],
                [388, 260],
                [260, 387],
                [286, 414],
                [414, 398],
                [398, 286],
                [335, 406],
                [406, 418],
                [418, 335],
                [364, 367],
                [367, 416],
                [416, 364],
                [423, 358],
                [358, 327],
                [327, 423],
                [251, 284],
                [284, 298],
                [298, 251],
                [281, 5],
                [5, 4],
                [4, 281],
                [373, 374],
                [374, 253],
                [253, 373],
                [307, 320],
                [320, 321],
                [321, 307],
                [425, 427],
                [427, 411],
                [411, 425],
                [421, 313],
                [313, 18],
                [18, 421],
                [321, 405],
                [405, 406],
                [406, 321],
                [320, 404],
                [404, 405],
                [405, 320],
                [315, 16],
                [16, 17],
                [17, 315],
                [426, 425],
                [425, 266],
                [266, 426],
                [377, 400],
                [400, 369],
                [369, 377],
                [322, 391],
                [391, 269],
                [269, 322],
                [417, 465],
                [465, 464],
                [464, 417],
                [386, 257],
                [257, 258],
                [258, 386],
                [466, 260],
                [260, 388],
                [388, 466],
                [456, 399],
                [
                  399,
                  419
                ],
                [419, 456],
                [284, 332],
                [332, 333],
                [333, 284],
                [417, 285],
                [285, 8],
                [8, 417],
                [346, 340],
                [340, 261],
                [261, 346],
                [413, 441],
                [441, 285],
                [285, 413],
                [327, 460],
                [460, 328],
                [328, 327],
                [355, 371],
                [371, 329],
                [329, 355],
                [392, 439],
                [439, 438],
                [438, 392],
                [382, 341],
                [341, 256],
                [256, 382],
                [429, 420],
                [420, 360],
                [360, 429],
                [364, 394],
                [394, 379],
                [379, 364],
                [277, 343],
                [343, 437],
                [437, 277],
                [443, 444],
                [444, 283],
                [283, 443],
                [275, 440],
                [440, 363],
                [363, 275],
                [431, 262],
                [262, 369],
                [369, 431],
                [297, 338],
                [338, 337],
                [337, 297],
                [273, 375],
                [375, 321],
                [321, 273],
                [450, 451],
                [451, 349],
                [349, 450],
                [446, 342],
                [342, 467],
                [467, 446],
                [293, 334],
                [334, 282],
                [282, 293],
                [458, 461],
                [461, 462],
                [462, 458],
                [276, 353],
                [353, 383],
                [383, 276],
                [308, 324],
                [324, 325],
                [325, 308],
                [276, 300],
                [300, 293],
                [293, 276],
                [372, 345],
                [345, 447],
                [447, 372],
                [352, 345],
                [345, 340],
                [340, 352],
                [274, 1],
                [1, 19],
                [19, 274],
                [456, 248],
                [248, 281],
                [281, 456],
                [436, 427],
                [427, 425],
                [425, 436],
                [381, 256],
                [256, 252],
                [252, 381],
                [269, 391],
                [391, 393],
                [393, 269],
                [200, 199],
                [199, 428],
                [428, 200],
                [266, 330],
                [330, 329],
                [329, 266],
                [287, 273],
                [273, 422],
                [422, 287],
                [250, 462],
                [462, 328],
                [328, 250],
                [258, 286],
                [286, 384],
                [384, 258],
                [265, 353],
                [353, 342],
                [342, 265],
                [387, 259],
                [259, 257],
                [257, 387],
                [424, 431],
                [431, 430],
                [430, 424],
                [342, 353],
                [353, 276],
                [276, 342],
                [273, 335],
                [335, 424],
                [424, 273],
                [292, 325],
                [325, 307],
                [307, 292],
                [366, 447],
                [447, 345],
                [345, 366],
                [271, 303],
                [303, 302],
                [302, 271],
                [423, 266],
                [266, 371],
                [371, 423],
                [294, 455],
                [455, 460],
                [460, 294],
                [279, 278],
                [278, 294],
                [294, 279],
                [271, 272],
                [272, 304],
                [304, 271],
                [432, 434],
                [434, 427],
                [427, 432],
                [272, 407],
                [407, 408],
                [408, 272],
                [394, 430],
                [430, 431],
                [431, 394],
                [
                  395,
                  369
                ],
                [369, 400],
                [400, 395],
                [334, 333],
                [333, 299],
                [299, 334],
                [351, 417],
                [417, 168],
                [168, 351],
                [352, 280],
                [280, 411],
                [411, 352],
                [325, 319],
                [319, 320],
                [320, 325],
                [295, 296],
                [296, 336],
                [336, 295],
                [319, 403],
                [403, 404],
                [404, 319],
                [330, 348],
                [348, 349],
                [349, 330],
                [293, 298],
                [298, 333],
                [333, 293],
                [323, 454],
                [454, 447],
                [447, 323],
                [15, 16],
                [16, 315],
                [315, 15],
                [358, 429],
                [429, 279],
                [279, 358],
                [14, 15],
                [15, 316],
                [316, 14],
                [285, 336],
                [336, 9],
                [9, 285],
                [329, 349],
                [349, 350],
                [350, 329],
                [374, 380],
                [380, 252],
                [252, 374],
                [318, 402],
                [402, 403],
                [403, 318],
                [6, 197],
                [197, 419],
                [419, 6],
                [318, 319],
                [319, 325],
                [325, 318],
                [367, 364],
                [364, 365],
                [365, 367],
                [435, 367],
                [367, 397],
                [397, 435],
                [344, 438],
                [438, 439],
                [439, 344],
                [272, 271],
                [271, 311],
                [311, 272],
                [195, 5],
                [5, 281],
                [281, 195],
                [273, 287],
                [287, 291],
                [291, 273],
                [396, 428],
                [428, 199],
                [199, 396],
                [311, 271],
                [271, 268],
                [268, 311],
                [283, 444],
                [444, 445],
                [445, 283],
                [373, 254],
                [254, 339],
                [339, 373],
                [282, 334],
                [334, 296],
                [296, 282],
                [449, 347],
                [347, 346],
                [346, 449],
                [264, 447],
                [447, 454],
                [454, 264],
                [336, 296],
                [296, 299],
                [299, 336],
                [338, 10],
                [10, 151],
                [151, 338],
                [278, 439],
                [439, 455],
                [455, 278],
                [292, 407],
                [407, 415],
                [415, 292],
                [358, 371],
                [371, 355],
                [355, 358],
                [340, 345],
                [345, 372],
                [372, 340],
                [346, 347],
                [347, 280],
                [280, 346],
                [442, 443],
                [443, 282],
                [282, 442],
                [19, 94],
                [94, 370],
                [370, 19],
                [441, 442],
                [442, 295],
                [295, 441],
                [248, 419],
                [419, 197],
                [197, 248],
                [263, 255],
                [255, 359],
                [359, 263],
                [440, 275],
                [275, 274],
                [274, 440],
                [300, 383],
                [383, 368],
                [368, 300],
                [351, 412],
                [412, 465],
                [465, 351],
                [263, 467],
                [467, 466],
                [466, 263],
                [301, 368],
                [368, 389],
                [389, 301],
                [395, 378],
                [378, 379],
                [379, 395],
                [412, 351],
                [351, 419],
                [419, 412],
                [
                  436,
                  426
                ],
                [426, 322],
                [322, 436],
                [2, 164],
                [164, 393],
                [393, 2],
                [370, 462],
                [462, 461],
                [461, 370],
                [164, 0],
                [0, 267],
                [267, 164],
                [302, 11],
                [11, 12],
                [12, 302],
                [268, 12],
                [12, 13],
                [13, 268],
                [293, 300],
                [300, 301],
                [301, 293],
                [446, 261],
                [261, 340],
                [340, 446],
                [330, 266],
                [266, 425],
                [425, 330],
                [426, 423],
                [423, 391],
                [391, 426],
                [429, 355],
                [355, 437],
                [437, 429],
                [391, 327],
                [327, 326],
                [326, 391],
                [440, 457],
                [457, 438],
                [438, 440],
                [341, 382],
                [382, 362],
                [362, 341],
                [459, 457],
                [457, 461],
                [461, 459],
                [434, 430],
                [430, 394],
                [394, 434],
                [414, 463],
                [463, 362],
                [362, 414],
                [396, 369],
                [
                  369,
                  262
                ],
                [262, 396],
                [354, 461],
                [461, 457],
                [457, 354],
                [316, 403],
                [403, 402],
                [402, 316],
                [315, 404],
                [404, 403],
                [403, 315],
                [314, 405],
                [405, 404],
                [404, 314],
                [313, 406],
                [406, 405],
                [405, 313],
                [421, 418],
                [418, 406],
                [406, 421],
                [366, 401],
                [401, 361],
                [361, 366],
                [306, 408],
                [408, 407],
                [407, 306],
                [291, 409],
                [409, 408],
                [408, 291],
                [287, 410],
                [410, 409],
                [409, 287],
                [432, 436],
                [436, 410],
                [410, 432],
                [434, 416],
                [416, 411],
                [411, 434],
                [264, 368],
                [368, 383],
                [383, 264],
                [309, 438],
                [438, 457],
                [457, 309],
                [352, 376],
                [376, 401],
                [401, 352],
                [274, 275],
                [275, 4],
                [4, 274],
                [421, 428],
                [428, 262],
                [262, 421],
                [294, 327],
                [327, 358],
                [358, 294],
                [433, 416],
                [416, 367],
                [367, 433],
                [289, 455],
                [455, 439],
                [439, 289],
                [462, 370],
                [370, 326],
                [326, 462],
                [2, 326],
                [326, 370],
                [370, 2],
                [305, 460],
                [460, 455],
                [455, 305],
                [254, 449],
                [449, 448],
                [448, 254],
                [255, 261],
                [261, 446],
                [446, 255],
                [253, 450],
                [450, 449],
                [449, 253],
                [252, 451],
                [451, 450],
                [450, 252],
                [256, 452],
                [452, 451],
                [451, 256],
                [341, 453],
                [453, 452],
                [452, 341],
                [413, 464],
                [464, 463],
                [463, 413],
                [441, 413],
                [413, 414],
                [414, 441],
                [258, 442],
                [442, 441],
                [441, 258],
                [257, 443],
                [443, 442],
                [442, 257],
                [
                  259,
                  444
                ],
                [444, 443],
                [443, 259],
                [260, 445],
                [445, 444],
                [444, 260],
                [467, 342],
                [342, 445],
                [445, 467],
                [459, 458],
                [458, 250],
                [250, 459],
                [289, 392],
                [392, 290],
                [290, 289],
                [290, 328],
                [328, 460],
                [460, 290],
                [376, 433],
                [433, 435],
                [435, 376],
                [250, 290],
                [290, 392],
                [392, 250],
                [411, 416],
                [416, 433],
                [433, 411],
                [341, 463],
                [463, 464],
                [464, 341],
                [453, 464],
                [464, 465],
                [465, 453],
                [357, 465],
                [465, 412],
                [412, 357],
                [343, 412],
                [412, 399],
                [399, 343],
                [360, 363],
                [363, 440],
                [440, 360],
                [437, 399],
                [399, 456],
                [456, 437],
                [420, 456],
                [456, 363],
                [363, 420],
                [401, 435],
                [435, 288],
                [288, 401],
                [372, 383],
                [383, 353],
                [353, 372],
                [339, 255],
                [255, 249],
                [249, 339],
                [448, 261],
                [261, 255],
                [255, 448],
                [133, 243],
                [243, 190],
                [190, 133],
                [133, 155],
                [155, 112],
                [112, 133],
                [33, 246],
                [246, 247],
                [247, 33],
                [33, 130],
                [130, 25],
                [25, 33],
                [398, 384],
                [384, 286],
                [286, 398],
                [362, 398],
                [398, 414],
                [414, 362],
                [362, 463],
                [463, 341],
                [341, 362],
                [263, 359],
                [359, 467],
                [467, 263],
                [263, 249],
                [249, 255],
                [255, 263],
                [466, 467],
                [467, 260],
                [260, 466],
                [75, 60],
                [60, 166],
                [166, 75],
                [238, 239],
                [239, 79],
                [79, 238],
                [162, 127],
                [127, 139],
                [139, 162],
                [72, 11],
                [11, 37],
                [37, 72],
                [121, 232],
                [232, 120],
                [120, 121],
                [73, 72],
                [72, 39],
                [39, 73],
                [114, 128],
                [128, 47],
                [47, 114],
                [233, 232],
                [232, 128],
                [128, 233],
                [103, 104],
                [104, 67],
                [67, 103],
                [152, 175],
                [175, 148],
                [148, 152],
                [119, 118],
                [118, 101],
                [101, 119],
                [74, 73],
                [73, 40],
                [40, 74],
                [107, 9],
                [9, 108],
                [108, 107],
                [49, 48],
                [48, 131],
                [131, 49],
                [32, 194],
                [194, 211],
                [211, 32],
                [184, 74],
                [74, 185],
                [185, 184],
                [191, 80],
                [80, 183],
                [183, 191],
                [185, 40],
                [40, 186],
                [186, 185],
                [119, 230],
                [230, 118],
                [118, 119],
                [210, 202],
                [202, 214],
                [214, 210],
                [84, 83],
                [83, 17],
                [17, 84],
                [77, 76],
                [76, 146],
                [146, 77],
                [161, 160],
                [
                  160,
                  30
                ],
                [30, 161],
                [190, 56],
                [56, 173],
                [173, 190],
                [182, 106],
                [106, 194],
                [194, 182],
                [138, 135],
                [135, 192],
                [192, 138],
                [129, 203],
                [203, 98],
                [98, 129],
                [54, 21],
                [21, 68],
                [68, 54],
                [5, 51],
                [51, 4],
                [4, 5],
                [145, 144],
                [144, 23],
                [23, 145],
                [90, 77],
                [77, 91],
                [91, 90],
                [207, 205],
                [205, 187],
                [187, 207],
                [83, 201],
                [201, 18],
                [18, 83],
                [181, 91],
                [91, 182],
                [182, 181],
                [180, 90],
                [90, 181],
                [181, 180],
                [16, 85],
                [85, 17],
                [17, 16],
                [205, 206],
                [206, 36],
                [36, 205],
                [176, 148],
                [148, 140],
                [140, 176],
                [165, 92],
                [92, 39],
                [39, 165],
                [245, 193],
                [193, 244],
                [244, 245],
                [27, 159],
                [159, 28],
                [28, 27],
                [30, 247],
                [247, 161],
                [161, 30],
                [174, 236],
                [236, 196],
                [196, 174],
                [103, 54],
                [54, 104],
                [104, 103],
                [55, 193],
                [193, 8],
                [8, 55],
                [111, 117],
                [117, 31],
                [31, 111],
                [221, 189],
                [189, 55],
                [55, 221],
                [240, 98],
                [98, 99],
                [99, 240],
                [142, 126],
                [126, 100],
                [100, 142],
                [219, 166],
                [166, 218],
                [218, 219],
                [112, 155],
                [155, 26],
                [26, 112],
                [198, 209],
                [209, 131],
                [131, 198],
                [169, 135],
                [135, 150],
                [150, 169],
                [114, 47],
                [47, 217],
                [217, 114],
                [224, 223],
                [223, 53],
                [53, 224],
                [220, 45],
                [45, 134],
                [134, 220],
                [32, 211],
                [211, 140],
                [140, 32],
                [109, 67],
                [67, 108],
                [108, 109],
                [146, 43],
                [43, 91],
                [
                  91,
                  146
                ],
                [231, 230],
                [230, 120],
                [120, 231],
                [113, 226],
                [226, 247],
                [247, 113],
                [105, 63],
                [63, 52],
                [52, 105],
                [241, 238],
                [238, 242],
                [242, 241],
                [124, 46],
                [46, 156],
                [156, 124],
                [95, 78],
                [78, 96],
                [96, 95],
                [70, 46],
                [46, 63],
                [63, 70],
                [116, 143],
                [143, 227],
                [227, 116],
                [116, 123],
                [123, 111],
                [111, 116],
                [1, 44],
                [44, 19],
                [19, 1],
                [3, 236],
                [236, 51],
                [51, 3],
                [207, 216],
                [216, 205],
                [205, 207],
                [26, 154],
                [154, 22],
                [22, 26],
                [165, 39],
                [39, 167],
                [167, 165],
                [199, 200],
                [200, 208],
                [208, 199],
                [101, 36],
                [36, 100],
                [100, 101],
                [43, 57],
                [57, 202],
                [202, 43],
                [242, 20],
                [20, 99],
                [99, 242],
                [
                  56,
                  28
                ],
                [28, 157],
                [157, 56],
                [124, 35],
                [35, 113],
                [113, 124],
                [29, 160],
                [160, 27],
                [27, 29],
                [211, 204],
                [204, 210],
                [210, 211],
                [124, 113],
                [113, 46],
                [46, 124],
                [106, 43],
                [43, 204],
                [204, 106],
                [96, 62],
                [62, 77],
                [77, 96],
                [227, 137],
                [137, 116],
                [116, 227],
                [73, 41],
                [41, 72],
                [72, 73],
                [36, 203],
                [203, 142],
                [142, 36],
                [235, 64],
                [64, 240],
                [240, 235],
                [48, 49],
                [49, 64],
                [64, 48],
                [42, 41],
                [41, 74],
                [74, 42],
                [214, 212],
                [212, 207],
                [207, 214],
                [183, 42],
                [42, 184],
                [184, 183],
                [210, 169],
                [169, 211],
                [211, 210],
                [140, 170],
                [170, 176],
                [176, 140],
                [104, 105],
                [105, 69],
                [69, 104],
                [193, 122],
                [
                  122,
                  168
                ],
                [168, 193],
                [50, 123],
                [123, 187],
                [187, 50],
                [89, 96],
                [96, 90],
                [90, 89],
                [66, 65],
                [65, 107],
                [107, 66],
                [179, 89],
                [89, 180],
                [180, 179],
                [119, 101],
                [101, 120],
                [120, 119],
                [68, 63],
                [63, 104],
                [104, 68],
                [234, 93],
                [93, 227],
                [227, 234],
                [16, 15],
                [15, 85],
                [85, 16],
                [209, 129],
                [129, 49],
                [49, 209],
                [15, 14],
                [14, 86],
                [86, 15],
                [107, 55],
                [55, 9],
                [9, 107],
                [120, 100],
                [100, 121],
                [121, 120],
                [153, 145],
                [145, 22],
                [22, 153],
                [178, 88],
                [88, 179],
                [179, 178],
                [197, 6],
                [6, 196],
                [196, 197],
                [89, 88],
                [88, 96],
                [96, 89],
                [135, 138],
                [138, 136],
                [136, 135],
                [138, 215],
                [215, 172],
                [172, 138],
                [218, 115],
                [115, 219],
                [219, 218],
                [41, 42],
                [42, 81],
                [81, 41],
                [5, 195],
                [195, 51],
                [51, 5],
                [57, 43],
                [43, 61],
                [61, 57],
                [208, 171],
                [171, 199],
                [199, 208],
                [41, 81],
                [81, 38],
                [38, 41],
                [224, 53],
                [53, 225],
                [225, 224],
                [24, 144],
                [144, 110],
                [110, 24],
                [105, 52],
                [52, 66],
                [66, 105],
                [118, 229],
                [229, 117],
                [117, 118],
                [227, 34],
                [34, 234],
                [234, 227],
                [66, 107],
                [107, 69],
                [69, 66],
                [10, 109],
                [109, 151],
                [151, 10],
                [219, 48],
                [48, 235],
                [235, 219],
                [183, 62],
                [62, 191],
                [191, 183],
                [142, 129],
                [129, 126],
                [126, 142],
                [116, 111],
                [111, 143],
                [143, 116],
                [118, 117],
                [117, 50],
                [50, 118],
                [223, 222],
                [222, 52],
                [52, 223],
                [94, 19],
                [19, 141],
                [141, 94],
                [222, 221],
                [221, 65],
                [65, 222],
                [196, 3],
                [3, 197],
                [197, 196],
                [45, 220],
                [220, 44],
                [44, 45],
                [156, 70],
                [70, 139],
                [139, 156],
                [188, 122],
                [122, 245],
                [245, 188],
                [139, 71],
                [71, 162],
                [162, 139],
                [149, 170],
                [170, 150],
                [150, 149],
                [122, 188],
                [188, 196],
                [196, 122],
                [206, 216],
                [216, 92],
                [92, 206],
                [164, 2],
                [2, 167],
                [167, 164],
                [242, 141],
                [141, 241],
                [241, 242],
                [0, 164],
                [164, 37],
                [37, 0],
                [11, 72],
                [72, 12],
                [12, 11],
                [12, 38],
                [38, 13],
                [13, 12],
                [70, 63],
                [63, 71],
                [71, 70],
                [31, 226],
                [226, 111],
                [111, 31],
                [36, 101],
                [101, 205],
                [
                  205,
                  36
                ],
                [203, 206],
                [206, 165],
                [165, 203],
                [126, 209],
                [209, 217],
                [217, 126],
                [98, 165],
                [165, 97],
                [97, 98],
                [237, 220],
                [220, 218],
                [218, 237],
                [237, 239],
                [239, 241],
                [241, 237],
                [210, 214],
                [214, 169],
                [169, 210],
                [140, 171],
                [171, 32],
                [32, 140],
                [241, 125],
                [125, 237],
                [237, 241],
                [179, 86],
                [86, 178],
                [178, 179],
                [180, 85],
                [85, 179],
                [179, 180],
                [181, 84],
                [84, 180],
                [180, 181],
                [182, 83],
                [83, 181],
                [181, 182],
                [194, 201],
                [201, 182],
                [182, 194],
                [177, 137],
                [137, 132],
                [132, 177],
                [184, 76],
                [76, 183],
                [183, 184],
                [185, 61],
                [61, 184],
                [184, 185],
                [186, 57],
                [57, 185],
                [185, 186],
                [216, 212],
                [212, 186],
                [186, 216],
                [192, 214],
                [214, 187],
                [187, 192],
                [139, 34],
                [34, 156],
                [156, 139],
                [218, 79],
                [79, 237],
                [237, 218],
                [147, 123],
                [123, 177],
                [177, 147],
                [45, 44],
                [44, 4],
                [4, 45],
                [208, 201],
                [201, 32],
                [32, 208],
                [98, 64],
                [64, 129],
                [129, 98],
                [192, 213],
                [213, 138],
                [138, 192],
                [235, 59],
                [59, 219],
                [219, 235],
                [141, 242],
                [242, 97],
                [97, 141],
                [97, 2],
                [2, 141],
                [141, 97],
                [240, 75],
                [75, 235],
                [235, 240],
                [229, 24],
                [24, 228],
                [228, 229],
                [31, 25],
                [25, 226],
                [226, 31],
                [230, 23],
                [23, 229],
                [229, 230],
                [231, 22],
                [22, 230],
                [230, 231],
                [232, 26],
                [26, 231],
                [231, 232],
                [233, 112],
                [
                  112,
                  232
                ],
                [232, 233],
                [244, 189],
                [189, 243],
                [243, 244],
                [189, 221],
                [221, 190],
                [190, 189],
                [222, 28],
                [28, 221],
                [221, 222],
                [223, 27],
                [27, 222],
                [222, 223],
                [224, 29],
                [29, 223],
                [223, 224],
                [225, 30],
                [30, 224],
                [224, 225],
                [113, 247],
                [247, 225],
                [225, 113],
                [99, 60],
                [60, 240],
                [240, 99],
                [213, 147],
                [147, 215],
                [215, 213],
                [60, 20],
                [20, 166],
                [166, 60],
                [192, 187],
                [187, 213],
                [213, 192],
                [243, 112],
                [112, 244],
                [244, 243],
                [244, 233],
                [233, 245],
                [245, 244],
                [245, 128],
                [128, 188],
                [188, 245],
                [188, 114],
                [114, 174],
                [174, 188],
                [134, 131],
                [131, 220],
                [220, 134],
                [174, 217],
                [217, 236],
                [
                  236,
                  174
                ],
                [236, 198],
                [198, 134],
                [134, 236],
                [215, 177],
                [177, 58],
                [58, 215],
                [156, 143],
                [143, 124],
                [124, 156],
                [25, 110],
                [110, 7],
                [7, 25],
                [31, 228],
                [228, 25],
                [25, 31],
                [264, 356],
                [356, 368],
                [368, 264],
                [0, 11],
                [11, 267],
                [267, 0],
                [451, 452],
                [452, 349],
                [349, 451],
                [267, 302],
                [302, 269],
                [269, 267],
                [350, 357],
                [357, 277],
                [277, 350],
                [350, 452],
                [452, 357],
                [357, 350],
                [299, 333],
                [333, 297],
                [297, 299],
                [396, 175],
                [175, 377],
                [377, 396],
                [280, 347],
                [347, 330],
                [330, 280],
                [269, 303],
                [303, 270],
                [270, 269],
                [151, 9],
                [9, 337],
                [337, 151],
                [344, 278],
                [278, 360],
                [360, 344],
                [424, 418],
                [418, 431],
                [431, 424],
                [270, 304],
                [304, 409],
                [409, 270],
                [272, 310],
                [310, 407],
                [407, 272],
                [322, 270],
                [270, 410],
                [410, 322],
                [449, 450],
                [450, 347],
                [347, 449],
                [432, 422],
                [422, 434],
                [434, 432],
                [18, 313],
                [313, 17],
                [17, 18],
                [291, 306],
                [306, 375],
                [375, 291],
                [259, 387],
                [387, 260],
                [260, 259],
                [424, 335],
                [335, 418],
                [418, 424],
                [434, 364],
                [364, 416],
                [416, 434],
                [391, 423],
                [423, 327],
                [327, 391],
                [301, 251],
                [251, 298],
                [298, 301],
                [275, 281],
                [281, 4],
                [4, 275],
                [254, 373],
                [373, 253],
                [253, 254],
                [375, 307],
                [307, 321],
                [321, 375],
                [280, 425],
                [425, 411],
                [411, 280],
                [200, 421],
                [421, 18],
                [18, 200],
                [335, 321],
                [321, 406],
                [406, 335],
                [321, 320],
                [320, 405],
                [405, 321],
                [314, 315],
                [315, 17],
                [17, 314],
                [423, 426],
                [426, 266],
                [266, 423],
                [396, 377],
                [377, 369],
                [369, 396],
                [270, 322],
                [322, 269],
                [269, 270],
                [413, 417],
                [417, 464],
                [464, 413],
                [385, 386],
                [386, 258],
                [258, 385],
                [248, 456],
                [456, 419],
                [419, 248],
                [298, 284],
                [284, 333],
                [333, 298],
                [168, 417],
                [417, 8],
                [8, 168],
                [448, 346],
                [346, 261],
                [261, 448],
                [417, 413],
                [413, 285],
                [285, 417],
                [326, 327],
                [327, 328],
                [328, 326],
                [277, 355],
                [355, 329],
                [329, 277],
                [309, 392],
                [392, 438],
                [438, 309],
                [381, 382],
                [382, 256],
                [256, 381],
                [279, 429],
                [429, 360],
                [360, 279],
                [365, 364],
                [364, 379],
                [379, 365],
                [355, 277],
                [277, 437],
                [437, 355],
                [282, 443],
                [443, 283],
                [283, 282],
                [281, 275],
                [275, 363],
                [363, 281],
                [395, 431],
                [431, 369],
                [369, 395],
                [299, 297],
                [297, 337],
                [337, 299],
                [335, 273],
                [273, 321],
                [321, 335],
                [348, 450],
                [450, 349],
                [349, 348],
                [359, 446],
                [446, 467],
                [467, 359],
                [283, 293],
                [293, 282],
                [282, 283],
                [250, 458],
                [458, 462],
                [462, 250],
                [300, 276],
                [276, 383],
                [383, 300],
                [292, 308],
                [308, 325],
                [325, 292],
                [283, 276],
                [276, 293],
                [293, 283],
                [264, 372],
                [372, 447],
                [447, 264],
                [
                  346,
                  352
                ],
                [352, 340],
                [340, 346],
                [354, 274],
                [274, 19],
                [19, 354],
                [363, 456],
                [456, 281],
                [281, 363],
                [426, 436],
                [436, 425],
                [425, 426],
                [380, 381],
                [381, 252],
                [252, 380],
                [267, 269],
                [269, 393],
                [393, 267],
                [421, 200],
                [200, 428],
                [428, 421],
                [371, 266],
                [266, 329],
                [329, 371],
                [432, 287],
                [287, 422],
                [422, 432],
                [290, 250],
                [250, 328],
                [328, 290],
                [385, 258],
                [258, 384],
                [384, 385],
                [446, 265],
                [265, 342],
                [342, 446],
                [386, 387],
                [387, 257],
                [257, 386],
                [422, 424],
                [424, 430],
                [430, 422],
                [445, 342],
                [342, 276],
                [276, 445],
                [422, 273],
                [273, 424],
                [424, 422],
                [306, 292],
                [292, 307],
                [307, 306],
                [352, 366],
                [366, 345],
                [345, 352],
                [268, 271],
                [271, 302],
                [302, 268],
                [358, 423],
                [423, 371],
                [371, 358],
                [327, 294],
                [294, 460],
                [460, 327],
                [331, 279],
                [279, 294],
                [294, 331],
                [303, 271],
                [271, 304],
                [304, 303],
                [436, 432],
                [432, 427],
                [427, 436],
                [304, 272],
                [272, 408],
                [408, 304],
                [395, 394],
                [394, 431],
                [431, 395],
                [378, 395],
                [395, 400],
                [400, 378],
                [296, 334],
                [334, 299],
                [299, 296],
                [6, 351],
                [351, 168],
                [168, 6],
                [376, 352],
                [352, 411],
                [411, 376],
                [307, 325],
                [325, 320],
                [320, 307],
                [285, 295],
                [295, 336],
                [336, 285],
                [320, 319],
                [319, 404],
                [404, 320],
                [329, 330],
                [330, 349],
                [
                  349,
                  329
                ],
                [334, 293],
                [293, 333],
                [333, 334],
                [366, 323],
                [323, 447],
                [447, 366],
                [316, 15],
                [15, 315],
                [315, 316],
                [331, 358],
                [358, 279],
                [279, 331],
                [317, 14],
                [14, 316],
                [316, 317],
                [8, 285],
                [285, 9],
                [9, 8],
                [277, 329],
                [329, 350],
                [350, 277],
                [253, 374],
                [374, 252],
                [252, 253],
                [319, 318],
                [318, 403],
                [403, 319],
                [351, 6],
                [6, 419],
                [419, 351],
                [324, 318],
                [318, 325],
                [325, 324],
                [397, 367],
                [367, 365],
                [365, 397],
                [288, 435],
                [435, 397],
                [397, 288],
                [278, 344],
                [344, 439],
                [439, 278],
                [310, 272],
                [272, 311],
                [311, 310],
                [248, 195],
                [195, 281],
                [281, 248],
                [375, 273],
                [273, 291],
                [291, 375],
                [
                  175,
                  396
                ],
                [396, 199],
                [199, 175],
                [312, 311],
                [311, 268],
                [268, 312],
                [276, 283],
                [283, 445],
                [445, 276],
                [390, 373],
                [373, 339],
                [339, 390],
                [295, 282],
                [282, 296],
                [296, 295],
                [448, 449],
                [449, 346],
                [346, 448],
                [356, 264],
                [264, 454],
                [454, 356],
                [337, 336],
                [336, 299],
                [299, 337],
                [337, 338],
                [338, 151],
                [151, 337],
                [294, 278],
                [278, 455],
                [455, 294],
                [308, 292],
                [292, 415],
                [415, 308],
                [429, 358],
                [358, 355],
                [355, 429],
                [265, 340],
                [340, 372],
                [372, 265],
                [352, 346],
                [346, 280],
                [280, 352],
                [295, 442],
                [442, 282],
                [282, 295],
                [354, 19],
                [19, 370],
                [370, 354],
                [285, 441],
                [441, 295],
                [295, 285],
                [195, 248],
                [248, 197],
                [197, 195],
                [457, 440],
                [440, 274],
                [274, 457],
                [301, 300],
                [300, 368],
                [368, 301],
                [417, 351],
                [351, 465],
                [465, 417],
                [251, 301],
                [301, 389],
                [389, 251],
                [394, 395],
                [395, 379],
                [379, 394],
                [399, 412],
                [412, 419],
                [419, 399],
                [410, 436],
                [436, 322],
                [322, 410],
                [326, 2],
                [2, 393],
                [393, 326],
                [354, 370],
                [370, 461],
                [461, 354],
                [393, 164],
                [164, 267],
                [267, 393],
                [268, 302],
                [302, 12],
                [12, 268],
                [312, 268],
                [268, 13],
                [13, 312],
                [298, 293],
                [293, 301],
                [301, 298],
                [265, 446],
                [446, 340],
                [340, 265],
                [280, 330],
                [330, 425],
                [425, 280],
                [322, 426],
                [426, 391],
                [391, 322],
                [420, 429],
                [429, 437],
                [437, 420],
                [393, 391],
                [391, 326],
                [326, 393],
                [344, 440],
                [440, 438],
                [438, 344],
                [458, 459],
                [459, 461],
                [461, 458],
                [364, 434],
                [434, 394],
                [394, 364],
                [428, 396],
                [396, 262],
                [262, 428],
                [274, 354],
                [354, 457],
                [457, 274],
                [317, 316],
                [316, 402],
                [402, 317],
                [316, 315],
                [315, 403],
                [403, 316],
                [315, 314],
                [314, 404],
                [404, 315],
                [314, 313],
                [313, 405],
                [405, 314],
                [313, 421],
                [421, 406],
                [406, 313],
                [323, 366],
                [366, 361],
                [361, 323],
                [292, 306],
                [306, 407],
                [407, 292],
                [306, 291],
                [291, 408],
                [408, 306],
                [291, 287],
                [287, 409],
                [409, 291],
                [287, 432],
                [432, 410],
                [
                  410,
                  287
                ],
                [427, 434],
                [434, 411],
                [411, 427],
                [372, 264],
                [264, 383],
                [383, 372],
                [459, 309],
                [309, 457],
                [457, 459],
                [366, 352],
                [352, 401],
                [401, 366],
                [1, 274],
                [274, 4],
                [4, 1],
                [418, 421],
                [421, 262],
                [262, 418],
                [331, 294],
                [294, 358],
                [358, 331],
                [435, 433],
                [433, 367],
                [367, 435],
                [392, 289],
                [289, 439],
                [439, 392],
                [328, 462],
                [462, 326],
                [326, 328],
                [94, 2],
                [2, 370],
                [370, 94],
                [289, 305],
                [305, 455],
                [455, 289],
                [339, 254],
                [254, 448],
                [448, 339],
                [359, 255],
                [255, 446],
                [446, 359],
                [254, 253],
                [253, 449],
                [449, 254],
                [253, 252],
                [252, 450],
                [450, 253],
                [252, 256],
                [256, 451],
                [451, 252],
                [256, 341],
                [341, 452],
                [452, 256],
                [414, 413],
                [413, 463],
                [463, 414],
                [286, 441],
                [441, 414],
                [414, 286],
                [286, 258],
                [258, 441],
                [441, 286],
                [258, 257],
                [257, 442],
                [442, 258],
                [257, 259],
                [259, 443],
                [443, 257],
                [259, 260],
                [260, 444],
                [444, 259],
                [260, 467],
                [467, 445],
                [445, 260],
                [309, 459],
                [459, 250],
                [250, 309],
                [305, 289],
                [289, 290],
                [290, 305],
                [305, 290],
                [290, 460],
                [460, 305],
                [401, 376],
                [376, 435],
                [435, 401],
                [309, 250],
                [250, 392],
                [392, 309],
                [376, 411],
                [411, 433],
                [433, 376],
                [453, 341],
                [341, 464],
                [464, 453],
                [357, 453],
                [453, 465],
                [465, 357],
                [343, 357],
                [357, 412],
                [
                  412,
                  343
                ],
                [437, 343],
                [343, 399],
                [399, 437],
                [344, 360],
                [360, 440],
                [440, 344],
                [420, 437],
                [437, 456],
                [456, 420],
                [360, 420],
                [420, 363],
                [363, 360],
                [361, 401],
                [401, 288],
                [288, 361],
                [265, 372],
                [372, 353],
                [353, 265],
                [390, 339],
                [339, 249],
                [249, 390],
                [339, 448],
                [448, 255],
                [255, 339]
              ]), Ji("VERSION", "0.4.1646425229");
            }).call(Oe);
            const Jt = {};
            (function() {
              var E;
              function R(q) {
                var he = 0;
                return function() {
                  return he < q.length ? { done: !1, value: q[he++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(q, he, ve) {
                return q == Array.prototype || q == Object.prototype || (q[he] = ve.value), q;
              };
              function ie(q) {
                q = [typeof globalThis == "object" && globalThis, q, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var he = 0; he < q.length; ++he) {
                  var ve = q[he];
                  if (ve && ve.Math == Math)
                    return ve;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(q, he) {
                if (he)
                  e: {
                    var ve = pe;
                    q = q.split(".");
                    for (var bt = 0; bt < q.length - 1; bt++) {
                      var Ot = q[bt];
                      if (!(Ot in ve))
                        break e;
                      ve = ve[Ot];
                    }
                    q = q[q.length - 1], bt = ve[q], he = he(bt), he != bt && he != null && S(ve, q, { configurable: !0, writable: !0, value: he });
                  }
              }
              De("Symbol", function(q) {
                function he(In) {
                  if (this instanceof he)
                    throw new TypeError("Symbol is not a constructor");
                  return new ve(bt + (In || "") + "_" + Ot++, In);
                }
                function ve(In, en) {
                  this.g = In, S(this, "description", { configurable: !0, writable: !0, value: en });
                }
                if (q)
                  return q;
                ve.prototype.toString = function() {
                  return this.g;
                };
                var bt = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", Ot = 0;
                return he;
              }), De("Symbol.iterator", function(q) {
                if (q)
                  return q;
                q = Symbol("Symbol.iterator");
                for (var he = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), ve = 0; ve < he.length; ve++) {
                  var bt = pe[he[ve]];
                  typeof bt == "function" && typeof bt.prototype[q] != "function" && S(bt.prototype, q, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return q;
              });
              function ht(q) {
                return q = { next: q }, q[Symbol.iterator] = function() {
                  return this;
                }, q;
              }
              function rt(q) {
                var he = typeof Symbol < "u" && Symbol.iterator && q[Symbol.iterator];
                return he ? he.call(q) : { next: R(q) };
              }
              function Nt(q) {
                if (!(q instanceof Array)) {
                  q = rt(q);
                  for (var he, ve = []; !(he = q.next()).done; )
                    ve.push(he.value);
                  q = ve;
                }
                return q;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(q) {
                function he() {
                }
                return he.prototype = q, new he();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(q, he) {
                  if (q.__proto__ = he, q.__proto__ !== he)
                    throw new TypeError(q + " is not extensible");
                  return q;
                } : null;
              }
              var br = cr;
              function Nr(q, he) {
                if (q.prototype = Pn(he.prototype), q.prototype.constructor = q, br)
                  br(q, he);
                else
                  for (var ve in he)
                    if (ve != "prototype")
                      if (Object.defineProperties) {
                        var bt = Object.getOwnPropertyDescriptor(he, ve);
                        bt && Object.defineProperty(q, ve, bt);
                      } else
                        q[ve] = he[ve];
                q.ea = he.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
              }
              function qi(q) {
                if (q.l)
                  throw new TypeError("Generator is already running");
                q.l = !0;
              }
              $i.prototype.o = function(q) {
                this.h = q;
              };
              function Vo(q, he) {
                q.j = { U: he, V: !0 }, q.g = q.m || q.s;
              }
              $i.prototype.return = function(q) {
                this.j = { return: q }, this.g = this.s;
              };
              function Un(q, he, ve) {
                return q.g = ve, { value: he };
              }
              function el(q) {
                this.g = new $i(), this.h = q;
              }
              function Ys(q, he) {
                qi(q.g);
                var ve = q.g.i;
                return ve ? Ca(q, "return" in ve ? ve.return : function(bt) {
                  return { value: bt, done: !0 };
                }, he, q.g.return) : (q.g.return(he), lo(q));
              }
              function Ca(q, he, ve, bt) {
                try {
                  var Ot = he.call(q.g.i, ve);
                  if (!(Ot instanceof Object))
                    throw new TypeError("Iterator result " + Ot + " is not an object");
                  if (!Ot.done)
                    return q.g.l = !1, Ot;
                  var In = Ot.value;
                } catch (en) {
                  return q.g.i = null, Vo(q.g, en), lo(q);
                }
                return q.g.i = null, bt.call(q.g, In), lo(q);
              }
              function lo(q) {
                for (; q.g.g; )
                  try {
                    var he = q.h(q.g);
                    if (he)
                      return q.g.l = !1, { value: he.value, done: !1 };
                  } catch (ve) {
                    q.g.h = void 0, Vo(q.g, ve);
                  }
                if (q.g.l = !1, q.g.j) {
                  if (he = q.g.j, q.g.j = null, he.V)
                    throw he.U;
                  return { value: he.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(q) {
                this.next = function(he) {
                  return qi(q.g), q.g.i ? he = Ca(q, q.g.i.next, he, q.g.o) : (q.g.o(he), he = lo(q)), he;
                }, this.throw = function(he) {
                  return qi(q.g), q.g.i ? he = Ca(q, q.g.i.throw, he, q.g.o) : (Vo(q.g, he), he = lo(q)), he;
                }, this.return = function(he) {
                  return Ys(q, he);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(q, he) {
                return he = new Cc(new el(he)), br && q.prototype && br(he, q.prototype), he;
              }
              function Mr(q, he) {
                q instanceof String && (q += "");
                var ve = 0, bt = !1, Ot = { next: function() {
                  if (!bt && ve < q.length) {
                    var In = ve++;
                    return { value: he(In, q[In]), done: !1 };
                  }
                  return bt = !0, { done: !0, value: void 0 };
                } };
                return Ot[Symbol.iterator] = function() {
                  return Ot;
                }, Ot;
              }
              var ml = typeof Object.assign == "function" ? Object.assign : function(q, he) {
                for (var ve = 1; ve < arguments.length; ve++) {
                  var bt = arguments[ve];
                  if (bt)
                    for (var Ot in bt)
                      Object.prototype.hasOwnProperty.call(bt, Ot) && (q[Ot] = bt[Ot]);
                }
                return q;
              };
              De("Object.assign", function(q) {
                return q || ml;
              }), De("Promise", function(q) {
                function he(en) {
                  this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                  var Gn = this.j();
                  try {
                    en(Gn.resolve, Gn.reject);
                  } catch (dr) {
                    Gn.reject(dr);
                  }
                }
                function ve() {
                  this.g = null;
                }
                function bt(en) {
                  return en instanceof he ? en : new he(function(Gn) {
                    Gn(en);
                  });
                }
                if (q)
                  return q;
                ve.prototype.h = function(en) {
                  if (this.g == null) {
                    this.g = [];
                    var Gn = this;
                    this.i(function() {
                      Gn.l();
                    });
                  }
                  this.g.push(en);
                };
                var Ot = pe.setTimeout;
                ve.prototype.i = function(en) {
                  Ot(en, 0);
                }, ve.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var en = this.g;
                    this.g = [];
                    for (var Gn = 0; Gn < en.length; ++Gn) {
                      var dr = en[Gn];
                      en[Gn] = null;
                      try {
                        dr();
                      } catch (D) {
                        this.j(D);
                      }
                    }
                  }
                  this.g = null;
                }, ve.prototype.j = function(en) {
                  this.i(function() {
                    throw en;
                  });
                }, he.prototype.j = function() {
                  function en(D) {
                    return function(Fe) {
                      dr || (dr = !0, D.call(Gn, Fe));
                    };
                  }
                  var Gn = this, dr = !1;
                  return { resolve: en(this.C), reject: en(this.l) };
                }, he.prototype.C = function(en) {
                  if (en === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (en instanceof he)
                    this.F(en);
                  else {
                    e:
                      switch (typeof en) {
                        case "object":
                          var Gn = en != null;
                          break e;
                        case "function":
                          Gn = !0;
                          break e;
                        default:
                          Gn = !1;
                      }
                    Gn ? this.u(en) : this.m(en);
                  }
                }, he.prototype.u = function(en) {
                  var Gn = void 0;
                  try {
                    Gn = en.then;
                  } catch (dr) {
                    this.l(dr);
                    return;
                  }
                  typeof Gn == "function" ? this.G(Gn, en) : this.m(en);
                }, he.prototype.l = function(en) {
                  this.s(2, en);
                }, he.prototype.m = function(en) {
                  this.s(1, en);
                }, he.prototype.s = function(en, Gn) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + en + ", " + Gn + "): Promise already settled in state" + this.h);
                  this.h = en, this.i = Gn, this.h === 2 && this.D(), this.A();
                }, he.prototype.D = function() {
                  var en = this;
                  Ot(function() {
                    if (en.B()) {
                      var Gn = pe.console;
                      typeof Gn < "u" && Gn.error(en.i);
                    }
                  }, 1);
                }, he.prototype.B = function() {
                  if (this.o)
                    return !1;
                  var en = pe.CustomEvent, Gn = pe.Event, dr = pe.dispatchEvent;
                  return typeof dr > "u" ? !0 : (typeof en == "function" ? en = new en("unhandledrejection", { cancelable: !0 }) : typeof Gn == "function" ? en = new Gn("unhandledrejection", { cancelable: !0 }) : (en = pe.document.createEvent("CustomEvent"), en.initCustomEvent("unhandledrejection", !1, !0, en)), en.promise = this, en.reason = this.i, dr(en));
                }, he.prototype.A = function() {
                  if (this.g != null) {
                    for (var en = 0; en < this.g.length; ++en)
                      In.h(this.g[en]);
                    this.g = null;
                  }
                };
                var In = new ve();
                return he.prototype.F = function(en) {
                  var Gn = this.j();
                  en.J(Gn.resolve, Gn.reject);
                }, he.prototype.G = function(en, Gn) {
                  var dr = this.j();
                  try {
                    en.call(Gn, dr.resolve, dr.reject);
                  } catch (D) {
                    dr.reject(D);
                  }
                }, he.prototype.then = function(en, Gn) {
                  function dr(it, Gt) {
                    return typeof it == "function" ? function(nn) {
                      try {
                        D(it(nn));
                      } catch (Pt) {
                        Fe(Pt);
                      }
                    } : Gt;
                  }
                  var D, Fe, Se = new he(function(it, Gt) {
                    D = it, Fe = Gt;
                  });
                  return this.J(dr(en, D), dr(Gn, Fe)), Se;
                }, he.prototype.catch = function(en) {
                  return this.then(void 0, en);
                }, he.prototype.J = function(en, Gn) {
                  function dr() {
                    switch (D.h) {
                      case 1:
                        en(D.i);
                        break;
                      case 2:
                        Gn(D.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + D.h);
                    }
                  }
                  var D = this;
                  this.g == null ? In.h(dr) : this.g.push(dr), this.o = !0;
                }, he.resolve = bt, he.reject = function(en) {
                  return new he(function(Gn, dr) {
                    dr(en);
                  });
                }, he.race = function(en) {
                  return new he(function(Gn, dr) {
                    for (var D = rt(en), Fe = D.next(); !Fe.done; Fe = D.next())
                      bt(Fe.value).J(Gn, dr);
                  });
                }, he.all = function(en) {
                  var Gn = rt(en), dr = Gn.next();
                  return dr.done ? bt([]) : new he(function(D, Fe) {
                    function Se(nn) {
                      return function(Pt) {
                        it[nn] = Pt, Gt--, Gt == 0 && D(it);
                      };
                    }
                    var it = [], Gt = 0;
                    do
                      it.push(void 0), Gt++, bt(dr.value).J(Se(it.length - 1), Fe), dr = Gn.next();
                    while (!dr.done);
                  });
                }, he;
              }), De("Object.is", function(q) {
                return q || function(he, ve) {
                  return he === ve ? he !== 0 || 1 / he === 1 / ve : he !== he && ve !== ve;
                };
              }), De("Array.prototype.includes", function(q) {
                return q || function(he, ve) {
                  var bt = this;
                  bt instanceof String && (bt = String(bt));
                  var Ot = bt.length;
                  for (ve = ve || 0, 0 > ve && (ve = Math.max(ve + Ot, 0)); ve < Ot; ve++) {
                    var In = bt[ve];
                    if (In === he || Object.is(In, he))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(q) {
                return q || function(he, ve) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (he instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(he, ve || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(q) {
                return q || function() {
                  return Mr(this, function(he) {
                    return he;
                  });
                };
              });
              var cd = this || self;
              function Ma(q, he) {
                q = q.split(".");
                var ve = cd;
                q[0] in ve || typeof ve.execScript > "u" || ve.execScript("var " + q[0]);
                for (var bt; q.length && (bt = q.shift()); )
                  q.length || he === void 0 ? ve[bt] && ve[bt] !== Object.prototype[bt] ? ve = ve[bt] : ve = ve[bt] = {} : ve[bt] = he;
              }
              function Ji(q, he) {
                return he = String.fromCharCode.apply(null, he), q == null ? he : q + he;
              }
              var ts, tl = typeof TextDecoder < "u", Wl, Ac = typeof TextEncoder < "u";
              function Hl(q) {
                if (Ac)
                  q = (Wl || (Wl = new TextEncoder())).encode(q);
                else {
                  var he = void 0;
                  he = he === void 0 ? !1 : he;
                  for (var ve = 0, bt = new Uint8Array(3 * q.length), Ot = 0; Ot < q.length; Ot++) {
                    var In = q.charCodeAt(Ot);
                    if (128 > In)
                      bt[ve++] = In;
                    else {
                      if (2048 > In)
                        bt[ve++] = In >> 6 | 192;
                      else {
                        if (55296 <= In && 57343 >= In) {
                          if (56319 >= In && Ot < q.length) {
                            var en = q.charCodeAt(++Ot);
                            if (56320 <= en && 57343 >= en) {
                              In = 1024 * (In - 55296) + en - 56320 + 65536, bt[ve++] = In >> 18 | 240, bt[ve++] = In >> 12 & 63 | 128, bt[ve++] = In >> 6 & 63 | 128, bt[ve++] = In & 63 | 128;
                              continue;
                            } else
                              Ot--;
                          }
                          if (he)
                            throw Error("Found an unpaired surrogate");
                          In = 65533;
                        }
                        bt[ve++] = In >> 12 | 224, bt[ve++] = In >> 6 & 63 | 128;
                      }
                      bt[ve++] = In & 63 | 128;
                    }
                  }
                  q = bt.subarray(0, ve);
                }
                return q;
              }
              var Uc = {}, dl = null;
              function vl(q, he) {
                he === void 0 && (he = 0), Js(), he = Uc[he];
                for (var ve = Array(Math.floor(q.length / 3)), bt = he[64] || "", Ot = 0, In = 0; Ot < q.length - 2; Ot += 3) {
                  var en = q[Ot], Gn = q[Ot + 1], dr = q[Ot + 2], D = he[en >> 2];
                  en = he[(en & 3) << 4 | Gn >> 4], Gn = he[(Gn & 15) << 2 | dr >> 6], dr = he[dr & 63], ve[In++] = D + en + Gn + dr;
                }
                switch (D = 0, dr = bt, q.length - Ot) {
                  case 2:
                    D = q[Ot + 1], dr = he[(D & 15) << 2] || bt;
                  case 1:
                    q = q[Ot], ve[In] = he[q >> 2] + he[(q & 3) << 4 | D >> 4] + dr + bt;
                }
                return ve.join("");
              }
              function Nc(q) {
                var he = q.length, ve = 3 * he / 4;
                ve % 3 ? ve = Math.floor(ve) : "=.".indexOf(q[he - 1]) != -1 && (ve = "=.".indexOf(q[he - 2]) != -1 ? ve - 2 : ve - 1);
                var bt = new Uint8Array(ve), Ot = 0;
                return gc(q, function(In) {
                  bt[Ot++] = In;
                }), bt.subarray(0, Ot);
              }
              function gc(q, he) {
                function ve(dr) {
                  for (; bt < q.length; ) {
                    var D = q.charAt(bt++), Fe = dl[D];
                    if (Fe != null)
                      return Fe;
                    if (!/^[\s\xa0]*$/.test(D))
                      throw Error("Unknown base64 encoding at char: " + D);
                  }
                  return dr;
                }
                Js();
                for (var bt = 0; ; ) {
                  var Ot = ve(-1), In = ve(0), en = ve(64), Gn = ve(64);
                  if (Gn === 64 && Ot === -1)
                    break;
                  he(Ot << 2 | In >> 4), en != 64 && (he(In << 4 & 240 | en >> 2), Gn != 64 && he(en << 6 & 192 | Gn));
                }
              }
              function Js() {
                if (!dl) {
                  dl = {};
                  for (var q = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), he = ["+/=", "+/", "-_=", "-_.", "-_"], ve = 0; 5 > ve; ve++) {
                    var bt = q.concat(he[ve].split(""));
                    Uc[ve] = bt;
                    for (var Ot = 0; Ot < bt.length; Ot++) {
                      var In = bt[Ot];
                      dl[In] === void 0 && (dl[In] = Ot);
                    }
                  }
                }
              }
              var Is = typeof Uint8Array.prototype.slice == "function", Pl;
              function Nl(q, he, ve) {
                return he === ve ? Pl || (Pl = new Uint8Array(0)) : Is ? q.slice(he, ve) : new Uint8Array(q.subarray(he, ve));
              }
              var ta = 0, $a = 0;
              function Gs(q, he) {
                he = he === void 0 ? {} : he, he = he.v === void 0 ? !1 : he.v, this.h = null, this.g = this.j = this.l = 0, this.m = !1, this.v = he, q && To(this, q);
              }
              function To(q, he) {
                he = he.constructor === Uint8Array ? he : he.constructor === ArrayBuffer ? new Uint8Array(he) : he.constructor === Array ? new Uint8Array(he) : he.constructor === String ? Nc(he) : he instanceof Uint8Array ? new Uint8Array(he.buffer, he.byteOffset, he.byteLength) : new Uint8Array(0), q.h = he, q.l = 0, q.j = q.h.length, q.g = q.l;
              }
              Gs.prototype.reset = function() {
                this.g = this.l;
              };
              function Na(q) {
                for (var he = 128, ve = 0, bt = 0, Ot = 0; 4 > Ot && 128 <= he; Ot++)
                  he = q.h[q.g++], ve |= (he & 127) << 7 * Ot;
                if (128 <= he && (he = q.h[q.g++], ve |= (he & 127) << 28, bt |= (he & 127) >> 4), 128 <= he)
                  for (Ot = 0; 5 > Ot && 128 <= he; Ot++)
                    he = q.h[q.g++], bt |= (he & 127) << 7 * Ot + 3;
                if (128 > he)
                  return q = ve >>> 0, he = bt >>> 0, (bt = he & 2147483648) && (q = ~q + 1 >>> 0, he = ~he >>> 0, q == 0 && (he = he + 1 >>> 0)), q = 4294967296 * he + (q >>> 0), bt ? -q : q;
                q.m = !0;
              }
              Gs.prototype.i = function() {
                var q = this.h, he = q[this.g], ve = he & 127;
                return 128 > he ? (this.g += 1, ve) : (he = q[this.g + 1], ve |= (he & 127) << 7, 128 > he ? (this.g += 2, ve) : (he = q[this.g + 2], ve |= (he & 127) << 14, 128 > he ? (this.g += 3, ve) : (he = q[this.g + 3], ve |= (he & 127) << 21, 128 > he ? (this.g += 4, ve) : (he = q[this.g + 4], ve |= (he & 15) << 28, 128 > he ? (this.g += 5, ve >>> 0) : (this.g += 5, 128 <= q[this.g++] && 128 <= q[this.g++] && 128 <= q[this.g++] && 128 <= q[this.g++] && this.g++, ve)))));
              }, Gs.prototype.o = function() {
                var q = this.h[this.g], he = this.h[this.g + 1], ve = this.h[this.g + 2], bt = this.h[this.g + 3];
                return this.g += 4, ve = (q << 0 | he << 8 | ve << 16 | bt << 24) >>> 0, q = 2 * (ve >> 31) + 1, he = ve >>> 23 & 255, ve &= 8388607, he == 255 ? ve ? NaN : 1 / 0 * q : he == 0 ? q * Math.pow(2, -149) * ve : q * Math.pow(2, he - 150) * (ve + Math.pow(2, 23));
              };
              var nl = [];
              function vs() {
                this.g = new Uint8Array(64), this.h = 0;
              }
              vs.prototype.push = function(q) {
                if (!(this.h + 1 < this.g.length)) {
                  var he = this.g;
                  this.g = new Uint8Array(Math.ceil(1 + 2 * this.g.length)), this.g.set(he);
                }
                this.g[this.h++] = q;
              }, vs.prototype.length = function() {
                return this.h;
              }, vs.prototype.end = function() {
                var q = this.g, he = this.h;
                return this.h = 0, Nl(q, 0, he);
              };
              function bo(q, he) {
                for (; 127 < he; )
                  q.push(he & 127 | 128), he >>>= 7;
                q.push(he);
              }
              function fa(q) {
                var he = {}, ve = he.N === void 0 ? !1 : he.N;
                this.o = { v: he.v === void 0 ? !1 : he.v }, this.N = ve, he = this.o, nl.length ? (ve = nl.pop(), he && (ve.v = he.v), q && To(ve, q), q = ve) : q = new Gs(q, he), this.g = q, this.m = this.g.g, this.h = this.i = this.l = -1, this.j = !1;
              }
              fa.prototype.reset = function() {
                this.g.reset(), this.h = this.l = -1;
              };
              function ss(q) {
                var he = q.g;
                if ((he = he.g == he.j) || (he = q.j) || (he = q.g, he = he.m || 0 > he.g || he.g > he.j), he)
                  return !1;
                q.m = q.g.g, he = q.g.i();
                var ve = he & 7;
                return ve != 0 && ve != 5 && ve != 1 && ve != 2 && ve != 3 && ve != 4 ? (q.j = !0, !1) : (q.i = he, q.l = he >>> 3, q.h = ve, !0);
              }
              function eo(q) {
                switch (q.h) {
                  case 0:
                    if (q.h != 0)
                      eo(q);
                    else {
                      for (q = q.g; q.h[q.g] & 128; )
                        q.g++;
                      q.g++;
                    }
                    break;
                  case 1:
                    q.h != 1 ? eo(q) : (q = q.g, q.g += 8);
                    break;
                  case 2:
                    if (q.h != 2)
                      eo(q);
                    else {
                      var he = q.g.i();
                      q = q.g, q.g += he;
                    }
                    break;
                  case 5:
                    q.h != 5 ? eo(q) : (q = q.g, q.g += 4);
                    break;
                  case 3:
                    he = q.l;
                    do {
                      if (!ss(q)) {
                        q.j = !0;
                        break;
                      }
                      if (q.h == 4) {
                        q.l != he && (q.j = !0);
                        break;
                      }
                      eo(q);
                    } while (!0);
                    break;
                  default:
                    q.j = !0;
                }
              }
              function Pa(q, he, ve) {
                var bt = q.g.j, Ot = q.g.i(), In = q.g.g + Ot;
                if (q.g.j = In, ve(he, q), ve = In - q.g.g, ve !== 0)
                  throw Error("Message parsing ended unexpectedly. Expected to read " + Ot + " bytes, instead read " + (Ot - ve) + " bytes, either the data ended unexpectedly or the message misreported its own length");
                return q.g.g = In, q.g.j = bt, he;
              }
              function Ao(q) {
                return q.g.o();
              }
              function ua(q) {
                var he = q.g.i();
                q = q.g;
                var ve = q.g;
                q.g += he, q = q.h;
                var bt;
                if (tl)
                  (bt = ts) || (bt = ts = new TextDecoder("utf-8", { fatal: !1 })), bt = bt.decode(q.subarray(ve, ve + he));
                else {
                  he = ve + he;
                  for (var Ot = [], In = null, en, Gn, dr; ve < he; )
                    en = q[ve++], 128 > en ? Ot.push(en) : 224 > en ? ve >= he ? Ot.push(65533) : (Gn = q[ve++], 194 > en || (Gn & 192) !== 128 ? (ve--, Ot.push(65533)) : Ot.push((en & 31) << 6 | Gn & 63)) : 240 > en ? ve >= he - 1 ? Ot.push(65533) : (Gn = q[ve++], (Gn & 192) !== 128 || en === 224 && 160 > Gn || en === 237 && 160 <= Gn || ((bt = q[ve++]) & 192) !== 128 ? (ve--, Ot.push(65533)) : Ot.push((en & 15) << 12 | (Gn & 63) << 6 | bt & 63)) : 244 >= en ? ve >= he - 2 ? Ot.push(65533) : (Gn = q[ve++], (Gn & 192) !== 128 || (en << 28) + (Gn - 144) >> 30 || ((bt = q[ve++]) & 192) !== 128 || ((dr = q[ve++]) & 192) !== 128 ? (ve--, Ot.push(65533)) : (en = (en & 7) << 18 | (Gn & 63) << 12 | (bt & 63) << 6 | dr & 63, en -= 65536, Ot.push((en >> 10 & 1023) + 55296, (en & 1023) + 56320))) : Ot.push(65533), 8192 <= Ot.length && (In = Ji(In, Ot), Ot.length = 0);
                  bt = Ji(In, Ot);
                }
                return bt;
              }
              function ns(q, he, ve) {
                var bt = q.g.i();
                for (bt = q.g.g + bt; q.g.g < bt; )
                  ve.push(he.call(q.g));
              }
              function Ls(q, he) {
                q.h == 2 ? ns(q, Gs.prototype.o, he) : he.push(Ao(q));
              }
              function Ua() {
                this.h = [], this.i = 0, this.g = new vs();
              }
              function go(q, he) {
                he.length !== 0 && (q.h.push(he), q.i += he.length);
              }
              function Bs(q) {
                var he = q.i + q.g.length();
                if (he === 0)
                  return new Uint8Array(0);
                he = new Uint8Array(he);
                for (var ve = q.h, bt = ve.length, Ot = 0, In = 0; In < bt; In++) {
                  var en = ve[In];
                  en.length !== 0 && (he.set(en, Ot), Ot += en.length);
                }
                return ve = q.g, bt = ve.h, bt !== 0 && (he.set(ve.g.subarray(0, bt), Ot), ve.h = 0), q.h = [he], he;
              }
              function Ts(q, he, ve) {
                if (ve != null) {
                  bo(q.g, 8 * he + 5), q = q.g;
                  var bt = ve;
                  bt = (ve = 0 > bt ? 1 : 0) ? -bt : bt, bt === 0 ? 0 < 1 / bt ? ta = $a = 0 : ($a = 0, ta = 2147483648) : isNaN(bt) ? ($a = 0, ta = 2147483647) : 34028234663852886e22 < bt ? ($a = 0, ta = (ve << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > bt ? (bt = Math.round(bt / Math.pow(2, -149)), $a = 0, ta = (ve << 31 | bt) >>> 0) : (he = Math.floor(Math.log(bt) / Math.LN2), bt *= Math.pow(2, -he), bt = Math.round(8388608 * bt), 16777216 <= bt && ++he, $a = 0, ta = (ve << 31 | he + 127 << 23 | bt & 8388607) >>> 0), ve = ta, q.push(ve >>> 0 & 255), q.push(ve >>> 8 & 255), q.push(ve >>> 16 & 255), q.push(ve >>> 24 & 255);
                }
              }
              var Oa = typeof Uint8Array == "function";
              function Jl(q, he, ve) {
                if (q != null)
                  return typeof q == "object" ? Oa && q instanceof Uint8Array ? ve(q) : rl(q, he, ve) : he(q);
              }
              function rl(q, he, ve) {
                if (Array.isArray(q)) {
                  for (var bt = Array(q.length), Ot = 0; Ot < q.length; Ot++)
                    bt[Ot] = Jl(q[Ot], he, ve);
                  return Array.isArray(q) && q.W && pa(bt), bt;
                }
                bt = {};
                for (Ot in q)
                  bt[Ot] = Jl(q[Ot], he, ve);
                return bt;
              }
              function Xs(q) {
                return typeof q == "number" ? isFinite(q) ? q : String(q) : q;
              }
              var il = { W: { value: !0, configurable: !0 } };
              function pa(q) {
                return Array.isArray(q) && !Object.isFrozen(q) && Object.defineProperties(q, il), q;
              }
              var rs;
              function ma(q, he, ve) {
                var bt = rs;
                rs = null, q || (q = bt), bt = this.constructor.ca, q || (q = bt ? [bt] : []), this.j = bt ? 0 : -1, this.m = this.g = null, this.h = q;
                e: {
                  if (bt = this.h.length, q = bt - 1, bt && (bt = this.h[q], !(bt === null || typeof bt != "object" || Array.isArray(bt) || Oa && bt instanceof Uint8Array))) {
                    this.l = q - this.j, this.i = bt;
                    break e;
                  }
                  he !== void 0 && -1 < he ? (this.l = Math.max(he, q + 1 - this.j), this.i = null) : this.l = Number.MAX_VALUE;
                }
                if (ve)
                  for (he = 0; he < ve.length; he++)
                    q = ve[he], q < this.l ? (q += this.j, (bt = this.h[q]) ? pa(bt) : this.h[q] = Xo) : (ks(this), (bt = this.i[q]) ? pa(bt) : this.i[q] = Xo);
              }
              var Xo = Object.freeze(pa([]));
              function ks(q) {
                var he = q.l + q.j;
                q.h[he] || (q.i = q.h[he] = {});
              }
              function Zo(q, he, ve) {
                return he === -1 ? null : ve !== void 0 && ve || he >= q.l ? q.i ? q.i[he] : void 0 : q.h[he + q.j];
              }
              function fo(q, he) {
                var ve = ve === void 0 ? !1 : ve, bt = Zo(q, he, ve);
                return bt == null && (bt = Xo), bt === Xo && (bt = pa([]), li(q, he, bt, ve)), bt;
              }
              function ul(q) {
                var he = fo(q, 3);
                if (q.m || (q.m = {}), !q.m[3]) {
                  for (var ve = 0; ve < he.length; ve++)
                    he[ve] = +he[ve];
                  q.m[3] = !0;
                }
                return he;
              }
              function na(q, he, ve) {
                return q = Zo(q, he), q == null ? ve : q;
              }
              function Wi(q, he, ve) {
                return q = Zo(q, he), q = q == null ? q : +q, q == null ? ve === void 0 ? 0 : ve : q;
              }
              function li(q, he, ve, bt) {
                bt !== void 0 && bt || he >= q.l ? (ks(q), q.i[he] = ve) : q.h[he + q.j] = ve;
              }
              function ko(q, he, ve) {
                if (ve === -1)
                  return null;
                if (q.g || (q.g = {}), !q.g[ve]) {
                  var bt = Zo(q, ve, !1);
                  bt && (q.g[ve] = new he(bt));
                }
                return q.g[ve];
              }
              function is(q, he) {
                q.g || (q.g = {});
                var ve = q.g[1];
                if (!ve) {
                  var bt = fo(q, 1);
                  ve = [];
                  for (var Ot = 0; Ot < bt.length; Ot++)
                    ve[Ot] = new he(bt[Ot]);
                  q.g[1] = ve;
                }
                return ve;
              }
              function So(q, he, ve) {
                var bt = bt === void 0 ? !1 : bt;
                q.g || (q.g = {});
                var Ot = ve && wn(ve);
                q.g[he] = ve, li(q, he, Ot, bt);
              }
              function wo(q, he, ve, bt) {
                var Ot = is(q, ve);
                he = he || new ve(), q = fo(q, 1), bt != null ? (Ot.splice(bt, 0, he), q.splice(bt, 0, wn(he))) : (Ot.push(he), q.push(wn(he)));
              }
              ma.prototype.toJSON = function() {
                var q = wn(this);
                return rl(q, Xs, vl);
              };
              function wn(q, he) {
                if (q.g)
                  for (var ve in q.g) {
                    var bt = q.g[ve];
                    if (Array.isArray(bt))
                      for (var Ot = 0; Ot < bt.length; Ot++)
                        bt[Ot] && wn(bt[Ot]);
                    else
                      bt && wn(bt);
                  }
                return q.h;
              }
              ma.prototype.toString = function() {
                return wn(this).toString();
              };
              function jn(q, he) {
                if (q = q.o) {
                  go(he, he.g.end());
                  for (var ve = 0; ve < q.length; ve++)
                    go(he, q[ve]);
                }
              }
              function hr(q, he) {
                if (he.h == 4)
                  return !1;
                var ve = he.m;
                return eo(he), he.N || (he = Nl(he.g.h, ve, he.g.g), (ve = q.o) ? ve.push(he) : q.o = [he]), !0;
              }
              function po(q) {
                ma.call(this, q, -1, Yo);
              }
              Nr(po, ma), po.prototype.getRows = function() {
                return Zo(this, 1);
              }, po.prototype.getCols = function() {
                return Zo(this, 2);
              }, po.prototype.getPackedDataList = function() {
                return ul(this);
              }, po.prototype.getLayout = function() {
                return na(this, 4, 0);
              };
              function Po(q, he) {
                for (; ss(he); )
                  switch (he.i) {
                    case 8:
                      var ve = he.g.i();
                      li(q, 1, ve);
                      break;
                    case 16:
                      ve = he.g.i(), li(q, 2, ve);
                      break;
                    case 29:
                    case 26:
                      Ls(he, q.getPackedDataList());
                      break;
                    case 32:
                      ve = Na(he.g), li(q, 4, ve);
                      break;
                    default:
                      if (!hr(q, he))
                        return q;
                  }
                return q;
              }
              var Yo = [3];
              function fi(q, he) {
                var ve = void 0;
                return new (ve || (ve = n))(function(bt, Ot) {
                  function In(dr) {
                    try {
                      Gn(he.next(dr));
                    } catch (D) {
                      Ot(D);
                    }
                  }
                  function en(dr) {
                    try {
                      Gn(he.throw(dr));
                    } catch (D) {
                      Ot(D);
                    }
                  }
                  function Gn(dr) {
                    dr.done ? bt(dr.value) : new ve(function(D) {
                      D(dr.value);
                    }).then(In, en);
                  }
                  Gn((he = he.apply(q, void 0)).next());
                });
              }
              function ra(q) {
                ma.call(this, q);
              }
              Nr(ra, ma);
              function ls(q, he) {
                for (; ss(he); )
                  switch (he.i) {
                    case 8:
                      var ve = he.g.i();
                      li(q, 1, ve);
                      break;
                    case 21:
                      ve = Ao(he), li(q, 2, ve);
                      break;
                    case 26:
                      ve = ua(he), li(q, 3, ve);
                      break;
                    case 34:
                      ve = ua(he), li(q, 4, ve);
                      break;
                    default:
                      if (!hr(q, he))
                        return q;
                  }
                return q;
              }
              function xs(q) {
                ma.call(this, q, -1, Hs);
              }
              Nr(xs, ma), xs.prototype.addClassification = function(q, he) {
                return wo(this, q, ra, he), this;
              };
              var Hs = [1];
              function hl(q) {
                ma.call(this, q);
              }
              Nr(hl, ma);
              function bl(q, he) {
                for (; ss(he); )
                  switch (he.i) {
                    case 13:
                      var ve = Ao(he);
                      li(q, 1, ve);
                      break;
                    case 21:
                      ve = Ao(he), li(q, 2, ve);
                      break;
                    case 29:
                      ve = Ao(he), li(q, 3, ve);
                      break;
                    case 37:
                      ve = Ao(he), li(q, 4, ve);
                      break;
                    case 45:
                      ve = Ao(he), li(q, 5, ve);
                      break;
                    default:
                      if (!hr(q, he))
                        return q;
                  }
                return q;
              }
              function os(q) {
                ma.call(this, q, -1, dd);
              }
              Nr(os, ma);
              function Ps(q) {
                e: {
                  var he = new os();
                  for (q = new fa(q); ss(q); )
                    switch (q.i) {
                      case 10:
                        var ve = Pa(q, new hl(), bl);
                        wo(he, ve, hl, void 0);
                        break;
                      default:
                        if (!hr(he, q))
                          break e;
                    }
                }
                return he;
              }
              var dd = [1];
              function Os(q) {
                ma.call(this, q);
              }
              Nr(Os, ma);
              function cs(q) {
                ma.call(this, q, -1, Ol);
              }
              Nr(cs, ma), cs.prototype.getVertexType = function() {
                return na(this, 1, 0);
              }, cs.prototype.getPrimitiveType = function() {
                return na(this, 2, 0);
              }, cs.prototype.getVertexBufferList = function() {
                return ul(this);
              }, cs.prototype.getIndexBufferList = function() {
                return fo(this, 4);
              };
              function Il(q, he) {
                for (; ss(he); )
                  switch (he.i) {
                    case 8:
                      var ve = Na(he.g);
                      li(q, 1, ve);
                      break;
                    case 16:
                      ve = Na(he.g), li(q, 2, ve);
                      break;
                    case 29:
                    case 26:
                      Ls(he, q.getVertexBufferList());
                      break;
                    case 32:
                    case 34:
                      ve = he;
                      var bt = q.getIndexBufferList();
                      ve.h == 2 ? ns(ve, Gs.prototype.i, bt) : bt.push(ve.g.i());
                      break;
                    default:
                      if (!hr(q, he))
                        return q;
                  }
                return q;
              }
              var Ol = [3, 4];
              function bs(q) {
                ma.call(this, q);
              }
              Nr(bs, ma), bs.prototype.getMesh = function() {
                return ko(this, cs, 1);
              }, bs.prototype.getPoseTransformMatrix = function() {
                return ko(this, po, 2);
              };
              function Jc(q) {
                e: {
                  var he = new bs();
                  for (q = new fa(q); ss(q); )
                    switch (q.i) {
                      case 10:
                        var ve = Pa(q, new cs(), Il);
                        So(he, 1, ve);
                        break;
                      case 18:
                        ve = Pa(q, new po(), Po), So(he, 2, ve);
                        break;
                      default:
                        if (!hr(he, q))
                          break e;
                    }
                }
                return he;
              }
              function Ks(q, he, ve) {
                if (ve = q.createShader(ve === 0 ? q.VERTEX_SHADER : q.FRAGMENT_SHADER), q.shaderSource(ve, he), q.compileShader(ve), !q.getShaderParameter(ve, q.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + q.getShaderInfoLog(ve));
                return ve;
              }
              function Bl(q) {
                return is(q, ra).map(function(he) {
                  return { index: na(he, 1, 0), Y: Wi(he, 2), label: Zo(he, 3) != null ? na(he, 3, "") : void 0, displayName: Zo(he, 4) != null ? na(he, 4, "") : void 0 };
                });
              }
              function nc(q) {
                return { x: Wi(q, 1), y: Wi(q, 2), z: Wi(q, 3), visibility: Zo(q, 4) != null ? Wi(q, 4) : void 0 };
              }
              function Oc(q, he) {
                this.h = q, this.g = he, this.l = 0;
              }
              function ol(q, he, ve) {
                return rc(q, he), typeof q.g.canvas.transferToImageBitmap == "function" ? n.resolve(q.g.canvas.transferToImageBitmap()) : ve ? n.resolve(q.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(q.g.canvas) : (q.i === void 0 && (q.i = document.createElement("canvas")), new n(function(bt) {
                  q.i.height = q.g.canvas.height, q.i.width = q.g.canvas.width, q.i.getContext("2d", {}).drawImage(q.g.canvas, 0, 0, q.g.canvas.width, q.g.canvas.height), bt(q.i);
                }));
              }
              function rc(q, he) {
                var ve = q.g;
                if (q.m === void 0) {
                  var bt = Ks(ve, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), Ot = Ks(ve, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), In = ve.createProgram();
                  if (ve.attachShader(In, bt), ve.attachShader(In, Ot), ve.linkProgram(In), !ve.getProgramParameter(In, ve.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + ve.getProgramInfoLog(In));
                  bt = q.m = In, ve.useProgram(bt), Ot = ve.getUniformLocation(bt, "sampler0"), q.j = { I: ve.getAttribLocation(bt, "aVertex"), H: ve.getAttribLocation(bt, "aTex"), da: Ot }, q.s = ve.createBuffer(), ve.bindBuffer(ve.ARRAY_BUFFER, q.s), ve.enableVertexAttribArray(q.j.I), ve.vertexAttribPointer(q.j.I, 2, ve.FLOAT, !1, 0, 0), ve.bufferData(ve.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), ve.STATIC_DRAW), ve.bindBuffer(ve.ARRAY_BUFFER, null), q.o = ve.createBuffer(), ve.bindBuffer(ve.ARRAY_BUFFER, q.o), ve.enableVertexAttribArray(q.j.H), ve.vertexAttribPointer(
                    q.j.H,
                    2,
                    ve.FLOAT,
                    !1,
                    0,
                    0
                  ), ve.bufferData(ve.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), ve.STATIC_DRAW), ve.bindBuffer(ve.ARRAY_BUFFER, null), ve.uniform1i(Ot, 0);
                }
                bt = q.j, ve.useProgram(q.m), ve.canvas.width = he.width, ve.canvas.height = he.height, ve.viewport(0, 0, he.width, he.height), ve.activeTexture(ve.TEXTURE0), q.h.bindTexture2d(he.glName), ve.enableVertexAttribArray(bt.I), ve.bindBuffer(ve.ARRAY_BUFFER, q.s), ve.vertexAttribPointer(bt.I, 2, ve.FLOAT, !1, 0, 0), ve.enableVertexAttribArray(bt.H), ve.bindBuffer(ve.ARRAY_BUFFER, q.o), ve.vertexAttribPointer(
                  bt.H,
                  2,
                  ve.FLOAT,
                  !1,
                  0,
                  0
                ), ve.bindFramebuffer(ve.DRAW_FRAMEBUFFER ? ve.DRAW_FRAMEBUFFER : ve.FRAMEBUFFER, null), ve.clearColor(0, 0, 0, 0), ve.clear(ve.COLOR_BUFFER_BIT), ve.colorMask(!0, !0, !0, !0), ve.drawArrays(ve.TRIANGLE_FAN, 0, 4), ve.disableVertexAttribArray(bt.I), ve.disableVertexAttribArray(bt.H), ve.bindBuffer(ve.ARRAY_BUFFER, null), q.h.bindTexture2d(0);
              }
              function Ld(q) {
                this.g = q;
              }
              var xd = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function ic(q, he) {
                return he + q;
              }
              function fc(q, he) {
                window[q] = he;
              }
              function le(q) {
                var he = document.createElement("script");
                return he.setAttribute("src", q), he.setAttribute("crossorigin", "anonymous"), new n(function(ve) {
                  he.addEventListener("load", function() {
                    ve();
                  }, !1), he.addEventListener("error", function() {
                    ve();
                  }, !1), document.body.appendChild(he);
                });
              }
              function Ie() {
                return fi(this, function q() {
                  return Go(q, function(he) {
                    switch (he.g) {
                      case 1:
                        return he.m = 2, Un(he, WebAssembly.instantiate(xd), 4);
                      case 4:
                        he.g = 3, he.m = 0;
                        break;
                      case 2:
                        return he.m = 0, he.j = null, he.return(!1);
                      case 3:
                        return he.return(!0);
                    }
                  });
                });
              }
              function Ze(q) {
                if (this.g = q, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = n.resolve(), this.P = "", this.B = {}, this.locateFile = q && q.locateFile || ic, typeof window == "object")
                  var he = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  he = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.S = he, q.options) {
                  he = rt(Object.keys(q.options));
                  for (var ve = he.next(); !ve.done; ve = he.next()) {
                    ve = ve.value;
                    var bt = q.options[ve].default;
                    bt !== void 0 && (this.j[ve] = typeof bt == "function" ? bt() : bt);
                  }
                }
              }
              E = Ze.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function Mt(q, he) {
                return q.g.files === void 0 ? [] : typeof q.g.files == "function" ? q.g.files(he) : q.g.files;
              }
              function yn(q) {
                return fi(q, function he() {
                  var ve = this, bt, Ot, In, en, Gn, dr, D, Fe, Se, it, Gt;
                  return Go(he, function(nn) {
                    switch (nn.g) {
                      case 1:
                        return bt = ve, ve.R ? (Ot = Mt(ve, ve.j), Un(nn, Ie(), 2)) : nn.return();
                      case 2:
                        if (In = nn.h, typeof window == "object")
                          return fc("createMediapipeSolutionsWasm", { locateFile: ve.locateFile }), fc("createMediapipeSolutionsPackedAssets", { locateFile: ve.locateFile }), dr = Ot.filter(function(Pt) {
                            return Pt.data !== void 0;
                          }), D = Ot.filter(function(Pt) {
                            return Pt.data === void 0;
                          }), Fe = n.all(dr.map(function(Pt) {
                            var Mn = zn(bt, Pt.url);
                            if (Pt.path !== void 0) {
                              var Nn = Pt.path;
                              Mn = Mn.then(function(Xr) {
                                return bt.overrideFile(Nn, Xr), n.resolve(Xr);
                              });
                            }
                            return Mn;
                          })), Se = n.all(D.map(function(Pt) {
                            return Pt.simd === void 0 || Pt.simd && In || !Pt.simd && !In ? le(bt.locateFile(Pt.url, bt.S)) : n.resolve();
                          })).then(function() {
                            return fi(bt, function Pt() {
                              var Mn, Nn, Xr = this;
                              return Go(Pt, function(ei) {
                                if (ei.g == 1)
                                  return Mn = window.createMediapipeSolutionsWasm, Nn = window.createMediapipeSolutionsPackedAssets, Un(ei, Mn(Nn), 2);
                                Xr.h = ei.h, ei.g = 0;
                              });
                            });
                          }), it = function() {
                            return fi(bt, function Pt() {
                              var Mn = this;
                              return Go(Pt, function(Nn) {
                                return Mn.g.graph && Mn.g.graph.url ? Nn = Un(Nn, zn(Mn, Mn.g.graph.url), 0) : (Nn.g = 0, Nn = void 0), Nn;
                              });
                            });
                          }(), Un(nn, n.all([Se, Fe, it]), 7);
                        if (typeof importScripts != "function")
                          throw Error("solutions can only be loaded on a web page or in a web worker");
                        return en = Ot.filter(function(Pt) {
                          return Pt.simd === void 0 || Pt.simd && In || !Pt.simd && !In;
                        }).map(function(Pt) {
                          return bt.locateFile(Pt.url, bt.S);
                        }), importScripts.apply(null, Nt(en)), Un(nn, createMediapipeSolutionsWasm(Module), 6);
                      case 6:
                        ve.h = nn.h, ve.l = new OffscreenCanvas(1, 1), ve.h.canvas = ve.l, Gn = ve.h.GL.createContext(
                          ve.l,
                          { antialias: !1, alpha: !1, ba: typeof WebGL2RenderingContext < "u" ? 2 : 1 }
                        ), ve.h.GL.makeContextCurrent(Gn), nn.g = 4;
                        break;
                      case 7:
                        if (ve.l = document.createElement("canvas"), Gt = ve.l.getContext("webgl2", {}), !Gt && (Gt = ve.l.getContext("webgl", {}), !Gt))
                          return alert("Failed to create WebGL canvas context when passing video frame."), nn.return();
                        ve.D = Gt, ve.h.canvas = ve.l, ve.h.createContext(ve.l, !0, !0, {});
                      case 4:
                        ve.i = new ve.h.SolutionWasm(), ve.R = !1, nn.g = 0;
                    }
                  });
                });
              }
              function nr(q) {
                return fi(q, function he() {
                  var ve = this, bt, Ot, In, en, Gn, dr, D, Fe;
                  return Go(he, function(Se) {
                    if (Se.g == 1) {
                      if (ve.g.graph && ve.g.graph.url && ve.P === ve.g.graph.url)
                        return Se.return();
                      if (ve.o = !0, !ve.g.graph || !ve.g.graph.url) {
                        Se.g = 2;
                        return;
                      }
                      return ve.P = ve.g.graph.url, Un(Se, zn(ve, ve.g.graph.url), 3);
                    }
                    for (Se.g != 2 && (bt = Se.h, ve.i.loadGraph(bt)), Ot = rt(Object.keys(ve.B)), In = Ot.next(); !In.done; In = Ot.next())
                      en = In.value, ve.i.overrideFile(en, ve.B[en]);
                    if (ve.B = {}, ve.g.listeners)
                      for (Gn = rt(ve.g.listeners), dr = Gn.next(); !dr.done; dr = Gn.next())
                        D = dr.value, Ki(ve, D);
                    Fe = ve.j, ve.j = {}, ve.setOptions(Fe), Se.g = 0;
                  });
                });
              }
              E.reset = function() {
                return fi(this, function q() {
                  var he = this;
                  return Go(q, function(ve) {
                    he.i && (he.i.reset(), he.m = {}, he.s = {}), ve.g = 0;
                  });
                });
              }, E.setOptions = function(q, he) {
                var ve = this;
                if (he = he || this.g.options) {
                  for (var bt = [], Ot = [], In = {}, en = rt(Object.keys(q)), Gn = en.next(); !Gn.done; In = { K: In.K, L: In.L }, Gn = en.next()) {
                    var dr = Gn.value;
                    dr in this.j && this.j[dr] === q[dr] || (this.j[dr] = q[dr], Gn = he[dr], Gn !== void 0 && (Gn.onChange && (In.K = Gn.onChange, In.L = q[dr], bt.push(/* @__PURE__ */ function(D) {
                      return function() {
                        return fi(ve, function Fe() {
                          var Se, it = this;
                          return Go(Fe, function(Gt) {
                            if (Gt.g == 1)
                              return Un(Gt, D.K(D.L), 2);
                            Se = Gt.h, Se === !0 && (it.o = !0), Gt.g = 0;
                          });
                        });
                      };
                    }(In))), Gn.graphOptionXref && (dr = { valueNumber: Gn.type === 1 ? q[dr] : 0, valueBoolean: Gn.type === 0 ? q[dr] : !1, valueString: Gn.type === 2 ? q[dr] : "" }, Gn = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), Gn.graphOptionXref), dr), Ot.push(Gn))));
                  }
                  (bt.length !== 0 || Ot.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(Ot), this.u = (this.u === void 0 ? [] : this.u).concat(bt));
                }
              };
              function mn(q) {
                return fi(q, function he() {
                  var ve = this, bt, Ot, In, en, Gn, dr, D;
                  return Go(he, function(Fe) {
                    switch (Fe.g) {
                      case 1:
                        if (!ve.o)
                          return Fe.return();
                        if (!ve.u) {
                          Fe.g = 2;
                          break;
                        }
                        bt = rt(ve.u), Ot = bt.next();
                      case 3:
                        if (Ot.done) {
                          Fe.g = 5;
                          break;
                        }
                        return In = Ot.value, Un(Fe, In(), 4);
                      case 4:
                        Ot = bt.next(), Fe.g = 3;
                        break;
                      case 5:
                        ve.u = void 0;
                      case 2:
                        if (ve.A) {
                          for (en = new ve.h.GraphOptionChangeRequestList(), Gn = rt(ve.A), dr = Gn.next(); !dr.done; dr = Gn.next())
                            D = dr.value, en.push_back(D);
                          ve.i.changeOptions(en), en.delete(), ve.A = void 0;
                        }
                        ve.o = !1, Fe.g = 0;
                    }
                  });
                });
              }
              E.initialize = function() {
                return fi(this, function q() {
                  var he = this;
                  return Go(q, function(ve) {
                    return ve.g == 1 ? Un(ve, yn(he), 2) : ve.g != 3 ? Un(ve, nr(he), 3) : Un(ve, mn(he), 0);
                  });
                });
              };
              function zn(q, he) {
                return fi(q, function ve() {
                  var bt = this, Ot, In;
                  return Go(ve, function(en) {
                    return he in bt.F ? en.return(bt.F[he]) : (Ot = bt.locateFile(he, ""), In = fetch(Ot).then(function(Gn) {
                      return Gn.arrayBuffer();
                    }), bt.F[he] = In, en.return(In));
                  });
                });
              }
              E.overrideFile = function(q, he) {
                this.i ? this.i.overrideFile(q, he) : this.B[q] = he;
              }, E.clearOverriddenFiles = function() {
                this.B = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(q, he) {
                return fi(this, function ve() {
                  var bt = this, Ot, In, en, Gn, dr, D, Fe, Se, it;
                  return Go(ve, function(Gt) {
                    switch (Gt.g) {
                      case 1:
                        return bt.g.inputs ? (Ot = 1e3 * (he == null ? performance.now() : he), Un(Gt, bt.C, 2)) : Gt.return();
                      case 2:
                        return Un(Gt, bt.initialize(), 3);
                      case 3:
                        for (In = new bt.h.PacketDataList(), en = rt(Object.keys(q)), Gn = en.next(); !Gn.done; Gn = en.next())
                          if (dr = Gn.value, D = bt.g.inputs[dr]) {
                            e: {
                              var nn = bt, Pt = q[dr];
                              switch (D.type) {
                                case "video":
                                  var Mn = nn.m[D.stream];
                                  if (Mn || (Mn = new Oc(nn.h, nn.D), nn.m[D.stream] = Mn), nn = Mn, nn.l === 0 && (nn.l = nn.h.createTexture()), typeof HTMLVideoElement < "u" && Pt instanceof HTMLVideoElement) {
                                    var Nn = Pt.videoWidth;
                                    Mn = Pt.videoHeight;
                                  } else
                                    typeof HTMLImageElement < "u" && Pt instanceof HTMLImageElement ? (Nn = Pt.naturalWidth, Mn = Pt.naturalHeight) : (Nn = Pt.width, Mn = Pt.height);
                                  Mn = { glName: nn.l, width: Nn, height: Mn }, Nn = nn.g, Nn.canvas.width = Mn.width, Nn.canvas.height = Mn.height, Nn.activeTexture(Nn.TEXTURE0), nn.h.bindTexture2d(nn.l), Nn.texImage2D(Nn.TEXTURE_2D, 0, Nn.RGBA, Nn.RGBA, Nn.UNSIGNED_BYTE, Pt), nn.h.bindTexture2d(0), nn = Mn;
                                  break e;
                                case "detections":
                                  for (Mn = nn.m[D.stream], Mn || (Mn = new Ld(nn.h), nn.m[D.stream] = Mn), nn = Mn, nn.data || (nn.data = new nn.g.DetectionListData()), nn.data.reset(Pt.length), Mn = 0; Mn < Pt.length; ++Mn) {
                                    Nn = Pt[Mn];
                                    var Xr = nn.data, ei = Xr.setBoundingBox, ji = Mn, di = Nn.T, Cr = new Os();
                                    li(Cr, 1, di.Z), li(Cr, 2, di.$), li(Cr, 3, di.height), li(Cr, 4, di.width), li(Cr, 5, di.rotation), li(Cr, 6, di.X);
                                    var ni = di = new Ua();
                                    Ts(ni, 1, Zo(Cr, 1)), Ts(ni, 2, Zo(Cr, 2)), Ts(ni, 3, Zo(Cr, 3)), Ts(ni, 4, Zo(Cr, 4)), Ts(ni, 5, Zo(Cr, 5));
                                    var Ai = Zo(Cr, 6);
                                    if (Ai != null && Ai != null) {
                                      bo(ni.g, 48);
                                      var Ri = ni.g, Ii = Ai;
                                      Ai = 0 > Ii, Ii = Math.abs(Ii);
                                      var Y = Ii >>> 0;
                                      for (Ii = Math.floor((Ii - Y) / 4294967296), Ii >>>= 0, Ai && (Ii = ~Ii >>> 0, Y = (~Y >>> 0) + 1, 4294967295 < Y && (Y = 0, Ii++, 4294967295 < Ii && (Ii = 0))), ta = Y, $a = Ii, Ai = ta, Y = $a; 0 < Y || 127 < Ai; )
                                        Ri.push(Ai & 127 | 128), Ai = (Ai >>> 7 | Y << 25) >>> 0, Y >>>= 7;
                                      Ri.push(Ai);
                                    }
                                    if (jn(Cr, ni), di = Bs(di), ei.call(Xr, ji, di), Nn.O)
                                      for (Xr = 0; Xr < Nn.O.length; ++Xr)
                                        Cr = Nn.O[Xr], ni = !!Cr.visibility, ei = nn.data, ji = ei.addNormalizedLandmark, di = Mn, Cr = Object.assign(Object.assign({}, Cr), { visibility: ni ? Cr.visibility : 0 }), ni = new hl(), li(ni, 1, Cr.x), li(ni, 2, Cr.y), li(ni, 3, Cr.z), Cr.visibility && li(ni, 4, Cr.visibility), Ri = Cr = new Ua(), Ts(Ri, 1, Zo(ni, 1)), Ts(Ri, 2, Zo(ni, 2)), Ts(Ri, 3, Zo(ni, 3)), Ts(Ri, 4, Zo(ni, 4)), Ts(Ri, 5, Zo(ni, 5)), jn(ni, Ri), Cr = Bs(Cr), ji.call(ei, di, Cr);
                                    if (Nn.M)
                                      for (Xr = 0; Xr < Nn.M.length; ++Xr) {
                                        if (ei = nn.data, ji = ei.addClassification, di = Mn, Cr = Nn.M[Xr], ni = new ra(), li(ni, 2, Cr.Y), Cr.index && li(ni, 1, Cr.index), Cr.label && li(ni, 3, Cr.label), Cr.displayName && li(ni, 4, Cr.displayName), Ri = Cr = new Ua(), Y = Zo(ni, 1), Y != null && Y != null)
                                          if (bo(Ri.g, 8), Ai = Ri.g, 0 <= Y)
                                            bo(Ai, Y);
                                          else {
                                            for (Ii = 0; 9 > Ii; Ii++)
                                              Ai.push(Y & 127 | 128), Y >>= 7;
                                            Ai.push(1);
                                          }
                                        Ts(Ri, 2, Zo(ni, 2)), Ai = Zo(ni, 3), Ai != null && (Ai = Hl(Ai), bo(Ri.g, 26), bo(Ri.g, Ai.length), go(Ri, Ri.g.end()), go(Ri, Ai)), Ai = Zo(ni, 4), Ai != null && (Ai = Hl(Ai), bo(Ri.g, 34), bo(Ri.g, Ai.length), go(Ri, Ri.g.end()), go(Ri, Ai)), jn(ni, Ri), Cr = Bs(Cr), ji.call(ei, di, Cr);
                                      }
                                  }
                                  nn = nn.data;
                                  break e;
                                default:
                                  nn = {};
                              }
                            }
                            switch (Fe = nn, Se = D.stream, D.type) {
                              case "video":
                                In.pushTexture2d(Object.assign(Object.assign({}, Fe), { stream: Se, timestamp: Ot }));
                                break;
                              case "detections":
                                it = Fe, it.stream = Se, it.timestamp = Ot, In.pushDetectionList(it);
                                break;
                              default:
                                throw Error("Unknown input config type: '" + D.type + "'");
                            }
                          }
                        return bt.i.send(In), Un(Gt, bt.C, 4);
                      case 4:
                        In.delete(), Gt.g = 0;
                    }
                  });
                });
              };
              function Wr(q, he, ve) {
                return fi(q, function bt() {
                  var Ot, In, en, Gn, dr, D, Fe = this, Se, it, Gt, nn, Pt, Mn, Nn, Xr;
                  return Go(bt, function(ei) {
                    switch (ei.g) {
                      case 1:
                        if (!ve)
                          return ei.return(he);
                        for (Ot = {}, In = 0, en = rt(Object.keys(ve)), Gn = en.next(); !Gn.done; Gn = en.next())
                          dr = Gn.value, D = ve[dr], typeof D != "string" && D.type === "texture" && he[D.stream] !== void 0 && ++In;
                        1 < In && (Fe.G = !1), Se = rt(Object.keys(ve)), Gn = Se.next();
                      case 2:
                        if (Gn.done) {
                          ei.g = 4;
                          break;
                        }
                        if (it = Gn.value, Gt = ve[it], typeof Gt == "string")
                          return Nn = Ot, Xr = it, Un(ei, ci(Fe, it, he[Gt]), 14);
                        if (nn = he[Gt.stream], Gt.type === "detection_list") {
                          if (nn) {
                            for (var ji = nn.getRectList(), di = nn.getLandmarksList(), Cr = nn.getClassificationsList(), ni = [], Ai = 0; Ai < ji.size(); ++Ai) {
                              var Ri = ji.get(Ai);
                              e: {
                                var Ii = new Os();
                                for (Ri = new fa(Ri); ss(Ri); )
                                  switch (Ri.i) {
                                    case 13:
                                      var Y = Ao(Ri);
                                      li(Ii, 1, Y);
                                      break;
                                    case 21:
                                      Y = Ao(Ri), li(Ii, 2, Y);
                                      break;
                                    case 29:
                                      Y = Ao(Ri), li(Ii, 3, Y);
                                      break;
                                    case 37:
                                      Y = Ao(Ri), li(Ii, 4, Y);
                                      break;
                                    case 45:
                                      Y = Ao(Ri), li(Ii, 5, Y);
                                      break;
                                    case 48:
                                      Y = Na(Ri.g), li(Ii, 6, Y);
                                      break;
                                    default:
                                      if (!hr(Ii, Ri))
                                        break e;
                                  }
                              }
                              Ii = { Z: Wi(Ii, 1), $: Wi(Ii, 2), height: Wi(Ii, 3), width: Wi(Ii, 4), rotation: Wi(Ii, 5, 0), X: na(Ii, 6, 0) }, Ri = is(Ps(di.get(Ai)), hl).map(nc);
                              var me = Cr.get(Ai);
                              e:
                                for (Y = new xs(), me = new fa(me); ss(me); )
                                  switch (me.i) {
                                    case 10:
                                      Y.addClassification(Pa(me, new ra(), ls));
                                      break;
                                    default:
                                      if (!hr(Y, me))
                                        break e;
                                  }
                              Ii = { T: Ii, O: Ri, M: Bl(Y) }, ni.push(Ii);
                            }
                            ji = ni;
                          } else
                            ji = [];
                          Ot[it] = ji, ei.g = 7;
                          break;
                        }
                        if (Gt.type === "proto_list") {
                          if (nn) {
                            for (ji = Array(nn.size()), di = 0; di < nn.size(); di++)
                              ji[di] = nn.get(di);
                            nn.delete();
                          } else
                            ji = [];
                          Ot[it] = ji, ei.g = 7;
                          break;
                        }
                        if (nn === void 0) {
                          ei.g = 3;
                          break;
                        }
                        if (Gt.type === "float_list") {
                          Ot[it] = nn, ei.g = 7;
                          break;
                        }
                        if (Gt.type === "proto") {
                          Ot[it] = nn, ei.g = 7;
                          break;
                        }
                        if (Gt.type !== "texture")
                          throw Error("Unknown output config type: '" + Gt.type + "'");
                        return Pt = Fe.s[it], Pt || (Pt = new Oc(Fe.h, Fe.D), Fe.s[it] = Pt), Un(ei, ol(Pt, nn, Fe.G), 13);
                      case 13:
                        Mn = ei.h, Ot[it] = Mn;
                      case 7:
                        Gt.transform && Ot[it] && (Ot[it] = Gt.transform(Ot[it])), ei.g = 3;
                        break;
                      case 14:
                        Nn[Xr] = ei.h;
                      case 3:
                        Gn = Se.next(), ei.g = 2;
                        break;
                      case 4:
                        return ei.return(Ot);
                    }
                  });
                });
              }
              function ci(q, he, ve) {
                return fi(q, function bt() {
                  var Ot = this, In;
                  return Go(bt, function(en) {
                    return typeof ve == "number" || ve instanceof Uint8Array || ve instanceof Ot.h.Uint8BlobList ? en.return(ve) : ve instanceof Ot.h.Texture2dDataOut ? (In = Ot.s[he], In || (In = new Oc(Ot.h, Ot.D), Ot.s[he] = In), en.return(ol(In, ve, Ot.G))) : en.return(void 0);
                  });
                });
              }
              function Ki(q, he) {
                for (var ve = he.name || "$", bt = [].concat(Nt(he.wants)), Ot = new q.h.StringList(), In = rt(he.wants), en = In.next(); !en.done; en = In.next())
                  Ot.push_back(en.value);
                In = q.h.PacketListener.implement({ onResults: function(Gn) {
                  for (var dr = {}, D = 0; D < he.wants.length; ++D)
                    dr[bt[D]] = Gn.get(D);
                  var Fe = q.listeners[ve];
                  Fe && (q.C = Wr(q, dr, he.outs).then(function(Se) {
                    Se = Fe(Se);
                    for (var it = 0; it < he.wants.length; ++it) {
                      var Gt = dr[bt[it]];
                      typeof Gt == "object" && Gt.hasOwnProperty && Gt.hasOwnProperty("delete") && Gt.delete();
                    }
                    Se && (q.C = Se);
                  }));
                } }), q.i.attachMultiListener(Ot, In), Ot.delete();
              }
              E.onResults = function(q, he) {
                this.listeners[he || "$"] = q;
              }, Ma("Solution", Ze), Ma("OptionType", { BOOL: 0, NUMBER: 1, aa: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function Gi(q) {
                q = Jc(q);
                var he = q.getMesh();
                if (!he)
                  return q;
                var ve = new Float32Array(he.getVertexBufferList());
                he.getVertexBufferList = function() {
                  return ve;
                };
                var bt = new Uint32Array(he.getIndexBufferList());
                return he.getIndexBufferList = function() {
                  return bt;
                }, q;
              }
              var yo = { files: [{ url: "face_mesh_solution_packed_assets_loader.js" }, { simd: !0, url: "face_mesh_solution_simd_wasm_bin.js" }, { simd: !1, url: "face_mesh_solution_wasm_bin.js" }], graph: { url: "face_mesh.binarypb" }, listeners: [{ wants: ["multi_face_geometry", "image_transformed", "multi_face_landmarks"], outs: { image: "image_transformed", multiFaceGeometry: { type: "proto_list", stream: "multi_face_geometry", transform: function(q) {
                return q.map(Gi);
              } }, multiFaceLandmarks: { type: "proto_list", stream: "multi_face_landmarks", transform: function(q) {
                return q.map(function(he) {
                  return is(
                    Ps(he),
                    hl
                  ).map(nc);
                });
              } } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: { useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document }, enableFaceGeometry: { type: 0, graphOptionXref: {
                calculatorName: "EnableFaceGeometryConstant",
                calculatorType: "ConstantSidePacketCalculator",
                fieldName: "bool_value"
              } }, selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } }, maxNumFaces: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorNumFaces", fieldName: "int_value" } }, refineLandmarks: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorRefineLandmarks", fieldName: "bool_value" } }, minDetectionConfidence: {
                type: 1,
                graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "facelandmarkfrontgpu__facedetectionshortrangegpu__facedetectionshortrangecommon__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" }
              }, minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "facelandmarkfrontgpu__facelandmarkgpu__ThresholdingCalculator", fieldName: "threshold" } }, cameraNear: { type: 1, graphOptionXref: {
                calculatorType: "FaceGeometryEnvGeneratorCalculator",
                fieldName: "near"
              } }, cameraFar: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "far" } }, cameraVerticalFovDegrees: { type: 1, graphOptionXref: { calculatorType: "FaceGeometryEnvGeneratorCalculator", fieldName: "vertical_fov_degrees" } } } }, Xi = [[61, 146], [146, 91], [91, 181], [181, 84], [84, 17], [17, 314], [314, 405], [405, 321], [321, 375], [375, 291], [61, 185], [185, 40], [40, 39], [39, 37], [37, 0], [0, 267], [267, 269], [269, 270], [270, 409], [409, 291], [78, 95], [95, 88], [88, 178], [178, 87], [87, 14], [14, 317], [317, 402], [402, 318], [318, 324], [324, 308], [78, 191], [191, 80], [80, 81], [81, 82], [82, 13], [13, 312], [312, 311], [311, 310], [310, 415], [415, 308]], vi = [[263, 249], [249, 390], [390, 373], [373, 374], [374, 380], [380, 381], [381, 382], [382, 362], [263, 466], [466, 388], [388, 387], [387, 386], [
                386,
                385
              ], [385, 384], [384, 398], [398, 362]], Yi = [[276, 283], [283, 282], [282, 295], [295, 285], [300, 293], [293, 334], [334, 296], [296, 336]], Fo = [[33, 7], [7, 163], [163, 144], [144, 145], [145, 153], [153, 154], [154, 155], [155, 133], [33, 246], [246, 161], [161, 160], [160, 159], [159, 158], [158, 157], [157, 173], [173, 133]], Lo = [[46, 53], [53, 52], [52, 65], [65, 55], [70, 63], [63, 105], [105, 66], [66, 107]], ia = [
                [10, 338],
                [338, 297],
                [297, 332],
                [332, 284],
                [284, 251],
                [251, 389],
                [389, 356],
                [356, 454],
                [454, 323],
                [323, 361],
                [361, 288],
                [288, 397],
                [397, 365],
                [365, 379],
                [379, 378],
                [378, 400],
                [400, 377],
                [377, 152],
                [152, 148],
                [148, 176],
                [176, 149],
                [149, 150],
                [150, 136],
                [136, 172],
                [172, 58],
                [58, 132],
                [132, 93],
                [93, 234],
                [234, 127],
                [127, 162],
                [162, 21],
                [21, 54],
                [54, 103],
                [103, 67],
                [67, 109],
                [109, 10]
              ], ha = [].concat(Nt(Xi), Nt(vi), Nt(Yi), Nt(Fo), Nt(Lo), Nt(ia));
              function ds(q) {
                q = q || {}, q = Object.assign(Object.assign({}, yo), q), this.g = new Ze(q);
              }
              E = ds.prototype, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(q) {
                this.g.onResults(q);
              }, E.initialize = function() {
                return fi(this, function q() {
                  var he = this;
                  return Go(q, function(ve) {
                    return Un(ve, he.g.initialize(), 0);
                  });
                });
              }, E.reset = function() {
                this.g.reset();
              }, E.send = function(q) {
                return fi(this, function he() {
                  var ve = this;
                  return Go(he, function(bt) {
                    return Un(bt, ve.g.send(q), 0);
                  });
                });
              }, E.setOptions = function(q) {
                this.g.setOptions(q);
              }, Ma("FACE_GEOMETRY", { Layout: { COLUMN_MAJOR: 0, ROW_MAJOR: 1, 0: "COLUMN_MAJOR", 1: "ROW_MAJOR" }, PrimitiveType: { TRIANGLE: 0, 0: "TRIANGLE" }, VertexType: { VERTEX_PT: 0, 0: "VERTEX_PT" }, DEFAULT_CAMERA_PARAMS: { verticalFovDegrees: 63, near: 1, far: 1e4 } }), Ma("FaceMesh", ds), Ma("FACEMESH_LIPS", Xi), Ma("FACEMESH_LEFT_EYE", vi), Ma("FACEMESH_LEFT_EYEBROW", Yi), Ma("FACEMESH_LEFT_IRIS", [[474, 475], [475, 476], [476, 477], [477, 474]]), Ma("FACEMESH_RIGHT_EYE", Fo), Ma("FACEMESH_RIGHT_EYEBROW", Lo), Ma("FACEMESH_RIGHT_IRIS", [[469, 470], [470, 471], [471, 472], [472, 469]]), Ma("FACEMESH_FACE_OVAL", ia), Ma("FACEMESH_CONTOURS", ha), Ma("FACEMESH_TESSELATION", [
                [127, 34],
                [34, 139],
                [139, 127],
                [11, 0],
                [0, 37],
                [37, 11],
                [232, 231],
                [231, 120],
                [120, 232],
                [72, 37],
                [37, 39],
                [39, 72],
                [128, 121],
                [121, 47],
                [47, 128],
                [232, 121],
                [121, 128],
                [128, 232],
                [104, 69],
                [69, 67],
                [67, 104],
                [175, 171],
                [171, 148],
                [148, 175],
                [118, 50],
                [50, 101],
                [101, 118],
                [73, 39],
                [39, 40],
                [40, 73],
                [9, 151],
                [151, 108],
                [108, 9],
                [48, 115],
                [115, 131],
                [131, 48],
                [194, 204],
                [204, 211],
                [211, 194],
                [74, 40],
                [40, 185],
                [185, 74],
                [80, 42],
                [42, 183],
                [183, 80],
                [40, 92],
                [92, 186],
                [186, 40],
                [230, 229],
                [229, 118],
                [118, 230],
                [202, 212],
                [
                  212,
                  214
                ],
                [214, 202],
                [83, 18],
                [18, 17],
                [17, 83],
                [76, 61],
                [61, 146],
                [146, 76],
                [160, 29],
                [29, 30],
                [30, 160],
                [56, 157],
                [157, 173],
                [173, 56],
                [106, 204],
                [204, 194],
                [194, 106],
                [135, 214],
                [214, 192],
                [192, 135],
                [203, 165],
                [165, 98],
                [98, 203],
                [21, 71],
                [71, 68],
                [68, 21],
                [51, 45],
                [45, 4],
                [4, 51],
                [144, 24],
                [24, 23],
                [23, 144],
                [77, 146],
                [146, 91],
                [91, 77],
                [205, 50],
                [50, 187],
                [187, 205],
                [201, 200],
                [200, 18],
                [18, 201],
                [91, 106],
                [106, 182],
                [182, 91],
                [90, 91],
                [91, 181],
                [181, 90],
                [85, 84],
                [84, 17],
                [17, 85],
                [206, 203],
                [203, 36],
                [36, 206],
                [148, 171],
                [171, 140],
                [140, 148],
                [
                  92,
                  40
                ],
                [40, 39],
                [39, 92],
                [193, 189],
                [189, 244],
                [244, 193],
                [159, 158],
                [158, 28],
                [28, 159],
                [247, 246],
                [246, 161],
                [161, 247],
                [236, 3],
                [3, 196],
                [196, 236],
                [54, 68],
                [68, 104],
                [104, 54],
                [193, 168],
                [168, 8],
                [8, 193],
                [117, 228],
                [228, 31],
                [31, 117],
                [189, 193],
                [193, 55],
                [55, 189],
                [98, 97],
                [97, 99],
                [99, 98],
                [126, 47],
                [47, 100],
                [100, 126],
                [166, 79],
                [79, 218],
                [218, 166],
                [155, 154],
                [154, 26],
                [26, 155],
                [209, 49],
                [49, 131],
                [131, 209],
                [135, 136],
                [136, 150],
                [150, 135],
                [47, 126],
                [126, 217],
                [217, 47],
                [223, 52],
                [52, 53],
                [53, 223],
                [45, 51],
                [51, 134],
                [134, 45],
                [211, 170],
                [
                  170,
                  140
                ],
                [140, 211],
                [67, 69],
                [69, 108],
                [108, 67],
                [43, 106],
                [106, 91],
                [91, 43],
                [230, 119],
                [119, 120],
                [120, 230],
                [226, 130],
                [130, 247],
                [247, 226],
                [63, 53],
                [53, 52],
                [52, 63],
                [238, 20],
                [20, 242],
                [242, 238],
                [46, 70],
                [70, 156],
                [156, 46],
                [78, 62],
                [62, 96],
                [96, 78],
                [46, 53],
                [53, 63],
                [63, 46],
                [143, 34],
                [34, 227],
                [227, 143],
                [123, 117],
                [117, 111],
                [111, 123],
                [44, 125],
                [125, 19],
                [19, 44],
                [236, 134],
                [134, 51],
                [51, 236],
                [216, 206],
                [206, 205],
                [205, 216],
                [154, 153],
                [153, 22],
                [22, 154],
                [39, 37],
                [37, 167],
                [167, 39],
                [200, 201],
                [201, 208],
                [208, 200],
                [36, 142],
                [142, 100],
                [
                  100,
                  36
                ],
                [57, 212],
                [212, 202],
                [202, 57],
                [20, 60],
                [60, 99],
                [99, 20],
                [28, 158],
                [158, 157],
                [157, 28],
                [35, 226],
                [226, 113],
                [113, 35],
                [160, 159],
                [159, 27],
                [27, 160],
                [204, 202],
                [202, 210],
                [210, 204],
                [113, 225],
                [225, 46],
                [46, 113],
                [43, 202],
                [202, 204],
                [204, 43],
                [62, 76],
                [76, 77],
                [77, 62],
                [137, 123],
                [123, 116],
                [116, 137],
                [41, 38],
                [38, 72],
                [72, 41],
                [203, 129],
                [129, 142],
                [142, 203],
                [64, 98],
                [98, 240],
                [240, 64],
                [49, 102],
                [102, 64],
                [64, 49],
                [41, 73],
                [73, 74],
                [74, 41],
                [212, 216],
                [216, 207],
                [207, 212],
                [42, 74],
                [74, 184],
                [184, 42],
                [169, 170],
                [170, 211],
                [211, 169],
                [
                  170,
                  149
                ],
                [149, 176],
                [176, 170],
                [105, 66],
                [66, 69],
                [69, 105],
                [122, 6],
                [6, 168],
                [168, 122],
                [123, 147],
                [147, 187],
                [187, 123],
                [96, 77],
                [77, 90],
                [90, 96],
                [65, 55],
                [55, 107],
                [107, 65],
                [89, 90],
                [90, 180],
                [180, 89],
                [101, 100],
                [100, 120],
                [120, 101],
                [63, 105],
                [105, 104],
                [104, 63],
                [93, 137],
                [137, 227],
                [227, 93],
                [15, 86],
                [86, 85],
                [85, 15],
                [129, 102],
                [102, 49],
                [49, 129],
                [14, 87],
                [87, 86],
                [86, 14],
                [55, 8],
                [8, 9],
                [9, 55],
                [100, 47],
                [47, 121],
                [121, 100],
                [145, 23],
                [23, 22],
                [22, 145],
                [88, 89],
                [89, 179],
                [179, 88],
                [6, 122],
                [122, 196],
                [196, 6],
                [88, 95],
                [95, 96],
                [96, 88],
                [138, 172],
                [172, 136],
                [136, 138],
                [215, 58],
                [58, 172],
                [172, 215],
                [115, 48],
                [48, 219],
                [219, 115],
                [42, 80],
                [80, 81],
                [81, 42],
                [195, 3],
                [3, 51],
                [51, 195],
                [43, 146],
                [146, 61],
                [61, 43],
                [171, 175],
                [175, 199],
                [199, 171],
                [81, 82],
                [82, 38],
                [38, 81],
                [53, 46],
                [46, 225],
                [225, 53],
                [144, 163],
                [163, 110],
                [110, 144],
                [52, 65],
                [65, 66],
                [66, 52],
                [229, 228],
                [228, 117],
                [117, 229],
                [34, 127],
                [127, 234],
                [234, 34],
                [107, 108],
                [108, 69],
                [69, 107],
                [109, 108],
                [108, 151],
                [151, 109],
                [48, 64],
                [64, 235],
                [235, 48],
                [62, 78],
                [78, 191],
                [191, 62],
                [129, 209],
                [209, 126],
                [126, 129],
                [111, 35],
                [35, 143],
                [
                  143,
                  111
                ],
                [117, 123],
                [123, 50],
                [50, 117],
                [222, 65],
                [65, 52],
                [52, 222],
                [19, 125],
                [125, 141],
                [141, 19],
                [221, 55],
                [55, 65],
                [65, 221],
                [3, 195],
                [195, 197],
                [197, 3],
                [25, 7],
                [7, 33],
                [33, 25],
                [220, 237],
                [237, 44],
                [44, 220],
                [70, 71],
                [71, 139],
                [139, 70],
                [122, 193],
                [193, 245],
                [245, 122],
                [247, 130],
                [130, 33],
                [33, 247],
                [71, 21],
                [21, 162],
                [162, 71],
                [170, 169],
                [169, 150],
                [150, 170],
                [188, 174],
                [174, 196],
                [196, 188],
                [216, 186],
                [186, 92],
                [92, 216],
                [2, 97],
                [97, 167],
                [167, 2],
                [141, 125],
                [125, 241],
                [241, 141],
                [164, 167],
                [167, 37],
                [37, 164],
                [72, 38],
                [38, 12],
                [12, 72],
                [38, 82],
                [82, 13],
                [13, 38],
                [63, 68],
                [68, 71],
                [71, 63],
                [226, 35],
                [35, 111],
                [111, 226],
                [101, 50],
                [50, 205],
                [205, 101],
                [206, 92],
                [92, 165],
                [165, 206],
                [209, 198],
                [198, 217],
                [217, 209],
                [165, 167],
                [167, 97],
                [97, 165],
                [220, 115],
                [115, 218],
                [218, 220],
                [133, 112],
                [112, 243],
                [243, 133],
                [239, 238],
                [238, 241],
                [241, 239],
                [214, 135],
                [135, 169],
                [169, 214],
                [190, 173],
                [173, 133],
                [133, 190],
                [171, 208],
                [208, 32],
                [32, 171],
                [125, 44],
                [44, 237],
                [237, 125],
                [86, 87],
                [87, 178],
                [178, 86],
                [85, 86],
                [86, 179],
                [179, 85],
                [84, 85],
                [85, 180],
                [180, 84],
                [83, 84],
                [84, 181],
                [181, 83],
                [201, 83],
                [83, 182],
                [182, 201],
                [137, 93],
                [93, 132],
                [132, 137],
                [76, 62],
                [62, 183],
                [183, 76],
                [61, 76],
                [76, 184],
                [184, 61],
                [57, 61],
                [61, 185],
                [185, 57],
                [212, 57],
                [57, 186],
                [186, 212],
                [214, 207],
                [207, 187],
                [187, 214],
                [34, 143],
                [143, 156],
                [156, 34],
                [79, 239],
                [239, 237],
                [237, 79],
                [123, 137],
                [137, 177],
                [177, 123],
                [44, 1],
                [1, 4],
                [4, 44],
                [201, 194],
                [194, 32],
                [32, 201],
                [64, 102],
                [102, 129],
                [129, 64],
                [213, 215],
                [215, 138],
                [138, 213],
                [59, 166],
                [166, 219],
                [219, 59],
                [242, 99],
                [99, 97],
                [97, 242],
                [2, 94],
                [94, 141],
                [141, 2],
                [75, 59],
                [59, 235],
                [235, 75],
                [24, 110],
                [110, 228],
                [
                  228,
                  24
                ],
                [25, 130],
                [130, 226],
                [226, 25],
                [23, 24],
                [24, 229],
                [229, 23],
                [22, 23],
                [23, 230],
                [230, 22],
                [26, 22],
                [22, 231],
                [231, 26],
                [112, 26],
                [26, 232],
                [232, 112],
                [189, 190],
                [190, 243],
                [243, 189],
                [221, 56],
                [56, 190],
                [190, 221],
                [28, 56],
                [56, 221],
                [221, 28],
                [27, 28],
                [28, 222],
                [222, 27],
                [29, 27],
                [27, 223],
                [223, 29],
                [30, 29],
                [29, 224],
                [224, 30],
                [247, 30],
                [30, 225],
                [225, 247],
                [238, 79],
                [79, 20],
                [20, 238],
                [166, 59],
                [59, 75],
                [75, 166],
                [60, 75],
                [75, 240],
                [240, 60],
                [147, 177],
                [177, 215],
                [215, 147],
                [20, 79],
                [79, 166],
                [166, 20],
                [187, 147],
                [147, 213],
                [213, 187],
                [112, 233],
                [233, 244],
                [244, 112],
                [233, 128],
                [128, 245],
                [245, 233],
                [128, 114],
                [114, 188],
                [188, 128],
                [114, 217],
                [217, 174],
                [174, 114],
                [131, 115],
                [115, 220],
                [220, 131],
                [217, 198],
                [198, 236],
                [236, 217],
                [198, 131],
                [131, 134],
                [134, 198],
                [177, 132],
                [132, 58],
                [58, 177],
                [143, 35],
                [35, 124],
                [124, 143],
                [110, 163],
                [163, 7],
                [7, 110],
                [228, 110],
                [110, 25],
                [25, 228],
                [356, 389],
                [389, 368],
                [368, 356],
                [11, 302],
                [302, 267],
                [267, 11],
                [452, 350],
                [350, 349],
                [349, 452],
                [302, 303],
                [303, 269],
                [269, 302],
                [357, 343],
                [343, 277],
                [277, 357],
                [452, 453],
                [453, 357],
                [357, 452],
                [333, 332],
                [
                  332,
                  297
                ],
                [297, 333],
                [175, 152],
                [152, 377],
                [377, 175],
                [347, 348],
                [348, 330],
                [330, 347],
                [303, 304],
                [304, 270],
                [270, 303],
                [9, 336],
                [336, 337],
                [337, 9],
                [278, 279],
                [279, 360],
                [360, 278],
                [418, 262],
                [262, 431],
                [431, 418],
                [304, 408],
                [408, 409],
                [409, 304],
                [310, 415],
                [415, 407],
                [407, 310],
                [270, 409],
                [409, 410],
                [410, 270],
                [450, 348],
                [348, 347],
                [347, 450],
                [422, 430],
                [430, 434],
                [434, 422],
                [313, 314],
                [314, 17],
                [17, 313],
                [306, 307],
                [307, 375],
                [375, 306],
                [387, 388],
                [388, 260],
                [260, 387],
                [286, 414],
                [414, 398],
                [398, 286],
                [335, 406],
                [406, 418],
                [418, 335],
                [364, 367],
                [
                  367,
                  416
                ],
                [416, 364],
                [423, 358],
                [358, 327],
                [327, 423],
                [251, 284],
                [284, 298],
                [298, 251],
                [281, 5],
                [5, 4],
                [4, 281],
                [373, 374],
                [374, 253],
                [253, 373],
                [307, 320],
                [320, 321],
                [321, 307],
                [425, 427],
                [427, 411],
                [411, 425],
                [421, 313],
                [313, 18],
                [18, 421],
                [321, 405],
                [405, 406],
                [406, 321],
                [320, 404],
                [404, 405],
                [405, 320],
                [315, 16],
                [16, 17],
                [17, 315],
                [426, 425],
                [425, 266],
                [266, 426],
                [377, 400],
                [400, 369],
                [369, 377],
                [322, 391],
                [391, 269],
                [269, 322],
                [417, 465],
                [465, 464],
                [464, 417],
                [386, 257],
                [257, 258],
                [258, 386],
                [466, 260],
                [260, 388],
                [388, 466],
                [456, 399],
                [399, 419],
                [419, 456],
                [284, 332],
                [332, 333],
                [333, 284],
                [417, 285],
                [285, 8],
                [8, 417],
                [346, 340],
                [340, 261],
                [261, 346],
                [413, 441],
                [441, 285],
                [285, 413],
                [327, 460],
                [460, 328],
                [328, 327],
                [355, 371],
                [371, 329],
                [329, 355],
                [392, 439],
                [439, 438],
                [438, 392],
                [382, 341],
                [341, 256],
                [256, 382],
                [429, 420],
                [420, 360],
                [360, 429],
                [364, 394],
                [394, 379],
                [379, 364],
                [277, 343],
                [343, 437],
                [437, 277],
                [443, 444],
                [444, 283],
                [283, 443],
                [275, 440],
                [440, 363],
                [363, 275],
                [431, 262],
                [262, 369],
                [369, 431],
                [297, 338],
                [338, 337],
                [337, 297],
                [273, 375],
                [375, 321],
                [321, 273],
                [450, 451],
                [
                  451,
                  349
                ],
                [349, 450],
                [446, 342],
                [342, 467],
                [467, 446],
                [293, 334],
                [334, 282],
                [282, 293],
                [458, 461],
                [461, 462],
                [462, 458],
                [276, 353],
                [353, 383],
                [383, 276],
                [308, 324],
                [324, 325],
                [325, 308],
                [276, 300],
                [300, 293],
                [293, 276],
                [372, 345],
                [345, 447],
                [447, 372],
                [352, 345],
                [345, 340],
                [340, 352],
                [274, 1],
                [1, 19],
                [19, 274],
                [456, 248],
                [248, 281],
                [281, 456],
                [436, 427],
                [427, 425],
                [425, 436],
                [381, 256],
                [256, 252],
                [252, 381],
                [269, 391],
                [391, 393],
                [393, 269],
                [200, 199],
                [199, 428],
                [428, 200],
                [266, 330],
                [330, 329],
                [329, 266],
                [287, 273],
                [273, 422],
                [422, 287],
                [250, 462],
                [
                  462,
                  328
                ],
                [328, 250],
                [258, 286],
                [286, 384],
                [384, 258],
                [265, 353],
                [353, 342],
                [342, 265],
                [387, 259],
                [259, 257],
                [257, 387],
                [424, 431],
                [431, 430],
                [430, 424],
                [342, 353],
                [353, 276],
                [276, 342],
                [273, 335],
                [335, 424],
                [424, 273],
                [292, 325],
                [325, 307],
                [307, 292],
                [366, 447],
                [447, 345],
                [345, 366],
                [271, 303],
                [303, 302],
                [302, 271],
                [423, 266],
                [266, 371],
                [371, 423],
                [294, 455],
                [455, 460],
                [460, 294],
                [279, 278],
                [278, 294],
                [294, 279],
                [271, 272],
                [272, 304],
                [304, 271],
                [432, 434],
                [434, 427],
                [427, 432],
                [272, 407],
                [407, 408],
                [408, 272],
                [394, 430],
                [430, 431],
                [431, 394],
                [395, 369],
                [369, 400],
                [400, 395],
                [334, 333],
                [333, 299],
                [299, 334],
                [351, 417],
                [417, 168],
                [168, 351],
                [352, 280],
                [280, 411],
                [411, 352],
                [325, 319],
                [319, 320],
                [320, 325],
                [295, 296],
                [296, 336],
                [336, 295],
                [319, 403],
                [403, 404],
                [404, 319],
                [330, 348],
                [348, 349],
                [349, 330],
                [293, 298],
                [298, 333],
                [333, 293],
                [323, 454],
                [454, 447],
                [447, 323],
                [15, 16],
                [16, 315],
                [315, 15],
                [358, 429],
                [429, 279],
                [279, 358],
                [14, 15],
                [15, 316],
                [316, 14],
                [285, 336],
                [336, 9],
                [9, 285],
                [329, 349],
                [349, 350],
                [350, 329],
                [374, 380],
                [380, 252],
                [252, 374],
                [318, 402],
                [402, 403],
                [403, 318],
                [6, 197],
                [
                  197,
                  419
                ],
                [419, 6],
                [318, 319],
                [319, 325],
                [325, 318],
                [367, 364],
                [364, 365],
                [365, 367],
                [435, 367],
                [367, 397],
                [397, 435],
                [344, 438],
                [438, 439],
                [439, 344],
                [272, 271],
                [271, 311],
                [311, 272],
                [195, 5],
                [5, 281],
                [281, 195],
                [273, 287],
                [287, 291],
                [291, 273],
                [396, 428],
                [428, 199],
                [199, 396],
                [311, 271],
                [271, 268],
                [268, 311],
                [283, 444],
                [444, 445],
                [445, 283],
                [373, 254],
                [254, 339],
                [339, 373],
                [282, 334],
                [334, 296],
                [296, 282],
                [449, 347],
                [347, 346],
                [346, 449],
                [264, 447],
                [447, 454],
                [454, 264],
                [336, 296],
                [296, 299],
                [299, 336],
                [338, 10],
                [10, 151],
                [151, 338],
                [278, 439],
                [
                  439,
                  455
                ],
                [455, 278],
                [292, 407],
                [407, 415],
                [415, 292],
                [358, 371],
                [371, 355],
                [355, 358],
                [340, 345],
                [345, 372],
                [372, 340],
                [346, 347],
                [347, 280],
                [280, 346],
                [442, 443],
                [443, 282],
                [282, 442],
                [19, 94],
                [94, 370],
                [370, 19],
                [441, 442],
                [442, 295],
                [295, 441],
                [248, 419],
                [419, 197],
                [197, 248],
                [263, 255],
                [255, 359],
                [359, 263],
                [440, 275],
                [275, 274],
                [274, 440],
                [300, 383],
                [383, 368],
                [368, 300],
                [351, 412],
                [412, 465],
                [465, 351],
                [263, 467],
                [467, 466],
                [466, 263],
                [301, 368],
                [368, 389],
                [389, 301],
                [395, 378],
                [378, 379],
                [379, 395],
                [412, 351],
                [351, 419],
                [419, 412],
                [436, 426],
                [426, 322],
                [322, 436],
                [2, 164],
                [164, 393],
                [393, 2],
                [370, 462],
                [462, 461],
                [461, 370],
                [164, 0],
                [0, 267],
                [267, 164],
                [302, 11],
                [11, 12],
                [12, 302],
                [268, 12],
                [12, 13],
                [13, 268],
                [293, 300],
                [300, 301],
                [301, 293],
                [446, 261],
                [261, 340],
                [340, 446],
                [330, 266],
                [266, 425],
                [425, 330],
                [426, 423],
                [423, 391],
                [391, 426],
                [429, 355],
                [355, 437],
                [437, 429],
                [391, 327],
                [327, 326],
                [326, 391],
                [440, 457],
                [457, 438],
                [438, 440],
                [341, 382],
                [382, 362],
                [362, 341],
                [459, 457],
                [457, 461],
                [461, 459],
                [434, 430],
                [430, 394],
                [394, 434],
                [414, 463],
                [463, 362],
                [362, 414],
                [396, 369],
                [369, 262],
                [262, 396],
                [354, 461],
                [461, 457],
                [457, 354],
                [316, 403],
                [403, 402],
                [402, 316],
                [315, 404],
                [404, 403],
                [403, 315],
                [314, 405],
                [405, 404],
                [404, 314],
                [313, 406],
                [406, 405],
                [405, 313],
                [421, 418],
                [418, 406],
                [406, 421],
                [366, 401],
                [401, 361],
                [361, 366],
                [306, 408],
                [408, 407],
                [407, 306],
                [291, 409],
                [409, 408],
                [408, 291],
                [287, 410],
                [410, 409],
                [409, 287],
                [432, 436],
                [436, 410],
                [410, 432],
                [434, 416],
                [416, 411],
                [411, 434],
                [264, 368],
                [368, 383],
                [383, 264],
                [309, 438],
                [438, 457],
                [457, 309],
                [352, 376],
                [376, 401],
                [401, 352],
                [274, 275],
                [275, 4],
                [4, 274],
                [421, 428],
                [
                  428,
                  262
                ],
                [262, 421],
                [294, 327],
                [327, 358],
                [358, 294],
                [433, 416],
                [416, 367],
                [367, 433],
                [289, 455],
                [455, 439],
                [439, 289],
                [462, 370],
                [370, 326],
                [326, 462],
                [2, 326],
                [326, 370],
                [370, 2],
                [305, 460],
                [460, 455],
                [455, 305],
                [254, 449],
                [449, 448],
                [448, 254],
                [255, 261],
                [261, 446],
                [446, 255],
                [253, 450],
                [450, 449],
                [449, 253],
                [252, 451],
                [451, 450],
                [450, 252],
                [256, 452],
                [452, 451],
                [451, 256],
                [341, 453],
                [453, 452],
                [452, 341],
                [413, 464],
                [464, 463],
                [463, 413],
                [441, 413],
                [413, 414],
                [414, 441],
                [258, 442],
                [442, 441],
                [441, 258],
                [257, 443],
                [443, 442],
                [442, 257],
                [259, 444],
                [444, 443],
                [443, 259],
                [260, 445],
                [445, 444],
                [444, 260],
                [467, 342],
                [342, 445],
                [445, 467],
                [459, 458],
                [458, 250],
                [250, 459],
                [289, 392],
                [392, 290],
                [290, 289],
                [290, 328],
                [328, 460],
                [460, 290],
                [376, 433],
                [433, 435],
                [435, 376],
                [250, 290],
                [290, 392],
                [392, 250],
                [411, 416],
                [416, 433],
                [433, 411],
                [341, 463],
                [463, 464],
                [464, 341],
                [453, 464],
                [464, 465],
                [465, 453],
                [357, 465],
                [465, 412],
                [412, 357],
                [343, 412],
                [412, 399],
                [399, 343],
                [360, 363],
                [363, 440],
                [440, 360],
                [437, 399],
                [399, 456],
                [456, 437],
                [420, 456],
                [456, 363],
                [363, 420],
                [401, 435],
                [435, 288],
                [288, 401],
                [
                  372,
                  383
                ],
                [383, 353],
                [353, 372],
                [339, 255],
                [255, 249],
                [249, 339],
                [448, 261],
                [261, 255],
                [255, 448],
                [133, 243],
                [243, 190],
                [190, 133],
                [133, 155],
                [155, 112],
                [112, 133],
                [33, 246],
                [246, 247],
                [247, 33],
                [33, 130],
                [130, 25],
                [25, 33],
                [398, 384],
                [384, 286],
                [286, 398],
                [362, 398],
                [398, 414],
                [414, 362],
                [362, 463],
                [463, 341],
                [341, 362],
                [263, 359],
                [359, 467],
                [467, 263],
                [263, 249],
                [249, 255],
                [255, 263],
                [466, 467],
                [467, 260],
                [260, 466],
                [75, 60],
                [60, 166],
                [166, 75],
                [238, 239],
                [239, 79],
                [79, 238],
                [162, 127],
                [127, 139],
                [139, 162],
                [72, 11],
                [11, 37],
                [37, 72],
                [121, 232],
                [
                  232,
                  120
                ],
                [120, 121],
                [73, 72],
                [72, 39],
                [39, 73],
                [114, 128],
                [128, 47],
                [47, 114],
                [233, 232],
                [232, 128],
                [128, 233],
                [103, 104],
                [104, 67],
                [67, 103],
                [152, 175],
                [175, 148],
                [148, 152],
                [119, 118],
                [118, 101],
                [101, 119],
                [74, 73],
                [73, 40],
                [40, 74],
                [107, 9],
                [9, 108],
                [108, 107],
                [49, 48],
                [48, 131],
                [131, 49],
                [32, 194],
                [194, 211],
                [211, 32],
                [184, 74],
                [74, 185],
                [185, 184],
                [191, 80],
                [80, 183],
                [183, 191],
                [185, 40],
                [40, 186],
                [186, 185],
                [119, 230],
                [230, 118],
                [118, 119],
                [210, 202],
                [202, 214],
                [214, 210],
                [84, 83],
                [83, 17],
                [17, 84],
                [77, 76],
                [76, 146],
                [146, 77],
                [161, 160],
                [160, 30],
                [30, 161],
                [190, 56],
                [56, 173],
                [173, 190],
                [182, 106],
                [106, 194],
                [194, 182],
                [138, 135],
                [135, 192],
                [192, 138],
                [129, 203],
                [203, 98],
                [98, 129],
                [54, 21],
                [21, 68],
                [68, 54],
                [5, 51],
                [51, 4],
                [4, 5],
                [145, 144],
                [144, 23],
                [23, 145],
                [90, 77],
                [77, 91],
                [91, 90],
                [207, 205],
                [205, 187],
                [187, 207],
                [83, 201],
                [201, 18],
                [18, 83],
                [181, 91],
                [91, 182],
                [182, 181],
                [180, 90],
                [90, 181],
                [181, 180],
                [16, 85],
                [85, 17],
                [17, 16],
                [205, 206],
                [206, 36],
                [36, 205],
                [176, 148],
                [148, 140],
                [140, 176],
                [165, 92],
                [92, 39],
                [39, 165],
                [245, 193],
                [193, 244],
                [244, 245],
                [27, 159],
                [159, 28],
                [28, 27],
                [
                  30,
                  247
                ],
                [247, 161],
                [161, 30],
                [174, 236],
                [236, 196],
                [196, 174],
                [103, 54],
                [54, 104],
                [104, 103],
                [55, 193],
                [193, 8],
                [8, 55],
                [111, 117],
                [117, 31],
                [31, 111],
                [221, 189],
                [189, 55],
                [55, 221],
                [240, 98],
                [98, 99],
                [99, 240],
                [142, 126],
                [126, 100],
                [100, 142],
                [219, 166],
                [166, 218],
                [218, 219],
                [112, 155],
                [155, 26],
                [26, 112],
                [198, 209],
                [209, 131],
                [131, 198],
                [169, 135],
                [135, 150],
                [150, 169],
                [114, 47],
                [47, 217],
                [217, 114],
                [224, 223],
                [223, 53],
                [53, 224],
                [220, 45],
                [45, 134],
                [134, 220],
                [32, 211],
                [211, 140],
                [140, 32],
                [109, 67],
                [67, 108],
                [108, 109],
                [146, 43],
                [43, 91],
                [91, 146],
                [231, 230],
                [230, 120],
                [120, 231],
                [113, 226],
                [226, 247],
                [247, 113],
                [105, 63],
                [63, 52],
                [52, 105],
                [241, 238],
                [238, 242],
                [242, 241],
                [124, 46],
                [46, 156],
                [156, 124],
                [95, 78],
                [78, 96],
                [96, 95],
                [70, 46],
                [46, 63],
                [63, 70],
                [116, 143],
                [143, 227],
                [227, 116],
                [116, 123],
                [123, 111],
                [111, 116],
                [1, 44],
                [44, 19],
                [19, 1],
                [3, 236],
                [236, 51],
                [51, 3],
                [207, 216],
                [216, 205],
                [205, 207],
                [26, 154],
                [154, 22],
                [22, 26],
                [165, 39],
                [39, 167],
                [167, 165],
                [199, 200],
                [200, 208],
                [208, 199],
                [101, 36],
                [36, 100],
                [100, 101],
                [43, 57],
                [57, 202],
                [202, 43],
                [242, 20],
                [20, 99],
                [99, 242],
                [56, 28],
                [
                  28,
                  157
                ],
                [157, 56],
                [124, 35],
                [35, 113],
                [113, 124],
                [29, 160],
                [160, 27],
                [27, 29],
                [211, 204],
                [204, 210],
                [210, 211],
                [124, 113],
                [113, 46],
                [46, 124],
                [106, 43],
                [43, 204],
                [204, 106],
                [96, 62],
                [62, 77],
                [77, 96],
                [227, 137],
                [137, 116],
                [116, 227],
                [73, 41],
                [41, 72],
                [72, 73],
                [36, 203],
                [203, 142],
                [142, 36],
                [235, 64],
                [64, 240],
                [240, 235],
                [48, 49],
                [49, 64],
                [64, 48],
                [42, 41],
                [41, 74],
                [74, 42],
                [214, 212],
                [212, 207],
                [207, 214],
                [183, 42],
                [42, 184],
                [184, 183],
                [210, 169],
                [169, 211],
                [211, 210],
                [140, 170],
                [170, 176],
                [176, 140],
                [104, 105],
                [105, 69],
                [69, 104],
                [193, 122],
                [122, 168],
                [168, 193],
                [50, 123],
                [123, 187],
                [187, 50],
                [89, 96],
                [96, 90],
                [90, 89],
                [66, 65],
                [65, 107],
                [107, 66],
                [179, 89],
                [89, 180],
                [180, 179],
                [119, 101],
                [101, 120],
                [120, 119],
                [68, 63],
                [63, 104],
                [104, 68],
                [234, 93],
                [93, 227],
                [227, 234],
                [16, 15],
                [15, 85],
                [85, 16],
                [209, 129],
                [129, 49],
                [49, 209],
                [15, 14],
                [14, 86],
                [86, 15],
                [107, 55],
                [55, 9],
                [9, 107],
                [120, 100],
                [100, 121],
                [121, 120],
                [153, 145],
                [145, 22],
                [22, 153],
                [178, 88],
                [88, 179],
                [179, 178],
                [197, 6],
                [6, 196],
                [196, 197],
                [89, 88],
                [88, 96],
                [96, 89],
                [135, 138],
                [138, 136],
                [136, 135],
                [138, 215],
                [215, 172],
                [172, 138],
                [
                  218,
                  115
                ],
                [115, 219],
                [219, 218],
                [41, 42],
                [42, 81],
                [81, 41],
                [5, 195],
                [195, 51],
                [51, 5],
                [57, 43],
                [43, 61],
                [61, 57],
                [208, 171],
                [171, 199],
                [199, 208],
                [41, 81],
                [81, 38],
                [38, 41],
                [224, 53],
                [53, 225],
                [225, 224],
                [24, 144],
                [144, 110],
                [110, 24],
                [105, 52],
                [52, 66],
                [66, 105],
                [118, 229],
                [229, 117],
                [117, 118],
                [227, 34],
                [34, 234],
                [234, 227],
                [66, 107],
                [107, 69],
                [69, 66],
                [10, 109],
                [109, 151],
                [151, 10],
                [219, 48],
                [48, 235],
                [235, 219],
                [183, 62],
                [62, 191],
                [191, 183],
                [142, 129],
                [129, 126],
                [126, 142],
                [116, 111],
                [111, 143],
                [143, 116],
                [118, 117],
                [117, 50],
                [50, 118],
                [223, 222],
                [
                  222,
                  52
                ],
                [52, 223],
                [94, 19],
                [19, 141],
                [141, 94],
                [222, 221],
                [221, 65],
                [65, 222],
                [196, 3],
                [3, 197],
                [197, 196],
                [45, 220],
                [220, 44],
                [44, 45],
                [156, 70],
                [70, 139],
                [139, 156],
                [188, 122],
                [122, 245],
                [245, 188],
                [139, 71],
                [71, 162],
                [162, 139],
                [149, 170],
                [170, 150],
                [150, 149],
                [122, 188],
                [188, 196],
                [196, 122],
                [206, 216],
                [216, 92],
                [92, 206],
                [164, 2],
                [2, 167],
                [167, 164],
                [242, 141],
                [141, 241],
                [241, 242],
                [0, 164],
                [164, 37],
                [37, 0],
                [11, 72],
                [72, 12],
                [12, 11],
                [12, 38],
                [38, 13],
                [13, 12],
                [70, 63],
                [63, 71],
                [71, 70],
                [31, 226],
                [226, 111],
                [111, 31],
                [36, 101],
                [101, 205],
                [205, 36],
                [203, 206],
                [206, 165],
                [165, 203],
                [126, 209],
                [209, 217],
                [217, 126],
                [98, 165],
                [165, 97],
                [97, 98],
                [237, 220],
                [220, 218],
                [218, 237],
                [237, 239],
                [239, 241],
                [241, 237],
                [210, 214],
                [214, 169],
                [169, 210],
                [140, 171],
                [171, 32],
                [32, 140],
                [241, 125],
                [125, 237],
                [237, 241],
                [179, 86],
                [86, 178],
                [178, 179],
                [180, 85],
                [85, 179],
                [179, 180],
                [181, 84],
                [84, 180],
                [180, 181],
                [182, 83],
                [83, 181],
                [181, 182],
                [194, 201],
                [201, 182],
                [182, 194],
                [177, 137],
                [137, 132],
                [132, 177],
                [184, 76],
                [76, 183],
                [183, 184],
                [185, 61],
                [61, 184],
                [184, 185],
                [186, 57],
                [57, 185],
                [185, 186],
                [216, 212],
                [
                  212,
                  186
                ],
                [186, 216],
                [192, 214],
                [214, 187],
                [187, 192],
                [139, 34],
                [34, 156],
                [156, 139],
                [218, 79],
                [79, 237],
                [237, 218],
                [147, 123],
                [123, 177],
                [177, 147],
                [45, 44],
                [44, 4],
                [4, 45],
                [208, 201],
                [201, 32],
                [32, 208],
                [98, 64],
                [64, 129],
                [129, 98],
                [192, 213],
                [213, 138],
                [138, 192],
                [235, 59],
                [59, 219],
                [219, 235],
                [141, 242],
                [242, 97],
                [97, 141],
                [97, 2],
                [2, 141],
                [141, 97],
                [240, 75],
                [75, 235],
                [235, 240],
                [229, 24],
                [24, 228],
                [228, 229],
                [31, 25],
                [25, 226],
                [226, 31],
                [230, 23],
                [23, 229],
                [229, 230],
                [231, 22],
                [22, 230],
                [230, 231],
                [232, 26],
                [26, 231],
                [231, 232],
                [233, 112],
                [112, 232],
                [232, 233],
                [244, 189],
                [189, 243],
                [243, 244],
                [189, 221],
                [221, 190],
                [190, 189],
                [222, 28],
                [28, 221],
                [221, 222],
                [223, 27],
                [27, 222],
                [222, 223],
                [224, 29],
                [29, 223],
                [223, 224],
                [225, 30],
                [30, 224],
                [224, 225],
                [113, 247],
                [247, 225],
                [225, 113],
                [99, 60],
                [60, 240],
                [240, 99],
                [213, 147],
                [147, 215],
                [215, 213],
                [60, 20],
                [20, 166],
                [166, 60],
                [192, 187],
                [187, 213],
                [213, 192],
                [243, 112],
                [112, 244],
                [244, 243],
                [244, 233],
                [233, 245],
                [245, 244],
                [245, 128],
                [128, 188],
                [188, 245],
                [188, 114],
                [114, 174],
                [174, 188],
                [134, 131],
                [131, 220],
                [220, 134],
                [174, 217],
                [217, 236],
                [236, 174],
                [236, 198],
                [198, 134],
                [134, 236],
                [215, 177],
                [177, 58],
                [58, 215],
                [156, 143],
                [143, 124],
                [124, 156],
                [25, 110],
                [110, 7],
                [7, 25],
                [31, 228],
                [228, 25],
                [25, 31],
                [264, 356],
                [356, 368],
                [368, 264],
                [0, 11],
                [11, 267],
                [267, 0],
                [451, 452],
                [452, 349],
                [349, 451],
                [267, 302],
                [302, 269],
                [269, 267],
                [350, 357],
                [357, 277],
                [277, 350],
                [350, 452],
                [452, 357],
                [357, 350],
                [299, 333],
                [333, 297],
                [297, 299],
                [396, 175],
                [175, 377],
                [377, 396],
                [280, 347],
                [347, 330],
                [330, 280],
                [269, 303],
                [303, 270],
                [270, 269],
                [151, 9],
                [9, 337],
                [337, 151],
                [344, 278],
                [278, 360],
                [360, 344],
                [424, 418],
                [
                  418,
                  431
                ],
                [431, 424],
                [270, 304],
                [304, 409],
                [409, 270],
                [272, 310],
                [310, 407],
                [407, 272],
                [322, 270],
                [270, 410],
                [410, 322],
                [449, 450],
                [450, 347],
                [347, 449],
                [432, 422],
                [422, 434],
                [434, 432],
                [18, 313],
                [313, 17],
                [17, 18],
                [291, 306],
                [306, 375],
                [375, 291],
                [259, 387],
                [387, 260],
                [260, 259],
                [424, 335],
                [335, 418],
                [418, 424],
                [434, 364],
                [364, 416],
                [416, 434],
                [391, 423],
                [423, 327],
                [327, 391],
                [301, 251],
                [251, 298],
                [298, 301],
                [275, 281],
                [281, 4],
                [4, 275],
                [254, 373],
                [373, 253],
                [253, 254],
                [375, 307],
                [307, 321],
                [321, 375],
                [280, 425],
                [425, 411],
                [411, 280],
                [200, 421],
                [
                  421,
                  18
                ],
                [18, 200],
                [335, 321],
                [321, 406],
                [406, 335],
                [321, 320],
                [320, 405],
                [405, 321],
                [314, 315],
                [315, 17],
                [17, 314],
                [423, 426],
                [426, 266],
                [266, 423],
                [396, 377],
                [377, 369],
                [369, 396],
                [270, 322],
                [322, 269],
                [269, 270],
                [413, 417],
                [417, 464],
                [464, 413],
                [385, 386],
                [386, 258],
                [258, 385],
                [248, 456],
                [456, 419],
                [419, 248],
                [298, 284],
                [284, 333],
                [333, 298],
                [168, 417],
                [417, 8],
                [8, 168],
                [448, 346],
                [346, 261],
                [261, 448],
                [417, 413],
                [413, 285],
                [285, 417],
                [326, 327],
                [327, 328],
                [328, 326],
                [277, 355],
                [355, 329],
                [329, 277],
                [309, 392],
                [392, 438],
                [438, 309],
                [381, 382],
                [
                  382,
                  256
                ],
                [256, 381],
                [279, 429],
                [429, 360],
                [360, 279],
                [365, 364],
                [364, 379],
                [379, 365],
                [355, 277],
                [277, 437],
                [437, 355],
                [282, 443],
                [443, 283],
                [283, 282],
                [281, 275],
                [275, 363],
                [363, 281],
                [395, 431],
                [431, 369],
                [369, 395],
                [299, 297],
                [297, 337],
                [337, 299],
                [335, 273],
                [273, 321],
                [321, 335],
                [348, 450],
                [450, 349],
                [349, 348],
                [359, 446],
                [446, 467],
                [467, 359],
                [283, 293],
                [293, 282],
                [282, 283],
                [250, 458],
                [458, 462],
                [462, 250],
                [300, 276],
                [276, 383],
                [383, 300],
                [292, 308],
                [308, 325],
                [325, 292],
                [283, 276],
                [276, 293],
                [293, 283],
                [264, 372],
                [372, 447],
                [447, 264],
                [346, 352],
                [352, 340],
                [340, 346],
                [354, 274],
                [274, 19],
                [19, 354],
                [363, 456],
                [456, 281],
                [281, 363],
                [426, 436],
                [436, 425],
                [425, 426],
                [380, 381],
                [381, 252],
                [252, 380],
                [267, 269],
                [269, 393],
                [393, 267],
                [421, 200],
                [200, 428],
                [428, 421],
                [371, 266],
                [266, 329],
                [329, 371],
                [432, 287],
                [287, 422],
                [422, 432],
                [290, 250],
                [250, 328],
                [328, 290],
                [385, 258],
                [258, 384],
                [384, 385],
                [446, 265],
                [265, 342],
                [342, 446],
                [386, 387],
                [387, 257],
                [257, 386],
                [422, 424],
                [424, 430],
                [430, 422],
                [445, 342],
                [342, 276],
                [276, 445],
                [422, 273],
                [273, 424],
                [424, 422],
                [306, 292],
                [292, 307],
                [307, 306],
                [
                  352,
                  366
                ],
                [366, 345],
                [345, 352],
                [268, 271],
                [271, 302],
                [302, 268],
                [358, 423],
                [423, 371],
                [371, 358],
                [327, 294],
                [294, 460],
                [460, 327],
                [331, 279],
                [279, 294],
                [294, 331],
                [303, 271],
                [271, 304],
                [304, 303],
                [436, 432],
                [432, 427],
                [427, 436],
                [304, 272],
                [272, 408],
                [408, 304],
                [395, 394],
                [394, 431],
                [431, 395],
                [378, 395],
                [395, 400],
                [400, 378],
                [296, 334],
                [334, 299],
                [299, 296],
                [6, 351],
                [351, 168],
                [168, 6],
                [376, 352],
                [352, 411],
                [411, 376],
                [307, 325],
                [325, 320],
                [320, 307],
                [285, 295],
                [295, 336],
                [336, 285],
                [320, 319],
                [319, 404],
                [404, 320],
                [329, 330],
                [330, 349],
                [349, 329],
                [334, 293],
                [293, 333],
                [333, 334],
                [366, 323],
                [323, 447],
                [447, 366],
                [316, 15],
                [15, 315],
                [315, 316],
                [331, 358],
                [358, 279],
                [279, 331],
                [317, 14],
                [14, 316],
                [316, 317],
                [8, 285],
                [285, 9],
                [9, 8],
                [277, 329],
                [329, 350],
                [350, 277],
                [253, 374],
                [374, 252],
                [252, 253],
                [319, 318],
                [318, 403],
                [403, 319],
                [351, 6],
                [6, 419],
                [419, 351],
                [324, 318],
                [318, 325],
                [325, 324],
                [397, 367],
                [367, 365],
                [365, 397],
                [288, 435],
                [435, 397],
                [397, 288],
                [278, 344],
                [344, 439],
                [439, 278],
                [310, 272],
                [272, 311],
                [311, 310],
                [248, 195],
                [195, 281],
                [281, 248],
                [375, 273],
                [273, 291],
                [291, 375],
                [175, 396],
                [396, 199],
                [199, 175],
                [312, 311],
                [311, 268],
                [268, 312],
                [276, 283],
                [283, 445],
                [445, 276],
                [390, 373],
                [373, 339],
                [339, 390],
                [295, 282],
                [282, 296],
                [296, 295],
                [448, 449],
                [449, 346],
                [346, 448],
                [356, 264],
                [264, 454],
                [454, 356],
                [337, 336],
                [336, 299],
                [299, 337],
                [337, 338],
                [338, 151],
                [151, 337],
                [294, 278],
                [278, 455],
                [455, 294],
                [308, 292],
                [292, 415],
                [415, 308],
                [429, 358],
                [358, 355],
                [355, 429],
                [265, 340],
                [340, 372],
                [372, 265],
                [352, 346],
                [346, 280],
                [280, 352],
                [295, 442],
                [442, 282],
                [282, 295],
                [354, 19],
                [19, 370],
                [370, 354],
                [285, 441],
                [441, 295],
                [295, 285],
                [
                  195,
                  248
                ],
                [248, 197],
                [197, 195],
                [457, 440],
                [440, 274],
                [274, 457],
                [301, 300],
                [300, 368],
                [368, 301],
                [417, 351],
                [351, 465],
                [465, 417],
                [251, 301],
                [301, 389],
                [389, 251],
                [394, 395],
                [395, 379],
                [379, 394],
                [399, 412],
                [412, 419],
                [419, 399],
                [410, 436],
                [436, 322],
                [322, 410],
                [326, 2],
                [2, 393],
                [393, 326],
                [354, 370],
                [370, 461],
                [461, 354],
                [393, 164],
                [164, 267],
                [267, 393],
                [268, 302],
                [302, 12],
                [12, 268],
                [312, 268],
                [268, 13],
                [13, 312],
                [298, 293],
                [293, 301],
                [301, 298],
                [265, 446],
                [446, 340],
                [340, 265],
                [280, 330],
                [330, 425],
                [425, 280],
                [322, 426],
                [426, 391],
                [391, 322],
                [
                  420,
                  429
                ],
                [429, 437],
                [437, 420],
                [393, 391],
                [391, 326],
                [326, 393],
                [344, 440],
                [440, 438],
                [438, 344],
                [458, 459],
                [459, 461],
                [461, 458],
                [364, 434],
                [434, 394],
                [394, 364],
                [428, 396],
                [396, 262],
                [262, 428],
                [274, 354],
                [354, 457],
                [457, 274],
                [317, 316],
                [316, 402],
                [402, 317],
                [316, 315],
                [315, 403],
                [403, 316],
                [315, 314],
                [314, 404],
                [404, 315],
                [314, 313],
                [313, 405],
                [405, 314],
                [313, 421],
                [421, 406],
                [406, 313],
                [323, 366],
                [366, 361],
                [361, 323],
                [292, 306],
                [306, 407],
                [407, 292],
                [306, 291],
                [291, 408],
                [408, 306],
                [291, 287],
                [287, 409],
                [409, 291],
                [287, 432],
                [432, 410],
                [410, 287],
                [427, 434],
                [434, 411],
                [411, 427],
                [372, 264],
                [264, 383],
                [383, 372],
                [459, 309],
                [309, 457],
                [457, 459],
                [366, 352],
                [352, 401],
                [401, 366],
                [1, 274],
                [274, 4],
                [4, 1],
                [418, 421],
                [421, 262],
                [262, 418],
                [331, 294],
                [294, 358],
                [358, 331],
                [435, 433],
                [433, 367],
                [367, 435],
                [392, 289],
                [289, 439],
                [439, 392],
                [328, 462],
                [462, 326],
                [326, 328],
                [94, 2],
                [2, 370],
                [370, 94],
                [289, 305],
                [305, 455],
                [455, 289],
                [339, 254],
                [254, 448],
                [448, 339],
                [359, 255],
                [255, 446],
                [446, 359],
                [254, 253],
                [253, 449],
                [449, 254],
                [253, 252],
                [252, 450],
                [450, 253],
                [252, 256],
                [256, 451],
                [451, 252],
                [
                  256,
                  341
                ],
                [341, 452],
                [452, 256],
                [414, 413],
                [413, 463],
                [463, 414],
                [286, 441],
                [441, 414],
                [414, 286],
                [286, 258],
                [258, 441],
                [441, 286],
                [258, 257],
                [257, 442],
                [442, 258],
                [257, 259],
                [259, 443],
                [443, 257],
                [259, 260],
                [260, 444],
                [444, 259],
                [260, 467],
                [467, 445],
                [445, 260],
                [309, 459],
                [459, 250],
                [250, 309],
                [305, 289],
                [289, 290],
                [290, 305],
                [305, 290],
                [290, 460],
                [460, 305],
                [401, 376],
                [376, 435],
                [435, 401],
                [309, 250],
                [250, 392],
                [392, 309],
                [376, 411],
                [411, 433],
                [433, 376],
                [453, 341],
                [341, 464],
                [464, 453],
                [357, 453],
                [453, 465],
                [465, 357],
                [343, 357],
                [357, 412],
                [412, 343],
                [437, 343],
                [343, 399],
                [399, 437],
                [344, 360],
                [360, 440],
                [440, 344],
                [420, 437],
                [437, 456],
                [456, 420],
                [360, 420],
                [420, 363],
                [363, 360],
                [361, 401],
                [401, 288],
                [288, 361],
                [265, 372],
                [372, 353],
                [353, 265],
                [390, 339],
                [339, 249],
                [249, 390],
                [339, 448],
                [448, 255],
                [255, 339]
              ]), Ma("matrixDataToMatrix", function(q) {
                for (var he = q.getCols(), ve = q.getRows(), bt = q.getPackedDataList(), Ot = [], In = 0; In < ve; In++)
                  Ot.push(Array(he));
                for (In = 0; In < ve; In++)
                  for (var en = 0; en < he; en++) {
                    var Gn = q.getLayout() === 1 ? In * he + en : en * ve + In;
                    Ot[In][en] = bt[Gn];
                  }
                return Ot;
              }), Ma("VERSION", "0.4.1633559619");
            }).call(Jt);
            const St = {};
            (function() {
              var E;
              function R(F) {
                var M = 0;
                return function() {
                  return M < F.length ? { done: !1, value: F[M++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(F, M, H) {
                return F == Array.prototype || F == Object.prototype || (F[M] = H.value), F;
              };
              function ie(F) {
                F = [typeof globalThis == "object" && globalThis, F, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var M = 0; M < F.length; ++M) {
                  var H = F[M];
                  if (H && H.Math == Math)
                    return H;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(F, M) {
                if (M)
                  e: {
                    var H = pe;
                    F = F.split(".");
                    for (var ce = 0; ce < F.length - 1; ce++) {
                      var ke = F[ce];
                      if (!(ke in H))
                        break e;
                      H = H[ke];
                    }
                    F = F[F.length - 1], ce = H[F], M = M(ce), M != ce && M != null && S(H, F, { configurable: !0, writable: !0, value: M });
                  }
              }
              De("Symbol", function(F) {
                function M(st) {
                  if (this instanceof M)
                    throw new TypeError("Symbol is not a constructor");
                  return new H(ce + (st || "") + "_" + ke++, st);
                }
                function H(st, mt) {
                  this.g = st, S(this, "description", { configurable: !0, writable: !0, value: mt });
                }
                if (F)
                  return F;
                H.prototype.toString = function() {
                  return this.g;
                };
                var ce = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", ke = 0;
                return M;
              }), De("Symbol.iterator", function(F) {
                if (F)
                  return F;
                F = Symbol("Symbol.iterator");
                for (var M = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), H = 0; H < M.length; H++) {
                  var ce = pe[M[H]];
                  typeof ce == "function" && typeof ce.prototype[F] != "function" && S(ce.prototype, F, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return F;
              });
              function ht(F) {
                return F = { next: F }, F[Symbol.iterator] = function() {
                  return this;
                }, F;
              }
              function rt(F) {
                var M = typeof Symbol < "u" && Symbol.iterator && F[Symbol.iterator];
                return M ? M.call(F) : { next: R(F) };
              }
              function Nt(F) {
                if (!(F instanceof Array)) {
                  F = rt(F);
                  for (var M, H = []; !(M = F.next()).done; )
                    H.push(M.value);
                  F = H;
                }
                return F;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(F) {
                function M() {
                }
                return M.prototype = F, new M();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(F, M) {
                  if (F.__proto__ = M, F.__proto__ !== M)
                    throw new TypeError(F + " is not extensible");
                  return F;
                } : null;
              }
              var br = cr;
              function Nr(F, M) {
                if (F.prototype = Pn(M.prototype), F.prototype.constructor = F, br)
                  br(F, M);
                else
                  for (var H in M)
                    if (H != "prototype")
                      if (Object.defineProperties) {
                        var ce = Object.getOwnPropertyDescriptor(M, H);
                        ce && Object.defineProperty(F, H, ce);
                      } else
                        F[H] = M[H];
                F.ka = M.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
              }
              function qi(F) {
                if (F.l)
                  throw new TypeError("Generator is already running");
                F.l = !0;
              }
              $i.prototype.o = function(F) {
                this.h = F;
              };
              function Vo(F, M) {
                F.j = { V: M, X: !0 }, F.g = F.m || F.s;
              }
              $i.prototype.return = function(F) {
                this.j = { return: F }, this.g = this.s;
              };
              function Un(F, M, H) {
                return F.g = H, { value: M };
              }
              function el(F) {
                this.g = new $i(), this.h = F;
              }
              function Ys(F, M) {
                qi(F.g);
                var H = F.g.i;
                return H ? Ca(F, "return" in H ? H.return : function(ce) {
                  return { value: ce, done: !0 };
                }, M, F.g.return) : (F.g.return(M), lo(F));
              }
              function Ca(F, M, H, ce) {
                try {
                  var ke = M.call(F.g.i, H);
                  if (!(ke instanceof Object))
                    throw new TypeError("Iterator result " + ke + " is not an object");
                  if (!ke.done)
                    return F.g.l = !1, ke;
                  var st = ke.value;
                } catch (mt) {
                  return F.g.i = null, Vo(F.g, mt), lo(F);
                }
                return F.g.i = null, ce.call(F.g, st), lo(F);
              }
              function lo(F) {
                for (; F.g.g; )
                  try {
                    var M = F.h(F.g);
                    if (M)
                      return F.g.l = !1, { value: M.value, done: !1 };
                  } catch (H) {
                    F.g.h = void 0, Vo(F.g, H);
                  }
                if (F.g.l = !1, F.g.j) {
                  if (M = F.g.j, F.g.j = null, M.X)
                    throw M.V;
                  return { value: M.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(F) {
                this.next = function(M) {
                  return qi(F.g), F.g.i ? M = Ca(F, F.g.i.next, M, F.g.o) : (F.g.o(M), M = lo(F)), M;
                }, this.throw = function(M) {
                  return qi(F.g), F.g.i ? M = Ca(F, F.g.i.throw, M, F.g.o) : (Vo(F.g, M), M = lo(F)), M;
                }, this.return = function(M) {
                  return Ys(F, M);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(F) {
                function M(ce) {
                  return F.next(ce);
                }
                function H(ce) {
                  return F.throw(ce);
                }
                return new n(function(ce, ke) {
                  function st(mt) {
                    mt.done ? ce(mt.value) : n.resolve(mt.value).then(M, H).then(st, ke);
                  }
                  st(F.next());
                });
              }
              function Mr(F) {
                return Go(new Cc(new el(F)));
              }
              De("Promise", function(F) {
                function M(mt) {
                  this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                  var xt = this.j();
                  try {
                    mt(xt.resolve, xt.reject);
                  } catch (dn) {
                    xt.reject(dn);
                  }
                }
                function H() {
                  this.g = null;
                }
                function ce(mt) {
                  return mt instanceof M ? mt : new M(function(xt) {
                    xt(mt);
                  });
                }
                if (F)
                  return F;
                H.prototype.h = function(mt) {
                  if (this.g == null) {
                    this.g = [];
                    var xt = this;
                    this.i(function() {
                      xt.l();
                    });
                  }
                  this.g.push(mt);
                };
                var ke = pe.setTimeout;
                H.prototype.i = function(mt) {
                  ke(mt, 0);
                }, H.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var mt = this.g;
                    this.g = [];
                    for (var xt = 0; xt < mt.length; ++xt) {
                      var dn = mt[xt];
                      mt[xt] = null;
                      try {
                        dn();
                      } catch (Bn) {
                        this.j(Bn);
                      }
                    }
                  }
                  this.g = null;
                }, H.prototype.j = function(mt) {
                  this.i(function() {
                    throw mt;
                  });
                }, M.prototype.j = function() {
                  function mt(Bn) {
                    return function(Zn) {
                      dn || (dn = !0, Bn.call(xt, Zn));
                    };
                  }
                  var xt = this, dn = !1;
                  return { resolve: mt(this.D), reject: mt(this.l) };
                }, M.prototype.D = function(mt) {
                  if (mt === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (mt instanceof M)
                    this.G(mt);
                  else {
                    e:
                      switch (typeof mt) {
                        case "object":
                          var xt = mt != null;
                          break e;
                        case "function":
                          xt = !0;
                          break e;
                        default:
                          xt = !1;
                      }
                    xt ? this.A(mt) : this.m(mt);
                  }
                }, M.prototype.A = function(mt) {
                  var xt = void 0;
                  try {
                    xt = mt.then;
                  } catch (dn) {
                    this.l(dn);
                    return;
                  }
                  typeof xt == "function" ? this.H(xt, mt) : this.m(mt);
                }, M.prototype.l = function(mt) {
                  this.s(2, mt);
                }, M.prototype.m = function(mt) {
                  this.s(1, mt);
                }, M.prototype.s = function(mt, xt) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + mt + ", " + xt + "): Promise already settled in state" + this.h);
                  this.h = mt, this.i = xt, this.h === 2 && this.F(), this.B();
                }, M.prototype.F = function() {
                  var mt = this;
                  ke(function() {
                    if (mt.C()) {
                      var xt = pe.console;
                      typeof xt < "u" && xt.error(mt.i);
                    }
                  }, 1);
                }, M.prototype.C = function() {
                  if (this.o)
                    return !1;
                  var mt = pe.CustomEvent, xt = pe.Event, dn = pe.dispatchEvent;
                  return typeof dn > "u" ? !0 : (typeof mt == "function" ? mt = new mt("unhandledrejection", { cancelable: !0 }) : typeof xt == "function" ? mt = new xt("unhandledrejection", { cancelable: !0 }) : (mt = pe.document.createEvent("CustomEvent"), mt.initCustomEvent("unhandledrejection", !1, !0, mt)), mt.promise = this, mt.reason = this.i, dn(mt));
                }, M.prototype.B = function() {
                  if (this.g != null) {
                    for (var mt = 0; mt < this.g.length; ++mt)
                      st.h(this.g[mt]);
                    this.g = null;
                  }
                };
                var st = new H();
                return M.prototype.G = function(mt) {
                  var xt = this.j();
                  mt.K(xt.resolve, xt.reject);
                }, M.prototype.H = function(mt, xt) {
                  var dn = this.j();
                  try {
                    mt.call(xt, dn.resolve, dn.reject);
                  } catch (Bn) {
                    dn.reject(Bn);
                  }
                }, M.prototype.then = function(mt, xt) {
                  function dn(Ur, Zr) {
                    return typeof Ur == "function" ? function(Pr) {
                      try {
                        Bn(Ur(Pr));
                      } catch (xr) {
                        Zn(xr);
                      }
                    } : Zr;
                  }
                  var Bn, Zn, ir = new M(function(Ur, Zr) {
                    Bn = Ur, Zn = Zr;
                  });
                  return this.K(dn(mt, Bn), dn(xt, Zn)), ir;
                }, M.prototype.catch = function(mt) {
                  return this.then(void 0, mt);
                }, M.prototype.K = function(mt, xt) {
                  function dn() {
                    switch (Bn.h) {
                      case 1:
                        mt(Bn.i);
                        break;
                      case 2:
                        xt(Bn.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + Bn.h);
                    }
                  }
                  var Bn = this;
                  this.g == null ? st.h(dn) : this.g.push(dn), this.o = !0;
                }, M.resolve = ce, M.reject = function(mt) {
                  return new M(function(xt, dn) {
                    dn(mt);
                  });
                }, M.race = function(mt) {
                  return new M(function(xt, dn) {
                    for (var Bn = rt(mt), Zn = Bn.next(); !Zn.done; Zn = Bn.next())
                      ce(Zn.value).K(xt, dn);
                  });
                }, M.all = function(mt) {
                  var xt = rt(mt), dn = xt.next();
                  return dn.done ? ce([]) : new M(function(Bn, Zn) {
                    function ir(Pr) {
                      return function(xr) {
                        Ur[Pr] = xr, Zr--, Zr == 0 && Bn(Ur);
                      };
                    }
                    var Ur = [], Zr = 0;
                    do
                      Ur.push(void 0), Zr++, ce(dn.value).K(ir(Ur.length - 1), Zn), dn = xt.next();
                    while (!dn.done);
                  });
                }, M;
              });
              function ml(F, M) {
                F instanceof String && (F += "");
                var H = 0, ce = !1, ke = { next: function() {
                  if (!ce && H < F.length) {
                    var st = H++;
                    return { value: M(st, F[st]), done: !1 };
                  }
                  return ce = !0, { done: !0, value: void 0 };
                } };
                return ke[Symbol.iterator] = function() {
                  return ke;
                }, ke;
              }
              var cd = typeof Object.assign == "function" ? Object.assign : function(F, M) {
                for (var H = 1; H < arguments.length; H++) {
                  var ce = arguments[H];
                  if (ce)
                    for (var ke in ce)
                      Object.prototype.hasOwnProperty.call(ce, ke) && (F[ke] = ce[ke]);
                }
                return F;
              };
              De("Object.assign", function(F) {
                return F || cd;
              }), De("Object.is", function(F) {
                return F || function(M, H) {
                  return M === H ? M !== 0 || 1 / M === 1 / H : M !== M && H !== H;
                };
              }), De("Array.prototype.includes", function(F) {
                return F || function(M, H) {
                  var ce = this;
                  ce instanceof String && (ce = String(ce));
                  var ke = ce.length;
                  for (H = H || 0, 0 > H && (H = Math.max(H + ke, 0)); H < ke; H++) {
                    var st = ce[H];
                    if (st === M || Object.is(st, M))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(F) {
                return F || function(M, H) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (M instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(M, H || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(F) {
                return F || function() {
                  return ml(this, function(M) {
                    return M;
                  });
                };
              });
              var Ma = this || self;
              function Ji(F, M) {
                F = F.split(".");
                var H = Ma;
                F[0] in H || typeof H.execScript > "u" || H.execScript("var " + F[0]);
                for (var ce; F.length && (ce = F.shift()); )
                  F.length || M === void 0 ? H[ce] && H[ce] !== Object.prototype[ce] ? H = H[ce] : H = H[ce] = {} : H[ce] = M;
              }
              function ts(F) {
                throw F;
              }
              function tl(F, M) {
                ts(Error("Invalid wire type: " + F + " (at position " + M + ")"));
              }
              function Wl() {
                ts(Error("Failed to read varint, encoding is invalid."));
              }
              function Ac(F, M) {
                return M = String.fromCharCode.apply(null, M), F == null ? M : F + M;
              }
              var Hl, Uc = typeof TextDecoder < "u", dl, vl = typeof TextEncoder < "u";
              function Nc(F) {
                if (vl)
                  F = (dl || (dl = new TextEncoder())).encode(F);
                else {
                  var M = void 0;
                  M = M === void 0 ? !1 : M;
                  for (var H = 0, ce = new Uint8Array(3 * F.length), ke = 0; ke < F.length; ke++) {
                    var st = F.charCodeAt(ke);
                    if (128 > st)
                      ce[H++] = st;
                    else {
                      if (2048 > st)
                        ce[H++] = st >> 6 | 192;
                      else {
                        if (55296 <= st && 57343 >= st) {
                          if (56319 >= st && ke < F.length) {
                            var mt = F.charCodeAt(++ke);
                            if (56320 <= mt && 57343 >= mt) {
                              st = 1024 * (st - 55296) + mt - 56320 + 65536, ce[H++] = st >> 18 | 240, ce[H++] = st >> 12 & 63 | 128, ce[H++] = st >> 6 & 63 | 128, ce[H++] = st & 63 | 128;
                              continue;
                            } else
                              ke--;
                          }
                          if (M)
                            throw Error("Found an unpaired surrogate");
                          st = 65533;
                        }
                        ce[H++] = st >> 12 | 224, ce[H++] = st >> 6 & 63 | 128;
                      }
                      ce[H++] = st & 63 | 128;
                    }
                  }
                  F = ce.subarray(0, H);
                }
                return F;
              }
              var gc = {}, Js = null;
              function Is(F) {
                var M;
                M === void 0 && (M = 0), ta(), M = gc[M];
                for (var H = Array(Math.floor(F.length / 3)), ce = M[64] || "", ke = 0, st = 0; ke < F.length - 2; ke += 3) {
                  var mt = F[ke], xt = F[ke + 1], dn = F[ke + 2], Bn = M[mt >> 2];
                  mt = M[(mt & 3) << 4 | xt >> 4], xt = M[(xt & 15) << 2 | dn >> 6], dn = M[dn & 63], H[st++] = Bn + mt + xt + dn;
                }
                switch (Bn = 0, dn = ce, F.length - ke) {
                  case 2:
                    Bn = F[ke + 1], dn = M[(Bn & 15) << 2] || ce;
                  case 1:
                    F = F[ke], H[st] = M[F >> 2] + M[(F & 3) << 4 | Bn >> 4] + dn + ce;
                }
                return H.join("");
              }
              function Pl(F) {
                var M = F.length, H = 3 * M / 4;
                H % 3 ? H = Math.floor(H) : "=.".indexOf(F[M - 1]) != -1 && (H = "=.".indexOf(F[M - 2]) != -1 ? H - 2 : H - 1);
                var ce = new Uint8Array(H), ke = 0;
                return Nl(F, function(st) {
                  ce[ke++] = st;
                }), ce.subarray(0, ke);
              }
              function Nl(F, M) {
                function H(dn) {
                  for (; ce < F.length; ) {
                    var Bn = F.charAt(ce++), Zn = Js[Bn];
                    if (Zn != null)
                      return Zn;
                    if (!/^[\s\xa0]*$/.test(Bn))
                      throw Error("Unknown base64 encoding at char: " + Bn);
                  }
                  return dn;
                }
                ta();
                for (var ce = 0; ; ) {
                  var ke = H(-1), st = H(0), mt = H(64), xt = H(64);
                  if (xt === 64 && ke === -1)
                    break;
                  M(ke << 2 | st >> 4), mt != 64 && (M(st << 4 & 240 | mt >> 2), xt != 64 && M(mt << 6 & 192 | xt));
                }
              }
              function ta() {
                if (!Js) {
                  Js = {};
                  for (var F = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), M = ["+/=", "+/", "-_=", "-_.", "-_"], H = 0; 5 > H; H++) {
                    var ce = F.concat(M[H].split(""));
                    gc[H] = ce;
                    for (var ke = 0; ke < ce.length; ke++) {
                      var st = ce[ke];
                      Js[st] === void 0 && (Js[st] = ke);
                    }
                  }
                }
              }
              var $a = typeof Uint8Array == "function", Gs;
              function To(F) {
                if (this.g = F, F !== null && F.length === 0)
                  throw Error("ByteString should be constructed with non-empty values");
              }
              var Na = typeof Uint8Array.prototype.slice == "function";
              function nl(F, M, H) {
                return M === H ? Gs || (Gs = new Uint8Array(0)) : Na ? F.slice(M, H) : new Uint8Array(F.subarray(M, H));
              }
              var vs = 0, bo = 0;
              function fa(F) {
                if (F.constructor === Uint8Array)
                  return F;
                if (F.constructor === ArrayBuffer)
                  return new Uint8Array(F);
                if (F.constructor === Array)
                  return new Uint8Array(F);
                if (F.constructor === String)
                  return Pl(F);
                if (F.constructor === To) {
                  if (F.g == null)
                    var M = Gs || (Gs = new Uint8Array(0));
                  else {
                    M = Uint8Array;
                    var H = F.g;
                    H = H == null || $a && H != null && H instanceof Uint8Array ? H : typeof H == "string" ? Pl(H) : null, F = F.g = H, M = new M(F);
                  }
                  return M;
                }
                if (F instanceof Uint8Array)
                  return new Uint8Array(F.buffer, F.byteOffset, F.byteLength);
                throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
              }
              function ss(F, M) {
                M = M === void 0 ? {} : M, M = M.v === void 0 ? !1 : M.v, this.h = null, this.g = this.i = this.l = 0, this.j = !1, this.v = M, F && eo(this, F);
              }
              function eo(F, M) {
                F.h = fa(M), F.l = 0, F.i = F.h.length, F.g = F.l;
              }
              ss.prototype.reset = function() {
                this.g = this.l;
              };
              function Pa(F) {
                for (var M = 128, H = 0, ce = 0, ke = 0; 4 > ke && 128 <= M; ke++)
                  M = F.h[F.g++], H |= (M & 127) << 7 * ke;
                if (128 <= M && (M = F.h[F.g++], H |= (M & 127) << 28, ce |= (M & 127) >> 4), 128 <= M)
                  for (ke = 0; 5 > ke && 128 <= M; ke++)
                    M = F.h[F.g++], ce |= (M & 127) << 7 * ke + 3;
                if (128 > M)
                  return F = H >>> 0, M = ce >>> 0, (ce = M & 2147483648) && (F = ~F + 1 >>> 0, M = ~M >>> 0, F == 0 && (M = M + 1 >>> 0)), F = 4294967296 * M + (F >>> 0), ce ? -F : F;
                F.j = !0, Wl();
              }
              function Ao(F) {
                F.g > F.i && (F.j = !0, ts(Error("Tried to read past the end of the data " + F.g + " > " + F.i)));
              }
              function ua(F) {
                var M = F.h, H = M[F.g], ce = H & 127;
                return 128 > H ? (F.g += 1, Ao(F), ce) : (H = M[F.g + 1], ce |= (H & 127) << 7, 128 > H ? (F.g += 2, Ao(F), ce) : (H = M[F.g + 2], ce |= (H & 127) << 14, 128 > H ? (F.g += 3, Ao(F), ce) : (H = M[F.g + 3], ce |= (H & 127) << 21, 128 > H ? (F.g += 4, Ao(F), ce) : (H = M[F.g + 4], ce |= (H & 15) << 28, 128 > H ? (F.g += 5, Ao(F), ce >>> 0) : (F.g += 5, 128 <= M[F.g++] && 128 <= M[F.g++] && 128 <= M[F.g++] && 128 <= M[F.g++] && 128 <= M[F.g++] ? (F.j = !0, Wl(), ce) : (Ao(F), ce))))));
              }
              function ns(F) {
                var M = F.h[F.g], H = F.h[F.g + 1], ce = F.h[F.g + 2], ke = F.h[F.g + 3];
                return F.g += 4, Ao(F), (M << 0 | H << 8 | ce << 16 | ke << 24) >>> 0;
              }
              ss.prototype.m = function() {
                var F = ns(this), M = 2 * (F >> 31) + 1, H = F >>> 23 & 255;
                return F &= 8388607, H == 255 ? F ? NaN : 1 / 0 * M : H == 0 ? M * Math.pow(2, -149) * F : M * Math.pow(2, H - 150) * (F + Math.pow(2, 23));
              };
              var Ls = [];
              function Ua() {
                this.g = new Uint8Array(64), this.h = 0;
              }
              function go(F, M) {
                if (!(F.h + 1 < F.g.length)) {
                  var H = F.g;
                  F.g = new Uint8Array(Math.ceil(1 + 2 * F.g.length)), F.g.set(H);
                }
                F.g[F.h++] = M;
              }
              Ua.prototype.length = function() {
                return this.h;
              }, Ua.prototype.end = function() {
                var F = this.g, M = this.h;
                return this.h = 0, nl(F, 0, M);
              };
              function Bs(F, M) {
                for (; 127 < M; )
                  go(F, M & 127 | 128), M >>>= 7;
                go(F, M);
              }
              function Ts(F) {
                var M = {}, H = M.O === void 0 ? !1 : M.O;
                this.m = { v: M.v === void 0 ? !1 : M.v }, this.O = H, M = this.m, Ls.length ? (H = Ls.pop(), M && (H.v = M.v), F && eo(H, F), F = H) : F = new ss(F, M), this.g = F, this.l = this.g.g, this.h = this.i = -1, this.j = !1;
              }
              Ts.prototype.reset = function() {
                this.g.reset(), this.h = this.i = -1;
              };
              function Oa(F) {
                var M = F.g;
                if ((M = M.g == M.i) || (M = F.j) || (M = F.g, M = M.j || 0 > M.g || M.g > M.i), M)
                  return !1;
                F.l = F.g.g;
                var H = ua(F.g);
                return M = H >>> 3, H &= 7, 0 <= H && 5 >= H ? (F.i = M, F.h = H, !0) : (F.j = !0, tl(H, F.l), !1);
              }
              function Jl(F) {
                switch (F.h) {
                  case 0:
                    if (F.h != 0)
                      Jl(F);
                    else
                      e: {
                        F = F.g;
                        for (var M = F.g, H = 0; 10 > H; H++) {
                          if (!(F.h[M] & 128)) {
                            F.g = M + 1, Ao(F);
                            break e;
                          }
                          M++;
                        }
                        F.j = !0, Wl();
                      }
                    break;
                  case 1:
                    F = F.g, F.g += 8, Ao(F);
                    break;
                  case 2:
                    F.h != 2 ? Jl(F) : (M = ua(F.g), F = F.g, F.g += M, Ao(F));
                    break;
                  case 5:
                    F = F.g, F.g += 4, Ao(F);
                    break;
                  case 3:
                    M = F.i;
                    do {
                      if (!Oa(F)) {
                        F.j = !0, ts(Error("Unmatched start-group tag: stream EOF"));
                        break;
                      }
                      if (F.h == 4) {
                        F.i != M && (F.j = !0, ts(Error("Unmatched end-group tag")));
                        break;
                      }
                      Jl(F);
                    } while (!0);
                    break;
                  default:
                    F.j = !0, tl(F.h, F.l);
                }
              }
              function rl(F, M, H) {
                var ce = F.g.i, ke = ua(F.g), st = F.g.g + ke;
                if (F.g.i = st, H(M, F), H = st - F.g.g, H !== 0)
                  throw Error("Message parsing ended unexpectedly. Expected to read " + (ke + " bytes, instead read " + (ke - H) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                return F.g.g = st, F.g.i = ce, M;
              }
              var Xs = [];
              function il() {
                this.h = [], this.i = 0, this.g = new Ua();
              }
              function pa(F, M) {
                M.length !== 0 && (F.h.push(M), F.i += M.length);
              }
              function rs(F, M, H) {
                Bs(F.g, 8 * M + 2), Bs(F.g, H.length), pa(F, F.g.end()), pa(F, H);
              }
              var ma = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
              function Xo(F) {
                return Object.isFrozen(F) || (ma ? F[ma] |= 1 : F.g !== void 0 ? F.g |= 1 : Object.defineProperties(F, { g: { value: 1, configurable: !0, writable: !0, enumerable: !1 } })), F;
              }
              function ks(F) {
                return F !== null && typeof F == "object" && F.constructor === Object;
              }
              function Zo(F) {
                switch (typeof F) {
                  case "number":
                    return isFinite(F) ? F : String(F);
                  case "object":
                    if ($a && F != null && F instanceof Uint8Array)
                      return Is(F);
                    if (F instanceof To) {
                      if (F.g == null)
                        F = "";
                      else {
                        var M = F.g;
                        M = M == null || typeof M == "string" ? M : $a && M instanceof Uint8Array ? Is(M) : null, F = F.g = M;
                      }
                      return F;
                    }
                }
                return F;
              }
              function fo(F, M) {
                if (F != null)
                  return Array.isArray(F) || ks(F) ? ul(F, M) : M(F);
              }
              function ul(F, M) {
                if (Array.isArray(F)) {
                  for (var H = Array(F.length), ce = 0; ce < F.length; ce++)
                    H[ce] = fo(F[ce], M);
                  if (M = Array.isArray(F)) {
                    var ke;
                    ma ? ke = F[ma] : ke = F.g, M = (ke == null ? 0 : ke) & 1;
                  }
                  return M && Xo(H), H;
                }
                ke = {};
                for (H in F)
                  ke[H] = fo(F[H], M);
                return ke;
              }
              function na(F) {
                return F = Zo(F), Array.isArray(F) ? ul(F, na) : F;
              }
              var Wi;
              function li(F, M, H) {
                var ce = Wi;
                Wi = null, F || (F = ce), ce = this.constructor.ha, F || (F = ce ? [ce] : []), this.i = (ce ? 0 : -1) - (this.constructor.fa || 0), this.l = this.g = null, this.u = F;
                e: {
                  if (ce = this.u.length, F = ce - 1, ce && (ce = this.u[F], ks(ce))) {
                    this.j = F - this.i, this.h = ce;
                    break e;
                  }
                  M !== void 0 && -1 < M ? (this.j = Math.max(M, F + 1 - this.i), this.h = null) : this.j = Number.MAX_VALUE;
                }
                if (H)
                  for (M = 0; M < H.length; M++)
                    F = H[M], F < this.j ? (F += this.i, (ce = this.u[F]) ? Array.isArray(ce) && Xo(ce) : this.u[F] = ko) : (is(this), (ce = this.h[F]) ? Array.isArray(ce) && Xo(ce) : this.h[F] = ko);
              }
              var ko = Object.freeze(Xo([]));
              function is(F) {
                var M = F.j + F.i;
                F.u[M] || (F.h = F.u[M] = {});
              }
              function So(F, M, H) {
                return M === -1 ? null : H !== void 0 && H || M >= F.j ? F.h ? F.h[M] : void 0 : F.u[M + F.i];
              }
              function wo(F, M, H) {
                H = H === void 0 ? !1 : H;
                var ce = So(F, M, H);
                return ce == null && (ce = ko), ce === ko && (ce = Xo(ce.slice()), hr(F, M, ce, H)), ce;
              }
              function wn(F, M) {
                var H = wo(F, M);
                if (F.l || (F.l = {}), !F.l[M]) {
                  for (var ce = 0; ce < H.length; ce++)
                    H[ce] = +H[ce];
                  F.l[M] = !0;
                }
                return H;
              }
              function jn(F, M, H) {
                return F = So(F, M), F = F == null ? F : +F, F == null ? H === void 0 ? 0 : H : F;
              }
              function hr(F, M, H, ce) {
                ce !== void 0 && ce || M >= F.j ? (is(F), F.h[M] = H) : F.u[M + F.i] = H;
              }
              function po(F, M, H, ce) {
                H !== ce ? hr(F, M, H) : hr(F, M, void 0, !1);
              }
              function Po(F, M, H) {
                if (H === -1)
                  return null;
                F.g || (F.g = {});
                var ce = F.g[H];
                if (ce)
                  return ce;
                var ke = So(F, H, !1);
                return ke == null ? ce : (M = new M(ke), F.g[H] = M);
              }
              function Yo(F, M, H) {
                F.g || (F.g = {});
                var ce = F.g[H];
                if (!ce) {
                  var ke = wo(F, H, !1);
                  ce = [];
                  for (var st = 0; st < ke.length; st++)
                    ce[st] = new M(ke[st]);
                  F.g[H] = ce;
                }
                return ce;
              }
              function fi(F, M, H, ce, ke) {
                var st = Yo(F, ce, M);
                H = H || new ce(), F = wo(F, M), ke != null ? (st.splice(ke, 0, H), F.splice(ke, 0, H.u)) : (st.push(H), F.push(H.u));
              }
              li.prototype.toJSON = function() {
                return ul(this.u, na);
              }, li.prototype.toString = function() {
                return this.u.toString();
              };
              function ra(F, M) {
                return F = So(F, M), F == null ? 0 : F;
              }
              function ls(F, M) {
                return F = So(F, M), F == null ? "" : F;
              }
              function xs(F, M) {
                if (F = F.m) {
                  pa(M, M.g.end());
                  for (var H = 0; H < F.length; H++)
                    pa(M, F[H]);
                }
              }
              var Hs = Symbol();
              function hl(F, M, H) {
                return F[Hs] || (F[Hs] = function(ce, ke) {
                  return M(ce, ke, H);
                });
              }
              function bl(F) {
                var M = F[Hs];
                if (!M) {
                  var H = F[Os] || (F[Os] = F());
                  M = function(ce, ke) {
                    return cs(ce, ke, H);
                  }, F[Hs] = M;
                }
                return M;
              }
              function os(F) {
                var M = F.da;
                if (M)
                  return bl(M);
                if (M = F.ia) {
                  var H = F.Y;
                  return delete F.Y, hl(F.W.g, M, H);
                }
              }
              function Ps(F) {
                var M = os(F), H = F.W, ce = F.ea;
                return M ? function(ke, st) {
                  return ce(ke, st, H, M);
                } : function(ke, st) {
                  return ce(ke, st, H);
                };
              }
              function dd(F) {
                var M = F[0];
                switch (F.length) {
                  case 2:
                    var H = F[1];
                    return function(Zr, Pr, xr) {
                      return M(Zr, Pr, xr, H);
                    };
                  case 3:
                    var ce = F[1], ke = bl(F[2]);
                    return function(Zr, Pr, xr) {
                      return M(Zr, Pr, xr, ce, ke);
                    };
                  case 4:
                    var st = F[1], mt = F[3], xt = bl(F[2]);
                    return function(Zr, Pr, xr) {
                      return M(Zr, Pr, xr, st, xt, mt);
                    };
                  case 5:
                    var dn = F[1], Bn = hl(dn, F[3], F[4]);
                    return function(Zr, Pr, xr) {
                      return M(Zr, Pr, xr, dn, Bn);
                    };
                  case 6:
                    var Zn = F[1], ir = F[5], Ur = hl(Zn, F[3], F[4]);
                    return function(Zr, Pr, xr) {
                      return M(Zr, Pr, xr, Zn, Ur, ir);
                    };
                  default:
                    throw Error("Unsupported number of parameters, expected [2-6], got " + F.length);
                }
              }
              var Os = Symbol();
              function cs(F, M, H) {
                for (; Oa(M) && M.h != 4; ) {
                  var ce = M.i, ke = H[ce];
                  if (ke)
                    Array.isArray(ke) && (ke = H[ce] = dd(ke));
                  else {
                    var st = H[0];
                    st && (st = st[ce]) && (ke = H[ce] = Ps(st));
                  }
                  ke && ke(M, F, ce) || (ke = M, ce = F, st = ke.l, Jl(ke), ke.O || (ke = nl(ke.g.h, st, ke.g.g), (st = ce.m) ? st.push(ke) : ce.m = [ke]));
                }
                return F;
              }
              function Il(F, M) {
                var H = new il();
                if (M(F, H), F = H.i + H.g.length(), F === 0)
                  H = new Uint8Array(0);
                else {
                  F = new Uint8Array(F);
                  for (var ce = H.h, ke = ce.length, st = M = 0; st < ke; st++) {
                    var mt = ce[st];
                    mt.length !== 0 && (F.set(mt, M), M += mt.length);
                  }
                  ce = H.g, ke = ce.h, ke !== 0 && (F.set(ce.g.subarray(0, ke), M), ce.h = 0), H.h = [F], H = F;
                }
                return H;
              }
              function Ol(F, M, H) {
                if (Xs.length) {
                  var ce = Xs.pop();
                  F && (eo(ce.g, F), ce.i = -1, ce.h = -1), F = ce;
                } else
                  F = new Ts(F);
                try {
                  var ke = new M();
                  return cs(ke, F, H[Os] || (H[Os] = H()));
                } finally {
                  M = F.g, M.h = null, M.l = 0, M.i = 0, M.g = 0, M.j = !1, M.v = !1, F.i = -1, F.h = -1, F.j = !1, 100 > Xs.length && Xs.push(F);
                }
              }
              function bs(F, M, H) {
                if (M = So(M, H), M != null) {
                  Bs(F.g, 8 * H + 5), F = F.g;
                  var ce = M;
                  ce = (H = 0 > ce ? 1 : 0) ? -ce : ce, ce === 0 ? 0 < 1 / ce ? vs = bo = 0 : (bo = 0, vs = 2147483648) : isNaN(ce) ? (bo = 0, vs = 2147483647) : 34028234663852886e22 < ce ? (bo = 0, vs = (H << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > ce ? (ce = Math.round(ce / Math.pow(2, -149)), bo = 0, vs = (H << 31 | ce) >>> 0) : (M = Math.floor(Math.log(ce) / Math.LN2), ce *= Math.pow(2, -M), ce = Math.round(8388608 * ce), 16777216 <= ce && ++M, bo = 0, vs = (H << 31 | M + 127 << 23 | ce & 8388607) >>> 0), H = vs, go(F, H >>> 0 & 255), go(F, H >>> 8 & 255), go(F, H >>> 16 & 255), go(F, H >>> 24 & 255);
                }
              }
              function Jc(F, M, H) {
                if (F.h !== 1)
                  return !1;
                var ce = F.g;
                F = ns(ce);
                var ke = ns(ce);
                ce = 2 * (ke >> 31) + 1;
                var st = ke >>> 20 & 2047;
                return F = 4294967296 * (ke & 1048575) + F, po(M, H, st == 2047 ? F ? NaN : 1 / 0 * ce : st == 0 ? ce * Math.pow(2, -1074) * F : ce * Math.pow(2, st - 1075) * (F + 4503599627370496), 0), !0;
              }
              function Ks(F, M, H) {
                return F.h !== 5 ? !1 : (hr(M, H, F.g.m()), !0);
              }
              function Bl(F, M, H) {
                if (F.h !== 5 && F.h !== 2)
                  return !1;
                if (M = wo(M, H), F.h == 2) {
                  H = ss.prototype.m;
                  var ce = ua(F.g);
                  for (ce = F.g.g + ce; F.g.g < ce; )
                    M.push(H.call(F.g));
                } else
                  M.push(F.g.m());
                return !0;
              }
              function nc(F, M, H) {
                return F.h !== 5 ? !1 : (F = F.g.m(), po(M, H, F, 0), !0);
              }
              function Oc(F, M, H) {
                return F.h !== 0 ? !1 : (hr(M, H, Pa(F.g)), !0);
              }
              function ol(F, M, H) {
                return F.h !== 0 ? !1 : (hr(M, H, ua(F.g)), !0);
              }
              function rc(F, M, H) {
                return F.h !== 0 ? !1 : (F = ua(F.g), po(M, H, F, 0), !0);
              }
              function Ld(F, M, H) {
                return F.h !== 0 ? !1 : (F = !!ua(F.g), po(M, H, F, !1), !0);
              }
              function xd(F, M, H) {
                if (F.h !== 2)
                  return !1;
                var ce = ua(F.g);
                F = F.g;
                var ke = F.g;
                F.g += ce, Ao(F), F = F.h;
                var st;
                if (Uc)
                  (st = Hl) || (st = Hl = new TextDecoder("utf-8", { fatal: !1 })), st = st.decode(F.subarray(ke, ke + ce));
                else {
                  ce = ke + ce;
                  for (var mt = [], xt = null, dn, Bn, Zn; ke < ce; )
                    dn = F[ke++], 128 > dn ? mt.push(dn) : 224 > dn ? ke >= ce ? mt.push(65533) : (Bn = F[ke++], 194 > dn || (Bn & 192) !== 128 ? (ke--, mt.push(65533)) : mt.push((dn & 31) << 6 | Bn & 63)) : 240 > dn ? ke >= ce - 1 ? mt.push(65533) : (Bn = F[ke++], (Bn & 192) !== 128 || dn === 224 && 160 > Bn || dn === 237 && 160 <= Bn || ((st = F[ke++]) & 192) !== 128 ? (ke--, mt.push(65533)) : mt.push((dn & 15) << 12 | (Bn & 63) << 6 | st & 63)) : 244 >= dn ? ke >= ce - 2 ? mt.push(65533) : (Bn = F[ke++], (Bn & 192) !== 128 || (dn << 28) + (Bn - 144) >> 30 || ((st = F[ke++]) & 192) !== 128 || ((Zn = F[ke++]) & 192) !== 128 ? (ke--, mt.push(65533)) : (dn = (dn & 7) << 18 | (Bn & 63) << 12 | (st & 63) << 6 | Zn & 63, dn -= 65536, mt.push((dn >> 10 & 1023) + 55296, (dn & 1023) + 56320))) : mt.push(65533), 8192 <= mt.length && (xt = Ac(xt, mt), mt.length = 0);
                  st = Ac(xt, mt);
                }
                return hr(M, H, st), !0;
              }
              function ic(F, M, H, ce, ke) {
                return F.h !== 2 ? !1 : (F = rl(F, new ce(), ke), M.g || (M.g = {}), ce = F && F.u, M.g[H] = F, hr(M, H, ce, !1), !0);
              }
              function fc(F, M, H, ce, ke) {
                return F.h !== 2 ? !1 : (F = rl(F, new ce(), ke), fi(M, H, F, ce, void 0), !0);
              }
              function le(F, M, H) {
                return F.h !== 0 ? !1 : (hr(M, H, Pa(F.g)), !0);
              }
              function Ie(F) {
                li.call(this, F);
              }
              Nr(Ie, li);
              function Ze() {
                return { 1: ol, 2: Ks, 3: xd, 4: xd };
              }
              function Mt(F, M) {
                var H = So(F, 1);
                if (H != null && H != null) {
                  Bs(M.g, 8);
                  var ce = M.g;
                  if (0 <= H)
                    Bs(ce, H);
                  else {
                    for (var ke = 0; 9 > ke; ke++)
                      go(ce, H & 127 | 128), H >>= 7;
                    go(ce, 1);
                  }
                }
                bs(M, F, 2), ce = So(F, 3), ce != null && rs(M, 3, Nc(ce)), ce = So(F, 4), ce != null && rs(M, 4, Nc(ce)), xs(F, M);
              }
              function yn(F) {
                li.call(this, F, -1, mn);
              }
              Nr(yn, li), yn.prototype.addClassification = function(F, M) {
                return fi(this, 1, F, Ie, M), this;
              };
              function nr() {
                return { 1: [fc, Ie, Ze] };
              }
              var mn = [1];
              function zn(F) {
                li.call(this, F);
              }
              Nr(zn, li);
              function Wr() {
                return { 1: Ks, 2: Ks, 3: Ks, 4: Ks, 5: Ks };
              }
              function ci(F, M) {
                bs(M, F, 1), bs(M, F, 2), bs(M, F, 3), bs(M, F, 4), bs(M, F, 5), xs(F, M);
              }
              function Ki(F) {
                li.call(this, F, -1, yo);
              }
              Nr(Ki, li);
              function Gi() {
                return { 1: [fc, zn, Wr] };
              }
              var yo = [1];
              function Xi(F) {
                li.call(this, F);
              }
              Nr(Xi, li);
              function vi() {
                return { 1: Ks, 2: Ks, 3: Ks, 4: Ks, 5: Ks, 6: Oc };
              }
              function Yi(F, M) {
                bs(M, F, 1), bs(M, F, 2), bs(M, F, 3), bs(M, F, 4), bs(M, F, 5);
                var H = So(F, 6);
                if (H != null && H != null) {
                  Bs(M.g, 48);
                  var ce = M.g, ke = H;
                  H = 0 > ke, ke = Math.abs(ke);
                  var st = ke >>> 0;
                  for (ke = Math.floor((ke - st) / 4294967296), ke >>>= 0, H && (ke = ~ke >>> 0, st = (~st >>> 0) + 1, 4294967295 < st && (st = 0, ke++, 4294967295 < ke && (ke = 0))), vs = st, bo = ke, H = vs, st = bo; 0 < st || 127 < H; )
                    go(ce, H & 127 | 128), H = (H >>> 7 | st << 25) >>> 0, st >>>= 7;
                  go(ce, H);
                }
                xs(F, M);
              }
              function Fo(F) {
                li.call(this, F, -1, ds);
              }
              Nr(Fo, li);
              function Lo() {
                return { 1: le, 2: le, 3: Bl, 4: [ic, ia, ha], 5: ol, 6: ol, 7: Bl, 8: Bl, 9: Bl };
              }
              function ia(F) {
                li.call(this, F);
              }
              Nr(ia, li);
              function ha() {
                return { 1: Ks, 2: Ks, 3: Ks };
              }
              var ds = [3, 7, 8, 9];
              function q(F) {
                li.call(this, F);
              }
              Nr(q, li);
              function he() {
                return { 1: nc, 2: nc, 3: nc };
              }
              function ve(F) {
                li.call(this, F);
              }
              Nr(ve, li);
              function bt() {
                return { 1: nc, 2: nc, 3: nc };
              }
              function Ot(F) {
                li.call(this, F);
              }
              Nr(Ot, li);
              function In() {
                return { 1: rc, 2: [ic, ve, bt], 3: [ic, q, he], 4: Ld };
              }
              function en(F) {
                li.call(this, F, -1, dr);
              }
              Nr(en, li);
              function Gn() {
                return { 1: rc, 2: [fc, Ot, In], 3: nc, 4: Bl, 5: Bl, 6: Bl };
              }
              var dr = [2, 4, 5, 6];
              function D(F) {
                li.call(this, F, -1, Se);
              }
              Nr(D, li);
              function Fe() {
                return { 1: rc, 2: [fc, en, Gn], 3: [ic, Fo, Lo], 4: Jc, 5: Bl, 6: Bl };
              }
              var Se = [2, 5, 6];
              function it(F, M, H) {
                if (H = F.createShader(H === 0 ? F.VERTEX_SHADER : F.FRAGMENT_SHADER), F.shaderSource(H, M), F.compileShader(H), !F.getShaderParameter(H, F.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + F.getShaderInfoLog(H));
                return H;
              }
              function Gt(F) {
                return Yo(F, Ie, 1).map(function(M) {
                  return { index: ra(M, 1), $: jn(M, 2), label: So(M, 3) != null ? ls(M, 3) : void 0, displayName: So(M, 4) != null ? ls(M, 4) : void 0 };
                });
              }
              function nn(F) {
                return { x: jn(F, 1), y: jn(F, 2), z: jn(F, 3), visibility: So(F, 4) != null ? jn(F, 4) : void 0 };
              }
              function Pt(F, M) {
                this.h = F, this.g = M, this.l = 0;
              }
              function Mn(F, M, H) {
                return Nn(F, M), typeof F.g.canvas.transferToImageBitmap == "function" ? n.resolve(F.g.canvas.transferToImageBitmap()) : H ? n.resolve(F.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(F.g.canvas) : (F.i === void 0 && (F.i = document.createElement("canvas")), new n(function(ce) {
                  F.i.height = F.g.canvas.height, F.i.width = F.g.canvas.width, F.i.getContext("2d", {}).drawImage(F.g.canvas, 0, 0, F.g.canvas.width, F.g.canvas.height), ce(F.i);
                }));
              }
              function Nn(F, M) {
                var H = F.g;
                if (F.m === void 0) {
                  var ce = it(H, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), ke = it(H, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), st = H.createProgram();
                  if (H.attachShader(st, ce), H.attachShader(st, ke), H.linkProgram(st), !H.getProgramParameter(st, H.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + H.getProgramInfoLog(st));
                  ce = F.m = st, H.useProgram(ce), ke = H.getUniformLocation(ce, "sampler0"), F.j = { J: H.getAttribLocation(ce, "aVertex"), I: H.getAttribLocation(ce, "aTex"), ja: ke }, F.s = H.createBuffer(), H.bindBuffer(H.ARRAY_BUFFER, F.s), H.enableVertexAttribArray(F.j.J), H.vertexAttribPointer(F.j.J, 2, H.FLOAT, !1, 0, 0), H.bufferData(H.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), H.STATIC_DRAW), H.bindBuffer(H.ARRAY_BUFFER, null), F.o = H.createBuffer(), H.bindBuffer(H.ARRAY_BUFFER, F.o), H.enableVertexAttribArray(F.j.I), H.vertexAttribPointer(
                    F.j.I,
                    2,
                    H.FLOAT,
                    !1,
                    0,
                    0
                  ), H.bufferData(H.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), H.STATIC_DRAW), H.bindBuffer(H.ARRAY_BUFFER, null), H.uniform1i(ke, 0);
                }
                ce = F.j, H.useProgram(F.m), H.canvas.width = M.width, H.canvas.height = M.height, H.viewport(0, 0, M.width, M.height), H.activeTexture(H.TEXTURE0), F.h.bindTexture2d(M.glName), H.enableVertexAttribArray(ce.J), H.bindBuffer(H.ARRAY_BUFFER, F.s), H.vertexAttribPointer(ce.J, 2, H.FLOAT, !1, 0, 0), H.enableVertexAttribArray(ce.I), H.bindBuffer(H.ARRAY_BUFFER, F.o), H.vertexAttribPointer(
                  ce.I,
                  2,
                  H.FLOAT,
                  !1,
                  0,
                  0
                ), H.bindFramebuffer(H.DRAW_FRAMEBUFFER ? H.DRAW_FRAMEBUFFER : H.FRAMEBUFFER, null), H.clearColor(0, 0, 0, 0), H.clear(H.COLOR_BUFFER_BIT), H.colorMask(!0, !0, !0, !0), H.drawArrays(H.TRIANGLE_FAN, 0, 4), H.disableVertexAttribArray(ce.J), H.disableVertexAttribArray(ce.I), H.bindBuffer(H.ARRAY_BUFFER, null), F.h.bindTexture2d(0);
              }
              function Xr(F) {
                this.g = F;
              }
              var ei = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function ji(F, M) {
                return M + F;
              }
              function di(F, M) {
                window[F] = M;
              }
              function Cr(F) {
                var M = document.createElement("script");
                return M.setAttribute("src", F), M.setAttribute("crossorigin", "anonymous"), new n(function(H) {
                  M.addEventListener("load", function() {
                    H();
                  }, !1), M.addEventListener("error", function() {
                    H();
                  }, !1), document.body.appendChild(M);
                });
              }
              function ni() {
                return Mr(function(F) {
                  switch (F.g) {
                    case 1:
                      return F.m = 2, Un(F, WebAssembly.instantiate(ei), 4);
                    case 4:
                      F.g = 3, F.m = 0;
                      break;
                    case 2:
                      return F.m = 0, F.j = null, F.return(!1);
                    case 3:
                      return F.return(!0);
                  }
                });
              }
              function Ai(F) {
                if (this.g = F, this.listeners = {}, this.j = {}, this.G = {}, this.m = {}, this.s = {}, this.H = this.o = this.S = !0, this.D = n.resolve(), this.R = "", this.C = {}, this.locateFile = F && F.locateFile || ji, typeof window == "object")
                  var M = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  M = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.T = M, F.options) {
                  M = rt(Object.keys(F.options));
                  for (var H = M.next(); !H.done; H = M.next()) {
                    H = H.value;
                    var ce = F.options[H].default;
                    ce !== void 0 && (this.j[H] = typeof ce == "function" ? ce() : ce);
                  }
                }
              }
              E = Ai.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function Ri(F) {
                var M, H, ce, ke, st, mt, xt, dn, Bn, Zn, ir;
                return Mr(function(Ur) {
                  switch (Ur.g) {
                    case 1:
                      return F.S ? (M = F.g.files === void 0 ? [] : typeof F.g.files == "function" ? F.g.files(F.j) : F.g.files, Un(Ur, ni(), 2)) : Ur.return();
                    case 2:
                      if (H = Ur.h, typeof window == "object")
                        return di("createMediapipeSolutionsWasm", { locateFile: F.locateFile }), di("createMediapipeSolutionsPackedAssets", { locateFile: F.locateFile }), mt = M.filter(function(Zr) {
                          return Zr.data !== void 0;
                        }), xt = M.filter(function(Zr) {
                          return Zr.data === void 0;
                        }), dn = n.all(mt.map(function(Zr) {
                          var Pr = me(F, Zr.url);
                          if (Zr.path !== void 0) {
                            var xr = Zr.path;
                            Pr = Pr.then(function(oo) {
                              return F.overrideFile(xr, oo), n.resolve(oo);
                            });
                          }
                          return Pr;
                        })), Bn = n.all(xt.map(function(Zr) {
                          return Zr.simd === void 0 || Zr.simd && H || !Zr.simd && !H ? Cr(F.locateFile(Zr.url, F.T)) : n.resolve();
                        })).then(function() {
                          var Zr, Pr, xr;
                          return Mr(function(oo) {
                            if (oo.g == 1)
                              return Zr = window.createMediapipeSolutionsWasm, Pr = window.createMediapipeSolutionsPackedAssets, xr = F, Un(oo, Zr(Pr), 2);
                            xr.h = oo.h, oo.g = 0;
                          });
                        }), Zn = function() {
                          return Mr(function(Zr) {
                            return F.g.graph && F.g.graph.url ? Zr = Un(
                              Zr,
                              me(F, F.g.graph.url),
                              0
                            ) : (Zr.g = 0, Zr = void 0), Zr;
                          });
                        }(), Un(Ur, n.all([Bn, dn, Zn]), 7);
                      if (typeof importScripts != "function")
                        throw Error("solutions can only be loaded on a web page or in a web worker");
                      return ce = M.filter(function(Zr) {
                        return Zr.simd === void 0 || Zr.simd && H || !Zr.simd && !H;
                      }).map(function(Zr) {
                        return F.locateFile(Zr.url, F.T);
                      }), importScripts.apply(null, Nt(ce)), ke = F, Un(Ur, createMediapipeSolutionsWasm(Module), 6);
                    case 6:
                      ke.h = Ur.h, F.l = new OffscreenCanvas(1, 1), F.h.canvas = F.l, st = F.h.GL.createContext(F.l, {
                        antialias: !1,
                        alpha: !1,
                        ga: typeof WebGL2RenderingContext < "u" ? 2 : 1
                      }), F.h.GL.makeContextCurrent(st), Ur.g = 4;
                      break;
                    case 7:
                      if (F.l = document.createElement("canvas"), ir = F.l.getContext("webgl2", {}), !ir && (ir = F.l.getContext("webgl", {}), !ir))
                        return alert("Failed to create WebGL canvas context when passing video frame."), Ur.return();
                      F.F = ir, F.h.canvas = F.l, F.h.createContext(F.l, !0, !0, {});
                    case 4:
                      F.i = new F.h.SolutionWasm(), F.S = !1, Ur.g = 0;
                  }
                });
              }
              function Ii(F) {
                var M, H, ce, ke, st, mt, xt, dn;
                return Mr(function(Bn) {
                  if (Bn.g == 1) {
                    if (F.g.graph && F.g.graph.url && F.R === F.g.graph.url)
                      return Bn.return();
                    if (F.o = !0, !F.g.graph || !F.g.graph.url) {
                      Bn.g = 2;
                      return;
                    }
                    return F.R = F.g.graph.url, Un(Bn, me(F, F.g.graph.url), 3);
                  }
                  for (Bn.g != 2 && (M = Bn.h, F.i.loadGraph(M)), H = rt(Object.keys(F.C)), ce = H.next(); !ce.done; ce = H.next())
                    ke = ce.value, F.i.overrideFile(ke, F.C[ke]);
                  if (F.C = {}, F.g.listeners)
                    for (st = rt(F.g.listeners), mt = st.next(); !mt.done; mt = st.next())
                      xt = mt.value, Tt(F, xt);
                  dn = F.j, F.j = {}, F.setOptions(dn), Bn.g = 0;
                });
              }
              E.reset = function() {
                var F = this;
                return Mr(function(M) {
                  F.i && (F.i.reset(), F.m = {}, F.s = {}), M.g = 0;
                });
              }, E.setOptions = function(F, M) {
                var H = this;
                if (M = M || this.g.options) {
                  for (var ce = [], ke = [], st = {}, mt = rt(Object.keys(F)), xt = mt.next(); !xt.done; st = { L: st.L, M: st.M }, xt = mt.next()) {
                    var dn = xt.value;
                    dn in this.j && this.j[dn] === F[dn] || (this.j[dn] = F[dn], xt = M[dn], xt !== void 0 && (xt.onChange && (st.L = xt.onChange, st.M = F[dn], ce.push(/* @__PURE__ */ function(Bn) {
                      return function() {
                        var Zn;
                        return Mr(function(ir) {
                          if (ir.g == 1)
                            return Un(ir, Bn.L(Bn.M), 2);
                          Zn = ir.h, Zn === !0 && (H.o = !0), ir.g = 0;
                        });
                      };
                    }(st))), xt.graphOptionXref && (dn = { valueNumber: xt.type === 1 ? F[dn] : 0, valueBoolean: xt.type === 0 ? F[dn] : !1, valueString: xt.type === 2 ? F[dn] : "" }, xt = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), xt.graphOptionXref), dn), ke.push(xt))));
                  }
                  (ce.length !== 0 || ke.length !== 0) && (this.o = !0, this.B = (this.B === void 0 ? [] : this.B).concat(ke), this.A = (this.A === void 0 ? [] : this.A).concat(ce));
                }
              };
              function Y(F) {
                var M, H, ce, ke, st, mt, xt;
                return Mr(function(dn) {
                  switch (dn.g) {
                    case 1:
                      if (!F.o)
                        return dn.return();
                      if (!F.A) {
                        dn.g = 2;
                        break;
                      }
                      M = rt(F.A), H = M.next();
                    case 3:
                      if (H.done) {
                        dn.g = 5;
                        break;
                      }
                      return ce = H.value, Un(dn, ce(), 4);
                    case 4:
                      H = M.next(), dn.g = 3;
                      break;
                    case 5:
                      F.A = void 0;
                    case 2:
                      if (F.B) {
                        for (ke = new F.h.GraphOptionChangeRequestList(), st = rt(F.B), mt = st.next(); !mt.done; mt = st.next())
                          xt = mt.value, ke.push_back(xt);
                        F.i.changeOptions(ke), ke.delete(), F.B = void 0;
                      }
                      F.o = !1, dn.g = 0;
                  }
                });
              }
              E.initialize = function() {
                var F = this;
                return Mr(function(M) {
                  return M.g == 1 ? Un(M, Ri(F), 2) : M.g != 3 ? Un(M, Ii(F), 3) : Un(M, Y(F), 0);
                });
              };
              function me(F, M) {
                var H, ce;
                return Mr(function(ke) {
                  return M in F.G ? ke.return(F.G[M]) : (H = F.locateFile(M, ""), ce = fetch(H).then(function(st) {
                    return st.arrayBuffer();
                  }), F.G[M] = ce, ke.return(ce));
                });
              }
              E.overrideFile = function(F, M) {
                this.i ? this.i.overrideFile(F, M) : this.C[F] = M;
              }, E.clearOverriddenFiles = function() {
                this.C = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(F, M) {
                var H = this, ce, ke, st, mt, xt, dn, Bn, Zn, ir;
                return Mr(function(Ur) {
                  switch (Ur.g) {
                    case 1:
                      return H.g.inputs ? (ce = 1e3 * (M == null ? performance.now() : M), Un(Ur, H.D, 2)) : Ur.return();
                    case 2:
                      return Un(Ur, H.initialize(), 3);
                    case 3:
                      for (ke = new H.h.PacketDataList(), st = rt(Object.keys(F)), mt = st.next(); !mt.done; mt = st.next())
                        if (xt = mt.value, dn = H.g.inputs[xt]) {
                          e: {
                            var Zr = F[xt];
                            switch (dn.type) {
                              case "video":
                                var Pr = H.m[dn.stream];
                                if (Pr || (Pr = new Pt(H.h, H.F), H.m[dn.stream] = Pr), Pr.l === 0 && (Pr.l = Pr.h.createTexture()), typeof HTMLVideoElement < "u" && Zr instanceof HTMLVideoElement)
                                  var xr = Zr.videoWidth, oo = Zr.videoHeight;
                                else
                                  typeof HTMLImageElement < "u" && Zr instanceof HTMLImageElement ? (xr = Zr.naturalWidth, oo = Zr.naturalHeight) : (xr = Zr.width, oo = Zr.height);
                                oo = { glName: Pr.l, width: xr, height: oo }, xr = Pr.g, xr.canvas.width = oo.width, xr.canvas.height = oo.height, xr.activeTexture(xr.TEXTURE0), Pr.h.bindTexture2d(Pr.l), xr.texImage2D(xr.TEXTURE_2D, 0, xr.RGBA, xr.RGBA, xr.UNSIGNED_BYTE, Zr), Pr.h.bindTexture2d(0), Pr = oo;
                                break e;
                              case "detections":
                                for (Pr = H.m[dn.stream], Pr || (Pr = new Xr(H.h), H.m[dn.stream] = Pr), Pr.data || (Pr.data = new Pr.g.DetectionListData()), Pr.data.reset(Zr.length), oo = 0; oo < Zr.length; ++oo) {
                                  xr = Zr[oo];
                                  var Do = Pr.data, Mo = Do.setBoundingBox, gs = oo, Gl = xr.U, fs = new Xi();
                                  if (hr(fs, 1, Gl.aa), hr(fs, 2, Gl.ba), hr(fs, 3, Gl.height), hr(fs, 4, Gl.width), hr(fs, 5, Gl.rotation), hr(fs, 6, Gl.Z), Gl = Il(fs, Yi), Mo.call(Do, gs, Gl), xr.P)
                                    for (Do = 0; Do < xr.P.length; ++Do) {
                                      fs = xr.P[Do];
                                      var Ic = !!fs.visibility;
                                      Mo = Pr.data, gs = Mo.addNormalizedLandmark, Gl = oo, fs = Object.assign(Object.assign({}, fs), { visibility: Ic ? fs.visibility : 0 }), Ic = new zn(), hr(Ic, 1, fs.x), hr(Ic, 2, fs.y), hr(Ic, 3, fs.z), fs.visibility && hr(Ic, 4, fs.visibility), fs = Il(Ic, ci), gs.call(Mo, Gl, fs);
                                    }
                                  if (xr.N)
                                    for (Do = 0; Do < xr.N.length; ++Do)
                                      Mo = Pr.data, gs = Mo.addClassification, Gl = oo, fs = xr.N[Do], Ic = new Ie(), hr(Ic, 2, fs.$), fs.index && hr(Ic, 1, fs.index), fs.label && hr(Ic, 3, fs.label), fs.displayName && hr(Ic, 4, fs.displayName), fs = Il(Ic, Mt), gs.call(Mo, Gl, fs);
                                }
                                Pr = Pr.data;
                                break e;
                              default:
                                Pr = {};
                            }
                          }
                          switch (Bn = Pr, Zn = dn.stream, dn.type) {
                            case "video":
                              ke.pushTexture2d(Object.assign(Object.assign({}, Bn), { stream: Zn, timestamp: ce }));
                              break;
                            case "detections":
                              ir = Bn, ir.stream = Zn, ir.timestamp = ce, ke.pushDetectionList(ir);
                              break;
                            default:
                              throw Error("Unknown input config type: '" + dn.type + "'");
                          }
                        }
                      return H.i.send(ke), Un(Ur, H.D, 4);
                    case 4:
                      ke.delete(), Ur.g = 0;
                  }
                });
              };
              function Ee(F, M, H) {
                var ce, ke, st, mt, xt, dn, Bn, Zn, ir, Ur, Zr, Pr, xr, oo;
                return Mr(function(Do) {
                  switch (Do.g) {
                    case 1:
                      if (!H)
                        return Do.return(M);
                      for (ce = {}, ke = 0, st = rt(Object.keys(H)), mt = st.next(); !mt.done; mt = st.next())
                        xt = mt.value, dn = H[xt], typeof dn != "string" && dn.type === "texture" && M[dn.stream] !== void 0 && ++ke;
                      1 < ke && (F.H = !1), Bn = rt(Object.keys(H)), mt = Bn.next();
                    case 2:
                      if (mt.done) {
                        Do.g = 4;
                        break;
                      }
                      if (Zn = mt.value, ir = H[Zn], typeof ir == "string")
                        return xr = ce, oo = Zn, Un(Do, je(F, Zn, M[ir]), 14);
                      if (Ur = M[ir.stream], ir.type === "detection_list") {
                        if (Ur) {
                          for (var Mo = Ur.getRectList(), gs = Ur.getLandmarksList(), Gl = Ur.getClassificationsList(), fs = [], Ic = 0; Ic < Mo.size(); ++Ic) {
                            var Y0 = Ol(Mo.get(Ic), Xi, vi);
                            Y0 = { U: { aa: jn(Y0, 1), ba: jn(Y0, 2), height: jn(Y0, 3), width: jn(Y0, 4), rotation: jn(Y0, 5, 0), Z: ra(Y0, 6) }, P: Yo(Ol(gs.get(Ic), Ki, Gi), zn, 1).map(nn), N: Gt(Ol(Gl.get(Ic), yn, nr)) }, fs.push(Y0);
                          }
                          Mo = fs;
                        } else
                          Mo = [];
                        ce[Zn] = Mo, Do.g = 7;
                        break;
                      }
                      if (ir.type === "proto_list") {
                        if (Ur) {
                          for (Mo = Array(Ur.size()), gs = 0; gs < Ur.size(); gs++)
                            Mo[gs] = Ur.get(gs);
                          Ur.delete();
                        } else
                          Mo = [];
                        ce[Zn] = Mo, Do.g = 7;
                        break;
                      }
                      if (Ur === void 0) {
                        Do.g = 3;
                        break;
                      }
                      if (ir.type === "float_list") {
                        ce[Zn] = Ur, Do.g = 7;
                        break;
                      }
                      if (ir.type === "proto") {
                        ce[Zn] = Ur, Do.g = 7;
                        break;
                      }
                      if (ir.type !== "texture")
                        throw Error("Unknown output config type: '" + ir.type + "'");
                      return Zr = F.s[Zn], Zr || (Zr = new Pt(F.h, F.F), F.s[Zn] = Zr), Un(Do, Mn(Zr, Ur, F.H), 13);
                    case 13:
                      Pr = Do.h, ce[Zn] = Pr;
                    case 7:
                      ir.transform && ce[Zn] && (ce[Zn] = ir.transform(ce[Zn])), Do.g = 3;
                      break;
                    case 14:
                      xr[oo] = Do.h;
                    case 3:
                      mt = Bn.next(), Do.g = 2;
                      break;
                    case 4:
                      return Do.return(ce);
                  }
                });
              }
              function je(F, M, H) {
                var ce;
                return Mr(function(ke) {
                  return typeof H == "number" || H instanceof Uint8Array || H instanceof F.h.Uint8BlobList ? ke.return(H) : H instanceof F.h.Texture2dDataOut ? (ce = F.s[M], ce || (ce = new Pt(F.h, F.F), F.s[M] = ce), ke.return(Mn(ce, H, F.H))) : ke.return(void 0);
                });
              }
              function Tt(F, M) {
                for (var H = M.name || "$", ce = [].concat(Nt(M.wants)), ke = new F.h.StringList(), st = rt(M.wants), mt = st.next(); !mt.done; mt = st.next())
                  ke.push_back(mt.value);
                st = F.h.PacketListener.implement({ onResults: function(xt) {
                  for (var dn = {}, Bn = 0; Bn < M.wants.length; ++Bn)
                    dn[ce[Bn]] = xt.get(Bn);
                  var Zn = F.listeners[H];
                  Zn && (F.D = Ee(F, dn, M.outs).then(function(ir) {
                    ir = Zn(ir);
                    for (var Ur = 0; Ur < M.wants.length; ++Ur) {
                      var Zr = dn[ce[Ur]];
                      typeof Zr == "object" && Zr.hasOwnProperty && Zr.hasOwnProperty("delete") && Zr.delete();
                    }
                    ir && (F.D = ir);
                  }));
                } }), F.i.attachMultiListener(ke, st), ke.delete();
              }
              E.onResults = function(F, M) {
                this.listeners[M || "$"] = F;
              }, Ji("Solution", Ai), Ji("OptionType", { BOOL: 0, NUMBER: 1, ca: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function X(F) {
                var M = ra(F, 1), H = Po(F, q, 3);
                return H = { x: jn(H, 1), y: jn(H, 2), depth: jn(H, 3) }, F = Po(F, ve, 2), { id: M, point2d: H, point3d: { x: jn(F, 1), y: jn(F, 2), z: jn(F, 3) } };
              }
              function j(F) {
                var M = Ol(F, D, Fe);
                F = [], M = Yo(M, en, 2);
                for (var H = 0; H < M.length; H++)
                  F.push({ id: ra(M[H], 1), keypoints: Yo(M[H], Ot, 2).map(X), visibility: jn(M[H], 3), scale: wn(M[H], 6), translation: wn(M[H], 5), rotation: wn(M[H], 4) });
                return F;
              }
              function Ae(F) {
                switch (F) {
                  case "Camera":
                    return "object_detection_3d_camera.tflite";
                  case "Chair":
                    return "object_detection_3d_chair.tflite";
                  case "Cup":
                    return "object_detection_3d_cup.tflite";
                  default:
                    return "object_detection_3d_sneakers.tflite";
                }
              }
              function C(F) {
                switch (F) {
                  case "Camera":
                    return "Camera";
                  case "Chair":
                    return "Chair";
                  case "Cup":
                    return "Coffee cup, Mug";
                  default:
                    return "Footwear";
                }
              }
              var x = {
                focalX: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_focal_x" } },
                focalY: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_focal_y" } },
                principalX: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_principal_point_x" } },
                principalY: { type: 1, graphOptionXref: { calculatorType: "Lift2DFrameAnnotationTo3DCalculator", fieldName: "normalized_principal_point_y" } },
                allowedLabels: { type: 2, graphOptionXref: { calculatorName: "ConstantSidePacketCalculatorAllowedLabels", calculatorType: "ConstantSidePacketCalculator", fieldName: "string_value" } }
              };
              function ee(F) {
                var M = this;
                F = F || {}, this.g = new Ai({ locateFile: F.locateFile, files: [{ url: "objectron_solution_packed_assets_loader.js" }, { simd: !1, url: "objectron_solution_wasm_bin.js" }, { simd: !0, url: "objectron_solution_simd_wasm_bin.js" }], graph: { url: "objectron.binarypb" }, inputs: { image: { type: "video", stream: "input_frames_gpu" } }, listeners: [{ wants: ["lifted_objects", "image_transformed"], outs: { image: "image_transformed", objectDetections: { type: "proto", stream: "lifted_objects", transform: j } } }], options: {
                  useCpuInference: {
                    type: 0,
                    graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" },
                    default: typeof window != "object" || window.navigator === void 0 ? !1 : "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document
                  },
                  selfieMode: { type: 0, default: !1, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
                  maxNumObjects: { type: 1, default: 5, graphOptionXref: {
                    calculatorType: "ConstantSidePacketCalculator",
                    calculatorName: "ConstantSidePacketCalculatorMaxNumObjects",
                    fieldName: "int_value"
                  } },
                  staticImageMode: { type: 0, default: !0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "objectrongpusubgraph__ConstantSidePacketCalculator", fieldName: "bool_value" } },
                  minDetectionConfidence: { type: 1, default: 0.5, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "objectrongpusubgraph__objectdetectionoidv4subgraph__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
                  minTrackingConfidence: { type: 1, default: 0.99, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "objectrongpusubgraph__boxlandmarksubgraph__ThresholdingCalculator", fieldName: "threshold" } },
                  modelName: { default: "Shoe", onChange: function(H) {
                    var ce, ke, st, mt;
                    return Mr(function(xt) {
                      return xt.g == 1 ? (ce = H, M.g.setOptions({ allowedLabels: C(ce) }, x), ke = Ae(ce), st = "object_detection_3d.tflite", Un(xt, me(M.g, ke), 2)) : (mt = xt.h, M.g.overrideFile(st, mt), xt.return(!0));
                    });
                  } },
                  focalLength: { default: [1, 1], onChange: function(H) {
                    var ce;
                    return Mr(function(ke) {
                      return ce = H, M.h = ce, M.g.setOptions({ focalX: ce[0], focalY: ce[1] }, x), ke.return(!0);
                    });
                  } },
                  principalPoint: { default: [0, 0], onChange: function(H) {
                    var ce;
                    return Mr(function(ke) {
                      return ce = H, M.i = ce, M.g.setOptions({ principalX: ce[0], principalY: ce[1] }, x), ke.return(!0);
                    });
                  } },
                  imageSize: { onChange: function(H) {
                    var ce, ke, st, mt;
                    return Mr(function(xt) {
                      if (M.h === void 0 || M.i === void 0)
                        return console.error('"focalLength" and "principalPoint" must be set if setting image size'), xt.return();
                      ce = H, ke = [ce[0] / 2, ce[1] / 2], st = [
                        M.h[0] / ke[0],
                        M.h[1] / ke[1]
                      ], mt = [M.i[0] / ke[0], M.i[1] / ke[1]], M.setOptions({ focalLength: st, principalPoint: mt }), xt.g = 0;
                    });
                  } }
                } });
              }
              E = ee.prototype, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(F) {
                this.g.onResults(F);
              }, E.initialize = function() {
                var F = this;
                return Mr(function(M) {
                  return Un(M, F.g.initialize(), 0);
                });
              }, E.reset = function() {
                this.g.reset();
              }, E.send = function(F) {
                var M = this;
                return Mr(function(H) {
                  return Un(H, M.g.send(F), 0);
                });
              }, E.setOptions = function(F) {
                this.g.setOptions(F);
              }, Ji("Objectron", ee), Ji("BOX_CONNECTIONS", [[1, 2], [2, 4], [4, 3], [3, 1], [5, 6], [6, 8], [8, 7], [7, 5], [1, 5], [2, 6], [3, 7], [4, 8]]), Ji("BOX_KEYPOINTS", { CENTER: 0, BACK_BOTTOM_LEFT: 1, FRONT_BOTTOM_LEFT: 2, BACK_TOP_LEFT: 3, FRONT_TOP_LEFT: 4, BACK_BOTTOM_RIGHT: 5, FRONT_BOTTOM_RIGHT: 6, BACK_TOP_RIGHT: 7, FRONT_TOP_RIGHT: 8 }), Ji("VERSION", "0.4.1636596145");
            }).call(St);
            const Vt = {};
            (function() {
              var E;
              function R(D) {
                var Fe = 0;
                return function() {
                  return Fe < D.length ? { done: !1, value: D[Fe++] } : { done: !0 };
                };
              }
              var S = typeof Object.defineProperties == "function" ? Object.defineProperty : function(D, Fe, Se) {
                return D == Array.prototype || D == Object.prototype || (D[Fe] = Se.value), D;
              };
              function ie(D) {
                D = [typeof globalThis == "object" && globalThis, D, typeof window == "object" && window, typeof self == "object" && self, typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn)];
                for (var Fe = 0; Fe < D.length; ++Fe) {
                  var Se = D[Fe];
                  if (Se && Se.Math == Math)
                    return Se;
                }
                throw Error("Cannot find global object");
              }
              var pe = ie(this);
              function De(D, Fe) {
                if (Fe)
                  e: {
                    var Se = pe;
                    D = D.split(".");
                    for (var it = 0; it < D.length - 1; it++) {
                      var Gt = D[it];
                      if (!(Gt in Se))
                        break e;
                      Se = Se[Gt];
                    }
                    D = D[D.length - 1], it = Se[D], Fe = Fe(it), Fe != it && Fe != null && S(Se, D, { configurable: !0, writable: !0, value: Fe });
                  }
              }
              De("Symbol", function(D) {
                function Fe(nn) {
                  if (this instanceof Fe)
                    throw new TypeError("Symbol is not a constructor");
                  return new Se(it + (nn || "") + "_" + Gt++, nn);
                }
                function Se(nn, Pt) {
                  this.g = nn, S(this, "description", { configurable: !0, writable: !0, value: Pt });
                }
                if (D)
                  return D;
                Se.prototype.toString = function() {
                  return this.g;
                };
                var it = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", Gt = 0;
                return Fe;
              }), De("Symbol.iterator", function(D) {
                if (D)
                  return D;
                D = Symbol("Symbol.iterator");
                for (var Fe = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), Se = 0; Se < Fe.length; Se++) {
                  var it = pe[Fe[Se]];
                  typeof it == "function" && typeof it.prototype[D] != "function" && S(it.prototype, D, { configurable: !0, writable: !0, value: function() {
                    return ht(R(this));
                  } });
                }
                return D;
              });
              function ht(D) {
                return D = { next: D }, D[Symbol.iterator] = function() {
                  return this;
                }, D;
              }
              function rt(D) {
                var Fe = typeof Symbol < "u" && Symbol.iterator && D[Symbol.iterator];
                return Fe ? Fe.call(D) : { next: R(D) };
              }
              function Nt(D) {
                if (!(D instanceof Array)) {
                  D = rt(D);
                  for (var Fe, Se = []; !(Fe = D.next()).done; )
                    Se.push(Fe.value);
                  D = Se;
                }
                return D;
              }
              var Pn = typeof Object.create == "function" ? Object.create : function(D) {
                function Fe() {
                }
                return Fe.prototype = D, new Fe();
              }, cr;
              if (typeof Object.setPrototypeOf == "function")
                cr = Object.setPrototypeOf;
              else {
                var Vr;
                e: {
                  var mi = { a: !0 }, Fi = {};
                  try {
                    Fi.__proto__ = mi, Vr = Fi.a;
                    break e;
                  } catch {
                  }
                  Vr = !1;
                }
                cr = Vr ? function(D, Fe) {
                  if (D.__proto__ = Fe, D.__proto__ !== Fe)
                    throw new TypeError(D + " is not extensible");
                  return D;
                } : null;
              }
              var br = cr;
              function Nr(D, Fe) {
                if (D.prototype = Pn(Fe.prototype), D.prototype.constructor = D, br)
                  br(D, Fe);
                else
                  for (var Se in Fe)
                    if (Se != "prototype")
                      if (Object.defineProperties) {
                        var it = Object.getOwnPropertyDescriptor(Fe, Se);
                        it && Object.defineProperty(D, Se, it);
                      } else
                        D[Se] = Fe[Se];
                D.ea = Fe.prototype;
              }
              function $i() {
                this.l = !1, this.i = null, this.h = void 0, this.g = 1, this.s = this.m = 0, this.j = null;
              }
              function qi(D) {
                if (D.l)
                  throw new TypeError("Generator is already running");
                D.l = !0;
              }
              $i.prototype.o = function(D) {
                this.h = D;
              };
              function Vo(D, Fe) {
                D.j = { U: Fe, V: !0 }, D.g = D.m || D.s;
              }
              $i.prototype.return = function(D) {
                this.j = { return: D }, this.g = this.s;
              };
              function Un(D, Fe, Se) {
                return D.g = Se, { value: Fe };
              }
              function el(D) {
                this.g = new $i(), this.h = D;
              }
              function Ys(D, Fe) {
                qi(D.g);
                var Se = D.g.i;
                return Se ? Ca(D, "return" in Se ? Se.return : function(it) {
                  return { value: it, done: !0 };
                }, Fe, D.g.return) : (D.g.return(Fe), lo(D));
              }
              function Ca(D, Fe, Se, it) {
                try {
                  var Gt = Fe.call(D.g.i, Se);
                  if (!(Gt instanceof Object))
                    throw new TypeError("Iterator result " + Gt + " is not an object");
                  if (!Gt.done)
                    return D.g.l = !1, Gt;
                  var nn = Gt.value;
                } catch (Pt) {
                  return D.g.i = null, Vo(D.g, Pt), lo(D);
                }
                return D.g.i = null, it.call(D.g, nn), lo(D);
              }
              function lo(D) {
                for (; D.g.g; )
                  try {
                    var Fe = D.h(D.g);
                    if (Fe)
                      return D.g.l = !1, { value: Fe.value, done: !1 };
                  } catch (Se) {
                    D.g.h = void 0, Vo(D.g, Se);
                  }
                if (D.g.l = !1, D.g.j) {
                  if (Fe = D.g.j, D.g.j = null, Fe.V)
                    throw Fe.U;
                  return { value: Fe.return, done: !0 };
                }
                return { value: void 0, done: !0 };
              }
              function Cc(D) {
                this.next = function(Fe) {
                  return qi(D.g), D.g.i ? Fe = Ca(D, D.g.i.next, Fe, D.g.o) : (D.g.o(Fe), Fe = lo(D)), Fe;
                }, this.throw = function(Fe) {
                  return qi(D.g), D.g.i ? Fe = Ca(D, D.g.i.throw, Fe, D.g.o) : (Vo(D.g, Fe), Fe = lo(D)), Fe;
                }, this.return = function(Fe) {
                  return Ys(D, Fe);
                }, this[Symbol.iterator] = function() {
                  return this;
                };
              }
              function Go(D) {
                function Fe(it) {
                  return D.next(it);
                }
                function Se(it) {
                  return D.throw(it);
                }
                return new n(function(it, Gt) {
                  function nn(Pt) {
                    Pt.done ? it(Pt.value) : n.resolve(Pt.value).then(Fe, Se).then(nn, Gt);
                  }
                  nn(D.next());
                });
              }
              function Mr(D) {
                return Go(new Cc(new el(D)));
              }
              De("Promise", function(D) {
                function Fe(Pt) {
                  this.h = 0, this.i = void 0, this.g = [], this.o = !1;
                  var Mn = this.j();
                  try {
                    Pt(Mn.resolve, Mn.reject);
                  } catch (Nn) {
                    Mn.reject(Nn);
                  }
                }
                function Se() {
                  this.g = null;
                }
                function it(Pt) {
                  return Pt instanceof Fe ? Pt : new Fe(function(Mn) {
                    Mn(Pt);
                  });
                }
                if (D)
                  return D;
                Se.prototype.h = function(Pt) {
                  if (this.g == null) {
                    this.g = [];
                    var Mn = this;
                    this.i(function() {
                      Mn.l();
                    });
                  }
                  this.g.push(Pt);
                };
                var Gt = pe.setTimeout;
                Se.prototype.i = function(Pt) {
                  Gt(Pt, 0);
                }, Se.prototype.l = function() {
                  for (; this.g && this.g.length; ) {
                    var Pt = this.g;
                    this.g = [];
                    for (var Mn = 0; Mn < Pt.length; ++Mn) {
                      var Nn = Pt[Mn];
                      Pt[Mn] = null;
                      try {
                        Nn();
                      } catch (Xr) {
                        this.j(Xr);
                      }
                    }
                  }
                  this.g = null;
                }, Se.prototype.j = function(Pt) {
                  this.i(function() {
                    throw Pt;
                  });
                }, Fe.prototype.j = function() {
                  function Pt(Xr) {
                    return function(ei) {
                      Nn || (Nn = !0, Xr.call(Mn, ei));
                    };
                  }
                  var Mn = this, Nn = !1;
                  return { resolve: Pt(this.C), reject: Pt(this.l) };
                }, Fe.prototype.C = function(Pt) {
                  if (Pt === this)
                    this.l(new TypeError("A Promise cannot resolve to itself"));
                  else if (Pt instanceof Fe)
                    this.F(Pt);
                  else {
                    e:
                      switch (typeof Pt) {
                        case "object":
                          var Mn = Pt != null;
                          break e;
                        case "function":
                          Mn = !0;
                          break e;
                        default:
                          Mn = !1;
                      }
                    Mn ? this.v(Pt) : this.m(Pt);
                  }
                }, Fe.prototype.v = function(Pt) {
                  var Mn = void 0;
                  try {
                    Mn = Pt.then;
                  } catch (Nn) {
                    this.l(Nn);
                    return;
                  }
                  typeof Mn == "function" ? this.G(Mn, Pt) : this.m(Pt);
                }, Fe.prototype.l = function(Pt) {
                  this.s(2, Pt);
                }, Fe.prototype.m = function(Pt) {
                  this.s(1, Pt);
                }, Fe.prototype.s = function(Pt, Mn) {
                  if (this.h != 0)
                    throw Error("Cannot settle(" + Pt + ", " + Mn + "): Promise already settled in state" + this.h);
                  this.h = Pt, this.i = Mn, this.h === 2 && this.D(), this.A();
                }, Fe.prototype.D = function() {
                  var Pt = this;
                  Gt(function() {
                    if (Pt.B()) {
                      var Mn = pe.console;
                      typeof Mn < "u" && Mn.error(Pt.i);
                    }
                  }, 1);
                }, Fe.prototype.B = function() {
                  if (this.o)
                    return !1;
                  var Pt = pe.CustomEvent, Mn = pe.Event, Nn = pe.dispatchEvent;
                  return typeof Nn > "u" ? !0 : (typeof Pt == "function" ? Pt = new Pt("unhandledrejection", { cancelable: !0 }) : typeof Mn == "function" ? Pt = new Mn("unhandledrejection", { cancelable: !0 }) : (Pt = pe.document.createEvent("CustomEvent"), Pt.initCustomEvent("unhandledrejection", !1, !0, Pt)), Pt.promise = this, Pt.reason = this.i, Nn(Pt));
                }, Fe.prototype.A = function() {
                  if (this.g != null) {
                    for (var Pt = 0; Pt < this.g.length; ++Pt)
                      nn.h(this.g[Pt]);
                    this.g = null;
                  }
                };
                var nn = new Se();
                return Fe.prototype.F = function(Pt) {
                  var Mn = this.j();
                  Pt.J(Mn.resolve, Mn.reject);
                }, Fe.prototype.G = function(Pt, Mn) {
                  var Nn = this.j();
                  try {
                    Pt.call(Mn, Nn.resolve, Nn.reject);
                  } catch (Xr) {
                    Nn.reject(Xr);
                  }
                }, Fe.prototype.then = function(Pt, Mn) {
                  function Nn(di, Cr) {
                    return typeof di == "function" ? function(ni) {
                      try {
                        Xr(di(ni));
                      } catch (Ai) {
                        ei(Ai);
                      }
                    } : Cr;
                  }
                  var Xr, ei, ji = new Fe(function(di, Cr) {
                    Xr = di, ei = Cr;
                  });
                  return this.J(Nn(Pt, Xr), Nn(Mn, ei)), ji;
                }, Fe.prototype.catch = function(Pt) {
                  return this.then(void 0, Pt);
                }, Fe.prototype.J = function(Pt, Mn) {
                  function Nn() {
                    switch (Xr.h) {
                      case 1:
                        Pt(Xr.i);
                        break;
                      case 2:
                        Mn(Xr.i);
                        break;
                      default:
                        throw Error("Unexpected state: " + Xr.h);
                    }
                  }
                  var Xr = this;
                  this.g == null ? nn.h(Nn) : this.g.push(Nn), this.o = !0;
                }, Fe.resolve = it, Fe.reject = function(Pt) {
                  return new Fe(function(Mn, Nn) {
                    Nn(Pt);
                  });
                }, Fe.race = function(Pt) {
                  return new Fe(function(Mn, Nn) {
                    for (var Xr = rt(Pt), ei = Xr.next(); !ei.done; ei = Xr.next())
                      it(ei.value).J(Mn, Nn);
                  });
                }, Fe.all = function(Pt) {
                  var Mn = rt(Pt), Nn = Mn.next();
                  return Nn.done ? it([]) : new Fe(function(Xr, ei) {
                    function ji(ni) {
                      return function(Ai) {
                        di[ni] = Ai, Cr--, Cr == 0 && Xr(di);
                      };
                    }
                    var di = [], Cr = 0;
                    do
                      di.push(void 0), Cr++, it(Nn.value).J(ji(di.length - 1), ei), Nn = Mn.next();
                    while (!Nn.done);
                  });
                }, Fe;
              });
              function ml(D, Fe) {
                D instanceof String && (D += "");
                var Se = 0, it = !1, Gt = { next: function() {
                  if (!it && Se < D.length) {
                    var nn = Se++;
                    return { value: Fe(nn, D[nn]), done: !1 };
                  }
                  return it = !0, { done: !0, value: void 0 };
                } };
                return Gt[Symbol.iterator] = function() {
                  return Gt;
                }, Gt;
              }
              var cd = typeof Object.assign == "function" ? Object.assign : function(D, Fe) {
                for (var Se = 1; Se < arguments.length; Se++) {
                  var it = arguments[Se];
                  if (it)
                    for (var Gt in it)
                      Object.prototype.hasOwnProperty.call(it, Gt) && (D[Gt] = it[Gt]);
                }
                return D;
              };
              De("Object.assign", function(D) {
                return D || cd;
              }), De("Object.is", function(D) {
                return D || function(Fe, Se) {
                  return Fe === Se ? Fe !== 0 || 1 / Fe === 1 / Se : Fe !== Fe && Se !== Se;
                };
              }), De("Array.prototype.includes", function(D) {
                return D || function(Fe, Se) {
                  var it = this;
                  it instanceof String && (it = String(it));
                  var Gt = it.length;
                  for (Se = Se || 0, 0 > Se && (Se = Math.max(Se + Gt, 0)); Se < Gt; Se++) {
                    var nn = it[Se];
                    if (nn === Fe || Object.is(nn, Fe))
                      return !0;
                  }
                  return !1;
                };
              }), De("String.prototype.includes", function(D) {
                return D || function(Fe, Se) {
                  if (this == null)
                    throw new TypeError("The 'this' value for String.prototype.includes must not be null or undefined");
                  if (Fe instanceof RegExp)
                    throw new TypeError("First argument to String.prototype.includes must not be a regular expression");
                  return this.indexOf(Fe, Se || 0) !== -1;
                };
              }), De("Array.prototype.keys", function(D) {
                return D || function() {
                  return ml(this, function(Fe) {
                    return Fe;
                  });
                };
              });
              var Ma = this || self;
              function Ji(D, Fe) {
                D = D.split(".");
                var Se = Ma;
                D[0] in Se || typeof Se.execScript > "u" || Se.execScript("var " + D[0]);
                for (var it; D.length && (it = D.shift()); )
                  D.length || Fe === void 0 ? Se[it] && Se[it] !== Object.prototype[it] ? Se = Se[it] : Se = Se[it] = {} : Se[it] = Fe;
              }
              function ts(D) {
                Ma.setTimeout(function() {
                  throw D;
                }, 0);
              }
              function tl(D) {
                ts(D);
              }
              function Wl(D, Fe) {
                tl(Error("Invalid wire type: " + D + " (at position " + Fe + ")"));
              }
              function Ac() {
                tl(Error("Failed to read varint, encoding is invalid."));
              }
              function Hl(D, Fe) {
                return Fe = String.fromCharCode.apply(null, Fe), D == null ? Fe : D + Fe;
              }
              var Uc, dl = typeof TextDecoder < "u", vl, Nc = typeof TextEncoder < "u";
              function gc(D) {
                if (Nc)
                  D = (vl || (vl = new TextEncoder())).encode(D);
                else {
                  var Fe = void 0;
                  Fe = Fe === void 0 ? !1 : Fe;
                  for (var Se = 0, it = new Uint8Array(3 * D.length), Gt = 0; Gt < D.length; Gt++) {
                    var nn = D.charCodeAt(Gt);
                    if (128 > nn)
                      it[Se++] = nn;
                    else {
                      if (2048 > nn)
                        it[Se++] = nn >> 6 | 192;
                      else {
                        if (55296 <= nn && 57343 >= nn) {
                          if (56319 >= nn && Gt < D.length) {
                            var Pt = D.charCodeAt(++Gt);
                            if (56320 <= Pt && 57343 >= Pt) {
                              nn = 1024 * (nn - 55296) + Pt - 56320 + 65536, it[Se++] = nn >> 18 | 240, it[Se++] = nn >> 12 & 63 | 128, it[Se++] = nn >> 6 & 63 | 128, it[Se++] = nn & 63 | 128;
                              continue;
                            } else
                              Gt--;
                          }
                          if (Fe)
                            throw Error("Found an unpaired surrogate");
                          nn = 65533;
                        }
                        it[Se++] = nn >> 12 | 224, it[Se++] = nn >> 6 & 63 | 128;
                      }
                      it[Se++] = nn & 63 | 128;
                    }
                  }
                  D = it.subarray(0, Se);
                }
                return D;
              }
              var Js = {}, Is = null;
              function Pl(D) {
                var Fe;
                Fe === void 0 && (Fe = 0), $a(), Fe = Js[Fe];
                for (var Se = Array(Math.floor(D.length / 3)), it = Fe[64] || "", Gt = 0, nn = 0; Gt < D.length - 2; Gt += 3) {
                  var Pt = D[Gt], Mn = D[Gt + 1], Nn = D[Gt + 2], Xr = Fe[Pt >> 2];
                  Pt = Fe[(Pt & 3) << 4 | Mn >> 4], Mn = Fe[(Mn & 15) << 2 | Nn >> 6], Nn = Fe[Nn & 63], Se[nn++] = Xr + Pt + Mn + Nn;
                }
                switch (Xr = 0, Nn = it, D.length - Gt) {
                  case 2:
                    Xr = D[Gt + 1], Nn = Fe[(Xr & 15) << 2] || it;
                  case 1:
                    D = D[Gt], Se[nn] = Fe[D >> 2] + Fe[(D & 3) << 4 | Xr >> 4] + Nn + it;
                }
                return Se.join("");
              }
              function Nl(D) {
                var Fe = D.length, Se = 3 * Fe / 4;
                Se % 3 ? Se = Math.floor(Se) : "=.".indexOf(D[Fe - 1]) != -1 && (Se = "=.".indexOf(D[Fe - 2]) != -1 ? Se - 2 : Se - 1);
                var it = new Uint8Array(Se), Gt = 0;
                return ta(D, function(nn) {
                  it[Gt++] = nn;
                }), it.subarray(0, Gt);
              }
              function ta(D, Fe) {
                function Se(Nn) {
                  for (; it < D.length; ) {
                    var Xr = D.charAt(it++), ei = Is[Xr];
                    if (ei != null)
                      return ei;
                    if (!/^[\s\xa0]*$/.test(Xr))
                      throw Error("Unknown base64 encoding at char: " + Xr);
                  }
                  return Nn;
                }
                $a();
                for (var it = 0; ; ) {
                  var Gt = Se(-1), nn = Se(0), Pt = Se(64), Mn = Se(64);
                  if (Mn === 64 && Gt === -1)
                    break;
                  Fe(Gt << 2 | nn >> 4), Pt != 64 && (Fe(nn << 4 & 240 | Pt >> 2), Mn != 64 && Fe(Pt << 6 & 192 | Mn));
                }
              }
              function $a() {
                if (!Is) {
                  Is = {};
                  for (var D = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), Fe = ["+/=", "+/", "-_=", "-_.", "-_"], Se = 0; 5 > Se; Se++) {
                    var it = D.concat(Fe[Se].split(""));
                    Js[Se] = it;
                    for (var Gt = 0; Gt < it.length; Gt++) {
                      var nn = it[Gt];
                      Is[nn] === void 0 && (Is[nn] = Gt);
                    }
                  }
                }
              }
              var Gs = typeof Uint8Array == "function", To;
              function Na(D) {
                if (this.g = D, D !== null && D.length === 0)
                  throw Error("ByteString should be constructed with non-empty values");
              }
              Na.prototype.toJSON = function() {
                if (this.g == null)
                  var D = "";
                else
                  D = this.g, D = this.g = D == null || typeof D == "string" ? D : Gs && D instanceof Uint8Array ? Pl(D) : null;
                return D;
              };
              var nl = typeof Uint8Array.prototype.slice == "function";
              function vs(D, Fe, Se) {
                return Fe === Se ? To || (To = new Uint8Array(0)) : nl ? D.slice(Fe, Se) : new Uint8Array(D.subarray(Fe, Se));
              }
              var bo = 0, fa = 0;
              function ss(D) {
                if (D.constructor === Uint8Array)
                  return D;
                if (D.constructor === ArrayBuffer)
                  return new Uint8Array(D);
                if (D.constructor === Array)
                  return new Uint8Array(D);
                if (D.constructor === String)
                  return Nl(D);
                if (D.constructor === Na) {
                  if (D.g == null)
                    var Fe = To || (To = new Uint8Array(0));
                  else {
                    Fe = Uint8Array;
                    var Se = D.g;
                    Se = Se == null || Gs && Se != null && Se instanceof Uint8Array ? Se : typeof Se == "string" ? Nl(Se) : null, D = D.g = Se, Fe = new Fe(D);
                  }
                  return Fe;
                }
                if (D instanceof Uint8Array)
                  return new Uint8Array(D.buffer, D.byteOffset, D.byteLength);
                throw Error("Type not convertible to a Uint8Array, expected a Uint8Array, an ArrayBuffer, a base64 encoded string, or Array of numbers");
              }
              function eo(D, Fe) {
                Fe = Fe === void 0 ? {} : Fe, Fe = Fe.u === void 0 ? !1 : Fe.u, this.h = null, this.g = this.i = this.l = 0, this.j = !1, this.u = Fe, D && Pa(this, D);
              }
              function Pa(D, Fe) {
                D.h = ss(Fe), D.l = 0, D.i = D.h.length, D.g = D.l;
              }
              eo.prototype.reset = function() {
                this.g = this.l;
              };
              function Ao(D) {
                D.g > D.i && (D.j = !0, tl(Error("Tried to read past the end of the data " + D.g + " > " + D.i)));
              }
              function ua(D) {
                var Fe = D.h, Se = Fe[D.g], it = Se & 127;
                return 128 > Se ? (D.g += 1, Ao(D), it) : (Se = Fe[D.g + 1], it |= (Se & 127) << 7, 128 > Se ? (D.g += 2, Ao(D), it) : (Se = Fe[D.g + 2], it |= (Se & 127) << 14, 128 > Se ? (D.g += 3, Ao(D), it) : (Se = Fe[D.g + 3], it |= (Se & 127) << 21, 128 > Se ? (D.g += 4, Ao(D), it) : (Se = Fe[D.g + 4], it |= (Se & 15) << 28, 128 > Se ? (D.g += 5, Ao(D), it >>> 0) : (D.g += 5, 128 <= Fe[D.g++] && 128 <= Fe[D.g++] && 128 <= Fe[D.g++] && 128 <= Fe[D.g++] && 128 <= Fe[D.g++] ? (D.j = !0, Ac(), it) : (Ao(D), it))))));
              }
              var ns = [];
              function Ls() {
                this.g = new Uint8Array(64), this.h = 0;
              }
              function Ua(D, Fe) {
                if (!(D.h + 1 < D.g.length)) {
                  var Se = D.g;
                  D.g = new Uint8Array(Math.ceil(1 + 2 * D.g.length)), D.g.set(Se);
                }
                D.g[D.h++] = Fe;
              }
              Ls.prototype.length = function() {
                return this.h;
              }, Ls.prototype.end = function() {
                var D = this.g, Fe = this.h;
                return this.h = 0, vs(D, 0, Fe);
              };
              function go(D, Fe) {
                for (; 127 < Fe; )
                  Ua(D, Fe & 127 | 128), Fe >>>= 7;
                Ua(D, Fe);
              }
              function Bs(D) {
                var Fe = {}, Se = Fe.N === void 0 ? !1 : Fe.N;
                this.m = { u: Fe.u === void 0 ? !1 : Fe.u }, this.N = Se, Fe = this.m, ns.length ? (Se = ns.pop(), Fe && (Se.u = Fe.u), D && Pa(Se, D), D = Se) : D = new eo(D, Fe), this.g = D, this.l = this.g.g, this.h = this.i = -1, this.j = !1;
              }
              Bs.prototype.reset = function() {
                this.g.reset(), this.h = this.i = -1;
              };
              function Ts(D) {
                var Fe = D.g;
                if ((Fe = Fe.g == Fe.i) || (Fe = D.j) || (Fe = D.g, Fe = Fe.j || 0 > Fe.g || Fe.g > Fe.i), Fe)
                  return !1;
                D.l = D.g.g;
                var Se = ua(D.g);
                return Fe = Se >>> 3, Se &= 7, 0 <= Se && 5 >= Se ? (D.i = Fe, D.h = Se, !0) : (D.j = !0, Wl(Se, D.l), !1);
              }
              function Oa(D) {
                switch (D.h) {
                  case 0:
                    if (D.h != 0)
                      Oa(D);
                    else
                      e: {
                        D = D.g;
                        for (var Fe = D.g, Se = 0; 10 > Se; Se++) {
                          if (!(D.h[Fe] & 128)) {
                            D.g = Fe + 1, Ao(D);
                            break e;
                          }
                          Fe++;
                        }
                        D.j = !0, Ac();
                      }
                    break;
                  case 1:
                    D = D.g, D.g += 8, Ao(D);
                    break;
                  case 2:
                    D.h != 2 ? Oa(D) : (Fe = ua(D.g), D = D.g, D.g += Fe, Ao(D));
                    break;
                  case 5:
                    D = D.g, D.g += 4, Ao(D);
                    break;
                  case 3:
                    Fe = D.i;
                    do {
                      if (!Ts(D)) {
                        D.j = !0, tl(Error("Unmatched start-group tag: stream EOF"));
                        break;
                      }
                      if (D.h == 4) {
                        D.i != Fe && (D.j = !0, tl(Error("Unmatched end-group tag")));
                        break;
                      }
                      Oa(D);
                    } while (!0);
                    break;
                  default:
                    D.j = !0, Wl(D.h, D.l);
                }
              }
              function Jl(D, Fe, Se) {
                D.N || (D = vs(D.g.h, Se, D.g.g), (Se = Fe.m) ? Se.push(D) : Fe.m = [D]);
              }
              var rl = [];
              function Xs() {
                this.h = [], this.i = 0, this.g = new Ls();
              }
              function il(D, Fe) {
                Fe.length !== 0 && (D.h.push(Fe), D.i += Fe.length);
              }
              function pa(D, Fe, Se) {
                go(D.g, 8 * Fe + 2), go(D.g, Se.length), il(D, D.g.end()), il(D, Se);
              }
              var rs = typeof Symbol == "function" && typeof Symbol() == "symbol" ? Symbol(void 0) : void 0;
              function ma(D, Fe) {
                Object.isFrozen(D) || (rs ? D[rs] |= Fe : D.g !== void 0 ? D.g |= Fe : Object.defineProperties(D, { g: { value: Fe, configurable: !0, writable: !0, enumerable: !1 } }));
              }
              function Xo(D) {
                if (!D)
                  return 0;
                var Fe;
                return rs ? Fe = D[rs] : Fe = D.g, Fe == null ? 0 : Fe;
              }
              function ks(D) {
                return Array.isArray(D) && ma(D, 1), D;
              }
              function Zo(D) {
                if (!Array.isArray(D))
                  throw Error("cannot mark non-array as immutable");
                ma(D, 2);
              }
              function fo(D) {
                return D !== null && typeof D == "object" && D.constructor === Object;
              }
              function ul(D) {
                switch (typeof D) {
                  case "number":
                    return isFinite(D) ? D : String(D);
                  case "object":
                    return Gs && D != null && D instanceof Uint8Array ? Pl(D) : D;
                  default:
                    return D;
                }
              }
              function na(D, Fe) {
                if (D != null)
                  return Array.isArray(D) || fo(D) ? Wi(D, Fe) : Fe(D);
              }
              function Wi(D, Fe) {
                if (Array.isArray(D)) {
                  for (var Se = Array(D.length), it = 0; it < D.length; it++)
                    Se[it] = na(D[it], Fe);
                  return Xo(D) & 1 && ks(Se), Se;
                }
                Se = {};
                for (it in D)
                  Se[it] = na(D[it], Fe);
                return Se;
              }
              var li;
              function ko(D, Fe, Se) {
                var it = li;
                li = null, D || (D = it), it = this.constructor.ca, D || (D = it ? [it] : []), this.j = (it ? 0 : -1) - (this.constructor.aa || 0), this.i = null, this.g = D;
                e: {
                  if (it = this.g.length, D = it - 1, it && (it = this.g[D], fo(it))) {
                    this.l = D - this.j, this.h = it;
                    break e;
                  }
                  Fe !== void 0 && -1 < Fe ? (this.l = Math.max(Fe, D + 1 - this.j), this.h = null) : this.l = Number.MAX_VALUE;
                }
                if (Se)
                  for (Fe = 0; Fe < Se.length; Fe++)
                    D = Se[Fe], D < this.l ? (D += this.j, (it = this.g[D]) ? ks(it) : this.g[D] = is) : (So(this), (it = this.h[D]) ? ks(it) : this.h[D] = is);
              }
              var is = Object.freeze(ks([]));
              function So(D) {
                var Fe = D.l + D.j;
                D.g[Fe] || (D.h = D.g[Fe] = {});
              }
              function wo(D, Fe, Se) {
                return Fe === -1 ? null : Se !== void 0 && Se || Fe >= D.l ? D.h ? D.h[Fe] : void 0 : D.g[Fe + D.j];
              }
              function wn(D, Fe, Se) {
                Se = Se === void 0 ? !0 : Se;
                var it = it === void 0 ? !1 : it, Gt = wo(D, Fe, it);
                return Gt == null && (Gt = is), Gt === is ? (Gt = ks([]), hr(D, Fe, Gt, it)) : Se && Array.isArray(Gt) && Xo(Gt) & 2 && (Gt = Gt.slice(), hr(D, Fe, Gt, it)), Gt;
              }
              function jn(D, Fe, Se) {
                return D = wo(D, Fe), D = D == null ? D : +D, D == null ? Se === void 0 ? 0 : Se : D;
              }
              function hr(D, Fe, Se, it) {
                it !== void 0 && it || Fe >= D.l ? (So(D), D.h[Fe] = Se) : D.g[Fe + D.j] = Se;
              }
              function po(D, Fe, Se) {
                D.i || (D.i = {});
                var it = D.i[Se];
                if (!it) {
                  var Gt = wn(D, Se, !1);
                  it = [];
                  for (var nn = Array.isArray(Gt) ? !!(Xo(Gt) & 2) : !1, Pt = 0; Pt < Gt.length; Pt++)
                    it[Pt] = new Fe(Gt[Pt]), nn && Zo(it[Pt].g);
                  nn && (Zo(it), Object.freeze(it)), D.i[Se] = it;
                }
                return it;
              }
              function Po(D, Fe, Se, it, Gt) {
                var nn = po(D, it, Fe);
                Se = Se || new it(), D = wn(D, Fe), Gt != null ? (nn.splice(Gt, 0, Se), D.splice(Gt, 0, Yo(Se))) : (nn.push(Se), D.push(Yo(Se)));
              }
              ko.prototype.toJSON = function() {
                var D = Yo(this);
                return Wi(D, ul);
              };
              function Yo(D) {
                if (D.i)
                  for (var Fe in D.i) {
                    var Se = D.i[Fe];
                    if (Array.isArray(Se))
                      for (var it = 0; it < Se.length; it++)
                        Se[it] && Yo(Se[it]);
                    else
                      Se && Yo(Se);
                  }
                return D.g;
              }
              ko.prototype.toString = function() {
                return Yo(this).toString();
              };
              function fi(D, Fe) {
                return D = wo(D, Fe), D == null ? 0 : D;
              }
              function ra(D, Fe) {
                return D = wo(D, Fe), D == null ? "" : D;
              }
              function ls(D, Fe) {
                if (D = D.m) {
                  il(Fe, Fe.g.end());
                  for (var Se = 0; Se < D.length; Se++)
                    il(Fe, D[Se]);
                }
              }
              function xs(D) {
                var Fe = D[0];
                switch (D.length) {
                  case 2:
                    var Se = D[1];
                    return function(Nn, Xr, ei) {
                      return Fe(Nn, Xr, ei, Se);
                    };
                  case 3:
                    var it = D[1], Gt = D[2];
                    return function(Nn, Xr, ei) {
                      return Fe(Nn, Xr, ei, it, Gt);
                    };
                  case 4:
                    var nn = D[1], Pt = D[2], Mn = D[3];
                    return function(Nn, Xr, ei) {
                      return Fe(Nn, Xr, ei, nn, Pt, Mn);
                    };
                  default:
                    throw Error("unsupported number of parameters, expected [2-4], got " + D.length);
                }
              }
              function Hs(D, Fe, Se) {
                for (; Ts(Fe) && Fe.h != 4; ) {
                  var it = Fe.i, Gt = Se[it];
                  if (Gt) {
                    if (Array.isArray(Gt) && (Gt = Se[it] = xs(Gt)), !Gt(Fe, D, it)) {
                      it = Fe, Gt = D;
                      var nn = it.l;
                      Oa(it), Jl(it, Gt, nn);
                    }
                  } else
                    it = Fe, Gt = D, nn = it.l, Oa(it), Jl(it, Gt, nn);
                }
                return D;
              }
              function hl(D, Fe) {
                var Se = new Xs();
                if (Fe(D, Se), D = Se.i + Se.g.length(), D === 0)
                  Se = new Uint8Array(0);
                else {
                  D = new Uint8Array(D);
                  for (var it = Se.h, Gt = it.length, nn = Fe = 0; nn < Gt; nn++) {
                    var Pt = it[nn];
                    Pt.length !== 0 && (D.set(Pt, Fe), Fe += Pt.length);
                  }
                  it = Se.g, Gt = it.h, Gt !== 0 && (D.set(it.g.subarray(0, Gt), Fe), it.h = 0), Se.h = [D], Se = D;
                }
                return Se;
              }
              function bl(D, Fe, Se) {
                if (rl.length) {
                  var it = rl.pop();
                  D && (Pa(it.g, D), it.i = -1, it.h = -1), D = it;
                } else
                  D = new Bs(D);
                try {
                  return Se(new Fe(), D);
                } finally {
                  Fe = D.g, Fe.h = null, Fe.l = 0, Fe.i = 0, Fe.g = 0, Fe.j = !1, Fe.u = !1, D.i = -1, D.h = -1, D.j = !1, 100 > rl.length && rl.push(D);
                }
              }
              function os(D, Fe, Se) {
                if (Fe = wo(Fe, Se), Fe != null) {
                  go(D.g, 8 * Se + 5), D = D.g;
                  var it = Fe;
                  it = (Se = 0 > it ? 1 : 0) ? -it : it, it === 0 ? 0 < 1 / it ? bo = fa = 0 : (fa = 0, bo = 2147483648) : isNaN(it) ? (fa = 0, bo = 2147483647) : 34028234663852886e22 < it ? (fa = 0, bo = (Se << 31 | 2139095040) >>> 0) : 11754943508222875e-54 > it ? (it = Math.round(it / Math.pow(2, -149)), fa = 0, bo = (Se << 31 | it) >>> 0) : (Fe = Math.floor(Math.log(it) / Math.LN2), it *= Math.pow(2, -Fe), it = Math.round(8388608 * it), 16777216 <= it && ++Fe, fa = 0, bo = (Se << 31 | Fe + 127 << 23 | it & 8388607) >>> 0), Se = bo, Ua(D, Se >>> 0 & 255), Ua(D, Se >>> 8 & 255), Ua(D, Se >>> 16 & 255), Ua(D, Se >>> 24 & 255);
                }
              }
              function Ps(D, Fe, Se) {
                if (D.h !== 5)
                  return !1;
                D = D.g;
                var it = D.h[D.g], Gt = D.h[D.g + 1], nn = D.h[D.g + 2], Pt = D.h[D.g + 3];
                return D.g += 4, Ao(D), Gt = (it << 0 | Gt << 8 | nn << 16 | Pt << 24) >>> 0, D = 2 * (Gt >> 31) + 1, it = Gt >>> 23 & 255, Gt &= 8388607, hr(Fe, Se, it == 255 ? Gt ? NaN : 1 / 0 * D : it == 0 ? D * Math.pow(2, -149) * Gt : D * Math.pow(2, it - 150) * (Gt + Math.pow(2, 23))), !0;
              }
              function dd(D, Fe, Se) {
                if (D.h !== 0)
                  return !1;
                for (var it = D.g, Gt = 128, nn = 0, Pt = D = 0; 4 > Pt && 128 <= Gt; Pt++)
                  Gt = it.h[it.g++], nn |= (Gt & 127) << 7 * Pt;
                if (128 <= Gt && (Gt = it.h[it.g++], nn |= (Gt & 127) << 28, D |= (Gt & 127) >> 4), 128 <= Gt)
                  for (Pt = 0; 5 > Pt && 128 <= Gt; Pt++)
                    Gt = it.h[it.g++], D |= (Gt & 127) << 7 * Pt + 3;
                return 128 > Gt ? (it = nn >>> 0, Gt = D >>> 0, (D = Gt & 2147483648) && (it = ~it + 1 >>> 0, Gt = ~Gt >>> 0, it == 0 && (Gt = Gt + 1 >>> 0)), it = 4294967296 * Gt + (it >>> 0), D = D ? -it : it) : (it.j = !0, Ac(), D = void 0), hr(Fe, Se, D), !0;
              }
              function Os(D, Fe, Se) {
                return D.h !== 0 ? !1 : (hr(Fe, Se, ua(D.g)), !0);
              }
              function cs(D, Fe, Se) {
                if (D.h !== 2)
                  return !1;
                var it = ua(D.g);
                D = D.g;
                var Gt = D.g;
                D.g += it, Ao(D), D = D.h;
                var nn;
                if (dl)
                  (nn = Uc) || (nn = Uc = new TextDecoder("utf-8", { fatal: !1 })), nn = nn.decode(D.subarray(Gt, Gt + it));
                else {
                  it = Gt + it;
                  for (var Pt = [], Mn = null, Nn, Xr, ei; Gt < it; )
                    Nn = D[Gt++], 128 > Nn ? Pt.push(Nn) : 224 > Nn ? Gt >= it ? Pt.push(65533) : (Xr = D[Gt++], 194 > Nn || (Xr & 192) !== 128 ? (Gt--, Pt.push(65533)) : Pt.push((Nn & 31) << 6 | Xr & 63)) : 240 > Nn ? Gt >= it - 1 ? Pt.push(65533) : (Xr = D[Gt++], (Xr & 192) !== 128 || Nn === 224 && 160 > Xr || Nn === 237 && 160 <= Xr || ((nn = D[Gt++]) & 192) !== 128 ? (Gt--, Pt.push(65533)) : Pt.push((Nn & 15) << 12 | (Xr & 63) << 6 | nn & 63)) : 244 >= Nn ? Gt >= it - 2 ? Pt.push(65533) : (Xr = D[Gt++], (Xr & 192) !== 128 || (Nn << 28) + (Xr - 144) >> 30 || ((nn = D[Gt++]) & 192) !== 128 || ((ei = D[Gt++]) & 192) !== 128 ? (Gt--, Pt.push(65533)) : (Nn = (Nn & 7) << 18 | (Xr & 63) << 12 | (nn & 63) << 6 | ei & 63, Nn -= 65536, Pt.push((Nn >> 10 & 1023) + 55296, (Nn & 1023) + 56320))) : Pt.push(65533), 8192 <= Pt.length && (Mn = Hl(Mn, Pt), Pt.length = 0);
                  nn = Hl(Mn, Pt);
                }
                return hr(Fe, Se, nn), !0;
              }
              function Il(D, Fe, Se, it, Gt) {
                if (D.h !== 2)
                  return !1;
                var nn = new it(), Pt = D.g.i, Mn = ua(D.g), Nn = D.g.g + Mn;
                if (D.g.i = Nn, Gt(nn, D), Gt = Nn - D.g.g, Gt !== 0)
                  throw Error("Message parsing ended unexpectedly. Expected to read " + (Mn + " bytes, instead read " + (Mn - Gt) + " bytes, either the data ended unexpectedly or the message misreported its own length"));
                return D.g.g = Nn, D.g.i = Pt, Po(Fe, Se, nn, it, void 0), !0;
              }
              function Ol(D) {
                ko.call(this, D);
              }
              var bs;
              Nr(Ol, ko);
              function Jc(D, Fe) {
                var Se = wo(D, 1);
                if (Se != null && Se != null) {
                  go(Fe.g, 8);
                  var it = Fe.g;
                  if (0 <= Se)
                    go(it, Se);
                  else {
                    for (var Gt = 0; 9 > Gt; Gt++)
                      Ua(it, Se & 127 | 128), Se >>= 7;
                    Ua(it, 1);
                  }
                }
                os(Fe, D, 2), it = wo(D, 3), it != null && pa(Fe, 3, gc(it)), it = wo(D, 4), it != null && pa(Fe, 4, gc(it)), ls(D, Fe);
              }
              function Ks(D, Fe) {
                return Hs(D, Fe, bs || (bs = { 1: Os, 2: Ps, 3: cs, 4: cs }));
              }
              function Bl(D) {
                ko.call(this, D, -1, ol);
              }
              var nc;
              Nr(Bl, ko), Bl.prototype.addClassification = function(D, Fe) {
                return Po(this, 1, D, Ol, Fe), this;
              };
              function Oc(D, Fe) {
                return Hs(D, Fe, nc || (nc = { 1: [Il, Ol, Ks] }));
              }
              var ol = [1];
              function rc(D) {
                ko.call(this, D);
              }
              var Ld;
              Nr(rc, ko);
              function xd(D, Fe) {
                os(Fe, D, 1), os(Fe, D, 2), os(Fe, D, 3), os(Fe, D, 4), os(Fe, D, 5), ls(D, Fe);
              }
              function ic(D, Fe) {
                return Hs(D, Fe, Ld || (Ld = { 1: Ps, 2: Ps, 3: Ps, 4: Ps, 5: Ps }));
              }
              function fc(D) {
                ko.call(this, D, -1, Ze);
              }
              var le;
              Nr(fc, ko);
              function Ie(D, Fe) {
                return Hs(D, Fe, le || (le = { 1: [Il, rc, ic] }));
              }
              var Ze = [1];
              function Mt(D) {
                ko.call(this, D);
              }
              var yn;
              Nr(Mt, ko);
              function nr(D, Fe) {
                os(Fe, D, 1), os(Fe, D, 2), os(Fe, D, 3), os(Fe, D, 4), os(Fe, D, 5);
                var Se = wo(D, 6);
                if (Se != null && Se != null) {
                  go(Fe.g, 48);
                  var it = Fe.g, Gt = Se;
                  Se = 0 > Gt, Gt = Math.abs(Gt);
                  var nn = Gt >>> 0;
                  for (Gt = Math.floor((Gt - nn) / 4294967296), Gt >>>= 0, Se && (Gt = ~Gt >>> 0, nn = (~nn >>> 0) + 1, 4294967295 < nn && (nn = 0, Gt++, 4294967295 < Gt && (Gt = 0))), bo = nn, fa = Gt, Se = bo, nn = fa; 0 < nn || 127 < Se; )
                    Ua(it, Se & 127 | 128), Se = (Se >>> 7 | nn << 25) >>> 0, nn >>>= 7;
                  Ua(it, Se);
                }
                ls(D, Fe);
              }
              function mn(D, Fe) {
                return Hs(D, Fe, yn || (yn = { 1: Ps, 2: Ps, 3: Ps, 4: Ps, 5: Ps, 6: dd }));
              }
              function zn(D, Fe, Se) {
                if (Se = D.createShader(Se === 0 ? D.VERTEX_SHADER : D.FRAGMENT_SHADER), D.shaderSource(Se, Fe), D.compileShader(Se), !D.getShaderParameter(Se, D.COMPILE_STATUS))
                  throw Error(`Could not compile WebGL shader.

` + D.getShaderInfoLog(Se));
                return Se;
              }
              function Wr(D) {
                return po(D, Ol, 1).map(function(Fe) {
                  return { index: fi(Fe, 1), X: jn(Fe, 2), label: wo(Fe, 3) != null ? ra(Fe, 3) : void 0, displayName: wo(Fe, 4) != null ? ra(Fe, 4) : void 0 };
                });
              }
              function ci(D) {
                return { x: jn(D, 1), y: jn(D, 2), z: jn(D, 3), visibility: wo(D, 4) != null ? jn(D, 4) : void 0 };
              }
              function Ki(D) {
                return po(bl(D, fc, Ie), rc, 1).map(ci);
              }
              function Gi(D, Fe) {
                this.h = D, this.g = Fe, this.l = 0;
              }
              function yo(D, Fe, Se) {
                return Xi(D, Fe), typeof D.g.canvas.transferToImageBitmap == "function" ? n.resolve(D.g.canvas.transferToImageBitmap()) : Se ? n.resolve(D.g.canvas) : typeof createImageBitmap == "function" ? createImageBitmap(D.g.canvas) : (D.i === void 0 && (D.i = document.createElement("canvas")), new n(function(it) {
                  D.i.height = D.g.canvas.height, D.i.width = D.g.canvas.width, D.i.getContext("2d", {}).drawImage(D.g.canvas, 0, 0, D.g.canvas.width, D.g.canvas.height), it(D.i);
                }));
              }
              function Xi(D, Fe) {
                var Se = D.g;
                if (D.m === void 0) {
                  var it = zn(Se, `
  attribute vec2 aVertex;
  attribute vec2 aTex;
  varying vec2 vTex;
  void main(void) {
    gl_Position = vec4(aVertex, 0.0, 1.0);
    vTex = aTex;
  }`, 0), Gt = zn(Se, `
  precision mediump float;
  varying vec2 vTex;
  uniform sampler2D sampler0;
  void main(){
    gl_FragColor = texture2D(sampler0, vTex);
  }`, 1), nn = Se.createProgram();
                  if (Se.attachShader(nn, it), Se.attachShader(nn, Gt), Se.linkProgram(nn), !Se.getProgramParameter(nn, Se.LINK_STATUS))
                    throw Error(`Could not compile WebGL program.

` + Se.getProgramInfoLog(nn));
                  it = D.m = nn, Se.useProgram(it), Gt = Se.getUniformLocation(it, "sampler0"), D.j = { I: Se.getAttribLocation(it, "aVertex"), H: Se.getAttribLocation(it, "aTex"), da: Gt }, D.s = Se.createBuffer(), Se.bindBuffer(Se.ARRAY_BUFFER, D.s), Se.enableVertexAttribArray(D.j.I), Se.vertexAttribPointer(D.j.I, 2, Se.FLOAT, !1, 0, 0), Se.bufferData(Se.ARRAY_BUFFER, new Float32Array([-1, -1, -1, 1, 1, 1, 1, -1]), Se.STATIC_DRAW), Se.bindBuffer(Se.ARRAY_BUFFER, null), D.o = Se.createBuffer(), Se.bindBuffer(Se.ARRAY_BUFFER, D.o), Se.enableVertexAttribArray(D.j.H), Se.vertexAttribPointer(
                    D.j.H,
                    2,
                    Se.FLOAT,
                    !1,
                    0,
                    0
                  ), Se.bufferData(Se.ARRAY_BUFFER, new Float32Array([0, 1, 0, 0, 1, 0, 1, 1]), Se.STATIC_DRAW), Se.bindBuffer(Se.ARRAY_BUFFER, null), Se.uniform1i(Gt, 0);
                }
                it = D.j, Se.useProgram(D.m), Se.canvas.width = Fe.width, Se.canvas.height = Fe.height, Se.viewport(0, 0, Fe.width, Fe.height), Se.activeTexture(Se.TEXTURE0), D.h.bindTexture2d(Fe.glName), Se.enableVertexAttribArray(it.I), Se.bindBuffer(Se.ARRAY_BUFFER, D.s), Se.vertexAttribPointer(it.I, 2, Se.FLOAT, !1, 0, 0), Se.enableVertexAttribArray(it.H), Se.bindBuffer(Se.ARRAY_BUFFER, D.o), Se.vertexAttribPointer(
                  it.H,
                  2,
                  Se.FLOAT,
                  !1,
                  0,
                  0
                ), Se.bindFramebuffer(Se.DRAW_FRAMEBUFFER ? Se.DRAW_FRAMEBUFFER : Se.FRAMEBUFFER, null), Se.clearColor(0, 0, 0, 0), Se.clear(Se.COLOR_BUFFER_BIT), Se.colorMask(!0, !0, !0, !0), Se.drawArrays(Se.TRIANGLE_FAN, 0, 4), Se.disableVertexAttribArray(it.I), Se.disableVertexAttribArray(it.H), Se.bindBuffer(Se.ARRAY_BUFFER, null), D.h.bindTexture2d(0);
              }
              function vi(D) {
                this.g = D;
              }
              var Yi = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
              function Fo(D, Fe) {
                return Fe + D;
              }
              function Lo(D, Fe) {
                window[D] = Fe;
              }
              function ia(D) {
                var Fe = document.createElement("script");
                return Fe.setAttribute("src", D), Fe.setAttribute("crossorigin", "anonymous"), new n(function(Se) {
                  Fe.addEventListener("load", function() {
                    Se();
                  }, !1), Fe.addEventListener("error", function() {
                    Se();
                  }, !1), document.body.appendChild(Fe);
                });
              }
              function ha() {
                return Mr(function(D) {
                  switch (D.g) {
                    case 1:
                      return D.m = 2, Un(D, WebAssembly.instantiate(Yi), 4);
                    case 4:
                      D.g = 3, D.m = 0;
                      break;
                    case 2:
                      return D.m = 0, D.j = null, D.return(!1);
                    case 3:
                      return D.return(!0);
                  }
                });
              }
              function ds(D) {
                if (this.g = D, this.listeners = {}, this.j = {}, this.F = {}, this.m = {}, this.s = {}, this.G = this.o = this.R = !0, this.C = n.resolve(), this.P = "", this.B = {}, this.locateFile = D && D.locateFile || Fo, typeof window == "object")
                  var Fe = window.location.pathname.toString().substring(0, window.location.pathname.toString().lastIndexOf("/")) + "/";
                else if (typeof location < "u")
                  Fe = location.pathname.toString().substring(0, location.pathname.toString().lastIndexOf("/")) + "/";
                else
                  throw Error("solutions can only be loaded on a web page or in a web worker");
                if (this.S = Fe, D.options) {
                  Fe = rt(Object.keys(D.options));
                  for (var Se = Fe.next(); !Se.done; Se = Fe.next()) {
                    Se = Se.value;
                    var it = D.options[Se].default;
                    it !== void 0 && (this.j[Se] = typeof it == "function" ? it() : it);
                  }
                }
              }
              E = ds.prototype, E.close = function() {
                return this.i && this.i.delete(), n.resolve();
              };
              function q(D) {
                var Fe, Se, it, Gt, nn, Pt, Mn, Nn, Xr, ei, ji;
                return Mr(function(di) {
                  switch (di.g) {
                    case 1:
                      return D.R ? (Fe = D.g.files === void 0 ? [] : typeof D.g.files == "function" ? D.g.files(D.j) : D.g.files, Un(di, ha(), 2)) : di.return();
                    case 2:
                      if (Se = di.h, typeof window == "object")
                        return Lo("createMediapipeSolutionsWasm", { locateFile: D.locateFile }), Lo("createMediapipeSolutionsPackedAssets", { locateFile: D.locateFile }), Pt = Fe.filter(function(Cr) {
                          return Cr.data !== void 0;
                        }), Mn = Fe.filter(function(Cr) {
                          return Cr.data === void 0;
                        }), Nn = n.all(Pt.map(function(Cr) {
                          var ni = bt(D, Cr.url);
                          if (Cr.path !== void 0) {
                            var Ai = Cr.path;
                            ni = ni.then(function(Ri) {
                              return D.overrideFile(Ai, Ri), n.resolve(Ri);
                            });
                          }
                          return ni;
                        })), Xr = n.all(Mn.map(function(Cr) {
                          return Cr.simd === void 0 || Cr.simd && Se || !Cr.simd && !Se ? ia(D.locateFile(Cr.url, D.S)) : n.resolve();
                        })).then(function() {
                          var Cr, ni, Ai;
                          return Mr(function(Ri) {
                            if (Ri.g == 1)
                              return Cr = window.createMediapipeSolutionsWasm, ni = window.createMediapipeSolutionsPackedAssets, Ai = D, Un(Ri, Cr(ni), 2);
                            Ai.h = Ri.h, Ri.g = 0;
                          });
                        }), ei = function() {
                          return Mr(function(Cr) {
                            return D.g.graph && D.g.graph.url ? Cr = Un(
                              Cr,
                              bt(D, D.g.graph.url),
                              0
                            ) : (Cr.g = 0, Cr = void 0), Cr;
                          });
                        }(), Un(di, n.all([Xr, Nn, ei]), 7);
                      if (typeof importScripts != "function")
                        throw Error("solutions can only be loaded on a web page or in a web worker");
                      return it = Fe.filter(function(Cr) {
                        return Cr.simd === void 0 || Cr.simd && Se || !Cr.simd && !Se;
                      }).map(function(Cr) {
                        return D.locateFile(Cr.url, D.S);
                      }), importScripts.apply(null, Nt(it)), Gt = D, Un(di, createMediapipeSolutionsWasm(Module), 6);
                    case 6:
                      Gt.h = di.h, D.l = new OffscreenCanvas(1, 1), D.h.canvas = D.l, nn = D.h.GL.createContext(D.l, {
                        antialias: !1,
                        alpha: !1,
                        ba: typeof WebGL2RenderingContext < "u" ? 2 : 1
                      }), D.h.GL.makeContextCurrent(nn), di.g = 4;
                      break;
                    case 7:
                      if (D.l = document.createElement("canvas"), ji = D.l.getContext("webgl2", {}), !ji && (ji = D.l.getContext("webgl", {}), !ji))
                        return alert("Failed to create WebGL canvas context when passing video frame."), di.return();
                      D.D = ji, D.h.canvas = D.l, D.h.createContext(D.l, !0, !0, {});
                    case 4:
                      D.i = new D.h.SolutionWasm(), D.R = !1, di.g = 0;
                  }
                });
              }
              function he(D) {
                var Fe, Se, it, Gt, nn, Pt, Mn, Nn;
                return Mr(function(Xr) {
                  if (Xr.g == 1) {
                    if (D.g.graph && D.g.graph.url && D.P === D.g.graph.url)
                      return Xr.return();
                    if (D.o = !0, !D.g.graph || !D.g.graph.url) {
                      Xr.g = 2;
                      return;
                    }
                    return D.P = D.g.graph.url, Un(Xr, bt(D, D.g.graph.url), 3);
                  }
                  for (Xr.g != 2 && (Fe = Xr.h, D.i.loadGraph(Fe)), Se = rt(Object.keys(D.B)), it = Se.next(); !it.done; it = Se.next())
                    Gt = it.value, D.i.overrideFile(Gt, D.B[Gt]);
                  if (D.B = {}, D.g.listeners)
                    for (nn = rt(D.g.listeners), Pt = nn.next(); !Pt.done; Pt = nn.next())
                      Mn = Pt.value, en(D, Mn);
                  Nn = D.j, D.j = {}, D.setOptions(Nn), Xr.g = 0;
                });
              }
              E.reset = function() {
                var D = this;
                return Mr(function(Fe) {
                  D.i && (D.i.reset(), D.m = {}, D.s = {}), Fe.g = 0;
                });
              }, E.setOptions = function(D, Fe) {
                var Se = this;
                if (Fe = Fe || this.g.options) {
                  for (var it = [], Gt = [], nn = {}, Pt = rt(Object.keys(D)), Mn = Pt.next(); !Mn.done; nn = { K: nn.K, L: nn.L }, Mn = Pt.next()) {
                    var Nn = Mn.value;
                    Nn in this.j && this.j[Nn] === D[Nn] || (this.j[Nn] = D[Nn], Mn = Fe[Nn], Mn !== void 0 && (Mn.onChange && (nn.K = Mn.onChange, nn.L = D[Nn], it.push(/* @__PURE__ */ function(Xr) {
                      return function() {
                        var ei;
                        return Mr(function(ji) {
                          if (ji.g == 1)
                            return Un(ji, Xr.K(Xr.L), 2);
                          ei = ji.h, ei === !0 && (Se.o = !0), ji.g = 0;
                        });
                      };
                    }(nn))), Mn.graphOptionXref && (Nn = { valueNumber: Mn.type === 1 ? D[Nn] : 0, valueBoolean: Mn.type === 0 ? D[Nn] : !1, valueString: Mn.type === 2 ? D[Nn] : "" }, Mn = Object.assign(Object.assign(Object.assign({}, { calculatorName: "", calculatorIndex: 0 }), Mn.graphOptionXref), Nn), Gt.push(Mn))));
                  }
                  (it.length !== 0 || Gt.length !== 0) && (this.o = !0, this.A = (this.A === void 0 ? [] : this.A).concat(Gt), this.v = (this.v === void 0 ? [] : this.v).concat(it));
                }
              };
              function ve(D) {
                var Fe, Se, it, Gt, nn, Pt, Mn;
                return Mr(function(Nn) {
                  switch (Nn.g) {
                    case 1:
                      if (!D.o)
                        return Nn.return();
                      if (!D.v) {
                        Nn.g = 2;
                        break;
                      }
                      Fe = rt(D.v), Se = Fe.next();
                    case 3:
                      if (Se.done) {
                        Nn.g = 5;
                        break;
                      }
                      return it = Se.value, Un(Nn, it(), 4);
                    case 4:
                      Se = Fe.next(), Nn.g = 3;
                      break;
                    case 5:
                      D.v = void 0;
                    case 2:
                      if (D.A) {
                        for (Gt = new D.h.GraphOptionChangeRequestList(), nn = rt(D.A), Pt = nn.next(); !Pt.done; Pt = nn.next())
                          Mn = Pt.value, Gt.push_back(Mn);
                        D.i.changeOptions(Gt), Gt.delete(), D.A = void 0;
                      }
                      D.o = !1, Nn.g = 0;
                  }
                });
              }
              E.initialize = function() {
                var D = this;
                return Mr(function(Fe) {
                  return Fe.g == 1 ? Un(Fe, q(D), 2) : Fe.g != 3 ? Un(Fe, he(D), 3) : Un(Fe, ve(D), 0);
                });
              };
              function bt(D, Fe) {
                var Se, it;
                return Mr(function(Gt) {
                  return Fe in D.F ? Gt.return(D.F[Fe]) : (Se = D.locateFile(Fe, ""), it = fetch(Se).then(function(nn) {
                    return nn.arrayBuffer();
                  }), D.F[Fe] = it, Gt.return(it));
                });
              }
              E.overrideFile = function(D, Fe) {
                this.i ? this.i.overrideFile(D, Fe) : this.B[D] = Fe;
              }, E.clearOverriddenFiles = function() {
                this.B = {}, this.i && this.i.clearOverriddenFiles();
              }, E.send = function(D, Fe) {
                var Se = this, it, Gt, nn, Pt, Mn, Nn, Xr, ei, ji;
                return Mr(function(di) {
                  switch (di.g) {
                    case 1:
                      return Se.g.inputs ? (it = 1e3 * (Fe == null ? performance.now() : Fe), Un(di, Se.C, 2)) : di.return();
                    case 2:
                      return Un(di, Se.initialize(), 3);
                    case 3:
                      for (Gt = new Se.h.PacketDataList(), nn = rt(Object.keys(D)), Pt = nn.next(); !Pt.done; Pt = nn.next())
                        if (Mn = Pt.value, Nn = Se.g.inputs[Mn]) {
                          e: {
                            var Cr = D[Mn];
                            switch (Nn.type) {
                              case "video":
                                var ni = Se.m[Nn.stream];
                                if (ni || (ni = new Gi(Se.h, Se.D), Se.m[Nn.stream] = ni), ni.l === 0 && (ni.l = ni.h.createTexture()), typeof HTMLVideoElement < "u" && Cr instanceof HTMLVideoElement)
                                  var Ai = Cr.videoWidth, Ri = Cr.videoHeight;
                                else
                                  typeof HTMLImageElement < "u" && Cr instanceof HTMLImageElement ? (Ai = Cr.naturalWidth, Ri = Cr.naturalHeight) : (Ai = Cr.width, Ri = Cr.height);
                                Ri = { glName: ni.l, width: Ai, height: Ri }, Ai = ni.g, Ai.canvas.width = Ri.width, Ai.canvas.height = Ri.height, Ai.activeTexture(Ai.TEXTURE0), ni.h.bindTexture2d(ni.l), Ai.texImage2D(Ai.TEXTURE_2D, 0, Ai.RGBA, Ai.RGBA, Ai.UNSIGNED_BYTE, Cr), ni.h.bindTexture2d(0), ni = Ri;
                                break e;
                              case "detections":
                                for (ni = Se.m[Nn.stream], ni || (ni = new vi(Se.h), Se.m[Nn.stream] = ni), ni.data || (ni.data = new ni.g.DetectionListData()), ni.data.reset(Cr.length), Ri = 0; Ri < Cr.length; ++Ri) {
                                  Ai = Cr[Ri];
                                  var Ii = ni.data, Y = Ii.setBoundingBox, me = Ri, Ee = Ai.T, je = new Mt();
                                  if (hr(je, 1, Ee.Y), hr(je, 2, Ee.Z), hr(je, 3, Ee.height), hr(je, 4, Ee.width), hr(je, 5, Ee.rotation), hr(je, 6, Ee.W), Ee = hl(je, nr), Y.call(Ii, me, Ee), Ai.O)
                                    for (Ii = 0; Ii < Ai.O.length; ++Ii) {
                                      je = Ai.O[Ii];
                                      var Tt = !!je.visibility;
                                      Y = ni.data, me = Y.addNormalizedLandmark, Ee = Ri, je = Object.assign(Object.assign({}, je), { visibility: Tt ? je.visibility : 0 }), Tt = new rc(), hr(Tt, 1, je.x), hr(Tt, 2, je.y), hr(Tt, 3, je.z), je.visibility && hr(Tt, 4, je.visibility), je = hl(Tt, xd), me.call(Y, Ee, je);
                                    }
                                  if (Ai.M)
                                    for (Ii = 0; Ii < Ai.M.length; ++Ii)
                                      Y = ni.data, me = Y.addClassification, Ee = Ri, je = Ai.M[Ii], Tt = new Ol(), hr(Tt, 2, je.X), je.index && hr(Tt, 1, je.index), je.label && hr(Tt, 3, je.label), je.displayName && hr(Tt, 4, je.displayName), je = hl(Tt, Jc), me.call(Y, Ee, je);
                                }
                                ni = ni.data;
                                break e;
                              default:
                                ni = {};
                            }
                          }
                          switch (Xr = ni, ei = Nn.stream, Nn.type) {
                            case "video":
                              Gt.pushTexture2d(Object.assign(Object.assign({}, Xr), { stream: ei, timestamp: it }));
                              break;
                            case "detections":
                              ji = Xr, ji.stream = ei, ji.timestamp = it, Gt.pushDetectionList(ji);
                              break;
                            default:
                              throw Error("Unknown input config type: '" + Nn.type + "'");
                          }
                        }
                      return Se.i.send(Gt), Un(di, Se.C, 4);
                    case 4:
                      Gt.delete(), di.g = 0;
                  }
                });
              };
              function Ot(D, Fe, Se) {
                var it, Gt, nn, Pt, Mn, Nn, Xr, ei, ji, di, Cr, ni, Ai, Ri;
                return Mr(function(Ii) {
                  switch (Ii.g) {
                    case 1:
                      if (!Se)
                        return Ii.return(Fe);
                      for (it = {}, Gt = 0, nn = rt(Object.keys(Se)), Pt = nn.next(); !Pt.done; Pt = nn.next())
                        Mn = Pt.value, Nn = Se[Mn], typeof Nn != "string" && Nn.type === "texture" && Fe[Nn.stream] !== void 0 && ++Gt;
                      1 < Gt && (D.G = !1), Xr = rt(Object.keys(Se)), Pt = Xr.next();
                    case 2:
                      if (Pt.done) {
                        Ii.g = 4;
                        break;
                      }
                      if (ei = Pt.value, ji = Se[ei], typeof ji == "string")
                        return Ai = it, Ri = ei, Un(Ii, In(D, ei, Fe[ji]), 14);
                      if (di = Fe[ji.stream], ji.type === "detection_list") {
                        if (di) {
                          for (var Y = di.getRectList(), me = di.getLandmarksList(), Ee = di.getClassificationsList(), je = [], Tt = 0; Tt < Y.size(); ++Tt) {
                            var X = bl(Y.get(Tt), Mt, mn);
                            X = { T: { Y: jn(X, 1), Z: jn(X, 2), height: jn(X, 3), width: jn(X, 4), rotation: jn(X, 5, 0), W: fi(X, 6) }, O: Ki(me.get(Tt)), M: Wr(bl(Ee.get(Tt), Bl, Oc)) }, je.push(X);
                          }
                          Y = je;
                        } else
                          Y = [];
                        it[ei] = Y, Ii.g = 7;
                        break;
                      }
                      if (ji.type === "proto_list") {
                        if (di) {
                          for (Y = Array(di.size()), me = 0; me < di.size(); me++)
                            Y[me] = di.get(me);
                          di.delete();
                        } else
                          Y = [];
                        it[ei] = Y, Ii.g = 7;
                        break;
                      }
                      if (di === void 0) {
                        Ii.g = 3;
                        break;
                      }
                      if (ji.type === "float_list") {
                        it[ei] = di, Ii.g = 7;
                        break;
                      }
                      if (ji.type === "proto") {
                        it[ei] = di, Ii.g = 7;
                        break;
                      }
                      if (ji.type !== "texture")
                        throw Error("Unknown output config type: '" + ji.type + "'");
                      return Cr = D.s[ei], Cr || (Cr = new Gi(D.h, D.D), D.s[ei] = Cr), Un(Ii, yo(Cr, di, D.G), 13);
                    case 13:
                      ni = Ii.h, it[ei] = ni;
                    case 7:
                      ji.transform && it[ei] && (it[ei] = ji.transform(it[ei])), Ii.g = 3;
                      break;
                    case 14:
                      Ai[Ri] = Ii.h;
                    case 3:
                      Pt = Xr.next(), Ii.g = 2;
                      break;
                    case 4:
                      return Ii.return(it);
                  }
                });
              }
              function In(D, Fe, Se) {
                var it;
                return Mr(function(Gt) {
                  return typeof Se == "number" || Se instanceof Uint8Array || Se instanceof D.h.Uint8BlobList ? Gt.return(Se) : Se instanceof D.h.Texture2dDataOut ? (it = D.s[Fe], it || (it = new Gi(D.h, D.D), D.s[Fe] = it), Gt.return(yo(it, Se, D.G))) : Gt.return(void 0);
                });
              }
              function en(D, Fe) {
                for (var Se = Fe.name || "$", it = [].concat(Nt(Fe.wants)), Gt = new D.h.StringList(), nn = rt(Fe.wants), Pt = nn.next(); !Pt.done; Pt = nn.next())
                  Gt.push_back(Pt.value);
                nn = D.h.PacketListener.implement({ onResults: function(Mn) {
                  for (var Nn = {}, Xr = 0; Xr < Fe.wants.length; ++Xr)
                    Nn[it[Xr]] = Mn.get(Xr);
                  var ei = D.listeners[Se];
                  ei && (D.C = Ot(D, Nn, Fe.outs).then(function(ji) {
                    ji = ei(ji);
                    for (var di = 0; di < Fe.wants.length; ++di) {
                      var Cr = Nn[it[di]];
                      typeof Cr == "object" && Cr.hasOwnProperty && Cr.hasOwnProperty("delete") && Cr.delete();
                    }
                    ji && (D.C = ji);
                  }));
                } }), D.i.attachMultiListener(Gt, nn), Gt.delete();
              }
              E.onResults = function(D, Fe) {
                this.listeners[Fe || "$"] = D;
              }, Ji("Solution", ds), Ji("OptionType", { BOOL: 0, NUMBER: 1, $: 2, 0: "BOOL", 1: "NUMBER", 2: "STRING" });
              function Gn(D) {
                switch (D === void 0 && (D = 0), D) {
                  case 1:
                    return "pose_landmark_full.tflite";
                  case 2:
                    return "pose_landmark_heavy.tflite";
                  default:
                    return "pose_landmark_lite.tflite";
                }
              }
              function dr(D) {
                var Fe = this;
                D = D || {}, this.g = new ds({ locateFile: D.locateFile, files: function(Se) {
                  return [{ url: "pose_solution_packed_assets_loader.js" }, { simd: !1, url: "pose_solution_wasm_bin.js" }, { simd: !0, url: "pose_solution_simd_wasm_bin.js" }, { data: !0, url: Gn(Se.modelComplexity) }];
                }, graph: { url: "pose_web.binarypb" }, listeners: [{ wants: ["pose_landmarks", "world_landmarks", "segmentation_mask", "image_transformed"], outs: { image: { type: "texture", stream: "image_transformed" }, poseLandmarks: {
                  type: "proto",
                  stream: "pose_landmarks",
                  transform: Ki
                }, poseWorldLandmarks: { type: "proto", stream: "world_landmarks", transform: Ki }, segmentationMask: { type: "texture", stream: "segmentation_mask" } } }], inputs: { image: { type: "video", stream: "input_frames_gpu" } }, options: {
                  useCpuInference: { type: 0, graphOptionXref: { calculatorType: "InferenceCalculator", fieldName: "use_cpu_inference" }, default: "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document },
                  selfieMode: { type: 0, graphOptionXref: { calculatorType: "GlScalerCalculator", calculatorIndex: 1, fieldName: "flip_horizontal" } },
                  modelComplexity: { type: 1, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorModelComplexity", fieldName: "int_value" }, onChange: function(Se) {
                    var it, Gt, nn;
                    return Mr(function(Pt) {
                      return Pt.g == 1 ? (it = Gn(Se), Gt = "third_party/mediapipe/modules/pose_landmark/" + it, Un(Pt, bt(Fe.g, it), 2)) : (nn = Pt.h, Fe.g.overrideFile(Gt, nn), Pt.return(!0));
                    });
                  } },
                  smoothLandmarks: {
                    type: 0,
                    graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothLandmarks", fieldName: "bool_value" }
                  },
                  enableSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorEnableSegmentation", fieldName: "bool_value" } },
                  smoothSegmentation: { type: 0, graphOptionXref: { calculatorType: "ConstantSidePacketCalculator", calculatorName: "ConstantSidePacketCalculatorSmoothSegmentation", fieldName: "bool_value" } },
                  minDetectionConfidence: { type: 1, graphOptionXref: { calculatorType: "TensorsToDetectionsCalculator", calculatorName: "poselandmarkgpu__posedetectiongpu__TensorsToDetectionsCalculator", fieldName: "min_score_thresh" } },
                  minTrackingConfidence: { type: 1, graphOptionXref: { calculatorType: "ThresholdingCalculator", calculatorName: "poselandmarkgpu__poselandmarkbyroigpu__tensorstoposelandmarksandsegmentation__ThresholdingCalculator", fieldName: "threshold" } }
                } });
              }
              E = dr.prototype, E.reset = function() {
                this.g.reset();
              }, E.close = function() {
                return this.g.close(), n.resolve();
              }, E.onResults = function(D) {
                this.g.onResults(D);
              }, E.initialize = function() {
                var D = this;
                return Mr(function(Fe) {
                  return Un(Fe, D.g.initialize(), 0);
                });
              }, E.send = function(D, Fe) {
                var Se = this;
                return Mr(function(it) {
                  return Un(it, Se.g.send(D, Fe), 0);
                });
              }, E.setOptions = function(D) {
                this.g.setOptions(D);
              }, Ji("Pose", dr), Ji("POSE_CONNECTIONS", [[0, 1], [1, 2], [2, 3], [3, 7], [0, 4], [4, 5], [5, 6], [6, 8], [9, 10], [11, 12], [11, 13], [13, 15], [15, 17], [15, 19], [15, 21], [17, 19], [12, 14], [14, 16], [16, 18], [16, 20], [16, 22], [18, 20], [11, 23], [12, 24], [23, 24], [23, 25], [24, 26], [25, 27], [26, 28], [27, 29], [28, 30], [29, 31], [30, 32], [27, 31], [28, 32]]), Ji("POSE_LANDMARKS", { NOSE: 0, LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, LEFT_EAR: 7, RIGHT_EAR: 8, LEFT_RIGHT: 9, RIGHT_LEFT: 10, LEFT_SHOULDER: 11, RIGHT_SHOULDER: 12, LEFT_ELBOW: 13, RIGHT_ELBOW: 14, LEFT_WRIST: 15, RIGHT_WRIST: 16, LEFT_PINKY: 17, RIGHT_PINKY: 18, LEFT_INDEX: 19, RIGHT_INDEX: 20, LEFT_THUMB: 21, RIGHT_THUMB: 22, LEFT_HIP: 23, RIGHT_HIP: 24, LEFT_KNEE: 25, RIGHT_KNEE: 26, LEFT_ANKLE: 27, RIGHT_ANKLE: 28, LEFT_HEEL: 29, RIGHT_HEEL: 30, LEFT_FOOT_INDEX: 31, RIGHT_FOOT_INDEX: 32 }), Ji("POSE_LANDMARKS_LEFT", { LEFT_EYE_INNER: 1, LEFT_EYE: 2, LEFT_EYE_OUTER: 3, LEFT_EAR: 7, LEFT_RIGHT: 9, LEFT_SHOULDER: 11, LEFT_ELBOW: 13, LEFT_WRIST: 15, LEFT_PINKY: 17, LEFT_INDEX: 19, LEFT_THUMB: 21, LEFT_HIP: 23, LEFT_KNEE: 25, LEFT_ANKLE: 27, LEFT_HEEL: 29, LEFT_FOOT_INDEX: 31 }), Ji("POSE_LANDMARKS_RIGHT", { RIGHT_EYE_INNER: 4, RIGHT_EYE: 5, RIGHT_EYE_OUTER: 6, RIGHT_EAR: 8, RIGHT_LEFT: 10, RIGHT_SHOULDER: 12, RIGHT_ELBOW: 14, RIGHT_WRIST: 16, RIGHT_PINKY: 18, RIGHT_INDEX: 20, RIGHT_THUMB: 22, RIGHT_HIP: 24, RIGHT_KNEE: 26, RIGHT_ANKLE: 28, RIGHT_HEEL: 30, RIGHT_FOOT_INDEX: 32 }), Ji("POSE_LANDMARKS_NEUTRAL", { NOSE: 0 }), Ji("VERSION", "0.5.1635988162");
            }).call(Vt);
            const Et = class {
              constructor() {
                c(this, "mediapipeMap_", /* @__PURE__ */ new Map());
              }
              getVersion(E) {
                switch (E) {
                  case "face_detection":
                    return Oe.VERSION;
                  case "face_mesh":
                    return Jt.VERSION;
                  case "hands":
                    return ln.VERSION;
                  case "holistic":
                    return tt.VERSION;
                  case "objectron":
                    return St.VERSION;
                  case "selfie_segmentation":
                    return Rt.VERSION;
                  case "pose":
                    return Vt.VERSION;
                  default:
                    return "";
                }
              }
              initialize(E) {
                return new n(async (R, S) => {
                  if (E.mediaPipeModelConfigArray.length == 0) {
                    S("no model was selected");
                    return;
                  }
                  for (let ie = 0; ie < E.mediaPipeModelConfigArray.length; ie++) {
                    const pe = E.mediaPipeModelConfigArray[ie];
                    if (this.mediapipeMap_.has(pe.modelType)) {
                      S("setting same type is not supported");
                      return;
                    }
                    if (typeof pe.listener != "function") {
                      S(
                        `[${pe.modelType}] ResultsListener must be provided`
                      );
                      return;
                    }
                    let De;
                    switch (pe.modelType) {
                      case "face_mesh":
                        De = new Jt.FaceMesh({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "face_mesh/" + this.getVersion("face_mesh")) + "/" + ht
                        });
                        break;
                      case "face_detection":
                        De = new Oe.FaceDetection({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "face_detection/" + this.getVersion("face_detection")) + "/" + ht
                        });
                        break;
                      case "hands":
                        De = new ln.Hands({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "hands/" + this.getVersion("hands")) + "/" + ht
                        });
                        break;
                      case "holistic":
                        De = new tt.Holistic({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "holistic/" + this.getVersion("holistic")) + "/" + ht
                        });
                        break;
                      case "objectron":
                        De = new St.Objectron({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "objectron/" + this.getVersion("objectron")) + "/" + ht
                        });
                        break;
                      case "selfie_segmentation":
                        De = new Rt.SelfieSegmentation({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "selfie_segmentation/" + this.getVersion(
                            "selfie_segmentation"
                          )) + "/" + ht
                        });
                        break;
                      case "pose":
                        De = new Vt.Pose({
                          locateFile: (ht, rt) => (pe.assetsUri || Et.defaultAssetsBaseUrl + "pose/" + this.getVersion("pose")) + "/" + ht
                        });
                        break;
                      default:
                        S("unknown model type");
                        return;
                    }
                    De.onResults(pe.listener), pe.options && De.setOptions(pe.options);
                    try {
                      await De.initialize(), this.mediapipeMap_.set(
                        pe.modelType,
                        De
                      );
                    } catch (ht) {
                      S(ht);
                      return;
                    }
                  }
                  R();
                });
              }
              close(E) {
                return new n((R, S) => {
                  let ie = [];
                  if (E) {
                    let pe = this.mediapipeMap_.get(E);
                    if (pe)
                      this.mediapipeMap_.delete(E), ie.push(pe.close());
                    else {
                      S("model not exit");
                      return;
                    }
                  } else {
                    for (const [
                      pe,
                      De
                    ] of this.mediapipeMap_.entries())
                      ie.push(De.close());
                    this.mediapipeMap_.clear();
                  }
                  n.all(ie).then(() => {
                    R();
                  }).catch((pe) => {
                    S(pe);
                  });
                });
              }
              send(E, R) {
                return new n((S, ie) => {
                  let pe = [];
                  if (R) {
                    let De = this.mediapipeMap_.get(R);
                    if (De)
                      pe.push(De.send({ image: E }));
                    else {
                      ie("model not exit");
                      return;
                    }
                  } else
                    for (const [
                      De,
                      ht
                    ] of this.mediapipeMap_.entries())
                      pe.push(ht.send({ image: E }));
                  n.all(pe).then(() => {
                    S();
                  }).catch((De) => {
                    ie(De);
                  });
                });
              }
              reset(E) {
                if (E) {
                  let R = this.mediapipeMap_.get(E);
                  R && typeof R.reset == "function" && R.reset();
                } else
                  for (const [R, S] of this.mediapipeMap_.entries())
                    S && typeof S.reset == "function" && S.reset();
              }
            };
            let Qn = Et;
            c(Qn, "defaultAssetsBaseUrl", "https://d3opqjmqzxf057.cloudfront.net/ml/mediapipe/");
            const gn = /* @__PURE__ */ new WeakMap(), jt = /* @__PURE__ */ new WeakMap(), On = /* @__PURE__ */ new WeakMap(), Ar = Symbol("anyProducer"), ui = n.resolve(), fr = Symbol("listenerAdded"), Jn = Symbol("listenerRemoved");
            let Qr = !1, ti = !1;
            function Wn(E) {
              if (typeof E != "string" && typeof E != "symbol" && typeof E != "number")
                throw new TypeError("`eventName` must be a string, symbol, or number");
            }
            function Hi(E) {
              if (typeof E != "function")
                throw new TypeError("listener must be a function");
            }
            function Ho(E, R) {
              const S = jt.get(E);
              if (S.has(R))
                return S.get(R);
            }
            function Ea(E, R) {
              const S = typeof R == "string" || typeof R == "symbol" || typeof R == "number" ? R : Ar, ie = On.get(E);
              if (ie.has(S))
                return ie.get(S);
            }
            function Ga(E, R, S) {
              const ie = On.get(E);
              if (ie.has(R))
                for (const pe of ie.get(R))
                  pe.enqueue(S);
              if (ie.has(Ar)) {
                const pe = n.all([R, S]);
                for (const De of ie.get(Ar))
                  De.enqueue(pe);
              }
            }
            function No(E, R) {
              R = Array.isArray(R) ? R : [R];
              let S = !1, ie = () => {
              }, pe = [];
              const De = {
                enqueue(ht) {
                  pe.push(ht), ie();
                },
                finish() {
                  S = !0, ie();
                }
              };
              for (const ht of R) {
                let rt = Ea(E, ht);
                rt || (rt = /* @__PURE__ */ new Set(), On.get(E).set(ht, rt)), rt.add(De);
              }
              return {
                async next() {
                  return pe ? pe.length === 0 ? S ? (pe = void 0, this.next()) : (await new n((ht) => {
                    ie = ht;
                  }), this.next()) : {
                    done: !1,
                    value: await pe.shift()
                  } : { done: !0 };
                },
                async return(ht) {
                  pe = void 0;
                  for (const rt of R) {
                    const Nt = Ea(E, rt);
                    Nt && (Nt.delete(De), Nt.size === 0 && On.get(E).delete(rt));
                  }
                  return ie(), arguments.length > 0 ? { done: !0, value: await ht } : { done: !0 };
                },
                [Symbol.asyncIterator]() {
                  return this;
                }
              };
            }
            function Ba(E) {
              if (E === void 0)
                return Va;
              if (!Array.isArray(E))
                throw new TypeError("`methodNames` must be an array of strings");
              for (const R of E)
                if (!Va.includes(R))
                  throw typeof R != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${R} is not Emittery method`);
              return E;
            }
            const Ra = (E) => E === fr || E === Jn;
            function us(E, R, S) {
              if (Ra(R))
                try {
                  Qr = !0, E.emit(R, S);
                } finally {
                  Qr = !1;
                }
            }
            class so {
              static mixin(R, S) {
                return S = Ba(S), (ie) => {
                  if (typeof ie != "function")
                    throw new TypeError("`target` must be function");
                  for (const ht of S)
                    if (ie.prototype[ht] !== void 0)
                      throw new Error(`The property \`${ht}\` already exists on \`target\``);
                  function pe() {
                    return Object.defineProperty(this, R, {
                      enumerable: !1,
                      value: new so()
                    }), this[R];
                  }
                  Object.defineProperty(ie.prototype, R, {
                    enumerable: !1,
                    get: pe
                  });
                  const De = (ht) => function(...rt) {
                    return this[R][ht](...rt);
                  };
                  for (const ht of S)
                    Object.defineProperty(ie.prototype, ht, {
                      enumerable: !1,
                      value: De(ht)
                    });
                  return ie;
                };
              }
              static get isDebugEnabled() {
                var R, S;
                if (typeof ((R = globalThis.process) == null ? void 0 : R.env) != "object")
                  return ti;
                const { env: ie } = (S = globalThis.process) != null ? S : { env: {} };
                return ie.DEBUG === "emittery" || ie.DEBUG === "*" || ti;
              }
              static set isDebugEnabled(R) {
                ti = R;
              }
              constructor(R = {}) {
                var S;
                gn.set(this, /* @__PURE__ */ new Set()), jt.set(this, /* @__PURE__ */ new Map()), On.set(this, /* @__PURE__ */ new Map()), On.get(this).set(Ar, /* @__PURE__ */ new Set()), this.debug = (S = R.debug) != null ? S : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (ie, pe, De, ht) => {
                  try {
                    ht = JSON.stringify(ht);
                  } catch {
                    ht = `Object with the following keys failed to stringify: ${Object.keys(ht).join(",")}`;
                  }
                  (typeof De == "symbol" || typeof De == "number") && (De = De.toString());
                  const rt = /* @__PURE__ */ new Date(), Nt = `${rt.getHours()}:${rt.getMinutes()}:${rt.getSeconds()}.${rt.getMilliseconds()}`;
                  console.log(`[${Nt}][emittery:${ie}][${pe}] Event Name: ${De}
	data: ${ht}`);
                });
              }
              logIfDebugEnabled(R, S, ie) {
                (so.isDebugEnabled || this.debug.enabled) && this.debug.logger(R, this.debug.name, S, ie);
              }
              on(R, S) {
                Hi(S), R = Array.isArray(R) ? R : [R];
                for (const ie of R) {
                  Wn(ie);
                  let pe = Ho(this, ie);
                  pe || (pe = /* @__PURE__ */ new Set(), jt.get(this).set(ie, pe)), pe.add(S), this.logIfDebugEnabled("subscribe", ie, void 0), Ra(ie) || us(this, fr, { eventName: ie, listener: S });
                }
                return this.off.bind(this, R, S);
              }
              off(R, S) {
                Hi(S), R = Array.isArray(R) ? R : [R];
                for (const ie of R) {
                  Wn(ie);
                  const pe = Ho(this, ie);
                  pe && (pe.delete(S), pe.size === 0 && jt.get(this).delete(ie)), this.logIfDebugEnabled("unsubscribe", ie, void 0), Ra(ie) || us(this, Jn, { eventName: ie, listener: S });
                }
              }
              once(R) {
                let S;
                const ie = new n((pe) => {
                  S = this.on(R, (De) => {
                    S(), pe(De);
                  });
                });
                return ie.off = S, ie;
              }
              events(R) {
                R = Array.isArray(R) ? R : [R];
                for (const S of R)
                  Wn(S);
                return No(this, R);
              }
              async emit(R, S) {
                var ie;
                if (Wn(R), Ra(R) && !Qr)
                  throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                this.logIfDebugEnabled("emit", R, S), Ga(this, R, S);
                const pe = (ie = Ho(this, R)) != null ? ie : /* @__PURE__ */ new Set(), De = gn.get(this), ht = [...pe], rt = Ra(R) ? [] : [...De];
                await ui, await n.all([
                  ...ht.map(async (Nt) => {
                    if (pe.has(Nt))
                      return Nt(S);
                  }),
                  ...rt.map(async (Nt) => {
                    if (De.has(Nt))
                      return Nt(R, S);
                  })
                ]);
              }
              async emitSerial(R, S) {
                var ie;
                if (Wn(R), Ra(R) && !Qr)
                  throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                this.logIfDebugEnabled("emitSerial", R, S);
                const pe = (ie = Ho(this, R)) != null ? ie : /* @__PURE__ */ new Set(), De = gn.get(this), ht = [...pe], rt = [...De];
                await ui;
                for (const Nt of ht)
                  pe.has(Nt) && await Nt(S);
                for (const Nt of rt)
                  De.has(Nt) && await Nt(R, S);
              }
              onAny(R) {
                return Hi(R), this.logIfDebugEnabled("subscribeAny", void 0, void 0), gn.get(this).add(R), us(this, fr, { listener: R }), this.offAny.bind(this, R);
              }
              anyEvent() {
                return No(this);
              }
              offAny(R) {
                Hi(R), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), us(this, Jn, { listener: R }), gn.get(this).delete(R);
              }
              clearListeners(R) {
                R = Array.isArray(R) ? R : [R];
                for (const S of R)
                  if (this.logIfDebugEnabled("clear", S, void 0), typeof S == "string" || typeof S == "symbol" || typeof S == "number") {
                    const ie = Ho(this, S);
                    ie && ie.clear();
                    const pe = Ea(this, S);
                    if (pe) {
                      for (const De of pe)
                        De.finish();
                      pe.clear();
                    }
                  } else {
                    gn.get(this).clear();
                    for (const [ie, pe] of jt.get(this).entries())
                      pe.clear(), jt.get(this).delete(ie);
                    for (const [ie, pe] of On.get(this).entries()) {
                      for (const De of pe)
                        De.finish();
                      pe.clear(), On.get(this).delete(ie);
                    }
                  }
              }
              listenerCount(R) {
                var S, ie, pe, De, ht, rt;
                R = Array.isArray(R) ? R : [R];
                let Nt = 0;
                for (const Pn of R) {
                  if (typeof Pn == "string") {
                    Nt += gn.get(this).size + ((ie = (S = Ho(this, Pn)) == null ? void 0 : S.size) != null ? ie : 0) + ((De = (pe = Ea(this, Pn)) == null ? void 0 : pe.size) != null ? De : 0) + ((rt = (ht = Ea(this)) == null ? void 0 : ht.size) != null ? rt : 0);
                    continue;
                  }
                  typeof Pn < "u" && Wn(Pn), Nt += gn.get(this).size;
                  for (const cr of jt.get(this).values())
                    Nt += cr.size;
                  for (const cr of On.get(this).values())
                    Nt += cr.size;
                }
                return Nt;
              }
              bindMethods(R, S) {
                if (typeof R != "object" || R === null)
                  throw new TypeError("`target` must be an object");
                S = Ba(S);
                for (const ie of S) {
                  if (R[ie] !== void 0)
                    throw new Error(`The property \`${ie}\` already exists on \`target\``);
                  Object.defineProperty(R, ie, {
                    enumerable: !1,
                    value: this[ie].bind(this)
                  });
                }
              }
            }
            const Va = Object.getOwnPropertyNames(so.prototype).filter((E) => E !== "constructor");
            Object.defineProperty(so, "listenerAdded", {
              value: fr,
              writable: !1,
              enumerable: !0,
              configurable: !1
            }), Object.defineProperty(so, "listenerRemoved", {
              value: Jn,
              writable: !1,
              enumerable: !0,
              configurable: !1
            });
            function qa(E, R) {
              globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
              let S = globalThis.vonage.workerizer;
              return S[E] || (S[E] = R), S[E];
            }
            const hs = qa(
              "globals",
              {}
            );
            var oi = /* @__PURE__ */ ((E) => (E.INIT = "INIT", E.FORWARD = "FORWARD", E.TERMINATE = "TERMINATE", E.GLOBALS_SYNC = "GLOBALS_SYNC", E.EVENT = "EVENT", E))(oi || {});
            function oa(E) {
              return [ImageBitmap, ReadableStream, WritableStream].some((R) => E instanceof R);
            }
            let Wa = 0;
            function Xa(E, R, S, ie, pe) {
              const De = Wa++;
              return E.postMessage(
                {
                  id: De,
                  type: R,
                  functionName: S,
                  args: ie
                },
                ie.filter((ht) => oa(ht))
              ), new n((ht) => {
                pe == null || pe.set(De, ht);
              });
            }
            function ya(E, R) {
              const { id: S, type: ie } = E, pe = Array.isArray(R) ? R : [R];
              postMessage(
                {
                  id: S,
                  type: ie,
                  result: R
                },
                pe.filter((De) => oa(De))
              );
            }
            const Fl = qa("workerized", {});
            function As() {
              return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
            }
            async function gl() {
              if (As())
                ya({ type: oi.GLOBALS_SYNC }, hs);
              else {
                const E = [];
                for (const R in Fl) {
                  const { worker: S, resolvers: ie } = Fl[R].workerContext;
                  S && E.push(
                    Xa(
                      S,
                      oi.GLOBALS_SYNC,
                      "",
                      [hs],
                      ie
                    )
                  );
                }
                await n.all(E);
              }
            }
            function Vi(E, R) {
              if (Array.isArray(R))
                R.splice(0, R.length);
              else if (typeof R == "object")
                for (const S in R)
                  delete R[S];
              for (const S in E)
                Array.isArray(E[S]) ? (R[S] = [], Vi(E[S], R[S])) : typeof E[S] == "object" ? (R[S] = {}, Vi(E[S], R[S])) : R[S] = E[S];
            }
            async function zr(E, R, S, ie) {
              const pe = new R();
              if (pe.addEventListener(
                "message",
                async ({ data: De }) => {
                  var ht, rt, Nt, Pn, cr, Vr, mi;
                  switch (De.type) {
                    case oi.GLOBALS_SYNC:
                      De.id ? ((rt = S.get((ht = De.id) != null ? ht : -1)) == null || rt(De.result), S.delete((Nt = De.id) != null ? Nt : -1)) : (Vi((Pn = De.result) != null ? Pn : {}, hs), await gl());
                      break;
                    case oi.EVENT:
                      const { result: Fi } = De, br = Fi;
                      if ((br == null ? void 0 : br.name) == null)
                        throw "Missing event name";
                      ie(br.name, br.data);
                      break;
                    default:
                      (Vr = S.get((cr = De.id) != null ? cr : -1)) == null || Vr(De.result), S.delete((mi = De.id) != null ? mi : -1);
                  }
                }
              ), !await Xa(
                pe,
                oi.INIT,
                "",
                [E.workerId, hs],
                S
              ))
                throw "Failed to instantiate workerized class";
              return pe;
            }
            const za = /* @__PURE__ */ new WeakMap(), ws = /* @__PURE__ */ new WeakMap(), Zi = /* @__PURE__ */ new WeakMap(), kl = Symbol("anyProducer"), vc = n.resolve(), wl = Symbol("listenerAdded"), ys = Symbol("listenerRemoved");
            let Xn = !1, Kn = !1;
            function pr(E) {
              if (typeof E != "string" && typeof E != "symbol" && typeof E != "number")
                throw new TypeError("`eventName` must be a string, symbol, or number");
            }
            function hi(E) {
              if (typeof E != "function")
                throw new TypeError("listener must be a function");
            }
            function Qi(E, R) {
              const S = ws.get(E);
              if (S.has(R))
                return S.get(R);
            }
            function qt(E, R) {
              const S = typeof R == "string" || typeof R == "symbol" || typeof R == "number" ? R : kl, ie = Zi.get(E);
              if (ie.has(S))
                return ie.get(S);
            }
            function bn(E, R, S) {
              const ie = Zi.get(E);
              if (ie.has(R))
                for (const pe of ie.get(R))
                  pe.enqueue(S);
              if (ie.has(kl)) {
                const pe = n.all([R, S]);
                for (const De of ie.get(kl))
                  De.enqueue(pe);
              }
            }
            function hn(E, R) {
              R = Array.isArray(R) ? R : [R];
              let S = !1, ie = () => {
              }, pe = [];
              const De = {
                enqueue(ht) {
                  pe.push(ht), ie();
                },
                finish() {
                  S = !0, ie();
                }
              };
              for (const ht of R) {
                let rt = qt(E, ht);
                rt || (rt = /* @__PURE__ */ new Set(), Zi.get(E).set(ht, rt)), rt.add(De);
              }
              return {
                async next() {
                  return pe ? pe.length === 0 ? S ? (pe = void 0, this.next()) : (await new n((ht) => {
                    ie = ht;
                  }), this.next()) : {
                    done: !1,
                    value: await pe.shift()
                  } : { done: !0 };
                },
                async return(ht) {
                  pe = void 0;
                  for (const rt of R) {
                    const Nt = qt(E, rt);
                    Nt && (Nt.delete(De), Nt.size === 0 && Zi.get(E).delete(rt));
                  }
                  return ie(), arguments.length > 0 ? { done: !0, value: await ht } : { done: !0 };
                },
                [Symbol.asyncIterator]() {
                  return this;
                }
              };
            }
            function xn(E) {
              if (E === void 0)
                return _i;
              if (!Array.isArray(E))
                throw new TypeError("`methodNames` must be an array of strings");
              for (const R of E)
                if (!_i.includes(R))
                  throw typeof R != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${R} is not Emittery method`);
              return E;
            }
            const vr = (E) => E === wl || E === ys;
            function Rr(E, R, S) {
              if (vr(R))
                try {
                  Xn = !0, E.emit(R, S);
                } finally {
                  Xn = !1;
                }
            }
            class zi {
              static mixin(R, S) {
                return S = xn(S), (ie) => {
                  if (typeof ie != "function")
                    throw new TypeError("`target` must be function");
                  for (const ht of S)
                    if (ie.prototype[ht] !== void 0)
                      throw new Error(`The property \`${ht}\` already exists on \`target\``);
                  function pe() {
                    return Object.defineProperty(this, R, {
                      enumerable: !1,
                      value: new zi()
                    }), this[R];
                  }
                  Object.defineProperty(ie.prototype, R, {
                    enumerable: !1,
                    get: pe
                  });
                  const De = (ht) => function(...rt) {
                    return this[R][ht](...rt);
                  };
                  for (const ht of S)
                    Object.defineProperty(ie.prototype, ht, {
                      enumerable: !1,
                      value: De(ht)
                    });
                  return ie;
                };
              }
              static get isDebugEnabled() {
                var R, S;
                if (typeof ((R = globalThis.process) == null ? void 0 : R.env) != "object")
                  return Kn;
                const { env: ie } = (S = globalThis.process) != null ? S : { env: {} };
                return ie.DEBUG === "emittery" || ie.DEBUG === "*" || Kn;
              }
              static set isDebugEnabled(R) {
                Kn = R;
              }
              constructor(R = {}) {
                var S;
                za.set(this, /* @__PURE__ */ new Set()), ws.set(this, /* @__PURE__ */ new Map()), Zi.set(this, /* @__PURE__ */ new Map()), Zi.get(this).set(kl, /* @__PURE__ */ new Set()), this.debug = (S = R.debug) != null ? S : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (ie, pe, De, ht) => {
                  try {
                    ht = JSON.stringify(ht);
                  } catch {
                    ht = `Object with the following keys failed to stringify: ${Object.keys(ht).join(",")}`;
                  }
                  (typeof De == "symbol" || typeof De == "number") && (De = De.toString());
                  const rt = /* @__PURE__ */ new Date(), Nt = `${rt.getHours()}:${rt.getMinutes()}:${rt.getSeconds()}.${rt.getMilliseconds()}`;
                  console.log(`[${Nt}][emittery:${ie}][${pe}] Event Name: ${De}
	data: ${ht}`);
                });
              }
              logIfDebugEnabled(R, S, ie) {
                (zi.isDebugEnabled || this.debug.enabled) && this.debug.logger(R, this.debug.name, S, ie);
              }
              on(R, S) {
                hi(S), R = Array.isArray(R) ? R : [R];
                for (const ie of R) {
                  pr(ie);
                  let pe = Qi(this, ie);
                  pe || (pe = /* @__PURE__ */ new Set(), ws.get(this).set(ie, pe)), pe.add(S), this.logIfDebugEnabled("subscribe", ie, void 0), vr(ie) || Rr(this, wl, { eventName: ie, listener: S });
                }
                return this.off.bind(this, R, S);
              }
              off(R, S) {
                hi(S), R = Array.isArray(R) ? R : [R];
                for (const ie of R) {
                  pr(ie);
                  const pe = Qi(this, ie);
                  pe && (pe.delete(S), pe.size === 0 && ws.get(this).delete(ie)), this.logIfDebugEnabled("unsubscribe", ie, void 0), vr(ie) || Rr(this, ys, { eventName: ie, listener: S });
                }
              }
              once(R) {
                let S;
                const ie = new n((pe) => {
                  S = this.on(R, (De) => {
                    S(), pe(De);
                  });
                });
                return ie.off = S, ie;
              }
              events(R) {
                R = Array.isArray(R) ? R : [R];
                for (const S of R)
                  pr(S);
                return hn(this, R);
              }
              async emit(R, S) {
                var ie;
                if (pr(R), vr(R) && !Xn)
                  throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                this.logIfDebugEnabled("emit", R, S), bn(this, R, S);
                const pe = (ie = Qi(this, R)) != null ? ie : /* @__PURE__ */ new Set(), De = za.get(this), ht = [...pe], rt = vr(R) ? [] : [...De];
                await vc, await n.all([
                  ...ht.map(async (Nt) => {
                    if (pe.has(Nt))
                      return Nt(S);
                  }),
                  ...rt.map(async (Nt) => {
                    if (De.has(Nt))
                      return Nt(R, S);
                  })
                ]);
              }
              async emitSerial(R, S) {
                var ie;
                if (pr(R), vr(R) && !Xn)
                  throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                this.logIfDebugEnabled("emitSerial", R, S);
                const pe = (ie = Qi(this, R)) != null ? ie : /* @__PURE__ */ new Set(), De = za.get(this), ht = [...pe], rt = [...De];
                await vc;
                for (const Nt of ht)
                  pe.has(Nt) && await Nt(S);
                for (const Nt of rt)
                  De.has(Nt) && await Nt(R, S);
              }
              onAny(R) {
                return hi(R), this.logIfDebugEnabled("subscribeAny", void 0, void 0), za.get(this).add(R), Rr(this, wl, { listener: R }), this.offAny.bind(this, R);
              }
              anyEvent() {
                return hn(this);
              }
              offAny(R) {
                hi(R), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), Rr(this, ys, { listener: R }), za.get(this).delete(R);
              }
              clearListeners(R) {
                R = Array.isArray(R) ? R : [R];
                for (const S of R)
                  if (this.logIfDebugEnabled("clear", S, void 0), typeof S == "string" || typeof S == "symbol" || typeof S == "number") {
                    const ie = Qi(this, S);
                    ie && ie.clear();
                    const pe = qt(this, S);
                    if (pe) {
                      for (const De of pe)
                        De.finish();
                      pe.clear();
                    }
                  } else {
                    za.get(this).clear();
                    for (const [ie, pe] of ws.get(this).entries())
                      pe.clear(), ws.get(this).delete(ie);
                    for (const [ie, pe] of Zi.get(this).entries()) {
                      for (const De of pe)
                        De.finish();
                      pe.clear(), Zi.get(this).delete(ie);
                    }
                  }
              }
              listenerCount(R) {
                var S, ie, pe, De, ht, rt;
                R = Array.isArray(R) ? R : [R];
                let Nt = 0;
                for (const Pn of R) {
                  if (typeof Pn == "string") {
                    Nt += za.get(this).size + ((ie = (S = Qi(this, Pn)) == null ? void 0 : S.size) != null ? ie : 0) + ((De = (pe = qt(this, Pn)) == null ? void 0 : pe.size) != null ? De : 0) + ((rt = (ht = qt(this)) == null ? void 0 : ht.size) != null ? rt : 0);
                    continue;
                  }
                  typeof Pn < "u" && pr(Pn), Nt += za.get(this).size;
                  for (const cr of ws.get(this).values())
                    Nt += cr.size;
                  for (const cr of Zi.get(this).values())
                    Nt += cr.size;
                }
                return Nt;
              }
              bindMethods(R, S) {
                if (typeof R != "object" || R === null)
                  throw new TypeError("`target` must be an object");
                S = xn(S);
                for (const ie of S) {
                  if (R[ie] !== void 0)
                    throw new Error(`The property \`${ie}\` already exists on \`target\``);
                  Object.defineProperty(R, ie, {
                    enumerable: !1,
                    value: this[ie].bind(this)
                  });
                }
              }
            }
            const _i = Object.getOwnPropertyNames(zi.prototype).filter((E) => E !== "constructor");
            Object.defineProperty(zi, "listenerAdded", {
              value: wl,
              writable: !1,
              enumerable: !0,
              configurable: !1
            }), Object.defineProperty(zi, "listenerRemoved", {
              value: ys,
              writable: !1,
              enumerable: !0,
              configurable: !1
            });
            function Ko(E) {
              return E.onAny && E.emit;
            }
            function ps(E) {
              return E.prototype.onAny && E.prototype.emit;
            }
            let ho = 0;
            async function Ya(E, R, S) {
              const ie = ps(E) ? new zi() : {}, pe = ho++;
              return Object.getOwnPropertyNames(E.prototype).forEach(
                (De) => {
                  ie[De] = (...ht) => Xa(R, oi.FORWARD, De, ht, S);
                }
              ), ie.terminate = async (...De) => {
                const ht = await Xa(
                  R,
                  oi.TERMINATE,
                  "",
                  De,
                  S
                );
                return delete Fl[pe], R.terminate(), ie.workerContext.worker = void 0, ht;
              }, ie.workerContext = {
                id: pe,
                worker: R,
                resolvers: S
              }, Fl[pe] = ie, ie;
            }
            async function La(E, R) {
              const S = /* @__PURE__ */ new Map();
              let ie;
              const pe = await zr(
                E,
                R,
                S,
                (De, ht) => {
                  ie != null && ie.emit && (ie == null || ie.emit(De, ht));
                }
              );
              return ie = await Ya(
                E,
                pe,
                S
              ), ie;
            }
            async function Jd(E, R) {
              const { functionName: S, args: ie } = E;
              if (!R.instance)
                throw "instance not initialized";
              if (!S)
                throw "missing function name to call";
              if (!R.instance[S])
                throw `undefined function [${S}] in class ${R.instance.constructor.workerId}`;
              ya(E, await R.instance[S](...ie != null ? ie : []));
            }
            const zo = qa("registeredWorkers", {});
            function Rl(E, R) {
              R.workerId = E, As() && (zo[R.workerId] = R);
            }
            function ms(E, R) {
              if (!E.args)
                throw "Missing className while initializing worker";
              const [S, ie] = E.args, pe = zo[S];
              if (pe)
                R.instance = new pe(E.args.slice(1));
              else
                throw `unknown worker class ${S}`;
              Vi(ie, hs), Ko(R.instance) && R.instance.onAny((De, ht) => {
                ya(
                  {
                    type: oi.EVENT
                  },
                  { name: De, data: ht }
                );
              }), ya(E, typeof R.instance !== void 0);
            }
            async function $o(E, R) {
              const { args: S } = E;
              if (!R.instance)
                throw "instance not initialized";
              let ie;
              R.instance.terminate && (ie = await R.instance.terminate(...S != null ? S : [])), ya(E, ie);
            }
            function bc(E) {
              if (!E.args)
                throw "Missing globals while syncing";
              Vi(E.args[0], hs), ya(E, {});
            }
            function Zc() {
              const E = {};
              onmessage = async (R) => {
                const S = R.data;
                switch (S.type) {
                  case oi.INIT:
                    ms(S, E);
                    break;
                  case oi.FORWARD:
                    Jd(S, E);
                    break;
                  case oi.TERMINATE:
                    $o(S, E);
                    break;
                  case oi.GLOBALS_SYNC:
                    bc(S);
                    break;
                }
              };
            }
            As() && Zc();
            class oc {
              static async createVideoReadable(R) {
                return new n((S, ie) => {
                  const pe = document.createElement("video");
                  let De = new AbortController(), ht = new AbortController();
                  pe.addEventListener(
                    "canplay",
                    () => {
                      De.abort(), pe.muted = !0, pe.loop = !0, pe.play().then(() => {
                        try {
                          const rt = pe.captureStream(), Nt = new MediaStreamTrackProcessor(
                            rt.getVideoTracks()[0]
                          );
                          S(Nt.readable);
                        } catch (rt) {
                          ie(rt);
                        }
                      });
                    },
                    { once: !0, signal: ht.signal }
                  ), pe.addEventListener(
                    "error",
                    (rt) => {
                      ht.abort(), ie("loading error:" + rt);
                    },
                    { once: !0, signal: De.signal }
                  ), pe.crossOrigin = "anonymous", pe.src = R;
                });
              }
              static async createImageCanvas(R) {
                const S = await (await fetch(R)).blob();
                return await createImageBitmap(S);
              }
            }
            var gu = Object.defineProperty, zd = (E, R, S) => R in E ? gu(E, R, { enumerable: !0, configurable: !0, writable: !0, value: S }) : E[R] = S, ka = (E, R, S) => (zd(E, R + "", S), S);
            const jr = "hlg.tokbox.com/prod/logging/vcp_webrtc", xe = "https://", ot = 1e4;
            let ye;
            const re = new Uint8Array(16);
            function Be() {
              if (!ye && (ye = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ye))
                throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
              return ye(re);
            }
            const He = [];
            for (let E = 0; E < 256; ++E)
              He.push((E + 256).toString(16).slice(1));
            function Xe(E, R = 0) {
              return (He[E[R + 0]] + He[E[R + 1]] + He[E[R + 2]] + He[E[R + 3]] + "-" + He[E[R + 4]] + He[E[R + 5]] + "-" + He[E[R + 6]] + He[E[R + 7]] + "-" + He[E[R + 8]] + He[E[R + 9]] + "-" + He[E[R + 10]] + He[E[R + 11]] + He[E[R + 12]] + He[E[R + 13]] + He[E[R + 14]] + He[E[R + 15]]).toLowerCase();
            }
            const ut = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ct = {
              randomUUID: ut
            };
            function Xt(E, R, S) {
              if (ct.randomUUID && !R && !E)
                return ct.randomUUID();
              E = E || {};
              const ie = E.random || (E.rng || Be)();
              return ie[6] = ie[6] & 15 | 64, ie[8] = ie[8] & 63 | 128, Xe(ie);
            }
            function pn(E, R) {
              globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
              let S = globalThis.vonage.workerizer;
              return S[E] || (S[E] = R), S[E];
            }
            const un = pn(
              "globals",
              {}
            );
            var vt = /* @__PURE__ */ ((E) => (E.INIT = "INIT", E.FORWARD = "FORWARD", E.TERMINATE = "TERMINATE", E.GLOBALS_SYNC = "GLOBALS_SYNC", E))(vt || {});
            function gr(E) {
              return [ImageBitmap, ReadableStream, WritableStream].some((R) => E instanceof R);
            }
            let sr = 0;
            function an(E, R, S, ie, pe) {
              const De = sr++;
              return E.postMessage(
                {
                  id: De,
                  type: R,
                  functionName: S,
                  args: ie
                },
                ie.filter((ht) => gr(ht))
              ), new n((ht) => {
                pe == null || pe.set(De, ht);
              });
            }
            function En(E, R) {
              const { id: S, type: ie } = E, pe = Array.isArray(R) ? R : [R];
              postMessage(
                {
                  id: S,
                  type: ie,
                  result: R
                },
                pe.filter((De) => gr(De))
              );
            }
            const fn = pn("workerized", {});
            function Fr() {
              return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
            }
            async function Ro() {
              if (Fr())
                En({ type: vt.GLOBALS_SYNC }, un);
              else {
                const E = [];
                for (const R in fn) {
                  const { worker: S, resolvers: ie } = fn[R].workerContext;
                  S && E.push(
                    an(
                      S,
                      vt.GLOBALS_SYNC,
                      "",
                      [un],
                      ie
                    )
                  );
                }
                await n.all(E);
              }
            }
            function ca(E, R) {
              if (Array.isArray(R))
                R.splice(0, R.length);
              else if (typeof R == "object")
                for (const S in R)
                  delete R[S];
              for (const S in E)
                Array.isArray(E[S]) ? (R[S] = [], ca(E[S], R[S])) : typeof E[S] == "object" ? (R[S] = {}, ca(E[S], R[S])) : R[S] = E[S];
            }
            async function Co(E, R) {
              const { functionName: S, args: ie } = E;
              if (!R.instance)
                throw "instance not initialized";
              if (!S)
                throw "missing function name to call";
              if (!R.instance[S])
                throw `undefined function [${S}] in class ${R.instance.constructor.workerId}`;
              En(E, await R.instance[S](...ie != null ? ie : []));
            }
            const ga = pn("registeredWorkers", {});
            function aa(E, R) {
              if (!E.args)
                throw "Missing className while initializing worker";
              const [S, ie] = E.args, pe = ga[S];
              if (pe)
                R.instance = new pe(E.args.slice(1));
              else
                throw `unknown worker class ${S}`;
              ca(ie, un), En(E, typeof R.instance !== void 0);
            }
            async function Dl(E, R) {
              const { args: S } = E;
              if (!R.instance)
                throw "instance not initialized";
              let ie;
              R.instance.terminate && (ie = await R.instance.terminate(...S != null ? S : [])), En(E, ie);
            }
            function Jo(E) {
              if (!E.args)
                throw "Missing globals while syncing";
              ca(E.args[0], un), En(E, {});
            }
            function Pi() {
              const E = {};
              onmessage = async (R) => {
                const S = R.data;
                switch (S.type) {
                  case vt.INIT:
                    aa(S, E);
                    break;
                  case vt.FORWARD:
                    Co(S, E);
                    break;
                  case vt.TERMINATE:
                    Dl(S, E);
                    break;
                  case vt.GLOBALS_SYNC:
                    Jo(S);
                    break;
                }
              };
            }
            Fr() && Pi();
            function wa(E, R) {
              return un[E] || (un[E] = R), [
                () => un[E],
                async (S) => {
                  un[E] = S, await Ro();
                }
              ];
            }
            function yl(E, R) {
              return wa(E, R);
            }
            const [Ci, Ti] = yl("metadata");
            function Di() {
              return Ci();
            }
            class Gd {
              constructor(R) {
                ka(this, "uuid", Xt()), this.config = R;
              }
              async send(R) {
                var S, ie, pe;
                const { appId: De, sourceType: ht } = (S = Di()) != null ? S : {};
                if (!De || !ht)
                  return "metadata missing";
                const rt = new AbortController(), Nt = setTimeout(() => rt.abort(), ot);
                return await ((pe = (ie = this.config) == null ? void 0 : ie.fetch) != null ? pe : fetch)(this.getUrl(), {
                  method: "POST",
                  headers: this.getHeaders(),
                  body: JSON.stringify(this.buildReport(R)),
                  signal: rt.signal
                }), clearTimeout(Nt), "success";
              }
              getUrl() {
                var R;
                let S = (R = Di().proxyUrl) != null ? R : xe;
                return S += (S.at(-1) === "/" ? "" : "/") + jr, S;
              }
              getHeaders() {
                return {
                  "Content-Type": "application/json"
                };
              }
              buildReport(R) {
                const S = Di();
                return {
                  guid: this.uuid,
                  ...R,
                  applicationId: S.appId,
                  timestamp: Date.now(),
                  proxyUrl: S.proxyUrl,
                  source: S.sourceType
                };
              }
            }
            const _l = "5.1.2";
            class Zl {
              constructor() {
                c(this, "canvas"), c(this, "context");
                const R = new OffscreenCanvas(0, 0), S = R.getContext("2d");
                if (!S)
                  throw "Fail to retrieve webgl2 context";
                this.canvas = R, this.context = S;
              }
              setFlickeringOptions(R) {
              }
              enablePostProcessing() {
              }
              disablePostProcessing() {
              }
              async profileWebgl(R) {
                return [];
              }
              async render(R, S) {
                return this.canvas;
              }
              resizeCanvas(R) {
                const { width: S, height: ie } = R;
                this.canvas.width = S, this.canvas.height = ie;
              }
              renderSilhouette(R, S, ie = "none") {
                const { width: pe, height: De } = R;
                this.context.save(), this.context.drawImage(
                  S,
                  0,
                  0,
                  S.width,
                  S.height,
                  0,
                  0,
                  pe,
                  De
                ), this.context.globalCompositeOperation = "source-in", this.context.filter = ie, this.context.drawImage(
                  R,
                  0,
                  0,
                  pe,
                  De,
                  0,
                  0,
                  this.canvas.width,
                  this.canvas.height
                ), this.context.restore();
              }
            }
            class Ml extends Zl {
              constructor(R) {
                super(), this.radius = R;
              }
              async render(R, S) {
                return super.resizeCanvas(R), this.renderSilhouette(R, S), this.context.save(), this.context.filter = `blur(${this.radius}px)`, this.context.globalCompositeOperation = "destination-over", this.context.drawImage(R, 0, 0, R.width, R.height), this.context.restore(), super.render(R, S);
              }
            }
            class kc extends Zl {
              constructor(R) {
                super(), this.radius = R;
              }
              async render(R, S) {
                return super.resizeCanvas(R), this.renderSilhouette(R, S, `blur(${this.radius}px)`), this.context.save(), this.context.filter = "none", this.context.globalCompositeOperation = "destination-over", this.context.drawImage(R, 0, 0, R.width, R.height), this.context.restore(), super.render(R, S);
              }
            }
            class Td extends Zl {
              constructor() {
                super(...arguments), c(this, "backgroundImage");
              }
              setBackgroundImage(R) {
                this.backgroundImage = R;
              }
              async render(R, S) {
                return super.resizeCanvas(R), this.renderSilhouette(R, S), this.backgroundImage && (this.context.save(), this.context.filter = "none", this.context.globalCompositeOperation = "destination-over", this.context.drawImage(
                  this.backgroundImage,
                  0,
                  0,
                  this.backgroundImage.width,
                  this.backgroundImage.height,
                  0,
                  0,
                  R.width,
                  R.height
                ), this.context.restore()), super.render(R, S);
              }
            }
            /* @license twgl.js 5.5.1 Copyright (c) 2015, Gregg Tavares All Rights Reserved.
            Available via the MIT license.
            see: http://github.com/greggman/twgl.js for details */
            const wc = 5120, $l = 5121, Yl = 5122, js = 5123, ac = 5124, Dc = 5125, Ll = 5126, ed = 32819, sc = 32820, Ql = 33635, ql = 5131, Ds = 33640, jd = 35899, Sc = 35902, Cl = 36269, _r = 34042, Xd = {};
            {
              const E = Xd;
              E[wc] = Int8Array, E[$l] = Uint8Array, E[Yl] = Int16Array, E[js] = Uint16Array, E[ac] = Int32Array, E[Dc] = Uint32Array, E[Ll] = Float32Array, E[ed] = Uint16Array, E[sc] = Uint16Array, E[Ql] = Uint16Array, E[ql] = Uint16Array, E[Ds] = Uint32Array, E[jd] = Uint32Array, E[Sc] = Uint32Array, E[Cl] = Uint32Array, E[_r] = Uint32Array;
            }
            function to(E) {
              if (E instanceof Int8Array)
                return wc;
              if (E instanceof Uint8Array || E instanceof Uint8ClampedArray)
                return $l;
              if (E instanceof Int16Array)
                return Yl;
              if (E instanceof Uint16Array)
                return js;
              if (E instanceof Int32Array)
                return ac;
              if (E instanceof Uint32Array)
                return Dc;
              if (E instanceof Float32Array)
                return Ll;
              throw new Error("unsupported typed array type");
            }
            function Za(E) {
              if (E === Int8Array)
                return wc;
              if (E === Uint8Array || E === Uint8ClampedArray)
                return $l;
              if (E === Int16Array)
                return Yl;
              if (E === Uint16Array)
                return js;
              if (E === Int32Array)
                return ac;
              if (E === Uint32Array)
                return Dc;
              if (E === Float32Array)
                return Ll;
              throw new Error("unsupported typed array type");
            }
            function sa(E) {
              const R = Xd[E];
              if (!R)
                throw new Error("unknown gl type");
              return R;
            }
            const Ec = typeof SharedArrayBuffer < "u" ? function(E) {
              return E && E.buffer && (E.buffer instanceof ArrayBuffer || E.buffer instanceof SharedArrayBuffer);
            } : function(E) {
              return E && E.buffer && E.buffer instanceof ArrayBuffer;
            };
            function Fc(...E) {
              console.error(...E);
            }
            const Cd = /* @__PURE__ */ new Map();
            function Sl(E, R) {
              if (!E || typeof E != "object")
                return !1;
              let S = Cd.get(R);
              S || (S = /* @__PURE__ */ new WeakMap(), Cd.set(R, S));
              let ie = S.get(E);
              if (ie === void 0) {
                const pe = Object.prototype.toString.call(E);
                ie = pe.substring(8, pe.length - 1) === R, S.set(E, ie);
              }
              return ie;
            }
            function Uo(E, R) {
              return typeof WebGLBuffer < "u" && Sl(R, "WebGLBuffer");
            }
            function ja(E, R) {
              return typeof WebGLRenderbuffer < "u" && Sl(R, "WebGLRenderbuffer");
            }
            function Mc(E, R) {
              return typeof WebGLTexture < "u" && Sl(R, "WebGLTexture");
            }
            function td(E, R) {
              return typeof WebGLSampler < "u" && Sl(R, "WebGLSampler");
            }
            const Ud = 35044, fl = 34962, ou = 34963, nd = 34660, au = 5120, lc = 5121, Vc = 5122, _s = 5123, da = 5124, kd = 5125, la = 5126, cc = {
              attribPrefix: ""
            };
            function Da(E, R, S, ie, pe) {
              E.bindBuffer(R, S), E.bufferData(R, ie, pe || Ud);
            }
            function ea(E, R, S, ie) {
              if (Uo(E, R))
                return R;
              S = S || fl;
              const pe = E.createBuffer();
              return Da(E, S, pe, R, ie), pe;
            }
            function ec(E) {
              return E === "indices";
            }
            function Yc(E) {
              return E === Int8Array || E === Uint8Array;
            }
            function rd(E) {
              return E.length ? E : E.data;
            }
            const Lc = /coord|texture/i, fu = /color|colour/i;
            function El(E, R) {
              let S;
              if (Lc.test(E) ? S = 2 : fu.test(E) ? S = 4 : S = 3, R % S > 0)
                throw new Error(`Can not guess numComponents for attribute '${E}'. Tried ${S} but ${R} values is not evenly divisible by ${S}. You should specify it.`);
              return S;
            }
            function xc(E, R, S) {
              return E.numComponents || E.size || El(R, S || rd(E).length);
            }
            function _d(E, R) {
              if (Ec(E))
                return E;
              if (Ec(E.data))
                return E.data;
              Array.isArray(E) && (E = {
                data: E
              });
              let S = E.type ? co(E.type) : void 0;
              return S || (ec(R) ? S = Uint16Array : S = Float32Array), new S(E.data);
            }
            function vo(E) {
              return typeof E == "number" ? E : E ? Za(E) : la;
            }
            function co(E) {
              return typeof E == "number" ? sa(E) : E || Float32Array;
            }
            function id(E, R) {
              return {
                buffer: R.buffer,
                numValues: 2 * 3 * 4,
                type: vo(R.type),
                arrayType: co(R.type)
              };
            }
            function wd(E, R) {
              const S = R.data || R, ie = co(R.type), pe = S * ie.BYTES_PER_ELEMENT, De = E.createBuffer();
              return E.bindBuffer(fl, De), E.bufferData(fl, pe, R.drawType || Ud), {
                buffer: De,
                numValues: S,
                type: Za(ie),
                arrayType: ie
              };
            }
            function Dd(E, R, S) {
              const ie = _d(R, S);
              return {
                arrayType: ie.constructor,
                buffer: ea(E, ie, void 0, R.drawType),
                type: to(ie),
                numValues: 0
              };
            }
            function su(E, R) {
              const S = {};
              return Object.keys(R).forEach(function(ie) {
                if (!ec(ie)) {
                  const pe = R[ie], De = pe.attrib || pe.name || pe.attribName || cc.attribPrefix + ie;
                  if (pe.value) {
                    if (!Array.isArray(pe.value) && !Ec(pe.value))
                      throw new Error("array.value is not array or typedarray");
                    S[De] = {
                      value: pe.value
                    };
                  } else {
                    let ht;
                    pe.buffer && pe.buffer instanceof WebGLBuffer ? ht = id : typeof pe == "number" || typeof pe.data == "number" ? ht = wd : ht = Dd;
                    const { buffer: rt, type: Nt, numValues: Pn, arrayType: cr } = ht(E, pe, ie), Vr = pe.normalize !== void 0 ? pe.normalize : Yc(cr), mi = xc(pe, ie, Pn);
                    S[De] = {
                      buffer: rt,
                      numComponents: mi,
                      type: Nt,
                      normalize: Vr,
                      stride: pe.stride || 0,
                      offset: pe.offset || 0,
                      divisor: pe.divisor === void 0 ? void 0 : pe.divisor,
                      drawType: pe.drawType
                    };
                  }
                }
              }), E.bindBuffer(fl, null), S;
            }
            function Md(E, R) {
              return R === au || R === lc ? 1 : R === Vc || R === _s ? 2 : R === da || R === kd || R === la ? 4 : 0;
            }
            const od = ["position", "positions", "a_position"];
            function Je(E, R) {
              let S, ie;
              for (ie = 0; ie < od.length && (S = od[ie], !(S in R || (S = cc.attribPrefix + S, S in R))); ++ie)
                ;
              ie === od.length && (S = Object.keys(R)[0]);
              const pe = R[S];
              if (!pe.buffer)
                return 1;
              E.bindBuffer(fl, pe.buffer);
              const De = E.getBufferParameter(fl, nd);
              E.bindBuffer(fl, null);
              const ht = Md(E, pe.type), rt = De / ht, Nt = pe.numComponents || pe.size, Pn = rt / Nt;
              if (Pn % 1 !== 0)
                throw new Error(`numComponents ${Nt} not correct for length ${length}`);
              return Pn;
            }
            function Ne(E, R, S) {
              const ie = su(E, R), pe = Object.assign({}, {});
              pe.attribs = Object.assign({}, {}, ie);
              const De = R.indices;
              if (De) {
                const ht = _d(De, "indices");
                pe.indices = ea(E, ht, ou), pe.numElements = ht.length, pe.elementType = to(ht);
              } else
                pe.numElements || (pe.numElements = Je(E, pe.attribs));
              return pe;
            }
            function qr(E) {
              return !!E.texStorage2D;
            }
            const dc = /* @__PURE__ */ function() {
              const E = {}, R = {};
              function S(ie) {
                const pe = ie.constructor.name;
                if (!E[pe]) {
                  for (const De in ie)
                    if (typeof ie[De] == "number") {
                      const ht = R[ie[De]];
                      R[ie[De]] = ht ? `${ht} | ${De}` : De;
                    }
                  E[pe] = !0;
                }
              }
              return function(ie, pe) {
                return S(ie), R[pe] || (typeof pe == "number" ? `0x${pe.toString(16)}` : pe);
              };
            }(), sl = {
              textureColor: new Uint8Array([128, 192, 255, 255]),
              textureOptions: {},
              crossOrigin: void 0
            }, Ta = Ec, $d = /* @__PURE__ */ function() {
              let E;
              return function() {
                return E = E || (typeof document < "u" && document.createElement ? document.createElement("canvas").getContext("2d") : null), E;
              };
            }(), Id = 6406, $s = 6407, _a = 6408, no = 6409, Bd = 6410, xl = 6402, Yd = 34041, nt = 33071, Ke = 9728, et = 9729, dt = 3553, $t = 34067, be = 32879, ze = 35866, P = 34069, te = 34070, Re = 34071, Qe = 34072, yt = 34073, Ht = 34074, zt = 10241, rn = 10240, tr = 10242, Vn = 10243, si = 32882, ai = 33082, Ui = 33083, Sa = 33084, xa = 33085, ll = 34892, Hc = 34893, Wc = 3317, Zd = 3314, Sd = 32878, lu = 3316, Zu = 3315, Su = 32877, qd = 37443, rA = 37441, iA = 37440, Ku = 33321, oA = 36756, zu = 33325, ig = 33326, ju = 33330, Rc = 33329, pu = 33338, mu = 33337, y0 = 33340, Eu = 33339, Ha = 33323, aA = 36757, Vu = 33327, _u = 33328, og = 33336, eu = 33335, tu = 33332, ag = 33331, Q0 = 33334, lh = 33333, ch = 32849, $u = 35905, C0 = 36194, Es = 36758, sA = 35898, lA = 35901, Wu = 34843, sg = 34837, Nu = 36221, U0 = 36239, vu = 36215, lg = 36233, cA = 36209, qu = 36227, cg = 32856, dA = 35907, I0 = 36759, dg = 32855, e0 = 32854, ug = 32857, t0 = 34842, yc = 34836, dh = 36220, hg = 36238, Ag = 36975, B0 = 36214, uA = 36232, gg = 36226, n0 = 36208, fg = 33189, pg = 33190, mg = 36012, hA = 36013, vg = 35056, Ed = 5120, Vs = 5121, Z0 = 5122, Ju = 5123, S0 = 5124, ad = 5125, uc = 5126, uh = 32819, hh = 32820, E0 = 33635, Vd = 5131, Gu = 36193, Ah = 33640, bg = 35899, AA = 35902, Fg = 36269, Rg = 34042, V0 = 33319, Tu = 33320, r0 = 6403, tc = 36244, cu = 36248, bu = 36249;
            let gh;
            function Fu(E) {
              if (!gh) {
                const R = {};
                R[Id] = { textureFormat: Id, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [1, 2, 2, 4], type: [Vs, Vd, Gu, uc] }, R[no] = { textureFormat: no, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [1, 2, 2, 4], type: [Vs, Vd, Gu, uc] }, R[Bd] = { textureFormat: Bd, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [2, 4, 4, 8], type: [Vs, Vd, Gu, uc] }, R[$s] = { textureFormat: $s, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [3, 6, 6, 12, 2], type: [Vs, Vd, Gu, uc, E0] }, R[_a] = { textureFormat: _a, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4, 8, 8, 16, 2, 2], type: [Vs, Vd, Gu, uc, uh, hh] }, R[xl] = { textureFormat: xl, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2, 4], type: [ad, Ju] }, R[Ku] = { textureFormat: r0, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [1], type: [Vs] }, R[oA] = { textureFormat: r0, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [1], type: [Ed] }, R[zu] = { textureFormat: r0, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [4, 2], type: [uc, Vd] }, R[ig] = { textureFormat: r0, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [4], type: [uc] }, R[ju] = { textureFormat: tc, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [1], type: [Vs] }, R[Rc] = { textureFormat: tc, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [1], type: [Ed] }, R[tu] = { textureFormat: tc, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [Ju] }, R[ag] = { textureFormat: tc, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [Z0] }, R[Q0] = { textureFormat: tc, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [ad] }, R[lh] = { textureFormat: tc, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [S0] }, R[Ha] = { textureFormat: V0, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [2], type: [Vs] }, R[aA] = { textureFormat: V0, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [2], type: [Ed] }, R[Vu] = { textureFormat: V0, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [8, 4], type: [uc, Vd] }, R[_u] = { textureFormat: V0, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [8], type: [uc] }, R[og] = { textureFormat: Tu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [Vs] }, R[eu] = { textureFormat: Tu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2], type: [Ed] }, R[pu] = { textureFormat: Tu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Ju] }, R[mu] = { textureFormat: Tu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Z0] }, R[y0] = { textureFormat: Tu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [ad] }, R[Eu] = { textureFormat: Tu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [S0] }, R[ch] = { textureFormat: $s, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [3], type: [Vs] }, R[$u] = { textureFormat: $s, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [3], type: [Vs] }, R[C0] = { textureFormat: $s, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [3, 2], type: [Vs, E0] }, R[Es] = { textureFormat: $s, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [3], type: [Ed] }, R[sA] = { textureFormat: $s, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [12, 6, 4], type: [uc, Vd, bg] }, R[lA] = { textureFormat: $s, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [12, 6, 4], type: [uc, Vd, AA] }, R[Wu] = { textureFormat: $s, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [12, 6], type: [uc, Vd] }, R[sg] = { textureFormat: $s, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [12], type: [uc] }, R[Nu] = { textureFormat: cu, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [3], type: [Vs] }, R[U0] = { textureFormat: cu, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [3], type: [Ed] }, R[vu] = { textureFormat: cu, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [6], type: [Ju] }, R[lg] = { textureFormat: cu, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [6], type: [Z0] }, R[cA] = { textureFormat: cu, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [12], type: [ad] }, R[qu] = { textureFormat: cu, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [12], type: [S0] }, R[cg] = { textureFormat: _a, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4], type: [Vs] }, R[dA] = { textureFormat: _a, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4], type: [Vs] }, R[I0] = { textureFormat: _a, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [4], type: [Ed] }, R[dg] = { textureFormat: _a, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4, 2, 4], type: [Vs, hh, Ah] }, R[e0] = { textureFormat: _a, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4, 2], type: [Vs, uh] }, R[ug] = { textureFormat: _a, colorRenderable: !0, textureFilterable: !0, bytesPerElement: [4], type: [Ah] }, R[t0] = { textureFormat: _a, colorRenderable: !1, textureFilterable: !0, bytesPerElement: [16, 8], type: [uc, Vd] }, R[yc] = { textureFormat: _a, colorRenderable: !1, textureFilterable: !1, bytesPerElement: [16], type: [uc] }, R[dh] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Vs] }, R[hg] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Ed] }, R[Ag] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Ah] }, R[B0] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [Ju] }, R[uA] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [8], type: [Z0] }, R[gg] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [16], type: [S0] }, R[n0] = { textureFormat: bu, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [16], type: [ad] }, R[fg] = { textureFormat: xl, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [2, 4], type: [Ju, ad] }, R[pg] = { textureFormat: xl, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [ad] }, R[mg] = { textureFormat: xl, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [uc] }, R[vg] = { textureFormat: Yd, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Rg] }, R[hA] = { textureFormat: Yd, colorRenderable: !0, textureFilterable: !1, bytesPerElement: [4], type: [Fg] }, Object.keys(R).forEach(function(S) {
                  const ie = R[S];
                  ie.bytesPerElementMap = {}, ie.bytesPerElement.forEach(function(pe, De) {
                    const ht = ie.type[De];
                    ie.bytesPerElementMap[ht] = pe;
                  });
                }), gh = R;
              }
              return gh[E];
            }
            function W0(E, R) {
              const S = Fu(E);
              if (!S)
                throw "unknown internal format";
              const ie = S.bytesPerElementMap[R];
              if (ie === void 0)
                throw "unknown internal format";
              return ie;
            }
            function i0(E) {
              const R = Fu(E);
              if (!R)
                throw "unknown internal format";
              return {
                format: R.textureFormat,
                type: R.type[0]
              };
            }
            function du(E) {
              return (E & E - 1) === 0;
            }
            function yg(E, R, S, ie) {
              if (!qr(E))
                return du(R) && du(S);
              const pe = Fu(ie);
              if (!pe)
                throw "unknown internal format";
              return pe.colorRenderable && pe.textureFilterable;
            }
            function Qg(E) {
              const R = Fu(E);
              if (!R)
                throw "unknown internal format";
              return R.textureFilterable;
            }
            function Cg(E, R, S) {
              return Ta(R) ? to(R) : S || Vs;
            }
            function N0(E, R, S, ie, pe) {
              if (pe % 1 !== 0)
                throw "can't guess dimensions";
              if (!S && !ie) {
                const De = Math.sqrt(pe / (R === $t ? 6 : 1));
                De % 1 === 0 ? (S = De, ie = De) : (S = pe, ie = 1);
              } else if (ie) {
                if (!S && (S = pe / ie, S % 1))
                  throw "can't guess dimensions";
              } else if (ie = pe / S, ie % 1)
                throw "can't guess dimensions";
              return {
                width: S,
                height: ie
              };
            }
            function Ru(E, R) {
              R.colorspaceConversion !== void 0 && E.pixelStorei(qd, R.colorspaceConversion), R.premultiplyAlpha !== void 0 && E.pixelStorei(rA, R.premultiplyAlpha), R.flipY !== void 0 && E.pixelStorei(iA, R.flipY);
            }
            function gA(E) {
              E.pixelStorei(Wc, 4), qr(E) && (E.pixelStorei(Zd, 0), E.pixelStorei(Sd, 0), E.pixelStorei(lu, 0), E.pixelStorei(Zu, 0), E.pixelStorei(Su, 0));
            }
            function fA(E, R, S, ie) {
              ie.minMag && (S.call(E, R, zt, ie.minMag), S.call(E, R, rn, ie.minMag)), ie.min && S.call(E, R, zt, ie.min), ie.mag && S.call(E, R, rn, ie.mag), ie.wrap && (S.call(E, R, tr, ie.wrap), S.call(E, R, Vn, ie.wrap), (R === be || td(E, R)) && S.call(E, R, si, ie.wrap)), ie.wrapR && S.call(E, R, si, ie.wrapR), ie.wrapS && S.call(E, R, tr, ie.wrapS), ie.wrapT && S.call(E, R, Vn, ie.wrapT), ie.minLod !== void 0 && S.call(E, R, ai, ie.minLod), ie.maxLod !== void 0 && S.call(E, R, Ui, ie.maxLod), ie.baseLevel !== void 0 && S.call(E, R, Sa, ie.baseLevel), ie.maxLevel !== void 0 && S.call(E, R, xa, ie.maxLevel), ie.compareFunc !== void 0 && S.call(E, R, Hc, ie.compareFunc), ie.compareMode !== void 0 && S.call(E, R, ll, ie.compareMode);
            }
            function pA(E, R, S) {
              const ie = S.target || dt;
              E.bindTexture(ie, R), fA(E, ie, E.texParameteri, S);
            }
            function Ug(E) {
              return E = E || sl.textureColor, Ta(E) ? E : new Uint8Array([E[0] * 255, E[1] * 255, E[2] * 255, E[3] * 255]);
            }
            function fh(E, R, S, ie, pe, De) {
              S = S || sl.textureOptions, De = De || _a;
              const ht = S.target || dt;
              if (ie = ie || S.width, pe = pe || S.height, E.bindTexture(ht, R), yg(E, ie, pe, De))
                E.generateMipmap(ht);
              else {
                const rt = Qg(De) ? et : Ke;
                E.texParameteri(ht, zt, rt), E.texParameteri(ht, rn, rt), E.texParameteri(ht, tr, nt), E.texParameteri(ht, Vn, nt);
              }
            }
            function o0(E) {
              return E.auto === !0 || E.auto === void 0 && E.level === void 0;
            }
            function ph(E, R) {
              return R = R || {}, R.cubeFaceOrder || [
                P,
                te,
                Re,
                Qe,
                yt,
                Ht
              ];
            }
            function mh(E, R) {
              const S = ph(E, R).map(function(ie, pe) {
                return { face: ie, ndx: pe };
              });
              return S.sort(function(ie, pe) {
                return ie.face - pe.face;
              }), S;
            }
            function mA(E, R, S, ie) {
              ie = ie || sl.textureOptions;
              const pe = ie.target || dt, De = ie.level || 0;
              let ht = S.width, rt = S.height;
              const Nt = ie.internalFormat || ie.format || _a, Pn = i0(Nt), cr = ie.format || Pn.format, Vr = ie.type || Pn.type;
              if (Ru(E, ie), E.bindTexture(pe, R), pe === $t) {
                const mi = S.width, Fi = S.height;
                let br, Nr;
                if (mi / 6 === Fi)
                  br = Fi, Nr = [0, 0, 1, 0, 2, 0, 3, 0, 4, 0, 5, 0];
                else if (Fi / 6 === mi)
                  br = mi, Nr = [0, 0, 0, 1, 0, 2, 0, 3, 0, 4, 0, 5];
                else if (mi / 3 === Fi / 2)
                  br = mi / 3, Nr = [0, 0, 1, 0, 2, 0, 0, 1, 1, 1, 2, 1];
                else if (mi / 2 === Fi / 3)
                  br = mi / 2, Nr = [0, 0, 1, 0, 0, 1, 1, 1, 0, 2, 1, 2];
                else
                  throw "can't figure out cube map from element: " + (S.src ? S.src : S.nodeName);
                const $i = $d();
                $i ? ($i.canvas.width = br, $i.canvas.height = br, ht = br, rt = br, mh(E, ie).forEach(function(qi) {
                  const Vo = Nr[qi.ndx * 2 + 0] * br, Un = Nr[qi.ndx * 2 + 1] * br;
                  $i.drawImage(S, Vo, Un, br, br, 0, 0, br, br), E.texImage2D(qi.face, De, Nt, cr, Vr, $i.canvas);
                }), $i.canvas.width = 1, $i.canvas.height = 1) : typeof createImageBitmap < "u" && (ht = br, rt = br, mh(E, ie).forEach(function(qi) {
                  const Vo = Nr[qi.ndx * 2 + 0] * br, Un = Nr[qi.ndx * 2 + 1] * br;
                  E.texImage2D(qi.face, De, Nt, br, br, 0, cr, Vr, null), createImageBitmap(S, Vo, Un, br, br, {
                    premultiplyAlpha: "none",
                    colorSpaceConversion: "none"
                  }).then(function(el) {
                    Ru(E, ie), E.bindTexture(pe, R), E.texImage2D(qi.face, De, Nt, cr, Vr, el), o0(ie) && fh(E, R, ie, ht, rt, Nt);
                  });
                }));
              } else if (pe === be || pe === ze) {
                const mi = Math.min(S.width, S.height), Fi = Math.max(S.width, S.height), br = Fi / mi;
                if (br % 1 !== 0)
                  throw "can not compute 3D dimensions of element";
                const Nr = S.width === Fi ? 1 : 0, $i = S.height === Fi ? 1 : 0;
                E.pixelStorei(Wc, 1), E.pixelStorei(Zd, S.width), E.pixelStorei(Sd, 0), E.pixelStorei(Su, 0), E.texImage3D(pe, De, Nt, mi, mi, mi, 0, cr, Vr, null);
                for (let qi = 0; qi < br; ++qi) {
                  const Vo = qi * mi * Nr, Un = qi * mi * $i;
                  E.pixelStorei(lu, Vo), E.pixelStorei(Zu, Un), E.texSubImage3D(pe, De, 0, 0, qi, mi, mi, 1, cr, Vr, S);
                }
                gA(E);
              } else
                E.texImage2D(pe, De, Nt, cr, Vr, S);
              o0(ie) && fh(E, R, ie, ht, rt, Nt), pA(E, R, ie);
            }
            function a0() {
            }
            function Ig(E) {
              if (typeof document < "u") {
                const R = document.createElement("a");
                return R.href = E, R.hostname === location.hostname && R.port === location.port && R.protocol === location.protocol;
              } else {
                const R = new URL(location.href).origin;
                return new URL(E, location.href).origin === R;
              }
            }
            function J0(E, R) {
              return R === void 0 && !Ig(E) ? "anonymous" : R;
            }
            function Bg(E, R, S) {
              S = S || a0;
              let ie;
              if (R = R !== void 0 ? R : sl.crossOrigin, R = J0(E, R), typeof Image < "u") {
                ie = new Image(), R !== void 0 && (ie.crossOrigin = R);
                const pe = function() {
                  ie.removeEventListener("error", De), ie.removeEventListener("load", ht), ie = null;
                }, De = function() {
                  const rt = "couldn't load image: " + E;
                  Fc(rt), S(rt, ie), pe();
                }, ht = function() {
                  S(null, ie), pe();
                };
                return ie.addEventListener("error", De), ie.addEventListener("load", ht), ie.src = E, ie;
              } else if (typeof ImageBitmap < "u") {
                let pe, De;
                const ht = function() {
                  S(pe, De);
                }, rt = {};
                R && (rt.mode = "cors"), fetch(E, rt).then(function(Nt) {
                  if (!Nt.ok)
                    throw Nt;
                  return Nt.blob();
                }).then(function(Nt) {
                  return createImageBitmap(Nt, {
                    premultiplyAlpha: "none",
                    colorSpaceConversion: "none"
                  });
                }).then(function(Nt) {
                  De = Nt, setTimeout(ht);
                }).catch(function(Nt) {
                  pe = Nt, setTimeout(ht);
                }), ie = null;
              }
              return ie;
            }
            function vh(E) {
              return typeof ImageBitmap < "u" && E instanceof ImageBitmap || typeof ImageData < "u" && E instanceof ImageData || typeof HTMLElement < "u" && E instanceof HTMLElement;
            }
            function Xu(E, R, S) {
              return vh(E) ? (setTimeout(function() {
                S(null, E);
              }), E) : Bg(E, R, S);
            }
            function ku(E, R, S) {
              S = S || sl.textureOptions;
              const ie = S.target || dt;
              if (E.bindTexture(ie, R), S.color === !1)
                return;
              const pe = Ug(S.color);
              if (ie === $t)
                for (let De = 0; De < 6; ++De)
                  E.texImage2D(P + De, 0, _a, 1, 1, 0, _a, Vs, pe);
              else
                ie === be || ie === ze ? E.texImage3D(ie, 0, _a, 1, 1, 1, 0, _a, Vs, pe) : E.texImage2D(ie, 0, _a, 1, 1, 0, _a, Vs, pe);
            }
            function Zg(E, R, S, ie) {
              return ie = ie || a0, S = S || sl.textureOptions, ku(E, R, S), S = Object.assign({}, S), Xu(S.src, S.crossOrigin, function(pe, De) {
                pe ? ie(pe, R, De) : (mA(E, R, De, S), ie(null, R, De));
              });
            }
            function bh(E, R, S, ie) {
              ie = ie || a0;
              const pe = S.src;
              if (pe.length !== 6)
                throw "there must be 6 urls for a cubemap";
              const De = S.level || 0, ht = S.internalFormat || S.format || _a, rt = i0(ht), Nt = S.format || rt.format, Pn = S.type || Vs, cr = S.target || dt;
              if (cr !== $t)
                throw "target must be TEXTURE_CUBE_MAP";
              ku(E, R, S), S = Object.assign({}, S);
              let Vr = 6;
              const mi = [], Fi = ph(E, S);
              let br;
              function Nr($i) {
                return function(qi, Vo) {
                  --Vr, qi ? mi.push(qi) : Vo.width !== Vo.height ? mi.push("cubemap face img is not a square: " + Vo.src) : (Ru(E, S), E.bindTexture(cr, R), Vr === 5 ? ph().forEach(function(Un) {
                    E.texImage2D(Un, De, ht, Nt, Pn, Vo);
                  }) : E.texImage2D($i, De, ht, Nt, Pn, Vo), o0(S) && E.generateMipmap(cr)), Vr === 0 && ie(mi.length ? mi : void 0, R, br);
                };
              }
              br = pe.map(function($i, qi) {
                return Xu($i, S.crossOrigin, Nr(Fi[qi]));
              });
            }
            function Sg(E, R, S, ie) {
              ie = ie || a0;
              const pe = S.src, De = S.internalFormat || S.format || _a, ht = i0(De), rt = S.format || ht.format, Nt = S.type || Vs, Pn = S.target || ze;
              if (Pn !== be && Pn !== ze)
                throw "target must be TEXTURE_3D or TEXTURE_2D_ARRAY";
              ku(E, R, S), S = Object.assign({}, S);
              let cr = pe.length;
              const Vr = [];
              let mi;
              const Fi = S.level || 0;
              let br = S.width, Nr = S.height;
              const $i = pe.length;
              let qi = !0;
              function Vo(Un) {
                return function(el, Ys) {
                  if (--cr, el)
                    Vr.push(el);
                  else {
                    if (Ru(E, S), E.bindTexture(Pn, R), qi) {
                      qi = !1, br = S.width || Ys.width, Nr = S.height || Ys.height, E.texImage3D(Pn, Fi, De, br, Nr, $i, 0, rt, Nt, null);
                      for (let Ca = 0; Ca < $i; ++Ca)
                        E.texSubImage3D(Pn, Fi, 0, 0, Ca, br, Nr, 1, rt, Nt, Ys);
                    } else {
                      let Ca = Ys, lo;
                      (Ys.width !== br || Ys.height !== Nr) && (lo = $d(), Ca = lo.canvas, lo.canvas.width = br, lo.canvas.height = Nr, lo.drawImage(Ys, 0, 0, br, Nr)), E.texSubImage3D(Pn, Fi, 0, 0, Un, br, Nr, 1, rt, Nt, Ca), lo && Ca === lo.canvas && (lo.canvas.width = 0, lo.canvas.height = 0);
                    }
                    o0(S) && E.generateMipmap(Pn);
                  }
                  cr === 0 && ie(Vr.length ? Vr : void 0, R, mi);
                };
              }
              mi = pe.map(function(Un, el) {
                return Xu(Un, S.crossOrigin, Vo(el));
              });
            }
            function vA(E, R, S, ie) {
              ie = ie || sl.textureOptions;
              const pe = ie.target || dt;
              E.bindTexture(pe, R);
              let De = ie.width, ht = ie.height, rt = ie.depth;
              const Nt = ie.level || 0, Pn = ie.internalFormat || ie.format || _a, cr = i0(Pn), Vr = ie.format || cr.format, mi = ie.type || Cg(E, S, cr.type);
              if (Ta(S))
                S instanceof Uint8ClampedArray && (S = new Uint8Array(S.buffer));
              else {
                const $i = sa(mi);
                S = new $i(S);
              }
              const Fi = W0(Pn, mi), br = S.byteLength / Fi;
              if (br % 1)
                throw "length wrong size for format: " + dc(E, Vr);
              let Nr;
              if (pe === be || pe === ze)
                if (!De && !ht && !rt) {
                  const $i = Math.cbrt(br);
                  if ($i % 1 !== 0)
                    throw "can't guess cube size of array of numElements: " + br;
                  De = $i, ht = $i, rt = $i;
                } else
                  De && (!ht || !rt) ? (Nr = N0(E, pe, ht, rt, br / De), ht = Nr.width, rt = Nr.height) : ht && (!De || !rt) ? (Nr = N0(E, pe, De, rt, br / ht), De = Nr.width, rt = Nr.height) : (Nr = N0(E, pe, De, ht, br / rt), De = Nr.width, ht = Nr.height);
              else
                Nr = N0(E, pe, De, ht, br), De = Nr.width, ht = Nr.height;
              if (gA(E), E.pixelStorei(Wc, ie.unpackAlignment || 1), Ru(E, ie), pe === $t) {
                const $i = Fi / S.BYTES_PER_ELEMENT, qi = br / 6 * $i;
                mh(E, ie).forEach((Vo) => {
                  const Un = qi * Vo.ndx, el = S.subarray(Un, Un + qi);
                  E.texImage2D(Vo.face, Nt, Pn, De, ht, 0, Vr, mi, el);
                });
              } else
                pe === be || pe === ze ? E.texImage3D(pe, Nt, Pn, De, ht, rt, 0, Vr, mi, S) : E.texImage2D(pe, Nt, Pn, De, ht, 0, Vr, mi, S);
              return {
                width: De,
                height: ht,
                depth: rt,
                type: mi
              };
            }
            function G0(E, R, S) {
              const ie = S.target || dt;
              E.bindTexture(ie, R);
              const pe = S.level || 0, De = S.internalFormat || S.format || _a, ht = i0(De), rt = S.format || ht.format, Nt = S.type || ht.type;
              if (Ru(E, S), ie === $t)
                for (let Pn = 0; Pn < 6; ++Pn)
                  E.texImage2D(P + Pn, pe, De, S.width, S.height, 0, rt, Nt, null);
              else
                ie === be || ie === ze ? E.texImage3D(ie, pe, De, S.width, S.height, S.depth, 0, rt, Nt, null) : E.texImage2D(ie, pe, De, S.width, S.height, 0, rt, Nt, null);
            }
            function s0(E, R, S) {
              S = S || a0, R = R || sl.textureOptions;
              const ie = E.createTexture(), pe = R.target || dt;
              let De = R.width || 1, ht = R.height || 1;
              const rt = R.internalFormat || _a;
              E.bindTexture(pe, ie), pe === $t && (E.texParameteri(pe, tr, nt), E.texParameteri(pe, Vn, nt));
              let Nt = R.src;
              if (Nt)
                if (typeof Nt == "function" && (Nt = Nt(E, R)), typeof Nt == "string")
                  Zg(E, ie, R, S);
                else if (Ta(Nt) || Array.isArray(Nt) && (typeof Nt[0] == "number" || Array.isArray(Nt[0]) || Ta(Nt[0]))) {
                  const Pn = vA(E, ie, Nt, R);
                  De = Pn.width, ht = Pn.height;
                } else
                  Array.isArray(Nt) && (typeof Nt[0] == "string" || vh(Nt[0])) ? pe === $t ? bh(E, ie, R, S) : Sg(E, ie, R, S) : (mA(E, ie, Nt, R), De = Nt.width, ht = Nt.height);
              else
                G0(E, ie, R);
              return o0(R) && fh(E, ie, R, De, ht, rt), pA(E, ie, R), ie;
            }
            const Fh = Fc;
            function Qa(E) {
              return typeof document < "u" && document.getElementById ? document.getElementById(E) : null;
            }
            const yu = 33984, sd = 34962, bA = 34963, FA = 35713, RA = 35714, yA = 35632, Ws = 35633, l0 = 35981, Qs = 35718, Ms = 35721, QA = 35971, CA = 35382, T0 = 35396, UA = 35398, wu = 35392, Eg = 35395, c0 = 5126, Rh = 35664, yh = 35665, IA = 35666, X0 = 5124, Qh = 35667, Ch = 35668, BA = 35669, Uh = 35670, ZA = 35671, d0 = 35672, SA = 35673, Ih = 35674, Bh = 35675, EA = 35676, Vg = 35678, Wg = 35680, Ng = 35679, VA = 35682, k0 = 35685, w0 = 35686, Jg = 35687, D0 = 35688, Io = 35689, V = 35690, k = 36289, _ = 36292, ue = 36293, Me = 5125, lt = 36294, Ut = 36295, Dt = 36296, kn = 36298, _n = 36299, $r = 36300, Mi = 36303, ri = 36306, Dr = 36307, ro = 36308, as = 36311, io = 3553, uo = 34067, yr = 32879, bi = 35866, Ni = {};
            function es(E, R) {
              return Ni[R].bindPoint;
            }
            function Qc(E, R) {
              return function(S) {
                E.uniform1f(R, S);
              };
            }
            function qs(E, R) {
              return function(S) {
                E.uniform1fv(R, S);
              };
            }
            function G2(E, R) {
              return function(S) {
                E.uniform2fv(R, S);
              };
            }
            function T2(E, R) {
              return function(S) {
                E.uniform3fv(R, S);
              };
            }
            function X2(E, R) {
              return function(S) {
                E.uniform4fv(R, S);
              };
            }
            function um(E, R) {
              return function(S) {
                E.uniform1i(R, S);
              };
            }
            function hm(E, R) {
              return function(S) {
                E.uniform1iv(R, S);
              };
            }
            function Am(E, R) {
              return function(S) {
                E.uniform2iv(R, S);
              };
            }
            function gm(E, R) {
              return function(S) {
                E.uniform3iv(R, S);
              };
            }
            function fm(E, R) {
              return function(S) {
                E.uniform4iv(R, S);
              };
            }
            function k2(E, R) {
              return function(S) {
                E.uniform1ui(R, S);
              };
            }
            function w2(E, R) {
              return function(S) {
                E.uniform1uiv(R, S);
              };
            }
            function D2(E, R) {
              return function(S) {
                E.uniform2uiv(R, S);
              };
            }
            function M2(E, R) {
              return function(S) {
                E.uniform3uiv(R, S);
              };
            }
            function Y2(E, R) {
              return function(S) {
                E.uniform4uiv(R, S);
              };
            }
            function L2(E, R) {
              return function(S) {
                E.uniformMatrix2fv(R, !1, S);
              };
            }
            function x2(E, R) {
              return function(S) {
                E.uniformMatrix3fv(R, !1, S);
              };
            }
            function H2(E, R) {
              return function(S) {
                E.uniformMatrix4fv(R, !1, S);
              };
            }
            function P2(E, R) {
              return function(S) {
                E.uniformMatrix2x3fv(R, !1, S);
              };
            }
            function O2(E, R) {
              return function(S) {
                E.uniformMatrix3x2fv(R, !1, S);
              };
            }
            function K2(E, R) {
              return function(S) {
                E.uniformMatrix2x4fv(R, !1, S);
              };
            }
            function z2(E, R) {
              return function(S) {
                E.uniformMatrix4x2fv(R, !1, S);
              };
            }
            function j2(E, R) {
              return function(S) {
                E.uniformMatrix3x4fv(R, !1, S);
              };
            }
            function _2(E, R) {
              return function(S) {
                E.uniformMatrix4x3fv(R, !1, S);
              };
            }
            function Pc(E, R, S, ie) {
              const pe = es(E, R);
              return qr(E) ? function(De) {
                let ht, rt;
                !De || Mc(E, De) ? (ht = De, rt = null) : (ht = De.texture, rt = De.sampler), E.uniform1i(ie, S), E.activeTexture(yu + S), E.bindTexture(pe, ht), E.bindSampler(S, rt);
              } : function(De) {
                E.uniform1i(ie, S), E.activeTexture(yu + S), E.bindTexture(pe, De);
              };
            }
            function hc(E, R, S, ie, pe) {
              const De = es(E, R), ht = new Int32Array(pe);
              for (let rt = 0; rt < pe; ++rt)
                ht[rt] = S + rt;
              return qr(E) ? function(rt) {
                E.uniform1iv(ie, ht), rt.forEach(function(Nt, Pn) {
                  E.activeTexture(yu + ht[Pn]);
                  let cr, Vr;
                  !Nt || Mc(E, Nt) ? (cr = Nt, Vr = null) : (cr = Nt.texture, Vr = Nt.sampler), E.bindSampler(S, Vr), E.bindTexture(De, cr);
                });
              } : function(rt) {
                E.uniform1iv(ie, ht), rt.forEach(function(Nt, Pn) {
                  E.activeTexture(yu + ht[Pn]), E.bindTexture(De, Nt);
                });
              };
            }
            Ni[c0] = { Type: Float32Array, size: 4, setter: Qc, arraySetter: qs }, Ni[Rh] = { Type: Float32Array, size: 8, setter: G2, cols: 2 }, Ni[yh] = { Type: Float32Array, size: 12, setter: T2, cols: 3 }, Ni[IA] = { Type: Float32Array, size: 16, setter: X2, cols: 4 }, Ni[X0] = { Type: Int32Array, size: 4, setter: um, arraySetter: hm }, Ni[Qh] = { Type: Int32Array, size: 8, setter: Am, cols: 2 }, Ni[Ch] = { Type: Int32Array, size: 12, setter: gm, cols: 3 }, Ni[BA] = { Type: Int32Array, size: 16, setter: fm, cols: 4 }, Ni[Me] = { Type: Uint32Array, size: 4, setter: k2, arraySetter: w2 }, Ni[lt] = { Type: Uint32Array, size: 8, setter: D2, cols: 2 }, Ni[Ut] = { Type: Uint32Array, size: 12, setter: M2, cols: 3 }, Ni[Dt] = { Type: Uint32Array, size: 16, setter: Y2, cols: 4 }, Ni[Uh] = { Type: Uint32Array, size: 4, setter: um, arraySetter: hm }, Ni[ZA] = { Type: Uint32Array, size: 8, setter: Am, cols: 2 }, Ni[d0] = { Type: Uint32Array, size: 12, setter: gm, cols: 3 }, Ni[SA] = { Type: Uint32Array, size: 16, setter: fm, cols: 4 }, Ni[Ih] = { Type: Float32Array, size: 32, setter: L2, rows: 2, cols: 2 }, Ni[Bh] = { Type: Float32Array, size: 48, setter: x2, rows: 3, cols: 3 }, Ni[EA] = { Type: Float32Array, size: 64, setter: H2, rows: 4, cols: 4 }, Ni[k0] = { Type: Float32Array, size: 32, setter: P2, rows: 2, cols: 3 }, Ni[w0] = { Type: Float32Array, size: 32, setter: K2, rows: 2, cols: 4 }, Ni[Jg] = { Type: Float32Array, size: 48, setter: O2, rows: 3, cols: 2 }, Ni[D0] = { Type: Float32Array, size: 48, setter: j2, rows: 3, cols: 4 }, Ni[Io] = { Type: Float32Array, size: 64, setter: z2, rows: 4, cols: 2 }, Ni[V] = { Type: Float32Array, size: 64, setter: _2, rows: 4, cols: 3 }, Ni[Vg] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: io }, Ni[Wg] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: uo }, Ni[Ng] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: yr }, Ni[VA] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: io }, Ni[k] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: bi }, Ni[_] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: bi }, Ni[ue] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: uo }, Ni[kn] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: io }, Ni[_n] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: yr }, Ni[$r] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: uo }, Ni[Mi] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: bi }, Ni[ri] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: io }, Ni[Dr] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: yr }, Ni[ro] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: uo }, Ni[as] = { Type: null, size: 0, setter: Pc, arraySetter: hc, bindPoint: bi };
            function Zh(E, R) {
              return function(S) {
                if (S.value)
                  switch (E.disableVertexAttribArray(R), S.value.length) {
                    case 4:
                      E.vertexAttrib4fv(R, S.value);
                      break;
                    case 3:
                      E.vertexAttrib3fv(R, S.value);
                      break;
                    case 2:
                      E.vertexAttrib2fv(R, S.value);
                      break;
                    case 1:
                      E.vertexAttrib1fv(R, S.value);
                      break;
                    default:
                      throw new Error("the length of a float constant value must be between 1 and 4!");
                  }
                else
                  E.bindBuffer(sd, S.buffer), E.enableVertexAttribArray(R), E.vertexAttribPointer(
                    R,
                    S.numComponents || S.size,
                    S.type || c0,
                    S.normalize || !1,
                    S.stride || 0,
                    S.offset || 0
                  ), E.vertexAttribDivisor && E.vertexAttribDivisor(R, S.divisor || 0);
              };
            }
            function I(E, R) {
              return function(S) {
                if (S.value)
                  if (E.disableVertexAttribArray(R), S.value.length === 4)
                    E.vertexAttrib4iv(R, S.value);
                  else
                    throw new Error("The length of an integer constant value must be 4!");
                else
                  E.bindBuffer(sd, S.buffer), E.enableVertexAttribArray(R), E.vertexAttribIPointer(
                    R,
                    S.numComponents || S.size,
                    S.type || X0,
                    S.stride || 0,
                    S.offset || 0
                  ), E.vertexAttribDivisor && E.vertexAttribDivisor(R, S.divisor || 0);
              };
            }
            function T(E, R) {
              return function(S) {
                if (S.value)
                  if (E.disableVertexAttribArray(R), S.value.length === 4)
                    E.vertexAttrib4uiv(R, S.value);
                  else
                    throw new Error("The length of an unsigned integer constant value must be 4!");
                else
                  E.bindBuffer(sd, S.buffer), E.enableVertexAttribArray(R), E.vertexAttribIPointer(
                    R,
                    S.numComponents || S.size,
                    S.type || Me,
                    S.stride || 0,
                    S.offset || 0
                  ), E.vertexAttribDivisor && E.vertexAttribDivisor(R, S.divisor || 0);
              };
            }
            function z(E, R, S) {
              const ie = S.size, pe = S.count;
              return function(De) {
                E.bindBuffer(sd, De.buffer);
                const ht = De.size || De.numComponents || ie, rt = ht / pe, Nt = De.type || c0, Pn = Ni[Nt].size * ht, cr = De.normalize || !1, Vr = De.offset || 0, mi = Pn / pe;
                for (let Fi = 0; Fi < pe; ++Fi)
                  E.enableVertexAttribArray(R + Fi), E.vertexAttribPointer(
                    R + Fi,
                    rt,
                    Nt,
                    cr,
                    Pn,
                    Vr + mi * Fi
                  ), E.vertexAttribDivisor && E.vertexAttribDivisor(R + Fi, De.divisor || 0);
              };
            }
            const ae = {};
            ae[c0] = { size: 4, setter: Zh }, ae[Rh] = { size: 8, setter: Zh }, ae[yh] = { size: 12, setter: Zh }, ae[IA] = { size: 16, setter: Zh }, ae[X0] = { size: 4, setter: I }, ae[Qh] = { size: 8, setter: I }, ae[Ch] = { size: 12, setter: I }, ae[BA] = { size: 16, setter: I }, ae[Me] = { size: 4, setter: T }, ae[lt] = { size: 8, setter: T }, ae[Ut] = { size: 12, setter: T }, ae[Dt] = { size: 16, setter: T }, ae[Uh] = { size: 4, setter: I }, ae[ZA] = { size: 8, setter: I }, ae[d0] = { size: 12, setter: I }, ae[SA] = { size: 16, setter: I }, ae[Ih] = { size: 4, setter: z, count: 2 }, ae[Bh] = { size: 9, setter: z, count: 3 }, ae[EA] = { size: 16, setter: z, count: 4 };
            const Ve = /ERROR:\s*\d+:(\d+)/gi;
            function qe(E, R = "", S = 0) {
              const ie = [...R.matchAll(Ve)], pe = new Map(ie.map((De, ht) => {
                const rt = parseInt(De[1]), Nt = ie[ht + 1], Pn = Nt ? Nt.index : R.length, cr = R.substring(De.index, Pn);
                return [rt - 1, cr];
              }));
              return E.split(`
`).map((De, ht) => {
                const rt = pe.get(ht);
                return `${ht + 1 + S}: ${De}${rt ? `

^^^ ${rt}` : ""}`;
              }).join(`
`);
            }
            const gt = /^[ \t]*\n/;
            function Wt(E) {
              let R = 0;
              return gt.test(E) && (R = 1, E = E.replace(gt, "")), { lineOffset: R, shaderSource: E };
            }
            function Rn(E, R) {
              return E.errorCallback(R), E.callback && setTimeout(() => {
                E.callback(`${R}
${E.errors.join(`
`)}`);
              }), null;
            }
            function Ln(E, R, S, ie) {
              if (ie = ie || Fh, !E.getShaderParameter(S, FA)) {
                const pe = E.getShaderInfoLog(S), { lineOffset: De, shaderSource: ht } = Wt(E.getShaderSource(S)), rt = `${qe(ht, pe, De)}
Error compiling ${dc(E, R)}: ${pe}`;
                return ie(rt), rt;
              }
              return "";
            }
            function Lr(E, R, S) {
              let ie, pe, De;
              if (typeof E == "function")
                S = E, E = void 0;
              else if (E && !Array.isArray(E)) {
                const Pn = E;
                S = Pn.errorCallback, E = Pn.attribLocations, ie = Pn.transformFeedbackVaryings, pe = Pn.transformFeedbackMode, De = Pn.callback;
              }
              const ht = S || Fh, rt = [], Nt = {
                errorCallback(Pn, ...cr) {
                  rt.push(Pn), ht(Pn, ...cr);
                },
                transformFeedbackVaryings: ie,
                transformFeedbackMode: pe,
                callback: De,
                errors: rt
              };
              {
                let Pn = {};
                Array.isArray(E) ? E.forEach(function(cr, Vr) {
                  Pn[cr] = Vr;
                }) : Pn = E || {}, Nt.attribLocations = Pn;
              }
              return Nt;
            }
            const Oi = [
              "VERTEX_SHADER",
              "FRAGMENT_SHADER"
            ];
            function ii(E, R) {
              if (R.indexOf("frag") >= 0)
                return yA;
              if (R.indexOf("vert") >= 0)
                return Ws;
            }
            function gi(E, R, S) {
              const ie = E.getAttachedShaders(R);
              for (const pe of ie)
                S.has(pe) && E.deleteShader(pe);
              E.deleteProgram(R);
            }
            const Bo = (E = 0) => new n((R) => setTimeout(R, E));
            function Cs(E, R, S) {
              const ie = E.createProgram(), {
                attribLocations: pe,
                transformFeedbackVaryings: De,
                transformFeedbackMode: ht
              } = Lr(S);
              for (let rt = 0; rt < R.length; ++rt) {
                let Nt = R[rt];
                if (typeof Nt == "string") {
                  const Pn = Qa(Nt), cr = Pn ? Pn.text : Nt;
                  let Vr = E[Oi[rt]];
                  Pn && Pn.type && (Vr = ii(E, Pn.type) || Vr), Nt = E.createShader(Vr), E.shaderSource(Nt, Wt(cr).shaderSource), E.compileShader(Nt), E.attachShader(ie, Nt);
                }
              }
              Object.entries(pe).forEach(([rt, Nt]) => E.bindAttribLocation(ie, Nt, rt));
              {
                let rt = De;
                rt && (rt.attribs && (rt = rt.attribs), Array.isArray(rt) || (rt = Object.keys(rt)), E.transformFeedbackVaryings(ie, rt, ht || l0));
              }
              return E.linkProgram(ie), ie;
            }
            function Ns(E, R, S, ie, pe) {
              const De = Lr(S, ie, pe), ht = new Set(R), rt = Cs(E, R, De);
              function Nt(Pn, cr) {
                const Vr = Er(Pn, cr, De.errorCallback);
                return Vr && gi(Pn, cr, ht), Vr;
              }
              if (De.callback) {
                cl(E, rt).then(() => {
                  const Pn = Nt(E, rt);
                  De.callback(Pn, Pn ? void 0 : rt);
                });
                return;
              }
              return Nt(E, rt) ? void 0 : rt;
            }
            async function cl(E, R) {
              const S = E.getExtension("KHR_parallel_shader_compile"), ie = S ? (De, ht) => De.getProgramParameter(ht, S.COMPLETION_STATUS_KHR) : () => !0;
              let pe = 0;
              do
                await Bo(pe), pe = 1e3 / 60;
              while (!ie(E, R));
            }
            function Er(E, R, S) {
              if (S = S || Fh, !E.getProgramParameter(R, RA)) {
                const ie = E.getProgramInfoLog(R);
                S(`Error in program linking: ${ie}`);
                const pe = E.getAttachedShaders(R).map((De) => Ln(E, E.getShaderParameter(De, E.SHADER_TYPE), De, S));
                return `${ie}
${pe.filter((De) => De).join(`
`)}`;
              }
            }
            function Si(E, R, S, ie, pe) {
              return Ns(E, R, S, ie, pe);
            }
            function Vl(E) {
              const R = E.name;
              return R.startsWith("gl_") || R.startsWith("webgl_");
            }
            const Us = /(\.|\[|]|\w+)/g, ld = (E) => E >= "0" && E <= "9";
            function Ul(E, R, S, ie) {
              const pe = E.split(Us).filter((rt) => rt !== "");
              let De = 0, ht = "";
              for (; ; ) {
                const rt = pe[De++];
                ht += rt;
                const Nt = ld(rt[0]), Pn = Nt ? parseInt(rt) : rt;
                if (Nt && (ht += pe[De++]), De === pe.length) {
                  S[Pn] = R;
                  break;
                } else {
                  const cr = pe[De++], Vr = cr === "[", mi = S[Pn] || (Vr ? [] : {});
                  S[Pn] = mi, S = mi, ie[ht] = ie[ht] || /* @__PURE__ */ function(Fi) {
                    return function(br) {
                      EF(Fi, br);
                    };
                  }(mi), ht += cr;
                }
              }
            }
            function _Z(E, R) {
              let S = 0;
              function ie(rt, Nt, Pn) {
                const cr = Nt.name.endsWith("[0]"), Vr = Nt.type, mi = Ni[Vr];
                if (!mi)
                  throw new Error(`unknown type: 0x${Vr.toString(16)}`);
                let Fi;
                if (mi.bindPoint) {
                  const br = S;
                  S += Nt.size, cr ? Fi = mi.arraySetter(E, Vr, br, Pn, Nt.size) : Fi = mi.setter(E, Vr, br, Pn, Nt.size);
                } else
                  mi.arraySetter && cr ? Fi = mi.arraySetter(E, Pn) : Fi = mi.setter(E, Pn);
                return Fi.location = Pn, Fi;
              }
              const pe = {}, De = {}, ht = E.getProgramParameter(R, Qs);
              for (let rt = 0; rt < ht; ++rt) {
                const Nt = E.getActiveUniform(R, rt);
                if (Vl(Nt))
                  continue;
                let Pn = Nt.name;
                Pn.endsWith("[0]") && (Pn = Pn.substr(0, Pn.length - 3));
                const cr = E.getUniformLocation(R, Nt.name);
                if (cr) {
                  const Vr = ie(R, Nt, cr);
                  pe[Pn] = Vr, Ul(Pn, Vr, De, pe);
                }
              }
              return pe;
            }
            function $Z(E, R) {
              const S = {}, ie = E.getProgramParameter(R, QA);
              for (let pe = 0; pe < ie; ++pe) {
                const De = E.getTransformFeedbackVarying(R, pe);
                S[De.name] = {
                  index: pe,
                  type: De.type,
                  size: De.size
                };
              }
              return S;
            }
            function qZ(E, R) {
              const S = E.getProgramParameter(R, Qs), ie = [], pe = [];
              for (let rt = 0; rt < S; ++rt) {
                pe.push(rt), ie.push({});
                const Nt = E.getActiveUniform(R, rt);
                ie[rt].name = Nt.name;
              }
              [
                ["UNIFORM_TYPE", "type"],
                ["UNIFORM_SIZE", "size"],
                ["UNIFORM_BLOCK_INDEX", "blockNdx"],
                ["UNIFORM_OFFSET", "offset"]
              ].forEach(function(rt) {
                const Nt = rt[0], Pn = rt[1];
                E.getActiveUniforms(R, pe, E[Nt]).forEach(function(cr, Vr) {
                  ie[Vr][Pn] = cr;
                });
              });
              const De = {}, ht = E.getProgramParameter(R, CA);
              for (let rt = 0; rt < ht; ++rt) {
                const Nt = E.getActiveUniformBlockName(R, rt), Pn = {
                  index: E.getUniformBlockIndex(R, Nt),
                  usedByVertexShader: E.getActiveUniformBlockParameter(R, rt, T0),
                  usedByFragmentShader: E.getActiveUniformBlockParameter(R, rt, UA),
                  size: E.getActiveUniformBlockParameter(R, rt, wu),
                  uniformIndices: E.getActiveUniformBlockParameter(R, rt, Eg)
                };
                Pn.used = Pn.usedByVertexShader || Pn.usedByFragmentShader, De[Nt] = Pn;
              }
              return {
                blockSpecs: De,
                uniformData: ie
              };
            }
            function EF(E, R) {
              for (const S in R) {
                const ie = E[S];
                typeof ie == "function" ? ie(R[S]) : EF(E[S], R[S]);
              }
            }
            function VF(E, ...R) {
              const S = E.uniformSetters || E, ie = R.length;
              for (let pe = 0; pe < ie; ++pe) {
                const De = R[pe];
                if (Array.isArray(De)) {
                  const ht = De.length;
                  for (let rt = 0; rt < ht; ++rt)
                    VF(S, De[rt]);
                } else
                  for (const ht in De) {
                    const rt = S[ht];
                    rt && rt(De[ht]);
                  }
              }
            }
            function eS(E, R) {
              const S = {}, ie = E.getProgramParameter(R, Ms);
              for (let pe = 0; pe < ie; ++pe) {
                const De = E.getActiveAttrib(R, pe);
                if (Vl(De))
                  continue;
                const ht = E.getAttribLocation(R, De.name), rt = ae[De.type], Nt = rt.setter(E, ht, rt);
                Nt.location = ht, S[De.name] = Nt;
              }
              return S;
            }
            function tS(E, R) {
              for (const S in R) {
                const ie = E[S];
                ie && ie(R[S]);
              }
            }
            function nS(E, R, S) {
              S.vertexArrayObject ? E.bindVertexArray(S.vertexArrayObject) : (tS(R.attribSetters || R, S.attribs), S.indices && E.bindBuffer(bA, S.indices));
            }
            function WF(E, R) {
              const S = _Z(E, R), ie = eS(E, R), pe = {
                program: R,
                uniformSetters: S,
                attribSetters: ie
              };
              return qr(E) && (pe.uniformBlockSpec = qZ(E, R), pe.transformFeedbackInfo = $Z(E, R)), pe;
            }
            const rS = /\s|{|}|;/;
            function iS(E, R, S, ie, pe) {
              const De = Lr(S, ie, pe), ht = [];
              if (R = R.map(function(Pn) {
                if (!rS.test(Pn)) {
                  const cr = Qa(Pn);
                  if (cr)
                    Pn = cr.text;
                  else {
                    const Vr = `no element with id: ${Pn}`;
                    De.errorCallback(Vr), ht.push(Vr);
                  }
                }
                return Pn;
              }), ht.length)
                return Rn(De, "");
              const rt = De.callback;
              rt && (De.callback = (Pn, cr) => {
                rt(Pn, Pn ? void 0 : WF(E, cr));
              });
              const Nt = Si(E, R, De);
              return Nt ? WF(E, Nt) : null;
            }
            const oS = 4, aS = 5123;
            function sS(E, R, S, ie, pe, De) {
              S = S === void 0 ? oS : S;
              const ht = R.indices, rt = R.elementType, Nt = R.numElements;
              pe = pe === void 0 ? 0 : pe, rt || ht ? E.drawElements(S, Nt, rt === void 0 ? aS : R.elementType, pe) : E.drawArrays(S, pe, Nt);
            }
            const NF = 36160, pm = 36161, lS = 3553, cS = 5121, dS = 6402, uS = 6408, hS = 33190, AS = 36012, gS = 35056, fS = 36013, pS = 32854, mS = 32855, vS = 36194, JF = 33189, GF = 6401, TF = 36168, $2 = 34041, q2 = 36064, mm = 36096, XF = 36128, ev = 33306, tv = 33071, nv = 9729, bS = [
              { format: uS, type: cS, min: nv, wrap: tv },
              { format: $2 }
            ], Qu = {};
            Qu[$2] = ev, Qu[GF] = XF, Qu[TF] = XF, Qu[dS] = mm, Qu[JF] = mm, Qu[hS] = mm, Qu[AS] = mm, Qu[gS] = ev, Qu[fS] = ev;
            function FS(E, R) {
              return Qu[E] || Qu[R];
            }
            const M0 = {};
            M0[pS] = !0, M0[mS] = !0, M0[vS] = !0, M0[$2] = !0, M0[JF] = !0, M0[GF] = !0, M0[TF] = !0;
            function RS(E) {
              return M0[E];
            }
            const yS = 32;
            function QS(E) {
              return E >= q2 && E < q2 + yS;
            }
            function vm(E, R, S, ie) {
              const pe = NF, De = E.createFramebuffer();
              E.bindFramebuffer(pe, De), S = S || E.drawingBufferWidth, ie = ie || E.drawingBufferHeight, R = R || bS;
              const ht = [], rt = {
                framebuffer: De,
                attachments: [],
                width: S,
                height: ie
              };
              return R.forEach(function(Nt, Pn) {
                let cr = Nt.attachment;
                const Vr = Nt.samples, mi = Nt.format;
                let Fi = Nt.attachmentPoint || FS(mi, Nt.internalFormat);
                if (Fi || (Fi = q2 + Pn), QS(Fi) && ht.push(Fi), !cr)
                  if (Vr !== void 0 || RS(mi))
                    cr = E.createRenderbuffer(), E.bindRenderbuffer(pm, cr), Vr > 1 ? E.renderbufferStorageMultisample(pm, Vr, mi, S, ie) : E.renderbufferStorage(pm, mi, S, ie);
                  else {
                    const br = Object.assign({}, Nt);
                    br.width = S, br.height = ie, br.auto === void 0 && (br.auto = !1, br.min = br.min || br.minMag || nv, br.mag = br.mag || br.minMag || nv, br.wrapS = br.wrapS || br.wrap || tv, br.wrapT = br.wrapT || br.wrap || tv), cr = s0(E, br);
                  }
                if (ja(E, cr))
                  E.framebufferRenderbuffer(pe, Fi, pm, cr);
                else if (Mc(E, cr))
                  Nt.layer !== void 0 ? E.framebufferTextureLayer(
                    pe,
                    Fi,
                    cr,
                    Nt.level || 0,
                    Nt.layer
                  ) : E.framebufferTexture2D(
                    pe,
                    Fi,
                    Nt.target || lS,
                    cr,
                    Nt.level || 0
                  );
                else
                  throw new Error("unknown attachment type");
                rt.attachments.push(cr);
              }), E.drawBuffers && E.drawBuffers(ht), rt;
            }
            function CS(E, R, S) {
              S = S || NF, R ? (E.bindFramebuffer(S, R.framebuffer), E.viewport(0, 0, R.width, R.height)) : (E.bindFramebuffer(S, null), E.viewport(0, 0, E.drawingBufferWidth, E.drawingBufferHeight));
            }
            function pl(E, R) {
              return () => R instanceof WebGLTexture ? R : s0(E, {
                src: R,
                wrap: E.CLAMP_TO_EDGE
              });
            }
            const WA = 2;
            class Sh {
              constructor(R) {
                c(this, "id", "_"), c(this, "context"), c(this, "output"), c(this, "fbi"), c(this, "options"), c(this, "programInfo"), c(this, "bufferInfo"), c(this, "profiler"), c(this, "lastRun");
                const { context: S, width: ie, height: pe } = R;
                this.context = S, this.options = R;
                const De = this.buildDefines();
                this.programInfo = iS(this.context, [
                  De + this.getVertexShader(),
                  De + this.getFragmentShader()
                ]), this.bufferInfo = Ne(
                  this.context,
                  this.getBuffers()
                ), this.fbi = vm(
                  this.context,
                  [
                    {
                      format: this.context.RGBA,
                      type: this.context.UNSIGNED_BYTE,
                      min: this.context.LINEAR,
                      wrap: this.context.CLAMP_TO_EDGE
                    }
                  ],
                  ie,
                  pe
                ), this.output = this.fbi.attachments[0];
              }
              resizeOutput(R, S) {
                this.fbi = vm(
                  this.context,
                  [
                    {
                      format: this.context.RGBA,
                      type: this.context.UNSIGNED_BYTE,
                      min: this.context.LINEAR,
                      wrap: this.context.CLAMP_TO_EDGE
                    }
                  ],
                  R,
                  S
                ), this.options.width = R, this.options.height = S, this.output = this.fbi.attachments[0];
              }
              getDefines() {
                return {};
              }
              getBuffers() {
                return {
                  position: {
                    numComponents: 2,
                    data: [-1, -1, -1, 1, 1, -1, 1, 1, -1, 1, 1, -1]
                  },
                  texture_coord: {
                    numComponents: 2,
                    data: [0, 0, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0]
                  }
                };
              }
              buildDefines() {
                let R = "";
                const S = this.getDefines();
                for (let ie in S)
                  R += `#define ${ie} ${S[ie].toFixed(1)}
`;
                return R;
              }
              run(R) {
                var S, ie, pe, De, ht, rt;
                (S = this.profiler) == null || S.pushContext(
                  `[${this.id}] PROG : ${this.constructor.name}`
                ), (ie = this.profiler) == null || ie.pushContext(`[${this.id}] UNIFORMS`);
                for (const cr in R)
                  typeof R[cr] == "function" && ((pe = this.profiler) == null || pe.pushContext(`[${this.id}] UNI : ${cr}`), R[cr] = R[cr](), (De = this.profiler) == null || De.popContext(`[${this.id}] UNI : ${cr}`));
                (ht = this.profiler) == null || ht.popContext(`[${this.id}] UNIFORMS`);
                const Nt = Date.now();
                let Pn = 0;
                this.lastRun && (Pn = (Nt - this.lastRun) / 1e3), this.lastRun = Nt, this.context.viewport(
                  0,
                  0,
                  this.context.canvas.width,
                  this.context.canvas.height
                ), this.context.useProgram(this.programInfo.program), nS(
                  this.context,
                  this.programInfo,
                  this.bufferInfo
                ), VF(this.programInfo, {
                  delta: Pn,
                  canvas: [this.context.canvas.width, this.context.canvas.height],
                  ...R
                }), CS(
                  this.context,
                  this.options.disableFramebuffer ? null : this.fbi
                ), sS(this.context, this.bufferInfo), (rt = this.profiler) == null || rt.popContext(
                  `[${this.id}] PROG : ${this.constructor.name}`
                );
              }
              setProfiler(R) {
                this.profiler = R;
              }
            }
            const US = `precision mediump float;

varying vec2 _texture_coord;

uniform sampler2D background;
uniform sampler2D foreground;
uniform sampler2D threshold;

void main() {
  vec4 backgroundColor = texture2D(background, _texture_coord);
  vec4 foregroundColor = texture2D(foreground, _texture_coord);
  vec4 tresholdColor = texture2D(threshold, _texture_coord);
  gl_FragColor = foregroundColor * tresholdColor.a +
                 backgroundColor * (1. - tresholdColor.a);
}
`, IS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
  _texture_coord.y = 1. - texture_coord.y;
}
`;
            class rv extends Sh {
              getFragmentShader() {
                return US;
              }
              getVertexShader() {
                return IS;
              }
            }
            class iv {
              constructor() {
                c(this, "steps", []), c(this, "profiler");
              }
              addStep(R) {
                this.steps.push(R);
              }
              async run() {
                for (const R of this.steps)
                  R.program.run(R.getUniforms());
              }
              resizeOutput(R, S) {
                var ie, pe;
                (ie = this.profiler) == null || ie.pushContext(`PIP [${this.constructor.name}]`);
                for (const De of this.steps)
                  De.preventResize || De.program.resizeOutput(R, S);
                (pe = this.profiler) == null || pe.popContext(`PIP [${this.constructor.name}]`);
              }
              setProfiler(R) {
                this.profiler = R;
                for (const S of this.steps)
                  S.program.setProfiler(R);
              }
              setId(R) {
                for (const S of this.steps)
                  S.program.id = R;
              }
            }
            class ov extends iv {
              constructor() {
                super(...arguments), c(this, "preciseMaskEnabled", !1);
              }
            }
            class kF extends ov {
              constructor(R) {
                super(), c(this, "inputImage"), c(this, "inputBackgroundImage"), c(this, "inputMask"), c(this, "preciseMaskEnabled", !0), this.context = R;
                const S = {
                  context: R,
                  height: R.canvas.height,
                  width: R.canvas.width
                }, ie = new rv({ ...S, disableFramebuffer: !0 });
                this.addStep({
                  program: ie,
                  getUniforms: () => ({
                    background: pl(R, this.inputBackgroundImage),
                    foreground: pl(R, this.inputImage),
                    threshold: pl(R, this.inputMask)
                  })
                });
              }
              setData(R, S) {
                this.inputImage = R, this.inputMask = S;
              }
            }
            const BS = `precision mediump float;

varying vec2 _texture_coord;
uniform sampler2D texture;

void main() { gl_FragColor = texture2D(texture, _texture_coord); }
`, ZS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;
uniform bool invert_y;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
  if (invert_y) {
    _texture_coord.y = 1. - texture_coord.y;
  }
}
`;
            class SS extends Sh {
              getFragmentShader() {
                return BS;
              }
              getVertexShader() {
                return ZS;
              }
            }
            class ES extends iv {
              constructor(R, S, ie) {
                super(), c(this, "inputImage"), this.context = R;
                const pe = {
                  context: R,
                  height: ie,
                  width: S
                };
                this.addStep({
                  program: new SS({
                    ...pe,
                    disableFramebuffer: !0
                  }),
                  getUniforms: () => ({
                    texture: pl(R, this.inputImage),
                    invert_y: !0
                  })
                });
              }
              setData(R) {
                this.inputImage = R;
              }
            }
            async function wF(E) {
              return new n((R) => {
                setTimeout(() => {
                  R();
                }, E);
              });
            }
            const VS = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

vec4 loop();

void main() { gl_FragColor = loop(); }
`, WS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
            var av = /* @__PURE__ */ ((E) => (E[E.LINEAR = 0] = "LINEAR", E[E.GAUSSIAN = 1] = "GAUSSIAN", E))(av || {});
            class DF extends Sh {
              getDefines() {
                var R;
                return { RADIUS: (R = this.options.radius) != null ? R : 1 };
              }
              getFragmentShader() {
                return VS + this.createLoopFunction();
              }
              getVertexShader() {
                return WS;
              }
              createLoopFunction() {
                var R;
                let S = (R = this.options.radius) != null ? R : 1;
                return `

        vec4 loop() { 
            vec4 result = vec4(0,0,0,0);
            float factorSum = 0.;

            vec2 normalizedRadius = vec2(-${S}.) / canvas;
            vec2 normalizedIncrement = vec2(1.) / canvas;
            vec2 diff = normalizedRadius;

            for(int y=-${S}; y<${S + 1}; ++y) {
                for(int x=-${S}; x<${S + 1}; ++x) {
                    float factor = 1.;
                    result += factor * texture2D(texture, _texture_coord + diff);
                    factorSum += factor;
                    diff.x += normalizedIncrement.x;
                }
                diff.y += normalizedIncrement.y;
                diff.x = normalizedRadius.x;
            }
            return result / factorSum;
        }`;
              }
              getFactor(R, S) {
                switch (this.options.type) {
                  case 1:
                    return this.getLinearFactor(R, S);
                  case 0:
                  default:
                    return this.getLinearFactor(R, S);
                }
              }
              getLinearFactor(R, S) {
                return 1;
              }
              getGaussianFactor(R, S) {
                var ie;
                const pe = Math.PI * 2, De = Math.max((ie = this.options.radius) != null ? ie : 1, 1), ht = 1 / (pe * De ** 2), rt = -(R ** 2 + S ** 2), Nt = ht * rt;
                return ht * Math.E ** Nt;
              }
            }
            class sv extends Sh {
              constructor(R) {
                super(R), c(this, "fbi2"), this.fbi2 = vm(
                  R.context,
                  [
                    {
                      format: R.context.RGBA,
                      type: R.context.UNSIGNED_BYTE,
                      min: R.context.LINEAR,
                      mag: R.context.LINEAR,
                      wrap: R.context.CLAMP_TO_EDGE
                    }
                  ],
                  R.width,
                  R.height
                );
              }
              run(R) {
                const S = this.fbi;
                this.fbi = this.fbi2, this.fbi2 = S, this.output = this.fbi.attachments[0], super.run({
                  ...R,
                  previous_rendering: this.fbi2.attachments[0]
                });
              }
              resizeOutput(R, S) {
                super.resizeOutput(R, S), this.fbi2 = vm(
                  this.context,
                  [
                    {
                      format: this.context.RGBA,
                      type: this.context.UNSIGNED_BYTE,
                      min: this.context.LINEAR,
                      wrap: this.context.CLAMP_TO_EDGE
                    }
                  ],
                  R,
                  S
                );
              }
            }
            const NS = `precision mediump float;

varying vec2 _texture_coord;

// uniform float treshold;
uniform sampler2D image_now;
uniform sampler2D image_before;
uniform sampler2D mask_now;
uniform sampler2D mask_before;
uniform sampler2D previous_rendering;
uniform vec2 canvas;

uniform float delta;

float current_factor = 0.69;
float previous_factor = 0.74;
float threshold_activation = 0.54;

float map(float value, float min1, float max1, float min2, float max2) {
  return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

float getThreshold() {
  vec4 color = vec4(0.);
  for (float y = -6.; y < 7.; y += 1.) {
    for (float x = -6.; x < 7.; x += 1.) {
      vec4 image_now_color =
          texture2D(image_now, _texture_coord + vec2(x, y) / canvas);
      vec4 image_before_color =
          texture2D(image_before, _texture_coord + vec2(x, y) / canvas);
      color += abs(image_before_color - image_now_color);
    }
  }
  return (color.x + color.y + color.z) / (3. * 9.);
}

void main() {
  float treshold_input = .4;
  float treshold_previous_rendering = .98;

  vec4 mask_now_color = texture2D(mask_now, _texture_coord);
  vec4 mask_before_color = texture2D(mask_before, _texture_coord);
  vec4 previous_rendering_color = texture2D(previous_rendering, _texture_coord);

  vec3 mask_diff = abs(mask_before_color.xyz - mask_now_color.xyz);
  float flickering = mask_diff.x;
  float threshold = getThreshold();
  if (threshold < threshold_activation) {
    gl_FragColor = vec4(flickering, 0., 0., 1.) * current_factor +
                   previous_rendering_color * previous_factor;
    gl_FragColor *= (1. - threshold);
  }
}
`, JS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
            class GS extends sv {
              getFragmentShader() {
                return NS;
              }
              getVertexShader() {
                return JS;
              }
            }
            const TS = `#version 300 es
// https://github.com/Volcomix/virtual-background/blob/main/src/pipelines/webgl2/jointBilateralFilterStage.ts

precision highp float;
uniform sampler2D input_frame;
uniform sampler2D segmentation_mask;
uniform sampler2D threshold;
uniform vec2 texel_size;
uniform float step;
uniform float radius;
uniform float offset;
uniform float sigma_texel;
uniform float sigma_color;

in vec2 _texture_coord;
out vec4 outColor;

float gaussian(float x, float sigma) {
  float coeff = -0.5 / (sigma * sigma * 4.0 + 1.0e-6);
  return exp((x * x) * coeff);
}

void main() {
  vec2 centerCoord = _texture_coord;
  vec3 centerColor = texture(input_frame, centerCoord).rgb;
  float newVal = 0.0;
  float spaceWeight = 0.0;
  float colorWeight = 0.0;
  float totalWeight = 0.0;
  // Subsample kernel space.
  for (float i = -radius + offset; i <= radius; i += step) {
    for (float j = -radius + offset; j <= radius; j += step) {
      vec2 shift = vec2(j, i) * texel_size;
      vec2 coord = vec2(centerCoord + shift);
      vec3 frameColor = texture(input_frame, coord).rgb;
      float threshold = texture(threshold, coord).a;
      float outVal = texture(segmentation_mask, coord).a;

      spaceWeight = gaussian(distance(centerCoord, coord), sigma_texel);
      colorWeight = gaussian(distance(centerColor, frameColor), sigma_color);
      totalWeight += spaceWeight * colorWeight;
      newVal += spaceWeight * colorWeight * outVal * threshold;
    }
  }
  newVal /= totalWeight;
  outColor = vec4(vec3(0.), newVal);
}`, XS = `#version 300 es
in vec2 position;
in vec2 texture_coord;
out vec2 _texture_coord;
void main() {
  gl_Position = vec4(position, 0.0, 1.0);
  _texture_coord = texture_coord;
}`;
            class kS extends Sh {
              getFragmentShader() {
                return TS;
              }
              getVertexShader() {
                return XS;
              }
            }
            const wS = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

void main() {
  int count = 0;
  for (float y = -1.; y < 2.; y += 1.) {
    for (float x = -1.; x < 2.; x += 1.) {
      vec2 coord = _texture_coord + vec2(y, x) / canvas;
      vec4 color = texture2D(texture, coord);
      if (color.r > .1) {
        count++;
      }
    }
  }
  if (count > 5) {
    gl_FragColor = texture2D(texture, _texture_coord);
  }
}
`, DS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
            class MS extends Sh {
              getFragmentShader() {
                return wS;
              }
              getVertexShader() {
                return DS;
              }
            }
            const YS = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;

void main() {
  vec4 color = texture2D(texture, _texture_coord);
  for (float y = -2.; y < 3.; y += 1.) {
    for (float x = -2.; x < 3.; x += 1.) {
      vec2 coord = _texture_coord;
      coord += vec2(y, x) / canvas;
      color += texture2D(texture, coord) * (1. / 4.);
    }
  }

  gl_FragColor = color;
}
`, LS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
            class xS extends sv {
              getFragmentShader() {
                return YS;
              }
              getVertexShader() {
                return LS;
              }
            }
            const HS = `precision mediump float;

varying vec2 _texture_coord;

uniform sampler2D threshold;
uniform sampler2D inputs;

void main() {
  vec4 inputs_color = texture2D(inputs, _texture_coord);
  vec4 threshold_color = texture2D(threshold, _texture_coord);
  if (threshold_color.r < .1 && inputs_color.r > .5) {
    gl_FragColor = inputs_color;
  }
}
`, PS = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
            class OS extends sv {
              getFragmentShader() {
                return HS;
              }
              getVertexShader() {
                return PS;
              }
            }
            class KS extends iv {
              constructor(R, S, ie) {
                super(), c(this, "inputImage"), c(this, "inputMask"), c(this, "previousInputImage"), c(this, "previousInputMask"), c(this, "output"), c(this, "options", {
                  currentThresholdMinimum: 0,
                  currentThresholdMaximum: 1,
                  previousThresholdMinimum: 0,
                  previousThresholdMaximum: 1,
                  thresholdMinimum: 0,
                  thresholdMaximum: 1,
                  thresholdFactor: 1
                }), c(this, "jointBilateral"), this.context = R;
                const pe = {
                  context: R,
                  height: ie,
                  width: S
                }, De = new GS(pe), ht = new DF({
                  ...pe,
                  radius: 1,
                  type: av.GAUSSIAN
                }), rt = new OS(pe), Nt = new xS(pe), Pn = new MS(pe);
                this.jointBilateral = new kS(pe), this.addStep({
                  program: De,
                  getUniforms: () => ({
                    image_now: pl(R, this.inputImage),
                    image_before: pl(R, this.previousInputImage),
                    mask_now: pl(R, this.inputMask),
                    mask_before: pl(R, this.previousInputMask),
                    current_threshold_minimum: this.options.currentThresholdMinimum,
                    current_threshold_maximum: this.options.currentThresholdMaximum,
                    previous_threshold_minimum: this.options.previousThresholdMinimum,
                    previous_threshold_maximum: this.options.previousThresholdMaximum,
                    threshold_minimum: this.options.thresholdMinimum,
                    threshold_maximum: this.options.thresholdMaximum,
                    threshold_factor: this.options.thresholdFactor
                  })
                }), this.addStep({
                  program: rt,
                  getUniforms: () => ({
                    inputs: pl(R, this.inputMask),
                    threshold: pl(R, De.output)
                  })
                }), this.addStep({
                  program: Pn,
                  getUniforms: () => ({
                    texture: pl(R, rt.output)
                  })
                }), this.addStep({
                  program: Nt,
                  getUniforms: () => ({
                    texture: pl(R, Pn.output)
                  })
                }), this.addStep({
                  program: ht,
                  getUniforms: () => ({
                    texture: pl(R, Nt.output)
                  })
                }), this.addStep({
                  program: this.jointBilateral,
                  getUniforms: () => {
                    var cr, Vr, mi, Fi, br, Nr, $i, qi;
                    const Vo = (Vr = (cr = this.inputImage) == null ? void 0 : cr.width) != null ? Vr : 1, Un = (Fi = (mi = this.inputImage) == null ? void 0 : mi.height) != null ? Fi : 1, el = (Nr = (br = this.inputMask) == null ? void 0 : br.width) != null ? Nr : 1, Ys = (qi = ($i = this.inputMask) == null ? void 0 : $i.height) != null ? qi : 1, Ca = Math.max(
                      Vo / el,
                      Un / Ys
                    ), lo = Math.max(
                      1,
                      Math.sqrt(Ca) * 0.66
                    ), Cc = 1 / Vo, Go = 1 / Un;
                    return {
                      input_frame: pl(R, this.inputImage),
                      segmentation_mask: pl(R, this.inputMask),
                      threshold: pl(R, ht.output),
                      texel_size: [Cc, Go],
                      step: lo,
                      radius: Ca,
                      offset: lo > 1 ? lo * 0.5 : 0,
                      sigma_texel: Math.max(Cc, Go) * Ca,
                      sigma_color: 0.1
                    };
                  }
                }), this.output = this.jointBilateral.output;
              }
              setData(R, S) {
                this.previousInputImage = this.inputImage ? this.inputImage : R, this.previousInputMask = this.inputMask ? this.inputMask : S, this.inputImage = R, this.inputMask = S;
              }
              setOptions(R) {
                this.options = R;
              }
              resizeOutput(R, S) {
                super.resizeOutput(R, S), this.output = this.jointBilateral.output;
              }
            }
            var MF = /* @__PURE__ */ ((E) => (E.PUSH = "PUSH", E.POP = "POP", E))(MF || {});
            class zS {
              constructor(R) {
                c(this, "context"), c(this, "extension"), c(this, "queries", []), c(this, "activeQuery"), this.context = R, this.extension = R.getExtension(
                  "EXT_disjoint_timer_query_webgl2"
                );
              }
              start() {
              }
              stop() {
                this.activeQuery && this.context.endQuery(this.extension.TIME_ELAPSED_EXT);
              }
              pushContext(R) {
                this.createQuery("PUSH", R);
              }
              popContext(R) {
                this.createQuery("POP", R);
              }
              createQuery(R, S) {
                this.activeQuery && this.context.endQuery(this.extension.TIME_ELAPSED_EXT), this.activeQuery = this.context.createQuery(), this.context.beginQuery(
                  this.extension.TIME_ELAPSED_EXT,
                  this.activeQuery
                ), this.queries.push({
                  name: S,
                  action: R,
                  query: this.activeQuery
                });
              }
              async getResolvedQueries() {
                const R = (await n.all(
                  [...this.queries].map((S) => this.resolveQuery(S))
                )).filter((S) => S);
                for (let S = 1; S < R.length; ++S)
                  R[S].timestamp += R[S - 1].duration + R[S - 1].timestamp;
                return R;
              }
              async resolveQuery(R) {
                if (!await this.awaitQueryAvailable(R)) {
                  console.log("Unawaitable query", R);
                  return;
                }
                if (this.context.getParameter(
                  this.extension.GPU_DISJOINT_EXT
                )) {
                  console.log("Disjointed query", R);
                  return;
                }
                return {
                  ...R,
                  duration: this.context.getQueryParameter(
                    R.query,
                    this.context.QUERY_RESULT
                  ),
                  timestamp: 0
                };
              }
              async awaitQueryAvailable(R) {
                for (let S = 0; S < 10; ++S) {
                  if (this.context.getQueryParameter(
                    R.query,
                    this.context.QUERY_RESULT_AVAILABLE
                  ))
                    return R;
                  await wF(200);
                }
              }
            }
            class bm {
              constructor() {
                c(this, "canvas"), c(this, "context"), c(this, "pipeline"), c(this, "previousImageWidth", 0), c(this, "previousImageHeight", 0), c(this, "previousMaskWidth", WA), c(this, "previousMaskHeight", WA), c(this, "profiler"), c(this, "postProcessingEnabled", !0), c(this, "improveMask");
                const R = new OffscreenCanvas(0, 0), S = R.getContext("webgl2");
                if (!S)
                  throw "Fail to retrieve webgl2 context";
                this.canvas = R, this.context = S, this.improveMask = new KS(
                  this.context,
                  WA,
                  WA
                );
              }
              setFlickeringOptions(R) {
                this.improveMask.setOptions(R);
              }
              enablePostProcessing() {
                this.postProcessingEnabled = !0;
              }
              disablePostProcessing() {
                this.postProcessingEnabled = !1;
              }
              async profileWebgl(R) {
                const S = new zS(this.context);
                return this.profiler = S, S.start(), await wF(R), this.profiler = void 0, S.stop(), S.getResolvedQueries();
              }
              async render(R, S) {
                var ie, pe;
                if (!this.pipeline)
                  throw "missing pipeline";
                (this.previousImageHeight !== R.height || this.previousImageWidth !== R.width) && this.resizeOutput(R.width, R.height), (this.previousMaskHeight !== S.height || this.previousMaskWidth !== S.width) && (this.improveMask.resizeOutput(S.width, S.height), this.previousMaskWidth = S.width, this.previousMaskHeight = S.height);
                const De = "renderer";
                (ie = this.profiler) == null || ie.pushContext(De), this.improveMask.setProfiler(this.profiler), this.pipeline.setProfiler(this.profiler);
                let ht = S;
                return this.postProcessingEnabled && (this.improveMask.setData(R, S), this.improveMask.run(), ht = this.improveMask.output), this.pipeline.setData(R, ht), await this.pipeline.run(), (pe = this.profiler) == null || pe.popContext(De), this.canvas;
              }
              resizeOutput(R, S) {
                var ie;
                this.canvas.width = R, this.canvas.height = S, (ie = this.pipeline) == null || ie.resizeOutput(R, S), this.previousImageWidth = R, this.previousImageHeight = S;
              }
            }
            class YF extends bm {
              constructor() {
                super(), c(this, "pipeline"), c(this, "backgroundImage"), c(this, "backgroundImageResizerCanvas"), c(this, "backgroundImageResizerContext"), c(this, "backgroundImageResizer"), this.pipeline = new kF(this.context);
                const R = new OffscreenCanvas(0, 0), S = R.getContext("webgl2");
                if (!S)
                  throw "Fail to retrieve webgl context";
                this.backgroundImageResizerCanvas = R, this.backgroundImageResizerContext = S, this.backgroundImageResizer = new ES(
                  this.backgroundImageResizerContext,
                  0,
                  0
                );
              }
              setBackgroundImage(R) {
                this.backgroundImage = R, this.updateBackgroundImage();
              }
              updateBackgroundImage() {
                const { width: R, height: S } = this.canvas;
                this.backgroundImageResizer.resizeOutput(R, S), this.backgroundImageResizer.setData(this.backgroundImage), this.backgroundImageResizer.run(), this.pipeline.inputBackgroundImage = this.backgroundImageResizerCanvas;
              }
              resizeOutput(R, S) {
                super.resizeOutput(R, S), this.backgroundImageResizerCanvas.width = R, this.backgroundImageResizerCanvas.height = S, this.backgroundImageResizer.resizeOutput(R, S), this.updateBackgroundImage();
              }
            }
            class jS extends YF {
              constructor() {
                super(...arguments), c(this, "frameReader");
              }
              setBackgroundVideo(R) {
                this.frameReader = R;
              }
              async render(R, S) {
                return await this.readNextVideoFrame(), super.render(R, S);
              }
              async readNextVideoFrame() {
                var R;
                const S = await ((R = this.frameReader) == null ? void 0 : R.read());
                if (S != null && S.value) {
                  const ie = await createImageBitmap(S.value);
                  this.setBackgroundImage(ie), S.value.close();
                }
              }
            }
            class LF {
              blurBackground(R) {
                return new Ml(R);
              }
              blurSilhouette(R) {
                return new kc(R);
              }
              imageBackground() {
                return new Td();
              }
              videoBackground() {
                return new jS();
              }
            }
            const _S = `precision mediump float;

varying vec2 _texture_coord;

uniform vec2 canvas;
uniform sampler2D texture;
uniform sampler2D mask;

vec4 loop();

void main() { gl_FragColor = loop(); }
`, $S = `varying vec2 _texture_coord;

attribute vec2 position;
attribute vec2 texture_coord;

void main() {
  gl_Position = vec4(position, 0., 1.);
  _texture_coord = texture_coord;
}
`;
            class qS extends Sh {
              getDefines() {
                var R;
                return { RADIUS: (R = this.options.radius) != null ? R : 1 };
              }
              getFragmentShader() {
                return _S + this.createLoopFunction();
              }
              getVertexShader() {
                return $S;
              }
              createLoopFunction() {
                var R;
                let S = (R = this.options.radius) != null ? R : 1;
                return `

        vec4 loop() { 
            vec4 result = vec4(0,0,0,0);
            float factorSum = 0.;

            vec2 normalizedRadius = vec2(-${S}.) / canvas;
            vec2 normalizedIncrement = vec2(1.) / canvas;
            vec2 diff = normalizedRadius;
            float maxLength = length(normalizedRadius);

            for(int y=-${S}; y<${S + 1}; ++y) {
                for(int x=-${S}; x<${S + 1}; ++x) {
                    float factor = (1.- texture2D(mask, _texture_coord + diff).a) * (maxLength - length(diff)) / maxLength;
                    result += factor * texture2D(texture, _texture_coord + diff);
                    factorSum += factor;
                    diff.x += normalizedIncrement.x;
                }
                diff.y += normalizedIncrement.y;
                diff.x = normalizedRadius.x;
            }
            return result / factorSum;
        }`;
              }
            }
            const eE = 10, tE = 2, nE = 8;
            class rE extends ov {
              constructor(R, S) {
                super(), c(this, "inputImage"), c(this, "inputMask"), c(this, "blur"), this.context = R, this.radius = S;
                const ie = {
                  context: R,
                  height: R.canvas.height,
                  width: R.canvas.width
                };
                this.blur = new qS({
                  ...ie,
                  radius: S,
                  ...this.getBlurTextureSize(
                    R.canvas.width,
                    R.canvas.height
                  )
                });
                const pe = new rv({ ...ie, disableFramebuffer: !0 });
                this.addStep({
                  program: this.blur,
                  preventResize: !0,
                  getUniforms: () => ({
                    texture: pl(R, this.inputImage),
                    mask: pl(R, this.inputMask)
                  })
                }), this.addStep({
                  program: pe,
                  getUniforms: () => ({
                    background: pl(R, this.blur.output),
                    foreground: pl(R, this.inputImage),
                    threshold: pl(R, this.inputMask)
                  })
                });
              }
              getBlurTextureSize(R, S) {
                const ie = this.radius > eE ? nE : tE;
                return {
                  width: Math.max(WA, R / ie),
                  height: Math.max(WA, S / ie)
                };
              }
              setData(R, S) {
                this.inputImage = R, this.inputMask = S;
              }
              resizeOutput(R, S) {
                super.resizeOutput(R, S);
                const ie = this.getBlurTextureSize(R, S);
                this.blur.resizeOutput(ie.width, ie.height);
              }
            }
            class iE extends bm {
              constructor(R) {
                super(), c(this, "pipeline"), this.pipeline = new rE(this.context, R), this.disablePostProcessing();
              }
            }
            class oE extends ov {
              constructor(R, S) {
                super(), c(this, "inputImage"), c(this, "inputMask"), this.context = R;
                const ie = {
                  context: R,
                  height: R.canvas.height,
                  width: R.canvas.width
                }, pe = new DF({
                  ...ie,
                  radius: S,
                  type: av.GAUSSIAN
                }), De = new rv({ ...ie, disableFramebuffer: !0 });
                this.addStep({
                  program: pe,
                  getUniforms: () => ({
                    texture: pl(R, this.inputImage)
                  })
                }), this.addStep({
                  program: De,
                  getUniforms: () => ({
                    background: pl(R, this.inputImage),
                    foreground: pl(R, pe.output),
                    threshold: pl(R, this.inputMask)
                  })
                });
              }
              setData(R, S) {
                this.inputImage = R, this.inputMask = S;
              }
            }
            class aE extends bm {
              constructor(R) {
                super(), c(this, "pipeline"), this.pipeline = new oE(this.context, R), this.disablePostProcessing();
              }
            }
            class sE extends kF {
              constructor() {
                super(...arguments), c(this, "frameReader"), c(this, "preciseMaskEnabled", !0);
              }
              set reader(R) {
                this.frameReader = R;
              }
              async run() {
                this.frameReader && (await this.readNextVideoFrame(), await super.run());
              }
              async readNextVideoFrame() {
                var R;
                const S = await ((R = this.frameReader) == null ? void 0 : R.read());
                S != null && S.value && (this.inputBackgroundImage = await createImageBitmap(S.value), S.value.close());
              }
            }
            class lE extends bm {
              constructor() {
                super(), c(this, "pipeline"), this.pipeline = new sE(this.context);
              }
              setBackgroundVideo(R) {
                this.pipeline.reader = R;
              }
            }
            class xF {
              blurBackground(R) {
                return new iE(R);
              }
              blurSilhouette(R) {
                return new aE(R);
              }
              imageBackground() {
                return new YF();
              }
              videoBackground() {
                return new lE();
              }
            }
            class cE {
              constructor(R) {
                switch (c(this, "factory"), R) {
                  case ao.CANVAS:
                    this.factory = new LF();
                    break;
                  case ao.WEBGL:
                    this.factory = new xF();
                    break;
                  default:
                    const S = Ei();
                    this.factory = S.supported ? new xF() : new LF();
                }
              }
              blurBackground(R) {
                return this.getFactory().blurBackground(R);
              }
              blurSilhouette(R) {
                return this.getFactory().blurSilhouette(R);
              }
              imageBackground() {
                return this.getFactory().imageBackground();
              }
              videoBackground() {
                return this.getFactory().videoBackground();
              }
              getFactory() {
                if (!this.factory)
                  throw "Factory is not initialized";
                return this.factory;
              }
            }
            class dE {
              constructor() {
                c(this, "renderer"), c(this, "backgroundVideo"), c(this, "backgroundImage");
              }
              setBackgroundOptions(R) {
                var S, ie;
                const pe = new cE((S = R.renderingOptions) == null ? void 0 : S.type);
                switch (R.transformerType) {
                  case "BackgroundBlur":
                    this.renderer = pe.blurBackground(
                      this.getBlurSize(R.radius)
                    );
                    break;
                  case "SilhouetteBlur":
                    this.renderer = pe.blurSilhouette(
                      this.getBlurSize(R.radius)
                    );
                    break;
                  case "VideoBackground":
                    const De = pe.videoBackground();
                    this.backgroundVideo && De.setBackgroundVideo(this.backgroundVideo), this.renderer = De;
                    break;
                  case "VirtualBackground":
                    const ht = pe.imageBackground();
                    this.backgroundImage && ht.setBackgroundImage(this.backgroundImage), this.renderer = ht;
                    break;
                  default:
                    throw `Unknown rendering type [${R.transformerType}]`;
                }
                ((ie = R.renderingOptions) == null ? void 0 : ie.type) === ao.WEBGL && (R.renderingOptions.selfieSegmentationType === Sr.PRECISE ? this.renderer.enablePostProcessing() : R.renderingOptions.selfieSegmentationType === Sr.FAST && this.renderer.disablePostProcessing());
              }
              setFlickeringOptions(R) {
                var S;
                (S = this.renderer) == null || S.setFlickeringOptions(R);
              }
              setVideoBGReadable(R) {
                this.backgroundVideo = R.getReader();
                const S = this.renderer;
                S != null && S.setBackgroundVideo && S.setBackgroundVideo(this.backgroundVideo);
              }
              async setVirtualBGImage(R) {
                const S = this.renderer;
                S != null && S.setBackgroundImage && S.setBackgroundImage(R), this.backgroundImage = R;
              }
              async process(R, S) {
                if (this.renderer)
                  return this.renderer.render(R, S);
              }
              async resizeForeground(R, S) {
              }
              getBlurSize(R = cn.Low) {
                switch (R) {
                  case cn.Low:
                    return 5;
                  case cn.High:
                    return 12;
                }
                return R;
              }
              async profile(R) {
                var S, ie;
                return (ie = (S = this.renderer) == null ? void 0 : S.profileWebgl(R)) != null ? ie : [];
              }
            }
            class HF {
              constructor() {
                c(this, "selfieSegmentation", new kr()), c(this, "backgroundFilter"), c(this, "reporter", new Gd()), c(this, "isEnabled", !0), c(this, "backgroundOptions");
              }
              async init(R, S) {
                await this.selfieSegmentation.init(
                  S.wasmAssetUriPath,
                  S.tfliteAssetUriPath
                ), this.backgroundFilter = new dE(), this.report({
                  variation: "Create"
                });
              }
              async transform(R, S) {
                var ie, pe;
                if (!this.isEnabled)
                  return S.enqueue(R);
                let De;
                const ht = (ie = R.timestamp) != null ? ie : 0, rt = await createImageBitmap(R), Nt = await this.selfieSegmentation.process(rt);
                Nt && (De = await ((pe = this.backgroundFilter) == null ? void 0 : pe.process(rt, Nt))), De ? (R.close(), S.enqueue(
                  new VideoFrame(De, {
                    timestamp: ht,
                    alpha: "discard"
                  })
                )) : S.enqueue(R);
              }
              async setBackgroundOptions(R) {
                var S;
                this.backgroundOptions = R, await ((S = this.backgroundFilter) == null ? void 0 : S.setBackgroundOptions(R)), this.report({
                  variation: "Update"
                });
              }
              async setVideoBGReadable(R) {
                var S;
                await ((S = this.backgroundFilter) == null ? void 0 : S.setVideoBGReadable(R));
              }
              async setVirtualBGImage(R) {
                var S;
                await ((S = this.backgroundFilter) == null ? void 0 : S.setVirtualBGImage(R));
              }
              setFlickeringOptions(R) {
                var S;
                (S = this.backgroundFilter) == null || S.setFlickeringOptions(R), this.report({
                  variation: "Update"
                });
              }
              async profile(R) {
                var S, ie;
                return (ie = (S = this.backgroundFilter) == null ? void 0 : S.profile(R)) != null ? ie : [];
              }
              getTransformerType() {
                var R, S;
                return (S = (R = this.backgroundOptions) == null ? void 0 : R.transformerType) != null ? S : "Undefined";
              }
              enable() {
                this.isEnabled = !0;
              }
              disable() {
                this.isEnabled = !1;
              }
              report(R) {
                var S;
                this.reporter.send({
                  version: _l,
                  action: "MlTransformers",
                  transformerType: (S = this.backgroundOptions) == null ? void 0 : S.transformerType,
                  config: JSON.stringify(this.backgroundOptions),
                  ...R
                });
              }
            }
            const PF = class {
              constructor() {
                c(this, "backgroundTransformer", new HF()), c(this, "mediaProcessor", new Fa()), c(this, "rate", 30), c(this, "resolveOnMediaProcessor"), c(this, "eventsQueue", []);
              }
              async init(E, R) {
                await this.backgroundTransformer.init(E, R), await this.mediaProcessor.setTransformers([this.backgroundTransformer]), this.mediaProcessor.setTrackExpectedRate(this.rate), this.mediaProcessor.onAny((S, ie) => {
                  this.resolveOnMediaProcessor ? (this.resolveOnMediaProcessor({ name: S, data: ie }), this.resolveOnMediaProcessor = void 0) : this.eventsQueue.push({ name: S, data: ie });
                });
              }
              enable() {
                this.backgroundTransformer.enable();
              }
              disable() {
                this.backgroundTransformer.disable();
              }
              async onMediaProcessorEvent() {
                return await new n((E) => {
                  this.eventsQueue.length > 0 ? E(this.eventsQueue.shift()) : this.resolveOnMediaProcessor = E;
                });
              }
              async setTrackExpectedRate(E) {
                this.rate = E, this.mediaProcessor.setTrackExpectedRate(E);
              }
              async transform(E, R) {
                this.mediaProcessor.transform(E, R);
              }
              async setBackgroundOptions(E) {
                var R;
                await ((R = this.backgroundTransformer) == null ? void 0 : R.setBackgroundOptions(E));
              }
              setVideoBGReadable(E) {
                this.backgroundTransformer.setVideoBGReadable(E);
              }
              async setVirtualBGImage(E) {
                await this.backgroundTransformer.setVirtualBGImage(E);
              }
              async terminate() {
                await this.mediaProcessor.destroy();
              }
              setFlickeringOptions(E) {
                this.backgroundTransformer.setFlickeringOptions(E);
              }
              setVonageMetadata(E) {
                Br(E);
              }
              async profile(E) {
                return JSON.stringify(
                  await this.backgroundTransformer.profile(E)
                );
              }
            };
            let uE = PF;
            Rl("ProcessorWorker", PF);
            const OF = "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", KF = typeof window < "u" && window.Blob && new Blob([atob(OF)], { type: "text/javascript;charset=utf-8" });
            function hE() {
              const E = KF && (window.URL || window.webkitURL).createObjectURL(KF);
              try {
                return E ? new Worker(E) : new Worker("data:application/javascript;base64," + OF);
              } finally {
                E && (window.URL || window.webkitURL).revokeObjectURL(E);
              }
            }
            const zF = class extends so {
              constructor(E) {
                super(), c(this, "rate", 30), c(this, "worker"), c(this, "config"), c(this, "backgroundOptions"), c(this, "isEnabled", !0), this.config = E;
              }
              async setTrackExpectedRate(E) {
                var R;
                await this.startWorker(), await ((R = this.worker) == null ? void 0 : R.setTrackExpectedRate(E));
              }
              async setBackgroundOptions(E) {
                this.backgroundOptions = E, await this.updateBackgroundOptions(E);
              }
              async transform(E, R) {
                var S;
                await this.startWorker(), await ((S = this.worker) == null ? void 0 : S.transform(E, R));
              }
              async destroy() {
                var E;
                await ((E = this.worker) == null ? void 0 : E.terminate()), this.worker = void 0;
              }
              async setFlickeringOptions(E) {
                var R;
                await this.startWorker(), await ((R = this.worker) == null ? void 0 : R.setFlickeringOptions(E));
              }
              async profile(E) {
                var R;
                const S = await ((R = this.worker) == null ? void 0 : R.profile(E));
                return JSON.parse(S != null ? S : "[]");
              }
              async enable() {
                var E;
                this.isEnabled = !0, await ((E = this.worker) == null ? void 0 : E.enable());
              }
              async disable() {
                var E;
                this.isEnabled = !1, await ((E = this.worker) == null ? void 0 : E.disable());
              }
              async listenWorker() {
                for (var E, R; (E = this.worker) != null && E.workerContext.worker; ) {
                  const { name: S, data: ie } = await ((R = this.worker) == null ? void 0 : R.onMediaProcessorEvent());
                  switch (S) {
                    case "error":
                    case "warn":
                      this.emit(S, ie);
                      break;
                    case "pipelineInfo":
                      switch (this.emit(S, ie), ie) {
                        case "pipeline_ended":
                        case "pipeline_ended_with_error":
                          await this.destroy();
                          return;
                      }
                      break;
                  }
                }
              }
              async startWorker() {
                !this.config || this.worker || (this.worker = await La(uE, hE), this.isEnabled || await this.worker.disable(), await this.worker.init(
                  `worker_${zF.initCount++}`,
                  this.config
                ), this.backgroundOptions && await this.updateBackgroundOptions(this.backgroundOptions), await this.worker.setVonageMetadata(pi()), await this.setBackgroundOptions(this.config), this.listenWorker());
              }
              async updateBackgroundOptions(E) {
                var R, S, ie;
                await this.startWorker();
                const { transformerType: pe } = E;
                switch (pe) {
                  case "VideoBackground":
                    await ((R = this.worker) == null ? void 0 : R.setVideoBGReadable(
                      await oc.createVideoReadable(
                        E.backgroundAssetUri
                      )
                    ));
                    break;
                  case "VirtualBackground":
                    await ((S = this.worker) == null ? void 0 : S.setVirtualBGImage(
                      await oc.createImageCanvas(
                        E.backgroundAssetUri
                      )
                    ));
                    break;
                }
                await ((ie = this.worker) == null ? void 0 : ie.setBackgroundOptions(E));
              }
            };
            let jF = zF;
            c(jF, "initCount", 0);
            class AE {
              constructor(R) {
                this.queries = R;
              }
              async downloadSpeedscope() {
                this.download(await this.convertToSpeedscope());
              }
              download(R) {
                const S = document.createElement("a");
                S.href = URL.createObjectURL(
                  new Blob([R], { type: "application/json" })
                ), S.download = `profile-${+/* @__PURE__ */ new Date()}.speedscope.json`, document.body.appendChild(S), S.click(), document.body.removeChild(S);
              }
              convertToSpeedscope() {
                const R = [], S = {}, ie = [];
                let pe = 0;
                for (const ht of this.queries) {
                  const rt = [];
                  for (const Nt of ht)
                    S[Nt.name] === void 0 && (S[Nt.name] = R.length, R.push({
                      name: Nt.name
                    })), rt.push({
                      type: Nt.action == MF.PUSH ? "O" : "C",
                      frame: S[Nt.name],
                      at: Nt.timestamp
                    }), pe = Math.max(pe, Nt.timestamp + Nt.duration);
                  ie.push({
                    events: rt,
                    type: "evented",
                    name: "GPU Profile",
                    unit: "nanoseconds",
                    startValue: 0,
                    endValue: pe
                  });
                }
                return JSON.stringify({
                  $schema: "https://www.speedscope.app/file-format-schema.json",
                  shared: {
                    frames: R
                  },
                  profiles: ie
                }, null, 2);
              }
            }
            class lv extends so {
              constructor(R) {
                super(), c(this, "worker"), c(this, "connector"), this.worker = new jF(R), this.connector = new Ct(this.worker), this.worker.onAny(
                  (S, ie) => this.emit(S, ie)
                );
              }
              async setBackgroundOptions(R) {
                await this.worker.setBackgroundOptions(R);
              }
              async enable() {
                await this.worker.enable();
              }
              async disable() {
                await this.worker.disable();
              }
              setTrackExpectedRate(R) {
                this.worker.setTrackExpectedRate(R);
              }
              getConnector() {
                return this.connector;
              }
              async profile(R) {
                return this.worker.profile(R);
              }
              static async profile(R) {
                const S = await n.all(
                  this.instances.map((ie) => ie.profile(R))
                );
                return new AE(S);
              }
              static async create(R) {
                const S = new this(R);
                return this.instances.push(S), S;
              }
            }
            c(lv, "instances", []);
            function gE() {
              return Rt;
            }
            function fE() {
              return ln;
            }
            function pE() {
              return tt;
            }
            function mE() {
              return Oe;
            }
            function vE() {
              return Jt;
            }
            function bE() {
              return St;
            }
            function FE() {
              return Vt;
            }
            async function RE(E) {
              return await lv.create(E);
            }
          }.call(this, e(2), e(27));
        },
        /* 337 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = b;
          var t = n(e(17)), o = n(e(11)), l = n(e(1)), c = n(e(10)), d = n(e(741)), u = n(e(24)), h = n(e(13)), A = n(e(8)), g = n(e(7)), f = n(e(742)), p = n(e(743)), v = n(e(178));
          function b(m) {
            m === void 0 && (m = {});
            const y = m.Errors || A.default, U = m.ExceptionCodes || c.default, B = m.logging || (0, l.default)("publisherInit"), Q = m.otError || (0, h.default)(), N = m.OTHelpers || g.default, J = m.Publisher || (0, v.default)(), w = m.sessionObjects || u.default;
            return function(G, Z, K) {
              B.debug(`OT.initPublisher(${G})`), typeof G == "string" && !document.getElementById(G) && (G = Z, Z = K, K = arguments[3]), typeof G == "function" ? (K = G, Z = void 0, G = void 0) : (0, o.default)(G) && !N.isElementNode(G) && (K = Z, Z = G, G = void 0), typeof Z == "function" && (K = Z, Z = void 0);
              let L;
              Z && ((0, o.default)(Z) ? Z.insertDefaultUI === !1 && G ? L = "You cannot specify a target element if insertDefaultUI is false" : (0, d.default)(Z.audioSource) && (0, d.default)(Z.videoSource) && (L = "You cannot specify both audioSource and videoSource as null or false") : (L = "properties argument to Publisher constructor, if provided, should be an object", Z = void 0)), (0, f.default)(Z), (0, p.default)(Z);
              const O = new J(Z || {});
              w.publishers.add(O);
              const de = function() {
                K && (0, t.default)(K) && (K(...arguments), K = void 0);
              };
              L !== void 0 && (B.error(L), de(Q(y.INVALID_PARAMETER, new Error(L), U.INVALID_PARAMETER)));
              const oe = function(we) {
                O.off("publishComplete", fe), de(we);
              };
              let fe = function(we) {
                O.off("initSuccess", oe), we && de(we);
              };
              return O.once("initSuccess", oe), O.once("publishComplete", fe), O.publish(G), O;
            };
          }
        },
        /* 338 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = Ue;
            var o = t(e(4)), l = t(e(5)), c = t(e(14)), d = t(e(9)), u = t(e(744)), h = t(e(17)), A = t(e(11)), g = t(e(16)), f = t(e(6)), p = t(e(1)), v = t(e(73)), b = t(e(746)), m = t(e(10)), y = t(e(22)), U = t(e(103)), B = t(e(31)), Q = t(e(28)), N = t(e(172)), J = t(e(747)), w = t(e(748)), W = t(e(112)), G = t(e(339)), Z = t(e(24)), K = t(e(13)), L = t(e(749)), O = t(e(8)), de = t(e(752)), oe = e(71), fe = t(e(753)), ge = e(107), we = t(e(72)), _e = t(e(181)), Te = t(e(340)), Pe = t(e(23)), $e = t(e(182)), Bt = t(e(7)), Le = t(e(178)), at = t(e(754)), pt = t(e(347)), kt = t(e(346)), _t = t(e(323)), Lt = t(e(159)), Ft = t(e(778)), Zt = t(e(148)), ft = t(e(781)), It = t(e(782)), Kt = t(e(337)), Sn = t(e(37)), Cn = t(e(791)), on = t(e(78));
            const An = (0, Sn.default)();
            function Ue(ne) {
              ne === void 0 && (ne = {});
              const se = ne.adaptIceServers || ge.adaptIceServers, Ce = ne.AnalyticsHelper || Q.default, At = ne.APIKEY || we.default, Ge = ne.Capabilities || _e.default, Ye = ne.convertRumorError || Te.default, Qt = ne.Errors || O.default, tn = ne.Events || (0, Pe.default)(), vn = ne.Stream || $e.default, Yt = ne.ExceptionCodes || m.default, Tn = ne.hasIceRestartsCapability || G.default, er = ne.hasE2eeCapability || W.default, lr = ne.logging || (0, p.default)("Session"), Br = ne.otError || (0, K.default)(), pi = ne.OTErrorClass || y.default, $n = ne.OTHelpers || Bt.default, rr = ne.StaticConfig || An, Kr = ne.staticConfig || rr.onlyLocal(), Bi = ne.Publisher || (0, Le.default)(), Li = ne.RaptorSocket || (0, at.default)(), xo = ne.SessionDispatcher || pt.default, Yr = ne.sessionObjects || Z.default, Qo = ne.sessionTag || kt.default, Wo = ne.socketCloseCodes || on.default, xi = ne.Subscriber || (0, _t.default)(), Fa = ne.systemRequirements || Lt.default, sn = ne.uuid || g.default, Ct = (0, w.default)({
                otError: Br
              }), cn = ne.global || (typeof window !== void 0 ? window : Dn), Hn = ne.getSessionInfo || (0, Ft.default)(), Sr = ne.KeyStore || ft.default, ao = ne.SFrameClientStore || (0, It.default)(), wr = ne.SinglePeerConnectionController || Cn.default, Jr = ne.initPublisher || (0, Kt.default)({
                Publisher: Bi
              });
              return function(wt, Yn, kr) {
                var mr = this;
                let yi = kr === void 0 ? {} : kr, Or = yi.iceConfig, Ei = yi.connectionEventsSuppressed, Rt = yi.ipWhitelist, ln = Rt === void 0 ? !1 : Rt, tt = yi.encryptionSecret, Oe = yi._enableSinglePeerConnection, Jt = yi._prioritizeVP9, St = Jt === void 0 ? !1 : Jt;
                const Vt = (0, oe.getProxyUrl)(), Et = new Ce(), Qn = (qt) => typeof qt == "string" ? this.streams.get(qt) || {
                  id: qt
                } : qt;
                (0, f.default)(this), this._tag = Qo, Fa.check() || Fa.upgrade(), Yn == null && (Yn = wt, wt = null), Ct(Or), this.id = Yn, this.sessionId = Yn, this.keyStore = new Sr(), this.sFrameClientStore = new ao();
                let gn, jt, On, Ar, ui, fr, Jn, Qr, ti = !1, Wn = wt;
                const Hi = this;
                let Ho = Yn, Ea = sn(), Ga = lr, No = !1;
                const Ba = [];
                let Ra = null, us = !1, so, Va = tt, qa, hs, oi, oa;
                const Wa = $n.statable(this, ["disconnected", "connecting", "connected", "disconnecting"], "disconnected");
                this.connection = null, this.connections = new $n.Collection(), this.streams = new $n.Collection(), this.archives = new $n.Collection();
                let Xa;
                const ya = function(bn) {
                  Wa("disconnected"), bn.code || (bn.code = Yt.CONNECT_FAILED), Ga.error(`${bn.name || "Unknown Error"}: ${bn.message}`), pi.handleJsException({
                    error: bn,
                    target: this,
                    analytics: Et
                  }), this.trigger("sessionConnectFailed", bn);
                }, Fl = function(bn) {
                  ti = !1;
                  const hn = bn.reason;
                  this.logEvent("Connect", "Disconnected", {
                    reason: bn.reason
                  });
                  const xn = new tn.SessionDisconnectEvent("sessionDisconnected", hn.replace("networkTimedout", "networkDisconnected"));
                  this.isConnected() && this.disconnect(), hs(), qa.call(this, hn), setTimeout(() => {
                    this.dispatchEvent(xn), oi.call(this, xn.reason), xn.isDefaultPrevented() || oa.call(this, xn.reason);
                  });
                }, As = function(bn) {
                  Ei || bn.id.match(/^symphony\./) || this.dispatchEvent(new tn.ConnectionEvent(B.default.CONNECTION_CREATED, bn));
                }, gl = function(bn, hn) {
                  bn.id.match(/^symphony\./) || gn && bn.id === gn.id() || this.dispatchEvent(new tn.ConnectionEvent(B.default.CONNECTION_DESTROYED, bn, hn));
                }, Vi = function(bn) {
                  bn && bn.connection && (!this.connection || bn.connection.id !== this.connection.id) && this.dispatchEvent(new tn.StreamEvent(B.default.STREAM_CREATED, bn, null, !1));
                }, zr = function(bn) {
                  const hn = bn.target, xn = bn.changedProperty;
                  let vr = bn.newValue;
                  xn === "videoDisableWarning" || xn === "audioDisableWarning" || (xn === "videoDimensions" && (vr = {
                    width: vr.width,
                    height: vr.height
                  }), this.dispatchEvent(new tn.StreamPropertyChangedEvent(B.default.STREAM_PROPERTY_CHANGED, hn, xn, bn.oldValue, vr)));
                }, za = function(bn, hn) {
                  hn === void 0 && (hn = "clientDisconnected");
                  const xn = new tn.StreamEvent("streamDestroyed", bn, hn, !0), vr = () => {
                    Yr.subscribers.where({
                      streamId: bn.id
                    }).filter((Rr) => Rr.session.id === this.id && Rr.stream).forEach((Rr) => {
                      Rr._disconnect({
                        reason: hn
                      }), xn.isDefaultPrevented() || Rr._destroy({
                        reason: hn,
                        noStateTransition: !0
                      });
                    });
                  };
                  bn.connection.id === this.connection.id ? Yr.publishers.where({
                    streamId: bn.id
                  }).forEach(function(Rr) {
                    Rr._.unpublishStreamFromSession(bn, this, hn);
                  }, this) : this.dispatchEvent(xn), vr();
                }, ws = function(bn) {
                  this.dispatchEvent(new tn.ArchiveEvent("archiveStarted", bn));
                }, Zi = function(bn) {
                  this.dispatchEvent(new tn.ArchiveEvent("archiveDestroyed", bn));
                }, kl = function(bn) {
                  const hn = bn.target, xn = bn.changedProperty, vr = bn.newValue;
                  xn === "status" && vr === "stopped" ? this.dispatchEvent(new tn.ArchiveEvent("archiveStopped", hn)) : this.dispatchEvent(new tn.ArchiveEvent("archiveUpdated", hn));
                }, vc = () => Yr.subscribers.forEach((qt) => qt._.pauseAndPlayVideoElement()), wl = function() {
                  Hi.token = null, On = null, Wa("disconnected"), gn = null, jt && (jt.stop(), jt = null), Hi.connection = null, Hi.capabilities = new Ge([], {
                    hasE2eeCapability: er
                  }), Hi.connections.destroy(), Hi.streams.destroy(), Hi.archives.destroy();
                };
                hs = function() {
                  Ea = sn(), wl();
                }, qa = function(bn) {
                  Yr.publishers.where({
                    session: this
                  }).forEach((hn) => {
                    hn.disconnect(bn);
                  }), Yr.subscribers.where({
                    session: this
                  }).forEach((hn) => {
                    hn._disconnect();
                  });
                }, oi = function(bn) {
                  Yr.publishers.where({
                    session: this
                  }).forEach((hn) => {
                    hn._.streamDestroyed(bn);
                  });
                }, oa = function(bn) {
                  Yr.subscribers.where({
                    session: this
                  }).forEach((hn) => {
                    hn._destroy({
                      reason: bn
                    });
                  });
                };
                const ys = function() {
                  Ga.debug("OT.Session: connecting to Raptor");
                  const bn = (0, U.default)(this.sessionInfo.messagingURL, Vt), hn = ["forceMute"];
                  this.sessionInfo.isAdaptiveEnabled && hn.push("amr"), so && hn.push("spc"), gn = new Li({
                    connectionId: Ea,
                    sessionId: Yn,
                    messagingSocketUrl: bn,
                    symphonyUrl: this.sessionInfo.symphonyAddress,
                    dispatcher: xo(this, {
                      connectionEventsSuppressed: Ei
                    }),
                    analytics: Et,
                    requestedCapabilities: hn
                  });
                  function vr(Rr, zi) {
                    let _i;
                    switch (Rr) {
                      case "WebSocketConnection":
                        if (_i = (0, u.default)(Wo.codes, (Ko) => Ko === zi), _i)
                          return Qt[`SOCKET_${_i}`];
                        break;
                      case "ConnectToSession":
                      case "GetSessionState":
                        switch (zi) {
                          case Yt.CONNECT_FAILED:
                            return Qt.CONNECT_FAILED;
                          case Yt.UNEXPECTED_SERVER_RESPONSE:
                            return Qt.UNEXPECTED_SERVER_RESPONSE;
                          case Yt.CONNECTION_LIMIT_EXCEEDED:
                            return Qt.CONNECTION_LIMIT_EXCEEDED;
                        }
                        break;
                    }
                  }
                  gn.connect(On, this.sessionInfo, {
                    connectionEventsSuppressed: Ei
                  }, (Rr, zi) => {
                    if (Rr) {
                      const Ko = {};
                      let ps;
                      if (Rr.reason === "ConnectToSession" || Rr.reason === "GetSessionState") {
                        const Ya = Ye(Rr);
                        (0, d.default)(Ko, {
                          originalMessage: Rr.message,
                          originalCode: Rr.code
                        }), Rr.code = Ya.code, Rr.message = Ya.message;
                      }
                      (Rr.code || Rr.message || Rr.reason) && (ps = {
                        failureCode: Rr.code,
                        failureMessage: Rr.message,
                        failureReason: Rr.reason,
                        socketId: gn.socketId
                      }), gn = null, this.logConnectivityEvent("Failure", Ko, ps);
                      const ho = vr(Rr.reason, Rr.code);
                      ho && (Rr = Br(ho, new Error(Rr.message), Rr.code)), ya.call(this, Rr);
                      return;
                    }
                    Ga.debug("OT.Session: Received session state from Raptor", zi), this.connection = this.connections.get(gn.id()), this.connection && (this.capabilities = this.connection.permissions), Wa("connected"), this.logConnectivityEvent("Success", {
                      connectionId: this.connection.id
                    }), this.connection.on("destroyed", Fl, this), this.dispatchEvent(new tn.SessionConnectEvent(B.default.SESSION_CONNECTED)), this.connections.on({
                      add: As,
                      remove: gl
                    }, this), this.streams.on({
                      add: Vi,
                      remove: za,
                      update: zr
                    }, this), this.archives.on({
                      add: ws,
                      remove: Zi,
                      update: kl
                    }, this), this.connections._triggerAddEvents(), this.streams._triggerAddEvents(), this.archives._triggerAddEvents(), $n.env.isiOS && $n.env.iOSVersion >= 13.3 && this.on("gsmCallEnded", vc);
                  });
                }, Xn = (qt) => this.capabilities.permittedTo(qt), Kn = (qt, bn) => {
                  lr.error(`${qt.name}: ${qt.message}`), typeof bn == "function" && bn(qt), pi.handleJsException({
                    error: qt,
                    target: this,
                    analytics: Et
                  });
                }, pr = (qt) => {
                  const bn = Br(qt.code, new Error(qt.message), qt.exceptionCode);
                  return Kn(bn), bn;
                }, hi = () => this.isNot("connected") ? pr(de.default.NOT_CONNECTED) : Xn("forceMute") ? null : pr(de.default.PERMISSION_DENIED), Qi = (qt) => qt.code === "404" ? pr(de.default.NOT_FOUND) : qt.code === "403" ? pr(de.default.PERMISSION_DENIED) : pr(de.default.UNEXPECTED_SERVER_RESPONSE);
                this.reportIssue = (qt) => {
                  let bn = qt.id;
                  return (0, N.default)(Et.logEvent.bind(Et))({
                    action: "ReportIssue",
                    variation: "Event",
                    connectionId: Ea,
                    payload: {
                      reportIssueId: bn
                    }
                  }, null);
                }, this.logEvent = function(qt, bn, hn, xn) {
                  let vr = {
                    action: qt,
                    variation: bn,
                    payload: hn,
                    sessionId: Ho,
                    messagingServer: ui,
                    p2p: Ar,
                    partnerId: Wn,
                    connectionId: Ea,
                    singlePeerConnection: so
                  };
                  xn && (vr = (0, d.default)(xn, vr)), Et.logEvent(vr);
                }, this.logConfigurationFileEvent = function(qt, bn, hn) {
                  if (bn === void 0 && (bn = null), hn === void 0 && (hn = {}), qt === "Attempt")
                    Jn = (/* @__PURE__ */ new Date()).getTime();
                  else if (qt === "Failure" || qt === "Success") {
                    const xn = (/* @__PURE__ */ new Date()).getTime() - Jn;
                    (0, d.default)(hn, {
                      attemptDuration: xn
                    });
                  }
                  Vt && (hn.proxyUrl = Vt), this.logEvent("ConfigurationFile", qt, bn, Object.assign({}, hn));
                }, this.logConnectivityEvent = function(qt, bn, hn) {
                  if (bn === void 0 && (bn = null), hn === void 0 && (hn = {}), Vt && (hn.proxyUrl = Vt), qt === "Attempt" && (jt && (jt.stop(), lr.error("_connectivityAttemptPinger should have been cleaned up")), fr = (/* @__PURE__ */ new Date()).getTime(), jt = new v.default(() => {
                    this.logEvent("Connect", "Attempting", bn, Object.assign({}, hn));
                  }, 1 / 5, 6), jt.start()), qt === "Failure" || qt === "Success" || qt === "Cancel") {
                    const xn = (vr) => {
                      jt && (jt.stop(), jt = void 0), this.logEvent("Connect", qt, bn, Object.assign({}, hn, {
                        attemptDuration: (/* @__PURE__ */ new Date()).getTime() - fr,
                        iceConfig: vr,
                        ipWhitelist: ln
                      }));
                    };
                    qt === "Success" ? this._.getIceConfig().then((vr) => {
                      const Rr = {
                        includeServers: Or && Or.includeServers || "all",
                        transportPolicy: vr.transportPolicy
                      };
                      Rr.servers = vr.servers ? vr.servers.map((zi) => ({
                        url: zi.urls
                      })) : [], xn(Rr);
                    }) : xn();
                  } else
                    this.logEvent("Connect", qt, bn, hn);
                }, this.connect = function() {
                  let qt;
                  for (var bn = arguments.length, hn = new Array(bn), xn = 0; xn < bn; xn++)
                    hn[xn] = arguments[xn];
                  hn.length > 1 && (typeof hn[0] == "string" || typeof hn[0] == "number") && typeof hn[1] == "string" ? (wt == null && (Wn = hn[0].toString()), qt = hn[1]) : qt = hn[0];
                  const vr = hn[hn.length - 1];
                  if (mr.is("connecting", "connected"))
                    return Ga.warn(`OT.Session: Cannot connect, the session is already ${mr.currentState}`), mr;
                  mr.is("disconnecting") && (Ga.warn("OT.Session: trying to connect while the session is not done disconnecting."), Ea = sn()), Et.sessionInfo = new Zt.default(), wl(), Wa("connecting");
                  const Rr = Ea;
                  function zi() {
                    const ho = Ea !== Rr;
                    return ho && lr.debug("Connection was interrupted"), ho;
                  }
                  if (mr.token = !(0, h.default)(qt) && qt, On = !(0, h.default)(qt) && qt, vr && (0, h.default)(vr)) {
                    let ho;
                    const Ya = function() {
                      ho();
                      for (var zo = arguments.length, Rl = new Array(zo), ms = 0; ms < zo; ms++)
                        Rl[ms] = arguments[ms];
                      vr(void 0, ...Rl);
                    }, La = function() {
                      ho(), vr(...arguments);
                    };
                    ho = () => {
                      mr.off("sessionConnected", Ya), mr.off("sessionConnectFailed", La);
                    }, mr.once("sessionConnected", Ya), mr.once("sessionConnectFailed", La);
                  }
                  if (Wn == null || (0, h.default)(Wn))
                    return setTimeout(ya.bind(mr, Br(Qt.AUTHENTICATION_ERROR, new Error("API Key is undefined. You must pass an API Key to initSession."), Yt.AUTHENTICATION_ERROR))), mr;
                  if (!Ho || (0, A.default)(Ho) || Array.isArray(Ho)) {
                    let ho;
                    return Ho ? (ho = "SessionID is not a string. You must use string as the session ID passed into OT.initSession().", Ho = Ho.toString()) : ho = "SessionID is undefined. You must pass a sessionID to initSession.", setTimeout(ya.bind(mr, Br(Qt.INVALID_SESSION_ID, new Error(ho), Yt.INVALID_SESSION_ID))), mr.logConnectivityEvent("Attempt"), mr.logConnectivityEvent("Failure", null, {
                      failureReason: "ConnectToSession",
                      failureCode: Yt.INVALID_SESSION_ID,
                      failureMessage: ho
                    }), mr;
                  }
                  if (mr.apiKey = Wn.toString(), Wn = Wn.toString(), Va) {
                    if (!er())
                      return setTimeout(ya.bind(mr, Br(Qt.UNSUPPORTED_BROWSER, new Error("E2E Encryption is not supported in your browser.")))), mr;
                    try {
                      (0, fe.default)(Va), mr.keyStore.set(Yn, Va), us = !0;
                    } catch (ho) {
                      return setTimeout(ya.bind(mr, Br(Qt.INVALID_ENCRYPTION_SECRET, new Error(`Invalid encryptionSecret: ${ho.message}`)))), mr;
                    }
                  }
                  At.value.length === 0 && (At.value = Wn);
                  const _i = !!rr.onlyLocal().configUrl, Ko = ln === !0 && !!rr.onlyLocal().ipWhitelistConfigUrl;
                  return !_i && !Ko ? mr.logConfigurationFileEvent("Event", {
                    message: "No configUrl, using local config only"
                  }) : mr.logConfigurationFileEvent("Attempt"), (_i || Ko ? rr.get({
                    partnerId: Wn,
                    token: qt,
                    useIpWhitelistConfigUrl: Ko,
                    proxyUrl: Vt
                  }) : n.resolve(rr.onlyLocal())).then((ho) => ((_i || Ko) && mr.logConfigurationFileEvent("Success"), ho), (ho) => ((_i || Ko) && mr.logConfigurationFileEvent("Failure", {
                    failureMessage: ho.message,
                    failureStack: ho.stack
                  }), rr.onlyLocal())).then((ho) => {
                    if (mr.staticConfig = ho, Et.staticConfig = ho, ho.apiEnabled === !1)
                      throw Br(Qt.API_KEY_DISABLED, new Error("The API KEY has been disabled. Access to the service is currently being restricted. Please contact support."));
                    if (zi())
                      return;
                    mr.logConnectivityEvent("Attempt"), Vt ? mr.logEvent("SessionInfo", "Attempt", null, {
                      proxyUrl: Vt
                    }) : mr.logEvent("SessionInfo", "Attempt");
                    const Ya = (zo) => {
                      zo.code = (0, b.default)(zo.code), mr.logConnectivityEvent("Failure", null, {
                        failureReason: "GetSessionInfo",
                        failureCode: zo.code || "No code",
                        failureMessage: zo.message,
                        failureName: zo.name
                      }), zo.name && (zo = Br(zo.name, new Error(`${zo.message}${zo.code ? ` (${zo.code})` : ""}`), zo.code)), ya.call(mr, zo);
                    }, La = (zo) => {
                      if (zi())
                        return;
                      if (zo.partnerId && zo.partnerId !== Wn) {
                        const ms = "Authentication Error: The API key does not match the token or session.";
                        Ya(Br(Qt.AUTHENTICATION_ERROR, new Error(ms), Yt.AUTHENTICATION_ERROR));
                        return;
                      }
                      so = (0, L.default)(zo, Oe), so && (Xa = new wr(mr)), Et.sessionInfo = zo;
                      const Rl = {
                        features: {
                          reconnection: zo.reconnection,
                          renegotiation: Tn() && zo.renegotiation,
                          simulcast: zo.simulcast === void 0 ? !1 : zo.simulcast && $n.env.name === "Chrome"
                        }
                      };
                      if (Vt && (Rl.proxyUrl = Vt), mr.is("connecting")) {
                        mr.sessionInfo = zo, mr._.setIceServers(mr.sessionInfo.iceServers), Ar = zo.p2pEnabled, ui = zo.messagingServer, mr.logEvent("SessionInfo", "Success", null, Rl, {
                          messagingServer: zo.messagingServer
                        });
                        const ms = ho.sessionInfoOverrides || {};
                        St && (ms.priorityVideoCodec = "vp9"), ms != null && typeof ms == "object" && Object.keys(ms).forEach(($o) => {
                          Object.defineProperty(mr.sessionInfo, $o, {
                            value: ms[$o]
                          });
                        }), ys.call(mr);
                      }
                    }, Jd = (0, U.default)(ho.apiUrl, Vt);
                    return Hn({
                      anvilUrl: Jd,
                      sessionId: Yn,
                      token: On,
                      connectionId: Ea,
                      clientVersion: ho.clientVersion
                    }).then(La, Ya);
                  }).catch((ho) => {
                    ya.call(mr, ho);
                  }), mr;
                }, this.disconnect = function() {
                  Xa && (Xa.destroy(), Xa = null), gn && gn.isNot("disconnected") ? gn.isNot("disconnecting") && (gn.isNot("connecting") || this.logConnectivityEvent("Cancel"), Wa("disconnecting"), gn.disconnect(), this.off("gsmCallEnded", vc)) : hs();
                }, this.destroy = function() {
                  this.streams.destroy(), this.connections.destroy(), this.archives.destroy(), this.disconnect();
                }, this.publish = (qt, bn, hn) => {
                  if (typeof qt == "function" && (hn = qt, qt = void 0), typeof bn == "function" && (hn = bn, bn = void 0), hn = hn || function() {
                  }, this.isNot("connected"))
                    return Et.logError(1010, "OT.exception", "We need to be connected before you can publish", null, {
                      action: "Publish",
                      variation: "Failure",
                      failureReason: "unconnected",
                      failureCode: Yt.NOT_CONNECTED,
                      failureMessage: "We need to be connected before you can publish",
                      sessionId: Ho,
                      streamId: qt && qt.stream ? qt.stream.id : null,
                      p2p: this.sessionInfo ? this.sessionInfo.p2pEnabled : void 0,
                      messagingServer: this.sessionInfo ? this.sessionInfo.messagingServer : null,
                      partnerId: Wn
                    }), Kn(Br(Qt.NOT_CONNECTED, new Error("We need to be connected before you can publish"), Yt.NOT_CONNECTED), hn), null;
                  if (!Xn("publish")) {
                    const Rr = "This token does not allow publishing. The role must be at least `publisher` to enable this functionality", zi = {
                      failureReason: "Permission",
                      failureCode: Yt.UNABLE_TO_PUBLISH,
                      failureMessage: Rr
                    };
                    return this.logEvent("Publish", "Failure", null, zi), Kn(Br(Qt.PERMISSION_DENIED, new Error(Rr), Yt.UNABLE_TO_PUBLISH), hn), null;
                  }
                  const xn = !qt || typeof qt == "string" || $n.isElementNode(qt), vr = qt instanceof Bi;
                  if (!xn && !vr) {
                    Kn(Br(Qt.INVALID_PARAMETER, new Error("Session.publish :: First parameter passed in is neither a string nor an instance of the Publisher"), Yt.UNABLE_TO_PUBLISH), hn);
                    return;
                  }
                  if (vr) {
                    if ("session" in qt && qt.session && "sessionId" in qt.session)
                      return qt.session.sessionId === this.sessionId ? Ga.warn(`Cannot publish ${qt.guid()} again to ${this.sessionId}. Please call session.unpublish(publisher) first.`) : Ga.warn(`Cannot publish ${qt.guid()} publisher already attached to ${qt.session.sessionId}. Please call session.unpublish(publisher) first.`), hn(null, qt), qt;
                  } else xn && (qt = Jr(qt, bn));
                  return No && qt._.forceMuteAudio(), qt._.publishToSession(this, Et).then(() => hn(null, qt), (Rr) => {
                    Rr.message = `Session.publish :: ${Rr.message}`, Ga.error(Rr.code, Rr.message), hn(Rr);
                  }), qt;
                }, this.unpublish = function(qt) {
                  if (!qt) {
                    Ga.error("OT.Session.unpublish: publisher parameter missing.");
                    return;
                  }
                  qt._.unpublishFromSession(this, "unpublished");
                }, this.setIceConfig = /* @__PURE__ */ function() {
                  var qt = (0, l.default)(/* @__PURE__ */ o.default.mark(function bn(hn) {
                    var xn, vr, Rr;
                    return o.default.wrap(function(_i) {
                      for (; ; ) switch (_i.prev = _i.next) {
                        case 0:
                          if (Ct(hn), Et.logEvent({
                            action: "setIceConfig",
                            variation: "Attempt",
                            payload: {
                              newIceConfig: hn
                            }
                          }), Or = Object.assign({}, hn), hn.includeServers !== "all") {
                            _i.next = 8;
                            break;
                          }
                          return _i.next = 6, Hi._.getOtIceServerInfo();
                        case 6:
                          xn = _i.sent, hn.customServers = hn.customServers.concat(xn.servers);
                        case 8:
                          return vr = (Ko) => ({
                            iceServers: Ko.customServers,
                            iceTransportPolicy: Ko.transportPolicy
                          }), Rr = vr(hn), _i.prev = 10, _i.next = 13, n.all(Yr.publishers.map((Ko) => Ko._.setIceConfig(Rr)).concat(Yr.subscribers.map((Ko) => Ko._.setIceConfig(Rr))));
                        case 13:
                          _i.next = 19;
                          break;
                        case 15:
                          throw _i.prev = 15, _i.t0 = _i.catch(10), Et.logEvent({
                            action: "setIceConfig",
                            variation: "Failure",
                            payload: {
                              newIceConfig: hn
                            }
                          }), _i.t0;
                        case 19:
                          Et.logEvent({
                            action: "setIceConfig",
                            variation: "Success",
                            payload: {
                              newIceConfig: hn
                            }
                          });
                        case 20:
                        case "end":
                          return _i.stop();
                      }
                    }, bn, null, [[10, 15]]);
                  }));
                  return function(bn) {
                    return qt.apply(this, arguments);
                  };
                }(), this.subscribe = function(qt, bn, hn, xn) {
                  if (typeof bn == "function" && (xn = bn, bn = void 0, hn = void 0), typeof hn == "function" && (xn = hn, hn = void 0), xn = xn || function() {
                  }, !this.connection || !this.connection.connectionId) {
                    Kn(Br(Qt.NOT_CONNECTED, new Error("Session.subscribe :: Connection required to subscribe"), Yt.UNABLE_TO_SUBSCRIBE), xn);
                    return;
                  }
                  if (!qt) {
                    Kn(Br(Qt.INVALID_PARAMETER, new Error("Session.subscribe :: stream cannot be null"), Yt.UNABLE_TO_SUBSCRIBE), xn);
                    return;
                  }
                  if (!Object.prototype.hasOwnProperty.call(qt, "streamId")) {
                    Kn(Br(Qt.INVALID_PARAMETER, new Error("Session.subscribe :: invalid stream object"), Yt.UNABLE_TO_SUBSCRIBE), xn);
                    return;
                  }
                  if (hn && hn.insertDefaultUI === !1 && bn) {
                    Kn(Br(Qt.INVALID_PARAMETER, new Error("You cannot specify a target element if insertDefaultUI is false"), Yt.INVALID_PARAMETER), xn);
                    return;
                  }
                  bn && bn.insertDefaultUI === !1 && (hn = bn, bn = void 0);
                  const vr = new xi(bn, (0, d.default)(hn || {}, {
                    stream: qt,
                    session: this,
                    // @todo this needs to go.
                    analytics: Et,
                    _singlePeerConnectionController: Xa
                  }), (Rr) => {
                    if (Rr) {
                      Kn(Rr, xn);
                      return;
                    }
                    xn(null, vr);
                  });
                  return Yr.subscribers.add(vr), vr;
                }, this.unsubscribe = function(qt) {
                  if (!qt) {
                    const bn = "OT.Session.unsubscribe: subscriber cannot be null";
                    throw Ga.error(bn), new Error(bn);
                  }
                  return qt.stream ? (Ga.debug(`OT.Session.unsubscribe: subscriber ${qt.id}`), qt._destroy({
                    reason: "Unsubscribe"
                  }), !0) : (Ga.warn("OT.Session.unsubscribe:: tried to unsubscribe a subscriber that had no stream"), !1);
                }, this.getSubscribersForStream = function(qt) {
                  return Yr.subscribers.where({
                    streamId: qt.id
                  });
                }, this.getPublisherForStream = function(qt) {
                  let bn, hn;
                  if (typeof qt == "string")
                    bn = qt;
                  else if (typeof qt == "object" && qt && Object.hasOwnProperty.call(qt, "id"))
                    bn = qt.id;
                  else
                    throw hn = "Session.getPublisherForStream :: Invalid stream type", Ga.error(hn), new Error(hn);
                  return Yr.publishers.where({
                    streamId: bn
                  })[0];
                }, this._ = {
                  getProxyUrl() {
                    return Vt;
                  },
                  isE2ee() {
                    return Hi.sessionInfo.e2ee && us && !!Hi.capabilities.supportsE2ee;
                  },
                  isSocketReconnecting() {
                    return ti;
                  },
                  getSocket() {
                    return gn;
                  },
                  reconnecting: function() {
                    ti = !0, this.dispatchEvent(new tn.SessionReconnectingEvent());
                  }.bind(this),
                  reconnected: function() {
                    ti = !1, this.dispatchEvent(new tn.SessionReconnectedEvent()), this.sessionInfo.reconnection && (Yr.publishers.where({
                      session: this
                    }).forEach((qt) => {
                      qt._.iceRestart();
                    }), this.sessionInfo.p2pEnabled || Yr.subscribers.where({
                      session: this
                    }).forEach((qt) => {
                      qt._.iceRestart("socket reconnected");
                    }));
                  }.bind(this),
                  // session.on("signal", function(SignalEvent))
                  // session.on("signal:{type}", function(SignalEvent))
                  dispatchSignal: function(qt, bn, hn) {
                    const xn = new tn.SignalEvent(bn, hn, qt);
                    xn.target = this, this.trigger(B.default.SIGNAL, xn), bn && this.dispatchEvent(xn);
                  }.bind(this),
                  dispatchCaption: function(qt, bn) {
                    let hn, xn, vr;
                    try {
                      const zi = JSON.parse(bn.data);
                      hn = zi.caption.text, xn = zi.streamId, vr = zi.isFinal;
                    } catch (zi) {
                      Ga.error(`Caption parsing failed: ${zi.message}`);
                      return;
                    }
                    const Rr = new tn.CaptionReceivedEvent(hn, xn, vr);
                    Rr.target = this, this.trigger(B.default.SUBSCRIBER_CAPTION_RECEIVED, Rr), this.dispatchEvent(Rr);
                  }.bind(this),
                  subscriberChannelUpdate(qt, bn, hn, xn) {
                    return gn ? gn.subscriberChannelUpdate(qt.id, bn.widgetId, hn.id, xn) : (Ga.warn("You are disconnected, cannot update subscriber properties ", xn), null);
                  },
                  streamCreate(qt, bn) {
                    let hn = qt === void 0 ? {} : qt, xn = hn.name, vr = hn.streamId, Rr = hn.subscriberAudioFallbackEnabled, zi = hn.channels, _i = hn.minBitrate, Ko = hn.sourceStreamId, ps = hn.e2ee, ho = hn.publisherAudioFallbackEnabled, Ya = hn.customProperties;
                    if (!gn) {
                      Ga.warn("You are disconnected, cannot create stream ", vr);
                      return;
                    }
                    gn.streamCreate({
                      name: xn,
                      streamId: vr,
                      subscriberAudioFallbackEnabled: Rr,
                      channels: zi,
                      minBitrate: _i,
                      maxBitrate: void 0,
                      // Do not expose maxBitrate to the end user,
                      sourceStreamId: Ko,
                      e2ee: ps,
                      publisherAudioFallbackEnabled: ho,
                      customProperties: Ya
                    }, bn);
                  },
                  streamDestroy(qt, bn) {
                    if (!gn) {
                      Ga.warn("You are disconnected, cannot destroy stream ", qt);
                      return;
                    }
                    gn.streamDestroy(qt, bn);
                  },
                  streamChannelUpdate(qt, bn, hn) {
                    if (!gn) {
                      Ga.warn("You are disconnected, cannot update stream properties ", hn);
                      return;
                    }
                    gn.streamChannelUpdate(qt.id, bn.id, hn);
                  },
                  // allow these variables to be overridden in unit tests
                  // it's dirty, but I figure it can be cleaned up when we implement proper DI for our unit tests
                  setSocket(qt) {
                    gn = qt;
                  },
                  setLogging(qt) {
                    Ga = qt;
                  },
                  setState: Wa,
                  setIceServers(qt) {
                    qt && (Qr = {
                      iceServers: se(qt),
                      timestamp: Date.now()
                    });
                  },
                  getOtIceServerInfo() {
                    const qt = Qr ? Date.now() - Qr.timestamp : 1 / 0, hn = 24 * 60 * 60 * 1e3 - qt, xn = 5 * 60 * 1e3;
                    if (hn > xn)
                      return n.resolve({
                        transportPolicy: Hi && Hi.sessionInfo && Hi.sessionInfo.clientCandidates,
                        servers: Qr && Qr.iceServers
                      });
                    if (!On)
                      return n.resolve({
                        transportPolicy: Hi && Hi.sessionInfo && Hi.sessionInfo.clientCandidates,
                        servers: [],
                        needRumorIceServersFallback: !0
                      });
                    const vr = Kr.clientVersion;
                    return Hn({
                      anvilUrl: (this.staticConfig || Kr).apiUrl,
                      sessionId: Yn,
                      token: On,
                      connectionId: Ea,
                      clientVersion: vr
                    }).then((Rr) => (Hi._.setIceServers(Rr.iceServers), Qr ? {
                      transportPolicy: Hi && Hi.sessionInfo && Hi.sessionInfo.clientCandidates,
                      servers: Qr && Qr.iceServers
                    } : {
                      transportPolicy: Hi.sessionInfo.clientCandidates,
                      servers: [],
                      needRumorIceServersFallback: !0
                    }));
                  },
                  getCodecFlags: () => ({
                    h264: Hi.sessionInfo.h264,
                    vp9: Hi.sessionInfo.vp9,
                    vp8: Hi.sessionInfo.vp8
                  }),
                  getVideoCodecsCompatible: (qt) => (0, J.default)({
                    RTCPeerConnection: cn.RTCPeerConnection,
                    env: $n.env,
                    stream: qt,
                    codecFlags: Hi._.getCodecFlags()
                  }),
                  getIceConfig: () => {
                    if (!Or)
                      return Hi._.getOtIceServerInfo();
                    const qt = Or && Or.transportPolicy === "relay" ? "relay" : Hi.sessionInfo.clientCandidates;
                    return (Or.includeServers === "custom" ? n.resolve({
                      servers: []
                    }) : Hi._.getOtIceServerInfo()).then((hn) => (0, d.default)(hn, {
                      transportPolicy: qt,
                      servers: [...hn.servers, ...Or.customServers]
                    }));
                  },
                  forceMute: function(qt) {
                    this.dispatchEvent(new tn.MuteForcedEvent(qt));
                  }.bind(this),
                  enableMuteOnEntry: () => {
                    No = !0;
                  },
                  addSubscriberToPeerConnectionsQueue: (qt, bn) => {
                    Ba.push({
                      pc: qt,
                      message: bn
                    }), Ra || (Ra = setInterval(() => {
                      const hn = Ba.shift();
                      hn ? hn.pc.processMessage("offer", hn.message) : (clearInterval(Ra), Ra = null);
                    }, 100));
                  },
                  disableMuteOnEntry: () => {
                    No = !1;
                  },
                  privateEvents: new c.default()
                }, this.signal = function(qt, bn) {
                  let hn = qt, xn = bn || function() {
                  };
                  if ((0, h.default)(hn) && (xn = hn, hn = null), this.isNot("connected")) {
                    const Rr = "Unable to send signal - you are not connected to the session.";
                    Kn(Br(Qt.NOT_CONNECTED, new Error(Rr), 500), xn);
                    return;
                  }
                  function vr(Rr) {
                    switch (Rr) {
                      case 400:
                      case 413:
                        return Qt.INVALID_PARAMETER;
                      case 429:
                        return Qt.RATE_LIMIT_EXCEEDED;
                      case 404:
                        return Qt.NOT_FOUND;
                      case 500:
                        return Qt.NOT_CONNECTED;
                      case 403:
                        return Qt.PERMISSION_DENIED;
                      case 2001:
                        return Qt.UNEXPECTED_SERVER_RESPONSE;
                      default:
                        return;
                    }
                  }
                  gn.signal(hn, function(Rr) {
                    if (Rr) {
                      const ps = vr(Rr.code);
                      ps && (Rr = Br(ps, new Error(Rr.message), Rr.code)), xn(Rr);
                      return;
                    }
                    for (var zi = arguments.length, _i = new Array(zi > 1 ? zi - 1 : 0), Ko = 1; Ko < zi; Ko++)
                      _i[Ko - 1] = arguments[Ko];
                    xn(Rr, ..._i);
                  }, this.logEvent), qt && qt.data && typeof qt.data != "string" && Ga.warn("Signaling of anything other than Strings is deprecated. Please update the data property to be a string.");
                }, this.forceDisconnect = function(qt, bn) {
                  if (this.isNot("connected")) {
                    const Rr = "Cannot call forceDisconnect(). You are not connected to the session.";
                    Kn(Br(Qt.NOT_CONNECTED, new Error(Rr), Yt.NOT_CONNECTED), bn);
                    return;
                  }
                  const hn = typeof qt == "string" ? qt : qt.id, xn = "Invalid Parameter. Check that you have passed valid parameter values into the method call.";
                  if (!hn) {
                    Kn(Br(Qt.INVALID_PARAMETER, new Error(xn), Yt.INVALID_PARAMETER), bn);
                    return;
                  }
                  const vr = "This token does not allow forceDisconnect. The role must be at least `moderator` to enable this functionality";
                  if (!Xn("forceDisconnect")) {
                    Kn(Br(Qt.PERMISSION_DENIED, new Error(vr), Yt.UNABLE_TO_FORCE_DISCONNECT), bn);
                    return;
                  }
                  gn.forceDisconnect(hn, function(Rr) {
                    if (Rr)
                      Kn(Br(Qt.INVALID_PARAMETER, new Error(xn), Yt.INVALID_PARAMETER), bn);
                    else if (bn && (0, h.default)(bn)) {
                      for (var zi = arguments.length, _i = new Array(zi > 1 ? zi - 1 : 0), Ko = 1; Ko < zi; Ko++)
                        _i[Ko - 1] = arguments[Ko];
                      bn(Rr, ..._i);
                    }
                  });
                }, this.forceUnpublish = function(qt, bn) {
                  bn === void 0 && (bn = () => {
                  });
                  const hn = (ps) => Kn(Br(ps.name, new Error(ps.msg), ps.code), bn), xn = {
                    msg: "Invalid Parameter. Check that you have passed valid parameter values into the method call.",
                    code: Yt.INVALID_PARAMETER,
                    name: Qt.INVALID_PARAMETER
                  }, vr = {
                    msg: "Cannot call forceUnpublish(). You are not connected to the session.",
                    code: Yt.NOT_CONNECTED,
                    name: Qt.NOT_CONNECTED
                  }, Rr = {
                    msg: "This token does not allow forceUnpublish. The role must be at least `moderator` to enable this functionality",
                    code: Yt.UNABLE_TO_FORCE_UNPUBLISH,
                    name: Qt.PERMISSION_DENIED
                  }, zi = {
                    msg: "The stream does not exist.",
                    name: Qt.NOT_FOUND
                  }, _i = {
                    msg: "An unexpected error occurred.",
                    name: Qt.UNEXPECTED_SERVER_RESPONSE,
                    code: Yt.UNEXPECTED_SERVER_RESPONSE
                  };
                  if (!qt) {
                    hn(xn);
                    return;
                  }
                  if (mr.isNot("connected")) {
                    hn(vr);
                    return;
                  }
                  const Ko = Qn(qt);
                  if (!Xn("forceUnpublish")) {
                    hn(Rr);
                    return;
                  }
                  gn.forceUnpublish(Ko.id, (ps) => {
                    if (!ps) {
                      bn(null);
                      return;
                    }
                    ps.code === "404" ? hn(zi) : ps.code === "403" ? hn(Rr) : hn(_i);
                  });
                }, this.forceMuteStream = (qt) => new n((bn, hn) => {
                  const xn = hi();
                  if (xn) {
                    hn(xn);
                    return;
                  }
                  if (!qt || !qt.id) {
                    hn(pr(de.default.INVALID_PARAMETER));
                    return;
                  }
                  gn.forceMuteStream(qt.id, (vr) => {
                    vr ? hn(Qi(vr)) : bn();
                  });
                }), this.forceMuteAll = (qt) => new n((bn, hn) => {
                  const xn = hi();
                  if (xn) {
                    hn(xn);
                    return;
                  }
                  if (Array.isArray(qt) && !qt.every((Rr) => Rr instanceof vn) || qt && !Array.isArray(qt)) {
                    hn(pr(de.default.INVALID_PARAMETER));
                    return;
                  }
                  const vr = (qt || []).map((Rr) => Rr.id);
                  gn.forceMuteAll(vr, !0, (Rr) => {
                    Rr ? hn(Qi(Rr)) : bn();
                  });
                }), this.disableForceMute = () => new n((qt, bn) => {
                  const hn = hi();
                  if (hn) {
                    bn(hn);
                    return;
                  }
                  gn.forceMuteAll([], !1, (xn) => {
                    xn ? bn(Qi(xn)) : qt();
                  });
                }), this.setEncryptionSecret = /* @__PURE__ */ function() {
                  var qt = (0, l.default)(/* @__PURE__ */ o.default.mark(function bn(hn) {
                    return o.default.wrap(function(vr) {
                      for (; ; ) switch (vr.prev = vr.next) {
                        case 0:
                          if (Va) {
                            vr.next = 3;
                            break;
                          }
                          return lr.error("Encryption secret must first be set in initSession."), vr.abrupt("return");
                        case 3:
                          vr.prev = 3, (0, fe.default)(hn), vr.next = 10;
                          break;
                        case 7:
                          throw vr.prev = 7, vr.t0 = vr.catch(3), Br(Qt.INVALID_ENCRYPTION_SECRET, new Error(`setEncryptionSecret: ${vr.t0.message}`));
                        case 10:
                          return vr.prev = 10, vr.next = 13, mr.keyStore.set(Yn, hn);
                        case 13:
                          Va = hn, vr.next = 19;
                          break;
                        case 16:
                          vr.prev = 16, vr.t1 = vr.catch(10), Ga.error(`Error in setEncryptionSecret}: ${vr.t1.message}`);
                        case 19:
                        case "end":
                          return vr.stop();
                      }
                    }, bn, null, [[3, 7], [10, 16]]);
                  }));
                  return function(bn) {
                    return qt.apply(this, arguments);
                  };
                }(), this.isConnected = () => this.is("connected"), this.capabilities = new Ge([], {
                  hasE2eeCapability: er
                });
              };
            }
          }).call(this, e(2));
        },
        /* 339 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(52));
          const l = o.default.once;
          var c = () => l() && (t.default.isChromiumEdge || ["Chrome", "Safari", "Firefox", "Opera"].includes(t.default.name));
          r.default = c;
        },
        /* 340 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = d;
          var t = n(e(10)), o = n(e(22));
          const l = [400, 403, 409, t.default.CONNECTION_LIMIT_EXCEEDED], c = {
            CONNECT: "ConnectToSession",
            SESSION_STATE: "GetSessionState"
          };
          function d(u) {
            let h, A;
            if (u.reason === c.CONNECT && u.code === t.default.CONNECT_FAILED)
              h = u.code, A = o.default.getTitleByCode(u.code);
            else if (u.code && l.indexOf(Number(u.code)) > -1)
              switch (h = t.default.CONNECT_FAILED, u.reason) {
                case c.CONNECT:
                  switch (u.code) {
                    case t.default.CONNECTION_LIMIT_EXCEEDED:
                      h = u.code, A = "Cannot connect -- the limit for concurrent connections to the session has been reached";
                      break;
                    default:
                      A = "Received error response to connection create message.";
                      break;
                  }
                  break;
                case c.SESSION_STATE:
                  A = "Received error response to session read";
                  break;
                default:
                  A = "";
                  break;
              }
            else
              h = t.default.UNEXPECTED_SERVER_RESPONSE, A = "Unexpected server response. Try this operation again later.";
            return {
              code: h,
              message: A
            };
          }
        },
        /* 341 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            return JSON.stringify(t);
          }
        },
        /* 342 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            let o = t.logger, l = t.obj;
            t.eventNames.forEach((d) => {
              l.on(d, function() {
                for (var u = arguments.length, h = new Array(u), A = 0; A < u; A++)
                  h[A] = arguments[A];
                return o.spam("emitted", d, h);
              });
            });
          };
          r.default = n;
        },
        /* 343 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(17)), o = n(e(6)), l = n(e(1)), c = n(e(22)), d = n(e(183)), u = n(e(770));
          const h = (0, l.default)("Dispatcher"), A = function() {
            (0, o.default)(this), this.callbacks = {};
          };
          A.prototype.registerCallback = function(f, p) {
            this.callbacks[f] = p;
          }, A.prototype.triggerCallback = function(f) {
            if (!f)
              return;
            const p = this.callbacks[f];
            if (p && (0, t.default)(p)) {
              const v = Array.prototype.slice.call(arguments);
              v.shift(), p(...v);
            }
            delete this.callbacks[f];
          }, A.prototype.onClose = function(f) {
            this.emit("close", f);
          }, A.prototype.onReconnected = function() {
            this.emit("reconnected");
          }, A.prototype.onReconnecting = function() {
            this.emit("reconnecting");
          }, A.prototype.dispatch = function(f) {
            var p, v;
            if (f.type === d.default.STATUS) {
              var b;
              h.debug(f);
              let y;
              if (f.isError) {
                let B;
                if (typeof f.data == "string")
                  try {
                    const Q = JSON.parse(f.data);
                    Q && typeof Q == "object" && (B = Q.reason);
                  } catch (Q) {
                    h.warn("Failed to parse rumorMessage.data", Q);
                  }
                y = new c.default(f.status, B);
              }
              const U = f.data ? JSON.parse(f.data) : "";
              U != null && (b = U.mute) != null && b.active && this.dispatchMuteOnEntry(), this.triggerCallback(f.transactionId, y, f);
              return;
            }
            const m = (0, u.default)(f);
            switch (m.resource === "data" ? h.spam(`${m.signature}:`, m) : h.debug(`${m.signature}:`, m), m.resource) {
              case "session":
                this.dispatchSession(m);
                break;
              case "connection":
                if (m != null && (p = m.content) != null && (v = p.userAgent) != null && v.includes("auriga"))
                  return;
                this.dispatchConnection(m);
                break;
              case "stream":
                this.dispatchStream(m);
                break;
              case "stream_channel":
                this.dispatchStreamChannel(m);
                break;
              case "subscriber":
                this.dispatchSubscriber(m);
                break;
              case "subscriber_channel":
                this.dispatchSubscriberChannel(m);
                break;
              case "signal":
                this.dispatchSignal(m);
                break;
              case "data":
                m.params.channel === "caption1" ? this.dispatchCaption(m) : m.params.channel === "downlinkStats1" && this.dispatchSenderStats(m);
                break;
              case "archive":
                this.dispatchArchive(m);
                break;
              case "source":
                this.dispatchSource(m);
                break;
              default:
                h.debug(`Type ${m.resource} is not currently implemented`);
            }
          }, A.prototype.dispatchSession = function(f) {
            switch (f.method) {
              case "read":
                this.emit("session#read", f.content, f.transactionId);
                break;
              case "update":
                this.emit("session#update", f.content);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          }, A.prototype.dispatchMuteOnEntry = function() {
            this.emit("session#muted");
          }, A.prototype.dispatchConnection = function(f) {
            switch (f.method) {
              case "created":
                this.emit("connection#created", f.content);
                break;
              case "deleted":
                this.emit("connection#deleted", f.params.connection, f.reason);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          }, A.prototype.dispatchStream = function(f) {
            switch (f.method) {
              case "created":
                this.emit("stream#created", f.content, f.transactionId);
                break;
              case "deleted":
                this.emit("stream#deleted", f.params.stream, f.reason, f.content);
                break;
              case "updated":
                this.emit("stream#updated", f.params.stream, f.content);
                break;
              case "update":
                this.emit("stream#update", f.params.stream, f.content);
                break;
              case "generateoffer":
              case "answer":
              case "pranswer":
              case "offer":
              case "candidate":
                this.dispatchJsep(f.method, f);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          }, A.prototype.dispatchStreamChannel = function(f) {
            switch (f.method) {
              case "updated":
                this.emit("streamChannel#updated", f.params.stream, f.params.channel, f.content);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          }, A.prototype.dispatchJsep = function(f, p) {
            this.emit(`jsep#${f}`, p.params.stream, p.fromAddress, p);
          }, A.prototype.dispatchSubscriberChannel = function(f) {
            switch (f.method) {
              case "updated":
                this.emit("subscriberChannel#updated", f.params.stream, f.params.channel, f.content);
                break;
              case "update":
                this.emit("subscriberChannel#update", f.params.subscriber, f.params.stream, f.content);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          }, A.prototype.dispatchSubscriber = function(f) {
            switch (f.method) {
              case "created":
                this.emit("subscriber#created", f.params.stream, f.fromAddress, f.content.id);
                break;
              case "deleted":
                this.dispatchJsep("unsubscribe", f), this.emit("subscriber#deleted", f.params.stream, f.fromAddress);
                break;
              case "generateoffer":
              case "answer":
              case "pranswer":
              case "offer":
              case "candidate":
                this.dispatchJsep(f.method, f);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          }, A.prototype.dispatchSignal = function(f) {
            if (f.method !== "signal") {
              h.debug(`${f.signature} is not currently implemented`);
              return;
            }
            this.emit("signal", f.fromAddress, f.content);
          }, A.prototype.dispatchCaption = function(f) {
            this.emit("caption", f.fromAddress, f.content);
          }, A.prototype.dispatchSenderStats = function(f) {
            this.emit("senderStatsReceived", f.params.subscriber, f.content);
          }, A.prototype.dispatchArchive = function(f) {
            switch (f.method) {
              case "created":
                this.emit("archive#created", f.content);
                break;
              case "updated":
                this.emit("archive#updated", f.params.archive, f.content);
                break;
            }
          }, A.prototype.dispatchSource = function(f) {
            switch (f.method) {
              case "create":
                this.emit("source#create", f.params.source, f.params.stream, f.reason);
                break;
              case "delete":
                this.emit("source#delete", f.params.source, f.params.stream, f.reason);
                break;
              default:
                h.debug(`${f.signature} is not currently implemented`);
            }
          };
          var g = A;
          r.default = g;
        },
        /* 344 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(16)), o = n(e(772)), l = n(e(773)), c = n(e(7)), d = n(e(774)), u = n(e(341)), h = n(e(37));
          const A = (0, h.default)().onlyLocal(), g = {};
          g.connections = {}, g.connections.create = function(p) {
            const v = p.apiKey, b = p.sessionId, m = p.connectionId, y = p.connectionEventsSuppressed, U = p.capabilities;
            return (0, u.default)({
              method: "create",
              uri: `/v2/partner/${v}/session/${b}/connection/${m}`,
              content: {
                userAgent: c.default.env.userAgent,
                clientVersion: A.clientVersion,
                capabilities: U || [],
                connectionEventsSuppressed: y
              }
            });
          }, g.connections.destroy = function(p) {
            const v = p.apiKey, b = p.sessionId, m = p.connectionId;
            return (0, u.default)({
              method: "delete",
              uri: `/v2/partner/${v}/session/${b}/connection/${m}`,
              content: {}
            });
          }, g.sessions = {}, g.sessions.get = function(p, v) {
            return (0, u.default)({
              method: "read",
              uri: `/v2/partner/${p}/session/${v}`,
              content: {}
            });
          }, g.streams = {}, g.streams.get = function(p, v, b) {
            return (0, u.default)({
              method: "read",
              uri: `/v2/partner/${p}/session/${v}/stream/${b}`,
              content: {}
            });
          }, g.streams.channelFromOTChannel = function(p) {
            const v = {
              id: p.id,
              type: p.type,
              active: p.active
            };
            return p.type === "video" && (v.width = p.width, v.height = p.height, v.orientation = p.orientation, v.frameRate = p.frameRate, p.source !== "default" && (v.source = p.source), v.fitMode = p.fitMode), v;
          }, g.streams.create = function(p) {
            p === void 0 && (p = {});
            const v = p, b = v.apiKey, m = v.sessionId, y = v.streamId, U = v.name, B = v.audioFallbackEnabled, Q = v.publisherAudioFallbackEnabled, N = v.subscriberAudioFallbackEnabled, J = v.channels, w = v.minBitrate, W = v.maxBitrate, G = v.sourceStreamId, Z = v.e2ee, K = v.customProperties, L = {
              id: y,
              name: U,
              audioFallbackEnabled: B,
              publisherAudioFallbackEnabled: Q,
              subscriberAudioFallbackEnabled: N,
              channel: J.map((O) => g.streams.channelFromOTChannel(O)),
              e2ee: Z,
              customProperties: K
            };
            return w && (L.minBitrate = Math.round(w)), W && (L.maxBitrate = Math.round(W)), G && (L.sourceStreamId = G), typeof Z == "boolean" && (L.e2ee = Z), (0, u.default)({
              method: "create",
              uri: `/v2/partner/${b}/session/${m}/stream/${y}`,
              content: L
            });
          }, g.streams.destroy = function(p, v, b, m) {
            const y = {};
            return m && (y.sourceStreamId = m), (0, u.default)({
              method: "delete",
              uri: `/v2/partner/${p}/session/${v}/stream/${b}`,
              content: y
            });
          }, g.streamChannels = {}, g.streamChannels.update = function(p, v, b, m, y) {
            return (0, u.default)({
              method: "update",
              uri: `/v2/partner/${p}/session/${v}/stream/${b}/channel/${m}`,
              content: y
            });
          }, g.subscribers = {}, g.subscribers.create = function(p) {
            p === void 0 && (p = {});
            const v = p, b = v.apiKey, m = v.sessionId, y = v.streamId, U = v.subscriberId, B = v.connectionId, Q = v.channelsToSubscribeTo, N = v.sourceStreamId, J = v.e2ee, w = {
              id: U,
              connection: B,
              keyManagementMethod: o.default,
              bundleSupport: (0, d.default)(),
              rtcpMuxSupport: (0, l.default)(),
              e2ee: J
            };
            return Q && (w.channel = Q), N && (w.sourceStreamId = N), (0, u.default)({
              method: "create",
              uri: `/v2/partner/${b}/session/${m}/stream/${y}/subscriber/${U}`,
              content: w
            });
          }, g.subscribers.destroy = function(p, v, b, m, y) {
            const U = {};
            return y && (U.sourceStreamId = y), (0, u.default)({
              method: "delete",
              uri: `/v2/partner/${p}/session/${v}/stream/${b}/subscriber/${m}`,
              content: U
            });
          }, g.subscribers.update = function(p, v, b, m, y) {
            return (0, u.default)({
              method: "update",
              uri: `/v2/partner/${p}/session/${v}/stream/${b}/subscriber/${m}`,
              content: y
            });
          }, g.subscriberChannels = {}, g.subscriberChannels.update = function(p, v, b, m, y, U) {
            return (0, u.default)({
              method: "update",
              uri: `/v2/partner/${p}/session/${v}/stream/${b}/subscriber/${m}/channel/${y}`,
              content: U
            });
          }, g.signals = {}, g.signals.create = function(p, v, b, m, y) {
            const U = {};
            return m !== void 0 && (U.type = m), y !== void 0 && (U.data = y), (0, u.default)({
              method: "signal",
              uri: `/v2/partner/${p}/session/${v}${b !== void 0 ? `/connection/${b}` : ""}/signal/${(0, t.default)()}`,
              content: U
            });
          }, g.forceMute = {}, g.forceMute.update = (p) => {
            const v = p.apiKey, b = p.sessionId, m = p.streamId, y = p.active, U = p.excludedStreamIds, B = {
              reason: "mute",
              channels: ["audio"],
              active: y,
              locked: !1
            };
            return U && (B.exclusion = U), (0, u.default)({
              method: "update",
              uri: `/v2/partner/${v}/session/${b}${m ? `/stream/${m}` : ""}`,
              content: B
            });
          };
          var f = g;
          r.default = f;
        },
        /* 345 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = A;
          var t = n(e(42)), o = n(e(72)), l = n(e(184)), c = n(e(344)), d = n(e(346));
          const u = 8192, h = 128;
          function A(g, f, p) {
            const v = function(Q) {
              return !/^[a-zA-Z0-9\-\._~]+$/.exec(Q);
            }, b = function(Q) {
              return Q ? Q instanceof l.default || Q._tag === d.default ? null : {
                code: 400,
                reason: "The To field was invalid"
              } : {
                code: 400,
                reason: "The signal to field was invalid. Either set it to a OT.Connection, OT.Session, or omit it entirely"
              };
            }, m = function(Q) {
              let N = null;
              return Q == null ? N = {
                code: 400,
                reason: "The signal type was null or undefined. Either set it to a String value or omit it"
              } : Q.length > h ? N = {
                code: 413,
                reason: `The signal type was too long, the maximum length of it is ${h} characters`
              } : v(Q) && (N = {
                code: 400,
                reason: "The signal type was invalid, it can only contain letters, numbers, '-', '_', and '~'."
              }), N;
            }, y = function(Q) {
              let N = null;
              if (Q == null)
                N = {
                  code: 400,
                  reason: "The signal data was null or undefined. Either set it to a String value or omit it"
                };
              else
                try {
                  JSON.stringify(Q).length > u && (N = {
                    code: 413,
                    reason: `The data field was too long, the maximum size of it is ${u} characters`
                  });
                } catch {
                  N = {
                    code: 400,
                    reason: "The data field was not valid JSON"
                  };
                }
              return N;
            }, U = function(Q) {
              let N = null;
              return Q === !0 || Q === !1 || (N = {
                code: 400,
                reason: "The signal retryAfterReconnect was not true or false. Either set it to a Boolean value or omit it"
              }), N;
            };
            this.toRaptorMessage = function() {
              let B = this.to;
              return B && typeof B != "string" && (B = B.id), c.default.signals.create(o.default.value, g, B, this.type, this.data);
            }, this.toHash = function() {
              return p;
            }, this.error = null, this.retryAfterReconnect = !0, p && (p.hasOwnProperty("data") && (this.data = (0, t.default)(p.data), this.error = y(this.data)), p.hasOwnProperty("to") && (this.to = p.to, this.error || (this.error = b(this.to))), p.hasOwnProperty("type") && (this.error || (this.error = m(p.type)), this.type = p.type), p.hasOwnProperty("retryAfterReconnect") && (this.error || (this.error = U(p.retryAfterReconnect)), this.retryAfterReconnect = p.retryAfterReconnect)), this.valid = this.error === null;
          }
        },
        /* 346 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {};
          r.default = n;
        },
        /* 347 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = w;
          var t = n(e(4)), o = n(e(5)), l = n(e(1)), c = n(e(24)), d = n(e(348)), u = n(e(50)), h = n(e(184)), A = n(e(777)), g = n(e(343)), f = n(e(182)), p = n(e(157)), v = n(e(176));
          const b = (0, l.default)("SessionDispatcher");
          function m(W) {
            return {
              id: W,
              creationTime: (/* @__PURE__ */ new Date()).getTime(),
              data: {},
              capablities: {},
              permissions: []
            };
          }
          function y(W, G) {
            const Z = W.channel.map((L) => new p.default(L)), K = W.connectionId ? W.connectionId : W.connection.id;
            return new f.default(W.id, W.name, W.creationTime, G.connections.get(K), G, Z, W.customProperties && W.customProperties.initials);
          }
          function U(W, G) {
            if (G.streams.has(W.id))
              return;
            const Z = y(W, G);
            return G.streams.add(Z), Z;
          }
          function B(W) {
            return new d.default(W.id, W.name, W.status);
          }
          function Q(W, G) {
            if (G.archives.has(W.id))
              return;
            const Z = B(W);
            return G.archives.add(Z), Z;
          }
          const N = function(G) {
            const Z = {};
            this.enqueue = function() {
              const L = arguments[0], O = Array.prototype.slice.call(arguments, 1);
              Z[L] || (Z[L] = new A.default(G)), Z[L].enqueue.apply(Z[L], O);
            }, this.triggerConnectionCreated = function(L) {
              Z[`connectionCreated${L.id}`] && Z[`connectionCreated${L.id}`].triggerAll();
            }, this.triggerSessionConnected = function(L) {
              Z.sessionConnected && Z.sessionConnected.triggerAll(), L.forEach(function(O) {
                this.triggerConnectionCreated(O);
              }, this);
            };
          }, J = {};
          function w(W, G) {
            let Z = G === void 0 ? {} : G, K = Z.connectionEventsSuppressed;
            const L = new g.default();
            let O = !1;
            const de = new N(L);
            L.on("reconnecting", () => {
              W._.reconnecting();
            }), L.on("reconnected", () => {
              W._.reconnected();
            }), L.on("close", (ge) => {
              const we = W.connection;
              if (we) {
                if (we.destroyedReason()) {
                  b.debug(`Socket was closed but the connection had already been destroyed. Reason: ${we.destroyedReason()}`);
                  return;
                }
                we.destroy(ge);
              }
            });
            const oe = function(we, _e) {
              return W.connections.has(we.id) ? W.connections.get(we.id) : (we = h.default.fromHash(we), (_e || W.connection && we.id !== W.connection.id) && (W.connections.add(we), de.triggerConnectionCreated(we)), Object.keys(J).forEach((Te) => {
                const Pe = J[Te];
                if (Pe && we.id === Pe.connection.id) {
                  U(Pe, W), delete J[Pe.id];
                  const $e = {
                    debug: _e ? "connection came in session#read" : "connection came in connection#created",
                    streamId: Pe.id,
                    connectionId: we.id
                  };
                  W.logEvent("streamCreated", "warning", $e);
                }
              }), we);
            };
            L.on("session#read", (ge, we) => {
              let _e;
              const Te = {};
              Te.streams = [], Te.connections = [], Te.archives = [], ge.connection.forEach((Pe) => {
                _e = oe(Pe, !0), Te.connections.push(_e);
              }), ge.stream.forEach((Pe) => {
                Te.streams.push(U(Pe, W));
              }), (ge.archive || ge.archives).forEach((Pe) => {
                Te.archives.push(Q(Pe, W));
              }), L.triggerCallback(we, null, Te), O = !0, de.triggerSessionConnected(W.connections);
            }), L.on("session#update", (ge) => {
              if (ge.reason !== "mute") {
                b.debug("session#update that handle this reason is not currently implemented");
                return;
              }
              const we = ge.active === !0;
              W._.forceMute({
                active: we
              }), we ? W._.enableMuteOnEntry() : W._.disableMuteOnEntry();
            }), L.on("session#muted", () => {
              W._.enableMuteOnEntry(), W._.forceMute({
                active: !0
              });
            }), L.on("connection#created", (ge) => {
              oe(ge);
            }), L.on("connection#deleted", (ge, we) => {
              if (ge = W.connections.get(ge), !ge) {
                b.warn("A connection was deleted that we do not know about");
                return;
              }
              ge.destroy(we);
            }), L.on("stream#created", (ge, we) => {
              const _e = ge.id, Te = ge.sourceStreamId, Pe = ge.connection;
              let $e;
              if (K) {
                if (Pe == null || Pe.id == null) {
                  W.logEvent("SessionDispatcher:stream#created", "Event", {
                    connection: Pe,
                    info: "Stream did not contain a connection object. Event ignored"
                  });
                  return;
                }
                oe(Pe);
              }
              const Bt = ge.connectionId || Pe.id;
              if (W.connections.has(Bt))
                $e = U(ge, W);
              else {
                J[_e] = ge;
                const Le = {
                  debug: "eventOrderError -- streamCreated event before connectionCreated",
                  streamId: _e,
                  sourceStreamId: (0, v.default)(Te)
                };
                W.logEvent("streamCreated", "warning", Le);
              }
              $e ? ($e.publisher && $e.publisher.setStream($e), L.triggerCallback(we, null, $e)) : W.sessionInfo.isAdaptiveEnabled && Te === "P2P" && c.default.subscribers.where({
                streamId: _e
              }).forEach((Le) => {
                Le._.startRoutedToRelayedTransition();
              });
            }), L.on("stream#deleted", (ge, we, _e) => {
              const Te = W.streams.get(ge), Pe = _e.sourceStreamId, $e = c.default.subscribers, Le = W.sessionInfo.isAdaptiveEnabled && Pe === "P2P";
              !Te && !Le || (Le ? $e.where({
                streamId: ge
              }).forEach((at) => {
                at._.startRelayedToRoutedTransition();
              }) : Te.destroy(we));
            }), L.on("stream#updated", (ge, we) => {
              const _e = W.streams.get(ge);
              if (!_e) {
                b.error(`A stream does not exist with the id of ${ge}, for stream#updated message!`);
                return;
              }
              _e._.update(we);
            }), L.on("stream#update", (ge, we) => {
              const _e = W.streams.get(ge), Te = we.reason, Pe = we.active;
              if (!_e) {
                b.error(`A stream does not exist with the id of ${ge}, for stream#updated message!`);
                return;
              }
              if (Te !== "mute") {
                b.debug("stream#update that handle this reason is not currently implemented");
                return;
              }
              Pe && _e._.forceMute(we);
            }), L.on("streamChannel#updated", (ge, we, _e) => {
              let Te;
              if (!(W.sessionInfo.isAdaptiveEnabled && _e.sourceStreamId === "P2P")) {
                if (!(ge && (Te = W.streams.get(ge)))) {
                  b.error("Unable to determine streamId, or the stream does not exist, for streamChannel message!");
                  return;
                }
                Te._.updateChannel(we, _e);
              }
            });
            const fe = (ge, we, _e, Te) => {
              let Pe, $e;
              const Bt = {
                streamId: we
              }, Le = c.default.subscribers, at = c.default.publishers;
              switch (Te.params.subscriber ? Pe = {
                widgetId: Te.params.subscriber
              } : Pe = Bt, ge) {
                case "offer":
                  $e = [].concat(Le.where(Pe), at.where(Bt)).slice(0, 1);
                  break;
                case "answer":
                case "pranswer":
                  $e = [].concat(at.where(Bt), Le.where(Pe)).slice(0, 1);
                  break;
                case "generateoffer":
                case "unsubscribe":
                  $e = at.where(Bt);
                  break;
                case "candidate":
                  $e = [].concat(Le.where(Pe), at.where(Bt));
                  break;
                default:
                  b.debug(`jsep#${ge} is not currently implemented`);
                  return;
              }
              if ($e.length === 0)
                return;
              let pt = W.connections.get(_e);
              !pt && _e.match(/^symphony\./) && (pt = h.default.fromHash({
                id: _e,
                creationTime: Math.floor((0, u.default)())
              }), W.connections.add(pt)), $e.forEach(/* @__PURE__ */ function() {
                var kt = (0, o.default)(/* @__PURE__ */ t.default.mark(function _t(Lt) {
                  return t.default.wrap(function(Zt) {
                    for (; ; ) switch (Zt.prev = Zt.next) {
                      case 0:
                        return Zt.prev = 0, Zt.next = 3, Lt.processMessage(ge, _e, Te);
                      case 3:
                        Zt.next = 8;
                        break;
                      case 5:
                        Zt.prev = 5, Zt.t0 = Zt.catch(0), b.error("Error occurred during processMessage", Zt.t0);
                      case 8:
                      case "end":
                        return Zt.stop();
                    }
                  }, _t, null, [[0, 5]]);
                }));
                return function(_t) {
                  return kt.apply(this, arguments);
                };
              }());
            };
            return L.on("jsep#offer", fe.bind(null, "offer")), L.on("jsep#answer", fe.bind(null, "answer")), L.on("jsep#pranswer", fe.bind(null, "pranswer")), L.on("jsep#generateoffer", fe.bind(null, "generateoffer")), L.on("jsep#unsubscribe", fe.bind(null, "unsubscribe")), L.on("jsep#candidate", fe.bind(null, "candidate")), L.on("subscriberChannel#updated", (ge, we, _e) => {
              if (!ge || !W.streams.has(ge)) {
                b.error("Unable to determine streamId, or the stream does not exist, for subscriberChannel#updated message!");
                return;
              }
              W.streams.get(ge)._.updateChannel(we, _e);
            }), L.on("subscriberChannel#update", (ge, we, _e) => {
              if (!we || !W.streams.has(we)) {
                b.error("Unable to determine streamId, or the stream does not exist, for subscriberChannel#update message!");
                return;
              }
              if (!c.default.subscribers.has(ge)) {
                b.error("Unable to determine subscriberId, or the subscriber does not exist, for subscriberChannel#update message!");
                return;
              }
              c.default.subscribers.get(ge).disableVideo(_e.active);
            }), L.on("signal", (ge, we) => {
              if (K) {
                let $e = we.connection || we.fromConnection;
                ($e == null || $e.id == null) && ($e = m(ge), W.logEvent("SessionDispatcher:Signal", "Event", {
                  fromAddress: ge,
                  connection: we.connection,
                  fromConnection: we.fromConnection,
                  info: "Signal did not contain a connection object. One has been constructed",
                  constructedConnection: $e
                })), oe($e);
              }
              const _e = we.type, Te = we.data, Pe = W.connections.get(ge);
              W.connection && ge === W.connection.connectionId ? O ? W._.dispatchSignal(Pe, _e, Te) : de.enqueue("sessionConnected", "signal", ge, _e, Te) : W.connections.get(ge) ? W._.dispatchSignal(Pe, _e, Te) : ge === "" ? W._.dispatchSignal(null, _e, Te) : de.enqueue(`connectionCreated${ge}`, "signal", ge, _e, Te);
            }), L.on("caption", (ge, we) => {
              W._.dispatchCaption(ge, we);
            }), L.on("senderStatsReceived", (ge, we) => {
              var _e;
              (_e = c.default.subscribers.get(ge)) == null || _e._onSenderStatsReceived(we);
            }), L.on("archive#created", (ge) => {
              Q(ge, W);
            }), L.on("archive#updated", (ge, we) => {
              const _e = W.archives.get(ge);
              if (!_e) {
                b.error(`An archive does not exist with the id of ${ge}, for archive#updated message!`);
                return;
              }
              _e._.update(we);
            }), L.on("source#create", (ge, we, _e) => {
              const Te = (0, v.default)(ge);
              W.logEvent("SessionDispatcher:source#create", "Event", {
                sourceStreamId: Te,
                streamId: we,
                reason: _e
              }), b.debug(`Received a request from RUMOR to start a transition to ${ge} for the stream ID ${we} with the reason: ${_e}`), c.default.publishers.where({
                streamId: we
              }).forEach((Pe) => {
                Pe._.startRoutedToRelayedTransition();
              });
            }), L.on("source#delete", (ge, we, _e) => {
              W.logEvent("SessionDispatcher:source#delete", "Event", {
                sourceStreamId: (0, v.default)(ge),
                streamId: we,
                reason: _e
              }), b.debug(`Received a request from RUMOR to start a transition from P2P to MANTIS for the stream ID ${we} with the reason: ${_e}`), c.default.publishers.where({
                streamId: we
              }).forEach((Te) => {
                Te._.startRelayedToRoutedTransition();
              });
            }), L;
          }
        },
        /* 348 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(6)), o = n(e(23));
          const l = (0, o.default)();
          function c(d, u, h) {
            this.id = d, this.name = u, this.status = h, this._ = {}, (0, t.default)(this), this._.update = (A) => {
              Object.keys(A).forEach((g) => {
                const f = this[g];
                this[g] = A[g];
                const p = new l.ArchiveUpdatedEvent(this, g, f, this[g]);
                this.dispatchEvent(p);
              });
            }, this.destroy = () => {
            };
          }
        },
        /* 349 */
        /***/
        function(i, r, e) {
          (function(n) {
            function t(d, u) {
              for (var h = 0, A = d.length - 1; A >= 0; A--) {
                var g = d[A];
                g === "." ? d.splice(A, 1) : g === ".." ? (d.splice(A, 1), h++) : h && (d.splice(A, 1), h--);
              }
              if (u)
                for (; h--; h)
                  d.unshift("..");
              return d;
            }
            r.resolve = function() {
              for (var d = "", u = !1, h = arguments.length - 1; h >= -1 && !u; h--) {
                var A = h >= 0 ? arguments[h] : n.cwd();
                if (typeof A != "string")
                  throw new TypeError("Arguments to path.resolve must be strings");
                if (!A)
                  continue;
                d = A + "/" + d, u = A.charAt(0) === "/";
              }
              return d = t(l(d.split("/"), function(g) {
                return !!g;
              }), !u).join("/"), (u ? "/" : "") + d || ".";
            }, r.normalize = function(d) {
              var u = r.isAbsolute(d), h = c(d, -1) === "/";
              return d = t(l(d.split("/"), function(A) {
                return !!A;
              }), !u).join("/"), !d && !u && (d = "."), d && h && (d += "/"), (u ? "/" : "") + d;
            }, r.isAbsolute = function(d) {
              return d.charAt(0) === "/";
            }, r.join = function() {
              var d = Array.prototype.slice.call(arguments, 0);
              return r.normalize(l(d, function(u, h) {
                if (typeof u != "string")
                  throw new TypeError("Arguments to path.join must be strings");
                return u;
              }).join("/"));
            }, r.relative = function(d, u) {
              d = r.resolve(d).substr(1), u = r.resolve(u).substr(1);
              function h(m) {
                for (var y = 0; y < m.length && m[y] === ""; y++)
                  ;
                for (var U = m.length - 1; U >= 0 && m[U] === ""; U--)
                  ;
                return y > U ? [] : m.slice(y, U - y + 1);
              }
              for (var A = h(d.split("/")), g = h(u.split("/")), f = Math.min(A.length, g.length), p = f, v = 0; v < f; v++)
                if (A[v] !== g[v]) {
                  p = v;
                  break;
                }
              for (var b = [], v = p; v < A.length; v++)
                b.push("..");
              return b = b.concat(g.slice(p)), b.join("/");
            }, r.sep = "/", r.delimiter = ":", r.dirname = function(d) {
              if (typeof d != "string" && (d = d + ""), d.length === 0) return ".";
              for (var u = d.charCodeAt(0), h = u === 47, A = -1, g = !0, f = d.length - 1; f >= 1; --f)
                if (u = d.charCodeAt(f), u === 47) {
                  if (!g) {
                    A = f;
                    break;
                  }
                } else
                  g = !1;
              return A === -1 ? h ? "/" : "." : h && A === 1 ? "/" : d.slice(0, A);
            };
            function o(d) {
              typeof d != "string" && (d = d + "");
              var u = 0, h = -1, A = !0, g;
              for (g = d.length - 1; g >= 0; --g)
                if (d.charCodeAt(g) === 47) {
                  if (!A) {
                    u = g + 1;
                    break;
                  }
                } else h === -1 && (A = !1, h = g + 1);
              return h === -1 ? "" : d.slice(u, h);
            }
            r.basename = function(d, u) {
              var h = o(d);
              return u && h.substr(-1 * u.length) === u && (h = h.substr(0, h.length - u.length)), h;
            }, r.extname = function(d) {
              typeof d != "string" && (d = d + "");
              for (var u = -1, h = 0, A = -1, g = !0, f = 0, p = d.length - 1; p >= 0; --p) {
                var v = d.charCodeAt(p);
                if (v === 47) {
                  if (!g) {
                    h = p + 1;
                    break;
                  }
                  continue;
                }
                A === -1 && (g = !1, A = p + 1), v === 46 ? u === -1 ? u = p : f !== 1 && (f = 1) : u !== -1 && (f = -1);
              }
              return u === -1 || A === -1 || // We saw a non-dot character immediately before the dot
              f === 0 || // The (right-most) trimmed path component is exactly '..'
              f === 1 && u === A - 1 && u === h + 1 ? "" : d.slice(u, A);
            };
            function l(d, u) {
              if (d.filter) return d.filter(u);
              for (var h = [], A = 0; A < d.length; A++)
                u(d[A], A, d) && h.push(d[A]);
              return h;
            }
            var c = "ab".substr(-1) === "b" ? function(d, u, h) {
              return d.substr(u, h);
            } : function(d, u, h) {
              return u < 0 && (u = d.length + u), d.substr(u, h);
            };
          }).call(this, e(27));
        },
        /* 350 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(21));
          const o = (0, t.default)(), l = o.getAudioOutputMediaDevices;
          var c = () => l();
          r.default = c;
        },
        /* 351 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(21));
          const o = (0, t.default)(), l = o.getActiveAudioOutputDevice;
          var c = () => l();
          r.default = c;
        },
        /* 352 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(104)), d = t(e(21)), u = t(e(252)), h = t(e(28)), A = t(e(24)), g = t(e(351));
            const f = c.default.setCurrentAudioOutputDeviceId, p = (0, d.default)(), v = p.getDefaultAudioOutputDeviceId, b = p.getAudioOutputMediaDevices, m = new h.default(), y = (w, W) => {
              m.logEvent({
                action: "updateSubscribersSinkId",
                variation: w,
                payload: W
              });
            }, U = (w) => {
              const W = A.default.subscribers.map((G) => G._.setSinkId(w));
              return n.all(W);
            }, B = /* @__PURE__ */ function() {
              var w = (0, l.default)(/* @__PURE__ */ o.default.mark(function W(G) {
                return o.default.wrap(function(K) {
                  for (; ; ) switch (K.prev = K.next) {
                    case 0:
                      return K.next = 2, (0, u.default)();
                    case 2:
                      return K.prev = 2, y("Attempt", {
                        deviceId: G
                      }), K.next = 6, U(G);
                    case 6:
                      y("Success", {
                        deviceId: G
                      }), K.next = 13;
                      break;
                    case 9:
                      throw K.prev = 9, K.t0 = K.catch(2), y("Failure", {
                        deviceId: G,
                        error: K.t0 == null ? void 0 : K.t0.message
                      }), K.t0;
                    case 13:
                    case "end":
                      return K.stop();
                  }
                }, W, null, [[2, 9]]);
              }));
              return function(G) {
                return w.apply(this, arguments);
              };
            }(), Q = /* @__PURE__ */ function() {
              var w = (0, l.default)(/* @__PURE__ */ o.default.mark(function W() {
                var G, Z;
                return o.default.wrap(function(L) {
                  for (; ; ) switch (L.prev = L.next) {
                    case 0:
                      return L.next = 2, b();
                    case 2:
                      return G = L.sent, Z = v(G), L.prev = 4, L.next = 7, B(Z);
                    case 7:
                      f(Z), L.next = 12;
                      break;
                    case 10:
                      L.prev = 10, L.t0 = L.catch(4);
                    case 12:
                    case "end":
                      return L.stop();
                  }
                }, W, null, [[4, 10]]);
              }));
              return function() {
                return w.apply(this, arguments);
              };
            }(), N = /* @__PURE__ */ function() {
              var w = (0, l.default)(/* @__PURE__ */ o.default.mark(function W() {
                var G;
                return o.default.wrap(function(K) {
                  for (; ; ) switch (K.prev = K.next) {
                    case 0:
                      return K.next = 2, (0, g.default)();
                    case 2:
                      return G = K.sent, K.prev = 3, K.next = 6, B(G.deviceId);
                    case 6:
                      K.next = 12;
                      break;
                    case 8:
                      return K.prev = 8, K.t0 = K.catch(3), K.next = 12, Q();
                    case 12:
                    case "end":
                      return K.stop();
                  }
                }, W, null, [[3, 8]]);
              }));
              return function() {
                return w.apply(this, arguments);
              };
            }();
            var J = /* @__PURE__ */ function() {
              var w = (0, l.default)(/* @__PURE__ */ o.default.mark(function W(G) {
                return o.default.wrap(function(K) {
                  for (; ; ) switch (K.prev = K.next) {
                    case 0:
                      return K.prev = 0, y("Attempt", {
                        deviceId: G
                      }), K.next = 4, U(G);
                    case 4:
                      y("Success", {
                        deviceId: G
                      }), f(G), K.next = 14;
                      break;
                    case 8:
                      return K.prev = 8, K.t0 = K.catch(0), y("Failure", {
                        deviceId: G,
                        error: K.t0 == null ? void 0 : K.t0.message
                      }), K.next = 13, N();
                    case 13:
                      throw K.t0;
                    case 14:
                    case "end":
                      return K.stop();
                  }
                }, W, null, [[0, 8]]);
              }));
              return function(W) {
                return w.apply(this, arguments);
              };
            }();
            r.default = J;
          }).call(this, e(2));
        },
        /* 353 */
        /***/
        function(i, r, e) {
          var n = e(0), t = n(e(42)), o = n(e(203)), l = n(e(6)), c = n(e(1)), d = n(e(127)), u = n(e(21)), h = n(e(141)), A = n(e(268)), g = n(e(142)), f = n(e(73)), p = n(e(10)), v = n(e(22)), b = n(e(253)), m = n(e(106)), y = n(e(150)), U = n(e(31)), B = n(e(144)), Q = n(e(37)), N = n(e(28)), J = n(e(257)), w = n(e(572)), W = n(e(573)), G = n(e(574)), Z = n(e(24)), K = n(e(13)), L = n(e(8)), O = n(e(151)), de = n(e(7)), oe = n(e(72)), fe = n(e(152)), ge = n(e(270)), we = n(e(153)), _e = n(e(154)), Te = n(e(271)), Pe = n(e(264)), $e = n(e(601)), Bt = e(107), Le = n(e(284)), at = n(e(157)), pt = n(e(158)), kt = n(e(159)), _t = n(e(74)), Lt = n(e(300)), Ft = n(e(301)), Zt = n(e(23)), ft = n(e(167)), It = n(e(654)), Kt = n(e(168)), Sn = n(e(659)), Cn = n(e(662)), on = n(e(169)), An = n(e(311)), Ue = n(e(266)), ne = n(e(170)), se = n(e(312)), Ce = n(e(318)), At = n(e(319)), Ge = n(e(683)), Ye = n(e(173)), Qt = n(e(323)), tn = n(e(178)), vn = n(e(337)), Yt = n(e(338)), Tn = n(e(801)), er = n(e(802)), lr = n(e(803)), Br = n(e(804)), pi = n(e(348)), $n = n(e(181)), rr = n(e(184)), Kr = n(e(805)), Bi = n(e(350)), Li = n(e(351)), xo = n(e(806)), Yr = n(e(298)), Qo = n(e(347)), Wo = n(e(345)), xi = n(e(182)), Fa = n(e(329)), sn = n(e(77)), Ct = n(e(294)), cn = e(71), Hn = n(e(174)), Sr = n(e(807));
          e(809);
          const ao = (0, Q.default)(), wr = (0, c.default)("OT"), Jr = ao.onlyLocal(), Fn = {};
          Fn.noConflict = (0, G.default)(), (typeof window !== void 0 ? window : Dn).OT = Fn, i.exports = Fn, (() => {
            let so = Fn;
            Object.defineProperty(typeof window !== void 0 ? window : Dn, "TB", {
              get: () => (so === Fn && console.warn("window.TB is deprecated, and will be removed in the future. Please access via window.OT"), so),
              set: (Va) => {
                so = Va;
              },
              // We provide a setter so noConflict works
              configurable: !0
            });
          })();
          const Ia = (0, O.default)(typeof window !== void 0 ? window : Dn), wt = (0, _t.default)({
            global: Ia
          }), Yn = (0, K.default)({}), kr = (0, h.default)(), mr = (0, Lt.default)({
            otError: Yn
          }), yi = (0, Ft.default)(), Or = (0, b.default)({
            global: Ia
          }), Ei = (0, u.default)({
            getNativeEnumerateDevices: Or
          }), Rt = (0, Zt.default)(), ln = (0, ft.default)(), tt = (0, It.default)({
            otError: Yn,
            global: Ia
          }), Oe = (0, Kt.default)({
            chromeExtensionHelper: mr,
            otError: Yn
          }), Jt = (0, Sn.default)({
            deviceHelpers: Ei,
            generateConstraintInfo: Te.default,
            getUserMediaHelper: tt,
            global: Ia,
            OTHelpers: de.default,
            screenSharing: Oe
          }), St = (0, Cn.default)({
            otError: Yn,
            processPubOptions: Jt
          }), Vt = (0, on.default)({
            otError: Yn
          }), Et = (0, An.default)(), Qn = (0, Ue.default)({
            otError: Yn
          }), gn = (0, o.default)({
            global: Ia,
            videoElementErrorMap: Qn
          }), jt = (0, ne.default)({
            global: Ia
          }), On = (0, se.default)({
            PeerConnection: wt,
            setCertificates: jt
          }), Ar = (0, Ce.default)({
            PeerConnection: wt,
            setCertificates: jt
          }), ui = (0, At.default)(), fr = (0, Ge.default)({
            otError: Yn
          }), Jn = (0, m.default)({
            NativeVideoElementWrapper: gn
          }), Qr = (0, y.default)(), ti = (0, Ye.default)({
            VideoElementFacade: Jn
          }), Wn = (0, Qt.default)({
            interpretPeerConnectionError: Vt,
            otError: Yn,
            SubscriberPeerConnection: Ar,
            WidgetView: ti
          }), Hi = (0, tn.default)({
            APIKEY: oe.default,
            createChromeMixin: yi,
            deviceHelpers: Ei,
            EnvironmentLoader: _e.default,
            Errors: L.default,
            Events: Rt,
            ExceptionCodes: p.default,
            calculateCapableSimulcastStreams: ge.default,
            global: Ia,
            interpretPeerConnectionError: Vt,
            IntervalRunner: f.default,
            Microphone: Et,
            otError: Yn,
            OTErrorClass: v.default,
            OTHelpers: de.default,
            parseIceServers: Bt.parseIceServers,
            processPubOptions: Jt,
            PUBLISH_MAX_DELAY: Le.default,
            PublisherPeerConnection: On,
            PublishingState: ui,
            StreamChannel: at.default,
            systemRequirements: kt.default,
            VideoOrientation: Qr,
            WidgetView: ti
          }), Ho = (0, vn.default)({
            otError: Yn,
            Publisher: Hi
          }), Ea = (0, Yt.default)({
            global: Ia,
            initPublisher: Ho,
            otError: Yn,
            Publisher: Hi,
            Subscriber: Wn
          }), Ga = (0, Tn.default)({
            Session: Ea
          });
          (0, l.default)(Fn), (0, J.default)(Fn, "$", {
            name: "OT.$",
            getMessage: "Please use an external library like jQuery to select elements from the page.",
            value: de.default
          }), Fn.APIKEY = oe.default.value, Fn.AnalyserAudioLevelSampler = g.default, Fn.Archive = pi.default, Fn.ArchiveEvent = Rt.ArchiveEvent, Fn.ArchiveUpdatedEvent = Rt.ArchiveUpdatedEvent, Fn.AudioLevelTransformer = fe.default, Fn.AudioLevelUpdatedEvent = Rt.AudioLevelUpdatedEvent, Fn.Capabilities = $n.default, Fn.Chrome = we.default, Fn.Connection = rr.default, Fn.ConnectionCapabilities = Fn.Connection.Capabilities, Fn.ConnectionEvent = Rt.ConnectionEvent, Object.keys(d.default).forEach((so) => {
            Fn[so.toUpperCase()] = d.default[so].priority;
          }), Fn.NONE = 0, Fn.debug = wr.debug, Fn.error = wr.error, Fn.info = wr.info, Fn.log = wr.log, Fn.warn = wr.warn, Fn.DestroyedEvent = Rt.DestroyedEvent, Fn.EnvLoadedEvent = Rt.EnvLoadedEvent, Fn.Error = v.default, Fn.Error.on(U.default.EXCEPTION, (so) => {
            if (so.target === Fn.Error) {
              const Va = (0, t.default)(so);
              Va.target = Fn, Fn.dispatchEvent(Va);
            } else
              Fn.dispatchEvent(so);
          }), Fn.Event = B.default, Fn.ExceptionCodes = p.default, Fn.ExceptionEvent = Rt.ExceptionEvent, Fn.getDevices = Kr.default, Fn.getAudioOutputDevices = Bi.default, Fn.getActiveAudioOutputDevice = Li.default, Fn.setAudioOutputDevice = (0, xo.default)(), Fn.GetAudioLevelSampler = A.default, Fn.HAS_REQUIREMENTS = 1, Fn.IntervalRunner = f.default, Fn.IssueReportedEvent = Rt.IssueReportedEvent, Fn.MediaStoppedEvent = Rt.MediaStoppedEvent, Fn.Microphone = Et, Fn.NOT_HAS_REQUIREMENTS = 0, Fn.PeerConnection = wt, Fn.PeerConnection.QOS = Yr.default, Fn.Publisher = Hi, Fn.PublisherPeerConnection = On, Fn.PublishingState = ui, Fn.MuteForcedEvent = Rt.MuteForcedEvent, Fn.Session = Ea, Fn.SessionConnectEvent = Rt.SessionConnectEvent, Fn.SessionDisconnectEvent = Rt.SessionDisconnectEvent, Fn.SessionDispatcher = Qo.default, Fn.Signal = Wo.default, Fn.SignalEvent = Rt.SignalEvent, Fn.Stream = xi.default, Fn.StreamChannel = at.default, Fn.StreamEvent = Rt.StreamEvent, Fn.StreamPropertyChangedEvent = Rt.StreamPropertyChangedEvent, Fn.StreamUpdatedEvent = Rt.StreamUpdatedEvent, Fn.StylableComponent = pt.default, Fn.Subscriber = Wn, Fn.SubscriberPeerConnection = Ar, Fn.SubscribingState = Fa.default, Fn.VideoDimensionsChangedEvent = Rt.VideoDimensionsChangedEvent, Fn.VideoDisableWarningEvent = Rt.VideoDisableWarningEvent, Fn.VideoElement = Jn, Fn.VideoEnabledChangedEvent = Rt.VideoEnabledChangedEvent, Fn.VideoOrientation = Qr, Fn.WidgetView = ti, Fn.getSupportedCodecs = er.default, Fn.hasMediaProcessorSupport = lr.default, Fn.hasEndToEndEncryptionSupport = Br.default, Fn._ = {
            AnalyticsHelper: N.default,
            getClientGuid: Pe.default.get,
            StaticConfig: ao
          }, Object.defineProperty(Fn, "version", {
            value: Jr.version
          });
          const No = {}, Ba = (so) => W.default.includes(so);
          (0, J.default)(No, "version", {
            value: Jr.version,
            name: "OT.properties.version",
            getWarning: "Please use OT.version instead",
            warnOnSet: !0,
            setWarning: "Mutating version has no effect"
          }), w.default.forEach((so) => {
            let Va, qa;
            if (Array.isArray(so)) {
              const oi = so[0], oa = so[1];
              qa = oi, Va = Jr[oa] || oa;
            } else
              Va = Jr[so], qa = so;
            const hs = Ba(qa);
            (0, J.default)(No, qa, {
              value: Va,
              name: `OT.properties.${qa}`,
              warnOnSet: !0,
              canSet: hs,
              setWarning: hs ? `Mutating ${qa} can cause side effects` : `Mutating ${qa} has no effect`
            });
          }), Fn.properties = No, Fn.audioContext = kr, Fn.checkScreenSharingCapability = Oe.checkCapability, Fn.checkSystemRequirements = kt.default.check, Fn.components = {}, Fn.generateSimpleStateMachine = ln, Fn.getErrorTitleByCode = v.default.getTitleByCode, Fn.getLogs = wr.getLogs, Fn.getStatsAdpater = Ct.default, Fn.getStatsHelpers = sn.default, Fn.getUserMedia = St, Fn.handleJsException = v.default.handleJsException, Fn.initPublisher = Ho, Fn.setProxyUrl = cn.setProxyUrl, Fn.initSession = function(so, Va, qa) {
            return Va == null && (Va = so, so = null), oe.default.value.length === 0 && so && (oe.default.value = so, Fn.APIKEY = so), Ga(so, Va, qa);
          };
          const Ra = (so) => `${so} is deprecated and will be removed in a future version of OpenTok`, us = (so, Va) => () => (console.warn(Ra(so)), Va);
          Object.defineProperties(Fn, {
            isUnloaded: {
              get: us("OT.isUnloaded", _e.default.isUnloaded)
            },
            onLoad: {
              get: us("OT.onLoad", _e.default.onLoad)
            },
            onUnload: {
              get: us("OT.onUnload", _e.default.onUnload)
            },
            overrideGuidStorage: {
              get: us("OT.overrideGuidStorage", Pe.default.override)
            }
          }), Fn.pickScreenSharingHelper = Oe.pickHelper, Fn.publishers = Z.default.publishers, Fn.registerScreenSharingExtension = Oe.registerExtension, Fn.registerScreenSharingExtensionHelper = Oe.registerExtensionHelper, Fn.reportIssue = fr, Fn.sessions = Z.default.sessions, Fn.setLogLevel = $e.default, Fn.shouldLog = wr.shouldLog, Fn.subscribers = Z.default.subscribers, Fn.unblockAudio = Hn.default, Fn.upgradeSystemRequirements = kt.default.upgrade, _e.default.onUnload(() => {
            Z.default.publishers.destroy(), Z.default.subscribers.destroy(), Z.default.sessions.destroy("unloaded");
          }), (0, Sr.default)();
        },
        /* 354 */
        /***/
        function(i, r) {
          function e() {
            this.__data__ = [], this.size = 0;
          }
          i.exports = e;
        },
        /* 355 */
        /***/
        function(i, r, e) {
          var n = e(82), t = Array.prototype, o = t.splice;
          function l(c) {
            var d = this.__data__, u = n(d, c);
            if (u < 0)
              return !1;
            var h = d.length - 1;
            return u == h ? d.pop() : o.call(d, u, 1), --this.size, !0;
          }
          i.exports = l;
        },
        /* 356 */
        /***/
        function(i, r, e) {
          var n = e(82);
          function t(o) {
            var l = this.__data__, c = n(l, o);
            return c < 0 ? void 0 : l[c][1];
          }
          i.exports = t;
        },
        /* 357 */
        /***/
        function(i, r, e) {
          var n = e(82);
          function t(o) {
            return n(this.__data__, o) > -1;
          }
          i.exports = t;
        },
        /* 358 */
        /***/
        function(i, r, e) {
          var n = e(82);
          function t(o, l) {
            var c = this.__data__, d = n(c, o);
            return d < 0 ? (++this.size, c.push([o, l])) : c[d][1] = l, this;
          }
          i.exports = t;
        },
        /* 359 */
        /***/
        function(i, r, e) {
          var n = e(81);
          function t() {
            this.__data__ = new n(), this.size = 0;
          }
          i.exports = t;
        },
        /* 360 */
        /***/
        function(i, r) {
          function e(n) {
            var t = this.__data__, o = t.delete(n);
            return this.size = t.size, o;
          }
          i.exports = e;
        },
        /* 361 */
        /***/
        function(i, r) {
          function e(n) {
            return this.__data__.get(n);
          }
          i.exports = e;
        },
        /* 362 */
        /***/
        function(i, r) {
          function e(n) {
            return this.__data__.has(n);
          }
          i.exports = e;
        },
        /* 363 */
        /***/
        function(i, r, e) {
          var n = e(81), t = e(113), o = e(114), l = 200;
          function c(d, u) {
            var h = this.__data__;
            if (h instanceof n) {
              var A = h.__data__;
              if (!t || A.length < l - 1)
                return A.push([d, u]), this.size = ++h.size, this;
              h = this.__data__ = new o(A);
            }
            return h.set(d, u), this.size = h.size, this;
          }
          i.exports = c;
        },
        /* 364 */
        /***/
        function(i, r, e) {
          var n = e(17), t = e(367), o = e(11), l = e(187), c = /[\\^$.*+?()[\]{}|]/g, d = /^\[object .+?Constructor\]$/, u = Function.prototype, h = Object.prototype, A = u.toString, g = h.hasOwnProperty, f = RegExp(
            "^" + A.call(g).replace(c, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
          );
          function p(v) {
            if (!o(v) || t(v))
              return !1;
            var b = n(v) ? f : d;
            return b.test(l(v));
          }
          i.exports = p;
        },
        /* 365 */
        /***/
        function(i, r, e) {
          var n = e(44), t = Object.prototype, o = t.hasOwnProperty, l = t.toString, c = n ? n.toStringTag : void 0;
          function d(u) {
            var h = o.call(u, c), A = u[c];
            try {
              u[c] = void 0;
              var g = !0;
            } catch {
            }
            var f = l.call(u);
            return g && (h ? u[c] = A : delete u[c]), f;
          }
          i.exports = d;
        },
        /* 366 */
        /***/
        function(i, r) {
          var e = Object.prototype, n = e.toString;
          function t(o) {
            return n.call(o);
          }
          i.exports = t;
        },
        /* 367 */
        /***/
        function(i, r, e) {
          var n = e(368), t = function() {
            var l = /[^.]+$/.exec(n && n.keys && n.keys.IE_PROTO || "");
            return l ? "Symbol(src)_1." + l : "";
          }();
          function o(l) {
            return !!t && t in l;
          }
          i.exports = o;
        },
        /* 368 */
        /***/
        function(i, r, e) {
          var n = e(15), t = n["__core-js_shared__"];
          i.exports = t;
        },
        /* 369 */
        /***/
        function(i, r) {
          function e(n, t) {
            return n == null ? void 0 : n[t];
          }
          i.exports = e;
        },
        /* 370 */
        /***/
        function(i, r, e) {
          var n = e(371), t = e(81), o = e(113);
          function l() {
            this.size = 0, this.__data__ = {
              hash: new n(),
              map: new (o || t)(),
              string: new n()
            };
          }
          i.exports = l;
        },
        /* 371 */
        /***/
        function(i, r, e) {
          var n = e(372), t = e(373), o = e(374), l = e(375), c = e(376);
          function d(u) {
            var h = -1, A = u == null ? 0 : u.length;
            for (this.clear(); ++h < A; ) {
              var g = u[h];
              this.set(g[0], g[1]);
            }
          }
          d.prototype.clear = n, d.prototype.delete = t, d.prototype.get = o, d.prototype.has = l, d.prototype.set = c, i.exports = d;
        },
        /* 372 */
        /***/
        function(i, r, e) {
          var n = e(83);
          function t() {
            this.__data__ = n ? n(null) : {}, this.size = 0;
          }
          i.exports = t;
        },
        /* 373 */
        /***/
        function(i, r) {
          function e(n) {
            var t = this.has(n) && delete this.__data__[n];
            return this.size -= t ? 1 : 0, t;
          }
          i.exports = e;
        },
        /* 374 */
        /***/
        function(i, r, e) {
          var n = e(83), t = "__lodash_hash_undefined__", o = Object.prototype, l = o.hasOwnProperty;
          function c(d) {
            var u = this.__data__;
            if (n) {
              var h = u[d];
              return h === t ? void 0 : h;
            }
            return l.call(u, d) ? u[d] : void 0;
          }
          i.exports = c;
        },
        /* 375 */
        /***/
        function(i, r, e) {
          var n = e(83), t = Object.prototype, o = t.hasOwnProperty;
          function l(c) {
            var d = this.__data__;
            return n ? d[c] !== void 0 : o.call(d, c);
          }
          i.exports = l;
        },
        /* 376 */
        /***/
        function(i, r, e) {
          var n = e(83), t = "__lodash_hash_undefined__";
          function o(l, c) {
            var d = this.__data__;
            return this.size += this.has(l) ? 0 : 1, d[l] = n && c === void 0 ? t : c, this;
          }
          i.exports = o;
        },
        /* 377 */
        /***/
        function(i, r, e) {
          var n = e(84);
          function t(o) {
            var l = n(this, o).delete(o);
            return this.size -= l ? 1 : 0, l;
          }
          i.exports = t;
        },
        /* 378 */
        /***/
        function(i, r) {
          function e(n) {
            var t = typeof n;
            return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
          }
          i.exports = e;
        },
        /* 379 */
        /***/
        function(i, r, e) {
          var n = e(84);
          function t(o) {
            return n(this, o).get(o);
          }
          i.exports = t;
        },
        /* 380 */
        /***/
        function(i, r, e) {
          var n = e(84);
          function t(o) {
            return n(this, o).has(o);
          }
          i.exports = t;
        },
        /* 381 */
        /***/
        function(i, r, e) {
          var n = e(84);
          function t(o, l) {
            var c = n(this, o), d = c.size;
            return c.set(o, l), this.size += c.size == d ? 0 : 1, this;
          }
          i.exports = t;
        },
        /* 382 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = -1, l = Array(n); ++o < n; )
              l[o] = t(o);
            return l;
          }
          i.exports = e;
        },
        /* 383 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(18), o = "[object Arguments]";
          function l(c) {
            return t(c) && n(c) == o;
          }
          i.exports = l;
        },
        /* 384 */
        /***/
        function(i, r) {
          function e() {
            return !1;
          }
          i.exports = e;
        },
        /* 385 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(116), o = e(18), l = "[object Arguments]", c = "[object Array]", d = "[object Boolean]", u = "[object Date]", h = "[object Error]", A = "[object Function]", g = "[object Map]", f = "[object Number]", p = "[object Object]", v = "[object RegExp]", b = "[object Set]", m = "[object String]", y = "[object WeakMap]", U = "[object ArrayBuffer]", B = "[object DataView]", Q = "[object Float32Array]", N = "[object Float64Array]", J = "[object Int8Array]", w = "[object Int16Array]", W = "[object Int32Array]", G = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", K = "[object Uint16Array]", L = "[object Uint32Array]", O = {};
          O[Q] = O[N] = O[J] = O[w] = O[W] = O[G] = O[Z] = O[K] = O[L] = !0, O[l] = O[c] = O[U] = O[d] = O[B] = O[u] = O[h] = O[A] = O[g] = O[f] = O[p] = O[v] = O[b] = O[m] = O[y] = !1;
          function de(oe) {
            return o(oe) && t(oe.length) && !!O[n(oe)];
          }
          i.exports = de;
        },
        /* 386 */
        /***/
        function(i, r, e) {
          var n = e(191), t = n(Object.keys, Object);
          i.exports = t;
        },
        /* 387 */
        /***/
        function(i, r, e) {
          var n = e(45), t = e(54);
          function o(l, c) {
            return l && n(c, t(c), l);
          }
          i.exports = o;
        },
        /* 388 */
        /***/
        function(i, r, e) {
          var n = e(11), t = e(68), o = e(389), l = Object.prototype, c = l.hasOwnProperty;
          function d(u) {
            if (!n(u))
              return o(u);
            var h = t(u), A = [];
            for (var g in u)
              g == "constructor" && (h || !c.call(u, g)) || A.push(g);
            return A;
          }
          i.exports = d;
        },
        /* 389 */
        /***/
        function(i, r) {
          function e(n) {
            var t = [];
            if (n != null)
              for (var o in Object(n))
                t.push(o);
            return t;
          }
          i.exports = e;
        },
        /* 390 */
        /***/
        function(i, r, e) {
          var n = e(45), t = e(119);
          function o(l, c) {
            return n(l, t(l), c);
          }
          i.exports = o;
        },
        /* 391 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = -1, l = n == null ? 0 : n.length, c = 0, d = []; ++o < l; ) {
              var u = n[o];
              t(u, o, n) && (d[c++] = u);
            }
            return d;
          }
          i.exports = e;
        },
        /* 392 */
        /***/
        function(i, r, e) {
          var n = e(45), t = e(194);
          function o(l, c) {
            return n(l, t(l), c);
          }
          i.exports = o;
        },
        /* 393 */
        /***/
        function(i, r, e) {
          var n = e(43), t = e(15), o = n(t, "DataView");
          i.exports = o;
        },
        /* 394 */
        /***/
        function(i, r, e) {
          var n = e(43), t = e(15), o = n(t, "Promise");
          i.exports = o;
        },
        /* 395 */
        /***/
        function(i, r) {
          var e = Object.prototype, n = e.hasOwnProperty;
          function t(o) {
            var l = o.length, c = new o.constructor(l);
            return l && typeof o[0] == "string" && n.call(o, "index") && (c.index = o.index, c.input = o.input), c;
          }
          i.exports = t;
        },
        /* 396 */
        /***/
        function(i, r, e) {
          var n = e(122), t = e(397), o = e(398), l = e(399), c = e(201), d = "[object Boolean]", u = "[object Date]", h = "[object Map]", A = "[object Number]", g = "[object RegExp]", f = "[object Set]", p = "[object String]", v = "[object Symbol]", b = "[object ArrayBuffer]", m = "[object DataView]", y = "[object Float32Array]", U = "[object Float64Array]", B = "[object Int8Array]", Q = "[object Int16Array]", N = "[object Int32Array]", J = "[object Uint8Array]", w = "[object Uint8ClampedArray]", W = "[object Uint16Array]", G = "[object Uint32Array]";
          function Z(K, L, O) {
            var de = K.constructor;
            switch (L) {
              case b:
                return n(K);
              case d:
              case u:
                return new de(+K);
              case m:
                return t(K, O);
              case y:
              case U:
              case B:
              case Q:
              case N:
              case J:
              case w:
              case W:
              case G:
                return c(K, O);
              case h:
                return new de();
              case A:
              case p:
                return new de(K);
              case g:
                return o(K);
              case f:
                return new de();
              case v:
                return l(K);
            }
          }
          i.exports = Z;
        },
        /* 397 */
        /***/
        function(i, r, e) {
          var n = e(122);
          function t(o, l) {
            var c = l ? n(o.buffer) : o.buffer;
            return new o.constructor(c, o.byteOffset, o.byteLength);
          }
          i.exports = t;
        },
        /* 398 */
        /***/
        function(i, r) {
          var e = /\w*$/;
          function n(t) {
            var o = new t.constructor(t.source, e.exec(t));
            return o.lastIndex = t.lastIndex, o;
          }
          i.exports = n;
        },
        /* 399 */
        /***/
        function(i, r, e) {
          var n = e(44), t = n ? n.prototype : void 0, o = t ? t.valueOf : void 0;
          function l(c) {
            return o ? Object(o.call(c)) : {};
          }
          i.exports = l;
        },
        /* 400 */
        /***/
        function(i, r, e) {
          var n = e(401), t = e(67), o = e(117), l = o && o.isMap, c = l ? t(l) : n;
          i.exports = c;
        },
        /* 401 */
        /***/
        function(i, r, e) {
          var n = e(46), t = e(18), o = "[object Map]";
          function l(c) {
            return t(c) && n(c) == o;
          }
          i.exports = l;
        },
        /* 402 */
        /***/
        function(i, r, e) {
          var n = e(403), t = e(67), o = e(117), l = o && o.isSet, c = l ? t(l) : n;
          i.exports = c;
        },
        /* 403 */
        /***/
        function(i, r, e) {
          var n = e(46), t = e(18), o = "[object Set]";
          function l(c) {
            return t(c) && n(c) == o;
          }
          i.exports = l;
        },
        /* 404 */
        /***/
        function(i, r, e) {
          var n = /* @__PURE__ */ function() {
            return this || typeof self == "object" && self;
          }() || Function("return this")(), t = n.regeneratorRuntime && Object.getOwnPropertyNames(n).indexOf("regeneratorRuntime") >= 0, o = t && n.regeneratorRuntime;
          if (n.regeneratorRuntime = void 0, i.exports = e(405), t)
            n.regeneratorRuntime = o;
          else
            try {
              delete n.regeneratorRuntime;
            } catch {
              n.regeneratorRuntime = void 0;
            }
        },
        /* 405 */
        /***/
        function(i, r, e) {
          (function(n) {
            (function(t) {
              var o = Object.prototype, l = o.hasOwnProperty, c, d = typeof Symbol == "function" ? Symbol : {}, u = d.iterator || "@@iterator", h = d.asyncIterator || "@@asyncIterator", A = d.toStringTag || "@@toStringTag", g = typeof i == "object", f = t.regeneratorRuntime;
              if (f) {
                g && (i.exports = f);
                return;
              }
              f = t.regeneratorRuntime = g ? i.exports : {};
              function p(Te, Pe, $e, Bt) {
                var Le = Pe && Pe.prototype instanceof Q ? Pe : Q, at = Object.create(Le.prototype), pt = new ge(Bt || []);
                return at._invoke = O(Te, $e, pt), at;
              }
              f.wrap = p;
              function v(Te, Pe, $e) {
                try {
                  return { type: "normal", arg: Te.call(Pe, $e) };
                } catch (Bt) {
                  return { type: "throw", arg: Bt };
                }
              }
              var b = "suspendedStart", m = "suspendedYield", y = "executing", U = "completed", B = {};
              function Q() {
              }
              function N() {
              }
              function J() {
              }
              var w = {};
              w[u] = function() {
                return this;
              };
              var W = Object.getPrototypeOf, G = W && W(W(we([])));
              G && G !== o && l.call(G, u) && (w = G);
              var Z = J.prototype = Q.prototype = Object.create(w);
              N.prototype = Z.constructor = J, J.constructor = N, J[A] = N.displayName = "GeneratorFunction";
              function K(Te) {
                ["next", "throw", "return"].forEach(function(Pe) {
                  Te[Pe] = function($e) {
                    return this._invoke(Pe, $e);
                  };
                });
              }
              f.isGeneratorFunction = function(Te) {
                var Pe = typeof Te == "function" && Te.constructor;
                return Pe ? Pe === N || // For the native GeneratorFunction constructor, the best we can
                // do is to check its .name property.
                (Pe.displayName || Pe.name) === "GeneratorFunction" : !1;
              }, f.mark = function(Te) {
                return Object.setPrototypeOf ? Object.setPrototypeOf(Te, J) : (Te.__proto__ = J, A in Te || (Te[A] = "GeneratorFunction")), Te.prototype = Object.create(Z), Te;
              }, f.awrap = function(Te) {
                return { __await: Te };
              };
              function L(Te) {
                function Pe(Le, at, pt, kt) {
                  var _t = v(Te[Le], Te, at);
                  if (_t.type === "throw")
                    kt(_t.arg);
                  else {
                    var Lt = _t.arg, Ft = Lt.value;
                    return Ft && typeof Ft == "object" && l.call(Ft, "__await") ? n.resolve(Ft.__await).then(function(Zt) {
                      Pe("next", Zt, pt, kt);
                    }, function(Zt) {
                      Pe("throw", Zt, pt, kt);
                    }) : n.resolve(Ft).then(function(Zt) {
                      Lt.value = Zt, pt(Lt);
                    }, function(Zt) {
                      return Pe("throw", Zt, pt, kt);
                    });
                  }
                }
                var $e;
                function Bt(Le, at) {
                  function pt() {
                    return new n(function(kt, _t) {
                      Pe(Le, at, kt, _t);
                    });
                  }
                  return $e = // If enqueue has been called before, then we want to wait until
                  // all previous Promises have been resolved before calling invoke,
                  // so that results are always delivered in the correct order. If
                  // enqueue has not been called before, then it is important to
                  // call invoke immediately, without waiting on a callback to fire,
                  // so that the async generator function has the opportunity to do
                  // any necessary setup in a predictable way. This predictability
                  // is why the Promise constructor synchronously invokes its
                  // executor callback, and why async functions synchronously
                  // execute code before the first await. Since we implement simple
                  // async functions in terms of async generators, it is especially
                  // important to get this right, even though it requires care.
                  $e ? $e.then(
                    pt,
                    // Avoid propagating failures to Promises returned by later
                    // invocations of the iterator.
                    pt
                  ) : pt();
                }
                this._invoke = Bt;
              }
              K(L.prototype), L.prototype[h] = function() {
                return this;
              }, f.AsyncIterator = L, f.async = function(Te, Pe, $e, Bt) {
                var Le = new L(
                  p(Te, Pe, $e, Bt)
                );
                return f.isGeneratorFunction(Pe) ? Le : Le.next().then(function(at) {
                  return at.done ? at.value : Le.next();
                });
              };
              function O(Te, Pe, $e) {
                var Bt = b;
                return function(at, pt) {
                  if (Bt === y)
                    throw new Error("Generator is already running");
                  if (Bt === U) {
                    if (at === "throw")
                      throw pt;
                    return _e();
                  }
                  for ($e.method = at, $e.arg = pt; ; ) {
                    var kt = $e.delegate;
                    if (kt) {
                      var _t = de(kt, $e);
                      if (_t) {
                        if (_t === B) continue;
                        return _t;
                      }
                    }
                    if ($e.method === "next")
                      $e.sent = $e._sent = $e.arg;
                    else if ($e.method === "throw") {
                      if (Bt === b)
                        throw Bt = U, $e.arg;
                      $e.dispatchException($e.arg);
                    } else $e.method === "return" && $e.abrupt("return", $e.arg);
                    Bt = y;
                    var Lt = v(Te, Pe, $e);
                    if (Lt.type === "normal") {
                      if (Bt = $e.done ? U : m, Lt.arg === B)
                        continue;
                      return {
                        value: Lt.arg,
                        done: $e.done
                      };
                    } else Lt.type === "throw" && (Bt = U, $e.method = "throw", $e.arg = Lt.arg);
                  }
                };
              }
              function de(Te, Pe) {
                var $e = Te.iterator[Pe.method];
                if ($e === c) {
                  if (Pe.delegate = null, Pe.method === "throw") {
                    if (Te.iterator.return && (Pe.method = "return", Pe.arg = c, de(Te, Pe), Pe.method === "throw"))
                      return B;
                    Pe.method = "throw", Pe.arg = new TypeError(
                      "The iterator does not provide a 'throw' method"
                    );
                  }
                  return B;
                }
                var Bt = v($e, Te.iterator, Pe.arg);
                if (Bt.type === "throw")
                  return Pe.method = "throw", Pe.arg = Bt.arg, Pe.delegate = null, B;
                var Le = Bt.arg;
                if (!Le)
                  return Pe.method = "throw", Pe.arg = new TypeError("iterator result is not an object"), Pe.delegate = null, B;
                if (Le.done)
                  Pe[Te.resultName] = Le.value, Pe.next = Te.nextLoc, Pe.method !== "return" && (Pe.method = "next", Pe.arg = c);
                else
                  return Le;
                return Pe.delegate = null, B;
              }
              K(Z), Z[A] = "Generator", Z[u] = function() {
                return this;
              }, Z.toString = function() {
                return "[object Generator]";
              };
              function oe(Te) {
                var Pe = { tryLoc: Te[0] };
                1 in Te && (Pe.catchLoc = Te[1]), 2 in Te && (Pe.finallyLoc = Te[2], Pe.afterLoc = Te[3]), this.tryEntries.push(Pe);
              }
              function fe(Te) {
                var Pe = Te.completion || {};
                Pe.type = "normal", delete Pe.arg, Te.completion = Pe;
              }
              function ge(Te) {
                this.tryEntries = [{ tryLoc: "root" }], Te.forEach(oe, this), this.reset(!0);
              }
              f.keys = function(Te) {
                var Pe = [];
                for (var $e in Te)
                  Pe.push($e);
                return Pe.reverse(), function Bt() {
                  for (; Pe.length; ) {
                    var Le = Pe.pop();
                    if (Le in Te)
                      return Bt.value = Le, Bt.done = !1, Bt;
                  }
                  return Bt.done = !0, Bt;
                };
              };
              function we(Te) {
                if (Te) {
                  var Pe = Te[u];
                  if (Pe)
                    return Pe.call(Te);
                  if (typeof Te.next == "function")
                    return Te;
                  if (!isNaN(Te.length)) {
                    var $e = -1, Bt = function Le() {
                      for (; ++$e < Te.length; )
                        if (l.call(Te, $e))
                          return Le.value = Te[$e], Le.done = !1, Le;
                      return Le.value = c, Le.done = !0, Le;
                    };
                    return Bt.next = Bt;
                  }
                }
                return { next: _e };
              }
              f.values = we;
              function _e() {
                return { value: c, done: !0 };
              }
              ge.prototype = {
                constructor: ge,
                reset: function(Te) {
                  if (this.prev = 0, this.next = 0, this.sent = this._sent = c, this.done = !1, this.delegate = null, this.method = "next", this.arg = c, this.tryEntries.forEach(fe), !Te)
                    for (var Pe in this)
                      Pe.charAt(0) === "t" && l.call(this, Pe) && !isNaN(+Pe.slice(1)) && (this[Pe] = c);
                },
                stop: function() {
                  this.done = !0;
                  var Te = this.tryEntries[0], Pe = Te.completion;
                  if (Pe.type === "throw")
                    throw Pe.arg;
                  return this.rval;
                },
                dispatchException: function(Te) {
                  if (this.done)
                    throw Te;
                  var Pe = this;
                  function $e(_t, Lt) {
                    return at.type = "throw", at.arg = Te, Pe.next = _t, Lt && (Pe.method = "next", Pe.arg = c), !!Lt;
                  }
                  for (var Bt = this.tryEntries.length - 1; Bt >= 0; --Bt) {
                    var Le = this.tryEntries[Bt], at = Le.completion;
                    if (Le.tryLoc === "root")
                      return $e("end");
                    if (Le.tryLoc <= this.prev) {
                      var pt = l.call(Le, "catchLoc"), kt = l.call(Le, "finallyLoc");
                      if (pt && kt) {
                        if (this.prev < Le.catchLoc)
                          return $e(Le.catchLoc, !0);
                        if (this.prev < Le.finallyLoc)
                          return $e(Le.finallyLoc);
                      } else if (pt) {
                        if (this.prev < Le.catchLoc)
                          return $e(Le.catchLoc, !0);
                      } else if (kt) {
                        if (this.prev < Le.finallyLoc)
                          return $e(Le.finallyLoc);
                      } else
                        throw new Error("try statement without catch or finally");
                    }
                  }
                },
                abrupt: function(Te, Pe) {
                  for (var $e = this.tryEntries.length - 1; $e >= 0; --$e) {
                    var Bt = this.tryEntries[$e];
                    if (Bt.tryLoc <= this.prev && l.call(Bt, "finallyLoc") && this.prev < Bt.finallyLoc) {
                      var Le = Bt;
                      break;
                    }
                  }
                  Le && (Te === "break" || Te === "continue") && Le.tryLoc <= Pe && Pe <= Le.finallyLoc && (Le = null);
                  var at = Le ? Le.completion : {};
                  return at.type = Te, at.arg = Pe, Le ? (this.method = "next", this.next = Le.finallyLoc, B) : this.complete(at);
                },
                complete: function(Te, Pe) {
                  if (Te.type === "throw")
                    throw Te.arg;
                  return Te.type === "break" || Te.type === "continue" ? this.next = Te.arg : Te.type === "return" ? (this.rval = this.arg = Te.arg, this.method = "return", this.next = "end") : Te.type === "normal" && Pe && (this.next = Pe), B;
                },
                finish: function(Te) {
                  for (var Pe = this.tryEntries.length - 1; Pe >= 0; --Pe) {
                    var $e = this.tryEntries[Pe];
                    if ($e.finallyLoc === Te)
                      return this.complete($e.completion, $e.afterLoc), fe($e), B;
                  }
                },
                catch: function(Te) {
                  for (var Pe = this.tryEntries.length - 1; Pe >= 0; --Pe) {
                    var $e = this.tryEntries[Pe];
                    if ($e.tryLoc === Te) {
                      var Bt = $e.completion;
                      if (Bt.type === "throw") {
                        var Le = Bt.arg;
                        fe($e);
                      }
                      return Le;
                    }
                  }
                  throw new Error("illegal catch attempt");
                },
                delegateYield: function(Te, Pe, $e) {
                  return this.delegate = {
                    iterator: we(Te),
                    resultName: Pe,
                    nextLoc: $e
                  }, this.method === "next" && (this.arg = c), B;
                }
              };
            })(
              // In sloppy mode, unbound `this` refers to the global object, fallback to
              // Function constructor if we're in global strict mode. That is sadly a form
              // of indirect eval which violates Content Security Policy.
              /* @__PURE__ */ function() {
                return this || typeof self == "object" && self;
              }() || Function("return this")()
            );
          }).call(this, e(2));
        },
        /* 406 */
        /***/
        function(i, r, e) {
          var n = e(407), t = e(188), o = e(90), l = t ? function(c, d) {
            return t(c, "toString", {
              configurable: !0,
              enumerable: !1,
              value: n(d),
              writable: !0
            });
          } : o;
          i.exports = l;
        },
        /* 407 */
        /***/
        function(i, r) {
          function e(n) {
            return function() {
              return n;
            };
          }
          i.exports = e;
        },
        /* 408 */
        /***/
        function(i, r, e) {
          (function(n) {
            r.log = l, r.formatArgs = o, r.save = c, r.load = d, r.useColors = t, r.storage = h(), r.colors = [
              "#0000CC",
              "#0000FF",
              "#0033CC",
              "#0033FF",
              "#0066CC",
              "#0066FF",
              "#0099CC",
              "#0099FF",
              "#00CC00",
              "#00CC33",
              "#00CC66",
              "#00CC99",
              "#00CCCC",
              "#00CCFF",
              "#3300CC",
              "#3300FF",
              "#3333CC",
              "#3333FF",
              "#3366CC",
              "#3366FF",
              "#3399CC",
              "#3399FF",
              "#33CC00",
              "#33CC33",
              "#33CC66",
              "#33CC99",
              "#33CCCC",
              "#33CCFF",
              "#6600CC",
              "#6600FF",
              "#6633CC",
              "#6633FF",
              "#66CC00",
              "#66CC33",
              "#9900CC",
              "#9900FF",
              "#9933CC",
              "#9933FF",
              "#99CC00",
              "#99CC33",
              "#CC0000",
              "#CC0033",
              "#CC0066",
              "#CC0099",
              "#CC00CC",
              "#CC00FF",
              "#CC3300",
              "#CC3333",
              "#CC3366",
              "#CC3399",
              "#CC33CC",
              "#CC33FF",
              "#CC6600",
              "#CC6633",
              "#CC9900",
              "#CC9933",
              "#CCCC00",
              "#CCCC33",
              "#FF0000",
              "#FF0033",
              "#FF0066",
              "#FF0099",
              "#FF00CC",
              "#FF00FF",
              "#FF3300",
              "#FF3333",
              "#FF3366",
              "#FF3399",
              "#FF33CC",
              "#FF33FF",
              "#FF6600",
              "#FF6633",
              "#FF9900",
              "#FF9933",
              "#FFCC00",
              "#FFCC33"
            ];
            function t() {
              var g = u("colors");
              return /^(no|off|false|disabled)$/i.test(g) ? !1 : typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : !!(typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
              typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
              // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
              typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
              typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
            }
            function o(g) {
              var f = this.useColors;
              if (g[0] = (f ? "%c" : "") + this.namespace + (f ? " %c" : " ") + g[0] + (f ? "%c " : " ") + "+" + i.exports.humanize(this.diff), !!f) {
                var p = "color: " + this.color;
                g.splice(1, 0, p, "color: inherit");
                var v = 0, b = 0;
                g[0].replace(/%[a-zA-Z%]/g, function(m) {
                  m !== "%%" && (v++, m === "%c" && (b = v));
                }), g.splice(b, 0, p);
              }
            }
            function l() {
              return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
            }
            function c(g) {
              try {
                g == null ? r.storage.removeItem("debug") : r.storage.setItem("debug", g);
              } catch {
              }
            }
            function d() {
              var g;
              try {
                g = r.storage.getItem("debug");
              } catch {
              }
              return !g && typeof n != "undefined" && "env" in n && (g = n.env.DEBUG), g;
            }
            function u(g) {
              var f = "debug_" + g.toLowerCase();
              try {
                return r.storage.getItem(f);
              } catch {
                return typeof n != "undefined" && "env" in n ? n.env[f.toUpperCase()] : void 0;
              }
            }
            function h() {
              try {
                return localStorage;
              } catch {
              }
            }
            i.exports = e(409)(r);
            var A = i.exports.formatters;
            A.j = function(g) {
              try {
                return JSON.stringify(g);
              } catch (f) {
                return "[UnexpectedJSONParseError]: " + f.message;
              }
            };
          }).call(this, e(27));
        },
        /* 409 */
        /***/
        function(i, r, e) {
          i.exports = function(t) {
            l.debug = l.default = l, l.coerce = A, l.disable = u, l.enable = d, l.enabled = h, l.humanize = e(410), Object.keys(t).forEach(function(g) {
              l[g] = t[g];
            }), l.instances = [], l.names = [], l.skips = [], l.formatters = {};
            function o(g) {
              var f = 0, p;
              for (p in g)
                f = (f << 5) - f + g.charCodeAt(p), f |= 0;
              return l.colors[Math.abs(f) % l.colors.length];
            }
            l.selectColor = o;
            function l(g) {
              var f;
              function p() {
                if (p.enabled) {
                  var v = p, b = +/* @__PURE__ */ new Date(), m = b - (f || b);
                  v.diff = m, v.prev = f, v.curr = b, f = b;
                  for (var y = new Array(arguments.length), U = 0; U < y.length; U++)
                    y[U] = arguments[U];
                  y[0] = l.coerce(y[0]), typeof y[0] != "string" && y.unshift("%O");
                  var B = 0;
                  y[0] = y[0].replace(/%([a-zA-Z%])/g, function(N, J) {
                    if (N === "%%") return N;
                    B++;
                    var w = l.formatters[J];
                    if (typeof w == "function") {
                      var W = y[B];
                      N = w.call(v, W), y.splice(B, 1), B--;
                    }
                    return N;
                  }), l.formatArgs.call(v, y);
                  var Q = v.log || l.log;
                  Q.apply(v, y);
                }
              }
              return p.namespace = g, p.enabled = l.enabled(g), p.useColors = l.useColors(), p.color = o(g), p.destroy = c, typeof l.init == "function" && l.init(p), l.instances.push(p), p;
            }
            function c() {
              var g = l.instances.indexOf(this);
              return g !== -1 ? (l.instances.splice(g, 1), !0) : !1;
            }
            function d(g) {
              l.save(g), l.names = [], l.skips = [];
              var f, p = (typeof g == "string" ? g : "").split(/[\s,]+/), v = p.length;
              for (f = 0; f < v; f++)
                p[f] && (g = p[f].replace(/\*/g, ".*?"), g[0] === "-" ? l.skips.push(new RegExp("^" + g.substr(1) + "$")) : l.names.push(new RegExp("^" + g + "$")));
              for (f = 0; f < l.instances.length; f++) {
                var b = l.instances[f];
                b.enabled = l.enabled(b.namespace);
              }
            }
            function u() {
              l.enable("");
            }
            function h(g) {
              if (g[g.length - 1] === "*")
                return !0;
              var f, p;
              for (f = 0, p = l.skips.length; f < p; f++)
                if (l.skips[f].test(g))
                  return !1;
              for (f = 0, p = l.names.length; f < p; f++)
                if (l.names[f].test(g))
                  return !0;
              return !1;
            }
            function A(g) {
              return g instanceof Error ? g.stack || g.message : g;
            }
            return l.enable(l.load()), l;
          };
        },
        /* 410 */
        /***/
        function(i, r) {
          var e = 1e3, n = e * 60, t = n * 60, o = t * 24, l = o * 7, c = o * 365.25;
          i.exports = function(g, f) {
            f = f || {};
            var p = typeof g;
            if (p === "string" && g.length > 0)
              return d(g);
            if (p === "number" && isFinite(g))
              return f.long ? h(g) : u(g);
            throw new Error(
              "val is not a non-empty string or a valid number. val=" + JSON.stringify(g)
            );
          };
          function d(g) {
            if (g = String(g), !(g.length > 100)) {
              var f = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
                g
              );
              if (f) {
                var p = parseFloat(f[1]), v = (f[2] || "ms").toLowerCase();
                switch (v) {
                  case "years":
                  case "year":
                  case "yrs":
                  case "yr":
                  case "y":
                    return p * c;
                  case "weeks":
                  case "week":
                  case "w":
                    return p * l;
                  case "days":
                  case "day":
                  case "d":
                    return p * o;
                  case "hours":
                  case "hour":
                  case "hrs":
                  case "hr":
                  case "h":
                    return p * t;
                  case "minutes":
                  case "minute":
                  case "mins":
                  case "min":
                  case "m":
                    return p * n;
                  case "seconds":
                  case "second":
                  case "secs":
                  case "sec":
                  case "s":
                    return p * e;
                  case "milliseconds":
                  case "millisecond":
                  case "msecs":
                  case "msec":
                  case "ms":
                    return p;
                  default:
                    return;
                }
              }
            }
          }
          function u(g) {
            var f = Math.abs(g);
            return f >= o ? Math.round(g / o) + "d" : f >= t ? Math.round(g / t) + "h" : f >= n ? Math.round(g / n) + "m" : f >= e ? Math.round(g / e) + "s" : g + "ms";
          }
          function h(g) {
            var f = Math.abs(g);
            return f >= o ? A(g, f, o, "day") : f >= t ? A(g, f, t, "hour") : f >= n ? A(g, f, n, "minute") : f >= e ? A(g, f, e, "second") : g + " ms";
          }
          function A(g, f, p, v) {
            var b = f >= p * 1.5;
            return Math.round(g / p) + " " + v + (b ? "s" : "");
          }
        },
        /* 411 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(207));
          const o = new t.default();
          function l(d, u) {
            if (u === void 0)
              return d;
            o.has(u) || o.set(u, new t.default());
            const h = o.get(u);
            return h.has(d) || h.set(d, d.bind(u)), h.get(d);
          }
          var c = l;
          r.default = c;
        },
        /* 412 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            var n, t;
            if (typeof WeakMap != "function") return !1;
            try {
              n = new WeakMap([[t = {}, "one"], [{}, "two"], [{}, "three"]]);
            } catch {
              return !1;
            }
            return !(String(n) !== "[object WeakMap]" || typeof n.set != "function" || n.set({}, 1) !== n || typeof n.delete != "function" || typeof n.has != "function" || n.get(t) !== "one");
          };
        },
        /* 413 */
        /***/
        function(i, r, e) {
          var n = e(47), t = e(128), o = e(416), l = e(35), c = e(417), d = e(36), u = e(214), h = e(459), A = e(48).toStringTag, g = e(460), f = Array.isArray, p = Object.defineProperty, v = Object.prototype.hasOwnProperty, b = Object.getPrototypeOf, m;
          i.exports = m = function() {
            var y = arguments[0], U;
            if (!(this instanceof m)) throw new TypeError("Constructor requires 'new'");
            return U = g && t && WeakMap !== m ? t(/* @__PURE__ */ new WeakMap(), b(this)) : this, n(y) && (f(y) || (y = u(y))), p(U, "__weakMapData__", d("c", "$weakMap$" + c())), y && h(y, function(B) {
              l(B), U.set(B[0], B[1]);
            }), U;
          }, g && (t && t(m, WeakMap), m.prototype = Object.create(WeakMap.prototype, { constructor: d(m) })), Object.defineProperties(m.prototype, {
            delete: d(function(y) {
              return v.call(o(y), this.__weakMapData__) ? (delete y[this.__weakMapData__], !0) : !1;
            }),
            get: d(function(y) {
              if (v.call(o(y), this.__weakMapData__))
                return y[this.__weakMapData__];
            }),
            has: d(function(y) {
              return v.call(o(y), this.__weakMapData__);
            }),
            set: d(function(y, U) {
              return p(o(y), this.__weakMapData__, d("c", U)), this;
            }),
            toString: d(function() {
              return "[object WeakMap]";
            })
          }), p(m.prototype, A, d("c", "WeakMap"));
        },
        /* 414 */
        /***/
        function(i, r, e) {
          i.exports = function() {
          };
        },
        /* 415 */
        /***/
        function(i, r, e) {
          var n = Object.create, t;
          e(208)() || (t = e(209)), i.exports = function() {
            var o, l, c;
            return !t || t.level !== 1 ? n : (o = {}, l = {}, c = { configurable: !1, enumerable: !1, writable: !0, value: void 0 }, Object.getOwnPropertyNames(Object.prototype).forEach(function(d) {
              if (d === "__proto__") {
                l[d] = {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: void 0
                };
                return;
              }
              l[d] = c;
            }), Object.defineProperties(o, l), Object.defineProperty(t, "nullPolyfill", {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: o
            }), function(d, u) {
              return n(d === null ? o : d, u);
            });
          }();
        },
        /* 416 */
        /***/
        function(i, r, e) {
          var n = e(210);
          i.exports = function(t) {
            if (!n(t)) throw new TypeError(t + " is not an Object");
            return t;
          };
        },
        /* 417 */
        /***/
        function(i, r, e) {
          var n = /* @__PURE__ */ Object.create(null), t = Math.random;
          i.exports = function() {
            var o;
            do
              o = t().toString(36).slice(2);
            while (n[o]);
            return o;
          };
        },
        /* 418 */
        /***/
        function(i, r, e) {
          var n = e(419);
          i.exports = function(t) {
            if (typeof t != "function" || !hasOwnProperty.call(t, "length")) return !1;
            try {
              if (typeof t.length != "number" || typeof t.call != "function" || typeof t.apply != "function") return !1;
            } catch {
              return !1;
            }
            return !n(t);
          };
        },
        /* 419 */
        /***/
        function(i, r, e) {
          var n = e(129);
          i.exports = function(t) {
            if (!n(t)) return !1;
            try {
              return t.constructor ? t.constructor.prototype === t : !1;
            } catch {
              return !1;
            }
          };
        },
        /* 420 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            var n = Object.assign, t;
            return typeof n != "function" ? !1 : (t = { foo: "raz" }, n(t, { bar: "dwa" }, { trzy: "trzy" }), t.foo + t.bar + t.trzy === "razdwatrzy");
          };
        },
        /* 421 */
        /***/
        function(i, r, e) {
          var n = e(422), t = e(35), o = Math.max;
          i.exports = function(l, c) {
            var d, u, h = o(arguments.length, 2), A;
            for (l = Object(t(l)), A = function(g) {
              try {
                l[g] = c[g];
              } catch (f) {
                d || (d = f);
              }
            }, u = 1; u < h; ++u)
              c = arguments[u], n(c).forEach(A);
            if (d !== void 0) throw d;
            return l;
          };
        },
        /* 422 */
        /***/
        function(i, r, e) {
          i.exports = e(423)() ? Object.keys : e(424);
        },
        /* 423 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            try {
              return Object.keys("primitive"), !0;
            } catch {
              return !1;
            }
          };
        },
        /* 424 */
        /***/
        function(i, r, e) {
          var n = e(47), t = Object.keys;
          i.exports = function(o) {
            return t(n(o) ? Object(o) : o);
          };
        },
        /* 425 */
        /***/
        function(i, r, e) {
          var n = "razdwatrzy";
          i.exports = function() {
            return typeof n.contains != "function" ? !1 : n.contains("dwa") === !0 && n.contains("foo") === !1;
          };
        },
        /* 426 */
        /***/
        function(i, r, e) {
          var n = String.prototype.indexOf;
          i.exports = function(t) {
            return n.call(this, t, arguments[1]) > -1;
          };
        },
        /* 427 */
        /***/
        function(i, r, e) {
          var n = e(128), t = e(213), o = e(36), l = e(48), c = e(216), d = Object.defineProperty, u;
          u = i.exports = function(h, A) {
            if (!(this instanceof u)) throw new TypeError("Constructor requires 'new'");
            c.call(this, h), A ? t.call(A, "key+value") ? A = "key+value" : t.call(A, "key") ? A = "key" : A = "value" : A = "value", d(this, "__kind__", o("", A));
          }, n && n(u, c), delete u.prototype.constructor, u.prototype = Object.create(c.prototype, {
            _resolve: o(function(h) {
              return this.__kind__ === "value" ? this.__list__[h] : this.__kind__ === "key+value" ? [h, this.__list__[h]] : h;
            })
          }), d(u.prototype, l.toStringTag, o("c", "Array Iterator"));
        },
        /* 428 */
        /***/
        function(i, r, e) {
          var n = e(93), t = { object: !0, symbol: !0 };
          i.exports = function() {
            var o = n.Symbol, l;
            if (typeof o != "function") return !1;
            l = o("test symbol");
            try {
              String(l);
            } catch {
              return !1;
            }
            return !(!t[typeof o.iterator] || !t[typeof o.toPrimitive] || !t[typeof o.toStringTag]);
          };
        },
        /* 429 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            return typeof globalThis != "object" || !globalThis ? !1 : globalThis.Array === Array;
          };
        },
        /* 430 */
        /***/
        function(i, r) {
          var e = function() {
            if (typeof self == "object" && self) return self;
            if (typeof window == "object" && window) return window;
            throw new Error("Unable to resolve global `this`");
          };
          i.exports = function() {
            if (this) return this;
            try {
              Object.defineProperty(Object.prototype, "__global__", {
                get: function() {
                  return this;
                },
                configurable: !0
              });
            } catch {
              return e();
            }
            try {
              return __global__ || e();
            } finally {
              delete Object.prototype.__global__;
            }
          }();
        },
        /* 431 */
        /***/
        function(i, r, e) {
          var n = e(36), t = e(215), o = e(93).Symbol, l = e(433), c = e(434), d = e(435), u = Object.create, h = Object.defineProperties, A = Object.defineProperty, g, f, p;
          if (typeof o == "function")
            try {
              String(o()), p = !0;
            } catch {
            }
          else
            o = null;
          f = function(b) {
            if (this instanceof f) throw new TypeError("Symbol is not a constructor");
            return g(b);
          }, i.exports = g = function v(b) {
            var m;
            if (this instanceof v) throw new TypeError("Symbol is not a constructor");
            return p ? o(b) : (m = u(f.prototype), b = b === void 0 ? "" : String(b), h(m, {
              __description__: n("", b),
              __name__: n("", l(b))
            }));
          }, c(g), d(g), h(f.prototype, {
            constructor: n(g),
            toString: n("", function() {
              return this.__name__;
            })
          }), h(g.prototype, {
            toString: n(function() {
              return "Symbol (" + t(this).__description__ + ")";
            }),
            valueOf: n(function() {
              return t(this);
            })
          }), A(
            g.prototype,
            g.toPrimitive,
            n("", function() {
              var v = t(this);
              return typeof v == "symbol" ? v : v.toString();
            })
          ), A(g.prototype, g.toStringTag, n("c", "Symbol")), A(
            f.prototype,
            g.toStringTag,
            n("c", g.prototype[g.toStringTag])
          ), A(
            f.prototype,
            g.toPrimitive,
            n("c", g.prototype[g.toPrimitive])
          );
        },
        /* 432 */
        /***/
        function(i, r, e) {
          i.exports = function(n) {
            return n ? typeof n == "symbol" ? !0 : !n.constructor || n.constructor.name !== "Symbol" ? !1 : n[n.constructor.toStringTag] === "Symbol" : !1;
          };
        },
        /* 433 */
        /***/
        function(i, r, e) {
          var n = e(36), t = Object.create, o = Object.defineProperty, l = Object.prototype, c = t(null);
          i.exports = function(d) {
            for (var u = 0, h, A; c[d + (u || "")]; ) ++u;
            return d += u || "", c[d] = !0, h = "@@" + d, o(
              l,
              h,
              n.gs(null, function(g) {
                A || (A = !0, o(this, h, n(g)), A = !1);
              })
            ), h;
          };
        },
        /* 434 */
        /***/
        function(i, r, e) {
          var n = e(36), t = e(93).Symbol;
          i.exports = function(o) {
            return Object.defineProperties(o, {
              // To ensure proper interoperability with other native functions (e.g. Array.from)
              // fallback to eventual native implementation of given symbol
              hasInstance: n(
                "",
                t && t.hasInstance || o("hasInstance")
              ),
              isConcatSpreadable: n(
                "",
                t && t.isConcatSpreadable || o("isConcatSpreadable")
              ),
              iterator: n("", t && t.iterator || o("iterator")),
              match: n("", t && t.match || o("match")),
              replace: n("", t && t.replace || o("replace")),
              search: n("", t && t.search || o("search")),
              species: n("", t && t.species || o("species")),
              split: n("", t && t.split || o("split")),
              toPrimitive: n(
                "",
                t && t.toPrimitive || o("toPrimitive")
              ),
              toStringTag: n(
                "",
                t && t.toStringTag || o("toStringTag")
              ),
              unscopables: n(
                "",
                t && t.unscopables || o("unscopables")
              )
            });
          };
        },
        /* 435 */
        /***/
        function(i, r, e) {
          var n = e(36), t = e(215), o = /* @__PURE__ */ Object.create(null);
          i.exports = function(l) {
            return Object.defineProperties(l, {
              for: n(function(c) {
                return o[c] ? o[c] : o[c] = l(String(c));
              }),
              keyFor: n(function(c) {
                var d;
                t(c);
                for (d in o)
                  if (o[d] === c) return d;
              })
            });
          };
        },
        /* 436 */
        /***/
        function(i, r, e) {
          var n = e(35);
          i.exports = function() {
            return n(this).length = 0, this;
          };
        },
        /* 437 */
        /***/
        function(i, r, e) {
          var n = e(56), t = e(438), o = e(442), l = e(443), c = e(212), d = e(453), u = Function.prototype.bind, h = Object.defineProperty, A = Object.prototype.hasOwnProperty, g;
          g = function(f, p, v) {
            var b = t(p) && o(p.value), m;
            return m = l(p), delete m.writable, delete m.value, m.get = function() {
              return !v.overwriteDefinition && A.call(this, f) ? b : (p.value = u.call(b, v.resolveContext ? v.resolveContext(this) : this), h(this, f, p), this[f]);
            }, m;
          }, i.exports = function(f) {
            var p = c(arguments[1]);
            return n(p.resolveContext) && o(p.resolveContext), d(f, function(v, b) {
              return g(b, v, p);
            });
          };
        },
        /* 438 */
        /***/
        function(i, r, e) {
          var n = e(217), t = e(56);
          i.exports = function(o) {
            return t(o) ? o : n(o, "Cannot use %v", arguments[1]);
          };
        },
        /* 439 */
        /***/
        function(i, r, e) {
          var n = e(56), t = e(129), o = Object.prototype.toString;
          i.exports = function(l) {
            if (!n(l)) return null;
            if (t(l)) {
              var c = l.toString;
              if (typeof c != "function" || c === o) return null;
            }
            try {
              return "" + l;
            } catch {
              return null;
            }
          };
        },
        /* 440 */
        /***/
        function(i, r, e) {
          var n = e(441), t = /[\n\r\u2028\u2029]/g;
          i.exports = function(o) {
            var l = n(o);
            return l === null ? "<Non-coercible to string value>" : (l.length > 100 && (l = l.slice(0, 99) + "…"), l = l.replace(t, function(c) {
              switch (c) {
                case `
`:
                  return "\\n";
                case "\r":
                  return "\\r";
                case "\u2028":
                  return "\\u2028";
                case "\u2029":
                  return "\\u2029";
                default:
                  throw new Error("Unexpected character");
              }
            }), l);
          };
        },
        /* 441 */
        /***/
        function(i, r, e) {
          i.exports = function(n) {
            try {
              return n.toString();
            } catch {
              try {
                return String(n);
              } catch {
                return null;
              }
            }
          };
        },
        /* 442 */
        /***/
        function(i, r, e) {
          var n = e(217), t = e(211);
          i.exports = function(o) {
            return t(o) ? o : n(o, "%v is not a plain function", arguments[1]);
          };
        },
        /* 443 */
        /***/
        function(i, r, e) {
          var n = e(444), t = e(130), o = e(35);
          i.exports = function(l) {
            var c = Object(o(l)), d = arguments[1], u = Object(arguments[2]);
            if (c !== l && !d) return c;
            var h = {};
            return d ? n(d, function(A) {
              (u.ensure || A in l) && (h[A] = l[A]);
            }) : t(h, l), h;
          };
        },
        /* 444 */
        /***/
        function(i, r, e) {
          i.exports = e(445)() ? Array.from : e(446);
        },
        /* 445 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            var n = Array.from, t, o;
            return typeof n != "function" ? !1 : (t = ["raz", "dwa"], o = n(t), !!(o && o !== t && o[1] === "dwa"));
          };
        },
        /* 446 */
        /***/
        function(i, r, e) {
          var n = e(48).iterator, t = e(91), o = e(447), l = e(448), c = e(69), d = e(35), u = e(47), h = e(92), A = Array.isArray, g = Function.prototype.call, f = { configurable: !0, enumerable: !0, writable: !0, value: null }, p = Object.defineProperty;
          i.exports = function(v) {
            var b = arguments[1], m = arguments[2], y, U, B, Q, N, J, w, W, G, Z;
            if (v = Object(d(v)), u(b) && c(b), !this || this === Array || !o(this)) {
              if (!b) {
                if (t(v))
                  return N = v.length, N !== 1 ? Array.apply(null, v) : (Q = new Array(1), Q[0] = v[0], Q);
                if (A(v)) {
                  for (Q = new Array(N = v.length), U = 0; U < N; ++U) Q[U] = v[U];
                  return Q;
                }
              }
              Q = [];
            } else
              y = this;
            if (!A(v)) {
              if ((G = v[n]) !== void 0) {
                for (w = c(G).call(v), y && (Q = new y()), W = w.next(), U = 0; !W.done; )
                  Z = b ? g.call(b, m, W.value, U) : W.value, y ? (f.value = Z, p(Q, U, f)) : Q[U] = Z, W = w.next(), ++U;
                N = U;
              } else if (h(v)) {
                for (N = v.length, y && (Q = new y()), U = 0, B = 0; U < N; ++U)
                  Z = v[U], U + 1 < N && (J = Z.charCodeAt(0), J >= 55296 && J <= 56319 && (Z += v[++U])), Z = b ? g.call(b, m, Z, B) : Z, y ? (f.value = Z, p(Q, B, f)) : Q[B] = Z, ++B;
                N = B;
              }
            }
            if (N === void 0)
              for (N = l(v.length), y && (Q = new y(N)), U = 0; U < N; ++U)
                Z = b ? g.call(b, m, v[U], U) : v[U], y ? (f.value = Z, p(Q, U, f)) : Q[U] = Z;
            return y && (f.value = null, Q.length = N), Q;
          };
        },
        /* 447 */
        /***/
        function(i, r, e) {
          var n = Object.prototype.toString, t = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
          i.exports = function(o) {
            return typeof o == "function" && t(n.call(o));
          };
        },
        /* 448 */
        /***/
        function(i, r, e) {
          var n = e(449), t = Math.max;
          i.exports = function(o) {
            return t(0, n(o));
          };
        },
        /* 449 */
        /***/
        function(i, r, e) {
          var n = e(450), t = Math.abs, o = Math.floor;
          i.exports = function(l) {
            return isNaN(l) ? 0 : (l = Number(l), l === 0 || !isFinite(l) ? l : n(l) * o(t(l)));
          };
        },
        /* 450 */
        /***/
        function(i, r, e) {
          i.exports = e(451)() ? Math.sign : e(452);
        },
        /* 451 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            var n = Math.sign;
            return typeof n != "function" ? !1 : n(10) === 1 && n(-20) === -1;
          };
        },
        /* 452 */
        /***/
        function(i, r, e) {
          i.exports = function(n) {
            return n = Number(n), isNaN(n) || n === 0 ? n : n > 0 ? 1 : -1;
          };
        },
        /* 453 */
        /***/
        function(i, r, e) {
          var n = e(69), t = e(454), o = Function.prototype.call;
          i.exports = function(l, c) {
            var d = {}, u = arguments[2];
            return n(c), t(l, function(h, A, g, f) {
              d[A] = o.call(c, u, h, A, g, f);
            }), d;
          };
        },
        /* 454 */
        /***/
        function(i, r, e) {
          i.exports = e(455)("forEach");
        },
        /* 455 */
        /***/
        function(i, r, e) {
          var n = e(69), t = e(35), o = Function.prototype.bind, l = Function.prototype.call, c = Object.keys, d = Object.prototype.propertyIsEnumerable;
          i.exports = function(u, h) {
            return function(A, g) {
              var f, p = arguments[2], v = arguments[3];
              return A = Object(t(A)), n(g), f = c(A), v && f.sort(typeof v == "function" ? o.call(v, A) : void 0), typeof u != "function" && (u = f[u]), l.call(u, f, function(b, m) {
                return d.call(A, b) ? l.call(g, p, A[b], b, A, m) : h;
              });
            };
          };
        },
        /* 456 */
        /***/
        function(i, r, e) {
          var n = e(128), t = e(36), o = e(48), l = e(216), c = Object.defineProperty, d;
          d = i.exports = function(u) {
            if (!(this instanceof d)) throw new TypeError("Constructor requires 'new'");
            u = String(u), l.call(this, u), c(this, "__length__", t("", u.length));
          }, n && n(d, l), delete d.prototype.constructor, d.prototype = Object.create(l.prototype, {
            _next: t(function() {
              if (this.__list__) {
                if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
                this._unBind();
              }
            }),
            _resolve: t(function(u) {
              var h = this.__list__[u], A;
              return this.__nextIndex__ === this.__length__ ? h : (A = h.charCodeAt(0), A >= 55296 && A <= 56319 ? h + this.__list__[this.__nextIndex__++] : h);
            })
          }), c(d.prototype, o.toStringTag, t("c", "String Iterator"));
        },
        /* 457 */
        /***/
        function(i, r, e) {
          var n = e(458);
          i.exports = function(t) {
            if (!n(t)) throw new TypeError(t + " is not iterable");
            return t;
          };
        },
        /* 458 */
        /***/
        function(i, r, e) {
          var n = e(91), t = e(47), o = e(92), l = e(48).iterator, c = Array.isArray;
          i.exports = function(d) {
            return t(d) ? c(d) || o(d) || n(d) ? !0 : typeof d[l] == "function" : !1;
          };
        },
        /* 459 */
        /***/
        function(i, r, e) {
          var n = e(91), t = e(69), o = e(92), l = e(214), c = Array.isArray, d = Function.prototype.call, u = Array.prototype.some;
          i.exports = function(h, A) {
            var g, f = arguments[2], p, v, b, m, y, U, B;
            if (c(h) || n(h) ? g = "array" : o(h) ? g = "string" : h = l(h), t(A), v = function() {
              b = !0;
            }, g === "array") {
              u.call(h, function(Q) {
                return d.call(A, f, Q, v), b;
              });
              return;
            }
            if (g === "string") {
              for (y = h.length, m = 0; m < y && (U = h[m], m + 1 < y && (B = U.charCodeAt(0), B >= 55296 && B <= 56319 && (U += h[++m])), d.call(A, f, U, v), !b); ++m)
                ;
              return;
            }
            for (p = h.next(); !p.done; ) {
              if (d.call(A, f, p.value, v), b) return;
              p = h.next();
            }
          };
        },
        /* 460 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            return typeof WeakMap != "function" ? !1 : Object.prototype.toString.call(/* @__PURE__ */ new WeakMap()) === "[object WeakMap]";
          }();
        },
        /* 461 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t, o) {
            const l = (c, d) => () => {
              throw new Error(`Cannot ${c} ${d}, ${t} is destroyed`);
            };
            Object.keys(o).forEach((c) => {
              typeof o[c] == "function" ? o[c] = l("call", c) : Object.defineProperty(o, c, {
                get: l("get", c),
                set: l("set", c)
              });
            });
          }
        },
        /* 462 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = (o) => {
            if ("srcObject" in o)
              return;
            const l = window && window.URL;
            "srcObject" in window.HTMLMediaElement.prototype || Object.defineProperty(o, "srcObject", {
              get() {
                return this._srcObject;
              },
              set(c) {
                const d = this;
                if (this._srcObject = c, this.src && l.revokeObjectURL(this.src), !c) {
                  this.src = "";
                  return;
                }
                return this.src = l.createObjectURL(c), c.addEventListener("addtrack", () => {
                  d.src && l.revokeObjectURL(d.src), d.src = l.createObjectURL(c);
                }), c.addEventListener("removetrack", () => {
                  d.src && l.revokeObjectURL(d.src), d.src = l.createObjectURL(c);
                }), this._srcObject;
              }
            });
          };
          r.default = t;
        },
        /* 463 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = (c) => !(!c || typeof c.getBoundingClientRect != "function"), t = (c) => {
            const d = c.getBoundingClientRect(), u = window.innerHeight || document.documentElement.clientHeight, h = window.innerWidth || document.documentElement.clientWidth, A = d.top <= u && d.top + d.height >= 0, g = d.left <= h && d.left + d.width >= 0;
            return A && g;
          }, o = (c) => {
            const d = (u) => u.style && u.style.visibility === "hidden" ? !0 : u.parentNode ? d(u.parentNode) : !1;
            return c.offsetParent !== null && !d(c);
          };
          var l = (c) => n(c) && t(c) && o(c);
          r.default = l;
        },
        /* 464 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = e(465), l = e(466), c = t(e(545)), d = t(e(546));
            const u = (m) => {
              var y, U;
              return m = m || ((y = typeof window !== void 0 ? window : Dn) == null ? void 0 : y.navigator), ((U = m) == null ? void 0 : U.userAgent.toLowerCase().indexOf("electron")) >= 0;
            }, h = () => {
              var m, y, U;
              return typeof ((m = typeof window !== void 0 ? window : Dn) == null || (y = m.process) == null || (U = y.versions) == null ? void 0 : U.node) == "string" && !u();
            };
            let A;
            const g = () => {
              A = {
                // @todo why is the default -1?;
                version: -1,
                name: "unknown"
              };
            }, f = () => {
              A.name = "Node", A.isNode = !0, A.version = parseInt(n.versions.node, 10), A.userAgent = `${A.name} ${A.version}`;
            }, p = (m) => {
              if (m = m || (typeof window !== void 0 ? window : Dn).navigator, A.userAgent = m.userAgent.toLowerCase(), A.name = "unknown", A.userAgent.indexOf("opera") > -1 || A.userAgent.indexOf("opr/") > -1)
                A.name = "Opera", A.isOpera = !0, /opr\/([0-9]{1,}[.0-9]{0,})/.exec(A.userAgent) !== null && (A.version = parseFloat(RegExp.$1));
              else if (A.userAgent.indexOf("firefox") > -1)
                A.name = "Firefox", A.isFirefox = !0, /firefox\/([0-9]{1,}[.0-9]{0,})/.exec(A.userAgent) !== null && (A.version = parseFloat(RegExp.$1));
              else if (A.userAgent.match(/edge?\/(\d+)(?:\.\d+)+$/)) {
                A.name = "Edge", A.isEdge = !0;
                const y = RegExp.$1;
                A.version = parseInt(y, 10);
              } else A.userAgent.indexOf("chrome") > -1 ? (A.name = "Chrome", A.isElectron = u(m), A.isElectron ? A.electronVersion = (0, d.default)(m.userAgent) : A.isChrome = !0, /chrome\/([0-9]{1,}[.0-9]{0,})/.exec(A.userAgent) !== null && (A.version = parseFloat(RegExp.$1))) : m.vendor && m.vendor.toLowerCase().indexOf("apple") > -1 ? (A.name = "Safari", A.isSafari = !0, A.isiPhone = (0, o.isiPhone)(m.userAgent), A.isiPad = (0, o.isiPad)(m.userAgent), A.isiOS = (0, o.isiOS)(m.userAgent), A.isiOS && (A.iOSVersion = (0, c.default)(m.userAgent)), (/version\/([0-9]{1,}[.0-9]{0,})/.exec(A.userAgent) !== null || /fxios\/([0-9]{1,}[.0-9]{0,})/.exec(A.userAgent) !== null || /crios\/([0-9]{1,}[.0-9]{0,})/.exec(A.userAgent) !== null) && (A.version = parseFloat(RegExp.$1))) : A.userAgent.indexOf("applewebkit") > -1 && A.userAgent.indexOf("version") === -1 && (A.isIosWebView = !0);
              A.isChromiumEdge = A.name === "Edge" && A.version >= 79, A.isLegacyEdge = A.name === "Edge" && A.version < 79, A.isLegacyElectron = A.isElectron && A.electronVersion < 16, A.isLegacyChrome = A.isChrome && A.version < 87, A.isLegacyFirefox = A.isFirefox && A.version <= 98, A.isChromium = !!(A.isChrome || A.isChromiumEdge || A.isElectron || A.isOpera), A.isAndroid = A.userAgent.indexOf("android") > -1, A.userAgent = m.userAgent, A.protocol = location.protocol, A.hostName = location.hostName, A.isProd = (0, l.isProd)(), A.isRel = (0, l.isRel)(), A.isDev = (0, l.isDev)(), (A.version === -1 || A.name === "unknown" || A.isiOS && !A.iOSVersion) && (A.error = !0);
            };
            var b = {
              parse: (m) => (g(), h() ? f() : p(m), A),
              isNode: h
            };
            r.default = b;
          }).call(this, e(27));
        },
        /* 465 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.isiPhone = r.isiPad = r.isiOS = void 0;
          const n = (c) => /iPhone/.test(c);
          r.isiPhone = n;
          const t = (c) => {
            try {
              return c.includes("Mac") && "ontouchend" in document;
            } catch {
              return !1;
            }
          }, o = (c) => /iPad/.test(c) || t(c);
          r.isiPad = o;
          const l = (c) => n(c) || o(c);
          r.isiOS = l;
        },
        /* 466 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.isRel = r.isProd = r.isDev = void 0;
          var t = n(e(37));
          const o = (0, t.default)(), l = (h, A) => (A.StaticConfig || o.onlyLocal()).apiUrl.includes(h), c = function(A) {
            return A === void 0 && (A = {}), l("anvil.opentok.com", A);
          };
          r.isProd = c;
          const d = function(A) {
            return A === void 0 && (A = {}), l("api.dev.opentok.com", A);
          };
          r.isDev = d;
          const u = function(A) {
            return A === void 0 && (A = {}), l("api.rel.opentok.com", A);
          };
          r.isRel = u;
        },
        /* 467 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(19), o = e(219), l = e(468), c = e(225), d = e(131);
            function u(A) {
              var g = new l(A), f = o(l.prototype.request, g);
              return t.extend(f, l.prototype, g), t.extend(f, g), f;
            }
            var h = u(d);
            h.Axios = l, h.create = function(g) {
              return u(c(h.defaults, g));
            }, h.Cancel = e(226), h.CancelToken = e(482), h.isCancel = e(224), h.all = function(g) {
              return n.all(g);
            }, h.spread = e(483), h.isAxiosError = e(484), i.exports = h, i.exports.default = h;
          }).call(this, e(2));
        },
        /* 468 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(19), o = e(220), l = e(469), c = e(470), d = e(225), u = e(480), h = u.validators;
            function A(g) {
              this.defaults = g, this.interceptors = {
                request: new l(),
                response: new l()
              };
            }
            A.prototype.request = function(f) {
              typeof f == "string" ? (f = arguments[1] || {}, f.url = arguments[0]) : f = f || {}, f = d(this.defaults, f), f.method ? f.method = f.method.toLowerCase() : this.defaults.method ? f.method = this.defaults.method.toLowerCase() : f.method = "get";
              var p = f.transitional;
              p !== void 0 && u.assertOptions(p, {
                silentJSONParsing: h.transitional(h.boolean, "1.0.0"),
                forcedJSONParsing: h.transitional(h.boolean, "1.0.0"),
                clarifyTimeoutError: h.transitional(h.boolean, "1.0.0")
              }, !1);
              var v = [], b = !0;
              this.interceptors.request.forEach(function(w) {
                typeof w.runWhen == "function" && w.runWhen(f) === !1 || (b = b && w.synchronous, v.unshift(w.fulfilled, w.rejected));
              });
              var m = [];
              this.interceptors.response.forEach(function(w) {
                m.push(w.fulfilled, w.rejected);
              });
              var y;
              if (!b) {
                var U = [c, void 0];
                for (Array.prototype.unshift.apply(U, v), U = U.concat(m), y = n.resolve(f); U.length; )
                  y = y.then(U.shift(), U.shift());
                return y;
              }
              for (var B = f; v.length; ) {
                var Q = v.shift(), N = v.shift();
                try {
                  B = Q(B);
                } catch (J) {
                  N(J);
                  break;
                }
              }
              try {
                y = c(B);
              } catch (J) {
                return n.reject(J);
              }
              for (; m.length; )
                y = y.then(m.shift(), m.shift());
              return y;
            }, A.prototype.getUri = function(f) {
              return f = d(this.defaults, f), o(f.url, f.params, f.paramsSerializer).replace(/^\?/, "");
            }, t.forEach(["delete", "get", "head", "options"], function(f) {
              A.prototype[f] = function(p, v) {
                return this.request(d(v || {}, {
                  method: f,
                  url: p,
                  data: (v || {}).data
                }));
              };
            }), t.forEach(["post", "put", "patch"], function(f) {
              A.prototype[f] = function(p, v, b) {
                return this.request(d(b || {}, {
                  method: f,
                  url: p,
                  data: v
                }));
              };
            }), i.exports = A;
          }).call(this, e(2));
        },
        /* 469 */
        /***/
        function(i, r, e) {
          var n = e(19);
          function t() {
            this.handlers = [];
          }
          t.prototype.use = function(l, c, d) {
            return this.handlers.push({
              fulfilled: l,
              rejected: c,
              synchronous: d ? d.synchronous : !1,
              runWhen: d ? d.runWhen : null
            }), this.handlers.length - 1;
          }, t.prototype.eject = function(l) {
            this.handlers[l] && (this.handlers[l] = null);
          }, t.prototype.forEach = function(l) {
            n.forEach(this.handlers, function(d) {
              d !== null && l(d);
            });
          }, i.exports = t;
        },
        /* 470 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(19), o = e(471), l = e(224), c = e(131);
            function d(u) {
              u.cancelToken && u.cancelToken.throwIfRequested();
            }
            i.exports = function(h) {
              d(h), h.headers = h.headers || {}, h.data = o.call(
                h,
                h.data,
                h.headers,
                h.transformRequest
              ), h.headers = t.merge(
                h.headers.common || {},
                h.headers[h.method] || {},
                h.headers
              ), t.forEach(
                ["delete", "get", "head", "post", "put", "patch", "common"],
                function(f) {
                  delete h.headers[f];
                }
              );
              var A = h.adapter || c.adapter;
              return A(h).then(function(f) {
                return d(h), f.data = o.call(
                  h,
                  f.data,
                  f.headers,
                  h.transformResponse
                ), f;
              }, function(f) {
                return l(f) || (d(h), f && f.response && (f.response.data = o.call(
                  h,
                  f.response.data,
                  f.response.headers,
                  h.transformResponse
                ))), n.reject(f);
              });
            };
          }).call(this, e(2));
        },
        /* 471 */
        /***/
        function(i, r, e) {
          var n = e(19), t = e(131);
          i.exports = function(l, c, d) {
            var u = this || t;
            return n.forEach(d, function(A) {
              l = A.call(u, l, c);
            }), l;
          };
        },
        /* 472 */
        /***/
        function(i, r, e) {
          var n = e(19);
          i.exports = function(o, l) {
            n.forEach(o, function(d, u) {
              u !== l && u.toUpperCase() === l.toUpperCase() && (o[l] = d, delete o[u]);
            });
          };
        },
        /* 473 */
        /***/
        function(i, r, e) {
          var n = e(223);
          i.exports = function(o, l, c) {
            var d = c.config.validateStatus;
            !c.status || !d || d(c.status) ? o(c) : l(n(
              "Request failed with status code " + c.status,
              c.config,
              null,
              c.request,
              c
            ));
          };
        },
        /* 474 */
        /***/
        function(i, r, e) {
          var n = e(19);
          i.exports = n.isStandardBrowserEnv() ? (
            // Standard browser envs support document.cookie
            /* @__PURE__ */ function() {
              return {
                write: function(l, c, d, u, h, A) {
                  var g = [];
                  g.push(l + "=" + encodeURIComponent(c)), n.isNumber(d) && g.push("expires=" + new Date(d).toGMTString()), n.isString(u) && g.push("path=" + u), n.isString(h) && g.push("domain=" + h), A === !0 && g.push("secure"), document.cookie = g.join("; ");
                },
                read: function(l) {
                  var c = document.cookie.match(new RegExp("(^|;\\s*)(" + l + ")=([^;]*)"));
                  return c ? decodeURIComponent(c[3]) : null;
                },
                remove: function(l) {
                  this.write(l, "", Date.now() - 864e5);
                }
              };
            }()
          ) : (
            // Non standard browser env (web workers, react-native) lack needed support.
            /* @__PURE__ */ function() {
              return {
                write: function() {
                },
                read: function() {
                  return null;
                },
                remove: function() {
                }
              };
            }()
          );
        },
        /* 475 */
        /***/
        function(i, r, e) {
          var n = e(476), t = e(477);
          i.exports = function(l, c) {
            return l && !n(c) ? t(l, c) : c;
          };
        },
        /* 476 */
        /***/
        function(i, r, e) {
          i.exports = function(t) {
            return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
          };
        },
        /* 477 */
        /***/
        function(i, r, e) {
          i.exports = function(t, o) {
            return o ? t.replace(/\/+$/, "") + "/" + o.replace(/^\/+/, "") : t;
          };
        },
        /* 478 */
        /***/
        function(i, r, e) {
          var n = e(19), t = [
            "age",
            "authorization",
            "content-length",
            "content-type",
            "etag",
            "expires",
            "from",
            "host",
            "if-modified-since",
            "if-unmodified-since",
            "last-modified",
            "location",
            "max-forwards",
            "proxy-authorization",
            "referer",
            "retry-after",
            "user-agent"
          ];
          i.exports = function(l) {
            var c = {}, d, u, h;
            return l && n.forEach(l.split(`
`), function(g) {
              if (h = g.indexOf(":"), d = n.trim(g.substr(0, h)).toLowerCase(), u = n.trim(g.substr(h + 1)), d) {
                if (c[d] && t.indexOf(d) >= 0)
                  return;
                d === "set-cookie" ? c[d] = (c[d] ? c[d] : []).concat([u]) : c[d] = c[d] ? c[d] + ", " + u : u;
              }
            }), c;
          };
        },
        /* 479 */
        /***/
        function(i, r, e) {
          var n = e(19);
          i.exports = n.isStandardBrowserEnv() ? (
            // Standard browser envs have full support of the APIs needed to test
            // whether the request URL is of the same origin as current location.
            function() {
              var o = /(msie|trident)/i.test(navigator.userAgent), l = document.createElement("a"), c;
              function d(u) {
                var h = u;
                return o && (l.setAttribute("href", h), h = l.href), l.setAttribute("href", h), {
                  href: l.href,
                  protocol: l.protocol ? l.protocol.replace(/:$/, "") : "",
                  host: l.host,
                  search: l.search ? l.search.replace(/^\?/, "") : "",
                  hash: l.hash ? l.hash.replace(/^#/, "") : "",
                  hostname: l.hostname,
                  port: l.port,
                  pathname: l.pathname.charAt(0) === "/" ? l.pathname : "/" + l.pathname
                };
              }
              return c = d(window.location.href), function(h) {
                var A = n.isString(h) ? d(h) : h;
                return A.protocol === c.protocol && A.host === c.host;
              };
            }()
          ) : (
            // Non standard browser envs (web workers, react-native) lack needed support.
            /* @__PURE__ */ function() {
              return function() {
                return !0;
              };
            }()
          );
        },
        /* 480 */
        /***/
        function(i, r, e) {
          var n = e(481), t = {};
          ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(u, h) {
            t[u] = function(g) {
              return typeof g === u || "a" + (h < 1 ? "n " : " ") + u;
            };
          });
          var o = {}, l = n.version.split(".");
          function c(u, h) {
            for (var A = h ? h.split(".") : l, g = u.split("."), f = 0; f < 3; f++) {
              if (A[f] > g[f])
                return !0;
              if (A[f] < g[f])
                return !1;
            }
            return !1;
          }
          t.transitional = function(h, A, g) {
            var f = A && c(A);
            function p(v, b) {
              return "[Axios v" + n.version + "] Transitional option '" + v + "'" + b + (g ? ". " + g : "");
            }
            return function(v, b, m) {
              if (h === !1)
                throw new Error(p(b, " has been removed in " + A));
              return f && !o[b] && (o[b] = !0, console.warn(
                p(
                  b,
                  " has been deprecated since v" + A + " and will be removed in the near future"
                )
              )), h ? h(v, b, m) : !0;
            };
          };
          function d(u, h, A) {
            if (typeof u != "object")
              throw new TypeError("options must be an object");
            for (var g = Object.keys(u), f = g.length; f-- > 0; ) {
              var p = g[f], v = h[p];
              if (v) {
                var b = u[p], m = b === void 0 || v(b, p, u);
                if (m !== !0)
                  throw new TypeError("option " + p + " must be " + m);
                continue;
              }
              if (A !== !0)
                throw Error("Unknown option " + p);
            }
          }
          i.exports = {
            isOlderVersion: c,
            assertOptions: d,
            validators: t
          };
        },
        /* 481 */
        /***/
        function(i) {
          i.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');
        },
        /* 482 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(226);
            function o(l) {
              if (typeof l != "function")
                throw new TypeError("executor must be a function.");
              var c;
              this.promise = new n(function(h) {
                c = h;
              });
              var d = this;
              l(function(h) {
                d.reason || (d.reason = new t(h), c(d.reason));
              });
            }
            o.prototype.throwIfRequested = function() {
              if (this.reason)
                throw this.reason;
            }, o.source = function() {
              var c, d = new o(function(h) {
                c = h;
              });
              return {
                token: d,
                cancel: c
              };
            }, i.exports = o;
          }).call(this, e(2));
        },
        /* 483 */
        /***/
        function(i, r, e) {
          i.exports = function(t) {
            return function(l) {
              return t.apply(null, l);
            };
          };
        },
        /* 484 */
        /***/
        function(i, r, e) {
          i.exports = function(t) {
            return typeof t == "object" && t.isAxiosError === !0;
          };
        },
        /* 485 */
        /***/
        function(i, r, e) {
          var n = e(227), t = n("mapKeys", e(534));
          t.placeholder = e(132), i.exports = t;
        },
        /* 486 */
        /***/
        function(i, r, e) {
          var n = e(487), t = e(132), o = Array.prototype.push;
          function l(f, p) {
            return p == 2 ? function(v, b) {
              return f.apply(void 0, arguments);
            } : function(v) {
              return f.apply(void 0, arguments);
            };
          }
          function c(f, p) {
            return p == 2 ? function(v, b) {
              return f(v, b);
            } : function(v) {
              return f(v);
            };
          }
          function d(f) {
            for (var p = f ? f.length : 0, v = Array(p); p--; )
              v[p] = f[p];
            return v;
          }
          function u(f) {
            return function(p) {
              return f({}, p);
            };
          }
          function h(f, p) {
            return function() {
              for (var v = arguments.length, b = v - 1, m = Array(v); v--; )
                m[v] = arguments[v];
              var y = m[p], U = m.slice(0, p);
              return y && o.apply(U, y), p != b && o.apply(U, m.slice(p + 1)), f.apply(this, U);
            };
          }
          function A(f, p) {
            return function() {
              var v = arguments.length;
              if (v) {
                for (var b = Array(v); v--; )
                  b[v] = arguments[v];
                var m = b[0] = p.apply(void 0, b);
                return f.apply(void 0, b), m;
              }
            };
          }
          function g(f, p, v, b) {
            var m = typeof p == "function", y = p === Object(p);
            if (y && (b = v, v = p, p = void 0), v == null)
              throw new TypeError();
            b || (b = {});
            var U = {
              cap: "cap" in b ? b.cap : !0,
              curry: "curry" in b ? b.curry : !0,
              fixed: "fixed" in b ? b.fixed : !0,
              immutable: "immutable" in b ? b.immutable : !0,
              rearg: "rearg" in b ? b.rearg : !0
            }, B = m ? v : t, Q = "curry" in b && b.curry, N = "fixed" in b && b.fixed, J = "rearg" in b && b.rearg, w = m ? v.runInContext() : void 0, W = m ? v : {
              ary: f.ary,
              assign: f.assign,
              clone: f.clone,
              curry: f.curry,
              forEach: f.forEach,
              isArray: f.isArray,
              isError: f.isError,
              isFunction: f.isFunction,
              isWeakMap: f.isWeakMap,
              iteratee: f.iteratee,
              keys: f.keys,
              rearg: f.rearg,
              toInteger: f.toInteger,
              toPath: f.toPath
            }, G = W.ary, Z = W.assign, K = W.clone, L = W.curry, O = W.forEach, de = W.isArray, oe = W.isError, fe = W.isFunction, ge = W.isWeakMap, we = W.keys, _e = W.rearg, Te = W.toInteger, Pe = W.toPath, $e = we(n.aryMethod), Bt = {
              castArray: function(on) {
                return function() {
                  var An = arguments[0];
                  return de(An) ? on(d(An)) : on.apply(void 0, arguments);
                };
              },
              iteratee: function(on) {
                return function() {
                  var An = arguments[0], Ue = arguments[1], ne = on(An, Ue), se = ne.length;
                  return U.cap && typeof Ue == "number" ? (Ue = Ue > 2 ? Ue - 2 : 1, se && se <= Ue ? ne : c(ne, Ue)) : ne;
                };
              },
              mixin: function(on) {
                return function(An) {
                  var Ue = this;
                  if (!fe(Ue))
                    return on(Ue, Object(An));
                  var ne = [];
                  return O(we(An), function(se) {
                    fe(An[se]) && ne.push([se, Ue.prototype[se]]);
                  }), on(Ue, Object(An)), O(ne, function(se) {
                    var Ce = se[1];
                    fe(Ce) ? Ue.prototype[se[0]] = Ce : delete Ue.prototype[se[0]];
                  }), Ue;
                };
              },
              nthArg: function(on) {
                return function(An) {
                  var Ue = An < 0 ? 1 : Te(An) + 1;
                  return L(on(An), Ue);
                };
              },
              rearg: function(on) {
                return function(An, Ue) {
                  var ne = Ue ? Ue.length : 0;
                  return L(on(An, Ue), ne);
                };
              },
              runInContext: function(on) {
                return function(An) {
                  return g(f, on(An), b);
                };
              }
            };
            function Le(on, An) {
              if (U.cap) {
                var Ue = n.iterateeRearg[on];
                if (Ue)
                  return ft(An, Ue);
                var ne = !m && n.iterateeAry[on];
                if (ne)
                  return Zt(An, ne);
              }
              return An;
            }
            function at(on, An, Ue) {
              return Q || U.curry && Ue > 1 ? L(An, Ue) : An;
            }
            function pt(on, An, Ue) {
              if (U.fixed && (N || !n.skipFixed[on])) {
                var ne = n.methodSpread[on], se = ne && ne.start;
                return se === void 0 ? G(An, Ue) : h(An, se);
              }
              return An;
            }
            function kt(on, An, Ue) {
              return U.rearg && Ue > 1 && (J || !n.skipRearg[on]) ? _e(An, n.methodRearg[on] || n.aryRearg[Ue]) : An;
            }
            function _t(on, An) {
              An = Pe(An);
              for (var Ue = -1, ne = An.length, se = ne - 1, Ce = K(Object(on)), At = Ce; At != null && ++Ue < ne; ) {
                var Ge = An[Ue], Ye = At[Ge];
                Ye != null && !(fe(Ye) || oe(Ye) || ge(Ye)) && (At[Ge] = K(Ue == se ? Ye : Object(Ye))), At = At[Ge];
              }
              return Ce;
            }
            function Lt(on) {
              return Sn.runInContext.convert(on)(void 0);
            }
            function Ft(on, An) {
              var Ue = n.aliasToReal[on] || on, ne = n.remap[Ue] || Ue, se = b;
              return function(Ce) {
                var At = m ? w : W, Ge = m ? w[ne] : An, Ye = Z(Z({}, se), Ce);
                return g(At, Ue, Ge, Ye);
              };
            }
            function Zt(on, An) {
              return It(on, function(Ue) {
                return typeof Ue == "function" ? c(Ue, An) : Ue;
              });
            }
            function ft(on, An) {
              return It(on, function(Ue) {
                var ne = An.length;
                return l(_e(c(Ue, ne), An), ne);
              });
            }
            function It(on, An) {
              return function() {
                var Ue = arguments.length;
                if (!Ue)
                  return on();
                for (var ne = Array(Ue); Ue--; )
                  ne[Ue] = arguments[Ue];
                var se = U.rearg ? 0 : Ue - 1;
                return ne[se] = An(ne[se]), on.apply(void 0, ne);
              };
            }
            function Kt(on, An, Ue) {
              var ne, se = n.aliasToReal[on] || on, Ce = An, At = Bt[se];
              return At ? Ce = At(An) : U.immutable && (n.mutate.array[se] ? Ce = A(An, d) : n.mutate.object[se] ? Ce = A(An, u(An)) : n.mutate.set[se] && (Ce = A(An, _t))), O($e, function(Ge) {
                return O(n.aryMethod[Ge], function(Ye) {
                  if (se == Ye) {
                    var Qt = n.methodSpread[se], tn = Qt && Qt.afterRearg;
                    return ne = tn ? pt(se, kt(se, Ce, Ge), Ge) : kt(se, pt(se, Ce, Ge), Ge), ne = Le(se, ne), ne = at(se, ne, Ge), !1;
                  }
                }), !ne;
              }), ne || (ne = Ce), ne == An && (ne = Q ? L(ne, 1) : function() {
                return An.apply(this, arguments);
              }), ne.convert = Ft(se, An), ne.placeholder = An.placeholder = Ue, ne;
            }
            if (!y)
              return Kt(p, v, B);
            var Sn = v, Cn = [];
            return O($e, function(on) {
              O(n.aryMethod[on], function(An) {
                var Ue = Sn[n.remap[An] || An];
                Ue && Cn.push([An, Kt(An, Ue, Sn)]);
              });
            }), O(we(Sn), function(on) {
              var An = Sn[on];
              if (typeof An == "function") {
                for (var Ue = Cn.length; Ue--; )
                  if (Cn[Ue][0] == on)
                    return;
                An.convert = Ft(on, An), Cn.push([on, An]);
              }
            }), O(Cn, function(on) {
              Sn[on[0]] = on[1];
            }), Sn.convert = Lt, Sn.placeholder = Sn, O(we(Sn), function(on) {
              O(n.realToAlias[on] || [], function(An) {
                Sn[An] = Sn[on];
              });
            }), Sn;
          }
          i.exports = g;
        },
        /* 487 */
        /***/
        function(i, r) {
          r.aliasToReal = {
            // Lodash aliases.
            each: "forEach",
            eachRight: "forEachRight",
            entries: "toPairs",
            entriesIn: "toPairsIn",
            extend: "assignIn",
            extendAll: "assignInAll",
            extendAllWith: "assignInAllWith",
            extendWith: "assignInWith",
            first: "head",
            // Methods that are curried variants of others.
            conforms: "conformsTo",
            matches: "isMatch",
            property: "get",
            // Ramda aliases.
            __: "placeholder",
            F: "stubFalse",
            T: "stubTrue",
            all: "every",
            allPass: "overEvery",
            always: "constant",
            any: "some",
            anyPass: "overSome",
            apply: "spread",
            assoc: "set",
            assocPath: "set",
            complement: "negate",
            compose: "flowRight",
            contains: "includes",
            dissoc: "unset",
            dissocPath: "unset",
            dropLast: "dropRight",
            dropLastWhile: "dropRightWhile",
            equals: "isEqual",
            identical: "eq",
            indexBy: "keyBy",
            init: "initial",
            invertObj: "invert",
            juxt: "over",
            omitAll: "omit",
            nAry: "ary",
            path: "get",
            pathEq: "matchesProperty",
            pathOr: "getOr",
            paths: "at",
            pickAll: "pick",
            pipe: "flow",
            pluck: "map",
            prop: "get",
            propEq: "matchesProperty",
            propOr: "getOr",
            props: "at",
            symmetricDifference: "xor",
            symmetricDifferenceBy: "xorBy",
            symmetricDifferenceWith: "xorWith",
            takeLast: "takeRight",
            takeLastWhile: "takeRightWhile",
            unapply: "rest",
            unnest: "flatten",
            useWith: "overArgs",
            where: "conformsTo",
            whereEq: "isMatch",
            zipObj: "zipObject"
          }, r.aryMethod = {
            1: [
              "assignAll",
              "assignInAll",
              "attempt",
              "castArray",
              "ceil",
              "create",
              "curry",
              "curryRight",
              "defaultsAll",
              "defaultsDeepAll",
              "floor",
              "flow",
              "flowRight",
              "fromPairs",
              "invert",
              "iteratee",
              "memoize",
              "method",
              "mergeAll",
              "methodOf",
              "mixin",
              "nthArg",
              "over",
              "overEvery",
              "overSome",
              "rest",
              "reverse",
              "round",
              "runInContext",
              "spread",
              "template",
              "trim",
              "trimEnd",
              "trimStart",
              "uniqueId",
              "words",
              "zipAll"
            ],
            2: [
              "add",
              "after",
              "ary",
              "assign",
              "assignAllWith",
              "assignIn",
              "assignInAllWith",
              "at",
              "before",
              "bind",
              "bindAll",
              "bindKey",
              "chunk",
              "cloneDeepWith",
              "cloneWith",
              "concat",
              "conformsTo",
              "countBy",
              "curryN",
              "curryRightN",
              "debounce",
              "defaults",
              "defaultsDeep",
              "defaultTo",
              "delay",
              "difference",
              "divide",
              "drop",
              "dropRight",
              "dropRightWhile",
              "dropWhile",
              "endsWith",
              "eq",
              "every",
              "filter",
              "find",
              "findIndex",
              "findKey",
              "findLast",
              "findLastIndex",
              "findLastKey",
              "flatMap",
              "flatMapDeep",
              "flattenDepth",
              "forEach",
              "forEachRight",
              "forIn",
              "forInRight",
              "forOwn",
              "forOwnRight",
              "get",
              "groupBy",
              "gt",
              "gte",
              "has",
              "hasIn",
              "includes",
              "indexOf",
              "intersection",
              "invertBy",
              "invoke",
              "invokeMap",
              "isEqual",
              "isMatch",
              "join",
              "keyBy",
              "lastIndexOf",
              "lt",
              "lte",
              "map",
              "mapKeys",
              "mapValues",
              "matchesProperty",
              "maxBy",
              "meanBy",
              "merge",
              "mergeAllWith",
              "minBy",
              "multiply",
              "nth",
              "omit",
              "omitBy",
              "overArgs",
              "pad",
              "padEnd",
              "padStart",
              "parseInt",
              "partial",
              "partialRight",
              "partition",
              "pick",
              "pickBy",
              "propertyOf",
              "pull",
              "pullAll",
              "pullAt",
              "random",
              "range",
              "rangeRight",
              "rearg",
              "reject",
              "remove",
              "repeat",
              "restFrom",
              "result",
              "sampleSize",
              "some",
              "sortBy",
              "sortedIndex",
              "sortedIndexOf",
              "sortedLastIndex",
              "sortedLastIndexOf",
              "sortedUniqBy",
              "split",
              "spreadFrom",
              "startsWith",
              "subtract",
              "sumBy",
              "take",
              "takeRight",
              "takeRightWhile",
              "takeWhile",
              "tap",
              "throttle",
              "thru",
              "times",
              "trimChars",
              "trimCharsEnd",
              "trimCharsStart",
              "truncate",
              "union",
              "uniqBy",
              "uniqWith",
              "unset",
              "unzipWith",
              "without",
              "wrap",
              "xor",
              "zip",
              "zipObject",
              "zipObjectDeep"
            ],
            3: [
              "assignInWith",
              "assignWith",
              "clamp",
              "differenceBy",
              "differenceWith",
              "findFrom",
              "findIndexFrom",
              "findLastFrom",
              "findLastIndexFrom",
              "getOr",
              "includesFrom",
              "indexOfFrom",
              "inRange",
              "intersectionBy",
              "intersectionWith",
              "invokeArgs",
              "invokeArgsMap",
              "isEqualWith",
              "isMatchWith",
              "flatMapDepth",
              "lastIndexOfFrom",
              "mergeWith",
              "orderBy",
              "padChars",
              "padCharsEnd",
              "padCharsStart",
              "pullAllBy",
              "pullAllWith",
              "rangeStep",
              "rangeStepRight",
              "reduce",
              "reduceRight",
              "replace",
              "set",
              "slice",
              "sortedIndexBy",
              "sortedLastIndexBy",
              "transform",
              "unionBy",
              "unionWith",
              "update",
              "xorBy",
              "xorWith",
              "zipWith"
            ],
            4: [
              "fill",
              "setWith",
              "updateWith"
            ]
          }, r.aryRearg = {
            2: [1, 0],
            3: [2, 0, 1],
            4: [3, 2, 0, 1]
          }, r.iterateeAry = {
            dropRightWhile: 1,
            dropWhile: 1,
            every: 1,
            filter: 1,
            find: 1,
            findFrom: 1,
            findIndex: 1,
            findIndexFrom: 1,
            findKey: 1,
            findLast: 1,
            findLastFrom: 1,
            findLastIndex: 1,
            findLastIndexFrom: 1,
            findLastKey: 1,
            flatMap: 1,
            flatMapDeep: 1,
            flatMapDepth: 1,
            forEach: 1,
            forEachRight: 1,
            forIn: 1,
            forInRight: 1,
            forOwn: 1,
            forOwnRight: 1,
            map: 1,
            mapKeys: 1,
            mapValues: 1,
            partition: 1,
            reduce: 2,
            reduceRight: 2,
            reject: 1,
            remove: 1,
            some: 1,
            takeRightWhile: 1,
            takeWhile: 1,
            times: 1,
            transform: 2
          }, r.iterateeRearg = {
            mapKeys: [1],
            reduceRight: [1, 0]
          }, r.methodRearg = {
            assignInAllWith: [1, 0],
            assignInWith: [1, 2, 0],
            assignAllWith: [1, 0],
            assignWith: [1, 2, 0],
            differenceBy: [1, 2, 0],
            differenceWith: [1, 2, 0],
            getOr: [2, 1, 0],
            intersectionBy: [1, 2, 0],
            intersectionWith: [1, 2, 0],
            isEqualWith: [1, 2, 0],
            isMatchWith: [2, 1, 0],
            mergeAllWith: [1, 0],
            mergeWith: [1, 2, 0],
            padChars: [2, 1, 0],
            padCharsEnd: [2, 1, 0],
            padCharsStart: [2, 1, 0],
            pullAllBy: [2, 1, 0],
            pullAllWith: [2, 1, 0],
            rangeStep: [1, 2, 0],
            rangeStepRight: [1, 2, 0],
            setWith: [3, 1, 2, 0],
            sortedIndexBy: [2, 1, 0],
            sortedLastIndexBy: [2, 1, 0],
            unionBy: [1, 2, 0],
            unionWith: [1, 2, 0],
            updateWith: [3, 1, 2, 0],
            xorBy: [1, 2, 0],
            xorWith: [1, 2, 0],
            zipWith: [1, 2, 0]
          }, r.methodSpread = {
            assignAll: { start: 0 },
            assignAllWith: { start: 0 },
            assignInAll: { start: 0 },
            assignInAllWith: { start: 0 },
            defaultsAll: { start: 0 },
            defaultsDeepAll: { start: 0 },
            invokeArgs: { start: 2 },
            invokeArgsMap: { start: 2 },
            mergeAll: { start: 0 },
            mergeAllWith: { start: 0 },
            partial: { start: 1 },
            partialRight: { start: 1 },
            without: { start: 1 },
            zipAll: { start: 0 }
          }, r.mutate = {
            array: {
              fill: !0,
              pull: !0,
              pullAll: !0,
              pullAllBy: !0,
              pullAllWith: !0,
              pullAt: !0,
              remove: !0,
              reverse: !0
            },
            object: {
              assign: !0,
              assignAll: !0,
              assignAllWith: !0,
              assignIn: !0,
              assignInAll: !0,
              assignInAllWith: !0,
              assignInWith: !0,
              assignWith: !0,
              defaults: !0,
              defaultsAll: !0,
              defaultsDeep: !0,
              defaultsDeepAll: !0,
              merge: !0,
              mergeAll: !0,
              mergeAllWith: !0,
              mergeWith: !0
            },
            set: {
              set: !0,
              setWith: !0,
              unset: !0,
              update: !0,
              updateWith: !0
            }
          }, r.realToAlias = function() {
            var e = Object.prototype.hasOwnProperty, n = r.aliasToReal, t = {};
            for (var o in n) {
              var l = n[o];
              e.call(t, l) ? t[l].push(o) : t[l] = [o];
            }
            return t;
          }(), r.remap = {
            assignAll: "assign",
            assignAllWith: "assignWith",
            assignInAll: "assignIn",
            assignInAllWith: "assignInWith",
            curryN: "curry",
            curryRightN: "curryRight",
            defaultsAll: "defaults",
            defaultsDeepAll: "defaultsDeep",
            findFrom: "find",
            findIndexFrom: "findIndex",
            findLastFrom: "findLast",
            findLastIndexFrom: "findLastIndex",
            getOr: "get",
            includesFrom: "includes",
            indexOfFrom: "indexOf",
            invokeArgs: "invoke",
            invokeArgsMap: "invokeMap",
            lastIndexOfFrom: "lastIndexOf",
            mergeAll: "merge",
            mergeAllWith: "mergeWith",
            padChars: "pad",
            padCharsEnd: "padEnd",
            padCharsStart: "padStart",
            propertyOf: "get",
            rangeStep: "range",
            rangeStepRight: "rangeRight",
            restFrom: "rest",
            spreadFrom: "spread",
            trimChars: "trim",
            trimCharsEnd: "trimEnd",
            trimCharsStart: "trimStart",
            zipAll: "zip"
          }, r.skipFixed = {
            castArray: !0,
            flow: !0,
            flowRight: !0,
            iteratee: !0,
            mixin: !0,
            rearg: !0,
            runInContext: !0
          }, r.skipRearg = {
            add: !0,
            assign: !0,
            assignIn: !0,
            bind: !0,
            bindKey: !0,
            concat: !0,
            difference: !0,
            divide: !0,
            eq: !0,
            gt: !0,
            gte: !0,
            isEqual: !0,
            lt: !0,
            lte: !0,
            matchesProperty: !0,
            merge: !0,
            multiply: !0,
            overArgs: !0,
            partial: !0,
            partialRight: !0,
            propertyOf: !0,
            random: !0,
            range: !0,
            rangeRight: !0,
            subtract: !0,
            zip: !0,
            zipObject: !0,
            zipObjectDeep: !0
          };
        },
        /* 488 */
        /***/
        function(i, r, e) {
          i.exports = {
            ary: e(489),
            assign: e(189),
            clone: e(42),
            curry: e(510),
            forEach: e(115),
            isArray: e(12),
            isError: e(511),
            isFunction: e(17),
            isWeakMap: e(512),
            iteratee: e(513),
            keys: e(118),
            rearg: e(530),
            toInteger: e(97),
            toPath: e(533)
          };
        },
        /* 489 */
        /***/
        function(i, r, e) {
          var n = e(133), t = 128;
          function o(l, c, d) {
            return c = d ? void 0 : c, c = l && c == null ? l.length : c, n(l, t, void 0, void 0, void 0, void 0, c);
          }
          i.exports = o;
        },
        /* 490 */
        /***/
        function(i, r, e) {
          var n = e(95), t = e(15), o = 1;
          function l(c, d, u) {
            var h = d & o, A = n(c);
            function g() {
              var f = this && this !== t && this instanceof g ? A : c;
              return f.apply(h ? u : this, arguments);
            }
            return g;
          }
          i.exports = l;
        },
        /* 491 */
        /***/
        function(i, r, e) {
          var n = e(123), t = e(95), o = e(230), l = e(233), c = e(240), d = e(136), u = e(15);
          function h(A, g, f) {
            var p = t(A);
            function v() {
              for (var b = arguments.length, m = Array(b), y = b, U = c(v); y--; )
                m[y] = arguments[y];
              var B = b < 3 && m[0] !== U && m[b - 1] !== U ? [] : d(m, U);
              if (b -= B.length, b < f)
                return l(
                  A,
                  g,
                  o,
                  v.placeholder,
                  void 0,
                  m,
                  B,
                  void 0,
                  void 0,
                  f - b
                );
              var Q = this && this !== u && this instanceof v ? p : A;
              return n(Q, this, m);
            }
            return v;
          }
          i.exports = h;
        },
        /* 492 */
        /***/
        function(i, r) {
          function e(n, t) {
            for (var o = n.length, l = 0; o--; )
              n[o] === t && ++l;
            return l;
          }
          i.exports = e;
        },
        /* 493 */
        /***/
        function(i, r, e) {
          var n = e(134), t = e(234), o = e(494), l = e(496);
          function c(d) {
            var u = o(d), h = l[u];
            if (typeof h != "function" || !(u in n.prototype))
              return !1;
            if (d === h)
              return !0;
            var A = t(h);
            return !!A && d === A[0];
          }
          i.exports = c;
        },
        /* 494 */
        /***/
        function(i, r, e) {
          var n = e(495), t = Object.prototype, o = t.hasOwnProperty;
          function l(c) {
            for (var d = c.name + "", u = n[d], h = o.call(n, d) ? u.length : 0; h--; ) {
              var A = u[h], g = A.func;
              if (g == null || g == c)
                return A.name;
            }
            return d;
          }
          i.exports = l;
        },
        /* 495 */
        /***/
        function(i, r) {
          var e = {};
          i.exports = e;
        },
        /* 496 */
        /***/
        function(i, r, e) {
          var n = e(134), t = e(236), o = e(135), l = e(12), c = e(18), d = e(497), u = Object.prototype, h = u.hasOwnProperty;
          function A(g) {
            if (c(g) && !l(g) && !(g instanceof n)) {
              if (g instanceof t)
                return g;
              if (h.call(g, "__wrapped__"))
                return d(g);
            }
            return new t(g);
          }
          A.prototype = o.prototype, A.prototype.constructor = A, i.exports = A;
        },
        /* 497 */
        /***/
        function(i, r, e) {
          var n = e(134), t = e(236), o = e(55);
          function l(c) {
            if (c instanceof n)
              return c.clone();
            var d = new t(c.__wrapped__, c.__chain__);
            return d.__actions__ = o(c.__actions__), d.__index__ = c.__index__, d.__values__ = c.__values__, d;
          }
          i.exports = l;
        },
        /* 498 */
        /***/
        function(i, r) {
          var e = /\{\n\/\* \[wrapped with (.+)\] \*/, n = /,? & /;
          function t(o) {
            var l = o.match(e);
            return l ? l[1].split(n) : [];
          }
          i.exports = t;
        },
        /* 499 */
        /***/
        function(i, r) {
          var e = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
          function n(t, o) {
            var l = o.length;
            if (!l)
              return t;
            var c = l - 1;
            return o[c] = (l > 1 ? "& " : "") + o[c], o = o.join(l > 2 ? ", " : " "), t.replace(e, `{
/* [wrapped with ` + o + `] */
`);
          }
          i.exports = n;
        },
        /* 500 */
        /***/
        function(i, r, e) {
          var n = e(115), t = e(96), o = 1, l = 2, c = 8, d = 16, u = 32, h = 64, A = 128, g = 256, f = 512, p = [
            ["ary", A],
            ["bind", o],
            ["bindKey", l],
            ["curry", c],
            ["curryRight", d],
            ["flip", f],
            ["partial", u],
            ["partialRight", h],
            ["rearg", g]
          ];
          function v(b, m) {
            return n(p, function(y) {
              var U = "_." + y[0];
              m & y[1] && !t(b, U) && b.push(U);
            }), b.sort();
          }
          i.exports = v;
        },
        /* 501 */
        /***/
        function(i, r, e) {
          var n = e(239), t = e(502), o = e(503);
          function l(c, d, u) {
            return d === d ? o(c, d, u) : n(c, t, u);
          }
          i.exports = l;
        },
        /* 502 */
        /***/
        function(i, r) {
          function e(n) {
            return n !== n;
          }
          i.exports = e;
        },
        /* 503 */
        /***/
        function(i, r) {
          function e(n, t, o) {
            for (var l = o - 1, c = n.length; ++l < c; )
              if (n[l] === t)
                return l;
            return -1;
          }
          i.exports = e;
        },
        /* 504 */
        /***/
        function(i, r, e) {
          var n = e(55), t = e(66), o = Math.min;
          function l(c, d) {
            for (var u = c.length, h = o(d.length, u), A = n(c); h--; ) {
              var g = d[h];
              c[h] = t(g, u) ? A[g] : void 0;
            }
            return c;
          }
          i.exports = l;
        },
        /* 505 */
        /***/
        function(i, r, e) {
          var n = e(123), t = e(95), o = e(15), l = 1;
          function c(d, u, h, A) {
            var g = u & l, f = t(d);
            function p() {
              for (var v = -1, b = arguments.length, m = -1, y = A.length, U = Array(y + b), B = this && this !== o && this instanceof p ? f : d; ++m < y; )
                U[m] = A[m];
              for (; b--; )
                U[m++] = arguments[++v];
              return n(B, g ? h : this, U);
            }
            return p;
          }
          i.exports = c;
        },
        /* 506 */
        /***/
        function(i, r, e) {
          var n = e(231), t = e(232), o = e(136), l = "__lodash_placeholder__", c = 1, d = 2, u = 4, h = 8, A = 128, g = 256, f = Math.min;
          function p(v, b) {
            var m = v[1], y = b[1], U = m | y, B = U < (c | d | A), Q = y == A && m == h || y == A && m == g && v[7].length <= b[8] || y == (A | g) && b[7].length <= b[8] && m == h;
            if (!(B || Q))
              return v;
            y & c && (v[2] = b[2], U |= m & c ? 0 : u);
            var N = b[3];
            if (N) {
              var J = v[3];
              v[3] = J ? n(J, N, b[4]) : N, v[4] = J ? o(v[3], l) : b[4];
            }
            return N = b[5], N && (J = v[5], v[5] = J ? t(J, N, b[6]) : N, v[6] = J ? o(v[5], l) : b[6]), N = b[7], N && (v[7] = N), y & A && (v[8] = v[8] == null ? b[8] : f(v[8], b[8])), v[9] == null && (v[9] = b[9]), v[0] = b[0], v[1] = U, v;
          }
          i.exports = p;
        },
        /* 507 */
        /***/
        function(i, r, e) {
          var n = e(241), t = 1 / 0, o = 17976931348623157e292;
          function l(c) {
            if (!c)
              return c === 0 ? c : 0;
            if (c = n(c), c === t || c === -t) {
              var d = c < 0 ? -1 : 1;
              return d * o;
            }
            return c === c ? c : 0;
          }
          i.exports = l;
        },
        /* 508 */
        /***/
        function(i, r, e) {
          var n = e(509), t = /^\s+/;
          function o(l) {
            return l && l.slice(0, n(l) + 1).replace(t, "");
          }
          i.exports = o;
        },
        /* 509 */
        /***/
        function(i, r) {
          var e = /\s/;
          function n(t) {
            for (var o = t.length; o-- && e.test(t.charAt(o)); )
              ;
            return o;
          }
          i.exports = n;
        },
        /* 510 */
        /***/
        function(i, r, e) {
          var n = e(133), t = 8;
          function o(l, c, d) {
            c = d ? void 0 : c;
            var u = n(l, t, void 0, void 0, void 0, void 0, void 0, c);
            return u.placeholder = o.placeholder, u;
          }
          o.placeholder = {}, i.exports = o;
        },
        /* 511 */
        /***/
        function(i, r, e) {
          var n = e(33), t = e(18), o = e(137), l = "[object DOMException]", c = "[object Error]";
          function d(u) {
            if (!t(u))
              return !1;
            var h = n(u);
            return h == c || h == l || typeof u.message == "string" && typeof u.name == "string" && !o(u);
          }
          i.exports = d;
        },
        /* 512 */
        /***/
        function(i, r, e) {
          var n = e(46), t = e(18), o = "[object WeakMap]";
          function l(c) {
            return t(c) && n(c) == o;
          }
          i.exports = l;
        },
        /* 513 */
        /***/
        function(i, r, e) {
          var n = e(79), t = e(38), o = 1;
          function l(c) {
            return t(typeof c == "function" ? c : n(c, o));
          }
          i.exports = l;
        },
        /* 514 */
        /***/
        function(i, r, e) {
          var n = e(515), t = e(521), o = e(246);
          function l(c) {
            var d = t(c);
            return d.length == 1 && d[0][2] ? o(d[0][0], d[0][1]) : function(u) {
              return u === c || n(u, c, d);
            };
          }
          i.exports = l;
        },
        /* 515 */
        /***/
        function(i, r, e) {
          var n = e(80), t = e(138), o = 1, l = 2;
          function c(d, u, h, A) {
            var g = h.length, f = g, p = !A;
            if (d == null)
              return !f;
            for (d = Object(d); g--; ) {
              var v = h[g];
              if (p && v[2] ? v[1] !== d[v[0]] : !(v[0] in d))
                return !1;
            }
            for (; ++g < f; ) {
              v = h[g];
              var b = v[0], m = d[b], y = v[1];
              if (p && v[2]) {
                if (m === void 0 && !(b in d))
                  return !1;
              } else {
                var U = new n();
                if (A)
                  var B = A(m, y, b, d, u, U);
                if (!(B === void 0 ? t(y, m, o | l, A, U) : B))
                  return !1;
              }
            }
            return !0;
          }
          i.exports = c;
        },
        /* 516 */
        /***/
        function(i, r, e) {
          var n = e(80), t = e(242), o = e(519), l = e(520), c = e(46), d = e(12), u = e(65), h = e(87), A = 1, g = "[object Arguments]", f = "[object Array]", p = "[object Object]", v = Object.prototype, b = v.hasOwnProperty;
          function m(y, U, B, Q, N, J) {
            var w = d(y), W = d(U), G = w ? f : c(y), Z = W ? f : c(U);
            G = G == g ? p : G, Z = Z == g ? p : Z;
            var K = G == p, L = Z == p, O = G == Z;
            if (O && u(y)) {
              if (!u(U))
                return !1;
              w = !0, K = !1;
            }
            if (O && !K)
              return J || (J = new n()), w || h(y) ? t(y, U, B, Q, N, J) : o(y, U, G, B, Q, N, J);
            if (!(B & A)) {
              var de = K && b.call(y, "__wrapped__"), oe = L && b.call(U, "__wrapped__");
              if (de || oe) {
                var fe = de ? y.value() : y, ge = oe ? U.value() : U;
                return J || (J = new n()), N(fe, ge, B, Q, J);
              }
            }
            return O ? (J || (J = new n()), l(y, U, B, Q, N, J)) : !1;
          }
          i.exports = m;
        },
        /* 517 */
        /***/
        function(i, r) {
          var e = "__lodash_hash_undefined__";
          function n(t) {
            return this.__data__.set(t, e), this;
          }
          i.exports = n;
        },
        /* 518 */
        /***/
        function(i, r) {
          function e(n) {
            return this.__data__.has(n);
          }
          i.exports = e;
        },
        /* 519 */
        /***/
        function(i, r, e) {
          var n = e(44), t = e(200), o = e(53), l = e(242), c = e(244), d = e(100), u = 1, h = 2, A = "[object Boolean]", g = "[object Date]", f = "[object Error]", p = "[object Map]", v = "[object Number]", b = "[object RegExp]", m = "[object Set]", y = "[object String]", U = "[object Symbol]", B = "[object ArrayBuffer]", Q = "[object DataView]", N = n ? n.prototype : void 0, J = N ? N.valueOf : void 0;
          function w(W, G, Z, K, L, O, de) {
            switch (Z) {
              case Q:
                if (W.byteLength != G.byteLength || W.byteOffset != G.byteOffset)
                  return !1;
                W = W.buffer, G = G.buffer;
              case B:
                return !(W.byteLength != G.byteLength || !O(new t(W), new t(G)));
              case A:
              case g:
              case v:
                return o(+W, +G);
              case f:
                return W.name == G.name && W.message == G.message;
              case b:
              case y:
                return W == G + "";
              case p:
                var oe = c;
              case m:
                var fe = K & u;
                if (oe || (oe = d), W.size != G.size && !fe)
                  return !1;
                var ge = de.get(W);
                if (ge)
                  return ge == G;
                K |= h, de.set(W, G);
                var we = l(oe(W), oe(G), K, L, O, de);
                return de.delete(W), we;
              case U:
                if (J)
                  return J.call(W) == J.call(G);
            }
            return !1;
          }
          i.exports = w;
        },
        /* 520 */
        /***/
        function(i, r, e) {
          var n = e(195), t = 1, o = Object.prototype, l = o.hasOwnProperty;
          function c(d, u, h, A, g, f) {
            var p = h & t, v = n(d), b = v.length, m = n(u), y = m.length;
            if (b != y && !p)
              return !1;
            for (var U = b; U--; ) {
              var B = v[U];
              if (!(p ? B in u : l.call(u, B)))
                return !1;
            }
            var Q = f.get(d), N = f.get(u);
            if (Q && N)
              return Q == u && N == d;
            var J = !0;
            f.set(d, u), f.set(u, d);
            for (var w = p; ++U < b; ) {
              B = v[U];
              var W = d[B], G = u[B];
              if (A)
                var Z = p ? A(G, W, B, u, d, f) : A(W, G, B, d, u, f);
              if (!(Z === void 0 ? W === G || g(W, G, h, A, f) : Z)) {
                J = !1;
                break;
              }
              w || (w = B == "constructor");
            }
            if (J && !w) {
              var K = d.constructor, L = u.constructor;
              K != L && "constructor" in d && "constructor" in u && !(typeof K == "function" && K instanceof K && typeof L == "function" && L instanceof L) && (J = !1);
            }
            return f.delete(d), f.delete(u), J;
          }
          i.exports = c;
        },
        /* 521 */
        /***/
        function(i, r, e) {
          var n = e(245), t = e(34);
          function o(l) {
            for (var c = t(l), d = c.length; d--; ) {
              var u = c[d], h = l[u];
              c[d] = [u, h, n(h)];
            }
            return c;
          }
          i.exports = o;
        },
        /* 522 */
        /***/
        function(i, r, e) {
          var n = e(138), t = e(58), o = e(248), l = e(139), c = e(245), d = e(246), u = e(49), h = 1, A = 2;
          function g(f, p) {
            return l(f) && c(p) ? d(u(f), p) : function(v) {
              var b = t(v, f);
              return b === void 0 && b === p ? o(v, f) : n(p, b, h | A);
            };
          }
          i.exports = g;
        },
        /* 523 */
        /***/
        function(i, r, e) {
          var n = e(126), t = 500;
          function o(l) {
            var c = n(l, function(u) {
              return d.size === t && d.clear(), u;
            }), d = c.cache;
            return c;
          }
          i.exports = o;
        },
        /* 524 */
        /***/
        function(i, r, e) {
          var n = e(44), t = e(39), o = e(12), l = e(70), c = 1 / 0, d = n ? n.prototype : void 0, u = d ? d.toString : void 0;
          function h(A) {
            if (typeof A == "string")
              return A;
            if (o(A))
              return t(A, h) + "";
            if (l(A))
              return u ? u.call(A) : "";
            var g = A + "";
            return g == "0" && 1 / A == -c ? "-0" : g;
          }
          i.exports = h;
        },
        /* 525 */
        /***/
        function(i, r) {
          function e(n, t) {
            return n != null && t in Object(n);
          }
          i.exports = e;
        },
        /* 526 */
        /***/
        function(i, r, e) {
          var n = e(59), t = e(64), o = e(12), l = e(66), c = e(116), d = e(49);
          function u(h, A, g) {
            A = n(A, h);
            for (var f = -1, p = A.length, v = !1; ++f < p; ) {
              var b = d(A[f]);
              if (!(v = h != null && g(h, b)))
                break;
              h = h[b];
            }
            return v || ++f != p ? v : (p = h == null ? 0 : h.length, !!p && c(p) && l(b, p) && (o(h) || t(h)));
          }
          i.exports = u;
        },
        /* 527 */
        /***/
        function(i, r, e) {
          var n = e(528), t = e(529), o = e(139), l = e(49);
          function c(d) {
            return o(d) ? n(l(d)) : t(d);
          }
          i.exports = c;
        },
        /* 528 */
        /***/
        function(i, r) {
          function e(n) {
            return function(t) {
              return t == null ? void 0 : t[n];
            };
          }
          i.exports = e;
        },
        /* 529 */
        /***/
        function(i, r, e) {
          var n = e(101);
          function t(o) {
            return function(l) {
              return n(l, o);
            };
          }
          i.exports = t;
        },
        /* 530 */
        /***/
        function(i, r, e) {
          var n = e(133), t = e(140), o = 256, l = t(function(c, d) {
            return n(c, o, void 0, void 0, void 0, d);
          });
          i.exports = l;
        },
        /* 531 */
        /***/
        function(i, r, e) {
          var n = e(249);
          function t(o) {
            var l = o == null ? 0 : o.length;
            return l ? n(o, 1) : [];
          }
          i.exports = t;
        },
        /* 532 */
        /***/
        function(i, r, e) {
          var n = e(44), t = e(64), o = e(12), l = n ? n.isConcatSpreadable : void 0;
          function c(d) {
            return o(d) || t(d) || !!(l && d && d[l]);
          }
          i.exports = c;
        },
        /* 533 */
        /***/
        function(i, r, e) {
          var n = e(39), t = e(55), o = e(12), l = e(70), c = e(247), d = e(49), u = e(60);
          function h(A) {
            return o(A) ? n(A, d) : l(A) ? [A] : t(c(u(A)));
          }
          i.exports = h;
        },
        /* 534 */
        /***/
        function(i, r, e) {
          var n = e(63), t = e(102), o = e(38);
          function l(c, d) {
            var u = {};
            return d = o(d, 3), t(c, function(h, A, g) {
              n(u, d(h, A, g), h);
            }), u;
          }
          i.exports = l;
        },
        /* 535 */
        /***/
        function(i, r) {
          function e(n) {
            return function(t, o, l) {
              for (var c = -1, d = Object(t), u = l(t), h = u.length; h--; ) {
                var A = u[n ? h : ++c];
                if (o(d[A], A, d) === !1)
                  break;
              }
              return t;
            };
          }
          i.exports = e;
        },
        /* 536 */
        /***/
        function(i, r, e) {
          var n = e(227), t = n("pick", e(40));
          t.placeholder = e(132), i.exports = t;
        },
        /* 537 */
        /***/
        function(i, r, e) {
          var n = e(538), t = e(248);
          function o(l, c) {
            return n(l, c, function(d, u) {
              return t(l, u);
            });
          }
          i.exports = o;
        },
        /* 538 */
        /***/
        function(i, r, e) {
          var n = e(101), t = e(539), o = e(59);
          function l(c, d, u) {
            for (var h = -1, A = d.length, g = {}; ++h < A; ) {
              var f = d[h], p = n(c, f);
              u(p, f) && t(g, o(f, c), p);
            }
            return g;
          }
          i.exports = l;
        },
        /* 539 */
        /***/
        function(i, r, e) {
          var n = e(85), t = e(59), o = e(66), l = e(11), c = e(49);
          function d(u, h, A, g) {
            if (!l(u))
              return u;
            h = t(h, u);
            for (var f = -1, p = h.length, v = p - 1, b = u; b != null && ++f < p; ) {
              var m = c(h[f]), y = A;
              if (m === "__proto__" || m === "constructor" || m === "prototype")
                return u;
              if (f != v) {
                var U = b[m];
                y = g ? g(U, m, b) : void 0, y === void 0 && (y = l(U) ? U : o(h[f + 1]) ? [] : {});
              }
              n(b, m, y), b = b[m];
            }
            return u;
          }
          i.exports = d;
        },
        /* 540 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t;
            (function(o) {
              r && r.nodeType, n && n.nodeType;
              var l = typeof (typeof window !== void 0 ? window : Dn) == "object" && (typeof window !== void 0 ? window : Dn);
              l.global === l || l.window === l || l.self;
              var c, d = 2147483647, u = 36, h = 1, A = 26, g = 38, f = 700, p = 72, v = 128, b = "-", m = /^xn--/, y = /[^\x20-\x7E]/, U = /[\x2E\u3002\uFF0E\uFF61]/g, B = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
              }, Q = u - h, N = Math.floor, J = String.fromCharCode;
              function w(_e) {
                throw new RangeError(B[_e]);
              }
              function W(_e, Te) {
                for (var Pe = _e.length, $e = []; Pe--; )
                  $e[Pe] = Te(_e[Pe]);
                return $e;
              }
              function G(_e, Te) {
                var Pe = _e.split("@"), $e = "";
                Pe.length > 1 && ($e = Pe[0] + "@", _e = Pe[1]), _e = _e.replace(U, ".");
                var Bt = _e.split("."), Le = W(Bt, Te).join(".");
                return $e + Le;
              }
              function Z(_e) {
                for (var Te = [], Pe = 0, $e = _e.length, Bt, Le; Pe < $e; )
                  Bt = _e.charCodeAt(Pe++), Bt >= 55296 && Bt <= 56319 && Pe < $e ? (Le = _e.charCodeAt(Pe++), (Le & 64512) == 56320 ? Te.push(((Bt & 1023) << 10) + (Le & 1023) + 65536) : (Te.push(Bt), Pe--)) : Te.push(Bt);
                return Te;
              }
              function K(_e) {
                return W(_e, function(Te) {
                  var Pe = "";
                  return Te > 65535 && (Te -= 65536, Pe += J(Te >>> 10 & 1023 | 55296), Te = 56320 | Te & 1023), Pe += J(Te), Pe;
                }).join("");
              }
              function L(_e) {
                return _e - 48 < 10 ? _e - 22 : _e - 65 < 26 ? _e - 65 : _e - 97 < 26 ? _e - 97 : u;
              }
              function O(_e, Te) {
                return _e + 22 + 75 * (_e < 26) - ((Te != 0) << 5);
              }
              function de(_e, Te, Pe) {
                var $e = 0;
                for (_e = Pe ? N(_e / f) : _e >> 1, _e += N(_e / Te); _e > Q * A >> 1; $e += u)
                  _e = N(_e / Q);
                return N($e + (Q + 1) * _e / (_e + g));
              }
              function oe(_e) {
                var Te = [], Pe = _e.length, $e, Bt = 0, Le = v, at = p, pt, kt, _t, Lt, Ft, Zt, ft, It, Kt;
                for (pt = _e.lastIndexOf(b), pt < 0 && (pt = 0), kt = 0; kt < pt; ++kt)
                  _e.charCodeAt(kt) >= 128 && w("not-basic"), Te.push(_e.charCodeAt(kt));
                for (_t = pt > 0 ? pt + 1 : 0; _t < Pe; ) {
                  for (Lt = Bt, Ft = 1, Zt = u; _t >= Pe && w("invalid-input"), ft = L(_e.charCodeAt(_t++)), (ft >= u || ft > N((d - Bt) / Ft)) && w("overflow"), Bt += ft * Ft, It = Zt <= at ? h : Zt >= at + A ? A : Zt - at, !(ft < It); Zt += u)
                    Kt = u - It, Ft > N(d / Kt) && w("overflow"), Ft *= Kt;
                  $e = Te.length + 1, at = de(Bt - Lt, $e, Lt == 0), N(Bt / $e) > d - Le && w("overflow"), Le += N(Bt / $e), Bt %= $e, Te.splice(Bt++, 0, Le);
                }
                return K(Te);
              }
              function fe(_e) {
                var Te, Pe, $e, Bt, Le, at, pt, kt, _t, Lt, Ft, Zt = [], ft, It, Kt, Sn;
                for (_e = Z(_e), ft = _e.length, Te = v, Pe = 0, Le = p, at = 0; at < ft; ++at)
                  Ft = _e[at], Ft < 128 && Zt.push(J(Ft));
                for ($e = Bt = Zt.length, Bt && Zt.push(b); $e < ft; ) {
                  for (pt = d, at = 0; at < ft; ++at)
                    Ft = _e[at], Ft >= Te && Ft < pt && (pt = Ft);
                  for (It = $e + 1, pt - Te > N((d - Pe) / It) && w("overflow"), Pe += (pt - Te) * It, Te = pt, at = 0; at < ft; ++at)
                    if (Ft = _e[at], Ft < Te && ++Pe > d && w("overflow"), Ft == Te) {
                      for (kt = Pe, _t = u; Lt = _t <= Le ? h : _t >= Le + A ? A : _t - Le, !(kt < Lt); _t += u)
                        Sn = kt - Lt, Kt = u - Lt, Zt.push(
                          J(O(Lt + Sn % Kt, 0))
                        ), kt = N(Sn / Kt);
                      Zt.push(J(O(kt, 0))), Le = de(Pe, It, $e == Bt), Pe = 0, ++$e;
                    }
                  ++Pe, ++Te;
                }
                return Zt.join("");
              }
              function ge(_e) {
                return G(_e, function(Te) {
                  return m.test(Te) ? oe(Te.slice(4).toLowerCase()) : Te;
                });
              }
              function we(_e) {
                return G(_e, function(Te) {
                  return y.test(Te) ? "xn--" + fe(Te) : Te;
                });
              }
              c = {
                /**
                 * A string representing the current Punycode.js version number.
                 * @memberOf punycode
                 * @type String
                 */
                version: "1.4.1",
                /**
                 * An object of methods to convert from JavaScript's internal character
                 * representation (UCS-2) to Unicode code points, and back.
                 * @see <https://mathiasbynens.be/notes/javascript-encoding>
                 * @memberOf punycode
                 * @type Object
                 */
                ucs2: {
                  decode: Z,
                  encode: K
                },
                decode: oe,
                encode: fe,
                toASCII: we,
                toUnicode: ge
              }, t = function() {
                return c;
              }.call(r, e, r, n), t !== void 0 && (n.exports = t);
            })();
          }).call(this, e(86)(i));
        },
        /* 541 */
        /***/
        function(i, r, e) {
          i.exports = {
            isString: function(n) {
              return typeof n == "string";
            },
            isObject: function(n) {
              return typeof n == "object" && n !== null;
            },
            isNull: function(n) {
              return n === null;
            },
            isNullOrUndefined: function(n) {
              return n == null;
            }
          };
        },
        /* 542 */
        /***/
        function(i, r, e) {
          r.decode = r.parse = e(543), r.encode = r.stringify = e(544);
        },
        /* 543 */
        /***/
        function(i, r, e) {
          function n(o, l) {
            return Object.prototype.hasOwnProperty.call(o, l);
          }
          i.exports = function(o, l, c, d) {
            l = l || "&", c = c || "=";
            var u = {};
            if (typeof o != "string" || o.length === 0)
              return u;
            var h = /\+/g;
            o = o.split(l);
            var A = 1e3;
            d && typeof d.maxKeys == "number" && (A = d.maxKeys);
            var g = o.length;
            A > 0 && g > A && (g = A);
            for (var f = 0; f < g; ++f) {
              var p = o[f].replace(h, "%20"), v = p.indexOf(c), b, m, y, U;
              v >= 0 ? (b = p.substr(0, v), m = p.substr(v + 1)) : (b = p, m = ""), y = decodeURIComponent(b), U = decodeURIComponent(m), n(u, y) ? t(u[y]) ? u[y].push(U) : u[y] = [u[y], U] : u[y] = U;
            }
            return u;
          };
          var t = Array.isArray || function(o) {
            return Object.prototype.toString.call(o) === "[object Array]";
          };
        },
        /* 544 */
        /***/
        function(i, r, e) {
          var n = function(c) {
            switch (typeof c) {
              case "string":
                return c;
              case "boolean":
                return c ? "true" : "false";
              case "number":
                return isFinite(c) ? c : "";
              default:
                return "";
            }
          };
          i.exports = function(c, d, u, h) {
            return d = d || "&", u = u || "=", c === null && (c = void 0), typeof c == "object" ? o(l(c), function(A) {
              var g = encodeURIComponent(n(A)) + u;
              return t(c[A]) ? o(c[A], function(f) {
                return g + encodeURIComponent(n(f));
              }).join(d) : g + encodeURIComponent(n(c[A]));
            }).join(d) : h ? encodeURIComponent(n(h)) + u + encodeURIComponent(n(c)) : "";
          };
          var t = Array.isArray || function(c) {
            return Object.prototype.toString.call(c) === "[object Array]";
          };
          function o(c, d) {
            if (c.map) return c.map(d);
            for (var u = [], h = 0; h < c.length; h++)
              u.push(d(c[h], h));
            return u;
          }
          var l = Object.keys || function(c) {
            var d = [];
            for (var u in c)
              Object.prototype.hasOwnProperty.call(c, u) && d.push(u);
            return d;
          };
        },
        /* 545 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            const o = t.match(/OS (\d+_\d+).* like Mac/);
            if (!(o === null || !o[1]))
              return parseFloat(o[1].replace("_", "."));
          }
        },
        /* 546 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = /(Electron)\/([0-9]{1,}[.0-9]{0,})/;
          var o = (l) => {
            const c = l.match(n);
            return c && parseFloat(c[2]);
          };
          r.default = o;
        },
        /* 547 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = function(o) {
            o === void 0 && (o = {});
            const l = o.global || (typeof window !== void 0 ? window : Dn);
            return () => l.navigator && l.navigator.mediaDevices;
          };
          r.default = n;
        },
        /* 548 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(105)), o = n(e(7));
          const l = {
            0: "rotate(0deg)",
            270: "rotate(90deg)",
            90: "rotate(-90deg)",
            180: "rotate(180deg)"
          };
          function c(d, u, h) {
            let A = h;
            (0, t.default)(d, {
              isRotated: {
                get() {
                  return this.orientation() && (this.orientation().videoOrientation === 270 || this.orientation().videoOrientation === 90);
                }
              },
              // @todo I don't think we need vendor prefixes at all anymore.
              orientation: {
                get() {
                  return A;
                },
                set(g) {
                  A = g;
                  const f = l[g.videoOrientation] || l.ROTATED_NORMAL;
                  switch (o.default.env.name) {
                    case "Chrome":
                    case "Safari":
                      u().style.webkitTransform = f;
                      break;
                    default:
                      u().style.transform = f;
                  }
                  d.trigger("orientationChanged", A);
                }
              },
              // see https://wiki.mozilla.org/WebAPI/AudioChannels
              // The audioChannelType is currently only available in Firefox. This property returns
              // "unknown" in other browser. The related HTML tag attribute is "mozaudiochannel"
              audioChannelType: {
                get() {
                  return "mozAudioChannelType" in this.domElement ? this.domElement.mozAudioChannelType : "unknown";
                },
                set(g) {
                  "mozAudioChannelType" in this.domElement && (this.domElement.mozAudioChannelType = g);
                }
              }
            });
          }
        },
        /* 549 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(11));
          const o = {
            for: "htmlFor",
            class: "className"
          };
          var c = (d) => {
            d.prototype.attr = function(A, g) {
              if ((0, t.default)(A)) {
                let f;
                Object.keys(A).forEach((p) => {
                  f = o[p] || p, this.first.setAttribute(f, A[p]);
                });
              } else {
                if (g === void 0)
                  return this.first.getAttribute(o[A] || A);
                this.first.setAttribute(o[A] || A, g);
              }
              return this;
            }, d.prototype.removeAttr = function(A) {
              const g = o[A] || A;
              return this.forEach((f) => {
                f.removeAttribute(g);
              }), this;
            }, d.prototype.html = function(A) {
              return A !== void 0 && (this.first.innerHTML = A), this.first.innerHTML;
            }, d.prototype.center = function(A, g) {
              let f;
              return this.forEach((p) => {
                f = new d(p), A = A || parseInt(f.width(), 10), g = g || parseInt(f.height(), 10);
                const v = `${-0.5 * A}px`, b = `${-0.5 * g}px`;
                f.css("margin", `${b} 0 0 ${v}`).addClass("OT_centered");
              }), this;
            }, d._attachToOTHelpers.centerElement = function(A, g, f) {
              return new d(A).center(g, f);
            };
            const u = function(g) {
              return g.offsetWidth > 0 ? `${g.offsetWidth}px` : new d(g).css("width");
            }, h = function(g) {
              return g.offsetHeight > 0 ? `${g.offsetHeight}px` : new d(g).css("height");
            };
            d.prototype.width = function(A) {
              return A ? (this.css("width", A), this) : this.isDisplayNone() ? this.makeVisibleAndYield((g) => u(g))[0] : u(this.get(0));
            }, d._attachToOTHelpers.width = function(A, g) {
              const f = new d(A).width(g);
              return g ? d._attachToOTHelpers : f;
            }, d.prototype.height = function(A) {
              return A ? (this.css("height", A), this) : this.isDisplayNone() ? this.makeVisibleAndYield((g) => h(g))[0] : h(this.get(0));
            }, d._attachToOTHelpers.height = function(A, g) {
              const f = new d(A).height(g);
              return g ? d._attachToOTHelpers : f;
            };
          };
          r.default = c;
        },
        /* 550 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3));
          const o = (typeof window !== void 0 ? window : Dn).getComputedStyle, l = {
            Firefox: "moz",
            Opera: "O",
            Chrome: "Webkit",
            Safari: "Webkit"
          };
          function c() {
            return l[t.default.name];
          }
          var u = (h, A) => {
            const g = {}, f = {}, p = function(N) {
              if (f[N.ownerDocument] && f[N.ownerDocument][N.nodeName])
                return f[N.ownerDocument][N.nodeName];
              f[N.ownerDocument] || (f[N.ownerDocument] = {});
              let J = N.ownerDocument.createElement(N.nodeName), w;
              return N.ownerDocument.body.appendChild(J), w = new h(J).css("display"), f[N.ownerDocument][N.nodeName] = w, new h(J).remove(), J = null, w;
            }, v = function(N) {
              return o(N).getPropertyValue("display") === "none";
            }, b = function(N, J) {
              if (J in N.style)
                return J;
              const W = c() + J[0].toUpperCase() + J.slice(1);
              return W in N.style ? W : J;
            }, m = function(N, J) {
              const w = N.style;
              for (const W in J)
                J.hasOwnProperty(W) && (w[b(N, W)] = J[W]);
            }, y = function(N, J, w) {
              N.style[b(N, J)] = w;
            }, U = function(N, J) {
              const w = b(N, J);
              let G = o(N).getPropertyValue(w);
              return G === "" && (G = N.style[w]), G;
            }, B = function(N, J, w) {
              const W = new h(N), G = {};
              let Z, K;
              for (Z in J)
                J.hasOwnProperty(Z) && (G[Z] = N.style[Z], W.css(Z, J[Z]));
              K = w(N);
              for (Z in J)
                J.hasOwnProperty(Z) && W.css(Z, G[Z] || "");
              return K;
            };
            h.prototype.show = function() {
              return this.forEach((Q) => {
                const N = Q.style.display;
                (N === "" || N === "none") && (Q.style.display = g[Q] || "", delete g[Q]), v(Q) && (g[Q] = "none", Q.style.display = p(Q));
              });
            }, h.prototype.hide = function() {
              return this.forEach((Q) => {
                Q.style.display !== "none" && (g[Q] = Q.style.display, Q.style.display = "none");
              });
            }, h.prototype.css = function(Q, N) {
              if (this.length !== 0)
                return typeof Q != "string" ? this.forEach((J) => {
                  m(J, Q);
                }) : N !== void 0 ? this.forEach((J) => {
                  y(J, Q, N);
                }) : U(this.first, Q);
            }, h.prototype.makeVisibleAndYield = function(Q) {
              const N = {
                display: "block",
                visibility: "hidden"
              }, J = [];
              return this.forEach((w) => {
                const W = A(w);
                W ? J.push(B(W, N, Q)) : J.push(void 0);
              }), J;
            };
          };
          r.default = u;
        },
        /* 551 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(552));
          function o(A, g) {
            return g ? (0, t.default)() ? A.classList.contains(g) : A.className.indexOf(g) > -1 : !1;
          }
          function l(A, g) {
            if (!g || g.length === 0 || A.nodeType !== 1)
              return;
            const f = g.length;
            let p = 0;
            if ((0, t.default)()) {
              for (; p < f; ++p)
                A.classList.toggle(g[p]);
              return;
            }
            let v = ` ${A.className} `.replace(/[\s+]/, " ");
            for (; p < f; ++p)
              o(A, g[p]) ? v = v.replace(` ${g[p]} `, " ") : v += `${g[p]} `;
            A.className = v.trim();
          }
          function c(A, g) {
            if (!g || g.length === 0 || A.nodeType !== 1)
              return;
            const f = g.length;
            let p = 0;
            if ((0, t.default)()) {
              for (; p < f; ++p)
                A.classList.add(g[p]);
              return;
            }
            if (!A.className && g.length === 1)
              A.className = g.join(" ");
            else {
              let v = ` ${A.className} `;
              for (; p < f; ++p)
                ~v.indexOf(` ${g[p]} `) || (v += `${g[p]} `);
              A.className = v.trim();
            }
          }
          function d(A, g) {
            if (!g || g.length === 0 || A.nodeType !== 1)
              return;
            const f = g.length;
            let p = 0;
            if ((0, t.default)()) {
              for (; p < f; ++p)
                A.classList.remove(g[p]);
              return;
            }
            let v = ` ${A.className} `.replace(/[\s+]/, " ");
            for (; p < f; ++p)
              v = v.replace(` ${g[p]} `, " ");
            A.className = v.trim();
          }
          var h = (A) => {
            A.prototype.addClass = function(g) {
              if (g) {
                const f = g.trim().split(/\s+/);
                this.forEach((p) => {
                  c(p, f);
                });
              }
              return this;
            }, A.prototype.removeClass = function(g) {
              if (g) {
                const f = g.trim().split(/\s+/);
                this.forEach((p) => {
                  d(p, f);
                });
              }
              return this;
            }, A.prototype.toggleClass = function(g) {
              if (g) {
                const f = g.trim().split(/\s+/);
                this.forEach((p) => {
                  l(p, f);
                });
              }
              return this;
            }, A.prototype.hasClass = function(g) {
              return this.some((f) => o(f, g));
            };
          };
          r.default = h;
        },
        /* 552 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = () => typeof document != "undefined" && "classList" in document.createElement("a");
          r.default = n;
        },
        /* 553 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(554)), l = (c) => {
            let d = 0, u = 0;
            const h = function(p, v, b) {
              const m = {}, y = function(Q) {
                switch (Q) {
                  case "width":
                    return new c(p).width();
                  case "height":
                    return new c(p).height();
                  default:
                    return new c(p).css(Q);
                }
              };
              v.forEach((B) => {
                m[B] = y(B);
              });
              const U = new (typeof window !== void 0 ? window : Dn).MutationObserver((B) => {
                const Q = {};
                B.forEach((N) => {
                  if (N.attributeName !== "style")
                    return;
                  const J = new c(p).isDisplayNone();
                  v.forEach((w) => {
                    if (J && (w === "width" || w === "height"))
                      return;
                    const W = y(w);
                    W !== m[w] && (Q[w] = [m[w], W], m[w] = W);
                  });
                }), (0, t.default)(Q) || setTimeout(() => {
                  b.call(null, Q);
                });
              });
              return U.observe(p, {
                attributes: !0,
                attributeFilter: ["style"],
                childList: !1,
                characterData: !1,
                subtree: !1
              }), U;
            }, A = function(p, v) {
              const b = new (typeof window !== void 0 ? window : Dn).MutationObserver((y) => {
                let U = [];
                y.forEach((B) => {
                  B.removedNodes.length && (U = U.concat(Array.prototype.slice.call(B.removedNodes)));
                }), U.length && setTimeout(() => {
                  v(new c(U));
                });
              });
              b.observe(p, {
                attributes: !1,
                childList: !0,
                characterData: !1,
                subtree: !0
              }), u++;
              const m = b.disconnect;
              return b.disconnect = function() {
                m.apply(b, arguments), u--;
              }, b;
            }, g = function(p, v) {
              let b = {
                width: 0,
                height: 0
              };
              const m = setInterval(() => {
                const y = p.getBoundingClientRect();
                (b.width !== y.width || b.height !== y.height) && (v(y, b), b = {
                  width: y.width,
                  height: y.height
                });
              }, 1e3 / 5);
              return d++, {
                disconnect() {
                  clearInterval(m), d--;
                }
              };
            };
            c.prototype.observeStyleChanges = function(f, p) {
              const v = [];
              return this.forEach((b) => {
                v.push(h(b, f, p));
              }), v;
            }, c.prototype.observeNodeOrChildNodeRemoval = function(f) {
              const p = [];
              return this.forEach((v) => {
                p.push(A(v, f));
              }), p;
            }, c.prototype.observeSize = function(f) {
              const p = [];
              return this.forEach((v) => {
                p.push(g(v, f));
              }), p;
            }, c._attachToOTHelpers.observeStyleChanges = function(f, p, v) {
              return new c(f).observeStyleChanges(p, v)[0];
            }, c._attachToOTHelpers.observeNodeOrChildNodeRemoval = function(f, p) {
              return new c(f).observeNodeOrChildNodeRemoval(p)[0];
            }, c.__testOnly || (c.__testOnly = {}), c.__testOnly.sizeObserverCount = function() {
              return d;
            }, c.__testOnly.nodeRemovalObserverCount = function() {
              return u;
            };
          };
          r.default = l;
        },
        /* 554 */
        /***/
        function(i, r, e) {
          var n = e(118), t = e(46), o = e(64), l = e(12), c = e(26), d = e(65), u = e(68), h = e(87), A = "[object Map]", g = "[object Set]", f = Object.prototype, p = f.hasOwnProperty;
          function v(b) {
            if (b == null)
              return !0;
            if (c(b) && (l(b) || typeof b == "string" || typeof b.splice == "function" || d(b) || h(b) || o(b)))
              return !b.length;
            var m = t(b);
            if (m == A || m == g)
              return !b.size;
            if (u(b))
              return !n(b).length;
            for (var y in b)
              if (p.call(b, y))
                return !1;
            return !0;
          }
          i.exports = v;
        },
        /* 555 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(17));
          function o(l, c, d, u, h) {
            let A, g = d;
            l.currentState = d;
            const f = function(v) {
              if (g !== v) {
                if (c.indexOf(v) === -1) {
                  h && (0, t.default)(h) && h("invalidState", v);
                  return;
                }
                l.previousState = g, A = g, l.currentState = v, g = v, u && (0, t.default)(u) && u(v, A);
              }
            };
            return l.is = function() {
              return Array.prototype.indexOf.call(arguments, g) !== -1;
            }, l.isNot = function() {
              return Array.prototype.indexOf.call(arguments, g) === -1;
            }, f;
          }
        },
        /* 556 */
        /***/
        function(i, r, e) {
          var n = e(261), t = e(262), o, l, c = 0, d = 0;
          function u(h, A, g) {
            var f = A && g || 0, p = A || [];
            h = h || {};
            var v = h.node || o, b = h.clockseq !== void 0 ? h.clockseq : l;
            if (v == null || b == null) {
              var m = n();
              v == null && (v = o = [
                m[0] | 1,
                m[1],
                m[2],
                m[3],
                m[4],
                m[5]
              ]), b == null && (b = l = (m[6] << 8 | m[7]) & 16383);
            }
            var y = h.msecs !== void 0 ? h.msecs : (/* @__PURE__ */ new Date()).getTime(), U = h.nsecs !== void 0 ? h.nsecs : d + 1, B = y - c + (U - d) / 1e4;
            if (B < 0 && h.clockseq === void 0 && (b = b + 1 & 16383), (B < 0 || y > c) && h.nsecs === void 0 && (U = 0), U >= 1e4)
              throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
            c = y, d = U, l = b, y += 122192928e5;
            var Q = ((y & 268435455) * 1e4 + U) % 4294967296;
            p[f++] = Q >>> 24 & 255, p[f++] = Q >>> 16 & 255, p[f++] = Q >>> 8 & 255, p[f++] = Q & 255;
            var N = y / 4294967296 * 1e4 & 268435455;
            p[f++] = N >>> 8 & 255, p[f++] = N & 255, p[f++] = N >>> 24 & 15 | 16, p[f++] = N >>> 16 & 255, p[f++] = b >>> 8 | 128, p[f++] = b & 255;
            for (var J = 0; J < 6; ++J)
              p[f + J] = v[J];
            return A || t(p);
          }
          i.exports = u;
        },
        /* 557 */
        /***/
        function(i, r, e) {
          var n = e(261), t = e(262);
          function o(l, c, d) {
            var u = c && d || 0;
            typeof l == "string" && (c = l === "binary" ? new Array(16) : null, l = null), l = l || {};
            var h = l.random || (l.rng || n)();
            if (h[6] = h[6] & 15 | 64, h[8] = h[8] & 63 | 128, c)
              for (var A = 0; A < 16; ++A)
                c[u + A] = h[A];
            return c || t(h);
          }
          i.exports = o;
        },
        /* 558 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = /* @__PURE__ */ function() {
            function o(c) {
              let d = c === void 0 ? {} : c, u = d.waitTime, h = u === void 0 ? 50 : u;
              this.queue = [], this.running = !1, this.waitTime = h;
            }
            var l = o.prototype;
            return l.add = function(d) {
              this.queue.push(d), this.run();
            }, l.run = function() {
              if (this.running)
                return;
              this.running = !0;
              const d = () => {
                if (this.queue.length === 0) {
                  this.running = !1;
                  return;
                }
                this.queue.shift()(() => {
                  setTimeout(d, this.waitTime);
                });
              };
              d();
            }, o;
          }();
          r.default = t;
        },
        /* 559 */
        /***/
        function(i, r, e) {
          var n = e(98), t = e(96), o = e(146), l = e(39), c = e(67), d = e(99), u = Math.min;
          function h(A, g, f) {
            for (var p = f ? o : t, v = A[0].length, b = A.length, m = b, y = Array(b), U = 1 / 0, B = []; m--; ) {
              var Q = A[m];
              m && g && (Q = l(Q, c(g))), U = u(Q.length, U), y[m] = !f && (g || v >= 120 && Q.length >= 120) ? new n(m && Q) : void 0;
            }
            Q = A[0];
            var N = -1, J = y[0];
            e:
              for (; ++N < v && B.length < U; ) {
                var w = Q[N], W = g ? g(w) : w;
                if (w = f || w !== 0 ? w : 0, !(J ? d(J, W) : p(B, W, f))) {
                  for (m = b; --m; ) {
                    var G = y[m];
                    if (!(G ? d(G, W) : p(A[m], W, f)))
                      continue e;
                  }
                  J && J.push(W), B.push(w);
                }
              }
            return B;
          }
          i.exports = h;
        },
        /* 560 */
        /***/
        function(i, r, e) {
          var n = e(147);
          function t(o) {
            return n(o) ? o : [];
          }
          i.exports = t;
        },
        /* 561 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {
            1004: "Authentication error",
            1005: "Invalid Session ID",
            1006: "Connect Failed",
            1007: "Connect Rejected",
            1008: "Connect Time-out",
            1009: "Security Error",
            1010: "Not Connected",
            1011: "Invalid Parameter",
            1012: "Peer-to-peer Stream Play Failed",
            1013: "Connection Failed",
            1014: "API Response Failure",
            1015: "PeerConnection not connected, cannot call this method",
            1021: "Request Timeout",
            1026: "Terms of Service Violation: Export Compliance",
            1027: "Connection Limit Exceeded",
            1040: "Set Video Source Failure",
            1041: "Invalid Video Source",
            1500: "Unable to Publish",
            1501: "Unable to Subscribe",
            1502: "Unsupported Video Codec",
            1503: "No TURN server found",
            1520: "Unable to Force Disconnect",
            1530: "Unable to Force Unpublish",
            1540: "Unable to Force Mute",
            1553: "Publisher ICEWorkflow failed",
            1554: "Subscriber ICEWorkflow failed",
            1600: "createOffer, createAnswer, setLocalDescription, setRemoteDescription",
            1605: "Stream Limit Exceeded",
            2e3: "Internal Error",
            2001: "Unexpected Server Response",
            2021: "Proxy URL Timing Error",
            2022: "Proxy URL Already Set Error",
            2031: "getRtcStatsReport is not supported in this browser",
            4e3: "WebSocket Connection Failed",
            4001: "WebSocket Network Disconnected",
            5001: "Unable to access media engine"
          };
          r.default = n;
        },
        /* 562 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(563)), o = (l, c) => {
            if (typeof l == "string" && typeof c == "string") {
              const d = (0, t.default)(l), u = c.match(/(\w+:\/\/)(.*)/), h = u[1], A = u[2];
              return `${h}${d}/${A}`;
            }
            return c;
          };
          r.default = o;
        },
        /* 563 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = (o) => o.replace(/\/+$/, "").replace(/^.*:\/+/, "");
          r.default = t;
        },
        /* 564 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(565)), o = n(e(566));
          function l(c) {
            c === void 0 && (c = {});
            const d = c.isSessionProxied || o.default, u = c, h = u.sessionId;
            d(h) && t.default.forEach((A) => {
              A in c && (c[A] = "");
            });
          }
        },
        /* 565 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = ["audioLocalAddress", "audioRemoteAddress", "videoLocalAddress", "videoRemoteAddress"];
          r.default = n;
        },
        /* 566 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(24));
          const o = t.default.sessions;
          var l = (c) => {
            const d = o.get(c);
            return d ? !!d._.getProxyUrl() : !1;
          };
          r.default = l;
        },
        /* 567 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5));
          const l = {
            architecture: "event_ua_arch",
            bitness: "event_ua_bitness",
            model: "event_ua_model",
            platformVersion: "event_ua_platform_version"
          };
          var d = /* @__PURE__ */ function() {
            var u = (0, o.default)(/* @__PURE__ */ t.default.mark(function h(A) {
              var g, f;
              return t.default.wrap(function(v) {
                for (; ; ) switch (v.prev = v.next) {
                  case 0:
                    if (g = {}, !(A != null && A.getHighEntropyValues)) {
                      v.next = 6;
                      break;
                    }
                    return v.next = 4, A.getHighEntropyValues(Object.keys(l));
                  case 4:
                    f = v.sent, f && Object.entries(l).forEach((b) => {
                      let m = b[0], y = b[1];
                      f[m] !== void 0 && (g[y] = f[m]);
                    });
                  case 6:
                    return v.abrupt("return", g);
                  case 7:
                  case "end":
                    return v.stop();
                }
              }, h);
            }));
            return function(A) {
              return u.apply(this, arguments);
            };
          }();
          r.default = d;
        },
        /* 568 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(259));
          const o = {};
          o.isElementNode = function(c) {
            return c && typeof c == "object" && c.nodeType === 1;
          }, o.createElement = function(c, d, u, h) {
            const A = (h || document).createElement(c);
            d = d || {}, Object.keys(d).forEach((f) => {
              if (typeof d[f] == "object") {
                A[f] || (A[f] = {});
                const p = d[f];
                Object.keys(p).forEach((v) => {
                  A[f][v] = p[v];
                });
              } else f === "className" ? A.className = d[f] : A.setAttribute(f, d[f]);
            });
            const g = function(p) {
              typeof p == "string" ? A.innerHTML += p : A.appendChild(p);
            };
            return Array.isArray(u) ? u.forEach(g) : u && g(u), A;
          }, (0, t.default)(o);
          var l = o;
          r.default = l;
        },
        /* 569 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n() {
            function t(o) {
              return o.getTracks().every((l) => l.readyState === "ended");
            }
            return function(l, c, d) {
              const u = [];
              function h(p) {
                setTimeout(() => {
                  if (u.length)
                    if (t(l))
                      g(), typeof c == "function" && c();
                    else {
                      const v = p.target;
                      A(v), typeof d == "function" && d(v);
                    }
                }, 100);
              }
              function A(p) {
                p.onended === h && (p.onended = null);
                const v = u.indexOf(p);
                v >= 0 && u.splice(v, 1);
              }
              function g() {
                u.slice().forEach(A);
              }
              function f() {
                l.getTracks().forEach((p) => {
                  u.push(p), p.onended = h;
                });
              }
              return f(), {
                stop: g,
                refresh: () => {
                  g(), f();
                }
              };
            };
          }
        },
        /* 570 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(149)), o = c(e(571));
          function l(h) {
            if (typeof WeakMap != "function") return null;
            var A = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap();
            return (l = function(p) {
              return p ? g : A;
            })(h);
          }
          function c(h, A) {
            if (h && h.__esModule)
              return h;
            if (h === null || typeof h != "object" && typeof h != "function")
              return { default: h };
            var g = l(A);
            if (g && g.has(h))
              return g.get(h);
            var f = {}, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var v in h)
              if (v !== "default" && Object.prototype.hasOwnProperty.call(h, v)) {
                var b = p ? Object.getOwnPropertyDescriptor(h, v) : null;
                b && (b.get || b.set) ? Object.defineProperty(f, v, b) : f[v] = h[v];
              }
            return f.default = h, g && g.set(h, f), f;
          }
          var u = function(A) {
            A === void 0 && (A = {});
            const g = A.document || document, f = A.videoElementBuffer || o, p = A.createVideoElementUsingNativeAPI || t.default;
            return g.hasFocus() ? (f.fillBuffer(), p()) : f.getNext() || p();
          };
          r.default = u;
        },
        /* 571 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.sizeOfBuffer = r.getNext = r.fillBuffer = r.clearBuffer = r.MAX_VIDEO_ELEMENTS = void 0;
          var t = n(e(149));
          const o = 20;
          r.MAX_VIDEO_ELEMENTS = o;
          const l = [], c = () => l.length;
          r.sizeOfBuffer = c;
          const d = () => {
            for (; c() < o; ) {
              const A = (0, t.default)();
              A.play().catch(() => {
              }), l.push(A);
            }
          };
          r.fillBuffer = d;
          const u = () => l.shift();
          r.getNext = u;
          const h = () => {
            l.length = 0;
          };
          r.clearBuffer = h;
        },
        /* 572 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = ["buildHash", "minimumVersion", "debug", ["websiteURL", "websiteUrl"], ["cdnURL", "cdnUrl"], ["loggingURL", "loggingUrl"], ["apiURL", "apiUrl"], ["supportSSL", !0], ["cdnURLSSL", "cdnUrl"], ["loggingURLSSL", "loggingUrl"], ["apiURLSSL", "apiUrl"], ["assetURL", "assetUrl"]];
          r.default = t;
        },
        /* 573 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = ["apiUrl", "apiURL", "apiURLSSL"];
          r.default = t;
        },
        /* 574 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n() {
            const t = (typeof window !== void 0 ? window : Dn).OT, o = (typeof window !== void 0 ? window : Dn).TB;
            return () => {
              const l = (typeof window !== void 0 ? window : Dn).OT;
              return (typeof window !== void 0 ? window : Dn).OT = t, (typeof window !== void 0 ? window : Dn).TB = o, l;
            };
          }
        },
        /* 575 */
        /***/
        function(i, r, e) {
          var n = e(32);
          i.exports = function(t, o) {
            var l = t && t.window, c = {
              shimChrome: !0,
              shimFirefox: !0,
              shimEdge: !0,
              shimSafari: !0
            };
            for (var d in o)
              hasOwnProperty.call(o, d) && (c[d] = o[d]);
            var u = n.log, h = n.detectBrowser(l), A = e(576) || null, g = e(578) || null, f = e(582) || null, p = e(584) || null, v = e(585) || null, b = {
              browserDetails: h,
              commonShim: v,
              extractVersion: n.extractVersion,
              disableLog: n.disableLog,
              disableWarnings: n.disableWarnings
            };
            switch (h.browser) {
              case "chrome":
                if (!A || !A.shimPeerConnection || !c.shimChrome)
                  return u("Chrome shim is not included in this adapter release."), b;
                u("adapter.js shimming chrome."), b.browserShim = A, v.shimCreateObjectURL(l), A.shimGetUserMedia(l), A.shimMediaStream(l), A.shimSourceObject(l), A.shimPeerConnection(l), A.shimOnTrack(l), A.shimAddTrackRemoveTrack(l), A.shimGetSendersWithDtmf(l), A.shimSenderReceiverGetStats(l), A.fixNegotiationNeeded(l), v.shimRTCIceCandidate(l), v.shimMaxMessageSize(l), v.shimSendThrowTypeError(l);
                break;
              case "firefox":
                if (!f || !f.shimPeerConnection || !c.shimFirefox)
                  return u("Firefox shim is not included in this adapter release."), b;
                u("adapter.js shimming firefox."), b.browserShim = f, v.shimCreateObjectURL(l), f.shimGetUserMedia(l), f.shimSourceObject(l), f.shimPeerConnection(l), f.shimOnTrack(l), f.shimRemoveStream(l), f.shimSenderGetStats(l), f.shimReceiverGetStats(l), f.shimRTCDataChannel(l), v.shimRTCIceCandidate(l), v.shimMaxMessageSize(l), v.shimSendThrowTypeError(l);
                break;
              case "edge":
                if (!g || !g.shimPeerConnection || !c.shimEdge)
                  return u("MS edge shim is not included in this adapter release."), b;
                u("adapter.js shimming edge."), b.browserShim = g, v.shimCreateObjectURL(l), g.shimGetUserMedia(l), g.shimPeerConnection(l), g.shimReplaceTrack(l), g.shimGetDisplayMedia(l), v.shimMaxMessageSize(l), v.shimSendThrowTypeError(l);
                break;
              case "safari":
                if (!p || !c.shimSafari)
                  return u("Safari shim is not included in this adapter release."), b;
                u("adapter.js shimming safari."), b.browserShim = p, v.shimCreateObjectURL(l), p.shimRTCIceServerUrls(l), p.shimCreateOfferLegacy(l), p.shimCallbacksAPI(l), p.shimLocalStreamsAPI(l), p.shimRemoteStreamsAPI(l), p.shimTrackEventTransceiver(l), p.shimGetUserMedia(l), v.shimRTCIceCandidate(l), v.shimMaxMessageSize(l), v.shimSendThrowTypeError(l);
                break;
              default:
                u("Unsupported browser!");
                break;
            }
            return b;
          };
        },
        /* 576 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(32), o = t.log;
            function l(d, u, h) {
              !u || h.has(u.id) || (h.set(u.id, u), Object.keys(u).forEach(function(A) {
                A.endsWith("Id") ? l(d, d.get(u[A]), h) : A.endsWith("Ids") && u[A].forEach(function(g) {
                  l(d, d.get(g), h);
                });
              }));
            }
            function c(d, u, h) {
              var A = h ? "outbound-rtp" : "inbound-rtp", g = /* @__PURE__ */ new Map();
              if (u === null)
                return g;
              var f = [];
              return d.forEach(function(p) {
                p.type === "track" && p.trackIdentifier === u.id && f.push(p);
              }), f.forEach(function(p) {
                d.forEach(function(v) {
                  v.type === A && v.trackId === p.id && l(d, v, g);
                });
              }), g;
            }
            i.exports = {
              shimGetUserMedia: e(577),
              shimMediaStream: function(d) {
                d.MediaStream = d.MediaStream || d.webkitMediaStream;
              },
              shimOnTrack: function(d) {
                if (typeof d == "object" && d.RTCPeerConnection && !("ontrack" in d.RTCPeerConnection.prototype)) {
                  Object.defineProperty(d.RTCPeerConnection.prototype, "ontrack", {
                    get: function() {
                      return this._ontrack;
                    },
                    set: function(h) {
                      this._ontrack && this.removeEventListener("track", this._ontrack), this.addEventListener("track", this._ontrack = h);
                    },
                    enumerable: !0,
                    configurable: !0
                  });
                  var u = d.RTCPeerConnection.prototype.setRemoteDescription;
                  d.RTCPeerConnection.prototype.setRemoteDescription = function() {
                    var h = this;
                    return h._ontrackpoly || (h._ontrackpoly = function(A) {
                      A.stream.addEventListener("addtrack", function(g) {
                        var f;
                        d.RTCPeerConnection.prototype.getReceivers ? f = h.getReceivers().find(function(v) {
                          return v.track && v.track.id === g.track.id;
                        }) : f = { track: g.track };
                        var p = new Event("track");
                        p.track = g.track, p.receiver = f, p.transceiver = { receiver: f }, p.streams = [A.stream], h.dispatchEvent(p);
                      }), A.stream.getTracks().forEach(function(g) {
                        var f;
                        d.RTCPeerConnection.prototype.getReceivers ? f = h.getReceivers().find(function(v) {
                          return v.track && v.track.id === g.id;
                        }) : f = { track: g };
                        var p = new Event("track");
                        p.track = g, p.receiver = f, p.transceiver = { receiver: f }, p.streams = [A.stream], h.dispatchEvent(p);
                      });
                    }, h.addEventListener("addstream", h._ontrackpoly)), u.apply(h, arguments);
                  };
                } else
                  t.wrapPeerConnectionEvent(d, "track", function(h) {
                    return h.transceiver || Object.defineProperty(
                      h,
                      "transceiver",
                      { value: { receiver: h.receiver } }
                    ), h;
                  });
              },
              shimGetSendersWithDtmf: function(d) {
                if (typeof d == "object" && d.RTCPeerConnection && !("getSenders" in d.RTCPeerConnection.prototype) && "createDTMFSender" in d.RTCPeerConnection.prototype) {
                  var u = function(v, b) {
                    return {
                      track: b,
                      get dtmf() {
                        return this._dtmf === void 0 && (b.kind === "audio" ? this._dtmf = v.createDTMFSender(b) : this._dtmf = null), this._dtmf;
                      },
                      _pc: v
                    };
                  };
                  if (!d.RTCPeerConnection.prototype.getSenders) {
                    d.RTCPeerConnection.prototype.getSenders = function() {
                      return this._senders = this._senders || [], this._senders.slice();
                    };
                    var h = d.RTCPeerConnection.prototype.addTrack;
                    d.RTCPeerConnection.prototype.addTrack = function(v, b) {
                      var m = this, y = h.apply(m, arguments);
                      return y || (y = u(m, v), m._senders.push(y)), y;
                    };
                    var A = d.RTCPeerConnection.prototype.removeTrack;
                    d.RTCPeerConnection.prototype.removeTrack = function(v) {
                      var b = this;
                      A.apply(b, arguments);
                      var m = b._senders.indexOf(v);
                      m !== -1 && b._senders.splice(m, 1);
                    };
                  }
                  var g = d.RTCPeerConnection.prototype.addStream;
                  d.RTCPeerConnection.prototype.addStream = function(v) {
                    var b = this;
                    b._senders = b._senders || [], g.apply(b, [v]), v.getTracks().forEach(function(m) {
                      b._senders.push(u(b, m));
                    });
                  };
                  var f = d.RTCPeerConnection.prototype.removeStream;
                  d.RTCPeerConnection.prototype.removeStream = function(v) {
                    var b = this;
                    b._senders = b._senders || [], f.apply(b, [v]), v.getTracks().forEach(function(m) {
                      var y = b._senders.find(function(U) {
                        return U.track === m;
                      });
                      y && b._senders.splice(b._senders.indexOf(y), 1);
                    });
                  };
                } else if (typeof d == "object" && d.RTCPeerConnection && "getSenders" in d.RTCPeerConnection.prototype && "createDTMFSender" in d.RTCPeerConnection.prototype && d.RTCRtpSender && !("dtmf" in d.RTCRtpSender.prototype)) {
                  var p = d.RTCPeerConnection.prototype.getSenders;
                  d.RTCPeerConnection.prototype.getSenders = function() {
                    var v = this, b = p.apply(v, []);
                    return b.forEach(function(m) {
                      m._pc = v;
                    }), b;
                  }, Object.defineProperty(d.RTCRtpSender.prototype, "dtmf", {
                    get: function() {
                      return this._dtmf === void 0 && (this.track.kind === "audio" ? this._dtmf = this._pc.createDTMFSender(this.track) : this._dtmf = null), this._dtmf;
                    }
                  });
                }
              },
              shimSenderReceiverGetStats: function(d) {
                if (typeof d == "object" && d.RTCPeerConnection && d.RTCRtpSender && d.RTCRtpReceiver) {
                  if (!("getStats" in d.RTCRtpSender.prototype)) {
                    var u = d.RTCPeerConnection.prototype.getSenders;
                    u && (d.RTCPeerConnection.prototype.getSenders = function() {
                      var f = this, p = u.apply(f, []);
                      return p.forEach(function(v) {
                        v._pc = f;
                      }), p;
                    });
                    var h = d.RTCPeerConnection.prototype.addTrack;
                    h && (d.RTCPeerConnection.prototype.addTrack = function() {
                      var f = h.apply(this, arguments);
                      return f._pc = this, f;
                    }), d.RTCRtpSender.prototype.getStats = function() {
                      var f = this;
                      return this._pc.getStats().then(function(p) {
                        return c(p, f.track, !0);
                      });
                    };
                  }
                  if (!("getStats" in d.RTCRtpReceiver.prototype)) {
                    var A = d.RTCPeerConnection.prototype.getReceivers;
                    A && (d.RTCPeerConnection.prototype.getReceivers = function() {
                      var f = this, p = A.apply(f, []);
                      return p.forEach(function(v) {
                        v._pc = f;
                      }), p;
                    }), t.wrapPeerConnectionEvent(d, "track", function(f) {
                      return f.receiver._pc = f.srcElement, f;
                    }), d.RTCRtpReceiver.prototype.getStats = function() {
                      var f = this;
                      return this._pc.getStats().then(function(p) {
                        return c(p, f.track, !1);
                      });
                    };
                  }
                  if ("getStats" in d.RTCRtpSender.prototype && "getStats" in d.RTCRtpReceiver.prototype) {
                    var g = d.RTCPeerConnection.prototype.getStats;
                    d.RTCPeerConnection.prototype.getStats = function() {
                      var f = this;
                      if (arguments.length > 0 && arguments[0] instanceof d.MediaStreamTrack) {
                        var p = arguments[0], v, b, m;
                        return f.getSenders().forEach(function(y) {
                          y.track === p && (v ? m = !0 : v = y);
                        }), f.getReceivers().forEach(function(y) {
                          return y.track === p && (b ? m = !0 : b = y), y.track === p;
                        }), m || v && b ? n.reject(new DOMException(
                          "There are more than one sender or receiver for the track.",
                          "InvalidAccessError"
                        )) : v ? v.getStats() : b ? b.getStats() : n.reject(new DOMException(
                          "There is no sender or receiver for the track.",
                          "InvalidAccessError"
                        ));
                      }
                      return g.apply(f, arguments);
                    };
                  }
                }
              },
              shimSourceObject: function(d) {
                var u = d && d.URL;
                typeof d == "object" && d.HTMLMediaElement && !("srcObject" in d.HTMLMediaElement.prototype) && Object.defineProperty(d.HTMLMediaElement.prototype, "srcObject", {
                  get: function() {
                    return this._srcObject;
                  },
                  set: function(h) {
                    var A = this;
                    if (this._srcObject = h, this.src && u.revokeObjectURL(this.src), !h) {
                      this.src = "";
                      return;
                    }
                    this.src = u.createObjectURL(h), h.addEventListener("addtrack", function() {
                      A.src && u.revokeObjectURL(A.src), A.src = u.createObjectURL(h);
                    }), h.addEventListener("removetrack", function() {
                      A.src && u.revokeObjectURL(A.src), A.src = u.createObjectURL(h);
                    });
                  }
                });
              },
              shimAddTrackRemoveTrackWithNative: function(d) {
                d.RTCPeerConnection.prototype.getLocalStreams = function() {
                  var f = this;
                  return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, Object.keys(this._shimmedLocalStreams).map(function(p) {
                    return f._shimmedLocalStreams[p][0];
                  });
                };
                var u = d.RTCPeerConnection.prototype.addTrack;
                d.RTCPeerConnection.prototype.addTrack = function(f, p) {
                  if (!p)
                    return u.apply(this, arguments);
                  this._shimmedLocalStreams = this._shimmedLocalStreams || {};
                  var v = u.apply(this, arguments);
                  return this._shimmedLocalStreams[p.id] ? this._shimmedLocalStreams[p.id].indexOf(v) === -1 && this._shimmedLocalStreams[p.id].push(v) : this._shimmedLocalStreams[p.id] = [p, v], v;
                };
                var h = d.RTCPeerConnection.prototype.addStream;
                d.RTCPeerConnection.prototype.addStream = function(f) {
                  var p = this;
                  this._shimmedLocalStreams = this._shimmedLocalStreams || {}, f.getTracks().forEach(function(m) {
                    var y = p.getSenders().find(function(U) {
                      return U.track === m;
                    });
                    if (y)
                      throw new DOMException(
                        "Track already exists.",
                        "InvalidAccessError"
                      );
                  });
                  var v = p.getSenders();
                  h.apply(this, arguments);
                  var b = p.getSenders().filter(function(m) {
                    return v.indexOf(m) === -1;
                  });
                  this._shimmedLocalStreams[f.id] = [f].concat(b);
                };
                var A = d.RTCPeerConnection.prototype.removeStream;
                d.RTCPeerConnection.prototype.removeStream = function(f) {
                  return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, delete this._shimmedLocalStreams[f.id], A.apply(this, arguments);
                };
                var g = d.RTCPeerConnection.prototype.removeTrack;
                d.RTCPeerConnection.prototype.removeTrack = function(f) {
                  var p = this;
                  return this._shimmedLocalStreams = this._shimmedLocalStreams || {}, f && Object.keys(this._shimmedLocalStreams).forEach(function(v) {
                    var b = p._shimmedLocalStreams[v].indexOf(f);
                    b !== -1 && p._shimmedLocalStreams[v].splice(b, 1), p._shimmedLocalStreams[v].length === 1 && delete p._shimmedLocalStreams[v];
                  }), g.apply(this, arguments);
                };
              },
              shimAddTrackRemoveTrack: function(d) {
                if (!d.RTCPeerConnection)
                  return;
                var u = t.detectBrowser(d);
                if (d.RTCPeerConnection.prototype.addTrack && u.version >= 65)
                  return this.shimAddTrackRemoveTrackWithNative(d);
                var h = d.RTCPeerConnection.prototype.getLocalStreams;
                d.RTCPeerConnection.prototype.getLocalStreams = function() {
                  var m = this, y = h.apply(this);
                  return m._reverseStreams = m._reverseStreams || {}, y.map(function(U) {
                    return m._reverseStreams[U.id];
                  });
                };
                var A = d.RTCPeerConnection.prototype.addStream;
                d.RTCPeerConnection.prototype.addStream = function(m) {
                  var y = this;
                  if (y._streams = y._streams || {}, y._reverseStreams = y._reverseStreams || {}, m.getTracks().forEach(function(B) {
                    var Q = y.getSenders().find(function(N) {
                      return N.track === B;
                    });
                    if (Q)
                      throw new DOMException(
                        "Track already exists.",
                        "InvalidAccessError"
                      );
                  }), !y._reverseStreams[m.id]) {
                    var U = new d.MediaStream(m.getTracks());
                    y._streams[m.id] = U, y._reverseStreams[U.id] = m, m = U;
                  }
                  A.apply(y, [m]);
                };
                var g = d.RTCPeerConnection.prototype.removeStream;
                d.RTCPeerConnection.prototype.removeStream = function(m) {
                  var y = this;
                  y._streams = y._streams || {}, y._reverseStreams = y._reverseStreams || {}, g.apply(y, [y._streams[m.id] || m]), delete y._reverseStreams[y._streams[m.id] ? y._streams[m.id].id : m.id], delete y._streams[m.id];
                }, d.RTCPeerConnection.prototype.addTrack = function(m, y) {
                  var U = this;
                  if (U.signalingState === "closed")
                    throw new DOMException(
                      "The RTCPeerConnection's signalingState is 'closed'.",
                      "InvalidStateError"
                    );
                  var B = [].slice.call(arguments, 1);
                  if (B.length !== 1 || !B[0].getTracks().find(function(w) {
                    return w === m;
                  }))
                    throw new DOMException(
                      "The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.",
                      "NotSupportedError"
                    );
                  var Q = U.getSenders().find(function(w) {
                    return w.track === m;
                  });
                  if (Q)
                    throw new DOMException(
                      "Track already exists.",
                      "InvalidAccessError"
                    );
                  U._streams = U._streams || {}, U._reverseStreams = U._reverseStreams || {};
                  var N = U._streams[y.id];
                  if (N)
                    N.addTrack(m), n.resolve().then(function() {
                      U.dispatchEvent(new Event("negotiationneeded"));
                    });
                  else {
                    var J = new d.MediaStream([m]);
                    U._streams[y.id] = J, U._reverseStreams[J.id] = y, U.addStream(J);
                  }
                  return U.getSenders().find(function(w) {
                    return w.track === m;
                  });
                };
                function f(m, y) {
                  var U = y.sdp;
                  return Object.keys(m._reverseStreams || []).forEach(function(B) {
                    var Q = m._reverseStreams[B], N = m._streams[Q.id];
                    U = U.replace(
                      new RegExp(N.id, "g"),
                      Q.id
                    );
                  }), new RTCSessionDescription({
                    type: y.type,
                    sdp: U
                  });
                }
                function p(m, y) {
                  var U = y.sdp;
                  return Object.keys(m._reverseStreams || []).forEach(function(B) {
                    var Q = m._reverseStreams[B], N = m._streams[Q.id];
                    U = U.replace(
                      new RegExp(Q.id, "g"),
                      N.id
                    );
                  }), new RTCSessionDescription({
                    type: y.type,
                    sdp: U
                  });
                }
                ["createOffer", "createAnswer"].forEach(function(m) {
                  var y = d.RTCPeerConnection.prototype[m];
                  d.RTCPeerConnection.prototype[m] = function() {
                    var U = this, B = arguments, Q = arguments.length && typeof arguments[0] == "function";
                    return Q ? y.apply(U, [
                      function(N) {
                        var J = f(U, N);
                        B[0].apply(null, [J]);
                      },
                      function(N) {
                        B[1] && B[1].apply(null, N);
                      },
                      arguments[2]
                    ]) : y.apply(U, arguments).then(function(N) {
                      return f(U, N);
                    });
                  };
                });
                var v = d.RTCPeerConnection.prototype.setLocalDescription;
                d.RTCPeerConnection.prototype.setLocalDescription = function() {
                  var m = this;
                  return !arguments.length || !arguments[0].type || (arguments[0] = p(m, arguments[0])), v.apply(m, arguments);
                };
                var b = Object.getOwnPropertyDescriptor(
                  d.RTCPeerConnection.prototype,
                  "localDescription"
                );
                Object.defineProperty(
                  d.RTCPeerConnection.prototype,
                  "localDescription",
                  {
                    get: function() {
                      var m = this, y = b.get.apply(this);
                      return y.type === "" ? y : f(m, y);
                    }
                  }
                ), d.RTCPeerConnection.prototype.removeTrack = function(m) {
                  var y = this;
                  if (y.signalingState === "closed")
                    throw new DOMException(
                      "The RTCPeerConnection's signalingState is 'closed'.",
                      "InvalidStateError"
                    );
                  if (!m._pc)
                    throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
                  var U = m._pc === y;
                  if (!U)
                    throw new DOMException(
                      "Sender was not created by this connection.",
                      "InvalidAccessError"
                    );
                  y._streams = y._streams || {};
                  var B;
                  Object.keys(y._streams).forEach(function(Q) {
                    var N = y._streams[Q].getTracks().find(function(J) {
                      return m.track === J;
                    });
                    N && (B = y._streams[Q]);
                  }), B && (B.getTracks().length === 1 ? y.removeStream(y._reverseStreams[B.id]) : B.removeTrack(m.track), y.dispatchEvent(new Event("negotiationneeded")));
                };
              },
              shimPeerConnection: function(d) {
                var u = t.detectBrowser(d);
                if (!d.RTCPeerConnection && d.webkitRTCPeerConnection && (d.RTCPeerConnection = function(g, f) {
                  return o("PeerConnection"), g && g.iceTransportPolicy && (g.iceTransports = g.iceTransportPolicy), new d.webkitRTCPeerConnection(g, f);
                }, d.RTCPeerConnection.prototype = d.webkitRTCPeerConnection.prototype, d.webkitRTCPeerConnection.generateCertificate && Object.defineProperty(d.RTCPeerConnection, "generateCertificate", {
                  get: function() {
                    return d.webkitRTCPeerConnection.generateCertificate;
                  }
                })), !!d.RTCPeerConnection) {
                  var h = d.RTCPeerConnection.prototype.getStats;
                  d.RTCPeerConnection.prototype.getStats = function(g, f, p) {
                    var v = this, b = arguments;
                    if (arguments.length > 0 && typeof g == "function")
                      return h.apply(this, arguments);
                    if (h.length === 0 && (arguments.length === 0 || typeof arguments[0] != "function"))
                      return h.apply(this, []);
                    var m = function(B) {
                      var Q = {}, N = B.result();
                      return N.forEach(function(J) {
                        var w = {
                          id: J.id,
                          timestamp: J.timestamp,
                          type: {
                            localcandidate: "local-candidate",
                            remotecandidate: "remote-candidate"
                          }[J.type] || J.type
                        };
                        J.names().forEach(function(W) {
                          w[W] = J.stat(W);
                        }), Q[w.id] = w;
                      }), Q;
                    }, y = function(B) {
                      return new Map(Object.keys(B).map(function(Q) {
                        return [Q, B[Q]];
                      }));
                    };
                    if (arguments.length >= 2) {
                      var U = function(B) {
                        b[1](y(m(B)));
                      };
                      return h.apply(this, [
                        U,
                        arguments[0]
                      ]);
                    }
                    return new n(function(B, Q) {
                      h.apply(v, [
                        function(N) {
                          B(y(m(N)));
                        },
                        Q
                      ]);
                    }).then(f, p);
                  }, u.version < 51 && ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(g) {
                    var f = d.RTCPeerConnection.prototype[g];
                    d.RTCPeerConnection.prototype[g] = function() {
                      var p = arguments, v = this, b = new n(function(m, y) {
                        f.apply(v, [p[0], m, y]);
                      });
                      return p.length < 2 ? b : b.then(
                        function() {
                          p[1].apply(null, []);
                        },
                        function(m) {
                          p.length >= 3 && p[2].apply(null, [m]);
                        }
                      );
                    };
                  }), u.version < 52 && ["createOffer", "createAnswer"].forEach(function(g) {
                    var f = d.RTCPeerConnection.prototype[g];
                    d.RTCPeerConnection.prototype[g] = function() {
                      var p = this;
                      if (arguments.length < 1 || arguments.length === 1 && typeof arguments[0] == "object") {
                        var v = arguments.length === 1 ? arguments[0] : void 0;
                        return new n(function(b, m) {
                          f.apply(p, [b, m, v]);
                        });
                      }
                      return f.apply(this, arguments);
                    };
                  }), ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(g) {
                    var f = d.RTCPeerConnection.prototype[g];
                    d.RTCPeerConnection.prototype[g] = function() {
                      return arguments[0] = new (g === "addIceCandidate" ? d.RTCIceCandidate : d.RTCSessionDescription)(arguments[0]), f.apply(this, arguments);
                    };
                  });
                  var A = d.RTCPeerConnection.prototype.addIceCandidate;
                  d.RTCPeerConnection.prototype.addIceCandidate = function() {
                    return arguments[0] ? A.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), n.resolve());
                  };
                }
              },
              fixNegotiationNeeded: function(d) {
                t.wrapPeerConnectionEvent(d, "negotiationneeded", function(u) {
                  var h = u.target;
                  if (h.signalingState === "stable")
                    return u;
                });
              },
              shimGetDisplayMedia: function(d, u) {
                if (!(!d.navigator || !d.navigator.mediaDevices || "getDisplayMedia" in d.navigator.mediaDevices)) {
                  if (typeof u != "function") {
                    console.error("shimGetDisplayMedia: getSourceId argument is not a function");
                    return;
                  }
                  d.navigator.mediaDevices.getDisplayMedia = function(h) {
                    return u(h).then(function(A) {
                      var g = h.video && h.video.width, f = h.video && h.video.height, p = h.video && h.video.frameRate;
                      return h.video = {
                        mandatory: {
                          chromeMediaSource: "desktop",
                          chromeMediaSourceId: A,
                          maxFrameRate: p || 3
                        }
                      }, g && (h.video.mandatory.maxWidth = g), f && (h.video.mandatory.maxHeight = f), d.navigator.mediaDevices.getUserMedia(h);
                    });
                  }, d.navigator.getDisplayMedia = function(h) {
                    return t.deprecated(
                      "navigator.getDisplayMedia",
                      "navigator.mediaDevices.getDisplayMedia"
                    ), d.navigator.mediaDevices.getDisplayMedia(h);
                  };
                }
              }
            };
          }).call(this, e(2));
        },
        /* 577 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(32), o = t.log;
            i.exports = function(l) {
              var c = t.detectBrowser(l), d = l && l.navigator, u = function(v) {
                if (typeof v != "object" || v.mandatory || v.optional)
                  return v;
                var b = {};
                return Object.keys(v).forEach(function(m) {
                  if (!(m === "require" || m === "advanced" || m === "mediaSource")) {
                    var y = typeof v[m] == "object" ? v[m] : { ideal: v[m] };
                    y.exact !== void 0 && typeof y.exact == "number" && (y.min = y.max = y.exact);
                    var U = function(Q, N) {
                      return Q ? Q + N.charAt(0).toUpperCase() + N.slice(1) : N === "deviceId" ? "sourceId" : N;
                    };
                    if (y.ideal !== void 0) {
                      b.optional = b.optional || [];
                      var B = {};
                      typeof y.ideal == "number" ? (B[U("min", m)] = y.ideal, b.optional.push(B), B = {}, B[U("max", m)] = y.ideal, b.optional.push(B)) : (B[U("", m)] = y.ideal, b.optional.push(B));
                    }
                    y.exact !== void 0 && typeof y.exact != "number" ? (b.mandatory = b.mandatory || {}, b.mandatory[U("", m)] = y.exact) : ["min", "max"].forEach(function(Q) {
                      y[Q] !== void 0 && (b.mandatory = b.mandatory || {}, b.mandatory[U(Q, m)] = y[Q]);
                    });
                  }
                }), v.advanced && (b.optional = (b.optional || []).concat(v.advanced)), b;
              }, h = function(v, b) {
                if (c.version >= 61)
                  return b(v);
                if (v = JSON.parse(JSON.stringify(v)), v && typeof v.audio == "object") {
                  var m = function(Q, N, J) {
                    N in Q && !(J in Q) && (Q[J] = Q[N], delete Q[N]);
                  };
                  v = JSON.parse(JSON.stringify(v)), m(v.audio, "autoGainControl", "googAutoGainControl"), m(v.audio, "noiseSuppression", "googNoiseSuppression"), v.audio = u(v.audio);
                }
                if (v && typeof v.video == "object") {
                  var y = v.video.facingMode;
                  y = y && (typeof y == "object" ? y : { ideal: y });
                  var U = c.version < 66;
                  if (y && (y.exact === "user" || y.exact === "environment" || y.ideal === "user" || y.ideal === "environment") && !(d.mediaDevices.getSupportedConstraints && d.mediaDevices.getSupportedConstraints().facingMode && !U)) {
                    delete v.video.facingMode;
                    var B;
                    if (y.exact === "environment" || y.ideal === "environment" ? B = ["back", "rear"] : (y.exact === "user" || y.ideal === "user") && (B = ["front"]), B)
                      return d.mediaDevices.enumerateDevices().then(function(Q) {
                        Q = Q.filter(function(J) {
                          return J.kind === "videoinput";
                        });
                        var N = Q.find(function(J) {
                          return B.some(function(w) {
                            return J.label.toLowerCase().indexOf(w) !== -1;
                          });
                        });
                        return !N && Q.length && B.indexOf("back") !== -1 && (N = Q[Q.length - 1]), N && (v.video.deviceId = y.exact ? { exact: N.deviceId } : { ideal: N.deviceId }), v.video = u(v.video), o("chrome: " + JSON.stringify(v)), b(v);
                      });
                  }
                  v.video = u(v.video);
                }
                return o("chrome: " + JSON.stringify(v)), b(v);
              }, A = function(v) {
                return c.version >= 64 ? v : {
                  name: {
                    PermissionDeniedError: "NotAllowedError",
                    PermissionDismissedError: "NotAllowedError",
                    InvalidStateError: "NotAllowedError",
                    DevicesNotFoundError: "NotFoundError",
                    ConstraintNotSatisfiedError: "OverconstrainedError",
                    TrackStartError: "NotReadableError",
                    MediaDeviceFailedDueToShutdown: "NotAllowedError",
                    MediaDeviceKillSwitchOn: "NotAllowedError",
                    TabCaptureError: "AbortError",
                    ScreenCaptureError: "AbortError",
                    DeviceCaptureError: "AbortError"
                  }[v.name] || v.name,
                  message: v.message,
                  constraint: v.constraint || v.constraintName,
                  toString: function() {
                    return this.name + (this.message && ": ") + this.message;
                  }
                };
              }, g = function(v, b, m) {
                h(v, function(y) {
                  d.webkitGetUserMedia(y, b, function(U) {
                    m && m(A(U));
                  });
                });
              };
              d.getUserMedia = g;
              var f = function(v) {
                return new n(function(b, m) {
                  d.getUserMedia(v, b, m);
                });
              };
              if (d.mediaDevices || (d.mediaDevices = {
                getUserMedia: f,
                enumerateDevices: function() {
                  return new n(function(v) {
                    var b = { audio: "audioinput", video: "videoinput" };
                    return l.MediaStreamTrack.getSources(function(m) {
                      v(m.map(function(y) {
                        return {
                          label: y.label,
                          kind: b[y.kind],
                          deviceId: y.id,
                          groupId: ""
                        };
                      }));
                    });
                  });
                },
                getSupportedConstraints: function() {
                  return {
                    deviceId: !0,
                    echoCancellation: !0,
                    facingMode: !0,
                    frameRate: !0,
                    height: !0,
                    width: !0
                  };
                }
              }), !d.mediaDevices.getUserMedia)
                d.mediaDevices.getUserMedia = function(v) {
                  return f(v);
                };
              else {
                var p = d.mediaDevices.getUserMedia.bind(d.mediaDevices);
                d.mediaDevices.getUserMedia = function(v) {
                  return h(v, function(b) {
                    return p(b).then(function(m) {
                      if (b.audio && !m.getAudioTracks().length || b.video && !m.getVideoTracks().length)
                        throw m.getTracks().forEach(function(y) {
                          y.stop();
                        }), new DOMException("", "NotFoundError");
                      return m;
                    }, function(m) {
                      return n.reject(A(m));
                    });
                  });
                };
              }
              typeof d.mediaDevices.addEventListener == "undefined" && (d.mediaDevices.addEventListener = function() {
                o("Dummy mediaDevices.addEventListener called.");
              }), typeof d.mediaDevices.removeEventListener == "undefined" && (d.mediaDevices.removeEventListener = function() {
                o("Dummy mediaDevices.removeEventListener called.");
              });
            };
          }).call(this, e(2));
        },
        /* 578 */
        /***/
        function(i, r, e) {
          var n = e(32), t = e(579), o = e(580);
          i.exports = {
            shimGetUserMedia: e(581),
            shimPeerConnection: function(l) {
              var c = n.detectBrowser(l);
              if (l.RTCIceGatherer && (l.RTCIceCandidate || (l.RTCIceCandidate = function(h) {
                return h;
              }), l.RTCSessionDescription || (l.RTCSessionDescription = function(h) {
                return h;
              }), c.version < 15025)) {
                var d = Object.getOwnPropertyDescriptor(
                  l.MediaStreamTrack.prototype,
                  "enabled"
                );
                Object.defineProperty(l.MediaStreamTrack.prototype, "enabled", {
                  set: function(h) {
                    d.set.call(this, h);
                    var A = new Event("enabled");
                    A.enabled = h, this.dispatchEvent(A);
                  }
                });
              }
              l.RTCRtpSender && !("dtmf" in l.RTCRtpSender.prototype) && Object.defineProperty(l.RTCRtpSender.prototype, "dtmf", {
                get: function() {
                  return this._dtmf === void 0 && (this.track.kind === "audio" ? this._dtmf = new l.RTCDtmfSender(this) : this.track.kind === "video" && (this._dtmf = null)), this._dtmf;
                }
              }), l.RTCDtmfSender && !l.RTCDTMFSender && (l.RTCDTMFSender = l.RTCDtmfSender);
              var u = o(
                l,
                c.version
              );
              l.RTCPeerConnection = function(h) {
                return h && h.iceServers && (h.iceServers = t(h.iceServers)), new u(h);
              }, l.RTCPeerConnection.prototype = u.prototype;
            },
            shimReplaceTrack: function(l) {
              l.RTCRtpSender && !("replaceTrack" in l.RTCRtpSender.prototype) && (l.RTCRtpSender.prototype.replaceTrack = l.RTCRtpSender.prototype.setTrack);
            },
            shimGetDisplayMedia: function(l, c) {
              if (!(!("getDisplayMedia" in l.navigator) || !l.navigator.mediaDevices || "getDisplayMedia" in l.navigator.mediaDevices)) {
                var d = l.navigator.getDisplayMedia;
                l.navigator.mediaDevices.getDisplayMedia = function(u) {
                  return d.call(l.navigator, u);
                }, l.navigator.getDisplayMedia = function(u) {
                  return n.deprecated(
                    "navigator.getDisplayMedia",
                    "navigator.mediaDevices.getDisplayMedia"
                  ), d.call(l.navigator, u);
                };
              }
            }
          };
        },
        /* 579 */
        /***/
        function(i, r, e) {
          var n = e(32);
          i.exports = function(t, o) {
            var l = !1;
            return t = JSON.parse(JSON.stringify(t)), t.filter(function(c) {
              if (c && (c.urls || c.url)) {
                var d = c.urls || c.url;
                c.url && !c.urls && n.deprecated("RTCIceServer.url", "RTCIceServer.urls");
                var u = typeof d == "string";
                return u && (d = [d]), d = d.filter(function(h) {
                  var A = h.indexOf("turn:") === 0 && h.indexOf("transport=udp") !== -1 && h.indexOf("turn:[") === -1 && !l;
                  return A ? (l = !0, !0) : h.indexOf("stun:") === 0 && o >= 14393 && h.indexOf("?transport=udp") === -1;
                }), delete c.url, c.urls = u ? d[0] : d, !!d.length;
              }
            });
          };
        },
        /* 580 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(269);
            function o(g) {
              return {
                inboundrtp: "inbound-rtp",
                outboundrtp: "outbound-rtp",
                candidatepair: "candidate-pair",
                localcandidate: "local-candidate",
                remotecandidate: "remote-candidate"
              }[g.type] || g.type;
            }
            function l(g, f, p, v, b) {
              var m = t.writeRtpDescription(g.kind, f);
              if (m += t.writeIceParameters(
                g.iceGatherer.getLocalParameters()
              ), m += t.writeDtlsParameters(
                g.dtlsTransport.getLocalParameters(),
                p === "offer" ? "actpass" : b || "active"
              ), m += "a=mid:" + g.mid + `\r
`, g.rtpSender && g.rtpReceiver ? m += `a=sendrecv\r
` : g.rtpSender ? m += `a=sendonly\r
` : g.rtpReceiver ? m += `a=recvonly\r
` : m += `a=inactive\r
`, g.rtpSender) {
                var y = g.rtpSender._initialTrackId || g.rtpSender.track.id;
                g.rtpSender._initialTrackId = y;
                var U = "msid:" + (v ? v.id : "-") + " " + y + `\r
`;
                m += "a=" + U, m += "a=ssrc:" + g.sendEncodingParameters[0].ssrc + " " + U, g.sendEncodingParameters[0].rtx && (m += "a=ssrc:" + g.sendEncodingParameters[0].rtx.ssrc + " " + U, m += "a=ssrc-group:FID " + g.sendEncodingParameters[0].ssrc + " " + g.sendEncodingParameters[0].rtx.ssrc + `\r
`);
              }
              return m += "a=ssrc:" + g.sendEncodingParameters[0].ssrc + " cname:" + t.localCName + `\r
`, g.rtpSender && g.sendEncodingParameters[0].rtx && (m += "a=ssrc:" + g.sendEncodingParameters[0].rtx.ssrc + " cname:" + t.localCName + `\r
`), m;
            }
            function c(g, f) {
              var p = !1;
              return g = JSON.parse(JSON.stringify(g)), g.filter(function(v) {
                if (v && (v.urls || v.url)) {
                  var b = v.urls || v.url;
                  v.url && !v.urls && console.warn("RTCIceServer.url is deprecated! Use urls instead.");
                  var m = typeof b == "string";
                  return m && (b = [b]), b = b.filter(function(y) {
                    var U = y.indexOf("turn:") === 0 && y.indexOf("transport=udp") !== -1 && y.indexOf("turn:[") === -1 && !p;
                    return U ? (p = !0, !0) : y.indexOf("stun:") === 0 && f >= 14393 && y.indexOf("?transport=udp") === -1;
                  }), delete v.url, v.urls = m ? b[0] : b, !!b.length;
                }
              });
            }
            function d(g, f) {
              var p = {
                codecs: [],
                headerExtensions: [],
                fecMechanisms: []
              }, v = function(m, y) {
                m = parseInt(m, 10);
                for (var U = 0; U < y.length; U++)
                  if (y[U].payloadType === m || y[U].preferredPayloadType === m)
                    return y[U];
              }, b = function(m, y, U, B) {
                var Q = v(m.parameters.apt, U), N = v(y.parameters.apt, B);
                return Q && N && Q.name.toLowerCase() === N.name.toLowerCase();
              };
              return g.codecs.forEach(function(m) {
                for (var y = 0; y < f.codecs.length; y++) {
                  var U = f.codecs[y];
                  if (m.name.toLowerCase() === U.name.toLowerCase() && m.clockRate === U.clockRate) {
                    if (m.name.toLowerCase() === "rtx" && m.parameters && U.parameters.apt && !b(
                      m,
                      U,
                      g.codecs,
                      f.codecs
                    ))
                      continue;
                    U = JSON.parse(JSON.stringify(U)), U.numChannels = Math.min(
                      m.numChannels,
                      U.numChannels
                    ), p.codecs.push(U), U.rtcpFeedback = U.rtcpFeedback.filter(function(B) {
                      for (var Q = 0; Q < m.rtcpFeedback.length; Q++)
                        if (m.rtcpFeedback[Q].type === B.type && m.rtcpFeedback[Q].parameter === B.parameter)
                          return !0;
                      return !1;
                    });
                    break;
                  }
                }
              }), g.headerExtensions.forEach(function(m) {
                for (var y = 0; y < f.headerExtensions.length; y++) {
                  var U = f.headerExtensions[y];
                  if (m.uri === U.uri) {
                    p.headerExtensions.push(U);
                    break;
                  }
                }
              }), p;
            }
            function u(g, f, p) {
              return {
                offer: {
                  setLocalDescription: ["stable", "have-local-offer"],
                  setRemoteDescription: ["stable", "have-remote-offer"]
                },
                answer: {
                  setLocalDescription: ["have-remote-offer", "have-local-pranswer"],
                  setRemoteDescription: ["have-local-offer", "have-remote-pranswer"]
                }
              }[f][g].indexOf(p) !== -1;
            }
            function h(g, f) {
              var p = g.getRemoteCandidates().find(function(v) {
                return f.foundation === v.foundation && f.ip === v.ip && f.port === v.port && f.priority === v.priority && f.protocol === v.protocol && f.type === v.type;
              });
              return p || g.addRemoteCandidate(f), !p;
            }
            function A(g, f) {
              var p = new Error(f);
              return p.name = g, p.code = {
                NotSupportedError: 9,
                InvalidStateError: 11,
                InvalidAccessError: 15,
                TypeError: void 0,
                OperationError: void 0
              }[g], p;
            }
            i.exports = function(g, f) {
              function p(B, Q) {
                Q.addTrack(B), Q.dispatchEvent(new g.MediaStreamTrackEvent(
                  "addtrack",
                  { track: B }
                ));
              }
              function v(B, Q) {
                Q.removeTrack(B), Q.dispatchEvent(new g.MediaStreamTrackEvent(
                  "removetrack",
                  { track: B }
                ));
              }
              function b(B, Q, N, J) {
                var w = new Event("track");
                w.track = Q, w.receiver = N, w.transceiver = { receiver: N }, w.streams = J, g.setTimeout(function() {
                  B._dispatchEvent("track", w);
                });
              }
              var m = function(B) {
                var Q = this, N = document.createDocumentFragment();
                if (["addEventListener", "removeEventListener", "dispatchEvent"].forEach(function(w) {
                  Q[w] = N[w].bind(N);
                }), this.canTrickleIceCandidates = null, this.needNegotiation = !1, this.localStreams = [], this.remoteStreams = [], this._localDescription = null, this._remoteDescription = null, this.signalingState = "stable", this.iceConnectionState = "new", this.connectionState = "new", this.iceGatheringState = "new", B = JSON.parse(JSON.stringify(B || {})), this.usingBundle = B.bundlePolicy === "max-bundle", B.rtcpMuxPolicy === "negotiate")
                  throw A(
                    "NotSupportedError",
                    "rtcpMuxPolicy 'negotiate' is not supported"
                  );
                switch (B.rtcpMuxPolicy || (B.rtcpMuxPolicy = "require"), B.iceTransportPolicy) {
                  case "all":
                  case "relay":
                    break;
                  default:
                    B.iceTransportPolicy = "all";
                    break;
                }
                switch (B.bundlePolicy) {
                  case "balanced":
                  case "max-compat":
                  case "max-bundle":
                    break;
                  default:
                    B.bundlePolicy = "balanced";
                    break;
                }
                if (B.iceServers = c(B.iceServers || [], f), this._iceGatherers = [], B.iceCandidatePoolSize)
                  for (var J = B.iceCandidatePoolSize; J > 0; J--)
                    this._iceGatherers.push(new g.RTCIceGatherer({
                      iceServers: B.iceServers,
                      gatherPolicy: B.iceTransportPolicy
                    }));
                else
                  B.iceCandidatePoolSize = 0;
                this._config = B, this.transceivers = [], this._sdpSessionId = t.generateSessionId(), this._sdpSessionVersion = 0, this._dtlsRole = void 0, this._isClosed = !1;
              };
              Object.defineProperty(m.prototype, "localDescription", {
                configurable: !0,
                get: function() {
                  return this._localDescription;
                }
              }), Object.defineProperty(m.prototype, "remoteDescription", {
                configurable: !0,
                get: function() {
                  return this._remoteDescription;
                }
              }), m.prototype.onicecandidate = null, m.prototype.onaddstream = null, m.prototype.ontrack = null, m.prototype.onremovestream = null, m.prototype.onsignalingstatechange = null, m.prototype.oniceconnectionstatechange = null, m.prototype.onconnectionstatechange = null, m.prototype.onicegatheringstatechange = null, m.prototype.onnegotiationneeded = null, m.prototype.ondatachannel = null, m.prototype._dispatchEvent = function(B, Q) {
                this._isClosed || (this.dispatchEvent(Q), typeof this["on" + B] == "function" && this["on" + B](Q));
              }, m.prototype._emitGatheringStateChange = function() {
                var B = new Event("icegatheringstatechange");
                this._dispatchEvent("icegatheringstatechange", B);
              }, m.prototype.getConfiguration = function() {
                return this._config;
              }, m.prototype.getLocalStreams = function() {
                return this.localStreams;
              }, m.prototype.getRemoteStreams = function() {
                return this.remoteStreams;
              }, m.prototype._createTransceiver = function(B, Q) {
                var N = this.transceivers.length > 0, J = {
                  track: null,
                  iceGatherer: null,
                  iceTransport: null,
                  dtlsTransport: null,
                  localCapabilities: null,
                  remoteCapabilities: null,
                  rtpSender: null,
                  rtpReceiver: null,
                  kind: B,
                  mid: null,
                  sendEncodingParameters: null,
                  recvEncodingParameters: null,
                  stream: null,
                  associatedRemoteMediaStreams: [],
                  wantReceive: !0
                };
                if (this.usingBundle && N)
                  J.iceTransport = this.transceivers[0].iceTransport, J.dtlsTransport = this.transceivers[0].dtlsTransport;
                else {
                  var w = this._createIceAndDtlsTransports();
                  J.iceTransport = w.iceTransport, J.dtlsTransport = w.dtlsTransport;
                }
                return Q || this.transceivers.push(J), J;
              }, m.prototype.addTrack = function(B, Q) {
                if (this._isClosed)
                  throw A(
                    "InvalidStateError",
                    "Attempted to call addTrack on a closed peerconnection."
                  );
                var N = this.transceivers.find(function(W) {
                  return W.track === B;
                });
                if (N)
                  throw A("InvalidAccessError", "Track already exists.");
                for (var J, w = 0; w < this.transceivers.length; w++)
                  !this.transceivers[w].track && this.transceivers[w].kind === B.kind && (J = this.transceivers[w]);
                return J || (J = this._createTransceiver(B.kind)), this._maybeFireNegotiationNeeded(), this.localStreams.indexOf(Q) === -1 && this.localStreams.push(Q), J.track = B, J.stream = Q, J.rtpSender = new g.RTCRtpSender(
                  B,
                  J.dtlsTransport
                ), J.rtpSender;
              }, m.prototype.addStream = function(B) {
                var Q = this;
                if (f >= 15025)
                  B.getTracks().forEach(function(J) {
                    Q.addTrack(J, B);
                  });
                else {
                  var N = B.clone();
                  B.getTracks().forEach(function(J, w) {
                    var W = N.getTracks()[w];
                    J.addEventListener("enabled", function(G) {
                      W.enabled = G.enabled;
                    });
                  }), N.getTracks().forEach(function(J) {
                    Q.addTrack(J, N);
                  });
                }
              }, m.prototype.removeTrack = function(B) {
                if (this._isClosed)
                  throw A(
                    "InvalidStateError",
                    "Attempted to call removeTrack on a closed peerconnection."
                  );
                if (!(B instanceof g.RTCRtpSender))
                  throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");
                var Q = this.transceivers.find(function(w) {
                  return w.rtpSender === B;
                });
                if (!Q)
                  throw A(
                    "InvalidAccessError",
                    "Sender was not created by this connection."
                  );
                var N = Q.stream;
                Q.rtpSender.stop(), Q.rtpSender = null, Q.track = null, Q.stream = null;
                var J = this.transceivers.map(function(w) {
                  return w.stream;
                });
                J.indexOf(N) === -1 && this.localStreams.indexOf(N) > -1 && this.localStreams.splice(this.localStreams.indexOf(N), 1), this._maybeFireNegotiationNeeded();
              }, m.prototype.removeStream = function(B) {
                var Q = this;
                B.getTracks().forEach(function(N) {
                  var J = Q.getSenders().find(function(w) {
                    return w.track === N;
                  });
                  J && Q.removeTrack(J);
                });
              }, m.prototype.getSenders = function() {
                return this.transceivers.filter(function(B) {
                  return !!B.rtpSender;
                }).map(function(B) {
                  return B.rtpSender;
                });
              }, m.prototype.getReceivers = function() {
                return this.transceivers.filter(function(B) {
                  return !!B.rtpReceiver;
                }).map(function(B) {
                  return B.rtpReceiver;
                });
              }, m.prototype._createIceGatherer = function(B, Q) {
                var N = this;
                if (Q && B > 0)
                  return this.transceivers[0].iceGatherer;
                if (this._iceGatherers.length)
                  return this._iceGatherers.shift();
                var J = new g.RTCIceGatherer({
                  iceServers: this._config.iceServers,
                  gatherPolicy: this._config.iceTransportPolicy
                });
                return Object.defineProperty(
                  J,
                  "state",
                  { value: "new", writable: !0 }
                ), this.transceivers[B].bufferedCandidateEvents = [], this.transceivers[B].bufferCandidates = function(w) {
                  var W = !w.candidate || Object.keys(w.candidate).length === 0;
                  J.state = W ? "completed" : "gathering", N.transceivers[B].bufferedCandidateEvents !== null && N.transceivers[B].bufferedCandidateEvents.push(w);
                }, J.addEventListener(
                  "localcandidate",
                  this.transceivers[B].bufferCandidates
                ), J;
              }, m.prototype._gather = function(B, Q) {
                var N = this, J = this.transceivers[Q].iceGatherer;
                if (!J.onlocalcandidate) {
                  var w = this.transceivers[Q].bufferedCandidateEvents;
                  this.transceivers[Q].bufferedCandidateEvents = null, J.removeEventListener(
                    "localcandidate",
                    this.transceivers[Q].bufferCandidates
                  ), J.onlocalcandidate = function(W) {
                    if (!(N.usingBundle && Q > 0)) {
                      var G = new Event("icecandidate");
                      G.candidate = { sdpMid: B, sdpMLineIndex: Q };
                      var Z = W.candidate, K = !Z || Object.keys(Z).length === 0;
                      if (K)
                        (J.state === "new" || J.state === "gathering") && (J.state = "completed");
                      else {
                        J.state === "new" && (J.state = "gathering"), Z.component = 1, Z.ufrag = J.getLocalParameters().usernameFragment;
                        var L = t.writeCandidate(Z);
                        G.candidate = Object.assign(
                          G.candidate,
                          t.parseCandidate(L)
                        ), G.candidate.candidate = L, G.candidate.toJSON = function() {
                          return {
                            candidate: G.candidate.candidate,
                            sdpMid: G.candidate.sdpMid,
                            sdpMLineIndex: G.candidate.sdpMLineIndex,
                            usernameFragment: G.candidate.usernameFragment
                          };
                        };
                      }
                      var O = t.getMediaSections(N._localDescription.sdp);
                      K ? O[G.candidate.sdpMLineIndex] += `a=end-of-candidates\r
` : O[G.candidate.sdpMLineIndex] += "a=" + G.candidate.candidate + `\r
`, N._localDescription.sdp = t.getDescription(N._localDescription.sdp) + O.join("");
                      var de = N.transceivers.every(function(oe) {
                        return oe.iceGatherer && oe.iceGatherer.state === "completed";
                      });
                      N.iceGatheringState !== "gathering" && (N.iceGatheringState = "gathering", N._emitGatheringStateChange()), K || N._dispatchEvent("icecandidate", G), de && (N._dispatchEvent("icecandidate", new Event("icecandidate")), N.iceGatheringState = "complete", N._emitGatheringStateChange());
                    }
                  }, g.setTimeout(function() {
                    w.forEach(function(W) {
                      J.onlocalcandidate(W);
                    });
                  }, 0);
                }
              }, m.prototype._createIceAndDtlsTransports = function() {
                var B = this, Q = new g.RTCIceTransport(null);
                Q.onicestatechange = function() {
                  B._updateIceConnectionState(), B._updateConnectionState();
                };
                var N = new g.RTCDtlsTransport(Q);
                return N.ondtlsstatechange = function() {
                  B._updateConnectionState();
                }, N.onerror = function() {
                  Object.defineProperty(
                    N,
                    "state",
                    { value: "failed", writable: !0 }
                  ), B._updateConnectionState();
                }, {
                  iceTransport: Q,
                  dtlsTransport: N
                };
              }, m.prototype._disposeIceAndDtlsTransports = function(B) {
                var Q = this.transceivers[B].iceGatherer;
                Q && (delete Q.onlocalcandidate, delete this.transceivers[B].iceGatherer);
                var N = this.transceivers[B].iceTransport;
                N && (delete N.onicestatechange, delete this.transceivers[B].iceTransport);
                var J = this.transceivers[B].dtlsTransport;
                J && (delete J.ondtlsstatechange, delete J.onerror, delete this.transceivers[B].dtlsTransport);
              }, m.prototype._transceive = function(B, Q, N) {
                var J = d(
                  B.localCapabilities,
                  B.remoteCapabilities
                );
                Q && B.rtpSender && (J.encodings = B.sendEncodingParameters, J.rtcp = {
                  cname: t.localCName,
                  compound: B.rtcpParameters.compound
                }, B.recvEncodingParameters.length && (J.rtcp.ssrc = B.recvEncodingParameters[0].ssrc), B.rtpSender.send(J)), N && B.rtpReceiver && J.codecs.length > 0 && (B.kind === "video" && B.recvEncodingParameters && f < 15019 && B.recvEncodingParameters.forEach(function(w) {
                  delete w.rtx;
                }), B.recvEncodingParameters.length ? J.encodings = B.recvEncodingParameters : J.encodings = [{}], J.rtcp = {
                  compound: B.rtcpParameters.compound
                }, B.rtcpParameters.cname && (J.rtcp.cname = B.rtcpParameters.cname), B.sendEncodingParameters.length && (J.rtcp.ssrc = B.sendEncodingParameters[0].ssrc), B.rtpReceiver.receive(J));
              }, m.prototype.setLocalDescription = function(B) {
                var Q = this;
                if (["offer", "answer"].indexOf(B.type) === -1)
                  return n.reject(A(
                    "TypeError",
                    'Unsupported type "' + B.type + '"'
                  ));
                if (!u(
                  "setLocalDescription",
                  B.type,
                  Q.signalingState
                ) || Q._isClosed)
                  return n.reject(A(
                    "InvalidStateError",
                    "Can not set local " + B.type + " in state " + Q.signalingState
                  ));
                var N, J;
                if (B.type === "offer")
                  N = t.splitSections(B.sdp), J = N.shift(), N.forEach(function(W, G) {
                    var Z = t.parseRtpParameters(W);
                    Q.transceivers[G].localCapabilities = Z;
                  }), Q.transceivers.forEach(function(W, G) {
                    Q._gather(W.mid, G);
                  });
                else if (B.type === "answer") {
                  N = t.splitSections(Q._remoteDescription.sdp), J = N.shift();
                  var w = t.matchPrefix(
                    J,
                    "a=ice-lite"
                  ).length > 0;
                  N.forEach(function(W, G) {
                    var Z = Q.transceivers[G], K = Z.iceGatherer, L = Z.iceTransport, O = Z.dtlsTransport, de = Z.localCapabilities, oe = Z.remoteCapabilities, fe = t.isRejected(W) && t.matchPrefix(W, "a=bundle-only").length === 0;
                    if (!fe && !Z.rejected) {
                      var ge = t.getIceParameters(
                        W,
                        J
                      ), we = t.getDtlsParameters(
                        W,
                        J
                      );
                      w && (we.role = "server"), (!Q.usingBundle || G === 0) && (Q._gather(Z.mid, G), L.state === "new" && L.start(
                        K,
                        ge,
                        w ? "controlling" : "controlled"
                      ), O.state === "new" && O.start(we));
                      var _e = d(
                        de,
                        oe
                      );
                      Q._transceive(
                        Z,
                        _e.codecs.length > 0,
                        !1
                      );
                    }
                  });
                }
                return Q._localDescription = {
                  type: B.type,
                  sdp: B.sdp
                }, B.type === "offer" ? Q._updateSignalingState("have-local-offer") : Q._updateSignalingState("stable"), n.resolve();
              }, m.prototype.setRemoteDescription = function(B) {
                var Q = this;
                if (["offer", "answer"].indexOf(B.type) === -1)
                  return n.reject(A(
                    "TypeError",
                    'Unsupported type "' + B.type + '"'
                  ));
                if (!u(
                  "setRemoteDescription",
                  B.type,
                  Q.signalingState
                ) || Q._isClosed)
                  return n.reject(A(
                    "InvalidStateError",
                    "Can not set remote " + B.type + " in state " + Q.signalingState
                  ));
                var N = {};
                Q.remoteStreams.forEach(function(L) {
                  N[L.id] = L;
                });
                var J = [], w = t.splitSections(B.sdp), W = w.shift(), G = t.matchPrefix(
                  W,
                  "a=ice-lite"
                ).length > 0, Z = t.matchPrefix(
                  W,
                  "a=group:BUNDLE "
                ).length > 0;
                Q.usingBundle = Z;
                var K = t.matchPrefix(
                  W,
                  "a=ice-options:"
                )[0];
                return K ? Q.canTrickleIceCandidates = K.substr(14).split(" ").indexOf("trickle") >= 0 : Q.canTrickleIceCandidates = !1, w.forEach(function(L, O) {
                  var de = t.splitLines(L), oe = t.getKind(L), fe = t.isRejected(L) && t.matchPrefix(L, "a=bundle-only").length === 0, ge = de[0].substr(2).split(" ")[2], we = t.getDirection(L, W), _e = t.parseMsid(L), Te = t.getMid(L) || t.generateIdentifier();
                  if (fe || oe === "application" && (ge === "DTLS/SCTP" || ge === "UDP/DTLS/SCTP")) {
                    Q.transceivers[O] = {
                      mid: Te,
                      kind: oe,
                      protocol: ge,
                      rejected: !0
                    };
                    return;
                  }
                  !fe && Q.transceivers[O] && Q.transceivers[O].rejected && (Q.transceivers[O] = Q._createTransceiver(oe, !0));
                  var Pe, $e, Bt, Le, at, pt, kt, _t, Lt, Ft = t.parseRtpParameters(L), Zt, ft;
                  fe || (Zt = t.getIceParameters(
                    L,
                    W
                  ), ft = t.getDtlsParameters(
                    L,
                    W
                  ), ft.role = "client"), kt = t.parseRtpEncodingParameters(L);
                  var It = t.parseRtcpParameters(L), Kt = t.matchPrefix(
                    L,
                    "a=end-of-candidates",
                    W
                  ).length > 0, Sn = t.matchPrefix(L, "a=candidate:").map(function(ne) {
                    return t.parseCandidate(ne);
                  }).filter(function(ne) {
                    return ne.component === 1;
                  });
                  if ((B.type === "offer" || B.type === "answer") && !fe && Z && O > 0 && Q.transceivers[O] && (Q._disposeIceAndDtlsTransports(O), Q.transceivers[O].iceGatherer = Q.transceivers[0].iceGatherer, Q.transceivers[O].iceTransport = Q.transceivers[0].iceTransport, Q.transceivers[O].dtlsTransport = Q.transceivers[0].dtlsTransport, Q.transceivers[O].rtpSender && Q.transceivers[O].rtpSender.setTransport(
                    Q.transceivers[0].dtlsTransport
                  ), Q.transceivers[O].rtpReceiver && Q.transceivers[O].rtpReceiver.setTransport(
                    Q.transceivers[0].dtlsTransport
                  )), B.type === "offer" && !fe) {
                    Pe = Q.transceivers[O] || Q._createTransceiver(oe), Pe.mid = Te, Pe.iceGatherer || (Pe.iceGatherer = Q._createIceGatherer(
                      O,
                      Z
                    )), Sn.length && Pe.iceTransport.state === "new" && (Kt && (!Z || O === 0) ? Pe.iceTransport.setRemoteCandidates(Sn) : Sn.forEach(function(ne) {
                      h(Pe.iceTransport, ne);
                    })), _t = g.RTCRtpReceiver.getCapabilities(oe), f < 15019 && (_t.codecs = _t.codecs.filter(
                      function(ne) {
                        return ne.name !== "rtx";
                      }
                    )), pt = Pe.sendEncodingParameters || [{
                      ssrc: (2 * O + 2) * 1001
                    }];
                    var Cn = !1;
                    if (we === "sendrecv" || we === "sendonly") {
                      if (Cn = !Pe.rtpReceiver, at = Pe.rtpReceiver || new g.RTCRtpReceiver(Pe.dtlsTransport, oe), Cn) {
                        var on;
                        Lt = at.track, _e && _e.stream === "-" || (_e ? (N[_e.stream] || (N[_e.stream] = new g.MediaStream(), Object.defineProperty(N[_e.stream], "id", {
                          get: function() {
                            return _e.stream;
                          }
                        })), Object.defineProperty(Lt, "id", {
                          get: function() {
                            return _e.track;
                          }
                        }), on = N[_e.stream]) : (N.default || (N.default = new g.MediaStream()), on = N.default)), on && (p(Lt, on), Pe.associatedRemoteMediaStreams.push(on)), J.push([Lt, at, on]);
                      }
                    } else Pe.rtpReceiver && Pe.rtpReceiver.track && (Pe.associatedRemoteMediaStreams.forEach(function(ne) {
                      var se = ne.getTracks().find(function(Ce) {
                        return Ce.id === Pe.rtpReceiver.track.id;
                      });
                      se && v(se, ne);
                    }), Pe.associatedRemoteMediaStreams = []);
                    Pe.localCapabilities = _t, Pe.remoteCapabilities = Ft, Pe.rtpReceiver = at, Pe.rtcpParameters = It, Pe.sendEncodingParameters = pt, Pe.recvEncodingParameters = kt, Q._transceive(
                      Q.transceivers[O],
                      !1,
                      Cn
                    );
                  } else if (B.type === "answer" && !fe) {
                    Pe = Q.transceivers[O], $e = Pe.iceGatherer, Bt = Pe.iceTransport, Le = Pe.dtlsTransport, at = Pe.rtpReceiver, pt = Pe.sendEncodingParameters, _t = Pe.localCapabilities, Q.transceivers[O].recvEncodingParameters = kt, Q.transceivers[O].remoteCapabilities = Ft, Q.transceivers[O].rtcpParameters = It, Sn.length && Bt.state === "new" && ((G || Kt) && (!Z || O === 0) ? Bt.setRemoteCandidates(Sn) : Sn.forEach(function(ne) {
                      h(Pe.iceTransport, ne);
                    })), (!Z || O === 0) && (Bt.state === "new" && Bt.start(
                      $e,
                      Zt,
                      "controlling"
                    ), Le.state === "new" && Le.start(ft));
                    var An = d(
                      Pe.localCapabilities,
                      Pe.remoteCapabilities
                    ), Ue = An.codecs.filter(function(ne) {
                      return ne.name.toLowerCase() === "rtx";
                    }).length;
                    !Ue && Pe.sendEncodingParameters[0].rtx && delete Pe.sendEncodingParameters[0].rtx, Q._transceive(
                      Pe,
                      we === "sendrecv" || we === "recvonly",
                      we === "sendrecv" || we === "sendonly"
                    ), at && (we === "sendrecv" || we === "sendonly") ? (Lt = at.track, _e ? (N[_e.stream] || (N[_e.stream] = new g.MediaStream()), p(Lt, N[_e.stream]), J.push([Lt, at, N[_e.stream]])) : (N.default || (N.default = new g.MediaStream()), p(Lt, N.default), J.push([Lt, at, N.default]))) : delete Pe.rtpReceiver;
                  }
                }), Q._dtlsRole === void 0 && (Q._dtlsRole = B.type === "offer" ? "active" : "passive"), Q._remoteDescription = {
                  type: B.type,
                  sdp: B.sdp
                }, B.type === "offer" ? Q._updateSignalingState("have-remote-offer") : Q._updateSignalingState("stable"), Object.keys(N).forEach(function(L) {
                  var O = N[L];
                  if (O.getTracks().length) {
                    if (Q.remoteStreams.indexOf(O) === -1) {
                      Q.remoteStreams.push(O);
                      var de = new Event("addstream");
                      de.stream = O, g.setTimeout(function() {
                        Q._dispatchEvent("addstream", de);
                      });
                    }
                    J.forEach(function(oe) {
                      var fe = oe[0], ge = oe[1];
                      O.id === oe[2].id && b(Q, fe, ge, [O]);
                    });
                  }
                }), J.forEach(function(L) {
                  L[2] || b(Q, L[0], L[1], []);
                }), g.setTimeout(function() {
                  Q && Q.transceivers && Q.transceivers.forEach(function(L) {
                    L.iceTransport && L.iceTransport.state === "new" && L.iceTransport.getRemoteCandidates().length > 0 && (console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification"), L.iceTransport.addRemoteCandidate({}));
                  });
                }, 4e3), n.resolve();
              }, m.prototype.close = function() {
                this.transceivers.forEach(function(B) {
                  B.iceTransport && B.iceTransport.stop(), B.dtlsTransport && B.dtlsTransport.stop(), B.rtpSender && B.rtpSender.stop(), B.rtpReceiver && B.rtpReceiver.stop();
                }), this._isClosed = !0, this._updateSignalingState("closed");
              }, m.prototype._updateSignalingState = function(B) {
                this.signalingState = B;
                var Q = new Event("signalingstatechange");
                this._dispatchEvent("signalingstatechange", Q);
              }, m.prototype._maybeFireNegotiationNeeded = function() {
                var B = this;
                this.signalingState !== "stable" || this.needNegotiation === !0 || (this.needNegotiation = !0, g.setTimeout(function() {
                  if (B.needNegotiation) {
                    B.needNegotiation = !1;
                    var Q = new Event("negotiationneeded");
                    B._dispatchEvent("negotiationneeded", Q);
                  }
                }, 0));
              }, m.prototype._updateIceConnectionState = function() {
                var B, Q = {
                  new: 0,
                  closed: 0,
                  checking: 0,
                  connected: 0,
                  completed: 0,
                  disconnected: 0,
                  failed: 0
                };
                if (this.transceivers.forEach(function(J) {
                  J.iceTransport && !J.rejected && Q[J.iceTransport.state]++;
                }), B = "new", Q.failed > 0 ? B = "failed" : Q.checking > 0 ? B = "checking" : Q.disconnected > 0 ? B = "disconnected" : Q.new > 0 ? B = "new" : Q.connected > 0 ? B = "connected" : Q.completed > 0 && (B = "completed"), B !== this.iceConnectionState) {
                  this.iceConnectionState = B;
                  var N = new Event("iceconnectionstatechange");
                  this._dispatchEvent("iceconnectionstatechange", N);
                }
              }, m.prototype._updateConnectionState = function() {
                var B, Q = {
                  new: 0,
                  closed: 0,
                  connecting: 0,
                  connected: 0,
                  completed: 0,
                  disconnected: 0,
                  failed: 0
                };
                if (this.transceivers.forEach(function(J) {
                  J.iceTransport && J.dtlsTransport && !J.rejected && (Q[J.iceTransport.state]++, Q[J.dtlsTransport.state]++);
                }), Q.connected += Q.completed, B = "new", Q.failed > 0 ? B = "failed" : Q.connecting > 0 ? B = "connecting" : Q.disconnected > 0 ? B = "disconnected" : Q.new > 0 ? B = "new" : Q.connected > 0 && (B = "connected"), B !== this.connectionState) {
                  this.connectionState = B;
                  var N = new Event("connectionstatechange");
                  this._dispatchEvent("connectionstatechange", N);
                }
              }, m.prototype.createOffer = function() {
                var B = this;
                if (B._isClosed)
                  return n.reject(A(
                    "InvalidStateError",
                    "Can not call createOffer after close"
                  ));
                var Q = B.transceivers.filter(function(G) {
                  return G.kind === "audio";
                }).length, N = B.transceivers.filter(function(G) {
                  return G.kind === "video";
                }).length, J = arguments[0];
                if (J) {
                  if (J.mandatory || J.optional)
                    throw new TypeError(
                      "Legacy mandatory/optional constraints not supported."
                    );
                  J.offerToReceiveAudio !== void 0 && (J.offerToReceiveAudio === !0 ? Q = 1 : J.offerToReceiveAudio === !1 ? Q = 0 : Q = J.offerToReceiveAudio), J.offerToReceiveVideo !== void 0 && (J.offerToReceiveVideo === !0 ? N = 1 : J.offerToReceiveVideo === !1 ? N = 0 : N = J.offerToReceiveVideo);
                }
                for (B.transceivers.forEach(function(G) {
                  G.kind === "audio" ? (Q--, Q < 0 && (G.wantReceive = !1)) : G.kind === "video" && (N--, N < 0 && (G.wantReceive = !1));
                }); Q > 0 || N > 0; )
                  Q > 0 && (B._createTransceiver("audio"), Q--), N > 0 && (B._createTransceiver("video"), N--);
                var w = t.writeSessionBoilerplate(
                  B._sdpSessionId,
                  B._sdpSessionVersion++
                );
                B.transceivers.forEach(function(G, Z) {
                  var K = G.track, L = G.kind, O = G.mid || t.generateIdentifier();
                  G.mid = O, G.iceGatherer || (G.iceGatherer = B._createIceGatherer(
                    Z,
                    B.usingBundle
                  ));
                  var de = g.RTCRtpSender.getCapabilities(L);
                  f < 15019 && (de.codecs = de.codecs.filter(
                    function(fe) {
                      return fe.name !== "rtx";
                    }
                  )), de.codecs.forEach(function(fe) {
                    fe.name === "H264" && fe.parameters["level-asymmetry-allowed"] === void 0 && (fe.parameters["level-asymmetry-allowed"] = "1"), G.remoteCapabilities && G.remoteCapabilities.codecs && G.remoteCapabilities.codecs.forEach(function(ge) {
                      fe.name.toLowerCase() === ge.name.toLowerCase() && fe.clockRate === ge.clockRate && (fe.preferredPayloadType = ge.payloadType);
                    });
                  }), de.headerExtensions.forEach(function(fe) {
                    var ge = G.remoteCapabilities && G.remoteCapabilities.headerExtensions || [];
                    ge.forEach(function(we) {
                      fe.uri === we.uri && (fe.id = we.id);
                    });
                  });
                  var oe = G.sendEncodingParameters || [{
                    ssrc: (2 * Z + 1) * 1001
                  }];
                  K && f >= 15019 && L === "video" && !oe[0].rtx && (oe[0].rtx = {
                    ssrc: oe[0].ssrc + 1
                  }), G.wantReceive && (G.rtpReceiver = new g.RTCRtpReceiver(
                    G.dtlsTransport,
                    L
                  )), G.localCapabilities = de, G.sendEncodingParameters = oe;
                }), B._config.bundlePolicy !== "max-compat" && (w += "a=group:BUNDLE " + B.transceivers.map(function(G) {
                  return G.mid;
                }).join(" ") + `\r
`), w += `a=ice-options:trickle\r
`, B.transceivers.forEach(function(G, Z) {
                  w += l(
                    G,
                    G.localCapabilities,
                    "offer",
                    G.stream,
                    B._dtlsRole
                  ), w += `a=rtcp-rsize\r
`, G.iceGatherer && B.iceGatheringState !== "new" && (Z === 0 || !B.usingBundle) && (G.iceGatherer.getLocalCandidates().forEach(function(K) {
                    K.component = 1, w += "a=" + t.writeCandidate(K) + `\r
`;
                  }), G.iceGatherer.state === "completed" && (w += `a=end-of-candidates\r
`));
                });
                var W = new g.RTCSessionDescription({
                  type: "offer",
                  sdp: w
                });
                return n.resolve(W);
              }, m.prototype.createAnswer = function() {
                var B = this;
                if (B._isClosed)
                  return n.reject(A(
                    "InvalidStateError",
                    "Can not call createAnswer after close"
                  ));
                if (!(B.signalingState === "have-remote-offer" || B.signalingState === "have-local-pranswer"))
                  return n.reject(A(
                    "InvalidStateError",
                    "Can not call createAnswer in signalingState " + B.signalingState
                  ));
                var Q = t.writeSessionBoilerplate(
                  B._sdpSessionId,
                  B._sdpSessionVersion++
                );
                B.usingBundle && (Q += "a=group:BUNDLE " + B.transceivers.map(function(w) {
                  return w.mid;
                }).join(" ") + `\r
`), Q += `a=ice-options:trickle\r
`;
                var N = t.getMediaSections(
                  B._remoteDescription.sdp
                ).length;
                B.transceivers.forEach(function(w, W) {
                  if (!(W + 1 > N)) {
                    if (w.rejected) {
                      w.kind === "application" ? w.protocol === "DTLS/SCTP" ? Q += `m=application 0 DTLS/SCTP 5000\r
` : Q += "m=application 0 " + w.protocol + ` webrtc-datachannel\r
` : w.kind === "audio" ? Q += `m=audio 0 UDP/TLS/RTP/SAVPF 0\r
a=rtpmap:0 PCMU/8000\r
` : w.kind === "video" && (Q += `m=video 0 UDP/TLS/RTP/SAVPF 120\r
a=rtpmap:120 VP8/90000\r
`), Q += `c=IN IP4 0.0.0.0\r
a=inactive\r
a=mid:` + w.mid + `\r
`;
                      return;
                    }
                    if (w.stream) {
                      var G;
                      w.kind === "audio" ? G = w.stream.getAudioTracks()[0] : w.kind === "video" && (G = w.stream.getVideoTracks()[0]), G && f >= 15019 && w.kind === "video" && !w.sendEncodingParameters[0].rtx && (w.sendEncodingParameters[0].rtx = {
                        ssrc: w.sendEncodingParameters[0].ssrc + 1
                      });
                    }
                    var Z = d(
                      w.localCapabilities,
                      w.remoteCapabilities
                    ), K = Z.codecs.filter(function(L) {
                      return L.name.toLowerCase() === "rtx";
                    }).length;
                    !K && w.sendEncodingParameters[0].rtx && delete w.sendEncodingParameters[0].rtx, Q += l(
                      w,
                      Z,
                      "answer",
                      w.stream,
                      B._dtlsRole
                    ), w.rtcpParameters && w.rtcpParameters.reducedSize && (Q += `a=rtcp-rsize\r
`);
                  }
                });
                var J = new g.RTCSessionDescription({
                  type: "answer",
                  sdp: Q
                });
                return n.resolve(J);
              }, m.prototype.addIceCandidate = function(B) {
                var Q = this, N;
                return B && !(B.sdpMLineIndex !== void 0 || B.sdpMid) ? n.reject(new TypeError("sdpMLineIndex or sdpMid required")) : new n(function(J, w) {
                  if (Q._remoteDescription)
                    if (!B || B.candidate === "")
                      for (var W = 0; W < Q.transceivers.length && !(!Q.transceivers[W].rejected && (Q.transceivers[W].iceTransport.addRemoteCandidate({}), N = t.getMediaSections(Q._remoteDescription.sdp), N[W] += `a=end-of-candidates\r
`, Q._remoteDescription.sdp = t.getDescription(Q._remoteDescription.sdp) + N.join(""), Q.usingBundle)); W++)
                        ;
                    else {
                      var G = B.sdpMLineIndex;
                      if (B.sdpMid) {
                        for (var Z = 0; Z < Q.transceivers.length; Z++)
                          if (Q.transceivers[Z].mid === B.sdpMid) {
                            G = Z;
                            break;
                          }
                      }
                      var K = Q.transceivers[G];
                      if (K) {
                        if (K.rejected)
                          return J();
                        var L = Object.keys(B.candidate).length > 0 ? t.parseCandidate(B.candidate) : {};
                        if (L.protocol === "tcp" && (L.port === 0 || L.port === 9) || L.component && L.component !== 1)
                          return J();
                        if ((G === 0 || G > 0 && K.iceTransport !== Q.transceivers[0].iceTransport) && !h(K.iceTransport, L))
                          return w(A(
                            "OperationError",
                            "Can not add ICE candidate"
                          ));
                        var O = B.candidate.trim();
                        O.indexOf("a=") === 0 && (O = O.substr(2)), N = t.getMediaSections(Q._remoteDescription.sdp), N[G] += "a=" + (L.type ? O : "end-of-candidates") + `\r
`, Q._remoteDescription.sdp = t.getDescription(Q._remoteDescription.sdp) + N.join("");
                      } else
                        return w(A(
                          "OperationError",
                          "Can not add ICE candidate"
                        ));
                    }
                  else return w(A(
                    "InvalidStateError",
                    "Can not add ICE candidate without a remote description"
                  ));
                  J();
                });
              }, m.prototype.getStats = function(B) {
                if (B && B instanceof g.MediaStreamTrack) {
                  var Q = null;
                  if (this.transceivers.forEach(function(J) {
                    J.rtpSender && J.rtpSender.track === B ? Q = J.rtpSender : J.rtpReceiver && J.rtpReceiver.track === B && (Q = J.rtpReceiver);
                  }), !Q)
                    throw A("InvalidAccessError", "Invalid selector.");
                  return Q.getStats();
                }
                var N = [];
                return this.transceivers.forEach(function(J) {
                  [
                    "rtpSender",
                    "rtpReceiver",
                    "iceGatherer",
                    "iceTransport",
                    "dtlsTransport"
                  ].forEach(function(w) {
                    J[w] && N.push(J[w].getStats());
                  });
                }), n.all(N).then(function(J) {
                  var w = /* @__PURE__ */ new Map();
                  return J.forEach(function(W) {
                    W.forEach(function(G) {
                      w.set(G.id, G);
                    });
                  }), w;
                });
              };
              var y = [
                "RTCRtpSender",
                "RTCRtpReceiver",
                "RTCIceGatherer",
                "RTCIceTransport",
                "RTCDtlsTransport"
              ];
              y.forEach(function(B) {
                var Q = g[B];
                if (Q && Q.prototype && Q.prototype.getStats) {
                  var N = Q.prototype.getStats;
                  Q.prototype.getStats = function() {
                    return N.apply(this).then(function(J) {
                      var w = /* @__PURE__ */ new Map();
                      return Object.keys(J).forEach(function(W) {
                        J[W].type = o(J[W]), w.set(W, J[W]);
                      }), w;
                    });
                  };
                }
              });
              var U = ["createOffer", "createAnswer"];
              return U.forEach(function(B) {
                var Q = m.prototype[B];
                m.prototype[B] = function() {
                  var N = arguments;
                  return typeof N[0] == "function" || typeof N[1] == "function" ? Q.apply(this, [arguments[2]]).then(function(J) {
                    typeof N[0] == "function" && N[0].apply(null, [J]);
                  }, function(J) {
                    typeof N[1] == "function" && N[1].apply(null, [J]);
                  }) : Q.apply(this, arguments);
                };
              }), U = ["setLocalDescription", "setRemoteDescription", "addIceCandidate"], U.forEach(function(B) {
                var Q = m.prototype[B];
                m.prototype[B] = function() {
                  var N = arguments;
                  return typeof N[1] == "function" || typeof N[2] == "function" ? Q.apply(this, arguments).then(function() {
                    typeof N[1] == "function" && N[1].apply(null);
                  }, function(J) {
                    typeof N[2] == "function" && N[2].apply(null, [J]);
                  }) : Q.apply(this, arguments);
                };
              }), ["getStats"].forEach(function(B) {
                var Q = m.prototype[B];
                m.prototype[B] = function() {
                  var N = arguments;
                  return typeof N[1] == "function" ? Q.apply(this, arguments).then(function() {
                    typeof N[1] == "function" && N[1].apply(null);
                  }) : Q.apply(this, arguments);
                };
              }), m;
            };
          }).call(this, e(2));
        },
        /* 581 */
        /***/
        function(i, r, e) {
          (function(n) {
            i.exports = function(t) {
              var o = t && t.navigator, l = function(d) {
                return {
                  name: { PermissionDeniedError: "NotAllowedError" }[d.name] || d.name,
                  message: d.message,
                  constraint: d.constraint,
                  toString: function() {
                    return this.name;
                  }
                };
              }, c = o.mediaDevices.getUserMedia.bind(o.mediaDevices);
              o.mediaDevices.getUserMedia = function(d) {
                return c(d).catch(function(u) {
                  return n.reject(l(u));
                });
              };
            };
          }).call(this, e(2));
        },
        /* 582 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(32);
            i.exports = {
              shimGetUserMedia: e(583),
              shimOnTrack: function(o) {
                typeof o == "object" && o.RTCPeerConnection && !("ontrack" in o.RTCPeerConnection.prototype) && Object.defineProperty(o.RTCPeerConnection.prototype, "ontrack", {
                  get: function() {
                    return this._ontrack;
                  },
                  set: function(l) {
                    this._ontrack && (this.removeEventListener("track", this._ontrack), this.removeEventListener("addstream", this._ontrackpoly)), this.addEventListener("track", this._ontrack = l), this.addEventListener("addstream", this._ontrackpoly = function(c) {
                      c.stream.getTracks().forEach(function(d) {
                        var u = new Event("track");
                        u.track = d, u.receiver = { track: d }, u.transceiver = { receiver: u.receiver }, u.streams = [c.stream], this.dispatchEvent(u);
                      }.bind(this));
                    }.bind(this));
                  },
                  enumerable: !0,
                  configurable: !0
                }), typeof o == "object" && o.RTCTrackEvent && "receiver" in o.RTCTrackEvent.prototype && !("transceiver" in o.RTCTrackEvent.prototype) && Object.defineProperty(o.RTCTrackEvent.prototype, "transceiver", {
                  get: function() {
                    return { receiver: this.receiver };
                  }
                });
              },
              shimSourceObject: function(o) {
                typeof o == "object" && o.HTMLMediaElement && !("srcObject" in o.HTMLMediaElement.prototype) && Object.defineProperty(o.HTMLMediaElement.prototype, "srcObject", {
                  get: function() {
                    return this.mozSrcObject;
                  },
                  set: function(l) {
                    this.mozSrcObject = l;
                  }
                });
              },
              shimPeerConnection: function(o) {
                var l = t.detectBrowser(o);
                if (!(typeof o != "object" || !(o.RTCPeerConnection || o.mozRTCPeerConnection))) {
                  o.RTCPeerConnection || (o.RTCPeerConnection = function(A, g) {
                    if (l.version < 38 && A && A.iceServers) {
                      for (var f = [], p = 0; p < A.iceServers.length; p++) {
                        var v = A.iceServers[p];
                        if (v.hasOwnProperty("urls"))
                          for (var b = 0; b < v.urls.length; b++) {
                            var m = {
                              url: v.urls[b]
                            };
                            v.urls[b].indexOf("turn") === 0 && (m.username = v.username, m.credential = v.credential), f.push(m);
                          }
                        else
                          f.push(A.iceServers[p]);
                      }
                      A.iceServers = f;
                    }
                    return new o.mozRTCPeerConnection(A, g);
                  }, o.RTCPeerConnection.prototype = o.mozRTCPeerConnection.prototype, o.mozRTCPeerConnection.generateCertificate && Object.defineProperty(o.RTCPeerConnection, "generateCertificate", {
                    get: function() {
                      return o.mozRTCPeerConnection.generateCertificate;
                    }
                  }), o.RTCSessionDescription = o.mozRTCSessionDescription, o.RTCIceCandidate = o.mozRTCIceCandidate), ["setLocalDescription", "setRemoteDescription", "addIceCandidate"].forEach(function(A) {
                    var g = o.RTCPeerConnection.prototype[A];
                    o.RTCPeerConnection.prototype[A] = function() {
                      return arguments[0] = new (A === "addIceCandidate" ? o.RTCIceCandidate : o.RTCSessionDescription)(arguments[0]), g.apply(this, arguments);
                    };
                  });
                  var c = o.RTCPeerConnection.prototype.addIceCandidate;
                  o.RTCPeerConnection.prototype.addIceCandidate = function() {
                    return arguments[0] ? c.apply(this, arguments) : (arguments[1] && arguments[1].apply(null), n.resolve());
                  };
                  var d = function(A) {
                    var g = /* @__PURE__ */ new Map();
                    return Object.keys(A).forEach(function(f) {
                      g.set(f, A[f]), g[f] = A[f];
                    }), g;
                  }, u = {
                    inboundrtp: "inbound-rtp",
                    outboundrtp: "outbound-rtp",
                    candidatepair: "candidate-pair",
                    localcandidate: "local-candidate",
                    remotecandidate: "remote-candidate"
                  }, h = o.RTCPeerConnection.prototype.getStats;
                  o.RTCPeerConnection.prototype.getStats = function(A, g, f) {
                    return h.apply(this, [A || null]).then(function(p) {
                      if (l.version < 48 && (p = d(p)), l.version < 53 && !g)
                        try {
                          p.forEach(function(v) {
                            v.type = u[v.type] || v.type;
                          });
                        } catch (v) {
                          if (v.name !== "TypeError")
                            throw v;
                          p.forEach(function(b, m) {
                            p.set(m, Object.assign({}, b, {
                              type: u[b.type] || b.type
                            }));
                          });
                        }
                      return p;
                    }).then(g, f);
                  };
                }
              },
              shimSenderGetStats: function(o) {
                if (typeof o == "object" && o.RTCPeerConnection && o.RTCRtpSender && !(o.RTCRtpSender && "getStats" in o.RTCRtpSender.prototype)) {
                  var l = o.RTCPeerConnection.prototype.getSenders;
                  l && (o.RTCPeerConnection.prototype.getSenders = function() {
                    var d = this, u = l.apply(d, []);
                    return u.forEach(function(h) {
                      h._pc = d;
                    }), u;
                  });
                  var c = o.RTCPeerConnection.prototype.addTrack;
                  c && (o.RTCPeerConnection.prototype.addTrack = function() {
                    var d = c.apply(this, arguments);
                    return d._pc = this, d;
                  }), o.RTCRtpSender.prototype.getStats = function() {
                    return this.track ? this._pc.getStats(this.track) : n.resolve(/* @__PURE__ */ new Map());
                  };
                }
              },
              shimReceiverGetStats: function(o) {
                if (typeof o == "object" && o.RTCPeerConnection && o.RTCRtpSender && !(o.RTCRtpSender && "getStats" in o.RTCRtpReceiver.prototype)) {
                  var l = o.RTCPeerConnection.prototype.getReceivers;
                  l && (o.RTCPeerConnection.prototype.getReceivers = function() {
                    var c = this, d = l.apply(c, []);
                    return d.forEach(function(u) {
                      u._pc = c;
                    }), d;
                  }), t.wrapPeerConnectionEvent(o, "track", function(c) {
                    return c.receiver._pc = c.srcElement, c;
                  }), o.RTCRtpReceiver.prototype.getStats = function() {
                    return this._pc.getStats(this.track);
                  };
                }
              },
              shimRemoveStream: function(o) {
                !o.RTCPeerConnection || "removeStream" in o.RTCPeerConnection.prototype || (o.RTCPeerConnection.prototype.removeStream = function(l) {
                  var c = this;
                  t.deprecated("removeStream", "removeTrack"), this.getSenders().forEach(function(d) {
                    d.track && l.getTracks().indexOf(d.track) !== -1 && c.removeTrack(d);
                  });
                });
              },
              shimRTCDataChannel: function(o) {
                o.DataChannel && !o.RTCDataChannel && (o.RTCDataChannel = o.DataChannel);
              },
              shimGetDisplayMedia: function(o, l) {
                !o.navigator || !o.navigator.mediaDevices || "getDisplayMedia" in o.navigator.mediaDevices || (o.navigator.mediaDevices.getDisplayMedia = function(c) {
                  if (!(c && c.video)) {
                    var d = new DOMException("getDisplayMedia without video constraints is undefined");
                    return d.name = "NotFoundError", d.code = 8, n.reject(d);
                  }
                  return c.video === !0 ? c.video = { mediaSource: l } : c.video.mediaSource = l, o.navigator.mediaDevices.getUserMedia(c);
                }, o.navigator.getDisplayMedia = function(c) {
                  return t.deprecated(
                    "navigator.getDisplayMedia",
                    "navigator.mediaDevices.getDisplayMedia"
                  ), o.navigator.mediaDevices.getDisplayMedia(c);
                });
              }
            };
          }).call(this, e(2));
        },
        /* 583 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(32), o = t.log;
            i.exports = function(l) {
              var c = t.detectBrowser(l), d = l && l.navigator, u = l && l.MediaStreamTrack, h = function(U) {
                return {
                  name: {
                    InternalError: "NotReadableError",
                    NotSupportedError: "TypeError",
                    PermissionDeniedError: "NotAllowedError",
                    SecurityError: "NotAllowedError"
                  }[U.name] || U.name,
                  message: {
                    "The operation is insecure.": "The request is not allowed by the user agent or the platform in the current context."
                  }[U.message] || U.message,
                  constraint: U.constraint,
                  toString: function() {
                    return this.name + (this.message && ": ") + this.message;
                  }
                };
              }, A = function(U, B, Q) {
                var N = function(J) {
                  if (typeof J != "object" || J.require)
                    return J;
                  var w = [];
                  return Object.keys(J).forEach(function(W) {
                    if (!(W === "require" || W === "advanced" || W === "mediaSource")) {
                      var G = J[W] = typeof J[W] == "object" ? J[W] : { ideal: J[W] };
                      if ((G.min !== void 0 || G.max !== void 0 || G.exact !== void 0) && w.push(W), G.exact !== void 0 && (typeof G.exact == "number" ? G.min = G.max = G.exact : J[W] = G.exact, delete G.exact), G.ideal !== void 0) {
                        J.advanced = J.advanced || [];
                        var Z = {};
                        typeof G.ideal == "number" ? Z[W] = { min: G.ideal, max: G.ideal } : Z[W] = G.ideal, J.advanced.push(Z), delete G.ideal, Object.keys(G).length || delete J[W];
                      }
                    }
                  }), w.length && (J.require = w), J;
                };
                return U = JSON.parse(JSON.stringify(U)), c.version < 38 && (o("spec: " + JSON.stringify(U)), U.audio && (U.audio = N(U.audio)), U.video && (U.video = N(U.video)), o("ff37: " + JSON.stringify(U))), d.mozGetUserMedia(U, B, function(J) {
                  Q(h(J));
                });
              }, g = function(U) {
                return new n(function(B, Q) {
                  A(U, B, Q);
                });
              };
              if (d.mediaDevices || (d.mediaDevices = {
                getUserMedia: g,
                addEventListener: function() {
                },
                removeEventListener: function() {
                }
              }), d.mediaDevices.enumerateDevices = d.mediaDevices.enumerateDevices || function() {
                return new n(function(U) {
                  var B = [
                    { kind: "audioinput", deviceId: "default", label: "", groupId: "" },
                    { kind: "videoinput", deviceId: "default", label: "", groupId: "" }
                  ];
                  U(B);
                });
              }, c.version < 41) {
                var f = d.mediaDevices.enumerateDevices.bind(d.mediaDevices);
                d.mediaDevices.enumerateDevices = function() {
                  return f().then(void 0, function(U) {
                    if (U.name === "NotFoundError")
                      return [];
                    throw U;
                  });
                };
              }
              if (c.version < 49) {
                var p = d.mediaDevices.getUserMedia.bind(d.mediaDevices);
                d.mediaDevices.getUserMedia = function(U) {
                  return p(U).then(function(B) {
                    if (U.audio && !B.getAudioTracks().length || U.video && !B.getVideoTracks().length)
                      throw B.getTracks().forEach(function(Q) {
                        Q.stop();
                      }), new DOMException(
                        "The object can not be found here.",
                        "NotFoundError"
                      );
                    return B;
                  }, function(B) {
                    return n.reject(h(B));
                  });
                };
              }
              if (!(c.version > 55 && "autoGainControl" in d.mediaDevices.getSupportedConstraints())) {
                var v = function(U, B, Q) {
                  B in U && !(Q in U) && (U[Q] = U[B], delete U[B]);
                }, b = d.mediaDevices.getUserMedia.bind(d.mediaDevices);
                if (d.mediaDevices.getUserMedia = function(U) {
                  return typeof U == "object" && typeof U.audio == "object" && (U = JSON.parse(JSON.stringify(U)), v(U.audio, "autoGainControl", "mozAutoGainControl"), v(U.audio, "noiseSuppression", "mozNoiseSuppression")), b(U);
                }, u && u.prototype.getSettings) {
                  var m = u.prototype.getSettings;
                  u.prototype.getSettings = function() {
                    var U = m.apply(this, arguments);
                    return v(U, "mozAutoGainControl", "autoGainControl"), v(U, "mozNoiseSuppression", "noiseSuppression"), U;
                  };
                }
                if (u && u.prototype.applyConstraints) {
                  var y = u.prototype.applyConstraints;
                  u.prototype.applyConstraints = function(U) {
                    return this.kind === "audio" && typeof U == "object" && (U = JSON.parse(JSON.stringify(U)), v(U, "autoGainControl", "mozAutoGainControl"), v(U, "noiseSuppression", "mozNoiseSuppression")), y.apply(this, [U]);
                  };
                }
              }
              d.getUserMedia = function(U, B, Q) {
                if (c.version < 44)
                  return A(U, B, Q);
                t.deprecated(
                  "navigator.getUserMedia",
                  "navigator.mediaDevices.getUserMedia"
                ), d.mediaDevices.getUserMedia(U).then(B, Q);
              };
            };
          }).call(this, e(2));
        },
        /* 584 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(32);
            i.exports = {
              shimLocalStreamsAPI: function(o) {
                if (!(typeof o != "object" || !o.RTCPeerConnection)) {
                  if ("getLocalStreams" in o.RTCPeerConnection.prototype || (o.RTCPeerConnection.prototype.getLocalStreams = function() {
                    return this._localStreams || (this._localStreams = []), this._localStreams;
                  }), "getStreamById" in o.RTCPeerConnection.prototype || (o.RTCPeerConnection.prototype.getStreamById = function(c) {
                    var d = null;
                    return this._localStreams && this._localStreams.forEach(function(u) {
                      u.id === c && (d = u);
                    }), this._remoteStreams && this._remoteStreams.forEach(function(u) {
                      u.id === c && (d = u);
                    }), d;
                  }), !("addStream" in o.RTCPeerConnection.prototype)) {
                    var l = o.RTCPeerConnection.prototype.addTrack;
                    o.RTCPeerConnection.prototype.addStream = function(c) {
                      this._localStreams || (this._localStreams = []), this._localStreams.indexOf(c) === -1 && this._localStreams.push(c);
                      var d = this;
                      c.getTracks().forEach(function(u) {
                        l.call(d, u, c);
                      });
                    }, o.RTCPeerConnection.prototype.addTrack = function(c, d) {
                      return d && (this._localStreams ? this._localStreams.indexOf(d) === -1 && this._localStreams.push(d) : this._localStreams = [d]), l.call(this, c, d);
                    };
                  }
                  "removeStream" in o.RTCPeerConnection.prototype || (o.RTCPeerConnection.prototype.removeStream = function(c) {
                    this._localStreams || (this._localStreams = []);
                    var d = this._localStreams.indexOf(c);
                    if (d !== -1) {
                      this._localStreams.splice(d, 1);
                      var u = this, h = c.getTracks();
                      this.getSenders().forEach(function(A) {
                        h.indexOf(A.track) !== -1 && u.removeTrack(A);
                      });
                    }
                  });
                }
              },
              shimRemoteStreamsAPI: function(o) {
                if (!(typeof o != "object" || !o.RTCPeerConnection) && ("getRemoteStreams" in o.RTCPeerConnection.prototype || (o.RTCPeerConnection.prototype.getRemoteStreams = function() {
                  return this._remoteStreams ? this._remoteStreams : [];
                }), !("onaddstream" in o.RTCPeerConnection.prototype))) {
                  Object.defineProperty(o.RTCPeerConnection.prototype, "onaddstream", {
                    get: function() {
                      return this._onaddstream;
                    },
                    set: function(c) {
                      this._onaddstream && this.removeEventListener("addstream", this._onaddstream), this.addEventListener("addstream", this._onaddstream = c);
                    }
                  });
                  var l = o.RTCPeerConnection.prototype.setRemoteDescription;
                  o.RTCPeerConnection.prototype.setRemoteDescription = function() {
                    var c = this;
                    return this._onaddstreampoly || this.addEventListener("track", this._onaddstreampoly = function(d) {
                      d.streams.forEach(function(u) {
                        if (c._remoteStreams || (c._remoteStreams = []), !(c._remoteStreams.indexOf(u) >= 0)) {
                          c._remoteStreams.push(u);
                          var h = new Event("addstream");
                          h.stream = u, c.dispatchEvent(h);
                        }
                      });
                    }), l.apply(c, arguments);
                  };
                }
              },
              shimCallbacksAPI: function(o) {
                if (!(typeof o != "object" || !o.RTCPeerConnection)) {
                  var l = o.RTCPeerConnection.prototype, c = l.createOffer, d = l.createAnswer, u = l.setLocalDescription, h = l.setRemoteDescription, A = l.addIceCandidate;
                  l.createOffer = function(f, p) {
                    var v = arguments.length >= 2 ? arguments[2] : arguments[0], b = c.apply(this, [v]);
                    return p ? (b.then(f, p), n.resolve()) : b;
                  }, l.createAnswer = function(f, p) {
                    var v = arguments.length >= 2 ? arguments[2] : arguments[0], b = d.apply(this, [v]);
                    return p ? (b.then(f, p), n.resolve()) : b;
                  };
                  var g = function(f, p, v) {
                    var b = u.apply(this, [f]);
                    return v ? (b.then(p, v), n.resolve()) : b;
                  };
                  l.setLocalDescription = g, g = function(f, p, v) {
                    var b = h.apply(this, [f]);
                    return v ? (b.then(p, v), n.resolve()) : b;
                  }, l.setRemoteDescription = g, g = function(f, p, v) {
                    var b = A.apply(this, [f]);
                    return v ? (b.then(p, v), n.resolve()) : b;
                  }, l.addIceCandidate = g;
                }
              },
              shimGetUserMedia: function(o) {
                var l = o && o.navigator;
                l.getUserMedia || (l.webkitGetUserMedia ? l.getUserMedia = l.webkitGetUserMedia.bind(l) : l.mediaDevices && l.mediaDevices.getUserMedia && (l.getUserMedia = function(c, d, u) {
                  l.mediaDevices.getUserMedia(c).then(d, u);
                }.bind(l)));
              },
              shimRTCIceServerUrls: function(o) {
                var l = o.RTCPeerConnection;
                o.RTCPeerConnection = function(c, d) {
                  if (c && c.iceServers) {
                    for (var u = [], h = 0; h < c.iceServers.length; h++) {
                      var A = c.iceServers[h];
                      !A.hasOwnProperty("urls") && A.hasOwnProperty("url") ? (t.deprecated("RTCIceServer.url", "RTCIceServer.urls"), A = JSON.parse(JSON.stringify(A)), A.urls = A.url, delete A.url, u.push(A)) : u.push(c.iceServers[h]);
                    }
                    c.iceServers = u;
                  }
                  return new l(c, d);
                }, o.RTCPeerConnection.prototype = l.prototype, "generateCertificate" in o.RTCPeerConnection && Object.defineProperty(o.RTCPeerConnection, "generateCertificate", {
                  get: function() {
                    return l.generateCertificate;
                  }
                });
              },
              shimTrackEventTransceiver: function(o) {
                typeof o == "object" && o.RTCPeerConnection && "receiver" in o.RTCTrackEvent.prototype && // can't check 'transceiver' in window.RTCTrackEvent.prototype, as it is
                // defined for some reason even when window.RTCTransceiver is not.
                !o.RTCTransceiver && Object.defineProperty(o.RTCTrackEvent.prototype, "transceiver", {
                  get: function() {
                    return { receiver: this.receiver };
                  }
                });
              },
              shimCreateOfferLegacy: function(o) {
                var l = o.RTCPeerConnection.prototype.createOffer;
                o.RTCPeerConnection.prototype.createOffer = function(c) {
                  var d = this;
                  if (c) {
                    typeof c.offerToReceiveAudio != "undefined" && (c.offerToReceiveAudio = !!c.offerToReceiveAudio);
                    var u = d.getTransceivers().find(function(A) {
                      return A.sender.track && A.sender.track.kind === "audio";
                    });
                    c.offerToReceiveAudio === !1 && u ? u.direction === "sendrecv" ? u.setDirection ? u.setDirection("sendonly") : u.direction = "sendonly" : u.direction === "recvonly" && (u.setDirection ? u.setDirection("inactive") : u.direction = "inactive") : c.offerToReceiveAudio === !0 && !u && d.addTransceiver("audio"), typeof c.offerToReceiveVideo != "undefined" && (c.offerToReceiveVideo = !!c.offerToReceiveVideo);
                    var h = d.getTransceivers().find(function(A) {
                      return A.sender.track && A.sender.track.kind === "video";
                    });
                    c.offerToReceiveVideo === !1 && h ? h.direction === "sendrecv" ? h.setDirection("sendonly") : h.direction === "recvonly" && h.setDirection("inactive") : c.offerToReceiveVideo === !0 && !h && d.addTransceiver("video");
                  }
                  return l.apply(d, arguments);
                };
              }
            };
          }).call(this, e(2));
        },
        /* 585 */
        /***/
        function(i, r, e) {
          var n = e(269), t = e(32);
          i.exports = {
            shimRTCIceCandidate: function(o) {
              if (!(!o.RTCIceCandidate || o.RTCIceCandidate && "foundation" in o.RTCIceCandidate.prototype)) {
                var l = o.RTCIceCandidate;
                o.RTCIceCandidate = function(c) {
                  if (typeof c == "object" && c.candidate && c.candidate.indexOf("a=") === 0 && (c = JSON.parse(JSON.stringify(c)), c.candidate = c.candidate.substr(2)), c.candidate && c.candidate.length) {
                    var d = new l(c), u = n.parseCandidate(c.candidate), h = Object.assign(
                      d,
                      u
                    );
                    return h.toJSON = function() {
                      return {
                        candidate: h.candidate,
                        sdpMid: h.sdpMid,
                        sdpMLineIndex: h.sdpMLineIndex,
                        usernameFragment: h.usernameFragment
                      };
                    }, h;
                  }
                  return new l(c);
                }, o.RTCIceCandidate.prototype = l.prototype, t.wrapPeerConnectionEvent(o, "icecandidate", function(c) {
                  return c.candidate && Object.defineProperty(c, "candidate", {
                    value: new o.RTCIceCandidate(c.candidate),
                    writable: "false"
                  }), c;
                });
              }
            },
            // shimCreateObjectURL must be called before shimSourceObject to avoid loop.
            shimCreateObjectURL: function(o) {
              var l = o && o.URL;
              if (typeof o == "object" && o.HTMLMediaElement && "srcObject" in o.HTMLMediaElement.prototype && l.createObjectURL && l.revokeObjectURL) {
                var c = l.createObjectURL.bind(l), d = l.revokeObjectURL.bind(l), u = /* @__PURE__ */ new Map(), h = 0;
                l.createObjectURL = function(f) {
                  if ("getTracks" in f) {
                    var p = "polyblob:" + ++h;
                    return u.set(p, f), t.deprecated(
                      "URL.createObjectURL(stream)",
                      "elem.srcObject = stream"
                    ), p;
                  }
                  return c(f);
                }, l.revokeObjectURL = function(f) {
                  d(f), u.delete(f);
                };
                var A = Object.getOwnPropertyDescriptor(
                  o.HTMLMediaElement.prototype,
                  "src"
                );
                Object.defineProperty(o.HTMLMediaElement.prototype, "src", {
                  get: function() {
                    return A.get.apply(this);
                  },
                  set: function(f) {
                    return this.srcObject = u.get(f) || null, A.set.apply(this, [f]);
                  }
                });
                var g = o.HTMLMediaElement.prototype.setAttribute;
                o.HTMLMediaElement.prototype.setAttribute = function() {
                  return arguments.length === 2 && ("" + arguments[0]).toLowerCase() === "src" && (this.srcObject = u.get(arguments[1]) || null), g.apply(this, arguments);
                };
              }
            },
            shimMaxMessageSize: function(o) {
              if (!(o.RTCSctpTransport || !o.RTCPeerConnection)) {
                var l = t.detectBrowser(o);
                "sctp" in o.RTCPeerConnection.prototype || Object.defineProperty(o.RTCPeerConnection.prototype, "sctp", {
                  get: function() {
                    return typeof this._sctp == "undefined" ? null : this._sctp;
                  }
                });
                var c = function(g) {
                  var f = n.splitSections(g.sdp);
                  return f.shift(), f.some(function(p) {
                    var v = n.parseMLine(p);
                    return v && v.kind === "application" && v.protocol.indexOf("SCTP") !== -1;
                  });
                }, d = function(g) {
                  var f = g.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
                  if (f === null || f.length < 2)
                    return -1;
                  var p = parseInt(f[1], 10);
                  return p !== p ? -1 : p;
                }, u = function(g) {
                  var f = 65536;
                  return l.browser === "firefox" && (l.version < 57 ? g === -1 ? f = 16384 : f = 2147483637 : l.version < 60 ? f = l.version === 57 ? 65535 : 65536 : f = 2147483637), f;
                }, h = function(g, f) {
                  var p = 65536;
                  l.browser === "firefox" && l.version === 57 && (p = 65535);
                  var v = n.matchPrefix(g.sdp, "a=max-message-size:");
                  return v.length > 0 ? p = parseInt(v[0].substr(19), 10) : l.browser === "firefox" && f !== -1 && (p = 2147483637), p;
                }, A = o.RTCPeerConnection.prototype.setRemoteDescription;
                o.RTCPeerConnection.prototype.setRemoteDescription = function() {
                  var g = this;
                  if (g._sctp = null, c(arguments[0])) {
                    var f = d(arguments[0]), p = u(f), v = h(arguments[0], f), b;
                    p === 0 && v === 0 ? b = Number.POSITIVE_INFINITY : p === 0 || v === 0 ? b = Math.max(p, v) : b = Math.min(p, v);
                    var m = {};
                    Object.defineProperty(m, "maxMessageSize", {
                      get: function() {
                        return b;
                      }
                    }), g._sctp = m;
                  }
                  return A.apply(g, arguments);
                };
              }
            },
            shimSendThrowTypeError: function(o) {
              if (!(o.RTCPeerConnection && "createDataChannel" in o.RTCPeerConnection.prototype))
                return;
              function l(d, u) {
                var h = d.send;
                d.send = function() {
                  var A = arguments[0], g = A.length || A.size || A.byteLength;
                  if (d.readyState === "open" && u.sctp && g > u.sctp.maxMessageSize)
                    throw new TypeError("Message too large (can send a maximum of " + u.sctp.maxMessageSize + " bytes)");
                  return h.apply(d, arguments);
                };
              }
              var c = o.RTCPeerConnection.prototype.createDataChannel;
              o.RTCPeerConnection.prototype.createDataChannel = function() {
                var d = this, u = c.apply(d, arguments);
                return l(u, d), u;
              }, t.wrapPeerConnectionEvent(o, "datachannel", function(d) {
                return l(d.channel, d.target), d;
              });
            }
          };
        },
        /* 586 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = t;
          const n = (o) => {
            const l = {};
            return Object.getOwnPropertyNames(o).forEach((c) => {
              l[c] = Object.getOwnPropertyDescriptor(o, c);
            }), l;
          };
          function t(o) {
            function l() {
              for (var c = arguments.length, d = new Array(c), u = 0; u < c; u++)
                d[u] = arguments[u];
              const h = new o(...d);
              return Object.setPrototypeOf(h, l.prototype), h;
            }
            return l.prototype = Object.create(o.prototype), Object.defineProperties(l.prototype, n(o.prototype)), Object.keys(o).forEach((c) => {
              l[c] = o[c];
            }), l;
          }
        },
        /* 587 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(6));
            function l() {
              return typeof document == "undefined" || document.readyState === "complete" || document.readyState === "interactive" && document.body;
            }
            let c = !1;
            const d = {
              isDomLoaded: l,
              isDomUnloaded() {
                return c;
              },
              whenUnloaded: new n((h) => {
                if (typeof window != "undefined") {
                  const A = () => {
                    c = !0, d.emit("unload"), h();
                  };
                  window.addEventListener("unload", A);
                }
              }),
              whenLoaded: new n((h) => {
                if (l()) {
                  h();
                  return;
                }
                const A = () => {
                  document.removeEventListener("DOMContentLoaded", A), document.removeEventListener("load", A), d.emit("load"), h();
                };
                document.addEventListener("DOMContentLoaded", A), document.addEventListener("load", A);
              })
            };
            (0, o.default)(d);
            var u = d;
            r.default = u;
          }).call(this, e(2));
        },
        /* 588 */
        /***/
        function(i, r, e) {
          var n = e(80), t = e(273), o = e(250), l = e(589), c = e(11), d = e(54), u = e(274);
          function h(A, g, f, p, v) {
            A !== g && o(g, function(b, m) {
              if (v || (v = new n()), c(b))
                l(A, g, m, f, h, p, v);
              else {
                var y = p ? p(u(A, m), b, m + "", A, g, v) : void 0;
                y === void 0 && (y = b), t(A, m, y);
              }
            }, d);
          }
          i.exports = h;
        },
        /* 589 */
        /***/
        function(i, r, e) {
          var n = e(273), t = e(192), o = e(201), l = e(55), c = e(202), d = e(64), u = e(12), h = e(147), A = e(65), g = e(17), f = e(11), p = e(137), v = e(87), b = e(274), m = e(590);
          function y(U, B, Q, N, J, w, W) {
            var G = b(U, Q), Z = b(B, Q), K = W.get(Z);
            if (K) {
              n(U, Q, K);
              return;
            }
            var L = w ? w(G, Z, Q + "", U, B, W) : void 0, O = L === void 0;
            if (O) {
              var de = u(Z), oe = !de && A(Z), fe = !de && !oe && v(Z);
              L = Z, de || oe || fe ? u(G) ? L = G : h(G) ? L = l(G) : oe ? (O = !1, L = t(Z, !0)) : fe ? (O = !1, L = o(Z, !0)) : L = [] : p(Z) || d(Z) ? (L = G, d(G) ? L = m(G) : (!f(G) || g(G)) && (L = c(Z))) : O = !1;
            }
            O && (W.set(Z, L), J(L, Z, N, w, W), W.delete(Z)), n(U, Q, L);
          }
          i.exports = y;
        },
        /* 590 */
        /***/
        function(i, r, e) {
          var n = e(45), t = e(54);
          function o(l) {
            return n(l, t(l));
          }
          i.exports = o;
        },
        /* 591 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = y;
          var t = n(e(155)), o = n(e(275)), l = n(e(1)), c = n(e(280)), d = n(e(281));
          const u = (0, l.default)("normalizeConstraintInput"), h = {
            "320x240": {
              width: 320,
              height: 240
            },
            "320x180": {
              width: 320,
              height: 180
            },
            "640x480": {
              width: 640,
              height: 480
            },
            "640x360": {
              width: 640,
              height: 360
            },
            "1280x720": {
              width: 1280,
              height: 720
            },
            "1280x960": {
              width: 1280,
              height: 960
            },
            "1920x1080": {
              width: 1920,
              height: 1080
            }
          }, A = [1, 7, 15, 30];
          function g(U) {
            return U._inject && U._inject.logging || u;
          }
          function f(U, B, Q, N, J) {
            if (B === void 0)
              return;
            const w = Q(B);
            return w || J.warn(`Invalid ${U} passed to the Publisher. Got: ${B}, expecting one of ${N}`), w;
          }
          function p(U, B) {
            const Q = g(B), N = (() => {
              const w = B[`publish${(0, o.default)(U)}`];
              return w !== void 0 ? !!w : !0;
            })();
            let J = (() => {
              const w = B[`${U}Source`];
              return w === void 0 ? !0 : w === null || w === !1 ? !1 : typeof w == "object" ? B[`isCustom${(0, o.default)(U)}Track`] ? !1 : typeof w.deviceId != "string" ? (Q.warn(`Invalid ${U}Source passed to Publisher. Expected either a device ID or device.`), !0) : w.deviceId : typeof w != "string" ? (Q.warn(`Ignoring invalid ${U}Source parameter`), !0) : w;
            })();
            return U === "audio" && B.isScreenSharing && !d.default && J !== !1 && (B.audioSource && g(B).warn("Invalid audioSource passed to Publisher - when using screen sharing no audioSource may be used"), J = !1), {
              source: J,
              publish: N
            };
          }
          function v(U, B) {
            return U.name === "Chrome" && U.userAgent.indexOf("Mac OS X") !== -1 && B === 1 ? 2 : B;
          }
          const b = ["user", "environment", "left", "right"], m = (U, B) => {
            if (U === void 0 || b.indexOf(U) >= 0)
              return U;
            g(B).warn(`Invalid facingMode passed to Publisher. Expected one of: ${b.join(", ")}`);
          };
          function y(U) {
            const B = g(U), Q = U.env || {}, N = U.isScreenSharing, J = U.isCustomAudioTrack, w = U.isCustomVideoTrack;
            return N && !c.default && (0, t.default)(U.usingOptionalMandatoryStyle, "Screensharing only uses optional-mandatory constraints right now"), ["echoCancellation", "autoGainControl", "noiseSuppression"].forEach((W) => {
              U[W] !== !1 && Object.assign(U, {
                [W]: !0
              });
            }), {
              isScreenSharing: N,
              isCustomAudioTrack: J,
              isCustomVideoTrack: w,
              // These will be of the form { source: string | boolean, publish: boolean }
              audio: p("audio", U),
              video: p("video", U),
              usingOptionalMandatoryStyle: U.usingOptionalMandatoryStyle,
              enableRenegotiation: U.enableRenegotiation,
              enableStereo: U.enableStereo,
              noiseSuppression: U.noiseSuppression,
              autoGainControl: U.autoGainControl,
              echoCancellation: U.echoCancellation,
              disableAudioProcessing: U.disableAudioProcessing,
              videoDimensions: f("resolution", U.resolution, (W) => h[W], `"${Object.keys(h).join('", "')}"`, B),
              frameRate: v(Q, f("frameRate", U.frameRate, (W) => A.indexOf(W) !== -1 ? W : void 0, A.join(","), B)),
              maxResolution: function() {
                if (U.maxResolution === void 0)
                  return N ? {
                    width: 1920,
                    height: 1920
                  } : void 0;
                const W = {
                  width: U.maxResolution.width,
                  height: U.maxResolution.height
                };
                return Object.keys(W).forEach((G) => {
                  const Z = W[G];
                  (typeof Z != "number" || Z > 1920) && (B.warn(`Invalid maxResolution passed to the Publisher. maxResolution.${G} must be less than or equal to 1920`), W[G] = 1920);
                }), W;
              }(),
              facingMode: m(U.facingMode, U)
            };
          }
        },
        /* 592 */
        /***/
        function(i, r, e) {
          /*
          object-assign
          (c) Sindre Sorhus
          @license MIT
          */
          var n = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
          function l(d) {
            if (d == null)
              throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(d);
          }
          function c() {
            try {
              if (!Object.assign)
                return !1;
              var d = new String("abc");
              if (d[5] = "de", Object.getOwnPropertyNames(d)[0] === "5")
                return !1;
              for (var u = {}, h = 0; h < 10; h++)
                u["_" + String.fromCharCode(h)] = h;
              var A = Object.getOwnPropertyNames(u).map(function(f) {
                return u[f];
              });
              if (A.join("") !== "0123456789")
                return !1;
              var g = {};
              return "abcdefghijklmnopqrst".split("").forEach(function(f) {
                g[f] = f;
              }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
            } catch {
              return !1;
            }
          }
          i.exports = c() ? Object.assign : function(d, u) {
            for (var h, A = l(d), g, f = 1; f < arguments.length; f++) {
              h = Object(arguments[f]);
              for (var p in h)
                t.call(h, p) && (A[p] = h[p]);
              if (n) {
                g = n(h);
                for (var v = 0; v < g.length; v++)
                  o.call(h, g[v]) && (A[g[v]] = h[g[v]]);
              }
            }
            return A;
          };
        },
        /* 593 */
        /***/
        function(i, r, e) {
          (function(n, t) {
            var o = Object.getOwnPropertyDescriptors || function(at) {
              for (var pt = Object.keys(at), kt = {}, _t = 0; _t < pt.length; _t++)
                kt[pt[_t]] = Object.getOwnPropertyDescriptor(at, pt[_t]);
              return kt;
            }, l = /%[sdj%]/g;
            r.format = function(Le) {
              if (!w(Le)) {
                for (var at = [], pt = 0; pt < arguments.length; pt++)
                  at.push(u(arguments[pt]));
                return at.join(" ");
              }
              for (var pt = 1, kt = arguments, _t = kt.length, Lt = String(Le).replace(l, function(Zt) {
                if (Zt === "%%") return "%";
                if (pt >= _t) return Zt;
                switch (Zt) {
                  case "%s":
                    return String(kt[pt++]);
                  case "%d":
                    return Number(kt[pt++]);
                  case "%j":
                    try {
                      return JSON.stringify(kt[pt++]);
                    } catch {
                      return "[Circular]";
                    }
                  default:
                    return Zt;
                }
              }), Ft = kt[pt]; pt < _t; Ft = kt[++pt])
                Q(Ft) || !K(Ft) ? Lt += " " + Ft : Lt += " " + u(Ft);
              return Lt;
            }, r.deprecate = function(Le, at) {
              if (typeof n != "undefined" && n.noDeprecation === !0)
                return Le;
              if (typeof n == "undefined")
                return function() {
                  return r.deprecate(Le, at).apply(this, arguments);
                };
              var pt = !1;
              function kt() {
                if (!pt) {
                  if (n.throwDeprecation)
                    throw new Error(at);
                  n.traceDeprecation ? console.trace(at) : console.error(at), pt = !0;
                }
                return Le.apply(this, arguments);
              }
              return kt;
            };
            var c = {}, d;
            r.debuglog = function(Le) {
              if (G(d) && (d = n.env.NODE_DEBUG || ""), Le = Le.toUpperCase(), !c[Le])
                if (new RegExp("\\b" + Le + "\\b", "i").test(d)) {
                  var at = n.pid;
                  c[Le] = function() {
                    var pt = r.format.apply(r, arguments);
                    console.error("%s %d: %s", Le, at, pt);
                  };
                } else
                  c[Le] = function() {
                  };
              return c[Le];
            };
            function u(Le, at) {
              var pt = {
                seen: [],
                stylize: A
              };
              return arguments.length >= 3 && (pt.depth = arguments[2]), arguments.length >= 4 && (pt.colors = arguments[3]), B(at) ? pt.showHidden = at : at && r._extend(pt, at), G(pt.showHidden) && (pt.showHidden = !1), G(pt.depth) && (pt.depth = 2), G(pt.colors) && (pt.colors = !1), G(pt.customInspect) && (pt.customInspect = !0), pt.colors && (pt.stylize = h), f(pt, Le, pt.depth);
            }
            r.inspect = u, u.colors = {
              bold: [1, 22],
              italic: [3, 23],
              underline: [4, 24],
              inverse: [7, 27],
              white: [37, 39],
              grey: [90, 39],
              black: [30, 39],
              blue: [34, 39],
              cyan: [36, 39],
              green: [32, 39],
              magenta: [35, 39],
              red: [31, 39],
              yellow: [33, 39]
            }, u.styles = {
              special: "cyan",
              number: "yellow",
              boolean: "yellow",
              undefined: "grey",
              null: "bold",
              string: "green",
              date: "magenta",
              // "name": intentionally not styling
              regexp: "red"
            };
            function h(Le, at) {
              var pt = u.styles[at];
              return pt ? "\x1B[" + u.colors[pt][0] + "m" + Le + "\x1B[" + u.colors[pt][1] + "m" : Le;
            }
            function A(Le, at) {
              return Le;
            }
            function g(Le) {
              var at = {};
              return Le.forEach(function(pt, kt) {
                at[pt] = !0;
              }), at;
            }
            function f(Le, at, pt) {
              if (Le.customInspect && at && de(at.inspect) && // Filter out the util module, it's inspect function is special
              at.inspect !== r.inspect && // Also filter out any prototype objects using the circular check.
              !(at.constructor && at.constructor.prototype === at)) {
                var kt = at.inspect(pt, Le);
                return w(kt) || (kt = f(Le, kt, pt)), kt;
              }
              var _t = p(Le, at);
              if (_t)
                return _t;
              var Lt = Object.keys(at), Ft = g(Lt);
              if (Le.showHidden && (Lt = Object.getOwnPropertyNames(at)), O(at) && (Lt.indexOf("message") >= 0 || Lt.indexOf("description") >= 0))
                return v(at);
              if (Lt.length === 0) {
                if (de(at)) {
                  var Zt = at.name ? ": " + at.name : "";
                  return Le.stylize("[Function" + Zt + "]", "special");
                }
                if (Z(at))
                  return Le.stylize(RegExp.prototype.toString.call(at), "regexp");
                if (L(at))
                  return Le.stylize(Date.prototype.toString.call(at), "date");
                if (O(at))
                  return v(at);
              }
              var ft = "", It = !1, Kt = ["{", "}"];
              if (U(at) && (It = !0, Kt = ["[", "]"]), de(at)) {
                var Sn = at.name ? ": " + at.name : "";
                ft = " [Function" + Sn + "]";
              }
              if (Z(at) && (ft = " " + RegExp.prototype.toString.call(at)), L(at) && (ft = " " + Date.prototype.toUTCString.call(at)), O(at) && (ft = " " + v(at)), Lt.length === 0 && (!It || at.length == 0))
                return Kt[0] + ft + Kt[1];
              if (pt < 0)
                return Z(at) ? Le.stylize(RegExp.prototype.toString.call(at), "regexp") : Le.stylize("[Object]", "special");
              Le.seen.push(at);
              var Cn;
              return It ? Cn = b(Le, at, pt, Ft, Lt) : Cn = Lt.map(function(on) {
                return m(Le, at, pt, Ft, on, It);
              }), Le.seen.pop(), y(Cn, ft, Kt);
            }
            function p(Le, at) {
              if (G(at))
                return Le.stylize("undefined", "undefined");
              if (w(at)) {
                var pt = "'" + JSON.stringify(at).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return Le.stylize(pt, "string");
              }
              if (J(at))
                return Le.stylize("" + at, "number");
              if (B(at))
                return Le.stylize("" + at, "boolean");
              if (Q(at))
                return Le.stylize("null", "null");
            }
            function v(Le) {
              return "[" + Error.prototype.toString.call(Le) + "]";
            }
            function b(Le, at, pt, kt, _t) {
              for (var Lt = [], Ft = 0, Zt = at.length; Ft < Zt; ++Ft)
                Te(at, String(Ft)) ? Lt.push(m(
                  Le,
                  at,
                  pt,
                  kt,
                  String(Ft),
                  !0
                )) : Lt.push("");
              return _t.forEach(function(ft) {
                ft.match(/^\d+$/) || Lt.push(m(
                  Le,
                  at,
                  pt,
                  kt,
                  ft,
                  !0
                ));
              }), Lt;
            }
            function m(Le, at, pt, kt, _t, Lt) {
              var Ft, Zt, ft;
              if (ft = Object.getOwnPropertyDescriptor(at, _t) || { value: at[_t] }, ft.get ? ft.set ? Zt = Le.stylize("[Getter/Setter]", "special") : Zt = Le.stylize("[Getter]", "special") : ft.set && (Zt = Le.stylize("[Setter]", "special")), Te(kt, _t) || (Ft = "[" + _t + "]"), Zt || (Le.seen.indexOf(ft.value) < 0 ? (Q(pt) ? Zt = f(Le, ft.value, null) : Zt = f(Le, ft.value, pt - 1), Zt.indexOf(`
`) > -1 && (Lt ? Zt = Zt.split(`
`).map(function(It) {
                return "  " + It;
              }).join(`
`).substr(2) : Zt = `
` + Zt.split(`
`).map(function(It) {
                return "   " + It;
              }).join(`
`))) : Zt = Le.stylize("[Circular]", "special")), G(Ft)) {
                if (Lt && _t.match(/^\d+$/))
                  return Zt;
                Ft = JSON.stringify("" + _t), Ft.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Ft = Ft.substr(1, Ft.length - 2), Ft = Le.stylize(Ft, "name")) : (Ft = Ft.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Ft = Le.stylize(Ft, "string"));
              }
              return Ft + ": " + Zt;
            }
            function y(Le, at, pt) {
              var kt = Le.reduce(function(_t, Lt) {
                return Lt.indexOf(`
`) >= 0, _t + Lt.replace(/\u001b\[\d\d?m/g, "").length + 1;
              }, 0);
              return kt > 60 ? pt[0] + (at === "" ? "" : at + `
 `) + " " + Le.join(`,
  `) + " " + pt[1] : pt[0] + at + " " + Le.join(", ") + " " + pt[1];
            }
            function U(Le) {
              return Array.isArray(Le);
            }
            r.isArray = U;
            function B(Le) {
              return typeof Le == "boolean";
            }
            r.isBoolean = B;
            function Q(Le) {
              return Le === null;
            }
            r.isNull = Q;
            function N(Le) {
              return Le == null;
            }
            r.isNullOrUndefined = N;
            function J(Le) {
              return typeof Le == "number";
            }
            r.isNumber = J;
            function w(Le) {
              return typeof Le == "string";
            }
            r.isString = w;
            function W(Le) {
              return typeof Le == "symbol";
            }
            r.isSymbol = W;
            function G(Le) {
              return Le === void 0;
            }
            r.isUndefined = G;
            function Z(Le) {
              return K(Le) && fe(Le) === "[object RegExp]";
            }
            r.isRegExp = Z;
            function K(Le) {
              return typeof Le == "object" && Le !== null;
            }
            r.isObject = K;
            function L(Le) {
              return K(Le) && fe(Le) === "[object Date]";
            }
            r.isDate = L;
            function O(Le) {
              return K(Le) && (fe(Le) === "[object Error]" || Le instanceof Error);
            }
            r.isError = O;
            function de(Le) {
              return typeof Le == "function";
            }
            r.isFunction = de;
            function oe(Le) {
              return Le === null || typeof Le == "boolean" || typeof Le == "number" || typeof Le == "string" || typeof Le == "symbol" || // ES6 symbol
              typeof Le == "undefined";
            }
            r.isPrimitive = oe, r.isBuffer = e(594);
            function fe(Le) {
              return Object.prototype.toString.call(Le);
            }
            function ge(Le) {
              return Le < 10 ? "0" + Le.toString(10) : Le.toString(10);
            }
            var we = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec"
            ];
            function _e() {
              var Le = /* @__PURE__ */ new Date(), at = [
                ge(Le.getHours()),
                ge(Le.getMinutes()),
                ge(Le.getSeconds())
              ].join(":");
              return [Le.getDate(), we[Le.getMonth()], at].join(" ");
            }
            r.log = function() {
              console.log("%s - %s", _e(), r.format.apply(r, arguments));
            }, r.inherits = e(595), r._extend = function(Le, at) {
              if (!at || !K(at)) return Le;
              for (var pt = Object.keys(at), kt = pt.length; kt--; )
                Le[pt[kt]] = at[pt[kt]];
              return Le;
            };
            function Te(Le, at) {
              return Object.prototype.hasOwnProperty.call(Le, at);
            }
            var Pe = typeof Symbol != "undefined" ? Symbol("util.promisify.custom") : void 0;
            r.promisify = function(at) {
              if (typeof at != "function")
                throw new TypeError('The "original" argument must be of type Function');
              if (Pe && at[Pe]) {
                var pt = at[Pe];
                if (typeof pt != "function")
                  throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                return Object.defineProperty(pt, Pe, {
                  value: pt,
                  enumerable: !1,
                  writable: !1,
                  configurable: !0
                }), pt;
              }
              function pt() {
                for (var kt, _t, Lt = new t(function(ft, It) {
                  kt = ft, _t = It;
                }), Ft = [], Zt = 0; Zt < arguments.length; Zt++)
                  Ft.push(arguments[Zt]);
                Ft.push(function(ft, It) {
                  ft ? _t(ft) : kt(It);
                });
                try {
                  at.apply(this, Ft);
                } catch (ft) {
                  _t(ft);
                }
                return Lt;
              }
              return Object.setPrototypeOf(pt, Object.getPrototypeOf(at)), Pe && Object.defineProperty(pt, Pe, {
                value: pt,
                enumerable: !1,
                writable: !1,
                configurable: !0
              }), Object.defineProperties(
                pt,
                o(at)
              );
            }, r.promisify.custom = Pe;
            function $e(Le, at) {
              if (!Le) {
                var pt = new Error("Promise was rejected with a falsy value");
                pt.reason = Le, Le = pt;
              }
              return at(Le);
            }
            function Bt(Le) {
              if (typeof Le != "function")
                throw new TypeError('The "original" argument must be of type Function');
              function at() {
                for (var pt = [], kt = 0; kt < arguments.length; kt++)
                  pt.push(arguments[kt]);
                var _t = pt.pop();
                if (typeof _t != "function")
                  throw new TypeError("The last argument must be of type Function");
                var Lt = this, Ft = function() {
                  return _t.apply(Lt, arguments);
                };
                Le.apply(this, pt).then(
                  function(Zt) {
                    n.nextTick(Ft, null, Zt);
                  },
                  function(Zt) {
                    n.nextTick($e, Zt, Ft);
                  }
                );
              }
              return Object.setPrototypeOf(at, Object.getPrototypeOf(Le)), Object.defineProperties(
                at,
                o(Le)
              ), at;
            }
            r.callbackify = Bt;
          }).call(this, e(27), e(2));
        },
        /* 594 */
        /***/
        function(i, r) {
          i.exports = function(n) {
            return n && typeof n == "object" && typeof n.copy == "function" && typeof n.fill == "function" && typeof n.readUInt8 == "function";
          };
        },
        /* 595 */
        /***/
        function(i, r) {
          typeof Object.create == "function" ? i.exports = function(n, t) {
            n.super_ = t, n.prototype = Object.create(t.prototype, {
              constructor: {
                value: n,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            });
          } : i.exports = function(n, t) {
            n.super_ = t;
            var o = function() {
            };
            o.prototype = t.prototype, n.prototype = new o(), n.prototype.constructor = n;
          };
        },
        /* 596 */
        /***/
        function(i, r, e) {
          var n = e(597), t = e(278), o = e(279), l = e(60);
          function c(d) {
            return function(u) {
              u = l(u);
              var h = t(u) ? o(u) : void 0, A = h ? h[0] : u.charAt(0), g = h ? n(h, 1).join("") : u.slice(1);
              return A[d]() + g;
            };
          }
          i.exports = c;
        },
        /* 597 */
        /***/
        function(i, r, e) {
          var n = e(277);
          function t(o, l, c) {
            var d = o.length;
            return c = c === void 0 ? d : c, !l && c >= d ? o : n(o, l, c);
          }
          i.exports = t;
        },
        /* 598 */
        /***/
        function(i, r) {
          function e(n) {
            return n.split("");
          }
          i.exports = e;
        },
        /* 599 */
        /***/
        function(i, r) {
          var e = "\\ud800-\\udfff", n = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", o = "\\u20d0-\\u20ff", l = n + t + o, c = "\\ufe0e\\ufe0f", d = "[" + e + "]", u = "[" + l + "]", h = "\\ud83c[\\udffb-\\udfff]", A = "(?:" + u + "|" + h + ")", g = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", p = "[\\ud800-\\udbff][\\udc00-\\udfff]", v = "\\u200d", b = A + "?", m = "[" + c + "]?", y = "(?:" + v + "(?:" + [g, f, p].join("|") + ")" + m + b + ")*", U = m + b + y, B = "(?:" + [g + u + "?", u, f, p, d].join("|") + ")", Q = RegExp(h + "(?=" + h + ")|" + B + U, "g");
          function N(J) {
            return J.match(Q) || [];
          }
          i.exports = N;
        },
        /* 600 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = ["screen", "window", "tab", "browser", "application"];
          r.default = n;
        },
        /* 601 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(51)), o = n(e(603)), l = n(e(606)), c = n(e(1)), d = n(e(127)), u = n(e(37));
          const h = (0, u.default)(), A = "/opentok/webrtc/docs/js/release-notes.html", g = h.onlyLocal(), f = (0, c.default)("setLogLevel"), p = `
 ██████╗ ██████╗ ███████╗███╗   ██╗████████╗ ██████╗ ██╗  ██╗
██╔═══██╗██╔══██╗██╔════╝████╗  ██║╚══██╔══╝██╔═══██╗██║ ██╔╝
██║   ██║██████╔╝█████╗  ██╔██╗ ██║   ██║   ██║   ██║█████╔╝
██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║   ██║   ██║   ██║██╔═██╗
╚██████╔╝██║     ███████╗██║ ╚████║   ██║   ╚██████╔╝██║  ██╗
 ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝   ╚═╝    ╚═════╝ ╚═╝  ╚═╝`, v = (0, t.default)(() => {
            f.info(`%c${p}`, 'font-family: "Fire Code", Courier, "Courier New", Consolas, "DejaVu Sans Mono"'), f.info(`OpenTok JS SDK ${g.version}`), f.info(`Release notes: ${g.websiteUrl}${A}`), f.info(`Known issues: ${g.websiteUrl}${A}l#knownIssues`);
          });
          function b(y) {
            if (y === void 0 || !(0, o.default)(d.default, {
              priority: y
            }) && y !== 0) {
              const B = (0, l.default)(d.default, (Q, N) => `OT.${N.toUpperCase()} = ${Q.priority}`).join(", ");
              f.error(`level must be one of: OT.NONE = 0, ${B}`), f.warn("Using OT.WARN instead"), y = d.default.warn.priority;
            }
            return c.default.setLogLevel(y), y >= d.default.debug.priority && v(), f.info("OpenTok JS SDK now uses the debug library. More info at https://www.npmjs.com/package/debug#browser-support"), f.info(`Changed log level to: ${y}`), y;
          }
          b(g.debug ? d.default.debug.priority : d.default.warn.priority);
          var m = b;
          r.default = m;
        },
        /* 602 */
        /***/
        function(i, r, e) {
          var n = e(97), t = "Expected a function";
          function o(l, c) {
            var d;
            if (typeof c != "function")
              throw new TypeError(t);
            return l = n(l), function() {
              return --l > 0 && (d = c.apply(this, arguments)), l <= 1 && (c = void 0), d;
            };
          }
          i.exports = o;
        },
        /* 603 */
        /***/
        function(i, r, e) {
          var n = e(243), t = e(38), o = e(604), l = e(12), c = e(125);
          function d(u, h, A) {
            var g = l(u) ? n : o;
            return A && c(u, h, A) && (h = void 0), g(u, t(h, 3));
          }
          i.exports = d;
        },
        /* 604 */
        /***/
        function(i, r, e) {
          var n = e(283);
          function t(o, l) {
            var c;
            return n(o, function(d, u, h) {
              return c = l(d, u, h), !c;
            }), !!c;
          }
          i.exports = t;
        },
        /* 605 */
        /***/
        function(i, r, e) {
          var n = e(26);
          function t(o, l) {
            return function(c, d) {
              if (c == null)
                return c;
              if (!n(c))
                return o(c, d);
              for (var u = c.length, h = l ? u : -1, A = Object(c); (l ? h-- : ++h < u) && d(A[h], h, A) !== !1; )
                ;
              return c;
            };
          }
          i.exports = t;
        },
        /* 606 */
        /***/
        function(i, r, e) {
          var n = e(39), t = e(38), o = e(607), l = e(12);
          function c(d, u) {
            var h = l(d) ? n : o;
            return h(d, t(u, 3));
          }
          i.exports = c;
        },
        /* 607 */
        /***/
        function(i, r, e) {
          var n = e(283), t = e(26);
          function o(l, c) {
            var d = -1, u = t(l) ? Array(l.length) : [];
            return n(l, function(h, A, g) {
              u[++d] = c(h, A, g);
            }), u;
          }
          i.exports = o;
        },
        /* 608 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            return t.substr(0, 5) !== "http:" && t.substr(0, 6) !== "https:" && t.substr(0, 22) !== "data:image/png;base64," ? `data:image/png;base64,${t}` : t;
          }
        },
        /* 609 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(61)), o = n(e(1));
          const l = (0, o.default)("Style");
          function c(d, u) {
            const h = this, A = {}, g = {
              buttonDisplayMode: ["auto", "mini", "mini-auto", "off", "on"],
              nameDisplayMode: ["auto", "off", "on"],
              audioLevelDisplayMode: ["auto", "off", "on"],
              showSettingsButton: [!0, !1],
              showSpeakerButton: null,
              showMicButton: [!0, !1],
              backgroundImageURI: null,
              showControlBar: [!0, !1],
              // 'showArchiveStatus' is kept for backwards compatibility.
              // 'archiveStatusDisplayMode' is the documented style name.
              showArchiveStatus: [!0, !1],
              archiveStatusDisplayMode: ["auto", "off", "on"],
              videoDisabledDisplayMode: ["auto", "off", "on"],
              audioBlockedDisplayMode: ["auto", "off", "on"]
            }, f = function(b, m) {
              const y = g[b];
              return y === void 0 ? !1 : y === null ? !0 : y.indexOf(m) !== -1;
            }, p = function(b) {
              switch (b) {
                case "true":
                  return !0;
                case "false":
                  return !1;
                default:
                  return b;
              }
            };
            h.getAll = function() {
              return (0, t.default)(A);
            }, h.get = function(v) {
              return v ? A[v] : h.getAll();
            }, h.setAll = function(v, b) {
              return Object.keys(v).forEach((m) => {
                h.set(m, v[m], b);
              }), h;
            }, h.set = function(v, b, m) {
              l.debug(`setStyle: ${v.toString()}`);
              let y;
              const U = p(b);
              return f(v, U) ? (y = A[v], U !== y && (A[v] = U, m || u(v, b, y)), h) : (l.warn(`Style.set::Invalid style property passed ${v} : ${U}`), h);
            }, d && h.setAll(d, !0);
          }
        },
        /* 610 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(287));
          const l = () => t.default.isIosWebView ? !1 : (0, o.default)() ? !0 : (typeof window !== void 0 ? window : Dn).navigator.mediaDevices && (typeof window !== void 0 ? window : Dn).navigator.mediaDevices.getUserMedia || (typeof window !== void 0 ? window : Dn).navigator.webkitGetUserMedia || (typeof window !== void 0 ? window : Dn).navigator.mozGetUserMedia;
          var c = () => !!(t.default.name !== "Node" && l());
          r.default = c;
        },
        /* 611 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), l = () => t.default.name === "Node" ? !1 : typeof (typeof window !== void 0 ? window : Dn).webkitRTCPeerConnection == "function" && (typeof window !== void 0 ? window : Dn).webkitRTCPeerConnection.prototype.addTrack || typeof (typeof window !== void 0 ? window : Dn).RTCPeerConnection == "function" ? !0 : typeof (typeof window !== void 0 ? window : Dn).mozRTCPeerConnection == "function" && t.default.version > 20;
          r.default = l;
        },
        /* 612 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (typeof window !== void 0 ? window : Dn).WebSocket !== void 0;
          r.default = n;
        },
        /* 613 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(30)), o = n(e(14));
          let l = /* @__PURE__ */ function(c) {
            (0, t.default)(d, c);
            function d(h, A) {
              var g;
              let f = A === void 0 ? {} : A, p = f.destroyOnClose, v = p === void 0 ? !0 : p;
              g = c.call(this) || this, g.modalDiv = document.createElement("div"), g.modalDiv.classList.add("OT_ModalDialog"), g.modalDiv.innerHTML = h;
              const b = g.modalDiv.querySelectorAll("[role=OT_close]");
              return [].forEach.call(b, (m) => m.addEventListener("click", (y) => {
                y.preventDefault(), g.close();
              })), g.close(), document.body.appendChild(g.modalDiv), v && g.on("closed", () => g.destroy()), g;
            }
            var u = d.prototype;
            return u.open = function() {
              this.modalDiv.style.display = "block", this.emit("opened");
            }, u.close = function() {
              this.modalDiv.style.display = "none", this.emit("closed");
            }, u.destroy = function() {
              this.modalDiv.innerHTML = "", this.modalDiv.parentNode.removeChild(this.modalDiv), this.emit("destroyed");
            }, u.el = function(A) {
              return this.modalDiv.querySelector(A);
            }, d;
          }(o.default);
          r.default = l;
        },
        /* 614 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(28)), l = function(d) {
            d === void 0 && (d = {});
            const u = d.env || t.default, h = d.analytics || new o.default();
            h.logEvent({
              action: "UserAgentParsing",
              variation: "Attempt",
              payload: {
                userAgent: u.userAgent
              }
            }), h.logEvent({
              action: "UserAgentParsing",
              variation: u.error ? "Failure" : "Success",
              payload: {
                userAgent: u.userAgent
              }
            });
          };
          r.default = l;
        },
        /* 615 */
        /***/
        function(i, r) {
          i.exports = `<div id="tb_alert"><div id="section-normal-install" class="OT_alert"><div class="OT_alert-exclamation">!</div><button class="OT_alert-close-button" role="OT_close">&#x00D7;</button><div class="OT_alert-header" data-text="Incompatible Browser">Incompatible Browser</div><div class="OT_alert-body">The video component of this application requires <a target="_blank" href="https://www.google.com/chrome/">Google Chrome</a>, <a target="_blank" href="http://www.mozilla.org/firefox">Firefox</a>, <a target="_blank" href="https://www.microsoft.com/en-us/edge">Edge</a>, or <a target="_blank" href="https://www.apple.com/safari/">Safari</a>.</div></div><div id="section-upgrade-install" class="OT_alert"><div class="OT_alert-exclamation">!</div><button class="OT_alert-close-button" role="OT_close">&#x00D7;</button><div class="OT_alert-header" data-text="Incompatible Browser">Incompatible Browser</div><div class="OT_alert-body">The video component of this application requires a newer version of <a target="_blank" href="https://www.google.com/chrome/">Google Chrome</a>, <a target="_blank" href="http://www.mozilla.org/firefox">Firefox</a>, <a target="_blank" href="https://www.microsoft.com/en-us/edge">Edge</a>, or <a target="_blank" href="https://www.apple.com/safari/">Safari</a>.</div><div class="continue-text"><a href="#" role="OT_close">Continue at my own risk.</a></div></div><div id="section-supported-mobile-browser" class="OT_alert"><div class="OT_alert-exclamation">!</div><button class="OT_alert-close-button" role="OT_close">&#x00D7;</button><div class="OT_alert-header" data-text="Incompatible Browser">Incompatible Browser</div><div class="OT_alert-body">The video component of this application requires a newer version of <a target="_blank" href="https://www.google.com.au/chrome/browser/mobile/">Google Chrome</a>.</div><div class="continue-text"><a href="#" role="OT_close">Continue at my own risk.</a></div></div><div id="section-mobile-browser" class="OT_alert"><div class="OT_alert-exclamation">!</div><button class="OT_alert-close-button" role="OT_close">&#x00D7;</button><div class="OT_alert-header" data-text="Incompatible Browser">Incompatible Browser</div><div class="OT_alert-body">The video component of this application is not supported on your mobile device's browser at this time.</div></div></div>`;
        },
        /* 616 */
        /***/
        function(i, r) {
          function e(n) {
            return i.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
              return o.__proto__ || Object.getPrototypeOf(o);
            }, e(n);
          }
          i.exports = e;
        },
        /* 617 */
        /***/
        function(i, r) {
          function e(n) {
            return Function.toString.call(n).indexOf("[native code]") !== -1;
          }
          i.exports = e;
        },
        /* 618 */
        /***/
        function(i, r, e) {
          var n = e(288);
          function t() {
            if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
            if (typeof Proxy == "function") return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              })), !0;
            } catch {
              return !1;
            }
          }
          function o(l, c, d) {
            return t() ? i.exports = o = Reflect.construct : i.exports = o = function(h, A, g) {
              var f = [null];
              f.push.apply(f, A);
              var p = Function.bind.apply(h, f), v = new p();
              return g && n(v, g.prototype), v;
            }, o.apply(null, arguments);
          }
          i.exports = o;
        },
        /* 619 */
        /***/
        function(i, r, e) {
          (function(n) {
            i.exports = (t, o) => (o = o || (() => {
            }), t.then((l) => new n((c) => {
              c(o());
            }).then(() => l), (l) => new n((c) => {
              c(o());
            }).then(() => {
              throw l;
            })));
          }).call(this, e(2));
        },
        /* 620 */
        /***/
        function(i, r, e) {
          var n = e(15), t = function() {
            return n.Date.now();
          };
          i.exports = t;
        },
        /* 621 */
        /***/
        function(i, r, e) {
          var n = e(59), t = e(622), o = e(623), l = e(49);
          function c(d, u) {
            return u = n(u, d), d = o(d, u), d == null || delete d[l(t(u))];
          }
          i.exports = c;
        },
        /* 622 */
        /***/
        function(i, r) {
          function e(n) {
            var t = n == null ? 0 : n.length;
            return t ? n[t - 1] : void 0;
          }
          i.exports = e;
        },
        /* 623 */
        /***/
        function(i, r, e) {
          var n = e(101), t = e(277);
          function o(l, c) {
            return c.length < 2 ? l : n(l, t(c, 0, -1));
          }
          i.exports = o;
        },
        /* 624 */
        /***/
        function(i, r, e) {
          var n = e(137);
          function t(o) {
            return n(o) ? void 0 : o;
          }
          i.exports = t;
        },
        /* 625 */
        /***/
        function(i, r, e) {
          var n = e(38), t = e(26), o = e(34);
          function l(c) {
            return function(d, u, h) {
              var A = Object(d);
              if (!t(d)) {
                var g = n(u, 3);
                d = o(d), u = function(p) {
                  return g(A[p], p, A);
                };
              }
              var f = c(d, u, h);
              return f > -1 ? A[g ? d[f] : f] : void 0;
            };
          }
          i.exports = l;
        },
        /* 626 */
        /***/
        function(i, r, e) {
          var n = e(98), t = e(96), o = e(146), l = e(99), c = e(627), d = e(100), u = 200;
          function h(A, g, f) {
            var p = -1, v = t, b = A.length, m = !0, y = [], U = y;
            if (f)
              m = !1, v = o;
            else if (b >= u) {
              var B = g ? null : c(A);
              if (B)
                return d(B);
              m = !1, v = l, U = new n();
            } else
              U = g ? [] : y;
            e:
              for (; ++p < b; ) {
                var Q = A[p], N = g ? g(Q) : Q;
                if (Q = f || Q !== 0 ? Q : 0, m && N === N) {
                  for (var J = U.length; J--; )
                    if (U[J] === N)
                      continue e;
                  g && U.push(N), y.push(Q);
                } else v(U, N, f) || (U !== y && U.push(N), y.push(Q));
              }
            return y;
          }
          i.exports = h;
        },
        /* 627 */
        /***/
        function(i, r, e) {
          var n = e(198), t = e(235), o = e(100), l = 1 / 0, c = n && 1 / o(new n([, -0]))[1] == l ? function(d) {
            return new n(d);
          } : t;
          i.exports = c;
        },
        /* 628 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(126)), c = n(e(293)), d = n(e(629)), h = function(g) {
            let f = g === void 0 ? {} : g, p = f.memoize, v = p === void 0 ? l.default : p, b = f.generateKey, m = b === void 0 ? c.default : b, y = f.arrayBufferToHex, U = y === void 0 ? d.default : y;
            return v(
              /* @__PURE__ */ function() {
                var Q = (0, o.default)(/* @__PURE__ */ t.default.mark(function N(J) {
                  var w, W, G, Z, K, L;
                  return t.default.wrap(function(de) {
                    for (; ; ) switch (de.prev = de.next) {
                      case 0:
                        return w = J.sessionId, W = J.connectionId, de.next = 3, m(w, W);
                      case 3:
                        return G = de.sent, de.next = 6, window.crypto.subtle.exportKey("raw", G);
                      case 6:
                        return Z = de.sent, K = [...new Uint8Array(Z)], K.splice(6), L = U(K), de.abrupt("return", parseInt(L, 16));
                      case 11:
                      case "end":
                        return de.stop();
                    }
                  }, N);
                }));
                return function(N) {
                  return Q.apply(this, arguments);
                };
              }(),
              // Memoize cache resolver function
              (Q) => {
                let N = Q.sessionId, J = Q.connectionId;
                return `${N}${J}`;
              }
            );
          };
          r.default = h;
        },
        /* 629 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => Array.isArray(t) ? `0x${t.map((l) => l.toString(16).padStart(2, "0")).join("")}` : null;
          r.default = n;
        },
        /* 630 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(1));
            const d = (0, c.default)("hasValidPeerConnection");
            function u(f) {
              return new n((p) => {
                f.addEventListener("signalingstatechange", () => p(!0)), f.createOffer({
                  offerToReceiveAudio: 1
                }).then((v) => f.setLocalDescription(v)).then(() => setTimeout(() => {
                  p(!1);
                }, 1e3));
              });
            }
            function h(f) {
              return A.apply(this, arguments);
            }
            function A() {
              return A = (0, l.default)(/* @__PURE__ */ o.default.mark(function f(p) {
                var v;
                return o.default.wrap(function(m) {
                  for (; ; ) switch (m.prev = m.next) {
                    case 0:
                      m.prev = 0, v = new p({
                        iceServers: []
                      }), m.next = 8;
                      break;
                    case 4:
                      return m.prev = 4, m.t0 = m.catch(0), d.error("Error occurred creating PeerConnection", m.t0), m.abrupt("return", !1);
                    case 8:
                      return m.prev = 8, m.next = 11, u(v);
                    case 11:
                      m.next = 18;
                      break;
                    case 13:
                      m.prev = 13, m.t1 = m.catch(8), d.error("Error occurred checking the validity of the PeerConnection", m.t1);
                      try {
                        v.close();
                      } catch {
                      }
                      return m.abrupt("return", !1);
                    case 18:
                      m.prev = 18, v.close(), m.next = 26;
                      break;
                    case 22:
                      return m.prev = 22, m.t2 = m.catch(18), d.error("Error occurred closing PeerConnection", m.t2), m.abrupt("return", !1);
                    case 26:
                      return m.abrupt("return", !0);
                    case 27:
                    case "end":
                      return m.stop();
                  }
                }, f, null, [[0, 4], [8, 13], [18, 22]]);
              })), A.apply(this, arguments);
            }
            var g = h;
            r.default = g;
          }).call(this, e(2));
        },
        /* 631 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = A;
            var o = t(e(42)), l = t(e(1)), c = t(e(3)), d = t(e(632)), u = t(e(75));
            const h = (0, l.default)("createPeerConnection");
            function A(g) {
              let f = g.window, p = g.config, v = g.constraints;
              h.debug("called");
              const b = (0, o.default)(p);
              b.iceServers = (0, d.default)(c.default, b.iceServers), (0, u.default)() && (b.sdpSemantics = "plan-b");
              const m = new f.RTCPeerConnection(b, v);
              return n.resolve(m);
            }
          }).call(this, e(2));
        },
        /* 632 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(9)), o = n(e(290));
          const l = {
            Edge(d) {
              let u = !1;
              return d.map((h) => {
                if (!h)
                  return;
                const A = h.urls || h.url && [h.url];
                if (!A)
                  return;
                const g = A.filter((f) => f.indexOf("turn:") === 0 && f.indexOf("transport=udp") !== -1 && f.indexOf("turn:[") === -1 && !u ? (u = !0, !0) : f.indexOf("stun:") === 0);
                if (g.length !== 0)
                  return (0, t.default)((0, o.default)(h, ["url", "urls"]), {
                    urls: g
                  });
              }).filter((h) => h !== void 0);
            },
            Safari(d) {
              return d.map((u) => {
                if (u.urls !== void 0 && u.url === void 0)
                  return u;
                const h = u.urls || u.url && [u.url];
                return (0, t.default)((0, o.default)(u, ["url", "urls"]), {
                  urls: h
                });
              });
            }
          };
          function c(d, u) {
            let h = d.name;
            d.isEdge && (h = d.isLegacyEdge ? "Edge" : "ChromiumEdge");
            const A = l[h];
            return A ? A(u) : u;
          }
        },
        /* 633 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(20)), o = n(e(3));
          const l = {
            h264: {
              baseline: "42001f",
              constBaseline: "42e01f"
            }
          }, c = (u) => {
            let h = u.sdp, A = u.from, g = u.to;
            return h.replace(new RegExp(`^(a=fmtp:\\d+ .*profile-level-id=)${A}`, "gmi"), `$1${g}`);
          };
          var d = {
            local: {
              offer: function(h, A) {
                let g = h === void 0 ? {} : h, f = g.numSimulcastStreams, p = g.audioBitrate, v = g.priorityVideoCodec, b = v === void 0 ? "" : v, m = g.codecFlags, y = m === void 0 ? {} : m, U = g.enableStereo, B = U === void 0 ? !1 : U, Q = g.enableDtx, N = Q === void 0 ? !1 : Q, J = g.replaceBaselineProfile, w = J === void 0 ? !1 : J, W = g.removeVideoOrientation, G = W === void 0 ? !1 : W, Z = t.default.filterExcessSSRCs(A);
                f > 1 && (Z = t.default.enableSimulcast(Z, f)), p > 0 && (Z = t.default.setAudioBitrate(Z, p)), G && (Z = t.default.removeVideoOrientation(Z)), Z = t.default.modifyReceiveStereo(Z, !1), Z = t.default.modifySendStereo(Z, !!B), Z = t.default.modifyDtx(Z, !!N), o.default.isLegacyEdge || Object.keys(y).filter((L) => y[L] === !1).forEach((L) => {
                  Z = t.default.removeVideoCodec(Z, L);
                }), b === "vp9" && !o.default.isLegacyEdge ? (Z = t.default.reprioritizeVideoCodec(Z, "vp8", "top"), Z = t.default.reprioritizeVideoCodec(Z, "vp9", "top")) : b && !o.default.isLegacyEdge ? Z = t.default.reprioritizeVideoCodec(Z, b, "top") : b !== "h264" && (Z = t.default.reprioritizeVideoCodec(Z, "h264", "bottom"));
                let K = Z;
                return w && (K = c({
                  sdp: K,
                  from: l.h264.baseline,
                  to: l.h264.constBaseline
                })), {
                  local: Z,
                  remote: K
                };
              },
              answer: function(h, A) {
                let g = h === void 0 ? {} : h, f = g.audioBitrate, p = g.codecFlags, v = g.enableStereo, b = v === void 0 ? !1 : v, m = g.enableDtx, y = m === void 0 ? !1 : m, U = g.replaceBaselineProfile, B = U === void 0 ? !1 : U, Q = g.sourceStreamId, N = A;
                f > 0 && (N = t.default.setAudioBitrate(N, f)), N = t.default.modifyReceiveStereo(N, !!b), N = t.default.modifySendStereo(N, !1), N = t.default.modifyDtx(N, !!y), Q === "MANTIS" && t.default.getSetupRole(N) === "passive" && (N = t.default.setSetupRole(N, "active")), p && Object.keys(p).filter((w) => p[w] === !1).forEach((w) => {
                  N = t.default.removeVideoCodec(N, w);
                });
                let J = N;
                return B && (J = c({
                  sdp: J,
                  from: l.h264.baseline,
                  to: l.h264.constBaseline
                })), {
                  local: N,
                  remote: J
                };
              }
            },
            remote: {
              offer: (u, h) => {
                let A = u.replaceBaselineProfile, g = A === void 0 ? !1 : A, f = h;
                return f.indexOf("a=rtcp-fb") === -1 && (f = f.replace(/^m=video(.*)$/gmi, `m=video$1\r
a=rtcp-fb:* ccm fir\r
a=rtcp-fb:* nack `)), g && (f = c({
                  sdp: f,
                  from: l.h264.constBaseline,
                  to: l.h264.baseline
                })), {
                  local: f
                };
              },
              answer: function(h, A) {
                let g = h === void 0 ? {} : h, f = g.audioBitrate, p = g.replaceBaselineProfile, v = p === void 0 ? !1 : p, b = A;
                return f > 0 && (b = t.default.setAudioBitrate(b, f)), v && (b = c({
                  sdp: b,
                  from: l.h264.constBaseline,
                  to: l.h264.baseline
                })), {
                  local: b
                };
              }
            }
          };
          r.default = d;
        },
        /* 634 */
        /***/
        function(i, r, e) {
          var n = e(44), t = e(55), o = e(46), l = e(26), c = e(295), d = e(635), u = e(244), h = e(100), A = e(279), g = e(296), f = "[object Map]", p = "[object Set]", v = n ? n.iterator : void 0;
          function b(m) {
            if (!m)
              return [];
            if (l(m))
              return c(m) ? A(m) : t(m);
            if (v && m[v])
              return d(m[v]());
            var y = o(m), U = y == f ? u : y == p ? h : g;
            return U(m);
          }
          i.exports = b;
        },
        /* 635 */
        /***/
        function(i, r) {
          function e(n) {
            for (var t, o = []; !(t = n.next()).done; )
              o.push(t.value);
            return o;
          }
          i.exports = e;
        },
        /* 636 */
        /***/
        function(i, r, e) {
          var n = e(39);
          function t(o, l) {
            return n(l, function(c) {
              return o[c];
            });
          }
          i.exports = t;
        },
        /* 637 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t, o) => {
            let l = [], c = null;
            if (typeof t.getReceivers == "function") {
              const d = t.getReceivers().find((u) => u.track.kind === "audio");
              d && (l = d.getSynchronizationSources());
            } else
              c = new Error("peerConnection does not support getReceivers function");
            o && o(c, l);
          };
          r.default = n;
        },
        /* 638 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(639));
            const l = function(u) {
              this.pending = [], this._processBinding = this.maybeProcessPending.bind(this), u && this.setPeerConnection(u);
            };
            l.prototype.setPeerConnection = function(u) {
              if (this.pc)
                throw new Error("Peer connection already set");
              this.pc = u, this._forwardIceCandidate = (0, o.default)(this.pc, "addIceCandidate"), this.pc.addEventListener("signalingstatechange", this._processBinding), this.maybeProcessPending();
            }, l.prototype.canAddCandidates = function() {
              return !!(this.pc && this.pc.iceConnectionState !== "closed" && this.pc.remoteDescription && this.pc.remoteDescription.type && this.pc.localDescription && this.pc.localDescription.type);
            }, l.prototype.addIceCandidate = function(u) {
              if (this.canAddCandidates())
                return this._forwardIceCandidate(u);
              const h = this.pending;
              return new n((A, g) => {
                h.push({
                  iceCandidate: u,
                  resolve: A,
                  reject: g
                });
              });
            }, l.prototype.maybeProcessPending = function() {
              this.canAddCandidates() && this.process();
            }, l.prototype.process = function() {
              for (; this.pending.length; ) {
                const u = this.pending.shift();
                this._forwardIceCandidate(u.iceCandidate).then(u.resolve).catch(u.reject);
              }
            }, l.prototype.destroy = function() {
              this.pc && this.pc.removeEventListener("signalingstatechange", this._processBinding), this._processBinding = null, this.pc = null;
            };
            var c = l;
            r.default = c;
          }).call(this, e(2));
        },
        /* 639 */
        /***/
        function(i, r, e) {
          (function(n) {
            r.__esModule = !0, r.default = t;
            function t(o, l) {
              const c = o[l];
              return function(d) {
                return new n((u, h) => {
                  const A = c.apply(o, [d, u, h]);
                  A && typeof A.then == "function" && u(A);
                });
              };
            }
          }).call(this, e(2));
        },
        /* 640 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = h;
          var t = n(e(1)), o = n(e(3)), l = n(e(164)), c = n(e(20)), d = n(e(641));
          const u = (0, t.default)("offerProcessor");
          function h(A, g, f, p, v, b, m, y, U, B, Q, N, J) {
            const w = (O, de) => (oe) => {
              u.error(O), u.error(oe), B && B(O, oe, de);
            }, W = (O) => {
              const de = c.default.hasSendStereo(b.sdp), oe = c.default.hasSendDtx(b.sdp), fe = c.default.getAudioBitrate(b.sdp), ge = (0, l.default)(v, "local", "answer", {
                enableStereo: de,
                enableDtx: oe,
                audioBitrate: fe,
                replaceBaselineProfile: N,
                codecFlags: m,
                sourceStreamId: J
              }, O.sdp), we = new p({
                type: O.type,
                sdp: ge.local
              }), _e = {
                type: O.type,
                sdp: ge.remote
              };
              return A.setLocalDescription(we).then(() => U(_e)).catch(w("Error while setting LocalDescription", "SetLocalDescription"));
            }, G = () => A.createAnswer().then(W).catch(w("Error while setting createAnswer", "CreateAnswer")), Z = new p({
              type: b.type,
              sdp: (0, l.default)(v, "remote", "offer", {
                replaceBaselineProfile: N
              }, b.sdp).local
            }), K = w("Error while setting RemoteDescription", "SetRemoteDescription");
            return (0, d.default)(Z, y, o.default, g, f).then(() => (Q(!0), Z)).catch((O) => {
              if (Q(!1), !c.default.hasMediaType(Z.sdp, "audio"))
                throw new Error("Unsupported video without audio for fallback");
              u.debug("Couldn't set remote description", Z, O, ", trying without video");
              const de = new p({
                type: b.type,
                sdp: c.default.disableMediaType(Z.sdp, "video")
              });
              return u.debug("offer without video", de.sdp), de;
            }).then((O) => A.setRemoteDescription(O)).then(G).catch(K);
          }
        },
        /* 641 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(75)), c = (d, u, h, A, g) => {
              if (!A)
                return n.resolve(!0);
              const f = {
                iceServers: []
              };
              (0, o.default)() && (f.sdpSemantics = "plan-b");
              const p = new A(f), v = () => {
                try {
                  p.close();
                } catch {
                }
              };
              return p.setRemoteDescription(new g(d)).then(() => {
                v();
              }).catch((b) => {
                throw v(), b;
              });
            };
            r.default = c;
          }).call(this, e(2));
        },
        /* 642 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(62)), o = n(e(643));
          function l(c) {
            let d = [];
            const u = {};
            let h = {
              sentMessages: 0,
              recvMessages: 0
            };
            const A = function(p) {
              d.filter((v) => p !== v);
            }, g = function(p) {
              const v = new o.default(p);
              return d.push(v), v.on("close", () => {
                A(v);
              }), v;
            };
            return u.add = function(f, p) {
              return g(c.createDataChannel(f, p));
            }, u.addMany = function(f) {
              for (const p in f)
                f.hasOwnProperty(p) && u.add(p, f[p]);
            }, u.get = function(f, p) {
              return (0, t.default)(d, (v) => v.equals(f, p));
            }, u.getOrAdd = function(f, p) {
              let v = u.get(f, p);
              return v || (v = u.add(f, p)), v;
            }, u.getQosData = function() {
              const f = {
                sentMessages: 0,
                recvMessages: 0
              };
              return d.forEach((p) => {
                f.sentMessages += p.getQosData().sentMessages, f.recvMessages += p.getQosData().recvMessages;
              }), f;
            }, u.sampleQos = function() {
              const f = u.getQosData(), p = {
                sentMessages: f.sentMessages - h.sentMessages,
                recvMessages: f.recvMessages - h.recvMessages
              };
              return h = f, p;
            }, u.destroy = function() {
              d.forEach((f) => {
                f.close();
              }), d = [];
            }, c.addEventListener("datachannel", (f) => {
              g(f.channel);
            }), u;
          }
        },
        /* 643 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = d;
          var t = n(e(6)), o = n(e(1));
          const l = (0, o.default)("DataChannel"), c = function(h) {
            this.data = h.data, this.source = h.source, this.lastEventId = h.lastEventId, this.origin = h.origin, this.timeStamp = h.timeStamp, this.type = h.type, this.ports = h.ports, this.path = h.path;
          };
          function d(u) {
            const h = {}, A = [], g = {
              sentMessages: 0,
              recvMessages: 0
            }, f = function(Q) {
              return A.push(Q), h;
            }, p = function(Q) {
              return u.send(Q), g.sentMessages++, h;
            }, v = function() {
              let Q;
              for (; Q = A.shift(); )
                h.send(Q);
            }, b = function() {
              h.send = p, v();
            }, m = function(Q) {
              h.send = f, h.trigger("close", Q);
            }, y = function(Q) {
              l.error(Q);
            }, U = function(Q) {
              const N = new c(Q);
              g.recvMessages++, h.trigger("message", N);
            };
            return (0, t.default)(h, !0), h.label = u.label, h.id = u.id, h.reliable = u.reliable, h.negotiated = u.negotiated, h.ordered = u.ordered, h.protocol = u.protocol, h._channel = u, h.close = function() {
              u.close();
            }, h.equals = function(B, Q) {
              if (h.label !== B)
                return !1;
              for (const N in Q)
                if (Q.hasOwnProperty(N) && h[N] !== Q[N])
                  return !1;
              return !0;
            }, h.getQosData = function() {
              return g;
            }, h.send = f, u.addEventListener("open", b, !1), u.addEventListener("close", m, !1), u.addEventListener("error", y, !1), u.addEventListener("message", U, !1), h;
          }
        },
        /* 644 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = u;
          var t = n(e(9)), o = n(e(1)), l = n(e(164)), c = n(e(20));
          const d = (0, o.default)("subscribeProcessor");
          function u(h) {
            let A = h.peerConnection, g = h.NativeRTCSessionDescription, f = h.sdpTransforms, p = h.numSimulcastStreams, v = h.offerOverrides, b = h.offerConstraints, m = h.replaceBaselineProfile, y = h.removeVideoOrientation, U = h.removeUnusedCodecs;
            const B = (N, J) => (w) => {
              d.error(N, w);
              const W = new Error(N);
              throw W.reason = w, W.prefix = J, W;
            }, Q = (N) => {
              d.debug("subscribeProcessor: offer created", N);
              let J = N.sdp;
              if (U) {
                var w;
                J = c.default.removeUnusedCodecs(J, (w = A.currentLocalDescription) == null ? void 0 : w.sdp);
              }
              const W = (0, l.default)(f, "local", "offer", (0, t.default)({
                numSimulcastStreams: p,
                replaceBaselineProfile: m,
                removeVideoOrientation: y
              }, v), J), G = new g({
                type: N.type,
                sdp: W.local
              }), Z = new g({
                type: N.type,
                sdp: W.remote
              });
              return d.debug("subscribeProcessor: setting local description"), A.setLocalDescription(G).then(() => Z, B("Error while setting LocalDescription", "SetLocalDescription"));
            };
            return d.debug("subscribeProcessor: creating offer"), A.createOffer(b).then(Q, B("Error while creating Offer", "CreateOffer")).then((N) => ({
              sdp: N.sdp,
              type: N.type
            }));
          }
        },
        /* 645 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(646)), l = /* @__PURE__ */ function() {
            function c(u) {
              this.state = t.default.RESOLVED, this.offerAnswerQueue = [], this.logAnalyticsEvent = u;
            }
            var d = c.prototype;
            return d.setPending = function() {
              this.state = t.default.PENDING;
            }, d.setResolved = function() {
              this.state = t.default.RESOLVED;
              const h = this.offerAnswerQueue.shift();
              h && (this.logAnalyticsEvent("dequeueOfferAnswer", "Event"), this.setPending(), h());
            }, d.isPending = function() {
              return this.state === t.default.PENDING;
            }, d.enqueueOfferAnswer = function(h) {
              this.isPending() ? (this.offerAnswerQueue.push(h), this.logAnalyticsEvent("enqueueOfferAnswer", "Event")) : (this.setPending(), h());
            }, c;
          }();
          r.default = l;
        },
        /* 646 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {
            PENDING: "pending",
            RESOLVED: "resolved"
          };
          r.default = n;
        },
        /* 647 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(20));
          const c = l.default.MediaDirection, d = c.RECVONLY, u = c.INACTIVE, h = /* @__PURE__ */ function() {
            var g = (0, o.default)(/* @__PURE__ */ t.default.mark(function f(p, v) {
              var b, m, y;
              return t.default.wrap(function(B) {
                for (; ; ) switch (B.prev = B.next) {
                  case 0:
                    if (p) {
                      B.next = 2;
                      break;
                    }
                    return B.abrupt("return");
                  case 2:
                    return B.next = 4, p.createOffer();
                  case 4:
                    return b = B.sent, B.next = 7, p.setLocalDescription(b);
                  case 7:
                    m = p.remoteDescription.sdp, y = l.default.changeMediaDirection(m, v), p.setRemoteDescription({
                      type: p.remoteDescription.type,
                      sdp: y
                    });
                  case 10:
                  case "end":
                    return B.stop();
                }
              }, f);
            }));
            return function(p, v) {
              return g.apply(this, arguments);
            };
          }();
          var A = {
            changeMediaDirectionToInactive: (g) => h(g, u),
            changeMediaDirectionToRecvOnly: (g) => h(g, d)
          };
          r.default = A;
        },
        /* 648 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = J, r.parseStatsNewAPI = N, r.parseStatsOldAPI = Q;
          var t = n(e(1)), o = n(e(3)), l = n(e(7)), c = n(e(20)), d = n(e(299)), u = n(e(649)), h = n(e(108)), A = n(e(165));
          function g(W, G) {
            var Z = typeof Symbol != "undefined" && W[Symbol.iterator] || W["@@iterator"];
            if (Z) return (Z = Z.call(W)).next.bind(Z);
            if (Array.isArray(W) || (Z = f(W)) || G) {
              Z && (W = Z);
              var K = 0;
              return function() {
                return K >= W.length ? { done: !0 } : { done: !1, value: W[K++] };
              };
            }
            throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          function f(W, G) {
            if (W) {
              if (typeof W == "string") return p(W, G);
              var Z = Object.prototype.toString.call(W).slice(8, -1);
              if (Z === "Object" && W.constructor && (Z = W.constructor.name), Z === "Map" || Z === "Set") return Array.from(W);
              if (Z === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Z)) return p(W, G);
            }
          }
          function p(W, G) {
            (G == null || G > W.length) && (G = W.length);
            for (var Z = 0, K = new Array(G); Z < G; Z++) K[Z] = W[Z];
            return K;
          }
          const v = (0, h.default)(), b = (0, t.default)("QoS"), m = ["audioCodec", "audioSentBytes", "audioSentPackets", "audioSentPacketsLost", "audioRtt", "videoCodec", "videoHeight", "videoHeightInput", "videoSentBytes", "videoFrameRateSent", "videoSentPackets", "videoRtt", "videoSentPacketsLost", "videoWidthInput", "videoWidth", "srtpCipher"], y = ["audioCodec", "audioRecvBytes", "audioRecvPackets", "audioRecvPacketsLost", "videoCodec", "videoHeight", "videoRecvBytes", "videoRecvPackets", "videoRecvPacketsLost", "videoFrameRateReceived", "videoWidth", "srtpCipher"], U = (W, G) => b.debug(`Raw stats for peer conn ${W.id}:`, G), B = (W) => {
            const G = W.portNumber || W.port;
            return `${W.ipAddress || W.address || W.ip}:${G}`;
          };
          function Q(W, G, Z, K, L) {
            const O = (fe) => (Number(fe.stat("googFrameRateSent")) > 0 ? (Z.videoSentBytes = Number(fe.stat("bytesSent")), Z.videoSentPackets = Number(fe.stat("packetsSent")), Z.videoSentPacketsLost = Number(fe.stat("packetsLost")), Z.videoRtt = Number(fe.stat("googRtt")) / 1e3, Z.videoFrameRate = Number(fe.stat("googFrameRateInput")), Z.videoWidth = Number(fe.stat("googFrameWidthSent")), Z.videoHeight = Number(fe.stat("googFrameHeightSent")), Z.videoFrameRateSent = Number(fe.stat("googFrameRateSent")), Z.videoWidthInput = Number(fe.stat("googFrameWidthInput")), Z.videoHeightInput = Number(fe.stat("googFrameHeightInput")), Z.videoCodec = fe.stat("googCodecName"), Z.videoBandwidthLimitedResolution = fe.stat("googBandwidthLimitedResolution") === "true", Z.cpuLimitedResolution = fe.stat("googCpuLimitedResolution") === "true") : Number(fe.stat("googFrameRateReceived")) > 0 && (Z.videoRecvBytes = Number(fe.stat("bytesReceived")), Z.videoRecvPackets = Number(fe.stat("packetsReceived")), Z.videoRecvPacketsLost = Number(fe.stat("packetsLost")), Z.videoFrameRate = Number(fe.stat("googFrameRateOutput")), Z.videoFrameRateReceived = Number(fe.stat("googFrameRateReceived")), Z.videoFrameRateDecoded = Number(fe.stat("googFrameRateDecoded")), Z.videoWidth = Number(fe.stat("googFrameWidthReceived")), Z.videoHeight = Number(fe.stat("googFrameHeightReceived")), Z.videoCodec = fe.stat("googCodecName")), null), de = (fe) => {
              Number(fe.stat("audioInputLevel")) > 0 ? (Z.audioSentPackets = Number(fe.stat("packetsSent")), Z.audioSentPacketsLost = Number(fe.stat("packetsLost")), Z.audioSentBytes = Number(fe.stat("bytesSent")), Z.audioCodec = fe.stat("googCodecName"), Z.audioRtt = Number(fe.stat("googRtt")) / 1e3) : Number(fe.stat("audioOutputLevel")) > 0 && (Z.audioRecvPackets = Number(fe.stat("packetsReceived")), Z.audioRecvPacketsLost = Number(fe.stat("packetsLost")), Z.audioRecvBytes = Number(fe.stat("bytesReceived")), Z.audioCodec = fe.stat("googCodecName"));
            }, oe = (fe) => {
              if (fe.result) {
                const ge = fe.result();
                U(W, ge);
                const we = (Pe, $e) => ge.filter((Bt) => Bt.id === $e.stat(Pe))[0], _e = (Pe) => we("localCandidateId", Pe), Te = (Pe) => we("remoteCandidateId", Pe);
                for (let Pe = 0; Pe < ge.length; Pe++) {
                  const $e = ge[Pe];
                  $e.stat && ($e.stat("googActiveConnection") === "true" && ($e.stat("googChannelId").indexOf("audio") > -1 ? (Z.audioLocalAddress = $e.stat("googLocalAddress"), Z.audioRemoteAddress = $e.stat("googRemoteAddress"), Z.audioLocalCandidateType = $e.stat("googLocalCandidateType"), Z.audioRemoteCandidateType = $e.stat("googRemoteCandidateType"), Z.audioTransportType = $e.stat("googTransportType"), Z.audioLocalRelayProtocol = (0, d.default)(_e($e).stat("priority")), Z.audioRemoteRelayProtocol = (0, d.default)(Te($e).stat("priority"))) : $e.stat("googChannelId").indexOf("video") > -1 && (Z.videoLocalAddress = $e.stat("googLocalAddress"), Z.videoRemoteAddress = $e.stat("googRemoteAddress"), Z.videoLocalCandidateType = $e.stat("googLocalCandidateType"), Z.videoRemoteCandidateType = $e.stat("googRemoteCandidateType"), Z.videoTransportType = $e.stat("googTransportType"), Z.videoLocalRelayProtocol = (0, d.default)(_e($e).stat("priority")), Z.videoRemoteRelayProtocol = (0, d.default)(Te($e).stat("priority")))), Number($e.stat("googAvailableSendBandwidth")) > 0 && (Z.videoSentEstimatedBandwidth = Number($e.stat("googAvailableSendBandwidth"))), Number($e.stat("googAvailableReceiveBandwidth")) > 0 && (Z.videoRecvEstimatedBandwidth = Number($e.stat("googAvailableReceiveBandwidth"))), de($e), O($e));
                }
                "videoCodec" in Z && !Z.videoLocalAddress && ["LocalAddress", "RemoteAddress", "LocalCandidateType", "RemoteCandidateType", "TransportType", "LocalRelayProtocol", "RemoteRelayProtocol"].forEach((Pe) => {
                  Z[`video${Pe}`] = Z[`audio${Pe}`];
                });
              }
              L(null, Z);
            };
            W.getStats(oe);
          }
          function N(W, G, Z, K, L) {
            const O = function(we) {
              L(we);
            }, de = (ge, we) => {
              if (we === "outboundrtp" ? (Z.audioSentPackets = ge.packetsSent, Z.audioSentPacketsLost = ge.packetsLost, Z.audioSentBytes = ge.bytesSent) : we === "inboundrtp" && (Z.audioRecvPackets = ge.packetsReceived, Z.audioRecvPacketsLost = ge.packetsLost, Z.audioRecvBytes = ge.bytesReceived), Z.audioCodec === void 0 && ["Safari"].indexOf(l.default.env.name) !== -1 && ge.codecId !== void 0) {
                const _e = W.remoteDescription.type === "answer" ? W.remoteDescription : W.localDescription, Te = _e.sdp, Pe = ge.codecId.lastIndexOf("_"), $e = c.default.getCodecsAndCodecMap(Te, "audio");
                Pe !== -1 && $e !== void 0 && (Z.audioCodec = $e.codecMap[ge.codecId.substring(Pe + 1)]);
              }
            }, oe = (ge) => {
              const we = {
                packetsSent: "videoSentPackets",
                packetsLost: "videoSentPacketsLost",
                bytesSent: "videoSentBytes",
                framesPerSecond: "videoFrameRate",
                framesSent: "videoFrameRateSent",
                framesReceived: "videoFramesReceived",
                frameWidth: "videoWidth",
                frameHeight: "videoHeight"
              }, _e = ["videoSentPackets", "videoSentBytes"];
              for (const Te in we)
                if (Te in ge) {
                  const Pe = we[Te];
                  _e.includes(Pe) && Number.isSafeInteger(Z[Pe]) ? Z[Pe] += ge[Te] : Z[Pe] = ge[Te];
                }
            }, fe = (ge, we) => {
              const _e = () => {
                if (!("videoSentBytes" in Z ? Z.videoSentBytes > 0 : Z.videoRecvBytes > 0))
                  return 0;
                let Pe = 0;
                if (o.default.isFirefox && o.default.version < 96)
                  Pe = Number(ge.framerateMean);
                else {
                  const $e = we === "outboundrtp" ? "framesEncoded" : "framesDecoded";
                  Z[$e] = ge[$e], Pe = (0, A.default)({
                    currentStatFrames: ge[$e],
                    currentTimestamp: ge.timestamp,
                    prevStatFrames: G[$e],
                    prevTimestamp: G.timeStamp || Date.now()
                  });
                }
                return Pe;
              };
              if (we === "outboundrtp" ? (ge.hasOwnProperty("qualityLimitationReason") && (Z.videoBandwidthLimitedResolution = ge.qualityLimitationReason === "bandwidth", Z.cpuLimitedResolution = ge.qualityLimitationReason === "cpu"), oe(ge)) : we === "inboundrtp" && (Z.videoRecvPackets = ge.packetsReceived, Z.videoRecvPacketsLost = ge.packetsLost, Z.videoRecvBytes = ge.bytesReceived, Z.videoWidth = ge.frameWidth, Z.videoHeight = ge.frameHeight, Z.videoFramesReceived = ge.framesReceived), (o.default.isFirefox && ["outboundrtp", "inboundrtp"].includes(we) || !K && we === "inboundrtp") && (Z.videoFrameRate = _e()), Z.videoCodec === void 0 && ["Safari"].indexOf(l.default.env.name) !== -1 && ge.codecId !== void 0) {
                const Te = W.remoteDescription.type === "answer" ? W.remoteDescription : W.localDescription, Pe = Te.sdp, $e = ge.codecId.lastIndexOf("_"), Bt = c.default.getCodecsAndCodecMap(Pe, "video");
                $e !== -1 && Bt !== void 0 && (Z.videoCodec = Bt.codecMap[ge.codecId.substring($e + 1)]);
              }
            };
            W.getStats(null).then((ge) => {
              let we, _e, Te, Pe, $e, Bt, Le, at;
              const pt = [], kt = () => {
                if (pt.length === 0)
                  return null;
                const ft = pt.filter((Sn) => Sn > 0), It = ft.reduce((Sn, Cn) => Sn + Cn, 0);
                return ft.length ? It / ft.length : 0;
              }, _t = (ft) => ft.toLowerCase().replace(/[^a-z]/g, ""), Lt = (ft) => {
                const It = _t(ft.type), Kt = ft.id.toLowerCase();
                if (/(in|out)boundrtp$/.test(It)) {
                  const Sn = /rtp/.test(Kt), Cn = Sn && /audio/.test(Kt), on = Sn && /video/.test(Kt), An = Cn || ft.kind === "audio", Ue = on || ft.kind === "video";
                  if (An ? de(ft, It) : Ue && fe(ft, It), ft.hasOwnProperty("roundTripTime")) {
                    const ne = ft.mediaType || ft.kind;
                    ne === "video" ? pt.push(ft.roundTripTime) : ne === "audio" && (Z.audioRtt = ft.roundTripTime);
                  }
                  if (It === "remoteinboundrtp" && ft.hasOwnProperty("packetsLost")) {
                    const se = `${ft.kind}SentPacketsLost`;
                    Z[se] || (Z[se] = 0), Z[se] += ft.packetsLost;
                  }
                } else if (It === "transport") {
                  const Sn = ft.selectedCandidatePairId, Cn = ft.srtpCipher;
                  Z.srtpCipher = Cn, Sn && (Pe = (0, u.default)(Sn, ge));
                } else if (It === "localcandidate")
                  we = ft.candidateType, Te = B(ft), Bt = ft.protocol || ft.transport;
                else if (It === "remotecandidate")
                  _e = ft.candidateType, $e = B(ft);
                else if (It === "track" && Kt.indexOf("video") !== 0)
                  Le = ft.frameWidth, at = ft.frameHeight, oe(ft);
                else if (It === "mediasource")
                  ft.hasOwnProperty("framesPerSecond") && (Z.videoFrameRate = ft.framesPerSecond), ft.hasOwnProperty("width") && (Z.videoWidthInput = ft.width), ft.hasOwnProperty("height") && (Z.videoHeightInput = ft.height);
                else if (It === "candidatepair" && ft.hasOwnProperty("availableOutgoingBitrate")) {
                  const Sn = `video${K ? "Sent" : "Recv"}EstimatedBandwidth`;
                  Z[Sn] = parseInt(ft.availableOutgoingBitrate, 10);
                }
              };
              if (typeof ge[Symbol.iterator] == "function") {
                U(W, Array.from(ge));
                for (var Ft = g(ge), Zt; !(Zt = Ft()).done; ) {
                  const ft = Zt.value, It = Array.isArray(ft) ? ft[1] : ft;
                  Lt(It);
                }
              } else {
                U(W, ge);
                for (const ft in ge)
                  ge.hasOwnProperty(ft) && Lt(ge[ft]);
              }
              if (W.currentRemoteDescription && (Z.useDtx = c.default.hasSendDtx(W.currentRemoteDescription.sdp)), K && (Z.videoRtt = kt()), (Z.audioRecvBytes || Z.audioSentBytes) && (Z.audioLocalCandidateType = we, Z.audioLocalAddress = Te, Z.audioRemoteCandidateType = _e, Z.audioRemoteAddress = $e, Z.audioTransportType = Bt, Z.audioLocalRelayProtocol = Pe, Z.audioCodec === void 0)) {
                const ft = W.remoteDescription.type === "answer" ? W.remoteDescription : W.localDescription, It = ft.sdp, Kt = c.default.getCodecs(It, "audio");
                Z.audioCodec = Kt[0];
              }
              if ((Z.videoRecvBytes || Z.videoSentBytes) && (Z.videoLocalCandidateType = we, Z.videoLocalAddress = Te, Z.videoRemoteCandidateType = _e, Z.videoRemoteAddress = $e, Z.videoTransportType = Bt, Z.videoLocalRelayProtocol = Pe, Z.videoCodec === void 0)) {
                const ft = W.remoteDescription.type === "answer" ? W.remoteDescription : W.localDescription, It = ft.sdp, Kt = c.default.getCodecs(It, "video");
                Z.videoCodec = Kt[0];
              }
              w(Z, K), Z.videoWidth = Z.videoWidth || Le, Z.videoHeight = Z.videoHeight || at, L(null, Z);
            }).catch(O);
          }
          function J(W, G, Z, K, L) {
            return v ? N(W, G, Z, K, L) : Q(W, G, Z, K, L);
          }
          function w(W, G) {
            (G ? m : y).forEach((K) => {
              W.hasOwnProperty(K) || (W[K] = null);
            });
          }
        },
        /* 649 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(299)), o = (l, c) => {
            let d = "";
            if (!l || !c)
              return d;
            const u = c.get(l);
            if (u) {
              const h = u.localCandidateId;
              if (h) {
                const A = c.get(h);
                if (A) {
                  const g = A.relayProtocol, f = A.priority;
                  g ? d = `TURN/${g.toUpperCase()}` : d = (0, t.default)(f);
                }
              }
            }
            return d;
          };
          r.default = o;
        },
        /* 650 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          let n = /* @__PURE__ */ function() {
            function t() {
              this.value = null, this.changeCount = 0;
            }
            var o = t.prototype;
            return o.onValue = function(c) {
              c && c !== this.value && (this.value && (this.changeCount += 1), this.value = c);
            }, t;
          }();
          r.default = n;
        },
        /* 651 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(51)), o = n(e(3));
          const l = function(h) {
            h === void 0 && (h = {});
            const A = h.env || o.default;
            return A.name === "Chrome" && A.userAgent.toLowerCase().indexOf("android") > -1 && A.version < 65;
          };
          var d = {
            once: (0, t.default)(() => l()),
            check: l
          };
          r.default = d;
        },
        /* 652 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = function(c) {
            c === void 0 && (c = {});
            const d = c, u = d.env, h = u === void 0 ? t.default : u;
            return !!(h.isiOS && h.iOSVersion > 10);
          };
          r.default = o;
        },
        /* 653 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(41)), o = n(e(7));
          function l(c) {
            let d, u, h, A, g;
            const f = this;
            let p = c.archiving;
            const v = c.archivingStarted || "Archiving on", b = c.archivingEnded || "Archiving off";
            let m = !0;
            const y = function(Q) {
              A.nodeValue = Q, d.setAttribute("title", Q);
            }, U = function() {
              g && (clearTimeout(g), g = null), p ? o.default.addClass(u, "OT_active") : o.default.removeClass(u, "OT_active"), o.default.removeClass(f.domElement, `OT_archiving-${p ? "off" : "on"}`), o.default.addClass(f.domElement, `OT_archiving-${p ? "on" : "off"}`), c.show && p ? (y(v), o.default.addClass(h, "OT_mode-on"), o.default.removeClass(h, "OT_mode-auto"), f.setDisplayMode("on"), g = setTimeout(() => {
                o.default.addClass(h, "OT_mode-auto"), o.default.removeClass(h, "OT_mode-on");
              }, 5e3)) : c.show && !m ? (o.default.addClass(h, "OT_mode-on"), o.default.removeClass(h, "OT_mode-auto"), f.setDisplayMode("on"), y(b), g = setTimeout(() => {
                f.setDisplayMode("off");
              }, 5e3)) : f.setDisplayMode("off");
            };
            (0, t.default)(this, {
              mode: p && c.show && "on" || "off",
              nodeName: "h1",
              htmlAttributes: {
                className: "OT_archiving OT_edge-bar-item OT_edge-bottom"
              },
              onCreate() {
                d = o.default.createElement("div", {
                  className: "OT_archiving-light-box"
                }, ""), u = o.default.createElement("div", {
                  className: "OT_archiving-light"
                }, ""), d.appendChild(u), h = o.default.createElement("div", {
                  className: "OT_archiving-status OT_mode-on OT_edge-bar-item OT_edge-bottom"
                }, ""), A = document.createTextNode(""), h.appendChild(A), f.domElement.appendChild(d), f.domElement.appendChild(h), U();
              }
            }), this.setShowArchiveStatus = function(B) {
              c.show = B, f.domElement && U.call(f);
            }, this.setArchiving = function(B) {
              p = B, m = !1, f.domElement && U.call(f);
            };
          }
        },
        /* 654 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = y;
            var o = t(e(9)), l = t(e(11)), c = t(e(6)), d = t(e(1)), u = t(e(22)), h = t(e(94)), A = t(e(655)), g = t(e(28)), f = t(e(3)), p = t(e(8)), v = t(e(13)), b = t(e(168)), m = t(e(307));
            function y(U) {
              U === void 0 && (U = {});
              const B = U.env || f.default, Q = U.Errors || p.default, N = U.otError || (0, v.default)(), J = U.logging || (0, d.default)("getUserMedia"), w = U.screenSharing || (0, b.default)(), W = U.getDisplayMediaExtensionHelper || m.default, G = U.customGetUserMedia, Z = U.global || (typeof window !== void 0 ? window : Dn), K = U.analytics || new g.default(), L = Z.navigator, O = Z.location, de = () => {
                if (G)
                  return G;
                if (L.mediaDevices) {
                  var $e;
                  return ($e = L.mediaDevices).getUserMedia.bind($e);
                }
              }, oe = function() {
                const Bt = de();
                return Bt ? Bt(...arguments) : n.reject(new Error("Cannot find getUserMedia"));
              }, fe = () => {
                if (G)
                  return G;
                if (L.mediaDevices && L.getDisplayMedia)
                  return L.getDisplayMedia.bind(L);
                if (L.mediaDevices && L.mediaDevices.getDisplayMedia) {
                  var $e;
                  return ($e = L.mediaDevices).getDisplayMedia.bind($e);
                }
              }, ge = function() {
                const Bt = fe();
                return Bt ? Bt(...arguments) : n.reject(new Error("Cannot find getDisplayMedia"));
              }, we = (() => {
                const $e = {
                  name: Q.USER_MEDIA_ACCESS_DENIED,
                  message: "End-user denied permission to hardware devices"
                }, Bt = {
                  name: Q.NOT_SUPPORTED,
                  message: "A constraint specified is not supported by the browser."
                }, Le = {
                  name: Q.CONSTRAINTS_NOT_SATISFIED,
                  message: "It's not possible to satisfy one or more constraints passed into the getUserMedia function"
                }, at = {
                  name: Q.NO_DEVICES_FOUND,
                  message: "No voice or video input devices are available on this machine."
                }, pt = {
                  name: Q.HARDWARE_UNAVAILABLE,
                  message: "The selected voice or video devices are unavailable. Verify that the chosen devices are not in use by another application."
                }, kt = {
                  name: Q.UNABLE_TO_CAPTURE_SCREEN,
                  message: "Unable to capture screen. Unknown error occurred"
                }, Lt = {
                  // Spec:
                  AbortError: {
                    name: Q.UNABLE_TO_CAPTURE_MEDIA,
                    message: "Unable to capture media. Unknown error occurred"
                  },
                  NotAllowedError: $e,
                  NotFoundError: at,
                  NotReadableError: pt,
                  OverconstrainedError: Le,
                  SecurityError: (0, o.default)({}, $e, {
                    message: "End-user denied permission to hardware devices or user media support may be disabled on this page"
                  }),
                  TypeError: Le,
                  // Old errors, probably not used anymore. @todo log usage to be removed.
                  PermissionDeniedError: $e,
                  PermissionDismissedError: $e,
                  NotSupportedError: Bt,
                  ConstraintNotSatisfiedError: Le,
                  MandatoryUnsatisfiedError: Le,
                  OverConstrainedError: Le,
                  DevicesNotFoundError: at,
                  NoDevicesFoundError: at,
                  HardwareUnavailableError: pt,
                  SourceUnavailableError: pt,
                  TrackStartError: pt,
                  ScreenCaptureError: kt,
                  TabCaptureError: kt
                };
                return (0, A.default)({
                  objectToTrack: Lt,
                  keys: ["PermissionDeniedError", "PermissionDismissedError", "NotSupportedError", "ConstraintNotSatisfiedError", "MandatoryUnsatisfiedError", "OverConstrainedError", "DevicesNotFoundError", "NoDevicesFoundError", "HardwareUnavailableError", "SourceUnavailableError", "TrackStartError", "ScreenCaptureError", "TabCaptureError"],
                  onUsage(Ft) {
                    K.logEvent({
                      action: "DeprecatedPropertyUsage:getUserMedia:errorMap",
                      variation: "Event",
                      payload: {
                        key: Ft
                      }
                    });
                  }
                }), Lt;
              })(), _e = ($e, Bt) => {
                let Le = $e;
                Le === "AbortError" && typeof Bt == "string" && Bt.match(/(screen|tab).?capture/i) && (Le = "ScreenCaptureError");
                const at = we[Le];
                let pt;
                return at ? pt = N(at.name, new Error(`${at.message} (getUserMedia error: ${$e})`)) : pt = new Error(`Unknown error while getting user media: ${$e}`), pt.originalMessage = Bt, pt.originalName = $e, pt;
              }, Te = ($e) => {
                if ((0, l.default)($e) && $e.name) {
                  let Bt = $e.name, Le = $e.message;
                  if ((Le === "Cannot find getUserMedia" || Le === "Cannot find getDisplayMedia") && (B.name === "Chrome" && B.version > 73 && Z.location.protocol !== "https:" ? Bt = "NotAllowedError" : Bt = "NotSupportedError"), B.name === "Safari" && Bt === "Error") {
                    const kt = Object.prototype.toString.call($e).match(/^\[object (\w+Error)\]$/);
                    kt && (Bt = kt[1]);
                  }
                  const at = _e(Bt, Le);
                  return at.constraintName = $e.constraint || $e.constraintName, at instanceof u.default || K.logEvent({
                    action: "UnexpectedError:getUserMedia:parseErrorEvent",
                    variation: "Event",
                    payload: {
                      name: at.name,
                      message: at.message,
                      originalMessage: at.originalMessage
                    }
                  }), at;
                }
                if (typeof $e == "string") {
                  const Bt = _e($e);
                  return K.logEvent({
                    action: "CheckUnreachable:getUserMedia:parseErrorEvent",
                    variation: "Event",
                    payload: {
                      info: "error is string",
                      error: $e
                    }
                  }), Bt;
                }
                return K.logEvent({
                  action: "CheckUnreachable:getUserMedia:parseErrorEvent",
                  variation: "Event",
                  payload: {
                    info: "error was not string or object with name property",
                    error: $e
                  }
                }), new Error("Unknown error type while getting media");
              }, Pe = function(Bt) {
                if (!Bt || !(0, l.default)(Bt))
                  return !0;
                for (const Le in Bt)
                  if (Bt.hasOwnProperty(Le) && Bt[Le])
                    return !1;
                return !0;
              };
              return function($e, Bt) {
                if (Bt === void 0 && (Bt = !1), J.debug("getUserMedia wrapper called with", $e), Pe($e))
                  return J.error("Couldn't get UserMedia: All constraints were false"), (0, c.default)(n.reject(N(Q.NO_VALID_CONSTRAINTS, new Error("Video and Audio was disabled, you need to enable at least one"))));
                const Le = Bt && W.isSupportedInThisBrowser ? ge : oe, at = (0, c.default)(Le($e).catch((Lt) => {
                  const Ft = Te(Lt);
                  if (Ft.name === Q.UNABLE_TO_CAPTURE_SCREEN)
                    return new n((Zt, ft) => {
                      w.checkCapability((It) => {
                        if (It.extensionRequired === "chrome") {
                          if (It.extensionRegistered && !It.extensionInstalled) {
                            const Kt = N(Q.SCREEN_SHARING_EXTENSION_NOT_INSTALLED, Ft);
                            Kt.message = "Screen sharing extension not installed see https://tokbox.com/developer/guides/screen-sharing/js/#chrome-extension", ft(Kt);
                          } else if (!It.extensionRegistered) {
                            const Kt = N(Q.SCREEN_SHARING_EXTENSION_NOT_REGISTERED, Ft);
                            Kt.message = "Screen sharing extension not registered see https://tokbox.com/developer/guides/screen-sharing/js/#chrome-extension", ft(Kt);
                          }
                        } else
                          ft(Ft);
                      });
                    });
                  throw Ft;
                }).then((Lt) => (J.debug("got stream:", {
                  stream: Lt,
                  tracks: Lt.getTracks(),
                  trackLabels: Lt.getTracks().map((Ft) => Ft.label)
                }), Lt))), pt = O.protocol.indexOf("https") !== -1 ? 500 : 100;
                let kt = !0;
                const _t = () => {
                  kt = !1;
                };
                return at.then(_t, _t), (0, h.default)(pt).then(() => {
                  if (!kt)
                    return;
                  const Lt = () => {
                    at.emit("accessDialogClosed");
                  };
                  at.emit("accessDialogOpened"), at.then(Lt, Lt);
                }), at;
              };
            }
          }).call(this, e(2));
        },
        /* 655 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = function(o) {
            let l = o === void 0 ? {} : o, c = l.objectToTrack, d = l.keys, u = l.onUsage;
            if (!Array.isArray(d) && d !== void 0)
              throw new Error("keys must be an array, or undefined");
            if (typeof u != "function")
              throw new Error("onUsage must be a function");
            if (c == null)
              throw new Error("Expected objectToTrack to be a trackable object");
            Object.keys(c).forEach((h) => {
              if (d !== void 0 && d.indexOf(h) === -1)
                return;
              let A = c[h];
              Object.defineProperty(c, h, {
                get() {
                  return u(h), A;
                },
                set(g) {
                  A = g, u(h, A);
                },
                enumerable: !0
              });
            });
          };
          r.default = n;
        },
        /* 656 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = p;
          var t = n(e(3)), o = n(e(657)), l = n(e(282));
          const c = o.default.isCallbackBasedAPI;
          let d = l.default, u = null;
          const h = (v, b) => {
            u.getSources(v, b);
          }, A = (v, b) => {
            u.getSources(v).then((m) => {
              b(void 0, m);
            }, b);
          }, g = () => c ? h : A, f = (v, b) => {
            g()({
              types: [v]
            }, (y, U) => {
              if (y) {
                b(y);
                return;
              }
              const B = U[0];
              if (!B) {
                b(new Error("Could not find Electron source for screensharing"));
                return;
              }
              const Q = {
                audio: !1,
                video: {
                  mandatory: {
                    chromeMediaSource: v,
                    chromeMediaSourceId: B.id
                  }
                }
              };
              b(void 0, Q);
            });
          };
          function p(v) {
            v === void 0 && (v = {});
            try {
              const b = () => {
                let y = typeof window !== void 0 ? window : Dn;
                for (; typeof y.require != "function" && y.parent && y.parent !== y; )
                  y = y.parent;
                return y;
              }, m = () => {
                const y = b();
                return (y.require ? y.require("electron") : y.electron).desktopCapturer;
              };
              u = v.desktopCapturer || // Don't try to import unless in electron environment, else `require` will
              // dispatch an error message if `electron` is not found
              (t.default.isElectron ? m() : null), d = v.isElectronScreenSharingSource || d;
            } catch {
            }
            return {
              isSupportedInThisBrowser: u !== null,
              autoRegisters: !0,
              extensionRequired: !1,
              getConstraintsShowsPermissionUI: !1,
              sources: {
                screen: !0,
                application: !0,
                window: !0,
                browser: !0
              },
              register: () => ({
                isInstalled: (b) => b(!0),
                getConstraints(b, m, y) {
                  d(b) ? y(void 0, {
                    audio: !0,
                    video: !1
                  }) : f(b, y);
                }
              })
            };
          }
        },
        /* 657 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3));
          const o = t.default.version < 78;
          var c = {
            isCallbackBasedAPI: o,
            isPromiseBasedAPI: !o
          };
          r.default = c;
        },
        /* 658 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(166)), c = {
            isSupportedInThisBrowser: t.default.isFirefox ? !o.default : !1,
            autoRegisters: !0,
            extensionRequired: !1,
            extensionInstalled: !1,
            getConstraintsShowsPermissionUI: !1,
            sources: {
              screen: !0,
              application: !1,
              window: !0,
              browser: !1
            },
            register() {
              return {
                isInstalled(d) {
                  d(typeof OTScreenSharing == "object");
                },
                getConstraints(d, u, h) {
                  u.video = {
                    mediaSource: d
                  }, u.browserWindow && (u.video.browserWindow = u.browserWindow, delete u.browserWindow), typeof u.scrollWithPage != "undefined" && (u.video.scrollWithPage = u.scrollWithPage, delete u.scrollWithPage), h(void 0, u);
                }
              };
            }
          };
          r.default = c;
        },
        /* 659 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = G;
          var t = n(e(4)), o = n(e(5)), l = n(e(155)), c = n(e(308)), d = n(e(9)), u = n(e(143)), h = n(e(40)), A = n(e(6)), g = n(e(1)), f = n(e(3)), p = e(309), v = n(e(660)), b = n(e(310)), m = n(e(13)), y = n(e(8)), U = n(e(156)), B = n(e(281)), Q = n(e(271)), N = n(e(168)), J = n(e(661));
          const w = (0, m.default)(), W = "getUserMedia request was aborted";
          function G(Z) {
            Z === void 0 && (Z = {}), ["deviceHelpers", "getUserMediaHelper"].forEach((Pe) => {
              (0, l.default)(Z[Pe], `${Pe} dependency must be injected into processPubOptions`);
            });
            const K = Z.generateConstraintInfo || Q.default, L = Z.global || (typeof window !== void 0 ? window : Dn), O = Z.logging || (0, g.default)("processPubOptions"), de = Z.navigator || L.navigator, oe = Z.screenSharing || (0, N.default)(), fe = Z.env || f.default, ge = (0, J.default)({
              navigator: de || {}
            }), we = Z, _e = we.deviceHelpers, Te = we.getUserMediaHelper;
            return (Pe, $e, Bt) => {
              var Le, at, pt;
              const kt = (0, v.default)(Pe, $e, O), _t = (0, U.default)(kt.videoSource), Lt = (0, b.default)(kt.audioSource), Ft = (0, b.default)(kt.videoSource), Zt = !Lt && kt.audioSource !== null, ft = !Ft && kt.videoSource !== null, It = Zt || ft, Kt = (se) => typeof se == "boolean", Sn = !_t || Lt || B.default, Cn = (0, u.default)(kt, {
                mirror: !_t && !Ft,
                publishAudio: !0,
                publishVideo: !0,
                showControls: !0,
                fitMode: _t ? "contain" : "cover",
                insertDefaultUI: !0,
                enableRenegotiation: !1,
                enableStereo: !1,
                enableDtx: !1,
                disableAudioProcessing: !1,
                echoCancellation: !0,
                noiseSuppression: !0,
                autoGainControl: !0
              }), on = kt.audioFallback, An = on === void 0 ? {} : on, Ue = kt.audioFallbackEnabled;
              if (Cn.publisherAudioFallbackEnabled = (Le = An.publisher) != null ? Le : !1, Cn.subscriberAudioFallbackEnabled = (at = (pt = An.subscriber) != null ? pt : Ue) != null ? at : !_t, Cn.videoContentHint !== void 0 && !(0, p.isValidVideoContentHint)(Cn.videoContentHint) && (O.warn(`${$e}: Invalid content hint. Valid content hints are "text", "detail", "motion", or ""`), Cn.videoContentHint = ""), Cn.name && (Cn.name = String(Cn.name)), Kt(Cn.enableDtx) || (Cn.enableDtx = !1), Kt(Cn.enableStereo) || (Cn.enableStereo = !1), Cn.initials && (typeof Cn.initials != "string" && (Cn.initials = ""), Cn.initials.length > 2 && (Cn.initials = "", O.warn("Publisher initials cleared. Only one or two characters allowed for publisher initials.")), Cn.initials = Cn.initials.toUpperCase()), Cn.constraints)
                O.warn(`${$e}: You have passed your own constraints not using ours`);
              else {
                const se = K(Object.assign({
                  isScreenSharing: _t,
                  isCustomAudioTrack: Lt,
                  isCustomVideoTrack: Ft
                }, (0, h.default)(Cn, ["audioSource", "publishAudio", "videoSource", "publishVideo", "resolution", "maxResolution", "frameRate", "facingMode", "enableRenegotiation", "enableStereo", "disableAudioProcessing", "echoCancellation", "noiseSuppression", "autoGainControl"]), {
                  env: fe,
                  usingOptionalMandatoryStyle: ge(_t)
                }));
                (0, d.default)(Cn, se);
              }
              const ne = {
                isScreenSharing: _t,
                isCustomAudioTrack: Lt,
                isCustomVideoTrack: Ft,
                shouldAllowAudio: Sn,
                properties: Cn
              };
              return (0, A.default)(ne), ne.getUserMedia = /* @__PURE__ */ (0, o.default)(/* @__PURE__ */ t.default.mark(function se() {
                var Ce, At, Ge, Ye, Qt, tn, vn, Yt, Tn;
                return t.default.wrap(function(lr) {
                  for (; ; ) switch (lr.prev = lr.next) {
                    case 0:
                      if (Ce = function() {
                        for (var pi = arguments.length, $n = new Array(pi), rr = 0; rr < pi; rr++)
                          $n[rr] = arguments[rr];
                        return ne.emit("accessDialogOpened", ...$n);
                      }, At = function() {
                        for (var pi = arguments.length, $n = new Array(pi), rr = 0; rr < pi; rr++)
                          $n[rr] = arguments[rr];
                        return ne.emit("accessDialogClosed", ...$n);
                      }, It) {
                        lr.next = 7;
                        break;
                      }
                      return Ge = new L.MediaStream(), Lt && Ge.addTrack(kt.audioSource), Ft && Ge.addTrack(kt.videoSource), lr.abrupt("return", Ge);
                    case 7:
                      if (!_t) {
                        lr.next = 15;
                        break;
                      }
                      return lr.next = 10, oe.getConstraints({
                        onAccessDialogOpened: Ce,
                        onAccessDialogClosed: At,
                        videoSource: kt.videoSource,
                        constraints: Cn.constraints
                      });
                    case 10:
                      if (Cn.constraints = lr.sent, !Bt()) {
                        lr.next = 13;
                        break;
                      }
                      throw w(y.default.CANCEL, new Error(W));
                    case 13:
                      lr.next = 25;
                      break;
                    case 15:
                      return lr.next = 17, _e.shouldAskForDevices();
                    case 17:
                      if (Ye = lr.sent, !Bt()) {
                        lr.next = 20;
                        break;
                      }
                      throw w(y.default.CANCEL, new Error(W));
                    case 20:
                      O.debug(`${$e}: shouldAskForDevices:`, Ye), Ye.video || (O.warn(`${$e}: Setting video constraint to false, there are no video sources`), Cn.constraints.video = !1), Ye.audio || (O.warn(`${$e}: Setting audio constraint to false, there are no audio sources`), Cn.constraints.audio = !1), ne.videoDevices = Ye.videoDevices, ne.audioDevices = Ye.audioDevices;
                    case 25:
                      if (Qt = Cn.constraints, O.debug(`${$e}: onConstraintsFound`, Qt), !Bt()) {
                        lr.next = 29;
                        break;
                      }
                      throw w(y.default.CANCEL, new Error(W));
                    case 29:
                      return tn = "Failed to acquire functional stream, this might be caused by the following iOS bug: https://bugs.webkit.org/show_bug.cgi?id=188088", vn = "Failed to acquire functional stream, this might be caused by the following iOS bug: https://bugs.webkit.org/show_bug.cgi?id=204106", Yt = (Br) => Br.originalName === "NotReadableError" && Br.originalMessage === "Failed starting capture of a video track", Tn = /* @__PURE__ */ function() {
                        var Br = (0, o.default)(/* @__PURE__ */ t.default.mark(function pi() {
                          var $n, rr, Kr, Bi, Li;
                          return t.default.wrap(function(Yr) {
                            for (; ; ) switch (Yr.prev = Yr.next) {
                              case 0:
                                return $n = Te(Qt, _t), $n.on("accessDialogOpened", Ce), $n.on("accessDialogClosed", At), Yr.prev = 3, Yr.next = 6, $n;
                              case 6:
                                if (rr = Yr.sent, !(fe.isiOS && Cn.publishVideo && rr.getVideoTracks().length && rr.getVideoTracks()[0].readyState === "ended")) {
                                  Yr.next = 11;
                                  break;
                                }
                                throw rr.getTracks().forEach((Qo) => Qo.stop()), Kr = new Error(tn), Kr;
                              case 11:
                                return Yr.abrupt("return", rr);
                              case 14:
                                if (Yr.prev = 14, Yr.t0 = Yr.catch(3), !fe.isiOS) {
                                  Yr.next = 34;
                                  break;
                                }
                                if (!(Yt(Yr.t0) && fe.iOSVersion >= 13 && fe.iOSVersion < 13.4)) {
                                  Yr.next = 32;
                                  break;
                                }
                                return Yr.prev = 18, Bi = Te({
                                  audio: !0,
                                  video: !1
                                }, !1), Yr.next = 22, Bi;
                              case 22:
                                Li = Yr.sent, Li.getTracks().forEach((Qo) => Qo.stop()), Yr.next = 29;
                                break;
                              case 26:
                                Yr.prev = 26, Yr.t1 = Yr.catch(18), O.debug(`${$e}: error disposing audio track`, Yr.t1);
                              case 29:
                                throw new Error(vn);
                              case 32:
                                if (Yr.t0.name !== y.default.HARDWARE_UNAVAILABLE) {
                                  Yr.next = 34;
                                  break;
                                }
                                throw new Error(tn);
                              case 34:
                                throw Yr.t0;
                              case 35:
                                return Yr.prev = 35, setTimeout(() => {
                                  $n.off("accessDialogOpened", Ce), $n.off("accessDialogClosed", At);
                                }), Yr.finish(35);
                              case 38:
                              case "end":
                                return Yr.stop();
                            }
                          }, pi, null, [[3, 14, 35, 38], [18, 26]]);
                        }));
                        return function() {
                          return Br.apply(this, arguments);
                        };
                      }(), lr.next = 35, (0, c.default)(Tn, (Br, pi) => [
                        // Detected the iOS new window bug. Need try again.
                        // https://jira.vonage.com/browse/OPENTOK-37691
                        // https://bugs.webkit.org/show_bug.cgi?id=188088
                        // Fixed 4th Dec 2018 - unsure which Safari versions are fixed
                        tn,
                        // https://jira.vonage.com/browse/OPENTOK-39914
                        vn
                      ].includes(Br.message) && pi === 1 && !Bt() ? 1e3 : !1)();
                    case 35:
                      if (Ge = lr.sent, !Bt()) {
                        lr.next = 39;
                        break;
                      }
                      throw Ge.getTracks().forEach((Br) => {
                        Br.stop();
                      }), w(y.default.CANCEL, new Error(W));
                    case 39:
                      return Lt && Ge.addTrack(kt.audioSource), Ft && Ge.addTrack(kt.videoSource), lr.abrupt("return", Ge);
                    case 42:
                    case "end":
                      return lr.stop();
                  }
                }, se);
              })), ne;
            };
          }
        },
        /* 660 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(42)), o = n(e(3)), l = n(e(310)), d = (u, h, A) => {
            const g = u && typeof u == "object" ? (0, t.default)(u) : {};
            if (g.audioSource === !1 && (g.audioSource = null), g.videoSource === !1 && (g.videoSource = null), g.minVideoBitrate !== void 0 && !(typeof g.minVideoBitrate == "number" && g.minVideoBitrate > 0) && (A.warn(`${h}: Invalid minVideoBitrate in publisher properties. minVideoBitrate must be a positive number`), delete g.minVideoBitrate), g.audioBitrate !== void 0 && !(g.audioBitrate >= 6 * 1e3 && g.audioBitrate <= 510 * 1e3) && (A.warn(`${h}: Invalid audioBitrate in publisher properties. audioBitrate must be a number between ${6 * 1e3} and ${510 * 1e3} bits per second`), delete g.audioBitrate), o.default.name === "Firefox" && o.default.version < 49) {
              const f = "Firefox 48 and below";
              (0, l.default)(g.audioSource) && (g.audioSource = null, A.warn(`${h}: Cannot use custom tracks with ${f}. Setting audioSource to null`)), (0, l.default)(g.videoSource) && (g.videoSource = null, A.warn(`${h}: Cannot use custom tracks with ${f}. Setting videoSource to null`));
            }
            return g;
          };
          r.default = d;
        },
        /* 661 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = d;
          var t = n(e(3)), o = n(e(280));
          const l = t.default.name, c = t.default.version;
          function d(u) {
            let h = u === void 0 ? {} : u, A = h.navigator, g = A === void 0 ? window.navigator : A;
            return function(p) {
              return (
                // screen sharing should not be optionalMandatory in later chome or FF or chromium edge
                // see https://bugzilla.mozilla.org/show_bug.cgi?id=1321221 for firefox getDisplayMedia
                // see https://w3c.github.io/mediacapture-screen-share/#displaymediastreamconstraints for updated getDisplayMedia
                // see https://blog.addpipe.com/standards-compliant-screen-capture-in-chrome-72/ chrome constraint info
                p && !o.default || // Internet Explorer
                !(g.mediaDevices && g.mediaDevices.getUserMedia) || // Chrome <=60 doesn't accept ideal constraints and advanced
                // constraints are ignored by Firefox and broken by adapter.js
                // so we revert to optional/mandatory style. This has been
                // updated in Chrome 61.
                // See OPENTOK-32149, OPENTOK-32129 and OPENTOK-32655
                // Fixed in adapter.js: https://github.com/webrtc/adapter/issues/553
                l === "Chrome" && c < 61
              );
            };
          }
        },
        /* 662 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(1));
          function o(l) {
            l === void 0 && (l = {}), ["processPubOptions"].forEach((A) => {
              if (!l[A])
                throw new Error(`${A} dependency must be injected into OT.getUserMedia`);
            });
            const c = l.logging || (0, t.default)("getUserMedia"), d = l, u = d.processPubOptions;
            return function(g) {
              return g === void 0 && (g = {}), u(g, "OT.getUserMedia", () => !1).getUserMedia().catch((p) => {
                throw c.error(`OT.getUserMedia failed to getUserMedia: ${p}`), p;
              });
            };
          }
        },
        /* 663 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = n(e(1)), l = n(e(76)), c = e(25);
          const d = (0, o.default)("AudioFallbackState");
          var h = function(g) {
            g === void 0 && (g = {});
            const f = g.logAnalyticsEvent, p = new t.default();
            let v = c.CongestionLevels.LOW, b = l.default.ACTIVE_VIDEO;
            const m = function(w, W) {
              var G, Z;
              W === void 0 && (W = {}), f("congestionLevelChanged", "Event", W.payload, {
                congestionLevel: w,
                algorithm: W.algorithm,
                audioPL: W.audioPacketLoss,
                videoPL: W.videoPacketLoss,
                videoSentEstimatedBandwidth: parseInt(W.bandwidth, 10),
                videoHeight: (G = W.resolution) == null ? void 0 : G.height,
                videoWidth: (Z = W.resolution) == null ? void 0 : Z.width
              });
            }, y = (J) => {
              b = J, p.emit("stateChange", {
                state: J
              });
            }, U = () => {
              v = c.CongestionLevels.LOW, y(l.default.ACTIVE_VIDEO);
            }, B = () => {
              v === c.CongestionLevels.LOW && y(l.default.ACTIVE_VIDEO_WITH_WARNING), v = c.CongestionLevels.MEDIUM;
            }, Q = () => {
              v = c.CongestionLevels.CRITICAL, y(l.default.SUSPENDED_VIDEO);
            }, N = {
              [c.CongestionLevels.LOW]: U,
              [c.CongestionLevels.MEDIUM]: B,
              [c.CongestionLevels.CRITICAL]: Q
            };
            return Object.assign(p, {
              setCongestionLevel(J, w) {
                if (v === J)
                  return;
                const W = N[J];
                W ? (W(w), m(J, w)) : d.warn(`Invalid congestion level: ${J}`);
              },
              getState() {
                return {
                  videoState: b,
                  congestionLevel: v
                };
              },
              setInternalState(J) {
                b = J.videoState, v = J.congestionLevel;
              },
              reset() {
                v = c.CongestionLevels.LOW, b = l.default.ACTIVE_VIDEO;
              }
            });
          };
          r.default = h;
        },
        /* 664 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(665)), o = n(e(14)), l = n(e(666)), c = n(e(667)), d = n(e(313)), u = n(e(314)), h = n(e(669)), A = e(25), g = n(e(670)), p = function(b) {
            b === void 0 && (b = {});
            const m = new o.default(), y = b, U = y.getStats, B = y.createMovingAverageTracker, Q = B === void 0 ? u.default : B, N = y.createTimeBasedCongestionLevel, J = N === void 0 ? l.default : N, w = y.createBasicCongestionLevel, W = w === void 0 ? c.default : w, G = y.createCongestionLevelStats, Z = G === void 0 ? d.default : G, K = y.getFairQualityBandwidthForResolution, L = K === void 0 ? h.default : K, O = J(), de = W(), oe = Q(), fe = Q(), ge = Q();
            let we;
            const _e = (0, g.default)(), Te = () => oe.getDataPointCount() === 0 ? A.LOW : O.getLevel({
              audioPacketLoss: oe.getMovingAverageValue()
            }), Pe = () => ge.getDataPointCount() === 0 || oe.getDataPointCount() === 0 ? A.LOW : de.getLevel({
              bandwidth: ge.getMovingAverageValue(),
              audioPacketLoss: oe.getMovingAverageValue(),
              bandwidthFairThreshold: L(we)
            }), $e = (_t) => {
              let Lt = _t.audioPacketLoss, Ft = _t.videoPacketLoss, Zt = _t.bandwidth;
              _e.addData({
                timestamp: Date.now(),
                rawAudioPL: Lt.toFixed(3),
                rawVideoPL: Ft.toFixed(3),
                rawBW: parseInt(Zt, 10),
                videoWidth: we.width,
                videoHeight: we.height,
                avgAudioPL: oe.getMovingAverageValue().toFixed(3),
                avgVideoPL: fe.getMovingAverageValue().toFixed(3),
                avgBW: parseInt(ge.getMovingAverageValue(), 10)
              });
            }, Bt = (_t) => {
              let Lt = _t.timeLevel, Ft = _t.basicLevel;
              return Ft === Lt ? "basic,timeBased" : Ft > Lt ? "basic" : "timeBased";
            }, Le = (_t) => {
              let Lt = _t.congestionLevel, Ft = _t.timeLevel, Zt = _t.basicLevel;
              if (Lt !== A.LOW)
                return {
                  resolution: we,
                  algorithm: Bt({
                    timeLevel: Ft,
                    basicLevel: Zt
                  }),
                  videoPacketLoss: fe.getMovingAverageValue(),
                  audioPacketLoss: oe.getMovingAverageValue(),
                  bandwidth: ge.getMovingAverageValue(),
                  payload: _e.getCsvString()
                };
            }, at = () => {
              const _t = Te(), Lt = Pe(), Ft = Math.max(_t, Lt);
              m.emit("congestionLevel", Ft, Le({
                congestionLevel: Ft,
                timeLevel: _t,
                basicLevel: Lt
              }));
            }, pt = (_t) => {
              let Lt = _t.audioPacketLoss, Ft = _t.videoPacketLoss, Zt = _t.bandwidth, ft = _t.videoResolution;
              we && !(0, t.default)(we, ft) && (oe.reset(), fe.reset(), ge.reset()), we = ft, ge.addValue(Zt), fe.addValue(Ft), oe.addValue(Lt), $e({
                audioPacketLoss: Lt,
                videoPacketLoss: Ft,
                bandwidth: Zt
              }), at();
            }, kt = Z(U);
            return kt.on("statsAvailable", (_t) => {
              pt(_t);
            }), Object.assign(m, {
              start() {
                kt.start();
              },
              stop() {
                kt.stop(), _e.reset();
              }
            });
          };
          r.default = p;
        },
        /* 665 */
        /***/
        function(i, r, e) {
          var n = e(138);
          function t(o, l) {
            return n(o, l);
          }
          i.exports = t;
        },
        /* 666 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(171)), o = e(25), c = function(u) {
            u === void 0 && (u = {});
            const h = Object.assign({}, t.default, u);
            let A = !1, g;
            return {
              getLevel(f) {
                if (f.audioPacketLoss < h.packetLossCriticalThreshold)
                  return A = !1, o.LOW;
                const v = Date.now();
                return A || (g = v, A = !0), v > g + h.criticalCongestionPeriod ? o.CRITICAL : v > g + h.criticalCongestionPeriod / 2 ? o.MEDIUM : o.LOW;
              }
            };
          };
          r.default = c;
        },
        /* 667 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(171)), o = e(25), c = function(u) {
            u === void 0 && (u = {});
            const h = Object.assign({}, t.default, u);
            return {
              getLevel(A) {
                let g = A.bandwidth, f = A.audioPacketLoss, p = A.bandwidthFairThreshold, v;
                if (g <= 0)
                  return f > h.packetLossCriticalThresholdMediumBw ? v = o.CRITICAL : v = o.LOW, v;
                if (g >= p ? v = o.LOW : g >= h.bandwidthCriticalThreshold ? g >= (h.bandwidthCriticalThreshold + p) / 2 ? f > h.packetLossCriticalThresholdMediumBw * 2 ? v = o.CRITICAL : v = o.MEDIUM : f > h.packetLossCriticalThresholdMediumBw ? v = o.CRITICAL : v = o.MEDIUM : f > h.packetLossCriticalThreshold ? v = o.CRITICAL : v = o.MEDIUM, v === void 0)
                  throw new Error("undefined congestion level");
                return v;
              }
            };
          };
          r.default = c;
        },
        /* 668 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.parseStats = r.getVideoResolution = r.getVideoPacketStats = r.getVideoPacketLoss = r.getSelectedCandidatePairId = r.getBandwidth = r.getAudioPacketStats = r.getAudioPacketLoss = void 0;
          const n = (v, b) => {
            const m = v.filter((J) => {
              let w = J.type, W = J.kind;
              return w === "outbound-rtp" && W === b;
            }), y = v.filter((J) => {
              let w = J.type, W = J.kind;
              return w === "remote-inbound-rtp" && W === b;
            }), U = y[0].timestamp, B = y[0].fractionLost, Q = m.reduce((J, w) => J + w.packetsSent, 0), N = y.reduce((J, w) => J + w.packetsLost, 0);
            return {
              [`${b}ReportTimestamp`]: U,
              [`${b}PacketsSent`]: Q,
              [`${b}PacketsLost`]: N,
              [`${b}FractionLost`]: B
            };
          }, t = (v) => v.filter((y) => {
            let U = y.type, B = y.kind;
            return U === "outbound-rtp" && B === "video";
          }).filter((y) => y.frameHeight !== void 0 && y.frameWidth !== void 0).reduce((y, U) => ({
            width: Math.max(y.width, U.frameWidth),
            height: Math.max(y.height, U.frameHeight)
          }), {
            width: 0,
            height: 0
          });
          r.getVideoResolution = t;
          const o = (v) => n(v, "audio");
          r.getAudioPacketStats = o;
          const l = (v) => n(v, "video");
          r.getVideoPacketStats = l;
          const c = (v) => {
            const b = v.find((m) => m.type === "transport");
            return b == null ? void 0 : b.selectedCandidatePairId;
          };
          r.getSelectedCandidatePairId = c;
          const d = (v, b) => {
            if (b) {
              const m = v.find((y) => {
                let U = y.id, B = y.type;
                return U === b && B === "candidate-pair";
              });
              return m == null ? void 0 : m.availableOutgoingBitrate;
            }
          }, u = (v) => {
            const b = d(v, c(v));
            if (b !== void 0)
              return b;
            const m = v.find((y) => {
              let U = y.type, B = y.availableOutgoingBitrate;
              return U === "candidate-pair" && B !== void 0;
            });
            return m == null ? void 0 : m.availableOutgoingBitrate;
          };
          r.getBandwidth = u;
          const h = (v) => {
            const b = o(v), m = b.audioPacketsSent, y = b.audioPacketsLost, U = b.audioReportTimestamp, B = b.audioFractionLost, Q = l(v), N = Q.videoPacketsSent, J = Q.videoPacketsLost, w = Q.videoReportTimestamp, W = u(v), G = t(v);
            return {
              bandwidth: W,
              audioFractionLost: B,
              audioReportTimestamp: U,
              audioPacketsSent: m,
              audioPacketsLost: y,
              videoReportTimestamp: w,
              videoPacketsSent: N,
              videoPacketsLost: J,
              videoResolution: G
            };
          };
          r.parseStats = h;
          const A = (v, b) => b === 0 ? 0 : v / b, g = (v, b, m) => {
            const y = b[`${v}PacketsSent`] - m[`${v}PacketsSent`], U = b[`${v}PacketsLost`] - m[`${v}PacketsLost`];
            return A(U, y);
          }, f = (v, b) => g("audio", v, b);
          r.getAudioPacketLoss = f;
          const p = (v, b) => g("video", v, b);
          r.getVideoPacketLoss = p;
        },
        /* 669 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = [{
            width: "320",
            height: "180",
            fairQualityBitrate: 12e4
          }, {
            width: "320",
            height: "240",
            fairQualityBitrate: 12e4
          }, {
            width: "352",
            height: "288",
            fairQualityBitrate: 125e3
          }, {
            width: "480",
            height: "270",
            fairQualityBitrate: 125e3
          }, {
            width: "640",
            height: "360",
            fairQualityBitrate: 15e4
          }, {
            width: "640",
            height: "480",
            fairQualityBitrate: 15e4
          }, {
            width: "960",
            height: "540",
            fairQualityBitrate: 15e4
          }, {
            width: "1280",
            height: "720",
            fairQualityBitrate: 4e5
          }, {
            width: "1920",
            height: "1080",
            fairQualityBitrate: 5e5
          }].sort((d, u) => d.fairQualityBitrate - u.fairQualityBitrate), t = 25e4, o = n.reduce((d, u) => {
            let h = u.fairQualityBitrate;
            return Math.max(d, h);
          }, t);
          var c = (d) => {
            var u;
            let h = d.width, A = d.height;
            return !h || !A ? t : ((u = n.find((f) => {
              let p = f.height, v = f.width;
              return A * h <= p * v;
            })) == null ? void 0 : u.fairQualityBitrate) || o;
          };
          r.default = c;
        },
        /* 670 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(40));
          const o = ["timestamp", "rawAudioPL", "rawVideoPL", "rawBW", "videoWidth", "videoHeight", "avgAudioPL", "avgVideoPL", "avgBW"];
          var c = function(u) {
            u === void 0 && (u = 10);
            let h = [];
            return {
              addData(A) {
                h.push((0, t.default)(A, o)), h.length > u && h.shift();
              },
              reset() {
                h = [];
              },
              getCsvString() {
                const A = h.map((g) => o.map((p) => g[p]).join(","));
                return [o.join(","), ...A].join(`\r
`);
              }
            };
          };
          r.default = c;
        },
        /* 671 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = n(e(672)), l = e(25), c = n(e(315)), u = function(A) {
            A === void 0 && (A = {});
            const g = new t.default(), f = A, p = f.getStats, v = f.setVideoActive, b = f.createNetworkProbe, m = b === void 0 ? o.default : b;
            let y, U;
            const B = () => {
              var N, J;
              (N = y) == null || N.removeAllListeners(), clearTimeout(U), (J = y) == null || J.stop(), y = void 0;
            };
            return Object.assign(g, {
              start: function(J) {
                let w = J === void 0 ? {} : J, W = w.getDelayForProbeNumber, G = W === void 0 ? c.default : W;
                y && B(), y = m({
                  getStats: p
                });
                let Z = 0;
                const K = () => {
                  const L = G(Z);
                  Z++, U = setTimeout(() => {
                    v(!0), y.start();
                  }, L);
                };
                y.on("probeResult", (L) => {
                  L === l.LOW ? g.emit("networkRecovered") : (v(!1), K());
                }), K();
              },
              stop: B
            });
          };
          r.default = u;
        },
        /* 672 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = n(e(673)), l = e(25), c = n(e(1)), d = e(110);
          const u = (0, c.default)("networkProbe"), h = 10 * d.ONE_SECOND_IN_MS;
          var g = function(p) {
            p === void 0 && (p = {});
            const v = new t.default(), b = p, m = b.getStats, y = b.createRecoveryCongestionLevelCalculator, U = y === void 0 ? o.default : y;
            let B;
            const Q = U({
              getStats: m
            }), N = (J) => {
              Q.stop(), u.info(`Network probe result ${J}`), v.emit("probeResult", J);
            };
            return Q.on("congestionLevel", (J) => {
              const w = Date.now() - B;
              J === l.CRITICAL ? N(l.CRITICAL) : w > h && (J === l.LOW ? N(l.LOW) : N(l.CRITICAL));
            }), Object.assign(v, {
              start() {
                B = Date.now(), u.info("Start network probe"), Q.start();
              },
              stop() {
                u.info("Stop network probe"), Q.stop();
              }
            });
          };
          r.default = g;
        },
        /* 673 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = n(e(674)), l = n(e(313)), c = n(e(314)), d = e(25), h = function(g) {
            g === void 0 && (g = {});
            const f = new t.default(), p = g, v = p.getStats, b = p.createMovingAverageTracker, m = b === void 0 ? c.default : b, y = p.createBandwidthCongestionLevel, U = y === void 0 ? o.default : y, B = p.createCongestionLevelStats, Q = B === void 0 ? l.default : B, N = U(), J = m(), w = m(), W = Q(v), G = () => {
              J.reset(), w.reset();
            }, Z = () => {
              W.stop(), G();
            }, K = () => w.getDataPointCount() === 0 || J.getDataPointCount() === 0 ? d.LOW : N.getLevel({
              audioPacketLoss: J.getMovingAverageValue(),
              videoPacketLoss: w.getMovingAverageValue()
            }), L = (O) => {
              let de = O.audioPacketLoss, oe = O.videoPacketLoss;
              J.addValue(de), w.addValue(oe);
              const fe = K();
              f.emit("congestionLevel", fe);
            };
            return W.on("statsAvailable", L), Object.assign(f, {
              start() {
                W.start();
              },
              stop() {
                Z();
              }
            });
          };
          r.default = h;
        },
        /* 674 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(171)), o = e(25);
          const l = 0.8, c = 0.5;
          var u = function(A) {
            A === void 0 && (A = {});
            const f = Object.assign({}, t.default, A).packetLossCriticalThreshold, p = f * c, v = f * l, b = v * c;
            return {
              getLevel(m) {
                let y = m.audioPacketLoss, U = m.videoPacketLoss;
                return y > v || U > f ? o.CRITICAL : y > b || U > p ? o.MEDIUM : o.LOW;
              }
            };
          };
          r.default = u;
        },
        /* 675 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3));
          const o = (c) => c >= 15 && c < 15.4;
          var l = (c) => (c = c || t.default, c.isiPad ? !0 : c.isiPhone ? o(c.iOSVersion) : c.isSafari ? o(c.version) : !1);
          r.default = l;
        },
        /* 676 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = [{
            width: 320,
            height: 180,
            maxBitrate: 3e5
          }, {
            width: 320,
            height: 240,
            maxBitrate: 4e5
          }, {
            width: 352,
            height: 288,
            maxBitrate: 5e5
          }, {
            width: 480,
            height: 270,
            maxBitrate: 55e4
          }, {
            width: 640,
            height: 360,
            maxBitrate: 8e5
          }, {
            width: 640,
            height: 480,
            maxBitrate: 8e5
          }, {
            width: 960,
            height: 540,
            maxBitrate: 11e5
          }, {
            width: 1280,
            height: 720,
            maxBitrate: 25e5
          }, {
            width: 1920,
            height: 1080,
            maxBitrate: 45e5
          }].sort((c, d) => c.maxBitrate - d.maxBitrate), t = 45e5;
          var l = (c, d) => {
            var u;
            return !c || !d ? t : ((u = n.find((A) => {
              let g = A.height, f = A.width;
              return d * c <= g * f;
            })) == null ? void 0 : u.maxBitrate) || t;
          };
          r.default = l;
        },
        /* 677 */
        /***/
        function(i, r, e) {
          var n = e(63), t = e(102), o = e(38);
          function l(c, d) {
            var u = {};
            return d = o(d, 3), t(c, function(h, A, g) {
              n(u, A, d(h, A, g));
            }), u;
          }
          i.exports = l;
        },
        /* 678 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t, o) {
            const l = setTimeout(() => {
              t((c, d) => {
                if (!c)
                  for (let u = 0; u < d.length; u += 1) {
                    const h = d[u];
                    h.id.indexOf("_send") !== -1 && h.type === "ssrc" && (h.kind === "audio" || h.mediaType === "audio") && parseInt(h.bytesSent, 10) === 0 && o();
                  }
              });
            }, 3e3);
            return function() {
              clearTimeout(l);
            };
          }
        },
        /* 679 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = e(110), o = n(e(315)), c = (d) => d === 0 ? 5 * t.ONE_SECOND_IN_MS : (0, o.default)(d - 1);
          r.default = c;
        },
        /* 680 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = h;
          var t = n(e(4)), o = n(e(5)), l = n(e(16)), c = n(e(6)), d = e(681);
          const u = () => new MediaStream();
          function h(A) {
            A === void 0 && (A = {});
            const g = A.createMediaStream || u;
            return function(p, v) {
              const b = {}, m = [], y = g();
              this._id = (0, l.default)();
              let U = !1;
              const B = () => {
                U || (this.trigger("iceConnected"), U = !0);
              };
              let Q = !1;
              const N = (oe) => {
                oe === "connected" && Q || (Q = oe === "connected", this.trigger("iceConnectionStateChange", oe));
              }, J = () => this.trigger("close"), w = (oe) => this.trigger("remoteVideoSupported", oe), W = (oe) => {
                let fe = oe.reason, ge = oe.prefix;
                return this.trigger("error", {
                  reason: fe,
                  prefix: ge
                });
              }, G = (oe) => {
                oe.parsedStats.singlePeerConnection = !0, this.trigger("qos", oe);
              }, Z = (oe) => this.trigger("signalingStateChange", oe), K = (oe) => this.trigger("signalingStateStable", oe), L = () => this.trigger("decryptFailed"), O = () => this.trigger("decryptRestored");
              (0, c.default)(this);
              const de = v.getPeerConnection(p, this);
              de.on({
                iceConnected: B,
                close: J,
                signalingStateChange: Z,
                signalingStateStable: K,
                error: W,
                qos: G,
                iceConnectionStateChange: N,
                remoteVideoSupported: w,
                decryptFailed: L,
                decryptRestored: O
              }, this), this.onTrackAdded = (oe) => {
                let fe = oe.track, ge = oe.transceiver;
                b[fe.id] = ge.mid, v.addSubscriberMid(ge.mid, this._id), m.push(fe), y.addTrack(fe), de.iceConnectionStateIsConnected() && (B(), N("connected")), this.trigger("trackAdded", {
                  stream: y,
                  track: fe
                });
              }, this.disconnect = () => {
                v.removeSubscriber(this._id, Object.values(b));
              }, this.remoteTracks = () => m, this.generateOfferAndSend = () => de.generateOfferAndSend(), this.getDataChannel = (oe, fe, ge) => {
                de.getDataChannel(oe, fe, ge);
              }, this.getSourceStreamId = () => de.getSourceStreamId(), this.processOffer = /* @__PURE__ */ function() {
                var oe = (0, o.default)(/* @__PURE__ */ t.default.mark(function fe(ge) {
                  return t.default.wrap(function(_e) {
                    for (; ; ) switch (_e.prev = _e.next) {
                      case 0:
                        return _e.next = 2, v.processOffer(ge.content.sdp);
                      case 2:
                        ge.content.sdp = _e.sent, de.processMessage("offer", ge);
                      case 4:
                      case "end":
                        return _e.stop();
                    }
                  }, fe);
                }));
                return function(fe) {
                  return oe.apply(this, arguments);
                };
              }(), this.processAnswer = (oe) => {
                oe.content.sdp = v.processAnswer(oe.content.sdp), de.processMessage("answer", oe), v.subscriberComplete();
              }, this.processMessage = (oe, fe) => {
                oe === "offer" ? this.processOffer(fe) : oe === "answer" ? this.processAnswer(fe) : de.processMessage(oe, fe);
              }, this.remoteDescription = () => de.remoteDescription(), this.getStats = (oe, fe) => {
                oe ? de.getStats(oe, fe) : (0, d.collectGetStatsHelper)(de, m, fe);
              }, this.getSynchronizationSources = (oe) => {
                de.getSynchronizationSources(oe);
              }, this.getRtcStatsReport = (oe, fe) => {
                oe ? de.getRtcStatsReport(oe, fe) : (0, d.collectRtcStatsReportHelper)(de, m, fe);
              }, this.remoteStreams = () => de.remoteStreams(), this.hasRelayCandidates = () => de.hasRelayCandidates(), this.iceRestart = () => de.iceRestart(), this.iceConnectionStateIsConnected = () => de.iceConnectionStateIsConnected(), this.startDecryption = (oe, fe) => de.startDecryption(oe, fe);
            };
          }
        },
        /* 681 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.collectStatsHelper = r.collectRtcStatsReportHelper = r.collectGetStatsHelper = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(172));
            const d = /* @__PURE__ */ function() {
              var A = (0, l.default)(/* @__PURE__ */ o.default.mark(function g(f, p) {
                var v, b, m, y, U, B, Q;
                return o.default.wrap(function(J) {
                  for (; ; ) switch (J.prev = J.next) {
                    case 0:
                      return f === void 0 && (f = {}), v = f, b = v.tracks, m = v.getStats, y = v.merge, U = (0, c.default)(m), J.prev = 3, J.next = 6, n.all(b.map((w) => U(w)));
                    case 6:
                      Q = J.sent, B = Q.reduce(y), J.next = 14;
                      break;
                    case 10:
                      return J.prev = 10, J.t0 = J.catch(3), p(J.t0), J.abrupt("return");
                    case 14:
                      p(null, B);
                    case 15:
                    case "end":
                      return J.stop();
                  }
                }, g, null, [[3, 10]]);
              }));
              return function(f, p) {
                return A.apply(this, arguments);
              };
            }();
            r.collectStatsHelper = d;
            const u = (A, g, f) => {
              d({
                tracks: g,
                getStats: (v, b) => A.getStats(v, b),
                merge: function(b, m) {
                  return b === void 0 && (b = []), [...b, ...m];
                }
              }, f);
            };
            r.collectGetStatsHelper = u;
            const h = (A, g, f) => {
              d({
                tracks: g,
                getStats: (v, b) => A.getRtcStatsReport(v, b),
                merge: function(b, m) {
                  return b === void 0 && (b = {}), Object.assign({}, b, m);
                }
              }, f);
            };
            r.collectRtcStatsReportHelper = h;
          }).call(this, e(2));
        },
        /* 682 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = t;
          const n = 3e3;
          function t(o, l, c) {
            c === void 0 && (c = !1);
            let d = null, u = 0, h = null, A = c;
            const g = (y) => y.type === "inbound-rtp" && (y.kind || y.mediaType) === "audio", f = (y) => y.id === h && y.type === "track" && (y.kind || y.mediaType) === "audio", p = (y, U) => y === d && U === u, v = (y, U) => !A && y === 0 && d === 0 && U > u, b = () => {
              setTimeout(() => {
                A = !0;
              }, n);
            }, m = setInterval(() => {
              o((y, U) => {
                if (y)
                  return;
                h = (U.find(g) || {}).trackId;
                const Q = U.find(f);
                if (Q) {
                  const N = Q.audioLevel, J = Q.totalSamplesReceived;
                  if (N === void 0)
                    return;
                  p(N, J) ? (clearInterval(m), l("audioLevelStuck")) : v(N, J) && (clearInterval(m), l("audioLevelStuckAt0")), d = N, u = J;
                }
              });
            }, 500);
            return c || b(), {
              stop: () => {
                clearInterval(m);
              }
            };
          }
        },
        /* 683 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = g;
            var o = t(e(16)), l = t(e(10)), c = t(e(28)), d = t(e(24)), u = t(e(13)), h = t(e(8));
            const A = new c.default();
            function g(f) {
              f === void 0 && (f = {});
              const p = f.analytics || A, v = f.errors || h.default, b = f.ExceptionCodes || l.default, m = f.otError || (0, u.default)(), y = f.sessionObjects || d.default, U = f.uuid || o.default;
              return function(Q) {
                Q === void 0 && (Q = () => {
                });
                const N = U();
                function J(w) {
                  w ? Q(m(v.REPORT_ISSUE_FAILED, new Error("Error calling OT.reportIssue(). Check the client's network connection."), b.REPORT_ISSUE_ERROR)) : Q(null, N);
                }
                y.sessions.length() === 0 ? p.logEvent({
                  action: "ReportIssue",
                  variation: "Event",
                  payload: {
                    reportIssueId: N
                  }
                }, null, J) : n.all(y.sessions.map((w) => w.reportIssue({
                  id: N
                }))).then(() => J(), (w) => J(w));
              };
            }
          }).call(this, e(2));
        },
        /* 684 */
        /***/
        function(i, r, e) {
          Object.defineProperty(r, "__esModule", {
            value: !0
          });
          var n = /* @__PURE__ */ function() {
            function h(A, g) {
              for (var f = 0; f < g.length; f++) {
                var p = g[f];
                p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(A, p.key, p);
              }
            }
            return function(A, g, f) {
              return g && h(A.prototype, g), f && h(A, f), A;
            };
          }(), t = e(320), o = l(t);
          function l(h) {
            return h && h.__esModule ? h : { default: h };
          }
          function c(h, A) {
            if (!(h instanceof A))
              throw new TypeError("Cannot call a class as a function");
          }
          var d = function() {
          }, u = function() {
            function h() {
              c(this, h), this.internalIsCanceled = !1, this.listeners = [];
            }
            return n(h, [{
              key: "isCanceled",
              /**
               * Returns `true` if cancellation has been requested; otherwise, returns `false`.
               */
              value: function() {
                return this.internalIsCanceled;
              }
              /**
               * Issues a cancellation request.
               *
               * It is safe to call this method multiple times since all but the first call are ignored.
               */
            }, {
              key: "cancel",
              value: function() {
                this.internalIsCanceled || (this.internalIsCanceled = !0, this.listeners.forEach(function(g) {
                  return g();
                }), this.listeners = null);
              }
              /**
               * Throws a `CancellationError` if cancellation has been requested.
               */
            }, {
              key: "throwIfCanceled",
              value: function() {
                if (this.internalIsCanceled)
                  throw new o.default("Operation has been canceled.");
              }
              /**
               * Adds a listener to be notified when cancellation is requested.
               *
               * @param {Function} listener The function to be called when cancellation is requested.
               * @returns {Function} A function that, when called, removes the listener.
               */
            }, {
              key: "onCancel",
              value: function(g) {
                var f = this;
                return this.internalIsCanceled ? d : (this.listeners.push(g), function() {
                  if (f.listeners) {
                    var p = f.listeners.indexOf(g);
                    p !== -1 && f.listeners.splice(p, 1);
                  }
                });
              }
              /**
               * Creates a child `Cancellation` object.
               *
               * @returns {Cancellation}
               */
            }, {
              key: "fork",
              value: function() {
                if (this.internalIsCanceled)
                  return h.CANCELED;
                var g = new h();
                return this.onCancel(function() {
                  return g.cancel();
                }), g;
              }
            }]), h;
          }();
          r.default = u, u.CANCELED = new u(), u.CANCELED.internalIsCanceled = !0;
        },
        /* 685 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t, o) {
            return o === void 0 && (o = "px"), String(parseFloat(t, 10)) === String(t).trim() ? `${String(t).trim()}${o}` : t;
          }
        },
        /* 686 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            let o = t.window, l = !1;
            try {
              const c = Object.defineProperty({}, "passive", {
                get() {
                  l = !0;
                }
              });
              o.addEventListener("testPassive", null, c), o.removeEventListener("testPassive", null, c);
            } catch {
            }
            return l;
          };
          r.default = n;
        },
        /* 687 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = () => {
            const l = document.createElementNS("http://www.w3.org/2000/svg", "circle");
            return l.setAttribute("cx", "50%"), l.setAttribute("cy", "50%"), l.setAttribute("r", "50%"), l.setAttribute("fill", "%23000000"), l;
          }, t = (l) => {
            const c = document.createElementNS("http://www.w3.org/2000/svg", "text");
            c.setAttribute("x", "50%"), c.setAttribute("y", "50%"), c.setAttribute("dy", "5%"), c.setAttribute("line-height", "133%"), c.setAttribute("font-size", "108"), c.setAttribute("font-weight", "500"), c.setAttribute("font-style", "normal"), c.setAttribute("fill", "%23FFFFFF"), c.setAttribute("font-family", "spezia,sans-serif"), c.setAttribute("dominant-baseline", "middle"), c.setAttribute("text-anchor", "middle");
            const d = document.createTextNode(l);
            return c.appendChild(d), c;
          };
          var o = (l) => {
            const c = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            c.setAttribute("viewBox", "0 0 300 300"), c.setAttribute("style", "width: 50%; dominant-baseline: middle; text-anchor: middle;");
            const d = n(), u = t(l);
            return c.appendChild(d), c.appendChild(u), c;
          };
          r.default = o;
        },
        /* 688 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(16));
          function o(l, c) {
            let d, u;
            if (l && l.nodeName ? (d = l, (!d.getAttribute("id") || d.getAttribute("id").length === 0) && d.setAttribute("id", `OT_${(0, t.default)()}`), u = d.getAttribute("id")) : l && (d = document.getElementById(l), d && (u = l)), u || (u = `OT_${(0, t.default)().replace(/-/g, "_")}`), !d)
              return d = document.createElement("div"), d.id = u, d.setAttribute("id", u), d.style.backgroundColor = "#000000", document.body.appendChild(d), d;
            const h = document.createElement("div");
            switch (h.id = `OT_${(0, t.default)()}`, c) {
              case "append":
                return d.appendChild(h), h;
              case "before":
                return d.parentNode.insertBefore(h, d), h;
              case "after":
                return d.parentNode.insertBefore(h, d.nextSibling), h;
              case "replace":
              default:
                for (; d.firstChild; )
                  d.removeChild(d.firstChild);
                return d;
            }
          }
        },
        /* 689 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = h;
          var t = n(e(1));
          const o = (0, t.default)("WidgetView:fixMini"), l = 128, c = 128, d = 64, u = 64;
          function h(A) {
            const g = A.clientWidth, f = A.clientHeight;
            A.classList.remove("OT_micro"), A.classList.remove("OT_mini"), (g < d || f < u) && (A.classList.add("OT_micro"), o.debug("OT_micro class added", {
              clientWidth: g,
              clientHeight: f,
              microWidth: d,
              microHeight: u
            })), (g < l || f < c) && (A.classList.add("OT_mini"), o.debug("OT_mini class added", {
              clientWidth: g,
              clientHeight: f,
              miniWidth: l,
              miniHeight: c
            }));
          }
        },
        /* 690 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(321)), l = t(e(160)), c = t(e(57)), d = t(e(106));
            (0, d.default)();
            function u(A, g) {
              g === void 0 && (g = 5e3);
              const f = (0, c.default)(A), p = new n((v) => {
                f.on("timeupdate", v), f.on("loadedmetadata", v);
              });
              return (0, o.default)((0, l.default)(p, g, () => !1), () => f.removeAll());
            }
            var h = u;
            r.default = h;
          }).call(this, e(2));
        },
        /* 691 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(321)), l = t(e(160)), c = t(e(57)), d = t(e(106));
            (0, d.default)();
            function u(A, g) {
              const f = (0, c.default)(A), p = new n((v) => {
                const b = () => {
                  (A.videoWidth() > 2 || A.videoHeight() > 2) && v(!0);
                };
                f.on("videoDimensionsChanged", b), b();
              });
              return (0, o.default)((0, l.default)(p, g, () => !1), () => f.removeAll());
            }
            var h = u;
            r.default = h;
          }).call(this, e(2));
        },
        /* 692 */
        /***/
        function(i, r) {
          function e(n, t) {
            if (n == null) return {};
            var o = {}, l = Object.keys(n), c, d;
            for (d = 0; d < l.length; d++)
              c = l[d], !(t.indexOf(c) >= 0) && (o[c] = n[c]);
            return o;
          }
          i.exports = e;
        },
        /* 693 */
        /***/
        function(i, r, e) {
          e.r(r);
          var n = function() {
            if (typeof Map != "undefined")
              return Map;
            function oe(fe, ge) {
              var we = -1;
              return fe.some(function(_e, Te) {
                return _e[0] === ge ? (we = Te, !0) : !1;
              }), we;
            }
            return (
              /** @class */
              function() {
                function fe() {
                  this.__entries__ = [];
                }
                return Object.defineProperty(fe.prototype, "size", {
                  /**
                   * @returns {boolean}
                   */
                  get: function() {
                    return this.__entries__.length;
                  },
                  enumerable: !0,
                  configurable: !0
                }), fe.prototype.get = function(ge) {
                  var we = oe(this.__entries__, ge), _e = this.__entries__[we];
                  return _e && _e[1];
                }, fe.prototype.set = function(ge, we) {
                  var _e = oe(this.__entries__, ge);
                  ~_e ? this.__entries__[_e][1] = we : this.__entries__.push([ge, we]);
                }, fe.prototype.delete = function(ge) {
                  var we = this.__entries__, _e = oe(we, ge);
                  ~_e && we.splice(_e, 1);
                }, fe.prototype.has = function(ge) {
                  return !!~oe(this.__entries__, ge);
                }, fe.prototype.clear = function() {
                  this.__entries__.splice(0);
                }, fe.prototype.forEach = function(ge, we) {
                  we === void 0 && (we = null);
                  for (var _e = 0, Te = this.__entries__; _e < Te.length; _e++) {
                    var Pe = Te[_e];
                    ge.call(we, Pe[1], Pe[0]);
                  }
                }, fe;
              }()
            );
          }(), t = typeof window != "undefined" && typeof document != "undefined" && window.document === document, o = function() {
            return typeof (typeof window !== void 0 ? window : Dn) != "undefined" && (typeof window !== void 0 ? window : Dn).Math === Math ? typeof window !== void 0 ? window : Dn : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
          }(), l = function() {
            return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(o) : function(oe) {
              return setTimeout(function() {
                return oe(Date.now());
              }, 1e3 / 60);
            };
          }(), c = 2;
          function d(oe, fe) {
            var ge = !1, we = !1, _e = 0;
            function Te() {
              ge && (ge = !1, oe()), we && $e();
            }
            function Pe() {
              l(Te);
            }
            function $e() {
              var Bt = Date.now();
              if (ge) {
                if (Bt - _e < c)
                  return;
                we = !0;
              } else
                ge = !0, we = !1, setTimeout(Pe, fe);
              _e = Bt;
            }
            return $e;
          }
          var u = 20, h = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], A = typeof MutationObserver != "undefined", g = (
            /** @class */
            function() {
              function oe() {
                this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = d(this.refresh.bind(this), u);
              }
              return oe.prototype.addObserver = function(fe) {
                ~this.observers_.indexOf(fe) || this.observers_.push(fe), this.connected_ || this.connect_();
              }, oe.prototype.removeObserver = function(fe) {
                var ge = this.observers_, we = ge.indexOf(fe);
                ~we && ge.splice(we, 1), !ge.length && this.connected_ && this.disconnect_();
              }, oe.prototype.refresh = function() {
                var fe = this.updateObservers_();
                fe && this.refresh();
              }, oe.prototype.updateObservers_ = function() {
                var fe = this.observers_.filter(function(ge) {
                  return ge.gatherActive(), ge.hasActive();
                });
                return fe.forEach(function(ge) {
                  return ge.broadcastActive();
                }), fe.length > 0;
              }, oe.prototype.connect_ = function() {
                !t || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), A ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
                  attributes: !0,
                  childList: !0,
                  characterData: !0,
                  subtree: !0
                })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
              }, oe.prototype.disconnect_ = function() {
                !t || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
              }, oe.prototype.onTransitionEnd_ = function(fe) {
                var ge = fe.propertyName, we = ge === void 0 ? "" : ge, _e = h.some(function(Te) {
                  return !!~we.indexOf(Te);
                });
                _e && this.refresh();
              }, oe.getInstance = function() {
                return this.instance_ || (this.instance_ = new oe()), this.instance_;
              }, oe.instance_ = null, oe;
            }()
          ), f = function(oe, fe) {
            for (var ge = 0, we = Object.keys(fe); ge < we.length; ge++) {
              var _e = we[ge];
              Object.defineProperty(oe, _e, {
                value: fe[_e],
                enumerable: !1,
                writable: !1,
                configurable: !0
              });
            }
            return oe;
          }, p = function(oe) {
            var fe = oe && oe.ownerDocument && oe.ownerDocument.defaultView;
            return fe || o;
          }, v = W(0, 0, 0, 0);
          function b(oe) {
            return parseFloat(oe) || 0;
          }
          function m(oe) {
            for (var fe = [], ge = 1; ge < arguments.length; ge++)
              fe[ge - 1] = arguments[ge];
            return fe.reduce(function(we, _e) {
              var Te = oe["border-" + _e + "-width"];
              return we + b(Te);
            }, 0);
          }
          function y(oe) {
            for (var fe = ["top", "right", "bottom", "left"], ge = {}, we = 0, _e = fe; we < _e.length; we++) {
              var Te = _e[we], Pe = oe["padding-" + Te];
              ge[Te] = b(Pe);
            }
            return ge;
          }
          function U(oe) {
            var fe = oe.getBBox();
            return W(0, 0, fe.width, fe.height);
          }
          function B(oe) {
            var fe = oe.clientWidth, ge = oe.clientHeight;
            if (!fe && !ge)
              return v;
            var we = p(oe).getComputedStyle(oe), _e = y(we), Te = _e.left + _e.right, Pe = _e.top + _e.bottom, $e = b(we.width), Bt = b(we.height);
            if (we.boxSizing === "border-box" && (Math.round($e + Te) !== fe && ($e -= m(we, "left", "right") + Te), Math.round(Bt + Pe) !== ge && (Bt -= m(we, "top", "bottom") + Pe)), !N(oe)) {
              var Le = Math.round($e + Te) - fe, at = Math.round(Bt + Pe) - ge;
              Math.abs(Le) !== 1 && ($e -= Le), Math.abs(at) !== 1 && (Bt -= at);
            }
            return W(_e.left, _e.top, $e, Bt);
          }
          var Q = /* @__PURE__ */ function() {
            return typeof SVGGraphicsElement != "undefined" ? function(oe) {
              return oe instanceof p(oe).SVGGraphicsElement;
            } : function(oe) {
              return oe instanceof p(oe).SVGElement && typeof oe.getBBox == "function";
            };
          }();
          function N(oe) {
            return oe === p(oe).document.documentElement;
          }
          function J(oe) {
            return t ? Q(oe) ? U(oe) : B(oe) : v;
          }
          function w(oe) {
            var fe = oe.x, ge = oe.y, we = oe.width, _e = oe.height, Te = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, Pe = Object.create(Te.prototype);
            return f(Pe, {
              x: fe,
              y: ge,
              width: we,
              height: _e,
              top: ge,
              right: fe + we,
              bottom: _e + ge,
              left: fe
            }), Pe;
          }
          function W(oe, fe, ge, we) {
            return { x: oe, y: fe, width: ge, height: we };
          }
          var G = (
            /** @class */
            function() {
              function oe(fe) {
                this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = W(0, 0, 0, 0), this.target = fe;
              }
              return oe.prototype.isActive = function() {
                var fe = J(this.target);
                return this.contentRect_ = fe, fe.width !== this.broadcastWidth || fe.height !== this.broadcastHeight;
              }, oe.prototype.broadcastRect = function() {
                var fe = this.contentRect_;
                return this.broadcastWidth = fe.width, this.broadcastHeight = fe.height, fe;
              }, oe;
            }()
          ), Z = (
            /** @class */
            /* @__PURE__ */ function() {
              function oe(fe, ge) {
                var we = w(ge);
                f(this, { target: fe, contentRect: we });
              }
              return oe;
            }()
          ), K = (
            /** @class */
            function() {
              function oe(fe, ge, we) {
                if (this.activeObservations_ = [], this.observations_ = new n(), typeof fe != "function")
                  throw new TypeError("The callback provided as parameter 1 is not a function.");
                this.callback_ = fe, this.controller_ = ge, this.callbackCtx_ = we;
              }
              return oe.prototype.observe = function(fe) {
                if (!arguments.length)
                  throw new TypeError("1 argument required, but only 0 present.");
                if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
                  if (!(fe instanceof p(fe).Element))
                    throw new TypeError('parameter 1 is not of type "Element".');
                  var ge = this.observations_;
                  ge.has(fe) || (ge.set(fe, new G(fe)), this.controller_.addObserver(this), this.controller_.refresh());
                }
              }, oe.prototype.unobserve = function(fe) {
                if (!arguments.length)
                  throw new TypeError("1 argument required, but only 0 present.");
                if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
                  if (!(fe instanceof p(fe).Element))
                    throw new TypeError('parameter 1 is not of type "Element".');
                  var ge = this.observations_;
                  ge.has(fe) && (ge.delete(fe), ge.size || this.controller_.removeObserver(this));
                }
              }, oe.prototype.disconnect = function() {
                this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
              }, oe.prototype.gatherActive = function() {
                var fe = this;
                this.clearActive(), this.observations_.forEach(function(ge) {
                  ge.isActive() && fe.activeObservations_.push(ge);
                });
              }, oe.prototype.broadcastActive = function() {
                if (this.hasActive()) {
                  var fe = this.callbackCtx_, ge = this.activeObservations_.map(function(we) {
                    return new Z(we.target, we.broadcastRect());
                  });
                  this.callback_.call(fe, ge, fe), this.clearActive();
                }
              }, oe.prototype.clearActive = function() {
                this.activeObservations_.splice(0);
              }, oe.prototype.hasActive = function() {
                return this.activeObservations_.length > 0;
              }, oe;
            }()
          ), L = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new n(), O = (
            /** @class */
            /* @__PURE__ */ function() {
              function oe(fe) {
                if (!(this instanceof oe))
                  throw new TypeError("Cannot call a class as a function.");
                if (!arguments.length)
                  throw new TypeError("1 argument required, but only 0 present.");
                var ge = g.getInstance(), we = new K(fe, ge, this);
                L.set(this, we);
              }
              return oe;
            }()
          );
          [
            "observe",
            "unobserve",
            "disconnect"
          ].forEach(function(oe) {
            O.prototype[oe] = function() {
              var fe;
              return (fe = L.get(this))[oe].apply(fe, arguments);
            };
          });
          var de = function() {
            return typeof o.ResizeObserver != "undefined" ? o.ResizeObserver : O;
          }();
          r.default = de;
        },
        /* 694 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(73)), l = (c) => {
            let d = c.connectivityState, u = c.logAttempt;
            const h = new t.default(u, 1 / 5, 6);
            d.observe({
              onEnterConnecting() {
                h.start();
              },
              onEnterDisconnected() {
                h.stop();
              },
              onEnterConnected() {
                h.stop();
              }
            });
          };
          r.default = l;
        },
        /* 695 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(326)), l = (c) => {
            let d = c.onInvalidTransition;
            return new t.default({
              init: "disconnected",
              transitions: [{
                name: "beginConnect",
                from: "disconnected",
                to: "connecting"
              }, {
                name: "connect",
                from: "connecting",
                to: "connected"
              }, {
                name: "fail",
                from: ["connecting", "connected"],
                to: "disconnected"
              }, {
                name: "cancel",
                from: ["connecting", "connected"],
                to: "disconnected"
              }, {
                name: "disconnect",
                from: ["connecting", "connected"],
                to: "disconnected"
              }],
              methods: {
                onInvalidTransition: d
              }
            });
          };
          r.default = l;
        },
        /* 696 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(73)), d = function(h) {
              let A = h === void 0 ? {} : h, g = A.asynchronous;
              return (g === void 0 ? !1 : g) ? function(p, v) {
                let b = v === void 0 ? {} : v, m = b.frequency, y = m === void 0 ? 10 : m, U = b.timeout, B = U === void 0 ? 2e3 : U;
                return new n((Q, N) => {
                  let J;
                  const w = new c.default(/* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function W() {
                    var G, Z, K;
                    return o.default.wrap(function(O) {
                      for (; ; ) switch (O.prev = O.next) {
                        case 0:
                          return Z = function() {
                            return Z = (0, l.default)(/* @__PURE__ */ o.default.mark(function oe() {
                              return o.default.wrap(function(ge) {
                                for (; ; ) switch (ge.prev = ge.next) {
                                  case 0:
                                    return ge.prev = 0, ge.next = 3, p();
                                  case 3:
                                    return ge.abrupt("return", ge.sent);
                                  case 6:
                                    return ge.prev = 6, ge.t0 = ge.catch(0), ge.abrupt("return", !1);
                                  case 9:
                                  case "end":
                                    return ge.stop();
                                }
                              }, oe, null, [[0, 6]]);
                            })), Z.apply(this, arguments);
                          }, G = function() {
                            return Z.apply(this, arguments);
                          }, O.next = 4, G();
                        case 4:
                          K = O.sent, K && (clearTimeout(J), w.stop(), Q());
                        case 6:
                        case "end":
                          return O.stop();
                      }
                    }, W);
                  })), y);
                  J = setTimeout(() => {
                    w.stop(), N(new Error("TIMEOUT"));
                  }, B), w.start();
                });
              } : function(p, v) {
                let b = v === void 0 ? {} : v, m = b.frequency, y = m === void 0 ? 60 : m, U = b.timeout, B = U === void 0 ? 2e3 : U;
                return new n((Q, N) => {
                  let J;
                  const w = new c.default(() => {
                    function W() {
                      try {
                        return p();
                      } catch {
                        return !1;
                      }
                    }
                    W() && (clearTimeout(J), w.stop(), Q());
                  }, y);
                  J = setTimeout(() => {
                    w.stop(), N(new Error("TIMEOUT"));
                  }, B), w.start();
                });
              };
            };
            r.default = d;
          }).call(this, e(2));
        },
        /* 697 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            let o = t.connectivityState, l = t.onWarning, c = t.onTimeout, d = t.warningMs, u = t.timeoutMs;
            const h = [], A = () => {
              h.forEach((g) => clearTimeout(g));
            };
            o.observe({
              onEnterConnecting() {
                h.push(setTimeout(l, d), setTimeout(c, u));
              },
              onEnterConnected: A,
              onEnterDisconnected: A
            });
          };
          r.default = n;
        },
        /* 698 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(10)), o = n(e(13)), l = n(e(8));
          const c = (0, o.default)();
          var d = (u) => String(u.code) === "404" ? c(l.default.STREAM_NOT_FOUND, new Error("stream not found"), t.default.UNABLE_TO_SUBSCRIBE) : String(u.code) === "409" && u.message === "streamLimitExceeded" ? c(l.default.STREAM_LIMIT_EXCEEDED, new Error("The limit for concurrent streams in the session has been reached"), t.default.STREAM_LIMIT_EXCEEDED) : String(u.code) === "405" && u.message === "IncompatibleEncryptionSettings" ? c(l.default.UNABLE_TO_SUBSCRIBE, new Error("Tried to subscribe to an encrypted stream without enabling encryption"), t.default.UNABLE_TO_SUBSCRIBE) : String(u.code) === "500" && u.message === "Not connected." ? c(l.default.UNABLE_TO_SUBSCRIBE, new Error("Tried to subscribe to a stream while disconnected."), t.default.UNABLE_TO_SUBSCRIBE) : c(l.default.UNABLE_TO_SUBSCRIBE, new Error(`subscriberCreate failed with unexpected code ${u.code}: ${u.message}`), t.default.UNEXPECTED_SERVER_RESPONSE);
          r.default = d;
        },
        /* 699 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(31)), o = n(e(50)), l = n(e(109)), c = n(e(23));
          const d = (0, c.default)();
          var u = (h) => {
            let A = h.subscriber, g = h.audioLevelSampler, f = 0, p = 0;
            const v = new l.default(() => {
              const b = A.listenerCount(t.default.AUDIO_LEVEL_UPDATED);
              if ((0, o.default)() - p > 1e4 && b === 0) {
                v.stop();
                return;
              }
              f = g.sample(), b > 0 && A.dispatchEvent(new d.AudioLevelUpdatedEvent(f));
            });
            return Object.defineProperty(A, "loudness", {
              get() {
                return v.start(), p = (0, o.default)(), f;
              },
              set() {
                throw new TypeError("Cannot set readonly property loudness");
              },
              configurable: !0
            }), A.listenerCount(t.default.AUDIO_LEVEL_UPDATED) && v.start(), A.on("audioLevelUpdated:added", () => {
              v.start();
            }), A.once(t.default.SUBSCRIBER_DESTROYED, () => {
              v.stop();
            }), {
              destroy() {
                g.destroy(), v.stop();
              }
            };
          };
          r.default = u;
        },
        /* 700 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), l = () => ["Chrome", "Opera", "Safari"].indexOf(t.default.name) > -1;
          r.default = l;
        },
        /* 701 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(1)), o = n(e(268)), l = n(e(142)), c = n(e(702)), d = n(e(328)), u = n(e(141)), h = n(e(703));
          const A = (0, u.default)(), g = (0, t.default)("Subscriber");
          var p = function(b, m) {
            m === void 0 && (m = {});
            const y = m.hasGetSynchronizationSupport;
            if (b) {
              if ((0, d.default)()) {
                let U;
                try {
                  U = m.audioContext || A();
                } catch (B) {
                  g.warn("Failed to get AudioContext()", B);
                }
                if ((0, h.default)(U))
                  return new l.default(U);
              }
              if ((0, c.default)({
                hasGetSynchronizationSupport: y
              }))
                return new o.default(b.getSynchronizationSources);
            }
          };
          r.default = p;
        },
        /* 702 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3));
          const o = !1, l = () => window.RTCRtpReceiver && "getSynchronizationSources" in window.RTCRtpReceiver.prototype;
          var d = function(h) {
            h === void 0 && (h = {});
            const A = h.hasGetSynchronizationSupport || l;
            return (typeof h.isEnabled == "boolean" ? h.isEnabled : o) && A() && !t.default.isFirefox;
          };
          r.default = d;
        },
        /* 703 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => (typeof window !== void 0 ? window : Dn).AudioContext && t instanceof (typeof window !== void 0 ? window : Dn).AudioContext || (typeof window !== void 0 ? window : Dn).webkitAudioContext && t instanceof (typeof window !== void 0 ? window : Dn).webkitAudioContext;
          r.default = n;
        },
        /* 704 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(41)), o = n(e(7));
          function l(c) {
            let d = !1;
            const u = (A) => {
              const g = ["auto", "on"].indexOf(this.getDisplayMode()) > -1;
              o.default.removeClass(A, ["OT_audio-blocked", "OT_active"].join(" ")), g && (d && o.default.addClass(A, "OT_audio-blocked"), o.default.addClass(A, "OT_active"));
            };
            this.setAudioBlocked = (A) => {
              d = A, u(this.domElement);
            }, (0, t.default)(this, {
              mode: c.mode || "auto",
              nodeName: "div",
              htmlAttributes: {
                className: "OT_audio-blocked-indicator"
              }
            });
            const h = this.setDisplayMode.bind(this);
            this.setDisplayMode = (A) => {
              h(A), u(this.domElement);
            };
          }
        },
        /* 705 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(41)), o = n(e(7));
          function l(c) {
            let d = !1;
            const u = (A) => {
              const g = ["auto", "on"].indexOf(this.getDisplayMode()) > -1;
              o.default.removeClass(A, ["OT_active"].join(" ")), !(!g || !d) && o.default.addClass(A, "OT_active");
            };
            this.setVideoUnsupported = (A) => {
              d = A, u(this.domElement);
            }, (0, t.default)(this, {
              mode: c.mode || "auto",
              nodeName: "div",
              htmlAttributes: {
                className: "OT_video-unsupported"
              },
              htmlContent: '<div class="OT_video-unsupported-bar"></div><div class="OT_video-unsupported-img"></div><span class="OT_video-unsupported-text">Video format not supported</span>'
            });
            const h = this.setDisplayMode.bind(this);
            this.setDisplayMode = (A) => {
              h(A), u(this.domElement);
            };
          }
        },
        /* 706 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(9)), o = n(e(62)), l = n(e(40)), c = n(e(77)), d = n(e(165)), h = function(g, f) {
            f === void 0 && (f = 5e3);
            let p, v = !1;
            const b = {}, m = function(B) {
              return B === void 0 && (B = []), (0, o.default)(B, (Q) => c.default.isVideoInboundRtpStat(Q));
            }, y = () => {
              v || g((U, B) => {
                if (!v) {
                  if (!U) {
                    const Q = m(B);
                    Q ? (0, t.default)(b, (0, l.default)(Q, ["timestamp", "framesDecoded"])) : b.timestamp || (0, t.default)(b, {
                      timestamp: Date.now(),
                      framesDecoded: 0
                    });
                  }
                  p = setTimeout(y, f);
                }
              });
            };
            return y(), {
              getFrameRateFromStat(U) {
                return (0, d.default)({
                  currentStatFrames: U.framesDecoded,
                  currentTimestamp: U.timestamp,
                  prevStatFrames: b.framesDecoded,
                  prevTimestamp: b.timestamp
                });
              },
              destroy() {
                v = !0, p && (clearTimeout(p), p = null);
              }
            };
          };
          r.default = h;
        },
        /* 707 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(177)), c = n(e(1)), d = n(e(331)), u = n(e(708));
          const h = (0, c.default)("Subscriber"), A = "MANTIS", g = "P2P";
          var p = function(b, m) {
            m === void 0 && (m = {});
            const y = m.updateTrackOnStream || d.default, U = m.createAudioTrackHolder || u.default, B = b;
            let Q, N, J;
            const w = () => {
              var Z;
              (Z = Q) == null || Z.destroy(), Q = null, J && (J.srcObject = null, J = null), N = null;
            }, W = /* @__PURE__ */ function() {
              var Z = (0, o.default)(/* @__PURE__ */ t.default.mark(function K(L) {
                var O, de, oe, fe, ge, we;
                return t.default.wrap(function(Te) {
                  for (; ; ) switch (Te.prev = Te.next) {
                    case 0:
                      if (de = (O = B[L]) == null ? void 0 : O.getAudioTracks(), oe = de[0], oe) {
                        Te.next = 7;
                        break;
                      }
                      throw fe = "Connector not set as no audio track is present.", ge = new Error(fe), h.error(`setAudioMediaProcessorConnector: ${fe}`), Q = null, ge;
                    case 7:
                      return Te.prev = 7, J = U(oe), Te.next = 11, Q.setTrack(oe);
                    case 11:
                      we = Te.sent, N = oe, y(B[L], oe, we), Te.next = 20;
                      break;
                    case 16:
                      throw Te.prev = 16, Te.t0 = Te.catch(7), w(), Te.t0;
                    case 20:
                    case "end":
                      return Te.stop();
                  }
                }, K, null, [[7, 16]]);
              }));
              return function(L) {
                return Z.apply(this, arguments);
              };
            }(), G = (Z) => {
              try {
                const K = B[Z].getAudioTracks(), L = K[0];
                y(B[Z], L, N);
              } catch (K) {
                throw Error(`setAudioMediaProcessorConnector: Error resetting track: ${K.message}`);
              }
            };
            return {
              get audioMediaProcessorConnector() {
                return Q;
              },
              initializeConnector(Z) {
                Q = new l.default(Z);
              },
              setAudioMediaProcessorConnector(Z) {
                return (0, o.default)(/* @__PURE__ */ t.default.mark(function K() {
                  return t.default.wrap(function(O) {
                    for (; ; ) switch (O.prev = O.next) {
                      case 0:
                        return O.next = 2, W(Z);
                      case 2:
                      case "end":
                        return O.stop();
                    }
                  }, K);
                }))();
              },
              applyAudioConnectorOnRoutedToRelayedTransition() {
                var Z = this;
                return (0, o.default)(/* @__PURE__ */ t.default.mark(function K() {
                  return t.default.wrap(function(O) {
                    for (; ; ) switch (O.prev = O.next) {
                      case 0:
                        if (Z.resetAudioStreamAndTrack(A), Q) {
                          O.next = 3;
                          break;
                        }
                        return O.abrupt("return");
                      case 3:
                        return O.next = 5, W(g);
                      case 5:
                      case "end":
                        return O.stop();
                    }
                  }, K);
                }))();
              },
              applyAudioConnectorOnRelayedToRoutedTransition() {
                return (0, o.default)(/* @__PURE__ */ t.default.mark(function Z() {
                  return t.default.wrap(function(L) {
                    for (; ; ) switch (L.prev = L.next) {
                      case 0:
                        if (Q) {
                          L.next = 2;
                          break;
                        }
                        return L.abrupt("return");
                      case 2:
                        return L.next = 4, W(A);
                      case 4:
                      case "end":
                        return L.stop();
                    }
                  }, Z);
                }))();
              },
              clearAudioMediaProcessorConnector(Z) {
                N && (G(Z), w());
              },
              resetAudioStreamAndTrack(Z) {
                N && (G(Z), N = null);
              }
            };
          };
          r.default = p;
        },
        /* 708 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = function(o, l) {
            l === void 0 && (l = {});
            const c = l.document || document, d = l.MediaStream || (typeof window !== void 0 ? window : Dn).MediaStream, u = c.createElement("video"), h = new d([o]);
            return u.srcObject = h, u;
          };
          r.default = n;
        },
        /* 709 */
        /***/
        function(i, r, e) {
          var n = e(710), t = e(276), o = n(function(l, c, d) {
            return l + (d ? " " : "") + t(c);
          });
          i.exports = o;
        },
        /* 710 */
        /***/
        function(i, r, e) {
          var n = e(711), t = e(712), o = e(715), l = "['’]", c = RegExp(l, "g");
          function d(u) {
            return function(h) {
              return n(o(t(h).replace(c, "")), u, "");
            };
          }
          i.exports = d;
        },
        /* 711 */
        /***/
        function(i, r) {
          function e(n, t, o, l) {
            var c = -1, d = n == null ? 0 : n.length;
            for (l && d && (o = n[++c]); ++c < d; )
              o = t(o, n[c], c, n);
            return o;
          }
          i.exports = e;
        },
        /* 712 */
        /***/
        function(i, r, e) {
          var n = e(713), t = e(60), o = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, l = "\\u0300-\\u036f", c = "\\ufe20-\\ufe2f", d = "\\u20d0-\\u20ff", u = l + c + d, h = "[" + u + "]", A = RegExp(h, "g");
          function g(f) {
            return f = t(f), f && f.replace(o, n).replace(A, "");
          }
          i.exports = g;
        },
        /* 713 */
        /***/
        function(i, r, e) {
          var n = e(714), t = {
            // Latin-1 Supplement block.
            À: "A",
            Á: "A",
            Â: "A",
            Ã: "A",
            Ä: "A",
            Å: "A",
            à: "a",
            á: "a",
            â: "a",
            ã: "a",
            ä: "a",
            å: "a",
            Ç: "C",
            ç: "c",
            Ð: "D",
            ð: "d",
            È: "E",
            É: "E",
            Ê: "E",
            Ë: "E",
            è: "e",
            é: "e",
            ê: "e",
            ë: "e",
            Ì: "I",
            Í: "I",
            Î: "I",
            Ï: "I",
            ì: "i",
            í: "i",
            î: "i",
            ï: "i",
            Ñ: "N",
            ñ: "n",
            Ò: "O",
            Ó: "O",
            Ô: "O",
            Õ: "O",
            Ö: "O",
            Ø: "O",
            ò: "o",
            ó: "o",
            ô: "o",
            õ: "o",
            ö: "o",
            ø: "o",
            Ù: "U",
            Ú: "U",
            Û: "U",
            Ü: "U",
            ù: "u",
            ú: "u",
            û: "u",
            ü: "u",
            Ý: "Y",
            ý: "y",
            ÿ: "y",
            Æ: "Ae",
            æ: "ae",
            Þ: "Th",
            þ: "th",
            ß: "ss",
            // Latin Extended-A block.
            Ā: "A",
            Ă: "A",
            Ą: "A",
            ā: "a",
            ă: "a",
            ą: "a",
            Ć: "C",
            Ĉ: "C",
            Ċ: "C",
            Č: "C",
            ć: "c",
            ĉ: "c",
            ċ: "c",
            č: "c",
            Ď: "D",
            Đ: "D",
            ď: "d",
            đ: "d",
            Ē: "E",
            Ĕ: "E",
            Ė: "E",
            Ę: "E",
            Ě: "E",
            ē: "e",
            ĕ: "e",
            ė: "e",
            ę: "e",
            ě: "e",
            Ĝ: "G",
            Ğ: "G",
            Ġ: "G",
            Ģ: "G",
            ĝ: "g",
            ğ: "g",
            ġ: "g",
            ģ: "g",
            Ĥ: "H",
            Ħ: "H",
            ĥ: "h",
            ħ: "h",
            Ĩ: "I",
            Ī: "I",
            Ĭ: "I",
            Į: "I",
            İ: "I",
            ĩ: "i",
            ī: "i",
            ĭ: "i",
            į: "i",
            ı: "i",
            Ĵ: "J",
            ĵ: "j",
            Ķ: "K",
            ķ: "k",
            ĸ: "k",
            Ĺ: "L",
            Ļ: "L",
            Ľ: "L",
            Ŀ: "L",
            Ł: "L",
            ĺ: "l",
            ļ: "l",
            ľ: "l",
            ŀ: "l",
            ł: "l",
            Ń: "N",
            Ņ: "N",
            Ň: "N",
            Ŋ: "N",
            ń: "n",
            ņ: "n",
            ň: "n",
            ŋ: "n",
            Ō: "O",
            Ŏ: "O",
            Ő: "O",
            ō: "o",
            ŏ: "o",
            ő: "o",
            Ŕ: "R",
            Ŗ: "R",
            Ř: "R",
            ŕ: "r",
            ŗ: "r",
            ř: "r",
            Ś: "S",
            Ŝ: "S",
            Ş: "S",
            Š: "S",
            ś: "s",
            ŝ: "s",
            ş: "s",
            š: "s",
            Ţ: "T",
            Ť: "T",
            Ŧ: "T",
            ţ: "t",
            ť: "t",
            ŧ: "t",
            Ũ: "U",
            Ū: "U",
            Ŭ: "U",
            Ů: "U",
            Ű: "U",
            Ų: "U",
            ũ: "u",
            ū: "u",
            ŭ: "u",
            ů: "u",
            ű: "u",
            ų: "u",
            Ŵ: "W",
            ŵ: "w",
            Ŷ: "Y",
            ŷ: "y",
            Ÿ: "Y",
            Ź: "Z",
            Ż: "Z",
            Ž: "Z",
            ź: "z",
            ż: "z",
            ž: "z",
            Ĳ: "IJ",
            ĳ: "ij",
            Œ: "Oe",
            œ: "oe",
            ŉ: "'n",
            ſ: "s"
          }, o = n(t);
          i.exports = o;
        },
        /* 714 */
        /***/
        function(i, r) {
          function e(n) {
            return function(t) {
              return n == null ? void 0 : n[t];
            };
          }
          i.exports = e;
        },
        /* 715 */
        /***/
        function(i, r, e) {
          var n = e(716), t = e(717), o = e(60), l = e(718);
          function c(d, u, h) {
            return d = o(d), u = h ? void 0 : u, u === void 0 ? t(d) ? l(d) : n(d) : d.match(u) || [];
          }
          i.exports = c;
        },
        /* 716 */
        /***/
        function(i, r) {
          var e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
          function n(t) {
            return t.match(e) || [];
          }
          i.exports = n;
        },
        /* 717 */
        /***/
        function(i, r) {
          var e = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
          function n(t) {
            return e.test(t);
          }
          i.exports = n;
        },
        /* 718 */
        /***/
        function(i, r) {
          var e = "\\ud800-\\udfff", n = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", o = "\\u20d0-\\u20ff", l = n + t + o, c = "\\u2700-\\u27bf", d = "a-z\\xdf-\\xf6\\xf8-\\xff", u = "\\xac\\xb1\\xd7\\xf7", h = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", A = "\\u2000-\\u206f", g = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", f = "A-Z\\xc0-\\xd6\\xd8-\\xde", p = "\\ufe0e\\ufe0f", v = u + h + A + g, b = "['’]", m = "[" + v + "]", y = "[" + l + "]", U = "\\d+", B = "[" + c + "]", Q = "[" + d + "]", N = "[^" + e + v + U + c + d + f + "]", J = "\\ud83c[\\udffb-\\udfff]", w = "(?:" + y + "|" + J + ")", W = "[^" + e + "]", G = "(?:\\ud83c[\\udde6-\\uddff]){2}", Z = "[\\ud800-\\udbff][\\udc00-\\udfff]", K = "[" + f + "]", L = "\\u200d", O = "(?:" + Q + "|" + N + ")", de = "(?:" + K + "|" + N + ")", oe = "(?:" + b + "(?:d|ll|m|re|s|t|ve))?", fe = "(?:" + b + "(?:D|LL|M|RE|S|T|VE))?", ge = w + "?", we = "[" + p + "]?", _e = "(?:" + L + "(?:" + [W, G, Z].join("|") + ")" + we + ge + ")*", Te = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Pe = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $e = we + ge + _e, Bt = "(?:" + [B, G, Z].join("|") + ")" + $e, Le = RegExp([
            K + "?" + Q + "+" + oe + "(?=" + [m, K, "$"].join("|") + ")",
            de + "+" + fe + "(?=" + [m, K + O, "$"].join("|") + ")",
            K + "?" + O + "+" + oe,
            K + "+" + fe,
            Pe,
            Te,
            U,
            Bt
          ].join("|"), "g");
          function at(pt) {
            return pt.match(Le) || [];
          }
          i.exports = at;
        },
        /* 719 */
        /***/
        function(i, r, e) {
          (function(n, t) {
            var o = e(0);
            r.__esModule = !0, r.WavExporterTransformer = r.VonageNoiseSuppression = r.NoiseSuppressionTransformer = void 0, r.createVonageNoiseSuppression = zd;
            var l = o(e(4)), c = o(e(179)), d = o(e(29)), u = o(e(5)), h = o(e(30)), A = o(e(161)), g = function(xe) {
              function ot() {
                var re = this || self;
                return delete xe.prototype.__magic__, re;
              }
              if (typeof globalThis == "object")
                return globalThis;
              if (this)
                return ot();
              xe.defineProperty(xe.prototype, "__magic__", { configurable: !0, get: ot });
              var ye = __magic__;
              return ye;
            }(Object);
            function f(xe, ot) {
              var ye = typeof Symbol != "undefined" && xe[Symbol.iterator] || xe["@@iterator"];
              if (ye) return (ye = ye.call(xe)).next.bind(ye);
              if (Array.isArray(xe) || (ye = p(xe)) || ot) {
                ye && (xe = ye);
                var re = 0;
                return function() {
                  return re >= xe.length ? { done: !0 } : { done: !1, value: xe[re++] };
                };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function p(xe, ot) {
              if (xe) {
                if (typeof xe == "string") return v(xe, ot);
                var ye = Object.prototype.toString.call(xe).slice(8, -1);
                if (ye === "Object" && xe.constructor && (ye = xe.constructor.name), ye === "Map" || ye === "Set") return Array.from(xe);
                if (ye === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ye)) return v(xe, ot);
              }
            }
            function v(xe, ot) {
              (ot == null || ot > xe.length) && (ot = xe.length);
              for (var ye = 0, re = new Array(ot); ye < ot; ye++) re[ye] = xe[ye];
              return re;
            }
            let b;
            {
              var m = (() => {
                var xe = location.href;
                return function(ot) {
                  ot === void 0 && (ot = {});
                  var ye = ot, re, Be;
                  ye.ready = new n((V, k) => {
                    re = V, Be = k;
                  });
                  var He = Object.assign({}, ye), Xe = "./this.program", ut = (V, k) => {
                    throw k;
                  }, ct = typeof window == "object", Xt = typeof importScripts == "function";
                  typeof t == "object" && typeof t.versions == "object" && t.versions.node;
                  var pn = "";
                  function un(V) {
                    return ye.locateFile ? ye.locateFile(V, pn) : pn + V;
                  }
                  var vt, gr, sr;
                  (ct || Xt) && (Xt ? pn = self.location.href : typeof document != "undefined" && document.currentScript && (pn = document.currentScript.src), xe && (pn = xe), pn.indexOf("blob:") !== 0 ? pn = pn.substr(0, pn.replace(/[?#].*/, "").lastIndexOf("/") + 1) : pn = "", vt = (V) => {
                    var k = new XMLHttpRequest();
                    return k.open("GET", V, !1), k.send(null), k.responseText;
                  }, Xt && (sr = (V) => {
                    var k = new XMLHttpRequest();
                    return k.open("GET", V, !1), k.responseType = "arraybuffer", k.send(null), new Uint8Array(k.response);
                  }), gr = (V, k, _) => {
                    var ue = new XMLHttpRequest();
                    ue.open("GET", V, !0), ue.responseType = "arraybuffer", ue.onload = () => {
                      if (ue.status == 200 || ue.status == 0 && ue.response) {
                        k(ue.response);
                        return;
                      }
                      _();
                    }, ue.onerror = _, ue.send(null);
                  });
                  var an = ye.print || console.log.bind(console), En = ye.printErr || console.error.bind(console);
                  Object.assign(ye, He), He = null, ye.arguments && ye.arguments, ye.thisProgram && (Xe = ye.thisProgram), ye.quit && (ut = ye.quit);
                  var fn;
                  ye.wasmBinary && (fn = ye.wasmBinary), typeof WebAssembly != "object" && sc("no native wasm support detected");
                  var Fr, Ro = !1;
                  function ca(V, k) {
                    V || sc(k);
                  }
                  var Co, ga, aa, Dl, Jo, Pi, wa, yl;
                  function Ci() {
                    var V = Fr.buffer;
                    ye.HEAP8 = Co = new Int8Array(V), ye.HEAP16 = aa = new Int16Array(V), ye.HEAPU8 = ga = new Uint8Array(V), ye.HEAPU16 = Dl = new Uint16Array(V), ye.HEAP32 = Jo = new Int32Array(V), ye.HEAPU32 = Pi = new Uint32Array(V), ye.HEAPF32 = wa = new Float32Array(V), ye.HEAPF64 = yl = new Float64Array(V);
                  }
                  var Ti = [], Di = [], Gd = [], _l = [];
                  function Zl() {
                    if (ye.preRun)
                      for (typeof ye.preRun == "function" && (ye.preRun = [ye.preRun]); ye.preRun.length; )
                        wc(ye.preRun.shift());
                    Fc(Ti);
                  }
                  function Ml() {
                    !ye.noFSInit && !Ne.init.initialized && Ne.init(), Ne.ignorePermissions = !1, Fc(Di);
                  }
                  function kc() {
                    FA(), Fc(Gd), Ne.quit();
                  }
                  function Td() {
                    if (ye.postRun)
                      for (typeof ye.postRun == "function" && (ye.postRun = [ye.postRun]); ye.postRun.length; )
                        Yl(ye.postRun.shift());
                    Fc(_l);
                  }
                  function wc(V) {
                    Ti.unshift(V);
                  }
                  function $l(V) {
                    Di.unshift(V);
                  }
                  function Yl(V) {
                    _l.unshift(V);
                  }
                  var js = 0, ac = null;
                  function Dc(V) {
                    return V;
                  }
                  function Ll(V) {
                    js++, ye.monitorRunDependencies && ye.monitorRunDependencies(js);
                  }
                  function ed(V) {
                    if (js--, ye.monitorRunDependencies && ye.monitorRunDependencies(js), js == 0 && ac) {
                      var k = ac;
                      ac = null, k();
                    }
                  }
                  function sc(V) {
                    ye.onAbort && ye.onAbort(V), V = "Aborted(" + V + ")", En(V), Ro = !0, V += ". Build with -sASSERTIONS for more info.";
                    var k = new WebAssembly.RuntimeError(V);
                    throw Be(k), k;
                  }
                  var Ql = "data:application/octet-stream;base64,", ql = (V) => V.startsWith(Ql), Ds;
                  ye.locateFile ? (Ds = "main-bin-mono.wasm", ql(Ds) || (Ds = un(Ds))) : Ds = new URL("main-bin-mono.wasm", location.href).href;
                  function jd(V) {
                    if (V == Ds && fn)
                      return new Uint8Array(fn);
                    if (sr)
                      return sr(V);
                    throw "both async and sync fetching of the wasm failed";
                  }
                  function Sc(V) {
                    return !fn && (ct || Xt) && typeof fetch == "function" ? fetch(V, { credentials: "same-origin" }).then((k) => {
                      if (!k.ok)
                        throw "failed to load wasm binary file at '" + V + "'";
                      return k.arrayBuffer();
                    }).catch(() => jd(V)) : n.resolve().then(() => jd(V));
                  }
                  function Cl(V, k, _) {
                    return Sc(V).then((ue) => WebAssembly.instantiate(ue, k)).then((ue) => ue).then(_, (ue) => {
                      En(`failed to asynchronously prepare wasm: ${ue}`), sc(ue);
                    });
                  }
                  function _r(V, k, _, ue) {
                    return !V && typeof WebAssembly.instantiateStreaming == "function" && !ql(k) && typeof fetch == "function" ? fetch(k, { credentials: "same-origin" }).then((Me) => {
                      var lt = WebAssembly.instantiateStreaming(Me, _);
                      return lt.then(ue, function(Ut) {
                        return En(`wasm streaming compile failed: ${Ut}`), En("falling back to ArrayBuffer instantiation"), Cl(k, _, ue);
                      });
                    }) : Cl(k, _, ue);
                  }
                  function Xd() {
                    var V = { a: Fh };
                    function k(ue, Me) {
                      return Qa = ue.exports, Fr = Qa.ua, Ci(), C0 = Qa.wa, $l(Qa.va), ed(), Qa;
                    }
                    Ll();
                    function _(ue) {
                      k(ue.instance);
                    }
                    if (ye.instantiateWasm)
                      try {
                        return ye.instantiateWasm(V, k);
                      } catch (ue) {
                        En(`Module.instantiateWasm callback failed with error: ${ue}`), Be(ue);
                      }
                    return _r(fn, Ds, V, _).catch(Be), {};
                  }
                  var to, Za;
                  function sa(V, k, _, ue) {
                    const Me = C0.length, lt = new Uint8Array(ga.slice(V + k, V + _));
                    try {
                      var Ut = new WebAssembly.Module(lt), Dt = new WebAssembly.Instance(Ut, { env: { memory: Fr } });
                      for (var kn in Dt.exports) {
                        var _n = Dt.exports[kn];
                        addFunction(_n);
                      }
                      return Me < C0.length ? Me : ue;
                    } catch ($r) {
                      return console.log($r), ue;
                    }
                  }
                  function Ec(V) {
                    this.name = "ExitStatus", this.message = `Program terminated with exit(${V})`, this.status = V;
                  }
                  var Fc = (V) => {
                    for (; V.length > 0; )
                      V.shift()(ye);
                  }, Cd = ye.noExitRuntime || !1, Sl = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0, Uo = (V, k, _) => {
                    for (var ue = k + _, Me = k; V[Me] && !(Me >= ue); ) ++Me;
                    if (Me - k > 16 && V.buffer && Sl)
                      return Sl.decode(V.subarray(k, Me));
                    for (var lt = ""; k < Me; ) {
                      var Ut = V[k++];
                      if (!(Ut & 128)) {
                        lt += String.fromCharCode(Ut);
                        continue;
                      }
                      var Dt = V[k++] & 63;
                      if ((Ut & 224) == 192) {
                        lt += String.fromCharCode((Ut & 31) << 6 | Dt);
                        continue;
                      }
                      var kn = V[k++] & 63;
                      if ((Ut & 240) == 224 ? Ut = (Ut & 15) << 12 | Dt << 6 | kn : Ut = (Ut & 7) << 18 | Dt << 12 | kn << 6 | V[k++] & 63, Ut < 65536)
                        lt += String.fromCharCode(Ut);
                      else {
                        var _n = Ut - 65536;
                        lt += String.fromCharCode(55296 | _n >> 10, 56320 | _n & 1023);
                      }
                    }
                    return lt;
                  }, ja = (V, k) => V ? Uo(ga, V, k) : "", Mc = (V, k, _, ue) => {
                    sc(`Assertion failed: ${ja(V)}, at: ` + [k ? ja(k) : "unknown filename", _, ue ? ja(ue) : "unknown function"]);
                  }, td = [], Ud = (V) => {
                    var k = new nd(V);
                    return k.get_caught() || k.set_caught(!0), k.set_rethrown(!1), td.push(k), CA(k.excPtr), k.get_exception_ptr();
                  }, fl = 0, ou = () => {
                    Ws(0, 0);
                    var V = td.pop();
                    QA(V.excPtr), fl = 0;
                  };
                  function nd(V) {
                    this.excPtr = V, this.ptr = V - 24, this.set_type = function(k) {
                      Pi[this.ptr + 4 >> 2] = k;
                    }, this.get_type = function() {
                      return Pi[this.ptr + 4 >> 2];
                    }, this.set_destructor = function(k) {
                      Pi[this.ptr + 8 >> 2] = k;
                    }, this.get_destructor = function() {
                      return Pi[this.ptr + 8 >> 2];
                    }, this.set_caught = function(k) {
                      k = k ? 1 : 0, Co[this.ptr + 12 >> 0] = k;
                    }, this.get_caught = function() {
                      return Co[this.ptr + 12 >> 0] != 0;
                    }, this.set_rethrown = function(k) {
                      k = k ? 1 : 0, Co[this.ptr + 13 >> 0] = k;
                    }, this.get_rethrown = function() {
                      return Co[this.ptr + 13 >> 0] != 0;
                    }, this.init = function(k, _) {
                      this.set_adjusted_ptr(0), this.set_type(k), this.set_destructor(_);
                    }, this.set_adjusted_ptr = function(k) {
                      Pi[this.ptr + 16 >> 2] = k;
                    }, this.get_adjusted_ptr = function() {
                      return Pi[this.ptr + 16 >> 2];
                    }, this.get_exception_ptr = function() {
                      var k = UA(this.get_type());
                      if (k)
                        return Pi[this.excPtr >> 2];
                      var _ = this.get_adjusted_ptr();
                      return _ !== 0 ? _ : this.excPtr;
                    };
                  }
                  var au = (V) => {
                    throw fl || (fl = V), fl;
                  }, lc = (V) => {
                    var k = fl;
                    if (!k)
                      return l0(0), 0;
                    var _ = new nd(k);
                    _.set_adjusted_ptr(k);
                    var ue = _.get_type();
                    if (!ue)
                      return l0(0), k;
                    for (var Me in V) {
                      var lt = V[Me];
                      if (lt === 0 || lt === ue)
                        break;
                      var Ut = _.ptr + 16;
                      if (T0(lt, ue, Ut))
                        return l0(lt), k;
                    }
                    return l0(ue), k;
                  }, Vc = () => lc([]), _s = (V) => lc([V]), da = () => {
                    var V = td.pop();
                    V || sc("no exception to throw");
                    var k = V.excPtr;
                    throw V.get_rethrown() || (td.push(V), V.set_rethrown(!0), V.set_caught(!1)), fl = k, fl;
                  }, kd = (V, k, _) => {
                    var ue = new nd(V);
                    throw ue.init(k, _), fl = V, fl;
                  }, la = { isAbs: (V) => V.charAt(0) === "/", splitPath: (V) => {
                    var k = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                    return k.exec(V).slice(1);
                  }, normalizeArray: (V, k) => {
                    for (var _ = 0, ue = V.length - 1; ue >= 0; ue--) {
                      var Me = V[ue];
                      Me === "." ? V.splice(ue, 1) : Me === ".." ? (V.splice(ue, 1), _++) : _ && (V.splice(ue, 1), _--);
                    }
                    if (k)
                      for (; _; _--)
                        V.unshift("..");
                    return V;
                  }, normalize: (V) => {
                    var k = la.isAbs(V), _ = V.substr(-1) === "/";
                    return V = la.normalizeArray(V.split("/").filter((ue) => !!ue), !k).join("/"), !V && !k && (V = "."), V && _ && (V += "/"), (k ? "/" : "") + V;
                  }, dirname: (V) => {
                    var k = la.splitPath(V), _ = k[0], ue = k[1];
                    return !_ && !ue ? "." : (ue && (ue = ue.substr(0, ue.length - 1)), _ + ue);
                  }, basename: (V) => {
                    if (V === "/") return "/";
                    V = la.normalize(V), V = V.replace(/\/$/, "");
                    var k = V.lastIndexOf("/");
                    return k === -1 ? V : V.substr(k + 1);
                  }, join: function() {
                    var k = Array.prototype.slice.call(arguments);
                    return la.normalize(k.join("/"));
                  }, join2: (V, k) => la.normalize(V + "/" + k) }, cc = () => {
                    if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
                      return (V) => crypto.getRandomValues(V);
                    sc("initRandomDevice");
                  }, Da = (V) => (Da = cc())(V), ea = { resolve: function() {
                    for (var k = "", _ = !1, ue = arguments.length - 1; ue >= -1 && !_; ue--) {
                      var Me = ue >= 0 ? arguments[ue] : Ne.cwd();
                      if (typeof Me != "string")
                        throw new TypeError("Arguments to path.resolve must be strings");
                      if (!Me)
                        return "";
                      k = Me + "/" + k, _ = la.isAbs(Me);
                    }
                    return k = la.normalizeArray(k.split("/").filter((lt) => !!lt), !_).join("/"), (_ ? "/" : "") + k || ".";
                  }, relative: (V, k) => {
                    V = ea.resolve(V).substr(1), k = ea.resolve(k).substr(1);
                    function _(_n) {
                      for (var $r = 0; $r < _n.length && _n[$r] === ""; $r++)
                        ;
                      for (var Mi = _n.length - 1; Mi >= 0 && _n[Mi] === ""; Mi--)
                        ;
                      return $r > Mi ? [] : _n.slice($r, Mi - $r + 1);
                    }
                    for (var ue = _(V.split("/")), Me = _(k.split("/")), lt = Math.min(ue.length, Me.length), Ut = lt, Dt = 0; Dt < lt; Dt++)
                      if (ue[Dt] !== Me[Dt]) {
                        Ut = Dt;
                        break;
                      }
                    for (var kn = [], Dt = Ut; Dt < ue.length; Dt++)
                      kn.push("..");
                    return kn = kn.concat(Me.slice(Ut)), kn.join("/");
                  } }, ec = [], Yc = (V) => {
                    for (var k = 0, _ = 0; _ < V.length; ++_) {
                      var ue = V.charCodeAt(_);
                      ue <= 127 ? k++ : ue <= 2047 ? k += 2 : ue >= 55296 && ue <= 57343 ? (k += 4, ++_) : k += 3;
                    }
                    return k;
                  }, rd = (V, k, _, ue) => {
                    if (!(ue > 0)) return 0;
                    for (var Me = _, lt = _ + ue - 1, Ut = 0; Ut < V.length; ++Ut) {
                      var Dt = V.charCodeAt(Ut);
                      if (Dt >= 55296 && Dt <= 57343) {
                        var kn = V.charCodeAt(++Ut);
                        Dt = 65536 + ((Dt & 1023) << 10) | kn & 1023;
                      }
                      if (Dt <= 127) {
                        if (_ >= lt) break;
                        k[_++] = Dt;
                      } else if (Dt <= 2047) {
                        if (_ + 1 >= lt) break;
                        k[_++] = 192 | Dt >> 6, k[_++] = 128 | Dt & 63;
                      } else if (Dt <= 65535) {
                        if (_ + 2 >= lt) break;
                        k[_++] = 224 | Dt >> 12, k[_++] = 128 | Dt >> 6 & 63, k[_++] = 128 | Dt & 63;
                      } else {
                        if (_ + 3 >= lt) break;
                        k[_++] = 240 | Dt >> 18, k[_++] = 128 | Dt >> 12 & 63, k[_++] = 128 | Dt >> 6 & 63, k[_++] = 128 | Dt & 63;
                      }
                    }
                    return k[_] = 0, _ - Me;
                  };
                  function Lc(V, k, _) {
                    var ue = Yc(V) + 1, Me = new Array(ue), lt = rd(V, Me, 0, Me.length);
                    return k && (Me.length = lt), Me;
                  }
                  var fu = () => {
                    if (!ec.length) {
                      var V = null;
                      if (typeof window != "undefined" && typeof window.prompt == "function" ? (V = window.prompt("Input: "), V !== null && (V += `
`)) : typeof readline == "function" && (V = readline(), V !== null && (V += `
`)), !V)
                        return null;
                      ec = Lc(V, !0);
                    }
                    return ec.shift();
                  }, El = { ttys: [], init() {
                  }, shutdown() {
                  }, register(V, k) {
                    El.ttys[V] = { input: [], output: [], ops: k }, Ne.registerDevice(V, El.stream_ops);
                  }, stream_ops: { open(V) {
                    var k = El.ttys[V.node.rdev];
                    if (!k)
                      throw new Ne.ErrnoError(43);
                    V.tty = k, V.seekable = !1;
                  }, close(V) {
                    V.tty.ops.fsync(V.tty);
                  }, fsync(V) {
                    V.tty.ops.fsync(V.tty);
                  }, read(V, k, _, ue, Me) {
                    if (!V.tty || !V.tty.ops.get_char)
                      throw new Ne.ErrnoError(60);
                    for (var lt = 0, Ut = 0; Ut < ue; Ut++) {
                      var Dt;
                      try {
                        Dt = V.tty.ops.get_char(V.tty);
                      } catch {
                        throw new Ne.ErrnoError(29);
                      }
                      if (Dt === void 0 && lt === 0)
                        throw new Ne.ErrnoError(6);
                      if (Dt == null) break;
                      lt++, k[_ + Ut] = Dt;
                    }
                    return lt && (V.node.timestamp = Date.now()), lt;
                  }, write(V, k, _, ue, Me) {
                    if (!V.tty || !V.tty.ops.put_char)
                      throw new Ne.ErrnoError(60);
                    try {
                      for (var lt = 0; lt < ue; lt++)
                        V.tty.ops.put_char(V.tty, k[_ + lt]);
                    } catch {
                      throw new Ne.ErrnoError(29);
                    }
                    return ue && (V.node.timestamp = Date.now()), lt;
                  } }, default_tty_ops: { get_char(V) {
                    return fu();
                  }, put_char(V, k) {
                    k === null || k === 10 ? (an(Uo(V.output, 0)), V.output = []) : k != 0 && V.output.push(k);
                  }, fsync(V) {
                    V.output && V.output.length > 0 && (an(Uo(V.output, 0)), V.output = []);
                  }, ioctl_tcgets(V) {
                    return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
                  }, ioctl_tcsets(V, k, _) {
                    return 0;
                  }, ioctl_tiocgwinsz(V) {
                    return [24, 80];
                  } }, default_tty1_ops: { put_char(V, k) {
                    k === null || k === 10 ? (En(Uo(V.output, 0)), V.output = []) : k != 0 && V.output.push(k);
                  }, fsync(V) {
                    V.output && V.output.length > 0 && (En(Uo(V.output, 0)), V.output = []);
                  } } }, xc = (V, k) => (ga.fill(0, V, V + k), V), _d = (V, k) => Math.ceil(V / k) * k, vo = (V) => {
                    V = _d(V, 65536);
                    var k = yA(65536, V);
                    return k ? xc(k, V) : 0;
                  }, co = { ops_table: null, mount(V) {
                    return co.createNode(null, "/", 16895, 0);
                  }, createNode(V, k, _, ue) {
                    if (Ne.isBlkdev(_) || Ne.isFIFO(_))
                      throw new Ne.ErrnoError(63);
                    co.ops_table || (co.ops_table = { dir: { node: { getattr: co.node_ops.getattr, setattr: co.node_ops.setattr, lookup: co.node_ops.lookup, mknod: co.node_ops.mknod, rename: co.node_ops.rename, unlink: co.node_ops.unlink, rmdir: co.node_ops.rmdir, readdir: co.node_ops.readdir, symlink: co.node_ops.symlink }, stream: { llseek: co.stream_ops.llseek } }, file: { node: { getattr: co.node_ops.getattr, setattr: co.node_ops.setattr }, stream: { llseek: co.stream_ops.llseek, read: co.stream_ops.read, write: co.stream_ops.write, allocate: co.stream_ops.allocate, mmap: co.stream_ops.mmap, msync: co.stream_ops.msync } }, link: { node: { getattr: co.node_ops.getattr, setattr: co.node_ops.setattr, readlink: co.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: co.node_ops.getattr, setattr: co.node_ops.setattr }, stream: Ne.chrdev_stream_ops } });
                    var Me = Ne.createNode(V, k, _, ue);
                    return Ne.isDir(Me.mode) ? (Me.node_ops = co.ops_table.dir.node, Me.stream_ops = co.ops_table.dir.stream, Me.contents = {}) : Ne.isFile(Me.mode) ? (Me.node_ops = co.ops_table.file.node, Me.stream_ops = co.ops_table.file.stream, Me.usedBytes = 0, Me.contents = null) : Ne.isLink(Me.mode) ? (Me.node_ops = co.ops_table.link.node, Me.stream_ops = co.ops_table.link.stream) : Ne.isChrdev(Me.mode) && (Me.node_ops = co.ops_table.chrdev.node, Me.stream_ops = co.ops_table.chrdev.stream), Me.timestamp = Date.now(), V && (V.contents[k] = Me, V.timestamp = Me.timestamp), Me;
                  }, getFileDataAsTypedArray(V) {
                    return V.contents ? V.contents.subarray ? V.contents.subarray(0, V.usedBytes) : new Uint8Array(V.contents) : new Uint8Array(0);
                  }, expandFileStorage(V, k) {
                    var _ = V.contents ? V.contents.length : 0;
                    if (!(_ >= k)) {
                      var ue = 1024 * 1024;
                      k = Math.max(k, _ * (_ < ue ? 2 : 1.125) >>> 0), _ != 0 && (k = Math.max(k, 256));
                      var Me = V.contents;
                      V.contents = new Uint8Array(k), V.usedBytes > 0 && V.contents.set(Me.subarray(0, V.usedBytes), 0);
                    }
                  }, resizeFileStorage(V, k) {
                    if (V.usedBytes != k)
                      if (k == 0)
                        V.contents = null, V.usedBytes = 0;
                      else {
                        var _ = V.contents;
                        V.contents = new Uint8Array(k), _ && V.contents.set(_.subarray(0, Math.min(k, V.usedBytes))), V.usedBytes = k;
                      }
                  }, node_ops: { getattr(V) {
                    var k = {};
                    return k.dev = Ne.isChrdev(V.mode) ? V.id : 1, k.ino = V.id, k.mode = V.mode, k.nlink = 1, k.uid = 0, k.gid = 0, k.rdev = V.rdev, Ne.isDir(V.mode) ? k.size = 4096 : Ne.isFile(V.mode) ? k.size = V.usedBytes : Ne.isLink(V.mode) ? k.size = V.link.length : k.size = 0, k.atime = new Date(V.timestamp), k.mtime = new Date(V.timestamp), k.ctime = new Date(V.timestamp), k.blksize = 4096, k.blocks = Math.ceil(k.size / k.blksize), k;
                  }, setattr(V, k) {
                    k.mode !== void 0 && (V.mode = k.mode), k.timestamp !== void 0 && (V.timestamp = k.timestamp), k.size !== void 0 && co.resizeFileStorage(V, k.size);
                  }, lookup(V, k) {
                    throw Ne.genericErrors[44];
                  }, mknod(V, k, _, ue) {
                    return co.createNode(V, k, _, ue);
                  }, rename(V, k, _) {
                    if (Ne.isDir(V.mode)) {
                      var ue;
                      try {
                        ue = Ne.lookupNode(k, _);
                      } catch {
                      }
                      if (ue)
                        for (var Me in ue.contents)
                          throw new Ne.ErrnoError(55);
                    }
                    delete V.parent.contents[V.name], V.parent.timestamp = Date.now(), V.name = _, k.contents[_] = V, k.timestamp = V.parent.timestamp, V.parent = k;
                  }, unlink(V, k) {
                    delete V.contents[k], V.timestamp = Date.now();
                  }, rmdir(V, k) {
                    var _ = Ne.lookupNode(V, k);
                    for (var ue in _.contents)
                      throw new Ne.ErrnoError(55);
                    delete V.contents[k], V.timestamp = Date.now();
                  }, readdir(V) {
                    var k = [".", ".."];
                    for (var _ in V.contents)
                      V.contents.hasOwnProperty(_) && k.push(_);
                    return k;
                  }, symlink(V, k, _) {
                    var ue = co.createNode(V, k, 41471, 0);
                    return ue.link = _, ue;
                  }, readlink(V) {
                    if (!Ne.isLink(V.mode))
                      throw new Ne.ErrnoError(28);
                    return V.link;
                  } }, stream_ops: { read(V, k, _, ue, Me) {
                    var lt = V.node.contents;
                    if (Me >= V.node.usedBytes) return 0;
                    var Ut = Math.min(V.node.usedBytes - Me, ue);
                    if (Ut > 8 && lt.subarray)
                      k.set(lt.subarray(Me, Me + Ut), _);
                    else
                      for (var Dt = 0; Dt < Ut; Dt++) k[_ + Dt] = lt[Me + Dt];
                    return Ut;
                  }, write(V, k, _, ue, Me, lt) {
                    if (!ue) return 0;
                    var Ut = V.node;
                    if (Ut.timestamp = Date.now(), k.subarray && (!Ut.contents || Ut.contents.subarray)) {
                      if (lt)
                        return Ut.contents = k.subarray(_, _ + ue), Ut.usedBytes = ue, ue;
                      if (Ut.usedBytes === 0 && Me === 0)
                        return Ut.contents = k.slice(_, _ + ue), Ut.usedBytes = ue, ue;
                      if (Me + ue <= Ut.usedBytes)
                        return Ut.contents.set(k.subarray(_, _ + ue), Me), ue;
                    }
                    if (co.expandFileStorage(Ut, Me + ue), Ut.contents.subarray && k.subarray)
                      Ut.contents.set(k.subarray(_, _ + ue), Me);
                    else
                      for (var Dt = 0; Dt < ue; Dt++)
                        Ut.contents[Me + Dt] = k[_ + Dt];
                    return Ut.usedBytes = Math.max(Ut.usedBytes, Me + ue), ue;
                  }, llseek(V, k, _) {
                    var ue = k;
                    if (_ === 1 ? ue += V.position : _ === 2 && Ne.isFile(V.node.mode) && (ue += V.node.usedBytes), ue < 0)
                      throw new Ne.ErrnoError(28);
                    return ue;
                  }, allocate(V, k, _) {
                    co.expandFileStorage(V.node, k + _), V.node.usedBytes = Math.max(V.node.usedBytes, k + _);
                  }, mmap(V, k, _, ue, Me) {
                    if (!Ne.isFile(V.node.mode))
                      throw new Ne.ErrnoError(43);
                    var lt, Ut, Dt = V.node.contents;
                    if (!(Me & 2) && Dt.buffer === Co.buffer)
                      Ut = !1, lt = Dt.byteOffset;
                    else {
                      if ((_ > 0 || _ + k < Dt.length) && (Dt.subarray ? Dt = Dt.subarray(_, _ + k) : Dt = Array.prototype.slice.call(Dt, _, _ + k)), Ut = !0, lt = vo(k), !lt)
                        throw new Ne.ErrnoError(48);
                      Co.set(Dt, lt);
                    }
                    return { ptr: lt, allocated: Ut };
                  }, msync(V, k, _, ue, Me) {
                    return co.stream_ops.write(V, k, 0, ue, _, !1), 0;
                  } } }, id = (V, k, _, ue) => {
                    var Me = `al ${V}`;
                    gr(V, (lt) => {
                      ca(lt, `Loading data file "${V}" failed (no arrayBuffer).`), k(new Uint8Array(lt)), Me && ed();
                    }, (lt) => {
                      if (_)
                        _();
                      else
                        throw `Loading data file "${V}" failed.`;
                    }), Me && Ll();
                  }, wd = (V, k, _, ue, Me, lt) => {
                    Ne.createDataFile(V, k, _, ue, Me, lt);
                  }, Dd = ye.preloadPlugins || [], su = (V, k, _, ue) => {
                    typeof Browser != "undefined" && Browser.init();
                    var Me = !1;
                    return Dd.forEach((lt) => {
                      Me || lt.canHandle(k) && (lt.handle(V, k, _, ue), Me = !0);
                    }), Me;
                  }, Md = (V, k, _, ue, Me, lt, Ut, Dt, kn, _n) => {
                    var $r = k ? ea.resolve(la.join2(V, k)) : V;
                    function Mi(ri) {
                      function Dr(ro) {
                        _n && _n(), Dt || wd(V, k, ro, ue, Me, kn), lt && lt(), ed();
                      }
                      su(ri, $r, Dr, () => {
                        Ut && Ut(), ed();
                      }) || Dr(ri);
                    }
                    Ll(), typeof _ == "string" ? id(_, (ri) => Mi(ri), Ut) : Mi(_);
                  }, od = (V) => {
                    var k = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, _ = k[V];
                    if (typeof _ == "undefined")
                      throw new Error(`Unknown file open mode: ${V}`);
                    return _;
                  }, Je = (V, k) => {
                    var _ = 0;
                    return V && (_ |= 365), k && (_ |= 146), _;
                  }, Ne = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath(V, k) {
                    if (k === void 0 && (k = {}), V = ea.resolve(V), !V) return { path: "", node: null };
                    var _ = { follow_mount: !0, recurse_count: 0 };
                    if (k = Object.assign(_, k), k.recurse_count > 8)
                      throw new Ne.ErrnoError(32);
                    for (var ue = V.split("/").filter((Mi) => !!Mi), Me = Ne.root, lt = "/", Ut = 0; Ut < ue.length; Ut++) {
                      var Dt = Ut === ue.length - 1;
                      if (Dt && k.parent)
                        break;
                      if (Me = Ne.lookupNode(Me, ue[Ut]), lt = la.join2(lt, ue[Ut]), Ne.isMountpoint(Me) && (!Dt || Dt && k.follow_mount) && (Me = Me.mounted.root), !Dt || k.follow)
                        for (var kn = 0; Ne.isLink(Me.mode); ) {
                          var _n = Ne.readlink(lt);
                          lt = ea.resolve(la.dirname(lt), _n);
                          var $r = Ne.lookupPath(lt, { recurse_count: k.recurse_count + 1 });
                          if (Me = $r.node, kn++ > 40)
                            throw new Ne.ErrnoError(32);
                        }
                    }
                    return { path: lt, node: Me };
                  }, getPath(V) {
                    for (var k; ; ) {
                      if (Ne.isRoot(V)) {
                        var _ = V.mount.mountpoint;
                        return k ? _[_.length - 1] !== "/" ? `${_}/${k}` : _ + k : _;
                      }
                      k = k ? `${V.name}/${k}` : V.name, V = V.parent;
                    }
                  }, hashName(V, k) {
                    for (var _ = 0, ue = 0; ue < k.length; ue++)
                      _ = (_ << 5) - _ + k.charCodeAt(ue) | 0;
                    return (V + _ >>> 0) % Ne.nameTable.length;
                  }, hashAddNode(V) {
                    var k = Ne.hashName(V.parent.id, V.name);
                    V.name_next = Ne.nameTable[k], Ne.nameTable[k] = V;
                  }, hashRemoveNode(V) {
                    var k = Ne.hashName(V.parent.id, V.name);
                    if (Ne.nameTable[k] === V)
                      Ne.nameTable[k] = V.name_next;
                    else
                      for (var _ = Ne.nameTable[k]; _; ) {
                        if (_.name_next === V) {
                          _.name_next = V.name_next;
                          break;
                        }
                        _ = _.name_next;
                      }
                  }, lookupNode(V, k) {
                    var _ = Ne.mayLookup(V);
                    if (_)
                      throw new Ne.ErrnoError(_, V);
                    for (var ue = Ne.hashName(V.id, k), Me = Ne.nameTable[ue]; Me; Me = Me.name_next) {
                      var lt = Me.name;
                      if (Me.parent.id === V.id && lt === k)
                        return Me;
                    }
                    return Ne.lookup(V, k);
                  }, createNode(V, k, _, ue) {
                    var Me = new Ne.FSNode(V, k, _, ue);
                    return Ne.hashAddNode(Me), Me;
                  }, destroyNode(V) {
                    Ne.hashRemoveNode(V);
                  }, isRoot(V) {
                    return V === V.parent;
                  }, isMountpoint(V) {
                    return !!V.mounted;
                  }, isFile(V) {
                    return (V & 61440) === 32768;
                  }, isDir(V) {
                    return (V & 61440) === 16384;
                  }, isLink(V) {
                    return (V & 61440) === 40960;
                  }, isChrdev(V) {
                    return (V & 61440) === 8192;
                  }, isBlkdev(V) {
                    return (V & 61440) === 24576;
                  }, isFIFO(V) {
                    return (V & 61440) === 4096;
                  }, isSocket(V) {
                    return (V & 49152) === 49152;
                  }, flagsToPermissionString(V) {
                    var k = ["r", "w", "rw"][V & 3];
                    return V & 512 && (k += "w"), k;
                  }, nodePermissions(V, k) {
                    return Ne.ignorePermissions ? 0 : k.includes("r") && !(V.mode & 292) || k.includes("w") && !(V.mode & 146) || k.includes("x") && !(V.mode & 73) ? 2 : 0;
                  }, mayLookup(V) {
                    var k = Ne.nodePermissions(V, "x");
                    return k || (V.node_ops.lookup ? 0 : 2);
                  }, mayCreate(V, k) {
                    try {
                      var _ = Ne.lookupNode(V, k);
                      return 20;
                    } catch {
                    }
                    return Ne.nodePermissions(V, "wx");
                  }, mayDelete(V, k, _) {
                    var ue;
                    try {
                      ue = Ne.lookupNode(V, k);
                    } catch (lt) {
                      return lt.errno;
                    }
                    var Me = Ne.nodePermissions(V, "wx");
                    if (Me)
                      return Me;
                    if (_) {
                      if (!Ne.isDir(ue.mode))
                        return 54;
                      if (Ne.isRoot(ue) || Ne.getPath(ue) === Ne.cwd())
                        return 10;
                    } else if (Ne.isDir(ue.mode))
                      return 31;
                    return 0;
                  }, mayOpen(V, k) {
                    return V ? Ne.isLink(V.mode) ? 32 : Ne.isDir(V.mode) && (Ne.flagsToPermissionString(k) !== "r" || k & 512) ? 31 : Ne.nodePermissions(V, Ne.flagsToPermissionString(k)) : 44;
                  }, MAX_OPEN_FDS: 4096, nextfd() {
                    for (var V = 0; V <= Ne.MAX_OPEN_FDS; V++)
                      if (!Ne.streams[V])
                        return V;
                    throw new Ne.ErrnoError(33);
                  }, getStreamChecked(V) {
                    var k = Ne.getStream(V);
                    if (!k)
                      throw new Ne.ErrnoError(8);
                    return k;
                  }, getStream: (V) => Ne.streams[V], createStream(V, k) {
                    return k === void 0 && (k = -1), Ne.FSStream || (Ne.FSStream = function() {
                      this.shared = {};
                    }, Ne.FSStream.prototype = {}, Object.defineProperties(Ne.FSStream.prototype, { object: { get() {
                      return this.node;
                    }, set(_) {
                      this.node = _;
                    } }, isRead: { get() {
                      return (this.flags & 2097155) !== 1;
                    } }, isWrite: { get() {
                      return (this.flags & 2097155) !== 0;
                    } }, isAppend: { get() {
                      return this.flags & 1024;
                    } }, flags: { get() {
                      return this.shared.flags;
                    }, set(_) {
                      this.shared.flags = _;
                    } }, position: { get() {
                      return this.shared.position;
                    }, set(_) {
                      this.shared.position = _;
                    } } })), V = Object.assign(new Ne.FSStream(), V), k == -1 && (k = Ne.nextfd()), V.fd = k, Ne.streams[k] = V, V;
                  }, closeStream(V) {
                    Ne.streams[V] = null;
                  }, chrdev_stream_ops: { open(V) {
                    var k = Ne.getDevice(V.node.rdev);
                    V.stream_ops = k.stream_ops, V.stream_ops.open && V.stream_ops.open(V);
                  }, llseek() {
                    throw new Ne.ErrnoError(70);
                  } }, major: (V) => V >> 8, minor: (V) => V & 255, makedev: (V, k) => V << 8 | k, registerDevice(V, k) {
                    Ne.devices[V] = { stream_ops: k };
                  }, getDevice: (V) => Ne.devices[V], getMounts(V) {
                    for (var k = [], _ = [V]; _.length; ) {
                      var ue = _.pop();
                      k.push(ue), _.push.apply(_, ue.mounts);
                    }
                    return k;
                  }, syncfs(V, k) {
                    typeof V == "function" && (k = V, V = !1), Ne.syncFSRequests++, Ne.syncFSRequests > 1 && En(`warning: ${Ne.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
                    var _ = Ne.getMounts(Ne.root.mount), ue = 0;
                    function Me(Ut) {
                      return Ne.syncFSRequests--, k(Ut);
                    }
                    function lt(Ut) {
                      if (Ut)
                        return lt.errored ? void 0 : (lt.errored = !0, Me(Ut));
                      ++ue >= _.length && Me(null);
                    }
                    _.forEach((Ut) => {
                      if (!Ut.type.syncfs)
                        return lt(null);
                      Ut.type.syncfs(Ut, V, lt);
                    });
                  }, mount(V, k, _) {
                    var ue = _ === "/", Me = !_, lt;
                    if (ue && Ne.root)
                      throw new Ne.ErrnoError(10);
                    if (!ue && !Me) {
                      var Ut = Ne.lookupPath(_, { follow_mount: !1 });
                      if (_ = Ut.path, lt = Ut.node, Ne.isMountpoint(lt))
                        throw new Ne.ErrnoError(10);
                      if (!Ne.isDir(lt.mode))
                        throw new Ne.ErrnoError(54);
                    }
                    var Dt = { type: V, opts: k, mountpoint: _, mounts: [] }, kn = V.mount(Dt);
                    return kn.mount = Dt, Dt.root = kn, ue ? Ne.root = kn : lt && (lt.mounted = Dt, lt.mount && lt.mount.mounts.push(Dt)), kn;
                  }, unmount(V) {
                    var k = Ne.lookupPath(V, { follow_mount: !1 });
                    if (!Ne.isMountpoint(k.node))
                      throw new Ne.ErrnoError(28);
                    var _ = k.node, ue = _.mounted, Me = Ne.getMounts(ue);
                    Object.keys(Ne.nameTable).forEach((Ut) => {
                      for (var Dt = Ne.nameTable[Ut]; Dt; ) {
                        var kn = Dt.name_next;
                        Me.includes(Dt.mount) && Ne.destroyNode(Dt), Dt = kn;
                      }
                    }), _.mounted = null;
                    var lt = _.mount.mounts.indexOf(ue);
                    _.mount.mounts.splice(lt, 1);
                  }, lookup(V, k) {
                    return V.node_ops.lookup(V, k);
                  }, mknod(V, k, _) {
                    var ue = Ne.lookupPath(V, { parent: !0 }), Me = ue.node, lt = la.basename(V);
                    if (!lt || lt === "." || lt === "..")
                      throw new Ne.ErrnoError(28);
                    var Ut = Ne.mayCreate(Me, lt);
                    if (Ut)
                      throw new Ne.ErrnoError(Ut);
                    if (!Me.node_ops.mknod)
                      throw new Ne.ErrnoError(63);
                    return Me.node_ops.mknod(Me, lt, k, _);
                  }, create(V, k) {
                    return k = k !== void 0 ? k : 438, k &= 4095, k |= 32768, Ne.mknod(V, k, 0);
                  }, mkdir(V, k) {
                    return k = k !== void 0 ? k : 511, k &= 1023, k |= 16384, Ne.mknod(V, k, 0);
                  }, mkdirTree(V, k) {
                    for (var _ = V.split("/"), ue = "", Me = 0; Me < _.length; ++Me)
                      if (_[Me]) {
                        ue += "/" + _[Me];
                        try {
                          Ne.mkdir(ue, k);
                        } catch (lt) {
                          if (lt.errno != 20) throw lt;
                        }
                      }
                  }, mkdev(V, k, _) {
                    return typeof _ == "undefined" && (_ = k, k = 438), k |= 8192, Ne.mknod(V, k, _);
                  }, symlink(V, k) {
                    if (!ea.resolve(V))
                      throw new Ne.ErrnoError(44);
                    var _ = Ne.lookupPath(k, { parent: !0 }), ue = _.node;
                    if (!ue)
                      throw new Ne.ErrnoError(44);
                    var Me = la.basename(k), lt = Ne.mayCreate(ue, Me);
                    if (lt)
                      throw new Ne.ErrnoError(lt);
                    if (!ue.node_ops.symlink)
                      throw new Ne.ErrnoError(63);
                    return ue.node_ops.symlink(ue, Me, V);
                  }, rename(V, k) {
                    var _ = la.dirname(V), ue = la.dirname(k), Me = la.basename(V), lt = la.basename(k), Ut, Dt, kn;
                    if (Ut = Ne.lookupPath(V, { parent: !0 }), Dt = Ut.node, Ut = Ne.lookupPath(k, { parent: !0 }), kn = Ut.node, !Dt || !kn) throw new Ne.ErrnoError(44);
                    if (Dt.mount !== kn.mount)
                      throw new Ne.ErrnoError(75);
                    var _n = Ne.lookupNode(Dt, Me), $r = ea.relative(V, ue);
                    if ($r.charAt(0) !== ".")
                      throw new Ne.ErrnoError(28);
                    if ($r = ea.relative(k, _), $r.charAt(0) !== ".")
                      throw new Ne.ErrnoError(55);
                    var Mi;
                    try {
                      Mi = Ne.lookupNode(kn, lt);
                    } catch {
                    }
                    if (_n !== Mi) {
                      var ri = Ne.isDir(_n.mode), Dr = Ne.mayDelete(Dt, Me, ri);
                      if (Dr)
                        throw new Ne.ErrnoError(Dr);
                      if (Dr = Mi ? Ne.mayDelete(kn, lt, ri) : Ne.mayCreate(kn, lt), Dr)
                        throw new Ne.ErrnoError(Dr);
                      if (!Dt.node_ops.rename)
                        throw new Ne.ErrnoError(63);
                      if (Ne.isMountpoint(_n) || Mi && Ne.isMountpoint(Mi))
                        throw new Ne.ErrnoError(10);
                      if (kn !== Dt && (Dr = Ne.nodePermissions(Dt, "w"), Dr))
                        throw new Ne.ErrnoError(Dr);
                      Ne.hashRemoveNode(_n);
                      try {
                        Dt.node_ops.rename(_n, kn, lt);
                      } catch (ro) {
                        throw ro;
                      } finally {
                        Ne.hashAddNode(_n);
                      }
                    }
                  }, rmdir(V) {
                    var k = Ne.lookupPath(V, { parent: !0 }), _ = k.node, ue = la.basename(V), Me = Ne.lookupNode(_, ue), lt = Ne.mayDelete(_, ue, !0);
                    if (lt)
                      throw new Ne.ErrnoError(lt);
                    if (!_.node_ops.rmdir)
                      throw new Ne.ErrnoError(63);
                    if (Ne.isMountpoint(Me))
                      throw new Ne.ErrnoError(10);
                    _.node_ops.rmdir(_, ue), Ne.destroyNode(Me);
                  }, readdir(V) {
                    var k = Ne.lookupPath(V, { follow: !0 }), _ = k.node;
                    if (!_.node_ops.readdir)
                      throw new Ne.ErrnoError(54);
                    return _.node_ops.readdir(_);
                  }, unlink(V) {
                    var k = Ne.lookupPath(V, { parent: !0 }), _ = k.node;
                    if (!_)
                      throw new Ne.ErrnoError(44);
                    var ue = la.basename(V), Me = Ne.lookupNode(_, ue), lt = Ne.mayDelete(_, ue, !1);
                    if (lt)
                      throw new Ne.ErrnoError(lt);
                    if (!_.node_ops.unlink)
                      throw new Ne.ErrnoError(63);
                    if (Ne.isMountpoint(Me))
                      throw new Ne.ErrnoError(10);
                    _.node_ops.unlink(_, ue), Ne.destroyNode(Me);
                  }, readlink(V) {
                    var k = Ne.lookupPath(V), _ = k.node;
                    if (!_)
                      throw new Ne.ErrnoError(44);
                    if (!_.node_ops.readlink)
                      throw new Ne.ErrnoError(28);
                    return ea.resolve(Ne.getPath(_.parent), _.node_ops.readlink(_));
                  }, stat(V, k) {
                    var _ = Ne.lookupPath(V, { follow: !k }), ue = _.node;
                    if (!ue)
                      throw new Ne.ErrnoError(44);
                    if (!ue.node_ops.getattr)
                      throw new Ne.ErrnoError(63);
                    return ue.node_ops.getattr(ue);
                  }, lstat(V) {
                    return Ne.stat(V, !0);
                  }, chmod(V, k, _) {
                    var ue;
                    if (typeof V == "string") {
                      var Me = Ne.lookupPath(V, { follow: !_ });
                      ue = Me.node;
                    } else
                      ue = V;
                    if (!ue.node_ops.setattr)
                      throw new Ne.ErrnoError(63);
                    ue.node_ops.setattr(ue, { mode: k & 4095 | ue.mode & -4096, timestamp: Date.now() });
                  }, lchmod(V, k) {
                    Ne.chmod(V, k, !0);
                  }, fchmod(V, k) {
                    var _ = Ne.getStreamChecked(V);
                    Ne.chmod(_.node, k);
                  }, chown(V, k, _, ue) {
                    var Me;
                    if (typeof V == "string") {
                      var lt = Ne.lookupPath(V, { follow: !ue });
                      Me = lt.node;
                    } else
                      Me = V;
                    if (!Me.node_ops.setattr)
                      throw new Ne.ErrnoError(63);
                    Me.node_ops.setattr(Me, { timestamp: Date.now() });
                  }, lchown(V, k, _) {
                    Ne.chown(V, k, _, !0);
                  }, fchown(V, k, _) {
                    var ue = Ne.getStreamChecked(V);
                    Ne.chown(ue.node, k, _);
                  }, truncate(V, k) {
                    if (k < 0)
                      throw new Ne.ErrnoError(28);
                    var _;
                    if (typeof V == "string") {
                      var ue = Ne.lookupPath(V, { follow: !0 });
                      _ = ue.node;
                    } else
                      _ = V;
                    if (!_.node_ops.setattr)
                      throw new Ne.ErrnoError(63);
                    if (Ne.isDir(_.mode))
                      throw new Ne.ErrnoError(31);
                    if (!Ne.isFile(_.mode))
                      throw new Ne.ErrnoError(28);
                    var Me = Ne.nodePermissions(_, "w");
                    if (Me)
                      throw new Ne.ErrnoError(Me);
                    _.node_ops.setattr(_, { size: k, timestamp: Date.now() });
                  }, ftruncate(V, k) {
                    var _ = Ne.getStreamChecked(V);
                    if (!(_.flags & 2097155))
                      throw new Ne.ErrnoError(28);
                    Ne.truncate(_.node, k);
                  }, utime(V, k, _) {
                    var ue = Ne.lookupPath(V, { follow: !0 }), Me = ue.node;
                    Me.node_ops.setattr(Me, { timestamp: Math.max(k, _) });
                  }, open(V, k, _) {
                    if (V === "")
                      throw new Ne.ErrnoError(44);
                    k = typeof k == "string" ? od(k) : k, _ = typeof _ == "undefined" ? 438 : _, k & 64 ? _ = _ & 4095 | 32768 : _ = 0;
                    var ue;
                    if (typeof V == "object")
                      ue = V;
                    else {
                      V = la.normalize(V);
                      try {
                        var Me = Ne.lookupPath(V, { follow: !(k & 131072) });
                        ue = Me.node;
                      } catch {
                      }
                    }
                    var lt = !1;
                    if (k & 64)
                      if (ue) {
                        if (k & 128)
                          throw new Ne.ErrnoError(20);
                      } else
                        ue = Ne.mknod(V, _, 0), lt = !0;
                    if (!ue)
                      throw new Ne.ErrnoError(44);
                    if (Ne.isChrdev(ue.mode) && (k &= -513), k & 65536 && !Ne.isDir(ue.mode))
                      throw new Ne.ErrnoError(54);
                    if (!lt) {
                      var Ut = Ne.mayOpen(ue, k);
                      if (Ut)
                        throw new Ne.ErrnoError(Ut);
                    }
                    k & 512 && !lt && Ne.truncate(ue, 0), k &= -131713;
                    var Dt = Ne.createStream({ node: ue, path: Ne.getPath(ue), flags: k, seekable: !0, position: 0, stream_ops: ue.stream_ops, ungotten: [], error: !1 });
                    return Dt.stream_ops.open && Dt.stream_ops.open(Dt), ye.logReadFiles && !(k & 1) && (Ne.readFiles || (Ne.readFiles = {}), V in Ne.readFiles || (Ne.readFiles[V] = 1)), Dt;
                  }, close(V) {
                    if (Ne.isClosed(V))
                      throw new Ne.ErrnoError(8);
                    V.getdents && (V.getdents = null);
                    try {
                      V.stream_ops.close && V.stream_ops.close(V);
                    } catch (k) {
                      throw k;
                    } finally {
                      Ne.closeStream(V.fd);
                    }
                    V.fd = null;
                  }, isClosed(V) {
                    return V.fd === null;
                  }, llseek(V, k, _) {
                    if (Ne.isClosed(V))
                      throw new Ne.ErrnoError(8);
                    if (!V.seekable || !V.stream_ops.llseek)
                      throw new Ne.ErrnoError(70);
                    if (_ != 0 && _ != 1 && _ != 2)
                      throw new Ne.ErrnoError(28);
                    return V.position = V.stream_ops.llseek(V, k, _), V.ungotten = [], V.position;
                  }, read(V, k, _, ue, Me) {
                    if (ue < 0 || Me < 0)
                      throw new Ne.ErrnoError(28);
                    if (Ne.isClosed(V))
                      throw new Ne.ErrnoError(8);
                    if ((V.flags & 2097155) === 1)
                      throw new Ne.ErrnoError(8);
                    if (Ne.isDir(V.node.mode))
                      throw new Ne.ErrnoError(31);
                    if (!V.stream_ops.read)
                      throw new Ne.ErrnoError(28);
                    var lt = typeof Me != "undefined";
                    if (!lt)
                      Me = V.position;
                    else if (!V.seekable)
                      throw new Ne.ErrnoError(70);
                    var Ut = V.stream_ops.read(V, k, _, ue, Me);
                    return lt || (V.position += Ut), Ut;
                  }, write(V, k, _, ue, Me, lt) {
                    if (ue < 0 || Me < 0)
                      throw new Ne.ErrnoError(28);
                    if (Ne.isClosed(V))
                      throw new Ne.ErrnoError(8);
                    if (!(V.flags & 2097155))
                      throw new Ne.ErrnoError(8);
                    if (Ne.isDir(V.node.mode))
                      throw new Ne.ErrnoError(31);
                    if (!V.stream_ops.write)
                      throw new Ne.ErrnoError(28);
                    V.seekable && V.flags & 1024 && Ne.llseek(V, 0, 2);
                    var Ut = typeof Me != "undefined";
                    if (!Ut)
                      Me = V.position;
                    else if (!V.seekable)
                      throw new Ne.ErrnoError(70);
                    var Dt = V.stream_ops.write(V, k, _, ue, Me, lt);
                    return Ut || (V.position += Dt), Dt;
                  }, allocate(V, k, _) {
                    if (Ne.isClosed(V))
                      throw new Ne.ErrnoError(8);
                    if (k < 0 || _ <= 0)
                      throw new Ne.ErrnoError(28);
                    if (!(V.flags & 2097155))
                      throw new Ne.ErrnoError(8);
                    if (!Ne.isFile(V.node.mode) && !Ne.isDir(V.node.mode))
                      throw new Ne.ErrnoError(43);
                    if (!V.stream_ops.allocate)
                      throw new Ne.ErrnoError(138);
                    V.stream_ops.allocate(V, k, _);
                  }, mmap(V, k, _, ue, Me) {
                    if (ue & 2 && !(Me & 2) && (V.flags & 2097155) !== 2)
                      throw new Ne.ErrnoError(2);
                    if ((V.flags & 2097155) === 1)
                      throw new Ne.ErrnoError(2);
                    if (!V.stream_ops.mmap)
                      throw new Ne.ErrnoError(43);
                    return V.stream_ops.mmap(V, k, _, ue, Me);
                  }, msync(V, k, _, ue, Me) {
                    return V.stream_ops.msync ? V.stream_ops.msync(V, k, _, ue, Me) : 0;
                  }, munmap: (V) => 0, ioctl(V, k, _) {
                    if (!V.stream_ops.ioctl)
                      throw new Ne.ErrnoError(59);
                    return V.stream_ops.ioctl(V, k, _);
                  }, readFile(V, k) {
                    if (k === void 0 && (k = {}), k.flags = k.flags || 0, k.encoding = k.encoding || "binary", k.encoding !== "utf8" && k.encoding !== "binary")
                      throw new Error(`Invalid encoding type "${k.encoding}"`);
                    var _, ue = Ne.open(V, k.flags), Me = Ne.stat(V), lt = Me.size, Ut = new Uint8Array(lt);
                    return Ne.read(ue, Ut, 0, lt, 0), k.encoding === "utf8" ? _ = Uo(Ut, 0) : k.encoding === "binary" && (_ = Ut), Ne.close(ue), _;
                  }, writeFile(V, k, _) {
                    _ === void 0 && (_ = {}), _.flags = _.flags || 577;
                    var ue = Ne.open(V, _.flags, _.mode);
                    if (typeof k == "string") {
                      var Me = new Uint8Array(Yc(k) + 1), lt = rd(k, Me, 0, Me.length);
                      Ne.write(ue, Me, 0, lt, void 0, _.canOwn);
                    } else if (ArrayBuffer.isView(k))
                      Ne.write(ue, k, 0, k.byteLength, void 0, _.canOwn);
                    else
                      throw new Error("Unsupported data type");
                    Ne.close(ue);
                  }, cwd: () => Ne.currentPath, chdir(V) {
                    var k = Ne.lookupPath(V, { follow: !0 });
                    if (k.node === null)
                      throw new Ne.ErrnoError(44);
                    if (!Ne.isDir(k.node.mode))
                      throw new Ne.ErrnoError(54);
                    var _ = Ne.nodePermissions(k.node, "x");
                    if (_)
                      throw new Ne.ErrnoError(_);
                    Ne.currentPath = k.path;
                  }, createDefaultDirectories() {
                    Ne.mkdir("/tmp"), Ne.mkdir("/home"), Ne.mkdir("/home/web_user");
                  }, createDefaultDevices() {
                    Ne.mkdir("/dev"), Ne.registerDevice(Ne.makedev(1, 3), { read: () => 0, write: (ue, Me, lt, Ut, Dt) => Ut }), Ne.mkdev("/dev/null", Ne.makedev(1, 3)), El.register(Ne.makedev(5, 0), El.default_tty_ops), El.register(Ne.makedev(6, 0), El.default_tty1_ops), Ne.mkdev("/dev/tty", Ne.makedev(5, 0)), Ne.mkdev("/dev/tty1", Ne.makedev(6, 0));
                    var V = new Uint8Array(1024), k = 0, _ = () => (k === 0 && (k = Da(V).byteLength), V[--k]);
                    Ne.createDevice("/dev", "random", _), Ne.createDevice("/dev", "urandom", _), Ne.mkdir("/dev/shm"), Ne.mkdir("/dev/shm/tmp");
                  }, createSpecialDirectories() {
                    Ne.mkdir("/proc");
                    var V = Ne.mkdir("/proc/self");
                    Ne.mkdir("/proc/self/fd"), Ne.mount({ mount() {
                      var k = Ne.createNode(V, "fd", 16895, 73);
                      return k.node_ops = { lookup(_, ue) {
                        var Me = +ue, lt = Ne.getStreamChecked(Me), Ut = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => lt.path } };
                        return Ut.parent = Ut, Ut;
                      } }, k;
                    } }, {}, "/proc/self/fd");
                  }, createStandardStreams() {
                    ye.stdin ? Ne.createDevice("/dev", "stdin", ye.stdin) : Ne.symlink("/dev/tty", "/dev/stdin"), ye.stdout ? Ne.createDevice("/dev", "stdout", null, ye.stdout) : Ne.symlink("/dev/tty", "/dev/stdout"), ye.stderr ? Ne.createDevice("/dev", "stderr", null, ye.stderr) : Ne.symlink("/dev/tty1", "/dev/stderr"), Ne.open("/dev/stdin", 0), Ne.open("/dev/stdout", 1), Ne.open("/dev/stderr", 1);
                  }, ensureErrnoError() {
                    Ne.ErrnoError || (Ne.ErrnoError = function(k, _) {
                      this.name = "ErrnoError", this.node = _, this.setErrno = function(ue) {
                        this.errno = ue;
                      }, this.setErrno(k), this.message = "FS error";
                    }, Ne.ErrnoError.prototype = new Error(), Ne.ErrnoError.prototype.constructor = Ne.ErrnoError, [44].forEach((V) => {
                      Ne.genericErrors[V] = new Ne.ErrnoError(V), Ne.genericErrors[V].stack = "<generic error, no stack>";
                    }));
                  }, staticInit() {
                    Ne.ensureErrnoError(), Ne.nameTable = new Array(4096), Ne.mount(co, {}, "/"), Ne.createDefaultDirectories(), Ne.createDefaultDevices(), Ne.createSpecialDirectories(), Ne.filesystems = { MEMFS: co };
                  }, init(V, k, _) {
                    Ne.init.initialized = !0, Ne.ensureErrnoError(), ye.stdin = V || ye.stdin, ye.stdout = k || ye.stdout, ye.stderr = _ || ye.stderr, Ne.createStandardStreams();
                  }, quit() {
                    Ne.init.initialized = !1, RA(0);
                    for (var V = 0; V < Ne.streams.length; V++) {
                      var k = Ne.streams[V];
                      k && Ne.close(k);
                    }
                  }, findObject(V, k) {
                    var _ = Ne.analyzePath(V, k);
                    return _.exists ? _.object : null;
                  }, analyzePath(V, k) {
                    try {
                      var _ = Ne.lookupPath(V, { follow: !k });
                      V = _.path;
                    } catch {
                    }
                    var ue = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
                    try {
                      var _ = Ne.lookupPath(V, { parent: !0 });
                      ue.parentExists = !0, ue.parentPath = _.path, ue.parentObject = _.node, ue.name = la.basename(V), _ = Ne.lookupPath(V, { follow: !k }), ue.exists = !0, ue.path = _.path, ue.object = _.node, ue.name = _.node.name, ue.isRoot = _.path === "/";
                    } catch (Me) {
                      ue.error = Me.errno;
                    }
                    return ue;
                  }, createPath(V, k, _, ue) {
                    V = typeof V == "string" ? V : Ne.getPath(V);
                    for (var Me = k.split("/").reverse(); Me.length; ) {
                      var lt = Me.pop();
                      if (lt) {
                        var Ut = la.join2(V, lt);
                        try {
                          Ne.mkdir(Ut);
                        } catch {
                        }
                        V = Ut;
                      }
                    }
                    return Ut;
                  }, createFile(V, k, _, ue, Me) {
                    var lt = la.join2(typeof V == "string" ? V : Ne.getPath(V), k), Ut = Je(ue, Me);
                    return Ne.create(lt, Ut);
                  }, createDataFile(V, k, _, ue, Me, lt) {
                    var Ut = k;
                    V && (V = typeof V == "string" ? V : Ne.getPath(V), Ut = k ? la.join2(V, k) : V);
                    var Dt = Je(ue, Me), kn = Ne.create(Ut, Dt);
                    if (_) {
                      if (typeof _ == "string") {
                        for (var _n = new Array(_.length), $r = 0, Mi = _.length; $r < Mi; ++$r) _n[$r] = _.charCodeAt($r);
                        _ = _n;
                      }
                      Ne.chmod(kn, Dt | 146);
                      var ri = Ne.open(kn, 577);
                      Ne.write(ri, _, 0, _.length, 0, lt), Ne.close(ri), Ne.chmod(kn, Dt);
                    }
                  }, createDevice(V, k, _, ue) {
                    var Me = la.join2(typeof V == "string" ? V : Ne.getPath(V), k), lt = Je(!!_, !!ue);
                    Ne.createDevice.major || (Ne.createDevice.major = 64);
                    var Ut = Ne.makedev(Ne.createDevice.major++, 0);
                    return Ne.registerDevice(Ut, { open(Dt) {
                      Dt.seekable = !1;
                    }, close(Dt) {
                      ue && ue.buffer && ue.buffer.length && ue(10);
                    }, read(Dt, kn, _n, $r, Mi) {
                      for (var ri = 0, Dr = 0; Dr < $r; Dr++) {
                        var ro;
                        try {
                          ro = _();
                        } catch {
                          throw new Ne.ErrnoError(29);
                        }
                        if (ro === void 0 && ri === 0)
                          throw new Ne.ErrnoError(6);
                        if (ro == null) break;
                        ri++, kn[_n + Dr] = ro;
                      }
                      return ri && (Dt.node.timestamp = Date.now()), ri;
                    }, write(Dt, kn, _n, $r, Mi) {
                      for (var ri = 0; ri < $r; ri++)
                        try {
                          ue(kn[_n + ri]);
                        } catch {
                          throw new Ne.ErrnoError(29);
                        }
                      return $r && (Dt.node.timestamp = Date.now()), ri;
                    } }), Ne.mkdev(Me, lt, Ut);
                  }, forceLoadFile(V) {
                    if (V.isDevice || V.isFolder || V.link || V.contents) return !0;
                    if (typeof XMLHttpRequest != "undefined")
                      throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                    if (vt)
                      try {
                        V.contents = Lc(vt(V.url), !0), V.usedBytes = V.contents.length;
                      } catch {
                        throw new Ne.ErrnoError(29);
                      }
                    else
                      throw new Error("Cannot load without read() or XMLHttpRequest.");
                  }, createLazyFile(V, k, _, ue, Me) {
                    function lt() {
                      this.lengthKnown = !1, this.chunks = [];
                    }
                    if (lt.prototype.get = function(Dr) {
                      if (!(Dr > this.length - 1 || Dr < 0)) {
                        var ro = Dr % this.chunkSize, as = Dr / this.chunkSize | 0;
                        return this.getter(as)[ro];
                      }
                    }, lt.prototype.setDataGetter = function(Dr) {
                      this.getter = Dr;
                    }, lt.prototype.cacheLength = function() {
                      var Dr = new XMLHttpRequest();
                      if (Dr.open("HEAD", _, !1), Dr.send(null), !(Dr.status >= 200 && Dr.status < 300 || Dr.status === 304)) throw new Error("Couldn't load " + _ + ". Status: " + Dr.status);
                      var ro = Number(Dr.getResponseHeader("Content-length")), as, io = (as = Dr.getResponseHeader("Accept-Ranges")) && as === "bytes", uo = (as = Dr.getResponseHeader("Content-Encoding")) && as === "gzip", yr = 1024 * 1024;
                      io || (yr = ro);
                      var bi = (es, Qc) => {
                        if (es > Qc) throw new Error("invalid range (" + es + ", " + Qc + ") or no bytes requested!");
                        if (Qc > ro - 1) throw new Error("only " + ro + " bytes available! programmer error!");
                        var qs = new XMLHttpRequest();
                        if (qs.open("GET", _, !1), ro !== yr && qs.setRequestHeader("Range", "bytes=" + es + "-" + Qc), qs.responseType = "arraybuffer", qs.overrideMimeType && qs.overrideMimeType("text/plain; charset=x-user-defined"), qs.send(null), !(qs.status >= 200 && qs.status < 300 || qs.status === 304)) throw new Error("Couldn't load " + _ + ". Status: " + qs.status);
                        return qs.response !== void 0 ? new Uint8Array(qs.response || []) : Lc(qs.responseText || "", !0);
                      }, Ni = this;
                      Ni.setDataGetter((es) => {
                        var Qc = es * yr, qs = (es + 1) * yr - 1;
                        if (qs = Math.min(qs, ro - 1), typeof Ni.chunks[es] == "undefined" && (Ni.chunks[es] = bi(Qc, qs)), typeof Ni.chunks[es] == "undefined") throw new Error("doXHR failed!");
                        return Ni.chunks[es];
                      }), (uo || !ro) && (yr = ro = 1, ro = this.getter(0).length, yr = ro, an("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = ro, this._chunkSize = yr, this.lengthKnown = !0;
                    }, typeof XMLHttpRequest != "undefined") {
                      if (!Xt) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                      var Ut = new lt();
                      Object.defineProperties(Ut, { length: { get: function() {
                        return this.lengthKnown || this.cacheLength(), this._length;
                      } }, chunkSize: { get: function() {
                        return this.lengthKnown || this.cacheLength(), this._chunkSize;
                      } } });
                      var Dt = { isDevice: !1, contents: Ut };
                    } else
                      var Dt = { isDevice: !1, url: _ };
                    var kn = Ne.createFile(V, k, Dt, ue, Me);
                    Dt.contents ? kn.contents = Dt.contents : Dt.url && (kn.contents = null, kn.url = Dt.url), Object.defineProperties(kn, { usedBytes: { get: function() {
                      return this.contents.length;
                    } } });
                    var _n = {}, $r = Object.keys(kn.stream_ops);
                    $r.forEach((ri) => {
                      var Dr = kn.stream_ops[ri];
                      _n[ri] = function() {
                        return Ne.forceLoadFile(kn), Dr.apply(null, arguments);
                      };
                    });
                    function Mi(ri, Dr, ro, as, io) {
                      var uo = ri.node.contents;
                      if (io >= uo.length) return 0;
                      var yr = Math.min(uo.length - io, as);
                      if (uo.slice)
                        for (var bi = 0; bi < yr; bi++)
                          Dr[ro + bi] = uo[io + bi];
                      else
                        for (var bi = 0; bi < yr; bi++)
                          Dr[ro + bi] = uo.get(io + bi);
                      return yr;
                    }
                    return _n.read = (ri, Dr, ro, as, io) => (Ne.forceLoadFile(kn), Mi(ri, Dr, ro, as, io)), _n.mmap = (ri, Dr, ro, as, io) => {
                      Ne.forceLoadFile(kn);
                      var uo = vo(Dr);
                      if (!uo)
                        throw new Ne.ErrnoError(48);
                      return Mi(ri, Co, uo, Dr, ro), { ptr: uo, allocated: !0 };
                    }, kn.stream_ops = _n, kn;
                  } }, qr = { DEFAULT_POLLMASK: 5, calculateAt(V, k, _) {
                    if (la.isAbs(k))
                      return k;
                    var ue;
                    if (V === -100)
                      ue = Ne.cwd();
                    else {
                      var Me = qr.getStreamFromFD(V);
                      ue = Me.path;
                    }
                    if (k.length == 0) {
                      if (!_)
                        throw new Ne.ErrnoError(44);
                      return ue;
                    }
                    return la.join2(ue, k);
                  }, doStat(V, k, _) {
                    try {
                      var ue = V(k);
                    } catch (Dt) {
                      if (Dt && Dt.node && la.normalize(k) !== la.normalize(Ne.getPath(Dt.node)))
                        return -54;
                      throw Dt;
                    }
                    Jo[_ >> 2] = ue.dev, Jo[_ + 4 >> 2] = ue.mode, Pi[_ + 8 >> 2] = ue.nlink, Jo[_ + 12 >> 2] = ue.uid, Jo[_ + 16 >> 2] = ue.gid, Jo[_ + 20 >> 2] = ue.rdev, Za = [ue.size >>> 0, (to = ue.size, +Math.abs(to) >= 1 ? to > 0 ? +Math.floor(to / 4294967296) >>> 0 : ~~+Math.ceil((to - +(~~to >>> 0)) / 4294967296) >>> 0 : 0)], Jo[_ + 24 >> 2] = Za[0], Jo[_ + 28 >> 2] = Za[1], Jo[_ + 32 >> 2] = 4096, Jo[_ + 36 >> 2] = ue.blocks;
                    var Me = ue.atime.getTime(), lt = ue.mtime.getTime(), Ut = ue.ctime.getTime();
                    return Za = [Math.floor(Me / 1e3) >>> 0, (to = Math.floor(Me / 1e3), +Math.abs(to) >= 1 ? to > 0 ? +Math.floor(to / 4294967296) >>> 0 : ~~+Math.ceil((to - +(~~to >>> 0)) / 4294967296) >>> 0 : 0)], Jo[_ + 40 >> 2] = Za[0], Jo[_ + 44 >> 2] = Za[1], Pi[_ + 48 >> 2] = Me % 1e3 * 1e3, Za = [Math.floor(lt / 1e3) >>> 0, (to = Math.floor(lt / 1e3), +Math.abs(to) >= 1 ? to > 0 ? +Math.floor(to / 4294967296) >>> 0 : ~~+Math.ceil((to - +(~~to >>> 0)) / 4294967296) >>> 0 : 0)], Jo[_ + 56 >> 2] = Za[0], Jo[_ + 60 >> 2] = Za[1], Pi[_ + 64 >> 2] = lt % 1e3 * 1e3, Za = [Math.floor(Ut / 1e3) >>> 0, (to = Math.floor(Ut / 1e3), +Math.abs(to) >= 1 ? to > 0 ? +Math.floor(to / 4294967296) >>> 0 : ~~+Math.ceil((to - +(~~to >>> 0)) / 4294967296) >>> 0 : 0)], Jo[_ + 72 >> 2] = Za[0], Jo[_ + 76 >> 2] = Za[1], Pi[_ + 80 >> 2] = Ut % 1e3 * 1e3, Za = [ue.ino >>> 0, (to = ue.ino, +Math.abs(to) >= 1 ? to > 0 ? +Math.floor(to / 4294967296) >>> 0 : ~~+Math.ceil((to - +(~~to >>> 0)) / 4294967296) >>> 0 : 0)], Jo[_ + 88 >> 2] = Za[0], Jo[_ + 92 >> 2] = Za[1], 0;
                  }, doMsync(V, k, _, ue, Me) {
                    if (!Ne.isFile(k.node.mode))
                      throw new Ne.ErrnoError(43);
                    if (ue & 2)
                      return 0;
                    var lt = ga.slice(V, V + _);
                    Ne.msync(k, lt, Me, _, ue);
                  }, varargs: void 0, get() {
                    var V = Jo[+qr.varargs >> 2];
                    return qr.varargs += 4, V;
                  }, getp() {
                    return qr.get();
                  }, getStr(V) {
                    var k = ja(V);
                    return k;
                  }, getStreamFromFD(V) {
                    var k = Ne.getStreamChecked(V);
                    return k;
                  } };
                  function dc(V, k) {
                    try {
                      var _ = qr.getStreamFromFD(V);
                      return qr.doStat(Ne.stat, _.path, k);
                    } catch (ue) {
                      if (typeof Ne == "undefined" || ue.name !== "ErrnoError") throw ue;
                      return -ue.errno;
                    }
                  }
                  var sl = (V, k) => k + 2097152 >>> 0 < 4194305 - !!V ? (V >>> 0) + k * 4294967296 : NaN;
                  function Ta(V, k, _) {
                    var ue = sl(k, _);
                    try {
                      return isNaN(ue) ? 61 : (Ne.ftruncate(V, ue), 0);
                    } catch (Me) {
                      if (typeof Ne == "undefined" || Me.name !== "ErrnoError") throw Me;
                      return -Me.errno;
                    }
                  }
                  function $d(V, k, _, ue) {
                    try {
                      k = qr.getStr(k);
                      var Me = ue & 256, lt = ue & 4096;
                      return ue = ue & -6401, k = qr.calculateAt(V, k, lt), qr.doStat(Me ? Ne.lstat : Ne.stat, k, _);
                    } catch (Ut) {
                      if (typeof Ne == "undefined" || Ut.name !== "ErrnoError") throw Ut;
                      return -Ut.errno;
                    }
                  }
                  function Id(V, k, _, ue) {
                    qr.varargs = ue;
                    try {
                      k = qr.getStr(k), k = qr.calculateAt(V, k);
                      var Me = ue ? qr.get() : 0;
                      return Ne.open(k, _, Me).fd;
                    } catch (lt) {
                      if (typeof Ne == "undefined" || lt.name !== "ErrnoError") throw lt;
                      return -lt.errno;
                    }
                  }
                  var $s = (V, k, _) => rd(V, ga, k, _);
                  function _a(V, k, _, ue) {
                    try {
                      if (k = qr.getStr(k), k = qr.calculateAt(V, k), ue <= 0) return -28;
                      var Me = Ne.readlink(k), lt = Math.min(ue, Yc(Me)), Ut = Co[_ + lt];
                      return $s(Me, _, ue + 1), Co[_ + lt] = Ut, lt;
                    } catch (Dt) {
                      if (typeof Ne == "undefined" || Dt.name !== "ErrnoError") throw Dt;
                      return -Dt.errno;
                    }
                  }
                  function no(V, k, _, ue) {
                    try {
                      return k = qr.getStr(k), ue = qr.getStr(ue), k = qr.calculateAt(V, k), ue = qr.calculateAt(_, ue), Ne.rename(k, ue), 0;
                    } catch (Me) {
                      if (typeof Ne == "undefined" || Me.name !== "ErrnoError") throw Me;
                      return -Me.errno;
                    }
                  }
                  function Bd(V, k) {
                    try {
                      return V = qr.getStr(V), qr.doStat(Ne.stat, V, k);
                    } catch (_) {
                      if (typeof Ne == "undefined" || _.name !== "ErrnoError") throw _;
                      return -_.errno;
                    }
                  }
                  function xl(V, k, _) {
                    try {
                      return k = qr.getStr(k), k = qr.calculateAt(V, k), _ === 0 ? Ne.unlink(k) : _ === 512 ? Ne.rmdir(k) : sc("Invalid flags passed to unlinkat"), 0;
                    } catch (ue) {
                      if (typeof Ne == "undefined" || ue.name !== "ErrnoError") throw ue;
                      return -ue.errno;
                    }
                  }
                  var Yd = (V, k, _, ue, Me) => {
                  }, nt = () => {
                    for (var V = new Array(256), k = 0; k < 256; ++k)
                      V[k] = String.fromCharCode(k);
                    Ke = V;
                  }, Ke, et = (V) => {
                    for (var k = "", _ = V; ga[_]; )
                      k += Ke[ga[_++]];
                    return k;
                  }, dt = {}, $t = {}, be = {}, ze, P = (V) => {
                    throw new ze(V);
                  }, te, Re = (V) => {
                    throw new te(V);
                  }, Qe = (V, k, _) => {
                    V.forEach(function(Dt) {
                      be[Dt] = k;
                    });
                    function ue(Dt) {
                      var kn = _(Dt);
                      kn.length !== V.length && Re("Mismatched type converter count");
                      for (var _n = 0; _n < V.length; ++_n)
                        Ht(V[_n], kn[_n]);
                    }
                    var Me = new Array(k.length), lt = [], Ut = 0;
                    k.forEach((Dt, kn) => {
                      $t.hasOwnProperty(Dt) ? Me[kn] = $t[Dt] : (lt.push(Dt), dt.hasOwnProperty(Dt) || (dt[Dt] = []), dt[Dt].push(() => {
                        Me[kn] = $t[Dt], ++Ut, Ut === lt.length && ue(Me);
                      }));
                    }), lt.length === 0 && ue(Me);
                  };
                  function yt(V, k, _) {
                    _ === void 0 && (_ = {});
                    var ue = k.name;
                    if (V || P(`type "${ue}" must have a positive integer typeid pointer`), $t.hasOwnProperty(V)) {
                      if (_.ignoreDuplicateRegistrations)
                        return;
                      P(`Cannot register type '${ue}' twice`);
                    }
                    if ($t[V] = k, delete be[V], dt.hasOwnProperty(V)) {
                      var Me = dt[V];
                      delete dt[V], Me.forEach((lt) => lt());
                    }
                  }
                  function Ht(V, k, _) {
                    if (_ === void 0 && (_ = {}), !("argPackAdvance" in k))
                      throw new TypeError("registerType registeredInstance requires argPackAdvance");
                    return yt(V, k, _);
                  }
                  var zt = 8, rn = (V, k, _, ue) => {
                    k = et(k), Ht(V, { name: k, fromWireType: function(lt) {
                      return !!lt;
                    }, toWireType: function(lt, Ut) {
                      return Ut ? _ : ue;
                    }, argPackAdvance: zt, readValueFromPointer: function(lt) {
                      return this.fromWireType(ga[lt]);
                    }, destructorFunction: null });
                  }, tr = (V) => ({ count: V.count, deleteScheduled: V.deleteScheduled, preservePointerOnDelete: V.preservePointerOnDelete, ptr: V.ptr, ptrType: V.ptrType, smartPtr: V.smartPtr, smartPtrType: V.smartPtrType }), Vn = (V) => {
                    function k(_) {
                      return _.$$.ptrType.registeredClass.name;
                    }
                    P(k(V) + " instance already deleted");
                  }, si = !1, ai = (V) => {
                  }, Ui = (V) => {
                    V.smartPtr ? V.smartPtrType.rawDestructor(V.smartPtr) : V.ptrType.registeredClass.rawDestructor(V.ptr);
                  }, Sa = (V) => {
                    V.count.value -= 1;
                    var k = V.count.value === 0;
                    k && Ui(V);
                  }, xa = (V, k, _) => {
                    if (k === _)
                      return V;
                    if (_.baseClass === void 0)
                      return null;
                    var ue = xa(V, k, _.baseClass);
                    return ue === null ? null : _.downcast(ue);
                  }, ll = {}, Hc = () => Object.keys(qd).length, Wc = () => {
                    var V = [];
                    for (var k in qd)
                      qd.hasOwnProperty(k) && V.push(qd[k]);
                    return V;
                  }, Zd = [], Sd = () => {
                    for (; Zd.length; ) {
                      var V = Zd.pop();
                      V.$$.deleteScheduled = !1, V.delete();
                    }
                  }, lu, Zu = (V) => {
                    lu = V, Zd.length && lu && lu(Sd);
                  }, Su = () => {
                    ye.getInheritedInstanceCount = Hc, ye.getLiveInheritedInstances = Wc, ye.flushPendingDeletes = Sd, ye.setDelayFunction = Zu;
                  }, qd = {}, rA = (V, k) => {
                    for (k === void 0 && P("ptr should not be undefined"); V.baseClass; )
                      k = V.upcast(k), V = V.baseClass;
                    return k;
                  }, iA = (V, k) => (k = rA(V, k), qd[k]), Ku = (V, k) => {
                    (!k.ptrType || !k.ptr) && Re("makeClassHandle requires ptr and ptrType");
                    var _ = !!k.smartPtrType, ue = !!k.smartPtr;
                    return _ !== ue && Re("Both smartPtrType and smartPtr must be specified"), k.count = { value: 1 }, zu(Object.create(V, { $$: { value: k } }));
                  };
                  function oA(V) {
                    var k = this.getPointee(V);
                    if (!k)
                      return this.destructor(V), null;
                    var _ = iA(this.registeredClass, k);
                    if (_ !== void 0) {
                      if (_.$$.count.value === 0)
                        return _.$$.ptr = k, _.$$.smartPtr = V, _.clone();
                      var ue = _.clone();
                      return this.destructor(V), ue;
                    }
                    function Me() {
                      return this.isSmartPointer ? Ku(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: k, smartPtrType: this, smartPtr: V }) : Ku(this.registeredClass.instancePrototype, { ptrType: this, ptr: V });
                    }
                    var lt = this.registeredClass.getActualType(k), Ut = ll[lt];
                    if (!Ut)
                      return Me.call(this);
                    var Dt;
                    this.isConst ? Dt = Ut.constPointerType : Dt = Ut.pointerType;
                    var kn = xa(k, this.registeredClass, Dt.registeredClass);
                    return kn === null ? Me.call(this) : this.isSmartPointer ? Ku(Dt.registeredClass.instancePrototype, { ptrType: Dt, ptr: kn, smartPtrType: this, smartPtr: V }) : Ku(Dt.registeredClass.instancePrototype, { ptrType: Dt, ptr: kn });
                  }
                  var zu = (V) => typeof FinalizationRegistry == "undefined" ? (zu = (k) => k, V) : (si = new FinalizationRegistry((k) => {
                    Sa(k.$$);
                  }), zu = (k) => {
                    var _ = k.$$, ue = !!_.smartPtr;
                    if (ue) {
                      var Me = { $$: _ };
                      si.register(k, Me, k);
                    }
                    return k;
                  }, ai = (k) => si.unregister(k), zu(V)), ig = () => {
                    Object.assign(ju.prototype, { isAliasOf(V) {
                      if (!(this instanceof ju) || !(V instanceof ju))
                        return !1;
                      var k = this.$$.ptrType.registeredClass, _ = this.$$.ptr;
                      V.$$ = V.$$;
                      for (var ue = V.$$.ptrType.registeredClass, Me = V.$$.ptr; k.baseClass; )
                        _ = k.upcast(_), k = k.baseClass;
                      for (; ue.baseClass; )
                        Me = ue.upcast(Me), ue = ue.baseClass;
                      return k === ue && _ === Me;
                    }, clone() {
                      if (this.$$.ptr || Vn(this), this.$$.preservePointerOnDelete)
                        return this.$$.count.value += 1, this;
                      var V = zu(Object.create(Object.getPrototypeOf(this), { $$: { value: tr(this.$$) } }));
                      return V.$$.count.value += 1, V.$$.deleteScheduled = !1, V;
                    }, delete() {
                      this.$$.ptr || Vn(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && P("Object already scheduled for deletion"), ai(this), Sa(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
                    }, isDeleted() {
                      return !this.$$.ptr;
                    }, deleteLater() {
                      return this.$$.ptr || Vn(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && P("Object already scheduled for deletion"), Zd.push(this), Zd.length === 1 && lu && lu(Sd), this.$$.deleteScheduled = !0, this;
                    } });
                  };
                  function ju() {
                  }
                  var Rc = (V, k) => Object.defineProperty(k, "name", { value: V }), pu = (V, k, _) => {
                    if (V[k].overloadTable === void 0) {
                      var ue = V[k];
                      V[k] = function() {
                        return V[k].overloadTable.hasOwnProperty(arguments.length) || P(`Function '${_}' called with an invalid number of arguments (${arguments.length}) - expects one of (${V[k].overloadTable})!`), V[k].overloadTable[arguments.length].apply(this, arguments);
                      }, V[k].overloadTable = [], V[k].overloadTable[ue.argCount] = ue;
                    }
                  }, mu = (V, k, _) => {
                    ye.hasOwnProperty(V) ? (P(`Cannot register public name '${V}' twice`), pu(ye, V, V), ye.hasOwnProperty(_) && P(`Cannot register multiple overloads of a function with the same number of arguments (${_})!`), ye[V].overloadTable[_] = k) : ye[V] = k;
                  }, y0 = 48, Eu = 57, Ha = (V) => {
                    if (V === void 0)
                      return "_unknown";
                    V = V.replace(/[^a-zA-Z0-9_]/g, "$");
                    var k = V.charCodeAt(0);
                    return k >= y0 && k <= Eu ? `_${V}` : V;
                  };
                  function aA(V, k, _, ue, Me, lt, Ut, Dt) {
                    this.name = V, this.constructor = k, this.instancePrototype = _, this.rawDestructor = ue, this.baseClass = Me, this.getActualType = lt, this.upcast = Ut, this.downcast = Dt, this.pureVirtualFunctions = [];
                  }
                  var Vu = (V, k, _) => {
                    for (; k !== _; )
                      k.upcast || P(`Expected null or instance of ${_.name}, got an instance of ${k.name}`), V = k.upcast(V), k = k.baseClass;
                    return V;
                  };
                  function _u(V, k) {
                    if (k === null)
                      return this.isReference && P(`null is not a valid ${this.name}`), 0;
                    k.$$ || P(`Cannot pass "${n0(k)}" as a ${this.name}`), k.$$.ptr || P(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    var _ = k.$$.ptrType.registeredClass, ue = Vu(k.$$.ptr, _, this.registeredClass);
                    return ue;
                  }
                  function og(V, k) {
                    var _;
                    if (k === null)
                      return this.isReference && P(`null is not a valid ${this.name}`), this.isSmartPointer ? (_ = this.rawConstructor(), V !== null && V.push(this.rawDestructor, _), _) : 0;
                    k.$$ || P(`Cannot pass "${n0(k)}" as a ${this.name}`), k.$$.ptr || P(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && k.$$.ptrType.isConst && P(`Cannot convert argument of type ${k.$$.smartPtrType ? k.$$.smartPtrType.name : k.$$.ptrType.name} to parameter type ${this.name}`);
                    var ue = k.$$.ptrType.registeredClass;
                    if (_ = Vu(k.$$.ptr, ue, this.registeredClass), this.isSmartPointer)
                      switch (k.$$.smartPtr === void 0 && P("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
                        case 0:
                          k.$$.smartPtrType === this ? _ = k.$$.smartPtr : P(`Cannot convert argument of type ${k.$$.smartPtrType ? k.$$.smartPtrType.name : k.$$.ptrType.name} to parameter type ${this.name}`);
                          break;
                        case 1:
                          _ = k.$$.smartPtr;
                          break;
                        case 2:
                          if (k.$$.smartPtrType === this)
                            _ = k.$$.smartPtr;
                          else {
                            var Me = k.clone();
                            _ = this.rawShare(_, B0.toHandle(() => Me.delete())), V !== null && V.push(this.rawDestructor, _);
                          }
                          break;
                        default:
                          P("Unsupporting sharing policy");
                      }
                    return _;
                  }
                  function eu(V, k) {
                    if (k === null)
                      return this.isReference && P(`null is not a valid ${this.name}`), 0;
                    k.$$ || P(`Cannot pass "${n0(k)}" as a ${this.name}`), k.$$.ptr || P(`Cannot pass deleted object as a pointer of type ${this.name}`), k.$$.ptrType.isConst && P(`Cannot convert argument of type ${k.$$.ptrType.name} to parameter type ${this.name}`);
                    var _ = k.$$.ptrType.registeredClass, ue = Vu(k.$$.ptr, _, this.registeredClass);
                    return ue;
                  }
                  function tu(V) {
                    return this.fromWireType(Pi[V >> 2]);
                  }
                  var ag = () => {
                    Object.assign(Q0.prototype, { getPointee(V) {
                      return this.rawGetPointee && (V = this.rawGetPointee(V)), V;
                    }, destructor(V) {
                      this.rawDestructor && this.rawDestructor(V);
                    }, argPackAdvance: zt, readValueFromPointer: tu, deleteObject(V) {
                      V !== null && V.delete();
                    }, fromWireType: oA });
                  };
                  function Q0(V, k, _, ue, Me, lt, Ut, Dt, kn, _n, $r) {
                    this.name = V, this.registeredClass = k, this.isReference = _, this.isConst = ue, this.isSmartPointer = Me, this.pointeeType = lt, this.sharingPolicy = Ut, this.rawGetPointee = Dt, this.rawConstructor = kn, this.rawShare = _n, this.rawDestructor = $r, !Me && k.baseClass === void 0 ? ue ? (this.toWireType = _u, this.destructorFunction = null) : (this.toWireType = eu, this.destructorFunction = null) : this.toWireType = og;
                  }
                  var lh = (V, k, _) => {
                    ye.hasOwnProperty(V) || Re("Replacing nonexistant public symbol"), ye[V].overloadTable !== void 0 && _ !== void 0 ? ye[V].overloadTable[_] = k : (ye[V] = k, ye[V].argCount = _);
                  }, ch = (V, k, _) => {
                    var ue = ye["dynCall_" + V];
                    return _ && _.length ? ue.apply(null, [k].concat(_)) : ue.call(null, k);
                  }, $u = [], C0, Es = (V) => {
                    var k = $u[V];
                    return k || (V >= $u.length && ($u.length = V + 1), $u[V] = k = C0.get(V)), k;
                  }, sA = (V, k, _) => {
                    if (V.includes("j"))
                      return ch(V, k, _);
                    var ue = Es(k).apply(null, _);
                    return ue;
                  }, lA = (V, k) => {
                    var _ = [];
                    return function() {
                      return _.length = 0, Object.assign(_, arguments), sA(V, k, _);
                    };
                  }, Wu = (V, k) => {
                    V = et(V);
                    function _() {
                      return V.includes("j") ? lA(V, k) : Es(k);
                    }
                    var ue = _();
                    return typeof ue != "function" && P(`unknown function pointer with signature ${V}: ${k}`), ue;
                  }, sg = (V, k) => {
                    var _ = Rc(k, function(ue) {
                      this.name = k, this.message = ue;
                      var Me = new Error(ue).stack;
                      Me !== void 0 && (this.stack = this.toString() + `
` + Me.replace(/^Error(:[^\n]*)?\n/, ""));
                    });
                    return _.prototype = Object.create(V.prototype), _.prototype.constructor = _, _.prototype.toString = function() {
                      return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
                    }, _;
                  }, Nu, U0 = (V) => {
                    var k = bA(V), _ = et(k);
                    return sd(k), _;
                  }, vu = (V, k) => {
                    var _ = [], ue = {};
                    function Me(lt) {
                      if (!ue[lt] && !$t[lt]) {
                        if (be[lt]) {
                          be[lt].forEach(Me);
                          return;
                        }
                        _.push(lt), ue[lt] = !0;
                      }
                    }
                    throw k.forEach(Me), new Nu(`${V}: ` + _.map(U0).join([", "]));
                  }, lg = (V, k, _, ue, Me, lt, Ut, Dt, kn, _n, $r, Mi, ri) => {
                    $r = et($r), lt = Wu(Me, lt), Dt && (Dt = Wu(Ut, Dt)), _n && (_n = Wu(kn, _n)), ri = Wu(Mi, ri);
                    var Dr = Ha($r);
                    mu(Dr, function() {
                      vu(`Cannot construct ${$r} due to unbound types`, [ue]);
                    }), Qe([V, k, _], ue ? [ue] : [], function(ro) {
                      ro = ro[0];
                      var as, io;
                      ue ? (as = ro.registeredClass, io = as.instancePrototype) : io = ju.prototype;
                      var uo = Rc($r, function() {
                        if (Object.getPrototypeOf(this) !== yr)
                          throw new ze("Use 'new' to construct " + $r);
                        if (bi.constructor_body === void 0)
                          throw new ze($r + " has no accessible constructor");
                        var qs = bi.constructor_body[arguments.length];
                        if (qs === void 0)
                          throw new ze(`Tried to invoke ctor of ${$r} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(bi.constructor_body).toString()}) parameters instead!`);
                        return qs.apply(this, arguments);
                      }), yr = Object.create(io, { constructor: { value: uo } });
                      uo.prototype = yr;
                      var bi = new aA($r, uo, yr, ri, as, lt, Dt, _n);
                      bi.baseClass && (bi.baseClass.__derivedClasses === void 0 && (bi.baseClass.__derivedClasses = []), bi.baseClass.__derivedClasses.push(bi));
                      var Ni = new Q0($r, bi, !0, !1, !1), es = new Q0($r + "*", bi, !1, !1, !1), Qc = new Q0($r + " const*", bi, !1, !0, !1);
                      return ll[V] = { pointerType: es, constPointerType: Qc }, lh(Dr, uo), [Ni, es, Qc];
                    });
                  }, cA = (V, k) => {
                    for (var _ = [], ue = 0; ue < V; ue++)
                      _.push(Pi[k + ue * 4 >> 2]);
                    return _;
                  }, qu = (V) => {
                    for (; V.length; ) {
                      var k = V.pop(), _ = V.pop();
                      _(k);
                    }
                  };
                  function cg(V, k) {
                    if (!(V instanceof Function))
                      throw new TypeError(`new_ called with constructor type ${typeof V} which is not a function`);
                    var _ = Rc(V.name || "unknownFunctionName", function() {
                    });
                    _.prototype = V.prototype;
                    var ue = new _(), Me = V.apply(ue, k);
                    return Me instanceof Object ? Me : ue;
                  }
                  function dA(V, k, _, ue, Me, lt) {
                    var Ut = k.length;
                    Ut < 2 && P("argTypes array size mismatch! Must at least get return value and 'this' types!");
                    for (var Dt = k[1] !== null && _ !== null, kn = !1, _n = 1; _n < k.length; ++_n)
                      if (k[_n] !== null && k[_n].destructorFunction === void 0) {
                        kn = !0;
                        break;
                      }
                    for (var $r = k[0].name !== "void", Mi = "", ri = "", _n = 0; _n < Ut - 2; ++_n)
                      Mi += (_n !== 0 ? ", " : "") + "arg" + _n, ri += (_n !== 0 ? ", " : "") + "arg" + _n + "Wired";
                    var Dr = `
        return function (${Mi}) {
        if (arguments.length !== ${Ut - 2}) {
          throwBindingError('function ${V} called with ' + arguments.length + ' arguments, expected ${Ut - 2}');
        }`;
                    kn && (Dr += `var destructors = [];
`);
                    var ro = kn ? "destructors" : "null", as = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], io = [P, ue, Me, qu, k[0], k[1]];
                    Dt && (Dr += "var thisWired = classParam.toWireType(" + ro + `, this);
`);
                    for (var _n = 0; _n < Ut - 2; ++_n)
                      Dr += "var arg" + _n + "Wired = argType" + _n + ".toWireType(" + ro + ", arg" + _n + "); // " + k[_n + 2].name + `
`, as.push("argType" + _n), io.push(k[_n + 2]);
                    if (Dt && (ri = "thisWired" + (ri.length > 0 ? ", " : "") + ri), Dr += ($r || lt ? "var rv = " : "") + "invoker(fn" + (ri.length > 0 ? ", " : "") + ri + `);
`, kn)
                      Dr += `runDestructors(destructors);
`;
                    else
                      for (var _n = Dt ? 1 : 2; _n < k.length; ++_n) {
                        var uo = _n === 1 ? "thisWired" : "arg" + (_n - 2) + "Wired";
                        k[_n].destructorFunction !== null && (Dr += uo + "_dtor(" + uo + "); // " + k[_n].name + `
`, as.push(uo + "_dtor"), io.push(k[_n].destructorFunction));
                      }
                    $r && (Dr += `var ret = retType.fromWireType(rv);
return ret;
`), Dr += `}
`, as.push(Dr);
                    var yr = cg(Function, as).apply(null, io);
                    return Rc(V, yr);
                  }
                  var I0 = (V, k, _, ue, Me, lt) => {
                    var Ut = cA(k, _);
                    Me = Wu(ue, Me), Qe([], [V], function(Dt) {
                      Dt = Dt[0];
                      var kn = `constructor ${Dt.name}`;
                      if (Dt.registeredClass.constructor_body === void 0 && (Dt.registeredClass.constructor_body = []), Dt.registeredClass.constructor_body[k - 1] !== void 0)
                        throw new ze(`Cannot register multiple constructors with identical number of parameters (${k - 1}) for class '${Dt.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                      return Dt.registeredClass.constructor_body[k - 1] = () => {
                        vu(`Cannot construct ${Dt.name} due to unbound types`, Ut);
                      }, Qe([], Ut, (_n) => (_n.splice(1, 0, null), Dt.registeredClass.constructor_body[k - 1] = dA(kn, _n, null, Me, lt), [])), [];
                    });
                  }, dg = (V) => {
                    V = V.trim();
                    const k = V.indexOf("(");
                    return k !== -1 ? V.substr(0, k) : V;
                  }, e0 = (V, k, _, ue, Me, lt, Ut, Dt, kn) => {
                    var _n = cA(_, ue);
                    k = et(k), k = dg(k), lt = Wu(Me, lt), Qe([], [V], function($r) {
                      $r = $r[0];
                      var Mi = `${$r.name}.${k}`;
                      k.startsWith("@@") && (k = Symbol[k.substring(2)]), Dt && $r.registeredClass.pureVirtualFunctions.push(k);
                      function ri() {
                        vu(`Cannot call ${Mi} due to unbound types`, _n);
                      }
                      var Dr = $r.registeredClass.instancePrototype, ro = Dr[k];
                      return ro === void 0 || ro.overloadTable === void 0 && ro.className !== $r.name && ro.argCount === _ - 2 ? (ri.argCount = _ - 2, ri.className = $r.name, Dr[k] = ri) : (pu(Dr, k, Mi), Dr[k].overloadTable[_ - 2] = ri), Qe([], _n, function(as) {
                        var io = dA(Mi, as, $r, lt, Ut, kn);
                        return Dr[k].overloadTable === void 0 ? (io.argCount = _ - 2, Dr[k] = io) : Dr[k].overloadTable[_ - 2] = io, [];
                      }), [];
                    });
                  };
                  function ug() {
                    Object.assign(t0.prototype, { get(V) {
                      return this.allocated[V];
                    }, has(V) {
                      return this.allocated[V] !== void 0;
                    }, allocate(V) {
                      var k = this.freelist.pop() || this.allocated.length;
                      return this.allocated[k] = V, k;
                    }, free(V) {
                      this.allocated[V] = void 0, this.freelist.push(V);
                    } });
                  }
                  function t0() {
                    this.allocated = [void 0], this.freelist = [];
                  }
                  var yc = new t0(), dh = (V) => {
                    V >= yc.reserved && --yc.get(V).refcount === 0 && yc.free(V);
                  }, hg = () => {
                    for (var V = 0, k = yc.reserved; k < yc.allocated.length; ++k)
                      yc.allocated[k] !== void 0 && ++V;
                    return V;
                  }, Ag = () => {
                    yc.allocated.push({ value: void 0 }, { value: null }, { value: !0 }, { value: !1 }), yc.reserved = yc.allocated.length, ye.count_emval_handles = hg;
                  }, B0 = { toValue: (V) => (V || P("Cannot use deleted val. handle = " + V), yc.get(V).value), toHandle: (V) => {
                    switch (V) {
                      case void 0:
                        return 1;
                      case null:
                        return 2;
                      case !0:
                        return 3;
                      case !1:
                        return 4;
                      default:
                        return yc.allocate({ refcount: 1, value: V });
                    }
                  } };
                  function uA(V) {
                    return this.fromWireType(Jo[V >> 2]);
                  }
                  var gg = (V, k) => {
                    k = et(k), Ht(V, { name: k, fromWireType: (_) => {
                      var ue = B0.toValue(_);
                      return dh(_), ue;
                    }, toWireType: (_, ue) => B0.toHandle(ue), argPackAdvance: zt, readValueFromPointer: uA, destructorFunction: null });
                  }, n0 = (V) => {
                    if (V === null)
                      return "null";
                    var k = typeof V;
                    return k === "object" || k === "array" || k === "function" ? V.toString() : "" + V;
                  }, fg = (V, k) => {
                    switch (k) {
                      case 4:
                        return function(_) {
                          return this.fromWireType(wa[_ >> 2]);
                        };
                      case 8:
                        return function(_) {
                          return this.fromWireType(yl[_ >> 3]);
                        };
                      default:
                        throw new TypeError(`invalid float width (${k}): ${V}`);
                    }
                  }, pg = (V, k, _) => {
                    k = et(k), Ht(V, { name: k, fromWireType: (ue) => ue, toWireType: (ue, Me) => Me, argPackAdvance: zt, readValueFromPointer: fg(k, _), destructorFunction: null });
                  }, mg = (V, k, _) => {
                    switch (k) {
                      case 1:
                        return _ ? (ue) => Co[ue >> 0] : (ue) => ga[ue >> 0];
                      case 2:
                        return _ ? (ue) => aa[ue >> 1] : (ue) => Dl[ue >> 1];
                      case 4:
                        return _ ? (ue) => Jo[ue >> 2] : (ue) => Pi[ue >> 2];
                      default:
                        throw new TypeError(`invalid integer width (${k}): ${V}`);
                    }
                  }, hA = (V, k, _, ue, Me) => {
                    k = et(k);
                    var lt = ($r) => $r;
                    if (ue === 0) {
                      var Ut = 32 - 8 * _;
                      lt = ($r) => $r << Ut >>> Ut;
                    }
                    var Dt = k.includes("unsigned"), kn = ($r, Mi) => {
                    }, _n;
                    Dt ? _n = function(Mi, ri) {
                      return kn(ri, this.name), ri >>> 0;
                    } : _n = function(Mi, ri) {
                      return kn(ri, this.name), ri;
                    }, Ht(V, { name: k, fromWireType: lt, toWireType: _n, argPackAdvance: zt, readValueFromPointer: mg(k, _, ue !== 0), destructorFunction: null });
                  }, vg = (V, k, _) => {
                    var ue = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], Me = ue[k];
                    function lt(Ut) {
                      var Dt = Pi[Ut >> 2], kn = Pi[Ut + 4 >> 2];
                      return new Me(Co.buffer, kn, Dt);
                    }
                    _ = et(_), Ht(V, { name: _, fromWireType: lt, argPackAdvance: zt, readValueFromPointer: lt }, { ignoreDuplicateRegistrations: !0 });
                  }, Ed = (V, k) => {
                    k = et(k);
                    var _ = k === "std::string";
                    Ht(V, { name: k, fromWireType(ue) {
                      var Me = Pi[ue >> 2], lt = ue + 4, Ut;
                      if (_)
                        for (var Dt = lt, kn = 0; kn <= Me; ++kn) {
                          var _n = lt + kn;
                          if (kn == Me || ga[_n] == 0) {
                            var $r = _n - Dt, Mi = ja(Dt, $r);
                            Ut === void 0 ? Ut = Mi : (Ut += "\0", Ut += Mi), Dt = _n + 1;
                          }
                        }
                      else {
                        for (var ri = new Array(Me), kn = 0; kn < Me; ++kn)
                          ri[kn] = String.fromCharCode(ga[lt + kn]);
                        Ut = ri.join("");
                      }
                      return sd(ue), Ut;
                    }, toWireType(ue, Me) {
                      Me instanceof ArrayBuffer && (Me = new Uint8Array(Me));
                      var lt, Ut = typeof Me == "string";
                      Ut || Me instanceof Uint8Array || Me instanceof Uint8ClampedArray || Me instanceof Int8Array || P("Cannot pass non-string to std::string"), _ && Ut ? lt = Yc(Me) : lt = Me.length;
                      var Dt = yu(4 + lt + 1), kn = Dt + 4;
                      if (Pi[Dt >> 2] = lt, _ && Ut)
                        $s(Me, kn, lt + 1);
                      else if (Ut)
                        for (var _n = 0; _n < lt; ++_n) {
                          var $r = Me.charCodeAt(_n);
                          $r > 255 && (sd(kn), P("String has UTF-16 code units that do not fit in 8 bits")), ga[kn + _n] = $r;
                        }
                      else
                        for (var _n = 0; _n < lt; ++_n)
                          ga[kn + _n] = Me[_n];
                      return ue !== null && ue.push(sd, Dt), Dt;
                    }, argPackAdvance: zt, readValueFromPointer: tu, destructorFunction(ue) {
                      sd(ue);
                    } });
                  }, Vs = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, Z0 = (V, k) => {
                    for (var _ = V, ue = _ >> 1, Me = ue + k / 2; !(ue >= Me) && Dl[ue]; ) ++ue;
                    if (_ = ue << 1, _ - V > 32 && Vs) return Vs.decode(ga.subarray(V, _));
                    for (var lt = "", Ut = 0; !(Ut >= k / 2); ++Ut) {
                      var Dt = aa[V + Ut * 2 >> 1];
                      if (Dt == 0) break;
                      lt += String.fromCharCode(Dt);
                    }
                    return lt;
                  }, Ju = (V, k, _) => {
                    if (_ === void 0 && (_ = 2147483647), _ < 2) return 0;
                    _ -= 2;
                    for (var ue = k, Me = _ < V.length * 2 ? _ / 2 : V.length, lt = 0; lt < Me; ++lt) {
                      var Ut = V.charCodeAt(lt);
                      aa[k >> 1] = Ut, k += 2;
                    }
                    return aa[k >> 1] = 0, k - ue;
                  }, S0 = (V) => V.length * 2, ad = (V, k) => {
                    for (var _ = 0, ue = ""; !(_ >= k / 4); ) {
                      var Me = Jo[V + _ * 4 >> 2];
                      if (Me == 0) break;
                      if (++_, Me >= 65536) {
                        var lt = Me - 65536;
                        ue += String.fromCharCode(55296 | lt >> 10, 56320 | lt & 1023);
                      } else
                        ue += String.fromCharCode(Me);
                    }
                    return ue;
                  }, uc = (V, k, _) => {
                    if (_ === void 0 && (_ = 2147483647), _ < 4) return 0;
                    for (var ue = k, Me = ue + _ - 4, lt = 0; lt < V.length; ++lt) {
                      var Ut = V.charCodeAt(lt);
                      if (Ut >= 55296 && Ut <= 57343) {
                        var Dt = V.charCodeAt(++lt);
                        Ut = 65536 + ((Ut & 1023) << 10) | Dt & 1023;
                      }
                      if (Jo[k >> 2] = Ut, k += 4, k + 4 > Me) break;
                    }
                    return Jo[k >> 2] = 0, k - ue;
                  }, uh = (V) => {
                    for (var k = 0, _ = 0; _ < V.length; ++_) {
                      var ue = V.charCodeAt(_);
                      ue >= 55296 && ue <= 57343 && ++_, k += 4;
                    }
                    return k;
                  }, hh = (V, k, _) => {
                    _ = et(_);
                    var ue, Me, lt, Ut, Dt;
                    k === 2 ? (ue = Z0, Me = Ju, Ut = S0, lt = () => Dl, Dt = 1) : k === 4 && (ue = ad, Me = uc, Ut = uh, lt = () => Pi, Dt = 2), Ht(V, { name: _, fromWireType: (kn) => {
                      for (var _n = Pi[kn >> 2], $r = lt(), Mi, ri = kn + 4, Dr = 0; Dr <= _n; ++Dr) {
                        var ro = kn + 4 + Dr * k;
                        if (Dr == _n || $r[ro >> Dt] == 0) {
                          var as = ro - ri, io = ue(ri, as);
                          Mi === void 0 ? Mi = io : (Mi += "\0", Mi += io), ri = ro + k;
                        }
                      }
                      return sd(kn), Mi;
                    }, toWireType: (kn, _n) => {
                      typeof _n != "string" && P(`Cannot pass non-string to C++ string type ${_}`);
                      var $r = Ut(_n), Mi = yu(4 + $r + k);
                      return Pi[Mi >> 2] = $r >> Dt, Me(_n, Mi + 4, $r + k), kn !== null && kn.push(sd, Mi), Mi;
                    }, argPackAdvance: zt, readValueFromPointer: uA, destructorFunction(kn) {
                      sd(kn);
                    } });
                  }, E0 = (V, k) => {
                    k = et(k), Ht(V, { isVoid: !0, name: k, argPackAdvance: 0, fromWireType: () => {
                    }, toWireType: (_, ue) => {
                    } });
                  }, Vd = 1, Gu = () => Vd, Ah = (V) => {
                    V > 4 && (yc.get(V).refcount += 1);
                  }, bg = (V, k) => {
                    var _ = $t[V];
                    return _ === void 0 && P(k + " has unknown type " + U0(V)), _;
                  }, AA = (V, k) => {
                    V = bg(V, "_emval_take_value");
                    var _ = V.readValueFromPointer(k);
                    return B0.toHandle(_);
                  };
                  function Fg(V, k, _, ue, Me, lt, Ut, Dt) {
                    var kn = sl(Me, lt);
                    try {
                      if (isNaN(kn)) return 61;
                      var _n = qr.getStreamFromFD(ue), $r = Ne.mmap(_n, V, kn, k, _), Mi = $r.ptr;
                      return Jo[Ut >> 2] = $r.allocated, Pi[Dt >> 2] = Mi, 0;
                    } catch (ri) {
                      if (typeof Ne == "undefined" || ri.name !== "ErrnoError") throw ri;
                      return -ri.errno;
                    }
                  }
                  function Rg(V, k, _, ue, Me, lt, Ut) {
                    var Dt = sl(lt, Ut);
                    try {
                      if (isNaN(Dt)) return 61;
                      var kn = qr.getStreamFromFD(Me);
                      _ & 2 && qr.doMsync(V, kn, k, ue, Dt), Ne.munmap(kn);
                    } catch (_n) {
                      if (typeof Ne == "undefined" || _n.name !== "ErrnoError") throw _n;
                      return -_n.errno;
                    }
                  }
                  var V0 = () => {
                    sc("");
                  }, Tu = () => Date.now(), r0 = () => ga.length, tc = () => r0(), cu;
                  cu = () => performance.now();
                  var bu = (V, k, _) => ga.copyWithin(V, k, k + _), gh = (V) => {
                    sc("OOM");
                  }, Fu = (V) => {
                    ga.length, gh();
                  }, W0 = {}, i0 = () => Xe || "./this.program", du = () => {
                    if (!du.strings) {
                      var V = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", k = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: V, _: i0() };
                      for (var _ in W0)
                        W0[_] === void 0 ? delete k[_] : k[_] = W0[_];
                      var ue = [];
                      for (var _ in k)
                        ue.push(`${_}=${k[_]}`);
                      du.strings = ue;
                    }
                    return du.strings;
                  }, yg = (V, k) => {
                    for (var _ = 0; _ < V.length; ++_)
                      Co[k++ >> 0] = V.charCodeAt(_);
                    Co[k >> 0] = 0;
                  }, Qg = (V, k) => {
                    var _ = 0;
                    return du().forEach((ue, Me) => {
                      var lt = k + _;
                      Pi[V + Me * 4 >> 2] = lt, yg(ue, lt), _ += ue.length + 1;
                    }), 0;
                  }, Cg = (V, k) => {
                    var _ = du();
                    Pi[V >> 2] = _.length;
                    var ue = 0;
                    return _.forEach((Me) => ue += Me.length + 1), Pi[k >> 2] = ue, 0;
                  }, N0 = 0, Ru = () => Cd || N0 > 0, gA = (V) => {
                    Ru() || (ye.onExit && ye.onExit(V), Ro = !0), ut(V, new Ec(V));
                  }, fA = (V, k) => {
                    Ru() || kc(), gA(V);
                  }, pA = fA;
                  function Ug(V) {
                    try {
                      var k = qr.getStreamFromFD(V);
                      return Ne.close(k), 0;
                    } catch (_) {
                      if (typeof Ne == "undefined" || _.name !== "ErrnoError") throw _;
                      return _.errno;
                    }
                  }
                  var fh = (V, k, _, ue) => {
                    for (var Me = 0, lt = 0; lt < _; lt++) {
                      var Ut = Pi[k >> 2], Dt = Pi[k + 4 >> 2];
                      k += 8;
                      var kn = Ne.read(V, Co, Ut, Dt, ue);
                      if (kn < 0) return -1;
                      if (Me += kn, kn < Dt) break;
                    }
                    return Me;
                  };
                  function o0(V, k, _, ue) {
                    try {
                      var Me = qr.getStreamFromFD(V), lt = fh(Me, k, _);
                      return Pi[ue >> 2] = lt, 0;
                    } catch (Ut) {
                      if (typeof Ne == "undefined" || Ut.name !== "ErrnoError") throw Ut;
                      return Ut.errno;
                    }
                  }
                  function ph(V, k, _, ue, Me) {
                    var lt = sl(k, _);
                    try {
                      if (isNaN(lt)) return 61;
                      var Ut = qr.getStreamFromFD(V);
                      return Ne.llseek(Ut, lt, ue), Za = [Ut.position >>> 0, (to = Ut.position, +Math.abs(to) >= 1 ? to > 0 ? +Math.floor(to / 4294967296) >>> 0 : ~~+Math.ceil((to - +(~~to >>> 0)) / 4294967296) >>> 0 : 0)], Jo[Me >> 2] = Za[0], Jo[Me + 4 >> 2] = Za[1], Ut.getdents && lt === 0 && ue === 0 && (Ut.getdents = null), 0;
                    } catch (Dt) {
                      if (typeof Ne == "undefined" || Dt.name !== "ErrnoError") throw Dt;
                      return Dt.errno;
                    }
                  }
                  function mh(V) {
                    try {
                      var k = qr.getStreamFromFD(V);
                      return k.stream_ops && k.stream_ops.fsync ? k.stream_ops.fsync(k) : 0;
                    } catch (_) {
                      if (typeof Ne == "undefined" || _.name !== "ErrnoError") throw _;
                      return _.errno;
                    }
                  }
                  var mA = (V, k, _, ue) => {
                    for (var Me = 0, lt = 0; lt < _; lt++) {
                      var Ut = Pi[k >> 2], Dt = Pi[k + 4 >> 2];
                      k += 8;
                      var kn = Ne.write(V, Co, Ut, Dt, ue);
                      if (kn < 0) return -1;
                      Me += kn;
                    }
                    return Me;
                  };
                  function a0(V, k, _, ue) {
                    try {
                      var Me = qr.getStreamFromFD(V), lt = mA(Me, k, _);
                      return Pi[ue >> 2] = lt, 0;
                    } catch (Ut) {
                      if (typeof Ne == "undefined" || Ut.name !== "ErrnoError") throw Ut;
                      return Ut.errno;
                    }
                  }
                  var Ig = (V, k) => (Da(ga.subarray(V, V + k)), 0), J0 = (V) => V % 4 === 0 && (V % 100 !== 0 || V % 400 === 0), Bg = (V, k) => {
                    for (var _ = 0, ue = 0; ue <= k; _ += V[ue++])
                      ;
                    return _;
                  }, vh = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Xu = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ku = (V, k) => {
                    for (var _ = new Date(V.getTime()); k > 0; ) {
                      var ue = J0(_.getFullYear()), Me = _.getMonth(), lt = (ue ? vh : Xu)[Me];
                      if (k > lt - _.getDate())
                        k -= lt - _.getDate() + 1, _.setDate(1), Me < 11 ? _.setMonth(Me + 1) : (_.setMonth(0), _.setFullYear(_.getFullYear() + 1));
                      else
                        return _.setDate(_.getDate() + k), _;
                    }
                    return _;
                  }, Zg = (V, k) => {
                    Co.set(V, k);
                  }, bh = (V, k, _, ue) => {
                    var Me = Pi[ue + 40 >> 2], lt = { tm_sec: Jo[ue >> 2], tm_min: Jo[ue + 4 >> 2], tm_hour: Jo[ue + 8 >> 2], tm_mday: Jo[ue + 12 >> 2], tm_mon: Jo[ue + 16 >> 2], tm_year: Jo[ue + 20 >> 2], tm_wday: Jo[ue + 24 >> 2], tm_yday: Jo[ue + 28 >> 2], tm_isdst: Jo[ue + 32 >> 2], tm_gmtoff: Jo[ue + 36 >> 2], tm_zone: Me ? ja(Me) : "" }, Ut = ja(_), Dt = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
                    for (var kn in Dt)
                      Ut = Ut.replace(new RegExp(kn, "g"), Dt[kn]);
                    var _n = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], $r = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    function Mi(yr, bi, Ni) {
                      for (var es = typeof yr == "number" ? yr.toString() : yr || ""; es.length < bi; )
                        es = Ni[0] + es;
                      return es;
                    }
                    function ri(yr, bi) {
                      return Mi(yr, bi, "0");
                    }
                    function Dr(yr, bi) {
                      function Ni(Qc) {
                        return Qc < 0 ? -1 : Qc > 0 ? 1 : 0;
                      }
                      var es;
                      return (es = Ni(yr.getFullYear() - bi.getFullYear())) === 0 && (es = Ni(yr.getMonth() - bi.getMonth())) === 0 && (es = Ni(yr.getDate() - bi.getDate())), es;
                    }
                    function ro(yr) {
                      switch (yr.getDay()) {
                        case 0:
                          return new Date(yr.getFullYear() - 1, 11, 29);
                        case 1:
                          return yr;
                        case 2:
                          return new Date(yr.getFullYear(), 0, 3);
                        case 3:
                          return new Date(yr.getFullYear(), 0, 2);
                        case 4:
                          return new Date(yr.getFullYear(), 0, 1);
                        case 5:
                          return new Date(yr.getFullYear() - 1, 11, 31);
                        case 6:
                          return new Date(yr.getFullYear() - 1, 11, 30);
                      }
                    }
                    function as(yr) {
                      var bi = ku(new Date(yr.tm_year + 1900, 0, 1), yr.tm_yday), Ni = new Date(bi.getFullYear(), 0, 4), es = new Date(bi.getFullYear() + 1, 0, 4), Qc = ro(Ni), qs = ro(es);
                      return Dr(Qc, bi) <= 0 ? Dr(qs, bi) <= 0 ? bi.getFullYear() + 1 : bi.getFullYear() : bi.getFullYear() - 1;
                    }
                    var io = { "%a": (yr) => _n[yr.tm_wday].substring(0, 3), "%A": (yr) => _n[yr.tm_wday], "%b": (yr) => $r[yr.tm_mon].substring(0, 3), "%B": (yr) => $r[yr.tm_mon], "%C": (yr) => {
                      var bi = yr.tm_year + 1900;
                      return ri(bi / 100 | 0, 2);
                    }, "%d": (yr) => ri(yr.tm_mday, 2), "%e": (yr) => Mi(yr.tm_mday, 2, " "), "%g": (yr) => as(yr).toString().substring(2), "%G": (yr) => as(yr), "%H": (yr) => ri(yr.tm_hour, 2), "%I": (yr) => {
                      var bi = yr.tm_hour;
                      return bi == 0 ? bi = 12 : bi > 12 && (bi -= 12), ri(bi, 2);
                    }, "%j": (yr) => ri(yr.tm_mday + Bg(J0(yr.tm_year + 1900) ? vh : Xu, yr.tm_mon - 1), 3), "%m": (yr) => ri(yr.tm_mon + 1, 2), "%M": (yr) => ri(yr.tm_min, 2), "%n": () => `
`, "%p": (yr) => yr.tm_hour >= 0 && yr.tm_hour < 12 ? "AM" : "PM", "%S": (yr) => ri(yr.tm_sec, 2), "%t": () => "	", "%u": (yr) => yr.tm_wday || 7, "%U": (yr) => {
                      var bi = yr.tm_yday + 7 - yr.tm_wday;
                      return ri(Math.floor(bi / 7), 2);
                    }, "%V": (yr) => {
                      var bi = Math.floor((yr.tm_yday + 7 - (yr.tm_wday + 6) % 7) / 7);
                      if ((yr.tm_wday + 371 - yr.tm_yday - 2) % 7 <= 2 && bi++, bi) {
                        if (bi == 53) {
                          var es = (yr.tm_wday + 371 - yr.tm_yday) % 7;
                          es != 4 && (es != 3 || !J0(yr.tm_year)) && (bi = 1);
                        }
                      } else {
                        bi = 52;
                        var Ni = (yr.tm_wday + 7 - yr.tm_yday - 1) % 7;
                        (Ni == 4 || Ni == 5 && J0(yr.tm_year % 400 - 1)) && bi++;
                      }
                      return ri(bi, 2);
                    }, "%w": (yr) => yr.tm_wday, "%W": (yr) => {
                      var bi = yr.tm_yday + 7 - (yr.tm_wday + 6) % 7;
                      return ri(Math.floor(bi / 7), 2);
                    }, "%y": (yr) => (yr.tm_year + 1900).toString().substring(2), "%Y": (yr) => yr.tm_year + 1900, "%z": (yr) => {
                      var bi = yr.tm_gmtoff, Ni = bi >= 0;
                      return bi = Math.abs(bi) / 60, bi = bi / 60 * 100 + bi % 60, (Ni ? "+" : "-") + ("0000" + bi).slice(-4);
                    }, "%Z": (yr) => yr.tm_zone, "%%": () => "%" };
                    Ut = Ut.replace(/%%/g, "\0\0");
                    for (var kn in io)
                      Ut.includes(kn) && (Ut = Ut.replace(new RegExp(kn, "g"), io[kn](lt)));
                    Ut = Ut.replace(/\0\0/g, "%");
                    var uo = Lc(Ut, !1);
                    return uo.length > k ? 0 : (Zg(uo, V), uo.length - 1);
                  }, Sg = (V, k, _, ue, Me) => bh(V, k, _, ue), vA = function(k, _, ue, Me) {
                    k || (k = this), this.parent = k, this.mount = k.mount, this.mounted = null, this.id = Ne.nextInode++, this.name = _, this.mode = ue, this.node_ops = {}, this.stream_ops = {}, this.rdev = Me;
                  }, G0 = 365, s0 = 146;
                  Object.defineProperties(vA.prototype, { read: { get: function() {
                    return (this.mode & G0) === G0;
                  }, set: function(k) {
                    k ? this.mode |= G0 : this.mode &= ~G0;
                  } }, write: { get: function() {
                    return (this.mode & s0) === s0;
                  }, set: function(k) {
                    k ? this.mode |= s0 : this.mode &= ~s0;
                  } }, isFolder: { get: function() {
                    return Ne.isDir(this.mode);
                  } }, isDevice: { get: function() {
                    return Ne.isChrdev(this.mode);
                  } } }), Ne.FSNode = vA, Ne.createPreloadedFile = Md, Ne.staticInit(), nt(), ze = ye.BindingError = /* @__PURE__ */ function(V) {
                    (0, h.default)(k, V);
                    function k(_) {
                      var ue;
                      return ue = V.call(this, _) || this, ue.name = "BindingError", ue;
                    }
                    return k;
                  }(/* @__PURE__ */ (0, A.default)(Error)), te = ye.InternalError = /* @__PURE__ */ function(V) {
                    (0, h.default)(k, V);
                    function k(_) {
                      var ue;
                      return ue = V.call(this, _) || this, ue.name = "InternalError", ue;
                    }
                    return k;
                  }(/* @__PURE__ */ (0, A.default)(Error)), ig(), Su(), ag(), Nu = ye.UnboundTypeError = sg(Error, "UnboundTypeError"), ug(), Ag();
                  var Fh = { a: Mc, t: Ud, s: ou, c: Vc, j: _s, oa: da, m: kd, g: au, ea: dc, R: Ta, ca: $d, fa: Id, _: _a, Z: no, da: Bd, X: xl, S: Yd, ja: rn, N: lg, M: I0, l: e0, ia: gg, H: pg, o: hA, k: vg, G: Ed, z: hh, ka: E0, ga: Gu, sa: dh, ta: Ah, q: AA, O: Fg, P: Rg, b: V0, E: Tu, Y: tc, w: cu, ha: bu, W: Fu, $: Qg, aa: Cg, la: pA, F: Ug, D: o0, Q: ph, ba: mh, y: a0, U: Ig, ra: BA, C: Qh, f: Eg, na: w0, qa: Uh, d: c0, e: X0, B: VA, v: IA, K: ZA, T: Jg, p: d0, i: yh, h: Rh, r: Wg, A: k0, n: Bh, pa: Vg, L: Ch, I: EA, J: SA, u: Ih, x: Ng, V: Sg, ma: sa }, Qa = Xd(), yu = (V) => (yu = Qa.xa)(V), sd = (V) => (sd = Qa.ya)(V), bA = (V) => (bA = Qa.Aa)(V), FA = () => (FA = Qa.Ba)(), RA = ye._fflush = (V) => (RA = ye._fflush = Qa.Ca)(V), yA = (V, k) => (yA = Qa.Da)(V, k), Ws = (V, k) => (Ws = Qa.Ea)(V, k), l0 = (V) => (l0 = Qa.Fa)(V), Qs = () => (Qs = Qa.Ga)(), Ms = (V) => (Ms = Qa.Ha)(V), QA = (V) => (QA = Qa.Ia)(V), CA = (V) => (CA = Qa.Ja)(V), T0 = (V, k, _) => (T0 = Qa.Ka)(V, k, _), UA = (V) => (UA = Qa.La)(V);
                  ye.dynCall_viijj = (V, k, _, ue, Me, lt, Ut) => (ye.dynCall_viijj = Qa.Ma)(V, k, _, ue, Me, lt, Ut), ye.dynCall_viiijjj = (V, k, _, ue, Me, lt, Ut, Dt, kn, _n) => (ye.dynCall_viiijjj = Qa.Na)(V, k, _, ue, Me, lt, Ut, Dt, kn, _n), ye.dynCall_iiiij = (V, k, _, ue, Me, lt) => (ye.dynCall_iiiij = Qa.Oa)(V, k, _, ue, Me, lt), ye.dynCall_jii = (V, k, _) => (ye.dynCall_jii = Qa.Pa)(V, k, _), ye.dynCall_jjj = (V, k, _, ue, Me) => (ye.dynCall_jjj = Qa.Qa)(V, k, _, ue, Me), ye.dynCall_iiiijj = (V, k, _, ue, Me, lt, Ut, Dt) => (ye.dynCall_iiiijj = Qa.Ra)(V, k, _, ue, Me, lt, Ut, Dt), ye.dynCall_viijji = (V, k, _, ue, Me, lt, Ut, Dt) => (ye.dynCall_viijji = Qa.Sa)(V, k, _, ue, Me, lt, Ut, Dt), ye.dynCall_iiijj = (V, k, _, ue, Me, lt, Ut) => (ye.dynCall_iiijj = Qa.Ta)(V, k, _, ue, Me, lt, Ut), ye.dynCall_viijjj = (V, k, _, ue, Me, lt, Ut, Dt, kn) => (ye.dynCall_viijjj = Qa.Ua)(V, k, _, ue, Me, lt, Ut, Dt, kn);
                  var wu = ye.dynCall_iij = (V, k, _, ue) => (wu = ye.dynCall_iij = Qa.Va)(V, k, _, ue);
                  ye.dynCall_iijjiiii = (V, k, _, ue, Me, lt, Ut, Dt, kn, _n) => (ye.dynCall_iijjiiii = Qa.Wa)(V, k, _, ue, Me, lt, Ut, Dt, kn, _n), ye.dynCall_jiji = (V, k, _, ue, Me) => (ye.dynCall_jiji = Qa.Xa)(V, k, _, ue, Me), ye.dynCall_viijii = (V, k, _, ue, Me, lt, Ut) => (ye.dynCall_viijii = Qa.Ya)(V, k, _, ue, Me, lt, Ut), ye.dynCall_iiiiij = (V, k, _, ue, Me, lt, Ut) => (ye.dynCall_iiiiij = Qa.Za)(V, k, _, ue, Me, lt, Ut), ye.dynCall_iiiiijj = (V, k, _, ue, Me, lt, Ut, Dt, kn) => (ye.dynCall_iiiiijj = Qa._a)(V, k, _, ue, Me, lt, Ut, Dt, kn), ye.dynCall_iiiiiijj = (V, k, _, ue, Me, lt, Ut, Dt, kn, _n) => (ye.dynCall_iiiiiijj = Qa.$a)(V, k, _, ue, Me, lt, Ut, Dt, kn, _n), ye.___start_em_js = 261460, ye.___stop_em_js = 262072;
                  function Eg(V, k) {
                    var _ = Qs();
                    try {
                      return Es(V)(k);
                    } catch (ue) {
                      if (Ms(_), ue !== ue + 0) throw ue;
                      Ws(1, 0);
                    }
                  }
                  function c0(V, k, _) {
                    var ue = Qs();
                    try {
                      return Es(V)(k, _);
                    } catch (Me) {
                      if (Ms(ue), Me !== Me + 0) throw Me;
                      Ws(1, 0);
                    }
                  }
                  function Rh(V, k, _) {
                    var ue = Qs();
                    try {
                      Es(V)(k, _);
                    } catch (Me) {
                      if (Ms(ue), Me !== Me + 0) throw Me;
                      Ws(1, 0);
                    }
                  }
                  function yh(V, k) {
                    var _ = Qs();
                    try {
                      Es(V)(k);
                    } catch (ue) {
                      if (Ms(_), ue !== ue + 0) throw ue;
                      Ws(1, 0);
                    }
                  }
                  function IA(V, k, _, ue, Me, lt) {
                    var Ut = Qs();
                    try {
                      return Es(V)(k, _, ue, Me, lt);
                    } catch (Dt) {
                      if (Ms(Ut), Dt !== Dt + 0) throw Dt;
                      Ws(1, 0);
                    }
                  }
                  function X0(V, k, _, ue) {
                    var Me = Qs();
                    try {
                      return Es(V)(k, _, ue);
                    } catch (lt) {
                      if (Ms(Me), lt !== lt + 0) throw lt;
                      Ws(1, 0);
                    }
                  }
                  function Qh(V) {
                    var k = Qs();
                    try {
                      return Es(V)();
                    } catch (_) {
                      if (Ms(k), _ !== _ + 0) throw _;
                      Ws(1, 0);
                    }
                  }
                  function Ch(V, k, _, ue, Me) {
                    var lt = Qs();
                    try {
                      Es(V)(k, _, ue, Me);
                    } catch (Ut) {
                      if (Ms(lt), Ut !== Ut + 0) throw Ut;
                      Ws(1, 0);
                    }
                  }
                  function BA(V, k) {
                    var _ = Qs();
                    try {
                      return Es(V)(k);
                    } catch (ue) {
                      if (Ms(_), ue !== ue + 0) throw ue;
                      Ws(1, 0);
                    }
                  }
                  function Uh(V, k, _) {
                    var ue = Qs();
                    try {
                      return Es(V)(k, _);
                    } catch (Me) {
                      if (Ms(ue), Me !== Me + 0) throw Me;
                      Ws(1, 0);
                    }
                  }
                  function ZA(V, k, _, ue, Me, lt, Ut) {
                    var Dt = Qs();
                    try {
                      return Es(V)(k, _, ue, Me, lt, Ut);
                    } catch (kn) {
                      if (Ms(Dt), kn !== kn + 0) throw kn;
                      Ws(1, 0);
                    }
                  }
                  function d0(V) {
                    var k = Qs();
                    try {
                      Es(V)();
                    } catch (_) {
                      if (Ms(k), _ !== _ + 0) throw _;
                      Ws(1, 0);
                    }
                  }
                  function SA(V, k, _, ue, Me, lt) {
                    var Ut = Qs();
                    try {
                      Es(V)(k, _, ue, Me, lt);
                    } catch (Dt) {
                      if (Ms(Ut), Dt !== Dt + 0) throw Dt;
                      Ws(1, 0);
                    }
                  }
                  function Ih(V, k, _, ue, Me, lt, Ut, Dt, kn, _n) {
                    var $r = Qs();
                    try {
                      Es(V)(k, _, ue, Me, lt, Ut, Dt, kn, _n);
                    } catch (Mi) {
                      if (Ms($r), Mi !== Mi + 0) throw Mi;
                      Ws(1, 0);
                    }
                  }
                  function Bh(V, k, _, ue) {
                    var Me = Qs();
                    try {
                      Es(V)(k, _, ue);
                    } catch (lt) {
                      if (Ms(Me), lt !== lt + 0) throw lt;
                      Ws(1, 0);
                    }
                  }
                  function EA(V, k, _, ue, Me, lt, Ut) {
                    var Dt = Qs();
                    try {
                      Es(V)(k, _, ue, Me, lt, Ut);
                    } catch (kn) {
                      if (Ms(Dt), kn !== kn + 0) throw kn;
                      Ws(1, 0);
                    }
                  }
                  function Vg(V, k, _, ue, Me, lt, Ut, Dt) {
                    var kn = Qs();
                    try {
                      Es(V)(k, _, ue, Me, lt, Ut, Dt);
                    } catch (_n) {
                      if (Ms(kn), _n !== _n + 0) throw _n;
                      Ws(1, 0);
                    }
                  }
                  function Wg(V, k, _, ue) {
                    var Me = Qs();
                    try {
                      Es(V)(k, _, ue);
                    } catch (lt) {
                      if (Ms(Me), lt !== lt + 0) throw lt;
                      Ws(1, 0);
                    }
                  }
                  function Ng(V, k, _, ue, Me, lt, Ut, Dt, kn) {
                    var _n = Qs();
                    try {
                      Es(V)(k, _, ue, Me, lt, Ut, Dt, kn);
                    } catch ($r) {
                      if (Ms(_n), $r !== $r + 0) throw $r;
                      Ws(1, 0);
                    }
                  }
                  function VA(V, k, _, ue, Me) {
                    var lt = Qs();
                    try {
                      return Es(V)(k, _, ue, Me);
                    } catch (Ut) {
                      if (Ms(lt), Ut !== Ut + 0) throw Ut;
                      Ws(1, 0);
                    }
                  }
                  function k0(V, k, _, ue, Me) {
                    var lt = Qs();
                    try {
                      Es(V)(k, _, ue, Me);
                    } catch (Ut) {
                      if (Ms(lt), Ut !== Ut + 0) throw Ut;
                      Ws(1, 0);
                    }
                  }
                  function w0(V, k, _, ue, Me) {
                    var lt = Qs();
                    try {
                      return Es(V)(k, _, ue, Me);
                    } catch (Ut) {
                      if (Ms(lt), Ut !== Ut + 0) throw Ut;
                      Ws(1, 0);
                    }
                  }
                  function Jg(V, k, _, ue) {
                    var Me = Qs();
                    try {
                      return wu(V, k, _, ue);
                    } catch (lt) {
                      if (Ms(Me), lt !== lt + 0) throw lt;
                      Ws(1, 0);
                    }
                  }
                  var D0;
                  ac = function V() {
                    D0 || Io(), D0 || (ac = V);
                  };
                  function Io() {
                    if (js > 0 || (Zl(), js > 0))
                      return;
                    function V() {
                      D0 || (D0 = !0, ye.calledRun = !0, !Ro && (Ml(), re(ye), ye.onRuntimeInitialized && ye.onRuntimeInitialized(), Td()));
                    }
                    ye.setStatus ? (ye.setStatus("Running..."), setTimeout(function() {
                      setTimeout(function() {
                        ye.setStatus("");
                      }, 1), V();
                    }, 1)) : V();
                  }
                  if (ye.preInit)
                    for (typeof ye.preInit == "function" && (ye.preInit = [ye.preInit]); ye.preInit.length > 0; )
                      ye.preInit.pop()();
                  return Io(), ot.ready;
                };
              })();
              b = m;
            }
            let y;
            {
              var m = (() => {
                var ot = location.href;
                return function(ye) {
                  ye === void 0 && (ye = {});
                  var re = ye, Be, He;
                  re.ready = new n((I, T) => {
                    Be = I, He = T;
                  });
                  var Xe = Object.assign({}, re), ut = "./this.program", ct = (I, T) => {
                    throw T;
                  }, Xt = typeof window == "object", pn = typeof importScripts == "function", un = typeof t == "object" && typeof t.versions == "object" && typeof t.versions.node == "string", vt = re.ENVIRONMENT_IS_PTHREAD || !1, gr = "";
                  function sr(I) {
                    return re.locateFile ? re.locateFile(I, gr) : gr + I;
                  }
                  var an, En, fn;
                  (Xt || pn) && (pn ? gr = self.location.href : typeof document != "undefined" && document.currentScript && (gr = document.currentScript.src), ot && (gr = ot), gr.indexOf("blob:") !== 0 ? gr = gr.substr(0, gr.replace(/[?#].*/, "").lastIndexOf("/") + 1) : gr = "", an = (I) => {
                    var T = new XMLHttpRequest();
                    return T.open("GET", I, !1), T.send(null), T.responseText;
                  }, pn && (fn = (I) => {
                    var T = new XMLHttpRequest();
                    return T.open("GET", I, !1), T.responseType = "arraybuffer", T.send(null), new Uint8Array(T.response);
                  }), En = (I, T, z) => {
                    var ae = new XMLHttpRequest();
                    ae.open("GET", I, !0), ae.responseType = "arraybuffer", ae.onload = () => {
                      if (ae.status == 200 || ae.status == 0 && ae.response) {
                        T(ae.response);
                        return;
                      }
                      z();
                    }, ae.onerror = z, ae.send(null);
                  });
                  var Fr = re.print || console.log.bind(console), Ro = re.printErr || console.error.bind(console);
                  Object.assign(re, Xe), Xe = null, re.arguments && re.arguments, re.thisProgram && (ut = re.thisProgram), re.quit && (ct = re.quit);
                  var ca;
                  re.wasmBinary && (ca = re.wasmBinary), typeof WebAssembly != "object" && _r("no native wasm support detected");
                  var Co, ga, aa = !1, Dl;
                  function Jo(I, T) {
                    I || _r(T);
                  }
                  var Pi, wa, yl, Ci, Ti, Di, Gd, _l;
                  function Zl() {
                    var I = Co.buffer;
                    re.HEAP8 = Pi = new Int8Array(I), re.HEAP16 = yl = new Int16Array(I), re.HEAPU8 = wa = new Uint8Array(I), re.HEAPU16 = Ci = new Uint16Array(I), re.HEAP32 = Ti = new Int32Array(I), re.HEAPU32 = Di = new Uint32Array(I), re.HEAPF32 = Gd = new Float32Array(I), re.HEAPF64 = _l = new Float64Array(I);
                  }
                  var Ml = re.INITIAL_MEMORY || 134217728;
                  if (vt)
                    Co = re.wasmMemory;
                  else if (re.wasmMemory)
                    Co = re.wasmMemory;
                  else if (Co = new WebAssembly.Memory({ initial: Ml / 65536, maximum: Ml / 65536, shared: !0 }), !(Co.buffer instanceof SharedArrayBuffer))
                    throw Ro("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag"), un && Ro("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)"), Error("bad memory");
                  Zl(), Ml = Co.buffer.byteLength;
                  var kc = [], Td = [], wc = [], $l = [], Yl = !1;
                  function js() {
                    if (re.preRun)
                      for (typeof re.preRun == "function" && (re.preRun = [re.preRun]); re.preRun.length; )
                        ed(re.preRun.shift());
                    Bd(kc);
                  }
                  function ac() {
                    vt || (!re.noFSInit && !Je.init.initialized && Je.init(), Je.ignorePermissions = !1, Bd(Td));
                  }
                  function Dc() {
                    vt || (Ut(), Bd(wc), Je.quit(), no.terminateAllThreads(), Yl = !0);
                  }
                  function Ll() {
                    if (!vt) {
                      if (re.postRun)
                        for (typeof re.postRun == "function" && (re.postRun = [re.postRun]); re.postRun.length; )
                          Ql(re.postRun.shift());
                      Bd($l);
                    }
                  }
                  function ed(I) {
                    kc.unshift(I);
                  }
                  function sc(I) {
                    Td.unshift(I);
                  }
                  function Ql(I) {
                    $l.unshift(I);
                  }
                  var ql = 0, Ds = null;
                  function jd(I) {
                    return I;
                  }
                  function Sc(I) {
                    ql++, re.monitorRunDependencies && re.monitorRunDependencies(ql);
                  }
                  function Cl(I) {
                    if (ql--, re.monitorRunDependencies && re.monitorRunDependencies(ql), ql == 0 && Ds) {
                      var T = Ds;
                      Ds = null, T();
                    }
                  }
                  function _r(I) {
                    re.onAbort && re.onAbort(I), I = "Aborted(" + I + ")", Ro(I), aa = !0, Dl = 1, I += ". Build with -sASSERTIONS for more info.";
                    var T = new WebAssembly.RuntimeError(I);
                    throw He(T), T;
                  }
                  var Xd = "data:application/octet-stream;base64,", to = (I) => I.startsWith(Xd), Za;
                  re.locateFile ? (Za = "main-bin-multi.wasm", to(Za) || (Za = sr(Za))) : Za = new URL("main-bin-multi.wasm", location.href).href;
                  function sa(I) {
                    if (I == Za && ca)
                      return new Uint8Array(ca);
                    if (fn)
                      return fn(I);
                    throw "both async and sync fetching of the wasm failed";
                  }
                  function Ec(I) {
                    return !ca && (Xt || pn) && typeof fetch == "function" ? fetch(I, { credentials: "same-origin" }).then((T) => {
                      if (!T.ok)
                        throw "failed to load wasm binary file at '" + I + "'";
                      return T.arrayBuffer();
                    }).catch(() => sa(I)) : n.resolve().then(() => sa(I));
                  }
                  function Fc(I, T, z) {
                    return Ec(I).then((ae) => WebAssembly.instantiate(ae, T)).then((ae) => ae).then(z, (ae) => {
                      Ro(`failed to asynchronously prepare wasm: ${ae}`), _r(ae);
                    });
                  }
                  function Cd(I, T, z, ae) {
                    return !I && typeof WebAssembly.instantiateStreaming == "function" && !to(T) && typeof fetch == "function" ? fetch(T, { credentials: "same-origin" }).then((Ve) => {
                      var qe = WebAssembly.instantiateStreaming(Ve, z);
                      return qe.then(ae, function(gt) {
                        return Ro(`wasm streaming compile failed: ${gt}`), Ro("falling back to ArrayBuffer instantiation"), Fc(T, z, ae);
                      });
                    }) : Fc(T, z, ae);
                  }
                  function Sl() {
                    var I = { a: D0 };
                    function T(ae, Ve) {
                      return Io = ae.exports, be(Io.Ka), Ke = Io.Ga, sc(Io.Ea), ga = Ve, Cl(), Io;
                    }
                    Sc();
                    function z(ae) {
                      T(ae.instance, ae.module);
                    }
                    if (re.instantiateWasm)
                      try {
                        return re.instantiateWasm(I, T);
                      } catch (ae) {
                        Ro(`Module.instantiateWasm callback failed with error: ${ae}`), He(ae);
                      }
                    return Cd(ca, Za, I, z).catch(He), {};
                  }
                  var Uo, ja;
                  function Mc(I, T, z, ae) {
                    const Ve = Ke.length, qe = new Uint8Array(wa.slice(I + T, I + z));
                    try {
                      var gt = new WebAssembly.Module(qe), Wt = new WebAssembly.Instance(gt, { env: { memory: Co } });
                      for (var Rn in Wt.exports) {
                        var Ln = Wt.exports[Rn];
                        addFunction(Ln);
                      }
                      return Ve < Ke.length ? Ve : ae;
                    } catch (Lr) {
                      return console.log(Lr), ae;
                    }
                  }
                  function td(I) {
                    this.name = "ExitStatus", this.message = `Program terminated with exit(${I})`, this.status = I;
                  }
                  var Ud = (I) => {
                    I.terminate(), I.onmessage = (T) => {
                    };
                  }, fl = (I) => {
                    var T = no.pthreads[I];
                    delete no.pthreads[I], Ud(T), $r(I), no.runningWorkers.splice(no.runningWorkers.indexOf(T), 1), T.pthread_ptr = 0;
                  }, ou = (I) => {
                    var T = no.pthreads[I];
                    T.postMessage({ cmd: "cancel" });
                  }, nd = (I) => {
                    var T = no.pthreads[I];
                    no.returnWorkerToPool(T);
                  }, au = (I, T) => (wa.fill(0, I, I + T), I), lc = (I) => {
                    var T = no.getNewWorker();
                    if (!T)
                      return 6;
                    no.runningWorkers.push(T), no.pthreads[I.pthread_ptr] = T, T.pthread_ptr = I.pthread_ptr;
                    var z = { cmd: "run", start_routine: I.startRoutine, arg: I.arg, pthread_ptr: I.pthread_ptr };
                    return T.postMessage(z, I.transferList), 0;
                  }, Vc = 0, _s = () => $t || Vc > 0, da = { isAbs: (I) => I.charAt(0) === "/", splitPath: (I) => {
                    var T = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                    return T.exec(I).slice(1);
                  }, normalizeArray: (I, T) => {
                    for (var z = 0, ae = I.length - 1; ae >= 0; ae--) {
                      var Ve = I[ae];
                      Ve === "." ? I.splice(ae, 1) : Ve === ".." ? (I.splice(ae, 1), z++) : z && (I.splice(ae, 1), z--);
                    }
                    if (T)
                      for (; z; z--)
                        I.unshift("..");
                    return I;
                  }, normalize: (I) => {
                    var T = da.isAbs(I), z = I.substr(-1) === "/";
                    return I = da.normalizeArray(I.split("/").filter((ae) => !!ae), !T).join("/"), !I && !T && (I = "."), I && z && (I += "/"), (T ? "/" : "") + I;
                  }, dirname: (I) => {
                    var T = da.splitPath(I), z = T[0], ae = T[1];
                    return !z && !ae ? "." : (ae && (ae = ae.substr(0, ae.length - 1)), z + ae);
                  }, basename: (I) => {
                    if (I === "/") return "/";
                    I = da.normalize(I), I = I.replace(/\/$/, "");
                    var T = I.lastIndexOf("/");
                    return T === -1 ? I : I.substr(T + 1);
                  }, join: function() {
                    var T = Array.prototype.slice.call(arguments);
                    return da.normalize(T.join("/"));
                  }, join2: (I, T) => da.normalize(I + "/" + T) }, kd = () => {
                    if (typeof crypto == "object" && typeof crypto.getRandomValues == "function")
                      return (I) => (I.set(crypto.getRandomValues(new Uint8Array(I.byteLength))), I);
                    _r("initRandomDevice");
                  }, la = (I) => (la = kd())(I), cc = { resolve: function() {
                    for (var T = "", z = !1, ae = arguments.length - 1; ae >= -1 && !z; ae--) {
                      var Ve = ae >= 0 ? arguments[ae] : Je.cwd();
                      if (typeof Ve != "string")
                        throw new TypeError("Arguments to path.resolve must be strings");
                      if (!Ve)
                        return "";
                      T = Ve + "/" + T, z = da.isAbs(Ve);
                    }
                    return T = da.normalizeArray(T.split("/").filter((qe) => !!qe), !z).join("/"), (z ? "/" : "") + T || ".";
                  }, relative: (I, T) => {
                    I = cc.resolve(I).substr(1), T = cc.resolve(T).substr(1);
                    function z(Ln) {
                      for (var Lr = 0; Lr < Ln.length && Ln[Lr] === ""; Lr++)
                        ;
                      for (var Oi = Ln.length - 1; Oi >= 0 && Ln[Oi] === ""; Oi--)
                        ;
                      return Lr > Oi ? [] : Ln.slice(Lr, Oi - Lr + 1);
                    }
                    for (var ae = z(I.split("/")), Ve = z(T.split("/")), qe = Math.min(ae.length, Ve.length), gt = qe, Wt = 0; Wt < qe; Wt++)
                      if (ae[Wt] !== Ve[Wt]) {
                        gt = Wt;
                        break;
                      }
                    for (var Rn = [], Wt = gt; Wt < ae.length; Wt++)
                      Rn.push("..");
                    return Rn = Rn.concat(Ve.slice(gt)), Rn.join("/");
                  } }, Da = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0, ea = (I, T, z) => {
                    for (var ae = T + z, Ve = T; I[Ve] && !(Ve >= ae); ) ++Ve;
                    if (Ve - T > 16 && I.buffer && Da)
                      return Da.decode(I.buffer instanceof SharedArrayBuffer ? I.slice(T, Ve) : I.subarray(T, Ve));
                    for (var qe = ""; T < Ve; ) {
                      var gt = I[T++];
                      if (!(gt & 128)) {
                        qe += String.fromCharCode(gt);
                        continue;
                      }
                      var Wt = I[T++] & 63;
                      if ((gt & 224) == 192) {
                        qe += String.fromCharCode((gt & 31) << 6 | Wt);
                        continue;
                      }
                      var Rn = I[T++] & 63;
                      if ((gt & 240) == 224 ? gt = (gt & 15) << 12 | Wt << 6 | Rn : gt = (gt & 7) << 18 | Wt << 12 | Rn << 6 | I[T++] & 63, gt < 65536)
                        qe += String.fromCharCode(gt);
                      else {
                        var Ln = gt - 65536;
                        qe += String.fromCharCode(55296 | Ln >> 10, 56320 | Ln & 1023);
                      }
                    }
                    return qe;
                  }, ec = [], Yc = (I) => {
                    for (var T = 0, z = 0; z < I.length; ++z) {
                      var ae = I.charCodeAt(z);
                      ae <= 127 ? T++ : ae <= 2047 ? T += 2 : ae >= 55296 && ae <= 57343 ? (T += 4, ++z) : T += 3;
                    }
                    return T;
                  }, rd = (I, T, z, ae) => {
                    if (!(ae > 0)) return 0;
                    for (var Ve = z, qe = z + ae - 1, gt = 0; gt < I.length; ++gt) {
                      var Wt = I.charCodeAt(gt);
                      if (Wt >= 55296 && Wt <= 57343) {
                        var Rn = I.charCodeAt(++gt);
                        Wt = 65536 + ((Wt & 1023) << 10) | Rn & 1023;
                      }
                      if (Wt <= 127) {
                        if (z >= qe) break;
                        T[z++] = Wt;
                      } else if (Wt <= 2047) {
                        if (z + 1 >= qe) break;
                        T[z++] = 192 | Wt >> 6, T[z++] = 128 | Wt & 63;
                      } else if (Wt <= 65535) {
                        if (z + 2 >= qe) break;
                        T[z++] = 224 | Wt >> 12, T[z++] = 128 | Wt >> 6 & 63, T[z++] = 128 | Wt & 63;
                      } else {
                        if (z + 3 >= qe) break;
                        T[z++] = 240 | Wt >> 18, T[z++] = 128 | Wt >> 12 & 63, T[z++] = 128 | Wt >> 6 & 63, T[z++] = 128 | Wt & 63;
                      }
                    }
                    return T[z] = 0, z - Ve;
                  };
                  function Lc(I, T, z) {
                    var ae = Yc(I) + 1, Ve = new Array(ae), qe = rd(I, Ve, 0, Ve.length);
                    return T && (Ve.length = qe), Ve;
                  }
                  var fu = () => {
                    if (!ec.length) {
                      var I = null;
                      if (typeof window != "undefined" && typeof window.prompt == "function" ? (I = window.prompt("Input: "), I !== null && (I += `
`)) : typeof readline == "function" && (I = readline(), I !== null && (I += `
`)), !I)
                        return null;
                      ec = Lc(I, !0);
                    }
                    return ec.shift();
                  }, El = { ttys: [], init() {
                  }, shutdown() {
                  }, register(I, T) {
                    El.ttys[I] = { input: [], output: [], ops: T }, Je.registerDevice(I, El.stream_ops);
                  }, stream_ops: { open(I) {
                    var T = El.ttys[I.node.rdev];
                    if (!T)
                      throw new Je.ErrnoError(43);
                    I.tty = T, I.seekable = !1;
                  }, close(I) {
                    I.tty.ops.fsync(I.tty);
                  }, fsync(I) {
                    I.tty.ops.fsync(I.tty);
                  }, read(I, T, z, ae, Ve) {
                    if (!I.tty || !I.tty.ops.get_char)
                      throw new Je.ErrnoError(60);
                    for (var qe = 0, gt = 0; gt < ae; gt++) {
                      var Wt;
                      try {
                        Wt = I.tty.ops.get_char(I.tty);
                      } catch {
                        throw new Je.ErrnoError(29);
                      }
                      if (Wt === void 0 && qe === 0)
                        throw new Je.ErrnoError(6);
                      if (Wt == null) break;
                      qe++, T[z + gt] = Wt;
                    }
                    return qe && (I.node.timestamp = Date.now()), qe;
                  }, write(I, T, z, ae, Ve) {
                    if (!I.tty || !I.tty.ops.put_char)
                      throw new Je.ErrnoError(60);
                    try {
                      for (var qe = 0; qe < ae; qe++)
                        I.tty.ops.put_char(I.tty, T[z + qe]);
                    } catch {
                      throw new Je.ErrnoError(29);
                    }
                    return ae && (I.node.timestamp = Date.now()), qe;
                  } }, default_tty_ops: { get_char(I) {
                    return fu();
                  }, put_char(I, T) {
                    T === null || T === 10 ? (Fr(ea(I.output, 0)), I.output = []) : T != 0 && I.output.push(T);
                  }, fsync(I) {
                    I.output && I.output.length > 0 && (Fr(ea(I.output, 0)), I.output = []);
                  }, ioctl_tcgets(I) {
                    return { c_iflag: 25856, c_oflag: 5, c_cflag: 191, c_lflag: 35387, c_cc: [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] };
                  }, ioctl_tcsets(I, T, z) {
                    return 0;
                  }, ioctl_tiocgwinsz(I) {
                    return [24, 80];
                  } }, default_tty1_ops: { put_char(I, T) {
                    T === null || T === 10 ? (Ro(ea(I.output, 0)), I.output = []) : T != 0 && I.output.push(T);
                  }, fsync(I) {
                    I.output && I.output.length > 0 && (Ro(ea(I.output, 0)), I.output = []);
                  } } }, xc = (I, T) => Math.ceil(I / T) * T, _d = (I) => {
                    I = xc(I, 65536);
                    var T = Me(65536, I);
                    return T ? au(T, I) : 0;
                  }, vo = { ops_table: null, mount(I) {
                    return vo.createNode(null, "/", 16895, 0);
                  }, createNode(I, T, z, ae) {
                    if (Je.isBlkdev(z) || Je.isFIFO(z))
                      throw new Je.ErrnoError(63);
                    vo.ops_table || (vo.ops_table = { dir: { node: { getattr: vo.node_ops.getattr, setattr: vo.node_ops.setattr, lookup: vo.node_ops.lookup, mknod: vo.node_ops.mknod, rename: vo.node_ops.rename, unlink: vo.node_ops.unlink, rmdir: vo.node_ops.rmdir, readdir: vo.node_ops.readdir, symlink: vo.node_ops.symlink }, stream: { llseek: vo.stream_ops.llseek } }, file: { node: { getattr: vo.node_ops.getattr, setattr: vo.node_ops.setattr }, stream: { llseek: vo.stream_ops.llseek, read: vo.stream_ops.read, write: vo.stream_ops.write, allocate: vo.stream_ops.allocate, mmap: vo.stream_ops.mmap, msync: vo.stream_ops.msync } }, link: { node: { getattr: vo.node_ops.getattr, setattr: vo.node_ops.setattr, readlink: vo.node_ops.readlink }, stream: {} }, chrdev: { node: { getattr: vo.node_ops.getattr, setattr: vo.node_ops.setattr }, stream: Je.chrdev_stream_ops } });
                    var Ve = Je.createNode(I, T, z, ae);
                    return Je.isDir(Ve.mode) ? (Ve.node_ops = vo.ops_table.dir.node, Ve.stream_ops = vo.ops_table.dir.stream, Ve.contents = {}) : Je.isFile(Ve.mode) ? (Ve.node_ops = vo.ops_table.file.node, Ve.stream_ops = vo.ops_table.file.stream, Ve.usedBytes = 0, Ve.contents = null) : Je.isLink(Ve.mode) ? (Ve.node_ops = vo.ops_table.link.node, Ve.stream_ops = vo.ops_table.link.stream) : Je.isChrdev(Ve.mode) && (Ve.node_ops = vo.ops_table.chrdev.node, Ve.stream_ops = vo.ops_table.chrdev.stream), Ve.timestamp = Date.now(), I && (I.contents[T] = Ve, I.timestamp = Ve.timestamp), Ve;
                  }, getFileDataAsTypedArray(I) {
                    return I.contents ? I.contents.subarray ? I.contents.subarray(0, I.usedBytes) : new Uint8Array(I.contents) : new Uint8Array(0);
                  }, expandFileStorage(I, T) {
                    var z = I.contents ? I.contents.length : 0;
                    if (!(z >= T)) {
                      var ae = 1024 * 1024;
                      T = Math.max(T, z * (z < ae ? 2 : 1.125) >>> 0), z != 0 && (T = Math.max(T, 256));
                      var Ve = I.contents;
                      I.contents = new Uint8Array(T), I.usedBytes > 0 && I.contents.set(Ve.subarray(0, I.usedBytes), 0);
                    }
                  }, resizeFileStorage(I, T) {
                    if (I.usedBytes != T)
                      if (T == 0)
                        I.contents = null, I.usedBytes = 0;
                      else {
                        var z = I.contents;
                        I.contents = new Uint8Array(T), z && I.contents.set(z.subarray(0, Math.min(T, I.usedBytes))), I.usedBytes = T;
                      }
                  }, node_ops: { getattr(I) {
                    var T = {};
                    return T.dev = Je.isChrdev(I.mode) ? I.id : 1, T.ino = I.id, T.mode = I.mode, T.nlink = 1, T.uid = 0, T.gid = 0, T.rdev = I.rdev, Je.isDir(I.mode) ? T.size = 4096 : Je.isFile(I.mode) ? T.size = I.usedBytes : Je.isLink(I.mode) ? T.size = I.link.length : T.size = 0, T.atime = new Date(I.timestamp), T.mtime = new Date(I.timestamp), T.ctime = new Date(I.timestamp), T.blksize = 4096, T.blocks = Math.ceil(T.size / T.blksize), T;
                  }, setattr(I, T) {
                    T.mode !== void 0 && (I.mode = T.mode), T.timestamp !== void 0 && (I.timestamp = T.timestamp), T.size !== void 0 && vo.resizeFileStorage(I, T.size);
                  }, lookup(I, T) {
                    throw Je.genericErrors[44];
                  }, mknod(I, T, z, ae) {
                    return vo.createNode(I, T, z, ae);
                  }, rename(I, T, z) {
                    if (Je.isDir(I.mode)) {
                      var ae;
                      try {
                        ae = Je.lookupNode(T, z);
                      } catch {
                      }
                      if (ae)
                        for (var Ve in ae.contents)
                          throw new Je.ErrnoError(55);
                    }
                    delete I.parent.contents[I.name], I.parent.timestamp = Date.now(), I.name = z, T.contents[z] = I, T.timestamp = I.parent.timestamp, I.parent = T;
                  }, unlink(I, T) {
                    delete I.contents[T], I.timestamp = Date.now();
                  }, rmdir(I, T) {
                    var z = Je.lookupNode(I, T);
                    for (var ae in z.contents)
                      throw new Je.ErrnoError(55);
                    delete I.contents[T], I.timestamp = Date.now();
                  }, readdir(I) {
                    var T = [".", ".."];
                    for (var z in I.contents)
                      I.contents.hasOwnProperty(z) && T.push(z);
                    return T;
                  }, symlink(I, T, z) {
                    var ae = vo.createNode(I, T, 41471, 0);
                    return ae.link = z, ae;
                  }, readlink(I) {
                    if (!Je.isLink(I.mode))
                      throw new Je.ErrnoError(28);
                    return I.link;
                  } }, stream_ops: { read(I, T, z, ae, Ve) {
                    var qe = I.node.contents;
                    if (Ve >= I.node.usedBytes) return 0;
                    var gt = Math.min(I.node.usedBytes - Ve, ae);
                    if (gt > 8 && qe.subarray)
                      T.set(qe.subarray(Ve, Ve + gt), z);
                    else
                      for (var Wt = 0; Wt < gt; Wt++) T[z + Wt] = qe[Ve + Wt];
                    return gt;
                  }, write(I, T, z, ae, Ve, qe) {
                    if (!ae) return 0;
                    var gt = I.node;
                    if (gt.timestamp = Date.now(), T.subarray && (!gt.contents || gt.contents.subarray)) {
                      if (qe)
                        return gt.contents = T.subarray(z, z + ae), gt.usedBytes = ae, ae;
                      if (gt.usedBytes === 0 && Ve === 0)
                        return gt.contents = T.slice(z, z + ae), gt.usedBytes = ae, ae;
                      if (Ve + ae <= gt.usedBytes)
                        return gt.contents.set(T.subarray(z, z + ae), Ve), ae;
                    }
                    if (vo.expandFileStorage(gt, Ve + ae), gt.contents.subarray && T.subarray)
                      gt.contents.set(T.subarray(z, z + ae), Ve);
                    else
                      for (var Wt = 0; Wt < ae; Wt++)
                        gt.contents[Ve + Wt] = T[z + Wt];
                    return gt.usedBytes = Math.max(gt.usedBytes, Ve + ae), ae;
                  }, llseek(I, T, z) {
                    var ae = T;
                    if (z === 1 ? ae += I.position : z === 2 && Je.isFile(I.node.mode) && (ae += I.node.usedBytes), ae < 0)
                      throw new Je.ErrnoError(28);
                    return ae;
                  }, allocate(I, T, z) {
                    vo.expandFileStorage(I.node, T + z), I.node.usedBytes = Math.max(I.node.usedBytes, T + z);
                  }, mmap(I, T, z, ae, Ve) {
                    if (!Je.isFile(I.node.mode))
                      throw new Je.ErrnoError(43);
                    var qe, gt, Wt = I.node.contents;
                    if (!(Ve & 2) && Wt.buffer === Pi.buffer)
                      gt = !1, qe = Wt.byteOffset;
                    else {
                      if ((z > 0 || z + T < Wt.length) && (Wt.subarray ? Wt = Wt.subarray(z, z + T) : Wt = Array.prototype.slice.call(Wt, z, z + T)), gt = !0, qe = _d(T), !qe)
                        throw new Je.ErrnoError(48);
                      Pi.set(Wt, qe);
                    }
                    return { ptr: qe, allocated: gt };
                  }, msync(I, T, z, ae, Ve) {
                    return vo.stream_ops.write(I, T, 0, ae, z, !1), 0;
                  } } }, co = (I, T, z, ae) => {
                    var Ve = `al ${I}`;
                    En(I, (qe) => {
                      Jo(qe, `Loading data file "${I}" failed (no arrayBuffer).`), T(new Uint8Array(qe)), Ve && Cl();
                    }, (qe) => {
                      if (z)
                        z();
                      else
                        throw `Loading data file "${I}" failed.`;
                    }), Ve && Sc();
                  }, id = (I, T, z, ae, Ve, qe) => {
                    Je.createDataFile(I, T, z, ae, Ve, qe);
                  }, wd = re.preloadPlugins || [], Dd = (I, T, z, ae) => {
                    typeof Browser != "undefined" && Browser.init();
                    var Ve = !1;
                    return wd.forEach((qe) => {
                      Ve || qe.canHandle(T) && (qe.handle(I, T, z, ae), Ve = !0);
                    }), Ve;
                  }, su = (I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln) => {
                    var Lr = T ? cc.resolve(da.join2(I, T)) : I;
                    function Oi(ii) {
                      function gi(Bo) {
                        Ln && Ln(), Wt || id(I, T, Bo, ae, Ve, Rn), qe && qe(), Cl();
                      }
                      Dd(ii, Lr, gi, () => {
                        gt && gt(), Cl();
                      }) || gi(ii);
                    }
                    Sc(), typeof z == "string" ? co(z, (ii) => Oi(ii), gt) : Oi(z);
                  }, Md = (I) => {
                    var T = { r: 0, "r+": 2, w: 577, "w+": 578, a: 1089, "a+": 1090 }, z = T[I];
                    if (typeof z == "undefined")
                      throw new Error(`Unknown file open mode: ${I}`);
                    return z;
                  }, od = (I, T) => {
                    var z = 0;
                    return I && (z |= 365), T && (z |= 146), z;
                  }, Je = { root: null, mounts: [], devices: {}, streams: [], nextInode: 1, nameTable: null, currentPath: "/", initialized: !1, ignorePermissions: !0, ErrnoError: null, genericErrors: {}, filesystems: null, syncFSRequests: 0, lookupPath(I, T) {
                    if (T === void 0 && (T = {}), I = cc.resolve(I), !I) return { path: "", node: null };
                    var z = { follow_mount: !0, recurse_count: 0 };
                    if (T = Object.assign(z, T), T.recurse_count > 8)
                      throw new Je.ErrnoError(32);
                    for (var ae = I.split("/").filter((Oi) => !!Oi), Ve = Je.root, qe = "/", gt = 0; gt < ae.length; gt++) {
                      var Wt = gt === ae.length - 1;
                      if (Wt && T.parent)
                        break;
                      if (Ve = Je.lookupNode(Ve, ae[gt]), qe = da.join2(qe, ae[gt]), Je.isMountpoint(Ve) && (!Wt || Wt && T.follow_mount) && (Ve = Ve.mounted.root), !Wt || T.follow)
                        for (var Rn = 0; Je.isLink(Ve.mode); ) {
                          var Ln = Je.readlink(qe);
                          qe = cc.resolve(da.dirname(qe), Ln);
                          var Lr = Je.lookupPath(qe, { recurse_count: T.recurse_count + 1 });
                          if (Ve = Lr.node, Rn++ > 40)
                            throw new Je.ErrnoError(32);
                        }
                    }
                    return { path: qe, node: Ve };
                  }, getPath(I) {
                    for (var T; ; ) {
                      if (Je.isRoot(I)) {
                        var z = I.mount.mountpoint;
                        return T ? z[z.length - 1] !== "/" ? `${z}/${T}` : z + T : z;
                      }
                      T = T ? `${I.name}/${T}` : I.name, I = I.parent;
                    }
                  }, hashName(I, T) {
                    for (var z = 0, ae = 0; ae < T.length; ae++)
                      z = (z << 5) - z + T.charCodeAt(ae) | 0;
                    return (I + z >>> 0) % Je.nameTable.length;
                  }, hashAddNode(I) {
                    var T = Je.hashName(I.parent.id, I.name);
                    I.name_next = Je.nameTable[T], Je.nameTable[T] = I;
                  }, hashRemoveNode(I) {
                    var T = Je.hashName(I.parent.id, I.name);
                    if (Je.nameTable[T] === I)
                      Je.nameTable[T] = I.name_next;
                    else
                      for (var z = Je.nameTable[T]; z; ) {
                        if (z.name_next === I) {
                          z.name_next = I.name_next;
                          break;
                        }
                        z = z.name_next;
                      }
                  }, lookupNode(I, T) {
                    var z = Je.mayLookup(I);
                    if (z)
                      throw new Je.ErrnoError(z, I);
                    for (var ae = Je.hashName(I.id, T), Ve = Je.nameTable[ae]; Ve; Ve = Ve.name_next) {
                      var qe = Ve.name;
                      if (Ve.parent.id === I.id && qe === T)
                        return Ve;
                    }
                    return Je.lookup(I, T);
                  }, createNode(I, T, z, ae) {
                    var Ve = new Je.FSNode(I, T, z, ae);
                    return Je.hashAddNode(Ve), Ve;
                  }, destroyNode(I) {
                    Je.hashRemoveNode(I);
                  }, isRoot(I) {
                    return I === I.parent;
                  }, isMountpoint(I) {
                    return !!I.mounted;
                  }, isFile(I) {
                    return (I & 61440) === 32768;
                  }, isDir(I) {
                    return (I & 61440) === 16384;
                  }, isLink(I) {
                    return (I & 61440) === 40960;
                  }, isChrdev(I) {
                    return (I & 61440) === 8192;
                  }, isBlkdev(I) {
                    return (I & 61440) === 24576;
                  }, isFIFO(I) {
                    return (I & 61440) === 4096;
                  }, isSocket(I) {
                    return (I & 49152) === 49152;
                  }, flagsToPermissionString(I) {
                    var T = ["r", "w", "rw"][I & 3];
                    return I & 512 && (T += "w"), T;
                  }, nodePermissions(I, T) {
                    return Je.ignorePermissions ? 0 : T.includes("r") && !(I.mode & 292) || T.includes("w") && !(I.mode & 146) || T.includes("x") && !(I.mode & 73) ? 2 : 0;
                  }, mayLookup(I) {
                    var T = Je.nodePermissions(I, "x");
                    return T || (I.node_ops.lookup ? 0 : 2);
                  }, mayCreate(I, T) {
                    try {
                      var z = Je.lookupNode(I, T);
                      return 20;
                    } catch {
                    }
                    return Je.nodePermissions(I, "wx");
                  }, mayDelete(I, T, z) {
                    var ae;
                    try {
                      ae = Je.lookupNode(I, T);
                    } catch (qe) {
                      return qe.errno;
                    }
                    var Ve = Je.nodePermissions(I, "wx");
                    if (Ve)
                      return Ve;
                    if (z) {
                      if (!Je.isDir(ae.mode))
                        return 54;
                      if (Je.isRoot(ae) || Je.getPath(ae) === Je.cwd())
                        return 10;
                    } else if (Je.isDir(ae.mode))
                      return 31;
                    return 0;
                  }, mayOpen(I, T) {
                    return I ? Je.isLink(I.mode) ? 32 : Je.isDir(I.mode) && (Je.flagsToPermissionString(T) !== "r" || T & 512) ? 31 : Je.nodePermissions(I, Je.flagsToPermissionString(T)) : 44;
                  }, MAX_OPEN_FDS: 4096, nextfd() {
                    for (var I = 0; I <= Je.MAX_OPEN_FDS; I++)
                      if (!Je.streams[I])
                        return I;
                    throw new Je.ErrnoError(33);
                  }, getStreamChecked(I) {
                    var T = Je.getStream(I);
                    if (!T)
                      throw new Je.ErrnoError(8);
                    return T;
                  }, getStream: (I) => Je.streams[I], createStream(I, T) {
                    return T === void 0 && (T = -1), Je.FSStream || (Je.FSStream = function() {
                      this.shared = {};
                    }, Je.FSStream.prototype = {}, Object.defineProperties(Je.FSStream.prototype, { object: { get() {
                      return this.node;
                    }, set(z) {
                      this.node = z;
                    } }, isRead: { get() {
                      return (this.flags & 2097155) !== 1;
                    } }, isWrite: { get() {
                      return (this.flags & 2097155) !== 0;
                    } }, isAppend: { get() {
                      return this.flags & 1024;
                    } }, flags: { get() {
                      return this.shared.flags;
                    }, set(z) {
                      this.shared.flags = z;
                    } }, position: { get() {
                      return this.shared.position;
                    }, set(z) {
                      this.shared.position = z;
                    } } })), I = Object.assign(new Je.FSStream(), I), T == -1 && (T = Je.nextfd()), I.fd = T, Je.streams[T] = I, I;
                  }, closeStream(I) {
                    Je.streams[I] = null;
                  }, chrdev_stream_ops: { open(I) {
                    var T = Je.getDevice(I.node.rdev);
                    I.stream_ops = T.stream_ops, I.stream_ops.open && I.stream_ops.open(I);
                  }, llseek() {
                    throw new Je.ErrnoError(70);
                  } }, major: (I) => I >> 8, minor: (I) => I & 255, makedev: (I, T) => I << 8 | T, registerDevice(I, T) {
                    Je.devices[I] = { stream_ops: T };
                  }, getDevice: (I) => Je.devices[I], getMounts(I) {
                    for (var T = [], z = [I]; z.length; ) {
                      var ae = z.pop();
                      T.push(ae), z.push.apply(z, ae.mounts);
                    }
                    return T;
                  }, syncfs(I, T) {
                    typeof I == "function" && (T = I, I = !1), Je.syncFSRequests++, Je.syncFSRequests > 1 && Ro(`warning: ${Je.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
                    var z = Je.getMounts(Je.root.mount), ae = 0;
                    function Ve(gt) {
                      return Je.syncFSRequests--, T(gt);
                    }
                    function qe(gt) {
                      if (gt)
                        return qe.errored ? void 0 : (qe.errored = !0, Ve(gt));
                      ++ae >= z.length && Ve(null);
                    }
                    z.forEach((gt) => {
                      if (!gt.type.syncfs)
                        return qe(null);
                      gt.type.syncfs(gt, I, qe);
                    });
                  }, mount(I, T, z) {
                    var ae = z === "/", Ve = !z, qe;
                    if (ae && Je.root)
                      throw new Je.ErrnoError(10);
                    if (!ae && !Ve) {
                      var gt = Je.lookupPath(z, { follow_mount: !1 });
                      if (z = gt.path, qe = gt.node, Je.isMountpoint(qe))
                        throw new Je.ErrnoError(10);
                      if (!Je.isDir(qe.mode))
                        throw new Je.ErrnoError(54);
                    }
                    var Wt = { type: I, opts: T, mountpoint: z, mounts: [] }, Rn = I.mount(Wt);
                    return Rn.mount = Wt, Wt.root = Rn, ae ? Je.root = Rn : qe && (qe.mounted = Wt, qe.mount && qe.mount.mounts.push(Wt)), Rn;
                  }, unmount(I) {
                    var T = Je.lookupPath(I, { follow_mount: !1 });
                    if (!Je.isMountpoint(T.node))
                      throw new Je.ErrnoError(28);
                    var z = T.node, ae = z.mounted, Ve = Je.getMounts(ae);
                    Object.keys(Je.nameTable).forEach((gt) => {
                      for (var Wt = Je.nameTable[gt]; Wt; ) {
                        var Rn = Wt.name_next;
                        Ve.includes(Wt.mount) && Je.destroyNode(Wt), Wt = Rn;
                      }
                    }), z.mounted = null;
                    var qe = z.mount.mounts.indexOf(ae);
                    z.mount.mounts.splice(qe, 1);
                  }, lookup(I, T) {
                    return I.node_ops.lookup(I, T);
                  }, mknod(I, T, z) {
                    var ae = Je.lookupPath(I, { parent: !0 }), Ve = ae.node, qe = da.basename(I);
                    if (!qe || qe === "." || qe === "..")
                      throw new Je.ErrnoError(28);
                    var gt = Je.mayCreate(Ve, qe);
                    if (gt)
                      throw new Je.ErrnoError(gt);
                    if (!Ve.node_ops.mknod)
                      throw new Je.ErrnoError(63);
                    return Ve.node_ops.mknod(Ve, qe, T, z);
                  }, create(I, T) {
                    return T = T !== void 0 ? T : 438, T &= 4095, T |= 32768, Je.mknod(I, T, 0);
                  }, mkdir(I, T) {
                    return T = T !== void 0 ? T : 511, T &= 1023, T |= 16384, Je.mknod(I, T, 0);
                  }, mkdirTree(I, T) {
                    for (var z = I.split("/"), ae = "", Ve = 0; Ve < z.length; ++Ve)
                      if (z[Ve]) {
                        ae += "/" + z[Ve];
                        try {
                          Je.mkdir(ae, T);
                        } catch (qe) {
                          if (qe.errno != 20) throw qe;
                        }
                      }
                  }, mkdev(I, T, z) {
                    return typeof z == "undefined" && (z = T, T = 438), T |= 8192, Je.mknod(I, T, z);
                  }, symlink(I, T) {
                    if (!cc.resolve(I))
                      throw new Je.ErrnoError(44);
                    var z = Je.lookupPath(T, { parent: !0 }), ae = z.node;
                    if (!ae)
                      throw new Je.ErrnoError(44);
                    var Ve = da.basename(T), qe = Je.mayCreate(ae, Ve);
                    if (qe)
                      throw new Je.ErrnoError(qe);
                    if (!ae.node_ops.symlink)
                      throw new Je.ErrnoError(63);
                    return ae.node_ops.symlink(ae, Ve, I);
                  }, rename(I, T) {
                    var z = da.dirname(I), ae = da.dirname(T), Ve = da.basename(I), qe = da.basename(T), gt, Wt, Rn;
                    if (gt = Je.lookupPath(I, { parent: !0 }), Wt = gt.node, gt = Je.lookupPath(T, { parent: !0 }), Rn = gt.node, !Wt || !Rn) throw new Je.ErrnoError(44);
                    if (Wt.mount !== Rn.mount)
                      throw new Je.ErrnoError(75);
                    var Ln = Je.lookupNode(Wt, Ve), Lr = cc.relative(I, ae);
                    if (Lr.charAt(0) !== ".")
                      throw new Je.ErrnoError(28);
                    if (Lr = cc.relative(T, z), Lr.charAt(0) !== ".")
                      throw new Je.ErrnoError(55);
                    var Oi;
                    try {
                      Oi = Je.lookupNode(Rn, qe);
                    } catch {
                    }
                    if (Ln !== Oi) {
                      var ii = Je.isDir(Ln.mode), gi = Je.mayDelete(Wt, Ve, ii);
                      if (gi)
                        throw new Je.ErrnoError(gi);
                      if (gi = Oi ? Je.mayDelete(Rn, qe, ii) : Je.mayCreate(Rn, qe), gi)
                        throw new Je.ErrnoError(gi);
                      if (!Wt.node_ops.rename)
                        throw new Je.ErrnoError(63);
                      if (Je.isMountpoint(Ln) || Oi && Je.isMountpoint(Oi))
                        throw new Je.ErrnoError(10);
                      if (Rn !== Wt && (gi = Je.nodePermissions(Wt, "w"), gi))
                        throw new Je.ErrnoError(gi);
                      Je.hashRemoveNode(Ln);
                      try {
                        Wt.node_ops.rename(Ln, Rn, qe);
                      } catch (Bo) {
                        throw Bo;
                      } finally {
                        Je.hashAddNode(Ln);
                      }
                    }
                  }, rmdir(I) {
                    var T = Je.lookupPath(I, { parent: !0 }), z = T.node, ae = da.basename(I), Ve = Je.lookupNode(z, ae), qe = Je.mayDelete(z, ae, !0);
                    if (qe)
                      throw new Je.ErrnoError(qe);
                    if (!z.node_ops.rmdir)
                      throw new Je.ErrnoError(63);
                    if (Je.isMountpoint(Ve))
                      throw new Je.ErrnoError(10);
                    z.node_ops.rmdir(z, ae), Je.destroyNode(Ve);
                  }, readdir(I) {
                    var T = Je.lookupPath(I, { follow: !0 }), z = T.node;
                    if (!z.node_ops.readdir)
                      throw new Je.ErrnoError(54);
                    return z.node_ops.readdir(z);
                  }, unlink(I) {
                    var T = Je.lookupPath(I, { parent: !0 }), z = T.node;
                    if (!z)
                      throw new Je.ErrnoError(44);
                    var ae = da.basename(I), Ve = Je.lookupNode(z, ae), qe = Je.mayDelete(z, ae, !1);
                    if (qe)
                      throw new Je.ErrnoError(qe);
                    if (!z.node_ops.unlink)
                      throw new Je.ErrnoError(63);
                    if (Je.isMountpoint(Ve))
                      throw new Je.ErrnoError(10);
                    z.node_ops.unlink(z, ae), Je.destroyNode(Ve);
                  }, readlink(I) {
                    var T = Je.lookupPath(I), z = T.node;
                    if (!z)
                      throw new Je.ErrnoError(44);
                    if (!z.node_ops.readlink)
                      throw new Je.ErrnoError(28);
                    return cc.resolve(Je.getPath(z.parent), z.node_ops.readlink(z));
                  }, stat(I, T) {
                    var z = Je.lookupPath(I, { follow: !T }), ae = z.node;
                    if (!ae)
                      throw new Je.ErrnoError(44);
                    if (!ae.node_ops.getattr)
                      throw new Je.ErrnoError(63);
                    return ae.node_ops.getattr(ae);
                  }, lstat(I) {
                    return Je.stat(I, !0);
                  }, chmod(I, T, z) {
                    var ae;
                    if (typeof I == "string") {
                      var Ve = Je.lookupPath(I, { follow: !z });
                      ae = Ve.node;
                    } else
                      ae = I;
                    if (!ae.node_ops.setattr)
                      throw new Je.ErrnoError(63);
                    ae.node_ops.setattr(ae, { mode: T & 4095 | ae.mode & -4096, timestamp: Date.now() });
                  }, lchmod(I, T) {
                    Je.chmod(I, T, !0);
                  }, fchmod(I, T) {
                    var z = Je.getStreamChecked(I);
                    Je.chmod(z.node, T);
                  }, chown(I, T, z, ae) {
                    var Ve;
                    if (typeof I == "string") {
                      var qe = Je.lookupPath(I, { follow: !ae });
                      Ve = qe.node;
                    } else
                      Ve = I;
                    if (!Ve.node_ops.setattr)
                      throw new Je.ErrnoError(63);
                    Ve.node_ops.setattr(Ve, { timestamp: Date.now() });
                  }, lchown(I, T, z) {
                    Je.chown(I, T, z, !0);
                  }, fchown(I, T, z) {
                    var ae = Je.getStreamChecked(I);
                    Je.chown(ae.node, T, z);
                  }, truncate(I, T) {
                    if (T < 0)
                      throw new Je.ErrnoError(28);
                    var z;
                    if (typeof I == "string") {
                      var ae = Je.lookupPath(I, { follow: !0 });
                      z = ae.node;
                    } else
                      z = I;
                    if (!z.node_ops.setattr)
                      throw new Je.ErrnoError(63);
                    if (Je.isDir(z.mode))
                      throw new Je.ErrnoError(31);
                    if (!Je.isFile(z.mode))
                      throw new Je.ErrnoError(28);
                    var Ve = Je.nodePermissions(z, "w");
                    if (Ve)
                      throw new Je.ErrnoError(Ve);
                    z.node_ops.setattr(z, { size: T, timestamp: Date.now() });
                  }, ftruncate(I, T) {
                    var z = Je.getStreamChecked(I);
                    if (!(z.flags & 2097155))
                      throw new Je.ErrnoError(28);
                    Je.truncate(z.node, T);
                  }, utime(I, T, z) {
                    var ae = Je.lookupPath(I, { follow: !0 }), Ve = ae.node;
                    Ve.node_ops.setattr(Ve, { timestamp: Math.max(T, z) });
                  }, open(I, T, z) {
                    if (I === "")
                      throw new Je.ErrnoError(44);
                    T = typeof T == "string" ? Md(T) : T, z = typeof z == "undefined" ? 438 : z, T & 64 ? z = z & 4095 | 32768 : z = 0;
                    var ae;
                    if (typeof I == "object")
                      ae = I;
                    else {
                      I = da.normalize(I);
                      try {
                        var Ve = Je.lookupPath(I, { follow: !(T & 131072) });
                        ae = Ve.node;
                      } catch {
                      }
                    }
                    var qe = !1;
                    if (T & 64)
                      if (ae) {
                        if (T & 128)
                          throw new Je.ErrnoError(20);
                      } else
                        ae = Je.mknod(I, z, 0), qe = !0;
                    if (!ae)
                      throw new Je.ErrnoError(44);
                    if (Je.isChrdev(ae.mode) && (T &= -513), T & 65536 && !Je.isDir(ae.mode))
                      throw new Je.ErrnoError(54);
                    if (!qe) {
                      var gt = Je.mayOpen(ae, T);
                      if (gt)
                        throw new Je.ErrnoError(gt);
                    }
                    T & 512 && !qe && Je.truncate(ae, 0), T &= -131713;
                    var Wt = Je.createStream({ node: ae, path: Je.getPath(ae), flags: T, seekable: !0, position: 0, stream_ops: ae.stream_ops, ungotten: [], error: !1 });
                    return Wt.stream_ops.open && Wt.stream_ops.open(Wt), re.logReadFiles && !(T & 1) && (Je.readFiles || (Je.readFiles = {}), I in Je.readFiles || (Je.readFiles[I] = 1)), Wt;
                  }, close(I) {
                    if (Je.isClosed(I))
                      throw new Je.ErrnoError(8);
                    I.getdents && (I.getdents = null);
                    try {
                      I.stream_ops.close && I.stream_ops.close(I);
                    } catch (T) {
                      throw T;
                    } finally {
                      Je.closeStream(I.fd);
                    }
                    I.fd = null;
                  }, isClosed(I) {
                    return I.fd === null;
                  }, llseek(I, T, z) {
                    if (Je.isClosed(I))
                      throw new Je.ErrnoError(8);
                    if (!I.seekable || !I.stream_ops.llseek)
                      throw new Je.ErrnoError(70);
                    if (z != 0 && z != 1 && z != 2)
                      throw new Je.ErrnoError(28);
                    return I.position = I.stream_ops.llseek(I, T, z), I.ungotten = [], I.position;
                  }, read(I, T, z, ae, Ve) {
                    if (ae < 0 || Ve < 0)
                      throw new Je.ErrnoError(28);
                    if (Je.isClosed(I))
                      throw new Je.ErrnoError(8);
                    if ((I.flags & 2097155) === 1)
                      throw new Je.ErrnoError(8);
                    if (Je.isDir(I.node.mode))
                      throw new Je.ErrnoError(31);
                    if (!I.stream_ops.read)
                      throw new Je.ErrnoError(28);
                    var qe = typeof Ve != "undefined";
                    if (!qe)
                      Ve = I.position;
                    else if (!I.seekable)
                      throw new Je.ErrnoError(70);
                    var gt = I.stream_ops.read(I, T, z, ae, Ve);
                    return qe || (I.position += gt), gt;
                  }, write(I, T, z, ae, Ve, qe) {
                    if (ae < 0 || Ve < 0)
                      throw new Je.ErrnoError(28);
                    if (Je.isClosed(I))
                      throw new Je.ErrnoError(8);
                    if (!(I.flags & 2097155))
                      throw new Je.ErrnoError(8);
                    if (Je.isDir(I.node.mode))
                      throw new Je.ErrnoError(31);
                    if (!I.stream_ops.write)
                      throw new Je.ErrnoError(28);
                    I.seekable && I.flags & 1024 && Je.llseek(I, 0, 2);
                    var gt = typeof Ve != "undefined";
                    if (!gt)
                      Ve = I.position;
                    else if (!I.seekable)
                      throw new Je.ErrnoError(70);
                    var Wt = I.stream_ops.write(I, T, z, ae, Ve, qe);
                    return gt || (I.position += Wt), Wt;
                  }, allocate(I, T, z) {
                    if (Je.isClosed(I))
                      throw new Je.ErrnoError(8);
                    if (T < 0 || z <= 0)
                      throw new Je.ErrnoError(28);
                    if (!(I.flags & 2097155))
                      throw new Je.ErrnoError(8);
                    if (!Je.isFile(I.node.mode) && !Je.isDir(I.node.mode))
                      throw new Je.ErrnoError(43);
                    if (!I.stream_ops.allocate)
                      throw new Je.ErrnoError(138);
                    I.stream_ops.allocate(I, T, z);
                  }, mmap(I, T, z, ae, Ve) {
                    if (ae & 2 && !(Ve & 2) && (I.flags & 2097155) !== 2)
                      throw new Je.ErrnoError(2);
                    if ((I.flags & 2097155) === 1)
                      throw new Je.ErrnoError(2);
                    if (!I.stream_ops.mmap)
                      throw new Je.ErrnoError(43);
                    return I.stream_ops.mmap(I, T, z, ae, Ve);
                  }, msync(I, T, z, ae, Ve) {
                    return I.stream_ops.msync ? I.stream_ops.msync(I, T, z, ae, Ve) : 0;
                  }, munmap: (I) => 0, ioctl(I, T, z) {
                    if (!I.stream_ops.ioctl)
                      throw new Je.ErrnoError(59);
                    return I.stream_ops.ioctl(I, T, z);
                  }, readFile(I, T) {
                    if (T === void 0 && (T = {}), T.flags = T.flags || 0, T.encoding = T.encoding || "binary", T.encoding !== "utf8" && T.encoding !== "binary")
                      throw new Error(`Invalid encoding type "${T.encoding}"`);
                    var z, ae = Je.open(I, T.flags), Ve = Je.stat(I), qe = Ve.size, gt = new Uint8Array(qe);
                    return Je.read(ae, gt, 0, qe, 0), T.encoding === "utf8" ? z = ea(gt, 0) : T.encoding === "binary" && (z = gt), Je.close(ae), z;
                  }, writeFile(I, T, z) {
                    z === void 0 && (z = {}), z.flags = z.flags || 577;
                    var ae = Je.open(I, z.flags, z.mode);
                    if (typeof T == "string") {
                      var Ve = new Uint8Array(Yc(T) + 1), qe = rd(T, Ve, 0, Ve.length);
                      Je.write(ae, Ve, 0, qe, void 0, z.canOwn);
                    } else if (ArrayBuffer.isView(T))
                      Je.write(ae, T, 0, T.byteLength, void 0, z.canOwn);
                    else
                      throw new Error("Unsupported data type");
                    Je.close(ae);
                  }, cwd: () => Je.currentPath, chdir(I) {
                    var T = Je.lookupPath(I, { follow: !0 });
                    if (T.node === null)
                      throw new Je.ErrnoError(44);
                    if (!Je.isDir(T.node.mode))
                      throw new Je.ErrnoError(54);
                    var z = Je.nodePermissions(T.node, "x");
                    if (z)
                      throw new Je.ErrnoError(z);
                    Je.currentPath = T.path;
                  }, createDefaultDirectories() {
                    Je.mkdir("/tmp"), Je.mkdir("/home"), Je.mkdir("/home/web_user");
                  }, createDefaultDevices() {
                    Je.mkdir("/dev"), Je.registerDevice(Je.makedev(1, 3), { read: () => 0, write: (ae, Ve, qe, gt, Wt) => gt }), Je.mkdev("/dev/null", Je.makedev(1, 3)), El.register(Je.makedev(5, 0), El.default_tty_ops), El.register(Je.makedev(6, 0), El.default_tty1_ops), Je.mkdev("/dev/tty", Je.makedev(5, 0)), Je.mkdev("/dev/tty1", Je.makedev(6, 0));
                    var I = new Uint8Array(1024), T = 0, z = () => (T === 0 && (T = la(I).byteLength), I[--T]);
                    Je.createDevice("/dev", "random", z), Je.createDevice("/dev", "urandom", z), Je.mkdir("/dev/shm"), Je.mkdir("/dev/shm/tmp");
                  }, createSpecialDirectories() {
                    Je.mkdir("/proc");
                    var I = Je.mkdir("/proc/self");
                    Je.mkdir("/proc/self/fd"), Je.mount({ mount() {
                      var T = Je.createNode(I, "fd", 16895, 73);
                      return T.node_ops = { lookup(z, ae) {
                        var Ve = +ae, qe = Je.getStreamChecked(Ve), gt = { parent: null, mount: { mountpoint: "fake" }, node_ops: { readlink: () => qe.path } };
                        return gt.parent = gt, gt;
                      } }, T;
                    } }, {}, "/proc/self/fd");
                  }, createStandardStreams() {
                    re.stdin ? Je.createDevice("/dev", "stdin", re.stdin) : Je.symlink("/dev/tty", "/dev/stdin"), re.stdout ? Je.createDevice("/dev", "stdout", null, re.stdout) : Je.symlink("/dev/tty", "/dev/stdout"), re.stderr ? Je.createDevice("/dev", "stderr", null, re.stderr) : Je.symlink("/dev/tty1", "/dev/stderr"), Je.open("/dev/stdin", 0), Je.open("/dev/stdout", 1), Je.open("/dev/stderr", 1);
                  }, ensureErrnoError() {
                    Je.ErrnoError || (Je.ErrnoError = function(T, z) {
                      this.name = "ErrnoError", this.node = z, this.setErrno = function(ae) {
                        this.errno = ae;
                      }, this.setErrno(T), this.message = "FS error";
                    }, Je.ErrnoError.prototype = new Error(), Je.ErrnoError.prototype.constructor = Je.ErrnoError, [44].forEach((I) => {
                      Je.genericErrors[I] = new Je.ErrnoError(I), Je.genericErrors[I].stack = "<generic error, no stack>";
                    }));
                  }, staticInit() {
                    Je.ensureErrnoError(), Je.nameTable = new Array(4096), Je.mount(vo, {}, "/"), Je.createDefaultDirectories(), Je.createDefaultDevices(), Je.createSpecialDirectories(), Je.filesystems = { MEMFS: vo };
                  }, init(I, T, z) {
                    Je.init.initialized = !0, Je.ensureErrnoError(), re.stdin = I || re.stdin, re.stdout = T || re.stdout, re.stderr = z || re.stderr, Je.createStandardStreams();
                  }, quit() {
                    Je.init.initialized = !1, kn(0);
                    for (var I = 0; I < Je.streams.length; I++) {
                      var T = Je.streams[I];
                      T && Je.close(T);
                    }
                  }, findObject(I, T) {
                    var z = Je.analyzePath(I, T);
                    return z.exists ? z.object : null;
                  }, analyzePath(I, T) {
                    try {
                      var z = Je.lookupPath(I, { follow: !T });
                      I = z.path;
                    } catch {
                    }
                    var ae = { isRoot: !1, exists: !1, error: 0, name: null, path: null, object: null, parentExists: !1, parentPath: null, parentObject: null };
                    try {
                      var z = Je.lookupPath(I, { parent: !0 });
                      ae.parentExists = !0, ae.parentPath = z.path, ae.parentObject = z.node, ae.name = da.basename(I), z = Je.lookupPath(I, { follow: !T }), ae.exists = !0, ae.path = z.path, ae.object = z.node, ae.name = z.node.name, ae.isRoot = z.path === "/";
                    } catch (Ve) {
                      ae.error = Ve.errno;
                    }
                    return ae;
                  }, createPath(I, T, z, ae) {
                    I = typeof I == "string" ? I : Je.getPath(I);
                    for (var Ve = T.split("/").reverse(); Ve.length; ) {
                      var qe = Ve.pop();
                      if (qe) {
                        var gt = da.join2(I, qe);
                        try {
                          Je.mkdir(gt);
                        } catch {
                        }
                        I = gt;
                      }
                    }
                    return gt;
                  }, createFile(I, T, z, ae, Ve) {
                    var qe = da.join2(typeof I == "string" ? I : Je.getPath(I), T), gt = od(ae, Ve);
                    return Je.create(qe, gt);
                  }, createDataFile(I, T, z, ae, Ve, qe) {
                    var gt = T;
                    I && (I = typeof I == "string" ? I : Je.getPath(I), gt = T ? da.join2(I, T) : I);
                    var Wt = od(ae, Ve), Rn = Je.create(gt, Wt);
                    if (z) {
                      if (typeof z == "string") {
                        for (var Ln = new Array(z.length), Lr = 0, Oi = z.length; Lr < Oi; ++Lr) Ln[Lr] = z.charCodeAt(Lr);
                        z = Ln;
                      }
                      Je.chmod(Rn, Wt | 146);
                      var ii = Je.open(Rn, 577);
                      Je.write(ii, z, 0, z.length, 0, qe), Je.close(ii), Je.chmod(Rn, Wt);
                    }
                  }, createDevice(I, T, z, ae) {
                    var Ve = da.join2(typeof I == "string" ? I : Je.getPath(I), T), qe = od(!!z, !!ae);
                    Je.createDevice.major || (Je.createDevice.major = 64);
                    var gt = Je.makedev(Je.createDevice.major++, 0);
                    return Je.registerDevice(gt, { open(Wt) {
                      Wt.seekable = !1;
                    }, close(Wt) {
                      ae && ae.buffer && ae.buffer.length && ae(10);
                    }, read(Wt, Rn, Ln, Lr, Oi) {
                      for (var ii = 0, gi = 0; gi < Lr; gi++) {
                        var Bo;
                        try {
                          Bo = z();
                        } catch {
                          throw new Je.ErrnoError(29);
                        }
                        if (Bo === void 0 && ii === 0)
                          throw new Je.ErrnoError(6);
                        if (Bo == null) break;
                        ii++, Rn[Ln + gi] = Bo;
                      }
                      return ii && (Wt.node.timestamp = Date.now()), ii;
                    }, write(Wt, Rn, Ln, Lr, Oi) {
                      for (var ii = 0; ii < Lr; ii++)
                        try {
                          ae(Rn[Ln + ii]);
                        } catch {
                          throw new Je.ErrnoError(29);
                        }
                      return Lr && (Wt.node.timestamp = Date.now()), ii;
                    } }), Je.mkdev(Ve, qe, gt);
                  }, forceLoadFile(I) {
                    if (I.isDevice || I.isFolder || I.link || I.contents) return !0;
                    if (typeof XMLHttpRequest != "undefined")
                      throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                    if (an)
                      try {
                        I.contents = Lc(an(I.url), !0), I.usedBytes = I.contents.length;
                      } catch {
                        throw new Je.ErrnoError(29);
                      }
                    else
                      throw new Error("Cannot load without read() or XMLHttpRequest.");
                  }, createLazyFile(I, T, z, ae, Ve) {
                    function qe() {
                      this.lengthKnown = !1, this.chunks = [];
                    }
                    if (qe.prototype.get = function(gi) {
                      if (!(gi > this.length - 1 || gi < 0)) {
                        var Bo = gi % this.chunkSize, Cs = gi / this.chunkSize | 0;
                        return this.getter(Cs)[Bo];
                      }
                    }, qe.prototype.setDataGetter = function(gi) {
                      this.getter = gi;
                    }, qe.prototype.cacheLength = function() {
                      var gi = new XMLHttpRequest();
                      if (gi.open("HEAD", z, !1), gi.send(null), !(gi.status >= 200 && gi.status < 300 || gi.status === 304)) throw new Error("Couldn't load " + z + ". Status: " + gi.status);
                      var Bo = Number(gi.getResponseHeader("Content-length")), Cs, Ns = (Cs = gi.getResponseHeader("Accept-Ranges")) && Cs === "bytes", cl = (Cs = gi.getResponseHeader("Content-Encoding")) && Cs === "gzip", Er = 1024 * 1024;
                      Ns || (Er = Bo);
                      var Si = (Us, ld) => {
                        if (Us > ld) throw new Error("invalid range (" + Us + ", " + ld + ") or no bytes requested!");
                        if (ld > Bo - 1) throw new Error("only " + Bo + " bytes available! programmer error!");
                        var Ul = new XMLHttpRequest();
                        if (Ul.open("GET", z, !1), Bo !== Er && Ul.setRequestHeader("Range", "bytes=" + Us + "-" + ld), Ul.responseType = "arraybuffer", Ul.overrideMimeType && Ul.overrideMimeType("text/plain; charset=x-user-defined"), Ul.send(null), !(Ul.status >= 200 && Ul.status < 300 || Ul.status === 304)) throw new Error("Couldn't load " + z + ". Status: " + Ul.status);
                        return Ul.response !== void 0 ? new Uint8Array(Ul.response || []) : Lc(Ul.responseText || "", !0);
                      }, Vl = this;
                      Vl.setDataGetter((Us) => {
                        var ld = Us * Er, Ul = (Us + 1) * Er - 1;
                        if (Ul = Math.min(Ul, Bo - 1), typeof Vl.chunks[Us] == "undefined" && (Vl.chunks[Us] = Si(ld, Ul)), typeof Vl.chunks[Us] == "undefined") throw new Error("doXHR failed!");
                        return Vl.chunks[Us];
                      }), (cl || !Bo) && (Er = Bo = 1, Bo = this.getter(0).length, Er = Bo, Fr("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = Bo, this._chunkSize = Er, this.lengthKnown = !0;
                    }, typeof XMLHttpRequest != "undefined") {
                      if (!pn) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                      var gt = new qe();
                      Object.defineProperties(gt, { length: { get: function() {
                        return this.lengthKnown || this.cacheLength(), this._length;
                      } }, chunkSize: { get: function() {
                        return this.lengthKnown || this.cacheLength(), this._chunkSize;
                      } } });
                      var Wt = { isDevice: !1, contents: gt };
                    } else
                      var Wt = { isDevice: !1, url: z };
                    var Rn = Je.createFile(I, T, Wt, ae, Ve);
                    Wt.contents ? Rn.contents = Wt.contents : Wt.url && (Rn.contents = null, Rn.url = Wt.url), Object.defineProperties(Rn, { usedBytes: { get: function() {
                      return this.contents.length;
                    } } });
                    var Ln = {}, Lr = Object.keys(Rn.stream_ops);
                    Lr.forEach((ii) => {
                      var gi = Rn.stream_ops[ii];
                      Ln[ii] = function() {
                        return Je.forceLoadFile(Rn), gi.apply(null, arguments);
                      };
                    });
                    function Oi(ii, gi, Bo, Cs, Ns) {
                      var cl = ii.node.contents;
                      if (Ns >= cl.length) return 0;
                      var Er = Math.min(cl.length - Ns, Cs);
                      if (cl.slice)
                        for (var Si = 0; Si < Er; Si++)
                          gi[Bo + Si] = cl[Ns + Si];
                      else
                        for (var Si = 0; Si < Er; Si++)
                          gi[Bo + Si] = cl.get(Ns + Si);
                      return Er;
                    }
                    return Ln.read = (ii, gi, Bo, Cs, Ns) => (Je.forceLoadFile(Rn), Oi(ii, gi, Bo, Cs, Ns)), Ln.mmap = (ii, gi, Bo, Cs, Ns) => {
                      Je.forceLoadFile(Rn);
                      var cl = _d(gi);
                      if (!cl)
                        throw new Je.ErrnoError(48);
                      return Oi(ii, Pi, cl, gi, Bo), { ptr: cl, allocated: !0 };
                    }, Rn.stream_ops = Ln, Rn;
                  } }, Ne = (I, T) => I ? ea(wa, I, T) : "", qr = { DEFAULT_POLLMASK: 5, calculateAt(I, T, z) {
                    if (da.isAbs(T))
                      return T;
                    var ae;
                    if (I === -100)
                      ae = Je.cwd();
                    else {
                      var Ve = qr.getStreamFromFD(I);
                      ae = Ve.path;
                    }
                    if (T.length == 0) {
                      if (!z)
                        throw new Je.ErrnoError(44);
                      return ae;
                    }
                    return da.join2(ae, T);
                  }, doStat(I, T, z) {
                    try {
                      var ae = I(T);
                    } catch (Wt) {
                      if (Wt && Wt.node && da.normalize(T) !== da.normalize(Je.getPath(Wt.node)))
                        return -54;
                      throw Wt;
                    }
                    Ti[z >> 2] = ae.dev, Ti[z + 4 >> 2] = ae.mode, Di[z + 8 >> 2] = ae.nlink, Ti[z + 12 >> 2] = ae.uid, Ti[z + 16 >> 2] = ae.gid, Ti[z + 20 >> 2] = ae.rdev, ja = [ae.size >>> 0, (Uo = ae.size, +Math.abs(Uo) >= 1 ? Uo > 0 ? +Math.floor(Uo / 4294967296) >>> 0 : ~~+Math.ceil((Uo - +(~~Uo >>> 0)) / 4294967296) >>> 0 : 0)], Ti[z + 24 >> 2] = ja[0], Ti[z + 28 >> 2] = ja[1], Ti[z + 32 >> 2] = 4096, Ti[z + 36 >> 2] = ae.blocks;
                    var Ve = ae.atime.getTime(), qe = ae.mtime.getTime(), gt = ae.ctime.getTime();
                    return ja = [Math.floor(Ve / 1e3) >>> 0, (Uo = Math.floor(Ve / 1e3), +Math.abs(Uo) >= 1 ? Uo > 0 ? +Math.floor(Uo / 4294967296) >>> 0 : ~~+Math.ceil((Uo - +(~~Uo >>> 0)) / 4294967296) >>> 0 : 0)], Ti[z + 40 >> 2] = ja[0], Ti[z + 44 >> 2] = ja[1], Di[z + 48 >> 2] = Ve % 1e3 * 1e3, ja = [Math.floor(qe / 1e3) >>> 0, (Uo = Math.floor(qe / 1e3), +Math.abs(Uo) >= 1 ? Uo > 0 ? +Math.floor(Uo / 4294967296) >>> 0 : ~~+Math.ceil((Uo - +(~~Uo >>> 0)) / 4294967296) >>> 0 : 0)], Ti[z + 56 >> 2] = ja[0], Ti[z + 60 >> 2] = ja[1], Di[z + 64 >> 2] = qe % 1e3 * 1e3, ja = [Math.floor(gt / 1e3) >>> 0, (Uo = Math.floor(gt / 1e3), +Math.abs(Uo) >= 1 ? Uo > 0 ? +Math.floor(Uo / 4294967296) >>> 0 : ~~+Math.ceil((Uo - +(~~Uo >>> 0)) / 4294967296) >>> 0 : 0)], Ti[z + 72 >> 2] = ja[0], Ti[z + 76 >> 2] = ja[1], Di[z + 80 >> 2] = gt % 1e3 * 1e3, ja = [ae.ino >>> 0, (Uo = ae.ino, +Math.abs(Uo) >= 1 ? Uo > 0 ? +Math.floor(Uo / 4294967296) >>> 0 : ~~+Math.ceil((Uo - +(~~Uo >>> 0)) / 4294967296) >>> 0 : 0)], Ti[z + 88 >> 2] = ja[0], Ti[z + 92 >> 2] = ja[1], 0;
                  }, doMsync(I, T, z, ae, Ve) {
                    if (!Je.isFile(T.node.mode))
                      throw new Je.ErrnoError(43);
                    if (ae & 2)
                      return 0;
                    var qe = wa.slice(I, I + z);
                    Je.msync(T, qe, Ve, z, ae);
                  }, varargs: void 0, get() {
                    var I = Ti[+qr.varargs >> 2];
                    return qr.varargs += 4, I;
                  }, getp() {
                    return qr.get();
                  }, getStr(I) {
                    var T = Ne(I);
                    return T;
                  }, getStreamFromFD(I) {
                    var T = Je.getStreamChecked(I);
                    return T;
                  } }, dc = (I) => {
                    var T = io(), z = I();
                    return uo(T), z;
                  }, sl = (I, T) => T + 2097152 >>> 0 < 4194305 - !!I ? (I >>> 0) + T * 4294967296 : NaN, Ta = function(T, z) {
                    var ae = arguments.length - 2, Ve = arguments;
                    return dc(() => {
                      for (var qe = ae, gt = yr(qe * 8), Wt = gt >> 3, Rn = 0; Rn < ae; Rn++) {
                        var Ln = Ve[2 + Rn];
                        _l[Wt + Rn] = Ln;
                      }
                      return _n(T, qe, gt, z);
                    });
                  };
                  function $d(I) {
                    if (vt) return Ta(0, 1, I);
                    Dl = I, _s() || (no.terminateAllThreads(), re.onExit && re.onExit(I), aa = !0), ct(I, new td(I));
                  }
                  var Id = (I, T) => {
                    if (Dl = I, vt)
                      throw Yd(I), "unwind";
                    _s() || Dc(), $d(I);
                  }, $s = Id, _a = (I) => {
                    if (I instanceof td || I == "unwind")
                      return Dl;
                    ct(1, I);
                  }, no = { unusedWorkers: [], runningWorkers: [], tlsInitFunctions: [], pthreads: {}, init() {
                    vt ? no.initWorker() : no.initMainThread();
                  }, initMainThread() {
                    for (var I = 4; I--; )
                      no.allocateUnusedWorker();
                    ed(() => {
                      Sc(), no.loadWasmModuleToAllWorkers(() => Cl());
                    });
                  }, initWorker() {
                    $t = !1;
                  }, setExitStatus: (I) => {
                    Dl = I;
                  }, terminateAllThreads__deps: ["$terminateWorker"], terminateAllThreads: () => {
                    for (var I = f(no.runningWorkers), T; !(T = I()).done; ) {
                      var z = T.value;
                      Ud(z);
                    }
                    for (var ae = f(no.unusedWorkers), Ve; !(Ve = ae()).done; ) {
                      var z = Ve.value;
                      Ud(z);
                    }
                    no.unusedWorkers = [], no.runningWorkers = [], no.pthreads = [];
                  }, returnWorkerToPool: (I) => {
                    var T = I.pthread_ptr;
                    delete no.pthreads[T], no.unusedWorkers.push(I), no.runningWorkers.splice(no.runningWorkers.indexOf(I), 1), I.pthread_ptr = 0, $r(T);
                  }, receiveObjectTransfer(I) {
                  }, threadInitTLS() {
                    no.tlsInitFunctions.forEach((I) => I());
                  }, loadWasmModuleToWorker: (I) => new n((T) => {
                    I.onmessage = (Wt) => {
                      var Rn = Wt.data, Ln = Rn.cmd;
                      if (Rn.targetThread && Rn.targetThread != V()) {
                        var Lr = no.pthreads[Rn.targetThread];
                        Lr ? Lr.postMessage(Rn, Rn.transferList) : Ro(`Internal error! Worker sent a message "${Ln}" to target pthread ${Rn.targetThread}, but that thread no longer exists!`);
                        return;
                      }
                      Ln === "checkMailbox" ? ku() : Ln === "spawnThread" ? lc(Rn) : Ln === "cleanupThread" ? nd(Rn.thread) : Ln === "killThread" ? fl(Rn.thread) : Ln === "cancelThread" ? ou(Rn.thread) : Ln === "loaded" ? (I.loaded = !0, T(I)) : Ln === "alert" ? alert(`Thread ${Rn.threadId}: ${Rn.text}`) : Rn.target === "setimmediate" ? I.postMessage(Rn) : Ln === "callHandler" ? re[Rn.handler](...Rn.args) : Ln && Ro(`worker sent an unknown command ${Ln}`);
                    }, I.onerror = (Wt) => {
                      var Rn = "worker sent an error!";
                      throw Ro(`${Rn} ${Wt.filename}:${Wt.lineno}: ${Wt.message}`), Wt;
                    };
                    for (var z = [], ae = ["onExit", "onAbort", "print", "printErr"], Ve = 0, qe = ae; Ve < qe.length; Ve++) {
                      var gt = qe[Ve];
                      re.hasOwnProperty(gt) && z.push(gt);
                    }
                    I.postMessage({ cmd: "load", handlers: z, urlOrBlob: re.mainScriptUrlOrBlob, wasmMemory: Co, wasmModule: ga });
                  }), loadWasmModuleToAllWorkers(I) {
                    if (vt)
                      return I();
                    n.all(no.unusedWorkers.map(no.loadWasmModuleToWorker)).then(I);
                  }, allocateUnusedWorker() {
                    var I;
                    if (!re.locateFile)
                      I = new Worker(new URL("main-bin-multi.worker.js", location.href), { type: "module" });
                    else {
                      var T = sr("main-bin-multi.worker.js");
                      I = new Worker(T, { type: "module" });
                    }
                    no.unusedWorkers.push(I);
                  }, getNewWorker() {
                    return no.unusedWorkers.length == 0 && (no.allocateUnusedWorker(), no.loadWasmModuleToWorker(no.unusedWorkers[0])), no.unusedWorkers.pop();
                  } };
                  re.PThread = no;
                  var Bd = (I) => {
                    for (; I.length > 0; )
                      I.shift()(re);
                  }, xl = () => {
                    var I = V(), T = Di[I + 52 >> 2], z = Di[I + 56 >> 2], ae = T - z;
                    as(T, ae), uo(T);
                  };
                  re.establishStackSpace = xl;
                  function Yd(I) {
                    if (vt) return Ta(1, 0, I);
                    $s(I);
                  }
                  var nt = [], Ke, et = (I) => {
                    var T = nt[I];
                    return T || (I >= nt.length && (nt.length = I + 1), nt[I] = T = Ke.get(I)), T;
                  }, dt = (I, T) => {
                    Vc = 0;
                    var z = et(I)(T);
                    function ae(Ve) {
                      _s() ? no.setExitStatus(Ve) : Mi(Ve);
                    }
                    ae(z);
                  };
                  re.invokeEntryPoint = dt;
                  var $t = re.noExitRuntime || !1, be = (I) => {
                    no.tlsInitFunctions.push(I);
                  }, ze = (I, T, z, ae) => {
                    _r(`Assertion failed: ${Ne(I)}, at: ` + [T ? Ne(T) : "unknown filename", z, ae ? Ne(ae) : "unknown function"]);
                  }, P = [], te = (I) => {
                    var T = new yt(I);
                    return T.get_caught() || T.set_caught(!0), T.set_rethrown(!1), P.push(T), Ni(T.excPtr), T.get_exception_ptr();
                  }, Re = 0, Qe = () => {
                    Dr(0, 0);
                    var I = P.pop();
                    bi(I.excPtr), Re = 0;
                  };
                  function yt(I) {
                    this.excPtr = I, this.ptr = I - 24, this.set_type = function(T) {
                      Di[this.ptr + 4 >> 2] = T;
                    }, this.get_type = function() {
                      return Di[this.ptr + 4 >> 2];
                    }, this.set_destructor = function(T) {
                      Di[this.ptr + 8 >> 2] = T;
                    }, this.get_destructor = function() {
                      return Di[this.ptr + 8 >> 2];
                    }, this.set_caught = function(T) {
                      T = T ? 1 : 0, Pi[this.ptr + 12 >> 0] = T;
                    }, this.get_caught = function() {
                      return Pi[this.ptr + 12 >> 0] != 0;
                    }, this.set_rethrown = function(T) {
                      T = T ? 1 : 0, Pi[this.ptr + 13 >> 0] = T;
                    }, this.get_rethrown = function() {
                      return Pi[this.ptr + 13 >> 0] != 0;
                    }, this.init = function(T, z) {
                      this.set_adjusted_ptr(0), this.set_type(T), this.set_destructor(z);
                    }, this.set_adjusted_ptr = function(T) {
                      Di[this.ptr + 16 >> 2] = T;
                    }, this.get_adjusted_ptr = function() {
                      return Di[this.ptr + 16 >> 2];
                    }, this.get_exception_ptr = function() {
                      var T = Qc(this.get_type());
                      if (T)
                        return Di[this.excPtr >> 2];
                      var z = this.get_adjusted_ptr();
                      return z !== 0 ? z : this.excPtr;
                    };
                  }
                  var Ht = (I) => {
                    throw Re || (Re = I), Re;
                  }, zt = (I) => {
                    var T = Re;
                    if (!T)
                      return ro(0), 0;
                    var z = new yt(T);
                    z.set_adjusted_ptr(T);
                    var ae = z.get_type();
                    if (!ae)
                      return ro(0), T;
                    for (var Ve in I) {
                      var qe = I[Ve];
                      if (qe === 0 || qe === ae)
                        break;
                      var gt = z.ptr + 16;
                      if (es(qe, ae, gt))
                        return ro(qe), T;
                    }
                    return ro(ae), T;
                  }, rn = () => zt([]), tr = (I) => zt([I]), Vn = () => {
                    var I = P.pop();
                    I || _r("no exception to throw");
                    var T = I.excPtr;
                    throw I.get_rethrown() || (P.push(I), I.set_rethrown(!0), I.set_caught(!1)), Re = T, Re;
                  }, si = (I, T, z) => {
                    var ae = new yt(I);
                    throw ae.init(T, z), Re = I, Re;
                  }, ai = (I) => {
                    Dt(I, !pn, 1, !Xt, 65536, !1), no.threadInitTLS();
                  }, Ui = (I) => {
                    vt ? postMessage({ cmd: "cleanupThread", thread: I }) : nd(I);
                  };
                  function Sa(I, T, z, ae) {
                    return vt ? Ta(2, 1, I, T, z, ae) : xa(I, T, z, ae);
                  }
                  var xa = (I, T, z, ae) => {
                    if (typeof SharedArrayBuffer == "undefined")
                      return Ro("Current environment does not support SharedArrayBuffer, pthreads are not available!"), 6;
                    var Ve = [], qe = 0;
                    if (vt && (Ve.length === 0 || qe))
                      return Sa(I, T, z, ae);
                    var gt = { startRoutine: z, pthread_ptr: I, arg: ae, transferList: Ve };
                    return vt ? (gt.cmd = "spawnThread", postMessage(gt, Ve), 0) : lc(gt);
                  }, ll = (I) => (Ti[ue() >> 2] = I, I);
                  function Hc(I, T, z) {
                    if (vt) return Ta(3, 1, I, T, z);
                    qr.varargs = z;
                    try {
                      var ae = qr.getStreamFromFD(I);
                      switch (T) {
                        case 0: {
                          var Ve = qr.get();
                          if (Ve < 0)
                            return -28;
                          for (; Je.streams[Ve]; )
                            Ve++;
                          var qe;
                          return qe = Je.createStream(ae, Ve), qe.fd;
                        }
                        case 1:
                        case 2:
                          return 0;
                        case 3:
                          return ae.flags;
                        case 4: {
                          var Ve = qr.get();
                          return ae.flags |= Ve, 0;
                        }
                        case 5: {
                          var Ve = qr.getp(), gt = 0;
                          return yl[Ve + gt >> 1] = 2, 0;
                        }
                        case 6:
                        case 7:
                          return 0;
                        case 16:
                        case 8:
                          return -28;
                        case 9:
                          return ll(28), -1;
                        default:
                          return -28;
                      }
                    } catch (Wt) {
                      if (typeof Je == "undefined" || Wt.name !== "ErrnoError") throw Wt;
                      return -Wt.errno;
                    }
                  }
                  function Wc(I, T) {
                    if (vt) return Ta(4, 1, I, T);
                    try {
                      var z = qr.getStreamFromFD(I);
                      return qr.doStat(Je.stat, z.path, T);
                    } catch (ae) {
                      if (typeof Je == "undefined" || ae.name !== "ErrnoError") throw ae;
                      return -ae.errno;
                    }
                  }
                  function Zd(I, T, z) {
                    if (vt) return Ta(5, 1, I, T, z);
                    var ae = sl(T, z);
                    try {
                      return isNaN(ae) ? 61 : (Je.ftruncate(I, ae), 0);
                    } catch (Ve) {
                      if (typeof Je == "undefined" || Ve.name !== "ErrnoError") throw Ve;
                      return -Ve.errno;
                    }
                  }
                  function Sd(I, T, z) {
                    if (vt) return Ta(6, 1, I, T, z);
                    qr.varargs = z;
                    try {
                      var ae = qr.getStreamFromFD(I);
                      switch (T) {
                        case 21509:
                          return ae.tty ? 0 : -59;
                        case 21505: {
                          if (!ae.tty) return -59;
                          if (ae.tty.ops.ioctl_tcgets) {
                            var Ve = ae.tty.ops.ioctl_tcgets(ae), qe = qr.getp();
                            Ti[qe >> 2] = Ve.c_iflag || 0, Ti[qe + 4 >> 2] = Ve.c_oflag || 0, Ti[qe + 8 >> 2] = Ve.c_cflag || 0, Ti[qe + 12 >> 2] = Ve.c_lflag || 0;
                            for (var gt = 0; gt < 32; gt++)
                              Pi[qe + gt + 17 >> 0] = Ve.c_cc[gt] || 0;
                            return 0;
                          }
                          return 0;
                        }
                        case 21510:
                        case 21511:
                        case 21512:
                          return ae.tty ? 0 : -59;
                        case 21506:
                        case 21507:
                        case 21508: {
                          if (!ae.tty) return -59;
                          if (ae.tty.ops.ioctl_tcsets) {
                            for (var qe = qr.getp(), Wt = Ti[qe >> 2], Rn = Ti[qe + 4 >> 2], Ln = Ti[qe + 8 >> 2], Lr = Ti[qe + 12 >> 2], Oi = [], gt = 0; gt < 32; gt++)
                              Oi.push(Pi[qe + gt + 17 >> 0]);
                            return ae.tty.ops.ioctl_tcsets(ae.tty, T, { c_iflag: Wt, c_oflag: Rn, c_cflag: Ln, c_lflag: Lr, c_cc: Oi });
                          }
                          return 0;
                        }
                        case 21519: {
                          if (!ae.tty) return -59;
                          var qe = qr.getp();
                          return Ti[qe >> 2] = 0, 0;
                        }
                        case 21520:
                          return ae.tty ? -28 : -59;
                        case 21531: {
                          var qe = qr.getp();
                          return Je.ioctl(ae, T, qe);
                        }
                        case 21523: {
                          if (!ae.tty) return -59;
                          if (ae.tty.ops.ioctl_tiocgwinsz) {
                            var ii = ae.tty.ops.ioctl_tiocgwinsz(ae.tty), qe = qr.getp();
                            yl[qe >> 1] = ii[0], yl[qe + 2 >> 1] = ii[1];
                          }
                          return 0;
                        }
                        case 21524:
                          return ae.tty ? 0 : -59;
                        case 21515:
                          return ae.tty ? 0 : -59;
                        default:
                          return -28;
                      }
                    } catch (gi) {
                      if (typeof Je == "undefined" || gi.name !== "ErrnoError") throw gi;
                      return -gi.errno;
                    }
                  }
                  function lu(I, T) {
                    if (vt) return Ta(7, 1, I, T);
                    try {
                      return I = qr.getStr(I), qr.doStat(Je.lstat, I, T);
                    } catch (z) {
                      if (typeof Je == "undefined" || z.name !== "ErrnoError") throw z;
                      return -z.errno;
                    }
                  }
                  function Zu(I, T, z, ae) {
                    if (vt) return Ta(8, 1, I, T, z, ae);
                    try {
                      T = qr.getStr(T);
                      var Ve = ae & 256, qe = ae & 4096;
                      return ae = ae & -6401, T = qr.calculateAt(I, T, qe), qr.doStat(Ve ? Je.lstat : Je.stat, T, z);
                    } catch (gt) {
                      if (typeof Je == "undefined" || gt.name !== "ErrnoError") throw gt;
                      return -gt.errno;
                    }
                  }
                  function Su(I, T, z, ae) {
                    if (vt) return Ta(9, 1, I, T, z, ae);
                    qr.varargs = ae;
                    try {
                      T = qr.getStr(T), T = qr.calculateAt(I, T);
                      var Ve = ae ? qr.get() : 0;
                      return Je.open(T, z, Ve).fd;
                    } catch (qe) {
                      if (typeof Je == "undefined" || qe.name !== "ErrnoError") throw qe;
                      return -qe.errno;
                    }
                  }
                  var qd = (I, T, z) => rd(I, wa, T, z);
                  function rA(I, T, z, ae) {
                    if (vt) return Ta(10, 1, I, T, z, ae);
                    try {
                      if (T = qr.getStr(T), T = qr.calculateAt(I, T), ae <= 0) return -28;
                      var Ve = Je.readlink(T), qe = Math.min(ae, Yc(Ve)), gt = Pi[z + qe];
                      return qd(Ve, z, ae + 1), Pi[z + qe] = gt, qe;
                    } catch (Wt) {
                      if (typeof Je == "undefined" || Wt.name !== "ErrnoError") throw Wt;
                      return -Wt.errno;
                    }
                  }
                  function iA(I, T, z, ae) {
                    if (vt) return Ta(11, 1, I, T, z, ae);
                    try {
                      return T = qr.getStr(T), ae = qr.getStr(ae), T = qr.calculateAt(I, T), ae = qr.calculateAt(z, ae), Je.rename(T, ae), 0;
                    } catch (Ve) {
                      if (typeof Je == "undefined" || Ve.name !== "ErrnoError") throw Ve;
                      return -Ve.errno;
                    }
                  }
                  function Ku(I, T) {
                    if (vt) return Ta(12, 1, I, T);
                    try {
                      return I = qr.getStr(I), qr.doStat(Je.stat, I, T);
                    } catch (z) {
                      if (typeof Je == "undefined" || z.name !== "ErrnoError") throw z;
                      return -z.errno;
                    }
                  }
                  function oA(I, T, z) {
                    if (vt) return Ta(13, 1, I, T, z);
                    try {
                      return T = qr.getStr(T), T = qr.calculateAt(I, T), z === 0 ? Je.unlink(T) : z === 512 ? Je.rmdir(T) : _r("Invalid flags passed to unlinkat"), 0;
                    } catch (ae) {
                      if (typeof Je == "undefined" || ae.name !== "ErrnoError") throw ae;
                      return -ae.errno;
                    }
                  }
                  var zu = (I, T, z, ae, Ve) => {
                  }, ig = () => {
                    for (var I = new Array(256), T = 0; T < 256; ++T)
                      I[T] = String.fromCharCode(T);
                    ju = I;
                  }, ju, Rc = (I) => {
                    for (var T = "", z = I; wa[z]; )
                      T += ju[wa[z++]];
                    return T;
                  }, pu = {}, mu = {}, y0 = {}, Eu, Ha = (I) => {
                    throw new Eu(I);
                  }, aA, Vu = (I) => {
                    throw new aA(I);
                  }, _u = (I, T, z) => {
                    I.forEach(function(Wt) {
                      y0[Wt] = T;
                    });
                    function ae(Wt) {
                      var Rn = z(Wt);
                      Rn.length !== I.length && Vu("Mismatched type converter count");
                      for (var Ln = 0; Ln < I.length; ++Ln)
                        eu(I[Ln], Rn[Ln]);
                    }
                    var Ve = new Array(T.length), qe = [], gt = 0;
                    T.forEach((Wt, Rn) => {
                      mu.hasOwnProperty(Wt) ? Ve[Rn] = mu[Wt] : (qe.push(Wt), pu.hasOwnProperty(Wt) || (pu[Wt] = []), pu[Wt].push(() => {
                        Ve[Rn] = mu[Wt], ++gt, gt === qe.length && ae(Ve);
                      }));
                    }), qe.length === 0 && ae(Ve);
                  };
                  function og(I, T, z) {
                    z === void 0 && (z = {});
                    var ae = T.name;
                    if (I || Ha(`type "${ae}" must have a positive integer typeid pointer`), mu.hasOwnProperty(I)) {
                      if (z.ignoreDuplicateRegistrations)
                        return;
                      Ha(`Cannot register type '${ae}' twice`);
                    }
                    if (mu[I] = T, delete y0[I], pu.hasOwnProperty(I)) {
                      var Ve = pu[I];
                      delete pu[I], Ve.forEach((qe) => qe());
                    }
                  }
                  function eu(I, T, z) {
                    if (z === void 0 && (z = {}), !("argPackAdvance" in T))
                      throw new TypeError("registerType registeredInstance requires argPackAdvance");
                    return og(I, T, z);
                  }
                  var tu = 8, ag = (I, T, z, ae) => {
                    T = Rc(T), eu(I, { name: T, fromWireType: function(qe) {
                      return !!qe;
                    }, toWireType: function(qe, gt) {
                      return gt ? z : ae;
                    }, argPackAdvance: tu, readValueFromPointer: function(qe) {
                      return this.fromWireType(wa[qe]);
                    }, destructorFunction: null });
                  }, Q0 = (I) => ({ count: I.count, deleteScheduled: I.deleteScheduled, preservePointerOnDelete: I.preservePointerOnDelete, ptr: I.ptr, ptrType: I.ptrType, smartPtr: I.smartPtr, smartPtrType: I.smartPtrType }), lh = (I) => {
                    function T(z) {
                      return z.$$.ptrType.registeredClass.name;
                    }
                    Ha(T(I) + " instance already deleted");
                  }, ch = !1, $u = (I) => {
                  }, C0 = (I) => {
                    I.smartPtr ? I.smartPtrType.rawDestructor(I.smartPtr) : I.ptrType.registeredClass.rawDestructor(I.ptr);
                  }, Es = (I) => {
                    I.count.value -= 1;
                    var T = I.count.value === 0;
                    T && C0(I);
                  }, sA = (I, T, z) => {
                    if (T === z)
                      return I;
                    if (z.baseClass === void 0)
                      return null;
                    var ae = sA(I, T, z.baseClass);
                    return ae === null ? null : z.downcast(ae);
                  }, lA = {}, Wu = () => Object.keys(qu).length, sg = () => {
                    var I = [];
                    for (var T in qu)
                      qu.hasOwnProperty(T) && I.push(qu[T]);
                    return I;
                  }, Nu = [], U0 = () => {
                    for (; Nu.length; ) {
                      var I = Nu.pop();
                      I.$$.deleteScheduled = !1, I.delete();
                    }
                  }, vu, lg = (I) => {
                    vu = I, Nu.length && vu && vu(U0);
                  }, cA = () => {
                    re.getInheritedInstanceCount = Wu, re.getLiveInheritedInstances = sg, re.flushPendingDeletes = U0, re.setDelayFunction = lg;
                  }, qu = {}, cg = (I, T) => {
                    for (T === void 0 && Ha("ptr should not be undefined"); I.baseClass; )
                      T = I.upcast(T), I = I.baseClass;
                    return T;
                  }, dA = (I, T) => (T = cg(I, T), qu[T]), I0 = (I, T) => {
                    (!T.ptrType || !T.ptr) && Vu("makeClassHandle requires ptr and ptrType");
                    var z = !!T.smartPtrType, ae = !!T.smartPtr;
                    return z !== ae && Vu("Both smartPtrType and smartPtr must be specified"), T.count = { value: 1 }, e0(Object.create(I, { $$: { value: T } }));
                  };
                  function dg(I) {
                    var T = this.getPointee(I);
                    if (!T)
                      return this.destructor(I), null;
                    var z = dA(this.registeredClass, T);
                    if (z !== void 0) {
                      if (z.$$.count.value === 0)
                        return z.$$.ptr = T, z.$$.smartPtr = I, z.clone();
                      var ae = z.clone();
                      return this.destructor(I), ae;
                    }
                    function Ve() {
                      return this.isSmartPointer ? I0(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: T, smartPtrType: this, smartPtr: I }) : I0(this.registeredClass.instancePrototype, { ptrType: this, ptr: I });
                    }
                    var qe = this.registeredClass.getActualType(T), gt = lA[qe];
                    if (!gt)
                      return Ve.call(this);
                    var Wt;
                    this.isConst ? Wt = gt.constPointerType : Wt = gt.pointerType;
                    var Rn = sA(T, this.registeredClass, Wt.registeredClass);
                    return Rn === null ? Ve.call(this) : this.isSmartPointer ? I0(Wt.registeredClass.instancePrototype, { ptrType: Wt, ptr: Rn, smartPtrType: this, smartPtr: I }) : I0(Wt.registeredClass.instancePrototype, { ptrType: Wt, ptr: Rn });
                  }
                  var e0 = (I) => typeof FinalizationRegistry == "undefined" ? (e0 = (T) => T, I) : (ch = new FinalizationRegistry((T) => {
                    Es(T.$$);
                  }), e0 = (T) => {
                    var z = T.$$, ae = !!z.smartPtr;
                    if (ae) {
                      var Ve = { $$: z };
                      ch.register(T, Ve, T);
                    }
                    return T;
                  }, $u = (T) => ch.unregister(T), e0(I)), ug = () => {
                    Object.assign(t0.prototype, { isAliasOf(I) {
                      if (!(this instanceof t0) || !(I instanceof t0))
                        return !1;
                      var T = this.$$.ptrType.registeredClass, z = this.$$.ptr;
                      I.$$ = I.$$;
                      for (var ae = I.$$.ptrType.registeredClass, Ve = I.$$.ptr; T.baseClass; )
                        z = T.upcast(z), T = T.baseClass;
                      for (; ae.baseClass; )
                        Ve = ae.upcast(Ve), ae = ae.baseClass;
                      return T === ae && z === Ve;
                    }, clone() {
                      if (this.$$.ptr || lh(this), this.$$.preservePointerOnDelete)
                        return this.$$.count.value += 1, this;
                      var I = e0(Object.create(Object.getPrototypeOf(this), { $$: { value: Q0(this.$$) } }));
                      return I.$$.count.value += 1, I.$$.deleteScheduled = !1, I;
                    }, delete() {
                      this.$$.ptr || lh(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Ha("Object already scheduled for deletion"), $u(this), Es(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
                    }, isDeleted() {
                      return !this.$$.ptr;
                    }, deleteLater() {
                      return this.$$.ptr || lh(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && Ha("Object already scheduled for deletion"), Nu.push(this), Nu.length === 1 && vu && vu(U0), this.$$.deleteScheduled = !0, this;
                    } });
                  };
                  function t0() {
                  }
                  var yc = (I, T) => Object.defineProperty(T, "name", { value: I }), dh = (I, T, z) => {
                    if (I[T].overloadTable === void 0) {
                      var ae = I[T];
                      I[T] = function() {
                        return I[T].overloadTable.hasOwnProperty(arguments.length) || Ha(`Function '${z}' called with an invalid number of arguments (${arguments.length}) - expects one of (${I[T].overloadTable})!`), I[T].overloadTable[arguments.length].apply(this, arguments);
                      }, I[T].overloadTable = [], I[T].overloadTable[ae.argCount] = ae;
                    }
                  }, hg = (I, T, z) => {
                    re.hasOwnProperty(I) ? (Ha(`Cannot register public name '${I}' twice`), dh(re, I, I), re.hasOwnProperty(z) && Ha(`Cannot register multiple overloads of a function with the same number of arguments (${z})!`), re[I].overloadTable[z] = T) : re[I] = T;
                  }, Ag = 48, B0 = 57, uA = (I) => {
                    if (I === void 0)
                      return "_unknown";
                    I = I.replace(/[^a-zA-Z0-9_]/g, "$");
                    var T = I.charCodeAt(0);
                    return T >= Ag && T <= B0 ? `_${I}` : I;
                  };
                  function gg(I, T, z, ae, Ve, qe, gt, Wt) {
                    this.name = I, this.constructor = T, this.instancePrototype = z, this.rawDestructor = ae, this.baseClass = Ve, this.getActualType = qe, this.upcast = gt, this.downcast = Wt, this.pureVirtualFunctions = [];
                  }
                  var n0 = (I, T, z) => {
                    for (; T !== z; )
                      T.upcast || Ha(`Expected null or instance of ${z.name}, got an instance of ${T.name}`), I = T.upcast(I), T = T.baseClass;
                    return I;
                  };
                  function fg(I, T) {
                    if (T === null)
                      return this.isReference && Ha(`null is not a valid ${this.name}`), 0;
                    T.$$ || Ha(`Cannot pass "${du(T)}" as a ${this.name}`), T.$$.ptr || Ha(`Cannot pass deleted object as a pointer of type ${this.name}`);
                    var z = T.$$.ptrType.registeredClass, ae = n0(T.$$.ptr, z, this.registeredClass);
                    return ae;
                  }
                  function pg(I, T) {
                    var z;
                    if (T === null)
                      return this.isReference && Ha(`null is not a valid ${this.name}`), this.isSmartPointer ? (z = this.rawConstructor(), I !== null && I.push(this.rawDestructor, z), z) : 0;
                    T.$$ || Ha(`Cannot pass "${du(T)}" as a ${this.name}`), T.$$.ptr || Ha(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && T.$$.ptrType.isConst && Ha(`Cannot convert argument of type ${T.$$.smartPtrType ? T.$$.smartPtrType.name : T.$$.ptrType.name} to parameter type ${this.name}`);
                    var ae = T.$$.ptrType.registeredClass;
                    if (z = n0(T.$$.ptr, ae, this.registeredClass), this.isSmartPointer)
                      switch (T.$$.smartPtr === void 0 && Ha("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
                        case 0:
                          T.$$.smartPtrType === this ? z = T.$$.smartPtr : Ha(`Cannot convert argument of type ${T.$$.smartPtrType ? T.$$.smartPtrType.name : T.$$.ptrType.name} to parameter type ${this.name}`);
                          break;
                        case 1:
                          z = T.$$.smartPtr;
                          break;
                        case 2:
                          if (T.$$.smartPtrType === this)
                            z = T.$$.smartPtr;
                          else {
                            var Ve = T.clone();
                            z = this.rawShare(z, Fu.toHandle(() => Ve.delete())), I !== null && I.push(this.rawDestructor, z);
                          }
                          break;
                        default:
                          Ha("Unsupporting sharing policy");
                      }
                    return z;
                  }
                  function mg(I, T) {
                    if (T === null)
                      return this.isReference && Ha(`null is not a valid ${this.name}`), 0;
                    T.$$ || Ha(`Cannot pass "${du(T)}" as a ${this.name}`), T.$$.ptr || Ha(`Cannot pass deleted object as a pointer of type ${this.name}`), T.$$.ptrType.isConst && Ha(`Cannot convert argument of type ${T.$$.ptrType.name} to parameter type ${this.name}`);
                    var z = T.$$.ptrType.registeredClass, ae = n0(T.$$.ptr, z, this.registeredClass);
                    return ae;
                  }
                  function hA(I) {
                    return this.fromWireType(Di[I >> 2]);
                  }
                  var vg = () => {
                    Object.assign(Ed.prototype, { getPointee(I) {
                      return this.rawGetPointee && (I = this.rawGetPointee(I)), I;
                    }, destructor(I) {
                      this.rawDestructor && this.rawDestructor(I);
                    }, argPackAdvance: tu, readValueFromPointer: hA, deleteObject(I) {
                      I !== null && I.delete();
                    }, fromWireType: dg });
                  };
                  function Ed(I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln, Lr) {
                    this.name = I, this.registeredClass = T, this.isReference = z, this.isConst = ae, this.isSmartPointer = Ve, this.pointeeType = qe, this.sharingPolicy = gt, this.rawGetPointee = Wt, this.rawConstructor = Rn, this.rawShare = Ln, this.rawDestructor = Lr, !Ve && T.baseClass === void 0 ? ae ? (this.toWireType = fg, this.destructorFunction = null) : (this.toWireType = mg, this.destructorFunction = null) : this.toWireType = pg;
                  }
                  var Vs = (I, T, z) => {
                    re.hasOwnProperty(I) || Vu("Replacing nonexistant public symbol"), re[I].overloadTable !== void 0 && z !== void 0 ? re[I].overloadTable[z] = T : (re[I] = T, re[I].argCount = z);
                  }, Z0 = (I, T, z) => {
                    var ae = re["dynCall_" + I];
                    return z && z.length ? ae.apply(null, [T].concat(z)) : ae.call(null, T);
                  }, Ju = (I, T, z) => {
                    if (I.includes("j"))
                      return Z0(I, T, z);
                    var ae = et(T).apply(null, z);
                    return ae;
                  }, S0 = (I, T) => {
                    var z = [];
                    return function() {
                      return z.length = 0, Object.assign(z, arguments), Ju(I, T, z);
                    };
                  }, ad = (I, T) => {
                    I = Rc(I);
                    function z() {
                      return I.includes("j") ? S0(I, T) : et(T);
                    }
                    var ae = z();
                    return typeof ae != "function" && Ha(`unknown function pointer with signature ${I}: ${T}`), ae;
                  }, uc = (I, T) => {
                    var z = yc(T, function(ae) {
                      this.name = T, this.message = ae;
                      var Ve = new Error(ae).stack;
                      Ve !== void 0 && (this.stack = this.toString() + `
` + Ve.replace(/^Error(:[^\n]*)?\n/, ""));
                    });
                    return z.prototype = Object.create(I.prototype), z.prototype.constructor = z, z.prototype.toString = function() {
                      return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
                    }, z;
                  }, uh, hh = (I) => {
                    var T = lt(I), z = Rc(T);
                    return _(T), z;
                  }, E0 = (I, T) => {
                    var z = [], ae = {};
                    function Ve(qe) {
                      if (!ae[qe] && !mu[qe]) {
                        if (y0[qe]) {
                          y0[qe].forEach(Ve);
                          return;
                        }
                        z.push(qe), ae[qe] = !0;
                      }
                    }
                    throw T.forEach(Ve), new uh(`${I}: ` + z.map(hh).join([", "]));
                  }, Vd = (I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln, Lr, Oi, ii) => {
                    Lr = Rc(Lr), qe = ad(Ve, qe), Wt && (Wt = ad(gt, Wt)), Ln && (Ln = ad(Rn, Ln)), ii = ad(Oi, ii);
                    var gi = uA(Lr);
                    hg(gi, function() {
                      E0(`Cannot construct ${Lr} due to unbound types`, [ae]);
                    }), _u([I, T, z], ae ? [ae] : [], function(Bo) {
                      Bo = Bo[0];
                      var Cs, Ns;
                      ae ? (Cs = Bo.registeredClass, Ns = Cs.instancePrototype) : Ns = t0.prototype;
                      var cl = yc(Lr, function() {
                        if (Object.getPrototypeOf(this) !== Er)
                          throw new Eu("Use 'new' to construct " + Lr);
                        if (Si.constructor_body === void 0)
                          throw new Eu(Lr + " has no accessible constructor");
                        var Ul = Si.constructor_body[arguments.length];
                        if (Ul === void 0)
                          throw new Eu(`Tried to invoke ctor of ${Lr} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(Si.constructor_body).toString()}) parameters instead!`);
                        return Ul.apply(this, arguments);
                      }), Er = Object.create(Ns, { constructor: { value: cl } });
                      cl.prototype = Er;
                      var Si = new gg(Lr, cl, Er, ii, Cs, qe, Wt, Ln);
                      Si.baseClass && (Si.baseClass.__derivedClasses === void 0 && (Si.baseClass.__derivedClasses = []), Si.baseClass.__derivedClasses.push(Si));
                      var Vl = new Ed(Lr, Si, !0, !1, !1), Us = new Ed(Lr + "*", Si, !1, !1, !1), ld = new Ed(Lr + " const*", Si, !1, !0, !1);
                      return lA[I] = { pointerType: Us, constPointerType: ld }, Vs(gi, cl), [Vl, Us, ld];
                    });
                  }, Gu = (I, T) => {
                    for (var z = [], ae = 0; ae < I; ae++)
                      z.push(Di[T + ae * 4 >> 2]);
                    return z;
                  }, Ah = (I) => {
                    for (; I.length; ) {
                      var T = I.pop(), z = I.pop();
                      z(T);
                    }
                  };
                  function bg(I, T) {
                    if (!(I instanceof Function))
                      throw new TypeError(`new_ called with constructor type ${typeof I} which is not a function`);
                    var z = yc(I.name || "unknownFunctionName", function() {
                    });
                    z.prototype = I.prototype;
                    var ae = new z(), Ve = I.apply(ae, T);
                    return Ve instanceof Object ? Ve : ae;
                  }
                  function AA(I, T, z, ae, Ve, qe) {
                    var gt = T.length;
                    gt < 2 && Ha("argTypes array size mismatch! Must at least get return value and 'this' types!");
                    for (var Wt = T[1] !== null && z !== null, Rn = !1, Ln = 1; Ln < T.length; ++Ln)
                      if (T[Ln] !== null && T[Ln].destructorFunction === void 0) {
                        Rn = !0;
                        break;
                      }
                    for (var Lr = T[0].name !== "void", Oi = "", ii = "", Ln = 0; Ln < gt - 2; ++Ln)
                      Oi += (Ln !== 0 ? ", " : "") + "arg" + Ln, ii += (Ln !== 0 ? ", " : "") + "arg" + Ln + "Wired";
                    var gi = `
        return function (${Oi}) {
        if (arguments.length !== ${gt - 2}) {
          throwBindingError('function ${I} called with ' + arguments.length + ' arguments, expected ${gt - 2}');
        }`;
                    Rn && (gi += `var destructors = [];
`);
                    var Bo = Rn ? "destructors" : "null", Cs = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], Ns = [Ha, ae, Ve, Ah, T[0], T[1]];
                    Wt && (gi += "var thisWired = classParam.toWireType(" + Bo + `, this);
`);
                    for (var Ln = 0; Ln < gt - 2; ++Ln)
                      gi += "var arg" + Ln + "Wired = argType" + Ln + ".toWireType(" + Bo + ", arg" + Ln + "); // " + T[Ln + 2].name + `
`, Cs.push("argType" + Ln), Ns.push(T[Ln + 2]);
                    if (Wt && (ii = "thisWired" + (ii.length > 0 ? ", " : "") + ii), gi += (Lr || qe ? "var rv = " : "") + "invoker(fn" + (ii.length > 0 ? ", " : "") + ii + `);
`, Rn)
                      gi += `runDestructors(destructors);
`;
                    else
                      for (var Ln = Wt ? 1 : 2; Ln < T.length; ++Ln) {
                        var cl = Ln === 1 ? "thisWired" : "arg" + (Ln - 2) + "Wired";
                        T[Ln].destructorFunction !== null && (gi += cl + "_dtor(" + cl + "); // " + T[Ln].name + `
`, Cs.push(cl + "_dtor"), Ns.push(T[Ln].destructorFunction));
                      }
                    Lr && (gi += `var ret = retType.fromWireType(rv);
return ret;
`), gi += `}
`, Cs.push(gi);
                    var Er = bg(Function, Cs).apply(null, Ns);
                    return yc(I, Er);
                  }
                  var Fg = (I, T, z, ae, Ve, qe) => {
                    var gt = Gu(T, z);
                    Ve = ad(ae, Ve), _u([], [I], function(Wt) {
                      Wt = Wt[0];
                      var Rn = `constructor ${Wt.name}`;
                      if (Wt.registeredClass.constructor_body === void 0 && (Wt.registeredClass.constructor_body = []), Wt.registeredClass.constructor_body[T - 1] !== void 0)
                        throw new Eu(`Cannot register multiple constructors with identical number of parameters (${T - 1}) for class '${Wt.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                      return Wt.registeredClass.constructor_body[T - 1] = () => {
                        E0(`Cannot construct ${Wt.name} due to unbound types`, gt);
                      }, _u([], gt, (Ln) => (Ln.splice(1, 0, null), Wt.registeredClass.constructor_body[T - 1] = AA(Rn, Ln, null, Ve, qe), [])), [];
                    });
                  }, Rg = (I) => {
                    I = I.trim();
                    const T = I.indexOf("(");
                    return T !== -1 ? I.substr(0, T) : I;
                  }, V0 = (I, T, z, ae, Ve, qe, gt, Wt, Rn) => {
                    var Ln = Gu(z, ae);
                    T = Rc(T), T = Rg(T), qe = ad(Ve, qe), _u([], [I], function(Lr) {
                      Lr = Lr[0];
                      var Oi = `${Lr.name}.${T}`;
                      T.startsWith("@@") && (T = Symbol[T.substring(2)]), Wt && Lr.registeredClass.pureVirtualFunctions.push(T);
                      function ii() {
                        E0(`Cannot call ${Oi} due to unbound types`, Ln);
                      }
                      var gi = Lr.registeredClass.instancePrototype, Bo = gi[T];
                      return Bo === void 0 || Bo.overloadTable === void 0 && Bo.className !== Lr.name && Bo.argCount === z - 2 ? (ii.argCount = z - 2, ii.className = Lr.name, gi[T] = ii) : (dh(gi, T, Oi), gi[T].overloadTable[z - 2] = ii), _u([], Ln, function(Cs) {
                        var Ns = AA(Oi, Cs, Lr, qe, gt, Rn);
                        return gi[T].overloadTable === void 0 ? (Ns.argCount = z - 2, gi[T] = Ns) : gi[T].overloadTable[z - 2] = Ns, [];
                      }), [];
                    });
                  };
                  function Tu() {
                    Object.assign(r0.prototype, { get(I) {
                      return this.allocated[I];
                    }, has(I) {
                      return this.allocated[I] !== void 0;
                    }, allocate(I) {
                      var T = this.freelist.pop() || this.allocated.length;
                      return this.allocated[T] = I, T;
                    }, free(I) {
                      this.allocated[I] = void 0, this.freelist.push(I);
                    } });
                  }
                  function r0() {
                    this.allocated = [void 0], this.freelist = [];
                  }
                  var tc = new r0(), cu = (I) => {
                    I >= tc.reserved && --tc.get(I).refcount === 0 && tc.free(I);
                  }, bu = () => {
                    for (var I = 0, T = tc.reserved; T < tc.allocated.length; ++T)
                      tc.allocated[T] !== void 0 && ++I;
                    return I;
                  }, gh = () => {
                    tc.allocated.push({ value: void 0 }, { value: null }, { value: !0 }, { value: !1 }), tc.reserved = tc.allocated.length, re.count_emval_handles = bu;
                  }, Fu = { toValue: (I) => (I || Ha("Cannot use deleted val. handle = " + I), tc.get(I).value), toHandle: (I) => {
                    switch (I) {
                      case void 0:
                        return 1;
                      case null:
                        return 2;
                      case !0:
                        return 3;
                      case !1:
                        return 4;
                      default:
                        return tc.allocate({ refcount: 1, value: I });
                    }
                  } };
                  function W0(I) {
                    return this.fromWireType(Ti[I >> 2]);
                  }
                  var i0 = (I, T) => {
                    T = Rc(T), eu(I, { name: T, fromWireType: (z) => {
                      var ae = Fu.toValue(z);
                      return cu(z), ae;
                    }, toWireType: (z, ae) => Fu.toHandle(ae), argPackAdvance: tu, readValueFromPointer: W0, destructorFunction: null });
                  }, du = (I) => {
                    if (I === null)
                      return "null";
                    var T = typeof I;
                    return T === "object" || T === "array" || T === "function" ? I.toString() : "" + I;
                  }, yg = (I, T) => {
                    switch (T) {
                      case 4:
                        return function(z) {
                          return this.fromWireType(Gd[z >> 2]);
                        };
                      case 8:
                        return function(z) {
                          return this.fromWireType(_l[z >> 3]);
                        };
                      default:
                        throw new TypeError(`invalid float width (${T}): ${I}`);
                    }
                  }, Qg = (I, T, z) => {
                    T = Rc(T), eu(I, { name: T, fromWireType: (ae) => ae, toWireType: (ae, Ve) => Ve, argPackAdvance: tu, readValueFromPointer: yg(T, z), destructorFunction: null });
                  }, Cg = (I, T, z) => {
                    switch (T) {
                      case 1:
                        return z ? (ae) => Pi[ae >> 0] : (ae) => wa[ae >> 0];
                      case 2:
                        return z ? (ae) => yl[ae >> 1] : (ae) => Ci[ae >> 1];
                      case 4:
                        return z ? (ae) => Ti[ae >> 2] : (ae) => Di[ae >> 2];
                      default:
                        throw new TypeError(`invalid integer width (${T}): ${I}`);
                    }
                  }, N0 = (I, T, z, ae, Ve) => {
                    T = Rc(T);
                    var qe = (Lr) => Lr;
                    if (ae === 0) {
                      var gt = 32 - 8 * z;
                      qe = (Lr) => Lr << gt >>> gt;
                    }
                    var Wt = T.includes("unsigned"), Rn = (Lr, Oi) => {
                    }, Ln;
                    Wt ? Ln = function(Oi, ii) {
                      return Rn(ii, this.name), ii >>> 0;
                    } : Ln = function(Oi, ii) {
                      return Rn(ii, this.name), ii;
                    }, eu(I, { name: T, fromWireType: qe, toWireType: Ln, argPackAdvance: tu, readValueFromPointer: Cg(T, z, ae !== 0), destructorFunction: null });
                  }, Ru = (I, T, z) => {
                    var ae = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array], Ve = ae[T];
                    function qe(gt) {
                      var Wt = Di[gt >> 2], Rn = Di[gt + 4 >> 2];
                      return new Ve(Pi.buffer, Rn, Wt);
                    }
                    z = Rc(z), eu(I, { name: z, fromWireType: qe, argPackAdvance: tu, readValueFromPointer: qe }, { ignoreDuplicateRegistrations: !0 });
                  }, gA = (I, T) => {
                    T = Rc(T);
                    var z = T === "std::string";
                    eu(I, { name: T, fromWireType(ae) {
                      var Ve = Di[ae >> 2], qe = ae + 4, gt;
                      if (z)
                        for (var Wt = qe, Rn = 0; Rn <= Ve; ++Rn) {
                          var Ln = qe + Rn;
                          if (Rn == Ve || wa[Ln] == 0) {
                            var Lr = Ln - Wt, Oi = Ne(Wt, Lr);
                            gt === void 0 ? gt = Oi : (gt += "\0", gt += Oi), Wt = Ln + 1;
                          }
                        }
                      else {
                        for (var ii = new Array(Ve), Rn = 0; Rn < Ve; ++Rn)
                          ii[Rn] = String.fromCharCode(wa[qe + Rn]);
                        gt = ii.join("");
                      }
                      return _(ae), gt;
                    }, toWireType(ae, Ve) {
                      Ve instanceof ArrayBuffer && (Ve = new Uint8Array(Ve));
                      var qe, gt = typeof Ve == "string";
                      gt || Ve instanceof Uint8Array || Ve instanceof Uint8ClampedArray || Ve instanceof Int8Array || Ha("Cannot pass non-string to std::string"), z && gt ? qe = Yc(Ve) : qe = Ve.length;
                      var Wt = k(4 + qe + 1), Rn = Wt + 4;
                      if (Di[Wt >> 2] = qe, z && gt)
                        qd(Ve, Rn, qe + 1);
                      else if (gt)
                        for (var Ln = 0; Ln < qe; ++Ln) {
                          var Lr = Ve.charCodeAt(Ln);
                          Lr > 255 && (_(Rn), Ha("String has UTF-16 code units that do not fit in 8 bits")), wa[Rn + Ln] = Lr;
                        }
                      else
                        for (var Ln = 0; Ln < qe; ++Ln)
                          wa[Rn + Ln] = Ve[Ln];
                      return ae !== null && ae.push(_, Wt), Wt;
                    }, argPackAdvance: tu, readValueFromPointer: hA, destructorFunction(ae) {
                      _(ae);
                    } });
                  }, fA = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, pA = (I, T) => {
                    for (var z = I, ae = z >> 1, Ve = ae + T / 2; !(ae >= Ve) && Ci[ae]; ) ++ae;
                    if (z = ae << 1, z - I > 32 && fA) return fA.decode(wa.slice(I, z));
                    for (var qe = "", gt = 0; !(gt >= T / 2); ++gt) {
                      var Wt = yl[I + gt * 2 >> 1];
                      if (Wt == 0) break;
                      qe += String.fromCharCode(Wt);
                    }
                    return qe;
                  }, Ug = (I, T, z) => {
                    if (z === void 0 && (z = 2147483647), z < 2) return 0;
                    z -= 2;
                    for (var ae = T, Ve = z < I.length * 2 ? z / 2 : I.length, qe = 0; qe < Ve; ++qe) {
                      var gt = I.charCodeAt(qe);
                      yl[T >> 1] = gt, T += 2;
                    }
                    return yl[T >> 1] = 0, T - ae;
                  }, fh = (I) => I.length * 2, o0 = (I, T) => {
                    for (var z = 0, ae = ""; !(z >= T / 4); ) {
                      var Ve = Ti[I + z * 4 >> 2];
                      if (Ve == 0) break;
                      if (++z, Ve >= 65536) {
                        var qe = Ve - 65536;
                        ae += String.fromCharCode(55296 | qe >> 10, 56320 | qe & 1023);
                      } else
                        ae += String.fromCharCode(Ve);
                    }
                    return ae;
                  }, ph = (I, T, z) => {
                    if (z === void 0 && (z = 2147483647), z < 4) return 0;
                    for (var ae = T, Ve = ae + z - 4, qe = 0; qe < I.length; ++qe) {
                      var gt = I.charCodeAt(qe);
                      if (gt >= 55296 && gt <= 57343) {
                        var Wt = I.charCodeAt(++qe);
                        gt = 65536 + ((gt & 1023) << 10) | Wt & 1023;
                      }
                      if (Ti[T >> 2] = gt, T += 4, T + 4 > Ve) break;
                    }
                    return Ti[T >> 2] = 0, T - ae;
                  }, mh = (I) => {
                    for (var T = 0, z = 0; z < I.length; ++z) {
                      var ae = I.charCodeAt(z);
                      ae >= 55296 && ae <= 57343 && ++z, T += 4;
                    }
                    return T;
                  }, mA = (I, T, z) => {
                    z = Rc(z);
                    var ae, Ve, qe, gt, Wt;
                    T === 2 ? (ae = pA, Ve = Ug, gt = fh, qe = () => Ci, Wt = 1) : T === 4 && (ae = o0, Ve = ph, gt = mh, qe = () => Di, Wt = 2), eu(I, { name: z, fromWireType: (Rn) => {
                      for (var Ln = Di[Rn >> 2], Lr = qe(), Oi, ii = Rn + 4, gi = 0; gi <= Ln; ++gi) {
                        var Bo = Rn + 4 + gi * T;
                        if (gi == Ln || Lr[Bo >> Wt] == 0) {
                          var Cs = Bo - ii, Ns = ae(ii, Cs);
                          Oi === void 0 ? Oi = Ns : (Oi += "\0", Oi += Ns), ii = Bo + T;
                        }
                      }
                      return _(Rn), Oi;
                    }, toWireType: (Rn, Ln) => {
                      typeof Ln != "string" && Ha(`Cannot pass non-string to C++ string type ${z}`);
                      var Lr = gt(Ln), Oi = k(4 + Lr + T);
                      return Di[Oi >> 2] = Lr >> Wt, Ve(Ln, Oi + 4, Lr + T), Rn !== null && Rn.push(_, Oi), Oi;
                    }, argPackAdvance: tu, readValueFromPointer: W0, destructorFunction(Rn) {
                      _(Rn);
                    } });
                  }, a0 = (I, T) => {
                    T = Rc(T), eu(I, { isVoid: !0, name: T, argPackAdvance: 0, fromWireType: () => {
                    }, toWireType: (z, ae) => {
                    } });
                  }, Ig = 1, J0 = () => Ig, Bg = () => {
                    if (!Yl && !_s())
                      try {
                        vt ? Mi(Dl) : $s(Dl);
                      } catch (I) {
                        _a(I);
                      }
                  }, vh = (I) => {
                    if (!(Yl || aa))
                      try {
                        I(), Bg();
                      } catch (T) {
                        _a(T);
                      }
                  }, Xu = (I) => {
                    if (typeof Atomics.waitAsync == "function") {
                      var T = Atomics.waitAsync(Ti, I >> 2, I);
                      T.value.then(ku);
                      var z = I + 128;
                      Atomics.store(Ti, z >> 2, 1);
                    }
                  };
                  re.__emscripten_thread_mailbox_await = Xu;
                  var ku = () => {
                    var I = V();
                    I && (Xu(I), vh(ri));
                  };
                  re.checkMailbox = ku;
                  var Zg = (I, T, z) => {
                    if (I == T)
                      setTimeout(() => ku());
                    else if (vt)
                      postMessage({ targetThread: I, cmd: "checkMailbox" });
                    else {
                      var ae = no.pthreads[I];
                      if (!ae)
                        return;
                      ae.postMessage({ cmd: "checkMailbox" });
                    }
                  }, bh = [], Sg = (I, T, z, ae) => {
                    bh.length = z;
                    for (var Ve = ae >> 3, qe = 0; qe < z; qe++)
                      bh[qe] = _l[Ve + qe];
                    var gt = Jg[I];
                    no.currentProxiedOperationCallerThread = T;
                    var Wt = gt.apply(null, bh);
                    return no.currentProxiedOperationCallerThread = 0, Wt;
                  }, vA = (I) => {
                  }, G0 = (I) => {
                    I > 4 && (tc.get(I).refcount += 1);
                  }, s0 = (I, T) => {
                    var z = mu[I];
                    return z === void 0 && Ha(T + " has unknown type " + hh(I)), z;
                  }, Fh = (I, T) => {
                    I = s0(I, "_emval_take_value");
                    var z = I.readValueFromPointer(T);
                    return Fu.toHandle(z);
                  };
                  function Qa(I, T, z, ae, Ve, qe, gt, Wt) {
                    if (vt) return Ta(14, 1, I, T, z, ae, Ve, qe, gt, Wt);
                    var Rn = sl(Ve, qe);
                    try {
                      if (isNaN(Rn)) return 61;
                      var Ln = qr.getStreamFromFD(ae), Lr = Je.mmap(Ln, I, Rn, T, z), Oi = Lr.ptr;
                      return Ti[gt >> 2] = Lr.allocated, Di[Wt >> 2] = Oi, 0;
                    } catch (ii) {
                      if (typeof Je == "undefined" || ii.name !== "ErrnoError") throw ii;
                      return -ii.errno;
                    }
                  }
                  function yu(I, T, z, ae, Ve, qe, gt) {
                    if (vt) return Ta(15, 1, I, T, z, ae, Ve, qe, gt);
                    var Wt = sl(qe, gt);
                    try {
                      if (isNaN(Wt)) return 61;
                      var Rn = qr.getStreamFromFD(Ve);
                      z & 2 && qr.doMsync(I, Rn, T, ae, Wt), Je.munmap(Rn);
                    } catch (Ln) {
                      if (typeof Je == "undefined" || Ln.name !== "ErrnoError") throw Ln;
                      return -Ln.errno;
                    }
                  }
                  var sd = () => {
                    _r("");
                  }, bA = () => {
                  }, FA = () => Date.now(), RA = () => {
                    Vc += 1;
                  }, yA = () => {
                    throw RA(), "unwind";
                  }, Ws = () => wa.length, l0 = () => Ws(), Qs;
                  Qs = () => performance.timeOrigin + performance.now();
                  var Ms = () => navigator.hardwareConcurrency, QA = (I) => {
                    _r("OOM");
                  }, CA = (I) => {
                    wa.length, QA();
                  }, T0 = {}, UA = () => ut || "./this.program", wu = () => {
                    if (!wu.strings) {
                      var I = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", T = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: I, _: UA() };
                      for (var z in T0)
                        T0[z] === void 0 ? delete T[z] : T[z] = T0[z];
                      var ae = [];
                      for (var z in T)
                        ae.push(`${z}=${T[z]}`);
                      wu.strings = ae;
                    }
                    return wu.strings;
                  }, Eg = (I, T) => {
                    for (var z = 0; z < I.length; ++z)
                      Pi[T++ >> 0] = I.charCodeAt(z);
                    Pi[T >> 0] = 0;
                  }, c0 = function(T, z) {
                    if (vt) return Ta(16, 1, T, z);
                    var ae = 0;
                    return wu().forEach((Ve, qe) => {
                      var gt = z + ae;
                      Di[T + qe * 4 >> 2] = gt, Eg(Ve, gt), ae += Ve.length + 1;
                    }), 0;
                  }, Rh = function(T, z) {
                    if (vt) return Ta(17, 1, T, z);
                    var ae = wu();
                    Di[T >> 2] = ae.length;
                    var Ve = 0;
                    return ae.forEach((qe) => Ve += qe.length + 1), Di[z >> 2] = Ve, 0;
                  };
                  function yh(I) {
                    if (vt) return Ta(18, 1, I);
                    try {
                      var T = qr.getStreamFromFD(I);
                      return Je.close(T), 0;
                    } catch (z) {
                      if (typeof Je == "undefined" || z.name !== "ErrnoError") throw z;
                      return z.errno;
                    }
                  }
                  var IA = (I, T, z, ae) => {
                    for (var Ve = 0, qe = 0; qe < z; qe++) {
                      var gt = Di[T >> 2], Wt = Di[T + 4 >> 2];
                      T += 8;
                      var Rn = Je.read(I, Pi, gt, Wt, ae);
                      if (Rn < 0) return -1;
                      if (Ve += Rn, Rn < Wt) break;
                    }
                    return Ve;
                  };
                  function X0(I, T, z, ae) {
                    if (vt) return Ta(19, 1, I, T, z, ae);
                    try {
                      var Ve = qr.getStreamFromFD(I), qe = IA(Ve, T, z);
                      return Di[ae >> 2] = qe, 0;
                    } catch (gt) {
                      if (typeof Je == "undefined" || gt.name !== "ErrnoError") throw gt;
                      return gt.errno;
                    }
                  }
                  function Qh(I, T, z, ae, Ve) {
                    if (vt) return Ta(20, 1, I, T, z, ae, Ve);
                    var qe = sl(T, z);
                    try {
                      if (isNaN(qe)) return 61;
                      var gt = qr.getStreamFromFD(I);
                      return Je.llseek(gt, qe, ae), ja = [gt.position >>> 0, (Uo = gt.position, +Math.abs(Uo) >= 1 ? Uo > 0 ? +Math.floor(Uo / 4294967296) >>> 0 : ~~+Math.ceil((Uo - +(~~Uo >>> 0)) / 4294967296) >>> 0 : 0)], Ti[Ve >> 2] = ja[0], Ti[Ve + 4 >> 2] = ja[1], gt.getdents && qe === 0 && ae === 0 && (gt.getdents = null), 0;
                    } catch (Wt) {
                      if (typeof Je == "undefined" || Wt.name !== "ErrnoError") throw Wt;
                      return Wt.errno;
                    }
                  }
                  function Ch(I) {
                    if (vt) return Ta(21, 1, I);
                    try {
                      var T = qr.getStreamFromFD(I);
                      return T.stream_ops && T.stream_ops.fsync ? T.stream_ops.fsync(T) : 0;
                    } catch (z) {
                      if (typeof Je == "undefined" || z.name !== "ErrnoError") throw z;
                      return z.errno;
                    }
                  }
                  var BA = (I, T, z, ae) => {
                    for (var Ve = 0, qe = 0; qe < z; qe++) {
                      var gt = Di[T >> 2], Wt = Di[T + 4 >> 2];
                      T += 8;
                      var Rn = Je.write(I, Pi, gt, Wt, ae);
                      if (Rn < 0) return -1;
                      Ve += Rn;
                    }
                    return Ve;
                  };
                  function Uh(I, T, z, ae) {
                    if (vt) return Ta(22, 1, I, T, z, ae);
                    try {
                      var Ve = qr.getStreamFromFD(I), qe = BA(Ve, T, z);
                      return Di[ae >> 2] = qe, 0;
                    } catch (gt) {
                      if (typeof Je == "undefined" || gt.name !== "ErrnoError") throw gt;
                      return gt.errno;
                    }
                  }
                  var ZA = (I, T) => (la(wa.subarray(I, I + T)), 0), d0 = (I) => I % 4 === 0 && (I % 100 !== 0 || I % 400 === 0), SA = (I, T) => {
                    for (var z = 0, ae = 0; ae <= T; z += I[ae++])
                      ;
                    return z;
                  }, Ih = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Bh = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], EA = (I, T) => {
                    for (var z = new Date(I.getTime()); T > 0; ) {
                      var ae = d0(z.getFullYear()), Ve = z.getMonth(), qe = (ae ? Ih : Bh)[Ve];
                      if (T > qe - z.getDate())
                        T -= qe - z.getDate() + 1, z.setDate(1), Ve < 11 ? z.setMonth(Ve + 1) : (z.setMonth(0), z.setFullYear(z.getFullYear() + 1));
                      else
                        return z.setDate(z.getDate() + T), z;
                    }
                    return z;
                  }, Vg = (I, T) => {
                    Pi.set(I, T);
                  }, Wg = (I, T, z, ae) => {
                    var Ve = Di[ae + 40 >> 2], qe = { tm_sec: Ti[ae >> 2], tm_min: Ti[ae + 4 >> 2], tm_hour: Ti[ae + 8 >> 2], tm_mday: Ti[ae + 12 >> 2], tm_mon: Ti[ae + 16 >> 2], tm_year: Ti[ae + 20 >> 2], tm_wday: Ti[ae + 24 >> 2], tm_yday: Ti[ae + 28 >> 2], tm_isdst: Ti[ae + 32 >> 2], tm_gmtoff: Ti[ae + 36 >> 2], tm_zone: Ve ? Ne(Ve) : "" }, gt = Ne(z), Wt = { "%c": "%a %b %d %H:%M:%S %Y", "%D": "%m/%d/%y", "%F": "%Y-%m-%d", "%h": "%b", "%r": "%I:%M:%S %p", "%R": "%H:%M", "%T": "%H:%M:%S", "%x": "%m/%d/%y", "%X": "%H:%M:%S", "%Ec": "%c", "%EC": "%C", "%Ex": "%m/%d/%y", "%EX": "%H:%M:%S", "%Ey": "%y", "%EY": "%Y", "%Od": "%d", "%Oe": "%e", "%OH": "%H", "%OI": "%I", "%Om": "%m", "%OM": "%M", "%OS": "%S", "%Ou": "%u", "%OU": "%U", "%OV": "%V", "%Ow": "%w", "%OW": "%W", "%Oy": "%y" };
                    for (var Rn in Wt)
                      gt = gt.replace(new RegExp(Rn, "g"), Wt[Rn]);
                    var Ln = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], Lr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    function Oi(Er, Si, Vl) {
                      for (var Us = typeof Er == "number" ? Er.toString() : Er || ""; Us.length < Si; )
                        Us = Vl[0] + Us;
                      return Us;
                    }
                    function ii(Er, Si) {
                      return Oi(Er, Si, "0");
                    }
                    function gi(Er, Si) {
                      function Vl(ld) {
                        return ld < 0 ? -1 : ld > 0 ? 1 : 0;
                      }
                      var Us;
                      return (Us = Vl(Er.getFullYear() - Si.getFullYear())) === 0 && (Us = Vl(Er.getMonth() - Si.getMonth())) === 0 && (Us = Vl(Er.getDate() - Si.getDate())), Us;
                    }
                    function Bo(Er) {
                      switch (Er.getDay()) {
                        case 0:
                          return new Date(Er.getFullYear() - 1, 11, 29);
                        case 1:
                          return Er;
                        case 2:
                          return new Date(Er.getFullYear(), 0, 3);
                        case 3:
                          return new Date(Er.getFullYear(), 0, 2);
                        case 4:
                          return new Date(Er.getFullYear(), 0, 1);
                        case 5:
                          return new Date(Er.getFullYear() - 1, 11, 31);
                        case 6:
                          return new Date(Er.getFullYear() - 1, 11, 30);
                      }
                    }
                    function Cs(Er) {
                      var Si = EA(new Date(Er.tm_year + 1900, 0, 1), Er.tm_yday), Vl = new Date(Si.getFullYear(), 0, 4), Us = new Date(Si.getFullYear() + 1, 0, 4), ld = Bo(Vl), Ul = Bo(Us);
                      return gi(ld, Si) <= 0 ? gi(Ul, Si) <= 0 ? Si.getFullYear() + 1 : Si.getFullYear() : Si.getFullYear() - 1;
                    }
                    var Ns = { "%a": (Er) => Ln[Er.tm_wday].substring(0, 3), "%A": (Er) => Ln[Er.tm_wday], "%b": (Er) => Lr[Er.tm_mon].substring(0, 3), "%B": (Er) => Lr[Er.tm_mon], "%C": (Er) => {
                      var Si = Er.tm_year + 1900;
                      return ii(Si / 100 | 0, 2);
                    }, "%d": (Er) => ii(Er.tm_mday, 2), "%e": (Er) => Oi(Er.tm_mday, 2, " "), "%g": (Er) => Cs(Er).toString().substring(2), "%G": (Er) => Cs(Er), "%H": (Er) => ii(Er.tm_hour, 2), "%I": (Er) => {
                      var Si = Er.tm_hour;
                      return Si == 0 ? Si = 12 : Si > 12 && (Si -= 12), ii(Si, 2);
                    }, "%j": (Er) => ii(Er.tm_mday + SA(d0(Er.tm_year + 1900) ? Ih : Bh, Er.tm_mon - 1), 3), "%m": (Er) => ii(Er.tm_mon + 1, 2), "%M": (Er) => ii(Er.tm_min, 2), "%n": () => `
`, "%p": (Er) => Er.tm_hour >= 0 && Er.tm_hour < 12 ? "AM" : "PM", "%S": (Er) => ii(Er.tm_sec, 2), "%t": () => "	", "%u": (Er) => Er.tm_wday || 7, "%U": (Er) => {
                      var Si = Er.tm_yday + 7 - Er.tm_wday;
                      return ii(Math.floor(Si / 7), 2);
                    }, "%V": (Er) => {
                      var Si = Math.floor((Er.tm_yday + 7 - (Er.tm_wday + 6) % 7) / 7);
                      if ((Er.tm_wday + 371 - Er.tm_yday - 2) % 7 <= 2 && Si++, Si) {
                        if (Si == 53) {
                          var Us = (Er.tm_wday + 371 - Er.tm_yday) % 7;
                          Us != 4 && (Us != 3 || !d0(Er.tm_year)) && (Si = 1);
                        }
                      } else {
                        Si = 52;
                        var Vl = (Er.tm_wday + 7 - Er.tm_yday - 1) % 7;
                        (Vl == 4 || Vl == 5 && d0(Er.tm_year % 400 - 1)) && Si++;
                      }
                      return ii(Si, 2);
                    }, "%w": (Er) => Er.tm_wday, "%W": (Er) => {
                      var Si = Er.tm_yday + 7 - (Er.tm_wday + 6) % 7;
                      return ii(Math.floor(Si / 7), 2);
                    }, "%y": (Er) => (Er.tm_year + 1900).toString().substring(2), "%Y": (Er) => Er.tm_year + 1900, "%z": (Er) => {
                      var Si = Er.tm_gmtoff, Vl = Si >= 0;
                      return Si = Math.abs(Si) / 60, Si = Si / 60 * 100 + Si % 60, (Vl ? "+" : "-") + ("0000" + Si).slice(-4);
                    }, "%Z": (Er) => Er.tm_zone, "%%": () => "%" };
                    gt = gt.replace(/%%/g, "\0\0");
                    for (var Rn in Ns)
                      gt.includes(Rn) && (gt = gt.replace(new RegExp(Rn, "g"), Ns[Rn](qe)));
                    gt = gt.replace(/\0\0/g, "%");
                    var cl = Lc(gt, !1);
                    return cl.length > T ? 0 : (Vg(cl, I), cl.length - 1);
                  }, Ng = (I, T, z, ae, Ve) => Wg(I, T, z, ae);
                  no.init();
                  var VA = function(T, z, ae, Ve) {
                    T || (T = this), this.parent = T, this.mount = T.mount, this.mounted = null, this.id = Je.nextInode++, this.name = z, this.mode = ae, this.node_ops = {}, this.stream_ops = {}, this.rdev = Ve;
                  }, k0 = 365, w0 = 146;
                  Object.defineProperties(VA.prototype, { read: { get: function() {
                    return (this.mode & k0) === k0;
                  }, set: function(T) {
                    T ? this.mode |= k0 : this.mode &= ~k0;
                  } }, write: { get: function() {
                    return (this.mode & w0) === w0;
                  }, set: function(T) {
                    T ? this.mode |= w0 : this.mode &= ~w0;
                  } }, isFolder: { get: function() {
                    return Je.isDir(this.mode);
                  } }, isDevice: { get: function() {
                    return Je.isChrdev(this.mode);
                  } } }), Je.FSNode = VA, Je.createPreloadedFile = su, Je.staticInit(), ig(), Eu = re.BindingError = /* @__PURE__ */ function(I) {
                    (0, h.default)(T, I);
                    function T(z) {
                      var ae;
                      return ae = I.call(this, z) || this, ae.name = "BindingError", ae;
                    }
                    return T;
                  }(/* @__PURE__ */ (0, A.default)(Error)), aA = re.InternalError = /* @__PURE__ */ function(I) {
                    (0, h.default)(T, I);
                    function T(z) {
                      var ae;
                      return ae = I.call(this, z) || this, ae.name = "InternalError", ae;
                    }
                    return T;
                  }(/* @__PURE__ */ (0, A.default)(Error)), ug(), cA(), vg(), uh = re.UnboundTypeError = uc(Error, "UnboundTypeError"), Tu(), gh();
                  var Jg = [$d, Yd, Sa, Hc, Wc, Zd, Sd, lu, Zu, Su, rA, iA, Ku, oA, Qa, yu, c0, Rh, yh, X0, Qh, Ch, Uh], D0 = { b: ze, w: te, v: Qe, d: rn, k: tr, ya: Vn, n: si, ia: ai, E: Ui, fa: xa, h: Ht, oa: Wc, W: Zd, ma: Zu, pa: Su, ea: rA, da: iA, na: Ku, aa: oA, X: zu, ua: ag, S: Vd, R: Fg, m: V0, ta: i0, K: Qg, q: N0, l: Ru, J: gA, B: mA, va: a0, sa: J0, ba: Zg, ga: Sg, ha: Xu, ra: vA, Ca: cu, Da: G0, s: Fh, T: Qa, U: yu, c: sd, F: bA, H: FA, qa: yA, ca: l0, p: Qs, M: Ms, $: CA, ja: c0, ka: Rh, L: $s, I: yh, G: X0, V: Qh, la: Ch, A: Uh, Z: ZA, Ba: k2, D: fm, g: G2, xa: _2, Aa: w2, e: T2, f: gm, z: z2, y: Am, Q: D2, Y: Pc, r: M2, j: um, i: X2, t: O2, C: j2, o: x2, za: P2, u: hm, O: H2, P: Y2, x: L2, N: K2, a: Co || re.wasmMemory, _: Ng, wa: Mc }, Io = Sl(), V = re._pthread_self = () => (V = re._pthread_self = Io.Fa)(), k = (I) => (k = Io.Ha)(I), _ = (I) => (_ = Io.Ia)(I), ue = () => (ue = Io.Ja)();
                  re.__emscripten_tls_init = () => (re.__emscripten_tls_init = Io.Ka)();
                  var Me = (I, T) => (Me = Io.La)(I, T), lt = (I) => (lt = Io.Ma)(I);
                  re.__embind_initialize_bindings = () => (re.__embind_initialize_bindings = Io.Na)();
                  var Ut = () => (Ut = Io.Oa)(), Dt = re.__emscripten_thread_init = (I, T, z, ae, Ve, qe) => (Dt = re.__emscripten_thread_init = Io.Pa)(I, T, z, ae, Ve, qe);
                  re.__emscripten_thread_crashed = () => (re.__emscripten_thread_crashed = Io.Qa)();
                  var kn = re._fflush = (I) => (kn = re._fflush = Io.Ra)(I), _n = (I, T, z, ae) => (_n = Io.Sa)(I, T, z, ae), $r = (I) => ($r = Io.Ta)(I), Mi = re.__emscripten_thread_exit = (I) => (Mi = re.__emscripten_thread_exit = Io.Ua)(I), ri = () => (ri = Io.Va)(), Dr = (I, T) => (Dr = Io.Wa)(I, T), ro = (I) => (ro = Io.Xa)(I), as = (I, T) => (as = Io.Ya)(I, T), io = () => (io = Io.Za)(), uo = (I) => (uo = Io._a)(I), yr = (I) => (yr = Io.$a)(I), bi = (I) => (bi = Io.ab)(I), Ni = (I) => (Ni = Io.bb)(I), es = (I, T, z) => (es = Io.cb)(I, T, z), Qc = (I) => (Qc = Io.db)(I);
                  re.dynCall_viijj = (I, T, z, ae, Ve, qe, gt) => (re.dynCall_viijj = Io.eb)(I, T, z, ae, Ve, qe, gt), re.dynCall_viiijjj = (I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln) => (re.dynCall_viiijjj = Io.fb)(I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln), re.dynCall_iiiij = (I, T, z, ae, Ve, qe) => (re.dynCall_iiiij = Io.gb)(I, T, z, ae, Ve, qe), re.dynCall_jii = (I, T, z) => (re.dynCall_jii = Io.hb)(I, T, z), re.dynCall_jjj = (I, T, z, ae, Ve) => (re.dynCall_jjj = Io.ib)(I, T, z, ae, Ve), re.dynCall_iiiijj = (I, T, z, ae, Ve, qe, gt, Wt) => (re.dynCall_iiiijj = Io.jb)(I, T, z, ae, Ve, qe, gt, Wt), re.dynCall_viijji = (I, T, z, ae, Ve, qe, gt, Wt) => (re.dynCall_viijji = Io.kb)(I, T, z, ae, Ve, qe, gt, Wt), re.dynCall_iiijj = (I, T, z, ae, Ve, qe, gt) => (re.dynCall_iiijj = Io.lb)(I, T, z, ae, Ve, qe, gt), re.dynCall_viijjj = (I, T, z, ae, Ve, qe, gt, Wt, Rn) => (re.dynCall_viijjj = Io.mb)(I, T, z, ae, Ve, qe, gt, Wt, Rn);
                  var qs = re.dynCall_iij = (I, T, z, ae) => (qs = re.dynCall_iij = Io.nb)(I, T, z, ae);
                  re.dynCall_iijjiiii = (I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln) => (re.dynCall_iijjiiii = Io.ob)(I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln), re.dynCall_jiji = (I, T, z, ae, Ve) => (re.dynCall_jiji = Io.pb)(I, T, z, ae, Ve), re.dynCall_viijii = (I, T, z, ae, Ve, qe, gt) => (re.dynCall_viijii = Io.qb)(I, T, z, ae, Ve, qe, gt), re.dynCall_iiiiij = (I, T, z, ae, Ve, qe, gt) => (re.dynCall_iiiiij = Io.rb)(I, T, z, ae, Ve, qe, gt), re.dynCall_iiiiijj = (I, T, z, ae, Ve, qe, gt, Wt, Rn) => (re.dynCall_iiiiijj = Io.sb)(I, T, z, ae, Ve, qe, gt, Wt, Rn), re.dynCall_iiiiiijj = (I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln) => (re.dynCall_iiiiiijj = Io.tb)(I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln), re.___start_em_js = 262148, re.___stop_em_js = 262760;
                  function G2(I, T) {
                    var z = io();
                    try {
                      return et(I)(T);
                    } catch (ae) {
                      if (uo(z), ae !== ae + 0) throw ae;
                      Dr(1, 0);
                    }
                  }
                  function T2(I, T, z) {
                    var ae = io();
                    try {
                      return et(I)(T, z);
                    } catch (Ve) {
                      if (uo(ae), Ve !== Ve + 0) throw Ve;
                      Dr(1, 0);
                    }
                  }
                  function X2(I, T, z) {
                    var ae = io();
                    try {
                      et(I)(T, z);
                    } catch (Ve) {
                      if (uo(ae), Ve !== Ve + 0) throw Ve;
                      Dr(1, 0);
                    }
                  }
                  function um(I, T) {
                    var z = io();
                    try {
                      et(I)(T);
                    } catch (ae) {
                      if (uo(z), ae !== ae + 0) throw ae;
                      Dr(1, 0);
                    }
                  }
                  function hm(I, T, z, ae, Ve) {
                    var qe = io();
                    try {
                      et(I)(T, z, ae, Ve);
                    } catch (gt) {
                      if (uo(qe), gt !== gt + 0) throw gt;
                      Dr(1, 0);
                    }
                  }
                  function Am(I, T, z, ae, Ve, qe) {
                    var gt = io();
                    try {
                      return et(I)(T, z, ae, Ve, qe);
                    } catch (Wt) {
                      if (uo(gt), Wt !== Wt + 0) throw Wt;
                      Dr(1, 0);
                    }
                  }
                  function gm(I, T, z, ae) {
                    var Ve = io();
                    try {
                      return et(I)(T, z, ae);
                    } catch (qe) {
                      if (uo(Ve), qe !== qe + 0) throw qe;
                      Dr(1, 0);
                    }
                  }
                  function fm(I) {
                    var T = io();
                    try {
                      return et(I)();
                    } catch (z) {
                      if (uo(T), z !== z + 0) throw z;
                      Dr(1, 0);
                    }
                  }
                  function k2(I, T) {
                    var z = io();
                    try {
                      return et(I)(T);
                    } catch (ae) {
                      if (uo(z), ae !== ae + 0) throw ae;
                      Dr(1, 0);
                    }
                  }
                  function w2(I, T, z) {
                    var ae = io();
                    try {
                      return et(I)(T, z);
                    } catch (Ve) {
                      if (uo(ae), Ve !== Ve + 0) throw Ve;
                      Dr(1, 0);
                    }
                  }
                  function D2(I, T, z, ae, Ve, qe, gt) {
                    var Wt = io();
                    try {
                      return et(I)(T, z, ae, Ve, qe, gt);
                    } catch (Rn) {
                      if (uo(Wt), Rn !== Rn + 0) throw Rn;
                      Dr(1, 0);
                    }
                  }
                  function M2(I) {
                    var T = io();
                    try {
                      et(I)();
                    } catch (z) {
                      if (uo(T), z !== z + 0) throw z;
                      Dr(1, 0);
                    }
                  }
                  function Y2(I, T, z, ae, Ve, qe) {
                    var gt = io();
                    try {
                      et(I)(T, z, ae, Ve, qe);
                    } catch (Wt) {
                      if (uo(gt), Wt !== Wt + 0) throw Wt;
                      Dr(1, 0);
                    }
                  }
                  function L2(I, T, z, ae, Ve, qe, gt, Wt, Rn, Ln) {
                    var Lr = io();
                    try {
                      et(I)(T, z, ae, Ve, qe, gt, Wt, Rn, Ln);
                    } catch (Oi) {
                      if (uo(Lr), Oi !== Oi + 0) throw Oi;
                      Dr(1, 0);
                    }
                  }
                  function x2(I, T, z, ae) {
                    var Ve = io();
                    try {
                      et(I)(T, z, ae);
                    } catch (qe) {
                      if (uo(Ve), qe !== qe + 0) throw qe;
                      Dr(1, 0);
                    }
                  }
                  function H2(I, T, z, ae, Ve, qe, gt) {
                    var Wt = io();
                    try {
                      et(I)(T, z, ae, Ve, qe, gt);
                    } catch (Rn) {
                      if (uo(Wt), Rn !== Rn + 0) throw Rn;
                      Dr(1, 0);
                    }
                  }
                  function P2(I, T, z, ae, Ve, qe, gt, Wt) {
                    var Rn = io();
                    try {
                      et(I)(T, z, ae, Ve, qe, gt, Wt);
                    } catch (Ln) {
                      if (uo(Rn), Ln !== Ln + 0) throw Ln;
                      Dr(1, 0);
                    }
                  }
                  function O2(I, T, z, ae) {
                    var Ve = io();
                    try {
                      et(I)(T, z, ae);
                    } catch (qe) {
                      if (uo(Ve), qe !== qe + 0) throw qe;
                      Dr(1, 0);
                    }
                  }
                  function K2(I, T, z, ae, Ve, qe, gt, Wt, Rn) {
                    var Ln = io();
                    try {
                      et(I)(T, z, ae, Ve, qe, gt, Wt, Rn);
                    } catch (Lr) {
                      if (uo(Ln), Lr !== Lr + 0) throw Lr;
                      Dr(1, 0);
                    }
                  }
                  function z2(I, T, z, ae, Ve) {
                    var qe = io();
                    try {
                      return et(I)(T, z, ae, Ve);
                    } catch (gt) {
                      if (uo(qe), gt !== gt + 0) throw gt;
                      Dr(1, 0);
                    }
                  }
                  function j2(I, T, z, ae, Ve) {
                    var qe = io();
                    try {
                      et(I)(T, z, ae, Ve);
                    } catch (gt) {
                      if (uo(qe), gt !== gt + 0) throw gt;
                      Dr(1, 0);
                    }
                  }
                  function _2(I, T, z, ae, Ve) {
                    var qe = io();
                    try {
                      return et(I)(T, z, ae, Ve);
                    } catch (gt) {
                      if (uo(qe), gt !== gt + 0) throw gt;
                      Dr(1, 0);
                    }
                  }
                  function Pc(I, T, z, ae) {
                    var Ve = io();
                    try {
                      return qs(I, T, z, ae);
                    } catch (qe) {
                      if (uo(Ve), qe !== qe + 0) throw qe;
                      Dr(1, 0);
                    }
                  }
                  re.wasmMemory = Co, re.keepRuntimeAlive = _s, re.ExitStatus = td, re.PThread = no;
                  var hc;
                  Ds = function I() {
                    hc || Zh(), hc || (Ds = I);
                  };
                  function Zh() {
                    if (ql > 0)
                      return;
                    if (vt) {
                      Be(re), ac(), startWorker(re);
                      return;
                    }
                    if (js(), ql > 0)
                      return;
                    function I() {
                      hc || (hc = !0, re.calledRun = !0, !aa && (ac(), Be(re), re.onRuntimeInitialized && re.onRuntimeInitialized(), Ll()));
                    }
                    re.setStatus ? (re.setStatus("Running..."), setTimeout(function() {
                      setTimeout(function() {
                        re.setStatus("");
                      }, 1), I();
                    }, 1)) : I();
                  }
                  if (re.preInit)
                    for (typeof re.preInit == "function" && (re.preInit = [re.preInit]); re.preInit.length > 0; )
                      re.preInit.pop()();
                  return Zh(), ye.ready;
                };
              })();
              y = m;
            }
            let U = function() {
            };
            U.updates = { transformer_new: "New transformer", transformer_null: "Null transformer" }, U.errors = { transformer_none: "No transformers provided", transformer_start: "Cannot start transformer", transformer_transform: "Cannot transform frame", transformer_flush: "Cannot flush transformer", readable_null: "Readable is null", writable_null: "Writable is null" };
            function B(xe) {
              return xe && xe.__esModule && Object.prototype.hasOwnProperty.call(xe, "default") ? xe.default : xe;
            }
            const Q = /* @__PURE__ */ new WeakMap(), N = /* @__PURE__ */ new WeakMap(), J = /* @__PURE__ */ new WeakMap(), w = Symbol("anyProducer"), W = n.resolve(), G = Symbol("listenerAdded"), Z = Symbol("listenerRemoved");
            let K = !1;
            function L(xe) {
              if (typeof xe != "string" && typeof xe != "symbol") throw new TypeError("eventName must be a string or a symbol");
            }
            function O(xe) {
              if (typeof xe != "function") throw new TypeError("listener must be a function");
            }
            function de(xe, ot) {
              const ye = N.get(xe);
              return ye.has(ot) || ye.set(ot, /* @__PURE__ */ new Set()), ye.get(ot);
            }
            function oe(xe, ot) {
              const ye = typeof ot == "string" || typeof ot == "symbol" ? ot : w, re = J.get(xe);
              return re.has(ye) || re.set(ye, /* @__PURE__ */ new Set()), re.get(ye);
            }
            function fe(xe, ot, ye) {
              const re = J.get(xe);
              if (re.has(ot))
                for (var Be = f(re.get(ot)), He; !(He = Be()).done; )
                  He.value.enqueue(ye);
              if (re.has(w)) {
                const ct = n.all([ot, ye]);
                for (var Xe = f(re.get(w)), ut; !(ut = Xe()).done; )
                  ut.value.enqueue(ct);
              }
            }
            function ge(xe, ot) {
              ot = Array.isArray(ot) ? ot : [ot];
              let ye = !1, re = () => {
              }, Be = [];
              const He = { enqueue(ct) {
                Be.push(ct), re();
              }, finish() {
                ye = !0, re();
              } };
              for (var Xe = f(ot), ut; !(ut = Xe()).done; ) {
                const ct = ut.value;
                oe(xe, ct).add(He);
              }
              return { next() {
                var ct = this;
                return (0, u.default)(/* @__PURE__ */ l.default.mark(function Xt() {
                  return l.default.wrap(function(un) {
                    for (; ; ) switch (un.prev = un.next) {
                      case 0:
                        if (!Be) {
                          un.next = 19;
                          break;
                        }
                        if (Be.length !== 0) {
                          un.next = 12;
                          break;
                        }
                        if (!ye) {
                          un.next = 6;
                          break;
                        }
                        un.t2 = (Be = void 0, ct.next()), un.next = 9;
                        break;
                      case 6:
                        return un.next = 8, new n((vt) => {
                          re = vt;
                        });
                      case 8:
                        un.t2 = ct.next();
                      case 9:
                        un.t1 = un.t2, un.next = 16;
                        break;
                      case 12:
                        return un.next = 14, Be.shift();
                      case 14:
                        un.t3 = un.sent, un.t1 = { done: !1, value: un.t3 };
                      case 16:
                        un.t0 = un.t1, un.next = 20;
                        break;
                      case 19:
                        un.t0 = { done: !0 };
                      case 20:
                        return un.abrupt("return", un.t0);
                      case 21:
                      case "end":
                        return un.stop();
                    }
                  }, Xt);
                }))();
              }, return(ct) {
                var Xt = arguments;
                return (0, u.default)(/* @__PURE__ */ l.default.mark(function pn() {
                  var un, vt, gr;
                  return l.default.wrap(function(an) {
                    for (; ; ) switch (an.prev = an.next) {
                      case 0:
                        for (Be = void 0, un = f(ot); !(vt = un()).done; )
                          gr = vt.value, oe(xe, gr).delete(He);
                        if (re(), !(Xt.length > 0)) {
                          an.next = 10;
                          break;
                        }
                        return an.next = 6, ct;
                      case 6:
                        an.t1 = an.sent, an.t0 = { done: !0, value: an.t1 }, an.next = 11;
                        break;
                      case 10:
                        an.t0 = { done: !0 };
                      case 11:
                        return an.abrupt("return", an.t0);
                      case 12:
                      case "end":
                        return an.stop();
                    }
                  }, pn);
                }))();
              }, [Symbol.asyncIterator]() {
                return this;
              } };
            }
            function we(xe) {
              if (xe === void 0) return Pe;
              if (!Array.isArray(xe)) throw new TypeError("`methodNames` must be an array of strings");
              for (var ot = f(xe), ye; !(ye = ot()).done; ) {
                const re = ye.value;
                if (!Pe.includes(re)) throw typeof re != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${re} is not Emittery method`);
              }
              return xe;
            }
            const _e = (xe) => xe === G || xe === Z;
            let Te = /* @__PURE__ */ function() {
              xe.mixin = function(re, Be) {
                return Be = we(Be), (He) => {
                  if (typeof He != "function") throw new TypeError("`target` must be function");
                  for (var Xe = f(Be), ut; !(ut = Xe()).done; ) {
                    const vt = ut.value;
                    if (He.prototype[vt] !== void 0) throw new Error(`The property \`${vt}\` already exists on \`target\``);
                  }
                  function ct() {
                    return Object.defineProperty(this, re, { enumerable: !1, value: new xe() }), this[re];
                  }
                  Object.defineProperty(He.prototype, re, { enumerable: !1, get: ct });
                  const Xt = (vt) => function() {
                    return this[re][vt](...arguments);
                  };
                  for (var pn = f(Be), un; !(un = pn()).done; ) {
                    const vt = un.value;
                    Object.defineProperty(He.prototype, vt, { enumerable: !1, value: Xt(vt) });
                  }
                  return He;
                };
              };
              function xe(ye) {
                ye === void 0 && (ye = {}), Q.set(this, /* @__PURE__ */ new Set()), N.set(this, /* @__PURE__ */ new Map()), J.set(this, /* @__PURE__ */ new Map()), this.debug = ye.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (re, Be, He, Xe) => {
                  try {
                    Xe = JSON.stringify(Xe);
                  } catch {
                    Xe = `Object with the following keys failed to stringify: ${Object.keys(Xe).join(",")}`;
                  }
                  typeof He == "symbol" && (He = He.toString());
                  const ut = /* @__PURE__ */ new Date(), ct = `${ut.getHours()}:${ut.getMinutes()}:${ut.getSeconds()}.${ut.getMilliseconds()}`;
                  console.log(`[${ct}][emittery:${re}][${Be}] Event Name: ${He}
	data: ${Xe}`);
                });
              }
              var ot = xe.prototype;
              return ot.logIfDebugEnabled = function(re, Be, He) {
                (xe.isDebugEnabled || this.debug.enabled) && this.debug.logger(re, this.debug.name, Be, He);
              }, ot.on = function(re, Be) {
                O(Be), re = Array.isArray(re) ? re : [re];
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  L(ut), de(this, ut).add(Be), this.logIfDebugEnabled("subscribe", ut, void 0), _e(ut) || this.emit(G, { eventName: ut, listener: Be });
                }
                return this.off.bind(this, re, Be);
              }, ot.off = function(re, Be) {
                O(Be), re = Array.isArray(re) ? re : [re];
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  L(ut), de(this, ut).delete(Be), this.logIfDebugEnabled("unsubscribe", ut, void 0), _e(ut) || this.emit(Z, { eventName: ut, listener: Be });
                }
              }, ot.once = function(re) {
                return new n((Be) => {
                  const He = this.on(re, (Xe) => {
                    He(), Be(Xe);
                  });
                });
              }, ot.events = function(re) {
                re = Array.isArray(re) ? re : [re];
                for (var Be = f(re), He; !(He = Be()).done; ) {
                  const Xe = He.value;
                  L(Xe);
                }
                return ge(this, re);
              }, ot.emit = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn;
                  return l.default.wrap(function(vt) {
                    for (; ; ) switch (vt.prev = vt.next) {
                      case 0:
                        return L(He), this.logIfDebugEnabled("emit", He, Xe), fe(this, He, Xe), ut = de(this, He), ct = Q.get(this), Xt = [...ut], pn = _e(He) ? [] : [...ct], vt.next = 4, W;
                      case 4:
                        return vt.next = 6, n.all([...Xt.map(/* @__PURE__ */ function() {
                          var gr = (0, u.default)(/* @__PURE__ */ l.default.mark(function sr(an) {
                            return l.default.wrap(function(fn) {
                              for (; ; ) switch (fn.prev = fn.next) {
                                case 0:
                                  if (!ut.has(an)) {
                                    fn.next = 2;
                                    break;
                                  }
                                  return fn.abrupt("return", an(Xe));
                                case 2:
                                case "end":
                                  return fn.stop();
                              }
                            }, sr);
                          }));
                          return function(sr) {
                            return gr.apply(this, arguments);
                          };
                        }()), ...pn.map(/* @__PURE__ */ function() {
                          var gr = (0, u.default)(/* @__PURE__ */ l.default.mark(function sr(an) {
                            return l.default.wrap(function(fn) {
                              for (; ; ) switch (fn.prev = fn.next) {
                                case 0:
                                  if (!ct.has(an)) {
                                    fn.next = 2;
                                    break;
                                  }
                                  return fn.abrupt("return", an(He, Xe));
                                case 2:
                                case "end":
                                  return fn.stop();
                              }
                            }, sr);
                          }));
                          return function(sr) {
                            return gr.apply(this, arguments);
                          };
                        }())]);
                      case 6:
                      case "end":
                        return vt.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.emitSerial = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn, un, vt, gr, sr, an;
                  return l.default.wrap(function(fn) {
                    for (; ; ) switch (fn.prev = fn.next) {
                      case 0:
                        return L(He), this.logIfDebugEnabled("emitSerial", He, Xe), ut = de(this, He), ct = Q.get(this), Xt = [...ut], pn = [...ct], fn.next = 4, W;
                      case 4:
                        un = 0, vt = Xt;
                      case 5:
                        if (!(un < vt.length)) {
                          fn.next = 14;
                          break;
                        }
                        if (gr = vt[un], fn.t0 = ut.has(gr), !fn.t0) {
                          fn.next = 11;
                          break;
                        }
                        return fn.next = 11, gr(Xe);
                      case 11:
                        un++, fn.next = 5;
                        break;
                      case 14:
                        sr = 0, an = pn;
                      case 15:
                        if (!(sr < an.length)) {
                          fn.next = 24;
                          break;
                        }
                        if (gr = an[sr], fn.t1 = ct.has(gr), !fn.t1) {
                          fn.next = 21;
                          break;
                        }
                        return fn.next = 21, gr(He, Xe);
                      case 21:
                        sr++, fn.next = 15;
                        break;
                      case 24:
                      case "end":
                        return fn.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.onAny = function(re) {
                return O(re), this.logIfDebugEnabled("subscribeAny", void 0, void 0), Q.get(this).add(re), this.emit(G, { listener: re }), this.offAny.bind(this, re);
              }, ot.anyEvent = function() {
                return ge(this);
              }, ot.offAny = function(re) {
                O(re), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(Z, { listener: re }), Q.get(this).delete(re);
              }, ot.clearListeners = function(re) {
                re = Array.isArray(re) ? re : [re];
                for (var Be = f(re), He; !(He = Be()).done; ) {
                  const sr = He.value;
                  if (this.logIfDebugEnabled("clear", sr, void 0), typeof sr == "string" || typeof sr == "symbol") {
                    de(this, sr).clear();
                    const an = oe(this, sr);
                    for (var Xe = f(an), ut; !(ut = Xe()).done; )
                      ut.value.finish();
                    an.clear();
                  } else {
                    Q.get(this).clear();
                    for (var ct = f(N.get(this).values()), Xt; !(Xt = ct()).done; )
                      Xt.value.clear();
                    for (var pn = f(J.get(this).values()), un; !(un = pn()).done; ) {
                      const an = un.value;
                      for (var vt = f(an), gr; !(gr = vt()).done; )
                        gr.value.finish();
                      an.clear();
                    }
                  }
                }
              }, ot.listenerCount = function(re) {
                re = Array.isArray(re) ? re : [re];
                let Be = 0;
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const un = Xe.value;
                  if (typeof un == "string") {
                    Be += Q.get(this).size + de(this, un).size + oe(this, un).size + oe(this).size;
                    continue;
                  }
                  typeof un < "u" && L(un), Be += Q.get(this).size;
                  for (var ut = f(N.get(this).values()), ct; !(ct = ut()).done; ) {
                    const vt = ct.value;
                    Be += vt.size;
                  }
                  for (var Xt = f(J.get(this).values()), pn; !(pn = Xt()).done; ) {
                    const vt = pn.value;
                    Be += vt.size;
                  }
                }
                return Be;
              }, ot.bindMethods = function(re, Be) {
                if (typeof re != "object" || re === null) throw new TypeError("`target` must be an object");
                Be = we(Be);
                for (var He = f(Be), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  if (re[ut] !== void 0) throw new Error(`The property \`${ut}\` already exists on \`target\``);
                  Object.defineProperty(re, ut, { enumerable: !1, value: this[ut].bind(this) });
                }
              }, (0, d.default)(xe, null, [{ key: "isDebugEnabled", get: function() {
                if (typeof t != "object") return K;
                const re = t || { env: {} }, Be = re.env;
                return Be.DEBUG === "emittery" || Be.DEBUG === "*" || K;
              }, set: function(re) {
                K = re;
              } }]), xe;
            }();
            const Pe = Object.getOwnPropertyNames(Te.prototype).filter((xe) => xe !== "constructor");
            Object.defineProperty(Te, "listenerAdded", { value: G, writable: !1, enumerable: !0, configurable: !1 }), Object.defineProperty(Te, "listenerRemoved", { value: Z, writable: !1, enumerable: !0, configurable: !1 });
            var $e = Te;
            const Bt = /* @__PURE__ */ B($e);
            function Le(xe) {
              return typeof xe == "object" && xe !== null && "message" in xe && typeof xe.message == "string";
            }
            function at(xe) {
              if (Le(xe)) return xe;
              try {
                return new Error(JSON.stringify(xe));
              } catch {
                return new Error(String(xe));
              }
            }
            function pt(xe) {
              return at(xe).message;
            }
            var kt = Object.defineProperty, _t = (xe, ot, ye) => ot in xe ? kt(xe, ot, { enumerable: !0, configurable: !0, writable: !0, value: ye }) : xe[ot] = ye, Lt = (xe, ot, ye) => (_t(xe, ot + "", ye), ye);
            const Ft = "hlg.tokbox.com/prod/logging/vcp_webrtc", Zt = "https://", ft = 1e4;
            let It;
            const Kt = new Uint8Array(16);
            function Sn() {
              if (!It && (It = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !It)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
              return It(Kt);
            }
            const Cn = [];
            for (let xe = 0; xe < 256; ++xe) Cn.push((xe + 256).toString(16).slice(1));
            function on(xe, ot) {
              return ot === void 0 && (ot = 0), (Cn[xe[ot + 0]] + Cn[xe[ot + 1]] + Cn[xe[ot + 2]] + Cn[xe[ot + 3]] + "-" + Cn[xe[ot + 4]] + Cn[xe[ot + 5]] + "-" + Cn[xe[ot + 6]] + Cn[xe[ot + 7]] + "-" + Cn[xe[ot + 8]] + Cn[xe[ot + 9]] + "-" + Cn[xe[ot + 10]] + Cn[xe[ot + 11]] + Cn[xe[ot + 12]] + Cn[xe[ot + 13]] + Cn[xe[ot + 14]] + Cn[xe[ot + 15]]).toLowerCase();
            }
            const An = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Ue = { randomUUID: An };
            function ne(xe, ot, ye) {
              if (Ue.randomUUID && !ot && !xe) return Ue.randomUUID();
              xe = xe || {};
              const re = xe.random || (xe.rng || Sn)();
              return re[6] = re[6] & 15 | 64, re[8] = re[8] & 63 | 128, on(re);
            }
            function se(xe, ot) {
              g.vonage || (g.vonage = {}), g.vonage.workerizer || (g.vonage.workerizer = {});
              let ye = g.vonage.workerizer;
              return ye[xe] || (ye[xe] = ot), ye[xe];
            }
            const Ce = se("globals", {});
            var At = /* @__PURE__ */ ((xe) => (xe.INIT = "INIT", xe.FORWARD = "FORWARD", xe.TERMINATE = "TERMINATE", xe.GLOBALS_SYNC = "GLOBALS_SYNC", xe))(At || {});
            function Ge(xe) {
              return [ImageBitmap, ReadableStream, WritableStream].some((ot) => xe instanceof ot);
            }
            let Ye = 0;
            function Qt(xe, ot, ye, re, Be) {
              const He = Ye++;
              return xe.postMessage({ id: He, type: ot, functionName: ye, args: re }, re.filter((Xe) => Ge(Xe))), new n((Xe) => {
                Be == null || Be.set(He, Xe);
              });
            }
            function tn(xe, ot) {
              const ye = xe.id, re = xe.type, Be = Array.isArray(ot) ? ot : [ot];
              postMessage({ id: ye, type: re, result: ot }, Be.filter((He) => Ge(He)));
            }
            const vn = se("workerized", {});
            function Yt() {
              return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
            }
            function Tn() {
              return er.apply(this, arguments);
            }
            function er() {
              return er = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe() {
                var ot, ye, re, Be, He;
                return l.default.wrap(function(ut) {
                  for (; ; ) switch (ut.prev = ut.next) {
                    case 0:
                      if (!Yt()) {
                        ut.next = 4;
                        break;
                      }
                      tn({ type: At.GLOBALS_SYNC }, Ce), ut.next = 8;
                      break;
                    case 4:
                      ot = [];
                      for (ye in vn)
                        re = vn[ye].workerContext, Be = re.worker, He = re.resolvers, Be && ot.push(Qt(Be, At.GLOBALS_SYNC, "", [Ce], He));
                      return ut.next = 8, n.all(ot);
                    case 8:
                    case "end":
                      return ut.stop();
                  }
                }, xe);
              })), er.apply(this, arguments);
            }
            function lr(xe, ot) {
              if (Array.isArray(ot)) ot.splice(0, ot.length);
              else if (typeof ot == "object") for (const ye in ot) delete ot[ye];
              for (const ye in xe) Array.isArray(xe[ye]) ? (ot[ye] = [], lr(xe[ye], ot[ye])) : typeof xe[ye] == "object" ? (ot[ye] = {}, lr(xe[ye], ot[ye])) : ot[ye] = xe[ye];
            }
            function Br(xe, ot) {
              return pi.apply(this, arguments);
            }
            function pi() {
              return pi = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye) {
                var re, Be;
                return l.default.wrap(function(Xe) {
                  for (; ; ) switch (Xe.prev = Xe.next) {
                    case 0:
                      if (re = ot.functionName, Be = ot.args, ye.instance) {
                        Xe.next = 3;
                        break;
                      }
                      throw "instance not initialized";
                    case 3:
                      if (re) {
                        Xe.next = 5;
                        break;
                      }
                      throw "missing function name to call";
                    case 5:
                      if (ye.instance[re]) {
                        Xe.next = 7;
                        break;
                      }
                      throw `undefined function [${re}] in class ${ye.instance.constructor.workerId}`;
                    case 7:
                      return Xe.t0 = tn, Xe.t1 = ot, Xe.next = 11, ye.instance[re](...Be != null ? Be : []);
                    case 11:
                      Xe.t2 = Xe.sent, (0, Xe.t0)(Xe.t1, Xe.t2);
                    case 13:
                    case "end":
                      return Xe.stop();
                  }
                }, xe);
              })), pi.apply(this, arguments);
            }
            const $n = se("registeredWorkers", {});
            function rr(xe, ot) {
              if (!xe.args) throw "Missing className while initializing worker";
              const ye = xe.args, re = ye[0], Be = ye[1], He = $n[re];
              if (He) ot.instance = new He(xe.args.slice(1));
              else throw `unknown worker class ${re}`;
              lr(Be, Ce), tn(xe, typeof ot.instance !== void 0);
            }
            function Kr(xe, ot) {
              return Bi.apply(this, arguments);
            }
            function Bi() {
              return Bi = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye) {
                var re, Be;
                return l.default.wrap(function(Xe) {
                  for (; ; ) switch (Xe.prev = Xe.next) {
                    case 0:
                      if (re = ot.args, ye.instance) {
                        Xe.next = 3;
                        break;
                      }
                      throw "instance not initialized";
                    case 3:
                      if (Xe.t0 = ye.instance.terminate, !Xe.t0) {
                        Xe.next = 8;
                        break;
                      }
                      return Xe.next = 7, ye.instance.terminate(...re != null ? re : []);
                    case 7:
                      Be = Xe.sent;
                    case 8:
                      tn(ot, Be);
                    case 9:
                    case "end":
                      return Xe.stop();
                  }
                }, xe);
              })), Bi.apply(this, arguments);
            }
            function Li(xe) {
              if (!xe.args) throw "Missing globals while syncing";
              lr(xe.args[0], Ce), tn(xe, {});
            }
            function xo() {
              const xe = {};
              onmessage = /* @__PURE__ */ function() {
                var ot = (0, u.default)(/* @__PURE__ */ l.default.mark(function ye(re) {
                  var Be;
                  return l.default.wrap(function(Xe) {
                    for (; ; ) switch (Xe.prev = Xe.next) {
                      case 0:
                        Be = re.data, Xe.t0 = Be.type, Xe.next = Xe.t0 === At.INIT ? 4 : Xe.t0 === At.FORWARD ? 6 : Xe.t0 === At.TERMINATE ? 8 : Xe.t0 === At.GLOBALS_SYNC ? 10 : 12;
                        break;
                      case 4:
                        return rr(Be, xe), Xe.abrupt("break", 12);
                      case 6:
                        return Br(Be, xe), Xe.abrupt("break", 12);
                      case 8:
                        return Kr(Be, xe), Xe.abrupt("break", 12);
                      case 10:
                        return Li(Be), Xe.abrupt("break", 12);
                      case 12:
                      case "end":
                        return Xe.stop();
                    }
                  }, ye);
                }));
                return function(re) {
                  return ot.apply(this, arguments);
                };
              }();
            }
            Yt() && xo();
            function Yr(xe, ot) {
              return Ce[xe] || (Ce[xe] = ot), [() => Ce[xe], /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function re(Be) {
                  return l.default.wrap(function(Xe) {
                    for (; ; ) switch (Xe.prev = Xe.next) {
                      case 0:
                        return Ce[xe] = Be, Xe.next = 3, Tn();
                      case 3:
                      case "end":
                        return Xe.stop();
                    }
                  }, re);
                }));
                return function(re) {
                  return ye.apply(this, arguments);
                };
              }()];
            }
            function Qo(xe, ot) {
              return Yr(xe, ot);
            }
            const Wo = Qo("metadata"), xi = Wo[0];
            function Fa() {
              return xi();
            }
            let sn = /* @__PURE__ */ function() {
              function xe(ye, re) {
                Lt(this, "uuid"), this.config = ye, this.uuid = re != null ? re : ne();
              }
              var ot = xe.prototype;
              return ot.send = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He) {
                  var Xe, ut, ct, Xt, pn, un, vt, gr;
                  return l.default.wrap(function(an) {
                    for (; ; ) switch (an.prev = an.next) {
                      case 0:
                        if (Xt = (Xe = Fa()) != null ? Xe : {}, pn = Xt.appId, un = Xt.sourceType, !(!pn || !un)) {
                          an.next = 3;
                          break;
                        }
                        return an.abrupt("return", "metadata missing");
                      case 3:
                        return vt = new AbortController(), gr = setTimeout(() => vt.abort(), ft), an.next = 6, ((ct = (ut = this.config) == null ? void 0 : ut.fetch) != null ? ct : fetch)(this.getUrl(), { method: "POST", headers: this.getHeaders(), body: JSON.stringify(this.buildReport(He)), signal: vt.signal });
                      case 6:
                        return clearTimeout(gr), an.abrupt("return", "success");
                      case 8:
                      case "end":
                        return an.stop();
                    }
                  }, Be, this);
                }));
                function re(Be) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.getUrl = function() {
                var re;
                let Be = (re = Fa().proxyUrl) != null ? re : Zt;
                return Be += (Be.at(-1) === "/" ? "" : "/") + Ft, Be;
              }, ot.getHeaders = function() {
                return { "Content-Type": "application/json" };
              }, ot.buildReport = function(re) {
                const Be = Fa();
                return Object.assign({ guid: this.uuid }, re, { applicationId: Be.appId, timestamp: Date.now(), proxyUrl: Be.proxyUrl, source: Be.sourceType });
              }, xe;
            }();
            const Ct = "2.0.4";
            let cn = /* @__PURE__ */ function() {
              function xe(ye, re) {
                this.config = ye, this.frameTransformedCount = 0, this.frameFromSourceCount = 0, this.startAt = 0, this.reporter = new sn(ye, re);
              }
              var ot = xe.prototype;
              return ot.onFrameFromSource = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be() {
                  return l.default.wrap(function(Xe) {
                    for (; ; ) switch (Xe.prev = Xe.next) {
                      case 0:
                        this.frameFromSourceCount++;
                      case 1:
                      case "end":
                        return Xe.stop();
                    }
                  }, Be, this);
                }));
                function re() {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.onFrameTransformed = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn, un, vt, gr;
                  return l.default.wrap(function(an) {
                    for (; ; ) switch (an.prev = an.next) {
                      case 0:
                        return He === void 0 && (He = {}), Xe === void 0 && (Xe = !1), this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++, ut = this.startAt, ct = this.frameTransformedCount, Xt = this.frameFromSourceCount, pn = Date.now(), un = (pn - ut) / 1e3, vt = ct / un, gr = Xt / un, an.abrupt("return", Xe || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = pn, this.reporter.config = this.config, this.reporter.send(Object.assign({}, this.config.report, { variation: "QoS", fps: gr, transformedFps: vt, framesTransformed: ct }, He))) : "success");
                      case 5:
                      case "end":
                        return an.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), (0, d.default)(xe, [{ key: "fps", get: function() {
                const re = this.startAt, Be = this.frameFromSourceCount, He = (Date.now() - re) / 1e3;
                return Be / He;
              } }]), xe;
            }();
            var Hn = /* @__PURE__ */ ((xe) => (xe.pipeline_ended = "pipeline_ended", xe.pipeline_ended_with_error = "pipeline_ended_with_error", xe.pipeline_started = "pipeline_started", xe.pipeline_started_with_error = "pipeline_started_with_error", xe.pipeline_restarted = "pipeline_restarted", xe.pipeline_restarted_with_error = "pipeline_restarted_with_error", xe))(Hn || {});
            const Sr = 500, ao = 0.8;
            let wr = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot(re, Be) {
                var He;
                return He = xe.call(this) || this, He.reporter_ = new sn(), He.reporterQos_ = new cn({ loggingIntervalFrameCount: Sr, report: { version: Ct } }), He.index_ = Be, He.transformer_ = re, He.shouldStop_ = !1, He.isFlashed_ = !1, He.mediaTransformerQosReportStartTimestamp_ = 0, He.videoHeight_ = 0, He.videoWidth_ = 0, He.trackExpectedRate_ = -1, He.transformerType_ = "Custom", "getTransformerType" in re && (He.transformerType_ = re.getTransformerType()), He.report({ variation: "Create" }), He;
              }
              var ye = ot.prototype;
              return ye.setTrackExpectedRate = function(Be) {
                this.trackExpectedRate_ = Be;
              }, ye.start = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  var ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        if (this.controller_ = Xe, !(this.transformer_ && typeof this.transformer_.start == "function")) {
                          Xt.next = 11;
                          break;
                        }
                        return Xt.prev = 1, Xt.next = 4, this.transformer_.start(Xe);
                      case 4:
                        Xt.next = 11;
                        break;
                      case 6:
                        Xt.prev = 6, Xt.t0 = Xt.catch(1), this.report({ message: U.errors.transformer_start, variation: "Error", error: pt(Xt.t0) }), ut = {
                          eventMetaData: { transformerIndex: this.index_ },
                          error: Xt.t0,
                          function: "start"
                          /* start */
                        }, this.emit("error", ut);
                      case 11:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this, [[1, 6]]);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.transform = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut) {
                  var ct, Xt, pn, un, vt, gr;
                  return l.default.wrap(function(an) {
                    for (; ; ) switch (an.prev = an.next) {
                      case 0:
                        if (this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), Xe instanceof VideoFrame && (this.videoHeight_ = (ct = Xe == null ? void 0 : Xe.displayHeight) != null ? ct : 0, this.videoWidth_ = (Xt = Xe == null ? void 0 : Xe.displayWidth) != null ? Xt : 0), this.reporterQos_.onFrameFromSource(), !this.transformer_) {
                          an.next = 17;
                          break;
                        }
                        if (!this.shouldStop_) {
                          an.next = 5;
                          break;
                        }
                        console.warn("[Pipeline] flush from transform"), Xe.close(), this.flush(ut), ut.terminate(), an.next = 17;
                        break;
                      case 5:
                        return an.prev = 5, an.next = 8, (un = (pn = this.transformer_).transform) == null ? void 0 : un.call(pn, Xe, ut);
                      case 8:
                        this.reportQos(), an.next = 16;
                        break;
                      case 11:
                        an.prev = 11, an.t0 = an.catch(5), this.report({ message: U.errors.transformer_transform, variation: "Error", error: pt(an.t0) }), vt = {
                          eventMetaData: { transformerIndex: this.index_ },
                          error: an.t0,
                          function: "transform"
                          /* transform */
                        }, this.emit("error", vt);
                      case 16:
                        this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * ao > this.reporterQos_.fps && (gr = { eventMetaData: { transformerIndex: this.index_ }, warningType: "fps_drop", dropInfo: { requested: this.trackExpectedRate_, current: this.reporterQos_.fps } }, this.emit("warn", gr));
                      case 17:
                      case "end":
                        return an.stop();
                    }
                  }, He, this, [[5, 11]]);
                }));
                function Be(He, Xe) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.flush = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  var ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        if (!(this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_)) {
                          Xt.next = 12;
                          break;
                        }
                        return this.isFlashed_ = !0, Xt.prev = 2, Xt.next = 5, this.transformer_.flush(Xe);
                      case 5:
                        Xt.next = 12;
                        break;
                      case 7:
                        Xt.prev = 7, Xt.t0 = Xt.catch(2), this.report({ message: U.errors.transformer_flush, variation: "Error", error: pt(Xt.t0) }), ut = {
                          eventMetaData: { transformerIndex: this.index_ },
                          error: Xt.t0,
                          function: "flush"
                          /* flush */
                        }, this.emit("error", ut);
                      case 12:
                        this.reportQos(!0), this.report({ variation: "Delete" });
                      case 13:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this, [[2, 7]]);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.stop = function() {
                console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
              }, ye.report = function(Be) {
                this.reporter_.send(Object.assign({ version: Ct, action: "MediaTransformer", transformerType: this.transformerType_ }, Be));
              }, ye.reportQos = function(Be) {
                Be === void 0 && (Be = !1), this.reporterQos_.config = Object.assign({}, this.reporterQos_.config), this.reporterQos_.onFrameTransformed({ version: Ct, action: "MediaTransformer", transformerType: this.transformerType_, videoWidth: this.videoWidth_, videoHeight: this.videoHeight_ }, Be);
              }, ot;
            }(Bt), Jr = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot(re) {
                var Be;
                Be = xe.call(this) || this, Be.transformers_ = [], Be.trackExpectedRate_ = -1;
                for (let He = 0; He < re.length; He++) {
                  let Xe = new wr(re[He], He);
                  Xe.on("error", (ut) => {
                    Be.emit("error", ut);
                  }), Xe.on("warn", (ut) => {
                    Be.emit("warn", ut);
                  }), Be.transformers_.push(Xe);
                }
                return Be;
              }
              var ye = ot.prototype;
              return ye.setTrackExpectedRate = function(Be) {
                this.trackExpectedRate_ = Be;
                for (var He = f(this.transformers_), Xe; !(Xe = He()).done; )
                  Xe.value.setTrackExpectedRate(this.trackExpectedRate_);
              }, ye.start = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut) {
                  var ct = this, Xt, pn, un, vt;
                  return l.default.wrap(function(sr) {
                    for (; ; ) switch (sr.prev = sr.next) {
                      case 0:
                        if (!(!this.transformers_ || this.transformers_.length === 0)) {
                          sr.next = 3;
                          break;
                        }
                        return console.log("[Pipeline] No transformers."), sr.abrupt("return");
                      case 3:
                        for (sr.prev = 3, Xt = Xe, pn = f(this.transformers_); !(un = pn()).done; )
                          vt = un.value, Xe = Xe.pipeThrough(new TransformStream(vt));
                        Xe.pipeTo(ut).then(/* @__PURE__ */ (0, u.default)(/* @__PURE__ */ l.default.mark(function an() {
                          return l.default.wrap(function(fn) {
                            for (; ; ) switch (fn.prev = fn.next) {
                              case 0:
                                return console.log("[Pipeline] Setup."), fn.next = 3, ut.abort();
                              case 3:
                                return fn.next = 5, Xt.cancel();
                              case 5:
                                ct.emit(
                                  "pipelineInfo",
                                  "pipeline_ended"
                                  /* pipeline_ended */
                                );
                              case 6:
                              case "end":
                                return fn.stop();
                            }
                          }, an);
                        }))).catch(/* @__PURE__ */ function() {
                          var an = (0, u.default)(/* @__PURE__ */ l.default.mark(function En(fn) {
                            return l.default.wrap(function(Ro) {
                              for (; ; ) switch (Ro.prev = Ro.next) {
                                case 0:
                                  return Xe.cancel().then(() => {
                                    console.log("[Pipeline] Shutting down streams after abort.");
                                  }).catch((ca) => {
                                    console.error("[Pipeline] Error from stream transform:", ca);
                                  }), Ro.next = 3, ut.abort(fn);
                                case 3:
                                  return Ro.next = 5, Xt.cancel(fn);
                                case 5:
                                  ct.emit(
                                    "pipelineInfo",
                                    "pipeline_ended_with_error"
                                    /* pipeline_ended_with_error */
                                  );
                                case 6:
                                case "end":
                                  return Ro.stop();
                              }
                            }, En);
                          }));
                          return function(En) {
                            return an.apply(this, arguments);
                          };
                        }()), sr.next = 13;
                        break;
                      case 9:
                        return sr.prev = 9, sr.t0 = sr.catch(3), this.emit(
                          "pipelineInfo",
                          "pipeline_started_with_error"
                          /* pipeline_started_with_error */
                        ), this.destroy(), sr.abrupt("return");
                      case 13:
                        this.emit(
                          "pipelineInfo",
                          "pipeline_started"
                          /* pipeline_started */
                        ), console.log("[Pipeline] Pipeline started.");
                      case 14:
                      case "end":
                        return sr.stop();
                    }
                  }, He, this, [[3, 9]]);
                }));
                function Be(He, Xe) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.destroy = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut, ct;
                  return l.default.wrap(function(pn) {
                    for (; ; ) switch (pn.prev = pn.next) {
                      case 0:
                        for (console.log("[Pipeline] Destroying Pipeline."), Xe = f(this.transformers_); !(ut = Xe()).done; )
                          ct = ut.value, ct.stop();
                      case 2:
                      case "end":
                        return pn.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ot;
            }(Bt), Fn = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot() {
                var re;
                return re = xe.call(this) || this, re.reporter_ = new sn(), re.trackExpectedRate_ = -1, re.report({ variation: "Create" }), re;
              }
              var ye = ot.prototype;
              return ye.setTrackExpectedRate = function(Be) {
                this.trackExpectedRate_ = Be, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
              }, ye.transform = function(Be, He) {
                return this.readable_ = Be, this.writable_ = He, this.transformInternal();
              }, ye.transformInternal = function() {
                var Be = this;
                return new n(/* @__PURE__ */ function() {
                  var He = (0, u.default)(/* @__PURE__ */ l.default.mark(function Xe(ut, ct) {
                    var Xt;
                    return l.default.wrap(function(un) {
                      for (; ; ) switch (un.prev = un.next) {
                        case 0:
                          if (!(!Be.transformers_ || Be.transformers_.length === 0)) {
                            un.next = 3;
                            break;
                          }
                          return Be.report({ message: U.errors.transformer_none, variation: "Error" }), ct("[MediaProcessor] Need to set transformers."), un.abrupt("return");
                        case 3:
                          if (Be.readable_) {
                            un.next = 6;
                            break;
                          }
                          return Be.report({ variation: "Error", message: U.errors.readable_null }), ct("[MediaProcessor] Readable is null."), un.abrupt("return");
                        case 6:
                          if (Be.writable_) {
                            un.next = 9;
                            break;
                          }
                          return Be.report({ variation: "Error", message: U.errors.writable_null }), ct("[MediaProcessor] Writable is null."), un.abrupt("return");
                        case 9:
                          Xt = !1, Be.pipeline_ && (Xt = !0, Be.pipeline_.clearListeners(), Be.pipeline_.destroy()), Be.pipeline_ = new Jr(Be.transformers_), Be.pipeline_.on("warn", (vt) => {
                            Be.emit("warn", vt);
                          }), Be.pipeline_.on("error", (vt) => {
                            Be.emit("error", vt);
                          }), Be.pipeline_.on("pipelineInfo", (vt) => {
                            Xt && (vt === "pipeline_started" ? vt = Hn.pipeline_restarted : vt === "pipeline_started_with_error" && (vt = Hn.pipeline_restarted_with_error)), Be.emit("pipelineInfo", vt);
                          }), Be.trackExpectedRate_ != -1 && Be.pipeline_.setTrackExpectedRate(Be.trackExpectedRate_), Be.pipeline_.start(Be.readable_, Be.writable_).then(() => {
                            ut();
                          }).catch((vt) => {
                            ct(vt);
                          });
                        case 11:
                        case "end":
                          return un.stop();
                      }
                    }, Xe);
                  }));
                  return function(Xe, ut) {
                    return He.apply(this, arguments);
                  };
                }());
              }, ye.setTransformers = function(Be) {
                return this.report({ variation: "Update", message: U.updates.transformer_new }), this.transformers_ = Be, this.readable_ && this.writable_ ? this.transformInternal() : n.resolve();
              }, ye.destroy = function() {
                var Be = this;
                return new n(/* @__PURE__ */ function() {
                  var He = (0, u.default)(/* @__PURE__ */ l.default.mark(function Xe(ut) {
                    return l.default.wrap(function(Xt) {
                      for (; ; ) switch (Xt.prev = Xt.next) {
                        case 0:
                          Be.pipeline_ && Be.pipeline_.destroy(), Be.report({ variation: "Delete" }), ut();
                        case 1:
                        case "end":
                          return Xt.stop();
                      }
                    }, Xe);
                  }));
                  return function(Xe) {
                    return He.apply(this, arguments);
                  };
                }());
              }, ye.report = function(Be) {
                this.reporter_.send(Object.assign({ version: Ct, action: "MediaProcessor" }, Be));
              }, ot;
            }(Bt), Ia = /* @__PURE__ */ function() {
              function xe() {
                this.processor_ = null, this.generator_ = null;
              }
              var ot = xe.prototype;
              return ot.init = function(re) {
                return new n((Be, He) => {
                  try {
                    this.processor_ = new MediaStreamTrackProcessor(re);
                  } catch (Xe) {
                    console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${Xe}`), He(Xe);
                  }
                  try {
                    re.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "audio" }) : re.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "video" }) : He("kind not supported");
                  } catch (Xe) {
                    console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${Xe}`), He(Xe);
                  }
                  Be();
                });
              }, ot.getReadable = function() {
                return this.processor_.readable;
              }, ot.getWriteable = function() {
                return this.generator_.writable;
              }, ot.getProccesorTrack = function() {
                return this.generator_;
              }, xe;
            }(), wt = /* @__PURE__ */ function() {
              function xe(ye) {
                this.insertableStreamHelper_ = new Ia(), this.mediaProcessor_ = ye;
              }
              var ot = xe.prototype;
              return ot.setTrack = function(re) {
                return new n((Be, He) => {
                  this.insertableStreamHelper_.init(re).then(() => {
                    this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
                      Be(this.insertableStreamHelper_.getProccesorTrack());
                    }).catch((Xe) => {
                      He(Xe);
                    });
                  }).catch((Xe) => {
                    He(Xe);
                  });
                });
              }, ot.destroy = function() {
                return new n((re, Be) => {
                  this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
                    re();
                  }).catch((He) => {
                    Be(He);
                  }) : Be("no processor");
                });
              }, xe;
            }();
            const Yn = /* @__PURE__ */ new WeakMap(), kr = /* @__PURE__ */ new WeakMap(), mr = /* @__PURE__ */ new WeakMap(), yi = Symbol("anyProducer"), Or = n.resolve(), Ei = Symbol("listenerAdded"), Rt = Symbol("listenerRemoved");
            let ln = !1, tt = !1;
            function Oe(xe) {
              if (typeof xe != "string" && typeof xe != "symbol" && typeof xe != "number")
                throw new TypeError("`eventName` must be a string, symbol, or number");
            }
            function Jt(xe) {
              if (typeof xe != "function")
                throw new TypeError("listener must be a function");
            }
            function St(xe, ot) {
              const ye = kr.get(xe);
              if (ye.has(ot))
                return ye.get(ot);
            }
            function Vt(xe, ot) {
              const ye = typeof ot == "string" || typeof ot == "symbol" || typeof ot == "number" ? ot : yi, re = mr.get(xe);
              if (re.has(ye))
                return re.get(ye);
            }
            function Et(xe, ot, ye) {
              const re = mr.get(xe);
              if (re.has(ot))
                for (var Be = f(re.get(ot)), He; !(He = Be()).done; )
                  He.value.enqueue(ye);
              if (re.has(yi)) {
                const ct = n.all([ot, ye]);
                for (var Xe = f(re.get(yi)), ut; !(ut = Xe()).done; )
                  ut.value.enqueue(ct);
              }
            }
            function Qn(xe, ot) {
              ot = Array.isArray(ot) ? ot : [ot];
              let ye = !1, re = () => {
              }, Be = [];
              const He = { enqueue(ct) {
                Be.push(ct), re();
              }, finish() {
                ye = !0, re();
              } };
              for (var Xe = f(ot), ut; !(ut = Xe()).done; ) {
                const ct = ut.value;
                let Xt = Vt(xe, ct);
                Xt || (Xt = /* @__PURE__ */ new Set(), mr.get(xe).set(ct, Xt)), Xt.add(He);
              }
              return { next() {
                var ct = this;
                return (0, u.default)(/* @__PURE__ */ l.default.mark(function Xt() {
                  return l.default.wrap(function(un) {
                    for (; ; ) switch (un.prev = un.next) {
                      case 0:
                        if (Be) {
                          un.next = 2;
                          break;
                        }
                        return un.abrupt("return", { done: !0 });
                      case 2:
                        if (Be.length !== 0) {
                          un.next = 9;
                          break;
                        }
                        if (!ye) {
                          un.next = 6;
                          break;
                        }
                        return Be = void 0, un.abrupt("return", ct.next());
                      case 6:
                        return un.next = 8, new n((vt) => {
                          re = vt;
                        });
                      case 8:
                        return un.abrupt("return", ct.next());
                      case 9:
                        return un.next = 11, Be.shift();
                      case 11:
                        return un.t0 = un.sent, un.abrupt("return", { done: !1, value: un.t0 });
                      case 13:
                      case "end":
                        return un.stop();
                    }
                  }, Xt);
                }))();
              }, return(ct) {
                var Xt = arguments;
                return (0, u.default)(/* @__PURE__ */ l.default.mark(function pn() {
                  var un, vt, gr, sr, an;
                  return l.default.wrap(function(fn) {
                    for (; ; ) switch (fn.prev = fn.next) {
                      case 0:
                        for (Be = void 0, un = f(ot); !(vt = un()).done; )
                          gr = vt.value, sr = Vt(xe, gr), sr && (sr.delete(He), sr.size === 0 && (an = mr.get(xe), an.delete(gr)));
                        if (re(), !(Xt.length > 0)) {
                          fn.next = 10;
                          break;
                        }
                        return fn.next = 6, ct;
                      case 6:
                        fn.t1 = fn.sent, fn.t0 = { done: !0, value: fn.t1 }, fn.next = 11;
                        break;
                      case 10:
                        fn.t0 = { done: !0 };
                      case 11:
                        return fn.abrupt("return", fn.t0);
                      case 12:
                      case "end":
                        return fn.stop();
                    }
                  }, pn);
                }))();
              }, [Symbol.asyncIterator]() {
                return this;
              } };
            }
            function gn(xe) {
              if (xe === void 0)
                return ui;
              if (!Array.isArray(xe))
                throw new TypeError("`methodNames` must be an array of strings");
              for (var ot = f(xe), ye; !(ye = ot()).done; ) {
                const re = ye.value;
                if (!ui.includes(re))
                  throw typeof re != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${re} is not Emittery method`);
              }
              return xe;
            }
            const jt = (xe) => xe === Ei || xe === Rt;
            function On(xe, ot, ye) {
              if (jt(ot))
                try {
                  ln = !0, xe.emit(ot, ye);
                } finally {
                  ln = !1;
                }
            }
            let Ar = /* @__PURE__ */ function() {
              xe.mixin = function(re, Be) {
                return Be = gn(Be), (He) => {
                  if (typeof He != "function")
                    throw new TypeError("`target` must be function");
                  for (var Xe = f(Be), ut; !(ut = Xe()).done; ) {
                    const vt = ut.value;
                    if (He.prototype[vt] !== void 0)
                      throw new Error(`The property \`${vt}\` already exists on \`target\``);
                  }
                  function ct() {
                    return Object.defineProperty(this, re, { enumerable: !1, value: new xe() }), this[re];
                  }
                  Object.defineProperty(He.prototype, re, { enumerable: !1, get: ct });
                  const Xt = (vt) => function() {
                    return this[re][vt](...arguments);
                  };
                  for (var pn = f(Be), un; !(un = pn()).done; ) {
                    const vt = un.value;
                    Object.defineProperty(He.prototype, vt, { enumerable: !1, value: Xt(vt) });
                  }
                  return He;
                };
              };
              function xe(ye) {
                var re;
                ye === void 0 && (ye = {}), Yn.set(this, /* @__PURE__ */ new Set()), kr.set(this, /* @__PURE__ */ new Map()), mr.set(this, /* @__PURE__ */ new Map()), mr.get(this).set(yi, /* @__PURE__ */ new Set()), this.debug = (re = ye.debug) != null ? re : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (Be, He, Xe, ut) => {
                  try {
                    ut = JSON.stringify(ut);
                  } catch {
                    ut = `Object with the following keys failed to stringify: ${Object.keys(ut).join(",")}`;
                  }
                  (typeof Xe == "symbol" || typeof Xe == "number") && (Xe = Xe.toString());
                  const ct = /* @__PURE__ */ new Date(), Xt = `${ct.getHours()}:${ct.getMinutes()}:${ct.getSeconds()}.${ct.getMilliseconds()}`;
                  console.log(`[${Xt}][emittery:${Be}][${He}] Event Name: ${Xe}
	data: ${ut}`);
                });
              }
              var ot = xe.prototype;
              return ot.logIfDebugEnabled = function(re, Be, He) {
                (xe.isDebugEnabled || this.debug.enabled) && this.debug.logger(re, this.debug.name, Be, He);
              }, ot.on = function(re, Be) {
                Jt(Be), re = Array.isArray(re) ? re : [re];
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  Oe(ut);
                  let ct = St(this, ut);
                  ct || (ct = /* @__PURE__ */ new Set(), kr.get(this).set(ut, ct)), ct.add(Be), this.logIfDebugEnabled("subscribe", ut, void 0), jt(ut) || On(this, Ei, { eventName: ut, listener: Be });
                }
                return this.off.bind(this, re, Be);
              }, ot.off = function(re, Be) {
                Jt(Be), re = Array.isArray(re) ? re : [re];
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  Oe(ut);
                  const ct = St(this, ut);
                  ct && (ct.delete(Be), ct.size === 0 && kr.get(this).delete(ut)), this.logIfDebugEnabled("unsubscribe", ut, void 0), jt(ut) || On(this, Rt, { eventName: ut, listener: Be });
                }
              }, ot.once = function(re) {
                let Be;
                const He = new n((Xe) => {
                  Be = this.on(re, (ut) => {
                    Be(), Xe(ut);
                  });
                });
                return He.off = Be, He;
              }, ot.events = function(re) {
                re = Array.isArray(re) ? re : [re];
                for (var Be = f(re), He; !(He = Be()).done; ) {
                  const Xe = He.value;
                  Oe(Xe);
                }
                return Qn(this, re);
              }, ot.emit = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn, un;
                  return l.default.wrap(function(gr) {
                    for (; ; ) switch (gr.prev = gr.next) {
                      case 0:
                        if (Oe(He), !(jt(He) && !ln)) {
                          gr.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emit", He, Xe), Et(this, He, Xe), ct = (ut = St(this, He)) != null ? ut : /* @__PURE__ */ new Set(), Xt = Yn.get(this), pn = [...ct], un = jt(He) ? [] : [...Xt], gr.next = 11, Or;
                      case 11:
                        return gr.next = 13, n.all([...pn.map(/* @__PURE__ */ function() {
                          var sr = (0, u.default)(/* @__PURE__ */ l.default.mark(function an(En) {
                            return l.default.wrap(function(Fr) {
                              for (; ; ) switch (Fr.prev = Fr.next) {
                                case 0:
                                  if (!ct.has(En)) {
                                    Fr.next = 2;
                                    break;
                                  }
                                  return Fr.abrupt("return", En(Xe));
                                case 2:
                                case "end":
                                  return Fr.stop();
                              }
                            }, an);
                          }));
                          return function(an) {
                            return sr.apply(this, arguments);
                          };
                        }()), ...un.map(/* @__PURE__ */ function() {
                          var sr = (0, u.default)(/* @__PURE__ */ l.default.mark(function an(En) {
                            return l.default.wrap(function(Fr) {
                              for (; ; ) switch (Fr.prev = Fr.next) {
                                case 0:
                                  if (!Xt.has(En)) {
                                    Fr.next = 2;
                                    break;
                                  }
                                  return Fr.abrupt("return", En(He, Xe));
                                case 2:
                                case "end":
                                  return Fr.stop();
                              }
                            }, an);
                          }));
                          return function(an) {
                            return sr.apply(this, arguments);
                          };
                        }())]);
                      case 13:
                      case "end":
                        return gr.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.emitSerial = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn, un, vt, gr, sr, an, En;
                  return l.default.wrap(function(Fr) {
                    for (; ; ) switch (Fr.prev = Fr.next) {
                      case 0:
                        if (Oe(He), !(jt(He) && !ln)) {
                          Fr.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emitSerial", He, Xe), ct = (ut = St(this, He)) != null ? ut : /* @__PURE__ */ new Set(), Xt = Yn.get(this), pn = [...ct], un = [...Xt], Fr.next = 10, Or;
                      case 10:
                        vt = 0, gr = pn;
                      case 11:
                        if (!(vt < gr.length)) {
                          Fr.next = 19;
                          break;
                        }
                        if (sr = gr[vt], !ct.has(sr)) {
                          Fr.next = 16;
                          break;
                        }
                        return Fr.next = 16, sr(Xe);
                      case 16:
                        vt++, Fr.next = 11;
                        break;
                      case 19:
                        an = 0, En = un;
                      case 20:
                        if (!(an < En.length)) {
                          Fr.next = 28;
                          break;
                        }
                        if (sr = En[an], !Xt.has(sr)) {
                          Fr.next = 25;
                          break;
                        }
                        return Fr.next = 25, sr(He, Xe);
                      case 25:
                        an++, Fr.next = 20;
                        break;
                      case 28:
                      case "end":
                        return Fr.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.onAny = function(re) {
                return Jt(re), this.logIfDebugEnabled("subscribeAny", void 0, void 0), Yn.get(this).add(re), On(this, Ei, { listener: re }), this.offAny.bind(this, re);
              }, ot.anyEvent = function() {
                return Qn(this);
              }, ot.offAny = function(re) {
                Jt(re), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), On(this, Rt, { listener: re }), Yn.get(this).delete(re);
              }, ot.clearListeners = function(re) {
                re = Array.isArray(re) ? re : [re];
                for (var Be = f(re), He; !(He = Be()).done; ) {
                  const sr = He.value;
                  if (this.logIfDebugEnabled("clear", sr, void 0), typeof sr == "string" || typeof sr == "symbol" || typeof sr == "number") {
                    const an = St(this, sr);
                    an && an.clear();
                    const En = Vt(this, sr);
                    if (En) {
                      for (var Xe = f(En), ut; !(ut = Xe()).done; )
                        ut.value.finish();
                      En.clear();
                    }
                  } else {
                    Yn.get(this).clear();
                    for (var ct = f(kr.get(this).entries()), Xt; !(Xt = ct()).done; ) {
                      const an = Xt.value, En = an[0];
                      an[1].clear(), kr.get(this).delete(En);
                    }
                    for (var pn = f(mr.get(this).entries()), un; !(un = pn()).done; ) {
                      const an = un.value, En = an[0], fn = an[1];
                      for (var vt = f(fn), gr; !(gr = vt()).done; )
                        gr.value.finish();
                      fn.clear(), mr.get(this).delete(En);
                    }
                  }
                }
              }, ot.listenerCount = function(re) {
                re = Array.isArray(re) ? re : [re];
                let Be = 0;
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const fn = Xe.value;
                  if (typeof fn == "string") {
                    var ut, ct, Xt, pn, un, vt;
                    Be += Yn.get(this).size + ((ut = (ct = St(this, fn)) == null ? void 0 : ct.size) != null ? ut : 0) + ((Xt = (pn = Vt(this, fn)) == null ? void 0 : pn.size) != null ? Xt : 0) + ((un = (vt = Vt(this)) == null ? void 0 : vt.size) != null ? un : 0);
                    continue;
                  }
                  typeof fn != "undefined" && Oe(fn), Be += Yn.get(this).size;
                  for (var gr = f(kr.get(this).values()), sr; !(sr = gr()).done; ) {
                    const Fr = sr.value;
                    Be += Fr.size;
                  }
                  for (var an = f(mr.get(this).values()), En; !(En = an()).done; ) {
                    const Fr = En.value;
                    Be += Fr.size;
                  }
                }
                return Be;
              }, ot.bindMethods = function(re, Be) {
                if (typeof re != "object" || re === null)
                  throw new TypeError("`target` must be an object");
                Be = gn(Be);
                for (var He = f(Be), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  if (re[ut] !== void 0)
                    throw new Error(`The property \`${ut}\` already exists on \`target\``);
                  Object.defineProperty(re, ut, { enumerable: !1, value: this[ut].bind(this) });
                }
              }, (0, d.default)(xe, null, [{ key: "isDebugEnabled", get: function() {
                var re, Be;
                if (typeof ((re = g.process) == null ? void 0 : re.env) != "object")
                  return tt;
                const He = (Be = g.process) != null ? Be : { env: {} }, Xe = He.env;
                return Xe.DEBUG === "emittery" || Xe.DEBUG === "*" || tt;
              }, set: function(re) {
                tt = re;
              } }]), xe;
            }();
            const ui = Object.getOwnPropertyNames(Ar.prototype).filter((xe) => xe !== "constructor");
            Object.defineProperty(Ar, "listenerAdded", { value: Ei, writable: !1, enumerable: !0, configurable: !1 }), Object.defineProperty(Ar, "listenerRemoved", { value: Rt, writable: !1, enumerable: !0, configurable: !1 });
            const fr = "1.0.0";
            let Jn = /* @__PURE__ */ function() {
              function xe(ye) {
                this.size = ye, this.values = [], this.sum = 0;
              }
              var ot = xe.prototype;
              return ot.push = function(re) {
                for (this.values.push(re), this.sum += re; this.size < this.values.length; ) {
                  var Be;
                  this.sum -= (Be = this.values.shift()) != null ? Be : 0;
                }
              }, ot.value = function() {
                return this.sum / Math.max(1, this.values.length);
              }, xe;
            }();
            const Qr = `https://d3opqjmqzxf057.cloudfront.net/noise-suppression/${fr}`;
            let ti = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot() {
                var re;
                return re = xe.call(this) || this, re.isEnabled = !0, re.internalResampleSupported = !1, re.latency = new Jn(100), re.transform = re.transformAudioData.bind((0, c.default)(re)), re;
              }
              var ye = ot.prototype;
              return ye.init = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  var ut, ct, Xt, pn, un, vt, gr, sr, an, En;
                  return l.default.wrap(function(Fr) {
                    for (; ; ) switch (Fr.prev = Fr.next) {
                      case 0:
                        return Xe === void 0 && (Xe = {}), console.log("Noise suppression transformer initialization"), this.transform = Xe.debug ? this.transformDebug.bind(this) : this.transformAudioData.bind(this), Xt = (ut = Xe.assetsDirBaseUrl) != null ? ut : Qr, pn = (Ro) => `${Xt}/${Ro}`, un = 1, Fr.next = 8, this.isMonoThread(Xe);
                      case 8:
                        if (!Fr.sent) {
                          Fr.next = 14;
                          break;
                        }
                        return Fr.next = 11, b({ locateFile: pn, mainScriptUrlOrBlob: pn("main-bin-mono.js") });
                      case 11:
                        this.wasmInstance = Fr.sent, Fr.next = 18;
                        break;
                      case 14:
                        return Fr.next = 16, y({ locateFile: pn, mainScriptUrlOrBlob: pn("main-bin-multi.js") });
                      case 16:
                        this.wasmInstance = Fr.sent, un = 4;
                      case 18:
                        return this.wasmTransformer = new this.wasmInstance.DtlnTransformer(), Fr.next = 21, n.all([this.loadModel(`${Xt}/model_1.tflite`, 1), this.loadModel(`${Xt}/model_2.tflite`, 2)]);
                      case 21:
                        return Fr.prev = 21, Fr.next = 24, (gr = this.wasmTransformer) == null ? void 0 : gr.init(un);
                      case 24:
                        vt = Fr.sent, Fr.next = 30;
                        break;
                      case 27:
                        if (Fr.prev = 27, Fr.t0 = Fr.catch(21), typeof Fr.t0 == "number") {
                          for (sr = "", an = 0; an < 500; ++an)
                            sr += String.fromCharCode(this.wasmInstance.HEAP8[Fr.t0 + an]);
                          console.error(sr);
                        } else
                          console.error(Fr.t0);
                      case 30:
                        if (vt === 0) {
                          Fr.next = 34;
                          break;
                        }
                        throw sr = `Fail to init wasm transformer, error code = ${vt}`, console.error(sr), sr;
                      case 34:
                        if (this.internalResampleSupported = (ct = this.wasmTransformer) == null ? void 0 : ct.getInternalResampleSupported(), this.internalResampleSupported) {
                          Fr.next = 39;
                          break;
                        }
                        throw sr = "Internal resampling not supported", console.error(sr), sr;
                      case 39:
                        Xe.debug && ((En = this.wasmTransformer) == null || En.enableWavExport()), console.log("Noise suppression transformer ready");
                      case 41:
                      case "end":
                        return Fr.stop();
                    }
                  }, He, this, [[21, 27]]);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getWav = function() {
                if (!this.wasmTransformer)
                  return "";
                this.wasmTransformer.closeWav();
                const Be = this.wasmTransformer.getWav();
                return `data:audio/wav;base64,${btoa(new Uint8Array(Be).reduce((Xe, ut) => Xe + String.fromCharCode(ut), ""))}`;
              }, ye.setAudioOptions = function(Be, He, Xe, ut, ct) {
                var Xt;
                (Xt = this.wasmTransformer) == null || Xt.setAudioOptions(Be, He, Xe, ut, ct);
              }, ye.enable = function() {
                this.isEnabled = !0;
              }, ye.disable = function() {
                this.isEnabled = !1;
              }, ye.getLatency = function() {
                return this.latency.value();
              }, ye.getWasmLatencyNs = function() {
                var Be, He;
                return (Be = (He = this.wasmTransformer) == null ? void 0 : He.getLatencyNs()) != null ? Be : 0;
              }, ye.transformDebug = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut) {
                  var ct;
                  return l.default.wrap(function(pn) {
                    for (; ; ) switch (pn.prev = pn.next) {
                      case 0:
                        return pn.prev = 0, ct = performance.now(), pn.next = 4, this.transformAudioData(Xe, ut);
                      case 4:
                        this.latency.push(performance.now() - ct), pn.next = 10;
                        break;
                      case 7:
                        pn.prev = 7, pn.t0 = pn.catch(0), console.error(pn.t0);
                      case 10:
                      case "end":
                        return pn.stop();
                    }
                  }, He, this, [[0, 7]]);
                }));
                function Be(He, Xe) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.transformAudioData = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut) {
                  var ct, Xt, pn, un, vt, gr, sr, an, En, fn, Fr, Ro;
                  return l.default.wrap(function(Co) {
                    for (; ; ) switch (Co.prev = Co.next) {
                      case 0:
                        if (this.wasmTransformer || this.emit("warning", "transformer not initialized"), this.isEnabled && this.wasmTransformer)
                          try {
                            ct = Xe, Xt = ct.numberOfFrames, pn = ct.sampleRate, un = ct.numberOfChannels, vt = ct.timestamp, gr = this.getAudioDataAsFloat32(Xe), sr = this.convertTypedArray(gr, Int16Array, Math.pow(2, 15) - 1), this.wasmTransformer.getInputFrame(sr.length).set(sr), an = 0;
                            try {
                              an = this.wasmTransformer.runAlgorithm(Xt, pn, un);
                            } catch (ga) {
                              if (typeof ga == "number") {
                                for (En = "", fn = 0; fn < 500; ++fn)
                                  En += String.fromCharCode(this.wasmInstance.HEAP8[ga + fn]);
                                console.error(En);
                              } else
                                console.error(ga);
                            }
                            an > 0 && (Fr = this.wasmTransformer.getOutputFrame().slice(0, an), Ro = this.convertTypedArray(Fr, Float32Array, 1 / (Math.pow(2, 15) - 1)), Xe = new AudioData({ data: Ro, format: "f32", numberOfChannels: un, numberOfFrames: Xt, sampleRate: pn, timestamp: vt }));
                          } catch (ga) {
                            console.error(ga);
                          }
                        ut.enqueue(Xe);
                      case 3:
                      case "end":
                        return Co.stop();
                    }
                  }, He, this);
                }));
                function Be(He, Xe) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.loadModel = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut) {
                  var ct, Xt, pn, un, vt, gr;
                  return l.default.wrap(function(an) {
                    for (; ; ) switch (an.prev = an.next) {
                      case 0:
                        if (this.wasmTransformer) {
                          an.next = 2;
                          break;
                        }
                        return an.abrupt("return");
                      case 2:
                        return an.next = 4, fetch(Xe);
                      case 4:
                        return ct = an.sent, an.next = 7, ct.arrayBuffer();
                      case 7:
                        Xt = an.sent, pn = Xt.byteLength, un = `getModel${ut}`, vt = this.wasmTransformer[un](pn), vt && (gr = new Uint8Array(Xt), vt.set(gr));
                      case 12:
                      case "end":
                        return an.stop();
                    }
                  }, He, this);
                }));
                function Be(He, Xe) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getAudioDataAsFloat32 = function(Be) {
                return this.audioDataToTypedArray(Be, Float32Array, "f32-planar");
              }, ye.audioDataToTypedArray = function(Be, He, Xe, ut) {
                ut === void 0 && (ut = Be.numberOfChannels);
                const ct = Be.numberOfFrames * ut, Xt = new He(ct);
                for (let pn = 0; pn < ut; ++pn) {
                  const un = Be.numberOfFrames * pn, vt = Xt.subarray(un, un + Be.numberOfFrames);
                  Be.copyTo(vt, { planeIndex: pn, format: Xe });
                }
                if (ut > 1) {
                  const pn = new He(ct);
                  for (let un = 0; un < Be.numberOfFrames; ++un) {
                    const vt = un * 2;
                    for (let gr = 0; gr < ut; ++gr)
                      pn[vt + gr] = Xt[un + gr * Be.numberOfFrames];
                  }
                  return pn;
                }
                return Xt;
              }, ye.convertTypedArray = function(Be, He, Xe) {
                const ut = Be.length, ct = new He(ut);
                for (let Xt = 0; Xt < ut; ++Xt)
                  ct[Xt] = Be[Xt] * Xe;
                return ct;
              }, ye.isMonoThread = function(Be) {
                if (Be.disableWasmMultiThread)
                  return !0;
                try {
                  if (new SharedArrayBuffer(1024) === void 0)
                    throw new Error("not supported");
                } catch {
                  return this.emit("warning", `
Multithread is not available, noise-suppresion is now running on a single thread.
This is impacting the performance and increase the latency.

To enable multithread, you need to serve the application via https with these http headers :
   - Cross-Origin-Opener-Policy: same-origin
   - Cross-Origin-Embedder-Policy: require-corp.
More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer#security_requirements

You can disable this warning by enabling disableWasmMultiThread within the noiseSuppression options.
`), !0;
                }
                return !1;
              }, ot;
            }(Ar);
            r.NoiseSuppressionTransformer = ti;
            function Wn(xe, ot) {
              g.vonage || (g.vonage = {}), g.vonage.workerizer || (g.vonage.workerizer = {});
              let ye = g.vonage.workerizer;
              return ye[xe] || (ye[xe] = ot), ye[xe];
            }
            const Hi = Wn("globals", {});
            var Ho = /* @__PURE__ */ ((xe) => (xe.INIT = "INIT", xe.FORWARD = "FORWARD", xe.TERMINATE = "TERMINATE", xe.GLOBALS_SYNC = "GLOBALS_SYNC", xe.EVENT = "EVENT", xe))(Ho || {});
            function Ea(xe) {
              return [ImageBitmap, ReadableStream, WritableStream].some((ye) => xe instanceof ye);
            }
            let Ga = 0;
            function No(xe, ot, ye, re, Be) {
              const He = Ga++;
              return xe.postMessage({ id: He, type: ot, functionName: ye, args: re }, re.filter((ut) => Ea(ut))), new n((ut) => {
                Be == null || Be.set(He, ut);
              });
            }
            function Ba(xe, ot) {
              const ye = xe.id, re = xe.type, Be = Array.isArray(ot) ? ot : [ot];
              postMessage({ id: ye, type: re, result: ot }, Be.filter((He) => Ea(He)));
            }
            const Ra = Wn("workerized", {});
            function us() {
              return typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope;
            }
            function so() {
              return Va.apply(this, arguments);
            }
            function Va() {
              return Va = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe() {
                var ot, ye, re, Be, He;
                return l.default.wrap(function(ut) {
                  for (; ; ) switch (ut.prev = ut.next) {
                    case 0:
                      if (!us()) {
                        ut.next = 4;
                        break;
                      }
                      Ba({ type: Ho.GLOBALS_SYNC }, Hi), ut.next = 8;
                      break;
                    case 4:
                      ot = [];
                      for (ye in Ra)
                        re = Ra[ye].workerContext, Be = re.worker, He = re.resolvers, Be && ot.push(No(Be, Ho.GLOBALS_SYNC, "", [Hi], He));
                      return ut.next = 8, n.all(ot);
                    case 8:
                    case "end":
                      return ut.stop();
                  }
                }, xe);
              })), Va.apply(this, arguments);
            }
            function qa(xe, ot) {
              if (Array.isArray(ot))
                ot.splice(0, ot.length);
              else if (typeof ot == "object")
                for (const ye in ot)
                  delete ot[ye];
              for (const ye in xe)
                Array.isArray(xe[ye]) ? (ot[ye] = [], qa(xe[ye], ot[ye])) : typeof xe[ye] == "object" ? (ot[ye] = {}, qa(xe[ye], ot[ye])) : ot[ye] = xe[ye];
            }
            function hs(xe, ot, ye, re) {
              return oi.apply(this, arguments);
            }
            function oi() {
              return oi = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye, re, Be) {
                var He, Xe;
                return l.default.wrap(function(ct) {
                  for (; ; ) switch (ct.prev = ct.next) {
                    case 0:
                      return He = new ye(), He.addEventListener("message", /* @__PURE__ */ function() {
                        var Xt = (0, u.default)(/* @__PURE__ */ l.default.mark(function pn(un) {
                          var vt, gr, sr, an, En, fn, Fr, Ro, ca, Co;
                          return l.default.wrap(function(aa) {
                            for (; ; ) switch (aa.prev = aa.next) {
                              case 0:
                                vt = un.data, aa.t0 = vt.type, aa.next = aa.t0 === Ho.GLOBALS_SYNC ? 4 : aa.t0 === Ho.EVENT ? 13 : 19;
                                break;
                              case 4:
                                if (!vt.id) {
                                  aa.next = 9;
                                  break;
                                }
                                (sr = re.get((gr = vt.id) != null ? gr : -1)) == null || sr(vt.result), re.delete((an = vt.id) != null ? an : -1), aa.next = 12;
                                break;
                              case 9:
                                return qa((En = vt.result) != null ? En : {}, Hi), aa.next = 12, so();
                              case 12:
                                return aa.abrupt("break", 21);
                              case 13:
                                if (ca = vt.result, Co = ca, (Co == null ? void 0 : Co.name) != null) {
                                  aa.next = 17;
                                  break;
                                }
                                throw "Missing event name";
                              case 17:
                                return Be(Co.name, Co.data), aa.abrupt("break", 21);
                              case 19:
                                (Fr = re.get((fn = vt.id) != null ? fn : -1)) == null || Fr(vt.result), re.delete((Ro = vt.id) != null ? Ro : -1);
                              case 21:
                              case "end":
                                return aa.stop();
                            }
                          }, pn);
                        }));
                        return function(pn) {
                          return Xt.apply(this, arguments);
                        };
                      }()), ct.next = 4, No(He, Ho.INIT, "", [ot.workerId, Hi], re);
                    case 4:
                      if (Xe = ct.sent, Xe) {
                        ct.next = 7;
                        break;
                      }
                      throw "Failed to instantiate workerized class";
                    case 7:
                      return ct.abrupt("return", He);
                    case 8:
                    case "end":
                      return ct.stop();
                  }
                }, xe);
              })), oi.apply(this, arguments);
            }
            const oa = /* @__PURE__ */ new WeakMap(), Wa = /* @__PURE__ */ new WeakMap(), Xa = /* @__PURE__ */ new WeakMap(), ya = Symbol("anyProducer"), Fl = n.resolve(), As = Symbol("listenerAdded"), gl = Symbol("listenerRemoved");
            let Vi = !1, zr = !1;
            function za(xe) {
              if (typeof xe != "string" && typeof xe != "symbol" && typeof xe != "number")
                throw new TypeError("`eventName` must be a string, symbol, or number");
            }
            function ws(xe) {
              if (typeof xe != "function")
                throw new TypeError("listener must be a function");
            }
            function Zi(xe, ot) {
              const ye = Wa.get(xe);
              if (ye.has(ot))
                return ye.get(ot);
            }
            function kl(xe, ot) {
              const ye = typeof ot == "string" || typeof ot == "symbol" || typeof ot == "number" ? ot : ya, re = Xa.get(xe);
              if (re.has(ye))
                return re.get(ye);
            }
            function vc(xe, ot, ye) {
              const re = Xa.get(xe);
              if (re.has(ot))
                for (var Be = f(re.get(ot)), He; !(He = Be()).done; )
                  He.value.enqueue(ye);
              if (re.has(ya)) {
                const ct = n.all([ot, ye]);
                for (var Xe = f(re.get(ya)), ut; !(ut = Xe()).done; )
                  ut.value.enqueue(ct);
              }
            }
            function wl(xe, ot) {
              ot = Array.isArray(ot) ? ot : [ot];
              let ye = !1, re = () => {
              }, Be = [];
              const He = { enqueue(ct) {
                Be.push(ct), re();
              }, finish() {
                ye = !0, re();
              } };
              for (var Xe = f(ot), ut; !(ut = Xe()).done; ) {
                const ct = ut.value;
                let Xt = kl(xe, ct);
                Xt || (Xt = /* @__PURE__ */ new Set(), Xa.get(xe).set(ct, Xt)), Xt.add(He);
              }
              return { next() {
                var ct = this;
                return (0, u.default)(/* @__PURE__ */ l.default.mark(function Xt() {
                  return l.default.wrap(function(un) {
                    for (; ; ) switch (un.prev = un.next) {
                      case 0:
                        if (Be) {
                          un.next = 2;
                          break;
                        }
                        return un.abrupt("return", { done: !0 });
                      case 2:
                        if (Be.length !== 0) {
                          un.next = 9;
                          break;
                        }
                        if (!ye) {
                          un.next = 6;
                          break;
                        }
                        return Be = void 0, un.abrupt("return", ct.next());
                      case 6:
                        return un.next = 8, new n((vt) => {
                          re = vt;
                        });
                      case 8:
                        return un.abrupt("return", ct.next());
                      case 9:
                        return un.next = 11, Be.shift();
                      case 11:
                        return un.t0 = un.sent, un.abrupt("return", { done: !1, value: un.t0 });
                      case 13:
                      case "end":
                        return un.stop();
                    }
                  }, Xt);
                }))();
              }, return(ct) {
                var Xt = arguments;
                return (0, u.default)(/* @__PURE__ */ l.default.mark(function pn() {
                  var un, vt, gr, sr, an;
                  return l.default.wrap(function(fn) {
                    for (; ; ) switch (fn.prev = fn.next) {
                      case 0:
                        for (Be = void 0, un = f(ot); !(vt = un()).done; )
                          gr = vt.value, sr = kl(xe, gr), sr && (sr.delete(He), sr.size === 0 && (an = Xa.get(xe), an.delete(gr)));
                        if (re(), !(Xt.length > 0)) {
                          fn.next = 10;
                          break;
                        }
                        return fn.next = 6, ct;
                      case 6:
                        fn.t1 = fn.sent, fn.t0 = { done: !0, value: fn.t1 }, fn.next = 11;
                        break;
                      case 10:
                        fn.t0 = { done: !0 };
                      case 11:
                        return fn.abrupt("return", fn.t0);
                      case 12:
                      case "end":
                        return fn.stop();
                    }
                  }, pn);
                }))();
              }, [Symbol.asyncIterator]() {
                return this;
              } };
            }
            function ys(xe) {
              if (xe === void 0)
                return hi;
              if (!Array.isArray(xe))
                throw new TypeError("`methodNames` must be an array of strings");
              for (var ot = f(xe), ye; !(ye = ot()).done; ) {
                const re = ye.value;
                if (!hi.includes(re))
                  throw typeof re != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${re} is not Emittery method`);
              }
              return xe;
            }
            const Xn = (xe) => xe === As || xe === gl;
            function Kn(xe, ot, ye) {
              if (Xn(ot))
                try {
                  Vi = !0, xe.emit(ot, ye);
                } finally {
                  Vi = !1;
                }
            }
            let pr = /* @__PURE__ */ function() {
              xe.mixin = function(re, Be) {
                return Be = ys(Be), (He) => {
                  if (typeof He != "function")
                    throw new TypeError("`target` must be function");
                  for (var Xe = f(Be), ut; !(ut = Xe()).done; ) {
                    const vt = ut.value;
                    if (He.prototype[vt] !== void 0)
                      throw new Error(`The property \`${vt}\` already exists on \`target\``);
                  }
                  function ct() {
                    return Object.defineProperty(this, re, { enumerable: !1, value: new xe() }), this[re];
                  }
                  Object.defineProperty(He.prototype, re, { enumerable: !1, get: ct });
                  const Xt = (vt) => function() {
                    return this[re][vt](...arguments);
                  };
                  for (var pn = f(Be), un; !(un = pn()).done; ) {
                    const vt = un.value;
                    Object.defineProperty(He.prototype, vt, { enumerable: !1, value: Xt(vt) });
                  }
                  return He;
                };
              };
              function xe(ye) {
                ye === void 0 && (ye = {});
                var re;
                oa.set(this, /* @__PURE__ */ new Set()), Wa.set(this, /* @__PURE__ */ new Map()), Xa.set(this, /* @__PURE__ */ new Map()), Xa.get(this).set(ya, /* @__PURE__ */ new Set()), this.debug = (re = ye.debug) != null ? re : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (Be, He, Xe, ut) => {
                  try {
                    ut = JSON.stringify(ut);
                  } catch {
                    ut = `Object with the following keys failed to stringify: ${Object.keys(ut).join(",")}`;
                  }
                  (typeof Xe == "symbol" || typeof Xe == "number") && (Xe = Xe.toString());
                  const ct = /* @__PURE__ */ new Date(), Xt = `${ct.getHours()}:${ct.getMinutes()}:${ct.getSeconds()}.${ct.getMilliseconds()}`;
                  console.log(`[${Xt}][emittery:${Be}][${He}] Event Name: ${Xe}
	data: ${ut}`);
                });
              }
              var ot = xe.prototype;
              return ot.logIfDebugEnabled = function(re, Be, He) {
                (xe.isDebugEnabled || this.debug.enabled) && this.debug.logger(re, this.debug.name, Be, He);
              }, ot.on = function(re, Be) {
                ws(Be), re = Array.isArray(re) ? re : [re];
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  za(ut);
                  let ct = Zi(this, ut);
                  ct || (ct = /* @__PURE__ */ new Set(), Wa.get(this).set(ut, ct)), ct.add(Be), this.logIfDebugEnabled("subscribe", ut, void 0), Xn(ut) || Kn(this, As, { eventName: ut, listener: Be });
                }
                return this.off.bind(this, re, Be);
              }, ot.off = function(re, Be) {
                ws(Be), re = Array.isArray(re) ? re : [re];
                for (var He = f(re), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  za(ut);
                  const ct = Zi(this, ut);
                  ct && (ct.delete(Be), ct.size === 0 && Wa.get(this).delete(ut)), this.logIfDebugEnabled("unsubscribe", ut, void 0), Xn(ut) || Kn(this, gl, { eventName: ut, listener: Be });
                }
              }, ot.once = function(re) {
                let Be;
                const He = new n((Xe) => {
                  Be = this.on(re, (ut) => {
                    Be(), Xe(ut);
                  });
                });
                return He.off = Be, He;
              }, ot.events = function(re) {
                re = Array.isArray(re) ? re : [re];
                for (var Be = f(re), He; !(He = Be()).done; ) {
                  const Xe = He.value;
                  za(Xe);
                }
                return wl(this, re);
              }, ot.emit = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn, un;
                  return l.default.wrap(function(gr) {
                    for (; ; ) switch (gr.prev = gr.next) {
                      case 0:
                        if (za(He), !(Xn(He) && !Vi)) {
                          gr.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emit", He, Xe), vc(this, He, Xe), ct = (ut = Zi(this, He)) != null ? ut : /* @__PURE__ */ new Set(), Xt = oa.get(this), pn = [...ct], un = Xn(He) ? [] : [...Xt], gr.next = 11, Fl;
                      case 11:
                        return gr.next = 13, n.all([...pn.map(/* @__PURE__ */ function() {
                          var sr = (0, u.default)(/* @__PURE__ */ l.default.mark(function an(En) {
                            return l.default.wrap(function(Fr) {
                              for (; ; ) switch (Fr.prev = Fr.next) {
                                case 0:
                                  if (!ct.has(En)) {
                                    Fr.next = 2;
                                    break;
                                  }
                                  return Fr.abrupt("return", En(Xe));
                                case 2:
                                case "end":
                                  return Fr.stop();
                              }
                            }, an);
                          }));
                          return function(an) {
                            return sr.apply(this, arguments);
                          };
                        }()), ...un.map(/* @__PURE__ */ function() {
                          var sr = (0, u.default)(/* @__PURE__ */ l.default.mark(function an(En) {
                            return l.default.wrap(function(Fr) {
                              for (; ; ) switch (Fr.prev = Fr.next) {
                                case 0:
                                  if (!Xt.has(En)) {
                                    Fr.next = 2;
                                    break;
                                  }
                                  return Fr.abrupt("return", En(He, Xe));
                                case 2:
                                case "end":
                                  return Fr.stop();
                              }
                            }, an);
                          }));
                          return function(an) {
                            return sr.apply(this, arguments);
                          };
                        }())]);
                      case 13:
                      case "end":
                        return gr.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.emitSerial = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He, Xe) {
                  var ut, ct, Xt, pn, un, vt, gr, sr, an, En;
                  return l.default.wrap(function(Fr) {
                    for (; ; ) switch (Fr.prev = Fr.next) {
                      case 0:
                        if (za(He), !(Xn(He) && !Vi)) {
                          Fr.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emitSerial", He, Xe), ct = (ut = Zi(this, He)) != null ? ut : /* @__PURE__ */ new Set(), Xt = oa.get(this), pn = [...ct], un = [...Xt], Fr.next = 10, Fl;
                      case 10:
                        vt = 0, gr = pn;
                      case 11:
                        if (!(vt < gr.length)) {
                          Fr.next = 19;
                          break;
                        }
                        if (sr = gr[vt], !ct.has(sr)) {
                          Fr.next = 16;
                          break;
                        }
                        return Fr.next = 16, sr(Xe);
                      case 16:
                        vt++, Fr.next = 11;
                        break;
                      case 19:
                        an = 0, En = un;
                      case 20:
                        if (!(an < En.length)) {
                          Fr.next = 28;
                          break;
                        }
                        if (sr = En[an], !Xt.has(sr)) {
                          Fr.next = 25;
                          break;
                        }
                        return Fr.next = 25, sr(He, Xe);
                      case 25:
                        an++, Fr.next = 20;
                        break;
                      case 28:
                      case "end":
                        return Fr.stop();
                    }
                  }, Be, this);
                }));
                function re(Be, He) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.onAny = function(re) {
                return ws(re), this.logIfDebugEnabled("subscribeAny", void 0, void 0), oa.get(this).add(re), Kn(this, As, { listener: re }), this.offAny.bind(this, re);
              }, ot.anyEvent = function() {
                return wl(this);
              }, ot.offAny = function(re) {
                ws(re), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), Kn(this, gl, { listener: re }), oa.get(this).delete(re);
              }, ot.clearListeners = function(re) {
                re = Array.isArray(re) ? re : [re];
                for (var Be = f(re), He; !(He = Be()).done; ) {
                  const sr = He.value;
                  if (this.logIfDebugEnabled("clear", sr, void 0), typeof sr == "string" || typeof sr == "symbol" || typeof sr == "number") {
                    const an = Zi(this, sr);
                    an && an.clear();
                    const En = kl(this, sr);
                    if (En) {
                      for (var Xe = f(En), ut; !(ut = Xe()).done; )
                        ut.value.finish();
                      En.clear();
                    }
                  } else {
                    oa.get(this).clear();
                    for (var ct = f(Wa.get(this).entries()), Xt; !(Xt = ct()).done; ) {
                      const an = Xt.value, En = an[0];
                      an[1].clear(), Wa.get(this).delete(En);
                    }
                    for (var pn = f(Xa.get(this).entries()), un; !(un = pn()).done; ) {
                      const an = un.value, En = an[0], fn = an[1];
                      for (var vt = f(fn), gr; !(gr = vt()).done; )
                        gr.value.finish();
                      fn.clear(), Xa.get(this).delete(En);
                    }
                  }
                }
              }, ot.listenerCount = function(re) {
                var Be, He, Xe, ut, ct, Xt;
                re = Array.isArray(re) ? re : [re];
                let pn = 0;
                for (var un = f(re), vt; !(vt = un()).done; ) {
                  const fn = vt.value;
                  if (typeof fn == "string") {
                    pn += oa.get(this).size + ((He = (Be = Zi(this, fn)) == null ? void 0 : Be.size) != null ? He : 0) + ((ut = (Xe = kl(this, fn)) == null ? void 0 : Xe.size) != null ? ut : 0) + ((Xt = (ct = kl(this)) == null ? void 0 : ct.size) != null ? Xt : 0);
                    continue;
                  }
                  typeof fn != "undefined" && za(fn), pn += oa.get(this).size;
                  for (var gr = f(Wa.get(this).values()), sr; !(sr = gr()).done; ) {
                    const Fr = sr.value;
                    pn += Fr.size;
                  }
                  for (var an = f(Xa.get(this).values()), En; !(En = an()).done; ) {
                    const Fr = En.value;
                    pn += Fr.size;
                  }
                }
                return pn;
              }, ot.bindMethods = function(re, Be) {
                if (typeof re != "object" || re === null)
                  throw new TypeError("`target` must be an object");
                Be = ys(Be);
                for (var He = f(Be), Xe; !(Xe = He()).done; ) {
                  const ut = Xe.value;
                  if (re[ut] !== void 0)
                    throw new Error(`The property \`${ut}\` already exists on \`target\``);
                  Object.defineProperty(re, ut, { enumerable: !1, value: this[ut].bind(this) });
                }
              }, (0, d.default)(xe, null, [{ key: "isDebugEnabled", get: function() {
                var re, Be;
                if (typeof ((re = g.process) == null ? void 0 : re.env) != "object")
                  return zr;
                const He = (Be = g.process) != null ? Be : { env: {} }, Xe = He.env;
                return Xe.DEBUG === "emittery" || Xe.DEBUG === "*" || zr;
              }, set: function(re) {
                zr = re;
              } }]), xe;
            }();
            const hi = Object.getOwnPropertyNames(pr.prototype).filter((xe) => xe !== "constructor");
            Object.defineProperty(pr, "listenerAdded", { value: As, writable: !1, enumerable: !0, configurable: !1 }), Object.defineProperty(pr, "listenerRemoved", { value: gl, writable: !1, enumerable: !0, configurable: !1 });
            function Qi(xe) {
              return xe.onAny && xe.emit;
            }
            function qt(xe) {
              return xe.prototype.onAny && xe.prototype.emit;
            }
            let bn = 0;
            function hn(xe, ot, ye) {
              return xn.apply(this, arguments);
            }
            function xn() {
              return xn = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye, re) {
                var Be, He, Xe;
                return l.default.wrap(function(ct) {
                  for (; ; ) switch (ct.prev = ct.next) {
                    case 0:
                      return Be = qt(ot), He = Be ? new pr() : {}, Xe = bn++, Object.getOwnPropertyNames(ot.prototype).forEach((Xt) => {
                        He[Xt] = function() {
                          for (var pn = arguments.length, un = new Array(pn), vt = 0; vt < pn; vt++)
                            un[vt] = arguments[vt];
                          return No(ye, Ho.FORWARD, Xt, un, re);
                        };
                      }), He.terminate = /* @__PURE__ */ (0, u.default)(/* @__PURE__ */ l.default.mark(function Xt() {
                        var pn, un, vt, gr, sr = arguments;
                        return l.default.wrap(function(En) {
                          for (; ; ) switch (En.prev = En.next) {
                            case 0:
                              for (pn = sr.length, un = new Array(pn), vt = 0; vt < pn; vt++)
                                un[vt] = sr[vt];
                              return En.next = 3, No(ye, Ho.TERMINATE, "", un, re);
                            case 3:
                              return gr = En.sent, delete Ra[Xe], ye.terminate(), He.workerContext.worker = void 0, En.abrupt("return", gr);
                            case 8:
                            case "end":
                              return En.stop();
                          }
                        }, Xt);
                      })), He.workerContext = { id: Xe, worker: ye, resolvers: re }, Ra[Xe] = He, ct.abrupt("return", He);
                    case 8:
                    case "end":
                      return ct.stop();
                  }
                }, xe);
              })), xn.apply(this, arguments);
            }
            function vr(xe, ot) {
              return Rr.apply(this, arguments);
            }
            function Rr() {
              return Rr = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye) {
                var re, Be, He;
                return l.default.wrap(function(ut) {
                  for (; ; ) switch (ut.prev = ut.next) {
                    case 0:
                      return re = /* @__PURE__ */ new Map(), ut.next = 3, hs(ot, ye, re, (ct, Xt) => {
                        Be != null && Be.emit && (Be == null || Be.emit(ct, Xt));
                      });
                    case 3:
                      return He = ut.sent, ut.next = 6, hn(ot, He, re);
                    case 6:
                      return Be = ut.sent, ut.abrupt("return", Be);
                    case 8:
                    case "end":
                      return ut.stop();
                  }
                }, xe);
              })), Rr.apply(this, arguments);
            }
            function zi(xe, ot) {
              return _i.apply(this, arguments);
            }
            function _i() {
              return _i = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye) {
                var re, Be;
                return l.default.wrap(function(Xe) {
                  for (; ; ) switch (Xe.prev = Xe.next) {
                    case 0:
                      if (re = ot.functionName, Be = ot.args, ye.instance) {
                        Xe.next = 3;
                        break;
                      }
                      throw "instance not initialized";
                    case 3:
                      if (re) {
                        Xe.next = 5;
                        break;
                      }
                      throw "missing function name to call";
                    case 5:
                      if (ye.instance[re]) {
                        Xe.next = 7;
                        break;
                      }
                      throw `undefined function [${re}] in class ${ye.instance.constructor.workerId}`;
                    case 7:
                      return Xe.t0 = Ba, Xe.t1 = ot, Xe.next = 11, ye.instance[re](...Be != null ? Be : []);
                    case 11:
                      Xe.t2 = Xe.sent, (0, Xe.t0)(Xe.t1, Xe.t2);
                    case 13:
                    case "end":
                      return Xe.stop();
                  }
                }, xe);
              })), _i.apply(this, arguments);
            }
            const Ko = Wn("registeredWorkers", {});
            function ps(xe, ot) {
              ot.workerId = xe, us() && (Ko[ot.workerId] = ot);
            }
            function ho(xe, ot) {
              if (!xe.args)
                throw "Missing className while initializing worker";
              const ye = xe.args, re = ye[0], Be = ye[1], He = Ko[re];
              if (He)
                ot.instance = new He(xe.args.slice(1));
              else
                throw `unknown worker class ${re}`;
              qa(Be, Hi), Qi(ot.instance) && ot.instance.onAny((Xe, ut) => {
                Ba({ type: Ho.EVENT }, { name: Xe, data: ut });
              }), Ba(xe, typeof ot.instance !== void 0);
            }
            function Ya(xe, ot) {
              return La.apply(this, arguments);
            }
            function La() {
              return La = (0, u.default)(/* @__PURE__ */ l.default.mark(function xe(ot, ye) {
                var re, Be;
                return l.default.wrap(function(Xe) {
                  for (; ; ) switch (Xe.prev = Xe.next) {
                    case 0:
                      if (re = ot.args, ye.instance) {
                        Xe.next = 3;
                        break;
                      }
                      throw "instance not initialized";
                    case 3:
                      if (!ye.instance.terminate) {
                        Xe.next = 7;
                        break;
                      }
                      return Xe.next = 6, ye.instance.terminate(...re != null ? re : []);
                    case 6:
                      Be = Xe.sent;
                    case 7:
                      Ba(ot, Be);
                    case 8:
                    case "end":
                      return Xe.stop();
                  }
                }, xe);
              })), La.apply(this, arguments);
            }
            function Jd(xe) {
              if (!xe.args)
                throw "Missing globals while syncing";
              qa(xe.args[0], Hi), Ba(xe, {});
            }
            function zo() {
              const xe = {};
              onmessage = /* @__PURE__ */ function() {
                var ot = (0, u.default)(/* @__PURE__ */ l.default.mark(function ye(re) {
                  var Be;
                  return l.default.wrap(function(Xe) {
                    for (; ; ) switch (Xe.prev = Xe.next) {
                      case 0:
                        Be = re.data, Xe.t0 = Be.type, Xe.next = Xe.t0 === Ho.INIT ? 4 : Xe.t0 === Ho.FORWARD ? 6 : Xe.t0 === Ho.TERMINATE ? 8 : Xe.t0 === Ho.GLOBALS_SYNC ? 10 : 12;
                        break;
                      case 4:
                        return ho(Be, xe), Xe.abrupt("break", 12);
                      case 6:
                        return zi(Be, xe), Xe.abrupt("break", 12);
                      case 8:
                        return Ya(Be, xe), Xe.abrupt("break", 12);
                      case 10:
                        return Jd(Be), Xe.abrupt("break", 12);
                      case 12:
                      case "end":
                        return Xe.stop();
                    }
                  }, ye);
                }));
                return function(re) {
                  return ot.apply(this, arguments);
                };
              }();
            }
            us() && zo();
            const Rl = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot() {
                var re;
                return re = xe.apply(this, arguments) || this, re.processor = new Fn(), re;
              }
              var ye = ot.prototype;
              return ye.init = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return Xe === void 0 && (Xe = {}), this.transformer = new ti(), this.processor.onAny((Xt, pn) => this.emit(Xt, pn)), this.transformer.onAny((Xt, pn) => this.emit(Xt, pn)), ct.next = 6, this.transformer.init(Xe);
                      case 6:
                        return ct.next = 8, this.processor.setTransformers([this.transformer]);
                      case 8:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.transform = function(Be, He) {
                this.processor.transform(Be, He);
              }, ye.setAudioOptions = function(Be, He, Xe, ut, ct) {
                var Xt;
                (Xt = this.transformer) == null || Xt.setAudioOptions(Be, He, Xe, ut, ct);
              }, ye.enable = function() {
                var Be;
                (Be = this.transformer) == null || Be.enable();
              }, ye.disable = function() {
                var Be;
                (Be = this.transformer) == null || Be.disable();
              }, ye.terminate = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  return l.default.wrap(function(ut) {
                    for (; ; ) switch (ut.prev = ut.next) {
                      case 0:
                        return ut.next = 2, this.processor.destroy();
                      case 2:
                      case "end":
                        return ut.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getWav = function() {
                var Be, He;
                return (Be = (He = this.transformer) == null ? void 0 : He.getWav()) != null ? Be : "";
              }, ye.getLatency = function() {
                var Be, He;
                return (Be = (He = this.transformer) == null ? void 0 : He.getLatency()) != null ? Be : 0;
              }, ye.getWasmLatencyNs = function() {
                var Be, He;
                return (Be = (He = this.transformer) == null ? void 0 : He.getWasmLatencyNs()) != null ? Be : 0;
              }, ot;
            }(Ar);
            ps("ProcessorWorker", Rl);
            let ms = Rl;
            const $o = "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", bc = typeof window != "undefined" && window.Blob && new Blob([atob($o)], { type: "text/javascript;charset=utf-8" });
            function Zc() {
              let xe;
              try {
                if (xe = bc && (window.URL || window.webkitURL).createObjectURL(bc), !xe) throw "";
                return new Worker(xe);
              } catch {
                return new Worker("data:application/javascript;base64," + $o);
              } finally {
                xe && (window.URL || window.webkitURL).revokeObjectURL(xe);
              }
            }
            let oc = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot() {
                var re;
                return re = xe.apply(this, arguments) || this, re.isEnabled = !0, re;
              }
              var ye = ot.prototype;
              return ye.init = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return Xe === void 0 && (Xe = {}), ct.next = 3, this.startWorker(Xe);
                      case 3:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.enable = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return this.isEnabled = !0, ct.next = 3, (Xe = this.worker) == null ? void 0 : Xe.enable();
                      case 3:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.disable = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return this.isEnabled = !1, ct.next = 3, (Xe = this.worker) == null ? void 0 : Xe.disable();
                      case 3:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.transform = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut) {
                  var ct;
                  return l.default.wrap(function(pn) {
                    for (; ; ) switch (pn.prev = pn.next) {
                      case 0:
                        return pn.next = 2, this.startWorker();
                      case 2:
                        return pn.next = 4, (ct = this.worker) == null ? void 0 : ct.transform(Xe, ut);
                      case 4:
                      case "end":
                        return pn.stop();
                    }
                  }, He, this);
                }));
                function Be(He, Xe) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.destroy = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return ct.next = 2, (Xe = this.worker) == null ? void 0 : Xe.terminate();
                      case 2:
                        this.worker = void 0;
                      case 3:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.setAudioOptions = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe, ut, ct, Xt, pn) {
                  var un;
                  return l.default.wrap(function(gr) {
                    for (; ; ) switch (gr.prev = gr.next) {
                      case 0:
                        return gr.next = 2, (un = this.worker) == null ? void 0 : un.setAudioOptions(Xe, ut, ct, Xt, pn);
                      case 2:
                      case "end":
                        return gr.stop();
                    }
                  }, He, this);
                }));
                function Be(He, Xe, ut, ct, Xt) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getLatency = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        return Xt.abrupt("return", (Xe = (ut = this.worker) == null ? void 0 : ut.getLatency()) != null ? Xe : 0);
                      case 1:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getWasmLatencyNs = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        return Xt.abrupt("return", (Xe = (ut = this.worker) == null ? void 0 : ut.getWasmLatencyNs()) != null ? Xe : 0);
                      case 1:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.startWorker = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        if (Xe === void 0 && (Xe = {}), !this.worker) {
                          ct.next = 3;
                          break;
                        }
                        return ct.abrupt("return");
                      case 3:
                        return ct.next = 5, vr(ms, Zc);
                      case 5:
                        return this.worker = ct.sent, this.worker.onAny((Xt, pn) => this.emit(Xt, pn)), ct.next = 9, this.worker.init(Xe);
                      case 9:
                        if (this.isEnabled) {
                          ct.next = 12;
                          break;
                        }
                        return ct.next = 12, this.worker.disable();
                      case 12:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.close = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return ct.next = 2, (Xe = this.worker) == null ? void 0 : Xe.terminate();
                      case 2:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getWav = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        return Xt.next = 2, (ut = this.worker) == null ? void 0 : ut.getWav();
                      case 2:
                        if (Xt.t0 = Xe = Xt.sent, Xt.t0 == null) {
                          Xt.next = 7;
                          break;
                        }
                        Xt.t1 = Xe, Xt.next = 8;
                        break;
                      case 7:
                        Xt.t1 = "";
                      case 8:
                        return Xt.abrupt("return", Xt.t1);
                      case 9:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ot;
            }(Ar), gu = /* @__PURE__ */ function(xe) {
              (0, h.default)(ot, xe);
              function ot() {
                return xe.apply(this, arguments) || this;
              }
              var ye = ot.prototype;
              return ye.init = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He(Xe) {
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return Xe === void 0 && (Xe = {}), this.worker = new oc(), this.worker.onAny((Xt, pn) => this.emit(Xt, pn)), ct.next = 5, this.worker.init(Xe);
                      case 5:
                        this.connector = new wt(this.worker);
                      case 6:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be(He) {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getConnector = function() {
                return this.connector;
              }, ye.close = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return ct.next = 2, (Xe = this.worker) == null ? void 0 : Xe.close();
                      case 2:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.enable = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return ct.next = 2, (Xe = this.worker) == null ? void 0 : Xe.enable();
                      case 2:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.disable = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe;
                  return l.default.wrap(function(ct) {
                    for (; ; ) switch (ct.prev = ct.next) {
                      case 0:
                        return ct.next = 2, (Xe = this.worker) == null ? void 0 : Xe.disable();
                      case 2:
                      case "end":
                        return ct.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getLatency = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        return Xt.abrupt("return", (Xe = (ut = this.worker) == null ? void 0 : ut.getLatency()) != null ? Xe : 0);
                      case 1:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getWasmLatencyNs = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        return Xt.abrupt("return", (Xe = (ut = this.worker) == null ? void 0 : ut.getWasmLatencyNs()) != null ? Xe : 0);
                      case 1:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ye.getWav = /* @__PURE__ */ function() {
                var re = (0, u.default)(/* @__PURE__ */ l.default.mark(function He() {
                  var Xe, ut;
                  return l.default.wrap(function(Xt) {
                    for (; ; ) switch (Xt.prev = Xt.next) {
                      case 0:
                        return Xt.next = 2, (ut = this.worker) == null ? void 0 : ut.getWav();
                      case 2:
                        if (Xt.t0 = Xe = Xt.sent, Xt.t0 == null) {
                          Xt.next = 7;
                          break;
                        }
                        Xt.t1 = Xe, Xt.next = 8;
                        break;
                      case 7:
                        Xt.t1 = "";
                      case 8:
                        return Xt.abrupt("return", Xt.t1);
                      case 9:
                      case "end":
                        return Xt.stop();
                    }
                  }, He, this);
                }));
                function Be() {
                  return re.apply(this, arguments);
                }
                return Be;
              }(), ot;
            }(Ar);
            r.VonageNoiseSuppression = gu;
            function zd() {
              return new gu();
            }
            const ka = `https://d3opqjmqzxf057.cloudfront.net/noise-suppression/${fr}`;
            let jr = /* @__PURE__ */ function() {
              function xe() {
              }
              var ot = xe.prototype;
              return ot.init = /* @__PURE__ */ function() {
                var ye = (0, u.default)(/* @__PURE__ */ l.default.mark(function Be(He) {
                  var Xe, ut, ct;
                  return l.default.wrap(function(pn) {
                    for (; ; ) switch (pn.prev = pn.next) {
                      case 0:
                        return He === void 0 && (He = {}), console.log("Wav exporter transformer initialization"), ut = (Xe = He.assetsDirBaseUrl) != null ? Xe : ka, ct = (un) => `${ut}/${un}`, pn.next = 6, b({ locateFile: ct, mainScriptUrlOrBlob: ct("main-bin-mono.js") });
                      case 6:
                        this.wasmInstance = pn.sent, console.log("Wav exporter transformer ready");
                      case 8:
                      case "end":
                        return pn.stop();
                    }
                  }, Be, this);
                }));
                function re(Be) {
                  return ye.apply(this, arguments);
                }
                return re;
              }(), ot.transform = function(re, Be) {
                if (this.wasmTransformer || (this.wasmTransformer = new this.wasmInstance.WavExporter(re.sampleRate, 1)), this.wasmTransformer) {
                  const He = this.getAudioDataAsInt16(re);
                  this.wasmTransformer.getInputFrame(He.length).set(He), this.wasmTransformer.push(re.numberOfFrames, re.sampleRate, re.numberOfChannels);
                }
                Be.enqueue(re);
              }, ot.getWav = function() {
                if (!this.wasmTransformer)
                  return "";
                this.wasmTransformer.close();
                const re = this.wasmTransformer.getWav();
                return `data:audio/wav;base64,${btoa(new Uint8Array(re).reduce((He, Xe) => He + String.fromCharCode(Xe), ""))}`;
              }, ot.getAudioDataAsInt16 = function(re) {
                const Be = this.getAudioDataAsFloat32(re), He = new Int16Array(Be.length);
                for (let Xe = 0; Xe < Be.length; ++Xe)
                  He[Xe] = Math.round(Be[Xe] * 65535);
                return He;
              }, ot.getAudioDataAsFloat32 = function(re) {
                return this.audioDataToTypedArray(re, Float32Array, "f32-planar", 1);
              }, ot.audioDataToTypedArray = function(re, Be, He, Xe) {
                Xe === void 0 && (Xe = re.numberOfChannels);
                const ut = re.numberOfFrames * Xe, ct = new Be(ut);
                for (let Xt = 0; Xt < Xe; ++Xt) {
                  const pn = re.numberOfFrames * Xt, un = ct.subarray(pn, pn + re.numberOfFrames);
                  re.copyTo(un, { planeIndex: Xt, format: He });
                }
                return ct;
              }, xe;
            }();
            r.WavExporterTransformer = jr;
          }).call(this, e(2), e(27));
        },
        /* 720 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(14)), c = n(e(721)), d = n(e(76)), u = e(25);
          const h = d.default.ACTIVE_VIDEO, A = d.default.ACTIVE_VIDEO_WITH_WARNING, g = d.default.SUSPENDED_VIDEO;
          var p = (v) => {
            let b = v.getAllPeerConnections;
            const m = new l.default(), y = (0, c.default)();
            y.on("stateChange", function() {
              for (var Q = arguments.length, N = new Array(Q), J = 0; J < Q; J++)
                N[J] = arguments[J];
              return m.emit("stateChange", ...N);
            });
            const U = /* @__PURE__ */ function() {
              var Q = (0, o.default)(/* @__PURE__ */ t.default.mark(function N() {
                var J, w;
                return t.default.wrap(function(G) {
                  for (; ; ) switch (G.prev = G.next) {
                    case 0:
                      return G.next = 2, b();
                    case 2:
                      J = G.sent, w = J.reduce((Z, K) => {
                        var L;
                        return Math.max(Z, (L = K.getAudioFallbackState()) == null ? void 0 : L.videoState);
                      }, h), y.setState(w);
                    case 5:
                    case "end":
                      return G.stop();
                  }
                }, N);
              }));
              return function() {
                return Q.apply(this, arguments);
              };
            }();
            return Object.assign(m, {
              onPeerConnectionStateChange: (Q) => {
                let N = Q.state, J = Q.peerConnection, w = Q.publishVideo, W = Q.stream, G = Q.peerId;
                if (w) {
                  const Z = J.getSourceStreamId() === "MANTIS" ? void 0 : G, K = (L) => {
                    let O = L.activeState, de = L.congestionLevel;
                    W.setChannelActiveState({
                      activeState: O,
                      congestionLevel: de,
                      channelType: "video",
                      activeReason: "auto",
                      subscriberId: Z
                    });
                  };
                  switch (N) {
                    case h:
                      K({
                        activeState: !0,
                        congestionLevel: u.LOW
                      });
                      break;
                    case A:
                      K({
                        activeState: !0,
                        congestionLevel: u.MEDIUM
                      });
                      break;
                    case g:
                      K({
                        activeState: !1,
                        congestionLevel: u.CRITICAL
                      });
                      break;
                  }
                }
                U();
              },
              onPeerConnectionDisconnected: () => {
                U();
              },
              reset: () => y.reset(),
              getState: () => y.getState()
            });
          };
          r.default = p;
        },
        /* 721 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(14)), o = n(e(76)), c = () => {
            const d = new t.default();
            let u = o.default.ACTIVE_VIDEO;
            return Object.assign(d, {
              getState() {
                return u;
              },
              setState(h) {
                if (!Object.values(o.default).includes(h))
                  throw new Error("Invalid video state: ", h);
                if (h === u)
                  return;
                const A = u;
                u = h, d.emit("stateChange", {
                  state: u,
                  previousState: A
                });
              },
              reset() {
                u = o.default.ACTIVE_VIDEO;
              }
            });
          };
          r.default = c;
        },
        /* 722 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(4)), o = n(e(5));
          function l(c) {
            let d = !1;
            return /* @__PURE__ */ function() {
              var u = (0, o.default)(/* @__PURE__ */ t.default.mark(function A() {
                var g, f, p, v = arguments;
                return t.default.wrap(function(m) {
                  for (; ; ) switch (m.prev = m.next) {
                    case 0:
                      if (!d) {
                        m.next = 2;
                        break;
                      }
                      throw new Error("The previous call to this function has not yet completed.");
                    case 2:
                      for (d = !0, m.prev = 3, g = v.length, f = new Array(g), p = 0; p < g; p++)
                        f[p] = v[p];
                      return m.next = 7, c.call(this, ...f);
                    case 7:
                      return m.abrupt("return", m.sent);
                    case 8:
                      return m.prev = 8, d = !1, m.finish(8);
                    case 11:
                    case "end":
                      return m.stop();
                  }
                }, A, this, [[3, , 8, 11]]);
              }));
              function h() {
                return u.apply(this, arguments);
              }
              return h;
            }();
          }
        },
        /* 723 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(40)), o = n(e(334)), l = n(e(286)), c = (d) => {
            const u = (0, t.default)(d, ["audioDeviceId", "audioFallback", "audioFallbackEnabled", "audioSource", "audioFilter", "channels", "classNames", "constraints", "disableAudioProcessing", "echoCancellation", "noiseSuppression", "autoGainControl", "enableRenegotiation", "enableStereo", "facingMode", "fitMode", "frameRate", "height", "insertDefaultUI", "insertMode", "audioBitrate", "maxResolution", "minVideoBitrate", "mirror", "name", "publishAudio", "publishVideo", "publishCaptions", "resolution", "scalableScreenshare", "scalableVideo", "showControls", "style", "videoContentHint", "videoDeviceId", "videoDimensions", "videoFilter", "videoSource", "width"]);
            return u.style && (u.style = (0, l.default)(u.style)), u.videoFilter && (u.videoFilter = (0, o.default)(u.videoFilter)), u;
          };
          r.default = c;
        },
        /* 724 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(31)), o = n(e(50)), l = n(e(109)), c = n(e(23));
          const d = (0, c.default)();
          var u = (h) => {
            let A = h.publisher, g = h.widgetView, f = 0, p = 0;
            const v = new l.default(() => {
              const b = A.listenerCount(t.default.AUDIO_LEVEL_UPDATED);
              if ((0, o.default)() - p > 1e4 && b === 0) {
                v.stop();
                return;
              }
              const y = g && g.video();
              if (y) {
                const U = y.getAudioInputLevel();
                f = U, b > 0 && A.dispatchEvent(new d.AudioLevelUpdatedEvent(U));
              }
            });
            Object.defineProperty(A, "loudness", {
              get() {
                return v.start(), p = (0, o.default)(), f;
              },
              set() {
                throw new TypeError("Cannot set readonly property loudness");
              }
            }), A.listenerCount(t.default.AUDIO_LEVEL_UPDATED) && v.start(), A.on("audioLevelUpdated:added", () => {
              v.start();
            }), A.once(t.default.PUBLISHER_DESTROYED, () => {
              v.stop();
            });
          };
          r.default = u;
        },
        /* 725 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(13)), o = n(e(8));
          const l = (0, t.default)();
          function c(d) {
            const u = document.createElement("canvas");
            if (!u.captureStream)
              throw l(o.default.NOT_SUPPORTED, new Error("Your browser does not support HTMLCanvasElement.captureStream()"));
            u.width = d.width, u.height = d.height, u.getContext("2d").fillRect(0, 0, 1, 1);
            const h = u.captureStream().getVideoTracks(), A = h[0];
            return A.isCreatedCanvas = !0, A.enabled = !1, A;
          }
        },
        /* 726 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = (d) => d.getSettings && d.getSettings().deviceId, t = (d) => {
            let u;
            return d.getConstraints && d.getConstraints().deviceId && (u = d.getConstraints().deviceId.exact), u;
          }, o = (d, u) => {
            let h;
            if (u && u.length) {
              const A = u.find((g) => g.label === d.label);
              A && (h = A.deviceId);
            }
            return h;
          }, l = (d, u) => n(d) || t(d) || o(d, u);
          var c = (d, u) => {
            if (!d)
              return null;
            const h = d.getVideoTracks(), A = h[0];
            return A ? l(A, u) : null;
          };
          r.default = c;
        },
        /* 727 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(10)), o = n(e(8)), l = n(e(13));
          const c = (0, l.default)();
          var d = (u) => {
            const h = [
              "403",
              // FORBIDDEN ERRORS: forbiddenConnection
              "404",
              // NOT FOUND ERRORS: streamNotFound
              "409"
              // CONFLICT ERRORS: streamLimitExceeded
            ], A = String(u.code);
            return A === "405" && u.message === "IncompatibleEncryptionSettings" ? c(o.default.STREAM_CREATE_FAILED, new Error("IncompatibleEncryptionSettings: Tried to publish a stream to an encrypted session without enabling encryption"), t.default.UNABLE_TO_PUBLISH) : h.includes(A) ? c(o.default.STREAM_CREATE_FAILED, new Error(`Failed to create stream in server model: ${u.message}`), t.default.UNABLE_TO_PUBLISH) : c(o.default.UNEXPECTED_SERVER_RESPONSE, new Error(`Unexpected server response: ${u.message}`), t.default.UNEXPECTED_SERVER_RESPONSE);
          };
          r.default = d;
        },
        /* 728 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(1)), c = n(e(3)), d = n(e(335)), u = n(e(730)), h = e(71);
          const A = (0, l.default)("MediaProcessor");
          function g(p) {
            var v = this;
            p === void 0 && (p = {});
            const b = p, m = b.ML, y = m === void 0 ? d.default : m, U = b.MediaTransform, B = U === void 0 ? u.default : U, Q = b.getProxyUrl, N = Q === void 0 ? h.getProxyUrl : Q;
            let J, w, W, G;
            this.isValidVideoFilter = (Z) => {
              const K = Z.type;
              return B.isSupported(K) && B.isValidConfig(Z);
            }, this.canUpdateVideoFilter = (Z) => ["backgroundBlur", "backgroundReplacement"].includes(Z), this.updateVideoFilter = /* @__PURE__ */ function() {
              var Z = (0, o.default)(/* @__PURE__ */ t.default.mark(function K(L) {
                var O, de, oe;
                return t.default.wrap(function(ge) {
                  for (; ; ) switch (ge.prev = ge.next) {
                    case 0:
                      if (O = L.type, v.canUpdateVideoFilter(O)) {
                        ge.next = 4;
                        break;
                      }
                      return A.warn(`Ignoring: filter "${O}" doesn't support real-time updates`), ge.abrupt("return");
                    case 4:
                      return de = B.getConfigurator(O), oe = de.getConfig(Object.assign({
                        proxyUrl: N()
                      }, L)), ge.next = 8, w.setBackgroundOptions(oe);
                    case 8:
                      W = L;
                    case 9:
                    case "end":
                      return ge.stop();
                  }
                }, K);
              }));
              return function(K) {
                return Z.apply(this, arguments);
              };
            }(), this.setVideoFilter = /* @__PURE__ */ function() {
              var Z = (0, o.default)(/* @__PURE__ */ t.default.mark(function K(L) {
                var O, de, oe, fe;
                return t.default.wrap(function(we) {
                  for (; ; ) switch (we.prev = we.next) {
                    case 0:
                      if (O = L.type, de = B.getConfigurator(O), de) {
                        we.next = 5;
                        break;
                      }
                      return A.warn(`Ignoring: filter "${O}" isn't supported`), we.abrupt("return");
                    case 5:
                      if (oe = de.getConfig(Object.assign({
                        proxyUrl: N()
                      }, L)), oe) {
                        we.next = 9;
                        break;
                      }
                      return A.warn(`Ignoring: couldn't configure filter ${O}`), we.abrupt("return");
                    case 9:
                      if (fe = !!v.getVideoFilter(), !fe) {
                        we.next = 20;
                        break;
                      }
                      return we.prev = 11, we.next = 14, v.destroy();
                    case 14:
                      we.next = 20;
                      break;
                    case 16:
                      return we.prev = 16, we.t0 = we.catch(11), A.warn(`Ignoring, couldn't remove previous filter: ${we.t0}`), we.abrupt("return");
                    case 20:
                      return we.next = 22, y.createProcessor(oe);
                    case 22:
                      return w = we.sent, we.next = 25, w.getConnector();
                    case 25:
                      J = we.sent, W = L;
                    case 27:
                    case "end":
                      return we.stop();
                  }
                }, K, null, [[11, 16]]);
              }));
              return function(K) {
                return Z.apply(this, arguments);
              };
            }(), this.getVideoFilter = () => W, this.getOriginalVideoTrack = () => G, this.setMediaStream = /* @__PURE__ */ function() {
              var Z = (0, o.default)(/* @__PURE__ */ t.default.mark(function K(L) {
                var O, de, oe;
                return t.default.wrap(function(ge) {
                  for (; ; ) switch (ge.prev = ge.next) {
                    case 0:
                      if (O = L.getVideoTracks(), de = O[0], de) {
                        ge.next = 4;
                        break;
                      }
                      return A.warn("Ignoring. No video track found"), ge.abrupt("return", null);
                    case 4:
                      return oe = null, ge.prev = 5, ge.next = 8, J.setTrack(de);
                    case 8:
                      oe = ge.sent, G = de, ge.next = 15;
                      break;
                    case 12:
                      ge.prev = 12, ge.t0 = ge.catch(5), A.error(`Error setting media stream: ${ge.t0}`);
                    case 15:
                      return ge.abrupt("return", oe);
                    case 16:
                    case "end":
                      return ge.stop();
                  }
                }, K, null, [[5, 12]]);
              }));
              return function(K) {
                return Z.apply(this, arguments);
              };
            }(), this.setVideoTrack = /* @__PURE__ */ function() {
              var Z = (0, o.default)(/* @__PURE__ */ t.default.mark(function K(L) {
                var O;
                return t.default.wrap(function(oe) {
                  for (; ; ) switch (oe.prev = oe.next) {
                    case 0:
                      return O = null, oe.prev = 1, oe.next = 4, J.setTrack(L);
                    case 4:
                      O = oe.sent, G = L, oe.next = 11;
                      break;
                    case 8:
                      oe.prev = 8, oe.t0 = oe.catch(1), A.error(`Error setting video track: ${oe.t0}`);
                    case 11:
                      return oe.abrupt("return", O);
                    case 12:
                    case "end":
                      return oe.stop();
                  }
                }, K, null, [[1, 8]]);
              }));
              return function(K) {
                return Z.apply(this, arguments);
              };
            }(), this._setConnector = (Z) => {
              J = Z;
            }, this.destroy = /* @__PURE__ */ (0, o.default)(/* @__PURE__ */ t.default.mark(function Z() {
              return t.default.wrap(function(L) {
                for (; ; ) switch (L.prev = L.next) {
                  case 0:
                    return L.prev = 0, L.next = 3, J.destroy();
                  case 3:
                    L.next = 8;
                    break;
                  case 5:
                    L.prev = 5, L.t0 = L.catch(0), A.warn(`Error destroying connector: ${L.t0}`);
                  case 8:
                    J = null, W = null, G = null;
                  case 11:
                  case "end":
                    return L.stop();
                }
              }, Z, null, [[0, 5]]);
            })), this.enableLogging = (Z) => {
              if (!Z) {
                A.warn("Error enabling logging: invalid API key");
                return;
              }
              const K = {
                appId: Z,
                sourceType: "video"
              }, L = N();
              L && (K.proxyUrl = L), y.setMetadata(K);
            }, this.disableLogging = () => {
              y.setMetadata();
            };
          }
          g.isSupported = function(p) {
            p === void 0 && (p = {});
            const v = p, b = v.env, m = b === void 0 ? c.default : b, y = v.ML, U = y === void 0 ? d.default : y;
            return !!m.isChromium && U.isSupported();
          };
          var f = g;
          r.default = f;
        },
        /* 729 */
        /***/
        function(i, r, e) {
          e.r(r), function(n, t) {
            e.d(r, "ErrorFunction", function() {
              return Kr;
            }), e.d(r, "MediaProcessor", function() {
              return Wo;
            }), e.d(r, "MediaProcessorConnector", function() {
              return Fa;
            }), e.d(r, "PipelineInfoData", function() {
              return Bi;
            }), e.d(r, "VonageSourceType", function() {
              return we;
            }), e.d(r, "WarningType", function() {
              return rr;
            }), e.d(r, "getVonageMetadata", function() {
              return lr;
            }), e.d(r, "isSupported", function() {
              return d;
            }), e.d(r, "setVonageMetadata", function() {
              return er;
            });
            var o = Object.defineProperty, l = (sn, Ct, cn) => Ct in sn ? o(sn, Ct, { enumerable: !0, configurable: !0, writable: !0, value: cn }) : sn[Ct] = cn, c = (sn, Ct, cn) => (l(sn, typeof Ct != "symbol" ? Ct + "" : Ct, cn), cn);
            function d() {
              return new n((sn, Ct) => {
                typeof MediaStreamTrackProcessor > "u" || typeof MediaStreamTrackGenerator > "u" ? Ct("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.") : sn();
              });
            }
            class u {
            }
            c(u, "updates", {
              transformer_new: "New transformer",
              transformer_null: "Null transformer"
            }), c(u, "errors", {
              transformer_none: "No transformers provided",
              transformer_start: "Cannot start transformer",
              transformer_transform: "Cannot transform frame",
              transformer_flush: "Cannot flush transformer",
              readable_null: "Readable is null",
              writable_null: "Writable is null"
            });
            const h = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ new WeakMap(), f = Symbol("anyProducer"), p = n.resolve(), v = Symbol("listenerAdded"), b = Symbol("listenerRemoved");
            let m = !1;
            function y(sn) {
              if (typeof sn != "string" && typeof sn != "symbol")
                throw new TypeError("eventName must be a string or a symbol");
            }
            function U(sn) {
              if (typeof sn != "function")
                throw new TypeError("listener must be a function");
            }
            function B(sn, Ct) {
              const cn = A.get(sn);
              return cn.has(Ct) || cn.set(Ct, /* @__PURE__ */ new Set()), cn.get(Ct);
            }
            function Q(sn, Ct) {
              const cn = typeof Ct == "string" || typeof Ct == "symbol" ? Ct : f, Hn = g.get(sn);
              return Hn.has(cn) || Hn.set(cn, /* @__PURE__ */ new Set()), Hn.get(cn);
            }
            function N(sn, Ct, cn) {
              const Hn = g.get(sn);
              if (Hn.has(Ct))
                for (const Sr of Hn.get(Ct))
                  Sr.enqueue(cn);
              if (Hn.has(f)) {
                const Sr = n.all([Ct, cn]);
                for (const ao of Hn.get(f))
                  ao.enqueue(Sr);
              }
            }
            function J(sn, Ct) {
              Ct = Array.isArray(Ct) ? Ct : [Ct];
              let cn = !1, Hn = () => {
              }, Sr = [];
              const ao = {
                enqueue(wr) {
                  Sr.push(wr), Hn();
                },
                finish() {
                  cn = !0, Hn();
                }
              };
              for (const wr of Ct)
                Q(sn, wr).add(ao);
              return {
                async next() {
                  return Sr ? Sr.length === 0 ? cn ? (Sr = void 0, this.next()) : (await new n((wr) => {
                    Hn = wr;
                  }), this.next()) : {
                    done: !1,
                    value: await Sr.shift()
                  } : { done: !0 };
                },
                async return(wr) {
                  Sr = void 0;
                  for (const Jr of Ct)
                    Q(sn, Jr).delete(ao);
                  return Hn(), arguments.length > 0 ? { done: !0, value: await wr } : { done: !0 };
                },
                [Symbol.asyncIterator]() {
                  return this;
                }
              };
            }
            function w(sn) {
              if (sn === void 0)
                return Z;
              if (!Array.isArray(sn))
                throw new TypeError("`methodNames` must be an array of strings");
              for (const Ct of sn)
                if (!Z.includes(Ct))
                  throw typeof Ct != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${Ct} is not Emittery method`);
              return sn;
            }
            const W = (sn) => sn === v || sn === b;
            class G {
              static mixin(Ct, cn) {
                return cn = w(cn), (Hn) => {
                  if (typeof Hn != "function")
                    throw new TypeError("`target` must be function");
                  for (const wr of cn)
                    if (Hn.prototype[wr] !== void 0)
                      throw new Error(`The property \`${wr}\` already exists on \`target\``);
                  function Sr() {
                    return Object.defineProperty(this, Ct, {
                      enumerable: !1,
                      value: new G()
                    }), this[Ct];
                  }
                  Object.defineProperty(Hn.prototype, Ct, {
                    enumerable: !1,
                    get: Sr
                  });
                  const ao = (wr) => function(...Jr) {
                    return this[Ct][wr](...Jr);
                  };
                  for (const wr of cn)
                    Object.defineProperty(Hn.prototype, wr, {
                      enumerable: !1,
                      value: ao(wr)
                    });
                  return Hn;
                };
              }
              static get isDebugEnabled() {
                if (typeof t != "object")
                  return m;
                const { env: Ct } = t || { env: {} };
                return Ct.DEBUG === "emittery" || Ct.DEBUG === "*" || m;
              }
              static set isDebugEnabled(Ct) {
                m = Ct;
              }
              constructor(Ct = {}) {
                h.set(this, /* @__PURE__ */ new Set()), A.set(this, /* @__PURE__ */ new Map()), g.set(this, /* @__PURE__ */ new Map()), this.debug = Ct.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (cn, Hn, Sr, ao) => {
                  try {
                    ao = JSON.stringify(ao);
                  } catch {
                    ao = `Object with the following keys failed to stringify: ${Object.keys(ao).join(",")}`;
                  }
                  typeof Sr == "symbol" && (Sr = Sr.toString());
                  const wr = /* @__PURE__ */ new Date(), Jr = `${wr.getHours()}:${wr.getMinutes()}:${wr.getSeconds()}.${wr.getMilliseconds()}`;
                  console.log(`[${Jr}][emittery:${cn}][${Hn}] Event Name: ${Sr}
	data: ${ao}`);
                });
              }
              logIfDebugEnabled(Ct, cn, Hn) {
                (G.isDebugEnabled || this.debug.enabled) && this.debug.logger(Ct, this.debug.name, cn, Hn);
              }
              on(Ct, cn) {
                U(cn), Ct = Array.isArray(Ct) ? Ct : [Ct];
                for (const Hn of Ct)
                  y(Hn), B(this, Hn).add(cn), this.logIfDebugEnabled("subscribe", Hn, void 0), W(Hn) || this.emit(v, { eventName: Hn, listener: cn });
                return this.off.bind(this, Ct, cn);
              }
              off(Ct, cn) {
                U(cn), Ct = Array.isArray(Ct) ? Ct : [Ct];
                for (const Hn of Ct)
                  y(Hn), B(this, Hn).delete(cn), this.logIfDebugEnabled("unsubscribe", Hn, void 0), W(Hn) || this.emit(b, { eventName: Hn, listener: cn });
              }
              once(Ct) {
                return new n((cn) => {
                  const Hn = this.on(Ct, (Sr) => {
                    Hn(), cn(Sr);
                  });
                });
              }
              events(Ct) {
                Ct = Array.isArray(Ct) ? Ct : [Ct];
                for (const cn of Ct)
                  y(cn);
                return J(this, Ct);
              }
              async emit(Ct, cn) {
                y(Ct), this.logIfDebugEnabled("emit", Ct, cn), N(this, Ct, cn);
                const Hn = B(this, Ct), Sr = h.get(this), ao = [...Hn], wr = W(Ct) ? [] : [...Sr];
                await p, await n.all([
                  ...ao.map(async (Jr) => {
                    if (Hn.has(Jr))
                      return Jr(cn);
                  }),
                  ...wr.map(async (Jr) => {
                    if (Sr.has(Jr))
                      return Jr(Ct, cn);
                  })
                ]);
              }
              async emitSerial(Ct, cn) {
                y(Ct), this.logIfDebugEnabled("emitSerial", Ct, cn);
                const Hn = B(this, Ct), Sr = h.get(this), ao = [...Hn], wr = [...Sr];
                await p;
                for (const Jr of ao)
                  Hn.has(Jr) && await Jr(cn);
                for (const Jr of wr)
                  Sr.has(Jr) && await Jr(Ct, cn);
              }
              onAny(Ct) {
                return U(Ct), this.logIfDebugEnabled("subscribeAny", void 0, void 0), h.get(this).add(Ct), this.emit(v, { listener: Ct }), this.offAny.bind(this, Ct);
              }
              anyEvent() {
                return J(this);
              }
              offAny(Ct) {
                U(Ct), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(b, { listener: Ct }), h.get(this).delete(Ct);
              }
              clearListeners(Ct) {
                Ct = Array.isArray(Ct) ? Ct : [Ct];
                for (const cn of Ct)
                  if (this.logIfDebugEnabled("clear", cn, void 0), typeof cn == "string" || typeof cn == "symbol") {
                    B(this, cn).clear();
                    const Hn = Q(this, cn);
                    for (const Sr of Hn)
                      Sr.finish();
                    Hn.clear();
                  } else {
                    h.get(this).clear();
                    for (const Hn of A.get(this).values())
                      Hn.clear();
                    for (const Hn of g.get(this).values()) {
                      for (const Sr of Hn)
                        Sr.finish();
                      Hn.clear();
                    }
                  }
              }
              listenerCount(Ct) {
                Ct = Array.isArray(Ct) ? Ct : [Ct];
                let cn = 0;
                for (const Hn of Ct) {
                  if (typeof Hn == "string") {
                    cn += h.get(this).size + B(this, Hn).size + Q(this, Hn).size + Q(this).size;
                    continue;
                  }
                  typeof Hn < "u" && y(Hn), cn += h.get(this).size;
                  for (const Sr of A.get(this).values())
                    cn += Sr.size;
                  for (const Sr of g.get(this).values())
                    cn += Sr.size;
                }
                return cn;
              }
              bindMethods(Ct, cn) {
                if (typeof Ct != "object" || Ct === null)
                  throw new TypeError("`target` must be an object");
                cn = w(cn);
                for (const Hn of cn) {
                  if (Ct[Hn] !== void 0)
                    throw new Error(`The property \`${Hn}\` already exists on \`target\``);
                  Object.defineProperty(Ct, Hn, {
                    enumerable: !1,
                    value: this[Hn].bind(this)
                  });
                }
              }
            }
            const Z = Object.getOwnPropertyNames(G.prototype).filter((sn) => sn !== "constructor");
            Object.defineProperty(G, "listenerAdded", {
              value: v,
              writable: !1,
              enumerable: !0,
              configurable: !1
            }), Object.defineProperty(G, "listenerRemoved", {
              value: b,
              writable: !1,
              enumerable: !0,
              configurable: !1
            });
            var K = G;
            function L(sn) {
              return typeof sn == "object" && sn !== null && "message" in sn && typeof sn.message == "string";
            }
            function O(sn) {
              if (L(sn))
                return sn;
              try {
                return new Error(JSON.stringify(sn));
              } catch {
                return new Error(String(sn));
              }
            }
            function de(sn) {
              return O(sn).message;
            }
            var oe = Object.defineProperty, fe = (sn, Ct, cn) => Ct in sn ? oe(sn, Ct, { enumerable: !0, configurable: !0, writable: !0, value: cn }) : sn[Ct] = cn, ge = (sn, Ct, cn) => (fe(sn, Ct + "", cn), cn), we = /* @__PURE__ */ ((sn) => (sn.automation = "automation", sn.test = "test", sn.vbc = "vbc", sn.video = "video", sn.voice = "voice", sn))(we || {});
            const _e = "hlg.tokbox.com/prod/logging/vcp_webrtc", Te = "https://", Pe = 1e4;
            let $e;
            const Bt = new Uint8Array(16);
            function Le() {
              if (!$e && ($e = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !$e))
                throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
              return $e(Bt);
            }
            const at = [];
            for (let sn = 0; sn < 256; ++sn)
              at.push((sn + 256).toString(16).slice(1));
            function pt(sn, Ct = 0) {
              return (at[sn[Ct + 0]] + at[sn[Ct + 1]] + at[sn[Ct + 2]] + at[sn[Ct + 3]] + "-" + at[sn[Ct + 4]] + at[sn[Ct + 5]] + "-" + at[sn[Ct + 6]] + at[sn[Ct + 7]] + "-" + at[sn[Ct + 8]] + at[sn[Ct + 9]] + "-" + at[sn[Ct + 10]] + at[sn[Ct + 11]] + at[sn[Ct + 12]] + at[sn[Ct + 13]] + at[sn[Ct + 14]] + at[sn[Ct + 15]]).toLowerCase();
            }
            const kt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), _t = {
              randomUUID: kt
            };
            function Lt(sn, Ct, cn) {
              if (_t.randomUUID && !Ct && !sn)
                return _t.randomUUID();
              sn = sn || {};
              const Hn = sn.random || (sn.rng || Le)();
              return Hn[6] = Hn[6] & 15 | 64, Hn[8] = Hn[8] & 63 | 128, pt(Hn);
            }
            function Ft(sn, Ct) {
              globalThis.vonage || (globalThis.vonage = {}), globalThis.vonage.workerizer || (globalThis.vonage.workerizer = {});
              let cn = globalThis.vonage.workerizer;
              return cn[sn] || (cn[sn] = Ct), cn[sn];
            }
            const Zt = Ft(
              "globals",
              {}
            );
            var ft = /* @__PURE__ */ ((sn) => (sn.INIT = "INIT", sn.FORWARD = "FORWARD", sn.TERMINATE = "TERMINATE", sn.GLOBALS_SYNC = "GLOBALS_SYNC", sn))(ft || {});
            function It(sn) {
              return [ImageBitmap, ReadableStream, WritableStream].some((Ct) => sn instanceof Ct);
            }
            let Kt = 0;
            function Sn(sn, Ct, cn, Hn, Sr) {
              const ao = Kt++;
              return sn.postMessage(
                {
                  id: ao,
                  type: Ct,
                  functionName: cn,
                  args: Hn
                },
                Hn.filter((wr) => It(wr))
              ), new n((wr) => {
                Sr == null || Sr.set(ao, wr);
              });
            }
            function Cn(sn, Ct) {
              const { id: cn, type: Hn } = sn, Sr = Array.isArray(Ct) ? Ct : [Ct];
              postMessage(
                {
                  id: cn,
                  type: Hn,
                  result: Ct
                },
                Sr.filter((ao) => It(ao))
              );
            }
            const on = Ft("workerized", {});
            function An() {
              return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
            }
            async function Ue() {
              if (An())
                Cn({ type: ft.GLOBALS_SYNC }, Zt);
              else {
                const sn = [];
                for (const Ct in on) {
                  const { worker: cn, resolvers: Hn } = on[Ct].workerContext;
                  cn && sn.push(
                    Sn(
                      cn,
                      ft.GLOBALS_SYNC,
                      "",
                      [Zt],
                      Hn
                    )
                  );
                }
                await n.all(sn);
              }
            }
            function ne(sn, Ct) {
              if (Array.isArray(Ct))
                Ct.splice(0, Ct.length);
              else if (typeof Ct == "object")
                for (const cn in Ct)
                  delete Ct[cn];
              for (const cn in sn)
                Array.isArray(sn[cn]) ? (Ct[cn] = [], ne(sn[cn], Ct[cn])) : typeof sn[cn] == "object" ? (Ct[cn] = {}, ne(sn[cn], Ct[cn])) : Ct[cn] = sn[cn];
            }
            async function se(sn, Ct) {
              const { functionName: cn, args: Hn } = sn;
              if (!Ct.instance)
                throw "instance not initialized";
              if (!cn)
                throw "missing function name to call";
              if (!Ct.instance[cn])
                throw `undefined function [${cn}] in class ${Ct.instance.constructor.workerId}`;
              Cn(sn, await Ct.instance[cn](...Hn != null ? Hn : []));
            }
            const Ce = Ft("registeredWorkers", {});
            function At(sn, Ct) {
              if (!sn.args)
                throw "Missing className while initializing worker";
              const [cn, Hn] = sn.args, Sr = Ce[cn];
              if (Sr)
                Ct.instance = new Sr(sn.args.slice(1));
              else
                throw `unknown worker class ${cn}`;
              ne(Hn, Zt), Cn(sn, typeof Ct.instance !== void 0);
            }
            async function Ge(sn, Ct) {
              const { args: cn } = sn;
              if (!Ct.instance)
                throw "instance not initialized";
              let Hn;
              Ct.instance.terminate && (Hn = await Ct.instance.terminate(...cn != null ? cn : [])), Cn(sn, Hn);
            }
            function Ye(sn) {
              if (!sn.args)
                throw "Missing globals while syncing";
              ne(sn.args[0], Zt), Cn(sn, {});
            }
            function Qt() {
              const sn = {};
              onmessage = async (Ct) => {
                const cn = Ct.data;
                switch (cn.type) {
                  case ft.INIT:
                    At(cn, sn);
                    break;
                  case ft.FORWARD:
                    se(cn, sn);
                    break;
                  case ft.TERMINATE:
                    Ge(cn, sn);
                    break;
                  case ft.GLOBALS_SYNC:
                    Ye(cn);
                    break;
                }
              };
            }
            An() && Qt();
            function tn(sn, Ct) {
              return Zt[sn] || (Zt[sn] = Ct), [
                () => Zt[sn],
                async (cn) => {
                  Zt[sn] = cn, await Ue();
                }
              ];
            }
            function vn(sn, Ct) {
              return tn(sn, Ct);
            }
            const [Yt, Tn] = vn("metadata");
            function er(sn) {
              Tn(sn);
            }
            function lr() {
              return Yt();
            }
            class Br {
              constructor(Ct) {
                ge(this, "uuid", Lt()), this.config = Ct;
              }
              async send(Ct) {
                var cn, Hn, Sr;
                const { appId: ao, sourceType: wr } = (cn = lr()) != null ? cn : {};
                if (!ao || !wr)
                  return "metadata missing";
                const Jr = new AbortController(), Fn = setTimeout(() => Jr.abort(), Pe);
                return await ((Sr = (Hn = this.config) == null ? void 0 : Hn.fetch) != null ? Sr : fetch)(this.getUrl(), {
                  method: "POST",
                  headers: this.getHeaders(),
                  body: JSON.stringify(this.buildReport(Ct)),
                  signal: Jr.signal
                }), clearTimeout(Fn), "success";
              }
              getUrl() {
                var Ct;
                let cn = (Ct = lr().proxyUrl) != null ? Ct : Te;
                return cn += (cn.at(-1) === "/" ? "" : "/") + _e, cn;
              }
              getHeaders() {
                return {
                  "Content-Type": "application/json"
                };
              }
              buildReport(Ct) {
                const cn = lr();
                return {
                  guid: this.uuid,
                  ...Ct,
                  applicationId: cn.appId,
                  timestamp: Date.now(),
                  proxyUrl: cn.proxyUrl,
                  source: cn.sourceType
                };
              }
            }
            const pi = "2.0.3";
            class $n {
              constructor(Ct) {
                c(this, "frameTransformedCount", 0), c(this, "frameFromSourceCount", 0), c(this, "startAt", 0), c(this, "reporter"), this.config = Ct, this.reporter = new Br(Ct);
              }
              async onFrameFromSource() {
                this.frameFromSourceCount++;
              }
              get fps() {
                const { startAt: Ct, frameFromSourceCount: cn } = this, Hn = (Date.now() - Ct) / 1e3;
                return cn / Hn;
              }
              async onFrameTransformed(Ct = {}, cn = !1) {
                this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
                const { startAt: Hn, frameTransformedCount: Sr, frameFromSourceCount: ao } = this, wr = Date.now(), Jr = (wr - Hn) / 1e3, Fn = Sr / Jr, Ia = ao / Jr;
                return cn || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = wr, this.reporter.config = this.config, this.reporter.send({
                  ...this.config.report,
                  variation: "QoS",
                  fps: Ia,
                  transformedFps: Fn,
                  framesTransformed: Sr,
                  ...Ct
                })) : "success";
              }
            }
            var rr = /* @__PURE__ */ ((sn) => (sn.FPS_DROP = "fps_drop", sn))(rr || {}), Kr = /* @__PURE__ */ ((sn) => (sn.start = "start", sn.transform = "transform", sn.flush = "flush", sn))(Kr || {}), Bi = /* @__PURE__ */ ((sn) => (sn.pipeline_ended = "pipeline_ended", sn.pipeline_ended_with_error = "pipeline_ended_with_error", sn.pipeline_started = "pipeline_started", sn.pipeline_started_with_error = "pipeline_started_with_error", sn.pipeline_restarted = "pipeline_restarted", sn.pipeline_restarted_with_error = "pipeline_restarted_with_error", sn))(Bi || {});
            const Li = 500, xo = 0.8;
            class Yr extends K {
              constructor(Ct, cn) {
                super(), c(this, "reporter_", new Br()), c(this, "reporterQos_", new $n({
                  loggingIntervalFrameCount: Li,
                  report: {
                    version: pi
                  }
                })), c(this, "transformerType_"), c(this, "transformer_"), c(this, "shouldStop_"), c(this, "isFlashed_"), c(this, "mediaTransformerQosReportStartTimestamp_"), c(this, "videoHeight_"), c(this, "videoWidth_"), c(this, "trackExpectedRate_"), c(this, "index_"), c(this, "controller_"), this.index_ = cn, this.transformer_ = Ct, this.shouldStop_ = !1, this.isFlashed_ = !1, this.mediaTransformerQosReportStartTimestamp_ = 0, this.videoHeight_ = 0, this.videoWidth_ = 0, this.trackExpectedRate_ = -1, this.transformerType_ = "Custom", "getTransformerType" in Ct && (this.transformerType_ = Ct.getTransformerType()), this.report({
                  variation: "Create"
                });
              }
              setTrackExpectedRate(Ct) {
                this.trackExpectedRate_ = Ct;
              }
              async start(Ct) {
                if (this.controller_ = Ct, this.transformer_ && typeof this.transformer_.start == "function")
                  try {
                    await this.transformer_.start(Ct);
                  } catch (cn) {
                    this.report({
                      message: u.errors.transformer_start,
                      variation: "Error",
                      error: de(cn)
                    });
                    const Hn = { eventMetaData: { transformerIndex: this.index_ }, error: cn, function: "start" };
                    this.emit("error", Hn);
                  }
              }
              async transform(Ct, cn) {
                var Hn, Sr, ao, wr;
                if (this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), Ct instanceof VideoFrame && (this.videoHeight_ = (Hn = Ct == null ? void 0 : Ct.displayHeight) != null ? Hn : 0, this.videoWidth_ = (Sr = Ct == null ? void 0 : Ct.displayWidth) != null ? Sr : 0), this.reporterQos_.onFrameFromSource(), this.transformer_)
                  if (this.shouldStop_)
                    console.warn("[Pipeline] flush from transform"), Ct.close(), this.flush(cn), cn.terminate();
                  else {
                    try {
                      await ((wr = (ao = this.transformer_).transform) == null ? void 0 : wr.call(ao, Ct, cn)), this.reportQos();
                    } catch (Jr) {
                      this.report({
                        message: u.errors.transformer_transform,
                        variation: "Error",
                        error: de(Jr)
                      });
                      const Fn = { eventMetaData: { transformerIndex: this.index_ }, error: Jr, function: "transform" };
                      this.emit("error", Fn);
                    }
                    if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * xo > this.reporterQos_.fps) {
                      const Jr = {
                        eventMetaData: {
                          transformerIndex: this.index_
                        },
                        warningType: "fps_drop",
                        dropInfo: {
                          requested: this.trackExpectedRate_,
                          current: this.reporterQos_.fps
                        }
                      };
                      this.emit("warn", Jr);
                    }
                  }
              }
              async flush(Ct) {
                if (this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_) {
                  this.isFlashed_ = !0;
                  try {
                    await this.transformer_.flush(Ct);
                  } catch (cn) {
                    this.report({
                      message: u.errors.transformer_flush,
                      variation: "Error",
                      error: de(cn)
                    });
                    const Hn = { eventMetaData: { transformerIndex: this.index_ }, error: cn, function: "flush" };
                    this.emit("error", Hn);
                  }
                }
                this.reportQos(!0), this.report({
                  variation: "Delete"
                });
              }
              stop() {
                console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
              }
              report(Ct) {
                this.reporter_.send({
                  version: pi,
                  action: "MediaTransformer",
                  transformerType: this.transformerType_,
                  ...Ct
                });
              }
              reportQos(Ct = !1) {
                this.reporterQos_.config = {
                  ...this.reporterQos_.config
                }, this.reporterQos_.onFrameTransformed({
                  version: pi,
                  action: "MediaTransformer",
                  transformerType: this.transformerType_,
                  videoWidth: this.videoWidth_,
                  videoHeight: this.videoHeight_
                }, Ct);
              }
            }
            class Qo extends K {
              constructor(Ct) {
                super(), c(this, "transformers_"), c(this, "trackExpectedRate_"), this.transformers_ = [], this.trackExpectedRate_ = -1;
                for (let cn = 0; cn < Ct.length; cn++) {
                  let Hn = new Yr(Ct[cn], cn);
                  Hn.on("error", (Sr) => {
                    this.emit("error", Sr);
                  }), Hn.on("warn", (Sr) => {
                    this.emit("warn", Sr);
                  }), this.transformers_.push(Hn);
                }
              }
              setTrackExpectedRate(Ct) {
                this.trackExpectedRate_ = Ct;
                for (let cn of this.transformers_)
                  cn.setTrackExpectedRate(this.trackExpectedRate_);
              }
              async start(Ct, cn) {
                if (!this.transformers_ || this.transformers_.length === 0) {
                  console.log("[Pipeline] No transformers.");
                  return;
                }
                try {
                  let Hn = Ct;
                  for (let Sr of this.transformers_)
                    Ct = Ct.pipeThrough(new TransformStream(Sr));
                  Ct.pipeTo(cn).then(async () => {
                    console.log("[Pipeline] Setup."), await cn.abort(), await Hn.cancel(), this.emit("pipelineInfo", "pipeline_ended");
                  }).catch(async (Sr) => {
                    Ct.cancel().then(() => {
                      console.log("[Pipeline] Shutting down streams after abort.");
                    }).catch((ao) => {
                      console.error("[Pipeline] Error from stream transform:", ao);
                    }), await cn.abort(Sr), await Hn.cancel(Sr), this.emit("pipelineInfo", "pipeline_ended_with_error");
                  });
                } catch {
                  this.emit("pipelineInfo", "pipeline_started_with_error"), this.destroy();
                  return;
                }
                this.emit("pipelineInfo", "pipeline_started"), console.log("[Pipeline] Pipeline started.");
              }
              async destroy() {
                console.log("[Pipeline] Destroying Pipeline.");
                for (let Ct of this.transformers_)
                  Ct.stop();
              }
            }
            class Wo extends K {
              constructor() {
                super(), c(this, "reporter_"), c(this, "pipeline_"), c(this, "transformers_"), c(this, "readable_"), c(this, "writable_"), c(this, "trackExpectedRate_"), this.reporter_ = new Br(), this.trackExpectedRate_ = -1, this.report({
                  variation: "Create"
                });
              }
              setTrackExpectedRate(Ct) {
                this.trackExpectedRate_ = Ct, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
              }
              transform(Ct, cn) {
                return this.readable_ = Ct, this.writable_ = cn, this.transformInternal();
              }
              transformInternal() {
                return new n(async (Ct, cn) => {
                  if (!this.transformers_ || this.transformers_.length === 0) {
                    this.report({
                      message: u.errors.transformer_none,
                      variation: "Error"
                    }), cn("[MediaProcessor] Need to set transformers.");
                    return;
                  }
                  if (!this.readable_) {
                    this.report({
                      variation: "Error",
                      message: u.errors.readable_null
                    }), cn("[MediaProcessor] Readable is null.");
                    return;
                  }
                  if (!this.writable_) {
                    this.report({
                      variation: "Error",
                      message: u.errors.writable_null
                    }), cn("[MediaProcessor] Writable is null.");
                    return;
                  }
                  let Hn = !1;
                  this.pipeline_ && (Hn = !0, this.pipeline_.clearListeners(), this.pipeline_.destroy()), this.pipeline_ = new Qo(this.transformers_), this.pipeline_.on("warn", (Sr) => {
                    this.emit("warn", Sr);
                  }), this.pipeline_.on("error", (Sr) => {
                    this.emit("error", Sr);
                  }), this.pipeline_.on("pipelineInfo", (Sr) => {
                    Hn && (Sr === "pipeline_started" ? Sr = Bi.pipeline_restarted : Sr === "pipeline_started_with_error" && (Sr = Bi.pipeline_restarted_with_error)), this.emit("pipelineInfo", Sr);
                  }), this.trackExpectedRate_ != -1 && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_), this.pipeline_.start(this.readable_, this.writable_).then(() => {
                    Ct();
                  }).catch((Sr) => {
                    cn(Sr);
                  });
                });
              }
              setTransformers(Ct) {
                return this.report({
                  variation: "Update",
                  message: u.updates.transformer_new
                }), this.transformers_ = Ct, this.readable_ && this.writable_ ? this.transformInternal() : n.resolve();
              }
              destroy() {
                return new n(async (Ct) => {
                  this.pipeline_ && this.pipeline_.destroy(), this.report({ variation: "Delete" }), Ct();
                });
              }
              report(Ct) {
                this.reporter_.send({
                  version: pi,
                  action: "MediaProcessor",
                  ...Ct
                });
              }
            }
            class xi {
              constructor() {
                c(this, "processor_"), c(this, "generator_"), this.processor_ = null, this.generator_ = null;
              }
              init(Ct) {
                return new n((cn, Hn) => {
                  try {
                    this.processor_ = new MediaStreamTrackProcessor(Ct);
                  } catch (Sr) {
                    console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${Sr}`), Hn(Sr);
                  }
                  try {
                    Ct.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "audio" }) : Ct.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({ kind: "video" }) : Hn("kind not supported");
                  } catch (Sr) {
                    console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${Sr}`), Hn(Sr);
                  }
                  cn();
                });
              }
              getReadable() {
                return this.processor_.readable;
              }
              getWriteable() {
                return this.generator_.writable;
              }
              getProccesorTrack() {
                return this.generator_;
              }
            }
            class Fa {
              constructor(Ct) {
                c(this, "insertableStreamHelper_"), c(this, "mediaProcessor_"), this.insertableStreamHelper_ = new xi(), this.mediaProcessor_ = Ct;
              }
              setTrack(Ct) {
                return new n((cn, Hn) => {
                  this.insertableStreamHelper_.init(Ct).then(() => {
                    this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
                      cn(this.insertableStreamHelper_.getProccesorTrack());
                    }).catch((Sr) => {
                      Hn(Sr);
                    });
                  }).catch((Sr) => {
                    Hn(Sr);
                  });
                });
              }
              destroy() {
                return new n((Ct, cn) => {
                  this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
                    Ct();
                  }).catch((Hn) => {
                    cn(Hn);
                  }) : cn("no processor");
                });
              }
            }
          }.call(this, e(2), e(27));
        },
        /* 730 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(731)), o = n(e(732));
          const l = {
            backgroundBlur: o.default,
            backgroundReplacement: t.default
          }, c = (g) => !!l[g], d = (g) => c(g) ? l[g] : null;
          var A = {
            isSupported: c,
            getConfigurator: d,
            isValidConfig: (g) => {
              const f = g.type;
              return c(f) ? d(f).isValidConfig(g) : !1;
            }
          };
          r.default = A;
        },
        /* 731 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(180));
          const o = (h) => Object.assign({}, t.default.getConfig(h), {
            transformerType: "VirtualBackground"
          }), l = (h) => (
            // Check if image is a BLOB
            /^data:image\/(?:png|jpeg|bmp|gif);base64/.test(h) || // Check if URL is a supported image type
            /\.(?:png|jpe?g|bmp|gif)$/i.test(h)
          );
          var u = {
            isValidConfig: (h) => {
              if ((h == null ? void 0 : h.type) !== "backgroundReplacement")
                return !1;
              const A = h.backgroundImgUrl;
              return l(A);
            },
            getConfig: function(A) {
              A === void 0 && (A = {});
              const g = o(A), f = A, p = f.backgroundImgUrl;
              return l(p) && (g.backgroundAssetUri = p), g;
            }
          };
          r.default = u;
        },
        /* 732 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = e(336), o = n(e(180));
          const l = t.BlurRadius.High, c = (f) => Object.assign({}, o.default.getConfig(f), {
            transformerType: "BackgroundBlur",
            radius: l
          }), d = (f) => f === "low" || f === "high", u = (f) => f === "low" ? t.BlurRadius.Low : t.BlurRadius.High;
          var g = {
            isValidConfig: (f) => {
              if ((f == null ? void 0 : f.type) !== "backgroundBlur")
                return !1;
              const p = f.blurStrength;
              return p ? d(p) : !0;
            },
            getConfig: function(p) {
              p === void 0 && (p = {});
              const v = c(p), b = p, m = b.blurStrength;
              return d(m) && (v.radius = u(m)), v;
            }
          };
          r.default = g;
        },
        /* 733 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => t ? !!t.apiKey : !1;
          r.default = n;
        },
        /* 734 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(735)), c = n(e(21));
          const d = (0, l.default)(), u = (0, c.default)(), h = u.getNativeMediaDevices;
          var A = (g) => {
            let f = !1;
            const p = /* @__PURE__ */ function() {
              var m = (0, o.default)(/* @__PURE__ */ t.default.mark(function y() {
                var U;
                return t.default.wrap(function(Q) {
                  for (; ; ) switch (Q.prev = Q.next) {
                    case 0:
                      if (!f) {
                        Q.next = 2;
                        break;
                      }
                      return Q.abrupt("return");
                    case 2:
                      return f = !0, Q.next = 5, d();
                    case 5:
                      return U = Q.sent, f = !1, Q.next = 9, g.setAudioSource(U);
                    case 9:
                    case "end":
                      return Q.stop();
                  }
                }, y);
              }));
              return function() {
                return m.apply(this, arguments);
              };
            }(), v = h();
            return v.addEventListener("devicechange", p), () => {
              v.removeEventListener("devicechange", p);
            };
          };
          r.default = A;
        },
        /* 735 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(21)), c = n(e(254)), d = function(h) {
            h === void 0 && (h = {});
            const A = h.deviceHelpers || (0, l.default)(), g = A.getAudioInputMediaDevices, f = A.getDefaultAudioInputDevice, p = A.hasDevice, v = h.currentAudioOutputDevice || c.default, b = v.getCurrentAudioInputDevice, m = v.setCurrentAudioInputDevice;
            return /* @__PURE__ */ function() {
              var U = (0, o.default)(/* @__PURE__ */ t.default.mark(function B() {
                var Q, N, J, w;
                return t.default.wrap(function(G) {
                  for (; ; ) switch (G.prev = G.next) {
                    case 0:
                      return G.next = 2, g();
                    case 2:
                      if (Q = G.sent, Q.length !== 0) {
                        G.next = 6;
                        break;
                      }
                      return m(""), G.abrupt("return");
                    case 6:
                      if (N = b(), J = p(Q, N.deviceId), w = f(Q), !(J && N.label === w.label)) {
                        G.next = 11;
                        break;
                      }
                      return G.abrupt("return");
                    case 11:
                      return m(w), G.abrupt("return", w.deviceId);
                    case 13:
                    case "end":
                      return G.stop();
                  }
                }, B);
              }));
              return function() {
                return U.apply(this, arguments);
              };
            }();
          };
          r.default = d;
        },
        /* 736 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(1));
          let c = function(u) {
            var h = this;
            u === void 0 && (u = {}), this.replaceTrackInMutedAudioTracks = /* @__PURE__ */ function() {
              var A = (0, o.default)(/* @__PURE__ */ t.default.mark(function g(f, p, v) {
                var b, m;
                return t.default.wrap(function(U) {
                  for (; ; ) switch (U.prev = U.next) {
                    case 0:
                      if (!(h.mutedMantisAudioTracksInAMR[v.id] && f != null && f.hasTrack(h.mutedMantisAudioTracksInAMR[v.id]))) {
                        U.next = 2;
                        break;
                      }
                      return U.abrupt("return");
                    case 2:
                      return b = v.clone(), b.enabled = !1, m = h.mutedMantisAudioTracksInAMR[p.id], U.prev = 5, U.next = 8, f.findAndReplaceTrack(m, b);
                    case 8:
                      U.next = 14;
                      break;
                    case 10:
                      return U.prev = 10, U.t0 = U.catch(5), h.logging.error(`Error swapping AMR audio track: ${U.t0}`), U.abrupt("return");
                    case 14:
                      h.mutedMantisAudioTracksInAMR[v.id] = b, delete h.mutedMantisAudioTracksInAMR[p.id];
                    case 16:
                    case "end":
                      return U.stop();
                  }
                }, g, null, [[5, 10]]);
              }));
              return function(g, f, p) {
                return A.apply(this, arguments);
              };
            }(), this.unmuteAudioInPeerConnection = /* @__PURE__ */ function() {
              var A = (0, o.default)(/* @__PURE__ */ t.default.mark(function g(f, p) {
                return t.default.wrap(function(b) {
                  for (; ; ) switch (b.prev = b.next) {
                    case 0:
                      f.getAudioTracks().forEach(/* @__PURE__ */ function() {
                        var m = (0, o.default)(/* @__PURE__ */ t.default.mark(function y(U) {
                          return t.default.wrap(function(Q) {
                            for (; ; ) switch (Q.prev = Q.next) {
                              case 0:
                                return Q.prev = 0, Q.next = 3, p.findAndReplaceTrack(h.mutedMantisAudioTracksInAMR[U.id], U);
                              case 3:
                                Q.next = 8;
                                break;
                              case 5:
                                return Q.prev = 5, Q.t0 = Q.catch(0), Q.abrupt("return");
                              case 8:
                                delete h.mutedMantisAudioTracksInAMR[U.id];
                              case 9:
                              case "end":
                                return Q.stop();
                            }
                          }, y, null, [[0, 5]]);
                        }));
                        return function(y) {
                          return m.apply(this, arguments);
                        };
                      }()), h.amrAudioMuted = !1;
                    case 2:
                    case "end":
                      return b.stop();
                  }
                }, g);
              }));
              return function(g, f) {
                return A.apply(this, arguments);
              };
            }(), this.muteAudioInPeerConnection = /* @__PURE__ */ function() {
              var A = (0, o.default)(/* @__PURE__ */ t.default.mark(function g(f, p) {
                return t.default.wrap(function(b) {
                  for (; ; ) switch (b.prev = b.next) {
                    case 0:
                      if (!h.amrAudioMuted) {
                        b.next = 2;
                        break;
                      }
                      return b.abrupt("return");
                    case 2:
                      h.amrAudioMuted = !0, f.getAudioTracks().forEach(/* @__PURE__ */ function() {
                        var m = (0, o.default)(/* @__PURE__ */ t.default.mark(function y(U) {
                          var B;
                          return t.default.wrap(function(N) {
                            for (; ; ) switch (N.prev = N.next) {
                              case 0:
                                return B = U.clone(), B.enabled = !1, N.prev = 2, N.next = 5, p.findAndReplaceTrack(U, B);
                              case 5:
                                N.next = 10;
                                break;
                              case 7:
                                return N.prev = 7, N.t0 = N.catch(2), N.abrupt("return");
                              case 10:
                                h.mutedMantisAudioTracksInAMR[U.id] = B;
                              case 11:
                              case "end":
                                return N.stop();
                            }
                          }, y, null, [[2, 7]]);
                        }));
                        return function(y) {
                          return m.apply(this, arguments);
                        };
                      }());
                    case 4:
                    case "end":
                      return b.stop();
                  }
                }, g);
              }));
              return function(g, f) {
                return A.apply(this, arguments);
              };
            }(), this.destroy = () => {
              Object.entries(this.mutedMantisAudioTracksInAMR).forEach((A) => {
                let g = A[0], f = A[1];
                f == null || f.stop(), delete this.mutedMantisAudioTracksInAMR[g];
              }), this.amrAudioMuted = !1;
            }, this.logging = u.logging || (0, l.default)("AMRTrackProcessor"), this.mutedMantisAudioTracksInAMR = {}, this.amrAudioMuted = !1;
          };
          r.default = c;
        },
        /* 737 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.createCancellationFactory = r.callWithCancellation = void 0;
          var t = n(e(111));
          const o = () => {
            let c = new t.default();
            return () => (c.cancel(), c = new t.default(), c);
          };
          r.createCancellationFactory = o;
          const l = (c) => {
            const d = o();
            return function() {
              const u = d();
              for (var h = arguments.length, A = new Array(h), g = 0; g < h; g++)
                A[g] = arguments[g];
              return c(...A, u);
            };
          };
          r.callWithCancellation = l;
        },
        /* 738 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = ["advancedNoiseSuppression"];
          var t = (o) => n.includes(o == null ? void 0 : o.type);
          r.default = t;
        },
        /* 739 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            let o;
            switch (t) {
              case "motion":
                o = "L3T1";
                break;
              case "detail":
              case "text":
              case "":
              default:
                o = "L1T3";
                break;
            }
            return o;
          };
          r.default = n;
        },
        /* 740 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), c = /* @__PURE__ */ function() {
            var d = (0, o.default)(/* @__PURE__ */ t.default.mark(function u(h, A) {
              var g, f, p;
              return t.default.wrap(function(b) {
                for (; ; ) switch (b.prev = b.next) {
                  case 0:
                    if (!(!h || !A)) {
                      b.next = 2;
                      break;
                    }
                    return b.abrupt("return");
                  case 2:
                    return b.next = 4, A._getVideoSenders();
                  case 4:
                    return g = b.sent, f = g[0], p = f.getParameters(), p.encodings.forEach((m) => {
                      m.scalabilityMode = h;
                    }), b.prev = 8, b.next = 11, f.setParameters(p);
                  case 11:
                    b.next = 16;
                    break;
                  case 13:
                    b.prev = 13, b.t0 = b.catch(8), console.error(`Unable to set scalabilityMode. ${b.t0.message}`);
                  case 16:
                  case "end":
                    return b.stop();
                }
              }, u, null, [[8, 13]]);
            }));
            return function(h, A) {
              return d.apply(this, arguments);
            };
          }();
          r.default = c;
        },
        /* 741 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = (o) => o === null || o === !1;
          r.default = t;
        },
        /* 742 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            var o;
            const l = !!(t && (o = t.videoSource) != null && o.canvas), c = !!(t && "videoContentHint" in t);
            l && !c && (t.videoContentHint = "detail");
          };
          r.default = n;
        },
        /* 743 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(156));
          const o = (c) => !!(c != null && c.scalableScreenshare);
          var l = (c) => {
            var d;
            c || (c = {});
            const u = !!(0, t.default)((d = c) == null ? void 0 : d.videoSource);
            c.capableSimulcastScreenshare = u && o(c);
          };
          r.default = l;
        },
        /* 744 */
        /***/
        function(i, r, e) {
          var n = e(745), t = e(102), o = e(38);
          function l(c, d) {
            return n(c, o(d, 3), t);
          }
          i.exports = l;
        },
        /* 745 */
        /***/
        function(i, r) {
          function e(n, t, o) {
            var l;
            return o(n, function(c, d, u) {
              if (t(c, d, u))
                return l = d, !1;
            }), l;
          }
          i.exports = e;
        },
        /* 746 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(10));
          function o(l) {
            switch (l) {
              case t.default.AUTHENTICATION_ERROR:
              case t.default.INVALID_SESSION_ID:
              case t.default.TERMS_OF_SERVICE_FAILURE:
              case t.default.UNEXPECTED_SERVER_RESPONSE:
                return l;
              case t.default.ANVIL_EMPTY_RESPONSE_BODY:
              case t.default.ANVIL_CONNECT_FAILED:
                return t.default.CONNECT_FAILED;
              case t.default.ANVIL_BADLY_FORMED_RESPONSE:
              case t.default.ANVIL_INVALID_HTTP_STATUS:
              case t.default.ANVIL_XDOMAIN_OR_PARSING_ERROR:
              case t.default.ANVIL_UNKNOWN_HTTP_ERROR:
              case t.default.ANVIL_UNEXPECTED_ERROR_CODE:
              default:
                return t.default.UNEXPECTED_SERVER_RESPONSE;
            }
          }
        },
        /* 747 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(20)), l = t(e(75)), c = (d) => {
              let u = d.RTCPeerConnection, h = d.env, A = d.stream, g = d.codecFlags;
              if (h.isLegacyEdge)
                return !0;
              let f, p;
              const v = () => {
                try {
                  f.close();
                } catch {
                }
                try {
                  p.close();
                } catch {
                }
                f = null, p = null;
              };
              try {
                const b = {
                  iceServers: []
                };
                (0, l.default)() && (b.sdpSemantics = "plan-b"), f = new u(b), p = new u(b), A.getTracks().forEach((m) => f.addTrack(m, A));
              } catch {
                return v(), n.resolve(!1);
              }
              return f.createOffer().then((b) => {
                const m = {
                  type: b.type,
                  sdp: b.sdp
                };
                return Object.keys(g).forEach((y) => {
                  g[y] || (m.sdp = o.default.removeVideoCodec(m.sdp, y));
                }), p.setRemoteDescription(m);
              }).then(() => !0).catch(() => !1).then((b) => (v(), b));
            };
            r.default = c;
          }).call(this, e(2));
        },
        /* 748 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(8));
          const o = t.default.INVALID_PARAMETER;
          var c = (d) => {
            let u = d.otError;
            return (h) => {
              if (!h)
                return;
              const A = (g, f) => {
                if (!g)
                  throw u(o, new Error(`iceConfig invalid: ${f}`));
              };
              "includeServers" in h && A(["all", "custom"].indexOf(h.includeServers) !== -1, ".includeServers must be all or custom"), "transportPolicy" in h && A(["all", "relay"].indexOf(h.transportPolicy) !== -1, ".transportPolicy must be all or relay"), A(Array.isArray(h.customServers), ".customServers must be an array"), h.customServers.forEach((g) => {
                A(g.urls || !("url" in g), "ice servers need .urls, not .url"), A(typeof g.urls == "string" || Array.isArray(g.urls), "ice server .urls must be a string or an array"), A(!g.username || typeof g.username == "string", "ice server .username must be a string if present"), A(!g.credential || typeof g.credential == "string", "ice server .credential must be a string if present");
              });
            };
          };
          r.default = c;
        },
        /* 749 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(750)), o = (l, c) => {
            const d = l || {}, u = d.p2pEnabled, h = d.singlePeerConnection;
            return u ? !1 : !!h && !(c === !1) && (0, t.default)();
          };
          r.default = o;
        },
        /* 750 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(751)), l = () => {
            if (!(t.default.isChromium || t.default.isFirefox || t.default.isSafari))
              return !1;
            const d = t.default.name, u = t.default.version, h = o.default[d];
            return u >= h;
          };
          r.default = l;
        },
        /* 751 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = {
            Chrome: 118,
            Firefox: 118,
            Safari: 17,
            Edge: 118,
            Opera: 104
          };
          r.default = n;
        },
        /* 752 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(10)), o = n(e(8)), l = {
            NOT_CONNECTED: {
              code: o.default.NOT_CONNECTED,
              message: "Cannot use forceMute functionality. You are not connected to the session.",
              exceptionCode: t.default.NOT_CONNECTED
            },
            PERMISSION_DENIED: {
              code: o.default.PERMISSION_DENIED,
              message: "This token does not allow forceMute usage. The role must be at least `moderator` to enable this functionality",
              exceptionCode: t.default.UNABLE_TO_FORCE_MUTE
            },
            INVALID_PARAMETER: {
              code: o.default.INVALID_PARAMETER,
              message: "Invalid Parameter. Check that you have passed valid parameter values into the method call.",
              exceptionCode: t.default.INVALID_PARAMETER
            },
            NOT_FOUND: {
              code: o.default.NOT_FOUND,
              message: "The stream does not exist."
            },
            UNEXPECTED_SERVER_RESPONSE: {
              code: o.default.UNEXPECTED_SERVER_RESPONSE,
              message: "An unexpected error occurred.",
              exceptionCode: t.default.UNEXPECTED_SERVER_RESPONSE
            }
          };
          r.default = l;
        },
        /* 753 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = 8, t = 256;
          var l = (c) => {
            if (typeof c != "string")
              throw new Error("secret must be a string");
            if (c.length < n)
              throw new Error("secret must have at least 8 characters");
            if (c.length > t)
              throw new Error("secret must not exceed 256 characters");
          };
          r.default = l;
        },
        /* 754 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = N;
            var o = t(e(17)), l = t(e(9)), c = t(e(51)), d = t(e(16)), u = t(e(341)), h = t(e(755)), A = t(e(1)), g = t(e(10)), f = t(e(112)), p = t(e(339)), v = t(e(769)), b = t(e(340)), m = t(e(343)), y = t(e(344)), U = t(e(7)), B = t(e(345)), Q = t(e(776));
            function N(J) {
              J === void 0 && (J = {});
              const w = J.convertRumorError || b.default, W = J.Dispatcher || m.default, G = J.ExceptionCodes || g.default, Z = J.hasIceRestartsCapability || p.default, K = J.hasRenegotiationCapability || v.default, L = J.hasE2eeCapability || f.default, O = J.logging || (0, A.default)("RaptorSocket"), de = J.Message || y.default, oe = J.OTHelpers || U.default, fe = J.RumorSocket || (0, h.default)(), ge = J.Signal || B.default, we = J.SignalError || Q.default, _e = function Te(Pe) {
                var $e = this;
                let Bt = Pe.connectionId, Le = Pe.sessionId, at = Pe.messagingSocketUrl, pt = Pe.symphonyUrl, kt = Pe.dispatcher, _t = Pe.analytics, Lt = Pe.requestedCapabilities, Ft = Lt === void 0 ? [] : Lt, Zt, ft, It, Kt, Sn, Cn, on, An;
                const Ue = ["disconnected", "connecting", "connected", "error", "disconnecting"], ne = kt || new W(), se = oe.statable(this, Ue, "disconnected"), Ce = function(er) {
                  (!er.action || !er.variation) && O.debug("Expected action and variation"), _t.logEvent((0, l.default)({
                    sessionId: ft,
                    partnerId: Zt,
                    p2p: Cn,
                    messagingServer: on,
                    connectionId: Bt
                  }, er));
                }, At = function() {
                  for (var er = arguments.length, lr = new Array(er), Br = 0; Br < er; Br++)
                    lr[Br] = arguments[Br];
                  const pi = lr[0];
                  se(pi ? "error" : "connected"), Sn(...lr);
                }, Ge = (Tn) => {
                  let er = "clientDisconnected";
                  !this.is("disconnecting") && An && (er = "networkDisconnected"), Tn && Tn.code === 4001 && (er = "networkTimedout"), se("disconnected"), ne.onClose(er);
                }, Ye = (Tn) => {
                  An = !0, O.error(Tn);
                }, Qt = () => {
                  ne.onReconnecting();
                }, tn = () => {
                  Ce({
                    action: "Reconnect",
                    variation: "Success",
                    retries: this._rumor.reconnectRetriesCount(),
                    messageQueueSize: this._rumor.messageQueueSize(),
                    socketId: this.socketId
                  }), ne.onReconnected();
                }, vn = () => {
                  Ce({
                    action: "Reconnect",
                    variation: "Attempt",
                    retries: this._rumor.reconnectRetriesCount(),
                    messageQueueSize: this._rumor.messageQueueSize(),
                    socketId: this.socketId
                  });
                }, Yt = (Tn) => {
                  Tn.message === "connectionLimitExceeded" && (Tn.code = G.CONNECTION_LIMIT_EXCEEDED), Tn.reason = "ConnectToSession";
                  const er = w(Tn);
                  Ce({
                    action: "Reconnect",
                    variation: "Failure",
                    failureReason: Tn.reason,
                    failureCode: er.code,
                    failureMessage: er.message,
                    messageQueueSize: this._rumor.messageQueueSize(),
                    socketId: this.socketId
                  });
                };
                Object.defineProperty(this, "socketId", {
                  get() {
                    return this._rumor.socketID;
                  }
                }), this.connect = function(er, lr, Br, pi) {
                  if (!this.is("disconnected", "error")) {
                    O.warn("Cannot connect the Raptor Socket as it is currently connected. You should disconnect first.");
                    return;
                  }
                  se("connecting"), Zt = lr.partnerId, ft = lr.sessionId, Cn = lr.p2pEnabled, on = lr.messagingServer, It = er, Sn = pi, Kt = {
                    apiKey: Zt,
                    sessionId: ft
                  };
                  const $n = `/v2/partner/${Zt}/session/${ft}`;
                  this._rumor = new Te.RumorSocket({
                    messagingURL: at,
                    notifyDisconnectAddress: pt,
                    connectionId: Bt,
                    sessionId: Le,
                    enableReconnection: lr.reconnection
                  }), this._rumor.on("close", Ge), this._rumor.on("error", Ye), this._rumor.on("reconnecting", Qt), this._rumor.on("reconnectAttempt", vn), this._rumor.on("reconnectFailure", Yt), this._rumor.on("reconnected", tn), this._rumor.on("message", ne.dispatch.bind(ne));
                  const rr = (Kr) => {
                    At({
                      reason: "WebSocketConnection",
                      code: Kr.code,
                      message: Kr.message
                    });
                  };
                  this._rumor.once("error", rr), this._rumor.once("open", () => {
                    this._rumor.removeListener("error", rr), O.debug(`connected. Subscribing to ${$n} on ${at}`), this._rumor.subscribe([$n]);
                    const Kr = Ft;
                    (Te.hasIceRestartsCapability() || Te.hasRenegotiationCapability()) && lr.renegotiation && Kr.push("renegotiation"), Te.hasE2eeCapability() && lr.e2ee && Kr.push("e2ee");
                    const xo = de.connections.create({
                      apiKey: Zt,
                      sessionId: ft,
                      connectionId: this._rumor.id,
                      connectionEventsSuppressed: Br.connectionEventsSuppressed,
                      capabilities: Kr
                    }), Yr = new n((Qo) => {
                      const Wo = (xi) => {
                        xi.id === this._rumor.id && (Qo(xi), kt.off("connection#created", Wo));
                      };
                      kt.on("connection#created", Wo);
                    });
                    this.publish(xo, {
                      "X-TB-TOKEN-AUTH": It
                    }, !0, (Qo, Wo) => {
                      if (Qo) {
                        Qo.message === "connectionLimitExceeded" && (Qo.code = G.CONNECTION_LIMIT_EXCEEDED), At({
                          reason: "ConnectToSession",
                          code: Qo.code,
                          message: Qo.message,
                          socketId: this.socketId
                        });
                        return;
                      }
                      const xi = Wo && Wo.data ? JSON.parse(Wo.data) : null;
                      xi && (!xi.connection || xi.connection.length === 0) && (xi.connection = [], Array.isArray(xi.stream) && xi.stream.forEach((sn) => {
                        let Ct = sn.connection;
                        return xi.connection.push(Ct);
                      }));
                      const Fa = (sn, Ct) => {
                        sn ? At({
                          reason: "GetSessionState",
                          code: sn.code,
                          message: sn.message,
                          socketId: this.socketId
                        }) : At(void 0, Ct);
                      };
                      Yr.then((sn) => {
                        xi.connection.some((cn) => cn.id === sn.id) || xi.connection.unshift(sn);
                        const Ct = (0, d.default)();
                        ne.registerCallback(Ct, Fa), ne.emit("session#read", xi, Ct);
                      });
                    });
                  });
                }, this.disconnect = function() {
                  this.is("disconnected") || (se("disconnecting"), this._rumor.disconnect());
                }, this.publish = function(Tn, er, lr, Br) {
                  Br = Br || function() {
                  };
                  const pi = (0, c.default)(Br), $n = (0, d.default)();
                  if (O.debug(`Publish (ID:${$n}) ${Tn}`), this._rumor.readyState !== fe.OPEN || this._rumor.reconnecting && !lr) {
                    const rr = new Error("Not connected.");
                    rr.code = 500, pi(rr), O.error("cannot publish until the socket is connected.");
                    return;
                  }
                  return ne.registerCallback($n, pi), this._rumor.publish([pt], Tn, (0, l.default)({}, er, {
                    "Content-Type": "application/x-raptor+v2",
                    "TRANSACTION-ID": $n,
                    "X-TB-FROM-ADDRESS": this._rumor.id
                  }), lr, function(rr) {
                    rr && pi(...arguments);
                  }), $n;
                }, this.send = function(Tn, er) {
                  let lr = Tn.message, Br = Tn.headers, pi = Tn.retryAfterReconnect, $n = pi === void 0 ? !0 : pi;
                  er === void 0 && (er = () => {
                  }), $e.publish((0, u.default)(lr), Br, $n, er);
                }, this.streamCreate = function(Tn, er) {
                  Tn === void 0 && (Tn = {}), er === void 0 && (er = () => {
                  });
                  const lr = Tn, Br = lr.name, pi = lr.streamId, $n = lr.subscriberAudioFallbackEnabled, rr = lr.channels, Kr = lr.minBitrate, Bi = lr.maxBitrate, Li = lr.sourceStreamId, xo = lr.e2ee, Yr = lr.publisherAudioFallbackEnabled, Qo = lr.customProperties, Wo = {
                    apiKey: Zt,
                    sessionId: ft,
                    streamId: pi,
                    name: Br,
                    audioFallbackEnabled: $n,
                    // deprecated, to be removed when rumor in production
                    subscriberAudioFallbackEnabled: $n,
                    channels: rr,
                    minBitrate: Kr,
                    maxBitrate: Bi,
                    sourceStreamId: Li,
                    e2ee: xo,
                    publisherAudioFallbackEnabled: Yr,
                    customProperties: Qo
                  }, xi = de.streams.create(Wo);
                  this.publish(xi, {}, !0, (Fa, sn) => {
                    er(Fa, pi, sn);
                  });
                }, this.streamDestroy = function(Tn, er) {
                  this.publish(de.streams.destroy(Zt, ft, Tn, er), {}, !0);
                }, this.streamChannelUpdate = function(Tn, er, lr) {
                  this.publish(de.streamChannels.update(Zt, ft, Tn, er, lr), {}, !0);
                }, this.subscriberCreate = function(Tn, er, lr, Br, pi, $n) {
                  const rr = {
                    apiKey: Zt,
                    sessionId: ft,
                    streamId: Tn,
                    subscriberId: er,
                    connectionId: this._rumor.id,
                    channelsToSubscribeTo: lr,
                    sourceStreamId: Br,
                    e2ee: pi
                  };
                  this.publish(de.subscribers.create(rr), {}, !0, $n);
                }, this.subscriberDestroy = function(Tn, er, lr) {
                  this.publish(de.subscribers.destroy(Zt, ft, Tn, er, lr), {}, !0);
                }, this.subscriberUpdate = function(Tn, er, lr) {
                  this.publish(de.subscribers.update(Zt, ft, Tn, er, lr), {}, !0);
                }, this.subscriberChannelUpdate = function(Tn, er, lr, Br) {
                  this.publish(de.subscriberChannels.update(Zt, ft, Tn, er, lr, Br), {}, !0);
                }, this.forceDisconnect = function(Tn, er) {
                  this.publish(de.connections.destroy({
                    apiKey: Zt,
                    sessionId: ft,
                    connectionId: Tn
                  }), {}, !0, er);
                }, this.forceUnpublish = function(Tn, er) {
                  this.publish(de.streams.destroy(Zt, ft, Tn), {}, !0, er);
                }, this.forceMuteStream = function(Tn, er) {
                  const lr = {
                    streamId: Tn,
                    active: !0
                  };
                  this.publish(de.forceMute.update(Object.assign({}, Kt, lr)), {}, !0, er);
                }, this.forceMuteAll = function(Tn, er, lr) {
                  const Br = {
                    excludedStreamIds: Tn,
                    active: er
                  };
                  this.publish(de.forceMute.update(Object.assign({}, Kt, Br)), {}, !0, lr);
                }, this.signal = function(Tn, er, lr) {
                  const Br = new ge(ft, this._rumor.id, Tn || {});
                  if (!Br.valid) {
                    er && (0, o.default)(er) && er(new we(Br.error.code, Br.error.reason), Br.toHash());
                    return;
                  }
                  this.publish(Br.toRaptorMessage(), {}, Br.retryAfterReconnect, (pi) => {
                    let $n, rr, Kr;
                    const Bi = [400, 403, 404, 413, 500];
                    if (pi) {
                      const Li = parseInt(pi.code, 10);
                      Bi.includes(Li) ? (rr = Li, Kr = pi.message) : (rr = G.UNEXPECTED_SERVER_RESPONSE, Kr = "Unexpected server response. Try this operation again later."), $n = new we(rr, Kr);
                    } else {
                      const Li = Br.data ? typeof Br.data : null;
                      lr("signal", "send", {
                        type: Li
                      });
                    }
                    er && (0, o.default)(er) && er($n, Br.toHash());
                  });
                }, this.id = function() {
                  return this._rumor && this._rumor.id;
                };
              };
              return _e.hasIceRestartsCapability = Z, _e.hasRenegotiationCapability = K, _e.hasE2eeCapability = L, _e.RumorSocket = fe, _e;
            }
          }).call(this, e(2));
        },
        /* 755 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = A;
          var t = n(e(14)), o = n(e(756)), l = n(e(1)), c = n(e(757)), d = n(e(762)), u = n(e(767)), h = n(e(28));
          function A(g) {
            let f = g === void 0 ? {} : g, p = f.WebSocket, v = p === void 0 ? u.default : p;
            const b = (0, o.default)(), m = (0, c.default)({
              AnalyticsHelper: h.default,
              EventEmitter: t.default,
              WebSocket: v,
              logging: l.default,
              allocateId: b
            });
            return (0, d.default)({
              EventEmitter: t.default,
              ReconnectableSocket: m,
              logging: l.default,
              allocateId: b
            });
          }
        },
        /* 756 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n() {
            let t = 0;
            return () => (t += 1, t);
          }
        },
        /* 757 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(29)), c = n(e(179)), d = n(e(30)), u = n(e(342)), h = e(78), A = n(e(758)), g = n(e(57)), f = n(e(759)), p = n(e(761));
          const v = (U) => function() {
            U(...arguments);
          }, b = (U) => U === 1e3 || U >= 3e3 && U <= 4999, m = h.codes.CLOSE_TIMEOUT;
          var y = (U) => {
            var B;
            let Q = U.AnalyticsHelper, N = U.EventEmitter, J = U.WebSocket, w = U.logging, W = U.allocateId, G = U.BUFFER_DRAIN_INTERVAL, Z = G === void 0 ? 100 : G, K = U.BUFFER_DRAIN_MAX_RETRIES, L = K === void 0 ? 10 : K;
            return B = /* @__PURE__ */ function(O) {
              (0, d.default)(de, O);
              function de(fe) {
                var ge;
                ge = O.call(this) || this, ge._url = void 0, ge._id = W(), ge._logger = w(`ReconnectableSocket:${ge._id}`), ge._webSocket = void 0, ge._connectTimer = void 0, ge._pingTimer = void 0, ge._pingWarningTimer = void 0, ge._disconnectTimer = void 0, ge._queuedMessages = [], ge._draining = !1, ge._analytics = new Q(), ge._logAnalyticsEvent = (ft) => {
                  let It = ft.action, Kt = ft.variation, Sn = ft.payload;
                  ge._analytics.logEvent({
                    action: It,
                    variation: Kt,
                    payload: Sn,
                    sessionId: ge.sessionId,
                    connectionId: ge.connectionId
                  });
                };
                const we = fe.url, _e = fe.connectionId, Te = fe.sessionId, Pe = fe.connectTimeout, $e = Pe === void 0 ? 15e3 : Pe, Bt = fe.pingThreshold, Le = Bt === void 0 ? 3e3 : Bt, at = fe.pingWarningDelay, pt = at === void 0 ? 100 : at, kt = fe.disconnectThreshold, _t = kt === void 0 ? 5900 : kt, Lt = fe.reconnectMaxDuration, Ft = Lt === void 0 ? 6e4 : Lt;
                if (!we)
                  throw new Error("Must provide url");
                ge.connectionId = _e, ge.sessionId = Te, ge.readyStateMachine = (0, f.default)({
                  reconnectMaxDuration: Ft,
                  CLOSED: de.CLOSED,
                  CLOSING: de.CLOSING
                }), ge._url = we, (0, u.default)({
                  logger: ge._logger,
                  obj: (0, c.default)(ge),
                  eventNames: ["error", "open", "message", "needsPing", "reconnecting", "reconnectAttempt", "reconnectFailure", "reconnected", "close"]
                }), ge.readyStateMachine.observe("onEnterOpen", (ft) => {
                  let It = ft.from;
                  ge._resetPingTimers(), ge._resetDisconnectTimer(), ge._connectTimer.clear(), It === "reconnecting" ? (ge._queuedMessages.forEach((Kt) => ge.send(Kt, !0)), ge._queuedMessages = [], ge.emit("reconnected"), ge._logAnalyticsEvent({
                    action: "WebSocket:reconnect",
                    variation: "Success"
                  })) : (ge.emit("open"), ge._logAnalyticsEvent({
                    action: "WebSocket:open"
                  }));
                }), ge.readyStateMachine.observe("onEnterClosed", (ft, It) => {
                  let Kt = ft.from, Sn = ft.code, Cn = ft.reason;
                  ge.emit("close", It), Kt === "reconnecting" && ge._logAnalyticsEvent({
                    action: "WebSocket:reconnect",
                    variation: "Failure",
                    payload: {
                      code: Sn,
                      reason: Cn
                    }
                  });
                }), ge.readyStateMachine.observe("onEnterClosing", v(/* @__PURE__ */ function() {
                  var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function It(Kt, Sn) {
                    var Cn, on, An;
                    return t.default.wrap(function(ne) {
                      for (; ; ) switch (ne.prev = ne.next) {
                        case 0:
                          return Cn = Kt.from, on = Sn.code, An = Sn.reason, ge._clearTimers(), ne.next = 5, ge._clearSocket({
                            drain: Cn === "open",
                            code: on,
                            reason: An
                          });
                        case 5:
                          Cn === "reconnecting" && (ge.emit("reconnectFailure", {
                            code: on,
                            reason: An
                          }), ge._logAnalyticsEvent({
                            action: "WebSocket:reconnect",
                            variation: "Failure"
                          })), setTimeout(() => {
                            ge.readyStateMachine.closed({
                              code: on,
                              reason: An
                            });
                          });
                        case 7:
                        case "end":
                          return ne.stop();
                      }
                    }, It);
                  }));
                  return function(It, Kt) {
                    return ft.apply(this, arguments);
                  };
                }())), ge.readyStateMachine.observe("onEnterReconnecting", () => {
                  ge.emit("reconnecting"), ge._logAnalyticsEvent({
                    action: "WebSocket:reconnect",
                    variation: "Attempt"
                  });
                }), ge.readyStateMachine.observe("onDisconnect", v(/* @__PURE__ */ function() {
                  var ft = (0, o.default)(/* @__PURE__ */ t.default.mark(function It(Kt, Sn) {
                    var Cn, on, An, Ue;
                    return t.default.wrap(function(se) {
                      for (; ; ) switch (se.prev = se.next) {
                        case 0:
                          if (Cn = Kt.from, on = Kt.to, An = Sn.code, Ue = Sn.reason, on !== "reconnecting") {
                            se.next = 12;
                            break;
                          }
                          if (!ge._draining) {
                            se.next = 5;
                            break;
                          }
                          return se.abrupt("return");
                        case 5:
                          return ge._clearTimers(), ge.emit("reconnectAttempt"), se.next = 9, ge._clearSocket({
                            drain: Cn === "open",
                            code: An,
                            reason: Ue
                          });
                        case 9:
                          ge._createSocket(), se.next = 13;
                          break;
                        case 12:
                          ge._logAnalyticsEvent({
                            action: "WebSocket:disconnect",
                            payload: {
                              code: An,
                              reason: Ue
                            }
                          });
                        case 13:
                        case "end":
                          return se.stop();
                      }
                    }, It);
                  }));
                  return function(It, Kt) {
                    return ft.apply(this, arguments);
                  };
                }()));
                const Zt = (ft, It) => new A.default({
                  name: ft,
                  duration: It,
                  logger: ge._logger
                });
                return ge._connectTimer = Zt("connect", $e), ge._pingTimer = Zt("ping", Le), ge._pingWarningTimer = Zt("pingWarning", pt), ge._disconnectTimer = Zt("disconnect", _t), ge._createSocket(), ge;
              }
              var oe = de.prototype;
              return oe._createSocket = function() {
                const ge = new J(this.url);
                ge.binaryType = "arraybuffer";
                const we = (0, g.default)(ge);
                we.on("open", () => {
                  this.readyStateMachine.open();
                }), we.on("close", (_e) => {
                  let Te = _e.code, Pe = _e.reason;
                  this.readyStateMachine.disconnect({
                    code: Te,
                    reason: Pe
                  });
                }), we.on("error", (_e) => {
                  this.emit("error", _e);
                }), we.on("message", (_e) => {
                  this.readyState !== de.CLOSING && this._resetDisconnectTimer(), this.emit("message", _e);
                }), this._webSocket = ge, this._webSocketEvents = we, this._connectTimer.reset(() => {
                  const _e = {
                    code: m,
                    reason: "Timeout while opening connection"
                  }, Te = new Error(_e.reason);
                  Te.code = m, this.emit("error", Te), this.readyStateMachine.disconnect(_e);
                });
              }, oe._clearSocket = /* @__PURE__ */ function() {
                var fe = (0, o.default)(/* @__PURE__ */ t.default.mark(function we(_e) {
                  var Te, Pe, $e, Bt, Le;
                  return t.default.wrap(function(pt) {
                    for (; ; ) switch (pt.prev = pt.next) {
                      case 0:
                        if (Te = _e === void 0 ? {} : _e, Pe = Te.drain, $e = Pe === void 0 ? !1 : Pe, Bt = Te.code, Le = Te.reason, this._draining = !0, this._webSocketEvents && this._webSocketEvents.removeAll(), this._webSocket.readyState === de.CLOSED) {
                          pt.next = 9;
                          break;
                        }
                        if (!$e) {
                          pt.next = 7;
                          break;
                        }
                        return pt.next = 7, (0, p.default)(this._webSocket, {
                          BUFFER_DRAIN_INTERVAL: Z,
                          BUFFER_DRAIN_MAX_RETRIES: L
                        });
                      case 7:
                        this._logAnalyticsEvent({
                          action: "WebSocket:close",
                          payload: {
                            code: Bt,
                            reason: Le
                          },
                          variation: "Attempt"
                        });
                        try {
                          !b(Bt) || Bt === void 0 && Le === void 0 ? this._webSocket.close() : this._webSocket.close(Bt, Le), this._logAnalyticsEvent({
                            action: "WebSocket:close",
                            payload: {
                              code: Bt,
                              reason: Le
                            },
                            variation: "Success"
                          });
                        } catch (kt) {
                          w.error("Could not close websocket", kt), this._logAnalyticsEvent({
                            action: "WebSocket:close",
                            payload: {
                              err: kt
                            },
                            variation: "Failure"
                          });
                        }
                      case 9:
                        this._draining = !1;
                      case 10:
                      case "end":
                        return pt.stop();
                    }
                  }, we, this);
                }));
                function ge(we) {
                  return fe.apply(this, arguments);
                }
                return ge;
              }(), oe.send = function(ge, we) {
                we === void 0 && (we = !0), this.readyState === de.OPEN && this._resetPingTimers();
                const _e = () => {
                  try {
                    return this._webSocket.send(ge), "sent";
                  } catch (Te) {
                    if (this._webSocket.readyState === J.OPEN)
                      return this._logger.debug("webSocket.send threw exception even though it was open:", Te), "dropped";
                    throw Te;
                  }
                };
                if (this.readyStateMachine.state === "reconnecting") {
                  if (this._webSocket.readyState === J.OPEN)
                    try {
                      _e();
                    } catch {
                    }
                  return we ? (this._queuedMessages.push(ge), "queued") : (this._logger.debug("Dropping message during reconnection since retryAfterReconnect is false:", ge), "dropped");
                }
                return _e();
              }, oe.close = function(ge, we) {
                if (this.readyState === de.CLOSING)
                  throw new Error("Can not call close on a closing ReconnectableSocket");
                if (this.readyState === de.CLOSED)
                  throw new Error("Can not call close on an already closed ReconnectableSocket");
                this.readyStateMachine.close({
                  code: ge,
                  reason: we
                });
              }, oe._resetPingTimers = function() {
                this._pingWarningTimer.clear(), this._pingTimer.reset(() => {
                  this._pingWarningTimer.reset(() => {
                    this._logger.warn("Did not send message after needsPing event. Other side may disconnect.");
                  }), this.emit("needsPing");
                });
              }, oe._resetDisconnectTimer = function() {
                this._disconnectTimer.reset(() => this.readyStateMachine.disconnect({
                  code: m,
                  reason: "No activity"
                }));
              }, oe._clearTimers = function() {
                [this._disconnectTimer, this._connectTimer, this._pingTimer, this._pingWarningTimer].forEach((ge) => ge.clear());
              }, (0, l.default)(de, [{
                key: "url",
                get: function() {
                  return typeof this._url == "function" ? this._url() : this._url;
                }
              }, {
                key: "reconnecting",
                get: function() {
                  return this.readyStateMachine.state === "reconnecting";
                }
              }, {
                key: "binaryType",
                get: function() {
                  return this._webSocket.binaryType;
                }
              }, {
                key: "bufferedAmount",
                get: function() {
                  return this._webSocket.bufferedAmount;
                }
              }, {
                key: "protocol",
                get: function() {
                  return this._webSocket.protocol;
                }
              }, {
                key: "extensions",
                get: function() {
                  return this._webSocket.extensions;
                }
              }, {
                key: "readyState",
                get: function() {
                  return {
                    reconnecting: de.OPEN,
                    open: de.OPEN,
                    closing: de.CLOSING,
                    closed: de.CLOSED,
                    connecting: de.CONNECTING
                  }[this.readyStateMachine.state];
                }
              }]), de;
            }(N), B.CONNECTING = J.CONNECTING, B.OPEN = J.OPEN, B.CLOSING = J.CLOSING, B.CLOSED = J.CLOSED, B;
          };
          r.default = y;
        },
        /* 758 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          let n = /* @__PURE__ */ function() {
            function t(l) {
              let c = l.name, d = l.logger, u = l.duration;
              this.name = void 0, this.logger = void 0, this.duration = void 0, this.currId = void 0, this.name = c, this.logger = d, this.duration = u;
            }
            var o = t.prototype;
            return o.reset = function(c) {
              this.clear();
              const d = setTimeout(() => {
                this.currId !== void 0 && (this.logger.spam(`${this.name} timer with id ${this.currId} expired, entering callback`), this.currId = void 0, c());
              }, this.duration);
              this.currId = d, this.logger.spam(`Started ${this.name} timer with id ${this.currId}, expires in ${this.duration}ms`);
            }, o.clear = function() {
              this.currId !== void 0 && (clearTimeout(this.currId), this.logger.spam(`Cleared ${this.name} timer with id ${this.currId}`), this.currId = void 0);
            }, o.isRunning = function() {
              return this.currId !== void 0;
            }, t;
          }();
          r.default = n;
        },
        /* 759 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(326)), o = n(e(760)), l = e(78), c = n(e(1));
          const d = (0, c.default)("ReconnectableSocketStateMachine"), u = l.codes.CLOSE_UNSUPPORTED, h = l.codes.CLOSE_UNEXPECTED_CONDITION;
          var A = (g) => {
            let f = g.reconnectMaxDuration, p = g.CLOSED, v = g.CLOSING, b;
            function m(y) {
              let U = y.code;
              return (this.state === "open" || !b) && (b = (0, o.default)(f)), f > 0 && !b() && [u, h].indexOf(U) === -1 && [p, v].indexOf(this.readyState) === -1 ? "reconnecting" : "closing";
            }
            return new t.default({
              init: "connecting",
              methods: {
                onInvalidTransition(y, U, B) {
                  d.error("Invalid state transition", {
                    transition: y,
                    from: U,
                    to: B
                  });
                }
              },
              transitions: [{
                name: "open",
                from: ["connecting", "reconnecting"],
                to: "open"
              }, {
                name: "close",
                from: ["connecting", "reconnecting", "open"],
                to: "closing"
              }, {
                name: "closed",
                from: "closing",
                to: "closed"
              }, {
                name: "disconnect",
                from: ["reconnecting", "open", "connecting"],
                to: m
              }]
            });
          };
          r.default = A;
        },
        /* 760 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = (t) => {
            let o = !1;
            return setTimeout(() => {
              o = !0;
            }, t), () => o;
          };
          r.default = n;
        },
        /* 761 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(94)), c = /* @__PURE__ */ function() {
            var d = (0, o.default)(/* @__PURE__ */ t.default.mark(function u(h, A) {
              var g, f, p, v, b, m;
              return t.default.wrap(function(U) {
                for (; ; ) switch (U.prev = U.next) {
                  case 0:
                    g = A === void 0 ? {} : A, f = g.BUFFER_DRAIN_INTERVAL, p = f === void 0 ? 100 : f, v = g.BUFFER_DRAIN_MAX_RETRIES, b = v === void 0 ? 10 : v, m = 0;
                  case 2:
                    if (!(m < b)) {
                      U.next = 10;
                      break;
                    }
                    if (h.bufferedAmount !== 0) {
                      U.next = 5;
                      break;
                    }
                    return U.abrupt("break", 10);
                  case 5:
                    return U.next = 7, (0, l.default)(p);
                  case 7:
                    m += 1, U.next = 2;
                    break;
                  case 10:
                  case "end":
                    return U.stop();
                }
              }, u);
            }));
            return function(u, h) {
              return d.apply(this, arguments);
            };
          }();
          r.default = c;
        },
        /* 762 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(29)), o = n(e(179)), l = n(e(30)), c = n(e(16)), d = n(e(342)), u = n(e(763)), h = p(e(183)), A = n(e(766)), g = e(78);
          function f(b) {
            if (typeof WeakMap != "function") return null;
            var m = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap();
            return (f = function(B) {
              return B ? y : m;
            })(b);
          }
          function p(b, m) {
            if (b && b.__esModule)
              return b;
            if (b === null || typeof b != "object" && typeof b != "function")
              return { default: b };
            var y = f(m);
            if (y && y.has(b))
              return y.get(b);
            var U = {}, B = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var Q in b)
              if (Q !== "default" && Object.prototype.hasOwnProperty.call(b, Q)) {
                var N = B ? Object.getOwnPropertyDescriptor(b, Q) : null;
                N && (N.get || N.set) ? Object.defineProperty(U, Q, N) : U[Q] = b[Q];
              }
            return U.default = b, y && y.set(b, U), U;
          }
          var v = (b) => {
            var m;
            let y = b.EventEmitter, U = b.ReconnectableSocket, B = b.logging, Q = b.allocateId;
            return m = /* @__PURE__ */ function(N) {
              (0, l.default)(J, N);
              function J(W) {
                var G;
                let Z = W.messagingURL, K = W.notifyDisconnectAddress, L = W.connectionId, O = W.sessionId, de = W.enableReconnection, oe = W.pingThreshold, fe = oe === void 0 ? 2e3 : oe, ge = W.disconnectThreshold, we = ge === void 0 ? (de ? 3 : 25) * fe - 100 : ge, _e = W.reconnectMaxDuration, Te = _e === void 0 ? de ? 6e4 : 0 : _e;
                G = N.call(this) || this, G.url = void 0, G.id = void 0, G._opened = !1, G._socket = void 0, G._reconnectAttempts = 0, G._socketID = (0, c.default)(), G._receivedTransactionIDs = [], G._notifyDisconnectAddress = void 0, G._enableReconnection = void 0, G._pendingMessages = [], G._logger = B(`RumorSocket:${Q()}`), (0, d.default)({
                  logger: G._logger,
                  obj: (0, o.default)(G),
                  eventNames: ["open", "message", "error", "reconnecting", "reconnectAttempt", "reconnectFailure", "reconnected", "close"]
                }), G.url = Z, G.id = L, G._notifyDisconnectAddress = K, G._enableReconnection = de, G.on("error", ($e) => {
                  G._logger.error($e.message);
                });
                try {
                  G._socket = new U({
                    url: () => G._enableReconnection ? [G.url, G.url.indexOf("?") >= 0 ? "&" : "?", `socketId=${G._socketID}`, G._socket && G._socket.reconnecting ? "&reconnect=true" : "", `&attempt=${(0, c.default)()}`].join("") : G.url,
                    pingThreshold: fe,
                    disconnectThreshold: we,
                    reconnectMaxDuration: Te,
                    connectionId: L,
                    sessionId: O
                  });
                } catch ($e) {
                  G._logger.error($e), G.emit("error", new A.default(g.codes.CLOSE_CONNECT_EXCEPTION));
                }
                const Pe = () => {
                  G._opened = !0, G._socket.send(u.default.Connect(G.id, K).serialize()), G.emit("open", G.id);
                };
                return G._socket.once("open", Pe), G._socket.on("message", ($e) => G._receiveMessage($e)), G._socket.once("close", ($e) => {
                  G._logger.debug(`ReconnectableSocket closed (code: ${$e.code})`), G._clearPendingMessages();
                  const Bt = g.codes.CLOSE_NORMAL, Le = g.codes.CLOSE_GOING_AWAY, at = g.codes.CLOSE_TIMEOUT;
                  [Bt, Le, at].indexOf($e.code) === -1 && G.emit("error", new A.default($e.code)), G.emit("close", $e);
                }), G._socket.on("error", ($e) => {
                  let Bt = $e.code;
                  return G.emit("error", new A.default(Bt));
                }), G._socket.on("needsPing", () => {
                  G._socket.send(u.default.Ping().serialize());
                }), G._socket.on("reconnecting", () => {
                  G._opened && (G._clearPendingMessagesWhichShouldntRetry(), G.emit("reconnecting"), G._reconnectAttempts = 0);
                }), G._socket.on("reconnectAttempt", () => {
                  G._opened && (G._reconnectAttempts += 1, G._socket.send(u.default.Disconnect("1").serialize(), !1), G.emit("reconnectAttempt"));
                }), G._socket.on("reconnected", () => {
                  if (!G._opened) {
                    Pe();
                    return;
                  }
                  G._pendingMessages.forEach(($e) => {
                    G._socket.send($e.rumorMessage.serialize());
                  }), G.emit("reconnected");
                }), G._socket.on("reconnectFailure", () => {
                  G._opened && (G._logger.debug(`Reconnecting failed as connectivity was not restored within ${Te}ms`), G.emit("reconnectFailure", new A.default()));
                }), G;
              }
              var w = J.prototype;
              return w._clearPendingMessagesWhichShouldntRetry = function() {
                const G = this._pendingMessages.filter((Z) => !Z.retryAfterReconnect);
                this._pendingMessages = this._pendingMessages.filter((Z) => Z.retryAfterReconnect), G.forEach((Z) => {
                  const K = new Error("Not connected.");
                  K.code = 500, Z.completion(K);
                });
              }, w._clearPendingMessages = function() {
                this._pendingMessages.forEach((G) => {
                  const Z = new Error("Not connected.");
                  Z.code = 500, G.completion(Z);
                }), this._pendingMessages = [];
              }, w._sendAck = function(G) {
                this._socket.send(u.default.Status([G.fromAddress], {
                  "TRANSACTION-ID": G.headers["TRANSACTION-ID"],
                  "X-TB-FROM-ADDRESS": this.id
                }).serialize());
              }, w._receiveMessage = function(G) {
                var Z, K;
                const L = u.default.deserialize(G.data);
                if (L.type === h.PONG)
                  return;
                let O;
                if (L.data)
                  try {
                    O = JSON.parse(L.data);
                  } catch (de) {
                    this._logger.error(`Failed to parse JSON with error ${de}`);
                  }
                if (((Z = O) == null || (K = Z.content) == null ? void 0 : K.type) === "data" ? this._logger.spam("Received:", L) : this._logger.debug("Received:", L), L.transactionId && (this._pendingMessages = this._pendingMessages.filter((de) => (de.rumorMessage.transactionId === L.transactionId && (this._logger.debug("Marking", L.transactionId, " as received"), de.completion(void 0, L)), de.rumorMessage.transactionId !== L.transactionId))), L.transactionId && L.type !== h.STATUS) {
                  if (this._sendAck(L), this._receivedTransactionIDs.indexOf(L.transactionId) >= 0)
                    return;
                  this._receivedTransactionIDs.push(L.transactionId);
                }
                this.emit("message", L);
              }, w.publish = function(G, Z, K, L, O) {
                O === void 0 && (O = () => {
                });
                const de = u.default.Publish(G, Z, K);
                if (this._socket.send(de.serialize(), !1) === "dropped" && !L) {
                  const fe = new Error("Not connected.");
                  fe.code = 500, O(fe);
                  return;
                }
                this._pendingMessages.push({
                  rumorMessage: de,
                  retryAfterReconnect: L,
                  completion: O
                });
              }, w.subscribe = function(G) {
                this._socket.send(u.default.Subscribe(G).serialize());
              }, w.unsubscribe = function(G) {
                this._socket.send(u.default.Unsubscribe(G).serialize());
              }, w.disconnect = function() {
                if (this.readyState === J.OPEN && this._socket.send(u.default.Disconnect().serialize()), this._socket.readyState !== U.CLOSED && this._socket.readyState !== U.CLOSING) {
                  const G = g.codes.CLOSE_NORMAL;
                  this._socket.close(G, g.messages[G]);
                }
              }, w.status = function(G, Z) {
                this._socket.send(u.default.Status(G, {
                  "TRANSACTION-ID": Z,
                  "X-TB-FROM-ADDRESS": this.id
                }).serialize());
              }, w.reconnectRetriesCount = function() {
                return this._reconnectAttempts;
              }, w.messageQueueSize = function() {
                return this._pendingMessages.length;
              }, (0, t.default)(J, [{
                key: "readyState",
                get: function() {
                  return this._socket ? this._socket.readyState : U.CONNECTING;
                }
              }, {
                key: "reconnecting",
                get: function() {
                  return this._opened && this._socket && this._socket.reconnecting;
                }
                // Messages which have not yet been acknowledged
              }, {
                key: "socketID",
                get: function() {
                  return this._socketID;
                }
              }]), J;
            }(y), m.CONNECTING = U.CONNECTING, m.OPEN = U.OPEN, m.CLOSING = U.CLOSING, m.CLOSED = U.CLOSED, m;
          };
          r.default = v;
        },
        /* 763 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(16)), o = e(764), l = d(e(183));
          function c(A) {
            if (typeof WeakMap != "function") return null;
            var g = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
            return (c = function(v) {
              return v ? f : g;
            })(A);
          }
          function d(A, g) {
            if (A && A.__esModule)
              return A;
            if (A === null || typeof A != "object" && typeof A != "function")
              return { default: A };
            var f = c(g);
            if (f && f.has(A))
              return f.get(A);
            var p = {}, v = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var b in A)
              if (b !== "default" && Object.prototype.hasOwnProperty.call(A, b)) {
                var m = v ? Object.getOwnPropertyDescriptor(A, b) : null;
                m && (m.get || m.set) ? Object.defineProperty(p, b, m) : p[b] = A[b];
              }
            return p.default = A, f && f.set(A, p), p;
          }
          const u = (A) => {
            const g = new ArrayBuffer(A.length), f = new Uint8Array(g);
            for (let p = 0; p < A.length; ++p)
              f[p] = A[p];
            return g;
          };
          let h = /* @__PURE__ */ function() {
            function A(f, p, v, b) {
              this.type = void 0, this.toAddress = void 0, this.headers = void 0, this.data = void 0, this.type = f, this.toAddress = p, this.headers = v, this.data = b, this.fromAddress = this.headers["X-TB-FROM-ADDRESS"], this.transactionId = this.headers["TRANSACTION-ID"], this.status = this.headers.STATUS, this.isError = this.status && this.status[0] !== "2";
            }
            var g = A.prototype;
            return g.serialize = function() {
              let p, v, b, m, y = 8, U = 7;
              const B = [], Q = [], N = [];
              for (U++, b = 0; b < this.toAddress.length; b++)
                B.push(new o.TextEncoder().encode(this.toAddress[b])), U += 2, U += B[b].length;
              U++, b = 0;
              for (const W in this.headers)
                this.headers.hasOwnProperty(W) && (Q.push(new o.TextEncoder().encode(W)), N.push(new o.TextEncoder().encode(this.headers[W])), U += 4, U += Q[b].length, U += N[b].length, b++);
              v = new o.TextEncoder("utf-8").encode(this.data), U += v.length;
              const J = new ArrayBuffer(U), w = new Uint8Array(J, 0, U);
              for (U -= 4, w[0] = (U & 4278190080) >>> 24, w[1] = (U & 16711680) >>> 16, w[2] = (U & 65280) >>> 8, w[3] = (U & 255) >>> 0, w[4] = 0, w[5] = 0, w[6] = this.type, w[7] = this.toAddress.length, b = 0; b < B.length; b++)
                for (p = B[b], w[y++] = p.length >> 8 & 255, w[y++] = p.length >> 0 & 255, m = 0; m < p.length; m++)
                  w[y++] = p[m];
              for (w[y++] = Q.length, b = 0; b < Q.length; b++) {
                for (p = Q[b], w[y++] = p.length >> 8 & 255, w[y++] = p.length >> 0 & 255, m = 0; m < p.length; m++)
                  w[y++] = p[m];
                for (p = N[b], w[y++] = p.length >> 8 & 255, w[y++] = p.length >> 0 & 255, m = 0; m < p.length; m++)
                  w[y++] = p[m];
              }
              for (b = 0; b < v.length; b++)
                w[y++] = v[b];
              return J;
            }, A.deserialize = function(p) {
              (typeof window !== void 0 ? window : Dn).Buffer && (typeof window !== void 0 ? window : Dn).Buffer.isBuffer(p) && (p = u(p));
              let v, b, m, y, U, B, Q, N, J = 8;
              const w = new Uint8Array(p);
              v = w[6];
              const W = [];
              for (N = 0; N < w[7]; N++)
                Q = w[J++] << 8, Q += w[J++], b = new Uint8Array(p, J, Q), W[N] = new o.TextDecoder("utf-8").decode(b), J += Q;
              for (m = w[J++], y = {}, N = 0; N < m; N++)
                Q = w[J++] << 8, Q += w[J++], b = new Uint8Array(p, J, Q), U = new o.TextDecoder("utf-8").decode(b), J += Q, Q = w[J++] << 8, Q += w[J++], b = new Uint8Array(p, J, Q), B = new o.TextDecoder("utf-8").decode(b), y[U] = B, J += Q;
              const G = new Uint8Array(p, J), Z = new o.TextDecoder("utf-8").decode(G);
              return new A(v, W, y, Z);
            }, A.Connect = function(p, v) {
              const b = {
                uniqueId: p,
                "TRANSACTION-ID": (0, t.default)(),
                notifyDisconnectAddress: v
              };
              return new A(l.CONNECT, [], b, "");
            }, A.Disconnect = function(p) {
              return new A(l.DISCONNECT, [], {
                reconnect: p
              }, "");
            }, A.Subscribe = function(p) {
              return new A(l.SUBSCRIBE, p, {}, "");
            }, A.Unsubscribe = function(p) {
              return new A(l.UNSUBSCRIBE, p, {}, "");
            }, A.Publish = function(p, v, b) {
              return new A(l.MESSAGE, p, b || {}, v || "");
            }, A.Status = function(p, v) {
              return new A(l.STATUS, p, v || {}, "");
            }, A.Ping = function() {
              return new A(l.PING, [], {}, "");
            }, A;
          }();
          r.default = h;
        },
        /* 764 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.TextEncoder = r.TextDecoder = void 0;
          var n = o(e(765));
          function t(d) {
            if (typeof WeakMap != "function") return null;
            var u = /* @__PURE__ */ new WeakMap(), h = /* @__PURE__ */ new WeakMap();
            return (t = function(g) {
              return g ? h : u;
            })(d);
          }
          function o(d, u) {
            if (d && d.__esModule)
              return d;
            if (d === null || typeof d != "object" && typeof d != "function")
              return { default: d };
            var h = t(u);
            if (h && h.has(d))
              return h.get(d);
            var A = {}, g = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var f in d)
              if (f !== "default" && Object.prototype.hasOwnProperty.call(d, f)) {
                var p = g ? Object.getOwnPropertyDescriptor(d, f) : null;
                p && (p.get || p.set) ? Object.defineProperty(A, f, p) : A[f] = d[f];
              }
            return A.default = d, h && h.set(d, A), A;
          }
          const l = (typeof window !== void 0 ? window : Dn).TextEncoder || n.TextEncoder;
          r.TextEncoder = l;
          const c = (typeof window !== void 0 ? window : Dn).TextDecoder || n.TextDecoder;
          r.TextDecoder = c;
        },
        /* 765 */
        /***/
        function(i, r, e) {
          e.r(r), e.d(r, "TextEncoder", function() {
            return f;
          }), e.d(r, "TextDecoder", function() {
            return g;
          });
          function n(b, m, y) {
            return m <= b && b <= y;
          }
          function t(b) {
            if (b === void 0) return {};
            if (b === Object(b)) return b;
            throw TypeError("Could not convert argument to dictionary");
          }
          function o(b) {
            for (var m = String(b), y = m.length, U = 0, B = []; U < y; ) {
              var Q = m.charCodeAt(U);
              if (Q < 55296 || Q > 57343)
                B.push(Q);
              else if (56320 <= Q && Q <= 57343)
                B.push(65533);
              else if (55296 <= Q && Q <= 56319)
                if (U === y - 1)
                  B.push(65533);
                else {
                  var N = b.charCodeAt(U + 1);
                  if (56320 <= N && N <= 57343) {
                    var J = Q & 1023, w = N & 1023;
                    B.push(65536 + (J << 10) + w), U += 1;
                  } else
                    B.push(65533);
                }
              U += 1;
            }
            return B;
          }
          function l(b) {
            for (var m = "", y = 0; y < b.length; ++y) {
              var U = b[y];
              U <= 65535 ? m += String.fromCharCode(U) : (U -= 65536, m += String.fromCharCode(
                (U >> 10) + 55296,
                (U & 1023) + 56320
              ));
            }
            return m;
          }
          var c = -1;
          function d(b) {
            this.tokens = [].slice.call(b);
          }
          d.prototype = {
            /**
             * @return {boolean} True if end-of-stream has been hit.
             */
            endOfStream: function() {
              return !this.tokens.length;
            },
            /**
             * When a token is read from a stream, the first token in the
             * stream must be returned and subsequently removed, and
             * end-of-stream must be returned otherwise.
             *
             * @return {number} Get the next token from the stream, or
             * end_of_stream.
             */
            read: function() {
              return this.tokens.length ? this.tokens.shift() : c;
            },
            /**
             * When one or more tokens are prepended to a stream, those tokens
             * must be inserted, in given order, before the first token in the
             * stream.
             *
             * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
             */
            prepend: function(b) {
              if (Array.isArray(b))
                for (var m = (
                  /**@type {!Array.<number>}*/
                  b
                ); m.length; )
                  this.tokens.unshift(m.pop());
              else
                this.tokens.unshift(b);
            },
            /**
             * When one or more tokens are pushed to a stream, those tokens
             * must be inserted, in given order, after the last token in the
             * stream.
             *
             * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
             */
            push: function(b) {
              if (Array.isArray(b))
                for (var m = (
                  /**@type {!Array.<number>}*/
                  b
                ); m.length; )
                  this.tokens.push(m.shift());
              else
                this.tokens.push(b);
            }
          };
          var u = -1;
          function h(b, m) {
            if (b)
              throw TypeError("Decoder error");
            return m || 65533;
          }
          var A = "utf-8";
          function g(b, m) {
            if (!(this instanceof g))
              return new g(b, m);
            if (b = b !== void 0 ? String(b).toLowerCase() : A, b !== A)
              throw new Error("Encoding not supported. Only utf-8 is supported");
            m = t(m), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!m.fatal, this._ignoreBOM = !!m.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
          }
          g.prototype = {
            /**
             * @param {ArrayBufferView=} input The buffer of bytes to decode.
             * @param {Object=} options
             * @return {string} The decoded string.
             */
            decode: function(m, y) {
              var U;
              typeof m == "object" && m instanceof ArrayBuffer ? U = new Uint8Array(m) : typeof m == "object" && "buffer" in m && m.buffer instanceof ArrayBuffer ? U = new Uint8Array(
                m.buffer,
                m.byteOffset,
                m.byteLength
              ) : U = new Uint8Array(0), y = t(y), this._streaming || (this._decoder = new p({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!y.stream;
              for (var B = new d(U), Q = [], N; !B.endOfStream() && (N = this._decoder.handler(B, B.read()), N !== u); )
                N !== null && (Array.isArray(N) ? Q.push.apply(
                  Q,
                  /**@type {!Array.<number>}*/
                  N
                ) : Q.push(N));
              if (!this._streaming) {
                do {
                  if (N = this._decoder.handler(B, B.read()), N === u)
                    break;
                  N !== null && (Array.isArray(N) ? Q.push.apply(
                    Q,
                    /**@type {!Array.<number>}*/
                    N
                  ) : Q.push(N));
                } while (!B.endOfStream());
                this._decoder = null;
              }
              return Q.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (Q[0] === 65279 ? (this._BOMseen = !0, Q.shift()) : this._BOMseen = !0), l(Q);
            }
          };
          function f(b, m) {
            if (!(this instanceof f))
              return new f(b, m);
            if (b = b !== void 0 ? String(b).toLowerCase() : A, b !== A)
              throw new Error("Encoding not supported. Only utf-8 is supported");
            m = t(m), this._streaming = !1, this._encoder = null, this._options = { fatal: !!m.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
          }
          f.prototype = {
            /**
             * @param {string=} opt_string The string to encode.
             * @param {Object=} options
             * @return {Uint8Array} Encoded bytes, as a Uint8Array.
             */
            encode: function(m, y) {
              m = m ? String(m) : "", y = t(y), this._streaming || (this._encoder = new v(this._options)), this._streaming = !!y.stream;
              for (var U = [], B = new d(o(m)), Q; !B.endOfStream() && (Q = this._encoder.handler(B, B.read()), Q !== u); )
                Array.isArray(Q) ? U.push.apply(
                  U,
                  /**@type {!Array.<number>}*/
                  Q
                ) : U.push(Q);
              if (!this._streaming) {
                for (; Q = this._encoder.handler(B, B.read()), Q !== u; )
                  Array.isArray(Q) ? U.push.apply(
                    U,
                    /**@type {!Array.<number>}*/
                    Q
                  ) : U.push(Q);
                this._encoder = null;
              }
              return new Uint8Array(U);
            }
          };
          function p(b) {
            var m = b.fatal, y = 0, U = 0, B = 0, Q = 128, N = 191;
            this.handler = function(J, w) {
              if (w === c && B !== 0)
                return B = 0, h(m);
              if (w === c)
                return u;
              if (B === 0) {
                if (n(w, 0, 127))
                  return w;
                if (n(w, 194, 223))
                  B = 1, y = w - 192;
                else if (n(w, 224, 239))
                  w === 224 && (Q = 160), w === 237 && (N = 159), B = 2, y = w - 224;
                else if (n(w, 240, 244))
                  w === 240 && (Q = 144), w === 244 && (N = 143), B = 3, y = w - 240;
                else
                  return h(m);
                return y = y << 6 * B, null;
              }
              if (!n(w, Q, N))
                return y = B = U = 0, Q = 128, N = 191, J.prepend(w), h(m);
              if (Q = 128, N = 191, U += 1, y += w - 128 << 6 * (B - U), U !== B)
                return null;
              var W = y;
              return y = B = U = 0, W;
            };
          }
          function v(b) {
            b.fatal, this.handler = function(m, y) {
              if (y === c)
                return u;
              if (n(y, 0, 127))
                return y;
              var U, B;
              n(y, 128, 2047) ? (U = 1, B = 192) : n(y, 2048, 65535) ? (U = 2, B = 224) : n(y, 65536, 1114111) && (U = 3, B = 240);
              for (var Q = [(y >> 6 * U) + B]; U > 0; ) {
                var N = y >> 6 * (U - 1);
                Q.push(128 | N & 63), U -= 1;
              }
              return Q;
            };
          }
        },
        /* 766 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = c(e(78)), o = n(e(8));
          function l(u) {
            if (typeof WeakMap != "function") return null;
            var h = /* @__PURE__ */ new WeakMap(), A = /* @__PURE__ */ new WeakMap();
            return (l = function(f) {
              return f ? A : h;
            })(u);
          }
          function c(u, h) {
            if (u && u.__esModule)
              return u;
            if (u === null || typeof u != "object" && typeof u != "function")
              return { default: u };
            var A = l(h);
            if (A && A.has(u))
              return A.get(u);
            var g = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var p in u)
              if (p !== "default" && Object.prototype.hasOwnProperty.call(u, p)) {
                var v = f ? Object.getOwnPropertyDescriptor(u, p) : null;
                v && (v.get || v.set) ? Object.defineProperty(g, p, v) : g[p] = u[p];
              }
            return g.default = u, A && A.set(u, g), g;
          }
          let d = function(h) {
            if (this.code = void 0, this.message = void 0, this.name = void 0, this.code = t.codes.CLOSE_FALLBACK_CODE, Object.values(t.codes).includes(h))
              switch (this.code = h, this.code) {
                case t.codes.CLOSE_GOING_AWAY:
                case t.codes.CLOSE_PROTOCOL_ERROR:
                case t.codes.CLOSE_UNSUPPORTED:
                case t.codes.CLOSE_NO_STATUS:
                case t.codes.CLOSE_ABNORMAL:
                case t.codes.CLOSE_INCONSISTENT_DATA:
                case t.codes.CLOSE_POLICY_VIOLATION:
                case t.codes.CLOSE_TOO_LARGE:
                case t.codes.CLOSE_UNEXPECTED_CONDITION:
                case t.codes.CLOSE_CONNECTIVITY_LOSS:
                case t.codes.CLOSE_CONNECT_EXCEPTION:
                case t.codes.CLOSE_TIMEOUT:
                  this.name = o.default.DISCONNECTED, this.message = "Action failed due to session disconnection.";
                  return;
              }
            this.message = t.messages[this.code] || "No message available from code.";
          };
          r.default = d;
        },
        /* 767 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(768)), o = (typeof window !== void 0 ? window : Dn).WebSocket ? (typeof window !== void 0 ? window : Dn).WebSocket : t.default;
          r.default = o;
        },
        /* 768 */
        /***/
        function(i, r, e) {
          i.exports = function() {
            throw new Error(
              "ws does not work in the browser. Browser clients must use the native WebSocket object"
            );
          };
        },
        /* 769 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(52)), o = n(e(3));
          const l = o.default.name, c = t.default.once;
          var d = () => c() && ["Chrome", "Firefox", "Safari"].indexOf(l) > -1;
          r.default = d;
        },
        /* 770 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = o;
          var t = n(e(771));
          function o(l) {
            const c = (0, t.default)(l.data);
            return c.transactionId = l.transactionId, c.fromAddress = l.headers["X-TB-FROM-ADDRESS"], c;
          }
        },
        /* 771 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            if (t.length === 0)
              return {};
            const o = JSON.parse(t), l = o.uri.substr(1).split("/");
            l.shift(), l[l.length - 1] === "" && l.pop(), o.params = {};
            for (let c = 0, d = l.length; c < d - 1; c += 2)
              o.params[l[c]] = l[c + 1];
            return l.length % 2 === 0 ? l[l.length - 2] === "channel" && l.length > 6 ? o.resource = `${l[l.length - 4]}_${l[l.length - 2]}` : o.resource = l[l.length - 2] : l[l.length - 1] === "channel" && l.length > 5 ? o.resource = `${l[l.length - 3]}_${l[l.length - 1]}` : o.resource = l[l.length - 1], o.signature = `${o.resource}#${o.method}`, o;
          }
        },
        /* 772 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var n = "DTLS_SRTP";
          r.default = n;
        },
        /* 773 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(52));
          const o = t.default.once;
          var l = () => o();
          r.default = l;
        },
        /* 774 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(3)), o = n(e(52));
          const l = o.default.once;
          var c = () => l() && (t.default.name === "Chrome" || t.default.name === "Firefox" || t.default.name === "Node" || t.default.name === "Safari" || t.default.name === "Edge");
          r.default = c;
        },
        /* 775 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t) {
            let o = t.supportsWebRTC;
            return {
              supportsWebRTC: o === "true" || o === !0
            };
          }
        },
        /* 776 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = n;
          function n(t, o) {
            this.code = t, this.message = o, this.reason = o;
          }
        },
        /* 777 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = function(l) {
            const c = [];
            this.enqueue = function() {
              c.push(Array.prototype.slice.call(arguments));
            }, this.triggerAll = function() {
              let u;
              for (; u = c.shift(); )
                l.trigger(...u);
            };
          };
          r.default = t;
        },
        /* 778 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(251)), o = n(e(218)), l = n(e(308)), c = n(e(58)), d = n(e(9)), u = n(e(10)), h = n(e(148)), A = n(e(779)), g = n(e(780));
          const f = {
            EMPTY_RESPONSE: "Response body was empty, probably due to connectivity loss",
            BADLY_FORMED: "Unknown error: JSON response was badly formed",
            NO_ERROR: "No error message",
            UNEXPECTED_SERVER_RESPONSE: (m) => `Unexpected server response (${m}). Try this operation again later.`
          }, p = [0, 600, 1200];
          function v(m) {
            let y = m === void 0 ? {} : m, U = y.axios, B = U === void 0 ? o.default : U, Q = y.retryDelays, N = Q === void 0 ? p : Q;
            function J(W) {
              let G = W.anvilUrl, Z = W.sessionId, K = W.token, L = W.clientVersion, O = W.connectionId;
              const de = t.default.parse(G, !0), oe = t.default.format({
                protocol: de.protocol,
                auth: de.auth,
                host: de.host,
                pathname: t.default.resolve((de.pathname || "").replace(/\/?$/, "/"), `session/${Z}`),
                query: Object.assign({}, de.query, {
                  extended: !0
                })
              });
              return B.get(oe, {
                validateStatus: (fe) => fe >= 200 && fe < 300,
                headers: {
                  "X-OPENTOK-AUTH": K,
                  "X-TB-VERSION": 1,
                  "X-TB-CLIENT-VERSION": L,
                  "X-TB-CONNECTIONID": O,
                  Accept: "application/json"
                }
              }).catch((fe) => {
                if (fe.response) {
                  const ge = new Error(f.UNEXPECTED_SERVER_RESPONSE(`${fe.response.statusCode}${fe.response.status ? ` ${fe.response.status}` : ""}`));
                  throw ge.code = u.default.ANVIL_INVALID_HTTP_STATUS, ge.name = (0, A.default)(ge.code), ge;
                } else if (fe.request) {
                  const ge = new Error(f.CONNECT_FAILED);
                  throw ge.code = u.default.ANVIL_CONNECT_FAILED, ge.name = (0, A.default)(ge.code), ge;
                } else {
                  const ge = u.default.ANVIL_UNKNOWN_HTTP_ERROR, we = (0, A.default)(fe.code);
                  throw (0, d.default)(fe, {
                    code: ge,
                    name: we
                  }), fe;
                }
              }).then((fe) => {
                let ge = fe.data;
                if (typeof ge == "string") {
                  if (ge.length > 0)
                    try {
                      JSON.parse(ge);
                    } catch (Pe) {
                      throw Pe.message = f.UNEXPECTED_SERVER_RESPONSE(Pe.toString()), Pe.code = u.default.ANVIL_XDOMAIN_OR_PARSING_ERROR, Pe.name = (0, A.default)(Pe.code), Pe;
                    }
                  const Te = new Error(ge.length === 0 ? f.EMPTY_RESPONSE : f.BADLY_FORMED);
                  throw Te.code = ge.length === 0 ? u.default.ANVIL_EMPTY_RESPONSE_BODY : u.default.ANVIL_BADLY_FORMED_RESPONSE, Te.name = (0, A.default)(Te.code), Te;
                }
                if (ge === null || ge.length === 0) {
                  const Te = new Error(f.EMPTY_RESPONSE);
                  throw Te.code = u.default.ANVIL_EMPTY_RESPONSE_BODY, Te.name = (0, A.default)(Te.code), Te;
                }
                const we = ge.filter((Te) => Te.error != null), _e = we[0];
                if (_e) {
                  const Te = (0, g.default)((0, c.default)(_e, "error.code", "500"));
                  (0, c.default)(_e, "error.errorMessage.message") === "Invalid token format" && (_e.error.errorMessage.message += ` Token: ${K}`);
                  const Pe = new Error((0, c.default)(_e, "error.errorMessage.message", Te === void 0 ? `Unknown error: ${_e.error.code}` : f.NO_ERROR));
                  throw Pe.code = Te || u.default.ANVIL_UNEXPECTED_ERROR_CODE, Pe.name = (0, A.default)(Pe.code), Pe;
                }
                return new h.default(ge[0]);
              });
            }
            return (0, l.default)(J, (W, G) => W.code && W.code >= 3e3 && W.code <= 3007 && N[G]);
          }
          var b = v;
          r.default = b;
        },
        /* 779 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(10)), o = n(e(8));
          const l = {
            [t.default.ANVIL_BADLY_FORMED_RESPONSE]: o.default.BADLY_FORMED_RESPONSE,
            [t.default.ANVIL_INVALID_HTTP_STATUS]: o.default.INVALID_HTTP_STATUS,
            [t.default.ANVIL_XDOMAIN_OR_PARSING_ERROR]: o.default.XDOMAIN_OR_PARSING_ERROR,
            [t.default.ANVIL_UNKNOWN_HTTP_ERROR]: o.default.UNKNOWN_HTTP_ERROR,
            [t.default.ANVIL_UNEXPECTED_ERROR_CODE]: o.default.UNEXPECTED_ERROR_CODE,
            [t.default.ANVIL_EMPTY_RESPONSE_BODY]: o.default.EMPTY_RESPONSE_BODY,
            [t.default.ANVIL_CONNECT_FAILED]: o.default.CONNECT_FAILED,
            [t.default.AUTHENTICATION_ERROR]: o.default.AUTHENTICATION_ERROR,
            [t.default.INVALID_SESSION_ID]: o.default.INVALID_SESSION_ID,
            [t.default.TERMS_OF_SERVICE_FAILURE]: o.default.TERMS_OF_SERVICE_FAILURE,
            [t.default.UNEXPECTED_SERVER_RESPONSE]: o.default.UNEXPECTED_SERVER_RESPONSE
          };
          function c(u) {
            return l[u];
          }
          var d = c;
          r.default = d;
        },
        /* 780 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(10));
          const o = {
            400: t.default.INVALID_SESSION_ID,
            403: t.default.AUTHENTICATION_ERROR,
            404: t.default.INVALID_SESSION_ID,
            409: t.default.TERMS_OF_SERVICE_FAILURE,
            500: t.default.UNEXPECTED_SERVER_RESPONSE
          };
          function l(d) {
            return o[d];
          }
          var c = l;
          r.default = c;
        },
        /* 781 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(30)), c = n(e(14)), d = n(e(293)), h = /* @__PURE__ */ function(A) {
            (0, l.default)(g, A);
            function g(p) {
              var v;
              return p === void 0 && (p = {}), v = A.call(this) || this, v._generateKey = p.generateKey || d.default, v;
            }
            var f = g.prototype;
            return f.set = /* @__PURE__ */ function() {
              var p = (0, o.default)(/* @__PURE__ */ t.default.mark(function b(m, y) {
                var U;
                return t.default.wrap(function(Q) {
                  for (; ; ) switch (Q.prev = Q.next) {
                    case 0:
                      return this.keyPromise = this._generateKey(m, y), Q.next = 3, this.keyPromise;
                    case 3:
                      U = Q.sent, this.emit("keyChanged", U);
                    case 5:
                    case "end":
                      return Q.stop();
                  }
                }, b, this);
              }));
              function v(b, m) {
                return p.apply(this, arguments);
              }
              return v;
            }(), f.get = /* @__PURE__ */ function() {
              var p = (0, o.default)(/* @__PURE__ */ t.default.mark(function b() {
                var m;
                return t.default.wrap(function(U) {
                  for (; ; ) switch (U.prev = U.next) {
                    case 0:
                      return U.next = 2, this.keyPromise;
                    case 2:
                      return m = U.sent, U.abrupt("return", m);
                    case 4:
                    case "end":
                      return U.stop();
                  }
                }, b, this);
              }));
              function v() {
                return p.apply(this, arguments);
              }
              return v;
            }(), f.clear = function() {
              this.keyPromise = void 0;
            }, g;
          }(c.default);
          r.default = h;
        },
        /* 782 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = u;
          var t = n(e(4)), o = n(e(5)), l = n(e(332)), c = n(e(333)), d = n(e(783));
          function u(h) {
            h === void 0 && (h = {});
            let A = h, g = (0, c.default)({}, ((0, l.default)(A), A)), f;
            const p = /* @__PURE__ */ function() {
              var b = (0, o.default)(/* @__PURE__ */ t.default.mark(function m(y) {
                return t.default.wrap(function(B) {
                  for (; ; ) switch (B.prev = B.next) {
                    case 0:
                      return B.abrupt("return", f.create(y));
                    case 1:
                    case "end":
                      return B.stop();
                  }
                }, m);
              }));
              return function(y) {
                return b.apply(this, arguments);
              };
            }();
            return function() {
              var m = this;
              this._clientStore = {}, f = g.sframe || d.default, this._initClientStore = (y) => {
                this._clientStore = y;
              }, this.createSender = /* @__PURE__ */ function() {
                var y = (0, o.default)(/* @__PURE__ */ t.default.mark(function U(B) {
                  var Q;
                  return t.default.wrap(function(J) {
                    for (; ; ) switch (J.prev = J.next) {
                      case 0:
                        if (B === void 0 && (B = 0), !m.getSender(B)) {
                          J.next = 3;
                          break;
                        }
                        return J.abrupt("return", m.getSender(B));
                      case 3:
                        return m._clientStore[B] || (m._clientStore[B] = {}), J.prev = 4, J.next = 7, p(B);
                      case 7:
                        m._clientStore[B].sender = J.sent, J.next = 13;
                        break;
                      case 10:
                        J.prev = 10, J.t0 = J.catch(4), (Q = m._clientStore[B]) == null || delete Q.sender;
                      case 13:
                        return J.abrupt("return", m.getSender(B));
                      case 14:
                      case "end":
                        return J.stop();
                    }
                  }, U, null, [[4, 10]]);
                }));
                return function(U) {
                  return y.apply(this, arguments);
                };
              }(), this.createReceiver = /* @__PURE__ */ function() {
                var y = (0, o.default)(/* @__PURE__ */ t.default.mark(function U(B) {
                  var Q;
                  return t.default.wrap(function(J) {
                    for (; ; ) switch (J.prev = J.next) {
                      case 0:
                        if (!m.getReceiver(B)) {
                          J.next = 2;
                          break;
                        }
                        return J.abrupt("return", m.getReceiver(B));
                      case 2:
                        return m._clientStore[B] || (m._clientStore[B] = {}), J.prev = 3, J.next = 6, p(B);
                      case 6:
                        m._clientStore[B].receiver = J.sent, J.next = 12;
                        break;
                      case 9:
                        J.prev = 9, J.t0 = J.catch(3), (Q = m._clientStore[B]) == null || delete Q.receiver;
                      case 12:
                        return J.abrupt("return", m.getReceiver(B));
                      case 13:
                      case "end":
                        return J.stop();
                    }
                  }, U, null, [[3, 9]]);
                }));
                return function(U) {
                  return y.apply(this, arguments);
                };
              }(), this.getSender = (y) => {
                var U;
                return (U = this._clientStore[y]) == null ? void 0 : U.sender;
              }, this.getReceiver = (y) => {
                var U;
                return (U = this._clientStore[y]) == null ? void 0 : U.receiver;
              }, this.deleteReceiver = (y) => {
                var U;
                (U = this._clientStore[y]) == null || delete U.receiver;
              }, this.deleteSender = (y) => {
                var U;
                (U = this._clientStore[y]) == null || delete U.sender;
              };
            };
          }
        },
        /* 783 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = e(784), c = n(e(790));
          const d = /* @__PURE__ */ function() {
            var g = (0, o.default)(/* @__PURE__ */ t.default.mark(function f(p) {
              var v, b;
              return t.default.wrap(function(y) {
                for (; ; ) switch (y.prev = y.next) {
                  case 0:
                    return y.next = 2, p.setEnableOnSuccess(!0);
                  case 2:
                    v = () => {
                      p.removeEventListener("error", v), p.addEventListener("success", b), p.dispatchEvent(new Event("decryptFailed"));
                    }, b = () => {
                      p.removeEventListener("success", b), p.addEventListener("error", v), p.dispatchEvent(new Event("decryptionRestored"));
                    }, p.addEventListener("error", v);
                  case 5:
                  case "end":
                    return y.stop();
                }
              }, f);
            }));
            return function(p) {
              return g.apply(this, arguments);
            };
          }();
          var A = {
            create: /* @__PURE__ */ function() {
              var g = (0, o.default)(/* @__PURE__ */ t.default.mark(function f(p, v) {
                var b, m, y;
                return t.default.wrap(function(B) {
                  for (; ; ) switch (B.prev = B.next) {
                    case 0:
                      return v === void 0 && (v = {}), b = v.SFrameClient || l.Client, m = v.normalizeKey || c.default, B.next = 5, b.create(p);
                    case 5:
                      return y = B.sent, y._setReceiverEncryptionKey = y.setReceiverEncryptionKey, y.setReceiverEncryptionKey = /* @__PURE__ */ function() {
                        var Q = (0, o.default)(/* @__PURE__ */ t.default.mark(function N(J, w) {
                          var W;
                          return t.default.wrap(function(Z) {
                            for (; ; ) switch (Z.prev = Z.next) {
                              case 0:
                                return Z.next = 2, m(w);
                              case 2:
                                return W = Z.sent, Z.abrupt("return", y._setReceiverEncryptionKey(J, W));
                              case 4:
                              case "end":
                                return Z.stop();
                            }
                          }, N);
                        }));
                        return function(N, J) {
                          return Q.apply(this, arguments);
                        };
                      }(), y._setSenderEncryptionKey = y.setSenderEncryptionKey, y.setSenderEncryptionKey = /* @__PURE__ */ function() {
                        var Q = (0, o.default)(/* @__PURE__ */ t.default.mark(function N(J) {
                          var w;
                          return t.default.wrap(function(G) {
                            for (; ; ) switch (G.prev = G.next) {
                              case 0:
                                return G.next = 2, m(J);
                              case 2:
                                return w = G.sent, G.abrupt("return", y._setSenderEncryptionKey(w));
                              case 4:
                              case "end":
                                return G.stop();
                            }
                          }, N);
                        }));
                        return function(N) {
                          return Q.apply(this, arguments);
                        };
                      }(), d(y), B.abrupt("return", y);
                    case 12:
                    case "end":
                      return B.stop();
                  }
                }, f);
              }));
              return function(p, v) {
                return g.apply(this, arguments);
              };
            }()
          };
          r.default = A;
        },
        /* 784 */
        /***/
        function(i, r, e) {
          (function(n, t, o, l) {
            function c(Rt) {
              const ln = e.p;
              let tt = "";
              return (!ln || ln.indexOf("://") < 0) && (tt += window.location.protocol + "//" + window.location.host), ln ? tt += ln : tt += "/", tt + Rt;
            }
            var d = e(0);
            r.__esModule = !0, r.VideoCodec = r.Codec = r.Client = r.AudioCodec = void 0;
            var u = d(e(4)), h = d(e(161)), A = d(e(30)), g = d(e(29)), f = d(e(5)), p = function(Rt) {
              function ln() {
                var Oe = this || self;
                return delete Rt.prototype.__magic__, Oe;
              }
              if (typeof globalThis == "object")
                return globalThis;
              if (this)
                return ln();
              Rt.defineProperty(Rt.prototype, "__magic__", { configurable: !0, get: ln });
              var tt = __magic__;
              return tt;
            }(Object);
            function v(Rt, ln) {
              var tt = typeof Symbol != "undefined" && Rt[Symbol.iterator] || Rt["@@iterator"];
              if (tt) return (tt = tt.call(Rt)).next.bind(tt);
              if (Array.isArray(Rt) || (tt = b(Rt)) || ln) {
                tt && (Rt = tt);
                var Oe = 0;
                return function() {
                  return Oe >= Rt.length ? { done: !0 } : { done: !1, value: Rt[Oe++] };
                };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function b(Rt, ln) {
              if (Rt) {
                if (typeof Rt == "string") return m(Rt, ln);
                var tt = Object.prototype.toString.call(Rt).slice(8, -1);
                if (tt === "Object" && Rt.constructor && (tt = Rt.constructor.name), tt === "Map" || tt === "Set") return Array.from(Rt);
                if (tt === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(tt)) return m(Rt, ln);
              }
            }
            function m(Rt, ln) {
              (ln == null || ln > Rt.length) && (ln = Rt.length);
              for (var tt = 0, Oe = new Array(ln); tt < ln; tt++) Oe[tt] = Rt[tt];
              return Oe;
            }
            var y = /* @__PURE__ */ ((Rt) => (Rt[Rt.VP8 = 0] = "VP8", Rt[Rt.H264 = 1] = "H264", Rt[Rt.OPUS = 2] = "OPUS", Rt))(y || {});
            r.Codec = y;
            var U = /* @__PURE__ */ ((Rt) => (Rt[
              Rt.VP8 = 0
              /* VP8 */
            ] = "VP8", Rt[
              Rt.H264 = 1
              /* H264 */
            ] = "H264", Rt))(U || {});
            r.VideoCodec = U;
            var B = /* @__PURE__ */ ((Rt) => (Rt[
              Rt.OPUS = 2
              /* OPUS */
            ] = "OPUS", Rt))(B || {});
            r.AudioCodec = B;
            function Q(Rt, ln) {
              p.vonage || (p.vonage = {}), p.vonage.workerizer || (p.vonage.workerizer = {});
              let tt = p.vonage.workerizer;
              return tt[Rt] || (tt[Rt] = ln), tt[Rt];
            }
            const N = Q("globals", {});
            var J = /* @__PURE__ */ ((Rt) => (Rt.INIT = "INIT", Rt.FORWARD = "FORWARD", Rt.TERMINATE = "TERMINATE", Rt.GLOBALS_SYNC = "GLOBALS_SYNC", Rt.EVENT = "EVENT", Rt))(J || {});
            function w(Rt) {
              return [ImageBitmap, ReadableStream, WritableStream].some((tt) => Rt instanceof tt);
            }
            let W = 0;
            function G(Rt, ln, tt, Oe, Jt) {
              const St = W++;
              return Rt.postMessage({ id: St, type: ln, functionName: tt, args: Oe }, Oe.filter((Et) => w(Et))), new n((Et) => {
                Jt == null || Jt.set(St, Et);
              });
            }
            function Z(Rt, ln) {
              const tt = Rt.id, Oe = Rt.type, Jt = Array.isArray(ln) ? ln : [ln];
              postMessage({ id: tt, type: Oe, result: ln }, Jt.filter((St) => w(St)));
            }
            const K = Q("workerized", {});
            function L() {
              return typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope;
            }
            function O() {
              return de.apply(this, arguments);
            }
            function de() {
              return de = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt() {
                var ln, tt, Oe, Jt, St;
                return u.default.wrap(function(Et) {
                  for (; ; ) switch (Et.prev = Et.next) {
                    case 0:
                      if (!L()) {
                        Et.next = 4;
                        break;
                      }
                      Z({ type: J.GLOBALS_SYNC }, N), Et.next = 8;
                      break;
                    case 4:
                      ln = [];
                      for (tt in K)
                        Oe = K[tt].workerContext, Jt = Oe.worker, St = Oe.resolvers, Jt && ln.push(G(Jt, J.GLOBALS_SYNC, "", [N], St));
                      return Et.next = 8, n.all(ln);
                    case 8:
                    case "end":
                      return Et.stop();
                  }
                }, Rt);
              })), de.apply(this, arguments);
            }
            function oe(Rt, ln) {
              if (Array.isArray(ln))
                ln.splice(0, ln.length);
              else if (typeof ln == "object")
                for (const tt in ln)
                  delete ln[tt];
              for (const tt in Rt)
                Array.isArray(Rt[tt]) ? (ln[tt] = [], oe(Rt[tt], ln[tt])) : typeof Rt[tt] == "object" ? (ln[tt] = {}, oe(Rt[tt], ln[tt])) : ln[tt] = Rt[tt];
            }
            function fe(Rt, ln, tt, Oe) {
              return ge.apply(this, arguments);
            }
            function ge() {
              return ge = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt(ln, tt, Oe, Jt) {
                var St, Vt;
                return u.default.wrap(function(Qn) {
                  for (; ; ) switch (Qn.prev = Qn.next) {
                    case 0:
                      return St = new tt(), St.addEventListener("message", /* @__PURE__ */ function() {
                        var gn = (0, f.default)(/* @__PURE__ */ u.default.mark(function jt(On) {
                          var Ar, ui, fr, Jn, Qr, ti, Wn, Hi, Ho, Ea;
                          return u.default.wrap(function(No) {
                            for (; ; ) switch (No.prev = No.next) {
                              case 0:
                                Ar = On.data, No.t0 = Ar.type, No.next = No.t0 === J.GLOBALS_SYNC ? 4 : No.t0 === J.EVENT ? 13 : 19;
                                break;
                              case 4:
                                if (!Ar.id) {
                                  No.next = 9;
                                  break;
                                }
                                (fr = Oe.get((ui = Ar.id) != null ? ui : -1)) == null || fr(Ar.result), Oe.delete((Jn = Ar.id) != null ? Jn : -1), No.next = 12;
                                break;
                              case 9:
                                return oe((Qr = Ar.result) != null ? Qr : {}, N), No.next = 12, O();
                              case 12:
                                return No.abrupt("break", 21);
                              case 13:
                                if (Ho = Ar.result, Ea = Ho, (Ea == null ? void 0 : Ea.name) != null) {
                                  No.next = 17;
                                  break;
                                }
                                throw "Missing event name";
                              case 17:
                                return Jt(Ea.name, Ea.data), No.abrupt("break", 21);
                              case 19:
                                (Wn = Oe.get((ti = Ar.id) != null ? ti : -1)) == null || Wn(Ar.result), Oe.delete((Hi = Ar.id) != null ? Hi : -1);
                              case 21:
                              case "end":
                                return No.stop();
                            }
                          }, jt);
                        }));
                        return function(jt) {
                          return gn.apply(this, arguments);
                        };
                      }()), Qn.next = 4, G(St, J.INIT, "", [ln.workerId, N], Oe);
                    case 4:
                      if (Vt = Qn.sent, Vt) {
                        Qn.next = 7;
                        break;
                      }
                      throw "Failed to instantiate workerized class";
                    case 7:
                      return Qn.abrupt("return", St);
                    case 8:
                    case "end":
                      return Qn.stop();
                  }
                }, Rt);
              })), ge.apply(this, arguments);
            }
            const we = /* @__PURE__ */ new WeakMap(), _e = /* @__PURE__ */ new WeakMap(), Te = /* @__PURE__ */ new WeakMap(), Pe = Symbol("anyProducer"), $e = n.resolve(), Bt = Symbol("listenerAdded"), Le = Symbol("listenerRemoved");
            let at = !1, pt = !1;
            function kt(Rt) {
              if (typeof Rt != "string" && typeof Rt != "symbol" && typeof Rt != "number")
                throw new TypeError("`eventName` must be a string, symbol, or number");
            }
            function _t(Rt) {
              if (typeof Rt != "function")
                throw new TypeError("listener must be a function");
            }
            function Lt(Rt, ln) {
              const tt = _e.get(Rt);
              if (tt.has(ln))
                return tt.get(ln);
            }
            function Ft(Rt, ln) {
              const tt = typeof ln == "string" || typeof ln == "symbol" || typeof ln == "number" ? ln : Pe, Oe = Te.get(Rt);
              if (Oe.has(tt))
                return Oe.get(tt);
            }
            function Zt(Rt, ln, tt) {
              const Oe = Te.get(Rt);
              if (Oe.has(ln))
                for (var Jt = v(Oe.get(ln)), St; !(St = Jt()).done; )
                  St.value.enqueue(tt);
              if (Oe.has(Pe)) {
                const Qn = n.all([ln, tt]);
                for (var Vt = v(Oe.get(Pe)), Et; !(Et = Vt()).done; )
                  Et.value.enqueue(Qn);
              }
            }
            function ft(Rt, ln) {
              ln = Array.isArray(ln) ? ln : [ln];
              let tt = !1, Oe = () => {
              }, Jt = [];
              const St = { enqueue(Qn) {
                Jt.push(Qn), Oe();
              }, finish() {
                tt = !0, Oe();
              } };
              for (var Vt = v(ln), Et; !(Et = Vt()).done; ) {
                const Qn = Et.value;
                let gn = Ft(Rt, Qn);
                gn || (gn = /* @__PURE__ */ new Set(), Te.get(Rt).set(Qn, gn)), gn.add(St);
              }
              return { next() {
                var Qn = this;
                return (0, f.default)(/* @__PURE__ */ u.default.mark(function gn() {
                  return u.default.wrap(function(On) {
                    for (; ; ) switch (On.prev = On.next) {
                      case 0:
                        if (Jt) {
                          On.next = 2;
                          break;
                        }
                        return On.abrupt("return", { done: !0 });
                      case 2:
                        if (Jt.length !== 0) {
                          On.next = 9;
                          break;
                        }
                        if (!tt) {
                          On.next = 6;
                          break;
                        }
                        return Jt = void 0, On.abrupt("return", Qn.next());
                      case 6:
                        return On.next = 8, new n((Ar) => {
                          Oe = Ar;
                        });
                      case 8:
                        return On.abrupt("return", Qn.next());
                      case 9:
                        return On.next = 11, Jt.shift();
                      case 11:
                        return On.t0 = On.sent, On.abrupt("return", { done: !1, value: On.t0 });
                      case 13:
                      case "end":
                        return On.stop();
                    }
                  }, gn);
                }))();
              }, return(Qn) {
                var gn = arguments;
                return (0, f.default)(/* @__PURE__ */ u.default.mark(function jt() {
                  var On, Ar, ui, fr, Jn;
                  return u.default.wrap(function(ti) {
                    for (; ; ) switch (ti.prev = ti.next) {
                      case 0:
                        for (Jt = void 0, On = v(ln); !(Ar = On()).done; )
                          ui = Ar.value, fr = Ft(Rt, ui), fr && (fr.delete(St), fr.size === 0 && (Jn = Te.get(Rt), Jn.delete(ui)));
                        if (Oe(), !(gn.length > 0)) {
                          ti.next = 10;
                          break;
                        }
                        return ti.next = 6, Qn;
                      case 6:
                        ti.t1 = ti.sent, ti.t0 = { done: !0, value: ti.t1 }, ti.next = 11;
                        break;
                      case 10:
                        ti.t0 = { done: !0 };
                      case 11:
                        return ti.abrupt("return", ti.t0);
                      case 12:
                      case "end":
                        return ti.stop();
                    }
                  }, jt);
                }))();
              }, [Symbol.asyncIterator]() {
                return this;
              } };
            }
            function It(Rt) {
              if (Rt === void 0)
                return on;
              if (!Array.isArray(Rt))
                throw new TypeError("`methodNames` must be an array of strings");
              for (var ln = v(Rt), tt; !(tt = ln()).done; ) {
                const Oe = tt.value;
                if (!on.includes(Oe))
                  throw typeof Oe != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${Oe} is not Emittery method`);
              }
              return Rt;
            }
            const Kt = (Rt) => Rt === Bt || Rt === Le;
            function Sn(Rt, ln, tt) {
              if (Kt(ln))
                try {
                  at = !0, Rt.emit(ln, tt);
                } finally {
                  at = !1;
                }
            }
            let Cn = /* @__PURE__ */ function() {
              Rt.mixin = function(Oe, Jt) {
                return Jt = It(Jt), (St) => {
                  if (typeof St != "function")
                    throw new TypeError("`target` must be function");
                  for (var Vt = v(Jt), Et; !(Et = Vt()).done; ) {
                    const Ar = Et.value;
                    if (St.prototype[Ar] !== void 0)
                      throw new Error(`The property \`${Ar}\` already exists on \`target\``);
                  }
                  function Qn() {
                    return Object.defineProperty(this, Oe, { enumerable: !1, value: new Rt() }), this[Oe];
                  }
                  Object.defineProperty(St.prototype, Oe, { enumerable: !1, get: Qn });
                  const gn = (Ar) => function() {
                    return this[Oe][Ar](...arguments);
                  };
                  for (var jt = v(Jt), On; !(On = jt()).done; ) {
                    const Ar = On.value;
                    Object.defineProperty(St.prototype, Ar, { enumerable: !1, value: gn(Ar) });
                  }
                  return St;
                };
              };
              function Rt(tt) {
                tt === void 0 && (tt = {});
                var Oe;
                we.set(this, /* @__PURE__ */ new Set()), _e.set(this, /* @__PURE__ */ new Map()), Te.set(this, /* @__PURE__ */ new Map()), Te.get(this).set(Pe, /* @__PURE__ */ new Set()), this.debug = (Oe = tt.debug) != null ? Oe : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (Jt, St, Vt, Et) => {
                  try {
                    Et = JSON.stringify(Et);
                  } catch {
                    Et = `Object with the following keys failed to stringify: ${Object.keys(Et).join(",")}`;
                  }
                  (typeof Vt == "symbol" || typeof Vt == "number") && (Vt = Vt.toString());
                  const Qn = /* @__PURE__ */ new Date(), gn = `${Qn.getHours()}:${Qn.getMinutes()}:${Qn.getSeconds()}.${Qn.getMilliseconds()}`;
                  console.log(`[${gn}][emittery:${Jt}][${St}] Event Name: ${Vt}
	data: ${Et}`);
                });
              }
              var ln = Rt.prototype;
              return ln.logIfDebugEnabled = function(Oe, Jt, St) {
                (Rt.isDebugEnabled || this.debug.enabled) && this.debug.logger(Oe, this.debug.name, Jt, St);
              }, ln.on = function(Oe, Jt) {
                _t(Jt), Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var St = v(Oe), Vt; !(Vt = St()).done; ) {
                  const Et = Vt.value;
                  kt(Et);
                  let Qn = Lt(this, Et);
                  Qn || (Qn = /* @__PURE__ */ new Set(), _e.get(this).set(Et, Qn)), Qn.add(Jt), this.logIfDebugEnabled("subscribe", Et, void 0), Kt(Et) || Sn(this, Bt, { eventName: Et, listener: Jt });
                }
                return this.off.bind(this, Oe, Jt);
              }, ln.off = function(Oe, Jt) {
                _t(Jt), Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var St = v(Oe), Vt; !(Vt = St()).done; ) {
                  const Et = Vt.value;
                  kt(Et);
                  const Qn = Lt(this, Et);
                  Qn && (Qn.delete(Jt), Qn.size === 0 && _e.get(this).delete(Et)), this.logIfDebugEnabled("unsubscribe", Et, void 0), Kt(Et) || Sn(this, Le, { eventName: Et, listener: Jt });
                }
              }, ln.once = function(Oe) {
                let Jt;
                const St = new n((Vt) => {
                  Jt = this.on(Oe, (Et) => {
                    Jt(), Vt(Et);
                  });
                });
                return St.off = Jt, St;
              }, ln.events = function(Oe) {
                Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var Jt = v(Oe), St; !(St = Jt()).done; ) {
                  const Vt = St.value;
                  kt(Vt);
                }
                return ft(this, Oe);
              }, ln.emit = /* @__PURE__ */ function() {
                var tt = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jt(St, Vt) {
                  var Et, Qn, gn, jt, On;
                  return u.default.wrap(function(ui) {
                    for (; ; ) switch (ui.prev = ui.next) {
                      case 0:
                        if (kt(St), !(Kt(St) && !at)) {
                          ui.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emit", St, Vt), Zt(this, St, Vt), Qn = (Et = Lt(this, St)) != null ? Et : /* @__PURE__ */ new Set(), gn = we.get(this), jt = [...Qn], On = Kt(St) ? [] : [...gn], ui.next = 11, $e;
                      case 11:
                        return ui.next = 13, n.all([...jt.map(/* @__PURE__ */ function() {
                          var fr = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jn(Qr) {
                            return u.default.wrap(function(Wn) {
                              for (; ; ) switch (Wn.prev = Wn.next) {
                                case 0:
                                  if (!Qn.has(Qr)) {
                                    Wn.next = 2;
                                    break;
                                  }
                                  return Wn.abrupt("return", Qr(Vt));
                                case 2:
                                case "end":
                                  return Wn.stop();
                              }
                            }, Jn);
                          }));
                          return function(Jn) {
                            return fr.apply(this, arguments);
                          };
                        }()), ...On.map(/* @__PURE__ */ function() {
                          var fr = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jn(Qr) {
                            return u.default.wrap(function(Wn) {
                              for (; ; ) switch (Wn.prev = Wn.next) {
                                case 0:
                                  if (!gn.has(Qr)) {
                                    Wn.next = 2;
                                    break;
                                  }
                                  return Wn.abrupt("return", Qr(St, Vt));
                                case 2:
                                case "end":
                                  return Wn.stop();
                              }
                            }, Jn);
                          }));
                          return function(Jn) {
                            return fr.apply(this, arguments);
                          };
                        }())]);
                      case 13:
                      case "end":
                        return ui.stop();
                    }
                  }, Jt, this);
                }));
                function Oe(Jt, St) {
                  return tt.apply(this, arguments);
                }
                return Oe;
              }(), ln.emitSerial = /* @__PURE__ */ function() {
                var tt = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jt(St, Vt) {
                  var Et, Qn, gn, jt, On, Ar, ui, fr, Jn, Qr;
                  return u.default.wrap(function(Wn) {
                    for (; ; ) switch (Wn.prev = Wn.next) {
                      case 0:
                        if (kt(St), !(Kt(St) && !at)) {
                          Wn.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emitSerial", St, Vt), Qn = (Et = Lt(this, St)) != null ? Et : /* @__PURE__ */ new Set(), gn = we.get(this), jt = [...Qn], On = [...gn], Wn.next = 10, $e;
                      case 10:
                        Ar = 0, ui = jt;
                      case 11:
                        if (!(Ar < ui.length)) {
                          Wn.next = 19;
                          break;
                        }
                        if (fr = ui[Ar], !Qn.has(fr)) {
                          Wn.next = 16;
                          break;
                        }
                        return Wn.next = 16, fr(Vt);
                      case 16:
                        Ar++, Wn.next = 11;
                        break;
                      case 19:
                        Jn = 0, Qr = On;
                      case 20:
                        if (!(Jn < Qr.length)) {
                          Wn.next = 28;
                          break;
                        }
                        if (fr = Qr[Jn], !gn.has(fr)) {
                          Wn.next = 25;
                          break;
                        }
                        return Wn.next = 25, fr(St, Vt);
                      case 25:
                        Jn++, Wn.next = 20;
                        break;
                      case 28:
                      case "end":
                        return Wn.stop();
                    }
                  }, Jt, this);
                }));
                function Oe(Jt, St) {
                  return tt.apply(this, arguments);
                }
                return Oe;
              }(), ln.onAny = function(Oe) {
                return _t(Oe), this.logIfDebugEnabled("subscribeAny", void 0, void 0), we.get(this).add(Oe), Sn(this, Bt, { listener: Oe }), this.offAny.bind(this, Oe);
              }, ln.anyEvent = function() {
                return ft(this);
              }, ln.offAny = function(Oe) {
                _t(Oe), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), Sn(this, Le, { listener: Oe }), we.get(this).delete(Oe);
              }, ln.clearListeners = function(Oe) {
                Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var Jt = v(Oe), St; !(St = Jt()).done; ) {
                  const fr = St.value;
                  if (this.logIfDebugEnabled("clear", fr, void 0), typeof fr == "string" || typeof fr == "symbol" || typeof fr == "number") {
                    const Jn = Lt(this, fr);
                    Jn && Jn.clear();
                    const Qr = Ft(this, fr);
                    if (Qr) {
                      for (var Vt = v(Qr), Et; !(Et = Vt()).done; )
                        Et.value.finish();
                      Qr.clear();
                    }
                  } else {
                    we.get(this).clear();
                    for (var Qn = v(_e.get(this).entries()), gn; !(gn = Qn()).done; ) {
                      const Jn = gn.value, Qr = Jn[0];
                      Jn[1].clear(), _e.get(this).delete(Qr);
                    }
                    for (var jt = v(Te.get(this).entries()), On; !(On = jt()).done; ) {
                      const Jn = On.value, Qr = Jn[0], ti = Jn[1];
                      for (var Ar = v(ti), ui; !(ui = Ar()).done; )
                        ui.value.finish();
                      ti.clear(), Te.get(this).delete(Qr);
                    }
                  }
                }
              }, ln.listenerCount = function(Oe) {
                var Jt, St, Vt, Et, Qn, gn;
                Oe = Array.isArray(Oe) ? Oe : [Oe];
                let jt = 0;
                for (var On = v(Oe), Ar; !(Ar = On()).done; ) {
                  const ti = Ar.value;
                  if (typeof ti == "string") {
                    jt += we.get(this).size + ((St = (Jt = Lt(this, ti)) == null ? void 0 : Jt.size) != null ? St : 0) + ((Et = (Vt = Ft(this, ti)) == null ? void 0 : Vt.size) != null ? Et : 0) + ((gn = (Qn = Ft(this)) == null ? void 0 : Qn.size) != null ? gn : 0);
                    continue;
                  }
                  typeof ti != "undefined" && kt(ti), jt += we.get(this).size;
                  for (var ui = v(_e.get(this).values()), fr; !(fr = ui()).done; ) {
                    const Wn = fr.value;
                    jt += Wn.size;
                  }
                  for (var Jn = v(Te.get(this).values()), Qr; !(Qr = Jn()).done; ) {
                    const Wn = Qr.value;
                    jt += Wn.size;
                  }
                }
                return jt;
              }, ln.bindMethods = function(Oe, Jt) {
                if (typeof Oe != "object" || Oe === null)
                  throw new TypeError("`target` must be an object");
                Jt = It(Jt);
                for (var St = v(Jt), Vt; !(Vt = St()).done; ) {
                  const Et = Vt.value;
                  if (Oe[Et] !== void 0)
                    throw new Error(`The property \`${Et}\` already exists on \`target\``);
                  Object.defineProperty(Oe, Et, { enumerable: !1, value: this[Et].bind(this) });
                }
              }, (0, g.default)(Rt, null, [{ key: "isDebugEnabled", get: function() {
                var Oe, Jt;
                if (typeof ((Oe = p.process) == null ? void 0 : Oe.env) != "object")
                  return pt;
                const St = (Jt = p.process) != null ? Jt : { env: {} }, Vt = St.env;
                return Vt.DEBUG === "emittery" || Vt.DEBUG === "*" || pt;
              }, set: function(Oe) {
                pt = Oe;
              } }]), Rt;
            }();
            const on = Object.getOwnPropertyNames(Cn.prototype).filter((Rt) => Rt !== "constructor");
            Object.defineProperty(Cn, "listenerAdded", { value: Bt, writable: !1, enumerable: !0, configurable: !1 }), Object.defineProperty(Cn, "listenerRemoved", { value: Le, writable: !1, enumerable: !0, configurable: !1 });
            function An(Rt) {
              return Rt.onAny && Rt.emit;
            }
            function Ue(Rt) {
              return Rt.prototype.onAny && Rt.prototype.emit;
            }
            let ne = 0;
            function se(Rt, ln, tt) {
              return Ce.apply(this, arguments);
            }
            function Ce() {
              return Ce = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt(ln, tt, Oe) {
                var Jt, St, Vt;
                return u.default.wrap(function(Qn) {
                  for (; ; ) switch (Qn.prev = Qn.next) {
                    case 0:
                      return Jt = Ue(ln), St = Jt ? new Cn() : {}, Vt = ne++, Object.getOwnPropertyNames(ln.prototype).forEach((gn) => {
                        St[gn] = function() {
                          for (var jt = arguments.length, On = new Array(jt), Ar = 0; Ar < jt; Ar++)
                            On[Ar] = arguments[Ar];
                          return G(tt, J.FORWARD, gn, On, Oe);
                        };
                      }), St.terminate = /* @__PURE__ */ (0, f.default)(/* @__PURE__ */ u.default.mark(function gn() {
                        var jt, On, Ar, ui, fr = arguments;
                        return u.default.wrap(function(Qr) {
                          for (; ; ) switch (Qr.prev = Qr.next) {
                            case 0:
                              for (jt = fr.length, On = new Array(jt), Ar = 0; Ar < jt; Ar++)
                                On[Ar] = fr[Ar];
                              return Qr.next = 3, G(tt, J.TERMINATE, "", On, Oe);
                            case 3:
                              return ui = Qr.sent, delete K[Vt], tt.terminate(), St.workerContext.worker = void 0, Qr.abrupt("return", ui);
                            case 8:
                            case "end":
                              return Qr.stop();
                          }
                        }, gn);
                      })), St.workerContext = { id: Vt, worker: tt, resolvers: Oe }, K[Vt] = St, Qn.abrupt("return", St);
                    case 8:
                    case "end":
                      return Qn.stop();
                  }
                }, Rt);
              })), Ce.apply(this, arguments);
            }
            function At(Rt, ln) {
              return Ge.apply(this, arguments);
            }
            function Ge() {
              return Ge = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt(ln, tt) {
                var Oe, Jt, St;
                return u.default.wrap(function(Et) {
                  for (; ; ) switch (Et.prev = Et.next) {
                    case 0:
                      return Oe = /* @__PURE__ */ new Map(), Et.next = 3, fe(ln, tt, Oe, (Qn, gn) => {
                        Jt != null && Jt.emit && (Jt == null || Jt.emit(Qn, gn));
                      });
                    case 3:
                      return St = Et.sent, Et.next = 6, se(ln, St, Oe);
                    case 6:
                      return Jt = Et.sent, Et.abrupt("return", Jt);
                    case 8:
                    case "end":
                      return Et.stop();
                  }
                }, Rt);
              })), Ge.apply(this, arguments);
            }
            function Ye(Rt, ln) {
              return Qt.apply(this, arguments);
            }
            function Qt() {
              return Qt = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt(ln, tt) {
                var Oe, Jt;
                return u.default.wrap(function(Vt) {
                  for (; ; ) switch (Vt.prev = Vt.next) {
                    case 0:
                      if (Oe = ln.functionName, Jt = ln.args, tt.instance) {
                        Vt.next = 3;
                        break;
                      }
                      throw "instance not initialized";
                    case 3:
                      if (Oe) {
                        Vt.next = 5;
                        break;
                      }
                      throw "missing function name to call";
                    case 5:
                      if (tt.instance[Oe]) {
                        Vt.next = 7;
                        break;
                      }
                      throw `undefined function [${Oe}] in class ${tt.instance.constructor.workerId}`;
                    case 7:
                      return Vt.t0 = Z, Vt.t1 = ln, Vt.next = 11, tt.instance[Oe](...Jt != null ? Jt : []);
                    case 11:
                      Vt.t2 = Vt.sent, (0, Vt.t0)(Vt.t1, Vt.t2);
                    case 13:
                    case "end":
                      return Vt.stop();
                  }
                }, Rt);
              })), Qt.apply(this, arguments);
            }
            const tn = Q("registeredWorkers", {});
            function vn(Rt, ln) {
              ln.workerId = Rt, L() && (tn[ln.workerId] = ln);
            }
            function Yt(Rt, ln) {
              if (!Rt.args)
                throw "Missing className while initializing worker";
              const tt = Rt.args, Oe = tt[0], Jt = tt[1], St = tn[Oe];
              if (St)
                ln.instance = new St(Rt.args.slice(1));
              else
                throw `unknown worker class ${Oe}`;
              oe(Jt, N), An(ln.instance) && ln.instance.onAny((Vt, Et) => {
                Z({ type: J.EVENT }, { name: Vt, data: Et });
              }), Z(Rt, typeof ln.instance !== void 0);
            }
            function Tn(Rt, ln) {
              return er.apply(this, arguments);
            }
            function er() {
              return er = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt(ln, tt) {
                var Oe, Jt;
                return u.default.wrap(function(Vt) {
                  for (; ; ) switch (Vt.prev = Vt.next) {
                    case 0:
                      if (Oe = ln.args, tt.instance) {
                        Vt.next = 3;
                        break;
                      }
                      throw "instance not initialized";
                    case 3:
                      if (!tt.instance.terminate) {
                        Vt.next = 7;
                        break;
                      }
                      return Vt.next = 6, tt.instance.terminate(...Oe != null ? Oe : []);
                    case 6:
                      Jt = Vt.sent;
                    case 7:
                      Z(ln, Jt);
                    case 8:
                    case "end":
                      return Vt.stop();
                  }
                }, Rt);
              })), er.apply(this, arguments);
            }
            function lr(Rt) {
              if (!Rt.args)
                throw "Missing globals while syncing";
              oe(Rt.args[0], N), Z(Rt, {});
            }
            function Br() {
              const Rt = {};
              onmessage = /* @__PURE__ */ function() {
                var ln = (0, f.default)(/* @__PURE__ */ u.default.mark(function tt(Oe) {
                  var Jt;
                  return u.default.wrap(function(Vt) {
                    for (; ; ) switch (Vt.prev = Vt.next) {
                      case 0:
                        Jt = Oe.data, Vt.t0 = Jt.type, Vt.next = Vt.t0 === J.INIT ? 4 : Vt.t0 === J.FORWARD ? 6 : Vt.t0 === J.TERMINATE ? 8 : Vt.t0 === J.GLOBALS_SYNC ? 10 : 12;
                        break;
                      case 4:
                        return Yt(Jt, Rt), Vt.abrupt("break", 12);
                      case 6:
                        return Ye(Jt, Rt), Vt.abrupt("break", 12);
                      case 8:
                        return Tn(Jt, Rt), Vt.abrupt("break", 12);
                      case 10:
                        return lr(Jt), Vt.abrupt("break", 12);
                      case 12:
                      case "end":
                        return Vt.stop();
                    }
                  }, tt);
                }));
                return function(Oe) {
                  return ln.apply(this, arguments);
                };
              }();
            }
            L() && Br();
            var pi = (() => {
              var Rt = { url: c("node_modules/@vonage/js-sframe/dist/js-sframe.es.js") }.url;
              return function(tt) {
                tt = tt || {};
                var tt = typeof tt != "undefined" ? tt : {}, Oe, Jt;
                tt.ready = new n(function(P, te) {
                  Oe = P, Jt = te;
                });
                var St = Object.assign({}, tt), Vt = (P, te) => {
                  throw te;
                }, Et = typeof window == "object", Qn = typeof importScripts == "function", gn = typeof t == "object" && typeof t.versions == "object" && typeof t.versions.node == "string", jt = "";
                function On(P) {
                  return tt.locateFile ? tt.locateFile(P, jt) : jt + P;
                }
                var Ar, ui, fr;
                function Jn(P) {
                  if (P instanceof Rl) return;
                  Wn("exiting due to exception: " + P);
                }
                if (gn) {
                  Qn ? jt = e(349).dirname(jt) + "/" : jt = o + "/";
                  var Qr, ti;
                  Qr = e(789), ti = e(349), Ar = (P, te) => {
                    var Re = xl(P);
                    return Re ? te ? Re : Re.toString() : (P = ti.normalize(P), Qr.readFileSync(P, te ? void 0 : "utf8"));
                  }, fr = (P) => {
                    var te = Ar(P, !0);
                    return te.buffer || (te = new Uint8Array(te)), te;
                  }, ui = (P, te, Re) => {
                    var Qe = xl(P);
                    Qe && te(Qe), P = ti.normalize(P), Qr.readFile(P, function(yt, Ht) {
                      yt ? Re(yt) : te(Ht.buffer);
                    });
                  }, t.argv.length > 1 && t.argv[1].replace(/\\/g, "/"), t.argv.slice(2), t.on("uncaughtException", function(P) {
                    if (!(P instanceof Rl))
                      throw P;
                  }), t.on("unhandledRejection", function(P) {
                    throw P;
                  }), Vt = (P, te) => {
                    if (Xn())
                      throw t.exitCode = P, te;
                    Jn(te), t.exit(P);
                  }, tt.inspect = function() {
                    return "[Emscripten Module object]";
                  };
                } else (Et || Qn) && (Qn ? jt = self.location.href : typeof document != "undefined" && document.currentScript && (jt = document.currentScript.src), Rt && (jt = Rt), jt.indexOf("blob:") !== 0 ? jt = jt.substr(0, jt.replace(/[?#].*/, "").lastIndexOf("/") + 1) : jt = "", Ar = (P) => {
                  try {
                    var te = new XMLHttpRequest();
                    return te.open("GET", P, !1), te.send(null), te.responseText;
                  } catch (Qe) {
                    var Re = xl(P);
                    if (Re)
                      return bc(Re);
                    throw Qe;
                  }
                }, Qn && (fr = (P) => {
                  try {
                    var te = new XMLHttpRequest();
                    return te.open("GET", P, !1), te.responseType = "arraybuffer", te.send(null), new Uint8Array(te.response);
                  } catch (Qe) {
                    var Re = xl(P);
                    if (Re)
                      return Re;
                    throw Qe;
                  }
                }), ui = (P, te, Re) => {
                  var Qe = new XMLHttpRequest();
                  Qe.open("GET", P, !0), Qe.responseType = "arraybuffer", Qe.onload = () => {
                    if (Qe.status == 200 || Qe.status == 0 && Qe.response) {
                      te(Qe.response);
                      return;
                    }
                    var yt = xl(P);
                    if (yt) {
                      te(yt.buffer);
                      return;
                    }
                    Re();
                  }, Qe.onerror = Re, Qe.send(null);
                });
                tt.print || console.log.bind(console);
                var Wn = tt.printErr || console.warn.bind(console);
                Object.assign(tt, St), St = null, tt.arguments && tt.arguments, tt.thisProgram && tt.thisProgram, tt.quit && (Vt = tt.quit);
                var Hi;
                tt.wasmBinary && (Hi = tt.wasmBinary);
                var Ho = tt.noExitRuntime || !0;
                typeof WebAssembly != "object" && _i("no native wasm support detected");
                var Ea, Ga = !1, No;
                function Ba(P, te) {
                  P || _i(te);
                }
                var Ra = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;
                function us(P, te, Re) {
                  for (var Qe = te + Re, yt = te; P[yt] && !(yt >= Qe); ) ++yt;
                  if (yt - te > 16 && P.buffer && Ra)
                    return Ra.decode(P.subarray(te, yt));
                  for (var Ht = ""; te < yt; ) {
                    var zt = P[te++];
                    if (!(zt & 128)) {
                      Ht += String.fromCharCode(zt);
                      continue;
                    }
                    var rn = P[te++] & 63;
                    if ((zt & 224) == 192) {
                      Ht += String.fromCharCode((zt & 31) << 6 | rn);
                      continue;
                    }
                    var tr = P[te++] & 63;
                    if ((zt & 240) == 224 ? zt = (zt & 15) << 12 | rn << 6 | tr : zt = (zt & 7) << 18 | rn << 12 | tr << 6 | P[te++] & 63, zt < 65536)
                      Ht += String.fromCharCode(zt);
                    else {
                      var Vn = zt - 65536;
                      Ht += String.fromCharCode(55296 | Vn >> 10, 56320 | Vn & 1023);
                    }
                  }
                  return Ht;
                }
                function so(P, te) {
                  return P ? us(Wa, P, te) : "";
                }
                function Va(P, te, Re, Qe) {
                  if (!(Qe > 0)) return 0;
                  for (var yt = Re, Ht = Re + Qe - 1, zt = 0; zt < P.length; ++zt) {
                    var rn = P.charCodeAt(zt);
                    if (rn >= 55296 && rn <= 57343) {
                      var tr = P.charCodeAt(++zt);
                      rn = 65536 + ((rn & 1023) << 10) | tr & 1023;
                    }
                    if (rn <= 127) {
                      if (Re >= Ht) break;
                      te[Re++] = rn;
                    } else if (rn <= 2047) {
                      if (Re + 1 >= Ht) break;
                      te[Re++] = 192 | rn >> 6, te[Re++] = 128 | rn & 63;
                    } else if (rn <= 65535) {
                      if (Re + 2 >= Ht) break;
                      te[Re++] = 224 | rn >> 12, te[Re++] = 128 | rn >> 6 & 63, te[Re++] = 128 | rn & 63;
                    } else {
                      if (Re + 3 >= Ht) break;
                      te[Re++] = 240 | rn >> 18, te[Re++] = 128 | rn >> 12 & 63, te[Re++] = 128 | rn >> 6 & 63, te[Re++] = 128 | rn & 63;
                    }
                  }
                  return te[Re] = 0, Re - yt;
                }
                function qa(P, te, Re) {
                  return Va(P, Wa, te, Re);
                }
                function hs(P) {
                  for (var te = 0, Re = 0; Re < P.length; ++Re) {
                    var Qe = P.charCodeAt(Re);
                    Qe <= 127 ? te++ : Qe <= 2047 ? te += 2 : Qe >= 55296 && Qe <= 57343 ? (te += 4, ++Re) : te += 3;
                  }
                  return te;
                }
                var oi, oa, Wa, Xa, ya, Fl, As, gl, Vi, zr, za;
                function ws(P) {
                  oi = P, tt.HEAP8 = oa = new Int8Array(P), tt.HEAP16 = Xa = new Int16Array(P), tt.HEAP32 = Fl = new Int32Array(P), tt.HEAPU8 = Wa = new Uint8Array(P), tt.HEAPU16 = ya = new Uint16Array(P), tt.HEAPU32 = As = new Uint32Array(P), tt.HEAPF32 = gl = new Float32Array(P), tt.HEAPF64 = za = new Float64Array(P), tt.HEAP64 = Vi = new BigInt64Array(P), tt.HEAPU64 = zr = new BigUint64Array(P);
                }
                tt.INITIAL_MEMORY;
                var Zi, kl = [], vc = [], wl = [], ys = [];
                function Xn() {
                  return Ho;
                }
                function Kn() {
                  if (tt.preRun)
                    for (typeof tt.preRun == "function" && (tt.preRun = [tt.preRun]); tt.preRun.length; )
                      qt(tt.preRun.shift());
                  ms(kl);
                }
                function pr() {
                  ms(vc);
                }
                function hi() {
                  ms(wl);
                }
                function Qi() {
                  if (tt.postRun)
                    for (typeof tt.postRun == "function" && (tt.postRun = [tt.postRun]); tt.postRun.length; )
                      hn(tt.postRun.shift());
                  ms(ys);
                }
                function qt(P) {
                  kl.unshift(P);
                }
                function bn(P) {
                  vc.unshift(P);
                }
                function hn(P) {
                  ys.unshift(P);
                }
                var xn = 0, vr = null;
                function Rr(P) {
                  xn++, tt.monitorRunDependencies && tt.monitorRunDependencies(xn);
                }
                function zi(P) {
                  if (xn--, tt.monitorRunDependencies && tt.monitorRunDependencies(xn), xn == 0 && vr) {
                    var te = vr;
                    vr = null, te();
                  }
                }
                function _i(P) {
                  tt.onAbort && tt.onAbort(P), P = "Aborted(" + P + ")", Wn(P), Ga = !0, No = 1, P += ". Build with -sASSERTIONS for more info.";
                  var te = new WebAssembly.RuntimeError(P);
                  throw Jt(te), te;
                }
                var Ko = "data:application/octet-stream;base64,";
                function ps(P) {
                  return P.startsWith(Ko);
                }
                function ho(P) {
                  return P.startsWith("file://");
                }
                var Ya;
                Ya = "data:application/octet-stream;base64,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", ps(Ya) || (Ya = On(Ya));
                function La(P) {
                  try {
                    if (P == Ya && Hi)
                      return new Uint8Array(Hi);
                    var te = xl(P);
                    if (te)
                      return te;
                    if (fr)
                      return fr(P);
                    throw "both async and sync fetching of the wasm failed";
                  } catch (Re) {
                    _i(Re);
                  }
                }
                function Jd() {
                  if (!Hi && (Et || Qn)) {
                    if (typeof fetch == "function" && !ho(Ya))
                      return fetch(Ya, { credentials: "same-origin" }).then(function(P) {
                        if (!P.ok)
                          throw "failed to load wasm binary file at '" + Ya + "'";
                        return P.arrayBuffer();
                      }).catch(function() {
                        return La(Ya);
                      });
                    if (ui)
                      return new n(function(P, te) {
                        ui(Ya, function(Re) {
                          P(new Uint8Array(Re));
                        }, te);
                      });
                  }
                  return n.resolve().then(function() {
                    return La(Ya);
                  });
                }
                function zo() {
                  var P = { a: Yd };
                  function te(zt, rn) {
                    var tr = zt.exports;
                    tt.asm = tr, Ea = tt.asm.v, ws(Ea.buffer), Zi = tt.asm.y, bn(tt.asm.w), zi();
                  }
                  Rr();
                  function Re(zt) {
                    te(zt.instance);
                  }
                  function Qe(zt) {
                    return Jd().then(function(rn) {
                      return WebAssembly.instantiate(rn, P);
                    }).then(function(rn) {
                      return rn;
                    }).then(zt, function(rn) {
                      Wn("failed to asynchronously prepare wasm: " + rn), _i(rn);
                    });
                  }
                  function yt() {
                    return !Hi && typeof WebAssembly.instantiateStreaming == "function" && !ps(Ya) && !ho(Ya) && !gn && typeof fetch == "function" ? fetch(Ya, { credentials: "same-origin" }).then(function(zt) {
                      var rn = WebAssembly.instantiateStreaming(zt, P);
                      return rn.then(Re, function(tr) {
                        return Wn("wasm streaming compile failed: " + tr), Wn("falling back to ArrayBuffer instantiation"), Qe(Re);
                      });
                    }) : Qe(Re);
                  }
                  if (tt.instantiateWasm)
                    try {
                      var Ht = tt.instantiateWasm(P, te);
                      return Ht;
                    } catch (zt) {
                      Wn("Module.instantiateWasm callback failed with error: " + zt), Jt(zt);
                    }
                  return yt().catch(Jt), {};
                }
                function Rl(P) {
                  this.name = "ExitStatus", this.message = "Program terminated with exit(" + P + ")", this.status = P;
                }
                function ms(P) {
                  for (; P.length > 0; )
                    P.shift()(tt);
                }
                function $o(P) {
                  if (P instanceof Rl || P == "unwind")
                    return No;
                  Vt(1, P);
                }
                function bc(P) {
                  for (var te = [], Re = 0; Re < P.length; Re++) {
                    var Qe = P[Re];
                    Qe > 255 && (Qe &= 255), te.push(String.fromCharCode(Qe));
                  }
                  return te.join("");
                }
                function Zc(P, te, Re, Qe) {
                  _i("Assertion failed: " + so(P) + ", at: " + [te ? so(te) : "unknown filename", Re, Qe ? so(Qe) : "unknown function"]);
                }
                function oc(P) {
                  if (P === null)
                    return "null";
                  var te = typeof P;
                  return te === "object" || te === "array" || te === "function" ? P.toString() : "" + P;
                }
                function gu() {
                  for (var P = new Array(256), te = 0; te < 256; ++te)
                    P[te] = String.fromCharCode(te);
                  zd = P;
                }
                var zd = void 0;
                function ka(P) {
                  for (var te = "", Re = P; Wa[Re]; )
                    te += zd[Wa[Re++]];
                  return te;
                }
                var jr = {}, xe = {}, ot = {}, ye = 48, re = 57;
                function Be(P) {
                  if (P === void 0)
                    return "_unknown";
                  P = P.replace(/[^a-zA-Z0-9_]/g, "$");
                  var te = P.charCodeAt(0);
                  return te >= ye && te <= re ? "_" + P : P;
                }
                function He(P, te) {
                  return P = Be(P), new Function("body", "return function " + P + `() {
    "use strict";    return body.apply(this, arguments);
};
`)(te);
                }
                function Xe(P, te) {
                  var Re = He(te, function(Qe) {
                    this.name = te, this.message = Qe;
                    var yt = new Error(Qe).stack;
                    yt !== void 0 && (this.stack = this.toString() + `
` + yt.replace(/^Error(:[^\n]*)?\n/, ""));
                  });
                  return Re.prototype = Object.create(P.prototype), Re.prototype.constructor = Re, Re.prototype.toString = function() {
                    return this.message === void 0 ? this.name : this.name + ": " + this.message;
                  }, Re;
                }
                var ut = void 0;
                function ct(P) {
                  throw new ut(P);
                }
                var Xt = void 0;
                function pn(P) {
                  throw new Xt(P);
                }
                function un(P, te, Re) {
                  P.forEach(function(rn) {
                    ot[rn] = te;
                  });
                  function Qe(rn) {
                    var tr = Re(rn);
                    tr.length !== P.length && pn("Mismatched type converter count");
                    for (var Vn = 0; Vn < P.length; ++Vn)
                      vt(P[Vn], tr[Vn]);
                  }
                  var yt = new Array(te.length), Ht = [], zt = 0;
                  te.forEach((rn, tr) => {
                    xe.hasOwnProperty(rn) ? yt[tr] = xe[rn] : (Ht.push(rn), jr.hasOwnProperty(rn) || (jr[rn] = []), jr[rn].push(() => {
                      yt[tr] = xe[rn], ++zt, zt === Ht.length && Qe(yt);
                    }));
                  }), Ht.length === 0 && Qe(yt);
                }
                function vt(P, te, Re) {
                  if (Re === void 0 && (Re = {}), !("argPackAdvance" in te))
                    throw new TypeError("registerType registeredInstance requires argPackAdvance");
                  var Qe = te.name;
                  if (P || ct('type "' + Qe + '" must have a positive integer typeid pointer'), xe.hasOwnProperty(P)) {
                    if (Re.ignoreDuplicateRegistrations)
                      return;
                    ct("Cannot register type '" + Qe + "' twice");
                  }
                  if (xe[P] = te, delete ot[P], jr.hasOwnProperty(P)) {
                    var yt = jr[P];
                    delete jr[P], yt.forEach((Ht) => Ht());
                  }
                }
                function gr(P, te, Re) {
                  switch (te) {
                    case 0:
                      return Re ? function(yt) {
                        return oa[yt];
                      } : function(yt) {
                        return Wa[yt];
                      };
                    case 1:
                      return Re ? function(yt) {
                        return Xa[yt >> 1];
                      } : function(yt) {
                        return ya[yt >> 1];
                      };
                    case 2:
                      return Re ? function(yt) {
                        return Fl[yt >> 2];
                      } : function(yt) {
                        return As[yt >> 2];
                      };
                    case 3:
                      return Re ? function(yt) {
                        return Vi[yt >> 3];
                      } : function(yt) {
                        return zr[yt >> 3];
                      };
                    default:
                      throw new TypeError("Unknown integer type: " + P);
                  }
                }
                function sr(P, te, Re, Qe, yt) {
                  te = ka(te);
                  var Ht = an(Re), zt = te.indexOf("u") != -1;
                  zt && (yt = (1n << 64n) - 1n), vt(P, { name: te, fromWireType: function(tr) {
                    return tr;
                  }, toWireType: function(tr, Vn) {
                    if (typeof Vn != "bigint" && typeof Vn != "number")
                      throw new TypeError('Cannot convert "' + oc(Vn) + '" to ' + this.name);
                    if (Vn < Qe || Vn > yt)
                      throw new TypeError('Passing a number "' + oc(Vn) + '" from JS side to C/C++ side to an argument of type "' + te + '", which is outside the valid range [' + Qe + ", " + yt + "]!");
                    return Vn;
                  }, argPackAdvance: 8, readValueFromPointer: gr(te, Ht, !zt), destructorFunction: null });
                }
                function an(P) {
                  switch (P) {
                    case 1:
                      return 0;
                    case 2:
                      return 1;
                    case 4:
                      return 2;
                    case 8:
                      return 3;
                    default:
                      throw new TypeError("Unknown type size: " + P);
                  }
                }
                function En(P, te, Re, Qe, yt) {
                  var Ht = an(Re);
                  te = ka(te), vt(P, { name: te, fromWireType: function(rn) {
                    return !!rn;
                  }, toWireType: function(rn, tr) {
                    return tr ? Qe : yt;
                  }, argPackAdvance: 8, readValueFromPointer: function(rn) {
                    var tr;
                    if (Re === 1)
                      tr = oa;
                    else if (Re === 2)
                      tr = Xa;
                    else if (Re === 4)
                      tr = Fl;
                    else
                      throw new TypeError("Unknown boolean type size: " + te);
                    return this.fromWireType(tr[rn >> Ht]);
                  }, destructorFunction: null });
                }
                function fn(P) {
                  if (!(this instanceof Ll) || !(P instanceof Ll))
                    return !1;
                  for (var te = this.$$.ptrType.registeredClass, Re = this.$$.ptr, Qe = P.$$.ptrType.registeredClass, yt = P.$$.ptr; te.baseClass; )
                    Re = te.upcast(Re), te = te.baseClass;
                  for (; Qe.baseClass; )
                    yt = Qe.upcast(yt), Qe = Qe.baseClass;
                  return te === Qe && Re === yt;
                }
                function Fr(P) {
                  return { count: P.count, deleteScheduled: P.deleteScheduled, preservePointerOnDelete: P.preservePointerOnDelete, ptr: P.ptr, ptrType: P.ptrType, smartPtr: P.smartPtr, smartPtrType: P.smartPtrType };
                }
                function Ro(P) {
                  function te(Re) {
                    return Re.$$.ptrType.registeredClass.name;
                  }
                  ct(te(P) + " instance already deleted");
                }
                var ca = !1;
                function Co(P) {
                }
                function ga(P) {
                  P.smartPtr ? P.smartPtrType.rawDestructor(P.smartPtr) : P.ptrType.registeredClass.rawDestructor(P.ptr);
                }
                function aa(P) {
                  P.count.value -= 1;
                  var te = P.count.value === 0;
                  te && ga(P);
                }
                function Dl(P, te, Re) {
                  if (te === Re)
                    return P;
                  if (Re.baseClass === void 0)
                    return null;
                  var Qe = Dl(P, te, Re.baseClass);
                  return Qe === null ? null : Re.downcast(Qe);
                }
                var Jo = {};
                function Pi() {
                  return Object.keys(_l).length;
                }
                function wa() {
                  var P = [];
                  for (var te in _l)
                    _l.hasOwnProperty(te) && P.push(_l[te]);
                  return P;
                }
                var yl = [];
                function Ci() {
                  for (; yl.length; ) {
                    var P = yl.pop();
                    P.$$.deleteScheduled = !1, P.delete();
                  }
                }
                var Ti = void 0;
                function Di(P) {
                  Ti = P, yl.length && Ti && Ti(Ci);
                }
                function Gd() {
                  tt.getInheritedInstanceCount = Pi, tt.getLiveInheritedInstances = wa, tt.flushPendingDeletes = Ci, tt.setDelayFunction = Di;
                }
                var _l = {};
                function Zl(P, te) {
                  for (te === void 0 && ct("ptr should not be undefined"); P.baseClass; )
                    te = P.upcast(te), P = P.baseClass;
                  return te;
                }
                function Ml(P, te) {
                  return te = Zl(P, te), _l[te];
                }
                function kc(P, te) {
                  (!te.ptrType || !te.ptr) && pn("makeClassHandle requires ptr and ptrType");
                  var Re = !!te.smartPtrType, Qe = !!te.smartPtr;
                  return Re !== Qe && pn("Both smartPtrType and smartPtr must be specified"), te.count = { value: 1 }, wc(Object.create(P, { $$: { value: te } }));
                }
                function Td(P) {
                  var te = this.getPointee(P);
                  if (!te)
                    return this.destructor(P), null;
                  var Re = Ml(this.registeredClass, te);
                  if (Re !== void 0) {
                    if (Re.$$.count.value === 0)
                      return Re.$$.ptr = te, Re.$$.smartPtr = P, Re.clone();
                    var Qe = Re.clone();
                    return this.destructor(P), Qe;
                  }
                  function yt() {
                    return this.isSmartPointer ? kc(this.registeredClass.instancePrototype, { ptrType: this.pointeeType, ptr: te, smartPtrType: this, smartPtr: P }) : kc(this.registeredClass.instancePrototype, { ptrType: this, ptr: P });
                  }
                  var Ht = this.registeredClass.getActualType(te), zt = Jo[Ht];
                  if (!zt)
                    return yt.call(this);
                  var rn;
                  this.isConst ? rn = zt.constPointerType : rn = zt.pointerType;
                  var tr = Dl(te, this.registeredClass, rn.registeredClass);
                  return tr === null ? yt.call(this) : this.isSmartPointer ? kc(rn.registeredClass.instancePrototype, { ptrType: rn, ptr: tr, smartPtrType: this, smartPtr: P }) : kc(rn.registeredClass.instancePrototype, { ptrType: rn, ptr: tr });
                }
                function wc(P) {
                  return typeof FinalizationRegistry == "undefined" ? (wc = (te) => te, P) : (ca = new FinalizationRegistry((te) => {
                    aa(te.$$);
                  }), wc = (te) => {
                    var Re = te.$$, Qe = !!Re.smartPtr;
                    if (Qe) {
                      var yt = { $$: Re };
                      ca.register(te, yt, te);
                    }
                    return te;
                  }, Co = (te) => ca.unregister(te), wc(P));
                }
                function $l() {
                  if (this.$$.ptr || Ro(this), this.$$.preservePointerOnDelete)
                    return this.$$.count.value += 1, this;
                  var P = wc(Object.create(Object.getPrototypeOf(this), { $$: { value: Fr(this.$$) } }));
                  return P.$$.count.value += 1, P.$$.deleteScheduled = !1, P;
                }
                function Yl() {
                  this.$$.ptr || Ro(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && ct("Object already scheduled for deletion"), Co(this), aa(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
                }
                function js() {
                  return !this.$$.ptr;
                }
                function ac() {
                  return this.$$.ptr || Ro(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && ct("Object already scheduled for deletion"), yl.push(this), yl.length === 1 && Ti && Ti(Ci), this.$$.deleteScheduled = !0, this;
                }
                function Dc() {
                  Ll.prototype.isAliasOf = fn, Ll.prototype.clone = $l, Ll.prototype.delete = Yl, Ll.prototype.isDeleted = js, Ll.prototype.deleteLater = ac;
                }
                function Ll() {
                }
                function ed(P, te, Re) {
                  if (P[te].overloadTable === void 0) {
                    var Qe = P[te];
                    P[te] = function() {
                      return P[te].overloadTable.hasOwnProperty(arguments.length) || ct("Function '" + Re + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + P[te].overloadTable + ")!"), P[te].overloadTable[arguments.length].apply(this, arguments);
                    }, P[te].overloadTable = [], P[te].overloadTable[Qe.argCount] = Qe;
                  }
                }
                function sc(P, te, Re) {
                  tt.hasOwnProperty(P) ? (ct("Cannot register public name '" + P + "' twice"), ed(tt, P, P), tt.hasOwnProperty(Re) && ct("Cannot register multiple overloads of a function with the same number of arguments (" + Re + ")!"), tt[P].overloadTable[Re] = te) : tt[P] = te;
                }
                function Ql(P, te, Re, Qe, yt, Ht, zt, rn) {
                  this.name = P, this.constructor = te, this.instancePrototype = Re, this.rawDestructor = Qe, this.baseClass = yt, this.getActualType = Ht, this.upcast = zt, this.downcast = rn, this.pureVirtualFunctions = [];
                }
                function ql(P, te, Re) {
                  for (; te !== Re; )
                    te.upcast || ct("Expected null or instance of " + Re.name + ", got an instance of " + te.name), P = te.upcast(P), te = te.baseClass;
                  return P;
                }
                function Ds(P, te) {
                  if (te === null)
                    return this.isReference && ct("null is not a valid " + this.name), 0;
                  te.$$ || ct('Cannot pass "' + oc(te) + '" as a ' + this.name), te.$$.ptr || ct("Cannot pass deleted object as a pointer of type " + this.name);
                  var Re = te.$$.ptrType.registeredClass, Qe = ql(te.$$.ptr, Re, this.registeredClass);
                  return Qe;
                }
                function jd(P, te) {
                  var Re;
                  if (te === null)
                    return this.isReference && ct("null is not a valid " + this.name), this.isSmartPointer ? (Re = this.rawConstructor(), P !== null && P.push(this.rawDestructor, Re), Re) : 0;
                  te.$$ || ct('Cannot pass "' + oc(te) + '" as a ' + this.name), te.$$.ptr || ct("Cannot pass deleted object as a pointer of type " + this.name), !this.isConst && te.$$.ptrType.isConst && ct("Cannot convert argument of type " + (te.$$.smartPtrType ? te.$$.smartPtrType.name : te.$$.ptrType.name) + " to parameter type " + this.name);
                  var Qe = te.$$.ptrType.registeredClass;
                  if (Re = ql(te.$$.ptr, Qe, this.registeredClass), this.isSmartPointer)
                    switch (te.$$.smartPtr === void 0 && ct("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
                      case 0:
                        te.$$.smartPtrType === this ? Re = te.$$.smartPtr : ct("Cannot convert argument of type " + (te.$$.smartPtrType ? te.$$.smartPtrType.name : te.$$.ptrType.name) + " to parameter type " + this.name);
                        break;
                      case 1:
                        Re = te.$$.smartPtr;
                        break;
                      case 2:
                        if (te.$$.smartPtrType === this)
                          Re = te.$$.smartPtr;
                        else {
                          var yt = te.clone();
                          Re = this.rawShare(Re, Da.toHandle(function() {
                            yt.delete();
                          })), P !== null && P.push(this.rawDestructor, Re);
                        }
                        break;
                      default:
                        ct("Unsupporting sharing policy");
                    }
                  return Re;
                }
                function Sc(P, te) {
                  if (te === null)
                    return this.isReference && ct("null is not a valid " + this.name), 0;
                  te.$$ || ct('Cannot pass "' + oc(te) + '" as a ' + this.name), te.$$.ptr || ct("Cannot pass deleted object as a pointer of type " + this.name), te.$$.ptrType.isConst && ct("Cannot convert argument of type " + te.$$.ptrType.name + " to parameter type " + this.name);
                  var Re = te.$$.ptrType.registeredClass, Qe = ql(te.$$.ptr, Re, this.registeredClass);
                  return Qe;
                }
                function Cl(P) {
                  return this.fromWireType(Fl[P >> 2]);
                }
                function _r(P) {
                  return this.rawGetPointee && (P = this.rawGetPointee(P)), P;
                }
                function Xd(P) {
                  this.rawDestructor && this.rawDestructor(P);
                }
                function to(P) {
                  P !== null && P.delete();
                }
                function Za() {
                  sa.prototype.getPointee = _r, sa.prototype.destructor = Xd, sa.prototype.argPackAdvance = 8, sa.prototype.readValueFromPointer = Cl, sa.prototype.deleteObject = to, sa.prototype.fromWireType = Td;
                }
                function sa(P, te, Re, Qe, yt, Ht, zt, rn, tr, Vn, si) {
                  this.name = P, this.registeredClass = te, this.isReference = Re, this.isConst = Qe, this.isSmartPointer = yt, this.pointeeType = Ht, this.sharingPolicy = zt, this.rawGetPointee = rn, this.rawConstructor = tr, this.rawShare = Vn, this.rawDestructor = si, !yt && te.baseClass === void 0 ? Qe ? (this.toWireType = Ds, this.destructorFunction = null) : (this.toWireType = Sc, this.destructorFunction = null) : this.toWireType = jd;
                }
                function Ec(P, te, Re) {
                  tt.hasOwnProperty(P) || pn("Replacing nonexistant public symbol"), tt[P].overloadTable !== void 0 && Re !== void 0 ? tt[P].overloadTable[Re] = te : (tt[P] = te, tt[P].argCount = Re);
                }
                var Fc = [];
                function Cd(P) {
                  var te = Fc[P];
                  return te || (P >= Fc.length && (Fc.length = P + 1), Fc[P] = te = Zi.get(P)), te;
                }
                function Sl(P, te) {
                  P = ka(P);
                  function Re() {
                    return Cd(te);
                  }
                  var Qe = Re();
                  return typeof Qe != "function" && ct("unknown function pointer with signature " + P + ": " + te), Qe;
                }
                var Uo = void 0;
                function ja(P) {
                  var te = et(P), Re = ka(te);
                  return nt(te), Re;
                }
                function Mc(P, te) {
                  var Re = [], Qe = {};
                  function yt(Ht) {
                    if (!Qe[Ht] && !xe[Ht]) {
                      if (ot[Ht]) {
                        ot[Ht].forEach(yt);
                        return;
                      }
                      Re.push(Ht), Qe[Ht] = !0;
                    }
                  }
                  throw te.forEach(yt), new Uo(P + ": " + Re.map(ja).join([", "]));
                }
                function td(P, te, Re, Qe, yt, Ht, zt, rn, tr, Vn, si, ai, Ui) {
                  si = ka(si), Ht = Sl(yt, Ht), rn && (rn = Sl(zt, rn)), Vn && (Vn = Sl(tr, Vn)), Ui = Sl(ai, Ui);
                  var Sa = Be(si);
                  sc(Sa, function() {
                    Mc("Cannot construct " + si + " due to unbound types", [Qe]);
                  }), un([P, te, Re], Qe ? [Qe] : [], function(xa) {
                    xa = xa[0];
                    var ll, Hc;
                    Qe ? (ll = xa.registeredClass, Hc = ll.instancePrototype) : Hc = Ll.prototype;
                    var Wc = He(Sa, function() {
                      if (Object.getPrototypeOf(this) !== Zd)
                        throw new ut("Use 'new' to construct " + si);
                      if (Sd.constructor_body === void 0)
                        throw new ut(si + " has no accessible constructor");
                      var qd = Sd.constructor_body[arguments.length];
                      if (qd === void 0)
                        throw new ut("Tried to invoke ctor of " + si + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(Sd.constructor_body).toString() + ") parameters instead!");
                      return qd.apply(this, arguments);
                    }), Zd = Object.create(Hc, { constructor: { value: Wc } });
                    Wc.prototype = Zd;
                    var Sd = new Ql(si, Wc, Zd, Ui, ll, Ht, rn, Vn), lu = new sa(si, Sd, !0, !1, !1), Zu = new sa(si + "*", Sd, !1, !1, !1), Su = new sa(si + " const*", Sd, !1, !0, !1);
                    return Jo[P] = { pointerType: Zu, constPointerType: Su }, Ec(Sa, Wc), [lu, Zu, Su];
                  });
                }
                function Ud(P, te) {
                  for (var Re = [], Qe = 0; Qe < P; Qe++)
                    Re.push(As[te + Qe * 4 >> 2]);
                  return Re;
                }
                function fl(P) {
                  for (; P.length; ) {
                    var te = P.pop(), Re = P.pop();
                    Re(te);
                  }
                }
                function ou(P, te) {
                  if (!(P instanceof Function))
                    throw new TypeError("new_ called with constructor type " + typeof P + " which is not a function");
                  var Re = He(P.name || "unknownFunctionName", function() {
                  });
                  Re.prototype = P.prototype;
                  var Qe = new Re(), yt = P.apply(Qe, te);
                  return yt instanceof Object ? yt : Qe;
                }
                function nd(P, te, Re, Qe, yt) {
                  var Ht = te.length;
                  Ht < 2 && ct("argTypes array size mismatch! Must at least get return value and 'this' types!");
                  for (var zt = te[1] !== null && Re !== null, rn = !1, tr = 1; tr < te.length; ++tr)
                    if (te[tr] !== null && te[tr].destructorFunction === void 0) {
                      rn = !0;
                      break;
                    }
                  for (var Vn = te[0].name !== "void", si = "", ai = "", tr = 0; tr < Ht - 2; ++tr)
                    si += (tr !== 0 ? ", " : "") + "arg" + tr, ai += (tr !== 0 ? ", " : "") + "arg" + tr + "Wired";
                  var Ui = "return function " + Be(P) + "(" + si + `) {
if (arguments.length !== ` + (Ht - 2) + `) {
throwBindingError('function ` + P + " called with ' + arguments.length + ' arguments, expected " + (Ht - 2) + ` args!');
}
`;
                  rn && (Ui += `var destructors = [];
`);
                  var Sa = rn ? "destructors" : "null", xa = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"], ll = [ct, Qe, yt, fl, te[0], te[1]];
                  zt && (Ui += "var thisWired = classParam.toWireType(" + Sa + `, this);
`);
                  for (var tr = 0; tr < Ht - 2; ++tr)
                    Ui += "var arg" + tr + "Wired = argType" + tr + ".toWireType(" + Sa + ", arg" + tr + "); // " + te[tr + 2].name + `
`, xa.push("argType" + tr), ll.push(te[tr + 2]);
                  if (zt && (ai = "thisWired" + (ai.length > 0 ? ", " : "") + ai), Ui += (Vn ? "var rv = " : "") + "invoker(fn" + (ai.length > 0 ? ", " : "") + ai + `);
`, rn)
                    Ui += `runDestructors(destructors);
`;
                  else
                    for (var tr = zt ? 1 : 2; tr < te.length; ++tr) {
                      var Hc = tr === 1 ? "thisWired" : "arg" + (tr - 2) + "Wired";
                      te[tr].destructorFunction !== null && (Ui += Hc + "_dtor(" + Hc + "); // " + te[tr].name + `
`, xa.push(Hc + "_dtor"), ll.push(te[tr].destructorFunction));
                    }
                  Vn && (Ui += `var ret = retType.fromWireType(rv);
return ret;
`), Ui += `}
`, xa.push(Ui);
                  var Wc = ou(Function, xa).apply(null, ll);
                  return Wc;
                }
                function au(P, te, Re, Qe, yt, Ht) {
                  Ba(te > 0);
                  var zt = Ud(te, Re);
                  yt = Sl(Qe, yt), un([], [P], function(rn) {
                    rn = rn[0];
                    var tr = "constructor " + rn.name;
                    if (rn.registeredClass.constructor_body === void 0 && (rn.registeredClass.constructor_body = []), rn.registeredClass.constructor_body[te - 1] !== void 0)
                      throw new ut("Cannot register multiple constructors with identical number of parameters (" + (te - 1) + ") for class '" + rn.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
                    return rn.registeredClass.constructor_body[te - 1] = () => {
                      Mc("Cannot construct " + rn.name + " due to unbound types", zt);
                    }, un([], zt, function(Vn) {
                      return Vn.splice(1, 0, null), rn.registeredClass.constructor_body[te - 1] = nd(tr, Vn, null, yt, Ht), [];
                    }), [];
                  });
                }
                function lc(P, te, Re, Qe, yt, Ht, zt, rn) {
                  var tr = Ud(Re, Qe);
                  te = ka(te), Ht = Sl(yt, Ht), un([], [P], function(Vn) {
                    Vn = Vn[0];
                    var si = Vn.name + "." + te;
                    te.startsWith("@@") && (te = Symbol[te.substring(2)]), rn && Vn.registeredClass.pureVirtualFunctions.push(te);
                    function ai() {
                      Mc("Cannot call " + si + " due to unbound types", tr);
                    }
                    var Ui = Vn.registeredClass.instancePrototype, Sa = Ui[te];
                    return Sa === void 0 || Sa.overloadTable === void 0 && Sa.className !== Vn.name && Sa.argCount === Re - 2 ? (ai.argCount = Re - 2, ai.className = Vn.name, Ui[te] = ai) : (ed(Ui, te, si), Ui[te].overloadTable[Re - 2] = ai), un([], tr, function(xa) {
                      var ll = nd(si, xa, Vn, Ht, zt);
                      return Ui[te].overloadTable === void 0 ? (ll.argCount = Re - 2, Ui[te] = ll) : Ui[te].overloadTable[Re - 2] = ll, [];
                    }), [];
                  });
                }
                var Vc = [], _s = [{}, { value: void 0 }, { value: null }, { value: !0 }, { value: !1 }];
                function da(P) {
                  P > 4 && --_s[P].refcount === 0 && (_s[P] = void 0, Vc.push(P));
                }
                function kd() {
                  for (var P = 0, te = 5; te < _s.length; ++te)
                    _s[te] !== void 0 && ++P;
                  return P;
                }
                function la() {
                  for (var P = 5; P < _s.length; ++P)
                    if (_s[P] !== void 0)
                      return _s[P];
                  return null;
                }
                function cc() {
                  tt.count_emval_handles = kd, tt.get_first_emval = la;
                }
                var Da = { toValue: (P) => (P || ct("Cannot use deleted val. handle = " + P), _s[P].value), toHandle: (P) => {
                  switch (P) {
                    case void 0:
                      return 1;
                    case null:
                      return 2;
                    case !0:
                      return 3;
                    case !1:
                      return 4;
                    default: {
                      var te = Vc.length ? Vc.pop() : _s.length;
                      return _s[te] = { refcount: 1, value: P }, te;
                    }
                  }
                } };
                function ea(P, te) {
                  te = ka(te), vt(P, { name: te, fromWireType: function(Qe) {
                    var yt = Da.toValue(Qe);
                    return da(Qe), yt;
                  }, toWireType: function(Qe, yt) {
                    return Da.toHandle(yt);
                  }, argPackAdvance: 8, readValueFromPointer: Cl, destructorFunction: null });
                }
                function ec(P, te, Re) {
                  switch (te) {
                    case 0:
                      return function(Qe) {
                        var yt = Re ? oa : Wa;
                        return this.fromWireType(yt[Qe]);
                      };
                    case 1:
                      return function(Qe) {
                        var yt = Re ? Xa : ya;
                        return this.fromWireType(yt[Qe >> 1]);
                      };
                    case 2:
                      return function(Qe) {
                        var yt = Re ? Fl : As;
                        return this.fromWireType(yt[Qe >> 2]);
                      };
                    default:
                      throw new TypeError("Unknown integer type: " + P);
                  }
                }
                function Yc(P, te, Re, Qe) {
                  var yt = an(Re);
                  te = ka(te);
                  function Ht() {
                  }
                  Ht.values = {}, vt(P, { name: te, constructor: Ht, fromWireType: function(rn) {
                    return this.constructor.values[rn];
                  }, toWireType: function(rn, tr) {
                    return tr.value;
                  }, argPackAdvance: 8, readValueFromPointer: ec(te, yt, Qe), destructorFunction: null }), sc(te, Ht);
                }
                function rd(P, te) {
                  var Re = xe[P];
                  return Re === void 0 && ct(te + " has unknown type " + ja(P)), Re;
                }
                function Lc(P, te, Re) {
                  var Qe = rd(P, "enum");
                  te = ka(te);
                  var yt = Qe.constructor, Ht = Object.create(Qe.constructor.prototype, { value: { value: Re }, constructor: { value: He(Qe.name + "_" + te, function() {
                  }) } });
                  yt.values[Re] = Ht, yt[te] = Ht;
                }
                function fu(P, te) {
                  switch (te) {
                    case 2:
                      return function(Re) {
                        return this.fromWireType(gl[Re >> 2]);
                      };
                    case 3:
                      return function(Re) {
                        return this.fromWireType(za[Re >> 3]);
                      };
                    default:
                      throw new TypeError("Unknown float type: " + P);
                  }
                }
                function El(P, te, Re) {
                  var Qe = an(Re);
                  te = ka(te), vt(P, { name: te, fromWireType: function(Ht) {
                    return Ht;
                  }, toWireType: function(Ht, zt) {
                    return zt;
                  }, argPackAdvance: 8, readValueFromPointer: fu(te, Qe), destructorFunction: null });
                }
                function xc(P, te, Re, Qe, yt) {
                  te = ka(te);
                  var Ht = an(Re), zt = (ai) => ai;
                  if (Qe === 0) {
                    var rn = 32 - 8 * Re;
                    zt = (ai) => ai << rn >>> rn;
                  }
                  var tr = te.includes("unsigned"), Vn = (ai, Ui) => {
                  }, si;
                  tr ? si = function(Ui, Sa) {
                    return Vn(Sa, this.name), Sa >>> 0;
                  } : si = function(Ui, Sa) {
                    return Vn(Sa, this.name), Sa;
                  }, vt(P, { name: te, fromWireType: zt, toWireType: si, argPackAdvance: 8, readValueFromPointer: gr(te, Ht, Qe !== 0), destructorFunction: null });
                }
                function _d(P, te, Re) {
                  var Qe = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array, BigInt64Array, BigUint64Array], yt = Qe[te];
                  function Ht(zt) {
                    zt = zt >> 2;
                    var rn = As, tr = rn[zt], Vn = rn[zt + 1];
                    return new yt(oi, Vn, tr);
                  }
                  Re = ka(Re), vt(P, { name: Re, fromWireType: Ht, argPackAdvance: 8, readValueFromPointer: Ht }, { ignoreDuplicateRegistrations: !0 });
                }
                function vo(P, te) {
                  te = ka(te);
                  var Re = te === "std::string";
                  vt(P, { name: te, fromWireType: function(yt) {
                    var Ht = As[yt >> 2], zt = yt + 4, rn;
                    if (Re)
                      for (var tr = zt, Vn = 0; Vn <= Ht; ++Vn) {
                        var si = zt + Vn;
                        if (Vn == Ht || Wa[si] == 0) {
                          var ai = si - tr, Ui = so(tr, ai);
                          rn === void 0 ? rn = Ui : (rn += "\0", rn += Ui), tr = si + 1;
                        }
                      }
                    else {
                      for (var Sa = new Array(Ht), Vn = 0; Vn < Ht; ++Vn)
                        Sa[Vn] = String.fromCharCode(Wa[zt + Vn]);
                      rn = Sa.join("");
                    }
                    return nt(yt), rn;
                  }, toWireType: function(yt, Ht) {
                    Ht instanceof ArrayBuffer && (Ht = new Uint8Array(Ht));
                    var zt, rn = typeof Ht == "string";
                    rn || Ht instanceof Uint8Array || Ht instanceof Uint8ClampedArray || Ht instanceof Int8Array || ct("Cannot pass non-string to std::string"), Re && rn ? zt = hs(Ht) : zt = Ht.length;
                    var tr = Ke(4 + zt + 1), Vn = tr + 4;
                    if (As[tr >> 2] = zt, Re && rn)
                      qa(Ht, Vn, zt + 1);
                    else if (rn)
                      for (var si = 0; si < zt; ++si) {
                        var ai = Ht.charCodeAt(si);
                        ai > 255 && (nt(Vn), ct("String has UTF-16 code units that do not fit in 8 bits")), Wa[Vn + si] = ai;
                      }
                    else
                      for (var si = 0; si < zt; ++si)
                        Wa[Vn + si] = Ht[si];
                    return yt !== null && yt.push(nt, tr), tr;
                  }, argPackAdvance: 8, readValueFromPointer: Cl, destructorFunction: function(yt) {
                    nt(yt);
                  } });
                }
                var co = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;
                function id(P, te) {
                  for (var Re = P, Qe = Re >> 1, yt = Qe + te / 2; !(Qe >= yt) && ya[Qe]; ) ++Qe;
                  if (Re = Qe << 1, Re - P > 32 && co) return co.decode(Wa.subarray(P, Re));
                  for (var Ht = "", zt = 0; !(zt >= te / 2); ++zt) {
                    var rn = Xa[P + zt * 2 >> 1];
                    if (rn == 0) break;
                    Ht += String.fromCharCode(rn);
                  }
                  return Ht;
                }
                function wd(P, te, Re) {
                  if (Re === void 0 && (Re = 2147483647), Re < 2) return 0;
                  Re -= 2;
                  for (var Qe = te, yt = Re < P.length * 2 ? Re / 2 : P.length, Ht = 0; Ht < yt; ++Ht) {
                    var zt = P.charCodeAt(Ht);
                    Xa[te >> 1] = zt, te += 2;
                  }
                  return Xa[te >> 1] = 0, te - Qe;
                }
                function Dd(P) {
                  return P.length * 2;
                }
                function su(P, te) {
                  for (var Re = 0, Qe = ""; !(Re >= te / 4); ) {
                    var yt = Fl[P + Re * 4 >> 2];
                    if (yt == 0) break;
                    if (++Re, yt >= 65536) {
                      var Ht = yt - 65536;
                      Qe += String.fromCharCode(55296 | Ht >> 10, 56320 | Ht & 1023);
                    } else
                      Qe += String.fromCharCode(yt);
                  }
                  return Qe;
                }
                function Md(P, te, Re) {
                  if (Re === void 0 && (Re = 2147483647), Re < 4) return 0;
                  for (var Qe = te, yt = Qe + Re - 4, Ht = 0; Ht < P.length; ++Ht) {
                    var zt = P.charCodeAt(Ht);
                    if (zt >= 55296 && zt <= 57343) {
                      var rn = P.charCodeAt(++Ht);
                      zt = 65536 + ((zt & 1023) << 10) | rn & 1023;
                    }
                    if (Fl[te >> 2] = zt, te += 4, te + 4 > yt) break;
                  }
                  return Fl[te >> 2] = 0, te - Qe;
                }
                function od(P) {
                  for (var te = 0, Re = 0; Re < P.length; ++Re) {
                    var Qe = P.charCodeAt(Re);
                    Qe >= 55296 && Qe <= 57343 && ++Re, te += 4;
                  }
                  return te;
                }
                function Je(P, te, Re) {
                  Re = ka(Re);
                  var Qe, yt, Ht, zt, rn;
                  te === 2 ? (Qe = id, yt = wd, zt = Dd, Ht = () => ya, rn = 1) : te === 4 && (Qe = su, yt = Md, zt = od, Ht = () => As, rn = 2), vt(P, { name: Re, fromWireType: function(Vn) {
                    for (var si = As[Vn >> 2], ai = Ht(), Ui, Sa = Vn + 4, xa = 0; xa <= si; ++xa) {
                      var ll = Vn + 4 + xa * te;
                      if (xa == si || ai[ll >> rn] == 0) {
                        var Hc = ll - Sa, Wc = Qe(Sa, Hc);
                        Ui === void 0 ? Ui = Wc : (Ui += "\0", Ui += Wc), Sa = ll + te;
                      }
                    }
                    return nt(Vn), Ui;
                  }, toWireType: function(Vn, si) {
                    typeof si != "string" && ct("Cannot pass non-string to C++ string type " + Re);
                    var ai = zt(si), Ui = Ke(4 + ai + te);
                    return As[Ui >> 2] = ai >> rn, yt(si, Ui + 4, ai + te), Vn !== null && Vn.push(nt, Ui), Ui;
                  }, argPackAdvance: 8, readValueFromPointer: Cl, destructorFunction: function(Vn) {
                    nt(Vn);
                  } });
                }
                function Ne(P, te) {
                  te = ka(te), vt(P, { isVoid: !0, name: te, argPackAdvance: 0, fromWireType: function() {
                  }, toWireType: function(Qe, yt) {
                  } });
                }
                function qr(P) {
                  P > 4 && (_s[P].refcount += 1);
                }
                function dc(P, te) {
                  P = rd(P, "_emval_take_value");
                  var Re = P.readValueFromPointer(te);
                  return Da.toHandle(Re);
                }
                function sl() {
                  _i("");
                }
                function Ta(P, te, Re) {
                  Wa.copyWithin(P, te, te + Re);
                }
                function $d(P) {
                  _i("OOM");
                }
                function Id(P) {
                  Wa.length, $d();
                }
                function $s(P) {
                  No = P, Xn() || (tt.onExit && tt.onExit(P), Ga = !0), Vt(P, new Rl(P));
                }
                function _a(P, te) {
                  No = P, $s(P);
                }
                gu(), ut = tt.BindingError = Xe(Error, "BindingError"), Xt = tt.InternalError = Xe(Error, "InternalError"), Dc(), Gd(), Za(), Uo = tt.UnboundTypeError = Xe(Error, "UnboundTypeError"), cc();
                var no = typeof atob == "function" ? atob : function(P) {
                  var te = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", Re = "", Qe, yt, Ht, zt, rn, tr, Vn, si = 0;
                  P = P.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                  do
                    zt = te.indexOf(P.charAt(si++)), rn = te.indexOf(P.charAt(si++)), tr = te.indexOf(P.charAt(si++)), Vn = te.indexOf(P.charAt(si++)), Qe = zt << 2 | rn >> 4, yt = (rn & 15) << 4 | tr >> 2, Ht = (tr & 3) << 6 | Vn, Re = Re + String.fromCharCode(Qe), tr !== 64 && (Re = Re + String.fromCharCode(yt)), Vn !== 64 && (Re = Re + String.fromCharCode(Ht));
                  while (si < P.length);
                  return Re;
                };
                function Bd(P) {
                  if (typeof gn == "boolean" && gn) {
                    var te = l.from(P, "base64");
                    return new Uint8Array(te.buffer, te.byteOffset, te.byteLength);
                  }
                  try {
                    for (var Re = no(P), Qe = new Uint8Array(Re.length), yt = 0; yt < Re.length; ++yt)
                      Qe[yt] = Re.charCodeAt(yt);
                    return Qe;
                  } catch {
                    throw new Error("Converting base64 string to bytes failed.");
                  }
                }
                function xl(P) {
                  if (ps(P))
                    return Bd(P.slice(Ko.length));
                }
                var Yd = { a: Zc, l: sr, s: En, u: td, o: au, e: lc, r: ea, g: Yc, f: Lc, k: El, c: xc, b: _d, j: vo, h: Je, t: Ne, m: da, n: qr, i: dc, d: sl, q: Ta, p: Id };
                zo(), tt.___wasm_call_ctors = function() {
                  return (tt.___wasm_call_ctors = tt.asm.w).apply(null, arguments);
                }, tt._main = function() {
                  return (tt._main = tt.asm.x).apply(null, arguments);
                };
                var nt = tt._free = function() {
                  return (nt = tt._free = tt.asm.z).apply(null, arguments);
                }, Ke = tt._malloc = function() {
                  return (Ke = tt._malloc = tt.asm.A).apply(null, arguments);
                }, et = tt.___getTypeName = function() {
                  return (et = tt.___getTypeName = tt.asm.B).apply(null, arguments);
                };
                tt.__embind_initialize_bindings = function() {
                  return (tt.__embind_initialize_bindings = tt.asm.C).apply(null, arguments);
                };
                var dt;
                vr = function P() {
                  dt || be(), dt || (vr = P);
                };
                function $t(P) {
                  var te = tt._main, Re = 0, Qe = 0;
                  try {
                    var yt = te(Re, Qe);
                    return _a(yt, !0), yt;
                  } catch (Ht) {
                    return $o(Ht);
                  }
                }
                function be(P) {
                  if (xn > 0 || (Kn(), xn > 0))
                    return;
                  function te() {
                    dt || (dt = !0, tt.calledRun = !0, !Ga && (pr(), hi(), Oe(tt), tt.onRuntimeInitialized && tt.onRuntimeInitialized(), ze && $t(), Qi()));
                  }
                  tt.setStatus ? (tt.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                      tt.setStatus("");
                    }, 1), te();
                  }, 1)) : te();
                }
                if (tt.preInit)
                  for (typeof tt.preInit == "function" && (tt.preInit = [tt.preInit]); tt.preInit.length > 0; )
                    tt.preInit.pop()();
                var ze = !0;
                return tt.noInitialRun && (ze = !1), be(), tt.ready;
              };
            })();
            function $n() {
              return rr.apply(this, arguments);
            }
            function rr() {
              return rr = (0, f.default)(/* @__PURE__ */ u.default.mark(function Rt() {
                return u.default.wrap(function(tt) {
                  for (; ; ) switch (tt.prev = tt.next) {
                    case 0:
                      return tt.abrupt("return", pi());
                    case 1:
                    case "end":
                      return tt.stop();
                  }
                }, Rt);
              })), rr.apply(this, arguments);
            }
            const Kr = /* @__PURE__ */ new WeakMap(), Bi = /* @__PURE__ */ new WeakMap(), Li = /* @__PURE__ */ new WeakMap(), xo = Symbol("anyProducer"), Yr = n.resolve(), Qo = Symbol("listenerAdded"), Wo = Symbol("listenerRemoved");
            let xi = !1, Fa = !1;
            function sn(Rt) {
              if (typeof Rt != "string" && typeof Rt != "symbol" && typeof Rt != "number")
                throw new TypeError("`eventName` must be a string, symbol, or number");
            }
            function Ct(Rt) {
              if (typeof Rt != "function")
                throw new TypeError("listener must be a function");
            }
            function cn(Rt, ln) {
              const tt = Bi.get(Rt);
              if (tt.has(ln))
                return tt.get(ln);
            }
            function Hn(Rt, ln) {
              const tt = typeof ln == "string" || typeof ln == "symbol" || typeof ln == "number" ? ln : xo, Oe = Li.get(Rt);
              if (Oe.has(tt))
                return Oe.get(tt);
            }
            function Sr(Rt, ln, tt) {
              const Oe = Li.get(Rt);
              if (Oe.has(ln))
                for (var Jt = v(Oe.get(ln)), St; !(St = Jt()).done; )
                  St.value.enqueue(tt);
              if (Oe.has(xo)) {
                const Qn = n.all([ln, tt]);
                for (var Vt = v(Oe.get(xo)), Et; !(Et = Vt()).done; )
                  Et.value.enqueue(Qn);
              }
            }
            function ao(Rt, ln) {
              ln = Array.isArray(ln) ? ln : [ln];
              let tt = !1, Oe = () => {
              }, Jt = [];
              const St = { enqueue(Qn) {
                Jt.push(Qn), Oe();
              }, finish() {
                tt = !0, Oe();
              } };
              for (var Vt = v(ln), Et; !(Et = Vt()).done; ) {
                const Qn = Et.value;
                let gn = Hn(Rt, Qn);
                gn || (gn = /* @__PURE__ */ new Set(), Li.get(Rt).set(Qn, gn)), gn.add(St);
              }
              return { next() {
                var Qn = this;
                return (0, f.default)(/* @__PURE__ */ u.default.mark(function gn() {
                  return u.default.wrap(function(On) {
                    for (; ; ) switch (On.prev = On.next) {
                      case 0:
                        if (Jt) {
                          On.next = 2;
                          break;
                        }
                        return On.abrupt("return", { done: !0 });
                      case 2:
                        if (Jt.length !== 0) {
                          On.next = 9;
                          break;
                        }
                        if (!tt) {
                          On.next = 6;
                          break;
                        }
                        return Jt = void 0, On.abrupt("return", Qn.next());
                      case 6:
                        return On.next = 8, new n((Ar) => {
                          Oe = Ar;
                        });
                      case 8:
                        return On.abrupt("return", Qn.next());
                      case 9:
                        return On.next = 11, Jt.shift();
                      case 11:
                        return On.t0 = On.sent, On.abrupt("return", { done: !1, value: On.t0 });
                      case 13:
                      case "end":
                        return On.stop();
                    }
                  }, gn);
                }))();
              }, return(Qn) {
                var gn = arguments;
                return (0, f.default)(/* @__PURE__ */ u.default.mark(function jt() {
                  var On, Ar, ui, fr, Jn;
                  return u.default.wrap(function(ti) {
                    for (; ; ) switch (ti.prev = ti.next) {
                      case 0:
                        for (Jt = void 0, On = v(ln); !(Ar = On()).done; )
                          ui = Ar.value, fr = Hn(Rt, ui), fr && (fr.delete(St), fr.size === 0 && (Jn = Li.get(Rt), Jn.delete(ui)));
                        if (Oe(), !(gn.length > 0)) {
                          ti.next = 10;
                          break;
                        }
                        return ti.next = 6, Qn;
                      case 6:
                        ti.t1 = ti.sent, ti.t0 = { done: !0, value: ti.t1 }, ti.next = 11;
                        break;
                      case 10:
                        ti.t0 = { done: !0 };
                      case 11:
                        return ti.abrupt("return", ti.t0);
                      case 12:
                      case "end":
                        return ti.stop();
                    }
                  }, jt);
                }))();
              }, [Symbol.asyncIterator]() {
                return this;
              } };
            }
            function wr(Rt) {
              if (Rt === void 0)
                return wt;
              if (!Array.isArray(Rt))
                throw new TypeError("`methodNames` must be an array of strings");
              for (var ln = v(Rt), tt; !(tt = ln()).done; ) {
                const Oe = tt.value;
                if (!wt.includes(Oe))
                  throw typeof Oe != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${Oe} is not Emittery method`);
              }
              return Rt;
            }
            const Jr = (Rt) => Rt === Qo || Rt === Wo;
            function Fn(Rt, ln, tt) {
              if (Jr(ln))
                try {
                  xi = !0, Rt.emit(ln, tt);
                } finally {
                  xi = !1;
                }
            }
            let Ia = /* @__PURE__ */ function() {
              Rt.mixin = function(Oe, Jt) {
                return Jt = wr(Jt), (St) => {
                  if (typeof St != "function")
                    throw new TypeError("`target` must be function");
                  for (var Vt = v(Jt), Et; !(Et = Vt()).done; ) {
                    const Ar = Et.value;
                    if (St.prototype[Ar] !== void 0)
                      throw new Error(`The property \`${Ar}\` already exists on \`target\``);
                  }
                  function Qn() {
                    return Object.defineProperty(this, Oe, { enumerable: !1, value: new Rt() }), this[Oe];
                  }
                  Object.defineProperty(St.prototype, Oe, { enumerable: !1, get: Qn });
                  const gn = (Ar) => function() {
                    return this[Oe][Ar](...arguments);
                  };
                  for (var jt = v(Jt), On; !(On = jt()).done; ) {
                    const Ar = On.value;
                    Object.defineProperty(St.prototype, Ar, { enumerable: !1, value: gn(Ar) });
                  }
                  return St;
                };
              };
              function Rt(tt) {
                var Oe;
                tt === void 0 && (tt = {}), Kr.set(this, /* @__PURE__ */ new Set()), Bi.set(this, /* @__PURE__ */ new Map()), Li.set(this, /* @__PURE__ */ new Map()), Li.get(this).set(xo, /* @__PURE__ */ new Set()), this.debug = (Oe = tt.debug) != null ? Oe : {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (Jt, St, Vt, Et) => {
                  try {
                    Et = JSON.stringify(Et);
                  } catch {
                    Et = `Object with the following keys failed to stringify: ${Object.keys(Et).join(",")}`;
                  }
                  (typeof Vt == "symbol" || typeof Vt == "number") && (Vt = Vt.toString());
                  const Qn = /* @__PURE__ */ new Date(), gn = `${Qn.getHours()}:${Qn.getMinutes()}:${Qn.getSeconds()}.${Qn.getMilliseconds()}`;
                  console.log(`[${gn}][emittery:${Jt}][${St}] Event Name: ${Vt}
	data: ${Et}`);
                });
              }
              var ln = Rt.prototype;
              return ln.logIfDebugEnabled = function(Oe, Jt, St) {
                (Rt.isDebugEnabled || this.debug.enabled) && this.debug.logger(Oe, this.debug.name, Jt, St);
              }, ln.on = function(Oe, Jt) {
                Ct(Jt), Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var St = v(Oe), Vt; !(Vt = St()).done; ) {
                  const Et = Vt.value;
                  sn(Et);
                  let Qn = cn(this, Et);
                  Qn || (Qn = /* @__PURE__ */ new Set(), Bi.get(this).set(Et, Qn)), Qn.add(Jt), this.logIfDebugEnabled("subscribe", Et, void 0), Jr(Et) || Fn(this, Qo, { eventName: Et, listener: Jt });
                }
                return this.off.bind(this, Oe, Jt);
              }, ln.off = function(Oe, Jt) {
                Ct(Jt), Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var St = v(Oe), Vt; !(Vt = St()).done; ) {
                  const Et = Vt.value;
                  sn(Et);
                  const Qn = cn(this, Et);
                  Qn && (Qn.delete(Jt), Qn.size === 0 && Bi.get(this).delete(Et)), this.logIfDebugEnabled("unsubscribe", Et, void 0), Jr(Et) || Fn(this, Wo, { eventName: Et, listener: Jt });
                }
              }, ln.once = function(Oe) {
                let Jt;
                const St = new n((Vt) => {
                  Jt = this.on(Oe, (Et) => {
                    Jt(), Vt(Et);
                  });
                });
                return St.off = Jt, St;
              }, ln.events = function(Oe) {
                Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var Jt = v(Oe), St; !(St = Jt()).done; ) {
                  const Vt = St.value;
                  sn(Vt);
                }
                return ao(this, Oe);
              }, ln.emit = /* @__PURE__ */ function() {
                var tt = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jt(St, Vt) {
                  var Et, Qn, gn, jt, On;
                  return u.default.wrap(function(ui) {
                    for (; ; ) switch (ui.prev = ui.next) {
                      case 0:
                        if (sn(St), !(Jr(St) && !xi)) {
                          ui.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emit", St, Vt), Sr(this, St, Vt), Qn = (Et = cn(this, St)) != null ? Et : /* @__PURE__ */ new Set(), gn = Kr.get(this), jt = [...Qn], On = Jr(St) ? [] : [...gn], ui.next = 11, Yr;
                      case 11:
                        return ui.next = 13, n.all([...jt.map(/* @__PURE__ */ function() {
                          var fr = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jn(Qr) {
                            return u.default.wrap(function(Wn) {
                              for (; ; ) switch (Wn.prev = Wn.next) {
                                case 0:
                                  if (!Qn.has(Qr)) {
                                    Wn.next = 2;
                                    break;
                                  }
                                  return Wn.abrupt("return", Qr(Vt));
                                case 2:
                                case "end":
                                  return Wn.stop();
                              }
                            }, Jn);
                          }));
                          return function(Jn) {
                            return fr.apply(this, arguments);
                          };
                        }()), ...On.map(/* @__PURE__ */ function() {
                          var fr = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jn(Qr) {
                            return u.default.wrap(function(Wn) {
                              for (; ; ) switch (Wn.prev = Wn.next) {
                                case 0:
                                  if (!gn.has(Qr)) {
                                    Wn.next = 2;
                                    break;
                                  }
                                  return Wn.abrupt("return", Qr(St, Vt));
                                case 2:
                                case "end":
                                  return Wn.stop();
                              }
                            }, Jn);
                          }));
                          return function(Jn) {
                            return fr.apply(this, arguments);
                          };
                        }())]);
                      case 13:
                      case "end":
                        return ui.stop();
                    }
                  }, Jt, this);
                }));
                function Oe(Jt, St) {
                  return tt.apply(this, arguments);
                }
                return Oe;
              }(), ln.emitSerial = /* @__PURE__ */ function() {
                var tt = (0, f.default)(/* @__PURE__ */ u.default.mark(function Jt(St, Vt) {
                  var Et, Qn, gn, jt, On, Ar, ui, fr, Jn, Qr;
                  return u.default.wrap(function(Wn) {
                    for (; ; ) switch (Wn.prev = Wn.next) {
                      case 0:
                        if (sn(St), !(Jr(St) && !xi)) {
                          Wn.next = 3;
                          break;
                        }
                        throw new TypeError("`eventName` cannot be meta event `listenerAdded` or `listenerRemoved`");
                      case 3:
                        return this.logIfDebugEnabled("emitSerial", St, Vt), Qn = (Et = cn(this, St)) != null ? Et : /* @__PURE__ */ new Set(), gn = Kr.get(this), jt = [...Qn], On = [...gn], Wn.next = 10, Yr;
                      case 10:
                        Ar = 0, ui = jt;
                      case 11:
                        if (!(Ar < ui.length)) {
                          Wn.next = 19;
                          break;
                        }
                        if (fr = ui[Ar], !Qn.has(fr)) {
                          Wn.next = 16;
                          break;
                        }
                        return Wn.next = 16, fr(Vt);
                      case 16:
                        Ar++, Wn.next = 11;
                        break;
                      case 19:
                        Jn = 0, Qr = On;
                      case 20:
                        if (!(Jn < Qr.length)) {
                          Wn.next = 28;
                          break;
                        }
                        if (fr = Qr[Jn], !gn.has(fr)) {
                          Wn.next = 25;
                          break;
                        }
                        return Wn.next = 25, fr(St, Vt);
                      case 25:
                        Jn++, Wn.next = 20;
                        break;
                      case 28:
                      case "end":
                        return Wn.stop();
                    }
                  }, Jt, this);
                }));
                function Oe(Jt, St) {
                  return tt.apply(this, arguments);
                }
                return Oe;
              }(), ln.onAny = function(Oe) {
                return Ct(Oe), this.logIfDebugEnabled("subscribeAny", void 0, void 0), Kr.get(this).add(Oe), Fn(this, Qo, { listener: Oe }), this.offAny.bind(this, Oe);
              }, ln.anyEvent = function() {
                return ao(this);
              }, ln.offAny = function(Oe) {
                Ct(Oe), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), Fn(this, Wo, { listener: Oe }), Kr.get(this).delete(Oe);
              }, ln.clearListeners = function(Oe) {
                Oe = Array.isArray(Oe) ? Oe : [Oe];
                for (var Jt = v(Oe), St; !(St = Jt()).done; ) {
                  const fr = St.value;
                  if (this.logIfDebugEnabled("clear", fr, void 0), typeof fr == "string" || typeof fr == "symbol" || typeof fr == "number") {
                    const Jn = cn(this, fr);
                    Jn && Jn.clear();
                    const Qr = Hn(this, fr);
                    if (Qr) {
                      for (var Vt = v(Qr), Et; !(Et = Vt()).done; )
                        Et.value.finish();
                      Qr.clear();
                    }
                  } else {
                    Kr.get(this).clear();
                    for (var Qn = v(Bi.get(this).entries()), gn; !(gn = Qn()).done; ) {
                      const Jn = gn.value, Qr = Jn[0];
                      Jn[1].clear(), Bi.get(this).delete(Qr);
                    }
                    for (var jt = v(Li.get(this).entries()), On; !(On = jt()).done; ) {
                      const Jn = On.value, Qr = Jn[0], ti = Jn[1];
                      for (var Ar = v(ti), ui; !(ui = Ar()).done; )
                        ui.value.finish();
                      ti.clear(), Li.get(this).delete(Qr);
                    }
                  }
                }
              }, ln.listenerCount = function(Oe) {
                Oe = Array.isArray(Oe) ? Oe : [Oe];
                let Jt = 0;
                for (var St = v(Oe), Vt; !(Vt = St()).done; ) {
                  const ti = Vt.value;
                  if (typeof ti == "string") {
                    var Et, Qn, gn, jt, On, Ar;
                    Jt += Kr.get(this).size + ((Et = (Qn = cn(this, ti)) == null ? void 0 : Qn.size) != null ? Et : 0) + ((gn = (jt = Hn(this, ti)) == null ? void 0 : jt.size) != null ? gn : 0) + ((On = (Ar = Hn(this)) == null ? void 0 : Ar.size) != null ? On : 0);
                    continue;
                  }
                  typeof ti != "undefined" && sn(ti), Jt += Kr.get(this).size;
                  for (var ui = v(Bi.get(this).values()), fr; !(fr = ui()).done; ) {
                    const Wn = fr.value;
                    Jt += Wn.size;
                  }
                  for (var Jn = v(Li.get(this).values()), Qr; !(Qr = Jn()).done; ) {
                    const Wn = Qr.value;
                    Jt += Wn.size;
                  }
                }
                return Jt;
              }, ln.bindMethods = function(Oe, Jt) {
                if (typeof Oe != "object" || Oe === null)
                  throw new TypeError("`target` must be an object");
                Jt = wr(Jt);
                for (var St = v(Jt), Vt; !(Vt = St()).done; ) {
                  const Et = Vt.value;
                  if (Oe[Et] !== void 0)
                    throw new Error(`The property \`${Et}\` already exists on \`target\``);
                  Object.defineProperty(Oe, Et, { enumerable: !1, value: this[Et].bind(this) });
                }
              }, (0, g.default)(Rt, null, [{ key: "isDebugEnabled", get: function() {
                var Oe, Jt;
                if (typeof ((Oe = p.process) == null ? void 0 : Oe.env) != "object")
                  return Fa;
                const St = (Jt = p.process) != null ? Jt : { env: {} }, Vt = St.env;
                return Vt.DEBUG === "emittery" || Vt.DEBUG === "*" || Fa;
              }, set: function(Oe) {
                Fa = Oe;
              } }]), Rt;
            }();
            const wt = Object.getOwnPropertyNames(Ia.prototype).filter((Rt) => Rt !== "constructor");
            Object.defineProperty(Ia, "listenerAdded", { value: Qo, writable: !1, enumerable: !0, configurable: !1 }), Object.defineProperty(Ia, "listenerRemoved", { value: Wo, writable: !1, enumerable: !0, configurable: !1 });
            const Yn = /* @__PURE__ */ function(Rt) {
              (0, A.default)(ln, Rt);
              function ln() {
                var Oe;
                return Oe = Rt.apply(this, arguments) || this, Oe.isDecryptionEnabled = !0, Oe.payloadTypes = {}, Oe.isOnSuccessEnabled = !1, Oe;
              }
              var tt = ln.prototype;
              return tt.init = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St() {
                  return u.default.wrap(function(Et) {
                    for (; ; ) switch (Et.prev = Et.next) {
                      case 0:
                        return Et.prev = 0, Et.next = 3, $n();
                      case 3:
                        this.instance = Et.sent, this.encryptor = new this.instance.SFrameEngine(this.instance.EngineType.ENCRYPTOR, this.instance.CipherSuite.AES_CTR_128_HMAC_SHA256_80), this.decryptor = new this.instance.SFrameEngine(this.instance.EngineType.DECRYPTOR, this.instance.CipherSuite.AES_CTR_128_HMAC_SHA256_80), self.addEventListener("rtctransform", (Qn) => {
                          console.log("rtctransform", Qn);
                          const gn = Qn.transformer, jt = gn.options, On = jt.type, Ar = jt.id, ui = gn.readable, fr = gn.writable;
                          switch (On) {
                            case "encrypt":
                              this.encrypt(Ar, ui, fr);
                              break;
                            case "decrypt":
                              this.decrypt(Ar, ui, fr);
                              break;
                          }
                        }), Et.next = 12;
                        break;
                      case 9:
                        Et.prev = 9, Et.t0 = Et.catch(0), console.error("INIT ERRROR", Et.t0);
                      case 12:
                      case "end":
                        return Et.stop();
                    }
                  }, St, this, [[0, 9]]);
                }));
                function Jt() {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.setEnableOnSuccess = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  return u.default.wrap(function(Qn) {
                    for (; ; ) switch (Qn.prev = Qn.next) {
                      case 0:
                        this.isOnSuccessEnabled = Vt;
                      case 1:
                      case "end":
                        return Qn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.enableDecryption = function() {
                this.isDecryptionEnabled = !0;
              }, tt.disableDecryption = function() {
                this.isDecryptionEnabled = !1;
              }, tt.setKey = function(Jt) {
                if (!this.encryptor || !this.decryptor)
                  throw console.error("Engine must be initialized"), "Engine must be initialized";
                this.updateEngineKey(this.encryptor, Jt), this.updateEngineKey(this.decryptor, Jt);
              }, tt.addPayloadTypes = function(Jt) {
                this.payloadTypes = Object.assign({}, this.payloadTypes, Jt);
              }, tt.removeKey = function(Jt) {
                if (!this.encryptor || !this.decryptor)
                  throw console.error("Engine must be initialized"), "Engine must be initialized";
                this.encryptor.removeBaseKey(BigInt(Jt)), this.decryptor.removeBaseKey(BigInt(Jt));
              }, tt.encrypt = function(Jt, St, Vt) {
                this.transformStream(St, Vt, (Et) => {
                  if (!this.encryptor)
                    throw console.error("Engine must be initialized"), "Engine must be initialized";
                  this.processFrame(this.encryptor, Jt, Et);
                });
              }, tt.decrypt = function(Jt, St, Vt) {
                this.transformStream(St, Vt, (Et) => {
                  if (!this.decryptor)
                    throw console.error("Engine must be initialized"), "Engine must be initialized";
                  this.isDecryptionEnabled && this.processFrame(this.decryptor, Jt, Et);
                });
              }, tt.setCodecs = function(Jt, St) {
                this.audioCodec = Jt, this.videoCodec = St;
              }, tt.transformStream = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et, Qn) {
                  var gn, jt, On, Ar;
                  return u.default.wrap(function(fr) {
                    for (; ; ) switch (fr.prev = fr.next) {
                      case 0:
                        gn = Vt.getReader(), jt = Et.getWriter();
                      case 2:
                        return fr.prev = 3, fr.next = 6, gn.read();
                      case 6:
                        return On = fr.sent, Ar = On.value, Qn(Ar), fr.next = 11, jt.ready;
                      case 11:
                        return fr.next = 13, jt.write(Ar);
                      case 13:
                        fr.next = 18;
                        break;
                      case 15:
                        fr.prev = 15, fr.t0 = fr.catch(3), console.log("ERROR", fr.t0);
                      case 18:
                        fr.next = 2;
                        break;
                      case 20:
                      case "end":
                        return fr.stop();
                    }
                  }, St, null, [[3, 15]]);
                }));
                function Jt(St, Vt, Et) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.updateEngineKey = function(Jt, St) {
                const Vt = Jt.getKeyBuffer(St.key.length);
                let Et = St.key;
                typeof Et == "string" && (Et = Uint8Array.from(Et.split("").map((Qn) => Qn.charCodeAt(0)))), Vt.set(Et), Jt.addOrUpdateBaseKey(BigInt(St.kid));
              }, tt.processFrame = function(Jt, St, Vt) {
                var Et, Qn, gn;
                if (Vt.data.byteLength === 0) {
                  this.emit("emptyFrame", { message: `EMPTY ${Vt instanceof RTCEncodedAudioFrame ? "AUDIO" : "VIDEO"} FRAME` });
                  return;
                }
                if (!this.instance)
                  throw console.error("Engine must be initialized"), "Not initialized";
                let jt;
                if (this.audioCodec !== void 0 && Vt instanceof RTCEncodedAudioFrame)
                  jt = this.audioCodec;
                else if (this.videoCodec !== void 0 && Vt instanceof RTCEncodedVideoFrame)
                  jt = this.videoCodec;
                else {
                  const fr = Vt.getMetadata();
                  jt = this.payloadTypes[fr.payloadType];
                }
                switch (jt) {
                  case y.VP8:
                    Jt.setSkipOffset((Et = this.instance) == null ? void 0 : Et.SkipOffset.VP8);
                    break;
                  case y.H264:
                    Jt.setSkipOffset((Qn = this.instance) == null ? void 0 : Qn.SkipOffset.H264);
                    break;
                  case y.OPUS:
                    Jt.setSkipOffset((gn = this.instance) == null ? void 0 : gn.SkipOffset.OPUS);
                    break;
                  default:
                    this.emit("warning", { message: "Unknown codec" });
                    break;
                }
                const On = new Uint8Array(Vt.data), Ar = this.runEngineAlgorithm(Jt, St, On), ui = Jt.getStatus();
                if (ui === this.instance.Status.OK && Ar.byteLength > 0)
                  Vt.data = new ArrayBuffer(Ar.byteLength), new Uint8Array(Vt.data).set(Ar), this.isOnSuccessEnabled && this.emit("success", {});
                else
                  switch (ui) {
                    case this.instance.Status.FAILED_TO_AUTHENTICATE:
                      this.emit("error", { message: "ERROR: FAILED_TO_AUTHENTICATE" });
                      break;
                    case this.instance.Status.FAILED_TO_DECRYPT:
                      this.emit("error", { message: "ERROR: FAILED_TO_DECRYPT" });
                      break;
                    case this.instance.Status.FAILED_TO_ENCRYPT:
                      this.emit("error", { message: "ERROR: FAILED_TO_ENCRYPT" });
                      break;
                    case this.instance.Status.FAIL_PARSE_CODEC_HEADER:
                      this.emit("error", { message: "ERROR: FAIL_PARSE_CODEC_HEADER" });
                      break;
                    case this.instance.Status.NULL_INPUT_FRAME:
                      this.emit("error", { message: "ERROR: NULL_INPUT_FRAME" });
                      break;
                    case this.instance.Status.NULL_OUTPUT_FRAME:
                      this.emit("error", { message: "ERROR: NULL_OUTPUT_FRAME" });
                      break;
                    case this.instance.Status.UNKNOWN:
                      this.emit("error", { message: "ERROR: UNKNOWN" });
                      break;
                    case this.instance.Status.OK:
                      this.emit("error", { message: "ERROR: EMPTY OUTPUT" });
                      break;
                  }
              }, tt.runEngineAlgorithm = function(Jt, St, Vt) {
                try {
                  Jt.getInputFrame(Vt.length).set(Vt);
                  const Qn = Jt.runAlgorithm(BigInt(St));
                  return Jt.getOutputFrame().slice(0, Qn);
                } catch (Et) {
                  return console.log("FAIL", Vt.length, Et), new Uint8Array([]);
                }
              }, ln;
            }(Ia);
            vn("encryption-engine", Yn);
            let kr = Yn;
            const mr = "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", yi = typeof window != "undefined" && window.Blob && new Blob([atob(mr)], { type: "text/javascript;charset=utf-8" });
            function Or() {
              let Rt;
              try {
                if (Rt = yi && (window.URL || window.webkitURL).createObjectURL(yi), !Rt) throw "";
                return new Worker(Rt);
              } catch {
                return new Worker("data:application/javascript;base64," + mr);
              } finally {
                Rt && (window.URL || window.webkitURL).revokeObjectURL(Rt);
              }
            }
            let Ei = /* @__PURE__ */ function(Rt) {
              (0, A.default)(ln, Rt);
              function ln(Oe, Jt) {
                var St;
                return Oe === void 0 && (Oe = 0), St = Rt.call(this) || this, St.senderId = Oe, St.config = Jt, St;
              }
              var tt = ln.prototype;
              return tt.init = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St() {
                  return u.default.wrap(function(Et) {
                    for (; ; ) switch (Et.prev = Et.next) {
                      case 0:
                        return Et.next = 2, At(kr, Or);
                      case 2:
                        return this.worker = Et.sent, Et.next = 5, this.worker.init();
                      case 5:
                        this.worker.onAny((Qn, gn) => {
                          const jt = new Event(Qn);
                          jt.id = gn.id, jt.senderId = gn.senderId, this.dispatchEvent(jt);
                        });
                      case 6:
                      case "end":
                        return Et.stop();
                    }
                  }, St, this);
                }));
                function Jt() {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), ln.create = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et) {
                  var Qn;
                  return u.default.wrap(function(jt) {
                    for (; ; ) switch (jt.prev = jt.next) {
                      case 0:
                        return Et === void 0 && (Et = {}), Qn = new ln(Vt, Et), jt.next = 4, Qn.init();
                      case 4:
                        return jt.abrupt("return", Qn);
                      case 5:
                      case "end":
                        return jt.stop();
                    }
                  }, St);
                }));
                function Jt(St, Vt) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.setEnableDecryption = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  var Et, Qn;
                  return u.default.wrap(function(jt) {
                    for (; ; ) switch (jt.prev = jt.next) {
                      case 0:
                        if (!Vt) {
                          jt.next = 5;
                          break;
                        }
                        return jt.next = 3, (Et = this.worker) == null ? void 0 : Et.enableDecryption();
                      case 3:
                        jt.next = 7;
                        break;
                      case 5:
                        return jt.next = 7, (Qn = this.worker) == null ? void 0 : Qn.disableDecryption();
                      case 7:
                      case "end":
                        return jt.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.setEnableOnSuccess = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  var Et;
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        return gn.next = 2, (Et = this.worker) == null ? void 0 : Et.setEnableOnSuccess(Vt);
                      case 2:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.setSenderEncryptionKey = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  var Et;
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        return gn.next = 2, (Et = this.worker) == null ? void 0 : Et.setKey({ kid: this.senderId, key: Vt });
                      case 2:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.addReceiver = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  var Et;
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        return gn.next = 2, (Et = this.worker) == null ? void 0 : Et.setKey({ kid: Vt, key: "" });
                      case 2:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.setReceiverEncryptionKey = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et) {
                  var Qn;
                  return u.default.wrap(function(jt) {
                    for (; ; ) switch (jt.prev = jt.next) {
                      case 0:
                        return jt.next = 2, (Qn = this.worker) == null ? void 0 : Qn.setKey({ kid: Vt, key: Et });
                      case 2:
                      case "end":
                        return jt.stop();
                    }
                  }, St, this);
                }));
                function Jt(St, Vt) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.deleteReceiver = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  var Et;
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        return gn.next = 2, (Et = this.worker) == null ? void 0 : Et.removeKey(Vt);
                      case 2:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.encrypt = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et) {
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        return gn.abrupt("return", this.createPipeline(Vt, Et, "encrypt"));
                      case 1:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St, Vt) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.decrypt = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et) {
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        return gn.abrupt("return", this.createPipeline(Vt, Et, "decrypt"));
                      case 1:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St, Vt) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.createPipeline = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et, Qn) {
                  var gn, jt, On, Ar, ui, fr;
                  return u.default.wrap(function(Qr) {
                    for (; ; ) switch (Qr.prev = Qr.next) {
                      case 0:
                        if (!Et.createEncodedStreams) {
                          Qr.next = 15;
                          break;
                        }
                        return Qr.next = 3, this.updateWorkerWithParameters(Et.getParameters());
                      case 3:
                        return Qr.prev = 3, jt = Et.createEncodedStreams(), On = jt.readable, Ar = jt.writable, Qr.next = 7, (gn = this.worker) == null ? void 0 : gn[Qn](Vt, On, Ar);
                      case 7:
                        Qr.next = 13;
                        break;
                      case 9:
                        throw Qr.prev = 9, Qr.t0 = Qr.catch(3), console.error("Fail to retrieve streams", Qr.t0), Qr.t0;
                      case 13:
                        Qr.next = 21;
                        break;
                      case 15:
                        if (!window.RTCRtpScriptTransform) {
                          Qr.next = 20;
                          break;
                        }
                        fr = (ui = this.worker) == null ? void 0 : ui.workerContext.worker, Et.transform = new window.RTCRtpScriptTransform(fr, { type: Qn, id: Vt }), Qr.next = 21;
                        break;
                      case 20:
                        throw "Unsupported stream processing";
                      case 21:
                      case "end":
                        return Qr.stop();
                    }
                  }, St, this, [[3, 9]]);
                }));
                function Jt(St, Vt, Et) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.close = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St() {
                  var Vt;
                  return u.default.wrap(function(Qn) {
                    for (; ; ) switch (Qn.prev = Qn.next) {
                      case 0:
                        return Qn.next = 2, (Vt = this.worker) == null ? void 0 : Vt.terminate();
                      case 2:
                      case "end":
                        return Qn.stop();
                    }
                  }, St, this);
                }));
                function Jt() {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.setCodecs = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt, Et) {
                  var Qn;
                  return u.default.wrap(function(jt) {
                    for (; ; ) switch (jt.prev = jt.next) {
                      case 0:
                        return jt.next = 2, (Qn = this.worker) == null ? void 0 : Qn.setCodecs(Vt, Et);
                      case 2:
                      case "end":
                        return jt.stop();
                    }
                  }, St, this);
                }));
                function Jt(St, Vt) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.updateWorkerWithParameters = /* @__PURE__ */ function() {
                var Oe = (0, f.default)(/* @__PURE__ */ u.default.mark(function St(Vt) {
                  var Et;
                  return u.default.wrap(function(gn) {
                    for (; ; ) switch (gn.prev = gn.next) {
                      case 0:
                        if (this.worker) {
                          gn.next = 2;
                          break;
                        }
                        throw "Client not initialized, missing worker";
                      case 2:
                        if (Vt.codecs.length !== 0) {
                          gn.next = 4;
                          break;
                        }
                        throw "Empty codecs list, ensure your connection are in a proper state";
                      case 4:
                        return Et = this.getPayloadTypesFromCodecs(Vt.codecs), gn.next = 7, this.worker.addPayloadTypes(Et);
                      case 7:
                      case "end":
                        return gn.stop();
                    }
                  }, St, this);
                }));
                function Jt(St) {
                  return Oe.apply(this, arguments);
                }
                return Jt;
              }(), tt.getPayloadTypesFromCodecs = function(Jt) {
                const St = {};
                for (var Vt = v(Jt), Et; !(Et = Vt()).done; ) {
                  const Qn = Et.value, gn = Qn.mimeType.toLowerCase();
                  gn.includes("vp8") ? St[Qn.payloadType] = y.VP8 : gn.includes("h264") ? St[Qn.payloadType] = y.H264 : gn.includes("opus") && (St[Qn.payloadType] = y.OPUS);
                }
                return St;
              }, ln;
            }(/* @__PURE__ */ (0, h.default)(EventTarget));
            r.Client = Ei;
          }).call(this, e(2), e(27), "/", e(785).Buffer);
        },
        /* 785 */
        /***/
        function(i, r, e) {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <http://feross.org>
           * @license  MIT
           */
          var n = e(786), t = e(787), o = e(788);
          r.Buffer = u, r.SlowBuffer = U, r.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = (typeof window !== void 0 ? window : Dn).TYPED_ARRAY_SUPPORT !== void 0 ? (typeof window !== void 0 ? window : Dn).TYPED_ARRAY_SUPPORT : l(), r.kMaxLength = c();
          function l() {
            try {
              var Ue = new Uint8Array(1);
              return Ue.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                return 42;
              } }, Ue.foo() === 42 && // typed array instances can be augmented
              typeof Ue.subarray == "function" && // chrome 9-10 lack `subarray`
              Ue.subarray(1, 1).byteLength === 0;
            } catch {
              return !1;
            }
          }
          function c() {
            return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }
          function d(Ue, ne) {
            if (c() < ne)
              throw new RangeError("Invalid typed array length");
            return u.TYPED_ARRAY_SUPPORT ? (Ue = new Uint8Array(ne), Ue.__proto__ = u.prototype) : (Ue === null && (Ue = new u(ne)), Ue.length = ne), Ue;
          }
          function u(Ue, ne, se) {
            if (!u.TYPED_ARRAY_SUPPORT && !(this instanceof u))
              return new u(Ue, ne, se);
            if (typeof Ue == "number") {
              if (typeof ne == "string")
                throw new Error(
                  "If encoding is specified then the first argument must be a string"
                );
              return f(this, Ue);
            }
            return h(this, Ue, ne, se);
          }
          u.poolSize = 8192, u._augment = function(Ue) {
            return Ue.__proto__ = u.prototype, Ue;
          };
          function h(Ue, ne, se, Ce) {
            if (typeof ne == "number")
              throw new TypeError('"value" argument must not be a number');
            return typeof ArrayBuffer != "undefined" && ne instanceof ArrayBuffer ? b(Ue, ne, se, Ce) : typeof ne == "string" ? p(Ue, ne, se) : m(Ue, ne);
          }
          u.from = function(Ue, ne, se) {
            return h(null, Ue, ne, se);
          }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, typeof Symbol != "undefined" && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
            value: null,
            configurable: !0
          }));
          function A(Ue) {
            if (typeof Ue != "number")
              throw new TypeError('"size" argument must be a number');
            if (Ue < 0)
              throw new RangeError('"size" argument must not be negative');
          }
          function g(Ue, ne, se, Ce) {
            return A(ne), ne <= 0 ? d(Ue, ne) : se !== void 0 ? typeof Ce == "string" ? d(Ue, ne).fill(se, Ce) : d(Ue, ne).fill(se) : d(Ue, ne);
          }
          u.alloc = function(Ue, ne, se) {
            return g(null, Ue, ne, se);
          };
          function f(Ue, ne) {
            if (A(ne), Ue = d(Ue, ne < 0 ? 0 : y(ne) | 0), !u.TYPED_ARRAY_SUPPORT)
              for (var se = 0; se < ne; ++se)
                Ue[se] = 0;
            return Ue;
          }
          u.allocUnsafe = function(Ue) {
            return f(null, Ue);
          }, u.allocUnsafeSlow = function(Ue) {
            return f(null, Ue);
          };
          function p(Ue, ne, se) {
            if ((typeof se != "string" || se === "") && (se = "utf8"), !u.isEncoding(se))
              throw new TypeError('"encoding" must be a valid string encoding');
            var Ce = B(ne, se) | 0;
            Ue = d(Ue, Ce);
            var At = Ue.write(ne, se);
            return At !== Ce && (Ue = Ue.slice(0, At)), Ue;
          }
          function v(Ue, ne) {
            var se = ne.length < 0 ? 0 : y(ne.length) | 0;
            Ue = d(Ue, se);
            for (var Ce = 0; Ce < se; Ce += 1)
              Ue[Ce] = ne[Ce] & 255;
            return Ue;
          }
          function b(Ue, ne, se, Ce) {
            if (ne.byteLength, se < 0 || ne.byteLength < se)
              throw new RangeError("'offset' is out of bounds");
            if (ne.byteLength < se + (Ce || 0))
              throw new RangeError("'length' is out of bounds");
            return se === void 0 && Ce === void 0 ? ne = new Uint8Array(ne) : Ce === void 0 ? ne = new Uint8Array(ne, se) : ne = new Uint8Array(ne, se, Ce), u.TYPED_ARRAY_SUPPORT ? (Ue = ne, Ue.__proto__ = u.prototype) : Ue = v(Ue, ne), Ue;
          }
          function m(Ue, ne) {
            if (u.isBuffer(ne)) {
              var se = y(ne.length) | 0;
              return Ue = d(Ue, se), Ue.length === 0 || ne.copy(Ue, 0, 0, se), Ue;
            }
            if (ne) {
              if (typeof ArrayBuffer != "undefined" && ne.buffer instanceof ArrayBuffer || "length" in ne)
                return typeof ne.length != "number" || An(ne.length) ? d(Ue, 0) : v(Ue, ne);
              if (ne.type === "Buffer" && o(ne.data))
                return v(Ue, ne.data);
            }
            throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
          }
          function y(Ue) {
            if (Ue >= c())
              throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + c().toString(16) + " bytes");
            return Ue | 0;
          }
          function U(Ue) {
            return +Ue != Ue && (Ue = 0), u.alloc(+Ue);
          }
          u.isBuffer = function(ne) {
            return !!(ne != null && ne._isBuffer);
          }, u.compare = function(ne, se) {
            if (!u.isBuffer(ne) || !u.isBuffer(se))
              throw new TypeError("Arguments must be Buffers");
            if (ne === se) return 0;
            for (var Ce = ne.length, At = se.length, Ge = 0, Ye = Math.min(Ce, At); Ge < Ye; ++Ge)
              if (ne[Ge] !== se[Ge]) {
                Ce = ne[Ge], At = se[Ge];
                break;
              }
            return Ce < At ? -1 : At < Ce ? 1 : 0;
          }, u.isEncoding = function(ne) {
            switch (String(ne).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, u.concat = function(ne, se) {
            if (!o(ne))
              throw new TypeError('"list" argument must be an Array of Buffers');
            if (ne.length === 0)
              return u.alloc(0);
            var Ce;
            if (se === void 0)
              for (se = 0, Ce = 0; Ce < ne.length; ++Ce)
                se += ne[Ce].length;
            var At = u.allocUnsafe(se), Ge = 0;
            for (Ce = 0; Ce < ne.length; ++Ce) {
              var Ye = ne[Ce];
              if (!u.isBuffer(Ye))
                throw new TypeError('"list" argument must be an Array of Buffers');
              Ye.copy(At, Ge), Ge += Ye.length;
            }
            return At;
          };
          function B(Ue, ne) {
            if (u.isBuffer(Ue))
              return Ue.length;
            if (typeof ArrayBuffer != "undefined" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(Ue) || Ue instanceof ArrayBuffer))
              return Ue.byteLength;
            typeof Ue != "string" && (Ue = "" + Ue);
            var se = Ue.length;
            if (se === 0) return 0;
            for (var Ce = !1; ; )
              switch (ne) {
                case "ascii":
                case "latin1":
                case "binary":
                  return se;
                case "utf8":
                case "utf-8":
                case void 0:
                  return It(Ue).length;
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return se * 2;
                case "hex":
                  return se >>> 1;
                case "base64":
                  return Cn(Ue).length;
                default:
                  if (Ce) return It(Ue).length;
                  ne = ("" + ne).toLowerCase(), Ce = !0;
              }
          }
          u.byteLength = B;
          function Q(Ue, ne, se) {
            var Ce = !1;
            if ((ne === void 0 || ne < 0) && (ne = 0), ne > this.length || ((se === void 0 || se > this.length) && (se = this.length), se <= 0) || (se >>>= 0, ne >>>= 0, se <= ne))
              return "";
            for (Ue || (Ue = "utf8"); ; )
              switch (Ue) {
                case "hex":
                  return Te(this, ne, se);
                case "utf8":
                case "utf-8":
                  return oe(this, ne, se);
                case "ascii":
                  return we(this, ne, se);
                case "latin1":
                case "binary":
                  return _e(this, ne, se);
                case "base64":
                  return de(this, ne, se);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return Pe(this, ne, se);
                default:
                  if (Ce) throw new TypeError("Unknown encoding: " + Ue);
                  Ue = (Ue + "").toLowerCase(), Ce = !0;
              }
          }
          u.prototype._isBuffer = !0;
          function N(Ue, ne, se) {
            var Ce = Ue[ne];
            Ue[ne] = Ue[se], Ue[se] = Ce;
          }
          u.prototype.swap16 = function() {
            var ne = this.length;
            if (ne % 2 !== 0)
              throw new RangeError("Buffer size must be a multiple of 16-bits");
            for (var se = 0; se < ne; se += 2)
              N(this, se, se + 1);
            return this;
          }, u.prototype.swap32 = function() {
            var ne = this.length;
            if (ne % 4 !== 0)
              throw new RangeError("Buffer size must be a multiple of 32-bits");
            for (var se = 0; se < ne; se += 4)
              N(this, se, se + 3), N(this, se + 1, se + 2);
            return this;
          }, u.prototype.swap64 = function() {
            var ne = this.length;
            if (ne % 8 !== 0)
              throw new RangeError("Buffer size must be a multiple of 64-bits");
            for (var se = 0; se < ne; se += 8)
              N(this, se, se + 7), N(this, se + 1, se + 6), N(this, se + 2, se + 5), N(this, se + 3, se + 4);
            return this;
          }, u.prototype.toString = function() {
            var ne = this.length | 0;
            return ne === 0 ? "" : arguments.length === 0 ? oe(this, 0, ne) : Q.apply(this, arguments);
          }, u.prototype.equals = function(ne) {
            if (!u.isBuffer(ne)) throw new TypeError("Argument must be a Buffer");
            return this === ne ? !0 : u.compare(this, ne) === 0;
          }, u.prototype.inspect = function() {
            var ne = "", se = r.INSPECT_MAX_BYTES;
            return this.length > 0 && (ne = this.toString("hex", 0, se).match(/.{2}/g).join(" "), this.length > se && (ne += " ... ")), "<Buffer " + ne + ">";
          }, u.prototype.compare = function(ne, se, Ce, At, Ge) {
            if (!u.isBuffer(ne))
              throw new TypeError("Argument must be a Buffer");
            if (se === void 0 && (se = 0), Ce === void 0 && (Ce = ne ? ne.length : 0), At === void 0 && (At = 0), Ge === void 0 && (Ge = this.length), se < 0 || Ce > ne.length || At < 0 || Ge > this.length)
              throw new RangeError("out of range index");
            if (At >= Ge && se >= Ce)
              return 0;
            if (At >= Ge)
              return -1;
            if (se >= Ce)
              return 1;
            if (se >>>= 0, Ce >>>= 0, At >>>= 0, Ge >>>= 0, this === ne) return 0;
            for (var Ye = Ge - At, Qt = Ce - se, tn = Math.min(Ye, Qt), vn = this.slice(At, Ge), Yt = ne.slice(se, Ce), Tn = 0; Tn < tn; ++Tn)
              if (vn[Tn] !== Yt[Tn]) {
                Ye = vn[Tn], Qt = Yt[Tn];
                break;
              }
            return Ye < Qt ? -1 : Qt < Ye ? 1 : 0;
          };
          function J(Ue, ne, se, Ce, At) {
            if (Ue.length === 0) return -1;
            if (typeof se == "string" ? (Ce = se, se = 0) : se > 2147483647 ? se = 2147483647 : se < -2147483648 && (se = -2147483648), se = +se, isNaN(se) && (se = At ? 0 : Ue.length - 1), se < 0 && (se = Ue.length + se), se >= Ue.length) {
              if (At) return -1;
              se = Ue.length - 1;
            } else if (se < 0)
              if (At) se = 0;
              else return -1;
            if (typeof ne == "string" && (ne = u.from(ne, Ce)), u.isBuffer(ne))
              return ne.length === 0 ? -1 : w(Ue, ne, se, Ce, At);
            if (typeof ne == "number")
              return ne = ne & 255, u.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? At ? Uint8Array.prototype.indexOf.call(Ue, ne, se) : Uint8Array.prototype.lastIndexOf.call(Ue, ne, se) : w(Ue, [ne], se, Ce, At);
            throw new TypeError("val must be string, number or Buffer");
          }
          function w(Ue, ne, se, Ce, At) {
            var Ge = 1, Ye = Ue.length, Qt = ne.length;
            if (Ce !== void 0 && (Ce = String(Ce).toLowerCase(), Ce === "ucs2" || Ce === "ucs-2" || Ce === "utf16le" || Ce === "utf-16le")) {
              if (Ue.length < 2 || ne.length < 2)
                return -1;
              Ge = 2, Ye /= 2, Qt /= 2, se /= 2;
            }
            function tn(lr, Br) {
              return Ge === 1 ? lr[Br] : lr.readUInt16BE(Br * Ge);
            }
            var vn;
            if (At) {
              var Yt = -1;
              for (vn = se; vn < Ye; vn++)
                if (tn(Ue, vn) === tn(ne, Yt === -1 ? 0 : vn - Yt)) {
                  if (Yt === -1 && (Yt = vn), vn - Yt + 1 === Qt) return Yt * Ge;
                } else
                  Yt !== -1 && (vn -= vn - Yt), Yt = -1;
            } else
              for (se + Qt > Ye && (se = Ye - Qt), vn = se; vn >= 0; vn--) {
                for (var Tn = !0, er = 0; er < Qt; er++)
                  if (tn(Ue, vn + er) !== tn(ne, er)) {
                    Tn = !1;
                    break;
                  }
                if (Tn) return vn;
              }
            return -1;
          }
          u.prototype.includes = function(ne, se, Ce) {
            return this.indexOf(ne, se, Ce) !== -1;
          }, u.prototype.indexOf = function(ne, se, Ce) {
            return J(this, ne, se, Ce, !0);
          }, u.prototype.lastIndexOf = function(ne, se, Ce) {
            return J(this, ne, se, Ce, !1);
          };
          function W(Ue, ne, se, Ce) {
            se = Number(se) || 0;
            var At = Ue.length - se;
            Ce ? (Ce = Number(Ce), Ce > At && (Ce = At)) : Ce = At;
            var Ge = ne.length;
            if (Ge % 2 !== 0) throw new TypeError("Invalid hex string");
            Ce > Ge / 2 && (Ce = Ge / 2);
            for (var Ye = 0; Ye < Ce; ++Ye) {
              var Qt = parseInt(ne.substr(Ye * 2, 2), 16);
              if (isNaN(Qt)) return Ye;
              Ue[se + Ye] = Qt;
            }
            return Ye;
          }
          function G(Ue, ne, se, Ce) {
            return on(It(ne, Ue.length - se), Ue, se, Ce);
          }
          function Z(Ue, ne, se, Ce) {
            return on(Kt(ne), Ue, se, Ce);
          }
          function K(Ue, ne, se, Ce) {
            return Z(Ue, ne, se, Ce);
          }
          function L(Ue, ne, se, Ce) {
            return on(Cn(ne), Ue, se, Ce);
          }
          function O(Ue, ne, se, Ce) {
            return on(Sn(ne, Ue.length - se), Ue, se, Ce);
          }
          u.prototype.write = function(ne, se, Ce, At) {
            if (se === void 0)
              At = "utf8", Ce = this.length, se = 0;
            else if (Ce === void 0 && typeof se == "string")
              At = se, Ce = this.length, se = 0;
            else if (isFinite(se))
              se = se | 0, isFinite(Ce) ? (Ce = Ce | 0, At === void 0 && (At = "utf8")) : (At = Ce, Ce = void 0);
            else
              throw new Error(
                "Buffer.write(string, encoding, offset[, length]) is no longer supported"
              );
            var Ge = this.length - se;
            if ((Ce === void 0 || Ce > Ge) && (Ce = Ge), ne.length > 0 && (Ce < 0 || se < 0) || se > this.length)
              throw new RangeError("Attempt to write outside buffer bounds");
            At || (At = "utf8");
            for (var Ye = !1; ; )
              switch (At) {
                case "hex":
                  return W(this, ne, se, Ce);
                case "utf8":
                case "utf-8":
                  return G(this, ne, se, Ce);
                case "ascii":
                  return Z(this, ne, se, Ce);
                case "latin1":
                case "binary":
                  return K(this, ne, se, Ce);
                case "base64":
                  return L(this, ne, se, Ce);
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return O(this, ne, se, Ce);
                default:
                  if (Ye) throw new TypeError("Unknown encoding: " + At);
                  At = ("" + At).toLowerCase(), Ye = !0;
              }
          }, u.prototype.toJSON = function() {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          function de(Ue, ne, se) {
            return ne === 0 && se === Ue.length ? n.fromByteArray(Ue) : n.fromByteArray(Ue.slice(ne, se));
          }
          function oe(Ue, ne, se) {
            se = Math.min(Ue.length, se);
            for (var Ce = [], At = ne; At < se; ) {
              var Ge = Ue[At], Ye = null, Qt = Ge > 239 ? 4 : Ge > 223 ? 3 : Ge > 191 ? 2 : 1;
              if (At + Qt <= se) {
                var tn, vn, Yt, Tn;
                switch (Qt) {
                  case 1:
                    Ge < 128 && (Ye = Ge);
                    break;
                  case 2:
                    tn = Ue[At + 1], (tn & 192) === 128 && (Tn = (Ge & 31) << 6 | tn & 63, Tn > 127 && (Ye = Tn));
                    break;
                  case 3:
                    tn = Ue[At + 1], vn = Ue[At + 2], (tn & 192) === 128 && (vn & 192) === 128 && (Tn = (Ge & 15) << 12 | (tn & 63) << 6 | vn & 63, Tn > 2047 && (Tn < 55296 || Tn > 57343) && (Ye = Tn));
                    break;
                  case 4:
                    tn = Ue[At + 1], vn = Ue[At + 2], Yt = Ue[At + 3], (tn & 192) === 128 && (vn & 192) === 128 && (Yt & 192) === 128 && (Tn = (Ge & 15) << 18 | (tn & 63) << 12 | (vn & 63) << 6 | Yt & 63, Tn > 65535 && Tn < 1114112 && (Ye = Tn));
                }
              }
              Ye === null ? (Ye = 65533, Qt = 1) : Ye > 65535 && (Ye -= 65536, Ce.push(Ye >>> 10 & 1023 | 55296), Ye = 56320 | Ye & 1023), Ce.push(Ye), At += Qt;
            }
            return ge(Ce);
          }
          var fe = 4096;
          function ge(Ue) {
            var ne = Ue.length;
            if (ne <= fe)
              return String.fromCharCode.apply(String, Ue);
            for (var se = "", Ce = 0; Ce < ne; )
              se += String.fromCharCode.apply(
                String,
                Ue.slice(Ce, Ce += fe)
              );
            return se;
          }
          function we(Ue, ne, se) {
            var Ce = "";
            se = Math.min(Ue.length, se);
            for (var At = ne; At < se; ++At)
              Ce += String.fromCharCode(Ue[At] & 127);
            return Ce;
          }
          function _e(Ue, ne, se) {
            var Ce = "";
            se = Math.min(Ue.length, se);
            for (var At = ne; At < se; ++At)
              Ce += String.fromCharCode(Ue[At]);
            return Ce;
          }
          function Te(Ue, ne, se) {
            var Ce = Ue.length;
            (!ne || ne < 0) && (ne = 0), (!se || se < 0 || se > Ce) && (se = Ce);
            for (var At = "", Ge = ne; Ge < se; ++Ge)
              At += ft(Ue[Ge]);
            return At;
          }
          function Pe(Ue, ne, se) {
            for (var Ce = Ue.slice(ne, se), At = "", Ge = 0; Ge < Ce.length; Ge += 2)
              At += String.fromCharCode(Ce[Ge] + Ce[Ge + 1] * 256);
            return At;
          }
          u.prototype.slice = function(ne, se) {
            var Ce = this.length;
            ne = ~~ne, se = se === void 0 ? Ce : ~~se, ne < 0 ? (ne += Ce, ne < 0 && (ne = 0)) : ne > Ce && (ne = Ce), se < 0 ? (se += Ce, se < 0 && (se = 0)) : se > Ce && (se = Ce), se < ne && (se = ne);
            var At;
            if (u.TYPED_ARRAY_SUPPORT)
              At = this.subarray(ne, se), At.__proto__ = u.prototype;
            else {
              var Ge = se - ne;
              At = new u(Ge, void 0);
              for (var Ye = 0; Ye < Ge; ++Ye)
                At[Ye] = this[Ye + ne];
            }
            return At;
          };
          function $e(Ue, ne, se) {
            if (Ue % 1 !== 0 || Ue < 0) throw new RangeError("offset is not uint");
            if (Ue + ne > se) throw new RangeError("Trying to access beyond buffer length");
          }
          u.prototype.readUIntLE = function(ne, se, Ce) {
            ne = ne | 0, se = se | 0, Ce || $e(ne, se, this.length);
            for (var At = this[ne], Ge = 1, Ye = 0; ++Ye < se && (Ge *= 256); )
              At += this[ne + Ye] * Ge;
            return At;
          }, u.prototype.readUIntBE = function(ne, se, Ce) {
            ne = ne | 0, se = se | 0, Ce || $e(ne, se, this.length);
            for (var At = this[ne + --se], Ge = 1; se > 0 && (Ge *= 256); )
              At += this[ne + --se] * Ge;
            return At;
          }, u.prototype.readUInt8 = function(ne, se) {
            return se || $e(ne, 1, this.length), this[ne];
          }, u.prototype.readUInt16LE = function(ne, se) {
            return se || $e(ne, 2, this.length), this[ne] | this[ne + 1] << 8;
          }, u.prototype.readUInt16BE = function(ne, se) {
            return se || $e(ne, 2, this.length), this[ne] << 8 | this[ne + 1];
          }, u.prototype.readUInt32LE = function(ne, se) {
            return se || $e(ne, 4, this.length), (this[ne] | this[ne + 1] << 8 | this[ne + 2] << 16) + this[ne + 3] * 16777216;
          }, u.prototype.readUInt32BE = function(ne, se) {
            return se || $e(ne, 4, this.length), this[ne] * 16777216 + (this[ne + 1] << 16 | this[ne + 2] << 8 | this[ne + 3]);
          }, u.prototype.readIntLE = function(ne, se, Ce) {
            ne = ne | 0, se = se | 0, Ce || $e(ne, se, this.length);
            for (var At = this[ne], Ge = 1, Ye = 0; ++Ye < se && (Ge *= 256); )
              At += this[ne + Ye] * Ge;
            return Ge *= 128, At >= Ge && (At -= Math.pow(2, 8 * se)), At;
          }, u.prototype.readIntBE = function(ne, se, Ce) {
            ne = ne | 0, se = se | 0, Ce || $e(ne, se, this.length);
            for (var At = se, Ge = 1, Ye = this[ne + --At]; At > 0 && (Ge *= 256); )
              Ye += this[ne + --At] * Ge;
            return Ge *= 128, Ye >= Ge && (Ye -= Math.pow(2, 8 * se)), Ye;
          }, u.prototype.readInt8 = function(ne, se) {
            return se || $e(ne, 1, this.length), this[ne] & 128 ? (255 - this[ne] + 1) * -1 : this[ne];
          }, u.prototype.readInt16LE = function(ne, se) {
            se || $e(ne, 2, this.length);
            var Ce = this[ne] | this[ne + 1] << 8;
            return Ce & 32768 ? Ce | 4294901760 : Ce;
          }, u.prototype.readInt16BE = function(ne, se) {
            se || $e(ne, 2, this.length);
            var Ce = this[ne + 1] | this[ne] << 8;
            return Ce & 32768 ? Ce | 4294901760 : Ce;
          }, u.prototype.readInt32LE = function(ne, se) {
            return se || $e(ne, 4, this.length), this[ne] | this[ne + 1] << 8 | this[ne + 2] << 16 | this[ne + 3] << 24;
          }, u.prototype.readInt32BE = function(ne, se) {
            return se || $e(ne, 4, this.length), this[ne] << 24 | this[ne + 1] << 16 | this[ne + 2] << 8 | this[ne + 3];
          }, u.prototype.readFloatLE = function(ne, se) {
            return se || $e(ne, 4, this.length), t.read(this, ne, !0, 23, 4);
          }, u.prototype.readFloatBE = function(ne, se) {
            return se || $e(ne, 4, this.length), t.read(this, ne, !1, 23, 4);
          }, u.prototype.readDoubleLE = function(ne, se) {
            return se || $e(ne, 8, this.length), t.read(this, ne, !0, 52, 8);
          }, u.prototype.readDoubleBE = function(ne, se) {
            return se || $e(ne, 8, this.length), t.read(this, ne, !1, 52, 8);
          };
          function Bt(Ue, ne, se, Ce, At, Ge) {
            if (!u.isBuffer(Ue)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (ne > At || ne < Ge) throw new RangeError('"value" argument is out of bounds');
            if (se + Ce > Ue.length) throw new RangeError("Index out of range");
          }
          u.prototype.writeUIntLE = function(ne, se, Ce, At) {
            if (ne = +ne, se = se | 0, Ce = Ce | 0, !At) {
              var Ge = Math.pow(2, 8 * Ce) - 1;
              Bt(this, ne, se, Ce, Ge, 0);
            }
            var Ye = 1, Qt = 0;
            for (this[se] = ne & 255; ++Qt < Ce && (Ye *= 256); )
              this[se + Qt] = ne / Ye & 255;
            return se + Ce;
          }, u.prototype.writeUIntBE = function(ne, se, Ce, At) {
            if (ne = +ne, se = se | 0, Ce = Ce | 0, !At) {
              var Ge = Math.pow(2, 8 * Ce) - 1;
              Bt(this, ne, se, Ce, Ge, 0);
            }
            var Ye = Ce - 1, Qt = 1;
            for (this[se + Ye] = ne & 255; --Ye >= 0 && (Qt *= 256); )
              this[se + Ye] = ne / Qt & 255;
            return se + Ce;
          }, u.prototype.writeUInt8 = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (ne = Math.floor(ne)), this[se] = ne & 255, se + 1;
          };
          function Le(Ue, ne, se, Ce) {
            ne < 0 && (ne = 65535 + ne + 1);
            for (var At = 0, Ge = Math.min(Ue.length - se, 2); At < Ge; ++At)
              Ue[se + At] = (ne & 255 << 8 * (Ce ? At : 1 - At)) >>> (Ce ? At : 1 - At) * 8;
          }
          u.prototype.writeUInt16LE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne & 255, this[se + 1] = ne >>> 8) : Le(this, ne, se, !0), se + 2;
          }, u.prototype.writeUInt16BE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne >>> 8, this[se + 1] = ne & 255) : Le(this, ne, se, !1), se + 2;
          };
          function at(Ue, ne, se, Ce) {
            ne < 0 && (ne = 4294967295 + ne + 1);
            for (var At = 0, Ge = Math.min(Ue.length - se, 4); At < Ge; ++At)
              Ue[se + At] = ne >>> (Ce ? At : 3 - At) * 8 & 255;
          }
          u.prototype.writeUInt32LE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[se + 3] = ne >>> 24, this[se + 2] = ne >>> 16, this[se + 1] = ne >>> 8, this[se] = ne & 255) : at(this, ne, se, !0), se + 4;
          }, u.prototype.writeUInt32BE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne >>> 24, this[se + 1] = ne >>> 16, this[se + 2] = ne >>> 8, this[se + 3] = ne & 255) : at(this, ne, se, !1), se + 4;
          }, u.prototype.writeIntLE = function(ne, se, Ce, At) {
            if (ne = +ne, se = se | 0, !At) {
              var Ge = Math.pow(2, 8 * Ce - 1);
              Bt(this, ne, se, Ce, Ge - 1, -Ge);
            }
            var Ye = 0, Qt = 1, tn = 0;
            for (this[se] = ne & 255; ++Ye < Ce && (Qt *= 256); )
              ne < 0 && tn === 0 && this[se + Ye - 1] !== 0 && (tn = 1), this[se + Ye] = (ne / Qt >> 0) - tn & 255;
            return se + Ce;
          }, u.prototype.writeIntBE = function(ne, se, Ce, At) {
            if (ne = +ne, se = se | 0, !At) {
              var Ge = Math.pow(2, 8 * Ce - 1);
              Bt(this, ne, se, Ce, Ge - 1, -Ge);
            }
            var Ye = Ce - 1, Qt = 1, tn = 0;
            for (this[se + Ye] = ne & 255; --Ye >= 0 && (Qt *= 256); )
              ne < 0 && tn === 0 && this[se + Ye + 1] !== 0 && (tn = 1), this[se + Ye] = (ne / Qt >> 0) - tn & 255;
            return se + Ce;
          }, u.prototype.writeInt8 = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (ne = Math.floor(ne)), ne < 0 && (ne = 255 + ne + 1), this[se] = ne & 255, se + 1;
          }, u.prototype.writeInt16LE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne & 255, this[se + 1] = ne >>> 8) : Le(this, ne, se, !0), se + 2;
          }, u.prototype.writeInt16BE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne >>> 8, this[se + 1] = ne & 255) : Le(this, ne, se, !1), se + 2;
          }, u.prototype.writeInt32LE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne & 255, this[se + 1] = ne >>> 8, this[se + 2] = ne >>> 16, this[se + 3] = ne >>> 24) : at(this, ne, se, !0), se + 4;
          }, u.prototype.writeInt32BE = function(ne, se, Ce) {
            return ne = +ne, se = se | 0, Ce || Bt(this, ne, se, 4, 2147483647, -2147483648), ne < 0 && (ne = 4294967295 + ne + 1), u.TYPED_ARRAY_SUPPORT ? (this[se] = ne >>> 24, this[se + 1] = ne >>> 16, this[se + 2] = ne >>> 8, this[se + 3] = ne & 255) : at(this, ne, se, !1), se + 4;
          };
          function pt(Ue, ne, se, Ce, At, Ge) {
            if (se + Ce > Ue.length) throw new RangeError("Index out of range");
            if (se < 0) throw new RangeError("Index out of range");
          }
          function kt(Ue, ne, se, Ce, At) {
            return At || pt(Ue, ne, se, 4), t.write(Ue, ne, se, Ce, 23, 4), se + 4;
          }
          u.prototype.writeFloatLE = function(ne, se, Ce) {
            return kt(this, ne, se, !0, Ce);
          }, u.prototype.writeFloatBE = function(ne, se, Ce) {
            return kt(this, ne, se, !1, Ce);
          };
          function _t(Ue, ne, se, Ce, At) {
            return At || pt(Ue, ne, se, 8), t.write(Ue, ne, se, Ce, 52, 8), se + 8;
          }
          u.prototype.writeDoubleLE = function(ne, se, Ce) {
            return _t(this, ne, se, !0, Ce);
          }, u.prototype.writeDoubleBE = function(ne, se, Ce) {
            return _t(this, ne, se, !1, Ce);
          }, u.prototype.copy = function(ne, se, Ce, At) {
            if (Ce || (Ce = 0), !At && At !== 0 && (At = this.length), se >= ne.length && (se = ne.length), se || (se = 0), At > 0 && At < Ce && (At = Ce), At === Ce || ne.length === 0 || this.length === 0) return 0;
            if (se < 0)
              throw new RangeError("targetStart out of bounds");
            if (Ce < 0 || Ce >= this.length) throw new RangeError("sourceStart out of bounds");
            if (At < 0) throw new RangeError("sourceEnd out of bounds");
            At > this.length && (At = this.length), ne.length - se < At - Ce && (At = ne.length - se + Ce);
            var Ge = At - Ce, Ye;
            if (this === ne && Ce < se && se < At)
              for (Ye = Ge - 1; Ye >= 0; --Ye)
                ne[Ye + se] = this[Ye + Ce];
            else if (Ge < 1e3 || !u.TYPED_ARRAY_SUPPORT)
              for (Ye = 0; Ye < Ge; ++Ye)
                ne[Ye + se] = this[Ye + Ce];
            else
              Uint8Array.prototype.set.call(
                ne,
                this.subarray(Ce, Ce + Ge),
                se
              );
            return Ge;
          }, u.prototype.fill = function(ne, se, Ce, At) {
            if (typeof ne == "string") {
              if (typeof se == "string" ? (At = se, se = 0, Ce = this.length) : typeof Ce == "string" && (At = Ce, Ce = this.length), ne.length === 1) {
                var Ge = ne.charCodeAt(0);
                Ge < 256 && (ne = Ge);
              }
              if (At !== void 0 && typeof At != "string")
                throw new TypeError("encoding must be a string");
              if (typeof At == "string" && !u.isEncoding(At))
                throw new TypeError("Unknown encoding: " + At);
            } else typeof ne == "number" && (ne = ne & 255);
            if (se < 0 || this.length < se || this.length < Ce)
              throw new RangeError("Out of range index");
            if (Ce <= se)
              return this;
            se = se >>> 0, Ce = Ce === void 0 ? this.length : Ce >>> 0, ne || (ne = 0);
            var Ye;
            if (typeof ne == "number")
              for (Ye = se; Ye < Ce; ++Ye)
                this[Ye] = ne;
            else {
              var Qt = u.isBuffer(ne) ? ne : It(new u(ne, At).toString()), tn = Qt.length;
              for (Ye = 0; Ye < Ce - se; ++Ye)
                this[Ye + se] = Qt[Ye % tn];
            }
            return this;
          };
          var Lt = /[^+\/0-9A-Za-z-_]/g;
          function Ft(Ue) {
            if (Ue = Zt(Ue).replace(Lt, ""), Ue.length < 2) return "";
            for (; Ue.length % 4 !== 0; )
              Ue = Ue + "=";
            return Ue;
          }
          function Zt(Ue) {
            return Ue.trim ? Ue.trim() : Ue.replace(/^\s+|\s+$/g, "");
          }
          function ft(Ue) {
            return Ue < 16 ? "0" + Ue.toString(16) : Ue.toString(16);
          }
          function It(Ue, ne) {
            ne = ne || 1 / 0;
            for (var se, Ce = Ue.length, At = null, Ge = [], Ye = 0; Ye < Ce; ++Ye) {
              if (se = Ue.charCodeAt(Ye), se > 55295 && se < 57344) {
                if (!At) {
                  if (se > 56319) {
                    (ne -= 3) > -1 && Ge.push(239, 191, 189);
                    continue;
                  } else if (Ye + 1 === Ce) {
                    (ne -= 3) > -1 && Ge.push(239, 191, 189);
                    continue;
                  }
                  At = se;
                  continue;
                }
                if (se < 56320) {
                  (ne -= 3) > -1 && Ge.push(239, 191, 189), At = se;
                  continue;
                }
                se = (At - 55296 << 10 | se - 56320) + 65536;
              } else At && (ne -= 3) > -1 && Ge.push(239, 191, 189);
              if (At = null, se < 128) {
                if ((ne -= 1) < 0) break;
                Ge.push(se);
              } else if (se < 2048) {
                if ((ne -= 2) < 0) break;
                Ge.push(
                  se >> 6 | 192,
                  se & 63 | 128
                );
              } else if (se < 65536) {
                if ((ne -= 3) < 0) break;
                Ge.push(
                  se >> 12 | 224,
                  se >> 6 & 63 | 128,
                  se & 63 | 128
                );
              } else if (se < 1114112) {
                if ((ne -= 4) < 0) break;
                Ge.push(
                  se >> 18 | 240,
                  se >> 12 & 63 | 128,
                  se >> 6 & 63 | 128,
                  se & 63 | 128
                );
              } else
                throw new Error("Invalid code point");
            }
            return Ge;
          }
          function Kt(Ue) {
            for (var ne = [], se = 0; se < Ue.length; ++se)
              ne.push(Ue.charCodeAt(se) & 255);
            return ne;
          }
          function Sn(Ue, ne) {
            for (var se, Ce, At, Ge = [], Ye = 0; Ye < Ue.length && !((ne -= 2) < 0); ++Ye)
              se = Ue.charCodeAt(Ye), Ce = se >> 8, At = se % 256, Ge.push(At), Ge.push(Ce);
            return Ge;
          }
          function Cn(Ue) {
            return n.toByteArray(Ft(Ue));
          }
          function on(Ue, ne, se, Ce) {
            for (var At = 0; At < Ce && !(At + se >= ne.length || At >= Ue.length); ++At)
              ne[At + se] = Ue[At];
            return At;
          }
          function An(Ue) {
            return Ue !== Ue;
          }
        },
        /* 786 */
        /***/
        function(i, r, e) {
          r.byteLength = h, r.toByteArray = g, r.fromByteArray = v;
          for (var n = [], t = [], o = typeof Uint8Array != "undefined" ? Uint8Array : Array, l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = 0, d = l.length; c < d; ++c)
            n[c] = l[c], t[l.charCodeAt(c)] = c;
          t[45] = 62, t[95] = 63;
          function u(b) {
            var m = b.length;
            if (m % 4 > 0)
              throw new Error("Invalid string. Length must be a multiple of 4");
            var y = b.indexOf("=");
            y === -1 && (y = m);
            var U = y === m ? 0 : 4 - y % 4;
            return [y, U];
          }
          function h(b) {
            var m = u(b), y = m[0], U = m[1];
            return (y + U) * 3 / 4 - U;
          }
          function A(b, m, y) {
            return (m + y) * 3 / 4 - y;
          }
          function g(b) {
            var m, y = u(b), U = y[0], B = y[1], Q = new o(A(b, U, B)), N = 0, J = B > 0 ? U - 4 : U, w;
            for (w = 0; w < J; w += 4)
              m = t[b.charCodeAt(w)] << 18 | t[b.charCodeAt(w + 1)] << 12 | t[b.charCodeAt(w + 2)] << 6 | t[b.charCodeAt(w + 3)], Q[N++] = m >> 16 & 255, Q[N++] = m >> 8 & 255, Q[N++] = m & 255;
            return B === 2 && (m = t[b.charCodeAt(w)] << 2 | t[b.charCodeAt(w + 1)] >> 4, Q[N++] = m & 255), B === 1 && (m = t[b.charCodeAt(w)] << 10 | t[b.charCodeAt(w + 1)] << 4 | t[b.charCodeAt(w + 2)] >> 2, Q[N++] = m >> 8 & 255, Q[N++] = m & 255), Q;
          }
          function f(b) {
            return n[b >> 18 & 63] + n[b >> 12 & 63] + n[b >> 6 & 63] + n[b & 63];
          }
          function p(b, m, y) {
            for (var U, B = [], Q = m; Q < y; Q += 3)
              U = (b[Q] << 16 & 16711680) + (b[Q + 1] << 8 & 65280) + (b[Q + 2] & 255), B.push(f(U));
            return B.join("");
          }
          function v(b) {
            for (var m, y = b.length, U = y % 3, B = [], Q = 16383, N = 0, J = y - U; N < J; N += Q)
              B.push(p(b, N, N + Q > J ? J : N + Q));
            return U === 1 ? (m = b[y - 1], B.push(
              n[m >> 2] + n[m << 4 & 63] + "=="
            )) : U === 2 && (m = (b[y - 2] << 8) + b[y - 1], B.push(
              n[m >> 10] + n[m >> 4 & 63] + n[m << 2 & 63] + "="
            )), B.join("");
          }
        },
        /* 787 */
        /***/
        function(i, r) {
          /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
          r.read = function(e, n, t, o, l) {
            var c, d, u = l * 8 - o - 1, h = (1 << u) - 1, A = h >> 1, g = -7, f = t ? l - 1 : 0, p = t ? -1 : 1, v = e[n + f];
            for (f += p, c = v & (1 << -g) - 1, v >>= -g, g += u; g > 0; c = c * 256 + e[n + f], f += p, g -= 8)
              ;
            for (d = c & (1 << -g) - 1, c >>= -g, g += o; g > 0; d = d * 256 + e[n + f], f += p, g -= 8)
              ;
            if (c === 0)
              c = 1 - A;
            else {
              if (c === h)
                return d ? NaN : (v ? -1 : 1) * (1 / 0);
              d = d + Math.pow(2, o), c = c - A;
            }
            return (v ? -1 : 1) * d * Math.pow(2, c - o);
          }, r.write = function(e, n, t, o, l, c) {
            var d, u, h, A = c * 8 - l - 1, g = (1 << A) - 1, f = g >> 1, p = l === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, v = o ? 0 : c - 1, b = o ? 1 : -1, m = n < 0 || n === 0 && 1 / n < 0 ? 1 : 0;
            for (n = Math.abs(n), isNaN(n) || n === 1 / 0 ? (u = isNaN(n) ? 1 : 0, d = g) : (d = Math.floor(Math.log(n) / Math.LN2), n * (h = Math.pow(2, -d)) < 1 && (d--, h *= 2), d + f >= 1 ? n += p / h : n += p * Math.pow(2, 1 - f), n * h >= 2 && (d++, h /= 2), d + f >= g ? (u = 0, d = g) : d + f >= 1 ? (u = (n * h - 1) * Math.pow(2, l), d = d + f) : (u = n * Math.pow(2, f - 1) * Math.pow(2, l), d = 0)); l >= 8; e[t + v] = u & 255, v += b, u /= 256, l -= 8)
              ;
            for (d = d << l | u, A += l; A > 0; e[t + v] = d & 255, v += b, d /= 256, A -= 8)
              ;
            e[t + v - b] |= m * 128;
          };
        },
        /* 788 */
        /***/
        function(i, r) {
          var e = {}.toString;
          i.exports = Array.isArray || function(n) {
            return e.call(n) == "[object Array]";
          };
        },
        /* 789 */
        /***/
        function(i, r) {
        },
        /* 790 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), c = /* @__PURE__ */ function() {
            var d = (0, o.default)(/* @__PURE__ */ t.default.mark(function u(h) {
              var A, g, f;
              return t.default.wrap(function(v) {
                for (; ; ) switch (v.prev = v.next) {
                  case 0:
                    if (h instanceof ((A = window) == null ? void 0 : A.CryptoKey)) {
                      v.next = 2;
                      break;
                    }
                    return v.abrupt("return", h);
                  case 2:
                    return v.next = 4, (g = window) == null ? void 0 : g.crypto.subtle.exportKey("raw", h);
                  case 4:
                    return f = v.sent, v.abrupt("return", new Uint8Array(f));
                  case 6:
                  case "end":
                    return v.stop();
                }
              }, u);
            }));
            return function(h) {
              return d.apply(this, arguments);
            };
          }();
          r.default = c;
        },
        /* 791 */
        /***/
        function(i, r, e) {
          (function(n) {
            var t = e(0);
            r.__esModule = !0, r.default = void 0;
            var o = t(e(4)), l = t(e(5)), c = t(e(185)), d = t(e(163)), u = t(e(793)), h = t(e(74)), A = t(e(794)), g = t(e(795)), f = t(e(20));
            const p = (0, h.default)();
            var b = /* @__PURE__ */ function() {
              function m(U, B) {
                B === void 0 && (B = {}), this.createPeerConnectionSDP = B.createPeerConnectionSDP || g.default, this._session = U, this.PeerConnection = B.PeerConnection || p, this.sdpHelpers = B.helpers || f.default, this._init();
              }
              var y = m.prototype;
              return y._init = function() {
                this._reset();
              }, y._reset = function() {
                this._originalSendMessages = {}, this._tracks = [], this._currentAndPreviousMids = [], this._subscriberPcs = {}, this._peerConnectionSDP = this.createPeerConnectionSDP({
                  logEvent: this._session.logEvent
                }), this._subscriberQueue = new A.default(), this._sendMessage = () => {
                }, this._peerConnection && (this._peerConnection.disconnect(), this._peerConnection = null);
              }, y._parseOptions = function(B) {
                return Object.assign({}, B, {
                  // We always remove unused codecs after iceRestart in SPC
                  removeUnusedCodecs: !0,
                  sendMessage: (Q, N) => {
                    const J = Object.assign({}, N);
                    if (J.sdp) {
                      const W = this._peerConnectionSDP.getPartialSdp(Q, J.sdp);
                      J.sdp = W;
                    }
                    const w = this._createSendMessageErrorHandler(Q, J);
                    this._sendMessage(Q, J, w), Q === "answer" && this.subscriberComplete();
                  }
                });
              }, y._addListeners = function() {
                this._peerConnection && this._peerConnection.on("trackAdded", (B) => {
                  let Q = B.track, N = B.transceiver;
                  this._currentAndPreviousMids.includes(N.mid) || (this._subscriberPcs[this._subscriberPcToAdd._id].push(Q.id), this._tracks.push(Q.id), this._currentAndPreviousMids.push(N.mid), this._subscriberPcToAdd.onTrackAdded({
                    track: Q,
                    transceiver: N
                  }));
                });
              }, y._removeMessageSender = function(B) {
                delete this._originalSendMessages[B], this._sendMessage = this._getLatestSendMessage();
              }, y._generateOffer = /* @__PURE__ */ function() {
                var U = (0, l.default)(/* @__PURE__ */ o.default.mark(function Q() {
                  return o.default.wrap(function(J) {
                    for (; ; ) switch (J.prev = J.next) {
                      case 0:
                        return J.abrupt("return", new n((w) => {
                          const W = () => {
                            const G = this._peerConnectionSDP.createSdp();
                            this._peerConnection.processMessage("answer", {
                              content: {
                                sdp: G
                              }
                            }), w();
                          };
                          this._peerConnection.generateOffer(W);
                        }));
                      case 1:
                      case "end":
                        return J.stop();
                    }
                  }, Q, this);
                }));
                function B() {
                  return U.apply(this, arguments);
                }
                return B;
              }(), y._removeSubscriber = function(B) {
                delete this._subscriberPcs[B], this._removeMessageSender(B);
              }, y._stopTransceivers = function(B) {
                this._peerConnectionSDP.removeMids(B), this._peerConnection.stopTransceivers(B);
              }, y._setTransceiverToInactive = function(B) {
                this._peerConnectionSDP.setTrackToInactive(B), this._peerConnection.setTransceiversToInactive([B]);
              }, y._removeSubscribersDestroyedByMantis = /* @__PURE__ */ function() {
                var U = (0, l.default)(/* @__PURE__ */ o.default.mark(function Q(N) {
                  var J, w;
                  return o.default.wrap(function(G) {
                    for (; ; ) switch (G.prev = G.next) {
                      case 0:
                        if (J = (0, c.default)(this._peerConnectionSDP.sdp.tracks, N), J.length !== 0) {
                          G.next = 3;
                          break;
                        }
                        return G.abrupt("return");
                      case 3:
                        return this._session.logEvent("peerConnection:spcOfferMismatch", "Event", J), w = (0, d.default)(J.map((Z) => this._peerConnectionSDP.subscribePcIdsByMid[Z]).filter((Z) => Z !== void 0)), w.forEach((Z) => {
                          const K = J.filter((L) => this._peerConnectionSDP.subscribePcIdsByMid[L] === Z);
                          this._removeSubscriber(Z), this._stopTransceivers(K);
                        }), G.abrupt("return", this._generateOffer());
                      case 7:
                      case "end":
                        return G.stop();
                    }
                  }, Q, this);
                }));
                function B(Q) {
                  return U.apply(this, arguments);
                }
                return B;
              }(), y._getLatestSendMessage = function() {
                return Object.values(this._originalSendMessages).slice(-1)[0] || function() {
                };
              }, y._createSendMessageErrorHandler = function(B, Q) {
                const N = (J, w) => {
                  if (J && (w == null ? void 0 : w.status) === "404") {
                    const W = Object.keys(this._originalSendMessages);
                    if (W.length) {
                      const G = W.find((Z) => this._originalSendMessages[Z] === this._sendMessage);
                      this._removeMessageSender(G), this._sendMessage(B, Q, N);
                    }
                  }
                };
                return N;
              }, y.getPeerConnection = function(B, Q) {
                if (this._subscriberPcToAdd = Q, this._sendMessage = B.sendMessage, this._originalSendMessages[Q._id] = this._sendMessage, this._peerConnection)
                  this._peerConnection.addOptions(B);
                else {
                  const N = this._parseOptions(B);
                  this._peerConnection = new this.PeerConnection(N), this._addListeners();
                }
                return this._subscriberPcs[Q._id] = [], this._peerConnection;
              }, y.removeSubscriber = function(B, Q) {
                var N = this;
                this._subscriberQueue.enqueue(/* @__PURE__ */ (0, l.default)(/* @__PURE__ */ o.default.mark(function J() {
                  var w, W, G;
                  return o.default.wrap(function(K) {
                    for (; ; ) switch (K.prev = K.next) {
                      case 0:
                        if (w = Q, W = N._peerConnectionSDP.isHead(B), N._removeSubscriber(B), Object.keys(N._subscriberPcs).length) {
                          K.next = 6;
                          break;
                        }
                        return N._reset(), K.abrupt("return");
                      case 6:
                        return W && (G = N._peerConnectionSDP.getHeadMid(), N._setTransceiverToInactive(G), w = Q.filter((L) => L !== G)), N._stopTransceivers(w), K.next = 10, N._generateOffer();
                      case 10:
                        N._subscriberQueue.dequeueAndProcessNext();
                      case 11:
                      case "end":
                        return K.stop();
                    }
                  }, J);
                })));
              }, y.generateOfferWithIceRestart = function() {
                this._peerConnection.iceRestart(), this._peerConnection.generateOfferAndSend();
              }, y.removeTrack = function(B, Q) {
                const N = B == null ? void 0 : B.id;
                N && ((0, u.default)(this._tracks, N), (0, u.default)(this._subscriberPcs[Q] || [], N));
              }, y.destroy = function() {
                this._reset(), this._session = null;
              }, y.addSubscriber = function(B) {
                this._subscriberQueue.enqueue(B);
              }, y.addSubscriberMid = function(B, Q) {
                this._peerConnectionSDP.addSubscriberMid(B, Q);
              }, y.subscriberComplete = function() {
                this._subscriberQueue.dequeueAndProcessNext();
              }, y.processAnswer = function(B) {
                return this._peerConnectionSDP.processAnswer(B);
              }, y.processOffer = /* @__PURE__ */ function() {
                var U = (0, l.default)(/* @__PURE__ */ o.default.mark(function Q(N) {
                  var J;
                  return o.default.wrap(function(W) {
                    for (; ; ) switch (W.prev = W.next) {
                      case 0:
                        return J = this.sdpHelpers.parseMantisSDP(N), W.next = 3, this._removeSubscribersDestroyedByMantis(J.tracks);
                      case 3:
                        return W.abrupt("return", this._peerConnectionSDP.processOffer(J));
                      case 4:
                      case "end":
                        return W.stop();
                    }
                  }, Q, this);
                }));
                function B(Q) {
                  return U.apply(this, arguments);
                }
                return B;
              }(), m;
            }();
            r.default = b;
          }).call(this, e(2));
        },
        /* 792 */
        /***/
        function(i, r, e) {
          var n = e(98), t = e(96), o = e(146), l = e(39), c = e(67), d = e(99), u = 200;
          function h(A, g, f, p) {
            var v = -1, b = t, m = !0, y = A.length, U = [], B = g.length;
            if (!y)
              return U;
            f && (g = l(g, c(f))), p ? (b = o, m = !1) : g.length >= u && (b = d, m = !1, g = new n(g));
            e:
              for (; ++v < y; ) {
                var Q = A[v], N = f == null ? Q : f(Q);
                if (Q = p || Q !== 0 ? Q : 0, m && N === N) {
                  for (var J = B; J--; )
                    if (g[J] === N)
                      continue e;
                  U.push(Q);
                } else b(g, N, p) || U.push(Q);
              }
            return U;
          }
          i.exports = h;
        },
        /* 793 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          var t = (o, l) => {
            o.forEach((c, d) => {
              const u = c.id || c, h = l.id || l;
              u === h && o.splice(d, 1);
            });
          };
          r.default = t;
        },
        /* 794 */
        /***/
        function(i, r, e) {
          r.__esModule = !0, r.default = void 0;
          const n = 100;
          var o = /* @__PURE__ */ function() {
            function l() {
              this._processFinalTaskWithDelay = () => {
                this._timeoutId = setTimeout(() => {
                  this._timeoutId = void 0, this.processing = !0, this.finalTask(), this.finalTask = void 0;
                }, n);
              }, this._queue = [], this._isProcessing = !1, this._timeoutId = void 0;
            }
            var c = l.prototype;
            return c.enqueue = function(u) {
              this._isProcessing ? this._queue.push(u) : (this._timeoutId && clearTimeout(this._timeoutId), this._isProcessing = !0, u());
            }, c.finally = function(u) {
              this.finalTask = u, !this._isProcessing && (this._timeoutId || this._processFinalTaskWithDelay());
            }, c.dequeueAndProcessNext = function() {
              const u = this._queue.shift();
              u ? u() : (this.finalTask && this._processFinalTaskWithDelay(), this._isProcessing = !1);
            }, l;
          }();
          r.default = o;
        },
        /* 795 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(185)), o = n(e(796)), l = n(e(20)), c = n(e(797)), d = n(e(798)), h = function(g) {
            g === void 0 && (g = {});
            const f = g.logEvent, p = g.helpers || l.default, v = g.getFullRemoteSdp || (0, d.default)();
            return {
              sdp: {
                mids: [],
                mediaSections: [],
                headers: [],
                bundle: null,
                version: null,
                tracks: []
              },
              subscribePcIdsByMid: {},
              updateParsedSdp(m) {
                Object.assign(this.sdp, m);
              },
              updateSdpWithNewOffer(m) {
                const y = p.updateSDPWithNewOffer({
                  mediaSections: this.sdp.mediaSections,
                  headers: this.sdp.headers,
                  version: this.sdp.version
                }, m.sdp);
                Object.assign(this.sdp, y);
              },
              setOfferAndCreateAnswer(m) {
                return this.updateSdpWithNewOffer(m), p.createSDP(this.sdp.headers, this.sdp.mediaSections);
              },
              createSdp() {
                return p.createSDP(this.sdp.headers, this.sdp.mediaSections);
              },
              addSubscriberMid(m, y) {
                this.subscribePcIdsByMid[m] = y;
              },
              removeMidAndTrack(m) {
                this.sdp.tracks = this.sdp.tracks.filter((U) => U !== m);
                const y = this.sdp.mids.findIndex((U) => U === m);
                y < 0 || (this.sdp.mids[y] = null, this.sdp.mediaSections[y] = p.getDisabledSectionForMid(m));
              },
              updateSdpHeaders() {
                const m = this.sdp.version + 1;
                this.sdp.headers = p.updateVersion(this.sdp.headers, this.sdp.version, m), this.sdp.version = m, this.sdp.headers = p.updateBundleLine(this.sdp.headers, this.sdp.tracks), this.sdp.bundle = p.getBundleLine(this.sdp.headers);
              },
              processAnswer(m) {
                const y = p.parseMantisSDP(m), U = y.headers, B = y.version, Q = y.mediaSections, N = y.mids, J = y.tracks, w = (0, t.default)(this.sdp.tracks, J);
                w.length && f("peerConnection:spcAnswerMismatch", "Event", w);
                const W = p.updateVersion(this.sdp.headers, this.sdp.version, B);
                return this.sdp.version = B, this.sdp.headers = p.updateIceCredentials(W, U), this.sdp.mediaSections = p.updateFirstEnabledMediaSection(this.sdp, {
                  mediaSections: Q,
                  mids: N
                }), p.createSDP(this.sdp.headers, this.sdp.mediaSections);
              },
              getPartialSdpAnswer(m) {
                if (!this.midsToAdd)
                  return m;
                const y = (0, o.default)(p.parseSDP(m), this.midsToAdd);
                return this.midsToAdd = void 0, p.createSDP(y.headers, y.mediaSections);
              },
              getIceRestartPartialSdp(m) {
                const y = (0, c.default)(p.parseSDP(m));
                return p.createSDP(y.headers, y.mediaSections);
              },
              getPartialSdp(m, y) {
                return m === "answer" ? this.getPartialSdpAnswer(y) : this.getIceRestartPartialSdp(y);
              },
              processOffer(m) {
                this.midsToAdd = (0, t.default)(m.mids, this.sdp.mids);
                const y = v("offer", m, this.sdp);
                return this.updateParsedSdp(y), p.createSDP(y.headers, y.mediaSections);
              },
              removeMids(m) {
                m.forEach((y) => {
                  this.removeMidAndTrack(y), delete this.subscribePcIdsByMid[y];
                }), this.updateSdpHeaders();
              },
              setTrackToInactive(m) {
                const y = this.sdp.mids.findIndex((U) => U === m);
                this.sdp.mediaSections[y] = p.setSubscriberMediaSectionToInactive(this.sdp.mediaSections[y]);
              },
              getHeadMid() {
                return this.sdp.mids.find((m) => m !== null);
              },
              isHead(m) {
                const y = this.getHeadMid();
                return this.subscribePcIdsByMid[y] === m;
              }
            };
          };
          r.default = h;
        },
        /* 796 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(1));
          const o = (0, t.default)("partialSdp");
          var c = (d, u) => {
            o.debug("full answer: ", d);
            const h = d.mediaSections.filter((g) => u.some((p) => g.join("").includes(`a=mid:${p}`))), A = {
              headers: d.headers,
              mediaSections: h
            };
            return o.debug("partial answer: ", A), A;
          };
          r.default = c;
        },
        /* 797 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(1));
          const o = (0, t.default)("partialSdp");
          var c = (d) => {
            o.debug("full offer: ", d);
            const u = d.mids.find((g) => g !== null), h = d.mediaSections.find((g) => g.join("").includes(`a=mid:${u}`)), A = {
              headers: d.headers,
              mediaSections: [h]
            };
            return o.debug("partial offer: ", A), A;
          };
          r.default = c;
        },
        /* 798 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(20)), o = n(e(799)), l = n(e(800)), c = n(e(1));
          const d = (0, c.default)("partialSdp"), u = (g) => g.tracks.length !== g.mids.length;
          var A = function(f) {
            f === void 0 && (f = {});
            const p = f.getMediaSectionsForAnswer || o.default, v = f.getMediaSectionsForOffer || l.default, b = (y, U, B) => {
              let Q;
              return y === "answer" ? Q = p(U, B) : Q = v(U, B), Object.assign({}, U, {
                mediaSections: Q,
                mids: Q.map(t.default.getSectionMid)
              });
            };
            return (y, U, B) => {
              if (!B.bundle || !u(U))
                return U;
              d.debug("partial remote sdp: ", U);
              const Q = b(y, U, B);
              return d.debug("full reconstructed remote sdp: ", Q), b(y, U, B);
            };
          };
          r.default = A;
        },
        /* 799 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(20)), l = (c, d) => {
            const u = c.mids[0], h = d.tracks.slice(0, d.tracks.indexOf(u)).filter((p) => p !== null), A = d.mids.indexOf(u);
            return [...d.mediaSections.slice(0, A).map((p) => {
              const v = t.default.getTrackMids(p), b = v[0];
              return b && h.includes(b) ? t.default.getDisabledSectionForMid(b) : p;
            }), ...c.mediaSections, ...d.mediaSections.slice(A + 1)];
          };
          r.default = l;
        },
        /* 800 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(20)), l = (c, d) => {
            const u = d.mediaSections.map((A) => [...A]);
            let h = 0;
            return c.mediaSections.forEach((A) => {
              for (h; h < u.length; h++) {
                const g = u[h];
                if (t.default.isDisabledMediaSection(g)) {
                  u[h] = A;
                  return;
                }
              }
              u.push(A);
            }), u;
          };
          r.default = l;
        },
        /* 801 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = l;
          var t = n(e(24)), o = n(e(338));
          function l(c) {
            c === void 0 && (c = {});
            const d = c.Session || (0, o.default)(), u = c.sessionObjects || t.default;
            return function(A, g, f) {
              g == null && (g = A, A = null), Array.isArray(g) && g.length === 1 && (g = g[0]);
              let p = u.sessions.get(g);
              return p || (p = new d(A, g, f), u.sessions.add(p)), p;
            };
          }
        },
        /* 802 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(185)), c = n(e(163)), d = n(e(10)), u = n(e(13)), h = n(e(8)), A = n(e(3)), g = n(e(75)), f = n(e(20)), p = n(e(151));
          const v = (0, p.default)(typeof window !== void 0 ? window : Dn), b = (0, u.default)();
          function m(B) {
            return (0, c.default)((0, l.default)(B, ["AV1X", "AV1", "rtx", "red", "ulpfec", "H265", "X-H264UC", "x-ulpfecuc"]));
          }
          var U = /* @__PURE__ */ function() {
            var B = (0, o.default)(/* @__PURE__ */ t.default.mark(function Q() {
              var N, J, w, W, G, Z, K;
              return t.default.wrap(function(O) {
                for (; ; ) switch (O.prev = O.next) {
                  case 0:
                    if (typeof window != "undefined") {
                      O.next = 2;
                      break;
                    }
                    return O.abrupt("return", {
                      videoEncoders: [],
                      videoDecoders: []
                    });
                  case 2:
                    if (N = v.RTCPeerConnection, !(window.RTCRtpSender && "getCapabilities" in window.RTCRtpSender)) {
                      O.next = 7;
                      break;
                    }
                    return J = window.RTCRtpSender.getCapabilities("video").codecs.map((de) => de.mimeType || de.name).map((de) => de.replace("video/", "")), J = m(J), O.abrupt("return", {
                      videoEncoders: J,
                      videoDecoders: J
                    });
                  case 7:
                    if (!(A.default.name === "Chrome" && !("captureStream" in window.HTMLCanvasElement.prototype))) {
                      O.next = 9;
                      break;
                    }
                    return O.abrupt("return", {
                      videoEncoders: ["VP8"],
                      videoDecoders: ["VP8"]
                    });
                  case 9:
                    if (!A.default.isLegacyEdge) {
                      O.next = 11;
                      break;
                    }
                    return O.abrupt("return", {
                      videoEncoders: ["H264", "VP8"],
                      videoDecoders: ["H264", "VP8"]
                    });
                  case 11:
                    return w = window.document.createElement("canvas"), w.getContext("2d"), W = w.captureStream(), O.prev = 14, Z = {
                      iceServers: []
                    }, (0, g.default)() && (Z.sdpSemantics = "plan-b"), G = new N(Z), G.addTrack ? G.addTrack(W.getVideoTracks()[0], W) : G.addStream && G.addStream(W), O.next = 21, G.createOffer();
                  case 21:
                    return K = O.sent, J = f.default.getCodecs(K.sdp, "video") || [], J = m(J), O.abrupt("return", {
                      videoEncoders: J,
                      videoDecoders: J
                    });
                  case 27:
                    throw O.prev = 27, O.t0 = O.catch(14), b(h.default.UNABLE_TO_ACCESS_MEDIA_ENGINE, new Error("OT.getSupportedCodecs was not able to get the list of supported codecs"), d.default.UNABLE_TO_ACCESS_MEDIA_ENGINE);
                  case 30:
                    return O.prev = 30, G.close(), O.finish(30);
                  case 33:
                  case "end":
                    return O.stop();
                }
              }, Q, null, [[14, 27, 30, 33]]);
            }));
            return function() {
              return B.apply(this, arguments);
            };
          }();
          r.default = U;
        },
        /* 803 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(335)), o = t.default.isSupported;
          r.default = o;
        },
        /* 804 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(112)), o = t.default;
          r.default = o;
        },
        /* 805 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = c;
          var t = n(e(21));
          const o = (0, t.default)(), l = o.getInputMediaDevices;
          function c(d) {
            l().then((u) => d(void 0, u), d);
          }
        },
        /* 806 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(21)), c = n(e(13)), d = n(e(8)), u = n(e(350)), h = n(e(352)), A = function(f) {
            f === void 0 && (f = {});
            const p = f.deviceHelpers || (0, l.default)(), v = p.hasAudioOutputApiSupport, b = p.hasDevice, m = f.getAudioOutputDevices || u.default, y = f.updateSubscribersSinkId || h.default, U = (0, c.default)();
            return /* @__PURE__ */ function() {
              var Q = (0, o.default)(/* @__PURE__ */ t.default.mark(function N(J) {
                var w, W;
                return t.default.wrap(function(Z) {
                  for (; ; ) switch (Z.prev = Z.next) {
                    case 0:
                      if (v()) {
                        Z.next = 2;
                        break;
                      }
                      throw U(d.default.UNSUPPORTED_BROWSER, new Error("setAudioOutputDevice is not supported in your browser."));
                    case 2:
                      return Z.next = 4, m();
                    case 4:
                      if (w = Z.sent, W = b(w, J), W) {
                        Z.next = 8;
                        break;
                      }
                      throw U(d.default.INVALID_AUDIO_OUTPUT_SOURCE, new Error("The requested device is not valid."));
                    case 8:
                      return Z.prev = 8, Z.next = 11, y(J);
                    case 11:
                      Z.next = 16;
                      break;
                    case 13:
                      throw Z.prev = 13, Z.t0 = Z.catch(8), U(d.default.REQUESTED_DEVICE_PERMISSION_DENIED, new Error("No permission to use the requested device."));
                    case 16:
                    case "end":
                      return Z.stop();
                  }
                }, N, null, [[8, 13]]);
              }));
              return function(J) {
                return Q.apply(this, arguments);
              };
            }();
          };
          r.default = A;
        },
        /* 807 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(21)), c = n(e(808));
          const d = (0, c.default)(), u = (0, l.default)(), h = u.hasAudioOutputApiSupport, A = u.getNativeMediaDevices;
          var g = () => {
            if (h()) {
              const f = A();
              let p = !1;
              f.addEventListener("devicechange", /* @__PURE__ */ (0, o.default)(/* @__PURE__ */ t.default.mark(function v() {
                return t.default.wrap(function(m) {
                  for (; ; ) switch (m.prev = m.next) {
                    case 0:
                      if (!p) {
                        m.next = 2;
                        break;
                      }
                      return m.abrupt("return");
                    case 2:
                      return p = !0, m.next = 5, d();
                    case 5:
                      p = !1;
                    case 6:
                    case "end":
                      return m.stop();
                  }
                }, v);
              })));
            }
          };
          r.default = g;
        },
        /* 808 */
        /***/
        function(i, r, e) {
          var n = e(0);
          r.__esModule = !0, r.default = void 0;
          var t = n(e(4)), o = n(e(5)), l = n(e(1)), c = n(e(104)), d = n(e(21)), u = n(e(352)), A = function(f) {
            f === void 0 && (f = {});
            const p = f.deviceHelpers || (0, d.default)(), v = p.getAudioOutputMediaDevices, b = p.getDefaultAudioOutputDeviceId, m = p.hasDevice, y = f.currentAudioOutputDevice || c.default, U = y.getCurrentAudioOutputDeviceId, B = y.setCurrentAudioOutputDeviceId, Q = f.updateSubscribersSinkId || u.default, N = f.logging || (0, l.default)("currentAudioOutputDevice");
            return /* @__PURE__ */ function() {
              var w = (0, o.default)(/* @__PURE__ */ t.default.mark(function W() {
                var G, Z, K;
                return t.default.wrap(function(O) {
                  for (; ; ) switch (O.prev = O.next) {
                    case 0:
                      return O.next = 2, v();
                    case 2:
                      if (G = O.sent, G.length !== 0) {
                        O.next = 6;
                        break;
                      }
                      return B(""), O.abrupt("return");
                    case 6:
                      if (Z = m(G, U()), !Z) {
                        O.next = 9;
                        break;
                      }
                      return O.abrupt("return");
                    case 9:
                      return K = b(G), B(K), O.prev = 11, O.next = 14, Q(K);
                    case 14:
                      O.next = 19;
                      break;
                    case 16:
                      O.prev = 16, O.t0 = O.catch(11), N.debug("Failed to set the default audio output device.", O.t0);
                    case 19:
                    case "end":
                      return O.stop();
                  }
                }, W, null, [[11, 16]]);
              }));
              return function() {
                return w.apply(this, arguments);
              };
            }();
          };
          r.default = A;
        },
        /* 809 */
        /***/
        function(i, r, e) {
          var n = e(810);
          typeof n == "string" && (n = [[i.i, n, ""]]);
          var t, o = { hmr: !0 };
          o.transform = t, o.insertInto = void 0, e(824)(n, o), n.locals && (i.exports = n.locals);
        },
        /* 810 */
        /***/
        function(i, r, e) {
          r = i.exports = e(811)(!1);
          var n = e(812), t = n(e(813)), o = n(e(814)), l = n(e(815)), c = n(e(816)), d = n(e(817)), u = n(e(818)), h = n(e(819)), A = n(e(820)), g = n(e(821)), f = n(e(822)), p = n(e(823));
          r.push([i.i, `/*!
 * Copyright (c) 2017 TokBox, Inc.
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 */

/**
 * OT Base styles
 */

/* Root OT object, this is where our CSS reset happens */
.OT_root,
.OT_root * {
  color: #ffffff;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-family: Arial, Helvetica, sans-serif;
  vertical-align: baseline;
}

/**
 * Specific Element Reset
 */

.OT_root h1,
.OT_root h2,
.OT_root h3,
.OT_root h4,
.OT_root h5,
.OT_root h6 {
  color: #ffffff;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 100%;
  font-weight: bold;
}

.OT_root header {

}

.OT_root footer {

}

.OT_root div {

}

.OT_root section {

}

.OT_root video {

}

.OT_root button {

}

.OT_root strong {
  font-weight: bold;
}

.OT_root em {
  font-style: italic;
}

.OT_root a,
.OT_root a:link,
.OT_root a:visited,
.OT_root a:hover,
.OT_root a:active {
  font-family: Arial, Helvetica, sans-serif;
}

.OT_root ul, .OT_root ol {
  margin: 1em 1em 1em 2em;
}

.OT_root ol {
  list-style: decimal outside;
}

.OT_root ul {
  list-style: disc outside;
}

.OT_root dl {
  margin: 4px;
}

.OT_root dl dt,
.OT_root dl dd {
  float: left;
  margin: 0;
  padding: 0;
}

.OT_root dl dt {
  clear: left;
  text-align: right;
  width: 50px;
}

.OT_root dl dd {
  margin-left: 10px;
}

.OT_root img {
  border: 0 none;
}

/* Modal dialog styles */

/* Modal dialog styles */

.OT_dialog-centering {
  display: table;
  width: 100%;
  height: 100%;
}

.OT_dialog-centering-child {
  display: table-cell;
  vertical-align: middle;
}

.OT_dialog {
  position: relative;

  box-sizing: border-box;
  max-width: 576px;
  margin-right: auto;
  margin-left: auto;
  padding: 36px;
  text-align: center; /* centers all the inline content */

  background-color: #363636;
  color: #fff;
  box-shadow: 2px 4px 6px #999;
  font-family: 'Didact Gothic', sans-serif;
  font-size: 13px;
  line-height: 1.4;
}

.OT_dialog * {
  font-family: inherit;
  box-sizing: inherit;
}

.OT_closeButton {
  color: #999999;
  cursor: pointer;
  font-size: 32px;
  line-height: 36px;
  position: absolute;
  right: 18px;
  top: 0;
}

.OT_dialog-messages {
  text-align: center;
}

.OT_dialog-messages-main {
  margin-bottom: 36px;
  line-height: 36px;

  font-weight: 300;
  font-size: 24px;
}

.OT_dialog-messages-minor {
  margin-bottom: 18px;

  font-size: 13px;
  line-height: 18px;
  color: #A4A4A4;
}

.OT_dialog-messages-minor strong {
  color: #ffffff;
}

.OT_dialog-actions-card {
  display: inline-block;
}

.OT_dialog-button-title {
  margin-bottom: 18px;
  line-height: 18px;

  font-weight: 300;
  text-align: center;
  font-size: 14px;
  color: #999999;
}
.OT_dialog-button-title label {
  color: #999999;
}

.OT_dialog-button-title a,
.OT_dialog-button-title a:link,
.OT_dialog-button-title a:active {
  color: #02A1DE;
}

.OT_dialog-button-title strong {
  color: #ffffff;
  font-weight: 100;
  display: block;
}

.OT_dialog-button {
  display: inline-block;

  margin-bottom: 18px;
  padding: 0 1em;

  background-color: #1CA3DC;
  text-align: center;
  cursor: pointer;
}

.OT_dialog-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.OT_dialog-button-large {
  line-height: 36px;
  padding-top: 9px;
  padding-bottom: 9px;

  font-weight: 100;
  font-size: 24px;
}

.OT_dialog-button-small {
  line-height: 18px;
  padding-top: 9px;
  padding-bottom: 9px;

  background-color: #444444;
  color: #999999;
  font-size: 16px;
}

.OT_dialog-progress-bar {
  display: inline-block; /* prevents margin collapse */
  width: 100%;
  margin-top: 5px;
  margin-bottom: 41px;

  border: 1px solid #4E4E4E;
  height: 8px;
}

.OT_dialog-progress-bar-fill {
  height: 100%;

  background-color: #29A4DA;
}

/* Helpers */

.OT_centered {
  position: fixed;
  left: 50%;
  top: 50%;
  margin: 0;
}

.OT_dialog-hidden {
  display: none;
}

.OT_dialog-button-block {
  display: block;
}

.OT_dialog-no-natural-margin {
  margin-bottom: 0;
}

/* Publisher and Subscriber styles */

.OT_publisher, .OT_subscriber {
  position: relative;
  min-width: 48px;
  min-height: 48px;
}

.OT_publisher .OT_video-element,
.OT_subscriber .OT_video-element {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;

  transform-origin: 0 0;
}

/* Styles that are applied when the video element should be mirrored */
.OT_publisher.OT_mirrored .OT_video-element {
  transform: scale(-1, 1);
  transform-origin: 50% 50%;
}

.OT_subscriber_error {
  background-color: #000;
  color: #fff;
  text-align: center;
}

.OT_subscriber_error > p {
  padding: 20px;
}

/* The publisher/subscriber name/mute background */
.OT_publisher .OT_bar,
.OT_subscriber .OT_bar,
.OT_publisher .OT_name,
.OT_subscriber .OT_name,
.OT_publisher .OT_archiving,
.OT_subscriber .OT_archiving,
.OT_publisher .OT_archiving-status,
.OT_subscriber .OT_archiving-status,
.OT_publisher .OT_archiving-light-box,
.OT_subscriber .OT_archiving-light-box {
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  height: 34px;
  position: absolute;
}

.OT_publisher .OT_bar,
.OT_subscriber .OT_bar {
  background: rgba(0, 0, 0, 0.4);
}

.OT_publisher .OT_edge-bar-item,
.OT_subscriber .OT_edge-bar-item {
  z-index: 1; /* required to get audio level meter underneath */
}

/* The publisher/subscriber name panel/archiving status bar */
.OT_publisher .OT_name,
.OT_subscriber .OT_name {
  background-color: transparent;
  color: #ffffff;
  font-size: 15px;
  line-height: 34px;
  font-weight: normal;
  padding: 0 4px 0 36px;
  letter-spacing: normal;
}

.OT_publisher .OT_archiving-status,
.OT_subscriber .OT_archiving-status {
  background: rgba(0, 0, 0, 0.4);
  top: auto;
  bottom: 0;
  left: 34px;
  padding: 0 4px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
  line-height: 34px;
  font-weight: normal;
  letter-spacing: normal;
}

.OT_micro .OT_archiving-status,
.OT_micro:hover .OT_archiving-status,
.OT_mini .OT_archiving-status,
.OT_mini:hover .OT_archiving-status {
  display: none;
}

.OT_publisher .OT_archiving-light-box,
.OT_subscriber .OT_archiving-light-box {
  background: rgba(0, 0, 0, 0.4);
  top: auto;
  bottom: 0;
  right: auto;
  width: 34px;
  height: 34px;
}

.OT_archiving-light {
  width: 7px;
  height: 7px;
  border-radius: 30px;
  position: absolute;
  top: 14px;
  left: 14px;
  background-color: #575757;
  box-shadow: 0 0 5px 1px #575757;
}

.OT_archiving-light.OT_active {
  background-color: #970d13;
  -webkit-animation: OT_pulse 1.3s ease-in;
  -moz-animation: OT_pulse 1.3s ease-in;
  -webkit-animation: OT_pulse 1.3s ease-in;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
}

.OT_mini .OT_bar,
.OT_bar.OT_mode-mini,
.OT_bar.OT_mode-mini-auto {
  bottom: 0;
  height: auto;
}

.OT_mini .OT_name.OT_mode-off,
.OT_mini .OT_name.OT_mode-on,
.OT_mini .OT_name.OT_mode-auto,
.OT_mini:hover .OT_name.OT_mode-auto {
  display: none;
}

.OT_publisher .OT_name,
.OT_subscriber .OT_name {
    left: 10px;
    right: 37px;
    height: 34px;
    padding-left: 0;
}

.OT_publisher .OT_mute,
.OT_subscriber .OT_mute {
    border: none;
    cursor: pointer;
    display: block;
    position: absolute;
    text-align: center;
    text-indent: -9999em;
    background-color: transparent;
    background-repeat: no-repeat;
}

.OT_publisher .OT_mute,
.OT_subscriber .OT_mute {
  right: 0;
  top: 0;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  height: 36px;
  width: 37px;
}

.OT_mini .OT_mute,
.OT_publisher.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold,
.OT_subscriber.OT_mini .OT_mute.OT_mode-auto.OT_mode-on-hold {
  top: 50%;
  left: 50%;
  right: auto;
  margin-top: -18px;
  margin-left: -18.5px;
  border-left: none;
}

.OT_publisher .OT_mute {
  background-image: url(` + t + `);
  background-position: 9px 5px;
}

.OT_publisher .OT_mute.OT_active {
  background-image: url(` + o + `);
  background-position: 9px 4px;
}

.OT_subscriber .OT_mute {
  background-image: url(` + l + `);
  background-position: 8px 7px;
}

.OT_subscriber .OT_mute.OT_active {
  background-image: url(` + c + `);
  background-position: 7px 7px;
}

/**
 * Styles for display modes
 *
 * Note: It's important that these completely control the display and opacity
 * attributes, no other selectors should atempt to change them.
 */

/* Default display mode transitions for various chrome elements */
.OT_publisher .OT_edge-bar-item,
.OT_subscriber .OT_edge-bar-item {
  transition-property: top, bottom, opacity;
  transition-duration: 0.5s;
  transition-timing-function: ease-in;
}

.OT_publisher .OT_edge-bar-item.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_mode-off,
.OT_publisher .OT_edge-bar-item.OT_mode-auto,
.OT_subscriber .OT_edge-bar-item.OT_mode-auto,
.OT_publisher .OT_edge-bar-item.OT_mode-mini-auto,
.OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {
  top: -25px;
  opacity: 0;
}

.OT_publisher .OT_edge-bar-item.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_mode-off {
  display: none;
}

.OT_mini .OT_mute.OT_mode-auto,
.OT_publisher .OT_mute.OT_mode-mini-auto,
.OT_subscriber .OT_mute.OT_mode-mini-auto {
  top: 50%;
}

.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-off,
.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,
.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-mini-auto {
  top: auto;
  bottom: -25px;
}

.OT_publisher .OT_edge-bar-item.OT_mode-on,
.OT_subscriber .OT_edge-bar-item.OT_mode-on,
.OT_publisher .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,
.OT_subscriber .OT_edge-bar-item.OT_mode-auto.OT_mode-on-hold,
.OT_publisher:hover .OT_edge-bar-item.OT_mode-auto,
.OT_subscriber:hover .OT_edge-bar-item.OT_mode-auto,
.OT_publisher:hover .OT_edge-bar-item.OT_mode-mini-auto,
.OT_subscriber:hover .OT_edge-bar-item.OT_mode-mini-auto {
  top: 0;
  opacity: 1;
}

.OT_mini .OT_mute.OT_mode-on,
.OT_mini:hover .OT_mute.OT_mode-auto,
.OT_mute.OT_mode-mini,
.OT_root:hover .OT_mute.OT_mode-mini-auto {
  top: 50%;
}

.OT_publisher .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,
.OT_subscriber .OT_edge-bar-item.OT_edge-bottom.OT_mode-on,
.OT_publisher:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto,
.OT_subscriber:hover .OT_edge-bar-item.OT_edge-bottom.OT_mode-auto {
  top: auto;
  bottom: 0;
  opacity: 1;
}


/* Contains the video element, used to fix video letter-boxing */
.OT_widget-container {
  position: absolute;
  background: linear-gradient(60.08deg, #333333 0%, #1A1A1A 100%);
  overflow: hidden;
}

.OT_hidden-audio {
  position: absolute !important;
  height: 1px !important;
  width: 1px !important;
}

/* Load animation */
.OT_root .OT_video-loading {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: none;

  background-color: rgba(0, 0, 0, .75);
}

.OT_root .OT_video-loading .OT_video-loading-spinner {
  background: url(` + d + `) no-repeat;
  position: absolute;
  width: 32px;
  height: 32px;
  left: 50%;
  top: 50%;
  margin-left: -16px;
  margin-top: -16px;
  animation: OT_spin 2s linear infinite;
}
@keyframes OT_spin {
  100% {
    transform: rotate(360deg);
  }
}

.OT_publisher.OT_loading .OT_video-loading,
.OT_subscriber.OT_loading .OT_video-loading {
  display: block;
}

.OT_publisher.OT_loading .OT_video-element,
.OT_subscriber.OT_loading .OT_video-element {
  /*display: none;*/
}

.OT_video-centering {
  display: table;
  width: 100%;
  height: 100%;
}

.OT_video-container {
  display: table-cell;
  vertical-align: middle;
}

.OT_video-poster {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: none;

  opacity: 1.0;

  background-repeat: no-repeat;
  background-image: url(` + u + `);
  background-size: auto 55%;
}

.OT_fit-mode-cover .OT_video-element {
  object-fit: cover;
}

/* Workaround for iOS freezing issue when cropping videos */
/* https://bugs.webkit.org/show_bug.cgi?id=176439 */
@media only screen
  and (orientation: portrait) {
  .OT_subscriber.OT_ForceContain.OT_fit-mode-cover .OT_video-element {
    object-fit: contain !important;
  }
}

.OT_fit-mode-contain .OT_video-element {
  object-fit: contain;
}

.OT_fit-mode-cover .OT_video-poster {
  background-position: center;
}

.OT_fit-mode-contain .OT_video-poster {
  background-position: center;
}

.OT_audio-level-meter {
  position: absolute;
  width: 25%;
  max-width: 224px;
  min-width: 21px;
  top: 0;
  right: 0;
  overflow: hidden;
}

.OT_audio-level-meter:before {
  /* makes the height of the container equals its width */
  content: '';
  display: block;
  padding-top: 100%;
}

.OT_audio-level-meter__audio-only-img {
  position: absolute;
  top: 22%;
  right: 15%;
  width: 40%;

  opacity: .7;

  background: url(` + h + `) no-repeat center;
}

.OT_audio-level-meter__audio-only-img:before {
  /* makes the height of the container equals its width */
  content: '';
  display: block;
  padding-top: 100%;
}

.OT_audio-level-meter__value {
  will-change: transform;
  position: absolute;
  top: -100%;
  right: -100%;
  width: 200%;
  height: 200%;
  transform: scale(0);
  border-radius: 50%;
  background-image: radial-gradient(circle, rgba(151, 206, 0, 1) 0%, rgba(151, 206, 0, 0) 100%);
}

.OT_audio-level-meter.OT_mode-off {
    display: none;
}

.OT_audio-level-meter.OT_mode-on,
.OT_audio-only .OT_audio-level-meter.OT_mode-auto {
  display: block;
}

.OT_audio-only.OT_publisher .OT_video-element,
.OT_audio-only.OT_subscriber .OT_video-element {
  display: none;
}


.OT_video-disabled-indicator {
  opacity: 1;
  border: none;
  display: none;
  position: absolute;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: bottom right;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 3px;
  right: 3px;
}

.OT_video-disabled {
  background-image: url(` + A + `);
  background-size: 33px auto;
}

.OT_video-disabled-warning {
  background-image: url(` + g + `);
  background-size: 33px auto;
}

.OT_video-disabled-indicator.OT_active {
  display: block;
}

.OT_audio-blocked-indicator {
  opacity: 1;
  border: none;
  display: none;
  position: absolute;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.OT_audio-blocked {
  background-image: url(` + f + `);
  background-size: 90px auto;
}

.OT_container-audio-blocked {
  cursor: pointer;
}

.OT_container-audio-blocked.OT_mini .OT_edge-bar-item {
  display: none;
}

.OT_container-audio-blocked .OT_mute {
  display: none;
}

.OT_audio-blocked-indicator.OT_active {
  display: block;
}

.OT_video-unsupported {
  opacity: 1;
  border: none;
  display: none;
  position: absolute;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(` + p + `);
  background-size: 58px auto;
  pointer-events: none;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin-top: -30px;
}

.OT_video-unsupported-bar {
  display: none;
  position: absolute;
  width: 192%; /* copy the size of the audio meter bar for symmetry */
  height: 192%;
  top: -96% /* half of the size */;
  left: -96%;
  border-radius: 50%;

  background-color: rgba(0, 0, 0, .8);
}

.OT_video-unsupported-img {
  display: none;
  position: absolute;
  top: 11%;
  left: 15%;
  width: 70%;
  opacity: .7;
  background-image: url(` + p + `);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
}

.OT_video-unsupported-img:before {
  /* makes the height of the container 93% of its width (90/97 px) */
  content: '';
  display: block;
  padding-top: 93%;
}

.OT_video-unsupported-text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  margin-top: 40px;
}

.OT_video-unsupported.OT_active {
  display: block;
}

.OT_mini .OT_video-unsupported,
.OT_micro .OT_video-unsupported {
  position: absolute;
  width: 25%;
  max-width: 224px;
  min-width: 21px;
  top: 0;
  left: 0;
  overflow: hidden;
  background: none;
  bottom: auto;
  right: auto;
  margin: auto;
}

.OT_mini .OT_video-unsupported:before,
.OT_micro .OT_video-unsupported:before {
  /* makes the height of the container equals its width */
  content: '';
  display: block;
  padding-top: 100%;
}

.OT_mini .OT_video-unsupported-bar,
.OT_micro .OT_video-unsupported-bar,
.OT_mini .OT_video-unsupported-img,
.OT_micro .OT_video-unsupported-img {
  display: block;
}

.OT_mini .OT_video-unsupported-text,
.OT_micro .OT_video-unsupported-text {
  display: none;
}

.OT_hide-forced {
  display: none;
}

.OT_ModalDialog {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.2);
}

#tb_alert {
  position: fixed;
  width: 570px;
  font-family: "Lucida Grande", Arial;
  top: 50%;
  left: 50%;
  margin-top: -75px;
  margin-left: -285px;
}

#tb_alert * {
  box-sizing: border-box;
}

#tb_alert .OT_alert {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: #333;
  position: relative;
  padding: 30px;
  overflow: visible;
  margin-left: 70px;
  border-bottom-color: rgba(255, 255, 255, 0.1);
  border-left-color: rgba(255, 255, 255, 0.1);

  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));

  background-image: -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2)), -ms-linear-gradient(45deg, rgba(0, 0, 0, 0.2) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0.2));

  background-size: 4px 4px;
  background-position: 0 0, 2px 2px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

#tb_alert .OT_alert-exclamation {
  background-color: #9c1408;
  background-image: linear-gradient(0deg, #dd0c0a 0%, #9c1408 100%);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);

  margin: -1px 0;

  font-family: MS Trebuchet;
  font-weight: bold;
  font-size: 60px;
  text-shadow: -1px -1px 2px rgba(0, 0, 0, 0.5);

  color: white;
  width: 65px;
  position: absolute;
  padding: 42px 0;
  text-align: center;
  left: -70px;
  top: 0;
  bottom: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;

  border-bottom-color: transparent;
  border-left: none;
  border-right: none;
}

#tb_alert .OT_alert-exclamation:after,
#tb_alert .OT_alert-exclamation:before {
  content: " ";
  position: absolute;
  right: -24px;
  top: 40%;
  border: 12px solid transparent;
  border-left-color: #9c1408;
}

#tb_alert .OT_alert-exclamation:before {
  border-left-color: #bc3428;
  top: 39%;
}

#tb_alert .OT_alert-body {
  color: #c8c5c5;
  margin: 0;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);
  font-size: 14px;
  line-height: 1.3em;
}

#tb_alert .continue-text {
  margin-top: 12px
}

#tb_alert > * a {
  color: #a7d8df;
  text-decoration: none;
}

#tb_alert .OT_alert-header {
  font-size: 24px;
  padding-bottom: 5px;
  color: #aaa;
  font-weight: bold;
  position: relative;
  text-shadow: 0 2px 0 rgba(0, 0, 0, 0.3);
  margin: 0;
}

#tb_alert .OT_alert-header::before {
  content: attr(data-text);
  position: absolute;
  left: 0;
  color: white;
  -webkit-mask-image: -webkit-gradient(
    linear,
    left top, left bottom,
    from(rgba(0, 0, 0, 1)),
    color-stop(60%, rgba(0, 0, 0, 0)),
    to(rgba(0, 0, 0, 0))
  );
}

#tb_alert .OT_alert-close-button {
  position: absolute;
  right: 8px;
  top: 5px;
  background-color: #000;
  color: #666;
  border: none;
  font-size: 20px;
  /** Hack to bring it up to the proper line top */
  line-height: 14px;
  padding: 0;
  padding-bottom: 3px;
  cursor: pointer;
}

#tb_alert #section-mobile-browser,
#tb_alert #section-supported-mobile-browser {
  width: 200px;
  top: 0px;
  left: 25%;
  margin-top: 0;
  margin-left: 0;
}

@media all and (max-height: 300px) {
  #tb_alert {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    margin-left: 0;
    margin-top: 0;
  }
  #tb_alert #section-mobile-browser,
  #tb_alert #section-supported-mobile-browser {
    margin-left: 0;
    margin-top: 10px;
    left: 0;
  }
}

#tb_alert #section-normal-install,
#tb_alert #section-upgrade-install,
#tb_alert #section-mobile-browser,
#tb_alert #section-supported-mobile-browser {
  display: none;
}
`, ""]);
        },
        /* 811 */
        /***/
        function(i, r, e) {
          i.exports = function(o) {
            var l = [];
            return l.toString = function() {
              return this.map(function(d) {
                var u = n(d, o);
                return d[2] ? "@media " + d[2] + "{" + u + "}" : u;
              }).join("");
            }, l.i = function(c, d) {
              typeof c == "string" && (c = [[null, c, ""]]);
              for (var u = {}, h = 0; h < this.length; h++) {
                var A = this[h][0];
                A != null && (u[A] = !0);
              }
              for (h = 0; h < c.length; h++) {
                var g = c[h];
                (g[0] == null || !u[g[0]]) && (d && !g[2] ? g[2] = d : d && (g[2] = "(" + g[2] + ") and (" + d + ")"), l.push(g));
              }
            }, l;
          };
          function n(o, l) {
            var c = o[1] || "", d = o[3];
            if (!d)
              return c;
            if (l && typeof btoa == "function") {
              var u = t(d), h = d.sources.map(function(A) {
                return "/*# sourceURL=" + d.sourceRoot + A + " */";
              });
              return [c].concat(h).concat([u]).join(`
`);
            }
            return [c].join(`
`);
          }
          function t(o) {
            var l = btoa(unescape(encodeURIComponent(JSON.stringify(o)))), c = "sourceMappingURL=data:application/json;charset=utf-8;base64," + l;
            return "/*# " + c + " */";
          }
        },
        /* 812 */
        /***/
        function(i, r, e) {
          i.exports = function(t, o) {
            return typeof t != "string" ? t : (/^['"].*['"]$/.test(t) && (t = t.slice(1, -1)), /["'() \t\n]/.test(t) || o ? '"' + t.replace(/"/g, '\\"').replace(/\n/g, "\\n") + '"' : t);
          };
        },
        /* 813 */
        /***/
        function(i, r) {
          i.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAMAAAC02HQrAAAA1VBMVEUAAAD3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pn3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj3+Pj39/j3+Pj3+Pn4+Pk/JRMlAAAAQ3RSTlMABAUHCQoLDhAQERwdHiAjLjAxOD9ASFBRVl1mbnZ6fH2LjI+QkaWqrrC1uLzAwcXJycrL1NXj5Ofo6u3w9fr7/P3+d4M3+QAAAQBJREFUGBlVwYdCglAABdCLlr5Unijm3hMUtBzlBLSr//9JgUToOQgVJgceJgU8aHgMeA38K50ZOpcQmTPwcyXn+JM8M3JJIqQypiIkeXelTyIkGZPwKS1NMia1lgKTVkaE3oQQGYsmHNqSMWnTgUFbMiZtGlD2dpaxrL1XgM0i4ZK8MeAmFhsAs29MGZniawagS63oMOQUNXYB5D0D1RMDpyoMLw/fiE2og/V+PVDR5AiBl0/2Uwik+vx4xV3a5G5Ye68Nd1czjUjZckm6VhmPciRzeCZICjwTJAViQq+3e+St167rAoHK8sLYZVkBYPCZAZ/eGa+2R5LH7Wrc0YFf/O9J3yBDFaoAAAAASUVORK5CYII=";
        },
        /* 814 */
        /***/
        function(i, r) {
          i.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAADcElEQVRIiaWVXWhcRRTHf7NNd2aDtUKMIjTpg4ufFIuiUOmDEWm0Vi3VYhXRqIggQh4sWJFSig9+oOhTKSpIRUWMIBIr2kptoTbgU6ooxCiIjR+14kcJmf9sNceHnd3ebnc3Uv9wuXfOzPzmnDMz5zozGwdWAbc65w5RUJQ8cC2wDJgFJioh/MJCMrNxq2vOzK4HmIvRRemxKP0RJWt53o7S+d2Yzsx6gQ+AIUDAnUqpBLzXZd4RYFUlhB/bdZacc3PAOmAcCMC7wfvFwLNdoAPAyx09bXyYWRl4E7gDmAdGlNKFwLYu8GolhO9O87RJd64GbMrgEvB68P4osMWdXLtVV7czlooNpVRWSs8DO7NpR/B+3rBHsvetCgtCMTxwQCm9BbyQrc8F7/uBex3uRCeXO0PrUZ4NfKyUPgWeyj3bg/crDNsIRGwBaJQGorQ3Svdn2wHgc2BUKb0DPJHtjwfvbwRucc7tz+N+i9LFUdoXpfVN36I0CVwBTFI/q9e1LPxT8P4qYEdu70q12mYzWw1MYQzjeJF6zq+shHC4B7jklOBPP/TzSunh4P0DwKvAfb5c9krpe+CcwsEoZdbhEvBM9wxRAl5RShcA9wAngE3B+8tLpdLuwrhp4MNmK0pfRWkySr7NXS8+L5nZbWZWy/Vin1IaitJnUTqvwevJ71lgSSWEFKUfHG7Q2m/xqFJaGry/GXgfGPLl8mJgrXPur2JoUC8Qy3OpG+sAbGhEKT0ErAWOA6uBPWbW1wr9BOgFbgKezot0kAPYqJQA1gC/A9cA+82svzksSn1R+jNKX0SpnM/e1x3yqig92JhrZivM7FjO8bSZLSuCR/Ok16K0KMNHojQWpYko7Y7S1igN5PE3ROl4lNaZ2UVmNpPBU01orvZvZPCeKFXbBR+lEKVtUapFaSZKg9njqpl9aWYTrmXCImA7sCWb9lK/jj9TrwkrgA1AH3AQuKsSwkzbrLfxpgpsBtYDxf/R3xm2ExirhNCuHHZXTsmRwiat+S/zSt06eysVA/4pmGr/G3qm6ik28v29FKgCg8BS6pvS0KNRGgZ+Bb4FpsxsOkfUlMuwDcBWYOUZOHYM2AU8WQmhBifDv70O7PjX7KZ+4G7g3FM8zd6uBIaBy4AqxnIcZwFLCovPAhE4Sj38b4BDwEeVEFKD9S94Khjn486v3QAAAABJRU5ErkJggg==";
        },
        /* 815 */
        /***/
        function(i, r) {
          i.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABx0lEQVQ4jaWUv48NURiGn3ONmCs32ZBd28ht1gqyZAkF21ylQkEiSp2ehpDlD1BoFGqqVdJohYKI7MaPxMoVNghCWMF+7ybLUewnOXfcMWO9yeQ857zne8+XmZOBGjJpr0kvTIomvTZpS526UCO4DUwD64FjwCFgqZnnR+oc8LfgzKQ73vGsr42ZtGjSQFV9o8KfBCacZwCaef4YmAf2rzjcpN3A2WSpm/AssKcqPDNpDBjs410CViXzTwk/A7b1C4wxDgOngAsZcAXY2buDfp/6S4F3lDS8DjgBzDWAjX/Y/e/QgYS/AhsKHa+OMQ6GEJ4Cj4BOAxgq6aCowyZtdf4OtAr+FHDO+R4wWnVbihr3cQnICt4boO38GWj9a/icjwOACt4m4K3zEPA+AxaAtTWCnwN3lzHkEL8V/OPAGud9wK2GF9XR1Wae/1zG2AI+pGYI4VUIoRtjHAc2A9cz4LRPevYCZ+i9/4sJt4GXJU10gaPAzdI2TTro/5Tfz8XEe2LSZGmxq/SDNvP8BnA5WRrx4BwYBe6vONx1EnjovGvBLAAd4Adwuyq8UiaNmDTvr+a8SQ9MuvbfwckBHZPe+QEfTdpep+4XZmPBHiHgz74AAAAASUVORK5CYII=";
        },
        /* 816 */
        /***/
        function(i, r) {
          i.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAACtklEQVQ4jZ2VSYiURxTHf+/T9Nc9iRrBuYySmIsXUU9iFMEFERRBvAjJLUQi5ioiHvSScfTmgqC4XAT1ZIgLuJHkICaaQAgKI2hAUBT30bjUq7bbv4eukXK029F3+eqtv/fqK6qQdEnSNUmT6CDB/bvgfjO4N9zj2RD8007xg1IABkwEzkma0qb4PGAPMBZYLtSD8eNwAEjqTlNI0gNJM4YU7w7ut4O7gvuhZFsR3C8NC5BBLiTIY0mzM8AvqbiC++pk+zLpE95XuwAws3vAQuBPYDRwWtL84P4tsDSLv5oaug4EYOawAMF9jMdoLxqNZcDvQA04UVYqL4G/svj7AF21mhJscrvCksYBFO7xc2AAGGg2mrdjvf4rcAyomNn+slLZmUEGBgsYdh945xZJmgvckDSrEJpK6ySBgV6q12O8ABwGPjGzfWWlsjdN9rpjoSfA+DYDXARGAksK4Is3XC1Ub4z1f4CDQGFmu6tleQSYk0U+p7WVeefLJc00s4fAeWB6Qeunvj0m2ugx9gO7kmlrtSxvBfcy6fXUZS6rgG/S+jLQUwCVNmMC9HqM14EtSe+rluWazN8YEv8IqKZ1E1qnaIDO0ucx3gX6kv6TpM3AM+D/IbGjgP60/gq4WQA33gMA2OQxPgHWJX1ttSwL4FAeZGYLgB2SasBs4A8L7qOBf9M0uXQB3a+TMYSmVctyDrA9mfcBK82smSdKWgCcAaa1bTm4fxbc/8uuCQX3RanAD5Ka6Wo5IGnE0HxJPZ03pQX5Org3MsD3AO5xXLPZXJ9BjkrqdFg6QjZkgG3Jtsw93pG0VFI9QU5K6voYQBHcTydAfwheBI9HgvvPAJIWS3qeIL9JGvUxkO7gfi1BrqTvwkG/pPmSnibIqTzXPgAyEVgBjAEu1qrVPbk/PVTHgb/NbPGg/RVIzOQqzSTBaQAAAABJRU5ErkJggg==";
        },
        /* 817 */
        /***/
        function(i, r) {
          i.exports = "data:image/svg+xml;base64,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";
        },
        /* 818 */
        /***/
        function(i, r) {
          i.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMjMuNSIgY3k9IjIzLjUiIHI9IjIzLjUiIGZpbGw9IiMwMDAiLz48cGF0aCBkPSJNMjcuNjM0IDE4LjUwOGE0LjMwNCA0LjMwNCAwIDExLTguNjA5IDAgNC4zMDQgNC4zMDQgMCAwMTguNjA5IDB6bTQuNzEyIDEyLjgwNGMuMTIyLjUwNi0uMjc1Ljk2OS0uNzg2Ljk2OUgxNS4xYy0uNTEyIDAtLjkwOS0uNDYyLS43ODctLjk3Ljk5My00LjEzNyA0LjY1My03LjIwOCA5LjAxNi03LjIwOHM4LjAyMyAzLjA3IDkuMDE3IDcuMjA5eiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==";
        },
        /* 819 */
        /***/
        function(i, r) {
          i.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzkgODYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTkuNzU3IDQwLjkyNGMzLjczOC01LjE5MSAxMi43MTEtNC4zMDggMTIuNzExLTQuMzA4IDIuMjIzIDMuMDE0IDUuMTI2IDI0LjU4NiAzLjYyNCAyOC43MTgtMS40MDEgMS4zMDEtMTEuNjExIDEuNjI5LTEzLjM4LTEuNDM2LTEuMjI2LTguODA0LTIuOTU1LTIyLjk3NS0yLjk1NS0yMi45NzV6bTU4Ljc4NSAwYy0zLjczNy01LjE5MS0xMi43MTEtNC4zMDgtMTIuNzExLTQuMzA4LTIuMjIzIDMuMDE0LTUuMTI2IDI0LjU4Ni0zLjYyNCAyOC43MTggMS40MDEgMS4zMDEgMTEuNjExIDEuNjI5IDEzLjM4LTEuNDM2IDEuMjI2LTguODA0IDIuOTU1LTIyLjk3NSAyLjk1NS0yMi45NzV6Ii8+PHBhdGggZD0iTTY4LjY0NyA1OC42Yy43MjktNC43NTMgMi4zOC05LjU2MSAyLjM4LTE0LjgwNCAwLTIxLjQxMi0xNC4xMTUtMzguNzctMzEuNTI4LTM4Ljc3LTE3LjQxMiAwLTMxLjUyNyAxNy4zNTgtMzEuNTI3IDM4Ljc3IDAgNC41NDEuNTE1IDguOTM2IDEuODAyIDEyLjk1IDEuNjk4IDUuMjk1LTUuNTQyIDYuOTkxLTYuNjE2IDIuMDczQzIuNDEgNTUuMzk0IDAgNTEuNzg3IDAgNDguMTAzIDAgMjEuNTM2IDE3LjY4NSAwIDM5LjUgMCA2MS4zMTYgMCA3OSAyMS41MzYgNzkgNDguMTAzYzAgLjcxOC0yLjg5OSA5LjY5My0zLjI5MiAxMS40MDgtLjc1NCAzLjI5My03Ljc1MSAzLjU4OS03LjA2MS0uOTEyeiIvPjxwYXRoIGQ9Ik01LjA4NCA1MS4zODVjLS44MDQtMy43ODIuNTY5LTcuMzM1IDMuMTM0LTcuOTIxIDIuNjM2LS42MDMgNS40ODUgMi4xNSA2LjI4OSA2LjEzMi43OTcgMy45NDgtLjc1MiA3LjQ1Ny0zLjM4OCA3Ljg1OS0yLjU2Ni4zOTEtNS4yMzctMi4zMTgtNi4wMzQtNi4wN3ptNjguODM0IDBjLjgwNC0zLjc4Mi0uNTY4LTcuMzM1LTMuMTMzLTcuOTIxLTIuNjM2LS42MDMtNS40ODUgMi4xNS02LjI4OSA2LjEzMi0uNzk3IDMuOTQ4Ljc1MiA3LjQ1NyAzLjM4OSA3Ljg1OSAyLjU2NS4zOTEgNS4yMzctMi4zMTggNi4wMzQtNi4wN3ptLTIuMDM4IDguMjg4Yy0uOTI2IDE5LjY1OS0xNS4xMTIgMjQuNzU5LTI1Ljg1OSAyMC40NzUtNS40MDUtLjYwNi0zLjAzNCAxLjI2Mi0zLjAzNCAxLjI2MiAxMy42NjEgMy41NjIgMjYuMTY4IDMuNDk3IDMxLjI3My0yMC41NDktLjU4NS00LjUxMS0yLjM3OS0xLjE4Ny0yLjM3OS0xLjE4N3oiLz48cGF0aCBkPSJNNDEuNjYyIDc4LjQyMmw3LjU1My41NWMxLjE5Mi4xMDcgMi4xMiAxLjE1MyAyLjA3MiAyLjMzNWwtLjEwOSAyLjczOGMtLjA0NyAxLjE4Mi0xLjA1MSAyLjA1NC0yLjI0MyAxLjk0NmwtNy41NTMtLjU1Yy0xLjE5MS0uMTA3LTIuMTE5LTEuMTUzLTIuMDcyLTIuMzM1bC4xMDktMi43MzdjLjA0Ny0xLjE4MiAxLjA1Mi0yLjA1NCAyLjI0My0xLjk0N3oiLz48L2c+PC9zdmc+";
        },
        /* 820 */
        /***/
        function(i, r) {
          i.exports = "data:image/png;base64,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";
        },
        /* 821 */
        /***/
        function(i, r) {
          i.exports = "data:image/png;base64,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";
        },
        /* 822 */
        /***/
        function(i, r) {
          i.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUwIiBoZWlnaHQ9IjkwIj48ZGVmcz48cGF0aCBkPSJNNjcgMTJMNi40NDggNzIuNTUyIDAgMzFWMThMMjYgMGw0MSAxMnptMyA3bDYgNDctMjkgMTgtMzUuNTAyLTYuNDk4TDcwIDE5eiIgaWQ9ImEiLz48L2RlZnM+PHJlY3Qgd2lkdGg9IjE1MCIgaGVpZ2h0PSI5MCIgcng9IjM1IiByeT0iNDUiIG9wYWNpdHk9Ii41Ii8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNikiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0zOS4yNDkgNTEuMzEyYy42OTcgMTAuMzcgMi43ODUgMTcuODk3IDUuMjUxIDE3Ljg5NyAzLjAzOCAwIDUuNS0xMS40MTcgNS41LTI1LjVzLTIuNDYyLTI1LjUtNS41LTI1LjVjLTIuNTEgMC00LjYyOCA3Ljc5Ny01LjI4NyAxOC40NTNBOC45ODkgOC45ODkgMCAwMTQzIDQ0YTguOTg4IDguOTg4IDAgMDEtMy43NTEgNy4zMTJ6TTIwLjk4NSAzMi4yMjRsMTUuNzQ2LTE2Ljg3N2E3LjM4NSA3LjM4NSAwIDAxMTAuMzc0LS40MkM1MS43MDIgMTkuMTE0IDU0IDI5LjIwOCA1NCA0NS4yMDhjMCAxNC41MjctMi4zNDMgMjMuODgtNy4wMyAyOC4wNThhNy4yOCA3LjI4IDAgMDEtMTAuMTY4LS40NjhMMjAuNDA1IDU1LjIyNEgxMmE1IDUgMCAwMS01LTV2LTEzYTUgNSAwIDAxNS01aDguOTg1eiIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNiKSIvPjwvZz48cGF0aCBkPSJNMTA2LjUgMTMuNUw0NC45OTggNzUuMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==";
        },
        /* 823 */
        /***/
        function(i, r) {
          i.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTciIGhlaWdodD0iOTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik03MCAxMkw5LjQ0OCA3Mi41NTIgMCA2MmwzLTQ0TDI5IDBsNDEgMTJ6bTggMmwxIDUyLTI5IDE4LTM1LjUwMi02LjQ5OEw3OCAxNHoiIGlkPSJhIi8+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAzKSI+PG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPjx1c2UgeGxpbms6aHJlZj0iI2EiLz48L21hc2s+PHBhdGggZD0iTTkuMTEgMjAuOTY4SDQ4LjFhNSA1IDAgMDE1IDVWNTguMThhNSA1IDAgMDEtNSA1SDkuMTFhNSA1IDAgMDEtNS01VjI1Ljk3YTUgNSAwIDAxNS01em00Ny4wOCAxMy4zOTRjMC0uMzQ1IDUuNDcyLTMuMTU5IDE2LjQxNS04LjQ0M2EzIDMgMCAwMTQuMzA0IDIuNzAydjI2LjgzNWEzIDMgMCAwMS00LjMwNSAyLjcwMWMtMTAuOTQyLTUuMjg2LTE2LjQxMy04LjEtMTYuNDEzLTguNDQ2VjM0LjM2MnoiIGZpbGw9IiNGRkYiIG1hc2s9InVybCgjYikiLz48L2c+PHBhdGggZD0iTTgxLjUgMTYuNUwxOS45OTggNzguMDAyIiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+PC9nPjwvc3ZnPg==";
        },
        /* 824 */
        /***/
        function(i, r, e) {
          var n = {}, t = function(W) {
            var G;
            return function() {
              return typeof G == "undefined" && (G = W.apply(this, arguments)), G;
            };
          }, o = t(function() {
            return window && document && document.all && !window.atob;
          }), l = function(W, G) {
            return G ? G.querySelector(W) : document.querySelector(W);
          }, c = /* @__PURE__ */ function(W) {
            var G = {};
            return function(Z, K) {
              if (typeof Z == "function")
                return Z();
              if (typeof G[Z] == "undefined") {
                var L = l.call(this, Z, K);
                if (window.HTMLIFrameElement && L instanceof window.HTMLIFrameElement)
                  try {
                    L = L.contentDocument.head;
                  } catch {
                    L = null;
                  }
                G[Z] = L;
              }
              return G[Z];
            };
          }(), d = null, u = 0, h = [], A = e(825);
          i.exports = function(W, G) {
            if (typeof DEBUG != "undefined" && DEBUG && typeof document != "object")
              throw new Error("The style-loader cannot be used in a non-browser environment");
            G = G || {}, G.attrs = typeof G.attrs == "object" ? G.attrs : {}, !G.singleton && typeof G.singleton != "boolean" && (G.singleton = o()), G.insertInto || (G.insertInto = "head"), G.insertAt || (G.insertAt = "bottom");
            var Z = f(W, G);
            return g(Z, G), function(L) {
              for (var O = [], de = 0; de < Z.length; de++) {
                var oe = Z[de], fe = n[oe.id];
                fe.refs--, O.push(fe);
              }
              if (L) {
                var ge = f(L, G);
                g(ge, G);
              }
              for (var de = 0; de < O.length; de++) {
                var fe = O[de];
                if (fe.refs === 0) {
                  for (var we = 0; we < fe.parts.length; we++) fe.parts[we]();
                  delete n[fe.id];
                }
              }
            };
          };
          function g(W, G) {
            for (var Z = 0; Z < W.length; Z++) {
              var K = W[Z], L = n[K.id];
              if (L) {
                L.refs++;
                for (var O = 0; O < L.parts.length; O++)
                  L.parts[O](K.parts[O]);
                for (; O < K.parts.length; O++)
                  L.parts.push(B(K.parts[O], G));
              } else {
                for (var de = [], O = 0; O < K.parts.length; O++)
                  de.push(B(K.parts[O], G));
                n[K.id] = { id: K.id, refs: 1, parts: de };
              }
            }
          }
          function f(W, G) {
            for (var Z = [], K = {}, L = 0; L < W.length; L++) {
              var O = W[L], de = G.base ? O[0] + G.base : O[0], oe = O[1], fe = O[2], ge = O[3], we = { css: oe, media: fe, sourceMap: ge };
              K[de] ? K[de].parts.push(we) : Z.push(K[de] = { id: de, parts: [we] });
            }
            return Z;
          }
          function p(W, G) {
            var Z = c(W.insertInto);
            if (!Z)
              throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
            var K = h[h.length - 1];
            if (W.insertAt === "top")
              K ? K.nextSibling ? Z.insertBefore(G, K.nextSibling) : Z.appendChild(G) : Z.insertBefore(G, Z.firstChild), h.push(G);
            else if (W.insertAt === "bottom")
              Z.appendChild(G);
            else if (typeof W.insertAt == "object" && W.insertAt.before) {
              var L = c(W.insertAt.before, Z);
              Z.insertBefore(G, L);
            } else
              throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
          }
          function v(W) {
            if (W.parentNode === null) return !1;
            W.parentNode.removeChild(W);
            var G = h.indexOf(W);
            G >= 0 && h.splice(G, 1);
          }
          function b(W) {
            var G = document.createElement("style");
            if (W.attrs.type === void 0 && (W.attrs.type = "text/css"), W.attrs.nonce === void 0) {
              var Z = U();
              Z && (W.attrs.nonce = Z);
            }
            return y(G, W.attrs), p(W, G), G;
          }
          function m(W) {
            var G = document.createElement("link");
            return W.attrs.type === void 0 && (W.attrs.type = "text/css"), W.attrs.rel = "stylesheet", y(G, W.attrs), p(W, G), G;
          }
          function y(W, G) {
            Object.keys(G).forEach(function(Z) {
              W.setAttribute(Z, G[Z]);
            });
          }
          function U() {
            return e.nc;
          }
          function B(W, G) {
            var Z, K, L, O;
            if (G.transform && W.css)
              if (O = typeof G.transform == "function" ? G.transform(W.css) : G.transform.default(W.css), O)
                W.css = O;
              else
                return function() {
                };
            if (G.singleton) {
              var de = u++;
              Z = d || (d = b(G)), K = N.bind(null, Z, de, !1), L = N.bind(null, Z, de, !0);
            } else W.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (Z = m(G), K = w.bind(null, Z, G), L = function() {
              v(Z), Z.href && URL.revokeObjectURL(Z.href);
            }) : (Z = b(G), K = J.bind(null, Z), L = function() {
              v(Z);
            });
            return K(W), function(fe) {
              if (fe) {
                if (fe.css === W.css && fe.media === W.media && fe.sourceMap === W.sourceMap)
                  return;
                K(W = fe);
              } else
                L();
            };
          }
          var Q = /* @__PURE__ */ function() {
            var W = [];
            return function(G, Z) {
              return W[G] = Z, W.filter(Boolean).join(`
`);
            };
          }();
          function N(W, G, Z, K) {
            var L = Z ? "" : K.css;
            if (W.styleSheet)
              W.styleSheet.cssText = Q(G, L);
            else {
              var O = document.createTextNode(L), de = W.childNodes;
              de[G] && W.removeChild(de[G]), de.length ? W.insertBefore(O, de[G]) : W.appendChild(O);
            }
          }
          function J(W, G) {
            var Z = G.css, K = G.media;
            if (K && W.setAttribute("media", K), W.styleSheet)
              W.styleSheet.cssText = Z;
            else {
              for (; W.firstChild; )
                W.removeChild(W.firstChild);
              W.appendChild(document.createTextNode(Z));
            }
          }
          function w(W, G, Z) {
            var K = Z.css, L = Z.sourceMap, O = G.convertToAbsoluteUrls === void 0 && L;
            (G.convertToAbsoluteUrls || O) && (K = A(K)), L && (K += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(L)))) + " */");
            var de = new Blob([K], { type: "text/css" }), oe = W.href;
            W.href = URL.createObjectURL(de), oe && URL.revokeObjectURL(oe);
          }
        },
        /* 825 */
        /***/
        function(i, r) {
          i.exports = function(e) {
            var n = typeof window != "undefined" && window.location;
            if (!n)
              throw new Error("fixUrls requires window.location");
            if (!e || typeof e != "string")
              return e;
            var t = n.protocol + "//" + n.host, o = t + n.pathname.replace(/\/[^\/]*$/, "/"), l = e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(c, d) {
              var u = d.trim().replace(/^"(.*)"$/, function(A, g) {
                return g;
              }).replace(/^'(.*)'$/, function(A, g) {
                return g;
              });
              if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(u))
                return c;
              var h;
              return u.indexOf("//") === 0 ? h = u : u.indexOf("/") === 0 ? h = t + u : h = o + u.replace(/^\.\//, ""), "url(" + JSON.stringify(h) + ")";
            });
            return l;
          };
        }
        /******/
      ])
    );
  });
})(gI);
var XX = gI.exports;
const q0 = /* @__PURE__ */ d1(XX);
var fI = { exports: {} };
(function(s, a) {
  (function(r, e) {
    s.exports = e();
  })(typeof self != "undefined" ? self : Dn, function() {
    return (
      /******/
      function(i) {
        var r = {};
        function e(n) {
          if (r[n])
            return r[n].exports;
          var t = r[n] = {
            /******/
            i: n,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return i[n].call(t.exports, t, t.exports, e), t.l = !0, t.exports;
        }
        return e.m = i, e.c = r, e.d = function(n, t, o) {
          e.o(n, t) || Object.defineProperty(n, t, { enumerable: !0, get: o });
        }, e.r = function(n) {
          typeof Symbol != "undefined" && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(n, "__esModule", { value: !0 });
        }, e.t = function(n, t) {
          if (t & 1 && (n = e(n)), t & 8 || t & 4 && typeof n == "object" && n && n.__esModule) return n;
          var o = /* @__PURE__ */ Object.create(null);
          if (e.r(o), Object.defineProperty(o, "default", { enumerable: !0, value: n }), t & 2 && typeof n != "string") for (var l in n) e.d(o, l, function(c) {
            return n[c];
          }.bind(null, l));
          return o;
        }, e.n = function(n) {
          var t = n && n.__esModule ? (
            /******/
            function() {
              return n.default;
            }
          ) : (
            /******/
            function() {
              return n;
            }
          );
          return e.d(t, "a", t), t;
        }, e.o = function(n, t) {
          return Object.prototype.hasOwnProperty.call(n, t);
        }, e.p = "", e(e.s = 1);
      }([
        /* 0 */
        /***/
        function(i, r, e) {
          var n = function(c, d, u, h, A, g, f) {
            for (var p = void 0, v = void 0, b = void 0, m = void 0, y = void 0, U = void 0, B = void 0, Q = void 0, N = 1; N <= A; N += 1) {
              var J = N, w = Math.ceil(A / J);
              B = Math.floor(h / w), U = Math.floor(u / J), Q = B / U, Q > d ? (Q = d, B = U * Q) : Q < c && (Q = c, U = B / Q), U = Math.min(g, U), B = Math.min(f, B);
              var W = U * B * A;
              (p === void 0 || W >= p) && (p = W, m = B, y = U, v = J, b = w);
            }
            return {
              maxArea: p,
              targetCols: v,
              targetRows: b,
              targetHeight: m,
              targetWidth: y,
              ratio: m / y
            };
          }, t = function(c, d) {
            var u = c.maxRatio, h = c.minRatio, A = c.fixedRatio, g = c.containerWidth, f = c.containerHeight, p = c.offsetLeft, v = p === void 0 ? 0 : p, b = c.offsetTop, m = b === void 0 ? 0 : b, y = c.alignItems, U = y === void 0 ? "center" : y, B = c.maxWidth, Q = B === void 0 ? 1 / 0 : B, N = c.maxHeight, J = N === void 0 ? 1 / 0 : N, w = c.scaleLastRow, W = w === void 0 ? !0 : w, G = d.map(function(Kt) {
              return Kt.height / Kt.width;
            }), Z = G.length, K = void 0;
            if (!A)
              K = n(h, u, g, f, Z, Q, J);
            else {
              var L = G.length > 0 ? G[0] : null;
              K = n(L, L, g, f, Z, Q, J);
            }
            for (var O = 0, de = 0, oe = [], fe = void 0, ge = [], we = 0; we < G.length; we += 1) {
              we % K.targetCols === 0 && (fe = {
                ratios: [],
                width: 0,
                height: 0
              }, oe.push(fe));
              var _e = G[we];
              fe.ratios.push(_e);
              var Te = K.targetWidth, Pe = K.targetHeight;
              A && (Te = Pe / _e), fe.width += Te, fe.height = Pe;
            }
            for (var $e = 0, Bt = 0, Le = 0; Le < oe.length; Le += 1)
              fe = oe[Le], fe.width > g ? (fe.height = Math.floor(fe.height * (g / fe.width)), fe.width = g) : fe.width < g && fe.height < J && (Bt += 1), $e += fe.height;
            if (W && $e < f && Bt > 0) {
              var at = f - $e;
              $e = 0;
              for (var pt = 0; pt < oe.length; pt += 1) {
                if (fe = oe[pt], fe.width < g) {
                  var kt = at / Bt;
                  kt / fe.height > (g - fe.width) / fe.width && (kt = Math.floor((g - fe.width) / fe.width * fe.height)), fe.width += Math.floor(kt / fe.height * fe.width), fe.height += kt, at -= kt, Bt -= 1;
                }
                $e += fe.height;
              }
            }
            switch (U) {
              case "start":
                de = 0;
                break;
              case "end":
                de = f - $e;
                break;
              case "center":
              default:
                de = (f - $e) / 2;
                break;
            }
            for (var _t = 0; _t < oe.length; _t += 1) {
              fe = oe[_t];
              var Lt = void 0;
              switch (U) {
                case "start":
                  Lt = 0;
                  break;
                case "end":
                  Lt = g - fe.width;
                  break;
                case "center":
                default:
                  Lt = (g - fe.width) / 2;
                  break;
              }
              O = Lt;
              for (var Ft = void 0, Zt = 0; Zt < fe.ratios.length; Zt += 1) {
                var ft = fe.ratios[Zt], It = K.targetWidth;
                Ft = fe.height, A ? It = Math.floor(Ft / ft) : Ft / It !== K.targetHeight / K.targetWidth && (It = Math.floor(K.targetWidth / K.targetHeight * Ft)), ge.push({
                  left: O + v,
                  top: de + m,
                  width: It,
                  height: Ft
                }), O += It;
              }
              de += Ft;
            }
            return ge;
          }, o = function(c) {
            return c.height / c.width;
          };
          i.exports = function(l, c) {
            var d = l.maxRatio, u = d === void 0 ? 3 / 2 : d, h = l.minRatio, A = h === void 0 ? 9 / 16 : h, g = l.fixedRatio, f = g === void 0 ? !1 : g, p = l.bigPercentage, v = p === void 0 ? 0.8 : p, b = l.minBigPercentage, m = b === void 0 ? 0 : b, y = l.bigFixedRatio, U = y === void 0 ? !1 : y, B = l.bigMaxRatio, Q = B === void 0 ? 3 / 2 : B, N = l.bigMinRatio, J = N === void 0 ? 9 / 16 : N, w = l.bigFirst, W = w === void 0 ? !0 : w, G = l.containerWidth, Z = G === void 0 ? 640 : G, K = l.containerHeight, L = K === void 0 ? 480 : K, O = l.alignItems, de = O === void 0 ? "center" : O, oe = l.bigAlignItems, fe = oe === void 0 ? "center" : oe, ge = l.smallAlignItems, we = ge === void 0 ? "center" : ge, _e = l.maxWidth, Te = _e === void 0 ? 1 / 0 : _e, Pe = l.maxHeight, $e = Pe === void 0 ? 1 / 0 : Pe, Bt = l.smallMaxWidth, Le = Bt === void 0 ? 1 / 0 : Bt, at = l.smallMaxHeight, pt = at === void 0 ? 1 / 0 : at, kt = l.bigMaxWidth, _t = kt === void 0 ? 1 / 0 : kt, Lt = l.bigMaxHeight, Ft = Lt === void 0 ? 1 / 0 : Lt, Zt = l.scaleLastRow, ft = Zt === void 0 ? !0 : Zt, It = l.bigScaleLastRow, Kt = It === void 0 ? !0 : It, Sn = L / Z, Cn = 0, on = 0, An = 0, Ue = 0, ne = [], se = c.filter(function(Kr, Bi) {
              return Kr.big ? (ne.push(Bi), !0) : !1;
            }), Ce = c.filter(function(Kr) {
              return !Kr.big;
            }), At = [], Ge = [];
            if (se.length > 0 && Ce.length > 0) {
              var Ye = void 0, Qt = void 0, tn = W === !0;
              if (Sn > o(se[0])) {
                if (Ye = Z, Qt = Math.floor(L * v), m > 0) {
                  var vn = void 0;
                  if (!U)
                    vn = n(J, Q, Ye, Qt, se.length, _t, Ft);
                  else {
                    var Yt = se[0].height / se[0].width;
                    vn = n(Yt, Yt, Ye, Qt, se.length, _t, Ft);
                  }
                  Qt = Math.max(L * m, Math.min(Qt, vn.targetHeight * vn.targetRows));
                  var Tn = n(A, u, Z, L - Qt, Ce.length, Le, pt);
                  Qt = Math.max(Qt, L - Tn.targetRows * Tn.targetHeight);
                }
                on = Qt, An = L - on, W === "column" ? tn = !1 : W === "row" && (tn = !0);
              } else {
                if (Qt = L, Ye = Math.floor(Z * v), m > 0) {
                  var er = void 0;
                  if (!U)
                    er = n(J, Q, Ye, Qt, se.length, _t, Ft);
                  else {
                    var lr = se[0].height / se[0].width;
                    er = n(lr, lr, Ye, Qt, se.length, _t, Ft);
                  }
                  Ye = Math.max(Z * m, Math.min(Ye, er.targetWidth * er.targetCols));
                  var Br = n(A, u, Z - Ye, L, Ce.length, Le, pt);
                  Ye = Math.max(Ye, Z - Br.targetCols * Br.targetWidth);
                }
                Cn = Ye, Ue = Z - Cn, W === "column" ? tn = !0 : W === "row" && (tn = !1);
              }
              tn ? (At = t({
                containerWidth: Ye,
                containerHeight: Qt,
                offsetLeft: 0,
                offsetTop: 0,
                fixedRatio: U,
                minRatio: J,
                maxRatio: Q,
                alignItems: fe,
                maxWidth: _t,
                maxHeight: Ft,
                scaleLastRow: Kt
              }, se), Ge = t({
                containerWidth: Z - Cn,
                containerHeight: L - on,
                offsetLeft: Cn,
                offsetTop: on,
                fixedRatio: f,
                minRatio: A,
                maxRatio: u,
                alignItems: we,
                maxWidth: Le,
                maxHeight: pt,
                scaleLastRow: ft
              }, Ce)) : (Ge = t({
                containerWidth: Z - Cn,
                containerHeight: L - on,
                offsetLeft: 0,
                offsetTop: 0,
                fixedRatio: f,
                minRatio: A,
                maxRatio: u,
                alignItems: we,
                maxWidth: Le,
                maxHeight: pt,
                scaleLastRow: ft
              }, Ce), At = t({
                containerWidth: Ye,
                containerHeight: Qt,
                offsetLeft: Ue,
                offsetTop: An,
                fixedRatio: U,
                minRatio: J,
                alignItems: fe,
                maxWidth: _t,
                maxHeight: Ft,
                scaleLastRow: Kt
              }, se));
            } else se.length > 0 && Ce.length === 0 ? At = t({
              containerWidth: Z,
              containerHeight: L,
              fixedRatio: U,
              minRatio: J,
              maxRatio: Q,
              alignItems: fe,
              maxWidth: _t,
              maxHeight: Ft,
              scaleLastRow: Kt
            }, se) : Ge = t({
              containerWidth: Z - Cn,
              containerHeight: L - on,
              offsetLeft: Cn,
              offsetTop: on,
              fixedRatio: f,
              minRatio: A,
              maxRatio: u,
              alignItems: de,
              maxWidth: Te,
              maxHeight: $e,
              scaleLastRow: ft
            }, Ce);
            var pi = [], $n = 0, rr = 0;
            return c.forEach(function(Kr, Bi) {
              ne.indexOf(Bi) > -1 ? (pi[Bi] = At[$n], $n += 1) : (pi[Bi] = Ge[rr], rr += 1);
            }), pi;
          };
        },
        /* 1 */
        /***/
        function(i, r, e) {
          /*!
           *  opentok-layout-js (http://github.com/aullman/opentok-layout-js)
           *
           *  Automatic layout of video elements (publisher and subscriber) minimising
           *  white-space for the OpenTok on WebRTC API.
           *
           *  @Author: Adam Ullman (http://github.com/aullman)
           *  @Copyright (c) 2014 Adam Ullman
           *  @License: Released under the MIT license (http://opensource.org/licenses/MIT)
           * */
          var n = e(0), t = e(2);
          i.exports = function(l, c) {
            var d = c && c.window || (typeof window == "undefined" ? void 0 : window);
            return l = typeof l == "string" ? d.document.querySelector(l) : l, !(typeof (d && d.HTMLElement) == "undefined" || l instanceof d.HTMLElement) && !c ? c = l : c || (c = {}), {
              layout: t.bind(this, l, c),
              getLayout: n.bind(this, c)
            };
          };
        },
        /* 2 */
        /***/
        function(i, r, e) {
          var n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
            return typeof o;
          } : function(o) {
            return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
          }, t = e(0);
          i.exports = function(o, l) {
            function c(Z, K, L) {
              if (L)
                return Z.style[K] = L, NaN;
              if ((typeof K == "undefined" ? "undefined" : n(K)) === "object")
                return Object.keys(K).forEach(function(oe) {
                  c(Z, oe, K[oe]);
                }), NaN;
              var O = (l && l.window || window).getComputedStyle(Z), de = O.getPropertyValue(K);
              return de === "" && (de = Z.style[K]), de;
            }
            var d = function(K) {
              return c(K, "display") !== "none";
            };
            function u(Z) {
              return Z.offsetHeight > 0 ? Z.offsetHeight + "px" : c(Z, "height");
            }
            function h(Z) {
              return Z.offsetWidth > 0 ? Z.offsetWidth + "px" : c(Z, "width");
            }
            var A = function(K, L, O, de, oe, fe, ge) {
              var we = this, _e = {
                left: L + "px",
                top: O + "px",
                width: de + "px",
                height: oe + "px"
              }, Te = function() {
                var $e = K.querySelector(".OT_root");
                if ($e) {
                  var Bt = $e.style.width;
                  $e.style.width = de + "px", $e.style.width = Bt || "";
                }
              };
              fe && typeof $ != "undefined" ? ($(K).stop(), $(K).animate(_e, fe.duration || 200, fe.easing || "swing", function() {
                Te(), fe.complete && fe.complete.call(we), ge && ge(K, {
                  left: L,
                  top: O,
                  width: de,
                  height: oe
                });
              })) : (c(K, _e), K.classList.contains("ot-layout") || K.classList.add("ot-layout"), ge && ge(K, {
                left: L,
                top: O,
                width: de,
                height: oe
              })), Te();
            }, g = function(K) {
              if (K) {
                if (K.videoHeight && K.videoWidth)
                  return {
                    height: K.videoHeight,
                    width: K.videoWidth
                  };
                var L = K.querySelector("video");
                if (L && L.videoHeight && L.videoWidth)
                  return {
                    height: L.videoHeight,
                    width: L.videoWidth
                  };
              }
              return {
                height: 480,
                width: 640
              };
            }, f = function(K, L) {
              var O = c(K, L);
              return O ? parseInt(O, 10) : 0;
            }, p = function() {
              return (Math.random() * 1e8).toFixed(0);
            }, v = function(K) {
              var L = u(K);
              return L ? parseInt(L, 10) : 0;
            }, b = function(K) {
              var L = h(K);
              return L ? parseInt(L, 10) : 0;
            }, m = l.animate, y = m === void 0 ? !1 : m, U = l.bigClass, B = U === void 0 ? "OT_big" : U, Q = l.ignoreClass, N = Q === void 0 ? "OT_ignore" : Q;
            if (c(o, "display") !== "none") {
              var J = o.getAttribute("id");
              J || (J = "OT_" + p(), o.setAttribute("id", J)), l.containerHeight = v(o) - f(o, "border-top") - f(o, "border-bottom"), l.containerWidth = b(o) - f(o, "border-left") - f(o, "border-right");
              var w = Array.prototype.filter.call(o.querySelectorAll("#" + J + ">*:not(." + N + ")"), d), W = w.map(function(Z) {
                var K = g(Z);
                return K.big = Z.classList.contains(B), K;
              }), G = t(l, W);
              G.forEach(function(Z, K) {
                var L = w[K];
                c(L, "position", "absolute");
                var O = Z.width - f(L, "margin-left") - f(L, "margin-right") - (c(L, "box-sizing") !== "border-box" ? f(L, "padding-left") + f(L, "padding-right") + f(L, "border-left") + f(L, "border-right") : 0), de = Z.height - f(L, "margin-top") - f(L, "margin-bottom") - (c(L, "box-sizing") !== "border-box" ? f(L, "padding-top") + f(L, "padding-bottom") + f(L, "border-top") + f(L, "border-bottom") : 0);
                A(L, Z.left, Z.top, O, de, y, l.onLayout);
              });
            }
          };
        }
        /******/
      ])
    );
  });
})(fI);
var kX = fI.exports;
const wX = /* @__PURE__ */ d1(kX);
var pI = function() {
  if (typeof Map != "undefined")
    return Map;
  function s(a, i) {
    var r = -1;
    return a.some(function(e, n) {
      return e[0] === i ? (r = n, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function a() {
        this.__entries__ = [];
      }
      return Object.defineProperty(a.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), a.prototype.get = function(i) {
        var r = s(this.__entries__, i), e = this.__entries__[r];
        return e && e[1];
      }, a.prototype.set = function(i, r) {
        var e = s(this.__entries__, i);
        ~e ? this.__entries__[e][1] = r : this.__entries__.push([i, r]);
      }, a.prototype.delete = function(i) {
        var r = this.__entries__, e = s(r, i);
        ~e && r.splice(e, 1);
      }, a.prototype.has = function(i) {
        return !!~s(this.__entries__, i);
      }, a.prototype.clear = function() {
        this.__entries__.splice(0);
      }, a.prototype.forEach = function(i, r) {
        r === void 0 && (r = null);
        for (var e = 0, n = this.__entries__; e < n.length; e++) {
          var t = n[e];
          i.call(r, t[1], t[0]);
        }
      }, a;
    }()
  );
}(), Ab = typeof window != "undefined" && typeof document != "undefined" && window.document === document, Hm = function() {
  return typeof global != "undefined" && global.Math === Math ? global : typeof self != "undefined" && self.Math === Math ? self : typeof window != "undefined" && window.Math === Math ? window : Function("return this")();
}(), DX = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Hm) : function(s) {
    return setTimeout(function() {
      return s(Date.now());
    }, 1e3 / 60);
  };
}(), MX = 2;
function YX(s, a) {
  var i = !1, r = !1, e = 0;
  function n() {
    i && (i = !1, s()), r && o();
  }
  function t() {
    DX(n);
  }
  function o() {
    var l = Date.now();
    if (i) {
      if (l - e < MX)
        return;
      r = !0;
    } else
      i = !0, r = !1, setTimeout(t, a);
    e = l;
  }
  return o;
}
var LX = 20, xX = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], HX = typeof MutationObserver != "undefined", PX = (
  /** @class */
  function() {
    function s() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = YX(this.refresh.bind(this), LX);
    }
    return s.prototype.addObserver = function(a) {
      ~this.observers_.indexOf(a) || this.observers_.push(a), this.connected_ || this.connect_();
    }, s.prototype.removeObserver = function(a) {
      var i = this.observers_, r = i.indexOf(a);
      ~r && i.splice(r, 1), !i.length && this.connected_ && this.disconnect_();
    }, s.prototype.refresh = function() {
      var a = this.updateObservers_();
      a && this.refresh();
    }, s.prototype.updateObservers_ = function() {
      var a = this.observers_.filter(function(i) {
        return i.gatherActive(), i.hasActive();
      });
      return a.forEach(function(i) {
        return i.broadcastActive();
      }), a.length > 0;
    }, s.prototype.connect_ = function() {
      !Ab || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), HX ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, s.prototype.disconnect_ = function() {
      !Ab || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, s.prototype.onTransitionEnd_ = function(a) {
      var i = a.propertyName, r = i === void 0 ? "" : i, e = xX.some(function(n) {
        return !!~r.indexOf(n);
      });
      e && this.refresh();
    }, s.getInstance = function() {
      return this.instance_ || (this.instance_ = new s()), this.instance_;
    }, s.instance_ = null, s;
  }()
), mI = function(s, a) {
  for (var i = 0, r = Object.keys(a); i < r.length; i++) {
    var e = r[i];
    Object.defineProperty(s, e, {
      value: a[e],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return s;
}, LA = function(s) {
  var a = s && s.ownerDocument && s.ownerDocument.defaultView;
  return a || Hm;
}, vI = g1(0, 0, 0, 0);
function Pm(s) {
  return parseFloat(s) || 0;
}
function mR(s) {
  for (var a = [], i = 1; i < arguments.length; i++)
    a[i - 1] = arguments[i];
  return a.reduce(function(r, e) {
    var n = s["border-" + e + "-width"];
    return r + Pm(n);
  }, 0);
}
function OX(s) {
  for (var a = ["top", "right", "bottom", "left"], i = {}, r = 0, e = a; r < e.length; r++) {
    var n = e[r], t = s["padding-" + n];
    i[n] = Pm(t);
  }
  return i;
}
function KX(s) {
  var a = s.getBBox();
  return g1(0, 0, a.width, a.height);
}
function zX(s) {
  var a = s.clientWidth, i = s.clientHeight;
  if (!a && !i)
    return vI;
  var r = LA(s).getComputedStyle(s), e = OX(r), n = e.left + e.right, t = e.top + e.bottom, o = Pm(r.width), l = Pm(r.height);
  if (r.boxSizing === "border-box" && (Math.round(o + n) !== a && (o -= mR(r, "left", "right") + n), Math.round(l + t) !== i && (l -= mR(r, "top", "bottom") + t)), !_X(s)) {
    var c = Math.round(o + n) - a, d = Math.round(l + t) - i;
    Math.abs(c) !== 1 && (o -= c), Math.abs(d) !== 1 && (l -= d);
  }
  return g1(e.left, e.top, o, l);
}
var jX = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement != "undefined" ? function(s) {
    return s instanceof LA(s).SVGGraphicsElement;
  } : function(s) {
    return s instanceof LA(s).SVGElement && typeof s.getBBox == "function";
  };
}();
function _X(s) {
  return s === LA(s).document.documentElement;
}
function $X(s) {
  return Ab ? jX(s) ? KX(s) : zX(s) : vI;
}
function qX(s) {
  var a = s.x, i = s.y, r = s.width, e = s.height, n = typeof DOMRectReadOnly != "undefined" ? DOMRectReadOnly : Object, t = Object.create(n.prototype);
  return mI(t, {
    x: a,
    y: i,
    width: r,
    height: e,
    top: i,
    right: a + r,
    bottom: e + i,
    left: a
  }), t;
}
function g1(s, a, i, r) {
  return { x: s, y: a, width: i, height: r };
}
var ek = (
  /** @class */
  function() {
    function s(a) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = g1(0, 0, 0, 0), this.target = a;
    }
    return s.prototype.isActive = function() {
      var a = $X(this.target);
      return this.contentRect_ = a, a.width !== this.broadcastWidth || a.height !== this.broadcastHeight;
    }, s.prototype.broadcastRect = function() {
      var a = this.contentRect_;
      return this.broadcastWidth = a.width, this.broadcastHeight = a.height, a;
    }, s;
  }()
), tk = (
  /** @class */
  /* @__PURE__ */ function() {
    function s(a, i) {
      var r = qX(i);
      mI(this, { target: a, contentRect: r });
    }
    return s;
  }()
), nk = (
  /** @class */
  function() {
    function s(a, i, r) {
      if (this.activeObservations_ = [], this.observations_ = new pI(), typeof a != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = a, this.controller_ = i, this.callbackCtx_ = r;
    }
    return s.prototype.observe = function(a) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(a instanceof LA(a).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var i = this.observations_;
        i.has(a) || (i.set(a, new ek(a)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, s.prototype.unobserve = function(a) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element == "undefined" || !(Element instanceof Object))) {
        if (!(a instanceof LA(a).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var i = this.observations_;
        i.has(a) && (i.delete(a), i.size || this.controller_.removeObserver(this));
      }
    }, s.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, s.prototype.gatherActive = function() {
      var a = this;
      this.clearActive(), this.observations_.forEach(function(i) {
        i.isActive() && a.activeObservations_.push(i);
      });
    }, s.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var a = this.callbackCtx_, i = this.activeObservations_.map(function(r) {
          return new tk(r.target, r.broadcastRect());
        });
        this.callback_.call(a, i, a), this.clearActive();
      }
    }, s.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, s.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, s;
  }()
), bI = typeof WeakMap != "undefined" ? /* @__PURE__ */ new WeakMap() : new pI(), FI = (
  /** @class */
  /* @__PURE__ */ function() {
    function s(a) {
      if (!(this instanceof s))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var i = PX.getInstance(), r = new nk(a, i, this);
      bI.set(this, r);
    }
    return s;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(s) {
  FI.prototype[s] = function() {
    var a;
    return (a = bI.get(this))[s].apply(a, arguments);
  };
});
var rk = function() {
  return typeof Hm.ResizeObserver != "undefined" ? Hm.ResizeObserver : FI;
}(), ik = typeof global == "object" && global && global.Object === Object && global, ok = typeof self == "object" && self && self.Object === Object && self, RI = ik || ok || Function("return this")(), Om = RI.Symbol, yI = Object.prototype, ak = yI.hasOwnProperty, sk = yI.toString, kg = Om ? Om.toStringTag : void 0;
function lk(s) {
  var a = ak.call(s, kg), i = s[kg];
  try {
    s[kg] = void 0;
    var r = !0;
  } catch {
  }
  var e = sk.call(s);
  return r && (a ? s[kg] = i : delete s[kg]), e;
}
var ck = Object.prototype, dk = ck.toString;
function uk(s) {
  return dk.call(s);
}
var hk = "[object Null]", Ak = "[object Undefined]", vR = Om ? Om.toStringTag : void 0;
function gk(s) {
  return s == null ? s === void 0 ? Ak : hk : vR && vR in Object(s) ? lk(s) : uk(s);
}
function fk(s) {
  return s != null && typeof s == "object";
}
var pk = "[object Symbol]";
function mk(s) {
  return typeof s == "symbol" || fk(s) && gk(s) == pk;
}
var vk = /\s/;
function bk(s) {
  for (var a = s.length; a-- && vk.test(s.charAt(a)); )
    ;
  return a;
}
var Fk = /^\s+/;
function Rk(s) {
  return s && s.slice(0, bk(s) + 1).replace(Fk, "");
}
function Km(s) {
  var a = typeof s;
  return s != null && (a == "object" || a == "function");
}
var bR = NaN, yk = /^[-+]0x[0-9a-f]+$/i, Qk = /^0b[01]+$/i, Ck = /^0o[0-7]+$/i, Uk = parseInt;
function FR(s) {
  if (typeof s == "number")
    return s;
  if (mk(s))
    return bR;
  if (Km(s)) {
    var a = typeof s.valueOf == "function" ? s.valueOf() : s;
    s = Km(a) ? a + "" : a;
  }
  if (typeof s != "string")
    return s === 0 ? s : +s;
  s = Rk(s);
  var i = Qk.test(s);
  return i || Ck.test(s) ? Uk(s.slice(2), i ? 2 : 8) : yk.test(s) ? bR : +s;
}
var hv = function() {
  return RI.Date.now();
}, Ik = "Expected a function", Bk = Math.max, Zk = Math.min;
function QI(s, a, i) {
  var r, e, n, t, o, l, c = 0, d = !1, u = !1, h = !0;
  if (typeof s != "function")
    throw new TypeError(Ik);
  a = FR(a) || 0, Km(i) && (d = !!i.leading, u = "maxWait" in i, n = u ? Bk(FR(i.maxWait) || 0, a) : n, h = "trailing" in i ? !!i.trailing : h);
  function A(B) {
    var Q = r, N = e;
    return r = e = void 0, c = B, t = s.apply(N, Q), t;
  }
  function g(B) {
    return c = B, o = setTimeout(v, a), d ? A(B) : t;
  }
  function f(B) {
    var Q = B - l, N = B - c, J = a - Q;
    return u ? Zk(J, n - N) : J;
  }
  function p(B) {
    var Q = B - l, N = B - c;
    return l === void 0 || Q >= a || Q < 0 || u && N >= n;
  }
  function v() {
    var B = hv();
    if (p(B))
      return b(B);
    o = setTimeout(v, f(B));
  }
  function b(B) {
    return o = void 0, h && r ? A(B) : (r = e = void 0, t);
  }
  function m() {
    o !== void 0 && clearTimeout(o), c = 0, r = l = e = o = void 0;
  }
  function y() {
    return o === void 0 ? t : b(hv());
  }
  function U() {
    var B = hv(), Q = p(B);
    if (r = arguments, e = this, l = B, Q) {
      if (o === void 0)
        return g(l);
      if (u)
        return clearTimeout(o), o = setTimeout(v, a), A(l);
    }
    return o === void 0 && (o = setTimeout(v, a)), t;
  }
  return U.cancel = m, U.flush = y, U;
}
var Sk = "Expected a function";
function f1(s, a, i) {
  var r = !0, e = !0;
  if (typeof s != "function")
    throw new TypeError(Sk);
  return Km(i) && (r = "leading" in i ? !!i.leading : r, e = "trailing" in i ? !!i.trailing : e), QI(s, a, {
    leading: r,
    maxWait: a,
    trailing: e
  });
}
var RR = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
  return typeof s;
} : function(s) {
  return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
}, jp = (typeof window == "undefined" ? "undefined" : RR(window)) === "object" && (typeof document == "undefined" ? "undefined" : RR(document)) === "object" && document.nodeType === 9, Ek = {}, Vk = Ek.NODE_ENV === "production";
function Rd(s, a) {
  if (!Vk) {
    var i = "Warning: " + a;
    typeof console != "undefined" && console.warn(i);
    try {
      throw Error(i);
    } catch {
    }
  }
}
function Dp(s) {
  "@babel/helpers - typeof";
  return Dp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
    return typeof a;
  } : function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, Dp(s);
}
function Wk(s, a) {
  if (Dp(s) != "object" || !s) return s;
  var i = s[Symbol.toPrimitive];
  if (i !== void 0) {
    var r = i.call(s, a);
    if (Dp(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(s);
}
function Nk(s) {
  var a = Wk(s, "string");
  return Dp(a) == "symbol" ? a : a + "";
}
function Jk(s, a) {
  for (var i = 0; i < a.length; i++) {
    var r = a[i];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(s, Nk(r.key), r);
  }
}
function CI(s, a, i) {
  return a && Jk(s.prototype, a), Object.defineProperty(s, "prototype", {
    writable: !1
  }), s;
}
function gb(s, a) {
  return gb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, r) {
    return i.__proto__ = r, i;
  }, gb(s, a);
}
function UI(s, a) {
  s.prototype = Object.create(a.prototype), s.prototype.constructor = s, gb(s, a);
}
function yR(s) {
  if (s === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function Gk(s, a) {
  if (s == null) return {};
  var i = {};
  for (var r in s) if ({}.hasOwnProperty.call(s, r)) {
    if (a.includes(r)) continue;
    i[r] = s[r];
  }
  return i;
}
var Ou = {}, Tk = {}.constructor;
function fb(s) {
  if (s == null || typeof s != "object") return s;
  if (Array.isArray(s)) return s.map(fb);
  if (s.constructor !== Tk) return s;
  var a = {};
  for (var i in s)
    a[i] = fb(s[i]);
  return a;
}
function p1(s, a, i) {
  s === void 0 && (s = "unnamed");
  var r = i.jss, e = fb(a), n = r.plugins.onCreateRule(s, e, i);
  return n || (s[0] === "@" && Ou.NODE_ENV !== "production" && Rd(!1, "[JSS] Unknown rule " + s), null);
}
var QR = function(a, i) {
  for (var r = "", e = 0; e < a.length && a[e] !== "!important"; e++)
    r && (r += i), r += a[e];
  return r;
}, zh = function(a) {
  if (!Array.isArray(a)) return a;
  var i = "";
  if (Array.isArray(a[0]))
    for (var r = 0; r < a.length && a[r] !== "!important"; r++)
      i && (i += ", "), i += QR(a[r], " ");
  else i = QR(a, ", ");
  return a[a.length - 1] === "!important" && (i += " !important"), i;
};
function $A(s) {
  return s && s.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function wg(s, a) {
  for (var i = "", r = 0; r < a; r++)
    i += "  ";
  return i + s;
}
function Mp(s, a, i) {
  i === void 0 && (i = {});
  var r = "";
  if (!a) return r;
  var e = i, n = e.indent, t = n === void 0 ? 0 : n, o = a.fallbacks;
  i.format === !1 && (t = -1 / 0);
  var l = $A(i), c = l.linebreak, d = l.space;
  if (s && t++, o)
    if (Array.isArray(o))
      for (var u = 0; u < o.length; u++) {
        var h = o[u];
        for (var A in h) {
          var g = h[A];
          g != null && (r && (r += c), r += wg(A + ":" + d + zh(g) + ";", t));
        }
      }
    else
      for (var f in o) {
        var p = o[f];
        p != null && (r && (r += c), r += wg(f + ":" + d + zh(p) + ";", t));
      }
  for (var v in a) {
    var b = a[v];
    b != null && v !== "fallbacks" && (r && (r += c), r += wg(v + ":" + d + zh(b) + ";", t));
  }
  return !r && !i.allowEmpty || !s ? r : (t--, r && (r = "" + c + r + c), wg("" + s + d + "{" + r, t) + wg("}", t));
}
var Xk = /([[\].#*$><+~=|^:(),"'`\s])/g, CR = typeof CSS != "undefined" && CSS.escape, Kb = function(s) {
  return CR ? CR(s) : s.replace(Xk, "\\$1");
}, II = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "style", this.isProcessed = !1;
    var n = e.sheet, t = e.Renderer;
    this.key = i, this.options = e, this.style = r, n ? this.renderer = n.renderer : t && (this.renderer = new t());
  }
  var a = s.prototype;
  return a.prop = function(r, e, n) {
    if (e === void 0) return this.style[r];
    var t = n ? n.force : !1;
    if (!t && this.style[r] === e) return this;
    var o = e;
    (!n || n.process !== !1) && (o = this.options.jss.plugins.onChangeValue(e, r, this));
    var l = o == null || o === !1, c = r in this.style;
    if (l && !c && !t) return this;
    var d = l && c;
    if (d ? delete this.style[r] : this.style[r] = o, this.renderable && this.renderer)
      return d ? this.renderer.removeProperty(this.renderable, r) : this.renderer.setProperty(this.renderable, r, o), this;
    var u = this.options.sheet;
    return u && u.attached && Ou.NODE_ENV !== "production" && Rd(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, s;
}(), pb = /* @__PURE__ */ function(s) {
  UI(a, s);
  function a(r, e, n) {
    var t;
    t = s.call(this, r, e, n) || this;
    var o = n.selector, l = n.scoped, c = n.sheet, d = n.generateId;
    return o ? t.selectorText = o : l !== !1 && (t.id = d(yR(yR(t)), c), t.selectorText = "." + Kb(t.id)), t;
  }
  var i = a.prototype;
  return i.applyTo = function(e) {
    var n = this.renderer;
    if (n) {
      var t = this.toJSON();
      for (var o in t)
        n.setProperty(e, o, t[o]);
    }
    return this;
  }, i.toJSON = function() {
    var e = {};
    for (var n in this.style) {
      var t = this.style[n];
      typeof t != "object" ? e[n] = t : Array.isArray(t) && (e[n] = zh(t));
    }
    return e;
  }, i.toString = function(e) {
    var n = this.options.sheet, t = n ? n.options.link : !1, o = t ? zl({}, e, {
      allowEmpty: !0
    }) : e;
    return Mp(this.selectorText, this.style, o);
  }, CI(a, [{
    key: "selector",
    set: function(e) {
      if (e !== this.selectorText) {
        this.selectorText = e;
        var n = this.renderer, t = this.renderable;
        if (!(!t || !n)) {
          var o = n.setSelector(t, e);
          o || n.replaceRule(t, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), a;
}(II), kk = {
  onCreateRule: function(a, i, r) {
    return a[0] === "@" || r.parent && r.parent.type === "keyframes" ? null : new pb(a, i, r);
  }
}, Av = {
  indent: 1,
  children: !0
}, wk = /@([\w-]+)/, Dk = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "conditional", this.isProcessed = !1, this.key = i;
    var n = i.match(wk);
    this.at = n ? n[1] : "unknown", this.query = e.name || "@" + this.at, this.options = e, this.rules = new m1(zl({}, e, {
      parent: this
    }));
    for (var t in r)
      this.rules.add(t, r[t]);
    this.rules.process();
  }
  var a = s.prototype;
  return a.getRule = function(r) {
    return this.rules.get(r);
  }, a.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, a.addRule = function(r, e, n) {
    var t = this.rules.add(r, e, n);
    return t ? (this.options.jss.plugins.onProcessRule(t), t) : null;
  }, a.replaceRule = function(r, e, n) {
    var t = this.rules.replace(r, e, n);
    return t && this.options.jss.plugins.onProcessRule(t), t;
  }, a.toString = function(r) {
    r === void 0 && (r = Av);
    var e = $A(r), n = e.linebreak;
    if (r.indent == null && (r.indent = Av.indent), r.children == null && (r.children = Av.children), r.children === !1)
      return this.query + " {}";
    var t = this.rules.toString(r);
    return t ? this.query + " {" + n + t + n + "}" : "";
  }, s;
}(), Mk = /@container|@media|@supports\s+/, Yk = {
  onCreateRule: function(a, i, r) {
    return Mk.test(a) ? new Dk(a, i, r) : null;
  }
}, gv = {
  indent: 1,
  children: !0
}, Lk = /@keyframes\s+([\w-]+)/, mb = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var n = i.match(Lk);
    n && n[1] ? this.name = n[1] : (this.name = "noname", Ou.NODE_ENV !== "production" && Rd(!1, "[JSS] Bad keyframes name " + i)), this.key = this.type + "-" + this.name, this.options = e;
    var t = e.scoped, o = e.sheet, l = e.generateId;
    this.id = t === !1 ? this.name : Kb(l(this, o)), this.rules = new m1(zl({}, e, {
      parent: this
    }));
    for (var c in r)
      this.rules.add(c, r[c], zl({}, e, {
        parent: this
      }));
    this.rules.process();
  }
  var a = s.prototype;
  return a.toString = function(r) {
    r === void 0 && (r = gv);
    var e = $A(r), n = e.linebreak;
    if (r.indent == null && (r.indent = gv.indent), r.children == null && (r.children = gv.children), r.children === !1)
      return this.at + " " + this.id + " {}";
    var t = this.rules.toString(r);
    return t && (t = "" + n + t + n), this.at + " " + this.id + " {" + t + "}";
  }, s;
}(), xk = /@keyframes\s+/, Hk = /\$([\w-]+)/g, vb = function(a, i) {
  return typeof a == "string" ? a.replace(Hk, function(r, e) {
    return e in i ? i[e] : (Ou.NODE_ENV !== "production" && Rd(!1, '[JSS] Referenced keyframes rule "' + e + '" is not defined.'), r);
  }) : a;
}, UR = function(a, i, r) {
  var e = a[i], n = vb(e, r);
  n !== e && (a[i] = n);
}, Pk = {
  onCreateRule: function(a, i, r) {
    return typeof a == "string" && xk.test(a) ? new mb(a, i, r) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(a, i, r) {
    return i.type !== "style" || !r || ("animation-name" in a && UR(a, "animation-name", r.keyframes), "animation" in a && UR(a, "animation", r.keyframes)), a;
  },
  onChangeValue: function(a, i, r) {
    var e = r.options.sheet;
    if (!e)
      return a;
    switch (i) {
      case "animation":
        return vb(a, e.keyframes);
      case "animation-name":
        return vb(a, e.keyframes);
      default:
        return a;
    }
  }
}, Ok = /* @__PURE__ */ function(s) {
  UI(a, s);
  function a() {
    return s.apply(this, arguments) || this;
  }
  var i = a.prototype;
  return i.toString = function(e) {
    var n = this.options.sheet, t = n ? n.options.link : !1, o = t ? zl({}, e, {
      allowEmpty: !0
    }) : e;
    return Mp(this.key, this.style, o);
  }, a;
}(II), Kk = {
  onCreateRule: function(a, i, r) {
    return r.parent && r.parent.type === "keyframes" ? new Ok(a, i, r) : null;
  }
}, zk = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = i, this.style = r, this.options = e;
  }
  var a = s.prototype;
  return a.toString = function(r) {
    var e = $A(r), n = e.linebreak;
    if (Array.isArray(this.style)) {
      for (var t = "", o = 0; o < this.style.length; o++)
        t += Mp(this.at, this.style[o]), this.style[o + 1] && (t += n);
      return t;
    }
    return Mp(this.at, this.style, r);
  }, s;
}(), jk = /@font-face/, _k = {
  onCreateRule: function(a, i, r) {
    return jk.test(a) ? new zk(a, i, r) : null;
  }
}, $k = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = i, this.style = r, this.options = e;
  }
  var a = s.prototype;
  return a.toString = function(r) {
    return Mp(this.key, this.style, r);
  }, s;
}(), qk = {
  onCreateRule: function(a, i, r) {
    return a === "@viewport" || a === "@-ms-viewport" ? new $k(a, i, r) : null;
  }
}, ew = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "simple", this.isProcessed = !1, this.key = i, this.value = r, this.options = e;
  }
  var a = s.prototype;
  return a.toString = function(r) {
    if (Array.isArray(this.value)) {
      for (var e = "", n = 0; n < this.value.length; n++)
        e += this.key + " " + this.value[n] + ";", this.value[n + 1] && (e += `
`);
      return e;
    }
    return this.key + " " + this.value + ";";
  }, s;
}(), tw = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, nw = {
  onCreateRule: function(a, i, r) {
    return a in tw ? new ew(a, i, r) : null;
  }
}, IR = [kk, Yk, Pk, Kk, _k, qk, nw], rw = {
  process: !0
}, BR = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, m1 = /* @__PURE__ */ function() {
  function s(i) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = i, this.classes = i.classes, this.keyframes = i.keyframes;
  }
  var a = s.prototype;
  return a.add = function(r, e, n) {
    var t = this.options, o = t.parent, l = t.sheet, c = t.jss, d = t.Renderer, u = t.generateId, h = t.scoped, A = zl({
      classes: this.classes,
      parent: o,
      sheet: l,
      jss: c,
      Renderer: d,
      generateId: u,
      scoped: h,
      name: r,
      keyframes: this.keyframes,
      selector: void 0
    }, n), g = r;
    r in this.raw && (g = r + "-d" + this.counter++), this.raw[g] = e, g in this.classes && (A.selector = "." + Kb(this.classes[g]));
    var f = p1(g, e, A);
    if (!f) return null;
    this.register(f);
    var p = A.index === void 0 ? this.index.length : A.index;
    return this.index.splice(p, 0, f), f;
  }, a.replace = function(r, e, n) {
    var t = this.get(r), o = this.index.indexOf(t);
    t && this.remove(t);
    var l = n;
    return o !== -1 && (l = zl({}, n, {
      index: o
    })), this.add(r, e, l);
  }, a.get = function(r) {
    return this.map[r];
  }, a.remove = function(r) {
    this.unregister(r), delete this.raw[r.key], this.index.splice(this.index.indexOf(r), 1);
  }, a.indexOf = function(r) {
    return this.index.indexOf(r);
  }, a.process = function() {
    var r = this.options.jss.plugins;
    this.index.slice(0).forEach(r.onProcessRule, r);
  }, a.register = function(r) {
    this.map[r.key] = r, r instanceof pb ? (this.map[r.selector] = r, r.id && (this.classes[r.key] = r.id)) : r instanceof mb && this.keyframes && (this.keyframes[r.name] = r.id);
  }, a.unregister = function(r) {
    delete this.map[r.key], r instanceof pb ? (delete this.map[r.selector], delete this.classes[r.key]) : r instanceof mb && delete this.keyframes[r.name];
  }, a.update = function() {
    var r, e, n;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (r = arguments.length <= 0 ? void 0 : arguments[0], e = arguments.length <= 1 ? void 0 : arguments[1], n = arguments.length <= 2 ? void 0 : arguments[2]) : (e = arguments.length <= 0 ? void 0 : arguments[0], n = arguments.length <= 1 ? void 0 : arguments[1], r = null), r)
      this.updateOne(this.get(r), e, n);
    else
      for (var t = 0; t < this.index.length; t++)
        this.updateOne(this.index[t], e, n);
  }, a.updateOne = function(r, e, n) {
    n === void 0 && (n = rw);
    var t = this.options, o = t.jss.plugins, l = t.sheet;
    if (r.rules instanceof s) {
      r.rules.update(e, n);
      return;
    }
    var c = r.style;
    if (o.onUpdate(e, r, l, n), n.process && c && c !== r.style) {
      o.onProcessStyle(r.style, r, l);
      for (var d in r.style) {
        var u = r.style[d], h = c[d];
        u !== h && r.prop(d, u, BR);
      }
      for (var A in c) {
        var g = r.style[A], f = c[A];
        g == null && g !== f && r.prop(A, null, BR);
      }
    }
  }, a.toString = function(r) {
    for (var e = "", n = this.options.sheet, t = n ? n.options.link : !1, o = $A(r), l = o.linebreak, c = 0; c < this.index.length; c++) {
      var d = this.index[c], u = d.toString(r);
      !u && !t || (e && (e += l), e += u);
    }
    return e;
  }, s;
}(), BI = /* @__PURE__ */ function() {
  function s(i, r) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = zl({}, r, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), r.Renderer && (this.renderer = new r.Renderer(this)), this.rules = new m1(this.options);
    for (var e in i)
      this.rules.add(e, i[e]);
    this.rules.process();
  }
  var a = s.prototype;
  return a.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, a.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, a.addRule = function(r, e, n) {
    var t = this.queue;
    this.attached && !t && (this.queue = []);
    var o = this.rules.add(r, e, n);
    return o ? (this.options.jss.plugins.onProcessRule(o), this.attached ? (this.deployed && (t ? t.push(o) : (this.insertRule(o), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), o) : (this.deployed = !1, o)) : null;
  }, a.replaceRule = function(r, e, n) {
    var t = this.rules.get(r);
    if (!t) return this.addRule(r, e, n);
    var o = this.rules.replace(r, e, n);
    return o && this.options.jss.plugins.onProcessRule(o), this.attached ? (this.deployed && this.renderer && (o ? t.renderable && this.renderer.replaceRule(t.renderable, o) : this.renderer.deleteRule(t)), o) : (this.deployed = !1, o);
  }, a.insertRule = function(r) {
    this.renderer && this.renderer.insertRule(r);
  }, a.addRules = function(r, e) {
    var n = [];
    for (var t in r) {
      var o = this.addRule(t, r[t], e);
      o && n.push(o);
    }
    return n;
  }, a.getRule = function(r) {
    return this.rules.get(r);
  }, a.deleteRule = function(r) {
    var e = typeof r == "object" ? r : this.rules.get(r);
    return !e || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !e.renderable ? !1 : (this.rules.remove(e), this.attached && e.renderable && this.renderer ? this.renderer.deleteRule(e.renderable) : !0);
  }, a.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, a.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, a.update = function() {
    var r;
    return (r = this.rules).update.apply(r, arguments), this;
  }, a.updateOne = function(r, e, n) {
    return this.rules.updateOne(r, e, n), this;
  }, a.toString = function(r) {
    return this.rules.toString(r);
  }, s;
}(), iw = /* @__PURE__ */ function() {
  function s() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var a = s.prototype;
  return a.onCreateRule = function(r, e, n) {
    for (var t = 0; t < this.registry.onCreateRule.length; t++) {
      var o = this.registry.onCreateRule[t](r, e, n);
      if (o) return o;
    }
    return null;
  }, a.onProcessRule = function(r) {
    if (!r.isProcessed) {
      for (var e = r.options.sheet, n = 0; n < this.registry.onProcessRule.length; n++)
        this.registry.onProcessRule[n](r, e);
      r.style && this.onProcessStyle(r.style, r, e), r.isProcessed = !0;
    }
  }, a.onProcessStyle = function(r, e, n) {
    for (var t = 0; t < this.registry.onProcessStyle.length; t++)
      e.style = this.registry.onProcessStyle[t](e.style, e, n);
  }, a.onProcessSheet = function(r) {
    for (var e = 0; e < this.registry.onProcessSheet.length; e++)
      this.registry.onProcessSheet[e](r);
  }, a.onUpdate = function(r, e, n, t) {
    for (var o = 0; o < this.registry.onUpdate.length; o++)
      this.registry.onUpdate[o](r, e, n, t);
  }, a.onChangeValue = function(r, e, n) {
    for (var t = r, o = 0; o < this.registry.onChangeValue.length; o++)
      t = this.registry.onChangeValue[o](t, e, n);
    return t;
  }, a.use = function(r, e) {
    e === void 0 && (e = {
      queue: "external"
    });
    var n = this.plugins[e.queue];
    n.indexOf(r) === -1 && (n.push(r), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(t, o) {
      for (var l in o)
        l in t ? t[l].push(o[l]) : Ou.NODE_ENV !== "production" && Rd(!1, '[JSS] Unknown hook "' + l + '".');
      return t;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, s;
}(), ow = /* @__PURE__ */ function() {
  function s() {
    this.registry = [];
  }
  var a = s.prototype;
  return a.add = function(r) {
    var e = this.registry, n = r.options.index;
    if (e.indexOf(r) === -1) {
      if (e.length === 0 || n >= this.index) {
        e.push(r);
        return;
      }
      for (var t = 0; t < e.length; t++)
        if (e[t].options.index > n) {
          e.splice(t, 0, r);
          return;
        }
    }
  }, a.reset = function() {
    this.registry = [];
  }, a.remove = function(r) {
    var e = this.registry.indexOf(r);
    this.registry.splice(e, 1);
  }, a.toString = function(r) {
    for (var e = r === void 0 ? {} : r, n = e.attached, t = Gk(e, ["attached"]), o = $A(t), l = o.linebreak, c = "", d = 0; d < this.registry.length; d++) {
      var u = this.registry[d];
      n != null && u.attached !== n || (c && (c += l), c += u.toString(t));
    }
    return c;
  }, CI(s, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), s;
}(), Ep = new ow(), bb = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" && window.Math === Math ? window : typeof self != "undefined" && self.Math === Math ? self : Function("return this")(), Fb = "2f1acc6c3a606b082e5eef5e54414ffb";
bb[Fb] == null && (bb[Fb] = 0);
var ZR = bb[Fb]++, aw = 1e10, SR = function(a) {
  a === void 0 && (a = {});
  var i = 0, r = function(n, t) {
    i += 1, i > aw && Ou.NODE_ENV !== "production" && Rd(!1, "[JSS] You might have a memory leak. Rule counter is at " + i + ".");
    var o = "", l = "";
    return t && (t.options.classNamePrefix && (l = t.options.classNamePrefix), t.options.jss.id != null && (o = String(t.options.jss.id))), a.minify ? "" + (l || "c") + ZR + o + i : l + n.key + "-" + ZR + (o ? "-" + o : "") + "-" + i;
  };
  return r;
}, ZI = function(a) {
  var i;
  return function() {
    return i || (i = a()), i;
  };
}, sw = function(a, i) {
  try {
    return a.attributeStyleMap ? a.attributeStyleMap.get(i) : a.style.getPropertyValue(i);
  } catch {
    return "";
  }
}, lw = function(a, i, r) {
  try {
    var e = r;
    if (Array.isArray(r) && (e = zh(r)), a.attributeStyleMap)
      a.attributeStyleMap.set(i, e);
    else {
      var n = e ? e.indexOf("!important") : -1, t = n > -1 ? e.substr(0, n - 1) : e;
      a.style.setProperty(i, t, n > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, cw = function(a, i) {
  try {
    a.attributeStyleMap ? a.attributeStyleMap.delete(i) : a.style.removeProperty(i);
  } catch (r) {
    Ou.NODE_ENV !== "production" && Rd(!1, '[JSS] DOMException "' + r.message + '" was thrown. Tried to remove property "' + i + '".');
  }
}, dw = function(a, i) {
  return a.selectorText = i, a.selectorText === i;
}, SI = ZI(function() {
  return document.querySelector("head");
});
function uw(s, a) {
  for (var i = 0; i < s.length; i++) {
    var r = s[i];
    if (r.attached && r.options.index > a.index && r.options.insertionPoint === a.insertionPoint)
      return r;
  }
  return null;
}
function hw(s, a) {
  for (var i = s.length - 1; i >= 0; i--) {
    var r = s[i];
    if (r.attached && r.options.insertionPoint === a.insertionPoint)
      return r;
  }
  return null;
}
function Aw(s) {
  for (var a = SI(), i = 0; i < a.childNodes.length; i++) {
    var r = a.childNodes[i];
    if (r.nodeType === 8 && r.nodeValue.trim() === s)
      return r;
  }
  return null;
}
function gw(s) {
  var a = Ep.registry;
  if (a.length > 0) {
    var i = uw(a, s);
    if (i && i.renderer)
      return {
        parent: i.renderer.element.parentNode,
        node: i.renderer.element
      };
    if (i = hw(a, s), i && i.renderer)
      return {
        parent: i.renderer.element.parentNode,
        node: i.renderer.element.nextSibling
      };
  }
  var r = s.insertionPoint;
  if (r && typeof r == "string") {
    var e = Aw(r);
    if (e)
      return {
        parent: e.parentNode,
        node: e.nextSibling
      };
    Ou.NODE_ENV !== "production" && Rd(!1, '[JSS] Insertion point "' + r + '" not found.');
  }
  return !1;
}
function fw(s, a) {
  var i = a.insertionPoint, r = gw(a);
  if (r !== !1 && r.parent) {
    r.parent.insertBefore(s, r.node);
    return;
  }
  if (i && typeof i.nodeType == "number") {
    var e = i, n = e.parentNode;
    n ? n.insertBefore(s, e.nextSibling) : Ou.NODE_ENV !== "production" && Rd(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  SI().appendChild(s);
}
var pw = ZI(function() {
  var s = document.querySelector('meta[property="csp-nonce"]');
  return s ? s.getAttribute("content") : null;
}), ER = function(a, i, r) {
  try {
    "insertRule" in a ? a.insertRule(i, r) : "appendRule" in a && a.appendRule(i);
  } catch (e) {
    return Ou.NODE_ENV !== "production" && Rd(!1, "[JSS] " + e.message), !1;
  }
  return a.cssRules[r];
}, VR = function(a, i) {
  var r = a.cssRules.length;
  return i === void 0 || i > r ? r : i;
}, mw = function() {
  var a = document.createElement("style");
  return a.textContent = `
`, a;
}, vw = /* @__PURE__ */ function() {
  function s(i) {
    this.getPropertyValue = sw, this.setProperty = lw, this.removeProperty = cw, this.setSelector = dw, this.hasInsertedRules = !1, this.cssRules = [], i && Ep.add(i), this.sheet = i;
    var r = this.sheet ? this.sheet.options : {}, e = r.media, n = r.meta, t = r.element;
    this.element = t || mw(), this.element.setAttribute("data-jss", ""), e && this.element.setAttribute("media", e), n && this.element.setAttribute("data-meta", n);
    var o = pw();
    o && this.element.setAttribute("nonce", o);
  }
  var a = s.prototype;
  return a.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      fw(this.element, this.sheet.options);
      var r = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && r && (this.hasInsertedRules = !1, this.deploy());
    }
  }, a.detach = function() {
    if (this.sheet) {
      var r = this.element.parentNode;
      r && r.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, a.deploy = function() {
    var r = this.sheet;
    if (r) {
      if (r.options.link) {
        this.insertRules(r.rules);
        return;
      }
      this.element.textContent = `
` + r.toString() + `
`;
    }
  }, a.insertRules = function(r, e) {
    for (var n = 0; n < r.index.length; n++)
      this.insertRule(r.index[n], n, e);
  }, a.insertRule = function(r, e, n) {
    if (n === void 0 && (n = this.element.sheet), r.rules) {
      var t = r, o = n;
      if (r.type === "conditional" || r.type === "keyframes") {
        var l = VR(n, e);
        if (o = ER(n, t.toString({
          children: !1
        }), l), o === !1)
          return !1;
        this.refCssRule(r, l, o);
      }
      return this.insertRules(t.rules, o), o;
    }
    var c = r.toString();
    if (!c) return !1;
    var d = VR(n, e), u = ER(n, c, d);
    return u === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(r, d, u), u);
  }, a.refCssRule = function(r, e, n) {
    r.renderable = n, r.options.parent instanceof BI && this.cssRules.splice(e, 0, n);
  }, a.deleteRule = function(r) {
    var e = this.element.sheet, n = this.indexOf(r);
    return n === -1 ? !1 : (e.deleteRule(n), this.cssRules.splice(n, 1), !0);
  }, a.indexOf = function(r) {
    return this.cssRules.indexOf(r);
  }, a.replaceRule = function(r, e) {
    var n = this.indexOf(r);
    return n === -1 ? !1 : (this.element.sheet.deleteRule(n), this.cssRules.splice(n, 1), this.insertRule(e, n));
  }, a.getRules = function() {
    return this.element.sheet.cssRules;
  }, s;
}(), bw = 0, Fw = /* @__PURE__ */ function() {
  function s(i) {
    this.id = bw++, this.version = "10.10.0", this.plugins = new iw(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: SR,
      Renderer: jp ? vw : null,
      plugins: []
    }, this.generateId = SR({
      minify: !1
    });
    for (var r = 0; r < IR.length; r++)
      this.plugins.use(IR[r], {
        queue: "internal"
      });
    this.setup(i);
  }
  var a = s.prototype;
  return a.setup = function(r) {
    return r === void 0 && (r = {}), r.createGenerateId && (this.options.createGenerateId = r.createGenerateId), r.id && (this.options.id = zl({}, this.options.id, r.id)), (r.createGenerateId || r.id) && (this.generateId = this.options.createGenerateId(this.options.id)), r.insertionPoint != null && (this.options.insertionPoint = r.insertionPoint), "Renderer" in r && (this.options.Renderer = r.Renderer), r.plugins && this.use.apply(this, r.plugins), this;
  }, a.createStyleSheet = function(r, e) {
    e === void 0 && (e = {});
    var n = e, t = n.index;
    typeof t != "number" && (t = Ep.index === 0 ? 0 : Ep.index + 1);
    var o = new BI(r, zl({}, e, {
      jss: this,
      generateId: e.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: t
    }));
    return this.plugins.onProcessSheet(o), o;
  }, a.removeStyleSheet = function(r) {
    return r.detach(), Ep.remove(r), this;
  }, a.createRule = function(r, e, n) {
    if (e === void 0 && (e = {}), n === void 0 && (n = {}), typeof r == "object")
      return this.createRule(void 0, r, e);
    var t = zl({}, n, {
      name: r,
      jss: this,
      Renderer: this.options.Renderer
    });
    t.generateId || (t.generateId = this.generateId), t.classes || (t.classes = {}), t.keyframes || (t.keyframes = {});
    var o = p1(r, e, t);
    return o && this.plugins.onProcessRule(o), o;
  }, a.use = function() {
    for (var r = this, e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    return n.forEach(function(o) {
      r.plugins.use(o);
    }), this;
  }, s;
}(), Rw = function(a) {
  return new Fw(a);
}, zb = typeof CSS == "object" && CSS != null && "number" in CSS;
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var jb = Rw(), WR = {}, EI = Date.now(), fv = "fnValues" + EI, pv = "fnStyle" + ++EI, yw = function() {
  return {
    onCreateRule: function(i, r, e) {
      if (typeof r != "function") return null;
      var n = p1(i, {}, e);
      return n[pv] = r, n;
    },
    onProcessStyle: function(i, r) {
      if (fv in r || pv in r) return i;
      var e = {};
      for (var n in i) {
        var t = i[n];
        typeof t == "function" && (delete i[n], e[n] = t);
      }
      return r[fv] = e, i;
    },
    onUpdate: function(i, r, e, n) {
      var t = r, o = t[pv];
      if (o && (t.style = o(i) || {}, WR.NODE_ENV === "development")) {
        for (var l in t.style)
          if (typeof t.style[l] == "function") {
            WR.NODE_ENV !== "production" && Rd(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var c = t[fv];
      if (c)
        for (var d in c)
          t.prop(d, c[d](i), n);
    }
  };
};
function Qw(s) {
  var a, i = s.Symbol;
  return typeof i == "function" ? i.observable ? a = i.observable : (a = i("observable"), i.observable = a) : a = "@@observable", a;
}
var XA;
typeof self != "undefined" ? XA = self : typeof window != "undefined" ? XA = window : typeof global != "undefined" ? XA = global : typeof module != "undefined" ? XA = module : XA = Function("return this")();
var NR = Qw(XA), JR = function(a) {
  return a && a[NR] && a === a[NR]();
}, Cw = function(a) {
  return {
    onCreateRule: function(r, e, n) {
      if (!JR(e)) return null;
      var t = e, o = p1(r, {}, n);
      return t.subscribe(function(l) {
        for (var c in l)
          o.prop(c, l[c], a);
      }), o;
    },
    onProcessRule: function(r) {
      if (!(r && r.type !== "style")) {
        var e = r, n = e.style, t = function(d) {
          var u = n[d];
          if (!JR(u)) return "continue";
          delete n[d], u.subscribe({
            next: function(A) {
              e.prop(d, A, a);
            }
          });
        };
        for (var o in n)
          var l = t(o);
      }
    }
  };
}, Uw = {}, Iw = /;\n/, Bw = function(a) {
  for (var i = {}, r = a.split(Iw), e = 0; e < r.length; e++) {
    var n = (r[e] || "").trim();
    if (n) {
      var t = n.indexOf(":");
      if (t === -1) {
        Uw.NODE_ENV !== "production" && Rd(!1, '[JSS] Malformed CSS string "' + n + '"');
        continue;
      }
      var o = n.substr(0, t).trim(), l = n.substr(t + 1).trim();
      i[o] = l;
    }
  }
  return i;
}, Zw = function(a) {
  typeof a.style == "string" && (a.style = Bw(a.style));
};
function Sw() {
  return {
    onProcessRule: Zw
  };
}
var _0 = "@global", Rb = "@global ", Ew = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "global", this.at = _0, this.isProcessed = !1, this.key = i, this.options = e, this.rules = new m1(zl({}, e, {
      parent: this
    }));
    for (var n in r)
      this.rules.add(n, r[n]);
    this.rules.process();
  }
  var a = s.prototype;
  return a.getRule = function(r) {
    return this.rules.get(r);
  }, a.addRule = function(r, e, n) {
    var t = this.rules.add(r, e, n);
    return t && this.options.jss.plugins.onProcessRule(t), t;
  }, a.replaceRule = function(r, e, n) {
    var t = this.rules.replace(r, e, n);
    return t && this.options.jss.plugins.onProcessRule(t), t;
  }, a.indexOf = function(r) {
    return this.rules.indexOf(r);
  }, a.toString = function(r) {
    return this.rules.toString(r);
  }, s;
}(), Vw = /* @__PURE__ */ function() {
  function s(i, r, e) {
    this.type = "global", this.at = _0, this.isProcessed = !1, this.key = i, this.options = e;
    var n = i.substr(Rb.length);
    this.rule = e.jss.createRule(n, r, zl({}, e, {
      parent: this
    }));
  }
  var a = s.prototype;
  return a.toString = function(r) {
    return this.rule ? this.rule.toString(r) : "";
  }, s;
}(), Ww = /\s*,\s*/g;
function VI(s, a) {
  for (var i = s.split(Ww), r = "", e = 0; e < i.length; e++)
    r += a + " " + i[e].trim(), i[e + 1] && (r += ", ");
  return r;
}
function Nw(s, a) {
  var i = s.options, r = s.style, e = r ? r[_0] : null;
  if (e) {
    for (var n in e)
      a.addRule(n, e[n], zl({}, i, {
        selector: VI(n, s.selector)
      }));
    delete r[_0];
  }
}
function Jw(s, a) {
  var i = s.options, r = s.style;
  for (var e in r)
    if (!(e[0] !== "@" || e.substr(0, _0.length) !== _0)) {
      var n = VI(e.substr(_0.length), s.selector);
      a.addRule(n, r[e], zl({}, i, {
        selector: n
      })), delete r[e];
    }
}
function Gw() {
  function s(i, r, e) {
    if (!i) return null;
    if (i === _0)
      return new Ew(i, r, e);
    if (i[0] === "@" && i.substr(0, Rb.length) === Rb)
      return new Vw(i, r, e);
    var n = e.parent;
    return n && (n.type === "global" || n.options.parent && n.options.parent.type === "global") && (e.scoped = !1), !e.selector && e.scoped === !1 && (e.selector = i), null;
  }
  function a(i, r) {
    i.type !== "style" || !r || (Nw(i, r), Jw(i, r));
  }
  return {
    onCreateRule: s,
    onProcessRule: a
  };
}
var Tw = {}, Gm = function(a) {
  return a && typeof a == "object" && !Array.isArray(a);
}, mv = "extendCurrValue" + Date.now();
function Xw(s, a, i, r) {
  var e = typeof s.extend;
  if (e === "string") {
    if (!i) return;
    var n = i.getRule(s.extend);
    if (!n) return;
    if (n === a) {
      Tw.NODE_ENV !== "production" && Rd(!1, `[JSS] A rule tries to extend itself 
` + a.toString());
      return;
    }
    var t = n.options.parent;
    if (t) {
      var o = t.rules.raw[s.extend];
      Kh(o, a, i, r);
    }
    return;
  }
  if (Array.isArray(s.extend)) {
    for (var l = 0; l < s.extend.length; l++) {
      var c = s.extend[l], d = typeof c == "string" ? zl({}, s, {
        extend: c
      }) : s.extend[l];
      Kh(d, a, i, r);
    }
    return;
  }
  for (var u in s.extend) {
    if (u === "extend") {
      Kh(s.extend.extend, a, i, r);
      continue;
    }
    if (Gm(s.extend[u])) {
      u in r || (r[u] = {}), Kh(s.extend[u], a, i, r[u]);
      continue;
    }
    r[u] = s.extend[u];
  }
}
function kw(s, a, i, r) {
  for (var e in s)
    if (e !== "extend") {
      if (Gm(r[e]) && Gm(s[e])) {
        Kh(s[e], a, i, r[e]);
        continue;
      }
      if (Gm(s[e])) {
        r[e] = Kh(s[e], a, i);
        continue;
      }
      r[e] = s[e];
    }
}
function Kh(s, a, i, r) {
  return r === void 0 && (r = {}), Xw(s, a, i, r), kw(s, a, i, r), r;
}
function ww() {
  function s(i, r, e) {
    return "extend" in i ? Kh(i, r, e) : i;
  }
  function a(i, r, e) {
    if (r !== "extend") return i;
    if (i == null || i === !1) {
      for (var n in e[mv])
        e.prop(n, null);
      return e[mv] = null, null;
    }
    if (typeof i == "object") {
      for (var t in i)
        e.prop(t, i[t]);
      e[mv] = i;
    }
    return null;
  }
  return {
    onProcessStyle: s,
    onChangeValue: a
  };
}
var Dw = {}, GR = /\s*,\s*/g, Mw = /&/g, Yw = /\$([\w-]+)/g;
function Lw() {
  function s(e, n) {
    return function(t, o) {
      var l = e.getRule(o) || n && n.getRule(o);
      return l ? l.selector : (Dw.NODE_ENV !== "production" && Rd(!1, '[JSS] Could not find the referenced rule "' + o + '" in "' + (e.options.meta || e.toString()) + '".'), o);
    };
  }
  function a(e, n) {
    for (var t = n.split(GR), o = e.split(GR), l = "", c = 0; c < t.length; c++)
      for (var d = t[c], u = 0; u < o.length; u++) {
        var h = o[u];
        l && (l += ", "), l += h.indexOf("&") !== -1 ? h.replace(Mw, d) : d + " " + h;
      }
    return l;
  }
  function i(e, n, t) {
    if (t) return zl({}, t, {
      index: t.index + 1
    });
    var o = e.options.nestingLevel;
    o = o === void 0 ? 1 : o + 1;
    var l = zl({}, e.options, {
      nestingLevel: o,
      index: n.indexOf(e) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete l.name, l;
  }
  function r(e, n, t) {
    if (n.type !== "style") return e;
    var o = n, l = o.options.parent, c, d;
    for (var u in e) {
      var h = u.indexOf("&") !== -1, A = u[0] === "@";
      if (!(!h && !A)) {
        if (c = i(o, l, c), h) {
          var g = a(u, o.selector);
          d || (d = s(l, t)), g = g.replace(Yw, d);
          var f = o.key + "-" + u;
          "replaceRule" in l ? l.replaceRule(f, e[u], zl({}, c, {
            selector: g
          })) : l.addRule(f, e[u], zl({}, c, {
            selector: g
          }));
        } else A && l.addRule(u, {}, c).addRule(o.key, e[u], {
          selector: o.selector
        });
        delete e[u];
      }
    }
    return e;
  }
  return {
    onProcessStyle: r
  };
}
var TR = {};
function yb(s, a) {
  if (!a) return !0;
  if (Array.isArray(a)) {
    for (var i = 0; i < a.length; i++) {
      var r = yb(s, a[i]);
      if (!r) return !1;
    }
    return !0;
  }
  if (a.indexOf(" ") > -1)
    return yb(s, a.split(" "));
  var e = s.options.parent;
  if (a[0] === "$") {
    var n = e.getRule(a.substr(1));
    return n ? n === s ? (TR.NODE_ENV !== "production" && Rd(!1, `[JSS] Cyclic composition detected. 
` + s.toString()), !1) : (e.classes[s.key] += " " + e.classes[n.key], !0) : (TR.NODE_ENV !== "production" && Rd(!1, `[JSS] Referenced rule is not defined. 
` + s.toString()), !1);
  }
  return e.classes[s.key] += " " + a, !0;
}
function xw() {
  function s(a, i) {
    return "composes" in a && (yb(i, a.composes), delete a.composes), a;
  }
  return {
    onProcessStyle: s
  };
}
var Hw = /[A-Z]/g, Pw = /^ms-/, vv = {};
function Ow(s) {
  return "-" + s.toLowerCase();
}
function WI(s) {
  if (vv.hasOwnProperty(s))
    return vv[s];
  var a = s.replace(Hw, Ow);
  return vv[s] = Pw.test(a) ? "-" + a : a;
}
function zm(s) {
  var a = {};
  for (var i in s) {
    var r = i.indexOf("--") === 0 ? i : WI(i);
    a[r] = s[i];
  }
  return s.fallbacks && (Array.isArray(s.fallbacks) ? a.fallbacks = s.fallbacks.map(zm) : a.fallbacks = zm(s.fallbacks)), a;
}
function NI() {
  function s(i) {
    if (Array.isArray(i)) {
      for (var r = 0; r < i.length; r++)
        i[r] = zm(i[r]);
      return i;
    }
    return zm(i);
  }
  function a(i, r, e) {
    if (r.indexOf("--") === 0)
      return i;
    var n = WI(r);
    return r === n ? i : (e.prop(n, i), null);
  }
  return {
    onProcessStyle: s,
    onChangeValue: a
  };
}
var ur = zb && CSS ? CSS.px : "px", ym = zb && CSS ? CSS.ms : "ms", NA = zb && CSS ? CSS.percent : "%", Kw = {
  // Animation properties
  "animation-delay": ym,
  "animation-duration": ym,
  // Background properties
  "background-position": ur,
  "background-position-x": ur,
  "background-position-y": ur,
  "background-size": ur,
  // Border Properties
  border: ur,
  "border-bottom": ur,
  "border-bottom-left-radius": ur,
  "border-bottom-right-radius": ur,
  "border-bottom-width": ur,
  "border-left": ur,
  "border-left-width": ur,
  "border-radius": ur,
  "border-right": ur,
  "border-right-width": ur,
  "border-top": ur,
  "border-top-left-radius": ur,
  "border-top-right-radius": ur,
  "border-top-width": ur,
  "border-width": ur,
  "border-block": ur,
  "border-block-end": ur,
  "border-block-end-width": ur,
  "border-block-start": ur,
  "border-block-start-width": ur,
  "border-block-width": ur,
  "border-inline": ur,
  "border-inline-end": ur,
  "border-inline-end-width": ur,
  "border-inline-start": ur,
  "border-inline-start-width": ur,
  "border-inline-width": ur,
  "border-start-start-radius": ur,
  "border-start-end-radius": ur,
  "border-end-start-radius": ur,
  "border-end-end-radius": ur,
  // Margin properties
  margin: ur,
  "margin-bottom": ur,
  "margin-left": ur,
  "margin-right": ur,
  "margin-top": ur,
  "margin-block": ur,
  "margin-block-end": ur,
  "margin-block-start": ur,
  "margin-inline": ur,
  "margin-inline-end": ur,
  "margin-inline-start": ur,
  // Padding properties
  padding: ur,
  "padding-bottom": ur,
  "padding-left": ur,
  "padding-right": ur,
  "padding-top": ur,
  "padding-block": ur,
  "padding-block-end": ur,
  "padding-block-start": ur,
  "padding-inline": ur,
  "padding-inline-end": ur,
  "padding-inline-start": ur,
  // Mask properties
  "mask-position-x": ur,
  "mask-position-y": ur,
  "mask-size": ur,
  // Width and height properties
  height: ur,
  width: ur,
  "min-height": ur,
  "max-height": ur,
  "min-width": ur,
  "max-width": ur,
  // Position properties
  bottom: ur,
  left: ur,
  top: ur,
  right: ur,
  inset: ur,
  "inset-block": ur,
  "inset-block-end": ur,
  "inset-block-start": ur,
  "inset-inline": ur,
  "inset-inline-end": ur,
  "inset-inline-start": ur,
  // Shadow properties
  "box-shadow": ur,
  "text-shadow": ur,
  // Column properties
  "column-gap": ur,
  "column-rule": ur,
  "column-rule-width": ur,
  "column-width": ur,
  // Font and text properties
  "font-size": ur,
  "font-size-delta": ur,
  "letter-spacing": ur,
  "text-decoration-thickness": ur,
  "text-indent": ur,
  "text-stroke": ur,
  "text-stroke-width": ur,
  "word-spacing": ur,
  // Motion properties
  motion: ur,
  "motion-offset": ur,
  // Outline properties
  outline: ur,
  "outline-offset": ur,
  "outline-width": ur,
  // Perspective properties
  perspective: ur,
  "perspective-origin-x": NA,
  "perspective-origin-y": NA,
  // Transform properties
  "transform-origin": NA,
  "transform-origin-x": NA,
  "transform-origin-y": NA,
  "transform-origin-z": NA,
  // Transition properties
  "transition-delay": ym,
  "transition-duration": ym,
  // Alignment properties
  "vertical-align": ur,
  "flex-basis": ur,
  // Some random properties
  "shape-margin": ur,
  size: ur,
  gap: ur,
  // Grid properties
  grid: ur,
  "grid-gap": ur,
  "row-gap": ur,
  "grid-row-gap": ur,
  "grid-column-gap": ur,
  "grid-template-rows": ur,
  "grid-template-columns": ur,
  "grid-auto-rows": ur,
  "grid-auto-columns": ur,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": ur,
  "box-shadow-y": ur,
  "box-shadow-blur": ur,
  "box-shadow-spread": ur,
  "font-line-height": ur,
  "text-shadow-x": ur,
  "text-shadow-y": ur,
  "text-shadow-blur": ur
};
function JI(s) {
  var a = /(-[a-z])/g, i = function(t) {
    return t[1].toUpperCase();
  }, r = {};
  for (var e in s)
    r[e] = s[e], r[e.replace(a, i)] = s[e];
  return r;
}
var zw = JI(Kw);
function Vp(s, a, i) {
  if (a == null) return a;
  if (Array.isArray(a))
    for (var r = 0; r < a.length; r++)
      a[r] = Vp(s, a[r], i);
  else if (typeof a == "object")
    if (s === "fallbacks")
      for (var e in a)
        a[e] = Vp(e, a[e], i);
    else
      for (var n in a)
        a[n] = Vp(s + "-" + n, a[n], i);
  else if (typeof a == "number" && isNaN(a) === !1) {
    var t = i[s] || zw[s];
    return t && !(a === 0 && t === ur) ? typeof t == "function" ? t(a).toString() : "" + a + t : a.toString();
  }
  return a;
}
function jw(s) {
  s === void 0 && (s = {});
  var a = JI(s);
  function i(e, n) {
    if (n.type !== "style") return e;
    for (var t in e)
      e[t] = Vp(t, e[t], a);
    return e;
  }
  function r(e, n) {
    return Vp(n, e, a);
  }
  return {
    onProcessStyle: i,
    onChangeValue: r
  };
}
var _w = {
  "background-size": !0,
  "background-position": !0,
  border: !0,
  "border-bottom": !0,
  "border-left": !0,
  "border-top": !0,
  "border-right": !0,
  "border-radius": !0,
  "border-image": !0,
  "border-width": !0,
  "border-style": !0,
  "border-color": !0,
  "box-shadow": !0,
  flex: !0,
  margin: !0,
  padding: !0,
  outline: !0,
  "transform-origin": !0,
  transform: !0,
  transition: !0
  /**
   * A scheme for converting arrays to regular styles inside of objects.
   * For e.g.: "{position: [0, 0]}" => "background-position: 0 0;".
   */
}, $w = {
  position: !0,
  // background-position
  size: !0
  // background-size
  /**
   * A scheme for parsing and building correct styles from passed objects.
   */
}, Qm = {
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  background: {
    attachment: null,
    color: null,
    image: null,
    position: null,
    repeat: null
  },
  border: {
    width: null,
    style: null,
    color: null
  },
  "border-top": {
    width: null,
    style: null,
    color: null
  },
  "border-right": {
    width: null,
    style: null,
    color: null
  },
  "border-bottom": {
    width: null,
    style: null,
    color: null
  },
  "border-left": {
    width: null,
    style: null,
    color: null
  },
  outline: {
    width: null,
    style: null,
    color: null
  },
  "list-style": {
    type: null,
    position: null,
    image: null
  },
  transition: {
    property: null,
    duration: null,
    "timing-function": null,
    timingFunction: null,
    // Needed for avoiding comilation issues with jss-plugin-camel-case
    delay: null
  },
  animation: {
    name: null,
    duration: null,
    "timing-function": null,
    timingFunction: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    delay: null,
    "iteration-count": null,
    iterationCount: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    direction: null,
    "fill-mode": null,
    fillMode: null,
    // Needed to avoid compilation issues with jss-plugin-camel-case
    "play-state": null,
    playState: null
    // Needed to avoid compilation issues with jss-plugin-camel-case
  },
  "box-shadow": {
    x: 0,
    y: 0,
    blur: 0,
    spread: 0,
    color: null,
    inset: null
  },
  "text-shadow": {
    x: 0,
    y: 0,
    blur: null,
    color: null
  }
  /**
   * A scheme for converting non-standart properties inside object.
   * For e.g.: include 'border-radius' property inside 'border' object.
   */
}, bv = {
  border: {
    radius: "border-radius",
    image: "border-image",
    width: "border-width",
    style: "border-style",
    color: "border-color"
  },
  "border-bottom": {
    width: "border-bottom-width",
    style: "border-bottom-style",
    color: "border-bottom-color"
  },
  "border-top": {
    width: "border-top-width",
    style: "border-top-style",
    color: "border-top-color"
  },
  "border-left": {
    width: "border-left-width",
    style: "border-left-style",
    color: "border-left-color"
  },
  "border-right": {
    width: "border-right-width",
    style: "border-right-style",
    color: "border-right-color"
  },
  background: {
    size: "background-size",
    image: "background-image"
  },
  font: {
    style: "font-style",
    variant: "font-variant",
    weight: "font-weight",
    stretch: "font-stretch",
    size: "font-size",
    family: "font-family",
    lineHeight: "line-height",
    // Needed to avoid compilation issues with jss-plugin-camel-case
    "line-height": "line-height"
  },
  flex: {
    grow: "flex-grow",
    basis: "flex-basis",
    direction: "flex-direction",
    wrap: "flex-wrap",
    flow: "flex-flow",
    shrink: "flex-shrink"
  },
  align: {
    self: "align-self",
    items: "align-items",
    content: "align-content"
  },
  grid: {
    "template-columns": "grid-template-columns",
    templateColumns: "grid-template-columns",
    "template-rows": "grid-template-rows",
    templateRows: "grid-template-rows",
    "template-areas": "grid-template-areas",
    templateAreas: "grid-template-areas",
    template: "grid-template",
    "auto-columns": "grid-auto-columns",
    autoColumns: "grid-auto-columns",
    "auto-rows": "grid-auto-rows",
    autoRows: "grid-auto-rows",
    "auto-flow": "grid-auto-flow",
    autoFlow: "grid-auto-flow",
    row: "grid-row",
    column: "grid-column",
    "row-start": "grid-row-start",
    rowStart: "grid-row-start",
    "row-end": "grid-row-end",
    rowEnd: "grid-row-end",
    "column-start": "grid-column-start",
    columnStart: "grid-column-start",
    "column-end": "grid-column-end",
    columnEnd: "grid-column-end",
    area: "grid-area",
    gap: "grid-gap",
    "row-gap": "grid-row-gap",
    rowGap: "grid-row-gap",
    "column-gap": "grid-column-gap",
    columnGap: "grid-column-gap"
  }
};
function qw(s, a, i) {
  return s.map(function(r) {
    return TI(r, a, i, !1, !0);
  });
}
function GI(s, a, i, r) {
  return i[a] == null ? s : s.length === 0 ? [] : Array.isArray(s[0]) ? GI(s[0], a, i, r) : typeof s[0] == "object" ? qw(s, a, r) : [s];
}
function TI(s, a, i, r, e) {
  if (!(Qm[a] || bv[a])) return [];
  var n = [];
  if (bv[a] && (s = e4(s, i, bv[a], r)), Object.keys(s).length)
    for (var t in Qm[a]) {
      if (s[t]) {
        Array.isArray(s[t]) ? n.push($w[t] === null ? s[t] : s[t].join(" ")) : n.push(s[t]);
        continue;
      }
      Qm[a][t] != null && n.push(Qm[a][t]);
    }
  return !n.length || e ? n : [n];
}
function e4(s, a, i, r) {
  for (var e in i) {
    var n = i[e];
    if (typeof s[e] != "undefined" && (r || !a.prop(n))) {
      var t, o = Yp((t = {}, t[n] = s[e], t), a)[n];
      r ? a.style.fallbacks[n] = o : a.style[n] = o;
    }
    delete s[e];
  }
  return s;
}
function Yp(s, a, i) {
  for (var r in s) {
    var e = s[r];
    if (Array.isArray(e)) {
      if (!Array.isArray(e[0])) {
        if (r === "fallbacks") {
          for (var n = 0; n < s.fallbacks.length; n++)
            s.fallbacks[n] = Yp(s.fallbacks[n], a, !0);
          continue;
        }
        s[r] = GI(e, r, _w, a), s[r].length || delete s[r];
      }
    } else if (typeof e == "object") {
      if (r === "fallbacks") {
        s.fallbacks = Yp(s.fallbacks, a, !0);
        continue;
      }
      s[r] = TI(e, r, a, i), s[r].length || delete s[r];
    } else s[r] === "" && delete s[r];
  }
  return s;
}
function t4() {
  function s(a, i) {
    if (!a || i.type !== "style") return a;
    if (Array.isArray(a)) {
      for (var r = 0; r < a.length; r++)
        a[r] = Yp(a[r], i);
      return a;
    }
    return Yp(a, i);
  }
  return {
    onProcessStyle: s
  };
}
function Qb(s, a) {
  (a == null || a > s.length) && (a = s.length);
  for (var i = 0, r = Array(a); i < a; i++) r[i] = s[i];
  return r;
}
function n4(s) {
  if (Array.isArray(s)) return Qb(s);
}
function r4(s) {
  if (typeof Symbol != "undefined" && s[Symbol.iterator] != null || s["@@iterator"] != null) return Array.from(s);
}
function i4(s, a) {
  if (s) {
    if (typeof s == "string") return Qb(s, a);
    var i = {}.toString.call(s).slice(8, -1);
    return i === "Object" && s.constructor && (i = s.constructor.name), i === "Map" || i === "Set" ? Array.from(s) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Qb(s, a) : void 0;
  }
}
function o4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function a4(s) {
  return n4(s) || r4(s) || i4(s) || o4();
}
var XI = {}, Up = "", Cb = "", kI = "", wI = "", s4 = jp && "ontouchstart" in document.documentElement;
if (jp) {
  var Fv = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, l4 = document.createElement("p"), Rv = l4.style, c4 = "Transform";
  for (var yv in Fv)
    if (yv + c4 in Rv) {
      Up = yv, Cb = Fv[yv];
      break;
    }
  Up === "Webkit" && "msHyphens" in Rv && (Up = "ms", Cb = Fv.ms, wI = "edge"), Up === "Webkit" && "-apple-trailing-word" in Rv && (kI = "apple");
}
var ba = {
  js: Up,
  css: Cb,
  vendor: kI,
  browser: wI,
  isTouch: s4
};
function d4(s) {
  return s[1] === "-" || ba.js === "ms" ? s : "@" + ba.css + "keyframes" + s.substr(10);
}
var u4 = {
  noPrefill: ["appearance"],
  supportedProperty: function(a) {
    return a !== "appearance" ? !1 : ba.js === "ms" ? "-webkit-" + a : ba.css + a;
  }
}, h4 = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(a) {
    return a !== "color-adjust" ? !1 : ba.js === "Webkit" ? ba.css + "print-" + a : a;
  }
}, A4 = /[-\s]+(.)?/g;
function g4(s, a) {
  return a ? a.toUpperCase() : "";
}
function _b(s) {
  return s.replace(A4, g4);
}
function eh(s) {
  return _b("-" + s);
}
var f4 = {
  noPrefill: ["mask"],
  supportedProperty: function(a, i) {
    if (!/^mask/.test(a)) return !1;
    if (ba.js === "Webkit") {
      var r = "mask-image";
      if (_b(r) in i)
        return a;
      if (ba.js + eh(r) in i)
        return ba.css + a;
    }
    return a;
  }
}, p4 = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(a) {
    return a !== "text-orientation" ? !1 : ba.vendor === "apple" && !ba.isTouch ? ba.css + a : a;
  }
}, m4 = {
  noPrefill: ["transform"],
  supportedProperty: function(a, i, r) {
    return a !== "transform" ? !1 : r.transform ? a : ba.css + a;
  }
}, v4 = {
  noPrefill: ["transition"],
  supportedProperty: function(a, i, r) {
    return a !== "transition" ? !1 : r.transition ? a : ba.css + a;
  }
}, b4 = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(a) {
    return a !== "writing-mode" ? !1 : ba.js === "Webkit" || ba.js === "ms" && ba.browser !== "edge" ? ba.css + a : a;
  }
}, F4 = {
  noPrefill: ["user-select"],
  supportedProperty: function(a) {
    return a !== "user-select" ? !1 : ba.js === "Moz" || ba.js === "ms" || ba.vendor === "apple" ? ba.css + a : a;
  }
}, R4 = {
  supportedProperty: function(a, i) {
    if (!/^break-/.test(a)) return !1;
    if (ba.js === "Webkit") {
      var r = "WebkitColumn" + eh(a);
      return r in i ? ba.css + "column-" + a : !1;
    }
    if (ba.js === "Moz") {
      var e = "page" + eh(a);
      return e in i ? "page-" + a : !1;
    }
    return !1;
  }
}, y4 = {
  supportedProperty: function(a, i) {
    if (!/^(border|margin|padding)-inline/.test(a)) return !1;
    if (ba.js === "Moz") return a;
    var r = a.replace("-inline", "");
    return ba.js + eh(r) in i ? ba.css + r : !1;
  }
}, Q4 = {
  supportedProperty: function(a, i) {
    return _b(a) in i ? a : !1;
  }
}, C4 = {
  supportedProperty: function(a, i) {
    var r = eh(a);
    return a[0] === "-" || a[0] === "-" && a[1] === "-" ? a : ba.js + r in i ? ba.css + a : ba.js !== "Webkit" && "Webkit" + r in i ? "-webkit-" + a : !1;
  }
}, U4 = {
  supportedProperty: function(a) {
    return a.substring(0, 11) !== "scroll-snap" ? !1 : ba.js === "ms" ? "" + ba.css + a : a;
  }
}, I4 = {
  supportedProperty: function(a) {
    return a !== "overscroll-behavior" ? !1 : ba.js === "ms" ? ba.css + "scroll-chaining" : a;
  }
}, B4 = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, Z4 = {
  supportedProperty: function(a, i) {
    var r = B4[a];
    return r && ba.js + eh(r) in i ? ba.css + r : !1;
  }
}, DI = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, S4 = Object.keys(DI), E4 = function(a) {
  return ba.css + a;
}, V4 = {
  supportedProperty: function(a, i, r) {
    var e = r.multiple;
    if (S4.indexOf(a) > -1) {
      var n = DI[a];
      if (!Array.isArray(n))
        return ba.js + eh(n) in i ? ba.css + n : !1;
      if (!e) return !1;
      for (var t = 0; t < n.length; t++)
        if (!(ba.js + eh(n[0]) in i))
          return !1;
      return n.map(E4);
    }
    return !1;
  }
}, MI = [u4, h4, f4, p4, m4, v4, b4, F4, R4, y4, Q4, C4, U4, I4, Z4, V4], XR = MI.filter(function(s) {
  return s.supportedProperty;
}).map(function(s) {
  return s.supportedProperty;
}), W4 = MI.filter(function(s) {
  return s.noPrefill;
}).reduce(function(s, a) {
  return s.push.apply(s, a4(a.noPrefill)), s;
}, []), Ip, Ph = {};
if (jp) {
  Ip = document.createElement("p");
  var Qv = window.getComputedStyle(document.documentElement, "");
  for (var Cv in Qv)
    isNaN(Cv) || (Ph[Qv[Cv]] = Qv[Cv]);
  W4.forEach(function(s) {
    return delete Ph[s];
  });
}
function Ub(s, a) {
  if (a === void 0 && (a = {}), !Ip) return s;
  if (XI.NODE_ENV !== "benchmark" && Ph[s] != null)
    return Ph[s];
  (s === "transition" || s === "transform") && (a[s] = s in Ip.style);
  for (var i = 0; i < XR.length && (Ph[s] = XR[i](s, Ip.style, a), !Ph[s]); i++)
    ;
  try {
    Ip.style[s] = "";
  } catch {
    return !1;
  }
  return Ph[s];
}
var JA = {}, N4 = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, J4 = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, L0;
function G4(s, a, i) {
  if (a === "var") return "var";
  if (a === "all") return "all";
  if (i === "all") return ", all";
  var r = a ? Ub(a) : ", " + Ub(i);
  return r || a || i;
}
jp && (L0 = document.createElement("p"));
function kR(s, a) {
  var i = a;
  if (!L0 || s === "content") return a;
  if (typeof i != "string" || !isNaN(parseInt(i, 10)))
    return i;
  var r = s + i;
  if (XI.NODE_ENV !== "benchmark" && JA[r] != null)
    return JA[r];
  try {
    L0.style[s] = i;
  } catch {
    return JA[r] = !1, !1;
  }
  if (N4[s])
    i = i.replace(J4, G4);
  else if (L0.style[s] === "" && (i = ba.css + i, i === "-ms-flex" && (L0.style[s] = "-ms-flexbox"), L0.style[s] = i, L0.style[s] === ""))
    return JA[r] = !1, !1;
  return L0.style[s] = "", JA[r] = i, JA[r];
}
function T4() {
  function s(e) {
    if (e.type === "keyframes") {
      var n = e;
      n.at = d4(n.at);
    }
  }
  function a(e) {
    for (var n in e) {
      var t = e[n];
      if (n === "fallbacks" && Array.isArray(t)) {
        e[n] = t.map(a);
        continue;
      }
      var o = !1, l = Ub(n);
      l && l !== n && (o = !0);
      var c = !1, d = kR(l, zh(t));
      d && d !== t && (c = !0), (o || c) && (o && delete e[n], e[l || n] = d || t);
    }
    return e;
  }
  function i(e, n) {
    return n.type !== "style" ? e : a(e);
  }
  function r(e, n) {
    return kR(n, zh(e)) || e;
  }
  return {
    onProcessRule: s,
    onProcessStyle: i,
    onChangeValue: r
  };
}
function X4() {
  var s = function(i, r) {
    return i.length === r.length ? i > r ? 1 : -1 : i.length - r.length;
  };
  return {
    onProcessStyle: function(i, r) {
      if (r.type !== "style") return i;
      for (var e = {}, n = Object.keys(i).sort(s), t = 0; t < n.length; t++)
        e[n[t]] = i[n[t]];
      return e;
    }
  };
}
var k4 = function(a) {
  return a === void 0 && (a = {}), {
    plugins: [yw(), Cw(a.observable), Sw(), Gw(), ww(), Lw(), xw(), NI(), jw(a.defaultUnit), t4(), T4(), X4()]
  };
}, Ib = { exports: {} };
(function(s, a) {
  function i(t, o) {
    if (!(t instanceof o)) throw new TypeError("Cannot call a class as a function");
  }
  var r = /* @__PURE__ */ function() {
    function t(o, l) {
      for (var c = 0; c < l.length; c++) {
        var d = l[c];
        d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(o, d.key, d);
      }
    }
    return function(o, l, c) {
      return l && t(o.prototype, l), c && t(o, c), o;
    };
  }(), e = Object.assign || function(t) {
    for (var o = 1; o < arguments.length; o++) {
      var l = arguments[o];
      for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (t[c] = l[c]);
    }
    return t;
  }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  };
  (function(t, o) {
    n(a) === "object" ? s.exports = o(a1) : t.OTKAnalytics = o();
  })(Dn, function(t) {
    var o = !1, l = void 0, c = function(p, v, b) {
      if (o) return v;
      var m = "", y = void 0;
      y = /* @__PURE__ */ new Date(), y.setTime(y.getTime() + 24 * b * 60 * 60 * 1e3), m = ["; expires=", y.toGMTString()].join("");
      var U = [p, "=", v, m, "; path=/"].join("");
      return document.cookie = U, v;
    }, d = function(p) {
      if (o) return null;
      for (var v = p + "=", b = document.cookie.split(";"), m = void 0, y = 0; y < b.length; y++) {
        for (m = b[y]; m.charAt(0) === " "; ) m = m.substring(1, m.length);
        if (m.indexOf(v) === 0) return m.substring(v.length, m.length);
      }
      return null;
    }, u = function() {
      for (var p = [], v = "0123456789abcdef", b = 0; b < 36; b++) p.push(v.substr(Math.floor(16 * Math.random()), 1));
      return p[14] = "4", p[19] = v.substr(3 & p[19] | 8, 1), p[8] = p[13] = p[18] = p[23] = "-", p.join("");
    }, h = function(p) {
      return d(p) || c(p, u(), 7);
    }, A = function(p) {
      if (!p.clientVersion) throw console.log("Error. The clientVersion field cannot be null in the log entry"), new Error("The clientVersion field cannot be null in the log entry");
      if (!p.source) throw console.log("Error. The source field cannot be null in the log entry"), new Error("The source field cannot be null in the log entry");
      if (!p.componentId) throw console.log("Error. The componentId field cannot be null in the log entry"), new Error("The componentId field cannot be null in the log entry");
      if (!p.name) throw console.log("Error. The name field cannot be null in the log entry"), new Error("The guid field cannot be null in the log entry");
      var v = p.logVersion || "2", b = p.clientSystemTime || (/* @__PURE__ */ new Date()).getTime();
      return e({}, p, { logVersion: v, clientSystemTime: b });
    }, g = function(p) {
      var v = A(p);
      if (o) t.post(l, v);
      else {
        var b = new XMLHttpRequest();
        b.open("POST", l, !0), b.setRequestHeader("Content-type", "application/json"), b.send(JSON.stringify(v));
      }
    }, f = function() {
      function p(v, b) {
        i(this, p), this.analyticsData = v, o = b && b.server;
        var m = "hlg.tokbox.com/prod/logging/ClientEvent";
        b && b.loggingUrl && (m = b.loggingUrl), l = b && b.proxyUrl && b.proxyUrl + "/" + m || "https://" + m, this.analyticsData.guid = h(v.name);
      }
      return r(p, [{ key: "addSessionInfo", value: function(v) {
        if (!v.sessionId) throw console.log("Error. The sessionId field cannot be null in the log entry"), new Error("The sessionId field cannot be null in the log entry");
        if (this.analyticsData.sessionId = v.sessionId, !v.connectionId) throw console.log("Error. The connectionId field cannot be null in the log entry"), new Error("The connectionId field cannot be null in the log entry");
        if (this.analyticsData.connectionId = v.connectionId, v.partnerId === 0) throw console.log("Error. The partnerId field cannot be null in the log entry"), new Error("The partnerId field cannot be null in the log entry");
        this.analyticsData.partnerId = v.partnerId;
      } }, { key: "logEvent", value: function(v) {
        this.analyticsData = e({}, this.analyticsData, v, { clientSystemTime: (/* @__PURE__ */ new Date()).getTime() }), g(this.analyticsData);
      } }]), p;
    }();
    return f;
  });
})(Ib, Ib.exports);
var w4 = Ib.exports;
const D4 = /* @__PURE__ */ d1(w4);
var Bb = { exports: {} };
(function(s, a) {
  (function(i, r) {
    var e = "1.0.38", n = "", t = "?", o = "function", l = "undefined", c = "object", d = "string", u = "major", h = "model", A = "name", g = "type", f = "vendor", p = "version", v = "architecture", b = "console", m = "mobile", y = "tablet", U = "smarttv", B = "wearable", Q = "embedded", N = 500, J = "Amazon", w = "Apple", W = "ASUS", G = "BlackBerry", Z = "Browser", K = "Chrome", L = "Edge", O = "Firefox", de = "Google", oe = "Huawei", fe = "LG", ge = "Microsoft", we = "Motorola", _e = "Opera", Te = "Samsung", Pe = "Sharp", $e = "Sony", Bt = "Xiaomi", Le = "Zebra", at = "Facebook", pt = "Chromium OS", kt = "Mac OS", _t = function(Ce, At) {
      var Ge = {};
      for (var Ye in Ce)
        At[Ye] && At[Ye].length % 2 === 0 ? Ge[Ye] = At[Ye].concat(Ce[Ye]) : Ge[Ye] = Ce[Ye];
      return Ge;
    }, Lt = function(Ce) {
      for (var At = {}, Ge = 0; Ge < Ce.length; Ge++)
        At[Ce[Ge].toUpperCase()] = Ce[Ge];
      return At;
    }, Ft = function(Ce, At) {
      return typeof Ce === d ? Zt(At).indexOf(Zt(Ce)) !== -1 : !1;
    }, Zt = function(Ce) {
      return Ce.toLowerCase();
    }, ft = function(Ce) {
      return typeof Ce === d ? Ce.replace(/[^\d\.]/g, n).split(".")[0] : r;
    }, It = function(Ce, At) {
      if (typeof Ce === d)
        return Ce = Ce.replace(/^\s\s*/, n), typeof At === l ? Ce : Ce.substring(0, N);
    }, Kt = function(Ce, At) {
      for (var Ge = 0, Ye, Qt, tn, vn, Yt, Tn; Ge < At.length && !Yt; ) {
        var er = At[Ge], lr = At[Ge + 1];
        for (Ye = Qt = 0; Ye < er.length && !Yt && er[Ye]; )
          if (Yt = er[Ye++].exec(Ce), Yt)
            for (tn = 0; tn < lr.length; tn++)
              Tn = Yt[++Qt], vn = lr[tn], typeof vn === c && vn.length > 0 ? vn.length === 2 ? typeof vn[1] == o ? this[vn[0]] = vn[1].call(this, Tn) : this[vn[0]] = vn[1] : vn.length === 3 ? typeof vn[1] === o && !(vn[1].exec && vn[1].test) ? this[vn[0]] = Tn ? vn[1].call(this, Tn, vn[2]) : r : this[vn[0]] = Tn ? Tn.replace(vn[1], vn[2]) : r : vn.length === 4 && (this[vn[0]] = Tn ? vn[3].call(this, Tn.replace(vn[1], vn[2])) : r) : this[vn] = Tn || r;
        Ge += 2;
      }
    }, Sn = function(Ce, At) {
      for (var Ge in At)
        if (typeof At[Ge] === c && At[Ge].length > 0) {
          for (var Ye = 0; Ye < At[Ge].length; Ye++)
            if (Ft(At[Ge][Ye], Ce))
              return Ge === t ? r : Ge;
        } else if (Ft(At[Ge], Ce))
          return Ge === t ? r : Ge;
      return Ce;
    }, Cn = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, on = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, An = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [p, [A, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [p, [A, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [A, p],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [p, [A, _e + " Mini"]],
        [
          /\bop(?:rg)?x\/([\w\.]+)/i
          // Opera GX
        ],
        [p, [A, _e + " GX"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [p, [A, _e]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [p, [A, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [A, p],
        [
          /\bddg\/([\w\.]+)/i
          // DuckDuckGo
        ],
        [p, [A, "DuckDuckGo"]],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [p, [A, "UC" + Z]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [p, [A, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [p, [A, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [p, [A, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [p, [A, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [p, [A, "Smart Lenovo " + Z]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[A, /(.+)/, "$1 Secure " + Z], p],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [p, [A, O + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [p, [A, _e + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [p, [A, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [p, [A, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [p, [A, _e + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [p, [A, "MIUI " + Z]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [p, [A, O]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[A, "360 " + Z]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[A, /(.+)/, "$1 " + Z], p],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [p, [A, Te + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[A, /_/g, " "], p],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [p, [A, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[A, "Sogou Mobile"], p],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [A, p],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [A],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[A, at], p],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(twitter)(?:and| f.+e\/([\w\.]+))/i,
          // Twitter
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [A, p],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [p, [A, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [p, [A, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [p, [A, K + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[A, K + " WebView"], p],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [p, [A, "Android " + Z]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [A, p],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [p, [A, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [p, A],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [A, [p, Sn, Cn]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [A, p],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[A, "Netscape"], p],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [p, [A, O + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [A, p],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [A, [p, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[v, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[v, Zt]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[v, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[v, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[v, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[v, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[v, /ower/, n, Zt]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[v, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[v, Zt]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [h, [f, Te], [g, y]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [h, [f, Te], [g, m]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [h, [f, w], [g, m]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [h, [f, w], [g, y]],
        [
          /(macintosh);/i
        ],
        [h, [f, w]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [h, [f, Pe], [g, m]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [h, [f, oe], [g, y]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [h, [f, oe], [g, m]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[h, /_/g, " "], [f, Bt], [g, m]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[h, /_/g, " "], [f, Bt], [g, y]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [h, [f, "OPPO"], [g, m]],
        [
          /\b(opd2\d{3}a?) bui/i
        ],
        [h, [f, "OPPO"], [g, y]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [h, [f, "Vivo"], [g, m]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [h, [f, "Realme"], [g, m]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [h, [f, we], [g, m]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [h, [f, we], [g, y]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [h, [f, fe], [g, y]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [h, [f, fe], [g, m]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [h, [f, "Lenovo"], [g, y]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[h, /_/g, " "], [f, "Nokia"], [g, m]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [h, [f, de], [g, y]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [h, [f, de], [g, m]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [h, [f, $e], [g, m]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[h, "Xperia Tablet"], [f, $e], [g, y]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [h, [f, "OnePlus"], [g, m]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [h, [f, J], [g, y]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[h, /(.+)/g, "Fire Phone $1"], [f, J], [g, m]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [h, f, [g, y]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [h, [f, G], [g, m]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [h, [f, W], [g, y]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [h, [f, W], [g, m]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [h, [f, "HTC"], [g, y]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [f, [h, /_/g, " "], [g, m]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [h, [f, "Acer"], [g, y]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [h, [f, "Meizu"], [g, m]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [h, [f, "Ulefone"], [g, m]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [f, h, [g, m]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [f, h, [g, y]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [h, [f, ge], [g, y]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [h, [f, "Fairphone"], [g, m]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [h, [f, "AT&T"], [g, m]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [h, [f, "Siemens"], [g, m]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [h, [f, "RCA"], [g, y]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [h, [f, "Dell"], [g, y]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [h, [f, "Verizon"], [g, y]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [h, [f, "Barnes & Noble"], [g, y]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [h, [f, "NuVision"], [g, y]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [h, [f, "ZTE"], [g, y]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [h, [f, "ZTE"], [g, m]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [h, [f, "Swiss"], [g, m]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [h, [f, "Swiss"], [g, y]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [h, [f, "Zeki"], [g, y]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[f, "Dragon Touch"], h, [g, y]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [h, [f, "Insignia"], [g, y]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [h, [f, "NextBook"], [g, y]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[f, "Voice"], h, [g, m]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[f, "LvTel"], h, [g, m]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [h, [f, "Essential"], [g, m]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [h, [f, "Envizen"], [g, y]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [h, [f, "MachSpeed"], [g, y]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [h, [f, "Rotor"], [g, y]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [h, [f, "Nvidia"], [g, y]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [f, h, [g, m]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[h, /\./g, " "], [f, ge], [g, m]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [h, [f, Le], [g, y]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [h, [f, Le], [g, m]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [f, [g, U]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[h, /^/, "SmartTV"], [f, Te], [g, U]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[f, fe], [g, U]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [f, [h, w + " TV"], [g, U]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[h, K + "cast"], [f, de], [g, U]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [h, [f, J], [g, U]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [h, [f, Pe], [g, U]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [h, [f, $e], [g, U]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [h, [f, Bt], [g, U]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [f, h, [g, U]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[f, It], [h, It], [g, U]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[g, U]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [f, h, [g, b]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [h, [f, "Nvidia"], [g, b]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [h, [f, $e], [g, b]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [h, [f, ge], [g, b]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [f, h, [g, B]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [h, [f, w], [g, B]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [h, [f, de], [g, B]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [h, [f, Le], [g, B]],
        [
          /(quest( \d| pro)?)/i
          // Oculus Quest
        ],
        [h, [f, at], [g, B]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [f, [g, Q]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [h, [f, J], [g, Q]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [h, [g, m]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [h, [g, y]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[g, y]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[g, m]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [h, [f, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [p, [A, L + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [p, [A, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [A, p],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [p, A]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [A, p],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [A, [p, Sn, on]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[p, Sn, on], [A, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[p, /_/g, "."], [A, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[A, kt], [p, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [p, A],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [A, p],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [p, [A, G]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [p, [A, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [p, [A, O + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [p, [A, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [p, [A, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [p, [A, K + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[A, pt], p],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [A, p],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[A, "Solaris"], p],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [A, p]
      ]
    }, Ue = function(Ce, At) {
      if (typeof Ce === c && (At = Ce, Ce = r), !(this instanceof Ue))
        return new Ue(Ce, At).getResult();
      var Ge = typeof i !== l && i.navigator ? i.navigator : r, Ye = Ce || (Ge && Ge.userAgent ? Ge.userAgent : n), Qt = Ge && Ge.userAgentData ? Ge.userAgentData : r, tn = At ? _t(An, At) : An, vn = Ge && Ge.userAgent == Ye;
      return this.getBrowser = function() {
        var Yt = {};
        return Yt[A] = r, Yt[p] = r, Kt.call(Yt, Ye, tn.browser), Yt[u] = ft(Yt[p]), vn && Ge && Ge.brave && typeof Ge.brave.isBrave == o && (Yt[A] = "Brave"), Yt;
      }, this.getCPU = function() {
        var Yt = {};
        return Yt[v] = r, Kt.call(Yt, Ye, tn.cpu), Yt;
      }, this.getDevice = function() {
        var Yt = {};
        return Yt[f] = r, Yt[h] = r, Yt[g] = r, Kt.call(Yt, Ye, tn.device), vn && !Yt[g] && Qt && Qt.mobile && (Yt[g] = m), vn && Yt[h] == "Macintosh" && Ge && typeof Ge.standalone !== l && Ge.maxTouchPoints && Ge.maxTouchPoints > 2 && (Yt[h] = "iPad", Yt[g] = y), Yt;
      }, this.getEngine = function() {
        var Yt = {};
        return Yt[A] = r, Yt[p] = r, Kt.call(Yt, Ye, tn.engine), Yt;
      }, this.getOS = function() {
        var Yt = {};
        return Yt[A] = r, Yt[p] = r, Kt.call(Yt, Ye, tn.os), vn && !Yt[A] && Qt && Qt.platform && Qt.platform != "Unknown" && (Yt[A] = Qt.platform.replace(/chrome os/i, pt).replace(/macos/i, kt)), Yt;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return Ye;
      }, this.setUA = function(Yt) {
        return Ye = typeof Yt === d && Yt.length > N ? It(Yt, N) : Yt, this;
      }, this.setUA(Ye), this;
    };
    Ue.VERSION = e, Ue.BROWSER = Lt([A, p, u]), Ue.CPU = Lt([v]), Ue.DEVICE = Lt([h, f, g, b, m, U, y, B, Q]), Ue.ENGINE = Ue.OS = Lt([A, p]), s.exports && (a = s.exports = Ue), a.UAParser = Ue;
    var ne = typeof i !== l && (i.jQuery || i.Zepto);
    if (ne && !ne.ua) {
      var se = new Ue();
      ne.ua = se.getResult(), ne.ua.get = function() {
        return se.getUA();
      }, ne.ua.set = function(Ce) {
        se.setUA(Ce);
        var At = se.getResult();
        for (var Ge in At)
          ne.ua[Ge] = At[Ge];
      };
    }
  })(typeof window == "object" ? window : Dn);
})(Bb, Bb.exports);
var M4 = Bb.exports;
const Y4 = /* @__PURE__ */ d1(M4);
/**
 * @license video-express.js 1.8.0 a545b67
 *
 * Copyright (c) 2010-2024 TokBox, Inc.
 * Subject to the applicable Software Development Kit (SDK) License Agreement:
 * https://www.vonage.com/legal/communications-apis/terms-of-use/
 *
 * Date: Fri, 28 Jun 2024 15:39:35 GMT
 */
function mo() {
  mo = function() {
    return s;
  };
  var s = {}, a = Object.prototype, i = a.hasOwnProperty, r = Object.defineProperty || function(G, Z, K) {
    G[Z] = K.value;
  }, e = typeof Symbol == "function" ? Symbol : {}, n = e.iterator || "@@iterator", t = e.asyncIterator || "@@asyncIterator", o = e.toStringTag || "@@toStringTag";
  function l(G, Z, K) {
    return Object.defineProperty(G, Z, {
      value: K,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), G[Z];
  }
  try {
    l({}, "");
  } catch {
    l = function(Z, K, L) {
      return Z[K] = L;
    };
  }
  function c(G, Z, K, L) {
    var O = Z && Z.prototype instanceof h ? Z : h, de = Object.create(O.prototype), oe = new J(L || []);
    return r(de, "_invoke", {
      value: U(G, K, oe)
    }), de;
  }
  function d(G, Z, K) {
    try {
      return {
        type: "normal",
        arg: G.call(Z, K)
      };
    } catch (L) {
      return {
        type: "throw",
        arg: L
      };
    }
  }
  s.wrap = c;
  var u = {};
  function h() {
  }
  function A() {
  }
  function g() {
  }
  var f = {};
  l(f, n, function() {
    return this;
  });
  var p = Object.getPrototypeOf, v = p && p(p(w([])));
  v && v !== a && i.call(v, n) && (f = v);
  var b = g.prototype = h.prototype = Object.create(f);
  function m(G) {
    ["next", "throw", "return"].forEach(function(Z) {
      l(G, Z, function(K) {
        return this._invoke(Z, K);
      });
    });
  }
  function y(G, Z) {
    function K(O, de, oe, fe) {
      var ge = d(G[O], G, de);
      if (ge.type !== "throw") {
        var we = ge.arg, _e = we.value;
        return _e && typeof _e == "object" && i.call(_e, "__await") ? Z.resolve(_e.__await).then(function(Te) {
          K("next", Te, oe, fe);
        }, function(Te) {
          K("throw", Te, oe, fe);
        }) : Z.resolve(_e).then(function(Te) {
          we.value = Te, oe(we);
        }, function(Te) {
          return K("throw", Te, oe, fe);
        });
      }
      fe(ge.arg);
    }
    var L;
    r(this, "_invoke", {
      value: function(O, de) {
        function oe() {
          return new Z(function(fe, ge) {
            K(O, de, fe, ge);
          });
        }
        return L = L ? L.then(oe, oe) : oe();
      }
    });
  }
  function U(G, Z, K) {
    var L = "suspendedStart";
    return function(O, de) {
      if (L === "executing") throw new Error("Generator is already running");
      if (L === "completed") {
        if (O === "throw") throw de;
        return W();
      }
      for (K.method = O, K.arg = de; ; ) {
        var oe = K.delegate;
        if (oe) {
          var fe = B(oe, K);
          if (fe) {
            if (fe === u) continue;
            return fe;
          }
        }
        if (K.method === "next") K.sent = K._sent = K.arg;
        else if (K.method === "throw") {
          if (L === "suspendedStart") throw L = "completed", K.arg;
          K.dispatchException(K.arg);
        } else K.method === "return" && K.abrupt("return", K.arg);
        L = "executing";
        var ge = d(G, Z, K);
        if (ge.type === "normal") {
          if (L = K.done ? "completed" : "suspendedYield", ge.arg === u) continue;
          return {
            value: ge.arg,
            done: K.done
          };
        }
        ge.type === "throw" && (L = "completed", K.method = "throw", K.arg = ge.arg);
      }
    };
  }
  function B(G, Z) {
    var K = Z.method, L = G.iterator[K];
    if (L === void 0) return Z.delegate = null, K === "throw" && G.iterator.return && (Z.method = "return", Z.arg = void 0, B(G, Z), Z.method === "throw") || K !== "return" && (Z.method = "throw", Z.arg = new TypeError("The iterator does not provide a '" + K + "' method")), u;
    var O = d(L, G.iterator, Z.arg);
    if (O.type === "throw") return Z.method = "throw", Z.arg = O.arg, Z.delegate = null, u;
    var de = O.arg;
    return de ? de.done ? (Z[G.resultName] = de.value, Z.next = G.nextLoc, Z.method !== "return" && (Z.method = "next", Z.arg = void 0), Z.delegate = null, u) : de : (Z.method = "throw", Z.arg = new TypeError("iterator result is not an object"), Z.delegate = null, u);
  }
  function Q(G) {
    var Z = {
      tryLoc: G[0]
    };
    1 in G && (Z.catchLoc = G[1]), 2 in G && (Z.finallyLoc = G[2], Z.afterLoc = G[3]), this.tryEntries.push(Z);
  }
  function N(G) {
    var Z = G.completion || {};
    Z.type = "normal", delete Z.arg, G.completion = Z;
  }
  function J(G) {
    this.tryEntries = [{
      tryLoc: "root"
    }], G.forEach(Q, this), this.reset(!0);
  }
  function w(G) {
    if (G) {
      var Z = G[n];
      if (Z) return Z.call(G);
      if (typeof G.next == "function") return G;
      if (!isNaN(G.length)) {
        var K = -1, L = function O() {
          for (; ++K < G.length; ) if (i.call(G, K)) return O.value = G[K], O.done = !1, O;
          return O.value = void 0, O.done = !0, O;
        };
        return L.next = L;
      }
    }
    return {
      next: W
    };
  }
  function W() {
    return {
      value: void 0,
      done: !0
    };
  }
  return A.prototype = g, r(b, "constructor", {
    value: g,
    configurable: !0
  }), r(g, "constructor", {
    value: A,
    configurable: !0
  }), A.displayName = l(g, o, "GeneratorFunction"), s.isGeneratorFunction = function(G) {
    var Z = typeof G == "function" && G.constructor;
    return !!Z && (Z === A || (Z.displayName || Z.name) === "GeneratorFunction");
  }, s.mark = function(G) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(G, g) : (G.__proto__ = g, l(G, o, "GeneratorFunction")), G.prototype = Object.create(b), G;
  }, s.awrap = function(G) {
    return {
      __await: G
    };
  }, m(y.prototype), l(y.prototype, t, function() {
    return this;
  }), s.AsyncIterator = y, s.async = function(G, Z, K, L, O) {
    O === void 0 && (O = Promise);
    var de = new y(c(G, Z, K, L), O);
    return s.isGeneratorFunction(Z) ? de : de.next().then(function(oe) {
      return oe.done ? oe.value : de.next();
    });
  }, m(b), l(b, o, "Generator"), l(b, n, function() {
    return this;
  }), l(b, "toString", function() {
    return "[object Generator]";
  }), s.keys = function(G) {
    var Z = Object(G), K = [];
    for (var L in Z) K.push(L);
    return K.reverse(), function O() {
      for (; K.length; ) {
        var de = K.pop();
        if (de in Z) return O.value = de, O.done = !1, O;
      }
      return O.done = !0, O;
    };
  }, s.values = w, J.prototype = {
    constructor: J,
    reset: function(G) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(N), !G) for (var Z in this) Z.charAt(0) === "t" && i.call(this, Z) && !isNaN(+Z.slice(1)) && (this[Z] = void 0);
    },
    stop: function() {
      this.done = !0;
      var G = this.tryEntries[0].completion;
      if (G.type === "throw") throw G.arg;
      return this.rval;
    },
    dispatchException: function(G) {
      if (this.done) throw G;
      var Z = this;
      function K(ge, we) {
        return de.type = "throw", de.arg = G, Z.next = ge, we && (Z.method = "next", Z.arg = void 0), !!we;
      }
      for (var L = this.tryEntries.length - 1; L >= 0; --L) {
        var O = this.tryEntries[L], de = O.completion;
        if (O.tryLoc === "root") return K("end");
        if (O.tryLoc <= this.prev) {
          var oe = i.call(O, "catchLoc"), fe = i.call(O, "finallyLoc");
          if (oe && fe) {
            if (this.prev < O.catchLoc) return K(O.catchLoc, !0);
            if (this.prev < O.finallyLoc) return K(O.finallyLoc);
          } else if (oe) {
            if (this.prev < O.catchLoc) return K(O.catchLoc, !0);
          } else {
            if (!fe) throw new Error("try statement without catch or finally");
            if (this.prev < O.finallyLoc) return K(O.finallyLoc);
          }
        }
      }
    },
    abrupt: function(G, Z) {
      for (var K = this.tryEntries.length - 1; K >= 0; --K) {
        var L = this.tryEntries[K];
        if (L.tryLoc <= this.prev && i.call(L, "finallyLoc") && this.prev < L.finallyLoc) {
          var O = L;
          break;
        }
      }
      O && (G === "break" || G === "continue") && O.tryLoc <= Z && Z <= O.finallyLoc && (O = null);
      var de = O ? O.completion : {};
      return de.type = G, de.arg = Z, O ? (this.method = "next", this.next = O.finallyLoc, u) : this.complete(de);
    },
    complete: function(G, Z) {
      if (G.type === "throw") throw G.arg;
      return G.type === "break" || G.type === "continue" ? this.next = G.arg : G.type === "return" ? (this.rval = this.arg = G.arg, this.method = "return", this.next = "end") : G.type === "normal" && Z && (this.next = Z), u;
    },
    finish: function(G) {
      for (var Z = this.tryEntries.length - 1; Z >= 0; --Z) {
        var K = this.tryEntries[Z];
        if (K.finallyLoc === G) return this.complete(K.completion, K.afterLoc), N(K), u;
      }
    },
    catch: function(G) {
      for (var Z = this.tryEntries.length - 1; Z >= 0; --Z) {
        var K = this.tryEntries[Z];
        if (K.tryLoc === G) {
          var L = K.completion;
          if (L.type === "throw") {
            var O = L.arg;
            N(K);
          }
          return O;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(G, Z, K) {
      return this.delegate = {
        iterator: w(G),
        resultName: Z,
        nextLoc: K
      }, this.method === "next" && (this.arg = void 0), u;
    }
  }, s;
}
function wR(s, a, i, r, e, n, t) {
  try {
    var o = s[n](t), l = o.value;
  } catch (c) {
    i(c);
    return;
  }
  o.done ? a(l) : Promise.resolve(l).then(r, e);
}
function al(s) {
  return function() {
    var a = this, i = arguments;
    return new Promise(function(r, e) {
      var n = s.apply(a, i);
      function t(l) {
        wR(n, r, e, t, o, "next", l);
      }
      function o(l) {
        wR(n, r, e, t, o, "throw", l);
      }
      t(void 0);
    });
  };
}
function L4(s, a) {
  for (var i = 0; i < a.length; i++) {
    var r = a[i];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(s, P4(r.key), r);
  }
}
function x4(s, a, i) {
  return a && L4(s.prototype, a), Object.defineProperty(s, "prototype", {
    writable: !1
  }), s;
}
function jh() {
  return jh = Object.assign ? Object.assign.bind() : function(s) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a];
      for (var r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (s[r] = i[r]);
    }
    return s;
  }, jh.apply(this, arguments);
}
function Nd(s, a) {
  s.prototype = Object.create(a.prototype), s.prototype.constructor = s, Zb(s, a);
}
function Zb(s, a) {
  return Zb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, e) {
    return r.__proto__ = e, r;
  }, Zb(s, a);
}
function YI(s, a) {
  if (s == null) return {};
  var i = {}, r = Object.keys(s), e, n;
  for (n = 0; n < r.length; n++)
    e = r[n], !(a.indexOf(e) >= 0) && (i[e] = s[e]);
  return i;
}
function xu(s) {
  if (s === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return s;
}
function H4(s, a) {
  if (typeof s != "object" || s === null) return s;
  var i = s[Symbol.toPrimitive];
  if (i !== void 0) {
    var r = i.call(s, a);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(s);
}
function P4(s) {
  var a = H4(s, "string");
  return typeof a == "symbol" ? a : String(a);
}
var LI = function(a) {
  if (a instanceof HTMLElement)
    return a;
  if (typeof a == "string") {
    var i = document.getElementById(a);
    if (!i) throw new Error("Invalid element. Element not found: " + a);
    return i;
  } else
    throw new Error("element must be string or HTMLElement. Found: " + a);
}, jm = function(a, i) {
  i === void 0 && (i = {});
  var r = document.createElement("div");
  return r.id = a, Object.entries(i).forEach(function(e) {
    var n = e[0], t = e[1];
    r.style.setProperty(n, t);
  }), r;
};
jb.setup(k4());
jb.use(NI());
var qA = function(a) {
  var i = jb.createStyleSheet(a).attach(), r = i.classes;
  return r;
}, x0 = {
  error: function() {
  },
  warn: function() {
  },
  info: function() {
  },
  debug: function() {
  }
}, H0 = function(a, i) {
  var r = a.indexOf(i);
  r > -1 && a.splice(r, 1);
}, DR = /* @__PURE__ */ function() {
  function s(i) {
    this.hiddenElements = [], this.visibleElements = [], this._elementsOrderedByDisplayPriority = [], this.PARTICIPANT_DISPLAY_LIMIT = i;
  }
  var a = s.prototype;
  return a._removeLastActiveVisibleElement = function() {
    var r = this, e = this.visibleElements[0];
    this.visibleElements.forEach(function(n) {
      r._elementsOrderedByDisplayPriority.indexOf(n) < r._elementsOrderedByDisplayPriority.indexOf(e) && (e = n);
    }), H0(this.visibleElements, e), this.hiddenElements.push(e);
  }, a.onActiveSpeakerChanged = function(r) {
    this._currentActiveSpeakerElement = r, r && (H0(this._elementsOrderedByDisplayPriority, r), this._elementsOrderedByDisplayPriority.push(r), this.hiddenElements.includes(r) && (H0(this.hiddenElements, this._currentActiveSpeakerElement), this.visibleElements.push(r)), this.visibleElements.length > this.PARTICIPANT_DISPLAY_LIMIT && this._removeLastActiveVisibleElement());
  }, a.onSubscriberCreated = function(r) {
    this.visibleElements.length >= this.PARTICIPANT_DISPLAY_LIMIT && this._removeLastActiveVisibleElement(), this.visibleElements.push(r), this._elementsOrderedByDisplayPriority.push(r);
  }, a.onSubscriberRemoved = function(r) {
    if (H0(this.hiddenElements, r), H0(this.visibleElements, r), H0(this._elementsOrderedByDisplayPriority, r), this.visibleElements.length < this.PARTICIPANT_DISPLAY_LIMIT && this.hiddenElements.length > 0) {
      var e = this.hiddenElements.pop();
      e && this.visibleElements.push(e);
    }
  }, s;
}(), O4 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNCAwQzQuNTQ3NjggMCA1LjA0NzkzIDAuMjAwMTIxIDUuNDI5NDIgMC41MzAxNDNMMS45ODE4NCAzLjk3NzcyQzEuODg1OTcgMy43MzY3NCAxLjgzMzMzIDMuNDc0NDIgMS44MzMzMyAzLjJWMi4xMzMzM0MxLjgzMzMzIDAuOTU1MiAyLjgwMzQ2IDAgNCAwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEgMy40NDQ0NEMxIDMuODc0NzggMS4xMTQ2OCA0LjI4MTMxIDEuMzE4MzUgNC42NDEyMUwwLjYxNzAzNCA1LjM0MjUyQzAuMjI2MjE5IDQuNzkzMzEgMCA0LjE0MjM2IDAgMy40NDQ0NEMwIDMuMTk4OTggMC4yMjM4NTggMyAwLjUgM0MwLjc3NjE0MiAzIDEgMy4xOTg5OCAxIDMuNDQ0NDRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMi4xMjIzNyA2LjU4NDczQzIuNTQyNTUgNi43ODM2NSAzLjAwNzM2IDYuOTE3ODkgMy41IDYuOTcyNDlWOEg0LjVWNi45NzI0OUM2LjQ3MzE2IDYuNzUzNzggOCA1LjI1NzYxIDggMy40NDQ0NEM4IDMuMTk4OTggNy43NzYxNCAzIDcuNSAzQzcuMjIzODYgMyA3IDMuMTk4OTggNyAzLjQ0NDQ0QzcgNC45MTcyMSA1LjY1Njg2IDYuMTExMTEgNCA2LjExMTExQzMuNTc4MzMgNi4xMTExMSAzLjE3Njk3IDYuMDMzNzggMi44MTI5MSA1Ljg5NDJMMy40NDQ1NCA1LjI2MjU3QzMuNjIxODEgNS4zMDg3NCAzLjgwNzk5IDUuMzMzMzMgNCA1LjMzMzMzQzUuMTk2NTQgNS4zMzMzMyA2LjE2NjY3IDQuMzc4MTMgNi4xNjY2NyAzLjJWMi41NDA0NEw3Ljg1MzU1IDAuODUzNTUzQzguMDQ4ODIgMC42NTgyOTEgOC4wNDg4MiAwLjM0MTcwOSA3Ljg1MzU1IDAuMTQ2NDQ3QzcuNjU4MjkgLTAuMDQ4ODE1NSA3LjM0MTcxIC0wLjA0ODgxNTUgNy4xNDY0NSAwLjE0NjQ0N0wwLjE0NjQ0NyA3LjE0NjQ1Qy0wLjA0ODgxNTUgNy4zNDE3MSAtMC4wNDg4MTU1IDcuNjU4MjkgMC4xNDY0NDcgNy44NTM1NUMwLjM0MTcwOSA4LjA0ODgxIDAuNjU4MjkxIDguMDQ4ODEgMC44NTM1NTMgNy44NTM1NUwyLjEyMjM3IDYuNTg0NzNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=", K4 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMS44MzMzMyAzLjJDMS44MzMzMyA0LjM3ODEzIDIuODAzNDYgNS4zMzMzMyA0IDUuMzMzMzNDNS4xOTY1NCA1LjMzMzMzIDYuMTY2NjcgNC4zNzgxMyA2LjE2NjY3IDMuMlYyLjEzMzMzQzYuMTY2NjcgMC45NTUyIDUuMTk2NTQgMCA0IDBDMi44MDM0NiAwIDEuODMzMzMgMC45NTUyIDEuODMzMzMgMi4xMzMzM1YzLjJaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMSAzLjQ0NDQ0QzEgMy4xOTg5OCAwLjc3NjE0MiAzIDAuNSAzQzAuMjIzODU4IDMgMCAzLjE5ODk4IDAgMy40NDQ0NEMwIDUuMjU3NjEgMS41MjY4NCA2Ljc1Mzc4IDMuNSA2Ljk3MjQ5VjhINC41VjYuOTcyNDlDNi40NzMxNiA2Ljc1Mzc4IDggNS4yNTc2MSA4IDMuNDQ0NDRDOCAzLjE5ODk4IDcuNzc2MTQgMyA3LjUgM0M3LjIyMzg2IDMgNyAzLjE5ODk4IDcgMy40NDQ0NEM3IDQuOTE3MjEgNS42NTY4NiA2LjExMTExIDQgNi4xMTExMUMyLjM0MzE0IDYuMTExMTEgMSA0LjkxNzIxIDEgMy40NDQ0NFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==", z4 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNi41IDEuNTAwMUM1LjEgMS41MDAxIDQgMi42MDAxIDQgNC4wMDAwOUM0IDUuNDAwMDkgNS4xIDYuNTAwMDkgNi41IDYuNTAwMDlWNy41MDAwOUM2LjUgNy45MDAwOSA2LjA1IDguMTAwMDkgNS43IDcuOTAwMDlMMi44NSA2LjAwMDA5SDAuNUMwLjIgNi4wMDAwOSAwIDUuODAwMDkgMCA1LjUwMDA5VjIuNTAwMUMwIDIuMjAwMDkgMC4yIDIuMDAwMSAwLjUgMi4wMDAxSDIuODVMNS43IDAuMTAwMDk1QzYuMDUgLTAuMTQ5OTA1IDYuNSAwLjEwMDA5NSA2LjUgMC41MDAwOTVWMS41MDAxWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTYuNDk5OTggMy4yOTI4OUw3LjIwNzA5IDIuNTg1NzlMNy45MTQyIDMuMjkyODlMNy4yMDcwOSA0TDcuOTE0MiA0LjcwNzExTDcuMjA3MDkgNS40MTQyMUw2LjQ5OTk4IDQuNzA3MTFMNS43OTI4OCA1LjQxNDIxTDUuMDg1NzcgNC43MDcxMUw1Ljc5Mjg4IDRMNS4wODU3NyAzLjI5Mjg5TDUuNzkyODggMi41ODU3OUw2LjQ5OTk4IDMuMjkyODlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=", j4 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNiA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNS41IDAuNTAwMDk1QzUuNSAwLjEwMDA5NSA1LjA1IC0wLjE0OTkwNSA0LjcgMC4xMDAwOTVMMS44NSAyLjAwMDFIMC41QzAuMiAyLjAwMDEgMCAyLjIwMDEgMCAyLjUwMDFWNS41MDAwOUMwIDUuODAwMSAwLjIgNi4wMDAwOSAwLjUgNi4wMDAwOUgxLjg1TDQuNyA3LjkwMDA5QzUuMDUgOC4xMDAwOSA1LjUgNy45MDAwOSA1LjUgNy41MDAwOVYwLjUwMDA5NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==", xI = /* @__PURE__ */ qA({
  audioButton: {
    position: "absolute",
    left: 12,
    bottom: 12,
    height: 24,
    width: 24,
    background: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(15px)",
    borderRadius: 6,
    opacity: 0,
    "transition-property": "opacity",
    "transition-duration": "0.5s",
    "transition-timing-function": "ease-in",
    "&:hover": {
      background: "#000000"
    },
    "&.audio-disabled": {
      background: "#E61D1D",
      opacity: 1
    },
    "&:hover.audio-disabled": {
      background: "#9F0202"
    },
    "&.audio-enabled .icon-disabled": {
      display: "none"
    },
    "&.audio-disabled .icon-enabled": {
      display: "none"
    },
    "&.subscriber-audio-button": {
      display: "none"
    }
  },
  icon: {
    height: 12,
    width: 12
  }
}), _m = function(a) {
  var i, r = document.createElement("img");
  r.src = a;
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), t = 1; t < e; t++)
    n[t - 1] = arguments[t];
  return (i = r.classList).add.apply(i, [xI.icon].concat(n)), r;
}, HI = function(a) {
  var i = a.isAudioEnabled, r = a.enabledIcon, e = a.disabledIcon, n = a.type, t = document.createElement("button");
  return t.classList.add(xI.audioButton, "video-audio-button", n === "publisher" ? "publisher-audio-button" : "subscriber-audio-button"), t.appendChild(r), t.appendChild(e), i ? t.classList.add("audio-enabled") : t.classList.add("audio-disabled"), {
    element: t,
    setEnabled: function() {
      t.classList.remove("audio-disabled"), t.classList.add("audio-enabled");
    },
    setDisabled: function() {
      t.classList.remove("audio-enabled"), t.classList.add("audio-disabled");
    }
  };
}, _4 = function(a) {
  var i = _m(O4, "icon-disabled"), r = _m(K4, "icon-enabled");
  return HI({
    isAudioEnabled: a,
    enabledIcon: r,
    disabledIcon: i,
    type: "publisher"
  });
}, $4 = function(a) {
  var i = _m(z4, "icon-disabled"), r = _m(j4, "icon-enabled");
  return HI({
    isAudioEnabled: a,
    enabledIcon: r,
    disabledIcon: i,
    type: "subscriber"
  });
}, q4 = /* @__PURE__ */ qA({
  name: {
    background: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(15px)",
    borderRadius: "6px",
    paddingLeft: "8px",
    paddingRight: "8px",
    textAlign: "center",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "24px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "80%",
    marginLeft: "12px"
  }
}), eD = function(a) {
  var i = document.createElement("div");
  return i.innerText = a, i.classList.add(q4.name, "participant-name"), i;
}, tD = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOSA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC43MDk5NjEgMS43ODgxNEMxLjgwMzcxIDAuODYzOTczIDMuMTk1NzYgMC4zNzk4ODMgNC42ODcyMyAwLjM3OTg4M0M2LjE3ODcxIDAuMzc5ODgzIDcuNTcwNzYgMC44NjM5NzMgOC42NjQ1MSAxLjc4ODE0TDcuOTY4NDkgMi40NDgyN0M3LjA3MzYgMS42NTYxMiA1LjkzMDEzIDEuMjYwMDUgNC42ODcyMyAxLjI2MDA1QzMuNDQ0MzQgMS4yNjAwNSAyLjMwMDg3IDEuNjU2MTIgMS40MDU5OCAyLjQwNDI2TDAuNzA5OTYxIDEuNzg4MTRaIiBmaWxsPSIjRTYxRDFEIi8+CjxwYXRoIGQ9Ik02LjQyNzM0IDMuOTAwNTRDNS45Nzk5IDMuNDYwNDYgNS4zMzM1OSAzLjI0MDQyIDQuNjg3MjggMy4yNDA0MkM0LjA0MDk4IDMuMjQwNDIgMy4zOTQ2NyAzLjQ2MDQ2IDIuOTQ3MjMgMy45MDA1NEwyLjI1MTIgMy4yODQ0MkMyLjg5NzUxIDIuNjY4MzEgMy43NDI2OCAyLjM2MDI1IDQuNjg3MjggMi4zNjAyNUM1LjYzMTg5IDIuMzYwMjUgNi40NzcwNiAyLjY2ODMxIDcuMTIzMzYgMy4yODQ0Mkw2LjQyNzM0IDMuOTAwNTRaIiBmaWxsPSIjRTYxRDFEIi8+CjxwYXRoIGQ9Ik00LjY4NzIzIDUuNjYwODdDNS4wOTkwOSA1LjY2MDg3IDUuNDMyOTcgNS4zNjUzMiA1LjQzMjk3IDUuMDAwNzRDNS40MzI5NyA0LjYzNjE3IDUuMDk5MDkgNC4zNDA2MiA0LjY4NzIzIDQuMzQwNjJDNC4yNzUzNyA0LjM0MDYyIDMuOTQxNSA0LjYzNjE3IDMuOTQxNSA1LjAwMDc0QzMuOTQxNSA1LjM2NTMyIDQuMjc1MzcgNS42NjA4NyA0LjY4NzIzIDUuNjYwODdaIiBmaWxsPSIjRTYxRDFEIi8+Cjwvc3ZnPg==", Cm = /* @__PURE__ */ qA({
  networkQualityWarning: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "24px",
    minWidth: "24px",
    background: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(15px)",
    borderRadius: "6px",
    opacity: 0
  },
  networkQualityIcon: {
    width: "20px",
    height: "20px"
  },
  active: {
    opacity: 1
  }
}), nD = function() {
  var a = document.createElement("div");
  a.classList.add(Cm.networkQualityWarning, "network-quality-warning");
  var i = document.createElement("img");
  return i.src = tD, i.classList.add(Cm.networkQualityIcon, "network-quality-warning-icon"), a.appendChild(i), {
    element: a,
    show: function() {
      return a.classList.add(Cm.active);
    },
    hide: function() {
      return a.classList.remove(Cm.active);
    }
  };
}, MR = /* @__PURE__ */ qA({
  videoOverlay: {
    position: "relative",
    width: "100%",
    height: "100%",
    zIndex: 1,
    "&:hover .video-audio-button": {
      opacity: 1
    }
  },
  bottomRightContainer: {
    maxWidth: "calc(100% - 68px)",
    position: "absolute",
    bottom: 12,
    top: "auto",
    right: 12,
    display: "flex",
    width: "100%",
    justifyContent: "flex-end"
  }
}), PI = function(a) {
  var i = a.targetId, r = a.participantName, e = a.isAudioEnabled, n = a.type, t = document.getElementById(i);
  if (t) {
    var o, l, c;
    n === "publisher" ? (o = "MP_publisher_overlay", l = "MP_camera_publisher_default_controls", c = _4(e)) : (o = "MP_subscriber_overlay", l = "MP_" + i + "_default_controls", c = $4(e));
    var d = jm(l);
    d.classList.add(MR.videoOverlay, o), d.appendChild(c.element);
    var u = document.createElement("div");
    u.classList.add(MR.bottomRightContainer);
    var h = nD();
    if (u.appendChild(h.element), r) {
      var A = eD(r);
      u.appendChild(A);
    }
    d.appendChild(u), t.appendChild(d);
    var g = Object.assign(new Qd.EventEmitter(), {
      setAudioEnabled: c.setEnabled,
      setAudioDisabled: c.setDisabled,
      showNetworkQualityWarning: h.show,
      hideNetworkQualityWarning: h.hide
    });
    return c.element.addEventListener("click", function() {
      g.emit("toggleAudioClicked");
    }), g;
  }
}, rD = function(a) {
  var i = a.id, r = a.isAudioEnabled, e = a.participantName;
  return PI({
    targetId: i,
    isAudioEnabled: r,
    participantName: e,
    type: "publisher"
  });
}, iD = function(a) {
  var i = a.id, r = a.participantName;
  return PI({
    targetId: i,
    isAudioEnabled: !0,
    participantName: r,
    type: "subscriber"
  });
}, OI = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i) {
    var r;
    r = s.call(this) || this, r._toggleAudioEnabled = function() {
      r._subscribingToAudio ? r.disableAudio() : r.enableAudio();
    }, r.getSubscriberElement = function() {
      var t;
      return (t = r.otSubscriber) == null ? void 0 : t.element;
    }, r.isVideoEnabled = function() {
      var t, o;
      return !!((t = r.otSubscriber) != null && (o = t.stream) != null && o.hasVideo);
    }, r.isAudioEnabled = function() {
      var t, o;
      return !!((t = r.otSubscriber) != null && (o = t.stream) != null && o.hasAudio);
    }, r._setSubscribeToVideo = function(t) {
      var o;
      return (o = r.otSubscriber) == null ? void 0 : o.subscribeToVideo(t);
    }, r.enableVideo = function() {
      var t;
      (t = r.otSubscriber) == null || t.subscribeToVideo(!0);
    }, r.disableVideo = function() {
      var t;
      return (t = r.otSubscriber) == null ? void 0 : t.subscribeToVideo(!1);
    }, r.enableAudio = function() {
      var t, o;
      (t = r.otSubscriber) == null || t.subscribeToAudio(!0), r._subscribingToAudio = !0, (o = r.overlay) == null || o.setAudioEnabled();
    }, r.disableAudio = function() {
      var t, o;
      (t = r.otSubscriber) == null || t.subscribeToAudio(!1), r._subscribingToAudio = !1, (o = r.overlay) == null || o.setAudioDisabled();
    }, r.setDisabledImageURI = function(t) {
      var o;
      (o = r.otSubscriber) == null || o.setStyle("backgroundImageURI", t);
    }, r.otSubscriber = i, r.id = i.id, r._subscribingToAudio = !0;
    var e = function(o) {
      r.emit("audioLevelUpdated", o.audioLevel);
    }, n = f1(e, 60, {
      // So we don't send events after stream is destroyed
      leading: !0,
      trailing: !1
    });
    return r.otSubscriber.on("audioLevelUpdated", n), r.otSubscriber.on("destroyed", function() {
      return r.emit("destroyed");
    }), r.otSubscriber.on("videoElementCreated", function() {
      var t, o;
      if (((t = r.otSubscriber) == null || (o = t.stream) == null ? void 0 : o.videoType) !== "screen" && r.id) {
        var l, c, d;
        r.overlay = iD({
          id: r.id,
          participantName: (l = (c = r.otSubscriber.stream) == null ? void 0 : c.name) != null ? l : ""
        }), (d = r.overlay) == null || d.on("toggleAudioClicked", function() {
          r._toggleAudioEnabled();
        });
      }
      r.emit("videoElementCreated");
    }), r.otSubscriber.on("videoDisableWarning", function() {
      var t;
      return (t = r.overlay) == null ? void 0 : t.showNetworkQualityWarning();
    }), r.otSubscriber.on("videoDisableWarningLifted", function() {
      var t;
      return (t = r.overlay) == null ? void 0 : t.hideNetworkQualityWarning();
    }), r.otSubscriber.on("videoDisabled", function(t) {
      var o = t.reason;
      if (o === "quality") {
        var l;
        (l = r.overlay) == null || l.showNetworkQualityWarning();
      }
    }), r.otSubscriber.on("videoEnabled", function(t) {
      var o = t.reason;
      if (o === "quality") {
        var l;
        (l = r.overlay) == null || l.hideNetworkQualityWarning();
      }
    }), r;
  }
  return a;
}(Qd.EventEmitter), Gr = {
  attempt: "Attempt",
  success: "Success",
  failure: "Failure"
}, Tr = {
  // vars for the analytics logs. Internal use
  initRoom: "InitRoom",
  joinRoom: "JoinRoom",
  leaveRoom: "LeaveRoom",
  startScreenSharing: "StartScreenSharing",
  stopScreenSharing: "StopScreenSharing",
  publishCameraPublisher: "PublishCameraPublisher",
  destroyCameraPublisher: "DestroyCameraPublisher",
  cameraPublisherEnableVideo: "CameraPublisherEnableVideo",
  cameraPublisherEnableAudio: "CameraPublisherEnableAudio",
  cameraPublisherDisableVideo: "CameraPublisherDisableVideo",
  cameraPublisherDisableAudio: "CameraPublisherDisableAudio",
  screenPublisherEnableVideo: "ScreenPublisherEnableVideo",
  screenPublisherEnableAudio: "ScreenPublisherEnableAudio",
  screenPublisherDisableVideo: "ScreenPublisherDisableVideo",
  screenPublisherDisableAudio: "ScreenPublisherDisableAudio",
  cameraSubscriberEnableVideo: "CameraSubscriberEnableVideo",
  cameraSubscriberEnableAudio: "CameraSubscriberEnableAudio",
  cameraSubscriberDisableVideo: "CameraSubscriberDisableVideo",
  cameraSubscriberDisableAudio: "CameraSubscriberDisableAudio",
  screenSubscriberEnableVideo: "ScreenSubscriberEnableVideo",
  screenSubscriberEnableAudio: "ScreenSubscriberEnableAudio",
  screenSubscriberDisableVideo: "ScreenSubscriberDisableVideo",
  screenSubscriberDisableAudio: "ScreenSubscriberDisableAudio",
  initPreviewPublisher: "InitPreviewPublisher",
  destroyPreviewPublisher: "DestroyPreviewPublisher",
  previewPublisherEnableVideo: "PreviewPublisherEnableVideo",
  previewPublisherEnableAudio: "PreviewPublisherEnableAudio",
  previewPublisherDisableVideo: "PreviewPublisherDisableVideo",
  previewPublisherDisableAudio: "PreviewPublisherDisableAudio",
  setVideoDevice: "SetVideoDevice",
  setAudioDevice: "SetAudioDevice",
  getAudioOutputDevices: "GetAudioOutputDevices",
  getActiveAudioOutputDevice: "GetActiveAudioOutputDevice",
  getVideoDevice: "GetVideoDevice",
  getAudioDevice: "GetAudioDevice",
  getDevices: "GetDevices",
  createCameraSubscriber: "CreateCameraSubscriber",
  createScreenSubscriber: "CreateScreenSubscriber",
  setProxyUrl: "SetProxyUrl",
  setAudioOutputDevice: "SetAudioOutputDevice",
  setVideoFilter: "SetVideoFilter",
  clearVideoFilter: "ClearVideoFilter",
  setEncryptionSecret: "SetEncryptionSecret"
}, oD = {
  source: window.location.origin
}, _p = function(a) {
  var i = this;
  a === void 0 && (a = oD), this.update = function(u, h, A) {
    if (u && h && A) {
      var g = {
        sessionId: u,
        connectionId: h,
        partnerId: A
      };
      i.analytics.addSessionInfo(g);
    }
  }, this.log = function(u, h, A) {
    var g = {
      action: u,
      variation: h
    };
    A && (g.payload = A), i.analytics.logEvent(g);
  };
  var r = a, e = r.source, n = e === void 0 ? window.location.origin : e, t = r.sessionId, o = r.connectionId, l = r.apiKey, c = {
    clientVersion: "video-express-1.8.0",
    source: n,
    componentId: "video-express",
    name: "video-express",
    partnerId: l,
    sessionId: t
  }, d = {};
  this.analytics = new D4(c, d), t && o && l && this.update(t, o, l);
}, aD = "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", KI = "data:image/png;base64," + aD, zI = /* @__PURE__ */ qA({
  subscriberOnLoad: {
    display: ["none", "!important"]
  }
}), sD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i, r, e) {
    var n;
    n = s.call(this) || this, n._stream = i, n.movingAvg = null;
    var t = new OI(r);
    return n.id = t.id, t.on("audioLevelUpdated", function(o) {
      n.movingAvg === null || n.movingAvg <= o ? n.movingAvg = o : n.movingAvg = 0.7 * n.movingAvg + 0.3 * o;
      var l = Math.log(n.movingAvg) / Math.LN10 / 1.5 + 1;
      l = Math.min(Math.max(l, 0), 1), n.emit("audioLevelUpdated", o, l);
    }), t.on("destroyed", function() {
      n.emit("destroyed");
    }), t.on("videoElementCreated", function() {
      n.emit("created");
    }), n.setOptimalPreferredResolution = function() {
      if (t) {
        var o, l, c = t.otSubscriber, d = (o = c.element) == null ? void 0 : o.offsetWidth, u = (l = c.element) == null ? void 0 : l.offsetHeight;
        if (d && u) {
          var h = {
            width: d * window.devicePixelRatio,
            height: u * window.devicePixelRatio
          };
          c.setPreferredResolution(h);
        }
      }
    }, n.getSubscriberElement = function() {
      return t == null ? void 0 : t.getSubscriberElement();
    }, n.isVideoEnabled = function() {
      return t == null ? void 0 : t.isVideoEnabled();
    }, n.isAudioEnabled = function() {
      return t == null ? void 0 : t.isAudioEnabled();
    }, n.enableVideo = function() {
      e.log(Tr.cameraSubscriberEnableVideo, Gr.attempt), t ? (t.enableVideo(), x0.debug("Enabled subscriber video: ", n.id), e.log(Tr.cameraSubscriberEnableVideo, Gr.success)) : e.log(Tr.cameraSubscriberEnableVideo, Gr.failure);
    }, n.disableVideo = function() {
      e.log(Tr.cameraSubscriberDisableVideo, Gr.attempt), t ? (t.disableVideo(), x0.debug("Disabled subscriber video: ", n.id), e.log(Tr.cameraSubscriberDisableVideo, Gr.success)) : e.log(Tr.cameraSubscriberDisableVideo, Gr.failure);
    }, n.enableAudio = function() {
      e.log(Tr.cameraSubscriberEnableAudio, Gr.attempt), t ? (t.enableAudio(), e.log(Tr.cameraSubscriberEnableAudio, Gr.success)) : e.log(Tr.cameraSubscriberEnableAudio, Gr.failure);
    }, n.disableAudio = function() {
      e.log(Tr.cameraSubscriberDisableAudio, Gr.attempt), t ? (t.disableAudio(), e.log(Tr.cameraSubscriberDisableAudio, Gr.success)) : e.log(Tr.cameraSubscriberDisableAudio, Gr.failure);
    }, n.setDisabledImageURI = function(o) {
      t.setDisabledImageURI(o);
    }, n;
  }
  return a;
}(Qd.EventEmitter), lD = function(a, i, r, e, n) {
  var t = function() {
    return i.initials ? "" : KI;
  }, o = a.subscribe(i, "layoutContainer", {
    insertMode: "append",
    subscribeToVideo: r,
    style: {
      buttonDisplayMode: "off",
      nameDisplayMode: "off",
      videoDisabledDisplayMode: "off",
      backgroundImageURI: t()
    }
  }, function(c) {
    if (e.log(Tr.createCameraSubscriber, Gr.attempt), c)
      e.log(Tr.createCameraSubscriber, Gr.failure, {
        error: c
      }), n(c);
    else {
      var d = new sD(i, o, e);
      n(void 0, d), e.log(Tr.createCameraSubscriber, Gr.success);
    }
  });
  if (o.element instanceof HTMLElement) {
    var l;
    (l = o.element) == null || l.classList.add(zI.subscriberOnLoad);
  }
}, cD = ["layoutMode"], Sb = "OT_big", dD = 3, uD = 25, Tm = "active_speaker_highlight", hD = "#53CA6A", Uv = {
  fixedRatio: !1,
  alignItems: "center",
  bigPercentage: 0.8,
  bigFixedRatio: !1,
  bigAlignItems: "center",
  smallAlignItems: "center",
  maxWidth: 1 / 0,
  maxHeight: 1 / 0,
  smallMaxWidth: 1 / 0,
  smallMaxHeight: 1 / 0,
  bigMaxWidth: 1 / 0,
  bigMaxHeight: 1 / 0,
  bigMaxRatio: 3 / 2,
  bigMinRatio: 9 / 16,
  bigFirst: !0
}, AD = {
  bigClass: Sb,
  window,
  animate: !1,
  ignoreClass: "OT_ignore"
}, gD = function(a) {
  var i, r = 8, e = 2 * r;
  return qA({
    layoutContainer: (i = {
      margin: r,
      width: "calc(100% - " + e + "px)",
      height: "calc(100% - " + e + "px)",
      position: "relative",
      "& > *": {
        width: 0,
        height: 0,
        opacity: 0
      },
      "& > .ot-layout": {
        opacity: 1
      },
      "& > .OT_publisher, & > .OT_subscriber": {
        margin: 4,
        borderRadius: 16,
        // Fix for safari border radius https://stackoverflow.com/a/16681137/5433407
        "-webkit-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)"
      },
      "& > .OT_subscriber.MP_screenshare_subscriber": {
        borderRadius: 0
      }
    }, i["& > .OT_subscriber." + Tm] = {
      borderColor: "" + (a || hD),
      borderWidth: "3px",
      borderStyle: "solid"
    }, i),
    layoutContainerWrapper: {
      width: "100%",
      height: "100%",
      overflow: "auto"
    }
  });
}, fD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(r, e, n) {
    var t;
    t = s.call(this) || this, t._screenSharingElementIds = [], t._cameraSubscriberElementIds = [], t._layoutMode = "grid", t.isViewingScreenshare = !1, t._initLayoutContainerElement = function(h) {
      var A = LI(h), g = jm("layoutContainer"), f = jm("layoutContainerWrapper"), p = gD(t._speakerHighlightColor);
      return g.classList.add(p.layoutContainer), f.classList.add(p.layoutContainerWrapper), f.appendChild(g), A.appendChild(f), g;
    }, t._initContainerResizeListener = function() {
      var h = f1(function() {
        return t._recalculateTileSizes();
      }, 20), A = new rk(function() {
        h();
      });
      A.observe(t._layoutContainerElement);
    }, t.setLayoutMode = function(h) {
      t._layoutMode = h, t.updateLayout();
    }, t._setElementBig = function(h) {
      h.classList.add(Sb);
    }, t._setElementSmall = function(h) {
      h.classList.remove(Sb);
    }, t._hideElement = function(h) {
      var A = getComputedStyle(h);
      A.display !== "none" && (h.style.display = "none", t._cameraSubscriberElementIds.includes(h.id) && t.emit("cameraSubscriberHidden", h.id));
    }, t._displayElement = function(h) {
      var A = getComputedStyle(h);
      A.display !== "block" && (h.style.display = "block", t._cameraSubscriberElementIds.includes(h.id) && t.emit("cameraSubscriberDisplayed", h.id));
    }, t._removeSubscriberOnLoad = function(h) {
      h.classList.remove(zI.subscriberOnLoad);
    }, t._setAllElementsSmall = function() {
      t._layoutContainerElement.childNodes.forEach(function(h) {
        h instanceof HTMLElement && t._setElementSmall(h);
      });
    }, t._setOnlyScreenElementsBig = function() {
      t._layoutContainerElement.childNodes.forEach(function(h) {
        h instanceof HTMLElement && (t._screenSharingElementIds.includes(h.id) ? t._setElementBig(h) : t._setElementSmall(h));
      });
    }, t._setOnlyActiveSpeakerElementBig = function() {
      var h = t._getActiveSpeakerViewLargeElement();
      t._setAllElementsSmall(), h && t._setElementBig(h);
    }, t._getActiveSpeakerViewLargeElement = function() {
      if (t._activeSpeakerElement)
        return t._activeSpeakerElement;
      var h = t._layoutContainerElement.querySelector(".OT_subscriber");
      if (h)
        return h;
      var A = t._layoutContainerElement.querySelector(".OT_publisher");
      if (A)
        return A;
    }, t._displayOnlyScreenElement = function() {
      t._layoutContainerElement.childNodes.forEach(function(h) {
        h instanceof HTMLElement && (t._screenSharingElementIds.includes(h.id) ? t._setElementBig(h) : t._hideElement(h));
      });
    }, t._displayOnlyActiveSpeaker = function() {
      var h = t._getActiveSpeakerViewLargeElement();
      t._layoutContainerElement.childNodes.forEach(function(A) {
        if (A instanceof HTMLElement)
          A !== h ? t._hideElement(A) : t._displayElement(A);
        else return;
      });
    }, t._displayLimitedGridElements = function() {
      t._layoutContainerElement.childNodes.forEach(function(h) {
        var A;
        if (h instanceof HTMLElement)
          (A = t._hiddenTileTracker) != null && A.hiddenElements.includes(h) ? t._hideElement(h) : t._displayElement(h);
        else return;
      });
    }, t._isSubscribingToScreen = function() {
      return t._screenSharingElementIds.length > 0;
    }, t.onScreenSubscriberCreated = function(h) {
      h && (t._screenSharingElementIds.push(h), t.isViewingScreenshare = !0), t.updateLayout();
    }, t.onScreenSubscriberDestroyed = function(h) {
      h && H0(t._screenSharingElementIds, h), t._screenSharingElementIds.length === 0 && (t.isViewingScreenshare = !1), t.updateLayout();
    }, t.onCameraSubscriberCreated = function(h) {
      if (h) {
        var A;
        (A = t._hiddenTileTracker) == null || A.onSubscriberCreated(h), t._cameraSubscriberElementIds.push(h.id), t.emit("cameraSubscriberDisplayed", h.id);
      }
      t.updateLayout();
    }, t.onCameraSubscriberDestroyed = function(h) {
      if (h) {
        var A;
        (A = t._hiddenTileTracker) == null || A.onSubscriberRemoved(h), H0(t._cameraSubscriberElementIds, h.id);
      }
      t.updateLayout();
    };
    var o = e.layoutMode, l = o === void 0 ? "grid" : o, c = YI(e, cD);
    t._layoutMode = l, t._isMobileLayout = e.isMobileLayout, t._speakerHighlightColor = e.speakerHighlightColor, t._speakerHighlightEnabled = e.speakerHighlightEnabled, t._speakerHighlightColor && t._speakerHighlightEnabled;
    var d = t._isMobileLayout ? 16 / 9 : 14 / 16, u = t._isMobileLayout ? 3 / 2 : 9 / 16;
    return Uv.maxRatio = d, Uv.minRatio = u, t._layoutContainerElement = t._initLayoutContainerElement(r), t._emitLayoutRecalculated = QI(function() {
      t.emit("layoutComplete");
    }, 20), t._layoutContainer = wX(t._layoutContainerElement, jh({}, Uv, c, AD)), t._initContainerResizeListener(), t._isMobileLayout ? t._hiddenTileTracker = new DR(dD) : t._hiddenTileTracker = new DR(n || uD), t;
  }
  var i = a.prototype;
  return i.onActiveSpeakerChanged = function(e) {
    var n, t = e.newActiveSpeakerElement, o = e.previousActiveSpeakerElement;
    this._activeSpeakerElement = t, this._speakerHighlightEnabled && (o && o.classList.remove(Tm), t && t.classList.add(Tm)), (n = this._hiddenTileTracker) == null || n.onActiveSpeakerChanged(t), this.updateLayout();
  }, i.onActiveSpeakerStatusChanged = function(e) {
    var n = e.isSpeaking;
    if (this._speakerHighlightEnabled) {
      var t, o = n ? "add" : "remove";
      (t = this._activeSpeakerElement) == null || t.classList[o](Tm);
    }
  }, i._recalculateTileSizes = function() {
    this._layoutContainer.layout(), this._emitLayoutRecalculated();
  }, i.getLayoutContainerElement = function() {
    return this._layoutContainerElement;
  }, i.updateLayout = function() {
    this._isMobileLayout ? this.isViewingScreenshare ? this._displayOnlyScreenElement() : this._layoutMode === "active-speaker" ? this._displayOnlyActiveSpeaker() : this._displayLimitedGridElements() : (this.isViewingScreenshare ? this._setOnlyScreenElementsBig() : this._layoutMode === "active-speaker" ? this._setOnlyActiveSpeakerElementBig() : this._setAllElementsSmall(), this._displayLimitedGridElements()), this._recalculateTileSizes();
  }, a;
}(Qd.EventEmitter), Iv = /* @__PURE__ */ new _p(), jI = function() {
  return new Promise(function(a, i) {
    Iv.log(Tr.getDevices, Gr.attempt), q0.getDevices(function(r, e) {
      r && (Iv.log(Tr.getDevices, Gr.failure, {
        error: r
      }), i(r)), Iv.log(Tr.getDevices, Gr.success), a(e);
    });
  });
}, pD = function(a) {
  return a.getSettings ? a.getSettings().deviceId : "";
}, mD = /* @__PURE__ */ function() {
  var s = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function a(i) {
    var r, e, n;
    return mo().wrap(function(o) {
      for (; ; ) switch (o.prev = o.next) {
        case 0:
          return e = null, o.prev = 1, o.next = 4, jI();
        case 4:
          r = o.sent, r && r.length && (n = r.find(function(l) {
            return l.label === i.label;
          }), n && (e = n.deviceId)), o.next = 10;
          break;
        case 8:
          o.prev = 8, o.t0 = o.catch(1);
        case 10:
          return o.abrupt("return", e);
        case 11:
        case "end":
          return o.stop();
      }
    }, a, null, [[1, 8]]);
  }));
  return function(i) {
    return s.apply(this, arguments);
  };
}(), vD = /* @__PURE__ */ function() {
  var s = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function a(i) {
    return mo().wrap(function(e) {
      for (; ; ) switch (e.prev = e.next) {
        case 0:
          if (e.t1 = pD(i), e.t1) {
            e.next = 5;
            break;
          }
          return e.next = 4, mD(i);
        case 4:
          e.t1 = e.sent;
        case 5:
          if (e.t0 = e.t1, e.t0) {
            e.next = 8;
            break;
          }
          e.t0 = "";
        case 8:
          return e.abrupt("return", e.t0);
        case 9:
        case "end":
          return e.stop();
      }
    }, a);
  }));
  return function(i) {
    return s.apply(this, arguments);
  };
}(), _I = function(a, i) {
  var r = function(t) {
    a.emit("audioLevelUpdated", t.audioLevel);
  }, e = f1(r, 60, {
    // So we don't send events after stream is destroyed
    leading: !0,
    trailing: !1
  });
  i.on("destroyed", function() {
    return a.onDestroyed();
  }), i.on("videoElementCreated", a._onVideoElementCreated), a.source === "camera" && (i.on("audioLevelUpdated", e), i.on("accessAllowed", function() {
    a.emit("accessAllowed");
  }), i.on("accessDenied", function() {
    a.emit("accessDenied");
  }), i.on("accessDialogOpened", function() {
    a.emit("accessDialogOpened");
  }), i.on("accessDialogClosed", function(n) {
    a.emit("accessDialogClosed", n);
  }));
}, bD = function(a, i, r) {
  return new Promise(function(e, n) {
    var t = function() {
      var c;
      return (i == null || (c = i.style) == null ? void 0 : c.backgroundImageURI) || (r.initials ? "" : KI);
    }, o = q0.initPublisher(a, jh({}, i, {
      insertMode: "append",
      style: {
        buttonDisplayMode: "off",
        nameDisplayMode: "off",
        backgroundImageURI: t()
      },
      initials: r.initials
    }), function(l) {
      l ? n(l) : e(o);
    });
    o && (r.otPublisher = o, _I(r, o));
  });
}, FD = function(a, i, r) {
  return new Promise(function(e, n) {
    q0.checkScreenSharingCapability(function(t) {
      if (!t.supported || t.extensionRegistered === !1)
        n("Screen sharing not supported for this browser");
      else {
        var o = q0.initPublisher(a, jh({
          videoSource: "screen",
          insertMode: "append",
          showControls: !1,
          videoContentHint: "detail"
        }, i), function(l) {
          l ? n(l) : e(o);
        });
        _I(r, o);
      }
    });
  });
}, Eb = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i, r, e) {
    var n;
    return i === void 0 && (i = "camera"), n = s.call(this) || this, n.initOTPublisher = /* @__PURE__ */ function() {
      var t = al(/* @__PURE__ */ mo().mark(function o(l, c) {
        var d, u;
        return mo().wrap(function(A) {
          for (; ; ) switch (A.prev = A.next) {
            case 0:
              if (n._otPublisherPromise) {
                A.next = 15;
                break;
              }
              return d = bD, n.source === "screen" && (d = FD), n._otPublisherPromise = d(l, c, xu(n)), A.prev = 4, A.next = 7, n._otPublisherPromise;
            case 7:
              u = A.sent, A.next = 14;
              break;
            case 10:
              throw A.prev = 10, A.t0 = A.catch(4), n._otPublisherPromise = void 0, A.t0;
            case 14:
              n.otPublisher = u;
            case 15:
              return A.next = 17, n._otPublisherPromise;
            case 17:
              return A.abrupt("return", A.sent);
            case 18:
            case "end":
              return A.stop();
          }
        }, o, null, [[4, 10]]);
      }));
      return function(o, l) {
        return t.apply(this, arguments);
      };
    }(), n.getOTPublisher = function() {
      return n._otPublisherPromise;
    }, n.onDestroyed = function() {
      n._otPublisherPromise = void 0, n.emit("destroyed");
    }, n._onVideoElementCreated = function() {
      if (n.source === "camera") {
        var t, o = (t = n.otPublisher) == null ? void 0 : t.id;
        if (o) {
          var l;
          n.overlay = rD({
            id: o,
            isAudioEnabled: n.isAudioEnabled(),
            participantName: n.name
          }), (l = n.overlay) == null || l.on("toggleAudioClicked", function() {
            n._toggleAudioEnabled();
          });
        }
      }
      n.emit("videoElementCreated");
    }, n._toggleAudioEnabled = function() {
      n.isAudioEnabled() ? n.disableAudio() : n.enableAudio();
    }, n.isVideoEnabled = function() {
      var t, o;
      return !!((t = n.otPublisher) != null && (o = t.getVideoSource()) != null && o.track);
    }, n.isAudioEnabled = function() {
      var t, o;
      return !!((t = n.otPublisher) != null && (o = t.getAudioSource()) != null && o.enabled);
    }, n.enableVideo = function() {
      var t;
      return (t = n.otPublisher) == null ? void 0 : t.publishVideo(!0);
    }, n.disableVideo = function() {
      var t;
      return (t = n.otPublisher) == null ? void 0 : t.publishVideo(!1);
    }, n.enableAudio = function() {
      var t, o;
      (t = n.otPublisher) == null || t.publishAudio(!0), (o = n.overlay) == null || o.setAudioEnabled();
    }, n.disableAudio = function() {
      var t, o;
      (t = n.otPublisher) == null || t.publishAudio(!1), (o = n.overlay) == null || o.setAudioDisabled();
    }, n.getVideoDevice = function() {
      var t = {
        deviceId: "",
        label: "",
        kind: "videoInput"
      };
      if (n.otPublisher) {
        var o = n.otPublisher.getVideoSource(), l = o.deviceId, c = o.track;
        t.deviceId = l || "", t.label = (c == null ? void 0 : c.label) || "";
      }
      return t;
    }, n.setVideoDevice = /* @__PURE__ */ function() {
      var t = al(/* @__PURE__ */ mo().mark(function o(l) {
        var c;
        return mo().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, (c = n.otPublisher) == null ? void 0 : c.setVideoSource(l);
            case 2:
              return u.abrupt("return", u.sent);
            case 3:
            case "end":
              return u.stop();
          }
        }, o);
      }));
      return function(o) {
        return t.apply(this, arguments);
      };
    }(), n.getAudioDevice = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function t() {
      var o, l, c;
      return mo().wrap(function(u) {
        for (; ; ) switch (u.prev = u.next) {
          case 0:
            if (l = (o = n.otPublisher) == null ? void 0 : o.getAudioSource(), !l) {
              u.next = 7;
              break;
            }
            return u.next = 4, vD(l);
          case 4:
            u.t0 = u.sent, u.next = 8;
            break;
          case 7:
            u.t0 = "";
          case 8:
            return c = u.t0, u.abrupt("return", {
              deviceId: c,
              label: (l == null ? void 0 : l.label) || "",
              kind: "audioInput"
            });
          case 10:
          case "end":
            return u.stop();
        }
      }, t);
    })), n.setAudioDevice = /* @__PURE__ */ function() {
      var t = al(/* @__PURE__ */ mo().mark(function o(l) {
        var c;
        return mo().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, (c = n.otPublisher) == null ? void 0 : c.setAudioSource(l);
            case 2:
              return u.abrupt("return", u.sent);
            case 3:
            case "end":
              return u.stop();
          }
        }, o);
      }));
      return function(o) {
        return t.apply(this, arguments);
      };
    }(), n.destroyOTPublisher = function() {
      var t;
      return (t = n.otPublisher) == null ? void 0 : t.destroy();
    }, n.setVideoFilter = /* @__PURE__ */ function() {
      var t = al(/* @__PURE__ */ mo().mark(function o(l) {
        var c;
        return mo().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.next = 2, (c = n.otPublisher) == null ? void 0 : c.applyVideoFilter(l);
            case 2:
              return u.abrupt("return", u.sent);
            case 3:
            case "end":
              return u.stop();
          }
        }, o);
      }));
      return function(o) {
        return t.apply(this, arguments);
      };
    }(), n.clearVideoFilter = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function t() {
      var o;
      return mo().wrap(function(c) {
        for (; ; ) switch (c.prev = c.next) {
          case 0:
            return c.next = 2, (o = n.otPublisher) == null ? void 0 : o.clearVideoFilter();
          case 2:
            return c.abrupt("return", c.sent);
          case 3:
          case "end":
            return c.stop();
        }
      }, t);
    })), n.setDisabledImageURI = function(t) {
      var o;
      (o = n.otPublisher) == null || o.setStyle("backgroundImageURI", t);
    }, n.source = i, n.name = r, n.initials = e, n;
  }
  return a;
}(Qd.EventEmitter), RD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i, r, e, n, t) {
    var o;
    o = s.call(this) || this, o._defaultTargetElement = r;
    var l = new Eb("camera", n, t), c = function() {
      l.on("audioLevelUpdated", function(u) {
        o.emit("audioLevelUpdated", u);
      }), l.on("videoElementCreated", function() {
        return o.emit("created");
      }), l.on("destroyed", function() {
        return o.emit("destroyed");
      }), l.on("accessAllowed", function() {
        o.emit("accessAllowed");
      }), l.on("accessDenied", function() {
        o.emit("accessDenied");
      }), l.on("accessDialogOpened", function() {
        o.emit("accessDialogOpened");
      }), l.on("accessDialogClosed", function(u) {
        o.emit("accessDialogClosed", u);
      });
    };
    return o.isVideoEnabled = function() {
      return l.isVideoEnabled();
    }, o.isAudioEnabled = function() {
      return l.isAudioEnabled();
    }, o.enableVideo = function() {
      e.log(Tr.cameraPublisherEnableVideo, Gr.attempt), l.enableVideo(), e.log(Tr.cameraPublisherEnableVideo, Gr.success);
    }, o.disableVideo = function() {
      e.log(Tr.cameraPublisherDisableVideo, Gr.attempt), l.disableVideo(), e.log(Tr.cameraPublisherDisableVideo, Gr.success);
    }, o.enableAudio = function() {
      e.log(Tr.cameraPublisherEnableAudio, Gr.attempt), l.enableAudio(), e.log(Tr.cameraPublisherEnableAudio, Gr.success);
    }, o.disableAudio = function() {
      e.log(Tr.cameraPublisherDisableAudio, Gr.attempt), l.disableAudio(), e.log(Tr.cameraPublisherDisableAudio, Gr.success);
    }, o.getVideoDevice = function() {
      e.log(Tr.getVideoDevice, Gr.attempt);
      var d = l.getVideoDevice();
      return e.log(Tr.getVideoDevice, Gr.success), d;
    }, o.setVideoDevice = /* @__PURE__ */ function() {
      var d = al(/* @__PURE__ */ mo().mark(function u(h) {
        return mo().wrap(function(g) {
          for (; ; ) switch (g.prev = g.next) {
            case 0:
              return e.log(Tr.setVideoDevice, Gr.attempt), g.prev = 1, g.next = 4, l.setVideoDevice(h);
            case 4:
              e.log(Tr.setVideoDevice, Gr.success), g.next = 11;
              break;
            case 7:
              throw g.prev = 7, g.t0 = g.catch(1), e.log(Tr.setVideoDevice, Gr.failure, {
                error: g.t0
              }), g.t0;
            case 11:
            case "end":
              return g.stop();
          }
        }, u, null, [[1, 7]]);
      }));
      return function(u) {
        return d.apply(this, arguments);
      };
    }(), o.getAudioDevice = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function d() {
      var u;
      return mo().wrap(function(A) {
        for (; ; ) switch (A.prev = A.next) {
          case 0:
            return e.log(Tr.getAudioDevice, Gr.attempt), A.next = 3, l.getAudioDevice();
          case 3:
            return u = A.sent, e.log(Tr.getAudioDevice, Gr.success), A.abrupt("return", u);
          case 6:
          case "end":
            return A.stop();
        }
      }, d);
    })), o.setAudioDevice = /* @__PURE__ */ function() {
      var d = al(/* @__PURE__ */ mo().mark(function u(h) {
        return mo().wrap(function(g) {
          for (; ; ) switch (g.prev = g.next) {
            case 0:
              return e.log(Tr.setAudioDevice, Gr.attempt), g.prev = 1, g.next = 4, l.setAudioDevice(h);
            case 4:
              e.log(Tr.setAudioDevice, Gr.success), g.next = 11;
              break;
            case 7:
              throw g.prev = 7, g.t0 = g.catch(1), e.log(Tr.setAudioDevice, Gr.failure, {
                error: g.t0
              }), g.t0;
            case 11:
            case "end":
              return g.stop();
          }
        }, u, null, [[1, 7]]);
      }));
      return function(u) {
        return d.apply(this, arguments);
      };
    }(), o.destroyCameraPublisher = function() {
      try {
        e.log(Tr.destroyCameraPublisher, Gr.attempt), l.destroyOTPublisher(), e.log(Tr.destroyCameraPublisher, Gr.success);
      } catch {
        e.log(Tr.destroyCameraPublisher, Gr.failure);
      }
    }, o.initPublisher = /* @__PURE__ */ function() {
      var d = al(/* @__PURE__ */ mo().mark(function u(h) {
        var A, g, f, p;
        return mo().wrap(function(b) {
          for (; ; ) switch (b.prev = b.next) {
            case 0:
              return h === void 0 && (h = {}), A = h, g = A.targetElement, f = A.publisherProperties, p = g != null ? g : o._defaultTargetElement, c(), b.next = 6, l.initOTPublisher(p, f);
            case 6:
            case "end":
              return b.stop();
          }
        }, u);
      }));
      return function(u) {
        return d.apply(this, arguments);
      };
    }(), o.publish = /* @__PURE__ */ function() {
      var d = al(/* @__PURE__ */ mo().mark(function u(h) {
        var A;
        return mo().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              return h === void 0 && (h = {}), e.log(Tr.publishCameraPublisher, Gr.attempt, {
                publisherOptions: h
              }), f.next = 4, l.getOTPublisher();
            case 4:
              if (A = f.sent, A) {
                f.next = 7;
                break;
              }
              throw new Error("OT Publisher not initialized");
            case 7:
              return f.abrupt("return", new Promise(function(p, v) {
                i.publish(A, function(b) {
                  b ? (e.log(Tr.publishCameraPublisher, Gr.failure, {
                    error: b
                  }), v(b)) : (e.log(Tr.publishCameraPublisher, Gr.success), p());
                });
              }));
            case 8:
            case "end":
              return f.stop();
          }
        }, u);
      }));
      return function(u) {
        return d.apply(this, arguments);
      };
    }(), o.setVideoFilter = /* @__PURE__ */ function() {
      var d = al(/* @__PURE__ */ mo().mark(function u(h) {
        return mo().wrap(function(g) {
          for (; ; ) switch (g.prev = g.next) {
            case 0:
              return g.prev = 0, e.log(Tr.setVideoFilter, Gr.attempt), g.next = 4, l.setVideoFilter(h);
            case 4:
              e.log(Tr.setVideoFilter, Gr.success), g.next = 11;
              break;
            case 7:
              throw g.prev = 7, g.t0 = g.catch(0), e.log(Tr.setVideoFilter, Gr.failure, {
                error: g.t0
              }), g.t0;
            case 11:
            case "end":
              return g.stop();
          }
        }, u, null, [[0, 7]]);
      }));
      return function(u) {
        return d.apply(this, arguments);
      };
    }(), o.clearVideoFilter = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function d() {
      return mo().wrap(function(h) {
        for (; ; ) switch (h.prev = h.next) {
          case 0:
            return e.log(Tr.clearVideoFilter, Gr.attempt), h.prev = 1, h.next = 4, l.clearVideoFilter();
          case 4:
            e.log(Tr.clearVideoFilter, Gr.success), h.next = 11;
            break;
          case 7:
            throw h.prev = 7, h.t0 = h.catch(1), e.log(Tr.clearVideoFilter, Gr.failure, {
              error: h.t0
            }), h.t0;
          case 11:
          case "end":
            return h.stop();
        }
      }, d, null, [[1, 7]]);
    })), o.setDisabledImageURI = function(d) {
      l.setDisabledImageURI(d);
    }, o;
  }
  return a;
}(Qd.EventEmitter), Um = "Client is not screen sharing", yD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i, r, e) {
    var n;
    n = s.call(this) || this, n.isScreenSharing = !1, n._defaultTargetElement = r;
    var t = new Eb("screen"), o = /* @__PURE__ */ function() {
      var l = al(/* @__PURE__ */ mo().mark(function c() {
        return mo().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              t.on("audioLevelUpdated", function(h) {
                n.emit("audioLevelUpdated", h);
              }), t.on("videoElementCreated", function() {
                return n.emit("started");
              }), t.on("destroyed", function() {
                return n.emit("stopped");
              });
            case 3:
            case "end":
              return u.stop();
          }
        }, c);
      }));
      return function() {
        return l.apply(this, arguments);
      };
    }();
    return n.start = /* @__PURE__ */ function() {
      var l = al(/* @__PURE__ */ mo().mark(function c(d) {
        var u, h, A;
        return mo().wrap(function(f) {
          for (; ; ) switch (f.prev = f.next) {
            case 0:
              return t || (t = new Eb("screen")), h = d != null ? d : n._defaultTargetElement, o(), f.next = 5, t.initOTPublisher(h, {
                showControls: !0,
                style: {
                  buttonDisplayMode: "off"
                }
              });
            case 5:
              return A = f.sent, A == null || (u = A.element) == null || u.classList.add("OT_screenshare"), n.isScreenSharing = !0, f.abrupt("return", new Promise(function(p, v) {
                i.publish(A, function(b) {
                  b ? v(b) : p();
                });
              }));
            case 9:
            case "end":
              return f.stop();
          }
        }, c);
      }));
      return function(c) {
        return l.apply(this, arguments);
      };
    }(), n.stop = function() {
      var l;
      (l = t) == null || l.destroyOTPublisher(), t = void 0, n.isScreenSharing = !1;
    }, n.isVideoEnabled = function() {
      var l;
      return n.isScreenSharing && ((l = t) == null ? void 0 : l.isVideoEnabled());
    }, n.isAudioEnabled = function() {
      var l;
      return n.isScreenSharing && ((l = t) == null ? void 0 : l.isAudioEnabled());
    }, n.enableVideo = function() {
      if (e.log(Tr.screenPublisherEnableVideo, Gr.attempt), n.isScreenSharing) {
        var l;
        (l = t) == null || l.enableVideo(), e.log(Tr.screenPublisherEnableVideo, Gr.success);
      } else
        e.log(Tr.screenPublisherEnableVideo, Gr.failure, {
          error: Um
        });
    }, n.disableVideo = function() {
      if (e.log(Tr.screenPublisherDisableVideo, Gr.attempt), n.isScreenSharing) {
        var l;
        (l = t) == null || l.disableVideo(), e.log(Tr.screenPublisherDisableVideo, Gr.success);
      } else
        e.log(Tr.screenPublisherDisableVideo, Gr.failure, {
          error: Um
        });
    }, n.enableAudio = function() {
      if (e.log(Tr.screenPublisherEnableAudio, Gr.attempt), n.isScreenSharing) {
        var l;
        (l = t) == null || l.enableAudio(), e.log(Tr.screenPublisherEnableAudio, Gr.success);
      } else
        e.log(Tr.screenPublisherEnableAudio, Gr.failure, {
          error: Um
        });
    }, n.disableAudio = function() {
      if (e.log(Tr.screenPublisherDisableAudio, Gr.attempt), n.isScreenSharing) {
        var l;
        (l = t) == null || l.disableAudio(), e.log(Tr.screenPublisherDisableAudio, Gr.success);
      } else
        e.log(Tr.screenPublisherDisableAudio, Gr.failure, {
          error: Um
        });
    }, n.setDisabledImageURI = function(l) {
      t.setDisabledImageURI(l);
    }, n;
  }
  return a;
}(Qd.EventEmitter), QD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i, r, e) {
    var n, t;
    t = s.call(this) || this, t._stream = i;
    var o = new OI(r);
    return (n = r.element) == null || n.classList.add("MP_screenshare_subscriber"), o.on("audioLevelUpdated", function(l) {
      t.emit("audioLevelUpdated", l);
    }), o.on("destroyed", function() {
      return t.emit("destroyed");
    }), o.on("videoElementCreated", function() {
      t.emit("created");
    }), t.id = o.id, t.getSubscriberElement = function() {
      return o == null ? void 0 : o.getSubscriberElement();
    }, t.isVideoEnabled = function() {
      return o == null ? void 0 : o.isVideoEnabled();
    }, t.isAudioEnabled = function() {
      return o == null ? void 0 : o.isAudioEnabled();
    }, t.enableVideo = function() {
      e.log(Tr.screenSubscriberEnableVideo, Gr.attempt), o ? (o.enableVideo(), e.log(Tr.screenSubscriberEnableVideo, Gr.success)) : e.log(Tr.screenSubscriberEnableVideo, Gr.failure);
    }, t.disableVideo = function() {
      e.log(Tr.screenSubscriberDisableVideo, Gr.attempt), o ? (o.disableVideo(), e.log(Tr.screenSubscriberDisableVideo, Gr.success)) : e.log(Tr.screenSubscriberDisableVideo, Gr.failure);
    }, t.enableAudio = function() {
      e.log(Tr.screenSubscriberEnableAudio, Gr.attempt), o ? (o.enableAudio(), e.log(Tr.screenSubscriberEnableAudio, Gr.success)) : e.log(Tr.screenSubscriberEnableAudio, Gr.failure);
    }, t.disableAudio = function() {
      e.log(Tr.screenSubscriberDisableAudio, Gr.attempt), o ? (o.disableAudio(), e.log(Tr.screenSubscriberDisableAudio, Gr.success)) : e.log(Tr.screenSubscriberDisableAudio, Gr.failure);
    }, t.setDisabledImageURI = function(l) {
      o.setDisabledImageURI(l);
    }, t;
  }
  return a;
}(Qd.EventEmitter), CD = function(a, i, r, e) {
  r.log(Tr.createScreenSubscriber, Gr.attempt);
  var n = a.subscribe(i, "layoutContainer", {
    insertMode: "append",
    style: {
      buttonDisplayMode: "off",
      nameDisplayMode: "off",
      videoDisabledDisplayMode: "off"
    }
  }, function(t) {
    if (t)
      r.log(Tr.createScreenSubscriber, Gr.failure), e(t);
    else {
      var o = new QD(i, n, r);
      r.log(Tr.createScreenSubscriber, Gr.success), e(void 0, o);
    }
  });
}, UD = 100, ID = 100, BD = 0, ZD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a() {
    var r;
    return r = s.apply(this, arguments) || this, r.activity = {}, r;
  }
  var i = a.prototype;
  return i.onAudioLevelUpdated = function(e) {
    var n = Date.now(), t = e > BD;
    t ? Object.keys(this.activity).length === 0 ? this.activity = {
      timestamp: n,
      talking: !1
    } : this.activity.talking ? this.activity.timestamp = n : n - this.activity.timestamp > UD && (this.activity.talking = !0, this.emit("activeSpeakerStatusChanged", {
      isSpeaking: !0
    })) : Object.keys(this.activity).length !== 0 && n - this.activity.timestamp > ID && this.activity.talking && (this.emit("activeSpeakerStatusChanged", {
      isSpeaking: !1
    }), this.reset());
  }, i.reset = function() {
    this.activity = {};
  }, a;
}(Qd.EventEmitter), SD = 1500, ED = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a() {
    var i;
    return i = s.call(this) || this, i._subscriberAudioLevelsBySubscriberId = {}, i._participantsBySubscriberId = {}, i.onCameraSubscriberDestroyed = function(r) {
      delete i._subscriberAudioLevelsBySubscriberId[r], delete i._participantsBySubscriberId[r], i.activeSpeaker.subscriberId === r && (i.activeSpeaker = {
        subscriberId: void 0,
        movingAvg: 0,
        participant: void 0
      }), i.calculateActiveSpeaker();
    }, i.onSubscriberAudioLevelUpdated = function(r) {
      var e = r.subscriberId, n = r.movingAvg, t = r.participant, o = r.audioLevel;
      i._subscriberAudioLevelsBySubscriberId[e] = n, i._participantsBySubscriberId[e] = t, i.calculateActiveSpeaker(), e === i.activeSpeaker.subscriberId && i.speakerDetection.onAudioLevelUpdated(o);
    }, i._calculateActiveSpeaker = function() {
      var r = Object.entries(i._subscriberAudioLevelsBySubscriberId), e = r.reduce(function(t, o) {
        var l = o[0], c = o[1];
        return c > t.movingAvg ? {
          subscriberId: l,
          movingAvg: c,
          participant: i._participantsBySubscriberId[l]
        } : t;
      }, {
        subscriberId: void 0,
        movingAvg: 0,
        participant: void 0
      });
      if (e.subscriberId !== i.activeSpeaker.subscriberId && e.movingAvg > 0.2) {
        var n = jh({}, i.activeSpeaker);
        i.activeSpeaker = e, i.emit("activeSpeakerChanged", {
          newActiveSpeaker: e,
          previousActiveSpeaker: n
        }), i.speakerDetection.reset();
      }
    }, i.activeSpeaker = {
      movingAvg: 0,
      subscriberId: void 0,
      participant: void 0
    }, i.speakerDetection = new ZD(), i.speakerDetection.on("activeSpeakerStatusChanged", function(r) {
      i.emit("activeSpeakerStatusChanged", r);
    }), i.calculateActiveSpeaker = f1(i._calculateActiveSpeaker, SD, {
      // So we don't send events after subscriber is destroyed
      leading: !0,
      trailing: !1
    }), i;
  }
  return a;
}(Qd.EventEmitter), VD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(r) {
    var e;
    e = s.call(this) || this, e.name = null, e.isParticipantJoinedSent = !1, e.isMe = !1, e.connection = r;
    var n = r.connectionId, t = r.data;
    return e.id = n, e.connectionData = t, e;
  }
  var i = a.prototype;
  return i.setCameraSubscriber = function(e) {
    var n = this;
    this.camera = e, e.on("created", function() {
      n.emit("cameraCreated", e);
    }), e.on("destroyed", function() {
      n.emit("cameraDestroyed");
    });
  }, i.setScreenSubscriber = function(e) {
    var n = this;
    this.screen = e, e.on("created", function() {
      n.emit("screenCreated");
    }), e.on("destroyed", function() {
      n.emit("screenDestroyed");
    });
  }, i.setInitials = function(e) {
    this.initials = e;
  }, a;
}(Qd.EventEmitter), WD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i) {
    var r;
    return r = s.call(this) || this, r.isMe = !1, r.id = i.id, r.connectionData = i.connectionData, Object.defineProperty(xu(r), "camera", {
      get: function() {
        return i.camera;
      }
    }), Object.defineProperty(xu(r), "screen", {
      get: function() {
        return i.screen;
      }
    }), Object.defineProperty(xu(r), "name", {
      get: function() {
        return i.name;
      }
    }), Object.defineProperty(xu(r), "initials", {
      get: function() {
        return i.initials;
      }
    }), i.on("cameraCreated", function(e) {
      r.emit("cameraCreated", e);
    }), i.on("cameraDestroyed", function() {
      r.emit("cameraDestroyed");
    }), i.on("screenCreated", function(e) {
      r.emit("screenCreated", e);
    }), i.on("screenDestroyed", function() {
      r.emit("screenDestroyed");
    }), i.on("encryptionSecretMismatch", function() {
      r.emit("encryptionSecretMismatch");
    }), i.on("encryptionSecretMatch", function() {
      r.emit("encryptionSecretMatch");
    }), r;
  }
  return a;
}(Qd.EventEmitter), YR = function(a) {
  return Object.entries(a).reduce(function(i, r) {
    var e = r[0], n = r[1];
    return n !== void 0 && (i[e] = n), i;
  }, {});
}, LR = function(a) {
  Object.keys(a).forEach(function(i) {
    delete a[i];
  });
}, ND = 500, JD = /* @__PURE__ */ new Y4(navigator.userAgent), xR = /* @__PURE__ */ JD.getDevice(), GD = function() {
  if ("maxTouchPoints" in navigator)
    return navigator.maxTouchPoints > 0;
  var a = window.matchMedia("(pointer:coarse)");
  return a.matches;
}, TD = function() {
  var a = window.matchMedia("(max-device-width: " + ND + "px)");
  return a.matches;
}, XD = function() {
  return xR.type ? xR.type === "mobile" : TD() && GD();
}, HR = function() {
  var a, i, r = new Promise(function(e, n) {
    a = e, i = n;
  });
  return r.catch(function() {
  }), {
    promise: r,
    // @ts-ignore
    resolver: a,
    // @ts-ignore
    rejector: i
  };
}, kD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(r, e) {
    var n;
    return n = s.call(this) || this, n.isMe = !0, n.id = r.connectionId, n.name = e, n.connectionData = r.data, n;
  }
  var i = a.prototype;
  return i.setInitials = function(e) {
    this.initials = e;
  }, a;
}(Qd.EventEmitter), wD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i) {
    var r;
    return r = s.call(this) || this, r.isMe = !0, r.id = i.id, r.connectionData = i.connectionData, r.name = i.name, r.initials = i.initials, r;
  }
  return a;
}(Qd.EventEmitter), DD = ["deviceLayoutMode"], MD = 300, YD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(r) {
    var e;
    e = s.call(this) || this, e.participants = {}, e.participantWrappers = {}, e._cameraSubscribers = {}, e._screenSubscribers = {}, e._visibleParticipantsCount = 0, e._attachOTSessionEventListeners = function() {
      e._session.on("sessionConnected", function() {
        e.emit("connected");
      }), e._session.on("sessionDisconnected", function(B) {
        var Q = B.reason;
        e.camera && e.camera.destroyCameraPublisher(), e.screen && e.screen.stop(), e.emit("disconnected", Q);
      }), e._session.on("sessionReconnecting", function() {
        e.emit("reconnecting");
      }), e._session.on("sessionReconnected", function() {
        e.emit("reconnected");
      }), e._session.on("streamCreated", /* @__PURE__ */ function() {
        var B = al(/* @__PURE__ */ mo().mark(function Q(N) {
          var J, w, W;
          return mo().wrap(function(Z) {
            for (; ; ) switch (Z.prev = Z.next) {
              case 0:
                return Z.prev = 0, Z.next = 3, e._waitUntilJoined.promise;
              case 3:
                Z.next = 8;
                break;
              case 5:
                return Z.prev = 5, Z.t0 = Z.catch(0), Z.abrupt("return");
              case 8:
                J = N.stream, w = J.connection.connectionId, W = e.participants[w], W && !W.isMe && e._onParticipantStreamCreated(e._session, J, W, e._shouldEnableParticipantVideo());
              case 12:
              case "end":
                return Z.stop();
            }
          }, Q, null, [[0, 5]]);
        }));
        return function(Q) {
          return B.apply(this, arguments);
        };
      }()), e._session.on("streamDestroyed", function(B) {
        var Q = B.stream, N = Q.connection.connectionId, J = e.participants[N];
        J && e._onParticipantStreamDestroyed(), !e.useMobileLayout && e._shouldEnableParticipantVideo() && Object.values(e.participants).forEach(function(w) {
          if (!w.isMe) {
            var W;
            (W = w.camera) == null || W.enableVideo();
          }
        });
      }), e._session.on("connectionCreated", /* @__PURE__ */ function() {
        var B = al(/* @__PURE__ */ mo().mark(function Q(N) {
          var J, w, W, G;
          return mo().wrap(function(K) {
            for (; ; ) switch (K.prev = K.next) {
              case 0:
                if (J = N.connection, w = e._createParticipant(J), W = w.participant, G = w.participantWrapper, e._isMe(J)) {
                  K.next = 12;
                  break;
                }
                return K.prev = 3, K.next = 6, e._sendParticipantName(J);
              case 6:
                K.next = 11;
                break;
              case 8:
                K.prev = 8, K.t0 = K.catch(3);
              case 11:
                setTimeout(function() {
                  e.participants[W.id] && e.participants[W.id].name === null && e._onParticipantNameReceived(G, "");
                }, MD);
              case 12:
              case "end":
                return K.stop();
            }
          }, Q, null, [[3, 8]]);
        }));
        return function(Q) {
          return B.apply(this, arguments);
        };
      }()), e._session.on("connectionDestroyed", function(B) {
        var Q = B.connection, N = B.reason, J = Q.connectionId, w = e.participants[J];
        if (w && !w.isMe) {
          var W = w.isParticipantJoinedSent, G = e.participantWrappers[J];
          delete e.participantWrappers[J], delete e.participants[J], W && e.emit("participantLeft", G, N);
        }
      }), e._session.on("signal", e._onSignalReceived);
    }, e._createParticipant = function(B) {
      var Q, N;
      if (e._isMe(B)) {
        var J = e._createLocalParticipant(B, e.participantName);
        Q = J.participant, N = J.participantWrapper;
      } else {
        var w = e._createRemoteParticipant(B);
        Q = w.participant, N = w.participantWrapper;
      }
      return e.participants[Q.id] = Q, e.participantWrappers[Q.id] = N, {
        participant: Q,
        participantWrapper: N
      };
    }, e._createLocalParticipant = function(B, Q) {
      var N = new kD(B, Q);
      N.setInitials(e.participantInitials);
      var J = new wD(N);
      return {
        participant: N,
        participantWrapper: J
      };
    }, e._createRemoteParticipant = function(B) {
      var Q = new VD(B), N = new WD(Q);
      return {
        participant: Q,
        participantWrapper: N
      };
    }, e._removeOTSessionEventListeners = function() {
      e._session.off();
    }, e._createDefaultRoomContainer = function() {
      var B = jm("roomContainer", {
        width: "100vw",
        height: "100vh",
        position: "relative"
      });
      return document.body.appendChild(B), B;
    }, e._getDefaultPublisherElement = function(B) {
      B === void 0 && (B = "camera");
      var Q = xu(e), N = Q.managedLayoutOptions, J = N === void 0 ? {} : N, w = J.screenPublisherContainer, W = J.cameraPublisherContainer, G = B === "camera" ? W : w;
      return G ? LI(G) : e._layoutManager.getLayoutContainerElement();
    }, e._connect = function() {
      return new Promise(function(B, Q) {
        e._session.connect(e.token, function(N) {
          N ? Q(N) : (e._analytics.update(e._session.sessionId, e._session.connection.connectionId, e.apiKey), B());
        });
      });
    }, e._isMe = function(B) {
      var Q, N;
      return !!B && ((Q = e._session) == null || (N = Q.connection) == null ? void 0 : N.connectionId) === B.connectionId;
    }, e._setOptimalSubscriberResolutions = function() {
      Object.values(e._cameraSubscribers).forEach(function(B) {
        B.setOptimalPreferredResolution();
      });
    }, e._getCameraSubscriberElement = function(B) {
      if (B)
        return e._cameraSubscribers[B].getSubscriberElement();
    }, e._onParticipantNameReceived = function(B, Q) {
      var N = B.id;
      if (e.participants[N]) {
        e.participants[N].name = Q;
        var J = e.participants[N];
        !J.isMe && !J.isParticipantJoinedSent && (J.isParticipantJoinedSent = !0, e.emit("participantJoined", B));
      }
    }, e._onSignalReceived = function(B) {
      var Q = B.from ? e.participantWrappers[B.from.connectionId] : null;
      if (Q && B.type === "signal:MP_INTERNAL_PARTICIPANT_NAME" && !e._isMe(B.from)) {
        var N;
        e._onParticipantNameReceived(Q, (N = B.data) != null ? N : "");
        return;
      }
      var J = {
        type: B.type,
        data: B.data,
        from: Q,
        isSentByMe: e._isMe(B.from)
      };
      e.emit("signal", J);
    }, e._onCameraSubscriberCreated = function(B, Q) {
      e._cameraSubscribers[Q.id] = Q;
      var N = Q.getSubscriberElement();
      Q.on("created", function() {
        e._layoutManager.onCameraSubscriberCreated(N);
      }), Q.on("destroyed", function() {
        var J;
        e._activeSpeakerTracker.onCameraSubscriberDestroyed(Q.id), (J = e._layoutManager) == null || J.onCameraSubscriberDestroyed(N), delete e._cameraSubscribers[Q.id];
      });
    }, e._onScreenSubscriberCreated = function(B, Q) {
      e._screenSubscribers[Q.id] = Q, Q.on("created", function() {
        e._layoutManager.onScreenSubscriberCreated(Q.id);
      }), Q.on("destroyed", function() {
        var N = Q.id;
        e._layoutManager.onScreenSubscriberDestroyed(N), delete e._screenSubscribers[N];
      });
    }, e._onActiveSpeakerStatusChanged = function(B) {
      e._layoutManager.onActiveSpeakerStatusChanged(B);
    }, e._onActiveSpeakerChanged = function(B) {
      var Q = B.newActiveSpeaker, N = B.previousActiveSpeaker, J = e._getCameraSubscriberElement(Q.subscriberId), w = e._getCameraSubscriberElement(N.subscriberId);
      e._layoutManager.onActiveSpeakerChanged({
        newActiveSpeakerElement: J,
        previousActiveSpeakerElement: w
      }), e.emit("activeSpeakerChanged", Q.participant);
    }, e._sendParticipantName = function(B) {
      return new Promise(function(Q, N) {
        e._session.signal(YR({
          to: B,
          type: "MP_INTERNAL_PARTICIPANT_NAME",
          data: e.participantName
        }), function(J) {
          J && N(J), Q();
        });
      });
    }, e._shouldEnableParticipantVideo = function() {
      return e.maxVideoParticipantsOnScreen === void 0 || e._visibleParticipantsCount < e.maxVideoParticipantsOnScreen;
    }, e._shouldDisablePublisherMedia = function() {
      return !!e.mediaShutoffThreshold && Object.keys(e.participants).length > e.mediaShutoffThreshold;
    }, e._onParticipantStreamDestroyed = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function B() {
      return mo().wrap(function(N) {
        for (; ; ) switch (N.prev = N.next) {
          case 0:
            e._visibleParticipantsCount = e._visibleParticipantsCount > 0 ? e._visibleParticipantsCount - 1 : 0;
          case 1:
          case "end":
            return N.stop();
        }
      }, B);
    })), e._onParticipantStreamCreated = /* @__PURE__ */ function() {
      var B = al(/* @__PURE__ */ mo().mark(function Q(N, J, w, W) {
        var G;
        return mo().wrap(function(K) {
          for (; ; ) switch (K.prev = K.next) {
            case 0:
              G = J.videoType, G === "screen" ? CD(N, J, e._analytics, function(L, O) {
                !L && O && (w.setScreenSubscriber(O), e._onScreenSubscriberCreated(J, O));
              }) : (lD(N, J, W, e._analytics, function(L, O) {
                !L && O && (w.setCameraSubscriber(O), w.setInitials(J.initials), e._onCameraSubscriberCreated(J, O), O.on("audioLevelUpdated", function(de, oe) {
                  e._activeSpeakerTracker.onSubscriberAudioLevelUpdated({
                    subscriberId: O.id,
                    movingAvg: oe,
                    participant: w,
                    audioLevel: de
                  });
                }));
              }), W || e.emit("cameraSubscriberVideoDisabled", w.id), e._visibleParticipantsCount = e._visibleParticipantsCount + 1);
            case 2:
            case "end":
              return K.stop();
          }
        }, Q);
      }));
      return function(Q, N, J, w) {
        return B.apply(this, arguments);
      };
    }(), e._onCameraSubscriberHiddenByLayoutManager = function(B) {
      var Q = e._cameraSubscribers[B];
      Q && (x0.debug("Camera subscriber to be hidden in layout, unsubscribing to video: ", Q.id), Q.disableVideo());
    }, e._onCameraSubscriberDisplayedByLayoutManager = function(B) {
      var Q = e._cameraSubscribers[B];
      if (Q) {
        x0.debug("Camera subscriber to be displayed in layout, subscribing to video: ", Q.id), Q.enableVideo();
        var N = e._getCameraSubscriberElement(B);
        N && e._layoutManager._removeSubscriberOnLoad(N);
      }
    }, e.join = /* @__PURE__ */ function() {
      var B = al(/* @__PURE__ */ mo().mark(function Q(N) {
        var J, w, W, G, Z, K, L;
        return mo().wrap(function(de) {
          for (; ; ) switch (de.prev = de.next) {
            case 0:
              return N === void 0 && (N = {}), J = N, w = J.targetElement, W = J.publisherProperties, G = W === void 0 ? {} : W, G.name = e.participantName, e._analytics.log(Tr.joinRoom, Gr.attempt, {
                publisherOptions: N
              }), e._attachOTSessionEventListeners(), Z = !1, K = !1, L = function() {
                e._waitUntilJoined.rejector(), e._cleanupOnDisconnect(), Z && e.camera.destroyCameraPublisher(), K && e._session.disconnect();
              }, de.prev = 9, e.camera.on("destroyed", e._onCameraPublisherDestroyed), de.next = 13, e.camera.initPublisher({
                targetElement: w,
                publisherProperties: G
              });
            case 13:
              Z = !0, de.next = 22;
              break;
            case 16:
              throw de.prev = 16, de.t0 = de.catch(9), x0.error("Failed to join room: could not initialize camera publish.", de.t0), e._analytics.log(Tr.joinRoom, Gr.failure, {
                error: de.t0
              }), L(), de.t0;
            case 22:
              return de.prev = 22, de.next = 25, e._connect();
            case 25:
              K = !0, de.next = 34;
              break;
            case 28:
              throw de.prev = 28, de.t1 = de.catch(22), x0.error("Failed to join room: could not connect to session.", de.t1), e._analytics.log(Tr.joinRoom, Gr.failure, {
                error: de.t1
              }), L(), de.t1;
            case 34:
              return e._shouldDisablePublisherMedia() && (e.camera.disableAudio(), e.camera.disableVideo(), e.emit("cameraPublisherMediaDisabled")), de.prev = 35, de.next = 38, e.camera.publish();
            case 38:
              de.next = 47;
              break;
            case 41:
              throw de.prev = 41, de.t2 = de.catch(35), x0.error("Failed to join room: failed to publish to session", de.t2), e._analytics.log(Tr.joinRoom, Gr.failure, {
                error: de.t2
              }), L(), de.t2;
            case 47:
              e._analytics.log(Tr.joinRoom, Gr.success), e._waitUntilJoined.resolver(), e._layoutManager.updateLayout();
            case 50:
            case "end":
              return de.stop();
          }
        }, Q, null, [[9, 16], [22, 28], [35, 41]]);
      }));
      return function(Q) {
        return B.apply(this, arguments);
      };
    }(), e._cleanupOnDisconnect = function() {
      e._removeOTSessionEventListeners(), e.camera.off("destroyed", e._onCameraPublisherDestroyed), e._waitUntilJoined = HR(), LR(e.participants), LR(e.participantWrappers);
    }, e.leave = function() {
      return e._analytics.log(Tr.leaveRoom, Gr.attempt), e._cleanupOnDisconnect(), new Promise(function(B, Q) {
        try {
          e._session.on("sessionDisconnected", function() {
            e._analytics.log(Tr.leaveRoom, Gr.success), x0.info("Left room"), B();
          }), e._session.disconnect();
        } catch (N) {
          e._analytics.log(Tr.leaveRoom, Gr.failure, {
            error: N
          }), Q(N);
        }
      });
    }, e._onCameraPublisherDestroyed = function() {
      e._cleanupOnDisconnect(), e._session.disconnect(), e.emit("disconnected", "cameraPublisherError");
    }, e.setLayoutMode = function(B) {
      if (e._layoutManager)
        e._layoutManager.setLayoutMode(B);
      else
        throw new Error("Cannot set layout mode when not using layout manager");
    }, e.setEncryptionSecret = /* @__PURE__ */ function() {
      var B = al(/* @__PURE__ */ mo().mark(function Q(N) {
        return mo().wrap(function(w) {
          for (; ; ) switch (w.prev = w.next) {
            case 0:
              if (w.prev = 0, e._analytics.log(Tr.setEncryptionSecret, Gr.attempt), !e.encryptionEnabled) {
                w.next = 8;
                break;
              }
              return w.next = 5, e._session.setEncryptionSecret(N);
            case 5:
              e._analytics.log(Tr.setEncryptionSecret, Gr.success), w.next = 9;
              break;
            case 8:
              throw new Error("Must set encryption secret when creating the room");
            case 9:
              w.next = 15;
              break;
            case 11:
              throw w.prev = 11, w.t0 = w.catch(0), e._analytics.log(Tr.setEncryptionSecret, Gr.failure, {
                error: w.t0
              }), new Error("Error changing encryption secret due to: " + w.t0);
            case 15:
            case "end":
              return w.stop();
          }
        }, Q, null, [[0, 11]]);
      }));
      return function(Q) {
        return B.apply(this, arguments);
      };
    }(), e.startScreensharing = function(B) {
      return e._analytics.log(Tr.startScreenSharing, Gr.attempt), e.screen.start(B).then(function() {
        e._layoutManager.updateLayout(), e._analytics.log(Tr.startScreenSharing, Gr.success);
      }).catch(function(Q) {
        throw e._analytics.log(Tr.startScreenSharing, Gr.failure, {
          error: Q
        }), Q;
      });
    }, e.stopScreensharing = function() {
      e._analytics.log(Tr.stopScreenSharing, Gr.attempt), e.screen.stop(), e._layoutManager.updateLayout(), e._analytics.log(Tr.stopScreenSharing, Gr.success);
    };
    var n = r.apiKey, t = r.sessionId, o = r.token, l = r.roomContainer, c = r.mediaShutoffThreshold, d = r.maxVideoParticipantsOnScreen, u = r.managedLayoutOptions, h = u === void 0 ? {} : u, A = r.participantName, g = A === void 0 ? "" : A, f = r.iceConfig, p = r.participantInitials, v = p === void 0 ? "" : p;
    if (e._analytics = new _p({
      sessionId: t,
      apiKey: n
    }), e._analytics.log(Tr.initRoom, Gr.attempt, {
      roomProperties: r
    }), !n || !t || !o) {
      var b = "Invalid credentials. Check the API_KEY, TOKEN, SESSION_ID passed";
      throw e._analytics.log(Tr.initRoom, Gr.failure, {
        error: b
      }), new Error(b);
    }
    e.apiKey = n, e.roomId = t, e.token = o, e.iceConfig = f, e.encryptionEnabled = typeof r.encryptionSecret == "string", e.roomContainer = l || e._createDefaultRoomContainer(), e.mediaShutoffThreshold = c, e._waitUntilJoined = HR(), d !== void 0 && typeof d != "number" || typeof d == "number" && d < 0 || (e.maxVideoParticipantsOnScreen = d), e.participantName = g, e.participantInitials = v;
    var m = h.deviceLayoutMode, y = m === void 0 ? "auto" : m, U = YI(h, DD);
    return e.useMobileLayout = y === "mobile" || y === "auto" && XD(), e.managedLayoutOptions = jh({
      layoutMode: "grid",
      isMobileLayout: e.useMobileLayout
    }, U), e._session = q0.initSession(e.apiKey, e.roomId, {
      iceConfig: e.iceConfig,
      encryptionSecret: r.encryptionSecret
    }), e._layoutManager = new fD(e.roomContainer, e.managedLayoutOptions, d), e._layoutManager.on("layoutComplete", function() {
      e._setOptimalSubscriberResolutions();
    }), e._layoutManager.on("cameraSubscriberHidden", e._onCameraSubscriberHiddenByLayoutManager), e._layoutManager.on("cameraSubscriberDisplayed", e._onCameraSubscriberDisplayedByLayoutManager), e.camera = new RD(e._session, e._getDefaultPublisherElement(), e._analytics, e.participantName, e.participantInitials), e.screen = new yD(e._session, e._getDefaultPublisherElement("screen"), e._analytics), e._activeSpeakerTracker = new ED(), e._activeSpeakerTracker.on("activeSpeakerChanged", e._onActiveSpeakerChanged), e._activeSpeakerTracker.on("activeSpeakerStatusChanged", e._onActiveSpeakerStatusChanged), e._analytics.log(Tr.initRoom, Gr.success), e;
  }
  var i = a.prototype;
  return i.signal = function(e) {
    var n = this, t = e.to, o = e.data, l = e.type, c = e.retryAfterReconnect, d = t && this.participants[t.id], u = YR({
      data: o,
      type: l,
      retryAfterReconnect: c,
      to: d == null ? void 0 : d.connection
    });
    return new Promise(function(h, A) {
      n._session.signal(u, function(g) {
        g && A(g), h();
      });
    });
  }, x4(a, [{
    key: "participantId",
    get: function() {
      var e, n, t;
      return (e = (n = this._session) == null || (t = n.connection) == null ? void 0 : t.connectionId) != null ? e : "";
    }
  }, {
    key: "participantConnectionData",
    get: function() {
      var e, n, t;
      return (e = (n = this._session) == null || (t = n.connection) == null ? void 0 : t.data) != null ? e : "";
    }
  }]), a;
}(Qd.EventEmitter), LD = /* @__PURE__ */ function(s) {
  Nd(a, s);
  function a(i) {
    var r;
    r = s.call(this) || this, r.apiKey = i.apiKey, r.roomId = i.sessionId, r.token = i.token, r.iceConfig = i.iceConfig, r.roomContainer = i.roomContainer, r.managedLayoutOptions = i.managedLayoutOptions, r.mediaShutoffThreshold = i.mediaShutoffThreshold, r.maxVideoParticipantsOnScreen = i.maxVideoParticipantsOnScreen;
    var e = new YD(i);
    r.camera = e.camera, r.screen = e.screen, r.participants = e.participantWrappers, Object.defineProperty(xu(r), "participantId", {
      get: function() {
        return e.participantId;
      }
    }), Object.defineProperty(xu(r), "participantName", {
      get: function() {
        return e.participantName;
      }
    }), Object.defineProperty(xu(r), "participantConnectionData", {
      get: function() {
        return e.participantConnectionData;
      }
    }), Object.defineProperty(xu(r), "participantInitials", {
      get: function() {
        return e.participantInitials;
      }
    });
    var n = /* @__PURE__ */ function() {
      var t = al(/* @__PURE__ */ mo().mark(function o() {
        return mo().wrap(function(c) {
          for (; ; ) switch (c.prev = c.next) {
            case 0:
              e.on("connected", function() {
                r.emit("connected");
              }), e.on("disconnected", function(d) {
                return r.emit("disconnected", d);
              }), e.on("reconnecting", function() {
                r.emit("reconnecting");
              }), e.on("reconnected", function() {
                r.emit("reconnected");
              }), e.on("cameraPublisherMediaDisabled", function() {
                r.emit("cameraPublisherMediaDisabled");
              }), e.on("cameraSubscriberVideoDisabled", function(d) {
                r.emit("cameraSubscriberVideoDisabled", d);
              }), e.on("participantJoined", function(d) {
                r.emit("participantJoined", d);
              }), e.on("participantLeft", function(d, u) {
                r.emit("participantLeft", d, u);
              }), e.on("activeSpeakerChanged", function(d) {
                r.emit("activeSpeakerChanged", d);
              }), e.on("signal", function(d) {
                var u, h, A, g = (u = (h = d.type) == null || (A = h.split("signal:")) == null ? void 0 : A[1]) != null ? u : "";
                r.emit("signal", d), g && r.emit("signal:" + g, d);
              });
            case 10:
            case "end":
              return c.stop();
          }
        }, o);
      }));
      return function() {
        return t.apply(this, arguments);
      };
    }();
    return n(), r.join = function(t) {
      return t === void 0 && (t = {}), e.join(t);
    }, r.leave = function() {
      return e.leave();
    }, r.setLayoutMode = function(t) {
      return e.setLayoutMode(t);
    }, r.startScreensharing = function(t) {
      return e.startScreensharing(t);
    }, r.stopScreensharing = function() {
      return e.stopScreensharing();
    }, r.setEncryptionSecret = function(t) {
      return e.setEncryptionSecret(t);
    }, r.signal = function(t) {
      return e.signal(t);
    }, r;
  }
  return a;
}(Qd.EventEmitter), Bv = /* @__PURE__ */ new _p(), xD = /* @__PURE__ */ function() {
  var s = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function a() {
    var i;
    return mo().wrap(function(e) {
      for (; ; ) switch (e.prev = e.next) {
        case 0:
          return Bv.log(Tr.getActiveAudioOutputDevice, Gr.attempt), e.prev = 1, e.next = 4, q0.getActiveAudioOutputDevice();
        case 4:
          return i = e.sent, Bv.log(Tr.getActiveAudioOutputDevice, Gr.success), e.abrupt("return", i);
        case 9:
          throw e.prev = 9, e.t0 = e.catch(1), Bv.log(Tr.getActiveAudioOutputDevice, Gr.failure), new Error("Not able to get active audio output device");
        case 13:
        case "end":
          return e.stop();
      }
    }, a, null, [[1, 9]]);
  }));
  return function() {
    return s.apply(this, arguments);
  };
}(), Zv = /* @__PURE__ */ new _p(), HD = /* @__PURE__ */ function() {
  var s = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function a() {
    var i;
    return mo().wrap(function(e) {
      for (; ; ) switch (e.prev = e.next) {
        case 0:
          return Zv.log(Tr.getAudioOutputDevices, Gr.attempt), e.prev = 1, e.next = 4, q0.getAudioOutputDevices();
        case 4:
          return i = e.sent, Zv.log(Tr.getAudioOutputDevices, Gr.success), e.abrupt("return", i);
        case 9:
          throw e.prev = 9, e.t0 = e.catch(1), Zv.log(Tr.getAudioOutputDevices, Gr.failure), new Error("Not able to get available audio output device");
        case 13:
        case "end":
          return e.stop();
      }
    }, a, null, [[1, 9]]);
  }));
  return function() {
    return s.apply(this, arguments);
  };
}(), PD = /* @__PURE__ */ function() {
  var s = /* @__PURE__ */ al(/* @__PURE__ */ mo().mark(function a(i) {
    var r;
    return mo().wrap(function(n) {
      for (; ; ) switch (n.prev = n.next) {
        case 0:
          return r = new _p(), r.log(Tr.setAudioOutputDevice, Gr.attempt), n.prev = 2, n.next = 6, q0.setAudioOutputDevice(i);
        case 6:
          r.log(Tr.setAudioOutputDevice, Gr.success), n.next = 14;
          break;
        case 9:
          throw n.prev = 9, n.t0 = n.catch(2), r.log(Tr.setAudioOutputDevice, Gr.failure), new Error("Not able to set the audio output device");
        case 14:
        case "end":
          return n.stop();
      }
    }, a, null, [[2, 9]]);
  }));
  return function(i) {
    return s.apply(this, arguments);
  };
}(), OD = require("../package.json");
OD.publicVersion;
function KD() {
  const [s, a] = Tl({
    audioInputDevices: [],
    videoInputDevices: [],
    audioOutputDevices: []
  }), i = Gc(async () => {
    (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) && console.warn("enumerateDevices() not supported.");
    try {
      const r = await jI();
      let e = await HD();
      e = e.map((o) => o.deviceId === "default" ? {
        ...o,
        label: "Padrão"
      } : o);
      const n = r == null ? void 0 : r.filter((o) => o.kind.toLowerCase() === "audioinput"), t = r == null ? void 0 : r.filter((o) => o.kind.toLowerCase() === "videoinput");
      a({
        audioInputDevices: n,
        videoInputDevices: t,
        audioOutputDevices: e
      });
    } catch {
    }
  }, []);
  return Pd(() => {
    if (!pW)
      return navigator.mediaDevices.addEventListener("devicechange", i), i(), () => {
        navigator.mediaDevices.removeEventListener("devicechange", i);
      };
  }, [i]), {
    deviceInfo: s,
    getDevices: i
  };
}
const zD = ({
  mediaCreated: s,
  ...a
}) => {
  const {
    deviceInfo: i,
    getDevices: r
  } = KD(), e = Cu((m) => m.room), n = Cu((m) => m.defaultSettings), [t, o] = Tl(n == null ? void 0 : n.videoSource), [l, c] = Tl(n == null ? void 0 : n.audioSource), [d, u] = Tl(n == null ? void 0 : n.audioOutputSource), h = Oh(() => [{
    value: "Padrão",
    label: ""
  }], []), A = Oh(() => {
    var m, y;
    return (m = i == null ? void 0 : i.videoInputDevices) != null && m.length ? (y = i == null ? void 0 : i.videoInputDevices) == null ? void 0 : y.map((U) => ({
      value: U.deviceId,
      label: U.label
    })) : h;
  }, [i == null ? void 0 : i.videoInputDevices, h]), g = Oh(() => {
    var m, y;
    return (m = i == null ? void 0 : i.audioInputDevices) != null && m.length ? (y = i == null ? void 0 : i.audioInputDevices) == null ? void 0 : y.map((U) => ({
      value: U.deviceId,
      label: U.label
    })) : h;
  }, [i == null ? void 0 : i.audioInputDevices, h]), f = Oh(() => {
    var m, y;
    return (m = i == null ? void 0 : i.audioOutputDevices) != null && m.length ? (y = i == null ? void 0 : i.audioOutputDevices) == null ? void 0 : y.map((U) => ({
      value: U.deviceId,
      label: U.label
    })) : h;
  }, [i == null ? void 0 : i.audioOutputDevices, h]), p = Gc((m, y = !0) => {
    m && (y && e.camera.setVideoDevice(m), o(m));
  }, [e]), v = Gc((m, y = !0) => {
    m && (y && e.camera.setAudioDevice(m), c(m));
  }, [e]), b = async (m, y = !0) => {
    !m || m === "Padrão" || (y && await PD(m), u(m));
  };
  return Pd(() => {
    if (e != null && e.camera && i && s) {
      const m = e.camera;
      m.getAudioDevice().then((U) => {
        v(U == null ? void 0 : U.deviceId, !1);
      });
      const y = m.getVideoDevice();
      p(y == null ? void 0 : y.deviceId, !1), xD().then((U) => {
        b(U == null ? void 0 : U.deviceId, !1);
      });
    }
  }, [i, v, p, e == null ? void 0 : e.camera, s]), Pd(() => {
    r();
  }, [r]), /* @__PURE__ */ We(LC, { title: "Configurações", ...a, children: /* @__PURE__ */ Ir(YC, { mb: 16, children: [
    /* @__PURE__ */ We(j0, { variant: "paragraphSmall", children: "Se não encontrar a câmera ou microfone listados, verifique se estão conectados ao computador e funcionando corretamente." }),
    /* @__PURE__ */ We(cv, { label: "Câmera", placeholder: "Selecione...", fullWidth: !0, value: t, onChange: p, data: A }),
    /* @__PURE__ */ We(cv, { label: "Microfone", fullWidth: !0, placeholder: "Selecione", value: l, onChange: v, data: g }),
    /* @__PURE__ */ We(cv, { label: "Auto-falante", fullWidth: !0, placeholder: "Selecione", value: d, onChange: b, data: f })
  ] }) });
}, jD = (s) => {
  const a = vW({
    isMiniMode: s == null ? void 0 : s.isMiniMode,
    isMobile: Sp
  }), i = QW({
    onChangeMic: s == null ? void 0 : s.onChangeMic,
    participants: s == null ? void 0 : s.participants,
    startRecognition: s == null ? void 0 : s.startRecognition,
    stopRecognition: s == null ? void 0 : s.stopRecognition
  }), [r, e] = Tl(!1);
  return /* @__PURE__ */ Ir("div", { css: a.root, children: [
    (s == null ? void 0 : s.isDoctor) && /* @__PURE__ */ We(u0, { label: "Encerrar chamada", variant: "dark", position: s != null && s.isMiniMode ? "right" : "top", withArrow: !0, children: /* @__PURE__ */ We(Du, { onClick: i == null ? void 0 : i.exitRoom, disabled: !(s != null && s.mediaCreated), busy: i == null ? void 0 : i.isLoadingFinishMeet, endCall: !0, icon: "phone-on", isMiniMode: s == null ? void 0 : s.isMiniMode }) }),
    /* @__PURE__ */ We(u0, { label: i.hasVideo ? "Desativar vídeo" : "Ativar vídeo", variant: "dark", withArrow: !0, children: /* @__PURE__ */ We(Du, { active: !i.hasVideo, onClick: i.toggleVideo, disabled: !(s != null && s.cameraPublishing), icon: i.hasVideo ? "camera-on" : "camera-off", isMiniMode: s == null ? void 0 : s.isMiniMode }) }),
    /* @__PURE__ */ We(u0, { label: i.hasAudio ? "Desativar áudio" : "Ativar áudio", variant: "dark", withArrow: !0, children: /* @__PURE__ */ We(Du, { active: !i.hasAudio, onClick: i.toggleAudio, disabled: !(s != null && s.cameraPublishing), icon: i.hasAudio ? "microphone-on" : "microphone-off", isMiniMode: s == null ? void 0 : s.isMiniMode }) }),
    !(s != null && s.isMiniMode) && /* @__PURE__ */ We(u0, { label: i != null && i.isOpenChat ? "Fechar Chat" : "Abrir chat", variant: "dark", children: /* @__PURE__ */ We(Du, { active: i == null ? void 0 : i.isOpenChat, onClick: i == null ? void 0 : i.toggleChat, disabled: !(s != null && s.mediaCreated), icon: "chat" }) }),
    (s == null ? void 0 : s.isDoctor) && /* @__PURE__ */ We(u0, { label: s != null && s.isExpand ? "Restaurar" : "Expandir", variant: "dark", position: s != null && s.isMiniMode ? "left" : "top", withArrow: !0, children: /* @__PURE__ */ We(Du, { active: s == null ? void 0 : s.isExpand, onClick: s == null ? void 0 : s.onChangeExpand, disabled: !(s != null && s.mediaCreated), icon: "fullscreen", isMiniMode: s == null ? void 0 : s.isMiniMode }) }),
    !Sp && !(s != null && s.isMiniMode) && /* @__PURE__ */ We(u0, { label: i != null && i.isScreenSharing ? "Parar compartilhamento" : "Compartilhar tela", variant: "dark", withArrow: !0, children: /* @__PURE__ */ We(Du, { onClick: () => i != null && i.isScreenSharing ? i == null ? void 0 : i.stopScreenSharing() : i == null ? void 0 : i.startScreenSharing(), disabled: !(s != null && s.mediaCreated), active: i == null ? void 0 : i.isScreenSharing, icon: "share-screen", isMiniMode: s == null ? void 0 : s.isMiniMode }) }),
    !s.isDoctor && !Sp && /* @__PURE__ */ We(u0, { label: i != null && i.isFullscreen ? "Desativar tela cheia" : "Ativar tela cheia", variant: "dark", withArrow: !0, children: /* @__PURE__ */ We(Du, { onClick: () => i != null && i.isFullscreen ? i == null ? void 0 : i.handleExitFullscreen() : i == null ? void 0 : i.handleOpenFullscren(), disabled: !(s != null && s.mediaCreated), active: i == null ? void 0 : i.isFullscreen, icon: "fullscreen" }) }),
    /* @__PURE__ */ We(xm, { condition: !(s != null && s.isMiniMode), children: /* @__PURE__ */ We(u0, { label: "Configurações", withArrow: !0, children: /* @__PURE__ */ We(Du, { icon: "settings-handles", onClick: () => e(!0), disabled: !(s != null && s.mediaCreated), isMiniMode: s == null ? void 0 : s.isMiniMode }) }) }),
    /* @__PURE__ */ We(xm, { condition: s == null ? void 0 : s.enableAttachment, children: /* @__PURE__ */ We(u0, { label: "Enviar anexo", withArrow: !0, children: /* @__PURE__ */ We(Du, { icon: "file", onClick: i == null ? void 0 : i.dispatchAttachment, disabled: !(s != null && s.mediaCreated), isMiniMode: s == null ? void 0 : s.isMiniMode }) }) }),
    /* @__PURE__ */ We(zD, { opened: r, onClose: () => e(!1), mediaCreated: s == null ? void 0 : s.mediaCreated })
  ] });
}, _D = qh((s) => ({
  defaultSettings: {
    subscriberCameraCreated: !1
  },
  updateSettings: (a) => s((i) => ({
    defaultSettings: {
      ...i.defaultSettings,
      ...a
    }
  }))
}));
function $D() {
  const s = z0(null), [a, i] = Tl(!1), [r, e] = Tl(null), [n, t] = Tl([]), [o, l] = Tl(!1), c = Cu((w) => w.setRoom), d = _D((w) => w.updateSettings), [u, h] = Tl(!1), [A, g] = Tl(""), {
    meetSettings: f,
    env: p,
    userType: v
  } = Pb(), b = (w) => {
    t((W) => [...W, w]);
  }, m = ({
    participant: w
  }) => {
    t((W) => W.filter((G) => G.connectionId !== w.id));
  }, y = Gc(async ({
    userId: w,
    sessionId: W,
    reason: G,
    onunload: Z
  }) => await Xp.sessionEvents({
    cause: G,
    event: "participantLeft",
    sessionId: W,
    userId: w,
    eventTimestamp: Date.now()
  }, Z, p), [p]), U = Gc(async (w, W) => await Xp.sessionEvents({
    cause: "",
    event: "participantJoined",
    sessionId: W,
    userId: w,
    eventTimestamp: Date.now()
  }, !1, p), [p]), B = Gc(
    async (w, W) => {
      s.current && (s.current.on("connected", () => {
        console.log("Room: connected");
      }), s.current.on("disconnected", () => {
        e(
          "desconectado"
          /* DISCONNECTED */
        ), console.log("Room: disconnected");
      }), s.current.camera.on("created", async () => {
        l(!0), console.log("camera publishing now"), setTimeout(() => {
          let G = !1;
          const Z = Object.values(s.current.participants);
          Z == null || Z.forEach((K) => {
            var L;
            !(K != null && K.isMe) && W === ((L = JSON.parse(K == null ? void 0 : K.connectionData)) == null ? void 0 : L.userId) && (G = !0);
          }), h(G);
        }, 1800), v === "PROFESSIONAL" && m0.getState().dispatch({
          message: "Profissional se conectou",
          type: "participantJoined",
          userType: "PROFESSIONAL"
        }), await U(W, w);
      }), s.current.on("activeSpeakerChanged", (G) => {
        console.log("Active speaker changed", G);
      }), s.current.on("reconnected", () => {
        e(
          "reconectado"
          /* RECONNECTED */
        ), console.log("Room: reconnected");
      }), s.current.on("reconnecting", () => {
        e(
          "reconectando"
          /* RECONNECTING */
        ), console.log("Room: reconnecting");
      }), s.current.on("participantJoined", async (G) => {
        G.on("cameraCreated", async (Z) => {
          if (Z) {
            d({
              subscriberCameraCreated: !0
            });
            const K = JSON.parse(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              Z == null ? void 0 : Z._stream.connection.data
            );
            console.log("participantJoined", K), b({
              connectionId: G == null ? void 0 : G.id,
              userId: K == null ? void 0 : K.userId
            }), v === "PROFESSIONAL" && m0.getState().dispatch({
              message: "Paciente se conectou",
              type: "participantJoined",
              userType: "PATIENT"
            }), await U(K == null ? void 0 : K.userId, w);
          }
        });
      }), s.current.on("participantLeft", async (G, Z) => {
        var K, L;
        if (oU.invalidateQueries({
          queryKey: ["call-status"]
        }), G != null && G.camera) {
          d({
            subscriberCameraCreated: !1
          });
          const O = JSON.parse(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (K = G == null ? void 0 : G.camera) == null ? void 0 : K._stream.connection.data
          ), de = (L = G == null ? void 0 : G.camera) == null ? void 0 : L._stream.name;
          console.log("participantLeft", O), de && (eb({
            message: `${de} se desconectou`,
            variant: "warning"
          }), y({
            userId: O == null ? void 0 : O.userId,
            sessionId: w,
            reason: Z
          }), v === "PROFESSIONAL" && m0.getState().dispatch({
            message: `${de} se desconectou`,
            type: "participantLeft",
            userType: "PATIENT"
          })), m({
            participant: G
          });
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), Q = Gc(() => {
    s.current && (s.current.removeAllListeners(), s.current.leave());
  }, []), N = Gc(() => {
    s.current && s.current.leave();
  }, []), J = Gc(async ({
    publisherProperties: w,
    retry: W = !1
  }) => {
    if (!f || !(f != null && f.apiKey) || !(f != null && f.sessionId) || !(f != null && f.token))
      throw new Error("Check your credentials");
    g(null), W || (s.current = new LD({
      apiKey: f == null ? void 0 : f.apiKey,
      sessionId: f == null ? void 0 : f.sessionId,
      token: f == null ? void 0 : f.token,
      roomContainer: "roomContainer",
      maxVideoParticipantsOnScreen: 15,
      participantName: f == null ? void 0 : f.name,
      managedLayoutOptions: {
        layoutMode: Sp ? "grid" : "active-speaker",
        screenPublisherContainer: "screenSharingContainer"
        // cameraPublisherContainer: 'publisherContainer',
      }
    }), B(f == null ? void 0 : f.sessionId, f == null ? void 0 : f.userId)), s.current.join({
      publisherProperties: {
        ...w,
        publishAudio: !0,
        publishVideo: !0
      }
    }).then(() => {
      i(!0);
    }).catch((G) => {
      (G == null ? void 0 : G.name) === "OT_AUTHENTICATION_ERROR" && eb({
        message: "Erro de autenticação, token inválido ou expirado",
        variant: "error"
      });
      const Z = {
        OT_AUTHENTICATION_ERROR: "Erro de autenticação, token inválido ou expirado",
        OT_UNABLE_TO_CAPTURE_MEDIA: "Erro ao acessar seus dispositivo de vídeo e microfone, verifique se não tem nenhum outro aplicativo utilizando seus dispositivos",
        OT_HARDWARE_UNAVAILABLE: "Erro ao acessar seus dispositivo de vídeo e microfone, verifique se não tem nenhum outro aplicativo utilizando seus dispositivos",
        OT_USER_MEDIA_ACCESS_DENIED: "Acesso à câmera e/ou microfone negados, é necessário permitir o acesso à câmera e microfone para continuar",
        OT_MEDIA_ENDED: "Acesso à câmera e/ou microfone negados, é necessário permitir o acesso à câmera e microfone para continuar",
        OT_INVALID_SESSION_ID: "Sessão inválida"
      };
      g((Z == null ? void 0 : Z[G == null ? void 0 : G.name]) || "Erro ao acessar seu dispositivo de vídeo na chamada"), console.log(G);
    }), c(s.current);
  }, [f, c, B]);
  return {
    networkStatus: r,
    participants: n,
    cameraPublishing: o,
    mediaCreated: a,
    hasSameUser: u,
    handleParticipantLeft: y,
    createCall: J,
    vonageError: A,
    destroy: Q,
    leave: N
  };
}
const Sv = {
  mobile: Xl`
    .secondary {
      position: relative;

      .OT_subscriber {
        width: 100% !important;
        height: 88% !important;
        left: 0 !important;
        margin: 0 !important;
        top: 0 !important;
      }

      .OT_publisher {
        position: absolute;
        width: 114px !important;
        height: 166px !important;
        right: 8px !important;
        left: initial !important;
        top: 8px !important;
        z-index: 999;
        display: initial !important;

        border-radius: 8px !important;
      }
    }
  `,
  miniMode: Xl`
    overflow: hidden;

    .publisher-audio-button {
      display: none !important;
    }

    .room {
      position: relative;
      height: 100%;
    }

    #layoutContainer {
      margin: 0 !important;
      height: 100% !important;
      width: 100% !important;
      overflow: hidden;
    }

    .OT_publisher {
      width: 100% !important;
      height: 100% !important;
      left: 0 !important;
      margin: 0 !important;
      border-radius: 0px !important;

      position: absolute;
      right: 10px;
      top: 0px !important;
      z-index: 999;
    }

    .OT_subscriber {
      width: 100% !important;
      height: 100% !important;
      left: 0 !important;
      margin: 0 !important;
      top: 0 !important;
      border-radius: 0px !important;
    }

    .secondary {
      position: relative;

      .OT_publisher {
        position: absolute;
        width: 64px !important;
        height: 96px !important;
        right: 8px !important;
        left: initial !important;
        top: 8px !important;
        z-index: 999;

        border-radius: 8px !important;
      }
    }

    .participant-name {
      display: none !important;
    }
  `,
  expand: Xl`
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999;
  `
}, qD = zA({
  root: ({
    colors: s,
    border: a
  }, {
    isMobile: i,
    isMiniMode: r,
    isOneToOne: e,
    isDoctor: n,
    isExpand: t
  }) => {
    var o;
    return Xl`
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    background: ${s.neutral[500]};
    overflow: hidden;

    border-radius: ${(o = a == null ? void 0 : a.radius) == null ? void 0 : o.lg};
    position: relative;
    z-index: 0;

    .room {
      position: relative;
      height: 100%;
      min-height: 300px;
    }

    #layoutContainer {
      min-height: 300px;
    }

    #screenSharingContainer {
      position: absolute;
      z-index: 10;
      max-width: 300px;
      width: 100%;
      max-height: 260px;
      aspect-ratio: 16/9;
      border-radius: 8px;
      overflow: hidden;
      left: 20px;
      top: 20px;

      .OT_publisher {
        position: initial !important;
      }
    }

    .OT_archiving {
      display: none !important;
    }

    .OT_publisher {
      display: initial !important;
    }

    .button-pip {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 999;
    }

    ${i && e && !n && Sv.mobile}
    ${r && n && Sv.miniMode}
    ${t && Sv.expand}
  `;
  }
}), eM = zA({
  root: Xl`
    width: 100%;
    height: 100%;

    html: {
      height: webkit-fill-available;
    }

    body:fullscreen {
      overflow: auto;
    }
    body:-ms-fullscreen {
      overflow: auto;
    }
    body:-webkit-full-screen {
      overflow: auto;
    }
    body:-moz-full-screen {
      overflow: auto;
    }

    body,
    #root {
      min-height: webkit-fill-available;
      display: flex;
      flex-direction: column;
    }

    #root {
      flex: 1;
    }

    body,
    div,
    input,
    textarea,
    label,
    button {
      font-family: "Source Sans 3", sans-serif !important;
    }

    input[type="number"]::-webkit-inner-spin-button,
    input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .results {
      align-items: center;
    }

    #roomContainer {
      z-index: 1;
    }
  `
}), $I = qh((s) => ({
  transcriptTexts: [],
  listOfMessages: [],
  enabledMic: !0,
  addMessageToList: (a) => s((i) => ({
    listOfMessages: [...i.listOfMessages, a]
  })),
  setTranscript(a, i) {
    s((r) => ({
      transcriptTexts: [...r.transcriptTexts, {
        content: a,
        type: i === "PROFESSIONAL" ? "PROFESSIONAL" : "PATIENT"
      }]
    }));
  }
}));
function tM(s) {
  const a = s.getHours() % 12, i = s.getMinutes(), r = a ? a < 10 ? "0" + a : a : 12, e = i < 10 ? "0" + i : i;
  return `${r}.${e}`;
}
function nM() {
  const s = Cu((t) => t.room), a = m0((t) => t.dispatch), i = wp((t) => t.handleOpen), r = $I((t) => t.addMessageToList), e = Gc(({
    data: t,
    isSentByMe: o,
    from: l
  }) => {
    const c = tM(/* @__PURE__ */ new Date());
    r({
      data: t,
      isSentByMe: o,
      from: l,
      date: c
    }), i();
  }, [r, i]), n = Gc((t) => {
    const [o, l] = t.split(":");
    a({
      type: "transcription",
      message: l,
      userType: o
    });
  }, [a]);
  Pd(() => {
    if (s) {
      const t = (o) => {
        var l;
        o.type === "signal:transcription" && (o.isSentByMe || n(o.data)), o.type === "signal:msg" && e({
          data: o == null ? void 0 : o.data,
          from: (l = o == null ? void 0 : o.from) == null ? void 0 : l.name,
          isSentByMe: o == null ? void 0 : o.isSentByMe
        });
      };
      return s.on("signal", t), () => {
        s.off("signal", t);
      };
    }
  }, [s]);
}
const rM = zA({
  root: (s) => Xl`
    padding: ${s.spacing.sm} 0;

    display: flex;
    flex-direction: column;
    gap: ${s.spacing.xxs};
  `
});
var qI = /* @__PURE__ */ ((s) => (s.WHATSAPP = "https://wa.me/", s))(qI || {});
const iM = () => {
  const s = qI.WHATSAPP, a = "+55(21)96696-4821", i = "Olá, preciso de suporte.", r = (t) => t.replace(/\D/g, ""), e = Oh(() => encodeURIComponent(i), [i]);
  return {
    redirectToSupportChat: Gc(() => {
      const t = r(a);
      return window.open(`${s}${t}?text=${e}`, "_blank");
    }, [a, e, s])
  };
}, oM = (s) => {
  const a = rM(), {
    redirectToSupportChat: i
  } = iM(), r = Cu((t) => t.defaultSettings), e = SE(), n = () => {
    s == null || s.retryPublish({
      publisherProperties: {
        publishAudio: !0,
        publishVideo: !0,
        ...(r == null ? void 0 : r.videoSource) && {
          videoSource: r == null ? void 0 : r.videoSource
        },
        ...(r == null ? void 0 : r.audioSource) && {
          audioSource: r == null ? void 0 : r.audioSource
        },
        mirror: !0
      },
      retry: !0
    });
  };
  return /* @__PURE__ */ We(LC, { opened: !!(s != null && s.error) && !(s != null && s.isNewMedicalRecord), closeOnClickOutside: !1, closeOnEscape: !1, withCloseButton: !1, onClose: () => {
  }, title: "Ops! Parece que estamos com problemas na videoconferência.", primaryActionLabel: "Tentar novamente", primaryAction: n, negativeActionLabel: "Conversar com suporte", negativeAction: i, children: /* @__PURE__ */ Ir("div", { css: a.root, children: [
    /* @__PURE__ */ Ir(j0, { variant: "subheading", color: e.colors.feedback.error[300], children: [
      s == null ? void 0 : s.error,
      "!"
    ] }),
    /* @__PURE__ */ We(j0, { children: "Clique no botão abaixo para para tentar novamente, ou inicie uma conversa com o suporte." })
  ] }) });
}, aM = (s) => {
  const [a, i] = Tl({
    width: 0,
    height: 0
  }), r = Gc(() => {
    if (s) {
      const {
        width: e,
        height: n
      } = s.getBoundingClientRect();
      i({
        width: e,
        height: n
      });
    }
  }, [s]);
  return Pd(() => {
    if (!s) return;
    r();
    const e = new ResizeObserver(r);
    return s && e.observe(s), () => {
      e.disconnect();
    };
  }, [s, r]), {
    width: a == null ? void 0 : a.width,
    height: a == null ? void 0 : a.height
  };
}, eB = qh(() => ({
  isEnded: !1
}));
function tB(s) {
  var a, i, r = "";
  if (typeof s == "string" || typeof s == "number")
    r += s;
  else if (typeof s == "object")
    if (Array.isArray(s))
      for (a = 0; a < s.length; a++)
        s[a] && (i = tB(s[a])) && (r && (r += " "), r += i);
    else
      for (a in s)
        s[a] && (r && (r += " "), r += a);
  return r;
}
function sM() {
  for (var s = 0, a, i, r = ""; s < arguments.length; )
    (a = arguments[s++]) && (i = tB(a)) && (r && (r += " "), r += i);
  return r;
}
const lM = {
  dark: [
    "#C1C2C5",
    "#A6A7AB",
    "#909296",
    "#5c5f66",
    "#373A40",
    "#2C2E33",
    "#25262b",
    "#1A1B1E",
    "#141517",
    "#101113"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
};
function cM(s) {
  return () => ({ fontFamily: s.fontFamily || "sans-serif" });
}
var dM = Object.defineProperty, PR = Object.getOwnPropertySymbols, uM = Object.prototype.hasOwnProperty, hM = Object.prototype.propertyIsEnumerable, OR = (s, a, i) => a in s ? dM(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, KR = (s, a) => {
  for (var i in a || (a = {}))
    uM.call(a, i) && OR(s, i, a[i]);
  if (PR)
    for (var i of PR(a))
      hM.call(a, i) && OR(s, i, a[i]);
  return s;
};
function AM(s) {
  return (a) => ({
    WebkitTapHighlightColor: "transparent",
    [a || "&:focus"]: KR({}, s.focusRing === "always" || s.focusRing === "auto" ? s.focusRingStyles.styles(s) : s.focusRingStyles.resetStyles(s)),
    [a ? a.replace(":focus", ":focus:not(:focus-visible)") : "&:focus:not(:focus-visible)"]: KR({}, s.focusRing === "auto" || s.focusRing === "never" ? s.focusRingStyles.resetStyles(s) : null)
  });
}
function $p(s) {
  return (a) => typeof s.primaryShade == "number" ? s.primaryShade : s.primaryShade[a || s.colorScheme];
}
function $b(s) {
  const a = $p(s);
  return (i, r, e = !0, n = !0) => {
    if (typeof i == "string" && i.includes(".")) {
      const [o, l] = i.split("."), c = parseInt(l, 10);
      if (o in s.colors && c >= 0 && c < 10)
        return s.colors[o][typeof r == "number" && !n ? r : c];
    }
    const t = typeof r == "number" ? r : a();
    return i in s.colors ? s.colors[i][t] : e ? s.colors[s.primaryColor][t] : i;
  };
}
function nB(s) {
  let a = "";
  for (let i = 1; i < s.length - 1; i += 1)
    a += `${s[i]} ${i / (s.length - 1) * 100}%, `;
  return `${s[0]} 0%, ${a}${s[s.length - 1]} 100%`;
}
function gM(s, ...a) {
  return `linear-gradient(${s}deg, ${nB(a)})`;
}
function fM(...s) {
  return `radial-gradient(circle, ${nB(s)})`;
}
function rB(s) {
  const a = $b(s), i = $p(s);
  return (r) => {
    const e = {
      from: (r == null ? void 0 : r.from) || s.defaultGradient.from,
      to: (r == null ? void 0 : r.to) || s.defaultGradient.to,
      deg: (r == null ? void 0 : r.deg) || s.defaultGradient.deg
    };
    return `linear-gradient(${e.deg}deg, ${a(e.from, i(), !1)} 0%, ${a(e.to, i(), !1)} 100%)`;
  };
}
function iB(s) {
  return (a) => {
    if (typeof a == "number")
      return `${a / 16}${s}`;
    if (typeof a == "string") {
      const i = a.replace("px", "");
      if (!Number.isNaN(Number(i)))
        return `${Number(i) / 16}${s}`;
    }
    return a;
  };
}
const bd = iB("rem"), qb = iB("em");
function F0({
  size: s,
  sizes: a,
  units: i
}) {
  return s in a ? a[s] : typeof s == "number" ? i === "em" ? qb(s) : bd(s) : s || a.md;
}
function $m(s) {
  return typeof s == "number" ? s : typeof s == "string" && s.includes("rem") ? Number(s.replace("rem", "")) * 16 : typeof s == "string" && s.includes("em") ? Number(s.replace("em", "")) * 16 : Number(s);
}
function pM(s) {
  return (a) => `@media (min-width: ${qb($m(F0({ size: a, sizes: s.breakpoints })))})`;
}
function mM(s) {
  return (a) => `@media (max-width: ${qb($m(F0({ size: a, sizes: s.breakpoints })) - 1)})`;
}
function vM(s) {
  return /^#?([0-9A-F]{3}){1,2}$/i.test(s);
}
function bM(s) {
  let a = s.replace("#", "");
  if (a.length === 3) {
    const t = a.split("");
    a = [
      t[0],
      t[0],
      t[1],
      t[1],
      t[2],
      t[2]
    ].join("");
  }
  const i = parseInt(a, 16), r = i >> 16 & 255, e = i >> 8 & 255, n = i & 255;
  return {
    r,
    g: e,
    b: n,
    a: 1
  };
}
function FM(s) {
  const [a, i, r, e] = s.replace(/[^0-9,.]/g, "").split(",").map(Number);
  return { r: a, g: i, b: r, a: e || 1 };
}
function eF(s) {
  return vM(s) ? bM(s) : s.startsWith("rgb") ? FM(s) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function kA(s, a) {
  if (typeof s != "string" || a > 1 || a < 0)
    return "rgba(0, 0, 0, 1)";
  if (s.startsWith("var(--"))
    return s;
  const { r: i, g: r, b: e } = eF(s);
  return `rgba(${i}, ${r}, ${e}, ${a})`;
}
function RM(s = 0) {
  return {
    position: "absolute",
    top: bd(s),
    right: bd(s),
    left: bd(s),
    bottom: bd(s)
  };
}
function yM(s, a) {
  if (typeof s == "string" && s.startsWith("var(--"))
    return s;
  const { r: i, g: r, b: e, a: n } = eF(s), t = 1 - a, o = (l) => Math.round(l * t);
  return `rgba(${o(i)}, ${o(r)}, ${o(e)}, ${n})`;
}
function QM(s, a) {
  if (typeof s == "string" && s.startsWith("var(--"))
    return s;
  const { r: i, g: r, b: e, a: n } = eF(s), t = (o) => Math.round(o + (255 - o) * a);
  return `rgba(${t(i)}, ${t(r)}, ${t(e)}, ${n})`;
}
function CM(s) {
  return (a) => {
    if (typeof a == "number")
      return bd(a);
    const i = typeof s.defaultRadius == "number" ? s.defaultRadius : s.radius[s.defaultRadius] || s.defaultRadius;
    return s.radius[a] || a || i;
  };
}
function UM(s, a) {
  if (typeof s == "string" && s.includes(".")) {
    const [i, r] = s.split("."), e = parseInt(r, 10);
    if (i in a.colors && e >= 0 && e < 10)
      return { isSplittedColor: !0, key: i, shade: e };
  }
  return { isSplittedColor: !1 };
}
function IM(s) {
  const a = $b(s), i = $p(s), r = rB(s);
  return ({ variant: e, color: n, gradient: t, primaryFallback: o }) => {
    const l = UM(n, s);
    switch (e) {
      case "light":
        return {
          border: "transparent",
          background: kA(a(n, s.colorScheme === "dark" ? 8 : 0, o, !1), s.colorScheme === "dark" ? 0.2 : 1),
          color: n === "dark" ? s.colorScheme === "dark" ? s.colors.dark[0] : s.colors.dark[9] : a(n, s.colorScheme === "dark" ? 2 : i("light")),
          hover: kA(a(n, s.colorScheme === "dark" ? 7 : 1, o, !1), s.colorScheme === "dark" ? 0.25 : 0.65)
        };
      case "subtle":
        return {
          border: "transparent",
          background: "transparent",
          color: n === "dark" ? s.colorScheme === "dark" ? s.colors.dark[0] : s.colors.dark[9] : a(n, s.colorScheme === "dark" ? 2 : i("light")),
          hover: kA(a(n, s.colorScheme === "dark" ? 8 : 0, o, !1), s.colorScheme === "dark" ? 0.2 : 1)
        };
      case "outline":
        return {
          border: a(n, s.colorScheme === "dark" ? 5 : i("light")),
          background: "transparent",
          color: a(n, s.colorScheme === "dark" ? 5 : i("light")),
          hover: s.colorScheme === "dark" ? kA(a(n, 5, o, !1), 0.05) : kA(a(n, 0, o, !1), 0.35)
        };
      case "default":
        return {
          border: s.colorScheme === "dark" ? s.colors.dark[4] : s.colors.gray[4],
          background: s.colorScheme === "dark" ? s.colors.dark[6] : s.white,
          color: s.colorScheme === "dark" ? s.white : s.black,
          hover: s.colorScheme === "dark" ? s.colors.dark[5] : s.colors.gray[0]
        };
      case "white":
        return {
          border: "transparent",
          background: s.white,
          color: a(n, i()),
          hover: null
        };
      case "transparent":
        return {
          border: "transparent",
          color: n === "dark" ? s.colorScheme === "dark" ? s.colors.dark[0] : s.colors.dark[9] : a(n, s.colorScheme === "dark" ? 2 : i("light")),
          background: "transparent",
          hover: null
        };
      case "gradient":
        return {
          background: r(t),
          color: s.white,
          border: "transparent",
          hover: null
        };
      default: {
        const c = i(), d = l.isSplittedColor ? l.shade : c, u = l.isSplittedColor ? l.key : n;
        return {
          border: "transparent",
          background: a(u, d, o),
          color: s.white,
          hover: a(u, d === 9 ? 8 : d + 1)
        };
      }
    }
  };
}
function BM(s) {
  return (a) => {
    const i = $p(s)(a);
    return s.colors[s.primaryColor][i];
  };
}
function ZM(s) {
  return {
    "@media (hover: hover)": {
      "&:hover": s
    },
    "@media (hover: none)": {
      "&:active": s
    }
  };
}
function SM(s) {
  return () => ({
    userSelect: "none",
    color: s.colorScheme === "dark" ? s.colors.dark[3] : s.colors.gray[5]
  });
}
function EM(s) {
  return () => s.colorScheme === "dark" ? s.colors.dark[2] : s.colors.gray[6];
}
const Bc = {
  fontStyles: cM,
  themeColor: $b,
  focusStyles: AM,
  linearGradient: gM,
  radialGradient: fM,
  smallerThan: mM,
  largerThan: pM,
  rgba: kA,
  cover: RM,
  darken: yM,
  lighten: QM,
  radius: CM,
  variant: IM,
  primaryShade: $p,
  hover: ZM,
  gradient: rB,
  primaryColor: BM,
  placeholderStyles: SM,
  dimmed: EM
};
var VM = Object.defineProperty, WM = Object.defineProperties, NM = Object.getOwnPropertyDescriptors, zR = Object.getOwnPropertySymbols, JM = Object.prototype.hasOwnProperty, GM = Object.prototype.propertyIsEnumerable, jR = (s, a, i) => a in s ? VM(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, TM = (s, a) => {
  for (var i in a || (a = {}))
    JM.call(a, i) && jR(s, i, a[i]);
  if (zR)
    for (var i of zR(a))
      GM.call(a, i) && jR(s, i, a[i]);
  return s;
}, XM = (s, a) => WM(s, NM(a));
function kM(s) {
  return XM(TM({}, s), {
    fn: {
      fontStyles: Bc.fontStyles(s),
      themeColor: Bc.themeColor(s),
      focusStyles: Bc.focusStyles(s),
      largerThan: Bc.largerThan(s),
      smallerThan: Bc.smallerThan(s),
      radialGradient: Bc.radialGradient,
      linearGradient: Bc.linearGradient,
      gradient: Bc.gradient(s),
      rgba: Bc.rgba,
      cover: Bc.cover,
      lighten: Bc.lighten,
      darken: Bc.darken,
      primaryShade: Bc.primaryShade(s),
      radius: Bc.radius(s),
      variant: Bc.variant(s),
      hover: Bc.hover,
      primaryColor: Bc.primaryColor(s),
      placeholderStyles: Bc.placeholderStyles(s),
      dimmed: Bc.dimmed(s)
    }
  });
}
const wM = {
  dir: "ltr",
  primaryShade: {
    light: 6,
    dark: 8
  },
  focusRing: "auto",
  loader: "oval",
  colorScheme: "light",
  white: "#fff",
  black: "#000",
  defaultRadius: "sm",
  transitionTimingFunction: "ease",
  colors: lM,
  lineHeight: 1.55,
  fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  primaryColor: "blue",
  respectReducedMotion: !0,
  cursorType: "default",
  defaultGradient: {
    from: "indigo",
    to: "cyan",
    deg: 45
  },
  shadows: {
    xs: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.1)",
    sm: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 0.625rem 0.9375rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.4375rem 0.4375rem -0.3125rem",
    md: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.25rem 1.5625rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.625rem 0.625rem -0.3125rem",
    lg: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 0.75rem 0.75rem -0.4375rem",
    xl: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 2.25rem 1.75rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 1.0625rem 1.0625rem -0.4375rem"
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem"
  },
  radius: {
    xs: "0.125rem",
    sm: "0.25rem",
    md: "0.5rem",
    lg: "1rem",
    xl: "2rem"
  },
  spacing: {
    xs: "0.625rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem"
  },
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em"
  },
  headings: {
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontWeight: 700,
    sizes: {
      h1: { fontSize: "2.125rem", lineHeight: 1.3, fontWeight: void 0 },
      h2: { fontSize: "1.625rem", lineHeight: 1.35, fontWeight: void 0 },
      h3: { fontSize: "1.375rem", lineHeight: 1.4, fontWeight: void 0 },
      h4: { fontSize: "1.125rem", lineHeight: 1.45, fontWeight: void 0 },
      h5: { fontSize: "1rem", lineHeight: 1.5, fontWeight: void 0 },
      h6: { fontSize: "0.875rem", lineHeight: 1.5, fontWeight: void 0 }
    }
  },
  other: {},
  components: {},
  activeStyles: { transform: "translateY(0.0625rem)" },
  datesLocale: "en",
  globalStyles: void 0,
  focusRingStyles: {
    styles: (s) => ({
      outlineOffset: "0.125rem",
      outline: `0.125rem solid ${s.colors[s.primaryColor][s.colorScheme === "dark" ? 7 : 5]}`
    }),
    resetStyles: () => ({ outline: "none" }),
    inputStyles: (s) => ({
      outline: "none",
      borderColor: s.colors[s.primaryColor][typeof s.primaryShade == "object" ? s.primaryShade[s.colorScheme] : s.primaryShade]
    })
  }
}, oB = kM(wM);
function aB(s) {
  return Object.keys(s).reduce((a, i) => (s[i] !== void 0 && (a[i] = s[i]), a), {});
}
var DM = Object.defineProperty, _R = Object.getOwnPropertySymbols, MM = Object.prototype.hasOwnProperty, YM = Object.prototype.propertyIsEnumerable, $R = (s, a, i) => a in s ? DM(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, Ev = (s, a) => {
  for (var i in a || (a = {}))
    MM.call(a, i) && $R(s, i, a[i]);
  if (_R)
    for (var i of _R(a))
      YM.call(a, i) && $R(s, i, a[i]);
  return s;
};
const sB = Pp({
  theme: oB
});
function v1() {
  var s;
  return ((s = KA(sB)) == null ? void 0 : s.theme) || oB;
}
function LM(s) {
  const a = v1(), i = (r) => {
    var e, n, t, o;
    return {
      styles: ((e = a.components[r]) == null ? void 0 : e.styles) || {},
      classNames: ((n = a.components[r]) == null ? void 0 : n.classNames) || {},
      variants: (t = a.components[r]) == null ? void 0 : t.variants,
      sizes: (o = a.components[r]) == null ? void 0 : o.sizes
    };
  };
  return Array.isArray(s) ? s.map(i) : [i(s)];
}
function lB() {
  var s;
  return (s = KA(sB)) == null ? void 0 : s.emotionCache;
}
function b1(s, a, i) {
  var r;
  const e = v1(), n = (r = e.components[s]) == null ? void 0 : r.defaultProps, t = typeof n == "function" ? n(e) : n;
  return Ev(Ev(Ev({}, a), t), aB(i));
}
function xM(s, a) {
  const i = z0();
  return (!i.current || a.length !== i.current.prevDeps.length || i.current.prevDeps.map((r, e) => r === a[e]).indexOf(!1) >= 0) && (i.current = {
    v: s(),
    prevDeps: [...a]
  }), i.current.v;
}
const HM = _C({ key: "mantine", prepend: !0 });
function PM() {
  return lB() || HM;
}
var OM = Object.defineProperty, qR = Object.getOwnPropertySymbols, KM = Object.prototype.hasOwnProperty, zM = Object.prototype.propertyIsEnumerable, ey = (s, a, i) => a in s ? OM(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, jM = (s, a) => {
  for (var i in a || (a = {}))
    KM.call(a, i) && ey(s, i, a[i]);
  if (qR)
    for (var i of qR(a))
      zM.call(a, i) && ey(s, i, a[i]);
  return s;
};
const Vv = "ref";
function _M(s) {
  let a;
  if (s.length !== 1)
    return { args: s, ref: a };
  const [i] = s;
  if (!(i instanceof Object))
    return { args: s, ref: a };
  if (!(Vv in i))
    return { args: s, ref: a };
  a = i[Vv];
  const r = jM({}, i);
  return delete r[Vv], { args: [r], ref: a };
}
const { cssFactory: $M } = /* @__PURE__ */ (() => {
  function s(i, r, e) {
    const n = [], t = eU(i, n, e);
    return n.length < 2 ? e : t + r(n);
  }
  function a(i) {
    const { cache: r } = i, e = (...t) => {
      const { ref: o, args: l } = _M(t), c = ib(l, r.registered);
      return tU(r, c, !1), `${r.key}-${c.name}${o === void 0 ? "" : ` ${o}`}`;
    };
    return { css: e, cx: (...t) => s(r.registered, e, sM(t)) };
  }
  return { cssFactory: a };
})();
function cB() {
  const s = PM();
  return xM(() => $M({ cache: s }), [s]);
}
function qM({
  cx: s,
  classes: a,
  context: i,
  classNames: r,
  name: e,
  cache: n
}) {
  const t = i.reduce((o, l) => (Object.keys(l.classNames).forEach((c) => {
    typeof o[c] != "string" ? o[c] = `${l.classNames[c]}` : o[c] = `${o[c]} ${l.classNames[c]}`;
  }), o), {});
  return Object.keys(a).reduce((o, l) => (o[l] = s(a[l], t[l], r != null && r[l], Array.isArray(e) ? e.filter(Boolean).map((c) => `${(n == null ? void 0 : n.key) || "mantine"}-${c}-${l}`).join(" ") : e ? `${(n == null ? void 0 : n.key) || "mantine"}-${e}-${l}` : null), o), {});
}
var eY = Object.defineProperty, ty = Object.getOwnPropertySymbols, tY = Object.prototype.hasOwnProperty, nY = Object.prototype.propertyIsEnumerable, ny = (s, a, i) => a in s ? eY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, Wv = (s, a) => {
  for (var i in a || (a = {}))
    tY.call(a, i) && ny(s, i, a[i]);
  if (ty)
    for (var i of ty(a))
      nY.call(a, i) && ny(s, i, a[i]);
  return s;
};
function Vb(s, a) {
  return a && Object.keys(a).forEach((i) => {
    s[i] ? s[i] = Wv(Wv({}, s[i]), a[i]) : s[i] = Wv({}, a[i]);
  }), s;
}
function ry(s, a, i, r) {
  const e = (n) => typeof n == "function" ? n(a, i || {}, r) : n || {};
  return Array.isArray(s) ? s.map((n) => e(n.styles)).reduce((n, t) => Vb(n, t), {}) : e(s);
}
function rY({ ctx: s, theme: a, params: i, variant: r, size: e }) {
  return s.reduce((n, t) => (t.variants && r in t.variants && Vb(n, t.variants[r](a, i, { variant: r, size: e })), t.sizes && e in t.sizes && Vb(n, t.sizes[e](a, i, { variant: r, size: e })), n), {});
}
function F1(s) {
  const a = typeof s == "function" ? s : () => s;
  function i(r, e) {
    const n = v1(), t = LM(e == null ? void 0 : e.name), o = lB(), l = { variant: e == null ? void 0 : e.variant, size: e == null ? void 0 : e.size }, { css: c, cx: d } = cB(), u = a(n, r, l), h = ry(e == null ? void 0 : e.styles, n, r, l), A = ry(t, n, r, l), g = rY({
      ctx: t,
      theme: n,
      params: r,
      variant: e == null ? void 0 : e.variant,
      size: e == null ? void 0 : e.size
    }), f = Object.fromEntries(Object.keys(u).map((p) => {
      const v = d({ [c(u[p])]: !(e != null && e.unstyled) }, c(g[p]), c(A[p]), c(h[p]));
      return [p, v];
    }));
    return {
      classes: qM({
        cx: d,
        classes: f,
        context: t,
        classNames: e == null ? void 0 : e.classNames,
        name: e == null ? void 0 : e.name,
        cache: o
      }),
      cx: d,
      theme: n
    };
  }
  return i;
}
var iy = Object.getOwnPropertySymbols, iY = Object.prototype.hasOwnProperty, oY = Object.prototype.propertyIsEnumerable, aY = (s, a) => {
  var i = {};
  for (var r in s)
    iY.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && iy)
    for (var r of iy(s))
      a.indexOf(r) < 0 && oY.call(s, r) && (i[r] = s[r]);
  return i;
};
function sY(s) {
  const a = s, {
    m: i,
    mx: r,
    my: e,
    mt: n,
    mb: t,
    ml: o,
    mr: l,
    p: c,
    px: d,
    py: u,
    pt: h,
    pb: A,
    pl: g,
    pr: f,
    bg: p,
    c: v,
    opacity: b,
    ff: m,
    fz: y,
    fw: U,
    lts: B,
    ta: Q,
    lh: N,
    fs: J,
    tt: w,
    td: W,
    w: G,
    miw: Z,
    maw: K,
    h: L,
    mih: O,
    mah: de,
    bgsz: oe,
    bgp: fe,
    bgr: ge,
    bga: we,
    pos: _e,
    top: Te,
    left: Pe,
    bottom: $e,
    right: Bt,
    inset: Le,
    display: at
  } = a, pt = aY(a, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display"
  ]);
  return { systemStyles: aB({
    m: i,
    mx: r,
    my: e,
    mt: n,
    mb: t,
    ml: o,
    mr: l,
    p: c,
    px: d,
    py: u,
    pt: h,
    pb: A,
    pl: g,
    pr: f,
    bg: p,
    c: v,
    opacity: b,
    ff: m,
    fz: y,
    fw: U,
    lts: B,
    ta: Q,
    lh: N,
    fs: J,
    tt: w,
    td: W,
    w: G,
    miw: Z,
    maw: K,
    h: L,
    mih: O,
    mah: de,
    bgsz: oe,
    bgp: fe,
    bgr: ge,
    bga: we,
    pos: _e,
    top: Te,
    left: Pe,
    bottom: $e,
    right: Bt,
    inset: Le,
    display: at
  }), rest: pt };
}
function lY(s, a) {
  const i = Object.keys(s).filter((r) => r !== "base").sort((r, e) => $m(F0({ size: r, sizes: a.breakpoints })) - $m(F0({ size: e, sizes: a.breakpoints })));
  return "base" in s ? ["base", ...i] : i;
}
function cY({ value: s, theme: a, getValue: i, property: r }) {
  if (s == null)
    return;
  if (typeof s == "object")
    return lY(s, a).reduce((t, o) => {
      if (o === "base" && s.base !== void 0) {
        const c = i(s.base, a);
        return Array.isArray(r) ? (r.forEach((d) => {
          t[d] = c;
        }), t) : (t[r] = c, t);
      }
      const l = i(s[o], a);
      return Array.isArray(r) ? (t[a.fn.largerThan(o)] = {}, r.forEach((c) => {
        t[a.fn.largerThan(o)][c] = l;
      }), t) : (t[a.fn.largerThan(o)] = {
        [r]: l
      }, t);
    }, {});
  const e = i(s, a);
  return Array.isArray(r) ? r.reduce((n, t) => (n[t] = e, n), {}) : { [r]: e };
}
function dY(s, a) {
  return s === "dimmed" ? a.colorScheme === "dark" ? a.colors.dark[2] : a.colors.gray[6] : a.fn.variant({ variant: "filled", color: s, primaryFallback: !1 }).background;
}
function uY(s) {
  return bd(s);
}
function hY(s) {
  return s;
}
function AY(s, a) {
  return F0({ size: s, sizes: a.fontSizes });
}
const gY = ["-xs", "-sm", "-md", "-lg", "-xl"];
function fY(s, a) {
  return gY.includes(s) ? `calc(${F0({
    size: s.replace("-", ""),
    sizes: a.spacing
  })} * -1)` : F0({ size: s, sizes: a.spacing });
}
const pY = {
  identity: hY,
  color: dY,
  size: uY,
  fontSize: AY,
  spacing: fY
}, mY = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  mx: { type: "spacing", property: ["marginRight", "marginLeft"] },
  my: { type: "spacing", property: ["marginTop", "marginBottom"] },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  px: { type: "spacing", property: ["paddingRight", "paddingLeft"] },
  py: { type: "spacing", property: ["paddingTop", "paddingBottom"] },
  bg: { type: "color", property: "background" },
  c: { type: "color", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  ff: { type: "identity", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "identity", property: "fontWeight" },
  lts: { type: "size", property: "letterSpacing" },
  ta: { type: "identity", property: "textAlign" },
  lh: { type: "identity", property: "lineHeight" },
  fs: { type: "identity", property: "fontStyle" },
  tt: { type: "identity", property: "textTransform" },
  td: { type: "identity", property: "textDecoration" },
  w: { type: "spacing", property: "width" },
  miw: { type: "spacing", property: "minWidth" },
  maw: { type: "spacing", property: "maxWidth" },
  h: { type: "spacing", property: "height" },
  mih: { type: "spacing", property: "minHeight" },
  mah: { type: "spacing", property: "maxHeight" },
  bgsz: { type: "size", property: "backgroundSize" },
  bgp: { type: "identity", property: "backgroundPosition" },
  bgr: { type: "identity", property: "backgroundRepeat" },
  bga: { type: "identity", property: "backgroundAttachment" },
  pos: { type: "identity", property: "position" },
  top: { type: "identity", property: "top" },
  left: { type: "size", property: "left" },
  bottom: { type: "size", property: "bottom" },
  right: { type: "size", property: "right" },
  inset: { type: "size", property: "inset" },
  display: { type: "identity", property: "display" }
};
var vY = Object.defineProperty, oy = Object.getOwnPropertySymbols, bY = Object.prototype.hasOwnProperty, FY = Object.prototype.propertyIsEnumerable, ay = (s, a, i) => a in s ? vY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, sy = (s, a) => {
  for (var i in a || (a = {}))
    bY.call(a, i) && ay(s, i, a[i]);
  if (oy)
    for (var i of oy(a))
      FY.call(a, i) && ay(s, i, a[i]);
  return s;
};
function ly(s, a, i = mY) {
  return Object.keys(i).reduce((e, n) => (n in s && s[n] !== void 0 && e.push(cY({
    value: s[n],
    getValue: pY[i[n].type],
    property: i[n].property,
    theme: a
  })), e), []).reduce((e, n) => (Object.keys(n).forEach((t) => {
    typeof n[t] == "object" && n[t] !== null && t in e ? e[t] = sy(sy({}, e[t]), n[t]) : e[t] = n[t];
  }), e), {});
}
function cy(s, a) {
  return typeof s == "function" ? s(a) : s;
}
function RY(s, a, i) {
  const r = v1(), { css: e, cx: n } = cB();
  return Array.isArray(s) ? n(i, e(ly(a, r)), s.map((t) => e(cy(t, r)))) : n(i, e(cy(s, r)), e(ly(a, r)));
}
var yY = Object.defineProperty, qm = Object.getOwnPropertySymbols, dB = Object.prototype.hasOwnProperty, uB = Object.prototype.propertyIsEnumerable, dy = (s, a, i) => a in s ? yY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, QY = (s, a) => {
  for (var i in a || (a = {}))
    dB.call(a, i) && dy(s, i, a[i]);
  if (qm)
    for (var i of qm(a))
      uB.call(a, i) && dy(s, i, a[i]);
  return s;
}, CY = (s, a) => {
  var i = {};
  for (var r in s)
    dB.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && qm)
    for (var r of qm(s))
      a.indexOf(r) < 0 && uB.call(s, r) && (i[r] = s[r]);
  return i;
};
const hB = eA((s, a) => {
  var i = s, { className: r, component: e, style: n, sx: t } = i, o = CY(i, ["className", "component", "style", "sx"]);
  const { systemStyles: l, rest: c } = sY(o), d = e || "div";
  return /* @__PURE__ */ b0.createElement(d, QY({
    ref: a,
    className: RY(t, l, r),
    style: n
  }, c));
});
hB.displayName = "@mantine/core/Box";
const tF = hB;
var UY = F1((s, { radius: a, shadow: i }) => ({
  root: {
    outline: 0,
    WebkitTapHighlightColor: "transparent",
    display: "block",
    textDecoration: "none",
    color: s.colorScheme === "dark" ? s.colors.dark[0] : s.black,
    backgroundColor: s.colorScheme === "dark" ? s.colors.dark[7] : s.white,
    boxSizing: "border-box",
    borderRadius: s.fn.radius(a),
    boxShadow: s.shadows[i] || i || "none",
    "&[data-with-border]": {
      border: `${bd(1)} solid ${s.colorScheme === "dark" ? s.colors.dark[4] : s.colors.gray[3]}`
    }
  }
})), IY = Object.defineProperty, e1 = Object.getOwnPropertySymbols, AB = Object.prototype.hasOwnProperty, gB = Object.prototype.propertyIsEnumerable, uy = (s, a, i) => a in s ? IY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, BY = (s, a) => {
  for (var i in a || (a = {}))
    AB.call(a, i) && uy(s, i, a[i]);
  if (e1)
    for (var i of e1(a))
      gB.call(a, i) && uy(s, i, a[i]);
  return s;
}, ZY = (s, a) => {
  var i = {};
  for (var r in s)
    AB.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && e1)
    for (var r of e1(s))
      a.indexOf(r) < 0 && gB.call(s, r) && (i[r] = s[r]);
  return i;
};
const SY = {}, fB = eA((s, a) => {
  const i = b1("Paper", SY, s), { className: r, children: e, radius: n, withBorder: t, shadow: o, unstyled: l, variant: c } = i, d = ZY(i, ["className", "children", "radius", "withBorder", "shadow", "unstyled", "variant"]), { classes: u, cx: h } = UY({ radius: n, shadow: o }, { name: "Paper", unstyled: l, variant: c });
  return /* @__PURE__ */ b0.createElement(tF, BY({
    className: h(u.root, r),
    "data-with-border": t || void 0,
    ref: a
  }, d), e);
});
fB.displayName = "@mantine/core/Paper";
const EY = fB, pB = Pp({ padding: 0 }), VY = pB.Provider, WY = () => KA(pB).padding;
var NY = F1((s, { padding: a, withBorder: i, inheritPadding: r }) => {
  const e = F0({ size: a, sizes: s.spacing }), n = `calc(-1 * ${e})`, t = s.colorScheme === "dark" ? s.colors.dark[4] : s.colors.gray[3];
  return {
    cardSection: {
      display: "block",
      marginLeft: n,
      marginRight: n,
      paddingLeft: r ? e : void 0,
      paddingRight: r ? e : void 0,
      borderTop: i ? `${bd(1)} solid ${t}` : void 0,
      borderBottom: i ? `${bd(1)} solid ${t}` : void 0,
      "& + &": {
        borderTop: 0
      },
      "&[data-first]": {
        marginTop: n,
        borderTop: 0,
        borderBottom: i ? `${bd(1)} solid ${t}` : void 0
      },
      "&[data-last]": {
        marginBottom: n,
        borderBottom: 0
      }
    }
  };
}), JY = Object.defineProperty, t1 = Object.getOwnPropertySymbols, mB = Object.prototype.hasOwnProperty, vB = Object.prototype.propertyIsEnumerable, hy = (s, a, i) => a in s ? JY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, GY = (s, a) => {
  for (var i in a || (a = {}))
    mB.call(a, i) && hy(s, i, a[i]);
  if (t1)
    for (var i of t1(a))
      vB.call(a, i) && hy(s, i, a[i]);
  return s;
}, TY = (s, a) => {
  var i = {};
  for (var r in s)
    mB.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && t1)
    for (var r of t1(s))
      a.indexOf(r) < 0 && vB.call(s, r) && (i[r] = s[r]);
  return i;
};
const XY = {
  withBorder: !1,
  inheritPadding: !1
}, bB = eA((s, a) => {
  const i = b1("CardSection", XY, s), { className: r, withBorder: e, inheritPadding: n, unstyled: t, variant: o } = i, l = TY(i, ["className", "withBorder", "inheritPadding", "unstyled", "variant"]), { classes: c, cx: d } = NY({ padding: WY(), withBorder: e, inheritPadding: n }, { name: "Card", unstyled: t, variant: o });
  return /* @__PURE__ */ b0.createElement(tF, GY({
    className: d(c.cardSection, r),
    ref: a
  }, l));
});
bB.displayName = "@mantine/core/CardSection";
const FB = bB;
var kY = F1((s) => ({
  root: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: s.colorScheme === "dark" ? s.colors.dark[6] : s.white
  }
})), wY = Object.defineProperty, n1 = Object.getOwnPropertySymbols, RB = Object.prototype.hasOwnProperty, yB = Object.prototype.propertyIsEnumerable, Ay = (s, a, i) => a in s ? wY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, DY = (s, a) => {
  for (var i in a || (a = {}))
    RB.call(a, i) && Ay(s, i, a[i]);
  if (n1)
    for (var i of n1(a))
      yB.call(a, i) && Ay(s, i, a[i]);
  return s;
}, MY = (s, a) => {
  var i = {};
  for (var r in s)
    RB.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && n1)
    for (var r of n1(s))
      a.indexOf(r) < 0 && yB.call(s, r) && (i[r] = s[r]);
  return i;
};
const YY = {
  padding: "md"
}, nF = eA((s, a) => {
  const i = b1("Card", YY, s), { className: r, padding: e, radius: n, children: t, unstyled: o, variant: l } = i, c = MY(i, ["className", "padding", "radius", "children", "unstyled", "variant"]), { classes: d, cx: u } = kY(null, { name: "Card", unstyled: o, variant: l }), h = UE.toArray(t), A = h.map((g, f) => typeof g == "object" && g && "type" in g && g.type === FB ? IE(g, {
    variant: l,
    padding: e,
    "data-first": f === 0 || void 0,
    "data-last": f === h.length - 1 || void 0
  }) : g);
  return /* @__PURE__ */ b0.createElement(VY, {
    value: { padding: e }
  }, /* @__PURE__ */ b0.createElement(EY, DY({
    className: u(d.root, r),
    radius: n,
    p: e,
    ref: a
  }, c), A));
});
nF.Section = FB;
nF.displayName = "@mantine/core/Card";
const LY = nF;
var xY = F1((s, { fluid: a, sizes: i }, { size: r }) => ({
  root: {
    paddingLeft: s.spacing.md,
    paddingRight: s.spacing.md,
    maxWidth: a ? "100%" : F0({ size: r, sizes: i }),
    marginLeft: "auto",
    marginRight: "auto"
  }
})), HY = Object.defineProperty, r1 = Object.getOwnPropertySymbols, QB = Object.prototype.hasOwnProperty, CB = Object.prototype.propertyIsEnumerable, gy = (s, a, i) => a in s ? HY(s, a, { enumerable: !0, configurable: !0, writable: !0, value: i }) : s[a] = i, PY = (s, a) => {
  for (var i in a || (a = {}))
    QB.call(a, i) && gy(s, i, a[i]);
  if (r1)
    for (var i of r1(a))
      CB.call(a, i) && gy(s, i, a[i]);
  return s;
}, OY = (s, a) => {
  var i = {};
  for (var r in s)
    QB.call(s, r) && a.indexOf(r) < 0 && (i[r] = s[r]);
  if (s != null && r1)
    for (var r of r1(s))
      a.indexOf(r) < 0 && CB.call(s, r) && (i[r] = s[r]);
  return i;
};
const KY = {
  sizes: {
    xs: bd(540),
    sm: bd(720),
    md: bd(960),
    lg: bd(1140),
    xl: bd(1320)
  }
}, UB = eA((s, a) => {
  const i = b1("Container", KY, s), { className: r, fluid: e, size: n, unstyled: t, sizes: o, variant: l } = i, c = OY(i, ["className", "fluid", "size", "unstyled", "sizes", "variant"]), { classes: d, cx: u } = xY({ fluid: e, sizes: o }, { unstyled: t, name: "Container", variant: l, size: n });
  return /* @__PURE__ */ b0.createElement(tF, PY({
    className: u(d.root, r),
    ref: a
  }, c));
});
UB.displayName = "@mantine/core/Container";
const zY = (s) => /* @__PURE__ */ jo.createElement("svg", { name: "user-sucess-check", width: 240, height: 240, viewBox: "0 0 334 277", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img", ...s }, /* @__PURE__ */ jo.createElement("path", { d: "M84.08 225.859c17.073 12.136 33.604 19.175 53.971 23.981 20.367 4.807 41.166 10.992 61.915 8.45 21.909-2.685 39.698-2.635 63.877-21.223 17.511-13.472 29.607-40.077 29.385-62.215a56.343 56.343 0 0 0-4.861-22.342 56.19 56.19 0 0 0-13.335-18.55 55.998 55.998 0 0 0-19.6-11.687 55.885 55.885 0 0 0-22.621-2.887c-10.048.791-20.089 4.286-29.989 2.43-12.953-2.424-22.538-13.435-29.212-24.816-6.674-11.382-8.062-31.912-17.98-40.596-19.06-16.702-53.607-18.929-71.55-8.14C64.6 60.015 45.548 82.32 40.866 104.613c0 0-15.994 79.145 43.214 121.245Z", fill: "#E6EAF7" }), /* @__PURE__ */ jo.createElement("path", { d: "M58.549 44.21c12.173 0 22.042-9.897 22.042-22.105S70.722 0 58.549 0C46.375 0 36.507 9.897 36.507 22.105s9.868 22.104 22.042 22.104Z", fill: "#FCE6E6" }), /* @__PURE__ */ jo.createElement("path", { d: "M14.836 139.369s-8.073 2.792.157 20.09c8.23 17.298 14.009 25.94 14.009 25.94s1.436 4.007-1.906 4.533c-3.343.526-10.633-.847-12.253 3.195-1.654 4.191 1.307 8.266 7.426 11.939 6.12 3.673 19.244 12.206 20.422 12.97 1.177.765 2.294 2.635.075 3.359-2.22.724-18.74 2-17.665 9.83 1.076 7.83 19.809 15.237 21.837 16.083 2.029.846 2.498 1.741 2.301 2.867-.197 1.126-5.786 1.031-10.47 1.584-4.682.553-10.02 2.048-9.019 6.492 1.001 4.444 11.954 14.069 39.087 17.482l12.674.751 7.196-10.56c14.022-23.551 13.205-38.126 10.312-41.642-2.893-3.515-7.331-.225-10.653 3.134-3.322 3.358-6.684 7.837-7.692 7.304-1.007-.532-1.416-1.454-.83-3.584.585-2.13 6.283-21.496.796-27.162-5.486-5.666-16.664 6.608-18.597 7.912-1.933 1.304-2.723-.738-2.593-2.13.129-1.393 1.484-17.066 2.362-24.132.878-7.065-.463-11.973-4.772-13.243-4.16-1.229-7.57 5.373-10.04 7.694-2.471 2.321-4.765-1.277-4.765-1.277s-3.172-9.878-11.709-26.992c-8.536-17.114-15.853-12.335-15.853-12.335", fill: "#D1D3D7" }), /* @__PURE__ */ jo.createElement("path", { d: "M81.326 276.326c-6.112-12.292-16.605-34.329-25.707-53.213a11953.82 11953.82 0 0 0-23.407-48.264c-3.023-6.146-5.47-11.128-7.176-14.587-.836-1.71-1.491-3.047-1.946-3.991l-.508-1.005a5.5 5.5 0 0 1-.154-.359l.194.339.528 1.018c.468.918 1.15 2.242 2.006 3.938a1519.05 1519.05 0 0 1 7.29 14.534c6.12 12.325 14.425 29.38 23.52 48.244 9.096 18.864 19.555 40.921 25.608 53.247M24.992 195.427c.302.057.597.149.878.273.558.191 1.362.498 2.335.887 1.96.785 4.643 1.932 7.576 3.256l7.488 3.414 2.28 1.017c.29.105.566.243.824.409a3.747 3.747 0 0 1-.878-.266 50.588 50.588 0 0 1-2.335-.908c-1.953-.798-4.615-1.979-7.556-3.304l-7.508-3.345-2.28-1.003a4.403 4.403 0 0 1-.824-.43ZM47.278 203.892c-.102-.041 2.042-5.686 4.765-12.608 2.723-6.922 4.996-12.506 5.098-12.472.102.034-2.042 5.686-4.765 12.615-2.722 6.929-5.003 12.506-5.098 12.465Z", fill: "#90959F" }), /* @__PURE__ */ jo.createElement("path", { d: "M60.17 234.27c.154-.275.334-.534.539-.772l1.558-2.048a248.146 248.146 0 0 0 5.01-6.758c1.9-2.662 3.533-5.174 4.704-6.983.552-.847 1.021-1.563 1.362-2.144a3.93 3.93 0 0 1 .551-.757c-.11.292-.25.574-.415.839-.293.533-.729 1.29-1.287 2.212a117.22 117.22 0 0 1-4.622 7.059 118.864 118.864 0 0 1-5.112 6.71 67.03 67.03 0 0 1-1.66 1.945 4 4 0 0 1-.627.697ZM38.334 231.061a3.97 3.97 0 0 1 .864.041l2.349.253c1.974.225 4.697.567 7.706.969 3.008.403 5.731.792 7.698 1.093l2.328.375c.288.03.572.094.844.191a3.909 3.909 0 0 1-.864-.041l-2.342-.252c-1.98-.226-4.703-.567-7.712-.97a450.508 450.508 0 0 1-7.699-1.092l-2.328-.375a3.598 3.598 0 0 1-.844-.192ZM46.32 259.336c.37-.017.742.002 1.109.055l3.002.314c2.539.28 6.03.682 9.89 1.167 3.86.485 7.359.935 9.884 1.283l2.989.437c.368.037.733.108 1.089.212a5.644 5.644 0 0 1-1.11-.061l-3.002-.308c-2.539-.28-6.03-.682-9.897-1.167a731.26 731.26 0 0 1-9.877-1.29l-2.989-.43a6.027 6.027 0 0 1-1.089-.212Z", fill: "#90959F" }), /* @__PURE__ */ jo.createElement("path", { d: "M281.732 37.364v71.123H179.874l-3.668-70.627 105.526-.496Z", fill: "#D1D3D7" }), /* @__PURE__ */ jo.createElement("path", { d: "M176.199 37.86v70.475h101.859V37.86H176.199Z", fill: "#fff" }), /* @__PURE__ */ jo.createElement("path", { d: "M278.546 108.824H175.719V37.378h102.827v71.446Zm-101.859-.971h100.89V38.356h-100.89v69.497Z", fill: "#D1D3D7" }), /* @__PURE__ */ jo.createElement("path", { d: "M267.033 46.622h-79.796v52.965h79.796V46.622Z", fill: "#fff" }), /* @__PURE__ */ jo.createElement("path", { d: "M267.013 46.622h-5.914l-16.444.062-57.438.11.227-.227v52.951l-.248-.248 79.796.049-.206.2c.048-16.12.082-29.331.11-38.534 0-4.602.041-8.19.048-10.657V46.56v3.686c0 2.452 0 6.027.055 10.608 0 9.23.055 22.49.103 38.657v.2h-.089l-79.796.055h-.254V46.326h.233l57.589.117 16.396.062H266.621c.289.117.392.117.392.117Z", fill: "#D1D3D7" }), /* @__PURE__ */ jo.createElement("path", { d: "M176.206 37.667a8.45 8.45 0 0 1 1.752 1.137 116.58 116.58 0 0 1 3.991 3.051 78.356 78.356 0 0 1 3.826 3.265 8.541 8.541 0 0 1 1.463 1.502c-.096.103-2.548-1.922-5.605-4.367-3.057-2.446-5.516-4.47-5.427-4.588ZM278.065 37.867c.082.103-2.315 2.156-5.365 4.574-3.05 2.418-5.584 4.284-5.667 4.181-.082-.103 2.308-2.163 5.358-4.58 3.05-2.419 5.612-4.285 5.674-4.175Z", fill: "#D1D3D7" }), /* @__PURE__ */ jo.createElement("path", { d: "m278.003 108.35-11.355-9.23 11.355 9.23Z", fill: "#fff" }), /* @__PURE__ */ jo.createElement("path", { d: "M266.627 99.119c.083-.11 2.7 1.866 5.832 4.415 3.132 2.549 5.612 4.705 5.495 4.822-.117.117-2.699-1.874-5.838-4.422-3.139-2.549-5.578-4.712-5.489-4.815ZM176.207 108.335c-.09-.11 2.287-2.135 5.302-4.525 3.016-2.391 5.53-4.244 5.612-4.133.083.11-2.287 2.135-5.303 4.525-3.015 2.39-5.529 4.243-5.611 4.133Z", fill: "#D1D3D7" }), /* @__PURE__ */ jo.createElement("path", { d: "M203.441 63.127v17.73h50.212v-17.73h-50.212Z", fill: "#F28080" }), /* @__PURE__ */ jo.createElement("path", { opacity: 0.64, d: "M203.441 63.127v17.73h50.212v-17.73h-50.212Z", fill: "#fff" }), /* @__PURE__ */ jo.createElement("path", { d: "m280.786 136.44 8.504-10.333s2.136-13.99 1.841-15.96a66.506 66.506 0 0 0-2.35-7.729 1.22 1.22 0 0 1 .466-1.405c.147-.1.314-.165.489-.193 1.546-.255 4.073 0 6.038 3.741 1.8 3.444 2.748 8.087 3.201 11.111a2.6 2.6 0 0 0 1.205 1.8 2.587 2.587 0 0 0 2.147.266 87.887 87.887 0 0 1 11.938-2.9c2.329-.269 4.952 1.956 5.461 3.623.384 1.254-1.573 3.651-1.573 3.651s2.026.799 2.747 2.239c.096.186.186.365.261.544a3.664 3.664 0 0 1-.439 3.596l-.536.689s2.473.42 2.905 1.777c.266.996.343 2.034.227 3.058l-2.026 2.563a3.868 3.868 0 0 1 1.374 2.066c.24 1.261-2.837 4.753-2.837 4.753l-15.599 5.938-5.496 5.256-17.948-18.151Z", fill: "#B78876" }), /* @__PURE__ */ jo.createElement("path", { d: "M319.499 122.498a1.47 1.47 0 0 1-.323.193l-.968.489-3.579 1.75-5.33 2.549c-1.01.461-2.061 1.019-3.201 1.432a4.109 4.109 0 0 1-3.75-.282 2.839 2.839 0 0 1-1.065-1.681 3.992 3.992 0 0 1 .069-1.915 5.382 5.382 0 0 1 2.115-2.838 21.221 21.221 0 0 1 2.748-1.619l2.431-1.288 3.531-1.839.968-.489c.111-.063.228-.111.351-.145a1.608 1.608 0 0 1-.316.207l-.934.544-3.476 1.943-2.411 1.329a21.893 21.893 0 0 0-2.679 1.619 5.129 5.129 0 0 0-1.978 2.666 2.971 2.971 0 0 0 .872 3.21 3.034 3.034 0 0 0 1.683.537 5.01 5.01 0 0 0 1.745-.289c1.119-.393 2.157-.951 3.173-1.378l5.358-2.48 3.627-1.646.996-.434a1.46 1.46 0 0 1 .343-.145Z", fill: "#AA6550" }), /* @__PURE__ */ jo.createElement("path", { d: "M321.196 129.634a4.137 4.137 0 0 1-.749.399c-.494.235-1.208.558-2.108.937-1.786.765-4.293 1.75-7.103 2.707-.686.248-1.385.457-2.095.627a4.052 4.052 0 0 1-2.06-.041 3.177 3.177 0 0 1-2.15-2.631 3.113 3.113 0 0 1 .652-2.239c.133-.167.285-.317.454-.448.116-.083.185-.117.192-.11.007.007-.234.206-.536.64a3.139 3.139 0 0 0-.515 2.122 2.95 2.95 0 0 0 1.999 2.349 3.81 3.81 0 0 0 1.909 0 19.978 19.978 0 0 0 2.061-.627c2.809-.95 5.316-1.894 7.123-2.597l2.15-.833c.25-.111.51-.196.776-.255Z", fill: "#AA6550" }), /* @__PURE__ */ jo.createElement("path", { d: "M321.649 136.344a3.19 3.19 0 0 1-.742.248l-2.061.551c-1.744.448-4.155 1.04-6.821 1.674a18.62 18.62 0 0 1-1.985.406 3.533 3.533 0 0 1-1.916-.241 2.06 2.06 0 0 1-1.188-1.309 2.285 2.285 0 0 1 .096-1.529 3.184 3.184 0 0 1 1.477-1.577c.219-.148.467-.249.728-.296 0 0-.248.137-.687.413a3.258 3.258 0 0 0-1.312 1.55 2.118 2.118 0 0 0-.048 1.377 1.8 1.8 0 0 0 1.044 1.089c.551.221 1.151.29 1.738.199a18.26 18.26 0 0 0 1.944-.413 361.777 361.777 0 0 1 6.868-1.57l2.061-.441a3.91 3.91 0 0 1 .804-.131Z", fill: "#AA6550" }), /* @__PURE__ */ jo.createElement("path", { d: "M321.408 142.433c-.764.103-1.536.142-2.308.117h-7.157a6.03 6.03 0 0 1-1.504-.13 2.133 2.133 0 0 1-1.209-.744 1.426 1.426 0 0 1-.261-1.22 2.07 2.07 0 0 1 1.147-1.288c.189-.104.404-.149.618-.131 0 .035-.22.062-.556.255a1.963 1.963 0 0 0-.962 1.226 1.176 1.176 0 0 0 .247.979c.279.307.646.519 1.051.606.474.082.955.114 1.436.096h1.587c2.17 0 4.121.055 5.563.097.772-.013 1.544.033 2.308.137ZM307.074 136.488a20.063 20.063 0 0 0-3.833-1.219 19.693 19.693 0 0 0-4.018-.048 8.807 8.807 0 0 1 7.851 1.267Z", fill: "#AA6550" }), /* @__PURE__ */ jo.createElement("path", { d: "m230.891 170.427 52.011-37.521 18.491 21.251-40.705 42.074c-18.189 16.498-24.556 20.665-54.711 3.444l-19.136-11.021 7.068 87.531h-86.548c-9.507-.304 12.364-24.22 10.866-24.22l-18.985-64.276-29.371 19.798 27.84 21.829-10.304 23.91-47.601-22.064c-17.255-11.511-14.94-33.932-.22-48.563 26.514-26.348 47.03-45.519 69.698-49.404 11.677-3.52 18.546-4.133 18.546-4.133 18.244-.262 19.604-.2 29.378.262 1.903.099 3.796.329 5.667.689a66.251 66.251 0 0 1 29.474 12.165l38.542 28.249Z", fill: "#0031B2" }), /* @__PURE__ */ jo.createElement("path", { d: "M232.14 187.973a2.582 2.582 0 0 1-.398-.634 15.056 15.056 0 0 1-.852-1.853 19.434 19.434 0 0 1-.873-2.9 22.769 22.769 0 0 1-.467-3.679 21.982 21.982 0 0 1 .206-3.706c.153-1.001.383-1.989.687-2.955.186-.65.416-1.288.687-1.908.086-.244.204-.475.351-.689.068 0-.358.999-.804 2.639-.25.963-.441 1.94-.57 2.927a23.736 23.736 0 0 0-.172 3.644c.053 1.217.195 2.428.426 3.623.2.974.462 1.933.783 2.873.563 1.646 1.058 2.583.996 2.618Z", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M184.986 208.858a28.315 28.315 0 0 0 1.001-34.791 28.184 28.184 0 0 0-9.34-8.124", fill: "#0031B2" }), /* @__PURE__ */ jo.createElement("path", { d: "M176.62 167.3c.133.056.258.131.371.22.227.159.591.379 1.01.689a29.26 29.26 0 0 1 3.434 3.003 42.984 42.984 0 0 1 8.298 12.489 19.378 19.378 0 0 1 1.813 8.108 22.329 22.329 0 0 1-1.071 6.688 34.049 34.049 0 0 1-1.649 4.257l-.556 1.109c-.059.133-.131.26-.213.379.033-.141.084-.277.151-.406.124-.296.288-.689.488-1.137a41.625 41.625 0 0 0 1.538-4.271c.646-2.147.977-4.377.982-6.619a19.31 19.31 0 0 0-1.827-7.936 45.06 45.06 0 0 0-8.146-12.468 34.085 34.085 0 0 0-3.338-3.065c-.413-.344-.756-.579-.969-.765a2.12 2.12 0 0 1-.316-.275ZM157.414 192.016c.02.097.02.198 0 .296 0 .193 0 .475-.055.84a16.813 16.813 0 0 1-.604 3.038 18.23 18.23 0 0 1-5.411 8.574 18.146 18.146 0 0 1-9.144 4.342 16.43 16.43 0 0 1-3.084.234c-.364 0-.653-.041-.838-.048a.961.961 0 0 1-.296-.049c.377-.035.755-.051 1.134-.048a19.36 19.36 0 0 0 3.036-.337 18.49 18.49 0 0 0 8.959-4.366 18.573 18.573 0 0 0 5.404-8.392c.304-.977.534-1.976.687-2.989.051-.369.122-.734.212-1.095ZM123.449 224.515c.049.123.082.253.096.385.055.297.117.689.199 1.123.114.592.196 1.19.247 1.791.062.689.172 1.502.186 2.39 0 .441.034.91.048 1.378.013.469 0 .985 0 1.509 0 1.047-.117 2.156-.213 3.327a46.301 46.301 0 0 1-1.491 7.487 45.647 45.647 0 0 1-2.816 7.096c-.549 1.033-1.058 2.032-1.628 2.906-.275.441-.522.882-.797 1.282l-.796 1.143a23.588 23.588 0 0 1-1.45 1.901 43.922 43.922 0 0 1-1.174 1.378c-.337.372-.577.613-.783.833a1.543 1.543 0 0 1-.289.276c.069-.114.147-.222.234-.324l.728-.875c.323-.372.687-.833 1.126-1.377.44-.544.928-1.178 1.374-1.929l.769-1.143c.268-.4.509-.841.776-1.282.557-.881 1.051-1.873 1.587-2.9a43.598 43.598 0 0 0 4.273-14.465c.103-1.164.233-2.267.24-3.3 0-.516.055-1.019.048-1.502-.007-.482 0-.943 0-1.377 0-.882-.089-1.674-.13-2.377a21.962 21.962 0 0 0-.186-1.791c-.069-.489-.096-.833-.13-1.129a2.443 2.443 0 0 1-.048-.434ZM51.55 203.953c.235-.119.485-.205.743-.255a8.69 8.69 0 0 1 .9-.22c.35-.069.755-.165 1.202-.214a19.762 19.762 0 0 1 3.187-.213 22.89 22.89 0 0 1 3.88.413c1.279.269 2.533.642 3.751 1.116.987.399 1.942.874 2.857 1.419.399.22.729.468 1.03.689.303.22.543.386.743.544.218.149.416.325.59.524-.04.055-.92-.641-2.493-1.516a22.53 22.53 0 0 0-2.85-1.329 25.001 25.001 0 0 0-3.696-1.075 25.391 25.391 0 0 0-3.82-.434 24.128 24.128 0 0 0-3.145.131c-1.786.179-2.864.482-2.878.42ZM110.493 167.383c.001-.138.019-.274.055-.407.062-.303.131-.689.227-1.157a40.93 40.93 0 0 0 .57-4.257 29.075 29.075 0 0 0-.192-6.351 21.388 21.388 0 0 0-2.453-7.33 16.816 16.816 0 0 0-5.124-5.717 14.806 14.806 0 0 0-5.818-2.335 13.087 13.087 0 0 0-4.245 0c-1.003.165-1.532.358-1.545.317.123-.06.252-.108.384-.145.37-.129.75-.232 1.134-.31a12.552 12.552 0 0 1 4.313-.103 14.6 14.6 0 0 1 5.963 2.314 16.725 16.725 0 0 1 5.247 5.814 21.37 21.37 0 0 1 2.466 7.453 27.91 27.91 0 0 1 .117 6.42 32.944 32.944 0 0 1-.687 4.271c-.11.496-.206.875-.281 1.137a2.115 2.115 0 0 1-.131.386Z", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M83.436 163.58a46.072 46.072 0 0 1-.151-5.669c-.05-1.892.021-3.786.213-5.669a45.26 45.26 0 0 1 .144 5.669 45.36 45.36 0 0 1-.206 5.669ZM70.379 180.091a22.42 22.42 0 0 1-2.693-2.872 21.571 21.571 0 0 1-2.417-3.114c.98.879 1.881 1.842 2.692 2.88.9.958 1.71 1.998 2.418 3.106ZM92.276 176.848c-1.579.602-3.2 1.087-4.849 1.453-1.62.486-3.273.857-4.946 1.109a34.681 34.681 0 0 1 4.857-1.453 35.519 35.519 0 0 1 4.938-1.109ZM101.399 169.663a5.16 5.16 0 0 1-.289-1.378 38.14 38.14 0 0 1-.288-3.444 33.551 33.551 0 0 1 .041-3.445 5.224 5.224 0 0 1 .179-1.412c.103 0 .041 2.163.137 4.822.096 2.659.323 4.843.22 4.857ZM67.288 199.806a31.613 31.613 0 0 1-.179-4.712 30.993 30.993 0 0 1 .186-4.711c.176 1.564.234 3.139.171 4.711a31.6 31.6 0 0 1-.178 4.712ZM52.176 194.778a52.638 52.638 0 0 1-5.81-2.122 53.278 53.278 0 0 1-5.675-2.459 52.664 52.664 0 0 1 5.811 2.129c1.936.71 3.83 1.529 5.674 2.452ZM39.057 211.944a30.786 30.786 0 0 1 .343-4.733c.113-1.578.343-3.146.687-4.69a30.723 30.723 0 0 1-.343 4.732 31.672 31.672 0 0 1-.687 4.691ZM60.501 226.065a10.09 10.09 0 0 1-1.806-.42c-1.106-.289-2.624-.689-4.32-1.082-1.697-.392-3.236-.688-4.356-.943-.61-.089-1.212-.23-1.8-.42a8.31 8.31 0 0 1 1.849.172c1.126.165 2.685.441 4.389.84 1.703.4 3.221.834 4.306 1.192a9.39 9.39 0 0 1 1.738.661ZM67.995 219.707a64.835 64.835 0 0 1-2.026-9.437c.509 1.53.906 3.095 1.188 4.684.394 1.561.674 3.15.838 4.753ZM75.565 240.186a6.144 6.144 0 0 1-1.6-.124 33.736 33.736 0 0 1-7.433-1.984 6.282 6.282 0 0 1-1.442-.688 8.256 8.256 0 0 1 1.532.447 102 102 0 0 0 3.674 1.096c1.45.406 2.748.688 3.73.874.524.075 1.04.202 1.539.379ZM84.089 238.12a8.296 8.296 0 0 1 .075-1.688c.083-1.04.193-2.473.254-4.064.062-1.591.076-3.024.083-4.064a9.332 9.332 0 0 1 .055-1.695c.135.553.202 1.119.2 1.688.06 1.04.088 2.494 0 4.092a40.041 40.041 0 0 1-.358 4.071 7.433 7.433 0 0 1-.31 1.66ZM116.929 189.942c-.082.062-1.47-1.722-3.324-3.782-1.855-2.059-3.476-3.637-3.4-3.72.421.262.808.575 1.154.93.687.62 1.573 1.509 2.507 2.549a41.785 41.785 0 0 1 2.267 2.755c.32.386.588.812.796 1.268ZM136.327 172.604a22.085 22.085 0 0 1-3.022 2.652 22.916 22.916 0 0 1-3.249 2.369 23.16 23.16 0 0 1 3.022-2.652 22.781 22.781 0 0 1 3.249-2.369ZM125.523 162.961a60.037 60.037 0 0 1-.09-6.599 60.19 60.19 0 0 1 .275-6.592c.146 2.196.174 4.399.083 6.599.028 2.2-.061 4.401-.268 6.592ZM156.961 144.528a48.536 48.536 0 0 1 2.535-5.229 47.441 47.441 0 0 1 2.85-5.056 45.869 45.869 0 0 1-2.534 5.222 46.597 46.597 0 0 1-2.851 5.063ZM154.68 165.054a59.869 59.869 0 0 1-3.963-5.187 60.297 60.297 0 0 1-3.675-5.4 57.453 57.453 0 0 1 3.963 5.187 61.97 61.97 0 0 1 3.675 5.4ZM178.282 151.029a35.41 35.41 0 0 1-3.311 3.892 37.148 37.148 0 0 1-3.578 3.651 37.061 37.061 0 0 1 3.317-3.892 38.594 38.594 0 0 1 3.572-3.651ZM170.939 184.121a52.349 52.349 0 0 1-3.648-4.96 54.135 54.135 0 0 1-3.352-5.159 53.992 53.992 0 0 1 3.648 4.953 52.615 52.615 0 0 1 3.352 5.166ZM144.707 194.592a38.367 38.367 0 0 1 1.813-4.884 39.106 39.106 0 0 1 2.15-4.753 38.463 38.463 0 0 1-1.813 4.891 39.233 39.233 0 0 1-2.15 4.746ZM127.151 209.188c-.048.083-3.084-1.426-6.78-3.375-3.695-1.95-6.656-3.61-6.608-3.693.048-.082 3.078 1.419 6.773 3.376 3.695 1.956 6.656 3.602 6.615 3.692ZM138.655 234.379a8.872 8.872 0 0 1 .893-1.715 46.824 46.824 0 0 1 2.583-3.885 45.063 45.063 0 0 1 2.967-3.602c.408-.508.868-.97 1.374-1.378a12.277 12.277 0 0 1-1.195 1.522 91.004 91.004 0 0 0-2.864 3.651 94.532 94.532 0 0 0-2.659 3.802 12.649 12.649 0 0 1-1.099 1.605ZM116.27 229.743a19.993 19.993 0 0 1-.281-3.761 19.204 19.204 0 0 1 .075-3.775c.208 1.245.302 2.506.282 3.768a20.359 20.359 0 0 1-.076 3.768ZM136.938 254.652c-.083.062-1.299-1.467-2.913-3.251-1.614-1.784-3.001-3.162-2.933-3.238a25.767 25.767 0 0 1 5.846 6.489ZM125.68 264.296a37.967 37.967 0 0 1-4.19 3.265 40.9 40.9 0 0 1-4.396 2.976 37.967 37.967 0 0 1 4.19-3.265 39.428 39.428 0 0 1 4.396-2.976ZM151.761 265.55c-.527.161-1.067.278-1.614.351a52.641 52.641 0 0 0-3.874.882 54.261 54.261 0 0 0-3.792 1.184 9.042 9.042 0 0 1-1.58.51 6.782 6.782 0 0 1 1.484-.744 30.711 30.711 0 0 1 7.721-2.087 6.376 6.376 0 0 1 1.655-.096ZM162.744 263.255c-.096 0-.687-3.251-1.305-7.301-.618-4.051-1.044-7.344-.948-7.357.096-.014.687 3.251 1.305 7.301.618 4.051 1.044 7.343.948 7.357ZM165.334 236.631a9.196 9.196 0 0 1-1.882-.434 57.743 57.743 0 0 1-4.424-1.453 70.752 70.752 0 0 1-4.321-1.764 10.114 10.114 0 0 1-1.717-.888c.625.165 1.234.384 1.82.654 1.106.434 2.638 1.033 4.342 1.66a206.17 206.17 0 0 0 4.375 1.55c.62.174 1.224.4 1.807.675ZM184.477 250.36a42.856 42.856 0 0 1-2.864 4.746 43.439 43.439 0 0 1-3.167 4.554 42.32 42.32 0 0 1 2.865-4.746 43.43 43.43 0 0 1 3.166-4.554ZM181.002 274.325a35.622 35.622 0 0 1-4.073-2.894 34.58 34.58 0 0 1-3.861-3.182 35.75 35.75 0 0 1 4.074 2.893 34.67 34.67 0 0 1 3.86 3.183ZM177.217 221.787a45.423 45.423 0 0 1-1.374 5.6 46.105 46.105 0 0 1-1.724 5.511c.342-1.893.8-3.764 1.374-5.6a46.105 46.105 0 0 1 1.724-5.511ZM171.626 211.324a20.065 20.065 0 0 1-7.096-5.029c.076-.076 1.518 1.233 3.483 2.611 1.964 1.378 3.613 2.349 3.613 2.418ZM179.951 194.578a18.97 18.97 0 0 1-1.834 3.134 18.661 18.661 0 0 1-2.137 2.935 18.97 18.97 0 0 1 1.834-3.134 18.661 18.661 0 0 1 2.137-2.935ZM193.956 163.174a42.91 42.91 0 0 1 1.374-5.387 45.085 45.085 0 0 1 1.731-5.29 43.657 43.657 0 0 1-1.374 5.387 43.241 43.241 0 0 1-1.731 5.29ZM204.596 185.527a8.982 8.982 0 0 1-1.594-1.068 38.144 38.144 0 0 1-3.489-3.038 36.023 36.023 0 0 1-3.077-3.444 8.04 8.04 0 0 1-1.085-1.584c.459.441.886.916 1.277 1.419a61.994 61.994 0 0 0 3.139 3.368 59.894 59.894 0 0 0 3.393 3.093c.512.379.992.798 1.436 1.254ZM213.141 176.124c-.089-.055.887-1.674 1.8-3.81.914-2.135 1.436-3.96 1.539-3.933a17.932 17.932 0 0 1-3.339 7.743ZM219.817 193.944c.112-1.288.342-2.563.687-3.809.225-1.27.563-2.517 1.01-3.727a20.429 20.429 0 0 1-.687 3.809 20.887 20.887 0 0 1-1.01 3.727ZM235.685 204.415a31.926 31.926 0 0 1-3.846-2.817 31.418 31.418 0 0 1-3.627-3.1 32.035 32.035 0 0 1 3.846 2.817c1.288.938 2.5 1.974 3.627 3.1ZM246.723 182.413a8.87 8.87 0 0 1-.735 1.543 55.358 55.358 0 0 0-1.745 3.72 61.27 61.27 0 0 0-1.463 3.837 9.717 9.717 0 0 1-.604 1.598c.053-.57.173-1.132.357-1.674a33.31 33.31 0 0 1 1.374-3.906 32.095 32.095 0 0 1 1.854-3.699c.265-.508.588-.984.962-1.419ZM255.282 171.22a62.546 62.546 0 0 1-6.526-1.819 63.073 63.073 0 0 1-6.415-2.17 66.793 66.793 0 0 1 6.525 1.826 66.513 66.513 0 0 1 6.416 2.163ZM264.431 181.312c-.354.505-.74.989-1.154 1.446a32.98 32.98 0 0 0-4.643 7.577c-.218.579-.478 1.14-.777 1.681a7.463 7.463 0 0 1 .543-1.784 24.701 24.701 0 0 1 4.685-7.625c.39-.489.843-.925 1.346-1.295ZM268.882 165.888a14.174 14.174 0 0 1 0-1.998 86.165 86.165 0 0 0 0-4.821 81.103 81.103 0 0 0-.302-4.822 14.364 14.364 0 0 1-.138-1.998c.201.638.332 1.297.392 1.963.218 1.599.353 3.209.405 4.822a45.1 45.1 0 0 1-.096 4.822 9.467 9.467 0 0 1-.261 2.032ZM285.649 165.627a32.145 32.145 0 0 1-3.881-2.983 33.235 33.235 0 0 1-3.675-3.258 34.45 34.45 0 0 1 3.888 2.982 32.87 32.87 0 0 1 3.668 3.259ZM292.291 154.157a13.89 13.89 0 0 1-.721-1.895 99.535 99.535 0 0 0-1.745-4.553 97.632 97.632 0 0 0-1.978-4.457 13.02 13.02 0 0 1-.818-1.853 9.895 9.895 0 0 1 1.044 1.743 40.472 40.472 0 0 1 2.061 4.429c.687 1.771 1.291 3.41 1.655 4.616.237.637.405 1.297.502 1.97Z", fill: "#F7B3B3" }), /* @__PURE__ */ jo.createElement("path", { opacity: 0.3, d: "M155.642 198.401c-2.748 7.254-10.221 10.519-17.172 10.98h-.399a27.424 27.424 0 0 0-9.362 1.185 14.869 14.869 0 0 0 8.297 6.571 14.82 14.82 0 0 0 10.554-.622 14.881 14.881 0 0 0 7.472-7.501 14.946 14.946 0 0 0 .61-10.585v-.028ZM107.285 215.064c1.676 6.269 4.046 13.639 5.722 19.908 1.47 5.511 3.716 11.538 5.186 17.028l.646-.062c2.83-12.771-1.979-27.994-11.554-36.874ZM197.728 186.677a25.256 25.256 0 0 0-13.951-12.675c3.435 4.96 7.316 10.946 7.707 17.372l5.118 2.949c1.593-1.543 2.088-5.656 1.126-7.646Z", fill: "#000" }), /* @__PURE__ */ jo.createElement("path", { d: "M124.388 138.272a8.42 8.42 0 0 0-1.957.875 7.986 7.986 0 0 0-1.436 1.591c-.041 0 0-.275.172-.654a3.43 3.43 0 0 1 1.058-1.233 3.475 3.475 0 0 1 1.49-.62c.419-.055.673.007.673.041ZM132.756 149.039c-.042 0-.158-.29-.2-.806a4.611 4.611 0 0 1 .337-1.991 4.461 4.461 0 0 1 1.147-1.66c.385-.345.687-.475.687-.441a8.739 8.739 0 0 0-1.525 2.232 9.078 9.078 0 0 0-.446 2.666ZM123.826 148.57c-.045-.448.002-.9.137-1.329a8.474 8.474 0 0 1 3.703-5.146 3.32 3.32 0 0 1 1.209-.551 10.661 10.661 0 0 0-5.049 7.026ZM117.919 135.793c-.035 0 .089-.304.432-.689a3.762 3.762 0 0 1 3.552-.944c.474.138.686.317.686.358a6.226 6.226 0 0 0-2.507 0 6.398 6.398 0 0 0-2.163 1.275ZM142.31 148.44a8.923 8.923 0 0 1-.419-1.75 9.853 9.853 0 0 1-.426-1.743c.416.464.684 1.042.769 1.66.198.592.224 1.227.076 1.833ZM152.173 148.57a11.801 11.801 0 0 0-3.098-5.765 5.8 5.8 0 0 1 2.274 2.493c.599.982.886 2.123.824 3.272ZM156.329 140.869c-.096.041-.357-.51-.969-.861-.611-.352-1.202-.338-1.216-.441-.013-.103.138-.117.406-.131a1.8 1.8 0 0 1 .989.269c.297.174.536.433.687.744.137.234.144.406.103.42ZM164.222 137.549c-.356-.23-.7-.478-1.03-.744a7.45 7.45 0 0 0-2.748-1.116 7.554 7.554 0 0 0-2.988.069c-.749.179-1.188.393-1.216.338a2.745 2.745 0 0 1 1.154-.579 6.588 6.588 0 0 1 5.962 1.082c.354.25.649.575.866.95ZM162.057 131.398a11.89 11.89 0 0 0-2.012-.145 13.13 13.13 0 0 0-1.951.517 3.21 3.21 0 0 1 3.963-.372ZM125.453 122.346c-7.301.166-17.77-.688-22.124-6.578-4.355-5.89-2.466-16.601-.193-23.558-6.47-7.247-6.182-19.563.687-26.48 1.23-1.253 2.658-2.362 3.558-3.87 1.697-2.839 1.195-6.414 1.607-9.706a16.949 16.949 0 0 1 2.833-7.468 16.885 16.885 0 0 1 5.933-5.332 16.832 16.832 0 0 1 15.482-.24c4.066-3.561 8.297-7.157 13.394-8.955 5.097-1.798 11.327-1.33 15.159 2.48 2.102 2.066 3.435 5.083 6.059 6.434 2.624 1.35 5.914.64 8.826 1.33 5.557 1.315 8.628 7.287 10.084 12.825 1.456 5.539 2.177 11.6 5.914 15.933 1.944 2.26 4.602 3.892 6.182 6.413a9.598 9.598 0 0 1-2.799 13.117 9.539 9.539 0 0 1-4.626 1.57c3.386 4.29 4.121 10.332 2.624 15.595-1.498 5.262-4.63 11.923-10.063 13.646a15.309 15.309 0 0 1-10.894-.786s-2.823 5.387-15.799 4.863c-20.249-.826-28.753 6.358-31.837-1.26", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M172.203 98.05c.948-8.493-.116-22.29-1.373-33.56-1.106-10.14-8.394-22.304-18.45-20.761l-31.185 9.458a5.945 5.945 0 0 0-3.742 2.16 5.979 5.979 0 0 0-1.3 4.129l6.581 74.753c.076.909.402 1.779.941 2.514a19.135 19.135 0 0 0 8.164 6.555 19.083 19.083 0 0 0 10.382 1.27c12.254-1.591 15.001-9.471 15.565-11.986.096-.42.137-.85.123-1.281-.309-9.692-.487-13.487-.481-13.419.007.069 12.873-2.755 14.775-19.831Z", fill: "#B78876" }), /* @__PURE__ */ jo.createElement("path", { d: "M165.547 75.63a2.19 2.19 0 0 1-.533 1.552 2.172 2.172 0 0 1-1.459.741 2.055 2.055 0 0 1-2.084-1.068 2.058 2.058 0 0 1-.238-.791 2.175 2.175 0 0 1 .528-1.55 2.162 2.162 0 0 1 1.457-.737 2.055 2.055 0 0 1 2.088 1.062c.133.244.215.513.241.79ZM168.555 73.17c-.254.296-1.957-.847-4.286-.73-2.328.117-3.991 1.378-4.259 1.088-.13-.124.124-.647.845-1.226a5.925 5.925 0 0 1 3.387-1.219 5.682 5.682 0 0 1 3.434.937c.735.517 1.003 1.02.879 1.15ZM143.34 76.656a2.17 2.17 0 0 1-1.985 2.294 2.056 2.056 0 0 1-2.09-1.067 2.066 2.066 0 0 1-.238-.793 2.178 2.178 0 0 1 1.985-2.294 2.054 2.054 0 0 1 2.09 1.067c.132.245.213.515.238.793ZM145.455 73.942c-.254.296-1.957-.84-4.286-.73-2.329.11-3.991 1.377-4.252 1.088-.13-.117.117-.648.838-1.226a5.982 5.982 0 0 1 3.386-1.22 5.683 5.683 0 0 1 3.435.937c.735.517 1.003 1.02.879 1.15ZM154.556 90.275c0-.131 1.422-.448 3.758-.862.59-.09 1.147-.234 1.229-.647a3.046 3.046 0 0 0-.474-1.75c-.632-1.419-1.284-2.907-1.971-4.463-2.748-6.365-4.76-11.607-4.506-11.71.254-.104 2.693 4.959 5.433 11.324.687 1.57 1.298 3.065 1.896 4.498.409.702.558 1.527.419 2.328a1.484 1.484 0 0 1-.941.916 4.041 4.041 0 0 1-1.003.193c-2.356.228-3.826.303-3.84.172Z", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M157.443 117.883a42.948 42.948 0 0 1-22.908-5.008s6.258 11.71 23.107 9.334l-.199-4.326ZM153.828 95.957a4.219 4.219 0 0 0-3.839-1.377 3.838 3.838 0 0 0-2.583 1.55 2.446 2.446 0 0 0-.055 2.796c.687.861 1.992 1.006 3.091.634a8.85 8.85 0 0 0 2.899-1.922c.25-.19.464-.423.632-.689a.782.782 0 0 0-.042-.868", fill: "#AA6550" }), /* @__PURE__ */ jo.createElement("path", { d: "M147.764 92.21c.377-.042.501 2.5 2.747 4.201 2.246 1.702 4.932 1.302 4.966 1.654.042.158-.577.523-1.717.606a6.286 6.286 0 0 1-4.121-1.24 5.512 5.512 0 0 1-2.143-3.527c-.158-1.054.089-1.701.268-1.694ZM146.155 69.175c-.206.648-2.548.455-5.268.91-2.72.454-4.897 1.308-5.289.757-.179-.269.185-.882 1.044-1.543a9.278 9.278 0 0 1 8.044-1.267c1.023.358 1.524.84 1.469 1.143ZM168.06 69.03c-.384.551-2.019.076-3.949.138-1.93.062-3.551.523-3.957 0-.178-.262.055-.806.749-1.378a5.703 5.703 0 0 1 6.367-.096c.708.53.962 1.067.79 1.336ZM130.097 43.44a11.609 11.609 0 0 0 4.533 8.753 11.559 11.559 0 0 0 9.61 2.096c2.562-.586 5.337-2.019 7.631-.737 2.418 1.377 2.665 4.897 4.809 6.62 3.091 2.465 7.72-.18 11.553.778 2.96.744 4.911 3.444 6.951 5.73 2.04 2.288 5.049 4.382 7.934 3.383a34.61 34.61 0 0 0-1.504-7.763 11.517 11.517 0 0 0-4.706-6.2c-1.243-.737-2.665-1.157-3.826-2.018-2.514-1.853-3.228-5.249-4.808-7.922a12.696 12.696 0 0 0-4.246-4.205 12.658 12.658 0 0 0-5.693-1.794c-3.338-.193-6.725.957-10.001.282-2.418-.503-4.582-1.97-7.027-2.328-4.767-.69-9.012 2.907-12.295 6.447", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M120.508 81.064c-.268-.117-10.708-3.175-10.365 7.509.343 10.684 10.99 8.142 10.99 7.832 0-.31-.625-15.34-.625-15.34Z", fill: "#B78876" }), /* @__PURE__ */ jo.createElement("path", { d: "M117.732 92.479c-.048 0-.178.13-.487.29a1.87 1.87 0 0 1-1.374.068c-1.14-.379-2.143-2.135-2.26-4.064a6.258 6.258 0 0 1 .433-2.68 2.152 2.152 0 0 1 1.374-1.474.937.937 0 0 1 1.112.475c.151.297.09.51.151.524.062.014.22-.186.117-.62a1.158 1.158 0 0 0-.439-.689 1.373 1.373 0 0 0-1.031-.234 2.612 2.612 0 0 0-1.889 1.715 6.368 6.368 0 0 0-.549 3.003c.137 2.15 1.298 4.133 2.857 4.526a1.987 1.987 0 0 0 1.69-.337c.282-.248.33-.49.295-.503Z", fill: "#AA6550" }), /* @__PURE__ */ jo.createElement("path", { d: "M116.256 80.327c1.775.392 3.617.363 5.379-.085a11.67 11.67 0 0 0 4.771-2.495 11.725 11.725 0 0 0 4.006-9.702c3.929-.192 7.323-3.237 8.882-6.888 1.559-3.65 1.566-7.736 1.085-11.662a5.515 5.515 0 0 0-.804-2.618c-1.167-1.625-3.544-1.612-5.536-1.44-5.131.448-10.42.951-14.947 3.445-4.526 2.493-8.105 7.446-7.294 12.544.398 2.493 1.779 4.945 1.161 7.39-.461 1.82-1.986 3.293-2.164 5.16a5.039 5.039 0 0 0 1.587 3.878 14.567 14.567 0 0 0 3.544 2.446M118.159 97.342c2.061.33 4.204.944 5.379 2.679a7.792 7.792 0 0 1 1.147 5.993c1.655-.082 3.008 1.378 3.64 2.907 1.608 3.94-.206 8.728-3.551 11.352-1.175.916-2.624 1.64-4.121 1.44-1.498-.2-2.507-1.137-3.531-2.067a25.17 25.17 0 0 1-4.499-5.021 9.573 9.573 0 0 1 .687-12.165c1.374-1.64 3.05-3.899 4.808-5.111", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M104.104 64.181c.527.17 1.09.192 1.628.062a4.687 4.687 0 0 0 1.704-.882 11.688 11.688 0 0 0 1.793-1.866 7.553 7.553 0 0 1 2.418-2.067c1.092-.53 2.397-.42 3.647-.303a8.54 8.54 0 0 0 1.923 0 4.725 4.725 0 0 0 1.841-.689 7.774 7.774 0 0 0 2.748-3.155c.595-1.3 1.103-2.64 1.518-4.009a21.27 21.27 0 0 1 1.607-3.706 11.833 11.833 0 0 1 4.808-4.822 8.472 8.472 0 0 1 4.479-.943 4.74 4.74 0 0 1 1.641.372 11.637 11.637 0 0 0-1.648-.235 8.561 8.561 0 0 0-4.355 1.034 11.643 11.643 0 0 0-4.602 4.76 20.746 20.746 0 0 0-1.559 3.664 31.066 31.066 0 0 1-1.539 4.057 7.996 7.996 0 0 1-2.851 3.286 5.118 5.118 0 0 1-1.978.689c-.664.07-1.334.07-1.999 0-1.264-.13-2.493-.234-3.496.241a7.432 7.432 0 0 0-2.349 1.99 12.097 12.097 0 0 1-1.862 1.854 4.8 4.8 0 0 1-1.799.86 2.623 2.623 0 0 1-1.257 0 1.452 1.452 0 0 1-.461-.192ZM98.61 76.931a.532.532 0 0 1 0-.158 1.446 1.446 0 0 1 0-.461 5.71 5.71 0 0 1 .495-1.709c.38-.863.852-1.683 1.408-2.445.341-.485.715-.945 1.12-1.378.45-.492.971-.915 1.545-1.254a5.238 5.238 0 0 1 4.465-.034c.784.326 1.519.76 2.184 1.288a12.74 12.74 0 0 0 2.233 1.378 9.776 9.776 0 0 0 5.433.957 7.669 7.669 0 0 0 5.09-2.838c1.243-1.618 1.538-3.85 3.118-5.276a3.495 3.495 0 0 1 1.374-.724c.48-.123.974-.183 1.47-.179.916.043 1.834.02 2.747-.068a10.418 10.418 0 0 0 4.664-1.888 9.859 9.859 0 0 0 2.913-3.3 10.58 10.58 0 0 0 1.181-6.247 11.73 11.73 0 0 0-.343-1.722 3.567 3.567 0 0 1-.172-.6c.35.728.582 1.507.687 2.308a10.365 10.365 0 0 1-1.962 7.747 10.287 10.287 0 0 1-6.885 4.026c-.931.098-1.868.128-2.803.089a5.482 5.482 0 0 0-1.374.165 3.11 3.11 0 0 0-1.208.689c-1.457 1.281-1.766 3.492-3.064 5.221a8.018 8.018 0 0 1-5.33 2.976 10.087 10.087 0 0 1-5.626-1.012 12.708 12.708 0 0 1-2.28-1.42 9.023 9.023 0 0 0-2.109-1.26 4.974 4.974 0 0 0-4.224 0 6.496 6.496 0 0 0-1.505 1.192c-.403.414-.779.853-1.126 1.315a13.921 13.921 0 0 0-1.436 2.384 6.02 6.02 0 0 0-.556 1.66 2.009 2.009 0 0 0 0 .455.561.561 0 0 1-.124.123ZM187.115 54.248a5.776 5.776 0 0 0-1.291-1.86c-1.051-1.02-3.077-1.942-5.694-2.17-1.312-.124-2.748-.124-4.321-.268a10.532 10.532 0 0 1-4.774-1.454 15.524 15.524 0 0 1-3.874-3.94 28.448 28.448 0 0 0-3.764-4.477 10.752 10.752 0 0 0-5.186-2.425 20.664 20.664 0 0 0-5.426-.193c-1.731.138-3.366.406-4.905.689a46.577 46.577 0 0 1-4.293.585 18.49 18.49 0 0 1-6.257-.31 9.353 9.353 0 0 1-2.164-.785c.192.047.381.11.563.186.225.087.454.16.687.22.312.097.628.178.948.242 2.037.395 4.124.463 6.182.2 1.312-.139 2.748-.366 4.272-.627 1.525-.262 3.174-.552 4.925-.69a20.764 20.764 0 0 1 5.496.18 11.13 11.13 0 0 1 5.357 2.5 28.075 28.075 0 0 1 3.812 4.54 15.459 15.459 0 0 0 3.771 3.87 10.224 10.224 0 0 0 4.63 1.434c1.539.151 2.988.172 4.314.31 2.651.261 4.712 1.246 5.763 2.328.41.397.747.863.996 1.378.06.137.113.277.158.42.059.078.084.117.075.117ZM194.981 71.489s-.055 0-.172.069c-.168.064-.34.119-.515.165a6.27 6.27 0 0 1-2.061.186 6.071 6.071 0 0 1-1.483-.324 7.104 7.104 0 0 1-1.594-.833 11.187 11.187 0 0 1-2.94-3.238c-.865-1.377-1.373-3.113-2.239-4.78a7.183 7.183 0 0 0-1.751-2.26 6.565 6.565 0 0 0-2.748-1.253c-2.061-.469-4.307-.276-6.628-.613a12.577 12.577 0 0 1-5.064-1.988 12.622 12.622 0 0 1-3.756-3.943 34.282 34.282 0 0 0-1.917-2.948 6.636 6.636 0 0 0-2.582-2.067 9.697 9.697 0 0 0-3.105-.744 43.513 43.513 0 0 0-6.01.262 17.68 17.68 0 0 1-12.158-3.63 12.727 12.727 0 0 1-2.061-1.908c.052.034.1.073.145.117l.391.365a18.205 18.205 0 0 0 8.456 4.422c1.705.366 3.454.48 5.192.338a42.395 42.395 0 0 1 6.052-.297 9.987 9.987 0 0 1 3.221.765 6.864 6.864 0 0 1 2.748 2.142c.696.96 1.343 1.956 1.937 2.983a12.528 12.528 0 0 0 2.287 2.755 12.275 12.275 0 0 0 6.292 3.01c2.26.345 4.527.16 6.649.641a6.867 6.867 0 0 1 2.858 1.337 7.394 7.394 0 0 1 1.813 2.362c.872 1.709 1.374 3.444 2.198 4.788a10.973 10.973 0 0 0 2.837 3.203c.469.345.979.63 1.518.847.462.174.945.287 1.436.338a7.762 7.762 0 0 0 2.754-.269ZM189.959 114.005a8.843 8.843 0 0 0 1.373-1.688 10.812 10.812 0 0 0 1.312-5.697 11.74 11.74 0 0 0-.755-3.988 8.406 8.406 0 0 0-1.079-1.97 13.407 13.407 0 0 0-1.614-1.784c-1.195-1.144-2.624-2.163-3.963-3.445a10.249 10.249 0 0 1-3.132-4.69 8.092 8.092 0 0 1-.138-2.894c.11-.95.316-1.853.502-2.755.196-.861.325-1.736.384-2.618a6.515 6.515 0 0 0-.329-2.459 9.062 9.062 0 0 0-2.7-3.72 38.48 38.48 0 0 0-3.269-2.486 14.72 14.72 0 0 1-4.266-4.133 7.26 7.26 0 0 1-.687-1.495 3.126 3.126 0 0 1-.117-.558c.213.695.513 1.359.893 1.977a15.238 15.238 0 0 0 4.293 4.037c1.153.757 2.26 1.58 3.318 2.466a9.336 9.336 0 0 1 2.816 3.836c.284.833.408 1.712.364 2.59-.06.898-.189 1.789-.384 2.666-.364 1.77-.831 3.644-.357 5.477a9.858 9.858 0 0 0 3.022 4.525c1.312 1.226 2.747 2.26 3.949 3.444.602.56 1.151 1.174 1.642 1.833a8.776 8.776 0 0 1 1.099 2.066c.484 1.307.733 2.691.735 4.085a10.674 10.674 0 0 1-1.442 5.773 5.397 5.397 0 0 1-.564.764 3.27 3.27 0 0 1-.474.496 2.76 2.76 0 0 1-.432.345ZM103.879 92.402a4.434 4.434 0 0 1-.941-1.419 7.338 7.338 0 0 1-.426-4.56 8.708 8.708 0 0 1 3.977-5.435 11.372 11.372 0 0 1 3.75-1.536 22.689 22.689 0 0 1 4.314-.434c2.94-.062 5.791 0 8.174-.882a11.459 11.459 0 0 0 5.289-3.974 11.904 11.904 0 0 0 1.985-4.064c.268-1.047.302-1.654.344-1.647.018.144.018.29 0 .434-.032.42-.094.836-.186 1.247a11.863 11.863 0 0 1-2.623 5.065 11.816 11.816 0 0 1-4.678 3.25c-2.459.93-5.358.867-8.284.93a22.804 22.804 0 0 0-4.245.42c-1.293.27-2.527.766-3.648 1.467a8.532 8.532 0 0 0-3.908 5.214 7.426 7.426 0 0 0 .302 4.45c.232.51.5 1.003.804 1.474Z", fill: "#3E4148" }), /* @__PURE__ */ jo.createElement("path", { d: "M96.934 231.189c.123.228 2.885 2.377 2.885 2.377l5.062-1.832 6.319 3.237s5.674.599 5.722 2.652c.048 2.053 3.373 12.138-.941 19.04-4.314 6.902-7.37 9.189-7.37 9.189L93.279 251.49l-4.712-.972 8.367-19.329Z", fill: "#B78876" }), /* @__PURE__ */ jo.createElement("path", { d: "M241.893.69a32.768 32.768 0 0 0-17.944 5.345 32.903 32.903 0 0 0-12.115 14.31 33.02 33.02 0 0 0-2.349 18.624 32.968 32.968 0 0 0 8.182 16.884c.13.144.274.282.412.427l-6.23 16.015 19.919-7.033.048-.29c3.174 1.02 6.512 2.33 10.022 2.33 18.134 0 32.874-15.493 32.874-33.685 0-8.73-3.457-17.103-9.611-23.278A32.787 32.787 0 0 0 241.893.69Z", fill: "#fff" }), /* @__PURE__ */ jo.createElement("path", { d: "M241.859 1.16c.197-.02.395-.02.591 0l1.724.047c.936.016 1.868.108 2.789.276.549.083 1.147.138 1.779.269l1.978.489a33.185 33.185 0 0 1 13.287 7.217 33.317 33.317 0 0 1 8.722 12.374 33.388 33.388 0 0 1-2.151 29.433 33.508 33.508 0 0 1-16.004 13.956 32.632 32.632 0 0 1-11.1 2.452 31.698 31.698 0 0 1-11.609-1.446l-.343-.11h.268l-19.405 6.681-.79.276.254-.8 5.021-16.187.083.386a33.306 33.306 0 0 1-7.294-13.483 33.383 33.383 0 0 1-.489-15.331 32.862 32.862 0 0 1 5.001-11.993 33.799 33.799 0 0 1 7.686-8.039 35.622 35.622 0 0 1 4.025-2.617 37.314 37.314 0 0 1 3.881-1.784 26.558 26.558 0 0 1 3.49-1.116 22.459 22.459 0 0 1 2.994-.627c.907-.117 1.711-.255 2.405-.317l1.765-.055h1.078c.121-.015.243-.015.364 0a1.543 1.543 0 0 1-.364.055l-1.071.09-1.752.117c-.687.082-1.484.24-2.376.379-.999.162-1.986.392-2.954.688-1.171.303-2.319.69-3.435 1.158a38.291 38.291 0 0 0-3.791 1.784c-1.372.8-2.689 1.69-3.943 2.666a33.37 33.37 0 0 0-7.487 7.976 32.422 32.422 0 0 0-4.808 11.793 32.712 32.712 0 0 0 .532 14.968 32.648 32.648 0 0 0 7.147 13.15l.151.173-.068.22c-1.601 5.194-3.277 10.615-5.001 16.215l-.542-.523 19.397-6.75.138-.049.137.041.337.11a30.994 30.994 0 0 0 11.313 1.413 31.976 31.976 0 0 0 10.818-2.377 32.777 32.777 0 0 0 15.661-13.584 32.982 32.982 0 0 0 3.736-23.92 32.902 32.902 0 0 0-13.6-20.007 32.721 32.721 0 0 0-9.403-4.36l-1.951-.524c-.618-.144-1.209-.206-1.751-.31a18.947 18.947 0 0 0-2.748-.351l-1.717-.13a3.04 3.04 0 0 1-.605-.063Z", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "m222.352 36.627 5.103-5.118 9.85 8.776 19.322-18.654 4.747 5.125-24.797 23.4-14.225-13.53Z", fill: "#2ED47A" }), /* @__PURE__ */ jo.createElement("path", { d: "M260.412 242.253c-1.642 2.253-4.733 1.426-6.141 0-1.408-1.426-1.972-3.444-2.48-5.407-1.168-4.429-2.342-9.086-1.305-13.55a7.584 7.584 0 0 1 1.807-3.637 3.897 3.897 0 0 1 3.729-1.157c1.56.448 2.494 2.011 3.167 3.486a32.278 32.278 0 0 1 2.871 13.9c-.041 2.225-.35 4.554-1.648 6.365Z", fill: "#0031B2" }), /* @__PURE__ */ jo.createElement("path", { d: "M260.412 242.253c-1.642 2.253-4.733 1.426-6.141 0-1.408-1.426-1.972-3.444-2.48-5.407-1.168-4.429-2.342-9.086-1.305-13.55a7.584 7.584 0 0 1 1.807-3.637 3.897 3.897 0 0 1 3.729-1.157c1.56.448 2.494 2.011 3.167 3.486a32.278 32.278 0 0 1 2.871 13.9c-.041 2.225-.35 4.554-1.648 6.365Z", fill: "#CE6D6D" }), /* @__PURE__ */ jo.createElement("path", { d: "M254.182 253.674a13.803 13.803 0 0 0-8.559-1.24c-1.566.227-3.201.689-4.286 1.805-1.085 1.116-1.332 3.21-.137 4.243.773.55 1.713.813 2.658.744 2.274 0 4.808-.324 6.58 1.088 1.017.799 1.676 2.115 2.906 2.528a2.917 2.917 0 0 0 3.249-1.377c.611-1.13.768-2.45.439-3.692a5.633 5.633 0 0 0-2.85-4.099Z", fill: "#F59999" }), /* @__PURE__ */ jo.createElement("path", { d: "M264.725 245.601c-1.69-2.101-1.951-5.112-1.126-7.681a14.765 14.765 0 0 1 4.671-6.475 24.285 24.285 0 0 1 8.201-4.615 8.637 8.637 0 0 1 3.654-.538 3.84 3.84 0 0 1 3.016 1.922c.817 1.647-.048 3.603-.962 5.201a61.85 61.85 0 0 1-5.495 7.997c-1.635 2.067-3.51 4.023-5.955 4.898-2.446.875-4.973.689-6.224-1.006", fill: "#F28080" }), /* @__PURE__ */ jo.createElement("path", { d: "M259.767 276.695a4.792 4.792 0 0 1-.124-1.04c-.055-.758-.13-1.709-.213-2.845a40.848 40.848 0 0 0-.542-4.168 32.22 32.22 0 0 0-1.374-4.945 17.85 17.85 0 0 0-2.404-4.492 9.295 9.295 0 0 0-3.098-2.707 8.907 8.907 0 0 0-2.645-.888 5.217 5.217 0 0 1-1.03-.173 4.99 4.99 0 0 1 1.051 0 8.16 8.16 0 0 1 2.747.786 9.427 9.427 0 0 1 3.277 2.755 17.795 17.795 0 0 1 2.486 4.588 30.109 30.109 0 0 1 1.374 5.021c.239 1.397.392 2.807.46 4.223.062 1.205.076 2.184.076 2.859.02.342.006.686-.041 1.026Z", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M259.615 274.533a2.054 2.054 0 0 1 0-.483c0-.365 0-.819.034-1.377 0-1.199.069-2.928.049-5.07 0-4.278-.248-10.188-.818-16.691-.57-6.502-1.374-12.364-2.157-16.566a100.115 100.115 0 0 0-.542-2.838c-.172-.834-.309-1.55-.447-2.136-.137-.585-.213-.992-.295-1.343a1.913 1.913 0 0 1-.069-.475c.072.144.125.297.158.454.096.345.22.786.364 1.33s.337 1.288.522 2.121c.186.834.405 1.778.605 2.825a155.8 155.8 0 0 1 2.287 16.594c.57 6.516.762 12.44.687 16.725 0 2.142-.103 3.878-.186 5.077-.048.558-.082 1.012-.116 1.377a1.6 1.6 0 0 1-.076.476Z", fill: "#2D2F34" }), /* @__PURE__ */ jo.createElement("path", { d: "M259.842 263.111a8.348 8.348 0 0 1 .041-1.44c.108-1.305.282-2.604.522-3.892a52.753 52.753 0 0 1 1.374-5.655 49.543 49.543 0 0 1 2.514-6.668 35.732 35.732 0 0 1 7.198-10.718 17.825 17.825 0 0 1 1.669-1.488c.261-.207.488-.42.687-.579l.646-.427c.389-.283.8-.534 1.23-.751a43.247 43.247 0 0 0-4.046 3.444 37.913 37.913 0 0 0-7.02 10.684 53.198 53.198 0 0 0-2.452 6.62c-.687 2.067-1.12 3.988-1.47 5.6-.351 1.612-.529 2.935-.653 3.851a9.084 9.084 0 0 1-.24 1.419ZM334 276.651c0 .188-74.779.349-166.992.349S0 276.839 0 276.651c0-.188 74.755-.349 167.008-.349 92.253 0 166.992.147 166.992.349Z", fill: "#2D2F34" })), jY = ({
  meetStatus: s
}) => {
  const a = Cu((r) => r.room), i = eB((r) => r.isEnded);
  return Pd(() => {
    (s === Yb.END || i) && a && (a == null || a.leave(), a == null || a.removeAllListeners());
  }, [s, a, i]), /* @__PURE__ */ We(UB, { h: "100%", children: /* @__PURE__ */ We(EE, { h: "100%", maw: 800, children: /* @__PURE__ */ We(LY, { shadow: "sm", padding: "lg", radius: "md", withBorder: !0, children: /* @__PURE__ */ Ir(YC, { align: "center", maw: "480px", spacing: 12, mb: 16, pt: 16, children: [
    /* @__PURE__ */ We(j0, { variant: "headingSmall", children: "Esta sala foi encerrada com sucesso!" }),
    /* @__PURE__ */ We(j0, { children: "Obrigado por utilizar nossa plataforma." }),
    /* @__PURE__ */ We(zY, {})
  ] }) }) }) });
};
function _Y(s) {
  const a = (n) => typeof window != "undefined" ? window.matchMedia(n).matches : !1, [i, r] = Tl(a(s));
  function e() {
    r(a(s));
  }
  return Pd(() => {
    const n = window.matchMedia(s);
    return e(), n.addListener ? n.addListener(e) : n.addEventListener("change", e), () => {
      n.removeListener ? n.removeListener(e) : n.removeEventListener("change", e);
    };
  }, [s]), i;
}
const $Y = zA({
  root: (s, {
    open: a
  }) => Xl`
    position: fixed;
    right: 16px;
    bottom: ${a ? "16px" : "-400px"};
    opacity: ${a ? 1 : 0};

    transition:
      bottom 0.35s cubic-bezier(0.25, 1, 0.3, 1),
      opacity 0.25s;
    z-index: 99999;
  `,
  wrapper: Xl`
    filter: drop-shadow(6px 6px 12px rgba(0, 0, 0, 0.08));
    background: #ffff;
    border-radius: 16px;
    height: 418px;
    display: flex;
    flex-direction: column;
  `,
  header: ({
    colors: s
  }) => Xl`
    background: ${s.brand.primary[100]};
    border-radius: 16px 16px 0px 0px;
    padding: 16px;

    color: ${s.neutral[500]};
    font-weight: 600;

    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      color: ${s.neutral[200]};
      cursor: pointer;
    }
  `,
  content: ({
    colors: s
  }) => Xl`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-y: auto;
    overflow: overlay;

    .message {
      padding: 16px;
      border-radius: 16px 16px 16px 0px;
      max-width: 180px;
      background: ${s.neutral[100]};
      overflow-wrap: break-word;

      span {
        font-size: 12px;
        color: ${s.neutral[400]};
        margin-top: 4px;
        display: flex;
        gap: 4px;

        svg {
          width: 14px;
        }
      }
    }

    .mine {
      background: ${s.brand.primary[300]};
      color: ${s.background.white};
      margin-left: auto;

      p {
        color: ${s.background.white};
      }

      span {
        float: right;
        color: ${s.background.white};
      }
    }
  `,
  footer: ({
    colors: s
  }) => Xl`
    background: ${s.brand.primary[100]};
    border-radius: 0px 0px 16px 16px;
    padding: 16px;
    border-top: 1px solid ${s.neutral[200]};
    margin-top: auto;

    form {
      display: flex;
      align-items: center;
      gap: 8px;

      button {
        line-height: 14px;
        margin-top: 8px;
      }
    }
  `
}), qY = () => {
  const s = wp((d) => d.open), a = wp((d) => d.close), i = $Y({
    open: s
  }), [r, e] = Tl(""), n = z0(null), t = _Y("(max-width:300px)"), o = oI(), l = $I((d) => d.listOfMessages), c = (d) => {
    if (d.preventDefault(), !!r)
      try {
        o({
          data: r,
          type: "msg"
        });
      } catch (u) {
        console.warn(u);
      } finally {
        e("");
      }
  };
  return Pd(() => {
    t && s && a();
  }, [a, t, s]), Pd(() => {
    n.current && n.current.scrollTo({
      behavior: "smooth",
      top: n.current.scrollHeight
    });
  }, [l]), /* @__PURE__ */ We("div", { css: i.root, children: /* @__PURE__ */ Ir("div", { css: i.wrapper, children: [
    /* @__PURE__ */ Ir("div", { css: i.header, children: [
      /* @__PURE__ */ We(j0, { renderAs: "p", children: "Mensagens da consulta" }),
      /* @__PURE__ */ We(Nm, { name: "close", onClick: a })
    ] }),
    /* @__PURE__ */ We("div", { css: i.content, ref: n, children: l == null ? void 0 : l.map((d) => /* @__PURE__ */ Ir("div", { className: `message ${d.isSentByMe ? "mine" : ""}`, children: [
      /* @__PURE__ */ We(j0, { renderAs: "p", children: d == null ? void 0 : d.data }),
      /* @__PURE__ */ Ir(j0, { renderAs: "span", children: [
        d == null ? void 0 : d.date,
        (d == null ? void 0 : d.isSentByMe) && /* @__PURE__ */ We(Nm, { name: "check" })
      ] })
    ] }, d == null ? void 0 : d.data)) }),
    /* @__PURE__ */ We("div", { css: i.footer, children: /* @__PURE__ */ Ir("form", { onSubmit: c, children: [
      /* @__PURE__ */ We(VE, { placeholder: "Enviar uma mensagem", value: r, onChange: (d) => e(d.target.value) }),
      /* @__PURE__ */ We(WE, { type: "submit", children: /* @__PURE__ */ We(Nm, { name: "send" }) })
    ] }) })
  ] }) });
};
var Hh = {}, Nv = {}, R1 = {}, Jv = {}, Kl = {}, eg = {}, hu = {}, IB = {}, y1 = {}, Q1 = {};
Object.defineProperty(Q1, "__esModule", {
  value: !0
});
Q1.default = t7;
let Im;
const e7 = new Uint8Array(16);
function t7() {
  if (!Im && (Im = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Im))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Im(e7);
}
var ih = {}, tA = {}, C1 = {};
Object.defineProperty(C1, "__esModule", {
  value: !0
});
C1.default = void 0;
var n7 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
C1.default = n7;
Object.defineProperty(tA, "__esModule", {
  value: !0
});
tA.default = void 0;
var r7 = i7(C1);
function i7(s) {
  return s && s.__esModule ? s : { default: s };
}
function o7(s) {
  return typeof s == "string" && r7.default.test(s);
}
var a7 = o7;
tA.default = a7;
Object.defineProperty(ih, "__esModule", {
  value: !0
});
ih.default = void 0;
ih.unsafeStringify = BB;
var s7 = l7(tA);
function l7(s) {
  return s && s.__esModule ? s : { default: s };
}
const Kc = [];
for (let s = 0; s < 256; ++s)
  Kc.push((s + 256).toString(16).slice(1));
function BB(s, a = 0) {
  return Kc[s[a + 0]] + Kc[s[a + 1]] + Kc[s[a + 2]] + Kc[s[a + 3]] + "-" + Kc[s[a + 4]] + Kc[s[a + 5]] + "-" + Kc[s[a + 6]] + Kc[s[a + 7]] + "-" + Kc[s[a + 8]] + Kc[s[a + 9]] + "-" + Kc[s[a + 10]] + Kc[s[a + 11]] + Kc[s[a + 12]] + Kc[s[a + 13]] + Kc[s[a + 14]] + Kc[s[a + 15]];
}
function c7(s, a = 0) {
  const i = BB(s, a);
  if (!(0, s7.default)(i))
    throw TypeError("Stringified UUID is invalid");
  return i;
}
var d7 = c7;
ih.default = d7;
Object.defineProperty(y1, "__esModule", {
  value: !0
});
y1.default = void 0;
var u7 = A7(Q1), h7 = ih;
function A7(s) {
  return s && s.__esModule ? s : { default: s };
}
let fy, Gv, Tv = 0, Xv = 0;
function g7(s, a, i) {
  let r = a && i || 0;
  const e = a || new Array(16);
  s = s || {};
  let n = s.node || fy, t = s.clockseq !== void 0 ? s.clockseq : Gv;
  if (n == null || t == null) {
    const h = s.random || (s.rng || u7.default)();
    n == null && (n = fy = [h[0] | 1, h[1], h[2], h[3], h[4], h[5]]), t == null && (t = Gv = (h[6] << 8 | h[7]) & 16383);
  }
  let o = s.msecs !== void 0 ? s.msecs : Date.now(), l = s.nsecs !== void 0 ? s.nsecs : Xv + 1;
  const c = o - Tv + (l - Xv) / 1e4;
  if (c < 0 && s.clockseq === void 0 && (t = t + 1 & 16383), (c < 0 || o > Tv) && s.nsecs === void 0 && (l = 0), l >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  Tv = o, Xv = l, Gv = t, o += 122192928e5;
  const d = ((o & 268435455) * 1e4 + l) % 4294967296;
  e[r++] = d >>> 24 & 255, e[r++] = d >>> 16 & 255, e[r++] = d >>> 8 & 255, e[r++] = d & 255;
  const u = o / 4294967296 * 1e4 & 268435455;
  e[r++] = u >>> 8 & 255, e[r++] = u & 255, e[r++] = u >>> 24 & 15 | 16, e[r++] = u >>> 16 & 255, e[r++] = t >>> 8 | 128, e[r++] = t & 255;
  for (let h = 0; h < 6; ++h)
    e[r + h] = n[h];
  return a || (0, h7.unsafeStringify)(e);
}
var f7 = g7;
y1.default = f7;
var U1 = {}, th = {}, qp = {};
Object.defineProperty(qp, "__esModule", {
  value: !0
});
qp.default = void 0;
var p7 = m7(tA);
function m7(s) {
  return s && s.__esModule ? s : { default: s };
}
function v7(s) {
  if (!(0, p7.default)(s))
    throw TypeError("Invalid UUID");
  let a;
  const i = new Uint8Array(16);
  return i[0] = (a = parseInt(s.slice(0, 8), 16)) >>> 24, i[1] = a >>> 16 & 255, i[2] = a >>> 8 & 255, i[3] = a & 255, i[4] = (a = parseInt(s.slice(9, 13), 16)) >>> 8, i[5] = a & 255, i[6] = (a = parseInt(s.slice(14, 18), 16)) >>> 8, i[7] = a & 255, i[8] = (a = parseInt(s.slice(19, 23), 16)) >>> 8, i[9] = a & 255, i[10] = (a = parseInt(s.slice(24, 36), 16)) / 1099511627776 & 255, i[11] = a / 4294967296 & 255, i[12] = a >>> 24 & 255, i[13] = a >>> 16 & 255, i[14] = a >>> 8 & 255, i[15] = a & 255, i;
}
var b7 = v7;
qp.default = b7;
Object.defineProperty(th, "__esModule", {
  value: !0
});
th.URL = th.DNS = void 0;
th.default = C7;
var F7 = ih, R7 = y7(qp);
function y7(s) {
  return s && s.__esModule ? s : { default: s };
}
function Q7(s) {
  s = unescape(encodeURIComponent(s));
  const a = [];
  for (let i = 0; i < s.length; ++i)
    a.push(s.charCodeAt(i));
  return a;
}
const ZB = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
th.DNS = ZB;
const SB = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
th.URL = SB;
function C7(s, a, i) {
  function r(e, n, t, o) {
    var l;
    if (typeof e == "string" && (e = Q7(e)), typeof n == "string" && (n = (0, R7.default)(n)), ((l = n) === null || l === void 0 ? void 0 : l.length) !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    let c = new Uint8Array(16 + e.length);
    if (c.set(n), c.set(e, n.length), c = i(c), c[6] = c[6] & 15 | a, c[8] = c[8] & 63 | 128, t) {
      o = o || 0;
      for (let d = 0; d < 16; ++d)
        t[o + d] = c[d];
      return t;
    }
    return (0, F7.unsafeStringify)(c);
  }
  try {
    r.name = s;
  } catch {
  }
  return r.DNS = ZB, r.URL = SB, r;
}
var I1 = {};
Object.defineProperty(I1, "__esModule", {
  value: !0
});
I1.default = void 0;
function U7(s) {
  if (typeof s == "string") {
    const a = unescape(encodeURIComponent(s));
    s = new Uint8Array(a.length);
    for (let i = 0; i < a.length; ++i)
      s[i] = a.charCodeAt(i);
  }
  return I7(B7(Z7(s), s.length * 8));
}
function I7(s) {
  const a = [], i = s.length * 32, r = "0123456789abcdef";
  for (let e = 0; e < i; e += 8) {
    const n = s[e >> 5] >>> e % 32 & 255, t = parseInt(r.charAt(n >>> 4 & 15) + r.charAt(n & 15), 16);
    a.push(t);
  }
  return a;
}
function EB(s) {
  return (s + 64 >>> 9 << 4) + 14 + 1;
}
function B7(s, a) {
  s[a >> 5] |= 128 << a % 32, s[EB(a) - 1] = a;
  let i = 1732584193, r = -271733879, e = -1732584194, n = 271733878;
  for (let t = 0; t < s.length; t += 16) {
    const o = i, l = r, c = e, d = n;
    i = ud(i, r, e, n, s[t], 7, -680876936), n = ud(n, i, r, e, s[t + 1], 12, -389564586), e = ud(e, n, i, r, s[t + 2], 17, 606105819), r = ud(r, e, n, i, s[t + 3], 22, -1044525330), i = ud(i, r, e, n, s[t + 4], 7, -176418897), n = ud(n, i, r, e, s[t + 5], 12, 1200080426), e = ud(e, n, i, r, s[t + 6], 17, -1473231341), r = ud(r, e, n, i, s[t + 7], 22, -45705983), i = ud(i, r, e, n, s[t + 8], 7, 1770035416), n = ud(n, i, r, e, s[t + 9], 12, -1958414417), e = ud(e, n, i, r, s[t + 10], 17, -42063), r = ud(r, e, n, i, s[t + 11], 22, -1990404162), i = ud(i, r, e, n, s[t + 12], 7, 1804603682), n = ud(n, i, r, e, s[t + 13], 12, -40341101), e = ud(e, n, i, r, s[t + 14], 17, -1502002290), r = ud(r, e, n, i, s[t + 15], 22, 1236535329), i = hd(i, r, e, n, s[t + 1], 5, -165796510), n = hd(n, i, r, e, s[t + 6], 9, -1069501632), e = hd(e, n, i, r, s[t + 11], 14, 643717713), r = hd(r, e, n, i, s[t], 20, -373897302), i = hd(i, r, e, n, s[t + 5], 5, -701558691), n = hd(n, i, r, e, s[t + 10], 9, 38016083), e = hd(e, n, i, r, s[t + 15], 14, -660478335), r = hd(r, e, n, i, s[t + 4], 20, -405537848), i = hd(i, r, e, n, s[t + 9], 5, 568446438), n = hd(n, i, r, e, s[t + 14], 9, -1019803690), e = hd(e, n, i, r, s[t + 3], 14, -187363961), r = hd(r, e, n, i, s[t + 8], 20, 1163531501), i = hd(i, r, e, n, s[t + 13], 5, -1444681467), n = hd(n, i, r, e, s[t + 2], 9, -51403784), e = hd(e, n, i, r, s[t + 7], 14, 1735328473), r = hd(r, e, n, i, s[t + 12], 20, -1926607734), i = Ad(i, r, e, n, s[t + 5], 4, -378558), n = Ad(n, i, r, e, s[t + 8], 11, -2022574463), e = Ad(e, n, i, r, s[t + 11], 16, 1839030562), r = Ad(r, e, n, i, s[t + 14], 23, -35309556), i = Ad(i, r, e, n, s[t + 1], 4, -1530992060), n = Ad(n, i, r, e, s[t + 4], 11, 1272893353), e = Ad(e, n, i, r, s[t + 7], 16, -155497632), r = Ad(r, e, n, i, s[t + 10], 23, -1094730640), i = Ad(i, r, e, n, s[t + 13], 4, 681279174), n = Ad(n, i, r, e, s[t], 11, -358537222), e = Ad(e, n, i, r, s[t + 3], 16, -722521979), r = Ad(r, e, n, i, s[t + 6], 23, 76029189), i = Ad(i, r, e, n, s[t + 9], 4, -640364487), n = Ad(n, i, r, e, s[t + 12], 11, -421815835), e = Ad(e, n, i, r, s[t + 15], 16, 530742520), r = Ad(r, e, n, i, s[t + 2], 23, -995338651), i = gd(i, r, e, n, s[t], 6, -198630844), n = gd(n, i, r, e, s[t + 7], 10, 1126891415), e = gd(e, n, i, r, s[t + 14], 15, -1416354905), r = gd(r, e, n, i, s[t + 5], 21, -57434055), i = gd(i, r, e, n, s[t + 12], 6, 1700485571), n = gd(n, i, r, e, s[t + 3], 10, -1894986606), e = gd(e, n, i, r, s[t + 10], 15, -1051523), r = gd(r, e, n, i, s[t + 1], 21, -2054922799), i = gd(i, r, e, n, s[t + 8], 6, 1873313359), n = gd(n, i, r, e, s[t + 15], 10, -30611744), e = gd(e, n, i, r, s[t + 6], 15, -1560198380), r = gd(r, e, n, i, s[t + 13], 21, 1309151649), i = gd(i, r, e, n, s[t + 4], 6, -145523070), n = gd(n, i, r, e, s[t + 11], 10, -1120210379), e = gd(e, n, i, r, s[t + 2], 15, 718787259), r = gd(r, e, n, i, s[t + 9], 21, -343485551), i = K0(i, o), r = K0(r, l), e = K0(e, c), n = K0(n, d);
  }
  return [i, r, e, n];
}
function Z7(s) {
  if (s.length === 0)
    return [];
  const a = s.length * 8, i = new Uint32Array(EB(a));
  for (let r = 0; r < a; r += 8)
    i[r >> 5] |= (s[r / 8] & 255) << r % 32;
  return i;
}
function K0(s, a) {
  const i = (s & 65535) + (a & 65535);
  return (s >> 16) + (a >> 16) + (i >> 16) << 16 | i & 65535;
}
function S7(s, a) {
  return s << a | s >>> 32 - a;
}
function B1(s, a, i, r, e, n) {
  return K0(S7(K0(K0(a, s), K0(r, n)), e), i);
}
function ud(s, a, i, r, e, n, t) {
  return B1(a & i | ~a & r, s, a, e, n, t);
}
function hd(s, a, i, r, e, n, t) {
  return B1(a & r | i & ~r, s, a, e, n, t);
}
function Ad(s, a, i, r, e, n, t) {
  return B1(a ^ i ^ r, s, a, e, n, t);
}
function gd(s, a, i, r, e, n, t) {
  return B1(i ^ (a | ~r), s, a, e, n, t);
}
var E7 = U7;
I1.default = E7;
Object.defineProperty(U1, "__esModule", {
  value: !0
});
U1.default = void 0;
var V7 = VB(th), W7 = VB(I1);
function VB(s) {
  return s && s.__esModule ? s : { default: s };
}
const N7 = (0, V7.default)("v3", 48, W7.default);
var J7 = N7;
U1.default = J7;
var Z1 = {}, S1 = {};
Object.defineProperty(S1, "__esModule", {
  value: !0
});
S1.default = void 0;
const G7 = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var T7 = {
  randomUUID: G7
};
S1.default = T7;
Object.defineProperty(Z1, "__esModule", {
  value: !0
});
Z1.default = void 0;
var py = WB(S1), X7 = WB(Q1), k7 = ih;
function WB(s) {
  return s && s.__esModule ? s : { default: s };
}
function w7(s, a, i) {
  if (py.default.randomUUID && !a && !s)
    return py.default.randomUUID();
  s = s || {};
  const r = s.random || (s.rng || X7.default)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, a) {
    i = i || 0;
    for (let e = 0; e < 16; ++e)
      a[i + e] = r[e];
    return a;
  }
  return (0, k7.unsafeStringify)(r);
}
var D7 = w7;
Z1.default = D7;
var E1 = {}, V1 = {};
Object.defineProperty(V1, "__esModule", {
  value: !0
});
V1.default = void 0;
function M7(s, a, i, r) {
  switch (s) {
    case 0:
      return a & i ^ ~a & r;
    case 1:
      return a ^ i ^ r;
    case 2:
      return a & i ^ a & r ^ i & r;
    case 3:
      return a ^ i ^ r;
  }
}
function kv(s, a) {
  return s << a | s >>> 32 - a;
}
function Y7(s) {
  const a = [1518500249, 1859775393, 2400959708, 3395469782], i = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof s == "string") {
    const t = unescape(encodeURIComponent(s));
    s = [];
    for (let o = 0; o < t.length; ++o)
      s.push(t.charCodeAt(o));
  } else Array.isArray(s) || (s = Array.prototype.slice.call(s));
  s.push(128);
  const r = s.length / 4 + 2, e = Math.ceil(r / 16), n = new Array(e);
  for (let t = 0; t < e; ++t) {
    const o = new Uint32Array(16);
    for (let l = 0; l < 16; ++l)
      o[l] = s[t * 64 + l * 4] << 24 | s[t * 64 + l * 4 + 1] << 16 | s[t * 64 + l * 4 + 2] << 8 | s[t * 64 + l * 4 + 3];
    n[t] = o;
  }
  n[e - 1][14] = (s.length - 1) * 8 / Math.pow(2, 32), n[e - 1][14] = Math.floor(n[e - 1][14]), n[e - 1][15] = (s.length - 1) * 8 & 4294967295;
  for (let t = 0; t < e; ++t) {
    const o = new Uint32Array(80);
    for (let A = 0; A < 16; ++A)
      o[A] = n[t][A];
    for (let A = 16; A < 80; ++A)
      o[A] = kv(o[A - 3] ^ o[A - 8] ^ o[A - 14] ^ o[A - 16], 1);
    let l = i[0], c = i[1], d = i[2], u = i[3], h = i[4];
    for (let A = 0; A < 80; ++A) {
      const g = Math.floor(A / 20), f = kv(l, 5) + M7(g, c, d, u) + h + a[g] + o[A] >>> 0;
      h = u, u = d, d = kv(c, 30) >>> 0, c = l, l = f;
    }
    i[0] = i[0] + l >>> 0, i[1] = i[1] + c >>> 0, i[2] = i[2] + d >>> 0, i[3] = i[3] + u >>> 0, i[4] = i[4] + h >>> 0;
  }
  return [i[0] >> 24 & 255, i[0] >> 16 & 255, i[0] >> 8 & 255, i[0] & 255, i[1] >> 24 & 255, i[1] >> 16 & 255, i[1] >> 8 & 255, i[1] & 255, i[2] >> 24 & 255, i[2] >> 16 & 255, i[2] >> 8 & 255, i[2] & 255, i[3] >> 24 & 255, i[3] >> 16 & 255, i[3] >> 8 & 255, i[3] & 255, i[4] >> 24 & 255, i[4] >> 16 & 255, i[4] >> 8 & 255, i[4] & 255];
}
var L7 = Y7;
V1.default = L7;
Object.defineProperty(E1, "__esModule", {
  value: !0
});
E1.default = void 0;
var x7 = NB(th), H7 = NB(V1);
function NB(s) {
  return s && s.__esModule ? s : { default: s };
}
const P7 = (0, x7.default)("v5", 80, H7.default);
var O7 = P7;
E1.default = O7;
var W1 = {};
Object.defineProperty(W1, "__esModule", {
  value: !0
});
W1.default = void 0;
var K7 = "00000000-0000-0000-0000-000000000000";
W1.default = K7;
var N1 = {};
Object.defineProperty(N1, "__esModule", {
  value: !0
});
N1.default = void 0;
var z7 = j7(tA);
function j7(s) {
  return s && s.__esModule ? s : { default: s };
}
function _7(s) {
  if (!(0, z7.default)(s))
    throw TypeError("Invalid UUID");
  return parseInt(s.slice(14, 15), 16);
}
var $7 = _7;
N1.default = $7;
(function(s) {
  Object.defineProperty(s, "__esModule", {
    value: !0
  }), Object.defineProperty(s, "NIL", {
    enumerable: !0,
    get: function() {
      return n.default;
    }
  }), Object.defineProperty(s, "parse", {
    enumerable: !0,
    get: function() {
      return c.default;
    }
  }), Object.defineProperty(s, "stringify", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), Object.defineProperty(s, "v1", {
    enumerable: !0,
    get: function() {
      return a.default;
    }
  }), Object.defineProperty(s, "v3", {
    enumerable: !0,
    get: function() {
      return i.default;
    }
  }), Object.defineProperty(s, "v4", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  }), Object.defineProperty(s, "v5", {
    enumerable: !0,
    get: function() {
      return e.default;
    }
  }), Object.defineProperty(s, "validate", {
    enumerable: !0,
    get: function() {
      return o.default;
    }
  }), Object.defineProperty(s, "version", {
    enumerable: !0,
    get: function() {
      return t.default;
    }
  });
  var a = d(y1), i = d(U1), r = d(Z1), e = d(E1), n = d(W1), t = d(N1), o = d(tA), l = d(ih), c = d(qp);
  function d(u) {
    return u && u.__esModule ? u : { default: u };
  }
})(IB);
Object.defineProperty(hu, "__esModule", { value: !0 });
hu.createNoDashGuid = hu.createGuid = void 0;
const q7 = IB, JB = () => q7.v4();
hu.createGuid = JB;
const eL = () => JB().replace(new RegExp("-", "g"), "").toUpperCase();
hu.createNoDashGuid = eL;
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.PlatformEvent = s.EventType = void 0;
  const a = hu;
  (function(r) {
    r[r.Debug = 0] = "Debug", r[r.Info = 1] = "Info", r[r.Warning = 2] = "Warning", r[r.Error = 3] = "Error", r[r.None = 4] = "None";
  })(s.EventType || (s.EventType = {}));
  class i {
    constructor(e, n) {
      this.privName = e, this.privEventId = a.createNoDashGuid(), this.privEventTime = (/* @__PURE__ */ new Date()).toISOString(), this.privEventType = n, this.privMetadata = {};
    }
    get name() {
      return this.privName;
    }
    get eventId() {
      return this.privEventId;
    }
    get eventTime() {
      return this.privEventTime;
    }
    get eventType() {
      return this.privEventType;
    }
    get metadata() {
      return this.privMetadata;
    }
  }
  s.PlatformEvent = i;
})(eg);
Object.defineProperty(Kl, "__esModule", { value: !0 });
Kl.AudioStreamNodeErrorEvent = Kl.AudioStreamNodeDetachedEvent = Kl.AudioStreamNodeAttachedEvent = Kl.AudioStreamNodeAttachingEvent = Kl.AudioStreamNodeEvent = Kl.AudioSourceErrorEvent = Kl.AudioSourceOffEvent = Kl.AudioSourceReadyEvent = Kl.AudioSourceInitializingEvent = Kl.AudioSourceEvent = void 0;
const Wb = eg;
class tg extends Wb.PlatformEvent {
  constructor(a, i, r = Wb.EventType.Info) {
    super(a, r), this.privAudioSourceId = i;
  }
  get audioSourceId() {
    return this.privAudioSourceId;
  }
}
Kl.AudioSourceEvent = tg;
class tL extends tg {
  constructor(a) {
    super("AudioSourceInitializingEvent", a);
  }
}
Kl.AudioSourceInitializingEvent = tL;
class nL extends tg {
  constructor(a) {
    super("AudioSourceReadyEvent", a);
  }
}
Kl.AudioSourceReadyEvent = nL;
class rL extends tg {
  constructor(a) {
    super("AudioSourceOffEvent", a);
  }
}
Kl.AudioSourceOffEvent = rL;
class iL extends tg {
  constructor(a, i) {
    super("AudioSourceErrorEvent", a, Wb.EventType.Error), this.privError = i;
  }
  get error() {
    return this.privError;
  }
}
Kl.AudioSourceErrorEvent = iL;
class em extends tg {
  constructor(a, i, r) {
    super(a, i), this.privAudioNodeId = r;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
}
Kl.AudioStreamNodeEvent = em;
class oL extends em {
  constructor(a, i) {
    super("AudioStreamNodeAttachingEvent", a, i);
  }
}
Kl.AudioStreamNodeAttachingEvent = oL;
class aL extends em {
  constructor(a, i) {
    super("AudioStreamNodeAttachedEvent", a, i);
  }
}
Kl.AudioStreamNodeAttachedEvent = aL;
class sL extends em {
  constructor(a, i) {
    super("AudioStreamNodeDetachedEvent", a, i);
  }
}
Kl.AudioStreamNodeDetachedEvent = sL;
class lL extends em {
  constructor(a, i, r) {
    super("AudioStreamNodeErrorEvent", a, i), this.privError = r;
  }
  get error() {
    return this.privError;
  }
}
Kl.AudioStreamNodeErrorEvent = lL;
var pc = {};
Object.defineProperty(pc, "__esModule", { value: !0 });
pc.ConnectionMessageSentEvent = pc.ConnectionMessageReceivedEvent = pc.ConnectionEstablishErrorEvent = pc.ConnectionErrorEvent = pc.ConnectionClosedEvent = pc.ConnectionEstablishedEvent = pc.ConnectionStartEvent = pc.ConnectionEvent = pc.ServiceEvent = void 0;
const _h = eg;
class cL extends _h.PlatformEvent {
  constructor(a, i, r = _h.EventType.Info) {
    super(a, r), this.privJsonResult = i;
  }
  get jsonString() {
    return this.privJsonResult;
  }
}
pc.ServiceEvent = cL;
class oh extends _h.PlatformEvent {
  constructor(a, i, r = _h.EventType.Info) {
    super(a, r), this.privConnectionId = i;
  }
  get connectionId() {
    return this.privConnectionId;
  }
}
pc.ConnectionEvent = oh;
class dL extends oh {
  constructor(a, i, r) {
    super("ConnectionStartEvent", a), this.privUri = i, this.privHeaders = r;
  }
  get uri() {
    return this.privUri;
  }
  get headers() {
    return this.privHeaders;
  }
}
pc.ConnectionStartEvent = dL;
class uL extends oh {
  constructor(a) {
    super("ConnectionEstablishedEvent", a);
  }
}
pc.ConnectionEstablishedEvent = uL;
class hL extends oh {
  constructor(a, i, r) {
    super("ConnectionClosedEvent", a, _h.EventType.Debug), this.privReason = r, this.privStatusCode = i;
  }
  get reason() {
    return this.privReason;
  }
  get statusCode() {
    return this.privStatusCode;
  }
}
pc.ConnectionClosedEvent = hL;
class AL extends oh {
  constructor(a, i, r) {
    super("ConnectionErrorEvent", a, _h.EventType.Debug), this.privMessage = i, this.privType = r;
  }
  get message() {
    return this.privMessage;
  }
  get type() {
    return this.privType;
  }
}
pc.ConnectionErrorEvent = AL;
class gL extends oh {
  constructor(a, i, r) {
    super("ConnectionEstablishErrorEvent", a, _h.EventType.Error), this.privStatusCode = i, this.privReason = r;
  }
  get reason() {
    return this.privReason;
  }
  get statusCode() {
    return this.privStatusCode;
  }
}
pc.ConnectionEstablishErrorEvent = gL;
class fL extends oh {
  constructor(a, i, r) {
    super("ConnectionMessageReceivedEvent", a), this.privNetworkReceivedTime = i, this.privMessage = r;
  }
  get networkReceivedTime() {
    return this.privNetworkReceivedTime;
  }
  get message() {
    return this.privMessage;
  }
}
pc.ConnectionMessageReceivedEvent = fL;
class pL extends oh {
  constructor(a, i, r) {
    super("ConnectionMessageSentEvent", a), this.privNetworkSentTime = i, this.privMessage = r;
  }
  get networkSentTime() {
    return this.privNetworkSentTime;
  }
  get message() {
    return this.privMessage;
  }
}
pc.ConnectionMessageSentEvent = pL;
var rF = {}, _c = {};
Object.defineProperty(_c, "__esModule", { value: !0 });
_c.ObjectDisposedError = _c.InvalidOperationError = _c.ArgumentNullError = void 0;
class mL extends Error {
  /**
   * Creates an instance of ArgumentNullError.
   *
   * @param {string} argumentName - Name of the argument that is null
   *
   * @memberOf ArgumentNullError
   */
  constructor(a) {
    super(a), this.name = "ArgumentNull", this.message = a;
  }
}
_c.ArgumentNullError = mL;
class vL extends Error {
  /**
   * Creates an instance of InvalidOperationError.
   *
   * @param {string} error - The error
   *
   * @memberOf InvalidOperationError
   */
  constructor(a) {
    super(a), this.name = "InvalidOperation", this.message = a;
  }
}
_c.InvalidOperationError = vL;
class bL extends Error {
  /**
   * Creates an instance of ObjectDisposedError.
   *
   * @param {string} objectName - The object that is disposed
   * @param {string} error - The error
   *
   * @memberOf ObjectDisposedError
   */
  constructor(a, i) {
    super(i), this.name = a + "ObjectDisposed", this.message = i;
  }
}
_c.ObjectDisposedError = bL;
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.ConnectionMessage = s.MessageType = void 0;
  const a = _c, i = hu;
  var r;
  (function(n) {
    n[n.Text = 0] = "Text", n[n.Binary = 1] = "Binary";
  })(r = s.MessageType || (s.MessageType = {}));
  class e {
    constructor(t, o, l, c) {
      if (this.privBody = null, t === r.Text && o && typeof o != "string")
        throw new a.InvalidOperationError("Payload must be a string");
      if (t === r.Binary && o && !(o instanceof ArrayBuffer))
        throw new a.InvalidOperationError("Payload must be ArrayBuffer");
      switch (this.privMessageType = t, this.privBody = o, this.privHeaders = l || {}, this.privId = c || i.createNoDashGuid(), this.messageType) {
        case r.Binary:
          this.privSize = this.binaryBody !== null ? this.binaryBody.byteLength : 0;
          break;
        case r.Text:
          this.privSize = this.textBody.length;
      }
    }
    get messageType() {
      return this.privMessageType;
    }
    get headers() {
      return this.privHeaders;
    }
    get body() {
      return this.privBody;
    }
    get textBody() {
      if (this.privMessageType === r.Binary)
        throw new a.InvalidOperationError("Not supported for binary message");
      return this.privBody;
    }
    get binaryBody() {
      if (this.privMessageType === r.Text)
        throw new a.InvalidOperationError("Not supported for text message");
      return this.privBody;
    }
    get id() {
      return this.privId;
    }
  }
  s.ConnectionMessage = e;
})(rF);
var J1 = {};
Object.defineProperty(J1, "__esModule", { value: !0 });
J1.ConnectionOpenResponse = void 0;
class FL {
  constructor(a, i) {
    this.privStatusCode = a, this.privReason = i;
  }
  get statusCode() {
    return this.privStatusCode;
  }
  get reason() {
    return this.privReason;
  }
}
J1.ConnectionOpenResponse = FL;
var G1 = {};
Object.defineProperty(G1, "__esModule", { value: !0 });
G1.DeferralMap = void 0;
class RL {
  constructor() {
    this.privMap = {};
  }
  add(a, i) {
    this.privMap[a] = i;
  }
  getId(a) {
    return this.privMap[a];
  }
  complete(a, i) {
    try {
      this.privMap[a].resolve(i);
    } catch (r) {
      this.privMap[a].reject(r);
    } finally {
      this.privMap[a] = void 0;
    }
  }
}
G1.DeferralMap = RL;
var $h = {};
Object.defineProperty($h, "__esModule", { value: !0 });
$h.SendingAgentContextMessageEvent = $h.DialogEvent = void 0;
const my = eg;
class GB extends my.PlatformEvent {
  constructor(a, i = my.EventType.Info) {
    super(a, i);
  }
}
$h.DialogEvent = GB;
class yL extends GB {
  constructor(a) {
    super("SendingAgentContextMessageEvent"), this.privAgentConfig = a;
  }
  get agentConfig() {
    return this.privAgentConfig;
  }
}
$h.SendingAgentContextMessageEvent = yL;
var T1 = {}, tm = {};
Object.defineProperty(tm, "__esModule", { value: !0 });
tm.EventSource = void 0;
const QL = _c, CL = hu;
class UL {
  constructor(a) {
    this.privEventListeners = {}, this.privIsDisposed = !1, this.privConsoleListener = void 0, this.privMetadata = a;
  }
  onEvent(a) {
    if (this.isDisposed())
      throw new QL.ObjectDisposedError("EventSource");
    if (this.metadata)
      for (const i in this.metadata)
        i && a.metadata && (a.metadata[i] || (a.metadata[i] = this.metadata[i]));
    for (const i in this.privEventListeners)
      i && this.privEventListeners[i] && this.privEventListeners[i](a);
  }
  attach(a) {
    const i = CL.createNoDashGuid();
    return this.privEventListeners[i] = a, {
      detach: () => (delete this.privEventListeners[i], Promise.resolve())
    };
  }
  attachListener(a) {
    return this.attach((i) => a.onEvent(i));
  }
  attachConsoleListener(a) {
    return this.privConsoleListener && this.privConsoleListener.detach(), this.privConsoleListener = this.attach((i) => a.onEvent(i)), this.privConsoleListener;
  }
  isDisposed() {
    return this.privIsDisposed;
  }
  dispose() {
    this.privEventListeners = null, this.privIsDisposed = !0;
  }
  get metadata() {
    return this.privMetadata;
  }
}
tm.EventSource = UL;
Object.defineProperty(T1, "__esModule", { value: !0 });
T1.Events = void 0;
const IL = _c, BL = tm;
class Lp {
  static setEventSource(a) {
    if (!a)
      throw new IL.ArgumentNullError("eventSource");
    Lp.privInstance = a;
  }
  static get instance() {
    return Lp.privInstance;
  }
}
T1.Events = Lp;
Lp.privInstance = new BL.EventSource();
var TB = {};
Object.defineProperty(TB, "__esModule", { value: !0 });
var XB = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.ConnectionState = void 0, function(a) {
    a[a.None = 0] = "None", a[a.Connected = 1] = "Connected", a[a.Connecting = 2] = "Connecting", a[a.Disconnected = 3] = "Disconnected";
  }(s.ConnectionState || (s.ConnectionState = {}));
})(XB);
var kB = {};
Object.defineProperty(kB, "__esModule", { value: !0 });
var wB = {};
Object.defineProperty(wB, "__esModule", { value: !0 });
var DB = {};
Object.defineProperty(DB, "__esModule", { value: !0 });
var MB = {};
Object.defineProperty(MB, "__esModule", { value: !0 });
var YB = {};
Object.defineProperty(YB, "__esModule", { value: !0 });
var LB = {};
Object.defineProperty(LB, "__esModule", { value: !0 });
var xB = {};
Object.defineProperty(xB, "__esModule", { value: !0 });
var HB = {};
Object.defineProperty(HB, "__esModule", { value: !0 });
var nm = {};
Object.defineProperty(nm, "__esModule", { value: !0 });
nm.List = void 0;
const ZL = _c;
class P0 {
  constructor(a) {
    if (this.privSubscriptionIdCounter = 0, this.privAddSubscriptions = {}, this.privRemoveSubscriptions = {}, this.privDisposedSubscriptions = {}, this.privDisposeReason = null, this.privList = [], a)
      for (const i of a)
        this.privList.push(i);
  }
  get(a) {
    return this.throwIfDisposed(), this.privList[a];
  }
  first() {
    return this.get(0);
  }
  last() {
    return this.get(this.length() - 1);
  }
  add(a) {
    this.throwIfDisposed(), this.insertAt(this.privList.length, a);
  }
  insertAt(a, i) {
    this.throwIfDisposed(), a === 0 ? this.privList.unshift(i) : a === this.privList.length ? this.privList.push(i) : this.privList.splice(a, 0, i), this.triggerSubscriptions(this.privAddSubscriptions);
  }
  removeFirst() {
    return this.throwIfDisposed(), this.removeAt(0);
  }
  removeLast() {
    return this.throwIfDisposed(), this.removeAt(this.length() - 1);
  }
  removeAt(a) {
    return this.throwIfDisposed(), this.remove(a, 1)[0];
  }
  remove(a, i) {
    this.throwIfDisposed();
    const r = this.privList.splice(a, i);
    return this.triggerSubscriptions(this.privRemoveSubscriptions), r;
  }
  clear() {
    this.throwIfDisposed(), this.remove(0, this.length());
  }
  length() {
    return this.throwIfDisposed(), this.privList.length;
  }
  onAdded(a) {
    this.throwIfDisposed();
    const i = this.privSubscriptionIdCounter++;
    return this.privAddSubscriptions[i] = a, {
      detach: () => (delete this.privAddSubscriptions[i], Promise.resolve())
    };
  }
  onRemoved(a) {
    this.throwIfDisposed();
    const i = this.privSubscriptionIdCounter++;
    return this.privRemoveSubscriptions[i] = a, {
      detach: () => (delete this.privRemoveSubscriptions[i], Promise.resolve())
    };
  }
  onDisposed(a) {
    this.throwIfDisposed();
    const i = this.privSubscriptionIdCounter++;
    return this.privDisposedSubscriptions[i] = a, {
      detach: () => (delete this.privDisposedSubscriptions[i], Promise.resolve())
    };
  }
  join(a) {
    return this.throwIfDisposed(), this.privList.join(a);
  }
  toArray() {
    const a = Array();
    return this.privList.forEach((i) => {
      a.push(i);
    }), a;
  }
  any(a) {
    return this.throwIfDisposed(), a ? this.where(a).length() > 0 : this.length() > 0;
  }
  all(a) {
    return this.throwIfDisposed(), this.where(a).length() === this.length();
  }
  forEach(a) {
    this.throwIfDisposed();
    for (let i = 0; i < this.length(); i++)
      a(this.privList[i], i);
  }
  select(a) {
    this.throwIfDisposed();
    const i = [];
    for (let r = 0; r < this.privList.length; r++)
      i.push(a(this.privList[r], r));
    return new P0(i);
  }
  where(a) {
    this.throwIfDisposed();
    const i = new P0();
    for (let r = 0; r < this.privList.length; r++)
      a(this.privList[r], r) && i.add(this.privList[r]);
    return i;
  }
  orderBy(a) {
    this.throwIfDisposed();
    const r = this.toArray().sort(a);
    return new P0(r);
  }
  orderByDesc(a) {
    return this.throwIfDisposed(), this.orderBy((i, r) => a(r, i));
  }
  clone() {
    return this.throwIfDisposed(), new P0(this.toArray());
  }
  concat(a) {
    return this.throwIfDisposed(), new P0(this.privList.concat(a.toArray()));
  }
  concatArray(a) {
    return this.throwIfDisposed(), new P0(this.privList.concat(a));
  }
  isDisposed() {
    return this.privList == null;
  }
  dispose(a) {
    this.isDisposed() || (this.privDisposeReason = a, this.privList = null, this.privAddSubscriptions = null, this.privRemoveSubscriptions = null, this.triggerSubscriptions(this.privDisposedSubscriptions));
  }
  throwIfDisposed() {
    if (this.isDisposed())
      throw new ZL.ObjectDisposedError("List", this.privDisposeReason);
  }
  triggerSubscriptions(a) {
    if (a)
      for (const i in a)
        i && a[i]();
  }
}
nm.List = P0;
var iF = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.marshalPromiseToCallbacks = s.Sink = s.Deferred = s.PromiseResultEventSource = s.PromiseResult = s.PromiseState = void 0;
  var a;
  (function(o) {
    o[o.None = 0] = "None", o[o.Resolved = 1] = "Resolved", o[o.Rejected = 2] = "Rejected";
  })(a = s.PromiseState || (s.PromiseState = {}));
  class i {
    constructor(l) {
      this.throwIfError = () => {
        if (this.isError)
          throw this.error;
      }, l.on((c) => {
        this.privIsCompleted || (this.privIsCompleted = !0, this.privIsError = !1, this.privResult = c);
      }, (c) => {
        this.privIsCompleted || (this.privIsCompleted = !0, this.privIsError = !0, this.privError = c);
      });
    }
    get isCompleted() {
      return this.privIsCompleted;
    }
    get isError() {
      return this.privIsError;
    }
    get error() {
      return this.privError;
    }
    get result() {
      return this.privResult;
    }
  }
  s.PromiseResult = i;
  class r {
    constructor() {
      this.setResult = (l) => {
        this.privOnSetResult(l);
      }, this.setError = (l) => {
        this.privOnSetError(l);
      }, this.on = (l, c) => {
        this.privOnSetResult = l, this.privOnSetError = c;
      };
    }
  }
  s.PromiseResultEventSource = r;
  class e {
    constructor() {
      this.resolve = (l) => (this.privResolve(l), this), this.reject = (l) => (this.privReject(l), this), this.privPromise = new Promise((l, c) => {
        this.privResolve = l, this.privReject = c;
      });
    }
    get promise() {
      return this.privPromise;
    }
  }
  s.Deferred = e;
  class n {
    constructor() {
      this.privState = a.None, this.privPromiseResult = null, this.privPromiseResultEvents = null, this.privSuccessHandlers = [], this.privErrorHandlers = [], this.privPromiseResultEvents = new r(), this.privPromiseResult = new i(this.privPromiseResultEvents);
    }
    get state() {
      return this.privState;
    }
    get result() {
      return this.privPromiseResult;
    }
    resolve(l) {
      if (this.privState !== a.None)
        throw new Error("'Cannot resolve a completed promise'");
      this.privState = a.Resolved, this.privPromiseResultEvents.setResult(l);
      for (let c = 0; c < this.privSuccessHandlers.length; c++)
        this.executeSuccessCallback(l, this.privSuccessHandlers[c], this.privErrorHandlers[c]);
      this.detachHandlers();
    }
    reject(l) {
      if (this.privState !== a.None)
        throw new Error("'Cannot reject a completed promise'");
      this.privState = a.Rejected, this.privPromiseResultEvents.setError(l);
      for (const c of this.privErrorHandlers)
        this.executeErrorCallback(l, c);
      this.detachHandlers();
    }
    on(l, c) {
      l == null && (l = () => {
      }), this.privState === a.None ? (this.privSuccessHandlers.push(l), this.privErrorHandlers.push(c)) : (this.privState === a.Resolved ? this.executeSuccessCallback(this.privPromiseResult.result, l, c) : this.privState === a.Rejected && this.executeErrorCallback(this.privPromiseResult.error, c), this.detachHandlers());
    }
    executeSuccessCallback(l, c, d) {
      try {
        c(l);
      } catch (u) {
        this.executeErrorCallback(`'Unhandled callback error: ${u}'`, d);
      }
    }
    executeErrorCallback(l, c) {
      if (c)
        try {
          c(l);
        } catch (d) {
          throw new Error(`'Unhandled callback error: ${d}. InnerError: ${l}'`);
        }
      else
        throw new Error(`'Unhandled error: ${l}'`);
    }
    detachHandlers() {
      this.privErrorHandlers = [], this.privSuccessHandlers = [];
    }
  }
  s.Sink = n;
  function t(o, l, c) {
    o.then((d) => {
      try {
        l && l(d);
      } catch (u) {
        if (c)
          try {
            if (u instanceof Error) {
              const h = u;
              c(h.name + ": " + h.message);
            } else
              c(u);
          } catch {
          }
      }
    }, (d) => {
      if (c)
        try {
          if (d instanceof Error) {
            const u = d;
            c(u.name + ": " + u.message);
          } else
            c(d);
        } catch {
        }
    });
  }
  s.marshalPromiseToCallbacks = t;
})(iF);
var rm = {};
Object.defineProperty(rm, "__esModule", { value: !0 });
rm.Queue = void 0;
const wv = _c, Dv = nm, vy = iF;
var Wp;
(function(s) {
  s[s.Dequeue = 0] = "Dequeue", s[s.Peek = 1] = "Peek";
})(Wp || (Wp = {}));
class SL {
  constructor(a) {
    this.privPromiseStore = new Dv.List(), this.privIsDrainInProgress = !1, this.privIsDisposing = !1, this.privDisposeReason = null, this.privList = a || new Dv.List(), this.privDetachables = [], this.privSubscribers = new Dv.List(), this.privDetachables.push(this.privList.onAdded(() => this.drain()));
  }
  enqueue(a) {
    this.throwIfDispose(), this.enqueueFromPromise(new Promise((i) => i(a)));
  }
  enqueueFromPromise(a) {
    this.throwIfDispose(), a.then((i) => {
      this.privList.add(i);
    }, () => {
    });
  }
  dequeue() {
    this.throwIfDispose();
    const a = new vy.Deferred();
    return this.privSubscribers && (this.privSubscribers.add({ deferral: a, type: Wp.Dequeue }), this.drain()), a.promise;
  }
  peek() {
    this.throwIfDispose();
    const a = new vy.Deferred();
    return this.privSubscribers && (this.privSubscribers.add({ deferral: a, type: Wp.Peek }), this.drain()), a.promise;
  }
  length() {
    return this.throwIfDispose(), this.privList.length();
  }
  isDisposed() {
    return this.privSubscribers == null;
  }
  async drainAndDispose(a, i) {
    if (!this.isDisposed() && !this.privIsDisposing) {
      this.privDisposeReason = i, this.privIsDisposing = !0;
      const r = this.privSubscribers;
      if (r) {
        for (; r.length() > 0; )
          r.removeFirst().deferral.resolve(void 0);
        this.privSubscribers === r && (this.privSubscribers = r);
      }
      for (const e of this.privDetachables)
        await e.detach();
      if (this.privPromiseStore.length() > 0 && a) {
        const e = [];
        return this.privPromiseStore.toArray().forEach((n) => {
          e.push(n);
        }), Promise.all(e).finally(() => {
          this.privSubscribers = null, this.privList.forEach((n) => {
            a(n);
          }), this.privList = null;
        }).then();
      } else
        this.privSubscribers = null, this.privList = null;
    }
  }
  async dispose(a) {
    await this.drainAndDispose(null, a);
  }
  drain() {
    if (!this.privIsDrainInProgress && !this.privIsDisposing) {
      this.privIsDrainInProgress = !0;
      const a = this.privSubscribers, i = this.privList;
      if (a && i) {
        for (; i.length() > 0 && a.length() > 0 && !this.privIsDisposing; ) {
          const r = a.removeFirst();
          if (r.type === Wp.Peek)
            r.deferral.resolve(i.first());
          else {
            const e = i.removeFirst();
            r.deferral.resolve(e);
          }
        }
        this.privSubscribers === a && (this.privSubscribers = a), this.privList === i && (this.privList = i);
      }
      this.privIsDrainInProgress = !1;
    }
  }
  throwIfDispose() {
    if (this.isDisposed())
      throw this.privDisposeReason ? new wv.InvalidOperationError(this.privDisposeReason) : new wv.ObjectDisposedError("Queue");
    if (this.privIsDisposing)
      throw new wv.InvalidOperationError("Queue disposing");
  }
}
rm.Queue = SL;
var X1 = {};
Object.defineProperty(X1, "__esModule", { value: !0 });
X1.RawWebsocketMessage = void 0;
const Bm = rF, Dg = _c, EL = hu;
class VL {
  constructor(a, i, r) {
    if (this.privPayload = null, !i)
      throw new Dg.ArgumentNullError("payload");
    if (a === Bm.MessageType.Binary && Object.getPrototypeOf(i).constructor.name !== "ArrayBuffer")
      throw new Dg.InvalidOperationError("Payload must be ArrayBuffer");
    if (a === Bm.MessageType.Text && typeof i != "string")
      throw new Dg.InvalidOperationError("Payload must be a string");
    this.privMessageType = a, this.privPayload = i, this.privId = r || EL.createNoDashGuid();
  }
  get messageType() {
    return this.privMessageType;
  }
  get payload() {
    return this.privPayload;
  }
  get textContent() {
    if (this.privMessageType === Bm.MessageType.Binary)
      throw new Dg.InvalidOperationError("Not supported for binary message");
    return this.privPayload;
  }
  get binaryContent() {
    if (this.privMessageType === Bm.MessageType.Text)
      throw new Dg.InvalidOperationError("Not supported for text message");
    return this.privPayload;
  }
  get id() {
    return this.privId;
  }
}
X1.RawWebsocketMessage = VL;
var k1 = {};
Object.defineProperty(k1, "__esModule", { value: !0 });
k1.RiffPcmEncoder = void 0;
class WL {
  constructor(a, i) {
    this.privActualSampleRate = a, this.privDesiredSampleRate = i;
  }
  encode(a) {
    const i = this.downSampleAudioFrame(a, this.privActualSampleRate, this.privDesiredSampleRate);
    if (!i)
      return null;
    const r = i.length * 2, e = new ArrayBuffer(r), n = new DataView(e);
    return this.floatTo16BitPCM(n, 0, i), e;
  }
  setString(a, i, r) {
    for (let e = 0; e < r.length; e++)
      a.setUint8(i + e, r.charCodeAt(e));
  }
  floatTo16BitPCM(a, i, r) {
    for (let e = 0; e < r.length; e++, i += 2) {
      const n = Math.max(-1, Math.min(1, r[e]));
      a.setInt16(i, n < 0 ? n * 32768 : n * 32767, !0);
    }
  }
  downSampleAudioFrame(a, i, r) {
    if (!a)
      return null;
    if (r === i || r > i)
      return a;
    const e = i / r, n = Math.round(a.length / e), t = new Float32Array(n);
    let o = 0, l = 0;
    for (; l < n; ) {
      const c = Math.round((l + 1) * e);
      let d = 0, u = 0;
      for (; o < c && o < a.length; )
        d += a[o++], u++;
      t[l++] = d / u;
    }
    return t;
  }
}
k1.RiffPcmEncoder = WL;
var w1 = {};
Object.defineProperty(w1, "__esModule", { value: !0 });
w1.Stream = void 0;
const by = _c, NL = hu, Fy = rm;
class JL {
  constructor(a) {
    this.privIsWriteEnded = !1, this.privIsReadEnded = !1, this.privId = a || NL.createNoDashGuid(), this.privReaderQueue = new Fy.Queue();
  }
  get isClosed() {
    return this.privIsWriteEnded;
  }
  get isReadEnded() {
    return this.privIsReadEnded;
  }
  get id() {
    return this.privId;
  }
  close() {
    this.privIsWriteEnded || (this.writeStreamChunk({
      buffer: null,
      isEnd: !0,
      timeReceived: Date.now()
    }), this.privIsWriteEnded = !0);
  }
  writeStreamChunk(a) {
    if (this.throwIfClosed(), !this.privReaderQueue.isDisposed())
      try {
        this.privReaderQueue.enqueue(a);
      } catch {
      }
  }
  read() {
    if (this.privIsReadEnded)
      throw new by.InvalidOperationError("Stream read has already finished");
    return this.privReaderQueue.dequeue().then(async (a) => ((a === void 0 || a.isEnd) && await this.privReaderQueue.dispose("End of stream reached"), a));
  }
  readEnded() {
    this.privIsReadEnded || (this.privIsReadEnded = !0, this.privReaderQueue = new Fy.Queue());
  }
  throwIfClosed() {
    if (this.privIsWriteEnded)
      throw new by.InvalidOperationError("Stream closed");
  }
}
w1.Stream = JL;
var D1 = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.TranslationStatus = void 0, function(a) {
    a[a.Success = 0] = "Success", a[a.Error = 1] = "Error";
  }(s.TranslationStatus || (s.TranslationStatus = {}));
})(D1);
var Mg = {}, Ry;
function GL() {
  if (Ry) return Mg;
  Ry = 1, Object.defineProperty(Mg, "__esModule", { value: !0 }), Mg.ChunkedArrayBufferStream = void 0;
  const s = Eo();
  let a = class extends s.Stream {
    constructor(r, e) {
      super(e), this.privTargetChunkSize = r, this.privNextBufferReadyBytes = 0;
    }
    writeStreamChunk(r) {
      if (r.isEnd || this.privNextBufferReadyBytes === 0 && r.buffer.byteLength === this.privTargetChunkSize) {
        super.writeStreamChunk(r);
        return;
      }
      let e = 0;
      for (; e < r.buffer.byteLength; ) {
        this.privNextBufferToWrite === void 0 && (this.privNextBufferToWrite = new ArrayBuffer(this.privTargetChunkSize), this.privNextBufferStartTime = r.timeReceived);
        const n = Math.min(r.buffer.byteLength - e, this.privTargetChunkSize - this.privNextBufferReadyBytes), t = new Uint8Array(this.privNextBufferToWrite), o = new Uint8Array(r.buffer.slice(e, n + e));
        t.set(o, this.privNextBufferReadyBytes), this.privNextBufferReadyBytes += n, e += n, this.privNextBufferReadyBytes === this.privTargetChunkSize && (super.writeStreamChunk({
          buffer: this.privNextBufferToWrite,
          isEnd: !1,
          timeReceived: this.privNextBufferStartTime
        }), this.privNextBufferReadyBytes = 0, this.privNextBufferToWrite = void 0);
      }
    }
    close() {
      this.privNextBufferReadyBytes !== 0 && !this.isClosed && super.writeStreamChunk({
        buffer: this.privNextBufferToWrite.slice(0, this.privNextBufferReadyBytes),
        isEnd: !1,
        timeReceived: this.privNextBufferStartTime
      }), super.close();
    }
  };
  return Mg.ChunkedArrayBufferStream = a, Mg;
}
var PB = {};
Object.defineProperty(PB, "__esModule", { value: !0 });
var M1 = {};
Object.defineProperty(M1, "__esModule", { value: !0 });
M1.Timeout = void 0;
class md {
  static load() {
    const a = /* @__PURE__ */ new Map([[0, () => {
    }]]), i = /* @__PURE__ */ new Map(), e = "data:text/javascript;base64," + btoa(`!function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=14)}([function(e,t,n){"use strict";n.d(t,"a",(function(){return i})),n.d(t,"b",(function(){return u})),n.d(t,"c",(function(){return a})),n.d(t,"d",(function(){return d}));const r=new Map,o=new Map,i=e=>{const t=r.get(e);if(void 0===t)throw new Error('There is no interval scheduled with the given id "'.concat(e,'".'));clearTimeout(t),r.delete(e)},u=e=>{const t=o.get(e);if(void 0===t)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(t),o.delete(e)},f=(e,t)=>{let n,r;if("performance"in self){const o=performance.now();n=o,r=e-Math.max(0,o-t)}else n=Date.now(),r=e;return{expected:n+r,remainingDelay:r}},c=(e,t,n,r)=>{const o="performance"in self?performance.now():Date.now();o>n?postMessage({id:null,method:"call",params:{timerId:t}}):e.set(t,setTimeout(c,n-o,e,t,n))},a=(e,t,n)=>{const{expected:o,remainingDelay:i}=f(e,n);r.set(t,setTimeout(c,i,r,t,o))},d=(e,t,n)=>{const{expected:r,remainingDelay:i}=f(e,n);o.set(t,setTimeout(c,i,o,t,r))}},function(e,t,n){"use strict";n.r(t);var r=n(2);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(3);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(4);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o);var f=n(5);for(var o in f)"default"!==o&&function(e){n.d(t,e,(function(){return f[e]}))}(o);var c=n(6);for(var o in c)"default"!==o&&function(e){n.d(t,e,(function(){return c[e]}))}(o);var a=n(7);for(var o in a)"default"!==o&&function(e){n.d(t,e,(function(){return a[e]}))}(o);var d=n(8);for(var o in d)"default"!==o&&function(e){n.d(t,e,(function(){return d[e]}))}(o);var s=n(9);for(var o in s)"default"!==o&&function(e){n.d(t,e,(function(){return s[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(11);for(var o in r)"default"!==o&&function(e){n.d(t,e,(function(){return r[e]}))}(o);var i=n(12);for(var o in i)"default"!==o&&function(e){n.d(t,e,(function(){return i[e]}))}(o);var u=n(13);for(var o in u)"default"!==o&&function(e){n.d(t,e,(function(){return u[e]}))}(o)},function(e,t){},function(e,t){},function(e,t){},function(e,t,n){"use strict";n.r(t);var r=n(0),o=n(1);for(var i in o)"default"!==i&&function(e){n.d(t,e,(function(){return o[e]}))}(i);var u=n(10);for(var i in u)"default"!==i&&function(e){n.d(t,e,(function(){return u[e]}))}(i);addEventListener("message",({data:e})=>{try{if("clear"===e.method){const{id:t,params:{timerId:n}}=e;Object(r.b)(n),postMessage({error:null,id:t})}else{if("set"!==e.method)throw new Error('The given method "'.concat(e.method,'" is not supported'));{const{params:{delay:t,now:n,timerId:o}}=e;Object(r.d)(t,o,n)}}}catch(t){postMessage({error:{message:t.message},id:e.id,result:null})}})}]);`), n = new Worker(e);
    return n.addEventListener("message", ({ data: l }) => {
      if (md.isCallNotification(l)) {
        const { params: { timerId: c } } = l, d = a.get(c);
        if (typeof d == "number") {
          const u = i.get(d);
          if (u === void 0 || u !== c)
            throw new Error("The timer is in an undefined state.");
        } else if (typeof d != "undefined")
          d(), a.delete(c);
        else
          throw new Error("The timer is in an undefined state.");
      } else if (md.isClearResponse(l)) {
        const { id: c } = l, d = i.get(c);
        if (d === void 0)
          throw new Error("The timer is in an undefined state.");
        i.delete(c), a.delete(d);
      } else {
        const { error: { message: c } } = l;
        throw new Error(c);
      }
    }), {
      clearTimeout: (l) => {
        const c = Math.random();
        i.set(c, l), a.set(l, c), n.postMessage({
          id: c,
          method: "clear",
          params: { timerId: l }
        });
      },
      setTimeout: (l, c) => {
        const d = Math.random();
        return a.set(d, l), n.postMessage({
          id: null,
          method: "set",
          params: {
            delay: c,
            now: performance.now(),
            timerId: d
          }
        }), d;
      }
    };
  }
  static loadWorkerTimers() {
    return () => (md.workerTimers !== null || (md.workerTimers = md.load()), md.workerTimers);
  }
  static isCallNotification(a) {
    return a.method !== void 0 && a.method === "call";
  }
  static isClearResponse(a) {
    return a.error === null && typeof a.id == "number";
  }
}
M1.Timeout = md;
md.workerTimers = null;
md.clearTimeout = (s) => md.timers().clearTimeout(s);
md.setTimeout = (s, a) => md.timers().setTimeout(s, a);
md.timers = md.loadWorkerTimers();
var Ka = {};
Object.defineProperty(Ka, "__esModule", { value: !0 });
Ka.OCSPCacheUpdateErrorEvent = Ka.OCSPResponseRetrievedEvent = Ka.OCSPCacheFetchErrorEvent = Ka.OCSPVerificationFailedEvent = Ka.OCSPCacheHitEvent = Ka.OCSPCacheEntryNeedsRefreshEvent = Ka.OCSPCacheEntryExpiredEvent = Ka.OCSPWSUpgradeStartedEvent = Ka.OCSPStapleReceivedEvent = Ka.OCSPCacheUpdateCompleteEvent = Ka.OCSPDiskCacheStoreEvent = Ka.OCSPMemoryCacheStoreEvent = Ka.OCSPCacheUpdateNeededEvent = Ka.OCSPDiskCacheHitEvent = Ka.OCSPCacheMissEvent = Ka.OCSPMemoryCacheHitEvent = Ka.OCSPEvent = void 0;
const $c = eg;
class qc extends $c.PlatformEvent {
  constructor(a, i, r) {
    super(a, i), this.privSignature = r;
  }
}
Ka.OCSPEvent = qc;
class TL extends qc {
  constructor(a) {
    super("OCSPMemoryCacheHitEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPMemoryCacheHitEvent = TL;
class XL extends qc {
  constructor(a) {
    super("OCSPCacheMissEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPCacheMissEvent = XL;
class kL extends qc {
  constructor(a) {
    super("OCSPDiskCacheHitEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPDiskCacheHitEvent = kL;
class wL extends qc {
  constructor(a) {
    super("OCSPCacheUpdateNeededEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPCacheUpdateNeededEvent = wL;
class DL extends qc {
  constructor(a) {
    super("OCSPMemoryCacheStoreEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPMemoryCacheStoreEvent = DL;
class ML extends qc {
  constructor(a) {
    super("OCSPDiskCacheStoreEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPDiskCacheStoreEvent = ML;
class YL extends qc {
  constructor(a) {
    super("OCSPCacheUpdateCompleteEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPCacheUpdateCompleteEvent = YL;
class LL extends qc {
  constructor() {
    super("OCSPStapleReceivedEvent", $c.EventType.Debug, "");
  }
}
Ka.OCSPStapleReceivedEvent = LL;
class xL extends qc {
  constructor(a) {
    super("OCSPWSUpgradeStartedEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPWSUpgradeStartedEvent = xL;
class HL extends qc {
  constructor(a, i) {
    super("OCSPCacheEntryExpiredEvent", $c.EventType.Debug, a), this.privExpireTime = i;
  }
}
Ka.OCSPCacheEntryExpiredEvent = HL;
class PL extends qc {
  constructor(a, i, r) {
    super("OCSPCacheEntryNeedsRefreshEvent", $c.EventType.Debug, a), this.privExpireTime = r, this.privStartTime = i;
  }
}
Ka.OCSPCacheEntryNeedsRefreshEvent = PL;
class OL extends qc {
  constructor(a, i, r) {
    super("OCSPCacheHitEvent", $c.EventType.Debug, a), this.privExpireTime = r, this.privExpireTimeString = new Date(r).toLocaleDateString(), this.privStartTime = i, this.privStartTimeString = new Date(i).toLocaleTimeString();
  }
}
Ka.OCSPCacheHitEvent = OL;
class KL extends qc {
  constructor(a, i) {
    super("OCSPVerificationFailedEvent", $c.EventType.Debug, a), this.privError = i;
  }
}
Ka.OCSPVerificationFailedEvent = KL;
class zL extends qc {
  constructor(a, i) {
    super("OCSPCacheFetchErrorEvent", $c.EventType.Debug, a), this.privError = i;
  }
}
Ka.OCSPCacheFetchErrorEvent = zL;
class jL extends qc {
  constructor(a) {
    super("OCSPResponseRetrievedEvent", $c.EventType.Debug, a);
  }
}
Ka.OCSPResponseRetrievedEvent = jL;
class _L extends qc {
  constructor(a, i) {
    super("OCSPCacheUpdateErrorEvent", $c.EventType.Debug, a), this.privError = i;
  }
}
Ka.OCSPCacheUpdateErrorEvent = _L;
var Yg = {}, yy;
function $L() {
  if (yy) return Yg;
  yy = 1, Object.defineProperty(Yg, "__esModule", { value: !0 }), Yg.BackgroundEvent = void 0;
  const s = Eo();
  class a extends s.PlatformEvent {
    constructor(r) {
      super("BackgroundEvent", s.EventType.Error), this.privError = r;
    }
    get error() {
      return this.privError;
    }
  }
  return Yg.BackgroundEvent = a, Yg;
}
var Qy;
function Eo() {
  return Qy || (Qy = 1, function(s) {
    var a = Dn && Dn.__createBinding || (Object.create ? function(e, n, t, o) {
      o === void 0 && (o = t), Object.defineProperty(e, o, { enumerable: !0, get: function() {
        return n[t];
      } });
    } : function(e, n, t, o) {
      o === void 0 && (o = t), e[o] = n[t];
    }), i = Dn && Dn.__exportStar || function(e, n) {
      for (var t in e) t !== "default" && !n.hasOwnProperty(t) && a(n, e, t);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), i(Kl, s), i(pc, s), i(rF, s), i(J1, s), i(G1, s), i($h, s), i(_c, s), i(T1, s), i(tm, s), i(hu, s), i(TB, s), i(XB, s), i(kB, s), i(wB, s), i(DB, s), i(MB, s), i(YB, s), i(LB, s), i(xB, s), i(HB, s), i(nm, s), i(eg, s), i(iF, s), i(rm, s), i(X1, s), i(k1, s), i(w1, s);
    var r = D1;
    Object.defineProperty(s, "TranslationStatus", { enumerable: !0, get: function() {
      return r.TranslationStatus;
    } }), i(GL(), s), i(PB, s), i(M1, s), i(Ka, s), i($L(), s);
  }(Jv)), Jv;
}
var Tc = {};
Object.defineProperty(Tc, "__esModule", { value: !0 });
Tc.HeaderNames = void 0;
class Uu {
}
Tc.HeaderNames = Uu;
Uu.AuthKey = "Ocp-Apim-Subscription-Key";
Uu.Authorization = "Authorization";
Uu.SpIDAuthKey = "Apim-Subscription-Id";
Uu.ConnectionId = "X-ConnectionId";
Uu.ContentType = "Content-Type";
Uu.CustomCommandsAppId = "X-CommandsAppId";
Uu.Path = "Path";
Uu.RequestId = "X-RequestId";
Uu.RequestStreamId = "X-StreamId";
Uu.RequestTimestamp = "X-Timestamp";
var ng = {};
Object.defineProperty(ng, "__esModule", { value: !0 });
ng.AuthInfo = void 0;
class qL {
  constructor(a, i) {
    this.privHeaderName = a, this.privToken = i;
  }
  get headerName() {
    return this.privHeaderName;
  }
  get token() {
    return this.privToken;
  }
}
ng.AuthInfo = qL;
Object.defineProperty(R1, "__esModule", { value: !0 });
R1.CognitiveSubscriptionKeyAuthentication = void 0;
const ex = Eo(), tx = Tc, nx = ng;
class rx {
  /**
   * Creates and initializes an instance of the CognitiveSubscriptionKeyAuthentication class.
   * @constructor
   * @param {string} subscriptionKey - The subscription key
   */
  constructor(a) {
    if (!a)
      throw new ex.ArgumentNullError("subscriptionKey");
    this.privAuthInfo = new nx.AuthInfo(tx.HeaderNames.AuthKey, a);
  }
  /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fetch(a) {
    return Promise.resolve(this.privAuthInfo);
  }
  /**
   * Fetches the subscription key.
   * @member
   * @function
   * @public
   * @param {string} authFetchEventId - The id to fetch.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fetchOnExpiry(a) {
    return Promise.resolve(this.privAuthInfo);
  }
}
R1.CognitiveSubscriptionKeyAuthentication = rx;
var Y1 = {};
Object.defineProperty(Y1, "__esModule", { value: !0 });
Y1.CognitiveTokenAuthentication = void 0;
const Cy = Eo(), Uy = ng, Iy = Tc;
class xp {
  constructor(a, i) {
    if (!a)
      throw new Cy.ArgumentNullError("fetchCallback");
    if (!i)
      throw new Cy.ArgumentNullError("fetchOnExpiryCallback");
    this.privFetchCallback = a, this.privFetchOnExpiryCallback = i;
  }
  fetch(a) {
    return this.privFetchCallback(a).then((i) => new Uy.AuthInfo(Iy.HeaderNames.Authorization, i === void 0 ? void 0 : xp.privTokenPrefix + i));
  }
  fetchOnExpiry(a) {
    return this.privFetchOnExpiryCallback(a).then((i) => new Uy.AuthInfo(Iy.HeaderNames.Authorization, i === void 0 ? void 0 : xp.privTokenPrefix + i));
  }
}
Y1.CognitiveTokenAuthentication = xp;
xp.privTokenPrefix = "Bearer ";
var OB = {};
Object.defineProperty(OB, "__esModule", { value: !0 });
var KB = {};
Object.defineProperty(KB, "__esModule", { value: !0 });
var Lg = {}, Mv = {}, L1 = {};
const ix = {}, ox = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ix
}, Symbol.toStringTag, { value: "Module" })), nA = /* @__PURE__ */ fV(ox);
var oF = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.LogLevel = void 0;
  const a = Eo();
  Object.defineProperty(s, "LogLevel", { enumerable: !0, get: function() {
    return a.EventType;
  } });
})(oF);
var _o = {};
Object.defineProperty(_o, "__esModule", { value: !0 });
_o.Contracts = void 0;
class O0 {
  static throwIfNullOrUndefined(a, i) {
    if (a == null)
      throw new Error("throwIfNullOrUndefined:" + i);
  }
  static throwIfNull(a, i) {
    if (a === null)
      throw new Error("throwIfNull:" + i);
  }
  static throwIfNullOrWhitespace(a, i) {
    if (O0.throwIfNullOrUndefined(a, i), ("" + a).trim().length < 1)
      throw new Error("throwIfNullOrWhitespace:" + i);
  }
  static throwIfNullOrTooLong(a, i, r) {
    if (O0.throwIfNullOrUndefined(a, i), ("" + a).length > r)
      throw new Error("throwIfNullOrTooLong:" + i + " (more than " + r.toString() + " characters)");
  }
  static throwIfNullOrTooShort(a, i, r) {
    if (O0.throwIfNullOrUndefined(a, i), ("" + a).length < r)
      throw new Error("throwIfNullOrTooShort:" + i + " (less than " + r.toString() + " characters)");
  }
  static throwIfDisposed(a) {
    if (a)
      throw new Error("the object is already disposed");
  }
  static throwIfArrayEmptyOrWhitespace(a, i) {
    if (O0.throwIfNullOrUndefined(a, i), a.length === 0)
      throw new Error("throwIfArrayEmptyOrWhitespace:" + i);
    for (const r of a)
      O0.throwIfNullOrWhitespace(r, i);
  }
  static throwIfFileDoesNotExist(a, i) {
    O0.throwIfNullOrWhitespace(a, i);
  }
  static throwIfNotUndefined(a, i) {
    if (a !== void 0)
      throw new Error("throwIfNotUndefined:" + i);
  }
}
_o.Contracts = O0;
var ax = Dn && Dn.__createBinding || (Object.create ? function(s, a, i, r) {
  r === void 0 && (r = i), Object.defineProperty(s, r, { enumerable: !0, get: function() {
    return a[i];
  } });
} : function(s, a, i, r) {
  r === void 0 && (r = i), s[r] = a[i];
}), sx = Dn && Dn.__setModuleDefault || (Object.create ? function(s, a) {
  Object.defineProperty(s, "default", { enumerable: !0, value: a });
} : function(s, a) {
  s.default = a;
}), lx = Dn && Dn.__importStar || function(s) {
  if (s && s.__esModule) return s;
  var a = {};
  if (s != null) for (var i in s) i !== "default" && Object.hasOwnProperty.call(s, i) && ax(a, s, i);
  return sx(a, s), a;
};
Object.defineProperty(L1, "__esModule", { value: !0 });
L1.ConsoleLoggingListener = void 0;
const By = lx(nA), xg = oF, cx = _o;
class dx {
  constructor(a = xg.LogLevel.None) {
    this.privLogPath = void 0, this.privEnableConsoleOutput = !0, this.privLogLevelFilter = a;
  }
  set logPath(a) {
    cx.Contracts.throwIfNullOrUndefined(By.openSync, `
File System access not available`), this.privLogPath = a;
  }
  set enableConsoleOutput(a) {
    this.privEnableConsoleOutput = a;
  }
  onEvent(a) {
    if (a.eventType >= this.privLogLevelFilter) {
      const i = this.toString(a);
      if (this.logCallback && this.logCallback(i), this.privLogPath && By.writeFileSync(this.privLogPath, i + `
`, { flag: "a+" }), this.privEnableConsoleOutput)
        switch (a.eventType) {
          case xg.LogLevel.Debug:
            console.debug(i);
            break;
          case xg.LogLevel.Info:
            console.info(i);
            break;
          case xg.LogLevel.Warning:
            console.warn(i);
            break;
          case xg.LogLevel.Error:
            console.error(i);
            break;
          default:
            console.log(i);
            break;
        }
    }
  }
  toString(a) {
    const i = [
      `${a.eventTime}`,
      `${a.name}`
    ], r = a;
    for (const e in r)
      if (e && a.hasOwnProperty(e) && e !== "eventTime" && e !== "eventType" && e !== "eventId" && e !== "name" && e !== "constructor") {
        const n = r[e];
        let t = "<NULL>";
        n != null && (typeof n == "number" || typeof n == "string" ? t = n.toString() : t = JSON.stringify(n)), i.push(`${e}: ${t}`);
      }
    return i.join(" | ");
  }
}
L1.ConsoleLoggingListener = dx;
var zB = {};
Object.defineProperty(zB, "__esModule", { value: !0 });
var Yv = {}, ah = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.AudioStreamFormatImpl = s.AudioStreamFormat = s.AudioFormatTag = void 0;
  var a;
  (function(e) {
    e[e.PCM = 1] = "PCM", e[e.MuLaw = 2] = "MuLaw", e[e.Siren = 3] = "Siren", e[e.MP3 = 4] = "MP3", e[e.SILKSkype = 5] = "SILKSkype", e[e.OGG_OPUS = 6] = "OGG_OPUS", e[e.WEBM_OPUS = 7] = "WEBM_OPUS", e[e.ALaw = 8] = "ALaw", e[e.FLAC = 9] = "FLAC", e[e.OPUS = 10] = "OPUS", e[e.AMR_WB = 11] = "AMR_WB", e[e.G722 = 12] = "G722";
  })(a = s.AudioFormatTag || (s.AudioFormatTag = {}));
  class i {
    /**
     * Creates an audio stream format object representing the default audio stream
     * format (16KHz 16bit mono PCM).
     * @member AudioStreamFormat.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormat} The audio stream format being created.
     */
    static getDefaultInputFormat() {
      return r.getDefaultInputFormat();
    }
    /**
     * Creates an audio stream format object with the specified format characteristics.
     * @member AudioStreamFormat.getWaveFormat
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     * @returns {AudioStreamFormat} The audio stream format being created.
     */
    static getWaveFormat(n, t, o, l) {
      return new r(n, t, o, l);
    }
    /**
     * Creates an audio stream format object with the specified pcm waveformat characteristics.
     * @member AudioStreamFormat.getWaveFormatPCM
     * @function
     * @public
     * @param {number} samplesPerSecond - Sample rate, in samples per second (Hertz).
     * @param {number} bitsPerSample - Bits per sample, typically 16.
     * @param {number} channels - Number of channels in the waveform-audio data. Monaural data
     * uses one channel and stereo data uses two channels.
     * @returns {AudioStreamFormat} The audio stream format being created.
     */
    static getWaveFormatPCM(n, t, o) {
      return new r(n, t, o);
    }
  }
  s.AudioStreamFormat = i;
  class r extends i {
    /**
     * Creates an instance with the given values.
     * @constructor
     * @param {number} samplesPerSec - Samples per second.
     * @param {number} bitsPerSample - Bits per sample.
     * @param {number} channels - Number of channels.
     * @param {AudioFormatTag} format - Audio format (PCM, alaw or mulaw).
     */
    constructor(n = 16e3, t = 16, o = 1, l = a.PCM) {
      super();
      let c = !0;
      switch (l) {
        case a.PCM:
          this.formatTag = 1;
          break;
        case a.ALaw:
          this.formatTag = 6;
          break;
        case a.MuLaw:
          this.formatTag = 7;
          break;
        default:
          c = !1;
      }
      if (this.bitsPerSample = t, this.samplesPerSec = n, this.channels = o, this.avgBytesPerSec = this.samplesPerSec * this.channels * (this.bitsPerSample / 8), this.blockAlign = this.channels * Math.max(this.bitsPerSample, 8), c) {
        this.privHeader = new ArrayBuffer(44);
        const d = new DataView(this.privHeader);
        this.setString(d, 0, "RIFF"), d.setUint32(4, 0, !0), this.setString(d, 8, "WAVEfmt "), d.setUint32(16, 16, !0), d.setUint16(20, this.formatTag, !0), d.setUint16(22, this.channels, !0), d.setUint32(24, this.samplesPerSec, !0), d.setUint32(28, this.avgBytesPerSec, !0), d.setUint16(32, this.channels * (this.bitsPerSample / 8), !0), d.setUint16(34, this.bitsPerSample, !0), this.setString(d, 36, "data"), d.setUint32(40, 0, !0);
      }
    }
    /**
     * Retrieves the default input format.
     * @member AudioStreamFormatImpl.getDefaultInputFormat
     * @function
     * @public
     * @returns {AudioStreamFormatImpl} The default input format.
     */
    static getDefaultInputFormat() {
      return new r();
    }
    /**
     * Creates an audio context appropriate to current browser
     * @member AudioStreamFormatImpl.getAudioContext
     * @function
     * @public
     * @returns {AudioContext} An audio context instance
     */
    /* eslint-disable */
    static getAudioContext(n) {
      const t = window.AudioContext || window.webkitAudioContext || !1;
      if (t)
        return n !== void 0 && navigator.mediaDevices.getSupportedConstraints().sampleRate ? new t({ sampleRate: n }) : new t();
      throw new Error("Browser does not support Web Audio API (AudioContext is not available).");
    }
    /* eslint-enable */
    /**
     * Closes the configuration object.
     * @member AudioStreamFormatImpl.prototype.close
     * @function
     * @public
     */
    close() {
    }
    get header() {
      return this.privHeader;
    }
    setString(n, t, o) {
      for (let l = 0; l < o.length; l++)
        n.setUint8(t + l, o.charCodeAt(l));
    }
  }
  s.AudioStreamFormatImpl = r;
})(ah);
var Zy;
function ux() {
  return Zy || (Zy = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.MicAudioSource = s.AudioWorkletSourceURLPropertyName = void 0;
    const a = wi(), i = Eo(), r = ah;
    s.AudioWorkletSourceURLPropertyName = "MICROPHONE-WorkletSourceUrl";
    class e {
      constructor(t, o, l, c) {
        this.privRecorder = t, this.deviceId = o, this.privStreams = {}, this.privOutputChunkSize = e.AUDIOFORMAT.avgBytesPerSec / 10, this.privId = l || i.createNoDashGuid(), this.privEvents = new i.EventSource(), this.privMediaStream = c || null, this.privIsClosing = !1;
      }
      get format() {
        return Promise.resolve(e.AUDIOFORMAT);
      }
      turnOn() {
        if (this.privInitializeDeferral)
          return this.privInitializeDeferral.promise;
        this.privInitializeDeferral = new i.Deferred();
        try {
          this.createAudioContext();
        } catch (l) {
          if (l instanceof Error) {
            const c = l;
            this.privInitializeDeferral.reject(c.name + ": " + c.message);
          } else
            this.privInitializeDeferral.reject(l);
          return this.privInitializeDeferral.promise;
        }
        const t = window.navigator;
        let o = (
          // eslint-disable-next-line
          t.getUserMedia || t.webkitGetUserMedia || t.mozGetUserMedia || t.msGetUserMedia
        );
        if (t.mediaDevices && (o = (l, c, d) => {
          t.mediaDevices.getUserMedia(l).then(c).catch(d);
        }), o) {
          const l = () => {
            this.onEvent(new i.AudioSourceInitializingEvent(this.privId)), this.privMediaStream && this.privMediaStream.active ? (this.onEvent(new i.AudioSourceReadyEvent(this.privId)), this.privInitializeDeferral.resolve()) : o({ audio: this.deviceId ? { deviceId: this.deviceId } : !0, video: !1 }, (c) => {
              this.privMediaStream = c, this.onEvent(new i.AudioSourceReadyEvent(this.privId)), this.privInitializeDeferral.resolve();
            }, (c) => {
              const d = `Error occurred during microphone initialization: ${c}`;
              this.privInitializeDeferral.reject(d), this.onEvent(new i.AudioSourceErrorEvent(this.privId, d));
            });
          };
          this.privContext.state === "suspended" ? this.privContext.resume().then(l).catch((c) => {
            this.privInitializeDeferral.reject(`Failed to initialize audio context: ${c}`);
          }) : l();
        } else {
          const l = "Browser does not support getUserMedia.";
          this.privInitializeDeferral.reject(l), this.onEvent(new i.AudioSourceErrorEvent(l, ""));
        }
        return this.privInitializeDeferral.promise;
      }
      id() {
        return this.privId;
      }
      attach(t) {
        return this.onEvent(new i.AudioStreamNodeAttachingEvent(this.privId, t)), this.listen(t).then((o) => (this.onEvent(new i.AudioStreamNodeAttachedEvent(this.privId, t)), {
          detach: async () => (o.readEnded(), delete this.privStreams[t], this.onEvent(new i.AudioStreamNodeDetachedEvent(this.privId, t)), this.turnOff()),
          id: () => t,
          read: () => o.read()
        }));
      }
      detach(t) {
        t && this.privStreams[t] && (this.privStreams[t].close(), delete this.privStreams[t], this.onEvent(new i.AudioStreamNodeDetachedEvent(this.privId, t)));
      }
      async turnOff() {
        for (const t in this.privStreams)
          if (t) {
            const o = this.privStreams[t];
            o && o.close();
          }
        this.onEvent(new i.AudioSourceOffEvent(this.privId)), this.privInitializeDeferral && (await this.privInitializeDeferral, this.privInitializeDeferral = null), await this.destroyAudioContext();
      }
      get events() {
        return this.privEvents;
      }
      get deviceInfo() {
        return this.getMicrophoneLabel().then((t) => ({
          bitspersample: e.AUDIOFORMAT.bitsPerSample,
          channelcount: e.AUDIOFORMAT.channels,
          connectivity: a.connectivity.Unknown,
          manufacturer: "Speech SDK",
          model: t,
          samplerate: e.AUDIOFORMAT.samplesPerSec,
          type: a.type.Microphones
        }));
      }
      setProperty(t, o) {
        if (t === s.AudioWorkletSourceURLPropertyName)
          this.privRecorder.setWorkletUrl(o);
        else
          throw new Error("Property '" + t + "' is not supported on Microphone.");
      }
      getMicrophoneLabel() {
        const t = "microphone";
        if (this.privMicrophoneLabel !== void 0)
          return Promise.resolve(this.privMicrophoneLabel);
        if (this.privMediaStream === void 0 || !this.privMediaStream.active)
          return Promise.resolve(t);
        this.privMicrophoneLabel = t;
        const o = this.privMediaStream.getTracks()[0].getSettings().deviceId;
        if (o === void 0)
          return Promise.resolve(this.privMicrophoneLabel);
        const l = new i.Deferred();
        return navigator.mediaDevices.enumerateDevices().then((c) => {
          for (const d of c)
            if (d.deviceId === o) {
              this.privMicrophoneLabel = d.label;
              break;
            }
          l.resolve(this.privMicrophoneLabel);
        }, () => l.resolve(this.privMicrophoneLabel)), l.promise;
      }
      async listen(t) {
        await this.turnOn();
        const o = new i.ChunkedArrayBufferStream(this.privOutputChunkSize, t);
        this.privStreams[t] = o;
        try {
          this.privRecorder.record(this.privContext, this.privMediaStream, o);
        } catch (c) {
          throw this.onEvent(new i.AudioStreamNodeErrorEvent(this.privId, t, c)), c;
        }
        return o;
      }
      onEvent(t) {
        this.privEvents.onEvent(t), i.Events.instance.onEvent(t);
      }
      createAudioContext() {
        this.privContext || (this.privContext = r.AudioStreamFormatImpl.getAudioContext(e.AUDIOFORMAT.samplesPerSec));
      }
      async destroyAudioContext() {
        if (!this.privContext)
          return;
        this.privRecorder.releaseMediaResources(this.privContext);
        let t = !1;
        "close" in this.privContext && (t = !0), t ? this.privIsClosing || (this.privIsClosing = !0, await this.privContext.close(), this.privContext = null, this.privIsClosing = !1) : this.privContext !== null && this.privContext.state === "running" && await this.privContext.suspend();
      }
    }
    s.MicAudioSource = e, e.AUDIOFORMAT = r.AudioStreamFormat.getDefaultInputFormat();
  }(Yv)), Yv;
}
var Hg = {}, Sy;
function hx() {
  if (Sy) return Hg;
  Sy = 1, Object.defineProperty(Hg, "__esModule", { value: !0 }), Hg.FileAudioSource = void 0;
  const s = wi(), a = Eo(), i = ah;
  let r = class {
    constructor(n, t, o) {
      this.privStreams = {}, this.privHeaderEnd = 44, this.privId = o || a.createNoDashGuid(), this.privEvents = new a.EventSource(), this.privSource = n, typeof window != "undefined" && typeof Blob != "undefined" && this.privSource instanceof Blob ? this.privFilename = n.name : this.privFilename = t || "unknown.wav", this.privAudioFormatPromise = this.readHeader();
    }
    get format() {
      return this.privAudioFormatPromise;
    }
    turnOn() {
      if (this.privFilename.lastIndexOf(".wav") !== this.privFilename.length - 4) {
        const n = this.privFilename + " is not supported. Only WAVE files are allowed at the moment.";
        return this.onEvent(new a.AudioSourceErrorEvent(n, "")), Promise.reject(n);
      }
      this.onEvent(new a.AudioSourceInitializingEvent(this.privId)), this.onEvent(new a.AudioSourceReadyEvent(this.privId));
    }
    id() {
      return this.privId;
    }
    async attach(n) {
      this.onEvent(new a.AudioStreamNodeAttachingEvent(this.privId, n));
      const t = await this.upload(n);
      return this.onEvent(new a.AudioStreamNodeAttachedEvent(this.privId, n)), Promise.resolve({
        detach: async () => {
          t.readEnded(), delete this.privStreams[n], this.onEvent(new a.AudioStreamNodeDetachedEvent(this.privId, n)), await this.turnOff();
        },
        id: () => n,
        read: () => t.read()
      });
    }
    detach(n) {
      n && this.privStreams[n] && (this.privStreams[n].close(), delete this.privStreams[n], this.onEvent(new a.AudioStreamNodeDetachedEvent(this.privId, n)));
    }
    turnOff() {
      for (const n in this.privStreams)
        if (n) {
          const t = this.privStreams[n];
          t && !t.isClosed && t.close();
        }
      return this.onEvent(new a.AudioSourceOffEvent(this.privId)), Promise.resolve();
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return this.privAudioFormatPromise.then((n) => Promise.resolve({
        bitspersample: n.bitsPerSample,
        channelcount: n.channels,
        connectivity: s.connectivity.Unknown,
        manufacturer: "Speech SDK",
        model: "File",
        samplerate: n.samplesPerSec,
        type: s.type.File
      }));
    }
    readHeader() {
      const t = this.privSource.slice(0, 4296), o = new a.Deferred(), l = (c) => {
        const d = new DataView(c), u = (v) => String.fromCharCode(d.getUint8(v), d.getUint8(v + 1), d.getUint8(v + 2), d.getUint8(v + 3));
        if (u(0) !== "RIFF") {
          o.reject("Invalid WAV header in file, RIFF was not found");
          return;
        }
        if (u(8) !== "WAVE" || u(12) !== "fmt ") {
          o.reject("Invalid WAV header in file, WAVEfmt was not found");
          return;
        }
        const h = d.getInt32(16, !0), A = d.getUint16(22, !0), g = d.getUint32(24, !0), f = d.getUint16(34, !0);
        let p = 36 + Math.max(h - 16, 0);
        for (; u(p) !== "data"; p += 2)
          if (p > 4288) {
            o.reject("Invalid WAV header in file, data block was not found");
            return;
          }
        this.privHeaderEnd = p + 8, o.resolve(i.AudioStreamFormat.getWaveFormatPCM(g, f, A));
      };
      if (typeof window != "undefined" && typeof Blob != "undefined" && t instanceof Blob) {
        const c = new FileReader();
        c.onload = (d) => {
          const u = d.target.result;
          l(u);
        }, c.readAsArrayBuffer(t);
      } else {
        const c = t;
        l(c.buffer.slice(c.byteOffset, c.byteOffset + c.byteLength));
      }
      return o.promise;
    }
    async upload(n) {
      const t = (o) => {
        const l = `Error occurred while processing '${this.privFilename}'. ${o}`;
        throw this.onEvent(new a.AudioStreamNodeErrorEvent(this.privId, n, l)), new Error(l);
      };
      try {
        await this.turnOn();
        const o = await this.privAudioFormatPromise, l = new a.ChunkedArrayBufferStream(o.avgBytesPerSec / 10, n);
        this.privStreams[n] = l;
        const c = this.privSource.slice(this.privHeaderEnd), d = (u) => {
          l.isClosed || (l.writeStreamChunk({
            buffer: u,
            isEnd: !1,
            timeReceived: Date.now()
          }), l.close());
        };
        if (typeof window != "undefined" && typeof Blob != "undefined" && c instanceof Blob) {
          const u = new FileReader();
          u.onerror = (h) => t(h.toString()), u.onload = (h) => {
            const A = h.target.result;
            d(A);
          }, u.readAsArrayBuffer(c);
        } else {
          const u = c;
          d(u.buffer.slice(u.byteOffset, u.byteOffset + u.byteLength));
        }
        return l;
      } catch (o) {
        t(o);
      }
    }
    onEvent(n) {
      this.privEvents.onEvent(n), a.Events.instance.onEvent(n);
    }
  };
  return Hg.FileAudioSource = r, Hg;
}
var x1 = {};
Object.defineProperty(x1, "__esModule", { value: !0 });
x1.PcmRecorder = void 0;
const Ax = Eo();
class gx {
  constructor(a) {
    this.privStopInputOnRelease = a;
  }
  record(a, i, r) {
    const n = new Ax.RiffPcmEncoder(a.sampleRate, 16e3), t = a.createMediaStreamSource(i), o = () => {
      const c = (() => {
        let d = 0;
        try {
          return a.createScriptProcessor(d, 1, 1);
        } catch {
          d = 2048;
          let h = a.sampleRate;
          for (; d < 16384 && h >= 32e3; )
            d <<= 1, h >>= 1;
          return a.createScriptProcessor(d, 1, 1);
        }
      })();
      c.onaudioprocess = (d) => {
        const u = d.inputBuffer.getChannelData(0);
        if (r && !r.isClosed) {
          const h = n.encode(u);
          h && r.writeStreamChunk({
            buffer: h,
            isEnd: !1,
            timeReceived: Date.now()
          });
        }
      }, t.connect(c), c.connect(a.destination), this.privMediaResources = {
        scriptProcessorNode: c,
        source: t,
        stream: i
      };
    }, l = !!this.privSpeechProcessorScript && this.privSpeechProcessorScript.toLowerCase() === "ignore";
    if (a.audioWorklet && !l) {
      if (!this.privSpeechProcessorScript) {
        const c = `class SP extends AudioWorkletProcessor {
                    constructor(options) {
                      super(options);
                    }
                    process(inputs, outputs) {
                      const input = inputs[0];
                      const output = [];
                      for (let channel = 0; channel < input.length; channel += 1) {
                        output[channel] = input[channel];
                      }
                      this.port.postMessage(output[0]);
                      return true;
                    }
                  }
                  registerProcessor('speech-processor', SP);`, d = new Blob([c], { type: "application/javascript; charset=utf-8" });
        this.privSpeechProcessorScript = URL.createObjectURL(d);
      }
      a.audioWorklet.addModule(this.privSpeechProcessorScript).then(() => {
        const c = new AudioWorkletNode(a, "speech-processor");
        c.port.onmessage = (d) => {
          const u = d.data;
          if (r && !r.isClosed) {
            const h = n.encode(u);
            h && r.writeStreamChunk({
              buffer: h,
              isEnd: !1,
              timeReceived: Date.now()
            });
          }
        }, t.connect(c), c.connect(a.destination), this.privMediaResources = {
          scriptProcessorNode: c,
          source: t,
          stream: i
        };
      }).catch(() => {
        o();
      });
    } else
      try {
        o();
      } catch (c) {
        throw new Error(`Unable to start audio worklet node for PCMRecorder: ${c}`);
      }
  }
  releaseMediaResources(a) {
    this.privMediaResources && (this.privMediaResources.scriptProcessorNode && (this.privMediaResources.scriptProcessorNode.disconnect(a.destination), this.privMediaResources.scriptProcessorNode = null), this.privMediaResources.source && (this.privMediaResources.source.disconnect(), this.privStopInputOnRelease && this.privMediaResources.stream.getTracks().forEach((i) => i.stop()), this.privMediaResources.source = null));
  }
  setWorkletUrl(a) {
    this.privSpeechProcessorScript = a;
  }
}
x1.PcmRecorder = gx;
var H1 = {}, im = {}, fx = Dn && Dn.__createBinding || (Object.create ? function(s, a, i, r) {
  r === void 0 && (r = i), Object.defineProperty(s, r, { enumerable: !0, get: function() {
    return a[i];
  } });
} : function(s, a, i, r) {
  r === void 0 && (r = i), s[r] = a[i];
}), px = Dn && Dn.__setModuleDefault || (Object.create ? function(s, a) {
  Object.defineProperty(s, "default", { enumerable: !0, value: a });
} : function(s, a) {
  s.default = a;
}), jB = Dn && Dn.__importStar || function(s) {
  if (s && s.__esModule) return s;
  var a = {};
  if (s != null) for (var i in s) i !== "default" && Object.hasOwnProperty.call(s, i) && fx(a, s, i);
  return px(a, s), a;
}, aF = Dn && Dn.__importDefault || function(s) {
  return s && s.__esModule ? s : { default: s };
};
Object.defineProperty(im, "__esModule", { value: !0 });
im.WebsocketMessageAdapter = void 0;
const mx = jB(nA), vx = jB(nA), bx = aF(nA), Fx = aF(nA), Rx = aF(nA), yx = Tc, Aa = Eo();
class Hp {
  constructor(a, i, r, e, n, t) {
    if (!a)
      throw new Aa.ArgumentNullError("uri");
    if (!r)
      throw new Aa.ArgumentNullError("messageFormatter");
    this.proxyInfo = e, this.privConnectionEvents = new Aa.EventSource(), this.privConnectionId = i, this.privMessageFormatter = r, this.privConnectionState = Aa.ConnectionState.None, this.privUri = a, this.privHeaders = n, this.privEnableCompression = t, this.privHeaders[yx.HeaderNames.ConnectionId] = this.privConnectionId, this.privLastErrorReceived = "";
  }
  get state() {
    return this.privConnectionState;
  }
  open() {
    if (this.privConnectionState === Aa.ConnectionState.Disconnected)
      return Promise.reject(`Cannot open a connection that is in ${this.privConnectionState} state`);
    if (this.privConnectionEstablishDeferral)
      return this.privConnectionEstablishDeferral.promise;
    this.privConnectionEstablishDeferral = new Aa.Deferred(), this.privCertificateValidatedDeferral = new Aa.Deferred(), this.privConnectionState = Aa.ConnectionState.Connecting;
    try {
      if (typeof WebSocket != "undefined" && !Hp.forceNpmWebSocket)
        this.privCertificateValidatedDeferral.resolve(), this.privWebsocketClient = new WebSocket(this.privUri);
      else {
        const a = { headers: this.privHeaders, perMessageDeflate: this.privEnableCompression };
        this.privCertificateValidatedDeferral.resolve(), a.agent = this.getAgent();
        let r = new URL(this.privUri).protocol;
        (r == null ? void 0 : r.toLocaleLowerCase()) === "wss:" ? r = "https:" : (r == null ? void 0 : r.toLocaleLowerCase()) === "ws:" && (r = "http:"), a.agent.protocol = r, this.privWebsocketClient = new Rx.default(this.privUri, a);
      }
      this.privWebsocketClient.binaryType = "arraybuffer", this.privReceivingMessageQueue = new Aa.Queue(), this.privDisconnectDeferral = new Aa.Deferred(), this.privSendMessageQueue = new Aa.Queue(), this.processSendQueue().catch((a) => {
        Aa.Events.instance.onEvent(new Aa.BackgroundEvent(a));
      });
    } catch (a) {
      return this.privConnectionEstablishDeferral.resolve(new Aa.ConnectionOpenResponse(500, a)), this.privConnectionEstablishDeferral.promise;
    }
    return this.onEvent(new Aa.ConnectionStartEvent(this.privConnectionId, this.privUri)), this.privWebsocketClient.onopen = () => {
      this.privCertificateValidatedDeferral.promise.then(() => {
        this.privConnectionState = Aa.ConnectionState.Connected, this.onEvent(new Aa.ConnectionEstablishedEvent(this.privConnectionId)), this.privConnectionEstablishDeferral.resolve(new Aa.ConnectionOpenResponse(200, ""));
      }, (a) => {
        this.privConnectionEstablishDeferral.reject(a);
      });
    }, this.privWebsocketClient.onerror = (a) => {
      this.onEvent(new Aa.ConnectionErrorEvent(this.privConnectionId, a.message, a.type)), this.privLastErrorReceived = a.message;
    }, this.privWebsocketClient.onclose = (a) => {
      this.privConnectionState === Aa.ConnectionState.Connecting ? (this.privConnectionState = Aa.ConnectionState.Disconnected, this.privConnectionEstablishDeferral.resolve(new Aa.ConnectionOpenResponse(a.code, a.reason + " " + this.privLastErrorReceived))) : (this.privConnectionState = Aa.ConnectionState.Disconnected, this.privWebsocketClient = null, this.onEvent(new Aa.ConnectionClosedEvent(this.privConnectionId, a.code, a.reason))), this.onClose(a.code, a.reason).catch((i) => {
        Aa.Events.instance.onEvent(new Aa.BackgroundEvent(i));
      });
    }, this.privWebsocketClient.onmessage = (a) => {
      const i = (/* @__PURE__ */ new Date()).toISOString();
      if (this.privConnectionState === Aa.ConnectionState.Connected) {
        const r = new Aa.Deferred();
        if (this.privReceivingMessageQueue.enqueueFromPromise(r.promise), a.data instanceof ArrayBuffer) {
          const e = new Aa.RawWebsocketMessage(Aa.MessageType.Binary, a.data);
          this.privMessageFormatter.toConnectionMessage(e).then((n) => {
            this.onEvent(new Aa.ConnectionMessageReceivedEvent(this.privConnectionId, i, n)), r.resolve(n);
          }, (n) => {
            r.reject(`Invalid binary message format. Error: ${n}`);
          });
        } else {
          const e = new Aa.RawWebsocketMessage(Aa.MessageType.Text, a.data);
          this.privMessageFormatter.toConnectionMessage(e).then((n) => {
            this.onEvent(new Aa.ConnectionMessageReceivedEvent(this.privConnectionId, i, n)), r.resolve(n);
          }, (n) => {
            r.reject(`Invalid text message format. Error: ${n}`);
          });
        }
      }
    }, this.privConnectionEstablishDeferral.promise;
  }
  send(a) {
    if (this.privConnectionState !== Aa.ConnectionState.Connected)
      return Promise.reject(`Cannot send on connection that is in ${Aa.ConnectionState[this.privConnectionState]} state`);
    const i = new Aa.Deferred(), r = new Aa.Deferred();
    return this.privSendMessageQueue.enqueueFromPromise(r.promise), this.privMessageFormatter.fromConnectionMessage(a).then((e) => {
      r.resolve({
        Message: a,
        RawWebsocketMessage: e,
        sendStatusDeferral: i
      });
    }, (e) => {
      r.reject(`Error formatting the message. ${e}`);
    }), i.promise;
  }
  read() {
    return this.privConnectionState !== Aa.ConnectionState.Connected ? Promise.reject(`Cannot read on connection that is in ${this.privConnectionState} state`) : this.privReceivingMessageQueue.dequeue();
  }
  close(a) {
    if (this.privWebsocketClient)
      this.privConnectionState !== Aa.ConnectionState.Disconnected && this.privWebsocketClient.close(1e3, a || "Normal closure by client");
    else
      return Promise.resolve();
    return this.privDisconnectDeferral.promise;
  }
  get events() {
    return this.privConnectionEvents;
  }
  sendRawMessage(a) {
    try {
      if (!a)
        return Promise.resolve();
      if (this.onEvent(new Aa.ConnectionMessageSentEvent(this.privConnectionId, (/* @__PURE__ */ new Date()).toISOString(), a.Message)), this.isWebsocketOpen)
        this.privWebsocketClient.send(a.RawWebsocketMessage.payload);
      else
        return Promise.reject("websocket send error: Websocket not ready " + this.privConnectionId + " " + a.Message.id + " " + new Error().stack);
      return Promise.resolve();
    } catch (i) {
      return Promise.reject(`websocket send error: ${i}`);
    }
  }
  async onClose(a, i) {
    const r = `Connection closed. ${a}: ${i}`;
    this.privConnectionState = Aa.ConnectionState.Disconnected, this.privDisconnectDeferral.resolve(), await this.privReceivingMessageQueue.drainAndDispose(() => {
    }, r), await this.privSendMessageQueue.drainAndDispose((e) => {
      e.sendStatusDeferral.reject(r);
    }, r);
  }
  async processSendQueue() {
    for (; ; ) {
      const i = await this.privSendMessageQueue.dequeue();
      if (!i)
        return;
      try {
        await this.sendRawMessage(i), i.sendStatusDeferral.resolve();
      } catch (r) {
        i.sendStatusDeferral.reject(r);
      }
    }
  }
  onEvent(a) {
    this.privConnectionEvents.onEvent(a), Aa.Events.instance.onEvent(a);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getAgent() {
    const a = new bx.default.Agent(this.createConnection);
    return this.proxyInfo !== void 0 && this.proxyInfo.HostName !== void 0 && this.proxyInfo.Port > 0 && (a.proxyInfo = this.proxyInfo), a;
  }
  static GetProxyAgent(a) {
    const i = {
      host: a.HostName,
      port: a.Port
    };
    return a.UserName ? i.headers = {
      "Proxy-Authentication": "Basic " + new Buffer(`${a.UserName}:${a.Password === void 0 ? "" : a.Password}`).toString("base64")
    } : i.headers = {}, i.headers.requestOCSP = "true", new Fx.default(i);
  }
  createConnection(a, i) {
    let r;
    if (i = {
      ...i,
      requestOCSP: !0,
      servername: i.host
    }, this.proxyInfo) {
      const n = Hp.GetProxyAgent(this.proxyInfo);
      r = new Promise((t, o) => {
        n.callback(a, i, (l, c) => {
          l ? o(l) : t(c);
        });
      });
    } else
      i.secureEndpoint ? r = Promise.resolve(vx.connect(i)) : r = Promise.resolve(mx.connect(i));
    return r;
  }
  get isWebsocketOpen() {
    return this.privWebsocketClient && this.privWebsocketClient.readyState === this.privWebsocketClient.OPEN;
  }
}
im.WebsocketMessageAdapter = Hp;
Hp.forceNpmWebSocket = !1;
Object.defineProperty(H1, "__esModule", { value: !0 });
H1.WebsocketConnection = void 0;
const Lv = Eo(), Qx = im;
class Cx {
  constructor(a, i, r, e, n, t = !1, o) {
    if (this.privIsDisposed = !1, !a)
      throw new Lv.ArgumentNullError("uri");
    if (!e)
      throw new Lv.ArgumentNullError("messageFormatter");
    this.privMessageFormatter = e;
    let l = "", c = 0;
    if (i) {
      for (const d in i)
        if (d) {
          l += c === 0 && a.indexOf("?") === -1 ? "?" : "&";
          const u = encodeURIComponent(d);
          l += u;
          let h = i[d];
          h && (h = encodeURIComponent(h), l += `=${h}`), c++;
        }
    }
    if (r) {
      for (const d in r)
        if (d) {
          l += c === 0 && a.indexOf("?") === -1 ? "?" : "&";
          const u = encodeURIComponent(r[d]);
          l += `${d}=${u}`, c++;
        }
    }
    this.privUri = a + l, this.privId = o || Lv.createNoDashGuid(), this.privConnectionMessageAdapter = new Qx.WebsocketMessageAdapter(this.privUri, this.id, this.privMessageFormatter, n, r, t);
  }
  async dispose() {
    this.privIsDisposed = !0, this.privConnectionMessageAdapter && await this.privConnectionMessageAdapter.close();
  }
  isDisposed() {
    return this.privIsDisposed;
  }
  get id() {
    return this.privId;
  }
  get uri() {
    return this.privUri;
  }
  state() {
    return this.privConnectionMessageAdapter.state;
  }
  open() {
    return this.privConnectionMessageAdapter.open();
  }
  send(a) {
    return this.privConnectionMessageAdapter.send(a);
  }
  read() {
    return this.privConnectionMessageAdapter.read();
  }
  get events() {
    return this.privConnectionMessageAdapter.events;
  }
}
H1.WebsocketConnection = Cx;
var P1 = {};
Object.defineProperty(P1, "__esModule", { value: !0 });
P1.ReplayableAudioNode = void 0;
class Ux {
  constructor(a, i) {
    this.privBuffers = [], this.privReplayOffset = 0, this.privLastShrinkOffset = 0, this.privBufferStartOffset = 0, this.privBufferSerial = 0, this.privBufferedBytes = 0, this.privReplay = !1, this.privLastChunkAcquiredTime = 0, this.privAudioNode = a, this.privBytesPerSecond = i;
  }
  id() {
    return this.privAudioNode.id();
  }
  // Reads and returns the next chunk of audio buffer.
  // If replay of existing buffers are needed, read() will first seek and replay
  // existing content, and upoin completion it will read new content from the underlying
  // audio node, saving that content into the replayable buffers.
  read() {
    if (this.privReplay && this.privBuffers.length !== 0) {
      const a = this.privReplayOffset - this.privBufferStartOffset;
      let i = Math.round(a * this.privBytesPerSecond * 1e-7);
      i % 2 !== 0 && i++;
      let r = 0;
      for (; r < this.privBuffers.length && i >= this.privBuffers[r].chunk.buffer.byteLength; )
        i -= this.privBuffers[r++].chunk.buffer.byteLength;
      if (r < this.privBuffers.length) {
        const e = this.privBuffers[r].chunk.buffer.slice(i);
        return this.privReplayOffset += e.byteLength / this.privBytesPerSecond * 1e7, r === this.privBuffers.length - 1 && (this.privReplay = !1), Promise.resolve({
          buffer: e,
          isEnd: !1,
          timeReceived: this.privBuffers[r].chunk.timeReceived
        });
      }
    }
    return this.privAudioNode.read().then((a) => (a && a.buffer && (this.privBuffers.push(new Ix(a, this.privBufferSerial++, this.privBufferedBytes)), this.privBufferedBytes += a.buffer.byteLength), a));
  }
  detach() {
    return this.privBuffers = void 0, this.privAudioNode.detach();
  }
  replay() {
    this.privBuffers && this.privBuffers.length !== 0 && (this.privReplay = !0, this.privReplayOffset = this.privLastShrinkOffset);
  }
  // Shrinks the existing audio buffers to start at the new offset, or at the
  // beginning of the buffer closest to the requested offset.
  // A replay request will start from the last shrink point.
  shrinkBuffers(a) {
    if (this.privBuffers === void 0 || this.privBuffers.length === 0)
      return;
    this.privLastShrinkOffset = a;
    const i = a - this.privBufferStartOffset;
    let r = Math.round(i * this.privBytesPerSecond * 1e-7), e = 0;
    for (; e < this.privBuffers.length && r >= this.privBuffers[e].chunk.buffer.byteLength; )
      r -= this.privBuffers[e++].chunk.buffer.byteLength;
    this.privBufferStartOffset = Math.round(a - r / this.privBytesPerSecond * 1e7), this.privBuffers = this.privBuffers.slice(e);
  }
  // Finds the time a buffer of audio was first seen by offset.
  findTimeAtOffset(a) {
    if (a < this.privBufferStartOffset || this.privBuffers === void 0)
      return 0;
    for (const i of this.privBuffers) {
      const r = i.byteOffset / this.privBytesPerSecond * 1e7, e = r + i.chunk.buffer.byteLength / this.privBytesPerSecond * 1e7;
      if (a >= r && a <= e)
        return i.chunk.timeReceived;
    }
    return 0;
  }
}
P1.ReplayableAudioNode = Ux;
class Ix {
  constructor(a, i, r) {
    this.chunk = a, this.serial = i, this.byteOffset = r;
  }
}
var Pg = {}, xv = {}, A0 = {}, om = {}, Bx = Dn && Dn.__createBinding || (Object.create ? function(s, a, i, r) {
  r === void 0 && (r = i), Object.defineProperty(s, r, { enumerable: !0, get: function() {
    return a[i];
  } });
} : function(s, a, i, r) {
  r === void 0 && (r = i), s[r] = a[i];
}), Zx = Dn && Dn.__setModuleDefault || (Object.create ? function(s, a) {
  Object.defineProperty(s, "default", { enumerable: !0, value: a });
} : function(s, a) {
  s.default = a;
}), Sx = Dn && Dn.__importStar || function(s) {
  if (s && s.__esModule) return s;
  var a = {};
  if (s != null) for (var i in s) i !== "default" && Object.hasOwnProperty.call(s, i) && Bx(a, s, i);
  return Zx(a, s), a;
};
Object.defineProperty(om, "__esModule", { value: !0 });
om.AudioFileWriter = void 0;
const Og = Sx(nA), Hv = _o;
class Ex {
  constructor(a) {
    Hv.Contracts.throwIfNullOrUndefined(Og.openSync, `
File System access not available, please use Push or PullAudioOutputStream`), this.privFd = Og.openSync(a, "w");
  }
  set format(a) {
    Hv.Contracts.throwIfNotUndefined(this.privAudioFormat, "format is already set"), this.privAudioFormat = a;
    let i = 0;
    this.privAudioFormat.hasHeader && (i = this.privAudioFormat.header.byteLength), this.privFd !== void 0 && (this.privWriteStream = Og.createWriteStream("", { fd: this.privFd, start: i, autoClose: !1 }));
  }
  write(a) {
    Hv.Contracts.throwIfNullOrUndefined(this.privAudioFormat, "must set format before writing."), this.privWriteStream !== void 0 && this.privWriteStream.write(new Uint8Array(a.slice(0)));
  }
  close() {
    this.privFd !== void 0 && (this.privWriteStream.on("finish", () => {
      this.privAudioFormat.hasHeader && (this.privAudioFormat.updateHeader(this.privWriteStream.bytesWritten), Og.writeSync(this.privFd, new Int8Array(this.privAudioFormat.header), 0, this.privAudioFormat.header.byteLength, 0)), Og.closeSync(this.privFd), this.privFd = void 0;
    }), this.privWriteStream.end());
  }
  id() {
    return this.privId;
  }
}
om.AudioFileWriter = Ex;
var nu = {}, Ey;
function _B() {
  if (Ey) return nu;
  Ey = 1, Object.defineProperty(nu, "__esModule", { value: !0 }), nu.PullAudioInputStreamImpl = nu.PullAudioInputStream = nu.PushAudioInputStreamImpl = nu.PushAudioInputStream = nu.AudioInputStream = void 0;
  const s = wi(), a = Eo(), i = hu, r = Hr(), e = ah;
  let n = class {
    /**
     * Creates and initializes an instance.
     * @constructor
     */
    constructor() {
    }
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member AudioInputStream.createPushStream
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * written to the push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The audio input stream being created.
     */
    static createPushStream(u) {
      return t.create(u);
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for read()
     * and close() methods.
     * @member AudioInputStream.createPullStream
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object, derived from
     * PullAudioInputStreamCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be returned from
     * the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The audio input stream being created.
     */
    static createPullStream(u, h) {
      return l.create(u, h);
    }
  };
  nu.AudioInputStream = n;
  class t extends n {
    /**
     * Creates a memory backed PushAudioInputStream with the specified audio format.
     * @member PushAudioInputStream.create
     * @function
     * @public
     * @param {AudioStreamFormat} format - The audio data format in which audio will be written to the
     * push audio stream's write() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PushAudioInputStream} The push audio input stream being created.
     */
    static create(u) {
      return new o(u);
    }
  }
  nu.PushAudioInputStream = t;
  class o extends t {
    /**
     * Creates and initalizes an instance with the given values.
     * @constructor
     * @param {AudioStreamFormat} format - The audio stream format.
     */
    constructor(u) {
      super(), u === void 0 ? this.privFormat = e.AudioStreamFormatImpl.getDefaultInputFormat() : this.privFormat = u, this.privEvents = new a.EventSource(), this.privId = i.createNoDashGuid(), this.privStream = new a.ChunkedArrayBufferStream(this.privFormat.avgBytesPerSec / 10);
    }
    /**
     * Format information for the audio
     */
    get format() {
      return Promise.resolve(this.privFormat);
    }
    /**
     * Writes the audio data specified by making an internal copy of the data.
     * @member PushAudioInputStreamImpl.prototype.write
     * @function
     * @public
     * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
     */
    write(u) {
      this.privStream.writeStreamChunk({
        buffer: u,
        isEnd: !1,
        timeReceived: Date.now()
      });
    }
    /**
     * Closes the stream.
     * @member PushAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */
    close() {
      this.privStream.close();
    }
    id() {
      return this.privId;
    }
    turnOn() {
      this.onEvent(new a.AudioSourceInitializingEvent(this.privId)), this.onEvent(new a.AudioSourceReadyEvent(this.privId));
    }
    async attach(u) {
      this.onEvent(new a.AudioStreamNodeAttachingEvent(this.privId, u)), await this.turnOn();
      const h = this.privStream;
      return this.onEvent(new a.AudioStreamNodeAttachedEvent(this.privId, u)), {
        detach: async () => (this.onEvent(new a.AudioStreamNodeDetachedEvent(this.privId, u)), this.turnOff()),
        id: () => u,
        read: () => h.read()
      };
    }
    detach(u) {
      this.onEvent(new a.AudioStreamNodeDetachedEvent(this.privId, u));
    }
    turnOff() {
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return Promise.resolve({
        bitspersample: this.privFormat.bitsPerSample,
        channelcount: this.privFormat.channels,
        connectivity: s.connectivity.Unknown,
        manufacturer: "Speech SDK",
        model: "PushStream",
        samplerate: this.privFormat.samplesPerSec,
        type: s.type.Stream
      });
    }
    onEvent(u) {
      this.privEvents.onEvent(u), a.Events.instance.onEvent(u);
    }
    toBuffer(u) {
      const h = Buffer.alloc(u.byteLength), A = new Uint8Array(u);
      for (let g = 0; g < h.length; ++g)
        h[g] = A[g];
      return h;
    }
  }
  nu.PushAudioInputStreamImpl = o;
  class l extends n {
    /**
     * Creates and initializes and instance.
     * @constructor
     */
    constructor() {
      super();
    }
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @member PullAudioInputStream.create
     * @function
     * @public
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     * @returns {PullAudioInputStream} The push audio input stream being created.
     */
    static create(u, h) {
      return new c(u, h);
    }
  }
  nu.PullAudioInputStream = l;
  class c extends l {
    /**
     * Creates a PullAudioInputStream that delegates to the specified callback interface for
     * read() and close() methods, using the default format (16 kHz 16bit mono PCM).
     * @constructor
     * @param {PullAudioInputStreamCallback} callback - The custom audio input object,
     * derived from PullAudioInputStreamCustomCallback
     * @param {AudioStreamFormat} format - The audio data format in which audio will be
     * returned from the callback's read() method (Required if format is not 16 kHz 16bit mono PCM).
     */
    constructor(u, h) {
      super(), h === void 0 ? this.privFormat = r.AudioStreamFormat.getDefaultInputFormat() : this.privFormat = h, this.privEvents = new a.EventSource(), this.privId = i.createNoDashGuid(), this.privCallback = u, this.privIsClosed = !1, this.privBufferSize = this.privFormat.avgBytesPerSec / 10;
    }
    /**
     * Format information for the audio
     */
    get format() {
      return Promise.resolve(this.privFormat);
    }
    /**
     * Closes the stream.
     * @member PullAudioInputStreamImpl.prototype.close
     * @function
     * @public
     */
    close() {
      this.privIsClosed = !0, this.privCallback.close();
    }
    id() {
      return this.privId;
    }
    turnOn() {
      this.onEvent(new a.AudioSourceInitializingEvent(this.privId)), this.onEvent(new a.AudioSourceReadyEvent(this.privId));
    }
    async attach(u) {
      return this.onEvent(new a.AudioStreamNodeAttachingEvent(this.privId, u)), await this.turnOn(), this.onEvent(new a.AudioStreamNodeAttachedEvent(this.privId, u)), {
        detach: () => (this.privCallback.close(), this.onEvent(new a.AudioStreamNodeDetachedEvent(this.privId, u)), this.turnOff()),
        id: () => u,
        read: () => {
          let h = 0, A;
          for (; h < this.privBufferSize; ) {
            const g = new ArrayBuffer(this.privBufferSize - h), f = this.privCallback.read(g);
            if (A === void 0 ? A = g : new Int8Array(A).set(new Int8Array(g), h), f === 0)
              break;
            h += f;
          }
          return Promise.resolve({
            buffer: A.slice(0, h),
            isEnd: this.privIsClosed || h === 0,
            timeReceived: Date.now()
          });
        }
      };
    }
    detach(u) {
      this.onEvent(new a.AudioStreamNodeDetachedEvent(this.privId, u));
    }
    turnOff() {
    }
    get events() {
      return this.privEvents;
    }
    get deviceInfo() {
      return Promise.resolve({
        bitspersample: this.privFormat.bitsPerSample,
        channelcount: this.privFormat.channels,
        connectivity: s.connectivity.Unknown,
        manufacturer: "Speech SDK",
        model: "PullStream",
        samplerate: this.privFormat.samplesPerSec,
        type: s.type.Stream
      });
    }
    onEvent(u) {
      this.privEvents.onEvent(u), a.Events.instance.onEvent(u);
    }
  }
  return nu.PullAudioInputStreamImpl = c, nu;
}
var jc = {}, sh = {}, sF = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.SpeechSynthesisOutputFormat = void 0, function(a) {
    a[a.Raw8Khz8BitMonoMULaw = 0] = "Raw8Khz8BitMonoMULaw", a[a.Riff16Khz16KbpsMonoSiren = 1] = "Riff16Khz16KbpsMonoSiren", a[a.Audio16Khz16KbpsMonoSiren = 2] = "Audio16Khz16KbpsMonoSiren", a[a.Audio16Khz32KBitRateMonoMp3 = 3] = "Audio16Khz32KBitRateMonoMp3", a[a.Audio16Khz128KBitRateMonoMp3 = 4] = "Audio16Khz128KBitRateMonoMp3", a[a.Audio16Khz64KBitRateMonoMp3 = 5] = "Audio16Khz64KBitRateMonoMp3", a[a.Audio24Khz48KBitRateMonoMp3 = 6] = "Audio24Khz48KBitRateMonoMp3", a[a.Audio24Khz96KBitRateMonoMp3 = 7] = "Audio24Khz96KBitRateMonoMp3", a[a.Audio24Khz160KBitRateMonoMp3 = 8] = "Audio24Khz160KBitRateMonoMp3", a[a.Raw16Khz16BitMonoTrueSilk = 9] = "Raw16Khz16BitMonoTrueSilk", a[a.Riff16Khz16BitMonoPcm = 10] = "Riff16Khz16BitMonoPcm", a[a.Riff8Khz16BitMonoPcm = 11] = "Riff8Khz16BitMonoPcm", a[a.Riff24Khz16BitMonoPcm = 12] = "Riff24Khz16BitMonoPcm", a[a.Riff8Khz8BitMonoMULaw = 13] = "Riff8Khz8BitMonoMULaw", a[a.Raw16Khz16BitMonoPcm = 14] = "Raw16Khz16BitMonoPcm", a[a.Raw24Khz16BitMonoPcm = 15] = "Raw24Khz16BitMonoPcm", a[a.Raw8Khz16BitMonoPcm = 16] = "Raw8Khz16BitMonoPcm", a[a.Ogg16Khz16BitMonoOpus = 17] = "Ogg16Khz16BitMonoOpus", a[a.Ogg24Khz16BitMonoOpus = 18] = "Ogg24Khz16BitMonoOpus", a[a.Raw48Khz16BitMonoPcm = 19] = "Raw48Khz16BitMonoPcm", a[a.Riff48Khz16BitMonoPcm = 20] = "Riff48Khz16BitMonoPcm", a[a.Audio48Khz96KBitRateMonoMp3 = 21] = "Audio48Khz96KBitRateMonoMp3", a[a.Audio48Khz192KBitRateMonoMp3 = 22] = "Audio48Khz192KBitRateMonoMp3", a[a.Ogg48Khz16BitMonoOpus = 23] = "Ogg48Khz16BitMonoOpus", a[a.Webm16Khz16BitMonoOpus = 24] = "Webm16Khz16BitMonoOpus", a[a.Webm24Khz16BitMonoOpus = 25] = "Webm24Khz16BitMonoOpus", a[a.Raw24Khz16BitMonoTrueSilk = 26] = "Raw24Khz16BitMonoTrueSilk", a[a.Raw8Khz8BitMonoALaw = 27] = "Raw8Khz8BitMonoALaw", a[a.Riff8Khz8BitMonoALaw = 28] = "Riff8Khz8BitMonoALaw", a[a.Webm24Khz16Bit24KbpsMonoOpus = 29] = "Webm24Khz16Bit24KbpsMonoOpus", a[a.Audio16Khz16Bit32KbpsMonoOpus = 30] = "Audio16Khz16Bit32KbpsMonoOpus", a[a.Audio24Khz16Bit48KbpsMonoOpus = 31] = "Audio24Khz16Bit48KbpsMonoOpus", a[a.Audio24Khz16Bit24KbpsMonoOpus = 32] = "Audio24Khz16Bit24KbpsMonoOpus", a[a.Raw22050Hz16BitMonoPcm = 33] = "Raw22050Hz16BitMonoPcm", a[a.Riff22050Hz16BitMonoPcm = 34] = "Riff22050Hz16BitMonoPcm", a[a.Raw44100Hz16BitMonoPcm = 35] = "Raw44100Hz16BitMonoPcm", a[a.Riff44100Hz16BitMonoPcm = 36] = "Riff44100Hz16BitMonoPcm", a[a.AmrWb16000Hz = 37] = "AmrWb16000Hz", a[a.G72216Khz64Kbps = 38] = "G72216Khz64Kbps";
  }(s.SpeechSynthesisOutputFormat || (s.SpeechSynthesisOutputFormat = {}));
})(sF);
Object.defineProperty(sh, "__esModule", { value: !0 });
sh.AudioOutputFormatImpl = void 0;
const Ja = sF, va = ah;
class Oo extends va.AudioStreamFormatImpl {
  /**
   * Creates an instance with the given values.
   * @constructor
   * @param formatTag
   * @param {number} channels - Number of channels.
   * @param {number} samplesPerSec - Samples per second.
   * @param {number} avgBytesPerSec - Average bytes per second.
   * @param {number} blockAlign - Block alignment.
   * @param {number} bitsPerSample - Bits per sample.
   * @param {string} audioFormatString - Audio format string
   * @param {string} requestAudioFormatString - Audio format string sent to service.
   * @param {boolean} hasHeader - If the format has header or not.
   */
  constructor(a, i, r, e, n, t, o, l, c) {
    super(r, t, i, a), this.formatTag = a, this.avgBytesPerSec = e, this.blockAlign = n, this.priAudioFormatString = o, this.priRequestAudioFormatString = l, this.priHasHeader = c;
  }
  static fromSpeechSynthesisOutputFormat(a) {
    return a === void 0 ? Oo.getDefaultOutputFormat() : Oo.fromSpeechSynthesisOutputFormatString(Oo.SpeechSynthesisOutputFormatToString[a]);
  }
  static fromSpeechSynthesisOutputFormatString(a) {
    switch (a) {
      case "raw-8khz-8bit-mono-mulaw":
        return new Oo(va.AudioFormatTag.MuLaw, 1, 8e3, 8e3, 1, 8, a, a, !1);
      case "riff-16khz-16kbps-mono-siren":
        return new Oo(va.AudioFormatTag.Siren, 1, 16e3, 2e3, 40, 0, a, "audio-16khz-16kbps-mono-siren", !0);
      case "audio-16khz-16kbps-mono-siren":
        return new Oo(va.AudioFormatTag.Siren, 1, 16e3, 2e3, 40, 0, a, a, !1);
      case "audio-16khz-32kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 16e3, 4096, 2, 16, a, a, !1);
      case "audio-16khz-128kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 16e3, 16384, 2, 16, a, a, !1);
      case "audio-16khz-64kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 16e3, 8192, 2, 16, a, a, !1);
      case "audio-24khz-48kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 24e3, 6144, 2, 16, a, a, !1);
      case "audio-24khz-96kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 24e3, 12288, 2, 16, a, a, !1);
      case "audio-24khz-160kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 24e3, 20480, 2, 16, a, a, !1);
      case "raw-16khz-16bit-mono-truesilk":
        return new Oo(va.AudioFormatTag.SILKSkype, 1, 16e3, 32e3, 2, 16, a, a, !1);
      case "riff-8khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 8e3, 16e3, 2, 16, a, "raw-8khz-16bit-mono-pcm", !0);
      case "riff-24khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 24e3, 48e3, 2, 16, a, "raw-24khz-16bit-mono-pcm", !0);
      case "riff-8khz-8bit-mono-mulaw":
        return new Oo(va.AudioFormatTag.MuLaw, 1, 8e3, 8e3, 1, 8, a, "raw-8khz-8bit-mono-mulaw", !0);
      case "raw-16khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 16e3, 32e3, 2, 16, a, "raw-16khz-16bit-mono-pcm", !1);
      case "raw-24khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 24e3, 48e3, 2, 16, a, "raw-24khz-16bit-mono-pcm", !1);
      case "raw-8khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 8e3, 16e3, 2, 16, a, "raw-8khz-16bit-mono-pcm", !1);
      case "ogg-16khz-16bit-mono-opus":
        return new Oo(va.AudioFormatTag.OGG_OPUS, 1, 16e3, 8192, 2, 16, a, a, !1);
      case "ogg-24khz-16bit-mono-opus":
        return new Oo(va.AudioFormatTag.OGG_OPUS, 1, 24e3, 8192, 2, 16, a, a, !1);
      case "raw-48khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 48e3, 96e3, 2, 16, a, "raw-48khz-16bit-mono-pcm", !1);
      case "riff-48khz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 48e3, 96e3, 2, 16, a, "raw-48khz-16bit-mono-pcm", !0);
      case "audio-48khz-96kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 48e3, 12288, 2, 16, a, a, !1);
      case "audio-48khz-192kbitrate-mono-mp3":
        return new Oo(va.AudioFormatTag.MP3, 1, 48e3, 24576, 2, 16, a, a, !1);
      case "ogg-48khz-16bit-mono-opus":
        return new Oo(va.AudioFormatTag.OGG_OPUS, 1, 48e3, 12e3, 2, 16, a, a, !1);
      case "webm-16khz-16bit-mono-opus":
        return new Oo(va.AudioFormatTag.WEBM_OPUS, 1, 16e3, 4e3, 2, 16, a, a, !1);
      case "webm-24khz-16bit-mono-opus":
        return new Oo(va.AudioFormatTag.WEBM_OPUS, 1, 24e3, 6e3, 2, 16, a, a, !1);
      case "webm-24khz-16bit-24kbps-mono-opus":
        return new Oo(va.AudioFormatTag.WEBM_OPUS, 1, 24e3, 3e3, 2, 16, a, a, !1);
      case "audio-16khz-16bit-32kbps-mono-opus":
        return new Oo(va.AudioFormatTag.OPUS, 1, 16e3, 4e3, 2, 16, a, a, !1);
      case "audio-24khz-16bit-48kbps-mono-opus":
        return new Oo(va.AudioFormatTag.OPUS, 1, 24e3, 6e3, 2, 16, a, a, !1);
      case "audio-24khz-16bit-24kbps-mono-opus":
        return new Oo(va.AudioFormatTag.OPUS, 1, 24e3, 3e3, 2, 16, a, a, !1);
      case "audio-24khz-16bit-mono-flac":
        return new Oo(va.AudioFormatTag.FLAC, 1, 24e3, 24e3, 2, 16, a, a, !1);
      case "audio-48khz-16bit-mono-flac":
        return new Oo(va.AudioFormatTag.FLAC, 1, 48e3, 3e4, 2, 16, a, a, !1);
      case "raw-24khz-16bit-mono-truesilk":
        return new Oo(va.AudioFormatTag.SILKSkype, 1, 24e3, 48e3, 2, 16, a, a, !1);
      case "raw-8khz-8bit-mono-alaw":
        return new Oo(va.AudioFormatTag.ALaw, 1, 8e3, 8e3, 1, 8, a, a, !1);
      case "riff-8khz-8bit-mono-alaw":
        return new Oo(va.AudioFormatTag.ALaw, 1, 8e3, 8e3, 1, 8, a, "raw-8khz-8bit-mono-alaw", !0);
      case "raw-22050hz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, a, a, !1);
      case "riff-22050hz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 22050, 44100, 2, 16, a, "raw-22050hz-16bit-mono-pcm", !0);
      case "raw-44100hz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, a, a, !1);
      case "riff-44100hz-16bit-mono-pcm":
        return new Oo(va.AudioFormatTag.PCM, 1, 44100, 88200, 2, 16, a, "raw-44100hz-16bit-mono-pcm", !0);
      case "amr-wb-16000h":
        return new Oo(va.AudioFormatTag.AMR_WB, 1, 16e3, 3052, 2, 16, a, a, !1);
      case "g722-16khz-64kbps":
        return new Oo(va.AudioFormatTag.G722, 1, 16e3, 8e3, 2, 16, a, a, !1);
      case "riff-16khz-16bit-mono-pcm":
      default:
        return new Oo(va.AudioFormatTag.PCM, 1, 16e3, 32e3, 2, 16, "riff-16khz-16bit-mono-pcm", "raw-16khz-16bit-mono-pcm", !0);
    }
  }
  static getDefaultOutputFormat() {
    return Oo.fromSpeechSynthesisOutputFormatString(typeof window != "undefined" ? "audio-24khz-48kbitrate-mono-mp3" : "riff-16khz-16bit-mono-pcm");
  }
  /**
   * Specifies if this audio output format has a header
   * @boolean AudioOutputFormatImpl.prototype.hasHeader
   * @function
   * @public
   */
  get hasHeader() {
    return this.priHasHeader;
  }
  /**
   * Specifies the header of this format
   * @ArrayBuffer AudioOutputFormatImpl.prototype.header
   * @function
   * @public
   */
  get header() {
    if (this.hasHeader)
      return this.privHeader;
  }
  /**
   * Updates the header based on the audio length
   * @member AudioOutputFormatImpl.updateHeader
   * @function
   * @public
   * @param {number} audioLength - the audio length
   */
  updateHeader(a) {
    if (this.priHasHeader) {
      const i = new DataView(this.privHeader);
      i.setUint32(4, a + this.privHeader.byteLength - 8, !0), i.setUint32(40, a, !0);
    }
  }
  /**
   * Specifies the audio format string to be sent to the service
   * @string AudioOutputFormatImpl.prototype.requestAudioFormatString
   * @function
   * @public
   */
  get requestAudioFormatString() {
    return this.priRequestAudioFormatString;
  }
  /**
   * Adds audio header
   * @param audio the raw audio without header
   * @returns the audio with header if applicable
   */
  addHeader(a) {
    if (!this.hasHeader)
      return a;
    this.updateHeader(a.byteLength);
    const i = new Uint8Array(a.byteLength + this.header.byteLength);
    return i.set(new Uint8Array(this.header), 0), i.set(new Uint8Array(a), this.header.byteLength), i.buffer;
  }
}
sh.AudioOutputFormatImpl = Oo;
Oo.SpeechSynthesisOutputFormatToString = {
  [Ja.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoMULaw]: "raw-8khz-8bit-mono-mulaw",
  [Ja.SpeechSynthesisOutputFormat.Riff16Khz16KbpsMonoSiren]: "riff-16khz-16kbps-mono-siren",
  [Ja.SpeechSynthesisOutputFormat.Audio16Khz16KbpsMonoSiren]: "audio-16khz-16kbps-mono-siren",
  [Ja.SpeechSynthesisOutputFormat.Audio16Khz32KBitRateMonoMp3]: "audio-16khz-32kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Audio16Khz128KBitRateMonoMp3]: "audio-16khz-128kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Audio16Khz64KBitRateMonoMp3]: "audio-16khz-64kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Audio24Khz48KBitRateMonoMp3]: "audio-24khz-48kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Audio24Khz96KBitRateMonoMp3]: "audio-24khz-96kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Audio24Khz160KBitRateMonoMp3]: "audio-24khz-160kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoTrueSilk]: "raw-16khz-16bit-mono-truesilk",
  [Ja.SpeechSynthesisOutputFormat.Riff16Khz16BitMonoPcm]: "riff-16khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Riff8Khz16BitMonoPcm]: "riff-8khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm]: "riff-24khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoMULaw]: "riff-8khz-8bit-mono-mulaw",
  [Ja.SpeechSynthesisOutputFormat.Raw16Khz16BitMonoPcm]: "raw-16khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoPcm]: "raw-24khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Raw8Khz16BitMonoPcm]: "raw-8khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Ogg16Khz16BitMonoOpus]: "ogg-16khz-16bit-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Ogg24Khz16BitMonoOpus]: "ogg-24khz-16bit-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Raw48Khz16BitMonoPcm]: "raw-48khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Riff48Khz16BitMonoPcm]: "riff-48khz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Audio48Khz96KBitRateMonoMp3]: "audio-48khz-96kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Audio48Khz192KBitRateMonoMp3]: "audio-48khz-192kbitrate-mono-mp3",
  [Ja.SpeechSynthesisOutputFormat.Ogg48Khz16BitMonoOpus]: "ogg-48khz-16bit-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Webm16Khz16BitMonoOpus]: "webm-16khz-16bit-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Webm24Khz16BitMonoOpus]: "webm-24khz-16bit-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Webm24Khz16Bit24KbpsMonoOpus]: "webm-24khz-16bit-24kbps-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Raw24Khz16BitMonoTrueSilk]: "raw-24khz-16bit-mono-truesilk",
  [Ja.SpeechSynthesisOutputFormat.Raw8Khz8BitMonoALaw]: "raw-8khz-8bit-mono-alaw",
  [Ja.SpeechSynthesisOutputFormat.Riff8Khz8BitMonoALaw]: "riff-8khz-8bit-mono-alaw",
  [Ja.SpeechSynthesisOutputFormat.Audio16Khz16Bit32KbpsMonoOpus]: "audio-16khz-16bit-32kbps-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Audio24Khz16Bit48KbpsMonoOpus]: "audio-24khz-16bit-48kbps-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Audio24Khz16Bit24KbpsMonoOpus]: "audio-24khz-16bit-24kbps-mono-opus",
  [Ja.SpeechSynthesisOutputFormat.Raw22050Hz16BitMonoPcm]: "raw-22050hz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Riff22050Hz16BitMonoPcm]: "riff-22050hz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Raw44100Hz16BitMonoPcm]: "raw-44100hz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.Riff44100Hz16BitMonoPcm]: "riff-44100hz-16bit-mono-pcm",
  [Ja.SpeechSynthesisOutputFormat.AmrWb16000Hz]: "amr-wb-16000hz",
  [Ja.SpeechSynthesisOutputFormat.G72216Khz64Kbps]: "g722-16khz-64kbps"
};
Object.defineProperty(jc, "__esModule", { value: !0 });
jc.PushAudioOutputStreamImpl = jc.PushAudioOutputStream = jc.PullAudioOutputStreamImpl = jc.PullAudioOutputStream = jc.AudioOutputStream = void 0;
const Nb = Eo(), Vx = _o, Wx = sh;
class lF {
  /**
   * Creates and initializes an instance.
   * @constructor
   */
  constructor() {
  }
  /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member AudioOutputStream.createPullStream
   * @function
   * @public
   * @returns {PullAudioOutputStream} The audio output stream being created.
   */
  static createPullStream() {
    return cF.create();
  }
}
jc.AudioOutputStream = lF;
class cF extends lF {
  /**
   * Creates a memory backed PullAudioOutputStream with the specified audio format.
   * @member PullAudioOutputStream.create
   * @function
   * @public
   * @returns {PullAudioOutputStream} The push audio output stream being created.
   */
  static create() {
    return new $B();
  }
}
jc.PullAudioOutputStream = cF;
class $B extends cF {
  /**
   * Creates and initializes an instance with the given values.
   * @constructor
   */
  constructor() {
    super(), this.privId = Nb.createNoDashGuid(), this.privStream = new Nb.Stream();
  }
  /**
   * Sets the format information to the stream. For internal use only.
   * @param {AudioStreamFormat} format - the format to be set.
   */
  set format(a) {
    a == null && (this.privFormat = Wx.AudioOutputFormatImpl.getDefaultOutputFormat()), this.privFormat = a;
  }
  /**
   * Format information for the audio
   */
  get format() {
    return this.privFormat;
  }
  /**
   * Checks if the stream is closed
   * @member PullAudioOutputStreamImpl.prototype.isClosed
   * @property
   * @public
   */
  get isClosed() {
    return this.privStream.isClosed;
  }
  /**
   * Gets the id of the stream
   * @member PullAudioOutputStreamImpl.prototype.id
   * @property
   * @public
   */
  id() {
    return this.privId;
  }
  /**
   * Reads audio data from the internal buffer.
   * @member PullAudioOutputStreamImpl.prototype.read
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - An ArrayBuffer to store the read data.
   * @returns {Promise<number>} - Audio buffer length has been read.
   */
  async read(a) {
    const i = new Int8Array(a);
    let r = 0;
    if (this.privLastChunkView !== void 0) {
      if (this.privLastChunkView.length > a.byteLength)
        return i.set(this.privLastChunkView.slice(0, a.byteLength)), this.privLastChunkView = this.privLastChunkView.slice(a.byteLength), Promise.resolve(a.byteLength);
      i.set(this.privLastChunkView), r = this.privLastChunkView.length, this.privLastChunkView = void 0;
    }
    for (; r < a.byteLength && !this.privStream.isReadEnded; ) {
      const e = await this.privStream.read();
      if (e !== void 0 && !e.isEnd) {
        let n;
        e.buffer.byteLength > a.byteLength - r ? (n = e.buffer.slice(0, a.byteLength - r), this.privLastChunkView = new Int8Array(e.buffer.slice(a.byteLength - r))) : n = e.buffer, i.set(new Int8Array(n), r), r += n.byteLength;
      } else
        this.privStream.readEnded();
    }
    return r;
  }
  /**
   * Writes the audio data specified by making an internal copy of the data.
   * @member PullAudioOutputStreamImpl.prototype.write
   * @function
   * @public
   * @param {ArrayBuffer} dataBuffer - The audio buffer of which this function will make a copy.
   */
  write(a) {
    Vx.Contracts.throwIfNullOrUndefined(this.privStream, "must set format before writing"), this.privStream.writeStreamChunk({
      buffer: a,
      isEnd: !1,
      timeReceived: Date.now()
    });
  }
  /**
   * Closes the stream.
   * @member PullAudioOutputStreamImpl.prototype.close
   * @function
   * @public
   */
  close() {
    this.privStream.close();
  }
}
jc.PullAudioOutputStreamImpl = $B;
class qB extends lF {
  /**
   * Creates and initializes and instance.
   * @constructor
   */
  constructor() {
    super();
  }
  /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * write() and close() methods.
   * @member PushAudioOutputStream.create
   * @function
   * @public
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   * derived from PushAudioOutputStreamCallback
   * @returns {PushAudioOutputStream} The push audio output stream being created.
   */
  static create(a) {
    return new eZ(a);
  }
}
jc.PushAudioOutputStream = qB;
class eZ extends qB {
  /**
   * Creates a PushAudioOutputStream that delegates to the specified callback interface for
   * read() and close() methods.
   * @constructor
   * @param {PushAudioOutputStreamCallback} callback - The custom audio output object,
   * derived from PushAudioOutputStreamCallback
   */
  constructor(a) {
    super(), this.privId = Nb.createNoDashGuid(), this.privCallback = a;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  set format(a) {
  }
  write(a) {
    this.privCallback.write && this.privCallback.write(a);
  }
  close() {
    this.privCallback.close && this.privCallback.close();
  }
  id() {
    return this.privId;
  }
}
jc.PushAudioOutputStreamImpl = eZ;
var Vy;
function nZ() {
  if (Vy) return A0;
  Vy = 1, Object.defineProperty(A0, "__esModule", { value: !0 }), A0.AudioOutputConfigImpl = A0.AudioConfigImpl = A0.AudioConfig = void 0;
  const s = Xc(), a = _o, i = Hr(), r = om, e = _B(), n = jc;
  let t = class tZ {
    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */
    static fromDefaultMicrophoneInput() {
      const d = new s.PcmRecorder(!0);
      return new o(new s.MicAudioSource(d));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     * Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */
    static fromMicrophoneInput(d) {
      const u = new s.PcmRecorder(!0);
      return new o(new s.MicAudioSource(u, d));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */
    static fromWavFileInput(d, u = "unnamedBuffer.wav") {
      return new o(new s.FileAudioSource(d, u));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback | MediaStream} audioStream - Specifies the custom audio input
     * stream. Currently, only WAV / PCM is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */
    static fromStreamInput(d) {
      if (d instanceof i.PullAudioInputStreamCallback)
        return new o(new e.PullAudioInputStreamImpl(d));
      if (d instanceof i.AudioInputStream)
        return new o(d);
      if (typeof MediaStream != "undefined" && d instanceof MediaStream) {
        const u = new s.PcmRecorder(!1);
        return new o(new s.MicAudioSource(u, null, null, d));
      }
      throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */
    static fromDefaultSpeakerOutput() {
      return new l(new i.SpeakerAudioDestination());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */
    static fromSpeakerOutput(d) {
      if (d === void 0)
        return tZ.fromDefaultSpeakerOutput();
      if (d instanceof i.SpeakerAudioDestination)
        return new l(d);
      throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */
    static fromAudioFileOutput(d) {
      return new l(new r.AudioFileWriter(d));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     * stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */
    static fromStreamOutput(d) {
      if (d instanceof i.PushAudioOutputStreamCallback)
        return new l(new n.PushAudioOutputStreamImpl(d));
      if (d instanceof i.PushAudioOutputStream)
        return new l(d);
      if (d instanceof i.PullAudioOutputStream)
        return new l(d);
      throw new Error("Not Supported Type");
    }
  };
  A0.AudioConfig = t;
  class o extends t {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioSource} source - An audio source.
     */
    constructor(d) {
      super(), this.privSource = d;
    }
    /**
     * Format information for the audio
     */
    get format() {
      return this.privSource.format;
    }
    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */
    close(d, u) {
      this.privSource.turnOff().then(() => {
        d && d();
      }, (h) => {
        u && u(h);
      });
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */
    id() {
      return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */
    turnOn() {
      return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */
    attach(d) {
      return this.privSource.attach(d);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */
    detach(d) {
      return this.privSource.detach(d);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<void>} A promise.
     */
    turnOff() {
      return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */
    get events() {
      return this.privSource.events;
    }
    setProperty(d, u) {
      if (a.Contracts.throwIfNull(u, "value"), this.privSource.setProperty !== void 0)
        this.privSource.setProperty(d, u);
      else
        throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty(d, u) {
      if (this.privSource.getProperty !== void 0)
        return this.privSource.getProperty(d, u);
      throw new Error("This AudioConfig instance does not support getting properties.");
    }
    get deviceInfo() {
      return this.privSource.deviceInfo;
    }
  }
  A0.AudioConfigImpl = o;
  class l extends t {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {IAudioDestination} destination - An audio destination.
     */
    constructor(d) {
      super(), this.privDestination = d;
    }
    set format(d) {
      this.privDestination.format = d;
    }
    write(d) {
      this.privDestination.write(d);
    }
    close() {
      this.privDestination.close();
    }
    id() {
      return this.privDestination.id();
    }
    setProperty() {
      throw new Error("This AudioConfig instance does not support setting properties.");
    }
    getProperty() {
      throw new Error("This AudioConfig instance does not support getting properties.");
    }
  }
  return A0.AudioOutputConfigImpl = l, A0;
}
var rZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.CancellationReason = void 0, function(a) {
    a[a.Error = 0] = "Error", a[a.EndOfStream = 1] = "EndOfStream";
  }(s.CancellationReason || (s.CancellationReason = {}));
})(rZ);
var O1 = {};
Object.defineProperty(O1, "__esModule", { value: !0 });
O1.PullAudioInputStreamCallback = void 0;
class Nx {
}
O1.PullAudioInputStreamCallback = Nx;
var K1 = {};
Object.defineProperty(K1, "__esModule", { value: !0 });
K1.PushAudioOutputStreamCallback = void 0;
class Jx {
}
K1.PushAudioOutputStreamCallback = Jx;
var z1 = {};
Object.defineProperty(z1, "__esModule", { value: !0 });
z1.KeywordRecognitionModel = void 0;
const Wy = _o;
class Gx {
  /**
   * Create and initializes a new instance.
   * @constructor
   */
  constructor() {
    this.privDisposed = !1;
  }
  /**
   * Creates a keyword recognition model using the specified filename.
   * @member KeywordRecognitionModel.fromFile
   * @function
   * @public
   * @param {string} fileName - A string that represents file name for the keyword recognition model.
   * Note, the file can point to a zip file in which case the model
   * will be extracted from the zip.
   * @returns {KeywordRecognitionModel} The keyword recognition model being created.
   */
  static fromFile(a) {
    throw Wy.Contracts.throwIfFileDoesNotExist(a, "fileName"), new Error("Not yet implemented.");
  }
  /**
   * Creates a keyword recognition model using the specified filename.
   * @member KeywordRecognitionModel.fromStream
   * @function
   * @public
   * @param {string} file - A File that represents file for the keyword recognition model.
   * Note, the file can point to a zip file in which case the model will be extracted from the zip.
   * @returns {KeywordRecognitionModel} The keyword recognition model being created.
   */
  static fromStream(a) {
    throw Wy.Contracts.throwIfNull(a, "file"), new Error("Not yet implemented.");
  }
  /**
   * Dispose of associated resources.
   * @member KeywordRecognitionModel.prototype.close
   * @function
   * @public
   */
  close() {
    this.privDisposed || (this.privDisposed = !0);
  }
}
z1.KeywordRecognitionModel = Gx;
var j1 = {};
Object.defineProperty(j1, "__esModule", { value: !0 });
j1.SessionEventArgs = void 0;
class Tx {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionId - The session id.
   */
  constructor(a) {
    this.privSessionId = a;
  }
  /**
   * Represents the session identifier.
   * @member SessionEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} Represents the session identifier.
   */
  get sessionId() {
    return this.privSessionId;
  }
}
j1.SessionEventArgs = Tx;
var Kg = {}, Ny;
function Xx() {
  if (Ny) return Kg;
  Ny = 1, Object.defineProperty(Kg, "__esModule", { value: !0 }), Kg.RecognitionEventArgs = void 0;
  const s = Hr();
  let a = class extends s.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */
    constructor(r, e) {
      super(e), this.privOffset = r;
    }
    /**
     * Represents the message offset
     * @member RecognitionEventArgs.prototype.offset
     * @function
     * @public
     */
    get offset() {
      return this.privOffset;
    }
  };
  return Kg.RecognitionEventArgs = a, Kg;
}
var iZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.OutputFormat = void 0, function(a) {
    a[a.Simple = 0] = "Simple", a[a.Detailed = 1] = "Detailed";
  }(s.OutputFormat || (s.OutputFormat = {}));
})(iZ);
var zg = {}, Jy;
function kx() {
  if (Jy) return zg;
  Jy = 1, Object.defineProperty(zg, "__esModule", { value: !0 }), zg.IntentRecognitionEventArgs = void 0;
  const s = Hr();
  let a = class extends s.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param result - The result of the intent recognition.
     * @param offset - The offset.
     * @param sessionId - The session id.
     */
    constructor(r, e, n) {
      super(e, n), this.privResult = r;
    }
    /**
     * Represents the intent recognition result.
     * @member IntentRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {IntentRecognitionResult} Represents the intent recognition result.
     */
    get result() {
      return this.privResult;
    }
  };
  return zg.IntentRecognitionEventArgs = a, zg;
}
var _1 = {};
Object.defineProperty(_1, "__esModule", { value: !0 });
_1.RecognitionResult = void 0;
class wx {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} language - Primary Language detected, if provided.
   * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  constructor(a, i, r, e, n, t, o, l, c, d) {
    this.privResultId = a, this.privReason = i, this.privText = r, this.privDuration = e, this.privOffset = n, this.privLanguage = t, this.privLanguageDetectionConfidence = o, this.privErrorDetails = l, this.privJson = c, this.privProperties = d;
  }
  /**
   * Specifies the result identifier.
   * @member RecognitionResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */
  get resultId() {
    return this.privResultId;
  }
  /**
   * Specifies status of the result.
   * @member RecognitionResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */
  get reason() {
    return this.privReason;
  }
  /**
   * Presents the recognized text in the result.
   * @member RecognitionResult.prototype.text
   * @function
   * @public
   * @returns {string} Presents the recognized text in the result.
   */
  get text() {
    return this.privText;
  }
  /**
   * Duration of recognized speech in 100 nano second increments.
   * @member RecognitionResult.prototype.duration
   * @function
   * @public
   * @returns {number} Duration of recognized speech in 100 nano second increments.
   */
  get duration() {
    return this.privDuration;
  }
  /**
   * Offset of recognized speech in 100 nano second increments.
   * @member RecognitionResult.prototype.offset
   * @function
   * @public
   * @returns {number} Offset of recognized speech in 100 nano second increments.
   */
  get offset() {
    return this.privOffset;
  }
  /**
   * Primary Language detected.
   * @member RecognitionResult.prototype.language
   * @function
   * @public
   * @returns {string} language detected.
   */
  get language() {
    return this.privLanguage;
  }
  /**
   * Primary Language detection confidence (Unknown, Low, Medium, High).
   * @member RecognitionResult.prototype.languageDetectionConfidence
   * @function
   * @public
   * @returns {string} detection confidence strength.
   */
  get languageDetectionConfidence() {
    return this.privLanguageDetectionConfidence;
  }
  /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member RecognitionResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
  /**
   * A string containing Json serialized recognition result as it was received from the service.
   * @member RecognitionResult.prototype.json
   * @function
   * @private
   * @returns {string} Json serialized representation of the result.
   */
  get json() {
    return this.privJson;
  }
  /**
   * The set of properties exposed in the result.
   * @member RecognitionResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */
  get properties() {
    return this.privProperties;
  }
}
_1.RecognitionResult = wx;
var jg = {}, Gy;
function Dx() {
  if (Gy) return jg;
  Gy = 1, Object.defineProperty(jg, "__esModule", { value: !0 }), jg.SpeechRecognitionResult = void 0;
  const s = Hr();
  let a = class extends s.RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription, if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */
    constructor(r, e, n, t, o, l, c, d, u, h, A) {
      super(r, e, n, t, o, l, c, u, h, A), this.privSpeakerId = d;
    }
    /**
     * speaker id from conversation transcription/id scenarios
     * @member SpeechRecognitionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */
    get speakerId() {
      return this.privSpeakerId;
    }
  };
  return jg.SpeechRecognitionResult = a, jg;
}
var _g = {}, Ty;
function Mx() {
  if (Ty) return _g;
  Ty = 1, Object.defineProperty(_g, "__esModule", { value: !0 }), _g.IntentRecognitionResult = void 0;
  const s = Hr();
  let a = class extends s.SpeechRecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param intentId - The intent id.
     * @param resultId - The result id.
     * @param reason - The reason.
     * @param text - The recognized text.
     * @param duration - The duration.
     * @param offset - The offset into the stream.
     * @param language - Primary Language detected, if provided.
     * @param languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param errorDetails - Error details, if provided.
     * @param json - Additional Json, if provided.
     * @param properties - Additional properties, if provided.
     */
    constructor(r, e, n, t, o, l, c, d, u, h, A) {
      super(e, n, t, o, l, c, d, void 0, u, h, A), this.privIntentId = r;
    }
    /**
     * A String that represents the intent identifier being recognized.
     * @member IntentRecognitionResult.prototype.intentId
     * @function
     * @public
     * @returns {string} A String that represents the intent identifier being recognized.
     */
    get intentId() {
      return this.privIntentId;
    }
  };
  return _g.IntentRecognitionResult = a, _g;
}
var xA = {};
Object.defineProperty(xA, "__esModule", { value: !0 });
xA.LanguageUnderstandingModelImpl = xA.LanguageUnderstandingModel = void 0;
const GA = _o;
class oZ {
  /**
   * Creates and initializes a new instance
   * @constructor
   */
  constructor() {
  }
  /**
   * Creates an language understanding model using the specified endpoint.
   * @member LanguageUnderstandingModel.fromEndpoint
   * @function
   * @public
   * @param {URL} uri - A String that represents the endpoint of the language understanding model.
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */
  static fromEndpoint(a) {
    GA.Contracts.throwIfNull(a, "uri"), GA.Contracts.throwIfNullOrWhitespace(a.hostname, "uri");
    const i = new Xm(), r = a.host.indexOf(".");
    if (r === -1)
      throw new Error("Could not determine region from endpoint");
    i.region = a.host.substr(0, r);
    const e = a.pathname.lastIndexOf("/") + 1;
    if (e === -1)
      throw new Error("Could not determine appId from endpoint");
    if (i.appId = a.pathname.substr(e), i.subscriptionKey = a.searchParams.get("subscription-key"), i.subscriptionKey === void 0)
      throw new Error("Could not determine subscription key from endpoint");
    return i;
  }
  /**
   * Creates an language understanding model using the application id of Language Understanding service.
   * @member LanguageUnderstandingModel.fromAppId
   * @function
   * @public
   * @param {string} appId - A String that represents the application id of Language Understanding service.
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */
  static fromAppId(a) {
    GA.Contracts.throwIfNullOrWhitespace(a, "appId");
    const i = new Xm();
    return i.appId = a, i;
  }
  /**
   * Creates a language understanding model using hostname, subscription key and application
   * id of Language Understanding service.
   * @member LanguageUnderstandingModel.fromSubscription
   * @function
   * @public
   * @param {string} subscriptionKey - A String that represents the subscription key of
   * Language Understanding service.
   * @param {string} appId - A String that represents the application id of Language
   * Understanding service.
   * @param {LanguageUnderstandingModel} region - A String that represents the region
   * of the Language Understanding service (see the <a href="https://aka.ms/csspeech/region">region page</a>).
   * @returns {LanguageUnderstandingModel} The language understanding model being created.
   */
  static fromSubscription(a, i, r) {
    GA.Contracts.throwIfNullOrWhitespace(a, "subscriptionKey"), GA.Contracts.throwIfNullOrWhitespace(i, "appId"), GA.Contracts.throwIfNullOrWhitespace(r, "region");
    const e = new Xm();
    return e.appId = i, e.region = r, e.subscriptionKey = a, e;
  }
}
xA.LanguageUnderstandingModel = oZ;
class Xm extends oZ {
}
xA.LanguageUnderstandingModelImpl = Xm;
var g0 = {}, Xy;
function Yx() {
  if (Xy) return g0;
  Xy = 1, Object.defineProperty(g0, "__esModule", { value: !0 }), g0.MeetingTranscriptionEventArgs = g0.ConversationTranscriptionEventArgs = g0.SpeechRecognitionEventArgs = void 0;
  const s = Hr();
  let a = class extends s.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechRecognitionResult} result - The speech recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */
    constructor(n, t, o) {
      super(t, o), this.privResult = n;
    }
    /**
     * Specifies the recognition result.
     * @member SpeechRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {SpeechRecognitionResult} the recognition result.
     */
    get result() {
      return this.privResult;
    }
  };
  g0.SpeechRecognitionEventArgs = a;
  class i extends s.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranscriptionResult} result - The conversation transcription result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */
    constructor(n, t, o) {
      super(t, o), this.privResult = n;
    }
    /**
     * Specifies the transcription result.
     * @member ConversationTranscription1EventArgs.prototype.result
     * @function
     * @public
     * @returns {ConversationTranscriptionResult} the recognition result.
     */
    get result() {
      return this.privResult;
    }
  }
  g0.ConversationTranscriptionEventArgs = i;
  class r extends a {
  }
  return g0.MeetingTranscriptionEventArgs = r, g0;
}
var $g = {}, qg = {}, ky;
function am() {
  if (ky) return qg;
  ky = 1, Object.defineProperty(qg, "__esModule", { value: !0 }), qg.CancellationEventArgsBase = void 0;
  const s = Hr();
  let a = class extends s.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} reason - The cancellation reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */
    constructor(r, e, n, t, o) {
      super(t, o), this.privReason = r, this.privErrorDetails = e, this.privErrorCode = n;
    }
    /**
     * The reason the recognition was canceled.
     * @member CancellationEventArgsBase.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */
    get reason() {
      return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful operation.
     * @return An error code that represents the error reason.
     */
    get errorCode() {
      return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful operation, provides details of the occurred error.
     * @member CancellationEventArgsBase.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */
    get errorDetails() {
      return this.privErrorDetails;
    }
  };
  return qg.CancellationEventArgsBase = a, qg;
}
var wy;
function Lx() {
  if (wy) return $g;
  wy = 1, Object.defineProperty($g, "__esModule", { value: !0 }), $g.SpeechRecognitionCanceledEventArgs = void 0;
  const s = am();
  let a = class extends s.CancellationEventArgsBase {
  };
  return $g.SpeechRecognitionCanceledEventArgs = a, $g;
}
var ef = {}, Dy;
function xx() {
  if (Dy) return ef;
  Dy = 1, Object.defineProperty(ef, "__esModule", { value: !0 }), ef.TranslationRecognitionEventArgs = void 0;
  const s = Hr();
  let a = class extends s.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationRecognitionResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */
    constructor(r, e, n) {
      super(e, n), this.privResult = r;
    }
    /**
     * Specifies the recognition result.
     * @member TranslationRecognitionEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationRecognitionResult} the recognition result.
     */
    get result() {
      return this.privResult;
    }
  };
  return ef.TranslationRecognitionEventArgs = a, ef;
}
var tf = {}, My;
function Hx() {
  if (My) return tf;
  My = 1, Object.defineProperty(tf, "__esModule", { value: !0 }), tf.TranslationSynthesisEventArgs = void 0;
  const s = Hr();
  let a = class extends s.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {TranslationSynthesisResult} result - The translation synthesis result.
     * @param {string} sessionId - The session id.
     */
    constructor(r, e) {
      super(e), this.privResult = r;
    }
    /**
     * Specifies the translation synthesis result.
     * @member TranslationSynthesisEventArgs.prototype.result
     * @function
     * @public
     * @returns {TranslationSynthesisResult} Specifies the translation synthesis result.
     */
    get result() {
      return this.privResult;
    }
  };
  return tf.TranslationSynthesisEventArgs = a, tf;
}
var nf = {}, Yy;
function sZ() {
  if (Yy) return nf;
  Yy = 1, Object.defineProperty(nf, "__esModule", { value: !0 }), nf.TranslationRecognitionResult = void 0;
  const s = Hr();
  let a = class aZ extends s.SpeechRecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {Translations} translations - The translations.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */
    constructor(r, e, n, t, o, l, c, d, u, h, A) {
      super(e, n, t, o, l, c, d, void 0, u, h, A), this.privTranslations = r;
    }
    static fromSpeechRecognitionResult(r) {
      return new aZ(void 0, r.resultId, r.reason, r.text, r.duration, r.offset, r.language, r.languageDetectionConfidence, r.errorDetails, r.json, r.properties);
    }
    /**
     * Presents the translation results. Each item in the dictionary represents
     * a translation result in one of target languages, where the key is the name
     * of the target language, in BCP-47 format, and the value is the translation
     * text in the specified language.
     * @member TranslationRecognitionResult.prototype.translations
     * @function
     * @public
     * @returns {Translations} the current translation map that holds all translations requested.
     */
    get translations() {
      return this.privTranslations;
    }
  };
  return nf.TranslationRecognitionResult = a, nf;
}
var $1 = {};
Object.defineProperty($1, "__esModule", { value: !0 });
$1.TranslationSynthesisResult = void 0;
class Px {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {ResultReason} reason - The synthesis reason.
   * @param {ArrayBuffer} audio - The audio data.
   */
  constructor(a, i) {
    this.privReason = a, this.privAudio = i;
  }
  /**
   * Translated text in the target language.
   * @member TranslationSynthesisResult.prototype.audio
   * @function
   * @public
   * @returns {ArrayBuffer} Translated audio in the target language.
   */
  get audio() {
    return this.privAudio;
  }
  /**
   * The synthesis status.
   * @member TranslationSynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} The synthesis status.
   */
  get reason() {
    return this.privReason;
  }
}
$1.TranslationSynthesisResult = Px;
var lZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.ResultReason = void 0, function(a) {
    a[a.NoMatch = 0] = "NoMatch", a[a.Canceled = 1] = "Canceled", a[a.RecognizingSpeech = 2] = "RecognizingSpeech", a[a.RecognizedSpeech = 3] = "RecognizedSpeech", a[a.RecognizedKeyword = 4] = "RecognizedKeyword", a[a.RecognizingIntent = 5] = "RecognizingIntent", a[a.RecognizedIntent = 6] = "RecognizedIntent", a[a.TranslatingSpeech = 7] = "TranslatingSpeech", a[a.TranslatedSpeech = 8] = "TranslatedSpeech", a[a.SynthesizingAudio = 9] = "SynthesizingAudio", a[a.SynthesizingAudioCompleted = 10] = "SynthesizingAudioCompleted", a[a.SynthesizingAudioStarted = 11] = "SynthesizingAudioStarted", a[a.EnrollingVoiceProfile = 12] = "EnrollingVoiceProfile", a[a.EnrolledVoiceProfile = 13] = "EnrolledVoiceProfile", a[a.RecognizedSpeakers = 14] = "RecognizedSpeakers", a[a.RecognizedSpeaker = 15] = "RecognizedSpeaker", a[a.ResetVoiceProfile = 16] = "ResetVoiceProfile", a[a.DeletedVoiceProfile = 17] = "DeletedVoiceProfile", a[a.VoicesListRetrieved = 18] = "VoicesListRetrieved", a[a.TranslatingParticipantSpeech = 19] = "TranslatingParticipantSpeech", a[a.TranslatedParticipantSpeech = 20] = "TranslatedParticipantSpeech", a[a.TranslatedInstantMessage = 21] = "TranslatedInstantMessage", a[a.TranslatedParticipantInstantMessage = 22] = "TranslatedParticipantInstantMessage";
  }(s.ResultReason || (s.ResultReason = {}));
})(lZ);
var Eh = {}, Ly;
function Ox() {
  if (Ly) return Eh;
  Ly = 1, Object.defineProperty(Eh, "__esModule", { value: !0 }), Eh.SpeechConfigImpl = Eh.SpeechConfig = void 0;
  const s = wi(), a = _o, i = Hr();
  let r = class {
    /**
     * Creates and initializes an instance.
     * @constructor
     */
    constructor() {
    }
    /**
     * Static instance of SpeechConfig returned by passing subscriptionKey and service region.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * @member SpeechConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} The speech factory
     */
    static fromSubscription(t, o) {
      a.Contracts.throwIfNullOrWhitespace(t, "subscriptionKey"), a.Contracts.throwIfNullOrWhitespace(o, "region");
      const l = new e();
      return l.setProperty(i.PropertyId.SpeechServiceConnection_Region, o), l.setProperty(i.PropertyId.SpeechServiceConnection_IntentRegion, o), l.setProperty(i.PropertyId.SpeechServiceConnection_Key, t), l;
    }
    /**
     * Creates an instance of the speech config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: Please use your LanguageUnderstanding subscription key in case you want to use the Intent recognizer.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * For example, if language is defined in the uri as query parameter "language=de-DE", and also set by
     * SpeechConfig.speechRecognitionLanguage = "en-US", the language setting in uri takes precedence,
     * and the effective language is "de-DE". Only the parameters that are not specified in the
     * endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */
    static fromEndpoint(t, o) {
      a.Contracts.throwIfNull(t, "endpoint");
      const l = new e();
      return l.setProperty(i.PropertyId.SpeechServiceConnection_Endpoint, t.href), o !== void 0 && l.setProperty(i.PropertyId.SpeechServiceConnection_Key, o), l;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */
    static fromHost(t, o) {
      a.Contracts.throwIfNull(t, "hostName");
      const l = new e();
      return l.setProperty(i.PropertyId.SpeechServiceConnection_Host, t.protocol + "//" + t.hostname + (t.port === "" ? "" : ":" + t.port)), o !== void 0 && l.setProperty(i.PropertyId.SpeechServiceConnection_Key, o), l;
    }
    /**
     * Creates an instance of the speech factory with specified initial authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key in case you want
     * to use the Intent recognizer. As configuration values are copied when creating a new recognizer,
     * the new token value will not apply to recognizers that have already been created. For recognizers
     * that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The initial authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechConfig} A speech factory instance.
     */
    static fromAuthorizationToken(t, o) {
      a.Contracts.throwIfNull(t, "authorizationToken"), a.Contracts.throwIfNullOrWhitespace(o, "region");
      const l = new e();
      return l.setProperty(i.PropertyId.SpeechServiceConnection_Region, o), l.setProperty(i.PropertyId.SpeechServiceConnection_IntentRegion, o), l.authorizationToken = t, l;
    }
    /**
     * Closes the configuration.
     * @member SpeechConfig.prototype.close
     * @function
     * @public
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    close() {
    }
  };
  Eh.SpeechConfig = r;
  class e extends r {
    constructor() {
      super(), this.privProperties = new i.PropertyCollection(), this.speechRecognitionLanguage = "en-US", this.outputFormat = i.OutputFormat.Simple;
    }
    get properties() {
      return this.privProperties;
    }
    get endPoint() {
      return new URL(this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_Endpoint));
    }
    get subscriptionKey() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_Key);
    }
    get region() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_Region);
    }
    get authorizationToken() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    get speechRecognitionLanguage() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    set speechRecognitionLanguage(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage, t);
    }
    get autoDetectSourceLanguages() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages);
    }
    set autoDetectSourceLanguages(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, t);
    }
    get outputFormat() {
      return i.OutputFormat[this.privProperties.getProperty(s.OutputFormatPropertyName, void 0)];
    }
    set outputFormat(t) {
      this.privProperties.setProperty(s.OutputFormatPropertyName, i.OutputFormat[t]);
    }
    get endpointId() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_EndpointId);
    }
    set endpointId(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_EndpointId, t);
    }
    setProperty(t, o) {
      a.Contracts.throwIfNull(o, "value"), this.privProperties.setProperty(t, o);
    }
    getProperty(t, o) {
      return this.privProperties.getProperty(t, o);
    }
    setProxy(t, o, l, c) {
      this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyHostName], t), this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyPort], o), this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyUserName], l), this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyPassword], c);
    }
    setServiceProperty(t, o) {
      const l = JSON.parse(this.privProperties.getProperty(s.ServicePropertiesPropertyName, "{}"));
      l[t] = o, this.privProperties.setProperty(s.ServicePropertiesPropertyName, JSON.stringify(l));
    }
    setProfanity(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceResponse_ProfanityOption, i.ProfanityOption[t]);
    }
    enableAudioLogging() {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
      this.privProperties.setProperty(s.ForceDictationPropertyName, "true");
    }
    clone() {
      const t = new e();
      return t.privProperties = this.privProperties.clone(), t;
    }
    get speechSynthesisLanguage() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_SynthLanguage, t);
    }
    get speechSynthesisVoiceName() {
      return this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_SynthVoice, t);
    }
    get speechSynthesisOutputFormat() {
      return i.SpeechSynthesisOutputFormat[this.privProperties.getProperty(i.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(t) {
      this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_SynthOutputFormat, i.SpeechSynthesisOutputFormat[t]);
    }
  }
  return Eh.SpeechConfigImpl = e, Eh;
}
var Vh = {}, xy;
function Kx() {
  if (xy) return Vh;
  xy = 1, Object.defineProperty(Vh, "__esModule", { value: !0 }), Vh.SpeechTranslationConfigImpl = Vh.SpeechTranslationConfig = void 0;
  const s = wi(), a = _o, i = Hr();
  let r = class extends i.SpeechConfig {
    /**
     * Creates an instance of recognizer config.
     */
    constructor() {
      super();
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing a subscription key and service region.
     * @member SpeechTranslationConfig.fromSubscription
     * @function
     * @public
     * @param {string} subscriptionKey - The subscription key.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */
    static fromSubscription(t, o) {
      a.Contracts.throwIfNullOrWhitespace(t, "subscriptionKey"), a.Contracts.throwIfNullOrWhitespace(o, "region");
      const l = new e();
      return l.properties.setProperty(i.PropertyId.SpeechServiceConnection_Key, t), l.properties.setProperty(i.PropertyId.SpeechServiceConnection_Region, o), l;
    }
    /**
     * Static instance of SpeechTranslationConfig returned by passing authorization token and service region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by setting the property authorizationToken with a new
     * valid token. Otherwise, all the recognizers created by this SpeechTranslationConfig instance
     * will encounter errors during recognition.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply
     * to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member SpeechTranslationConfig.fromAuthorizationToken
     * @function
     * @public
     * @param {string} authorizationToken - The authorization token.
     * @param {string} region - The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {SpeechTranslationConfig} The speech translation config.
     */
    static fromAuthorizationToken(t, o) {
      a.Contracts.throwIfNullOrWhitespace(t, "authorizationToken"), a.Contracts.throwIfNullOrWhitespace(o, "region");
      const l = new e();
      return l.properties.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, t), l.properties.setProperty(i.PropertyId.SpeechServiceConnection_Region, o), l;
    }
    /**
     * Creates an instance of the speech config with specified host and subscription key.
     * This method is intended only for users who use a non-default service host. Standard resource path will be assumed.
     * For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL),
     * and then set the AuthorizationToken property on the created SpeechConfig instance.
     * Note: Added in version 1.9.0.
     * @member SpeechConfig.fromHost
     * @function
     * @public
     * @param {URL} host - The service endpoint to connect to. Format is "protocol://host:port" where ":port" is optional.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization token must be set.
     * @returns {SpeechConfig} A speech factory instance.
     */
    static fromHost(t, o) {
      a.Contracts.throwIfNull(t, "hostName");
      const l = new e();
      return l.setProperty(i.PropertyId.SpeechServiceConnection_Host, t.protocol + "//" + t.hostname + (t.port === "" ? "" : ":" + t.port)), o !== void 0 && l.setProperty(i.PropertyId.SpeechServiceConnection_Key, o), l;
    }
    /**
     * Creates an instance of the speech translation config with specified endpoint and subscription key.
     * This method is intended only for users who use a non-standard service endpoint or paramters.
     * Note: The query properties specified in the endpoint URL are not changed, even if they are
     * set by any other APIs. For example, if language is defined in the uri as query parameter
     * "language=de-DE", and also set by the speechRecognitionLanguage property, the language
     * setting in uri takes precedence, and the effective language is "de-DE".
     * Only the properties that are not specified in the endpoint URL can be set by other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created SpeechConfig instance to
     * use the authorization token.
     * @member SpeechTranslationConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key.
     * @returns {SpeechTranslationConfig} A speech config instance.
     */
    static fromEndpoint(t, o) {
      a.Contracts.throwIfNull(t, "endpoint"), a.Contracts.throwIfNull(o, "subscriptionKey");
      const l = new e();
      return l.properties.setProperty(i.PropertyId.SpeechServiceConnection_Endpoint, t.href), l.properties.setProperty(i.PropertyId.SpeechServiceConnection_Key, o), l;
    }
  };
  Vh.SpeechTranslationConfig = r;
  class e extends r {
    constructor() {
      super(), this.privSpeechProperties = new i.PropertyCollection(), this.outputFormat = i.OutputFormat.Simple;
    }
    /**
     * Gets/Sets the authorization token.
     * If this is set, subscription key is ignored.
     * User needs to make sure the provided authorization token is valid and not expired.
     * @member SpeechTranslationConfigImpl.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - The authorization token.
     */
    set authorizationToken(t) {
      a.Contracts.throwIfNullOrWhitespace(t, "value"), this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    /**
     * Sets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The authorization token.
     */
    set speechRecognitionLanguage(t) {
      a.Contracts.throwIfNullOrWhitespace(t, "value"), this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage, t);
    }
    /**
     * Gets the speech recognition language.
     * @member SpeechTranslationConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @return {string} The speechRecognitionLanguage.
     */
    get speechRecognitionLanguage() {
      return this.privSpeechProperties.getProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * @member SpeechTranslationConfigImpl.prototype.subscriptionKey
     * @function
     * @public
     */
    get subscriptionKey() {
      return this.privSpeechProperties.getProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_Key]);
    }
    /**
     * Gets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */
    get outputFormat() {
      return i.OutputFormat[this.privSpeechProperties.getProperty(s.OutputFormatPropertyName, void 0)];
    }
    /**
     * Gets/Sets the output format
     * @member SpeechTranslationConfigImpl.prototype.outputFormat
     * @function
     * @public
     */
    set outputFormat(t) {
      this.privSpeechProperties.setProperty(s.OutputFormatPropertyName, i.OutputFormat[t]);
    }
    /**
     * Gets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */
    get endpointId() {
      return this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_EndpointId);
    }
    /**
     * Gets/Sets the endpoint id.
     * @member SpeechTranslationConfigImpl.prototype.endpointId
     * @function
     * @public
     */
    set endpointId(t) {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_EndpointId, t);
    }
    /**
     * Add a (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.addTargetLanguage
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */
    addTargetLanguage(t) {
      a.Contracts.throwIfNullOrWhitespace(t, "value");
      const o = this.targetLanguages;
      o.includes(t) || (o.push(t), this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_TranslationToLanguages, o.join(",")));
    }
    /**
     * Gets the (text) target language to translate into.
     * @member SpeechTranslationConfigImpl.prototype.targetLanguages
     * @function
     * @public
     * @param {string} value - The language such as de-DE
     */
    get targetLanguages() {
      return this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",") : [];
    }
    /**
     * Gets the voice name.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     */
    get voiceName() {
      return this.getProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_TranslationVoice]);
    }
    /**
     * Gets/Sets the voice of the translated language, enable voice synthesis output.
     * @member SpeechTranslationConfigImpl.prototype.voiceName
     * @function
     * @public
     * @param {string} value - The name of the voice.
     */
    set voiceName(t) {
      a.Contracts.throwIfNullOrWhitespace(t, "value"), this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_TranslationVoice, t);
    }
    /**
     * Provides the region.
     * @member SpeechTranslationConfigImpl.prototype.region
     * @function
     * @public
     * @returns {string} The region.
     */
    get region() {
      return this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_Region);
    }
    setProxy(t, o, l, c) {
      this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyHostName], t), this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyPort], o), this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyUserName], l), this.setProperty(i.PropertyId[i.PropertyId.SpeechServiceConnection_ProxyPassword], c);
    }
    /**
     * Gets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {string} name - The name of the property.
     * @param {string} def - The default value of the property in case it is not set.
     * @returns {string} The value of the property.
     */
    getProperty(t, o) {
      return this.privSpeechProperties.getProperty(t, o);
    }
    /**
     * Gets/Sets an arbitrary property value.
     * @member SpeechTranslationConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {string | PropertyId} name - The name of the property to set.
     * @param {string} value - The value of the property.
     */
    setProperty(t, o) {
      this.privSpeechProperties.setProperty(t, o);
    }
    /**
     * Provides access to custom properties.
     * @member SpeechTranslationConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */
    get properties() {
      return this.privSpeechProperties;
    }
    /**
     * Dispose of associated resources.
     * @member SpeechTranslationConfigImpl.prototype.close
     * @function
     * @public
     */
    close() {
    }
    setServiceProperty(t, o) {
      const l = JSON.parse(this.privSpeechProperties.getProperty(s.ServicePropertiesPropertyName, "{}"));
      l[t] = o, this.privSpeechProperties.setProperty(s.ServicePropertiesPropertyName, JSON.stringify(l));
    }
    setProfanity(t) {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceResponse_ProfanityOption, i.ProfanityOption[t]);
    }
    enableAudioLogging() {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_EnableAudioLogging, "true");
    }
    requestWordLevelTimestamps() {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    }
    enableDictation() {
      this.privSpeechProperties.setProperty(s.ForceDictationPropertyName, "true");
    }
    get speechSynthesisLanguage() {
      return this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_SynthLanguage);
    }
    set speechSynthesisLanguage(t) {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_SynthLanguage, t);
    }
    get speechSynthesisVoiceName() {
      return this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_SynthVoice);
    }
    set speechSynthesisVoiceName(t) {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_SynthVoice, t);
    }
    get speechSynthesisOutputFormat() {
      return i.SpeechSynthesisOutputFormat[this.privSpeechProperties.getProperty(i.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)];
    }
    set speechSynthesisOutputFormat(t) {
      this.privSpeechProperties.setProperty(i.PropertyId.SpeechServiceConnection_SynthOutputFormat, i.SpeechSynthesisOutputFormat[t]);
    }
  }
  return Vh.SpeechTranslationConfigImpl = e, Vh;
}
var rf = {}, Hy;
function dZ() {
  if (Hy) return rf;
  Hy = 1, Object.defineProperty(rf, "__esModule", { value: !0 }), rf.PropertyCollection = void 0;
  const s = Hr();
  let a = class cZ {
    constructor() {
      this.privKeys = [], this.privValues = [];
    }
    /**
     * Returns the property value in type String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member PropertyCollection.prototype.getProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string | number | boolean} def - The default value which is returned if the parameter
     * is not available in the collection.
     * @returns {string} value of the parameter.
     */
    getProperty(r, e) {
      let n;
      typeof r == "string" ? n = r : n = s.PropertyId[r];
      for (let t = 0; t < this.privKeys.length; t++)
        if (this.privKeys[t] === n)
          return this.privValues[t];
      if (e !== void 0)
        return String(e);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member PropertyCollection.prototype.setProperty
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */
    setProperty(r, e) {
      let n;
      typeof r == "string" ? n = r : n = s.PropertyId[r];
      for (let t = 0; t < this.privKeys.length; t++)
        if (this.privKeys[t] === n) {
          this.privValues[t] = e;
          return;
        }
      this.privKeys.push(n), this.privValues.push(e);
    }
    /**
     * Clones the collection.
     * @member PropertyCollection.prototype.clone
     * @function
     * @public
     * @returns {PropertyCollection} A copy of the collection.
     */
    clone() {
      const r = new cZ();
      for (let e = 0; e < this.privKeys.length; e++)
        r.privKeys.push(this.privKeys[e]), r.privValues.push(this.privValues[e]);
      return r;
    }
    /**
     * Merges this set of properties into another, no overwrites.
     * @member PropertyCollection.prototype.mergeTo
     * @function
     * @public
     * @param {PropertyCollection}  destinationCollection - The collection to merge into.
     */
    mergeTo(r) {
      this.privKeys.forEach((e) => {
        if (r.getProperty(e, void 0) === void 0) {
          const n = this.getProperty(e);
          r.setProperty(e, n);
        }
      });
    }
    /**
     * Get the keys in Property Collection.
     * @member PropertyCollection.prototype.keys
     * @function
     * @public
     * @returns {string []} Keys in the collection.
     */
    get keys() {
      return this.privKeys;
    }
  };
  return rf.PropertyCollection = a, rf;
}
var q1 = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.PropertyId = void 0, function(a) {
    a[a.SpeechServiceConnection_Key = 0] = "SpeechServiceConnection_Key", a[a.SpeechServiceConnection_Endpoint = 1] = "SpeechServiceConnection_Endpoint", a[a.SpeechServiceConnection_Region = 2] = "SpeechServiceConnection_Region", a[a.SpeechServiceAuthorization_Token = 3] = "SpeechServiceAuthorization_Token", a[a.SpeechServiceAuthorization_Type = 4] = "SpeechServiceAuthorization_Type", a[a.SpeechServiceConnection_EndpointId = 5] = "SpeechServiceConnection_EndpointId", a[a.SpeechServiceConnection_TranslationToLanguages = 6] = "SpeechServiceConnection_TranslationToLanguages", a[a.SpeechServiceConnection_TranslationVoice = 7] = "SpeechServiceConnection_TranslationVoice", a[a.SpeechServiceConnection_TranslationFeatures = 8] = "SpeechServiceConnection_TranslationFeatures", a[a.SpeechServiceConnection_IntentRegion = 9] = "SpeechServiceConnection_IntentRegion", a[a.SpeechServiceConnection_ProxyHostName = 10] = "SpeechServiceConnection_ProxyHostName", a[a.SpeechServiceConnection_ProxyPort = 11] = "SpeechServiceConnection_ProxyPort", a[a.SpeechServiceConnection_ProxyUserName = 12] = "SpeechServiceConnection_ProxyUserName", a[a.SpeechServiceConnection_ProxyPassword = 13] = "SpeechServiceConnection_ProxyPassword", a[a.SpeechServiceConnection_RecoMode = 14] = "SpeechServiceConnection_RecoMode", a[a.SpeechServiceConnection_RecoLanguage = 15] = "SpeechServiceConnection_RecoLanguage", a[a.Speech_SessionId = 16] = "Speech_SessionId", a[a.SpeechServiceConnection_SynthLanguage = 17] = "SpeechServiceConnection_SynthLanguage", a[a.SpeechServiceConnection_SynthVoice = 18] = "SpeechServiceConnection_SynthVoice", a[a.SpeechServiceConnection_SynthOutputFormat = 19] = "SpeechServiceConnection_SynthOutputFormat", a[a.SpeechServiceConnection_AutoDetectSourceLanguages = 20] = "SpeechServiceConnection_AutoDetectSourceLanguages", a[a.SpeechServiceResponse_RequestDetailedResultTrueFalse = 21] = "SpeechServiceResponse_RequestDetailedResultTrueFalse", a[a.SpeechServiceResponse_RequestProfanityFilterTrueFalse = 22] = "SpeechServiceResponse_RequestProfanityFilterTrueFalse", a[a.SpeechServiceResponse_JsonResult = 23] = "SpeechServiceResponse_JsonResult", a[a.SpeechServiceResponse_JsonErrorDetails = 24] = "SpeechServiceResponse_JsonErrorDetails", a[a.CancellationDetails_Reason = 25] = "CancellationDetails_Reason", a[a.CancellationDetails_ReasonText = 26] = "CancellationDetails_ReasonText", a[a.CancellationDetails_ReasonDetailedText = 27] = "CancellationDetails_ReasonDetailedText", a[a.LanguageUnderstandingServiceResponse_JsonResult = 28] = "LanguageUnderstandingServiceResponse_JsonResult", a[a.SpeechServiceConnection_Url = 29] = "SpeechServiceConnection_Url", a[a.SpeechServiceConnection_InitialSilenceTimeoutMs = 30] = "SpeechServiceConnection_InitialSilenceTimeoutMs", a[a.SpeechServiceConnection_EndSilenceTimeoutMs = 31] = "SpeechServiceConnection_EndSilenceTimeoutMs", a[a.Speech_SegmentationSilenceTimeoutMs = 32] = "Speech_SegmentationSilenceTimeoutMs", a[a.SpeechServiceConnection_EnableAudioLogging = 33] = "SpeechServiceConnection_EnableAudioLogging", a[a.SpeechServiceConnection_LanguageIdMode = 34] = "SpeechServiceConnection_LanguageIdMode", a[a.SpeechServiceConnection_RecognitionEndpointVersion = 35] = "SpeechServiceConnection_RecognitionEndpointVersion", a[a.SpeechServiceConnection_SpeakerIdMode = 36] = "SpeechServiceConnection_SpeakerIdMode", a[a.SpeechServiceResponse_ProfanityOption = 37] = "SpeechServiceResponse_ProfanityOption", a[a.SpeechServiceResponse_PostProcessingOption = 38] = "SpeechServiceResponse_PostProcessingOption", a[a.SpeechServiceResponse_RequestWordLevelTimestamps = 39] = "SpeechServiceResponse_RequestWordLevelTimestamps", a[a.SpeechServiceResponse_StablePartialResultThreshold = 40] = "SpeechServiceResponse_StablePartialResultThreshold", a[a.SpeechServiceResponse_OutputFormatOption = 41] = "SpeechServiceResponse_OutputFormatOption", a[a.SpeechServiceResponse_TranslationRequestStablePartialResult = 42] = "SpeechServiceResponse_TranslationRequestStablePartialResult", a[a.SpeechServiceResponse_RequestWordBoundary = 43] = "SpeechServiceResponse_RequestWordBoundary", a[a.SpeechServiceResponse_RequestPunctuationBoundary = 44] = "SpeechServiceResponse_RequestPunctuationBoundary", a[a.SpeechServiceResponse_RequestSentenceBoundary = 45] = "SpeechServiceResponse_RequestSentenceBoundary", a[a.Conversation_ApplicationId = 46] = "Conversation_ApplicationId", a[a.Conversation_DialogType = 47] = "Conversation_DialogType", a[a.Conversation_Initial_Silence_Timeout = 48] = "Conversation_Initial_Silence_Timeout", a[a.Conversation_From_Id = 49] = "Conversation_From_Id", a[a.Conversation_Conversation_Id = 50] = "Conversation_Conversation_Id", a[a.Conversation_Custom_Voice_Deployment_Ids = 51] = "Conversation_Custom_Voice_Deployment_Ids", a[a.Conversation_Speech_Activity_Template = 52] = "Conversation_Speech_Activity_Template", a[a.Conversation_Request_Bot_Status_Messages = 53] = "Conversation_Request_Bot_Status_Messages", a[a.Conversation_Agent_Connection_Id = 54] = "Conversation_Agent_Connection_Id", a[a.SpeechServiceConnection_Host = 55] = "SpeechServiceConnection_Host", a[a.ConversationTranslator_Host = 56] = "ConversationTranslator_Host", a[a.ConversationTranslator_Name = 57] = "ConversationTranslator_Name", a[a.ConversationTranslator_CorrelationId = 58] = "ConversationTranslator_CorrelationId", a[a.ConversationTranslator_Token = 59] = "ConversationTranslator_Token", a[a.PronunciationAssessment_ReferenceText = 60] = "PronunciationAssessment_ReferenceText", a[a.PronunciationAssessment_GradingSystem = 61] = "PronunciationAssessment_GradingSystem", a[a.PronunciationAssessment_Granularity = 62] = "PronunciationAssessment_Granularity", a[a.PronunciationAssessment_EnableMiscue = 63] = "PronunciationAssessment_EnableMiscue", a[a.PronunciationAssessment_Json = 64] = "PronunciationAssessment_Json", a[a.PronunciationAssessment_Params = 65] = "PronunciationAssessment_Params", a[a.SpeakerRecognition_Api_Version = 66] = "SpeakerRecognition_Api_Version", a[a.WebWorkerLoadType = 67] = "WebWorkerLoadType", a[a.TalkingAvatarService_WebRTC_SDP = 68] = "TalkingAvatarService_WebRTC_SDP";
  }(s.PropertyId || (s.PropertyId = {}));
})(q1);
var of = {}, Py;
function zx() {
  if (Py) return of;
  Py = 1, Object.defineProperty(of, "__esModule", { value: !0 }), of.Recognizer = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class uZ {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {AudioConfig} audioInput - An optional audio input stream associated with the recognizer
     * @param {PropertyCollection} properties - A set of properties to set on the recognizer
     * @param {IConnectionFactory} connectionFactory - The factory class used to create a custom IConnection for the recognizer
     */
    constructor(t, o, l) {
      this.audioConfig = t !== void 0 ? t : r.AudioConfig.fromDefaultMicrophoneInput(), this.privDisposed = !1, this.privProperties = o.clone(), this.privConnectionFactory = l, this.implCommonRecognizerSetup();
    }
    /**
     * Dispose of associated resources.
     * @member Recognizer.prototype.close
     * @function
     * @public
     */
    close(t, o) {
      i.Contracts.throwIfDisposed(this.privDisposed), a.marshalPromiseToCallbacks(this.dispose(!0), t, o);
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */
    get internalData() {
      return this.privReco;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Recognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */
    async dispose(t) {
      this.privDisposed || (this.privDisposed = !0, t && this.privReco && (await this.privReco.audioSource.turnOff(), await this.privReco.dispose()));
    }
    /**
     * This method returns the current state of the telemetry setting.
     * @member Recognizer.prototype.telemetryEnabled
     * @function
     * @public
     * @returns true if the telemetry is enabled, false otherwise.
     */
    static get telemetryEnabled() {
      return s.ServiceRecognizerBase.telemetryDataEnabled;
    }
    /**
     * This method globally enables or disables telemetry.
     * @member Recognizer.prototype.enableTelemetry
     * @function
     * @public
     * @param enabled - Global setting for telemetry collection.
     * If set to true, telemetry information like microphone errors,
     * recognition errors are collected and sent to Microsoft.
     * If set to false, no telemetry is sent to Microsoft.
     */
    static enableTelemetry(t) {
      s.ServiceRecognizerBase.telemetryDataEnabled = t;
    }
    // Does the generic recognizer setup that is common across all recognizer types.
    implCommonRecognizerSetup() {
      let t = typeof window != "undefined" ? "Browser" : "Node", o = "unknown", l = "unknown";
      typeof navigator != "undefined" && (t = t + "/" + navigator.platform, o = navigator.userAgent, l = navigator.appVersion);
      const c = this.createRecognizerConfig(new s.SpeechServiceConfig(new s.Context(new s.OS(t, o, l))));
      this.privReco = this.createServiceRecognizer(uZ.getAuthFromProperties(this.privProperties), this.privConnectionFactory, this.audioConfig, c);
    }
    async recognizeOnceAsyncImpl(t) {
      i.Contracts.throwIfDisposed(this.privDisposed);
      const o = new a.Deferred();
      await this.implRecognizerStop(), await this.privReco.recognize(t, o.resolve, o.reject);
      const l = await o.promise;
      return await this.implRecognizerStop(), l;
    }
    async startContinuousRecognitionAsyncImpl(t) {
      i.Contracts.throwIfDisposed(this.privDisposed), await this.implRecognizerStop(), await this.privReco.recognize(t, void 0, void 0);
    }
    async stopContinuousRecognitionAsyncImpl() {
      i.Contracts.throwIfDisposed(this.privDisposed), await this.implRecognizerStop();
    }
    async implRecognizerStop() {
      this.privReco && await this.privReco.stopRecognizing();
    }
    static getAuthFromProperties(t) {
      const o = t.getProperty(r.PropertyId.SpeechServiceConnection_Key, void 0);
      return o && o !== "" ? new s.CognitiveSubscriptionKeyAuthentication(o) : new s.CognitiveTokenAuthentication(() => {
        const c = t.getProperty(r.PropertyId.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(c);
      }, () => {
        const c = t.getProperty(r.PropertyId.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(c);
      });
    }
  };
  return of.Recognizer = e, of;
}
var af = {}, Oy;
function jx() {
  if (Oy) return af;
  Oy = 1, Object.defineProperty(af, "__esModule", { value: !0 }), af.SpeechRecognizer = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class hZ extends r.Recognizer {
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */
    constructor(t, o) {
      const l = t;
      i.Contracts.throwIfNull(l, "speechConfig"), i.Contracts.throwIfNullOrWhitespace(l.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage), r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]), super(o, l.properties, new s.SpeechConnectionFactory()), this.privDisposedRecognizer = !1;
    }
    /**
     * SpeechRecognizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */
    static FromConfig(t, o, l) {
      const c = t;
      return o.properties.mergeTo(c.properties), new hZ(t, l);
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for speech recognition.
     * @member SpeechRecognizer.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */
    get endpointId() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(r.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeechRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(t) {
      i.Contracts.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(r.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    /**
     * Gets the spoken language of recognition.
     * @member SpeechRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */
    get speechRecognitionLanguage() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of recognition.
     * @member SpeechRecognizer.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of recognition.
     */
    get outputFormat() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(s.OutputFormatPropertyName, r.OutputFormat[r.OutputFormat.Simple]) === r.OutputFormat[r.OutputFormat.Simple] ? r.OutputFormat.Simple : r.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this SpeechRecognizer.
     * @member SpeechRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Starts speech recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition
     * like command or query. For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member SpeechRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the SpeechRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */
    recognizeOnceAsync(t, o) {
      a.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl(s.RecognitionMode.Interactive), t, o);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member SpeechRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */
    startContinuousRecognitionAsync(t, o) {
      a.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(s.RecognitionMode.Conversation), t, o);
    }
    /**
     * Stops continuous speech recognition.
     * @member SpeechRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */
    stopContinuousRecognitionAsync(t, o) {
      a.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), t, o);
    }
    /**
     * Starts speech recognition with keyword spotting, until
     * stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model The keyword recognition model that
     * specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */
    startKeywordRecognitionAsync(t, o, l) {
      i.Contracts.throwIfNull(t, "model"), l && l("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the
     * Speech Devices SDK. This functionality is currently not included in the SDK itself.
     * @member SpeechRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */
    stopKeywordRecognitionAsync(t) {
      t && t();
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member SpeechRecognizer.prototype.close
     * @function
     * @public
     */
    close(t, o) {
      i.Contracts.throwIfDisposed(this.privDisposedRecognizer), a.marshalPromiseToCallbacks(this.dispose(!0), t, o);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */
    async dispose(t) {
      this.privDisposedRecognizer || (t && (this.privDisposedRecognizer = !0, await this.implRecognizerStop()), await super.dispose(t));
    }
    createRecognizerConfig(t) {
      return new s.RecognizerConfig(t, this.privProperties);
    }
    createServiceRecognizer(t, o, l, c) {
      const d = l;
      return new s.SpeechServiceRecognizer(t, o, d, c, this);
    }
  };
  return af.SpeechRecognizer = e, af;
}
var sf = {}, Ky;
function _x() {
  if (Ky) return sf;
  Ky = 1, Object.defineProperty(sf, "__esModule", { value: !0 }), sf.IntentRecognizer = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class extends r.Recognizer {
    /**
     * Initializes an instance of the IntentRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */
    constructor(t, o) {
      i.Contracts.throwIfNullOrUndefined(t, "speechConfig");
      const l = t;
      i.Contracts.throwIfNullOrUndefined(l, "speechConfig"), super(o, l.properties, new s.IntentConnectionFactory()), this.privAddedIntents = [], this.privAddedLmIntents = {}, this.privDisposedIntentRecognizer = !1, this.privProperties = l.properties, i.Contracts.throwIfNullOrWhitespace(this.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage), r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * Gets the spoken language of recognition.
     * @member IntentRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} the spoken language of recognition.
     */
    get speechRecognitionLanguage() {
      return i.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), this.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member IntentRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * Note: Please use a token derived from your LanguageUnderstanding subscription key for the Intent recognizer.
     * @member IntentRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */
    set authorizationToken(t) {
      this.properties.setProperty(r.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    /**
     * The collection of properties and their values defined for this IntentRecognizer.
     * @member IntentRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their
     * values defined for this IntentRecognizer.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Starts intent recognition, and stops after the first utterance is recognized.
     * The task returns the recognition text and intent as result.
     * Note: RecognizeOnceAsync() returns when the first utterance has been recognized,
     * so it is suitable only for single shot recognition like command or query.
     * For long-running recognition, use StartContinuousRecognitionAsync() instead.
     * @member IntentRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the recognition has finished with an IntentRecognitionResult.
     * @param err - Callback invoked in case of an error.
     */
    recognizeOnceAsync(t, o) {
      if (i.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
        const l = this.buildSpeechContext();
        this.privReco.speechContext.setSection("intent", l.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(l.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
      }
      a.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl(s.RecognitionMode.Interactive), t, o);
    }
    /**
     * Starts speech recognition, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * @member IntentRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */
    startContinuousRecognitionAsync(t, o) {
      if (Object.keys(this.privAddedLmIntents).length !== 0 || this.privUmbrellaIntent !== void 0) {
        const l = this.buildSpeechContext();
        this.privReco.speechContext.setSection("intent", l.Intent), this.privReco.dynamicGrammar.addReferenceGrammar(l.ReferenceGrammars), this.privReco.setIntents(this.privAddedLmIntents, this.privUmbrellaIntent);
      }
      a.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(s.RecognitionMode.Conversation), t, o);
    }
    /**
     * Stops continuous intent recognition.
     * @member IntentRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */
    stopContinuousRecognitionAsync(t, o) {
      a.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), t, o);
    }
    /**
     * Starts speech recognition with keyword spotting, until stopKeywordRecognitionAsync() is called.
     * User must subscribe to events to receive recognition results.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.startKeywordRecognitionAsync
     * @function
     * @public
     * @param {KeywordRecognitionModel} model - The keyword recognition model that specifies the keyword to be recognized.
     * @param cb - Callback invoked once the recognition has started.
     * @param err - Callback invoked in case of an error.
     */
    startKeywordRecognitionAsync(t, o, l) {
      i.Contracts.throwIfNull(t, "model"), l && l("Not yet implemented.");
    }
    /**
     * Stops continuous speech recognition.
     * Note: Key word spotting functionality is only available on the Speech Devices SDK.
     * This functionality is currently not included in the SDK itself.
     * @member IntentRecognizer.prototype.stopKeywordRecognitionAsync
     * @function
     * @public
     * @param cb - Callback invoked once the recognition has stopped.
     * @param err - Callback invoked in case of an error.
     */
    stopKeywordRecognitionAsync(t, o) {
      if (t)
        try {
          t();
        } catch (l) {
          o && o(l);
        }
    }
    /**
     * Adds a phrase that should be recognized as intent.
     * @member IntentRecognizer.prototype.addIntent
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent to be recognized.
     * @param {string} phrase - A String that specifies the phrase representing the intent.
     */
    addIntent(t, o) {
      i.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), i.Contracts.throwIfNullOrWhitespace(o, "intentId"), i.Contracts.throwIfNullOrWhitespace(t, "simplePhrase"), this.privAddedIntents.push([o, t]);
    }
    /**
     * Adds an intent from Language Understanding service for recognition.
     * @member IntentRecognizer.prototype.addIntentWithLanguageModel
     * @function
     * @public
     * @param {string} intentId - A String that represents the identifier of the intent
     * to be recognized. Ignored if intentName is empty.
     * @param {string} model - The intent model from Language Understanding service.
     * @param {string} intentName - The intent name defined in the intent model. If it
     * is empty, all intent names defined in the model will be added.
     */
    addIntentWithLanguageModel(t, o, l) {
      i.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), i.Contracts.throwIfNullOrWhitespace(t, "intentId"), i.Contracts.throwIfNull(o, "model");
      const c = o;
      i.Contracts.throwIfNullOrWhitespace(c.appId, "model.appId"), this.privAddedLmIntents[t] = new s.AddedLmIntent(c, l);
    }
    /**
     * @summary Adds all intents from the specified Language Understanding Model.
     * @member IntentRecognizer.prototype.addAllIntents
     * @function
     * @public
     * @function
     * @public
     * @param {LanguageUnderstandingModel} model - The language understanding model containing the intents.
     * @param {string} intentId - A custom id String to be returned in the IntentRecognitionResult's getIntentId() method.
     */
    addAllIntents(t, o) {
      i.Contracts.throwIfNull(t, "model");
      const l = t;
      i.Contracts.throwIfNullOrWhitespace(l.appId, "model.appId"), this.privUmbrellaIntent = new s.AddedLmIntent(l, o);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member IntentRecognizer.prototype.close
     * @function
     * @public
     */
    close(t, o) {
      i.Contracts.throwIfDisposed(this.privDisposedIntentRecognizer), a.marshalPromiseToCallbacks(this.dispose(!0), t, o);
    }
    createRecognizerConfig(t) {
      return new s.RecognizerConfig(t, this.privProperties);
    }
    createServiceRecognizer(t, o, l, c) {
      const d = l;
      return new s.IntentServiceRecognizer(t, o, d, c, this);
    }
    async dispose(t) {
      this.privDisposedIntentRecognizer || t && (this.privDisposedIntentRecognizer = !0, await super.dispose(t));
    }
    buildSpeechContext() {
      let t, o, l;
      const c = [];
      this.privUmbrellaIntent !== void 0 && (t = this.privUmbrellaIntent.modelImpl.appId, o = this.privUmbrellaIntent.modelImpl.region, l = this.privUmbrellaIntent.modelImpl.subscriptionKey);
      for (const d of Object.keys(this.privAddedLmIntents)) {
        const u = this.privAddedLmIntents[d];
        if (t === void 0)
          t = u.modelImpl.appId;
        else if (t !== u.modelImpl.appId)
          throw new Error("Intents must all be from the same LUIS model");
        if (o === void 0)
          o = u.modelImpl.region;
        else if (o !== u.modelImpl.region)
          throw new Error("Intents must all be from the same LUIS model in a single region");
        if (l === void 0)
          l = u.modelImpl.subscriptionKey;
        else if (l !== u.modelImpl.subscriptionKey)
          throw new Error("Intents must all use the same subscription key");
        const h = "luis/" + t + "-PRODUCTION#" + d;
        c.push(h);
      }
      return {
        Intent: {
          id: t,
          key: l === void 0 ? this.privProperties.getProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_Key]) : l,
          provider: "LUIS"
        },
        ReferenceGrammars: this.privUmbrellaIntent === void 0 ? c : ["luis/" + t + "-PRODUCTION"]
      };
    }
  };
  return sf.IntentRecognizer = e, sf;
}
var AZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.VoiceProfileType = void 0, function(a) {
    a[a.TextIndependentIdentification = 0] = "TextIndependentIdentification", a[a.TextDependentVerification = 1] = "TextDependentVerification", a[a.TextIndependentVerification = 2] = "TextIndependentVerification";
  }(s.VoiceProfileType || (s.VoiceProfileType = {}));
})(AZ);
var lf = {}, cf = {}, Wh = {}, zy;
function gZ() {
  if (zy) return Wh;
  zy = 1, Object.defineProperty(Wh, "__esModule", { value: !0 }), Wh.ConnectionMessageImpl = Wh.ConnectionMessage = void 0;
  const s = Tc, a = Eo(), i = dZ(), r = q1;
  let e = class {
  };
  Wh.ConnectionMessage = e;
  class n {
    constructor(o) {
      this.privConnectionMessage = o, this.privProperties = new i.PropertyCollection(), this.privConnectionMessage.headers[s.HeaderNames.ConnectionId] && this.privProperties.setProperty(r.PropertyId.Speech_SessionId, this.privConnectionMessage.headers[s.HeaderNames.ConnectionId]), Object.keys(this.privConnectionMessage.headers).forEach((l) => {
        this.privProperties.setProperty(l, this.privConnectionMessage.headers[l]);
      });
    }
    /**
     * The message path.
     */
    get path() {
      return this.privConnectionMessage.headers[Object.keys(this.privConnectionMessage.headers).find((o) => o.toLowerCase() === "path".toLowerCase())];
    }
    /**
     * Checks to see if the ConnectionMessage is a text message.
     * See also IsBinaryMessage().
     */
    get isTextMessage() {
      return this.privConnectionMessage.messageType === a.MessageType.Text;
    }
    /**
     * Checks to see if the ConnectionMessage is a binary message.
     * See also GetBinaryMessage().
     */
    get isBinaryMessage() {
      return this.privConnectionMessage.messageType === a.MessageType.Binary;
    }
    /**
     * Gets the text message payload. Typically the text message content-type is
     * application/json. To determine other content-types use
     * Properties.GetProperty("Content-Type").
     */
    get TextMessage() {
      return this.privConnectionMessage.textBody;
    }
    /**
     * Gets the binary message payload.
     */
    get binaryMessage() {
      return this.privConnectionMessage.binaryBody;
    }
    /**
     * A collection of properties and their values defined for this <see cref="ConnectionMessage"/>.
     * Message headers can be accessed via this collection (e.g. "Content-Type").
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Returns a string that represents the connection message.
     */
    toString() {
      return "";
    }
  }
  return Wh.ConnectionMessageImpl = n, Wh;
}
var jy;
function fZ() {
  if (jy) return cf;
  jy = 1, Object.defineProperty(cf, "__esModule", { value: !0 }), cf.Connection = void 0;
  const s = wi(), a = Eo(), i = gZ(), r = _o, e = Hr();
  let n = class Jb {
    /**
     * Gets the Connection instance from the specified recognizer.
     * @param recognizer The recognizer associated with the connection.
     * @return The Connection instance of the recognizer.
     */
    static fromRecognizer(o) {
      const l = o.internalData, c = new Jb();
      return c.privInternalData = l, c.setupEvents(), c;
    }
    /**
     * Gets the Connection instance from the specified synthesizer.
     * @param synthesizer The synthesizer associated with the connection.
     * @return The Connection instance of the synthesizer.
     */
    static fromSynthesizer(o) {
      const l = o.internalData, c = new Jb();
      return c.privInternalData = l, c.setupEvents(), c;
    }
    /**
     * Starts to set up connection to the service.
     * Users can optionally call openConnection() to manually set up a connection in advance before starting recognition on the
     * Recognizer associated with this Connection. After starting recognition, calling Open() will have no effect
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     */
    openConnection(o, l) {
      a.marshalPromiseToCallbacks(this.privInternalData.connect(), o, l);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call closeConnection() to manually shutdown the connection of the associated Recognizer.
     *
     * If closeConnection() is called during recognition, recognition will fail and cancel with an error.
     */
    closeConnection(o, l) {
      if (this.privInternalData instanceof s.SynthesisAdapterBase)
        throw new Error("Disconnecting a synthesizer's connection is currently not supported");
      a.marshalPromiseToCallbacks(this.privInternalData.disconnect(), o, l);
    }
    /**
     * Appends a parameter in a message to service.
     * Added in version 1.12.1.
     * @param path The path of the network message.
     * @param propertyName Name of the property
     * @param propertyValue Value of the property. This is a json string.
     */
    setMessageProperty(o, l, c) {
      if (r.Contracts.throwIfNullOrWhitespace(l, "propertyName"), this.privInternalData instanceof s.ServiceRecognizerBase) {
        if (o.toLowerCase() !== "speech.context")
          throw new Error("Only speech.context message property sets are currently supported for recognizer");
        this.privInternalData.speechContext.setSection(l, c);
      } else if (this.privInternalData instanceof s.SynthesisAdapterBase) {
        if (o.toLowerCase() !== "synthesis.context")
          throw new Error("Only synthesis.context message property sets are currently supported for synthesizer");
        this.privInternalData.synthesisContext.setSection(l, c);
      }
    }
    /**
     * Sends a message to the speech service.
     * Added in version 1.13.0.
     * @param path The WebSocket path of the message
     * @param payload The payload of the message. This is a json string or a ArrayBuffer.
     * @param success A callback to indicate success.
     * @param error A callback to indicate an error.
     */
    sendMessageAsync(o, l, c, d) {
      a.marshalPromiseToCallbacks(this.privInternalData.sendNetworkMessage(o, l), c, d);
    }
    /**
     * Dispose of associated resources.
     */
    close() {
    }
    setupEvents() {
      this.privEventListener = this.privInternalData.connectionEvents.attach((o) => {
        o.name === "ConnectionEstablishedEvent" ? this.connected && this.connected(new e.ConnectionEventArgs(o.connectionId)) : o.name === "ConnectionClosedEvent" ? this.disconnected && this.disconnected(new e.ConnectionEventArgs(o.connectionId)) : o.name === "ConnectionMessageSentEvent" ? this.messageSent && this.messageSent(new e.ConnectionMessageEventArgs(new i.ConnectionMessageImpl(o.message))) : o.name === "ConnectionMessageReceivedEvent" && this.messageReceived && this.messageReceived(new e.ConnectionMessageEventArgs(new i.ConnectionMessageImpl(o.message)));
      }), this.privServiceEventListener = this.privInternalData.serviceEvents.attach((o) => {
        this.receivedServiceMessage && this.receivedServiceMessage(new e.ServiceEventArgs(o.jsonString, o.name));
      });
    }
  };
  return cf.Connection = n, cf;
}
var _y;
function $x() {
  if (_y) return lf;
  _y = 1, Object.defineProperty(lf, "__esModule", { value: !0 }), lf.TranslationRecognizer = void 0;
  const s = wi(), a = Eo(), i = fZ(), r = _o, e = Hr();
  let n = class pZ extends e.Recognizer {
    /**
     * Initializes an instance of the TranslationRecognizer.
     * @constructor
     * @param {SpeechTranslationConfig} speechConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     * @param {IConnectionFactory} connectionFactory - An optional connection factory to use to generate the endpoint URIs, headers to set, etc...
     */
    constructor(o, l, c) {
      const d = o;
      r.Contracts.throwIfNull(d, "speechConfig"), super(l, d.properties, c || new s.TranslationConnectionFactory()), this.privDisposedTranslationRecognizer = !1, this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationVoice, void 0) !== void 0 && r.Contracts.throwIfNullOrWhitespace(this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationVoice), e.PropertyId[e.PropertyId.SpeechServiceConnection_TranslationVoice]), r.Contracts.throwIfNullOrWhitespace(this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages), e.PropertyId[e.PropertyId.SpeechServiceConnection_TranslationToLanguages]), r.Contracts.throwIfNullOrWhitespace(this.properties.getProperty(e.PropertyId.SpeechServiceConnection_RecoLanguage), e.PropertyId[e.PropertyId.SpeechServiceConnection_RecoLanguage]);
    }
    /**
     * TranslationRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */
    static FromConfig(o, l, c) {
      const d = o;
      return l.properties.mergeTo(d.properties), new pZ(o, c);
    }
    /**
     * Gets the language name that was set when the recognizer was created.
     * @member TranslationRecognizer.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} Gets the language name that was set when the recognizer was created.
     */
    get speechRecognitionLanguage() {
      return r.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(e.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets target languages for translation that were set when the recognizer was created.
     * The language is specified in BCP-47 format. The translation will provide translated text for each of language.
     * @member TranslationRecognizer.prototype.targetLanguages
     * @function
     * @public
     * @returns {string[]} Gets target languages for translation that were set when the recognizer was created.
     */
    get targetLanguages() {
      return r.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(",");
    }
    /**
     * Gets the name of output voice.
     * @member TranslationRecognizer.prototype.voiceName
     * @function
     * @public
     * @returns {string} the name of output voice.
     */
    get voiceName() {
      return r.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationVoice, void 0);
    }
    /**
     * The collection of properties and their values defined for this TranslationRecognizer.
     * @member TranslationRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this TranslationRecognizer.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(e.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member TranslationRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} value - Authorization token.
     */
    set authorizationToken(o) {
      this.properties.setProperty(e.PropertyId.SpeechServiceAuthorization_Token, o);
    }
    /**
     * Starts recognition and translation, and stops after the first utterance is recognized.
     * The task returns the translation text as result.
     * Note: recognizeOnceAsync returns when the first utterance has been recognized, so it is suitable only
     * for single shot recognition like command or query. For long-running recognition,
     * use startContinuousRecognitionAsync() instead.
     * @member TranslationRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the translation has completed.
     * @param err - Callback invoked in case of an error.
     */
    recognizeOnceAsync(o, l) {
      r.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), a.marshalPromiseToCallbacks(this.recognizeOnceAsyncImpl(s.RecognitionMode.Interactive), o, l);
    }
    /**
     * Starts recognition and translation, until stopContinuousRecognitionAsync() is called.
     * User must subscribe to events to receive translation results.
     * @member TranslationRecognizer.prototype.startContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has started.
     * @param err - Callback invoked in case of an error.
     */
    startContinuousRecognitionAsync(o, l) {
      a.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(s.RecognitionMode.Conversation), o, l);
    }
    /**
     * Stops continuous recognition and translation.
     * @member TranslationRecognizer.prototype.stopContinuousRecognitionAsync
     * @function
     * @public
     * @param cb - Callback that received the translation has stopped.
     * @param err - Callback invoked in case of an error.
     */
    stopContinuousRecognitionAsync(o, l) {
      a.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), o, l);
    }
    /**
     * dynamically remove a language from list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.removeTargetLanguage
     * @function
     * @param lang - language to be removed
     * @public
     */
    removeTargetLanguage(o) {
      if (r.Contracts.throwIfNullOrUndefined(o, "language to be removed"), this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0) {
        const l = this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(","), c = l.indexOf(o);
        c > -1 && (l.splice(c, 1), this.properties.setProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages, l.join(",")), this.updateLanguages(l));
      }
    }
    /**
     * dynamically add a language to list of target language
     * (can be used while recognition is ongoing)
     * @member TranslationRecognizer.prototype.addTargetLanguage
     * @function
     * @param lang - language to be added
     * @public
     */
    addTargetLanguage(o) {
      r.Contracts.throwIfNullOrUndefined(o, "language to be added");
      let l = [];
      this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 ? (l = this.properties.getProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages).split(","), l.includes(o) || (l.push(o), this.properties.setProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages, l.join(",")))) : (this.properties.setProperty(e.PropertyId.SpeechServiceConnection_TranslationToLanguages, o), l = [o]), this.updateLanguages(l);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member TranslationRecognizer.prototype.close
     * @function
     * @public
     */
    close(o, l) {
      r.Contracts.throwIfDisposed(this.privDisposedTranslationRecognizer), a.marshalPromiseToCallbacks(this.dispose(!0), o, l);
    }
    /**
     * handles ConnectionEstablishedEvent for conversation translation scenarios.
     * @member TranslationRecognizer.prototype.onConnection
     * @function
     * @public
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onConnection() {
    }
    async dispose(o) {
      this.privDisposedTranslationRecognizer || (this.privDisposedTranslationRecognizer = !0, o && (await this.implRecognizerStop(), await super.dispose(o)));
    }
    createRecognizerConfig(o) {
      return new s.RecognizerConfig(o, this.privProperties);
    }
    createServiceRecognizer(o, l, c, d) {
      const u = c;
      return new s.TranslationServiceRecognizer(o, l, u, d, this);
    }
    updateLanguages(o) {
      const l = i.Connection.fromRecognizer(this);
      l && (l.setMessageProperty("speech.context", "translationcontext", { to: o }), l.sendMessageAsync("event", JSON.stringify({
        id: "translation",
        name: "updateLanguage",
        to: o
      })));
    }
  };
  return lf.TranslationRecognizer = n, lf;
}
var df = {}, $y;
function qx() {
  if ($y) return df;
  $y = 1, Object.defineProperty(df, "__esModule", { value: !0 }), df.Translations = void 0;
  const s = Hr();
  let a = class {
    constructor() {
      this.privMap = new s.PropertyCollection();
    }
    /**
     * Get the languages in the object in a String array.
     * @member Translations.prototype.languages
     * @function
     * @public
     * @returns {string[]} languages in translations object.
     */
    get languages() {
      return this.privMap.keys;
    }
    /**
     * Returns the parameter value in type String. The parameter must have the same type as String.
     * Currently only String, int and bool are allowed.
     * If the name is not available, the specified defaultValue is returned.
     * @member Translations.prototype.get
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} def - The default value which is returned if the parameter is not available in the collection.
     * @returns {string} value of the parameter.
     */
    get(r, e) {
      return this.privMap.getProperty(r, e);
    }
    /**
     * Sets the String value of the parameter specified by name.
     * @member Translations.prototype.set
     * @function
     * @public
     * @param {string} key - The parameter name.
     * @param {string} value - The value of the parameter.
     */
    set(r, e) {
      this.privMap.setProperty(r, e);
    }
  };
  return df.Translations = a, df;
}
var mZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.NoMatchReason = void 0, function(a) {
    a[a.NotRecognized = 0] = "NotRecognized", a[a.InitialSilenceTimeout = 1] = "InitialSilenceTimeout", a[a.InitialBabbleTimeout = 2] = "InitialBabbleTimeout";
  }(s.NoMatchReason || (s.NoMatchReason = {}));
})(mZ);
var uf = {}, qy;
function eH() {
  if (qy) return uf;
  qy = 1, Object.defineProperty(uf, "__esModule", { value: !0 }), uf.NoMatchDetails = void 0;
  const s = wi(), a = Hr();
  let i = class vZ {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {NoMatchReason} reason - The no-match reason.
     */
    constructor(e) {
      this.privReason = e;
    }
    /**
     * Creates an instance of NoMatchDetails object for the NoMatch SpeechRecognitionResults.
     * @member NoMatchDetails.fromResult
     * @function
     * @public
     * @param {SpeechRecognitionResult | IntentRecognitionResult | TranslationRecognitionResult}
     * result - The recognition result that was not recognized.
     * @returns {NoMatchDetails} The no match details object being created.
     */
    static fromResult(e) {
      const n = s.SimpleSpeechPhrase.fromJSON(e.json);
      let t = a.NoMatchReason.NotRecognized;
      switch (n.RecognitionStatus) {
        case s.RecognitionStatus.BabbleTimeout:
          t = a.NoMatchReason.InitialBabbleTimeout;
          break;
        case s.RecognitionStatus.InitialSilenceTimeout:
          t = a.NoMatchReason.InitialSilenceTimeout;
          break;
        default:
          t = a.NoMatchReason.NotRecognized;
          break;
      }
      return new vZ(t);
    }
    /**
     * The reason the recognition was canceled.
     * @member NoMatchDetails.prototype.reason
     * @function
     * @public
     * @returns {NoMatchReason} Specifies the reason canceled.
     */
    get reason() {
      return this.privReason;
    }
  };
  return uf.NoMatchDetails = i, uf;
}
var e2 = {};
Object.defineProperty(e2, "__esModule", { value: !0 });
e2.TranslationRecognitionCanceledEventArgs = void 0;
class tH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} sessionid - The session id.
   * @param {CancellationReason} cancellationReason - The cancellation reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {TranslationRecognitionResult} result - The result.
   */
  constructor(a, i, r, e, n) {
    this.privCancelReason = i, this.privErrorDetails = r, this.privResult = n, this.privSessionId = a, this.privErrorCode = e;
  }
  /**
   * Specifies the recognition result.
   * @member TranslationRecognitionCanceledEventArgs.prototype.result
   * @function
   * @public
   * @returns {TranslationRecognitionResult} the recognition result.
   */
  get result() {
    return this.privResult;
  }
  /**
   * Specifies the session identifier.
   * @member TranslationRecognitionCanceledEventArgs.prototype.sessionId
   * @function
   * @public
   * @returns {string} the session identifier.
   */
  get sessionId() {
    return this.privSessionId;
  }
  /**
   * The reason the recognition was canceled.
   * @member TranslationRecognitionCanceledEventArgs.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */
  get reason() {
    return this.privCancelReason;
  }
  /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */
  get errorCode() {
    return this.privErrorCode;
  }
  /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member TranslationRecognitionCanceledEventArgs.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
}
e2.TranslationRecognitionCanceledEventArgs = tH;
var hf = {}, eQ;
function nH() {
  if (eQ) return hf;
  eQ = 1, Object.defineProperty(hf, "__esModule", { value: !0 }), hf.IntentRecognitionCanceledEventArgs = void 0;
  const s = Hr();
  let a = class extends s.IntentRecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {CancellationReason} result - The result of the intent recognition.
     * @param {string} offset - The offset.
     * @param {IntentRecognitionResult} sessionId - The session id.
     */
    constructor(r, e, n, t, o, l) {
      super(t, o, l), this.privReason = r, this.privErrorDetails = e, this.privErrorCode = n;
    }
    /**
     * The reason the recognition was canceled.
     * @member IntentRecognitionCanceledEventArgs.prototype.reason
     * @function
     * @public
     * @returns {CancellationReason} Specifies the reason canceled.
     */
    get reason() {
      return this.privReason;
    }
    /**
     * The error code in case of an unsuccessful recognition.
     * Added in version 1.1.0.
     * @return An error code that represents the error reason.
     */
    get errorCode() {
      return this.privErrorCode;
    }
    /**
     * In case of an unsuccessful recognition, provides details of the occurred error.
     * @member IntentRecognitionCanceledEventArgs.prototype.errorDetails
     * @function
     * @public
     * @returns {string} A String that represents the error details.
     */
    get errorDetails() {
      return this.privErrorDetails;
    }
  };
  return hf.IntentRecognitionCanceledEventArgs = a, hf;
}
var sm = {};
Object.defineProperty(sm, "__esModule", { value: !0 });
sm.CancellationDetailsBase = void 0;
class rH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {CancellationReason} reason - The cancellation reason.
   * @param {string} errorDetails - The error details, if provided.
   */
  constructor(a, i, r) {
    this.privReason = a, this.privErrorDetails = i, this.privErrorCode = r;
  }
  /**
   * The reason the recognition was canceled.
   * @member CancellationDetailsBase.prototype.reason
   * @function
   * @public
   * @returns {CancellationReason} Specifies the reason canceled.
   */
  get reason() {
    return this.privReason;
  }
  /**
   * In case of an unsuccessful recognition, provides details of the occurred error.
   * @member CancellationDetailsBase.prototype.errorDetails
   * @function
   * @public
   * @returns {string} A String that represents the error details.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
  /**
   * The error code in case of an unsuccessful recognition.
   * Added in version 1.1.0.
   * @return An error code that represents the error reason.
   */
  get ErrorCode() {
    return this.privErrorCode;
  }
}
sm.CancellationDetailsBase = rH;
var Af = {}, tQ;
function iH() {
  if (tQ) return Af;
  tQ = 1, Object.defineProperty(Af, "__esModule", { value: !0 }), Af.CancellationDetails = void 0;
  const s = wi(), a = sm, i = Hr();
  let r = class bZ extends a.CancellationDetailsBase {
    constructor(n, t, o) {
      super(n, t, o);
    }
    /**
     * Creates an instance of CancellationDetails object for the canceled RecognitionResult.
     * @member CancellationDetails.fromResult
     * @function
     * @public
     * @param {RecognitionResult | SpeechSynthesisResult} result - The result that was canceled.
     * @returns {CancellationDetails} The cancellation details object being created.
     */
    static fromResult(n) {
      let t = i.CancellationReason.Error, o = i.CancellationErrorCode.NoError;
      if (n instanceof i.RecognitionResult && n.json) {
        const l = s.SimpleSpeechPhrase.fromJSON(n.json);
        t = s.EnumTranslation.implTranslateCancelResult(l.RecognitionStatus);
      }
      return n.properties && (o = i.CancellationErrorCode[n.properties.getProperty(s.CancellationErrorCodePropertyName, i.CancellationErrorCode[i.CancellationErrorCode.NoError])]), new bZ(t, n.errorDetails || s.EnumTranslation.implTranslateErrorDetails(o), o);
    }
  };
  return Af.CancellationDetails = r, Af;
}
var FZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.CancellationErrorCode = void 0, function(a) {
    a[a.NoError = 0] = "NoError", a[a.AuthenticationFailure = 1] = "AuthenticationFailure", a[a.BadRequestParameters = 2] = "BadRequestParameters", a[a.TooManyRequests = 3] = "TooManyRequests", a[a.ConnectionFailure = 4] = "ConnectionFailure", a[a.ServiceTimeout = 5] = "ServiceTimeout", a[a.ServiceError = 6] = "ServiceError", a[a.RuntimeError = 7] = "RuntimeError", a[a.Forbidden = 8] = "Forbidden";
  }(s.CancellationErrorCode || (s.CancellationErrorCode = {}));
})(FZ);
var gf = {}, nQ;
function oH() {
  if (nQ) return gf;
  nQ = 1, Object.defineProperty(gf, "__esModule", { value: !0 }), gf.ConnectionEventArgs = void 0;
  const s = Hr();
  let a = class extends s.SessionEventArgs {
  };
  return gf.ConnectionEventArgs = a, gf;
}
var ff = {}, rQ;
function aH() {
  if (rQ) return ff;
  rQ = 1, Object.defineProperty(ff, "__esModule", { value: !0 }), ff.ServiceEventArgs = void 0;
  const s = Hr();
  let a = class extends s.SessionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} json - json payload of the USP message.
     */
    constructor(r, e, n) {
      super(n), this.privJsonResult = r, this.privEventName = e;
    }
    get jsonString() {
      return this.privJsonResult;
    }
    get eventName() {
      return this.privEventName;
    }
  };
  return ff.ServiceEventArgs = a, ff;
}
var t2 = {};
Object.defineProperty(t2, "__esModule", { value: !0 });
t2.PhraseListGrammar = void 0;
class dF {
  constructor(a) {
    this.privGrammerBuilder = a.dynamicGrammar;
  }
  /**
   * Creates a PhraseListGrammar from a given speech recognizer. Will accept any recognizer that derives from @class Recognizer.
   * @param recognizer The recognizer to add phrase lists to.
   */
  static fromRecognizer(a) {
    const i = a.internalData;
    return new dF(i);
  }
  /**
   * Adds a single phrase to the current recognizer.
   * @param phrase Phrase to add.
   */
  addPhrase(a) {
    this.privGrammerBuilder.addPhrase(a);
  }
  /**
   * Adds multiple phrases to the current recognizer.
   * @param phrases Array of phrases to add.
   */
  addPhrases(a) {
    this.privGrammerBuilder.addPhrase(a);
  }
  /**
   * Clears all phrases added to the current recognizer.
   */
  clear() {
    this.privGrammerBuilder.clearPhrases();
  }
}
t2.PhraseListGrammar = dF;
var Nh = {}, iQ;
function uF() {
  if (iQ) return Nh;
  iQ = 1, Object.defineProperty(Nh, "__esModule", { value: !0 }), Nh.DialogServiceConfigImpl = Nh.DialogServiceConfig = void 0;
  const s = _o, a = Hr();
  let i = class {
    /**
     * Creates an instance of DialogService config.
     * @constructor
     */
    constructor() {
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member DialogServiceConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    set applicationId(n) {
    }
    static get DialogTypes() {
      return {
        BotFramework: "bot_framework",
        CustomCommands: "custom_commands"
      };
    }
  };
  Nh.DialogServiceConfig = i;
  class r extends i {
    /**
     * Creates an instance of dialogService config.
     */
    constructor() {
      super(), this.privSpeechConfig = new a.SpeechConfigImpl();
    }
    /**
     * Provides access to custom properties.
     * @member DialogServiceConfigImpl.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The properties.
     */
    get properties() {
      return this.privSpeechConfig.properties;
    }
    /**
     * Gets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     */
    get speechRecognitionLanguage() {
      return this.privSpeechConfig.speechRecognitionLanguage;
    }
    /**
     * Sets the speech recognition language.
     * @member DialogServiceConfigImpl.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @param {string} value - The language to set.
     */
    set speechRecognitionLanguage(n) {
      s.Contracts.throwIfNullOrWhitespace(n, "value"), this.privSpeechConfig.speechRecognitionLanguage = n;
    }
    get outputFormat() {
      return this.privSpeechConfig.outputFormat;
    }
    set outputFormat(n) {
      this.privSpeechConfig.outputFormat = n;
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.setProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to set.
     * @param {string} value - The value.
     */
    setProperty(n, t) {
      this.privSpeechConfig.setProperty(n, t);
    }
    /**
     * Sets a named property as value
     * @member DialogServiceConfigImpl.prototype.getProperty
     * @function
     * @public
     * @param {PropertyId | string} name - The property to get.
     * @param {string} def - The default value to return in case the property is not known.
     * @returns {string} The current value, or provided default, of the given property.
     */
    getProperty(n, t) {
      return this.privSpeechConfig.getProperty(n);
    }
    /**
     * Sets the proxy configuration.
     * Only relevant in Node.js environments.
     * Added in version 1.4.0.
     * @param proxyHostName The host name of the proxy server, without the protocol scheme (http://)
     * @param proxyPort The port number of the proxy server.
     * @param proxyUserName The user name of the proxy server.
     * @param proxyPassword The password of the proxy server.
     */
    setProxy(n, t, o, l) {
      this.setProperty(a.PropertyId.SpeechServiceConnection_ProxyHostName, n), this.setProperty(a.PropertyId.SpeechServiceConnection_ProxyPort, `${t}`), o && this.setProperty(a.PropertyId.SpeechServiceConnection_ProxyUserName, o), l && this.setProperty(a.PropertyId.SpeechServiceConnection_ProxyPassword, l);
    }
    setServiceProperty(n, t, o) {
      this.privSpeechConfig.setServiceProperty(n, t);
    }
    /**
     * Dispose of associated resources.
     * @member DialogServiceConfigImpl.prototype.close
     * @function
     * @public
     */
    close() {
    }
  }
  return Nh.DialogServiceConfigImpl = r, Nh;
}
var pf = {}, oQ;
function sH() {
  if (oQ) return pf;
  oQ = 1, Object.defineProperty(pf, "__esModule", { value: !0 }), pf.BotFrameworkConfig = void 0;
  const s = _o, a = uF(), i = Hr();
  let r = class extends a.DialogServiceConfigImpl {
    /**
     * Creates an instance of BotFrameworkConfig.
     */
    constructor() {
      super();
    }
    /**
     * Creates a bot framework configuration instance with the provided subscription information.
     * @member BotFrameworkConfig.fromSubscription
     * @function
     * @public
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */
    static fromSubscription(n, t, o) {
      s.Contracts.throwIfNullOrWhitespace(n, "subscription"), s.Contracts.throwIfNullOrWhitespace(t, "region");
      const l = new a.DialogServiceConfigImpl();
      return l.setProperty(i.PropertyId.Conversation_DialogType, a.DialogServiceConfig.DialogTypes.BotFramework), l.setProperty(i.PropertyId.SpeechServiceConnection_Key, n), l.setProperty(i.PropertyId.SpeechServiceConnection_Region, t), o && l.setProperty(i.PropertyId.Conversation_ApplicationId, o), l;
    }
    /**
     * Creates a bot framework configuration instance for the specified authorization token and region.
     * Note: The caller must ensure that an authorization token is valid. Before an authorization token expires, the
     * caller must refresh it by setting the authorizationToken property on the corresponding
     * DialogServiceConnector instance created with this config. The contents of configuration objects are copied
     * when connectors are created, so setting authorizationToken on a DialogServiceConnector will not update the
     * original configuration's authorization token. Create a new configuration instance or set the
     * SpeechServiceAuthorization_Token property to update an existing instance if it will be used to create
     * further DialogServiceConnectors.
     * @member BotFrameworkConfig.fromAuthorizationToken
     * @function
     * @public
     * @param authorizationToken The authorization token associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */
    static fromAuthorizationToken(n, t, o) {
      s.Contracts.throwIfNullOrWhitespace(n, "authorizationToken"), s.Contracts.throwIfNullOrWhitespace(t, "region");
      const l = new a.DialogServiceConfigImpl();
      return l.setProperty(i.PropertyId.Conversation_DialogType, a.DialogServiceConfig.DialogTypes.BotFramework), l.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, n), l.setProperty(i.PropertyId.SpeechServiceConnection_Region, t), o && l.setProperty(i.PropertyId.Conversation_ApplicationId, o), l;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-default service host. The standard resource path will be
     * assumed. For services with a non-standard resource path or no path at all, use fromEndpoint instead.
     * Note: Query parameters are not allowed in the host URI and must be set by other APIs.
     * Note: To use an authorization token with fromHost, use fromHost(URL) and then set the AuthorizationToken
     * property on the created BotFrameworkConfig instance.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromHost
     * @function
     * @public
     * @param {URL | string} host - If a URL is provided, the fully-qualified host with protocol (e.g.
     * wss://your.host.com:1234) will be used. If a string is provided, it will be embedded in
     * wss://{host}.convai.speech.azure.us.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @param botId Optional. Identifier for using a specific bot within an Azure resource group. Equivalent to the
     * resource name.
     * @returns {BotFrameworkConfig} A new bot framework configuration instance.
     */
    static fromHost(n, t, o) {
      s.Contracts.throwIfNullOrUndefined(n, "host");
      const l = n instanceof URL ? n : new URL(`wss://${n}.convai.speech.azure.us`);
      s.Contracts.throwIfNullOrUndefined(l, "resolvedHost");
      const c = new a.DialogServiceConfigImpl();
      return c.setProperty(i.PropertyId.Conversation_DialogType, a.DialogServiceConfig.DialogTypes.BotFramework), c.setProperty(i.PropertyId.SpeechServiceConnection_Host, l.toString()), t !== void 0 && c.setProperty(i.PropertyId.SpeechServiceConnection_Key, t), c;
    }
    /**
     * Creates an instance of a BotFrameworkConfig.
     * This method is intended only for users who use a non-standard service endpoint or parameters.
     * Note: The query parameters specified in the endpoint URL are not changed, even if they are set by any other APIs.
     * Note: To use authorization token with fromEndpoint, pass an empty string to the subscriptionKey in the
     * fromEndpoint method, and then set authorizationToken="token" on the created BotFrameworkConfig instance to
     * use the authorization token.
     * Note: Added in version 1.15.0.
     * @member BotFrameworkConfig.fromEndpoint
     * @function
     * @public
     * @param {URL} endpoint - The service endpoint to connect to.
     * @param {string} subscriptionKey - The subscription key. If a subscription key is not specified, an authorization
     * token must be set.
     * @returns {BotFrameworkConfig} - A new bot framework configuration instance using the provided endpoint.
     */
    static fromEndpoint(n, t) {
      s.Contracts.throwIfNull(n, "endpoint");
      const o = new a.DialogServiceConfigImpl();
      return o.setProperty(i.PropertyId.Conversation_DialogType, a.DialogServiceConfig.DialogTypes.BotFramework), o.setProperty(i.PropertyId.SpeechServiceConnection_Endpoint, n.toString()), t !== void 0 && o.setProperty(i.PropertyId.SpeechServiceConnection_Key, t), o;
    }
  };
  return pf.BotFrameworkConfig = r, pf;
}
var mf = {}, aQ;
function lH() {
  if (aQ) return mf;
  aQ = 1, Object.defineProperty(mf, "__esModule", { value: !0 }), mf.CustomCommandsConfig = void 0;
  const s = _o, a = uF(), i = Hr();
  let r = class extends a.DialogServiceConfigImpl {
    /**
     * Creates an instance of CustomCommandsConfig.
     */
    constructor() {
      super();
    }
    /**
     * Creates an instance of the bot framework config with the specified subscription and region.
     * @member CustomCommandsConfig.fromSubscription
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param subscription Subscription key associated with the bot
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new bot framework config.
     */
    static fromSubscription(n, t, o) {
      s.Contracts.throwIfNullOrWhitespace(n, "applicationId"), s.Contracts.throwIfNullOrWhitespace(t, "subscription"), s.Contracts.throwIfNullOrWhitespace(o, "region");
      const l = new a.DialogServiceConfigImpl();
      return l.setProperty(i.PropertyId.Conversation_DialogType, a.DialogServiceConfig.DialogTypes.CustomCommands), l.setProperty(i.PropertyId.Conversation_ApplicationId, n), l.setProperty(i.PropertyId.SpeechServiceConnection_Key, t), l.setProperty(i.PropertyId.SpeechServiceConnection_Region, o), l;
    }
    /**
     * Creates an instance of the bot framework config with the specified Speech Commands application id, authorization token and region.
     * Note: The caller needs to ensure that the authorization token is valid. Before the authorization token
     * expires, the caller needs to refresh it by calling this setter with a new valid token.
     * As configuration values are copied when creating a new recognizer, the new token value will not apply to recognizers that have already been created.
     * For recognizers that have been created before, you need to set authorization token of the corresponding recognizer
     * to refresh the token. Otherwise, the recognizers will encounter errors during recognition.
     * @member CustomCommandsConfig.fromAuthorizationToken
     * @function
     * @public
     * @param applicationId Speech Commands application id.
     * @param authorizationToken The authorization token associated with the application.
     * @param region The region name (see the <a href="https://aka.ms/csspeech/region">region page</a>).
     * @returns {CustomCommandsConfig} A new speech commands config.
     */
    static fromAuthorizationToken(n, t, o) {
      s.Contracts.throwIfNullOrWhitespace(n, "applicationId"), s.Contracts.throwIfNullOrWhitespace(t, "authorizationToken"), s.Contracts.throwIfNullOrWhitespace(o, "region");
      const l = new a.DialogServiceConfigImpl();
      return l.setProperty(i.PropertyId.Conversation_DialogType, a.DialogServiceConfig.DialogTypes.CustomCommands), l.setProperty(i.PropertyId.Conversation_ApplicationId, n), l.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, t), l.setProperty(i.PropertyId.SpeechServiceConnection_Region, o), l;
    }
    /**
     * Sets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to set.
     */
    set applicationId(n) {
      s.Contracts.throwIfNullOrWhitespace(n, "value"), this.setProperty(i.PropertyId.Conversation_ApplicationId, n);
    }
    /**
     * Gets the corresponding backend application identifier.
     * @member CustomCommandsConfig.prototype.Conversation_ApplicationId
     * @function
     * @public
     * @param {string} value - The application identifier to get.
     */
    get applicationId() {
      return this.getProperty(i.PropertyId.Conversation_ApplicationId);
    }
  };
  return mf.CustomCommandsConfig = r, mf;
}
var vf = {}, bf = {}, Ff = {}, Iu = {};
Object.defineProperty(Iu, "__esModule", { value: !0 });
Iu.QueryParameterNames = void 0;
class jl {
}
Iu.QueryParameterNames = jl;
jl.BotId = "botid";
jl.CustomSpeechDeploymentId = "cid";
jl.CustomVoiceDeploymentId = "deploymentId";
jl.EnableAudioLogging = "storeAudio";
jl.EnableLanguageId = "lidEnabled";
jl.EnableWordLevelTimestamps = "wordLevelTimestamps";
jl.EndSilenceTimeoutMs = "endSilenceTimeoutMs";
jl.SegmentationSilenceTimeoutMs = "segmentationSilenceTimeoutMs";
jl.Format = "format";
jl.InitialSilenceTimeoutMs = "initialSilenceTimeoutMs";
jl.Language = "language";
jl.Profanity = "profanity";
jl.RequestBotStatusMessages = "enableBotMessageStatus";
jl.StableIntermediateThreshold = "stableIntermediateThreshold";
jl.StableTranslation = "stableTranslation";
jl.TestHooks = "testhooks";
jl.Postprocessing = "postprocessing";
jl.CtsMeetingId = "meetingId";
jl.CtsDeviceId = "deviceId";
jl.CtsIsParticipant = "isParticipant";
jl.EnableAvatar = "enableTalkingAvatar";
var sQ;
function Bu() {
  if (sQ) return Ff;
  sQ = 1, Object.defineProperty(Ff, "__esModule", { value: !0 }), Ff.ConnectionFactoryBase = void 0;
  const s = wi(), a = Hr(), i = Iu;
  let r = class {
    static getHostSuffix(n) {
      if (n) {
        if (n.toLowerCase().startsWith("china"))
          return ".azure.cn";
        if (n.toLowerCase().startsWith("usgov"))
          return ".azure.us";
      }
      return ".microsoft.com";
    }
    setCommonUrlParams(n, t, o) {
      (/* @__PURE__ */ new Map([
        [a.PropertyId.Speech_SegmentationSilenceTimeoutMs, i.QueryParameterNames.SegmentationSilenceTimeoutMs],
        [a.PropertyId.SpeechServiceConnection_EnableAudioLogging, i.QueryParameterNames.EnableAudioLogging],
        [a.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, i.QueryParameterNames.EndSilenceTimeoutMs],
        [a.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, i.QueryParameterNames.InitialSilenceTimeoutMs],
        [a.PropertyId.SpeechServiceResponse_PostProcessingOption, i.QueryParameterNames.Postprocessing],
        [a.PropertyId.SpeechServiceResponse_ProfanityOption, i.QueryParameterNames.Profanity],
        [a.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, i.QueryParameterNames.EnableWordLevelTimestamps],
        [a.PropertyId.SpeechServiceResponse_StablePartialResultThreshold, i.QueryParameterNames.StableIntermediateThreshold]
      ])).forEach((d, u) => {
        this.setUrlParameter(u, d, n, t, o);
      });
      const c = JSON.parse(n.parameters.getProperty(s.ServicePropertiesPropertyName, "{}"));
      Object.keys(c).forEach((d) => {
        t[d] = c[d];
      });
    }
    setUrlParameter(n, t, o, l, c) {
      const d = o.parameters.getProperty(n, void 0);
      d && (!c || c.search(t) === -1) && (l[t] = d.toLocaleLowerCase());
    }
  };
  return Ff.ConnectionFactoryBase = r, Ff;
}
var lQ;
function cH() {
  if (lQ) return bf;
  lQ = 1, Object.defineProperty(bf, "__esModule", { value: !0 }), bf.DialogConnectionFactory = void 0;
  const s = Xc(), a = wi(), i = Hr(), r = Bu(), e = wi(), n = Tc, t = Iu;
  class o extends r.ConnectionFactoryBase {
    create(c, d, u) {
      const h = c.parameters.getProperty(i.PropertyId.Conversation_ApplicationId, ""), A = c.parameters.getProperty(i.PropertyId.Conversation_DialogType), g = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Region), f = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage, "en-US"), p = c.parameters.getProperty(i.PropertyId.Conversation_Request_Bot_Status_Messages, "true"), v = {};
      v[n.HeaderNames.ConnectionId] = u, v[t.QueryParameterNames.Format] = c.parameters.getProperty(a.OutputFormatPropertyName, i.OutputFormat[i.OutputFormat.Simple]).toLowerCase(), v[t.QueryParameterNames.Language] = f, v[t.QueryParameterNames.RequestBotStatusMessages] = p, h && (v[t.QueryParameterNames.BotId] = h, A === i.DialogServiceConfig.DialogTypes.CustomCommands && (v[n.HeaderNames.CustomCommandsAppId] = h));
      const b = A === i.DialogServiceConfig.DialogTypes.CustomCommands ? "commands/" : "", m = A === i.DialogServiceConfig.DialogTypes.CustomCommands ? "v1" : A === i.DialogServiceConfig.DialogTypes.BotFramework ? "v3" : "v0", y = {};
      d.token != null && d.token !== "" && (y[d.headerName] = d.token);
      let U = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Endpoint, "");
      if (!U) {
        const Q = r.ConnectionFactoryBase.getHostSuffix(g), N = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Host, `wss://${g}.${o.BaseUrl}${Q}`);
        U = `${N.endsWith("/") ? N : N + "/"}${b}${o.ApiKey}/${m}`;
      }
      this.setCommonUrlParams(c, v, U);
      const B = c.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(U, v, y, new e.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(c), B, u);
    }
  }
  return bf.DialogConnectionFactory = o, o.ApiKey = "api", o.BaseUrl = "convai.speech", bf;
}
var cQ;
function dH() {
  if (cQ) return vf;
  cQ = 1, Object.defineProperty(vf, "__esModule", { value: !0 }), vf.DialogServiceConnector = void 0;
  const s = cH(), a = wi(), i = Eo(), r = _o, e = Hr(), n = q1;
  let t = class extends e.Recognizer {
    /**
     * Initializes an instance of the DialogServiceConnector.
     * @constructor
     * @param {DialogServiceConfig} dialogConfig - Set of properties to configure this recognizer.
     * @param {AudioConfig} audioConfig - An optional audio config associated with the recognizer
     */
    constructor(l, c) {
      const d = l;
      r.Contracts.throwIfNull(l, "dialogConfig"), super(c, d.properties, new s.DialogConnectionFactory()), this.isTurnComplete = !0, this.privIsDisposed = !1, this.privProperties = d.properties.clone();
      const u = this.buildAgentConfig();
      this.privReco.agentConfig.set(u);
    }
    /**
     * Starts a connection to the service.
     * Users can optionally call connect() to manually set up a connection in advance, before starting interactions.
     *
     * Note: On return, the connection might not be ready yet. Please subscribe to the Connected event to
     * be notified when the connection is established.
     * @member DialogServiceConnector.prototype.connect
     * @function
     * @public
     */
    connect(l, c) {
      i.marshalPromiseToCallbacks(this.privReco.connect(), l, c);
    }
    /**
     * Closes the connection the service.
     * Users can optionally call disconnect() to manually shutdown the connection of the associated DialogServiceConnector.
     *
     * If disconnect() is called during a recognition, recognition will fail and cancel with an error.
     */
    disconnect(l, c) {
      i.marshalPromiseToCallbacks(this.privReco.disconnect(), l, c);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(n.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Sets the authorization token used to communicate with the service.
     * @member DialogServiceConnector.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(l) {
      r.Contracts.throwIfNullOrWhitespace(l, "token"), this.properties.setProperty(n.PropertyId.SpeechServiceAuthorization_Token, l);
    }
    /**
     * The collection of properties and their values defined for this DialogServiceConnector.
     * @member DialogServiceConnector.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this DialogServiceConnector.
     */
    get properties() {
      return this.privProperties;
    }
    /** Gets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be empty
     */
    get speechActivityTemplate() {
      return this.properties.getProperty(n.PropertyId.Conversation_Speech_Activity_Template);
    }
    /** Sets the template for the activity generated by service from speech.
     * Properties from the template will be stamped on the generated activity.
     * It can be null or empty.
     * Note: it has to be a valid Json object.
     */
    set speechActivityTemplate(l) {
      this.properties.setProperty(n.PropertyId.Conversation_Speech_Activity_Template, l);
    }
    /**
     * Starts recognition and stops after the first utterance is recognized.
     * @member DialogServiceConnector.prototype.listenOnceAsync
     * @function
     * @public
     * @param cb - Callback that received the result when the reco has completed.
     * @param err - Callback invoked in case of an error.
     */
    listenOnceAsync(l, c) {
      if (this.isTurnComplete) {
        r.Contracts.throwIfDisposed(this.privIsDisposed);
        const u = (async () => {
          await this.privReco.connect(), await this.implRecognizerStop(), this.isTurnComplete = !1;
          const h = new i.Deferred();
          await this.privReco.recognize(a.RecognitionMode.Conversation, h.resolve, h.reject);
          const A = await h.promise;
          return await this.implRecognizerStop(), A;
        })();
        u.catch(() => {
          this.dispose(!0).catch(() => {
          });
        }), i.marshalPromiseToCallbacks(u.finally(() => {
          this.isTurnComplete = !0;
        }), l, c);
      }
    }
    sendActivityAsync(l, c, d) {
      i.marshalPromiseToCallbacks(this.privReco.sendMessage(l), c, d);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member DialogServiceConnector.prototype.close
     * @function
     * @public
     */
    close(l, c) {
      r.Contracts.throwIfDisposed(this.privIsDisposed), i.marshalPromiseToCallbacks(this.dispose(!0), l, c);
    }
    async dispose(l) {
      this.privIsDisposed || l && (this.privIsDisposed = !0, await this.implRecognizerStop(), await super.dispose(l));
    }
    createRecognizerConfig(l) {
      return new a.RecognizerConfig(l, this.privProperties);
    }
    createServiceRecognizer(l, c, d, u) {
      const h = d;
      return new a.DialogServiceAdapter(l, c, h, u, this);
    }
    buildAgentConfig() {
      return {
        botInfo: {
          commType: this.properties.getProperty("Conversation_Communication_Type", "Default"),
          commandsCulture: void 0,
          connectionId: this.properties.getProperty(n.PropertyId.Conversation_Agent_Connection_Id),
          conversationId: this.properties.getProperty(n.PropertyId.Conversation_Conversation_Id, void 0),
          fromId: this.properties.getProperty(n.PropertyId.Conversation_From_Id, void 0),
          ttsAudioFormat: this.properties.getProperty(n.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)
        },
        version: 0.2
      };
    }
  };
  return vf.DialogServiceConnector = t, vf;
}
var n2 = {};
Object.defineProperty(n2, "__esModule", { value: !0 });
n2.ActivityReceivedEventArgs = void 0;
class uH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {any} activity - The activity..
   */
  constructor(a, i) {
    this.privActivity = a, this.privAudioStream = i;
  }
  /**
   * Gets the received activity
   * @member ActivityReceivedEventArgs.prototype.activity
   * @function
   * @public
   * @returns {any} the received activity.
   */
  get activity() {
    return this.privActivity;
  }
  get audioStream() {
    return this.privAudioStream;
  }
}
n2.ActivityReceivedEventArgs = uH;
var r2 = {}, i2 = {};
Object.defineProperty(i2, "__esModule", { value: !0 });
i2.TurnStatusResponsePayload = void 0;
class hF {
  constructor(a) {
    this.privMessageStatusResponse = JSON.parse(a);
  }
  static fromJSON(a) {
    return new hF(a);
  }
  get interactionId() {
    return this.privMessageStatusResponse.interactionId;
  }
  get conversationId() {
    return this.privMessageStatusResponse.conversationId;
  }
  get statusCode() {
    switch (this.privMessageStatusResponse.statusCode) {
      case "Success":
        return 200;
      case "Failed":
        return 400;
      case "TimedOut":
        return 429;
      default:
        return this.privMessageStatusResponse.statusCode;
    }
  }
}
i2.TurnStatusResponsePayload = hF;
Object.defineProperty(r2, "__esModule", { value: !0 });
r2.TurnStatusReceivedEventArgs = void 0;
const hH = i2;
class AH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} turnStatus - The JSON-encoded turn status message.
   */
  constructor(a) {
    this.privTurnStatus = hH.TurnStatusResponsePayload.fromJSON(a);
  }
  /**
   * Gets the interaction identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.interactionId
   * @function
   * @public
   * @returns {any} the received interaction id.
   */
  get interactionId() {
    return this.privTurnStatus.interactionId;
  }
  /**
   * Gets the conversation identifier associated with this turn status event.
   * @member TurnStatusReceivedEventArgs.prototype.conversationId
   * @function
   * @public
   * @returns {any} the received conversation id.
   */
  get conversationId() {
    return this.privTurnStatus.conversationId;
  }
  /**
   * Gets the received turn status code.
   * @member TurnStatusReceivedEventArgs.prototype.statusCode
   * @function
   * @public
   * @returns {number} the received turn status.
   */
  get statusCode() {
    return this.privTurnStatus.statusCode;
  }
}
r2.TurnStatusReceivedEventArgs = AH;
var RZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.ServicePropertyChannel = void 0, function(a) {
    a[a.UriQueryParameter = 0] = "UriQueryParameter";
  }(s.ServicePropertyChannel || (s.ServicePropertyChannel = {}));
})(RZ);
var yZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.ProfanityOption = void 0, function(a) {
    a[a.Masked = 0] = "Masked", a[a.Removed = 1] = "Removed", a[a.Raw = 2] = "Raw";
  }(s.ProfanityOption || (s.ProfanityOption = {}));
})(yZ);
var Rf = {}, dQ;
function gH() {
  if (dQ) return Rf;
  dQ = 1, Object.defineProperty(Rf, "__esModule", { value: !0 }), Rf.BaseAudioPlayer = void 0;
  const s = _c, a = Hr(), i = ah;
  let r = class {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {AudioStreamFormat} audioFormat audio stream format recognized by the player.
     */
    constructor(n) {
      this.audioContext = null, this.gainNode = null, this.autoUpdateBufferTimer = 0, n === void 0 && (n = a.AudioStreamFormat.getDefaultInputFormat()), this.init(n);
    }
    /**
     * play Audio sample
     * @param newAudioData audio data to be played.
     */
    playAudioSample(n, t, o) {
      try {
        this.ensureInitializedContext();
        const l = this.formatAudioData(n), c = new Float32Array(this.samples.length + l.length);
        c.set(this.samples, 0), c.set(l, this.samples.length), this.samples = c, t && t();
      } catch (l) {
        o && o(l);
      }
    }
    /**
     * stops audio and clears the buffers
     */
    stopAudio(n, t) {
      this.audioContext !== null && (this.samples = new Float32Array(), clearInterval(this.autoUpdateBufferTimer), this.audioContext.close().then(() => {
        n && n();
      }, (o) => {
        t && t(o);
      }), this.audioContext = null);
    }
    init(n) {
      this.audioFormat = n, this.samples = new Float32Array();
    }
    ensureInitializedContext() {
      if (this.audioContext === null) {
        this.createAudioContext();
        const n = 200;
        this.autoUpdateBufferTimer = setInterval(() => {
          this.updateAudioBuffer();
        }, n);
      }
    }
    createAudioContext() {
      this.audioContext = i.AudioStreamFormatImpl.getAudioContext(), this.gainNode = this.audioContext.createGain(), this.gainNode.gain.value = 1, this.gainNode.connect(this.audioContext.destination), this.startTime = this.audioContext.currentTime;
    }
    formatAudioData(n) {
      switch (this.audioFormat.bitsPerSample) {
        case 8:
          return this.formatArrayBuffer(new Int8Array(n), 128);
        case 16:
          return this.formatArrayBuffer(new Int16Array(n), 32768);
        case 32:
          return this.formatArrayBuffer(new Int32Array(n), 2147483648);
        default:
          throw new s.InvalidOperationError("Only WAVE_FORMAT_PCM (8/16/32 bps) format supported at this time");
      }
    }
    formatArrayBuffer(n, t) {
      const o = new Float32Array(n.length);
      for (let l = 0; l < n.length; l++)
        o[l] = n[l] / t;
      return o;
    }
    updateAudioBuffer() {
      if (this.samples.length === 0)
        return;
      const n = this.audioFormat.channels, t = this.audioContext.createBufferSource(), o = this.samples.length / n, l = this.audioContext.createBuffer(n, o, this.audioFormat.samplesPerSec);
      for (let c = 0; c < n; c++) {
        let d = c;
        const u = l.getChannelData(c);
        for (let h = 0; h < this.samples.length; h++, d += n)
          u[h] = this.samples[d];
      }
      this.startTime < this.audioContext.currentTime && (this.startTime = this.audioContext.currentTime), t.buffer = l, t.connect(this.gainNode), t.start(this.startTime), this.startTime += l.duration, this.samples = new Float32Array();
    }
    async playAudio(n) {
      this.audioContext === null && this.createAudioContext();
      const t = this.audioContext.createBufferSource(), o = this.audioContext.destination;
      await this.audioContext.decodeAudioData(n, (l) => {
        t.buffer = l, t.connect(o), t.start(0);
      });
    }
  };
  return Rf.BaseAudioPlayer = r, Rf;
}
var o2 = {};
Object.defineProperty(o2, "__esModule", { value: !0 });
o2.ConnectionMessageEventArgs = void 0;
class fH {
  constructor(a) {
    this.privConnectionMessage = a;
  }
  /**
   * Gets the <see cref="ConnectionMessage"/> associated with this <see cref="ConnectionMessageEventArgs"/>.
   */
  get message() {
    return this.privConnectionMessage;
  }
  /**
   * Returns a string that represents the connection message event.
   */
  toString() {
    return "Message: " + this.privConnectionMessage.toString();
  }
}
o2.ConnectionMessageEventArgs = fH;
var a2 = {};
Object.defineProperty(a2, "__esModule", { value: !0 });
a2.VoiceProfile = void 0;
class pH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} profileId - profileId of this Voice Profile.
   * @param {VoiceProfileType} profileType - profileType of this Voice Profile.
   */
  constructor(a, i) {
    this.privId = a, this.privProfileType = i;
  }
  /**
   * profileId of this Voice Profile instance
   * @member VoiceProfile.prototype.profileId
   * @function
   * @public
   * @returns {string} profileId of this Voice Profile instance.
   */
  get profileId() {
    return this.privId;
  }
  /**
   * profileType of this Voice Profile instance
   * @member VoiceProfile.prototype.profileType
   * @function
   * @public
   * @returns {VoiceProfileType} profile type of this Voice Profile instance.
   */
  get profileType() {
    return this.privProfileType;
  }
}
a2.VoiceProfile = pH;
var Jh = {}, uQ;
function mH() {
  if (uQ) return Jh;
  uQ = 1, Object.defineProperty(Jh, "__esModule", { value: !0 }), Jh.VoiceProfileEnrollmentCancellationDetails = Jh.VoiceProfileEnrollmentResult = void 0;
  const s = wi(), a = Hr();
  let i = class Gb {
    constructor(n, t, o) {
      this.privReason = n, this.privProperties = new a.PropertyCollection(), this.privReason !== a.ResultReason.Canceled ? t && (this.privDetails = JSON.parse(t), this.privDetails.enrollmentStatus.toLowerCase() === "enrolling" && (this.privReason = a.ResultReason.EnrollingVoiceProfile)) : (this.privErrorDetails = o, this.privProperties.setProperty(s.CancellationErrorCodePropertyName, a.CancellationErrorCode[a.CancellationErrorCode.ServiceError]));
    }
    get reason() {
      return this.privReason;
    }
    get enrollmentsCount() {
      return this.privDetails.enrollmentsCount;
    }
    get enrollmentsLength() {
      return this.privDetails.enrollmentsLength;
    }
    get properties() {
      return this.privProperties;
    }
    get enrollmentResultDetails() {
      return this.privDetails;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
    static FromIdentificationProfileList(n) {
      const t = [];
      for (const o of n.value) {
        const l = o.enrollmentStatus.toLowerCase() === "enrolling" ? a.ResultReason.EnrollingVoiceProfile : o.enrollmentStatus.toLowerCase() === "enrolled" ? a.ResultReason.EnrolledVoiceProfile : a.ResultReason.Canceled, c = new Gb(l, null, null);
        c.privDetails = this.getIdentificationDetails(o), t.push(c);
      }
      return t;
    }
    static FromVerificationProfileList(n) {
      const t = [];
      for (const o of n.value) {
        const l = o.enrollmentStatus.toLowerCase() === "enrolling" ? a.ResultReason.EnrollingVoiceProfile : o.enrollmentStatus.toLowerCase() === "enrolled" ? a.ResultReason.EnrolledVoiceProfile : a.ResultReason.Canceled, c = new Gb(l, null, null);
        c.privDetails = this.getVerificationDetails(o), t.push(c);
      }
      return t;
    }
    static getIdentificationDetails(n) {
      return {
        audioLength: n.audioLength ? parseFloat(n.audioLength) : 0,
        audioSpeechLength: n.audioSpeechLength ? parseFloat(n.audioSpeechLength) : 0,
        enrollmentStatus: n.enrollmentStatus,
        enrollmentsCount: n.enrollmentsCount || 0,
        enrollmentsLength: n.enrollmentsLength ? parseFloat(n.enrollmentsLength) : 0,
        enrollmentsSpeechLength: n.enrollmentsSpeechLength ? parseFloat(n.enrollmentsSpeechLength) : 0,
        profileId: n.profileId || n.identificationProfileId,
        remainingEnrollmentsSpeechLength: n.remainingEnrollmentsSpeechLength ? parseFloat(n.remainingEnrollmentsSpeechLength) : 0
      };
    }
    static getVerificationDetails(n) {
      return {
        audioLength: n.audioLength ? parseFloat(n.audioLength) : 0,
        audioSpeechLength: n.audioSpeechLength ? parseFloat(n.audioSpeechLength) : 0,
        enrollmentStatus: n.enrollmentStatus,
        enrollmentsCount: n.enrollmentsCount,
        enrollmentsLength: n.enrollmentsLength ? parseFloat(n.enrollmentsLength) : 0,
        enrollmentsSpeechLength: n.enrollmentsSpeechLength ? parseFloat(n.enrollmentsSpeechLength) : 0,
        profileId: n.profileId || n.verificationProfileId,
        remainingEnrollmentsCount: n.remainingEnrollments || n.remainingEnrollmentsCount,
        remainingEnrollmentsSpeechLength: n.remainingEnrollmentsSpeechLength ? parseFloat(n.remainingEnrollmentsSpeechLength) : 0
      };
    }
  };
  Jh.VoiceProfileEnrollmentResult = i;
  class r extends a.CancellationDetailsBase {
    constructor(n, t, o) {
      super(n, t, o);
    }
    /**
     * Creates an instance of VoiceProfileEnrollmentCancellationDetails object for the canceled VoiceProfileEnrollmentResult.
     * @member VoiceProfileEnrollmentCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileEnrollmentResult} result - The result that was canceled.
     * @returns {VoiceProfileEnrollmentCancellationDetails} The cancellation details object being created.
     */
    static fromResult(n) {
      const t = a.CancellationReason.Error;
      let o = a.CancellationErrorCode.NoError;
      return n.properties && (o = a.CancellationErrorCode[n.properties.getProperty(s.CancellationErrorCodePropertyName, a.CancellationErrorCode[a.CancellationErrorCode.NoError])]), new r(t, n.errorDetails, o);
    }
  }
  return Jh.VoiceProfileEnrollmentCancellationDetails = r, Jh;
}
var Gh = {}, hQ;
function vH() {
  if (hQ) return Gh;
  hQ = 1, Object.defineProperty(Gh, "__esModule", { value: !0 }), Gh.VoiceProfileCancellationDetails = Gh.VoiceProfileResult = void 0;
  const s = wi(), a = _o, i = Hr();
  let r = class {
    constructor(t, o) {
      this.privReason = t, this.privProperties = new i.PropertyCollection(), t === i.ResultReason.Canceled && (a.Contracts.throwIfNullOrUndefined(o, "statusText"), this.privErrorDetails = o, this.privProperties.setProperty(s.CancellationErrorCodePropertyName, i.CancellationErrorCode[i.CancellationErrorCode.ServiceError]));
    }
    get reason() {
      return this.privReason;
    }
    get properties() {
      return this.privProperties;
    }
    get errorDetails() {
      return this.privErrorDetails;
    }
  };
  Gh.VoiceProfileResult = r;
  class e extends i.CancellationDetailsBase {
    constructor(t, o, l) {
      super(t, o, l);
    }
    /**
     * Creates an instance of VoiceProfileCancellationDetails object for the canceled VoiceProfileResult.
     * @member VoiceProfileCancellationDetails.fromResult
     * @function
     * @public
     * @param {VoiceProfileResult} result - The result that was canceled.
     * @returns {VoiceProfileCancellationDetails} The cancellation details object being created.
     */
    static fromResult(t) {
      const o = i.CancellationReason.Error;
      let l = i.CancellationErrorCode.NoError;
      return t.properties && (l = i.CancellationErrorCode[t.properties.getProperty(s.CancellationErrorCodePropertyName, i.CancellationErrorCode[i.CancellationErrorCode.NoError])]), new e(o, t.errorDetails, l);
    }
  }
  return Gh.VoiceProfileCancellationDetails = e, Gh;
}
var yf = {}, AQ;
function bH() {
  if (AQ) return yf;
  AQ = 1, Object.defineProperty(yf, "__esModule", { value: !0 }), yf.VoiceProfilePhraseResult = void 0;
  const s = _o, a = Hr();
  let i = class extends a.VoiceProfileResult {
    constructor(e, n, t, o) {
      super(e, n), this.privPhrases = [], s.Contracts.throwIfNullOrUndefined(o, "phrase array"), this.privType = t, o && o[0] && (this.privPhrases = o);
    }
    get phrases() {
      return this.privPhrases;
    }
    get type() {
      return this.privType;
    }
  };
  return yf.VoiceProfilePhraseResult = i, yf;
}
var Qf = {}, gQ;
function FH() {
  if (gQ) return Qf;
  gQ = 1, Object.defineProperty(Qf, "__esModule", { value: !0 }), Qf.VoiceProfileClient = void 0;
  const s = wi(), a = nZ(), i = _o, r = Hr();
  let e = class extends r.Recognizer {
    /**
     * VoiceProfileClient constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer (authentication key, region, &c)
     */
    constructor(t) {
      i.Contracts.throwIfNullOrUndefined(t, "speechConfig");
      const o = t;
      i.Contracts.throwIfNull(o, "speechConfig"), super(a.AudioConfig.fromStreamInput(r.AudioInputStream.createPushStream()), o.properties, new s.VoiceProfileConnectionFactory()), this.privProperties = o.properties.clone(), this.privVoiceAdapter = this.privReco, this.privDisposedVoiceAdapter = !1;
    }
    /**
     * The collection of properties and their values defined for this VoiceProfileClient.
     * @member VoiceProfileClient.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this VoiceProfileClient.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member VoiceProfileClient.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member VoiceProfileClient.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(t) {
      i.Contracts.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(r.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.createProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Type of Voice Profile to be created
     * @param {string} lang Language string (locale) for Voice Profile
     * @return {Promise<VoiceProfile>} - Promise of a VoiceProfile.
     */
    async createProfileAsync(t, o) {
      const l = await this.privVoiceAdapter.createProfile(t, o);
      return new r.VoiceProfile(l[0], t);
    }
    /**
     * Get current information of a voice profile
     * @member VoiceProfileClient.prototype.retrieveEnrollmentResultAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to retrieve info for
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */
    async retrieveEnrollmentResultAsync(t) {
      return this.privVoiceAdapter.retrieveEnrollmentResult(t);
    }
    /**
     * Get all voice profiles on account with given voice profile type
     * @member VoiceProfileClient.prototype.getAllProfilesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType profile type (identification/verification) for which to list profiles
     * @return {Promise<VoiceProfileEnrollmentResult[]>} - Promise of an array of VoiceProfileEnrollmentResults.
     */
    async getAllProfilesAsync(t) {
      return this.privVoiceAdapter.getAllProfiles(t);
    }
    /**
     * Get valid authorization phrases for voice profile enrollment
     * @member VoiceProfileClient.prototype.getActivationPhrasesAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfileType} profileType Profile Type to get activation phrases for
     * @param {string} lang Language string (locale) for Voice Profile
     */
    async getActivationPhrasesAsync(t, o) {
      return this.privVoiceAdapter.getActivationPhrases(t, o);
    }
    /**
     * Create a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.enrollProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to create enrollment for
     * @param {AudioConfig} audioConfig source info from which to create enrollment
     * @return {Promise<VoiceProfileEnrollmentResult>} - Promise of a VoiceProfileEnrollmentResult.
     */
    async enrollProfileAsync(t, o) {
      const l = o;
      return i.Contracts.throwIfNullOrUndefined(l, "audioConfig"), this.audioConfig = o, this.privVoiceAdapter.SpeakerAudioSource = l, this.privVoiceAdapter.enrollProfile(t);
    }
    /**
     * Delete a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.deleteProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be deleted
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */
    async deleteProfileAsync(t) {
      return this.privVoiceAdapter.deleteProfile(t);
    }
    /**
     * Remove all enrollments for a speaker recognition voice profile
     * @member VoiceProfileClient.prototype.resetProfileAsync
     * @function
     * @public
     * @async
     * @param {VoiceProfile} profile Voice Profile to be reset
     * @return {Promise<VoiceProfileResult>} - Promise of a VoiceProfileResult.
     */
    async resetProfileAsync(t) {
      return this.privVoiceAdapter.resetProfile(t);
    }
    /**
     * Clean up object and close underlying connection
     * @member VoiceProfileClient.prototype.close
     * @function
     * @async
     * @public
     */
    async close() {
      await this.dispose(!0);
    }
    createServiceRecognizer(t, o, l, c) {
      const d = l;
      return new s.VoiceServiceRecognizer(t, o, d, c, this);
    }
    async dispose(t) {
      this.privDisposedVoiceAdapter || (this.privDisposedVoiceAdapter = !0, t && await super.dispose(t));
    }
    createRecognizerConfig(t) {
      return new s.RecognizerConfig(t, this.properties);
    }
    getResult(t, o) {
      return new r.VoiceProfileResult(t.ok ? o : r.ResultReason.Canceled, t.statusText);
    }
  };
  return Qf.VoiceProfileClient = e, Qf;
}
var Cf = {}, fQ;
function RH() {
  if (fQ) return Cf;
  fQ = 1, Object.defineProperty(Cf, "__esModule", { value: !0 }), Cf.SpeakerRecognizer = void 0;
  const s = wi(), a = _o, i = Hr();
  let r = class extends i.Recognizer {
    /**
     * Initializes an instance of the SpeakerRecognizer.
     * @constructor
     * @param {SpeechConfig} speechConfig - The set of configuration properties.
     * @param {AudioConfig} audioConfig - An optional audio input config associated with the recognizer
     */
    constructor(n, t) {
      a.Contracts.throwIfNullOrUndefined(n, "speechConfig");
      const o = n;
      a.Contracts.throwIfNullOrUndefined(o, "speechConfig"), super(t, o.properties, new s.SpeakerRecognitionConnectionFactory()), this.privAudioConfigImpl = t, a.Contracts.throwIfNull(this.privAudioConfigImpl, "audioConfig"), this.privDisposedSpeakerRecognizer = !1, this.privProperties = o.properties;
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member SpeakerRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(i.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member SpeakerRecognizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(n) {
      a.Contracts.throwIfNullOrWhitespace(n, "token"), this.properties.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, n);
    }
    /**
     * The collection of properties and their values defined for this SpeakerRecognizer.
     * @member SpeakerRecognizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeakerRecognizer.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Get recognition result for model using given audio
     * @member SpeakerRecognizer.prototype.recognizeOnceAsync
     * @function
     * @public
     * @async
     * @param {SpeakerIdentificationModel | SpeakerVerificationModel} model Model containing Voice Profiles to be identified
     * @param cb - Callback invoked once result is returned.
     * @param err - Callback invoked in case of an error.
     */
    async recognizeOnceAsync(n) {
      return a.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer), this.recognizeSpeakerOnceAsyncImpl(n);
    }
    /**
     * Included for compatibility
     * @member SpeakerRecognizer.prototype.close
     * @function
     * @public
     * @async
     */
    async close() {
      a.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer), await this.dispose(!0);
    }
    async recognizeSpeakerOnceAsyncImpl(n) {
      a.Contracts.throwIfDisposed(this.privDisposedSpeakerRecognizer), await this.implRecognizerStop();
      const t = await this.privReco.recognizeSpeaker(n);
      return await this.implRecognizerStop(), t;
    }
    async implRecognizerStop() {
      this.privReco && await this.privReco.stopRecognizing();
    }
    createRecognizerConfig(n) {
      return new s.RecognizerConfig(n, this.privProperties);
    }
    createServiceRecognizer(n, t, o, l) {
      const c = o;
      return new s.SpeakerServiceRecognizer(n, t, c, l, this);
    }
    async dispose(n) {
      this.privDisposedSpeakerRecognizer || n && (this.privDisposedSpeakerRecognizer = !0, await super.dispose(n));
    }
  };
  return Cf.SpeakerRecognizer = r, Cf;
}
var Uf = {}, pQ;
function yH() {
  if (pQ) return Uf;
  pQ = 1, Object.defineProperty(Uf, "__esModule", { value: !0 }), Uf.SpeakerIdentificationModel = void 0;
  const s = _o, a = Hr();
  let i = class QZ {
    constructor(e) {
      if (this.privVoiceProfiles = [], this.privProfileIds = [], s.Contracts.throwIfNullOrUndefined(e, "VoiceProfiles"), e.length === 0)
        throw new Error("Empty Voice Profiles array");
      for (const n of e) {
        if (n.profileType !== a.VoiceProfileType.TextIndependentIdentification)
          throw new Error("Identification model can only be created from Identification profile: " + n.profileId);
        this.privVoiceProfiles.push(n), this.privProfileIds.push(n.profileId);
      }
    }
    static fromProfiles(e) {
      return new QZ(e);
    }
    get voiceProfileIds() {
      return this.privProfileIds.join(",");
    }
    get profileIds() {
      return this.privProfileIds;
    }
    get scenario() {
      return "TextIndependentIdentification";
    }
  };
  return Uf.SpeakerIdentificationModel = i, Uf;
}
var If = {}, mQ;
function QH() {
  if (mQ) return If;
  mQ = 1, Object.defineProperty(If, "__esModule", { value: !0 }), If.SpeakerVerificationModel = void 0;
  const s = _o, a = Hr();
  let i = class CZ {
    constructor(e) {
      if (s.Contracts.throwIfNullOrUndefined(e, "VoiceProfile"), e.profileType === a.VoiceProfileType.TextIndependentIdentification)
        throw new Error("Verification model cannot be created from Identification profile");
      this.privVoiceProfile = e;
    }
    static fromProfile(e) {
      return new CZ(e);
    }
    get voiceProfile() {
      return this.privVoiceProfile;
    }
    get profileIds() {
      return [this.voiceProfile.profileId];
    }
    get scenario() {
      return this.voiceProfile.profileType === a.VoiceProfileType.TextDependentVerification ? "TextDependentVerification" : "TextIndependentVerification";
    }
  };
  return If.SpeakerVerificationModel = i, If;
}
var Bf = {}, AF = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.LanguageIdMode = void 0, function(a) {
    a[a.AtStart = 0] = "AtStart", a[a.Continuous = 1] = "Continuous";
  }(s.LanguageIdMode || (s.LanguageIdMode = {}));
})(AF);
var vQ;
function CH() {
  if (vQ) return Bf;
  vQ = 1, Object.defineProperty(Bf, "__esModule", { value: !0 }), Bf.AutoDetectSourceLanguageConfig = void 0;
  const s = wi(), a = _o, i = Hr(), r = AF;
  let e = class km {
    constructor() {
      this.privProperties = new i.PropertyCollection(), this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart"), this.privLanguageIdMode = r.LanguageIdMode.AtStart;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromOpenRange
     * @function
     * @public
     * Only [[SpeechSynthesizer]] supports source language auto detection from open range,
     * for [[Recognizer]], please use AutoDetectSourceLanguageConfig with specific source languages.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with open range.
     */
    static fromOpenRange() {
      const t = new km();
      return t.properties.setProperty(i.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, s.AutoDetectSourceLanguagesOpenRangeOptionName), t;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromLanguages
     * @function
     * @public
     * @param {string[]} languages Comma-separated string of languages (eg. "en-US,fr-FR") to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given languages.
     */
    static fromLanguages(t) {
      a.Contracts.throwIfArrayEmptyOrWhitespace(t, "languages");
      const o = new km();
      return o.properties.setProperty(i.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, t.join()), o;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.fromSourceLanguageConfigs
     * @function
     * @public
     * @param {SourceLanguageConfig[]} configs SourceLanguageConfigs to populate properties of config.
     * @return {AutoDetectSourceLanguageConfig} Instance of AutoDetectSourceLanguageConfig
     * @summary Creates an instance of the AutoDetectSourceLanguageConfig with given SourceLanguageConfigs.
     */
    static fromSourceLanguageConfigs(t) {
      if (t.length < 1)
        throw new Error("Expected non-empty SourceLanguageConfig array.");
      const o = new km(), l = [];
      return t.forEach((c) => {
        if (l.push(c.language), c.endpointId !== void 0 && c.endpointId !== "") {
          const d = c.language + i.PropertyId.SpeechServiceConnection_EndpointId.toString();
          o.properties.setProperty(d, c.endpointId);
        }
      }), o.properties.setProperty(i.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, l.join()), o;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets an auto detected language config properties
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * @member AutoDetectSourceLanguageConfig.prototype.mode
     * @function
     * @public
     * @param {LanguageIdMode} mode LID mode desired.
     * @summary Sets LID operation to desired mode
     */
    set mode(t) {
      t === r.LanguageIdMode.Continuous ? (this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2"), this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_LanguageIdMode, "Continuous")) : (this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "1"), this.privProperties.setProperty(i.PropertyId.SpeechServiceConnection_LanguageIdMode, "AtStart")), this.privLanguageIdMode = t;
    }
  };
  return Bf.AutoDetectSourceLanguageConfig = e, Bf;
}
var s2 = {};
Object.defineProperty(s2, "__esModule", { value: !0 });
s2.AutoDetectSourceLanguageResult = void 0;
const bQ = _o;
class i1 {
  constructor(a, i) {
    bQ.Contracts.throwIfNullOrUndefined(a, "language"), bQ.Contracts.throwIfNullOrUndefined(i, "languageDetectionConfidence"), this.privLanguage = a, this.privLanguageDetectionConfidence = i;
  }
  /**
   * Creates an instance of AutoDetectSourceLanguageResult object from a SpeechRecognitionResult instance.
   * @member AutoDetectSourceLanguageResult.fromResult
   * @function
   * @public
   * @param {SpeechRecognitionResult} result - The recognition result.
   * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
   */
  static fromResult(a) {
    return new i1(a.language, a.languageDetectionConfidence);
  }
  /**
   * Creates an instance of AutoDetectSourceLanguageResult object from a ConversationTranscriptionResult instance.
   * @member AutoDetectSourceLanguageResult.fromConversationTranscriptionResult
   * @function
   * @public
   * @param {ConversationTranscriptionResult} result - The transcription result.
   * @returns {AutoDetectSourceLanguageResult} AutoDetectSourceLanguageResult object being created.
   */
  static fromConversationTranscriptionResult(a) {
    return new i1(a.language, a.languageDetectionConfidence);
  }
  get language() {
    return this.privLanguage;
  }
  get languageDetectionConfidence() {
    return this.privLanguageDetectionConfidence;
  }
}
s2.AutoDetectSourceLanguageResult = i1;
var l2 = {};
Object.defineProperty(l2, "__esModule", { value: !0 });
l2.SourceLanguageConfig = void 0;
const UH = _o;
class gF {
  constructor(a, i) {
    UH.Contracts.throwIfNullOrUndefined(a, "language"), this.privLanguage = a, this.privEndpointId = i;
  }
  /**
   * @member SourceLanguageConfig.fromLanguage
   * @function
   * @public
   * @param {string} language language (eg. "en-US") value of config.
   * @param {string?} endpointId endpointId of model bound to given language of config.
   * @return {SourceLanguageConfig} Instance of SourceLanguageConfig
   * @summary Creates an instance of the SourceLanguageConfig with the given language and optional endpointId.
   * Added in version 1.13.0.
   */
  static fromLanguage(a, i) {
    return new gF(a, i);
  }
  get language() {
    return this.privLanguage;
  }
  get endpointId() {
    return this.privEndpointId;
  }
}
l2.SourceLanguageConfig = gF;
var Pv = {}, FQ;
function IH() {
  return FQ || (FQ = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.SpeakerRecognitionCancellationDetails = s.SpeakerRecognitionResult = s.SpeakerRecognitionResultType = void 0;
    const a = wi(), i = Hr();
    var r;
    (function(t) {
      t[t.Verify = 0] = "Verify", t[t.Identify = 1] = "Identify";
    })(r = s.SpeakerRecognitionResultType || (s.SpeakerRecognitionResultType = {}));
    class e {
      constructor(o, l = i.ResultReason.RecognizedSpeaker, c = i.CancellationErrorCode.NoError, d = "") {
        this.privProperties = new i.PropertyCollection();
        const u = o.scenario === "TextIndependentIdentification" ? r.Identify : r.Verify;
        this.privReason = l, this.privReason !== i.ResultReason.Canceled ? u === r.Identify ? (this.privProfileId = o.identificationResult.identifiedProfile.profileId, this.privScore = o.identificationResult.identifiedProfile.score, this.privReason = i.ResultReason.RecognizedSpeakers) : (this.privScore = o.verificationResult.score, o.verificationResult.recognitionResult.toLowerCase() !== "accept" && (this.privReason = i.ResultReason.NoMatch), o.verificationResult.profileId !== void 0 && o.verificationResult.profileId !== "" && (this.privProfileId = o.verificationResult.profileId)) : (this.privErrorDetails = d, this.privProperties.setProperty(a.CancellationErrorCodePropertyName, i.CancellationErrorCode[c])), this.privProperties.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, JSON.stringify(o));
      }
      get properties() {
        return this.privProperties;
      }
      get reason() {
        return this.privReason;
      }
      get profileId() {
        return this.privProfileId;
      }
      get errorDetails() {
        return this.privErrorDetails;
      }
      get score() {
        return this.privScore;
      }
    }
    s.SpeakerRecognitionResult = e;
    class n extends i.CancellationDetailsBase {
      constructor(o, l, c) {
        super(o, l, c);
      }
      /**
       * Creates an instance of SpeakerRecognitionCancellationDetails object for the canceled SpeakerRecognitionResult
       * @member SpeakerRecognitionCancellationDetails.fromResult
       * @function
       * @public
       * @param {SpeakerRecognitionResult} result - The result that was canceled.
       * @returns {SpeakerRecognitionCancellationDetails} The cancellation details object being created.
       */
      static fromResult(o) {
        const l = i.CancellationReason.Error;
        let c = i.CancellationErrorCode.NoError;
        return o.properties && (c = i.CancellationErrorCode[o.properties.getProperty(a.CancellationErrorCodePropertyName, i.CancellationErrorCode[i.CancellationErrorCode.NoError])]), new n(l, o.errorDetails, c);
      }
    }
    s.SpeakerRecognitionCancellationDetails = n;
  }(Pv)), Pv;
}
var Ov = {}, Th = {}, RQ;
function UZ() {
  if (RQ) return Th;
  RQ = 1, Object.defineProperty(Th, "__esModule", { value: !0 }), Th.ConversationImpl = Th.Conversation = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class {
    constructor() {
    }
    /**
     * Create a conversation
     * @param speechConfig
     * @param cb
     * @param err
     */
    static createConversationAsync(o, l, c, d) {
      i.Contracts.throwIfNullOrUndefined(o, s.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config")), i.Contracts.throwIfNullOrUndefined(o.region, s.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), !o.subscriptionKey && !o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceAuthorization_Token]) && i.Contracts.throwIfNullOrUndefined(o.subscriptionKey, s.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
      let u, h, A;
      return typeof l == "string" ? (u = new n(o, l), a.marshalPromiseToCallbacks((async () => {
      })(), c, d)) : (u = new n(o), h = l, A = c, u.createConversationAsync(() => {
        h && h();
      }, (g) => {
        A && A(g);
      })), u;
    }
  };
  Th.Conversation = e;
  class n extends e {
    /**
     * Create a conversation impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */
    constructor(o, l) {
      if (super(), this.privErrors = s.ConversationConnectionConfig.restErrors, this.onConnected = (u) => {
        var h;
        this.privIsConnected = !0;
        try {
          (h = this.privConversationTranslator) != null && h.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, u);
        } catch {
        }
      }, this.onDisconnected = (u) => {
        var h;
        try {
          (h = this.privConversationTranslator) != null && h.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, u);
        } catch {
        } finally {
          this.close(!1);
        }
      }, this.onCanceled = (u, h) => {
        var A;
        try {
          (A = this.privConversationTranslator) != null && A.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, h);
        } catch {
        }
      }, this.onParticipantUpdateCommandReceived = (u, h) => {
        try {
          const A = this.privParticipants.getParticipant(h.id);
          if (A !== void 0) {
            switch (h.key) {
              case s.ConversationTranslatorCommandTypes.changeNickname:
                A.displayName = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setUseTTS:
                A.isUsingTts = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setProfanityFiltering:
                A.profanity = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setMute:
                A.isMuted = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                A.translateToLanguages = h.value;
                break;
            }
            this.privParticipants.addOrUpdateParticipant(A), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.Updated, [this.toParticipant(A)], h.sessionId));
          }
        } catch {
        }
      }, this.onLockRoomCommandReceived = () => {
      }, this.onMuteAllCommandReceived = (u, h) => {
        try {
          this.privParticipants.participants.forEach((A) => A.isMuted = A.isHost ? !1 : h.isMuted), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.Updated, this.toParticipants(!1), h.sessionId));
        } catch {
        }
      }, this.onParticipantJoinCommandReceived = (u, h) => {
        try {
          const A = this.privParticipants.addOrUpdateParticipant(h.participant);
          A !== void 0 && this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.JoinedConversation, [this.toParticipant(A)], h.sessionId));
        } catch {
        }
      }, this.onParticipantLeaveCommandReceived = (u, h) => {
        try {
          const A = this.privParticipants.getParticipant(h.participant.id);
          A !== void 0 && (this.privParticipants.deleteParticipant(h.participant.id), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.LeftConversation, [this.toParticipant(A)], h.sessionId)));
        } catch {
        }
      }, this.onTranslationReceived = (u, h) => {
        try {
          switch (h.command) {
            case s.ConversationTranslatorMessageTypes.final:
              this.privConversationTranslator && this.privConversationTranslator.transcribed(this.privConversationTranslator, new r.ConversationTranslationEventArgs(h.payload, void 0, h.sessionId));
              break;
            case s.ConversationTranslatorMessageTypes.partial:
              this.privConversationTranslator && this.privConversationTranslator.transcribing(this.privConversationTranslator, new r.ConversationTranslationEventArgs(h.payload, void 0, h.sessionId));
              break;
            case s.ConversationTranslatorMessageTypes.instantMessage:
              this.privConversationTranslator && this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new r.ConversationTranslationEventArgs(h.payload, void 0, h.sessionId));
              break;
          }
        } catch {
        }
      }, this.onParticipantsListReceived = (u, h) => {
        var A;
        try {
          if (h.sessionToken !== void 0 && h.sessionToken !== null && (this.privRoom.token = h.sessionToken), this.privParticipants.participants = [...h.participants], this.privParticipants.me !== void 0 && (this.privIsReady = !0), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.JoinedConversation, this.toParticipants(!0), h.sessionId)), this.me.isHost) {
            const g = (A = this.privConversationTranslator) == null ? void 0 : A.properties.getProperty(r.PropertyId.ConversationTranslator_Name);
            g !== void 0 && g.length > 0 && g !== this.me.displayName && this.changeNicknameAsync(g);
          }
        } catch {
        }
      }, this.onConversationExpiration = (u, h) => {
        try {
          this.privConversationTranslator && this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, h);
        } catch {
        }
      }, this.privIsConnected = !1, this.privIsDisposed = !1, this.privConversationId = "", this.privProperties = new r.PropertyCollection(), this.privManager = new s.ConversationManager(), o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]) || o.setProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage], s.ConversationConnectionConfig.defaultLanguageCode), this.privLanguage = o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]), l)
        this.privConversationId = l;
      else {
        o.targetLanguages.length === 0 && o.addTargetLanguage(this.privLanguage), o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceResponse_ProfanityOption]) || o.setProfanity(r.ProfanityOption.Masked);
        let h = o.getProperty(r.PropertyId[r.PropertyId.ConversationTranslator_Name]);
        h == null && (h = "Host"), i.Contracts.throwIfNullOrTooLong(h, "nickname", 50), i.Contracts.throwIfNullOrTooShort(h, "nickname", 2), o.setProperty(r.PropertyId[r.PropertyId.ConversationTranslator_Name], h);
      }
      this.privConfig = o;
      const d = o;
      i.Contracts.throwIfNull(d, "speechConfig"), this.privProperties = d.properties.clone(), this.privIsConnected = !1, this.privParticipants = new s.InternalParticipants(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    // get the internal data about a conversation
    get room() {
      return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
      return this.privConversationRecognizer;
    }
    // get the config
    get config() {
      return this.privConfig;
    }
    // get the conversation Id
    get conversationId() {
      return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
      return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
      return this.privLanguage;
    }
    get isMutedByHost() {
      var o, l;
      return (o = this.privParticipants.me) != null && o.isHost ? !1 : (l = this.privParticipants.me) == null ? void 0 : l.isMuted;
    }
    get isConnected() {
      return this.privIsConnected && this.privIsReady;
    }
    get participants() {
      return this.toParticipants(!0);
    }
    get me() {
      return this.toParticipant(this.privParticipants.me);
    }
    get host() {
      return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
      return this.privTranscriberRecognizer;
    }
    get conversationInfo() {
      const o = this.conversationId, l = this.participants.map((u) => ({
        id: u.id,
        preferredLanguage: u.preferredLanguage,
        voice: u.voice
      })), c = {};
      for (const u of s.ConversationConnectionConfig.transcriptionEventKeys) {
        const h = this.properties.getProperty(u, "");
        h !== "" && (c[u] = h);
      }
      return { id: o, participants: l, conversationProperties: c };
    }
    get canSend() {
      var o;
      return this.privIsConnected && !((o = this.privParticipants.me) != null && o.isMuted);
    }
    get canSendAsHost() {
      var o;
      return this.privIsConnected && ((o = this.privParticipants.me) == null ? void 0 : o.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
      return this.privToken;
    }
    set authorizationToken(o) {
      i.Contracts.throwIfNullOrWhitespace(o, "authorizationToken"), this.privToken = o;
    }
    set conversationTranslator(o) {
      this.privConversationTranslator = o;
    }
    onToken(o) {
      this.privConversationTranslator.onToken(o);
    }
    /**
     * Create a new conversation as Host
     * @param cb
     * @param err
     */
    createConversationAsync(o, l) {
      try {
        this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), l), this.privManager.createOrJoin(this.privProperties, void 0, (c) => {
          c || this.handleError(new Error(this.privErrors.permissionDeniedConnect), l), this.privRoom = c, this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Starts a new conversation as host.
     * @param cb
     * @param err
     */
    startConversationAsync(o, l) {
      try {
        this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), l), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer = s.ConversationRecognizerFactory.fromConfig(this, this.privConfig), this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Join a conversation as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */
    addParticipantAsync(o, l, c) {
      i.Contracts.throwIfNullOrUndefined(o, "Participant"), a.marshalPromiseToCallbacks(this.addParticipantImplAsync(o), l, c);
    }
    /**
     * Join a conversation as a participant.
     * @param conversation
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */
    joinConversationAsync(o, l, c, d, u) {
      try {
        i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), i.Contracts.throwIfNullOrWhitespace(l, this.privErrors.invalidArgs.replace("{arg}", "nickname")), i.Contracts.throwIfNullOrWhitespace(c, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, o, (h) => {
          i.Contracts.throwIfNullOrUndefined(h, this.privErrors.permissionDeniedConnect), this.privRoom = h, this.privConfig.authorizationToken = h.cognitiveSpeechAuthToken, d && d(h.cognitiveSpeechAuthToken);
        }, (h) => {
          this.handleError(h, u);
        });
      } catch (h) {
        this.handleError(h, u);
      }
    }
    /**
     * Deletes a conversation
     * @param cb
     * @param err
     */
    deleteConversationAsync(o, l) {
      a.marshalPromiseToCallbacks(this.deleteConversationImplAsync(), o, l);
    }
    async deleteConversationImplAsync() {
      i.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), i.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), await this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */
    endConversationAsync(o, l) {
      a.marshalPromiseToCallbacks(this.endConversationImplAsync(), o, l);
    }
    endConversationImplAsync() {
      return this.close(!0);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */
    lockConversationAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!0), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to mute the conversation
     * @param cb
     * @param err
     */
    muteAllParticipantsAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!0), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to mute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */
    muteParticipantAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "userId")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), !this.me.isHost && this.me.id !== o && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), c), this.privParticipants.getParticipantIndex(o) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(o, !0), () => {
          this.handleCallback(l, c);
        }, (u) => {
          this.handleError(u, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */
    removeParticipantAsync(o, l, c) {
      try {
        if (i.Contracts.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && o.hasOwnProperty("id"))
          a.marshalPromiseToCallbacks(this.removeParticipantImplAsync(o), l, c);
        else {
          i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), c);
          let d = "";
          typeof o == "string" ? d = o : o.hasOwnProperty("id") ? d = o.id : o.hasOwnProperty("userId") && (d = o.userId), i.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((h) => h.id === d) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getEjectCommand(d), () => {
            this.handleCallback(l, c);
          }, (h) => {
            this.handleError(h, c);
          });
        }
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Issues a request to unlock the conversation
     * @param cb
     * @param err
     */
    unlockConversationAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!1), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to unmute all participants in the conversation
     * @param cb
     * @param err
     */
    unmuteAllParticipantsAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!1), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to unmute a participant in the conversation
     * @param userId
     * @param cb
     * @param err
     */
    unmuteParticipantAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "userId")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), !this.me.isHost && this.me.id !== o && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), c), this.privParticipants.getParticipantIndex(o) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(o, !1), () => {
          this.handleCallback(l, c);
        }, (u) => {
          this.handleError(u, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */
    sendTextMessageAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "message")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), o.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMessageCommand(o), () => {
          this.handleCallback(l, c);
        }, (d) => {
          this.handleError(d, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */
    setTranslatedLanguagesAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfArrayEmptyOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "languages")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(o), () => {
          this.handleCallback(l, c);
        }, (d) => {
          this.handleError(d, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */
    changeNicknameAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "nickname")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(o), () => {
          this.handleCallback(l, c);
        }, (d) => {
          this.handleError(d, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    dispose() {
      this.isDisposed || (this.privIsDisposed = !0, this.config && this.config.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    async connectTranscriberRecognizer(o) {
      this.privTranscriberRecognizer && await this.privTranscriberRecognizer.close(), await o.enforceAudioGating(), this.privTranscriberRecognizer = o, this.privTranscriberRecognizer.conversation = this;
    }
    getKeepAlive() {
      const o = this.me ? this.me.displayName : "default_nickname";
      return JSON.stringify({
        id: "0",
        nickname: o,
        participantId: this.privRoom.participantId,
        roomId: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.keepAlive
      });
    }
    /* eslint-enable @typescript-eslint/typedef */
    addParticipantImplAsync(o) {
      if (this.privParticipants.addOrUpdateParticipant(o) !== void 0 && this.privTranscriberRecognizer) {
        const c = this.conversationInfo;
        return c.participants = [o], this.privTranscriberRecognizer.pushConversationEvent(c, "join");
      }
    }
    removeParticipantImplAsync(o) {
      this.privParticipants.deleteParticipant(o.id);
      const l = this.conversationInfo;
      return l.participants = [o], this.privTranscriberRecognizer.pushConversationEvent(l, "leave");
    }
    async close(o) {
      var l;
      try {
        this.privIsConnected = !1, await ((l = this.privConversationRecognizer) == null ? void 0 : l.close()), this.privConversationRecognizer = void 0, this.privConversationTranslator && this.privConversationTranslator.dispose();
      } catch (c) {
        throw c;
      }
      o && this.dispose();
    }
    /** Helpers */
    handleCallback(o, l) {
      if (o) {
        try {
          o();
        } catch (c) {
          l && l(c);
        }
        o = void 0;
      }
    }
    handleError(o, l) {
      if (l)
        if (o instanceof Error) {
          const c = o;
          l(c.name + ": " + c.message);
        } else
          l(o);
    }
    /** Participant Helpers */
    toParticipants(o) {
      const l = this.privParticipants.participants.map((c) => this.toParticipant(c));
      return o ? l : l.filter((c) => c.isHost === !1);
    }
    toParticipant(o) {
      return new r.Participant(o.id, o.avatar, o.displayName, o.isHost, o.isMuted, o.isUsingTts, o.preferredLanguage, o.voice);
    }
    getMuteAllCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setMuteAll,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getMuteCommand(o, l) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(o, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setMute,
        // eslint-disable-next-line object-shorthand
        participantId: o,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: l
      });
    }
    getLockCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setLockState,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getEjectCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(o, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.ejectParticipant,
        // eslint-disable-next-line object-shorthand
        participantId: o,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand
      });
    }
    getSetTranslateToLanguagesCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setTranslateToLanguages,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getChangeNicknameCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(o, "nickname"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.changeNickname,
        nickname: o,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getMessageCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), i.Contracts.throwIfNullOrWhitespace(o, "message"), JSON.stringify({
        participantId: this.privRoom.participantId,
        roomId: this.privRoom.roomId,
        text: o,
        type: s.ConversationTranslatorMessageTypes.instantMessage
      });
    }
  }
  return Th.ConversationImpl = n, Th;
}
var c2 = {};
Object.defineProperty(c2, "__esModule", { value: !0 });
c2.ConversationCommon = void 0;
class BH {
  constructor(a) {
    this.privAudioConfig = a;
  }
  handleCallback(a, i) {
    if (a) {
      try {
        a();
      } catch (r) {
        i && i(r);
      }
      a = void 0;
    }
  }
  handleError(a, i) {
    if (i)
      if (a instanceof Error) {
        const r = a;
        i(r.name + ": " + r.message);
      } else
        i(a);
  }
}
c2.ConversationCommon = BH;
var Zf = {}, yQ;
function ZH() {
  if (yQ) return Zf;
  yQ = 1, Object.defineProperty(Zf, "__esModule", { value: !0 }), Zf.ConversationExpirationEventArgs = void 0;
  const s = Hr();
  let a = class extends s.SessionEventArgs {
    constructor(r, e) {
      super(e), this.privExpirationTime = r;
    }
    /** How much longer until the conversation expires (in minutes). */
    get expirationTime() {
      return this.privExpirationTime;
    }
  };
  return Zf.ConversationExpirationEventArgs = a, Zf;
}
var Sf = {}, QQ;
function SH() {
  if (QQ) return Sf;
  QQ = 1, Object.defineProperty(Sf, "__esModule", { value: !0 }), Sf.ConversationParticipantsChangedEventArgs = void 0;
  const s = Hr();
  let a = class extends s.SessionEventArgs {
    constructor(r, e, n) {
      super(n), this.privReason = r, this.privParticipant = e;
    }
    get reason() {
      return this.privReason;
    }
    get participants() {
      return this.privParticipant;
    }
  };
  return Sf.ConversationParticipantsChangedEventArgs = a, Sf;
}
var Ef = {}, CQ;
function EH() {
  if (CQ) return Ef;
  CQ = 1, Object.defineProperty(Ef, "__esModule", { value: !0 }), Ef.ConversationTranslationCanceledEventArgs = void 0;
  const s = am();
  let a = class extends s.CancellationEventArgsBase {
  };
  return Ef.ConversationTranslationCanceledEventArgs = a, Ef;
}
var Vf = {}, UQ;
function VH() {
  if (UQ) return Vf;
  UQ = 1, Object.defineProperty(Vf, "__esModule", { value: !0 }), Vf.ConversationTranslationEventArgs = void 0;
  const s = Hr();
  let a = class extends s.RecognitionEventArgs {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {ConversationTranslationResult} result - The translation recognition result.
     * @param {number} offset - The offset.
     * @param {string} sessionId - The session id.
     */
    constructor(r, e, n) {
      super(e, n), this.privResult = r;
    }
    /**
     * Specifies the recognition result.
     * @returns {ConversationTranslationResult} the recognition result.
     */
    get result() {
      return this.privResult;
    }
  };
  return Vf.ConversationTranslationEventArgs = a, Vf;
}
var Wf = {}, IQ;
function WH() {
  if (IQ) return Wf;
  IQ = 1, Object.defineProperty(Wf, "__esModule", { value: !0 }), Wf.ConversationTranslationResult = void 0;
  const s = sZ();
  let a = class extends s.TranslationRecognitionResult {
    constructor(r, e, n, t, o, l, c, d, u, h, A) {
      super(e, t, o, l, c, d, void 0, void 0, u, h, A), this.privId = r, this.privOrigLang = n;
    }
    /**
     * The unique identifier for the participant this result is for.
     */
    get participantId() {
      return this.privId;
    }
    /**
     * The original language this result was in.
     */
    get originalLang() {
      return this.privOrigLang;
    }
  };
  return Wf.ConversationTranslationResult = a, Wf;
}
var Kv = {}, Nf = {}, lm = {};
Object.defineProperty(lm, "__esModule", { value: !0 });
lm.StringUtils = void 0;
class NH {
  /**
   * Formats a string by replacing the named {keys} in the string with the values contained in the replacement dictionary.
   * @param format The format string that contains the parts to replace surrounded by {}. For example: "wss://{region}.cts.speech.microsoft.com".
   * If your string needs to contain a { or } you can use the {{ and }} escape sequences respectively.
   * @param replacements The dictionary of replacements. If a replacement is not found, it is replaced with an empty string
   * @returns The formatted string. If you pass in a null or undefined format string, an empty string will be returned
   */
  static formatString(a, i) {
    if (!a)
      return "";
    if (!i)
      return a;
    let r = "", e = "";
    const n = (l) => {
      r += l;
    }, t = (l) => {
      e += l;
    };
    let o = n;
    for (let l = 0; l < a.length; l++) {
      const c = a[l], d = l + 1 < a.length ? a[l + 1] : "";
      switch (c) {
        case "{":
          d === "{" ? (o("{"), l++) : o = t;
          break;
        case "}":
          d === "}" ? (o("}"), l++) : (i.hasOwnProperty(e) && (r += i[e]), o = n, e = "");
          break;
        default:
          o(c);
          break;
      }
    }
    return r;
  }
}
lm.StringUtils = NH;
var BQ;
function JH() {
  if (BQ) return Nf;
  BQ = 1, Object.defineProperty(Nf, "__esModule", { value: !0 }), Nf.ConversationTranslatorConnectionFactory = void 0;
  const s = Xc(), a = lm, i = _o, r = Hr(), e = Tc, n = Iu, t = Bu(), o = wi();
  let l = class IZ extends t.ConnectionFactoryBase {
    constructor(d) {
      super(), i.Contracts.throwIfNullOrUndefined(d, "convGetter"), this.privConvGetter = d;
    }
    create(d, u, h) {
      const A = d.parameters.getProperty("ConversationTranslator_MultiChannelAudio", "").toUpperCase() === "TRUE", g = this.privConvGetter().room, f = g.cognitiveSpeechRegion || d.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Region, ""), p = {
        hostSuffix: t.ConnectionFactoryBase.getHostSuffix(f),
        path: IZ.CTS_VIRT_MIC_PATH,
        region: encodeURIComponent(f)
      };
      p[n.QueryParameterNames.Language] = encodeURIComponent(d.parameters.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage, "")), p[n.QueryParameterNames.CtsMeetingId] = encodeURIComponent(g.roomId), p[n.QueryParameterNames.CtsDeviceId] = encodeURIComponent(g.participantId), p[n.QueryParameterNames.CtsIsParticipant] = g.isHost ? "" : "&" + n.QueryParameterNames.CtsIsParticipant;
      let v = "";
      const b = {}, m = {};
      if (A) {
        v = d.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Endpoint), v || (v = "wss://" + d.parameters.getProperty(r.PropertyId.SpeechServiceConnection_Host, "transcribe.{region}.cts.speech{hostSuffix}") + "{path}"), v = a.StringUtils.formatString(v, p);
        const U = new URL(v);
        U.searchParams.forEach((Q, N) => {
          b[N] = Q;
        }), new o.TranscriberConnectionFactory().setQueryParams(b, d, v), b[n.QueryParameterNames.CtsMeetingId] = p[n.QueryParameterNames.CtsMeetingId], b[n.QueryParameterNames.CtsDeviceId] = p[n.QueryParameterNames.CtsDeviceId], g.isHost || (b[n.QueryParameterNames.CtsIsParticipant] = ""), n.QueryParameterNames.Format in b || (b[n.QueryParameterNames.Format] = "simple"), U.searchParams.forEach((Q, N) => {
          U.searchParams.set(N, b[N]), delete b[N];
        }), v = U.toString();
      } else {
        const U = new o.TranslationConnectionFactory();
        v = U.getEndpointUrl(d, !0), v = a.StringUtils.formatString(v, p), U.setQueryParams(b, d, v);
      }
      m[e.HeaderNames.ConnectionId] = h, m[s.RestConfigBase.configParams.token] = g.token, u.token && (m[u.headerName] = u.token);
      const y = d.parameters.getProperty("SPEECH-EnableWebsocketCompression", "").toUpperCase() === "TRUE";
      return new s.WebsocketConnection(v, b, m, new o.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(d), y, h);
    }
  };
  return Nf.ConversationTranslatorConnectionFactory = l, l.CTS_VIRT_MIC_PATH = "/speech/recognition/dynamicaudio", Nf;
}
var ZQ;
function GH() {
  return ZQ || (ZQ = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.ConversationTranslator = s.SpeechState = void 0;
    const a = wi(), i = JH(), r = Eo(), e = _o, n = Hr(), t = UZ(), o = fF();
    var l;
    (function(u) {
      u[u.Inactive = 0] = "Inactive", u[u.Connecting = 1] = "Connecting", u[u.Connected = 2] = "Connected";
    })(l = s.SpeechState || (s.SpeechState = {}));
    class c extends n.TranslationRecognizer {
      constructor(h, A, g, f) {
        super(h, A, new i.ConversationTranslatorConnectionFactory(f)), this.privSpeechState = l.Inactive, g && (this.privTranslator = g, this.sessionStarted = () => {
          this.privSpeechState = l.Connected;
        }, this.sessionStopped = () => {
          this.privSpeechState = l.Inactive;
        }, this.recognizing = (p, v) => {
          this.privTranslator.recognizing && this.privTranslator.recognizing(this.privTranslator, v);
        }, this.recognized = async (p, v) => {
          var b;
          (b = v.result) != null && b.errorDetails ? (await this.cancelSpeech(), this.fireCancelEvent(v.result.errorDetails)) : this.privTranslator.recognized && this.privTranslator.recognized(this.privTranslator, v);
        }, this.canceled = async () => {
          if (this.privSpeechState !== l.Inactive)
            try {
              await this.cancelSpeech();
            } catch {
              this.privSpeechState = l.Inactive;
            }
        });
      }
      get state() {
        return this.privSpeechState;
      }
      set state(h) {
        this.privSpeechState = h;
      }
      set authentication(h) {
        this.privReco.authentication = h;
      }
      onConnection() {
        this.privSpeechState = l.Connected;
      }
      async onCancelSpeech() {
        this.privSpeechState = l.Inactive, await this.cancelSpeech();
      }
      /**
       * Fire a cancel event
       * @param error
       */
      fireCancelEvent(h) {
        try {
          if (this.privTranslator.canceled) {
            const A = new o.ConversationTranslationCanceledEventArgs(n.CancellationReason.Error, h, n.CancellationErrorCode.RuntimeError);
            this.privTranslator.canceled(this.privTranslator, A);
          }
        } catch {
        }
      }
      async cancelSpeech() {
        var h;
        try {
          this.stopContinuousRecognitionAsync(), await ((h = this.privReco) == null ? void 0 : h.disconnect()), this.privSpeechState = l.Inactive;
        } catch {
        }
      }
    }
    class d extends o.ConversationCommon {
      constructor(h) {
        super(h), this.privErrors = a.ConversationConnectionConfig.restErrors, this.privIsDisposed = !1, this.privIsSpeaking = !1, this.privPlaceholderKey = "abcdefghijklmnopqrstuvwxyz012345", this.privPlaceholderRegion = "westus", this.privProperties = new n.PropertyCollection();
      }
      get properties() {
        return this.privProperties;
      }
      get speechRecognitionLanguage() {
        return this.privSpeechRecognitionLanguage;
      }
      get participants() {
        var h;
        return (h = this.privConversation) == null ? void 0 : h.participants;
      }
      get canSpeak() {
        return !(!this.privConversation.isConnected || !this.privCTRecognizer || this.privIsSpeaking || this.privCTRecognizer.state === l.Connected || this.privCTRecognizer.state === l.Connecting || this.privConversation.isMutedByHost);
      }
      onToken(h) {
        this.privCTRecognizer.authentication = h;
      }
      setServiceProperty(h, A) {
        const g = JSON.parse(this.privProperties.getProperty(a.ServicePropertiesPropertyName, "{}"));
        g[h] = A, this.privProperties.setProperty(a.ServicePropertiesPropertyName, JSON.stringify(g));
      }
      joinConversationAsync(h, A, g, f, p) {
        try {
          if (typeof h == "string") {
            e.Contracts.throwIfNullOrUndefined(h, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), e.Contracts.throwIfNullOrWhitespace(A, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privConversation && this.handleError(new Error(this.privErrors.permissionDeniedStart), p);
            let v = g;
            (v == null || v === "") && (v = a.ConversationConnectionConfig.defaultLanguageCode), this.privSpeechTranslationConfig = n.SpeechTranslationConfig.fromSubscription(this.privPlaceholderKey, this.privPlaceholderRegion), this.privSpeechTranslationConfig.setProfanity(n.ProfanityOption.Masked), this.privSpeechTranslationConfig.addTargetLanguage(v), this.privSpeechTranslationConfig.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_RecoLanguage], v), this.privSpeechTranslationConfig.setProperty(n.PropertyId[n.PropertyId.ConversationTranslator_Name], A);
            const b = [
              n.PropertyId.SpeechServiceConnection_Host,
              n.PropertyId.ConversationTranslator_Host,
              n.PropertyId.SpeechServiceConnection_Endpoint,
              n.PropertyId.SpeechServiceConnection_ProxyHostName,
              n.PropertyId.SpeechServiceConnection_ProxyPassword,
              n.PropertyId.SpeechServiceConnection_ProxyPort,
              n.PropertyId.SpeechServiceConnection_ProxyUserName,
              "ConversationTranslator_MultiChannelAudio",
              "ConversationTranslator_Region"
            ];
            for (const y of b) {
              const U = this.privProperties.getProperty(y);
              if (U) {
                const B = typeof y == "string" ? y : n.PropertyId[y];
                this.privSpeechTranslationConfig.setProperty(B, U);
              }
            }
            const m = JSON.parse(this.privProperties.getProperty(a.ServicePropertiesPropertyName, "{}"));
            for (const y of Object.keys(m))
              this.privSpeechTranslationConfig.setServiceProperty(y, m[y], n.ServicePropertyChannel.UriQueryParameter);
            this.privConversation = new t.ConversationImpl(this.privSpeechTranslationConfig), this.privConversation.conversationTranslator = this, this.privConversation.joinConversationAsync(h, A, v, (y) => {
              y || this.handleError(new Error(this.privErrors.permissionDeniedConnect), p), this.privSpeechTranslationConfig.authorizationToken = y, this.privConversation.room.isHost = !1, this.privConversation.startConversationAsync(() => {
                this.handleCallback(f, p);
              }, (U) => {
                this.handleError(U, p);
              });
            }, (y) => {
              this.handleError(y, p);
            });
          } else typeof h == "object" ? (e.Contracts.throwIfNullOrUndefined(h, this.privErrors.invalidArgs.replace("{arg}", "conversation id")), e.Contracts.throwIfNullOrWhitespace(A, this.privErrors.invalidArgs.replace("{arg}", "nickname")), this.privProperties.setProperty(n.PropertyId.ConversationTranslator_Name, A), this.privConversation = h, this.privConversation.conversationTranslator = this, this.privConversation.room.isHost = !0, e.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedConnect), e.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privSpeechTranslationConfig = h.config, this.handleCallback(g, f)) : this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "invalid conversation type")), f);
        } catch (v) {
          this.handleError(v, typeof g == "string" ? p : f);
        }
      }
      /**
       * Leave the conversation
       * @param cb
       * @param err
       */
      leaveConversationAsync(h, A) {
        r.marshalPromiseToCallbacks((async () => {
          await this.cancelSpeech(), await this.privConversation.endConversationImplAsync(), await this.privConversation.deleteConversationImplAsync(), this.dispose();
        })(), h, A);
      }
      /**
       * Send a text message
       * @param message
       * @param cb
       * @param err
       */
      sendTextMessageAsync(h, A, g) {
        try {
          e.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), e.Contracts.throwIfNullOrWhitespace(h, this.privErrors.invalidArgs.replace("{arg}", h)), this.privConversation.sendTextMessageAsync(h, A, g);
        } catch (f) {
          this.handleError(f, g);
        }
      }
      /**
       * Start speaking
       * @param cb
       * @param err
       */
      startTranscribingAsync(h, A) {
        r.marshalPromiseToCallbacks((async () => {
          try {
            e.Contracts.throwIfNullOrUndefined(this.privConversation, this.privErrors.permissionDeniedSend), e.Contracts.throwIfNullOrUndefined(this.privConversation.room.token, this.privErrors.permissionDeniedConnect), this.privCTRecognizer === void 0 && await this.connectTranslatorRecognizer(), e.Contracts.throwIfNullOrUndefined(this.privCTRecognizer, this.privErrors.permissionDeniedSend), this.canSpeak || this.handleError(new Error(this.privErrors.permissionDeniedSend), A), await this.startContinuousRecognition(), this.privIsSpeaking = !0;
          } catch (g) {
            throw this.privIsSpeaking = !1, await this.cancelSpeech(), g;
          }
        })(), h, A);
      }
      /**
       * Stop speaking
       * @param cb
       * @param err
       */
      stopTranscribingAsync(h, A) {
        r.marshalPromiseToCallbacks((async () => {
          try {
            if (!this.privIsSpeaking) {
              await this.cancelSpeech();
              return;
            }
            this.privIsSpeaking = !1, await new Promise((g, f) => {
              this.privCTRecognizer.stopContinuousRecognitionAsync(g, f);
            });
          } catch {
            await this.cancelSpeech();
          }
        })(), h, A);
      }
      isDisposed() {
        return this.privIsDisposed;
      }
      dispose(h, A, g) {
        r.marshalPromiseToCallbacks((async () => {
          this.isDisposed && !this.privIsSpeaking || (await this.cancelSpeech(), this.privIsDisposed = !0, this.privSpeechTranslationConfig.close(), this.privSpeechRecognitionLanguage = void 0, this.privProperties = void 0, this.privAudioConfig = void 0, this.privSpeechTranslationConfig = void 0, this.privConversation.dispose(), this.privConversation = void 0);
        })(), A, g);
      }
      /**
       * Cancel the speech websocket
       */
      async cancelSpeech() {
        var h;
        try {
          this.privIsSpeaking = !1, await ((h = this.privCTRecognizer) == null ? void 0 : h.onCancelSpeech()), this.privCTRecognizer = void 0;
        } catch {
        }
      }
      /**
       * Connect to the speech translation recognizer.
       * Currently there is no language validation performed before sending the SpeechLanguage code to the service.
       * If it's an invalid language the raw error will be: 'Error during WebSocket handshake: Unexpected response code: 400'
       * e.g. pass in 'fr' instead of 'fr-FR', or a text-only language 'cy'
       */
      async connectTranslatorRecognizer() {
        try {
          this.privAudioConfig === void 0 && (this.privAudioConfig = n.AudioConfig.fromDefaultMicrophoneInput()), this.privSpeechTranslationConfig.getProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_Key]) === this.privPlaceholderKey && this.privSpeechTranslationConfig.setProperty(n.PropertyId[n.PropertyId.SpeechServiceConnection_Key], "");
          const h = () => this.privConversation;
          this.privCTRecognizer = new c(this.privSpeechTranslationConfig, this.privAudioConfig, this, h);
        } catch (h) {
          throw await this.cancelSpeech(), h;
        }
      }
      /**
       * Handle the start speaking request
       */
      startContinuousRecognition() {
        return new Promise((h, A) => {
          this.privCTRecognizer.startContinuousRecognitionAsync(h, A);
        });
      }
    }
    s.ConversationTranslator = d;
  }(Kv)), Kv;
}
var Jf = {}, SQ;
function TH() {
  if (SQ) return Jf;
  SQ = 1, Object.defineProperty(Jf, "__esModule", { value: !0 }), Jf.ConversationTranscriber = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class BZ extends r.Recognizer {
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */
    constructor(t, o) {
      const l = t;
      i.Contracts.throwIfNull(l, "speechConfig"), i.Contracts.throwIfNullOrWhitespace(l.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage), r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]), super(o, l.properties, new s.ConversationTranscriberConnectionFactory()), this.privProperties.setProperty(r.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, "2"), this.privDisposedRecognizer = !1;
    }
    /**
     * ConversationTranscriber constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this recognizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */
    static FromConfig(t, o, l) {
      const c = t;
      return o.properties.mergeTo(c.properties), new BZ(t, l);
    }
    /**
     * Gets the endpoint id of a customized speech model that is used for transcription.
     * @member ConversationTranscriber.prototype.endpointId
     * @function
     * @public
     * @returns {string} the endpoint id of a customized speech model that is used for speech recognition.
     */
    get endpointId() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(r.PropertyId.SpeechServiceConnection_EndpointId, "00000000-0000-0000-0000-000000000000");
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member ConversationTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(t) {
      i.Contracts.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(r.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    /**
     * Gets the spoken language of transcription.
     * @member ConversationTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of transcription.
     */
    get speechRecognitionLanguage() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * Gets the output format of transcription.
     * @member ConversationTranscriber.prototype.outputFormat
     * @function
     * @public
     * @returns {OutputFormat} The output format of transcription.
     */
    get outputFormat() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(s.OutputFormatPropertyName, r.OutputFormat[r.OutputFormat.Simple]) === r.OutputFormat[r.OutputFormat.Simple] ? r.OutputFormat.Simple : r.OutputFormat.Detailed;
    }
    /**
     * The collection of properties and their values defined for this conversation transcriber.
     * @member ConversationTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechRecognizer.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Starts conversation transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member ConversationTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */
    startTranscribingAsync(t, o) {
      a.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(s.RecognitionMode.Conversation), t, o);
    }
    /**
     * Stops conversation transcription.
     * @member ConversationTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has stopped.
     * @param err - Callback invoked in case of an error.
     */
    stopTranscribingAsync(t, o) {
      a.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), t, o);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member ConversationTranscriber.prototype.close
     * @function
     * @public
     */
    close(t, o) {
      i.Contracts.throwIfDisposed(this.privDisposedRecognizer), a.marshalPromiseToCallbacks(this.dispose(!0), t, o);
    }
    /**
     * Disposes any resources held by the object.
     * @member SpeechRecognizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */
    async dispose(t) {
      this.privDisposedRecognizer || (t && (this.privDisposedRecognizer = !0, await this.implRecognizerStop()), await super.dispose(t));
    }
    createRecognizerConfig(t) {
      return new s.RecognizerConfig(t, this.privProperties);
    }
    createServiceRecognizer(t, o, l, c) {
      const d = l;
      return c.isSpeakerDiarizationEnabled = !0, new s.ConversationTranscriptionServiceRecognizer(t, o, d, c, this);
    }
  };
  return Jf.ConversationTranscriber = e, Jf;
}
var Xh = {}, EQ;
function XH() {
  if (EQ) return Xh;
  EQ = 1, Object.defineProperty(Xh, "__esModule", { value: !0 }), Xh.Participant = Xh.User = void 0;
  const s = Hr();
  class a {
    constructor(e) {
      this.privUserId = e;
    }
    get userId() {
      return this.privUserId;
    }
  }
  Xh.User = a;
  class i {
    constructor(e, n, t, o, l, c, d, u) {
      this.privId = e, this.privAvatar = n, this.privDisplayName = t, this.privIsHost = o, this.privIsMuted = l, this.privIsUsingTts = c, this.privPreferredLanguage = d, this.privVoice = u, this.privProperties = new s.PropertyCollection();
    }
    get avatar() {
      return this.privAvatar;
    }
    get displayName() {
      return this.privDisplayName;
    }
    get id() {
      return this.privId;
    }
    get preferredLanguage() {
      return this.privPreferredLanguage;
    }
    get isHost() {
      return this.privIsHost;
    }
    get isMuted() {
      return this.privIsMuted;
    }
    get isUsingTts() {
      return this.privIsUsingTts;
    }
    get voice() {
      return this.privVoice;
    }
    get properties() {
      return this.privProperties;
    }
    static From(e, n, t) {
      return new i(e, "", e, !1, !1, !1, n, t);
    }
  }
  return Xh.Participant = i, Xh;
}
var ZZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.ParticipantChangedReason = void 0, function(a) {
    a[a.JoinedConversation = 0] = "JoinedConversation", a[a.LeftConversation = 1] = "LeftConversation", a[a.Updated = 2] = "Updated";
  }(s.ParticipantChangedReason || (s.ParticipantChangedReason = {}));
})(ZZ);
var kh = {}, VQ;
function kH() {
  if (VQ) return kh;
  VQ = 1, Object.defineProperty(kh, "__esModule", { value: !0 }), kh.MeetingImpl = kh.Meeting = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class {
    constructor() {
    }
    /**
     * Create a meeting
     * @param speechConfig
     * @param meetingId
     * @param cb
     * @param err
     */
    static createMeetingAsync(o, l, c, d) {
      if (i.Contracts.throwIfNullOrUndefined(o, s.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "config")), i.Contracts.throwIfNullOrUndefined(o.region, s.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Region")), i.Contracts.throwIfNull(l, "meetingId"), l.length === 0)
        throw new Error("meetingId cannot be empty");
      !o.subscriptionKey && !o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceAuthorization_Token]) && i.Contracts.throwIfNullOrUndefined(o.subscriptionKey, s.ConversationConnectionConfig.restErrors.invalidArgs.replace("{arg}", "SpeechServiceConnection_Key"));
      const u = new n(o, l);
      return a.marshalPromiseToCallbacks((async () => {
      })(), c, d), u;
    }
  };
  kh.Meeting = e;
  class n extends e {
    /**
     * Create a Meeting impl
     * @param speechConfig
     * @param {string} id - optional conversationId
     */
    constructor(o, l) {
      super(), this.privErrors = s.ConversationConnectionConfig.restErrors, this.onConnected = (u) => {
        var h;
        this.privIsConnected = !0;
        try {
          (h = this.privConversationTranslator) != null && h.sessionStarted && this.privConversationTranslator.sessionStarted(this.privConversationTranslator, u);
        } catch {
        }
      }, this.onDisconnected = (u) => {
        var h;
        try {
          (h = this.privConversationTranslator) != null && h.sessionStopped && this.privConversationTranslator.sessionStopped(this.privConversationTranslator, u);
        } catch {
        } finally {
          this.close(!1);
        }
      }, this.onCanceled = (u, h) => {
        var A;
        try {
          (A = this.privConversationTranslator) != null && A.canceled && this.privConversationTranslator.canceled(this.privConversationTranslator, h);
        } catch {
        }
      }, this.onParticipantUpdateCommandReceived = (u, h) => {
        try {
          const A = this.privParticipants.getParticipant(h.id);
          if (A !== void 0) {
            switch (h.key) {
              case s.ConversationTranslatorCommandTypes.changeNickname:
                A.displayName = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setUseTTS:
                A.isUsingTts = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setProfanityFiltering:
                A.profanity = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setMute:
                A.isMuted = h.value;
                break;
              case s.ConversationTranslatorCommandTypes.setTranslateToLanguages:
                A.translateToLanguages = h.value;
                break;
            }
            this.privParticipants.addOrUpdateParticipant(A), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.Updated, [this.toParticipant(A)], h.sessionId));
          }
        } catch {
        }
      }, this.onLockRoomCommandReceived = () => {
      }, this.onMuteAllCommandReceived = (u, h) => {
        try {
          this.privParticipants.participants.forEach((A) => A.isMuted = A.isHost ? !1 : h.isMuted), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.Updated, this.toParticipants(!1), h.sessionId));
        } catch {
        }
      }, this.onParticipantJoinCommandReceived = (u, h) => {
        try {
          const A = this.privParticipants.addOrUpdateParticipant(h.participant);
          A !== void 0 && this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.JoinedConversation, [this.toParticipant(A)], h.sessionId));
        } catch {
        }
      }, this.onParticipantLeaveCommandReceived = (u, h) => {
        try {
          const A = this.privParticipants.getParticipant(h.participant.id);
          A !== void 0 && (this.privParticipants.deleteParticipant(h.participant.id), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.LeftConversation, [this.toParticipant(A)], h.sessionId)));
        } catch {
        }
      }, this.onTranslationReceived = (u, h) => {
        try {
          switch (h.command) {
            case s.ConversationTranslatorMessageTypes.final:
              this.privConversationTranslator && this.privConversationTranslator.transcribed(this.privConversationTranslator, new r.ConversationTranslationEventArgs(h.payload, void 0, h.sessionId));
              break;
            case s.ConversationTranslatorMessageTypes.partial:
              this.privConversationTranslator && this.privConversationTranslator.transcribing(this.privConversationTranslator, new r.ConversationTranslationEventArgs(h.payload, void 0, h.sessionId));
              break;
            case s.ConversationTranslatorMessageTypes.instantMessage:
              this.privConversationTranslator && this.privConversationTranslator.textMessageReceived(this.privConversationTranslator, new r.ConversationTranslationEventArgs(h.payload, void 0, h.sessionId));
              break;
          }
        } catch {
        }
      }, this.onParticipantsListReceived = (u, h) => {
        var A;
        try {
          if (h.sessionToken !== void 0 && h.sessionToken !== null && (this.privRoom.token = h.sessionToken), this.privParticipants.participants = [...h.participants], this.privParticipants.me !== void 0 && (this.privIsReady = !0), this.privConversationTranslator && this.privConversationTranslator.participantsChanged(this.privConversationTranslator, new r.ConversationParticipantsChangedEventArgs(r.ParticipantChangedReason.JoinedConversation, this.toParticipants(!0), h.sessionId)), this.me.isHost) {
            const g = (A = this.privConversationTranslator) == null ? void 0 : A.properties.getProperty(r.PropertyId.ConversationTranslator_Name);
            g !== void 0 && g.length > 0 && g !== this.me.displayName && this.changeNicknameAsync(g);
          }
        } catch {
        }
      }, this.onConversationExpiration = (u, h) => {
        try {
          this.privConversationTranslator && this.privConversationTranslator.conversationExpiration(this.privConversationTranslator, h);
        } catch {
        }
      }, this.privIsConnected = !1, this.privIsDisposed = !1, this.privConversationId = "", this.privProperties = new r.PropertyCollection(), this.privManager = new s.ConversationManager(), o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]) || o.setProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage], s.ConversationConnectionConfig.defaultLanguageCode), this.privLanguage = o.getProperty(r.PropertyId[r.PropertyId.SpeechServiceConnection_RecoLanguage]), this.privConversationId = l, this.privConfig = o;
      const d = o;
      i.Contracts.throwIfNull(d, "speechConfig"), this.privProperties = d.properties.clone(), this.privIsConnected = !1, this.privParticipants = new s.InternalParticipants(), this.privIsReady = !1, this.privTextMessageMaxLength = 1e3;
    }
    // get the internal data about a conversation
    get room() {
      return this.privRoom;
    }
    // get the wrapper for connecting to the websockets
    get connection() {
      return this.privConversationRecognizer;
    }
    // get the config
    get config() {
      return this.privConfig;
    }
    // get the meeting Id
    get meetingId() {
      return this.privRoom ? this.privRoom.roomId : this.privConversationId;
    }
    // get the properties
    get properties() {
      return this.privProperties;
    }
    // get the speech language
    get speechRecognitionLanguage() {
      return this.privLanguage;
    }
    get isMutedByHost() {
      var o, l;
      return (o = this.privParticipants.me) != null && o.isHost ? !1 : (l = this.privParticipants.me) == null ? void 0 : l.isMuted;
    }
    get isConnected() {
      return this.privIsConnected && this.privIsReady;
    }
    get participants() {
      return this.toParticipants(!0);
    }
    get me() {
      return this.toParticipant(this.privParticipants.me);
    }
    get host() {
      return this.toParticipant(this.privParticipants.host);
    }
    get transcriberRecognizer() {
      return this.privTranscriberRecognizer;
    }
    get meetingInfo() {
      const o = this.meetingId, l = this.participants.map((u) => ({
        id: u.id,
        preferredLanguage: u.preferredLanguage,
        voice: u.voice
      })), c = {};
      for (const u of s.ConversationConnectionConfig.transcriptionEventKeys) {
        const h = this.properties.getProperty(u, "");
        h !== "" && (c[u] = h);
      }
      return { id: o, participants: l, meetingProperties: c };
    }
    get canSend() {
      var o;
      return this.privIsConnected && !((o = this.privParticipants.me) != null && o.isMuted);
    }
    get canSendAsHost() {
      var o;
      return this.privIsConnected && ((o = this.privParticipants.me) == null ? void 0 : o.isHost);
    }
    // get / set the speech auth token
    // eslint-disable-next-line @typescript-eslint/member-ordering
    get authorizationToken() {
      return this.privToken;
    }
    set authorizationToken(o) {
      i.Contracts.throwIfNullOrWhitespace(o, "authorizationToken"), this.privToken = o;
    }
    /**
     * Create a new meeting as Host
     * @param cb
     * @param err
     */
    createMeetingAsync(o, l) {
      try {
        this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), l), this.privManager.createOrJoin(this.privProperties, void 0, (c) => {
          c || this.handleError(new Error(this.privErrors.permissionDeniedConnect), l), this.privRoom = c, this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Starts a new meeting as host.
     * @param cb
     * @param err
     */
    startMeetingAsync(o, l) {
      try {
        this.privConversationRecognizer && this.handleError(new Error(this.privErrors.permissionDeniedStart), l), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedConnect), this.privParticipants.meId = this.privRoom.participantId, this.privConversationRecognizer.connected = this.onConnected, this.privConversationRecognizer.disconnected = this.onDisconnected, this.privConversationRecognizer.canceled = this.onCanceled, this.privConversationRecognizer.participantUpdateCommandReceived = this.onParticipantUpdateCommandReceived, this.privConversationRecognizer.lockRoomCommandReceived = this.onLockRoomCommandReceived, this.privConversationRecognizer.muteAllCommandReceived = this.onMuteAllCommandReceived, this.privConversationRecognizer.participantJoinCommandReceived = this.onParticipantJoinCommandReceived, this.privConversationRecognizer.participantLeaveCommandReceived = this.onParticipantLeaveCommandReceived, this.privConversationRecognizer.translationReceived = this.onTranslationReceived, this.privConversationRecognizer.participantsListReceived = this.onParticipantsListReceived, this.privConversationRecognizer.conversationExpiration = this.onConversationExpiration, this.privConversationRecognizer.connect(this.privRoom.token, () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Join a meeting as a participant.
     * @param { IParticipant } participant - participant to add
     * @param cb
     * @param err
     */
    addParticipantAsync(o, l, c) {
      i.Contracts.throwIfNullOrUndefined(o, "Participant"), a.marshalPromiseToCallbacks(this.addParticipantImplAsync(o), l, c);
    }
    /**
     * Join a meeting as a participant.
     * @param meeting
     * @param nickname
     * @param lang
     * @param cb
     * @param err
     */
    joinMeetingAsync(o, l, c, d, u) {
      try {
        i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "conversationId")), i.Contracts.throwIfNullOrWhitespace(l, this.privErrors.invalidArgs.replace("{arg}", "nickname")), i.Contracts.throwIfNullOrWhitespace(c, this.privErrors.invalidArgs.replace("{arg}", "language")), this.privManager.createOrJoin(this.privProperties, o, (h) => {
          i.Contracts.throwIfNullOrUndefined(h, this.privErrors.permissionDeniedConnect), this.privRoom = h, this.privConfig.authorizationToken = h.cognitiveSpeechAuthToken, d && d(h.cognitiveSpeechAuthToken);
        }, (h) => {
          this.handleError(h, u);
        });
      } catch (h) {
        this.handleError(h, u);
      }
    }
    /**
     * Deletes a meeting
     * @param cb
     * @param err
     */
    deleteMeetingAsync(o, l) {
      a.marshalPromiseToCallbacks(this.deleteMeetingImplAsync(), o, l);
    }
    async deleteMeetingImplAsync() {
      i.Contracts.throwIfNullOrUndefined(this.privProperties, this.privErrors.permissionDeniedConnect), i.Contracts.throwIfNullOrWhitespace(this.privRoom.token, this.privErrors.permissionDeniedConnect), await this.privManager.leave(this.privProperties, this.privRoom.token), this.dispose();
    }
    /**
     * Issues a request to close the client websockets
     * @param cb
     * @param err
     */
    endMeetingAsync(o, l) {
      a.marshalPromiseToCallbacks(this.endMeetingImplAsync(), o, l);
    }
    endMeetingImplAsync() {
      return this.close(!0);
    }
    /**
     * Issues a request to lock the conversation
     * @param cb
     * @param err
     */
    lockMeetingAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "lock")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!0), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to mute the meeting
     * @param cb
     * @param err
     */
    muteAllParticipantsAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privConversationRecognizer, this.privErrors.permissionDeniedSend), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "mute")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!0), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to mute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */
    muteParticipantAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "userId")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), !this.me.isHost && this.me.id !== o && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), c), this.privParticipants.getParticipantIndex(o) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(o, !0), () => {
          this.handleCallback(l, c);
        }, (u) => {
          this.handleError(u, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Issues a request to remove a participant from the conversation
     * @param userId
     * @param cb
     * @param err
     */
    removeParticipantAsync(o, l, c) {
      try {
        if (i.Contracts.throwIfDisposed(this.privIsDisposed), this.privTranscriberRecognizer && o.hasOwnProperty("id"))
          a.marshalPromiseToCallbacks(this.removeParticipantImplAsync(o), l, c);
        else {
          i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "remove")), c);
          let d = "";
          typeof o == "string" ? d = o : o.hasOwnProperty("id") ? d = o.id : o.hasOwnProperty("userId") && (d = o.userId), i.Contracts.throwIfNullOrWhitespace(d, this.privErrors.invalidArgs.replace("{arg}", "userId")), this.participants.findIndex((h) => h.id === d) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getEjectCommand(d), () => {
            this.handleCallback(l, c);
          }, (h) => {
            this.handleError(h, c);
          });
        }
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Issues a request to unlock the meeting
     * @param cb
     * @param err
     */
    unlockMeetingAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unlock")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getLockCommand(!1), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to unmute all participants in the meeting
     * @param cb
     * @param err
     */
    unmuteAllParticipantsAsync(o, l) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSendAsHost || this.handleError(new Error(this.privErrors.permissionDeniedConversation.replace("{command}", "unmute all")), l), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteAllCommand(!1), () => {
          this.handleCallback(o, l);
        }, (c) => {
          this.handleError(c, l);
        });
      } catch (c) {
        this.handleError(c, l);
      }
    }
    /**
     * Issues a request to unmute a participant in the meeting
     * @param userId
     * @param cb
     * @param err
     */
    unmuteParticipantAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "userId")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), !this.me.isHost && this.me.id !== o && this.handleError(new Error(this.privErrors.permissionDeniedParticipant.replace("{command}", "mute")), c), this.privParticipants.getParticipantIndex(o) === -1 && this.handleError(new Error(this.privErrors.invalidParticipantRequest), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMuteCommand(o, !1), () => {
          this.handleCallback(l, c);
        }, (u) => {
          this.handleError(u, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Send a text message
     * @param message
     * @param cb
     * @param err
     */
    sendTextMessageAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "message")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), o.length > this.privTextMessageMaxLength && this.handleError(new Error(this.privErrors.invalidArgs.replace("{arg}", "message length")), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getMessageCommand(o), () => {
          this.handleCallback(l, c);
        }, (d) => {
          this.handleError(d, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Set translated to languages
     * @param {string[]} languages - languages to translate to
     * @param cb
     * @param err
     */
    setTranslatedLanguagesAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfArrayEmptyOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "languages")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getSetTranslateToLanguagesCommand(o), () => {
          this.handleCallback(l, c);
        }, (d) => {
          this.handleError(d, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    /**
     * Change nickname
     * @param {string} nickname - new nickname for the room
     * @param cb
     * @param err
     */
    changeNicknameAsync(o, l, c) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfDisposed(this.privConversationRecognizer.isDisposed()), i.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "nickname")), i.Contracts.throwIfNullOrUndefined(this.privRoom, this.privErrors.permissionDeniedSend), this.canSend || this.handleError(new Error(this.privErrors.permissionDeniedSend), c), this.privConversationRecognizer && this.privConversationRecognizer.sendRequest(this.getChangeNicknameCommand(o), () => {
          this.handleCallback(l, c);
        }, (d) => {
          this.handleError(d, c);
        });
      } catch (d) {
        this.handleError(d, c);
      }
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    dispose() {
      this.isDisposed || (this.privIsDisposed = !0, this.config && this.config.close(), this.privConfig = void 0, this.privLanguage = void 0, this.privProperties = void 0, this.privRoom = void 0, this.privToken = void 0, this.privManager = void 0, this.privIsConnected = !1, this.privIsReady = !1, this.privParticipants = void 0);
    }
    async connectTranscriberRecognizer(o) {
      this.privTranscriberRecognizer && await this.privTranscriberRecognizer.close(), await o.enforceAudioGating(), this.privTranscriberRecognizer = o, this.privTranscriberRecognizer.meeting = this;
    }
    getKeepAlive() {
      const o = this.me ? this.me.displayName : "default_nickname";
      return JSON.stringify({
        id: "0",
        nickname: o,
        participantId: this.privRoom.participantId,
        roomId: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.keepAlive
      });
    }
    /* eslint-enable @typescript-eslint/typedef */
    addParticipantImplAsync(o) {
      if (this.privParticipants.addOrUpdateParticipant(o) !== void 0 && this.privTranscriberRecognizer) {
        const c = this.meetingInfo;
        return c.participants = [o], this.privTranscriberRecognizer.pushMeetingEvent(c, "join");
      }
    }
    removeParticipantImplAsync(o) {
      this.privParticipants.deleteParticipant(o.id);
      const l = this.meetingInfo;
      return l.participants = [o], this.privTranscriberRecognizer.pushMeetingEvent(l, "leave");
    }
    async close(o) {
      var l;
      try {
        this.privIsConnected = !1, await ((l = this.privConversationRecognizer) == null ? void 0 : l.close()), this.privConversationRecognizer = void 0, this.privConversationTranslator && this.privConversationTranslator.dispose();
      } catch (c) {
        throw c;
      }
      o && this.dispose();
    }
    /** Helpers */
    handleCallback(o, l) {
      if (o) {
        try {
          o();
        } catch (c) {
          l && l(c);
        }
        o = void 0;
      }
    }
    handleError(o, l) {
      if (l)
        if (o instanceof Error) {
          const c = o;
          l(c.name + ": " + c.message);
        } else
          l(o);
    }
    /** Participant Helpers */
    toParticipants(o) {
      const l = this.privParticipants.participants.map((c) => this.toParticipant(c));
      return o ? l : l.filter((c) => c.isHost === !1);
    }
    toParticipant(o) {
      return new r.Participant(o.id, o.avatar, o.displayName, o.isHost, o.isMuted, o.isUsingTts, o.preferredLanguage, o.voice);
    }
    getMuteAllCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingd"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setMuteAll,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getMuteCommand(o, l) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "conversationId"), i.Contracts.throwIfNullOrWhitespace(o, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setMute,
        // eslint-disable-next-line object-shorthand
        participantId: o,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: l
      });
    }
    getLockCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setLockState,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getEjectCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), i.Contracts.throwIfNullOrWhitespace(o, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.ejectParticipant,
        // eslint-disable-next-line object-shorthand
        participantId: o,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand
      });
    }
    getSetTranslateToLanguagesCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.setTranslateToLanguages,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getChangeNicknameCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), i.Contracts.throwIfNullOrWhitespace(o, "nickname"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), JSON.stringify({
        command: s.ConversationTranslatorCommandTypes.changeNickname,
        nickname: o,
        participantId: this.privRoom.participantId,
        roomid: this.privRoom.roomId,
        type: s.ConversationTranslatorMessageTypes.participantCommand,
        value: o
      });
    }
    getMessageCommand(o) {
      return i.Contracts.throwIfNullOrWhitespace(this.privRoom.roomId, "meetingId"), i.Contracts.throwIfNullOrWhitespace(this.privRoom.participantId, "participantId"), i.Contracts.throwIfNullOrWhitespace(o, "message"), JSON.stringify({
        participantId: this.privRoom.participantId,
        roomId: this.privRoom.roomId,
        text: o,
        type: s.ConversationTranslatorMessageTypes.instantMessage
      });
    }
  }
  return kh.MeetingImpl = n, kh;
}
var Gf = {}, WQ;
function wH() {
  if (WQ) return Gf;
  WQ = 1, Object.defineProperty(Gf, "__esModule", { value: !0 }), Gf.MeetingTranscriptionCanceledEventArgs = void 0;
  const s = am();
  class a extends s.CancellationEventArgsBase {
  }
  return Gf.MeetingTranscriptionCanceledEventArgs = a, Gf;
}
var Tf = {}, NQ;
function DH() {
  if (NQ) return Tf;
  NQ = 1, Object.defineProperty(Tf, "__esModule", { value: !0 }), Tf.MeetingTranscriber = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr(), e = fF();
  let n = class {
    /**
     * MeetingTranscriber constructor.
     * @constructor
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the recognizer
     */
    constructor(o) {
      this.privAudioConfig = o, this.privProperties = new r.PropertyCollection(), this.privRecognizer = void 0, this.privDisposedRecognizer = !1;
    }
    /**
     * Gets the spoken language of recognition.
     * @member MeetingTranscriber.prototype.speechRecognitionLanguage
     * @function
     * @public
     * @returns {string} The spoken language of recognition.
     */
    get speechRecognitionLanguage() {
      return i.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(r.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    /**
     * The collection of properties and their values defined for this MeetingTranscriber.
     * @member MeetingTranscriber.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this MeetingTranscriber.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * @Internal
     * Internal data member to support fromRecognizer* pattern methods on other classes.
     * Do not use externally, object returned will change without warning or notice.
     */
    get internalData() {
      return this.privRecognizer.internalData;
    }
    /**
     * @Deprecated
     * @Obsolete
     * Please use the Connection.fromRecognizer pattern to obtain a connection object
     */
    get connection() {
      return r.Connection.fromRecognizer(this.privRecognizer);
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member MeetingTranscriber.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(o) {
      i.Contracts.throwIfNullOrWhitespace(o, "token"), this.properties.setProperty(r.PropertyId.SpeechServiceAuthorization_Token, o);
    }
    /**
     * @param {Meeting} meeting - meeting to be recognized
     */
    joinMeetingAsync(o, l, c) {
      const d = o;
      i.Contracts.throwIfNullOrUndefined(e.MeetingImpl, "Meeting"), this.privRecognizer = new s.TranscriberRecognizer(o.config, this.privAudioConfig), i.Contracts.throwIfNullOrUndefined(this.privRecognizer, "Recognizer"), this.privRecognizer.connectMeetingCallbacks(this), a.marshalPromiseToCallbacks(d.connectTranscriberRecognizer(this.privRecognizer), l, c);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.startTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */
    startTranscribingAsync(o, l) {
      this.privRecognizer.startContinuousRecognitionAsync(o, l);
    }
    /**
     * Starts meeting transcription, until stopTranscribingAsync() is called.
     * User must subscribe to events to receive transcription results.
     * @member MeetingTranscriber.prototype.stopTranscribingAsync
     * @function
     * @public
     * @param cb - Callback invoked once the transcription has started.
     * @param err - Callback invoked in case of an error.
     */
    stopTranscribingAsync(o, l) {
      this.privRecognizer.stopContinuousRecognitionAsync(o, l);
    }
    /**
     * Leave the current meeting. After this is called, you will no longer receive any events.
     */
    leaveMeetingAsync(o, l) {
      this.privRecognizer.disconnectCallbacks(), a.marshalPromiseToCallbacks((async () => {
      })(), o, l);
    }
    /**
     * closes all external resources held by an instance of this class.
     * @member MeetingTranscriber.prototype.close
     * @function
     * @public
     */
    close(o, l) {
      i.Contracts.throwIfDisposed(this.privDisposedRecognizer), a.marshalPromiseToCallbacks(this.dispose(!0), o, l);
    }
    /**
     * Disposes any resources held by the object.
     * @member MeetingTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */
    async dispose(o) {
      this.privDisposedRecognizer || (this.privRecognizer && (await this.privRecognizer.close(), this.privRecognizer = void 0), o && (this.privDisposedRecognizer = !0));
    }
  };
  return Tf.MeetingTranscriber = n, Tf;
}
var Xf = {}, JQ;
function MH() {
  if (JQ) return Xf;
  JQ = 1, Object.defineProperty(Xf, "__esModule", { value: !0 }), Xf.ConversationTranscriptionResult = void 0;
  const s = Hr();
  let a = class extends s.RecognitionResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @public
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} text - The recognized text.
     * @param {number} duration - The duration.
     * @param {number} offset - The offset into the stream.
     * @param {string} language - Primary Language detected, if provided.
     * @param {string} languageDetectionConfidence - Primary Language confidence ("Unknown," "Low," "Medium," "High"...), if provided.
     * @param {string} speakerId - speaker id for conversation transcription.
     * @param {string} errorDetails - Error details, if provided.
     * @param {string} json - Additional Json, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */
    constructor(r, e, n, t, o, l, c, d, u, h, A) {
      super(r, e, n, t, o, l, c, u, h, A), this.privSpeakerId = d;
    }
    /**
     * speaker id
     * @member ConversationTranscriptionResult.prototype.speakerId
     * @function
     * @public
     * @returns {string} id of speaker in given result
     */
    get speakerId() {
      return this.privSpeakerId;
    }
  };
  return Xf.ConversationTranscriptionResult = a, Xf;
}
var GQ;
function fF() {
  return GQ || (GQ = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var a = UZ();
    Object.defineProperty(s, "Conversation", { enumerable: !0, get: function() {
      return a.Conversation;
    } }), Object.defineProperty(s, "ConversationImpl", { enumerable: !0, get: function() {
      return a.ConversationImpl;
    } });
    var i = c2;
    Object.defineProperty(s, "ConversationCommon", { enumerable: !0, get: function() {
      return i.ConversationCommon;
    } });
    var r = ZH();
    Object.defineProperty(s, "ConversationExpirationEventArgs", { enumerable: !0, get: function() {
      return r.ConversationExpirationEventArgs;
    } });
    var e = SH();
    Object.defineProperty(s, "ConversationParticipantsChangedEventArgs", { enumerable: !0, get: function() {
      return e.ConversationParticipantsChangedEventArgs;
    } });
    var n = EH();
    Object.defineProperty(s, "ConversationTranslationCanceledEventArgs", { enumerable: !0, get: function() {
      return n.ConversationTranslationCanceledEventArgs;
    } });
    var t = VH();
    Object.defineProperty(s, "ConversationTranslationEventArgs", { enumerable: !0, get: function() {
      return t.ConversationTranslationEventArgs;
    } });
    var o = WH();
    Object.defineProperty(s, "ConversationTranslationResult", { enumerable: !0, get: function() {
      return o.ConversationTranslationResult;
    } });
    var l = GH();
    Object.defineProperty(s, "ConversationTranslator", { enumerable: !0, get: function() {
      return l.ConversationTranslator;
    } });
    var c = TH();
    Object.defineProperty(s, "ConversationTranscriber", { enumerable: !0, get: function() {
      return c.ConversationTranscriber;
    } });
    var d = XH();
    Object.defineProperty(s, "Participant", { enumerable: !0, get: function() {
      return d.Participant;
    } }), Object.defineProperty(s, "User", { enumerable: !0, get: function() {
      return d.User;
    } });
    var u = ZZ;
    Object.defineProperty(s, "ParticipantChangedReason", { enumerable: !0, get: function() {
      return u.ParticipantChangedReason;
    } });
    var h = kH();
    Object.defineProperty(s, "Meeting", { enumerable: !0, get: function() {
      return h.Meeting;
    } }), Object.defineProperty(s, "MeetingImpl", { enumerable: !0, get: function() {
      return h.MeetingImpl;
    } });
    var A = wH();
    Object.defineProperty(s, "MeetingTranscriptionCanceledEventArgs", { enumerable: !0, get: function() {
      return A.MeetingTranscriptionCanceledEventArgs;
    } });
    var g = DH();
    Object.defineProperty(s, "MeetingTranscriber", { enumerable: !0, get: function() {
      return g.MeetingTranscriber;
    } });
    var f = MH();
    Object.defineProperty(s, "ConversationTranscriptionResult", { enumerable: !0, get: function() {
      return f.ConversationTranscriptionResult;
    } });
  }(Ov)), Ov;
}
var wh = {}, TQ;
function pF() {
  if (TQ) return wh;
  TQ = 1, Object.defineProperty(wh, "__esModule", { value: !0 }), wh.SynthesisRequest = wh.Synthesizer = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr();
  let e = class SZ {
    /**
     * Creates and initializes an instance of a Recognizer
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config to initialize the synthesizer.
     */
    constructor(o) {
      const l = o;
      i.Contracts.throwIfNull(l, "speechConfig"), this.privProperties = l.properties.clone(), this.privDisposed = !1, this.privSynthesizing = !1, this.synthesisRequestQueue = new a.Queue();
    }
    /**
     * Gets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @returns {string} Authorization token.
     */
    get authorizationToken() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token);
    }
    /**
     * Gets/Sets the authorization token used to communicate with the service.
     * @member Synthesizer.prototype.authorizationToken
     * @function
     * @public
     * @param {string} token - Authorization token.
     */
    set authorizationToken(o) {
      i.Contracts.throwIfNullOrWhitespace(o, "token"), this.properties.setProperty(r.PropertyId.SpeechServiceAuthorization_Token, o);
    }
    /**
     * The collection of properties and their values defined for this Synthesizer.
     * @member Synthesizer.prototype.properties
     * @function
     * @public
     * @returns {PropertyCollection} The collection of properties and their values defined for this SpeechSynthesizer.
     */
    get properties() {
      return this.privProperties;
    }
    /**
     * Indicates if auto detect source language is enabled
     * @member Synthesizer.prototype.autoDetectSourceLanguage
     * @function
     * @public
     * @returns {boolean} if auto detect source language is enabled
     */
    get autoDetectSourceLanguage() {
      return this.properties.getProperty(r.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages) === s.AutoDetectSourceLanguagesOpenRangeOptionName;
    }
    buildSsml(o) {
      const l = {
        "af-ZA": "af-ZA-AdriNeural",
        "am-ET": "am-ET-AmehaNeural",
        "ar-AE": "ar-AE-FatimaNeural",
        "ar-BH": "ar-BH-AliNeural",
        "ar-DZ": "ar-DZ-AminaNeural",
        "ar-EG": "ar-EG-SalmaNeural",
        "ar-IQ": "ar-IQ-BasselNeural",
        "ar-JO": "ar-JO-SanaNeural",
        "ar-KW": "ar-KW-FahedNeural",
        "ar-LY": "ar-LY-ImanNeural",
        "ar-MA": "ar-MA-JamalNeural",
        "ar-QA": "ar-QA-AmalNeural",
        "ar-SA": "ar-SA-HamedNeural",
        "ar-SY": "ar-SY-AmanyNeural",
        "ar-TN": "ar-TN-HediNeural",
        "ar-YE": "ar-YE-MaryamNeural",
        "bg-BG": "bg-BG-BorislavNeural",
        "bn-BD": "bn-BD-NabanitaNeural",
        "bn-IN": "bn-IN-BashkarNeural",
        "ca-ES": "ca-ES-JoanaNeural",
        "cs-CZ": "cs-CZ-AntoninNeural",
        "cy-GB": "cy-GB-AledNeural",
        "da-DK": "da-DK-ChristelNeural",
        "de-AT": "de-AT-IngridNeural",
        "de-CH": "de-CH-JanNeural",
        "de-DE": "de-DE-KatjaNeural",
        "el-GR": "el-GR-AthinaNeural",
        "en-AU": "en-AU-NatashaNeural",
        "en-CA": "en-CA-ClaraNeural",
        "en-GB": "en-GB-LibbyNeural",
        "en-HK": "en-HK-SamNeural",
        "en-IE": "en-IE-ConnorNeural",
        "en-IN": "en-IN-NeerjaNeural",
        "en-KE": "en-KE-AsiliaNeural",
        "en-NG": "en-NG-AbeoNeural",
        "en-NZ": "en-NZ-MitchellNeural",
        "en-PH": "en-PH-JamesNeural",
        "en-SG": "en-SG-LunaNeural",
        "en-TZ": "en-TZ-ElimuNeural",
        "en-US": "en-US-AvaMultilingualNeural",
        "en-ZA": "en-ZA-LeahNeural",
        "es-AR": "es-AR-ElenaNeural",
        "es-BO": "es-BO-MarceloNeural",
        "es-CL": "es-CL-CatalinaNeural",
        "es-CO": "es-CO-GonzaloNeural",
        "es-CR": "es-CR-JuanNeural",
        "es-CU": "es-CU-BelkysNeural",
        "es-DO": "es-DO-EmilioNeural",
        "es-EC": "es-EC-AndreaNeural",
        "es-ES": "es-ES-AlvaroNeural",
        "es-GQ": "es-GQ-JavierNeural",
        "es-GT": "es-GT-AndresNeural",
        "es-HN": "es-HN-CarlosNeural",
        "es-MX": "es-MX-DaliaNeural",
        "es-NI": "es-NI-FedericoNeural",
        "es-PA": "es-PA-MargaritaNeural",
        "es-PE": "es-PE-AlexNeural",
        "es-PR": "es-PR-KarinaNeural",
        "es-PY": "es-PY-MarioNeural",
        "es-SV": "es-SV-LorenaNeural",
        "es-US": "es-US-AlonsoNeural",
        "es-UY": "es-UY-MateoNeural",
        "es-VE": "es-VE-PaolaNeural",
        "et-EE": "et-EE-AnuNeural",
        "fa-IR": "fa-IR-DilaraNeural",
        "fi-FI": "fi-FI-SelmaNeural",
        "fil-PH": "fil-PH-AngeloNeural",
        "fr-BE": "fr-BE-CharlineNeural",
        "fr-CA": "fr-CA-SylvieNeural",
        "fr-CH": "fr-CH-ArianeNeural",
        "fr-FR": "fr-FR-DeniseNeural",
        "ga-IE": "ga-IE-ColmNeural",
        "gl-ES": "gl-ES-RoiNeural",
        "gu-IN": "gu-IN-DhwaniNeural",
        "he-IL": "he-IL-AvriNeural",
        "hi-IN": "hi-IN-MadhurNeural",
        "hr-HR": "hr-HR-GabrijelaNeural",
        "hu-HU": "hu-HU-NoemiNeural",
        "id-ID": "id-ID-ArdiNeural",
        "is-IS": "is-IS-GudrunNeural",
        "it-IT": "it-IT-IsabellaNeural",
        "ja-JP": "ja-JP-NanamiNeural",
        "jv-ID": "jv-ID-DimasNeural",
        "kk-KZ": "kk-KZ-AigulNeural",
        "km-KH": "km-KH-PisethNeural",
        "kn-IN": "kn-IN-GaganNeural",
        "ko-KR": "ko-KR-SunHiNeural",
        "lo-LA": "lo-LA-ChanthavongNeural",
        "lt-LT": "lt-LT-LeonasNeural",
        "lv-LV": "lv-LV-EveritaNeural",
        "mk-MK": "mk-MK-AleksandarNeural",
        "ml-IN": "ml-IN-MidhunNeural",
        "mr-IN": "mr-IN-AarohiNeural",
        "ms-MY": "ms-MY-OsmanNeural",
        "mt-MT": "mt-MT-GraceNeural",
        "my-MM": "my-MM-NilarNeural",
        "nb-NO": "nb-NO-PernilleNeural",
        "nl-BE": "nl-BE-ArnaudNeural",
        "nl-NL": "nl-NL-ColetteNeural",
        "pl-PL": "pl-PL-AgnieszkaNeural",
        "ps-AF": "ps-AF-GulNawazNeural",
        "pt-BR": "pt-BR-FranciscaNeural",
        "pt-PT": "pt-PT-DuarteNeural",
        "ro-RO": "ro-RO-AlinaNeural",
        "ru-RU": "ru-RU-SvetlanaNeural",
        "si-LK": "si-LK-SameeraNeural",
        "sk-SK": "sk-SK-LukasNeural",
        "sl-SI": "sl-SI-PetraNeural",
        "so-SO": "so-SO-MuuseNeural",
        "sr-RS": "sr-RS-NicholasNeural",
        "su-ID": "su-ID-JajangNeural",
        "sv-SE": "sv-SE-SofieNeural",
        "sw-KE": "sw-KE-RafikiNeural",
        "sw-TZ": "sw-TZ-DaudiNeural",
        "ta-IN": "ta-IN-PallaviNeural",
        "ta-LK": "ta-LK-KumarNeural",
        "ta-SG": "ta-SG-AnbuNeural",
        "te-IN": "te-IN-MohanNeural",
        "th-TH": "th-TH-PremwadeeNeural",
        "tr-TR": "tr-TR-AhmetNeural",
        "uk-UA": "uk-UA-OstapNeural",
        "ur-IN": "ur-IN-GulNeural",
        "ur-PK": "ur-PK-AsadNeural",
        "uz-UZ": "uz-UZ-MadinaNeural",
        "vi-VN": "vi-VN-HoaiMyNeural",
        "zh-CN": "zh-CN-XiaoxiaoNeural",
        "zh-HK": "zh-HK-HiuMaanNeural",
        "zh-TW": "zh-TW-HsiaoChenNeural",
        "zu-ZA": "zu-ZA-ThandoNeural"
      };
      let c = this.properties.getProperty(r.PropertyId.SpeechServiceConnection_SynthLanguage, "en-US"), d = this.properties.getProperty(r.PropertyId.SpeechServiceConnection_SynthVoice, ""), u = SZ.XMLEncode(o);
      return this.autoDetectSourceLanguage ? c = "en-US" : d = d || l[c], d && (u = `<voice name='${d}'>${u}</voice>`), u = `<speak version='1.0' xmlns='http://www.w3.org/2001/10/synthesis' xmlns:mstts='http://www.w3.org/2001/mstts' xmlns:emo='http://www.w3.org/2009/10/emotionml' xml:lang='${c}'>${u}</speak>`, u;
    }
    /**
     * This method performs cleanup of resources.
     * The Boolean parameter disposing indicates whether the method is called
     * from Dispose (if disposing is true) or from the finalizer (if disposing is false).
     * Derived classes should override this method to dispose resource if needed.
     * @member Synthesizer.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - Flag to request disposal.
     */
    async dispose(o) {
      this.privDisposed || (o && this.privAdapter && await this.privAdapter.dispose(), this.privDisposed = !0);
    }
    async adapterSpeak() {
      if (!this.privDisposed && !this.privSynthesizing) {
        this.privSynthesizing = !0;
        const o = await this.synthesisRequestQueue.dequeue();
        return this.privAdapter.Speak(o.text, o.isSSML, o.requestId, o.cb, o.err, o.dataStream);
      }
    }
    createSynthesizerConfig(o) {
      return new s.SynthesizerConfig(o, this.privProperties);
    }
    // Does the generic synthesizer setup that is common across all synthesizer types.
    implCommonSynthesizeSetup() {
      let o = typeof window != "undefined" ? "Browser" : "Node", l = "unknown", c = "unknown";
      typeof navigator != "undefined" && (o = o + "/" + navigator.platform, l = navigator.userAgent, c = navigator.appVersion);
      const d = this.createSynthesizerConfig(new s.SpeechServiceConfig(new s.Context(new s.OS(o, l, c)))), u = this.privProperties.getProperty(r.PropertyId.SpeechServiceConnection_Key, void 0), h = u && u !== "" ? new s.CognitiveSubscriptionKeyAuthentication(u) : new s.CognitiveTokenAuthentication(() => {
        const A = this.privProperties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(A);
      }, () => {
        const A = this.privProperties.getProperty(r.PropertyId.SpeechServiceAuthorization_Token, void 0);
        return Promise.resolve(A);
      });
      this.privAdapter = this.createSynthesisAdapter(h, this.privConnectionFactory, d), this.privRestAdapter = this.createRestSynthesisAdapter(h, d);
    }
    static XMLEncode(o) {
      return o.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
    }
  };
  wh.Synthesizer = e;
  class n {
    constructor(o, l, c, d, u, h) {
      this.requestId = o, this.text = l, this.isSSML = c, this.cb = d, this.err = u, this.dataStream = h;
    }
  }
  return wh.SynthesisRequest = n, wh;
}
var kf = {}, XQ;
function YH() {
  if (XQ) return kf;
  XQ = 1, Object.defineProperty(kf, "__esModule", { value: !0 }), kf.SpeechSynthesizer = void 0;
  const s = wi(), a = Eo(), i = om, r = sh, e = jc, n = _o, t = Hr(), o = pF();
  let l = class EZ extends t.Synthesizer {
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - An set of initial properties for this synthesizer.
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer.
     */
    constructor(d, u) {
      super(d), u !== null && (u === void 0 ? this.audioConfig = typeof window == "undefined" ? void 0 : t.AudioConfig.fromDefaultSpeakerOutput() : this.audioConfig = u), this.privConnectionFactory = new s.SpeechSynthesisConnectionFactory(), this.implCommonSynthesizeSetup();
    }
    /**
     * SpeechSynthesizer constructor.
     * @constructor
     * @param {SpeechConfig} speechConfig - an set of initial properties for this synthesizer
     * @param {AutoDetectSourceLanguageConfig} autoDetectSourceLanguageConfig - An source language detection configuration associated with the synthesizer
     * @param {AudioConfig} audioConfig - An optional audio configuration associated with the synthesizer
     */
    static FromConfig(d, u, h) {
      const A = d;
      return u.properties.mergeTo(A.properties), new EZ(d, h);
    }
    /**
     * Executes speech synthesis on plain text.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param text - Text to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */
    speakTextAsync(d, u, h, A) {
      this.speakImpl(d, !1, u, h, A);
    }
    /**
     * Executes speech synthesis on SSML.
     * The task returns the synthesis result.
     * @member SpeechSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param ssml - SSML to be synthesized.
     * @param cb - Callback that received the SpeechSynthesisResult.
     * @param err - Callback invoked in case of an error.
     * @param stream - AudioOutputStream to receive the synthesized audio.
     */
    speakSsmlAsync(d, u, h, A) {
      this.speakImpl(d, !0, u, h, A);
    }
    /**
     * Get list of synthesis voices available.
     * The task returns the synthesis voice result.
     * @member SpeechSynthesizer.prototype.getVoicesAsync
     * @function
     * @async
     * @public
     * @param locale - Locale of voices in BCP-47 format; if left empty, get all available voices.
     * @return {Promise<SynthesisVoicesResult>} - Promise of a SynthesisVoicesResult.
     */
    async getVoicesAsync(d = "") {
      return this.getVoices(d);
    }
    /**
     * Dispose of associated resources.
     * @member SpeechSynthesizer.prototype.close
     * @function
     * @public
     */
    close(d, u) {
      n.Contracts.throwIfDisposed(this.privDisposed), a.marshalPromiseToCallbacks(this.dispose(!0), d, u);
    }
    /**
     * @Internal
     * Do not use externally, object returned will change without warning or notice.
     */
    get internalData() {
      return this.privAdapter;
    }
    //
    // ################################################################################################################
    // IMPLEMENTATION.
    // ################################################################################################################
    //
    // Creates the synthesis adapter
    createSynthesisAdapter(d, u, h) {
      return new s.SpeechSynthesisAdapter(d, u, h, this, this.audioConfig);
    }
    createRestSynthesisAdapter(d, u) {
      return new s.SynthesisRestAdapter(u, d);
    }
    implCommonSynthesizeSetup() {
      super.implCommonSynthesizeSetup(), this.privAdapter.audioOutputFormat = r.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat(t.SpeechSynthesisOutputFormat[this.properties.getProperty(t.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0)]);
    }
    speakImpl(d, u, h, A, g) {
      try {
        n.Contracts.throwIfDisposed(this.privDisposed);
        const f = a.createNoDashGuid();
        let p;
        g instanceof t.PushAudioOutputStreamCallback ? p = new e.PushAudioOutputStreamImpl(g) : g instanceof t.PullAudioOutputStream ? p = g : g !== void 0 ? p = new i.AudioFileWriter(g) : p = void 0, this.synthesisRequestQueue.enqueue(new o.SynthesisRequest(f, d, u, (v) => {
          if (this.privSynthesizing = !1, h)
            try {
              h(v);
            } catch (b) {
              A && A(b);
            }
          h = void 0, this.adapterSpeak().catch(() => {
          });
        }, (v) => {
          A && A(v);
        }, p)), this.adapterSpeak().catch(() => {
        });
      } catch (f) {
        if (A)
          if (f instanceof Error) {
            const p = f;
            A(p.name + ": " + p.message);
          } else
            A(f);
        this.dispose(!0).catch(() => {
        });
      }
    }
    async getVoices(d) {
      const u = a.createNoDashGuid(), h = await this.privRestAdapter.getVoicesList(u);
      if (h.ok && Array.isArray(h.json)) {
        let A = h.json;
        return d && d.length > 0 && (A = A.filter((g) => !!g.Locale && g.Locale.toLowerCase() === d.toLowerCase())), new t.SynthesisVoicesResult(u, A, void 0);
      } else
        return new t.SynthesisVoicesResult(u, void 0, `Error: ${h.status}: ${h.statusText}`);
    }
  };
  return kf.SpeechSynthesizer = l, kf;
}
var d2 = {};
Object.defineProperty(d2, "__esModule", { value: !0 });
d2.SynthesisResult = void 0;
class LH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} errorDetails - Error details, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  constructor(a, i, r, e) {
    this.privResultId = a, this.privReason = i, this.privErrorDetails = r, this.privProperties = e;
  }
  /**
   * Specifies the result identifier.
   * @member SynthesisResult.prototype.resultId
   * @function
   * @public
   * @returns {string} Specifies the result identifier.
   */
  get resultId() {
    return this.privResultId;
  }
  /**
   * Specifies status of the result.
   * @member SynthesisResult.prototype.reason
   * @function
   * @public
   * @returns {ResultReason} Specifies status of the result.
   */
  get reason() {
    return this.privReason;
  }
  /**
   * In case of an unsuccessful synthesis, provides details of the occurred error.
   * @member SynthesisResult.prototype.errorDetails
   * @function
   * @public
   * @returns {string} a brief description of an error.
   */
  get errorDetails() {
    return this.privErrorDetails;
  }
  /**
   * The set of properties exposed in the result.
   * @member SynthesisResult.prototype.properties
   * @function
   * @public
   * @returns {PropertyCollection} The set of properties exposed in the result.
   */
  get properties() {
    return this.privProperties;
  }
}
d2.SynthesisResult = LH;
var wf = {}, kQ;
function xH() {
  if (kQ) return wf;
  kQ = 1, Object.defineProperty(wf, "__esModule", { value: !0 }), wf.SpeechSynthesisResult = void 0;
  const s = Hr();
  let a = class extends s.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {ArrayBuffer} audioData - The synthesized audio binary.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     * @param {number} audioDuration - The audio duration.
     */
    constructor(r, e, n, t, o, l) {
      super(r, e, t, o), this.privAudioData = n, this.privAudioDuration = l;
    }
    /**
     * The synthesized audio data
     * @member SpeechSynthesisResult.prototype.audioData
     * @function
     * @public
     * @returns {ArrayBuffer} The synthesized audio data.
     */
    get audioData() {
      return this.privAudioData;
    }
    /**
     * The time duration of synthesized audio, in ticks (100 nanoseconds).
     * @member SpeechSynthesisResult.prototype.audioDuration
     * @function
     * @public
     * @returns {number} The time duration of synthesized audio.
     */
    get audioDuration() {
      return this.privAudioDuration;
    }
  };
  return wf.SpeechSynthesisResult = a, wf;
}
var u2 = {};
Object.defineProperty(u2, "__esModule", { value: !0 });
u2.SpeechSynthesisEventArgs = void 0;
class HH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {SpeechSynthesisResult} result - The speech synthesis result.
   */
  constructor(a) {
    this.privResult = a;
  }
  /**
   * Specifies the synthesis result.
   * @member SpeechSynthesisEventArgs.prototype.result
   * @function
   * @public
   * @returns {SpeechSynthesisResult} the synthesis result.
   */
  get result() {
    return this.privResult;
  }
}
u2.SpeechSynthesisEventArgs = HH;
var h2 = {};
Object.defineProperty(h2, "__esModule", { value: !0 });
h2.SpeechSynthesisWordBoundaryEventArgs = void 0;
class PH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} duration - The audio duration.
   * @param {string} text - The text.
   * @param {number} wordLength - The length of the word.
   * @param {number} textOffset - The text offset.
   * @param {SpeechSynthesisBoundaryType} boundaryType - The boundary type
   */
  constructor(a, i, r, e, n, t) {
    this.privAudioOffset = a, this.privDuration = i, this.privText = r, this.privWordLength = e, this.privTextOffset = n, this.privBoundaryType = t;
  }
  /**
   * Specifies the audio offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */
  get audioOffset() {
    return this.privAudioOffset;
  }
  /**
   * Specifies the duration, in ticks (100 nanoseconds).
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.duration
   * @function
   * @public
   * @returns {number} Duration in 100 nanosecond increments.
   */
  get duration() {
    return this.privDuration;
  }
  /**
   * Specifies the text of the word boundary event.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the text.
   */
  get text() {
    return this.privText;
  }
  /**
   * Specifies the word length
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.wordLength
   * @function
   * @public
   * @returns {number} the word length
   */
  get wordLength() {
    return this.privWordLength;
  }
  /**
   * Specifies the text offset.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.textOffset
   * @function
   * @public
   * @returns {number} the text offset.
   */
  get textOffset() {
    return this.privTextOffset;
  }
  /**
   * Specifies the boundary type.
   * @member SpeechSynthesisWordBoundaryEventArgs.prototype.boundaryType
   * @function
   * @public
   * @returns {SpeechSynthesisBoundaryType} the boundary type.
   */
  get boundaryType() {
    return this.privBoundaryType;
  }
}
h2.SpeechSynthesisWordBoundaryEventArgs = PH;
var A2 = {};
Object.defineProperty(A2, "__esModule", { value: !0 });
A2.SpeechSynthesisBookmarkEventArgs = void 0;
class OH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {string} text - The bookmark text.
   */
  constructor(a, i) {
    this.privAudioOffset = a, this.privText = i;
  }
  /**
   * Specifies the audio offset.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */
  get audioOffset() {
    return this.privAudioOffset;
  }
  /**
   * Specifies the bookmark.
   * @member SpeechSynthesisBookmarkEventArgs.prototype.text
   * @function
   * @public
   * @returns {string} the bookmark text.
   */
  get text() {
    return this.privText;
  }
}
A2.SpeechSynthesisBookmarkEventArgs = OH;
var g2 = {};
Object.defineProperty(g2, "__esModule", { value: !0 });
g2.SpeechSynthesisVisemeEventArgs = void 0;
class KH {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {number} audioOffset - The audio offset.
   * @param {number} visemeId - The viseme ID.
   * @param {string} animation - The animation, could be in svg or other format.
   */
  constructor(a, i, r) {
    this.privAudioOffset = a, this.privVisemeId = i, this.privAnimation = r;
  }
  /**
   * Specifies the audio offset.
   * @member SpeechSynthesisVisemeEventArgs.prototype.audioOffset
   * @function
   * @public
   * @returns {number} the audio offset.
   */
  get audioOffset() {
    return this.privAudioOffset;
  }
  /**
   * Specifies the viseme ID.
   * @member SpeechSynthesisVisemeEventArgs.prototype.visemeId
   * @function
   * @public
   * @returns {number} the viseme ID.
   */
  get visemeId() {
    return this.privVisemeId;
  }
  /**
   * Specifies the animation.
   * @member SpeechSynthesisVisemeEventArgs.prototype.animation
   * @function
   * @public
   * @returns {string} the animation, could be in svg or other format.
   */
  get animation() {
    return this.privAnimation;
  }
}
g2.SpeechSynthesisVisemeEventArgs = KH;
var VZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.SpeechSynthesisBoundaryType = void 0, function(a) {
    a.Word = "WordBoundary", a.Punctuation = "PunctuationBoundary", a.Sentence = "SentenceBoundary";
  }(s.SpeechSynthesisBoundaryType || (s.SpeechSynthesisBoundaryType = {}));
})(VZ);
var Df = {}, wQ;
function zH() {
  if (wQ) return Df;
  wQ = 1, Object.defineProperty(Df, "__esModule", { value: !0 }), Df.SynthesisVoicesResult = void 0;
  const s = Hr();
  let a = class extends s.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param requestId - result id for request.
     * @param json - json payload from endpoint.
     */
    constructor(r, e, n) {
      if (Array.isArray(e)) {
        super(r, s.ResultReason.VoicesListRetrieved, void 0, new s.PropertyCollection()), this.privVoices = [];
        for (const t of e)
          this.privVoices.push(new s.VoiceInfo(t));
      } else
        super(r, s.ResultReason.Canceled, n || "Error information unavailable", new s.PropertyCollection());
    }
    /**
     * The list of voices
     * @member SynthesisVoicesResult.prototype.voices
     * @function
     * @public
     * @returns {VoiceInfo[]} List of synthesized voices.
     */
    get voices() {
      return this.privVoices;
    }
  };
  return Df.SynthesisVoicesResult = a, Df;
}
var WZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.VoiceInfo = s.SynthesisVoiceType = s.SynthesisVoiceGender = void 0;
  var a;
  (function(n) {
    n[n.Unknown = 0] = "Unknown", n[n.Female = 1] = "Female", n[n.Male = 2] = "Male", n[n.Neutral = 3] = "Neutral";
  })(a = s.SynthesisVoiceGender || (s.SynthesisVoiceGender = {}));
  var i;
  (function(n) {
    n[n.OnlineNeural = 1] = "OnlineNeural", n[n.OnlineStandard = 2] = "OnlineStandard", n[n.OfflineNeural = 3] = "OfflineNeural", n[n.OfflineStandard = 4] = "OfflineStandard";
  })(i = s.SynthesisVoiceType || (s.SynthesisVoiceType = {}));
  const r = {
    [a[a.Neutral]]: a.Neutral,
    [a[a.Male]]: a.Male,
    [a[a.Female]]: a.Female
  };
  class e {
    constructor(t) {
      if (this.privStyleList = [], t) {
        if (this.privName = t.Name, this.privLocale = t.Locale, this.privShortName = t.ShortName, this.privLocaleName = t.LocaleName, this.privDisplayName = t.DisplayName, this.privLocalName = t.LocalName, this.privVoiceType = t.VoiceType.endsWith("Standard") ? i.OnlineStandard : i.OnlineNeural, this.privGender = r[t.Gender] || a.Unknown, t.StyleList && Array.isArray(t.StyleList))
          for (const o of t.StyleList)
            this.privStyleList.push(o);
        this.privSampleRateHertz = t.SampleRateHertz, this.privStatus = t.Status, t.ExtendedPropertyMap && (this.privExtendedPropertyMap = t.ExtendedPropertyMap), this.privWordsPerMinute = t.WordsPerMinute, Array.isArray(t.SecondaryLocaleList) && (this.privSecondaryLocaleList = [...t.SecondaryLocaleList]), Array.isArray(t.RolePlayList) && (this.privRolePlayList = [...t.RolePlayList]);
      }
    }
    get name() {
      return this.privName;
    }
    get locale() {
      return this.privLocale;
    }
    get shortName() {
      return this.privShortName;
    }
    get displayName() {
      return this.privDisplayName;
    }
    get localName() {
      return this.privLocalName;
    }
    get localeName() {
      return this.privLocaleName;
    }
    get gender() {
      return this.privGender;
    }
    get voiceType() {
      return this.privVoiceType;
    }
    get styleList() {
      return this.privStyleList;
    }
    get sampleRateHertz() {
      return this.privSampleRateHertz;
    }
    get status() {
      return this.privStatus;
    }
    get extendedPropertyMap() {
      return this.privExtendedPropertyMap;
    }
    get wordsPerMinute() {
      return this.privWordsPerMinute;
    }
    get secondaryLocaleList() {
      return this.privSecondaryLocaleList;
    }
    get rolePlayList() {
      return this.privRolePlayList;
    }
  }
  s.VoiceInfo = e;
})(WZ);
var f2 = {};
Object.defineProperty(f2, "__esModule", { value: !0 });
f2.SpeakerAudioDestination = void 0;
const Dh = Eo(), jH = jc, Hd = ah, _H = 60 * 30, DQ = {
  [Hd.AudioFormatTag.PCM]: "audio/wav",
  [Hd.AudioFormatTag.MuLaw]: "audio/x-wav",
  [Hd.AudioFormatTag.MP3]: "audio/mpeg",
  [Hd.AudioFormatTag.OGG_OPUS]: "audio/ogg",
  [Hd.AudioFormatTag.WEBM_OPUS]: "audio/webm; codecs=opus",
  [Hd.AudioFormatTag.ALaw]: "audio/x-wav",
  [Hd.AudioFormatTag.FLAC]: "audio/flac",
  [Hd.AudioFormatTag.AMR_WB]: "audio/amr-wb",
  [Hd.AudioFormatTag.G722]: "audio/G722"
};
class $H {
  constructor(a) {
    this.privPlaybackStarted = !1, this.privAppendingToBuffer = !1, this.privMediaSourceOpened = !1, this.privBytesReceived = 0, this.privId = a || Dh.createNoDashGuid(), this.privIsPaused = !1, this.privIsClosed = !1;
  }
  id() {
    return this.privId;
  }
  write(a, i, r) {
    this.privAudioBuffer !== void 0 ? (this.privAudioBuffer.push(a), this.updateSourceBuffer().then(() => {
      i && i();
    }, (e) => {
      r && r(e);
    })) : this.privAudioOutputStream !== void 0 && (this.privAudioOutputStream.write(a), this.privBytesReceived += a.byteLength);
  }
  close(a, i) {
    if (this.privIsClosed = !0, this.privSourceBuffer !== void 0)
      this.handleSourceBufferUpdateEnd().then(() => {
        a && a();
      }, (r) => {
        i && i(r);
      });
    else if (this.privAudioOutputStream !== void 0 && typeof window != "undefined")
      if ((this.privFormat.formatTag === Hd.AudioFormatTag.PCM || this.privFormat.formatTag === Hd.AudioFormatTag.MuLaw || this.privFormat.formatTag === Hd.AudioFormatTag.ALaw) && this.privFormat.hasHeader === !1)
        console.warn("Play back is not supported for raw PCM, mulaw or alaw format without header."), this.onAudioEnd && this.onAudioEnd(this);
      else {
        let r = new ArrayBuffer(this.privBytesReceived);
        this.privAudioOutputStream.read(r).then(() => {
          r = this.privFormat.addHeader(r);
          const e = new Blob([r], { type: DQ[this.privFormat.formatTag] });
          this.privAudio.src = window.URL.createObjectURL(e), this.notifyPlayback().then(() => {
            a && a();
          }, (n) => {
            i && i(n);
          });
        }, (e) => {
          i && i(e);
        });
      }
    else
      this.onAudioEnd && this.onAudioEnd(this);
  }
  set format(a) {
    if (typeof AudioContext != "undefined" || typeof window != "undefined" && typeof window.webkitAudioContext != "undefined") {
      this.privFormat = a;
      const i = DQ[this.privFormat.formatTag];
      i === void 0 ? console.warn(`Unknown mimeType for format ${Hd.AudioFormatTag[this.privFormat.formatTag]}; playback is not supported.`) : typeof MediaSource != "undefined" && MediaSource.isTypeSupported(i) ? (this.privAudio = new Audio(), this.privAudioBuffer = [], this.privMediaSource = new MediaSource(), this.privAudio.src = URL.createObjectURL(this.privMediaSource), this.privAudio.load(), this.privMediaSource.onsourceopen = () => {
        this.privMediaSourceOpened = !0, this.privMediaSource.duration = _H, this.privSourceBuffer = this.privMediaSource.addSourceBuffer(i), this.privSourceBuffer.onupdate = () => {
          this.updateSourceBuffer().catch((r) => {
            Dh.Events.instance.onEvent(new Dh.BackgroundEvent(r));
          });
        }, this.privSourceBuffer.onupdateend = () => {
          this.handleSourceBufferUpdateEnd().catch((r) => {
            Dh.Events.instance.onEvent(new Dh.BackgroundEvent(r));
          });
        }, this.privSourceBuffer.onupdatestart = () => {
          this.privAppendingToBuffer = !1;
        };
      }, this.updateSourceBuffer().catch((r) => {
        Dh.Events.instance.onEvent(new Dh.BackgroundEvent(r));
      })) : (console.warn(`Format ${Hd.AudioFormatTag[this.privFormat.formatTag]} could not be played by MSE, streaming playback is not enabled.`), this.privAudioOutputStream = new jH.PullAudioOutputStreamImpl(), this.privAudioOutputStream.format = this.privFormat, this.privAudio = new Audio());
    }
  }
  get volume() {
    var a, i;
    return (i = (a = this.privAudio) == null ? void 0 : a.volume) != null ? i : -1;
  }
  set volume(a) {
    this.privAudio && (this.privAudio.volume = a);
  }
  mute() {
    this.privAudio && (this.privAudio.muted = !0);
  }
  unmute() {
    this.privAudio && (this.privAudio.muted = !1);
  }
  get isClosed() {
    return this.privIsClosed;
  }
  get currentTime() {
    return this.privAudio !== void 0 ? this.privAudio.currentTime : -1;
  }
  pause() {
    !this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.pause(), this.privIsPaused = !0);
  }
  resume(a, i) {
    this.privIsPaused && this.privAudio !== void 0 && (this.privAudio.play().then(() => {
      a && a();
    }, (r) => {
      i && i(r);
    }), this.privIsPaused = !1);
  }
  get internalAudio() {
    return this.privAudio;
  }
  async updateSourceBuffer() {
    if (this.privAudioBuffer !== void 0 && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
      this.privAppendingToBuffer = !0;
      const a = this.privAudioBuffer.shift();
      try {
        this.privSourceBuffer.appendBuffer(a);
      } catch {
        this.privAudioBuffer.unshift(a), console.log("buffer filled, pausing addition of binaries until space is made");
        return;
      }
      await this.notifyPlayback();
    } else this.canEndStream() && await this.handleSourceBufferUpdateEnd();
  }
  async handleSourceBufferUpdateEnd() {
    this.canEndStream() && this.sourceBufferAvailable() && (this.privMediaSource.endOfStream(), await this.notifyPlayback());
  }
  async notifyPlayback() {
    !this.privPlaybackStarted && this.privAudio !== void 0 && (this.privPlaybackStarted = !0, this.onAudioStart && this.onAudioStart(this), this.privAudio.onended = () => {
      this.onAudioEnd && this.onAudioEnd(this);
    }, this.privIsPaused || await this.privAudio.play());
  }
  canEndStream() {
    return this.isClosed && this.privSourceBuffer !== void 0 && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
  }
  sourceBufferAvailable() {
    return this.privSourceBuffer !== void 0 && !this.privSourceBuffer.updating;
  }
}
f2.SpeakerAudioDestination = $H;
var Mf = {}, MQ;
function qH() {
  if (MQ) return Mf;
  MQ = 1, Object.defineProperty(Mf, "__esModule", { value: !0 }), Mf.ConversationTranscriptionCanceledEventArgs = void 0;
  const s = am();
  let a = class extends s.CancellationEventArgsBase {
  };
  return Mf.ConversationTranscriptionCanceledEventArgs = a, Mf;
}
var Yf = {}, YQ;
function eP() {
  if (YQ) return Yf;
  YQ = 1, Object.defineProperty(Yf, "__esModule", { value: !0 }), Yf.MeetingTranscriptionCanceledEventArgs = void 0;
  const s = am();
  let a = class extends s.CancellationEventArgsBase {
  };
  return Yf.MeetingTranscriptionCanceledEventArgs = a, Yf;
}
var NZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.PronunciationAssessmentGradingSystem = void 0, function(a) {
    a[a.FivePoint = 1] = "FivePoint", a[a.HundredMark = 2] = "HundredMark";
  }(s.PronunciationAssessmentGradingSystem || (s.PronunciationAssessmentGradingSystem = {}));
})(NZ);
var JZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.PronunciationAssessmentGranularity = void 0, function(a) {
    a[a.Phoneme = 1] = "Phoneme", a[a.Word = 2] = "Word", a[a.FullText = 3] = "FullText";
  }(s.PronunciationAssessmentGranularity || (s.PronunciationAssessmentGranularity = {}));
})(JZ);
var Lf = {}, LQ;
function tP() {
  if (LQ) return Lf;
  LQ = 1, Object.defineProperty(Lf, "__esModule", { value: !0 }), Lf.PronunciationAssessmentConfig = void 0;
  const s = _o, a = Hr();
  let i = class GZ {
    /**
     * PronunciationAssessmentConfig constructor.
     * @constructor
     * @param {string} referenceText
     * @param gradingSystem
     * @param granularity
     * @param enableMiscue
     */
    constructor(e, n = a.PronunciationAssessmentGradingSystem.FivePoint, t = a.PronunciationAssessmentGranularity.Phoneme, o = !1) {
      s.Contracts.throwIfNullOrUndefined(e, "referenceText"), this.privProperties = new a.PropertyCollection(), this.privProperties.setProperty(a.PropertyId.PronunciationAssessment_ReferenceText, e), this.privProperties.setProperty(a.PropertyId.PronunciationAssessment_GradingSystem, a.PronunciationAssessmentGradingSystem[n]), this.privProperties.setProperty(a.PropertyId.PronunciationAssessment_Granularity, a.PronunciationAssessmentGranularity[t]), this.privProperties.setProperty(a.PropertyId.PronunciationAssessment_EnableMiscue, String(o));
    }
    /**
     * @member PronunciationAssessmentConfig.fromJSON
     * @function
     * @public
     * @param {string} json The json string containing the pronunciation assessment parameters.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentConfig from json.
     * This method is designed to support the pronunciation assessment parameters still in preview.
     * Under normal circumstances, use the constructor instead.
     */
    static fromJSON(e) {
      s.Contracts.throwIfNullOrUndefined(e, "json");
      const n = new GZ("");
      return n.privProperties = new a.PropertyCollection(), n.properties.setProperty(a.PropertyId.PronunciationAssessment_Json, e), n;
    }
    toJSON() {
      return this.updateJson(), this.privProperties.getProperty(a.PropertyId.PronunciationAssessment_Params);
    }
    applyTo(e) {
      this.updateJson();
      const n = e.internalData;
      n.expectContentAssessmentResponse = !!this.privContentAssessmentTopic, n.speechContext.setPronunciationAssessmentParams(this.properties.getProperty(a.PropertyId.PronunciationAssessment_Params), this.privContentAssessmentTopic, n.isSpeakerDiarizationEnabled);
    }
    /**
     * Gets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @returns {string} Reference text.
     */
    get referenceText() {
      return this.properties.getProperty(a.PropertyId.PronunciationAssessment_ReferenceText);
    }
    /**
     * Gets/Sets the reference text.
     * @member PronunciationAssessmentConfig.prototype.referenceText
     * @function
     * @public
     * @param {string} referenceText - Reference text.
     */
    set referenceText(e) {
      s.Contracts.throwIfNullOrWhitespace(e, "referenceText"), this.properties.setProperty(a.PropertyId.PronunciationAssessment_ReferenceText, e);
    }
    /**
     * Sets the phoneme alphabet.
     * The valid values are "SAPI" (default) and "IPA".
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.phonemeAlphabet
     * @function
     * @public
     * @param {string} phonemeAlphabet - Phoneme alphabet.
     */
    set phonemeAlphabet(e) {
      s.Contracts.throwIfNullOrWhitespace(e, "phonemeAlphabet"), this.privPhonemeAlphabet = e;
    }
    /**
     * Sets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @param {boolean} enableMiscue - enable miscue.
     */
    set enableMiscue(e) {
      const n = e ? "true" : "false";
      this.properties.setProperty(a.PropertyId.PronunciationAssessment_EnableMiscue, n);
    }
    /**
     * Gets the boolean enableMiscue property.
     * Added in version 1.26.0
     * @member PronunciationAssessmentConfig.prototype.enableMiscue
     * @function
     * @public
     * @return {boolean} enableMiscue - enable miscue.
     */
    get enableMiscue() {
      return this.properties.getProperty(a.PropertyId.PronunciationAssessment_EnableMiscue, "false").toLowerCase() === "true";
    }
    /**
     * Sets the nbest phoneme count
     * Added in version 1.20.0
     * @member PronunciationAssessmentConfig.prototype.nbestPhonemeCount
     * @function
     * @public
     * @param {number} nbestPhonemeCount - NBest phoneme count.
     */
    set nbestPhonemeCount(e) {
      this.privNBestPhonemeCount = e;
    }
    /**
     * Enables the prosody assessment.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableProsodyAssessment
     * @function
     * @public
     * @param {boolean} enableProsodyAssessment - enable prosody assessment.
     */
    set enableProsodyAssessment(e) {
      this.privEnableProsodyAssessment = e;
    }
    /**
     * Enables content assessment and sets the topic.
     * Added in version 1.34.0
     * @member PronunciationAssessmentConfig.prototype.enableContentAssessmentWithTopic
     * @function
     * @public
     * @param {string} topic - Topic for content assessment.
     */
    enableContentAssessmentWithTopic(e) {
      this.privContentAssessmentTopic = e;
    }
    /**
     * @member PronunciationAssessmentConfig.prototype.properties
     * @function
     * @public
     * @return {PropertyCollection} Properties of the config.
     * @summary Gets a pronunciation assessment config properties
     */
    get properties() {
      return this.privProperties;
    }
    updateJson() {
      const e = this.privProperties.getProperty(a.PropertyId.PronunciationAssessment_Json, "{}"), n = JSON.parse(e), t = this.privProperties.getProperty(a.PropertyId.PronunciationAssessment_ReferenceText);
      t && (n.referenceText = t);
      const o = this.privProperties.getProperty(a.PropertyId.PronunciationAssessment_GradingSystem);
      o && (n.gradingSystem = o);
      const l = this.privProperties.getProperty(a.PropertyId.PronunciationAssessment_Granularity);
      l && (n.granularity = l), this.privPhonemeAlphabet && (n.phonemeAlphabet = this.privPhonemeAlphabet), this.privNBestPhonemeCount && (n.nbestPhonemeCount = this.privNBestPhonemeCount), n.enableProsodyAssessment = this.privEnableProsodyAssessment, n.dimension = "Comprehensive", this.privProperties.getProperty(a.PropertyId.PronunciationAssessment_EnableMiscue) && (n.enableMiscue = this.enableMiscue), this.privProperties.setProperty(a.PropertyId.PronunciationAssessment_Params, JSON.stringify(n));
    }
  };
  return Lf.PronunciationAssessmentConfig = i, Lf;
}
var Mh = {}, xQ;
function nP() {
  if (xQ) return Mh;
  xQ = 1, Object.defineProperty(Mh, "__esModule", { value: !0 }), Mh.PronunciationAssessmentResult = Mh.ContentAssessmentResult = void 0;
  const s = _o, a = Hr();
  class i {
    /**
     * @Internal
     * Do not use externally.
     */
    constructor(n) {
      this.privPronJson = n;
    }
    /**
     * Correctness in using grammar and variety of sentence patterns.
     * Grammatical errors are jointly evaluated by lexical accuracy,
     * grammatical accuracy and diversity of sentence structures.
     * @member ContentAssessmentResult.prototype.grammarScore
     * @function
     * @public
     * @returns {number} Grammar score.
     */
    get grammarScore() {
      return this.privPronJson.ContentAssessment.GrammarScore;
    }
    /**
     * Proficiency in lexical usage. It evaluates the speaker's effective usage
     * of words and their appropriateness within the given context to express
     * ideas accurately, as well as level of lexical complexity.
     * @member ContentAssessmentResult.prototype.vocabularyScore
     * @function
     * @public
     * @returns {number} Vocabulary score.
     */
    get vocabularyScore() {
      return this.privPronJson.ContentAssessment.VocabularyScore;
    }
    /**
     * Level of understanding and engagement with the topic, which provides
     * insights into the speaker’s ability to express their thoughts and ideas
     * effectively and the ability to engage with the topic.
     * @member ContentAssessmentResult.prototype.topicScore
     * @function
     * @public
     * @returns {number} Topic score.
     */
    get topicScore() {
      return this.privPronJson.ContentAssessment.TopicScore;
    }
  }
  Mh.ContentAssessmentResult = i;
  let r = class TZ {
    constructor(n) {
      const t = JSON.parse(n);
      s.Contracts.throwIfNullOrUndefined(t.NBest[0], "NBest"), this.privPronJson = t.NBest[0];
    }
    /**
     * @member PronunciationAssessmentResult.fromResult
     * @function
     * @public
     * @param {RecognitionResult} result The recognition result.
     * @return {PronunciationAssessmentConfig} Instance of PronunciationAssessmentConfig
     * @summary Creates an instance of the PronunciationAssessmentResult from recognition result.
     */
    static fromResult(n) {
      s.Contracts.throwIfNullOrUndefined(n, "result");
      const t = n.properties.getProperty(a.PropertyId.SpeechServiceResponse_JsonResult);
      return s.Contracts.throwIfNullOrUndefined(t, "json"), new TZ(t);
    }
    /**
     * Gets the detail result of pronunciation assessment.
     * @member PronunciationAssessmentConfig.prototype.detailResult
     * @function
     * @public
     * @returns {DetailResult} detail result.
     */
    get detailResult() {
      return this.privPronJson;
    }
    /**
     * The score indicating the pronunciation accuracy of the given speech, which indicates
     * how closely the phonemes match a native speaker's pronunciation.
     * @member PronunciationAssessmentResult.prototype.accuracyScore
     * @function
     * @public
     * @returns {number} Accuracy score.
     */
    get accuracyScore() {
      var n;
      return (n = this.detailResult.PronunciationAssessment) == null ? void 0 : n.AccuracyScore;
    }
    /**
     * The overall score indicating the pronunciation quality of the given speech.
     * This is calculated from AccuracyScore, FluencyScore and CompletenessScore with weight.
     * @member PronunciationAssessmentResult.prototype.pronunciationScore
     * @function
     * @public
     * @returns {number} Pronunciation score.
     */
    get pronunciationScore() {
      var n;
      return (n = this.detailResult.PronunciationAssessment) == null ? void 0 : n.PronScore;
    }
    /**
     * The score indicating the completeness of the given speech by calculating the ratio of pronounced words towards entire input.
     * @member PronunciationAssessmentResult.prototype.completenessScore
     * @function
     * @public
     * @returns {number} Completeness score.
     */
    get completenessScore() {
      var n;
      return (n = this.detailResult.PronunciationAssessment) == null ? void 0 : n.CompletenessScore;
    }
    /**
     * The score indicating the fluency of the given speech.
     * @member PronunciationAssessmentResult.prototype.fluencyScore
     * @function
     * @public
     * @returns {number} Fluency score.
     */
    get fluencyScore() {
      var n;
      return (n = this.detailResult.PronunciationAssessment) == null ? void 0 : n.FluencyScore;
    }
    /**
     * The prosody score, which indicates how nature of the given speech, including stress, intonation, speaking speed and rhythm.
     * @member PronunciationAssessmentResult.prototype.prosodyScore
     * @function
     * @public
     * @returns {number} Prosody score.
     */
    get prosodyScore() {
      var n;
      return (n = this.detailResult.PronunciationAssessment) == null ? void 0 : n.ProsodyScore;
    }
    /**
     * The concent assessment result.
     * Only available when content assessment is enabled.
     * @member PronunciationAssessmentResult.prototype.contentAssessmentResult
     * @function
     * @public
     * @returns {ContentAssessmentResult} Content assessment result.
     */
    get contentAssessmentResult() {
      if (this.detailResult.ContentAssessment !== void 0)
        return new i(this.detailResult);
    }
  };
  return Mh.PronunciationAssessmentResult = r, Mh;
}
var xf = {}, HQ;
function rP() {
  if (HQ) return xf;
  HQ = 1, Object.defineProperty(xf, "__esModule", { value: !0 }), xf.AvatarConfig = void 0;
  const s = _o, a = Hr();
  let i = class {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {string} character - The avatar character.
     * @param {string} style - The avatar style.
     * @param {AvatarVideoFormat} videoFormat - The talking avatar output video format.
     */
    constructor(e, n, t) {
      this.privCustomized = !1, s.Contracts.throwIfNullOrWhitespace(e, "character"), this.character = e, this.style = n, t === void 0 && (t = new a.AvatarVideoFormat()), this.videoFormat = t;
    }
    /**
     * Indicates if the talking avatar is customized.
     */
    get customized() {
      return this.privCustomized;
    }
    /**
     * Sets if the talking avatar is customized.
     */
    set customized(e) {
      this.privCustomized = e;
    }
    /**
     * Gets the background color.
     */
    get backgroundColor() {
      return this.privBackgroundColor;
    }
    /**
     * Sets the background color.
     */
    set backgroundColor(e) {
      this.privBackgroundColor = e;
    }
    /**
     * Gets the background image.
     */
    get backgroundImage() {
      return this.privBackgroundImage;
    }
    /**
     * Sets the background image.
     * @param {URL} value - The background image.
     */
    set backgroundImage(e) {
      this.privBackgroundImage = e;
    }
    /**
     * Gets the remote ICE servers.
     * @remarks This method is designed to be used internally in the SDK.
     * @returns {RTCIceServer[]} The remote ICE servers.
     */
    get remoteIceServers() {
      return this.privRemoteIceServers;
    }
    /**
     * Sets the remote ICE servers.
     * @remarks Normally, the ICE servers are gathered from the PeerConnection,
     * set this property to override the ICE servers. E.g., the ICE servers are
     * different in client and server side.
     * @param {RTCIceServer[]} value - The remote ICE servers.
     */
    set remoteIceServers(e) {
      this.privRemoteIceServers = e;
    }
  };
  return xf.AvatarConfig = i, xf;
}
var XZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.AvatarEventArgs = s.AvatarEventTypes = void 0, function(i) {
    i.SwitchedToSpeaking = "SwitchedToSpeaking", i.SwitchedToIdle = "SwitchedToIdle", i.SessionClosed = "SessionClosed";
  }(s.AvatarEventTypes || (s.AvatarEventTypes = {}));
  class a {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {number} audioOffset - The audio offset.
     * @param {string} description - The description of the event.
     */
    constructor(r, e) {
      this.privOffset = r, this.privDescription = e;
    }
    /**
     * The type of the event.
     * @public
     * @returns {AvatarEventTypes} The type of the event.
     */
    get type() {
      return this.privType;
    }
    /**
     * The time offset associated with this event.
     * @public
     * @returns {number} The time offset associated with this event.
     */
    get offset() {
      return this.privOffset;
    }
    /**
     * The description of the event.
     * @public
     * @returns {string} The description of the event.
     */
    get description() {
      return this.privDescription;
    }
  }
  s.AvatarEventArgs = a;
})(XZ);
var Hf = {}, Pf = {}, PQ;
function kZ() {
  if (PQ) return Pf;
  PQ = 1, Object.defineProperty(Pf, "__esModule", { value: !0 }), Pf.SpeechSynthesisConnectionFactory = void 0;
  const s = Xc(), a = Hr(), i = Bu(), r = wi(), e = Tc, n = Iu;
  let t = class {
    constructor() {
      this.synthesisUri = "/cognitiveservices/websocket/v1";
    }
    create(l, c, d) {
      let u = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Endpoint, void 0);
      const h = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Region, void 0), A = i.ConnectionFactoryBase.getHostSuffix(h), g = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_EndpointId, void 0), f = g === void 0 ? "tts" : "voice", p = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Host, "wss://" + h + "." + f + ".speech" + A), v = {}, b = {};
      c.token !== void 0 && c.token !== "" && (b[c.headerName] = c.token), b[e.HeaderNames.ConnectionId] = d, g !== void 0 && g !== "" && (!u || u.search(n.QueryParameterNames.CustomVoiceDeploymentId) === -1) && (v[n.QueryParameterNames.CustomVoiceDeploymentId] = g), l.avatarEnabled && (!u || u.search(n.QueryParameterNames.EnableAvatar) === -1) && (v[n.QueryParameterNames.EnableAvatar] = "true"), u || (u = p + this.synthesisUri), l.parameters.setProperty(a.PropertyId.SpeechServiceConnection_Url, u);
      const m = l.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(u, v, b, new r.WebsocketMessageFormatter(), s.ProxyInfo.fromParameters(l.parameters), m, d);
    }
  };
  return Pf.SpeechSynthesisConnectionFactory = t, Pf;
}
var OQ;
function iP() {
  if (OQ) return Hf;
  OQ = 1, Object.defineProperty(Hf, "__esModule", { value: !0 }), Hf.AvatarSynthesizer = void 0;
  const s = kZ(), a = wi(), i = Eo(), r = sh, e = Hr(), n = _o, t = pF();
  let o = class extends e.Synthesizer {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {SpeechConfig} speechConfig - The speech config.
     * @param {AvatarConfig} avatarConfig - The talking avatar config.
     */
    constructor(c, d) {
      super(c), n.Contracts.throwIfNullOrUndefined(d, "avatarConfig"), this.privConnectionFactory = new s.SpeechSynthesisConnectionFactory(), this.privAvatarConfig = d, this.implCommonSynthesizeSetup();
    }
    implCommonSynthesizeSetup() {
      super.implCommonSynthesizeSetup(), this.privAdapter.audioOutputFormat = r.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormat(e.SpeechSynthesisOutputFormat.Riff24Khz16BitMonoPcm);
    }
    /**
     * Starts the talking avatar session and establishes the WebRTC connection.
     * @member AvatarSynthesizer.prototype.startAvatarAsync
     * @function
     * @public
     * @param {AvatarWebRTCConnectionInfo} peerConnection - The peer connection.
     * @returns {Promise<SynthesisResult>} The promise of the connection result.
     */
    async startAvatarAsync(c) {
      n.Contracts.throwIfNullOrUndefined(c, "peerConnection"), this.privIceServers = c.getConfiguration().iceServers, n.Contracts.throwIfNullOrUndefined(this.privIceServers, "Ice servers must be set.");
      const d = new i.Deferred();
      c.onicegatheringstatechange = () => {
        i.Events.instance.onEvent(new i.PlatformEvent("peer connection: ice gathering state: " + c.iceGatheringState, i.EventType.Debug)), c.iceGatheringState === "complete" && (i.Events.instance.onEvent(new i.PlatformEvent("peer connection: ice gathering complete.", i.EventType.Info)), d.resolve());
      }, c.onicecandidate = (f) => {
        f.candidate ? i.Events.instance.onEvent(new i.PlatformEvent("peer connection: ice candidate: " + f.candidate.candidate, i.EventType.Debug)) : (i.Events.instance.onEvent(new i.PlatformEvent("peer connection: ice candidate: complete", i.EventType.Debug)), d.resolve());
      }, setTimeout(() => {
        c.iceGatheringState !== "complete" && (i.Events.instance.onEvent(new i.PlatformEvent("peer connection: ice gathering timeout.", i.EventType.Warning)), d.resolve());
      }, 2e3);
      const u = await c.createOffer();
      await c.setLocalDescription(u), await d.promise, i.Events.instance.onEvent(new i.PlatformEvent("peer connection: got local SDP.", i.EventType.Info)), this.privProperties.setProperty(e.PropertyId.TalkingAvatarService_WebRTC_SDP, JSON.stringify(c.localDescription));
      const h = await this.speak("", !1);
      if (h.reason !== e.ResultReason.SynthesizingAudioCompleted)
        return new e.SynthesisResult(h.resultId, h.reason, h.errorDetails, h.properties);
      const A = atob(h.properties.getProperty(e.PropertyId.TalkingAvatarService_WebRTC_SDP)), g = new RTCSessionDescription(JSON.parse(A));
      return await c.setRemoteDescription(g), new e.SynthesisResult(h.resultId, h.reason, void 0, h.properties);
    }
    /**
     * Speaks plain text asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakTextAsync
     * @function
     * @public
     * @param {string} text - The plain text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */
    async speakTextAsync(c) {
      const d = await this.speak(c, !1);
      return new e.SynthesisResult(d.resultId, d.reason, d.errorDetails, d.properties);
    }
    /**
     * Speaks SSML asynchronously. The rendered audio and video will be sent via the WebRTC connection.
     * @member AvatarSynthesizer.prototype.speakSsmlAsync
     * @function
     * @public
     * @param {string} ssml - The SSML text to speak.
     * @returns {Promise<SynthesisResult>} The promise of the synthesis result.
     */
    async speakSsmlAsync(c) {
      const d = await this.speak(c, !0);
      return new e.SynthesisResult(d.resultId, d.reason, d.errorDetails, d.properties);
    }
    /**
     * Speaks text asynchronously. The avatar will switch to idle state.
     * @member AvatarSynthesizer.prototype.stopSpeakingAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */
    async stopSpeakingAsync() {
      for (; this.synthesisRequestQueue.length() > 0; )
        (await this.synthesisRequestQueue.dequeue()).err("Synthesis is canceled by user.");
      return this.privAdapter.stopSpeaking();
    }
    /**
     * Stops the talking avatar session and closes the WebRTC connection.
     * For now, this is the same as close().
     * You need to create a new AvatarSynthesizer instance to start a new session.
     * @member AvatarSynthesizer.prototype.stopAvatarAsync
     * @function
     * @public
     * @returns {Promise<void>} The promise of the void result.
     */
    async stopAvatarAsync() {
      return n.Contracts.throwIfDisposed(this.privDisposed), this.dispose(!0);
    }
    /**
     * Dispose of associated resources.
     * @member AvatarSynthesizer.prototype.close
     * @function
     * @public
     */
    async close() {
      if (!this.privDisposed)
        return this.dispose(!0);
    }
    /**
     * Gets the ICE servers. Internal use only.
     */
    get iceServers() {
      return this.privIceServers;
    }
    // Creates the synthesis adapter
    createSynthesisAdapter(c, d, u) {
      return new a.AvatarSynthesisAdapter(c, d, u, this, this.privAvatarConfig);
    }
    createRestSynthesisAdapter(c, d) {
    }
    createSynthesizerConfig(c) {
      const d = super.createSynthesizerConfig(c);
      return d.avatarEnabled = !0, d;
    }
    async speak(c, d) {
      const u = i.createNoDashGuid(), h = new i.Deferred();
      return this.synthesisRequestQueue.enqueue(new t.SynthesisRequest(u, c, d, (A) => {
        h.resolve(A), this.privSynthesizing = !1, this.adapterSpeak();
      }, (A) => {
        h.reject(A), this.privSynthesizing = !1;
      })), this.adapterSpeak(), h.promise;
    }
  };
  return Hf.AvatarSynthesizer = o, Hf;
}
var HA = {};
Object.defineProperty(HA, "__esModule", { value: !0 });
HA.AvatarVideoFormat = HA.Coordinate = void 0;
class oP {
  constructor(a, i) {
    this.x = a, this.y = i;
  }
}
HA.Coordinate = oP;
class aP {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {string} codec - The video codec.
   * @param {number} bitrate - The video bitrate.
   * @param {number} width - The video width.
   * @param {number} height - The video height.
   */
  constructor(a = "H264", i = 2e6, r = 1920, e = 1080) {
    this.codec = a, this.bitrate = i, this.width = r, this.height = e;
  }
  /**
   * Sets the video crop range.
   */
  setCropRange(a, i) {
    this.cropRange = {
      bottomRight: i,
      topLeft: a
    };
  }
}
HA.AvatarVideoFormat = aP;
var Of = {}, KQ;
function sP() {
  if (KQ) return Of;
  KQ = 1, Object.defineProperty(Of, "__esModule", { value: !0 }), Of.AvatarWebRTCConnectionResult = void 0;
  const s = Hr();
  let a = class extends s.SynthesisResult {
    /**
     * Creates and initializes an instance of this class.
     * @constructor
     * @param {RTCSessionDescriptionInit} SDPAnswer - The SDP answer of WebRTC connection.
     * @param {string} resultId - The result id.
     * @param {ResultReason} reason - The reason.
     * @param {string} errorDetails - Error details, if provided.
     * @param {PropertyCollection} properties - Additional properties, if provided.
     */
    constructor(r, e, n, t, o) {
      super(e, n, t, o), this.privSDPAnswer = r;
    }
    /**
     * Specifies SDP (Session Description Protocol) answer of WebRTC connection.
     * @member AvatarWebRTCConnectionResult.prototype.SDPAnswer
     * @function
     * @public
     * @returns {RTCSessionDescriptionInit} Specifies the SDP answer of WebRTC connection.
     */
    get SDPAnswer() {
      return this.privSDPAnswer;
    }
  };
  return Of.AvatarWebRTCConnectionResult = a, Of;
}
var Kf = {}, zQ;
function lP() {
  if (zQ) return Kf;
  zQ = 1, Object.defineProperty(Kf, "__esModule", { value: !0 }), Kf.Diagnostics = void 0;
  const s = Xc(), a = Eo();
  let i = class {
    static SetLoggingLevel(e) {
      this.privListener = new s.ConsoleLoggingListener(e), a.Events.instance.attachConsoleListener(this.privListener);
    }
    static StartConsoleOutput() {
      this.privListener && (this.privListener.enableConsoleOutput = !0);
    }
    static StopConsoleOutput() {
      this.privListener && (this.privListener.enableConsoleOutput = !1);
    }
    static SetLogOutputPath(e) {
      if (typeof window == "undefined")
        this.privListener && (this.privListener.logPath = e);
      else
        throw new Error("File system logging not available in browser.");
    }
    static set onLogOutput(e) {
      this.privListener && (this.privListener.logCallback = e);
    }
  };
  return Kf.Diagnostics = i, i.privListener = void 0, Kf;
}
var jQ;
function Hr() {
  return jQ || (jQ = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var a = nZ();
    Object.defineProperty(s, "AudioConfig", { enumerable: !0, get: function() {
      return a.AudioConfig;
    } });
    var i = ah;
    Object.defineProperty(s, "AudioStreamFormat", { enumerable: !0, get: function() {
      return i.AudioStreamFormat;
    } }), Object.defineProperty(s, "AudioFormatTag", { enumerable: !0, get: function() {
      return i.AudioFormatTag;
    } });
    var r = _B();
    Object.defineProperty(s, "AudioInputStream", { enumerable: !0, get: function() {
      return r.AudioInputStream;
    } }), Object.defineProperty(s, "PullAudioInputStream", { enumerable: !0, get: function() {
      return r.PullAudioInputStream;
    } }), Object.defineProperty(s, "PushAudioInputStream", { enumerable: !0, get: function() {
      return r.PushAudioInputStream;
    } });
    var e = jc;
    Object.defineProperty(s, "AudioOutputStream", { enumerable: !0, get: function() {
      return e.AudioOutputStream;
    } }), Object.defineProperty(s, "PullAudioOutputStream", { enumerable: !0, get: function() {
      return e.PullAudioOutputStream;
    } }), Object.defineProperty(s, "PushAudioOutputStream", { enumerable: !0, get: function() {
      return e.PushAudioOutputStream;
    } });
    var n = rZ;
    Object.defineProperty(s, "CancellationReason", { enumerable: !0, get: function() {
      return n.CancellationReason;
    } });
    var t = O1;
    Object.defineProperty(s, "PullAudioInputStreamCallback", { enumerable: !0, get: function() {
      return t.PullAudioInputStreamCallback;
    } });
    var o = K1;
    Object.defineProperty(s, "PushAudioOutputStreamCallback", { enumerable: !0, get: function() {
      return o.PushAudioOutputStreamCallback;
    } });
    var l = z1;
    Object.defineProperty(s, "KeywordRecognitionModel", { enumerable: !0, get: function() {
      return l.KeywordRecognitionModel;
    } });
    var c = j1;
    Object.defineProperty(s, "SessionEventArgs", { enumerable: !0, get: function() {
      return c.SessionEventArgs;
    } });
    var d = Xx();
    Object.defineProperty(s, "RecognitionEventArgs", { enumerable: !0, get: function() {
      return d.RecognitionEventArgs;
    } });
    var u = iZ;
    Object.defineProperty(s, "OutputFormat", { enumerable: !0, get: function() {
      return u.OutputFormat;
    } });
    var h = kx();
    Object.defineProperty(s, "IntentRecognitionEventArgs", { enumerable: !0, get: function() {
      return h.IntentRecognitionEventArgs;
    } });
    var A = _1;
    Object.defineProperty(s, "RecognitionResult", { enumerable: !0, get: function() {
      return A.RecognitionResult;
    } });
    var g = Dx();
    Object.defineProperty(s, "SpeechRecognitionResult", { enumerable: !0, get: function() {
      return g.SpeechRecognitionResult;
    } });
    var f = Mx();
    Object.defineProperty(s, "IntentRecognitionResult", { enumerable: !0, get: function() {
      return f.IntentRecognitionResult;
    } });
    var p = xA;
    Object.defineProperty(s, "LanguageUnderstandingModel", { enumerable: !0, get: function() {
      return p.LanguageUnderstandingModel;
    } });
    var v = Yx();
    Object.defineProperty(s, "SpeechRecognitionEventArgs", { enumerable: !0, get: function() {
      return v.SpeechRecognitionEventArgs;
    } }), Object.defineProperty(s, "ConversationTranscriptionEventArgs", { enumerable: !0, get: function() {
      return v.ConversationTranscriptionEventArgs;
    } }), Object.defineProperty(s, "MeetingTranscriptionEventArgs", { enumerable: !0, get: function() {
      return v.MeetingTranscriptionEventArgs;
    } });
    var b = Lx();
    Object.defineProperty(s, "SpeechRecognitionCanceledEventArgs", { enumerable: !0, get: function() {
      return b.SpeechRecognitionCanceledEventArgs;
    } });
    var m = xx();
    Object.defineProperty(s, "TranslationRecognitionEventArgs", { enumerable: !0, get: function() {
      return m.TranslationRecognitionEventArgs;
    } });
    var y = Hx();
    Object.defineProperty(s, "TranslationSynthesisEventArgs", { enumerable: !0, get: function() {
      return y.TranslationSynthesisEventArgs;
    } });
    var U = sZ();
    Object.defineProperty(s, "TranslationRecognitionResult", { enumerable: !0, get: function() {
      return U.TranslationRecognitionResult;
    } });
    var B = $1;
    Object.defineProperty(s, "TranslationSynthesisResult", { enumerable: !0, get: function() {
      return B.TranslationSynthesisResult;
    } });
    var Q = lZ;
    Object.defineProperty(s, "ResultReason", { enumerable: !0, get: function() {
      return Q.ResultReason;
    } });
    var N = Ox();
    Object.defineProperty(s, "SpeechConfig", { enumerable: !0, get: function() {
      return N.SpeechConfig;
    } }), Object.defineProperty(s, "SpeechConfigImpl", { enumerable: !0, get: function() {
      return N.SpeechConfigImpl;
    } });
    var J = Kx();
    Object.defineProperty(s, "SpeechTranslationConfig", { enumerable: !0, get: function() {
      return J.SpeechTranslationConfig;
    } }), Object.defineProperty(s, "SpeechTranslationConfigImpl", { enumerable: !0, get: function() {
      return J.SpeechTranslationConfigImpl;
    } });
    var w = dZ();
    Object.defineProperty(s, "PropertyCollection", { enumerable: !0, get: function() {
      return w.PropertyCollection;
    } });
    var W = q1;
    Object.defineProperty(s, "PropertyId", { enumerable: !0, get: function() {
      return W.PropertyId;
    } });
    var G = zx();
    Object.defineProperty(s, "Recognizer", { enumerable: !0, get: function() {
      return G.Recognizer;
    } });
    var Z = jx();
    Object.defineProperty(s, "SpeechRecognizer", { enumerable: !0, get: function() {
      return Z.SpeechRecognizer;
    } });
    var K = _x();
    Object.defineProperty(s, "IntentRecognizer", { enumerable: !0, get: function() {
      return K.IntentRecognizer;
    } });
    var L = AZ;
    Object.defineProperty(s, "VoiceProfileType", { enumerable: !0, get: function() {
      return L.VoiceProfileType;
    } });
    var O = $x();
    Object.defineProperty(s, "TranslationRecognizer", { enumerable: !0, get: function() {
      return O.TranslationRecognizer;
    } });
    var de = qx();
    Object.defineProperty(s, "Translations", { enumerable: !0, get: function() {
      return de.Translations;
    } });
    var oe = mZ;
    Object.defineProperty(s, "NoMatchReason", { enumerable: !0, get: function() {
      return oe.NoMatchReason;
    } });
    var fe = eH();
    Object.defineProperty(s, "NoMatchDetails", { enumerable: !0, get: function() {
      return fe.NoMatchDetails;
    } });
    var ge = e2;
    Object.defineProperty(s, "TranslationRecognitionCanceledEventArgs", { enumerable: !0, get: function() {
      return ge.TranslationRecognitionCanceledEventArgs;
    } });
    var we = nH();
    Object.defineProperty(s, "IntentRecognitionCanceledEventArgs", { enumerable: !0, get: function() {
      return we.IntentRecognitionCanceledEventArgs;
    } });
    var _e = sm;
    Object.defineProperty(s, "CancellationDetailsBase", { enumerable: !0, get: function() {
      return _e.CancellationDetailsBase;
    } });
    var Te = iH();
    Object.defineProperty(s, "CancellationDetails", { enumerable: !0, get: function() {
      return Te.CancellationDetails;
    } });
    var Pe = FZ;
    Object.defineProperty(s, "CancellationErrorCode", { enumerable: !0, get: function() {
      return Pe.CancellationErrorCode;
    } });
    var $e = oH();
    Object.defineProperty(s, "ConnectionEventArgs", { enumerable: !0, get: function() {
      return $e.ConnectionEventArgs;
    } });
    var Bt = aH();
    Object.defineProperty(s, "ServiceEventArgs", { enumerable: !0, get: function() {
      return Bt.ServiceEventArgs;
    } });
    var Le = fZ();
    Object.defineProperty(s, "Connection", { enumerable: !0, get: function() {
      return Le.Connection;
    } });
    var at = t2;
    Object.defineProperty(s, "PhraseListGrammar", { enumerable: !0, get: function() {
      return at.PhraseListGrammar;
    } });
    var pt = uF();
    Object.defineProperty(s, "DialogServiceConfig", { enumerable: !0, get: function() {
      return pt.DialogServiceConfig;
    } });
    var kt = sH();
    Object.defineProperty(s, "BotFrameworkConfig", { enumerable: !0, get: function() {
      return kt.BotFrameworkConfig;
    } });
    var _t = lH();
    Object.defineProperty(s, "CustomCommandsConfig", { enumerable: !0, get: function() {
      return _t.CustomCommandsConfig;
    } });
    var Lt = dH();
    Object.defineProperty(s, "DialogServiceConnector", { enumerable: !0, get: function() {
      return Lt.DialogServiceConnector;
    } });
    var Ft = n2;
    Object.defineProperty(s, "ActivityReceivedEventArgs", { enumerable: !0, get: function() {
      return Ft.ActivityReceivedEventArgs;
    } });
    var Zt = r2;
    Object.defineProperty(s, "TurnStatusReceivedEventArgs", { enumerable: !0, get: function() {
      return Zt.TurnStatusReceivedEventArgs;
    } });
    var ft = RZ;
    Object.defineProperty(s, "ServicePropertyChannel", { enumerable: !0, get: function() {
      return ft.ServicePropertyChannel;
    } });
    var It = yZ;
    Object.defineProperty(s, "ProfanityOption", { enumerable: !0, get: function() {
      return It.ProfanityOption;
    } });
    var Kt = gH();
    Object.defineProperty(s, "BaseAudioPlayer", { enumerable: !0, get: function() {
      return Kt.BaseAudioPlayer;
    } });
    var Sn = o2;
    Object.defineProperty(s, "ConnectionMessageEventArgs", { enumerable: !0, get: function() {
      return Sn.ConnectionMessageEventArgs;
    } });
    var Cn = gZ();
    Object.defineProperty(s, "ConnectionMessage", { enumerable: !0, get: function() {
      return Cn.ConnectionMessage;
    } });
    var on = a2;
    Object.defineProperty(s, "VoiceProfile", { enumerable: !0, get: function() {
      return on.VoiceProfile;
    } });
    var An = mH();
    Object.defineProperty(s, "VoiceProfileEnrollmentResult", { enumerable: !0, get: function() {
      return An.VoiceProfileEnrollmentResult;
    } }), Object.defineProperty(s, "VoiceProfileEnrollmentCancellationDetails", { enumerable: !0, get: function() {
      return An.VoiceProfileEnrollmentCancellationDetails;
    } });
    var Ue = vH();
    Object.defineProperty(s, "VoiceProfileResult", { enumerable: !0, get: function() {
      return Ue.VoiceProfileResult;
    } }), Object.defineProperty(s, "VoiceProfileCancellationDetails", { enumerable: !0, get: function() {
      return Ue.VoiceProfileCancellationDetails;
    } });
    var ne = bH();
    Object.defineProperty(s, "VoiceProfilePhraseResult", { enumerable: !0, get: function() {
      return ne.VoiceProfilePhraseResult;
    } });
    var se = FH();
    Object.defineProperty(s, "VoiceProfileClient", { enumerable: !0, get: function() {
      return se.VoiceProfileClient;
    } });
    var Ce = RH();
    Object.defineProperty(s, "SpeakerRecognizer", { enumerable: !0, get: function() {
      return Ce.SpeakerRecognizer;
    } });
    var At = yH();
    Object.defineProperty(s, "SpeakerIdentificationModel", { enumerable: !0, get: function() {
      return At.SpeakerIdentificationModel;
    } });
    var Ge = QH();
    Object.defineProperty(s, "SpeakerVerificationModel", { enumerable: !0, get: function() {
      return Ge.SpeakerVerificationModel;
    } });
    var Ye = CH();
    Object.defineProperty(s, "AutoDetectSourceLanguageConfig", { enumerable: !0, get: function() {
      return Ye.AutoDetectSourceLanguageConfig;
    } });
    var Qt = s2;
    Object.defineProperty(s, "AutoDetectSourceLanguageResult", { enumerable: !0, get: function() {
      return Qt.AutoDetectSourceLanguageResult;
    } });
    var tn = l2;
    Object.defineProperty(s, "SourceLanguageConfig", { enumerable: !0, get: function() {
      return tn.SourceLanguageConfig;
    } });
    var vn = IH();
    Object.defineProperty(s, "SpeakerRecognitionResult", { enumerable: !0, get: function() {
      return vn.SpeakerRecognitionResult;
    } }), Object.defineProperty(s, "SpeakerRecognitionResultType", { enumerable: !0, get: function() {
      return vn.SpeakerRecognitionResultType;
    } }), Object.defineProperty(s, "SpeakerRecognitionCancellationDetails", { enumerable: !0, get: function() {
      return vn.SpeakerRecognitionCancellationDetails;
    } });
    var Yt = fF();
    Object.defineProperty(s, "Conversation", { enumerable: !0, get: function() {
      return Yt.Conversation;
    } }), Object.defineProperty(s, "ConversationExpirationEventArgs", { enumerable: !0, get: function() {
      return Yt.ConversationExpirationEventArgs;
    } }), Object.defineProperty(s, "ConversationParticipantsChangedEventArgs", { enumerable: !0, get: function() {
      return Yt.ConversationParticipantsChangedEventArgs;
    } }), Object.defineProperty(s, "ConversationTranslationCanceledEventArgs", { enumerable: !0, get: function() {
      return Yt.ConversationTranslationCanceledEventArgs;
    } }), Object.defineProperty(s, "ConversationTranslationEventArgs", { enumerable: !0, get: function() {
      return Yt.ConversationTranslationEventArgs;
    } }), Object.defineProperty(s, "ConversationTranslationResult", { enumerable: !0, get: function() {
      return Yt.ConversationTranslationResult;
    } }), Object.defineProperty(s, "ConversationTranslator", { enumerable: !0, get: function() {
      return Yt.ConversationTranslator;
    } }), Object.defineProperty(s, "ConversationTranscriber", { enumerable: !0, get: function() {
      return Yt.ConversationTranscriber;
    } }), Object.defineProperty(s, "ConversationTranscriptionResult", { enumerable: !0, get: function() {
      return Yt.ConversationTranscriptionResult;
    } }), Object.defineProperty(s, "Meeting", { enumerable: !0, get: function() {
      return Yt.Meeting;
    } }), Object.defineProperty(s, "MeetingTranscriber", { enumerable: !0, get: function() {
      return Yt.MeetingTranscriber;
    } }), Object.defineProperty(s, "Participant", { enumerable: !0, get: function() {
      return Yt.Participant;
    } }), Object.defineProperty(s, "ParticipantChangedReason", { enumerable: !0, get: function() {
      return Yt.ParticipantChangedReason;
    } }), Object.defineProperty(s, "User", { enumerable: !0, get: function() {
      return Yt.User;
    } });
    var Tn = pF();
    Object.defineProperty(s, "Synthesizer", { enumerable: !0, get: function() {
      return Tn.Synthesizer;
    } });
    var er = sF;
    Object.defineProperty(s, "SpeechSynthesisOutputFormat", { enumerable: !0, get: function() {
      return er.SpeechSynthesisOutputFormat;
    } });
    var lr = YH();
    Object.defineProperty(s, "SpeechSynthesizer", { enumerable: !0, get: function() {
      return lr.SpeechSynthesizer;
    } });
    var Br = d2;
    Object.defineProperty(s, "SynthesisResult", { enumerable: !0, get: function() {
      return Br.SynthesisResult;
    } });
    var pi = xH();
    Object.defineProperty(s, "SpeechSynthesisResult", { enumerable: !0, get: function() {
      return pi.SpeechSynthesisResult;
    } });
    var $n = u2;
    Object.defineProperty(s, "SpeechSynthesisEventArgs", { enumerable: !0, get: function() {
      return $n.SpeechSynthesisEventArgs;
    } });
    var rr = h2;
    Object.defineProperty(s, "SpeechSynthesisWordBoundaryEventArgs", { enumerable: !0, get: function() {
      return rr.SpeechSynthesisWordBoundaryEventArgs;
    } });
    var Kr = A2;
    Object.defineProperty(s, "SpeechSynthesisBookmarkEventArgs", { enumerable: !0, get: function() {
      return Kr.SpeechSynthesisBookmarkEventArgs;
    } });
    var Bi = g2;
    Object.defineProperty(s, "SpeechSynthesisVisemeEventArgs", { enumerable: !0, get: function() {
      return Bi.SpeechSynthesisVisemeEventArgs;
    } });
    var Li = VZ;
    Object.defineProperty(s, "SpeechSynthesisBoundaryType", { enumerable: !0, get: function() {
      return Li.SpeechSynthesisBoundaryType;
    } });
    var xo = zH();
    Object.defineProperty(s, "SynthesisVoicesResult", { enumerable: !0, get: function() {
      return xo.SynthesisVoicesResult;
    } });
    var Yr = WZ;
    Object.defineProperty(s, "VoiceInfo", { enumerable: !0, get: function() {
      return Yr.VoiceInfo;
    } });
    var Qo = f2;
    Object.defineProperty(s, "SpeakerAudioDestination", { enumerable: !0, get: function() {
      return Qo.SpeakerAudioDestination;
    } });
    var Wo = qH();
    Object.defineProperty(s, "ConversationTranscriptionCanceledEventArgs", { enumerable: !0, get: function() {
      return Wo.ConversationTranscriptionCanceledEventArgs;
    } });
    var xi = eP();
    Object.defineProperty(s, "MeetingTranscriptionCanceledEventArgs", { enumerable: !0, get: function() {
      return xi.MeetingTranscriptionCanceledEventArgs;
    } });
    var Fa = NZ;
    Object.defineProperty(s, "PronunciationAssessmentGradingSystem", { enumerable: !0, get: function() {
      return Fa.PronunciationAssessmentGradingSystem;
    } });
    var sn = JZ;
    Object.defineProperty(s, "PronunciationAssessmentGranularity", { enumerable: !0, get: function() {
      return sn.PronunciationAssessmentGranularity;
    } });
    var Ct = tP();
    Object.defineProperty(s, "PronunciationAssessmentConfig", { enumerable: !0, get: function() {
      return Ct.PronunciationAssessmentConfig;
    } });
    var cn = nP();
    Object.defineProperty(s, "PronunciationAssessmentResult", { enumerable: !0, get: function() {
      return cn.PronunciationAssessmentResult;
    } });
    var Hn = AF;
    Object.defineProperty(s, "LanguageIdMode", { enumerable: !0, get: function() {
      return Hn.LanguageIdMode;
    } });
    var Sr = rP();
    Object.defineProperty(s, "AvatarConfig", { enumerable: !0, get: function() {
      return Sr.AvatarConfig;
    } });
    var ao = XZ;
    Object.defineProperty(s, "AvatarEventArgs", { enumerable: !0, get: function() {
      return ao.AvatarEventArgs;
    } });
    var wr = iP();
    Object.defineProperty(s, "AvatarSynthesizer", { enumerable: !0, get: function() {
      return wr.AvatarSynthesizer;
    } });
    var Jr = HA;
    Object.defineProperty(s, "AvatarVideoFormat", { enumerable: !0, get: function() {
      return Jr.AvatarVideoFormat;
    } }), Object.defineProperty(s, "Coordinate", { enumerable: !0, get: function() {
      return Jr.Coordinate;
    } });
    var Fn = sP();
    Object.defineProperty(s, "AvatarWebRTCConnectionResult", { enumerable: !0, get: function() {
      return Fn.AvatarWebRTCConnectionResult;
    } });
    var Ia = lP();
    Object.defineProperty(s, "Diagnostics", { enumerable: !0, get: function() {
      return Ia.Diagnostics;
    } });
    var wt = oF;
    Object.defineProperty(s, "LogLevel", { enumerable: !0, get: function() {
      return wt.LogLevel;
    } });
  }(xv)), xv;
}
var _Q;
function cP() {
  if (_Q) return Pg;
  _Q = 1, Object.defineProperty(Pg, "__esModule", { value: !0 }), Pg.ProxyInfo = void 0;
  const s = Hr();
  let a = class wZ {
    constructor(r, e, n, t) {
      this.privProxyHostName = r, this.privProxyPort = e, this.privProxyUserName = n, this.privProxyPassword = t;
    }
    static fromParameters(r) {
      return new wZ(r.getProperty(s.PropertyId.SpeechServiceConnection_ProxyHostName), parseInt(r.getProperty(s.PropertyId.SpeechServiceConnection_ProxyPort), 10), r.getProperty(s.PropertyId.SpeechServiceConnection_ProxyUserName), r.getProperty(s.PropertyId.SpeechServiceConnection_ProxyPassword));
    }
    static fromRecognizerConfig(r) {
      return this.fromParameters(r.parameters);
    }
    get HostName() {
      return this.privProxyHostName;
    }
    get Port() {
      return this.privProxyPort;
    }
    get UserName() {
      return this.privProxyUserName;
    }
    get Password() {
      return this.privProxyPassword;
    }
  };
  return Pg.ProxyInfo = a, Pg;
}
var DZ = {};
const dP = /* @__PURE__ */ new Set(["json", "buffer", "string"]);
var uP = (s) => (...a) => {
  const i = /* @__PURE__ */ new Set();
  let r, e, n, t = "";
  return a.forEach((o) => {
    if (typeof o == "string")
      if (o.toUpperCase() === o)
        if (r) {
          const l = `Can't set method to ${o}, already set to ${r}.`;
          throw new Error(l);
        } else
          r = o;
      else if (o.startsWith("http:") || o.startsWith("https:"))
        t = o;
      else if (dP.has(o))
        e = o;
      else
        throw new Error(`Unknown encoding, ${o}`);
    else if (typeof o == "number")
      i.add(o);
    else if (typeof o == "object")
      if (Array.isArray(o) || o instanceof Set)
        o.forEach((l) => i.add(l));
      else {
        if (n)
          throw new Error("Cannot set headers twice.");
        n = o;
      }
    else
      throw new Error(`Unknown type: ${typeof o}`);
  }), r || (r = "GET"), i.size === 0 && i.add(200), s(i, r, e, n, t);
};
const hP = uP;
class mF extends Error {
  constructor(a, ...i) {
    super(...i), Error.captureStackTrace && Error.captureStackTrace(this, mF), this.name = "StatusError", this.message = a.statusMessage, this.statusCode = a.status, this.res = a, this.json = a.json.bind(a), this.text = a.text.bind(a), this.arrayBuffer = a.arrayBuffer.bind(a);
    let r;
    Object.defineProperty(this, "responseBody", { get: () => (r || (r = this.arrayBuffer()), r) }), this.headers = {};
    for (const [n, t] of a.headers.entries())
      this.headers[n.toLowerCase()] = t;
  }
}
const AP = (s, a, i, r, e) => async (n, t, o = {}) => {
  n = e + (n || "");
  let l = new URL(n);
  if (r || (r = {}), l.username && (r.Authorization = "Basic " + btoa(l.username + ":" + l.password), l = new URL(l.protocol + "//" + l.host + l.pathname + l.search)), l.protocol !== "https:" && l.protocol !== "http:")
    throw new Error(`Unknown protocol, ${l.protocol}`);
  if (t && !(t instanceof ArrayBuffer || ArrayBuffer.isView(t) || typeof t == "string"))
    if (typeof t == "object")
      t = JSON.stringify(t), r["Content-Type"] = "application/json";
    else
      throw new Error("Unknown body type.");
  o = new Headers({ ...r || {}, ...o });
  const c = await fetch(l, { method: a, headers: o, body: t });
  if (c.statusCode = c.status, !s.has(c.status))
    throw new mF(c);
  return i === "json" ? c.json() : i === "buffer" ? c.arrayBuffer() : i === "string" ? c.text() : c;
};
var gP = hP(AP);
(function(s) {
  var a = Dn && Dn.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(s, "__esModule", { value: !0 }), s.RestMessageAdapter = s.RestRequestType = void 0;
  const i = a(gP), r = Eo();
  var e;
  (function(t) {
    t.Get = "GET", t.Post = "POST", t.Delete = "DELETE", t.File = "file";
  })(e = s.RestRequestType || (s.RestRequestType = {}));
  class n {
    constructor(o) {
      if (!o)
        throw new r.ArgumentNullError("configParams");
      this.privHeaders = o.headers, this.privIgnoreCache = o.ignoreCache;
    }
    static extractHeaderValue(o, l) {
      let c = "";
      try {
        const d = l.trim().split(/[\r\n]+/), u = {};
        d.forEach((h) => {
          const A = h.split(": "), g = A.shift().toLowerCase(), f = A.join(": ");
          u[g] = f;
        }), c = u[o.toLowerCase()];
      } catch {
      }
      return c;
    }
    set options(o) {
      this.privHeaders = o.headers, this.privIgnoreCache = o.ignoreCache;
    }
    setHeaders(o, l) {
      this.privHeaders[o] = l;
    }
    request(o, l, c = {}, d = null) {
      const u = new r.Deferred(), h = o === e.File ? "POST" : o, A = (f, p = {}) => {
        const v = f;
        return {
          data: JSON.stringify(p),
          headers: JSON.stringify(f.headers),
          json: p,
          ok: f.statusCode >= 200 && f.statusCode < 300,
          status: f.statusCode,
          statusText: p.error ? p.error.message : v.statusText ? v.statusText : v.statusMessage
        };
      }, g = (f) => {
        const p = i.default(l, h, this.privHeaders, 200, 201, 202, 204, 400, 401, 402, 403, 404), v = this.queryParams(c) === "" ? "" : `?${this.queryParams(c)}`;
        p(v, f).then(async (b) => {
          if (o === e.Delete || b.statusCode === 204)
            u.resolve(A(b));
          else
            try {
              const m = await b.json();
              u.resolve(A(b, m));
            } catch {
              u.resolve(A(b));
            }
        }).catch((b) => {
          u.reject(b);
        });
      };
      return this.privIgnoreCache && (this.privHeaders["Cache-Control"] = "no-cache"), o === e.Post && d && (this.privHeaders["content-type"] = "application/json", this.privHeaders["Content-Type"] = "application/json"), g(d), u.promise;
    }
    queryParams(o = {}) {
      return Object.keys(o).map((l) => encodeURIComponent(l) + "=" + encodeURIComponent(o[l])).join("&");
    }
  }
  s.RestMessageAdapter = n;
})(DZ);
var cm = {};
Object.defineProperty(cm, "__esModule", { value: !0 });
cm.RestConfigBase = void 0;
class $0 {
  static get requestOptions() {
    return $0.privDefaultRequestOptions;
  }
  static get configParams() {
    return $0.privDefaultParams;
  }
  static get restErrors() {
    return $0.privRestErrors;
  }
}
cm.RestConfigBase = $0;
$0.privDefaultRequestOptions = {
  headers: {
    Accept: "application/json"
  },
  ignoreCache: !1,
  timeout: 1e4
};
$0.privRestErrors = {
  authInvalidSubscriptionKey: "You must specify either an authentication token to use, or a Cognitive Speech subscription key.",
  authInvalidSubscriptionRegion: "You must specify the Cognitive Speech region to use.",
  invalidArgs: "Required input not found: {arg}.",
  invalidCreateJoinConversationResponse: "Creating/Joining conversation failed with HTTP {status}.",
  invalidParticipantRequest: "The requested participant was not found.",
  permissionDeniedConnect: "Required credentials not found.",
  permissionDeniedConversation: "Invalid operation: only the host can {command} the conversation.",
  permissionDeniedParticipant: "Invalid operation: only the host can {command} a participant.",
  permissionDeniedSend: "Invalid operation: the conversation is not in a connected state.",
  permissionDeniedStart: "Invalid operation: there is already an active conversation."
};
$0.privDefaultParams = {
  apiVersion: "api-version",
  authorization: "Authorization",
  clientAppId: "X-ClientAppId",
  contentTypeKey: "Content-Type",
  correlationId: "X-CorrelationId",
  languageCode: "language",
  nickname: "nickname",
  profanity: "profanity",
  requestId: "X-RequestId",
  roomId: "roomid",
  sessionToken: "token",
  subscriptionKey: "Ocp-Apim-Subscription-Key",
  subscriptionRegion: "Ocp-Apim-Subscription-Region",
  token: "X-CapitoToken"
};
var $Q;
function Xc() {
  return $Q || ($Q = 1, function(s) {
    var a = Dn && Dn.__createBinding || (Object.create ? function(r, e, n, t) {
      t === void 0 && (t = n), Object.defineProperty(r, t, { enumerable: !0, get: function() {
        return e[n];
      } });
    } : function(r, e, n, t) {
      t === void 0 && (t = n), r[t] = e[n];
    }), i = Dn && Dn.__exportStar || function(r, e) {
      for (var n in r) n !== "default" && !e.hasOwnProperty(n) && a(e, r, n);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), i(L1, s), i(zB, s), i(ux(), s), i(hx(), s), i(x1, s), i(H1, s), i(im, s), i(P1, s), i(cP(), s), i(DZ, s), i(cm, s);
  }(Mv)), Mv;
}
var qQ;
function fP() {
  if (qQ) return Lg;
  qQ = 1, Object.defineProperty(Lg, "__esModule", { value: !0 }), Lg.IntentConnectionFactory = void 0;
  const s = Xc(), a = Hr(), i = Bu(), r = wi(), e = Tc;
  let n = class extends i.ConnectionFactoryBase {
    create(o, l, c) {
      let d = o.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Endpoint);
      if (!d) {
        const g = o.parameters.getProperty(a.PropertyId.SpeechServiceConnection_IntentRegion), f = i.ConnectionFactoryBase.getHostSuffix(g);
        d = o.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Host, "wss://" + g + ".sr.speech" + f) + "/speech/recognition/interactive/cognitiveservices/v1";
      }
      const u = {
        format: "simple",
        language: o.parameters.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage)
      };
      this.setCommonUrlParams(o, u, d);
      const h = {};
      l.token !== void 0 && l.token !== "" && (h[l.headerName] = l.token), h[e.HeaderNames.ConnectionId] = c, o.parameters.setProperty(a.PropertyId.SpeechServiceConnection_Url, d);
      const A = o.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(d, u, h, new r.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(o), A, c);
    }
    getSpeechRegionFromIntentRegion(o) {
      switch (o) {
        case "West US":
        case "US West":
        case "westus":
          return "uswest";
        case "West US 2":
        case "US West 2":
        case "westus2":
          return "uswest2";
        case "South Central US":
        case "US South Central":
        case "southcentralus":
          return "ussouthcentral";
        case "West Central US":
        case "US West Central":
        case "westcentralus":
          return "uswestcentral";
        case "East US":
        case "US East":
        case "eastus":
          return "useast";
        case "East US 2":
        case "US East 2":
        case "eastus2":
          return "useast2";
        case "West Europe":
        case "Europe West":
        case "westeurope":
          return "europewest";
        case "North Europe":
        case "Europe North":
        case "northeurope":
          return "europenorth";
        case "Brazil South":
        case "South Brazil":
        case "southbrazil":
          return "brazilsouth";
        case "Australia East":
        case "East Australia":
        case "eastaustralia":
          return "australiaeast";
        case "Southeast Asia":
        case "Asia Southeast":
        case "southeastasia":
          return "asiasoutheast";
        case "East Asia":
        case "Asia East":
        case "eastasia":
          return "asiaeast";
        default:
          return o;
      }
    }
  };
  return Lg.IntentConnectionFactory = n, Lg;
}
var Yh = {}, eC;
function pP() {
  if (eC) return Yh;
  eC = 1, Object.defineProperty(Yh, "__esModule", { value: !0 }), Yh.VoiceProfileConnectionFactory = Yh.SpeakerRecognitionConnectionFactory = void 0;
  const s = Xc(), a = Hr(), i = Bu(), r = wi(), e = Tc;
  class n extends i.ConnectionFactoryBase {
    create(c, d, u, h) {
      let A = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Endpoint);
      if (!A) {
        const v = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Region), b = i.ConnectionFactoryBase.getHostSuffix(v), m = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Host, `wss://${v}.spr-frontend.speech${b}`), y = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_SpeakerIdMode, "TextIndependentIdentification");
        A = `${m}/speaker/ws/${this.scenarioToPath(y)}/${u}`;
      }
      const g = {
        format: "simple",
        language: c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage)
      };
      this.setCommonUrlParams(c, g, A);
      const f = {};
      d.token !== void 0 && d.token !== "" && (f[d.headerName] = d.token), f[e.HeaderNames.ConnectionId] = h, f[e.HeaderNames.SpIDAuthKey] = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Key), c.parameters.setProperty(a.PropertyId.SpeechServiceConnection_Url, A);
      const p = c.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(A, g, f, new r.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(c), p, h);
    }
    scenarioToPath(c) {
      switch (c) {
        case "TextIndependentVerification":
        case "2":
          return "verification/text-independent";
        case "TextDependentVerification":
        case "1":
          return "verification/text-dependent";
        default:
          return "identification/text-independent";
      }
    }
  }
  let t = class extends n {
    create(c, d, u) {
      return super.create(c, d, "recognition", u);
    }
  };
  Yh.SpeakerRecognitionConnectionFactory = t;
  class o extends n {
    create(c, d, u) {
      return super.create(c, d, "profile", u);
    }
  }
  return Yh.VoiceProfileConnectionFactory = o, Yh;
}
var p2 = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.RecognitionEndedEvent = s.RecognitionCompletionStatus = s.RecognitionStartedEvent = s.ConnectingToServiceEvent = s.ListeningStartedEvent = s.RecognitionTriggeredEvent = s.SpeechRecognitionEvent = void 0;
  const a = Eo();
  class i extends a.PlatformEvent {
    constructor(d, u, h, A = a.EventType.Info) {
      super(d, A), this.privRequestId = u, this.privSessionId = h;
    }
    get requestId() {
      return this.privRequestId;
    }
    get sessionId() {
      return this.privSessionId;
    }
  }
  s.SpeechRecognitionEvent = i;
  class r extends i {
    constructor(d, u, h, A) {
      super("RecognitionTriggeredEvent", d, u), this.privAudioSourceId = h, this.privAudioNodeId = A;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
  }
  s.RecognitionTriggeredEvent = r;
  class e extends i {
    constructor(d, u, h, A) {
      super("ListeningStartedEvent", d, u), this.privAudioSourceId = h, this.privAudioNodeId = A;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
  }
  s.ListeningStartedEvent = e;
  class n extends i {
    constructor(d, u, h) {
      super("ConnectingToServiceEvent", d, h), this.privAuthFetchEventid = u;
    }
    get authFetchEventid() {
      return this.privAuthFetchEventid;
    }
  }
  s.ConnectingToServiceEvent = n;
  class t extends i {
    constructor(d, u, h, A, g) {
      super("RecognitionStartedEvent", d, g), this.privAudioSourceId = u, this.privAudioNodeId = h, this.privAuthFetchEventId = A;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
    get authFetchEventId() {
      return this.privAuthFetchEventId;
    }
  }
  s.RecognitionStartedEvent = t;
  var o;
  (function(c) {
    c[c.Success = 0] = "Success", c[c.AudioSourceError = 1] = "AudioSourceError", c[c.AudioSourceTimeout = 2] = "AudioSourceTimeout", c[c.AuthTokenFetchError = 3] = "AuthTokenFetchError", c[c.AuthTokenFetchTimeout = 4] = "AuthTokenFetchTimeout", c[c.UnAuthorized = 5] = "UnAuthorized", c[c.ConnectTimeout = 6] = "ConnectTimeout", c[c.ConnectError = 7] = "ConnectError", c[c.ClientRecognitionActivityTimeout = 8] = "ClientRecognitionActivityTimeout", c[c.UnknownError = 9] = "UnknownError";
  })(o = s.RecognitionCompletionStatus || (s.RecognitionCompletionStatus = {}));
  class l extends i {
    constructor(d, u, h, A, g, f, p, v) {
      super("RecognitionEndedEvent", d, g, p === o.Success ? a.EventType.Info : a.EventType.Error), this.privAudioSourceId = u, this.privAudioNodeId = h, this.privAuthFetchEventId = A, this.privStatus = p, this.privError = v, this.privServiceTag = f;
    }
    get audioSourceId() {
      return this.privAudioSourceId;
    }
    get audioNodeId() {
      return this.privAudioNodeId;
    }
    get authFetchEventId() {
      return this.privAuthFetchEventId;
    }
    get serviceTag() {
      return this.privServiceTag;
    }
    get status() {
      return this.privStatus;
    }
    get error() {
      return this.privError;
    }
  }
  s.RecognitionEndedEvent = l;
})(p2);
var zf = {}, R0 = {};
Object.defineProperty(R0, "__esModule", { value: !0 });
R0.SpeechConnectionMessage = void 0;
const zv = Eo(), f0 = Tc;
class vF extends zv.ConnectionMessage {
  constructor(a, i, r, e, n, t, o, l) {
    if (!i)
      throw new zv.ArgumentNullError("path");
    if (!r)
      throw new zv.ArgumentNullError("requestId");
    const c = {};
    if (c[f0.HeaderNames.Path] = i, c[f0.HeaderNames.RequestId] = r, c[f0.HeaderNames.RequestTimestamp] = (/* @__PURE__ */ new Date()).toISOString(), e && (c[f0.HeaderNames.ContentType] = e), t && (c[f0.HeaderNames.RequestStreamId] = t), o)
      for (const d in o)
        d && (c[d] = o[d]);
    l ? super(a, n, c, l) : super(a, n, c), this.privPath = i, this.privRequestId = r, this.privContentType = e, this.privStreamId = t, this.privAdditionalHeaders = o;
  }
  get path() {
    return this.privPath;
  }
  get requestId() {
    return this.privRequestId;
  }
  get contentType() {
    return this.privContentType;
  }
  get streamId() {
    return this.privStreamId;
  }
  get additionalHeaders() {
    return this.privAdditionalHeaders;
  }
  static fromConnectionMessage(a) {
    let i = null, r = null, e = null, n = null;
    const t = {};
    if (a.headers)
      for (const o in a.headers)
        o && (o.toLowerCase() === f0.HeaderNames.Path.toLowerCase() ? i = a.headers[o] : o.toLowerCase() === f0.HeaderNames.RequestId.toLowerCase() ? r = a.headers[o] : o.toLowerCase() === f0.HeaderNames.ContentType.toLowerCase() ? e = a.headers[o] : o.toLowerCase() === f0.HeaderNames.RequestStreamId.toLowerCase() ? n = a.headers[o] : t[o] = a.headers[o]);
    return new vF(a.messageType, i, r, e, a.body, n, t, a.id);
  }
}
R0.SpeechConnectionMessage = vF;
var tC;
function mP() {
  if (tC) return zf;
  tC = 1, Object.defineProperty(zf, "__esModule", { value: !0 }), zf.ServiceRecognizerBase = void 0;
  const s = Xc(), a = Eo(), i = Hr(), r = wi(), e = R0;
  let n = class Bp {
    constructor(o, l, c, d, u) {
      if (this.privConnectionConfigurationPromise = void 0, this.privConnectionPromise = void 0, this.privSetTimeout = setTimeout, this.privIsLiveAudio = !1, this.privAverageBytesPerMs = 0, this.privEnableSpeakerId = !1, this.privExpectContentAssessmentResponse = !1, this.recognizeOverride = void 0, this.recognizeSpeaker = void 0, this.disconnectOverride = void 0, this.receiveMessageOverride = void 0, this.sendPrePayloadJSONOverride = void 0, this.postConnectImplOverride = void 0, this.configConnectionOverride = void 0, this.handleSpeechPhraseMessage = void 0, this.handleSpeechHypothesisMessage = void 0, !o)
        throw new a.ArgumentNullError("authentication");
      if (!l)
        throw new a.ArgumentNullError("connectionFactory");
      if (!c)
        throw new a.ArgumentNullError("audioSource");
      if (!d)
        throw new a.ArgumentNullError("recognizerConfig");
      this.privEnableSpeakerId = d.isSpeakerDiarizationEnabled, this.privMustReportEndOfStream = !1, this.privAuthentication = o, this.privConnectionFactory = l, this.privAudioSource = c, this.privRecognizerConfig = d, this.privIsDisposed = !1, this.privRecognizer = u, this.privRequestSession = new r.RequestSession(this.privAudioSource.id()), this.privConnectionEvents = new a.EventSource(), this.privServiceEvents = new a.EventSource(), this.privDynamicGrammar = new r.DynamicGrammarBuilder(), this.privSpeechContext = new r.SpeechContext(this.privDynamicGrammar), this.privAgentConfig = new r.AgentConfig(), this.privRecognizerConfig.parameters.getProperty(i.PropertyId.WebWorkerLoadType, "on").toLowerCase() === "on" && typeof Blob != "undefined" && typeof Worker != "undefined" ? this.privSetTimeout = a.Timeout.setTimeout : (typeof window != "undefined" && (this.privSetTimeout = window.setTimeout.bind(window)), typeof globalThis != "undefined" && (this.privSetTimeout = globalThis.setTimeout.bind(globalThis))), this.connectionEvents.attach((A) => {
        if (A.name === "ConnectionClosedEvent") {
          const g = A;
          (g.statusCode === 1003 || g.statusCode === 1007 || g.statusCode === 1002 || g.statusCode === 4e3 || this.privRequestSession.numConnectionAttempts > this.privRecognizerConfig.maxRetryCount) && this.cancelRecognitionLocal(i.CancellationReason.Error, g.statusCode === 1007 ? i.CancellationErrorCode.BadRequestParameters : i.CancellationErrorCode.ConnectionFailure, `${g.reason} websocket error code: ${g.statusCode}`);
        }
      }), this.privEnableSpeakerId && (this.privDiarizationSessionId = a.createNoDashGuid()), this.setLanguageIdJson(), this.setOutputDetailLevelJson();
    }
    setTranslationJson() {
      const o = this.privRecognizerConfig.parameters.getProperty(i.PropertyId.SpeechServiceConnection_TranslationToLanguages, void 0);
      if (o !== void 0) {
        const l = o.split(","), c = this.privRecognizerConfig.parameters.getProperty(i.PropertyId.SpeechServiceConnection_TranslationVoice, void 0), d = c !== void 0 ? "Synthesize" : "None";
        if (this.privSpeechContext.setSection("translation", {
          onSuccess: { action: d },
          output: { interimResults: { mode: "Always" } },
          targetLanguages: l
        }), c !== void 0) {
          const u = {};
          for (const h of l)
            u[h] = c;
          this.privSpeechContext.setSection("synthesis", {
            defaultVoices: u
          });
        }
      }
    }
    setSpeechSegmentationTimeoutJson() {
      const o = this.privRecognizerConfig.parameters.getProperty(i.PropertyId.Speech_SegmentationSilenceTimeoutMs, void 0);
      if (o !== void 0) {
        const l = this.recognitionMode === r.RecognitionMode.Conversation ? "CONVERSATION" : this.recognitionMode === r.RecognitionMode.Dictation ? "DICTATION" : "INTERACTIVE", c = parseInt(o, 10), d = this.privSpeechContext.getSection("phraseDetection");
        d.mode = l, d[l] = {
          segmentation: {
            mode: "Custom",
            segmentationSilenceTimeoutMs: c
          }
        }, this.privSpeechContext.setSection("phraseDetection", d);
      }
    }
    setLanguageIdJson() {
      const o = this.privSpeechContext.getSection("phraseDetection");
      if (this.privRecognizerConfig.autoDetectSourceLanguages !== void 0) {
        const c = this.privRecognizerConfig.autoDetectSourceLanguages.split(",");
        let d;
        this.privRecognizerConfig.languageIdMode === "Continuous" ? d = "DetectContinuous" : d = "DetectAtAudioStart", this.privSpeechContext.setSection("languageId", {
          Priority: "PrioritizeLatency",
          languages: c,
          mode: d,
          onSuccess: { action: "Recognize" },
          onUnknown: { action: "None" }
        }), this.privSpeechContext.setSection("phraseOutput", {
          interimResults: {
            resultType: "Auto"
          },
          phraseResults: {
            resultType: "Always"
          }
        });
        const u = this.privRecognizerConfig.sourceLanguageModels;
        u !== void 0 && (o.customModels = u, o.onInterim = { action: "None" }, o.onSuccess = { action: "None" });
      }
      this.privRecognizerConfig.parameters.getProperty(i.PropertyId.SpeechServiceConnection_TranslationToLanguages, void 0) !== void 0 && (o.onInterim = { action: "Translate" }, o.onSuccess = { action: "Translate" }, this.privSpeechContext.setSection("phraseOutput", {
        interimResults: {
          resultType: "None"
        },
        phraseResults: {
          resultType: "None"
        }
      })), this.privSpeechContext.setSection("phraseDetection", o);
    }
    setOutputDetailLevelJson() {
      this.privEnableSpeakerId && (this.privRecognizerConfig.parameters.getProperty(i.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true" ? this.privSpeechContext.setWordLevelTimings() : this.privRecognizerConfig.parameters.getProperty(r.OutputFormatPropertyName, i.OutputFormat[i.OutputFormat.Simple]).toLowerCase() === i.OutputFormat[i.OutputFormat.Detailed].toLocaleLowerCase() && this.privSpeechContext.setDetailedOutputFormat());
    }
    get isSpeakerDiarizationEnabled() {
      return this.privEnableSpeakerId;
    }
    get audioSource() {
      return this.privAudioSource;
    }
    get speechContext() {
      return this.privSpeechContext;
    }
    get dynamicGrammar() {
      return this.privDynamicGrammar;
    }
    get agentConfig() {
      return this.privAgentConfig;
    }
    set conversationTranslatorToken(o) {
      this.privRecognizerConfig.parameters.setProperty(i.PropertyId.ConversationTranslator_Token, o);
    }
    set voiceProfileType(o) {
      this.privRecognizerConfig.parameters.setProperty(i.PropertyId.SpeechServiceConnection_SpeakerIdMode, o);
    }
    set authentication(o) {
      this.privAuthentication = o;
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    async dispose(o) {
      if (this.privIsDisposed = !0, this.privConnectionConfigurationPromise !== void 0)
        try {
          await (await this.privConnectionConfigurationPromise).dispose(o);
        } catch {
          return;
        }
    }
    get connectionEvents() {
      return this.privConnectionEvents;
    }
    get serviceEvents() {
      return this.privServiceEvents;
    }
    get recognitionMode() {
      return this.privRecognizerConfig.recognitionMode;
    }
    async recognize(o, l, c) {
      if (this.recognizeOverride !== void 0) {
        await this.recognizeOverride(o, l, c);
        return;
      }
      this.privConnectionConfigurationPromise = void 0, this.privRecognizerConfig.recognitionMode = o, this.setSpeechSegmentationTimeoutJson(), this.setTranslationJson(), this.privSuccessCallback = l, this.privErrorCallback = c, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privAudioSource.events);
      const d = this.connectImpl();
      let u;
      try {
        const g = await this.audioSource.attach(this.privRequestSession.audioNodeId), f = await this.audioSource.format, p = await this.audioSource.deviceInfo;
        this.privIsLiveAudio = p.type && p.type === r.type.Microphones, u = new s.ReplayableAudioNode(g, f.avgBytesPerSec), await this.privRequestSession.onAudioSourceAttachCompleted(u, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: p };
      } catch (g) {
        throw await this.privRequestSession.onStopRecognizing(), g;
      }
      try {
        await d;
      } catch (g) {
        await this.cancelRecognitionLocal(i.CancellationReason.Error, i.CancellationErrorCode.ConnectionFailure, g);
        return;
      }
      const h = new i.SessionEventArgs(this.privRequestSession.sessionId);
      this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, h), this.receiveMessage(), this.sendAudio(u).catch(async (g) => {
        await this.cancelRecognitionLocal(i.CancellationReason.Error, i.CancellationErrorCode.RuntimeError, g);
      });
    }
    async stopRecognizing() {
      if (this.privRequestSession.isRecognizing)
        try {
          await this.audioSource.turnOff(), await this.sendFinalAudio(), await this.privRequestSession.onStopRecognizing(), await this.privRequestSession.turnCompletionPromise;
        } finally {
          await this.privRequestSession.dispose();
        }
    }
    async connect() {
      return await this.connectImpl(), Promise.resolve();
    }
    connectAsync(o, l) {
      this.connectImpl().then(() => {
        try {
          o && o();
        } catch (c) {
          l && l(c);
        }
      }, (c) => {
        try {
          l && l(c);
        } catch {
        }
      });
    }
    async disconnect() {
      if (await this.cancelRecognitionLocal(i.CancellationReason.Error, i.CancellationErrorCode.NoError, "Disconnecting"), this.disconnectOverride !== void 0 && await this.disconnectOverride(), this.privConnectionPromise !== void 0)
        try {
          await (await this.privConnectionPromise).dispose();
        } catch {
        }
      this.privConnectionPromise = void 0;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sendMessage(o) {
    }
    async sendNetworkMessage(o, l) {
      const c = typeof l == "string" ? a.MessageType.Text : a.MessageType.Binary, d = typeof l == "string" ? "application/json" : "";
      return (await this.fetchConnection()).send(new e.SpeechConnectionMessage(c, o, this.privRequestSession.requestId, d, l));
    }
    set activityTemplate(o) {
      this.privActivityTemplate = o;
    }
    get activityTemplate() {
      return this.privActivityTemplate;
    }
    set expectContentAssessmentResponse(o) {
      this.privExpectContentAssessmentResponse = o;
    }
    async sendTelemetryData() {
      const o = this.privRequestSession.getTelemetry();
      if (Bp.telemetryDataEnabled !== !0 || this.privIsDisposed || o === null)
        return;
      if (Bp.telemetryData)
        try {
          Bp.telemetryData(o);
        } catch {
        }
      await (await this.fetchConnection()).send(new e.SpeechConnectionMessage(a.MessageType.Text, "telemetry", this.privRequestSession.requestId, "application/json", o));
    }
    // Cancels recognition.
    async cancelRecognitionLocal(o, l, c) {
      this.privRequestSession.isRecognizing && (await this.privRequestSession.onStopRecognizing(), this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, o, l, c));
    }
    async receiveMessage() {
      try {
        if (this.privIsDisposed)
          return;
        let o = await this.fetchConnection();
        const l = await o.read();
        if (this.receiveMessageOverride !== void 0)
          return this.receiveMessageOverride();
        if (!l)
          return this.receiveMessage();
        this.privServiceHasSentMessage = !0;
        const c = e.SpeechConnectionMessage.fromConnectionMessage(l);
        if (c.requestId.toLowerCase() === this.privRequestSession.requestId.toLowerCase())
          switch (c.path.toLowerCase()) {
            case "turn.start":
              this.privMustReportEndOfStream = !0, this.privRequestSession.onServiceTurnStartResponse();
              break;
            case "speech.startdetected":
              const d = r.SpeechDetected.fromJSON(c.textBody), u = new i.RecognitionEventArgs(d.Offset, this.privRequestSession.sessionId);
              this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, u);
              break;
            case "speech.enddetected":
              let h;
              c.textBody.length > 0 ? h = c.textBody : h = "{ Offset: 0 }";
              const A = r.SpeechDetected.fromJSON(h), g = new i.RecognitionEventArgs(A.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
              this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, g);
              break;
            case "turn.end":
              await this.sendTelemetryData(), this.privRequestSession.isSpeechEnded && this.privMustReportEndOfStream && (this.privMustReportEndOfStream = !1, await this.cancelRecognitionLocal(i.CancellationReason.EndOfStream, i.CancellationErrorCode.NoError, void 0));
              const f = new i.SessionEventArgs(this.privRequestSession.sessionId);
              if (await this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition), !this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) {
                this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, f);
                return;
              } else
                o = await this.fetchConnection(), await this.sendPrePayloadJSON(o);
              break;
            default:
              await this.processTypeSpecificMessages(c) || this.privServiceEvents && this.serviceEvents.onEvent(new a.ServiceEvent(c.path.toLowerCase(), c.textBody));
          }
        return this.receiveMessage();
      } catch {
        return null;
      }
    }
    updateSpeakerDiarizationAudioOffset() {
      const l = this.privRequestSession.recognitionBytesSent / this.privAverageBytesPerMs;
      this.privSpeechContext.setSpeakerDiarizationAudioOffsetMs(l);
    }
    sendSpeechContext(o, l) {
      this.privEnableSpeakerId && this.updateSpeakerDiarizationAudioOffset();
      const c = this.speechContext.toJSON();
      if (l && this.privRequestSession.onSpeechContext(), c)
        return o.send(new e.SpeechConnectionMessage(a.MessageType.Text, "speech.context", this.privRequestSession.requestId, "application/json", c));
    }
    noOp() {
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendPrePayloadJSON(o, l = !0) {
      if (this.sendPrePayloadJSONOverride !== void 0)
        return this.sendPrePayloadJSONOverride(o);
      await this.sendSpeechContext(o, l), await this.sendWaveHeader(o);
    }
    async sendWaveHeader(o) {
      const l = await this.audioSource.format;
      return o.send(new e.SpeechConnectionMessage(a.MessageType.Binary, "audio", this.privRequestSession.requestId, "audio/x-wav", l.header));
    }
    // Establishes a websocket connection to the end point.
    connectImpl() {
      return this.privConnectionPromise !== void 0 ? this.privConnectionPromise.then((o) => o.state() === a.ConnectionState.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = void 0, this.privServiceHasSentMessage = !1, this.connectImpl()) : this.privConnectionPromise, () => (this.privConnectionId = null, this.privConnectionPromise = void 0, this.privServiceHasSentMessage = !1, this.connectImpl())) : (this.privConnectionPromise = this.retryableConnect(), this.privConnectionPromise.catch(() => {
      }), this.postConnectImplOverride !== void 0 ? this.postConnectImplOverride(this.privConnectionPromise) : this.privConnectionPromise);
    }
    sendSpeechServiceConfig(o, l, c) {
      if (l.onSpeechContext(), Bp.telemetryDataEnabled !== !0) {
        const u = {
          context: {
            system: JSON.parse(c).context.system
          }
        };
        c = JSON.stringify(u);
      }
      if (this.privRecognizerConfig.parameters.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() === "true") {
        const d = JSON.parse(c);
        d.context.DisableReferenceChannel = "True", d.context.MicSpec = "1_0_0", c = JSON.stringify(d);
      }
      if (c)
        return o.send(new e.SpeechConnectionMessage(a.MessageType.Text, "speech.config", l.requestId, "application/json", c));
    }
    async fetchConnection() {
      return this.privConnectionConfigurationPromise !== void 0 ? this.privConnectionConfigurationPromise.then((o) => o.state() === a.ConnectionState.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.privServiceHasSentMessage = !1, this.fetchConnection()) : this.privConnectionConfigurationPromise, () => (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.privServiceHasSentMessage = !1, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), await this.privConnectionConfigurationPromise);
    }
    async sendAudio(o) {
      const l = await this.audioSource.format;
      this.privAverageBytesPerMs = l.avgBytesPerSec / 1e3;
      let c = Date.now();
      const d = this.privRecognizerConfig.parameters.getProperty("SPEECH-TransmitLengthBeforThrottleMs", "5000"), u = l.avgBytesPerSec / 1e3 * parseInt(d, 10), h = this.privRequestSession.recogNumber, A = async () => {
        if (!this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === h) {
          const g = await this.fetchConnection(), f = await o.read();
          if (this.privRequestSession.isSpeechEnded)
            return;
          let p, v;
          if (!f || f.isEnd ? (p = null, v = 0) : (p = f.buffer, this.privRequestSession.onAudioSent(p.byteLength), u >= this.privRequestSession.bytesSent ? v = 0 : v = Math.max(0, c - Date.now())), v !== 0 && await this.delay(v), p !== null && (c = Date.now() + p.byteLength * 1e3 / (l.avgBytesPerSec * 2)), !this.privIsDisposed && !this.privRequestSession.isSpeechEnded && this.privRequestSession.isRecognizing && this.privRequestSession.recogNumber === h)
            if (g.send(new e.SpeechConnectionMessage(a.MessageType.Binary, "audio", this.privRequestSession.requestId, null, p)).catch(() => {
              this.privRequestSession.onServiceTurnEndResponse(this.privRecognizerConfig.isContinuousRecognition).catch(() => {
              });
            }), f != null && f.isEnd)
              this.privIsLiveAudio || this.privRequestSession.onSpeechEnded();
            else
              return A();
        }
      };
      return A();
    }
    async retryableConnect() {
      let o = !1;
      this.privAuthFetchEventId = a.createNoDashGuid();
      const l = this.privRequestSession.sessionId;
      this.privConnectionId = l !== void 0 ? l : a.createNoDashGuid(), this.privRequestSession.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
      let c = 0, d = "";
      for (; this.privRequestSession.numConnectionAttempts <= this.privRecognizerConfig.maxRetryCount; ) {
        const h = await (o ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId));
        await this.privRequestSession.onAuthCompleted(!1);
        const A = this.privConnectionFactory.create(this.privRecognizerConfig, h, this.privConnectionId);
        this.privRequestSession.listenForServiceTelemetry(A.events), A.events.attach((f) => {
          this.connectionEvents.onEvent(f);
        });
        const g = await A.open();
        if (g.statusCode === 200)
          return await this.privRequestSession.onConnectionEstablishCompleted(g.statusCode), Promise.resolve(A);
        g.statusCode === 1006 && (o = !0), c = g.statusCode, d = g.reason, this.privRequestSession.onRetryConnection();
      }
      return await this.privRequestSession.onConnectionEstablishCompleted(c, d), Promise.reject(`Unable to contact server. StatusCode: ${c}, ${this.privRecognizerConfig.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Endpoint)} Reason: ${d}`);
    }
    delay(o) {
      return new Promise((l) => this.privSetTimeout(l, o));
    }
    writeBufferToConsole(o) {
      let l = "Buffer Size: ";
      if (o === null)
        l += "null";
      else {
        const c = new Uint8Array(o);
        l += `${o.byteLength}\r
`;
        for (let d = 0; d < o.byteLength; d++)
          l += c[d].toString(16).padStart(2, "0") + " ", (d + 1) % 16 === 0 && (console.info(l), l = "");
      }
      console.info(l);
    }
    async sendFinalAudio() {
      await (await this.fetchConnection()).send(new e.SpeechConnectionMessage(a.MessageType.Binary, "audio", this.privRequestSession.requestId, null, null));
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
      const o = await this.connectImpl();
      return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(o) : (await this.sendSpeechServiceConfig(o, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), await this.sendPrePayloadJSON(o, !1), o);
    }
  };
  return zf.ServiceRecognizerBase = n, n.telemetryDataEnabled = !0, zf;
}
var jf = {}, nC;
function vP() {
  if (nC) return jf;
  nC = 1, Object.defineProperty(jf, "__esModule", { value: !0 }), jf.ConversationServiceRecognizer = void 0;
  const s = Hr(), a = wi();
  let i = class extends a.ServiceRecognizerBase {
    constructor(e, n, t, o, l) {
      super(e, n, t, o, l), this.handleSpeechPhraseMessage = async (c) => this.handleSpeechPhrase(c), this.handleSpeechHypothesisMessage = (c) => this.handleSpeechHypothesis(c);
    }
    processTypeSpecificMessages(e) {
    }
    handleRecognizedCallback(e, n, t) {
    }
    handleRecognizingCallback(e, n, t) {
    }
    async processSpeechMessages(e) {
      let n = !1;
      switch (e.path.toLowerCase()) {
        case "speech.hypothesis":
        case "speech.fragment":
          this.handleSpeechHypothesisMessage && this.handleSpeechHypothesisMessage(e.textBody), n = !0;
          break;
        case "speech.phrase":
          this.handleSpeechPhraseMessage && await this.handleSpeechPhraseMessage(e.textBody), n = !0;
          break;
      }
      return n;
    }
    cancelRecognition(e, n, t, o, l) {
    }
    async handleSpeechPhrase(e) {
      const n = a.SimpleSpeechPhrase.fromJSON(e), t = a.EnumTranslation.implTranslateRecognitionResult(n.RecognitionStatus);
      let o;
      const l = new s.PropertyCollection();
      l.setProperty(s.PropertyId.SpeechServiceResponse_JsonResult, e);
      const c = n.Offset + this.privRequestSession.currentTurnAudioOffset;
      let d = c;
      if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + n.Offset + n.Duration), s.ResultReason.Canceled === t) {
        const u = a.EnumTranslation.implTranslateCancelResult(n.RecognitionStatus), h = a.EnumTranslation.implTranslateCancelErrorCode(n.RecognitionStatus);
        await this.cancelRecognitionLocal(u, h, a.EnumTranslation.implTranslateErrorDetails(h));
      } else if (!(this.privRequestSession.isSpeechEnded && t === s.ResultReason.NoMatch && n.RecognitionStatus !== a.RecognitionStatus.InitialSilenceTimeout)) {
        if (this.privRecognizerConfig.parameters.getProperty(a.OutputFormatPropertyName) === s.OutputFormat[s.OutputFormat.Simple])
          o = new s.SpeechRecognitionResult(this.privRequestSession.requestId, t, n.DisplayText, n.Duration, c, n.Language, n.LanguageDetectionConfidence, n.SpeakerId, void 0, e, l);
        else {
          const u = a.DetailedSpeechPhrase.fromJSON(e), h = u.Offset + this.privRequestSession.currentTurnAudioOffset, A = u.getJsonWithCorrectedOffsets(h);
          o = new s.SpeechRecognitionResult(this.privRequestSession.requestId, t, u.Text, u.Duration, h, u.Language, u.LanguageDetectionConfidence, u.SpeakerId, void 0, A, l), d = o.offset;
        }
        this.handleRecognizedCallback(o, d, this.privRequestSession.sessionId);
      }
    }
    handleSpeechHypothesis(e) {
      const n = a.SpeechHypothesis.fromJSON(e), t = n.Offset + this.privRequestSession.currentTurnAudioOffset, o = new s.PropertyCollection();
      o.setProperty(s.PropertyId.SpeechServiceResponse_JsonResult, e);
      const l = new s.SpeechRecognitionResult(this.privRequestSession.requestId, s.ResultReason.RecognizingSpeech, n.Text, n.Duration, t, n.Language, n.LanguageDetectionConfidence, n.SpeakerId, void 0, e, o);
      this.privRequestSession.onHypothesis(t), this.handleRecognizingCallback(l, n.Duration, this.privRequestSession.sessionId);
    }
  };
  return jf.ConversationServiceRecognizer = i, jf;
}
var jv = {}, rC;
function bP() {
  return rC || (rC = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.RecognizerConfig = s.SpeechResultFormat = s.RecognitionMode = void 0;
    const a = Hr(), i = wi();
    var r;
    (function(n) {
      n[n.Interactive = 0] = "Interactive", n[n.Conversation = 1] = "Conversation", n[n.Dictation = 2] = "Dictation";
    })(r = s.RecognitionMode || (s.RecognitionMode = {})), function(n) {
      n[n.Simple = 0] = "Simple", n[n.Detailed = 1] = "Detailed";
    }(s.SpeechResultFormat || (s.SpeechResultFormat = {}));
    class e {
      constructor(t, o) {
        this.privSpeechServiceConfig = t || new i.SpeechServiceConfig(new i.Context(null)), this.privParameters = o, this.privMaxRetryCount = parseInt(o.getProperty("SPEECH-Error-MaxRetryCount", "4"), 10), this.privLanguageIdMode = o.getProperty(a.PropertyId.SpeechServiceConnection_LanguageIdMode, void 0), this.privEnableSpeakerId = !1;
      }
      get parameters() {
        return this.privParameters;
      }
      get recognitionMode() {
        return this.privRecognitionMode;
      }
      set recognitionMode(t) {
        this.privRecognitionMode = t, this.privRecognitionActivityTimeout = t === r.Interactive ? 8e3 : 25e3, this.privSpeechServiceConfig.Recognition = r[t];
      }
      get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
      }
      get recognitionActivityTimeout() {
        return this.privRecognitionActivityTimeout;
      }
      get isContinuousRecognition() {
        return this.privRecognitionMode !== r.Interactive;
      }
      get languageIdMode() {
        return this.privLanguageIdMode;
      }
      get autoDetectSourceLanguages() {
        return this.parameters.getProperty(a.PropertyId.SpeechServiceConnection_AutoDetectSourceLanguages, void 0);
      }
      get recognitionEndpointVersion() {
        return this.parameters.getProperty(a.PropertyId.SpeechServiceConnection_RecognitionEndpointVersion, void 0);
      }
      get sourceLanguageModels() {
        const t = [];
        let o = !1;
        if (this.autoDetectSourceLanguages !== void 0)
          for (const l of this.autoDetectSourceLanguages.split(",")) {
            const c = l + a.PropertyId.SpeechServiceConnection_EndpointId.toString(), d = this.parameters.getProperty(c, void 0);
            d !== void 0 ? (t.push({ language: l, endpoint: d }), o = !0) : t.push({ language: l, endpoint: "" });
          }
        return o ? t : void 0;
      }
      get maxRetryCount() {
        return this.privMaxRetryCount;
      }
      get isSpeakerDiarizationEnabled() {
        return this.privEnableSpeakerId;
      }
      set isSpeakerDiarizationEnabled(t) {
        this.privEnableSpeakerId = t;
      }
    }
    s.RecognizerConfig = e;
  }(jv)), jv;
}
var MZ = {};
Object.defineProperty(MZ, "__esModule", { value: !0 });
var m2 = {};
Object.defineProperty(m2, "__esModule", { value: !0 });
m2.WebsocketMessageFormatter = void 0;
const uu = Eo(), iC = `\r
`;
class FP {
  toConnectionMessage(a) {
    const i = new uu.Deferred();
    try {
      if (a.messageType === uu.MessageType.Text) {
        const r = a.textContent;
        let e = {}, n = null;
        if (r) {
          const t = r.split(`\r
\r
`);
          t && t.length > 0 && (e = this.parseHeaders(t[0]), t.length > 1 && (n = t[1]));
        }
        i.resolve(new uu.ConnectionMessage(a.messageType, n, e, a.id));
      } else if (a.messageType === uu.MessageType.Binary) {
        const r = a.binaryContent;
        let e = {}, n = null;
        if (!r || r.byteLength < 2)
          throw new Error("Invalid binary message format. Header length missing.");
        const t = new DataView(r), o = t.getInt16(0);
        if (r.byteLength < o + 2)
          throw new Error("Invalid binary message format. Header content missing.");
        let l = "";
        for (let c = 0; c < o; c++)
          l += String.fromCharCode(t.getInt8(c + 2));
        e = this.parseHeaders(l), r.byteLength > o + 2 && (n = r.slice(2 + o)), i.resolve(new uu.ConnectionMessage(a.messageType, n, e, a.id));
      }
    } catch (r) {
      i.reject(`Error formatting the message. Error: ${r}`);
    }
    return i.promise;
  }
  fromConnectionMessage(a) {
    const i = new uu.Deferred();
    try {
      if (a.messageType === uu.MessageType.Text) {
        const r = `${this.makeHeaders(a)}${iC}${a.textBody ? a.textBody : ""}`;
        i.resolve(new uu.RawWebsocketMessage(uu.MessageType.Text, r, a.id));
      } else if (a.messageType === uu.MessageType.Binary) {
        const r = this.makeHeaders(a), e = a.binaryBody, n = this.stringToArrayBuffer(r), t = new Int8Array(n), o = t.byteLength, l = new Int8Array(2 + o + (e ? e.byteLength : 0));
        if (l[0] = o >> 8 & 255, l[1] = o & 255, l.set(t, 2), e) {
          const d = new Int8Array(e);
          l.set(d, 2 + o);
        }
        const c = l.buffer;
        i.resolve(new uu.RawWebsocketMessage(uu.MessageType.Binary, c, a.id));
      }
    } catch (r) {
      i.reject(`Error formatting the message. ${r}`);
    }
    return i.promise;
  }
  makeHeaders(a) {
    let i = "";
    if (a.headers)
      for (const r in a.headers)
        r && (i += `${r}: ${a.headers[r]}${iC}`);
    return i;
  }
  parseHeaders(a) {
    const i = {};
    if (a) {
      const r = a.match(/[^\r\n]+/g);
      if (i) {
        for (const e of r)
          if (e) {
            const n = e.indexOf(":"), t = n > 0 ? e.substr(0, n).trim().toLowerCase() : e, o = n > 0 && e.length > n + 1 ? e.substr(n + 1).trim() : "";
            i[t] = o;
          }
      }
    }
    return i;
  }
  stringToArrayBuffer(a) {
    const i = new ArrayBuffer(a.length), r = new DataView(i);
    for (let e = 0; e < a.length; e++)
      r.setUint8(e, a.charCodeAt(e));
    return i;
  }
}
m2.WebsocketMessageFormatter = FP;
var _f = {}, oC;
function RP() {
  if (oC) return _f;
  oC = 1, Object.defineProperty(_f, "__esModule", { value: !0 }), _f.SpeechConnectionFactory = void 0;
  const s = Xc(), a = wi(), i = Hr(), r = Bu(), e = wi(), n = Tc, t = Iu;
  let o = class extends r.ConnectionFactoryBase {
    constructor() {
      super(...arguments), this.interactiveRelativeUri = "/speech/recognition/interactive/cognitiveservices/v1", this.conversationRelativeUri = "/speech/recognition/conversation/cognitiveservices/v1", this.dictationRelativeUri = "/speech/recognition/dictation/cognitiveservices/v1", this.universalUri = "/speech/universal/v";
    }
    create(c, d, u) {
      let h = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Endpoint, void 0);
      const A = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Region, void 0), g = r.ConnectionFactoryBase.getHostSuffix(A), f = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Host, "wss://" + A + ".stt.speech" + g), p = {}, v = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_EndpointId, void 0), b = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage, void 0);
      if (v ? (!h || h.search(t.QueryParameterNames.CustomSpeechDeploymentId) === -1) && (p[t.QueryParameterNames.CustomSpeechDeploymentId] = v) : b && (!h || h.search(t.QueryParameterNames.Language) === -1) && (p[t.QueryParameterNames.Language] = b), (!h || h.search(t.QueryParameterNames.Format) === -1) && (p[t.QueryParameterNames.Format] = c.parameters.getProperty(a.OutputFormatPropertyName, i.OutputFormat[i.OutputFormat.Simple]).toLowerCase()), c.autoDetectSourceLanguages !== void 0 && (p[t.QueryParameterNames.EnableLanguageId] = "true"), this.setCommonUrlParams(c, p, h), !h)
        switch (c.recognitionMode) {
          case e.RecognitionMode.Conversation:
            c.parameters.getProperty(a.ForceDictationPropertyName, "false") === "true" ? h = f + this.dictationRelativeUri : c.recognitionEndpointVersion !== void 0 && parseInt(c.recognitionEndpointVersion, 10) > 1 ? h = `${f}${this.universalUri}${c.recognitionEndpointVersion}` : h = f + this.conversationRelativeUri;
            break;
          case e.RecognitionMode.Dictation:
            h = f + this.dictationRelativeUri;
            break;
          default:
            c.recognitionEndpointVersion !== void 0 && parseInt(c.recognitionEndpointVersion, 10) > 1 ? h = `${f}${this.universalUri}${c.recognitionEndpointVersion}` : h = f + this.interactiveRelativeUri;
            break;
        }
      const m = {};
      d.token !== void 0 && d.token !== "" && (m[d.headerName] = d.token), m[n.HeaderNames.ConnectionId] = u;
      const y = c.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true", U = new s.WebsocketConnection(h, p, m, new e.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(c), y, u), B = U.uri;
      return c.parameters.setProperty(i.PropertyId.SpeechServiceConnection_Url, B), U;
    }
  };
  return _f.SpeechConnectionFactory = o, _f;
}
var $f = {}, aC;
function yP() {
  if (aC) return $f;
  aC = 1, Object.defineProperty($f, "__esModule", { value: !0 }), $f.ConversationTranscriberConnectionFactory = void 0;
  const s = Xc(), a = Hr(), i = wi(), r = Bu(), e = wi(), n = Tc, t = Iu;
  let o = class extends r.ConnectionFactoryBase {
    constructor() {
      super(...arguments), this.universalUri = "/speech/universal/v2";
    }
    create(c, d, u) {
      let h = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Endpoint, void 0);
      const A = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Region, void 0), g = r.ConnectionFactoryBase.getHostSuffix(A), f = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Host, "wss://" + A + ".stt.speech" + g), p = {}, v = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_EndpointId, void 0), b = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage, void 0);
      v ? (!h || h.search(t.QueryParameterNames.CustomSpeechDeploymentId) === -1) && (p[t.QueryParameterNames.CustomSpeechDeploymentId] = v) : b && (!h || h.search(t.QueryParameterNames.Language) === -1) && (p[t.QueryParameterNames.Language] = b), c.autoDetectSourceLanguages !== void 0 && (p[t.QueryParameterNames.EnableLanguageId] = "true"), this.setV2UrlParams(c, p, h), h || (h = `${f}${this.universalUri}`);
      const m = {};
      d.token !== void 0 && d.token !== "" && (m[d.headerName] = d.token), m[n.HeaderNames.ConnectionId] = u;
      const y = c.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true", U = new s.WebsocketConnection(h, p, m, new e.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(c), y, u), B = U.uri;
      return c.parameters.setProperty(a.PropertyId.SpeechServiceConnection_Url, B), U;
    }
    setV2UrlParams(c, d, u) {
      (/* @__PURE__ */ new Map([
        [a.PropertyId.Speech_SegmentationSilenceTimeoutMs, t.QueryParameterNames.SegmentationSilenceTimeoutMs],
        [a.PropertyId.SpeechServiceConnection_EnableAudioLogging, t.QueryParameterNames.EnableAudioLogging],
        [a.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, t.QueryParameterNames.EndSilenceTimeoutMs],
        [a.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, t.QueryParameterNames.InitialSilenceTimeoutMs],
        [a.PropertyId.SpeechServiceResponse_PostProcessingOption, t.QueryParameterNames.Postprocessing],
        [a.PropertyId.SpeechServiceResponse_ProfanityOption, t.QueryParameterNames.Profanity],
        [a.PropertyId.SpeechServiceResponse_StablePartialResultThreshold, t.QueryParameterNames.StableIntermediateThreshold]
      ])).forEach((g, f) => {
        this.setUrlParameter(f, g, c, d, u);
      });
      const A = JSON.parse(c.parameters.getProperty(i.ServicePropertiesPropertyName, "{}"));
      Object.keys(A).forEach((g) => {
        d[g] = A[g];
      });
    }
  };
  return $f.ConversationTranscriberConnectionFactory = o, $f;
}
var qf = {}, sC;
function QP() {
  if (sC) return qf;
  sC = 1, Object.defineProperty(qf, "__esModule", { value: !0 }), qf.TranscriberConnectionFactory = void 0;
  const s = Xc(), a = Hr(), i = Bu(), r = wi(), e = Tc, n = Iu;
  let t = class extends i.ConnectionFactoryBase {
    constructor() {
      super(...arguments), this.multiaudioRelativeUri = "/speech/recognition/multiaudio";
    }
    create(l, c, d) {
      let u = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Endpoint, void 0);
      const h = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Region, "centralus"), A = i.ConnectionFactoryBase.getHostSuffix(h), g = "wss://transcribe." + h + ".cts.speech" + A + this.multiaudioRelativeUri, f = l.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Host, g), p = {};
      this.setQueryParams(p, l, u), u || (u = f);
      const v = {};
      c.token !== void 0 && c.token !== "" && (v[c.headerName] = c.token), v[e.HeaderNames.ConnectionId] = d, l.parameters.setProperty(a.PropertyId.SpeechServiceConnection_Url, u);
      const b = l.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(u, p, v, new r.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(l), b, d);
    }
    setQueryParams(l, c, d) {
      const u = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_EndpointId, void 0), h = c.parameters.getProperty(a.PropertyId.SpeechServiceConnection_RecoLanguage, void 0);
      u && !(n.QueryParameterNames.CustomSpeechDeploymentId in l) && (l[n.QueryParameterNames.CustomSpeechDeploymentId] = u), h && !(n.QueryParameterNames.Language in l) && (l[n.QueryParameterNames.Language] = h);
      const A = c.parameters.getProperty(a.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "false").toLowerCase() === "true", g = c.parameters.getProperty(r.OutputFormatPropertyName, a.OutputFormat[a.OutputFormat.Simple]) !== a.OutputFormat[a.OutputFormat.Simple];
      (A || g) && (l[n.QueryParameterNames.Format] = a.OutputFormat[a.OutputFormat.Detailed].toLowerCase()), this.setCommonUrlParams(c, l, d);
    }
  };
  return qf.TranscriberConnectionFactory = t, qf;
}
var ep = {}, lC;
function CP() {
  if (lC) return ep;
  lC = 1, Object.defineProperty(ep, "__esModule", { value: !0 }), ep.TranslationConnectionFactory = void 0;
  const s = Xc(), a = lm, i = Hr(), r = Bu(), e = wi(), n = Tc, t = Iu;
  let o = class extends r.ConnectionFactoryBase {
    create(c, d, u) {
      const h = this.getEndpointUrl(c), A = {};
      c.autoDetectSourceLanguages !== void 0 && (A[t.QueryParameterNames.EnableLanguageId] = "true"), this.setQueryParams(A, c, h);
      const g = {};
      d.token !== void 0 && d.token !== "" && (g[d.headerName] = d.token), g[n.HeaderNames.ConnectionId] = u, c.parameters.setProperty(i.PropertyId.SpeechServiceConnection_Url, h);
      const f = c.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(h, A, g, new e.WebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(c), f, u);
    }
    getEndpointUrl(c, d) {
      const u = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Region), h = r.ConnectionFactoryBase.getHostSuffix(u);
      let A = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Endpoint, void 0);
      return A || (c.autoDetectSourceLanguages !== void 0 ? A = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Host, "wss://{region}.stt.speech" + h) + "/speech/universal/v2" : A = c.parameters.getProperty(i.PropertyId.SpeechServiceConnection_Host, "wss://{region}.s2s.speech" + h) + "/speech/translation/cognitiveservices/v1"), d === !0 ? A : a.StringUtils.formatString(A, { region: u });
    }
    setQueryParams(c, d, u) {
      c.from = d.parameters.getProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage), c.to = d.parameters.getProperty(i.PropertyId.SpeechServiceConnection_TranslationToLanguages), c.scenario = d.recognitionMode === e.RecognitionMode.Interactive ? "interactive" : d.recognitionMode === e.RecognitionMode.Conversation ? "conversation" : "", this.setCommonUrlParams(d, c, u), this.setUrlParameter(i.PropertyId.SpeechServiceResponse_TranslationRequestStablePartialResult, t.QueryParameterNames.StableTranslation, d, c, u);
      const h = d.parameters.getProperty(i.PropertyId.SpeechServiceConnection_TranslationVoice, void 0);
      h !== void 0 && (c.voice = h, c.features = "texttospeech");
    }
  };
  return ep.TranslationConnectionFactory = o, ep;
}
var tp = {}, cC;
function UP() {
  if (cC) return tp;
  cC = 1, Object.defineProperty(tp, "__esModule", { value: !0 }), tp.EnumTranslation = void 0;
  const s = Hr(), a = wi();
  let i = class {
    static implTranslateRecognitionResult(e, n = !1) {
      let t = s.ResultReason.Canceled;
      switch (e) {
        case a.RecognitionStatus.Success:
          t = s.ResultReason.RecognizedSpeech;
          break;
        case a.RecognitionStatus.EndOfDictation:
          t = n ? s.ResultReason.RecognizedSpeech : s.ResultReason.NoMatch;
          break;
        case a.RecognitionStatus.NoMatch:
        case a.RecognitionStatus.InitialSilenceTimeout:
        case a.RecognitionStatus.BabbleTimeout:
          t = s.ResultReason.NoMatch;
          break;
        case a.RecognitionStatus.Error:
        case a.RecognitionStatus.BadRequest:
        case a.RecognitionStatus.Forbidden:
        default:
          t = s.ResultReason.Canceled;
          break;
      }
      return t;
    }
    static implTranslateCancelResult(e) {
      let n = s.CancellationReason.EndOfStream;
      switch (e) {
        case a.RecognitionStatus.Success:
        case a.RecognitionStatus.EndOfDictation:
        case a.RecognitionStatus.NoMatch:
          n = s.CancellationReason.EndOfStream;
          break;
        case a.RecognitionStatus.InitialSilenceTimeout:
        case a.RecognitionStatus.BabbleTimeout:
        case a.RecognitionStatus.Error:
        case a.RecognitionStatus.BadRequest:
        case a.RecognitionStatus.Forbidden:
        default:
          n = s.CancellationReason.Error;
          break;
      }
      return n;
    }
    static implTranslateCancelErrorCode(e) {
      let n = s.CancellationErrorCode.NoError;
      switch (e) {
        case a.RecognitionStatus.Error:
          n = s.CancellationErrorCode.ServiceError;
          break;
        case a.RecognitionStatus.TooManyRequests:
          n = s.CancellationErrorCode.TooManyRequests;
          break;
        case a.RecognitionStatus.BadRequest:
          n = s.CancellationErrorCode.BadRequestParameters;
          break;
        case a.RecognitionStatus.Forbidden:
          n = s.CancellationErrorCode.Forbidden;
          break;
        default:
          n = s.CancellationErrorCode.NoError;
          break;
      }
      return n;
    }
    static implTranslateErrorDetails(e) {
      let n = "The speech service encountered an internal error and could not continue.";
      switch (e) {
        case s.CancellationErrorCode.Forbidden:
          n = "The recognizer is using a free subscription that ran out of quota.";
          break;
        case s.CancellationErrorCode.BadRequestParameters:
          n = "Invalid parameter or unsupported audio format in the request.";
          break;
        case s.CancellationErrorCode.TooManyRequests:
          n = "The number of parallel requests exceeded the number of allowed concurrent transcriptions.";
          break;
      }
      return n;
    }
  };
  return tp.EnumTranslation = i, tp;
}
var YZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.RecognitionStatus = s.SynthesisStatus = void 0, function(a) {
    a[a.Success = 0] = "Success", a[a.SynthesisEnd = 1] = "SynthesisEnd", a[a.Error = 2] = "Error";
  }(s.SynthesisStatus || (s.SynthesisStatus = {})), function(a) {
    a[a.Success = 0] = "Success", a[a.NoMatch = 1] = "NoMatch", a[a.InitialSilenceTimeout = 2] = "InitialSilenceTimeout", a[a.BabbleTimeout = 3] = "BabbleTimeout", a[a.Error = 4] = "Error", a[a.EndOfDictation = 5] = "EndOfDictation", a[a.TooManyRequests = 6] = "TooManyRequests", a[a.BadRequest = 7] = "BadRequest", a[a.Forbidden = 8] = "Forbidden";
  }(s.RecognitionStatus || (s.RecognitionStatus = {}));
})(YZ);
var np = {}, dC;
function IP() {
  if (dC) return np;
  dC = 1, Object.defineProperty(np, "__esModule", { value: !0 }), np.TranslationSynthesisEnd = void 0;
  const s = wi();
  let a = class LZ {
    constructor(r) {
      this.privSynthesisEnd = JSON.parse(r), this.privSynthesisEnd.SynthesisStatus && (this.privSynthesisEnd.SynthesisStatus = s.SynthesisStatus[this.privSynthesisEnd.SynthesisStatus]), this.privSynthesisEnd.Status && (this.privSynthesisEnd.SynthesisStatus = s.SynthesisStatus[this.privSynthesisEnd.Status]);
    }
    static fromJSON(r) {
      return new LZ(r);
    }
    get SynthesisStatus() {
      return this.privSynthesisEnd.SynthesisStatus;
    }
    get FailureReason() {
      return this.privSynthesisEnd.FailureReason;
    }
  };
  return np.TranslationSynthesisEnd = a, np;
}
var v2 = {};
Object.defineProperty(v2, "__esModule", { value: !0 });
v2.TranslationHypothesis = void 0;
const BP = _o, ZP = D1;
class o1 {
  constructor(a) {
    this.privTranslationHypothesis = a, this.privTranslationHypothesis.Translation.TranslationStatus = ZP.TranslationStatus[this.privTranslationHypothesis.Translation.TranslationStatus];
  }
  static fromJSON(a) {
    return new o1(JSON.parse(a));
  }
  static fromTranslationResponse(a) {
    BP.Contracts.throwIfNullOrUndefined(a, "translationHypothesis");
    const i = a.SpeechHypothesis;
    return a.SpeechHypothesis = void 0, i.Translation = a, new o1(i);
  }
  get Duration() {
    return this.privTranslationHypothesis.Duration;
  }
  get Offset() {
    return this.privTranslationHypothesis.Offset;
  }
  get Text() {
    return this.privTranslationHypothesis.Text;
  }
  get Translation() {
    return this.privTranslationHypothesis.Translation;
  }
  get Language() {
    var a;
    return (a = this.privTranslationHypothesis.PrimaryLanguage) == null ? void 0 : a.Language;
  }
}
v2.TranslationHypothesis = o1;
var rp = {}, uC;
function SP() {
  if (uC) return rp;
  uC = 1, Object.defineProperty(rp, "__esModule", { value: !0 }), rp.TranslationPhrase = void 0;
  const s = _o, a = wi(), i = D1;
  let r = class Tb {
    constructor(n) {
      this.privTranslationPhrase = n, this.privTranslationPhrase.RecognitionStatus = a.RecognitionStatus[this.privTranslationPhrase.RecognitionStatus], this.privTranslationPhrase.Translation !== void 0 && (this.privTranslationPhrase.Translation.TranslationStatus = i.TranslationStatus[this.privTranslationPhrase.Translation.TranslationStatus]);
    }
    static fromJSON(n) {
      return new Tb(JSON.parse(n));
    }
    static fromTranslationResponse(n) {
      s.Contracts.throwIfNullOrUndefined(n, "translationResponse");
      const t = n.SpeechPhrase;
      return n.SpeechPhrase = void 0, t.Translation = n, t.Text = t.DisplayText, new Tb(t);
    }
    get RecognitionStatus() {
      return this.privTranslationPhrase.RecognitionStatus;
    }
    get Offset() {
      return this.privTranslationPhrase.Offset;
    }
    get Duration() {
      return this.privTranslationPhrase.Duration;
    }
    get Text() {
      return this.privTranslationPhrase.Text;
    }
    get Language() {
      var n;
      return (n = this.privTranslationPhrase.PrimaryLanguage) == null ? void 0 : n.Language;
    }
    get Confidence() {
      var n;
      return (n = this.privTranslationPhrase.PrimaryLanguage) == null ? void 0 : n.Confidence;
    }
    get Translation() {
      return this.privTranslationPhrase.Translation;
    }
  };
  return rp.TranslationPhrase = r, rp;
}
var ip = {}, hC;
function EP() {
  if (hC) return ip;
  hC = 1, Object.defineProperty(ip, "__esModule", { value: !0 }), ip.TranslationServiceRecognizer = void 0;
  const s = Eo(), a = Hr(), i = wi();
  let r = class extends i.ConversationServiceRecognizer {
    constructor(n, t, o, l, c) {
      super(n, t, o, l, c), this.privTranslationRecognizer = c, this.connectionEvents.attach((d) => {
        d.name === "ConnectionEstablishedEvent" && this.privTranslationRecognizer.onConnection();
      });
    }
    async processTypeSpecificMessages(n) {
      const t = new a.PropertyCollection();
      let o = await this.processSpeechMessages(n);
      if (o)
        return !0;
      const l = async (d) => {
        if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + d.Offset + d.Duration), d.RecognitionStatus === i.RecognitionStatus.Success) {
          const u = this.fireEventForResult(d, t);
          if (this.privTranslationRecognizer.recognized)
            try {
              this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, u);
            } catch {
            }
          if (this.privSuccessCallback) {
            try {
              this.privSuccessCallback(u.result);
            } catch (h) {
              this.privErrorCallback && this.privErrorCallback(h);
            }
            this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
          }
        } else {
          const u = i.EnumTranslation.implTranslateRecognitionResult(d.RecognitionStatus), h = new a.TranslationRecognitionResult(void 0, this.privRequestSession.requestId, u, d.Text, d.Duration, this.privRequestSession.currentTurnAudioOffset + d.Offset, d.Language, d.Confidence, void 0, n.textBody, t);
          if (u === a.ResultReason.Canceled) {
            const A = i.EnumTranslation.implTranslateCancelResult(d.RecognitionStatus), g = i.EnumTranslation.implTranslateCancelErrorCode(d.RecognitionStatus);
            await this.cancelRecognitionLocal(A, g, i.EnumTranslation.implTranslateErrorDetails(g));
          } else {
            if (!(this.privRequestSession.isSpeechEnded && u === a.ResultReason.NoMatch && d.RecognitionStatus !== i.RecognitionStatus.InitialSilenceTimeout)) {
              const A = new a.TranslationRecognitionEventArgs(h, h.offset, this.privRequestSession.sessionId);
              if (this.privTranslationRecognizer.recognized)
                try {
                  this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, A);
                } catch {
                }
            }
            if (this.privSuccessCallback) {
              try {
                this.privSuccessCallback(h);
              } catch (A) {
                this.privErrorCallback && this.privErrorCallback(A);
              }
              this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
            }
          }
          o = !0;
        }
      }, c = (d, u) => {
        const h = this.fireEventForResult(d, u);
        if (this.privRequestSession.onHypothesis(this.privRequestSession.currentTurnAudioOffset + h.offset), this.privTranslationRecognizer.recognizing)
          try {
            this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, h);
          } catch {
          }
        o = !0;
      };
      switch (n.messageType === s.MessageType.Text && t.setProperty(a.PropertyId.SpeechServiceResponse_JsonResult, n.textBody), n.path.toLowerCase()) {
        case "translation.hypothesis":
          c(i.TranslationHypothesis.fromJSON(n.textBody), t);
          break;
        case "translation.response":
          const d = JSON.parse(n.textBody);
          if (d.SpeechPhrase)
            await l(i.TranslationPhrase.fromTranslationResponse(d));
          else {
            const h = JSON.parse(n.textBody);
            h.SpeechHypothesis && c(i.TranslationHypothesis.fromTranslationResponse(h), t);
          }
          break;
        case "translation.phrase":
          await l(i.TranslationPhrase.fromJSON(n.textBody));
          break;
        case "translation.synthesis":
          this.sendSynthesisAudio(n.binaryBody, this.privRequestSession.sessionId), o = !0;
          break;
        case "audio.end":
        case "translation.synthesis.end":
          const u = i.TranslationSynthesisEnd.fromJSON(n.textBody);
          switch (u.SynthesisStatus) {
            case i.SynthesisStatus.Error:
              if (this.privTranslationRecognizer.synthesizing) {
                const h = new a.TranslationSynthesisResult(a.ResultReason.Canceled, void 0), A = new a.TranslationSynthesisEventArgs(h, this.privRequestSession.sessionId);
                try {
                  this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, A);
                } catch {
                }
              }
              if (this.privTranslationRecognizer.canceled) {
                const h = new a.TranslationRecognitionCanceledEventArgs(this.privRequestSession.sessionId, a.CancellationReason.Error, u.FailureReason, a.CancellationErrorCode.ServiceError, null);
                try {
                  this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, h);
                } catch {
                }
              }
              break;
            case i.SynthesisStatus.Success:
              this.sendSynthesisAudio(void 0, this.privRequestSession.sessionId);
              break;
          }
          o = !0;
          break;
      }
      return o;
    }
    // Cancels recognition.
    cancelRecognition(n, t, o, l, c) {
      const d = new a.PropertyCollection();
      if (d.setProperty(i.CancellationErrorCodePropertyName, a.CancellationErrorCode[l]), this.privTranslationRecognizer.canceled) {
        const u = new a.TranslationRecognitionCanceledEventArgs(n, o, c, l, void 0);
        try {
          this.privTranslationRecognizer.canceled(this.privTranslationRecognizer, u);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        const u = new a.TranslationRecognitionResult(
          void 0,
          // Translations
          t,
          a.ResultReason.Canceled,
          void 0,
          // Text
          void 0,
          // Druation
          void 0,
          // Offset
          void 0,
          // Language
          void 0,
          // LanguageDetectionConfidence
          c,
          void 0,
          // Json
          d
        );
        try {
          this.privSuccessCallback(u), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
    handleRecognizingCallback(n, t, o) {
      try {
        const l = new a.TranslationRecognitionEventArgs(a.TranslationRecognitionResult.fromSpeechRecognitionResult(n), t, o);
        this.privTranslationRecognizer.recognizing(this.privTranslationRecognizer, l);
      } catch {
      }
    }
    handleRecognizedCallback(n, t, o) {
      try {
        const l = new a.TranslationRecognitionEventArgs(a.TranslationRecognitionResult.fromSpeechRecognitionResult(n), t, o);
        this.privTranslationRecognizer.recognized(this.privTranslationRecognizer, l);
      } catch {
      }
    }
    fireEventForResult(n, t) {
      let o;
      if (n.Translation.Translations !== void 0) {
        o = new a.Translations();
        for (const g of n.Translation.Translations)
          o.set(g.Language, g.Text || g.DisplayText);
      }
      let l, c;
      n instanceof i.TranslationPhrase ? (n.Translation && n.Translation.TranslationStatus === s.TranslationStatus.Success ? l = a.ResultReason.TranslatedSpeech : l = a.ResultReason.RecognizedSpeech, c = n.Confidence) : l = a.ResultReason.TranslatingSpeech;
      const d = n.Language, u = n.Offset + this.privRequestSession.currentTurnAudioOffset, h = new a.TranslationRecognitionResult(o, this.privRequestSession.requestId, l, n.Text, n.Duration, u, d, c, n.Translation.FailureReason, JSON.stringify(n), t);
      return new a.TranslationRecognitionEventArgs(h, u, this.privRequestSession.sessionId);
    }
    sendSynthesisAudio(n, t) {
      const o = n === void 0 ? a.ResultReason.SynthesizingAudioCompleted : a.ResultReason.SynthesizingAudio, l = new a.TranslationSynthesisResult(o, n), c = new a.TranslationSynthesisEventArgs(l, t);
      if (this.privTranslationRecognizer.synthesizing)
        try {
          this.privTranslationRecognizer.synthesizing(this.privTranslationRecognizer, c);
        } catch {
        }
    }
  };
  return ip.TranslationServiceRecognizer = r, ip;
}
var b2 = {};
Object.defineProperty(b2, "__esModule", { value: !0 });
b2.SpeechDetected = void 0;
class bF {
  constructor(a) {
    this.privSpeechStartDetected = JSON.parse(a);
  }
  static fromJSON(a) {
    return new bF(a);
  }
  get Offset() {
    return this.privSpeechStartDetected.Offset;
  }
}
b2.SpeechDetected = bF;
var F2 = {};
Object.defineProperty(F2, "__esModule", { value: !0 });
F2.SpeechHypothesis = void 0;
class FF {
  constructor(a) {
    this.privSpeechHypothesis = JSON.parse(a);
  }
  static fromJSON(a) {
    return new FF(a);
  }
  get Text() {
    return this.privSpeechHypothesis.Text;
  }
  get Offset() {
    return this.privSpeechHypothesis.Offset;
  }
  get Duration() {
    return this.privSpeechHypothesis.Duration;
  }
  get Language() {
    return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Language;
  }
  get LanguageDetectionConfidence() {
    return this.privSpeechHypothesis.PrimaryLanguage === void 0 ? void 0 : this.privSpeechHypothesis.PrimaryLanguage.Confidence;
  }
  get SpeakerId() {
    return this.privSpeechHypothesis.SpeakerId;
  }
}
F2.SpeechHypothesis = FF;
var R2 = {};
Object.defineProperty(R2, "__esModule", { value: !0 });
R2.SpeechKeyword = void 0;
class RF {
  constructor(a) {
    this.privSpeechKeyword = JSON.parse(a);
  }
  static fromJSON(a) {
    return new RF(a);
  }
  get Status() {
    return this.privSpeechKeyword.Status;
  }
  get Text() {
    return this.privSpeechKeyword.Text;
  }
  get Offset() {
    return this.privSpeechKeyword.Offset;
  }
  get Duration() {
    return this.privSpeechKeyword.Duration;
  }
}
R2.SpeechKeyword = RF;
var op = {}, AC;
function VP() {
  if (AC) return op;
  AC = 1, Object.defineProperty(op, "__esModule", { value: !0 }), op.SpeechServiceRecognizer = void 0;
  const s = Hr(), a = wi();
  let i = class extends a.ServiceRecognizerBase {
    constructor(e, n, t, o, l) {
      super(e, n, t, o, l), this.privSpeechRecognizer = l;
    }
    async processTypeSpecificMessages(e) {
      let n;
      const t = new s.PropertyCollection();
      t.setProperty(s.PropertyId.SpeechServiceResponse_JsonResult, e.textBody);
      let o = !1;
      switch (e.path.toLowerCase()) {
        case "speech.hypothesis":
        case "speech.fragment":
          const l = a.SpeechHypothesis.fromJSON(e.textBody), c = l.Offset + this.privRequestSession.currentTurnAudioOffset;
          n = new s.SpeechRecognitionResult(
            this.privRequestSession.requestId,
            s.ResultReason.RecognizingSpeech,
            l.Text,
            l.Duration,
            c,
            l.Language,
            l.LanguageDetectionConfidence,
            void 0,
            // Speaker Id
            void 0,
            e.textBody,
            t
          ), this.privRequestSession.onHypothesis(c);
          const d = new s.SpeechRecognitionEventArgs(n, l.Duration, this.privRequestSession.sessionId);
          if (this.privSpeechRecognizer.recognizing)
            try {
              this.privSpeechRecognizer.recognizing(this.privSpeechRecognizer, d);
            } catch {
            }
          o = !0;
          break;
        case "speech.phrase":
          const u = a.SimpleSpeechPhrase.fromJSON(e.textBody), h = a.EnumTranslation.implTranslateRecognitionResult(u.RecognitionStatus, this.privExpectContentAssessmentResponse);
          if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + u.Offset + u.Duration), s.ResultReason.Canceled === h) {
            const A = a.EnumTranslation.implTranslateCancelResult(u.RecognitionStatus), g = a.EnumTranslation.implTranslateCancelErrorCode(u.RecognitionStatus);
            await this.cancelRecognitionLocal(A, g, a.EnumTranslation.implTranslateErrorDetails(g));
          } else {
            if (!(this.privRequestSession.isSpeechEnded && h === s.ResultReason.NoMatch && u.RecognitionStatus !== a.RecognitionStatus.InitialSilenceTimeout)) {
              if (this.privRecognizerConfig.parameters.getProperty(a.OutputFormatPropertyName) === s.OutputFormat[s.OutputFormat.Simple])
                n = new s.SpeechRecognitionResult(
                  this.privRequestSession.requestId,
                  h,
                  u.DisplayText,
                  u.Duration,
                  u.Offset + this.privRequestSession.currentTurnAudioOffset,
                  u.Language,
                  u.LanguageDetectionConfidence,
                  void 0,
                  // Speaker Id
                  void 0,
                  e.textBody,
                  t
                );
              else {
                const g = a.DetailedSpeechPhrase.fromJSON(e.textBody), f = g.Offset + this.privRequestSession.currentTurnAudioOffset, p = g.getJsonWithCorrectedOffsets(f);
                n = new s.SpeechRecognitionResult(
                  this.privRequestSession.requestId,
                  h,
                  g.RecognitionStatus === a.RecognitionStatus.Success ? g.NBest[0].Display : void 0,
                  g.Duration,
                  f,
                  g.Language,
                  g.LanguageDetectionConfidence,
                  void 0,
                  // Speaker Id
                  void 0,
                  p,
                  t
                );
              }
              const A = new s.SpeechRecognitionEventArgs(n, n.offset, this.privRequestSession.sessionId);
              if (this.privSpeechRecognizer.recognized)
                try {
                  this.privSpeechRecognizer.recognized(this.privSpeechRecognizer, A);
                } catch {
                }
            }
            if (this.privSuccessCallback) {
              try {
                this.privSuccessCallback(n);
              } catch (A) {
                this.privErrorCallback && this.privErrorCallback(A);
              }
              this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
            }
          }
          o = !0;
          break;
      }
      return o;
    }
    // Cancels recognition.
    cancelRecognition(e, n, t, o, l) {
      const c = new s.PropertyCollection();
      if (c.setProperty(a.CancellationErrorCodePropertyName, s.CancellationErrorCode[o]), this.privSpeechRecognizer.canceled) {
        const d = new s.SpeechRecognitionCanceledEventArgs(t, l, o, void 0, e);
        try {
          this.privSpeechRecognizer.canceled(this.privSpeechRecognizer, d);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        const d = new s.SpeechRecognitionResult(
          n,
          s.ResultReason.Canceled,
          void 0,
          // Text
          void 0,
          // Duration
          void 0,
          // Offset
          void 0,
          // Language
          void 0,
          // Language Detection Confidence
          void 0,
          // Speaker Id
          l,
          void 0,
          // Json
          c
        );
        try {
          this.privSuccessCallback(d), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
  };
  return op.SpeechServiceRecognizer = i, op;
}
var ap = {}, gC;
function WP() {
  if (gC) return ap;
  gC = 1, Object.defineProperty(ap, "__esModule", { value: !0 }), ap.ConversationTranscriptionServiceRecognizer = void 0;
  const s = Hr(), a = wi();
  let i = class extends a.ServiceRecognizerBase {
    constructor(e, n, t, o, l) {
      super(e, n, t, o, l), this.privConversationTranscriber = l, this.setSpeakerDiarizationJson();
    }
    setSpeakerDiarizationJson() {
      if (this.privEnableSpeakerId) {
        const e = this.privSpeechContext.getSection("phraseDetection");
        e.mode = "Conversation";
        const n = {};
        n.mode = "Anonymous", n.audioSessionId = this.privDiarizationSessionId, n.audioOffsetMs = 0, e.speakerDiarization = n, this.privSpeechContext.setSection("phraseDetection", e);
      }
    }
    async processTypeSpecificMessages(e) {
      let n;
      const t = new s.PropertyCollection();
      t.setProperty(s.PropertyId.SpeechServiceResponse_JsonResult, e.textBody);
      let o = !1;
      switch (e.path.toLowerCase()) {
        case "speech.hypothesis":
        case "speech.fragment":
          const l = a.SpeechHypothesis.fromJSON(e.textBody), c = l.Offset + this.privRequestSession.currentTurnAudioOffset;
          n = new s.ConversationTranscriptionResult(
            this.privRequestSession.requestId,
            s.ResultReason.RecognizingSpeech,
            l.Text,
            l.Duration,
            c,
            l.Language,
            l.LanguageDetectionConfidence,
            void 0,
            // Speaker Id
            void 0,
            e.textBody,
            t
          ), this.privRequestSession.onHypothesis(c);
          const d = new s.ConversationTranscriptionEventArgs(n, l.Duration, this.privRequestSession.sessionId);
          if (this.privConversationTranscriber.transcribing)
            try {
              this.privConversationTranscriber.transcribing(this.privConversationTranscriber, d);
            } catch {
            }
          o = !0;
          break;
        case "speech.phrase":
          const u = a.SimpleSpeechPhrase.fromJSON(e.textBody), h = a.EnumTranslation.implTranslateRecognitionResult(u.RecognitionStatus);
          if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + u.Offset + u.Duration), s.ResultReason.Canceled === h) {
            const A = a.EnumTranslation.implTranslateCancelResult(u.RecognitionStatus), g = a.EnumTranslation.implTranslateCancelErrorCode(u.RecognitionStatus);
            await this.cancelRecognitionLocal(A, g, a.EnumTranslation.implTranslateErrorDetails(g));
          } else if (!(this.privRequestSession.isSpeechEnded && h === s.ResultReason.NoMatch && u.RecognitionStatus !== a.RecognitionStatus.InitialSilenceTimeout)) {
            if (this.privRecognizerConfig.parameters.getProperty(a.OutputFormatPropertyName) === s.OutputFormat[s.OutputFormat.Simple])
              n = new s.ConversationTranscriptionResult(this.privRequestSession.requestId, h, u.DisplayText, u.Duration, u.Offset + this.privRequestSession.currentTurnAudioOffset, u.Language, u.LanguageDetectionConfidence, u.SpeakerId, void 0, e.textBody, t);
            else {
              const g = a.DetailedSpeechPhrase.fromJSON(e.textBody), f = g.Offset + this.privRequestSession.currentTurnAudioOffset, p = g.getJsonWithCorrectedOffsets(f);
              n = new s.ConversationTranscriptionResult(this.privRequestSession.requestId, h, g.RecognitionStatus === a.RecognitionStatus.Success ? g.NBest[0].Display : void 0, g.Duration, f, g.Language, g.LanguageDetectionConfidence, u.SpeakerId, void 0, p, t);
            }
            const A = new s.ConversationTranscriptionEventArgs(n, n.offset, this.privRequestSession.sessionId);
            if (this.privConversationTranscriber.transcribed)
              try {
                this.privConversationTranscriber.transcribed(this.privConversationTranscriber, A);
              } catch {
              }
          }
          o = !0;
          break;
      }
      return o;
    }
    // Cancels recognition.
    cancelRecognition(e, n, t, o, l) {
      if (new s.PropertyCollection().setProperty(a.CancellationErrorCodePropertyName, s.CancellationErrorCode[o]), this.privConversationTranscriber.canceled) {
        const d = new s.ConversationTranscriptionCanceledEventArgs(t, l, o, void 0, e);
        try {
          this.privConversationTranscriber.canceled(this.privConversationTranscriber, d);
        } catch {
        }
      }
    }
  };
  return ap.ConversationTranscriptionServiceRecognizer = i, ap;
}
var sp = {}, fC;
function NP() {
  if (fC) return sp;
  fC = 1, Object.defineProperty(sp, "__esModule", { value: !0 }), sp.TranscriptionServiceRecognizer = void 0;
  const s = Eo(), a = Hr(), i = wi(), r = R0;
  let e = class extends i.ConversationServiceRecognizer {
    constructor(t, o, l, c, d) {
      super(t, o, l, c, d), this.privTranscriberRecognizer = d, this.sendPrePayloadJSONOverride = (u) => this.sendTranscriptionStartJSON(u), this.privRecognizerConfig.parameters.getProperty(a.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps) === "true" && this.privSpeechContext.setWordLevelTimings();
    }
    async sendSpeechEventAsync(t, o) {
      if (this.privRequestSession.isRecognizing) {
        const l = await this.fetchConnection();
        await this.sendSpeechEvent(l, this.createSpeechEventPayload(t, o));
      }
    }
    async sendMeetingSpeechEventAsync(t, o) {
      if (this.privRequestSession.isRecognizing) {
        const l = await this.fetchConnection();
        await this.sendSpeechEvent(l, this.createMeetingSpeechEventPayload(t, o));
      }
    }
    processTypeSpecificMessages(t) {
      return this.processSpeechMessages(t);
    }
    handleRecognizedCallback(t, o, l) {
      try {
        const c = new a.SpeechRecognitionEventArgs(t, o, l);
        if (this.privTranscriberRecognizer.recognized(this.privTranscriberRecognizer, c), this.privSuccessCallback) {
          try {
            this.privSuccessCallback(t);
          } catch (d) {
            this.privErrorCallback && this.privErrorCallback(d);
          }
          this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
        }
      } catch {
      }
    }
    handleRecognizingCallback(t, o, l) {
      try {
        const c = new a.SpeechRecognitionEventArgs(t, o, l);
        this.privTranscriberRecognizer.recognizing(this.privTranscriberRecognizer, c);
      } catch {
      }
    }
    // Cancels recognition.
    cancelRecognition(t, o, l, c, d) {
      const u = new a.PropertyCollection();
      if (u.setProperty(i.CancellationErrorCodePropertyName, a.CancellationErrorCode[c]), this.privTranscriberRecognizer.IsMeetingRecognizer()) {
        if (this.privTranscriberRecognizer.canceled) {
          const h = new a.MeetingTranscriptionCanceledEventArgs(l, d, c, void 0, t);
          try {
            this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, h);
          } catch {
          }
        }
      } else if (this.privTranscriberRecognizer.canceled) {
        const h = new a.ConversationTranscriptionCanceledEventArgs(l, d, c, void 0, t);
        try {
          this.privTranscriberRecognizer.canceled(this.privTranscriberRecognizer, h);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        const h = new a.SpeechRecognitionResult(
          o,
          a.ResultReason.Canceled,
          void 0,
          // Text
          void 0,
          // Duration
          void 0,
          // Offset
          void 0,
          // Language
          void 0,
          // Language Detection Confidence
          void 0,
          // Speaker Id
          d,
          void 0,
          // Json
          u
        );
        try {
          this.privSuccessCallback(h), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
    // Encapsulated for derived service recognizers that need to send additional JSON
    async sendTranscriptionStartJSON(t) {
      if (await this.sendSpeechContext(t, !0), this.privTranscriberRecognizer.IsMeetingRecognizer()) {
        const o = this.privTranscriberRecognizer.getMeetingInfo(), l = this.createMeetingSpeechEventPayload(o, "start");
        await this.sendSpeechEvent(t, l);
      } else {
        const o = this.privTranscriberRecognizer.getConversationInfo(), l = this.createSpeechEventPayload(o, "start");
        await this.sendSpeechEvent(t, l);
      }
      await this.sendWaveHeader(t);
    }
    sendSpeechEvent(t, o) {
      const l = JSON.stringify(o);
      if (l)
        return t.send(new r.SpeechConnectionMessage(s.MessageType.Text, "speech.event", this.privRequestSession.requestId, "application/json", l));
    }
    createSpeechEventPayload(t, o) {
      const l = { id: "meeting", name: o, meeting: t.conversationProperties };
      return l.meeting.id = t.id, l.meeting.attendees = t.participants, l;
    }
    createMeetingSpeechEventPayload(t, o) {
      const l = { id: "meeting", name: o, meeting: t.meetingProperties };
      return l.meeting.id = t.id, l.meeting.attendees = t.participants, l;
    }
  };
  return sp.TranscriptionServiceRecognizer = e, sp;
}
var lp = {}, pC;
function JP() {
  if (pC) return lp;
  pC = 1, Object.defineProperty(lp, "__esModule", { value: !0 }), lp.DetailedSpeechPhrase = void 0;
  const s = wi();
  let a = class xZ {
    constructor(r) {
      this.privDetailedSpeechPhrase = JSON.parse(r), this.privDetailedSpeechPhrase.RecognitionStatus = s.RecognitionStatus[this.privDetailedSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(r) {
      return new xZ(r);
    }
    getJsonWithCorrectedOffsets(r) {
      if (this.privDetailedSpeechPhrase.NBest) {
        let e;
        for (const n of this.privDetailedSpeechPhrase.NBest)
          if (n.Words && n.Words[0]) {
            e = n.Words[0].Offset;
            break;
          }
        if (e && e < r) {
          const n = r - e;
          for (const t of this.privDetailedSpeechPhrase.NBest) {
            if (t.Words)
              for (const o of t.Words)
                o.Offset += n;
            if (t.DisplayWords)
              for (const o of t.DisplayWords)
                o.Offset += n;
          }
        }
      }
      return JSON.stringify(this.privDetailedSpeechPhrase);
    }
    get RecognitionStatus() {
      return this.privDetailedSpeechPhrase.RecognitionStatus;
    }
    get NBest() {
      return this.privDetailedSpeechPhrase.NBest;
    }
    get Duration() {
      return this.privDetailedSpeechPhrase.Duration;
    }
    get Offset() {
      return this.privDetailedSpeechPhrase.Offset;
    }
    get Language() {
      return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
      return this.privDetailedSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privDetailedSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get Text() {
      return this.privDetailedSpeechPhrase.NBest && this.privDetailedSpeechPhrase.NBest[0] ? this.privDetailedSpeechPhrase.NBest[0].Display || this.privDetailedSpeechPhrase.NBest[0].DisplayText : this.privDetailedSpeechPhrase.DisplayText;
    }
    get SpeakerId() {
      return this.privDetailedSpeechPhrase.SpeakerId;
    }
  };
  return lp.DetailedSpeechPhrase = a, lp;
}
var cp = {}, mC;
function GP() {
  if (mC) return cp;
  mC = 1, Object.defineProperty(cp, "__esModule", { value: !0 }), cp.SimpleSpeechPhrase = void 0;
  const s = wi();
  let a = class HZ {
    constructor(r) {
      this.privSimpleSpeechPhrase = JSON.parse(r), this.privSimpleSpeechPhrase.RecognitionStatus = s.RecognitionStatus[this.privSimpleSpeechPhrase.RecognitionStatus];
    }
    static fromJSON(r) {
      return new HZ(r);
    }
    get RecognitionStatus() {
      return this.privSimpleSpeechPhrase.RecognitionStatus;
    }
    get DisplayText() {
      return this.privSimpleSpeechPhrase.DisplayText;
    }
    get Offset() {
      return this.privSimpleSpeechPhrase.Offset;
    }
    get Duration() {
      return this.privSimpleSpeechPhrase.Duration;
    }
    get Language() {
      return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Language;
    }
    get LanguageDetectionConfidence() {
      return this.privSimpleSpeechPhrase.PrimaryLanguage === void 0 ? void 0 : this.privSimpleSpeechPhrase.PrimaryLanguage.Confidence;
    }
    get SpeakerId() {
      return this.privSimpleSpeechPhrase.SpeakerId;
    }
  };
  return cp.SimpleSpeechPhrase = a, cp;
}
var y2 = {};
Object.defineProperty(y2, "__esModule", { value: !0 });
y2.AddedLmIntent = void 0;
class TP {
  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param modelImpl - The model.
   * @param intentName - The intent name.
   */
  constructor(a, i) {
    this.modelImpl = a, this.intentName = i;
  }
}
y2.AddedLmIntent = TP;
var dp = {}, vC;
function XP() {
  if (vC) return dp;
  vC = 1, Object.defineProperty(dp, "__esModule", { value: !0 }), dp.IntentServiceRecognizer = void 0;
  const s = Eo(), a = Hr(), i = wi();
  let r = class extends i.ServiceRecognizerBase {
    constructor(n, t, o, l, c) {
      super(n, t, o, l, c), this.privIntentRecognizer = c, this.privIntentDataSent = !1;
    }
    setIntents(n, t) {
      this.privAddedLmIntents = n, this.privUmbrellaIntent = t, this.privIntentDataSent = !0;
    }
    processTypeSpecificMessages(n) {
      let t, o, l = !1;
      const c = new a.PropertyCollection();
      switch (n.messageType === s.MessageType.Text && c.setProperty(a.PropertyId.SpeechServiceResponse_JsonResult, n.textBody), n.path.toLowerCase()) {
        case "speech.hypothesis":
          const u = i.SpeechHypothesis.fromJSON(n.textBody);
          if (t = new a.IntentRecognitionResult(void 0, this.privRequestSession.requestId, a.ResultReason.RecognizingIntent, u.Text, u.Duration, u.Offset + this.privRequestSession.currentTurnAudioOffset, u.Language, u.LanguageDetectionConfidence, void 0, n.textBody, c), this.privRequestSession.onHypothesis(t.offset), o = new a.IntentRecognitionEventArgs(t, u.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId), this.privIntentRecognizer.recognizing)
            try {
              this.privIntentRecognizer.recognizing(this.privIntentRecognizer, o);
            } catch {
            }
          l = !0;
          break;
        case "speech.phrase":
          const h = i.SimpleSpeechPhrase.fromJSON(n.textBody);
          t = new a.IntentRecognitionResult(void 0, this.privRequestSession.requestId, i.EnumTranslation.implTranslateRecognitionResult(h.RecognitionStatus), h.DisplayText, h.Duration, h.Offset + this.privRequestSession.currentTurnAudioOffset, h.Language, h.LanguageDetectionConfidence, void 0, n.textBody, c), o = new a.IntentRecognitionEventArgs(t, t.offset, this.privRequestSession.sessionId);
          const A = () => {
            if (this.privIntentRecognizer.recognized)
              try {
                this.privIntentRecognizer.recognized(this.privIntentRecognizer, o);
              } catch {
              }
            if (this.privSuccessCallback) {
              try {
                this.privSuccessCallback(t);
              } catch (f) {
                this.privErrorCallback && this.privErrorCallback(f);
              }
              this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
            }
          };
          this.privIntentDataSent === !1 || a.ResultReason.NoMatch === o.result.reason ? (this.privRequestSession.onPhraseRecognized(o.offset + o.result.duration), A()) : this.privPendingIntentArgs = o, l = !0;
          break;
        case "response":
          if (o = this.privPendingIntentArgs, this.privPendingIntentArgs = void 0, o === void 0) {
            if (n.textBody === "")
              return;
            o = new a.IntentRecognitionEventArgs(new a.IntentRecognitionResult(), 0, this.privRequestSession.sessionId);
          }
          const g = i.IntentResponse.fromJSON(n.textBody);
          if (g !== null && g.topScoringIntent && g.topScoringIntent.intent) {
            let f = this.privAddedLmIntents[g.topScoringIntent.intent];
            if (this.privUmbrellaIntent !== void 0 && (f = this.privUmbrellaIntent), f) {
              const p = f === void 0 || f.intentName === void 0 ? g.topScoringIntent.intent : f.intentName;
              let v = o.result.reason;
              p !== void 0 && (v = a.ResultReason.RecognizedIntent);
              const b = o.result.properties !== void 0 ? o.result.properties : new a.PropertyCollection();
              b.setProperty(a.PropertyId.LanguageUnderstandingServiceResponse_JsonResult, n.textBody), o = new a.IntentRecognitionEventArgs(new a.IntentRecognitionResult(p, o.result.resultId, v, o.result.text, o.result.duration, o.result.offset, void 0, void 0, o.result.errorDetails, o.result.json, b), o.offset, o.sessionId);
            }
          }
          if (this.privRequestSession.onPhraseRecognized(o.offset + o.result.duration), this.privIntentRecognizer.recognized)
            try {
              this.privIntentRecognizer.recognized(this.privIntentRecognizer, o);
            } catch {
            }
          if (this.privSuccessCallback) {
            try {
              this.privSuccessCallback(o.result);
            } catch (f) {
              this.privErrorCallback && this.privErrorCallback(f);
            }
            this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
          }
          l = !0;
          break;
      }
      const d = new s.Deferred();
      return d.resolve(l), d.promise;
    }
    // Cancels recognition.
    cancelRecognition(n, t, o, l, c) {
      const d = new a.PropertyCollection();
      if (d.setProperty(i.CancellationErrorCodePropertyName, a.CancellationErrorCode[l]), this.privIntentRecognizer.canceled) {
        const u = new a.IntentRecognitionCanceledEventArgs(o, c, l, void 0, void 0, n);
        try {
          this.privIntentRecognizer.canceled(this.privIntentRecognizer, u);
        } catch {
        }
      }
      if (this.privSuccessCallback) {
        const u = new a.IntentRecognitionResult(
          void 0,
          // Intent Id
          t,
          a.ResultReason.Canceled,
          void 0,
          // Text
          void 0,
          // Duration
          void 0,
          // Offset
          void 0,
          // Language
          void 0,
          // LanguageDetectionConfidence
          c,
          void 0,
          // Json
          d
        );
        try {
          this.privSuccessCallback(u), this.privSuccessCallback = void 0;
        } catch {
        }
      }
    }
  };
  return dp.IntentServiceRecognizer = r, dp;
}
var Q2 = {};
Object.defineProperty(Q2, "__esModule", { value: !0 });
Q2.IntentResponse = void 0;
class yF {
  constructor(a) {
    a === "" ? this.privIntentResponse = {} : this.privIntentResponse = JSON.parse(a);
  }
  static fromJSON(a) {
    return new yF(a);
  }
  get query() {
    return this.privIntentResponse.query;
  }
  get topScoringIntent() {
    return this.privIntentResponse.topScoringIntent;
  }
  get entities() {
    return this.privIntentResponse.entities;
  }
}
Q2.IntentResponse = yF;
var PZ = {};
Object.defineProperty(PZ, "__esModule", { value: !0 });
var C2 = {}, U2 = {};
Object.defineProperty(U2, "__esModule", { value: !0 });
U2.ServiceTelemetryListener = void 0;
const p0 = Eo(), bC = p2;
class kP {
  constructor(a, i, r) {
    this.privIsDisposed = !1, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privRequestId = a, this.privAudioSourceId = i, this.privAudioNodeId = r, this.privReceivedMessages = {}, this.privPhraseLatencies = [], this.privHypothesisLatencies = [];
  }
  phraseReceived(a) {
    a > 0 && this.privPhraseLatencies.push(Date.now() - a);
  }
  hypothesisReceived(a) {
    a > 0 && this.privHypothesisLatencies.push(Date.now() - a);
  }
  onEvent(a) {
    this.privIsDisposed || (a instanceof bC.RecognitionTriggeredEvent && a.requestId === this.privRequestId && (this.privListeningTriggerMetric = {
      End: a.eventTime,
      Name: "ListeningTrigger",
      Start: a.eventTime
    }), a instanceof p0.AudioStreamNodeAttachingEvent && a.audioSourceId === this.privAudioSourceId && a.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = a.eventTime), a instanceof p0.AudioStreamNodeAttachedEvent && a.audioSourceId === this.privAudioSourceId && a.audioNodeId === this.privAudioNodeId && (this.privMicStartTime = a.eventTime), a instanceof p0.AudioSourceErrorEvent && a.audioSourceId === this.privAudioSourceId && (this.privMicMetric || (this.privMicMetric = {
      End: a.eventTime,
      Error: a.error,
      Name: "Microphone",
      Start: this.privMicStartTime
    })), a instanceof p0.AudioStreamNodeErrorEvent && a.audioSourceId === this.privAudioSourceId && a.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
      End: a.eventTime,
      Error: a.error,
      Name: "Microphone",
      Start: this.privMicStartTime
    })), a instanceof p0.AudioStreamNodeDetachedEvent && a.audioSourceId === this.privAudioSourceId && a.audioNodeId === this.privAudioNodeId && (this.privMicMetric || (this.privMicMetric = {
      End: a.eventTime,
      Name: "Microphone",
      Start: this.privMicStartTime
    })), a instanceof bC.ConnectingToServiceEvent && a.requestId === this.privRequestId && (this.privConnectionId = a.sessionId), a instanceof p0.ConnectionStartEvent && a.connectionId === this.privConnectionId && (this.privConnectionStartTime = a.eventTime), a instanceof p0.ConnectionEstablishedEvent && a.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
      End: a.eventTime,
      Id: this.privConnectionId,
      Name: "Connection",
      Start: this.privConnectionStartTime
    })), a instanceof p0.ConnectionEstablishErrorEvent && a.connectionId === this.privConnectionId && (this.privConnectionEstablishMetric || (this.privConnectionEstablishMetric = {
      End: a.eventTime,
      Error: this.getConnectionError(a.statusCode),
      Id: this.privConnectionId,
      Name: "Connection",
      Start: this.privConnectionStartTime
    })), a instanceof p0.ConnectionMessageReceivedEvent && a.connectionId === this.privConnectionId && a.message && a.message.headers && a.message.headers.path && (this.privReceivedMessages[a.message.headers.path] || (this.privReceivedMessages[a.message.headers.path] = new Array()), this.privReceivedMessages[a.message.headers.path].length < 50 && this.privReceivedMessages[a.message.headers.path].push(a.networkReceivedTime)));
  }
  getTelemetry() {
    const a = new Array();
    this.privListeningTriggerMetric && a.push(this.privListeningTriggerMetric), this.privMicMetric && a.push(this.privMicMetric), this.privConnectionEstablishMetric && a.push(this.privConnectionEstablishMetric), this.privPhraseLatencies.length > 0 && a.push({
      PhraseLatencyMs: this.privPhraseLatencies
    }), this.privHypothesisLatencies.length > 0 && a.push({
      FirstHypothesisLatencyMs: this.privHypothesisLatencies
    });
    const i = {
      Metrics: a,
      ReceivedMessages: this.privReceivedMessages
    }, r = JSON.stringify(i);
    return this.privReceivedMessages = {}, this.privListeningTriggerMetric = null, this.privMicMetric = null, this.privConnectionEstablishMetric = null, this.privPhraseLatencies = [], this.privHypothesisLatencies = [], r;
  }
  // Determines if there are any telemetry events to send to the service.
  get hasTelemetry() {
    return Object.keys(this.privReceivedMessages).length !== 0 || this.privListeningTriggerMetric !== null || this.privMicMetric !== null || this.privConnectionEstablishMetric !== null || this.privPhraseLatencies.length !== 0 || this.privHypothesisLatencies.length !== 0;
  }
  dispose() {
    this.privIsDisposed = !0;
  }
  getConnectionError(a) {
    switch (a) {
      case 400:
      case 1002:
      case 1003:
      case 1005:
      case 1007:
      case 1008:
      case 1009:
        return "BadRequest";
      case 401:
        return "Unauthorized";
      case 403:
        return "Forbidden";
      case 503:
      case 1001:
        return "ServerUnavailable";
      case 500:
      case 1011:
        return "ServerError";
      case 408:
      case 504:
        return "Timeout";
      default:
        return "statuscode:" + a.toString();
    }
  }
}
U2.ServiceTelemetryListener = kP;
Object.defineProperty(C2, "__esModule", { value: !0 });
C2.RequestSession = void 0;
const TA = Eo(), Zm = p2, wP = U2;
class DP {
  constructor(a) {
    this.privIsDisposed = !1, this.privDetachables = new Array(), this.privIsAudioNodeDetached = !1, this.privIsRecognizing = !1, this.privIsSpeechEnded = !1, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privHypothesisReceived = !1, this.privBytesSent = 0, this.privRecognitionBytesSent = 0, this.privRecogNumber = 0, this.privInTurn = !1, this.privConnectionAttempts = 0, this.privAudioSourceId = a, this.privRequestId = TA.createNoDashGuid(), this.privAudioNodeId = TA.createNoDashGuid(), this.privTurnDeferral = new TA.Deferred(), this.privTurnDeferral.resolve();
  }
  get sessionId() {
    return this.privSessionId;
  }
  get requestId() {
    return this.privRequestId;
  }
  get audioNodeId() {
    return this.privAudioNodeId;
  }
  get turnCompletionPromise() {
    return this.privTurnDeferral.promise;
  }
  get isSpeechEnded() {
    return this.privIsSpeechEnded;
  }
  get isRecognizing() {
    return this.privIsRecognizing;
  }
  get currentTurnAudioOffset() {
    return this.privTurnStartAudioOffset;
  }
  get recogNumber() {
    return this.privRecogNumber;
  }
  get numConnectionAttempts() {
    return this.privConnectionAttempts;
  }
  // The number of bytes sent for the current connection.
  // Counter is reset to 0 each time a connection is established.
  get bytesSent() {
    return this.privBytesSent;
  }
  // The number of bytes sent for the current recognition.
  // Counter is reset to 0 each time recognition is started.
  get recognitionBytesSent() {
    return this.privRecognitionBytesSent;
  }
  listenForServiceTelemetry(a) {
    this.privServiceTelemetryListener && this.privDetachables.push(a.attachListener(this.privServiceTelemetryListener));
  }
  startNewRecognition() {
    this.privRecognitionBytesSent = 0, this.privIsSpeechEnded = !1, this.privIsRecognizing = !0, this.privTurnStartAudioOffset = 0, this.privLastRecoOffset = 0, this.privRecogNumber++, this.privServiceTelemetryListener = new wP.ServiceTelemetryListener(this.privRequestId, this.privAudioSourceId, this.privAudioNodeId), this.onEvent(new Zm.RecognitionTriggeredEvent(this.requestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
  }
  async onAudioSourceAttachCompleted(a, i) {
    this.privAudioNode = a, this.privIsAudioNodeDetached = !1, i ? await this.onComplete() : this.onEvent(new Zm.ListeningStartedEvent(this.privRequestId, this.privSessionId, this.privAudioSourceId, this.privAudioNodeId));
  }
  onPreConnectionStart(a, i) {
    this.privAuthFetchEventId = a, this.privSessionId = i, this.onEvent(new Zm.ConnectingToServiceEvent(this.privRequestId, this.privAuthFetchEventId, this.privSessionId));
  }
  async onAuthCompleted(a) {
    a && await this.onComplete();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async onConnectionEstablishCompleted(a, i) {
    if (a === 200) {
      this.onEvent(new Zm.RecognitionStartedEvent(this.requestId, this.privAudioSourceId, this.privAudioNodeId, this.privAuthFetchEventId, this.privSessionId)), this.privAudioNode && this.privAudioNode.replay(), this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privBytesSent = 0;
      return;
    } else a === 403 && await this.onComplete();
  }
  async onServiceTurnEndResponse(a) {
    this.privTurnDeferral.resolve(), !a || this.isSpeechEnded ? (await this.onComplete(), this.privInTurn = !1) : (this.privTurnStartAudioOffset = this.privLastRecoOffset, this.privAudioNode.replay());
  }
  onSpeechContext() {
    this.privRequestId = TA.createNoDashGuid();
  }
  onServiceTurnStartResponse() {
    this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(() => {
    })), this.privInTurn = !0, this.privTurnDeferral = new TA.Deferred();
  }
  onHypothesis(a) {
    this.privHypothesisReceived || (this.privHypothesisReceived = !0, this.privServiceTelemetryListener.hypothesisReceived(this.privAudioNode.findTimeAtOffset(a)));
  }
  onPhraseRecognized(a) {
    this.privServiceTelemetryListener.phraseReceived(this.privAudioNode.findTimeAtOffset(a)), this.onServiceRecognized(a);
  }
  onServiceRecognized(a) {
    this.privLastRecoOffset = a, this.privHypothesisReceived = !1, this.privAudioNode.shrinkBuffers(a), this.privConnectionAttempts = 0;
  }
  onAudioSent(a) {
    this.privBytesSent += a, this.privRecognitionBytesSent += a;
  }
  onRetryConnection() {
    this.privConnectionAttempts++;
  }
  async dispose() {
    if (!this.privIsDisposed) {
      this.privIsDisposed = !0;
      for (const a of this.privDetachables)
        await a.detach();
      this.privServiceTelemetryListener && this.privServiceTelemetryListener.dispose(), this.privIsRecognizing = !1;
    }
  }
  getTelemetry() {
    return this.privServiceTelemetryListener.hasTelemetry ? this.privServiceTelemetryListener.getTelemetry() : null;
  }
  async onStopRecognizing() {
    await this.onComplete();
  }
  // Should be called with the audioNode for this session has indicated that it is out of speech.
  onSpeechEnded() {
    this.privIsSpeechEnded = !0;
  }
  onEvent(a) {
    this.privServiceTelemetryListener && this.privServiceTelemetryListener.onEvent(a), TA.Events.instance.onEvent(a);
  }
  async onComplete() {
    this.privIsRecognizing && (this.privIsRecognizing = !1, await this.detachAudioNode());
  }
  async detachAudioNode() {
    this.privIsAudioNodeDetached || (this.privIsAudioNodeDetached = !0, this.privAudioNode && await this.privAudioNode.detach());
  }
}
C2.RequestSession = DP;
var I2 = {};
Object.defineProperty(I2, "__esModule", { value: !0 });
I2.SpeechContext = void 0;
class MP {
  constructor(a) {
    this.privContext = {}, this.privDynamicGrammar = a;
  }
  /**
   * Gets a section of the speech.context object.
   * @param sectionName Name of the section to get.
   * @return string or Context JSON serializable object that represents the value.
   */
  getSection(a) {
    return this.privContext[a] || {};
  }
  /**
   * Adds a section to the speech.context object.
   * @param sectionName Name of the section to add.
   * @param value JSON serializable object that represents the value.
   */
  setSection(a, i) {
    this.privContext[a] = i;
  }
  /**
   * @Internal
   * This is only used by pronunciation assessment config.
   * Do not use externally, object returned will change without warning or notice.
   */
  setPronunciationAssessmentParams(a, i, r = !1) {
    this.privContext.phraseDetection === void 0 && (this.privContext.phraseDetection = {
      enrichment: {
        pronunciationAssessment: {}
      }
    }), this.privContext.phraseDetection.enrichment === void 0 && (this.privContext.phraseDetection.enrichment = {
      pronunciationAssessment: {}
    }), this.privContext.phraseDetection.enrichment.pronunciationAssessment = JSON.parse(a), r && (this.privContext.phraseDetection.mode = "Conversation"), this.setWordLevelTimings(), this.privContext.phraseOutput.detailed.options.push("PronunciationAssessment"), this.privContext.phraseOutput.detailed.options.indexOf("SNR") === -1 && this.privContext.phraseOutput.detailed.options.push("SNR"), i && (this.privContext.phraseDetection.enrichment.contentAssessment = {
      topic: i
    }, this.privContext.phraseOutput.detailed.options.push("ContentAssessment"));
  }
  setDetailedOutputFormat() {
    this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
      detailed: {
        options: []
      },
      format: {}
    }), this.privContext.phraseOutput.detailed === void 0 && (this.privContext.phraseOutput.detailed = {
      options: []
    }), this.privContext.phraseOutput.format = "Detailed";
  }
  setWordLevelTimings() {
    this.privContext.phraseOutput === void 0 && (this.privContext.phraseOutput = {
      detailed: {
        options: []
      },
      format: {}
    }), this.privContext.phraseOutput.detailed === void 0 && (this.privContext.phraseOutput.detailed = {
      options: []
    }), this.privContext.phraseOutput.format = "Detailed", this.privContext.phraseOutput.detailed.options.indexOf("WordTimings") === -1 && this.privContext.phraseOutput.detailed.options.push("WordTimings");
  }
  setSpeakerDiarizationAudioOffsetMs(a) {
    this.privContext.phraseDetection.speakerDiarization.audioOffsetMs = a;
  }
  toJSON() {
    const a = this.privDynamicGrammar.generateGrammarObject();
    return this.setSection("dgi", a), JSON.stringify(this.privContext);
  }
}
I2.SpeechContext = MP;
var B2 = {};
Object.defineProperty(B2, "__esModule", { value: !0 });
B2.DynamicGrammarBuilder = void 0;
class YP {
  // Adds one more reference phrases to the dynamic grammar to send.
  // All added phrases are generic phrases.
  addPhrase(a) {
    this.privPhrases || (this.privPhrases = []), a instanceof Array ? this.privPhrases = this.privPhrases.concat(a) : this.privPhrases.push(a);
  }
  // Clears all phrases stored in the current object.
  clearPhrases() {
    this.privPhrases = void 0;
  }
  // Adds one or more reference grammars to the current grammar.
  addReferenceGrammar(a) {
    this.privGrammars || (this.privGrammars = []), a instanceof Array ? this.privGrammars = this.privGrammars.concat(a) : this.privGrammars.push(a);
  }
  // clears all grammars stored on the recognizer.
  clearGrammars() {
    this.privGrammars = void 0;
  }
  // Generates an object that represents the dynamic grammar used by the Speech Service.
  // This is done by building an object with the correct layout based on the phrases and reference grammars added to this instance
  // of a DynamicGrammarBuilder
  generateGrammarObject() {
    if (this.privGrammars === void 0 && this.privPhrases === void 0)
      return;
    const a = {};
    if (a.ReferenceGrammars = this.privGrammars, this.privPhrases !== void 0 && this.privPhrases.length !== 0) {
      const i = [];
      this.privPhrases.forEach((r) => {
        i.push({
          Text: r
        });
      }), a.Groups = [{ Type: "Generic", Items: i }];
    }
    return a;
  }
}
B2.DynamicGrammarBuilder = YP;
var OZ = {};
Object.defineProperty(OZ, "__esModule", { value: !0 });
var up = {}, Z2 = {}, S2 = {}, QF = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.MessageDataStreamType = s.ActivityPayloadResponse = void 0;
  class a {
    constructor(r) {
      this.privActivityResponse = JSON.parse(r);
    }
    static fromJSON(r) {
      return new a(r);
    }
    get conversationId() {
      return this.privActivityResponse.conversationId;
    }
    get messageDataStreamType() {
      return this.privActivityResponse.messageDataStreamType;
    }
    get messagePayload() {
      return this.privActivityResponse.messagePayload;
    }
    get version() {
      return this.privActivityResponse.version;
    }
  }
  s.ActivityPayloadResponse = a, function(i) {
    i[i.None = 0] = "None", i[i.TextToSpeechAudio = 1] = "TextToSpeechAudio";
  }(s.MessageDataStreamType || (s.MessageDataStreamType = {}));
})(QF);
Object.defineProperty(S2, "__esModule", { value: !0 });
S2.DialogServiceTurnState = void 0;
const LP = sh, xP = jc, HP = QF;
class PP {
  constructor(a, i) {
    this.privRequestId = i, this.privIsCompleted = !1, this.privAudioStream = null, this.privTurnManager = a, this.resetTurnEndTimeout();
  }
  get audioStream() {
    return this.resetTurnEndTimeout(), this.privAudioStream;
  }
  processActivityPayload(a, i) {
    return a.messageDataStreamType === HP.MessageDataStreamType.TextToSpeechAudio && (this.privAudioStream = xP.AudioOutputStream.createPullStream(), this.privAudioStream.format = i !== void 0 ? i : LP.AudioOutputFormatImpl.getDefaultOutputFormat()), this.privAudioStream;
  }
  endAudioStream() {
    this.privAudioStream !== null && !this.privAudioStream.isClosed && this.privAudioStream.close();
  }
  complete() {
    this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.endAudioStream();
  }
  resetTurnEndTimeout() {
    this.privTimeoutToken !== void 0 && clearTimeout(this.privTimeoutToken), this.privTimeoutToken = setTimeout(() => {
      this.privTurnManager.CompleteTurn(this.privRequestId);
    }, 2e3);
  }
}
S2.DialogServiceTurnState = PP;
Object.defineProperty(Z2, "__esModule", { value: !0 });
Z2.DialogServiceTurnStateManager = void 0;
const FC = _c, OP = S2;
class KP {
  constructor() {
    this.privTurnMap = /* @__PURE__ */ new Map();
  }
  StartTurn(a) {
    if (this.privTurnMap.has(a))
      throw new FC.InvalidOperationError("Service error: There is already a turn with id:" + a);
    const i = new OP.DialogServiceTurnState(this, a);
    return this.privTurnMap.set(a, i), this.privTurnMap.get(a);
  }
  GetTurn(a) {
    return this.privTurnMap.get(a);
  }
  CompleteTurn(a) {
    if (!this.privTurnMap.has(a))
      throw new FC.InvalidOperationError("Service error: Received turn end for an unknown turn id:" + a);
    const i = this.privTurnMap.get(a);
    return i.complete(), this.privTurnMap.delete(a), i;
  }
}
Z2.DialogServiceTurnStateManager = KP;
var RC;
function zP() {
  if (RC) return up;
  RC = 1, Object.defineProperty(up, "__esModule", { value: !0 }), up.DialogServiceAdapter = void 0;
  const s = Xc(), a = $h, i = Eo(), r = sh, e = Hr(), n = Z2, t = wi(), o = QF, l = R0;
  let c = class extends t.ServiceRecognizerBase {
    constructor(u, h, A, g, f) {
      super(u, h, A, g, f), this.privEvents = new i.EventSource(), this.privDialogServiceConnector = f, this.receiveMessageOverride = () => this.receiveDialogMessageOverride(), this.privTurnStateManager = new n.DialogServiceTurnStateManager(), this.recognizeOverride = (p, v, b) => this.listenOnce(p, v, b), this.postConnectImplOverride = (p) => this.dialogConnectImpl(p), this.configConnectionOverride = (p) => this.configConnection(p), this.disconnectOverride = () => this.privDisconnect(), this.privDialogAudioSource = A, this.agentConfigSent = !1, this.privLastResult = null, this.connectionEvents.attach((p) => {
        p.name === "ConnectionClosedEvent" && (this.terminateMessageLoop = !0);
      });
    }
    async sendMessage(u) {
      const h = i.createGuid(), A = i.createNoDashGuid(), g = {
        context: {
          interactionId: h
        },
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        messagePayload: JSON.parse(u),
        version: 0.5
      }, f = JSON.stringify(g);
      await (await this.fetchConnection()).send(new l.SpeechConnectionMessage(i.MessageType.Text, "agent", A, "application/json", f));
    }
    async privDisconnect() {
      await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, e.CancellationReason.Error, e.CancellationErrorCode.NoError, "Disconnecting"), this.terminateMessageLoop = !0, this.agentConfigSent = !1;
    }
    processTypeSpecificMessages(u) {
      const h = new e.PropertyCollection();
      u.messageType === i.MessageType.Text && h.setProperty(e.PropertyId.SpeechServiceResponse_JsonResult, u.textBody);
      let A, g;
      switch (u.path.toLowerCase()) {
        case "speech.phrase":
          const p = t.SimpleSpeechPhrase.fromJSON(u.textBody);
          if (this.privRequestSession.onPhraseRecognized(this.privRequestSession.currentTurnAudioOffset + p.Offset + p.Duration), p.RecognitionStatus !== t.RecognitionStatus.TooManyRequests && p.RecognitionStatus !== t.RecognitionStatus.Error) {
            const B = this.fireEventForResult(p, h);
            if (this.privLastResult = B.result, this.privDialogServiceConnector.recognized)
              try {
                this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, B);
              } catch {
              }
          }
          g = !0;
          break;
        case "speech.hypothesis":
          const v = t.SpeechHypothesis.fromJSON(u.textBody), b = v.Offset + this.privRequestSession.currentTurnAudioOffset;
          A = new e.SpeechRecognitionResult(this.privRequestSession.requestId, e.ResultReason.RecognizingSpeech, v.Text, v.Duration, b, v.Language, v.LanguageDetectionConfidence, void 0, void 0, u.textBody, h), this.privRequestSession.onHypothesis(b);
          const m = new e.SpeechRecognitionEventArgs(A, v.Duration, this.privRequestSession.sessionId);
          if (this.privDialogServiceConnector.recognizing)
            try {
              this.privDialogServiceConnector.recognizing(this.privDialogServiceConnector, m);
            } catch {
            }
          g = !0;
          break;
        case "speech.keyword":
          const y = t.SpeechKeyword.fromJSON(u.textBody);
          A = new e.SpeechRecognitionResult(this.privRequestSession.requestId, y.Status === "Accepted" ? e.ResultReason.RecognizedKeyword : e.ResultReason.NoMatch, y.Text, y.Duration, y.Offset, void 0, void 0, void 0, void 0, u.textBody, h), y.Status !== "Accepted" && (this.privLastResult = A);
          const U = new e.SpeechRecognitionEventArgs(A, A.duration, A.resultId);
          if (this.privDialogServiceConnector.recognized)
            try {
              this.privDialogServiceConnector.recognized(this.privDialogServiceConnector, U);
            } catch {
            }
          g = !0;
          break;
        case "audio":
          {
            const B = u.requestId.toUpperCase(), Q = this.privTurnStateManager.GetTurn(B);
            try {
              u.binaryBody ? Q.audioStream.write(u.binaryBody) : Q.endAudioStream();
            } catch {
            }
          }
          g = !0;
          break;
        case "response":
          this.handleResponseMessage(u), g = !0;
          break;
      }
      const f = new i.Deferred();
      return f.resolve(g), f.promise;
    }
    // Cancels recognition.
    async cancelRecognition(u, h, A, g, f) {
      if (this.terminateMessageLoop = !0, this.privRequestSession.isRecognizing && await this.privRequestSession.onStopRecognizing(), this.privDialogServiceConnector.canceled) {
        const p = new e.PropertyCollection();
        p.setProperty(t.CancellationErrorCodePropertyName, e.CancellationErrorCode[g]);
        const v = new e.SpeechRecognitionCanceledEventArgs(A, f, g, void 0, u);
        try {
          this.privDialogServiceConnector.canceled(this.privDialogServiceConnector, v);
        } catch {
        }
        if (this.privSuccessCallback) {
          const b = new e.SpeechRecognitionResult(
            void 0,
            // ResultId
            e.ResultReason.Canceled,
            void 0,
            // Text
            void 0,
            // Duration
            void 0,
            // Offset
            void 0,
            // Language
            void 0,
            // Language Detection Confidence
            void 0,
            // Speaker Id
            f,
            void 0,
            // Json
            p
          );
          try {
            this.privSuccessCallback(b), this.privSuccessCallback = void 0;
          } catch {
          }
        }
      }
    }
    async listenOnce(u, h, A) {
      this.privRecognizerConfig.recognitionMode = u, this.privSuccessCallback = h, this.privErrorCallback = A, this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privDialogAudioSource.events), this.privRecognizerConfig.parameters.setProperty(e.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
      const g = this.connectImpl(), f = this.sendPreAudioMessages(), p = await this.privDialogAudioSource.attach(this.privRequestSession.audioNodeId), v = await this.privDialogAudioSource.format, b = await this.privDialogAudioSource.deviceInfo, m = new s.ReplayableAudioNode(p, v.avgBytesPerSec);
      await this.privRequestSession.onAudioSourceAttachCompleted(m, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: b };
      try {
        await g, await f;
      } catch (B) {
        return await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, e.CancellationReason.Error, e.CancellationErrorCode.ConnectionFailure, B), Promise.resolve();
      }
      const y = new e.SessionEventArgs(this.privRequestSession.sessionId);
      this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, y), this.sendAudio(m).then(() => {
      }, async (B) => {
        await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, e.CancellationReason.Error, e.CancellationErrorCode.RuntimeError, B);
      });
    }
    // Establishes a websocket connection to the end point.
    dialogConnectImpl(u) {
      return this.privConnectionLoop = this.startMessageLoop(), u;
    }
    receiveDialogMessageOverride() {
      const u = new i.Deferred(), h = async () => {
        try {
          const A = this.isDisposed(), g = !this.isDisposed() && this.terminateMessageLoop;
          if (A || g) {
            u.resolve(void 0);
            return;
          }
          const p = await (await this.fetchConnection()).read();
          if (!p)
            return h();
          const v = l.SpeechConnectionMessage.fromConnectionMessage(p);
          switch (v.path.toLowerCase()) {
            case "turn.start":
              {
                const N = v.requestId.toUpperCase(), J = this.privRequestSession.requestId.toUpperCase();
                N !== J ? this.privTurnStateManager.StartTurn(N) : this.privRequestSession.onServiceTurnStartResponse();
              }
              break;
            case "speech.startdetected":
              const m = t.SpeechDetected.fromJSON(v.textBody), y = new e.RecognitionEventArgs(m.Offset, this.privRequestSession.sessionId);
              this.privRecognizer.speechStartDetected && this.privRecognizer.speechStartDetected(this.privRecognizer, y);
              break;
            case "speech.enddetected":
              let U;
              v.textBody.length > 0 ? U = v.textBody : U = "{ Offset: 0 }";
              const B = t.SpeechDetected.fromJSON(U);
              this.privRequestSession.onServiceRecognized(B.Offset + this.privRequestSession.currentTurnAudioOffset);
              const Q = new e.RecognitionEventArgs(B.Offset + this.privRequestSession.currentTurnAudioOffset, this.privRequestSession.sessionId);
              this.privRecognizer.speechEndDetected && this.privRecognizer.speechEndDetected(this.privRecognizer, Q);
              break;
            case "turn.end":
              {
                const N = v.requestId.toUpperCase(), J = this.privRequestSession.requestId.toUpperCase();
                if (N !== J)
                  this.privTurnStateManager.CompleteTurn(N);
                else {
                  const w = new e.SessionEventArgs(this.privRequestSession.sessionId);
                  if (await this.privRequestSession.onServiceTurnEndResponse(!1), (!this.privRecognizerConfig.isContinuousRecognition || this.privRequestSession.isSpeechEnded || !this.privRequestSession.isRecognizing) && this.privRecognizer.sessionStopped && this.privRecognizer.sessionStopped(this.privRecognizer, w), this.privSuccessCallback && this.privLastResult) {
                    try {
                      this.privSuccessCallback(this.privLastResult), this.privLastResult = null;
                    } catch (W) {
                      this.privErrorCallback && this.privErrorCallback(W);
                    }
                    this.privSuccessCallback = void 0, this.privErrorCallback = void 0;
                  }
                }
              }
              break;
            default:
              try {
                await this.processTypeSpecificMessages(v) || this.serviceEvents && this.serviceEvents.onEvent(new i.ServiceEvent(v.path.toLowerCase(), v.textBody));
              } catch {
              }
          }
          return h();
        } catch {
          this.terminateMessageLoop = !0, u.resolve();
        }
      };
      return h().catch((A) => {
        i.Events.instance.onEvent(new i.BackgroundEvent(A));
      }), u.promise;
    }
    async startMessageLoop() {
      this.terminateMessageLoop = !1;
      try {
        await this.receiveDialogMessageOverride();
      } catch (u) {
        await this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, e.CancellationReason.Error, e.CancellationErrorCode.RuntimeError, u);
      }
      return Promise.resolve();
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configConnection(u) {
      return this.terminateMessageLoop ? (this.terminateMessageLoop = !1, Promise.reject("Connection to service terminated.")) : (await this.sendSpeechServiceConfig(u, this.privRequestSession, this.privRecognizerConfig.SpeechServiceConfig.serialize()), await this.sendAgentConfig(u), u);
    }
    async sendPreAudioMessages() {
      const u = await this.fetchConnection();
      this.addKeywordContextData(), await this.sendSpeechContext(u, !0), await this.sendAgentContext(u), await this.sendWaveHeader(u);
    }
    sendAgentConfig(u) {
      if (this.agentConfig && !this.agentConfigSent) {
        if (this.privRecognizerConfig.parameters.getProperty(e.PropertyId.Conversation_DialogType) === e.DialogServiceConfig.DialogTypes.CustomCommands) {
          const A = this.agentConfig.get();
          A.botInfo.commandsCulture = this.privRecognizerConfig.parameters.getProperty(e.PropertyId.SpeechServiceConnection_RecoLanguage, "en-us"), this.agentConfig.set(A);
        }
        this.onEvent(new a.SendingAgentContextMessageEvent(this.agentConfig));
        const h = this.agentConfig.toJsonString();
        return this.agentConfigSent = !0, u.send(new l.SpeechConnectionMessage(i.MessageType.Text, "agent.config", this.privRequestSession.requestId, "application/json", h));
      }
    }
    sendAgentContext(u) {
      const h = i.createGuid(), A = this.privDialogServiceConnector.properties.getProperty(e.PropertyId.Conversation_Speech_Activity_Template), f = JSON.stringify({
        channelData: "",
        context: {
          interactionId: h
        },
        messagePayload: typeof A === void 0 ? void 0 : A,
        version: 0.5
      });
      return u.send(new l.SpeechConnectionMessage(i.MessageType.Text, "speech.agent.context", this.privRequestSession.requestId, "application/json", f));
    }
    fireEventForResult(u, h) {
      const A = t.EnumTranslation.implTranslateRecognitionResult(u.RecognitionStatus), g = u.Offset + this.privRequestSession.currentTurnAudioOffset, f = new e.SpeechRecognitionResult(this.privRequestSession.requestId, A, u.DisplayText, u.Duration, g, u.Language, u.LanguageDetectionConfidence, void 0, void 0, JSON.stringify(u), h);
      return new e.SpeechRecognitionEventArgs(f, g, this.privRequestSession.sessionId);
    }
    handleResponseMessage(u) {
      const h = JSON.parse(u.textBody);
      switch (h.messageType.toLowerCase()) {
        case "message":
          const A = u.requestId.toUpperCase(), g = o.ActivityPayloadResponse.fromJSON(u.textBody), f = this.privTurnStateManager.GetTurn(A);
          if (g.conversationId) {
            const b = this.agentConfig.get();
            b.botInfo.conversationId = g.conversationId, this.agentConfig.set(b);
          }
          const p = f.processActivityPayload(g, r.AudioOutputFormatImpl.fromSpeechSynthesisOutputFormatString(this.privDialogServiceConnector.properties.getProperty(e.PropertyId.SpeechServiceConnection_SynthOutputFormat, void 0))), v = new e.ActivityReceivedEventArgs(g.messagePayload, p);
          if (this.privDialogServiceConnector.activityReceived)
            try {
              this.privDialogServiceConnector.activityReceived(this.privDialogServiceConnector, v);
            } catch {
            }
          break;
        case "messagestatus":
          if (this.privDialogServiceConnector.turnStatusReceived)
            try {
              this.privDialogServiceConnector.turnStatusReceived(this.privDialogServiceConnector, new e.TurnStatusReceivedEventArgs(u.textBody));
            } catch {
            }
          break;
        default:
          i.Events.instance.onEvent(new i.BackgroundEvent(`Unexpected response of type ${h.messageType}. Ignoring.`));
          break;
      }
    }
    onEvent(u) {
      this.privEvents.onEvent(u), i.Events.instance.onEvent(u);
    }
    addKeywordContextData() {
      const u = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect");
      if (u === void 0)
        return;
      const h = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Offsets"), A = this.privRecognizerConfig.parameters.getProperty("SPEECH-KeywordsToDetect-Durations"), g = u.split(";"), f = h === void 0 ? [] : h.split(";"), p = A === void 0 ? [] : A.split(";"), v = [];
      for (let b = 0; b < g.length; b++) {
        const m = {};
        m.text = g[b], b < f.length && (m.offset = Number(f[b])), b < p.length && (m.duration = Number(p[b])), v.push(m);
      }
      this.speechContext.setSection("invocationSource", "VoiceActivationWithKeyword"), this.speechContext.setSection("keywordDetection", [{
        clientDetectedKeywords: v,
        onReject: { action: "EndOfTurn" },
        type: "startTrigger"
      }]);
    }
  };
  return up.DialogServiceAdapter = c, up;
}
var E2 = {};
Object.defineProperty(E2, "__esModule", { value: !0 });
E2.AgentConfig = void 0;
class jP {
  toJsonString() {
    return JSON.stringify(this.iPrivConfig);
  }
  get() {
    return this.iPrivConfig;
  }
  /**
   * Setter for the agent.config object.
   * @param value a JSON serializable object.
   */
  set(a) {
    this.iPrivConfig = a;
  }
}
E2.AgentConfig = jP;
var _v = {}, hp = {}, rg = {};
Object.defineProperty(rg, "__esModule", { value: !0 });
rg.ConversationConnectionConfig = void 0;
const _P = cm;
class vd extends _P.RestConfigBase {
  static get host() {
    return vd.privHost;
  }
  static get apiVersion() {
    return vd.privApiVersion;
  }
  static get clientAppId() {
    return vd.privClientAppId;
  }
  static get defaultLanguageCode() {
    return vd.privDefaultLanguageCode;
  }
  static get restPath() {
    return vd.privRestPath;
  }
  static get webSocketPath() {
    return vd.privWebSocketPath;
  }
  static get transcriptionEventKeys() {
    return vd.privTranscriptionEventKeys;
  }
}
rg.ConversationConnectionConfig = vd;
vd.privHost = "dev.microsofttranslator.com";
vd.privRestPath = "/capito/room";
vd.privApiVersion = "2.0";
vd.privDefaultLanguageCode = "en-US";
vd.privClientAppId = "FC539C22-1767-4F1F-84BC-B4D811114F15";
vd.privWebSocketPath = "/capito/translate";
vd.privTranscriptionEventKeys = ["iCalUid", "callId", "organizer", "FLAC", "MTUri", "DifferentiateGuestSpeakers", "audiorecording", "Threadid", "OrganizerMri", "OrganizerTenantId", "UserToken"];
var yC;
function $P() {
  if (yC) return hp;
  yC = 1, Object.defineProperty(hp, "__esModule", { value: !0 }), hp.ConversationManager = void 0;
  const s = Xc(), a = _o, i = Hr(), r = rg;
  let e = class {
    constructor() {
      this.privRequestParams = r.ConversationConnectionConfig.configParams, this.privErrors = r.ConversationConnectionConfig.restErrors, this.privHost = r.ConversationConnectionConfig.host, this.privApiVersion = r.ConversationConnectionConfig.apiVersion, this.privRestPath = r.ConversationConnectionConfig.restPath, this.privRestAdapter = new s.RestMessageAdapter({});
    }
    /**
     * Make a POST request to the Conversation Manager service endpoint to create or join a conversation.
     * @param args
     * @param conversationCode
     * @param callback
     * @param errorCallback
     */
    createOrJoin(t, o, l, c) {
      try {
        a.Contracts.throwIfNullOrUndefined(t, "args");
        const d = t.getProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage, r.ConversationConnectionConfig.defaultLanguageCode), u = t.getProperty(i.PropertyId.ConversationTranslator_Name, "conversation_host"), h = t.getProperty(i.PropertyId.ConversationTranslator_Host, this.privHost), A = t.getProperty(i.PropertyId.ConversationTranslator_CorrelationId), g = t.getProperty(i.PropertyId.SpeechServiceConnection_Key), f = t.getProperty(i.PropertyId.SpeechServiceConnection_Region), p = t.getProperty(i.PropertyId.SpeechServiceAuthorization_Token);
        a.Contracts.throwIfNullOrWhitespace(d, "languageCode"), a.Contracts.throwIfNullOrWhitespace(u, "nickname"), a.Contracts.throwIfNullOrWhitespace(h, "endpointHost");
        const v = {};
        v[this.privRequestParams.apiVersion] = this.privApiVersion, v[this.privRequestParams.languageCode] = d, v[this.privRequestParams.nickname] = u;
        const b = {};
        A && (b[this.privRequestParams.correlationId] = A), b[this.privRequestParams.clientAppId] = r.ConversationConnectionConfig.clientAppId, o !== void 0 ? v[this.privRequestParams.roomId] = o : (a.Contracts.throwIfNullOrUndefined(f, this.privErrors.authInvalidSubscriptionRegion), b[this.privRequestParams.subscriptionRegion] = f, g ? b[this.privRequestParams.subscriptionKey] = g : p ? b[this.privRequestParams.authorization] = `Bearer ${p}` : a.Contracts.throwIfNullOrUndefined(g, this.privErrors.authInvalidSubscriptionKey));
        const m = {};
        m.headers = b, this.privRestAdapter.options = m;
        const y = `https://${h}${this.privRestPath}`;
        this.privRestAdapter.request(s.RestRequestType.Post, y, v, null).then((U) => {
          const B = s.RestMessageAdapter.extractHeaderValue(this.privRequestParams.requestId, U.headers);
          if (!U.ok) {
            if (c) {
              let N = this.privErrors.invalidCreateJoinConversationResponse.replace("{status}", U.status.toString()), J;
              try {
                J = JSON.parse(U.data), N += ` [${J.error.code}: ${J.error.message}]`;
              } catch {
                N += ` [${U.data}]`;
              }
              B && (N += ` ${B}`), c(N);
            }
            return;
          }
          const Q = JSON.parse(U.data);
          if (Q && (Q.requestId = B), l) {
            try {
              l(Q);
            } catch (N) {
              c && c(N);
            }
            l = void 0;
          }
        }).catch(() => {
        });
      } catch (d) {
        if (c)
          if (d instanceof Error) {
            const u = d;
            c(u.name + ": " + u.message);
          } else
            c(d);
      }
    }
    /**
     * Make a DELETE request to the Conversation Manager service endpoint to leave the conversation.
     * @param args
     * @param sessionToken
     * @param callback
     */
    leave(t, o) {
      return new Promise((l, c) => {
        try {
          a.Contracts.throwIfNullOrUndefined(t, this.privErrors.invalidArgs.replace("{arg}", "config")), a.Contracts.throwIfNullOrWhitespace(o, this.privErrors.invalidArgs.replace("{arg}", "token"));
          const d = t.getProperty(i.PropertyId.ConversationTranslator_Host, this.privHost), u = t.getProperty(i.PropertyId.ConversationTranslator_CorrelationId), h = {};
          h[this.privRequestParams.apiVersion] = this.privApiVersion, h[this.privRequestParams.sessionToken] = o;
          const A = {};
          u && (A[this.privRequestParams.correlationId] = u);
          const g = {};
          g.headers = A, this.privRestAdapter.options = g;
          const f = `https://${d}${this.privRestPath}`;
          this.privRestAdapter.request(s.RestRequestType.Delete, f, h, null).then((p) => {
            p.ok, l();
          }).catch(() => {
          });
        } catch (d) {
          if (d instanceof Error) {
            const u = d;
            c(u.name + ": " + u.message);
          } else
            c(d);
        }
      });
    }
  };
  return hp.ConversationManager = e, hp;
}
var Lh = {}, Ap = {}, V2 = {}, dm = {};
Object.defineProperty(dm, "__esModule", { value: !0 });
dm.ConversationConnectionMessage = void 0;
const qP = Eo();
class eO extends qP.ConnectionMessage {
  constructor(a, i, r, e) {
    super(a, i, r, e);
    const n = JSON.parse(this.textBody);
    n.type !== void 0 && (this.privConversationMessageType = n.type);
  }
  get conversationMessageType() {
    return this.privConversationMessageType;
  }
}
dm.ConversationConnectionMessage = eO;
Object.defineProperty(V2, "__esModule", { value: !0 });
V2.ConversationWebsocketMessageFormatter = void 0;
const xh = Eo(), QC = dm;
class tO {
  /**
   * Format incoming messages: text (speech partial/final, IM) or binary (tts)
   */
  toConnectionMessage(a) {
    const i = new xh.Deferred();
    try {
      if (a.messageType === xh.MessageType.Text) {
        const r = new QC.ConversationConnectionMessage(a.messageType, a.textContent, {}, a.id);
        i.resolve(r);
      } else a.messageType === xh.MessageType.Binary && i.resolve(new QC.ConversationConnectionMessage(a.messageType, a.binaryContent, void 0, a.id));
    } catch (r) {
      i.reject(`Error formatting the message. Error: ${r}`);
    }
    return i.promise;
  }
  /**
   * Format outgoing messages: text (commands or IM)
   */
  fromConnectionMessage(a) {
    const i = new xh.Deferred();
    try {
      if (a.messageType === xh.MessageType.Text) {
        const r = `${a.textBody ? a.textBody : ""}`;
        i.resolve(new xh.RawWebsocketMessage(xh.MessageType.Text, r, a.id));
      }
    } catch (r) {
      i.reject(`Error formatting the message. ${r}`);
    }
    return i.promise;
  }
}
V2.ConversationWebsocketMessageFormatter = tO;
var CC;
function nO() {
  if (CC) return Ap;
  CC = 1, Object.defineProperty(Ap, "__esModule", { value: !0 }), Ap.ConversationConnectionFactory = void 0;
  const s = Xc(), a = Eo(), i = _o, r = Hr(), e = Bu(), n = rg, t = V2;
  let o = class extends e.ConnectionFactoryBase {
    create(c, d, u) {
      const h = c.parameters.getProperty(r.PropertyId.ConversationTranslator_Host, n.ConversationConnectionConfig.host), A = c.parameters.getProperty(r.PropertyId.ConversationTranslator_CorrelationId, a.createGuid()), g = `wss://${h}${n.ConversationConnectionConfig.webSocketPath}`, f = c.parameters.getProperty(r.PropertyId.ConversationTranslator_Token, void 0);
      i.Contracts.throwIfNullOrUndefined(f, "token");
      const p = {};
      p[n.ConversationConnectionConfig.configParams.apiVersion] = n.ConversationConnectionConfig.apiVersion, p[n.ConversationConnectionConfig.configParams.token] = f, p[n.ConversationConnectionConfig.configParams.correlationId] = A;
      const v = c.parameters.getProperty("SPEECH-EnableWebsocketCompression", "false") === "true";
      return new s.WebsocketConnection(g, p, {}, new t.ConversationWebsocketMessageFormatter(), s.ProxyInfo.fromRecognizerConfig(c), v, u);
    }
  };
  return Ap.ConversationConnectionFactory = o, Ap;
}
var gp = {}, W2 = {};
Object.defineProperty(W2, "__esModule", { value: !0 });
W2.ConversationRequestSession = void 0;
const $v = Eo();
class rO {
  constructor(a) {
    this.privIsDisposed = !1, this.privDetachables = new Array(), this.privSessionId = a, this.privRequestId = $v.createNoDashGuid(), this.privRequestCompletionDeferral = new $v.Deferred();
  }
  get sessionId() {
    return this.privSessionId;
  }
  get requestId() {
    return this.privRequestId;
  }
  get completionPromise() {
    return this.privRequestCompletionDeferral.promise;
  }
  onPreConnectionStart(a, i) {
    this.privSessionId = i;
  }
  onAuthCompleted(a) {
    a && this.onComplete();
  }
  onConnectionEstablishCompleted(a) {
    a !== 200 && a === 403 && this.onComplete();
  }
  onServiceTurnEndResponse(a) {
    a ? this.privRequestId = $v.createNoDashGuid() : this.onComplete();
  }
  async dispose() {
    if (!this.privIsDisposed) {
      this.privIsDisposed = !0;
      for (const a of this.privDetachables)
        await a.detach();
    }
  }
  onComplete() {
  }
}
W2.ConversationRequestSession = rO;
var Wd = {}, UC;
function KZ() {
  if (UC) return Wd;
  UC = 1, Object.defineProperty(Wd, "__esModule", { value: !0 }), Wd.ConversationReceivedTranslationEventArgs = Wd.ParticipantsListEventArgs = Wd.ParticipantAttributeEventArgs = Wd.ParticipantEventArgs = Wd.LockRoomEventArgs = Wd.MuteAllEventArgs = void 0;
  const s = Hr();
  class a extends s.SessionEventArgs {
    constructor(l, c) {
      super(c), this.privIsMuted = l;
    }
    get isMuted() {
      return this.privIsMuted;
    }
  }
  Wd.MuteAllEventArgs = a;
  class i extends s.SessionEventArgs {
    constructor(l, c) {
      super(c), this.privIsLocked = l;
    }
    get isMuted() {
      return this.privIsLocked;
    }
  }
  Wd.LockRoomEventArgs = i;
  class r extends s.SessionEventArgs {
    constructor(l, c) {
      super(c), this.privParticipant = l;
    }
    get participant() {
      return this.privParticipant;
    }
  }
  Wd.ParticipantEventArgs = r;
  class e extends s.SessionEventArgs {
    constructor(l, c, d, u) {
      super(u), this.privKey = c, this.privValue = d, this.privParticipantId = l;
    }
    get value() {
      return this.privValue;
    }
    get key() {
      return this.privKey;
    }
    get id() {
      return this.privParticipantId;
    }
  }
  Wd.ParticipantAttributeEventArgs = e;
  class n extends s.SessionEventArgs {
    constructor(l, c, d, u, h, A, g, f, p) {
      super(p), this.privRoomId = l, this.privSessionToken = c, this.privTranslateTo = d, this.privProfanityFilter = u, this.privRoomProfanityFilter = h, this.privIsRoomLocked = A, this.privIsRoomLocked = g, this.privParticipants = f;
    }
    get sessionToken() {
      return this.privSessionToken;
    }
    get conversationId() {
      return this.privRoomId;
    }
    get translateTo() {
      return this.privTranslateTo;
    }
    get profanityFilter() {
      return this.privProfanityFilter;
    }
    get roomProfanityFilter() {
      return this.privRoomProfanityFilter;
    }
    get isRoomLocked() {
      return this.privIsRoomLocked;
    }
    get isMuteAll() {
      return this.privIsMuteAll;
    }
    get participants() {
      return this.privParticipants;
    }
  }
  Wd.ParticipantsListEventArgs = n;
  class t {
    constructor(l, c, d) {
      this.privPayload = c, this.privCommand = l, this.privSessionId = d;
    }
    get payload() {
      return this.privPayload;
    }
    get command() {
      return this.privCommand;
    }
    get sessionId() {
      return this.privSessionId;
    }
  }
  return Wd.ConversationReceivedTranslationEventArgs = t, Wd;
}
var v0 = {};
Object.defineProperty(v0, "__esModule", { value: !0 });
v0.ConversationTranslatorCommandTypes = v0.ConversationTranslatorMessageTypes = v0.InternalParticipants = void 0;
class iO {
  constructor(a = [], i) {
    this.participants = a, this.meId = i;
  }
  /**
   * Add or update a participant
   * @param value
   */
  addOrUpdateParticipant(a) {
    if (a === void 0)
      return;
    const i = this.getParticipantIndex(a.id);
    return i > -1 ? this.participants.splice(i, 1, a) : this.participants.push(a), this.getParticipant(a.id);
  }
  /**
   * Find the participant's position in the participants list.
   * @param id
   */
  getParticipantIndex(a) {
    return this.participants.findIndex((i) => i.id === a);
  }
  /**
   * Find the participant by id.
   * @param id
   */
  getParticipant(a) {
    return this.participants.find((i) => i.id === a);
  }
  /**
   * Remove a participant from the participants list.
   */
  deleteParticipant(a) {
    this.participants = this.participants.filter((i) => i.id !== a);
  }
  /**
   * Helper to return the conversation host.
   */
  get host() {
    return this.participants.find((a) => a.isHost === !0);
  }
  /**
   * Helper to return the current user.
   */
  get me() {
    return this.getParticipant(this.meId);
  }
}
v0.InternalParticipants = iO;
v0.ConversationTranslatorMessageTypes = {
  command: "command",
  final: "final",
  info: "info",
  instantMessage: "instant_message",
  keepAlive: "keep_alive",
  partial: "partial",
  participantCommand: "participant_command",
  translatedMessage: "translated_message"
};
v0.ConversationTranslatorCommandTypes = {
  changeNickname: "ChangeNickname",
  disconnectSession: "DisconnectSession",
  ejectParticipant: "EjectParticipant",
  instant_message: "instant_message",
  joinSession: "JoinSession",
  leaveSession: "LeaveSession",
  participantList: "ParticipantList",
  roomExpirationWarning: "RoomExpirationWarning",
  setLockState: "SetLockState",
  setMute: "SetMute",
  setMuteAll: "SetMuteAll",
  setProfanityFiltering: "SetProfanityFiltering",
  setTranslateToLanguages: "SetTranslateToLanguages",
  setUseTTS: "SetUseTTS"
};
var zZ = {}, N2 = {};
Object.defineProperty(N2, "__esModule", { value: !0 });
N2.CommandResponsePayload = void 0;
const oO = (s) => JSON.parse(s);
class CF {
  constructor(a) {
    this.privCommandResponse = oO(a);
  }
  get type() {
    return this.privCommandResponse.type;
  }
  get command() {
    return this.privCommandResponse.command;
  }
  get id() {
    return this.privCommandResponse.id;
  }
  get nickname() {
    return this.privCommandResponse.nickname;
  }
  get participantId() {
    return this.privCommandResponse.participantId;
  }
  get roomid() {
    return this.privCommandResponse.roomid;
  }
  get value() {
    return this.privCommandResponse.value;
  }
  get token() {
    return this.privCommandResponse.token;
  }
  static fromJSON(a) {
    return new CF(a);
  }
}
N2.CommandResponsePayload = CF;
var PA = {};
Object.defineProperty(PA, "__esModule", { value: !0 });
PA.ParticipantPayloadResponse = PA.ParticipantsListPayloadResponse = void 0;
const aO = (s) => JSON.parse(s), sO = (s) => JSON.parse(s);
class UF {
  constructor(a) {
    this.privParticipantsPayloadResponse = aO(a);
  }
  get roomid() {
    return this.privParticipantsPayloadResponse.roomid;
  }
  get id() {
    return this.privParticipantsPayloadResponse.id;
  }
  get command() {
    return this.privParticipantsPayloadResponse.command;
  }
  get participants() {
    return this.privParticipantsPayloadResponse.participants;
  }
  get token() {
    return this.privParticipantsPayloadResponse.token;
  }
  get translateTo() {
    return this.privParticipantsPayloadResponse.translateTo;
  }
  get profanityFilter() {
    return this.privParticipantsPayloadResponse.profanityFilter;
  }
  get roomProfanityFilter() {
    return this.privParticipantsPayloadResponse.roomProfanityFilter;
  }
  get roomLocked() {
    return this.privParticipantsPayloadResponse.roomLocked;
  }
  get muteAll() {
    return this.privParticipantsPayloadResponse.muteAll;
  }
  get type() {
    return this.privParticipantsPayloadResponse.type;
  }
  static fromJSON(a) {
    return new UF(a);
  }
}
PA.ParticipantsListPayloadResponse = UF;
class IF {
  constructor(a) {
    this.privParticipantPayloadResponse = sO(a);
  }
  get nickname() {
    return this.privParticipantPayloadResponse.nickname;
  }
  get locale() {
    return this.privParticipantPayloadResponse.locale;
  }
  get usetts() {
    return this.privParticipantPayloadResponse.usetts;
  }
  get ismuted() {
    return this.privParticipantPayloadResponse.ismuted;
  }
  get ishost() {
    return this.privParticipantPayloadResponse.ishost;
  }
  get participantId() {
    return this.privParticipantPayloadResponse.participantId;
  }
  get avatar() {
    return this.privParticipantPayloadResponse.avatar;
  }
  static fromJSON(a) {
    return new IF(a);
  }
}
PA.ParticipantPayloadResponse = IF;
var OA = {};
Object.defineProperty(OA, "__esModule", { value: !0 });
OA.TextResponsePayload = OA.SpeechResponsePayload = void 0;
const lO = (s) => JSON.parse(s), cO = (s) => JSON.parse(s);
class BF {
  constructor(a) {
    this.privSpeechResponse = lO(a);
  }
  get recognition() {
    return this.privSpeechResponse.recognition;
  }
  get translations() {
    return this.privSpeechResponse.translations;
  }
  get id() {
    return this.privSpeechResponse.id;
  }
  get language() {
    return this.privSpeechResponse.language;
  }
  get nickname() {
    return this.privSpeechResponse.nickname;
  }
  get participantId() {
    return this.privSpeechResponse.participantId;
  }
  get roomid() {
    return this.privSpeechResponse.roomid;
  }
  get timestamp() {
    return this.privSpeechResponse.timestamp;
  }
  get type() {
    return this.privSpeechResponse.type;
  }
  get isFinal() {
    return this.privSpeechResponse.type === "final";
  }
  static fromJSON(a) {
    return new BF(a);
  }
}
OA.SpeechResponsePayload = BF;
class ZF {
  constructor(a) {
    this.privTextResponse = cO(a);
  }
  get originalText() {
    return this.privTextResponse.originalText;
  }
  get translations() {
    return this.privTextResponse.translations;
  }
  get id() {
    return this.privTextResponse.id;
  }
  get language() {
    return this.privTextResponse.language;
  }
  get nickname() {
    return this.privTextResponse.nickname;
  }
  get participantId() {
    return this.privTextResponse.participantId;
  }
  get roomid() {
    return this.privTextResponse.roomid;
  }
  get timestamp() {
    return this.privTextResponse.timestamp;
  }
  get type() {
    return this.privTextResponse.type;
  }
  static fromJSON(a) {
    return new ZF(a);
  }
}
OA.TextResponsePayload = ZF;
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 });
  var a = N2;
  Object.defineProperty(s, "CommandResponsePayload", { enumerable: !0, get: function() {
    return a.CommandResponsePayload;
  } });
  var i = PA;
  Object.defineProperty(s, "ParticipantsListPayloadResponse", { enumerable: !0, get: function() {
    return i.ParticipantsListPayloadResponse;
  } }), Object.defineProperty(s, "ParticipantPayloadResponse", { enumerable: !0, get: function() {
    return i.ParticipantPayloadResponse;
  } });
  var r = OA;
  Object.defineProperty(s, "SpeechResponsePayload", { enumerable: !0, get: function() {
    return r.SpeechResponsePayload;
  } }), Object.defineProperty(s, "TextResponsePayload", { enumerable: !0, get: function() {
    return r.TextResponsePayload;
  } });
})(zZ);
var IC;
function dO() {
  if (IC) return gp;
  IC = 1, Object.defineProperty(gp, "__esModule", { value: !0 }), gp.ConversationServiceAdapter = void 0;
  const s = Eo(), a = Hr(), i = wi(), r = dm, e = W2, n = KZ(), t = v0, o = zZ;
  let l = class extends i.ServiceRecognizerBase {
    constructor(d, u, h, A, g) {
      super(d, u, h, A, g), this.privConnectionConfigPromise = void 0, this.privLastPartialUtteranceId = "", this.privConversationServiceConnector = g, this.privConversationAuthentication = d, this.receiveMessageOverride = () => this.receiveConversationMessageOverride(), this.recognizeOverride = () => this.noOp(), this.postConnectImplOverride = (f) => this.conversationConnectImpl(f), this.configConnectionOverride = () => this.configConnection(), this.disconnectOverride = () => this.privDisconnect(), this.privConversationRequestSession = new e.ConversationRequestSession(s.createNoDashGuid()), this.privConversationConnectionFactory = u, this.privConversationIsDisposed = !1;
    }
    isDisposed() {
      return super.isDisposed() || this.privConversationIsDisposed;
    }
    async dispose(d) {
      this.privConversationIsDisposed = !0, this.privConnectionConfigPromise !== void 0 && await (await this.privConnectionConfigPromise).dispose(d), await super.dispose(d);
    }
    async sendMessage(d) {
      return (await this.fetchConnection()).send(new r.ConversationConnectionMessage(s.MessageType.Text, d));
    }
    async sendMessageAsync(d) {
      await (await this.fetchConnection()).send(new r.ConversationConnectionMessage(s.MessageType.Text, d));
    }
    privDisconnect() {
      if (!this.terminateMessageLoop)
        return this.cancelRecognition(this.privConversationRequestSession.sessionId, this.privConversationRequestSession.requestId, a.CancellationReason.Error, a.CancellationErrorCode.NoError, "Disconnecting"), this.terminateMessageLoop = !0, Promise.resolve();
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async processTypeSpecificMessages() {
      return !0;
    }
    // Cancels recognition.
    cancelRecognition(d, u, h, A, g) {
      this.terminateMessageLoop = !0;
      const f = new a.ConversationTranslationCanceledEventArgs(h, g, A, void 0, d);
      try {
        this.privConversationServiceConnector.canceled && this.privConversationServiceConnector.canceled(this.privConversationServiceConnector, f);
      } catch {
      }
    }
    /**
     * Establishes a websocket connection to the end point.
     */
    async conversationConnectImpl(d) {
      return this.privConnectionLoop = this.startMessageLoop(), d;
    }
    /**
     * Process incoming websocket messages
     */
    async receiveConversationMessageOverride() {
      if (this.isDisposed() || this.terminateMessageLoop)
        return Promise.resolve();
      const d = new s.Deferred();
      try {
        const h = await (await this.fetchConnection()).read();
        if (this.isDisposed() || this.terminateMessageLoop)
          return d.resolve(), Promise.resolve();
        if (!h)
          return this.receiveConversationMessageOverride();
        const A = this.privConversationRequestSession.sessionId, g = h.conversationMessageType.toLowerCase();
        let f = !1;
        try {
          switch (g) {
            case "info":
            case "participant_command":
            case "command":
              const p = o.CommandResponsePayload.fromJSON(h.textBody);
              switch (p.command.toLowerCase()) {
                case "participantlist":
                  const B = o.ParticipantsListPayloadResponse.fromJSON(h.textBody), Q = B.participants.map((Z) => ({
                    avatar: Z.avatar,
                    displayName: Z.nickname,
                    id: Z.participantId,
                    isHost: Z.ishost,
                    isMuted: Z.ismuted,
                    isUsingTts: Z.usetts,
                    preferredLanguage: Z.locale
                  }));
                  this.privConversationServiceConnector.participantsListReceived && this.privConversationServiceConnector.participantsListReceived(this.privConversationServiceConnector, new n.ParticipantsListEventArgs(B.roomid, B.token, B.translateTo, B.profanityFilter, B.roomProfanityFilter, B.roomLocked, B.muteAll, Q, A));
                  break;
                case "settranslatetolanguages":
                  this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new n.ParticipantAttributeEventArgs(p.participantId, t.ConversationTranslatorCommandTypes.setTranslateToLanguages, p.value, A));
                  break;
                case "setprofanityfiltering":
                  this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new n.ParticipantAttributeEventArgs(p.participantId, t.ConversationTranslatorCommandTypes.setProfanityFiltering, p.value, A));
                  break;
                case "setmute":
                  this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new n.ParticipantAttributeEventArgs(p.participantId, t.ConversationTranslatorCommandTypes.setMute, p.value, A));
                  break;
                case "setmuteall":
                  this.privConversationServiceConnector.muteAllCommandReceived && this.privConversationServiceConnector.muteAllCommandReceived(this.privConversationServiceConnector, new n.MuteAllEventArgs(p.value, A));
                  break;
                case "roomexpirationwarning":
                  this.privConversationServiceConnector.conversationExpiration && this.privConversationServiceConnector.conversationExpiration(this.privConversationServiceConnector, new a.ConversationExpirationEventArgs(p.value, this.privConversationRequestSession.sessionId));
                  break;
                case "setusetts":
                  this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new n.ParticipantAttributeEventArgs(p.participantId, t.ConversationTranslatorCommandTypes.setUseTTS, p.value, A));
                  break;
                case "setlockstate":
                  this.privConversationServiceConnector.lockRoomCommandReceived && this.privConversationServiceConnector.lockRoomCommandReceived(this.privConversationServiceConnector, new n.LockRoomEventArgs(p.value, A));
                  break;
                case "changenickname":
                  this.privConversationServiceConnector.participantUpdateCommandReceived && this.privConversationServiceConnector.participantUpdateCommandReceived(this.privConversationServiceConnector, new n.ParticipantAttributeEventArgs(p.participantId, t.ConversationTranslatorCommandTypes.changeNickname, p.value, A));
                  break;
                case "joinsession":
                  const N = o.ParticipantPayloadResponse.fromJSON(h.textBody), J = {
                    avatar: N.avatar,
                    displayName: N.nickname,
                    id: N.participantId,
                    isHost: N.ishost,
                    isMuted: N.ismuted,
                    isUsingTts: N.usetts,
                    preferredLanguage: N.locale
                  };
                  this.privConversationServiceConnector.participantJoinCommandReceived && this.privConversationServiceConnector.participantJoinCommandReceived(this.privConversationServiceConnector, new n.ParticipantEventArgs(J, A));
                  break;
                case "leavesession":
                  const w = {
                    id: p.participantId
                  };
                  this.privConversationServiceConnector.participantLeaveCommandReceived && this.privConversationServiceConnector.participantLeaveCommandReceived(this.privConversationServiceConnector, new n.ParticipantEventArgs(w, A));
                  break;
                case "disconnectsession":
                  const W = {
                    id: p.participantId
                  };
                  break;
                case "token":
                  const G = new i.CognitiveTokenAuthentication(() => {
                    const Z = p.token;
                    return Promise.resolve(Z);
                  }, () => {
                    const Z = p.token;
                    return Promise.resolve(Z);
                  });
                  this.authentication = G, this.privConversationServiceConnector.onToken(G);
                  break;
                default:
                  break;
              }
              break;
            case "partial":
            case "final":
              const v = o.SpeechResponsePayload.fromJSON(h.textBody), b = g === "final" ? a.ResultReason.TranslatedParticipantSpeech : a.ResultReason.TranslatingParticipantSpeech, m = new a.ConversationTranslationResult(v.participantId, this.getTranslations(v.translations), v.language, v.id, b, v.recognition, void 0, void 0, h.textBody, void 0);
              v.isFinal ? ((m.text !== void 0 && m.text.length > 0 || v.id === this.privLastPartialUtteranceId) && (f = !0), f && this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new n.ConversationReceivedTranslationEventArgs(t.ConversationTranslatorMessageTypes.final, m, A))) : m.text !== void 0 && (this.privLastPartialUtteranceId = v.id, this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new n.ConversationReceivedTranslationEventArgs(t.ConversationTranslatorMessageTypes.partial, m, A)));
              break;
            case "translated_message":
              const y = o.TextResponsePayload.fromJSON(h.textBody), U = new a.ConversationTranslationResult(y.participantId, this.getTranslations(y.translations), y.language, void 0, void 0, y.originalText, void 0, void 0, void 0, h.textBody, void 0);
              this.privConversationServiceConnector.translationReceived && this.privConversationServiceConnector.translationReceived(this.privConversationServiceConnector, new n.ConversationReceivedTranslationEventArgs(t.ConversationTranslatorMessageTypes.instantMessage, U, A));
              break;
            default:
              break;
          }
        } catch {
        }
        return this.receiveConversationMessageOverride();
      } catch {
        this.terminateMessageLoop = !0;
      }
      return d.promise;
    }
    async startMessageLoop() {
      if (this.isDisposed())
        return Promise.resolve();
      this.terminateMessageLoop = !1;
      const d = this.receiveConversationMessageOverride();
      try {
        return await d;
      } catch (u) {
        return this.cancelRecognition(this.privRequestSession ? this.privRequestSession.sessionId : "", this.privRequestSession ? this.privRequestSession.requestId : "", a.CancellationReason.Error, a.CancellationErrorCode.RuntimeError, u), null;
      }
    }
    // Takes an established websocket connection to the endpoint
    configConnection() {
      return this.isDisposed() ? Promise.resolve(void 0) : this.privConnectionConfigPromise !== void 0 ? this.privConnectionConfigPromise.then((d) => d.state() === s.ConnectionState.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigPromise = void 0, this.configConnection()) : this.privConnectionConfigPromise, () => (this.privConnectionId = null, this.privConnectionConfigPromise = void 0, this.configConnection())) : this.terminateMessageLoop ? Promise.resolve(void 0) : (this.privConnectionConfigPromise = this.connectImpl().then((d) => d), this.privConnectionConfigPromise);
    }
    getTranslations(d) {
      let u;
      if (d !== void 0) {
        u = new a.Translations();
        for (const h of d)
          u.set(h.lang, h.translation);
      }
      return u;
    }
  };
  return gp.ConversationServiceAdapter = l, gp;
}
var BC;
function uO() {
  if (BC) return Lh;
  BC = 1, Object.defineProperty(Lh, "__esModule", { value: !0 }), Lh.ConversationTranslatorRecognizer = Lh.ConversationRecognizerFactory = void 0;
  const s = wi(), a = Eo(), i = _o, r = Hr(), e = nO(), n = dO();
  class t {
    static fromConfig(c, d, u) {
      return new o(c, d, u);
    }
  }
  Lh.ConversationRecognizerFactory = t;
  let o = class extends r.Recognizer {
    constructor(c, d, u) {
      const h = d;
      i.Contracts.throwIfNull(h, "speechConfig");
      const A = c;
      i.Contracts.throwIfNull(A, "conversationImpl"), super(u, h.properties, new e.ConversationConnectionFactory()), this.privConversation = A, this.privIsDisposed = !1, this.privProperties = h.properties.clone(), this.privConnection = r.Connection.fromRecognizer(this), this.privProperties.getProperty(r.PropertyId.WebWorkerLoadType, "on").toLowerCase() === "on" && typeof Blob != "undefined" && typeof Worker != "undefined" ? (this.privSetTimeout = a.Timeout.setTimeout, this.privClearTimeout = a.Timeout.clearTimeout) : typeof window != "undefined" ? (this.privSetTimeout = window.setTimeout.bind(window), this.privClearTimeout = window.clearTimeout.bind(window)) : (this.privSetTimeout = setTimeout, this.privClearTimeout = clearTimeout);
    }
    set connected(c) {
      this.privConnection.connected = c;
    }
    set disconnected(c) {
      this.privConnection.disconnected = c;
    }
    /**
     * Return the speech language used by the recognizer
     */
    get speechRecognitionLanguage() {
      return this.privSpeechRecognitionLanguage;
    }
    /**
     * Return the properties for the recognizer
     */
    get properties() {
      return this.privProperties;
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    /**
     * Connect to the recognizer
     * @param token
     */
    connect(c, d, u) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), i.Contracts.throwIfNullOrWhitespace(c, "token"), this.privReco.conversationTranslatorToken = c, this.resetConversationTimeout(), this.privReco.connectAsync(d, u);
      } catch (h) {
        if (u)
          if (h instanceof Error) {
            const A = h;
            u(A.name + ": " + A.message);
          } else
            u(h);
      }
    }
    /**
     * Disconnect from the recognizer
     */
    disconnect(c, d) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privReco.disconnect().then(() => {
          c && c();
        }, (u) => {
          d && d(u);
        });
      } catch (u) {
        if (d)
          if (u instanceof Error) {
            const h = u;
            d(h.name + ": " + h.message);
          } else
            d(u);
        this.dispose(!0).catch((h) => {
          a.Events.instance.onEvent(new a.BackgroundEvent(h));
        });
      }
    }
    /**
     * Send the mute all participants command to the websocket
     * @param conversationId
     * @param participantId
     * @param isMuted
     */
    sendRequest(c, d, u) {
      try {
        i.Contracts.throwIfDisposed(this.privIsDisposed), this.sendMessage(c, d, u);
      } catch (h) {
        if (u)
          if (h instanceof Error) {
            const A = h;
            u(A.name + ": " + A.message);
          } else
            u(h);
        this.dispose(!0).catch((A) => {
          a.Events.instance.onEvent(new a.BackgroundEvent(A));
        });
      }
    }
    /**
     * Handle update of service auth token (#694)
     */
    onToken(c) {
      this.privConversation.onToken(c);
    }
    /**
     * Close and dispose the recognizer
     */
    async close() {
      this.privIsDisposed || (this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close()), this.privConnection = void 0, await this.dispose(!0));
    }
    /**
     * Dispose the recognizer
     * @param disposing
     */
    async dispose(c) {
      this.privIsDisposed || c && (this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privIsDisposed = !0, this.privConnection && (this.privConnection.closeConnection(), this.privConnection.close(), this.privConnection = void 0), await super.dispose(c));
    }
    /**
     * Create the config for the recognizer
     * @param speechConfig
     */
    createRecognizerConfig(c) {
      return new s.RecognizerConfig(c, this.privProperties);
    }
    /**
     * Create the service recognizer.
     * The audio source is redundnant here but is required by the implementation.
     * @param authentication
     * @param connectionFactory
     * @param audioConfig
     * @param recognizerConfig
     */
    createServiceRecognizer(c, d, u, h) {
      const A = u;
      return new n.ConversationServiceAdapter(c, d, A, h, this);
    }
    sendMessage(c, d, u) {
      const h = this.privReco;
      ((g, f, p) => {
        g !== void 0 ? g.then(() => {
          try {
            f && f();
          } catch (v) {
            p && p(`'Unhandled error on promise callback: ${v}'`);
          }
        }, (v) => {
          try {
            p && p(v);
          } catch {
          }
        }) : p && p("Null promise");
      })(h.sendMessageAsync(c), d, u), this.resetConversationTimeout();
    }
    resetConversationTimeout() {
      this.privTimeoutToken !== void 0 && this.privClearTimeout(this.privTimeoutToken), this.privTimeoutToken = this.privSetTimeout(() => {
        this.sendRequest(this.privConversation.getKeepAlive());
      }, 6e4);
    }
  };
  return Lh.ConversationTranslatorRecognizer = o, Lh;
}
var fp = {}, ZC;
function hO() {
  if (ZC) return fp;
  ZC = 1, Object.defineProperty(fp, "__esModule", { value: !0 }), fp.TranscriberRecognizer = void 0;
  const s = Eo(), a = _o, i = Hr(), r = wi();
  let e = class extends i.Recognizer {
    /**
     * TranscriberRecognizer constructor.
     * @constructor
     * @param {SpeechTranslationConfig} speechTranslationConfig - Non-audio configuration associated with the recognizer
     * @param {AudioConfig} audioConfig - An audio configuration associated with the recognizer
     */
    constructor(t, o) {
      const l = t;
      a.Contracts.throwIfNull(l, "speechTranslationConfig");
      const c = o;
      a.Contracts.throwIfNull(c, "audioConfigImpl"), a.Contracts.throwIfNullOrWhitespace(l.speechRecognitionLanguage, i.PropertyId[i.PropertyId.SpeechServiceConnection_RecoLanguage]), super(o, l.properties, new r.TranscriberConnectionFactory()), this.privDisposedRecognizer = !1, this.isMeetingRecognizer = !1;
    }
    get speechRecognitionLanguage() {
      return a.Contracts.throwIfDisposed(this.privDisposedRecognizer), this.properties.getProperty(i.PropertyId.SpeechServiceConnection_RecoLanguage);
    }
    get properties() {
      return this.privProperties;
    }
    get authorizationToken() {
      return this.properties.getProperty(i.PropertyId.SpeechServiceAuthorization_Token);
    }
    set authorizationToken(t) {
      a.Contracts.throwIfNullOrWhitespace(t, "token"), this.properties.setProperty(i.PropertyId.SpeechServiceAuthorization_Token, t);
    }
    set conversation(t) {
      a.Contracts.throwIfNullOrUndefined(t, "Conversation"), this.isMeetingRecognizer = !1, this.privConversation = t;
    }
    getConversationInfo() {
      return a.Contracts.throwIfNullOrUndefined(this.privConversation, "Conversation"), this.privConversation.conversationInfo;
    }
    set meeting(t) {
      a.Contracts.throwIfNullOrUndefined(t, "Meeting"), this.isMeetingRecognizer = !0, this.privMeeting = t;
    }
    getMeetingInfo() {
      return a.Contracts.throwIfNullOrUndefined(this.privMeeting, "Meeting"), this.privMeeting.meetingInfo;
    }
    IsMeetingRecognizer() {
      return this.isMeetingRecognizer;
    }
    startContinuousRecognitionAsync(t, o) {
      s.marshalPromiseToCallbacks(this.startContinuousRecognitionAsyncImpl(r.RecognitionMode.Conversation), t, o);
    }
    stopContinuousRecognitionAsync(t, o) {
      s.marshalPromiseToCallbacks(this.stopContinuousRecognitionAsyncImpl(), t, o);
    }
    async close() {
      this.privDisposedRecognizer || await this.dispose(!0);
    }
    // Push async join/leave conversation message via serviceRecognizer
    async pushConversationEvent(t, o) {
      const l = this.privReco;
      a.Contracts.throwIfNullOrUndefined(l, "serviceRecognizer"), await l.sendSpeechEventAsync(t, o);
    }
    // Push async join/leave meeting message via serviceRecognizer
    async pushMeetingEvent(t, o) {
      const l = this.privReco;
      a.Contracts.throwIfNullOrUndefined(l, "serviceRecognizer"), await l.sendMeetingSpeechEventAsync(t, o);
    }
    async enforceAudioGating() {
      const l = (await this.audioConfig.format).channels;
      if (l === 1) {
        if (this.properties.getProperty("f0f5debc-f8c9-4892-ac4b-90a7ab359fd2", "false").toLowerCase() !== "true")
          throw new Error("Single channel audio configuration for MeetingTranscriber is currently under private preview, please contact diarizationrequest@microsoft.com for more details");
      } else if (l !== 8)
        throw new Error(`Unsupported audio configuration: Detected ${l}-channel audio`);
    }
    connectMeetingCallbacks(t) {
      this.isMeetingRecognizer = !0, this.canceled = (o, l) => {
        t.canceled && t.canceled(t, l);
      }, this.recognizing = (o, l) => {
        t.transcribing && t.transcribing(t, l);
      }, this.recognized = (o, l) => {
        t.transcribed && t.transcribed(t, l);
      }, this.sessionStarted = (o, l) => {
        t.sessionStarted && t.sessionStarted(t, l);
      }, this.sessionStopped = (o, l) => {
        t.sessionStopped && t.sessionStopped(t, l);
      };
    }
    disconnectCallbacks() {
      this.canceled = void 0, this.recognizing = void 0, this.recognized = void 0, this.sessionStarted = void 0, this.sessionStopped = void 0;
    }
    /**
     * Disposes any resources held by the object.
     * @member ConversationTranscriber.prototype.dispose
     * @function
     * @public
     * @param {boolean} disposing - true if disposing the object.
     */
    async dispose(t) {
      this.privDisposedRecognizer || (t && (this.privDisposedRecognizer = !0, await this.implRecognizerStop()), await super.dispose(t));
    }
    createRecognizerConfig(t) {
      return new r.RecognizerConfig(t, this.properties);
    }
    createServiceRecognizer(t, o, l, c) {
      const d = l;
      return new r.TranscriptionServiceRecognizer(t, o, d, c, this);
    }
  };
  return fp.TranscriberRecognizer = e, fp;
}
var SC;
function AO() {
  return SC || (SC = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 });
    var a = $P();
    Object.defineProperty(s, "ConversationManager", { enumerable: !0, get: function() {
      return a.ConversationManager;
    } });
    var i = rg;
    Object.defineProperty(s, "ConversationConnectionConfig", { enumerable: !0, get: function() {
      return i.ConversationConnectionConfig;
    } });
    var r = uO();
    Object.defineProperty(s, "ConversationRecognizerFactory", { enumerable: !0, get: function() {
      return r.ConversationRecognizerFactory;
    } });
    var e = hO();
    Object.defineProperty(s, "TranscriberRecognizer", { enumerable: !0, get: function() {
      return e.TranscriberRecognizer;
    } });
    var n = KZ();
    Object.defineProperty(s, "ConversationReceivedTranslationEventArgs", { enumerable: !0, get: function() {
      return n.ConversationReceivedTranslationEventArgs;
    } }), Object.defineProperty(s, "LockRoomEventArgs", { enumerable: !0, get: function() {
      return n.LockRoomEventArgs;
    } }), Object.defineProperty(s, "MuteAllEventArgs", { enumerable: !0, get: function() {
      return n.MuteAllEventArgs;
    } }), Object.defineProperty(s, "ParticipantAttributeEventArgs", { enumerable: !0, get: function() {
      return n.ParticipantAttributeEventArgs;
    } }), Object.defineProperty(s, "ParticipantEventArgs", { enumerable: !0, get: function() {
      return n.ParticipantEventArgs;
    } }), Object.defineProperty(s, "ParticipantsListEventArgs", { enumerable: !0, get: function() {
      return n.ParticipantsListEventArgs;
    } });
    var t = v0;
    Object.defineProperty(s, "ConversationTranslatorCommandTypes", { enumerable: !0, get: function() {
      return t.ConversationTranslatorCommandTypes;
    } }), Object.defineProperty(s, "ConversationTranslatorMessageTypes", { enumerable: !0, get: function() {
      return t.ConversationTranslatorMessageTypes;
    } }), Object.defineProperty(s, "InternalParticipants", { enumerable: !0, get: function() {
      return t.InternalParticipants;
    } });
  }(_v)), _v;
}
var SF = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.SynthesisAudioMetadata = s.MetadataType = void 0, function(i) {
    i.WordBoundary = "WordBoundary", i.Bookmark = "Bookmark", i.Viseme = "Viseme", i.SentenceBoundary = "SentenceBoundary", i.SessionEnd = "SessionEnd", i.AvatarSignal = "TalkingAvatarSignal";
  }(s.MetadataType || (s.MetadataType = {}));
  class a {
    constructor(r) {
      this.privSynthesisAudioMetadata = JSON.parse(r);
    }
    static fromJSON(r) {
      return new a(r);
    }
    get Metadata() {
      return this.privSynthesisAudioMetadata.Metadata;
    }
  }
  s.SynthesisAudioMetadata = a;
})(SF);
var pp = {}, Hu = {};
Object.defineProperty(Hu, "__esModule", { value: !0 });
Hu.SynthesisStartedEvent = Hu.ConnectingToSynthesisServiceEvent = Hu.SynthesisTriggeredEvent = Hu.SpeechSynthesisEvent = void 0;
const EC = Eo();
class J2 extends EC.PlatformEvent {
  constructor(a, i, r = EC.EventType.Info) {
    super(a, r), this.privRequestId = i;
  }
  get requestId() {
    return this.privRequestId;
  }
}
Hu.SpeechSynthesisEvent = J2;
class gO extends J2 {
  constructor(a, i, r) {
    super("SynthesisTriggeredEvent", a), this.privSessionAudioDestinationId = i, this.privTurnAudioDestinationId = r;
  }
  get audioSessionDestinationId() {
    return this.privSessionAudioDestinationId;
  }
  get audioTurnDestinationId() {
    return this.privTurnAudioDestinationId;
  }
}
Hu.SynthesisTriggeredEvent = gO;
class fO extends J2 {
  constructor(a, i) {
    super("ConnectingToSynthesisServiceEvent", a), this.privAuthFetchEventId = i;
  }
  get authFetchEventId() {
    return this.privAuthFetchEventId;
  }
}
Hu.ConnectingToSynthesisServiceEvent = fO;
class pO extends J2 {
  constructor(a, i) {
    super("SynthesisStartedEvent", a), this.privAuthFetchEventId = i;
  }
  get authFetchEventId() {
    return this.privAuthFetchEventId;
  }
}
Hu.SynthesisStartedEvent = pO;
var VC;
function mO() {
  if (VC) return pp;
  VC = 1, Object.defineProperty(pp, "__esModule", { value: !0 }), pp.SynthesisTurn = void 0;
  const s = Eo(), a = jc, i = Hr(), r = SF, e = Hu;
  let n = class Xb {
    constructor() {
      this.privIsDisposed = !1, this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !1, this.privBytesReceived = 0, this.privInTurn = !1, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privSentenceOffset = 0, this.privNextSearchSentenceIndex = 0, this.privRequestId = s.createNoDashGuid(), this.privTurnDeferral = new s.Deferred(), this.privTurnDeferral.resolve();
    }
    get requestId() {
      return this.privRequestId;
    }
    get streamId() {
      return this.privStreamId;
    }
    set streamId(o) {
      this.privStreamId = o;
    }
    get audioOutputFormat() {
      return this.privAudioOutputFormat;
    }
    set audioOutputFormat(o) {
      this.privAudioOutputFormat = o;
    }
    get turnCompletionPromise() {
      return this.privTurnDeferral.promise;
    }
    get isSynthesisEnded() {
      return this.privIsSynthesisEnded;
    }
    get isSynthesizing() {
      return this.privIsSynthesizing;
    }
    get currentTextOffset() {
      return this.privTextOffset;
    }
    get currentSentenceOffset() {
      return this.privSentenceOffset;
    }
    // The number of bytes received for current turn
    get bytesReceived() {
      return this.privBytesReceived;
    }
    get audioDuration() {
      return this.privAudioDuration;
    }
    get extraProperties() {
      if (this.privWebRTCSDP) {
        const o = new i.PropertyCollection();
        return o.setProperty(i.PropertyId.TalkingAvatarService_WebRTC_SDP, this.privWebRTCSDP), o;
      }
    }
    async getAllReceivedAudio() {
      return this.privReceivedAudio ? Promise.resolve(this.privReceivedAudio) : this.privIsSynthesisEnded ? (await this.readAllAudioFromStream(), Promise.resolve(this.privReceivedAudio)) : null;
    }
    async getAllReceivedAudioWithHeader() {
      if (this.privReceivedAudioWithHeader)
        return this.privReceivedAudioWithHeader;
      if (!this.privIsSynthesisEnded)
        return null;
      if (this.audioOutputFormat.hasHeader) {
        const o = await this.getAllReceivedAudio();
        return this.privReceivedAudioWithHeader = this.audioOutputFormat.addHeader(o), this.privReceivedAudioWithHeader;
      } else
        return this.getAllReceivedAudio();
    }
    startNewSynthesis(o, l, c, d) {
      this.privIsSynthesisEnded = !1, this.privIsSynthesizing = !0, this.privRequestId = o, this.privRawText = l, this.privIsSSML = c, this.privAudioOutputStream = new a.PullAudioOutputStreamImpl(), this.privAudioOutputStream.format = this.privAudioOutputFormat, this.privReceivedAudio = null, this.privReceivedAudioWithHeader = null, this.privBytesReceived = 0, this.privTextOffset = 0, this.privNextSearchTextIndex = 0, this.privSentenceOffset = 0, this.privNextSearchSentenceIndex = 0, this.privPartialVisemeAnimation = "", this.privWebRTCSDP = "", d !== void 0 && (this.privTurnAudioDestination = d, this.privTurnAudioDestination.format = this.privAudioOutputFormat), this.onEvent(new e.SynthesisTriggeredEvent(this.requestId, void 0, d === void 0 ? void 0 : d.id()));
    }
    onPreConnectionStart(o) {
      this.privAuthFetchEventId = o, this.onEvent(new e.ConnectingToSynthesisServiceEvent(this.privRequestId, this.privAuthFetchEventId));
    }
    onAuthCompleted(o) {
      o && this.onComplete();
    }
    onConnectionEstablishCompleted(o) {
      if (o === 200) {
        this.onEvent(new e.SynthesisStartedEvent(this.requestId, this.privAuthFetchEventId)), this.privBytesReceived = 0;
        return;
      } else o === 403 && this.onComplete();
    }
    onServiceResponseMessage(o) {
      const l = JSON.parse(o);
      this.streamId = l.audio.streamId;
    }
    onServiceTurnEndResponse() {
      this.privInTurn = !1, this.privTurnDeferral.resolve(), this.onComplete();
    }
    onServiceTurnStartResponse(o) {
      this.privTurnDeferral && this.privInTurn && (this.privTurnDeferral.reject("Another turn started before current completed."), this.privTurnDeferral.promise.then().catch(() => {
      })), this.privInTurn = !0, this.privTurnDeferral = new s.Deferred();
      const l = JSON.parse(o);
      l.webrtc && (this.privWebRTCSDP = l.webrtc.connectionString);
    }
    onAudioChunkReceived(o) {
      this.isSynthesizing && (this.privAudioOutputStream.write(o), this.privBytesReceived += o.byteLength, this.privTurnAudioDestination !== void 0 && this.privTurnAudioDestination.write(o));
    }
    onTextBoundaryEvent(o) {
      this.updateTextOffset(o.Data.text.Text, o.Type);
    }
    onVisemeMetadataReceived(o) {
      o.Data.AnimationChunk !== void 0 && (this.privPartialVisemeAnimation += o.Data.AnimationChunk);
    }
    onSessionEnd(o) {
      this.privAudioDuration = o.Data.Offset;
    }
    async constructSynthesisResult() {
      const o = await this.getAllReceivedAudioWithHeader();
      return new i.SpeechSynthesisResult(this.requestId, i.ResultReason.SynthesizingAudioCompleted, o, void 0, this.extraProperties, this.audioDuration);
    }
    dispose() {
      this.privIsDisposed || (this.privIsDisposed = !0);
    }
    onStopSynthesizing() {
      this.onComplete();
    }
    /**
     * Gets the viseme animation string (merged from animation chunk), and clears the internal
     * partial animation.
     */
    getAndClearVisemeAnimation() {
      const o = this.privPartialVisemeAnimation;
      return this.privPartialVisemeAnimation = "", o;
    }
    onEvent(o) {
      s.Events.instance.onEvent(o);
    }
    /**
     * Check if the text is an XML(SSML) tag
     * @param text
     * @private
     */
    static isXmlTag(o) {
      return o.length >= 2 && o[0] === "<" && o[o.length - 1] === ">";
    }
    updateTextOffset(o, l) {
      l === r.MetadataType.WordBoundary ? (this.privTextOffset = this.privRawText.indexOf(o, this.privNextSearchTextIndex), this.privTextOffset >= 0 && (this.privNextSearchTextIndex = this.privTextOffset + o.length, this.privIsSSML && this.withinXmlTag(this.privTextOffset) && !Xb.isXmlTag(o) && this.updateTextOffset(o, l))) : (this.privSentenceOffset = this.privRawText.indexOf(o, this.privNextSearchSentenceIndex), this.privSentenceOffset >= 0 && (this.privNextSearchSentenceIndex = this.privSentenceOffset + o.length, this.privIsSSML && this.withinXmlTag(this.privSentenceOffset) && !Xb.isXmlTag(o) && this.updateTextOffset(o, l)));
    }
    onComplete() {
      this.privIsSynthesizing && (this.privIsSynthesizing = !1, this.privIsSynthesisEnded = !0, this.privAudioOutputStream.close(), this.privInTurn = !1, this.privTurnAudioDestination !== void 0 && (this.privTurnAudioDestination.close(), this.privTurnAudioDestination = void 0));
    }
    async readAllAudioFromStream() {
      if (this.privIsSynthesisEnded) {
        this.privReceivedAudio = new ArrayBuffer(this.bytesReceived);
        try {
          await this.privAudioOutputStream.read(this.privReceivedAudio);
        } catch {
          this.privReceivedAudio = new ArrayBuffer(0);
        }
      }
    }
    /**
     * Check if current idx is in XML(SSML) tag
     * @param idx
     * @private
     */
    withinXmlTag(o) {
      return this.privRawText.indexOf("<", o + 1) > this.privRawText.indexOf(">", o + 1);
    }
  };
  return pp.SynthesisTurn = n, pp;
}
var mp = {}, WC;
function vO() {
  if (WC) return mp;
  WC = 1, Object.defineProperty(mp, "__esModule", { value: !0 }), mp.SynthesisAdapterBase = void 0;
  const s = Eo(), a = Hr(), i = wi(), r = R0;
  let e = class {
    constructor(t, o, l, c) {
      if (this.speakOverride = void 0, this.receiveMessageOverride = void 0, this.connectImplOverride = void 0, this.configConnectionOverride = void 0, this.privConnectionConfigurationPromise = void 0, !t)
        throw new s.ArgumentNullError("authentication");
      if (!o)
        throw new s.ArgumentNullError("connectionFactory");
      if (!l)
        throw new s.ArgumentNullError("synthesizerConfig");
      this.privAuthentication = t, this.privConnectionFactory = o, this.privSynthesizerConfig = l, this.privIsDisposed = !1, this.privSessionAudioDestination = c, this.privSynthesisTurn = new i.SynthesisTurn(), this.privConnectionEvents = new s.EventSource(), this.privServiceEvents = new s.EventSource(), this.privSynthesisContext = new i.SynthesisContext(), this.privAgentConfig = new i.AgentConfig(), this.connectionEvents.attach((d) => {
        if (d.name === "ConnectionClosedEvent") {
          const u = d;
          u.statusCode !== 1e3 && this.cancelSynthesisLocal(a.CancellationReason.Error, u.statusCode === 1007 ? a.CancellationErrorCode.BadRequestParameters : a.CancellationErrorCode.ConnectionFailure, `${u.reason} websocket error code: ${u.statusCode}`);
        }
      });
    }
    get synthesisContext() {
      return this.privSynthesisContext;
    }
    get agentConfig() {
      return this.privAgentConfig;
    }
    get connectionEvents() {
      return this.privConnectionEvents;
    }
    get serviceEvents() {
      return this.privServiceEvents;
    }
    set activityTemplate(t) {
      this.privActivityTemplate = t;
    }
    get activityTemplate() {
      return this.privActivityTemplate;
    }
    set audioOutputFormat(t) {
      this.privAudioOutputFormat = t, this.privSynthesisTurn.audioOutputFormat = t, this.privSessionAudioDestination !== void 0 && (this.privSessionAudioDestination.format = t), this.synthesisContext !== void 0 && (this.synthesisContext.audioOutputFormat = t);
    }
    isDisposed() {
      return this.privIsDisposed;
    }
    async dispose(t) {
      this.privIsDisposed = !0, this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.close(), this.privConnectionConfigurationPromise !== void 0 && await (await this.privConnectionConfigurationPromise).dispose(t);
    }
    async connect() {
      await this.connectImpl();
    }
    async sendNetworkMessage(t, o) {
      const l = typeof o == "string" ? s.MessageType.Text : s.MessageType.Binary, c = typeof o == "string" ? "application/json" : "";
      return (await this.fetchConnection()).send(new r.SpeechConnectionMessage(l, t, this.privSynthesisTurn.requestId, c, o));
    }
    async Speak(t, o, l, c, d, u) {
      let h;
      if (o ? h = t : h = this.privSynthesizer.buildSsml(t), this.speakOverride !== void 0)
        return this.speakOverride(h, l, c, d);
      this.privSuccessCallback = c, this.privErrorCallback = d, this.privSynthesisTurn.startNewSynthesis(l, t, o, u);
      try {
        await this.connectImpl();
        const A = await this.fetchConnection();
        await this.sendSynthesisContext(A), await this.sendSsmlMessage(A, h, l), this.onSynthesisStarted(l), this.receiveMessage();
      } catch (A) {
        return this.cancelSynthesisLocal(a.CancellationReason.Error, a.CancellationErrorCode.ConnectionFailure, A), Promise.reject(A);
      }
    }
    async stopSpeaking() {
      return await this.connectImpl(), (await this.fetchConnection()).send(new r.SpeechConnectionMessage(s.MessageType.Text, "synthesis.control", this.privSynthesisTurn.requestId, "application/json", JSON.stringify({
        action: "stop"
      })));
    }
    // Cancels synthesis.
    cancelSynthesis(t, o, l, c) {
      const d = new a.PropertyCollection();
      d.setProperty(i.CancellationErrorCodePropertyName, a.CancellationErrorCode[l]);
      const u = new a.SpeechSynthesisResult(t, a.ResultReason.Canceled, void 0, c, d);
      if (this.onSynthesisCancelled(u), this.privSuccessCallback)
        try {
          this.privSuccessCallback(u);
        } catch {
        }
    }
    // Cancels synthesis.
    cancelSynthesisLocal(t, o, l) {
      this.privSynthesisTurn.isSynthesizing && (this.privSynthesisTurn.onStopSynthesizing(), this.cancelSynthesis(this.privSynthesisTurn.requestId, t, o, l));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processTypeSpecificMessages(t) {
      return !0;
    }
    async receiveMessage() {
      try {
        const o = await (await this.fetchConnection()).read();
        if (this.receiveMessageOverride !== void 0)
          return this.receiveMessageOverride();
        if (this.privIsDisposed)
          return;
        if (!o)
          return this.privSynthesisTurn.isSynthesizing ? this.receiveMessage() : void 0;
        const l = r.SpeechConnectionMessage.fromConnectionMessage(o);
        if (l.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase())
          switch (l.path.toLowerCase()) {
            case "turn.start":
              this.privSynthesisTurn.onServiceTurnStartResponse(l.textBody);
              break;
            case "response":
              this.privSynthesisTurn.onServiceResponseMessage(l.textBody);
              break;
            case "audio":
              this.privSynthesisTurn.streamId.toLowerCase() === l.streamId.toLowerCase() && l.binaryBody && (this.privSynthesisTurn.onAudioChunkReceived(l.binaryBody), this.onSynthesizing(l.binaryBody), this.privSessionAudioDestination !== void 0 && this.privSessionAudioDestination.write(l.binaryBody));
              break;
            case "audio.metadata":
              const c = i.SynthesisAudioMetadata.fromJSON(l.textBody).Metadata;
              for (const u of c)
                switch (u.Type) {
                  case i.MetadataType.WordBoundary:
                  case i.MetadataType.SentenceBoundary:
                    this.privSynthesisTurn.onTextBoundaryEvent(u);
                    const h = new a.SpeechSynthesisWordBoundaryEventArgs(u.Data.Offset, u.Data.Duration, u.Data.text.Text, u.Data.text.Length, u.Type === i.MetadataType.WordBoundary ? this.privSynthesisTurn.currentTextOffset : this.privSynthesisTurn.currentSentenceOffset, u.Data.text.BoundaryType);
                    this.onWordBoundary(h);
                    break;
                  case i.MetadataType.Bookmark:
                    const A = new a.SpeechSynthesisBookmarkEventArgs(u.Data.Offset, u.Data.Bookmark);
                    this.onBookmarkReached(A);
                    break;
                  case i.MetadataType.Viseme:
                    if (this.privSynthesisTurn.onVisemeMetadataReceived(u), u.Data.IsLastAnimation) {
                      const g = new a.SpeechSynthesisVisemeEventArgs(u.Data.Offset, u.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());
                      this.onVisemeReceived(g);
                    }
                    break;
                  case i.MetadataType.AvatarSignal:
                    this.onAvatarEvent(u);
                    break;
                  case i.MetadataType.SessionEnd:
                    this.privSynthesisTurn.onSessionEnd(u);
                    break;
                }
              break;
            case "turn.end":
              this.privSynthesisTurn.onServiceTurnEndResponse();
              let d;
              try {
                d = await this.privSynthesisTurn.constructSynthesisResult(), this.privSuccessCallback && this.privSuccessCallback(d);
              } catch (u) {
                this.privErrorCallback && this.privErrorCallback(u);
              }
              this.onSynthesisCompleted(d);
              break;
            default:
              this.processTypeSpecificMessages(l) || this.privServiceEvents && this.serviceEvents.onEvent(new s.ServiceEvent(l.path.toLowerCase(), l.textBody));
          }
        return this.receiveMessage();
      } catch {
      }
    }
    sendSynthesisContext(t) {
      this.setSynthesisContextSynthesisSection();
      const o = this.synthesisContext.toJSON();
      if (o)
        return t.send(new r.SpeechConnectionMessage(s.MessageType.Text, "synthesis.context", this.privSynthesisTurn.requestId, "application/json", o));
    }
    setSpeechConfigSynthesisSection() {
    }
    connectImpl(t = !1) {
      if (this.privConnectionPromise != null)
        return this.privConnectionPromise.then((l) => l.state() === s.ConnectionState.Disconnected ? (this.privConnectionId = null, this.privConnectionPromise = null, this.connectImpl()) : this.privConnectionPromise, () => (this.privConnectionId = null, this.privConnectionPromise = null, this.connectImpl()));
      this.privAuthFetchEventId = s.createNoDashGuid(), this.privConnectionId = s.createNoDashGuid(), this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId);
      const o = t ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
      return this.privConnectionPromise = o.then(async (l) => {
        this.privSynthesisTurn.onAuthCompleted(!1);
        const c = this.privConnectionFactory.create(this.privSynthesizerConfig, l, this.privConnectionId);
        c.events.attach((u) => {
          this.connectionEvents.onEvent(u);
        });
        const d = await c.open();
        return d.statusCode === 200 ? (this.privSynthesisTurn.onConnectionEstablishCompleted(d.statusCode), Promise.resolve(c)) : d.statusCode === 403 && !t ? this.connectImpl(!0) : (this.privSynthesisTurn.onConnectionEstablishCompleted(d.statusCode), Promise.reject(`Unable to contact server. StatusCode: ${d.statusCode},
                    ${this.privSynthesizerConfig.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Url)} Reason: ${d.reason}`));
      }, (l) => {
        throw this.privSynthesisTurn.onAuthCompleted(!0), new Error(l);
      }), this.privConnectionPromise.catch(() => {
      }), this.privConnectionPromise;
    }
    sendSpeechServiceConfig(t, o) {
      if (o)
        return t.send(new r.SpeechConnectionMessage(s.MessageType.Text, "speech.config", this.privSynthesisTurn.requestId, "application/json", o));
    }
    sendSsmlMessage(t, o, l) {
      return t.send(new r.SpeechConnectionMessage(s.MessageType.Text, "ssml", l, "application/ssml+xml", o));
    }
    async fetchConnection() {
      return this.privConnectionConfigurationPromise !== void 0 ? this.privConnectionConfigurationPromise.then((t) => t.state() === s.ConnectionState.Disconnected ? (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.fetchConnection()) : this.privConnectionConfigurationPromise, () => (this.privConnectionId = null, this.privConnectionConfigurationPromise = void 0, this.fetchConnection())) : (this.privConnectionConfigurationPromise = this.configureConnection(), await this.privConnectionConfigurationPromise);
    }
    // Takes an established websocket connection to the endpoint and sends speech configuration information.
    async configureConnection() {
      const t = await this.connectImpl();
      return this.configConnectionOverride !== void 0 ? this.configConnectionOverride(t) : (this.setSpeechConfigSynthesisSection(), await this.sendSpeechServiceConfig(t, this.privSynthesizerConfig.SpeechServiceConfig.serialize()), t);
    }
    onAvatarEvent(t) {
    }
    onSynthesisStarted(t) {
    }
    onSynthesizing(t) {
    }
    onSynthesisCancelled(t) {
    }
    onSynthesisCompleted(t) {
    }
    onWordBoundary(t) {
    }
    onVisemeReceived(t) {
    }
    onBookmarkReached(t) {
    }
  };
  return mp.SynthesisAdapterBase = e, e.telemetryDataEnabled = !0, mp;
}
var vp = {}, NC;
function bO() {
  if (NC) return vp;
  NC = 1, Object.defineProperty(vp, "__esModule", { value: !0 }), vp.AvatarSynthesisAdapter = void 0;
  const s = Hr(), a = wi();
  let i = class extends a.SynthesisAdapterBase {
    constructor(e, n, t, o, l) {
      super(e, n, t, void 0), this.privAvatarSynthesizer = o, this.privSynthesizer = o, this.privAvatarConfig = l;
    }
    setSynthesisContextSynthesisSection() {
      this.privSynthesisContext.setSynthesisSection(void 0);
    }
    setSpeechConfigSynthesisSection() {
      var e, n, t, o, l, c, d, u, h, A, g, f, p, v, b, m, y, U;
      this.privSynthesizerConfig.synthesisVideoSection = {
        format: {
          bitrate: (e = this.privAvatarConfig.videoFormat) == null ? void 0 : e.bitrate,
          codec: (n = this.privAvatarConfig.videoFormat) == null ? void 0 : n.codec,
          crop: {
            bottomRight: {
              x: (l = (o = (t = this.privAvatarConfig.videoFormat) == null ? void 0 : t.cropRange) == null ? void 0 : o.bottomRight) == null ? void 0 : l.x,
              y: (u = (d = (c = this.privAvatarConfig.videoFormat) == null ? void 0 : c.cropRange) == null ? void 0 : d.bottomRight) == null ? void 0 : u.y
            },
            topLeft: {
              x: (g = (A = (h = this.privAvatarConfig.videoFormat) == null ? void 0 : h.cropRange) == null ? void 0 : A.topLeft) == null ? void 0 : g.x,
              y: (v = (p = (f = this.privAvatarConfig.videoFormat) == null ? void 0 : f.cropRange) == null ? void 0 : p.topLeft) == null ? void 0 : v.y
            }
          },
          resolution: {
            height: (b = this.privAvatarConfig.videoFormat) == null ? void 0 : b.height,
            width: (m = this.privAvatarConfig.videoFormat) == null ? void 0 : m.width
          }
        },
        protocol: {
          name: "WebRTC",
          webrtcConfig: {
            clientDescription: btoa(this.privSynthesizerConfig.parameters.getProperty(s.PropertyId.TalkingAvatarService_WebRTC_SDP)),
            iceServers: (y = this.privAvatarConfig.remoteIceServers) != null ? y : this.privAvatarSynthesizer.iceServers
          }
        },
        talkingAvatar: {
          background: {
            color: this.privAvatarConfig.backgroundColor,
            image: {
              url: (U = this.privAvatarConfig.backgroundImage) == null ? void 0 : U.toString()
            }
          },
          character: this.privAvatarConfig.character,
          customized: this.privAvatarConfig.customized,
          style: this.privAvatarConfig.style
        }
      };
    }
    onAvatarEvent(e) {
      if (this.privAvatarSynthesizer.avatarEventReceived) {
        const n = new s.AvatarEventArgs(e.Data.Offset, e.Data.Name);
        try {
          this.privAvatarSynthesizer.avatarEventReceived(this.privAvatarSynthesizer, n);
        } catch {
        }
      }
    }
  };
  return vp.AvatarSynthesisAdapter = i, vp;
}
var bp = {}, JC;
function FO() {
  if (JC) return bp;
  JC = 1, Object.defineProperty(bp, "__esModule", { value: !0 }), bp.SpeechSynthesisAdapter = void 0;
  const s = Hr(), a = wi();
  let i = class extends a.SynthesisAdapterBase {
    constructor(e, n, t, o, l) {
      super(e, n, t, l), this.privSpeechSynthesizer = o, this.privSynthesizer = o;
    }
    setSynthesisContextSynthesisSection() {
      this.privSynthesisContext.setSynthesisSection(this.privSpeechSynthesizer);
    }
    onSynthesisStarted(e) {
      const n = new s.SpeechSynthesisEventArgs(new s.SpeechSynthesisResult(e, s.ResultReason.SynthesizingAudioStarted));
      this.privSpeechSynthesizer.synthesisStarted && this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, n);
    }
    onSynthesizing(e) {
      if (this.privSpeechSynthesizer.synthesizing)
        try {
          const n = this.privSynthesisTurn.audioOutputFormat.addHeader(e), t = new s.SpeechSynthesisEventArgs(new s.SpeechSynthesisResult(this.privSynthesisTurn.requestId, s.ResultReason.SynthesizingAudio, n));
          this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, t);
        } catch {
        }
    }
    onSynthesisCancelled(e) {
      if (this.privSpeechSynthesizer.SynthesisCanceled) {
        const n = new s.SpeechSynthesisEventArgs(e);
        try {
          this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, n);
        } catch {
        }
      }
    }
    onSynthesisCompleted(e) {
      if (this.privSpeechSynthesizer.synthesisCompleted)
        try {
          this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new s.SpeechSynthesisEventArgs(e));
        } catch {
        }
    }
    onWordBoundary(e) {
      if (this.privSpeechSynthesizer.wordBoundary)
        try {
          this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, e);
        } catch {
        }
    }
    onVisemeReceived(e) {
      if (this.privSpeechSynthesizer.visemeReceived)
        try {
          this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, e);
        } catch {
        }
    }
    onBookmarkReached(e) {
      if (this.privSpeechSynthesizer.bookmarkReached)
        try {
          this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, e);
        } catch {
        }
    }
  };
  return bp.SpeechSynthesisAdapter = i, bp;
}
var Fp = {}, GC;
function RO() {
  if (GC) return Fp;
  GC = 1, Object.defineProperty(Fp, "__esModule", { value: !0 }), Fp.SynthesisRestAdapter = void 0;
  const s = Xc(), a = Hr(), i = Bu(), r = Tc;
  let e = class {
    constructor(t, o) {
      let l = t.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Endpoint, void 0);
      if (!l) {
        const d = t.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Region, "westus"), u = i.ConnectionFactoryBase.getHostSuffix(d);
        l = t.parameters.getProperty(a.PropertyId.SpeechServiceConnection_Host, `https://${d}.tts.speech${u}`);
      }
      this.privUri = `${l}/cognitiveservices/voices/list`;
      const c = s.RestConfigBase.requestOptions;
      this.privRestAdapter = new s.RestMessageAdapter(c), this.privAuthentication = o;
    }
    /**
     * Sends list voices request to endpoint.
     * @function
     * @public
     * @param connectionId - guid for connectionId
     * @returns {Promise<IRestResponse>} rest response to status request
     */
    getVoicesList(t) {
      return this.privRestAdapter.setHeaders(r.HeaderNames.ConnectionId, t), this.privAuthentication.fetch(t).then((o) => (this.privRestAdapter.setHeaders(o.headerName, o.token), this.privRestAdapter.request(s.RestRequestType.Get, this.privUri)));
    }
  };
  return Fp.SynthesisRestAdapter = e, Fp;
}
var qv = {}, TC;
function yO() {
  return TC || (TC = 1, function(s) {
    Object.defineProperty(s, "__esModule", { value: !0 }), s.SynthesizerConfig = s.SynthesisServiceType = void 0;
    const a = wi();
    var i;
    (function(e) {
      e[e.Standard = 0] = "Standard", e[e.Custom = 1] = "Custom";
    })(i = s.SynthesisServiceType || (s.SynthesisServiceType = {}));
    class r {
      constructor(n, t) {
        this.privSynthesisServiceType = i.Standard, this.avatarEnabled = !1, this.privSpeechServiceConfig = n || new a.SpeechServiceConfig(new a.Context(null)), this.privParameters = t;
      }
      get parameters() {
        return this.privParameters;
      }
      get synthesisServiceType() {
        return this.privSynthesisServiceType;
      }
      set synthesisServiceType(n) {
        this.privSynthesisServiceType = n;
      }
      set synthesisVideoSection(n) {
        this.privSpeechServiceConfig.Context.synthesis = {
          video: n
        };
      }
      get SpeechServiceConfig() {
        return this.privSpeechServiceConfig;
      }
    }
    s.SynthesizerConfig = r;
  }(qv)), qv;
}
var Rp = {}, XC;
function QO() {
  if (XC) return Rp;
  XC = 1, Object.defineProperty(Rp, "__esModule", { value: !0 }), Rp.SynthesisContext = void 0;
  const s = Hr();
  let a = class {
    constructor() {
      this.privContext = {};
    }
    /**
     * Adds a section to the synthesis.context object.
     * @param sectionName Name of the section to add.
     * @param value JSON serializable object that represents the value.
     */
    setSection(r, e) {
      this.privContext[r] = e;
    }
    /**
     * Sets the audio output format for synthesis context generation.
     * @param format {AudioOutputFormatImpl} the output format
     */
    set audioOutputFormat(r) {
      this.privAudioOutputFormat = r;
    }
    toJSON() {
      return JSON.stringify(this.privContext);
    }
    setSynthesisSection(r) {
      const e = this.buildSynthesisContext(r);
      this.setSection("synthesis", e);
    }
    buildSynthesisContext(r) {
      return {
        audio: {
          metadataOptions: {
            bookmarkEnabled: !!(r != null && r.bookmarkReached),
            punctuationBoundaryEnabled: r == null ? void 0 : r.properties.getProperty(s.PropertyId.SpeechServiceResponse_RequestPunctuationBoundary, !!(r != null && r.wordBoundary)),
            sentenceBoundaryEnabled: r == null ? void 0 : r.properties.getProperty(s.PropertyId.SpeechServiceResponse_RequestSentenceBoundary, !1),
            sessionEndEnabled: !0,
            visemeEnabled: !!(r != null && r.visemeReceived),
            wordBoundaryEnabled: r == null ? void 0 : r.properties.getProperty(s.PropertyId.SpeechServiceResponse_RequestWordBoundary, !!(r != null && r.wordBoundary))
          },
          outputFormat: this.privAudioOutputFormat.requestAudioFormatString
        },
        language: {
          autoDetection: r == null ? void 0 : r.autoDetectSourceLanguage
        }
      };
    }
  };
  return Rp.SynthesisContext = a, Rp;
}
var yp = {}, kC;
function CO() {
  if (kC) return yp;
  kC = 1, Object.defineProperty(yp, "__esModule", { value: !0 }), yp.SpeakerRecognitionConfig = void 0;
  const s = wi();
  let a = class {
    constructor(r, e) {
      this.privContext = r || new s.Context(null), this.privParameters = e;
    }
    get parameters() {
      return this.privParameters;
    }
    get Context() {
      return this.privContext;
    }
  };
  return yp.SpeakerRecognitionConfig = a, yp;
}
var Qp = {}, wC;
function UO() {
  if (wC) return Qp;
  wC = 1, Object.defineProperty(Qp, "__esModule", { value: !0 }), Qp.SpeakerServiceRecognizer = void 0;
  const s = Xc(), a = Eo(), i = Hr(), r = wi(), e = R0;
  let n = class extends r.ServiceRecognizerBase {
    constructor(o, l, c, d, u) {
      super(o, l, c, d, u), this.privSpeakerRecognizer = u, this.privSpeakerAudioSource = c, this.recognizeSpeaker = (h) => this.recognizeSpeakerOnce(h), this.sendPrePayloadJSONOverride = () => this.noOp();
    }
    processTypeSpecificMessages(o) {
      let l = !1;
      const c = new i.PropertyCollection();
      switch (o.messageType === a.MessageType.Text && c.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, o.textBody), o.path.toLowerCase()) {
        case "speaker.response":
          const u = JSON.parse(o.textBody);
          let h;
          u.status.statusCode.toLowerCase() !== "success" ? h = new i.SpeakerRecognitionResult(u, i.ResultReason.Canceled, i.CancellationErrorCode.ServiceError, u.status.reason) : h = new i.SpeakerRecognitionResult(u, i.ResultReason.RecognizedSpeaker), this.privResultDeferral && this.privResultDeferral.resolve(h), l = !0;
          break;
      }
      const d = new a.Deferred();
      return d.resolve(l), d.promise;
    }
    // Cancels recognition.
    cancelRecognition(o, l, c, d, u) {
      if (new i.PropertyCollection().setProperty(r.CancellationErrorCodePropertyName, i.CancellationErrorCode[d]), this.privResultDeferral) {
        const A = new i.SpeakerRecognitionResult({
          scenario: this.privSpeakerModel.scenario,
          status: { statusCode: u, reason: u }
        }, i.ResultReason.Canceled, d, u);
        try {
          this.privResultDeferral.resolve(A);
        } catch (g) {
          this.privResultDeferral.reject(g);
        }
      }
    }
    async recognizeSpeakerOnce(o) {
      this.privSpeakerModel = o, this.voiceProfileType = o.scenario, this.privResultDeferral || (this.privResultDeferral = new a.Deferred()), this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events), this.privRecognizerConfig.parameters.setProperty(i.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
      const l = this.connectImpl(), c = this.sendPreAudioMessages(this.extractSpeakerContext(o)), d = await this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId), u = await this.privSpeakerAudioSource.format, h = await this.privSpeakerAudioSource.deviceInfo, A = new s.ReplayableAudioNode(d, u.avgBytesPerSec);
      await this.privRequestSession.onAudioSourceAttachCompleted(A, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: h };
      try {
        await l, await c;
      } catch (p) {
        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, i.CancellationReason.Error, i.CancellationErrorCode.ConnectionFailure, p);
      }
      const g = new i.SessionEventArgs(this.privRequestSession.sessionId);
      return this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, g), this.receiveMessage(), this.sendAudio(A).then(() => {
      }, (p) => {
        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, i.CancellationReason.Error, i.CancellationErrorCode.RuntimeError, p);
      }), this.privResultDeferral.promise;
    }
    async sendPreAudioMessages(o) {
      const l = await this.fetchConnection();
      await this.sendSpeakerRecognition(l, o);
    }
    async sendSpeakerRecognition(o, l) {
      const c = JSON.stringify(l);
      return o.send(new e.SpeechConnectionMessage(a.MessageType.Text, "speaker.context", this.privRequestSession.requestId, "application/json; charset=utf-8", c));
    }
    extractSpeakerContext(o) {
      return {
        features: {
          interimResult: "enabled",
          progressiveDetection: "disabled"
        },
        profileIds: o.profileIds,
        scenario: o.scenario
      };
    }
  };
  return Qp.SpeakerServiceRecognizer = n, Qp;
}
var Cp = {}, DC;
function IO() {
  if (DC) return Cp;
  DC = 1, Object.defineProperty(Cp, "__esModule", { value: !0 }), Cp.VoiceServiceRecognizer = void 0;
  const s = Xc(), a = Eo(), i = Hr(), r = wi(), e = R0;
  let n = class extends r.ServiceRecognizerBase {
    constructor(o, l, c, d, u) {
      super(o, l, c, d, u), this.privDeferralMap = new a.DeferralMap(), this.privSpeakerAudioSource = c, this.sendPrePayloadJSONOverride = () => this.noOp();
    }
    set SpeakerAudioSource(o) {
      this.privSpeakerAudioSource = o;
    }
    processTypeSpecificMessages(o) {
      let l = !1;
      const c = new i.PropertyCollection();
      switch (o.messageType === a.MessageType.Text && c.setProperty(i.PropertyId.SpeechServiceResponse_JsonResult, o.textBody), o.path.toLowerCase()) {
        case "speaker.profiles":
          const u = JSON.parse(o.textBody);
          switch (u.operation.toLowerCase()) {
            case "create":
              this.handleCreateResponse(u, o.requestId);
              break;
            case "delete":
            case "reset":
              this.handleResultResponse(u, o.requestId);
              break;
            case "fetch":
              const f = JSON.parse(o.textBody);
              this.handleFetchResponse(f, o.requestId);
              break;
          }
          l = !0;
          break;
        case "speaker.phrases":
          const h = JSON.parse(o.textBody);
          this.handlePhrasesResponse(h, o.requestId), l = !0;
          break;
        case "speaker.profile.enrollment":
          const A = JSON.parse(o.textBody), g = new i.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(A.enrollment ? A.enrollment.enrollmentStatus : A.status.statusCode), A.enrollment ? JSON.stringify(A.enrollment) : void 0, A.status.reason);
          this.privDeferralMap.getId(o.requestId) && this.privDeferralMap.complete(o.requestId, g), this.privRequestSession.onSpeechEnded(), l = !0;
          break;
      }
      const d = new a.Deferred();
      return d.resolve(l), d.promise;
    }
    // Cancels recognition.
    cancelRecognition(o, l, c, d, u) {
      new i.PropertyCollection().setProperty(r.CancellationErrorCodePropertyName, i.CancellationErrorCode[d]);
      const A = new i.VoiceProfileEnrollmentResult(i.ResultReason.Canceled, u, u);
      this.privDeferralMap.getId(l) && this.privDeferralMap.complete(l, A);
    }
    async createProfile(o, l) {
      this.voiceProfileType = o.toString();
      const c = this.connectImpl();
      try {
        const d = new a.Deferred();
        return await c, await this.sendCreateProfile(d, o, l), this.receiveMessage(), d.promise;
      } catch (d) {
        throw d;
      }
    }
    async resetProfile(o) {
      return this.voiceProfileType = o.profileType.toString(), this.sendCommonRequest("reset", o.profileType, o);
    }
    async deleteProfile(o) {
      return this.voiceProfileType = o.profileType.toString(), this.sendCommonRequest("delete", o.profileType, o);
    }
    async retrieveEnrollmentResult(o) {
      return this.voiceProfileType = o.profileType.toString(), this.privExpectedProfileId = o.profileId, this.sendCommonRequest("fetch", o.profileType, o);
    }
    async getAllProfiles(o) {
      return this.voiceProfileType = o.toString(), this.sendCommonRequest("fetch", o);
    }
    async getActivationPhrases(o, l) {
      this.voiceProfileType = o.toString();
      const c = this.connectImpl();
      try {
        const d = new a.Deferred();
        return await c, await this.sendPhrasesRequest(d, o, l), this.receiveMessage(), d.promise;
      } catch (d) {
        throw d;
      }
    }
    async enrollProfile(o) {
      this.voiceProfileType = o.profileType.toString();
      const l = new a.Deferred();
      this.privRequestSession.startNewRecognition(), this.privRequestSession.listenForServiceTelemetry(this.privSpeakerAudioSource.events), this.privRecognizerConfig.parameters.setProperty(i.PropertyId.Speech_SessionId, this.privRequestSession.sessionId);
      const c = this.connectImpl(), d = this.sendPreAudioMessages(o, l), u = await this.privSpeakerAudioSource.attach(this.privRequestSession.audioNodeId), h = await this.privSpeakerAudioSource.format, A = await this.privSpeakerAudioSource.deviceInfo, g = new s.ReplayableAudioNode(u, h.avgBytesPerSec);
      await this.privRequestSession.onAudioSourceAttachCompleted(g, !1), this.privRecognizerConfig.SpeechServiceConfig.Context.audio = { source: A };
      try {
        await c, await d;
      } catch (v) {
        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, i.CancellationReason.Error, i.CancellationErrorCode.ConnectionFailure, v);
      }
      const f = new i.SessionEventArgs(this.privRequestSession.sessionId);
      return this.privRecognizer.sessionStarted && this.privRecognizer.sessionStarted(this.privRecognizer, f), this.receiveMessage(), this.sendAudio(g).then(() => {
      }, (v) => {
        this.cancelRecognition(this.privRequestSession.sessionId, this.privRequestSession.requestId, i.CancellationReason.Error, i.CancellationErrorCode.RuntimeError, v);
      }), l.promise;
    }
    async sendPreAudioMessages(o, l) {
      const c = await this.fetchConnection();
      this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, l), await this.sendBaseRequest(c, "enroll", this.scenarioFrom(o.profileType), o);
    }
    async sendPhrasesRequest(o, l, c) {
      const d = await this.fetchConnection();
      this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, o);
      const u = this.scenarioFrom(l), h = {
        locale: c,
        scenario: u
      };
      return d.send(new e.SpeechConnectionMessage(a.MessageType.Text, "speaker.profile.phrases", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(h)));
    }
    async sendCreateProfile(o, l, c) {
      const d = await this.fetchConnection();
      this.privRequestSession.onSpeechContext(), this.privDeferralMap.add(this.privRequestSession.requestId, o);
      const u = l === i.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : l === i.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification", h = {
        locale: c,
        number: "1",
        scenario: u
      };
      return d.send(new e.SpeechConnectionMessage(a.MessageType.Text, "speaker.profile.create", this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(h)));
    }
    async sendCommonRequest(o, l, c = void 0) {
      const d = this.connectImpl();
      try {
        const u = new a.Deferred();
        this.privRequestSession.onSpeechContext(), await d;
        const h = await this.fetchConnection();
        return this.privDeferralMap.add(this.privRequestSession.requestId, u), await this.sendBaseRequest(h, o, this.scenarioFrom(l), c), this.receiveMessage(), u.promise;
      } catch (u) {
        throw u;
      }
    }
    async sendBaseRequest(o, l, c, d) {
      const u = {
        scenario: c
      };
      return d ? u.profileIds = [d.profileId] : u.maxPageSize = -1, o.send(new e.SpeechConnectionMessage(a.MessageType.Text, `speaker.profile.${l}`, this.privRequestSession.requestId, "application/json; charset=utf-8", JSON.stringify(u)));
    }
    extractSpeakerContext(o) {
      return {
        features: {
          interimResult: "enabled",
          progressiveDetection: "disabled"
        },
        profileIds: o.profileIds,
        scenario: o.scenario
      };
    }
    handlePhrasesResponse(o, l) {
      if (this.privDeferralMap.getId(l))
        if (o.status.statusCode.toLowerCase() !== "success") {
          const c = i.ResultReason.Canceled, d = new i.VoiceProfilePhraseResult(c, o.status.statusCode, o.passPhraseType, []);
          this.privDeferralMap.complete(l, d);
        } else if (o.phrases && o.phrases.length > 0) {
          const c = i.ResultReason.EnrollingVoiceProfile, d = new i.VoiceProfilePhraseResult(c, o.status.statusCode, o.passPhraseType, o.phrases);
          this.privDeferralMap.complete(l, d);
        } else
          throw new Error("Voice Profile get activation phrases failed, no phrases received");
      else
        throw new Error(`Voice Profile get activation phrases request for requestID ${l} not found`);
    }
    handleCreateResponse(o, l) {
      if (o.profiles && o.profiles.length > 0)
        if (this.privDeferralMap.getId(l)) {
          const c = o.profiles.map((d) => d.profileId);
          this.privDeferralMap.complete(l, c);
        } else
          throw new Error(`Voice Profile create request for requestID ${l} not found`);
      else
        throw new Error("Voice Profile create failed, no profile id received");
    }
    handleResultResponse(o, l) {
      if (this.privDeferralMap.getId(l)) {
        const c = o.operation.toLowerCase() === "delete" ? i.ResultReason.DeletedVoiceProfile : i.ResultReason.ResetVoiceProfile, d = o.status.statusCode.toLowerCase() === "success" ? c : i.ResultReason.Canceled, u = new i.VoiceProfileResult(d, `statusCode: ${o.status.statusCode}, errorDetails: ${o.status.reason}`);
        this.privDeferralMap.complete(l, u);
      } else
        throw new Error(`Voice Profile create request for requestID ${l} not found`);
    }
    handleFetchResponse(o, l) {
      if (this.privDeferralMap.getId(l) && o.profiles[0]) {
        if (this.privExpectedProfileId && o.profiles.length === 1 && o.profiles[0].profileId === this.privExpectedProfileId) {
          this.privExpectedProfileId = void 0;
          const c = o.profiles[0], d = new i.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(c.enrollmentStatus), JSON.stringify(c), o.status.reason);
          this.privDeferralMap.complete(l, d);
        } else if (o.profiles.length > 0) {
          const c = o.profiles, d = [];
          for (const u of c)
            d.push(new i.VoiceProfileEnrollmentResult(this.enrollmentReasonFrom(u.enrollmentStatus), JSON.stringify(u), o.status.reason));
          this.privDeferralMap.complete(l, d);
        }
      } else
        throw new Error(`Voice Profile fetch request for requestID ${l} not found`);
    }
    enrollmentReasonFrom(o) {
      switch (o.toLowerCase()) {
        case "enrolled":
          return i.ResultReason.EnrolledVoiceProfile;
        case "invalidlocale":
        case "invalidphrase":
        case "invalidaudioformat":
        case "invalidscenario":
        case "invalidprofilecount":
        case "invalidoperation":
        case "audiotooshort":
        case "audiotoolong":
        case "toomanyenrollments":
        case "storageconflict":
        case "profilenotfound":
        case "incompatibleprofiles":
        case "incompleteenrollment":
          return i.ResultReason.Canceled;
        default:
          return i.ResultReason.EnrollingVoiceProfile;
      }
    }
    scenarioFrom(o) {
      return o === i.VoiceProfileType.TextIndependentIdentification ? "TextIndependentIdentification" : o === i.VoiceProfileType.TextIndependentVerification ? "TextIndependentVerification" : "TextDependentVerification";
    }
  };
  return Cp.VoiceServiceRecognizer = n, Cp;
}
var jZ = {};
(function(s) {
  Object.defineProperty(s, "__esModule", { value: !0 }), s.type = s.connectivity = s.Device = s.OS = s.System = s.Context = s.SpeechServiceConfig = void 0;
  class a {
    constructor(o) {
      this.context = o;
    }
    serialize() {
      return JSON.stringify(this, (o, l) => {
        if (l && typeof l == "object" && !Array.isArray(l)) {
          const c = {};
          for (const d in l)
            Object.hasOwnProperty.call(l, d) && (c[d && d.charAt(0).toLowerCase() + d.substring(1)] = l[d]);
          return c;
        }
        return l;
      });
    }
    get Context() {
      return this.context;
    }
    get Recognition() {
      return this.recognition;
    }
    set Recognition(o) {
      this.recognition = o.toLowerCase();
    }
  }
  s.SpeechServiceConfig = a;
  class i {
    constructor(o) {
      this.system = new r(), this.os = o;
    }
  }
  s.Context = i;
  class r {
    constructor() {
      const o = "1.40.0";
      this.name = "SpeechSDK", this.version = o, this.build = "JavaScript", this.lang = "JavaScript";
    }
  }
  s.System = r;
  class e {
    constructor(o, l, c) {
      this.platform = o, this.name = l, this.version = c;
    }
  }
  s.OS = e;
  class n {
    constructor(o, l, c) {
      this.manufacturer = o, this.model = l, this.version = c;
    }
  }
  s.Device = n, function(t) {
    t.Bluetooth = "Bluetooth", t.Wired = "Wired", t.WiFi = "WiFi", t.Cellular = "Cellular", t.InBuilt = "InBuilt", t.Unknown = "Unknown";
  }(s.connectivity || (s.connectivity = {})), function(t) {
    t.Phone = "Phone", t.Speaker = "Speaker", t.Car = "Car", t.Headset = "Headset", t.Thermostat = "Thermostat", t.Microphones = "Microphones", t.Deskphone = "Deskphone", t.RemoteControl = "RemoteControl", t.Unknown = "Unknown", t.File = "File", t.Stream = "Stream";
  }(s.type || (s.type = {}));
})(jZ);
var MC;
function wi() {
  return MC || (MC = 1, function(s) {
    var a = Dn && Dn.__createBinding || (Object.create ? function(n, t, o, l) {
      l === void 0 && (l = o), Object.defineProperty(n, l, { enumerable: !0, get: function() {
        return t[o];
      } });
    } : function(n, t, o, l) {
      l === void 0 && (l = o), n[l] = t[o];
    }), i = Dn && Dn.__exportStar || function(n, t) {
      for (var o in n) o !== "default" && !t.hasOwnProperty(o) && a(t, n, o);
    };
    Object.defineProperty(s, "__esModule", { value: !0 }), s.AutoDetectSourceLanguagesOpenRangeOptionName = s.ForceDictationPropertyName = s.ServicePropertiesPropertyName = s.CancellationErrorCodePropertyName = s.OutputFormatPropertyName = void 0, i(R1, s), i(Y1, s), i(ng, s), i(OB, s), i(KB, s), i(fP(), s), i(pP(), s), i(p2, s), i(mP(), s), i(vP(), s), i(bP(), s), i(MZ, s), i(m2, s), i(RP(), s), i(yP(), s), i(QP(), s), i(CP(), s), i(kZ(), s), i(UP(), s), i(YZ, s), i(IP(), s), i(v2, s), i(SP(), s), i(EP(), s), i(b2, s), i(F2, s), i(R2, s), i(VP(), s), i(WP(), s), i(NP(), s), i(JP(), s), i(GP(), s), i(y2, s), i(XP(), s), i(Q2, s), i(PZ, s), i(C2, s), i(I2, s), i(B2, s), i(OZ, s), i(zP(), s), i(E2, s), i(AO(), s), i(SF, s), i(mO(), s), i(vO(), s);
    var r = bO();
    Object.defineProperty(s, "AvatarSynthesisAdapter", { enumerable: !0, get: function() {
      return r.AvatarSynthesisAdapter;
    } });
    var e = FO();
    Object.defineProperty(s, "SpeechSynthesisAdapter", { enumerable: !0, get: function() {
      return e.SpeechSynthesisAdapter;
    } }), i(RO(), s), i(yO(), s), i(QO(), s), i(CO(), s), i(UO(), s), i(IO(), s), i(jZ, s), s.OutputFormatPropertyName = "OutputFormat", s.CancellationErrorCodePropertyName = "CancellationErrorCode", s.ServicePropertiesPropertyName = "ServiceProperties", s.ForceDictationPropertyName = "ForceDictation", s.AutoDetectSourceLanguagesOpenRangeOptionName = "OpenRange";
  }(Nv)), Nv;
}
(function(s) {
  var a = Dn && Dn.__createBinding || (Object.create ? function(e, n, t, o) {
    o === void 0 && (o = t), Object.defineProperty(e, o, { enumerable: !0, get: function() {
      return n[t];
    } });
  } : function(e, n, t, o) {
    o === void 0 && (o = t), e[o] = n[t];
  }), i = Dn && Dn.__exportStar || function(e, n) {
    for (var t in e) t !== "default" && !n.hasOwnProperty(t) && a(n, e, t);
  };
  Object.defineProperty(s, "__esModule", { value: !0 });
  const r = wi();
  new r.AgentConfig(), i(Hr(), s);
})(Hh);
const BO = (s = !1) => {
  const a = "c54bc55f8da04584aa9f51b25f95e31d", i = "brazilsouth", r = m0((c) => c.dispatch), e = z0(null), n = z0(null);
  return {
    initRecognition: (c, d) => {
      if (!s) return;
      const u = Hh.SpeechConfig.fromSubscription(a, i);
      u.speechRecognitionLanguage = "pt-BR";
      let h;
      if (d === "PROFESSIONAL") {
        const A = Hh.AudioConfig.fromDefaultMicrophoneInput();
        h = new Hh.SpeechRecognizer(u, A);
      }
      if (d === "PATIENT") {
        const A = Hh.AudioConfig.fromStreamInput(c);
        h = new Hh.SpeechRecognizer(u, A);
      }
      h.recognized = (A, g) => {
        g.result.reason === Hh.ResultReason.RecognizedSpeech && r({
          type: "transcription",
          message: g.result.text,
          userType: d
        });
      }, h.canceled = (A, g) => {
        console.error(`CANCELED [${d}]: Reason=${g.reason}`), h.stopContinuousRecognitionAsync();
      }, h.startContinuousRecognitionAsync(), d === "PROFESSIONAL" && (e.current = h), d === "PATIENT" && (n.current = h);
    },
    startContinuousRecognition: () => {
      s && e.current.startContinuousRecognitionAsync();
    },
    stopContinuousRecognition: (c) => {
      s && (e.current && c === "PROFESSIONAL" && e.current.stopContinuousRecognitionAsync(), n.current && c === "PATIENT" && n.current.stopContinuousRecognitionAsync());
    }
  };
}, rK = () => {
  const {
    meetSettings: s,
    enableTranscription: a,
    userType: i,
    env: r
  } = Pb(), e = z0(), n = eB((w) => w.isEnded), {
    width: t
  } = aM(e == null ? void 0 : e.current), [o, l] = Tl(!1), c = eM(), d = z0(!1), u = z0(!1), {
    vonageError: h,
    createCall: A,
    participants: g,
    mediaCreated: f,
    cameraPublishing: p,
    leave: v
  } = $D(), b = Cu((w) => w.defaultSettings), {
    data: m
  } = RW(s == null ? void 0 : s.sessionId, r), y = m0((w) => w.dispatch), U = qD({
    isMiniMode: t < 390,
    isMobile: Sp,
    isOneToOne: (g == null ? void 0 : g.length) < 2,
    isDoctor: i === "PROFESSIONAL",
    isExpand: o
  }), {
    initRecognition: B,
    startContinuousRecognition: Q,
    stopContinuousRecognition: N
  } = BO(a);
  nM();
  const J = () => {
    y({
      message: o ? "decrease" : "expand",
      type: "changeExpand"
    }), l((w) => !w);
  };
  return Pd(() => (m && m !== Yb.END && s && A({
    publisherProperties: {
      publishAudio: !0,
      publishVideo: !0,
      ...(b == null ? void 0 : b.videoSource) && {
        videoSource: b == null ? void 0 : b.videoSource
      },
      ...(b == null ? void 0 : b.audioSource) && {
        audioSource: b == null ? void 0 : b.audioSource
      },
      mirror: !0
    }
  }), () => {
    v();
  }), [A, v, s, m, b == null ? void 0 : b.audioSource, b.publishAudio, b.publishVideo, b == null ? void 0 : b.videoSource]), Pd(() => {
    f && a && i === "PROFESSIONAL" && !d.current && (B(null, "PROFESSIONAL"), d.current = !0);
  }, [f, a, i, B]), Pd(() => {
    if (e.current && f && !u.current && i === "PROFESSIONAL") {
      const w = e.current.children[1].getElementsByClassName("OT_subscriber")[0], W = w == null ? void 0 : w.querySelector("video");
      if (W) {
        const G = W.captureStream(), Z = G == null ? void 0 : G.getAudioTracks()[0], K = new MediaStream();
        K.addTrack(Z), setTimeout(() => {
          B(K, "PATIENT");
        }, 1e3), u.current = !0;
      }
    }
  }, [f, B, i]), n ? /* @__PURE__ */ We(jY, { meetStatus: m }) : /* @__PURE__ */ Ir("div", { css: c.root, className: "room-wrapper", children: [
    /* @__PURE__ */ We(qY, {}),
    /* @__PURE__ */ Ir("div", { css: U.root, children: [
      /* @__PURE__ */ We("div", { id: "roomContainer", className: `room ${(g == null ? void 0 : g.length) > 0 ? "secondary" : ""}`, ref: e, children: /* @__PURE__ */ We("div", { id: "screenSharingContainer" }) }),
      /* @__PURE__ */ We(jD, { mediaCreated: f, cameraPublishing: p, isSolo: (g == null ? void 0 : g.length) === 0, startRecognition: Q, stopRecognition: () => N("PROFESSIONAL"), isMiniMode: t < 390, isExpand: o, isDoctor: i === "PROFESSIONAL", participants: g, onChangeExpand: J })
    ] }),
    /* @__PURE__ */ We(oM, { error: h, isNewMedicalRecord: !1, retryPublish: A })
  ] });
};
export {
  GO as MeetProvider,
  rK as Room,
  JO as clearListenerEvents,
  wp as useChatStore
};
//# sourceMappingURL=index.es.js.map
